/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(70);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(71);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(73);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _app = __webpack_require__(74);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _appView = __webpack_require__(75);
	
	var _appView2 = _interopRequireDefault(_appView);
	
	var _headerSection = __webpack_require__(81);
	
	var _headerSection2 = _interopRequireDefault(_headerSection);
	
	var _footerSection = __webpack_require__(88);
	
	var _footerSection2 = _interopRequireDefault(_footerSection);
	
	var _mapPage = __webpack_require__(94);
	
	var _mapPage2 = _interopRequireDefault(_mapPage);
	
	var _navLinksStrip = __webpack_require__(113);
	
	var _navLinksStrip2 = _interopRequireDefault(_navLinksStrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////REQUIRED: for bootstrap/jquery/LESS/font-awesome
	
	// import ngAnimate from 'angular-animate';
	
	////ROUTING
	/**
	 * Created by Julio Perez on 9/20/2016.
	 */
	
	__webpack_require__(122);
	
	////COMPONENTS
	
	__webpack_require__(124);
	__webpack_require__(127);
	__webpack_require__(148);
	__webpack_require__(150);
	__webpack_require__(112);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(161);
	__webpack_require__(162);
	__webpack_require__(164);
	
	__webpack_require__(165);
	__webpack_require__(103);
	
	var app = _angular2.default.module('app', [_angularUiRouter2.default, _appView2.default, _headerSection2.default, _footerSection2.default, _mapPage2.default, _navLinksStrip2.default]).config(_app2.default);
	
	exports.default = app;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(72);
	module.exports = angular;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * @license AngularJS v1.6.4
	 * (c) 2010-2017 Google, Inc. http://angularjs.org
	 * License: MIT
	 */
	(function(window) {'use strict';
	
	/**
	 * @description
	 *
	 * This object provides a utility for producing rich Error messages within
	 * Angular. It can be called as follows:
	 *
	 * var exampleMinErr = minErr('example');
	 * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
	 *
	 * The above creates an instance of minErr in the example namespace. The
	 * resulting error will have a namespaced error code of example.one.  The
	 * resulting error will replace {0} with the value of foo, and {1} with the
	 * value of bar. The object is not restricted in the number of arguments it can
	 * take.
	 *
	 * If fewer arguments are specified than necessary for interpolation, the extra
	 * interpolation markers will be preserved in the final string.
	 *
	 * Since data will be parsed statically during a build step, some restrictions
	 * are applied with respect to how minErr instances are created and called.
	 * Instances should have names of the form namespaceMinErr for a minErr created
	 * using minErr('namespace') . Error codes, namespaces and template strings
	 * should all be static strings, not variables or general expressions.
	 *
	 * @param {string} module The namespace to use for the new minErr instance.
	 * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
	 *   error from returned function, for cases when a particular type of error is useful.
	 * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
	 */
	
	function minErr(module, ErrorConstructor) {
	  ErrorConstructor = ErrorConstructor || Error;
	  return function() {
	    var code = arguments[0],
	      template = arguments[1],
	      message = '[' + (module ? module + ':' : '') + code + '] ',
	      templateArgs = sliceArgs(arguments, 2).map(function(arg) {
	        return toDebugString(arg, minErrConfig.objectMaxDepth);
	      }),
	      paramPrefix, i;
	
	    message += template.replace(/\{\d+\}/g, function(match) {
	      var index = +match.slice(1, -1);
	
	      if (index < templateArgs.length) {
	        return templateArgs[index];
	      }
	
	      return match;
	    });
	
	    message += '\nhttp://errors.angularjs.org/1.6.4/' +
	      (module ? module + '/' : '') + code;
	
	    for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
	      message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
	    }
	
	    return new ErrorConstructor(message);
	  };
	}
	
	/* We need to tell ESLint what variables are being exported */
	/* exported
	  angular,
	  msie,
	  jqLite,
	  jQuery,
	  slice,
	  splice,
	  push,
	  toString,
	  minErrConfig,
	  errorHandlingConfig,
	  isValidObjectMaxDepth,
	  ngMinErr,
	  angularModule,
	  uid,
	  REGEX_STRING_REGEXP,
	  VALIDITY_STATE_PROPERTY,
	
	  lowercase,
	  uppercase,
	  manualLowercase,
	  manualUppercase,
	  nodeName_,
	  isArrayLike,
	  forEach,
	  forEachSorted,
	  reverseParams,
	  nextUid,
	  setHashKey,
	  extend,
	  toInt,
	  inherit,
	  merge,
	  noop,
	  identity,
	  valueFn,
	  isUndefined,
	  isDefined,
	  isObject,
	  isBlankObject,
	  isString,
	  isNumber,
	  isNumberNaN,
	  isDate,
	  isArray,
	  isFunction,
	  isRegExp,
	  isWindow,
	  isScope,
	  isFile,
	  isFormData,
	  isBlob,
	  isBoolean,
	  isPromiseLike,
	  trim,
	  escapeForRegexp,
	  isElement,
	  makeMap,
	  includes,
	  arrayRemove,
	  copy,
	  simpleCompare,
	  equals,
	  csp,
	  jq,
	  concat,
	  sliceArgs,
	  bind,
	  toJsonReplacer,
	  toJson,
	  fromJson,
	  convertTimezoneToLocal,
	  timezoneToOffset,
	  startingTag,
	  tryDecodeURIComponent,
	  parseKeyValue,
	  toKeyValue,
	  encodeUriSegment,
	  encodeUriQuery,
	  angularInit,
	  bootstrap,
	  getTestability,
	  snake_case,
	  bindJQuery,
	  assertArg,
	  assertArgFn,
	  assertNotHasOwnProperty,
	  getter,
	  getBlockNodes,
	  hasOwnProperty,
	  createMap,
	  stringify,
	
	  NODE_TYPE_ELEMENT,
	  NODE_TYPE_ATTRIBUTE,
	  NODE_TYPE_TEXT,
	  NODE_TYPE_COMMENT,
	  NODE_TYPE_DOCUMENT,
	  NODE_TYPE_DOCUMENT_FRAGMENT
	*/
	
	////////////////////////////////////
	
	/**
	 * @ngdoc module
	 * @name ng
	 * @module ng
	 * @installation
	 * @description
	 *
	 * # ng (core module)
	 * The ng module is loaded by default when an AngularJS application is started. The module itself
	 * contains the essential components for an AngularJS application to function. The table below
	 * lists a high level breakdown of each of the services/factories, filters, directives and testing
	 * components available within this core module.
	 *
	 * <div doc-module-components="ng"></div>
	 */
	
	var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;
	
	// The name of a form control's ValidityState property.
	// This is used so that it's possible for internal tests to create mock ValidityStates.
	var VALIDITY_STATE_PROPERTY = 'validity';
	
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var minErrConfig = {
	  objectMaxDepth: 5
	};
	
	 /**
	 * @ngdoc function
	 * @name angular.errorHandlingConfig
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Configure several aspects of error handling in AngularJS if used as a setter or return the
	 * current configuration if used as a getter. The following options are supported:
	 *
	 * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
	 *
	 * Omitted or undefined options will leave the corresponding configuration values unchanged.
	 *
	 * @param {Object=} config - The configuration object. May only contain the options that need to be
	 *     updated. Supported keys:
	 *
	 * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
	 *   non-positive or non-numeric value, removes the max depth limit.
	 *   Default: 5
	 */
	function errorHandlingConfig(config) {
	  if (isObject(config)) {
	    if (isDefined(config.objectMaxDepth)) {
	      minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
	    }
	  } else {
	    return minErrConfig;
	  }
	}
	
	/**
	 * @private
	 * @param {Number} maxDepth
	 * @return {boolean}
	 */
	function isValidObjectMaxDepth(maxDepth) {
	  return isNumber(maxDepth) && maxDepth > 0;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.lowercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
	 *
	 * @description Converts the specified string to lowercase.
	 * @param {string} string String to be converted to lowercase.
	 * @returns {string} Lowercased string.
	 */
	var lowercase = function(string) {return isString(string) ? string.toLowerCase() : string;};
	
	/**
	 * @ngdoc function
	 * @name angular.uppercase
	 * @module ng
	 * @kind function
	 *
	 * @deprecated
	 * sinceVersion="1.5.0"
	 * removeVersion="1.7.0"
	 * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
	 *
	 * @description Converts the specified string to uppercase.
	 * @param {string} string String to be converted to uppercase.
	 * @returns {string} Uppercased string.
	 */
	var uppercase = function(string) {return isString(string) ? string.toUpperCase() : string;};
	
	
	var manualLowercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[A-Z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) | 32);})
	      : s;
	  /* eslint-enable */
	};
	var manualUppercase = function(s) {
	  /* eslint-disable no-bitwise */
	  return isString(s)
	      ? s.replace(/[a-z]/g, function(ch) {return String.fromCharCode(ch.charCodeAt(0) & ~32);})
	      : s;
	  /* eslint-enable */
	};
	
	
	// String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
	// locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
	// with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
	if ('i' !== 'I'.toLowerCase()) {
	  lowercase = manualLowercase;
	  uppercase = manualUppercase;
	}
	
	
	var
	    msie,             // holds major version number for IE, or NaN if UA is not IE.
	    jqLite,           // delay binding since jQuery could be loaded after us.
	    jQuery,           // delay binding
	    slice             = [].slice,
	    splice            = [].splice,
	    push              = [].push,
	    toString          = Object.prototype.toString,
	    getPrototypeOf    = Object.getPrototypeOf,
	    ngMinErr          = minErr('ng'),
	
	    /** @name angular */
	    angular           = window.angular || (window.angular = {}),
	    angularModule,
	    uid               = 0;
	
	// Support: IE 9-11 only
	/**
	 * documentMode is an IE-only property
	 * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
	 */
	msie = window.document.documentMode;
	
	
	/**
	 * @private
	 * @param {*} obj
	 * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
	 *                   String ...)
	 */
	function isArrayLike(obj) {
	
	  // `null`, `undefined` and `window` are not array-like
	  if (obj == null || isWindow(obj)) return false;
	
	  // arrays, strings and jQuery/jqLite objects are array like
	  // * jqLite is either the jQuery or jqLite constructor function
	  // * we have to check the existence of jqLite first as this method is called
	  //   via the forEach method when constructing the jqLite object in the first place
	  if (isArray(obj) || isString(obj) || (jqLite && obj instanceof jqLite)) return true;
	
	  // Support: iOS 8.2 (not reproducible in simulator)
	  // "length" in obj used to prevent JIT error (gh-11508)
	  var length = 'length' in Object(obj) && obj.length;
	
	  // NodeList objects (with `item` method) and
	  // other objects with suitable length characteristics are array-like
	  return isNumber(length) &&
	    (length >= 0 && ((length - 1) in obj || obj instanceof Array) || typeof obj.item === 'function');
	
	}
	
	/**
	 * @ngdoc function
	 * @name angular.forEach
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
	 * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
	 * is the value of an object property or an array element, `key` is the object property key or
	 * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
	 *
	 * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
	 * using the `hasOwnProperty` method.
	 *
	 * Unlike ES262's
	 * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
	 * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
	 * return the value provided.
	 *
	   ```js
	     var values = {name: 'misko', gender: 'male'};
	     var log = [];
	     angular.forEach(values, function(value, key) {
	       this.push(key + ': ' + value);
	     }, log);
	     expect(log).toEqual(['name: misko', 'gender: male']);
	   ```
	 *
	 * @param {Object|Array} obj Object to iterate over.
	 * @param {Function} iterator Iterator function.
	 * @param {Object=} context Object to become context (`this`) for the iterator function.
	 * @returns {Object|Array} Reference to `obj`.
	 */
	
	function forEach(obj, iterator, context) {
	  var key, length;
	  if (obj) {
	    if (isFunction(obj)) {
	      for (key in obj) {
	        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (isArray(obj) || isArrayLike(obj)) {
	      var isPrimitive = typeof obj !== 'object';
	      for (key = 0, length = obj.length; key < length; key++) {
	        if (isPrimitive || key in obj) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else if (obj.forEach && obj.forEach !== forEach) {
	        obj.forEach(iterator, context, obj);
	    } else if (isBlankObject(obj)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in obj) {
	        iterator.call(context, obj[key], key, obj);
	      }
	    } else if (typeof obj.hasOwnProperty === 'function') {
	      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
	      for (key in obj) {
	        if (obj.hasOwnProperty(key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    } else {
	      // Slow path for objects which do not have a method `hasOwnProperty`
	      for (key in obj) {
	        if (hasOwnProperty.call(obj, key)) {
	          iterator.call(context, obj[key], key, obj);
	        }
	      }
	    }
	  }
	  return obj;
	}
	
	function forEachSorted(obj, iterator, context) {
	  var keys = Object.keys(obj).sort();
	  for (var i = 0; i < keys.length; i++) {
	    iterator.call(context, obj[keys[i]], keys[i]);
	  }
	  return keys;
	}
	
	
	/**
	 * when using forEach the params are value, key, but it is often useful to have key, value.
	 * @param {function(string, *)} iteratorFn
	 * @returns {function(*, string)}
	 */
	function reverseParams(iteratorFn) {
	  return function(value, key) {iteratorFn(key, value);};
	}
	
	/**
	 * A consistent way of creating unique IDs in angular.
	 *
	 * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
	 * we hit number precision issues in JavaScript.
	 *
	 * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
	 *
	 * @returns {number} an unique alpha-numeric string
	 */
	function nextUid() {
	  return ++uid;
	}
	
	
	/**
	 * Set or clear the hashkey for an object.
	 * @param obj object
	 * @param h the hashkey (!truthy to delete the hashkey)
	 */
	function setHashKey(obj, h) {
	  if (h) {
	    obj.$$hashKey = h;
	  } else {
	    delete obj.$$hashKey;
	  }
	}
	
	
	function baseExtend(dst, objs, deep) {
	  var h = dst.$$hashKey;
	
	  for (var i = 0, ii = objs.length; i < ii; ++i) {
	    var obj = objs[i];
	    if (!isObject(obj) && !isFunction(obj)) continue;
	    var keys = Object.keys(obj);
	    for (var j = 0, jj = keys.length; j < jj; j++) {
	      var key = keys[j];
	      var src = obj[key];
	
	      if (deep && isObject(src)) {
	        if (isDate(src)) {
	          dst[key] = new Date(src.valueOf());
	        } else if (isRegExp(src)) {
	          dst[key] = new RegExp(src);
	        } else if (src.nodeName) {
	          dst[key] = src.cloneNode(true);
	        } else if (isElement(src)) {
	          dst[key] = src.clone();
	        } else {
	          if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
	          baseExtend(dst[key], [src], true);
	        }
	      } else {
	        dst[key] = src;
	      }
	    }
	  }
	
	  setHashKey(dst, h);
	  return dst;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.extend
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	 * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	 * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
	 *
	 * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
	 * {@link angular.merge} for this.
	 *
	 * @param {Object} dst Destination object.
	 * @param {...Object} src Source object(s).
	 * @returns {Object} Reference to `dst`.
	 */
	function extend(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), false);
	}
	
	
	/**
	* @ngdoc function
	* @name angular.merge
	* @module ng
	* @kind function
	*
	* @description
	* Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
	* to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
	* by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
	*
	* Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
	* objects, performing a deep copy.
	*
	* @param {Object} dst Destination object.
	* @param {...Object} src Source object(s).
	* @returns {Object} Reference to `dst`.
	*/
	function merge(dst) {
	  return baseExtend(dst, slice.call(arguments, 1), true);
	}
	
	
	
	function toInt(str) {
	  return parseInt(str, 10);
	}
	
	var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
	  // eslint-disable-next-line no-self-compare
	  return num !== num;
	};
	
	
	function inherit(parent, extra) {
	  return extend(Object.create(parent), extra);
	}
	
	/**
	 * @ngdoc function
	 * @name angular.noop
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that performs no operations. This function can be useful when writing code in the
	 * functional style.
	   ```js
	     function foo(callback) {
	       var result = calculateResult();
	       (callback || angular.noop)(result);
	     }
	   ```
	 */
	function noop() {}
	noop.$inject = [];
	
	
	/**
	 * @ngdoc function
	 * @name angular.identity
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * A function that returns its first argument. This function is useful when writing code in the
	 * functional style.
	 *
	   ```js
	   function transformer(transformationFn, value) {
	     return (transformationFn || angular.identity)(value);
	   };
	
	   // E.g.
	   function getResult(fn, input) {
	     return (fn || angular.identity)(input);
	   };
	
	   getResult(function(n) { return n * 2; }, 21);   // returns 42
	   getResult(null, 21);                            // returns 21
	   getResult(undefined, 21);                       // returns 21
	   ```
	 *
	 * @param {*} value to be returned.
	 * @returns {*} the value passed in.
	 */
	function identity($) {return $;}
	identity.$inject = [];
	
	
	function valueFn(value) {return function valueRef() {return value;};}
	
	function hasCustomToString(obj) {
	  return isFunction(obj.toString) && obj.toString !== toString;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isUndefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is undefined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is undefined.
	 */
	function isUndefined(value) {return typeof value === 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDefined
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is defined.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is defined.
	 */
	function isDefined(value) {return typeof value !== 'undefined';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isObject
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
	 * considered to be objects. Note that JavaScript arrays are objects.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Object` but not `null`.
	 */
	function isObject(value) {
	  // http://jsperf.com/isobject4
	  return value !== null && typeof value === 'object';
	}
	
	
	/**
	 * Determine if a value is an object with a null prototype
	 *
	 * @returns {boolean} True if `value` is an `Object` with a null prototype
	 */
	function isBlankObject(value) {
	  return value !== null && typeof value === 'object' && !getPrototypeOf(value);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isString
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `String`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `String`.
	 */
	function isString(value) {return typeof value === 'string';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isNumber
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Number`.
	 *
	 * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
	 *
	 * If you wish to exclude these then you can use the native
	 * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
	 * method.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Number`.
	 */
	function isNumber(value) {return typeof value === 'number';}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isDate
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a value is a date.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Date`.
	 */
	function isDate(value) {
	  return toString.call(value) === '[object Date]';
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.isArray
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is an `Array`. Alias of Array.isArray.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is an `Array`.
	 */
	var isArray = Array.isArray;
	
	/**
	 * @ngdoc function
	 * @name angular.isFunction
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a `Function`.
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `Function`.
	 */
	function isFunction(value) {return typeof value === 'function';}
	
	
	/**
	 * Determines if a value is a regular expression object.
	 *
	 * @private
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a `RegExp`.
	 */
	function isRegExp(value) {
	  return toString.call(value) === '[object RegExp]';
	}
	
	
	/**
	 * Checks if `obj` is a window object.
	 *
	 * @private
	 * @param {*} obj Object to check
	 * @returns {boolean} True if `obj` is a window obj.
	 */
	function isWindow(obj) {
	  return obj && obj.window === obj;
	}
	
	
	function isScope(obj) {
	  return obj && obj.$evalAsync && obj.$watch;
	}
	
	
	function isFile(obj) {
	  return toString.call(obj) === '[object File]';
	}
	
	
	function isFormData(obj) {
	  return toString.call(obj) === '[object FormData]';
	}
	
	
	function isBlob(obj) {
	  return toString.call(obj) === '[object Blob]';
	}
	
	
	function isBoolean(value) {
	  return typeof value === 'boolean';
	}
	
	
	function isPromiseLike(obj) {
	  return obj && isFunction(obj.then);
	}
	
	
	var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
	function isTypedArray(value) {
	  return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
	}
	
	function isArrayBuffer(obj) {
	  return toString.call(obj) === '[object ArrayBuffer]';
	}
	
	
	var trim = function(value) {
	  return isString(value) ? value.trim() : value;
	};
	
	// Copied from:
	// http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
	// Prereq: s is a string.
	var escapeForRegexp = function(s) {
	  return s
	    .replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
	    // eslint-disable-next-line no-control-regex
	    .replace(/\x08/g, '\\x08');
	};
	
	
	/**
	 * @ngdoc function
	 * @name angular.isElement
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if a reference is a DOM element (or wrapped jQuery element).
	 *
	 * @param {*} value Reference to check.
	 * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
	 */
	function isElement(node) {
	  return !!(node &&
	    (node.nodeName  // We are a direct element.
	    || (node.prop && node.attr && node.find)));  // We have an on and find method part of jQuery API.
	}
	
	/**
	 * @param str 'key1,key2,...'
	 * @returns {object} in the form of {key1:true, key2:true, ...}
	 */
	function makeMap(str) {
	  var obj = {}, items = str.split(','), i;
	  for (i = 0; i < items.length; i++) {
	    obj[items[i]] = true;
	  }
	  return obj;
	}
	
	
	function nodeName_(element) {
	  return lowercase(element.nodeName || (element[0] && element[0].nodeName));
	}
	
	function includes(array, obj) {
	  return Array.prototype.indexOf.call(array, obj) !== -1;
	}
	
	function arrayRemove(array, value) {
	  var index = array.indexOf(value);
	  if (index >= 0) {
	    array.splice(index, 1);
	  }
	  return index;
	}
	
	/**
	 * @ngdoc function
	 * @name angular.copy
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Creates a deep copy of `source`, which should be an object or an array.
	 *
	 * * If no destination is supplied, a copy of the object or array is created.
	 * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
	 *   are deleted and then all elements/properties from the source are copied to it.
	 * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
	 * * If `source` is identical to `destination` an exception will be thrown.
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
	 *   and on `destination`) will be ignored.
	 * </div>
	 *
	 * @param {*} source The source that will be used to make a copy.
	 *                   Can be any type, including primitives, `null`, and `undefined`.
	 * @param {(Object|Array)=} destination Destination into which the source is copied. If
	 *     provided, must be of the same type as `source`.
	 * @returns {*} The copy or updated `destination`, if `destination` was specified.
	 *
	 * @example
	  <example module="copyExample" name="angular-copy">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate class="simple-form">
	          <label>Name: <input type="text" ng-model="user.name" /></label><br />
	          <label>Age:  <input type="number" ng-model="user.age" /></label><br />
	          Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
	                  <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
	          <button ng-click="reset()">RESET</button>
	          <button ng-click="update(user)">SAVE</button>
	        </form>
	        <pre>form = {{user | json}}</pre>
	        <pre>master = {{master | json}}</pre>
	      </div>
	    </file>
	    <file name="script.js">
	      // Module: copyExample
	      angular.
	        module('copyExample', []).
	        controller('ExampleController', ['$scope', function($scope) {
	          $scope.master = {};
	
	          $scope.reset = function() {
	            // Example with 1 argument
	            $scope.user = angular.copy($scope.master);
	          };
	
	          $scope.update = function(user) {
	            // Example with 2 arguments
	            angular.copy(user, $scope.master);
	          };
	
	          $scope.reset();
	        }]);
	    </file>
	  </example>
	 */
	function copy(source, destination, maxDepth) {
	  var stackSource = [];
	  var stackDest = [];
	  maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
	
	  if (destination) {
	    if (isTypedArray(destination) || isArrayBuffer(destination)) {
	      throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
	    }
	    if (source === destination) {
	      throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
	    }
	
	    // Empty the destination object
	    if (isArray(destination)) {
	      destination.length = 0;
	    } else {
	      forEach(destination, function(value, key) {
	        if (key !== '$$hashKey') {
	          delete destination[key];
	        }
	      });
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	    return copyRecurse(source, destination, maxDepth);
	  }
	
	  return copyElement(source, maxDepth);
	
	  function copyRecurse(source, destination, maxDepth) {
	    maxDepth--;
	    if (maxDepth < 0) {
	      return '...';
	    }
	    var h = destination.$$hashKey;
	    var key;
	    if (isArray(source)) {
	      for (var i = 0, ii = source.length; i < ii; i++) {
	        destination.push(copyElement(source[i], maxDepth));
	      }
	    } else if (isBlankObject(source)) {
	      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
	      for (key in source) {
	        destination[key] = copyElement(source[key], maxDepth);
	      }
	    } else if (source && typeof source.hasOwnProperty === 'function') {
	      // Slow path, which must rely on hasOwnProperty
	      for (key in source) {
	        if (source.hasOwnProperty(key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    } else {
	      // Slowest path --- hasOwnProperty can't be called as a method
	      for (key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          destination[key] = copyElement(source[key], maxDepth);
	        }
	      }
	    }
	    setHashKey(destination, h);
	    return destination;
	  }
	
	  function copyElement(source, maxDepth) {
	    // Simple values
	    if (!isObject(source)) {
	      return source;
	    }
	
	    // Already copied values
	    var index = stackSource.indexOf(source);
	    if (index !== -1) {
	      return stackDest[index];
	    }
	
	    if (isWindow(source) || isScope(source)) {
	      throw ngMinErr('cpws',
	        'Can\'t copy! Making copies of Window or Scope instances is not supported.');
	    }
	
	    var needsRecurse = false;
	    var destination = copyType(source);
	
	    if (destination === undefined) {
	      destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
	      needsRecurse = true;
	    }
	
	    stackSource.push(source);
	    stackDest.push(destination);
	
	    return needsRecurse
	      ? copyRecurse(source, destination, maxDepth)
	      : destination;
	  }
	
	  function copyType(source) {
	    switch (toString.call(source)) {
	      case '[object Int8Array]':
	      case '[object Int16Array]':
	      case '[object Int32Array]':
	      case '[object Float32Array]':
	      case '[object Float64Array]':
	      case '[object Uint8Array]':
	      case '[object Uint8ClampedArray]':
	      case '[object Uint16Array]':
	      case '[object Uint32Array]':
	        return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
	
	      case '[object ArrayBuffer]':
	        // Support: IE10
	        if (!source.slice) {
	          // If we're in this case we know the environment supports ArrayBuffer
	          /* eslint-disable no-undef */
	          var copied = new ArrayBuffer(source.byteLength);
	          new Uint8Array(copied).set(new Uint8Array(source));
	          /* eslint-enable */
	          return copied;
	        }
	        return source.slice(0);
	
	      case '[object Boolean]':
	      case '[object Number]':
	      case '[object String]':
	      case '[object Date]':
	        return new source.constructor(source.valueOf());
	
	      case '[object RegExp]':
	        var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
	        re.lastIndex = source.lastIndex;
	        return re;
	
	      case '[object Blob]':
	        return new source.constructor([source], {type: source.type});
	    }
	
	    if (isFunction(source.cloneNode)) {
	      return source.cloneNode(true);
	    }
	  }
	}
	
	
	// eslint-disable-next-line no-self-compare
	function simpleCompare(a, b) { return a === b || (a !== a && b !== b); }
	
	
	/**
	 * @ngdoc function
	 * @name angular.equals
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Determines if two objects or two values are equivalent. Supports value types, regular
	 * expressions, arrays and objects.
	 *
	 * Two objects or values are considered equivalent if at least one of the following is true:
	 *
	 * * Both objects or values pass `===` comparison.
	 * * Both objects or values are of the same type and all of their properties are equal by
	 *   comparing them with `angular.equals`.
	 * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
	 * * Both values represent the same regular expression (In JavaScript,
	 *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
	 *   representation matches).
	 *
	 * During a property comparison, properties of `function` type and properties with names
	 * that begin with `$` are ignored.
	 *
	 * Scope and DOMWindow objects are being compared only by identify (`===`).
	 *
	 * @param {*} o1 Object or value to compare.
	 * @param {*} o2 Object or value to compare.
	 * @returns {boolean} True if arguments are equal.
	 *
	 * @example
	   <example module="equalsExample" name="equalsExample">
	     <file name="index.html">
	      <div ng-controller="ExampleController">
	        <form novalidate>
	          <h3>User 1</h3>
	          Name: <input type="text" ng-model="user1.name">
	          Age: <input type="number" ng-model="user1.age">
	
	          <h3>User 2</h3>
	          Name: <input type="text" ng-model="user2.name">
	          Age: <input type="number" ng-model="user2.age">
	
	          <div>
	            <br/>
	            <input type="button" value="Compare" ng-click="compare()">
	          </div>
	          User 1: <pre>{{user1 | json}}</pre>
	          User 2: <pre>{{user2 | json}}</pre>
	          Equal: <pre>{{result}}</pre>
	        </form>
	      </div>
	    </file>
	    <file name="script.js">
	        angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
	          $scope.user1 = {};
	          $scope.user2 = {};
	          $scope.compare = function() {
	            $scope.result = angular.equals($scope.user1, $scope.user2);
	          };
	        }]);
	    </file>
	  </example>
	 */
	function equals(o1, o2) {
	  if (o1 === o2) return true;
	  if (o1 === null || o2 === null) return false;
	  // eslint-disable-next-line no-self-compare
	  if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
	  var t1 = typeof o1, t2 = typeof o2, length, key, keySet;
	  if (t1 === t2 && t1 === 'object') {
	    if (isArray(o1)) {
	      if (!isArray(o2)) return false;
	      if ((length = o1.length) === o2.length) {
	        for (key = 0; key < length; key++) {
	          if (!equals(o1[key], o2[key])) return false;
	        }
	        return true;
	      }
	    } else if (isDate(o1)) {
	      if (!isDate(o2)) return false;
	      return simpleCompare(o1.getTime(), o2.getTime());
	    } else if (isRegExp(o1)) {
	      if (!isRegExp(o2)) return false;
	      return o1.toString() === o2.toString();
	    } else {
	      if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) ||
	        isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
	      keySet = createMap();
	      for (key in o1) {
	        if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
	        if (!equals(o1[key], o2[key])) return false;
	        keySet[key] = true;
	      }
	      for (key in o2) {
	        if (!(key in keySet) &&
	            key.charAt(0) !== '$' &&
	            isDefined(o2[key]) &&
	            !isFunction(o2[key])) return false;
	      }
	      return true;
	    }
	  }
	  return false;
	}
	
	var csp = function() {
	  if (!isDefined(csp.rules)) {
	
	
	    var ngCspElement = (window.document.querySelector('[ng-csp]') ||
	                    window.document.querySelector('[data-ng-csp]'));
	
	    if (ngCspElement) {
	      var ngCspAttribute = ngCspElement.getAttribute('ng-csp') ||
	                    ngCspElement.getAttribute('data-ng-csp');
	      csp.rules = {
	        noUnsafeEval: !ngCspAttribute || (ngCspAttribute.indexOf('no-unsafe-eval') !== -1),
	        noInlineStyle: !ngCspAttribute || (ngCspAttribute.indexOf('no-inline-style') !== -1)
	      };
	    } else {
	      csp.rules = {
	        noUnsafeEval: noUnsafeEval(),
	        noInlineStyle: false
	      };
	    }
	  }
	
	  return csp.rules;
	
	  function noUnsafeEval() {
	    try {
	      // eslint-disable-next-line no-new, no-new-func
	      new Function('');
	      return false;
	    } catch (e) {
	      return true;
	    }
	  }
	};
	
	/**
	 * @ngdoc directive
	 * @module ng
	 * @name ngJq
	 *
	 * @element ANY
	 * @param {string=} ngJq the name of the library available under `window`
	 * to be used for angular.element
	 * @description
	 * Use this directive to force the angular.element library.  This should be
	 * used to force either jqLite by leaving ng-jq blank or setting the name of
	 * the jquery variable under window (eg. jQuery).
	 *
	 * Since angular looks for this directive when it is loaded (doesn't wait for the
	 * DOMContentLoaded event), it must be placed on an element that comes before the script
	 * which loads angular. Also, only the first instance of `ng-jq` will be used and all
	 * others ignored.
	 *
	 * @example
	 * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq>
	 ...
	 ...
	 </html>
	 ```
	 * @example
	 * This example shows how to use a jQuery based library of a different name.
	 * The library name must be available at the top most 'window'.
	 ```html
	 <!doctype html>
	 <html ng-app ng-jq="jQueryLib">
	 ...
	 ...
	 </html>
	 ```
	 */
	var jq = function() {
	  if (isDefined(jq.name_)) return jq.name_;
	  var el;
	  var i, ii = ngAttrPrefixes.length, prefix, name;
	  for (i = 0; i < ii; ++i) {
	    prefix = ngAttrPrefixes[i];
	    el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
	    if (el) {
	      name = el.getAttribute(prefix + 'jq');
	      break;
	    }
	  }
	
	  return (jq.name_ = name);
	};
	
	function concat(array1, array2, index) {
	  return array1.concat(slice.call(array2, index));
	}
	
	function sliceArgs(args, startIndex) {
	  return slice.call(args, startIndex || 0);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.bind
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
	 * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
	 * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
	 * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
	 *
	 * @param {Object} self Context which `fn` should be evaluated in.
	 * @param {function()} fn Function to be bound.
	 * @param {...*} args Optional arguments to be prebound to the `fn` function call.
	 * @returns {function()} Function that wraps the `fn` with all the specified bindings.
	 */
	function bind(self, fn) {
	  var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
	  if (isFunction(fn) && !(fn instanceof RegExp)) {
	    return curryArgs.length
	      ? function() {
	          return arguments.length
	            ? fn.apply(self, concat(curryArgs, arguments, 0))
	            : fn.apply(self, curryArgs);
	        }
	      : function() {
	          return arguments.length
	            ? fn.apply(self, arguments)
	            : fn.call(self);
	        };
	  } else {
	    // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
	    return fn;
	  }
	}
	
	
	function toJsonReplacer(key, value) {
	  var val = value;
	
	  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
	    val = undefined;
	  } else if (isWindow(value)) {
	    val = '$WINDOW';
	  } else if (value &&  window.document === value) {
	    val = '$DOCUMENT';
	  } else if (isScope(value)) {
	    val = '$SCOPE';
	  }
	
	  return val;
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.toJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
	 * stripped since angular uses this notation internally.
	 *
	 * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
	 * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
	 *    If set to an integer, the JSON output will contain that many spaces per indentation.
	 * @returns {string|undefined} JSON-ified string representing `obj`.
	 * @knownIssue
	 *
	 * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
	 * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
	 * `Date.prototype.toJSON` method as follows:
	 *
	 * ```
	 * var _DatetoJSON = Date.prototype.toJSON;
	 * Date.prototype.toJSON = function() {
	 *   try {
	 *     return _DatetoJSON.call(this);
	 *   } catch(e) {
	 *     if (e instanceof RangeError) {
	 *       return null;
	 *     }
	 *     throw e;
	 *   }
	 * };
	 * ```
	 *
	 * See https://github.com/angular/angular.js/pull/14221 for more information.
	 */
	function toJson(obj, pretty) {
	  if (isUndefined(obj)) return undefined;
	  if (!isNumber(pretty)) {
	    pretty = pretty ? 2 : null;
	  }
	  return JSON.stringify(obj, toJsonReplacer, pretty);
	}
	
	
	/**
	 * @ngdoc function
	 * @name angular.fromJson
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Deserializes a JSON string.
	 *
	 * @param {string} json JSON string to deserialize.
	 * @returns {Object|Array|string|number} Deserialized JSON string.
	 */
	function fromJson(json) {
	  return isString(json)
	      ? JSON.parse(json)
	      : json;
	}
	
	
	var ALL_COLONS = /:/g;
	function timezoneToOffset(timezone, fallback) {
	  // Support: IE 9-11 only, Edge 13-14+
	  // IE/Edge do not "understand" colon (`:`) in timezone
	  timezone = timezone.replace(ALL_COLONS, '');
	  var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
	  return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
	}
	
	
	function addDateMinutes(date, minutes) {
	  date = new Date(date.getTime());
	  date.setMinutes(date.getMinutes() + minutes);
	  return date;
	}
	
	
	function convertTimezoneToLocal(date, timezone, reverse) {
	  reverse = reverse ? -1 : 1;
	  var dateTimezoneOffset = date.getTimezoneOffset();
	  var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	  return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
	}
	
	
	/**
	 * @returns {string} Returns the string representation of the element.
	 */
	function startingTag(element) {
	  element = jqLite(element).clone();
	  try {
	    // turns out IE does not let you set .html() on elements which
	    // are not allowed to have children. So we just ignore it.
	    element.empty();
	  } catch (e) { /* empty */ }
	  var elemHtml = jqLite('<div>').append(element).html();
	  try {
	    return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) :
	        elemHtml.
	          match(/^(<[^>]+>)/)[1].
	          replace(/^<([\w-]+)/, function(match, nodeName) {return '<' + lowercase(nodeName);});
	  } catch (e) {
	    return lowercase(elemHtml);
	  }
	
	}
	
	
	/////////////////////////////////////////////////
	
	/**
	 * Tries to decode the URI component without throwing an exception.
	 *
	 * @private
	 * @param str value potential URI component to check.
	 * @returns {boolean} True if `value` can be decoded
	 * with the decodeURIComponent function.
	 */
	function tryDecodeURIComponent(value) {
	  try {
	    return decodeURIComponent(value);
	  } catch (e) {
	    // Ignore any invalid uri component.
	  }
	}
	
	
	/**
	 * Parses an escaped url query string into key-value pairs.
	 * @returns {Object.<string,boolean|Array>}
	 */
	function parseKeyValue(/**string*/keyValue) {
	  var obj = {};
	  forEach((keyValue || '').split('&'), function(keyValue) {
	    var splitPoint, key, val;
	    if (keyValue) {
	      key = keyValue = keyValue.replace(/\+/g,'%20');
	      splitPoint = keyValue.indexOf('=');
	      if (splitPoint !== -1) {
	        key = keyValue.substring(0, splitPoint);
	        val = keyValue.substring(splitPoint + 1);
	      }
	      key = tryDecodeURIComponent(key);
	      if (isDefined(key)) {
	        val = isDefined(val) ? tryDecodeURIComponent(val) : true;
	        if (!hasOwnProperty.call(obj, key)) {
	          obj[key] = val;
	        } else if (isArray(obj[key])) {
	          obj[key].push(val);
	        } else {
	          obj[key] = [obj[key],val];
	        }
	      }
	    }
	  });
	  return obj;
	}
	
	function toKeyValue(obj) {
	  var parts = [];
	  forEach(obj, function(value, key) {
	    if (isArray(value)) {
	      forEach(value, function(arrayValue) {
	        parts.push(encodeUriQuery(key, true) +
	                   (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
	      });
	    } else {
	    parts.push(encodeUriQuery(key, true) +
	               (value === true ? '' : '=' + encodeUriQuery(value, true)));
	    }
	  });
	  return parts.length ? parts.join('&') : '';
	}
	
	
	/**
	 * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
	 * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
	 * segments:
	 *    segment       = *pchar
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriSegment(val) {
	  return encodeUriQuery(val, true).
	             replace(/%26/gi, '&').
	             replace(/%3D/gi, '=').
	             replace(/%2B/gi, '+');
	}
	
	
	/**
	 * This method is intended for encoding *key* or *value* parts of query component. We need a custom
	 * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
	 * encoded per http://tools.ietf.org/html/rfc3986:
	 *    query         = *( pchar / "/" / "?" )
	 *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
	 *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
	 *    pct-encoded   = "%" HEXDIG HEXDIG
	 *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
	 *                     / "*" / "+" / "," / ";" / "="
	 */
	function encodeUriQuery(val, pctEncodeSpaces) {
	  return encodeURIComponent(val).
	             replace(/%40/gi, '@').
	             replace(/%3A/gi, ':').
	             replace(/%24/g, '$').
	             replace(/%2C/gi, ',').
	             replace(/%3B/gi, ';').
	             replace(/%20/g, (pctEncodeSpaces ? '%20' : '+'));
	}
	
	var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
	
	function getNgAttribute(element, ngAttr) {
	  var attr, i, ii = ngAttrPrefixes.length;
	  for (i = 0; i < ii; ++i) {
	    attr = ngAttrPrefixes[i] + ngAttr;
	    if (isString(attr = element.getAttribute(attr))) {
	      return attr;
	    }
	  }
	  return null;
	}
	
	function allowAutoBootstrap(document) {
	  var script = document.currentScript;
	
	  if (!script) {
	    // IE does not have `document.currentScript`
	    return true;
	  }
	
	  // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
	  if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
	    return false;
	  }
	
	  var attributes = script.attributes;
	  var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
	
	  return srcs.every(function(src) {
	    if (!src) {
	      return true;
	    }
	    if (!src.value) {
	      return false;
	    }
	
	    var link = document.createElement('a');
	    link.href = src.value;
	
	    if (document.location.origin === link.origin) {
	      // Same-origin resources are always allowed, even for non-whitelisted schemes.
	      return true;
	    }
	    // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
	    // This is to prevent angular.js bundled with browser extensions from being used to bypass the
	    // content security policy in web pages and other browser extensions.
	    switch (link.protocol) {
	      case 'http:':
	      case 'https:':
	      case 'ftp:':
	      case 'blob:':
	      case 'file:':
	      case 'data:':
	        return true;
	      default:
	        return false;
	    }
	  });
	}
	
	// Cached as it has to run during loading so that document.currentScript is available.
	var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);
	
	/**
	 * @ngdoc directive
	 * @name ngApp
	 * @module ng
	 *
	 * @element ANY
	 * @param {angular.Module} ngApp an optional application
	 *   {@link angular.module module} name to load.
	 * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
	 *   created in "strict-di" mode. This means that the application will fail to invoke functions which
	 *   do not use explicit function annotation (and are thus unsuitable for minification), as described
	 *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
	 *   tracking down the root of these bugs.
	 *
	 * @description
	 *
	 * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
	 * designates the **root element** of the application and is typically placed near the root element
	 * of the page - e.g. on the `<body>` or `<html>` tags.
	 *
	 * There are a few things to keep in mind when using `ngApp`:
	 * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
	 *   found in the document will be used to define the root element to auto-bootstrap as an
	 *   application. To run multiple applications in an HTML document you must manually bootstrap them using
	 *   {@link angular.bootstrap} instead.
	 * - AngularJS applications cannot be nested within each other.
	 * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
	 *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
	 *   {@link ngRoute.ngView `ngView`}.
	 *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 *   causing animations to stop working and making the injector inaccessible from outside the app.
	 *
	 * You can specify an **AngularJS module** to be used as the root module for the application.  This
	 * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
	 * should contain the application code needed or have dependencies on other modules that will
	 * contain the code. See {@link angular.module} for more information.
	 *
	 * In the example below if the `ngApp` directive were not placed on the `html` element then the
	 * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
	 * would not be resolved to `3`.
	 *
	 * `ngApp` is the easiest, and most common way to bootstrap an application.
	 *
	 <example module="ngAppDemo" name="ng-app">
	   <file name="index.html">
	   <div ng-controller="ngAppDemoController">
	     I can add: {{a}} + {{b}} =  {{ a+b }}
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
	     $scope.a = 1;
	     $scope.b = 2;
	   });
	   </file>
	 </example>
	 *
	 * Using `ngStrictDi`, you would see something like this:
	 *
	 <example ng-app-included="true" name="strict-di">
	   <file name="index.html">
	   <div ng-app="ngAppStrictDemo" ng-strict-di>
	       <div ng-controller="GoodController1">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style (see
	              script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="GoodController2">
	           Name: <input ng-model="name"><br />
	           Hello, {{name}}!
	
	           <p>This renders because the controller does not fail to
	              instantiate, by using explicit annotation style
	              (see script.js for details)
	           </p>
	       </div>
	
	       <div ng-controller="BadController">
	           I can add: {{a}} + {{b}} =  {{ a+b }}
	
	           <p>The controller could not be instantiated, due to relying
	              on automatic function annotations (which are disabled in
	              strict mode). As such, the content of this section is not
	              interpolated, and there should be an error in your web console.
	           </p>
	       </div>
	   </div>
	   </file>
	   <file name="script.js">
	   angular.module('ngAppStrictDemo', [])
	     // BadController will fail to instantiate, due to relying on automatic function annotation,
	     // rather than an explicit annotation
	     .controller('BadController', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     })
	     // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
	     // due to using explicit annotations using the array style and $inject property, respectively.
	     .controller('GoodController1', ['$scope', function($scope) {
	       $scope.a = 1;
	       $scope.b = 2;
	     }])
	     .controller('GoodController2', GoodController2);
	     function GoodController2($scope) {
	       $scope.name = 'World';
	     }
	     GoodController2.$inject = ['$scope'];
	   </file>
	   <file name="style.css">
	   div[ng-controller] {
	       margin-bottom: 1em;
	       -webkit-border-radius: 4px;
	       border-radius: 4px;
	       border: 1px solid;
	       padding: .5em;
	   }
	   div[ng-controller^=Good] {
	       border-color: #d6e9c6;
	       background-color: #dff0d8;
	       color: #3c763d;
	   }
	   div[ng-controller^=Bad] {
	       border-color: #ebccd1;
	       background-color: #f2dede;
	       color: #a94442;
	       margin-bottom: 0;
	   }
	   </file>
	 </example>
	 */
	function angularInit(element, bootstrap) {
	  var appElement,
	      module,
	      config = {};
	
	  // The element `element` has priority over any other element.
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	
	    if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
	      appElement = element;
	      module = element.getAttribute(name);
	    }
	  });
	  forEach(ngAttrPrefixes, function(prefix) {
	    var name = prefix + 'app';
	    var candidate;
	
	    if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
	      appElement = candidate;
	      module = candidate.getAttribute(name);
	    }
	  });
	  if (appElement) {
	    if (!isAutoBootstrapAllowed) {
	      window.console.error('Angular: disabling automatic bootstrap. <script> protocol indicates ' +
	          'an extension, document.location.href does not match.');
	      return;
	    }
	    config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
	    bootstrap(appElement, module ? [module] : [], config);
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.bootstrap
	 * @module ng
	 * @description
	 * Use this function to manually start up angular application.
	 *
	 * For more information, see the {@link guide/bootstrap Bootstrap guide}.
	 *
	 * Angular will detect if it has been loaded into the browser more than once and only allow the
	 * first loaded script to be bootstrapped and will report a warning to the browser console for
	 * each of the subsequent scripts. This prevents strange results in applications, where otherwise
	 * multiple instances of Angular try to work on the DOM.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
	 * They must use {@link ng.directive:ngApp ngApp}.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
	 * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
	 * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
	 * causing animations to stop working and making the injector inaccessible from outside the app.
	 * </div>
	 *
	 * ```html
	 * <!doctype html>
	 * <html>
	 * <body>
	 * <div ng-controller="WelcomeController">
	 *   {{greeting}}
	 * </div>
	 *
	 * <script src="angular.js"></script>
	 * <script>
	 *   var app = angular.module('demo', [])
	 *   .controller('WelcomeController', function($scope) {
	 *       $scope.greeting = 'Welcome!';
	 *   });
	 *   angular.bootstrap(document, ['demo']);
	 * </script>
	 * </body>
	 * </html>
	 * ```
	 *
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
	 *     Each item in the array should be the name of a predefined module or a (DI annotated)
	 *     function that will be invoked by the injector as a `config` block.
	 *     See: {@link angular.module modules}
	 * @param {Object=} config an object for defining configuration options for the application. The
	 *     following keys are supported:
	 *
	 * * `strictDi` - disable automatic function annotation for the application. This is meant to
	 *   assist in finding bugs which break minified code. Defaults to `false`.
	 *
	 * @returns {auto.$injector} Returns the newly created injector for this app.
	 */
	function bootstrap(element, modules, config) {
	  if (!isObject(config)) config = {};
	  var defaultConfig = {
	    strictDi: false
	  };
	  config = extend(defaultConfig, config);
	  var doBootstrap = function() {
	    element = jqLite(element);
	
	    if (element.injector()) {
	      var tag = (element[0] === window.document) ? 'document' : startingTag(element);
	      // Encode angle brackets to prevent input from being sanitized to empty string #8683.
	      throw ngMinErr(
	          'btstrpd',
	          'App already bootstrapped with this element \'{0}\'',
	          tag.replace(/</,'&lt;').replace(/>/,'&gt;'));
	    }
	
	    modules = modules || [];
	    modules.unshift(['$provide', function($provide) {
	      $provide.value('$rootElement', element);
	    }]);
	
	    if (config.debugInfoEnabled) {
	      // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
	      modules.push(['$compileProvider', function($compileProvider) {
	        $compileProvider.debugInfoEnabled(true);
	      }]);
	    }
	
	    modules.unshift('ng');
	    var injector = createInjector(modules, config.strictDi);
	    injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector',
	       function bootstrapApply(scope, element, compile, injector) {
	        scope.$apply(function() {
	          element.data('$injector', injector);
	          compile(element)(scope);
	        });
	      }]
	    );
	    return injector;
	  };
	
	  var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
	  var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
	
	  if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
	    config.debugInfoEnabled = true;
	    window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
	  }
	
	  if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
	    return doBootstrap();
	  }
	
	  window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
	  angular.resumeBootstrap = function(extraModules) {
	    forEach(extraModules, function(module) {
	      modules.push(module);
	    });
	    return doBootstrap();
	  };
	
	  if (isFunction(angular.resumeDeferredBootstrap)) {
	    angular.resumeDeferredBootstrap();
	  }
	}
	
	/**
	 * @ngdoc function
	 * @name angular.reloadWithDebugInfo
	 * @module ng
	 * @description
	 * Use this function to reload the current application with debug information turned on.
	 * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
	 *
	 * See {@link ng.$compileProvider#debugInfoEnabled} for more.
	 */
	function reloadWithDebugInfo() {
	  window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
	  window.location.reload();
	}
	
	/**
	 * @name angular.getTestability
	 * @module ng
	 * @description
	 * Get the testability service for the instance of Angular on the given
	 * element.
	 * @param {DOMElement} element DOM element which is the root of angular application.
	 */
	function getTestability(rootElement) {
	  var injector = angular.element(rootElement).injector();
	  if (!injector) {
	    throw ngMinErr('test',
	      'no injector found for element argument to getTestability');
	  }
	  return injector.get('$$testability');
	}
	
	var SNAKE_CASE_REGEXP = /[A-Z]/g;
	function snake_case(name, separator) {
	  separator = separator || '_';
	  return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
	    return (pos ? separator : '') + letter.toLowerCase();
	  });
	}
	
	var bindJQueryFired = false;
	function bindJQuery() {
	  var originalCleanData;
	
	  if (bindJQueryFired) {
	    return;
	  }
	
	  // bind to jQuery if present;
	  var jqName = jq();
	  jQuery = isUndefined(jqName) ? window.jQuery :   // use jQuery (if present)
	           !jqName             ? undefined     :   // use jqLite
	                                 window[jqName];   // use jQuery specified by `ngJq`
	
	  // Use jQuery if it exists with proper functionality, otherwise default to us.
	  // Angular 1.2+ requires jQuery 1.7+ for on()/off() support.
	  // Angular 1.3+ technically requires at least jQuery 2.1+ but it may work with older
	  // versions. It will not work for sure with jQuery <1.7, though.
	  if (jQuery && jQuery.fn.on) {
	    jqLite = jQuery;
	    extend(jQuery.fn, {
	      scope: JQLitePrototype.scope,
	      isolateScope: JQLitePrototype.isolateScope,
	      controller: /** @type {?} */ (JQLitePrototype).controller,
	      injector: JQLitePrototype.injector,
	      inheritedData: JQLitePrototype.inheritedData
	    });
	
	    // All nodes removed from the DOM via various jQuery APIs like .remove()
	    // are passed through jQuery.cleanData. Monkey-patch this method to fire
	    // the $destroy event on all removed nodes.
	    originalCleanData = jQuery.cleanData;
	    jQuery.cleanData = function(elems) {
	      var events;
	      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
	        events = jQuery._data(elem, 'events');
	        if (events && events.$destroy) {
	          jQuery(elem).triggerHandler('$destroy');
	        }
	      }
	      originalCleanData(elems);
	    };
	  } else {
	    jqLite = JQLite;
	  }
	
	  angular.element = jqLite;
	
	  // Prevent double-proxying.
	  bindJQueryFired = true;
	}
	
	/**
	 * throw error if the argument is falsy.
	 */
	function assertArg(arg, name, reason) {
	  if (!arg) {
	    throw ngMinErr('areq', 'Argument \'{0}\' is {1}', (name || '?'), (reason || 'required'));
	  }
	  return arg;
	}
	
	function assertArgFn(arg, name, acceptArrayAnnotation) {
	  if (acceptArrayAnnotation && isArray(arg)) {
	      arg = arg[arg.length - 1];
	  }
	
	  assertArg(isFunction(arg), name, 'not a function, got ' +
	      (arg && typeof arg === 'object' ? arg.constructor.name || 'Object' : typeof arg));
	  return arg;
	}
	
	/**
	 * throw error if the name given is hasOwnProperty
	 * @param  {String} name    the name to test
	 * @param  {String} context the context in which the name is used, such as module or directive
	 */
	function assertNotHasOwnProperty(name, context) {
	  if (name === 'hasOwnProperty') {
	    throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	  }
	}
	
	/**
	 * Return the value accessible from the object by path. Any undefined traversals are ignored
	 * @param {Object} obj starting object
	 * @param {String} path path to traverse
	 * @param {boolean} [bindFnToScope=true]
	 * @returns {Object} value as accessible by path
	 */
	//TODO(misko): this function needs to be removed
	function getter(obj, path, bindFnToScope) {
	  if (!path) return obj;
	  var keys = path.split('.');
	  var key;
	  var lastInstance = obj;
	  var len = keys.length;
	
	  for (var i = 0; i < len; i++) {
	    key = keys[i];
	    if (obj) {
	      obj = (lastInstance = obj)[key];
	    }
	  }
	  if (!bindFnToScope && isFunction(obj)) {
	    return bind(lastInstance, obj);
	  }
	  return obj;
	}
	
	/**
	 * Return the DOM siblings between the first and last node in the given array.
	 * @param {Array} array like object
	 * @returns {Array} the inputted object or a jqLite collection containing the nodes
	 */
	function getBlockNodes(nodes) {
	  // TODO(perf): update `nodes` instead of creating a new object?
	  var node = nodes[0];
	  var endNode = nodes[nodes.length - 1];
	  var blockNodes;
	
	  for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
	    if (blockNodes || nodes[i] !== node) {
	      if (!blockNodes) {
	        blockNodes = jqLite(slice.call(nodes, 0, i));
	      }
	      blockNodes.push(node);
	    }
	  }
	
	  return blockNodes || nodes;
	}
	
	
	/**
	 * Creates a new object without a prototype. This object is useful for lookup without having to
	 * guard against prototypically inherited properties via hasOwnProperty.
	 *
	 * Related micro-benchmarks:
	 * - http://jsperf.com/object-create2
	 * - http://jsperf.com/proto-map-lookup/2
	 * - http://jsperf.com/for-in-vs-object-keys2
	 *
	 * @returns {Object}
	 */
	function createMap() {
	  return Object.create(null);
	}
	
	function stringify(value) {
	  if (value == null) { // null || undefined
	    return '';
	  }
	  switch (typeof value) {
	    case 'string':
	      break;
	    case 'number':
	      value = '' + value;
	      break;
	    default:
	      if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
	        value = value.toString();
	      } else {
	        value = toJson(value);
	      }
	  }
	
	  return value;
	}
	
	var NODE_TYPE_ELEMENT = 1;
	var NODE_TYPE_ATTRIBUTE = 2;
	var NODE_TYPE_TEXT = 3;
	var NODE_TYPE_COMMENT = 8;
	var NODE_TYPE_DOCUMENT = 9;
	var NODE_TYPE_DOCUMENT_FRAGMENT = 11;
	
	/**
	 * @ngdoc type
	 * @name angular.Module
	 * @module ng
	 * @description
	 *
	 * Interface for configuring angular {@link angular.module modules}.
	 */
	
	function setupModuleLoader(window) {
	
	  var $injectorMinErr = minErr('$injector');
	  var ngMinErr = minErr('ng');
	
	  function ensure(obj, name, factory) {
	    return obj[name] || (obj[name] = factory());
	  }
	
	  var angular = ensure(window, 'angular', Object);
	
	  // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
	  angular.$$minErr = angular.$$minErr || minErr;
	
	  return ensure(angular, 'module', function() {
	    /** @type {Object.<string, angular.Module>} */
	    var modules = {};
	
	    /**
	     * @ngdoc function
	     * @name angular.module
	     * @module ng
	     * @description
	     *
	     * The `angular.module` is a global place for creating, registering and retrieving Angular
	     * modules.
	     * All modules (angular core or 3rd party) that should be available to an application must be
	     * registered using this mechanism.
	     *
	     * Passing one argument retrieves an existing {@link angular.Module},
	     * whereas passing more than one argument creates a new {@link angular.Module}
	     *
	     *
	     * # Module
	     *
	     * A module is a collection of services, directives, controllers, filters, and configuration information.
	     * `angular.module` is used to configure the {@link auto.$injector $injector}.
	     *
	     * ```js
	     * // Create a new module
	     * var myModule = angular.module('myModule', []);
	     *
	     * // register a new service
	     * myModule.value('appName', 'MyCoolApp');
	     *
	     * // configure existing services inside initialization blocks.
	     * myModule.config(['$locationProvider', function($locationProvider) {
	     *   // Configure existing providers
	     *   $locationProvider.hashPrefix('!');
	     * }]);
	     * ```
	     *
	     * Then you can create an injector and load your modules like this:
	     *
	     * ```js
	     * var injector = angular.injector(['ng', 'myModule'])
	     * ```
	     *
	     * However it's more likely that you'll just use
	     * {@link ng.directive:ngApp ngApp} or
	     * {@link angular.bootstrap} to simplify this process for you.
	     *
	     * @param {!string} name The name of the module to create or retrieve.
	     * @param {!Array.<string>=} requires If specified then new module is being created. If
	     *        unspecified then the module is being retrieved for further configuration.
	     * @param {Function=} configFn Optional configuration function for the module. Same as
	     *        {@link angular.Module#config Module#config()}.
	     * @returns {angular.Module} new module with the {@link angular.Module} api.
	     */
	    return function module(name, requires, configFn) {
	
	      var info = {};
	
	      var assertNotHasOwnProperty = function(name, context) {
	        if (name === 'hasOwnProperty') {
	          throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
	        }
	      };
	
	      assertNotHasOwnProperty(name, 'module');
	      if (requires && modules.hasOwnProperty(name)) {
	        modules[name] = null;
	      }
	      return ensure(modules, name, function() {
	        if (!requires) {
	          throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' +
	             'the module name or forgot to load it. If registering a module ensure that you ' +
	             'specify the dependencies as the second argument.', name);
	        }
	
	        /** @type {!Array.<Array.<*>>} */
	        var invokeQueue = [];
	
	        /** @type {!Array.<Function>} */
	        var configBlocks = [];
	
	        /** @type {!Array.<Function>} */
	        var runBlocks = [];
	
	        var config = invokeLater('$injector', 'invoke', 'push', configBlocks);
	
	        /** @type {angular.Module} */
	        var moduleInstance = {
	          // Private state
	          _invokeQueue: invokeQueue,
	          _configBlocks: configBlocks,
	          _runBlocks: runBlocks,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#info
	           * @module ng
	           *
	           * @param {Object=} info Information about the module
	           * @returns {Object|Module} The current info object for this module if called as a getter,
	           *                          or `this` if called as a setter.
	           *
	           * @description
	           * Read and write custom information about this module.
	           * For example you could put the version of the module in here.
	           *
	           * ```js
	           * angular.module('myModule', []).info({ version: '1.0.0' });
	           * ```
	           *
	           * The version could then be read back out by accessing the module elsewhere:
	           *
	           * ```
	           * var version = angular.module('myModule').info().version;
	           * ```
	           *
	           * You can also retrieve this information during runtime via the
	           * {@link $injector#modules `$injector.modules`} property:
	           *
	           * ```js
	           * var version = $injector.modules['myModule'].info().version;
	           * ```
	           */
	          info: function(value) {
	            if (isDefined(value)) {
	              if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
	              info = value;
	              return this;
	            }
	            return info;
	          },
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#requires
	           * @module ng
	           *
	           * @description
	           * Holds the list of modules which the injector will load before the current module is
	           * loaded.
	           */
	          requires: requires,
	
	          /**
	           * @ngdoc property
	           * @name angular.Module#name
	           * @module ng
	           *
	           * @description
	           * Name of the module.
	           */
	          name: name,
	
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#provider
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerType Construction function for creating new instance of the
	           *                                service.
	           * @description
	           * See {@link auto.$provide#provider $provide.provider()}.
	           */
	          provider: invokeLaterAndSetModuleName('$provide', 'provider'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#factory
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} providerFunction Function for creating new instance of the service.
	           * @description
	           * See {@link auto.$provide#factory $provide.factory()}.
	           */
	          factory: invokeLaterAndSetModuleName('$provide', 'factory'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#service
	           * @module ng
	           * @param {string} name service name
	           * @param {Function} constructor A constructor function that will be instantiated.
	           * @description
	           * See {@link auto.$provide#service $provide.service()}.
	           */
	          service: invokeLaterAndSetModuleName('$provide', 'service'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#value
	           * @module ng
	           * @param {string} name service name
	           * @param {*} object Service instance object.
	           * @description
	           * See {@link auto.$provide#value $provide.value()}.
	           */
	          value: invokeLater('$provide', 'value'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#constant
	           * @module ng
	           * @param {string} name constant name
	           * @param {*} object Constant value.
	           * @description
	           * Because the constants are fixed, they get applied before other provide methods.
	           * See {@link auto.$provide#constant $provide.constant()}.
	           */
	          constant: invokeLater('$provide', 'constant', 'unshift'),
	
	           /**
	           * @ngdoc method
	           * @name angular.Module#decorator
	           * @module ng
	           * @param {string} name The name of the service to decorate.
	           * @param {Function} decorFn This function will be invoked when the service needs to be
	           *                           instantiated and should return the decorated service instance.
	           * @description
	           * See {@link auto.$provide#decorator $provide.decorator()}.
	           */
	          decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#animation
	           * @module ng
	           * @param {string} name animation name
	           * @param {Function} animationFactory Factory function for creating new instance of an
	           *                                    animation.
	           * @description
	           *
	           * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
	           *
	           *
	           * Defines an animation hook that can be later used with
	           * {@link $animate $animate} service and directives that use this service.
	           *
	           * ```js
	           * module.animation('.animation-name', function($inject1, $inject2) {
	           *   return {
	           *     eventName : function(element, done) {
	           *       //code to run the animation
	           *       //once complete, then run done()
	           *       return function cancellationFunction(element) {
	           *         //code to cancel the animation
	           *       }
	           *     }
	           *   }
	           * })
	           * ```
	           *
	           * See {@link ng.$animateProvider#register $animateProvider.register()} and
	           * {@link ngAnimate ngAnimate module} for more information.
	           */
	          animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#filter
	           * @module ng
	           * @param {string} name Filter name - this must be a valid angular expression identifier
	           * @param {Function} filterFactory Factory function for creating new instance of filter.
	           * @description
	           * See {@link ng.$filterProvider#register $filterProvider.register()}.
	           *
	           * <div class="alert alert-warning">
	           * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	           * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	           * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	           * (`myapp_subsection_filterx`).
	           * </div>
	           */
	          filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#controller
	           * @module ng
	           * @param {string|Object} name Controller name, or an object map of controllers where the
	           *    keys are the names and the values are the constructors.
	           * @param {Function} constructor Controller constructor function.
	           * @description
	           * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
	           */
	          controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#directive
	           * @module ng
	           * @param {string|Object} name Directive name, or an object map of directives where the
	           *    keys are the names and the values are the factories.
	           * @param {Function} directiveFactory Factory function for creating new instance of
	           * directives.
	           * @description
	           * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
	           */
	          directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#component
	           * @module ng
	           * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
	           * @param {Object} options Component definition object (a simplified
	           *    {@link ng.$compile#directive-definition-object directive definition object})
	           *
	           * @description
	           * See {@link ng.$compileProvider#component $compileProvider.component()}.
	           */
	          component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#config
	           * @module ng
	           * @param {Function} configFn Execute this function on module load. Useful for service
	           *    configuration.
	           * @description
	           * Use this method to register work which needs to be performed on module loading.
	           * For more about how to configure services, see
	           * {@link providers#provider-recipe Provider Recipe}.
	           */
	          config: config,
	
	          /**
	           * @ngdoc method
	           * @name angular.Module#run
	           * @module ng
	           * @param {Function} initializationFn Execute this function after injector creation.
	           *    Useful for application initialization.
	           * @description
	           * Use this method to register work which should be performed when the injector is done
	           * loading all modules.
	           */
	          run: function(block) {
	            runBlocks.push(block);
	            return this;
	          }
	        };
	
	        if (configFn) {
	          config(configFn);
	        }
	
	        return moduleInstance;
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @param {String=} insertMethod
	         * @returns {angular.Module}
	         */
	        function invokeLater(provider, method, insertMethod, queue) {
	          if (!queue) queue = invokeQueue;
	          return function() {
	            queue[insertMethod || 'push']([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	
	        /**
	         * @param {string} provider
	         * @param {string} method
	         * @returns {angular.Module}
	         */
	        function invokeLaterAndSetModuleName(provider, method, queue) {
	          if (!queue) queue = invokeQueue;
	          return function(recipeName, factoryFunction) {
	            if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
	            queue.push([provider, method, arguments]);
	            return moduleInstance;
	          };
	        }
	      });
	    };
	  });
	
	}
	
	/* global shallowCopy: true */
	
	/**
	 * Creates a shallow copy of an object, an array or a primitive.
	 *
	 * Assumes that there are no proto properties for objects.
	 */
	function shallowCopy(src, dst) {
	  if (isArray(src)) {
	    dst = dst || [];
	
	    for (var i = 0, ii = src.length; i < ii; i++) {
	      dst[i] = src[i];
	    }
	  } else if (isObject(src)) {
	    dst = dst || {};
	
	    for (var key in src) {
	      if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
	        dst[key] = src[key];
	      }
	    }
	  }
	
	  return dst || src;
	}
	
	/* global toDebugString: true */
	
	function serializeObject(obj, maxDepth) {
	  var seen = [];
	
	  // There is no direct way to stringify object until reaching a specific depth
	  // and a very deep object can cause a performance issue, so we copy the object
	  // based on this specific depth and then stringify it.
	  if (isValidObjectMaxDepth(maxDepth)) {
	    obj = copy(obj, null, maxDepth);
	  }
	  return JSON.stringify(obj, function(key, val) {
	    val = toJsonReplacer(key, val);
	    if (isObject(val)) {
	
	      if (seen.indexOf(val) >= 0) return '...';
	
	      seen.push(val);
	    }
	    return val;
	  });
	}
	
	function toDebugString(obj, maxDepth) {
	  if (typeof obj === 'function') {
	    return obj.toString().replace(/ \{[\s\S]*$/, '');
	  } else if (isUndefined(obj)) {
	    return 'undefined';
	  } else if (typeof obj !== 'string') {
	    return serializeObject(obj, maxDepth);
	  }
	  return obj;
	}
	
	/* global angularModule: true,
	  version: true,
	
	  $CompileProvider,
	
	  htmlAnchorDirective,
	  inputDirective,
	  inputDirective,
	  formDirective,
	  scriptDirective,
	  selectDirective,
	  optionDirective,
	  ngBindDirective,
	  ngBindHtmlDirective,
	  ngBindTemplateDirective,
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective,
	  ngCloakDirective,
	  ngControllerDirective,
	  ngFormDirective,
	  ngHideDirective,
	  ngIfDirective,
	  ngIncludeDirective,
	  ngIncludeFillContentDirective,
	  ngInitDirective,
	  ngNonBindableDirective,
	  ngPluralizeDirective,
	  ngRepeatDirective,
	  ngShowDirective,
	  ngStyleDirective,
	  ngSwitchDirective,
	  ngSwitchWhenDirective,
	  ngSwitchDefaultDirective,
	  ngOptionsDirective,
	  ngTranscludeDirective,
	  ngModelDirective,
	  ngListDirective,
	  ngChangeDirective,
	  patternDirective,
	  patternDirective,
	  requiredDirective,
	  requiredDirective,
	  minlengthDirective,
	  minlengthDirective,
	  maxlengthDirective,
	  maxlengthDirective,
	  ngValueDirective,
	  ngModelOptionsDirective,
	  ngAttributeAliasDirectives,
	  ngEventDirectives,
	
	  $AnchorScrollProvider,
	  $AnimateProvider,
	  $CoreAnimateCssProvider,
	  $$CoreAnimateJsProvider,
	  $$CoreAnimateQueueProvider,
	  $$AnimateRunnerFactoryProvider,
	  $$AnimateAsyncRunFactoryProvider,
	  $BrowserProvider,
	  $CacheFactoryProvider,
	  $ControllerProvider,
	  $DateProvider,
	  $DocumentProvider,
	  $$IsDocumentHiddenProvider,
	  $ExceptionHandlerProvider,
	  $FilterProvider,
	  $$ForceReflowProvider,
	  $InterpolateProvider,
	  $IntervalProvider,
	  $HttpProvider,
	  $HttpParamSerializerProvider,
	  $HttpParamSerializerJQLikeProvider,
	  $HttpBackendProvider,
	  $xhrFactoryProvider,
	  $jsonpCallbacksProvider,
	  $LocationProvider,
	  $LogProvider,
	  $$MapProvider,
	  $ParseProvider,
	  $RootScopeProvider,
	  $QProvider,
	  $$QProvider,
	  $$SanitizeUriProvider,
	  $SceProvider,
	  $SceDelegateProvider,
	  $SnifferProvider,
	  $TemplateCacheProvider,
	  $TemplateRequestProvider,
	  $$TestabilityProvider,
	  $TimeoutProvider,
	  $$RAFProvider,
	  $WindowProvider,
	  $$jqLiteProvider,
	  $$CookieReaderProvider
	*/
	
	
	/**
	 * @ngdoc object
	 * @name angular.version
	 * @module ng
	 * @description
	 * An object that contains information about the current AngularJS version.
	 *
	 * This object has the following properties:
	 *
	 * - `full` – `{string}` – Full version string, such as "0.9.18".
	 * - `major` – `{number}` – Major version number, such as "0".
	 * - `minor` – `{number}` – Minor version number, such as "9".
	 * - `dot` – `{number}` – Dot version number, such as "18".
	 * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
	 */
	var version = {
	  // These placeholder strings will be replaced by grunt's `build` task.
	  // They need to be double- or single-quoted.
	  full: '1.6.4',
	  major: 1,
	  minor: 6,
	  dot: 4,
	  codeName: 'phenomenal-footnote'
	};
	
	
	function publishExternalAPI(angular) {
	  extend(angular, {
	    'errorHandlingConfig': errorHandlingConfig,
	    'bootstrap': bootstrap,
	    'copy': copy,
	    'extend': extend,
	    'merge': merge,
	    'equals': equals,
	    'element': jqLite,
	    'forEach': forEach,
	    'injector': createInjector,
	    'noop': noop,
	    'bind': bind,
	    'toJson': toJson,
	    'fromJson': fromJson,
	    'identity': identity,
	    'isUndefined': isUndefined,
	    'isDefined': isDefined,
	    'isString': isString,
	    'isFunction': isFunction,
	    'isObject': isObject,
	    'isNumber': isNumber,
	    'isElement': isElement,
	    'isArray': isArray,
	    'version': version,
	    'isDate': isDate,
	    'lowercase': lowercase,
	    'uppercase': uppercase,
	    'callbacks': {$$counter: 0},
	    'getTestability': getTestability,
	    'reloadWithDebugInfo': reloadWithDebugInfo,
	    '$$minErr': minErr,
	    '$$csp': csp,
	    '$$encodeUriSegment': encodeUriSegment,
	    '$$encodeUriQuery': encodeUriQuery,
	    '$$stringify': stringify
	  });
	
	  angularModule = setupModuleLoader(window);
	
	  angularModule('ng', ['ngLocale'], ['$provide',
	    function ngModule($provide) {
	      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
	      $provide.provider({
	        $$sanitizeUri: $$SanitizeUriProvider
	      });
	      $provide.provider('$compile', $CompileProvider).
	        directive({
	            a: htmlAnchorDirective,
	            input: inputDirective,
	            textarea: inputDirective,
	            form: formDirective,
	            script: scriptDirective,
	            select: selectDirective,
	            option: optionDirective,
	            ngBind: ngBindDirective,
	            ngBindHtml: ngBindHtmlDirective,
	            ngBindTemplate: ngBindTemplateDirective,
	            ngClass: ngClassDirective,
	            ngClassEven: ngClassEvenDirective,
	            ngClassOdd: ngClassOddDirective,
	            ngCloak: ngCloakDirective,
	            ngController: ngControllerDirective,
	            ngForm: ngFormDirective,
	            ngHide: ngHideDirective,
	            ngIf: ngIfDirective,
	            ngInclude: ngIncludeDirective,
	            ngInit: ngInitDirective,
	            ngNonBindable: ngNonBindableDirective,
	            ngPluralize: ngPluralizeDirective,
	            ngRepeat: ngRepeatDirective,
	            ngShow: ngShowDirective,
	            ngStyle: ngStyleDirective,
	            ngSwitch: ngSwitchDirective,
	            ngSwitchWhen: ngSwitchWhenDirective,
	            ngSwitchDefault: ngSwitchDefaultDirective,
	            ngOptions: ngOptionsDirective,
	            ngTransclude: ngTranscludeDirective,
	            ngModel: ngModelDirective,
	            ngList: ngListDirective,
	            ngChange: ngChangeDirective,
	            pattern: patternDirective,
	            ngPattern: patternDirective,
	            required: requiredDirective,
	            ngRequired: requiredDirective,
	            minlength: minlengthDirective,
	            ngMinlength: minlengthDirective,
	            maxlength: maxlengthDirective,
	            ngMaxlength: maxlengthDirective,
	            ngValue: ngValueDirective,
	            ngModelOptions: ngModelOptionsDirective
	        }).
	        directive({
	          ngInclude: ngIncludeFillContentDirective
	        }).
	        directive(ngAttributeAliasDirectives).
	        directive(ngEventDirectives);
	      $provide.provider({
	        $anchorScroll: $AnchorScrollProvider,
	        $animate: $AnimateProvider,
	        $animateCss: $CoreAnimateCssProvider,
	        $$animateJs: $$CoreAnimateJsProvider,
	        $$animateQueue: $$CoreAnimateQueueProvider,
	        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
	        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
	        $browser: $BrowserProvider,
	        $cacheFactory: $CacheFactoryProvider,
	        $controller: $ControllerProvider,
	        $document: $DocumentProvider,
	        $$isDocumentHidden: $$IsDocumentHiddenProvider,
	        $exceptionHandler: $ExceptionHandlerProvider,
	        $filter: $FilterProvider,
	        $$forceReflow: $$ForceReflowProvider,
	        $interpolate: $InterpolateProvider,
	        $interval: $IntervalProvider,
	        $http: $HttpProvider,
	        $httpParamSerializer: $HttpParamSerializerProvider,
	        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
	        $httpBackend: $HttpBackendProvider,
	        $xhrFactory: $xhrFactoryProvider,
	        $jsonpCallbacks: $jsonpCallbacksProvider,
	        $location: $LocationProvider,
	        $log: $LogProvider,
	        $parse: $ParseProvider,
	        $rootScope: $RootScopeProvider,
	        $q: $QProvider,
	        $$q: $$QProvider,
	        $sce: $SceProvider,
	        $sceDelegate: $SceDelegateProvider,
	        $sniffer: $SnifferProvider,
	        $templateCache: $TemplateCacheProvider,
	        $templateRequest: $TemplateRequestProvider,
	        $$testability: $$TestabilityProvider,
	        $timeout: $TimeoutProvider,
	        $window: $WindowProvider,
	        $$rAF: $$RAFProvider,
	        $$jqLite: $$jqLiteProvider,
	        $$Map: $$MapProvider,
	        $$cookieReader: $$CookieReaderProvider
	      });
	    }
	  ])
	  .info({ angularVersion: '1.6.4' });
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* global
	  JQLitePrototype: true,
	  BOOLEAN_ATTR: true,
	  ALIASED_ATTR: true
	*/
	
	//////////////////////////////////
	//JQLite
	//////////////////////////////////
	
	/**
	 * @ngdoc function
	 * @name angular.element
	 * @module ng
	 * @kind function
	 *
	 * @description
	 * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
	 *
	 * If jQuery is available, `angular.element` is an alias for the
	 * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
	 * delegates to Angular's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
	 *
	 * jqLite is a tiny, API-compatible subset of jQuery that allows
	 * Angular to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
	 * commonly needed functionality with the goal of having a very small footprint.
	 *
	 * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
	 * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
	 * specific version of jQuery if multiple versions exist on the page.
	 *
	 * <div class="alert alert-info">**Note:** All element references in Angular are always wrapped with jQuery or
	 * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
	 *
	 * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
	 * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
	 * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
	 *
	 * ## Angular's jqLite
	 * jqLite provides only the following jQuery methods:
	 *
	 * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
	 * - [`after()`](http://api.jquery.com/after/)
	 * - [`append()`](http://api.jquery.com/append/)
	 * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
	 * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
	 * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
	 * - [`clone()`](http://api.jquery.com/clone/)
	 * - [`contents()`](http://api.jquery.com/contents/)
	 * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
	 *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
	 * - [`data()`](http://api.jquery.com/data/)
	 * - [`detach()`](http://api.jquery.com/detach/)
	 * - [`empty()`](http://api.jquery.com/empty/)
	 * - [`eq()`](http://api.jquery.com/eq/)
	 * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
	 * - [`hasClass()`](http://api.jquery.com/hasClass/)
	 * - [`html()`](http://api.jquery.com/html/)
	 * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
	 * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
	 * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
	 * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
	 * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
	 * - [`prepend()`](http://api.jquery.com/prepend/)
	 * - [`prop()`](http://api.jquery.com/prop/)
	 * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
	 * - [`remove()`](http://api.jquery.com/remove/)
	 * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
	 * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
	 * - [`removeData()`](http://api.jquery.com/removeData/)
	 * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
	 * - [`text()`](http://api.jquery.com/text/)
	 * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
	 * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
	 * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
	 * - [`val()`](http://api.jquery.com/val/)
	 * - [`wrap()`](http://api.jquery.com/wrap/)
	 *
	 * ## jQuery/jqLite Extras
	 * Angular also provides the following additional methods and events to both jQuery and jqLite:
	 *
	 * ### Events
	 * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
	 *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
	 *    element before it is removed.
	 *
	 * ### Methods
	 * - `controller(name)` - retrieves the controller of the current element or its parent. By default
	 *   retrieves controller associated with the `ngController` directive. If `name` is provided as
	 *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
	 *   `'ngModel'`).
	 * - `injector()` - retrieves the injector of the current element or its parent.
	 * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
	 *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
	 *   be enabled.
	 * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
	 *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
	 *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
	 *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
	 * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
	 *   parent element is reached.
	 *
	 * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
	 * https://github.com/angular/angular.js/issues/14251 for more information.
	 *
	 * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
	 * @returns {Object} jQuery object.
	 */
	
	JQLite.expando = 'ng339';
	
	var jqCache = JQLite.cache = {},
	    jqId = 1;
	
	/*
	 * !!! This is an undocumented "private" function !!!
	 */
	JQLite._data = function(node) {
	  //jQuery always returns an object on cache miss
	  return this.cache[node[this.expando]] || {};
	};
	
	function jqNextId() { return ++jqId; }
	
	
	var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
	var MS_HACK_REGEXP = /^-ms-/;
	var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
	var jqLiteMinErr = minErr('jqLite');
	
	/**
	 * Converts kebab-case to camelCase.
	 * There is also a special case for the ms prefix starting with a lowercase letter.
	 * @param name Name to normalize
	 */
	function cssKebabToCamel(name) {
	    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
	}
	
	function fnCamelCaseReplace(all, letter) {
	  return letter.toUpperCase();
	}
	
	/**
	 * Converts kebab-case to camelCase.
	 * @param name Name to normalize
	 */
	function kebabToCamel(name) {
	  return name
	    .replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
	var HTML_REGEXP = /<|&#?\w+;/;
	var TAG_NAME_REGEXP = /<([\w:-]+)/;
	var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;
	
	var wrapMap = {
	  'option': [1, '<select multiple="multiple">', '</select>'],
	
	  'thead': [1, '<table>', '</table>'],
	  'col': [2, '<table><colgroup>', '</colgroup></table>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	  'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
	  '_default': [0, '', '']
	};
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function jqLiteIsTextNode(html) {
	  return !HTML_REGEXP.test(html);
	}
	
	function jqLiteAcceptsData(node) {
	  // The window object can accept data but has no nodeType
	  // Otherwise we are only interested in elements (1) and documents (9)
	  var nodeType = node.nodeType;
	  return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
	}
	
	function jqLiteHasData(node) {
	  for (var key in jqCache[node.ng339]) {
	    return true;
	  }
	  return false;
	}
	
	function jqLiteBuildFragment(html, context) {
	  var tmp, tag, wrap,
	      fragment = context.createDocumentFragment(),
	      nodes = [], i;
	
	  if (jqLiteIsTextNode(html)) {
	    // Convert non-html into a text node
	    nodes.push(context.createTextNode(html));
	  } else {
	    // Convert html into DOM nodes
	    tmp = fragment.appendChild(context.createElement('div'));
	    tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
	    wrap = wrapMap[tag] || wrapMap._default;
	    tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];
	
	    // Descend through wrappers to the right content
	    i = wrap[0];
	    while (i--) {
	      tmp = tmp.lastChild;
	    }
	
	    nodes = concat(nodes, tmp.childNodes);
	
	    tmp = fragment.firstChild;
	    tmp.textContent = '';
	  }
	
	  // Remove wrapper from fragment
	  fragment.textContent = '';
	  fragment.innerHTML = ''; // Clear inner HTML
	  forEach(nodes, function(node) {
	    fragment.appendChild(node);
	  });
	
	  return fragment;
	}
	
	function jqLiteParseHTML(html, context) {
	  context = context || window.document;
	  var parsed;
	
	  if ((parsed = SINGLE_TAG_REGEXP.exec(html))) {
	    return [context.createElement(parsed[1])];
	  }
	
	  if ((parsed = jqLiteBuildFragment(html, context))) {
	    return parsed.childNodes;
	  }
	
	  return [];
	}
	
	function jqLiteWrapNode(node, wrapper) {
	  var parent = node.parentNode;
	
	  if (parent) {
	    parent.replaceChild(wrapper, node);
	  }
	
	  wrapper.appendChild(node);
	}
	
	
	// IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
	var jqLiteContains = window.Node.prototype.contains || /** @this */ function(arg) {
	  // eslint-disable-next-line no-bitwise
	  return !!(this.compareDocumentPosition(arg) & 16);
	};
	
	/////////////////////////////////////////////
	function JQLite(element) {
	  if (element instanceof JQLite) {
	    return element;
	  }
	
	  var argIsString;
	
	  if (isString(element)) {
	    element = trim(element);
	    argIsString = true;
	  }
	  if (!(this instanceof JQLite)) {
	    if (argIsString && element.charAt(0) !== '<') {
	      throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
	    }
	    return new JQLite(element);
	  }
	
	  if (argIsString) {
	    jqLiteAddNodes(this, jqLiteParseHTML(element));
	  } else if (isFunction(element)) {
	    jqLiteReady(element);
	  } else {
	    jqLiteAddNodes(this, element);
	  }
	}
	
	function jqLiteClone(element) {
	  return element.cloneNode(true);
	}
	
	function jqLiteDealoc(element, onlyDescendants) {
	  if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
	
	  if (element.querySelectorAll) {
	    jqLite.cleanData(element.querySelectorAll('*'));
	  }
	}
	
	function jqLiteOff(element, type, fn, unsupported) {
	  if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
	
	  var expandoStore = jqLiteExpandoStore(element);
	  var events = expandoStore && expandoStore.events;
	  var handle = expandoStore && expandoStore.handle;
	
	  if (!handle) return; //no listeners registered
	
	  if (!type) {
	    for (type in events) {
	      if (type !== '$destroy') {
	        element.removeEventListener(type, handle);
	      }
	      delete events[type];
	    }
	  } else {
	
	    var removeHandler = function(type) {
	      var listenerFns = events[type];
	      if (isDefined(fn)) {
	        arrayRemove(listenerFns || [], fn);
	      }
	      if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
	        element.removeEventListener(type, handle);
	        delete events[type];
	      }
	    };
	
	    forEach(type.split(' '), function(type) {
	      removeHandler(type);
	      if (MOUSE_EVENT_MAP[type]) {
	        removeHandler(MOUSE_EVENT_MAP[type]);
	      }
	    });
	  }
	}
	
	function jqLiteRemoveData(element, name) {
	  var expandoId = element.ng339;
	  var expandoStore = expandoId && jqCache[expandoId];
	
	  if (expandoStore) {
	    if (name) {
	      delete expandoStore.data[name];
	      return;
	    }
	
	    if (expandoStore.handle) {
	      if (expandoStore.events.$destroy) {
	        expandoStore.handle({}, '$destroy');
	      }
	      jqLiteOff(element);
	    }
	    delete jqCache[expandoId];
	    element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
	  }
	}
	
	
	function jqLiteExpandoStore(element, createIfNecessary) {
	  var expandoId = element.ng339,
	      expandoStore = expandoId && jqCache[expandoId];
	
	  if (createIfNecessary && !expandoStore) {
	    element.ng339 = expandoId = jqNextId();
	    expandoStore = jqCache[expandoId] = {events: {}, data: {}, handle: undefined};
	  }
	
	  return expandoStore;
	}
	
	
	function jqLiteData(element, key, value) {
	  if (jqLiteAcceptsData(element)) {
	    var prop;
	
	    var isSimpleSetter = isDefined(value);
	    var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
	    var massGetter = !key;
	    var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
	    var data = expandoStore && expandoStore.data;
	
	    if (isSimpleSetter) { // data('key', value)
	      data[kebabToCamel(key)] = value;
	    } else {
	      if (massGetter) {  // data()
	        return data;
	      } else {
	        if (isSimpleGetter) { // data('key')
	          // don't force creation of expandoStore if it doesn't exist yet
	          return data && data[kebabToCamel(key)];
	        } else { // mass-setter: data({key1: val1, key2: val2})
	          for (prop in key) {
	            data[kebabToCamel(prop)] = key[prop];
	          }
	        }
	      }
	    }
	  }
	}
	
	function jqLiteHasClass(element, selector) {
	  if (!element.getAttribute) return false;
	  return ((' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').
	      indexOf(' ' + selector + ' ') > -1);
	}
	
	function jqLiteRemoveClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    forEach(cssClasses.split(' '), function(cssClass) {
	      element.setAttribute('class', trim(
	          (' ' + (element.getAttribute('class') || '') + ' ')
	          .replace(/[\n\t]/g, ' ')
	          .replace(' ' + trim(cssClass) + ' ', ' '))
	      );
	    });
	  }
	}
	
	function jqLiteAddClass(element, cssClasses) {
	  if (cssClasses && element.setAttribute) {
	    var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ')
	                            .replace(/[\n\t]/g, ' ');
	
	    forEach(cssClasses.split(' '), function(cssClass) {
	      cssClass = trim(cssClass);
	      if (existingClasses.indexOf(' ' + cssClass + ' ') === -1) {
	        existingClasses += cssClass + ' ';
	      }
	    });
	
	    element.setAttribute('class', trim(existingClasses));
	  }
	}
	
	
	function jqLiteAddNodes(root, elements) {
	  // THIS CODE IS VERY HOT. Don't make changes without benchmarking.
	
	  if (elements) {
	
	    // if a Node (the most common case)
	    if (elements.nodeType) {
	      root[root.length++] = elements;
	    } else {
	      var length = elements.length;
	
	      // if an Array or NodeList and not a Window
	      if (typeof length === 'number' && elements.window !== elements) {
	        if (length) {
	          for (var i = 0; i < length; i++) {
	            root[root.length++] = elements[i];
	          }
	        }
	      } else {
	        root[root.length++] = elements;
	      }
	    }
	  }
	}
	
	
	function jqLiteController(element, name) {
	  return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
	}
	
	function jqLiteInheritedData(element, name, value) {
	  // if element is the document object work with the html element instead
	  // this makes $(document).scope() possible
	  if (element.nodeType === NODE_TYPE_DOCUMENT) {
	    element = element.documentElement;
	  }
	  var names = isArray(name) ? name : [name];
	
	  while (element) {
	    for (var i = 0, ii = names.length; i < ii; i++) {
	      if (isDefined(value = jqLite.data(element, names[i]))) return value;
	    }
	
	    // If dealing with a document fragment node with a host element, and no parent, use the host
	    // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
	    // to lookup parent controllers.
	    element = element.parentNode || (element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host);
	  }
	}
	
	function jqLiteEmpty(element) {
	  jqLiteDealoc(element, true);
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }
	}
	
	function jqLiteRemove(element, keepData) {
	  if (!keepData) jqLiteDealoc(element);
	  var parent = element.parentNode;
	  if (parent) parent.removeChild(element);
	}
	
	
	function jqLiteDocumentLoaded(action, win) {
	  win = win || window;
	  if (win.document.readyState === 'complete') {
	    // Force the action to be run async for consistent behavior
	    // from the action's point of view
	    // i.e. it will definitely not be in a $apply
	    win.setTimeout(action);
	  } else {
	    // No need to unbind this handler as load is only ever called once
	    jqLite(win).on('load', action);
	  }
	}
	
	function jqLiteReady(fn) {
	  function trigger() {
	    window.document.removeEventListener('DOMContentLoaded', trigger);
	    window.removeEventListener('load', trigger);
	    fn();
	  }
	
	  // check if document is already loaded
	  if (window.document.readyState === 'complete') {
	    window.setTimeout(fn);
	  } else {
	    // We can not use jqLite since we are not done loading and jQuery could be loaded later.
	
	    // Works for modern browsers and IE9
	    window.document.addEventListener('DOMContentLoaded', trigger);
	
	    // Fallback to window.onload for others
	    window.addEventListener('load', trigger);
	  }
	}
	
	//////////////////////////////////////////
	// Functions which are declared directly.
	//////////////////////////////////////////
	var JQLitePrototype = JQLite.prototype = {
	  ready: jqLiteReady,
	  toString: function() {
	    var value = [];
	    forEach(this, function(e) { value.push('' + e);});
	    return '[' + value.join(', ') + ']';
	  },
	
	  eq: function(index) {
	      return (index >= 0) ? jqLite(this[index]) : jqLite(this[this.length + index]);
	  },
	
	  length: 0,
	  push: push,
	  sort: [].sort,
	  splice: [].splice
	};
	
	//////////////////////////////////////////
	// Functions iterating getter/setters.
	// these functions return self on setter and
	// value on get.
	//////////////////////////////////////////
	var BOOLEAN_ATTR = {};
	forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function(value) {
	  BOOLEAN_ATTR[lowercase(value)] = value;
	});
	var BOOLEAN_ELEMENTS = {};
	forEach('input,select,option,textarea,button,form,details'.split(','), function(value) {
	  BOOLEAN_ELEMENTS[value] = true;
	});
	var ALIASED_ATTR = {
	  'ngMinlength': 'minlength',
	  'ngMaxlength': 'maxlength',
	  'ngMin': 'min',
	  'ngMax': 'max',
	  'ngPattern': 'pattern',
	  'ngStep': 'step'
	};
	
	function getBooleanAttrName(element, name) {
	  // check dom last since we will most likely fail on name
	  var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];
	
	  // booleanAttr is here twice to minimize DOM access
	  return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
	}
	
	function getAliasedAttrName(name) {
	  return ALIASED_ATTR[name];
	}
	
	forEach({
	  data: jqLiteData,
	  removeData: jqLiteRemoveData,
	  hasData: jqLiteHasData,
	  cleanData: function jqLiteCleanData(nodes) {
	    for (var i = 0, ii = nodes.length; i < ii; i++) {
	      jqLiteRemoveData(nodes[i]);
	    }
	  }
	}, function(fn, name) {
	  JQLite[name] = fn;
	});
	
	forEach({
	  data: jqLiteData,
	  inheritedData: jqLiteInheritedData,
	
	  scope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
	  },
	
	  isolateScope: function(element) {
	    // Can't use jqLiteData here directly so we stay compatible with jQuery!
	    return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
	  },
	
	  controller: jqLiteController,
	
	  injector: function(element) {
	    return jqLiteInheritedData(element, '$injector');
	  },
	
	  removeAttr: function(element, name) {
	    element.removeAttribute(name);
	  },
	
	  hasClass: jqLiteHasClass,
	
	  css: function(element, name, value) {
	    name = cssKebabToCamel(name);
	
	    if (isDefined(value)) {
	      element.style[name] = value;
	    } else {
	      return element.style[name];
	    }
	  },
	
	  attr: function(element, name, value) {
	    var ret;
	    var nodeType = element.nodeType;
	    if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT ||
	      !element.getAttribute) {
	      return;
	    }
	
	    var lowercasedName = lowercase(name);
	    var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
	
	    if (isDefined(value)) {
	      // setter
	
	      if (value === null || (value === false && isBooleanAttr)) {
	        element.removeAttribute(name);
	      } else {
	        element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
	      }
	    } else {
	      // getter
	
	      ret = element.getAttribute(name);
	
	      if (isBooleanAttr && ret !== null) {
	        ret = lowercasedName;
	      }
	      // Normalize non-existing attributes to undefined (as jQuery).
	      return ret === null ? undefined : ret;
	    }
	  },
	
	  prop: function(element, name, value) {
	    if (isDefined(value)) {
	      element[name] = value;
	    } else {
	      return element[name];
	    }
	  },
	
	  text: (function() {
	    getText.$dv = '';
	    return getText;
	
	    function getText(element, value) {
	      if (isUndefined(value)) {
	        var nodeType = element.nodeType;
	        return (nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT) ? element.textContent : '';
	      }
	      element.textContent = value;
	    }
	  })(),
	
	  val: function(element, value) {
	    if (isUndefined(value)) {
	      if (element.multiple && nodeName_(element) === 'select') {
	        var result = [];
	        forEach(element.options, function(option) {
	          if (option.selected) {
	            result.push(option.value || option.text);
	          }
	        });
	        return result;
	      }
	      return element.value;
	    }
	    element.value = value;
	  },
	
	  html: function(element, value) {
	    if (isUndefined(value)) {
	      return element.innerHTML;
	    }
	    jqLiteDealoc(element, true);
	    element.innerHTML = value;
	  },
	
	  empty: jqLiteEmpty
	}, function(fn, name) {
	  /**
	   * Properties: writes return selection, reads return first value
	   */
	  JQLite.prototype[name] = function(arg1, arg2) {
	    var i, key;
	    var nodeCount = this.length;
	
	    // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
	    // in a way that survives minification.
	    // jqLiteEmpty takes no arguments but is a setter.
	    if (fn !== jqLiteEmpty &&
	        (isUndefined((fn.length === 2 && (fn !== jqLiteHasClass && fn !== jqLiteController)) ? arg1 : arg2))) {
	      if (isObject(arg1)) {
	
	        // we are a write, but the object properties are the key/values
	        for (i = 0; i < nodeCount; i++) {
	          if (fn === jqLiteData) {
	            // data() takes the whole object in jQuery
	            fn(this[i], arg1);
	          } else {
	            for (key in arg1) {
	              fn(this[i], key, arg1[key]);
	            }
	          }
	        }
	        // return self for chaining
	        return this;
	      } else {
	        // we are a read, so read the first child.
	        // TODO: do we still need this?
	        var value = fn.$dv;
	        // Only if we have $dv do we iterate over all, otherwise it is just the first element.
	        var jj = (isUndefined(value)) ? Math.min(nodeCount, 1) : nodeCount;
	        for (var j = 0; j < jj; j++) {
	          var nodeValue = fn(this[j], arg1, arg2);
	          value = value ? value + nodeValue : nodeValue;
	        }
	        return value;
	      }
	    } else {
	      // we are a write, so apply to all children
	      for (i = 0; i < nodeCount; i++) {
	        fn(this[i], arg1, arg2);
	      }
	      // return self for chaining
	      return this;
	    }
	  };
	});
	
	function createEventHandler(element, events) {
	  var eventHandler = function(event, type) {
	    // jQuery specific api
	    event.isDefaultPrevented = function() {
	      return event.defaultPrevented;
	    };
	
	    var eventFns = events[type || event.type];
	    var eventFnsLength = eventFns ? eventFns.length : 0;
	
	    if (!eventFnsLength) return;
	
	    if (isUndefined(event.immediatePropagationStopped)) {
	      var originalStopImmediatePropagation = event.stopImmediatePropagation;
	      event.stopImmediatePropagation = function() {
	        event.immediatePropagationStopped = true;
	
	        if (event.stopPropagation) {
	          event.stopPropagation();
	        }
	
	        if (originalStopImmediatePropagation) {
	          originalStopImmediatePropagation.call(event);
	        }
	      };
	    }
	
	    event.isImmediatePropagationStopped = function() {
	      return event.immediatePropagationStopped === true;
	    };
	
	    // Some events have special handlers that wrap the real handler
	    var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;
	
	    // Copy event handlers in case event handlers array is modified during execution.
	    if ((eventFnsLength > 1)) {
	      eventFns = shallowCopy(eventFns);
	    }
	
	    for (var i = 0; i < eventFnsLength; i++) {
	      if (!event.isImmediatePropagationStopped()) {
	        handlerWrapper(element, event, eventFns[i]);
	      }
	    }
	  };
	
	  // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
	  //       events on `element`
	  eventHandler.elem = element;
	  return eventHandler;
	}
	
	function defaultHandlerWrapper(element, event, handler) {
	  handler.call(element, event);
	}
	
	function specialMouseHandlerWrapper(target, event, handler) {
	  // Refer to jQuery's implementation of mouseenter & mouseleave
	  // Read about mouseenter and mouseleave:
	  // http://www.quirksmode.org/js/events_mouse.html#link8
	  var related = event.relatedTarget;
	  // For mousenter/leave call the handler if related is outside the target.
	  // NB: No relatedTarget if the mouse left/entered the browser window
	  if (!related || (related !== target && !jqLiteContains.call(target, related))) {
	    handler.call(target, event);
	  }
	}
	
	//////////////////////////////////////////
	// Functions iterating traversal.
	// These functions chain results into a single
	// selector.
	//////////////////////////////////////////
	forEach({
	  removeData: jqLiteRemoveData,
	
	  on: function jqLiteOn(element, type, fn, unsupported) {
	    if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');
	
	    // Do not add event handlers to non-elements because they will not be cleaned up.
	    if (!jqLiteAcceptsData(element)) {
	      return;
	    }
	
	    var expandoStore = jqLiteExpandoStore(element, true);
	    var events = expandoStore.events;
	    var handle = expandoStore.handle;
	
	    if (!handle) {
	      handle = expandoStore.handle = createEventHandler(element, events);
	    }
	
	    // http://jsperf.com/string-indexof-vs-split
	    var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
	    var i = types.length;
	
	    var addHandler = function(type, specialHandlerWrapper, noEventListener) {
	      var eventFns = events[type];
	
	      if (!eventFns) {
	        eventFns = events[type] = [];
	        eventFns.specialHandlerWrapper = specialHandlerWrapper;
	        if (type !== '$destroy' && !noEventListener) {
	          element.addEventListener(type, handle);
	        }
	      }
	
	      eventFns.push(fn);
	    };
	
	    while (i--) {
	      type = types[i];
	      if (MOUSE_EVENT_MAP[type]) {
	        addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
	        addHandler(type, undefined, true);
	      } else {
	        addHandler(type);
	      }
	    }
	  },
	
	  off: jqLiteOff,
	
	  one: function(element, type, fn) {
	    element = jqLite(element);
	
	    //add the listener twice so that when it is called
	    //you can remove the original function and still be
	    //able to call element.off(ev, fn) normally
	    element.on(type, function onFn() {
	      element.off(type, fn);
	      element.off(type, onFn);
	    });
	    element.on(type, fn);
	  },
	
	  replaceWith: function(element, replaceNode) {
	    var index, parent = element.parentNode;
	    jqLiteDealoc(element);
	    forEach(new JQLite(replaceNode), function(node) {
	      if (index) {
	        parent.insertBefore(node, index.nextSibling);
	      } else {
	        parent.replaceChild(node, element);
	      }
	      index = node;
	    });
	  },
	
	  children: function(element) {
	    var children = [];
	    forEach(element.childNodes, function(element) {
	      if (element.nodeType === NODE_TYPE_ELEMENT) {
	        children.push(element);
	      }
	    });
	    return children;
	  },
	
	  contents: function(element) {
	    return element.contentDocument || element.childNodes || [];
	  },
	
	  append: function(element, node) {
	    var nodeType = element.nodeType;
	    if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
	
	    node = new JQLite(node);
	
	    for (var i = 0, ii = node.length; i < ii; i++) {
	      var child = node[i];
	      element.appendChild(child);
	    }
	  },
	
	  prepend: function(element, node) {
	    if (element.nodeType === NODE_TYPE_ELEMENT) {
	      var index = element.firstChild;
	      forEach(new JQLite(node), function(child) {
	        element.insertBefore(child, index);
	      });
	    }
	  },
	
	  wrap: function(element, wrapNode) {
	    jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
	  },
	
	  remove: jqLiteRemove,
	
	  detach: function(element) {
	    jqLiteRemove(element, true);
	  },
	
	  after: function(element, newElement) {
	    var index = element, parent = element.parentNode;
	
	    if (parent) {
	      newElement = new JQLite(newElement);
	
	      for (var i = 0, ii = newElement.length; i < ii; i++) {
	        var node = newElement[i];
	        parent.insertBefore(node, index.nextSibling);
	        index = node;
	      }
	    }
	  },
	
	  addClass: jqLiteAddClass,
	  removeClass: jqLiteRemoveClass,
	
	  toggleClass: function(element, selector, condition) {
	    if (selector) {
	      forEach(selector.split(' '), function(className) {
	        var classCondition = condition;
	        if (isUndefined(classCondition)) {
	          classCondition = !jqLiteHasClass(element, className);
	        }
	        (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
	      });
	    }
	  },
	
	  parent: function(element) {
	    var parent = element.parentNode;
	    return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
	  },
	
	  next: function(element) {
	    return element.nextElementSibling;
	  },
	
	  find: function(element, selector) {
	    if (element.getElementsByTagName) {
	      return element.getElementsByTagName(selector);
	    } else {
	      return [];
	    }
	  },
	
	  clone: jqLiteClone,
	
	  triggerHandler: function(element, event, extraParameters) {
	
	    var dummyEvent, eventFnsCopy, handlerArgs;
	    var eventName = event.type || event;
	    var expandoStore = jqLiteExpandoStore(element);
	    var events = expandoStore && expandoStore.events;
	    var eventFns = events && events[eventName];
	
	    if (eventFns) {
	      // Create a dummy event to pass to the handlers
	      dummyEvent = {
	        preventDefault: function() { this.defaultPrevented = true; },
	        isDefaultPrevented: function() { return this.defaultPrevented === true; },
	        stopImmediatePropagation: function() { this.immediatePropagationStopped = true; },
	        isImmediatePropagationStopped: function() { return this.immediatePropagationStopped === true; },
	        stopPropagation: noop,
	        type: eventName,
	        target: element
	      };
	
	      // If a custom event was provided then extend our dummy event with it
	      if (event.type) {
	        dummyEvent = extend(dummyEvent, event);
	      }
	
	      // Copy event handlers in case event handlers array is modified during execution.
	      eventFnsCopy = shallowCopy(eventFns);
	      handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
	
	      forEach(eventFnsCopy, function(fn) {
	        if (!dummyEvent.isImmediatePropagationStopped()) {
	          fn.apply(element, handlerArgs);
	        }
	      });
	    }
	  }
	}, function(fn, name) {
	  /**
	   * chaining functions
	   */
	  JQLite.prototype[name] = function(arg1, arg2, arg3) {
	    var value;
	
	    for (var i = 0, ii = this.length; i < ii; i++) {
	      if (isUndefined(value)) {
	        value = fn(this[i], arg1, arg2, arg3);
	        if (isDefined(value)) {
	          // any function which returns a value needs to be wrapped
	          value = jqLite(value);
	        }
	      } else {
	        jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
	      }
	    }
	    return isDefined(value) ? value : this;
	  };
	});
	
	// bind legacy bind/unbind to on/off
	JQLite.prototype.bind = JQLite.prototype.on;
	JQLite.prototype.unbind = JQLite.prototype.off;
	
	
	// Provider for private $$jqLite service
	/** @this */
	function $$jqLiteProvider() {
	  this.$get = function $$jqLite() {
	    return extend(JQLite, {
	      hasClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteHasClass(node, classes);
	      },
	      addClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteAddClass(node, classes);
	      },
	      removeClass: function(node, classes) {
	        if (node.attr) node = node[0];
	        return jqLiteRemoveClass(node, classes);
	      }
	    });
	  };
	}
	
	/**
	 * Computes a hash of an 'obj'.
	 * Hash of a:
	 *  string is string
	 *  number is number as string
	 *  object is either result of calling $$hashKey function on the object or uniquely generated id,
	 *         that is also assigned to the $$hashKey property of the object.
	 *
	 * @param obj
	 * @returns {string} hash string such that the same input will have the same hash string.
	 *         The resulting string key is in 'type:hashKey' format.
	 */
	function hashKey(obj, nextUidFn) {
	  var key = obj && obj.$$hashKey;
	
	  if (key) {
	    if (typeof key === 'function') {
	      key = obj.$$hashKey();
	    }
	    return key;
	  }
	
	  var objType = typeof obj;
	  if (objType === 'function' || (objType === 'object' && obj !== null)) {
	    key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
	  } else {
	    key = objType + ':' + obj;
	  }
	
	  return key;
	}
	
	// A minimal ES2015 Map implementation.
	// Should be bug/feature equivalent to the native implementations of supported browsers
	// (for the features required in Angular).
	// See https://kangax.github.io/compat-table/es6/#test-Map
	var nanKey = Object.create(null);
	function NgMapShim() {
	  this._keys = [];
	  this._values = [];
	  this._lastKey = NaN;
	  this._lastIndex = -1;
	}
	NgMapShim.prototype = {
	  _idx: function(key) {
	    if (key === this._lastKey) {
	      return this._lastIndex;
	    }
	    this._lastKey = key;
	    this._lastIndex = this._keys.indexOf(key);
	    return this._lastIndex;
	  },
	  _transformKey: function(key) {
	    return isNumberNaN(key) ? nanKey : key;
	  },
	  get: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx !== -1) {
	      return this._values[idx];
	    }
	  },
	  set: function(key, value) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      idx = this._lastIndex = this._keys.length;
	    }
	    this._keys[idx] = key;
	    this._values[idx] = value;
	
	    // Support: IE11
	    // Do not `return this` to simulate the partial IE11 implementation
	  },
	  delete: function(key) {
	    key = this._transformKey(key);
	    var idx = this._idx(key);
	    if (idx === -1) {
	      return false;
	    }
	    this._keys.splice(idx, 1);
	    this._values.splice(idx, 1);
	    this._lastKey = NaN;
	    this._lastIndex = -1;
	    return true;
	  }
	};
	
	// For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
	// are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
	// implementations get more stable, we can reconsider switching to `window.Map` (when available).
	var NgMap = NgMapShim;
	
	var $$MapProvider = [/** @this */function() {
	  this.$get = [function() {
	    return NgMap;
	  }];
	}];
	
	/**
	 * @ngdoc function
	 * @module ng
	 * @name angular.injector
	 * @kind function
	 *
	 * @description
	 * Creates an injector object that can be used for retrieving services as well as for
	 * dependency injection (see {@link guide/di dependency injection}).
	 *
	 * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
	 *     {@link angular.module}. The `ng` module must be explicitly added.
	 * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
	 *     disallows argument name annotation inference.
	 * @returns {injector} Injector object. See {@link auto.$injector $injector}.
	 *
	 * @example
	 * Typical usage
	 * ```js
	 *   // create an injector
	 *   var $injector = angular.injector(['ng']);
	 *
	 *   // use the injector to kick off your application
	 *   // use the type inference to auto inject arguments, or use implicit injection
	 *   $injector.invoke(function($rootScope, $compile, $document) {
	 *     $compile($document)($rootScope);
	 *     $rootScope.$digest();
	 *   });
	 * ```
	 *
	 * Sometimes you want to get access to the injector of a currently running Angular app
	 * from outside Angular. Perhaps, you want to inject and compile some markup after the
	 * application has been bootstrapped. You can do this using the extra `injector()` added
	 * to JQuery/jqLite elements. See {@link angular.element}.
	 *
	 * *This is fairly rare but could be the case if a third party library is injecting the
	 * markup.*
	 *
	 * In the following example a new block of HTML containing a `ng-controller`
	 * directive is added to the end of the document body by JQuery. We then compile and link
	 * it into the current AngularJS scope.
	 *
	 * ```js
	 * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
	 * $(document.body).append($div);
	 *
	 * angular.element(document).injector().invoke(function($compile) {
	 *   var scope = angular.element($div).scope();
	 *   $compile($div)(scope);
	 * });
	 * ```
	 */
	
	
	/**
	 * @ngdoc module
	 * @name auto
	 * @installation
	 * @description
	 *
	 * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
	 */
	
	var ARROW_ARG = /^([^(]+?)=>/;
	var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
	var FN_ARG_SPLIT = /,/;
	var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
	var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
	var $injectorMinErr = minErr('$injector');
	
	function stringifyFn(fn) {
	  return Function.prototype.toString.call(fn);
	}
	
	function extractArgs(fn) {
	  var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
	      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
	  return args;
	}
	
	function anonFn(fn) {
	  // For anonymous functions, showing at the very least the function signature can help in
	  // debugging.
	  var args = extractArgs(fn);
	  if (args) {
	    return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
	  }
	  return 'fn';
	}
	
	function annotate(fn, strictDi, name) {
	  var $inject,
	      argDecl,
	      last;
	
	  if (typeof fn === 'function') {
	    if (!($inject = fn.$inject)) {
	      $inject = [];
	      if (fn.length) {
	        if (strictDi) {
	          if (!isString(name) || !name) {
	            name = fn.name || anonFn(fn);
	          }
	          throw $injectorMinErr('strictdi',
	            '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
	        }
	        argDecl = extractArgs(fn);
	        forEach(argDecl[1].split(FN_ARG_SPLIT), function(arg) {
	          arg.replace(FN_ARG, function(all, underscore, name) {
	            $inject.push(name);
	          });
	        });
	      }
	      fn.$inject = $inject;
	    }
	  } else if (isArray(fn)) {
	    last = fn.length - 1;
	    assertArgFn(fn[last], 'fn');
	    $inject = fn.slice(0, last);
	  } else {
	    assertArgFn(fn, 'fn', true);
	  }
	  return $inject;
	}
	
	///////////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $injector
	 *
	 * @description
	 *
	 * `$injector` is used to retrieve object instances as defined by
	 * {@link auto.$provide provider}, instantiate types, invoke methods,
	 * and load modules.
	 *
	 * The following always holds true:
	 *
	 * ```js
	 *   var $injector = angular.injector();
	 *   expect($injector.get('$injector')).toBe($injector);
	 *   expect($injector.invoke(function($injector) {
	 *     return $injector;
	 *   })).toBe($injector);
	 * ```
	 *
	 * # Injection Function Annotation
	 *
	 * JavaScript does not have annotations, and annotations are needed for dependency injection. The
	 * following are all valid ways of annotating function with injection arguments and are equivalent.
	 *
	 * ```js
	 *   // inferred (only works if code not minified/obfuscated)
	 *   $injector.invoke(function(serviceA){});
	 *
	 *   // annotated
	 *   function explicit(serviceA) {};
	 *   explicit.$inject = ['serviceA'];
	 *   $injector.invoke(explicit);
	 *
	 *   // inline
	 *   $injector.invoke(['serviceA', function(serviceA){}]);
	 * ```
	 *
	 * ## Inference
	 *
	 * In JavaScript calling `toString()` on a function returns the function definition. The definition
	 * can then be parsed and the function arguments can be extracted. This method of discovering
	 * annotations is disallowed when the injector is in strict mode.
	 * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
	 * argument names.
	 *
	 * ## `$inject` Annotation
	 * By adding an `$inject` property onto a function the injection parameters can be specified.
	 *
	 * ## Inline
	 * As an array of injection names, where the last item in the array is the function to call.
	 */
	
	/**
	 * @ngdoc property
	 * @name $injector#modules
	 * @type {Object}
	 * @description
	 * A hash containing all the modules that have been loaded into the
	 * $injector.
	 *
	 * You can use this property to find out information about a module via the
	 * {@link angular.Module#info `myModule.info(...)`} method.
	 *
	 * For example:
	 *
	 * ```
	 * var info = $injector.modules['ngAnimate'].info();
	 * ```
	 *
	 * **Do not use this property to attempt to modify the modules after the application
	 * has been bootstrapped.**
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $injector#get
	 *
	 * @description
	 * Return an instance of the service.
	 *
	 * @param {string} name The name of the instance to retrieve.
	 * @param {string=} caller An optional string to provide the origin of the function call for error messages.
	 * @return {*} The instance.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#invoke
	 *
	 * @description
	 * Invoke the method and supply the method arguments from the `$injector`.
	 *
	 * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
	 *   injected according to the {@link guide/di $inject Annotation} rules.
	 * @param {Object=} self The `this` for the invoked method.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 *                         object first, before the `$injector` is consulted.
	 * @returns {*} the value returned by the invoked `fn` function.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#has
	 *
	 * @description
	 * Allows the user to query if the particular service exists.
	 *
	 * @param {string} name Name of the service to query.
	 * @returns {boolean} `true` if injector has given service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#instantiate
	 * @description
	 * Create a new instance of JS type. The method takes a constructor function, invokes the new
	 * operator, and supplies all of the arguments to the constructor function as specified by the
	 * constructor annotation.
	 *
	 * @param {Function} Type Annotated constructor function.
	 * @param {Object=} locals Optional object. If preset then any argument names are read from this
	 * object first, before the `$injector` is consulted.
	 * @returns {Object} new instance of `Type`.
	 */
	
	/**
	 * @ngdoc method
	 * @name $injector#annotate
	 *
	 * @description
	 * Returns an array of service names which the function is requesting for injection. This API is
	 * used by the injector to determine which services need to be injected into the function when the
	 * function is invoked. There are three ways in which the function can be annotated with the needed
	 * dependencies.
	 *
	 * # Argument names
	 *
	 * The simplest form is to extract the dependencies from the arguments of the function. This is done
	 * by converting the function into a string using `toString()` method and extracting the argument
	 * names.
	 * ```js
	 *   // Given
	 *   function MyController($scope, $route) {
	 *     // ...
	 *   }
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * You can disallow this method by using strict injection mode.
	 *
	 * This method does not work with code minification / obfuscation. For this reason the following
	 * annotation strategies are supported.
	 *
	 * # The `$inject` property
	 *
	 * If a function has an `$inject` property and its value is an array of strings, then the strings
	 * represent names of services to be injected into the function.
	 * ```js
	 *   // Given
	 *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
	 *     // ...
	 *   }
	 *   // Define function dependencies
	 *   MyController['$inject'] = ['$scope', '$route'];
	 *
	 *   // Then
	 *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
	 * ```
	 *
	 * # The array notation
	 *
	 * It is often desirable to inline Injected functions and that's when setting the `$inject` property
	 * is very inconvenient. In these situations using the array notation to specify the dependencies in
	 * a way that survives minification is a better choice:
	 *
	 * ```js
	 *   // We wish to write this (not minification / obfuscation safe)
	 *   injector.invoke(function($compile, $rootScope) {
	 *     // ...
	 *   });
	 *
	 *   // We are forced to write break inlining
	 *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
	 *     // ...
	 *   };
	 *   tmpFn.$inject = ['$compile', '$rootScope'];
	 *   injector.invoke(tmpFn);
	 *
	 *   // To better support inline function the inline annotation is supported
	 *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
	 *     // ...
	 *   }]);
	 *
	 *   // Therefore
	 *   expect(injector.annotate(
	 *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
	 *    ).toEqual(['$compile', '$rootScope']);
	 * ```
	 *
	 * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
	 * be retrieved as described above.
	 *
	 * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
	 *
	 * @returns {Array.<string>} The names of the services which the function requires.
	 */
	
	
	
	/**
	 * @ngdoc service
	 * @name $provide
	 *
	 * @description
	 *
	 * The {@link auto.$provide $provide} service has a number of methods for registering components
	 * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
	 * {@link angular.Module}.
	 *
	 * An Angular **service** is a singleton object created by a **service factory**.  These **service
	 * factories** are functions which, in turn, are created by a **service provider**.
	 * The **service providers** are constructor functions. When instantiated they must contain a
	 * property called `$get`, which holds the **service factory** function.
	 *
	 * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
	 * correct **service provider**, instantiating it and then calling its `$get` **service factory**
	 * function to get the instance of the **service**.
	 *
	 * Often services have no configuration options and there is no need to add methods to the service
	 * provider.  The provider will be no more than a constructor function with a `$get` property. For
	 * these cases the {@link auto.$provide $provide} service has additional helper methods to register
	 * services without specifying a provider.
	 *
	 * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
	 *     {@link auto.$injector $injector}
	 * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
	 *     providers and services.
	 * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
	 *     services, not providers.
	 * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
	 *     given factory function.
	 * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
	 *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
	 *      a new object using the given constructor function.
	 * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
	 *      will be able to modify or replace the implementation of another service.
	 *
	 * See the individual methods for more information and examples.
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#provider
	 * @description
	 *
	 * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
	 * are constructor functions, whose instances are responsible for "providing" a factory for a
	 * service.
	 *
	 * Service provider names start with the name of the service they provide followed by `Provider`.
	 * For example, the {@link ng.$log $log} service has a provider called
	 * {@link ng.$logProvider $logProvider}.
	 *
	 * Service provider objects can have additional methods which allow configuration of the provider
	 * and its service. Importantly, you can configure what kind of service is created by the `$get`
	 * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
	 * method {@link ng.$logProvider#debugEnabled debugEnabled}
	 * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
	 * console or not.
	 *
	 * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
	                        'Provider'` key.
	 * @param {(Object|function())} provider If the provider is:
	 *
	 *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
	 *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
	 *   - `Constructor`: a new instance of the provider will be created using
	 *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
	 *
	 * @returns {Object} registered provider instance
	
	 * @example
	 *
	 * The following example shows how to create a simple event tracking service and register it using
	 * {@link auto.$provide#provider $provide.provider()}.
	 *
	 * ```js
	 *  // Define the eventTracker provider
	 *  function EventTrackerProvider() {
	 *    var trackingUrl = '/track';
	 *
	 *    // A provider method for configuring where the tracked events should been saved
	 *    this.setTrackingUrl = function(url) {
	 *      trackingUrl = url;
	 *    };
	 *
	 *    // The service factory function
	 *    this.$get = ['$http', function($http) {
	 *      var trackedEvents = {};
	 *      return {
	 *        // Call this to track an event
	 *        event: function(event) {
	 *          var count = trackedEvents[event] || 0;
	 *          count += 1;
	 *          trackedEvents[event] = count;
	 *          return count;
	 *        },
	 *        // Call this to save the tracked events to the trackingUrl
	 *        save: function() {
	 *          $http.post(trackingUrl, trackedEvents);
	 *        }
	 *      };
	 *    }];
	 *  }
	 *
	 *  describe('eventTracker', function() {
	 *    var postSpy;
	 *
	 *    beforeEach(module(function($provide) {
	 *      // Register the eventTracker provider
	 *      $provide.provider('eventTracker', EventTrackerProvider);
	 *    }));
	 *
	 *    beforeEach(module(function(eventTrackerProvider) {
	 *      // Configure eventTracker provider
	 *      eventTrackerProvider.setTrackingUrl('/custom-track');
	 *    }));
	 *
	 *    it('tracks events', inject(function(eventTracker) {
	 *      expect(eventTracker.event('login')).toEqual(1);
	 *      expect(eventTracker.event('login')).toEqual(2);
	 *    }));
	 *
	 *    it('saves to the tracking url', inject(function(eventTracker, $http) {
	 *      postSpy = spyOn($http, 'post');
	 *      eventTracker.event('login');
	 *      eventTracker.save();
	 *      expect(postSpy).toHaveBeenCalled();
	 *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
	 *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
	 *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
	 *    }));
	 *  });
	 * ```
	 */
	
	/**
	 * @ngdoc method
	 * @name $provide#factory
	 * @description
	 *
	 * Register a **service factory**, which will be called to return the service instance.
	 * This is short for registering a service where its provider consists of only a `$get` property,
	 * which is the given service factory function.
	 * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
	 * configure your service in a provider.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
	 *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service
	 * ```js
	 *   $provide.factory('ping', ['$http', function($http) {
	 *     return function ping() {
	 *       return $http.send('/ping');
	 *     };
	 *   }]);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#service
	 * @description
	 *
	 * Register a **service constructor**, which will be invoked with `new` to create the service
	 * instance.
	 * This is short for registering a service where its provider's `$get` property is a factory
	 * function that returns an instance instantiated by the injector from the service constructor
	 * function.
	 *
	 * Internally it looks a bit like this:
	 *
	 * ```
	 * {
	 *   $get: function() {
	 *     return $injector.instantiate(constructor);
	 *   }
	 * }
	 * ```
	 *
	 *
	 * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
	 * as a type/class.
	 *
	 * @param {string} name The name of the instance.
	 * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
	 *     that will be instantiated.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here is an example of registering a service using
	 * {@link auto.$provide#service $provide.service(class)}.
	 * ```js
	 *   var Ping = function($http) {
	 *     this.$http = $http;
	 *   };
	 *
	 *   Ping.$inject = ['$http'];
	 *
	 *   Ping.prototype.send = function() {
	 *     return this.$http.get('/ping');
	 *   };
	 *   $provide.service('ping', Ping);
	 * ```
	 * You would then inject and use this service like this:
	 * ```js
	 *   someModule.controller('Ctrl', ['ping', function(ping) {
	 *     ping.send();
	 *   }]);
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#value
	 * @description
	 *
	 * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
	 * number, an array, an object or a function. This is short for registering a service where its
	 * provider's `$get` property is a factory function that takes no arguments and returns the **value
	 * service**. That also means it is not possible to inject other services into a value service.
	 *
	 * Value services are similar to constant services, except that they cannot be injected into a
	 * module configuration function (see {@link angular.Module#config}) but they can be overridden by
	 * an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the instance.
	 * @param {*} value The value.
	 * @returns {Object} registered provider instance
	 *
	 * @example
	 * Here are some examples of creating value services.
	 * ```js
	 *   $provide.value('ADMIN_USER', 'admin');
	 *
	 *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
	 *
	 *   $provide.value('halfOf', function(value) {
	 *     return value / 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#constant
	 * @description
	 *
	 * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
	 * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
	 * possible to inject other services into a constant.
	 *
	 * But unlike {@link auto.$provide#value value}, a constant can be
	 * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
	 * be overridden by an Angular {@link auto.$provide#decorator decorator}.
	 *
	 * @param {string} name The name of the constant.
	 * @param {*} value The constant value.
	 * @returns {Object} registered instance
	 *
	 * @example
	 * Here a some examples of creating constants:
	 * ```js
	 *   $provide.constant('SHARD_HEIGHT', 306);
	 *
	 *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
	 *
	 *   $provide.constant('double', function(value) {
	 *     return value * 2;
	 *   });
	 * ```
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $provide#decorator
	 * @description
	 *
	 * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
	 * intercepts the creation of a service, allowing it to override or modify the behavior of the
	 * service. The return value of the decorator function may be the original service, or a new service
	 * that replaces (or wraps and delegates to) the original service.
	 *
	 * You can find out more about using decorators in the {@link guide/decorators} guide.
	 *
	 * @param {string} name The name of the service to decorate.
	 * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
	 *    provided and should return the decorated service instance. The function is called using
	 *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
	 *    Local injection arguments:
	 *
	 *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
	 *      decorated or delegated to.
	 *
	 * @example
	 * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
	 * calls to {@link ng.$log#error $log.warn()}.
	 * ```js
	 *   $provide.decorator('$log', ['$delegate', function($delegate) {
	 *     $delegate.warn = $delegate.error;
	 *     return $delegate;
	 *   }]);
	 * ```
	 */
	
	
	function createInjector(modulesToLoad, strictDi) {
	  strictDi = (strictDi === true);
	  var INSTANTIATING = {},
	      providerSuffix = 'Provider',
	      path = [],
	      loadedModules = new NgMap(),
	      providerCache = {
	        $provide: {
	            provider: supportObject(provider),
	            factory: supportObject(factory),
	            service: supportObject(service),
	            value: supportObject(value),
	            constant: supportObject(constant),
	            decorator: decorator
	          }
	      },
	      providerInjector = (providerCache.$injector =
	          createInternalInjector(providerCache, function(serviceName, caller) {
	            if (angular.isString(caller)) {
	              path.push(caller);
	            }
	            throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
	          })),
	      instanceCache = {},
	      protoInstanceInjector =
	          createInternalInjector(instanceCache, function(serviceName, caller) {
	            var provider = providerInjector.get(serviceName + providerSuffix, caller);
	            return instanceInjector.invoke(
	                provider.$get, provider, undefined, serviceName);
	          }),
	      instanceInjector = protoInstanceInjector;
	
	  providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
	  instanceInjector.modules = providerInjector.modules = createMap();
	  var runBlocks = loadModules(modulesToLoad);
	  instanceInjector = protoInstanceInjector.get('$injector');
	  instanceInjector.strictDi = strictDi;
	  forEach(runBlocks, function(fn) { if (fn) instanceInjector.invoke(fn); });
	
	  return instanceInjector;
	
	  ////////////////////////////////////
	  // $provider
	  ////////////////////////////////////
	
	  function supportObject(delegate) {
	    return function(key, value) {
	      if (isObject(key)) {
	        forEach(key, reverseParams(delegate));
	      } else {
	        return delegate(key, value);
	      }
	    };
	  }
	
	  function provider(name, provider_) {
	    assertNotHasOwnProperty(name, 'service');
	    if (isFunction(provider_) || isArray(provider_)) {
	      provider_ = providerInjector.instantiate(provider_);
	    }
	    if (!provider_.$get) {
	      throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
	    }
	    return (providerCache[name + providerSuffix] = provider_);
	  }
	
	  function enforceReturnValue(name, factory) {
	    return /** @this */ function enforcedReturnValue() {
	      var result = instanceInjector.invoke(factory, this);
	      if (isUndefined(result)) {
	        throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
	      }
	      return result;
	    };
	  }
	
	  function factory(name, factoryFn, enforce) {
	    return provider(name, {
	      $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
	    });
	  }
	
	  function service(name, constructor) {
	    return factory(name, ['$injector', function($injector) {
	      return $injector.instantiate(constructor);
	    }]);
	  }
	
	  function value(name, val) { return factory(name, valueFn(val), false); }
	
	  function constant(name, value) {
	    assertNotHasOwnProperty(name, 'constant');
	    providerCache[name] = value;
	    instanceCache[name] = value;
	  }
	
	  function decorator(serviceName, decorFn) {
	    var origProvider = providerInjector.get(serviceName + providerSuffix),
	        orig$get = origProvider.$get;
	
	    origProvider.$get = function() {
	      var origInstance = instanceInjector.invoke(orig$get, origProvider);
	      return instanceInjector.invoke(decorFn, null, {$delegate: origInstance});
	    };
	  }
	
	  ////////////////////////////////////
	  // Module Loading
	  ////////////////////////////////////
	  function loadModules(modulesToLoad) {
	    assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
	    var runBlocks = [], moduleFn;
	    forEach(modulesToLoad, function(module) {
	      if (loadedModules.get(module)) return;
	      loadedModules.set(module, true);
	
	      function runInvokeQueue(queue) {
	        var i, ii;
	        for (i = 0, ii = queue.length; i < ii; i++) {
	          var invokeArgs = queue[i],
	              provider = providerInjector.get(invokeArgs[0]);
	
	          provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
	        }
	      }
	
	      try {
	        if (isString(module)) {
	          moduleFn = angularModule(module);
	          instanceInjector.modules[module] = moduleFn;
	          runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
	          runInvokeQueue(moduleFn._invokeQueue);
	          runInvokeQueue(moduleFn._configBlocks);
	        } else if (isFunction(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else if (isArray(module)) {
	            runBlocks.push(providerInjector.invoke(module));
	        } else {
	          assertArgFn(module, 'module');
	        }
	      } catch (e) {
	        if (isArray(module)) {
	          module = module[module.length - 1];
	        }
	        if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
	          // Safari & FF's stack traces don't contain error.message content
	          // unlike those of Chrome and IE
	          // So if stack doesn't contain message, we create a new string that contains both.
	          // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
	          // eslint-disable-next-line no-ex-assign
	          e = e.message + '\n' + e.stack;
	        }
	        throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}',
	                  module, e.stack || e.message || e);
	      }
	    });
	    return runBlocks;
	  }
	
	  ////////////////////////////////////
	  // internal Injector
	  ////////////////////////////////////
	
	  function createInternalInjector(cache, factory) {
	
	    function getService(serviceName, caller) {
	      if (cache.hasOwnProperty(serviceName)) {
	        if (cache[serviceName] === INSTANTIATING) {
	          throw $injectorMinErr('cdep', 'Circular dependency found: {0}',
	                    serviceName + ' <- ' + path.join(' <- '));
	        }
	        return cache[serviceName];
	      } else {
	        try {
	          path.unshift(serviceName);
	          cache[serviceName] = INSTANTIATING;
	          cache[serviceName] = factory(serviceName, caller);
	          return cache[serviceName];
	        } catch (err) {
	          if (cache[serviceName] === INSTANTIATING) {
	            delete cache[serviceName];
	          }
	          throw err;
	        } finally {
	          path.shift();
	        }
	      }
	    }
	
	
	    function injectionArgs(fn, locals, serviceName) {
	      var args = [],
	          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
	
	      for (var i = 0, length = $inject.length; i < length; i++) {
	        var key = $inject[i];
	        if (typeof key !== 'string') {
	          throw $injectorMinErr('itkn',
	                  'Incorrect injection token! Expected service name as string, got {0}', key);
	        }
	        args.push(locals && locals.hasOwnProperty(key) ? locals[key] :
	                                                         getService(key, serviceName));
	      }
	      return args;
	    }
	
	    function isClass(func) {
	      // Support: IE 9-11 only
	      // IE 9-11 do not support classes and IE9 leaks with the code below.
	      if (msie || typeof func !== 'function') {
	        return false;
	      }
	      var result = func.$$ngIsClass;
	      if (!isBoolean(result)) {
	        // Support: Edge 12-13 only
	        // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
	        result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
	      }
	      return result;
	    }
	
	    function invoke(fn, self, locals, serviceName) {
	      if (typeof locals === 'string') {
	        serviceName = locals;
	        locals = null;
	      }
	
	      var args = injectionArgs(fn, locals, serviceName);
	      if (isArray(fn)) {
	        fn = fn[fn.length - 1];
	      }
	
	      if (!isClass(fn)) {
	        // http://jsperf.com/angularjs-invoke-apply-vs-switch
	        // #5388
	        return fn.apply(self, args);
	      } else {
	        args.unshift(null);
	        return new (Function.prototype.bind.apply(fn, args))();
	      }
	    }
	
	
	    function instantiate(Type, locals, serviceName) {
	      // Check if Type is annotated and use just the given function at n-1 as parameter
	      // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
	      var ctor = (isArray(Type) ? Type[Type.length - 1] : Type);
	      var args = injectionArgs(Type, locals, serviceName);
	      // Empty object at position 0 is ignored for invocation with `new`, but required.
	      args.unshift(null);
	      return new (Function.prototype.bind.apply(ctor, args))();
	    }
	
	
	    return {
	      invoke: invoke,
	      instantiate: instantiate,
	      get: getService,
	      annotate: createInjector.$$annotate,
	      has: function(name) {
	        return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
	      }
	    };
	  }
	}
	
	createInjector.$$annotate = annotate;
	
	/**
	 * @ngdoc provider
	 * @name $anchorScrollProvider
	 * @this
	 *
	 * @description
	 * Use `$anchorScrollProvider` to disable automatic scrolling whenever
	 * {@link ng.$location#hash $location.hash()} changes.
	 */
	function $AnchorScrollProvider() {
	
	  var autoScrollingEnabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $anchorScrollProvider#disableAutoScrolling
	   *
	   * @description
	   * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
	   * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
	   * Use this method to disable automatic scrolling.
	   *
	   * If automatic scrolling is disabled, one must explicitly call
	   * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
	   * current hash.
	   */
	  this.disableAutoScrolling = function() {
	    autoScrollingEnabled = false;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $anchorScroll
	   * @kind function
	   * @requires $window
	   * @requires $location
	   * @requires $rootScope
	   *
	   * @description
	   * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
	   * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
	   * in the
	   * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
	   *
	   * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
	   * match any anchor whenever it changes. This can be disabled by calling
	   * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
	   *
	   * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
	   * vertical scroll-offset (either fixed or dynamic).
	   *
	   * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
	   *                       {@link ng.$location#hash $location.hash()} will be used.
	   *
	   * @property {(number|function|jqLite)} yOffset
	   * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
	   * positioned elements at the top of the page, such as navbars, headers etc.
	   *
	   * `yOffset` can be specified in various ways:
	   * - **number**: A fixed number of pixels to be used as offset.<br /><br />
	   * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
	   *   a number representing the offset (in pixels).<br /><br />
	   * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
	   *   the top of the page to the element's bottom will be used as offset.<br />
	   *   **Note**: The element will be taken into account only as long as its `position` is set to
	   *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
	   *   their height and/or positioning according to the viewport's size.
	   *
	   * <br />
	   * <div class="alert alert-warning">
	   * In order for `yOffset` to work properly, scrolling should take place on the document's root and
	   * not some child element.
	   * </div>
	   *
	   * @example
	     <example module="anchorScrollExample" name="anchor-scroll">
	       <file name="index.html">
	         <div id="scrollArea" ng-controller="ScrollController">
	           <a ng-click="gotoBottom()">Go to bottom</a>
	           <a id="bottom"></a> You're at the bottom!
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollExample', [])
	           .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
	             function($scope, $location, $anchorScroll) {
	               $scope.gotoBottom = function() {
	                 // set the location.hash to the id of
	                 // the element you wish to scroll to.
	                 $location.hash('bottom');
	
	                 // call $anchorScroll()
	                 $anchorScroll();
	               };
	             }]);
	       </file>
	       <file name="style.css">
	         #scrollArea {
	           height: 280px;
	           overflow: auto;
	         }
	
	         #bottom {
	           display: block;
	           margin-top: 2000px;
	         }
	       </file>
	     </example>
	   *
	   * <hr />
	   * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
	   * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
	   *
	   * @example
	     <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
	       <file name="index.html">
	         <div class="fixed-header" ng-controller="headerCtrl">
	           <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
	             Go to anchor {{x}}
	           </a>
	         </div>
	         <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
	           Anchor {{x}} of 5
	         </div>
	       </file>
	       <file name="script.js">
	         angular.module('anchorScrollOffsetExample', [])
	           .run(['$anchorScroll', function($anchorScroll) {
	             $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
	           }])
	           .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
	             function($anchorScroll, $location, $scope) {
	               $scope.gotoAnchor = function(x) {
	                 var newHash = 'anchor' + x;
	                 if ($location.hash() !== newHash) {
	                   // set the $location.hash to `newHash` and
	                   // $anchorScroll will automatically scroll to it
	                   $location.hash('anchor' + x);
	                 } else {
	                   // call $anchorScroll() explicitly,
	                   // since $location.hash hasn't changed
	                   $anchorScroll();
	                 }
	               };
	             }
	           ]);
	       </file>
	       <file name="style.css">
	         body {
	           padding-top: 50px;
	         }
	
	         .anchor {
	           border: 2px dashed DarkOrchid;
	           padding: 10px 10px 200px 10px;
	         }
	
	         .fixed-header {
	           background-color: rgba(0, 0, 0, 0.2);
	           height: 50px;
	           position: fixed;
	           top: 0; left: 0; right: 0;
	         }
	
	         .fixed-header > a {
	           display: inline-block;
	           margin: 5px 15px;
	         }
	       </file>
	     </example>
	   */
	  this.$get = ['$window', '$location', '$rootScope', function($window, $location, $rootScope) {
	    var document = $window.document;
	
	    // Helper function to get first anchor from a NodeList
	    // (using `Array#some()` instead of `angular#forEach()` since it's more performant
	    //  and working in all supported browsers.)
	    function getFirstAnchor(list) {
	      var result = null;
	      Array.prototype.some.call(list, function(element) {
	        if (nodeName_(element) === 'a') {
	          result = element;
	          return true;
	        }
	      });
	      return result;
	    }
	
	    function getYOffset() {
	
	      var offset = scroll.yOffset;
	
	      if (isFunction(offset)) {
	        offset = offset();
	      } else if (isElement(offset)) {
	        var elem = offset[0];
	        var style = $window.getComputedStyle(elem);
	        if (style.position !== 'fixed') {
	          offset = 0;
	        } else {
	          offset = elem.getBoundingClientRect().bottom;
	        }
	      } else if (!isNumber(offset)) {
	        offset = 0;
	      }
	
	      return offset;
	    }
	
	    function scrollTo(elem) {
	      if (elem) {
	        elem.scrollIntoView();
	
	        var offset = getYOffset();
	
	        if (offset) {
	          // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
	          // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
	          // top of the viewport.
	          //
	          // IF the number of pixels from the top of `elem` to the end of the page's content is less
	          // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
	          // way down the page.
	          //
	          // This is often the case for elements near the bottom of the page.
	          //
	          // In such cases we do not need to scroll the whole `offset` up, just the difference between
	          // the top of the element and the offset, which is enough to align the top of `elem` at the
	          // desired position.
	          var elemTop = elem.getBoundingClientRect().top;
	          $window.scrollBy(0, elemTop - offset);
	        }
	      } else {
	        $window.scrollTo(0, 0);
	      }
	    }
	
	    function scroll(hash) {
	      // Allow numeric hashes
	      hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
	      var elm;
	
	      // empty hash, scroll to the top of the page
	      if (!hash) scrollTo(null);
	
	      // element with given id
	      else if ((elm = document.getElementById(hash))) scrollTo(elm);
	
	      // first anchor with given name :-D
	      else if ((elm = getFirstAnchor(document.getElementsByName(hash)))) scrollTo(elm);
	
	      // no element and hash === 'top', scroll to the top of the page
	      else if (hash === 'top') scrollTo(null);
	    }
	
	    // does not scroll when user clicks on anchor link that is currently on
	    // (no url change, no $location.hash() change), browser native does scroll
	    if (autoScrollingEnabled) {
	      $rootScope.$watch(function autoScrollWatch() {return $location.hash();},
	        function autoScrollWatchAction(newVal, oldVal) {
	          // skip the initial scroll if $location.hash is empty
	          if (newVal === oldVal && newVal === '') return;
	
	          jqLiteDocumentLoaded(function() {
	            $rootScope.$evalAsync(scroll);
	          });
	        });
	    }
	
	    return scroll;
	  }];
	}
	
	var $animateMinErr = minErr('$animate');
	var ELEMENT_NODE = 1;
	var NG_ANIMATE_CLASSNAME = 'ng-animate';
	
	function mergeClasses(a,b) {
	  if (!a && !b) return '';
	  if (!a) return b;
	  if (!b) return a;
	  if (isArray(a)) a = a.join(' ');
	  if (isArray(b)) b = b.join(' ');
	  return a + ' ' + b;
	}
	
	function extractElementNode(element) {
	  for (var i = 0; i < element.length; i++) {
	    var elm = element[i];
	    if (elm.nodeType === ELEMENT_NODE) {
	      return elm;
	    }
	  }
	}
	
	function splitClasses(classes) {
	  if (isString(classes)) {
	    classes = classes.split(' ');
	  }
	
	  // Use createMap() to prevent class assumptions involving property names in
	  // Object.prototype
	  var obj = createMap();
	  forEach(classes, function(klass) {
	    // sometimes the split leaves empty string values
	    // incase extra spaces were applied to the options
	    if (klass.length) {
	      obj[klass] = true;
	    }
	  });
	  return obj;
	}
	
	// if any other type of options value besides an Object value is
	// passed into the $animate.method() animation then this helper code
	// will be run which will ignore it. While this patch is not the
	// greatest solution to this, a lot of existing plugins depend on
	// $animate to either call the callback (< 1.2) or return a promise
	// that can be changed. This helper function ensures that the options
	// are wiped clean incase a callback function is provided.
	function prepareAnimateOptions(options) {
	  return isObject(options)
	      ? options
	      : {};
	}
	
	var $$CoreAnimateJsProvider = /** @this */ function() {
	  this.$get = noop;
	};
	
	// this is prefixed with Core since it conflicts with
	// the animateQueueProvider defined in ngAnimate/animateQueue.js
	var $$CoreAnimateQueueProvider = /** @this */ function() {
	  var postDigestQueue = new NgMap();
	  var postDigestElements = [];
	
	  this.$get = ['$$AnimateRunner', '$rootScope',
	       function($$AnimateRunner,   $rootScope) {
	    return {
	      enabled: noop,
	      on: noop,
	      off: noop,
	      pin: noop,
	
	      push: function(element, event, options, domOperation) {
	        if (domOperation) {
	          domOperation();
	        }
	
	        options = options || {};
	        if (options.from) {
	          element.css(options.from);
	        }
	        if (options.to) {
	          element.css(options.to);
	        }
	
	        if (options.addClass || options.removeClass) {
	          addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
	        }
	
	        var runner = new $$AnimateRunner();
	
	        // since there are no animations to run the runner needs to be
	        // notified that the animation call is complete.
	        runner.complete();
	        return runner;
	      }
	    };
	
	
	    function updateData(data, classes, value) {
	      var changed = false;
	      if (classes) {
	        classes = isString(classes) ? classes.split(' ') :
	                  isArray(classes) ? classes : [];
	        forEach(classes, function(className) {
	          if (className) {
	            changed = true;
	            data[className] = value;
	          }
	        });
	      }
	      return changed;
	    }
	
	    function handleCSSClassChanges() {
	      forEach(postDigestElements, function(element) {
	        var data = postDigestQueue.get(element);
	        if (data) {
	          var existing = splitClasses(element.attr('class'));
	          var toAdd = '';
	          var toRemove = '';
	          forEach(data, function(status, className) {
	            var hasClass = !!existing[className];
	            if (status !== hasClass) {
	              if (status) {
	                toAdd += (toAdd.length ? ' ' : '') + className;
	              } else {
	                toRemove += (toRemove.length ? ' ' : '') + className;
	              }
	            }
	          });
	
	          forEach(element, function(elm) {
	            if (toAdd) {
	              jqLiteAddClass(elm, toAdd);
	            }
	            if (toRemove) {
	              jqLiteRemoveClass(elm, toRemove);
	            }
	          });
	          postDigestQueue.delete(element);
	        }
	      });
	      postDigestElements.length = 0;
	    }
	
	
	    function addRemoveClassesPostDigest(element, add, remove) {
	      var data = postDigestQueue.get(element) || {};
	
	      var classesAdded = updateData(data, add, true);
	      var classesRemoved = updateData(data, remove, false);
	
	      if (classesAdded || classesRemoved) {
	
	        postDigestQueue.set(element, data);
	        postDigestElements.push(element);
	
	        if (postDigestElements.length === 1) {
	          $rootScope.$$postDigest(handleCSSClassChanges);
	        }
	      }
	    }
	  }];
	};
	
	/**
	 * @ngdoc provider
	 * @name $animateProvider
	 *
	 * @description
	 * Default implementation of $animate that doesn't perform any animations, instead just
	 * synchronously performs DOM updates and resolves the returned runner promise.
	 *
	 * In order to enable animations the `ngAnimate` module has to be loaded.
	 *
	 * To see the functional implementation check out `src/ngAnimate/animate.js`.
	 */
	var $AnimateProvider = ['$provide', /** @this */ function($provide) {
	  var provider = this;
	  var classNameFilter = null;
	
	  this.$$registeredAnimations = Object.create(null);
	
	   /**
	   * @ngdoc method
	   * @name $animateProvider#register
	   *
	   * @description
	   * Registers a new injectable animation factory function. The factory function produces the
	   * animation object which contains callback functions for each event that is expected to be
	   * animated.
	   *
	   *   * `eventFn`: `function(element, ... , doneFunction, options)`
	   *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
	   *   on the type of animation additional arguments will be injected into the animation function. The
	   *   list below explains the function signatures for the different animation methods:
	   *
	   *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
	   *   - addClass: function(element, addedClasses, doneFunction, options)
	   *   - removeClass: function(element, removedClasses, doneFunction, options)
	   *   - enter, leave, move: function(element, doneFunction, options)
	   *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
	   *
	   *   Make sure to trigger the `doneFunction` once the animation is fully complete.
	   *
	   * ```js
	   *   return {
	   *     //enter, leave, move signature
	   *     eventFn : function(element, done, options) {
	   *       //code to run the animation
	   *       //once complete, then run done()
	   *       return function endFunction(wasCancelled) {
	   *         //code to cancel the animation
	   *       }
	   *     }
	   *   }
	   * ```
	   *
	   * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
	   * @param {Function} factory The factory function that will be executed to return the animation
	   *                           object.
	   */
	  this.register = function(name, factory) {
	    if (name && name.charAt(0) !== '.') {
	      throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
	    }
	
	    var key = name + '-animation';
	    provider.$$registeredAnimations[name.substr(1)] = key;
	    $provide.factory(key, factory);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $animateProvider#classNameFilter
	   *
	   * @description
	   * Sets and/or returns the CSS class regular expression that is checked when performing
	   * an animation. Upon bootstrap the classNameFilter value is not set at all and will
	   * therefore enable $animate to attempt to perform an animation on any element that is triggered.
	   * When setting the `classNameFilter` value, animations will only be performed on elements
	   * that successfully match the filter expression. This in turn can boost performance
	   * for low-powered devices as well as applications containing a lot of structural operations.
	   * @param {RegExp=} expression The className expression which will be checked against all animations
	   * @return {RegExp} The current CSS className expression value. If null then there is no expression value
	   */
	  this.classNameFilter = function(expression) {
	    if (arguments.length === 1) {
	      classNameFilter = (expression instanceof RegExp) ? expression : null;
	      if (classNameFilter) {
	        var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
	        if (reservedRegex.test(classNameFilter.toString())) {
	          classNameFilter = null;
	          throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
	        }
	      }
	    }
	    return classNameFilter;
	  };
	
	  this.$get = ['$$animateQueue', function($$animateQueue) {
	    function domInsert(element, parentElement, afterElement) {
	      // if for some reason the previous element was removed
	      // from the dom sometime before this code runs then let's
	      // just stick to using the parent element as the anchor
	      if (afterElement) {
	        var afterNode = extractElementNode(afterElement);
	        if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
	          afterElement = null;
	        }
	      }
	      if (afterElement) {
	        afterElement.after(element);
	      } else {
	        parentElement.prepend(element);
	      }
	    }
	
	    /**
	     * @ngdoc service
	     * @name $animate
	     * @description The $animate service exposes a series of DOM utility methods that provide support
	     * for animation hooks. The default behavior is the application of DOM operations, however,
	     * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
	     * to ensure that animation runs with the triggered DOM operation.
	     *
	     * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
	     * included and only when it is active then the animation hooks that `$animate` triggers will be
	     * functional. Once active then all structural `ng-` directives will trigger animations as they perform
	     * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
	     * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
	     *
	     * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
	     *
	     * To learn more about enabling animation support, click here to visit the
	     * {@link ngAnimate ngAnimate module page}.
	     */
	    return {
	      // we don't call it directly since non-existant arguments may
	      // be interpreted as null within the sub enabled function
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#on
	       * @kind function
	       * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
	       *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
	       *    is fired with the following params:
	       *
	       * ```js
	       * $animate.on('enter', container,
	       *    function callback(element, phase) {
	       *      // cool we detected an enter animation within the container
	       *    }
	       * );
	       * ```
	       *
	       * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
	       * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
	       *     as well as among its children
	       * @param {Function} callback the callback function that will be fired when the listener is triggered
	       *
	       * The arguments present in the callback function are:
	       * * `element` - The captured DOM element that the animation was fired on.
	       * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
	       */
	      on: $$animateQueue.on,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#off
	       * @kind function
	       * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
	       * can be used in three different ways depending on the arguments:
	       *
	       * ```js
	       * // remove all the animation event listeners listening for `enter`
	       * $animate.off('enter');
	       *
	       * // remove listeners for all animation events from the container element
	       * $animate.off(container);
	       *
	       * // remove all the animation event listeners listening for `enter` on the given element and its children
	       * $animate.off('enter', container);
	       *
	       * // remove the event listener function provided by `callback` that is set
	       * // to listen for `enter` on the given `container` as well as its children
	       * $animate.off('enter', container, callback);
	       * ```
	       *
	       * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
	       * addClass, removeClass, etc...), or the container element. If it is the element, all other
	       * arguments are ignored.
	       * @param {DOMElement=} container the container element the event listener was placed on
	       * @param {Function=} callback the callback function that was registered as the listener
	       */
	      off: $$animateQueue.off,
	
	      /**
	       * @ngdoc method
	       * @name $animate#pin
	       * @kind function
	       * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
	       *    outside of the DOM structure of the Angular application. By doing so, any animation triggered via `$animate` can be issued on the
	       *    element despite being outside the realm of the application or within another application. Say for example if the application
	       *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
	       *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
	       *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
	       *
	       *    Note that this feature is only active when the `ngAnimate` module is used.
	       *
	       * @param {DOMElement} element the external element that will be pinned
	       * @param {DOMElement} parentElement the host parent element that will be associated with the external element
	       */
	      pin: $$animateQueue.pin,
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enabled
	       * @kind function
	       * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
	       * function can be called in four ways:
	       *
	       * ```js
	       * // returns true or false
	       * $animate.enabled();
	       *
	       * // changes the enabled state for all animations
	       * $animate.enabled(false);
	       * $animate.enabled(true);
	       *
	       * // returns true or false if animations are enabled for an element
	       * $animate.enabled(element);
	       *
	       * // changes the enabled state for an element and its children
	       * $animate.enabled(element, true);
	       * $animate.enabled(element, false);
	       * ```
	       *
	       * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
	       * @param {boolean=} enabled whether or not the animations will be enabled for the element
	       *
	       * @return {boolean} whether or not animations are enabled
	       */
	      enabled: $$animateQueue.enabled,
	
	      /**
	       * @ngdoc method
	       * @name $animate#cancel
	       * @kind function
	       * @description Cancels the provided animation.
	       *
	       * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
	       */
	      cancel: function(runner) {
	        if (runner.end) {
	          runner.end();
	        }
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#enter
	       * @kind function
	       * @description Inserts the element into the DOM either after the `after` element (if provided) or
	       *   as the first child within the `parent` element and then triggers an animation.
	       *   A promise is returned that will be resolved during the next digest once the animation
	       *   has completed.
	       *
	       * @param {DOMElement} element the element which will be inserted into the DOM
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      enter: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
	      },
	
	      /**
	       *
	       * @ngdoc method
	       * @name $animate#move
	       * @kind function
	       * @description Inserts (moves) the element into its new position in the DOM either after
	       *   the `after` element (if provided) or as the first child within the `parent` element
	       *   and then triggers an animation. A promise is returned that will be resolved
	       *   during the next digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be moved into the new DOM position
	       * @param {DOMElement} parent the parent element which will append the element as
	       *   a child (so long as the after element is not present)
	       * @param {DOMElement=} after the sibling element after which the element will be appended
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      move: function(element, parent, after, options) {
	        parent = parent && jqLite(parent);
	        after = after && jqLite(after);
	        parent = parent || after.parent();
	        domInsert(element, parent, after);
	        return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#leave
	       * @kind function
	       * @description Triggers an animation and then removes the element from the DOM.
	       * When the function is called a promise is returned that will be resolved during the next
	       * digest once the animation has completed.
	       *
	       * @param {DOMElement} element the element which will be removed from the DOM
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      leave: function(element, options) {
	        return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function() {
	          element.remove();
	        });
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#addClass
	       * @kind function
	       *
	       * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
	       *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element already contains the CSS class or if the class is removed at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      addClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addclass, className);
	        return $$animateQueue.push(element, 'addClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#removeClass
	       * @kind function
	       *
	       * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
	       *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
	       *   animation if element does not contain the CSS class or if the class is added at a later step.
	       *   Note that class-based animations are treated differently compared to structural animations
	       *   (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *   depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      removeClass: function(element, className, options) {
	        options = prepareAnimateOptions(options);
	        options.removeClass = mergeClasses(options.removeClass, className);
	        return $$animateQueue.push(element, 'removeClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#setClass
	       * @kind function
	       *
	       * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
	       *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
	       *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
	       *    passed. Note that class-based animations are treated differently compared to structural animations
	       *    (like enter, move and leave) since the CSS classes may be added/removed at different points
	       *    depending if CSS or JavaScript animations are used.
	       *
	       * @param {DOMElement} element the element which the CSS classes will be applied to
	       * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
	       * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      setClass: function(element, add, remove, options) {
	        options = prepareAnimateOptions(options);
	        options.addClass = mergeClasses(options.addClass, add);
	        options.removeClass = mergeClasses(options.removeClass, remove);
	        return $$animateQueue.push(element, 'setClass', options);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $animate#animate
	       * @kind function
	       *
	       * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
	       * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
	       * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
	       * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
	       * style in `to`, the style in `from` is applied immediately, and no animation is run.
	       * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
	       * method (or as part of the `options` parameter):
	       *
	       * ```js
	       * ngModule.animation('.my-inline-animation', function() {
	       *   return {
	       *     animate : function(element, from, to, done, options) {
	       *       //animation
	       *       done();
	       *     }
	       *   }
	       * });
	       * ```
	       *
	       * @param {DOMElement} element the element which the CSS styles will be applied to
	       * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
	       * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
	       * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
	       *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
	       *    (Note that if no animation is detected then this value will not be applied to the element.)
	       * @param {object=} options an optional collection of options/styles that will be applied to the element.
	       *   The object can have the following properties:
	       *
	       *   - **addClass** - `{string}` - space-separated CSS classes to add to element
	       *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
	       *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
	       *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
	       *
	       * @return {Promise} the animation callback promise
	       */
	      animate: function(element, from, to, className, options) {
	        options = prepareAnimateOptions(options);
	        options.from = options.from ? extend(options.from, from) : from;
	        options.to   = options.to   ? extend(options.to, to)     : to;
	
	        className = className || 'ng-inline-animate';
	        options.tempClasses = mergeClasses(options.tempClasses, className);
	        return $$animateQueue.push(element, 'animate', options);
	      }
	    };
	  }];
	}];
	
	var $$AnimateAsyncRunFactoryProvider = /** @this */ function() {
	  this.$get = ['$$rAF', function($$rAF) {
	    var waitQueue = [];
	
	    function waitForTick(fn) {
	      waitQueue.push(fn);
	      if (waitQueue.length > 1) return;
	      $$rAF(function() {
	        for (var i = 0; i < waitQueue.length; i++) {
	          waitQueue[i]();
	        }
	        waitQueue = [];
	      });
	    }
	
	    return function() {
	      var passed = false;
	      waitForTick(function() {
	        passed = true;
	      });
	      return function(callback) {
	        if (passed) {
	          callback();
	        } else {
	          waitForTick(callback);
	        }
	      };
	    };
	  }];
	};
	
	var $$AnimateRunnerFactoryProvider = /** @this */ function() {
	  this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout',
	       function($q,   $sniffer,   $$animateAsyncRun,   $$isDocumentHidden,   $timeout) {
	
	    var INITIAL_STATE = 0;
	    var DONE_PENDING_STATE = 1;
	    var DONE_COMPLETE_STATE = 2;
	
	    AnimateRunner.chain = function(chain, callback) {
	      var index = 0;
	
	      next();
	      function next() {
	        if (index === chain.length) {
	          callback(true);
	          return;
	        }
	
	        chain[index](function(response) {
	          if (response === false) {
	            callback(false);
	            return;
	          }
	          index++;
	          next();
	        });
	      }
	    };
	
	    AnimateRunner.all = function(runners, callback) {
	      var count = 0;
	      var status = true;
	      forEach(runners, function(runner) {
	        runner.done(onProgress);
	      });
	
	      function onProgress(response) {
	        status = status && response;
	        if (++count === runners.length) {
	          callback(status);
	        }
	      }
	    };
	
	    function AnimateRunner(host) {
	      this.setHost(host);
	
	      var rafTick = $$animateAsyncRun();
	      var timeoutTick = function(fn) {
	        $timeout(fn, 0, false);
	      };
	
	      this._doneCallbacks = [];
	      this._tick = function(fn) {
	        if ($$isDocumentHidden()) {
	          timeoutTick(fn);
	        } else {
	          rafTick(fn);
	        }
	      };
	      this._state = 0;
	    }
	
	    AnimateRunner.prototype = {
	      setHost: function(host) {
	        this.host = host || {};
	      },
	
	      done: function(fn) {
	        if (this._state === DONE_COMPLETE_STATE) {
	          fn();
	        } else {
	          this._doneCallbacks.push(fn);
	        }
	      },
	
	      progress: noop,
	
	      getPromise: function() {
	        if (!this.promise) {
	          var self = this;
	          this.promise = $q(function(resolve, reject) {
	            self.done(function(status) {
	              if (status === false) {
	                reject();
	              } else {
	                resolve();
	              }
	            });
	          });
	        }
	        return this.promise;
	      },
	
	      then: function(resolveHandler, rejectHandler) {
	        return this.getPromise().then(resolveHandler, rejectHandler);
	      },
	
	      'catch': function(handler) {
	        return this.getPromise()['catch'](handler);
	      },
	
	      'finally': function(handler) {
	        return this.getPromise()['finally'](handler);
	      },
	
	      pause: function() {
	        if (this.host.pause) {
	          this.host.pause();
	        }
	      },
	
	      resume: function() {
	        if (this.host.resume) {
	          this.host.resume();
	        }
	      },
	
	      end: function() {
	        if (this.host.end) {
	          this.host.end();
	        }
	        this._resolve(true);
	      },
	
	      cancel: function() {
	        if (this.host.cancel) {
	          this.host.cancel();
	        }
	        this._resolve(false);
	      },
	
	      complete: function(response) {
	        var self = this;
	        if (self._state === INITIAL_STATE) {
	          self._state = DONE_PENDING_STATE;
	          self._tick(function() {
	            self._resolve(response);
	          });
	        }
	      },
	
	      _resolve: function(response) {
	        if (this._state !== DONE_COMPLETE_STATE) {
	          forEach(this._doneCallbacks, function(fn) {
	            fn(response);
	          });
	          this._doneCallbacks.length = 0;
	          this._state = DONE_COMPLETE_STATE;
	        }
	      }
	    };
	
	    return AnimateRunner;
	  }];
	};
	
	/* exported $CoreAnimateCssProvider */
	
	/**
	 * @ngdoc service
	 * @name $animateCss
	 * @kind object
	 * @this
	 *
	 * @description
	 * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
	 * then the `$animateCss` service will actually perform animations.
	 *
	 * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
	 */
	var $CoreAnimateCssProvider = function() {
	  this.$get = ['$$rAF', '$q', '$$AnimateRunner', function($$rAF, $q, $$AnimateRunner) {
	
	    return function(element, initialOptions) {
	      // all of the animation functions should create
	      // a copy of the options data, however, if a
	      // parent service has already created a copy then
	      // we should stick to using that
	      var options = initialOptions || {};
	      if (!options.$$prepared) {
	        options = copy(options);
	      }
	
	      // there is no point in applying the styles since
	      // there is no animation that goes on at all in
	      // this version of $animateCss.
	      if (options.cleanupStyles) {
	        options.from = options.to = null;
	      }
	
	      if (options.from) {
	        element.css(options.from);
	        options.from = null;
	      }
	
	      var closed, runner = new $$AnimateRunner();
	      return {
	        start: run,
	        end: run
	      };
	
	      function run() {
	        $$rAF(function() {
	          applyAnimationContents();
	          if (!closed) {
	            runner.complete();
	          }
	          closed = true;
	        });
	        return runner;
	      }
	
	      function applyAnimationContents() {
	        if (options.addClass) {
	          element.addClass(options.addClass);
	          options.addClass = null;
	        }
	        if (options.removeClass) {
	          element.removeClass(options.removeClass);
	          options.removeClass = null;
	        }
	        if (options.to) {
	          element.css(options.to);
	          options.to = null;
	        }
	      }
	    };
	  }];
	};
	
	/* global stripHash: true */
	
	/**
	 * ! This is a private undocumented service !
	 *
	 * @name $browser
	 * @requires $log
	 * @description
	 * This object has two goals:
	 *
	 * - hide all the global state in the browser caused by the window object
	 * - abstract away all the browser specific features and inconsistencies
	 *
	 * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
	 * service, which can be used for convenient testing of the application without the interaction with
	 * the real browser apis.
	 */
	/**
	 * @param {object} window The global window object.
	 * @param {object} document jQuery wrapped document.
	 * @param {object} $log window.console or an object with the same interface.
	 * @param {object} $sniffer $sniffer service
	 */
	function Browser(window, document, $log, $sniffer) {
	  var self = this,
	      location = window.location,
	      history = window.history,
	      setTimeout = window.setTimeout,
	      clearTimeout = window.clearTimeout,
	      pendingDeferIds = {};
	
	  self.isMock = false;
	
	  var outstandingRequestCount = 0;
	  var outstandingRequestCallbacks = [];
	
	  // TODO(vojta): remove this temporary api
	  self.$$completeOutstandingRequest = completeOutstandingRequest;
	  self.$$incOutstandingRequestCount = function() { outstandingRequestCount++; };
	
	  /**
	   * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
	   * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
	   */
	  function completeOutstandingRequest(fn) {
	    try {
	      fn.apply(null, sliceArgs(arguments, 1));
	    } finally {
	      outstandingRequestCount--;
	      if (outstandingRequestCount === 0) {
	        while (outstandingRequestCallbacks.length) {
	          try {
	            outstandingRequestCallbacks.pop()();
	          } catch (e) {
	            $log.error(e);
	          }
	        }
	      }
	    }
	  }
	
	  function getHash(url) {
	    var index = url.indexOf('#');
	    return index === -1 ? '' : url.substr(index);
	  }
	
	  /**
	   * @private
	   * Note: this method is used only by scenario runner
	   * TODO(vojta): prefix this method with $$ ?
	   * @param {function()} callback Function that will be called when no outstanding request
	   */
	  self.notifyWhenNoOutstandingRequests = function(callback) {
	    if (outstandingRequestCount === 0) {
	      callback();
	    } else {
	      outstandingRequestCallbacks.push(callback);
	    }
	  };
	
	  //////////////////////////////////////////////////////////////
	  // URL API
	  //////////////////////////////////////////////////////////////
	
	  var cachedState, lastHistoryState,
	      lastBrowserUrl = location.href,
	      baseElement = document.find('base'),
	      pendingLocation = null,
	      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
	        try {
	          return history.state;
	        } catch (e) {
	          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
	        }
	      };
	
	  cacheState();
	
	  /**
	   * @name $browser#url
	   *
	   * @description
	   * GETTER:
	   * Without any argument, this method just returns current value of location.href.
	   *
	   * SETTER:
	   * With at least one argument, this method sets url to new value.
	   * If html5 history api supported, pushState/replaceState is used, otherwise
	   * location.href/location.replace is used.
	   * Returns its own instance to allow chaining
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to change url.
	   *
	   * @param {string} url New url (when used as setter)
	   * @param {boolean=} replace Should new url replace current history record?
	   * @param {object=} state object to use with pushState/replaceState
	   */
	  self.url = function(url, replace, state) {
	    // In modern browsers `history.state` is `null` by default; treating it separately
	    // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
	    // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
	    if (isUndefined(state)) {
	      state = null;
	    }
	
	    // Android Browser BFCache causes location, history reference to become stale.
	    if (location !== window.location) location = window.location;
	    if (history !== window.history) history = window.history;
	
	    // setter
	    if (url) {
	      var sameState = lastHistoryState === state;
	
	      // Don't change anything if previous and current URLs and states match. This also prevents
	      // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
	      // See https://github.com/angular/angular.js/commit/ffb2701
	      if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
	        return self;
	      }
	      var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
	      lastBrowserUrl = url;
	      lastHistoryState = state;
	      // Don't use history API if only the hash changed
	      // due to a bug in IE10/IE11 which leads
	      // to not firing a `hashchange` nor `popstate` event
	      // in some cases (see #9143).
	      if ($sniffer.history && (!sameBase || !sameState)) {
	        history[replace ? 'replaceState' : 'pushState'](state, '', url);
	        cacheState();
	      } else {
	        if (!sameBase) {
	          pendingLocation = url;
	        }
	        if (replace) {
	          location.replace(url);
	        } else if (!sameBase) {
	          location.href = url;
	        } else {
	          location.hash = getHash(url);
	        }
	        if (location.href !== url) {
	          pendingLocation = url;
	        }
	      }
	      if (pendingLocation) {
	        pendingLocation = url;
	      }
	      return self;
	    // getter
	    } else {
	      // - pendingLocation is needed as browsers don't allow to read out
	      //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
	      //   https://openradar.appspot.com/22186109).
	      // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
	      return pendingLocation || location.href.replace(/%27/g,'\'');
	    }
	  };
	
	  /**
	   * @name $browser#state
	   *
	   * @description
	   * This method is a getter.
	   *
	   * Return history.state or null if history.state is undefined.
	   *
	   * @returns {object} state
	   */
	  self.state = function() {
	    return cachedState;
	  };
	
	  var urlChangeListeners = [],
	      urlChangeInit = false;
	
	  function cacheStateAndFireUrlChange() {
	    pendingLocation = null;
	    fireStateOrUrlChange();
	  }
	
	  // This variable should be used *only* inside the cacheState function.
	  var lastCachedState = null;
	  function cacheState() {
	    // This should be the only place in $browser where `history.state` is read.
	    cachedState = getCurrentState();
	    cachedState = isUndefined(cachedState) ? null : cachedState;
	
	    // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
	    if (equals(cachedState, lastCachedState)) {
	      cachedState = lastCachedState;
	    }
	
	    lastCachedState = cachedState;
	    lastHistoryState = cachedState;
	  }
	
	  function fireStateOrUrlChange() {
	    var prevLastHistoryState = lastHistoryState;
	    cacheState();
	
	    if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
	      return;
	    }
	
	    lastBrowserUrl = self.url();
	    lastHistoryState = cachedState;
	    forEach(urlChangeListeners, function(listener) {
	      listener(self.url(), cachedState);
	    });
	  }
	
	  /**
	   * @name $browser#onUrlChange
	   *
	   * @description
	   * Register callback function that will be called, when url changes.
	   *
	   * It's only called when the url is changed from outside of angular:
	   * - user types different url into address bar
	   * - user clicks on history (forward/back) button
	   * - user clicks on a link
	   *
	   * It's not called when url is changed by $browser.url() method
	   *
	   * The listener gets called with new url as parameter.
	   *
	   * NOTE: this api is intended for use only by the $location service. Please use the
	   * {@link ng.$location $location service} to monitor url changes in angular apps.
	   *
	   * @param {function(string)} listener Listener function to be called when url changes.
	   * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
	   */
	  self.onUrlChange = function(callback) {
	    // TODO(vojta): refactor to use node's syntax for events
	    if (!urlChangeInit) {
	      // We listen on both (hashchange/popstate) when available, as some browsers don't
	      // fire popstate when user changes the address bar and don't fire hashchange when url
	      // changed by push/replaceState
	
	      // html5 history api - popstate event
	      if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
	      // hashchange event
	      jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
	
	      urlChangeInit = true;
	    }
	
	    urlChangeListeners.push(callback);
	    return callback;
	  };
	
	  /**
	   * @private
	   * Remove popstate and hashchange handler from window.
	   *
	   * NOTE: this api is intended for use only by $rootScope.
	   */
	  self.$$applicationDestroyed = function() {
	    jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
	  };
	
	  /**
	   * Checks whether the url has changed outside of Angular.
	   * Needs to be exported to be able to check for changes that have been done in sync,
	   * as hashchange/popstate events fire in async.
	   */
	  self.$$checkUrlChange = fireStateOrUrlChange;
	
	  //////////////////////////////////////////////////////////////
	  // Misc API
	  //////////////////////////////////////////////////////////////
	
	  /**
	   * @name $browser#baseHref
	   *
	   * @description
	   * Returns current <base href>
	   * (always relative - without domain)
	   *
	   * @returns {string} The current base href
	   */
	  self.baseHref = function() {
	    var href = baseElement.attr('href');
	    return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
	  };
	
	  /**
	   * @name $browser#defer
	   * @param {function()} fn A function, who's execution should be deferred.
	   * @param {number=} [delay=0] of milliseconds to defer the function execution.
	   * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
	   *
	   * @description
	   * Executes a fn asynchronously via `setTimeout(fn, delay)`.
	   *
	   * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
	   * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
	   * via `$browser.defer.flush()`.
	   *
	   */
	  self.defer = function(fn, delay) {
	    var timeoutId;
	    outstandingRequestCount++;
	    timeoutId = setTimeout(function() {
	      delete pendingDeferIds[timeoutId];
	      completeOutstandingRequest(fn);
	    }, delay || 0);
	    pendingDeferIds[timeoutId] = true;
	    return timeoutId;
	  };
	
	
	  /**
	   * @name $browser#defer.cancel
	   *
	   * @description
	   * Cancels a deferred task identified with `deferId`.
	   *
	   * @param {*} deferId Token returned by the `$browser.defer` function.
	   * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	   *                    canceled.
	   */
	  self.defer.cancel = function(deferId) {
	    if (pendingDeferIds[deferId]) {
	      delete pendingDeferIds[deferId];
	      clearTimeout(deferId);
	      completeOutstandingRequest(noop);
	      return true;
	    }
	    return false;
	  };
	
	}
	
	/** @this */
	function $BrowserProvider() {
	  this.$get = ['$window', '$log', '$sniffer', '$document',
	      function($window, $log, $sniffer, $document) {
	        return new Browser($window, $document, $log, $sniffer);
	      }];
	}
	
	/**
	 * @ngdoc service
	 * @name $cacheFactory
	 * @this
	 *
	 * @description
	 * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
	 * them.
	 *
	 * ```js
	 *
	 *  var cache = $cacheFactory('cacheId');
	 *  expect($cacheFactory.get('cacheId')).toBe(cache);
	 *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
	 *
	 *  cache.put("key", "value");
	 *  cache.put("another key", "another value");
	 *
	 *  // We've specified no options on creation
	 *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
	 *
	 * ```
	 *
	 *
	 * @param {string} cacheId Name or id of the newly created cache.
	 * @param {object=} options Options object that specifies the cache behavior. Properties:
	 *
	 *   - `{number=}` `capacity` — turns the cache into LRU cache.
	 *
	 * @returns {object} Newly created cache object with the following set of methods:
	 *
	 * - `{object}` `info()` — Returns id, size, and options of cache.
	 * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
	 *   it.
	 * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
	 * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
	 * - `{void}` `removeAll()` — Removes all cached values.
	 * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
	 *
	 * @example
	   <example module="cacheExampleApp" name="cache-factory">
	     <file name="index.html">
	       <div ng-controller="CacheController">
	         <input ng-model="newCacheKey" placeholder="Key">
	         <input ng-model="newCacheValue" placeholder="Value">
	         <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
	
	         <p ng-if="keys.length">Cached Values</p>
	         <div ng-repeat="key in keys">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="cache.get(key)"></b>
	         </div>
	
	         <p>Cache Info</p>
	         <div ng-repeat="(key, value) in cache.info()">
	           <span ng-bind="key"></span>
	           <span>: </span>
	           <b ng-bind="value"></b>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('cacheExampleApp', []).
	         controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
	           $scope.keys = [];
	           $scope.cache = $cacheFactory('cacheId');
	           $scope.put = function(key, value) {
	             if (angular.isUndefined($scope.cache.get(key))) {
	               $scope.keys.push(key);
	             }
	             $scope.cache.put(key, angular.isUndefined(value) ? null : value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       p {
	         margin: 10px 0 3px;
	       }
	     </file>
	   </example>
	 */
	function $CacheFactoryProvider() {
	
	  this.$get = function() {
	    var caches = {};
	
	    function cacheFactory(cacheId, options) {
	      if (cacheId in caches) {
	        throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
	      }
	
	      var size = 0,
	          stats = extend({}, options, {id: cacheId}),
	          data = createMap(),
	          capacity = (options && options.capacity) || Number.MAX_VALUE,
	          lruHash = createMap(),
	          freshEnd = null,
	          staleEnd = null;
	
	      /**
	       * @ngdoc type
	       * @name $cacheFactory.Cache
	       *
	       * @description
	       * A cache object used to store and retrieve data, primarily used by
	       * {@link $http $http} and the {@link ng.directive:script script} directive to cache
	       * templates and other data.
	       *
	       * ```js
	       *  angular.module('superCache')
	       *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
	       *      return $cacheFactory('super-cache');
	       *    }]);
	       * ```
	       *
	       * Example test:
	       *
	       * ```js
	       *  it('should behave like a cache', inject(function(superCache) {
	       *    superCache.put('key', 'value');
	       *    superCache.put('another key', 'another value');
	       *
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 2
	       *    });
	       *
	       *    superCache.remove('another key');
	       *    expect(superCache.get('another key')).toBeUndefined();
	       *
	       *    superCache.removeAll();
	       *    expect(superCache.info()).toEqual({
	       *      id: 'super-cache',
	       *      size: 0
	       *    });
	       *  }));
	       * ```
	       */
	      return (caches[cacheId] = {
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#put
	         * @kind function
	         *
	         * @description
	         * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
	         * retrieved later, and incrementing the size of the cache if the key was not already
	         * present in the cache. If behaving like an LRU cache, it will also remove stale
	         * entries from the set.
	         *
	         * It will not insert undefined values into the cache.
	         *
	         * @param {string} key the key under which the cached data is stored.
	         * @param {*} value the value to store alongside the key. If it is undefined, the key
	         *    will not be stored.
	         * @returns {*} the value stored.
	         */
	        put: function(key, value) {
	          if (isUndefined(value)) return;
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key] || (lruHash[key] = {key: key});
	
	            refresh(lruEntry);
	          }
	
	          if (!(key in data)) size++;
	          data[key] = value;
	
	          if (size > capacity) {
	            this.remove(staleEnd.key);
	          }
	
	          return value;
	        },
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#get
	         * @kind function
	         *
	         * @description
	         * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the data to be retrieved
	         * @returns {*} the value stored.
	         */
	        get: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            refresh(lruEntry);
	          }
	
	          return data[key];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#remove
	         * @kind function
	         *
	         * @description
	         * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
	         *
	         * @param {string} key the key of the entry to be removed
	         */
	        remove: function(key) {
	          if (capacity < Number.MAX_VALUE) {
	            var lruEntry = lruHash[key];
	
	            if (!lruEntry) return;
	
	            if (lruEntry === freshEnd) freshEnd = lruEntry.p;
	            if (lruEntry === staleEnd) staleEnd = lruEntry.n;
	            link(lruEntry.n,lruEntry.p);
	
	            delete lruHash[key];
	          }
	
	          if (!(key in data)) return;
	
	          delete data[key];
	          size--;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#removeAll
	         * @kind function
	         *
	         * @description
	         * Clears the cache object of any entries.
	         */
	        removeAll: function() {
	          data = createMap();
	          size = 0;
	          lruHash = createMap();
	          freshEnd = staleEnd = null;
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#destroy
	         * @kind function
	         *
	         * @description
	         * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
	         * removing it from the {@link $cacheFactory $cacheFactory} set.
	         */
	        destroy: function() {
	          data = null;
	          stats = null;
	          lruHash = null;
	          delete caches[cacheId];
	        },
	
	
	        /**
	         * @ngdoc method
	         * @name $cacheFactory.Cache#info
	         * @kind function
	         *
	         * @description
	         * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
	         *
	         * @returns {object} an object with the following properties:
	         *   <ul>
	         *     <li>**id**: the id of the cache instance</li>
	         *     <li>**size**: the number of entries kept in the cache instance</li>
	         *     <li>**...**: any additional properties from the options object when creating the
	         *       cache.</li>
	         *   </ul>
	         */
	        info: function() {
	          return extend({}, stats, {size: size});
	        }
	      });
	
	
	      /**
	       * makes the `entry` the freshEnd of the LRU linked list
	       */
	      function refresh(entry) {
	        if (entry !== freshEnd) {
	          if (!staleEnd) {
	            staleEnd = entry;
	          } else if (staleEnd === entry) {
	            staleEnd = entry.n;
	          }
	
	          link(entry.n, entry.p);
	          link(entry, freshEnd);
	          freshEnd = entry;
	          freshEnd.n = null;
	        }
	      }
	
	
	      /**
	       * bidirectionally links two entries of the LRU linked list
	       */
	      function link(nextEntry, prevEntry) {
	        if (nextEntry !== prevEntry) {
	          if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
	          if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
	        }
	      }
	    }
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#info
	   *
	   * @description
	   * Get information about all the caches that have been created
	   *
	   * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
	   */
	    cacheFactory.info = function() {
	      var info = {};
	      forEach(caches, function(cache, cacheId) {
	        info[cacheId] = cache.info();
	      });
	      return info;
	    };
	
	
	  /**
	   * @ngdoc method
	   * @name $cacheFactory#get
	   *
	   * @description
	   * Get access to a cache object by the `cacheId` used when it was created.
	   *
	   * @param {string} cacheId Name or id of a cache to access.
	   * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
	   */
	    cacheFactory.get = function(cacheId) {
	      return caches[cacheId];
	    };
	
	
	    return cacheFactory;
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $templateCache
	 * @this
	 *
	 * @description
	 * The first time a template is used, it is loaded in the template cache for quick retrieval. You
	 * can load templates directly into the cache in a `script` tag, or by consuming the
	 * `$templateCache` service directly.
	 *
	 * Adding via the `script` tag:
	 *
	 * ```html
	 *   <script type="text/ng-template" id="templateId.html">
	 *     <p>This is the content of the template</p>
	 *   </script>
	 * ```
	 *
	 * **Note:** the `script` tag containing the template does not need to be included in the `head` of
	 * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (IE,
	 * element with ng-app attribute), otherwise the template will be ignored.
	 *
	 * Adding via the `$templateCache` service:
	 *
	 * ```js
	 * var myApp = angular.module('myApp', []);
	 * myApp.run(function($templateCache) {
	 *   $templateCache.put('templateId.html', 'This is the content of the template');
	 * });
	 * ```
	 *
	 * To retrieve the template later, simply use it in your component:
	 * ```js
	 * myApp.component('myComponent', {
	 *    templateUrl: 'templateId.html'
	 * });
	 * ```
	 *
	 * or get it via the `$templateCache` service:
	 * ```js
	 * $templateCache.get('templateId.html')
	 * ```
	 *
	 * See {@link ng.$cacheFactory $cacheFactory}.
	 *
	 */
	function $TemplateCacheProvider() {
	  this.$get = ['$cacheFactory', function($cacheFactory) {
	    return $cacheFactory('templates');
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables like document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
	 *
	 * DOM-related variables:
	 *
	 * - "node" - DOM Node
	 * - "element" - DOM Element or Node
	 * - "$node" or "$element" - jqLite-wrapped node or element
	 *
	 *
	 * Compiler related stuff:
	 *
	 * - "linkFn" - linking fn of a single directive
	 * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
	 * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
	 * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $compile
	 * @kind function
	 *
	 * @description
	 * Compiles an HTML string or DOM into a template and produces a template function, which
	 * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
	 *
	 * The compilation is a process of walking the DOM tree and matching DOM elements to
	 * {@link ng.$compileProvider#directive directives}.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** This document is an in-depth reference of all directive options.
	 * For a gentle introduction to directives with examples of common use cases,
	 * see the {@link guide/directive directive guide}.
	 * </div>
	 *
	 * ## Comprehensive Directive API
	 *
	 * There are many different options for a directive.
	 *
	 * The difference resides in the return value of the factory function.
	 * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
	 * that defines the directive properties, or just the `postLink` function (all other properties will have
	 * the default values).
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's recommended to use the "directive definition object" form.
	 * </div>
	 *
	 * Here's an example directive declared with a Directive Definition Object:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       {@link $compile#-priority- priority}: 0,
	 *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
	 *       // or
	 *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
	 *       {@link $compile#-transclude- transclude}: false,
	 *       {@link $compile#-restrict- restrict}: 'A',
	 *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
	 *       {@link $compile#-scope- scope}: false,
	 *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
	 *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
	 *       {@link $compile#-bindtocontroller- bindToController}: false,
	 *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
	 *       {@link $compile#-multielement- multiElement}: false,
	 *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
	 *         return {
	 *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *         }
	 *         // or
	 *         // return function postLink( ... ) { ... }
	 *       },
	 *       // or
	 *       // {@link $compile#-link- link}: {
	 *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
	 *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
	 *       // }
	 *       // or
	 *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *   });
	 * ```
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Any unspecified options will use the default value. You can see the default values below.
	 * </div>
	 *
	 * Therefore the above can be simplified as:
	 *
	 * ```js
	 *   var myModule = angular.module(...);
	 *
	 *   myModule.directive('directiveName', function factory(injectables) {
	 *     var directiveDefinitionObject = {
	 *       link: function postLink(scope, iElement, iAttrs) { ... }
	 *     };
	 *     return directiveDefinitionObject;
	 *     // or
	 *     // return function postLink(scope, iElement, iAttrs) { ... }
	 *   });
	 * ```
	 *
	 * ### Life-cycle hooks
	 * Directive controllers can provide the following methods that are called by Angular at points in the life-cycle of the
	 * directive:
	 * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
	 *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
	 *   this element). This is a good place to put initialization code for your controller.
	 * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
	 *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
	 *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
	 *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
	 *   also be called when your bindings are initialized.
	 * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
	 *   changes. Any actions that you wish to take in response to the changes that you detect must be
	 *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
	 *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
	 *   be detected by Angular's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
	 *   if detecting changes, you must store the previous value(s) for comparison to the current values.
	 * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
	 *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
	 *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
	 *   components will have their `$onDestroy()` hook called before child components.
	 * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
	 *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
	 *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
	 *   they are waiting for their template to load asynchronously and their own compilation and linking has been
	 *   suspended until that occurs.
	 *
	 * #### Comparison with Angular 2 life-cycle hooks
	 * Angular 2 also uses life-cycle hooks for its components. While the Angular 1 life-cycle hooks are similar there are
	 * some differences that you should be aware of, especially when it comes to moving your code from Angular 1 to Angular 2:
	 *
	 * * Angular 1 hooks are prefixed with `$`, such as `$onInit`. Angular 2 hooks are prefixed with `ng`, such as `ngOnInit`.
	 * * Angular 1 hooks can be defined on the controller prototype or added to the controller inside its constructor.
	 *   In Angular 2 you can only define hooks on the prototype of the Component class.
	 * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in Angular 1 than you would to
	 *   `ngDoCheck` in Angular 2
	 * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
	 *   propagated throughout the application.
	 *   Angular 2 does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
	 *   error or do nothing depending upon the state of `enableProdMode()`.
	 *
	 * #### Life-cycle hook examples
	 *
	 * This example shows how you can check for mutations to a Date object even though the identity of the object
	 * has not changed.
	 *
	 * <example name="doCheckDateExample" module="do-check-module">
	 *   <file name="app.js">
	 *     angular.module('do-check-module', [])
	 *       .component('app', {
	 *         template:
	 *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
	 *           'Date: {{ $ctrl.date }}' +
	 *           '<test date="$ctrl.date"></test>',
	 *         controller: function() {
	 *           this.date = new Date();
	 *           this.month = this.date.getMonth();
	 *           this.updateDate = function() {
	 *             this.date.setMonth(this.month);
	 *           };
	 *         }
	 *       })
	 *       .component('test', {
	 *         bindings: { date: '<' },
	 *         template:
	 *           '<pre>{{ $ctrl.log | json }}</pre>',
	 *         controller: function() {
	 *           var previousValue;
	 *           this.log = [];
	 *           this.$doCheck = function() {
	 *             var currentValue = this.date && this.date.valueOf();
	 *             if (previousValue !== currentValue) {
	 *               this.log.push('doCheck: date mutated: ' + this.date);
	 *               previousValue = currentValue;
	 *             }
	 *           };
	 *         }
	 *       });
	 *   </file>
	 *   <file name="index.html">
	 *     <app></app>
	 *   </file>
	 * </example>
	 *
	 * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
	 * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
	 * arrays or objects can have a negative impact on your application performance)
	 *
	 * <example name="doCheckArrayExample" module="do-check-module">
	 *   <file name="index.html">
	 *     <div ng-init="items = []">
	 *       <button ng-click="items.push(items.length)">Add Item</button>
	 *       <button ng-click="items = []">Reset Items</button>
	 *       <pre>{{ items }}</pre>
	 *       <test items="items"></test>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *      angular.module('do-check-module', [])
	 *        .component('test', {
	 *          bindings: { items: '<' },
	 *          template:
	 *            '<pre>{{ $ctrl.log | json }}</pre>',
	 *          controller: function() {
	 *            this.log = [];
	 *
	 *            this.$doCheck = function() {
	 *              if (this.items_ref !== this.items) {
	 *                this.log.push('doCheck: items changed');
	 *                this.items_ref = this.items;
	 *              }
	 *              if (!angular.equals(this.items_clone, this.items)) {
	 *                this.log.push('doCheck: items mutated');
	 *                this.items_clone = angular.copy(this.items);
	 *              }
	 *            };
	 *          }
	 *        });
	 *   </file>
	 * </example>
	 *
	 *
	 * ### Directive Definition Object
	 *
	 * The directive definition object provides instructions to the {@link ng.$compile
	 * compiler}. The attributes are:
	 *
	 * #### `multiElement`
	 * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
	 * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
	 * together as the directive elements. It is recommended that this feature be used on directives
	 * which are not strictly behavioral (such as {@link ngClick}), and which
	 * do not manipulate or replace child nodes (such as {@link ngInclude}).
	 *
	 * #### `priority`
	 * When there are multiple directives defined on a single DOM element, sometimes it
	 * is necessary to specify the order in which the directives are applied. The `priority` is used
	 * to sort the directives before their `compile` functions get called. Priority is defined as a
	 * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
	 * are also run in priority order, but post-link functions are run in reverse order. The order
	 * of directives with the same priority is undefined. The default priority is `0`.
	 *
	 * #### `terminal`
	 * If set to true then the current `priority` will be the last set of directives
	 * which will execute (any directives at the current priority will still execute
	 * as the order of execution on same `priority` is undefined). Note that expressions
	 * and other directives used in the directive's template will also be excluded from execution.
	 *
	 * #### `scope`
	 * The scope property can be `false`, `true`, or an object:
	 *
	 * * **`false` (default):** No scope will be created for the directive. The directive will use its
	 * parent's scope.
	 *
	 * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
	 * the directive's element. If multiple directives on the same element request a new scope,
	 * only one new scope is created.
	 *
	 * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
	 * The 'isolate' scope differs from normal scope in that it does not prototypically
	 * inherit from its parent scope. This is useful when creating reusable components, which should not
	 * accidentally read or modify data in the parent scope. Note that an isolate scope
	 * directive without a `template` or `templateUrl` will not apply the isolate scope
	 * to its children elements.
	 *
	 * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
	 * directive's element. These local properties are useful for aliasing values for templates. The keys in
	 * the object hash map to the name of the property on the isolate scope; the values define how the property
	 * is bound to the parent scope, via matching attributes on the directive's element:
	 *
	 * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
	 *   always a string since DOM attributes are strings. If no `attr` name is specified then the
	 *   attribute name is assumed to be the same as the local name. Given `<my-component
	 *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
	 *   the directive's scope property `localName` will reflect the interpolated value of `hello
	 *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
	 *   scope. The `name` is read from the parent scope (not the directive's scope).
	 *
	 * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
	 *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
	 *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
	 *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
	 *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
	 *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
	 *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
	 *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
	 *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
	 *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
	 *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
	 *   method is used for tracking changes, and the equality check is based on object identity.
	 *   However, if an object literal or an array literal is passed as the binding expression, the
	 *   equality check is done by value (using the {@link angular.equals} function). It's also possible
	 *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
	 *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
	 *
	  * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
	 *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
	 *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
	 *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
	 *
	 *   For example, given `<my-component my-attr="parentModel">` and directive definition of
	 *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
	 *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
	 *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
	 *   two caveats:
	 *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
	 *     sets the same value. That means if your bound value is an object, changes to its properties
	 *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
	 *     2. one-way binding watches changes to the **identity** of the parent value. That means the
	 *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
	 *     to the value has changed. In most cases, this should not be of concern, but can be important
	 *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
	 *     If you now change a property of the object in your parent scope, the change will not be
	 *     propagated to the isolated scope, because the identity of the object on the parent scope
	 *     has not changed. Instead you must assign a new object.
	 *
	 *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
	 *   back to the parent. However, it does not make this completely impossible.
	 *
	 * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
	 *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
	 *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
	 *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
	 *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
	 *   via an expression to the parent scope. This can be done by passing a map of local variable names
	 *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
	 *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
	 *
	 * In general it's possible to apply more than one directive to one element, but there might be limitations
	 * depending on the type of scope required by the directives. The following points will help explain these limitations.
	 * For simplicity only two directives are taken into account, but it is also applicable for several directives:
	 *
	 * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
	 * * **child scope** + **no scope** =>  Both directives will share one single child scope
	 * * **child scope** + **child scope** =>  Both directives will share one single child scope
	 * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
	 * its parent's scope
	 * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
	 * be applied to the same element.
	 * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
	 * cannot be applied to the same element.
	 *
	 *
	 * #### `bindToController`
	 * This property is used to bind scope properties directly to the controller. It can be either
	 * `true` or an object hash with the same format as the `scope` property.
	 *
	 * When an isolate scope is used for a directive (see above), `bindToController: true` will
	 * allow a component to have its properties bound to the controller, rather than to scope.
	 *
	 * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
	 * properties. You can access these bindings once they have been initialized by providing a controller method called
	 * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
	 * initialized.
	 *
	 * <div class="alert alert-warning">
	 * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
	 * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
	 * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
	 * </div>
	 *
	 * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
	 * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
	 * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
	 * scope (useful for component directives).
	 *
	 * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
	 *
	 *
	 * #### `controller`
	 * Controller constructor function. The controller is instantiated before the
	 * pre-linking phase and can be accessed by other directives (see
	 * `require` attribute). This allows the directives to communicate with each other and augment
	 * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
	 *
	 * * `$scope` - Current scope associated with the element
	 * * `$element` - Current element
	 * * `$attrs` - Current attributes object for the element
	 * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
	 *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
	 *    * `scope`: (optional) override the scope.
	 *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
	 *    * `futureParentElement` (optional):
	 *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
	 *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
	 *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
	 *          and when the `cloneLinkingFn` is passed,
	 *          as those elements need to created and cloned in a special way when they are defined outside their
	 *          usual containers (e.g. like `<svg>`).
	 *        * See also the `directive.templateNamespace` property.
	 *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
	 *      then the default transclusion is provided.
	 *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
	 *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
	 *
	 * #### `require`
	 * Require another directive and inject its controller as the fourth argument to the linking function. The
	 * `require` property can be a string, an array or an object:
	 * * a **string** containing the name of the directive to pass to the linking function
	 * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
	 * linking function will be an array of controllers in the same order as the names in the `require` property
	 * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
	 * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
	 * controllers.
	 *
	 * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
	 * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
	 * have been constructed but before `$onInit` is called.
	 * If the name of the required controller is the same as the local name (the key), the name can be
	 * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
	 * See the {@link $compileProvider#component} helper for an example of how this can be used.
	 * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
	 * raised (unless no link function is specified and the required controllers are not being bound to the directive
	 * controller, in which case error checking is skipped). The name can be prefixed with:
	 *
	 * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
	 * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
	 * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
	 * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
	 * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
	 *   `null` to the `link` fn if not found.
	 * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
	 *   `null` to the `link` fn if not found.
	 *
	 *
	 * #### `controllerAs`
	 * Identifier name for a reference to the controller in the directive's scope.
	 * This allows the controller to be referenced from the directive template. This is especially
	 * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
	 * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
	 * `controllerAs` reference might overwrite a property that already exists on the parent scope.
	 *
	 *
	 * #### `restrict`
	 * String of subset of `EACM` which restricts the directive to a specific directive
	 * declaration style. If omitted, the defaults (elements and attributes) are used.
	 *
	 * * `E` - Element name (default): `<my-directive></my-directive>`
	 * * `A` - Attribute (default): `<div my-directive="exp"></div>`
	 * * `C` - Class: `<div class="my-directive: exp;"></div>`
	 * * `M` - Comment: `<!-- directive: my-directive exp -->`
	 *
	 *
	 * #### `templateNamespace`
	 * String representing the document type used by the markup in the template.
	 * AngularJS needs this information as those elements need to be created and cloned
	 * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
	 *
	 * * `html` - All root nodes in the template are HTML. Root nodes may also be
	 *   top-level elements such as `<svg>` or `<math>`.
	 * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
	 * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
	 *
	 * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
	 *
	 * #### `template`
	 * HTML markup that may:
	 * * Replace the contents of the directive's element (default).
	 * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
	 * * Wrap the contents of the directive's element (if `transclude` is true).
	 *
	 * Value may be:
	 *
	 * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
	 * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
	 *   function api below) and returns a string value.
	 *
	 *
	 * #### `templateUrl`
	 * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
	 *
	 * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
	 * for later when the template has been resolved.  In the meantime it will continue to compile and link
	 * sibling and parent elements as though this element had not contained any directives.
	 *
	 * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
	 * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
	 * case when only one deeply nested directive has `templateUrl`.
	 *
	 * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
	 *
	 * You can specify `templateUrl` as a string representing the URL or as a function which takes two
	 * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
	 * a string value representing the url.  In either case, the template URL is passed through {@link
	 * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
	 *
	 *
	 * #### `replace` ([*DEPRECATED*!], will be removed in next major release - i.e. v2.0)
	 * specify what the template should replace. Defaults to `false`.
	 *
	 * * `true` - the template will replace the directive's element.
	 * * `false` - the template will replace the contents of the directive's element.
	 *
	 * The replacement process migrates all of the attributes / classes from the old element to the new
	 * one. See the {@link guide/directive#template-expanding-directive
	 * Directives Guide} for an example.
	 *
	 * There are very few scenarios where element replacement is required for the application function,
	 * the main one being reusable custom components that are used within SVG contexts
	 * (because SVG doesn't work with custom elements in the DOM tree).
	 *
	 * #### `transclude`
	 * Extract the contents of the element where the directive appears and make it available to the directive.
	 * The contents are compiled and provided to the directive as a **transclusion function**. See the
	 * {@link $compile#transclusion Transclusion} section below.
	 *
	 *
	 * #### `compile`
	 *
	 * ```js
	 *   function compile(tElement, tAttrs, transclude) { ... }
	 * ```
	 *
	 * The compile function deals with transforming the template DOM. Since most directives do not do
	 * template transformation, it is not used often. The compile function takes the following arguments:
	 *
	 *   * `tElement` - template element - The element where the directive has been declared. It is
	 *     safe to do template transformation on the element and child elements only.
	 *
	 *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
	 *     between all directive compile functions.
	 *
	 *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
	 *
	 * <div class="alert alert-warning">
	 * **Note:** The template instance and the link instance may be different objects if the template has
	 * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
	 * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
	 * should be done in a linking function rather than in a compile function.
	 * </div>
	
	 * <div class="alert alert-warning">
	 * **Note:** The compile function cannot handle directives that recursively use themselves in their
	 * own templates or compile functions. Compiling these directives results in an infinite loop and
	 * stack overflow errors.
	 *
	 * This can be avoided by manually using $compile in the postLink function to imperatively compile
	 * a directive's template instead of relying on automatic template compilation via `template` or
	 * `templateUrl` declaration or manual compilation inside the compile function.
	 * </div>
	 *
	 * <div class="alert alert-danger">
	 * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
	 *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
	 *   to the link function instead.
	 * </div>
	
	 * A compile function can have a return value which can be either a function or an object.
	 *
	 * * returning a (post-link) function - is equivalent to registering the linking function via the
	 *   `link` property of the config object when the compile function is empty.
	 *
	 * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
	 *   control when a linking function should be called during the linking phase. See info about
	 *   pre-linking and post-linking functions below.
	 *
	 *
	 * #### `link`
	 * This property is used only if the `compile` property is not defined.
	 *
	 * ```js
	 *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
	 * ```
	 *
	 * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
	 * executed after the template has been cloned. This is where most of the directive logic will be
	 * put.
	 *
	 *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
	 *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
	 *
	 *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
	 *     manipulate the children of the element only in `postLink` function since the children have
	 *     already been linked.
	 *
	 *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
	 *     between all directive linking functions.
	 *
	 *   * `controller` - the directive's required controller instance(s) - Instances are shared
	 *     among all directives, which allows the directives to use the controllers as a communication
	 *     channel. The exact value depends on the directive's `require` property:
	 *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
	 *       * `string`: the controller instance
	 *       * `array`: array of controller instances
	 *
	 *     If a required controller cannot be found, and it is optional, the instance is `null`,
	 *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
	 *
	 *     Note that you can also require the directive's own controller - it will be made available like
	 *     any other controller.
	 *
	 *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
	 *     This is the same as the `$transclude` parameter of directive controllers,
	 *     see {@link ng.$compile#-controller- the controller section for details}.
	 *     `function([scope], cloneLinkingFn, futureParentElement)`.
	 *
	 * #### Pre-linking function
	 *
	 * Executed before the child elements are linked. Not safe to do DOM transformation since the
	 * compiler linking function will fail to locate the correct elements for linking.
	 *
	 * #### Post-linking function
	 *
	 * Executed after the child elements are linked.
	 *
	 * Note that child elements that contain `templateUrl` directives will not have been compiled
	 * and linked since they are waiting for their template to load asynchronously and their own
	 * compilation and linking has been suspended until that occurs.
	 *
	 * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
	 * for their async templates to be resolved.
	 *
	 *
	 * ### Transclusion
	 *
	 * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
	 * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
	 * scope from where they were taken.
	 *
	 * Transclusion is used (often with {@link ngTransclude}) to insert the
	 * original contents of a directive's element into a specified place in the template of the directive.
	 * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
	 * content has access to the properties on the scope from which it was taken, even if the directive
	 * has isolated scope.
	 * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
	 *
	 * This makes it possible for the widget to have private state for its template, while the transcluded
	 * content has access to its originating scope.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** When testing an element transclude directive you must not place the directive at the root of the
	 * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
	 * Testing Transclusion Directives}.
	 * </div>
	 *
	 * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
	 * directive's element, the entire element or multiple parts of the element contents:
	 *
	 * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
	 * * `'element'` - transclude the whole of the directive's element including any directives on this
	 *   element that defined at a lower priority than this directive. When used, the `template`
	 *   property is ignored.
	 * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
	 *
	 * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
	 *
	 * This object is a map where the keys are the name of the slot to fill and the value is an element selector
	 * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
	 * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
	 *
	 * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	 *
	 * If the element selector is prefixed with a `?` then that slot is optional.
	 *
	 * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
	 * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
	 *
	 * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
	 * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
	 * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
	 * injectable into the directive's controller.
	 *
	 *
	 * #### Transclusion Functions
	 *
	 * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
	 * function** to the directive's `link` function and `controller`. This transclusion function is a special
	 * **linking function** that will return the compiled contents linked to a new transclusion scope.
	 *
	 * <div class="alert alert-info">
	 * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
	 * ngTransclude will deal with it for us.
	 * </div>
	 *
	 * If you want to manually control the insertion and removal of the transcluded content in your directive
	 * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
	 * object that contains the compiled DOM, which is linked to the correct transclusion scope.
	 *
	 * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
	 * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
	 * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
	 * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
	 * </div>
	 *
	 * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
	 * attach function**:
	 *
	 * ```js
	 * var transcludedContent, transclusionScope;
	 *
	 * $transclude(function(clone, scope) {
	 *   element.append(clone);
	 *   transcludedContent = clone;
	 *   transclusionScope = scope;
	 * });
	 * ```
	 *
	 * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
	 * associated transclusion scope:
	 *
	 * ```js
	 * transcludedContent.remove();
	 * transclusionScope.$destroy();
	 * ```
	 *
	 * <div class="alert alert-info">
	 * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
	 * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
	 * then you are also responsible for calling `$destroy` on the transclusion scope.
	 * </div>
	 *
	 * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
	 * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
	 * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
	 *
	 *
	 * #### Transclusion Scopes
	 *
	 * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
	 * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
	 * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
	 * was taken.
	 *
	 * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
	 * like this:
	 *
	 * ```html
	 * <div ng-app>
	 *   <div isolate>
	 *     <div transclusion>
	 *     </div>
	 *   </div>
	 * </div>
	 * ```
	 *
	 * The `$parent` scope hierarchy will look like this:
	 *
	   ```
	   - $rootScope
	     - isolate
	       - transclusion
	   ```
	 *
	 * but the scopes will inherit prototypically from different scopes to their `$parent`.
	 *
	   ```
	   - $rootScope
	     - transclusion
	   - isolate
	   ```
	 *
	 *
	 * ### Attributes
	 *
	 * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
	 * `link()` or `compile()` functions. It has a variety of uses.
	 *
	 * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
	 *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
	 *   to the attributes.
	 *
	 * * *Directive inter-communication:* All directives share the same instance of the attributes
	 *   object which allows the directives to use the attributes object as inter directive
	 *   communication.
	 *
	 * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
	 *   allowing other directives to read the interpolated value.
	 *
	 * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
	 *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
	 *   the only way to easily get the actual value because during the linking phase the interpolation
	 *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
	 *
	 * ```js
	 * function linkingFn(scope, elm, attrs, ctrl) {
	 *   // get the attribute value
	 *   console.log(attrs.ngModel);
	 *
	 *   // change the attribute
	 *   attrs.$set('ngModel', 'new value');
	 *
	 *   // observe changes to interpolated attribute
	 *   attrs.$observe('ngModel', function(value) {
	 *     console.log('ngModel has changed value to ' + value);
	 *   });
	 * }
	 * ```
	 *
	 * ## Example
	 *
	 * <div class="alert alert-warning">
	 * **Note**: Typically directives are registered with `module.directive`. The example below is
	 * to illustrate how `$compile` works.
	 * </div>
	 *
	 <example module="compileExample" name="compile">
	   <file name="index.html">
	    <script>
	      angular.module('compileExample', [], function($compileProvider) {
	        // configure new 'compile' directive by passing a directive
	        // factory function. The factory function injects the '$compile'
	        $compileProvider.directive('compile', function($compile) {
	          // directive factory creates a link function
	          return function(scope, element, attrs) {
	            scope.$watch(
	              function(scope) {
	                 // watch the 'compile' expression for changes
	                return scope.$eval(attrs.compile);
	              },
	              function(value) {
	                // when the 'compile' expression changes
	                // assign it into the current DOM
	                element.html(value);
	
	                // compile the new DOM and link it to the current
	                // scope.
	                // NOTE: we only compile .childNodes so that
	                // we don't get into infinite loop compiling ourselves
	                $compile(element.contents())(scope);
	              }
	            );
	          };
	        });
	      })
	      .controller('GreeterController', ['$scope', function($scope) {
	        $scope.name = 'Angular';
	        $scope.html = 'Hello {{name}}';
	      }]);
	    </script>
	    <div ng-controller="GreeterController">
	      <input ng-model="name"> <br/>
	      <textarea ng-model="html"></textarea> <br/>
	      <div compile="html"></div>
	    </div>
	   </file>
	   <file name="protractor.js" type="protractor">
	     it('should auto compile', function() {
	       var textarea = $('textarea');
	       var output = $('div[compile]');
	       // The initial state reads 'Hello Angular'.
	       expect(output.getText()).toBe('Hello Angular');
	       textarea.clear();
	       textarea.sendKeys('{{name}}!');
	       expect(output.getText()).toBe('Angular!');
	     });
	   </file>
	 </example>
	
	 *
	 *
	 * @param {string|DOMElement} element Element or HTML string to compile into a template function.
	 * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
	 *
	 * <div class="alert alert-danger">
	 * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
	 *   e.g. will not use the right outer scope. Please pass the transclude function as a
	 *   `parentBoundTranscludeFn` to the link function instead.
	 * </div>
	 *
	 * @param {number} maxPriority only apply directives lower than given priority (Only effects the
	 *                 root element(s), not their children)
	 * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
	 * (a DOM element/tree) to a scope. Where:
	 *
	 *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
	 *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
	 *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
	 *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
	 *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
	 *
	 *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
	 *      * `scope` - is the current scope with which the linking function is working with.
	 *
	 *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
	 *  keys may be used to control linking behavior:
	 *
	 *      * `parentBoundTranscludeFn` - the transclude function made available to
	 *        directives; if given, it will be passed through to the link functions of
	 *        directives found in `element` during compilation.
	 *      * `transcludeControllers` - an object hash with keys that map controller names
	 *        to a hash with the key `instance`, which maps to the controller instance;
	 *        if given, it will make the controllers available to directives on the compileNode:
	 *        ```
	 *        {
	 *          parent: {
	 *            instance: parentControllerInstance
	 *          }
	 *        }
	 *        ```
	 *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
	 *        the cloned elements; only needed for transcludes that are allowed to contain non html
	 *        elements (e.g. SVG elements). See also the directive.controller property.
	 *
	 * Calling the linking function returns the element of the template. It is either the original
	 * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
	 *
	 * After linking the view is not updated until after a call to $digest which typically is done by
	 * Angular automatically.
	 *
	 * If you need access to the bound view, there are two ways to do it:
	 *
	 * - If you are not asking the linking function to clone the template, create the DOM element(s)
	 *   before you send them to the compiler and keep this reference around.
	 *   ```js
	 *     var element = $compile('<p>{{total}}</p>')(scope);
	 *   ```
	 *
	 * - if on the other hand, you need the element to be cloned, the view reference from the original
	 *   example would not point to the clone, but rather to the original template that was cloned. In
	 *   this case, you can access the clone via the cloneAttachFn:
	 *   ```js
	 *     var templateElement = angular.element('<p>{{total}}</p>'),
	 *         scope = ....;
	 *
	 *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
	 *       //attach the clone to DOM document at the right place
	 *     });
	 *
	 *     //now we have reference to the cloned DOM via `clonedElement`
	 *   ```
	 *
	 *
	 * For information on how the compiler works, see the
	 * {@link guide/compiler Angular HTML Compiler} section of the Developer Guide.
	 *
	 * @knownIssue
	 *
	 * ### Double Compilation
	 *
	   Double compilation occurs when an already compiled part of the DOM gets
	   compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
	   and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
	   section on double compilation} for an in-depth explanation and ways to avoid it.
	 *
	 */
	
	var $compileMinErr = minErr('$compile');
	
	function UNINITIALIZED_VALUE() {}
	var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();
	
	/**
	 * @ngdoc provider
	 * @name $compileProvider
	 *
	 * @description
	 */
	$CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
	/** @this */
	function $CompileProvider($provide, $$sanitizeUriProvider) {
	  var hasDirectives = {},
	      Suffix = 'Directive',
	      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
	      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
	      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
	      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;
	
	  // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
	  // The assumption is that future DOM event attribute names will begin with
	  // 'on' and be composed of only English letters.
	  var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
	  var bindingCache = createMap();
	
	  function parseIsolateBindings(scope, directiveName, isController) {
	    var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;
	
	    var bindings = createMap();
	
	    forEach(scope, function(definition, scopeName) {
	      if (definition in bindingCache) {
	        bindings[scopeName] = bindingCache[definition];
	        return;
	      }
	      var match = definition.match(LOCAL_REGEXP);
	
	      if (!match) {
	        throw $compileMinErr('iscp',
	            'Invalid {3} for directive \'{0}\'.' +
	            ' Definition: {... {1}: \'{2}\' ...}',
	            directiveName, scopeName, definition,
	            (isController ? 'controller bindings definition' :
	            'isolate scope definition'));
	      }
	
	      bindings[scopeName] = {
	        mode: match[1][0],
	        collection: match[2] === '*',
	        optional: match[3] === '?',
	        attrName: match[4] || scopeName
	      };
	      if (match[4]) {
	        bindingCache[definition] = bindings[scopeName];
	      }
	    });
	
	    return bindings;
	  }
	
	  function parseDirectiveBindings(directive, directiveName) {
	    var bindings = {
	      isolateScope: null,
	      bindToController: null
	    };
	    if (isObject(directive.scope)) {
	      if (directive.bindToController === true) {
	        bindings.bindToController = parseIsolateBindings(directive.scope,
	                                                         directiveName, true);
	        bindings.isolateScope = {};
	      } else {
	        bindings.isolateScope = parseIsolateBindings(directive.scope,
	                                                     directiveName, false);
	      }
	    }
	    if (isObject(directive.bindToController)) {
	      bindings.bindToController =
	          parseIsolateBindings(directive.bindToController, directiveName, true);
	    }
	    if (bindings.bindToController && !directive.controller) {
	      // There is no controller
	      throw $compileMinErr('noctrl',
	            'Cannot bind to controller without directive \'{0}\'s controller.',
	            directiveName);
	    }
	    return bindings;
	  }
	
	  function assertValidDirectiveName(name) {
	    var letter = name.charAt(0);
	    if (!letter || letter !== lowercase(letter)) {
	      throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
	    }
	    if (name !== name.trim()) {
	      throw $compileMinErr('baddir',
	            'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces',
	            name);
	    }
	  }
	
	  function getDirectiveRequire(directive) {
	    var require = directive.require || (directive.controller && directive.name);
	
	    if (!isArray(require) && isObject(require)) {
	      forEach(require, function(value, key) {
	        var match = value.match(REQUIRE_PREFIX_REGEXP);
	        var name = value.substring(match[0].length);
	        if (!name) require[key] = match[0] + key;
	      });
	    }
	
	    return require;
	  }
	
	  function getDirectiveRestrict(restrict, name) {
	    if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
	      throw $compileMinErr('badrestrict',
	          'Restrict property \'{0}\' of directive \'{1}\' is invalid',
	          restrict,
	          name);
	    }
	
	    return restrict || 'EA';
	  }
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#directive
	   * @kind function
	   *
	   * @description
	   * Register a new directive with the compiler.
	   *
	   * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
	   *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
	   *    names and the values are the factories.
	   * @param {Function|Array} directiveFactory An injectable directive factory function. See the
	   *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
	   * @returns {ng.$compileProvider} Self for chaining.
	   */
	  this.directive = function registerDirective(name, directiveFactory) {
	    assertArg(name, 'name');
	    assertNotHasOwnProperty(name, 'directive');
	    if (isString(name)) {
	      assertValidDirectiveName(name);
	      assertArg(directiveFactory, 'directiveFactory');
	      if (!hasDirectives.hasOwnProperty(name)) {
	        hasDirectives[name] = [];
	        $provide.factory(name + Suffix, ['$injector', '$exceptionHandler',
	          function($injector, $exceptionHandler) {
	            var directives = [];
	            forEach(hasDirectives[name], function(directiveFactory, index) {
	              try {
	                var directive = $injector.invoke(directiveFactory);
	                if (isFunction(directive)) {
	                  directive = { compile: valueFn(directive) };
	                } else if (!directive.compile && directive.link) {
	                  directive.compile = valueFn(directive.link);
	                }
	                directive.priority = directive.priority || 0;
	                directive.index = index;
	                directive.name = directive.name || name;
	                directive.require = getDirectiveRequire(directive);
	                directive.restrict = getDirectiveRestrict(directive.restrict, name);
	                directive.$$moduleName = directiveFactory.$$moduleName;
	                directives.push(directive);
	              } catch (e) {
	                $exceptionHandler(e);
	              }
	            });
	            return directives;
	          }]);
	      }
	      hasDirectives[name].push(directiveFactory);
	    } else {
	      forEach(name, reverseParams(registerDirective));
	    }
	    return this;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#component
	   * @module ng
	   * @param {string} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`)
	   * @param {Object} options Component definition object (a simplified
	   *    {@link ng.$compile#directive-definition-object directive definition object}),
	   *    with the following properties (all optional):
	   *
	   *    - `controller` – `{(string|function()=}` – controller constructor function that should be
	   *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
	   *      registered controller} if passed as a string. An empty `noop` function by default.
	   *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
	   *      If present, the controller will be published to scope under the `controllerAs` name.
	   *      If not present, this will default to be `$ctrl`.
	   *    - `template` – `{string=|function()=}` – html template as a string or a function that
	   *      returns an html template as a string which should be used as the contents of this component.
	   *      Empty string by default.
	   *
	   *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
	   *      template that should be used  as the contents of this component.
	   *
	   *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
	   *      the following locals:
	   *
	   *      - `$element` - Current element
	   *      - `$attrs` - Current attributes object for the element
	   *
	   *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
	   *      Component properties are always bound to the component controller and not to the scope.
	   *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
	   *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
	   *      Disabled by default.
	   *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
	   *      this component's controller. The object keys specify the property names under which the required
	   *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
	   *    - `$...` – additional properties to attach to the directive factory function and the controller
	   *      constructor function. (This is used by the component router to annotate)
	   *
	   * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
	   * @description
	   * Register a **component definition** with the compiler. This is a shorthand for registering a special
	   * type of directive, which represents a self-contained UI component in your application. Such components
	   * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
	   *
	   * Component definitions are very simple and do not require as much configuration as defining general
	   * directives. Component definitions usually consist only of a template and a controller backing it.
	   *
	   * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
	   * `bindToController`. They always have **isolate scope** and are restricted to elements.
	   *
	   * Here are a few examples of how you would usually define components:
	   *
	   * ```js
	   *   var myMod = angular.module(...);
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     controller: function() {
	   *       this.name = 'shahar';
	   *     }
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     template: '<div>My name is {{$ctrl.name}}</div>',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   *   myMod.component('myComp', {
	   *     templateUrl: 'views/my-comp.html',
	   *     controller: 'MyCtrl',
	   *     controllerAs: 'ctrl',
	   *     bindings: {name: '@'}
	   *   });
	   *
	   * ```
	   * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
	   *
	   * <br />
	   * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
	   */
	  this.component = function registerComponent(name, options) {
	    var controller = options.controller || function() {};
	
	    function factory($injector) {
	      function makeInjectable(fn) {
	        if (isFunction(fn) || isArray(fn)) {
	          return /** @this */ function(tElement, tAttrs) {
	            return $injector.invoke(fn, this, {$element: tElement, $attrs: tAttrs});
	          };
	        } else {
	          return fn;
	        }
	      }
	
	      var template = (!options.template && !options.templateUrl ? '' : options.template);
	      var ddo = {
	        controller: controller,
	        controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
	        template: makeInjectable(template),
	        templateUrl: makeInjectable(options.templateUrl),
	        transclude: options.transclude,
	        scope: {},
	        bindToController: options.bindings || {},
	        restrict: 'E',
	        require: options.require
	      };
	
	      // Copy annotations (starting with $) over to the DDO
	      forEach(options, function(val, key) {
	        if (key.charAt(0) === '$') ddo[key] = val;
	      });
	
	      return ddo;
	    }
	
	    // TODO(pete) remove the following `forEach` before we release 1.6.0
	    // The component-router@0.2.0 looks for the annotations on the controller constructor
	    // Nothing in Angular looks for annotations on the factory function but we can't remove
	    // it from 1.5.x yet.
	
	    // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
	    // These could be used by libraries such as the new component router
	    forEach(options, function(val, key) {
	      if (key.charAt(0) === '$') {
	        factory[key] = val;
	        // Don't try to copy over annotations to named controller
	        if (isFunction(controller)) controller[key] = val;
	      }
	    });
	
	    factory.$inject = ['$injector'];
	
	    return this.directive(name, factory);
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#aHrefSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at preventing XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
	    }
	  };
	
	
	  /**
	   * @ngdoc method
	   * @name $compileProvider#imgSrcSanitizationWhitelist
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
	      return this;
	    } else {
	      return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#debugInfoEnabled
	   *
	   * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
	   * current debugInfoEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable various debug runtime information in the compiler such as adding
	   * binding information and a reference to the current scope on to DOM elements.
	   * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
	   * * `ng-binding` CSS class
	   * * `$binding` data property containing an array of the binding expressions
	   *
	   * You may want to disable this in production for a significant performance boost. See
	   * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
	   *
	   * The default value is true.
	   */
	  var debugInfoEnabled = true;
	  this.debugInfoEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      debugInfoEnabled = enabled;
	      return this;
	    }
	    return debugInfoEnabled;
	  };
	
	  /**
	   * @ngdoc method
	   * @name  $compileProvider#preAssignBindingsEnabled
	   *
	   * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
	   * current preAssignBindingsEnabled state
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   *
	   * @kind function
	   *
	   * @description
	   * Call this method to enable/disable whether directive controllers are assigned bindings before
	   * calling the controller's constructor.
	   * If enabled (true), the compiler assigns the value of each of the bindings to the
	   * properties of the controller object before the constructor of this object is called.
	   *
	   * If disabled (false), the compiler calls the constructor first before assigning bindings.
	   *
	   * The default value is false.
	   *
	   * @deprecated
	   * sinceVersion="1.6.0"
	   * removeVersion="1.7.0"
	   *
	   * This method and the option to assign the bindings before calling the controller's constructor
	   * will be removed in v1.7.0.
	   */
	  var preAssignBindingsEnabled = false;
	  this.preAssignBindingsEnabled = function(enabled) {
	    if (isDefined(enabled)) {
	      preAssignBindingsEnabled = enabled;
	      return this;
	    }
	    return preAssignBindingsEnabled;
	  };
	
	
	  var TTL = 10;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#onChangesTtl
	   * @description
	   *
	   * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
	   * assuming that the model is unstable.
	   *
	   * The current default is 10 iterations.
	   *
	   * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
	   * in several iterations of calls to these hooks. However if an application needs more than the default 10
	   * iterations to stabilize then you should investigate what is causing the model to continuously change during
	   * the `$onChanges` hook execution.
	   *
	   * Increasing the TTL could have performance implications, so you should not change it without proper justification.
	   *
	   * @param {number} limit The number of `$onChanges` hook iterations.
	   * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
	   */
	  this.onChangesTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	      return this;
	    }
	    return TTL;
	  };
	
	  var commentDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#commentDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on comments should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on comments for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check comments when looking for directives.
	   * This should however only be used if you are sure that no comment directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on comments
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.commentDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      commentDirectivesEnabledConfig = value;
	      return this;
	    }
	    return commentDirectivesEnabledConfig;
	  };
	
	
	  var cssClassDirectivesEnabledConfig = true;
	  /**
	   * @ngdoc method
	   * @name $compileProvider#cssClassDirectivesEnabled
	   * @description
	   *
	   * It indicates to the compiler
	   * whether or not directives on element classes should be compiled.
	   * Defaults to `true`.
	   *
	   * Calling this function with false disables the compilation of directives
	   * on element classes for the whole application.
	   * This results in a compilation performance gain,
	   * as the compiler doesn't have to check element classes when looking for directives.
	   * This should however only be used if you are sure that no class directives are used in
	   * the application (including any 3rd party directives).
	   *
	   * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
	   * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
	   */
	  this.cssClassDirectivesEnabled = function(value) {
	    if (arguments.length) {
	      cssClassDirectivesEnabledConfig = value;
	      return this;
	    }
	    return cssClassDirectivesEnabledConfig;
	  };
	
	  this.$get = [
	            '$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse',
	            '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri',
	    function($injector,   $interpolate,   $exceptionHandler,   $templateRequest,   $parse,
	             $controller,   $rootScope,   $sce,   $animate,   $$sanitizeUri) {
	
	    var SIMPLE_ATTR_NAME = /^\w/;
	    var specialAttrHolder = window.document.createElement('div');
	
	
	    var commentDirectivesEnabled = commentDirectivesEnabledConfig;
	    var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
	
	
	    var onChangesTtl = TTL;
	    // The onChanges hooks should all be run together in a single digest
	    // When changes occur, the call to trigger their hooks will be added to this queue
	    var onChangesQueue;
	
	    // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
	    function flushOnChangesQueue() {
	      try {
	        if (!(--onChangesTtl)) {
	          // We have hit the TTL limit so reset everything
	          onChangesQueue = undefined;
	          throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
	        }
	        // We must run this hook in an apply since the $$postDigest runs outside apply
	        $rootScope.$apply(function() {
	          var errors = [];
	          for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
	            try {
	              onChangesQueue[i]();
	            } catch (e) {
	              errors.push(e);
	            }
	          }
	          // Reset the queue to trigger a new schedule next time there is a change
	          onChangesQueue = undefined;
	          if (errors.length) {
	            throw errors;
	          }
	        });
	      } finally {
	        onChangesTtl++;
	      }
	    }
	
	
	    function Attributes(element, attributesToCopy) {
	      if (attributesToCopy) {
	        var keys = Object.keys(attributesToCopy);
	        var i, l, key;
	
	        for (i = 0, l = keys.length; i < l; i++) {
	          key = keys[i];
	          this[key] = attributesToCopy[key];
	        }
	      } else {
	        this.$attr = {};
	      }
	
	      this.$$element = element;
	    }
	
	    Attributes.prototype = {
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$normalize
	       * @kind function
	       *
	       * @description
	       * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
	       * `data-`) to its normalized, camelCase form.
	       *
	       * Also there is special case for Moz prefix starting with upper case letter.
	       *
	       * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
	       *
	       * @param {string} name Name to normalize
	       */
	      $normalize: directiveNormalize,
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$addClass
	       * @kind function
	       *
	       * @description
	       * Adds the CSS class value specified by the classVal parameter to the element. If animations
	       * are enabled then an animation will be triggered for the class addition.
	       *
	       * @param {string} classVal The className value that will be added to the element
	       */
	      $addClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.addClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$removeClass
	       * @kind function
	       *
	       * @description
	       * Removes the CSS class value specified by the classVal parameter from the element. If
	       * animations are enabled then an animation will be triggered for the class removal.
	       *
	       * @param {string} classVal The className value that will be removed from the element
	       */
	      $removeClass: function(classVal) {
	        if (classVal && classVal.length > 0) {
	          $animate.removeClass(this.$$element, classVal);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$updateClass
	       * @kind function
	       *
	       * @description
	       * Adds and removes the appropriate CSS class values to the element based on the difference
	       * between the new and old CSS class values (specified as newClasses and oldClasses).
	       *
	       * @param {string} newClasses The current CSS className value
	       * @param {string} oldClasses The former CSS className value
	       */
	      $updateClass: function(newClasses, oldClasses) {
	        var toAdd = tokenDifference(newClasses, oldClasses);
	        if (toAdd && toAdd.length) {
	          $animate.addClass(this.$$element, toAdd);
	        }
	
	        var toRemove = tokenDifference(oldClasses, newClasses);
	        if (toRemove && toRemove.length) {
	          $animate.removeClass(this.$$element, toRemove);
	        }
	      },
	
	      /**
	       * Set a normalized attribute on the element in a way such that all directives
	       * can share the attribute. This function properly handles boolean attributes.
	       * @param {string} key Normalized key. (ie ngAttribute)
	       * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
	       * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
	       *     Defaults to true.
	       * @param {string=} attrName Optional none normalized name. Defaults to key.
	       */
	      $set: function(key, value, writeAttr, attrName) {
	        // TODO: decide whether or not to throw an error if "class"
	        //is set through this function since it may cause $updateClass to
	        //become unstable.
	
	        var node = this.$$element[0],
	            booleanKey = getBooleanAttrName(node, key),
	            aliasedKey = getAliasedAttrName(key),
	            observer = key,
	            nodeName;
	
	        if (booleanKey) {
	          this.$$element.prop(key, value);
	          attrName = booleanKey;
	        } else if (aliasedKey) {
	          this[aliasedKey] = value;
	          observer = aliasedKey;
	        }
	
	        this[key] = value;
	
	        // translate normalized key to actual key
	        if (attrName) {
	          this.$attr[key] = attrName;
	        } else {
	          attrName = this.$attr[key];
	          if (!attrName) {
	            this.$attr[key] = attrName = snake_case(key, '-');
	          }
	        }
	
	        nodeName = nodeName_(this.$$element);
	
	        if ((nodeName === 'a' && (key === 'href' || key === 'xlinkHref')) ||
	            (nodeName === 'img' && key === 'src')) {
	          // sanitize a[href] and img[src] values
	          this[key] = value = $$sanitizeUri(value, key === 'src');
	        } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
	          // sanitize img[srcset] values
	          var result = '';
	
	          // first check if there are spaces because it's not the same pattern
	          var trimmedSrcset = trim(value);
	          //                (   999x   ,|   999w   ,|   ,|,   )
	          var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
	          var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;
	
	          // split srcset into tuple of uri and descriptor except for the last item
	          var rawUris = trimmedSrcset.split(pattern);
	
	          // for each tuples
	          var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
	          for (var i = 0; i < nbrUrisWith2parts; i++) {
	            var innerIdx = i * 2;
	            // sanitize the uri
	            result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
	            // add the descriptor
	            result += (' ' + trim(rawUris[innerIdx + 1]));
	          }
	
	          // split the last item into uri and descriptor
	          var lastTuple = trim(rawUris[i * 2]).split(/\s/);
	
	          // sanitize the last uri
	          result += $$sanitizeUri(trim(lastTuple[0]), true);
	
	          // and add the last descriptor if any
	          if (lastTuple.length === 2) {
	            result += (' ' + trim(lastTuple[1]));
	          }
	          this[key] = value = result;
	        }
	
	        if (writeAttr !== false) {
	          if (value === null || isUndefined(value)) {
	            this.$$element.removeAttr(attrName);
	          } else {
	            if (SIMPLE_ATTR_NAME.test(attrName)) {
	              this.$$element.attr(attrName, value);
	            } else {
	              setSpecialAttr(this.$$element[0], attrName, value);
	            }
	          }
	        }
	
	        // fire observers
	        var $$observers = this.$$observers;
	        if ($$observers) {
	          forEach($$observers[observer], function(fn) {
	            try {
	              fn(value);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          });
	        }
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $compile.directive.Attributes#$observe
	       * @kind function
	       *
	       * @description
	       * Observes an interpolated attribute.
	       *
	       * The observer function will be invoked once during the next `$digest` following
	       * compilation. The observer is then invoked whenever the interpolated value
	       * changes.
	       *
	       * @param {string} key Normalized key. (ie ngAttribute) .
	       * @param {function(interpolatedValue)} fn Function that will be called whenever
	                the interpolated value of the attribute changes.
	       *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
	       *        guide} for more info.
	       * @returns {function()} Returns a deregistration function for this observer.
	       */
	      $observe: function(key, fn) {
	        var attrs = this,
	            $$observers = (attrs.$$observers || (attrs.$$observers = createMap())),
	            listeners = ($$observers[key] || ($$observers[key] = []));
	
	        listeners.push(fn);
	        $rootScope.$evalAsync(function() {
	          if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
	            // no one registered attribute interpolation function, so lets call it manually
	            fn(attrs[key]);
	          }
	        });
	
	        return function() {
	          arrayRemove(listeners, fn);
	        };
	      }
	    };
	
	    function setSpecialAttr(element, attrName, value) {
	      // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
	      // so we have to jump through some hoops to get such an attribute
	      // https://github.com/angular/angular.js/pull/13318
	      specialAttrHolder.innerHTML = '<span ' + attrName + '>';
	      var attributes = specialAttrHolder.firstChild.attributes;
	      var attribute = attributes[0];
	      // We have to remove the attribute from its container element before we can add it to the destination element
	      attributes.removeNamedItem(attribute.name);
	      attribute.value = value;
	      element.attributes.setNamedItem(attribute);
	    }
	
	    function safeAddClass($element, className) {
	      try {
	        $element.addClass(className);
	      } catch (e) {
	        // ignore, since it means that we are trying to set class on
	        // SVG element, where class name is read-only.
	      }
	    }
	
	
	    var startSymbol = $interpolate.startSymbol(),
	        endSymbol = $interpolate.endSymbol(),
	        denormalizeTemplate = (startSymbol === '{{' && endSymbol  === '}}')
	            ? identity
	            : function denormalizeTemplate(template) {
	              return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
	        },
	        NG_ATTR_BINDING = /^ngAttr[A-Z]/;
	    var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
	
	    compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
	      var bindings = $element.data('$binding') || [];
	
	      if (isArray(binding)) {
	        bindings = bindings.concat(binding);
	      } else {
	        bindings.push(binding);
	      }
	
	      $element.data('$binding', bindings);
	    } : noop;
	
	    compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
	      safeAddClass($element, 'ng-binding');
	    } : noop;
	
	    compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
	      var dataName = isolated ? (noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope') : '$scope';
	      $element.data(dataName, scope);
	    } : noop;
	
	    compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
	      safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
	    } : noop;
	
	    compile.$$createComment = function(directiveName, comment) {
	      var content = '';
	      if (debugInfoEnabled) {
	        content = ' ' + (directiveName || '') + ': ';
	        if (comment) content += comment + ' ';
	      }
	      return window.document.createComment(content);
	    };
	
	    return compile;
	
	    //================================
	
	    function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective,
	                        previousCompileContext) {
	      if (!($compileNodes instanceof jqLite)) {
	        // jquery always rewraps, whereas we need to preserve the original selector so that we can
	        // modify it.
	        $compileNodes = jqLite($compileNodes);
	      }
	      var compositeLinkFn =
	              compileNodes($compileNodes, transcludeFn, $compileNodes,
	                           maxPriority, ignoreDirective, previousCompileContext);
	      compile.$$addScopeClass($compileNodes);
	      var namespace = null;
	      return function publicLinkFn(scope, cloneConnectFn, options) {
	        if (!$compileNodes) {
	          throw $compileMinErr('multilink', 'This element has already been linked.');
	        }
	        assertArg(scope, 'scope');
	
	        if (previousCompileContext && previousCompileContext.needsNewScope) {
	          // A parent directive did a replace and a directive on this element asked
	          // for transclusion, which caused us to lose a layer of element on which
	          // we could hold the new transclusion scope, so we will create it manually
	          // here.
	          scope = scope.$parent.$new();
	        }
	
	        options = options || {};
	        var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
	          transcludeControllers = options.transcludeControllers,
	          futureParentElement = options.futureParentElement;
	
	        // When `parentBoundTranscludeFn` is passed, it is a
	        // `controllersBoundTransclude` function (it was previously passed
	        // as `transclude` to directive.link) so we must unwrap it to get
	        // its `boundTranscludeFn`
	        if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
	          parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
	        }
	
	        if (!namespace) {
	          namespace = detectNamespaceForChildElements(futureParentElement);
	        }
	        var $linkNode;
	        if (namespace !== 'html') {
	          // When using a directive with replace:true and templateUrl the $compileNodes
	          // (or a child element inside of them)
	          // might change, so we need to recreate the namespace adapted compileNodes
	          // for call to the link function.
	          // Note: This will already clone the nodes...
	          $linkNode = jqLite(
	            wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html())
	          );
	        } else if (cloneConnectFn) {
	          // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
	          // and sometimes changes the structure of the DOM.
	          $linkNode = JQLitePrototype.clone.call($compileNodes);
	        } else {
	          $linkNode = $compileNodes;
	        }
	
	        if (transcludeControllers) {
	          for (var controllerName in transcludeControllers) {
	            $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
	          }
	        }
	
	        compile.$$addScopeInfo($linkNode, scope);
	
	        if (cloneConnectFn) cloneConnectFn($linkNode, scope);
	        if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
	
	        if (!cloneConnectFn) {
	          $compileNodes = compositeLinkFn = null;
	        }
	        return $linkNode;
	      };
	    }
	
	    function detectNamespaceForChildElements(parentElement) {
	      // TODO: Make this detect MathML as well...
	      var node = parentElement && parentElement[0];
	      if (!node) {
	        return 'html';
	      } else {
	        return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
	      }
	    }
	
	    /**
	     * Compile function matches each node in nodeList against the directives. Once all directives
	     * for a particular node are collected their compile functions are executed. The compile
	     * functions return values - the linking functions - are combined into a composite linking
	     * function, which is the a linking function for the node.
	     *
	     * @param {NodeList} nodeList an array of nodes or NodeList to compile
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *        scope argument is auto-generated to the new child of the transcluded parent scope.
	     * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
	     *        the rootElement must be set the jqLite collection of the compile root. This is
	     *        needed so that the jqLite collection items can be replaced with widgets.
	     * @param {number=} maxPriority Max directive priority.
	     * @returns {Function} A composite linking function of all of the matched directives or null.
	     */
	    function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective,
	                            previousCompileContext) {
	      var linkFns = [],
	          // `nodeList` can be either an element's `.childNodes` (live NodeList)
	          // or a jqLite/jQuery collection or an array
	          notLiveList = isArray(nodeList) || (nodeList instanceof jqLite),
	          attrs, directives, nodeLinkFn, childNodes, childLinkFn, linkFnFound, nodeLinkFnFound;
	
	
	      for (var i = 0; i < nodeList.length; i++) {
	        attrs = new Attributes();
	
	        // Support: IE 11 only
	        // Workaround for #11781 and #14924
	        if (msie === 11) {
	          mergeConsecutiveTextNodes(nodeList, i, notLiveList);
	        }
	
	        // We must always refer to `nodeList[i]` hereafter,
	        // since the nodes can be replaced underneath us.
	        directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined,
	                                        ignoreDirective);
	
	        nodeLinkFn = (directives.length)
	            ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement,
	                                      null, [], [], previousCompileContext)
	            : null;
	
	        if (nodeLinkFn && nodeLinkFn.scope) {
	          compile.$$addScopeClass(attrs.$$element);
	        }
	
	        childLinkFn = (nodeLinkFn && nodeLinkFn.terminal ||
	                      !(childNodes = nodeList[i].childNodes) ||
	                      !childNodes.length)
	            ? null
	            : compileNodes(childNodes,
	                 nodeLinkFn ? (
	                  (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement)
	                     && nodeLinkFn.transclude) : transcludeFn);
	
	        if (nodeLinkFn || childLinkFn) {
	          linkFns.push(i, nodeLinkFn, childLinkFn);
	          linkFnFound = true;
	          nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
	        }
	
	        //use the previous context only for the first element in the virtual group
	        previousCompileContext = null;
	      }
	
	      // return a linking function if we have found anything, null otherwise
	      return linkFnFound ? compositeLinkFn : null;
	
	      function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
	        var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
	        var stableNodeList;
	
	
	        if (nodeLinkFnFound) {
	          // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
	          // offsets don't get screwed up
	          var nodeListLength = nodeList.length;
	          stableNodeList = new Array(nodeListLength);
	
	          // create a sparse array by only copying the elements which have a linkFn
	          for (i = 0; i < linkFns.length; i += 3) {
	            idx = linkFns[i];
	            stableNodeList[idx] = nodeList[idx];
	          }
	        } else {
	          stableNodeList = nodeList;
	        }
	
	        for (i = 0, ii = linkFns.length; i < ii;) {
	          node = stableNodeList[linkFns[i++]];
	          nodeLinkFn = linkFns[i++];
	          childLinkFn = linkFns[i++];
	
	          if (nodeLinkFn) {
	            if (nodeLinkFn.scope) {
	              childScope = scope.$new();
	              compile.$$addScopeInfo(jqLite(node), childScope);
	            } else {
	              childScope = scope;
	            }
	
	            if (nodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(
	                  scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
	
	            } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
	              childBoundTranscludeFn = parentBoundTranscludeFn;
	
	            } else if (!parentBoundTranscludeFn && transcludeFn) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
	
	            } else {
	              childBoundTranscludeFn = null;
	            }
	
	            nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
	
	          } else if (childLinkFn) {
	            childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
	          }
	        }
	      }
	    }
	
	    function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
	      var node = nodeList[idx];
	      var parent = node.parentNode;
	      var sibling;
	
	      if (node.nodeType !== NODE_TYPE_TEXT) {
	        return;
	      }
	
	      while (true) {
	        sibling = parent ? node.nextSibling : nodeList[idx + 1];
	        if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
	          break;
	        }
	
	        node.nodeValue = node.nodeValue + sibling.nodeValue;
	
	        if (sibling.parentNode) {
	          sibling.parentNode.removeChild(sibling);
	        }
	        if (notLiveList && sibling === nodeList[idx + 1]) {
	          nodeList.splice(idx + 1, 1);
	        }
	      }
	    }
	
	    function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
	      function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
	
	        if (!transcludedScope) {
	          transcludedScope = scope.$new(false, containingScope);
	          transcludedScope.$$transcluded = true;
	        }
	
	        return transcludeFn(transcludedScope, cloneFn, {
	          parentBoundTranscludeFn: previousBoundTranscludeFn,
	          transcludeControllers: controllers,
	          futureParentElement: futureParentElement
	        });
	      }
	
	      // We need  to attach the transclusion slots onto the `boundTranscludeFn`
	      // so that they are available inside the `controllersBoundTransclude` function
	      var boundSlots = boundTranscludeFn.$$slots = createMap();
	      for (var slotName in transcludeFn.$$slots) {
	        if (transcludeFn.$$slots[slotName]) {
	          boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
	        } else {
	          boundSlots[slotName] = null;
	        }
	      }
	
	      return boundTranscludeFn;
	    }
	
	    /**
	     * Looks for directives on the given node and adds them to the directive collection which is
	     * sorted.
	     *
	     * @param node Node to search.
	     * @param directives An array to which the directives are added to. This array is sorted before
	     *        the function returns.
	     * @param attrs The shared attrs object which is used to populate the normalized attributes.
	     * @param {number=} maxPriority Max directive priority.
	     */
	    function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      var nodeType = node.nodeType,
	          attrsMap = attrs.$attr,
	          match,
	          nodeName,
	          className;
	
	      switch (nodeType) {
	        case NODE_TYPE_ELEMENT: /* Element */
	
	          nodeName = nodeName_(node);
	
	          // use the node name: <directive>
	          addDirective(directives,
	              directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);
	
	          // iterate over the attributes
	          for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes,
	                   j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
	            var attrStartName = false;
	            var attrEndName = false;
	
	            attr = nAttrs[j];
	            name = attr.name;
	            value = attr.value;
	
	            // support ngAttr attribute binding
	            ngAttrName = directiveNormalize(name);
	            isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
	            if (isNgAttr) {
	              name = name.replace(PREFIX_REGEXP, '')
	                .substr(8).replace(/_(.)/g, function(match, letter) {
	                  return letter.toUpperCase();
	                });
	            }
	
	            var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
	            if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
	              attrStartName = name;
	              attrEndName = name.substr(0, name.length - 5) + 'end';
	              name = name.substr(0, name.length - 6);
	            }
	
	            nName = directiveNormalize(name.toLowerCase());
	            attrsMap[nName] = name;
	            if (isNgAttr || !attrs.hasOwnProperty(nName)) {
	                attrs[nName] = value;
	                if (getBooleanAttrName(node, nName)) {
	                  attrs[nName] = true; // presence means true
	                }
	            }
	            addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
	            addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName,
	                          attrEndName);
	          }
	
	          if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
	            // Hidden input elements can have strange behaviour when navigating back to the page
	            // This tells the browser not to try to cache and reinstate previous values
	            node.setAttribute('autocomplete', 'off');
	          }
	
	          // use class as directive
	          if (!cssClassDirectivesEnabled) break;
	          className = node.className;
	          if (isObject(className)) {
	              // Maybe SVGAnimatedString
	              className = className.animVal;
	          }
	          if (isString(className) && className !== '') {
	            while ((match = CLASS_DIRECTIVE_REGEXP.exec(className))) {
	              nName = directiveNormalize(match[2]);
	              if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
	                attrs[nName] = trim(match[3]);
	              }
	              className = className.substr(match.index + match[0].length);
	            }
	          }
	          break;
	        case NODE_TYPE_TEXT: /* Text Node */
	          addTextInterpolateDirective(directives, node.nodeValue);
	          break;
	        case NODE_TYPE_COMMENT: /* Comment */
	          if (!commentDirectivesEnabled) break;
	          collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
	          break;
	      }
	
	      directives.sort(byPriority);
	      return directives;
	    }
	
	    function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
	      // function created because of performance, try/catch disables
	      // the optimization of the whole function #14848
	      try {
	        var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
	        if (match) {
	          var nName = directiveNormalize(match[1]);
	          if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
	            attrs[nName] = trim(match[2]);
	          }
	        }
	      } catch (e) {
	        // turns out that under some circumstances IE9 throws errors when one attempts to read
	        // comment's node value.
	        // Just ignore it and continue. (Can't seem to reproduce in test case.)
	      }
	    }
	
	    /**
	     * Given a node with a directive-start it collects all of the siblings until it finds
	     * directive-end.
	     * @param node
	     * @param attrStart
	     * @param attrEnd
	     * @returns {*}
	     */
	    function groupScan(node, attrStart, attrEnd) {
	      var nodes = [];
	      var depth = 0;
	      if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
	        do {
	          if (!node) {
	            throw $compileMinErr('uterdir',
	                      'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.',
	                      attrStart, attrEnd);
	          }
	          if (node.nodeType === NODE_TYPE_ELEMENT) {
	            if (node.hasAttribute(attrStart)) depth++;
	            if (node.hasAttribute(attrEnd)) depth--;
	          }
	          nodes.push(node);
	          node = node.nextSibling;
	        } while (depth > 0);
	      } else {
	        nodes.push(node);
	      }
	
	      return jqLite(nodes);
	    }
	
	    /**
	     * Wrapper for linking function which converts normal linking function into a grouped
	     * linking function.
	     * @param linkFn
	     * @param attrStart
	     * @param attrEnd
	     * @returns {Function}
	     */
	    function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
	      return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
	        element = groupScan(element[0], attrStart, attrEnd);
	        return linkFn(scope, element, attrs, controllers, transcludeFn);
	      };
	    }
	
	    /**
	     * A function generator that is used to support both eager and lazy compilation
	     * linking function.
	     * @param eager
	     * @param $compileNodes
	     * @param transcludeFn
	     * @param maxPriority
	     * @param ignoreDirective
	     * @param previousCompileContext
	     * @returns {Function}
	     */
	    function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
	      var compiled;
	
	      if (eager) {
	        return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	      }
	      return /** @this */ function lazyCompilation() {
	        if (!compiled) {
	          compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
	
	          // Null out all of these references in order to make them eligible for garbage collection
	          // since this is a potentially long lived closure
	          $compileNodes = transcludeFn = previousCompileContext = null;
	        }
	        return compiled.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Once the directives have been collected, their compile functions are executed. This method
	     * is responsible for inlining directive templates as well as terminating the application
	     * of the directives if the terminal directive has been reached.
	     *
	     * @param {Array} directives Array of collected directives to execute their compile function.
	     *        this needs to be pre-sorted by priority order.
	     * @param {Node} compileNode The raw DOM node to apply the compile functions to
	     * @param {Object} templateAttrs The shared attribute function
	     * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
	     *                                                  scope argument is auto-generated to the new
	     *                                                  child of the transcluded parent scope.
	     * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
	     *                              argument has the root jqLite array so that we can replace nodes
	     *                              on it.
	     * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
	     *                                           compiling the transclusion.
	     * @param {Array.<Function>} preLinkFns
	     * @param {Array.<Function>} postLinkFns
	     * @param {Object} previousCompileContext Context used for previous compilation of the current
	     *                                        node
	     * @returns {Function} linkFn
	     */
	    function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn,
	                                   jqCollection, originalReplaceDirective, preLinkFns, postLinkFns,
	                                   previousCompileContext) {
	      previousCompileContext = previousCompileContext || {};
	
	      var terminalPriority = -Number.MAX_VALUE,
	          newScopeDirective = previousCompileContext.newScopeDirective,
	          controllerDirectives = previousCompileContext.controllerDirectives,
	          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
	          templateDirective = previousCompileContext.templateDirective,
	          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
	          hasTranscludeDirective = false,
	          hasTemplate = false,
	          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
	          $compileNode = templateAttrs.$$element = jqLite(compileNode),
	          directive,
	          directiveName,
	          $template,
	          replaceDirective = originalReplaceDirective,
	          childTranscludeFn = transcludeFn,
	          linkFn,
	          didScanForMultipleTransclusion = false,
	          mightHaveMultipleTransclusionError = false,
	          directiveValue;
	
	      // executes all directives on the current element
	      for (var i = 0, ii = directives.length; i < ii; i++) {
	        directive = directives[i];
	        var attrStart = directive.$$start;
	        var attrEnd = directive.$$end;
	
	        // collect multiblock sections
	        if (attrStart) {
	          $compileNode = groupScan(compileNode, attrStart, attrEnd);
	        }
	        $template = undefined;
	
	        if (terminalPriority > directive.priority) {
	          break; // prevent further processing of directives
	        }
	
	        directiveValue = directive.scope;
	
	        if (directiveValue) {
	
	          // skip the check for directives with async templates, we'll check the derived sync
	          // directive when the template arrives
	          if (!directive.templateUrl) {
	            if (isObject(directiveValue)) {
	              // This directive is trying to add an isolated scope.
	              // Check that there is no scope of any kind already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective,
	                                directive, $compileNode);
	              newIsolateScopeDirective = directive;
	            } else {
	              // This directive is trying to add a child scope.
	              // Check that there is no isolated scope already
	              assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive,
	                                $compileNode);
	            }
	          }
	
	          newScopeDirective = newScopeDirective || directive;
	        }
	
	        directiveName = directive.name;
	
	        // If we encounter a condition that can result in transclusion on the directive,
	        // then scan ahead in the remaining directives for others that may cause a multiple
	        // transclusion error to be thrown during the compilation process.  If a matching directive
	        // is found, then we know that when we encounter a transcluded directive, we need to eagerly
	        // compile the `transclude` function rather than doing it lazily in order to throw
	        // exceptions at the correct time
	        if (!didScanForMultipleTransclusion && ((directive.replace && (directive.templateUrl || directive.template))
	            || (directive.transclude && !directive.$$tlb))) {
	                var candidateDirective;
	
	                for (var scanningIndex = i + 1; (candidateDirective = directives[scanningIndex++]);) {
	                    if ((candidateDirective.transclude && !candidateDirective.$$tlb)
	                        || (candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template))) {
	                        mightHaveMultipleTransclusionError = true;
	                        break;
	                    }
	                }
	
	                didScanForMultipleTransclusion = true;
	        }
	
	        if (!directive.templateUrl && directive.controller) {
	          controllerDirectives = controllerDirectives || createMap();
	          assertNoDuplicate('\'' + directiveName + '\' controller',
	              controllerDirectives[directiveName], directive, $compileNode);
	          controllerDirectives[directiveName] = directive;
	        }
	
	        directiveValue = directive.transclude;
	
	        if (directiveValue) {
	          hasTranscludeDirective = true;
	
	          // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
	          // This option should only be used by directives that know how to safely handle element transclusion,
	          // where the transcluded nodes are added or replaced after linking.
	          if (!directive.$$tlb) {
	            assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
	            nonTlbTranscludeDirective = directive;
	          }
	
	          if (directiveValue === 'element') {
	            hasElementTranscludeDirective = true;
	            terminalPriority = directive.priority;
	            $template = $compileNode;
	            $compileNode = templateAttrs.$$element =
	                jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
	            compileNode = $compileNode[0];
	            replaceWith(jqCollection, sliceArgs($template), compileNode);
	
	            // Support: Chrome < 50
	            // https://github.com/angular/angular.js/issues/14041
	
	            // In the versions of V8 prior to Chrome 50, the document fragment that is created
	            // in the `replaceWith` function is improperly garbage collected despite still
	            // being referenced by the `parentNode` property of all of the child nodes.  By adding
	            // a reference to the fragment via a different property, we can avoid that incorrect
	            // behavior.
	            // TODO: remove this line after Chrome 50 has been released
	            $template[0].$$parentNode = $template[0].parentNode;
	
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority,
	                                        replaceDirective && replaceDirective.name, {
	                                          // Don't pass in:
	                                          // - controllerDirectives - otherwise we'll create duplicates controllers
	                                          // - newIsolateScopeDirective or templateDirective - combining templates with
	                                          //   element transclusion doesn't make sense.
	                                          //
	                                          // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
	                                          // on the same element more than once.
	                                          nonTlbTranscludeDirective: nonTlbTranscludeDirective
	                                        });
	          } else {
	
	            var slots = createMap();
	
	            if (!isObject(directiveValue)) {
	              $template = jqLite(jqLiteClone(compileNode)).contents();
	            } else {
	
	              // We have transclusion slots,
	              // collect them up, compile them and store their transclusion functions
	              $template = [];
	
	              var slotMap = createMap();
	              var filledSlots = createMap();
	
	              // Parse the element selectors
	              forEach(directiveValue, function(elementSelector, slotName) {
	                // If an element selector starts with a ? then it is optional
	                var optional = (elementSelector.charAt(0) === '?');
	                elementSelector = optional ? elementSelector.substring(1) : elementSelector;
	
	                slotMap[elementSelector] = slotName;
	
	                // We explicitly assign `null` since this implies that a slot was defined but not filled.
	                // Later when calling boundTransclusion functions with a slot name we only error if the
	                // slot is `undefined`
	                slots[slotName] = null;
	
	                // filledSlots contains `true` for all slots that are either optional or have been
	                // filled. This is used to check that we have not missed any required slots
	                filledSlots[slotName] = optional;
	              });
	
	              // Add the matching elements into their slot
	              forEach($compileNode.contents(), function(node) {
	                var slotName = slotMap[directiveNormalize(nodeName_(node))];
	                if (slotName) {
	                  filledSlots[slotName] = true;
	                  slots[slotName] = slots[slotName] || [];
	                  slots[slotName].push(node);
	                } else {
	                  $template.push(node);
	                }
	              });
	
	              // Check for required slots that were not filled
	              forEach(filledSlots, function(filled, slotName) {
	                if (!filled) {
	                  throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
	                }
	              });
	
	              for (var slotName in slots) {
	                if (slots[slotName]) {
	                  // Only define a transclusion function if the slot was filled
	                  slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
	                }
	              }
	            }
	
	            $compileNode.empty(); // clear contents
	            childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined,
	                undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope});
	            childTranscludeFn.$$slots = slots;
	          }
	        }
	
	        if (directive.template) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          directiveValue = (isFunction(directive.template))
	              ? directive.template($compileNode, templateAttrs)
	              : directive.template;
	
	          directiveValue = denormalizeTemplate(directiveValue);
	
	          if (directive.replace) {
	            replaceDirective = directive;
	            if (jqLiteIsTextNode(directiveValue)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  directiveName, '');
	            }
	
	            replaceWith(jqCollection, $compileNode, compileNode);
	
	            var newTemplateAttrs = {$attr: {}};
	
	            // combine directives from the original node and from the template:
	            // - take the array of directives for this element
	            // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
	            // - collect directives from the template and sort them by priority
	            // - combine directives as: processed + template + unprocessed
	            var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
	            var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
	
	            if (newIsolateScopeDirective || newScopeDirective) {
	              // The original directive caused the current element to be replaced but this element
	              // also needs to have a new scope, so we need to tell the template directives
	              // that they would need to get their scope from further up, if they require transclusion
	              markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
	            }
	            directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
	            mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
	
	            ii = directives.length;
	          } else {
	            $compileNode.html(directiveValue);
	          }
	        }
	
	        if (directive.templateUrl) {
	          hasTemplate = true;
	          assertNoDuplicate('template', templateDirective, directive, $compileNode);
	          templateDirective = directive;
	
	          if (directive.replace) {
	            replaceDirective = directive;
	          }
	
	          // eslint-disable-next-line no-func-assign
	          nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode,
	              templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
	                controllerDirectives: controllerDirectives,
	                newScopeDirective: (newScopeDirective !== directive) && newScopeDirective,
	                newIsolateScopeDirective: newIsolateScopeDirective,
	                templateDirective: templateDirective,
	                nonTlbTranscludeDirective: nonTlbTranscludeDirective
	              });
	          ii = directives.length;
	        } else if (directive.compile) {
	          try {
	            linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
	            var context = directive.$$originalDirective || directive;
	            if (isFunction(linkFn)) {
	              addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
	            } else if (linkFn) {
	              addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
	            }
	          } catch (e) {
	            $exceptionHandler(e, startingTag($compileNode));
	          }
	        }
	
	        if (directive.terminal) {
	          nodeLinkFn.terminal = true;
	          terminalPriority = Math.max(terminalPriority, directive.priority);
	        }
	
	      }
	
	      nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
	      nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
	      nodeLinkFn.templateOnThisElement = hasTemplate;
	      nodeLinkFn.transclude = childTranscludeFn;
	
	      previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;
	
	      // might be normal or delayed nodeLinkFn depending on if templateUrl is present
	      return nodeLinkFn;
	
	      ////////////////////
	
	      function addLinkFns(pre, post, attrStart, attrEnd) {
	        if (pre) {
	          if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
	          pre.require = directive.require;
	          pre.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            pre = cloneAndAnnotateFn(pre, {isolateScope: true});
	          }
	          preLinkFns.push(pre);
	        }
	        if (post) {
	          if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
	          post.require = directive.require;
	          post.directiveName = directiveName;
	          if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
	            post = cloneAndAnnotateFn(post, {isolateScope: true});
	          }
	          postLinkFns.push(post);
	        }
	      }
	
	      function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
	        var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element,
	            attrs, scopeBindingInfo;
	
	        if (compileNode === linkNode) {
	          attrs = templateAttrs;
	          $element = templateAttrs.$$element;
	        } else {
	          $element = jqLite(linkNode);
	          attrs = new Attributes($element, templateAttrs);
	        }
	
	        controllerScope = scope;
	        if (newIsolateScopeDirective) {
	          isolateScope = scope.$new(true);
	        } else if (newScopeDirective) {
	          controllerScope = scope.$parent;
	        }
	
	        if (boundTranscludeFn) {
	          // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
	          // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
	          transcludeFn = controllersBoundTransclude;
	          transcludeFn.$$boundTransclude = boundTranscludeFn;
	          // expose the slots on the `$transclude` function
	          transcludeFn.isSlotFilled = function(slotName) {
	            return !!boundTranscludeFn.$$slots[slotName];
	          };
	        }
	
	        if (controllerDirectives) {
	          elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
	        }
	
	        if (newIsolateScopeDirective) {
	          // Initialize isolate scope bindings for new isolate scope directive.
	          compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective ||
	              templateDirective === newIsolateScopeDirective.$$originalDirective)));
	          compile.$$addScopeClass($element, true);
	          isolateScope.$$isolateBindings =
	              newIsolateScopeDirective.$$isolateBindings;
	          scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope,
	                                        isolateScope.$$isolateBindings,
	                                        newIsolateScopeDirective);
	          if (scopeBindingInfo.removeWatches) {
	            isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
	          }
	        }
	
	        // Initialize bindToController bindings
	        for (var name in elementControllers) {
	          var controllerDirective = controllerDirectives[name];
	          var controller = elementControllers[name];
	          var bindings = controllerDirective.$$bindings.bindToController;
	
	          if (preAssignBindingsEnabled) {
	            if (bindings) {
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            } else {
	              controller.bindingInfo = {};
	            }
	
	            var controllerResult = controller();
	            if (controllerResult !== controller.instance) {
	              // If the controller constructor has a return value, overwrite the instance
	              // from setupControllers
	              controller.instance = controllerResult;
	              $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
	              if (controller.bindingInfo.removeWatches) {
	                controller.bindingInfo.removeWatches();
	              }
	              controller.bindingInfo =
	                initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	            }
	          } else {
	            controller.instance = controller();
	            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
	            controller.bindingInfo =
	              initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
	          }
	        }
	
	        // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
	        forEach(controllerDirectives, function(controllerDirective, name) {
	          var require = controllerDirective.require;
	          if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
	            extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
	          }
	        });
	
	        // Handle the init and destroy lifecycle hooks on all controllers that have them
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$onChanges)) {
	            try {
	              controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$onInit)) {
	            try {
	              controllerInstance.$onInit();
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          if (isFunction(controllerInstance.$doCheck)) {
	            controllerScope.$watch(function() { controllerInstance.$doCheck(); });
	            controllerInstance.$doCheck();
	          }
	          if (isFunction(controllerInstance.$onDestroy)) {
	            controllerScope.$on('$destroy', function callOnDestroyHook() {
	              controllerInstance.$onDestroy();
	            });
	          }
	        });
	
	        // PRELINKING
	        for (i = 0, ii = preLinkFns.length; i < ii; i++) {
	          linkFn = preLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // RECURSION
	        // We only pass the isolate scope, if the isolate directive has a template,
	        // otherwise the child elements do not belong to the isolate directive.
	        var scopeToChild = scope;
	        if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
	          scopeToChild = isolateScope;
	        }
	        if (childLinkFn) {
	          childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
	        }
	
	        // POSTLINKING
	        for (i = postLinkFns.length - 1; i >= 0; i--) {
	          linkFn = postLinkFns[i];
	          invokeLinkFn(linkFn,
	              linkFn.isolateScope ? isolateScope : scope,
	              $element,
	              attrs,
	              linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers),
	              transcludeFn
	          );
	        }
	
	        // Trigger $postLink lifecycle hooks
	        forEach(elementControllers, function(controller) {
	          var controllerInstance = controller.instance;
	          if (isFunction(controllerInstance.$postLink)) {
	            controllerInstance.$postLink();
	          }
	        });
	
	        // This is the function that is injected as `$transclude`.
	        // Note: all arguments are optional!
	        function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
	          var transcludeControllers;
	          // No scope passed in:
	          if (!isScope(scope)) {
	            slotName = futureParentElement;
	            futureParentElement = cloneAttachFn;
	            cloneAttachFn = scope;
	            scope = undefined;
	          }
	
	          if (hasElementTranscludeDirective) {
	            transcludeControllers = elementControllers;
	          }
	          if (!futureParentElement) {
	            futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
	          }
	          if (slotName) {
	            // slotTranscludeFn can be one of three things:
	            //  * a transclude function - a filled slot
	            //  * `null` - an optional slot that was not filled
	            //  * `undefined` - a slot that was not declared (i.e. invalid)
	            var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
	            if (slotTranscludeFn) {
	              return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	            } else if (isUndefined(slotTranscludeFn)) {
	              throw $compileMinErr('noslot',
	               'No parent directive that requires a transclusion with slot name "{0}". ' +
	               'Element: {1}',
	               slotName, startingTag($element));
	            }
	          } else {
	            return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
	          }
	        }
	      }
	    }
	
	    function getControllers(directiveName, require, $element, elementControllers) {
	      var value;
	
	      if (isString(require)) {
	        var match = require.match(REQUIRE_PREFIX_REGEXP);
	        var name = require.substring(match[0].length);
	        var inheritType = match[1] || match[3];
	        var optional = match[2] === '?';
	
	        //If only parents then start at the parent element
	        if (inheritType === '^^') {
	          $element = $element.parent();
	        //Otherwise attempt getting the controller from elementControllers in case
	        //the element is transcluded (and has no data) and to avoid .data if possible
	        } else {
	          value = elementControllers && elementControllers[name];
	          value = value && value.instance;
	        }
	
	        if (!value) {
	          var dataName = '$' + name + 'Controller';
	          value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
	        }
	
	        if (!value && !optional) {
	          throw $compileMinErr('ctreq',
	              'Controller \'{0}\', required by directive \'{1}\', can\'t be found!',
	              name, directiveName);
	        }
	      } else if (isArray(require)) {
	        value = [];
	        for (var i = 0, ii = require.length; i < ii; i++) {
	          value[i] = getControllers(directiveName, require[i], $element, elementControllers);
	        }
	      } else if (isObject(require)) {
	        value = {};
	        forEach(require, function(controller, property) {
	          value[property] = getControllers(directiveName, controller, $element, elementControllers);
	        });
	      }
	
	      return value || null;
	    }
	
	    function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
	      var elementControllers = createMap();
	      for (var controllerKey in controllerDirectives) {
	        var directive = controllerDirectives[controllerKey];
	        var locals = {
	          $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
	          $element: $element,
	          $attrs: attrs,
	          $transclude: transcludeFn
	        };
	
	        var controller = directive.controller;
	        if (controller === '@') {
	          controller = attrs[directive.name];
	        }
	
	        var controllerInstance = $controller(controller, locals, true, directive.controllerAs);
	
	        // For directives with element transclusion the element is a comment.
	        // In this case .data will not attach any data.
	        // Instead, we save the controllers for the element in a local hash and attach to .data
	        // later, once we have the actual element.
	        elementControllers[directive.name] = controllerInstance;
	        $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
	      }
	      return elementControllers;
	    }
	
	    // Depending upon the context in which a directive finds itself it might need to have a new isolated
	    // or child scope created. For instance:
	    // * if the directive has been pulled into a template because another directive with a higher priority
	    // asked for element transclusion
	    // * if the directive itself asks for transclusion but it is at the root of a template and the original
	    // element was replaced. See https://github.com/angular/angular.js/issues/12936
	    function markDirectiveScope(directives, isolateScope, newScope) {
	      for (var j = 0, jj = directives.length; j < jj; j++) {
	        directives[j] = inherit(directives[j], {$$isolateScope: isolateScope, $$newScope: newScope});
	      }
	    }
	
	    /**
	     * looks up the directive and decorates it with exception handling and proper parameters. We
	     * call this the boundDirective.
	     *
	     * @param {string} name name of the directive to look up.
	     * @param {string} location The directive must be found in specific format.
	     *   String containing any of theses characters:
	     *
	     *   * `E`: element name
	     *   * `A': attribute
	     *   * `C`: class
	     *   * `M`: comment
	     * @returns {boolean} true if directive was added.
	     */
	    function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName,
	                          endAttrName) {
	      if (name === ignoreDirective) return null;
	      var match = null;
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if ((isUndefined(maxPriority) || maxPriority > directive.priority) &&
	               directive.restrict.indexOf(location) !== -1) {
	            if (startAttrName) {
	              directive = inherit(directive, {$$start: startAttrName, $$end: endAttrName});
	            }
	            if (!directive.$$bindings) {
	              var bindings = directive.$$bindings =
	                  parseDirectiveBindings(directive, directive.name);
	              if (isObject(bindings.isolateScope)) {
	                directive.$$isolateBindings = bindings.isolateScope;
	              }
	            }
	            tDirectives.push(directive);
	            match = directive;
	          }
	        }
	      }
	      return match;
	    }
	
	
	    /**
	     * looks up the directive and returns true if it is a multi-element directive,
	     * and therefore requires DOM nodes between -start and -end markers to be grouped
	     * together.
	     *
	     * @param {string} name name of the directive to look up.
	     * @returns true if directive was registered as multi-element.
	     */
	    function directiveIsMultiElement(name) {
	      if (hasDirectives.hasOwnProperty(name)) {
	        for (var directive, directives = $injector.get(name + Suffix),
	            i = 0, ii = directives.length; i < ii; i++) {
	          directive = directives[i];
	          if (directive.multiElement) {
	            return true;
	          }
	        }
	      }
	      return false;
	    }
	
	    /**
	     * When the element is replaced with HTML template then the new attributes
	     * on the template need to be merged with the existing attributes in the DOM.
	     * The desired effect is to have both of the attributes present.
	     *
	     * @param {object} dst destination attributes (original DOM)
	     * @param {object} src source attributes (from the directive template)
	     */
	    function mergeTemplateAttributes(dst, src) {
	      var srcAttr = src.$attr,
	          dstAttr = dst.$attr;
	
	      // reapply the old attributes to the new element
	      forEach(dst, function(value, key) {
	        if (key.charAt(0) !== '$') {
	          if (src[key] && src[key] !== value) {
	            if (value.length) {
	              value += (key === 'style' ? ';' : ' ') + src[key];
	            } else {
	              value = src[key];
	            }
	          }
	          dst.$set(key, value, true, srcAttr[key]);
	        }
	      });
	
	      // copy the new attributes on the old attrs object
	      forEach(src, function(value, key) {
	        // Check if we already set this attribute in the loop above.
	        // `dst` will never contain hasOwnProperty as DOM parser won't let it.
	        // You will get an "InvalidCharacterError: DOM Exception 5" error if you
	        // have an attribute like "has-own-property" or "data-has-own-property", etc.
	        if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
	          dst[key] = value;
	
	          if (key !== 'class' && key !== 'style') {
	            dstAttr[key] = srcAttr[key];
	          }
	        }
	      });
	    }
	
	
	    function compileTemplateUrl(directives, $compileNode, tAttrs,
	        $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
	      var linkQueue = [],
	          afterTemplateNodeLinkFn,
	          afterTemplateChildLinkFn,
	          beforeTemplateCompileNode = $compileNode[0],
	          origAsyncDirective = directives.shift(),
	          derivedSyncDirective = inherit(origAsyncDirective, {
	            templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
	          }),
	          templateUrl = (isFunction(origAsyncDirective.templateUrl))
	              ? origAsyncDirective.templateUrl($compileNode, tAttrs)
	              : origAsyncDirective.templateUrl,
	          templateNamespace = origAsyncDirective.templateNamespace;
	
	      $compileNode.empty();
	
	      $templateRequest(templateUrl)
	        .then(function(content) {
	          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
	
	          content = denormalizeTemplate(content);
	
	          if (origAsyncDirective.replace) {
	            if (jqLiteIsTextNode(content)) {
	              $template = [];
	            } else {
	              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
	            }
	            compileNode = $template[0];
	
	            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
	              throw $compileMinErr('tplrt',
	                  'Template for directive \'{0}\' must have exactly one root element. {1}',
	                  origAsyncDirective.name, templateUrl);
	            }
	
	            tempTemplateAttrs = {$attr: {}};
	            replaceWith($rootElement, $compileNode, compileNode);
	            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
	
	            if (isObject(origAsyncDirective.scope)) {
	              // the original directive that caused the template to be loaded async required
	              // an isolate scope
	              markDirectiveScope(templateDirectives, true);
	            }
	            directives = templateDirectives.concat(directives);
	            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
	          } else {
	            compileNode = beforeTemplateCompileNode;
	            $compileNode.html(content);
	          }
	
	          directives.unshift(derivedSyncDirective);
	
	          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs,
	              childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns,
	              previousCompileContext);
	          forEach($rootElement, function(node, i) {
	            if (node === compileNode) {
	              $rootElement[i] = $compileNode[0];
	            }
	          });
	          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
	
	          while (linkQueue.length) {
	            var scope = linkQueue.shift(),
	                beforeTemplateLinkNode = linkQueue.shift(),
	                linkRootElement = linkQueue.shift(),
	                boundTranscludeFn = linkQueue.shift(),
	                linkNode = $compileNode[0];
	
	            if (scope.$$destroyed) continue;
	
	            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
	              var oldClasses = beforeTemplateLinkNode.className;
	
	              if (!(previousCompileContext.hasElementTranscludeDirective &&
	                  origAsyncDirective.replace)) {
	                // it was cloned therefore we have to clone as well.
	                linkNode = jqLiteClone(compileNode);
	              }
	              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);
	
	              // Copy in CSS classes from original node
	              safeAddClass(jqLite(linkNode), oldClasses);
	            }
	            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	            } else {
	              childBoundTranscludeFn = boundTranscludeFn;
	            }
	            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement,
	              childBoundTranscludeFn);
	          }
	          linkQueue = null;
	        }).catch(function(error) {
	          if (error instanceof Error) {
	            $exceptionHandler(error);
	          }
	        });
	
	      return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
	        var childBoundTranscludeFn = boundTranscludeFn;
	        if (scope.$$destroyed) return;
	        if (linkQueue) {
	          linkQueue.push(scope,
	                         node,
	                         rootElement,
	                         childBoundTranscludeFn);
	        } else {
	          if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
	            childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
	          }
	          afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
	        }
	      };
	    }
	
	
	    /**
	     * Sorting function for bound directives.
	     */
	    function byPriority(a, b) {
	      var diff = b.priority - a.priority;
	      if (diff !== 0) return diff;
	      if (a.name !== b.name) return (a.name < b.name) ? -1 : 1;
	      return a.index - b.index;
	    }
	
	    function assertNoDuplicate(what, previousDirective, directive, element) {
	
	      function wrapModuleNameIfDefined(moduleName) {
	        return moduleName ?
	          (' (module: ' + moduleName + ')') :
	          '';
	      }
	
	      if (previousDirective) {
	        throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}',
	            previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName),
	            directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
	      }
	    }
	
	
	    function addTextInterpolateDirective(directives, text) {
	      var interpolateFn = $interpolate(text, true);
	      if (interpolateFn) {
	        directives.push({
	          priority: 0,
	          compile: function textInterpolateCompileFn(templateNode) {
	            var templateNodeParent = templateNode.parent(),
	                hasCompileParent = !!templateNodeParent.length;
	
	            // When transcluding a template that has bindings in the root
	            // we don't have a parent and thus need to add the class during linking fn.
	            if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
	
	            return function textInterpolateLinkFn(scope, node) {
	              var parent = node.parent();
	              if (!hasCompileParent) compile.$$addBindingClass(parent);
	              compile.$$addBindingInfo(parent, interpolateFn.expressions);
	              scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
	                node[0].nodeValue = value;
	              });
	            };
	          }
	        });
	      }
	    }
	
	
	    function wrapTemplate(type, template) {
	      type = lowercase(type || 'html');
	      switch (type) {
	      case 'svg':
	      case 'math':
	        var wrapper = window.document.createElement('div');
	        wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
	        return wrapper.childNodes[0].childNodes;
	      default:
	        return template;
	      }
	    }
	
	
	    function getTrustedContext(node, attrNormalizedName) {
	      if (attrNormalizedName === 'srcdoc') {
	        return $sce.HTML;
	      }
	      var tag = nodeName_(node);
	      // All tags with src attributes require a RESOURCE_URL value, except for
	      // img and various html5 media tags.
	      if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
	        if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
	          return $sce.RESOURCE_URL;
	        }
	      // maction[xlink:href] can source SVG.  It's not limited to <maction>.
	      } else if (attrNormalizedName === 'xlinkHref' ||
	          (tag === 'form' && attrNormalizedName === 'action') ||
	          // links can be stylesheets or imports, which can run script in the current origin
	          (tag === 'link' && attrNormalizedName === 'href')
	      ) {
	        return $sce.RESOURCE_URL;
	      }
	    }
	
	
	    function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
	      var trustedContext = getTrustedContext(node, name);
	      var mustHaveExpression = !isNgAttr;
	      var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
	
	      var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);
	
	      // no interpolation found -> ignore
	      if (!interpolateFn) return;
	
	      if (name === 'multiple' && nodeName_(node) === 'select') {
	        throw $compileMinErr('selmulti',
	            'Binding to the \'multiple\' attribute is not supported. Element: {0}',
	            startingTag(node));
	      }
	
	      if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
	        throw $compileMinErr('nodomevents',
	            'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' +
	                'ng- versions (such as ng-click instead of onclick) instead.');
	      }
	
	      directives.push({
	        priority: 100,
	        compile: function() {
	            return {
	              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
	                var $$observers = (attr.$$observers || (attr.$$observers = createMap()));
	
	                // If the attribute has changed since last $interpolate()ed
	                var newValue = attr[name];
	                if (newValue !== value) {
	                  // we need to interpolate again since the attribute value has been updated
	                  // (e.g. by another directive's compile function)
	                  // ensure unset/empty values make interpolateFn falsy
	                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
	                  value = newValue;
	                }
	
	                // if attribute was updated so that there is no interpolation going on we don't want to
	                // register any observers
	                if (!interpolateFn) return;
	
	                // initialize attr object so that it's ready in case we need the value for isolate
	                // scope initialization, otherwise the value would not be available from isolate
	                // directive's linking fn during linking phase
	                attr[name] = interpolateFn(scope);
	
	                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
	                (attr.$$observers && attr.$$observers[name].$$scope || scope).
	                  $watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
	                    //special case for class attribute addition + removal
	                    //so that class changes can tap into the animation
	                    //hooks provided by the $animate service. Be sure to
	                    //skip animations when the first digest occurs (when
	                    //both the new and the old values are the same) since
	                    //the CSS classes are the non-interpolated values
	                    if (name === 'class' && newValue !== oldValue) {
	                      attr.$updateClass(newValue, oldValue);
	                    } else {
	                      attr.$set(name, newValue);
	                    }
	                  });
	              }
	            };
	          }
	      });
	    }
	
	
	    /**
	     * This is a special jqLite.replaceWith, which can replace items which
	     * have no parents, provided that the containing jqLite collection is provided.
	     *
	     * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
	     *                               in the root of the tree.
	     * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
	     *                                  the shell, but replace its DOM node reference.
	     * @param {Node} newNode The new DOM node.
	     */
	    function replaceWith($rootElement, elementsToRemove, newNode) {
	      var firstElementToRemove = elementsToRemove[0],
	          removeCount = elementsToRemove.length,
	          parent = firstElementToRemove.parentNode,
	          i, ii;
	
	      if ($rootElement) {
	        for (i = 0, ii = $rootElement.length; i < ii; i++) {
	          if ($rootElement[i] === firstElementToRemove) {
	            $rootElement[i++] = newNode;
	            for (var j = i, j2 = j + removeCount - 1,
	                     jj = $rootElement.length;
	                 j < jj; j++, j2++) {
	              if (j2 < jj) {
	                $rootElement[j] = $rootElement[j2];
	              } else {
	                delete $rootElement[j];
	              }
	            }
	            $rootElement.length -= removeCount - 1;
	
	            // If the replaced element is also the jQuery .context then replace it
	            // .context is a deprecated jQuery api, so we should set it only when jQuery set it
	            // http://api.jquery.com/context/
	            if ($rootElement.context === firstElementToRemove) {
	              $rootElement.context = newNode;
	            }
	            break;
	          }
	        }
	      }
	
	      if (parent) {
	        parent.replaceChild(newNode, firstElementToRemove);
	      }
	
	      // Append all the `elementsToRemove` to a fragment. This will...
	      // - remove them from the DOM
	      // - allow them to still be traversed with .nextSibling
	      // - allow a single fragment.qSA to fetch all elements being removed
	      var fragment = window.document.createDocumentFragment();
	      for (i = 0; i < removeCount; i++) {
	        fragment.appendChild(elementsToRemove[i]);
	      }
	
	      if (jqLite.hasData(firstElementToRemove)) {
	        // Copy over user data (that includes Angular's $scope etc.). Don't copy private
	        // data here because there's no public interface in jQuery to do that and copying over
	        // event listeners (which is the main use of private data) wouldn't work anyway.
	        jqLite.data(newNode, jqLite.data(firstElementToRemove));
	
	        // Remove $destroy event listeners from `firstElementToRemove`
	        jqLite(firstElementToRemove).off('$destroy');
	      }
	
	      // Cleanup any data/listeners on the elements and children.
	      // This includes invoking the $destroy event on any elements with listeners.
	      jqLite.cleanData(fragment.querySelectorAll('*'));
	
	      // Update the jqLite collection to only contain the `newNode`
	      for (i = 1; i < removeCount; i++) {
	        delete elementsToRemove[i];
	      }
	      elementsToRemove[0] = newNode;
	      elementsToRemove.length = 1;
	    }
	
	
	    function cloneAndAnnotateFn(fn, annotation) {
	      return extend(function() { return fn.apply(null, arguments); }, fn, annotation);
	    }
	
	
	    function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
	      try {
	        linkFn(scope, $element, attrs, controllers, transcludeFn);
	      } catch (e) {
	        $exceptionHandler(e, startingTag($element));
	      }
	    }
	
	
	    // Set up $watches for isolate scope and controller bindings.
	    function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
	      var removeWatchCollection = [];
	      var initialChanges = {};
	      var changes;
	      forEach(bindings, function initializeBinding(definition, scopeName) {
	        var attrName = definition.attrName,
	        optional = definition.optional,
	        mode = definition.mode, // @, =, <, or &
	        lastValue,
	        parentGet, parentSet, compare, removeWatch;
	
	        switch (mode) {
	
	          case '@':
	            if (!optional && !hasOwnProperty.call(attrs, attrName)) {
	              destination[scopeName] = attrs[attrName] = undefined;
	            }
	            removeWatch = attrs.$observe(attrName, function(value) {
	              if (isString(value) || isBoolean(value)) {
	                var oldValue = destination[scopeName];
	                recordChanges(scopeName, value, oldValue);
	                destination[scopeName] = value;
	              }
	            });
	            attrs.$$observers[attrName].$$scope = scope;
	            lastValue = attrs[attrName];
	            if (isString(lastValue)) {
	              // If the attribute has been provided then we trigger an interpolation to ensure
	              // the value is there for use in the link fn
	              destination[scopeName] = $interpolate(lastValue)(scope);
	            } else if (isBoolean(lastValue)) {
	              // If the attributes is one of the BOOLEAN_ATTR then Angular will have converted
	              // the value to boolean rather than a string, so we special case this situation
	              destination[scopeName] = lastValue;
	            }
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '=':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            if (parentGet.literal) {
	              compare = equals;
	            } else {
	              compare = simpleCompare;
	            }
	            parentSet = parentGet.assign || function() {
	              // reset the change, or we will throw this exception on every $digest
	              lastValue = destination[scopeName] = parentGet(scope);
	              throw $compileMinErr('nonassign',
	                  'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!',
	                  attrs[attrName], attrName, directive.name);
	            };
	            lastValue = destination[scopeName] = parentGet(scope);
	            var parentValueWatch = function parentValueWatch(parentValue) {
	              if (!compare(parentValue, destination[scopeName])) {
	                // we are out of sync and need to copy
	                if (!compare(parentValue, lastValue)) {
	                  // parent changed and it has precedence
	                  destination[scopeName] = parentValue;
	                } else {
	                  // if the parent can be assigned then do so
	                  parentSet(scope, parentValue = destination[scopeName]);
	                }
	              }
	              lastValue = parentValue;
	              return lastValue;
	            };
	            parentValueWatch.$stateful = true;
	            if (definition.collection) {
	              removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
	            } else {
	              removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
	            }
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '<':
	            if (!hasOwnProperty.call(attrs, attrName)) {
	              if (optional) break;
	              attrs[attrName] = undefined;
	            }
	            if (optional && !attrs[attrName]) break;
	
	            parentGet = $parse(attrs[attrName]);
	            var deepWatch = parentGet.literal;
	
	            var initialValue = destination[scopeName] = parentGet(scope);
	            initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
	
	            removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
	              if (oldValue === newValue) {
	                if (oldValue === initialValue || (deepWatch && equals(oldValue, initialValue))) {
	                  return;
	                }
	                oldValue = initialValue;
	              }
	              recordChanges(scopeName, newValue, oldValue);
	              destination[scopeName] = newValue;
	            }, deepWatch);
	
	            removeWatchCollection.push(removeWatch);
	            break;
	
	          case '&':
	            // Don't assign Object.prototype method to scope
	            parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;
	
	            // Don't assign noop to destination if expression is not valid
	            if (parentGet === noop && optional) break;
	
	            destination[scopeName] = function(locals) {
	              return parentGet(scope, locals);
	            };
	            break;
	        }
	      });
	
	      function recordChanges(key, currentValue, previousValue) {
	        if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
	          // If we have not already scheduled the top level onChangesQueue handler then do so now
	          if (!onChangesQueue) {
	            scope.$$postDigest(flushOnChangesQueue);
	            onChangesQueue = [];
	          }
	          // If we have not already queued a trigger of onChanges for this controller then do so now
	          if (!changes) {
	            changes = {};
	            onChangesQueue.push(triggerOnChangesHook);
	          }
	          // If the has been a change on this property already then we need to reuse the previous value
	          if (changes[key]) {
	            previousValue = changes[key].previousValue;
	          }
	          // Store this change
	          changes[key] = new SimpleChange(previousValue, currentValue);
	        }
	      }
	
	      function triggerOnChangesHook() {
	        destination.$onChanges(changes);
	        // Now clear the changes so that we schedule onChanges when more changes arrive
	        changes = undefined;
	      }
	
	      return {
	        initialChanges: initialChanges,
	        removeWatches: removeWatchCollection.length && function removeWatches() {
	          for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
	            removeWatchCollection[i]();
	          }
	        }
	      };
	    }
	  }];
	}
	
	function SimpleChange(previous, current) {
	  this.previousValue = previous;
	  this.currentValue = current;
	}
	SimpleChange.prototype.isFirstChange = function() { return this.previousValue === _UNINITIALIZED_VALUE; };
	
	
	var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
	var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;
	
	/**
	 * Converts all accepted directives format into proper directive name.
	 * @param name Name to normalize
	 */
	function directiveNormalize(name) {
	  return name
	    .replace(PREFIX_REGEXP, '')
	    .replace(SPECIAL_CHARS_REGEXP, fnCamelCaseReplace);
	}
	
	/**
	 * @ngdoc type
	 * @name $compile.directive.Attributes
	 *
	 * @description
	 * A shared object between directive compile / linking functions which contains normalized DOM
	 * element attributes. The values reflect current binding state `{{ }}`. The normalization is
	 * needed since all of these are treated as equivalent in Angular:
	 *
	 * ```
	 *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
	 * ```
	 */
	
	/**
	 * @ngdoc property
	 * @name $compile.directive.Attributes#$attr
	 *
	 * @description
	 * A map of DOM element attribute names to the normalized name. This is
	 * needed to do reverse lookup from normalized name back to actual name.
	 */
	
	
	/**
	 * @ngdoc method
	 * @name $compile.directive.Attributes#$set
	 * @kind function
	 *
	 * @description
	 * Set DOM element attribute value.
	 *
	 *
	 * @param {string} name Normalized element attribute name of the property to modify. The name is
	 *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
	 *          property to the original name.
	 * @param {string} value Value to set the attribute to. The value can be an interpolated string.
	 */
	
	
	
	/**
	 * Closure compiler type information
	 */
	
	function nodesetLinkingFn(
	  /* angular.Scope */ scope,
	  /* NodeList */ nodeList,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function directiveLinkingFn(
	  /* nodesetLinkingFn */ nodesetLinkingFn,
	  /* angular.Scope */ scope,
	  /* Node */ node,
	  /* Element */ rootElement,
	  /* function(Function) */ boundTranscludeFn
	) {}
	
	function tokenDifference(str1, str2) {
	  var values = '',
	      tokens1 = str1.split(/\s+/),
	      tokens2 = str2.split(/\s+/);
	
	  outer:
	  for (var i = 0; i < tokens1.length; i++) {
	    var token = tokens1[i];
	    for (var j = 0; j < tokens2.length; j++) {
	      if (token === tokens2[j]) continue outer;
	    }
	    values += (values.length > 0 ? ' ' : '') + token;
	  }
	  return values;
	}
	
	function removeComments(jqNodes) {
	  jqNodes = jqLite(jqNodes);
	  var i = jqNodes.length;
	
	  if (i <= 1) {
	    return jqNodes;
	  }
	
	  while (i--) {
	    var node = jqNodes[i];
	    if (node.nodeType === NODE_TYPE_COMMENT ||
	       (node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '')) {
	         splice.call(jqNodes, i, 1);
	    }
	  }
	  return jqNodes;
	}
	
	var $controllerMinErr = minErr('$controller');
	
	
	var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
	function identifierForController(controller, ident) {
	  if (ident && isString(ident)) return ident;
	  if (isString(controller)) {
	    var match = CNTRL_REG.exec(controller);
	    if (match) return match[3];
	  }
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $controllerProvider
	 * @this
	 *
	 * @description
	 * The {@link ng.$controller $controller service} is used by Angular to create new
	 * controllers.
	 *
	 * This provider allows controller registration via the
	 * {@link ng.$controllerProvider#register register} method.
	 */
	function $ControllerProvider() {
	  var controllers = {},
	      globals = false;
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#has
	   * @param {string} name Controller name to check.
	   */
	  this.has = function(name) {
	    return controllers.hasOwnProperty(name);
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#register
	   * @param {string|Object} name Controller name, or an object map of controllers where the keys are
	   *    the names and the values are the constructors.
	   * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
	   *    annotations in the array notation).
	   */
	  this.register = function(name, constructor) {
	    assertNotHasOwnProperty(name, 'controller');
	    if (isObject(name)) {
	      extend(controllers, name);
	    } else {
	      controllers[name] = constructor;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $controllerProvider#allowGlobals
	   * @description If called, allows `$controller` to find controller constructors on `window`
	   *
	   * @deprecated
	   * sinceVersion="v1.3.0"
	   * removeVersion="v1.7.0"
	   * This method of finding controllers has been deprecated.
	   */
	  this.allowGlobals = function() {
	    globals = true;
	  };
	
	
	  this.$get = ['$injector', '$window', function($injector, $window) {
	
	    /**
	     * @ngdoc service
	     * @name $controller
	     * @requires $injector
	     *
	     * @param {Function|string} constructor If called with a function then it's considered to be the
	     *    controller constructor function. Otherwise it's considered to be a string which is used
	     *    to retrieve the controller constructor using the following steps:
	     *
	     *    * check if a controller with given name is registered via `$controllerProvider`
	     *    * check if evaluating the string on the current scope returns a constructor
	     *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
	     *      `window` object (deprecated, not recommended)
	     *
	     *    The string can use the `controller as property` syntax, where the controller instance is published
	     *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
	     *    to work correctly.
	     *
	     * @param {Object} locals Injection locals for Controller.
	     * @return {Object} Instance of given controller.
	     *
	     * @description
	     * `$controller` service is responsible for instantiating controllers.
	     *
	     * It's just a simple call to {@link auto.$injector $injector}, but extracted into
	     * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
	     */
	    return function $controller(expression, locals, later, ident) {
	      // PRIVATE API:
	      //   param `later` --- indicates that the controller's constructor is invoked at a later time.
	      //                     If true, $controller will allocate the object with the correct
	      //                     prototype chain, but will not invoke the controller until a returned
	      //                     callback is invoked.
	      //   param `ident` --- An optional label which overrides the label parsed from the controller
	      //                     expression, if any.
	      var instance, match, constructor, identifier;
	      later = later === true;
	      if (ident && isString(ident)) {
	        identifier = ident;
	      }
	
	      if (isString(expression)) {
	        match = expression.match(CNTRL_REG);
	        if (!match) {
	          throw $controllerMinErr('ctrlfmt',
	            'Badly formed controller string \'{0}\'. ' +
	            'Must match `__name__ as __id__` or `__name__`.', expression);
	        }
	        constructor = match[1];
	        identifier = identifier || match[3];
	        expression = controllers.hasOwnProperty(constructor)
	            ? controllers[constructor]
	            : getter(locals.$scope, constructor, true) ||
	                (globals ? getter($window, constructor, true) : undefined);
	
	        if (!expression) {
	          throw $controllerMinErr('ctrlreg',
	            'The controller with the name \'{0}\' is not registered.', constructor);
	        }
	
	        assertArgFn(expression, constructor, true);
	      }
	
	      if (later) {
	        // Instantiate controller later:
	        // This machinery is used to create an instance of the object before calling the
	        // controller's constructor itself.
	        //
	        // This allows properties to be added to the controller before the constructor is
	        // invoked. Primarily, this is used for isolate scope bindings in $compile.
	        //
	        // This feature is not intended for use by applications, and is thus not documented
	        // publicly.
	        // Object creation: http://jsperf.com/create-constructor/2
	        var controllerPrototype = (isArray(expression) ?
	          expression[expression.length - 1] : expression).prototype;
	        instance = Object.create(controllerPrototype || null);
	
	        if (identifier) {
	          addIdentifier(locals, identifier, instance, constructor || expression.name);
	        }
	
	        return extend(function $controllerInit() {
	          var result = $injector.invoke(expression, instance, locals, constructor);
	          if (result !== instance && (isObject(result) || isFunction(result))) {
	            instance = result;
	            if (identifier) {
	              // If result changed, re-assign controllerAs value to scope.
	              addIdentifier(locals, identifier, instance, constructor || expression.name);
	            }
	          }
	          return instance;
	        }, {
	          instance: instance,
	          identifier: identifier
	        });
	      }
	
	      instance = $injector.instantiate(expression, locals, constructor);
	
	      if (identifier) {
	        addIdentifier(locals, identifier, instance, constructor || expression.name);
	      }
	
	      return instance;
	    };
	
	    function addIdentifier(locals, identifier, instance, name) {
	      if (!(locals && isObject(locals.$scope))) {
	        throw minErr('$controller')('noscp',
	          'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.',
	          name, identifier);
	      }
	
	      locals.$scope[identifier] = instance;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $document
	 * @requires $window
	 * @this
	 *
	 * @description
	 * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
	 *
	 * @example
	   <example module="documentExample" name="document">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <p>$document title: <b ng-bind="title"></b></p>
	         <p>window.document title: <b ng-bind="windowTitle"></b></p>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('documentExample', [])
	         .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
	           $scope.title = $document[0].title;
	           $scope.windowTitle = angular.element(window.document)[0].title;
	         }]);
	     </file>
	   </example>
	 */
	function $DocumentProvider() {
	  this.$get = ['$window', function(window) {
	    return jqLite(window.document);
	  }];
	}
	
	
	/**
	 * @private
	 * @this
	 * Listens for document visibility change and makes the current status accessible.
	 */
	function $$IsDocumentHiddenProvider() {
	  this.$get = ['$document', '$rootScope', function($document, $rootScope) {
	    var doc = $document[0];
	    var hidden = doc && doc.hidden;
	
	    $document.on('visibilitychange', changeListener);
	
	    $rootScope.$on('$destroy', function() {
	      $document.off('visibilitychange', changeListener);
	    });
	
	    function changeListener() {
	      hidden = doc.hidden;
	    }
	
	    return function() {
	      return hidden;
	    };
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $exceptionHandler
	 * @requires ng.$log
	 * @this
	 *
	 * @description
	 * Any uncaught exception in angular expressions is delegated to this service.
	 * The default implementation simply delegates to `$log.error` which logs it into
	 * the browser console.
	 *
	 * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
	 * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
	 *
	 * ## Example:
	 *
	 * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
	 * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
	 * of `$log.error()`.
	 *
	 * ```js
	 *   angular.
	 *     module('exceptionOverwrite', []).
	 *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
	 *       return function myExceptionHandler(exception, cause) {
	 *         logErrorsToBackend(exception, cause);
	 *         $log.warn(exception, cause);
	 *       };
	 *     }]);
	 * ```
	 *
	 * <hr />
	 * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
	 * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
	 * (unless executed during a digest).
	 *
	 * If you wish, you can manually delegate exceptions, e.g.
	 * `try { ... } catch(e) { $exceptionHandler(e); }`
	 *
	 * @param {Error} exception Exception associated with the error.
	 * @param {string=} cause Optional information about the context in which
	 *       the error was thrown.
	 *
	 */
	function $ExceptionHandlerProvider() {
	  this.$get = ['$log', function($log) {
	    return function(exception, cause) {
	      $log.error.apply($log, arguments);
	    };
	  }];
	}
	
	var $$ForceReflowProvider = /** @this */ function() {
	  this.$get = ['$document', function($document) {
	    return function(domNode) {
	      //the line below will force the browser to perform a repaint so
	      //that all the animated elements within the animation frame will
	      //be properly updated and drawn on screen. This is required to
	      //ensure that the preparation animation is properly flushed so that
	      //the active state picks up from there. DO NOT REMOVE THIS LINE.
	      //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
	      //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
	      //WILL TAKE YEARS AWAY FROM YOUR LIFE.
	      if (domNode) {
	        if (!domNode.nodeType && domNode instanceof jqLite) {
	          domNode = domNode[0];
	        }
	      } else {
	        domNode = $document[0].body;
	      }
	      return domNode.offsetWidth + 1;
	    };
	  }];
	};
	
	var APPLICATION_JSON = 'application/json';
	var CONTENT_TYPE_APPLICATION_JSON = {'Content-Type': APPLICATION_JSON + ';charset=utf-8'};
	var JSON_START = /^\[|^\{(?!\{)/;
	var JSON_ENDS = {
	  '[': /]$/,
	  '{': /}$/
	};
	var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
	var $httpMinErr = minErr('$http');
	
	function serializeValue(v) {
	  if (isObject(v)) {
	    return isDate(v) ? v.toISOString() : toJson(v);
	  }
	  return v;
	}
	
	
	/** @this */
	function $HttpParamSerializerProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializer
	   * @description
	   *
	   * Default {@link $http `$http`} params serializer that converts objects to strings
	   * according to the following rules:
	   *
	   * * `{'foo': 'bar'}` results in `foo=bar`
	   * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
	   * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
	   * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
	   *
	   * Note that serializer will sort the request parameters alphabetically.
	   * */
	
	  this.$get = function() {
	    return function ngParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      forEachSorted(params, function(value, key) {
	        if (value === null || isUndefined(value)) return;
	        if (isArray(value)) {
	          forEach(value, function(v) {
	            parts.push(encodeUriQuery(key)  + '=' + encodeUriQuery(serializeValue(v)));
	          });
	        } else {
	          parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
	        }
	      });
	
	      return parts.join('&');
	    };
	  };
	}
	
	/** @this */
	function $HttpParamSerializerJQLikeProvider() {
	  /**
	   * @ngdoc service
	   * @name $httpParamSerializerJQLike
	   *
	   * @description
	   *
	   * Alternative {@link $http `$http`} params serializer that follows
	   * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
	   * The serializer will also sort the params alphabetically.
	   *
	   * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
	   *
	   * ```js
	   * $http({
	   *   url: myUrl,
	   *   method: 'GET',
	   *   params: myParams,
	   *   paramSerializer: '$httpParamSerializerJQLike'
	   * });
	   * ```
	   *
	   * It is also possible to set it as the default `paramSerializer` in the
	   * {@link $httpProvider#defaults `$httpProvider`}.
	   *
	   * Additionally, you can inject the serializer and use it explicitly, for example to serialize
	   * form data for submission:
	   *
	   * ```js
	   * .controller(function($http, $httpParamSerializerJQLike) {
	   *   //...
	   *
	   *   $http({
	   *     url: myUrl,
	   *     method: 'POST',
	   *     data: $httpParamSerializerJQLike(myData),
	   *     headers: {
	   *       'Content-Type': 'application/x-www-form-urlencoded'
	   *     }
	   *   });
	   *
	   * });
	   * ```
	   *
	   * */
	  this.$get = function() {
	    return function jQueryLikeParamSerializer(params) {
	      if (!params) return '';
	      var parts = [];
	      serialize(params, '', true);
	      return parts.join('&');
	
	      function serialize(toSerialize, prefix, topLevel) {
	        if (toSerialize === null || isUndefined(toSerialize)) return;
	        if (isArray(toSerialize)) {
	          forEach(toSerialize, function(value, index) {
	            serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
	          });
	        } else if (isObject(toSerialize) && !isDate(toSerialize)) {
	          forEachSorted(toSerialize, function(value, key) {
	            serialize(value, prefix +
	                (topLevel ? '' : '[') +
	                key +
	                (topLevel ? '' : ']'));
	          });
	        } else {
	          parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
	        }
	      }
	    };
	  };
	}
	
	function defaultHttpResponseTransform(data, headers) {
	  if (isString(data)) {
	    // Strip json vulnerability protection prefix and trim whitespace
	    var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
	
	    if (tempData) {
	      var contentType = headers('Content-Type');
	      if ((contentType && (contentType.indexOf(APPLICATION_JSON) === 0)) || isJsonLike(tempData)) {
	        try {
	          data = fromJson(tempData);
	        } catch (e) {
	          throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' +
	          'Parse error: "{1}"', data, e);
	        }
	      }
	    }
	  }
	
	  return data;
	}
	
	function isJsonLike(str) {
	    var jsonStart = str.match(JSON_START);
	    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
	}
	
	/**
	 * Parse headers into key value object
	 *
	 * @param {string} headers Raw headers as a string
	 * @returns {Object} Parsed headers as key value object
	 */
	function parseHeaders(headers) {
	  var parsed = createMap(), i;
	
	  function fillInParsed(key, val) {
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  }
	
	  if (isString(headers)) {
	    forEach(headers.split('\n'), function(line) {
	      i = line.indexOf(':');
	      fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
	    });
	  } else if (isObject(headers)) {
	    forEach(headers, function(headerVal, headerKey) {
	      fillInParsed(lowercase(headerKey), trim(headerVal));
	    });
	  }
	
	  return parsed;
	}
	
	
	/**
	 * Returns a function that provides access to parsed headers.
	 *
	 * Headers are lazy parsed when first requested.
	 * @see parseHeaders
	 *
	 * @param {(string|Object)} headers Headers to provide access to.
	 * @returns {function(string=)} Returns a getter function which if called with:
	 *
	 *   - if called with an argument returns a single header value or null
	 *   - if called with no arguments returns an object containing all headers.
	 */
	function headersGetter(headers) {
	  var headersObj;
	
	  return function(name) {
	    if (!headersObj) headersObj =  parseHeaders(headers);
	
	    if (name) {
	      var value = headersObj[lowercase(name)];
	      if (value === undefined) {
	        value = null;
	      }
	      return value;
	    }
	
	    return headersObj;
	  };
	}
	
	
	/**
	 * Chain all given functions
	 *
	 * This function is used for both request and response transforming
	 *
	 * @param {*} data Data to transform.
	 * @param {function(string=)} headers HTTP headers getter fn.
	 * @param {number} status HTTP status code of the response.
	 * @param {(Function|Array.<Function>)} fns Function or an array of functions.
	 * @returns {*} Transformed data.
	 */
	function transformData(data, headers, status, fns) {
	  if (isFunction(fns)) {
	    return fns(data, headers, status);
	  }
	
	  forEach(fns, function(fn) {
	    data = fn(data, headers, status);
	  });
	
	  return data;
	}
	
	
	function isSuccess(status) {
	  return 200 <= status && status < 300;
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $httpProvider
	 * @this
	 *
	 * @description
	 * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
	 * */
	function $HttpProvider() {
	  /**
	   * @ngdoc property
	   * @name $httpProvider#defaults
	   * @description
	   *
	   * Object containing default values for all {@link ng.$http $http} requests.
	   *
	   * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
	   * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
	   * by default. See {@link $http#caching $http Caching} for more information.
	   *
	   * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
	   * Defaults value is `'XSRF-TOKEN'`.
	   *
	   * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
	   * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
	   *
	   * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
	   * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
	   * setting default headers.
	   *     - **`defaults.headers.common`**
	   *     - **`defaults.headers.post`**
	   *     - **`defaults.headers.put`**
	   *     - **`defaults.headers.patch`**
	   *
	   *
	   * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
	   *  used to the prepare string representation of request parameters (specified as an object).
	   *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
	   *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
	   *
	   * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
	   * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
	   * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
	   *
	   **/
	  var defaults = this.defaults = {
	    // transform incoming response data
	    transformResponse: [defaultHttpResponseTransform],
	
	    // transform outgoing request data
	    transformRequest: [function(d) {
	      return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
	    }],
	
	    // default headers
	    headers: {
	      common: {
	        'Accept': 'application/json, text/plain, */*'
	      },
	      post:   shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      put:    shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
	      patch:  shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
	    },
	
	    xsrfCookieName: 'XSRF-TOKEN',
	    xsrfHeaderName: 'X-XSRF-TOKEN',
	
	    paramSerializer: '$httpParamSerializer',
	
	    jsonpCallbackParam: 'callback'
	  };
	
	  var useApplyAsync = false;
	  /**
	   * @ngdoc method
	   * @name $httpProvider#useApplyAsync
	   * @description
	   *
	   * Configure $http service to combine processing of multiple http responses received at around
	   * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
	   * significant performance improvement for bigger applications that make many HTTP requests
	   * concurrently (common during application bootstrap).
	   *
	   * Defaults to false. If no value is specified, returns the current configured value.
	   *
	   * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
	   *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
	   *    to load and share the same digest cycle.
	   *
	   * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
	   *    otherwise, returns the current configured value.
	   **/
	  this.useApplyAsync = function(value) {
	    if (isDefined(value)) {
	      useApplyAsync = !!value;
	      return this;
	    }
	    return useApplyAsync;
	  };
	
	  /**
	   * @ngdoc property
	   * @name $httpProvider#interceptors
	   * @description
	   *
	   * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
	   * pre-processing of request or postprocessing of responses.
	   *
	   * These service factories are ordered by request, i.e. they are applied in the same order as the
	   * array, on request, but reverse order, on response.
	   *
	   * {@link ng.$http#interceptors Interceptors detailed info}
	   **/
	  var interceptorFactories = this.interceptors = [];
	
	  this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce',
	      function($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
	
	    var defaultCache = $cacheFactory('$http');
	
	    /**
	     * Make sure that default param serializer is exposed as a function
	     */
	    defaults.paramSerializer = isString(defaults.paramSerializer) ?
	      $injector.get(defaults.paramSerializer) : defaults.paramSerializer;
	
	    /**
	     * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
	     * The reversal is needed so that we can build up the interception chain around the
	     * server request.
	     */
	    var reversedInterceptors = [];
	
	    forEach(interceptorFactories, function(interceptorFactory) {
	      reversedInterceptors.unshift(isString(interceptorFactory)
	          ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
	    });
	
	    /**
	     * @ngdoc service
	     * @kind function
	     * @name $http
	     * @requires ng.$httpBackend
	     * @requires $cacheFactory
	     * @requires $rootScope
	     * @requires $q
	     * @requires $injector
	     *
	     * @description
	     * The `$http` service is a core Angular service that facilitates communication with the remote
	     * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
	     * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
	     *
	     * For unit testing applications that use `$http` service, see
	     * {@link ngMock.$httpBackend $httpBackend mock}.
	     *
	     * For a higher level of abstraction, please check out the {@link ngResource.$resource
	     * $resource} service.
	     *
	     * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
	     * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
	     * it is important to familiarize yourself with these APIs and the guarantees they provide.
	     *
	     *
	     * ## General usage
	     * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
	     * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
	     *
	     * ```js
	     *   // Simple GET request example:
	     *   $http({
	     *     method: 'GET',
	     *     url: '/someUrl'
	     *   }).then(function successCallback(response) {
	     *       // this callback will be called asynchronously
	     *       // when the response is available
	     *     }, function errorCallback(response) {
	     *       // called asynchronously if an error occurs
	     *       // or server returns response with an error status.
	     *     });
	     * ```
	     *
	     * The response object has these properties:
	     *
	     *   - **data** – `{string|Object}` – The response body transformed with the transform
	     *     functions.
	     *   - **status** – `{number}` – HTTP status code of the response.
	     *   - **headers** – `{function([headerName])}` – Header getter function.
	     *   - **config** – `{Object}` – The configuration object that was used to generate the request.
	     *   - **statusText** – `{string}` – HTTP status text of the response.
	     *
	     * A response status code between 200 and 299 is considered a success status and will result in
	     * the success callback being called. Any response status code outside of that range is
	     * considered an error status and will result in the error callback being called.
	     * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
	     * aborted, e.g. using a `config.timeout`.
	     * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
	     * that the outcome (success or error) will be determined by the final response status code.
	     *
	     *
	     * ## Shortcut methods
	     *
	     * Shortcut methods are also available. All shortcut methods require passing in the URL, and
	     * request data must be passed in for POST/PUT requests. An optional config can be passed as the
	     * last argument.
	     *
	     * ```js
	     *   $http.get('/someUrl', config).then(successCallback, errorCallback);
	     *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
	     * ```
	     *
	     * Complete list of shortcut methods:
	     *
	     * - {@link ng.$http#get $http.get}
	     * - {@link ng.$http#head $http.head}
	     * - {@link ng.$http#post $http.post}
	     * - {@link ng.$http#put $http.put}
	     * - {@link ng.$http#delete $http.delete}
	     * - {@link ng.$http#jsonp $http.jsonp}
	     * - {@link ng.$http#patch $http.patch}
	     *
	     *
	     * ## Writing Unit Tests that use $http
	     * When unit testing (using {@link ngMock ngMock}), it is necessary to call
	     * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
	     * request using trained responses.
	     *
	     * ```
	     * $httpBackend.expectGET(...);
	     * $http.get(...);
	     * $httpBackend.flush();
	     * ```
	     *
	     * ## Setting HTTP Headers
	     *
	     * The $http service will automatically add certain HTTP headers to all requests. These defaults
	     * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
	     * object, which currently contains this default configuration:
	     *
	     * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
	     *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
	     * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
	     *   - `Content-Type: application/json`
	     * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
	     *   - `Content-Type: application/json`
	     *
	     * To add or overwrite these defaults, simply add or remove a property from these configuration
	     * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
	     * with the lowercased HTTP method name as the key, e.g.
	     * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
	     *
	     * The defaults can also be set at runtime via the `$http.defaults` object in the same
	     * fashion. For example:
	     *
	     * ```
	     * module.run(function($http) {
	     *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
	     * });
	     * ```
	     *
	     * In addition, you can supply a `headers` property in the config object passed when
	     * calling `$http(config)`, which overrides the defaults without changing them globally.
	     *
	     * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
	     * Use the `headers` property, setting the desired header to `undefined`. For example:
	     *
	     * ```js
	     * var req = {
	     *  method: 'POST',
	     *  url: 'http://example.com',
	     *  headers: {
	     *    'Content-Type': undefined
	     *  },
	     *  data: { test: 'test' }
	     * }
	     *
	     * $http(req).then(function(){...}, function(){...});
	     * ```
	     *
	     * ## Transforming Requests and Responses
	     *
	     * Both requests and responses can be transformed using transformation functions: `transformRequest`
	     * and `transformResponse`. These properties can be a single function that returns
	     * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
	     * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
	     *
	     * <div class="alert alert-warning">
	     * **Note:** Angular does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
	     * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
	     * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
	     * function will be reflected on the scope and in any templates where the object is data-bound.
	     * To prevent this, transform functions should have no side-effects.
	     * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
	     * </div>
	     *
	     * ### Default Transformations
	     *
	     * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
	     * `defaults.transformResponse` properties. If a request does not provide its own transformations
	     * then these will be applied.
	     *
	     * You can augment or replace the default transformations by modifying these properties by adding to or
	     * replacing the array.
	     *
	     * Angular provides the following default transformations:
	     *
	     * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`):
	     *
	     * - If the `data` property of the request configuration object contains an object, serialize it
	     *   into JSON format.
	     *
	     * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`):
	     *
	     *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
	     *  - If JSON response is detected, deserialize it using a JSON parser.
	     *
	     *
	     * ### Overriding the Default Transformations Per Request
	     *
	     * If you wish to override the request/response transformations only for a single request then provide
	     * `transformRequest` and/or `transformResponse` properties on the configuration object passed
	     * into `$http`.
	     *
	     * Note that if you provide these properties on the config object the default transformations will be
	     * overwritten. If you wish to augment the default transformations then you must include them in your
	     * local transformation array.
	     *
	     * The following code demonstrates adding a new response transformation to be run after the default response
	     * transformations have been run.
	     *
	     * ```js
	     * function appendTransform(defaults, transform) {
	     *
	     *   // We can't guarantee that the default transformation is an array
	     *   defaults = angular.isArray(defaults) ? defaults : [defaults];
	     *
	     *   // Append the new transformation to the defaults
	     *   return defaults.concat(transform);
	     * }
	     *
	     * $http({
	     *   url: '...',
	     *   method: 'GET',
	     *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
	     *     return doTransform(value);
	     *   })
	     * });
	     * ```
	     *
	     *
	     * ## Caching
	     *
	     * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
	     * set the config.cache value or the default cache value to TRUE or to a cache object (created
	     * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
	     * precedence over the default cache value.
	     *
	     * In order to:
	     *   * cache all responses - set the default cache value to TRUE or to a cache object
	     *   * cache a specific response - set config.cache value to TRUE or to a cache object
	     *
	     * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
	     * then the default `$cacheFactory("$http")` object is used.
	     *
	     * The default cache value can be set by updating the
	     * {@link ng.$http#defaults `$http.defaults.cache`} property or the
	     * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
	     *
	     * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
	     * the relevant cache object. The next time the same request is made, the response is returned
	     * from the cache without sending a request to the server.
	     *
	     * Take note that:
	     *
	     *   * Only GET and JSONP requests are cached.
	     *   * The cache key is the request URL including search parameters; headers are not considered.
	     *   * Cached responses are returned asynchronously, in the same way as responses from the server.
	     *   * If multiple identical requests are made using the same cache, which is not yet populated,
	     *     one request will be made to the server and remaining requests will return the same response.
	     *   * A cache-control header on the response does not affect if or how responses are cached.
	     *
	     *
	     * ## Interceptors
	     *
	     * Before you start creating interceptors, be sure to understand the
	     * {@link ng.$q $q and deferred/promise APIs}.
	     *
	     * For purposes of global error handling, authentication, or any kind of synchronous or
	     * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
	     * able to intercept requests before they are handed to the server and
	     * responses before they are handed over to the application code that
	     * initiated these requests. The interceptors leverage the {@link ng.$q
	     * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
	     *
	     * The interceptors are service factories that are registered with the `$httpProvider` by
	     * adding them to the `$httpProvider.interceptors` array. The factory is called and
	     * injected with dependencies (if specified) and returns the interceptor.
	     *
	     * There are two kinds of interceptors (and two kinds of rejection interceptors):
	     *
	     *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
	     *     modify the `config` object or create a new one. The function needs to return the `config`
	     *     object directly, or a promise containing the `config` or a new `config` object.
	     *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *   * `response`: interceptors get called with http `response` object. The function is free to
	     *     modify the `response` object or create a new one. The function needs to return the `response`
	     *     object directly, or as a promise containing the `response` or a new `response` object.
	     *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
	     *     resolved with a rejection.
	     *
	     *
	     * ```js
	     *   // register the interceptor as a service
	     *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
	     *     return {
	     *       // optional method
	     *       'request': function(config) {
	     *         // do something on success
	     *         return config;
	     *       },
	     *
	     *       // optional method
	     *      'requestError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       },
	     *
	     *
	     *
	     *       // optional method
	     *       'response': function(response) {
	     *         // do something on success
	     *         return response;
	     *       },
	     *
	     *       // optional method
	     *      'responseError': function(rejection) {
	     *         // do something on error
	     *         if (canRecover(rejection)) {
	     *           return responseOrNewPromise
	     *         }
	     *         return $q.reject(rejection);
	     *       }
	     *     };
	     *   });
	     *
	     *   $httpProvider.interceptors.push('myHttpInterceptor');
	     *
	     *
	     *   // alternatively, register the interceptor via an anonymous factory
	     *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
	     *     return {
	     *      'request': function(config) {
	     *          // same as above
	     *       },
	     *
	     *       'response': function(response) {
	     *          // same as above
	     *       }
	     *     };
	     *   });
	     * ```
	     *
	     * ## Security Considerations
	     *
	     * When designing web applications, consider security threats from:
	     *
	     * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
	     *
	     * Both server and the client must cooperate in order to eliminate these threats. Angular comes
	     * pre-configured with strategies that address these issues, but for this to work backend server
	     * cooperation is required.
	     *
	     * ### JSON Vulnerability Protection
	     *
	     * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
	     * allows third party website to turn your JSON resource URL into
	     * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
	     * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
	     * Angular will automatically strip the prefix before processing it as JSON.
	     *
	     * For example if your server needs to return:
	     * ```js
	     * ['one','two']
	     * ```
	     *
	     * which is vulnerable to attack, your server can return:
	     * ```js
	     * )]}',
	     * ['one','two']
	     * ```
	     *
	     * Angular will strip the prefix, before processing the JSON.
	     *
	     *
	     * ### Cross Site Request Forgery (XSRF) Protection
	     *
	     * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
	     * which the attacker can trick an authenticated user into unknowingly executing actions on your
	     * website. Angular provides a mechanism to counter XSRF. When performing XHR requests, the
	     * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
	     * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
	     * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
	     * The header will not be set for cross-domain requests.
	     *
	     * To take advantage of this, your server needs to set a token in a JavaScript readable session
	     * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
	     * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
	     * that only JavaScript running on your domain could have sent the request. The token must be
	     * unique for each user and must be verifiable by the server (to prevent the JavaScript from
	     * making up its own tokens). We recommend that the token is a digest of your site's
	     * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
	     * for added security.
	     *
	     * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
	     * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
	     * or the per-request config object.
	     *
	     * In order to prevent collisions in environments where multiple Angular apps share the
	     * same domain or subdomain, we recommend that each application uses unique cookie name.
	     *
	     * @param {object} config Object describing the request to be made and how it should be
	     *    processed. The object has following properties:
	     *
	     *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
	     *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
	     *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
	     *      with the `paramSerializer` and appended as GET parameters.
	     *    - **data** – `{string|Object}` – Data to be sent as the request message data.
	     *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
	     *      HTTP headers to send to the server. If the return value of a function is null, the
	     *      header will not be sent. Functions accept a config object as an argument.
	     *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
	     *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
	     *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
	     *      The handler will be called in the context of a `$apply` block.
	     *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
	     *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
	     *    - **transformRequest** –
	     *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      request body and headers and returns its transformed (typically serialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **transformResponse** –
	     *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
	     *      transform function or an array of such functions. The transform function takes the http
	     *      response body, headers and status and returns its transformed (typically deserialized) version.
	     *      See {@link ng.$http#overriding-the-default-transformations-per-request
	     *      Overriding the Default Transformations}
	     *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
	     *      prepare the string representation of request parameters (specified as an object).
	     *      If specified as string, it is interpreted as function registered with the
	     *      {@link $injector $injector}, which means you can create your own serializer
	     *      by registering it as a {@link auto.$provide#service service}.
	     *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
	     *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
	     *    - **cache** – `{boolean|Object}` – A boolean value or object created with
	     *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
	     *      See {@link $http#caching $http Caching} for more information.
	     *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
	     *      that should abort the request when resolved.
	     *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
	     *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
	     *      for more information.
	     *    - **responseType** - `{string}` - see
	     *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
	     *
	     * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
	     *                        when the request succeeds or fails.
	     *
	     *
	     * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
	     *   requests. This is primarily meant to be used for debugging purposes.
	     *
	     *
	     * @example
	<example module="httpExample" name="http-service">
	<file name="index.html">
	  <div ng-controller="FetchController">
	    <select ng-model="method" aria-label="Request method">
	      <option>GET</option>
	      <option>JSONP</option>
	    </select>
	    <input type="text" ng-model="url" size="80" aria-label="URL" />
	    <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
	    <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
	    <button id="samplejsonpbtn"
	      ng-click="updateModel('JSONP',
	                    'https://angularjs.org/greet.php?name=Super%20Hero')">
	      Sample JSONP
	    </button>
	    <button id="invalidjsonpbtn"
	      ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
	        Invalid JSONP
	      </button>
	    <pre>http status code: {{status}}</pre>
	    <pre>http response data: {{data}}</pre>
	  </div>
	</file>
	<file name="script.js">
	  angular.module('httpExample', [])
	    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
	      // We must whitelist the JSONP endpoint that we are using to show that we trust it
	      $sceDelegateProvider.resourceUrlWhitelist([
	        'self',
	        'https://angularjs.org/**'
	      ]);
	    }])
	    .controller('FetchController', ['$scope', '$http', '$templateCache',
	      function($scope, $http, $templateCache) {
	        $scope.method = 'GET';
	        $scope.url = 'http-hello.html';
	
	        $scope.fetch = function() {
	          $scope.code = null;
	          $scope.response = null;
	
	          $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
	            then(function(response) {
	              $scope.status = response.status;
	              $scope.data = response.data;
	            }, function(response) {
	              $scope.data = response.data || 'Request failed';
	              $scope.status = response.status;
	          });
	        };
	
	        $scope.updateModel = function(method, url) {
	          $scope.method = method;
	          $scope.url = url;
	        };
	      }]);
	</file>
	<file name="http-hello.html">
	  Hello, $http!
	</file>
	<file name="protractor.js" type="protractor">
	  var status = element(by.binding('status'));
	  var data = element(by.binding('data'));
	  var fetchBtn = element(by.id('fetchbtn'));
	  var sampleGetBtn = element(by.id('samplegetbtn'));
	  var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
	
	  it('should make an xhr GET request', function() {
	    sampleGetBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('200');
	    expect(data.getText()).toMatch(/Hello, \$http!/);
	  });
	
	// Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
	// it('should make a JSONP request to angularjs.org', function() {
	//   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
	//   sampleJsonpBtn.click();
	//   fetchBtn.click();
	//   expect(status.getText()).toMatch('200');
	//   expect(data.getText()).toMatch(/Super Hero!/);
	// });
	
	  it('should make JSONP request to invalid URL and invoke the error handler',
	      function() {
	    invalidJsonpBtn.click();
	    fetchBtn.click();
	    expect(status.getText()).toMatch('0');
	    expect(data.getText()).toMatch('Request failed');
	  });
	</file>
	</example>
	     */
	    function $http(requestConfig) {
	
	      if (!isObject(requestConfig)) {
	        throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
	      }
	
	      if (!isString($sce.valueOf(requestConfig.url))) {
	        throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
	      }
	
	      var config = extend({
	        method: 'get',
	        transformRequest: defaults.transformRequest,
	        transformResponse: defaults.transformResponse,
	        paramSerializer: defaults.paramSerializer,
	        jsonpCallbackParam: defaults.jsonpCallbackParam
	      }, requestConfig);
	
	      config.headers = mergeHeaders(requestConfig);
	      config.method = uppercase(config.method);
	      config.paramSerializer = isString(config.paramSerializer) ?
	          $injector.get(config.paramSerializer) : config.paramSerializer;
	
	      $browser.$$incOutstandingRequestCount();
	
	      var requestInterceptors = [];
	      var responseInterceptors = [];
	      var promise = $q.resolve(config);
	
	      // apply interceptors
	      forEach(reversedInterceptors, function(interceptor) {
	        if (interceptor.request || interceptor.requestError) {
	          requestInterceptors.unshift(interceptor.request, interceptor.requestError);
	        }
	        if (interceptor.response || interceptor.responseError) {
	          responseInterceptors.push(interceptor.response, interceptor.responseError);
	        }
	      });
	
	      promise = chainInterceptors(promise, requestInterceptors);
	      promise = promise.then(serverRequest);
	      promise = chainInterceptors(promise, responseInterceptors);
	      promise = promise.finally(completeOutstandingRequest);
	
	      return promise;
	
	
	      function chainInterceptors(promise, interceptors) {
	        for (var i = 0, ii = interceptors.length; i < ii;) {
	          var thenFn = interceptors[i++];
	          var rejectFn = interceptors[i++];
	
	          promise = promise.then(thenFn, rejectFn);
	        }
	
	        interceptors.length = 0;
	
	        return promise;
	      }
	
	      function completeOutstandingRequest() {
	        $browser.$$completeOutstandingRequest(noop);
	      }
	
	      function executeHeaderFns(headers, config) {
	        var headerContent, processedHeaders = {};
	
	        forEach(headers, function(headerFn, header) {
	          if (isFunction(headerFn)) {
	            headerContent = headerFn(config);
	            if (headerContent != null) {
	              processedHeaders[header] = headerContent;
	            }
	          } else {
	            processedHeaders[header] = headerFn;
	          }
	        });
	
	        return processedHeaders;
	      }
	
	      function mergeHeaders(config) {
	        var defHeaders = defaults.headers,
	            reqHeaders = extend({}, config.headers),
	            defHeaderName, lowercaseDefHeaderName, reqHeaderName;
	
	        defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);
	
	        // using for-in instead of forEach to avoid unnecessary iteration after header has been found
	        defaultHeadersIteration:
	        for (defHeaderName in defHeaders) {
	          lowercaseDefHeaderName = lowercase(defHeaderName);
	
	          for (reqHeaderName in reqHeaders) {
	            if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
	              continue defaultHeadersIteration;
	            }
	          }
	
	          reqHeaders[defHeaderName] = defHeaders[defHeaderName];
	        }
	
	        // execute if header value is a function for merged headers
	        return executeHeaderFns(reqHeaders, shallowCopy(config));
	      }
	
	      function serverRequest(config) {
	        var headers = config.headers;
	        var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);
	
	        // strip content-type if data is undefined
	        if (isUndefined(reqData)) {
	          forEach(headers, function(value, header) {
	            if (lowercase(header) === 'content-type') {
	              delete headers[header];
	            }
	          });
	        }
	
	        if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
	          config.withCredentials = defaults.withCredentials;
	        }
	
	        // send request
	        return sendReq(config, reqData).then(transformResponse, transformResponse);
	      }
	
	      function transformResponse(response) {
	        // make a copy since the response must be cacheable
	        var resp = extend({}, response);
	        resp.data = transformData(response.data, response.headers, response.status,
	                                  config.transformResponse);
	        return (isSuccess(response.status))
	          ? resp
	          : $q.reject(resp);
	      }
	    }
	
	    $http.pendingRequests = [];
	
	    /**
	     * @ngdoc method
	     * @name $http#get
	     *
	     * @description
	     * Shortcut method to perform `GET` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#delete
	     *
	     * @description
	     * Shortcut method to perform `DELETE` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#head
	     *
	     * @description
	     * Shortcut method to perform `HEAD` request.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#jsonp
	     *
	     * @description
	     * Shortcut method to perform `JSONP` request.
	     *
	     * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
	     * the url must be declared, via {@link $sce} as a trusted resource URL.
	     * You can trust a URL by adding it to the whitelist via
	     * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
	     * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
	     *
	     * JSONP requests must specify a callback to be used in the response from the server. This callback
	     * is passed as a query parameter in the request. You must specify the name of this parameter by
	     * setting the `jsonpCallbackParam` property on the request config object.
	     *
	     * ```
	     * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
	     * ```
	     *
	     * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
	     * Initially this is set to `'callback'`.
	     *
	     * <div class="alert alert-danger">
	     * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
	     * parameter value should go.
	     * </div>
	     *
	     * If you would like to customise where and how the callbacks are stored then try overriding
	     * or decorating the {@link $jsonpCallbacks} service.
	     *
	     * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
	     *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	    createShortMethods('get', 'delete', 'head', 'jsonp');
	
	    /**
	     * @ngdoc method
	     * @name $http#post
	     *
	     * @description
	     * Shortcut method to perform `POST` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	    /**
	     * @ngdoc method
	     * @name $http#put
	     *
	     * @description
	     * Shortcut method to perform `PUT` request.
	     *
	     * @param {string} url Relative or absolute URL specifying the destination of the request
	     * @param {*} data Request content
	     * @param {Object=} config Optional configuration object
	     * @returns {HttpPromise} Future object
	     */
	
	     /**
	      * @ngdoc method
	      * @name $http#patch
	      *
	      * @description
	      * Shortcut method to perform `PATCH` request.
	      *
	      * @param {string} url Relative or absolute URL specifying the destination of the request
	      * @param {*} data Request content
	      * @param {Object=} config Optional configuration object
	      * @returns {HttpPromise} Future object
	      */
	    createShortMethodsWithData('post', 'put', 'patch');
	
	        /**
	         * @ngdoc property
	         * @name $http#defaults
	         *
	         * @description
	         * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
	         * default headers, withCredentials as well as request and response transformations.
	         *
	         * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
	         */
	    $http.defaults = defaults;
	
	
	    return $http;
	
	
	    function createShortMethods(names) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url
	          }));
	        };
	      });
	    }
	
	
	    function createShortMethodsWithData(name) {
	      forEach(arguments, function(name) {
	        $http[name] = function(url, data, config) {
	          return $http(extend({}, config || {}, {
	            method: name,
	            url: url,
	            data: data
	          }));
	        };
	      });
	    }
	
	
	    /**
	     * Makes the request.
	     *
	     * !!! ACCESSES CLOSURE VARS:
	     * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
	     */
	    function sendReq(config, reqData) {
	      var deferred = $q.defer(),
	          promise = deferred.promise,
	          cache,
	          cachedResp,
	          reqHeaders = config.headers,
	          isJsonp = lowercase(config.method) === 'jsonp',
	          url = config.url;
	
	      if (isJsonp) {
	        // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
	        // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
	        url = $sce.getTrustedResourceUrl(url);
	      } else if (!isString(url)) {
	        // If it is not a string then the URL must be a $sce trusted object
	        url = $sce.valueOf(url);
	      }
	
	      url = buildUrl(url, config.paramSerializer(config.params));
	
	      if (isJsonp) {
	        // Check the url and add the JSONP callback placeholder
	        url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
	      }
	
	      $http.pendingRequests.push(config);
	      promise.then(removePendingReq, removePendingReq);
	
	      if ((config.cache || defaults.cache) && config.cache !== false &&
	          (config.method === 'GET' || config.method === 'JSONP')) {
	        cache = isObject(config.cache) ? config.cache
	            : isObject(/** @type {?} */ (defaults).cache)
	              ? /** @type {?} */ (defaults).cache
	              : defaultCache;
	      }
	
	      if (cache) {
	        cachedResp = cache.get(url);
	        if (isDefined(cachedResp)) {
	          if (isPromiseLike(cachedResp)) {
	            // cached request has already been sent, but there is no response yet
	            cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
	          } else {
	            // serving from cache
	            if (isArray(cachedResp)) {
	              resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3]);
	            } else {
	              resolvePromise(cachedResp, 200, {}, 'OK');
	            }
	          }
	        } else {
	          // put the promise for the non-transformed response into cache as a placeholder
	          cache.put(url, promise);
	        }
	      }
	
	
	      // if we won't have the response in cache, set the xsrf headers and
	      // send the request to the backend
	      if (isUndefined(cachedResp)) {
	        var xsrfValue = urlIsSameOrigin(config.url)
	            ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName]
	            : undefined;
	        if (xsrfValue) {
	          reqHeaders[(config.xsrfHeaderName || defaults.xsrfHeaderName)] = xsrfValue;
	        }
	
	        $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout,
	            config.withCredentials, config.responseType,
	            createApplyHandlers(config.eventHandlers),
	            createApplyHandlers(config.uploadEventHandlers));
	      }
	
	      return promise;
	
	      function createApplyHandlers(eventHandlers) {
	        if (eventHandlers) {
	          var applyHandlers = {};
	          forEach(eventHandlers, function(eventHandler, key) {
	            applyHandlers[key] = function(event) {
	              if (useApplyAsync) {
	                $rootScope.$applyAsync(callEventHandler);
	              } else if ($rootScope.$$phase) {
	                callEventHandler();
	              } else {
	                $rootScope.$apply(callEventHandler);
	              }
	
	              function callEventHandler() {
	                eventHandler(event);
	              }
	            };
	          });
	          return applyHandlers;
	        }
	      }
	
	
	      /**
	       * Callback registered to $httpBackend():
	       *  - caches the response if desired
	       *  - resolves the raw $http promise
	       *  - calls $apply
	       */
	      function done(status, response, headersString, statusText) {
	        if (cache) {
	          if (isSuccess(status)) {
	            cache.put(url, [status, response, parseHeaders(headersString), statusText]);
	          } else {
	            // remove promise from the cache
	            cache.remove(url);
	          }
	        }
	
	        function resolveHttpPromise() {
	          resolvePromise(response, status, headersString, statusText);
	        }
	
	        if (useApplyAsync) {
	          $rootScope.$applyAsync(resolveHttpPromise);
	        } else {
	          resolveHttpPromise();
	          if (!$rootScope.$$phase) $rootScope.$apply();
	        }
	      }
	
	
	      /**
	       * Resolves the raw $http promise.
	       */
	      function resolvePromise(response, status, headers, statusText) {
	        //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
	        status = status >= -1 ? status : 0;
	
	        (isSuccess(status) ? deferred.resolve : deferred.reject)({
	          data: response,
	          status: status,
	          headers: headersGetter(headers),
	          config: config,
	          statusText: statusText
	        });
	      }
	
	      function resolvePromiseWithResult(result) {
	        resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText);
	      }
	
	      function removePendingReq() {
	        var idx = $http.pendingRequests.indexOf(config);
	        if (idx !== -1) $http.pendingRequests.splice(idx, 1);
	      }
	    }
	
	
	    function buildUrl(url, serializedParams) {
	      if (serializedParams.length > 0) {
	        url += ((url.indexOf('?') === -1) ? '?' : '&') + serializedParams;
	      }
	      return url;
	    }
	
	    function sanitizeJsonpCallbackParam(url, key) {
	      if (/[&?][^=]+=JSON_CALLBACK/.test(url)) {
	        // Throw if the url already contains a reference to JSON_CALLBACK
	        throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
	      }
	
	      var callbackParamRegex = new RegExp('[&?]' + key + '=');
	      if (callbackParamRegex.test(url)) {
	        // Throw if the callback param was already provided
	        throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', key, url);
	      }
	
	      // Add in the JSON_CALLBACK callback param value
	      url += ((url.indexOf('?') === -1) ? '?' : '&') + key + '=JSON_CALLBACK';
	
	      return url;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $xhrFactory
	 * @this
	 *
	 * @description
	 * Factory function used to create XMLHttpRequest objects.
	 *
	 * Replace or decorate this service to create your own custom XMLHttpRequest objects.
	 *
	 * ```
	 * angular.module('myApp', [])
	 * .factory('$xhrFactory', function() {
	 *   return function createXhr(method, url) {
	 *     return new window.XMLHttpRequest({mozSystem: true});
	 *   };
	 * });
	 * ```
	 *
	 * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
	 * @param {string} url URL of the request.
	 */
	function $xhrFactoryProvider() {
	  this.$get = function() {
	    return function createXhr() {
	      return new window.XMLHttpRequest();
	    };
	  };
	}
	
	/**
	 * @ngdoc service
	 * @name $httpBackend
	 * @requires $jsonpCallbacks
	 * @requires $document
	 * @requires $xhrFactory
	 * @this
	 *
	 * @description
	 * HTTP backend used by the {@link ng.$http service} that delegates to
	 * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
	 *
	 * You should never need to use this service directly, instead use the higher-level abstractions:
	 * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
	 *
	 * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
	 * $httpBackend} which can be trained with responses.
	 */
	function $HttpBackendProvider() {
	  this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function($browser, $jsonpCallbacks, $document, $xhrFactory) {
	    return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
	  }];
	}
	
	function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
	  // TODO(vojta): fix the signature
	  return function(method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
	    url = url || $browser.url();
	
	    if (lowercase(method) === 'jsonp') {
	      var callbackPath = callbacks.createCallback(url);
	      var jsonpDone = jsonpReq(url, callbackPath, function(status, text) {
	        // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
	        var response = (status === 200) && callbacks.getResponse(callbackPath);
	        completeRequest(callback, status, response, '', text);
	        callbacks.removeCallback(callbackPath);
	      });
	    } else {
	
	      var xhr = createXhr(method, url);
	
	      xhr.open(method, url, true);
	      forEach(headers, function(value, key) {
	        if (isDefined(value)) {
	            xhr.setRequestHeader(key, value);
	        }
	      });
	
	      xhr.onload = function requestLoaded() {
	        var statusText = xhr.statusText || '';
	
	        // responseText is the old-school way of retrieving response (supported by IE9)
	        // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
	        var response = ('response' in xhr) ? xhr.response : xhr.responseText;
	
	        // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
	        var status = xhr.status === 1223 ? 204 : xhr.status;
	
	        // fix status code when it is 0 (0 status is undocumented).
	        // Occurs when accessing file resources or on Android 4.1 stock browser
	        // while retrieving files from application cache.
	        if (status === 0) {
	          status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
	        }
	
	        completeRequest(callback,
	            status,
	            response,
	            xhr.getAllResponseHeaders(),
	            statusText);
	      };
	
	      var requestError = function() {
	        // The response is always empty
	        // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
	        completeRequest(callback, -1, null, null, '');
	      };
	
	      xhr.onerror = requestError;
	      xhr.onabort = requestError;
	      xhr.ontimeout = requestError;
	
	      forEach(eventHandlers, function(value, key) {
	          xhr.addEventListener(key, value);
	      });
	
	      forEach(uploadEventHandlers, function(value, key) {
	        xhr.upload.addEventListener(key, value);
	      });
	
	      if (withCredentials) {
	        xhr.withCredentials = true;
	      }
	
	      if (responseType) {
	        try {
	          xhr.responseType = responseType;
	        } catch (e) {
	          // WebKit added support for the json responseType value on 09/03/2013
	          // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
	          // known to throw when setting the value "json" as the response type. Other older
	          // browsers implementing the responseType
	          //
	          // The json response type can be ignored if not supported, because JSON payloads are
	          // parsed on the client-side regardless.
	          if (responseType !== 'json') {
	            throw e;
	          }
	        }
	      }
	
	      xhr.send(isUndefined(post) ? null : post);
	    }
	
	    if (timeout > 0) {
	      var timeoutId = $browserDefer(timeoutRequest, timeout);
	    } else if (isPromiseLike(timeout)) {
	      timeout.then(timeoutRequest);
	    }
	
	
	    function timeoutRequest() {
	      if (jsonpDone) {
	        jsonpDone();
	      }
	      if (xhr) {
	        xhr.abort();
	      }
	    }
	
	    function completeRequest(callback, status, response, headersString, statusText) {
	      // cancel timeout and subsequent timeout promise resolution
	      if (isDefined(timeoutId)) {
	        $browserDefer.cancel(timeoutId);
	      }
	      jsonpDone = xhr = null;
	
	      callback(status, response, headersString, statusText);
	    }
	  };
	
	  function jsonpReq(url, callbackPath, done) {
	    url = url.replace('JSON_CALLBACK', callbackPath);
	    // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
	    // - fetches local scripts via XHR and evals them
	    // - adds and immediately removes script elements from the document
	    var script = rawDocument.createElement('script'), callback = null;
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	
	    callback = function(event) {
	      script.removeEventListener('load', callback);
	      script.removeEventListener('error', callback);
	      rawDocument.body.removeChild(script);
	      script = null;
	      var status = -1;
	      var text = 'unknown';
	
	      if (event) {
	        if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
	          event = { type: 'error' };
	        }
	        text = event.type;
	        status = event.type === 'error' ? 404 : 200;
	      }
	
	      if (done) {
	        done(status, text);
	      }
	    };
	
	    script.addEventListener('load', callback);
	    script.addEventListener('error', callback);
	    rawDocument.body.appendChild(script);
	    return callback;
	  }
	}
	
	var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
	$interpolateMinErr.throwNoconcat = function(text) {
	  throw $interpolateMinErr('noconcat',
	      'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' +
	      'interpolations that concatenate multiple expressions when a trusted value is ' +
	      'required.  See http://docs.angularjs.org/api/ng.$sce', text);
	};
	
	$interpolateMinErr.interr = function(text, err) {
	  return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
	};
	
	/**
	 * @ngdoc provider
	 * @name $interpolateProvider
	 * @this
	 *
	 * @description
	 *
	 * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
	 *
	 * <div class="alert alert-danger">
	 * This feature is sometimes used to mix different markup languages, e.g. to wrap an Angular
	 * template within a Python Jinja template (or any other template language). Mixing templating
	 * languages is **very dangerous**. The embedding template language will not safely escape Angular
	 * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
	 * security bugs!
	 * </div>
	 *
	 * @example
	<example name="custom-interpolation-markup" module="customInterpolationApp">
	<file name="index.html">
	<script>
	  var customInterpolationApp = angular.module('customInterpolationApp', []);
	
	  customInterpolationApp.config(function($interpolateProvider) {
	    $interpolateProvider.startSymbol('//');
	    $interpolateProvider.endSymbol('//');
	  });
	
	
	  customInterpolationApp.controller('DemoController', function() {
	      this.label = "This binding is brought you by // interpolation symbols.";
	  });
	</script>
	<div ng-controller="DemoController as demo">
	    //demo.label//
	</div>
	</file>
	<file name="protractor.js" type="protractor">
	  it('should interpolate binding with custom symbols', function() {
	    expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
	  });
	</file>
	</example>
	 */
	function $InterpolateProvider() {
	  var startSymbol = '{{';
	  var endSymbol = '}}';
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#startSymbol
	   * @description
	   * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
	   *
	   * @param {string=} value new value to set the starting symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.startSymbol = function(value) {
	    if (value) {
	      startSymbol = value;
	      return this;
	    } else {
	      return startSymbol;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $interpolateProvider#endSymbol
	   * @description
	   * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	   *
	   * @param {string=} value new value to set the ending symbol to.
	   * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
	   */
	  this.endSymbol = function(value) {
	    if (value) {
	      endSymbol = value;
	      return this;
	    } else {
	      return endSymbol;
	    }
	  };
	
	
	  this.$get = ['$parse', '$exceptionHandler', '$sce', function($parse, $exceptionHandler, $sce) {
	    var startSymbolLength = startSymbol.length,
	        endSymbolLength = endSymbol.length,
	        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
	        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
	
	    function escape(ch) {
	      return '\\\\\\' + ch;
	    }
	
	    function unescapeText(text) {
	      return text.replace(escapedStartRegexp, startSymbol).
	        replace(escapedEndRegexp, endSymbol);
	    }
	
	    // TODO: this is the same as the constantWatchDelegate in parse.js
	    function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
	      var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
	        unwatch();
	        return constantInterp(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    /**
	     * @ngdoc service
	     * @name $interpolate
	     * @kind function
	     *
	     * @requires $parse
	     * @requires $sce
	     *
	     * @description
	     *
	     * Compiles a string with markup into an interpolation function. This service is used by the
	     * HTML {@link ng.$compile $compile} service for data binding. See
	     * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
	     * interpolation markup.
	     *
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var exp = $interpolate('Hello {{name | uppercase}}!');
	     *   expect(exp({name:'Angular'})).toEqual('Hello ANGULAR!');
	     * ```
	     *
	     * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
	     * `true`, the interpolation function will return `undefined` unless all embedded expressions
	     * evaluate to a value other than `undefined`.
	     *
	     * ```js
	     *   var $interpolate = ...; // injected
	     *   var context = {greeting: 'Hello', name: undefined };
	     *
	     *   // default "forgiving" mode
	     *   var exp = $interpolate('{{greeting}} {{name}}!');
	     *   expect(exp(context)).toEqual('Hello !');
	     *
	     *   // "allOrNothing" mode
	     *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
	     *   expect(exp(context)).toBeUndefined();
	     *   context.name = 'Angular';
	     *   expect(exp(context)).toEqual('Hello Angular!');
	     * ```
	     *
	     * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
	     *
	     * #### Escaped Interpolation
	     * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
	     * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
	     * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
	     * or binding.
	     *
	     * This enables web-servers to prevent script injection attacks and defacing attacks, to some
	     * degree, while also enabling code examples to work without relying on the
	     * {@link ng.directive:ngNonBindable ngNonBindable} directive.
	     *
	     * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
	     * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
	     * interpolation start/end markers with their escaped counterparts.**
	     *
	     * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
	     * output when the $interpolate service processes the text. So, for HTML elements interpolated
	     * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
	     * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
	     * this is typically useful only when user-data is used in rendering a template from the server, or
	     * when otherwise untrusted data is used by a directive.
	     *
	     * <example name="interpolation">
	     *  <file name="index.html">
	     *    <div ng-init="username='A user'">
	     *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
	     *        </p>
	     *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
	     *        application, but fails to accomplish their task, because the server has correctly
	     *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
	     *        characters.</p>
	     *      <p>Instead, the result of the attempted script injection is visible, and can be removed
	     *        from the database by an administrator.</p>
	     *    </div>
	     *  </file>
	     * </example>
	     *
	     * @knownIssue
	     * It is currently not possible for an interpolated expression to contain the interpolation end
	     * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
	     * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
	     *
	     * @knownIssue
	     * All directives and components must use the standard `{{` `}}` interpolation symbols
	     * in their templates. If you change the application interpolation symbols the {@link $compile}
	     * service will attempt to denormalize the standard symbols to the custom symbols.
	     * The denormalization process is not clever enough to know not to replace instances of the standard
	     * symbols where they would not normally be treated as interpolation symbols. For example in the following
	     * code snippet the closing braces of the literal object will get incorrectly denormalized:
	     *
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"}}">
	     * ```
	     *
	     * The workaround is to ensure that such instances are separated by whitespace:
	     * ```
	     * <div data-context='{"context":{"id":3,"type":"page"} }">
	     * ```
	     *
	     * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
	     *
	     * @param {string} text The text with markup to interpolate.
	     * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
	     *    embedded expression in order to return an interpolation function. Strings with no
	     *    embedded expression will return null for the interpolation function.
	     * @param {string=} trustedContext when provided, the returned function passes the interpolated
	     *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
	     *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
	     *    provides Strict Contextual Escaping for details.
	     * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
	     *    unless all embedded expressions evaluate to a value other than `undefined`.
	     * @returns {function(context)} an interpolation function which is used to compute the
	     *    interpolated string. The function has these parameters:
	     *
	     * - `context`: evaluation context for all expressions embedded in the interpolated text
	     */
	    function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
	      // Provide a quick exit and simplified result function for text with no interpolation
	      if (!text.length || text.indexOf(startSymbol) === -1) {
	        var constantInterp;
	        if (!mustHaveExpression) {
	          var unescapedText = unescapeText(text);
	          constantInterp = valueFn(unescapedText);
	          constantInterp.exp = text;
	          constantInterp.expressions = [];
	          constantInterp.$$watchDelegate = constantWatchDelegate;
	        }
	        return constantInterp;
	      }
	
	      allOrNothing = !!allOrNothing;
	      var startIndex,
	          endIndex,
	          index = 0,
	          expressions = [],
	          parseFns = [],
	          textLength = text.length,
	          exp,
	          concat = [],
	          expressionPositions = [];
	
	      while (index < textLength) {
	        if (((startIndex = text.indexOf(startSymbol, index)) !== -1) &&
	             ((endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1)) {
	          if (index !== startIndex) {
	            concat.push(unescapeText(text.substring(index, startIndex)));
	          }
	          exp = text.substring(startIndex + startSymbolLength, endIndex);
	          expressions.push(exp);
	          parseFns.push($parse(exp, parseStringifyInterceptor));
	          index = endIndex + endSymbolLength;
	          expressionPositions.push(concat.length);
	          concat.push('');
	        } else {
	          // we did not find an interpolation, so we have to add the remainder to the separators array
	          if (index !== textLength) {
	            concat.push(unescapeText(text.substring(index)));
	          }
	          break;
	        }
	      }
	
	      // Concatenating expressions makes it hard to reason about whether some combination of
	      // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
	      // single expression be used for iframe[src], object[src], etc., we ensure that the value
	      // that's used is assigned or constructed by some JS code somewhere that is more testable or
	      // make it obvious that you bound the value to some user controlled value.  This helps reduce
	      // the load when auditing for XSS issues.
	      if (trustedContext && concat.length > 1) {
	          $interpolateMinErr.throwNoconcat(text);
	      }
	
	      if (!mustHaveExpression || expressions.length) {
	        var compute = function(values) {
	          for (var i = 0, ii = expressions.length; i < ii; i++) {
	            if (allOrNothing && isUndefined(values[i])) return;
	            concat[expressionPositions[i]] = values[i];
	          }
	          return concat.join('');
	        };
	
	        var getValue = function(value) {
	          return trustedContext ?
	            $sce.getTrusted(trustedContext, value) :
	            $sce.valueOf(value);
	        };
	
	        return extend(function interpolationFn(context) {
	            var i = 0;
	            var ii = expressions.length;
	            var values = new Array(ii);
	
	            try {
	              for (; i < ii; i++) {
	                values[i] = parseFns[i](context);
	              }
	
	              return compute(values);
	            } catch (err) {
	              $exceptionHandler($interpolateMinErr.interr(text, err));
	            }
	
	          }, {
	          // all of these properties are undocumented for now
	          exp: text, //just for compatibility with regular watchers created via $watch
	          expressions: expressions,
	          $$watchDelegate: function(scope, listener) {
	            var lastValue;
	            return scope.$watchGroup(parseFns, /** @this */ function interpolateFnWatcher(values, oldValues) {
	              var currValue = compute(values);
	              if (isFunction(listener)) {
	                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
	              }
	              lastValue = currValue;
	            });
	          }
	        });
	      }
	
	      function parseStringifyInterceptor(value) {
	        try {
	          value = getValue(value);
	          return allOrNothing && !isDefined(value) ? value : stringify(value);
	        } catch (err) {
	          $exceptionHandler($interpolateMinErr.interr(text, err));
	        }
	      }
	    }
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#startSymbol
	     * @description
	     * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
	     *
	     * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} start symbol.
	     */
	    $interpolate.startSymbol = function() {
	      return startSymbol;
	    };
	
	
	    /**
	     * @ngdoc method
	     * @name $interpolate#endSymbol
	     * @description
	     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
	     *
	     * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
	     * the symbol.
	     *
	     * @returns {string} end symbol.
	     */
	    $interpolate.endSymbol = function() {
	      return endSymbol;
	    };
	
	    return $interpolate;
	  }];
	}
	
	/** @this */
	function $IntervalProvider() {
	  this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser',
	       function($rootScope,   $window,   $q,   $$q,   $browser) {
	    var intervals = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $interval
	      *
	      * @description
	      * Angular's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
	      * milliseconds.
	      *
	      * The return value of registering an interval function is a promise. This promise will be
	      * notified upon each tick of the interval, and will be resolved after `count` iterations, or
	      * run indefinitely if `count` is not defined. The value of the notification will be the
	      * number of iterations that have run.
	      * To cancel an interval, call `$interval.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
	      * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
	      * time.
	      *
	      * <div class="alert alert-warning">
	      * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
	      * with them.  In particular they are not automatically destroyed when a controller's scope or a
	      * directive's element are destroyed.
	      * You should take this into consideration and make sure to always cancel the interval at the
	      * appropriate moment.  See the example below for more details on how and when to do this.
	      * </div>
	      *
	      * @param {function()} fn A function that should be called repeatedly. If no additional arguments
	      *   are passed (see below), the function is called with the current iteration count.
	      * @param {number} delay Number of milliseconds between each function call.
	      * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
	      *   indefinitely.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
	      *
	      * @example
	      * <example module="intervalExample" name="interval-service">
	      * <file name="index.html">
	      *   <script>
	      *     angular.module('intervalExample', [])
	      *       .controller('ExampleController', ['$scope', '$interval',
	      *         function($scope, $interval) {
	      *           $scope.format = 'M/d/yy h:mm:ss a';
	      *           $scope.blood_1 = 100;
	      *           $scope.blood_2 = 120;
	      *
	      *           var stop;
	      *           $scope.fight = function() {
	      *             // Don't start a new fight if we are already fighting
	      *             if ( angular.isDefined(stop) ) return;
	      *
	      *             stop = $interval(function() {
	      *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
	      *                 $scope.blood_1 = $scope.blood_1 - 3;
	      *                 $scope.blood_2 = $scope.blood_2 - 4;
	      *               } else {
	      *                 $scope.stopFight();
	      *               }
	      *             }, 100);
	      *           };
	      *
	      *           $scope.stopFight = function() {
	      *             if (angular.isDefined(stop)) {
	      *               $interval.cancel(stop);
	      *               stop = undefined;
	      *             }
	      *           };
	      *
	      *           $scope.resetFight = function() {
	      *             $scope.blood_1 = 100;
	      *             $scope.blood_2 = 120;
	      *           };
	      *
	      *           $scope.$on('$destroy', function() {
	      *             // Make sure that the interval is destroyed too
	      *             $scope.stopFight();
	      *           });
	      *         }])
	      *       // Register the 'myCurrentTime' directive factory method.
	      *       // We inject $interval and dateFilter service since the factory method is DI.
	      *       .directive('myCurrentTime', ['$interval', 'dateFilter',
	      *         function($interval, dateFilter) {
	      *           // return the directive link function. (compile function not needed)
	      *           return function(scope, element, attrs) {
	      *             var format,  // date format
	      *                 stopTime; // so that we can cancel the time updates
	      *
	      *             // used to update the UI
	      *             function updateTime() {
	      *               element.text(dateFilter(new Date(), format));
	      *             }
	      *
	      *             // watch the expression, and update the UI on change.
	      *             scope.$watch(attrs.myCurrentTime, function(value) {
	      *               format = value;
	      *               updateTime();
	      *             });
	      *
	      *             stopTime = $interval(updateTime, 1000);
	      *
	      *             // listen on DOM destroy (removal) event, and cancel the next UI update
	      *             // to prevent updating time after the DOM element was removed.
	      *             element.on('$destroy', function() {
	      *               $interval.cancel(stopTime);
	      *             });
	      *           }
	      *         }]);
	      *   </script>
	      *
	      *   <div>
	      *     <div ng-controller="ExampleController">
	      *       <label>Date format: <input ng-model="format"></label> <hr/>
	      *       Current time is: <span my-current-time="format"></span>
	      *       <hr/>
	      *       Blood 1 : <font color='red'>{{blood_1}}</font>
	      *       Blood 2 : <font color='red'>{{blood_2}}</font>
	      *       <button type="button" data-ng-click="fight()">Fight</button>
	      *       <button type="button" data-ng-click="stopFight()">StopFight</button>
	      *       <button type="button" data-ng-click="resetFight()">resetFight</button>
	      *     </div>
	      *   </div>
	      *
	      * </file>
	      * </example>
	      */
	    function interval(fn, delay, count, invokeApply) {
	      var hasParams = arguments.length > 4,
	          args = hasParams ? sliceArgs(arguments, 4) : [],
	          setInterval = $window.setInterval,
	          clearInterval = $window.clearInterval,
	          iteration = 0,
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise;
	
	      count = isDefined(count) ? count : 0;
	
	      promise.$$intervalId = setInterval(function tick() {
	        if (skipApply) {
	          $browser.defer(callback);
	        } else {
	          $rootScope.$evalAsync(callback);
	        }
	        deferred.notify(iteration++);
	
	        if (count > 0 && iteration >= count) {
	          deferred.resolve(iteration);
	          clearInterval(promise.$$intervalId);
	          delete intervals[promise.$$intervalId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	
	      }, delay);
	
	      intervals[promise.$$intervalId] = deferred;
	
	      return promise;
	
	      function callback() {
	        if (!hasParams) {
	          fn(iteration);
	        } else {
	          fn.apply(null, args);
	        }
	      }
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $interval#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`.
	      *
	      * @param {Promise=} promise returned by the `$interval` function.
	      * @returns {boolean} Returns `true` if the task was successfully canceled.
	      */
	    interval.cancel = function(promise) {
	      if (promise && promise.$$intervalId in intervals) {
	        // Interval cancels should not report as unhandled promise.
	        intervals[promise.$$intervalId].promise.catch(noop);
	        intervals[promise.$$intervalId].reject('canceled');
	        $window.clearInterval(promise.$$intervalId);
	        delete intervals[promise.$$intervalId];
	        return true;
	      }
	      return false;
	    };
	
	    return interval;
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $jsonpCallbacks
	 * @requires $window
	 * @description
	 * This service handles the lifecycle of callbacks to handle JSONP requests.
	 * Override this service if you wish to customise where the callbacks are stored and
	 * how they vary compared to the requested url.
	 */
	var $jsonpCallbacksProvider = /** @this */ function() {
	  this.$get = function() {
	    var callbacks = angular.callbacks;
	    var callbackMap = {};
	
	    function createCallback(callbackId) {
	      var callback = function(data) {
	        callback.data = data;
	        callback.called = true;
	      };
	      callback.id = callbackId;
	      return callback;
	    }
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#createCallback
	       * @param {string} url the url of the JSONP request
	       * @returns {string} the callback path to send to the server as part of the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
	       * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
	       */
	      createCallback: function(url) {
	        var callbackId = '_' + (callbacks.$$counter++).toString(36);
	        var callbackPath = 'angular.callbacks.' + callbackId;
	        var callback = createCallback(callbackId);
	        callbackMap[callbackPath] = callbacks[callbackId] = callback;
	        return callbackPath;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#wasCalled
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {boolean} whether the callback has been called, as a result of the JSONP response
	       * @description
	       * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
	       * callback that was passed in the request.
	       */
	      wasCalled: function(callbackPath) {
	        return callbackMap[callbackPath].called;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#getResponse
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @returns {*} the data received from the response via the registered callback
	       * @description
	       * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
	       * in the JSONP response.
	       */
	      getResponse: function(callbackPath) {
	        return callbackMap[callbackPath].data;
	      },
	      /**
	       * @ngdoc method
	       * @name $jsonpCallbacks#removeCallback
	       * @param {string} callbackPath the path to the callback that was sent in the JSONP request
	       * @description
	       * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
	       * completed or timed-out.
	       */
	      removeCallback: function(callbackPath) {
	        var callback = callbackMap[callbackPath];
	        delete callbacks[callback.id];
	        delete callbackMap[callbackPath];
	      }
	    };
	  };
	};
	
	/**
	 * @ngdoc service
	 * @name $locale
	 *
	 * @description
	 * $locale service provides localization rules for various Angular components. As of right now the
	 * only public api is:
	 *
	 * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
	 */
	
	var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
	    DEFAULT_PORTS = {'http': 80, 'https': 443, 'ftp': 21};
	var $locationMinErr = minErr('$location');
	
	
	/**
	 * Encode path using encodeUriSegment, ignoring forward slashes
	 *
	 * @param {string} path Path to encode
	 * @returns {string}
	 */
	function encodePath(path) {
	  var segments = path.split('/'),
	      i = segments.length;
	
	  while (i--) {
	    segments[i] = encodeUriSegment(segments[i]);
	  }
	
	  return segments.join('/');
	}
	
	function parseAbsoluteUrl(absoluteUrl, locationObj) {
	  var parsedUrl = urlResolve(absoluteUrl);
	
	  locationObj.$$protocol = parsedUrl.protocol;
	  locationObj.$$host = parsedUrl.hostname;
	  locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
	}
	
	var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
	function parseAppUrl(url, locationObj) {
	
	  if (DOUBLE_SLASH_REGEX.test(url)) {
	    throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
	  }
	
	  var prefixed = (url.charAt(0) !== '/');
	  if (prefixed) {
	    url = '/' + url;
	  }
	  var match = urlResolve(url);
	  locationObj.$$path = decodeURIComponent(prefixed && match.pathname.charAt(0) === '/' ?
	      match.pathname.substring(1) : match.pathname);
	  locationObj.$$search = parseKeyValue(match.search);
	  locationObj.$$hash = decodeURIComponent(match.hash);
	
	  // make sure path starts with '/';
	  if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
	    locationObj.$$path = '/' + locationObj.$$path;
	  }
	}
	
	function startsWith(str, search) {
	  return str.slice(0, search.length) === search;
	}
	
	/**
	 *
	 * @param {string} base
	 * @param {string} url
	 * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
	 *                   the expected string.
	 */
	function stripBaseUrl(base, url) {
	  if (startsWith(url, base)) {
	    return url.substr(base.length);
	  }
	}
	
	
	function stripHash(url) {
	  var index = url.indexOf('#');
	  return index === -1 ? url : url.substr(0, index);
	}
	
	function trimEmptyHash(url) {
	  return url.replace(/(#.+)|#$/, '$1');
	}
	
	
	function stripFile(url) {
	  return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
	}
	
	/* return the server only (scheme://host:port) */
	function serverBase(url) {
	  return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
	}
	
	
	/**
	 * LocationHtml5Url represents a URL
	 * This object is exposed as $location service when HTML5 mode is enabled and supported
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} basePrefix URL path prefix
	 */
	function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
	  this.$$html5 = true;
	  basePrefix = basePrefix || '';
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given HTML5 (regular) URL string into properties
	   * @param {string} url HTML5 URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var pathUrl = stripBaseUrl(appBaseNoFile, url);
	    if (!isString(pathUrl)) {
	      throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url,
	          appBaseNoFile);
	    }
	
	    parseAppUrl(pathUrl, this);
	
	    if (!this.$$path) {
	      this.$$path = '/';
	    }
	
	    this.$$compose();
	  };
	
	  /**
	   * Compose url and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	    var appUrl, prevAppUrl;
	    var rewrittenUrl;
	
	
	    if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
	      prevAppUrl = appUrl;
	      if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
	        rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
	      } else {
	        rewrittenUrl = appBase + prevAppUrl;
	      }
	    } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBaseNoFile + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when developer doesn't opt into html5 mode.
	 * It also serves as the base class for html5 mode fallback on legacy browsers.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
	
	  parseAbsoluteUrl(appBase, this);
	
	
	  /**
	   * Parse given hashbang URL into properties
	   * @param {string} url Hashbang URL
	   * @private
	   */
	  this.$$parse = function(url) {
	    var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
	    var withoutHashUrl;
	
	    if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
	
	      // The rest of the URL starts with a hash so we have
	      // got either a hashbang path or a plain hash fragment
	      withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
	      if (isUndefined(withoutHashUrl)) {
	        // There was no hashbang prefix so we just have a hash fragment
	        withoutHashUrl = withoutBaseUrl;
	      }
	
	    } else {
	      // There was no hashbang path nor hash fragment:
	      // If we are in HTML5 mode we use what is left as the path;
	      // Otherwise we ignore what is left
	      if (this.$$html5) {
	        withoutHashUrl = withoutBaseUrl;
	      } else {
	        withoutHashUrl = '';
	        if (isUndefined(withoutBaseUrl)) {
	          appBase = url;
	          /** @type {?} */ (this).replace();
	        }
	      }
	    }
	
	    parseAppUrl(withoutHashUrl, this);
	
	    this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
	
	    this.$$compose();
	
	    /*
	     * In Windows, on an anchor node on documents loaded from
	     * the filesystem, the browser will return a pathname
	     * prefixed with the drive name ('/C:/path') when a
	     * pathname without a drive is set:
	     *  * a.setAttribute('href', '/foo')
	     *   * a.pathname === '/C:/foo' //true
	     *
	     * Inside of Angular, we're always using pathnames that
	     * do not include drive names for routing.
	     */
	    function removeWindowsDriveName(path, url, base) {
	      /*
	      Matches paths for file protocol on windows,
	      such as /C:/foo/bar, and captures only /foo/bar.
	      */
	      var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
	
	      var firstPathSegmentMatch;
	
	      //Get the relative path from the input URL.
	      if (startsWith(url, base)) {
	        url = url.replace(base, '');
	      }
	
	      // The input URL intentionally contains a first path segment that ends with a colon.
	      if (windowsFilePathExp.exec(url)) {
	        return path;
	      }
	
	      firstPathSegmentMatch = windowsFilePathExp.exec(path);
	      return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
	    }
	  };
	
	  /**
	   * Compose hashbang URL and update `absUrl` property
	   * @private
	   */
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (stripHash(appBase) === stripHash(url)) {
	      this.$$parse(url);
	      return true;
	    }
	    return false;
	  };
	}
	
	
	/**
	 * LocationHashbangUrl represents URL
	 * This object is exposed as $location service when html5 history api is enabled but the browser
	 * does not support it.
	 *
	 * @constructor
	 * @param {string} appBase application base URL
	 * @param {string} appBaseNoFile application base URL stripped of any filename
	 * @param {string} hashPrefix hashbang prefix
	 */
	function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
	  this.$$html5 = true;
	  LocationHashbangUrl.apply(this, arguments);
	
	  this.$$parseLinkUrl = function(url, relHref) {
	    if (relHref && relHref[0] === '#') {
	      // special case for links to hash fragments:
	      // keep the old url and only replace the hash fragment
	      this.hash(relHref.slice(1));
	      return true;
	    }
	
	    var rewrittenUrl;
	    var appUrl;
	
	    if (appBase === stripHash(url)) {
	      rewrittenUrl = url;
	    } else if ((appUrl = stripBaseUrl(appBaseNoFile, url))) {
	      rewrittenUrl = appBase + hashPrefix + appUrl;
	    } else if (appBaseNoFile === url + '/') {
	      rewrittenUrl = appBaseNoFile;
	    }
	    if (rewrittenUrl) {
	      this.$$parse(rewrittenUrl);
	    }
	    return !!rewrittenUrl;
	  };
	
	  this.$$compose = function() {
	    var search = toKeyValue(this.$$search),
	        hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';
	
	    this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
	    // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
	    this.$$absUrl = appBase + hashPrefix + this.$$url;
	
	    this.$$urlUpdatedByLocation = true;
	  };
	
	}
	
	
	var locationPrototype = {
	
	  /**
	   * Ensure absolute URL is initialized.
	   * @private
	   */
	  $$absUrl:'',
	
	  /**
	   * Are we in html5 mode?
	   * @private
	   */
	  $$html5: false,
	
	  /**
	   * Has any change been replacing?
	   * @private
	   */
	  $$replace: false,
	
	  /**
	   * @ngdoc method
	   * @name $location#absUrl
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return full URL representation with all segments encoded according to rules specified in
	   * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var absUrl = $location.absUrl();
	   * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @return {string} full URL
	   */
	  absUrl: locationGetter('$$absUrl'),
	
	  /**
	   * @ngdoc method
	   * @name $location#url
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
	   *
	   * Change path, search and hash, when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var url = $location.url();
	   * // => "/some/path?foo=bar&baz=xoxo"
	   * ```
	   *
	   * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
	   * @return {string} url
	   */
	  url: function(url) {
	    if (isUndefined(url)) {
	      return this.$$url;
	    }
	
	    var match = PATH_MATCH.exec(url);
	    if (match[1] || url === '') this.path(decodeURIComponent(match[1]));
	    if (match[2] || match[1] || url === '') this.search(match[3] || '');
	    this.hash(match[5] || '');
	
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#protocol
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return protocol of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var protocol = $location.protocol();
	   * // => "http"
	   * ```
	   *
	   * @return {string} protocol of current URL
	   */
	  protocol: locationGetter('$$protocol'),
	
	  /**
	   * @ngdoc method
	   * @name $location#host
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return host of current URL.
	   *
	   * Note: compared to the non-angular version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var host = $location.host();
	   * // => "example.com"
	   *
	   * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
	   * host = $location.host();
	   * // => "example.com"
	   * host = location.host;
	   * // => "example.com:8080"
	   * ```
	   *
	   * @return {string} host of current URL.
	   */
	  host: locationGetter('$$host'),
	
	  /**
	   * @ngdoc method
	   * @name $location#port
	   *
	   * @description
	   * This method is getter only.
	   *
	   * Return port of current URL.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var port = $location.port();
	   * // => 80
	   * ```
	   *
	   * @return {Number} port
	   */
	  port: locationGetter('$$port'),
	
	  /**
	   * @ngdoc method
	   * @name $location#path
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return path of current URL when called without any parameter.
	   *
	   * Change path when called with parameter and return `$location`.
	   *
	   * Note: Path should always begin with forward slash (/), this method will add the forward slash
	   * if it is missing.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var path = $location.path();
	   * // => "/some/path"
	   * ```
	   *
	   * @param {(string|number)=} path New path
	   * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
	   */
	  path: locationGetterSetter('$$path', function(path) {
	    path = path !== null ? path.toString() : '';
	    return path.charAt(0) === '/' ? path : '/' + path;
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#search
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return search part (as object) of current URL when called without any parameter.
	   *
	   * Change search part when called with parameter and return `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
	   * var searchObject = $location.search();
	   * // => {foo: 'bar', baz: 'xoxo'}
	   *
	   * // set foo to 'yipee'
	   * $location.search('foo', 'yipee');
	   * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
	   * ```
	   *
	   * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
	   * hash object.
	   *
	   * When called with a single argument the method acts as a setter, setting the `search` component
	   * of `$location` to the specified value.
	   *
	   * If the argument is a hash object containing an array of values, these values will be encoded
	   * as duplicate search parameters in the URL.
	   *
	   * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
	   * will override only a single search property.
	   *
	   * If `paramValue` is an array, it will override the property of the `search` component of
	   * `$location` specified via the first argument.
	   *
	   * If `paramValue` is `null`, the property specified via the first argument will be deleted.
	   *
	   * If `paramValue` is `true`, the property specified via the first argument will be added with no
	   * value nor trailing equal sign.
	   *
	   * @return {Object} If called with no arguments returns the parsed `search` object. If called with
	   * one or more arguments returns `$location` object itself.
	   */
	  search: function(search, paramValue) {
	    switch (arguments.length) {
	      case 0:
	        return this.$$search;
	      case 1:
	        if (isString(search) || isNumber(search)) {
	          search = search.toString();
	          this.$$search = parseKeyValue(search);
	        } else if (isObject(search)) {
	          search = copy(search, {});
	          // remove object undefined or null properties
	          forEach(search, function(value, key) {
	            if (value == null) delete search[key];
	          });
	
	          this.$$search = search;
	        } else {
	          throw $locationMinErr('isrcharg',
	              'The first argument of the `$location#search()` call must be a string or an object.');
	        }
	        break;
	      default:
	        if (isUndefined(paramValue) || paramValue === null) {
	          delete this.$$search[search];
	        } else {
	          this.$$search[search] = paramValue;
	        }
	    }
	
	    this.$$compose();
	    return this;
	  },
	
	  /**
	   * @ngdoc method
	   * @name $location#hash
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Returns the hash fragment when called without any parameters.
	   *
	   * Changes the hash fragment when called with a parameter and returns `$location`.
	   *
	   *
	   * ```js
	   * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
	   * var hash = $location.hash();
	   * // => "hashValue"
	   * ```
	   *
	   * @param {(string|number)=} hash New hash fragment
	   * @return {string} hash
	   */
	  hash: locationGetterSetter('$$hash', function(hash) {
	    return hash !== null ? hash.toString() : '';
	  }),
	
	  /**
	   * @ngdoc method
	   * @name $location#replace
	   *
	   * @description
	   * If called, all changes to $location during the current `$digest` will replace the current history
	   * record, instead of adding a new one.
	   */
	  replace: function() {
	    this.$$replace = true;
	    return this;
	  }
	};
	
	forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function(Location) {
	  Location.prototype = Object.create(locationPrototype);
	
	  /**
	   * @ngdoc method
	   * @name $location#state
	   *
	   * @description
	   * This method is getter / setter.
	   *
	   * Return the history state object when called without any parameter.
	   *
	   * Change the history state object when called with one parameter and return `$location`.
	   * The state object is later passed to `pushState` or `replaceState`.
	   *
	   * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
	   * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
	   * older browsers (like IE9 or Android < 4.0), don't use this method.
	   *
	   * @param {object=} state State object for pushState or replaceState
	   * @return {object} state
	   */
	  Location.prototype.state = function(state) {
	    if (!arguments.length) {
	      return this.$$state;
	    }
	
	    if (Location !== LocationHtml5Url || !this.$$html5) {
	      throw $locationMinErr('nostate', 'History API state support is available only ' +
	        'in HTML5 mode and only in browsers supporting HTML5 History API');
	    }
	    // The user might modify `stateObject` after invoking `$location.state(stateObject)`
	    // but we're changing the $$state reference to $browser.state() during the $digest
	    // so the modification window is narrow.
	    this.$$state = isUndefined(state) ? null : state;
	    this.$$urlUpdatedByLocation = true;
	
	    return this;
	  };
	});
	
	
	function locationGetter(property) {
	  return /** @this */ function() {
	    return this[property];
	  };
	}
	
	
	function locationGetterSetter(property, preprocess) {
	  return /** @this */ function(value) {
	    if (isUndefined(value)) {
	      return this[property];
	    }
	
	    this[property] = preprocess(value);
	    this.$$compose();
	
	    return this;
	  };
	}
	
	
	/**
	 * @ngdoc service
	 * @name $location
	 *
	 * @requires $rootElement
	 *
	 * @description
	 * The $location service parses the URL in the browser address bar (based on the
	 * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
	 * available to your application. Changes to the URL in the address bar are reflected into
	 * $location service and changes to $location are reflected into the browser address bar.
	 *
	 * **The $location service:**
	 *
	 * - Exposes the current URL in the browser address bar, so you can
	 *   - Watch and observe the URL.
	 *   - Change the URL.
	 * - Synchronizes the URL with the browser when the user
	 *   - Changes the address bar.
	 *   - Clicks the back or forward button (or clicks a History link).
	 *   - Clicks on a link.
	 * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
	 *
	 * For more information see {@link guide/$location Developer Guide: Using $location}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $locationProvider
	 * @this
	 *
	 * @description
	 * Use the `$locationProvider` to configure how the application deep linking paths are stored.
	 */
	function $LocationProvider() {
	  var hashPrefix = '!',
	      html5Mode = {
	        enabled: false,
	        requireBase: true,
	        rewriteLinks: true
	      };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#hashPrefix
	   * @description
	   * The default value for the prefix is `'!'`.
	   * @param {string=} prefix Prefix for hash part (containing path and search)
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.hashPrefix = function(prefix) {
	    if (isDefined(prefix)) {
	      hashPrefix = prefix;
	      return this;
	    } else {
	      return hashPrefix;
	    }
	  };
	
	  /**
	   * @ngdoc method
	   * @name $locationProvider#html5Mode
	   * @description
	   * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
	   *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
	   *   properties:
	   *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
	   *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
	   *     support `pushState`.
	   *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
	   *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
	   *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
	   *     See the {@link guide/$location $location guide for more information}
	   *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
	   *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
	   *     only happen on links with an attribute that matches the given string. For example, if set
	   *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
	   *     Note that [attribute name normalization](guide/directive#normalization) does not apply
	   *     here, so `'internalLink'` will **not** match `'internal-link'`.
	   *
	   * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
	   */
	  this.html5Mode = function(mode) {
	    if (isBoolean(mode)) {
	      html5Mode.enabled = mode;
	      return this;
	    } else if (isObject(mode)) {
	
	      if (isBoolean(mode.enabled)) {
	        html5Mode.enabled = mode.enabled;
	      }
	
	      if (isBoolean(mode.requireBase)) {
	        html5Mode.requireBase = mode.requireBase;
	      }
	
	      if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
	        html5Mode.rewriteLinks = mode.rewriteLinks;
	      }
	
	      return this;
	    } else {
	      return html5Mode;
	    }
	  };
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeStart
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted before a URL will change.
	   *
	   * This change can be prevented by calling
	   * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
	   * details about event object. Upon successful change
	   * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  /**
	   * @ngdoc event
	   * @name $location#$locationChangeSuccess
	   * @eventType broadcast on root scope
	   * @description
	   * Broadcasted after a URL was changed.
	   *
	   * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
	   * the browser supports the HTML5 History API.
	   *
	   * @param {Object} angularEvent Synthetic event object.
	   * @param {string} newUrl New URL
	   * @param {string=} oldUrl URL that was before it was changed.
	   * @param {string=} newState New history state object
	   * @param {string=} oldState History state object that was before it was changed.
	   */
	
	  this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window',
	      function($rootScope, $browser, $sniffer, $rootElement, $window) {
	    var $location,
	        LocationMode,
	        baseHref = $browser.baseHref(), // if base[href] is undefined, it defaults to ''
	        initialUrl = $browser.url(),
	        appBase;
	
	    if (html5Mode.enabled) {
	      if (!baseHref && html5Mode.requireBase) {
	        throw $locationMinErr('nobase',
	          '$location in HTML5 mode requires a <base> tag to be present!');
	      }
	      appBase = serverBase(initialUrl) + (baseHref || '/');
	      LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
	    } else {
	      appBase = stripHash(initialUrl);
	      LocationMode = LocationHashbangUrl;
	    }
	    var appBaseNoFile = stripFile(appBase);
	
	    $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
	    $location.$$parseLinkUrl(initialUrl, initialUrl);
	
	    $location.$$state = $browser.state();
	
	    var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;
	
	    function setBrowserUrlWithFallback(url, replace, state) {
	      var oldUrl = $location.url();
	      var oldState = $location.$$state;
	      try {
	        $browser.url(url, replace, state);
	
	        // Make sure $location.state() returns referentially identical (not just deeply equal)
	        // state object; this makes possible quick checking if the state changed in the digest
	        // loop. Checking deep equality would be too expensive.
	        $location.$$state = $browser.state();
	      } catch (e) {
	        // Restore old values if pushState fails
	        $location.url(oldUrl);
	        $location.$$state = oldState;
	
	        throw e;
	      }
	    }
	
	    $rootElement.on('click', function(event) {
	      var rewriteLinks = html5Mode.rewriteLinks;
	      // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
	      // currently we open nice url link and redirect then
	
	      if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
	
	      var elm = jqLite(event.target);
	
	      // traverse the DOM up to find first A tag
	      while (nodeName_(elm[0]) !== 'a') {
	        // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
	        if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
	      }
	
	      if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
	
	      var absHref = elm.prop('href');
	      // get the actual href attribute - see
	      // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
	      var relHref = elm.attr('href') || elm.attr('xlink:href');
	
	      if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
	        // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
	        // an animation.
	        absHref = urlResolve(absHref.animVal).href;
	      }
	
	      // Ignore when url is started with javascript: or mailto:
	      if (IGNORE_URI_REGEXP.test(absHref)) return;
	
	      if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
	        if ($location.$$parseLinkUrl(absHref, relHref)) {
	          // We do a preventDefault for all urls that are part of the angular application,
	          // in html5mode and also without, so that we are able to abort navigation without
	          // getting double entries in the location history.
	          event.preventDefault();
	          // update location manually
	          if ($location.absUrl() !== $browser.url()) {
	            $rootScope.$apply();
	            // hack to work around FF6 bug 684208 when scenario runner clicks on links
	            $window.angular['ff-684208-preventDefault'] = true;
	          }
	        }
	      }
	    });
	
	
	    // rewrite hashbang url <> html5 url
	    if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
	      $browser.url($location.absUrl(), true);
	    }
	
	    var initializing = true;
	
	    // update $location when $browser url changes
	    $browser.onUrlChange(function(newUrl, newState) {
	
	      if (!startsWith(newUrl, appBaseNoFile)) {
	        // If we are navigating outside of the app then force a reload
	        $window.location.href = newUrl;
	        return;
	      }
	
	      $rootScope.$evalAsync(function() {
	        var oldUrl = $location.absUrl();
	        var oldState = $location.$$state;
	        var defaultPrevented;
	        newUrl = trimEmptyHash(newUrl);
	        $location.$$parse(newUrl);
	        $location.$$state = newState;
	
	        defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	            newState, oldState).defaultPrevented;
	
	        // if the location was changed by a `$locationChangeStart` handler then stop
	        // processing this location change
	        if ($location.absUrl() !== newUrl) return;
	
	        if (defaultPrevented) {
	          $location.$$parse(oldUrl);
	          $location.$$state = oldState;
	          setBrowserUrlWithFallback(oldUrl, false, oldState);
	        } else {
	          initializing = false;
	          afterLocationChange(oldUrl, oldState);
	        }
	      });
	      if (!$rootScope.$$phase) $rootScope.$digest();
	    });
	
	    // update browser
	    $rootScope.$watch(function $locationWatch() {
	      if (initializing || $location.$$urlUpdatedByLocation) {
	        $location.$$urlUpdatedByLocation = false;
	
	        var oldUrl = trimEmptyHash($browser.url());
	        var newUrl = trimEmptyHash($location.absUrl());
	        var oldState = $browser.state();
	        var currentReplace = $location.$$replace;
	        var urlOrStateChanged = oldUrl !== newUrl ||
	          ($location.$$html5 && $sniffer.history && oldState !== $location.$$state);
	
	        if (initializing || urlOrStateChanged) {
	          initializing = false;
	
	          $rootScope.$evalAsync(function() {
	            var newUrl = $location.absUrl();
	            var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl,
	                $location.$$state, oldState).defaultPrevented;
	
	            // if the location was changed by a `$locationChangeStart` handler then stop
	            // processing this location change
	            if ($location.absUrl() !== newUrl) return;
	
	            if (defaultPrevented) {
	              $location.$$parse(oldUrl);
	              $location.$$state = oldState;
	            } else {
	              if (urlOrStateChanged) {
	                setBrowserUrlWithFallback(newUrl, currentReplace,
	                                          oldState === $location.$$state ? null : $location.$$state);
	              }
	              afterLocationChange(oldUrl, oldState);
	            }
	          });
	        }
	      }
	
	      $location.$$replace = false;
	
	      // we don't need to return anything because $evalAsync will make the digest loop dirty when
	      // there is a change
	    });
	
	    return $location;
	
	    function afterLocationChange(oldUrl, oldState) {
	      $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl,
	        $location.$$state, oldState);
	    }
	}];
	}
	
	/**
	 * @ngdoc service
	 * @name $log
	 * @requires $window
	 *
	 * @description
	 * Simple service for logging. Default implementation safely writes the message
	 * into the browser's console (if present).
	 *
	 * The main purpose of this service is to simplify debugging and troubleshooting.
	 *
	 * The default is to log `debug` messages. You can use
	 * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
	 *
	 * @example
	   <example module="logExample" name="log-service">
	     <file name="script.js">
	       angular.module('logExample', [])
	         .controller('LogController', ['$scope', '$log', function($scope, $log) {
	           $scope.$log = $log;
	           $scope.message = 'Hello World!';
	         }]);
	     </file>
	     <file name="index.html">
	       <div ng-controller="LogController">
	         <p>Reload this page with open console, enter text and hit the log button...</p>
	         <label>Message:
	         <input type="text" ng-model="message" /></label>
	         <button ng-click="$log.log(message)">log</button>
	         <button ng-click="$log.warn(message)">warn</button>
	         <button ng-click="$log.info(message)">info</button>
	         <button ng-click="$log.error(message)">error</button>
	         <button ng-click="$log.debug(message)">debug</button>
	       </div>
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc provider
	 * @name $logProvider
	 * @this
	 *
	 * @description
	 * Use the `$logProvider` to configure how the application logs messages
	 */
	function $LogProvider() {
	  var debug = true,
	      self = this;
	
	  /**
	   * @ngdoc method
	   * @name $logProvider#debugEnabled
	   * @description
	   * @param {boolean=} flag enable or disable debug level messages
	   * @returns {*} current value if used as getter or itself (chaining) if used as setter
	   */
	  this.debugEnabled = function(flag) {
	    if (isDefined(flag)) {
	      debug = flag;
	      return this;
	    } else {
	      return debug;
	    }
	  };
	
	  this.$get = ['$window', function($window) {
	    // Support: IE 9-11, Edge 12-14+
	    // IE/Edge display errors in such a way that it requires the user to click in 4 places
	    // to see the stack trace. There is no way to feature-detect it so there's a chance
	    // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
	    // break apps. Other browsers display errors in a sensible way and some of them map stack
	    // traces along source maps if available so it makes sense to let browsers display it
	    // as they want.
	    var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
	
	    return {
	      /**
	       * @ngdoc method
	       * @name $log#log
	       *
	       * @description
	       * Write a log message
	       */
	      log: consoleLog('log'),
	
	      /**
	       * @ngdoc method
	       * @name $log#info
	       *
	       * @description
	       * Write an information message
	       */
	      info: consoleLog('info'),
	
	      /**
	       * @ngdoc method
	       * @name $log#warn
	       *
	       * @description
	       * Write a warning message
	       */
	      warn: consoleLog('warn'),
	
	      /**
	       * @ngdoc method
	       * @name $log#error
	       *
	       * @description
	       * Write an error message
	       */
	      error: consoleLog('error'),
	
	      /**
	       * @ngdoc method
	       * @name $log#debug
	       *
	       * @description
	       * Write a debug message
	       */
	      debug: (function() {
	        var fn = consoleLog('debug');
	
	        return function() {
	          if (debug) {
	            fn.apply(self, arguments);
	          }
	        };
	      })()
	    };
	
	    function formatError(arg) {
	      if (arg instanceof Error) {
	        if (arg.stack && formatStackTrace) {
	          arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
	              ? 'Error: ' + arg.message + '\n' + arg.stack
	              : arg.stack;
	        } else if (arg.sourceURL) {
	          arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
	        }
	      }
	      return arg;
	    }
	
	    function consoleLog(type) {
	      var console = $window.console || {},
	          logFn = console[type] || console.log || noop,
	          hasApply = false;
	
	      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
	      // The reason behind this is that console.log has type "object" in IE8...
	      try {
	        hasApply = !!logFn.apply;
	      } catch (e) { /* empty */ }
	
	      if (hasApply) {
	        return function() {
	          var args = [];
	          forEach(arguments, function(arg) {
	            args.push(formatError(arg));
	          });
	          return logFn.apply(console, args);
	        };
	      }
	
	      // we are IE which either doesn't have window.console => this is noop and we do nothing,
	      // or we are IE where console.log doesn't have apply so we log at least first 2 args
	      return function(arg1, arg2) {
	        logFn(arg1, arg2 == null ? '' : arg2);
	      };
	    }
	  }];
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	var $parseMinErr = minErr('$parse');
	
	var objectValueOf = {}.constructor.prototype.valueOf;
	
	// Sandboxing Angular Expressions
	// ------------------------------
	// Angular expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
	// various means such as obtaining a reference to native JS functions like the Function constructor.
	//
	// As an example, consider the following Angular expression:
	//
	//   {}.toString.constructor('alert("evil JS code")')
	//
	// It is important to realize that if you create an expression from a string that contains user provided
	// content then it is possible that your application contains a security vulnerability to an XSS style attack.
	//
	// See https://docs.angularjs.org/guide/security
	
	
	function getStringValue(name) {
	  // Property names must be strings. This means that non-string objects cannot be used
	  // as keys in an object. Any non-string object, including a number, is typecasted
	  // into a string via the toString method.
	  // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
	  //
	  // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
	  // to a string. It's not always possible. If `name` is an object and its `toString` method is
	  // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
	  //
	  // TypeError: Cannot convert object to primitive value
	  //
	  // For performance reasons, we don't catch this error here and allow it to propagate up the call
	  // stack. Note that you'll get the same error in JavaScript if you try to access a property using
	  // such a 'broken' object as a key.
	  return name + '';
	}
	
	
	var OPERATORS = createMap();
	forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function(operator) { OPERATORS[operator] = true; });
	var ESCAPE = {'n':'\n', 'f':'\f', 'r':'\r', 't':'\t', 'v':'\v', '\'':'\'', '"':'"'};
	
	
	/////////////////////////////////////////
	
	
	/**
	 * @constructor
	 */
	var Lexer = function Lexer(options) {
	  this.options = options;
	};
	
	Lexer.prototype = {
	  constructor: Lexer,
	
	  lex: function(text) {
	    this.text = text;
	    this.index = 0;
	    this.tokens = [];
	
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      if (ch === '"' || ch === '\'') {
	        this.readString(ch);
	      } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
	        this.readNumber();
	      } else if (this.isIdentifierStart(this.peekMultichar())) {
	        this.readIdent();
	      } else if (this.is(ch, '(){}[].,;:?')) {
	        this.tokens.push({index: this.index, text: ch});
	        this.index++;
	      } else if (this.isWhitespace(ch)) {
	        this.index++;
	      } else {
	        var ch2 = ch + this.peek();
	        var ch3 = ch2 + this.peek(2);
	        var op1 = OPERATORS[ch];
	        var op2 = OPERATORS[ch2];
	        var op3 = OPERATORS[ch3];
	        if (op1 || op2 || op3) {
	          var token = op3 ? ch3 : (op2 ? ch2 : ch);
	          this.tokens.push({index: this.index, text: token, operator: true});
	          this.index += token.length;
	        } else {
	          this.throwError('Unexpected next character ', this.index, this.index + 1);
	        }
	      }
	    }
	    return this.tokens;
	  },
	
	  is: function(ch, chars) {
	    return chars.indexOf(ch) !== -1;
	  },
	
	  peek: function(i) {
	    var num = i || 1;
	    return (this.index + num < this.text.length) ? this.text.charAt(this.index + num) : false;
	  },
	
	  isNumber: function(ch) {
	    return ('0' <= ch && ch <= '9') && typeof ch === 'string';
	  },
	
	  isWhitespace: function(ch) {
	    // IE treats non-breaking space as \u00A0
	    return (ch === ' ' || ch === '\r' || ch === '\t' ||
	            ch === '\n' || ch === '\v' || ch === '\u00A0');
	  },
	
	  isIdentifierStart: function(ch) {
	    return this.options.isIdentifierStart ?
	        this.options.isIdentifierStart(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierStart(ch);
	  },
	
	  isValidIdentifierStart: function(ch) {
	    return ('a' <= ch && ch <= 'z' ||
	            'A' <= ch && ch <= 'Z' ||
	            '_' === ch || ch === '$');
	  },
	
	  isIdentifierContinue: function(ch) {
	    return this.options.isIdentifierContinue ?
	        this.options.isIdentifierContinue(ch, this.codePointAt(ch)) :
	        this.isValidIdentifierContinue(ch);
	  },
	
	  isValidIdentifierContinue: function(ch, cp) {
	    return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
	  },
	
	  codePointAt: function(ch) {
	    if (ch.length === 1) return ch.charCodeAt(0);
	    // eslint-disable-next-line no-bitwise
	    return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
	  },
	
	  peekMultichar: function() {
	    var ch = this.text.charAt(this.index);
	    var peek = this.peek();
	    if (!peek) {
	      return ch;
	    }
	    var cp1 = ch.charCodeAt(0);
	    var cp2 = peek.charCodeAt(0);
	    if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
	      return ch + peek;
	    }
	    return ch;
	  },
	
	  isExpOperator: function(ch) {
	    return (ch === '-' || ch === '+' || this.isNumber(ch));
	  },
	
	  throwError: function(error, start, end) {
	    end = end || this.index;
	    var colStr = (isDefined(start)
	            ? 's ' + start +  '-' + this.index + ' [' + this.text.substring(start, end) + ']'
	            : ' ' + end);
	    throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].',
	        error, colStr, this.text);
	  },
	
	  readNumber: function() {
	    var number = '';
	    var start = this.index;
	    while (this.index < this.text.length) {
	      var ch = lowercase(this.text.charAt(this.index));
	      if (ch === '.' || this.isNumber(ch)) {
	        number += ch;
	      } else {
	        var peekCh = this.peek();
	        if (ch === 'e' && this.isExpOperator(peekCh)) {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            peekCh && this.isNumber(peekCh) &&
	            number.charAt(number.length - 1) === 'e') {
	          number += ch;
	        } else if (this.isExpOperator(ch) &&
	            (!peekCh || !this.isNumber(peekCh)) &&
	            number.charAt(number.length - 1) === 'e') {
	          this.throwError('Invalid exponent');
	        } else {
	          break;
	        }
	      }
	      this.index++;
	    }
	    this.tokens.push({
	      index: start,
	      text: number,
	      constant: true,
	      value: Number(number)
	    });
	  },
	
	  readIdent: function() {
	    var start = this.index;
	    this.index += this.peekMultichar().length;
	    while (this.index < this.text.length) {
	      var ch = this.peekMultichar();
	      if (!this.isIdentifierContinue(ch)) {
	        break;
	      }
	      this.index += ch.length;
	    }
	    this.tokens.push({
	      index: start,
	      text: this.text.slice(start, this.index),
	      identifier: true
	    });
	  },
	
	  readString: function(quote) {
	    var start = this.index;
	    this.index++;
	    var string = '';
	    var rawString = quote;
	    var escape = false;
	    while (this.index < this.text.length) {
	      var ch = this.text.charAt(this.index);
	      rawString += ch;
	      if (escape) {
	        if (ch === 'u') {
	          var hex = this.text.substring(this.index + 1, this.index + 5);
	          if (!hex.match(/[\da-f]{4}/i)) {
	            this.throwError('Invalid unicode escape [\\u' + hex + ']');
	          }
	          this.index += 4;
	          string += String.fromCharCode(parseInt(hex, 16));
	        } else {
	          var rep = ESCAPE[ch];
	          string = string + (rep || ch);
	        }
	        escape = false;
	      } else if (ch === '\\') {
	        escape = true;
	      } else if (ch === quote) {
	        this.index++;
	        this.tokens.push({
	          index: start,
	          text: rawString,
	          constant: true,
	          value: string
	        });
	        return;
	      } else {
	        string += ch;
	      }
	      this.index++;
	    }
	    this.throwError('Unterminated quote', start);
	  }
	};
	
	var AST = function AST(lexer, options) {
	  this.lexer = lexer;
	  this.options = options;
	};
	
	AST.Program = 'Program';
	AST.ExpressionStatement = 'ExpressionStatement';
	AST.AssignmentExpression = 'AssignmentExpression';
	AST.ConditionalExpression = 'ConditionalExpression';
	AST.LogicalExpression = 'LogicalExpression';
	AST.BinaryExpression = 'BinaryExpression';
	AST.UnaryExpression = 'UnaryExpression';
	AST.CallExpression = 'CallExpression';
	AST.MemberExpression = 'MemberExpression';
	AST.Identifier = 'Identifier';
	AST.Literal = 'Literal';
	AST.ArrayExpression = 'ArrayExpression';
	AST.Property = 'Property';
	AST.ObjectExpression = 'ObjectExpression';
	AST.ThisExpression = 'ThisExpression';
	AST.LocalsExpression = 'LocalsExpression';
	
	// Internal use only
	AST.NGValueParameter = 'NGValueParameter';
	
	AST.prototype = {
	  ast: function(text) {
	    this.text = text;
	    this.tokens = this.lexer.lex(text);
	
	    var value = this.program();
	
	    if (this.tokens.length !== 0) {
	      this.throwError('is an unexpected token', this.tokens[0]);
	    }
	
	    return value;
	  },
	
	  program: function() {
	    var body = [];
	    while (true) {
	      if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']'))
	        body.push(this.expressionStatement());
	      if (!this.expect(';')) {
	        return { type: AST.Program, body: body};
	      }
	    }
	  },
	
	  expressionStatement: function() {
	    return { type: AST.ExpressionStatement, expression: this.filterChain() };
	  },
	
	  filterChain: function() {
	    var left = this.expression();
	    while (this.expect('|')) {
	      left = this.filter(left);
	    }
	    return left;
	  },
	
	  expression: function() {
	    return this.assignment();
	  },
	
	  assignment: function() {
	    var result = this.ternary();
	    if (this.expect('=')) {
	      if (!isAssignable(result)) {
	        throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
	      }
	
	      result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '='};
	    }
	    return result;
	  },
	
	  ternary: function() {
	    var test = this.logicalOR();
	    var alternate;
	    var consequent;
	    if (this.expect('?')) {
	      alternate = this.expression();
	      if (this.consume(':')) {
	        consequent = this.expression();
	        return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent};
	      }
	    }
	    return test;
	  },
	
	  logicalOR: function() {
	    var left = this.logicalAND();
	    while (this.expect('||')) {
	      left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
	    }
	    return left;
	  },
	
	  logicalAND: function() {
	    var left = this.equality();
	    while (this.expect('&&')) {
	      left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality()};
	    }
	    return left;
	  },
	
	  equality: function() {
	    var left = this.relational();
	    var token;
	    while ((token = this.expect('==','!=','===','!=='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
	    }
	    return left;
	  },
	
	  relational: function() {
	    var left = this.additive();
	    var token;
	    while ((token = this.expect('<', '>', '<=', '>='))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
	    }
	    return left;
	  },
	
	  additive: function() {
	    var left = this.multiplicative();
	    var token;
	    while ((token = this.expect('+','-'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
	    }
	    return left;
	  },
	
	  multiplicative: function() {
	    var left = this.unary();
	    var token;
	    while ((token = this.expect('*','/','%'))) {
	      left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
	    }
	    return left;
	  },
	
	  unary: function() {
	    var token;
	    if ((token = this.expect('+', '-', '!'))) {
	      return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
	    } else {
	      return this.primary();
	    }
	  },
	
	  primary: function() {
	    var primary;
	    if (this.expect('(')) {
	      primary = this.filterChain();
	      this.consume(')');
	    } else if (this.expect('[')) {
	      primary = this.arrayDeclaration();
	    } else if (this.expect('{')) {
	      primary = this.object();
	    } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
	      primary = copy(this.selfReferential[this.consume().text]);
	    } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
	      primary = { type: AST.Literal, value: this.options.literals[this.consume().text]};
	    } else if (this.peek().identifier) {
	      primary = this.identifier();
	    } else if (this.peek().constant) {
	      primary = this.constant();
	    } else {
	      this.throwError('not a primary expression', this.peek());
	    }
	
	    var next;
	    while ((next = this.expect('(', '[', '.'))) {
	      if (next.text === '(') {
	        primary = {type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
	        this.consume(')');
	      } else if (next.text === '[') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
	        this.consume(']');
	      } else if (next.text === '.') {
	        primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
	      } else {
	        this.throwError('IMPOSSIBLE');
	      }
	    }
	    return primary;
	  },
	
	  filter: function(baseExpression) {
	    var args = [baseExpression];
	    var result = {type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true};
	
	    while (this.expect(':')) {
	      args.push(this.expression());
	    }
	
	    return result;
	  },
	
	  parseArguments: function() {
	    var args = [];
	    if (this.peekToken().text !== ')') {
	      do {
	        args.push(this.filterChain());
	      } while (this.expect(','));
	    }
	    return args;
	  },
	
	  identifier: function() {
	    var token = this.consume();
	    if (!token.identifier) {
	      this.throwError('is not a valid identifier', token);
	    }
	    return { type: AST.Identifier, name: token.text };
	  },
	
	  constant: function() {
	    // TODO check that it is a constant
	    return { type: AST.Literal, value: this.consume().value };
	  },
	
	  arrayDeclaration: function() {
	    var elements = [];
	    if (this.peekToken().text !== ']') {
	      do {
	        if (this.peek(']')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        elements.push(this.expression());
	      } while (this.expect(','));
	    }
	    this.consume(']');
	
	    return { type: AST.ArrayExpression, elements: elements };
	  },
	
	  object: function() {
	    var properties = [], property;
	    if (this.peekToken().text !== '}') {
	      do {
	        if (this.peek('}')) {
	          // Support trailing commas per ES5.1.
	          break;
	        }
	        property = {type: AST.Property, kind: 'init'};
	        if (this.peek().constant) {
	          property.key = this.constant();
	          property.computed = false;
	          this.consume(':');
	          property.value = this.expression();
	        } else if (this.peek().identifier) {
	          property.key = this.identifier();
	          property.computed = false;
	          if (this.peek(':')) {
	            this.consume(':');
	            property.value = this.expression();
	          } else {
	            property.value = property.key;
	          }
	        } else if (this.peek('[')) {
	          this.consume('[');
	          property.key = this.expression();
	          this.consume(']');
	          property.computed = true;
	          this.consume(':');
	          property.value = this.expression();
	        } else {
	          this.throwError('invalid key', this.peek());
	        }
	        properties.push(property);
	      } while (this.expect(','));
	    }
	    this.consume('}');
	
	    return {type: AST.ObjectExpression, properties: properties };
	  },
	
	  throwError: function(msg, token) {
	    throw $parseMinErr('syntax',
	        'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].',
	          token.text, msg, (token.index + 1), this.text, this.text.substring(token.index));
	  },
	
	  consume: function(e1) {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	
	    var token = this.expect(e1);
	    if (!token) {
	      this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
	    }
	    return token;
	  },
	
	  peekToken: function() {
	    if (this.tokens.length === 0) {
	      throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
	    }
	    return this.tokens[0];
	  },
	
	  peek: function(e1, e2, e3, e4) {
	    return this.peekAhead(0, e1, e2, e3, e4);
	  },
	
	  peekAhead: function(i, e1, e2, e3, e4) {
	    if (this.tokens.length > i) {
	      var token = this.tokens[i];
	      var t = token.text;
	      if (t === e1 || t === e2 || t === e3 || t === e4 ||
	          (!e1 && !e2 && !e3 && !e4)) {
	        return token;
	      }
	    }
	    return false;
	  },
	
	  expect: function(e1, e2, e3, e4) {
	    var token = this.peek(e1, e2, e3, e4);
	    if (token) {
	      this.tokens.shift();
	      return token;
	    }
	    return false;
	  },
	
	  selfReferential: {
	    'this': {type: AST.ThisExpression },
	    '$locals': {type: AST.LocalsExpression }
	  }
	};
	
	function ifDefined(v, d) {
	  return typeof v !== 'undefined' ? v : d;
	}
	
	function plusFn(l, r) {
	  if (typeof l === 'undefined') return r;
	  if (typeof r === 'undefined') return l;
	  return l + r;
	}
	
	function isStateless($filter, filterName) {
	  var fn = $filter(filterName);
	  return !fn.$stateful;
	}
	
	function findConstantAndWatchExpressions(ast, $filter) {
	  var allConstants;
	  var argsToWatch;
	  var isStatelessFilter;
	  switch (ast.type) {
	  case AST.Program:
	    allConstants = true;
	    forEach(ast.body, function(expr) {
	      findConstantAndWatchExpressions(expr.expression, $filter);
	      allConstants = allConstants && expr.expression.constant;
	    });
	    ast.constant = allConstants;
	    break;
	  case AST.Literal:
	    ast.constant = true;
	    ast.toWatch = [];
	    break;
	  case AST.UnaryExpression:
	    findConstantAndWatchExpressions(ast.argument, $filter);
	    ast.constant = ast.argument.constant;
	    ast.toWatch = ast.argument.toWatch;
	    break;
	  case AST.BinaryExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
	    break;
	  case AST.LogicalExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.ConditionalExpression:
	    findConstantAndWatchExpressions(ast.test, $filter);
	    findConstantAndWatchExpressions(ast.alternate, $filter);
	    findConstantAndWatchExpressions(ast.consequent, $filter);
	    ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
	    ast.toWatch = ast.constant ? [] : [ast];
	    break;
	  case AST.Identifier:
	    ast.constant = false;
	    ast.toWatch = [ast];
	    break;
	  case AST.MemberExpression:
	    findConstantAndWatchExpressions(ast.object, $filter);
	    if (ast.computed) {
	      findConstantAndWatchExpressions(ast.property, $filter);
	    }
	    ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
	    ast.toWatch = [ast];
	    break;
	  case AST.CallExpression:
	    isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
	    allConstants = isStatelessFilter;
	    argsToWatch = [];
	    forEach(ast.arguments, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
	    break;
	  case AST.AssignmentExpression:
	    findConstantAndWatchExpressions(ast.left, $filter);
	    findConstantAndWatchExpressions(ast.right, $filter);
	    ast.constant = ast.left.constant && ast.right.constant;
	    ast.toWatch = [ast];
	    break;
	  case AST.ArrayExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.elements, function(expr) {
	      findConstantAndWatchExpressions(expr, $filter);
	      allConstants = allConstants && expr.constant;
	      if (!expr.constant) {
	        argsToWatch.push.apply(argsToWatch, expr.toWatch);
	      }
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ObjectExpression:
	    allConstants = true;
	    argsToWatch = [];
	    forEach(ast.properties, function(property) {
	      findConstantAndWatchExpressions(property.value, $filter);
	      allConstants = allConstants && property.value.constant && !property.computed;
	      if (!property.value.constant) {
	        argsToWatch.push.apply(argsToWatch, property.value.toWatch);
	      }
	      if (property.computed) {
	        findConstantAndWatchExpressions(property.key, $filter);
	        if (!property.key.constant) {
	          argsToWatch.push.apply(argsToWatch, property.key.toWatch);
	        }
	      }
	
	    });
	    ast.constant = allConstants;
	    ast.toWatch = argsToWatch;
	    break;
	  case AST.ThisExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  case AST.LocalsExpression:
	    ast.constant = false;
	    ast.toWatch = [];
	    break;
	  }
	}
	
	function getInputs(body) {
	  if (body.length !== 1) return;
	  var lastExpression = body[0].expression;
	  var candidate = lastExpression.toWatch;
	  if (candidate.length !== 1) return candidate;
	  return candidate[0] !== lastExpression ? candidate : undefined;
	}
	
	function isAssignable(ast) {
	  return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
	}
	
	function assignableAST(ast) {
	  if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
	    return {type: AST.AssignmentExpression, left: ast.body[0].expression, right: {type: AST.NGValueParameter}, operator: '='};
	  }
	}
	
	function isLiteral(ast) {
	  return ast.body.length === 0 ||
	      ast.body.length === 1 && (
	      ast.body[0].expression.type === AST.Literal ||
	      ast.body[0].expression.type === AST.ArrayExpression ||
	      ast.body[0].expression.type === AST.ObjectExpression);
	}
	
	function isConstant(ast) {
	  return ast.constant;
	}
	
	function ASTCompiler($filter) {
	  this.$filter = $filter;
	}
	
	ASTCompiler.prototype = {
	  compile: function(ast) {
	    var self = this;
	    this.state = {
	      nextId: 0,
	      filters: {},
	      fn: {vars: [], body: [], own: {}},
	      assign: {vars: [], body: [], own: {}},
	      inputs: []
	    };
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var extra = '';
	    var assignable;
	    this.stage = 'assign';
	    if ((assignable = assignableAST(ast))) {
	      this.state.computing = 'assign';
	      var result = this.nextId();
	      this.recurse(assignable, result);
	      this.return_(result);
	      extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
	    }
	    var toWatch = getInputs(ast.body);
	    self.stage = 'inputs';
	    forEach(toWatch, function(watch, key) {
	      var fnKey = 'fn' + key;
	      self.state[fnKey] = {vars: [], body: [], own: {}};
	      self.state.computing = fnKey;
	      var intoId = self.nextId();
	      self.recurse(watch, intoId);
	      self.return_(intoId);
	      self.state.inputs.push(fnKey);
	      watch.watchId = key;
	    });
	    this.state.computing = 'fn';
	    this.stage = 'main';
	    this.recurse(ast);
	    var fnString =
	      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
	      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
	      '"' + this.USE + ' ' + this.STRICT + '";\n' +
	      this.filterPrefix() +
	      'var fn=' + this.generateFunction('fn', 's,l,a,i') +
	      extra +
	      this.watchFns() +
	      'return fn;';
	
	    // eslint-disable-next-line no-new-func
	    var fn = (new Function('$filter',
	        'getStringValue',
	        'ifDefined',
	        'plus',
	        fnString))(
	          this.$filter,
	          getStringValue,
	          ifDefined,
	          plusFn);
	    this.state = this.stage = undefined;
	    return fn;
	  },
	
	  USE: 'use',
	
	  STRICT: 'strict',
	
	  watchFns: function() {
	    var result = [];
	    var fns = this.state.inputs;
	    var self = this;
	    forEach(fns, function(name) {
	      result.push('var ' + name + '=' + self.generateFunction(name, 's'));
	    });
	    if (fns.length) {
	      result.push('fn.inputs=[' + fns.join(',') + '];');
	    }
	    return result.join('');
	  },
	
	  generateFunction: function(name, params) {
	    return 'function(' + params + '){' +
	        this.varsPrefix(name) +
	        this.body(name) +
	        '};';
	  },
	
	  filterPrefix: function() {
	    var parts = [];
	    var self = this;
	    forEach(this.state.filters, function(id, filter) {
	      parts.push(id + '=$filter(' + self.escape(filter) + ')');
	    });
	    if (parts.length) return 'var ' + parts.join(',') + ';';
	    return '';
	  },
	
	  varsPrefix: function(section) {
	    return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
	  },
	
	  body: function(section) {
	    return this.state[section].body.join('');
	  },
	
	  recurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var left, right, self = this, args, expression, computed;
	    recursionFn = recursionFn || noop;
	    if (!skipWatchIdCheck && isDefined(ast.watchId)) {
	      intoId = intoId || this.nextId();
	      this.if_('i',
	        this.lazyAssign(intoId, this.computedMember('i', ast.watchId)),
	        this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true)
	      );
	      return;
	    }
	    switch (ast.type) {
	    case AST.Program:
	      forEach(ast.body, function(expression, pos) {
	        self.recurse(expression.expression, undefined, undefined, function(expr) { right = expr; });
	        if (pos !== ast.body.length - 1) {
	          self.current().body.push(right, ';');
	        } else {
	          self.return_(right);
	        }
	      });
	      break;
	    case AST.Literal:
	      expression = this.escape(ast.value);
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.UnaryExpression:
	      this.recurse(ast.argument, undefined, undefined, function(expr) { right = expr; });
	      expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.BinaryExpression:
	      this.recurse(ast.left, undefined, undefined, function(expr) { left = expr; });
	      this.recurse(ast.right, undefined, undefined, function(expr) { right = expr; });
	      if (ast.operator === '+') {
	        expression = this.plus(left, right);
	      } else if (ast.operator === '-') {
	        expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
	      } else {
	        expression = '(' + left + ')' + ast.operator + '(' + right + ')';
	      }
	      this.assign(intoId, expression);
	      recursionFn(expression);
	      break;
	    case AST.LogicalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.left, intoId);
	      self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.ConditionalExpression:
	      intoId = intoId || this.nextId();
	      self.recurse(ast.test, intoId);
	      self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
	      recursionFn(intoId);
	      break;
	    case AST.Identifier:
	      intoId = intoId || this.nextId();
	      if (nameId) {
	        nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
	        nameId.computed = false;
	        nameId.name = ast.name;
	      }
	      self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)),
	        function() {
	          self.if_(self.stage === 'inputs' || 's', function() {
	            if (create && create !== 1) {
	              self.if_(
	                self.isNull(self.nonComputedMember('s', ast.name)),
	                self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
	            }
	            self.assign(intoId, self.nonComputedMember('s', ast.name));
	          });
	        }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name))
	        );
	      recursionFn(intoId);
	      break;
	    case AST.MemberExpression:
	      left = nameId && (nameId.context = this.nextId()) || this.nextId();
	      intoId = intoId || this.nextId();
	      self.recurse(ast.object, left, undefined, function() {
	        self.if_(self.notNull(left), function() {
	          if (ast.computed) {
	            right = self.nextId();
	            self.recurse(ast.property, right);
	            self.getStringValue(right);
	            if (create && create !== 1) {
	              self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
	            }
	            expression = self.computedMember(left, right);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = true;
	              nameId.name = right;
	            }
	          } else {
	            if (create && create !== 1) {
	              self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
	            }
	            expression = self.nonComputedMember(left, ast.property.name);
	            self.assign(intoId, expression);
	            if (nameId) {
	              nameId.computed = false;
	              nameId.name = ast.property.name;
	            }
	          }
	        }, function() {
	          self.assign(intoId, 'undefined');
	        });
	        recursionFn(intoId);
	      }, !!create);
	      break;
	    case AST.CallExpression:
	      intoId = intoId || this.nextId();
	      if (ast.filter) {
	        right = self.filter(ast.callee.name);
	        args = [];
	        forEach(ast.arguments, function(expr) {
	          var argument = self.nextId();
	          self.recurse(expr, argument);
	          args.push(argument);
	        });
	        expression = right + '(' + args.join(',') + ')';
	        self.assign(intoId, expression);
	        recursionFn(intoId);
	      } else {
	        right = self.nextId();
	        left = {};
	        args = [];
	        self.recurse(ast.callee, right, left, function() {
	          self.if_(self.notNull(right), function() {
	            forEach(ast.arguments, function(expr) {
	              self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	                args.push(argument);
	              });
	            });
	            if (left.name) {
	              expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
	            } else {
	              expression = right + '(' + args.join(',') + ')';
	            }
	            self.assign(intoId, expression);
	          }, function() {
	            self.assign(intoId, 'undefined');
	          });
	          recursionFn(intoId);
	        });
	      }
	      break;
	    case AST.AssignmentExpression:
	      right = this.nextId();
	      left = {};
	      this.recurse(ast.left, undefined, left, function() {
	        self.if_(self.notNull(left.context), function() {
	          self.recurse(ast.right, right);
	          expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
	          self.assign(intoId, expression);
	          recursionFn(intoId || expression);
	        });
	      }, 1);
	      break;
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function(argument) {
	          args.push(argument);
	        });
	      });
	      expression = '[' + args.join(',') + ']';
	      this.assign(intoId, expression);
	      recursionFn(intoId || expression);
	      break;
	    case AST.ObjectExpression:
	      args = [];
	      computed = false;
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          computed = true;
	        }
	      });
	      if (computed) {
	        intoId = intoId || this.nextId();
	        this.assign(intoId, '{}');
	        forEach(ast.properties, function(property) {
	          if (property.computed) {
	            left = self.nextId();
	            self.recurse(property.key, left);
	          } else {
	            left = property.key.type === AST.Identifier ?
	                       property.key.name :
	                       ('' + property.key.value);
	          }
	          right = self.nextId();
	          self.recurse(property.value, right);
	          self.assign(self.member(intoId, left, property.computed), right);
	        });
	      } else {
	        forEach(ast.properties, function(property) {
	          self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function(expr) {
	            args.push(self.escape(
	                property.key.type === AST.Identifier ? property.key.name :
	                  ('' + property.key.value)) +
	                ':' + expr);
	          });
	        });
	        expression = '{' + args.join(',') + '}';
	        this.assign(intoId, expression);
	      }
	      recursionFn(intoId || expression);
	      break;
	    case AST.ThisExpression:
	      this.assign(intoId, 's');
	      recursionFn(intoId || 's');
	      break;
	    case AST.LocalsExpression:
	      this.assign(intoId, 'l');
	      recursionFn(intoId || 'l');
	      break;
	    case AST.NGValueParameter:
	      this.assign(intoId, 'v');
	      recursionFn(intoId || 'v');
	      break;
	    }
	  },
	
	  getHasOwnProperty: function(element, property) {
	    var key = element + '.' + property;
	    var own = this.current().own;
	    if (!own.hasOwnProperty(key)) {
	      own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
	    }
	    return own[key];
	  },
	
	  assign: function(id, value) {
	    if (!id) return;
	    this.current().body.push(id, '=', value, ';');
	    return id;
	  },
	
	  filter: function(filterName) {
	    if (!this.state.filters.hasOwnProperty(filterName)) {
	      this.state.filters[filterName] = this.nextId(true);
	    }
	    return this.state.filters[filterName];
	  },
	
	  ifDefined: function(id, defaultValue) {
	    return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
	  },
	
	  plus: function(left, right) {
	    return 'plus(' + left + ',' + right + ')';
	  },
	
	  return_: function(id) {
	    this.current().body.push('return ', id, ';');
	  },
	
	  if_: function(test, alternate, consequent) {
	    if (test === true) {
	      alternate();
	    } else {
	      var body = this.current().body;
	      body.push('if(', test, '){');
	      alternate();
	      body.push('}');
	      if (consequent) {
	        body.push('else{');
	        consequent();
	        body.push('}');
	      }
	    }
	  },
	
	  not: function(expression) {
	    return '!(' + expression + ')';
	  },
	
	  isNull: function(expression) {
	    return expression + '==null';
	  },
	
	  notNull: function(expression) {
	    return expression + '!=null';
	  },
	
	  nonComputedMember: function(left, right) {
	    var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
	    var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
	    if (SAFE_IDENTIFIER.test(right)) {
	      return left + '.' + right;
	    } else {
	      return left  + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
	    }
	  },
	
	  computedMember: function(left, right) {
	    return left + '[' + right + ']';
	  },
	
	  member: function(left, right, computed) {
	    if (computed) return this.computedMember(left, right);
	    return this.nonComputedMember(left, right);
	  },
	
	  getStringValue: function(item) {
	    this.assign(item, 'getStringValue(' + item + ')');
	  },
	
	  lazyRecurse: function(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
	    var self = this;
	    return function() {
	      self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
	    };
	  },
	
	  lazyAssign: function(id, value) {
	    var self = this;
	    return function() {
	      self.assign(id, value);
	    };
	  },
	
	  stringEscapeRegex: /[^ a-zA-Z0-9]/g,
	
	  stringEscapeFn: function(c) {
	    return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
	  },
	
	  escape: function(value) {
	    if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
	    if (isNumber(value)) return value.toString();
	    if (value === true) return 'true';
	    if (value === false) return 'false';
	    if (value === null) return 'null';
	    if (typeof value === 'undefined') return 'undefined';
	
	    throw $parseMinErr('esc', 'IMPOSSIBLE');
	  },
	
	  nextId: function(skip, init) {
	    var id = 'v' + (this.state.nextId++);
	    if (!skip) {
	      this.current().vars.push(id + (init ? '=' + init : ''));
	    }
	    return id;
	  },
	
	  current: function() {
	    return this.state[this.state.computing];
	  }
	};
	
	
	function ASTInterpreter($filter) {
	  this.$filter = $filter;
	}
	
	ASTInterpreter.prototype = {
	  compile: function(ast) {
	    var self = this;
	    findConstantAndWatchExpressions(ast, self.$filter);
	    var assignable;
	    var assign;
	    if ((assignable = assignableAST(ast))) {
	      assign = this.recurse(assignable);
	    }
	    var toWatch = getInputs(ast.body);
	    var inputs;
	    if (toWatch) {
	      inputs = [];
	      forEach(toWatch, function(watch, key) {
	        var input = self.recurse(watch);
	        watch.input = input;
	        inputs.push(input);
	        watch.watchId = key;
	      });
	    }
	    var expressions = [];
	    forEach(ast.body, function(expression) {
	      expressions.push(self.recurse(expression.expression));
	    });
	    var fn = ast.body.length === 0 ? noop :
	             ast.body.length === 1 ? expressions[0] :
	             function(scope, locals) {
	               var lastValue;
	               forEach(expressions, function(exp) {
	                 lastValue = exp(scope, locals);
	               });
	               return lastValue;
	             };
	    if (assign) {
	      fn.assign = function(scope, value, locals) {
	        return assign(scope, locals, value);
	      };
	    }
	    if (inputs) {
	      fn.inputs = inputs;
	    }
	    return fn;
	  },
	
	  recurse: function(ast, context, create) {
	    var left, right, self = this, args;
	    if (ast.input) {
	      return this.inputs(ast.input, ast.watchId);
	    }
	    switch (ast.type) {
	    case AST.Literal:
	      return this.value(ast.value, context);
	    case AST.UnaryExpression:
	      right = this.recurse(ast.argument);
	      return this['unary' + ast.operator](right, context);
	    case AST.BinaryExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.LogicalExpression:
	      left = this.recurse(ast.left);
	      right = this.recurse(ast.right);
	      return this['binary' + ast.operator](left, right, context);
	    case AST.ConditionalExpression:
	      return this['ternary?:'](
	        this.recurse(ast.test),
	        this.recurse(ast.alternate),
	        this.recurse(ast.consequent),
	        context
	      );
	    case AST.Identifier:
	      return self.identifier(ast.name, context, create);
	    case AST.MemberExpression:
	      left = this.recurse(ast.object, false, !!create);
	      if (!ast.computed) {
	        right = ast.property.name;
	      }
	      if (ast.computed) right = this.recurse(ast.property);
	      return ast.computed ?
	        this.computedMember(left, right, context, create) :
	        this.nonComputedMember(left, right, context, create);
	    case AST.CallExpression:
	      args = [];
	      forEach(ast.arguments, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      if (ast.filter) right = this.$filter(ast.callee.name);
	      if (!ast.filter) right = this.recurse(ast.callee, true);
	      return ast.filter ?
	        function(scope, locals, assign, inputs) {
	          var values = [];
	          for (var i = 0; i < args.length; ++i) {
	            values.push(args[i](scope, locals, assign, inputs));
	          }
	          var value = right.apply(undefined, values, inputs);
	          return context ? {context: undefined, name: undefined, value: value} : value;
	        } :
	        function(scope, locals, assign, inputs) {
	          var rhs = right(scope, locals, assign, inputs);
	          var value;
	          if (rhs.value != null) {
	            var values = [];
	            for (var i = 0; i < args.length; ++i) {
	              values.push(args[i](scope, locals, assign, inputs));
	            }
	            value = rhs.value.apply(rhs.context, values);
	          }
	          return context ? {value: value} : value;
	        };
	    case AST.AssignmentExpression:
	      left = this.recurse(ast.left, true, 1);
	      right = this.recurse(ast.right);
	      return function(scope, locals, assign, inputs) {
	        var lhs = left(scope, locals, assign, inputs);
	        var rhs = right(scope, locals, assign, inputs);
	        lhs.context[lhs.name] = rhs;
	        return context ? {value: rhs} : rhs;
	      };
	    case AST.ArrayExpression:
	      args = [];
	      forEach(ast.elements, function(expr) {
	        args.push(self.recurse(expr));
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = [];
	        for (var i = 0; i < args.length; ++i) {
	          value.push(args[i](scope, locals, assign, inputs));
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ObjectExpression:
	      args = [];
	      forEach(ast.properties, function(property) {
	        if (property.computed) {
	          args.push({key: self.recurse(property.key),
	                     computed: true,
	                     value: self.recurse(property.value)
	          });
	        } else {
	          args.push({key: property.key.type === AST.Identifier ?
	                          property.key.name :
	                          ('' + property.key.value),
	                     computed: false,
	                     value: self.recurse(property.value)
	          });
	        }
	      });
	      return function(scope, locals, assign, inputs) {
	        var value = {};
	        for (var i = 0; i < args.length; ++i) {
	          if (args[i].computed) {
	            value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
	          } else {
	            value[args[i].key] = args[i].value(scope, locals, assign, inputs);
	          }
	        }
	        return context ? {value: value} : value;
	      };
	    case AST.ThisExpression:
	      return function(scope) {
	        return context ? {value: scope} : scope;
	      };
	    case AST.LocalsExpression:
	      return function(scope, locals) {
	        return context ? {value: locals} : locals;
	      };
	    case AST.NGValueParameter:
	      return function(scope, locals, assign) {
	        return context ? {value: assign} : assign;
	      };
	    }
	  },
	
	  'unary+': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = +arg;
	      } else {
	        arg = 0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary-': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = argument(scope, locals, assign, inputs);
	      if (isDefined(arg)) {
	        arg = -arg;
	      } else {
	        arg = -0;
	      }
	      return context ? {value: arg} : arg;
	    };
	  },
	  'unary!': function(argument, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = !argument(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary+': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = plusFn(lhs, rhs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary-': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs = right(scope, locals, assign, inputs);
	      var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary*': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary/': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary%': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary===': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary==': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary!=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      // eslint-disable-next-line eqeqeq
	      var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary<=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary>=': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary&&': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'binary||': function(left, right, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  'ternary?:': function(test, alternate, consequent, context) {
	    return function(scope, locals, assign, inputs) {
	      var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
	      return context ? {value: arg} : arg;
	    };
	  },
	  value: function(value, context) {
	    return function() { return context ? {context: undefined, name: undefined, value: value} : value; };
	  },
	  identifier: function(name, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var base = locals && (name in locals) ? locals : scope;
	      if (create && create !== 1 && base && base[name] == null) {
	        base[name] = {};
	      }
	      var value = base ? base[name] : undefined;
	      if (context) {
	        return {context: base, name: name, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  computedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      var rhs;
	      var value;
	      if (lhs != null) {
	        rhs = right(scope, locals, assign, inputs);
	        rhs = getStringValue(rhs);
	        if (create && create !== 1) {
	          if (lhs && !(lhs[rhs])) {
	            lhs[rhs] = {};
	          }
	        }
	        value = lhs[rhs];
	      }
	      if (context) {
	        return {context: lhs, name: rhs, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  nonComputedMember: function(left, right, context, create) {
	    return function(scope, locals, assign, inputs) {
	      var lhs = left(scope, locals, assign, inputs);
	      if (create && create !== 1) {
	        if (lhs && lhs[right] == null) {
	          lhs[right] = {};
	        }
	      }
	      var value = lhs != null ? lhs[right] : undefined;
	      if (context) {
	        return {context: lhs, name: right, value: value};
	      } else {
	        return value;
	      }
	    };
	  },
	  inputs: function(input, watchId) {
	    return function(scope, value, locals, inputs) {
	      if (inputs) return inputs[watchId];
	      return input(scope, value, locals);
	    };
	  }
	};
	
	/**
	 * @constructor
	 */
	function Parser(lexer, $filter, options) {
	  this.ast = new AST(lexer, options);
	  this.astCompiler = options.csp ? new ASTInterpreter($filter) :
	                                   new ASTCompiler($filter);
	}
	
	Parser.prototype = {
	  constructor: Parser,
	
	  parse: function(text) {
	    var ast = this.ast.ast(text);
	    var fn = this.astCompiler.compile(ast);
	    fn.literal = isLiteral(ast);
	    fn.constant = isConstant(ast);
	    return fn;
	  }
	};
	
	function getValueOf(value) {
	  return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
	}
	
	///////////////////////////////////
	
	/**
	 * @ngdoc service
	 * @name $parse
	 * @kind function
	 *
	 * @description
	 *
	 * Converts Angular {@link guide/expression expression} into a function.
	 *
	 * ```js
	 *   var getter = $parse('user.name');
	 *   var setter = getter.assign;
	 *   var context = {user:{name:'angular'}};
	 *   var locals = {user:{name:'local'}};
	 *
	 *   expect(getter(context)).toEqual('angular');
	 *   setter(context, 'newValue');
	 *   expect(context.user.name).toEqual('newValue');
	 *   expect(getter(context, locals)).toEqual('local');
	 * ```
	 *
	 *
	 * @param {string} expression String expression to compile.
	 * @returns {function(context, locals)} a function which represents the compiled expression:
	 *
	 *    * `context` – `{object}` – an object against which any expressions embedded in the strings
	 *      are evaluated against (typically a scope object).
	 *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
	 *      `context`.
	 *
	 *    The returned function also has the following properties:
	 *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
	 *        literal.
	 *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
	 *        constant literals.
	 *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
	 *        set to a function to change its value on the given context.
	 *
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $parseProvider
	 * @this
	 *
	 * @description
	 * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
	 *  service.
	 */
	function $ParseProvider() {
	  var cache = createMap();
	  var literals = {
	    'true': true,
	    'false': false,
	    'null': null,
	    'undefined': undefined
	  };
	  var identStart, identContinue;
	
	  /**
	   * @ngdoc method
	   * @name $parseProvider#addLiteral
	   * @description
	   *
	   * Configure $parse service to add literal values that will be present as literal at expressions.
	   *
	   * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
	   * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
	   *
	   **/
	  this.addLiteral = function(literalName, literalValue) {
	    literals[literalName] = literalValue;
	  };
	
	 /**
	  * @ngdoc method
	  * @name $parseProvider#setIdentifierFns
	  *
	  * @description
	  *
	  * Allows defining the set of characters that are allowed in Angular expressions. The function
	  * `identifierStart` will get called to know if a given character is a valid character to be the
	  * first character for an identifier. The function `identifierContinue` will get called to know if
	  * a given character is a valid character to be a follow-up identifier character. The functions
	  * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
	  * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
	  * mind that the `string` parameter can be two characters long depending on the character
	  * representation. It is expected for the function to return `true` or `false`, whether that
	  * character is allowed or not.
	  *
	  * Since this function will be called extensively, keep the implementation of these functions fast,
	  * as the performance of these functions have a direct impact on the expressions parsing speed.
	  *
	  * @param {function=} identifierStart The function that will decide whether the given character is
	  *   a valid identifier start character.
	  * @param {function=} identifierContinue The function that will decide whether the given character is
	  *   a valid identifier continue character.
	  */
	  this.setIdentifierFns = function(identifierStart, identifierContinue) {
	    identStart = identifierStart;
	    identContinue = identifierContinue;
	    return this;
	  };
	
	  this.$get = ['$filter', function($filter) {
	    var noUnsafeEval = csp().noUnsafeEval;
	    var $parseOptions = {
	          csp: noUnsafeEval,
	          literals: copy(literals),
	          isIdentifierStart: isFunction(identStart) && identStart,
	          isIdentifierContinue: isFunction(identContinue) && identContinue
	        };
	    return $parse;
	
	    function $parse(exp, interceptorFn) {
	      var parsedExpression, oneTime, cacheKey;
	
	      switch (typeof exp) {
	        case 'string':
	          exp = exp.trim();
	          cacheKey = exp;
	
	          parsedExpression = cache[cacheKey];
	
	          if (!parsedExpression) {
	            if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
	              oneTime = true;
	              exp = exp.substring(2);
	            }
	            var lexer = new Lexer($parseOptions);
	            var parser = new Parser(lexer, $filter, $parseOptions);
	            parsedExpression = parser.parse(exp);
	            if (parsedExpression.constant) {
	              parsedExpression.$$watchDelegate = constantWatchDelegate;
	            } else if (oneTime) {
	              parsedExpression.oneTime = true;
	              parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
	            } else if (parsedExpression.inputs) {
	              parsedExpression.$$watchDelegate = inputsWatchDelegate;
	            }
	            cache[cacheKey] = parsedExpression;
	          }
	          return addInterceptor(parsedExpression, interceptorFn);
	
	        case 'function':
	          return addInterceptor(exp, interceptorFn);
	
	        default:
	          return addInterceptor(noop, interceptorFn);
	      }
	    }
	
	    function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
	
	      if (newValue == null || oldValueOfValue == null) { // null/undefined
	        return newValue === oldValueOfValue;
	      }
	
	      if (typeof newValue === 'object') {
	
	        // attempt to convert the value to a primitive type
	        // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
	        //             be cheaply dirty-checked
	        newValue = getValueOf(newValue);
	
	        if (typeof newValue === 'object' && !compareObjectIdentity) {
	          // objects/arrays are not supported - deep-watching them would be too expensive
	          return false;
	        }
	
	        // fall-through to the primitive equality check
	      }
	
	      //Primitive or NaN
	      // eslint-disable-next-line no-self-compare
	      return newValue === oldValueOfValue || (newValue !== newValue && oldValueOfValue !== oldValueOfValue);
	    }
	
	    function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var inputExpressions = parsedExpression.inputs;
	      var lastResult;
	
	      if (inputExpressions.length === 1) {
	        var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        inputExpressions = inputExpressions[0];
	        return scope.$watch(function expressionInputWatch(scope) {
	          var newInputValue = inputExpressions(scope);
	          if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, parsedExpression.literal)) {
	            lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
	            oldInputValueOf = newInputValue && getValueOf(newInputValue);
	          }
	          return lastResult;
	        }, listener, objectEquality, prettyPrintExpression);
	      }
	
	      var oldInputValueOfValues = [];
	      var oldInputValues = [];
	      for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	        oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
	        oldInputValues[i] = null;
	      }
	
	      return scope.$watch(function expressionInputsWatch(scope) {
	        var changed = false;
	
	        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
	          var newInputValue = inputExpressions[i](scope);
	          if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], parsedExpression.literal))) {
	            oldInputValues[i] = newInputValue;
	            oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
	          }
	        }
	
	        if (changed) {
	          lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
	        }
	
	        return lastResult;
	      }, listener, objectEquality, prettyPrintExpression);
	    }
	
	    function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	      var unwatch, lastValue;
	      if (parsedExpression.inputs) {
	        unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
	      } else {
	        unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
	      }
	      return unwatch;
	
	      function oneTimeWatch(scope) {
	        return parsedExpression(scope);
	      }
	      function oneTimeListener(value, old, scope) {
	        lastValue = value;
	        if (isFunction(listener)) {
	          listener(value, old, scope);
	        }
	        if (isDone(value)) {
	          scope.$$postDigest(function() {
	            if (isDone(lastValue)) {
	              unwatch();
	            }
	          });
	        }
	      }
	    }
	
	    function isAllDefined(value) {
	      var allDefined = true;
	      forEach(value, function(val) {
	        if (!isDefined(val)) allDefined = false;
	      });
	      return allDefined;
	    }
	
	    function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
	      var unwatch = scope.$watch(function constantWatch(scope) {
	        unwatch();
	        return parsedExpression(scope);
	      }, listener, objectEquality);
	      return unwatch;
	    }
	
	    function addInterceptor(parsedExpression, interceptorFn) {
	      if (!interceptorFn) return parsedExpression;
	      var watchDelegate = parsedExpression.$$watchDelegate;
	      var useInputs = false;
	
	      var isDone = parsedExpression.literal ? isAllDefined : isDefined;
	
	      function regularInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        return interceptorFn(value, scope, locals);
	      }
	
	      function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
	        var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
	        var result = interceptorFn(value, scope, locals);
	        // we only return the interceptor's result if the
	        // initial value is defined (for bind-once)
	        return isDone(value) ? result : value;
	      }
	
	      var fn = parsedExpression.oneTime ? oneTimeInterceptedExpression : regularInterceptedExpression;
	
	      // Propogate the literal/oneTime attributes
	      fn.literal = parsedExpression.literal;
	      fn.oneTime = parsedExpression.oneTime;
	
	      // Propagate or create inputs / $$watchDelegates
	      useInputs = !parsedExpression.inputs;
	      if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
	        fn.$$watchDelegate = watchDelegate;
	        fn.inputs = parsedExpression.inputs;
	      } else if (!interceptorFn.$stateful) {
	        // If there is an interceptor, but no watchDelegate then treat the interceptor like
	        // we treat filters - it is assumed to be a pure function unless flagged with $stateful
	        fn.$$watchDelegate = inputsWatchDelegate;
	        fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
	      }
	
	      return fn;
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $q
	 * @requires $rootScope
	 *
	 * @description
	 * A service that helps you run functions asynchronously, and use their return values (or exceptions)
	 * when they are done processing.
	 *
	 * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
	 * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
	 *
	 * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
	 * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
	 *
	 * # $q constructor
	 *
	 * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
	 * function as the first argument. This is similar to the native Promise implementation from ES6,
	 * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
	 *
	 * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
	 * available yet.
	 *
	 * It can be used like so:
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
	 *     return $q(function(resolve, reject) {
	 *       setTimeout(function() {
	 *         if (okToGreet(name)) {
	 *           resolve('Hello, ' + name + '!');
	 *         } else {
	 *           reject('Greeting ' + name + ' is not allowed.');
	 *         }
	 *       }, 1000);
	 *     });
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   });
	 * ```
	 *
	 * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
	 *
	 * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
	 *
	 * However, the more traditional CommonJS-style usage is still available, and documented below.
	 *
	 * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
	 * interface for interacting with an object that represents the result of an action that is
	 * performed asynchronously, and may or may not be finished at any given point in time.
	 *
	 * From the perspective of dealing with error handling, deferred and promise APIs are to
	 * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
	 *
	 * ```js
	 *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
	 *   // are available in the current lexical scope (they could have been injected or passed in).
	 *
	 *   function asyncGreet(name) {
	 *     var deferred = $q.defer();
	 *
	 *     setTimeout(function() {
	 *       deferred.notify('About to greet ' + name + '.');
	 *
	 *       if (okToGreet(name)) {
	 *         deferred.resolve('Hello, ' + name + '!');
	 *       } else {
	 *         deferred.reject('Greeting ' + name + ' is not allowed.');
	 *       }
	 *     }, 1000);
	 *
	 *     return deferred.promise;
	 *   }
	 *
	 *   var promise = asyncGreet('Robin Hood');
	 *   promise.then(function(greeting) {
	 *     alert('Success: ' + greeting);
	 *   }, function(reason) {
	 *     alert('Failed: ' + reason);
	 *   }, function(update) {
	 *     alert('Got notification: ' + update);
	 *   });
	 * ```
	 *
	 * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
	 * comes in the way of guarantees that promise and deferred APIs make, see
	 * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
	 *
	 * Additionally the promise api allows for composition that is very hard to do with the
	 * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
	 * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
	 * section on serial or parallel joining of promises.
	 *
	 * # The Deferred API
	 *
	 * A new instance of deferred is constructed by calling `$q.defer()`.
	 *
	 * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
	 * that can be used for signaling the successful or unsuccessful completion, as well as the status
	 * of the task.
	 *
	 * **Methods**
	 *
	 * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
	 *   constructed via `$q.reject`, the promise will be rejected instead.
	 * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
	 *   resolving it with a rejection constructed via `$q.reject`.
	 * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
	 *   multiple times before the promise is either resolved or rejected.
	 *
	 * **Properties**
	 *
	 * - promise – `{Promise}` – promise object associated with this deferred.
	 *
	 *
	 * # The Promise API
	 *
	 * A new promise instance is created when a deferred instance is created and can be retrieved by
	 * calling `deferred.promise`.
	 *
	 * The purpose of the promise object is to allow for interested parties to get access to the result
	 * of the deferred task when it completes.
	 *
	 * **Methods**
	 *
	 * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
	 *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
	 *   as soon as the result is available. The callbacks are called with a single argument: the result
	 *   or rejection reason. Additionally, the notify callback may be called zero or more times to
	 *   provide a progress indication, before the promise is resolved or rejected.
	 *
	 *   This method *returns a new promise* which is resolved or rejected via the return value of the
	 *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
	 *   with the value which is resolved in that promise using
	 *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
	 *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
	 *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
	 *   arguments are optional.
	 *
	 * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
	 *
	 * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
	 *   but to do so without modifying the final value. This is useful to release resources or do some
	 *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
	 *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
	 *   more information.
	 *
	 * # Chaining promises
	 *
	 * Because calling the `then` method of a promise returns a new derived promise, it is easily
	 * possible to create a chain of promises:
	 *
	 * ```js
	 *   promiseB = promiseA.then(function(result) {
	 *     return result + 1;
	 *   });
	 *
	 *   // promiseB will be resolved immediately after promiseA is resolved and its value
	 *   // will be the result of promiseA incremented by 1
	 * ```
	 *
	 * It is possible to create chains of any length and since a promise can be resolved with another
	 * promise (which will defer its resolution further), it is possible to pause/defer resolution of
	 * the promises at any point in the chain. This makes it possible to implement powerful APIs like
	 * $http's response interceptors.
	 *
	 *
	 * # Differences between Kris Kowal's Q and $q
	 *
	 *  There are two main differences:
	 *
	 * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
	 *   mechanism in angular, which means faster propagation of resolution or rejection into your
	 *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
	 * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
	 *   all the important functionality needed for common async tasks.
	 *
	 * # Testing
	 *
	 *  ```js
	 *    it('should simulate promise', inject(function($q, $rootScope) {
	 *      var deferred = $q.defer();
	 *      var promise = deferred.promise;
	 *      var resolvedValue;
	 *
	 *      promise.then(function(value) { resolvedValue = value; });
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Simulate resolving of promise
	 *      deferred.resolve(123);
	 *      // Note that the 'then' function does not get called synchronously.
	 *      // This is because we want the promise API to always be async, whether or not
	 *      // it got called synchronously or asynchronously.
	 *      expect(resolvedValue).toBeUndefined();
	 *
	 *      // Propagate promise resolution to 'then' functions using $apply().
	 *      $rootScope.$apply();
	 *      expect(resolvedValue).toEqual(123);
	 *    }));
	 *  ```
	 *
	 * @param {function(function, function)} resolver Function which is responsible for resolving or
	 *   rejecting the newly created promise. The first parameter is a function which resolves the
	 *   promise, the second parameter is a function which rejects the promise.
	 *
	 * @returns {Promise} The newly created promise.
	 */
	/**
	 * @ngdoc provider
	 * @name $qProvider
	 * @this
	 *
	 * @description
	 */
	function $QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$rootScope', '$exceptionHandler', function($rootScope, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $rootScope.$evalAsync(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  /**
	   * @ngdoc method
	   * @name $qProvider#errorOnUnhandledRejections
	   * @kind function
	   *
	   * @description
	   * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
	   * This feature is enabled by default.
	   *
	   * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
	   * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
	   *    chaining otherwise.
	   */
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/** @this */
	function $$QProvider() {
	  var errorOnUnhandledRejections = true;
	  this.$get = ['$browser', '$exceptionHandler', function($browser, $exceptionHandler) {
	    return qFactory(function(callback) {
	      $browser.defer(callback);
	    }, $exceptionHandler, errorOnUnhandledRejections);
	  }];
	
	  this.errorOnUnhandledRejections = function(value) {
	    if (isDefined(value)) {
	      errorOnUnhandledRejections = value;
	      return this;
	    } else {
	      return errorOnUnhandledRejections;
	    }
	  };
	}
	
	/**
	 * Constructs a promise manager.
	 *
	 * @param {function(function)} nextTick Function for executing functions in the next turn.
	 * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
	 *     debugging purposes.
	 @ param {=boolean} errorOnUnhandledRejections Whether an error should be generated on unhandled
	 *     promises rejections.
	 * @returns {object} Promise manager.
	 */
	function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
	  var $qMinErr = minErr('$q', TypeError);
	  var queueSize = 0;
	  var checkQueue = [];
	
	  /**
	   * @ngdoc method
	   * @name ng.$q#defer
	   * @kind function
	   *
	   * @description
	   * Creates a `Deferred` object which represents a task which will finish in the future.
	   *
	   * @returns {Deferred} Returns a new instance of deferred.
	   */
	  function defer() {
	    return new Deferred();
	  }
	
	  function Deferred() {
	    var promise = this.promise = new Promise();
	    //Non prototype methods necessary to support unbound execution :/
	    this.resolve = function(val) { resolvePromise(promise, val); };
	    this.reject = function(reason) { rejectPromise(promise, reason); };
	    this.notify = function(progress) { notifyPromise(promise, progress); };
	  }
	
	
	  function Promise() {
	    this.$$state = { status: 0 };
	  }
	
	  extend(Promise.prototype, {
	    then: function(onFulfilled, onRejected, progressBack) {
	      if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
	        return this;
	      }
	      var result = new Promise();
	
	      this.$$state.pending = this.$$state.pending || [];
	      this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
	      if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
	
	      return result;
	    },
	
	    'catch': function(callback) {
	      return this.then(null, callback);
	    },
	
	    'finally': function(callback, progressBack) {
	      return this.then(function(value) {
	        return handleCallback(value, resolve, callback);
	      }, function(error) {
	        return handleCallback(error, reject, callback);
	      }, progressBack);
	    }
	  });
	
	  function processQueue(state) {
	    var fn, promise, pending;
	
	    pending = state.pending;
	    state.processScheduled = false;
	    state.pending = undefined;
	    try {
	      for (var i = 0, ii = pending.length; i < ii; ++i) {
	        state.pur = true;
	        promise = pending[i][0];
	        fn = pending[i][state.status];
	        try {
	          if (isFunction(fn)) {
	            resolvePromise(promise, fn(state.value));
	          } else if (state.status === 1) {
	            resolvePromise(promise, state.value);
	          } else {
	            rejectPromise(promise, state.value);
	          }
	        } catch (e) {
	          rejectPromise(promise, e);
	        }
	      }
	    } finally {
	      --queueSize;
	      if (errorOnUnhandledRejections && queueSize === 0) {
	        nextTick(processChecks);
	      }
	    }
	  }
	
	  function processChecks() {
	    // eslint-disable-next-line no-unmodified-loop-condition
	    while (!queueSize && checkQueue.length) {
	      var toCheck = checkQueue.shift();
	      if (!toCheck.pur) {
	        toCheck.pur = true;
	        var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
	        if (toCheck.value instanceof Error) {
	          exceptionHandler(toCheck.value, errorMessage);
	        } else {
	          exceptionHandler(errorMessage);
	        }
	      }
	    }
	  }
	
	  function scheduleProcessQueue(state) {
	    if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !state.pur) {
	      if (queueSize === 0 && checkQueue.length === 0) {
	        nextTick(processChecks);
	      }
	      checkQueue.push(state);
	    }
	    if (state.processScheduled || !state.pending) return;
	    state.processScheduled = true;
	    ++queueSize;
	    nextTick(function() { processQueue(state); });
	  }
	
	  function resolvePromise(promise, val) {
	    if (promise.$$state.status) return;
	    if (val === promise) {
	      $$reject(promise, $qMinErr(
	        'qcycle',
	        'Expected promise to be resolved with value other than itself \'{0}\'',
	        val));
	    } else {
	      $$resolve(promise, val);
	    }
	
	  }
	
	  function $$resolve(promise, val) {
	    var then;
	    var done = false;
	    try {
	      if (isObject(val) || isFunction(val)) then = val.then;
	      if (isFunction(then)) {
	        promise.$$state.status = -1;
	        then.call(val, doResolve, doReject, doNotify);
	      } else {
	        promise.$$state.value = val;
	        promise.$$state.status = 1;
	        scheduleProcessQueue(promise.$$state);
	      }
	    } catch (e) {
	      doReject(e);
	    }
	
	    function doResolve(val) {
	      if (done) return;
	      done = true;
	      $$resolve(promise, val);
	    }
	    function doReject(val) {
	      if (done) return;
	      done = true;
	      $$reject(promise, val);
	    }
	    function doNotify(progress) {
	      notifyPromise(promise, progress);
	    }
	  }
	
	  function rejectPromise(promise, reason) {
	    if (promise.$$state.status) return;
	    $$reject(promise, reason);
	  }
	
	  function $$reject(promise, reason) {
	    promise.$$state.value = reason;
	    promise.$$state.status = 2;
	    scheduleProcessQueue(promise.$$state);
	  }
	
	  function notifyPromise(promise, progress) {
	    var callbacks = promise.$$state.pending;
	
	    if ((promise.$$state.status <= 0) && callbacks && callbacks.length) {
	      nextTick(function() {
	        var callback, result;
	        for (var i = 0, ii = callbacks.length; i < ii; i++) {
	          result = callbacks[i][0];
	          callback = callbacks[i][3];
	          try {
	            notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
	          } catch (e) {
	            exceptionHandler(e);
	          }
	        }
	      });
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#reject
	   * @kind function
	   *
	   * @description
	   * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
	   * used to forward rejection in a chain of promises. If you are dealing with the last promise in
	   * a promise chain, you don't need to worry about it.
	   *
	   * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
	   * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
	   * a promise error callback and you want to forward the error to the promise derived from the
	   * current promise, you have to "rethrow" the error by returning a rejection constructed via
	   * `reject`.
	   *
	   * ```js
	   *   promiseB = promiseA.then(function(result) {
	   *     // success: do something and resolve promiseB
	   *     //          with the old or a new result
	   *     return result;
	   *   }, function(reason) {
	   *     // error: handle the error if possible and
	   *     //        resolve promiseB with newPromiseOrValue,
	   *     //        otherwise forward the rejection to promiseB
	   *     if (canHandle(reason)) {
	   *      // handle the error and recover
	   *      return newPromiseOrValue;
	   *     }
	   *     return $q.reject(reason);
	   *   });
	   * ```
	   *
	   * @param {*} reason Constant, message, exception or an object representing the rejection reason.
	   * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
	   */
	  function reject(reason) {
	    var result = new Promise();
	    rejectPromise(result, reason);
	    return result;
	  }
	
	  function handleCallback(value, resolver, callback) {
	    var callbackOutput = null;
	    try {
	      if (isFunction(callback)) callbackOutput = callback();
	    } catch (e) {
	      return reject(e);
	    }
	    if (isPromiseLike(callbackOutput)) {
	      return callbackOutput.then(function() {
	        return resolver(value);
	      }, reject);
	    } else {
	      return resolver(value);
	    }
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#when
	   * @kind function
	   *
	   * @description
	   * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
	   * This is useful when you are dealing with an object that might or might not be a promise, or if
	   * the promise comes from a source that can't be trusted.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	
	
	  function when(value, callback, errback, progressBack) {
	    var result = new Promise();
	    resolvePromise(result, value);
	    return result.then(callback, errback, progressBack);
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#resolve
	   * @kind function
	   *
	   * @description
	   * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
	   *
	   * @param {*} value Value or a promise
	   * @param {Function=} successCallback
	   * @param {Function=} errorCallback
	   * @param {Function=} progressCallback
	   * @returns {Promise} Returns a promise of the passed value or promise
	   */
	  var resolve = when;
	
	  /**
	   * @ngdoc method
	   * @name $q#all
	   * @kind function
	   *
	   * @description
	   * Combines multiple promises into a single promise that is resolved when all of the input
	   * promises are resolved.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
	   *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
	   *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
	   *   with the same rejection value.
	   */
	
	  function all(promises) {
	    var result = new Promise(),
	        counter = 0,
	        results = isArray(promises) ? [] : {};
	
	    forEach(promises, function(promise, key) {
	      counter++;
	      when(promise).then(function(value) {
	        results[key] = value;
	        if (!(--counter)) resolvePromise(result, results);
	      }, function(reason) {
	        rejectPromise(result, reason);
	      });
	    });
	
	    if (counter === 0) {
	      resolvePromise(result, results);
	    }
	
	    return result;
	  }
	
	  /**
	   * @ngdoc method
	   * @name $q#race
	   * @kind function
	   *
	   * @description
	   * Returns a promise that resolves or rejects as soon as one of those promises
	   * resolves or rejects, with the value or reason from that promise.
	   *
	   * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
	   * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
	   * resolves or rejects, with the value or reason from that promise.
	   */
	
	  function race(promises) {
	    var deferred = defer();
	
	    forEach(promises, function(promise) {
	      when(promise).then(deferred.resolve, deferred.reject);
	    });
	
	    return deferred.promise;
	  }
	
	  function $Q(resolver) {
	    if (!isFunction(resolver)) {
	      throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
	    }
	
	    var promise = new Promise();
	
	    function resolveFn(value) {
	      resolvePromise(promise, value);
	    }
	
	    function rejectFn(reason) {
	      rejectPromise(promise, reason);
	    }
	
	    resolver(resolveFn, rejectFn);
	
	    return promise;
	  }
	
	  // Let's make the instanceof operator work for promises, so that
	  // `new $q(fn) instanceof $q` would evaluate to true.
	  $Q.prototype = Promise.prototype;
	
	  $Q.defer = defer;
	  $Q.reject = reject;
	  $Q.when = when;
	  $Q.resolve = resolve;
	  $Q.all = all;
	  $Q.race = race;
	
	  return $Q;
	}
	
	/** @this */
	function $$RAFProvider() { //rAF
	  this.$get = ['$window', '$timeout', function($window, $timeout) {
	    var requestAnimationFrame = $window.requestAnimationFrame ||
	                                $window.webkitRequestAnimationFrame;
	
	    var cancelAnimationFrame = $window.cancelAnimationFrame ||
	                               $window.webkitCancelAnimationFrame ||
	                               $window.webkitCancelRequestAnimationFrame;
	
	    var rafSupported = !!requestAnimationFrame;
	    var raf = rafSupported
	      ? function(fn) {
	          var id = requestAnimationFrame(fn);
	          return function() {
	            cancelAnimationFrame(id);
	          };
	        }
	      : function(fn) {
	          var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
	          return function() {
	            $timeout.cancel(timer);
	          };
	        };
	
	    raf.supported = rafSupported;
	
	    return raf;
	  }];
	}
	
	/**
	 * DESIGN NOTES
	 *
	 * The design decisions behind the scope are heavily favored for speed and memory consumption.
	 *
	 * The typical use of scope is to watch the expressions, which most of the time return the same
	 * value as last time so we optimize the operation.
	 *
	 * Closures construction is expensive in terms of speed as well as memory:
	 *   - No closures, instead use prototypical inheritance for API
	 *   - Internal state needs to be stored on scope directly, which means that private state is
	 *     exposed as $$____ properties
	 *
	 * Loop operations are optimized by using while(count--) { ... }
	 *   - This means that in order to keep the same order of execution as addition we have to add
	 *     items to the array at the beginning (unshift) instead of at the end (push)
	 *
	 * Child scopes are created and removed often
	 *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
	 *
	 * There are fewer watches than observers. This is why you don't want the observer to be implemented
	 * in the same way as watch. Watch requires return of the initialization function which is expensive
	 * to construct.
	 */
	
	
	/**
	 * @ngdoc provider
	 * @name $rootScopeProvider
	 * @description
	 *
	 * Provider for the $rootScope service.
	 */
	
	/**
	 * @ngdoc method
	 * @name $rootScopeProvider#digestTtl
	 * @description
	 *
	 * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
	 * assuming that the model is unstable.
	 *
	 * The current default is 10 iterations.
	 *
	 * In complex applications it's possible that the dependencies between `$watch`s will result in
	 * several digest iterations. However if an application needs more than the default 10 digest
	 * iterations for its model to stabilize then you should investigate what is causing the model to
	 * continuously change during the digest.
	 *
	 * Increasing the TTL could have performance implications, so you should not change it without
	 * proper justification.
	 *
	 * @param {number} limit The number of digest iterations.
	 */
	
	
	/**
	 * @ngdoc service
	 * @name $rootScope
	 * @this
	 *
	 * @description
	 *
	 * Every application has a single root {@link ng.$rootScope.Scope scope}.
	 * All other scopes are descendant scopes of the root scope. Scopes provide separation
	 * between the model and the view, via a mechanism for watching the model for changes.
	 * They also provide event emission/broadcast and subscription facility. See the
	 * {@link guide/scope developer guide on scopes}.
	 */
	function $RootScopeProvider() {
	  var TTL = 10;
	  var $rootScopeMinErr = minErr('$rootScope');
	  var lastDirtyWatch = null;
	  var applyAsyncId = null;
	
	  this.digestTtl = function(value) {
	    if (arguments.length) {
	      TTL = value;
	    }
	    return TTL;
	  };
	
	  function createChildScopeClass(parent) {
	    function ChildScope() {
	      this.$$watchers = this.$$nextSibling =
	          this.$$childHead = this.$$childTail = null;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$id = nextUid();
	      this.$$ChildScope = null;
	    }
	    ChildScope.prototype = parent;
	    return ChildScope;
	  }
	
	  this.$get = ['$exceptionHandler', '$parse', '$browser',
	      function($exceptionHandler, $parse, $browser) {
	
	    function destroyChildScope($event) {
	        $event.currentScope.$$destroyed = true;
	    }
	
	    function cleanUpScope($scope) {
	
	      // Support: IE 9 only
	      if (msie === 9) {
	        // There is a memory leak in IE9 if all child scopes are not disconnected
	        // completely when a scope is destroyed. So this code will recurse up through
	        // all this scopes children
	        //
	        // See issue https://github.com/angular/angular.js/issues/10706
	        if ($scope.$$childHead) {
	          cleanUpScope($scope.$$childHead);
	        }
	        if ($scope.$$nextSibling) {
	          cleanUpScope($scope.$$nextSibling);
	        }
	      }
	
	      // The code below works around IE9 and V8's memory leaks
	      //
	      // See:
	      // - https://code.google.com/p/v8/issues/detail?id=2073#c26
	      // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
	      // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451
	
	      $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead =
	          $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
	    }
	
	    /**
	     * @ngdoc type
	     * @name $rootScope.Scope
	     *
	     * @description
	     * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
	     * {@link auto.$injector $injector}. Child scopes are created using the
	     * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
	     * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
	     * an in-depth introduction and usage examples.
	     *
	     *
	     * # Inheritance
	     * A scope can inherit from a parent scope, as in this example:
	     * ```js
	         var parent = $rootScope;
	         var child = parent.$new();
	
	         parent.salutation = "Hello";
	         expect(child.salutation).toEqual('Hello');
	
	         child.salutation = "Welcome";
	         expect(child.salutation).toEqual('Welcome');
	         expect(parent.salutation).toEqual('Hello');
	     * ```
	     *
	     * When interacting with `Scope` in tests, additional helper methods are available on the
	     * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
	     * details.
	     *
	     *
	     * @param {Object.<string, function()>=} providers Map of service factory which need to be
	     *                                       provided for the current scope. Defaults to {@link ng}.
	     * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
	     *                              append/override services provided by `providers`. This is handy
	     *                              when unit-testing and having the need to override a default
	     *                              service.
	     * @returns {Object} Newly created scope.
	     *
	     */
	    function Scope() {
	      this.$id = nextUid();
	      this.$$phase = this.$parent = this.$$watchers =
	                     this.$$nextSibling = this.$$prevSibling =
	                     this.$$childHead = this.$$childTail = null;
	      this.$root = this;
	      this.$$destroyed = false;
	      this.$$listeners = {};
	      this.$$listenerCount = {};
	      this.$$watchersCount = 0;
	      this.$$isolateBindings = null;
	    }
	
	    /**
	     * @ngdoc property
	     * @name $rootScope.Scope#$id
	     *
	     * @description
	     * Unique scope ID (monotonically increasing) useful for debugging.
	     */
	
	     /**
	      * @ngdoc property
	      * @name $rootScope.Scope#$parent
	      *
	      * @description
	      * Reference to the parent scope.
	      */
	
	      /**
	       * @ngdoc property
	       * @name $rootScope.Scope#$root
	       *
	       * @description
	       * Reference to the root scope.
	       */
	
	    Scope.prototype = {
	      constructor: Scope,
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$new
	       * @kind function
	       *
	       * @description
	       * Creates a new child {@link ng.$rootScope.Scope scope}.
	       *
	       * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
	       * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
	       *
	       * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
	       * desired for the scope and its child scopes to be permanently detached from the parent and
	       * thus stop participating in model change detection and listener notification by invoking.
	       *
	       * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
	       *         parent scope. The scope is isolated, as it can not see parent scope properties.
	       *         When creating widgets, it is useful for the widget to not accidentally read parent
	       *         state.
	       *
	       * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
	       *                              of the newly created scope. Defaults to `this` scope if not provided.
	       *                              This is used when creating a transclude scope to correctly place it
	       *                              in the scope hierarchy while maintaining the correct prototypical
	       *                              inheritance.
	       *
	       * @returns {Object} The newly created child scope.
	       *
	       */
	      $new: function(isolate, parent) {
	        var child;
	
	        parent = parent || this;
	
	        if (isolate) {
	          child = new Scope();
	          child.$root = this.$root;
	        } else {
	          // Only create a child scope class if somebody asks for one,
	          // but cache it to allow the VM to optimize lookups.
	          if (!this.$$ChildScope) {
	            this.$$ChildScope = createChildScopeClass(this);
	          }
	          child = new this.$$ChildScope();
	        }
	        child.$parent = parent;
	        child.$$prevSibling = parent.$$childTail;
	        if (parent.$$childHead) {
	          parent.$$childTail.$$nextSibling = child;
	          parent.$$childTail = child;
	        } else {
	          parent.$$childHead = parent.$$childTail = child;
	        }
	
	        // When the new scope is not isolated or we inherit from `this`, and
	        // the parent scope is destroyed, the property `$$destroyed` is inherited
	        // prototypically. In all other cases, this property needs to be set
	        // when the parent scope is destroyed.
	        // The listener needs to be added after the parent is set
	        if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
	
	        return child;
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watch
	       * @kind function
	       *
	       * @description
	       * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
	       *
	       * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
	       *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
	       *   its value when executed multiple times with the same input because it may be executed multiple
	       *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
	       *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
	       * - The `listener` is called only when the value from the current `watchExpression` and the
	       *   previous call to `watchExpression` are not equal (with the exception of the initial run,
	       *   see below). Inequality is determined according to reference inequality,
	       *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
	       *    via the `!==` Javascript operator, unless `objectEquality == true`
	       *   (see next point)
	       * - When `objectEquality == true`, inequality of the `watchExpression` is determined
	       *   according to the {@link angular.equals} function. To save the value of the object for
	       *   later comparison, the {@link angular.copy} function is used. This therefore means that
	       *   watching complex objects will have adverse memory and performance implications.
	       * - This should not be used to watch for changes in objects that are
	       *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
	       * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
	       *   This is achieved by rerunning the watchers until no changes are detected. The rerun
	       *   iteration limit is 10 to prevent an infinite loop deadlock.
	       *
	       *
	       * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
	       * you can register a `watchExpression` function with no `listener`. (Be prepared for
	       * multiple calls to your `watchExpression` because it will execute multiple times in a
	       * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
	       *
	       * After a watcher is registered with the scope, the `listener` fn is called asynchronously
	       * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
	       * watcher. In rare cases, this is undesirable because the listener is called when the result
	       * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
	       * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
	       * listener was called due to initialization.
	       *
	       *
	       *
	       * # Example
	       * ```js
	           // let's assume that scope was dependency injected as the $rootScope
	           var scope = $rootScope;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	
	
	
	           // Using a function as a watchExpression
	           var food;
	           scope.foodCounter = 0;
	           expect(scope.foodCounter).toEqual(0);
	           scope.$watch(
	             // This function returns the value being watched. It is called for each turn of the $digest loop
	             function() { return food; },
	             // This is the change listener, called when the value returned from the above function changes
	             function(newValue, oldValue) {
	               if ( newValue !== oldValue ) {
	                 // Only increment the counter if the value changed
	                 scope.foodCounter = scope.foodCounter + 1;
	               }
	             }
	           );
	           // No digest has been run so the counter will be zero
	           expect(scope.foodCounter).toEqual(0);
	
	           // Run the digest but since food has not changed count will still be zero
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(0);
	
	           // Update food and run digest.  Now the counter will increment
	           food = 'cheeseburger';
	           scope.$digest();
	           expect(scope.foodCounter).toEqual(1);
	
	       * ```
	       *
	       *
	       *
	       * @param {(function()|string)} watchExpression Expression that is evaluated on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
	       *    a call to the `listener`.
	       *
	       *    - `string`: Evaluated as {@link guide/expression expression}
	       *    - `function(scope)`: called with current `scope` as a parameter.
	       * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
	       *    of `watchExpression` changes.
	       *
	       *    - `newVal` contains the current value of the `watchExpression`
	       *    - `oldVal` contains the previous value of the `watchExpression`
	       *    - `scope` refers to the current scope
	       * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
	       *     comparing for reference equality.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $watch: function(watchExp, listener, objectEquality, prettyPrintExpression) {
	        var get = $parse(watchExp);
	
	        if (get.$$watchDelegate) {
	          return get.$$watchDelegate(this, listener, objectEquality, get, watchExp);
	        }
	        var scope = this,
	            array = scope.$$watchers,
	            watcher = {
	              fn: listener,
	              last: initWatchVal,
	              get: get,
	              exp: prettyPrintExpression || watchExp,
	              eq: !!objectEquality
	            };
	
	        lastDirtyWatch = null;
	
	        if (!isFunction(listener)) {
	          watcher.fn = noop;
	        }
	
	        if (!array) {
	          array = scope.$$watchers = [];
	          array.$$digestWatchIndex = -1;
	        }
	        // we use unshift since we use a while loop in $digest for speed.
	        // the while loop reads in reverse order.
	        array.unshift(watcher);
	        array.$$digestWatchIndex++;
	        incrementWatchersCount(this, 1);
	
	        return function deregisterWatch() {
	          var index = arrayRemove(array, watcher);
	          if (index >= 0) {
	            incrementWatchersCount(scope, -1);
	            if (index < array.$$digestWatchIndex) {
	              array.$$digestWatchIndex--;
	            }
	          }
	          lastDirtyWatch = null;
	        };
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchGroup
	       * @kind function
	       *
	       * @description
	       * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
	       * If any one expression in the collection changes the `listener` is executed.
	       *
	       * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
	       *   values are examined for changes on every call to `$digest`.
	       * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
	       *
	       * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
	       * watched using {@link ng.$rootScope.Scope#$watch $watch()}
	       *
	       * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
	       *    expression in `watchExpressions` changes
	       *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
	       *    those of `watchExpression`
	       *    The `scope` refers to the current scope.
	       * @returns {function()} Returns a de-registration function for all listeners.
	       */
	      $watchGroup: function(watchExpressions, listener) {
	        var oldValues = new Array(watchExpressions.length);
	        var newValues = new Array(watchExpressions.length);
	        var deregisterFns = [];
	        var self = this;
	        var changeReactionScheduled = false;
	        var firstRun = true;
	
	        if (!watchExpressions.length) {
	          // No expressions means we call the listener ASAP
	          var shouldCall = true;
	          self.$evalAsync(function() {
	            if (shouldCall) listener(newValues, newValues, self);
	          });
	          return function deregisterWatchGroup() {
	            shouldCall = false;
	          };
	        }
	
	        if (watchExpressions.length === 1) {
	          // Special case size of one
	          return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
	            newValues[0] = value;
	            oldValues[0] = oldValue;
	            listener(newValues, (value === oldValue) ? newValues : oldValues, scope);
	          });
	        }
	
	        forEach(watchExpressions, function(expr, i) {
	          var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
	            newValues[i] = value;
	            oldValues[i] = oldValue;
	            if (!changeReactionScheduled) {
	              changeReactionScheduled = true;
	              self.$evalAsync(watchGroupAction);
	            }
	          });
	          deregisterFns.push(unwatchFn);
	        });
	
	        function watchGroupAction() {
	          changeReactionScheduled = false;
	
	          if (firstRun) {
	            firstRun = false;
	            listener(newValues, newValues, self);
	          } else {
	            listener(newValues, oldValues, self);
	          }
	        }
	
	        return function deregisterWatchGroup() {
	          while (deregisterFns.length) {
	            deregisterFns.shift()();
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$watchCollection
	       * @kind function
	       *
	       * @description
	       * Shallow watches the properties of an object and fires whenever any of the properties change
	       * (for arrays, this implies watching the array items; for object maps, this implies watching
	       * the properties). If a change is detected, the `listener` callback is fired.
	       *
	       * - The `obj` collection is observed via standard $watch operation and is examined on every
	       *   call to $digest() to see if any items have been added, removed, or moved.
	       * - The `listener` is called whenever anything within the `obj` has changed. Examples include
	       *   adding, removing, and moving items belonging to an object or array.
	       *
	       *
	       * # Example
	       * ```js
	          $scope.names = ['igor', 'matias', 'misko', 'james'];
	          $scope.dataCount = 4;
	
	          $scope.$watchCollection('names', function(newNames, oldNames) {
	            $scope.dataCount = newNames.length;
	          });
	
	          expect($scope.dataCount).toEqual(4);
	          $scope.$digest();
	
	          //still at 4 ... no changes
	          expect($scope.dataCount).toEqual(4);
	
	          $scope.names.pop();
	          $scope.$digest();
	
	          //now there's been a change
	          expect($scope.dataCount).toEqual(3);
	       * ```
	       *
	       *
	       * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
	       *    expression value should evaluate to an object or an array which is observed on each
	       *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
	       *    collection will trigger a call to the `listener`.
	       *
	       * @param {function(newCollection, oldCollection, scope)} listener a callback function called
	       *    when a change is detected.
	       *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
	       *    - The `oldCollection` object is a copy of the former collection data.
	       *      Due to performance considerations, the`oldCollection` value is computed only if the
	       *      `listener` function declares two or more arguments.
	       *    - The `scope` argument refers to the current scope.
	       *
	       * @returns {function()} Returns a de-registration function for this listener. When the
	       *    de-registration function is executed, the internal watch operation is terminated.
	       */
	      $watchCollection: function(obj, listener) {
	        $watchCollectionInterceptor.$stateful = true;
	
	        var self = this;
	        // the current value, updated on each dirty-check run
	        var newValue;
	        // a shallow copy of the newValue from the last dirty-check run,
	        // updated to match newValue during dirty-check run
	        var oldValue;
	        // a shallow copy of the newValue from when the last change happened
	        var veryOldValue;
	        // only track veryOldValue if the listener is asking for it
	        var trackVeryOldValue = (listener.length > 1);
	        var changeDetected = 0;
	        var changeDetector = $parse(obj, $watchCollectionInterceptor);
	        var internalArray = [];
	        var internalObject = {};
	        var initRun = true;
	        var oldLength = 0;
	
	        function $watchCollectionInterceptor(_value) {
	          newValue = _value;
	          var newLength, key, bothNaN, newItem, oldItem;
	
	          // If the new value is undefined, then return undefined as the watch may be a one-time watch
	          if (isUndefined(newValue)) return;
	
	          if (!isObject(newValue)) { // if primitive
	            if (oldValue !== newValue) {
	              oldValue = newValue;
	              changeDetected++;
	            }
	          } else if (isArrayLike(newValue)) {
	            if (oldValue !== internalArray) {
	              // we are transitioning from something which was not an array into array.
	              oldValue = internalArray;
	              oldLength = oldValue.length = 0;
	              changeDetected++;
	            }
	
	            newLength = newValue.length;
	
	            if (oldLength !== newLength) {
	              // if lengths do not match we need to trigger change notification
	              changeDetected++;
	              oldValue.length = oldLength = newLength;
	            }
	            // copy the items to oldValue and look for changes.
	            for (var i = 0; i < newLength; i++) {
	              oldItem = oldValue[i];
	              newItem = newValue[i];
	
	              // eslint-disable-next-line no-self-compare
	              bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	              if (!bothNaN && (oldItem !== newItem)) {
	                changeDetected++;
	                oldValue[i] = newItem;
	              }
	            }
	          } else {
	            if (oldValue !== internalObject) {
	              // we are transitioning from something which was not an object into object.
	              oldValue = internalObject = {};
	              oldLength = 0;
	              changeDetected++;
	            }
	            // copy the items to oldValue and look for changes.
	            newLength = 0;
	            for (key in newValue) {
	              if (hasOwnProperty.call(newValue, key)) {
	                newLength++;
	                newItem = newValue[key];
	                oldItem = oldValue[key];
	
	                if (key in oldValue) {
	                  // eslint-disable-next-line no-self-compare
	                  bothNaN = (oldItem !== oldItem) && (newItem !== newItem);
	                  if (!bothNaN && (oldItem !== newItem)) {
	                    changeDetected++;
	                    oldValue[key] = newItem;
	                  }
	                } else {
	                  oldLength++;
	                  oldValue[key] = newItem;
	                  changeDetected++;
	                }
	              }
	            }
	            if (oldLength > newLength) {
	              // we used to have more keys, need to find them and destroy them.
	              changeDetected++;
	              for (key in oldValue) {
	                if (!hasOwnProperty.call(newValue, key)) {
	                  oldLength--;
	                  delete oldValue[key];
	                }
	              }
	            }
	          }
	          return changeDetected;
	        }
	
	        function $watchCollectionAction() {
	          if (initRun) {
	            initRun = false;
	            listener(newValue, newValue, self);
	          } else {
	            listener(newValue, veryOldValue, self);
	          }
	
	          // make a copy for the next time a collection is changed
	          if (trackVeryOldValue) {
	            if (!isObject(newValue)) {
	              //primitive
	              veryOldValue = newValue;
	            } else if (isArrayLike(newValue)) {
	              veryOldValue = new Array(newValue.length);
	              for (var i = 0; i < newValue.length; i++) {
	                veryOldValue[i] = newValue[i];
	              }
	            } else { // if object
	              veryOldValue = {};
	              for (var key in newValue) {
	                if (hasOwnProperty.call(newValue, key)) {
	                  veryOldValue[key] = newValue[key];
	                }
	              }
	            }
	          }
	        }
	
	        return this.$watch(changeDetector, $watchCollectionAction);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$digest
	       * @kind function
	       *
	       * @description
	       * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
	       * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
	       * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
	       * until no more listeners are firing. This means that it is possible to get into an infinite
	       * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
	       * iterations exceeds 10.
	       *
	       * Usually, you don't call `$digest()` directly in
	       * {@link ng.directive:ngController controllers} or in
	       * {@link ng.$compileProvider#directive directives}.
	       * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
	       * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
	       *
	       * If you want to be notified whenever `$digest()` is called,
	       * you can register a `watchExpression` function with
	       * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
	       *
	       * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
	       *
	       * # Example
	       * ```js
	           var scope = ...;
	           scope.name = 'misko';
	           scope.counter = 0;
	
	           expect(scope.counter).toEqual(0);
	           scope.$watch('name', function(newValue, oldValue) {
	             scope.counter = scope.counter + 1;
	           });
	           expect(scope.counter).toEqual(0);
	
	           scope.$digest();
	           // the listener is always called during the first $digest loop after it was registered
	           expect(scope.counter).toEqual(1);
	
	           scope.$digest();
	           // but now it will not be called unless the value changes
	           expect(scope.counter).toEqual(1);
	
	           scope.name = 'adam';
	           scope.$digest();
	           expect(scope.counter).toEqual(2);
	       * ```
	       *
	       */
	      $digest: function() {
	        var watch, value, last, fn, get,
	            watchers,
	            dirty, ttl = TTL,
	            next, current, target = this,
	            watchLog = [],
	            logIdx, asyncTask;
	
	        beginPhase('$digest');
	        // Check for changes to browser url that happened in sync before the call to $digest
	        $browser.$$checkUrlChange();
	
	        if (this === $rootScope && applyAsyncId !== null) {
	          // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
	          // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
	          $browser.defer.cancel(applyAsyncId);
	          flushApplyAsync();
	        }
	
	        lastDirtyWatch = null;
	
	        do { // "while dirty" loop
	          dirty = false;
	          current = target;
	
	          // It's safe for asyncQueuePosition to be a local variable here because this loop can't
	          // be reentered recursively. Calling $digest from a function passed to $evalAsync would
	          // lead to a '$digest already in progress' error.
	          for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
	            try {
	              asyncTask = asyncQueue[asyncQueuePosition];
	              fn = asyncTask.fn;
	              fn(asyncTask.scope, asyncTask.locals);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	            lastDirtyWatch = null;
	          }
	          asyncQueue.length = 0;
	
	          traverseScopesLoop:
	          do { // "traverse the scopes" loop
	            if ((watchers = current.$$watchers)) {
	              // process our watches
	              watchers.$$digestWatchIndex = watchers.length;
	              while (watchers.$$digestWatchIndex--) {
	                try {
	                  watch = watchers[watchers.$$digestWatchIndex];
	                  // Most common watches are on primitives, in which case we can short
	                  // circuit it with === operator, only when === fails do we use .equals
	                  if (watch) {
	                    get = watch.get;
	                    if ((value = get(current)) !== (last = watch.last) &&
	                        !(watch.eq
	                            ? equals(value, last)
	                            : (isNumberNaN(value) && isNumberNaN(last)))) {
	                      dirty = true;
	                      lastDirtyWatch = watch;
	                      watch.last = watch.eq ? copy(value, null) : value;
	                      fn = watch.fn;
	                      fn(value, ((last === initWatchVal) ? value : last), current);
	                      if (ttl < 5) {
	                        logIdx = 4 - ttl;
	                        if (!watchLog[logIdx]) watchLog[logIdx] = [];
	                        watchLog[logIdx].push({
	                          msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
	                          newVal: value,
	                          oldVal: last
	                        });
	                      }
	                    } else if (watch === lastDirtyWatch) {
	                      // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
	                      // have already been tested.
	                      dirty = false;
	                      break traverseScopesLoop;
	                    }
	                  }
	                } catch (e) {
	                  $exceptionHandler(e);
	                }
	              }
	            }
	
	            // Insanity Warning: scope depth-first traversal
	            // yes, this code is a bit crazy, but it works and we have tests to prove it!
	            // this piece should be kept in sync with the traversal in $broadcast
	            if (!(next = ((current.$$watchersCount && current.$$childHead) ||
	                (current !== target && current.$$nextSibling)))) {
	              while (current !== target && !(next = current.$$nextSibling)) {
	                current = current.$parent;
	              }
	            }
	          } while ((current = next));
	
	          // `break traverseScopesLoop;` takes us to here
	
	          if ((dirty || asyncQueue.length) && !(ttl--)) {
	            clearPhase();
	            throw $rootScopeMinErr('infdig',
	                '{0} $digest() iterations reached. Aborting!\n' +
	                'Watchers fired in the last 5 iterations: {1}',
	                TTL, watchLog);
	          }
	
	        } while (dirty || asyncQueue.length);
	
	        clearPhase();
	
	        // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
	        while (postDigestQueuePosition < postDigestQueue.length) {
	          try {
	            postDigestQueue[postDigestQueuePosition++]();
	          } catch (e) {
	            $exceptionHandler(e);
	          }
	        }
	        postDigestQueue.length = postDigestQueuePosition = 0;
	
	        // Check for changes to browser url that happened during the $digest
	        // (for which no event is fired; e.g. via `history.pushState()`)
	        $browser.$$checkUrlChange();
	      },
	
	
	      /**
	       * @ngdoc event
	       * @name $rootScope.Scope#$destroy
	       * @eventType broadcast on scope being destroyed
	       *
	       * @description
	       * Broadcasted when a scope and its children are being destroyed.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$destroy
	       * @kind function
	       *
	       * @description
	       * Removes the current scope (and all of its children) from the parent scope. Removal implies
	       * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
	       * propagate to the current scope and its children. Removal also implies that the current
	       * scope is eligible for garbage collection.
	       *
	       * The `$destroy()` is usually used by directives such as
	       * {@link ng.directive:ngRepeat ngRepeat} for managing the
	       * unrolling of the loop.
	       *
	       * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
	       * Application code can register a `$destroy` event handler that will give it a chance to
	       * perform any necessary cleanup.
	       *
	       * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
	       * clean up DOM bindings before an element is removed from the DOM.
	       */
	      $destroy: function() {
	        // We can't destroy a scope that has been already destroyed.
	        if (this.$$destroyed) return;
	        var parent = this.$parent;
	
	        this.$broadcast('$destroy');
	        this.$$destroyed = true;
	
	        if (this === $rootScope) {
	          //Remove handlers attached to window when $rootScope is removed
	          $browser.$$applicationDestroyed();
	        }
	
	        incrementWatchersCount(this, -this.$$watchersCount);
	        for (var eventName in this.$$listenerCount) {
	          decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
	        }
	
	        // sever all the references to parent scopes (after this cleanup, the current scope should
	        // not be retained by any of our references and should be eligible for garbage collection)
	        if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
	        if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
	        if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
	        if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;
	
	        // Disable listeners, watchers and apply/digest methods
	        this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
	        this.$on = this.$watch = this.$watchGroup = function() { return noop; };
	        this.$$listeners = {};
	
	        // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
	        this.$$nextSibling = null;
	        cleanUpScope(this);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$eval
	       * @kind function
	       *
	       * @description
	       * Executes the `expression` on the current scope and returns the result. Any exceptions in
	       * the expression are propagated (uncaught). This is useful when evaluating Angular
	       * expressions.
	       *
	       * # Example
	       * ```js
	           var scope = ng.$rootScope.Scope();
	           scope.a = 1;
	           scope.b = 2;
	
	           expect(scope.$eval('a+b')).toEqual(3);
	           expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
	       * ```
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       * @returns {*} The result of evaluating the expression.
	       */
	      $eval: function(expr, locals) {
	        return $parse(expr)(this, locals);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$evalAsync
	       * @kind function
	       *
	       * @description
	       * Executes the expression on the current scope at a later point in time.
	       *
	       * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
	       * that:
	       *
	       *   - it will execute after the function that scheduled the evaluation (preferably before DOM
	       *     rendering).
	       *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
	       *     `expression` execution.
	       *
	       * Any exceptions from the execution of the expression are forwarded to the
	       * {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
	       * will be scheduled. However, it is encouraged to always call code that changes the model
	       * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
	       *
	       * @param {(string|function())=} expression An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with the current `scope` parameter.
	       *
	       * @param {(object)=} locals Local variables object, useful for overriding values in scope.
	       */
	      $evalAsync: function(expr, locals) {
	        // if we are outside of an $digest loop and this is the first time we are scheduling async
	        // task also schedule async auto-flush
	        if (!$rootScope.$$phase && !asyncQueue.length) {
	          $browser.defer(function() {
	            if (asyncQueue.length) {
	              $rootScope.$digest();
	            }
	          });
	        }
	
	        asyncQueue.push({scope: this, fn: $parse(expr), locals: locals});
	      },
	
	      $$postDigest: function(fn) {
	        postDigestQueue.push(fn);
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$apply
	       * @kind function
	       *
	       * @description
	       * `$apply()` is used to execute an expression in angular from outside of the angular
	       * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
	       * Because we are calling into the angular framework we need to perform proper scope life
	       * cycle of {@link ng.$exceptionHandler exception handling},
	       * {@link ng.$rootScope.Scope#$digest executing watches}.
	       *
	       * ## Life cycle
	       *
	       * # Pseudo-Code of `$apply()`
	       * ```js
	           function $apply(expr) {
	             try {
	               return $eval(expr);
	             } catch (e) {
	               $exceptionHandler(e);
	             } finally {
	               $root.$digest();
	             }
	           }
	       * ```
	       *
	       *
	       * Scope's `$apply()` method transitions through the following stages:
	       *
	       * 1. The {@link guide/expression expression} is executed using the
	       *    {@link ng.$rootScope.Scope#$eval $eval()} method.
	       * 2. Any exceptions from the execution of the expression are forwarded to the
	       *    {@link ng.$exceptionHandler $exceptionHandler} service.
	       * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
	       *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
	       *
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       *
	       * @returns {*} The result of evaluating the expression.
	       */
	      $apply: function(expr) {
	        try {
	          beginPhase('$apply');
	          try {
	            return this.$eval(expr);
	          } finally {
	            clearPhase();
	          }
	        } catch (e) {
	          $exceptionHandler(e);
	        } finally {
	          try {
	            $rootScope.$digest();
	          } catch (e) {
	            $exceptionHandler(e);
	            // eslint-disable-next-line no-unsafe-finally
	            throw e;
	          }
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$applyAsync
	       * @kind function
	       *
	       * @description
	       * Schedule the invocation of $apply to occur at a later time. The actual time difference
	       * varies across browsers, but is typically around ~10 milliseconds.
	       *
	       * This can be used to queue up multiple expressions which need to be evaluated in the same
	       * digest.
	       *
	       * @param {(string|function())=} exp An angular expression to be executed.
	       *
	       *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
	       *    - `function(scope)`: execute the function with current `scope` parameter.
	       */
	      $applyAsync: function(expr) {
	        var scope = this;
	        if (expr) {
	          applyAsyncQueue.push($applyAsyncExpression);
	        }
	        expr = $parse(expr);
	        scheduleApplyAsync();
	
	        function $applyAsyncExpression() {
	          scope.$eval(expr);
	        }
	      },
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$on
	       * @kind function
	       *
	       * @description
	       * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
	       * discussion of event life cycle.
	       *
	       * The event listener function format is: `function(event, args...)`. The `event` object
	       * passed into the listener has the following attributes:
	       *
	       *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
	       *     `$broadcast`-ed.
	       *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
	       *     event propagates through the scope hierarchy, this property is set to null.
	       *   - `name` - `{string}`: name of the event.
	       *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
	       *     further event propagation (available only for events that were `$emit`-ed).
	       *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
	       *     to true.
	       *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
	       *
	       * @param {string} name Event name to listen on.
	       * @param {function(event, ...args)} listener Function to call when the event is emitted.
	       * @returns {function()} Returns a deregistration function for this listener.
	       */
	      $on: function(name, listener) {
	        var namedListeners = this.$$listeners[name];
	        if (!namedListeners) {
	          this.$$listeners[name] = namedListeners = [];
	        }
	        namedListeners.push(listener);
	
	        var current = this;
	        do {
	          if (!current.$$listenerCount[name]) {
	            current.$$listenerCount[name] = 0;
	          }
	          current.$$listenerCount[name]++;
	        } while ((current = current.$parent));
	
	        var self = this;
	        return function() {
	          var indexOfListener = namedListeners.indexOf(listener);
	          if (indexOfListener !== -1) {
	            namedListeners[indexOfListener] = null;
	            decrementListenerCount(self, 1, name);
	          }
	        };
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$emit
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` upwards through the scope hierarchy notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$emit` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event traverses upwards toward the root scope and calls all
	       * registered listeners along the way. The event will stop propagating if one of the listeners
	       * cancels it.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to emit.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
	       */
	      $emit: function(name, args) {
	        var empty = [],
	            namedListeners,
	            scope = this,
	            stopPropagation = false,
	            event = {
	              name: name,
	              targetScope: scope,
	              stopPropagation: function() {stopPropagation = true;},
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            },
	            listenerArgs = concat([event], arguments, 1),
	            i, length;
	
	        do {
	          namedListeners = scope.$$listeners[name] || empty;
	          event.currentScope = scope;
	          for (i = 0, length = namedListeners.length; i < length; i++) {
	
	            // if listeners were deregistered, defragment the array
	            if (!namedListeners[i]) {
	              namedListeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	            try {
	              //allow all listeners attached to the current scope to run
	              namedListeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	          //if any listener on the current scope stops propagation, prevent bubbling
	          if (stopPropagation) {
	            event.currentScope = null;
	            return event;
	          }
	          //traverse upwards
	          scope = scope.$parent;
	        } while (scope);
	
	        event.currentScope = null;
	
	        return event;
	      },
	
	
	      /**
	       * @ngdoc method
	       * @name $rootScope.Scope#$broadcast
	       * @kind function
	       *
	       * @description
	       * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
	       * registered {@link ng.$rootScope.Scope#$on} listeners.
	       *
	       * The event life cycle starts at the scope on which `$broadcast` was called. All
	       * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
	       * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
	       * scope and calls all registered listeners along the way. The event cannot be canceled.
	       *
	       * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
	       * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
	       *
	       * @param {string} name Event name to broadcast.
	       * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
	       * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
	       */
	      $broadcast: function(name, args) {
	        var target = this,
	            current = target,
	            next = target,
	            event = {
	              name: name,
	              targetScope: target,
	              preventDefault: function() {
	                event.defaultPrevented = true;
	              },
	              defaultPrevented: false
	            };
	
	        if (!target.$$listenerCount[name]) return event;
	
	        var listenerArgs = concat([event], arguments, 1),
	            listeners, i, length;
	
	        //down while you can, then up and next sibling or up and next sibling until back at root
	        while ((current = next)) {
	          event.currentScope = current;
	          listeners = current.$$listeners[name] || [];
	          for (i = 0, length = listeners.length; i < length; i++) {
	            // if listeners were deregistered, defragment the array
	            if (!listeners[i]) {
	              listeners.splice(i, 1);
	              i--;
	              length--;
	              continue;
	            }
	
	            try {
	              listeners[i].apply(null, listenerArgs);
	            } catch (e) {
	              $exceptionHandler(e);
	            }
	          }
	
	          // Insanity Warning: scope depth-first traversal
	          // yes, this code is a bit crazy, but it works and we have tests to prove it!
	          // this piece should be kept in sync with the traversal in $digest
	          // (though it differs due to having the extra check for $$listenerCount)
	          if (!(next = ((current.$$listenerCount[name] && current.$$childHead) ||
	              (current !== target && current.$$nextSibling)))) {
	            while (current !== target && !(next = current.$$nextSibling)) {
	              current = current.$parent;
	            }
	          }
	        }
	
	        event.currentScope = null;
	        return event;
	      }
	    };
	
	    var $rootScope = new Scope();
	
	    //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
	    var asyncQueue = $rootScope.$$asyncQueue = [];
	    var postDigestQueue = $rootScope.$$postDigestQueue = [];
	    var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
	
	    var postDigestQueuePosition = 0;
	
	    return $rootScope;
	
	
	    function beginPhase(phase) {
	      if ($rootScope.$$phase) {
	        throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
	      }
	
	      $rootScope.$$phase = phase;
	    }
	
	    function clearPhase() {
	      $rootScope.$$phase = null;
	    }
	
	    function incrementWatchersCount(current, count) {
	      do {
	        current.$$watchersCount += count;
	      } while ((current = current.$parent));
	    }
	
	    function decrementListenerCount(current, count, name) {
	      do {
	        current.$$listenerCount[name] -= count;
	
	        if (current.$$listenerCount[name] === 0) {
	          delete current.$$listenerCount[name];
	        }
	      } while ((current = current.$parent));
	    }
	
	    /**
	     * function used as an initial value for watchers.
	     * because it's unique we can easily tell it apart from other values
	     */
	    function initWatchVal() {}
	
	    function flushApplyAsync() {
	      while (applyAsyncQueue.length) {
	        try {
	          applyAsyncQueue.shift()();
	        } catch (e) {
	          $exceptionHandler(e);
	        }
	      }
	      applyAsyncId = null;
	    }
	
	    function scheduleApplyAsync() {
	      if (applyAsyncId === null) {
	        applyAsyncId = $browser.defer(function() {
	          $rootScope.$apply(flushApplyAsync);
	        });
	      }
	    }
	  }];
	}
	
	/**
	 * @ngdoc service
	 * @name $rootElement
	 *
	 * @description
	 * The root element of Angular application. This is either the element where {@link
	 * ng.directive:ngApp ngApp} was declared or the element passed into
	 * {@link angular.bootstrap}. The element represents the root element of application. It is also the
	 * location where the application's {@link auto.$injector $injector} service gets
	 * published, and can be retrieved using `$rootElement.injector()`.
	 */
	
	
	// the implementation is in angular.bootstrap
	
	/**
	 * @this
	 * @description
	 * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
	 */
	function $$SanitizeUriProvider() {
	  var aHrefSanitizationWhitelist = /^\s*(https?|ftp|mailto|tel|file):/,
	    imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during a[href] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.aHrefSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      aHrefSanitizationWhitelist = regexp;
	      return this;
	    }
	    return aHrefSanitizationWhitelist;
	  };
	
	
	  /**
	   * @description
	   * Retrieves or overrides the default regular expression that is used for whitelisting of safe
	   * urls during img[src] sanitization.
	   *
	   * The sanitization is a security measure aimed at prevent XSS attacks via html links.
	   *
	   * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
	   * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
	   * regular expression. If a match is found, the original url is written into the dom. Otherwise,
	   * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
	   *
	   * @param {RegExp=} regexp New regexp to whitelist urls with.
	   * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
	   *    chaining otherwise.
	   */
	  this.imgSrcSanitizationWhitelist = function(regexp) {
	    if (isDefined(regexp)) {
	      imgSrcSanitizationWhitelist = regexp;
	      return this;
	    }
	    return imgSrcSanitizationWhitelist;
	  };
	
	  this.$get = function() {
	    return function sanitizeUri(uri, isImage) {
	      var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
	      var normalizedVal;
	      normalizedVal = urlResolve(uri).href;
	      if (normalizedVal !== '' && !normalizedVal.match(regex)) {
	        return 'unsafe:' + normalizedVal;
	      }
	      return uri;
	    };
	  };
	}
	
	/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
	 *     Any commits to this file should be reviewed with security in mind.  *
	 *   Changes to this file can potentially create security vulnerabilities. *
	 *          An approval from 2 Core members with history of modifying      *
	 *                         this file is required.                          *
	 *                                                                         *
	 *  Does the change somehow allow for arbitrary javascript to be executed? *
	 *    Or allows for someone to change the prototype of built-in objects?   *
	 *     Or gives undesired access to variables likes document or window?    *
	 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */
	
	/* exported $SceProvider, $SceDelegateProvider */
	
	var $sceMinErr = minErr('$sce');
	
	var SCE_CONTEXTS = {
	  // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
	  HTML: 'html',
	
	  // Style statements or stylesheets. Currently unused in AngularJS.
	  CSS: 'css',
	
	  // An URL used in a context where it does not refer to a resource that loads code. Currently
	  // unused in AngularJS.
	  URL: 'url',
	
	  // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
	  // code. (e.g. ng-include, script src binding, templateUrl)
	  RESOURCE_URL: 'resourceUrl',
	
	  // Script. Currently unused in AngularJS.
	  JS: 'js'
	};
	
	// Helper functions follow.
	
	var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
	
	function snakeToCamel(name) {
	  return name
	    .replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
	}
	
	function adjustMatcher(matcher) {
	  if (matcher === 'self') {
	    return matcher;
	  } else if (isString(matcher)) {
	    // Strings match exactly except for 2 wildcards - '*' and '**'.
	    // '*' matches any character except those from the set ':/.?&'.
	    // '**' matches any character (like .* in a RegExp).
	    // More than 2 *'s raises an error as it's ill defined.
	    if (matcher.indexOf('***') > -1) {
	      throw $sceMinErr('iwcard',
	          'Illegal sequence *** in string matcher.  String: {0}', matcher);
	    }
	    matcher = escapeForRegexp(matcher).
	                  replace(/\\\*\\\*/g, '.*').
	                  replace(/\\\*/g, '[^:/.?&;]*');
	    return new RegExp('^' + matcher + '$');
	  } else if (isRegExp(matcher)) {
	    // The only other type of matcher allowed is a Regexp.
	    // Match entire URL / disallow partial matches.
	    // Flags are reset (i.e. no global, ignoreCase or multiline)
	    return new RegExp('^' + matcher.source + '$');
	  } else {
	    throw $sceMinErr('imatcher',
	        'Matchers may only be "self", string patterns or RegExp objects');
	  }
	}
	
	
	function adjustMatchers(matchers) {
	  var adjustedMatchers = [];
	  if (isDefined(matchers)) {
	    forEach(matchers, function(matcher) {
	      adjustedMatchers.push(adjustMatcher(matcher));
	    });
	  }
	  return adjustedMatchers;
	}
	
	
	/**
	 * @ngdoc service
	 * @name $sceDelegate
	 * @kind function
	 *
	 * @description
	 *
	 * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
	 * Contextual Escaping (SCE)} services to AngularJS.
	 *
	 * For an overview of this service and the functionnality it provides in AngularJS, see the main
	 * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
	 * SCE works in their application, which shouldn't be needed in most cases.
	 *
	 * <div class="alert alert-danger">
	 * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
	 * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
	 * changes to this service will also influence users, so be extra careful and document your changes.
	 * </div>
	 *
	 * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
	 * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
	 * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
	 * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
	 * work because `$sce` delegates to `$sceDelegate` for these operations.
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
	 *
	 * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
	 * can override it completely to change the behavior of `$sce`, the common case would
	 * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
	 * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
	 * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
	 * $sceDelegateProvider.resourceUrlWhitelist} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
	 */
	
	/**
	 * @ngdoc provider
	 * @name $sceDelegateProvider
	 * @this
	 *
	 * @description
	 *
	 * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
	 * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 *
	 * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
	 * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
	 * places that use the `$sce.RESOURCE_URL` context). See
	 * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
	 * and
	 * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
	 *
	 * For the general details about this service in Angular, read the main page for {@link ng.$sce
	 * Strict Contextual Escaping (SCE)}.
	 *
	 * **Example**:  Consider the following case. <a name="example"></a>
	 *
	 * - your app is hosted at url `http://myapp.example.com/`
	 * - but some of your templates are hosted on other domains you control such as
	 *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
	 * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
	 *
	 * Here is what a secure configuration for this scenario might look like:
	 *
	 * ```
	 *  angular.module('myApp', []).config(function($sceDelegateProvider) {
	 *    $sceDelegateProvider.resourceUrlWhitelist([
	 *      // Allow same origin resource loads.
	 *      'self',
	 *      // Allow loading from our assets domain.  Notice the difference between * and **.
	 *      'http://srv*.assets.example.com/**'
	 *    ]);
	 *
	 *    // The blacklist overrides the whitelist so the open redirect here is blocked.
	 *    $sceDelegateProvider.resourceUrlBlacklist([
	 *      'http://myapp.example.com/clickThru**'
	 *    ]);
	 *  });
	 * ```
	 * Note that an empty whitelist will block every resource URL from being loaded, and will require
	 * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
	 * requested by {@link ng.$templateRequest $templateRequest} that are present in
	 * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
	 * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
	 * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
	 * for instance attacker-controlled `ng-includes`.
	 */
	
	function $SceDelegateProvider() {
	  this.SCE_CONTEXTS = SCE_CONTEXTS;
	
	  // Resource URLs can also be trusted by policy.
	  var resourceUrlWhitelist = ['self'],
	      resourceUrlBlacklist = [];
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlWhitelist
	   * @kind function
	   *
	   * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.
	   *
	   * @return {Array} The currently set whitelist array.
	   *
	   * @description
	   * Sets/Gets the whitelist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
	   * same origin resource requests.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
	   * with other apps! It is a good idea to limit it to only your application's directory.
	   * </div>
	   */
	  this.resourceUrlWhitelist = function(value) {
	    if (arguments.length) {
	      resourceUrlWhitelist = adjustMatchers(value);
	    }
	    return resourceUrlWhitelist;
	  };
	
	  /**
	   * @ngdoc method
	   * @name $sceDelegateProvider#resourceUrlBlacklist
	   * @kind function
	   *
	   * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
	   *     provided.  This must be an array or null.  A snapshot of this array is used so further
	   *     changes to the array are ignored.</p><p>
	   *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
	   *     allowed in this array.</p><p>
	   *     The typical usage for the blacklist is to **block
	   *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
	   *     these would otherwise be trusted but actually return content from the redirected domain.
	   *     </p><p>
	   *     Finally, **the blacklist overrides the whitelist** and has the final say.
	   *
	   * @return {Array} The currently set blacklist array.
	   *
	   * @description
	   * Sets/Gets the blacklist of trusted resource URLs.
	   *
	   * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
	   * is no blacklist.)
	   */
	
	  this.resourceUrlBlacklist = function(value) {
	    if (arguments.length) {
	      resourceUrlBlacklist = adjustMatchers(value);
	    }
	    return resourceUrlBlacklist;
	  };
	
	  this.$get = ['$injector', function($injector) {
	
	    var htmlSanitizer = function htmlSanitizer(html) {
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    };
	
	    if ($injector.has('$sanitize')) {
	      htmlSanitizer = $injector.get('$sanitize');
	    }
	
	
	    function matchUrl(matcher, parsedUrl) {
	      if (matcher === 'self') {
	        return urlIsSameOrigin(parsedUrl);
	      } else {
	        // definitely a regex.  See adjustMatchers()
	        return !!matcher.exec(parsedUrl.href);
	      }
	    }
	
	    function isResourceUrlAllowedByPolicy(url) {
	      var parsedUrl = urlResolve(url.toString());
	      var i, n, allowed = false;
	      // Ensure that at least one item from the whitelist allows this url.
	      for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
	        if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
	          allowed = true;
	          break;
	        }
	      }
	      if (allowed) {
	        // Ensure that no item from the blacklist blocked this url.
	        for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
	          if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
	            allowed = false;
	            break;
	          }
	        }
	      }
	      return allowed;
	    }
	
	    function generateHolderType(Base) {
	      var holderType = function TrustedValueHolderType(trustedValue) {
	        this.$$unwrapTrustedValue = function() {
	          return trustedValue;
	        };
	      };
	      if (Base) {
	        holderType.prototype = new Base();
	      }
	      holderType.prototype.valueOf = function sceValueOf() {
	        return this.$$unwrapTrustedValue();
	      };
	      holderType.prototype.toString = function sceToString() {
	        return this.$$unwrapTrustedValue().toString();
	      };
	      return holderType;
	    }
	
	    var trustedValueHolderBase = generateHolderType(),
	        byType = {};
	
	    byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
	    byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#trustAs
	     *
	     * @description
	     * Returns a trusted representation of the parameter for the specified context. This trusted
	     * object will later on be used as-is, without any security check, by bindings or directives
	     * that require this security context.
	     * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
	     * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
	     * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
	     * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
	     * security risk.
	     *
	     * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
	     * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
	     * escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that should be considered trusted.
	     * @return {*} A trusted representation of value, that can be used in the given context.
	     */
	    function trustAs(type, trustedValue) {
	      var Constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      if (!Constructor) {
	        throw $sceMinErr('icontext',
	            'Attempted to trust a value in invalid context. Context: {0}; Value: {1}',
	            type, trustedValue);
	      }
	      if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
	        return trustedValue;
	      }
	      // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
	      // mutable objects, we ensure here that the value passed in is actually a string.
	      if (typeof trustedValue !== 'string') {
	        throw $sceMinErr('itype',
	            'Attempted to trust a non-string value in a content requiring a string: Context: {0}',
	            type);
	      }
	      return new Constructor(trustedValue);
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#valueOf
	     *
	     * @description
	     * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
	     * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
	     *
	     * If the passed parameter is not a value that had been returned by {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
	     *
	     * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
	     *     call or anything else.
	     * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
	     *     `value` unchanged.
	     */
	    function valueOf(maybeTrusted) {
	      if (maybeTrusted instanceof trustedValueHolderBase) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      } else {
	        return maybeTrusted;
	      }
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sceDelegate#getTrusted
	     *
	     * @description
	     * Takes any input, and either returns a value that's safe to use in the specified context, or
	     * throws an exception.
	     *
	     * In practice, there are several cases. When given a string, this function runs checks
	     * and sanitization to make it safe without prior assumptions. When given the result of a {@link
	     * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
	     * value if that value's context is valid for this call's context. Finally, this function can
	     * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
	     * is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
	     *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	    function getTrusted(type, maybeTrusted) {
	      if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
	        return maybeTrusted;
	      }
	      var constructor = (byType.hasOwnProperty(type) ? byType[type] : null);
	      // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
	      // as-is.
	      if (constructor && maybeTrusted instanceof constructor) {
	        return maybeTrusted.$$unwrapTrustedValue();
	      }
	      // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
	      // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
	      // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
	      // has no corresponding sinks.
	      if (type === SCE_CONTEXTS.RESOURCE_URL) {
	        // RESOURCE_URL uses a whitelist.
	        if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
	          return maybeTrusted;
	        } else {
	          throw $sceMinErr('insecurl',
	              'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}',
	              maybeTrusted.toString());
	        }
	      } else if (type === SCE_CONTEXTS.HTML) {
	        // htmlSanitizer throws its own error when no sanitizer is available.
	        return htmlSanitizer(maybeTrusted);
	      }
	      // Default error when the $sce service has no way to make the input safe.
	      throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
	    }
	
	    return { trustAs: trustAs,
	             getTrusted: getTrusted,
	             valueOf: valueOf };
	  }];
	}
	
	
	/**
	 * @ngdoc provider
	 * @name $sceProvider
	 * @this
	 *
	 * @description
	 *
	 * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
	 * -   enable/disable Strict Contextual Escaping (SCE) in a module
	 * -   override the default implementation with a custom delegate
	 *
	 * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
	 */
	
	/**
	 * @ngdoc service
	 * @name $sce
	 * @kind function
	 *
	 * @description
	 *
	 * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
	 *
	 * # Strict Contextual Escaping
	 *
	 * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
	 * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
	 * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
	 *
	 * ## Overview
	 *
	 * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
	 * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
	 * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
	 * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
	 * can be sanitized, but template URLs cannot, for instance.
	 *
	 * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
	 * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
	 * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
	 * render the input as-is, you will need to mark it as trusted for that context before attempting
	 * to bind it.
	 *
	 * As of version 1.2, AngularJS ships with SCE enabled by default.
	 *
	 * ## In practice
	 *
	 * Here's an example of a binding in a privileged context:
	 *
	 * ```
	 * <input ng-model="userHtml" aria-label="User input">
	 * <div ng-bind-html="userHtml"></div>
	 * ```
	 *
	 * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
	 * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
	 * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
	 * articles, etc. via bindings. (HTML is just one example of a context where rendering user
	 * controlled input creates security vulnerabilities.)
	 *
	 * For the case of HTML, you might use a library, either on the client side, or on the server side,
	 * to sanitize unsafe HTML before binding to the value and rendering it in the document.
	 *
	 * How would you ensure that every place that used these types of bindings was bound to a value that
	 * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
	 * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
	 * properties/fields and forgot to update the binding to the sanitized value?
	 *
	 * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
	 * any similar validation process, unless there's a good reason to trust the given value in this
	 * context.  That trust is formalized with a function call. This means that as a developer, you
	 * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
	 * you just need to ensure the values you mark as trusted indeed are safe - because they were
	 * received from your server, sanitized by your library, etc. You can organize your codebase to
	 * help with this - perhaps allowing only the files in a specific directory to do this.
	 * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
	 * becomes a more manageable task.
	 *
	 * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
	 * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
	 * build the trusted versions of your values.
	 *
	 * ## How does it work?
	 *
	 * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
	 * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
	 * a way to enforce the required security context in your data sink. Directives use {@link
	 * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
	 * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
	 * when binding without directives, AngularJS will understand the context of your bindings
	 * automatically.
	 *
	 * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
	 * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
	 * simplified):
	 *
	 * ```
	 * var ngBindHtmlDirective = ['$sce', function($sce) {
	 *   return function(scope, element, attr) {
	 *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
	 *       element.html(value || '');
	 *     });
	 *   };
	 * }];
	 * ```
	 *
	 * ## Impact on loading templates
	 *
	 * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
	 * `templateUrl`'s specified by {@link guide/directive directives}.
	 *
	 * By default, Angular only loads templates from the same domain and protocol as the application
	 * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
	 * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
	 * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
	 *
	 * *Please note*:
	 * The browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy apply in addition to this and may further restrict whether the template is successfully
	 * loaded.  This means that without the right CORS policy, loading templates from a different domain
	 * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
	 * browsers.
	 *
	 * ## This feels like too much overhead
	 *
	 * It's important to remember that SCE only applies to interpolation expressions.
	 *
	 * If your expressions are constant literals, they're automatically trusted and you don't need to
	 * call `$sce.trustAs` on them (e.g.
	 * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
	 * also use the `$sanitize` service if it is available when binding untrusted values to
	 * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
	 * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
	 * your application.
	 *
	 * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
	 * templates in `ng-include` from your application's domain without having to even know about SCE.
	 * It blocks loading templates from other domains or loading templates over http from an https
	 * served document.  You can change these by setting your own custom {@link
	 * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
	 * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
	 *
	 * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
	 * application that's secure and can be audited to verify that with much more ease than bolting
	 * security onto an application later.
	 *
	 * <a name="contexts"></a>
	 * ## What trusted context types are supported?
	 *
	 * | Context             | Notes          |
	 * |---------------------|----------------|
	 * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
	 * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
	 * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
	 * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
	 * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
	 *
	 *
	 * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
	 * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
	 * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
	 * might evolve.
	 *
	 * ## Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
	 *
	 *  Each element in these arrays must be one of the following:
	 *
	 *  - **'self'**
	 *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
	 *      domain** as the application document using the **same protocol**.
	 *  - **String** (except the special value `'self'`)
	 *    - The string is matched against the full *normalized / absolute URL* of the resource
	 *      being tested (substring matches are not good enough.)
	 *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
	 *      match themselves.
	 *    - `*`: matches zero or more occurrences of any character other than one of the following 6
	 *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
	 *      in a whitelist.
	 *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
	 *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
	 *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
	 *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
	 *      http://foo.example.com/templates/**).
	 *  - **RegExp** (*see caveat below*)
	 *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
	 *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
	 *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
	 *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
	 *      small number of cases.  A `.` character in the regex used when matching the scheme or a
	 *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
	 *      is highly recommended to use the string patterns and only fall back to regular expressions
	 *      as a last resort.
	 *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
	 *      matched against the **entire** *normalized / absolute URL* of the resource being tested
	 *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
	 *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
	 *    - If you are generating your JavaScript from some other templating engine (not
	 *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
	 *      remember to escape your regular expression (and be aware that you might need more than
	 *      one level of escaping depending on your templating engine and the way you interpolated
	 *      the value.)  Do make use of your platform's escaping mechanism as it might be good
	 *      enough before coding your own.  E.g. Ruby has
	 *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
	 *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
	 *      Javascript lacks a similar built in function for escaping.  Take a look at Google
	 *      Closure library's [goog.string.regExpEscape(s)](
	 *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
	 *
	 * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
	 *
	 * ## Show me an example using SCE.
	 *
	 * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
	 * <file name="index.html">
	 *   <div ng-controller="AppController as myCtrl">
	 *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
	 *     <b>User comments</b><br>
	 *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
	 *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
	 *     exploit.
	 *     <div class="well">
	 *       <div ng-repeat="userComment in myCtrl.userComments">
	 *         <b>{{userComment.name}}</b>:
	 *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
	 *         <br>
	 *       </div>
	 *     </div>
	 *   </div>
	 * </file>
	 *
	 * <file name="script.js">
	 *   angular.module('mySceApp', ['ngSanitize'])
	 *     .controller('AppController', ['$http', '$templateCache', '$sce',
	 *       function AppController($http, $templateCache, $sce) {
	 *         var self = this;
	 *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
	 *           self.userComments = response.data;
	 *         });
	 *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
	 *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *             'sanitization.&quot;">Hover over this text.</span>');
	 *       }]);
	 * </file>
	 *
	 * <file name="test_data.json">
	 * [
	 *   { "name": "Alice",
	 *     "htmlComment":
	 *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
	 *   },
	 *   { "name": "Bob",
	 *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
	 *   }
	 * ]
	 * </file>
	 *
	 * <file name="protractor.js" type="protractor">
	 *   describe('SCE doc demo', function() {
	 *     it('should sanitize untrusted values', function() {
	 *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
	 *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
	 *     });
	 *
	 *     it('should NOT sanitize explicitly trusted values', function() {
	 *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
	 *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
	 *           'sanitization.&quot;">Hover over this text.</span>');
	 *     });
	 *   });
	 * </file>
	 * </example>
	 *
	 *
	 *
	 * ## Can I disable SCE completely?
	 *
	 * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
	 * for little coding overhead.  It will be much harder to take an SCE disabled application and
	 * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
	 * for cases where you have a lot of existing code that was written before SCE was introduced and
	 * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
	 * you are writing a library, you will cause security bugs applications using it.
	 *
	 * That said, here's how you can completely disable SCE:
	 *
	 * ```
	 * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
	 *   // Completely disable SCE.  For demonstration purposes only!
	 *   // Do not use in new projects or libraries.
	 *   $sceProvider.enabled(false);
	 * });
	 * ```
	 *
	 */
	
	function $SceProvider() {
	  var enabled = true;
	
	  /**
	   * @ngdoc method
	   * @name $sceProvider#enabled
	   * @kind function
	   *
	   * @param {boolean=} value If provided, then enables/disables SCE application-wide.
	   * @return {boolean} True if SCE is enabled, false otherwise.
	   *
	   * @description
	   * Enables/disables SCE and returns the current value.
	   */
	  this.enabled = function(value) {
	    if (arguments.length) {
	      enabled = !!value;
	    }
	    return enabled;
	  };
	
	
	  /* Design notes on the default implementation for SCE.
	   *
	   * The API contract for the SCE delegate
	   * -------------------------------------
	   * The SCE delegate object must provide the following 3 methods:
	   *
	   * - trustAs(contextEnum, value)
	   *     This method is used to tell the SCE service that the provided value is OK to use in the
	   *     contexts specified by contextEnum.  It must return an object that will be accepted by
	   *     getTrusted() for a compatible contextEnum and return this value.
	   *
	   * - valueOf(value)
	   *     For values that were not produced by trustAs(), return them as is.  For values that were
	   *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
	   *     trustAs is wrapping the given values into some type, this operation unwraps it when given
	   *     such a value.
	   *
	   * - getTrusted(contextEnum, value)
	   *     This function should return the a value that is safe to use in the context specified by
	   *     contextEnum or throw and exception otherwise.
	   *
	   * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
	   * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
	   * instance, an implementation could maintain a registry of all trusted objects by context.  In
	   * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
	   * return the same object passed in if it was found in the registry under a compatible context or
	   * throw an exception otherwise.  An implementation might only wrap values some of the time based
	   * on some criteria.  getTrusted() might return a value and not throw an exception for special
	   * constants or objects even if not wrapped.  All such implementations fulfill this contract.
	   *
	   *
	   * A note on the inheritance model for SCE contexts
	   * ------------------------------------------------
	   * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
	   * is purely an implementation details.
	   *
	   * The contract is simply this:
	   *
	   *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
	   *     will also succeed.
	   *
	   * Inheritance happens to capture this in a natural way. In some future, we may not use
	   * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
	   * be aware of this detail.
	   */
	
	  this.$get = ['$parse', '$sceDelegate', function(
	                $parse,   $sceDelegate) {
	    // Support: IE 9-11 only
	    // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
	    // the "expression(javascript expression)" syntax which is insecure.
	    if (enabled && msie < 8) {
	      throw $sceMinErr('iequirks',
	        'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' +
	        'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' +
	        'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
	    }
	
	    var sce = shallowCopy(SCE_CONTEXTS);
	
	    /**
	     * @ngdoc method
	     * @name $sce#isEnabled
	     * @kind function
	     *
	     * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
	     *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
	     *
	     * @description
	     * Returns a boolean indicating if SCE is enabled.
	     */
	    sce.isEnabled = function() {
	      return enabled;
	    };
	    sce.trustAs = $sceDelegate.trustAs;
	    sce.getTrusted = $sceDelegate.getTrusted;
	    sce.valueOf = $sceDelegate.valueOf;
	
	    if (!enabled) {
	      sce.trustAs = sce.getTrusted = function(type, value) { return value; };
	      sce.valueOf = identity;
	    }
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAs
	     *
	     * @description
	     * Converts Angular {@link guide/expression expression} into a function.  This is like {@link
	     * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
	     * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
	     * *result*)}
	     *
	     * @param {string} type The SCE context in which this result will be used.
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	    sce.parseAs = function sceParseAs(type, expr) {
	      var parsed = $parse(expr);
	      if (parsed.literal && parsed.constant) {
	        return parsed;
	      } else {
	        return $parse(expr, function(value) {
	          return sce.getTrusted(type, value);
	        });
	      }
	    };
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAs
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
	     * wrapped object that represents your value, and the trust you have in its safety for the given
	     * context. AngularJS can then use that value as-is in bindings of the specified secure context.
	     * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
	     * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
	     *
	     * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
	     *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
	     *
	     * @param {*} value The value that that should be considered trusted.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in the context you specified.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsHtml(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.HTML` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.HTML` context (like `ng-bind-html`).
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsCss(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.CSS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant
	     *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
	     *     almost no reasons to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
	     *     to use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
	     *     bindings, ...)
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#trustAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.trustAsJs(value)` →
	     *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
	     *
	     * @param {*} value The value to mark as trusted for `$sce.JS` context.
	     * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
	     *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
	     *     use this function so far.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrusted
	     *
	     * @description
	     * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
	     * takes any input, and either returns a value that's safe to use in the specified context,
	     * or throws an exception. This function is aware of trusted values created by the `trustAs`
	     * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
	     * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
	     * safe value (e.g., no sanitization is available or possible.)
	     *
	     * @param {string} type The context in which this value is to be used.
	     * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
	     *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
	     * @return {*} A version of the value that's safe to use in the given context, or throws an
	     *     exception if this is impossible.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedHtml(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedCss
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedCss(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
	     *
	     * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#getTrustedJs
	     *
	     * @description
	     * Shorthand method.  `$sce.getTrustedJs(value)` →
	     *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
	     *
	     * @param {*} value The value to pass to `$sce.getTrusted`.
	     * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsHtml
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsHtml(expression string)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsCss
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsCss(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsResourceUrl
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    /**
	     * @ngdoc method
	     * @name $sce#parseAsJs
	     *
	     * @description
	     * Shorthand method.  `$sce.parseAsJs(value)` →
	     *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
	     *
	     * @param {string} expression String expression to compile.
	     * @return {function(context, locals)} A function which represents the compiled expression:
	     *
	     *    * `context` – `{object}` – an object against which any expressions embedded in the
	     *      strings are evaluated against (typically a scope object).
	     *    * `locals` – `{object=}` – local variables context object, useful for overriding values
	     *      in `context`.
	     */
	
	    // Shorthand delegations.
	    var parse = sce.parseAs,
	        getTrusted = sce.getTrusted,
	        trustAs = sce.trustAs;
	
	    forEach(SCE_CONTEXTS, function(enumValue, name) {
	      var lName = lowercase(name);
	      sce[snakeToCamel('parse_as_' + lName)] = function(expr) {
	        return parse(enumValue, expr);
	      };
	      sce[snakeToCamel('get_trusted_' + lName)] = function(value) {
	        return getTrusted(enumValue, value);
	      };
	      sce[snakeToCamel('trust_as_' + lName)] = function(value) {
	        return trustAs(enumValue, value);
	      };
	    });
	
	    return sce;
	  }];
	}
	
	/* exported $SnifferProvider */
	
	/**
	 * !!! This is an undocumented "private" service !!!
	 *
	 * @name $sniffer
	 * @requires $window
	 * @requires $document
	 * @this
	 *
	 * @property {boolean} history Does the browser support html5 history api ?
	 * @property {boolean} transitions Does the browser support CSS transition events ?
	 * @property {boolean} animations Does the browser support CSS animation events ?
	 *
	 * @description
	 * This is very simple implementation of testing browser's features.
	 */
	function $SnifferProvider() {
	  this.$get = ['$window', '$document', function($window, $document) {
	    var eventSupport = {},
	        // Chrome Packaged Apps are not allowed to access `history.pushState`.
	        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
	        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
	        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
	        // (see https://developer.chrome.com/apps/manifest/sandbox).
	        // (NW.js apps have access to Chrome APIs, but do support `history`.)
	        isNw = $window.nw && $window.nw.process,
	        isChromePackagedApp =
	            !isNw &&
	            $window.chrome &&
	            ($window.chrome.app && $window.chrome.app.runtime ||
	                !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
	        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
	        android =
	          toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
	        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
	        document = $document[0] || {},
	        bodyStyle = document.body && document.body.style,
	        transitions = false,
	        animations = false;
	
	    if (bodyStyle) {
	      // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
	      // Mentioned browsers need a -webkit- prefix for transitions & animations.
	      transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
	      animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
	    }
	
	
	    return {
	      // Android has history.pushState, but it does not update location correctly
	      // so let's not use the history API at all.
	      // http://code.google.com/p/android/issues/detail?id=17471
	      // https://github.com/angular/angular.js/issues/904
	
	      // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
	      // so let's not use the history API also
	      // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
	      history: !!(hasHistoryPushState && !(android < 4) && !boxee),
	      hasEvent: function(event) {
	        // Support: IE 9-11 only
	        // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
	        // it. In particular the event is not fired when backspace or delete key are pressed or
	        // when cut operation is performed.
	        // IE10+ implements 'input' event but it erroneously fires under various situations,
	        // e.g. when placeholder changes, or a form is focused.
	        if (event === 'input' && msie) return false;
	
	        if (isUndefined(eventSupport[event])) {
	          var divElm = document.createElement('div');
	          eventSupport[event] = 'on' + event in divElm;
	        }
	
	        return eventSupport[event];
	      },
	      csp: csp(),
	      transitions: transitions,
	      animations: animations,
	      android: android
	    };
	  }];
	}
	
	var $templateRequestMinErr = minErr('$compile');
	
	/**
	 * @ngdoc provider
	 * @name $templateRequestProvider
	 * @this
	 *
	 * @description
	 * Used to configure the options passed to the {@link $http} service when making a template request.
	 *
	 * For example, it can be used for specifying the "Accept" header that is sent to the server, when
	 * requesting a template.
	 */
	function $TemplateRequestProvider() {
	
	  var httpOptions;
	
	  /**
	   * @ngdoc method
	   * @name $templateRequestProvider#httpOptions
	   * @description
	   * The options to be passed to the {@link $http} service when making the request.
	   * You can use this to override options such as the "Accept" header for template requests.
	   *
	   * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
	   * options if not overridden here.
	   *
	   * @param {string=} value new value for the {@link $http} options.
	   * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
	   */
	  this.httpOptions = function(val) {
	    if (val) {
	      httpOptions = val;
	      return this;
	    }
	    return httpOptions;
	  };
	
	  /**
	   * @ngdoc service
	   * @name $templateRequest
	   *
	   * @description
	   * The `$templateRequest` service runs security checks then downloads the provided template using
	   * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
	   * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
	   * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
	   * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
	   * when `tpl` is of type string and `$templateCache` has the matching entry.
	   *
	   * If you want to pass custom options to the `$http` service, such as setting the Accept header you
	   * can configure this via {@link $templateRequestProvider#httpOptions}.
	   *
	   * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
	   * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
	   *
	   * @return {Promise} a promise for the HTTP response data of the given URL.
	   *
	   * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
	   */
	  this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce',
	    function($exceptionHandler, $templateCache, $http, $q, $sce) {
	
	      function handleRequestFn(tpl, ignoreRequestError) {
	        handleRequestFn.totalPendingRequests++;
	
	        // We consider the template cache holds only trusted templates, so
	        // there's no need to go through whitelisting again for keys that already
	        // are included in there. This also makes Angular accept any script
	        // directive, no matter its name. However, we still need to unwrap trusted
	        // types.
	        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
	          tpl = $sce.getTrustedResourceUrl(tpl);
	        }
	
	        var transformResponse = $http.defaults && $http.defaults.transformResponse;
	
	        if (isArray(transformResponse)) {
	          transformResponse = transformResponse.filter(function(transformer) {
	            return transformer !== defaultHttpResponseTransform;
	          });
	        } else if (transformResponse === defaultHttpResponseTransform) {
	          transformResponse = null;
	        }
	
	        return $http.get(tpl, extend({
	            cache: $templateCache,
	            transformResponse: transformResponse
	          }, httpOptions))
	          .finally(function() {
	            handleRequestFn.totalPendingRequests--;
	          })
	          .then(function(response) {
	            $templateCache.put(tpl, response.data);
	            return response.data;
	          }, handleError);
	
	        function handleError(resp) {
	          if (!ignoreRequestError) {
	            resp = $templateRequestMinErr('tpload',
	                'Failed to load template: {0} (HTTP status: {1} {2})',
	                tpl, resp.status, resp.statusText);
	
	            $exceptionHandler(resp);
	          }
	
	          return $q.reject(resp);
	        }
	      }
	
	      handleRequestFn.totalPendingRequests = 0;
	
	      return handleRequestFn;
	    }
	  ];
	}
	
	/** @this */
	function $$TestabilityProvider() {
	  this.$get = ['$rootScope', '$browser', '$location',
	       function($rootScope,   $browser,   $location) {
	
	    /**
	     * @name $testability
	     *
	     * @description
	     * The private $$testability service provides a collection of methods for use when debugging
	     * or by automated test and debugging tools.
	     */
	    var testability = {};
	
	    /**
	     * @name $$testability#findBindings
	     *
	     * @description
	     * Returns an array of elements that are bound (via ng-bind or {{}})
	     * to expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The binding expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression. Filters and whitespace are ignored.
	     */
	    testability.findBindings = function(element, expression, opt_exactMatch) {
	      var bindings = element.getElementsByClassName('ng-binding');
	      var matches = [];
	      forEach(bindings, function(binding) {
	        var dataBinding = angular.element(binding).data('$binding');
	        if (dataBinding) {
	          forEach(dataBinding, function(bindingName) {
	            if (opt_exactMatch) {
	              var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
	              if (matcher.test(bindingName)) {
	                matches.push(binding);
	              }
	            } else {
	              if (bindingName.indexOf(expression) !== -1) {
	                matches.push(binding);
	              }
	            }
	          });
	        }
	      });
	      return matches;
	    };
	
	    /**
	     * @name $$testability#findModels
	     *
	     * @description
	     * Returns an array of elements that are two-way found via ng-model to
	     * expressions matching the input.
	     *
	     * @param {Element} element The element root to search from.
	     * @param {string} expression The model expression to match.
	     * @param {boolean} opt_exactMatch If true, only returns exact matches
	     *     for the expression.
	     */
	    testability.findModels = function(element, expression, opt_exactMatch) {
	      var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
	      for (var p = 0; p < prefixes.length; ++p) {
	        var attributeEquals = opt_exactMatch ? '=' : '*=';
	        var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
	        var elements = element.querySelectorAll(selector);
	        if (elements.length) {
	          return elements;
	        }
	      }
	    };
	
	    /**
	     * @name $$testability#getLocation
	     *
	     * @description
	     * Shortcut for getting the location in a browser agnostic way. Returns
	     *     the path, search, and hash. (e.g. /path?a=b#hash)
	     */
	    testability.getLocation = function() {
	      return $location.url();
	    };
	
	    /**
	     * @name $$testability#setLocation
	     *
	     * @description
	     * Shortcut for navigating to a location without doing a full page reload.
	     *
	     * @param {string} url The location url (path, search and hash,
	     *     e.g. /path?a=b#hash) to go to.
	     */
	    testability.setLocation = function(url) {
	      if (url !== $location.url()) {
	        $location.url(url);
	        $rootScope.$digest();
	      }
	    };
	
	    /**
	     * @name $$testability#whenStable
	     *
	     * @description
	     * Calls the callback when $timeout and $http requests are completed.
	     *
	     * @param {function} callback
	     */
	    testability.whenStable = function(callback) {
	      $browser.notifyWhenNoOutstandingRequests(callback);
	    };
	
	    return testability;
	  }];
	}
	
	/** @this */
	function $TimeoutProvider() {
	  this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler',
	       function($rootScope,   $browser,   $q,   $$q,   $exceptionHandler) {
	
	    var deferreds = {};
	
	
	     /**
	      * @ngdoc service
	      * @name $timeout
	      *
	      * @description
	      * Angular's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
	      * block and delegates any exceptions to
	      * {@link ng.$exceptionHandler $exceptionHandler} service.
	      *
	      * The return value of calling `$timeout` is a promise, which will be resolved when
	      * the delay has passed and the timeout function, if provided, is executed.
	      *
	      * To cancel a timeout request, call `$timeout.cancel(promise)`.
	      *
	      * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
	      * synchronously flush the queue of deferred functions.
	      *
	      * If you only want a promise that will be resolved after some specified delay
	      * then you can call `$timeout` without the `fn` function.
	      *
	      * @param {function()=} fn A function, whose execution should be delayed.
	      * @param {number=} [delay=0] Delay in milliseconds.
	      * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
	      *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
	      * @param {...*=} Pass additional parameters to the executed function.
	      * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
	      *   will be resolved with the return value of the `fn` function.
	      *
	      */
	    function timeout(fn, delay, invokeApply) {
	      if (!isFunction(fn)) {
	        invokeApply = delay;
	        delay = fn;
	        fn = noop;
	      }
	
	      var args = sliceArgs(arguments, 3),
	          skipApply = (isDefined(invokeApply) && !invokeApply),
	          deferred = (skipApply ? $$q : $q).defer(),
	          promise = deferred.promise,
	          timeoutId;
	
	      timeoutId = $browser.defer(function() {
	        try {
	          deferred.resolve(fn.apply(null, args));
	        } catch (e) {
	          deferred.reject(e);
	          $exceptionHandler(e);
	        } finally {
	          delete deferreds[promise.$$timeoutId];
	        }
	
	        if (!skipApply) $rootScope.$apply();
	      }, delay);
	
	      promise.$$timeoutId = timeoutId;
	      deferreds[timeoutId] = deferred;
	
	      return promise;
	    }
	
	
	     /**
	      * @ngdoc method
	      * @name $timeout#cancel
	      *
	      * @description
	      * Cancels a task associated with the `promise`. As a result of this, the promise will be
	      * resolved with a rejection.
	      *
	      * @param {Promise=} promise Promise returned by the `$timeout` function.
	      * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
	      *   canceled.
	      */
	    timeout.cancel = function(promise) {
	      if (promise && promise.$$timeoutId in deferreds) {
	        // Timeout cancels should not report an unhandled promise.
	        deferreds[promise.$$timeoutId].promise.catch(noop);
	        deferreds[promise.$$timeoutId].reject('canceled');
	        delete deferreds[promise.$$timeoutId];
	        return $browser.defer.cancel(promise.$$timeoutId);
	      }
	      return false;
	    };
	
	    return timeout;
	  }];
	}
	
	// NOTE:  The usage of window and document instead of $window and $document here is
	// deliberate.  This service depends on the specific behavior of anchor nodes created by the
	// browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
	// cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
	// doesn't know about mocked locations and resolves URLs to the real document - which is
	// exactly the behavior needed here.  There is little value is mocking these out for this
	// service.
	var urlParsingNode = window.document.createElement('a');
	var originUrl = urlResolve(window.location.href);
	
	
	/**
	 *
	 * Implementation Notes for non-IE browsers
	 * ----------------------------------------
	 * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
	 * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
	 * URL will be resolved into an absolute URL in the context of the application document.
	 * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
	 * properties are all populated to reflect the normalized URL.  This approach has wide
	 * compatibility - Safari 1+, Mozilla 1+ etc.  See
	 * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *
	 * Implementation Notes for IE
	 * ---------------------------
	 * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
	 * browsers.  However, the parsed components will not be set if the URL assigned did not specify
	 * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
	 * work around that by performing the parsing in a 2nd step by taking a previously normalized
	 * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
	 * properties such as protocol, hostname, port, etc.
	 *
	 * References:
	 *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
	 *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
	 *   http://url.spec.whatwg.org/#urlutils
	 *   https://github.com/angular/angular.js/pull/2902
	 *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
	 *
	 * @kind function
	 * @param {string} url The URL to be parsed.
	 * @description Normalizes and parses a URL.
	 * @returns {object} Returns the normalized URL as a dictionary.
	 *
	 *   | member name   | Description    |
	 *   |---------------|----------------|
	 *   | href          | A normalized version of the provided URL if it was not an absolute URL |
	 *   | protocol      | The protocol including the trailing colon                              |
	 *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
	 *   | search        | The search params, minus the question mark                             |
	 *   | hash          | The hash string, minus the hash symbol
	 *   | hostname      | The hostname
	 *   | port          | The port, without ":"
	 *   | pathname      | The pathname, beginning with "/"
	 *
	 */
	function urlResolve(url) {
	  var href = url;
	
	  // Support: IE 9-11 only
	  if (msie) {
	    // Normalize before parse.  Refer Implementation Notes on why this is
	    // done in two steps on IE.
	    urlParsingNode.setAttribute('href', href);
	    href = urlParsingNode.href;
	  }
	
	  urlParsingNode.setAttribute('href', href);
	
	  // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	  return {
	    href: urlParsingNode.href,
	    protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	    host: urlParsingNode.host,
	    search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	    hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	    hostname: urlParsingNode.hostname,
	    port: urlParsingNode.port,
	    pathname: (urlParsingNode.pathname.charAt(0) === '/')
	      ? urlParsingNode.pathname
	      : '/' + urlParsingNode.pathname
	  };
	}
	
	/**
	 * Parse a request URL and determine whether this is a same-origin request as the application document.
	 *
	 * @param {string|object} requestUrl The url of the request as a string that will be resolved
	 * or a parsed URL object.
	 * @returns {boolean} Whether the request is for the same origin as the application document.
	 */
	function urlIsSameOrigin(requestUrl) {
	  var parsed = (isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
	  return (parsed.protocol === originUrl.protocol &&
	          parsed.host === originUrl.host);
	}
	
	/**
	 * @ngdoc service
	 * @name $window
	 * @this
	 *
	 * @description
	 * A reference to the browser's `window` object. While `window`
	 * is globally available in JavaScript, it causes testability problems, because
	 * it is a global variable. In angular we always refer to it through the
	 * `$window` service, so it may be overridden, removed or mocked for testing.
	 *
	 * Expressions, like the one defined for the `ngClick` directive in the example
	 * below, are evaluated with respect to the current scope.  Therefore, there is
	 * no risk of inadvertently coding in a dependency on a global value in such an
	 * expression.
	 *
	 * @example
	   <example module="windowExample" name="window-service">
	     <file name="index.html">
	       <script>
	         angular.module('windowExample', [])
	           .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
	             $scope.greeting = 'Hello, World!';
	             $scope.doGreeting = function(greeting) {
	               $window.alert(greeting);
	             };
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="text" ng-model="greeting" aria-label="greeting" />
	         <button ng-click="doGreeting(greeting)">ALERT</button>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	      it('should display the greeting in the input box', function() {
	       element(by.model('greeting')).sendKeys('Hello, E2E Tests');
	       // If we click the button it will block the test runner
	       // element(':button').click();
	      });
	     </file>
	   </example>
	 */
	function $WindowProvider() {
	  this.$get = valueFn(window);
	}
	
	/**
	 * @name $$cookieReader
	 * @requires $document
	 *
	 * @description
	 * This is a private service for reading cookies used by $http and ngCookies
	 *
	 * @return {Object} a key/value map of the current cookies
	 */
	function $$CookieReader($document) {
	  var rawDocument = $document[0] || {};
	  var lastCookies = {};
	  var lastCookieString = '';
	
	  function safeGetCookie(rawDocument) {
	    try {
	      return rawDocument.cookie || '';
	    } catch (e) {
	      return '';
	    }
	  }
	
	  function safeDecodeURIComponent(str) {
	    try {
	      return decodeURIComponent(str);
	    } catch (e) {
	      return str;
	    }
	  }
	
	  return function() {
	    var cookieArray, cookie, i, index, name;
	    var currentCookieString = safeGetCookie(rawDocument);
	
	    if (currentCookieString !== lastCookieString) {
	      lastCookieString = currentCookieString;
	      cookieArray = lastCookieString.split('; ');
	      lastCookies = {};
	
	      for (i = 0; i < cookieArray.length; i++) {
	        cookie = cookieArray[i];
	        index = cookie.indexOf('=');
	        if (index > 0) { //ignore nameless cookies
	          name = safeDecodeURIComponent(cookie.substring(0, index));
	          // the first value that is seen for a cookie is the most
	          // specific one.  values for the same cookie name that
	          // follow are for less specific paths.
	          if (isUndefined(lastCookies[name])) {
	            lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
	          }
	        }
	      }
	    }
	    return lastCookies;
	  };
	}
	
	$$CookieReader.$inject = ['$document'];
	
	/** @this */
	function $$CookieReaderProvider() {
	  this.$get = $$CookieReader;
	}
	
	/* global currencyFilter: true,
	 dateFilter: true,
	 filterFilter: true,
	 jsonFilter: true,
	 limitToFilter: true,
	 lowercaseFilter: true,
	 numberFilter: true,
	 orderByFilter: true,
	 uppercaseFilter: true,
	 */
	
	/**
	 * @ngdoc provider
	 * @name $filterProvider
	 * @description
	 *
	 * Filters are just functions which transform input to an output. However filters need to be
	 * Dependency Injected. To achieve this a filter definition consists of a factory function which is
	 * annotated with dependencies and is responsible for creating a filter function.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	 * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	 * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	 * (`myapp_subsection_filterx`).
	 * </div>
	 *
	 * ```js
	 *   // Filter registration
	 *   function MyModule($provide, $filterProvider) {
	 *     // create a service to demonstrate injection (not always needed)
	 *     $provide.value('greet', function(name){
	 *       return 'Hello ' + name + '!';
	 *     });
	 *
	 *     // register a filter factory which uses the
	 *     // greet service to demonstrate DI.
	 *     $filterProvider.register('greet', function(greet){
	 *       // return the filter function which uses the greet service
	 *       // to generate salutation
	 *       return function(text) {
	 *         // filters need to be forgiving so check input validity
	 *         return text && greet(text) || text;
	 *       };
	 *     });
	 *   }
	 * ```
	 *
	 * The filter function is registered with the `$injector` under the filter name suffix with
	 * `Filter`.
	 *
	 * ```js
	 *   it('should be the same instance', inject(
	 *     function($filterProvider) {
	 *       $filterProvider.register('reverse', function(){
	 *         return ...;
	 *       });
	 *     },
	 *     function($filter, reverseFilter) {
	 *       expect($filter('reverse')).toBe(reverseFilter);
	 *     });
	 * ```
	 *
	 *
	 * For more information about how angular filters work, and how to create your own filters, see
	 * {@link guide/filter Filters} in the Angular Developer Guide.
	 */
	
	/**
	 * @ngdoc service
	 * @name $filter
	 * @kind function
	 * @description
	 * Filters are used for formatting data displayed to the user.
	 *
	 * They can be used in view templates, controllers or services.Angular comes
	 * with a collection of [built-in filters](api/ng/filter), but it is easy to
	 * define your own as well.
	 *
	 * The general syntax in templates is as follows:
	 *
	 * ```html
	 * {{ expression [| filter_name[:parameter_value] ... ] }}
	 * ```
	 *
	 * @param {String} name Name of the filter function to retrieve
	 * @return {Function} the filter function
	 * @example
	   <example name="$filter" module="filterExample">
	     <file name="index.html">
	       <div ng-controller="MainCtrl">
	        <h3>{{ originalText }}</h3>
	        <h3>{{ filteredText }}</h3>
	       </div>
	     </file>
	
	     <file name="script.js">
	      angular.module('filterExample', [])
	      .controller('MainCtrl', function($scope, $filter) {
	        $scope.originalText = 'hello';
	        $scope.filteredText = $filter('uppercase')($scope.originalText);
	      });
	     </file>
	   </example>
	  */
	$FilterProvider.$inject = ['$provide'];
	/** @this */
	function $FilterProvider($provide) {
	  var suffix = 'Filter';
	
	  /**
	   * @ngdoc method
	   * @name $filterProvider#register
	   * @param {string|Object} name Name of the filter function, or an object map of filters where
	   *    the keys are the filter names and the values are the filter factories.
	   *
	   *    <div class="alert alert-warning">
	   *    **Note:** Filter names must be valid angular {@link expression} identifiers, such as `uppercase` or `orderBy`.
	   *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
	   *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
	   *    (`myapp_subsection_filterx`).
	   *    </div>
	    * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
	   * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
	   *    of the registered filter instances.
	   */
	  function register(name, factory) {
	    if (isObject(name)) {
	      var filters = {};
	      forEach(name, function(filter, key) {
	        filters[key] = register(key, filter);
	      });
	      return filters;
	    } else {
	      return $provide.factory(name + suffix, factory);
	    }
	  }
	  this.register = register;
	
	  this.$get = ['$injector', function($injector) {
	    return function(name) {
	      return $injector.get(name + suffix);
	    };
	  }];
	
	  ////////////////////////////////////////
	
	  /* global
	    currencyFilter: false,
	    dateFilter: false,
	    filterFilter: false,
	    jsonFilter: false,
	    limitToFilter: false,
	    lowercaseFilter: false,
	    numberFilter: false,
	    orderByFilter: false,
	    uppercaseFilter: false
	  */
	
	  register('currency', currencyFilter);
	  register('date', dateFilter);
	  register('filter', filterFilter);
	  register('json', jsonFilter);
	  register('limitTo', limitToFilter);
	  register('lowercase', lowercaseFilter);
	  register('number', numberFilter);
	  register('orderBy', orderByFilter);
	  register('uppercase', uppercaseFilter);
	}
	
	/**
	 * @ngdoc filter
	 * @name filter
	 * @kind function
	 *
	 * @description
	 * Selects a subset of items from `array` and returns it as a new array.
	 *
	 * @param {Array} array The source array.
	 * <div class="alert alert-info">
	 *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
	 * </div>
	 * @param {string|Object|function()} expression The predicate to be used for selecting items from
	 *   `array`.
	 *
	 *   Can be one of:
	 *
	 *   - `string`: The string is used for matching against the contents of the `array`. All strings or
	 *     objects with string properties in `array` that match this string will be returned. This also
	 *     applies to nested object properties.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *
	 *   - `Object`: A pattern object can be used to filter specific properties on objects contained
	 *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
	 *     which have property `name` containing "M" and property `phone` containing "1". A special
	 *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
	 *     against any property of the object or its nested object properties. That's equivalent to the
	 *     simple substring match with a `string` as described above. The special property name can be
	 *     overwritten, using the `anyPropertyKey` parameter.
	 *     The predicate can be negated by prefixing the string with `!`.
	 *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
	 *     not containing "M".
	 *
	 *     Note that a named property will match properties on the same level only, while the special
	 *     `$` property will match properties on the same level or deeper. E.g. an array item like
	 *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
	 *     **will** be matched by `{$: 'John'}`.
	 *
	 *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
	 *     The function is called for each element of the array, with the element, its index, and
	 *     the entire array itself as arguments.
	 *
	 *     The final result is an array of those elements that the predicate returned true for.
	 *
	 * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
	 *     determining if values retrieved using `expression` (when it is not a function) should be
	 *     considered a match based on the the expected value (from the filter expression) and actual
	 *     value (from the object in the array).
	 *
	 *   Can be one of:
	 *
	 *   - `function(actual, expected)`:
	 *     The function will be given the object value and the predicate value to compare and
	 *     should return true if both values should be considered equal.
	 *
	 *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
	 *     This is essentially strict comparison of expected and actual.
	 *
	 *   - `false`: A short hand for a function which will look for a substring match in a case
	 *     insensitive way. Primitive values are converted to strings. Objects are not compared against
	 *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
	 *
	 *
	 *   Defaults to `false`.
	 *
	 * @param {string} [anyPropertyKey] The special property name that matches against any property.
	 *     By default `$`.
	 *
	 * @example
	   <example name="filter-filter">
	     <file name="index.html">
	       <div ng-init="friends = [{name:'John', phone:'555-1276'},
	                                {name:'Mary', phone:'800-BIG-MARY'},
	                                {name:'Mike', phone:'555-4321'},
	                                {name:'Adam', phone:'555-5678'},
	                                {name:'Julie', phone:'555-8765'},
	                                {name:'Juliette', phone:'555-5678'}]"></div>
	
	       <label>Search: <input ng-model="searchText"></label>
	       <table id="searchTextResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friend in friends | filter:searchText">
	           <td>{{friend.name}}</td>
	           <td>{{friend.phone}}</td>
	         </tr>
	       </table>
	       <hr>
	       <label>Any: <input ng-model="search.$"></label> <br>
	       <label>Name only <input ng-model="search.name"></label><br>
	       <label>Phone only <input ng-model="search.phone"></label><br>
	       <label>Equality <input type="checkbox" ng-model="strict"></label><br>
	       <table id="searchObjResults">
	         <tr><th>Name</th><th>Phone</th></tr>
	         <tr ng-repeat="friendObj in friends | filter:search:strict">
	           <td>{{friendObj.name}}</td>
	           <td>{{friendObj.phone}}</td>
	         </tr>
	       </table>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var expectFriendNames = function(expectedNames, key) {
	         element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
	           arr.forEach(function(wd, i) {
	             expect(wd.getText()).toMatch(expectedNames[i]);
	           });
	         });
	       };
	
	       it('should search across all fields when filtering with a string', function() {
	         var searchText = element(by.model('searchText'));
	         searchText.clear();
	         searchText.sendKeys('m');
	         expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
	
	         searchText.clear();
	         searchText.sendKeys('76');
	         expectFriendNames(['John', 'Julie'], 'friend');
	       });
	
	       it('should search in specific fields when filtering with a predicate object', function() {
	         var searchAny = element(by.model('search.$'));
	         searchAny.clear();
	         searchAny.sendKeys('i');
	         expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
	       });
	       it('should use a equal comparison when comparator is true', function() {
	         var searchName = element(by.model('search.name'));
	         var strict = element(by.model('strict'));
	         searchName.clear();
	         searchName.sendKeys('Julie');
	         strict.click();
	         expectFriendNames(['Julie'], 'friendObj');
	       });
	     </file>
	   </example>
	 */
	
	function filterFilter() {
	  return function(array, expression, comparator, anyPropertyKey) {
	    if (!isArrayLike(array)) {
	      if (array == null) {
	        return array;
	      } else {
	        throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
	      }
	    }
	
	    anyPropertyKey = anyPropertyKey || '$';
	    var expressionType = getTypeForFilter(expression);
	    var predicateFn;
	    var matchAgainstAnyProp;
	
	    switch (expressionType) {
	      case 'function':
	        predicateFn = expression;
	        break;
	      case 'boolean':
	      case 'null':
	      case 'number':
	      case 'string':
	        matchAgainstAnyProp = true;
	        // falls through
	      case 'object':
	        predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	        break;
	      default:
	        return array;
	    }
	
	    return Array.prototype.filter.call(array, predicateFn);
	  };
	}
	
	// Helper functions for `filterFilter`
	function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
	  var shouldMatchPrimitives = isObject(expression) && (anyPropertyKey in expression);
	  var predicateFn;
	
	  if (comparator === true) {
	    comparator = equals;
	  } else if (!isFunction(comparator)) {
	    comparator = function(actual, expected) {
	      if (isUndefined(actual)) {
	        // No substring matching against `undefined`
	        return false;
	      }
	      if ((actual === null) || (expected === null)) {
	        // No substring matching against `null`; only match against `null`
	        return actual === expected;
	      }
	      if (isObject(expected) || (isObject(actual) && !hasCustomToString(actual))) {
	        // Should not compare primitives against objects, unless they have custom `toString` method
	        return false;
	      }
	
	      actual = lowercase('' + actual);
	      expected = lowercase('' + expected);
	      return actual.indexOf(expected) !== -1;
	    };
	  }
	
	  predicateFn = function(item) {
	    if (shouldMatchPrimitives && !isObject(item)) {
	      return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
	    }
	    return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
	  };
	
	  return predicateFn;
	}
	
	function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
	  var actualType = getTypeForFilter(actual);
	  var expectedType = getTypeForFilter(expected);
	
	  if ((expectedType === 'string') && (expected.charAt(0) === '!')) {
	    return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
	  } else if (isArray(actual)) {
	    // In case `actual` is an array, consider it a match
	    // if ANY of it's items matches `expected`
	    return actual.some(function(item) {
	      return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
	    });
	  }
	
	  switch (actualType) {
	    case 'object':
	      var key;
	      if (matchAgainstAnyProp) {
	        for (key in actual) {
	          // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
	          // See: https://github.com/angular/angular.js/issues/15644
	          if (key.charAt && (key.charAt(0) !== '$') &&
	              deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
	            return true;
	          }
	        }
	        return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
	      } else if (expectedType === 'object') {
	        for (key in expected) {
	          var expectedVal = expected[key];
	          if (isFunction(expectedVal) || isUndefined(expectedVal)) {
	            continue;
	          }
	
	          var matchAnyProperty = key === anyPropertyKey;
	          var actualVal = matchAnyProperty ? actual : actual[key];
	          if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
	            return false;
	          }
	        }
	        return true;
	      } else {
	        return comparator(actual, expected);
	      }
	    case 'function':
	      return false;
	    default:
	      return comparator(actual, expected);
	  }
	}
	
	// Used for easily differentiating between `null` and actual `object`
	function getTypeForFilter(val) {
	  return (val === null) ? 'null' : typeof val;
	}
	
	var MAX_DIGITS = 22;
	var DECIMAL_SEP = '.';
	var ZERO_CHAR = '0';
	
	/**
	 * @ngdoc filter
	 * @name currency
	 * @kind function
	 *
	 * @description
	 * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
	 * symbol for current locale is used.
	 *
	 * @param {number} amount Input to filter.
	 * @param {string=} symbol Currency symbol or identifier to be displayed.
	 * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
	 * @returns {string} Formatted number.
	 *
	 *
	 * @example
	   <example module="currencyExample" name="currency-filter">
	     <file name="index.html">
	       <script>
	         angular.module('currencyExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.amount = 1234.56;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <input type="number" ng-model="amount" aria-label="amount"> <br>
	         default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
	         custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
	         no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should init with 1234.56', function() {
	         expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
	         expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
	       });
	       it('should update', function() {
	         if (browser.params.browser === 'safari') {
	           // Safari does not understand the minus key. See
	           // https://github.com/angular/protractor/issues/481
	           return;
	         }
	         element(by.model('amount')).clear();
	         element(by.model('amount')).sendKeys('-1234');
	         expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
	         expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
	         expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
	       });
	     </file>
	   </example>
	 */
	currencyFilter.$inject = ['$locale'];
	function currencyFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(amount, currencySymbol, fractionSize) {
	    if (isUndefined(currencySymbol)) {
	      currencySymbol = formats.CURRENCY_SYM;
	    }
	
	    if (isUndefined(fractionSize)) {
	      fractionSize = formats.PATTERNS[1].maxFrac;
	    }
	
	    // if null or undefined pass it through
	    return (amount == null)
	        ? amount
	        : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).
	            replace(/\u00A4/g, currencySymbol);
	  };
	}
	
	/**
	 * @ngdoc filter
	 * @name number
	 * @kind function
	 *
	 * @description
	 * Formats a number as text.
	 *
	 * If the input is null or undefined, it will just be returned.
	 * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
	 * If the input is not a number an empty string is returned.
	 *
	 *
	 * @param {number|string} number Number to format.
	 * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
	 * If this is not provided then the fraction size is computed from the current locale's number
	 * formatting pattern. In the case of the default locale, it will be 3.
	 * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
	 *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
	 *                   include "," group separators after each third digit).
	 *
	 * @example
	   <example module="numberFilterExample" name="number-filter">
	     <file name="index.html">
	       <script>
	         angular.module('numberFilterExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.val = 1234.56789;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter number: <input ng-model='val'></label><br>
	         Default formatting: <span id='number-default'>{{val | number}}</span><br>
	         No fractions: <span>{{val | number:0}}</span><br>
	         Negative number: <span>{{-val | number:4}}</span>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format numbers', function() {
	         expect(element(by.id('number-default')).getText()).toBe('1,234.568');
	         expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
	       });
	
	       it('should update', function() {
	         element(by.model('val')).clear();
	         element(by.model('val')).sendKeys('3374.333');
	         expect(element(by.id('number-default')).getText()).toBe('3,374.333');
	         expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
	         expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
	      });
	     </file>
	   </example>
	 */
	numberFilter.$inject = ['$locale'];
	function numberFilter($locale) {
	  var formats = $locale.NUMBER_FORMATS;
	  return function(number, fractionSize) {
	
	    // if null or undefined pass it through
	    return (number == null)
	        ? number
	        : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP,
	                       fractionSize);
	  };
	}
	
	/**
	 * Parse a number (as a string) into three components that can be used
	 * for formatting the number.
	 *
	 * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
	 *
	 * @param  {string} numStr The number to parse
	 * @return {object} An object describing this number, containing the following keys:
	 *  - d : an array of digits containing leading zeros as necessary
	 *  - i : the number of the digits in `d` that are to the left of the decimal point
	 *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
	 *
	 */
	function parse(numStr) {
	  var exponent = 0, digits, numberOfIntegerDigits;
	  var i, j, zeros;
	
	  // Decimal point?
	  if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
	    numStr = numStr.replace(DECIMAL_SEP, '');
	  }
	
	  // Exponential form?
	  if ((i = numStr.search(/e/i)) > 0) {
	    // Work out the exponent.
	    if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
	    numberOfIntegerDigits += +numStr.slice(i + 1);
	    numStr = numStr.substring(0, i);
	  } else if (numberOfIntegerDigits < 0) {
	    // There was no decimal point or exponent so it is an integer.
	    numberOfIntegerDigits = numStr.length;
	  }
	
	  // Count the number of leading zeros.
	  for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) { /* empty */ }
	
	  if (i === (zeros = numStr.length)) {
	    // The digits are all zero.
	    digits = [0];
	    numberOfIntegerDigits = 1;
	  } else {
	    // Count the number of trailing zeros
	    zeros--;
	    while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;
	
	    // Trailing zeros are insignificant so ignore them
	    numberOfIntegerDigits -= i;
	    digits = [];
	    // Convert string to array of digits without leading/trailing zeros.
	    for (j = 0; i <= zeros; i++, j++) {
	      digits[j] = +numStr.charAt(i);
	    }
	  }
	
	  // If the number overflows the maximum allowed digits then use an exponent.
	  if (numberOfIntegerDigits > MAX_DIGITS) {
	    digits = digits.splice(0, MAX_DIGITS - 1);
	    exponent = numberOfIntegerDigits - 1;
	    numberOfIntegerDigits = 1;
	  }
	
	  return { d: digits, e: exponent, i: numberOfIntegerDigits };
	}
	
	/**
	 * Round the parsed number to the specified number of decimal places
	 * This function changed the parsedNumber in-place
	 */
	function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
	    var digits = parsedNumber.d;
	    var fractionLen = digits.length - parsedNumber.i;
	
	    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
	    fractionSize = (isUndefined(fractionSize)) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;
	
	    // The index of the digit to where rounding is to occur
	    var roundAt = fractionSize + parsedNumber.i;
	    var digit = digits[roundAt];
	
	    if (roundAt > 0) {
	      // Drop fractional digits beyond `roundAt`
	      digits.splice(Math.max(parsedNumber.i, roundAt));
	
	      // Set non-fractional digits beyond `roundAt` to 0
	      for (var j = roundAt; j < digits.length; j++) {
	        digits[j] = 0;
	      }
	    } else {
	      // We rounded to zero so reset the parsedNumber
	      fractionLen = Math.max(0, fractionLen);
	      parsedNumber.i = 1;
	      digits.length = Math.max(1, roundAt = fractionSize + 1);
	      digits[0] = 0;
	      for (var i = 1; i < roundAt; i++) digits[i] = 0;
	    }
	
	    if (digit >= 5) {
	      if (roundAt - 1 < 0) {
	        for (var k = 0; k > roundAt; k--) {
	          digits.unshift(0);
	          parsedNumber.i++;
	        }
	        digits.unshift(1);
	        parsedNumber.i++;
	      } else {
	        digits[roundAt - 1]++;
	      }
	    }
	
	    // Pad out with zeros to get the required fraction length
	    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);
	
	
	    // Do any carrying, e.g. a digit was rounded up to 10
	    var carry = digits.reduceRight(function(carry, d, i, digits) {
	      d = d + carry;
	      digits[i] = d % 10;
	      return Math.floor(d / 10);
	    }, 0);
	    if (carry) {
	      digits.unshift(carry);
	      parsedNumber.i++;
	    }
	}
	
	/**
	 * Format a number into a string
	 * @param  {number} number       The number to format
	 * @param  {{
	 *           minFrac, // the minimum number of digits required in the fraction part of the number
	 *           maxFrac, // the maximum number of digits required in the fraction part of the number
	 *           gSize,   // number of digits in each group of separated digits
	 *           lgSize,  // number of digits in the last group of digits before the decimal separator
	 *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
	 *           posPre,  // the string to go in front of a positive number
	 *           negSuf,  // the string to go after a negative number (e.g. `)`)
	 *           posSuf   // the string to go after a positive number
	 *         }} pattern
	 * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
	 * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
	 * @param  {[type]} fractionSize The size of the fractional part of the number
	 * @return {string}              The number formatted as a string
	 */
	function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
	
	  if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
	
	  var isInfinity = !isFinite(number);
	  var isZero = false;
	  var numStr = Math.abs(number) + '',
	      formattedText = '',
	      parsedNumber;
	
	  if (isInfinity) {
	    formattedText = '\u221e';
	  } else {
	    parsedNumber = parse(numStr);
	
	    roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
	
	    var digits = parsedNumber.d;
	    var integerLen = parsedNumber.i;
	    var exponent = parsedNumber.e;
	    var decimals = [];
	    isZero = digits.reduce(function(isZero, d) { return isZero && !d; }, true);
	
	    // pad zeros for small numbers
	    while (integerLen < 0) {
	      digits.unshift(0);
	      integerLen++;
	    }
	
	    // extract decimals digits
	    if (integerLen > 0) {
	      decimals = digits.splice(integerLen, digits.length);
	    } else {
	      decimals = digits;
	      digits = [0];
	    }
	
	    // format the integer digits with grouping separators
	    var groups = [];
	    if (digits.length >= pattern.lgSize) {
	      groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
	    }
	    while (digits.length > pattern.gSize) {
	      groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
	    }
	    if (digits.length) {
	      groups.unshift(digits.join(''));
	    }
	    formattedText = groups.join(groupSep);
	
	    // append the decimal digits
	    if (decimals.length) {
	      formattedText += decimalSep + decimals.join('');
	    }
	
	    if (exponent) {
	      formattedText += 'e+' + exponent;
	    }
	  }
	  if (number < 0 && !isZero) {
	    return pattern.negPre + formattedText + pattern.negSuf;
	  } else {
	    return pattern.posPre + formattedText + pattern.posSuf;
	  }
	}
	
	function padNumber(num, digits, trim, negWrap) {
	  var neg = '';
	  if (num < 0 || (negWrap && num <= 0)) {
	    if (negWrap) {
	      num = -num + 1;
	    } else {
	      num = -num;
	      neg = '-';
	    }
	  }
	  num = '' + num;
	  while (num.length < digits) num = ZERO_CHAR + num;
	  if (trim) {
	    num = num.substr(num.length - digits);
	  }
	  return neg + num;
	}
	
	
	function dateGetter(name, size, offset, trim, negWrap) {
	  offset = offset || 0;
	  return function(date) {
	    var value = date['get' + name]();
	    if (offset > 0 || value > -offset) {
	      value += offset;
	    }
	    if (value === 0 && offset === -12) value = 12;
	    return padNumber(value, size, trim, negWrap);
	  };
	}
	
	function dateStrGetter(name, shortForm, standAlone) {
	  return function(date, formats) {
	    var value = date['get' + name]();
	    var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
	    var get = uppercase(propPrefix + name);
	
	    return formats[get][value];
	  };
	}
	
	function timeZoneGetter(date, formats, offset) {
	  var zone = -1 * offset;
	  var paddedZone = (zone >= 0) ? '+' : '';
	
	  paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) +
	                padNumber(Math.abs(zone % 60), 2);
	
	  return paddedZone;
	}
	
	function getFirstThursdayOfYear(year) {
	    // 0 = index of January
	    var dayOfWeekOnFirst = (new Date(year, 0, 1)).getDay();
	    // 4 = index of Thursday (+1 to account for 1st = 5)
	    // 11 = index of *next* Thursday (+1 account for 1st = 12)
	    return new Date(year, 0, ((dayOfWeekOnFirst <= 4) ? 5 : 12) - dayOfWeekOnFirst);
	}
	
	function getThursdayThisWeek(datetime) {
	    return new Date(datetime.getFullYear(), datetime.getMonth(),
	      // 4 = index of Thursday
	      datetime.getDate() + (4 - datetime.getDay()));
	}
	
	function weekGetter(size) {
	   return function(date) {
	      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
	         thisThurs = getThursdayThisWeek(date);
	
	      var diff = +thisThurs - +firstThurs,
	         result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week
	
	      return padNumber(result, size);
	   };
	}
	
	function ampmGetter(date, formats) {
	  return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
	}
	
	function eraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
	}
	
	function longEraGetter(date, formats) {
	  return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
	}
	
	var DATE_FORMATS = {
	  yyyy: dateGetter('FullYear', 4, 0, false, true),
	    yy: dateGetter('FullYear', 2, 0, true, true),
	     y: dateGetter('FullYear', 1, 0, false, true),
	  MMMM: dateStrGetter('Month'),
	   MMM: dateStrGetter('Month', true),
	    MM: dateGetter('Month', 2, 1),
	     M: dateGetter('Month', 1, 1),
	  LLLL: dateStrGetter('Month', false, true),
	    dd: dateGetter('Date', 2),
	     d: dateGetter('Date', 1),
	    HH: dateGetter('Hours', 2),
	     H: dateGetter('Hours', 1),
	    hh: dateGetter('Hours', 2, -12),
	     h: dateGetter('Hours', 1, -12),
	    mm: dateGetter('Minutes', 2),
	     m: dateGetter('Minutes', 1),
	    ss: dateGetter('Seconds', 2),
	     s: dateGetter('Seconds', 1),
	     // while ISO 8601 requires fractions to be prefixed with `.` or `,`
	     // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
	   sss: dateGetter('Milliseconds', 3),
	  EEEE: dateStrGetter('Day'),
	   EEE: dateStrGetter('Day', true),
	     a: ampmGetter,
	     Z: timeZoneGetter,
	    ww: weekGetter(2),
	     w: weekGetter(1),
	     G: eraGetter,
	     GG: eraGetter,
	     GGG: eraGetter,
	     GGGG: longEraGetter
	};
	
	var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
	    NUMBER_STRING = /^-?\d+$/;
	
	/**
	 * @ngdoc filter
	 * @name date
	 * @kind function
	 *
	 * @description
	 *   Formats `date` to a string based on the requested `format`.
	 *
	 *   `format` string can be composed of the following elements:
	 *
	 *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
	 *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
	 *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
	 *   * `'MMMM'`: Month in year (January-December)
	 *   * `'MMM'`: Month in year (Jan-Dec)
	 *   * `'MM'`: Month in year, padded (01-12)
	 *   * `'M'`: Month in year (1-12)
	 *   * `'LLLL'`: Stand-alone month in year (January-December)
	 *   * `'dd'`: Day in month, padded (01-31)
	 *   * `'d'`: Day in month (1-31)
	 *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
	 *   * `'EEE'`: Day in Week, (Sun-Sat)
	 *   * `'HH'`: Hour in day, padded (00-23)
	 *   * `'H'`: Hour in day (0-23)
	 *   * `'hh'`: Hour in AM/PM, padded (01-12)
	 *   * `'h'`: Hour in AM/PM, (1-12)
	 *   * `'mm'`: Minute in hour, padded (00-59)
	 *   * `'m'`: Minute in hour (0-59)
	 *   * `'ss'`: Second in minute, padded (00-59)
	 *   * `'s'`: Second in minute (0-59)
	 *   * `'sss'`: Millisecond in second, padded (000-999)
	 *   * `'a'`: AM/PM marker
	 *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
	 *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
	 *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
	 *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
	 *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
	 *
	 *   `format` string can also be one of the following predefined
	 *   {@link guide/i18n localizable formats}:
	 *
	 *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
	 *     (e.g. Sep 3, 2010 12:05:08 PM)
	 *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
	 *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
	 *     (e.g. Friday, September 3, 2010)
	 *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
	 *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
	 *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
	 *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
	 *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
	 *
	 *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
	 *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
	 *   (e.g. `"h 'o''clock'"`).
	 *
	 *   Any other characters in the `format` string will be output as-is.
	 *
	 * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
	 *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
	 *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
	 *    specified in the string input, the time is considered to be in the local timezone.
	 * @param {string=} format Formatting rules (see Description). If not specified,
	 *    `mediumDate` is used.
	 * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
	 *    continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *    If not specified, the timezone of the browser will be used.
	 * @returns {string} Formatted string or the input if input is not recognized as date/millis.
	 *
	 * @example
	   <example name="filter-date">
	     <file name="index.html">
	       <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
	           <span>{{1288323623006 | date:'medium'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
	          <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
	          <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
	       <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
	          <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should format date', function() {
	         expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
	            toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
	         expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
	            toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
	         expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
	            toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
	         expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
	            toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
	       });
	     </file>
	   </example>
	 */
	dateFilter.$inject = ['$locale'];
	function dateFilter($locale) {
	
	
	  var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
	                     // 1        2       3         4          5          6          7          8  9     10      11
	  function jsonStringToDate(string) {
	    var match;
	    if ((match = string.match(R_ISO8601_STR))) {
	      var date = new Date(0),
	          tzHour = 0,
	          tzMin  = 0,
	          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
	          timeSetter = match[8] ? date.setUTCHours : date.setHours;
	
	      if (match[9]) {
	        tzHour = toInt(match[9] + match[10]);
	        tzMin = toInt(match[9] + match[11]);
	      }
	      dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
	      var h = toInt(match[4] || 0) - tzHour;
	      var m = toInt(match[5] || 0) - tzMin;
	      var s = toInt(match[6] || 0);
	      var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
	      timeSetter.call(date, h, m, s, ms);
	      return date;
	    }
	    return string;
	  }
	
	
	  return function(date, format, timezone) {
	    var text = '',
	        parts = [],
	        fn, match;
	
	    format = format || 'mediumDate';
	    format = $locale.DATETIME_FORMATS[format] || format;
	    if (isString(date)) {
	      date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
	    }
	
	    if (isNumber(date)) {
	      date = new Date(date);
	    }
	
	    if (!isDate(date) || !isFinite(date.getTime())) {
	      return date;
	    }
	
	    while (format) {
	      match = DATE_FORMATS_SPLIT.exec(format);
	      if (match) {
	        parts = concat(parts, match, 1);
	        format = parts.pop();
	      } else {
	        parts.push(format);
	        format = null;
	      }
	    }
	
	    var dateTimezoneOffset = date.getTimezoneOffset();
	    if (timezone) {
	      dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
	      date = convertTimezoneToLocal(date, timezone, true);
	    }
	    forEach(parts, function(value) {
	      fn = DATE_FORMATS[value];
	      text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset)
	                 : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
	    });
	
	    return text;
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name json
	 * @kind function
	 *
	 * @description
	 *   Allows you to convert a JavaScript object into JSON string.
	 *
	 *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
	 *   the binding is automatically converted to JSON.
	 *
	 * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
	 * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
	 * @returns {string} JSON string.
	 *
	 *
	 * @example
	   <example name="filter-json">
	     <file name="index.html">
	       <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
	       <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should jsonify filtered objects', function() {
	         expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
	         expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
	       });
	     </file>
	   </example>
	 *
	 */
	function jsonFilter() {
	  return function(object, spacing) {
	    if (isUndefined(spacing)) {
	        spacing = 2;
	    }
	    return toJson(object, spacing);
	  };
	}
	
	
	/**
	 * @ngdoc filter
	 * @name lowercase
	 * @kind function
	 * @description
	 * Converts string to lowercase.
	 * @see angular.lowercase
	 */
	var lowercaseFilter = valueFn(lowercase);
	
	
	/**
	 * @ngdoc filter
	 * @name uppercase
	 * @kind function
	 * @description
	 * Converts string to uppercase.
	 * @see angular.uppercase
	 */
	var uppercaseFilter = valueFn(uppercase);
	
	/**
	 * @ngdoc filter
	 * @name limitTo
	 * @kind function
	 *
	 * @description
	 * Creates a new array or string containing only a specified number of elements. The elements are
	 * taken from either the beginning or the end of the source array, string or number, as specified by
	 * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
	 * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
	 * it is converted to a string.
	 *
	 * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
	 * @param {string|number} limit - The length of the returned array or string. If the `limit` number
	 *     is positive, `limit` number of items from the beginning of the source array/string are copied.
	 *     If the number is negative, `limit` number  of items from the end of the source array/string
	 *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
	 *     the input will be returned unchanged.
	 * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
	 *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
	 * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
	 *     less than `limit` elements.
	 *
	 * @example
	   <example module="limitToExample" name="limit-to-filter">
	     <file name="index.html">
	       <script>
	         angular.module('limitToExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.numbers = [1,2,3,4,5,6,7,8,9];
	             $scope.letters = "abcdefghi";
	             $scope.longNumber = 2345432342;
	             $scope.numLimit = 3;
	             $scope.letterLimit = 3;
	             $scope.longNumberLimit = 3;
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>
	            Limit {{numbers}} to:
	            <input type="number" step="1" ng-model="numLimit">
	         </label>
	         <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
	         <label>
	            Limit {{letters}} to:
	            <input type="number" step="1" ng-model="letterLimit">
	         </label>
	         <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
	         <label>
	            Limit {{longNumber}} to:
	            <input type="number" step="1" ng-model="longNumberLimit">
	         </label>
	         <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       var numLimitInput = element(by.model('numLimit'));
	       var letterLimitInput = element(by.model('letterLimit'));
	       var longNumberLimitInput = element(by.model('longNumberLimit'));
	       var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
	       var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
	       var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
	
	       it('should limit the number array to first three items', function() {
	         expect(numLimitInput.getAttribute('value')).toBe('3');
	         expect(letterLimitInput.getAttribute('value')).toBe('3');
	         expect(longNumberLimitInput.getAttribute('value')).toBe('3');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abc');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
	       });
	
	       // There is a bug in safari and protractor that doesn't like the minus key
	       // it('should update the output when -3 is entered', function() {
	       //   numLimitInput.clear();
	       //   numLimitInput.sendKeys('-3');
	       //   letterLimitInput.clear();
	       //   letterLimitInput.sendKeys('-3');
	       //   longNumberLimitInput.clear();
	       //   longNumberLimitInput.sendKeys('-3');
	       //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
	       //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
	       //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
	       // });
	
	       it('should not exceed the maximum size of input array', function() {
	         numLimitInput.clear();
	         numLimitInput.sendKeys('100');
	         letterLimitInput.clear();
	         letterLimitInput.sendKeys('100');
	         longNumberLimitInput.clear();
	         longNumberLimitInput.sendKeys('100');
	         expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
	         expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
	         expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
	       });
	     </file>
	   </example>
	*/
	function limitToFilter() {
	  return function(input, limit, begin) {
	    if (Math.abs(Number(limit)) === Infinity) {
	      limit = Number(limit);
	    } else {
	      limit = toInt(limit);
	    }
	    if (isNumberNaN(limit)) return input;
	
	    if (isNumber(input)) input = input.toString();
	    if (!isArrayLike(input)) return input;
	
	    begin = (!begin || isNaN(begin)) ? 0 : toInt(begin);
	    begin = (begin < 0) ? Math.max(0, input.length + begin) : begin;
	
	    if (limit >= 0) {
	      return sliceFn(input, begin, begin + limit);
	    } else {
	      if (begin === 0) {
	        return sliceFn(input, limit, input.length);
	      } else {
	        return sliceFn(input, Math.max(0, begin + limit), begin);
	      }
	    }
	  };
	}
	
	function sliceFn(input, begin, end) {
	  if (isString(input)) return input.slice(begin, end);
	
	  return slice.call(input, begin, end);
	}
	
	/**
	 * @ngdoc filter
	 * @name orderBy
	 * @kind function
	 *
	 * @description
	 * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
	 * function based on the values computed using the `expression` predicate.
	 *
	 * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
	 * `[{id: 'bar'}, {id: 'foo'}]`.
	 *
	 * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
	 * String, etc).
	 *
	 * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
	 * for the preceding one. The `expression` is evaluated against each item and the output is used
	 * for comparing with other items.
	 *
	 * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
	 * ascending order.
	 *
	 * The comparison is done using the `comparator` function. If none is specified, a default, built-in
	 * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
	 * strings alphabetically).
	 *
	 * ### Under the hood
	 *
	 * Ordering the specified `collection` happens in two phases:
	 *
	 * 1. All items are passed through the predicate (or predicates), and the returned values are saved
	 *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
	 *    through a predicate that extracts the value of the `label` property, would be transformed to:
	 *    ```
	 *    {
	 *      value: 'foo',
	 *      type: 'string',
	 *      index: ...
	 *    }
	 *    ```
	 * 2. The comparator function is used to sort the items, based on the derived values, types and
	 *    indices.
	 *
	 * If you use a custom comparator, it will be called with pairs of objects of the form
	 * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
	 * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
	 * second, or `1` otherwise.
	 *
	 * In order to ensure that the sorting will be deterministic across platforms, if none of the
	 * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
	 * dummy predicate that returns the item's index as `value`.
	 * (If you are using a custom comparator, make sure it can handle this predicate as well.)
	 *
	 * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
	 * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
	 * it to the comparator. The following rules govern the conversion:
	 *
	 * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
	 *    used instead.<br />
	 *    (If the object has a `valueOf()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
	 *    returns a primitive, its return value will be used instead.<br />
	 *    (If the object has a `toString()` method that returns another object, then the returned object
	 *    will be used in subsequent steps.)
	 * 3. No conversion; the object itself is used.
	 *
	 * ### The default comparator
	 *
	 * The default, built-in comparator should be sufficient for most usecases. In short, it compares
	 * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
	 * using their index in the original collection, and sorts values of different types by type.
	 *
	 * More specifically, it follows these steps to determine the relative order of items:
	 *
	 * 1. If the compared values are of different types, compare the types themselves alphabetically.
	 * 2. If both values are of type `string`, compare them alphabetically in a case- and
	 *    locale-insensitive way.
	 * 3. If both values are objects, compare their indices instead.
	 * 4. Otherwise, return:
	 *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
	 *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
	 *    -  `1`, otherwise.
	 *
	 * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
	 *           saved as numbers and not strings.
	 * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
	 *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
	 *           other values.
	 *
	 * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
	 * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
	 *    predicates) to be used by the comparator to determine the order of elements.
	 *
	 *    Can be one of:
	 *
	 *    - `Function`: A getter function. This function will be called with each item as argument and
	 *      the return value will be used for sorting.
	 *    - `string`: An Angular expression. This expression will be evaluated against each item and the
	 *      result will be used for sorting. For example, use `'label'` to sort by a property called
	 *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
	 *      property.<br />
	 *      (The result of a constant expression is interpreted as a property name to be used for
	 *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
	 *      property called `special name`.)<br />
	 *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
	 *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
	 *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
	 *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
	 *      relative order of two items, the next predicate is used as a tie-breaker.
	 *
	 * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
	 *
	 * @param {boolean=} reverse - If `true`, reverse the sorting order.
	 * @param {(Function)=} comparator - The comparator function used to determine the relative order of
	 *    value pairs. If omitted, the built-in comparator will be used.
	 *
	 * @returns {Array} - The sorted array.
	 *
	 *
	 * @example
	 * ### Ordering a table with `ngRepeat`
	 *
	 * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
	 * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
	 * it defaults to the built-in comparator.
	 *
	   <example name="orderBy-static" module="orderByExample1">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <table class="friends">
	           <tr>
	             <th>Name</th>
	             <th>Phone Number</th>
	             <th>Age</th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:'-age'">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample1', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var names = element.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by age in reverse order', function() {
	         expect(names.get(0).getText()).toBe('Adam');
	         expect(names.get(1).getText()).toBe('Julie');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('John');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Changing parameters dynamically
	 *
	 * All parameters can be changed dynamically. The next example shows how you can make the columns of
	 * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
	 *
	   <example name="orderBy-dynamic" module="orderByExample2">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample2', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = friends;
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using `orderBy` inside a controller
	 *
	 * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
	 * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
	 * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
	 *
	   <example name="orderBy-call-manually" module="orderByExample3">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
	         <hr/>
	         <button ng-click="sortBy(null)">Set to unsorted</button>
	         <hr/>
	         <table class="friends">
	           <tr>
	             <th>
	               <button ng-click="sortBy('name')">Name</button>
	               <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('phone')">Phone Number</button>
	               <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
	             </th>
	             <th>
	               <button ng-click="sortBy('age')">Age</button>
	               <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
	             </th>
	           </tr>
	           <tr ng-repeat="friend in friends">
	             <td>{{friend.name}}</td>
	             <td>{{friend.phone}}</td>
	             <td>{{friend.age}}</td>
	           </tr>
	         </table>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample3', [])
	         .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
	           var friends = [
	             {name: 'John',   phone: '555-1212',  age: 10},
	             {name: 'Mary',   phone: '555-9876',  age: 19},
	             {name: 'Mike',   phone: '555-4321',  age: 21},
	             {name: 'Adam',   phone: '555-5678',  age: 35},
	             {name: 'Julie',  phone: '555-8765',  age: 29}
	           ];
	
	           $scope.propertyName = 'age';
	           $scope.reverse = true;
	           $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	
	           $scope.sortBy = function(propertyName) {
	             $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
	                 ? !$scope.reverse : false;
	             $scope.propertyName = propertyName;
	             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	
	       .sortorder:after {
	         content: '\25b2';   // BLACK UP-POINTING TRIANGLE
	       }
	       .sortorder.reverse:after {
	         content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var unsortButton = element(by.partialButtonText('unsorted'));
	       var nameHeader = element(by.partialButtonText('Name'));
	       var phoneHeader = element(by.partialButtonText('Phone'));
	       var ageHeader = element(by.partialButtonText('Age'));
	       var firstName = element(by.repeater('friends').column('friend.name').row(0));
	       var lastName = element(by.repeater('friends').column('friend.name').row(4));
	
	       it('should sort friends by some property, when clicking on the column header', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         phoneHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Mary');
	
	         nameHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('Mike');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	       });
	
	       it('should sort friends in reverse order, when clicking on the same column', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Adam');
	
	         ageHeader.click();
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	       });
	
	       it('should restore the original order, when clicking "Set to unsorted"', function() {
	         expect(firstName.getText()).toBe('Adam');
	         expect(lastName.getText()).toBe('John');
	
	         unsortButton.click();
	         expect(firstName.getText()).toBe('John');
	         expect(lastName.getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 * <hr />
	 *
	 * @example
	 * ### Using a custom comparator
	 *
	 * If you have very specific requirements about the way items are sorted, you can pass your own
	 * comparator function. For example, you might need to compare some strings in a locale-sensitive
	 * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
	 * argument - passing `false` retains the default sorting order, i.e. ascending.)
	 *
	   <example name="orderBy-custom-comparator" module="orderByExample4">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <div class="friends-container custom-comparator">
	           <h3>Locale-sensitive Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	         <div class="friends-container default-comparator">
	           <h3>Default Comparator</h3>
	           <table class="friends">
	             <tr>
	               <th>Name</th>
	               <th>Favorite Letter</th>
	             </tr>
	             <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
	               <td>{{friend.name}}</td>
	               <td>{{friend.favoriteLetter}}</td>
	             </tr>
	           </table>
	         </div>
	       </div>
	     </file>
	     <file name="script.js">
	       angular.module('orderByExample4', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.friends = [
	             {name: 'John',   favoriteLetter: 'Ä'},
	             {name: 'Mary',   favoriteLetter: 'Ü'},
	             {name: 'Mike',   favoriteLetter: 'Ö'},
	             {name: 'Adam',   favoriteLetter: 'H'},
	             {name: 'Julie',  favoriteLetter: 'Z'}
	           ];
	
	           $scope.localeSensitiveComparator = function(v1, v2) {
	             // If we don't get strings, just compare by index
	             if (v1.type !== 'string' || v2.type !== 'string') {
	               return (v1.index < v2.index) ? -1 : 1;
	             }
	
	             // Compare strings alphabetically, taking locale into account
	             return v1.value.localeCompare(v2.value);
	           };
	         }]);
	     </file>
	     <file name="style.css">
	       .friends-container {
	         display: inline-block;
	         margin: 0 30px;
	       }
	
	       .friends {
	         border-collapse: collapse;
	       }
	
	       .friends th {
	         border-bottom: 1px solid;
	       }
	       .friends td, .friends th {
	         border-left: 1px solid;
	         padding: 5px 10px;
	       }
	       .friends td:first-child, .friends th:first-child {
	         border-left: none;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       // Element locators
	       var container = element(by.css('.custom-comparator'));
	       var names = container.all(by.repeater('friends').column('friend.name'));
	
	       it('should sort friends by favorite letter (in correct alphabetical order)', function() {
	         expect(names.get(0).getText()).toBe('John');
	         expect(names.get(1).getText()).toBe('Adam');
	         expect(names.get(2).getText()).toBe('Mike');
	         expect(names.get(3).getText()).toBe('Mary');
	         expect(names.get(4).getText()).toBe('Julie');
	       });
	     </file>
	   </example>
	 *
	 */
	orderByFilter.$inject = ['$parse'];
	function orderByFilter($parse) {
	  return function(array, sortPredicate, reverseOrder, compareFn) {
	
	    if (array == null) return array;
	    if (!isArrayLike(array)) {
	      throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
	    }
	
	    if (!isArray(sortPredicate)) { sortPredicate = [sortPredicate]; }
	    if (sortPredicate.length === 0) { sortPredicate = ['+']; }
	
	    var predicates = processPredicates(sortPredicate);
	
	    var descending = reverseOrder ? -1 : 1;
	
	    // Define the `compare()` function. Use a default comparator if none is specified.
	    var compare = isFunction(compareFn) ? compareFn : defaultCompare;
	
	    // The next three lines are a version of a Swartzian Transform idiom from Perl
	    // (sometimes called the Decorate-Sort-Undecorate idiom)
	    // See https://en.wikipedia.org/wiki/Schwartzian_transform
	    var compareValues = Array.prototype.map.call(array, getComparisonObject);
	    compareValues.sort(doComparison);
	    array = compareValues.map(function(item) { return item.value; });
	
	    return array;
	
	    function getComparisonObject(value, index) {
	      // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
	      // This will be used to keep the sort stable when none of the input predicates can
	      // distinguish between two elements.
	      return {
	        value: value,
	        tieBreaker: {value: index, type: 'number', index: index},
	        predicateValues: predicates.map(function(predicate) {
	          return getPredicateValue(predicate.get(value), index);
	        })
	      };
	    }
	
	    function doComparison(v1, v2) {
	      for (var i = 0, ii = predicates.length; i < ii; i++) {
	        var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
	        if (result) {
	          return result * predicates[i].descending * descending;
	        }
	      }
	
	      return compare(v1.tieBreaker, v2.tieBreaker) * descending;
	    }
	  };
	
	  function processPredicates(sortPredicates) {
	    return sortPredicates.map(function(predicate) {
	      var descending = 1, get = identity;
	
	      if (isFunction(predicate)) {
	        get = predicate;
	      } else if (isString(predicate)) {
	        if ((predicate.charAt(0) === '+' || predicate.charAt(0) === '-')) {
	          descending = predicate.charAt(0) === '-' ? -1 : 1;
	          predicate = predicate.substring(1);
	        }
	        if (predicate !== '') {
	          get = $parse(predicate);
	          if (get.constant) {
	            var key = get();
	            get = function(value) { return value[key]; };
	          }
	        }
	      }
	      return {get: get, descending: descending};
	    });
	  }
	
	  function isPrimitive(value) {
	    switch (typeof value) {
	      case 'number': /* falls through */
	      case 'boolean': /* falls through */
	      case 'string':
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function objectValue(value) {
	    // If `valueOf` is a valid function use that
	    if (isFunction(value.valueOf)) {
	      value = value.valueOf();
	      if (isPrimitive(value)) return value;
	    }
	    // If `toString` is a valid function and not the one from `Object.prototype` use that
	    if (hasCustomToString(value)) {
	      value = value.toString();
	      if (isPrimitive(value)) return value;
	    }
	
	    return value;
	  }
	
	  function getPredicateValue(value, index) {
	    var type = typeof value;
	    if (value === null) {
	      type = 'string';
	      value = 'null';
	    } else if (type === 'object') {
	      value = objectValue(value);
	    }
	    return {value: value, type: type, index: index};
	  }
	
	  function defaultCompare(v1, v2) {
	    var result = 0;
	    var type1 = v1.type;
	    var type2 = v2.type;
	
	    if (type1 === type2) {
	      var value1 = v1.value;
	      var value2 = v2.value;
	
	      if (type1 === 'string') {
	        // Compare strings case-insensitively
	        value1 = value1.toLowerCase();
	        value2 = value2.toLowerCase();
	      } else if (type1 === 'object') {
	        // For basic objects, use the position of the object
	        // in the collection instead of the value
	        if (isObject(value1)) value1 = v1.index;
	        if (isObject(value2)) value2 = v2.index;
	      }
	
	      if (value1 !== value2) {
	        result = value1 < value2 ? -1 : 1;
	      }
	    } else {
	      result = type1 < type2 ? -1 : 1;
	    }
	
	    return result;
	  }
	}
	
	function ngDirective(directive) {
	  if (isFunction(directive)) {
	    directive = {
	      link: directive
	    };
	  }
	  directive.restrict = directive.restrict || 'AC';
	  return valueFn(directive);
	}
	
	/**
	 * @ngdoc directive
	 * @name a
	 * @restrict E
	 *
	 * @description
	 * Modifies the default behavior of the html a tag so that the default action is prevented when
	 * the href attribute is empty.
	 *
	 * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
	 */
	var htmlAnchorDirective = valueFn({
	  restrict: 'E',
	  compile: function(element, attr) {
	    if (!attr.href && !attr.xlinkHref) {
	      return function(scope, element) {
	        // If the linked element is not an anchor tag anymore, do nothing
	        if (element[0].nodeName.toLowerCase() !== 'a') return;
	
	        // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	        var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ?
	                   'xlink:href' : 'href';
	        element.on('click', function(event) {
	          // if we have no href url, then don't navigate anywhere.
	          if (!element.attr(href)) {
	            event.preventDefault();
	          }
	        });
	      };
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngHref
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in an href attribute will
	 * make the link go to the wrong URL if the user clicks it before
	 * Angular has a chance to replace the `{{hash}}` markup with its
	 * value. Until Angular replaces the markup the link will be broken
	 * and will most likely return a 404 error. The `ngHref` directive
	 * solves this problem.
	 *
	 * The wrong way to write it:
	 * ```html
	 * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
	 * ```
	 *
	 * @element A
	 * @param {template} ngHref any string which can contain `{{}}` markup.
	 *
	 * @example
	 * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
	 * in links and their different behaviors:
	    <example name="ng-href">
	      <file name="index.html">
	        <input ng-model="value" /><br />
	        <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
	        <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
	        <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
	        <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
	        <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
	        <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should execute ng-click but not reload when href without value', function() {
	          element(by.id('link-1')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('1');
	          expect(element(by.id('link-1')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when href empty string', function() {
	          element(by.id('link-2')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('2');
	          expect(element(by.id('link-2')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click and change url when ng-href specified', function() {
	          expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
	
	          element(by.id('link-3')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/123$/);
	            });
	          }, 5000, 'page should navigate to /123');
	        });
	
	        it('should execute ng-click but not reload when href empty string and name specified', function() {
	          element(by.id('link-4')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('4');
	          expect(element(by.id('link-4')).getAttribute('href')).toBe('');
	        });
	
	        it('should execute ng-click but not reload when no href but name specified', function() {
	          element(by.id('link-5')).click();
	          expect(element(by.model('value')).getAttribute('value')).toEqual('5');
	          expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
	        });
	
	        it('should only change url when only ng-href', function() {
	          element(by.model('value')).clear();
	          element(by.model('value')).sendKeys('6');
	          expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
	
	          element(by.id('link-6')).click();
	
	          // At this point, we navigate away from an Angular page, so we need
	          // to use browser.driver to get the base webdriver.
	          browser.wait(function() {
	            return browser.driver.getCurrentUrl().then(function(url) {
	              return url.match(/\/6$/);
	            });
	          }, 5000, 'page should navigate to /6');
	        });
	      </file>
	    </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrc
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `src` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrc` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrc any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngSrcset
	 * @restrict A
	 * @priority 99
	 *
	 * @description
	 * Using Angular markup like `{{hash}}` in a `srcset` attribute doesn't
	 * work right: The browser will fetch from the URL with the literal
	 * text `{{hash}}` until Angular replaces the expression inside
	 * `{{hash}}`. The `ngSrcset` directive solves this problem.
	 *
	 * The buggy way to write it:
	 * ```html
	 * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
	 * ```
	 *
	 * The correct way to write it:
	 * ```html
	 * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
	 * ```
	 *
	 * @element IMG
	 * @param {template} ngSrcset any string which can contain `{{}}` markup.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngDisabled
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * This directive sets the `disabled` attribute on the element (typically a form control,
	 * e.g. `input`, `button`, `select` etc.) if the
	 * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `disabled`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-disabled">
	      <file name="index.html">
	        <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
	        <button ng-model="button" ng-disabled="checked">Button</button>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle button', function() {
	          expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
	 *     then the `disabled` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngChecked
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
	 *
	 * Note that this directive should not be used together with {@link ngModel `ngModel`},
	 * as this can lead to unexpected behavior.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `checked`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-checked">
	      <file name="index.html">
	        <label>Check me to check both: <input type="checkbox" ng-model="master"></label><br/>
	        <input id="checkSlave" type="checkbox" ng-checked="master" aria-label="Slave input">
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should check both checkBoxes', function() {
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeFalsy();
	          element(by.model('master')).click();
	          expect(element(by.id('checkSlave')).getAttribute('checked')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
	 *     then the `checked` attribute will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngReadonly
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
	 * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
	 * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `readonly`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * @example
	    <example name="ng-readonly">
	      <file name="index.html">
	        <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
	        <input type="text" ng-readonly="checked" value="I'm Angular" aria-label="Readonly field" />
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should toggle readonly attr', function() {
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
	          element(by.model('checked')).click();
	          expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element INPUT
	 * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
	 *     then special attribute "readonly" will be set on the element
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSelected
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `selected`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * <div class="alert alert-warning">
	 *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
	 *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
	 *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
	 *   selected options.
	 * </div>
	 *
	 * @example
	    <example name="ng-selected">
	      <file name="index.html">
	        <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
	        <select aria-label="ngSelected demo">
	          <option>Hello!</option>
	          <option id="greet" ng-selected="selected">Greetings!</option>
	        </select>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should select Greetings!', function() {
	          expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
	          element(by.model('selected')).click();
	          expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
	        });
	      </file>
	    </example>
	 *
	 * @element OPTION
	 * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
	 *     then special attribute "selected" will be set on the element
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngOpen
	 * @restrict A
	 * @priority 100
	 *
	 * @description
	 *
	 * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
	 *
	 * A special directive is necessary because we cannot use interpolation inside the `open`
	 * attribute. See the {@link guide/interpolation interpolation guide} for more info.
	 *
	 * ## A note about browser compatibility
	 *
	 * Edge, Firefox, and Internet Explorer do not support the `details` element, it is
	 * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
	 *
	 * @example
	     <example name="ng-open">
	       <file name="index.html">
	         <label>Check me check multiple: <input type="checkbox" ng-model="open"></label><br/>
	         <details id="details" ng-open="open">
	            <summary>Show/Hide me</summary>
	         </details>
	       </file>
	       <file name="protractor.js" type="protractor">
	         it('should toggle open', function() {
	           expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
	           element(by.model('open')).click();
	           expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
	         });
	       </file>
	     </example>
	 *
	 * @element DETAILS
	 * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
	 *     then special attribute "open" will be set on the element
	 */
	
	var ngAttributeAliasDirectives = {};
	
	// boolean attrs are evaluated
	forEach(BOOLEAN_ATTR, function(propName, attrName) {
	  // binding to multiple is not supported
	  if (propName === 'multiple') return;
	
	  function defaultLinkFn(scope, element, attr) {
	    scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
	      attr.$set(attrName, !!value);
	    });
	  }
	
	  var normalized = directiveNormalize('ng-' + attrName);
	  var linkFn = defaultLinkFn;
	
	  if (propName === 'checked') {
	    linkFn = function(scope, element, attr) {
	      // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
	      if (attr.ngModel !== attr[normalized]) {
	        defaultLinkFn(scope, element, attr);
	      }
	    };
	  }
	
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      restrict: 'A',
	      priority: 100,
	      link: linkFn
	    };
	  };
	});
	
	// aliased input attrs are evaluated
	forEach(ALIASED_ATTR, function(htmlAttr, ngAttr) {
	  ngAttributeAliasDirectives[ngAttr] = function() {
	    return {
	      priority: 100,
	      link: function(scope, element, attr) {
	        //special case ngPattern when a literal regular expression value
	        //is used as the expression (this way we don't have to watch anything).
	        if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
	          var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
	          if (match) {
	            attr.$set('ngPattern', new RegExp(match[1], match[2]));
	            return;
	          }
	        }
	
	        scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
	          attr.$set(ngAttr, value);
	        });
	      }
	    };
	  };
	});
	
	// ng-src, ng-srcset, ng-href are interpolated
	forEach(['src', 'srcset', 'href'], function(attrName) {
	  var normalized = directiveNormalize('ng-' + attrName);
	  ngAttributeAliasDirectives[normalized] = function() {
	    return {
	      priority: 99, // it needs to run after the attributes are interpolated
	      link: function(scope, element, attr) {
	        var propName = attrName,
	            name = attrName;
	
	        if (attrName === 'href' &&
	            toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
	          name = 'xlinkHref';
	          attr.$attr[name] = 'xlink:href';
	          propName = null;
	        }
	
	        attr.$observe(normalized, function(value) {
	          if (!value) {
	            if (attrName === 'href') {
	              attr.$set(name, null);
	            }
	            return;
	          }
	
	          attr.$set(name, value);
	
	          // Support: IE 9-11 only
	          // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
	          // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
	          // to set the property as well to achieve the desired effect.
	          // We use attr[attrName] value since $set can sanitize the url.
	          if (msie && propName) element.prop(propName, attr[name]);
	        });
	      }
	    };
	  };
	});
	
	/* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
	 */
	var nullFormCtrl = {
	  $addControl: noop,
	  $$renameControl: nullFormRenameControl,
	  $removeControl: noop,
	  $setValidity: noop,
	  $setDirty: noop,
	  $setPristine: noop,
	  $setSubmitted: noop
	},
	PENDING_CLASS = 'ng-pending',
	SUBMITTED_CLASS = 'ng-submitted';
	
	function nullFormRenameControl(control, name) {
	  control.$name = name;
	}
	
	/**
	 * @ngdoc type
	 * @name form.FormController
	 *
	 * @property {boolean} $pristine True if user has not interacted with the form yet.
	 * @property {boolean} $dirty True if user has already interacted with the form.
	 * @property {boolean} $valid True if all of the containing forms and controls are valid.
	 * @property {boolean} $invalid True if at least one containing control or form is invalid.
	 * @property {boolean} $pending True if at least one containing control or form is pending.
	 * @property {boolean} $submitted True if user has submitted the form even if its invalid.
	 *
	 * @property {Object} $error Is an object hash, containing references to controls or
	 *  forms with failing validators, where:
	 *
	 *  - keys are validation tokens (error names),
	 *  - values are arrays of controls or forms that have a failing validator for given error name.
	 *
	 *  Built-in validation tokens:
	 *
	 *  - `email`
	 *  - `max`
	 *  - `maxlength`
	 *  - `min`
	 *  - `minlength`
	 *  - `number`
	 *  - `pattern`
	 *  - `required`
	 *  - `url`
	 *  - `date`
	 *  - `datetimelocal`
	 *  - `time`
	 *  - `week`
	 *  - `month`
	 *
	 * @description
	 * `FormController` keeps track of all its controls and nested forms as well as the state of them,
	 * such as being valid/invalid or dirty/pristine.
	 *
	 * Each {@link ng.directive:form form} directive creates an instance
	 * of `FormController`.
	 *
	 */
	//asks for $scope to fool the BC controller module
	FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
	function FormController($element, $attrs, $scope, $animate, $interpolate) {
	  this.$$controls = [];
	
	  // init state
	  this.$error = {};
	  this.$$success = {};
	  this.$pending = undefined;
	  this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
	  this.$dirty = false;
	  this.$pristine = true;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$submitted = false;
	  this.$$parentForm = nullFormCtrl;
	
	  this.$$element = $element;
	  this.$$animate = $animate;
	
	  setupValidity(this);
	}
	
	FormController.prototype = {
	  /**
	   * @ngdoc method
	   * @name form.FormController#$rollbackViewValue
	   *
	   * @description
	   * Rollback all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is typically needed by the reset button of
	   * a form that uses `ng-model-options` to pend updates.
	   */
	  $rollbackViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$rollbackViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$commitViewValue
	   *
	   * @description
	   * Commit all form controls pending updates to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    forEach(this.$$controls, function(control) {
	      control.$commitViewValue();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$addControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Register a control with the form. Input elements using ngModelController do this automatically
	   * when they are linked.
	   *
	   * Note that the current state of the control will not be reflected on the new parent form. This
	   * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
	   * state.
	   *
	   * However, if the method is used programmatically, for example by adding dynamically created controls,
	   * or controls that have been previously removed without destroying their corresponding DOM element,
	   * it's the developers responsibility to make sure the current state propagates to the parent form.
	   *
	   * For example, if an input control is added that is already `$dirty` and has `$error` properties,
	   * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
	   */
	  $addControl: function(control) {
	    // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
	    // and not added to the scope.  Now we throw an error.
	    assertNotHasOwnProperty(control.$name, 'input');
	    this.$$controls.push(control);
	
	    if (control.$name) {
	      this[control.$name] = control;
	    }
	
	    control.$$parentForm = this;
	  },
	
	  // Private API: rename a form control
	  $$renameControl: function(control, newName) {
	    var oldName = control.$name;
	
	    if (this[oldName] === control) {
	      delete this[oldName];
	    }
	    this[newName] = control;
	    control.$name = newName;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$removeControl
	   * @param {object} control control object, either a {@link form.FormController} or an
	   * {@link ngModel.NgModelController}
	   *
	   * @description
	   * Deregister a control from the form.
	   *
	   * Input elements using ngModelController do this automatically when they are destroyed.
	   *
	   * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
	   * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
	   * different from case to case. For example, removing the only `$dirty` control from a form may or
	   * may not mean that the form is still `$dirty`.
	   */
	  $removeControl: function(control) {
	    if (control.$name && this[control.$name] === control) {
	      delete this[control.$name];
	    }
	    forEach(this.$pending, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$error, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	    forEach(this.$$success, function(value, name) {
	      // eslint-disable-next-line no-invalid-this
	      this.$setValidity(name, null, control);
	    }, this);
	
	    arrayRemove(this.$$controls, control);
	    control.$$parentForm = nullFormCtrl;
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setDirty
	   *
	   * @description
	   * Sets the form to a dirty state.
	   *
	   * This method can be called to add the 'ng-dirty' class and set the form to a dirty
	   * state (ng-dirty class). This method will also propagate to parent forms.
	   */
	  $setDirty: function() {
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setPristine
	   *
	   * @description
	   * Sets the form to its pristine state.
	   *
	   * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
	   * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
	   * state to false.
	   *
	   * This method will also propagate to all the controls contained in this form.
	   *
	   * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
	   * saving or resetting it.
	   */
	  $setPristine: function() {
	    this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$submitted = false;
	    forEach(this.$$controls, function(control) {
	      control.$setPristine();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setUntouched
	   *
	   * @description
	   * Sets the form to its untouched state.
	   *
	   * This method can be called to remove the 'ng-touched' class and set the form controls to their
	   * untouched state (ng-untouched class).
	   *
	   * Setting a form controls back to their untouched state is often useful when setting the form
	   * back to its pristine state.
	   */
	  $setUntouched: function() {
	    forEach(this.$$controls, function(control) {
	      control.$setUntouched();
	    });
	  },
	
	  /**
	   * @ngdoc method
	   * @name form.FormController#$setSubmitted
	   *
	   * @description
	   * Sets the form to its submitted state.
	   */
	  $setSubmitted: function() {
	    this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
	    this.$submitted = true;
	    this.$$parentForm.$setSubmitted();
	  }
	};
	
	/**
	 * @ngdoc method
	 * @name form.FormController#$setValidity
	 *
	 * @description
	 * Sets the validity of a form control.
	 *
	 * This method will also propagate to parent forms.
	 */
	addSetValidityMethod({
	  clazz: FormController,
	  set: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      object[property] = [controller];
	    } else {
	      var index = list.indexOf(controller);
	      if (index === -1) {
	        list.push(controller);
	      }
	    }
	  },
	  unset: function(object, property, controller) {
	    var list = object[property];
	    if (!list) {
	      return;
	    }
	    arrayRemove(list, controller);
	    if (list.length === 0) {
	      delete object[property];
	    }
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngForm
	 * @restrict EAC
	 *
	 * @description
	 * Nestable alias of {@link ng.directive:form `form`} directive. HTML
	 * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
	 * sub-group of controls needs to be determined.
	 *
	 * Note: the purpose of `ngForm` is to group controls,
	 * but not to be a replacement for the `<form>` tag with all of its capabilities
	 * (e.g. posting to the server, ...).
	 *
	 * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 *
	 */
	
	 /**
	 * @ngdoc directive
	 * @name form
	 * @restrict E
	 *
	 * @description
	 * Directive that instantiates
	 * {@link form.FormController FormController}.
	 *
	 * If the `name` attribute is specified, the form controller is published onto the current scope under
	 * this name.
	 *
	 * # Alias: {@link ng.directive:ngForm `ngForm`}
	 *
	 * In Angular, forms can be nested. This means that the outer form is valid when all of the child
	 * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
	 * Angular provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
	 * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
	 * of controls needs to be determined.
	 *
	 * # CSS classes
	 *  - `ng-valid` is set if the form is valid.
	 *  - `ng-invalid` is set if the form is invalid.
	 *  - `ng-pending` is set if the form is pending.
	 *  - `ng-pristine` is set if the form is pristine.
	 *  - `ng-dirty` is set if the form is dirty.
	 *  - `ng-submitted` is set if the form was submitted.
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 *
	 * # Submitting a form and preventing the default action
	 *
	 * Since the role of forms in client-side Angular applications is different than in classical
	 * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
	 * page reload that sends the data to the server. Instead some javascript logic should be triggered
	 * to handle the form submission in an application-specific way.
	 *
	 * For this reason, Angular prevents the default action (form submission to the server) unless the
	 * `<form>` element has an `action` attribute specified.
	 *
	 * You can use one of the following two ways to specify what javascript method should be called when
	 * a form is submitted:
	 *
	 * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
	 * - {@link ng.directive:ngClick ngClick} directive on the first
	  *  button or input field of type submit (input[type=submit])
	 *
	 * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
	 * or {@link ng.directive:ngClick ngClick} directives.
	 * This is because of the following form submission rules in the HTML specification:
	 *
	 * - If a form has only one input field then hitting enter in this field triggers form submit
	 * (`ngSubmit`)
	 * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
	 * doesn't trigger submit
	 * - if a form has one or more input fields and one or more buttons or input[type=submit] then
	 * hitting enter in any of the input fields will trigger the click handler on the *first* button or
	 * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
	 *
	 * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
	 * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * ## Animation Hooks
	 *
	 * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
	 * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
	 * other validations that are performed within the form. Animations in ngForm are similar to how
	 * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
	 * as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style a form element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-form {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-form.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	    <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
	      <file name="index.html">
	       <script>
	         angular.module('formExample', [])
	           .controller('FormController', ['$scope', function($scope) {
	             $scope.userType = 'guest';
	           }]);
	       </script>
	       <style>
	        .my-form {
	          transition:all linear 0.5s;
	          background: transparent;
	        }
	        .my-form.ng-invalid {
	          background: red;
	        }
	       </style>
	       <form name="myForm" ng-controller="FormController" class="my-form">
	         userType: <input name="input" ng-model="userType" required>
	         <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
	         <code>userType = {{userType}}</code><br>
	         <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
	         <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
	         <code>myForm.$valid = {{myForm.$valid}}</code><br>
	         <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should initialize to model', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	
	          expect(userType.getText()).toContain('guest');
	          expect(valid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty', function() {
	          var userType = element(by.binding('userType'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var userInput = element(by.model('userType'));
	
	          userInput.clear();
	          userInput.sendKeys('');
	
	          expect(userType.getText()).toEqual('userType =');
	          expect(valid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 *
	 * @param {string=} name Name of the form. If specified, the form controller will be published into
	 *                       related scope, under this name.
	 */
	var formDirectiveFactory = function(isNgForm) {
	  return ['$timeout', '$parse', function($timeout, $parse) {
	    var formDirective = {
	      name: 'form',
	      restrict: isNgForm ? 'EAC' : 'E',
	      require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
	      controller: FormController,
	      compile: function ngFormCompile(formElement, attr) {
	        // Setup initial state of the control
	        formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
	
	        var nameAttr = attr.name ? 'name' : (isNgForm && attr.ngForm ? 'ngForm' : false);
	
	        return {
	          pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
	            var controller = ctrls[0];
	
	            // if `action` attr is not present on the form, prevent the default action (submission)
	            if (!('action' in attr)) {
	              // we can't use jq events because if a form is destroyed during submission the default
	              // action is not prevented. see #1238
	              //
	              // IE 9 is not affected because it doesn't fire a submit event and try to do a full
	              // page reload if the form was destroyed by submission of the form via a click handler
	              // on a button in the form. Looks like an IE9 specific bug.
	              var handleFormSubmission = function(event) {
	                scope.$apply(function() {
	                  controller.$commitViewValue();
	                  controller.$setSubmitted();
	                });
	
	                event.preventDefault();
	              };
	
	              formElement[0].addEventListener('submit', handleFormSubmission);
	
	              // unregister the preventDefault listener so that we don't not leak memory but in a
	              // way that will achieve the prevention of the default action.
	              formElement.on('$destroy', function() {
	                $timeout(function() {
	                  formElement[0].removeEventListener('submit', handleFormSubmission);
	                }, 0, false);
	              });
	            }
	
	            var parentFormCtrl = ctrls[1] || controller.$$parentForm;
	            parentFormCtrl.$addControl(controller);
	
	            var setter = nameAttr ? getSetter(controller.$name) : noop;
	
	            if (nameAttr) {
	              setter(scope, controller);
	              attr.$observe(nameAttr, function(newValue) {
	                if (controller.$name === newValue) return;
	                setter(scope, undefined);
	                controller.$$parentForm.$$renameControl(controller, newValue);
	                setter = getSetter(controller.$name);
	                setter(scope, controller);
	              });
	            }
	            formElement.on('$destroy', function() {
	              controller.$$parentForm.$removeControl(controller);
	              setter(scope, undefined);
	              extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
	            });
	          }
	        };
	      }
	    };
	
	    return formDirective;
	
	    function getSetter(expression) {
	      if (expression === '') {
	        //create an assignable expression, so forms with an empty name can be renamed later
	        return $parse('this[""]').assign;
	      }
	      return $parse(expression).assign || noop;
	    }
	  }];
	};
	
	var formDirective = formDirectiveFactory();
	var ngFormDirective = formDirectiveFactory(true);
	
	
	
	// helper methods
	function setupValidity(instance) {
	  instance.$$classCache = {};
	  instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
	}
	function addSetValidityMethod(context) {
	  var clazz = context.clazz,
	      set = context.set,
	      unset = context.unset;
	
	  clazz.prototype.$setValidity = function(validationErrorKey, state, controller) {
	    if (isUndefined(state)) {
	      createAndSet(this, '$pending', validationErrorKey, controller);
	    } else {
	      unsetAndCleanup(this, '$pending', validationErrorKey, controller);
	    }
	    if (!isBoolean(state)) {
	      unset(this.$error, validationErrorKey, controller);
	      unset(this.$$success, validationErrorKey, controller);
	    } else {
	      if (state) {
	        unset(this.$error, validationErrorKey, controller);
	        set(this.$$success, validationErrorKey, controller);
	      } else {
	        set(this.$error, validationErrorKey, controller);
	        unset(this.$$success, validationErrorKey, controller);
	      }
	    }
	    if (this.$pending) {
	      cachedToggleClass(this, PENDING_CLASS, true);
	      this.$valid = this.$invalid = undefined;
	      toggleValidationCss(this, '', null);
	    } else {
	      cachedToggleClass(this, PENDING_CLASS, false);
	      this.$valid = isObjectEmpty(this.$error);
	      this.$invalid = !this.$valid;
	      toggleValidationCss(this, '', this.$valid);
	    }
	
	    // re-read the state as the set/unset methods could have
	    // combined state in this.$error[validationError] (used for forms),
	    // where setting/unsetting only increments/decrements the value,
	    // and does not replace it.
	    var combinedState;
	    if (this.$pending && this.$pending[validationErrorKey]) {
	      combinedState = undefined;
	    } else if (this.$error[validationErrorKey]) {
	      combinedState = false;
	    } else if (this.$$success[validationErrorKey]) {
	      combinedState = true;
	    } else {
	      combinedState = null;
	    }
	
	    toggleValidationCss(this, validationErrorKey, combinedState);
	    this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
	  };
	
	  function createAndSet(ctrl, name, value, controller) {
	    if (!ctrl[name]) {
	      ctrl[name] = {};
	    }
	    set(ctrl[name], value, controller);
	  }
	
	  function unsetAndCleanup(ctrl, name, value, controller) {
	    if (ctrl[name]) {
	      unset(ctrl[name], value, controller);
	    }
	    if (isObjectEmpty(ctrl[name])) {
	      ctrl[name] = undefined;
	    }
	  }
	
	  function cachedToggleClass(ctrl, className, switchValue) {
	    if (switchValue && !ctrl.$$classCache[className]) {
	      ctrl.$$animate.addClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = true;
	    } else if (!switchValue && ctrl.$$classCache[className]) {
	      ctrl.$$animate.removeClass(ctrl.$$element, className);
	      ctrl.$$classCache[className] = false;
	    }
	  }
	
	  function toggleValidationCss(ctrl, validationErrorKey, isValid) {
	    validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
	
	    cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
	    cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
	  }
	}
	
	function isObjectEmpty(obj) {
	  if (obj) {
	    for (var prop in obj) {
	      if (obj.hasOwnProperty(prop)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/* global
	  VALID_CLASS: false,
	  INVALID_CLASS: false,
	  PRISTINE_CLASS: false,
	  DIRTY_CLASS: false,
	  ngModelMinErr: false
	*/
	
	// Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
	var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
	// See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
	// Note: We are being more lenient, because browsers are too.
	//   1. Scheme
	//   2. Slashes
	//   3. Username
	//   4. Password
	//   5. Hostname
	//   6. Port
	//   7. Path
	//   8. Query
	//   9. Fragment
	//                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
	var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
	// eslint-disable-next-line max-len
	var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
	var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
	var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
	var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
	var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
	var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
	
	var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
	var PARTIAL_VALIDATION_TYPES = createMap();
	forEach('date,datetime-local,month,time,week'.split(','), function(type) {
	  PARTIAL_VALIDATION_TYPES[type] = true;
	});
	
	var inputType = {
	
	  /**
	   * @ngdoc input
	   * @name input[text]
	   *
	   * @description
	   * Standard HTML text input with angular data binding, inherited by most of the `input` elements.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Adds `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	   *    This parameter is ignored for input[type=password] controls, which will never trim the
	   *    input.
	   *
	   * @example
	      <example name="text-input-directive" module="textInputExample">
	        <file name="index.html">
	         <script>
	           angular.module('textInputExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 text: 'guest',
	                 word: /^\s*\w*\s*$/
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Single word:
	             <input type="text" name="input" ng-model="example.text"
	                    ng-pattern="example.word" required ng-trim="false">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.pattern">
	               Single word only!</span>
	           </div>
	           <code>text = {{example.text}}</code><br/>
	           <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
	           <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
	           <code>myForm.$valid = {{myForm.$valid}}</code><br/>
	           <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('example.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('guest');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if multi word', function() {
	            input.clear();
	            input.sendKeys('hello world');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'text': textInputType,
	
	    /**
	     * @ngdoc input
	     * @name input[date]
	     *
	     * @description
	     * Input with date validation and transformation. In browsers that do not yet support
	     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
	     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
	     * modern browsers do not yet support this input type, it is important to provide cues to users on the
	     * expected input format via a placeholder or label.
	     *
	     * The model must always be a Date object, otherwise Angular will throw an error.
	     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	     *
	     * The timezone to be used to read/write the `Date` instance in the model can be defined using
	     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	     *
	     * @param {string} ngModel Assignable angular expression to data-bind to.
	     * @param {string=} name Property name of the form under which the control is published.
	     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
	     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
	     *   constraint validation.
	     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
	     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
	     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
	     *   constraint validation.
	     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
	     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
	     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	     * @param {string=} required Sets `required` validation error key if the value is not entered.
	     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	     *    `required` when you want to data-bind to the `required` attribute.
	     * @param {string=} ngChange Angular expression to be executed when input changes due to user
	     *    interaction with the input element.
	     *
	     * @example
	     <example name="date-input-directive" module="dateInputExample">
	     <file name="index.html">
	       <script>
	          angular.module('dateInputExample', [])
	            .controller('DateController', ['$scope', function($scope) {
	              $scope.example = {
	                value: new Date(2013, 9, 22)
	              };
	            }]);
	       </script>
	       <form name="myForm" ng-controller="DateController as dateCtrl">
	          <label for="exampleInput">Pick a date in 2013:</label>
	          <input type="date" id="exampleInput" name="input" ng-model="example.value"
	              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
	          <div role="alert">
	            <span class="error" ng-show="myForm.input.$error.required">
	                Required!</span>
	            <span class="error" ng-show="myForm.input.$error.date">
	                Not a valid date!</span>
	           </div>
	           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	       </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
	        var valid = element(by.binding('myForm.input.$valid'));
	
	        // currently protractor/webdriver does not support
	        // sending keys to all known HTML5 input controls
	        // for various browsers (see https://github.com/angular/protractor/issues/562).
	        function setInput(val) {
	          // set the value of the element and force validation.
	          var scr = "var ipt = document.getElementById('exampleInput'); " +
	          "ipt.value = '" + val + "';" +
	          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	          browser.executeScript(scr);
	        }
	
	        it('should initialize to model', function() {
	          expect(value.getText()).toContain('2013-10-22');
	          expect(valid.getText()).toContain('myForm.input.$valid = true');
	        });
	
	        it('should be invalid if empty', function() {
	          setInput('');
	          expect(value.getText()).toEqual('value =');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	
	        it('should be invalid if over max', function() {
	          setInput('2015-01-01');
	          expect(value.getText()).toContain('');
	          expect(valid.getText()).toContain('myForm.input.$valid = false');
	        });
	     </file>
	     </example>
	     */
	  'date': createDateInputType('date', DATE_REGEXP,
	         createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']),
	         'yyyy-MM-dd'),
	
	   /**
	    * @ngdoc input
	    * @name input[datetime-local]
	    *
	    * @description
	    * Input with datetime validation and transformation. In browsers that do not yet support
	    * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `min` will also add native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
	    *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
	    *   Note that `max` will also add native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="datetimelocal-input-directive" module="dateExample">
	    <file name="index.html">
	      <script>
	        angular.module('dateExample', [])
	          .controller('DateController', ['$scope', function($scope) {
	            $scope.example = {
	              value: new Date(2010, 11, 28, 14, 57)
	            };
	          }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a date between in 2013:</label>
	        <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.datetimelocal">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2010-12-28T14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01-01T23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP,
	      createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']),
	      'yyyy-MM-ddTHH:mm:ss.sss'),
	
	  /**
	   * @ngdoc input
	   * @name input[time]
	   *
	   * @description
	   * Input with time validation and transformation. In browsers that do not yet support
	   * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
	   * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
	   *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
	   *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="time-input-directive" module="timeExample">
	   <file name="index.html">
	     <script>
	      angular.module('timeExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(1970, 0, 1, 14, 57, 0)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label for="exampleInput">Pick a time between 8am and 5pm:</label>
	        <input type="time" id="exampleInput" name="input" ng-model="example.value"
	            placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.time">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "HH:mm:ss"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('14:57:00');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('23:59:00');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'time': createDateInputType('time', TIME_REGEXP,
	      createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']),
	     'HH:mm:ss.sss'),
	
	   /**
	    * @ngdoc input
	    * @name input[week]
	    *
	    * @description
	    * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
	    * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	    * week format (yyyy-W##), for example: `2013-W02`.
	    *
	    * The model must always be a Date object, otherwise Angular will throw an error.
	    * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	    *
	    * The timezone to be used to read/write the `Date` instance in the model can be defined using
	    * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	    *
	    * @param {string} ngModel Assignable angular expression to data-bind to.
	    * @param {string=} name Property name of the form under which the control is published.
	    * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
	    *   native HTML5 constraint validation.
	    * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	    *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
	    *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
	    *   native HTML5 constraint validation.
	    * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	    *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	    * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	    *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	    * @param {string=} required Sets `required` validation error key if the value is not entered.
	    * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	    *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	    *    `required` when you want to data-bind to the `required` attribute.
	    * @param {string=} ngChange Angular expression to be executed when input changes due to user
	    *    interaction with the input element.
	    *
	    * @example
	    <example name="week-input-directive" module="weekExample">
	    <file name="index.html">
	      <script>
	      angular.module('weekExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 0, 3)
	          };
	        }]);
	      </script>
	      <form name="myForm" ng-controller="DateController as dateCtrl">
	        <label>Pick a date between in 2013:
	          <input id="exampleInput" type="week" name="input" ng-model="example.value"
	                 placeholder="YYYY-W##" min="2012-W32"
	                 max="2013-W52" required />
	        </label>
	        <div role="alert">
	          <span class="error" ng-show="myForm.input.$error.required">
	              Required!</span>
	          <span class="error" ng-show="myForm.input.$error.week">
	              Not a valid date!</span>
	        </div>
	        <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
	        <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	        <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	        <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	        <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-Www"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-W01');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-W01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	    </file>
	    </example>
	    */
	  'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
	
	  /**
	   * @ngdoc input
	   * @name input[month]
	   *
	   * @description
	   * Input with month validation and transformation. In browsers that do not yet support
	   * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
	   * month format (yyyy-MM), for example: `2009-01`.
	   *
	   * The model must always be a Date object, otherwise Angular will throw an error.
	   * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
	   * If the model is not set to the first of the month, the next view to model update will set it
	   * to the first of the month.
	   *
	   * The timezone to be used to read/write the `Date` instance in the model can be defined using
	   * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
	   *   native HTML5 constraint validation.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
	   *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
	   *   native HTML5 constraint validation.
	   * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
	   *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
	   * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
	   *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
	
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	   <example name="month-input-directive" module="monthExample">
	   <file name="index.html">
	     <script>
	      angular.module('monthExample', [])
	        .controller('DateController', ['$scope', function($scope) {
	          $scope.example = {
	            value: new Date(2013, 9, 1)
	          };
	        }]);
	     </script>
	     <form name="myForm" ng-controller="DateController as dateCtrl">
	       <label for="exampleInput">Pick a month in 2013:</label>
	       <input id="exampleInput" type="month" name="input" ng-model="example.value"
	          placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
	       <div role="alert">
	         <span class="error" ng-show="myForm.input.$error.required">
	            Required!</span>
	         <span class="error" ng-show="myForm.input.$error.month">
	            Not a valid month!</span>
	       </div>
	       <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
	       <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	       <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	       <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	       <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	     </form>
	   </file>
	   <file name="protractor.js" type="protractor">
	      var value = element(by.binding('example.value | date: "yyyy-MM"'));
	      var valid = element(by.binding('myForm.input.$valid'));
	
	      // currently protractor/webdriver does not support
	      // sending keys to all known HTML5 input controls
	      // for various browsers (https://github.com/angular/protractor/issues/562).
	      function setInput(val) {
	        // set the value of the element and force validation.
	        var scr = "var ipt = document.getElementById('exampleInput'); " +
	        "ipt.value = '" + val + "';" +
	        "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
	        browser.executeScript(scr);
	      }
	
	      it('should initialize to model', function() {
	        expect(value.getText()).toContain('2013-10');
	        expect(valid.getText()).toContain('myForm.input.$valid = true');
	      });
	
	      it('should be invalid if empty', function() {
	        setInput('');
	        expect(value.getText()).toEqual('value =');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	
	      it('should be invalid if over max', function() {
	        setInput('2015-01');
	        expect(value.getText()).toContain('');
	        expect(valid.getText()).toContain('myForm.input.$valid = false');
	      });
	   </file>
	   </example>
	   */
	  'month': createDateInputType('month', MONTH_REGEXP,
	     createDateParser(MONTH_REGEXP, ['yyyy', 'MM']),
	     'yyyy-MM'),
	
	  /**
	   * @ngdoc input
	   * @name input[number]
	   *
	   * @description
	   * Text input with number validation and transformation. Sets the `number` validation
	   * error if not a valid number.
	   *
	   * <div class="alert alert-warning">
	   * The model must always be of type `number` otherwise Angular will throw an error.
	   * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
	   * error docs for more information and an example of how to convert your model if necessary.
	   * </div>
	   *
	   * ## Issues with HTML5 constraint validation
	   *
	   * In browsers that follow the
	   * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
	   * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
	   * If a non-number is entered in the input, the browser will report the value as an empty string,
	   * which means the view / model values in `ngModel` and subsequently the scope value
	   * will also be an empty string.
	   *
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
	   *    Can be interpolated.
	   * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
	   *    Can be interpolated.
	   * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
	   *    Can be interpolated.
	   * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
	   *    but does not trigger HTML5 native validation. Takes an expression.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="number-input-directive" module="numberExample">
	        <file name="index.html">
	         <script>
	           angular.module('numberExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.example = {
	                 value: 12
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Number:
	             <input type="number" name="input" ng-model="example.value"
	                    min="0" max="99" required>
	          </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.number">
	               Not valid number!</span>
	           </div>
	           <tt>value = {{example.value}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var value = element(by.binding('example.value'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('example.value'));
	
	          it('should initialize to model', function() {
	            expect(value.getText()).toContain('12');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if over max', function() {
	            input.clear();
	            input.sendKeys('123');
	            expect(value.getText()).toEqual('value =');
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'number': numberInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[url]
	   *
	   * @description
	   * Text input with URL validation. Sets the `url` validation error key if the content is not a
	   * valid URL.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
	   * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
	   * the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="url-input-directive" module="urlExample">
	        <file name="index.html">
	         <script>
	           angular.module('urlExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.url = {
	                 text: 'http://google.com'
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>URL:
	             <input type="url" name="input" ng-model="url.text" required>
	           <label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.input.$error.required">
	               Required!</span>
	             <span class="error" ng-show="myForm.input.$error.url">
	               Not valid url!</span>
	           </div>
	           <tt>text = {{url.text}}</tt><br/>
	           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	           <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('url.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('url.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('http://google.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not url', function() {
	            input.clear();
	            input.sendKeys('box');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'url': urlInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[email]
	   *
	   * @description
	   * Text input with email validation. Sets the `email` validation error key if not a valid email
	   * address.
	   *
	   * <div class="alert alert-warning">
	   * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
	   * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
	   * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
	   * </div>
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} required Sets `required` validation error key if the value is not entered.
	   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	   *    `required` when you want to data-bind to the `required` attribute.
	   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	   *    minlength.
	   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
	   *    any length.
	   * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
	   *    that contains the regular expression body that will be converted to a regular expression
	   *    as in the ngPattern directive.
	   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	   *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	   *    If the expression evaluates to a RegExp object, then this is used directly.
	   *    If the expression evaluates to a string, then it will be converted to a RegExp
	   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	   *    `new RegExp('^abc$')`.<br />
	   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	   *    start at the index of the last search's match, thus not taking the whole input value into
	   *    account.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="email-input-directive" module="emailExample">
	        <file name="index.html">
	         <script>
	           angular.module('emailExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.email = {
	                 text: 'me@example.com'
	               };
	             }]);
	         </script>
	           <form name="myForm" ng-controller="ExampleController">
	             <label>Email:
	               <input type="email" name="input" ng-model="email.text" required>
	             </label>
	             <div role="alert">
	               <span class="error" ng-show="myForm.input.$error.required">
	                 Required!</span>
	               <span class="error" ng-show="myForm.input.$error.email">
	                 Not valid email!</span>
	             </div>
	             <tt>text = {{email.text}}</tt><br/>
	             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
	             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
	             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	             <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
	           </form>
	         </file>
	        <file name="protractor.js" type="protractor">
	          var text = element(by.binding('email.text'));
	          var valid = element(by.binding('myForm.input.$valid'));
	          var input = element(by.model('email.text'));
	
	          it('should initialize to model', function() {
	            expect(text.getText()).toContain('me@example.com');
	            expect(valid.getText()).toContain('true');
	          });
	
	          it('should be invalid if empty', function() {
	            input.clear();
	            input.sendKeys('');
	            expect(text.getText()).toEqual('text =');
	            expect(valid.getText()).toContain('false');
	          });
	
	          it('should be invalid if not email', function() {
	            input.clear();
	            input.sendKeys('xxx');
	
	            expect(valid.getText()).toContain('false');
	          });
	        </file>
	      </example>
	   */
	  'email': emailInputType,
	
	
	  /**
	   * @ngdoc input
	   * @name input[radio]
	   *
	   * @description
	   * HTML radio button.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string} value The value to which the `ngModel` expression should be set when selected.
	   *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
	   *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   * @param {string} ngValue Angular expression to which `ngModel` will be be set when the radio
	   *    is selected. Should be used instead of the `value` attribute if you need
	   *    a non-string `ngModel` (`boolean`, `array`, ...).
	   *
	   * @example
	      <example name="radio-input-directive" module="radioExample">
	        <file name="index.html">
	         <script>
	           angular.module('radioExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.color = {
	                 name: 'blue'
	               };
	               $scope.specialValue = {
	                 "id": "12345",
	                 "value": "green"
	               };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>
	             <input type="radio" ng-model="color.name" value="red">
	             Red
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" ng-value="specialValue">
	             Green
	           </label><br/>
	           <label>
	             <input type="radio" ng-model="color.name" value="blue">
	             Blue
	           </label><br/>
	           <tt>color = {{color.name | json}}</tt><br/>
	          </form>
	          Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var inputs = element.all(by.model('color.name'));
	            var color = element(by.binding('color.name'));
	
	            expect(color.getText()).toContain('blue');
	
	            inputs.get(0).click();
	            expect(color.getText()).toContain('red');
	
	            inputs.get(1).click();
	            expect(color.getText()).toContain('green');
	          });
	        </file>
	      </example>
	   */
	  'radio': radioInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[range]
	   *
	   * @description
	   * Native range input with validation and transformation.
	   *
	   * The model for the range input must always be a `Number`.
	   *
	   * IE9 and other browsers that do not support the `range` type fall back
	   * to a text input without any default values for `min`, `max` and `step`. Model binding,
	   * validation and number parsing are nevertheless supported.
	   *
	   * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
	   * in a way that never allows the input to hold an invalid value. That means:
	   * - any non-numerical value is set to `(max + min) / 2`.
	   * - any numerical value that is less than the current min val, or greater than the current max val
	   * is set to the min / max val respectively.
	   * - additionally, the current `step` is respected, so the nearest value that satisfies a step
	   * is used.
	   *
	   * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
	   * for more info.
	   *
	   * This has the following consequences for Angular:
	   *
	   * Since the element value should always reflect the current model value, a range input
	   * will set the bound ngModel expression to the value that the browser has set for the
	   * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
	   * if the application sets `model.value = null`, the browser will set the input to `'50'`.
	   * Angular will then set the model to `50`, to prevent input and model value being out of sync.
	   *
	   * That means the model for range will immediately be set to `50` after `ngModel` has been
	   * initialized. It also means a range input can never have the required error.
	   *
	   * This does not only affect changes to the model value, but also to the values of the `min`,
	   * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
	   * the input value, Angular will also update the model value.
	   *
	   * Automatic value adjustment also means that a range input element can never have the `required`,
	   * `min`, or `max` errors.
	   *
	   * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
	   * when the step value changes dynamically - they do not adjust the element value correctly, but
	   * instead may set the `stepMismatch` error. If that's the case, the Angular will set the `step`
	   * error on the input, and set the model to `undefined`.
	   *
	   * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
	   * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
	   * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
	   *
	   * @param {string}  ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
	   *                  than `min`. Can be interpolated.
	   * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
	   *                  Can be interpolated.
	   * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
	   *                  Can be interpolated.
	   * @param {string=} ngChange Angular expression to be executed when the ngModel value changes due
	   *                  to user interaction with the input element.
	   * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
	   *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
	   *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
	   *
	   * @example
	      <example name="range-input-directive" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	
	            Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   * ## Range Input with ngMin & ngMax attributes
	
	   * @example
	      <example name="range-input-directive-ng" module="rangeExample">
	        <file name="index.html">
	          <script>
	            angular.module('rangeExample', [])
	              .controller('ExampleController', ['$scope', function($scope) {
	                $scope.value = 75;
	                $scope.min = 10;
	                $scope.max = 90;
	              }]);
	          </script>
	          <form name="myForm" ng-controller="ExampleController">
	            Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
	            <hr>
	            Model as number: <input type="number" ng-model="value"><br>
	            Min: <input type="number" ng-model="min"><br>
	            Max: <input type="number" ng-model="max"><br>
	            value = <code>{{value}}</code><br/>
	            myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
	            myForm.range.$error = <code>{{myForm.range.$error}}</code>
	          </form>
	        </file>
	      </example>
	
	   */
	  'range': rangeInputType,
	
	  /**
	   * @ngdoc input
	   * @name input[checkbox]
	   *
	   * @description
	   * HTML checkbox.
	   *
	   * @param {string} ngModel Assignable angular expression to data-bind to.
	   * @param {string=} name Property name of the form under which the control is published.
	   * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
	   * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
	   * @param {string=} ngChange Angular expression to be executed when input changes due to user
	   *    interaction with the input element.
	   *
	   * @example
	      <example name="checkbox-input-directive" module="checkboxExample">
	        <file name="index.html">
	         <script>
	           angular.module('checkboxExample', [])
	             .controller('ExampleController', ['$scope', function($scope) {
	               $scope.checkboxModel = {
	                value1 : true,
	                value2 : 'YES'
	              };
	             }]);
	         </script>
	         <form name="myForm" ng-controller="ExampleController">
	           <label>Value1:
	             <input type="checkbox" ng-model="checkboxModel.value1">
	           </label><br/>
	           <label>Value2:
	             <input type="checkbox" ng-model="checkboxModel.value2"
	                    ng-true-value="'YES'" ng-false-value="'NO'">
	            </label><br/>
	           <tt>value1 = {{checkboxModel.value1}}</tt><br/>
	           <tt>value2 = {{checkboxModel.value2}}</tt><br/>
	          </form>
	        </file>
	        <file name="protractor.js" type="protractor">
	          it('should change state', function() {
	            var value1 = element(by.binding('checkboxModel.value1'));
	            var value2 = element(by.binding('checkboxModel.value2'));
	
	            expect(value1.getText()).toContain('true');
	            expect(value2.getText()).toContain('YES');
	
	            element(by.model('checkboxModel.value1')).click();
	            element(by.model('checkboxModel.value2')).click();
	
	            expect(value1.getText()).toContain('false');
	            expect(value2.getText()).toContain('NO');
	          });
	        </file>
	      </example>
	   */
	  'checkbox': checkboxInputType,
	
	  'hidden': noop,
	  'button': noop,
	  'submit': noop,
	  'reset': noop,
	  'file': noop
	};
	
	function stringBasedInputType(ctrl) {
	  ctrl.$formatters.push(function(value) {
	    return ctrl.$isEmpty(value) ? value : value.toString();
	  });
	}
	
	function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	}
	
	function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  var type = lowercase(element[0].type);
	
	  // In composition mode, users are still inputting intermediate text buffer,
	  // hold the listener until composition is done.
	  // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
	  if (!$sniffer.android) {
	    var composing = false;
	
	    element.on('compositionstart', function() {
	      composing = true;
	    });
	
	    element.on('compositionend', function() {
	      composing = false;
	      listener();
	    });
	  }
	
	  var timeout;
	
	  var listener = function(ev) {
	    if (timeout) {
	      $browser.defer.cancel(timeout);
	      timeout = null;
	    }
	    if (composing) return;
	    var value = element.val(),
	        event = ev && ev.type;
	
	    // By default we will trim the value
	    // If the attribute ng-trim exists we will avoid trimming
	    // If input type is 'password', the value is never trimmed
	    if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
	      value = trim(value);
	    }
	
	    // If a control is suffering from bad input (due to native validators), browsers discard its
	    // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
	    // control's value is the same empty value twice in a row.
	    if (ctrl.$viewValue !== value || (value === '' && ctrl.$$hasNativeValidators)) {
	      ctrl.$setViewValue(value, event);
	    }
	  };
	
	  // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
	  // input event on backspace, delete or cut
	  if ($sniffer.hasEvent('input')) {
	    element.on('input', listener);
	  } else {
	    var deferListener = function(ev, input, origValue) {
	      if (!timeout) {
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (!input || input.value !== origValue) {
	            listener(ev);
	          }
	        });
	      }
	    };
	
	    element.on('keydown', /** @this */ function(event) {
	      var key = event.keyCode;
	
	      // ignore
	      //    command            modifiers                   arrows
	      if (key === 91 || (15 < key && key < 19) || (37 <= key && key <= 40)) return;
	
	      deferListener(event, this, this.value);
	    });
	
	    // if user modifies input value using context menu in IE, we need "paste" and "cut" events to catch it
	    if ($sniffer.hasEvent('paste')) {
	      element.on('paste cut', deferListener);
	    }
	  }
	
	  // if user paste into input using mouse on older browser
	  // or form autocomplete on newer browser, we need "change" event to catch it
	  element.on('change', listener);
	
	  // Some native input types (date-family) have the ability to change validity without
	  // firing any input/change events.
	  // For these event types, when native validators are present and the browser supports the type,
	  // check for validity changes on various DOM events.
	  if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
	    element.on(PARTIAL_VALIDATION_EVENTS, /** @this */ function(ev) {
	      if (!timeout) {
	        var validity = this[VALIDITY_STATE_PROPERTY];
	        var origBadInput = validity.badInput;
	        var origTypeMismatch = validity.typeMismatch;
	        timeout = $browser.defer(function() {
	          timeout = null;
	          if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
	            listener(ev);
	          }
	        });
	      }
	    });
	  }
	
	  ctrl.$render = function() {
	    // Workaround for Firefox validation #12102.
	    var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
	    if (element.val() !== value) {
	      element.val(value);
	    }
	  };
	}
	
	function weekParser(isoWeek, existingDate) {
	  if (isDate(isoWeek)) {
	    return isoWeek;
	  }
	
	  if (isString(isoWeek)) {
	    WEEK_REGEXP.lastIndex = 0;
	    var parts = WEEK_REGEXP.exec(isoWeek);
	    if (parts) {
	      var year = +parts[1],
	          week = +parts[2],
	          hours = 0,
	          minutes = 0,
	          seconds = 0,
	          milliseconds = 0,
	          firstThurs = getFirstThursdayOfYear(year),
	          addDays = (week - 1) * 7;
	
	      if (existingDate) {
	        hours = existingDate.getHours();
	        minutes = existingDate.getMinutes();
	        seconds = existingDate.getSeconds();
	        milliseconds = existingDate.getMilliseconds();
	      }
	
	      return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
	    }
	  }
	
	  return NaN;
	}
	
	function createDateParser(regexp, mapping) {
	  return function(iso, date) {
	    var parts, map;
	
	    if (isDate(iso)) {
	      return iso;
	    }
	
	    if (isString(iso)) {
	      // When a date is JSON'ified to wraps itself inside of an extra
	      // set of double quotes. This makes the date parsing code unable
	      // to match the date string and parse it as a date.
	      if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
	        iso = iso.substring(1, iso.length - 1);
	      }
	      if (ISO_DATE_REGEXP.test(iso)) {
	        return new Date(iso);
	      }
	      regexp.lastIndex = 0;
	      parts = regexp.exec(iso);
	
	      if (parts) {
	        parts.shift();
	        if (date) {
	          map = {
	            yyyy: date.getFullYear(),
	            MM: date.getMonth() + 1,
	            dd: date.getDate(),
	            HH: date.getHours(),
	            mm: date.getMinutes(),
	            ss: date.getSeconds(),
	            sss: date.getMilliseconds() / 1000
	          };
	        } else {
	          map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
	        }
	
	        forEach(parts, function(part, index) {
	          if (index < mapping.length) {
	            map[mapping[index]] = +part;
	          }
	        });
	        return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
	      }
	    }
	
	    return NaN;
	  };
	}
	
	function createDateInputType(type, regexp, parseDate, format) {
	  return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
	    badInputChecker(scope, element, attr, ctrl);
	    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	    var timezone = ctrl && ctrl.$options.getOption('timezone');
	    var previousDate;
	
	    ctrl.$$parserName = type;
	    ctrl.$parsers.push(function(value) {
	      if (ctrl.$isEmpty(value)) return null;
	      if (regexp.test(value)) {
	        // Note: We cannot read ctrl.$modelValue, as there might be a different
	        // parser/formatter in the processing chain so that the model
	        // contains some different data format!
	        var parsedDate = parseDate(value, previousDate);
	        if (timezone) {
	          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
	        }
	        return parsedDate;
	      }
	      return undefined;
	    });
	
	    ctrl.$formatters.push(function(value) {
	      if (value && !isDate(value)) {
	        throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
	      }
	      if (isValidDate(value)) {
	        previousDate = value;
	        if (previousDate && timezone) {
	          previousDate = convertTimezoneToLocal(previousDate, timezone, true);
	        }
	        return $filter('date')(value, format, timezone);
	      } else {
	        previousDate = null;
	        return '';
	      }
	    });
	
	    if (isDefined(attr.min) || attr.ngMin) {
	      var minVal;
	      ctrl.$validators.min = function(value) {
	        return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
	      };
	      attr.$observe('min', function(val) {
	        minVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    if (isDefined(attr.max) || attr.ngMax) {
	      var maxVal;
	      ctrl.$validators.max = function(value) {
	        return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
	      };
	      attr.$observe('max', function(val) {
	        maxVal = parseObservedDateValue(val);
	        ctrl.$validate();
	      });
	    }
	
	    function isValidDate(value) {
	      // Invalid Date: getTime() returns NaN
	      return value && !(value.getTime && value.getTime() !== value.getTime());
	    }
	
	    function parseObservedDateValue(val) {
	      return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
	    }
	  };
	}
	
	function badInputChecker(scope, element, attr, ctrl) {
	  var node = element[0];
	  var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
	  if (nativeValidation) {
	    ctrl.$parsers.push(function(value) {
	      var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
	      return validity.badInput || validity.typeMismatch ? undefined : value;
	    });
	  }
	}
	
	function numberFormatterParser(ctrl) {
	  ctrl.$$parserName = 'number';
	  ctrl.$parsers.push(function(value) {
	    if (ctrl.$isEmpty(value))      return null;
	    if (NUMBER_REGEXP.test(value)) return parseFloat(value);
	    return undefined;
	  });
	
	  ctrl.$formatters.push(function(value) {
	    if (!ctrl.$isEmpty(value)) {
	      if (!isNumber(value)) {
	        throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
	      }
	      value = value.toString();
	    }
	    return value;
	  });
	}
	
	function parseNumberAttrVal(val) {
	  if (isDefined(val) && !isNumber(val)) {
	    val = parseFloat(val);
	  }
	  return !isNumberNaN(val) ? val : undefined;
	}
	
	function isNumberInteger(num) {
	  // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
	  // (minus the assumption that `num` is a number)
	
	  // eslint-disable-next-line no-bitwise
	  return (num | 0) === num;
	}
	
	function countDecimals(num) {
	  var numString = num.toString();
	  var decimalSymbolIndex = numString.indexOf('.');
	
	  if (decimalSymbolIndex === -1) {
	    if (-1 < num && num < 1) {
	      // It may be in the exponential notation format (`1e-X`)
	      var match = /e-(\d+)$/.exec(numString);
	
	      if (match) {
	        return Number(match[1]);
	      }
	    }
	
	    return 0;
	  }
	
	  return numString.length - decimalSymbolIndex - 1;
	}
	
	function isValidForStep(viewValue, stepBase, step) {
	  // At this point `stepBase` and `step` are expected to be non-NaN values
	  // and `viewValue` is expected to be a valid stringified number.
	  var value = Number(viewValue);
	
	  var isNonIntegerValue = !isNumberInteger(value);
	  var isNonIntegerStepBase = !isNumberInteger(stepBase);
	  var isNonIntegerStep = !isNumberInteger(step);
	
	  // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
	  // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
	  if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
	    var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
	    var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
	    var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
	
	    var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
	    var multiplier = Math.pow(10, decimalCount);
	
	    value = value * multiplier;
	    stepBase = stepBase * multiplier;
	    step = step * multiplier;
	
	    if (isNonIntegerValue) value = Math.round(value);
	    if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
	    if (isNonIntegerStep) step = Math.round(step);
	  }
	
	  return (value - stepBase) % step === 0;
	}
	
	function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var minVal;
	  var maxVal;
	
	  if (isDefined(attr.min) || attr.ngMin) {
	    ctrl.$validators.min = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
	    };
	
	    attr.$observe('min', function(val) {
	      minVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.max) || attr.ngMax) {
	    ctrl.$validators.max = function(value) {
	      return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
	    };
	
	    attr.$observe('max', function(val) {
	      maxVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	
	  if (isDefined(attr.step) || attr.ngStep) {
	    var stepVal;
	    ctrl.$validators.step = function(modelValue, viewValue) {
	      return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	             isValidForStep(viewValue, minVal || 0, stepVal);
	    };
	
	    attr.$observe('step', function(val) {
	      stepVal = parseNumberAttrVal(val);
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    });
	  }
	}
	
	function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  badInputChecker(scope, element, attr, ctrl);
	  numberFormatterParser(ctrl);
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	
	  var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
	      minVal = supportsRange ? 0 : undefined,
	      maxVal = supportsRange ? 100 : undefined,
	      stepVal = supportsRange ? 1 : undefined,
	      validity = element[0].validity,
	      hasMinAttr = isDefined(attr.min),
	      hasMaxAttr = isDefined(attr.max),
	      hasStepAttr = isDefined(attr.step);
	
	  var originalRender = ctrl.$render;
	
	  ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
	    //Browsers that implement range will set these values automatically, but reading the adjusted values after
	    //$render would cause the min / max validators to be applied with the wrong value
	    function rangeRender() {
	      originalRender();
	      ctrl.$setViewValue(element.val());
	    } :
	    originalRender;
	
	  if (hasMinAttr) {
	    ctrl.$validators.min = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMinValidator() { return true; } :
	      // non-support browsers validate the min val
	      function minValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
	      };
	
	    setInitialValueAndObserver('min', minChange);
	  }
	
	  if (hasMaxAttr) {
	    ctrl.$validators.max = supportsRange ?
	      // Since all browsers set the input to a valid value, we don't need to check validity
	      function noopMaxValidator() { return true; } :
	      // non-support browsers validate the max val
	      function maxValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
	      };
	
	    setInitialValueAndObserver('max', maxChange);
	  }
	
	  if (hasStepAttr) {
	    ctrl.$validators.step = supportsRange ?
	      function nativeStepValidator() {
	        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
	        // input element value to a valid value). It's possible that other browsers set the stepMismatch
	        // validity error instead, so we can at least report an error in that case.
	        return !validity.stepMismatch;
	      } :
	      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
	      function stepValidator(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) ||
	               isValidForStep(viewValue, minVal || 0, stepVal);
	      };
	
	    setInitialValueAndObserver('step', stepChange);
	  }
	
	  function setInitialValueAndObserver(htmlAttrName, changeFn) {
	    // interpolated attributes set the attribute value only after a digest, but we need the
	    // attribute value when the input is first rendered, so that the browser can adjust the
	    // input value based on the min/max value
	    element.attr(htmlAttrName, attr[htmlAttrName]);
	    attr.$observe(htmlAttrName, changeFn);
	  }
	
	  function minChange(val) {
	    minVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the minVal is greater than the element value
	      if (minVal > elVal) {
	        elVal = minVal;
	        element.val(elVal);
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function maxChange(val) {
	    maxVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    if (supportsRange) {
	      var elVal = element.val();
	      // IE11 doesn't set the el val correctly if the maxVal is less than the element value
	      if (maxVal < elVal) {
	        element.val(maxVal);
	        // IE11 and Chrome don't set the value to the minVal when max < min
	        elVal = maxVal < minVal ? minVal : maxVal;
	      }
	      ctrl.$setViewValue(elVal);
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	
	  function stepChange(val) {
	    stepVal = parseNumberAttrVal(val);
	    // ignore changes before model is initialized
	    if (isNumberNaN(ctrl.$modelValue)) {
	      return;
	    }
	
	    // Some browsers don't adjust the input value correctly, but set the stepMismatch error
	    if (supportsRange && ctrl.$viewValue !== element.val()) {
	      ctrl.$setViewValue(element.val());
	    } else {
	      // TODO(matsko): implement validateLater to reduce number of validations
	      ctrl.$validate();
	    }
	  }
	}
	
	function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'url';
	  ctrl.$validators.url = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
	  };
	}
	
	function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
	  // Note: no badInputChecker here by purpose as `url` is only a validation
	  // in browsers, i.e. we can always read out input.value even if it is not valid!
	  baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
	  stringBasedInputType(ctrl);
	
	  ctrl.$$parserName = 'email';
	  ctrl.$validators.email = function(modelValue, viewValue) {
	    var value = modelValue || viewValue;
	    return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
	  };
	}
	
	function radioInputType(scope, element, attr, ctrl) {
	  var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
	  // make the name unique, if not defined
	  if (isUndefined(attr.name)) {
	    element.attr('name', nextUid());
	  }
	
	  var listener = function(ev) {
	    var value;
	    if (element[0].checked) {
	      value = attr.value;
	      if (doTrim) {
	        value = trim(value);
	      }
	      ctrl.$setViewValue(value, ev && ev.type);
	    }
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    var value = attr.value;
	    if (doTrim) {
	      value = trim(value);
	    }
	    element[0].checked = (value === ctrl.$viewValue);
	  };
	
	  attr.$observe('value', ctrl.$render);
	}
	
	function parseConstantExpr($parse, context, name, expression, fallback) {
	  var parseFn;
	  if (isDefined(expression)) {
	    parseFn = $parse(expression);
	    if (!parseFn.constant) {
	      throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' +
	                                   '`{1}`.', name, expression);
	    }
	    return parseFn(context);
	  }
	  return fallback;
	}
	
	function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
	  var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
	  var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
	
	  var listener = function(ev) {
	    ctrl.$setViewValue(element[0].checked, ev && ev.type);
	  };
	
	  element.on('click', listener);
	
	  ctrl.$render = function() {
	    element[0].checked = ctrl.$viewValue;
	  };
	
	  // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
	  // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
	  // it to a boolean.
	  ctrl.$isEmpty = function(value) {
	    return value === false;
	  };
	
	  ctrl.$formatters.push(function(value) {
	    return equals(value, trueValue);
	  });
	
	  ctrl.$parsers.push(function(value) {
	    return value ? trueValue : falseValue;
	  });
	}
	
	
	/**
	 * @ngdoc directive
	 * @name textarea
	 * @restrict E
	 *
	 * @description
	 * HTML textarea element control with angular data-binding. The data-binding and validation
	 * properties of this element are exactly the same as those of the
	 * {@link ng.directive:input input element}.
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *
	 * @knownIssue
	 *
	 * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
	 * insert the placeholder value as the textarea's content. If the placeholder value contains
	 * interpolation (`{{ ... }}`), an error will be logged in the console when Angular tries to update
	 * the value of the by-then-removed text node. This doesn't affect the functionality of the
	 * textarea, but can be undesirable.
	 *
	 * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
	 * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
	 * find more details on `ngAttr` in the
	 * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
	 * Developer Guide.
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name input
	 * @restrict E
	 *
	 * @description
	 * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
	 * input state control, and validation.
	 * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
	 *
	 * <div class="alert alert-warning">
	 * **Note:** Not every feature offered is available for all input types.
	 * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
	 * </div>
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {boolean=} ngRequired Sets `required` attribute if set to true
	 * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
	 *    minlength.
	 * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
	 *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
	 *    length.
	 * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
	 *    value does not match a RegExp found by evaluating the Angular expression given in the attribute value.
	 *    If the expression evaluates to a RegExp object, then this is used directly.
	 *    If the expression evaluates to a string, then it will be converted to a RegExp
	 *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
	 *    `new RegExp('^abc$')`.<br />
	 *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 *    start at the index of the last search's match, thus not taking the whole input value into
	 *    account.
	 * @param {string=} ngChange Angular expression to be executed when input changes due to user
	 *    interaction with the input element.
	 * @param {boolean=} [ngTrim=true] If set to false Angular will not automatically trim the input.
	 *    This parameter is ignored for input[type=password] controls, which will never trim the
	 *    input.
	 *
	 * @example
	    <example name="input-directive" module="inputExample">
	      <file name="index.html">
	       <script>
	          angular.module('inputExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.user = {name: 'guest', last: 'visitor'};
	            }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <form name="myForm">
	           <label>
	              User name:
	              <input type="text" name="userName" ng-model="user.name" required>
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.userName.$error.required">
	              Required!</span>
	           </div>
	           <label>
	              Last name:
	              <input type="text" name="lastName" ng-model="user.last"
	              ng-minlength="3" ng-maxlength="10">
	           </label>
	           <div role="alert">
	             <span class="error" ng-show="myForm.lastName.$error.minlength">
	               Too short!</span>
	             <span class="error" ng-show="myForm.lastName.$error.maxlength">
	               Too long!</span>
	           </div>
	         </form>
	         <hr>
	         <tt>user = {{user}}</tt><br/>
	         <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
	         <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
	         <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
	         <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
	         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	         <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
	         <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
	       </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var user = element(by.exactBinding('user'));
	        var userNameValid = element(by.binding('myForm.userName.$valid'));
	        var lastNameValid = element(by.binding('myForm.lastName.$valid'));
	        var lastNameError = element(by.binding('myForm.lastName.$error'));
	        var formValid = element(by.binding('myForm.$valid'));
	        var userNameInput = element(by.model('user.name'));
	        var userLastInput = element(by.model('user.last'));
	
	        it('should initialize to model', function() {
	          expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
	          expect(userNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if empty when required', function() {
	          userNameInput.clear();
	          userNameInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"last":"visitor"}');
	          expect(userNameValid.getText()).toContain('false');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be valid if empty when min length is set', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('');
	
	          expect(user.getText()).toContain('{"name":"guest","last":""}');
	          expect(lastNameValid.getText()).toContain('true');
	          expect(formValid.getText()).toContain('true');
	        });
	
	        it('should be invalid if less than required min length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('xx');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('minlength');
	          expect(formValid.getText()).toContain('false');
	        });
	
	        it('should be invalid if longer than max length', function() {
	          userLastInput.clear();
	          userLastInput.sendKeys('some ridiculously long name');
	
	          expect(user.getText()).toContain('{"name":"guest"}');
	          expect(lastNameValid.getText()).toContain('false');
	          expect(lastNameError.getText()).toContain('maxlength');
	          expect(formValid.getText()).toContain('false');
	        });
	      </file>
	    </example>
	 */
	var inputDirective = ['$browser', '$sniffer', '$filter', '$parse',
	    function($browser, $sniffer, $filter, $parse) {
	  return {
	    restrict: 'E',
	    require: ['?ngModel'],
	    link: {
	      pre: function(scope, element, attr, ctrls) {
	        if (ctrls[0]) {
	          (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer,
	                                                              $browser, $filter, $parse);
	        }
	      }
	    }
	  };
	}];
	
	
	
	var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
	/**
	 * @ngdoc directive
	 * @name ngValue
	 *
	 * @description
	 * Binds the given expression to the value of the element.
	 *
	 * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
	 * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
	 * {@link select `select`} parent element) is set to the bound value. It is especially useful
	 * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
	 *
	 * It can also be used to achieve one-way binding of a given expression to an input element
	 * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
	 *
	 * @element input
	 * @param {string=} ngValue angular expression, whose value will be bound to the `value` attribute
	 * and `value` property of the element.
	 *
	 * @example
	    <example name="ngValue-directive" module="valueExample">
	      <file name="index.html">
	       <script>
	          angular.module('valueExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.names = ['pizza', 'unicorns', 'robots'];
	              $scope.my = { favorite: 'unicorns' };
	            }]);
	       </script>
	        <form ng-controller="ExampleController">
	          <h2>Which is your favorite?</h2>
	            <label ng-repeat="name in names" for="{{name}}">
	              {{name}}
	              <input type="radio"
	                     ng-model="my.favorite"
	                     ng-value="name"
	                     id="{{name}}"
	                     name="favorite">
	            </label>
	          <div>You chose {{my.favorite}}</div>
	        </form>
	      </file>
	      <file name="protractor.js" type="protractor">
	        var favorite = element(by.binding('my.favorite'));
	
	        it('should initialize to model', function() {
	          expect(favorite.getText()).toContain('unicorns');
	        });
	        it('should bind the values to the inputs', function() {
	          element.all(by.model('my.favorite')).get(0).click();
	          expect(favorite.getText()).toContain('pizza');
	        });
	      </file>
	    </example>
	 */
	var ngValueDirective = function() {
	  /**
	   *  inputs use the value attribute as their default value if the value property is not set.
	   *  Once the value property has been set (by adding input), it will not react to changes to
	   *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
	   *  makes it possible to use ngValue as a sort of one-way bind.
	   */
	  function updateElementValue(element, attr, value) {
	    // Support: IE9 only
	    // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
	    var propValue = isDefined(value) ? value : (msie === 9) ? '' : null;
	    element.prop('value', propValue);
	    attr.$set('value', value);
	  }
	
	  return {
	    restrict: 'A',
	    priority: 100,
	    compile: function(tpl, tplAttr) {
	      if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
	        return function ngValueConstantLink(scope, elm, attr) {
	          var value = scope.$eval(attr.ngValue);
	          updateElementValue(elm, attr, value);
	        };
	      } else {
	        return function ngValueLink(scope, elm, attr) {
	          scope.$watch(attr.ngValue, function valueWatchAction(value) {
	            updateElementValue(elm, attr, value);
	          });
	        };
	      }
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngBind
	 * @restrict AC
	 *
	 * @description
	 * The `ngBind` attribute tells Angular to replace the text content of the specified HTML element
	 * with the value of a given expression, and to update the text content when the value of that
	 * expression changes.
	 *
	 * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
	 * `{{ expression }}` which is similar but less verbose.
	 *
	 * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
	 * displayed by the browser in its raw state before Angular compiles it. Since `ngBind` is an
	 * element attribute, it makes the bindings invisible to the user while the page is loading.
	 *
	 * An alternative solution to this problem would be using the
	 * {@link ng.directive:ngCloak ngCloak} directive.
	 *
	 *
	 * @element ANY
	 * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	 * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
	   <example module="bindExample" name="ng-bind">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.name = 'Whirled';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	         <label>Enter name: <input type="text" ng-model="name"></label><br>
	         Hello <span ng-bind="name"></span>!
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var nameInput = element(by.model('name'));
	
	         expect(element(by.binding('name')).getText()).toBe('Whirled');
	         nameInput.clear();
	         nameInput.sendKeys('world');
	         expect(element(by.binding('name')).getText()).toBe('world');
	       });
	     </file>
	   </example>
	 */
	var ngBindDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'AC',
	    compile: function ngBindCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBind);
	        element = element[0];
	        scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
	          element.textContent = stringify(value);
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindTemplate
	 *
	 * @description
	 * The `ngBindTemplate` directive specifies that the element
	 * text content should be replaced with the interpolation of the template
	 * in the `ngBindTemplate` attribute.
	 * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
	 * expressions. This directive is needed since some HTML elements
	 * (such as TITLE and OPTION) cannot contain SPAN elements.
	 *
	 * @element ANY
	 * @param {string} ngBindTemplate template of form
	 *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
	 *
	 * @example
	 * Try it here: enter text in text box and watch the greeting change.
	   <example module="bindExample" name="ng-bind-template">
	     <file name="index.html">
	       <script>
	         angular.module('bindExample', [])
	           .controller('ExampleController', ['$scope', function($scope) {
	             $scope.salutation = 'Hello';
	             $scope.name = 'World';
	           }]);
	       </script>
	       <div ng-controller="ExampleController">
	        <label>Salutation: <input type="text" ng-model="salutation"></label><br>
	        <label>Name: <input type="text" ng-model="name"></label><br>
	        <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
	       </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind', function() {
	         var salutationElem = element(by.binding('salutation'));
	         var salutationInput = element(by.model('salutation'));
	         var nameInput = element(by.model('name'));
	
	         expect(salutationElem.getText()).toBe('Hello World!');
	
	         salutationInput.clear();
	         salutationInput.sendKeys('Greetings');
	         nameInput.clear();
	         nameInput.sendKeys('user');
	
	         expect(salutationElem.getText()).toBe('Greetings user!');
	       });
	     </file>
	   </example>
	 */
	var ngBindTemplateDirective = ['$interpolate', '$compile', function($interpolate, $compile) {
	  return {
	    compile: function ngBindTemplateCompile(templateElement) {
	      $compile.$$addBindingClass(templateElement);
	      return function ngBindTemplateLink(scope, element, attr) {
	        var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
	        $compile.$$addBindingInfo(element, interpolateFn.expressions);
	        element = element[0];
	        attr.$observe('ngBindTemplate', function(value) {
	          element.textContent = isUndefined(value) ? '' : value;
	        });
	      };
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngBindHtml
	 *
	 * @description
	 * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
	 * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
	 * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
	 * ngSanitize} in your module's dependencies (not in core Angular). In order to use {@link ngSanitize}
	 * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
	 *
	 * You may also bypass sanitization for values you know are safe. To do so, bind to
	 * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
	 * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
	 *
	 * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
	 * will have an exception (instead of an exploit.)
	 *
	 * @element ANY
	 * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
	 *
	 * @example
	
	   <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	        <p ng-bind-html="myHTML"></p>
	       </div>
	     </file>
	
	     <file name="script.js">
	       angular.module('bindHtmlExample', ['ngSanitize'])
	         .controller('ExampleController', ['$scope', function($scope) {
	           $scope.myHTML =
	              'I am an <code>HTML</code>string with ' +
	              '<a href="#">links!</a> and other <em>stuff</em>';
	         }]);
	     </file>
	
	     <file name="protractor.js" type="protractor">
	       it('should check ng-bind-html', function() {
	         expect(element(by.binding('myHTML')).getText()).toBe(
	             'I am an HTMLstring with links! and other stuff');
	       });
	     </file>
	   </example>
	 */
	var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function($sce, $parse, $compile) {
	  return {
	    restrict: 'A',
	    compile: function ngBindHtmlCompile(tElement, tAttrs) {
	      var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
	      var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
	        // Unwrap the value to compare the actual inner safe value, not the wrapper object.
	        return $sce.valueOf(val);
	      });
	      $compile.$$addBindingClass(tElement);
	
	      return function ngBindHtmlLink(scope, element, attr) {
	        $compile.$$addBindingInfo(element, attr.ngBindHtml);
	
	        scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
	          // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
	          var value = ngBindHtmlGetter(scope);
	          element.html($sce.getTrustedHtml(value) || '');
	        });
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngChange
	 *
	 * @description
	 * Evaluate the given expression when the user changes the input.
	 * The expression is evaluated immediately, unlike the JavaScript onchange event
	 * which only triggers at the end of a change (usually, when the user leaves the
	 * form element or presses the return key).
	 *
	 * The `ngChange` expression is only evaluated when a change in the input value causes
	 * a new value to be committed to the model.
	 *
	 * It will not be evaluated:
	 * * if the value returned from the `$parsers` transformation pipeline has not changed
	 * * if the input has continued to be invalid since the model will stay `null`
	 * * if the model is changed programmatically and not by a change to the input value
	 *
	 *
	 * Note, this directive requires `ngModel` to be present.
	 *
	 * @element input
	 * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
	 * in input value.
	 *
	 * @example
	 * <example name="ngChange-directive" module="changeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('changeExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.counter = 0;
	 *           $scope.change = function() {
	 *             $scope.counter++;
	 *           };
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
	 *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
	 *       <label for="ng-change-example2">Confirmed</label><br />
	 *       <tt>debug = {{confirmed}}</tt><br/>
	 *       <tt>counter = {{counter}}</tt><br/>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var counter = element(by.binding('counter'));
	 *     var debug = element(by.binding('confirmed'));
	 *
	 *     it('should evaluate the expression if changing from view', function() {
	 *       expect(counter.getText()).toContain('0');
	 *
	 *       element(by.id('ng-change-example1')).click();
	 *
	 *       expect(counter.getText()).toContain('1');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *
	 *     it('should not evaluate the expression if changing from model', function() {
	 *       element(by.id('ng-change-example2')).click();
	
	 *       expect(counter.getText()).toContain('0');
	 *       expect(debug.getText()).toContain('true');
	 *     });
	 *   </file>
	 * </example>
	 */
	var ngChangeDirective = valueFn({
	  restrict: 'A',
	  require: 'ngModel',
	  link: function(scope, element, attr, ctrl) {
	    ctrl.$viewChangeListeners.push(function() {
	      scope.$eval(attr.ngChange);
	    });
	  }
	});
	
	/* exported
	  ngClassDirective,
	  ngClassEvenDirective,
	  ngClassOddDirective
	*/
	
	function classDirective(name, selector) {
	  name = 'ngClass' + name;
	  var indexWatchExpression;
	
	  return ['$parse', function($parse) {
	    return {
	      restrict: 'AC',
	      link: function(scope, element, attr) {
	        var classCounts = element.data('$classCounts');
	        var oldModulo = true;
	        var oldClassString;
	
	        if (!classCounts) {
	          // Use createMap() to prevent class assumptions involving property
	          // names in Object.prototype
	          classCounts = createMap();
	          element.data('$classCounts', classCounts);
	        }
	
	        if (name !== 'ngClass') {
	          if (!indexWatchExpression) {
	            indexWatchExpression = $parse('$index', function moduloTwo($index) {
	              // eslint-disable-next-line no-bitwise
	              return $index & 1;
	            });
	          }
	
	          scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
	        }
	
	        scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
	
	        function addClasses(classString) {
	          classString = digestClassCounts(split(classString), 1);
	          attr.$addClass(classString);
	        }
	
	        function removeClasses(classString) {
	          classString = digestClassCounts(split(classString), -1);
	          attr.$removeClass(classString);
	        }
	
	        function updateClasses(oldClassString, newClassString) {
	          var oldClassArray = split(oldClassString);
	          var newClassArray = split(newClassString);
	
	          var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
	          var toAddArray = arrayDifference(newClassArray, oldClassArray);
	
	          var toRemoveString = digestClassCounts(toRemoveArray, -1);
	          var toAddString = digestClassCounts(toAddArray, 1);
	
	          attr.$addClass(toAddString);
	          attr.$removeClass(toRemoveString);
	        }
	
	        function digestClassCounts(classArray, count) {
	          var classesToUpdate = [];
	
	          forEach(classArray, function(className) {
	            if (count > 0 || classCounts[className]) {
	              classCounts[className] = (classCounts[className] || 0) + count;
	              if (classCounts[className] === +(count > 0)) {
	                classesToUpdate.push(className);
	              }
	            }
	          });
	
	          return classesToUpdate.join(' ');
	        }
	
	        function ngClassIndexWatchAction(newModulo) {
	          // This watch-action should run before the `ngClassWatchAction()`, thus it
	          // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
	          // `ngClassWatchAction()` will update the classes.
	          if (newModulo === selector) {
	            addClasses(oldClassString);
	          } else {
	            removeClasses(oldClassString);
	          }
	
	          oldModulo = newModulo;
	        }
	
	        function ngClassWatchAction(newClassString) {
	          // When using a one-time binding the newClassString will return
	          // the pre-interceptor value until the one-time is complete
	          if (!isString(newClassString)) {
	            newClassString = toClassString(newClassString);
	          }
	
	          if (oldModulo === selector) {
	            updateClasses(oldClassString, newClassString);
	          }
	
	          oldClassString = newClassString;
	        }
	      }
	    };
	  }];
	
	  // Helpers
	  function arrayDifference(tokens1, tokens2) {
	    if (!tokens1 || !tokens1.length) return [];
	    if (!tokens2 || !tokens2.length) return tokens1;
	
	    var values = [];
	
	    outer:
	    for (var i = 0; i < tokens1.length; i++) {
	      var token = tokens1[i];
	      for (var j = 0; j < tokens2.length; j++) {
	        if (token === tokens2[j]) continue outer;
	      }
	      values.push(token);
	    }
	
	    return values;
	  }
	
	  function split(classString) {
	    return classString && classString.split(' ');
	  }
	
	  function toClassString(classValue) {
	    var classString = classValue;
	
	    if (isArray(classValue)) {
	      classString = classValue.map(toClassString).join(' ');
	    } else if (isObject(classValue)) {
	      classString = Object.keys(classValue).
	        filter(function(key) { return classValue[key]; }).
	        join(' ');
	    }
	
	    return classString;
	  }
	}
	
	/**
	 * @ngdoc directive
	 * @name ngClass
	 * @restrict AC
	 *
	 * @description
	 * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
	 * an expression that represents all classes to be added.
	 *
	 * The directive operates in three different ways, depending on which of three types the expression
	 * evaluates to:
	 *
	 * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
	 * names.
	 *
	 * 2. If the expression evaluates to an object, then for each key-value pair of the
	 * object with a truthy value the corresponding key is used as a class name.
	 *
	 * 3. If the expression evaluates to an array, each element of the array should either be a string as in
	 * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
	 * to give you more control over what CSS classes appear. See the code below for an example of this.
	 *
	 *
	 * The directive won't add duplicate classes if a particular class was already set.
	 *
	 * When the expression changes, the previously added classes are removed and only then are the
	 * new classes added.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `class`
	 * attribute, when using the `ngClass` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
	 * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
	 *
	 * @element ANY
	 * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class
	 *   names, an array, or a map of class names to boolean values. In the case of a map, the
	 *   names of the properties whose values are truthy will be added as css classes to the
	 *   element.
	 *
	 * @example Example that demonstrates basic bindings via ngClass directive.
	   <example name="ng-class">
	     <file name="index.html">
	       <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
	       <label>
	          <input type="checkbox" ng-model="deleted">
	          deleted (apply "strike" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="important">
	          important (apply "bold" class)
	       </label><br>
	       <label>
	          <input type="checkbox" ng-model="error">
	          error (apply "has-error" class)
	       </label>
	       <hr>
	       <p ng-class="style">Using String Syntax</p>
	       <input type="text" ng-model="style"
	              placeholder="Type: bold strike red" aria-label="Type: bold strike red">
	       <hr>
	       <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
	       <input ng-model="style1"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
	       <input ng-model="style2"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
	       <input ng-model="style3"
	              placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
	       <hr>
	       <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
	       <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
	       <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
	     </file>
	     <file name="style.css">
	       .strike {
	           text-decoration: line-through;
	       }
	       .bold {
	           font-weight: bold;
	       }
	       .red {
	           color: red;
	       }
	       .has-error {
	           color: red;
	           background-color: yellow;
	       }
	       .orange {
	           color: orange;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var ps = element.all(by.css('p'));
	
	       it('should let you toggle the class', function() {
	
	         expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
	         expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
	
	         element(by.model('important')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/bold/);
	
	         element(by.model('error')).click();
	         expect(ps.first().getAttribute('class')).toMatch(/has-error/);
	       });
	
	       it('should let you toggle string example', function() {
	         expect(ps.get(1).getAttribute('class')).toBe('');
	         element(by.model('style')).clear();
	         element(by.model('style')).sendKeys('red');
	         expect(ps.get(1).getAttribute('class')).toBe('red');
	       });
	
	       it('array example should have 3 classes', function() {
	         expect(ps.get(2).getAttribute('class')).toBe('');
	         element(by.model('style1')).sendKeys('bold');
	         element(by.model('style2')).sendKeys('strike');
	         element(by.model('style3')).sendKeys('red');
	         expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
	       });
	
	       it('array with map example should have 2 classes', function() {
	         expect(ps.last().getAttribute('class')).toBe('');
	         element(by.model('style4')).sendKeys('bold');
	         element(by.model('warning')).click();
	         expect(ps.last().getAttribute('class')).toBe('bold orange');
	       });
	     </file>
	   </example>
	
	   ## Animations
	
	   The example below demonstrates how to perform animations using ngClass.
	
	   <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
	     <file name="index.html">
	      <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
	      <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
	      <br>
	      <span class="base-class" ng-class="myVar">Sample Text</span>
	     </file>
	     <file name="style.css">
	       .base-class {
	         transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	       }
	
	       .base-class.my-class {
	         color: red;
	         font-size:3em;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class', function() {
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	
	         element(by.id('setbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).
	           toMatch(/my-class/);
	
	         element(by.id('clearbtn')).click();
	
	         expect(element(by.css('.base-class')).getAttribute('class')).not.
	           toMatch(/my-class/);
	       });
	     </file>
	   </example>
	
	
	   ## ngClass and pre-existing CSS3 Transitions/Animations
	   The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
	   Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
	   any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
	   to view the step by step details of {@link $animate#addClass $animate.addClass} and
	   {@link $animate#removeClass $animate.removeClass}.
	 */
	var ngClassDirective = classDirective('', true);
	
	/**
	 * @ngdoc directive
	 * @name ngClassOdd
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
	 *   of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-odd">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}}
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassOddDirective = classDirective('Odd', 0);
	
	/**
	 * @ngdoc directive
	 * @name ngClassEven
	 * @restrict AC
	 *
	 * @description
	 * The `ngClassOdd` and `ngClassEven` directives work exactly as
	 * {@link ng.directive:ngClass ngClass}, except they work in
	 * conjunction with `ngRepeat` and take effect only on odd (even) rows.
	 *
	 * This directive can be applied only within the scope of an
	 * {@link ng.directive:ngRepeat ngRepeat}.
	 *
	 * @element ANY
	 * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
	 *   result of the evaluation can be a string representing space delimited class names or an array.
	 *
	 * @example
	   <example name="ng-class-even">
	     <file name="index.html">
	        <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
	          <li ng-repeat="name in names">
	           <span ng-class-odd="'odd'" ng-class-even="'even'">
	             {{name}} &nbsp; &nbsp; &nbsp;
	           </span>
	          </li>
	        </ol>
	     </file>
	     <file name="style.css">
	       .odd {
	         color: red;
	       }
	       .even {
	         color: blue;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-class-odd and ng-class-even', function() {
	         expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
	           toMatch(/odd/);
	         expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
	           toMatch(/even/);
	       });
	     </file>
	   </example>
	 */
	var ngClassEvenDirective = classDirective('Even', 1);
	
	/**
	 * @ngdoc directive
	 * @name ngCloak
	 * @restrict AC
	 *
	 * @description
	 * The `ngCloak` directive is used to prevent the Angular html template from being briefly
	 * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
	 * directive to avoid the undesirable flicker effect caused by the html template display.
	 *
	 * The directive can be applied to the `<body>` element, but the preferred usage is to apply
	 * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
	 * of the browser view.
	 *
	 * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
	 * `angular.min.js`.
	 * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```css
	 * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
	 *   display: none !important;
	 * }
	 * ```
	 *
	 * When this css rule is loaded by the browser, all html elements (including their children) that
	 * are tagged with the `ngCloak` directive are hidden. When Angular encounters this directive
	 * during the compilation of the template it deletes the `ngCloak` element attribute, making
	 * the compiled element visible.
	 *
	 * For the best result, the `angular.js` script must be loaded in the head section of the html
	 * document; alternatively, the css rule above must be included in the external stylesheet of the
	 * application.
	 *
	 * @element ANY
	 *
	 * @example
	   <example name="ng-cloak">
	     <file name="index.html">
	        <div id="template1" ng-cloak>{{ 'hello' }}</div>
	        <div id="template2" class="ng-cloak">{{ 'world' }}</div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should remove the template directive and css class', function() {
	         expect($('#template1').getAttribute('ng-cloak')).
	           toBeNull();
	         expect($('#template2').getAttribute('ng-cloak')).
	           toBeNull();
	       });
	     </file>
	   </example>
	 *
	 */
	var ngCloakDirective = ngDirective({
	  compile: function(element, attr) {
	    attr.$set('ngCloak', undefined);
	    element.removeClass('ng-cloak');
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngController
	 *
	 * @description
	 * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
	 * supports the principles behind the Model-View-Controller design pattern.
	 *
	 * MVC components in angular:
	 *
	 * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
	 *   are accessed through bindings.
	 * * View — The template (HTML with data bindings) that is rendered into the View.
	 * * Controller — The `ngController` directive specifies a Controller class; the class contains business
	 *   logic behind the application to decorate the scope with functions and values
	 *
	 * Note that you can also attach controllers to the DOM by declaring it in a route definition
	 * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
	 * again using `ng-controller` in the template itself.  This will cause the controller to be attached
	 * and executed twice.
	 *
	 * @element ANY
	 * @scope
	 * @priority 500
	 * @param {expression} ngController Name of a constructor function registered with the current
	 * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
	 * that on the current scope evaluates to a constructor function.
	 *
	 * The controller instance can be published into a scope property by specifying
	 * `ng-controller="as propertyName"`.
	 *
	 * If the current `$controllerProvider` is configured to use globals (via
	 * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
	 * also be the name of a globally accessible constructor function (deprecated, not recommended).
	 *
	 * @example
	 * Here is a simple form for editing user contact information. Adding, removing, clearing, and
	 * greeting are methods declared on the controller (see source tab). These methods can
	 * easily be called from the angular markup. Any changes to the data are automatically reflected
	 * in the View without the need for a manual update.
	 *
	 * Two different declaration styles are included below:
	 *
	 * * one binds methods and properties directly onto the controller using `this`:
	 * `ng-controller="SettingsController1 as settings"`
	 * * one injects `$scope` into the controller:
	 * `ng-controller="SettingsController2"`
	 *
	 * The second option is more common in the Angular community, and is generally used in boilerplates
	 * and in this guide. However, there are advantages to binding properties directly to the controller
	 * and avoiding scope.
	 *
	 * * Using `controller as` makes it obvious which controller you are accessing in the template when
	 * multiple controllers apply to an element.
	 * * If you are writing your controllers as classes you have easier access to the properties and
	 * methods, which will appear on the scope, from inside the controller code.
	 * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
	 * inheritance masking primitives.
	 *
	 * This example demonstrates the `controller as` syntax.
	 *
	 * <example name="ngControllerAs" module="controllerAsExample">
	 *   <file name="index.html">
	 *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
	 *      <label>Name: <input type="text" ng-model="settings.name"/></label>
	 *      <button ng-click="settings.greet()">greet</button><br/>
	 *      Contact:
	 *      <ul>
	 *        <li ng-repeat="contact in settings.contacts">
	 *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
	 *             <option>phone</option>
	 *             <option>email</option>
	 *          </select>
	 *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *          <button ng-click="settings.clearContact(contact)">clear</button>
	 *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
	 *        </li>
	 *        <li><button ng-click="settings.addContact()">add</button></li>
	 *     </ul>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('controllerAsExample', [])
	 *      .controller('SettingsController1', SettingsController1);
	 *
	 *    function SettingsController1() {
	 *      this.name = 'John Smith';
	 *      this.contacts = [
	 *        {type: 'phone', value: '408 555 1212'},
	 *        {type: 'email', value: 'john.smith@example.org'}
	 *      ];
	 *    }
	 *
	 *    SettingsController1.prototype.greet = function() {
	 *      alert(this.name);
	 *    };
	 *
	 *    SettingsController1.prototype.addContact = function() {
	 *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
	 *    };
	 *
	 *    SettingsController1.prototype.removeContact = function(contactToRemove) {
	 *     var index = this.contacts.indexOf(contactToRemove);
	 *      this.contacts.splice(index, 1);
	 *    };
	 *
	 *    SettingsController1.prototype.clearContact = function(contact) {
	 *      contact.type = 'phone';
	 *      contact.value = '';
	 *    };
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should check controller as', function() {
	 *       var container = element(by.id('ctrl-as-exmpl'));
	 *         expect(container.element(by.model('settings.name'))
	 *           .getAttribute('value')).toBe('John Smith');
	 *
	 *       var firstRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(0));
	 *       var secondRepeat =
	 *           container.element(by.repeater('contact in settings.contacts').row(1));
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('408 555 1212');
	 *
	 *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('john.smith@example.org');
	 *
	 *       firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *           .toBe('');
	 *
	 *       container.element(by.buttonText('add')).click();
	 *
	 *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
	 *           .element(by.model('contact.value'))
	 *           .getAttribute('value'))
	 *           .toBe('yourname@example.org');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * This example demonstrates the "attach to `$scope`" style of controller.
	 *
	 * <example name="ngController" module="controllerExample">
	 *  <file name="index.html">
	 *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
	 *     <label>Name: <input type="text" ng-model="name"/></label>
	 *     <button ng-click="greet()">greet</button><br/>
	 *     Contact:
	 *     <ul>
	 *       <li ng-repeat="contact in contacts">
	 *         <select ng-model="contact.type" id="select_{{$index}}">
	 *            <option>phone</option>
	 *            <option>email</option>
	 *         </select>
	 *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
	 *         <button ng-click="clearContact(contact)">clear</button>
	 *         <button ng-click="removeContact(contact)">X</button>
	 *       </li>
	 *       <li>[ <button ng-click="addContact()">add</button> ]</li>
	 *    </ul>
	 *   </div>
	 *  </file>
	 *  <file name="app.js">
	 *   angular.module('controllerExample', [])
	 *     .controller('SettingsController2', ['$scope', SettingsController2]);
	 *
	 *   function SettingsController2($scope) {
	 *     $scope.name = 'John Smith';
	 *     $scope.contacts = [
	 *       {type:'phone', value:'408 555 1212'},
	 *       {type:'email', value:'john.smith@example.org'}
	 *     ];
	 *
	 *     $scope.greet = function() {
	 *       alert($scope.name);
	 *     };
	 *
	 *     $scope.addContact = function() {
	 *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
	 *     };
	 *
	 *     $scope.removeContact = function(contactToRemove) {
	 *       var index = $scope.contacts.indexOf(contactToRemove);
	 *       $scope.contacts.splice(index, 1);
	 *     };
	 *
	 *     $scope.clearContact = function(contact) {
	 *       contact.type = 'phone';
	 *       contact.value = '';
	 *     };
	 *   }
	 *  </file>
	 *  <file name="protractor.js" type="protractor">
	 *    it('should check controller', function() {
	 *      var container = element(by.id('ctrl-exmpl'));
	 *
	 *      expect(container.element(by.model('name'))
	 *          .getAttribute('value')).toBe('John Smith');
	 *
	 *      var firstRepeat =
	 *          container.element(by.repeater('contact in contacts').row(0));
	 *      var secondRepeat =
	 *          container.element(by.repeater('contact in contacts').row(1));
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('408 555 1212');
	 *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('john.smith@example.org');
	 *
	 *      firstRepeat.element(by.buttonText('clear')).click();
	 *
	 *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
	 *          .toBe('');
	 *
	 *      container.element(by.buttonText('add')).click();
	 *
	 *      expect(container.element(by.repeater('contact in contacts').row(2))
	 *          .element(by.model('contact.value'))
	 *          .getAttribute('value'))
	 *          .toBe('yourname@example.org');
	 *    });
	 *  </file>
	 *</example>
	
	 */
	var ngControllerDirective = [function() {
	  return {
	    restrict: 'A',
	    scope: true,
	    controller: '@',
	    priority: 500
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngCsp
	 *
	 * @restrict A
	 * @element ANY
	 * @description
	 *
	 * Angular has some features that can conflict with certain restrictions that are applied when using
	 * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
	 *
	 * If you intend to implement CSP with these rules then you must tell Angular not to use these
	 * features.
	 *
	 * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
	 *
	 *
	 * The following default rules in CSP affect Angular:
	 *
	 * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
	 * code from strings is forbidden. Angular makes use of this in the {@link $parse} service to
	 * provide a 30% increase in the speed of evaluating Angular expressions. (This CSP rule can be
	 * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
	 * weaken the protections offered by CSP.)
	 *
	 * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
	 * This prevents apps from injecting custom styles directly into the document. Angular makes use of
	 * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
	 * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
	 * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
	 * it is generally not recommended as it would weaken the protections offered by CSP.)
	 *
	 * If you do not provide `ngCsp` then Angular tries to autodetect if CSP is blocking dynamic code
	 * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
	 * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
	 * CSP error to be logged in the console:
	 *
	 * ```
	 * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
	 * script in the following Content Security Policy directive: "default-src 'self'". Note that
	 * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
	 * ```
	 *
	 * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
	 * directive on an element of the HTML document that appears before the `<script>` tag that loads
	 * the `angular.js` file.
	 *
	 * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
	 *
	 * You can specify which of the CSP related Angular features should be deactivated by providing
	 * a value for the `ng-csp` attribute. The options are as follows:
	 *
	 * * no-inline-style: this stops Angular from injecting CSS styles into the DOM
	 *
	 * * no-unsafe-eval: this stops Angular from optimizing $parse with unsafe eval of strings
	 *
	 * You can use these values in the following combinations:
	 *
	 *
	 * * No declaration means that Angular will assume that you can do inline styles, but it will do
	 * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell Angular to deactivate both inline
	 * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
	 * versions of Angular.
	 *
	 * * Specifying only `no-unsafe-eval` tells Angular that we must not use eval, but that we can
	 * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
	 *
	 * * Specifying only `no-inline-style` tells Angular that we must not inject styles, but that we can
	 * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
	 *
	 * * Specifying both `no-unsafe-eval` and `no-inline-style` tells Angular that we must not inject
	 * styles nor use eval, which is the same as an empty: ng-csp.
	 * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
	 *
	 * @example
	 * This example shows how to apply the `ngCsp` directive to the `html` tag.
	   ```html
	     <!doctype html>
	     <html ng-app ng-csp>
	     ...
	     ...
	     </html>
	   ```
	  * @example
	      <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
	      <example name="example.csp" module="cspExample" ng-csp="true">
	        <file name="index.html">
	          <div ng-controller="MainController as ctrl">
	            <div>
	              <button ng-click="ctrl.inc()" id="inc">Increment</button>
	              <span id="counter">
	                {{ctrl.counter}}
	              </span>
	            </div>
	
	            <div>
	              <button ng-click="ctrl.evil()" id="evil">Evil</button>
	              <span id="evilError">
	                {{ctrl.evilError}}
	              </span>
	            </div>
	          </div>
	        </file>
	        <file name="script.js">
	           angular.module('cspExample', [])
	             .controller('MainController', function MainController() {
	                this.counter = 0;
	                this.inc = function() {
	                  this.counter++;
	                };
	                this.evil = function() {
	                  try {
	                    eval('1+2'); // eslint-disable-line no-eval
	                  } catch (e) {
	                    this.evilError = e.message;
	                  }
	                };
	              });
	        </file>
	        <file name="protractor.js" type="protractor">
	          var util, webdriver;
	
	          var incBtn = element(by.id('inc'));
	          var counter = element(by.id('counter'));
	          var evilBtn = element(by.id('evil'));
	          var evilError = element(by.id('evilError'));
	
	          function getAndClearSevereErrors() {
	            return browser.manage().logs().get('browser').then(function(browserLog) {
	              return browserLog.filter(function(logEntry) {
	                return logEntry.level.value > webdriver.logging.Level.WARNING.value;
	              });
	            });
	          }
	
	          function clearErrors() {
	            getAndClearSevereErrors();
	          }
	
	          function expectNoErrors() {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              expect(filteredLog.length).toEqual(0);
	              if (filteredLog.length) {
	                console.log('browser console errors: ' + util.inspect(filteredLog));
	              }
	            });
	          }
	
	          function expectError(regex) {
	            getAndClearSevereErrors().then(function(filteredLog) {
	              var found = false;
	              filteredLog.forEach(function(log) {
	                if (log.message.match(regex)) {
	                  found = true;
	                }
	              });
	              if (!found) {
	                throw new Error('expected an error that matches ' + regex);
	              }
	            });
	          }
	
	          beforeEach(function() {
	            util = require('util');
	            webdriver = require('selenium-webdriver');
	          });
	
	          // For now, we only test on Chrome,
	          // as Safari does not load the page with Protractor's injected scripts,
	          // and Firefox webdriver always disables content security policy (#6358)
	          if (browser.params.browser !== 'chrome') {
	            return;
	          }
	
	          it('should not report errors when the page is loaded', function() {
	            // clear errors so we are not dependent on previous tests
	            clearErrors();
	            // Need to reload the page as the page is already loaded when
	            // we come here
	            browser.driver.getCurrentUrl().then(function(url) {
	              browser.get(url);
	            });
	            expectNoErrors();
	          });
	
	          it('should evaluate expressions', function() {
	            expect(counter.getText()).toEqual('0');
	            incBtn.click();
	            expect(counter.getText()).toEqual('1');
	            expectNoErrors();
	          });
	
	          it('should throw and report an error when using "eval"', function() {
	            evilBtn.click();
	            expect(evilError.getText()).toMatch(/Content Security Policy/);
	            expectError(/Content Security Policy/);
	          });
	        </file>
	      </example>
	  */
	
	// `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
	// we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
	// fn that looks for the `ng-csp` attribute anywhere in the current doc.
	
	/**
	 * @ngdoc directive
	 * @name ngClick
	 *
	 * @description
	 * The ngClick directive allows you to specify custom behavior when
	 * an element is clicked.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
	 * click. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-click">
	     <file name="index.html">
	      <button ng-click="count = count + 1" ng-init="count=0">
	        Increment
	      </button>
	      <span>
	        count: {{count}}
	      </span>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-click', function() {
	         expect(element(by.binding('count')).getText()).toMatch('0');
	         element(by.css('button')).click();
	         expect(element(by.binding('count')).getText()).toMatch('1');
	       });
	     </file>
	   </example>
	 */
	/*
	 * A collection of directives that allows creation of custom event handlers that are defined as
	 * angular expressions and are compiled and executed within the current scope.
	 */
	var ngEventDirectives = {};
	
	// For events that might fire synchronously during DOM manipulation
	// we need to execute their event handlers asynchronously using $evalAsync,
	// so that they are not executed in an inconsistent state.
	var forceAsyncEvents = {
	  'blur': true,
	  'focus': true
	};
	forEach(
	  'click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '),
	  function(eventName) {
	    var directiveName = directiveNormalize('ng-' + eventName);
	    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function($parse, $rootScope) {
	      return {
	        restrict: 'A',
	        compile: function($element, attr) {
	          // NOTE:
	          // We expose the powerful `$event` object on the scope that provides access to the Window,
	          // etc. This is OK, because expressions are not sandboxed any more (and the expression
	          // sandbox was never meant to be a security feature anyway).
	          var fn = $parse(attr[directiveName]);
	          return function ngEventHandler(scope, element) {
	            element.on(eventName, function(event) {
	              var callback = function() {
	                fn(scope, {$event: event});
	              };
	              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
	                scope.$evalAsync(callback);
	              } else {
	                scope.$apply(callback);
	              }
	            });
	          };
	        }
	      };
	    }];
	  }
	);
	
	/**
	 * @ngdoc directive
	 * @name ngDblclick
	 *
	 * @description
	 * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
	 * a dblclick. (The Event object is available as `$event`)
	 *
	 * @example
	   <example name="ng-dblclick">
	     <file name="index.html">
	      <button ng-dblclick="count = count + 1" ng-init="count=0">
	        Increment (on double click)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousedown
	 *
	 * @description
	 * The ngMousedown directive allows you to specify custom behavior on mousedown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
	 * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousedown">
	     <file name="index.html">
	      <button ng-mousedown="count = count + 1" ng-init="count=0">
	        Increment (on mouse down)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseup
	 *
	 * @description
	 * Specify custom behavior on mouseup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
	 * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseup">
	     <file name="index.html">
	      <button ng-mouseup="count = count + 1" ng-init="count=0">
	        Increment (on mouse up)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngMouseover
	 *
	 * @description
	 * Specify custom behavior on mouseover event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
	 * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseover">
	     <file name="index.html">
	      <button ng-mouseover="count = count + 1" ng-init="count=0">
	        Increment (when mouse is over)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseenter
	 *
	 * @description
	 * Specify custom behavior on mouseenter event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
	 * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseenter">
	     <file name="index.html">
	      <button ng-mouseenter="count = count + 1" ng-init="count=0">
	        Increment (when mouse enters)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMouseleave
	 *
	 * @description
	 * Specify custom behavior on mouseleave event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
	 * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mouseleave">
	     <file name="index.html">
	      <button ng-mouseleave="count = count + 1" ng-init="count=0">
	        Increment (when mouse leaves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngMousemove
	 *
	 * @description
	 * Specify custom behavior on mousemove event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
	 * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-mousemove">
	     <file name="index.html">
	      <button ng-mousemove="count = count + 1" ng-init="count=0">
	        Increment (when mouse moves)
	      </button>
	      count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeydown
	 *
	 * @description
	 * Specify custom behavior on keydown event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
	 * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keydown">
	     <file name="index.html">
	      <input ng-keydown="count = count + 1" ng-init="count=0">
	      key down count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeyup
	 *
	 * @description
	 * Specify custom behavior on keyup event.
	 *
	 * @element ANY
	 * @priority 0
	 * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
	 * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keyup">
	     <file name="index.html">
	       <p>Typing in the input box below updates the key count</p>
	       <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
	
	       <p>Typing in the input box below updates the keycode</p>
	       <input ng-keyup="event=$event">
	       <p>event keyCode: {{ event.keyCode }}</p>
	       <p>event altKey: {{ event.altKey }}</p>
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngKeypress
	 *
	 * @description
	 * Specify custom behavior on keypress event.
	 *
	 * @element ANY
	 * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
	 * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
	 * and can be interrogated for keyCode, altKey, etc.)
	 *
	 * @example
	   <example name="ng-keypress">
	     <file name="index.html">
	      <input ng-keypress="count = count + 1" ng-init="count=0">
	      key press count: {{count}}
	     </file>
	   </example>
	 */
	
	
	/**
	 * @ngdoc directive
	 * @name ngSubmit
	 *
	 * @description
	 * Enables binding angular expressions to onsubmit events.
	 *
	 * Additionally it prevents the default action (which for form means sending the request to the
	 * server and reloading the current page), but only if the form does not contain `action`,
	 * `data-action`, or `x-action` attributes.
	 *
	 * <div class="alert alert-warning">
	 * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
	 * `ngSubmit` handlers together. See the
	 * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
	 * for a detailed discussion of when `ngSubmit` may be triggered.
	 * </div>
	 *
	 * @element form
	 * @priority 0
	 * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
	 * ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example module="submitExample" name="ng-submit">
	     <file name="index.html">
	      <script>
	        angular.module('submitExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.list = [];
	            $scope.text = 'hello';
	            $scope.submit = function() {
	              if ($scope.text) {
	                $scope.list.push(this.text);
	                $scope.text = '';
	              }
	            };
	          }]);
	      </script>
	      <form ng-submit="submit()" ng-controller="ExampleController">
	        Enter text and hit enter:
	        <input type="text" ng-model="text" name="text" />
	        <input type="submit" id="submit" value="Submit" />
	        <pre>list={{list}}</pre>
	      </form>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should check ng-submit', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	         expect(element(by.model('text')).getAttribute('value')).toBe('');
	       });
	       it('should ignore empty strings', function() {
	         expect(element(by.binding('list')).getText()).toBe('list=[]');
	         element(by.css('#submit')).click();
	         element(by.css('#submit')).click();
	         expect(element(by.binding('list')).getText()).toContain('hello');
	        });
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngFocus
	 *
	 * @description
	 * Specify custom behavior on focus event.
	 *
	 * Note: As the `focus` event is executed synchronously when calling `input.focus()`
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
	 * focus. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngBlur
	 *
	 * @description
	 * Specify custom behavior on blur event.
	 *
	 * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
	 * an element has lost focus.
	 *
	 * Note: As the `blur` event is executed synchronously also during DOM manipulations
	 * (e.g. removing a focussed input),
	 * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
	 * during an `$apply` to ensure a consistent state.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
	 * blur. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	 * See {@link ng.directive:ngClick ngClick}
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCopy
	 *
	 * @description
	 * Specify custom behavior on copy event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
	 * copy. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-copy">
	     <file name="index.html">
	      <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
	      copied: {{copied}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngCut
	 *
	 * @description
	 * Specify custom behavior on cut event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
	 * cut. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-cut">
	     <file name="index.html">
	      <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
	      cut: {{cut}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngPaste
	 *
	 * @description
	 * Specify custom behavior on paste event.
	 *
	 * @element window, input, select, textarea, a
	 * @priority 0
	 * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
	 * paste. ({@link guide/expression#-event- Event object is available as `$event`})
	 *
	 * @example
	   <example name="ng-paste">
	     <file name="index.html">
	      <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
	      pasted: {{paste}}
	     </file>
	   </example>
	 */
	
	/**
	 * @ngdoc directive
	 * @name ngIf
	 * @restrict A
	 * @multiElement
	 *
	 * @description
	 * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
	 * {expression}. If the expression assigned to `ngIf` evaluates to a false
	 * value then the element is removed from the DOM, otherwise a clone of the
	 * element is reinserted into the DOM.
	 *
	 * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
	 * element in the DOM rather than changing its visibility via the `display` css property.  A common
	 * case when this difference is significant is when using css selectors that rely on an element's
	 * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
	 *
	 * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
	 * is created when the element is restored.  The scope created within `ngIf` inherits from
	 * its parent scope using
	 * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
	 * An important implication of this is if `ngModel` is used within `ngIf` to bind to
	 * a javascript primitive defined in the parent scope. In this case any modifications made to the
	 * variable within the child scope will override (hide) the value in the parent scope.
	 *
	 * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
	 * is if an element's class attribute is directly modified after it's compiled, using something like
	 * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
	 * the added class will be lost because the original compiled state is used to regenerate the element.
	 *
	 * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
	 * and `leave` effects.
	 *
	 * @animations
	 * | Animation                        | Occurs                               |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
	 * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
	 *
	 * @element ANY
	 * @scope
	 * @priority 600
	 * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
	 *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
	 *     element is added to the DOM tree.
	 *
	 * @example
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
	    <file name="index.html">
	      <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
	      Show when checked:
	      <span ng-if="checked" class="animate-if">
	        This is removed when the checkbox is unchecked.
	      </span>
	    </file>
	    <file name="animations.css">
	      .animate-if {
	        background:white;
	        border:1px solid black;
	        padding:10px;
	      }
	
	      .animate-if.ng-enter, .animate-if.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	      }
	
	      .animate-if.ng-enter,
	      .animate-if.ng-leave.ng-leave-active {
	        opacity:0;
	      }
	
	      .animate-if.ng-leave,
	      .animate-if.ng-enter.ng-enter-active {
	        opacity:1;
	      }
	    </file>
	  </example>
	 */
	var ngIfDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    multiElement: true,
	    transclude: 'element',
	    priority: 600,
	    terminal: true,
	    restrict: 'A',
	    $$tlb: true,
	    link: function($scope, $element, $attr, ctrl, $transclude) {
	        var block, childScope, previousElements;
	        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
	
	          if (value) {
	            if (!childScope) {
	              $transclude(function(clone, newScope) {
	                childScope = newScope;
	                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block = {
	                  clone: clone
	                };
	                $animate.enter(clone, $element.parent(), $element);
	              });
	            }
	          } else {
	            if (previousElements) {
	              previousElements.remove();
	              previousElements = null;
	            }
	            if (childScope) {
	              childScope.$destroy();
	              childScope = null;
	            }
	            if (block) {
	              previousElements = getBlockNodes(block.clone);
	              $animate.leave(previousElements).done(function(response) {
	                if (response !== false) previousElements = null;
	              });
	              block = null;
	            }
	          }
	        });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngInclude
	 * @restrict ECA
	 *
	 * @description
	 * Fetches, compiles and includes an external HTML fragment.
	 *
	 * By default, the template URL is restricted to the same domain and protocol as the
	 * application document. This is done by calling {@link $sce#getTrustedResourceUrl
	 * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
	 * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
	 * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to Angular's {@link
	 * ng.$sce Strict Contextual Escaping}.
	 *
	 * In addition, the browser's
	 * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
	 * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
	 * policy may further restrict whether the template is successfully loaded.
	 * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
	 * access on some browsers.
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
	 * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
	 *
	 * The enter and leave animation occur concurrently.
	 *
	 * @scope
	 * @priority 400
	 *
	 * @param {string} ngInclude|src angular expression evaluating to URL. If the source is a string constant,
	 *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
	 * @param {string=} onload Expression to evaluate when a new partial is loaded.
	 *                  <div class="alert alert-warning">
	 *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
	 *                  a function with the name on the window element, which will usually throw a
	 *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
	 *                  different form that {@link guide/directive#normalization matches} `onload`.
	 *                  </div>
	   *
	 * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
	 *                  $anchorScroll} to scroll the viewport after the content is loaded.
	 *
	 *                  - If the attribute is not set, disable scrolling.
	 *                  - If the attribute is set without value, enable scrolling.
	 *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
	 *
	 * @example
	  <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
	    <file name="index.html">
	     <div ng-controller="ExampleController">
	       <select ng-model="template" ng-options="t.name for t in templates">
	        <option value="">(blank)</option>
	       </select>
	       url of the template: <code>{{template.url}}</code>
	       <hr/>
	       <div class="slide-animate-container">
	         <div class="slide-animate" ng-include="template.url"></div>
	       </div>
	     </div>
	    </file>
	    <file name="script.js">
	      angular.module('includeExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.templates =
	            [{ name: 'template1.html', url: 'template1.html'},
	             { name: 'template2.html', url: 'template2.html'}];
	          $scope.template = $scope.templates[0];
	        }]);
	     </file>
	    <file name="template1.html">
	      Content of template1.html
	    </file>
	    <file name="template2.html">
	      Content of template2.html
	    </file>
	    <file name="animations.css">
	      .slide-animate-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .slide-animate {
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter, .slide-animate.ng-leave {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	        display:block;
	        padding:10px;
	      }
	
	      .slide-animate.ng-enter {
	        top:-50px;
	      }
	      .slide-animate.ng-enter.ng-enter-active {
	        top:0;
	      }
	
	      .slide-animate.ng-leave {
	        top:0;
	      }
	      .slide-animate.ng-leave.ng-leave-active {
	        top:50px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var templateSelect = element(by.model('template'));
	      var includeElem = element(by.css('[ng-include]'));
	
	      it('should load template1.html', function() {
	        expect(includeElem.getText()).toMatch(/Content of template1.html/);
	      });
	
	      it('should load template2.html', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          // See https://github.com/angular/protractor/issues/480
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(2).click();
	        expect(includeElem.getText()).toMatch(/Content of template2.html/);
	      });
	
	      it('should change to blank', function() {
	        if (browser.params.browser === 'firefox') {
	          // Firefox can't handle using selects
	          return;
	        }
	        templateSelect.click();
	        templateSelect.all(by.css('option')).get(0).click();
	        expect(includeElem.isPresent()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentRequested
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted every time the ngInclude content is requested.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentLoaded
	 * @eventType emit on the current ngInclude scope
	 * @description
	 * Emitted every time the ngInclude content is reloaded.
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	
	
	/**
	 * @ngdoc event
	 * @name ngInclude#$includeContentError
	 * @eventType emit on the scope ngInclude was declared in
	 * @description
	 * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
	 *
	 * @param {Object} angularEvent Synthetic event object.
	 * @param {String} src URL of content to load.
	 */
	var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate',
	                  function($templateRequest,   $anchorScroll,   $animate) {
	  return {
	    restrict: 'ECA',
	    priority: 400,
	    terminal: true,
	    transclude: 'element',
	    controller: angular.noop,
	    compile: function(element, attr) {
	      var srcExp = attr.ngInclude || attr.src,
	          onloadExp = attr.onload || '',
	          autoScrollExp = attr.autoscroll;
	
	      return function(scope, $element, $attr, ctrl, $transclude) {
	        var changeCounter = 0,
	            currentScope,
	            previousElement,
	            currentElement;
	
	        var cleanupLastIncludeContent = function() {
	          if (previousElement) {
	            previousElement.remove();
	            previousElement = null;
	          }
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	          if (currentElement) {
	            $animate.leave(currentElement).done(function(response) {
	              if (response !== false) previousElement = null;
	            });
	            previousElement = currentElement;
	            currentElement = null;
	          }
	        };
	
	        scope.$watch(srcExp, function ngIncludeWatchAction(src) {
	          var afterAnimation = function(response) {
	            if (response !== false && isDefined(autoScrollExp) &&
	              (!autoScrollExp || scope.$eval(autoScrollExp))) {
	                $anchorScroll();
	            }
	          };
	          var thisChangeId = ++changeCounter;
	
	          if (src) {
	            //set the 2nd param to true to ignore the template request error so that the inner
	            //contents and scope can be cleaned up.
	            $templateRequest(src, true).then(function(response) {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId !== changeCounter) return;
	              var newScope = scope.$new();
	              ctrl.template = response;
	
	              // Note: This will also link all children of ng-include that were contained in the original
	              // html. If that content contains controllers, ... they could pollute/change the scope.
	              // However, using ng-include on an element with additional content does not make sense...
	              // Note: We can't remove them in the cloneAttchFn of $transclude as that
	              // function is called before linking the content, which would apply child
	              // directives to non existing elements.
	              var clone = $transclude(newScope, function(clone) {
	                cleanupLastIncludeContent();
	                $animate.enter(clone, null, $element).done(afterAnimation);
	              });
	
	              currentScope = newScope;
	              currentElement = clone;
	
	              currentScope.$emit('$includeContentLoaded', src);
	              scope.$eval(onloadExp);
	            }, function() {
	              if (scope.$$destroyed) return;
	
	              if (thisChangeId === changeCounter) {
	                cleanupLastIncludeContent();
	                scope.$emit('$includeContentError', src);
	              }
	            });
	            scope.$emit('$includeContentRequested', src);
	          } else {
	            cleanupLastIncludeContent();
	            ctrl.template = null;
	          }
	        });
	      };
	    }
	  };
	}];
	
	// This directive is called during the $transclude call of the first `ngInclude` directive.
	// It will replace and compile the content of the element with the loaded template.
	// We need this directive so that the element content is already filled when
	// the link function of another directive on the same element as ngInclude
	// is called.
	var ngIncludeFillContentDirective = ['$compile',
	  function($compile) {
	    return {
	      restrict: 'ECA',
	      priority: -400,
	      require: 'ngInclude',
	      link: function(scope, $element, $attr, ctrl) {
	        if (toString.call($element[0]).match(/SVG/)) {
	          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
	          // support innerHTML, so detect this here and try to generate the contents
	          // specially.
	          $element.empty();
	          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope,
	              function namespaceAdaptedClone(clone) {
	            $element.append(clone);
	          }, {futureParentElement: $element});
	          return;
	        }
	
	        $element.html(ctrl.template);
	        $compile($element.contents())(scope);
	      }
	    };
	  }];
	
	/**
	 * @ngdoc directive
	 * @name ngInit
	 * @restrict AC
	 *
	 * @description
	 * The `ngInit` directive allows you to evaluate an expression in the
	 * current scope.
	 *
	 * <div class="alert alert-danger">
	 * This directive can be abused to add unnecessary amounts of logic into your templates.
	 * There are only a few appropriate uses of `ngInit`, such as for aliasing special properties of
	 * {@link ng.directive:ngRepeat `ngRepeat`}, as seen in the demo below; and for injecting data via
	 * server side scripting. Besides these few cases, you should use {@link guide/controller controllers}
	 * rather than `ngInit` to initialize values on a scope.
	 * </div>
	 *
	 * <div class="alert alert-warning">
	 * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
	 * sure you have parentheses to ensure correct operator precedence:
	 * <pre class="prettyprint">
	 * `<div ng-init="test1 = ($index | toString)"></div>`
	 * </pre>
	 * </div>
	 *
	 * @priority 450
	 *
	 * @element ANY
	 * @param {expression} ngInit {@link guide/expression Expression} to eval.
	 *
	 * @example
	   <example module="initExample" name="ng-init">
	     <file name="index.html">
	   <script>
	     angular.module('initExample', [])
	       .controller('ExampleController', ['$scope', function($scope) {
	         $scope.list = [['a', 'b'], ['c', 'd']];
	       }]);
	   </script>
	   <div ng-controller="ExampleController">
	     <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
	       <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
	          <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
	       </div>
	     </div>
	   </div>
	     </file>
	     <file name="protractor.js" type="protractor">
	       it('should alias index positions', function() {
	         var elements = element.all(by.css('.example-init'));
	         expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
	         expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
	         expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
	         expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
	       });
	     </file>
	   </example>
	 */
	var ngInitDirective = ngDirective({
	  priority: 450,
	  compile: function() {
	    return {
	      pre: function(scope, element, attrs) {
	        scope.$eval(attrs.ngInit);
	      }
	    };
	  }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngList
	 *
	 * @description
	 * Text input that converts between a delimited string and an array of strings. The default
	 * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
	 * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
	 *
	 * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
	 * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
	 *   list item is respected. This implies that the user of the directive is responsible for
	 *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
	 *   tab or newline character.
	 * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
	 *   when joining the list items back together) and whitespace around each list item is stripped
	 *   before it is added to the model.
	 *
	 * ### Example with Validation
	 *
	 * <example name="ngList-directive" module="listExample">
	 *   <file name="app.js">
	 *      angular.module('listExample', [])
	 *        .controller('ExampleController', ['$scope', function($scope) {
	 *          $scope.names = ['morpheus', 'neo', 'trinity'];
	 *        }]);
	 *   </file>
	 *   <file name="index.html">
	 *    <form name="myForm" ng-controller="ExampleController">
	 *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
	 *      <span role="alert">
	 *        <span class="error" ng-show="myForm.namesInput.$error.required">
	 *        Required!</span>
	 *      </span>
	 *      <br>
	 *      <tt>names = {{names}}</tt><br/>
	 *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
	 *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
	 *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
	 *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
	 *     </form>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var listInput = element(by.model('names'));
	 *     var names = element(by.exactBinding('names'));
	 *     var valid = element(by.binding('myForm.namesInput.$valid'));
	 *     var error = element(by.css('span.error'));
	 *
	 *     it('should initialize to model', function() {
	 *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
	 *       expect(valid.getText()).toContain('true');
	 *       expect(error.getCssValue('display')).toBe('none');
	 *     });
	 *
	 *     it('should be invalid if empty', function() {
	 *       listInput.clear();
	 *       listInput.sendKeys('');
	 *
	 *       expect(names.getText()).toContain('');
	 *       expect(valid.getText()).toContain('false');
	 *       expect(error.getCssValue('display')).not.toBe('none');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * ### Example - splitting on newline
	 * <example name="ngList-directive-newlines">
	 *   <file name="index.html">
	 *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
	 *    <pre>{{ list | json }}</pre>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it("should split the text by newlines", function() {
	 *       var listInput = element(by.model('list'));
	 *       var output = element(by.binding('list | json'));
	 *       listInput.sendKeys('abc\ndef\nghi');
	 *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * @element input
	 * @param {string=} ngList optional delimiter that should be used to split the value.
	 */
	var ngListDirective = function() {
	  return {
	    restrict: 'A',
	    priority: 100,
	    require: 'ngModel',
	    link: function(scope, element, attr, ctrl) {
	      var ngList = attr.ngList || ', ';
	      var trimValues = attr.ngTrim !== 'false';
	      var separator = trimValues ? trim(ngList) : ngList;
	
	      var parse = function(viewValue) {
	        // If the viewValue is invalid (say required but empty) it will be `undefined`
	        if (isUndefined(viewValue)) return;
	
	        var list = [];
	
	        if (viewValue) {
	          forEach(viewValue.split(separator), function(value) {
	            if (value) list.push(trimValues ? trim(value) : value);
	          });
	        }
	
	        return list;
	      };
	
	      ctrl.$parsers.push(parse);
	      ctrl.$formatters.push(function(value) {
	        if (isArray(value)) {
	          return value.join(ngList);
	        }
	
	        return undefined;
	      });
	
	      // Override the standard $isEmpty because an empty array means the input is empty.
	      ctrl.$isEmpty = function(value) {
	        return !value || !value.length;
	      };
	    }
	  };
	};
	
	/* global VALID_CLASS: true,
	  INVALID_CLASS: true,
	  PRISTINE_CLASS: true,
	  DIRTY_CLASS: true,
	  UNTOUCHED_CLASS: true,
	  TOUCHED_CLASS: true,
	  PENDING_CLASS: true,
	  addSetValidityMethod: true,
	  setupValidity: true,
	  defaultModelOptions: false
	*/
	
	
	var VALID_CLASS = 'ng-valid',
	    INVALID_CLASS = 'ng-invalid',
	    PRISTINE_CLASS = 'ng-pristine',
	    DIRTY_CLASS = 'ng-dirty',
	    UNTOUCHED_CLASS = 'ng-untouched',
	    TOUCHED_CLASS = 'ng-touched',
	    EMPTY_CLASS = 'ng-empty',
	    NOT_EMPTY_CLASS = 'ng-not-empty';
	
	var ngModelMinErr = minErr('ngModel');
	
	/**
	 * @ngdoc type
	 * @name ngModel.NgModelController
	 *
	 * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
	 * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
	 * is set.
	 *
	 * @property {*} $modelValue The value in the model that the control is bound to.
	 *
	 * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
	 *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
	    `$viewValue`} from the DOM, usually via user input.
	    See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
	    Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
	
	  The functions are called in array order, each passing
	    its return value through to the next. The last return value is forwarded to the
	    {@link ngModel.NgModelController#$validators `$validators`} collection.
	
	  Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
	    `$viewValue`}.
	
	  Returning `undefined` from a parser means a parse error occurred. In that case,
	    no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
	    will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
	    is set to `true`. The parse error is stored in `ngModel.$error.parse`.
	
	  This simple example shows a parser that would convert text input value to lowercase:
	 * ```js
	 * function parse(value) {
	 *   if (value) {
	 *     return value.toLowerCase();
	 *   }
	 * }
	 * ngModelController.$parsers.push(parse);
	 * ```
	
	 *
	 * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
	    the bound ngModel expression changes programmatically. The `$formatters` are not called when the
	    value of the control is changed by user interaction.
	
	  Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
	    `$modelValue`} for display in the control.
	
	  The functions are called in reverse array order, each passing the value through to the
	    next. The last return value is used as the actual DOM value.
	
	  This simple example shows a formatter that would convert the model value to uppercase:
	
	 * ```js
	 * function format(value) {
	 *   if (value) {
	 *     return value.toUpperCase();
	 *   }
	 * }
	 * ngModel.$formatters.push(format);
	 * ```
	 *
	 * @property {Object.<string, function>} $validators A collection of validators that are applied
	 *      whenever the model value changes. The key value within the object refers to the name of the
	 *      validator while the function refers to the validation operation. The validation operation is
	 *      provided with the model value as an argument and must return a true or false value depending
	 *      on the response of that validation.
	 *
	 * ```js
	 * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *   return /[0-9]+/.test(value) &&
	 *          /[a-z]+/.test(value) &&
	 *          /[A-Z]+/.test(value) &&
	 *          /\W+/.test(value);
	 * };
	 * ```
	 *
	 * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
	 *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
	 *      is expected to return a promise when it is run during the model validation process. Once the promise
	 *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
	 *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
	 *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
	 *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
	 *      will only run once all synchronous validators have passed.
	 *
	 * Please note that if $http is used then it is important that the server returns a success HTTP response code
	 * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
	 *
	 * ```js
	 * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
	 *   var value = modelValue || viewValue;
	 *
	 *   // Lookup user by username
	 *   return $http.get('/api/users/' + value).
	 *      then(function resolved() {
	 *        //username exists, this means validation fails
	 *        return $q.reject('exists');
	 *      }, function rejected() {
	 *        //username does not exist, therefore this validation passes
	 *        return true;
	 *      });
	 * };
	 * ```
	 *
	 * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever the
	 *     view value has changed. It is called with no arguments, and its return value is ignored.
	 *     This can be used in place of additional $watches against the model value.
	 *
	 * @property {Object} $error An object hash with all failing validator ids as keys.
	 * @property {Object} $pending An object hash with all pending validator ids as keys.
	 *
	 * @property {boolean} $untouched True if control has not lost focus yet.
	 * @property {boolean} $touched True if control has lost focus.
	 * @property {boolean} $pristine True if user has not interacted with the control yet.
	 * @property {boolean} $dirty True if user has already interacted with the control.
	 * @property {boolean} $valid True if there is no error.
	 * @property {boolean} $invalid True if at least one error on the control.
	 * @property {string} $name The name attribute of the control.
	 *
	 * @description
	 *
	 * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
	 * The controller contains services for data-binding, validation, CSS updates, and value formatting
	 * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
	 * listening to DOM events.
	 * Such DOM related logic should be provided by other directives which make use of
	 * `NgModelController` for data-binding to control elements.
	 * Angular provides this DOM logic for most {@link input `input`} elements.
	 * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
	 * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
	 *
	 * @example
	 * ### Custom Control Example
	 * This example shows how to use `NgModelController` with a custom control to achieve
	 * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
	 * collaborate together to achieve the desired result.
	 *
	 * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
	 * contents be edited in place by the user.
	 *
	 * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
	 * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
	 * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
	 * that content using the `$sce` service.
	 *
	 * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
	    <file name="style.css">
	      [contenteditable] {
	        border: 1px solid black;
	        background-color: white;
	        min-height: 20px;
	      }
	
	      .ng-invalid {
	        border: 1px solid red;
	      }
	
	    </file>
	    <file name="script.js">
	      angular.module('customControl', ['ngSanitize']).
	        directive('contenteditable', ['$sce', function($sce) {
	          return {
	            restrict: 'A', // only activate on element attribute
	            require: '?ngModel', // get a hold of NgModelController
	            link: function(scope, element, attrs, ngModel) {
	              if (!ngModel) return; // do nothing if no ng-model
	
	              // Specify how UI should be updated
	              ngModel.$render = function() {
	                element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
	              };
	
	              // Listen for change events to enable binding
	              element.on('blur keyup change', function() {
	                scope.$evalAsync(read);
	              });
	              read(); // initialize
	
	              // Write data to the model
	              function read() {
	                var html = element.html();
	                // When we clear the content editable the browser leaves a <br> behind
	                // If strip-br attribute is provided then we strip this out
	                if (attrs.stripBr && html === '<br>') {
	                  html = '';
	                }
	                ngModel.$setViewValue(html);
	              }
	            }
	          };
	        }]);
	    </file>
	    <file name="index.html">
	      <form name="myForm">
	       <div contenteditable
	            name="myWidget" ng-model="userContent"
	            strip-br="true"
	            required>Change me!</div>
	        <span ng-show="myForm.myWidget.$error.required">Required!</span>
	       <hr>
	       <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
	      </form>
	    </file>
	    <file name="protractor.js" type="protractor">
	    it('should data-bind and become invalid', function() {
	      if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
	        // SafariDriver can't handle contenteditable
	        // and Firefox driver can't clear contenteditables very well
	        return;
	      }
	      var contentEditable = element(by.css('[contenteditable]'));
	      var content = 'Change me!';
	
	      expect(contentEditable.getText()).toEqual(content);
	
	      contentEditable.clear();
	      contentEditable.sendKeys(protractor.Key.BACK_SPACE);
	      expect(contentEditable.getText()).toEqual('');
	      expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
	    });
	    </file>
	 * </example>
	 *
	 *
	 */
	NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
	function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
	  this.$viewValue = Number.NaN;
	  this.$modelValue = Number.NaN;
	  this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
	  this.$validators = {};
	  this.$asyncValidators = {};
	  this.$parsers = [];
	  this.$formatters = [];
	  this.$viewChangeListeners = [];
	  this.$untouched = true;
	  this.$touched = false;
	  this.$pristine = true;
	  this.$dirty = false;
	  this.$valid = true;
	  this.$invalid = false;
	  this.$error = {}; // keep invalid keys here
	  this.$$success = {}; // keep valid keys here
	  this.$pending = undefined; // keep pending keys here
	  this.$name = $interpolate($attr.name || '', false)($scope);
	  this.$$parentForm = nullFormCtrl;
	  this.$options = defaultModelOptions;
	
	  this.$$parsedNgModel = $parse($attr.ngModel);
	  this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
	  this.$$ngModelGet = this.$$parsedNgModel;
	  this.$$ngModelSet = this.$$parsedNgModelAssign;
	  this.$$pendingDebounce = null;
	  this.$$parserValid = undefined;
	
	  this.$$currentValidationRunId = 0;
	
	  // https://github.com/angular/angular.js/issues/15833
	  // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
	  Object.defineProperty(this, '$$scope', {value: $scope});
	  this.$$attr = $attr;
	  this.$$element = $element;
	  this.$$animate = $animate;
	  this.$$timeout = $timeout;
	  this.$$parse = $parse;
	  this.$$q = $q;
	  this.$$exceptionHandler = $exceptionHandler;
	
	  setupValidity(this);
	  setupModelWatcher(this);
	}
	
	NgModelController.prototype = {
	  $$initGetterSetters: function() {
	    if (this.$options.getOption('getterSetter')) {
	      var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
	          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
	
	      this.$$ngModelGet = function($scope) {
	        var modelValue = this.$$parsedNgModel($scope);
	        if (isFunction(modelValue)) {
	          modelValue = invokeModelGetter($scope);
	        }
	        return modelValue;
	      };
	      this.$$ngModelSet = function($scope, newValue) {
	        if (isFunction(this.$$parsedNgModel($scope))) {
	          invokeModelSetter($scope, {$$$p: newValue});
	        } else {
	          this.$$parsedNgModelAssign($scope, newValue);
	        }
	      };
	    } else if (!this.$$parsedNgModel.assign) {
	      throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}',
	          this.$$attr.ngModel, startingTag(this.$$element));
	    }
	  },
	
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$render
	   *
	   * @description
	   * Called when the view needs to be updated. It is expected that the user of the ng-model
	   * directive will implement this method.
	   *
	   * The `$render()` method is invoked in the following situations:
	   *
	   * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
	   *   committed value then `$render()` is called to update the input control.
	   * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
	   *   the `$viewValue` are different from last time.
	   *
	   * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
	   * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
	   * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
	   * invoked if you only change a property on the objects.
	   */
	  $render: noop,
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$isEmpty
	   *
	   * @description
	   * This is called when we need to determine if the value of an input is empty.
	   *
	   * For instance, the required directive does this to work out if the input has data or not.
	   *
	   * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
	   *
	   * You can override this for input directives whose concept of being empty is different from the
	   * default. The `checkboxInputType` directive does this because in its case a value of `false`
	   * implies empty.
	   *
	   * @param {*} value The value of the input to check for emptiness.
	   * @returns {boolean} True if `value` is "empty".
	   */
	  $isEmpty: function(value) {
	    // eslint-disable-next-line no-self-compare
	    return isUndefined(value) || value === '' || value === null || value !== value;
	  },
	
	  $$updateEmptyClasses: function(value) {
	    if (this.$isEmpty(value)) {
	      this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, EMPTY_CLASS);
	    } else {
	      this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
	      this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setPristine
	   *
	   * @description
	   * Sets the control to its pristine state.
	   *
	   * This method can be called to remove the `ng-dirty` class and set the control to its pristine
	   * state (`ng-pristine` class). A model is considered to be pristine when the control
	   * has not been changed from when first compiled.
	   */
	  $setPristine: function() {
	    this.$dirty = false;
	    this.$pristine = true;
	    this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
	    this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setDirty
	   *
	   * @description
	   * Sets the control to its dirty state.
	   *
	   * This method can be called to remove the `ng-pristine` class and set the control to its dirty
	   * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
	   * from when first compiled.
	   */
	  $setDirty: function() {
	    this.$dirty = true;
	    this.$pristine = false;
	    this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
	    this.$$animate.addClass(this.$$element, DIRTY_CLASS);
	    this.$$parentForm.$setDirty();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setUntouched
	   *
	   * @description
	   * Sets the control to its untouched state.
	   *
	   * This method can be called to remove the `ng-touched` class and set the control to its
	   * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
	   * by default, however this function can be used to restore that state if the model has
	   * already been touched by the user.
	   */
	  $setUntouched: function() {
	    this.$touched = false;
	    this.$untouched = true;
	    this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setTouched
	   *
	   * @description
	   * Sets the control to its touched state.
	   *
	   * This method can be called to remove the `ng-untouched` class and set the control to its
	   * touched state (`ng-touched` class). A model is considered to be touched when the user has
	   * first focused the control element and then shifted focus away from the control (blur event).
	   */
	  $setTouched: function() {
	    this.$touched = true;
	    this.$untouched = false;
	    this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$rollbackViewValue
	   *
	   * @description
	   * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
	   * which may be caused by a pending debounced event or because the input is waiting for some
	   * future event.
	   *
	   * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
	   * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
	   * sync with the ngModel's `$modelValue`.
	   *
	   * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
	   * and reset the input to the last committed view value.
	   *
	   * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
	   * programmatically before these debounced/future events have resolved/occurred, because Angular's
	   * dirty checking mechanism is not able to tell whether the model has actually changed or not.
	   *
	   * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
	   * input which may have such events pending. This is important in order to make sure that the
	   * input field will be updated with the new model value and any pending operations are cancelled.
	   *
	   * <example name="ng-model-cancel-update" module="cancel-update-example">
	   *   <file name="app.js">
	   *     angular.module('cancel-update-example', [])
	   *
	   *     .controller('CancelUpdateController', ['$scope', function($scope) {
	   *       $scope.model = {value1: '', value2: ''};
	   *
	   *       $scope.setEmpty = function(e, value, rollback) {
	   *         if (e.keyCode === 27) {
	   *           e.preventDefault();
	   *           if (rollback) {
	   *             $scope.myForm[value].$rollbackViewValue();
	   *           }
	   *           $scope.model[value] = '';
	   *         }
	   *       };
	   *     }]);
	   *   </file>
	   *   <file name="index.html">
	   *     <div ng-controller="CancelUpdateController">
	   *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
	   *       empty them. Follow these steps and observe the difference:</p>
	   *       <ol>
	   *         <li>Type something in the input. You will see that the model is not yet updated</li>
	   *         <li>Press the Escape key.
	   *           <ol>
	   *             <li> In the first example, nothing happens, because the model is already '', and no
	   *             update is detected. If you blur the input, the model will be set to the current view.
	   *             </li>
	   *             <li> In the second example, the pending update is cancelled, and the input is set back
	   *             to the last committed view value (''). Blurring the input does nothing.
	   *             </li>
	   *           </ol>
	   *         </li>
	   *       </ol>
	   *
	   *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
	   *         <div>
	   *           <p id="inputDescription1">Without $rollbackViewValue():</p>
	   *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
	   *                  ng-keydown="setEmpty($event, 'value1')">
	   *           value1: "{{ model.value1 }}"
	   *         </div>
	   *
	   *         <div>
	   *           <p id="inputDescription2">With $rollbackViewValue():</p>
	   *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
	   *                  ng-keydown="setEmpty($event, 'value2', true)">
	   *           value2: "{{ model.value2 }}"
	   *         </div>
	   *       </form>
	   *     </div>
	   *   </file>
	       <file name="style.css">
	          div {
	            display: table-cell;
	          }
	          div:nth-child(1) {
	            padding-right: 30px;
	          }
	
	        </file>
	   * </example>
	   */
	  $rollbackViewValue: function() {
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    this.$viewValue = this.$$lastCommittedViewValue;
	    this.$render();
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$validate
	   *
	   * @description
	   * Runs each of the registered validators (first synchronous validators and then
	   * asynchronous validators).
	   * If the validity changes to invalid, the model will be set to `undefined`,
	   * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
	   * If the validity changes to valid, it will set the model to the last available valid
	   * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
	   */
	  $validate: function() {
	    // ignore $validate before model is initialized
	    if (isNumberNaN(this.$modelValue)) {
	      return;
	    }
	
	    var viewValue = this.$$lastCommittedViewValue;
	    // Note: we use the $$rawModelValue as $modelValue might have been
	    // set to undefined during a view -> model update that found validation
	    // errors. We can't parse the view here, since that could change
	    // the model although neither viewValue nor the model on the scope changed
	    var modelValue = this.$$rawModelValue;
	
	    var prevValid = this.$valid;
	    var prevModelValue = this.$modelValue;
	
	    var allowInvalid = this.$options.getOption('allowInvalid');
	
	    var that = this;
	    this.$$runValidators(modelValue, viewValue, function(allValid) {
	      // If there was no change in validity, don't update the model
	      // This prevents changing an invalid modelValue to undefined
	      if (!allowInvalid && prevValid !== allValid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	
	        if (that.$modelValue !== prevModelValue) {
	          that.$$writeModelToScope();
	        }
	      }
	    });
	  },
	
	  $$runValidators: function(modelValue, viewValue, doneCallback) {
	    this.$$currentValidationRunId++;
	    var localValidationRunId = this.$$currentValidationRunId;
	    var that = this;
	
	    // check parser error
	    if (!processParseErrors()) {
	      validationDone(false);
	      return;
	    }
	    if (!processSyncValidators()) {
	      validationDone(false);
	      return;
	    }
	    processAsyncValidators();
	
	    function processParseErrors() {
	      var errorKey = that.$$parserName || 'parse';
	      if (isUndefined(that.$$parserValid)) {
	        setValidity(errorKey, null);
	      } else {
	        if (!that.$$parserValid) {
	          forEach(that.$validators, function(v, name) {
	            setValidity(name, null);
	          });
	          forEach(that.$asyncValidators, function(v, name) {
	            setValidity(name, null);
	          });
	        }
	        // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
	        setValidity(errorKey, that.$$parserValid);
	        return that.$$parserValid;
	      }
	      return true;
	    }
	
	    function processSyncValidators() {
	      var syncValidatorsValid = true;
	      forEach(that.$validators, function(validator, name) {
	        var result = Boolean(validator(modelValue, viewValue));
	        syncValidatorsValid = syncValidatorsValid && result;
	        setValidity(name, result);
	      });
	      if (!syncValidatorsValid) {
	        forEach(that.$asyncValidators, function(v, name) {
	          setValidity(name, null);
	        });
	        return false;
	      }
	      return true;
	    }
	
	    function processAsyncValidators() {
	      var validatorPromises = [];
	      var allValid = true;
	      forEach(that.$asyncValidators, function(validator, name) {
	        var promise = validator(modelValue, viewValue);
	        if (!isPromiseLike(promise)) {
	          throw ngModelMinErr('nopromise',
	            'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
	        }
	        setValidity(name, undefined);
	        validatorPromises.push(promise.then(function() {
	          setValidity(name, true);
	        }, function() {
	          allValid = false;
	          setValidity(name, false);
	        }));
	      });
	      if (!validatorPromises.length) {
	        validationDone(true);
	      } else {
	        that.$$q.all(validatorPromises).then(function() {
	          validationDone(allValid);
	        }, noop);
	      }
	    }
	
	    function setValidity(name, isValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	        that.$setValidity(name, isValid);
	      }
	    }
	
	    function validationDone(allValid) {
	      if (localValidationRunId === that.$$currentValidationRunId) {
	
	        doneCallback(allValid);
	      }
	    }
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$commitViewValue
	   *
	   * @description
	   * Commit a pending update to the `$modelValue`.
	   *
	   * Updates may be pending by a debounced event or because the input is waiting for a some future
	   * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
	   * usually handles calling this in response to input events.
	   */
	  $commitViewValue: function() {
	    var viewValue = this.$viewValue;
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	
	    // If the view value has not changed then we should just exit, except in the case where there is
	    // a native validator on the element. In this case the validation state may have changed even though
	    // the viewValue has stayed empty.
	    if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
	      return;
	    }
	    this.$$updateEmptyClasses(viewValue);
	    this.$$lastCommittedViewValue = viewValue;
	
	    // change to dirty
	    if (this.$pristine) {
	      this.$setDirty();
	    }
	    this.$$parseAndValidate();
	  },
	
	  $$parseAndValidate: function() {
	    var viewValue = this.$$lastCommittedViewValue;
	    var modelValue = viewValue;
	    var that = this;
	
	    this.$$parserValid = isUndefined(modelValue) ? undefined : true;
	
	    if (this.$$parserValid) {
	      for (var i = 0; i < this.$parsers.length; i++) {
	        modelValue = this.$parsers[i](modelValue);
	        if (isUndefined(modelValue)) {
	          this.$$parserValid = false;
	          break;
	        }
	      }
	    }
	    if (isNumberNaN(this.$modelValue)) {
	      // this.$modelValue has not been touched yet...
	      this.$modelValue = this.$$ngModelGet(this.$$scope);
	    }
	    var prevModelValue = this.$modelValue;
	    var allowInvalid = this.$options.getOption('allowInvalid');
	    this.$$rawModelValue = modelValue;
	
	    if (allowInvalid) {
	      this.$modelValue = modelValue;
	      writeToModelIfNeeded();
	    }
	
	    // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
	    // This can happen if e.g. $setViewValue is called from inside a parser
	    this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function(allValid) {
	      if (!allowInvalid) {
	        // Note: Don't check this.$valid here, as we could have
	        // external validators (e.g. calculated on the server),
	        // that just call $setValidity and need the model value
	        // to calculate their validity.
	        that.$modelValue = allValid ? modelValue : undefined;
	        writeToModelIfNeeded();
	      }
	    });
	
	    function writeToModelIfNeeded() {
	      if (that.$modelValue !== prevModelValue) {
	        that.$$writeModelToScope();
	      }
	    }
	  },
	
	  $$writeModelToScope: function() {
	    this.$$ngModelSet(this.$$scope, this.$modelValue);
	    forEach(this.$viewChangeListeners, function(listener) {
	      try {
	        listener();
	      } catch (e) {
	        // eslint-disable-next-line no-invalid-this
	        this.$$exceptionHandler(e);
	      }
	    }, this);
	  },
	
	  /**
	   * @ngdoc method
	   * @name ngModel.NgModelController#$setViewValue
	   *
	   * @description
	   * Update the view value.
	   *
	   * This method should be called when a control wants to change the view value; typically,
	   * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
	   * directive calls it when the value of the input changes and {@link ng.directive:select select}
	   * calls it when an option is selected.
	   *
	   * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
	   * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
	   * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
	   * `$asyncValidators` are called and the value is applied to `$modelValue`.
	   * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
	   * all the registered change listeners, in the `$viewChangeListeners` list are called.
	   *
	   * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
	   * and the `default` trigger is not listed, all those actions will remain pending until one of the
	   * `updateOn` events is triggered on the DOM element.
	   * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
	   * directive is used with a custom debounce for this particular event.
	   * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
	   * is specified, once the timer runs out.
	   *
	   * When used with standard inputs, the view value will always be a string (which is in some cases
	   * parsed into another type, such as a `Date` object for `input[date]`.)
	   * However, custom controls might also pass objects to this method. In this case, we should make
	   * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
	   * perform a deep watch of objects, it only looks for a change of identity. If you only change
	   * the property of the object then ngModel will not realize that the object has changed and
	   * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
	   * not change properties of the copy once it has been passed to `$setViewValue`.
	   * Otherwise you may cause the model value on the scope to change incorrectly.
	   *
	   * <div class="alert alert-info">
	   * In any case, the value passed to the method should always reflect the current value
	   * of the control. For example, if you are calling `$setViewValue` for an input element,
	   * you should pass the input DOM value. Otherwise, the control and the scope model become
	   * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
	   * the control's DOM value in any way. If we want to change the control's DOM value
	   * programmatically, we should update the `ngModel` scope expression. Its new value will be
	   * picked up by the model controller, which will run it through the `$formatters`, `$render` it
	   * to update the DOM, and finally call `$validate` on it.
	   * </div>
	   *
	   * @param {*} value value from the view.
	   * @param {string} trigger Event that triggered the update.
	   */
	  $setViewValue: function(value, trigger) {
	    this.$viewValue = value;
	    if (this.$options.getOption('updateOnDefault')) {
	      this.$$debounceViewValueCommit(trigger);
	    }
	  },
	
	  $$debounceViewValueCommit: function(trigger) {
	    var debounceDelay = this.$options.getOption('debounce');
	
	    if (isNumber(debounceDelay[trigger])) {
	      debounceDelay = debounceDelay[trigger];
	    } else if (isNumber(debounceDelay['default'])) {
	      debounceDelay = debounceDelay['default'];
	    }
	
	    this.$$timeout.cancel(this.$$pendingDebounce);
	    var that = this;
	    if (debounceDelay > 0) { // this fails if debounceDelay is an object
	      this.$$pendingDebounce = this.$$timeout(function() {
	        that.$commitViewValue();
	      }, debounceDelay);
	    } else if (this.$$scope.$root.$$phase) {
	      this.$commitViewValue();
	    } else {
	      this.$$scope.$apply(function() {
	        that.$commitViewValue();
	      });
	    }
	  },
	
	  /**
	   * @ngdoc method
	   *
	   * @name ngModel.NgModelController#$overrideModelOptions
	   *
	   * @description
	   *
	   * Override the current model options settings programmatically.
	   *
	   * The previous `ModelOptions` value will not be modified. Instead, a
	   * new `ModelOptions` object will inherit from the previous one overriding
	   * or inheriting settings that are defined in the given parameter.
	   *
	   * See {@link ngModelOptions} for information about what options can be specified
	   * and how model option inheritance works.
	   *
	   * @param {Object} options a hash of settings to override the previous options
	   *
	   */
	  $overrideModelOptions: function(options) {
	    this.$options = this.$options.createChild(options);
	  }
	};
	
	function setupModelWatcher(ctrl) {
	  // model -> value
	  // Note: we cannot use a normal scope.$watch as we want to detect the following:
	  // 1. scope value is 'a'
	  // 2. user enters 'b'
	  // 3. ng-change kicks in and reverts scope value to 'a'
	  //    -> scope value did not change since the last digest as
	  //       ng-change executes in apply phase
	  // 4. view should be changed back to 'a'
	  ctrl.$$scope.$watch(function ngModelWatch(scope) {
	    var modelValue = ctrl.$$ngModelGet(scope);
	
	    // if scope model value and ngModel value are out of sync
	    // TODO(perf): why not move this to the action fn?
	    if (modelValue !== ctrl.$modelValue &&
	       // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
	        // eslint-disable-next-line no-self-compare
	       (ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)
	    ) {
	      ctrl.$modelValue = ctrl.$$rawModelValue = modelValue;
	      ctrl.$$parserValid = undefined;
	
	      var formatters = ctrl.$formatters,
	          idx = formatters.length;
	
	      var viewValue = modelValue;
	      while (idx--) {
	        viewValue = formatters[idx](viewValue);
	      }
	      if (ctrl.$viewValue !== viewValue) {
	        ctrl.$$updateEmptyClasses(viewValue);
	        ctrl.$viewValue = ctrl.$$lastCommittedViewValue = viewValue;
	        ctrl.$render();
	
	        // It is possible that model and view value have been updated during render
	        ctrl.$$runValidators(ctrl.$modelValue, ctrl.$viewValue, noop);
	      }
	    }
	
	    return modelValue;
	  });
	}
	
	/**
	 * @ngdoc method
	 * @name ngModel.NgModelController#$setValidity
	 *
	 * @description
	 * Change the validity state, and notify the form.
	 *
	 * This method can be called within $parsers/$formatters or a custom validation implementation.
	 * However, in most cases it should be sufficient to use the `ngModel.$validators` and
	 * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
	 *
	 * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
	 *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
	 *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
	 *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
	 *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
	 *        class and can be bound to as  `{{someForm.someControl.$error.myError}}` .
	 * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
	 *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
	 *                          Skipped is used by Angular when validators do not run because of parse errors and
	 *                          when `$asyncValidators` do not run because any of the `$validators` failed.
	 */
	addSetValidityMethod({
	  clazz: NgModelController,
	  set: function(object, property) {
	    object[property] = true;
	  },
	  unset: function(object, property) {
	    delete object[property];
	  }
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModel
	 *
	 * @element input
	 * @priority 1
	 *
	 * @description
	 * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
	 * property on the scope using {@link ngModel.NgModelController NgModelController},
	 * which is created and exposed by this directive.
	 *
	 * `ngModel` is responsible for:
	 *
	 * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
	 *   require.
	 * - Providing validation behavior (i.e. required, number, email, url).
	 * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
	 * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
	 *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
	 * - Registering the control with its parent {@link ng.directive:form form}.
	 *
	 * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
	 * current scope. If the property doesn't already exist on this scope, it will be created
	 * implicitly and added to the scope.
	 *
	 * For best practices on using `ngModel`, see:
	 *
	 *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
	 *
	 * For basic examples, how to use `ngModel`, see:
	 *
	 *  - {@link ng.directive:input input}
	 *    - {@link input[text] text}
	 *    - {@link input[checkbox] checkbox}
	 *    - {@link input[radio] radio}
	 *    - {@link input[number] number}
	 *    - {@link input[email] email}
	 *    - {@link input[url] url}
	 *    - {@link input[date] date}
	 *    - {@link input[datetime-local] datetime-local}
	 *    - {@link input[time] time}
	 *    - {@link input[month] month}
	 *    - {@link input[week] week}
	 *  - {@link ng.directive:select select}
	 *  - {@link ng.directive:textarea textarea}
	 *
	 * # Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
	 * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
	 *
	 * The model must be assigned an entirely new object or collection before a re-rendering will occur.
	 *
	 * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
	 * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
	 * if the select is given the `multiple` attribute.
	 *
	 * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
	 * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
	 * not trigger a re-rendering of the model.
	 *
	 * # CSS classes
	 * The following CSS classes are added and removed on the associated input/select/textarea element
	 * depending on the validity of the model.
	 *
	 *  - `ng-valid`: the model is valid
	 *  - `ng-invalid`: the model is invalid
	 *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
	 *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
	 *  - `ng-pristine`: the control hasn't been interacted with yet
	 *  - `ng-dirty`: the control has been interacted with
	 *  - `ng-touched`: the control has been blurred
	 *  - `ng-untouched`: the control hasn't been blurred
	 *  - `ng-pending`: any `$asyncValidators` are unfulfilled
	 *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
	 *     by the {@link ngModel.NgModelController#$isEmpty} method
	 *  - `ng-not-empty`: the view contains a non-empty value
	 *
	 * Keep in mind that ngAnimate can detect each of these classes when added and removed.
	 *
	 * ## Animation Hooks
	 *
	 * Animations within models are triggered when any of the associated CSS classes are added and removed
	 * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
	 * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
	 * The animations that are triggered within ngModel are similar to how they work in ngClass and
	 * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
	 *
	 * The following example shows a simple way to utilize CSS transitions to style an input element
	 * that has been rendered as invalid after it has been validated:
	 *
	 * <pre>
	 * //be sure to include ngAnimate as a module to hook into more
	 * //advanced animations
	 * .my-input {
	 *   transition:0.5s linear all;
	 *   background: white;
	 * }
	 * .my-input.ng-invalid {
	 *   background: red;
	 *   color:white;
	 * }
	 * </pre>
	 *
	 * @example
	 * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
	     <file name="index.html">
	       <script>
	        angular.module('inputExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.val = '1';
	          }]);
	       </script>
	       <style>
	         .my-input {
	           transition:all linear 0.5s;
	           background: transparent;
	         }
	         .my-input.ng-invalid {
	           color:white;
	           background: red;
	         }
	       </style>
	       <p id="inputDescription">
	        Update input to see transitions when valid/invalid.
	        Integer is a valid value.
	       </p>
	       <form name="testForm" ng-controller="ExampleController">
	         <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
	                aria-describedby="inputDescription" />
	       </form>
	     </file>
	 * </example>
	 *
	 * ## Binding to a getter/setter
	 *
	 * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
	 * function that returns a representation of the model when called with zero arguments, and sets
	 * the internal state of a model when called with an argument. It's sometimes useful to use this
	 * for models that have an internal representation that's different from what the model exposes
	 * to the view.
	 *
	 * <div class="alert alert-success">
	 * **Best Practice:** It's best to keep getters fast because Angular is likely to call them more
	 * frequently than other parts of your code.
	 * </div>
	 *
	 * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
	 * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
	 * a `<form>`, which will enable this behavior for all `<input>`s within it. See
	 * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
	 *
	 * The following example shows how to use `ngModel` with a getter/setter:
	 *
	 * @example
	 * <example name="ngModel-getter-setter" module="getterSetterExample">
	     <file name="index.html">
	       <div ng-controller="ExampleController">
	         <form name="userForm">
	           <label>Name:
	             <input type="text" name="userName"
	                    ng-model="user.name"
	                    ng-model-options="{ getterSetter: true }" />
	           </label>
	         </form>
	         <pre>user.name = <span ng-bind="user.name()"></span></pre>
	       </div>
	     </file>
	     <file name="app.js">
	       angular.module('getterSetterExample', [])
	         .controller('ExampleController', ['$scope', function($scope) {
	           var _name = 'Brian';
	           $scope.user = {
	             name: function(newName) {
	              // Note that newName can be undefined for two reasons:
	              // 1. Because it is called as a getter and thus called with no arguments
	              // 2. Because the property should actually be set to undefined. This happens e.g. if the
	              //    input is invalid
	              return arguments.length ? (_name = newName) : _name;
	             }
	           };
	         }]);
	     </file>
	 * </example>
	 */
	var ngModelDirective = ['$rootScope', function($rootScope) {
	  return {
	    restrict: 'A',
	    require: ['ngModel', '^?form', '^?ngModelOptions'],
	    controller: NgModelController,
	    // Prelink needs to run before any input directive
	    // so that we can set the NgModelOptions in NgModelController
	    // before anyone else uses it.
	    priority: 1,
	    compile: function ngModelCompile(element) {
	      // Setup initial state of the control
	      element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
	
	      return {
	        pre: function ngModelPreLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0],
	              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
	              optionsCtrl = ctrls[2];
	
	          if (optionsCtrl) {
	            modelCtrl.$options = optionsCtrl.$options;
	          }
	
	          modelCtrl.$$initGetterSetters();
	
	          // notify others, especially parent forms
	          formCtrl.$addControl(modelCtrl);
	
	          attr.$observe('name', function(newValue) {
	            if (modelCtrl.$name !== newValue) {
	              modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
	            }
	          });
	
	          scope.$on('$destroy', function() {
	            modelCtrl.$$parentForm.$removeControl(modelCtrl);
	          });
	        },
	        post: function ngModelPostLink(scope, element, attr, ctrls) {
	          var modelCtrl = ctrls[0];
	          if (modelCtrl.$options.getOption('updateOn')) {
	            element.on(modelCtrl.$options.getOption('updateOn'), function(ev) {
	              modelCtrl.$$debounceViewValueCommit(ev && ev.type);
	            });
	          }
	
	          function setTouched() {
	            modelCtrl.$setTouched();
	          }
	
	          element.on('blur', function() {
	            if (modelCtrl.$touched) return;
	
	            if ($rootScope.$$phase) {
	              scope.$evalAsync(setTouched);
	            } else {
	              scope.$apply(setTouched);
	            }
	          });
	        }
	      };
	    }
	  };
	}];
	
	/* exported defaultModelOptions */
	var defaultModelOptions;
	var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;
	
	/**
	 * @ngdoc type
	 * @name ModelOptions
	 * @description
	 * A container for the options set by the {@link ngModelOptions} directive
	 */
	function ModelOptions(options) {
	  this.$$options = options;
	}
	
	ModelOptions.prototype = {
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#getOption
	   * @param {string} name the name of the option to retrieve
	   * @returns {*} the value of the option
	   * @description
	   * Returns the value of the given option
	   */
	  getOption: function(name) {
	    return this.$$options[name];
	  },
	
	  /**
	   * @ngdoc method
	   * @name ModelOptions#createChild
	   * @param {Object} options a hash of options for the new child that will override the parent's options
	   * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
	   */
	  createChild: function(options) {
	    var inheritAll = false;
	
	    // make a shallow copy
	    options = extend({}, options);
	
	    // Inherit options from the parent if specified by the value `"$inherit"`
	    forEach(options, /* @this */ function(option, key) {
	      if (option === '$inherit') {
	        if (key === '*') {
	          inheritAll = true;
	        } else {
	          options[key] = this.$$options[key];
	          // `updateOn` is special so we must also inherit the `updateOnDefault` option
	          if (key === 'updateOn') {
	            options.updateOnDefault = this.$$options.updateOnDefault;
	          }
	        }
	      } else {
	        if (key === 'updateOn') {
	          // If the `updateOn` property contains the `default` event then we have to remove
	          // it from the event list and set the `updateOnDefault` flag.
	          options.updateOnDefault = false;
	          options[key] = trim(option.replace(DEFAULT_REGEXP, function() {
	            options.updateOnDefault = true;
	            return ' ';
	          }));
	        }
	      }
	    }, this);
	
	    if (inheritAll) {
	      // We have a property of the form: `"*": "$inherit"`
	      delete options['*'];
	      defaults(options, this.$$options);
	    }
	
	    // Finally add in any missing defaults
	    defaults(options, defaultModelOptions.$$options);
	
	    return new ModelOptions(options);
	  }
	};
	
	
	defaultModelOptions = new ModelOptions({
	  updateOn: '',
	  updateOnDefault: true,
	  debounce: 0,
	  getterSetter: false,
	  allowInvalid: false,
	  timezone: null
	});
	
	
	/**
	 * @ngdoc directive
	 * @name ngModelOptions
	 *
	 * @description
	 * This directive allows you to modify the behaviour of {@link ngModel} directives within your
	 * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
	 * directives will use the options of their nearest `ngModelOptions` ancestor.
	 *
	 * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
	 * an Angular expression. This expression should evaluate to an object, whose properties contain
	 * the settings. For example: `<div "ng-model-options"="{ debounce: 100 }"`.
	 *
	 * ## Inheriting Options
	 *
	 * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
	 * directive by giving it the value of `"$inherit"`.
	 * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
	 * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
	 * will be used.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 0 }
	 * ```
	 *
	 * Notice that the `debounce` setting was not inherited and used the default value instead.
	 *
	 * You can specify that all undefined settings are automatically inherited from an ancestor by
	 * including a property with key of `"*"` and value of `"$inherit"`.
	 *
	 * For example given the following fragment of HTML
	 *
	 *
	 * ```html
	 * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
	 *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
	 *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
	 *   </form>
	 * </div>
	 * ```
	 *
	 * the `input` element will have the following settings
	 *
	 * ```js
	 * { allowInvalid: true, updateOn: 'default', debounce: 200 }
	 * ```
	 *
	 * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
	 *
	 * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
	 * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
	 *
	 *
	 * ## Triggering and debouncing model updates
	 *
	 * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
	 * trigger a model update and/or a debouncing delay so that the actual update only takes place when
	 * a timer expires; this timer will be reset after another change takes place.
	 *
	 * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
	 * be different from the value in the actual model. This means that if you update the model you
	 * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
	 * order to make sure it is synchronized with the model and that any debounced action is canceled.
	 *
	 * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
	 * method is by making sure the input is placed inside a form that has a `name` attribute. This is
	 * important because `form` controllers are published to the related scope under the name in their
	 * `name` attribute.
	 *
	 * Any pending changes will take place immediately when an enclosing form is submitted via the
	 * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
	 * to have access to the updated model.
	 *
	 * The following example shows how to override immediate updates. Changes on the inputs within the
	 * form will update the model only when the control loses focus (blur event). If `escape` key is
	 * pressed while the input field is focused, the value is reset to the value in the current model.
	 *
	 * <example name="ngModelOptions-directive-blur" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ updateOn: 'blur' }"
	 *                  ng-keyup="cancel($event)" />
	 *         </label><br />
	 *         <label>
	 *           Other data:
	 *           <input type="text" ng-model="user.data" />
	 *         </label><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say', data: '' };
	 *
	 *         $scope.cancel = function(e) {
	 *           if (e.keyCode === 27) {
	 *             $scope.userForm.userName.$rollbackViewValue();
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     var model = element(by.binding('user.name'));
	 *     var input = element(by.model('user.name'));
	 *     var other = element(by.model('user.data'));
	 *
	 *     it('should allow custom events', function() {
	 *       input.sendKeys(' hello');
	 *       input.click();
	 *       expect(model.getText()).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say hello');
	 *     });
	 *
	 *     it('should $rollbackViewValue when model changes', function() {
	 *       input.sendKeys(' hello');
	 *       expect(input.getAttribute('value')).toEqual('say hello');
	 *       input.sendKeys(protractor.Key.ESCAPE);
	 *       expect(input.getAttribute('value')).toEqual('say');
	 *       other.click();
	 *       expect(model.getText()).toEqual('say');
	 *     });
	 *   </file>
	 * </example>
	 *
	 * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
	 * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
	 *
	 * <example name="ngModelOptions-directive-debounce" module="optionsExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         Name:
	 *         <input type="text" name="userName"
	 *                ng-model="user.name"
	 *                ng-model-options="{ debounce: 1000 }" />
	 *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('optionsExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.user = { name: 'say' };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 * ## Model updates and validation
	 *
	 * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
	 * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
	 * the model will still be updated even if the value is invalid.
	 *
	 *
	 * ## Connecting to the scope
	 *
	 * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
	 * on the scope refers to a "getter/setter" function rather than the value itself.
	 *
	 * The following example shows how to bind to getter/setters:
	 *
	 * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
	 *   <file name="index.html">
	 *     <div ng-controller="ExampleController">
	 *       <form name="userForm">
	 *         <label>
	 *           Name:
	 *           <input type="text" name="userName"
	 *                  ng-model="user.name"
	 *                  ng-model-options="{ getterSetter: true }" />
	 *         </label>
	 *       </form>
	 *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
	 *     </div>
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('getterSetterExample', [])
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         var _name = 'Brian';
	 *         $scope.user = {
	 *           name: function(newName) {
	 *             return angular.isDefined(newName) ? (_name = newName) : _name;
	 *           }
	 *         };
	 *       }]);
	 *   </file>
	 * </example>
	 *
	 *
	 * ## Specifying timezones
	 *
	 * You can specify the timezone that date/time input directives expect by providing its name in the
	 * `timezone` property.
	 *
	 * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
	 *   and its descendents. Valid keys are:
	 *   - `updateOn`: string specifying which event should the input be bound to. You can set several
	 *     events using an space delimited list. There is a special event called `default` that
	 *     matches the default events belonging to the control.
	 *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
	 *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
	 *     custom value for each event. For example:
	 *     ```
	 *     ng-model-options="{
	 *       updateOn: 'default blur',
	 *       debounce: { 'default': 500, 'blur': 0 }
	 *     }"
	 *     ```
	 *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
	 *     not validate correctly instead of the default behavior of setting the model to undefined.
	 *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
	 *     `ngModel` as getters/setters.
	 *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
	 *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
	 *     continental US time zone abbreviations, but for general use, use a time zone offset, for
	 *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
	 *     If not specified, the timezone of the browser will be used.
	 *
	 */
	var ngModelOptionsDirective = function() {
	  NgModelOptionsController.$inject = ['$attrs', '$scope'];
	  function NgModelOptionsController($attrs, $scope) {
	    this.$$attrs = $attrs;
	    this.$$scope = $scope;
	  }
	  NgModelOptionsController.prototype = {
	    $onInit: function() {
	      var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
	      var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
	
	      this.$options = parentOptions.createChild(modelOptionsDefinition);
	    }
	  };
	
	  return {
	    restrict: 'A',
	    // ngModelOptions needs to run before ngModel and input directives
	    priority: 10,
	    require: {parentCtrl: '?^^ngModelOptions'},
	    bindToController: true,
	    controller: NgModelOptionsController
	  };
	};
	
	
	// shallow copy over values from `src` that are not already specified on `dst`
	function defaults(dst, src) {
	  forEach(src, function(value, key) {
	    if (!isDefined(dst[key])) {
	      dst[key] = value;
	    }
	  });
	}
	
	/**
	 * @ngdoc directive
	 * @name ngNonBindable
	 * @restrict AC
	 * @priority 1000
	 *
	 * @description
	 * The `ngNonBindable` directive tells Angular not to compile or bind the contents of the current
	 * DOM element. This is useful if the element contains what appears to be Angular directives and
	 * bindings but which should be ignored by Angular. This could be the case if you have a site that
	 * displays snippets of code, for instance.
	 *
	 * @element ANY
	 *
	 * @example
	 * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
	 * but the one wrapped in `ngNonBindable` is left alone.
	 *
	 * @example
	    <example name="ng-non-bindable">
	      <file name="index.html">
	        <div>Normal: {{1 + 2}}</div>
	        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
	      </file>
	      <file name="protractor.js" type="protractor">
	       it('should check ng-non-bindable', function() {
	         expect(element(by.binding('1 + 2')).getText()).toContain('3');
	         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
	       });
	      </file>
	    </example>
	 */
	var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });
	
	/* exported ngOptionsDirective */
	
	/* global jqLiteRemove */
	
	var ngOptionsMinErr = minErr('ngOptions');
	
	/**
	 * @ngdoc directive
	 * @name ngOptions
	 * @restrict A
	 *
	 * @description
	 *
	 * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
	 * elements for the `<select>` element using the array or object obtained by evaluating the
	 * `ngOptions` comprehension expression.
	 *
	 * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
	 * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * When an item in the `<select>` menu is selected, the array element or object property
	 * represented by the selected option will be bound to the model identified by the `ngModel`
	 * directive.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Complex Models (objects or collections)
	 *
	 * By default, `ngModel` watches the model by reference, not value. This is important to know when
	 * binding the select to a model that is an object or a collection.
	 *
	 * One issue occurs if you want to preselect an option. For example, if you set
	 * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
	 * because the objects are not identical. So by default, you should always reference the item in your collection
	 * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
	 *
	 * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
	 * of the item not by reference, but by the result of the `track by` expression. For example, if your
	 * collection items have an id property, you would `track by item.id`.
	 *
	 * A different issue with objects or collections is that ngModel won't detect if an object property or
	 * a collection item changes. For that reason, `ngOptions` additionally watches the model using
	 * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
	 * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
	 * has not changed identity, but only a property on the object or an item in the collection changes.
	 *
	 * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
	 * if the model is an array). This means that changing a property deeper than the first level inside the
	 * object/collection will not trigger a re-rendering.
	 *
	 * ## `select` **`as`**
	 *
	 * Using `select` **`as`** will bind the result of the `select` expression to the model, but
	 * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
	 * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
	 * is used, the result of that expression will be set as the value of the `option` and `select` elements.
	 *
	 *
	 * ### `select` **`as`** and **`track by`**
	 *
	 * <div class="alert alert-warning">
	 * Be careful when using `select` **`as`** and **`track by`** in the same expression.
	 * </div>
	 *
	 * Given this array of items on the $scope:
	 *
	 * ```js
	 * $scope.items = [{
	 *   id: 1,
	 *   label: 'aLabel',
	 *   subItem: { name: 'aSubItem' }
	 * }, {
	 *   id: 2,
	 *   label: 'bLabel',
	 *   subItem: { name: 'bSubItem' }
	 * }];
	 * ```
	 *
	 * This will work:
	 *
	 * ```html
	 * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0];
	 * ```
	 *
	 * but this will not work:
	 *
	 * ```html
	 * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
	 * ```
	 * ```js
	 * $scope.selected = $scope.items[0].subItem;
	 * ```
	 *
	 * In both examples, the **`track by`** expression is applied successfully to each `item` in the
	 * `items` array. Because the selected option has been set programmatically in the controller, the
	 * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
	 * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
	 * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
	 * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
	 * is not matched against any `<option>` and the `<select>` appears as having no selected value.
	 *
	 *
	 * @param {string} ngModel Assignable AngularJS expression to data-bind to.
	 * @param {comprehension_expression} ngOptions in one of the following forms:
	 *
	 *   * for array data sources:
	 *     * `label` **`for`** `value` **`in`** `array`
	 *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
	 *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
	 *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
	 *        (for including a filter with `track by`)
	 *   * for object data sources:
	 *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
	 *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`group by`** `group`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *     * `select` **`as`** `label` **`disable when`** `disable`
	 *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
	 *
	 * Where:
	 *
	 *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
	 *   * `value`: local variable which will refer to each item in the `array` or each property value
	 *      of `object` during iteration.
	 *   * `key`: local variable which will refer to a property name in `object` during iteration.
	 *   * `label`: The result of this expression will be the label for `<option>` element. The
	 *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
	 *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
	 *      element. If not specified, `select` expression will default to `value`.
	 *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
	 *      DOM element.
	 *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
	 *      element. Return `true` to disable.
	 *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
	 *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
	 *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
	 *      even when the options are recreated (e.g. reloaded from the server).
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} required The control is considered valid only if value is entered.
	 * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
	 *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
	 *    `required` when you want to data-bind to the `required` attribute.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	    <example module="selectExample" name="select">
	      <file name="index.html">
	        <script>
	        angular.module('selectExample', [])
	          .controller('ExampleController', ['$scope', function($scope) {
	            $scope.colors = [
	              {name:'black', shade:'dark'},
	              {name:'white', shade:'light', notAnOption: true},
	              {name:'red', shade:'dark'},
	              {name:'blue', shade:'dark', notAnOption: true},
	              {name:'yellow', shade:'light', notAnOption: false}
	            ];
	            $scope.myColor = $scope.colors[2]; // red
	          }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <ul>
	            <li ng-repeat="color in colors">
	              <label>Name: <input ng-model="color.name"></label>
	              <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
	              <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
	            </li>
	            <li>
	              <button ng-click="colors.push({})">add</button>
	            </li>
	          </ul>
	          <hr/>
	          <label>Color (null not allowed):
	            <select ng-model="myColor" ng-options="color.name for color in colors"></select>
	          </label><br/>
	          <label>Color (null allowed):
	          <span  class="nullable">
	            <select ng-model="myColor" ng-options="color.name for color in colors">
	              <option value="">-- choose color --</option>
	            </select>
	          </span></label><br/>
	
	          <label>Color grouped by shade:
	            <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
	            </select>
	          </label><br/>
	
	          <label>Color grouped by shade, with some disabled:
	            <select ng-model="myColor"
	                  ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
	            </select>
	          </label><br/>
	
	
	
	          Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
	          <br/>
	          <hr/>
	          Currently selected: {{ {selected_color:myColor} }}
	          <div style="border:solid 1px black; height:20px"
	               ng-style="{'background-color':myColor.name}">
	          </div>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	         it('should check ng-options', function() {
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
	           element.all(by.model('myColor')).first().click();
	           element.all(by.css('select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
	           element(by.css('.nullable select[ng-model="myColor"]')).click();
	           element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
	           expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
	         });
	      </file>
	    </example>
	 */
	
	/* eslint-disable max-len */
	//                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
	var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
	                        // 1: value expression (valueFn)
	                        // 2: label expression (displayFn)
	                        // 3: group by expression (groupByFn)
	                        // 4: disable when expression (disableWhenFn)
	                        // 5: array item variable name
	                        // 6: object item key variable name
	                        // 7: object item value variable name
	                        // 8: collection expression
	                        // 9: track by expression
	/* eslint-enable */
	
	
	var ngOptionsDirective = ['$compile', '$document', '$parse', function($compile, $document, $parse) {
	
	  function parseOptionsExpression(optionsExp, selectElement, scope) {
	
	    var match = optionsExp.match(NG_OPTIONS_REGEXP);
	    if (!(match)) {
	      throw ngOptionsMinErr('iexp',
	        'Expected expression in form of ' +
	        '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' +
	        ' but got \'{0}\'. Element: {1}',
	        optionsExp, startingTag(selectElement));
	    }
	
	    // Extract the parts from the ngOptions expression
	
	    // The variable name for the value of the item in the collection
	    var valueName = match[5] || match[7];
	    // The variable name for the key of the item in the collection
	    var keyName = match[6];
	
	    // An expression that generates the viewValue for an option if there is a label expression
	    var selectAs = / as /.test(match[0]) && match[1];
	    // An expression that is used to track the id of each object in the options collection
	    var trackBy = match[9];
	    // An expression that generates the viewValue for an option if there is no label expression
	    var valueFn = $parse(match[2] ? match[1] : valueName);
	    var selectAsFn = selectAs && $parse(selectAs);
	    var viewValueFn = selectAsFn || valueFn;
	    var trackByFn = trackBy && $parse(trackBy);
	
	    // Get the value by which we are going to track the option
	    // if we have a trackFn then use that (passing scope and locals)
	    // otherwise just hash the given viewValue
	    var getTrackByValueFn = trackBy ?
	                              function(value, locals) { return trackByFn(scope, locals); } :
	                              function getHashOfValue(value) { return hashKey(value); };
	    var getTrackByValue = function(value, key) {
	      return getTrackByValueFn(value, getLocals(value, key));
	    };
	
	    var displayFn = $parse(match[2] || match[1]);
	    var groupByFn = $parse(match[3] || '');
	    var disableWhenFn = $parse(match[4] || '');
	    var valuesFn = $parse(match[8]);
	
	    var locals = {};
	    var getLocals = keyName ? function(value, key) {
	      locals[keyName] = key;
	      locals[valueName] = value;
	      return locals;
	    } : function(value) {
	      locals[valueName] = value;
	      return locals;
	    };
	
	
	    function Option(selectValue, viewValue, label, group, disabled) {
	      this.selectValue = selectValue;
	      this.viewValue = viewValue;
	      this.label = label;
	      this.group = group;
	      this.disabled = disabled;
	    }
	
	    function getOptionValuesKeys(optionValues) {
	      var optionValuesKeys;
	
	      if (!keyName && isArrayLike(optionValues)) {
	        optionValuesKeys = optionValues;
	      } else {
	        // if object, extract keys, in enumeration order, unsorted
	        optionValuesKeys = [];
	        for (var itemKey in optionValues) {
	          if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
	            optionValuesKeys.push(itemKey);
	          }
	        }
	      }
	      return optionValuesKeys;
	    }
	
	    return {
	      trackBy: trackBy,
	      getTrackByValue: getTrackByValue,
	      getWatchables: $parse(valuesFn, function(optionValues) {
	        // Create a collection of things that we would like to watch (watchedArray)
	        // so that they can all be watched using a single $watchCollection
	        // that only runs the handler once if anything changes
	        var watchedArray = [];
	        optionValues = optionValues || [];
	
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	
	          var locals = getLocals(value, key);
	          var selectValue = getTrackByValueFn(value, locals);
	          watchedArray.push(selectValue);
	
	          // Only need to watch the displayFn if there is a specific label expression
	          if (match[2] || match[1]) {
	            var label = displayFn(scope, locals);
	            watchedArray.push(label);
	          }
	
	          // Only need to watch the disableWhenFn if there is a specific disable expression
	          if (match[4]) {
	            var disableWhen = disableWhenFn(scope, locals);
	            watchedArray.push(disableWhen);
	          }
	        }
	        return watchedArray;
	      }),
	
	      getOptions: function() {
	
	        var optionItems = [];
	        var selectValueMap = {};
	
	        // The option values were already computed in the `getWatchables` fn,
	        // which must have been called to trigger `getOptions`
	        var optionValues = valuesFn(scope) || [];
	        var optionValuesKeys = getOptionValuesKeys(optionValues);
	        var optionValuesLength = optionValuesKeys.length;
	
	        for (var index = 0; index < optionValuesLength; index++) {
	          var key = (optionValues === optionValuesKeys) ? index : optionValuesKeys[index];
	          var value = optionValues[key];
	          var locals = getLocals(value, key);
	          var viewValue = viewValueFn(scope, locals);
	          var selectValue = getTrackByValueFn(viewValue, locals);
	          var label = displayFn(scope, locals);
	          var group = groupByFn(scope, locals);
	          var disabled = disableWhenFn(scope, locals);
	          var optionItem = new Option(selectValue, viewValue, label, group, disabled);
	
	          optionItems.push(optionItem);
	          selectValueMap[selectValue] = optionItem;
	        }
	
	        return {
	          items: optionItems,
	          selectValueMap: selectValueMap,
	          getOptionFromViewValue: function(value) {
	            return selectValueMap[getTrackByValue(value)];
	          },
	          getViewValueFromOption: function(option) {
	            // If the viewValue could be an object that may be mutated by the application,
	            // we need to make a copy and not return the reference to the value on the option.
	            return trackBy ? copy(option.viewValue) : option.viewValue;
	          }
	        };
	      }
	    };
	  }
	
	
	  // we can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  var optionTemplate = window.document.createElement('option'),
	      optGroupTemplate = window.document.createElement('optgroup');
	
	    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	      var multiple = attr.multiple;
	
	      // The emptyOption allows the application developer to provide their own custom "empty"
	      // option when the viewValue does not match any of the option values.
	      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
	        if (children[i].value === '') {
	          selectCtrl.hasEmptyOption = true;
	          selectCtrl.emptyOption = children.eq(i);
	          break;
	        }
	      }
	
	      var providedEmptyOption = !!selectCtrl.emptyOption;
	
	      var unknownOption = jqLite(optionTemplate.cloneNode(false));
	      unknownOption.val('?');
	
	      var options;
	      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
	      // This stores the newly created options before they are appended to the select.
	      // Since the contents are removed from the fragment when it is appended,
	      // we only need to create it once.
	      var listFragment = $document[0].createDocumentFragment();
	
	      // Overwrite the implementation. ngOptions doesn't use hashes
	      selectCtrl.generateUnknownOptionValue = function(val) {
	        return '?';
	      };
	
	      // Update the controller methods for multiple selectable options
	      if (!multiple) {
	
	        selectCtrl.writeValue = function writeNgOptionsValue(value) {
	          var selectedOption = options.selectValueMap[selectElement.val()];
	          var option = options.getOptionFromViewValue(value);
	
	          // Make sure to remove the selected attribute from the previously selected option
	          // Otherwise, screen readers might get confused
	          if (selectedOption) selectedOption.element.removeAttribute('selected');
	
	          if (option) {
	            // Don't update the option when it is already selected.
	            // For example, the browser will select the first option by default. In that case,
	            // most properties are set automatically - except the `selected` attribute, which we
	            // set always
	
	            if (selectElement[0].value !== option.selectValue) {
	              selectCtrl.removeUnknownOption();
	              selectCtrl.unselectEmptyOption();
	
	              selectElement[0].value = option.selectValue;
	              option.element.selected = true;
	            }
	
	            option.element.setAttribute('selected', 'selected');
	          } else {
	
	            if (providedEmptyOption) {
	              selectCtrl.selectEmptyOption();
	            } else if (selectCtrl.unknownOption.parent().length) {
	              selectCtrl.updateUnknownOption(value);
	            } else {
	              selectCtrl.renderUnknownOption(value);
	            }
	          }
	        };
	
	        selectCtrl.readValue = function readNgOptionsValue() {
	
	          var selectedOption = options.selectValueMap[selectElement.val()];
	
	          if (selectedOption && !selectedOption.disabled) {
	            selectCtrl.unselectEmptyOption();
	            selectCtrl.removeUnknownOption();
	            return options.getViewValueFromOption(selectedOption);
	          }
	          return null;
	        };
	
	        // If we are using `track by` then we must watch the tracked value on the model
	        // since ngModel only watches for object identity change
	        // FIXME: When a user selects an option, this watch will fire needlessly
	        if (ngOptions.trackBy) {
	          scope.$watch(
	            function() { return ngOptions.getTrackByValue(ngModelCtrl.$viewValue); },
	            function() { ngModelCtrl.$render(); }
	          );
	        }
	
	      } else {
	
	        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
	          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
	          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
	
	          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
	
	          options.items.forEach(function(option) {
	            if (option.element.selected && !includes(selectedOptions, option)) {
	              option.element.selected = false;
	            }
	          });
	        };
	
	
	        selectCtrl.readValue = function readNgOptionsMultiple() {
	          var selectedValues = selectElement.val() || [],
	              selections = [];
	
	          forEach(selectedValues, function(value) {
	            var option = options.selectValueMap[value];
	            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
	          });
	
	          return selections;
	        };
	
	        // If we are using `track by` then we must watch these tracked values on the model
	        // since ngModel only watches for object identity change
	        if (ngOptions.trackBy) {
	
	          scope.$watchCollection(function() {
	            if (isArray(ngModelCtrl.$viewValue)) {
	              return ngModelCtrl.$viewValue.map(function(value) {
	                return ngOptions.getTrackByValue(value);
	              });
	            }
	          }, function() {
	            ngModelCtrl.$render();
	          });
	
	        }
	      }
	
	      if (providedEmptyOption) {
	
	        // we need to remove it before calling selectElement.empty() because otherwise IE will
	        // remove the label from the element. wtf?
	        selectCtrl.emptyOption.remove();
	
	        // compile the element since there might be bindings in it
	        $compile(selectCtrl.emptyOption)(scope);
	
	        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
	          // This means the empty option has currently no actual DOM node, probably because
	          // it has been modified by a transclusion directive.
	          selectCtrl.hasEmptyOption = false;
	
	          // Redefine the registerOption function, which will catch
	          // options that are added by ngIf etc. (rendering of the node is async because of
	          // lazy transclusion)
	          selectCtrl.registerOption = function(optionScope, optionEl) {
	            if (optionEl.val() === '') {
	              selectCtrl.hasEmptyOption = true;
	              selectCtrl.emptyOption = optionEl;
	              selectCtrl.emptyOption.removeClass('ng-scope');
	              // This ensures the new empty option is selected if previously no option was selected
	              ngModelCtrl.$render();
	
	              optionEl.on('$destroy', function() {
	                selectCtrl.hasEmptyOption = false;
	                selectCtrl.emptyOption = undefined;
	              });
	            }
	          };
	
	        } else {
	          // remove the class, which is added automatically because we recompile the element and it
	          // becomes the compilation root
	          selectCtrl.emptyOption.removeClass('ng-scope');
	        }
	
	      }
	
	      selectElement.empty();
	
	      // We need to do this here to ensure that the options object is defined
	      // when we first hit it in writeNgOptionsValue
	      updateOptions();
	
	      // We will re-render the option elements if the option values or labels change
	      scope.$watchCollection(ngOptions.getWatchables, updateOptions);
	
	      // ------------------------------------------------------------------ //
	
	      function addOptionElement(option, parent) {
	        var optionElement = optionTemplate.cloneNode(false);
	        parent.appendChild(optionElement);
	        updateOptionElement(option, optionElement);
	      }
	
	      function getAndUpdateSelectedOption(viewValue) {
	        var option = options.getOptionFromViewValue(viewValue);
	        var element = option && option.element;
	
	        if (element && !element.selected) element.selected = true;
	
	        return option;
	      }
	
	      function updateOptionElement(option, element) {
	        option.element = element;
	        element.disabled = option.disabled;
	        // NOTE: The label must be set before the value, otherwise IE10/11/EDGE create unresponsive
	        // selects in certain circumstances when multiple selects are next to each other and display
	        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
	        // See https://github.com/angular/angular.js/issues/11314 for more info.
	        // This is unfortunately untestable with unit / e2e tests
	        if (option.label !== element.label) {
	          element.label = option.label;
	          element.textContent = option.label;
	        }
	        element.value = option.selectValue;
	      }
	
	      function updateOptions() {
	        var previousValue = options && selectCtrl.readValue();
	
	        // We must remove all current options, but cannot simply set innerHTML = null
	        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
	        // must preserve.
	        // Instead, iterate over the current option elements and remove them or their optgroup
	        // parents
	        if (options) {
	
	          for (var i = options.items.length - 1; i >= 0; i--) {
	            var option = options.items[i];
	            if (isDefined(option.group)) {
	              jqLiteRemove(option.element.parentNode);
	            } else {
	              jqLiteRemove(option.element);
	            }
	          }
	        }
	
	        options = ngOptions.getOptions();
	
	        var groupElementMap = {};
	
	        // Ensure that the empty option is always there if it was explicitly provided
	        if (providedEmptyOption) {
	          selectElement.prepend(selectCtrl.emptyOption);
	        }
	
	        options.items.forEach(function addOption(option) {
	          var groupElement;
	
	          if (isDefined(option.group)) {
	
	            // This option is to live in a group
	            // See if we have already created this group
	            groupElement = groupElementMap[option.group];
	
	            if (!groupElement) {
	
	              groupElement = optGroupTemplate.cloneNode(false);
	              listFragment.appendChild(groupElement);
	
	              // Update the label on the group element
	              // "null" is special cased because of Safari
	              groupElement.label = option.group === null ? 'null' : option.group;
	
	              // Store it for use later
	              groupElementMap[option.group] = groupElement;
	            }
	
	            addOptionElement(option, groupElement);
	
	          } else {
	
	            // This option is not in a group
	            addOptionElement(option, listFragment);
	          }
	        });
	
	        selectElement[0].appendChild(listFragment);
	
	        ngModelCtrl.$render();
	
	        // Check to see if the value has changed due to the update to the options
	        if (!ngModelCtrl.$isEmpty(previousValue)) {
	          var nextValue = selectCtrl.readValue();
	          var isNotPrimitive = ngOptions.trackBy || multiple;
	          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
	            ngModelCtrl.$setViewValue(nextValue);
	            ngModelCtrl.$render();
	          }
	        }
	
	      }
	  }
	
	  return {
	    restrict: 'A',
	    terminal: true,
	    require: ['select', 'ngModel'],
	    link: {
	      pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
	        // Deactivate the SelectController.register method to prevent
	        // option directives from accidentally registering themselves
	        // (and unwanted $destroy handlers etc.)
	        ctrls[0].registerOption = noop;
	      },
	      post: ngOptionsPostLink
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngPluralize
	 * @restrict EA
	 *
	 * @description
	 * `ngPluralize` is a directive that displays messages according to en-US localization rules.
	 * These rules are bundled with angular.js, but can be overridden
	 * (see {@link guide/i18n Angular i18n} dev guide). You configure ngPluralize directive
	 * by specifying the mappings between
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * and the strings to be displayed.
	 *
	 * # Plural categories and explicit number rules
	 * There are two
	 * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
	 * in Angular's default en-US locale: "one" and "other".
	 *
	 * While a plural category may match many numbers (for example, in en-US locale, "other" can match
	 * any number that is not 1), an explicit number rule can only match one number. For example, the
	 * explicit number rule for "3" matches the number 3. There are examples of plural categories
	 * and explicit number rules throughout the rest of this documentation.
	 *
	 * # Configuring ngPluralize
	 * You configure ngPluralize by providing 2 attributes: `count` and `when`.
	 * You can also provide an optional attribute, `offset`.
	 *
	 * The value of the `count` attribute can be either a string or an {@link guide/expression
	 * Angular expression}; these are evaluated on the current scope for its bound value.
	 *
	 * The `when` attribute specifies the mappings between plural categories and the actual
	 * string to be displayed. The value of the attribute should be a JSON object.
	 *
	 * The following example shows how to configure ngPluralize:
	 *
	 * ```html
	 * <ng-pluralize count="personCount"
	                 when="{'0': 'Nobody is viewing.',
	 *                      'one': '1 person is viewing.',
	 *                      'other': '{} people are viewing.'}">
	 * </ng-pluralize>
	 *```
	 *
	 * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
	 * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
	 * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
	 * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
	 * show "a dozen people are viewing".
	 *
	 * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
	 * into pluralized strings. In the previous example, Angular will replace `{}` with
	 * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
	 * for <span ng-non-bindable>{{numberExpression}}</span>.
	 *
	 * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
	 * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
	 *
	 * # Configuring ngPluralize with offset
	 * The `offset` attribute allows further customization of pluralized text, which can result in
	 * a better user experience. For example, instead of the message "4 people are viewing this document",
	 * you might display "John, Kate and 2 others are viewing this document".
	 * The offset attribute allows you to offset a number by any desired value.
	 * Let's take a look at an example:
	 *
	 * ```html
	 * <ng-pluralize count="personCount" offset=2
	 *               when="{'0': 'Nobody is viewing.',
	 *                      '1': '{{person1}} is viewing.',
	 *                      '2': '{{person1}} and {{person2}} are viewing.',
	 *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
	 *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	 * </ng-pluralize>
	 * ```
	 *
	 * Notice that we are still using two plural categories(one, other), but we added
	 * three explicit number rules 0, 1 and 2.
	 * When one person, perhaps John, views the document, "John is viewing" will be shown.
	 * When three people view the document, no explicit number rule is found, so
	 * an offset of 2 is taken off 3, and Angular uses 1 to decide the plural category.
	 * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
	 * is shown.
	 *
	 * Note that when you specify offsets, you must provide explicit number rules for
	 * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
	 * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
	 * plural categories "one" and "other".
	 *
	 * @param {string|expression} count The variable to be bound to.
	 * @param {string} when The mapping between plural category to its corresponding strings.
	 * @param {number=} offset Offset to deduct from the total number.
	 *
	 * @example
	    <example module="pluralizeExample" name="ng-pluralize">
	      <file name="index.html">
	        <script>
	          angular.module('pluralizeExample', [])
	            .controller('ExampleController', ['$scope', function($scope) {
	              $scope.person1 = 'Igor';
	              $scope.person2 = 'Misko';
	              $scope.personCount = 1;
	            }]);
	        </script>
	        <div ng-controller="ExampleController">
	          <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
	          <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
	          <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
	
	          <!--- Example with simple pluralization rules for en locale --->
	          Without Offset:
	          <ng-pluralize count="personCount"
	                        when="{'0': 'Nobody is viewing.',
	                               'one': '1 person is viewing.',
	                               'other': '{} people are viewing.'}">
	          </ng-pluralize><br>
	
	          <!--- Example with offset --->
	          With Offset(2):
	          <ng-pluralize count="personCount" offset=2
	                        when="{'0': 'Nobody is viewing.',
	                               '1': '{{person1}} is viewing.',
	                               '2': '{{person1}} and {{person2}} are viewing.',
	                               'one': '{{person1}}, {{person2}} and one other person are viewing.',
	                               'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
	          </ng-pluralize>
	        </div>
	      </file>
	      <file name="protractor.js" type="protractor">
	        it('should show correct pluralized string', function() {
	          var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var countInput = element(by.model('personCount'));
	
	          expect(withoutOffset.getText()).toEqual('1 person is viewing.');
	          expect(withOffset.getText()).toEqual('Igor is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('0');
	
	          expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
	          expect(withOffset.getText()).toEqual('Nobody is viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('2');
	
	          expect(withoutOffset.getText()).toEqual('2 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('3');
	
	          expect(withoutOffset.getText()).toEqual('3 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
	
	          countInput.clear();
	          countInput.sendKeys('4');
	
	          expect(withoutOffset.getText()).toEqual('4 people are viewing.');
	          expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
	        });
	        it('should show data-bound names', function() {
	          var withOffset = element.all(by.css('ng-pluralize')).get(1);
	          var personCount = element(by.model('personCount'));
	          var person1 = element(by.model('person1'));
	          var person2 = element(by.model('person2'));
	          personCount.clear();
	          personCount.sendKeys('4');
	          person1.clear();
	          person1.sendKeys('Di');
	          person2.clear();
	          person2.sendKeys('Vojta');
	          expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
	        });
	      </file>
	    </example>
	 */
	var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function($locale, $interpolate, $log) {
	  var BRACE = /{}/g,
	      IS_WHEN = /^when(Minus)?(.+)$/;
	
	  return {
	    link: function(scope, element, attr) {
	      var numberExp = attr.count,
	          whenExp = attr.$attr.when && element.attr(attr.$attr.when), // we have {{}} in attrs
	          offset = attr.offset || 0,
	          whens = scope.$eval(whenExp) || {},
	          whensExpFns = {},
	          startSymbol = $interpolate.startSymbol(),
	          endSymbol = $interpolate.endSymbol(),
	          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
	          watchRemover = angular.noop,
	          lastCount;
	
	      forEach(attr, function(expression, attributeName) {
	        var tmpMatch = IS_WHEN.exec(attributeName);
	        if (tmpMatch) {
	          var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
	          whens[whenKey] = element.attr(attr.$attr[attributeName]);
	        }
	      });
	      forEach(whens, function(expression, key) {
	        whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
	
	      });
	
	      scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
	        var count = parseFloat(newVal);
	        var countIsNaN = isNumberNaN(count);
	
	        if (!countIsNaN && !(count in whens)) {
	          // If an explicit number rule such as 1, 2, 3... is defined, just use it.
	          // Otherwise, check it against pluralization rules in $locale service.
	          count = $locale.pluralCat(count - offset);
	        }
	
	        // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
	        // In JS `NaN !== NaN`, so we have to explicitly check.
	        if ((count !== lastCount) && !(countIsNaN && isNumberNaN(lastCount))) {
	          watchRemover();
	          var whenExpFn = whensExpFns[count];
	          if (isUndefined(whenExpFn)) {
	            if (newVal != null) {
	              $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
	            }
	            watchRemover = noop;
	            updateElementText();
	          } else {
	            watchRemover = scope.$watch(whenExpFn, updateElementText);
	          }
	          lastCount = count;
	        }
	      });
	
	      function updateElementText(newText) {
	        element.text(newText || '');
	      }
	    }
	  };
	}];
	
	/* exported ngRepeatDirective */
	
	/**
	 * @ngdoc directive
	 * @name ngRepeat
	 * @multiElement
	 * @restrict A
	 *
	 * @description
	 * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
	 * instance gets its own scope, where the given loop variable is set to the current collection item,
	 * and `$index` is set to the item index or key.
	 *
	 * Special properties are exposed on the local scope of each template instance, including:
	 *
	 * | Variable  | Type            | Details                                                                     |
	 * |-----------|-----------------|-----------------------------------------------------------------------------|
	 * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
	 * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
	 * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
	 * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
	 * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
	 * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
	 *
	 * <div class="alert alert-info">
	 *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
	 *   This may be useful when, for instance, nesting ngRepeats.
	 * </div>
	 *
	 *
	 * # Iterating over object properties
	 *
	 * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
	 * syntax:
	 *
	 * ```js
	 * <div ng-repeat="(key, value) in myObj"> ... </div>
	 * ```
	 *
	 * However, there are a few limitations compared to array iteration:
	 *
	 * - The JavaScript specification does not define the order of keys
	 *   returned for an object, so Angular relies on the order returned by the browser
	 *   when running `for key in myObj`. Browsers generally follow the strategy of providing
	 *   keys in the order in which they were defined, although there are exceptions when keys are deleted
	 *   and reinstated. See the
	 *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
	 *
	 * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
	 *   it's a prefix used by Angular for public (`$`) and private (`$$`) properties.
	 *
	 * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
	 *   objects, and will throw an error if used with one.
	 *
	 * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
	 * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
	 * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
	 * or implement a `$watch` on the object yourself.
	 *
	 *
	 * # Tracking and Duplicates
	 *
	 * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
	 * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
	 *
	 * * When an item is added, a new instance of the template is added to the DOM.
	 * * When an item is removed, its template instance is removed from the DOM.
	 * * When items are reordered, their respective templates are reordered in the DOM.
	 *
	 * To minimize creation of DOM elements, `ngRepeat` uses a function
	 * to "keep track" of all items in the collection and their corresponding DOM elements.
	 * For example, if an item is added to the collection, `ngRepeat` will know that all other items
	 * already have DOM elements, and will not re-render them.
	 *
	 * The default tracking function (which tracks items by their identity) does not allow
	 * duplicate items in arrays. This is because when there are duplicates, it is not possible
	 * to maintain a one-to-one mapping between collection items and DOM elements.
	 *
	 * If you do need to repeat duplicate items, you can substitute the default tracking behavior
	 * with your own using the `track by` expression.
	 *
	 * For example, you may track items by the index of each item in the collection, using the
	 * special scope property `$index`:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by $index">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * You may also use arbitrary expressions in `track by`, including references to custom functions
	 * on the scope:
	 * ```html
	 *    <div ng-repeat="n in [42, 42, 43, 43] track by myTrackingFunction(n)">
	 *      {{n}}
	 *    </div>
	 * ```
	 *
	 * <div class="alert alert-success">
	 * If you are working with objects that have a unique identifier property, you should track
	 * by this identifier instead of the object instance. Should you reload your data later, `ngRepeat`
	 * will not have to rebuild the DOM elements for items it has already rendered, even if the
	 * JavaScript objects in the collection have been substituted for new ones. For large collections,
	 * this significantly improves rendering performance. If you don't have a unique identifier,
	 * `track by $index` can also provide a performance boost.
	 * </div>
	 *
	 * ```html
	 *    <div ng-repeat="model in collection track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * Avoid using `track by $index` when the repeated template contains
	 * {@link guide/expression#one-time-binding one-time bindings}. In such cases, the `nth` DOM
	 * element will always be matched with the `nth` item of the array, so the bindings on that element
	 * will not be updated even when the corresponding item changes, essentially causing the view to get
	 * out-of-sync with the underlying data.
	 * </div>
	 *
	 * When no `track by` expression is provided, it is equivalent to tracking by the built-in
	 * `$id` function, which tracks items by their identity:
	 * ```html
	 *    <div ng-repeat="obj in collection track by $id(obj)">
	 *      {{obj.prop}}
	 *    </div>
	 * ```
	 *
	 * <br />
	 * <div class="alert alert-warning">
	 * **Note:** `track by` must always be the last expression:
	 * </div>
	 * ```
	 *    <div ng-repeat="model in collection | orderBy: 'id' as filtered_result track by model.id">
	 *      {{model.name}}
	 *    </div>
	 * ```
	 *
	 *
	 * # Special repeat start and end points
	 * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
	 * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
	 * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
	 * up to and including the ending HTML tag where **ng-repeat-end** is placed.
	 *
	 * The example below makes use of this feature:
	 * ```html
	 *   <header ng-repeat-start="item in items">
	 *     Header {{ item }}
	 *   </header>
	 *   <div class="body">
	 *     Body {{ item }}
	 *   </div>
	 *   <footer ng-repeat-end>
	 *     Footer {{ item }}
	 *   </footer>
	 * ```
	 *
	 * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
	 * ```html
	 *   <header>
	 *     Header A
	 *   </header>
	 *   <div class="body">
	 *     Body A
	 *   </div>
	 *   <footer>
	 *     Footer A
	 *   </footer>
	 *   <header>
	 *     Header B
	 *   </header>
	 *   <div class="body">
	 *     Body B
	 *   </div>
	 *   <footer>
	 *     Footer B
	 *   </footer>
	 * ```
	 *
	 * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
	 * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
	 *
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
	 * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
	 * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
	 *
	 * See the example below for defining CSS animations with ngRepeat.
	 *
	 * @element ANY
	 * @scope
	 * @priority 1000
	 * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
	 *   formats are currently supported:
	 *
	 *   * `variable in expression` – where variable is the user defined loop variable and `expression`
	 *     is a scope expression giving the collection to enumerate.
	 *
	 *     For example: `album in artist.albums`.
	 *
	 *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
	 *     and `expression` is the scope expression giving the collection to enumerate.
	 *
	 *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
	 *
	 *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
	 *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
	 *     is specified, ng-repeat associates elements by identity. It is an error to have
	 *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
	 *     mapped to the same DOM element, which is not possible.)
	 *
	 *     Note that the tracking expression must come last, after any filters, and the alias expression.
	 *
	 *     For example: `item in items` is equivalent to `item in items track by $id(item)`. This implies that the DOM elements
	 *     will be associated by item identity in the array.
	 *
	 *     For example: `item in items track by $id(item)`. A built in `$id()` function can be used to assign a unique
	 *     `$$hashKey` property to each item in the array. This property is then used as a key to associated DOM elements
	 *     with the corresponding item in the array by identity. Moving the same object in array would move the DOM
	 *     element in the same way in the DOM.
	 *
	 *     For example: `item in items track by item.id` is a typical pattern when the items come from the database. In this
	 *     case the object identity does not matter. Two objects are considered equivalent as long as their `id`
	 *     property is same.
	 *
	 *     For example: `item in items | filter:searchText track by item.id` is a pattern that might be used to apply a filter
	 *     to items in conjunction with a tracking expression.
	 *
	 *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
	 *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
	 *     when a filter is active on the repeater, but the filtered result set is empty.
	 *
	 *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
	 *     the items have been processed through the filter.
	 *
	 *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat micro-syntax so it can be used only at the end
	 *     (and not as operator, inside an expression).
	 *
	 *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results` .
	 *
	 * @example
	 * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
	 * results by name or by age. New (entering) and removed (leaving) items are animated.
	  <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true" name="ng-repeat">
	    <file name="index.html">
	      <div ng-controller="repeatController">
	        I have {{friends.length}} friends. They are:
	        <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
	        <ul class="example-animate-container">
	          <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results">
	            [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
	          </li>
	          <li class="animate-repeat" ng-if="results.length === 0">
	            <strong>No results found...</strong>
	          </li>
	        </ul>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
	        $scope.friends = [
	          {name:'John', age:25, gender:'boy'},
	          {name:'Jessie', age:30, gender:'girl'},
	          {name:'Johanna', age:28, gender:'girl'},
	          {name:'Joy', age:15, gender:'girl'},
	          {name:'Mary', age:28, gender:'girl'},
	          {name:'Peter', age:95, gender:'boy'},
	          {name:'Sebastian', age:50, gender:'boy'},
	          {name:'Erika', age:27, gender:'girl'},
	          {name:'Patrick', age:40, gender:'boy'},
	          {name:'Samantha', age:60, gender:'girl'}
	        ];
	      });
	    </file>
	    <file name="animations.css">
	      .example-animate-container {
	        background:white;
	        border:1px solid black;
	        list-style:none;
	        margin:0;
	        padding:0 10px;
	      }
	
	      .animate-repeat {
	        line-height:30px;
	        list-style:none;
	        box-sizing:border-box;
	      }
	
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter,
	      .animate-repeat.ng-leave {
	        transition:all linear 0.5s;
	      }
	
	      .animate-repeat.ng-leave.ng-leave-active,
	      .animate-repeat.ng-move,
	      .animate-repeat.ng-enter {
	        opacity:0;
	        max-height:0;
	      }
	
	      .animate-repeat.ng-leave,
	      .animate-repeat.ng-move.ng-move-active,
	      .animate-repeat.ng-enter.ng-enter-active {
	        opacity:1;
	        max-height:30px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var friends = element.all(by.repeater('friend in friends'));
	
	      it('should render initial data set', function() {
	        expect(friends.count()).toBe(10);
	        expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
	        expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
	        expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
	        expect(element(by.binding('friends.length')).getText())
	            .toMatch("I have 10 friends. They are:");
	      });
	
	       it('should update repeater when filter predicate changes', function() {
	         expect(friends.count()).toBe(10);
	
	         element(by.model('q')).sendKeys('ma');
	
	         expect(friends.count()).toBe(2);
	         expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
	         expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
	       });
	      </file>
	    </example>
	 */
	var ngRepeatDirective = ['$parse', '$animate', '$compile', function($parse, $animate, $compile) {
	  var NG_REMOVED = '$$NG_REMOVED';
	  var ngRepeatMinErr = minErr('ngRepeat');
	
	  var updateScope = function(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
	    // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
	    scope[valueIdentifier] = value;
	    if (keyIdentifier) scope[keyIdentifier] = key;
	    scope.$index = index;
	    scope.$first = (index === 0);
	    scope.$last = (index === (arrayLength - 1));
	    scope.$middle = !(scope.$first || scope.$last);
	    // eslint-disable-next-line no-bitwise
	    scope.$odd = !(scope.$even = (index & 1) === 0);
	  };
	
	  var getBlockStart = function(block) {
	    return block.clone[0];
	  };
	
	  var getBlockEnd = function(block) {
	    return block.clone[block.clone.length - 1];
	  };
	
	
	  return {
	    restrict: 'A',
	    multiElement: true,
	    transclude: 'element',
	    priority: 1000,
	    terminal: true,
	    $$tlb: true,
	    compile: function ngRepeatCompile($element, $attr) {
	      var expression = $attr.ngRepeat;
	      var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
	
	      var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.',
	            expression);
	      }
	
	      var lhs = match[1];
	      var rhs = match[2];
	      var aliasAs = match[3];
	      var trackByExp = match[4];
	
	      match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
	
	      if (!match) {
	        throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.',
	            lhs);
	      }
	      var valueIdentifier = match[3] || match[1];
	      var keyIdentifier = match[2];
	
	      if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) ||
	          /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
	        throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.',
	          aliasAs);
	      }
	
	      var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
	      var hashFnLocals = {$id: hashKey};
	
	      if (trackByExp) {
	        trackByExpGetter = $parse(trackByExp);
	      } else {
	        trackByIdArrayFn = function(key, value) {
	          return hashKey(value);
	        };
	        trackByIdObjFn = function(key) {
	          return key;
	        };
	      }
	
	      return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
	
	        if (trackByExpGetter) {
	          trackByIdExpFn = function(key, value, index) {
	            // assign key, value, and $index to the locals so that they can be used in hash functions
	            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
	            hashFnLocals[valueIdentifier] = value;
	            hashFnLocals.$index = index;
	            return trackByExpGetter($scope, hashFnLocals);
	          };
	        }
	
	        // Store a list of elements from previous run. This is a hash where key is the item from the
	        // iterator, and the value is objects with following properties.
	        //   - scope: bound scope
	        //   - element: previous element.
	        //   - index: position
	        //
	        // We are using no-proto object so that we don't need to guard against inherited props via
	        // hasOwnProperty.
	        var lastBlockMap = createMap();
	
	        //watch props
	        $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
	          var index, length,
	              previousNode = $element[0],     // node that cloned nodes should be inserted after
	                                              // initialized to the comment node anchor
	              nextNode,
	              // Same as lastBlockMap but it has the current state. It will become the
	              // lastBlockMap on the next iteration.
	              nextBlockMap = createMap(),
	              collectionLength,
	              key, value, // key/value of iteration
	              trackById,
	              trackByIdFn,
	              collectionKeys,
	              block,       // last object information {scope, element, id}
	              nextBlockOrder,
	              elementsToRemove;
	
	          if (aliasAs) {
	            $scope[aliasAs] = collection;
	          }
	
	          if (isArrayLike(collection)) {
	            collectionKeys = collection;
	            trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
	          } else {
	            trackByIdFn = trackByIdExpFn || trackByIdObjFn;
	            // if object, extract keys, in enumeration order, unsorted
	            collectionKeys = [];
	            for (var itemKey in collection) {
	              if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
	                collectionKeys.push(itemKey);
	              }
	            }
	          }
	
	          collectionLength = collectionKeys.length;
	          nextBlockOrder = new Array(collectionLength);
	
	          // locate existing items
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            trackById = trackByIdFn(key, value, index);
	            if (lastBlockMap[trackById]) {
	              // found previously seen block
	              block = lastBlockMap[trackById];
	              delete lastBlockMap[trackById];
	              nextBlockMap[trackById] = block;
	              nextBlockOrder[index] = block;
	            } else if (nextBlockMap[trackById]) {
	              // if collision detected. restore lastBlockMap and throw an error
	              forEach(nextBlockOrder, function(block) {
	                if (block && block.scope) lastBlockMap[block.id] = block;
	              });
	              throw ngRepeatMinErr('dupes',
	                  'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}',
	                  expression, trackById, value);
	            } else {
	              // new never before seen block
	              nextBlockOrder[index] = {id: trackById, scope: undefined, clone: undefined};
	              nextBlockMap[trackById] = true;
	            }
	          }
	
	          // remove leftover items
	          for (var blockKey in lastBlockMap) {
	            block = lastBlockMap[blockKey];
	            elementsToRemove = getBlockNodes(block.clone);
	            $animate.leave(elementsToRemove);
	            if (elementsToRemove[0].parentNode) {
	              // if the element was not removed yet because of pending animation, mark it as deleted
	              // so that we can ignore it later
	              for (index = 0, length = elementsToRemove.length; index < length; index++) {
	                elementsToRemove[index][NG_REMOVED] = true;
	              }
	            }
	            block.scope.$destroy();
	          }
	
	          // we are not using forEach for perf reasons (trying to avoid #call)
	          for (index = 0; index < collectionLength; index++) {
	            key = (collection === collectionKeys) ? index : collectionKeys[index];
	            value = collection[key];
	            block = nextBlockOrder[index];
	
	            if (block.scope) {
	              // if we have already seen this object, then we need to reuse the
	              // associated scope/element
	
	              nextNode = previousNode;
	
	              // skip nodes that are already pending removal via leave animation
	              do {
	                nextNode = nextNode.nextSibling;
	              } while (nextNode && nextNode[NG_REMOVED]);
	
	              if (getBlockStart(block) !== nextNode) {
	                // existing item which got moved
	                $animate.move(getBlockNodes(block.clone), null, previousNode);
	              }
	              previousNode = getBlockEnd(block);
	              updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	            } else {
	              // new item which we don't know about
	              $transclude(function ngRepeatTransclude(clone, scope) {
	                block.scope = scope;
	                // http://jsperf.com/clone-vs-createcomment
	                var endNode = ngRepeatEndComment.cloneNode(false);
	                clone[clone.length++] = endNode;
	
	                $animate.enter(clone, null, previousNode);
	                previousNode = endNode;
	                // Note: We only need the first/last node of the cloned nodes.
	                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
	                // by a directive with templateUrl when its template arrives.
	                block.clone = clone;
	                nextBlockMap[block.id] = block;
	                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
	              });
	            }
	          }
	          lastBlockMap = nextBlockMap;
	        });
	      };
	    }
	  };
	}];
	
	var NG_HIDE_CLASS = 'ng-hide';
	var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
	/**
	 * @ngdoc directive
	 * @name ngShow
	 * @multiElement
	 *
	 * @description
	 * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngShow` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is visible) -->
	 * <div ng-show="myValue"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is hidden) -->
	 * <div ng-show="myValue" class="ng-hide"></div>
	 * ```
	 *
	 * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override anything in CSS and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngShow`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                        |
	 * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
	 *
	 * @element ANY
	 * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is shown/hidden respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element animate-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
	    <file name="index.html">
	      Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
	      <div class="check-element funky-show-hide" ng-show="checked">
	        I show up when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngShow', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(false);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(true);
	      });
	    </file>
	  </example>
	 */
	var ngShowDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
	        // we're adding a temporary, animation-specific class for ng-hide since this way
	        // we can control when the element is actually displayed on screen without having
	        // to have a global/greedy CSS selector that breaks when other animations are run.
	        // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
	        $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	
	/**
	 * @ngdoc directive
	 * @name ngHide
	 * @multiElement
	 *
	 * @description
	 * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
	 * the `ngHide` attribute.
	 *
	 * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
	 * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
	 * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
	 * {@link ng.directive:ngCsp ngCsp}).
	 *
	 * ```html
	 * <!-- when $scope.myValue is truthy (element is hidden) -->
	 * <div ng-hide="myValue" class="ng-hide"></div>
	 *
	 * <!-- when $scope.myValue is falsy (element is visible) -->
	 * <div ng-hide="myValue"></div>
	 * ```
	 *
	 * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
	 * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
	 * CSS class is removed from the element causing the element not to appear hidden.
	 *
	 * ## Why is `!important` used?
	 *
	 * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
	 * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
	 * simple as changing the display style on a HTML list item would make hidden elements appear
	 * visible. This also becomes a bigger issue when dealing with CSS frameworks.
	 *
	 * By using `!important`, the show and hide behavior will work as expected despite any clash between
	 * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
	 * developer chooses to override the styling to change how to hide an element then it is just a
	 * matter of using `!important` in their own CSS code.
	 *
	 * ### Overriding `.ng-hide`
	 *
	 * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
	 * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
	 * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
	 * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
	 *
	 * ```css
	 * .ng-hide:not(.ng-hide-animate) {
	 *   /&#42; These are just alternative ways of hiding an element &#42;/
	 *   display: block!important;
	 *   position: absolute;
	 *   top: -9999px;
	 *   left: -9999px;
	 * }
	 * ```
	 *
	 * By default you don't need to override in CSS anything and the animations will work around the
	 * display style.
	 *
	 * ## A note about animations with `ngHide`
	 *
	 * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
	 * directive expression is true and false. This system works like the animation system present with
	 * `ngClass` except that you must also include the `!important` flag to override the display
	 * property so that the elements are not actually hidden during the animation.
	 *
	 * ```css
	 * /&#42; A working example can be found at the bottom of this page. &#42;/
	 * .my-element.ng-hide-add, .my-element.ng-hide-remove {
	 *   transition: all 0.5s linear;
	 * }
	 *
	 * .my-element.ng-hide-add { ... }
	 * .my-element.ng-hide-add.ng-hide-add-active { ... }
	 * .my-element.ng-hide-remove { ... }
	 * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
	 * ```
	 *
	 * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
	 * to block during animation states - ngAnimate will automatically handle the style toggling for you.
	 *
	 * @animations
	 * | Animation                                           | Occurs                                                                                                     |
	 * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
	 * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
	 * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
	 *
	 *
	 * @element ANY
	 * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
	 *                            element is hidden/shown respectively.
	 *
	 * @example
	 * A simple example, animating the element's opacity:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element animate-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      .animate-show-hide.ng-hide {
	        opacity: 0;
	      }
	
	      .animate-show-hide.ng-hide-add,
	      .animate-show-hide.ng-hide-remove {
	        transition: all linear 0.5s;
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 *
	 * <hr />
	 * @example
	 * A more complex example, featuring different show/hide animations:
	 *
	  <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
	    <file name="index.html">
	      Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
	      <div class="check-element funky-show-hide" ng-hide="checked">
	        I hide when your checkbox is checked.
	      </div>
	    </file>
	    <file name="animations.css">
	      body {
	        overflow: hidden;
	        perspective: 1000px;
	      }
	
	      .funky-show-hide.ng-hide-add {
	        transform: rotateZ(0);
	        transform-origin: right;
	        transition: all 0.5s ease-in-out;
	      }
	
	      .funky-show-hide.ng-hide-add.ng-hide-add-active {
	        transform: rotateZ(-135deg);
	      }
	
	      .funky-show-hide.ng-hide-remove {
	        transform: rotateY(90deg);
	        transform-origin: left;
	        transition: all 0.5s ease;
	      }
	
	      .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
	        transform: rotateY(0);
	      }
	
	      .check-element {
	        border: 1px solid black;
	        opacity: 1;
	        padding: 10px;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should check ngHide', function() {
	        var checkbox = element(by.model('checked'));
	        var checkElem = element(by.css('.check-element'));
	
	        expect(checkElem.isDisplayed()).toBe(true);
	        checkbox.click();
	        expect(checkElem.isDisplayed()).toBe(false);
	      });
	    </file>
	  </example>
	 */
	var ngHideDirective = ['$animate', function($animate) {
	  return {
	    restrict: 'A',
	    multiElement: true,
	    link: function(scope, element, attr) {
	      scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
	        // The comment inside of the ngShowDirective explains why we add and
	        // remove a temporary class for the show/hide animation
	        $animate[value ? 'addClass' : 'removeClass'](element,NG_HIDE_CLASS, {
	          tempClasses: NG_HIDE_IN_PROGRESS_CLASS
	        });
	      });
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngStyle
	 * @restrict AC
	 *
	 * @description
	 * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
	 *
	 * @knownIssue
	 * You should not use {@link guide/interpolation interpolation} in the value of the `style`
	 * attribute, when using the `ngStyle` directive on the same element.
	 * See {@link guide/interpolation#known-issues here} for more info.
	 *
	 * @element ANY
	 * @param {expression} ngStyle
	 *
	 * {@link guide/expression Expression} which evals to an
	 * object whose keys are CSS style names and values are corresponding values for those CSS
	 * keys.
	 *
	 * Since some CSS style names are not valid keys for an object, they must be quoted.
	 * See the 'background-color' style in the example below.
	 *
	 * @example
	   <example name="ng-style">
	     <file name="index.html">
	        <input type="button" value="set color" ng-click="myStyle={color:'red'}">
	        <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
	        <input type="button" value="clear" ng-click="myStyle={}">
	        <br/>
	        <span ng-style="myStyle">Sample Text</span>
	        <pre>myStyle={{myStyle}}</pre>
	     </file>
	     <file name="style.css">
	       span {
	         color: black;
	       }
	     </file>
	     <file name="protractor.js" type="protractor">
	       var colorSpan = element(by.css('span'));
	
	       it('should check ng-style', function() {
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	         element(by.css('input[value=\'set color\']')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
	         element(by.css('input[value=clear]')).click();
	         expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
	       });
	     </file>
	   </example>
	 */
	var ngStyleDirective = ngDirective(function(scope, element, attr) {
	  scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
	    if (oldStyles && (newStyles !== oldStyles)) {
	      forEach(oldStyles, function(val, style) { element.css(style, '');});
	    }
	    if (newStyles) element.css(newStyles);
	  }, true);
	});
	
	/**
	 * @ngdoc directive
	 * @name ngSwitch
	 * @restrict EA
	 *
	 * @description
	 * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
	 * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
	 * as specified in the template.
	 *
	 * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
	 * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
	 * matches the value obtained from the evaluated expression. In other words, you define a container element
	 * (where you place the directive), place an expression on the **`on="..."` attribute**
	 * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
	 * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
	 * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
	 * attribute is displayed.
	 *
	 * <div class="alert alert-info">
	 * Be aware that the attribute values to match against cannot be expressions. They are interpreted
	 * as literal string values to match against.
	 * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
	 * value of the expression `$scope.someVal`.
	 * </div>
	
	 * @animations
	 * | Animation                        | Occurs                              |
	 * |----------------------------------|-------------------------------------|
	 * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
	 * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
	 *
	 * @usage
	 *
	 * ```
	 * <ANY ng-switch="expression">
	 *   <ANY ng-switch-when="matchValue1">...</ANY>
	 *   <ANY ng-switch-when="matchValue2">...</ANY>
	 *   <ANY ng-switch-default>...</ANY>
	 * </ANY>
	 * ```
	 *
	 *
	 * @scope
	 * @priority 1200
	 * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
	 * On child elements add:
	 *
	 * * `ngSwitchWhen`: the case statement to match against. If match then this
	 *   case will be displayed. If the same match appears multiple times, all the
	 *   elements will be displayed. It is possible to associate multiple values to
	 *   the same `ngSwitchWhen` by defining the optional attribute
	 *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
	 *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
	 *   if any of the `ngSwitch` evaluates to any of these tokens.
	 * * `ngSwitchDefault`: the default case when no other case match. If there
	 *   are multiple default cases, all of them will be displayed when no other
	 *   case match.
	 *
	 *
	 * @example
	  <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
	    <file name="index.html">
	      <div ng-controller="ExampleController">
	        <select ng-model="selection" ng-options="item for item in items">
	        </select>
	        <code>selection={{selection}}</code>
	        <hr/>
	        <div class="animate-switch-container"
	          ng-switch on="selection">
	            <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
	            <div class="animate-switch" ng-switch-when="home">Home Span</div>
	            <div class="animate-switch" ng-switch-default>default</div>
	        </div>
	      </div>
	    </file>
	    <file name="script.js">
	      angular.module('switchExample', ['ngAnimate'])
	        .controller('ExampleController', ['$scope', function($scope) {
	          $scope.items = ['settings', 'home', 'options', 'other'];
	          $scope.selection = $scope.items[0];
	        }]);
	    </file>
	    <file name="animations.css">
	      .animate-switch-container {
	        position:relative;
	        background:white;
	        border:1px solid black;
	        height:40px;
	        overflow:hidden;
	      }
	
	      .animate-switch {
	        padding:10px;
	      }
	
	      .animate-switch.ng-animate {
	        transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
	
	        position:absolute;
	        top:0;
	        left:0;
	        right:0;
	        bottom:0;
	      }
	
	      .animate-switch.ng-leave.ng-leave-active,
	      .animate-switch.ng-enter {
	        top:-50px;
	      }
	      .animate-switch.ng-leave,
	      .animate-switch.ng-enter.ng-enter-active {
	        top:0;
	      }
	    </file>
	    <file name="protractor.js" type="protractor">
	      var switchElem = element(by.css('[ng-switch]'));
	      var select = element(by.model('selection'));
	
	      it('should start in settings', function() {
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should change to home', function() {
	        select.all(by.css('option')).get(1).click();
	        expect(switchElem.getText()).toMatch(/Home Span/);
	      });
	      it('should change to settings via "options"', function() {
	        select.all(by.css('option')).get(2).click();
	        expect(switchElem.getText()).toMatch(/Settings Div/);
	      });
	      it('should select default', function() {
	        select.all(by.css('option')).get(3).click();
	        expect(switchElem.getText()).toMatch(/default/);
	      });
	    </file>
	  </example>
	 */
	var ngSwitchDirective = ['$animate', '$compile', function($animate, $compile) {
	  return {
	    require: 'ngSwitch',
	
	    // asks for $scope to fool the BC controller module
	    controller: ['$scope', function NgSwitchController() {
	     this.cases = {};
	    }],
	    link: function(scope, element, attr, ngSwitchController) {
	      var watchExpr = attr.ngSwitch || attr.on,
	          selectedTranscludes = [],
	          selectedElements = [],
	          previousLeaveAnimations = [],
	          selectedScopes = [];
	
	      var spliceFactory = function(array, index) {
	          return function(response) {
	            if (response !== false) array.splice(index, 1);
	          };
	      };
	
	      scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
	        var i, ii;
	
	        // Start with the last, in case the array is modified during the loop
	        while (previousLeaveAnimations.length) {
	          $animate.cancel(previousLeaveAnimations.pop());
	        }
	
	        for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
	          var selected = getBlockNodes(selectedElements[i].clone);
	          selectedScopes[i].$destroy();
	          var runner = previousLeaveAnimations[i] = $animate.leave(selected);
	          runner.done(spliceFactory(previousLeaveAnimations, i));
	        }
	
	        selectedElements.length = 0;
	        selectedScopes.length = 0;
	
	        if ((selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?'])) {
	          forEach(selectedTranscludes, function(selectedTransclude) {
	            selectedTransclude.transclude(function(caseElement, selectedScope) {
	              selectedScopes.push(selectedScope);
	              var anchor = selectedTransclude.element;
	              caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
	              var block = { clone: caseElement };
	
	              selectedElements.push(block);
	              $animate.enter(caseElement, anchor.parent(), anchor);
	            });
	          });
	        }
	      });
	    }
	  };
	}];
	
	var ngSwitchWhenDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attrs, ctrl, $transclude) {
	
	    var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
	      // Filter duplicate cases
	      function(element, index, array) { return array[index - 1] !== element; }
	    );
	
	    forEach(cases, function(whenCase) {
	      ctrl.cases['!' + whenCase] = (ctrl.cases['!' + whenCase] || []);
	      ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
	    });
	  }
	});
	
	var ngSwitchDefaultDirective = ngDirective({
	  transclude: 'element',
	  priority: 1200,
	  require: '^ngSwitch',
	  multiElement: true,
	  link: function(scope, element, attr, ctrl, $transclude) {
	    ctrl.cases['?'] = (ctrl.cases['?'] || []);
	    ctrl.cases['?'].push({ transclude: $transclude, element: element });
	   }
	});
	
	/**
	 * @ngdoc directive
	 * @name ngTransclude
	 * @restrict EAC
	 *
	 * @description
	 * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
	 *
	 * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
	 * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
	 *
	 * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
	 * content of this element will be removed before the transcluded content is inserted.
	 * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
	 * content in the case that no transcluded content is provided.
	 *
	 * @element ANY
	 *
	 * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
	 *                                               or its value is the same as the name of the attribute then the default slot is used.
	 *
	 * @example
	 * ### Basic transclusion
	 * This example demonstrates basic transclusion of content into a component directive.
	 * <example name="simpleTranscludeExample" module="transcludeExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('transcludeExample', [])
	 *        .directive('pane', function(){
	 *           return {
	 *             restrict: 'E',
	 *             transclude: true,
	 *             scope: { title:'@' },
	 *             template: '<div style="border: 1px solid black;">' +
	 *                         '<div style="background-color: gray">{{title}}</div>' +
	 *                         '<ng-transclude></ng-transclude>' +
	 *                       '</div>'
	 *           };
	 *       })
	 *       .controller('ExampleController', ['$scope', function($scope) {
	 *         $scope.title = 'Lorem Ipsum';
	 *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *       }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <input ng-model="title" aria-label="title"> <br/>
	 *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *       <pane title="{{title}}"><span>{{text}}</span></pane>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *      });
	 *   </file>
	 * </example>
	 *
	 * @example
	 * ### Transclude fallback content
	 * This example shows how to use `NgTransclude` with fallback content, that
	 * is displayed if no transcluded content is provided.
	 *
	 * <example module="transcludeFallbackContentExample" name="ng-transclude">
	 * <file name="index.html">
	 * <script>
	 * angular.module('transcludeFallbackContentExample', [])
	 * .directive('myButton', function(){
	 *             return {
	 *               restrict: 'E',
	 *               transclude: true,
	 *               scope: true,
	 *               template: '<button style="cursor: pointer;">' +
	 *                           '<ng-transclude>' +
	 *                             '<b style="color: red;">Button1</b>' +
	 *                           '</ng-transclude>' +
	 *                         '</button>'
	 *             };
	 *         });
	 * </script>
	 * <!-- fallback button content -->
	 * <my-button id="fallback"></my-button>
	 * <!-- modified button content -->
	 * <my-button id="modified">
	 *   <i style="color: green;">Button2</i>
	 * </my-button>
	 * </file>
	 * <file name="protractor.js" type="protractor">
	 * it('should have different transclude element content', function() {
	 *          expect(element(by.id('fallback')).getText()).toBe('Button1');
	 *          expect(element(by.id('modified')).getText()).toBe('Button2');
	 *        });
	 * </file>
	 * </example>
	 *
	 * @example
	 * ### Multi-slot transclusion
	 * This example demonstrates using multi-slot transclusion in a component directive.
	 * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
	 *   <file name="index.html">
	 *    <style>
	 *      .title, .footer {
	 *        background-color: gray
	 *      }
	 *    </style>
	 *    <div ng-controller="ExampleController">
	 *      <input ng-model="title" aria-label="title"> <br/>
	 *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
	 *      <pane>
	 *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
	 *        <pane-body><p>{{text}}</p></pane-body>
	 *      </pane>
	 *    </div>
	 *   </file>
	 *   <file name="app.js">
	 *    angular.module('multiSlotTranscludeExample', [])
	 *     .directive('pane', function() {
	 *        return {
	 *          restrict: 'E',
	 *          transclude: {
	 *            'title': '?paneTitle',
	 *            'body': 'paneBody',
	 *            'footer': '?paneFooter'
	 *          },
	 *          template: '<div style="border: 1px solid black;">' +
	 *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
	 *                      '<div ng-transclude="body"></div>' +
	 *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
	 *                    '</div>'
	 *        };
	 *    })
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.title = 'Lorem Ipsum';
	 *      $scope.link = 'https://google.com';
	 *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
	 *    }]);
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *      it('should have transcluded the title and the body', function() {
	 *        var titleElement = element(by.model('title'));
	 *        titleElement.clear();
	 *        titleElement.sendKeys('TITLE');
	 *        var textElement = element(by.model('text'));
	 *        textElement.clear();
	 *        textElement.sendKeys('TEXT');
	 *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
	 *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
	 *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
	 *      });
	 *   </file>
	 * </example>
	 */
	var ngTranscludeMinErr = minErr('ngTransclude');
	var ngTranscludeDirective = ['$compile', function($compile) {
	  return {
	    restrict: 'EAC',
	    terminal: true,
	    compile: function ngTranscludeCompile(tElement) {
	
	      // Remove and cache any original content to act as a fallback
	      var fallbackLinkFn = $compile(tElement.contents());
	      tElement.empty();
	
	      return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
	
	        if (!$transclude) {
	          throw ngTranscludeMinErr('orphan',
	          'Illegal use of ngTransclude directive in the template! ' +
	          'No parent directive that requires a transclusion found. ' +
	          'Element: {0}',
	          startingTag($element));
	        }
	
	
	        // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
	        if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
	          $attrs.ngTransclude = '';
	        }
	        var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;
	
	        // If the slot is required and no transclusion content is provided then this call will throw an error
	        $transclude(ngTranscludeCloneAttachFn, null, slotName);
	
	        // If the slot is optional and no transclusion content is provided then use the fallback content
	        if (slotName && !$transclude.isSlotFilled(slotName)) {
	          useFallbackContent();
	        }
	
	        function ngTranscludeCloneAttachFn(clone, transcludedScope) {
	          if (clone.length && notWhitespace(clone)) {
	            $element.append(clone);
	          } else {
	            useFallbackContent();
	            // There is nothing linked against the transcluded scope since no content was available,
	            // so it should be safe to clean up the generated scope.
	            transcludedScope.$destroy();
	          }
	        }
	
	        function useFallbackContent() {
	          // Since this is the fallback content rather than the transcluded content,
	          // we link against the scope of this directive rather than the transcluded scope
	          fallbackLinkFn($scope, function(clone) {
	            $element.append(clone);
	          });
	        }
	
	        function notWhitespace(nodes) {
	          for (var i = 0, ii = nodes.length; i < ii; i++) {
	            var node = nodes[i];
	            if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
	              return true;
	            }
	          }
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name script
	 * @restrict E
	 *
	 * @description
	 * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
	 * template can be used by {@link ng.directive:ngInclude `ngInclude`},
	 * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
	 * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
	 * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
	 *
	 * @param {string} type Must be set to `'text/ng-template'`.
	 * @param {string} id Cache name of the template.
	 *
	 * @example
	  <example  name="script-tag">
	    <file name="index.html">
	      <script type="text/ng-template" id="/tpl.html">
	        Content of the template.
	      </script>
	
	      <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
	      <div id="tpl-content" ng-include src="currentTpl"></div>
	    </file>
	    <file name="protractor.js" type="protractor">
	      it('should load template defined inside script tag', function() {
	        element(by.css('#tpl-link')).click();
	        expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
	      });
	    </file>
	  </example>
	 */
	var scriptDirective = ['$templateCache', function($templateCache) {
	  return {
	    restrict: 'E',
	    terminal: true,
	    compile: function(element, attr) {
	      if (attr.type === 'text/ng-template') {
	        var templateUrl = attr.id,
	            text = element[0].text;
	
	        $templateCache.put(templateUrl, text);
	      }
	    }
	  };
	}];
	
	/* exported selectDirective, optionDirective */
	
	var noopNgModelController = { $setViewValue: noop, $render: noop };
	
	function setOptionSelectedStatus(optionEl, value) {
	  optionEl.prop('selected', value); // needed for IE
	  /**
	   * When unselecting an option, setting the property to null / false should be enough
	   * However, screenreaders might react to the selected attribute instead, see
	   * https://github.com/angular/angular.js/issues/14419
	   * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
	   * or null
	   */
	  optionEl.attr('selected', value);
	}
	
	/**
	 * @ngdoc type
	 * @name  select.SelectController
	 * @description
	 * The controller for the `<select>` directive. This provides support for reading
	 * and writing the selected value(s) of the control and also coordinates dynamically
	 * added `<option>` elements, perhaps by an `ngRepeat` directive.
	 */
	var SelectController =
	        ['$element', '$scope', /** @this */ function($element, $scope) {
	
	  var self = this,
	      optionsMap = new NgMap();
	
	  self.selectValueMap = {}; // Keys are the hashed values, values the original values
	
	  // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
	  self.ngModelCtrl = noopNgModelController;
	  self.multiple = false;
	
	  // The "unknown" option is one that is prepended to the list if the viewValue
	  // does not match any of the options. When it is rendered the value of the unknown
	  // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
	  //
	  // We can't just jqLite('<option>') since jqLite is not smart enough
	  // to create it in <select> and IE barfs otherwise.
	  self.unknownOption = jqLite(window.document.createElement('option'));
	
	  // The empty option is an option with the value '' that te application developer can
	  // provide inside the select. When the model changes to a value that doesn't match an option,
	  // it is selected - so if an empty option is provided, no unknown option is generated.
	  // However, the empty option is not removed when the model matches an option. It is always selectable
	  // and indicates that a "null" selection has been made.
	  self.hasEmptyOption = false;
	  self.emptyOption = undefined;
	
	  self.renderUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    $element.prepend(self.unknownOption);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.updateUnknownOption = function(val) {
	    var unknownVal = self.generateUnknownOptionValue(val);
	    self.unknownOption.val(unknownVal);
	    setOptionSelectedStatus(self.unknownOption, true);
	    $element.val(unknownVal);
	  };
	
	  self.generateUnknownOptionValue = function(val) {
	    return '? ' + hashKey(val) + ' ?';
	  };
	
	  self.removeUnknownOption = function() {
	    if (self.unknownOption.parent()) self.unknownOption.remove();
	  };
	
	  self.selectEmptyOption = function() {
	    if (self.emptyOption) {
	      $element.val('');
	      setOptionSelectedStatus(self.emptyOption, true);
	    }
	  };
	
	  self.unselectEmptyOption = function() {
	    if (self.hasEmptyOption) {
	      self.emptyOption.removeAttr('selected');
	    }
	  };
	
	  $scope.$on('$destroy', function() {
	    // disable unknown option so that we don't do work when the whole select is being destroyed
	    self.renderUnknownOption = noop;
	  });
	
	  // Read the value of the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.readValue = function readSingleValue() {
	    var val = $element.val();
	    // ngValue added option values are stored in the selectValueMap, normal interpolations are not
	    var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
	
	    if (self.hasOption(realVal)) {
	      return realVal;
	    }
	
	    return null;
	  };
	
	
	  // Write the value to the select control, the implementation of this changes depending
	  // upon whether the select can have multiple values and whether ngOptions is at work.
	  self.writeValue = function writeSingleValue(value) {
	    // Make sure to remove the selected attribute from the previously selected option
	    // Otherwise, screen readers might get confused
	    var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
	    if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
	
	    if (self.hasOption(value)) {
	      self.removeUnknownOption();
	
	      var hashedVal = hashKey(value);
	      $element.val(hashedVal in self.selectValueMap ? hashedVal : value);
	
	      // Set selected attribute and property on selected option for screen readers
	      var selectedOption = $element[0].options[$element[0].selectedIndex];
	      setOptionSelectedStatus(jqLite(selectedOption), true);
	    } else {
	      if (value == null && self.emptyOption) {
	        self.removeUnknownOption();
	        self.selectEmptyOption();
	      } else if (self.unknownOption.parent().length) {
	        self.updateUnknownOption(value);
	      } else {
	        self.renderUnknownOption(value);
	      }
	    }
	  };
	
	
	  // Tell the select control that an option, with the given value, has been added
	  self.addOption = function(value, element) {
	    // Skip comment nodes, as they only pollute the `optionsMap`
	    if (element[0].nodeType === NODE_TYPE_COMMENT) return;
	
	    assertNotHasOwnProperty(value, '"option value"');
	    if (value === '') {
	      self.hasEmptyOption = true;
	      self.emptyOption = element;
	    }
	    var count = optionsMap.get(value) || 0;
	    optionsMap.set(value, count + 1);
	    // Only render at the end of a digest. This improves render performance when many options
	    // are added during a digest and ensures all relevant options are correctly marked as selected
	    scheduleRender();
	  };
	
	  // Tell the select control that an option, with the given value, has been removed
	  self.removeOption = function(value) {
	    var count = optionsMap.get(value);
	    if (count) {
	      if (count === 1) {
	        optionsMap.delete(value);
	        if (value === '') {
	          self.hasEmptyOption = false;
	          self.emptyOption = undefined;
	        }
	      } else {
	        optionsMap.set(value, count - 1);
	      }
	    }
	  };
	
	  // Check whether the select control has an option matching the given value
	  self.hasOption = function(value) {
	    return !!optionsMap.get(value);
	  };
	
	
	  var renderScheduled = false;
	  function scheduleRender() {
	    if (renderScheduled) return;
	    renderScheduled = true;
	    $scope.$$postDigest(function() {
	      renderScheduled = false;
	      self.ngModelCtrl.$render();
	    });
	  }
	
	  var updateScheduled = false;
	  function scheduleViewValueUpdate(renderAfter) {
	    if (updateScheduled) return;
	
	    updateScheduled = true;
	
	    $scope.$$postDigest(function() {
	      if ($scope.$$destroyed) return;
	
	      updateScheduled = false;
	      self.ngModelCtrl.$setViewValue(self.readValue());
	      if (renderAfter) self.ngModelCtrl.$render();
	    });
	  }
	
	
	  self.registerOption = function(optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
	
	    if (optionAttrs.$attr.ngValue) {
	      // The value attribute is set by ngValue
	      var oldVal, hashedVal = NaN;
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(hashedVal)) {
	          self.removeOption(oldVal);
	          delete self.selectValueMap[hashedVal];
	          removal = true;
	        }
	
	        hashedVal = hashKey(newVal);
	        oldVal = newVal;
	        self.selectValueMap[hashedVal] = newVal;
	        self.addOption(newVal, optionElement);
	        // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
	        // from firing a second time. Other $observers on value will also get the result of the
	        // ngValue expression, not the hashed value
	        optionElement.attr('value', hashedVal);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	
	      });
	    } else if (interpolateValueFn) {
	      // The value attribute is interpolated
	      optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
	        // This method is overwritten in ngOptions and has side-effects!
	        self.readValue();
	
	        var removal;
	        var previouslySelected = optionElement.prop('selected');
	
	        if (isDefined(oldVal)) {
	          self.removeOption(oldVal);
	          removal = true;
	        }
	        oldVal = newVal;
	        self.addOption(newVal, optionElement);
	
	        if (removal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else if (interpolateTextFn) {
	      // The text content is interpolated
	      optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
	        optionAttrs.$set('value', newVal);
	        var previouslySelected = optionElement.prop('selected');
	        if (oldVal !== newVal) {
	          self.removeOption(oldVal);
	        }
	        self.addOption(newVal, optionElement);
	
	        if (oldVal && previouslySelected) {
	          scheduleViewValueUpdate();
	        }
	      });
	    } else {
	      // The value attribute is static
	      self.addOption(optionAttrs.value, optionElement);
	    }
	
	
	    optionAttrs.$observe('disabled', function(newVal) {
	
	      // Since model updates will also select disabled options (like ngOptions),
	      // we only have to handle options becoming disabled, not enabled
	
	      if (newVal === 'true' || newVal && optionElement.prop('selected')) {
	        if (self.multiple) {
	          scheduleViewValueUpdate(true);
	        } else {
	          self.ngModelCtrl.$setViewValue(null);
	          self.ngModelCtrl.$render();
	        }
	      }
	    });
	
	    optionElement.on('$destroy', function() {
	      var currentValue = self.readValue();
	      var removeValue = optionAttrs.value;
	
	      self.removeOption(removeValue);
	      scheduleRender();
	
	      if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 ||
	          currentValue === removeValue
	      ) {
	        // When multiple (selected) options are destroyed at the same time, we don't want
	        // to run a model update for each of them. Instead, run a single update in the $$postDigest
	        scheduleViewValueUpdate(true);
	      }
	    });
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name select
	 * @restrict E
	 *
	 * @description
	 * HTML `select` element with angular data-binding.
	 *
	 * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
	 * between the scope and the `<select>` control (including setting default values).
	 * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
	 * {@link ngOptions `ngOptions`} directives.
	 *
	 * When an item in the `<select>` menu is selected, the value of the selected option will be bound
	 * to the model identified by the `ngModel` directive. With static or repeated options, this is
	 * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
	 * Value and textContent can be interpolated.
	 *
	 * ## Matching model and option values
	 *
	 * In general, the match between the model and an option is evaluated by strictly comparing the model
	 * value against the value of the available options.
	 *
	 * If you are setting the option value with the option's `value` attribute, or textContent, the
	 * value will always be a `string` which means that the model value must also be a string.
	 * Otherwise the `select` directive cannot match them correctly.
	 *
	 * To bind the model to a non-string value, you can use one of the following strategies:
	 * - the {@link ng.ngOptions `ngOptions`} directive
	 *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
	 * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
	 *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
	 * - model $parsers / $formatters to convert the string value
	 *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
	 *
	 * If the viewValue of `ngModel` does not match any of the options, then the control
	 * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
	 *
	 * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
	 * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
	 * option. See example below for demonstration.
	 *
	 * ## Choosing between `ngRepeat` and `ngOptions`
	 *
	 * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
	 * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
	 * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
	 * comprehension expression
	 * - reduced memory consumption by not creating a new scope for each repeated instance
	 * - increased render speed by creating the options in a documentFragment instead of individually
	 *
	 * Specifically, select with repeated options slows down significantly starting at 2000 options in
	 * Chrome and Internet Explorer / Edge.
	 *
	 *
	 * @param {string} ngModel Assignable angular expression to data-bind to.
	 * @param {string=} name Property name of the form under which the control is published.
	 * @param {string=} multiple Allows multiple options to be selected. The selected values will be
	 *     bound to the model as an array.
	 * @param {string=} required Sets `required` validation error key if the value is not entered.
	 * @param {string=} ngRequired Adds required attribute and required validation constraint to
	 * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
	 * when you want to data-bind to the required attribute.
	 * @param {string=} ngChange Angular expression to be executed when selected option(s) changes due to user
	 *    interaction with the select element.
	 * @param {string=} ngOptions sets the options that the select is populated with and defines what is
	 * set on the model on selection. See {@link ngOptions `ngOptions`}.
	 * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
	 * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
	 *
	 * @example
	 * ### Simple `select` elements with static options
	 *
	 * <example name="static-select" module="staticSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="singleSelect"> Single select: </label><br>
	 *     <select name="singleSelect" ng-model="data.singleSelect">
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *
	 *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
	 *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
	 *       <option value="">---Please select---</option> <!-- not selected / blank option -->
	 *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
	 *       <option value="option-2">Option 2</option>
	 *     </select><br>
	 *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
	 *     <tt>singleSelect = {{data.singleSelect}}</tt>
	 *
	 *     <hr>
	 *     <label for="multipleSelect"> Multiple select: </label><br>
	 *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
	 *       <option value="option-1">Option 1</option>
	 *       <option value="option-2">Option 2</option>
	 *       <option value="option-3">Option 3</option>
	 *     </select><br>
	 *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
	 *   </form>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('staticSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       singleSelect: null,
	 *       multipleSelect: [],
	 *       option1: 'option-1'
	 *      };
	 *
	 *      $scope.forceUnknownOption = function() {
	 *        $scope.data.singleSelect = 'nonsense';
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngRepeat` to generate `select` options
	 * <example name="select-ngrepeat" module="ngrepeatSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="repeatSelect"> Repeat select: </label>
	 *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
	 *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <tt>model = {{data.model}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngrepeatSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `ngValue` to bind the model to an array of objects
	 * <example name="select-ngvalue" module="ngvalueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="ngvalueselect"> ngvalue select: </label>
	 *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
	 *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
	 *     </select>
	 *   </form>
	 *   <hr>
	 *   <pre>model = {{data.model | json}}</pre><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('ngvalueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       model: null,
	 *       availableOptions: [
	           {value: 'myString', name: 'string'},
	           {value: 1, name: 'integer'},
	           {value: true, name: 'boolean'},
	           {value: null, name: 'null'},
	           {value: {prop: 'value'}, name: 'object'},
	           {value: ['a'], name: 'array'}
	 *       ]
	 *      };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 * ### Using `select` with `ngOptions` and setting a default value
	 * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
	 *
	 * <example name="select-with-default-values" module="defaultValueSelect">
	 * <file name="index.html">
	 * <div ng-controller="ExampleController">
	 *   <form name="myForm">
	 *     <label for="mySelect">Make a choice:</label>
	 *     <select name="mySelect" id="mySelect"
	 *       ng-options="option.name for option in data.availableOptions track by option.id"
	 *       ng-model="data.selectedOption"></select>
	 *   </form>
	 *   <hr>
	 *   <tt>option = {{data.selectedOption}}</tt><br/>
	 * </div>
	 * </file>
	 * <file name="app.js">
	 *  angular.module('defaultValueSelect', [])
	 *    .controller('ExampleController', ['$scope', function($scope) {
	 *      $scope.data = {
	 *       availableOptions: [
	 *         {id: '1', name: 'Option A'},
	 *         {id: '2', name: 'Option B'},
	 *         {id: '3', name: 'Option C'}
	 *       ],
	 *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
	 *       };
	 *   }]);
	 * </file>
	 *</example>
	 *
	 *
	 * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
	 *
	 * <example name="select-with-non-string-options" module="nonStringSelect">
	 *   <file name="index.html">
	 *     <select ng-model="model.id" convert-to-number>
	 *       <option value="0">Zero</option>
	 *       <option value="1">One</option>
	 *       <option value="2">Two</option>
	 *     </select>
	 *     {{ model }}
	 *   </file>
	 *   <file name="app.js">
	 *     angular.module('nonStringSelect', [])
	 *       .run(function($rootScope) {
	 *         $rootScope.model = { id: 2 };
	 *       })
	 *       .directive('convertToNumber', function() {
	 *         return {
	 *           require: 'ngModel',
	 *           link: function(scope, element, attrs, ngModel) {
	 *             ngModel.$parsers.push(function(val) {
	 *               return parseInt(val, 10);
	 *             });
	 *             ngModel.$formatters.push(function(val) {
	 *               return '' + val;
	 *             });
	 *           }
	 *         };
	 *       });
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	 *     it('should initialize to model', function() {
	 *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
	 *     });
	 *   </file>
	 * </example>
	 *
	 */
	var selectDirective = function() {
	
	  return {
	    restrict: 'E',
	    require: ['select', '?ngModel'],
	    controller: SelectController,
	    priority: 1,
	    link: {
	      pre: selectPreLink,
	      post: selectPostLink
	    }
	  };
	
	  function selectPreLink(scope, element, attr, ctrls) {
	
	      var selectCtrl = ctrls[0];
	      var ngModelCtrl = ctrls[1];
	
	      // if ngModel is not defined, we don't need to do anything but set the registerOption
	      // function to noop, so options don't get added internally
	      if (!ngModelCtrl) {
	        selectCtrl.registerOption = noop;
	        return;
	      }
	
	
	      selectCtrl.ngModelCtrl = ngModelCtrl;
	
	      // When the selected item(s) changes we delegate getting the value of the select control
	      // to the `readValue` method, which can be changed if the select can have multiple
	      // selected values or if the options are being generated by `ngOptions`
	      element.on('change', function() {
	        selectCtrl.removeUnknownOption();
	        scope.$apply(function() {
	          ngModelCtrl.$setViewValue(selectCtrl.readValue());
	        });
	      });
	
	      // If the select allows multiple values then we need to modify how we read and write
	      // values from and to the control; also what it means for the value to be empty and
	      // we have to add an extra watch since ngModel doesn't work well with arrays - it
	      // doesn't trigger rendering if only an item in the array changes.
	      if (attr.multiple) {
	        selectCtrl.multiple = true;
	
	        // Read value now needs to check each option to see if it is selected
	        selectCtrl.readValue = function readMultipleValue() {
	          var array = [];
	          forEach(element.find('option'), function(option) {
	            if (option.selected && !option.disabled) {
	              var val = option.value;
	              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
	            }
	          });
	          return array;
	        };
	
	        // Write value now needs to set the selected property of each matching option
	        selectCtrl.writeValue = function writeMultipleValue(value) {
	          forEach(element.find('option'), function(option) {
	            var shouldBeSelected = !!value && (includes(value, option.value) ||
	                                               includes(value, selectCtrl.selectValueMap[option.value]));
	            var currentlySelected = option.selected;
	
	            // IE and Edge, adding options to the selection via shift+click/UP/DOWN,
	            // will de-select already selected options if "selected" on those options was set
	            // more than once (i.e. when the options were already selected)
	            // So we only modify the selected property if neccessary.
	            // Note: this behavior cannot be replicated via unit tests because it only shows in the
	            // actual user interface.
	            if (shouldBeSelected !== currentlySelected) {
	              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
	            }
	
	          });
	        };
	
	        // we have to do it on each watch since ngModel watches reference, but
	        // we need to work of an array, so we need to see if anything was inserted/removed
	        var lastView, lastViewRef = NaN;
	        scope.$watch(function selectMultipleWatch() {
	          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
	            lastView = shallowCopy(ngModelCtrl.$viewValue);
	            ngModelCtrl.$render();
	          }
	          lastViewRef = ngModelCtrl.$viewValue;
	        });
	
	        // If we are a multiple select then value is now a collection
	        // so the meaning of $isEmpty changes
	        ngModelCtrl.$isEmpty = function(value) {
	          return !value || value.length === 0;
	        };
	
	      }
	    }
	
	    function selectPostLink(scope, element, attrs, ctrls) {
	      // if ngModel is not defined, we don't need to do anything
	      var ngModelCtrl = ctrls[1];
	      if (!ngModelCtrl) return;
	
	      var selectCtrl = ctrls[0];
	
	      // We delegate rendering to the `writeValue` method, which can be changed
	      // if the select can have multiple selected values or if the options are being
	      // generated by `ngOptions`.
	      // This must be done in the postLink fn to prevent $render to be called before
	      // all nodes have been linked correctly.
	      ngModelCtrl.$render = function() {
	        selectCtrl.writeValue(ngModelCtrl.$viewValue);
	      };
	    }
	};
	
	
	// The option directive is purely designed to communicate the existence (or lack of)
	// of dynamically created (and destroyed) option elements to their containing select
	// directive via its controller.
	var optionDirective = ['$interpolate', function($interpolate) {
	  return {
	    restrict: 'E',
	    priority: 100,
	    compile: function(element, attr) {
	      var interpolateValueFn, interpolateTextFn;
	
	      if (isDefined(attr.ngValue)) {
	        // Will be handled by registerOption
	      } else if (isDefined(attr.value)) {
	        // If the value attribute is defined, check if it contains an interpolation
	        interpolateValueFn = $interpolate(attr.value, true);
	      } else {
	        // If the value attribute is not defined then we fall back to the
	        // text content of the option element, which may be interpolated
	        interpolateTextFn = $interpolate(element.text(), true);
	        if (!interpolateTextFn) {
	          attr.$set('value', element.text());
	        }
	      }
	
	      return function(scope, element, attr) {
	        // This is an optimization over using ^^ since we don't want to have to search
	        // all the way to the root of the DOM for every single option element
	        var selectCtrlName = '$selectController',
	            parent = element.parent(),
	            selectCtrl = parent.data(selectCtrlName) ||
	              parent.parent().data(selectCtrlName); // in case we are in optgroup
	
	        if (selectCtrl) {
	          selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
	        }
	      };
	    }
	  };
	}];
	
	/**
	 * @ngdoc directive
	 * @name ngRequired
	 * @restrict A
	 *
	 * @description
	 *
	 * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
	 * applied to custom controls.
	 *
	 * The directive sets the `required` attribute on the element if the Angular expression inside
	 * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
	 * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
	 * for more info.
	 *
	 * The validator will set the `required` error key to true if the `required` attribute is set and
	 * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
	 * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
	 * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
	 * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
	 *
	 * @example
	 * <example name="ngRequiredDirective" module="ngRequiredExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngRequiredExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.required = true;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="required">Toggle required: </label>
	 *         <input type="checkbox" ng-model="required" id="required" />
	 *         <br>
	 *         <label for="input">This input must be filled if `required` is true: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
	 *         <hr>
	 *         required error set? = <code>{{form.input.$error.required}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var required = element(by.binding('form.input.$error.required'));
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should set the required error', function() {
	         expect(required.getText()).toContain('true');
	
	         input.sendKeys('123');
	         expect(required.getText()).not.toContain('true');
	         expect(model.getText()).toContain('123');
	       });
	 *   </file>
	 * </example>
	 */
	var requiredDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	      attr.required = true; // force truthy in case we are on non input element
	
	      ctrl.$validators.required = function(modelValue, viewValue) {
	        return !attr.required || !ctrl.$isEmpty(viewValue);
	      };
	
	      attr.$observe('required', function() {
	        ctrl.$validate();
	      });
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngPattern
	 *
	 * @description
	 *
	 * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * does not match a RegExp which is obtained by evaluating the Angular expression given in the
	 * `ngPattern` attribute value:
	 * * If the expression evaluates to a RegExp object, then this is used directly.
	 * * If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
	 * in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
	 *
	 * <div class="alert alert-info">
	 * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
	 * start at the index of the last search's match, thus not taking the whole input value into
	 * account.
	 * </div>
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
	 *     not available.
	 *   </li>
	 *   <li>
	 *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngPatternDirective" module="ngPatternExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngPatternExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.regex = '\\d+';
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="regex">Set a pattern (regex string): </label>
	 *         <input type="text" ng-model="regex" id="regex" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current pattern: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default pattern', function() {
	         input.sendKeys('aaa');
	         expect(model.getText()).not.toContain('aaa');
	
	         input.clear().then(function() {
	           input.sendKeys('123');
	           expect(model.getText()).toContain('123');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var patternDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var regexp, patternExp = attr.ngPattern || attr.pattern;
	      attr.$observe('pattern', function(regex) {
	        if (isString(regex) && regex.length > 0) {
	          regex = new RegExp('^' + regex + '$');
	        }
	
	        if (regex && !regex.test) {
	          throw minErr('ngPattern')('noregexp',
	            'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp,
	            regex, startingTag(elm));
	        }
	
	        regexp = regex || undefined;
	        ctrl.$validate();
	      });
	
	      ctrl.$validators.pattern = function(modelValue, viewValue) {
	        // HTML5 pattern constraint validates the input value, so we validate the viewValue
	        return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMaxlength
	 *
	 * @description
	 *
	 * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is longer than the integer obtained by evaluating the Angular expression given in the
	 * `ngMaxlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMaxlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.maxlength = 5;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="maxlength">Set a maxlength: </label>
	 *         <input type="number" ng-model="maxlength" id="maxlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current maxlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default maxlength', function() {
	         input.sendKeys('abcdef');
	         expect(model.getText()).not.toContain('abcdef');
	
	         input.clear().then(function() {
	           input.sendKeys('abcde');
	           expect(model.getText()).toContain('abcde');
	         });
	       });
	 *   </file>
	 * </example>
	 */
	var maxlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var maxlength = -1;
	      attr.$observe('maxlength', function(value) {
	        var intVal = toInt(value);
	        maxlength = isNumberNaN(intVal) ? -1 : intVal;
	        ctrl.$validate();
	      });
	      ctrl.$validators.maxlength = function(modelValue, viewValue) {
	        return (maxlength < 0) || ctrl.$isEmpty(viewValue) || (viewValue.length <= maxlength);
	      };
	    }
	  };
	};
	
	/**
	 * @ngdoc directive
	 * @name ngMinlength
	 *
	 * @description
	 *
	 * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
	 * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
	 *
	 * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
	 * is shorter than the integer obtained by evaluating the Angular expression given in the
	 * `ngMinlength` attribute value.
	 *
	 * <div class="alert alert-info">
	 * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
	 * differences:
	 * <ol>
	 *   <li>
	 *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
	 *     validation is not available.
	 *   </li>
	 *   <li>
	 *     The `ngMinlength` value must be an expression, while the `minlength` value must be
	 *     interpolated.
	 *   </li>
	 * </ol>
	 * </div>
	 *
	 * @example
	 * <example name="ngMinlengthDirective" module="ngMinlengthExample">
	 *   <file name="index.html">
	 *     <script>
	 *       angular.module('ngMinlengthExample', [])
	 *         .controller('ExampleController', ['$scope', function($scope) {
	 *           $scope.minlength = 3;
	 *         }]);
	 *     </script>
	 *     <div ng-controller="ExampleController">
	 *       <form name="form">
	 *         <label for="minlength">Set a minlength: </label>
	 *         <input type="number" ng-model="minlength" id="minlength" />
	 *         <br>
	 *         <label for="input">This input is restricted by the current minlength: </label>
	 *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
	 *         <hr>
	 *         input valid? = <code>{{form.input.$valid}}</code><br>
	 *         model = <code>{{model}}</code>
	 *       </form>
	 *     </div>
	 *   </file>
	 *   <file name="protractor.js" type="protractor">
	       var model = element(by.binding('model'));
	       var input = element(by.id('input'));
	
	       it('should validate the input with the default minlength', function() {
	         input.sendKeys('ab');
	         expect(model.getText()).not.toContain('ab');
	
	         input.sendKeys('abc');
	         expect(model.getText()).toContain('abc');
	       });
	 *   </file>
	 * </example>
	 */
	var minlengthDirective = function() {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function(scope, elm, attr, ctrl) {
	      if (!ctrl) return;
	
	      var minlength = 0;
	      attr.$observe('minlength', function(value) {
	        minlength = toInt(value) || 0;
	        ctrl.$validate();
	      });
	      ctrl.$validators.minlength = function(modelValue, viewValue) {
	        return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
	      };
	    }
	  };
	};
	
	if (window.angular.bootstrap) {
	  // AngularJS is already loaded, so we can return here...
	  if (window.console) {
	    console.log('WARNING: Tried to load angular more than once.');
	  }
	  return;
	}
	
	// try to bind to jquery now so that one can write jqLite(fn)
	// but we will rebind on bootstrap again.
	bindJQuery();
	
	publishExternalAPI(angular);
	
	angular.module("ngLocale", [], ["$provide", function($provide) {
	var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
	function getDecimals(n) {
	  n = n + '';
	  var i = n.indexOf('.');
	  return (i == -1) ? 0 : n.length - i - 1;
	}
	
	function getVF(n, opt_precision) {
	  var v = opt_precision;
	
	  if (undefined === v) {
	    v = Math.min(getDecimals(n), 3);
	  }
	
	  var base = Math.pow(10, v);
	  var f = ((n * base) | 0) % base;
	  return {v: v, f: f};
	}
	
	$provide.value("$locale", {
	  "DATETIME_FORMATS": {
	    "AMPMS": [
	      "AM",
	      "PM"
	    ],
	    "DAY": [
	      "Sunday",
	      "Monday",
	      "Tuesday",
	      "Wednesday",
	      "Thursday",
	      "Friday",
	      "Saturday"
	    ],
	    "ERANAMES": [
	      "Before Christ",
	      "Anno Domini"
	    ],
	    "ERAS": [
	      "BC",
	      "AD"
	    ],
	    "FIRSTDAYOFWEEK": 6,
	    "MONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "SHORTDAY": [
	      "Sun",
	      "Mon",
	      "Tue",
	      "Wed",
	      "Thu",
	      "Fri",
	      "Sat"
	    ],
	    "SHORTMONTH": [
	      "Jan",
	      "Feb",
	      "Mar",
	      "Apr",
	      "May",
	      "Jun",
	      "Jul",
	      "Aug",
	      "Sep",
	      "Oct",
	      "Nov",
	      "Dec"
	    ],
	    "STANDALONEMONTH": [
	      "January",
	      "February",
	      "March",
	      "April",
	      "May",
	      "June",
	      "July",
	      "August",
	      "September",
	      "October",
	      "November",
	      "December"
	    ],
	    "WEEKENDRANGE": [
	      5,
	      6
	    ],
	    "fullDate": "EEEE, MMMM d, y",
	    "longDate": "MMMM d, y",
	    "medium": "MMM d, y h:mm:ss a",
	    "mediumDate": "MMM d, y",
	    "mediumTime": "h:mm:ss a",
	    "short": "M/d/yy h:mm a",
	    "shortDate": "M/d/yy",
	    "shortTime": "h:mm a"
	  },
	  "NUMBER_FORMATS": {
	    "CURRENCY_SYM": "$",
	    "DECIMAL_SEP": ".",
	    "GROUP_SEP": ",",
	    "PATTERNS": [
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 3,
	        "minFrac": 0,
	        "minInt": 1,
	        "negPre": "-",
	        "negSuf": "",
	        "posPre": "",
	        "posSuf": ""
	      },
	      {
	        "gSize": 3,
	        "lgSize": 3,
	        "maxFrac": 2,
	        "minFrac": 2,
	        "minInt": 1,
	        "negPre": "-\u00a4",
	        "negSuf": "",
	        "posPre": "\u00a4",
	        "posSuf": ""
	      }
	    ]
	  },
	  "id": "en-us",
	  "localeID": "en_US",
	  "pluralCat": function(n, opt_precision) {  var i = n | 0;  var vf = getVF(n, opt_precision);  if (i == 1 && vf.v == 0) {    return PLURAL_CATEGORY.ONE;  }  return PLURAL_CATEGORY.OTHER;}
	});
	}]);
	
	  jqLite(function() {
	    angularInit(window.document, bootstrap);
	  });
	
	})(window);
	
	!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * State-based routing for AngularJS
	 * @version v0.3.2
	 * @link http://angular-ui.github.com/
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	
	/* commonjs package manager support (eg componentjs) */
	if (typeof module !== "undefined" && typeof exports !== "undefined" && module.exports === exports){
	  module.exports = 'ui.router';
	}
	
	(function (window, angular, undefined) {
	/*jshint globalstrict:true*/
	/*global angular:false*/
	'use strict';
	
	var isDefined = angular.isDefined,
	    isFunction = angular.isFunction,
	    isString = angular.isString,
	    isObject = angular.isObject,
	    isArray = angular.isArray,
	    forEach = angular.forEach,
	    extend = angular.extend,
	    copy = angular.copy,
	    toJson = angular.toJson;
	
	function inherit(parent, extra) {
	  return extend(new (extend(function() {}, { prototype: parent }))(), extra);
	}
	
	function merge(dst) {
	  forEach(arguments, function(obj) {
	    if (obj !== dst) {
	      forEach(obj, function(value, key) {
	        if (!dst.hasOwnProperty(key)) dst[key] = value;
	      });
	    }
	  });
	  return dst;
	}
	
	/**
	 * Finds the common ancestor path between two states.
	 *
	 * @param {Object} first The first state.
	 * @param {Object} second The second state.
	 * @return {Array} Returns an array of state names in descending order, not including the root.
	 */
	function ancestors(first, second) {
	  var path = [];
	
	  for (var n in first.path) {
	    if (first.path[n] !== second.path[n]) break;
	    path.push(first.path[n]);
	  }
	  return path;
	}
	
	/**
	 * IE8-safe wrapper for `Object.keys()`.
	 *
	 * @param {Object} object A JavaScript object.
	 * @return {Array} Returns the keys of the object as an array.
	 */
	function objectKeys(object) {
	  if (Object.keys) {
	    return Object.keys(object);
	  }
	  var result = [];
	
	  forEach(object, function(val, key) {
	    result.push(key);
	  });
	  return result;
	}
	
	/**
	 * IE8-safe wrapper for `Array.prototype.indexOf()`.
	 *
	 * @param {Array} array A JavaScript array.
	 * @param {*} value A value to search the array for.
	 * @return {Number} Returns the array index value of `value`, or `-1` if not present.
	 */
	function indexOf(array, value) {
	  if (Array.prototype.indexOf) {
	    return array.indexOf(value, Number(arguments[2]) || 0);
	  }
	  var len = array.length >>> 0, from = Number(arguments[2]) || 0;
	  from = (from < 0) ? Math.ceil(from) : Math.floor(from);
	
	  if (from < 0) from += len;
	
	  for (; from < len; from++) {
	    if (from in array && array[from] === value) return from;
	  }
	  return -1;
	}
	
	/**
	 * Merges a set of parameters with all parameters inherited between the common parents of the
	 * current state and a given destination state.
	 *
	 * @param {Object} currentParams The value of the current state parameters ($stateParams).
	 * @param {Object} newParams The set of parameters which will be composited with inherited params.
	 * @param {Object} $current Internal definition of object representing the current state.
	 * @param {Object} $to Internal definition of object representing state to transition to.
	 */
	function inheritParams(currentParams, newParams, $current, $to) {
	  var parents = ancestors($current, $to), parentParams, inherited = {}, inheritList = [];
	
	  for (var i in parents) {
	    if (!parents[i] || !parents[i].params) continue;
	    parentParams = objectKeys(parents[i].params);
	    if (!parentParams.length) continue;
	
	    for (var j in parentParams) {
	      if (indexOf(inheritList, parentParams[j]) >= 0) continue;
	      inheritList.push(parentParams[j]);
	      inherited[parentParams[j]] = currentParams[parentParams[j]];
	    }
	  }
	  return extend({}, inherited, newParams);
	}
	
	/**
	 * Performs a non-strict comparison of the subset of two objects, defined by a list of keys.
	 *
	 * @param {Object} a The first object.
	 * @param {Object} b The second object.
	 * @param {Array} keys The list of keys within each object to compare. If the list is empty or not specified,
	 *                     it defaults to the list of keys in `a`.
	 * @return {Boolean} Returns `true` if the keys match, otherwise `false`.
	 */
	function equalForKeys(a, b, keys) {
	  if (!keys) {
	    keys = [];
	    for (var n in a) keys.push(n); // Used instead of Object.keys() for IE8 compatibility
	  }
	
	  for (var i=0; i<keys.length; i++) {
	    var k = keys[i];
	    if (a[k] != b[k]) return false; // Not '===', values aren't necessarily normalized
	  }
	  return true;
	}
	
	/**
	 * Returns the subset of an object, based on a list of keys.
	 *
	 * @param {Array} keys
	 * @param {Object} values
	 * @return {Boolean} Returns a subset of `values`.
	 */
	function filterByKeys(keys, values) {
	  var filtered = {};
	
	  forEach(keys, function (name) {
	    filtered[name] = values[name];
	  });
	  return filtered;
	}
	
	// like _.indexBy
	// when you know that your index values will be unique, or you want last-one-in to win
	function indexBy(array, propName) {
	  var result = {};
	  forEach(array, function(item) {
	    result[item[propName]] = item;
	  });
	  return result;
	}
	
	// extracted from underscore.js
	// Return a copy of the object only containing the whitelisted properties.
	function pick(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  forEach(keys, function(key) {
	    if (key in obj) copy[key] = obj[key];
	  });
	  return copy;
	}
	
	// extracted from underscore.js
	// Return a copy of the object omitting the blacklisted properties.
	function omit(obj) {
	  var copy = {};
	  var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	  for (var key in obj) {
	    if (indexOf(keys, key) == -1) copy[key] = obj[key];
	  }
	  return copy;
	}
	
	function pluck(collection, key) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = isFunction(key) ? key(val) : val[key];
	  });
	  return result;
	}
	
	function filter(collection, callback) {
	  var array = isArray(collection);
	  var result = array ? [] : {};
	  forEach(collection, function(val, i) {
	    if (callback(val, i)) {
	      result[array ? result.length : i] = val;
	    }
	  });
	  return result;
	}
	
	function map(collection, callback) {
	  var result = isArray(collection) ? [] : {};
	
	  forEach(collection, function(val, i) {
	    result[i] = callback(val, i);
	  });
	  return result;
	}
	
	// issue #2676 #2889
	function silenceUncaughtInPromise (promise) {
	  return promise.then(undefined, function() {}) && promise;
	}
	
	/**
	 * @ngdoc overview
	 * @name ui.router.util
	 *
	 * @description
	 * # ui.router.util sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 *
	 */
	angular.module('ui.router.util', ['ng']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.router
	 * 
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.router sub-module
	 *
	 * This module is a dependency of other sub-modules. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 */
	angular.module('ui.router.router', ['ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router.state
	 * 
	 * @requires ui.router.router
	 * @requires ui.router.util
	 *
	 * @description
	 * # ui.router.state sub-module
	 *
	 * This module is a dependency of the main ui.router module. Do not include this module as a dependency
	 * in your angular app (use {@link ui.router} module instead).
	 * 
	 */
	angular.module('ui.router.state', ['ui.router.router', 'ui.router.util']);
	
	/**
	 * @ngdoc overview
	 * @name ui.router
	 *
	 * @requires ui.router.state
	 *
	 * @description
	 * # ui.router
	 * 
	 * ## The main module for ui.router 
	 * There are several sub-modules included with the ui.router module, however only this module is needed
	 * as a dependency within your angular app. The other modules are for organization purposes. 
	 *
	 * The modules are:
	 * * ui.router - the main "umbrella" module
	 * * ui.router.router - 
	 * 
	 * *You'll need to include **only** this module as the dependency within your angular app.*
	 * 
	 * <pre>
	 * <!doctype html>
	 * <html ng-app="myApp">
	 * <head>
	 *   <script src="js/angular.js"></script>
	 *   <!-- Include the ui-router script -->
	 *   <script src="js/angular-ui-router.min.js"></script>
	 *   <script>
	 *     // ...and add 'ui.router' as a dependency
	 *     var myApp = angular.module('myApp', ['ui.router']);
	 *   </script>
	 * </head>
	 * <body>
	 * </body>
	 * </html>
	 * </pre>
	 */
	angular.module('ui.router', ['ui.router.state']);
	
	angular.module('ui.router.compat', ['ui.router']);
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$resolve
	 *
	 * @requires $q
	 * @requires $injector
	 *
	 * @description
	 * Manages resolution of (acyclic) graphs of promises.
	 */
	$Resolve.$inject = ['$q', '$injector'];
	function $Resolve(  $q,    $injector) {
	  
	  var VISIT_IN_PROGRESS = 1,
	      VISIT_DONE = 2,
	      NOTHING = {},
	      NO_DEPENDENCIES = [],
	      NO_LOCALS = NOTHING,
	      NO_PARENT = extend($q.when(NOTHING), { $$promises: NOTHING, $$values: NOTHING });
	  
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#study
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Studies a set of invocables that are likely to be used multiple times.
	   * <pre>
	   * $resolve.study(invocables)(locals, parent, self)
	   * </pre>
	   * is equivalent to
	   * <pre>
	   * $resolve.resolve(invocables, locals, parent, self)
	   * </pre>
	   * but the former is more efficient (in fact `resolve` just calls `study` 
	   * internally).
	   *
	   * @param {object} invocables Invocable objects
	   * @return {function} a function to pass in locals, parent and self
	   */
	  this.study = function (invocables) {
	    if (!isObject(invocables)) throw new Error("'invocables' must be an object");
	    var invocableKeys = objectKeys(invocables || {});
	    
	    // Perform a topological sort of invocables to build an ordered plan
	    var plan = [], cycle = [], visited = {};
	    function visit(value, key) {
	      if (visited[key] === VISIT_DONE) return;
	      
	      cycle.push(key);
	      if (visited[key] === VISIT_IN_PROGRESS) {
	        cycle.splice(0, indexOf(cycle, key));
	        throw new Error("Cyclic dependency: " + cycle.join(" -> "));
	      }
	      visited[key] = VISIT_IN_PROGRESS;
	      
	      if (isString(value)) {
	        plan.push(key, [ function() { return $injector.get(value); }], NO_DEPENDENCIES);
	      } else {
	        var params = $injector.annotate(value);
	        forEach(params, function (param) {
	          if (param !== key && invocables.hasOwnProperty(param)) visit(invocables[param], param);
	        });
	        plan.push(key, value, params);
	      }
	      
	      cycle.pop();
	      visited[key] = VISIT_DONE;
	    }
	    forEach(invocables, visit);
	    invocables = cycle = visited = null; // plan is all that's required
	    
	    function isResolve(value) {
	      return isObject(value) && value.then && value.$$promises;
	    }
	    
	    return function (locals, parent, self) {
	      if (isResolve(locals) && self === undefined) {
	        self = parent; parent = locals; locals = null;
	      }
	      if (!locals) locals = NO_LOCALS;
	      else if (!isObject(locals)) {
	        throw new Error("'locals' must be an object");
	      }       
	      if (!parent) parent = NO_PARENT;
	      else if (!isResolve(parent)) {
	        throw new Error("'parent' must be a promise returned by $resolve.resolve()");
	      }
	      
	      // To complete the overall resolution, we have to wait for the parent
	      // promise and for the promise for each invokable in our plan.
	      var resolution = $q.defer(),
	          result = resolution.promise,
	          promises = result.$$promises = {},
	          values = extend({}, locals),
	          wait = 1 + plan.length/3,
	          merged = false;
	          
	      function done() {
	        // Merge parent values we haven't got yet and publish our own $$values
	        if (!--wait) {
	          if (!merged) merge(values, parent.$$values); 
	          result.$$values = values;
	          result.$$promises = result.$$promises || true; // keep for isResolve()
	          delete result.$$inheritedValues;
	          resolution.resolve(values);
	        }
	      }
	      
	      function fail(reason) {
	        result.$$failure = reason;
	        resolution.reject(reason);
	      }
	
	      // Short-circuit if parent has already failed
	      if (isDefined(parent.$$failure)) {
	        fail(parent.$$failure);
	        return result;
	      }
	      
	      if (parent.$$inheritedValues) {
	        merge(values, omit(parent.$$inheritedValues, invocableKeys));
	      }
	
	      // Merge parent values if the parent has already resolved, or merge
	      // parent promises and wait if the parent resolve is still in progress.
	      extend(promises, parent.$$promises);
	      if (parent.$$values) {
	        merged = merge(values, omit(parent.$$values, invocableKeys));
	        result.$$inheritedValues = omit(parent.$$values, invocableKeys);
	        done();
	      } else {
	        if (parent.$$inheritedValues) {
	          result.$$inheritedValues = omit(parent.$$inheritedValues, invocableKeys);
	        }        
	        parent.then(done, fail);
	      }
	      
	      // Process each invocable in the plan, but ignore any where a local of the same name exists.
	      for (var i=0, ii=plan.length; i<ii; i+=3) {
	        if (locals.hasOwnProperty(plan[i])) done();
	        else invoke(plan[i], plan[i+1], plan[i+2]);
	      }
	      
	      function invoke(key, invocable, params) {
	        // Create a deferred for this invocation. Failures will propagate to the resolution as well.
	        var invocation = $q.defer(), waitParams = 0;
	        function onfailure(reason) {
	          invocation.reject(reason);
	          fail(reason);
	        }
	        // Wait for any parameter that we have a promise for (either from parent or from this
	        // resolve; in that case study() will have made sure it's ordered before us in the plan).
	        forEach(params, function (dep) {
	          if (promises.hasOwnProperty(dep) && !locals.hasOwnProperty(dep)) {
	            waitParams++;
	            promises[dep].then(function (result) {
	              values[dep] = result;
	              if (!(--waitParams)) proceed();
	            }, onfailure);
	          }
	        });
	        if (!waitParams) proceed();
	        function proceed() {
	          if (isDefined(result.$$failure)) return;
	          try {
	            invocation.resolve($injector.invoke(invocable, self, values));
	            invocation.promise.then(function (result) {
	              values[key] = result;
	              done();
	            }, onfailure);
	          } catch (e) {
	            onfailure(e);
	          }
	        }
	        // Publish promise synchronously; invocations further down in the plan may depend on it.
	        promises[key] = invocation.promise;
	      }
	      
	      return result;
	    };
	  };
	  
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$resolve#resolve
	   * @methodOf ui.router.util.$resolve
	   *
	   * @description
	   * Resolves a set of invocables. An invocable is a function to be invoked via 
	   * `$injector.invoke()`, and can have an arbitrary number of dependencies. 
	   * An invocable can either return a value directly,
	   * or a `$q` promise. If a promise is returned it will be resolved and the 
	   * resulting value will be used instead. Dependencies of invocables are resolved 
	   * (in this order of precedence)
	   *
	   * - from the specified `locals`
	   * - from another invocable that is part of this `$resolve` call
	   * - from an invocable that is inherited from a `parent` call to `$resolve` 
	   *   (or recursively
	   * - from any ancestor `$resolve` of that parent).
	   *
	   * The return value of `$resolve` is a promise for an object that contains 
	   * (in this order of precedence)
	   *
	   * - any `locals` (if specified)
	   * - the resolved return values of all injectables
	   * - any values inherited from a `parent` call to `$resolve` (if specified)
	   *
	   * The promise will resolve after the `parent` promise (if any) and all promises 
	   * returned by injectables have been resolved. If any invocable 
	   * (or `$injector.invoke`) throws an exception, or if a promise returned by an 
	   * invocable is rejected, the `$resolve` promise is immediately rejected with the 
	   * same error. A rejection of a `parent` promise (if specified) will likewise be 
	   * propagated immediately. Once the `$resolve` promise has been rejected, no 
	   * further invocables will be called.
	   * 
	   * Cyclic dependencies between invocables are not permitted and will cause `$resolve`
	   * to throw an error. As a special case, an injectable can depend on a parameter 
	   * with the same name as the injectable, which will be fulfilled from the `parent` 
	   * injectable of the same name. This allows inherited values to be decorated. 
	   * Note that in this case any other injectable in the same `$resolve` with the same
	   * dependency would see the decorated value, not the inherited value.
	   *
	   * Note that missing dependencies -- unlike cyclic dependencies -- will cause an 
	   * (asynchronous) rejection of the `$resolve` promise rather than a (synchronous) 
	   * exception.
	   *
	   * Invocables are invoked eagerly as soon as all dependencies are available. 
	   * This is true even for dependencies inherited from a `parent` call to `$resolve`.
	   *
	   * As a special case, an invocable can be a string, in which case it is taken to 
	   * be a service name to be passed to `$injector.get()`. This is supported primarily 
	   * for backwards-compatibility with the `resolve` property of `$routeProvider` 
	   * routes.
	   *
	   * @param {object} invocables functions to invoke or 
	   * `$injector` services to fetch.
	   * @param {object} locals  values to make available to the injectables
	   * @param {object} parent  a promise returned by another call to `$resolve`.
	   * @param {object} self  the `this` for the invoked methods
	   * @return {object} Promise for an object that contains the resolved return value
	   * of all invocables, as well as any inherited and local values.
	   */
	  this.resolve = function (invocables, locals, parent, self) {
	    return this.study(invocables)(locals, parent, self);
	  };
	}
	
	angular.module('ui.router.util').service('$resolve', $Resolve);
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$templateFactory
	 *
	 * @requires $http
	 * @requires $templateCache
	 * @requires $injector
	 *
	 * @description
	 * Service. Manages loading of templates.
	 */
	$TemplateFactory.$inject = ['$http', '$templateCache', '$injector'];
	function $TemplateFactory(  $http,   $templateCache,   $injector) {
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromConfig
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a configuration object. 
	   *
	   * @param {object} config Configuration object for which to load a template. 
	   * The following properties are search in the specified order, and the first one 
	   * that is defined is used to create the template:
	   *
	   * @param {string|object} config.template html string template or function to 
	   * load via {@link ui.router.util.$templateFactory#fromString fromString}.
	   * @param {string|object} config.templateUrl url to load or a function returning 
	   * the url to load via {@link ui.router.util.$templateFactory#fromUrl fromUrl}.
	   * @param {Function} config.templateProvider function to invoke via 
	   * {@link ui.router.util.$templateFactory#fromProvider fromProvider}.
	   * @param {object} params  Parameters to pass to the template function.
	   * @param {object} locals Locals to pass to `invoke` if the template is loaded 
	   * via a `templateProvider`. Defaults to `{ params: params }`.
	   *
	   * @return {string|object}  The template html as a string, or a promise for 
	   * that string,or `null` if no template is configured.
	   */
	  this.fromConfig = function (config, params, locals) {
	    return (
	      isDefined(config.template) ? this.fromString(config.template, params) :
	      isDefined(config.templateUrl) ? this.fromUrl(config.templateUrl, params) :
	      isDefined(config.templateProvider) ? this.fromProvider(config.templateProvider, params, locals) :
	      null
	    );
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromString
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template from a string or a function returning a string.
	   *
	   * @param {string|object} template html template as a string or function that 
	   * returns an html template as a string.
	   * @param {object} params Parameters to pass to the template function.
	   *
	   * @return {string|object} The template html as a string, or a promise for that 
	   * string.
	   */
	  this.fromString = function (template, params) {
	    return isFunction(template) ? template(params) : template;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromUrl
	   * @methodOf ui.router.util.$templateFactory
	   * 
	   * @description
	   * Loads a template from the a URL via `$http` and `$templateCache`.
	   *
	   * @param {string|Function} url url of the template to load, or a function 
	   * that returns a url.
	   * @param {Object} params Parameters to pass to the url function.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromUrl = function (url, params) {
	    if (isFunction(url)) url = url(params);
	    if (url == null) return null;
	    else return $http
	        .get(url, { cache: $templateCache, headers: { Accept: 'text/html' }})
	        .then(function(response) { return response.data; });
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$templateFactory#fromProvider
	   * @methodOf ui.router.util.$templateFactory
	   *
	   * @description
	   * Creates a template by invoking an injectable provider function.
	   *
	   * @param {Function} provider Function to invoke via `$injector.invoke`
	   * @param {Object} params Parameters for the template.
	   * @param {Object} locals Locals to pass to `invoke`. Defaults to 
	   * `{ params: params }`.
	   * @return {string|Promise.<string>} The template html as a string, or a promise 
	   * for that string.
	   */
	  this.fromProvider = function (provider, params, locals) {
	    return $injector.invoke(provider, null, locals || { params: params });
	  };
	}
	
	angular.module('ui.router.util').service('$templateFactory', $TemplateFactory);
	
	var $$UMFP; // reference to $UrlMatcherFactoryProvider
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Matches URLs against patterns and extracts named parameters from the path or the search
	 * part of the URL. A URL pattern consists of a path pattern, optionally followed by '?' and a list
	 * of search parameters. Multiple search parameter names are separated by '&'. Search parameters
	 * do not influence whether or not a URL is matched, but their values are passed through into
	 * the matched parameters returned by {@link ui.router.util.type:UrlMatcher#methods_exec exec}.
	 *
	 * Path parameter placeholders can be specified using simple colon/catch-all syntax or curly brace
	 * syntax, which optionally allows a regular expression for the parameter to be specified:
	 *
	 * * `':'` name - colon placeholder
	 * * `'*'` name - catch-all placeholder
	 * * `'{' name '}'` - curly placeholder
	 * * `'{' name ':' regexp|type '}'` - curly placeholder with regexp or type name. Should the
	 *   regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
	 *
	 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
	 * must be unique within the pattern (across both path and search parameters). For colon
	 * placeholders or curly placeholders without an explicit regexp, a path parameter matches any
	 * number of characters other than '/'. For catch-all placeholders the path parameter matches
	 * any number of characters.
	 *
	 * Examples:
	 *
	 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
	 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
	 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
	 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
	 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
	 * * `'/user/{id:[^/]*}'` - Same as the previous example.
	 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
	 *   parameter consists of 1 to 8 hex digits.
	 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
	 *   path into the parameter 'path'.
	 * * `'/files/*path'` - ditto.
	 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
	 *   in the built-in  `date` Type matches `2014-11-12`) and provides a Date object in $stateParams.start
	 *
	 * @param {string} pattern  The pattern to compile into a matcher.
	 * @param {Object} config  A configuration object hash:
	 * @param {Object=} parentMatcher Used to concatenate the pattern/config onto
	 *   an existing UrlMatcher
	 *
	 * * `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
	 * * `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
	 *
	 * @property {string} prefix  A static prefix of this pattern. The matcher guarantees that any
	 *   URL matching this matcher (i.e. any string for which {@link ui.router.util.type:UrlMatcher#methods_exec exec()} returns
	 *   non-null) will start with this prefix.
	 *
	 * @property {string} source  The pattern that was passed into the constructor
	 *
	 * @property {string} sourcePath  The path portion of the source property
	 *
	 * @property {string} sourceSearch  The search portion of the source property
	 *
	 * @property {string} regex  The constructed regex that will be used to match against the url when
	 *   it is time to determine which url will match.
	 *
	 * @returns {Object}  New `UrlMatcher` object
	 */
	function UrlMatcher(pattern, config, parentMatcher) {
	  config = extend({ params: {} }, isObject(config) ? config : {});
	
	  // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
	  //   '*' name
	  //   ':' name
	  //   '{' name '}'
	  //   '{' name ':' regexp '}'
	  // The regular expression is somewhat complicated due to the need to allow curly braces
	  // inside the regular expression. The placeholder regexp breaks down as follows:
	  //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
	  //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
	  //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
	  //    [^{}\\]+                       - anything other than curly braces or backslash
	  //    \\.                            - a backslash escape
	  //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
	  var placeholder       = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
	      compiled = '^', last = 0, m,
	      segments = this.segments = [],
	      parentParams = parentMatcher ? parentMatcher.params : {},
	      params = this.params = parentMatcher ? parentMatcher.params.$$new() : new $$UMFP.ParamSet(),
	      paramNames = [];
	
	  function addParameter(id, type, config, location) {
	    paramNames.push(id);
	    if (parentParams[id]) return parentParams[id];
	    if (!/^\w+([-.]+\w+)*(?:\[\])?$/.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
	    if (params[id]) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
	    params[id] = new $$UMFP.Param(id, type, config, location);
	    return params[id];
	  }
	
	  function quoteRegExp(string, pattern, squash, optional) {
	    var surroundPattern = ['',''], result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
	    if (!pattern) return result;
	    switch(squash) {
	      case false: surroundPattern = ['(', ')' + (optional ? "?" : "")]; break;
	      case true:
	        result = result.replace(/\/$/, '');
	        surroundPattern = ['(?:\/(', ')|\/)?'];
	      break;
	      default:    surroundPattern = ['(' + squash + "|", ')?']; break;
	    }
	    return result + surroundPattern[0] + pattern + surroundPattern[1];
	  }
	
	  this.source = pattern;
	
	  // Split into static segments separated by path parameter placeholders.
	  // The number of segments is always 1 more than the number of parameters.
	  function matchDetails(m, isSearch) {
	    var id, regexp, segment, type, cfg, arrayMode;
	    id          = m[2] || m[3]; // IE[78] returns '' for unmatched groups instead of null
	    cfg         = config.params[id];
	    segment     = pattern.substring(last, m.index);
	    regexp      = isSearch ? m[4] : m[4] || (m[1] == '*' ? '.*' : null);
	
	    if (regexp) {
	      type      = $$UMFP.type(regexp) || inherit($$UMFP.type("string"), { pattern: new RegExp(regexp, config.caseInsensitive ? 'i' : undefined) });
	    }
	
	    return {
	      id: id, regexp: regexp, segment: segment, type: type, cfg: cfg
	    };
	  }
	
	  var p, param, segment;
	  while ((m = placeholder.exec(pattern))) {
	    p = matchDetails(m, false);
	    if (p.segment.indexOf('?') >= 0) break; // we're into the search part
	
	    param = addParameter(p.id, p.type, p.cfg, "path");
	    compiled += quoteRegExp(p.segment, param.type.pattern.source, param.squash, param.isOptional);
	    segments.push(p.segment);
	    last = placeholder.lastIndex;
	  }
	  segment = pattern.substring(last);
	
	  // Find any search parameter names and remove them from the last segment
	  var i = segment.indexOf('?');
	
	  if (i >= 0) {
	    var search = this.sourceSearch = segment.substring(i);
	    segment = segment.substring(0, i);
	    this.sourcePath = pattern.substring(0, last + i);
	
	    if (search.length > 0) {
	      last = 0;
	      while ((m = searchPlaceholder.exec(search))) {
	        p = matchDetails(m, true);
	        param = addParameter(p.id, p.type, p.cfg, "search");
	        last = placeholder.lastIndex;
	        // check if ?&
	      }
	    }
	  } else {
	    this.sourcePath = pattern;
	    this.sourceSearch = '';
	  }
	
	  compiled += quoteRegExp(segment) + (config.strict === false ? '\/?' : '') + '$';
	  segments.push(segment);
	
	  this.regexp = new RegExp(compiled, config.caseInsensitive ? 'i' : undefined);
	  this.prefix = segments[0];
	  this.$$paramNames = paramNames;
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#concat
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns a new matcher for a pattern constructed by appending the path part and adding the
	 * search parameters of the specified pattern to this pattern. The current pattern is not
	 * modified. This can be understood as creating a pattern for URLs that are relative to (or
	 * suffixes of) the current pattern.
	 *
	 * @example
	 * The following two matchers are equivalent:
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').concat('/details?date');
	 * new UrlMatcher('/user/{id}/details?q&date');
	 * </pre>
	 *
	 * @param {string} pattern  The pattern to append.
	 * @param {Object} config  An object hash of the configuration for the matcher.
	 * @returns {UrlMatcher}  A matcher for the concatenated pattern.
	 */
	UrlMatcher.prototype.concat = function (pattern, config) {
	  // Because order of search parameters is irrelevant, we can add our own search
	  // parameters to the end of the new pattern. Parse the new pattern by itself
	  // and then join the bits together, but it's much easier to do this on a string level.
	  var defaultConfig = {
	    caseInsensitive: $$UMFP.caseInsensitive(),
	    strict: $$UMFP.strictMode(),
	    squash: $$UMFP.defaultSquashPolicy()
	  };
	  return new UrlMatcher(this.sourcePath + pattern + this.sourceSearch, extend(defaultConfig, config), this);
	};
	
	UrlMatcher.prototype.toString = function () {
	  return this.source;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#exec
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Tests the specified path against this matcher, and returns an object containing the captured
	 * parameter values, or null if the path does not match. The returned object contains the values
	 * of any search parameters that are mentioned in the pattern, but their value may be null if
	 * they are not present in `searchParams`. This means that search parameters are always treated
	 * as optional.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
	 *   x: '1', q: 'hello'
	 * });
	 * // returns { id: 'bob', q: 'hello', r: null }
	 * </pre>
	 *
	 * @param {string} path  The URL path to match, e.g. `$location.path()`.
	 * @param {Object} searchParams  URL search parameters, e.g. `$location.search()`.
	 * @returns {Object}  The captured parameter values.
	 */
	UrlMatcher.prototype.exec = function (path, searchParams) {
	  var m = this.regexp.exec(path);
	  if (!m) return null;
	  searchParams = searchParams || {};
	
	  var paramNames = this.parameters(), nTotal = paramNames.length,
	    nPath = this.segments.length - 1,
	    values = {}, i, j, cfg, paramName;
	
	  if (nPath !== m.length - 1) throw new Error("Unbalanced capture group in route '" + this.source + "'");
	
	  function decodePathArray(string) {
	    function reverseString(str) { return str.split("").reverse().join(""); }
	    function unquoteDashes(str) { return str.replace(/\\-/g, "-"); }
	
	    var split = reverseString(string).split(/-(?!\\)/);
	    var allReversed = map(split, reverseString);
	    return map(allReversed, unquoteDashes).reverse();
	  }
	
	  var param, paramVal;
	  for (i = 0; i < nPath; i++) {
	    paramName = paramNames[i];
	    param = this.params[paramName];
	    paramVal = m[i+1];
	    // if the param value matches a pre-replace pair, replace the value before decoding.
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (paramVal && param.array === true) paramVal = decodePathArray(paramVal);
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	  for (/**/; i < nTotal; i++) {
	    paramName = paramNames[i];
	    values[paramName] = this.params[paramName].value(searchParams[paramName]);
	    param = this.params[paramName];
	    paramVal = searchParams[paramName];
	    for (j = 0; j < param.replace.length; j++) {
	      if (param.replace[j].from === paramVal) paramVal = param.replace[j].to;
	    }
	    if (isDefined(paramVal)) paramVal = param.type.decode(paramVal);
	    values[paramName] = param.value(paramVal);
	  }
	
	  return values;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#parameters
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Returns the names of all path and search parameters of this pattern in an unspecified order.
	 *
	 * @returns {Array.<string>}  An array of parameter names. Must be treated as read-only. If the
	 *    pattern has no parameters, an empty array is returned.
	 */
	UrlMatcher.prototype.parameters = function (param) {
	  if (!isDefined(param)) return this.$$paramNames;
	  return this.params[param] || null;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#validates
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Checks an object hash of parameters to validate their correctness according to the parameter
	 * types of this `UrlMatcher`.
	 *
	 * @param {Object} params The object hash of parameters to validate.
	 * @returns {boolean} Returns `true` if `params` validates, otherwise `false`.
	 */
	UrlMatcher.prototype.validates = function (params) {
	  return this.params.$$validates(params);
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:UrlMatcher#format
	 * @methodOf ui.router.util.type:UrlMatcher
	 *
	 * @description
	 * Creates a URL that matches this pattern by substituting the specified values
	 * for the path and search parameters. Null values for path parameters are
	 * treated as empty strings.
	 *
	 * @example
	 * <pre>
	 * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
	 * // returns '/user/bob?q=yes'
	 * </pre>
	 *
	 * @param {Object} values  the values to substitute for the parameters in this pattern.
	 * @returns {string}  the formatted URL (path and optionally search part).
	 */
	UrlMatcher.prototype.format = function (values) {
	  values = values || {};
	  var segments = this.segments, params = this.parameters(), paramset = this.params;
	  if (!this.validates(values)) return null;
	
	  var i, search = false, nPath = segments.length - 1, nTotal = params.length, result = segments[0];
	
	  function encodeDashes(str) { // Replace dashes with encoded "\-"
	    return encodeURIComponent(str).replace(/-/g, function(c) { return '%5C%' + c.charCodeAt(0).toString(16).toUpperCase(); });
	  }
	
	  for (i = 0; i < nTotal; i++) {
	    var isPathParam = i < nPath;
	    var name = params[i], param = paramset[name], value = param.value(values[name]);
	    var isDefaultValue = param.isOptional && param.type.equals(param.value(), value);
	    var squash = isDefaultValue ? param.squash : false;
	    var encoded = param.type.encode(value);
	
	    if (isPathParam) {
	      var nextSegment = segments[i + 1];
	      var isFinalPathParam = i + 1 === nPath;
	
	      if (squash === false) {
	        if (encoded != null) {
	          if (isArray(encoded)) {
	            result += map(encoded, encodeDashes).join("-");
	          } else {
	            result += encodeURIComponent(encoded);
	          }
	        }
	        result += nextSegment;
	      } else if (squash === true) {
	        var capture = result.match(/\/$/) ? /\/?(.*)/ : /(.*)/;
	        result += nextSegment.match(capture)[1];
	      } else if (isString(squash)) {
	        result += squash + nextSegment;
	      }
	
	      if (isFinalPathParam && param.squash === true && result.slice(-1) === '/') result = result.slice(0, -1);
	    } else {
	      if (encoded == null || (isDefaultValue && squash !== false)) continue;
	      if (!isArray(encoded)) encoded = [ encoded ];
	      if (encoded.length === 0) continue;
	      encoded = map(encoded, encodeURIComponent).join('&' + name + '=');
	      result += (search ? '&' : '?') + (name + '=' + encoded);
	      search = true;
	    }
	  }
	
	  return result;
	};
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.type:Type
	 *
	 * @description
	 * Implements an interface to define custom parameter types that can be decoded from and encoded to
	 * string parameters matched in a URL. Used by {@link ui.router.util.type:UrlMatcher `UrlMatcher`}
	 * objects when matching or formatting URLs, or comparing or validating parameter values.
	 *
	 * See {@link ui.router.util.$urlMatcherFactory#methods_type `$urlMatcherFactory#type()`} for more
	 * information on registering custom types.
	 *
	 * @param {Object} config  A configuration object which contains the custom type definition.  The object's
	 *        properties will override the default methods and/or pattern in `Type`'s public interface.
	 * @example
	 * <pre>
	 * {
	 *   decode: function(val) { return parseInt(val, 10); },
	 *   encode: function(val) { return val && val.toString(); },
	 *   equals: function(a, b) { return this.is(a) && a === b; },
	 *   is: function(val) { return angular.isNumber(val) isFinite(val) && val % 1 === 0; },
	 *   pattern: /\d+/
	 * }
	 * </pre>
	 *
	 * @property {RegExp} pattern The regular expression pattern used to match values of this type when
	 *           coming from a substring of a URL.
	 *
	 * @returns {Object}  Returns a new `Type` object.
	 */
	function Type(config) {
	  extend(this, config);
	}
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#is
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Detects whether a value is of a particular type. Accepts a native (decoded) value
	 * and determines whether it matches the current `Type` object.
	 *
	 * @param {*} val  The value to check.
	 * @param {string} key  Optional. If the type check is happening in the context of a specific
	 *        {@link ui.router.util.type:UrlMatcher `UrlMatcher`} object, this is the name of the
	 *        parameter in which `val` is stored. Can be used for meta-programming of `Type` objects.
	 * @returns {Boolean}  Returns `true` if the value matches the type, otherwise `false`.
	 */
	Type.prototype.is = function(val, key) {
	  return true;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#encode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Encodes a custom/native type value to a string that can be embedded in a URL. Note that the
	 * return value does *not* need to be URL-safe (i.e. passed through `encodeURIComponent()`), it
	 * only needs to be a representation of `val` that has been coerced to a string.
	 *
	 * @param {*} val  The value to encode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {string}  Returns a string representation of `val` that can be encoded in a URL.
	 */
	Type.prototype.encode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#decode
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Converts a parameter value (from URL string or transition param) to a custom/native value.
	 *
	 * @param {string} val  The URL parameter value to decode.
	 * @param {string} key  The name of the parameter in which `val` is stored. Can be used for
	 *        meta-programming of `Type` objects.
	 * @returns {*}  Returns a custom representation of the URL parameter value.
	 */
	Type.prototype.decode = function(val, key) {
	  return val;
	};
	
	/**
	 * @ngdoc function
	 * @name ui.router.util.type:Type#equals
	 * @methodOf ui.router.util.type:Type
	 *
	 * @description
	 * Determines whether two decoded values are equivalent.
	 *
	 * @param {*} a  A value to compare against.
	 * @param {*} b  A value to compare against.
	 * @returns {Boolean}  Returns `true` if the values are equivalent/equal, otherwise `false`.
	 */
	Type.prototype.equals = function(a, b) {
	  return a == b;
	};
	
	Type.prototype.$subPattern = function() {
	  var sub = this.pattern.toString();
	  return sub.substr(1, sub.length - 2);
	};
	
	Type.prototype.pattern = /.*/;
	
	Type.prototype.toString = function() { return "{Type:" + this.name + "}"; };
	
	/** Given an encoded string, or a decoded object, returns a decoded object */
	Type.prototype.$normalize = function(val) {
	  return this.is(val) ? val : this.decode(val);
	};
	
	/*
	 * Wraps an existing custom Type as an array of Type, depending on 'mode'.
	 * e.g.:
	 * - urlmatcher pattern "/path?{queryParam[]:int}"
	 * - url: "/path?queryParam=1&queryParam=2
	 * - $stateParams.queryParam will be [1, 2]
	 * if `mode` is "auto", then
	 * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
	 * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
	 */
	Type.prototype.$asArray = function(mode, isSearch) {
	  if (!mode) return this;
	  if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
	
	  function ArrayType(type, mode) {
	    function bindTo(type, callbackName) {
	      return function() {
	        return type[callbackName].apply(type, arguments);
	      };
	    }
	
	    // Wrap non-array value as array
	    function arrayWrap(val) { return isArray(val) ? val : (isDefined(val) ? [ val ] : []); }
	    // Unwrap array value for "auto" mode. Return undefined for empty array.
	    function arrayUnwrap(val) {
	      switch(val.length) {
	        case 0: return undefined;
	        case 1: return mode === "auto" ? val[0] : val;
	        default: return val;
	      }
	    }
	    function falsey(val) { return !val; }
	
	    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
	    function arrayHandler(callback, allTruthyMode) {
	      return function handleArray(val) {
	        if (isArray(val) && val.length === 0) return val;
	        val = arrayWrap(val);
	        var result = map(val, callback);
	        if (allTruthyMode === true)
	          return filter(result, falsey).length === 0;
	        return arrayUnwrap(result);
	      };
	    }
	
	    // Wraps type (.equals) functions to operate on each value of an array
	    function arrayEqualsHandler(callback) {
	      return function handleArray(val1, val2) {
	        var left = arrayWrap(val1), right = arrayWrap(val2);
	        if (left.length !== right.length) return false;
	        for (var i = 0; i < left.length; i++) {
	          if (!callback(left[i], right[i])) return false;
	        }
	        return true;
	      };
	    }
	
	    this.encode = arrayHandler(bindTo(type, 'encode'));
	    this.decode = arrayHandler(bindTo(type, 'decode'));
	    this.is     = arrayHandler(bindTo(type, 'is'), true);
	    this.equals = arrayEqualsHandler(bindTo(type, 'equals'));
	    this.pattern = type.pattern;
	    this.$normalize = arrayHandler(bindTo(type, '$normalize'));
	    this.name = type.name;
	    this.$arrayMode = mode;
	  }
	
	  return new ArrayType(this, mode);
	};
	
	
	
	/**
	 * @ngdoc object
	 * @name ui.router.util.$urlMatcherFactory
	 *
	 * @description
	 * Factory for {@link ui.router.util.type:UrlMatcher `UrlMatcher`} instances. The factory
	 * is also available to providers under the name `$urlMatcherFactoryProvider`.
	 */
	function $UrlMatcherFactory() {
	  $$UMFP = this;
	
	  var isCaseInsensitive = false, isStrictMode = true, defaultSquashPolicy = false;
	
	  // Use tildes to pre-encode slashes.
	  // If the slashes are simply URLEncoded, the browser can choose to pre-decode them,
	  // and bidirectional encoding/decoding fails.
	  // Tilde was chosen because it's not a RFC 3986 section 2.2 Reserved Character
	  function valToString(val) { return val != null ? val.toString().replace(/(~|\/)/g, function (m) { return {'~':'~~', '/':'~2F'}[m]; }) : val; }
	  function valFromString(val) { return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) { return {'~~':'~', '~2F':'/'}[m]; }) : val; }
	
	  var $types = {}, enqueue = true, typeQueue = [], injector, defaultTypes = {
	    "string": {
	      encode: valToString,
	      decode: valFromString,
	      // TODO: in 1.0, make string .is() return false if value is undefined/null by default.
	      // In 0.2.x, string params are optional by default for backwards compat
	      is: function(val) { return val == null || !isDefined(val) || typeof val === "string"; },
	      pattern: /[^/]*/
	    },
	    "int": {
	      encode: valToString,
	      decode: function(val) { return parseInt(val, 10); },
	      is: function(val) { return isDefined(val) && this.decode(val.toString()) === val; },
	      pattern: /\d+/
	    },
	    "bool": {
	      encode: function(val) { return val ? 1 : 0; },
	      decode: function(val) { return parseInt(val, 10) !== 0; },
	      is: function(val) { return val === true || val === false; },
	      pattern: /0|1/
	    },
	    "date": {
	      encode: function (val) {
	        if (!this.is(val))
	          return undefined;
	        return [ val.getFullYear(),
	          ('0' + (val.getMonth() + 1)).slice(-2),
	          ('0' + val.getDate()).slice(-2)
	        ].join("-");
	      },
	      decode: function (val) {
	        if (this.is(val)) return val;
	        var match = this.capture.exec(val);
	        return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
	      },
	      is: function(val) { return val instanceof Date && !isNaN(val.valueOf()); },
	      equals: function (a, b) { return this.is(a) && this.is(b) && a.toISOString() === b.toISOString(); },
	      pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
	      capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
	    },
	    "json": {
	      encode: angular.toJson,
	      decode: angular.fromJson,
	      is: angular.isObject,
	      equals: angular.equals,
	      pattern: /[^/]*/
	    },
	    "any": { // does not encode/decode
	      encode: angular.identity,
	      decode: angular.identity,
	      equals: angular.equals,
	      pattern: /.*/
	    }
	  };
	
	  function getDefaultConfig() {
	    return {
	      strict: isStrictMode,
	      caseInsensitive: isCaseInsensitive
	    };
	  }
	
	  function isInjectable(value) {
	    return (isFunction(value) || (isArray(value) && isFunction(value[value.length - 1])));
	  }
	
	  /**
	   * [Internal] Get the default value of a parameter, which may be an injectable function.
	   */
	  $UrlMatcherFactory.$$getDefaultValue = function(config) {
	    if (!isInjectable(config.value)) return config.value;
	    if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	    return injector.invoke(config.value);
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#caseInsensitive
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URL matching should be case sensitive (the default behavior), or not.
	   *
	   * @param {boolean} value `false` to match URL in a case sensitive manner; otherwise `true`;
	   * @returns {boolean} the current value of caseInsensitive
	   */
	  this.caseInsensitive = function(value) {
	    if (isDefined(value))
	      isCaseInsensitive = value;
	    return isCaseInsensitive;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#strictMode
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Defines whether URLs should match trailing slashes, or not (the default behavior).
	   *
	   * @param {boolean=} value `false` to match trailing slashes in URLs, otherwise `true`.
	   * @returns {boolean} the current value of strictMode
	   */
	  this.strictMode = function(value) {
	    if (isDefined(value))
	      isStrictMode = value;
	    return isStrictMode;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#defaultSquashPolicy
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Sets the default behavior when generating or matching URLs with default parameter values.
	   *
	   * @param {string} value A string that defines the default parameter URL squashing behavior.
	   *    `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
	   *    `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
	   *             parameter is surrounded by slashes, squash (remove) one slash from the URL
	   *    any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
	   *             the parameter value from the URL and replace it with this string.
	   */
	  this.defaultSquashPolicy = function(value) {
	    if (!isDefined(value)) return defaultSquashPolicy;
	    if (value !== true && value !== false && !isString(value))
	      throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
	    defaultSquashPolicy = value;
	    return value;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#compile
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Creates a {@link ui.router.util.type:UrlMatcher `UrlMatcher`} for the specified pattern.
	   *
	   * @param {string} pattern  The URL pattern.
	   * @param {Object} config  The config object hash.
	   * @returns {UrlMatcher}  The UrlMatcher.
	   */
	  this.compile = function (pattern, config) {
	    return new UrlMatcher(pattern, extend(getDefaultConfig(), config));
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#isMatcher
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Returns true if the specified object is a `UrlMatcher`, or false otherwise.
	   *
	   * @param {Object} object  The object to perform the type check against.
	   * @returns {Boolean}  Returns `true` if the object matches the `UrlMatcher` interface, by
	   *          implementing all the same methods.
	   */
	  this.isMatcher = function (o) {
	    if (!isObject(o)) return false;
	    var result = true;
	
	    forEach(UrlMatcher.prototype, function(val, name) {
	      if (isFunction(val)) {
	        result = result && (isDefined(o[name]) && isFunction(o[name]));
	      }
	    });
	    return result;
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.util.$urlMatcherFactory#type
	   * @methodOf ui.router.util.$urlMatcherFactory
	   *
	   * @description
	   * Registers a custom {@link ui.router.util.type:Type `Type`} object that can be used to
	   * generate URLs with typed parameters.
	   *
	   * @param {string} name  The type name.
	   * @param {Object|Function} definition   The type definition. See
	   *        {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   * @param {Object|Function} definitionFn (optional) A function that is injected before the app
	   *        runtime starts.  The result of this function is merged into the existing `definition`.
	   *        See {@link ui.router.util.type:Type `Type`} for information on the values accepted.
	   *
	   * @returns {Object}  Returns `$urlMatcherFactoryProvider`.
	   *
	   * @example
	   * This is a simple example of a custom type that encodes and decodes items from an
	   * array, using the array index as the URL-encoded value:
	   *
	   * <pre>
	   * var list = ['John', 'Paul', 'George', 'Ringo'];
	   *
	   * $urlMatcherFactoryProvider.type('listItem', {
	   *   encode: function(item) {
	   *     // Represent the list item in the URL using its corresponding index
	   *     return list.indexOf(item);
	   *   },
	   *   decode: function(item) {
	   *     // Look up the list item by index
	   *     return list[parseInt(item, 10)];
	   *   },
	   *   is: function(item) {
	   *     // Ensure the item is valid by checking to see that it appears
	   *     // in the list
	   *     return list.indexOf(item) > -1;
	   *   }
	   * });
	   *
	   * $stateProvider.state('list', {
	   *   url: "/list/{item:listItem}",
	   *   controller: function($scope, $stateParams) {
	   *     console.log($stateParams.item);
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * // Changes URL to '/list/3', logs "Ringo" to the console
	   * $state.go('list', { item: "Ringo" });
	   * </pre>
	   *
	   * This is a more complex example of a type that relies on dependency injection to
	   * interact with services, and uses the parameter name from the URL to infer how to
	   * handle encoding and decoding parameter values:
	   *
	   * <pre>
	   * // Defines a custom type that gets a value from a service,
	   * // where each service gets different types of values from
	   * // a backend API:
	   * $urlMatcherFactoryProvider.type('dbObject', {}, function(Users, Posts) {
	   *
	   *   // Matches up services to URL parameter names
	   *   var services = {
	   *     user: Users,
	   *     post: Posts
	   *   };
	   *
	   *   return {
	   *     encode: function(object) {
	   *       // Represent the object in the URL using its unique ID
	   *       return object.id;
	   *     },
	   *     decode: function(value, key) {
	   *       // Look up the object by ID, using the parameter
	   *       // name (key) to call the correct service
	   *       return services[key].findById(value);
	   *     },
	   *     is: function(object, key) {
	   *       // Check that object is a valid dbObject
	   *       return angular.isObject(object) && object.id && services[key];
	   *     }
	   *     equals: function(a, b) {
	   *       // Check the equality of decoded objects by comparing
	   *       // their unique IDs
	   *       return a.id === b.id;
	   *     }
	   *   };
	   * });
	   *
	   * // In a config() block, you can then attach URLs with
	   * // type-annotated parameters:
	   * $stateProvider.state('users', {
	   *   url: "/users",
	   *   // ...
	   * }).state('users.item', {
	   *   url: "/{user:dbObject}",
	   *   controller: function($scope, $stateParams) {
	   *     // $stateParams.user will now be an object returned from
	   *     // the Users service
	   *   },
	   *   // ...
	   * });
	   * </pre>
	   */
	  this.type = function (name, definition, definitionFn) {
	    if (!isDefined(definition)) return $types[name];
	    if ($types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
	
	    $types[name] = new Type(extend({ name: name }, definition));
	    if (definitionFn) {
	      typeQueue.push({ name: name, def: definitionFn });
	      if (!enqueue) flushTypeQueue();
	    }
	    return this;
	  };
	
	  // `flushTypeQueue()` waits until `$urlMatcherFactory` is injected before invoking the queued `definitionFn`s
	  function flushTypeQueue() {
	    while(typeQueue.length) {
	      var type = typeQueue.shift();
	      if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
	      angular.extend($types[type.name], injector.invoke(type.def));
	    }
	  }
	
	  // Register default types. Store them in the prototype of $types.
	  forEach(defaultTypes, function(type, name) { $types[name] = new Type(extend({name: name}, type)); });
	  $types = inherit($types, {});
	
	  /* No need to document $get, since it returns this */
	  this.$get = ['$injector', function ($injector) {
	    injector = $injector;
	    enqueue = false;
	    flushTypeQueue();
	
	    forEach(defaultTypes, function(type, name) {
	      if (!$types[name]) $types[name] = new Type(type);
	    });
	    return this;
	  }];
	
	  this.Param = function Param(id, type, config, location) {
	    var self = this;
	    config = unwrapShorthand(config);
	    type = getType(config, type, location);
	    var arrayMode = getArrayMode();
	    type = arrayMode ? type.$asArray(arrayMode, location === "search") : type;
	    if (type.name === "string" && !arrayMode && location === "path" && config.value === undefined)
	      config.value = ""; // for 0.2.x; in 0.3.0+ do not automatically default to ""
	    var isOptional = config.value !== undefined;
	    var squash = getSquashPolicy(config, isOptional);
	    var replace = getReplace(config, arrayMode, isOptional, squash);
	
	    function unwrapShorthand(config) {
	      var keys = isObject(config) ? objectKeys(config) : [];
	      var isShorthand = indexOf(keys, "value") === -1 && indexOf(keys, "type") === -1 &&
	                        indexOf(keys, "squash") === -1 && indexOf(keys, "array") === -1;
	      if (isShorthand) config = { value: config };
	      config.$$fn = isInjectable(config.value) ? config.value : function () { return config.value; };
	      return config;
	    }
	
	    function getType(config, urlType, location) {
	      if (config.type && urlType) throw new Error("Param '"+id+"' has two type configurations.");
	      if (urlType) return urlType;
	      if (!config.type) return (location === "config" ? $types.any : $types.string);
	
	      if (angular.isString(config.type))
	        return $types[config.type];
	      if (config.type instanceof Type)
	        return config.type;
	      return new Type(config.type);
	    }
	
	    // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
	    function getArrayMode() {
	      var arrayDefaults = { array: (location === "search" ? "auto" : false) };
	      var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
	      return extend(arrayDefaults, arrayParamNomenclature, config).array;
	    }
	
	    /**
	     * returns false, true, or the squash value to indicate the "default parameter url squash policy".
	     */
	    function getSquashPolicy(config, isOptional) {
	      var squash = config.squash;
	      if (!isOptional || squash === false) return false;
	      if (!isDefined(squash) || squash == null) return defaultSquashPolicy;
	      if (squash === true || isString(squash)) return squash;
	      throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
	    }
	
	    function getReplace(config, arrayMode, isOptional, squash) {
	      var replace, configuredKeys, defaultPolicy = [
	        { from: "",   to: (isOptional || arrayMode ? undefined : "") },
	        { from: null, to: (isOptional || arrayMode ? undefined : "") }
	      ];
	      replace = isArray(config.replace) ? config.replace : [];
	      if (isString(squash))
	        replace.push({ from: squash, to: undefined });
	      configuredKeys = map(replace, function(item) { return item.from; } );
	      return filter(defaultPolicy, function(item) { return indexOf(configuredKeys, item.from) === -1; }).concat(replace);
	    }
	
	    /**
	     * [Internal] Get the default value of a parameter, which may be an injectable function.
	     */
	    function $$getDefaultValue() {
	      if (!injector) throw new Error("Injectable functions cannot be called at configuration time");
	      var defaultValue = injector.invoke(config.$$fn);
	      if (defaultValue !== null && defaultValue !== undefined && !self.type.is(defaultValue))
	        throw new Error("Default value (" + defaultValue + ") for parameter '" + self.id + "' is not an instance of Type (" + self.type.name + ")");
	      return defaultValue;
	    }
	
	    /**
	     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
	     * default value, which may be the result of an injectable function.
	     */
	    function $value(value) {
	      function hasReplaceVal(val) { return function(obj) { return obj.from === val; }; }
	      function $replace(value) {
	        var replacement = map(filter(self.replace, hasReplaceVal(value)), function(obj) { return obj.to; });
	        return replacement.length ? replacement[0] : value;
	      }
	      value = $replace(value);
	      return !isDefined(value) ? $$getDefaultValue() : self.type.$normalize(value);
	    }
	
	    function toString() { return "{Param:" + id + " " + type + " squash: '" + squash + "' optional: " + isOptional + "}"; }
	
	    extend(this, {
	      id: id,
	      type: type,
	      location: location,
	      array: arrayMode,
	      squash: squash,
	      replace: replace,
	      isOptional: isOptional,
	      value: $value,
	      dynamic: undefined,
	      config: config,
	      toString: toString
	    });
	  };
	
	  function ParamSet(params) {
	    extend(this, params || {});
	  }
	
	  ParamSet.prototype = {
	    $$new: function() {
	      return inherit(this, extend(new ParamSet(), { $$parent: this}));
	    },
	    $$keys: function () {
	      var keys = [], chain = [], parent = this,
	        ignore = objectKeys(ParamSet.prototype);
	      while (parent) { chain.push(parent); parent = parent.$$parent; }
	      chain.reverse();
	      forEach(chain, function(paramset) {
	        forEach(objectKeys(paramset), function(key) {
	            if (indexOf(keys, key) === -1 && indexOf(ignore, key) === -1) keys.push(key);
	        });
	      });
	      return keys;
	    },
	    $$values: function(paramValues) {
	      var values = {}, self = this;
	      forEach(self.$$keys(), function(key) {
	        values[key] = self[key].value(paramValues && paramValues[key]);
	      });
	      return values;
	    },
	    $$equals: function(paramValues1, paramValues2) {
	      var equal = true, self = this;
	      forEach(self.$$keys(), function(key) {
	        var left = paramValues1 && paramValues1[key], right = paramValues2 && paramValues2[key];
	        if (!self[key].type.equals(left, right)) equal = false;
	      });
	      return equal;
	    },
	    $$validates: function $$validate(paramValues) {
	      var keys = this.$$keys(), i, param, rawVal, normalized, encoded;
	      for (i = 0; i < keys.length; i++) {
	        param = this[keys[i]];
	        rawVal = paramValues[keys[i]];
	        if ((rawVal === undefined || rawVal === null) && param.isOptional)
	          break; // There was no parameter value, but the param is optional
	        normalized = param.type.$normalize(rawVal);
	        if (!param.type.is(normalized))
	          return false; // The value was not of the correct Type, and could not be decoded to the correct Type
	        encoded = param.type.encode(normalized);
	        if (angular.isString(encoded) && !param.type.pattern.exec(encoded))
	          return false; // The value was of the correct type, but when encoded, did not match the Type's regexp
	      }
	      return true;
	    },
	    $$parent: undefined
	  };
	
	  this.ParamSet = ParamSet;
	}
	
	// Register as a provider so it's available to other providers
	angular.module('ui.router.util').provider('$urlMatcherFactory', $UrlMatcherFactory);
	angular.module('ui.router.util').run(['$urlMatcherFactory', function($urlMatcherFactory) { }]);
	
	/**
	 * @ngdoc object
	 * @name ui.router.router.$urlRouterProvider
	 *
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 * @requires $locationProvider
	 *
	 * @description
	 * `$urlRouterProvider` has the responsibility of watching `$location`. 
	 * When `$location` changes it runs through a list of rules one by one until a 
	 * match is found. `$urlRouterProvider` is used behind the scenes anytime you specify 
	 * a url in a state configuration. All urls are compiled into a UrlMatcher object.
	 *
	 * There are several methods on `$urlRouterProvider` that make it useful to use directly
	 * in your module config.
	 */
	$UrlRouterProvider.$inject = ['$locationProvider', '$urlMatcherFactoryProvider'];
	function $UrlRouterProvider(   $locationProvider,   $urlMatcherFactory) {
	  var rules = [], otherwise = null, interceptDeferred = false, listener;
	
	  // Returns a string that is a prefix of all strings matching the RegExp
	  function regExpPrefix(re) {
	    var prefix = /^\^((?:\\[^a-zA-Z0-9]|[^\\\[\]\^$*+?.()|{}]+)*)/.exec(re.source);
	    return (prefix != null) ? prefix[1].replace(/\\(.)/g, "$1") : '';
	  }
	
	  // Interpolates matched values into a String.replace()-style pattern
	  function interpolate(pattern, match) {
	    return pattern.replace(/\$(\$|\d{1,2})/, function (m, what) {
	      return match[what === '$' ? 0 : Number(what)];
	    });
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#rule
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines rules that are used by `$urlRouterProvider` to find matches for
	   * specific URLs.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // Here's an example of how you might allow case insensitive urls
	   *   $urlRouterProvider.rule(function ($injector, $location) {
	   *     var path = $location.path(),
	   *         normalized = path.toLowerCase();
	   *
	   *     if (path !== normalized) {
	   *       return normalized;
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {function} rule Handler function that takes `$injector` and `$location`
	   * services as arguments. You can use them to return a valid path as a string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.rule = function (rule) {
	    if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    rules.push(rule);
	    return this;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouterProvider#otherwise
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Defines a path that is used when an invalid route is requested.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   // if the path doesn't match any of the urls you configured
	   *   // otherwise will take care of routing the user to the
	   *   // specified url
	   *   $urlRouterProvider.otherwise('/index');
	   *
	   *   // Example of using function rule as param
	   *   $urlRouterProvider.otherwise(function ($injector, $location) {
	   *     return '/a/valid/url';
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|function} rule The url path you want to redirect to or a function 
	   * rule that returns the url path. The function version is passed two params: 
	   * `$injector` and `$location` services, and must return a url string.
	   *
	   * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
	   */
	  this.otherwise = function (rule) {
	    if (isString(rule)) {
	      var redirect = rule;
	      rule = function () { return redirect; };
	    }
	    else if (!isFunction(rule)) throw new Error("'rule' must be a function");
	    otherwise = rule;
	    return this;
	  };
	
	
	  function handleIfMatch($injector, handler, match) {
	    if (!match) return false;
	    var result = $injector.invoke(handler, handler, { $match: match });
	    return isDefined(result) ? result : true;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#when
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Registers a handler for a given url matching. 
	   * 
	   * If the handler is a string, it is
	   * treated as a redirect, and is interpolated according to the syntax of match
	   * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
	   *
	   * If the handler is a function, it is injectable. It gets invoked if `$location`
	   * matches. You have the option of inject the match object as `$match`.
	   *
	   * The handler can return
	   *
	   * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
	   *   will continue trying to find another one that matches.
	   * - **string** which is treated as a redirect and passed to `$location.url()`
	   * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
	   *     if ($state.$current.navigable !== state ||
	   *         !equalForKeys($match, $stateParams) {
	   *      $state.transitionTo(state, $match, false);
	   *     }
	   *   });
	   * });
	   * </pre>
	   *
	   * @param {string|object} what The incoming path that you want to redirect.
	   * @param {string|function} handler The path you want to redirect your user to.
	   */
	  this.when = function (what, handler) {
	    var redirect, handlerIsString = isString(handler);
	    if (isString(what)) what = $urlMatcherFactory.compile(what);
	
	    if (!handlerIsString && !isFunction(handler) && !isArray(handler))
	      throw new Error("invalid 'handler' in when()");
	
	    var strategies = {
	      matcher: function (what, handler) {
	        if (handlerIsString) {
	          redirect = $urlMatcherFactory.compile(handler);
	          handler = ['$match', function ($match) { return redirect.format($match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path(), $location.search()));
	        }, {
	          prefix: isString(what.prefix) ? what.prefix : ''
	        });
	      },
	      regex: function (what, handler) {
	        if (what.global || what.sticky) throw new Error("when() RegExp must not be global or sticky");
	
	        if (handlerIsString) {
	          redirect = handler;
	          handler = ['$match', function ($match) { return interpolate(redirect, $match); }];
	        }
	        return extend(function ($injector, $location) {
	          return handleIfMatch($injector, handler, what.exec($location.path()));
	        }, {
	          prefix: regExpPrefix(what)
	        });
	      }
	    };
	
	    var check = { matcher: $urlMatcherFactory.isMatcher(what), regex: what instanceof RegExp };
	
	    for (var n in check) {
	      if (check[n]) return this.rule(strategies[n](what, handler));
	    }
	
	    throw new Error("invalid 'what' in when()");
	  };
	
	  /**
	   * @ngdoc function
	   * @name ui.router.router.$urlRouterProvider#deferIntercept
	   * @methodOf ui.router.router.$urlRouterProvider
	   *
	   * @description
	   * Disables (or enables) deferring location change interception.
	   *
	   * If you wish to customize the behavior of syncing the URL (for example, if you wish to
	   * defer a transition but maintain the current URL), call this method at configuration time.
	   * Then, at run time, call `$urlRouter.listen()` after you have configured your own
	   * `$locationChangeSuccess` event handler.
	   *
	   * @example
	   * <pre>
	   * var app = angular.module('app', ['ui.router.router']);
	   *
	   * app.config(function ($urlRouterProvider) {
	   *
	   *   // Prevent $urlRouter from automatically intercepting URL changes;
	   *   // this allows you to configure custom behavior in between
	   *   // location changes and route synchronization:
	   *   $urlRouterProvider.deferIntercept();
	   *
	   * }).run(function ($rootScope, $urlRouter, UserService) {
	   *
	   *   $rootScope.$on('$locationChangeSuccess', function(e) {
	   *     // UserService is an example service for managing user state
	   *     if (UserService.isLoggedIn()) return;
	   *
	   *     // Prevent $urlRouter's default handler from firing
	   *     e.preventDefault();
	   *
	   *     UserService.handleLogin().then(function() {
	   *       // Once the user has logged in, sync the current URL
	   *       // to the router:
	   *       $urlRouter.sync();
	   *     });
	   *   });
	   *
	   *   // Configures $urlRouter's listener *after* your custom listener
	   *   $urlRouter.listen();
	   * });
	   * </pre>
	   *
	   * @param {boolean} defer Indicates whether to defer location change interception. Passing
	            no parameter is equivalent to `true`.
	   */
	  this.deferIntercept = function (defer) {
	    if (defer === undefined) defer = true;
	    interceptDeferred = defer;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.router.$urlRouter
	   *
	   * @requires $location
	   * @requires $rootScope
	   * @requires $injector
	   * @requires $browser
	   *
	   * @description
	   *
	   */
	  this.$get = $get;
	  $get.$inject = ['$location', '$rootScope', '$injector', '$browser', '$sniffer'];
	  function $get(   $location,   $rootScope,   $injector,   $browser,   $sniffer) {
	
	    var baseHref = $browser.baseHref(), location = $location.url(), lastPushedUrl;
	
	    function appendBasePath(url, isHtml5, absolute) {
	      if (baseHref === '/') return url;
	      if (isHtml5) return baseHref.slice(0, -1) + url;
	      if (absolute) return baseHref.slice(1) + url;
	      return url;
	    }
	
	    // TODO: Optimize groups of rules with non-empty prefix into some sort of decision tree
	    function update(evt) {
	      if (evt && evt.defaultPrevented) return;
	      var ignoreUpdate = lastPushedUrl && $location.url() === lastPushedUrl;
	      lastPushedUrl = undefined;
	      // TODO: Re-implement this in 1.0 for https://github.com/angular-ui/ui-router/issues/1573
	      //if (ignoreUpdate) return true;
	
	      function check(rule) {
	        var handled = rule($injector, $location);
	
	        if (!handled) return false;
	        if (isString(handled)) $location.replace().url(handled);
	        return true;
	      }
	      var n = rules.length, i;
	
	      for (i = 0; i < n; i++) {
	        if (check(rules[i])) return;
	      }
	      // always check otherwise last to allow dynamic updates to the set of rules
	      if (otherwise) check(otherwise);
	    }
	
	    function listen() {
	      listener = listener || $rootScope.$on('$locationChangeSuccess', update);
	      return listener;
	    }
	
	    if (!interceptDeferred) listen();
	
	    return {
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#sync
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * Triggers an update; the same update that happens when the address bar url changes, aka `$locationChangeSuccess`.
	       * This method is useful when you need to use `preventDefault()` on the `$locationChangeSuccess` event,
	       * perform some custom logic (route protection, auth, config, redirection, etc) and then finally proceed
	       * with the transition by calling `$urlRouter.sync()`.
	       *
	       * @example
	       * <pre>
	       * angular.module('app', ['ui.router'])
	       *   .run(function($rootScope, $urlRouter) {
	       *     $rootScope.$on('$locationChangeSuccess', function(evt) {
	       *       // Halt state change from even starting
	       *       evt.preventDefault();
	       *       // Perform custom logic
	       *       var meetsRequirement = ...
	       *       // Continue with the update and state transition if logic allows
	       *       if (meetsRequirement) $urlRouter.sync();
	       *     });
	       * });
	       * </pre>
	       */
	      sync: function() {
	        update();
	      },
	
	      listen: function() {
	        return listen();
	      },
	
	      update: function(read) {
	        if (read) {
	          location = $location.url();
	          return;
	        }
	        if ($location.url() === location) return;
	
	        $location.url(location);
	        $location.replace();
	      },
	
	      push: function(urlMatcher, params, options) {
	         var url = urlMatcher.format(params || {});
	
	        // Handle the special hash param, if needed
	        if (url !== null && params && params['#']) {
	            url += '#' + params['#'];
	        }
	
	        $location.url(url);
	        lastPushedUrl = options && options.$$avoidResync ? $location.url() : undefined;
	        if (options && options.replace) $location.replace();
	      },
	
	      /**
	       * @ngdoc function
	       * @name ui.router.router.$urlRouter#href
	       * @methodOf ui.router.router.$urlRouter
	       *
	       * @description
	       * A URL generation method that returns the compiled URL for a given
	       * {@link ui.router.util.type:UrlMatcher `UrlMatcher`}, populated with the provided parameters.
	       *
	       * @example
	       * <pre>
	       * $bob = $urlRouter.href(new UrlMatcher("/about/:person"), {
	       *   person: "bob"
	       * });
	       * // $bob == "/about/bob";
	       * </pre>
	       *
	       * @param {UrlMatcher} urlMatcher The `UrlMatcher` object which is used as the template of the URL to generate.
	       * @param {object=} params An object of parameter values to fill the matcher's required parameters.
	       * @param {object=} options Options object. The options are:
	       *
	       * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	       *
	       * @returns {string} Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
	       */
	      href: function(urlMatcher, params, options) {
	        if (!urlMatcher.validates(params)) return null;
	
	        var isHtml5 = $locationProvider.html5Mode();
	        if (angular.isObject(isHtml5)) {
	          isHtml5 = isHtml5.enabled;
	        }
	
	        isHtml5 = isHtml5 && $sniffer.history;
	        
	        var url = urlMatcher.format(params);
	        options = options || {};
	
	        if (!isHtml5 && url !== null) {
	          url = "#" + $locationProvider.hashPrefix() + url;
	        }
	
	        // Handle special hash param, if needed
	        if (url !== null && params && params['#']) {
	          url += '#' + params['#'];
	        }
	
	        url = appendBasePath(url, isHtml5, options.absolute);
	
	        if (!options.absolute || !url) {
	          return url;
	        }
	
	        var slash = (!isHtml5 && url ? '/' : ''), port = $location.port();
	        port = (port === 80 || port === 443 ? '' : ':' + port);
	
	        return [$location.protocol(), '://', $location.host(), port, slash, url].join('');
	      }
	    };
	  }
	}
	
	angular.module('ui.router.router').provider('$urlRouter', $UrlRouterProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$stateProvider
	 *
	 * @requires ui.router.router.$urlRouterProvider
	 * @requires ui.router.util.$urlMatcherFactoryProvider
	 *
	 * @description
	 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
	 * on state.
	 *
	 * A state corresponds to a "place" in the application in terms of the overall UI and
	 * navigation. A state describes (via the controller / template / view properties) what
	 * the UI looks like and does at that place.
	 *
	 * States often have things in common, and the primary way of factoring out these
	 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
	 * nested states.
	 *
	 * The `$stateProvider` provides interfaces to declare these states for your app.
	 */
	$StateProvider.$inject = ['$urlRouterProvider', '$urlMatcherFactoryProvider'];
	function $StateProvider(   $urlRouterProvider,   $urlMatcherFactory) {
	
	  var root, states = {}, $state, queue = {}, abstractKey = 'abstract';
	
	  // Builds state properties from definition passed to registerState()
	  var stateBuilder = {
	
	    // Derive parent state from a hierarchical name only if 'parent' is not explicitly defined.
	    // state.children = [];
	    // if (parent) parent.children.push(state);
	    parent: function(state) {
	      if (isDefined(state.parent) && state.parent) return findState(state.parent);
	      // regex matches any valid composite state name
	      // would match "contact.list" but not "contacts"
	      var compositeName = /^(.+)\.[^.]+$/.exec(state.name);
	      return compositeName ? findState(compositeName[1]) : root;
	    },
	
	    // inherit 'data' from parent and override by own values (if any)
	    data: function(state) {
	      if (state.parent && state.parent.data) {
	        state.data = state.self.data = inherit(state.parent.data, state.data);
	      }
	      return state.data;
	    },
	
	    // Build a URLMatcher if necessary, either via a relative or absolute URL
	    url: function(state) {
	      var url = state.url, config = { params: state.params || {} };
	
	      if (isString(url)) {
	        if (url.charAt(0) == '^') return $urlMatcherFactory.compile(url.substring(1), config);
	        return (state.parent.navigable || root).url.concat(url, config);
	      }
	
	      if (!url || $urlMatcherFactory.isMatcher(url)) return url;
	      throw new Error("Invalid url '" + url + "' in state '" + state + "'");
	    },
	
	    // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
	    navigable: function(state) {
	      return state.url ? state : (state.parent ? state.parent.navigable : null);
	    },
	
	    // Own parameters for this state. state.url.params is already built at this point. Create and add non-url params
	    ownParams: function(state) {
	      var params = state.url && state.url.params || new $$UMFP.ParamSet();
	      forEach(state.params || {}, function(config, id) {
	        if (!params[id]) params[id] = new $$UMFP.Param(id, null, config, "config");
	      });
	      return params;
	    },
	
	    // Derive parameters for this state and ensure they're a super-set of parent's parameters
	    params: function(state) {
	      var ownParams = pick(state.ownParams, state.ownParams.$$keys());
	      return state.parent && state.parent.params ? extend(state.parent.params.$$new(), ownParams) : new $$UMFP.ParamSet();
	    },
	
	    // If there is no explicit multi-view configuration, make one up so we don't have
	    // to handle both cases in the view directive later. Note that having an explicit
	    // 'views' property will mean the default unnamed view properties are ignored. This
	    // is also a good time to resolve view names to absolute names, so everything is a
	    // straight lookup at link time.
	    views: function(state) {
	      var views = {};
	
	      forEach(isDefined(state.views) ? state.views : { '': state }, function (view, name) {
	        if (name.indexOf('@') < 0) name += '@' + state.parent.name;
	        view.resolveAs = view.resolveAs || state.resolveAs || '$resolve';
	        views[name] = view;
	      });
	      return views;
	    },
	
	    // Keep a full path from the root down to this state as this is needed for state activation.
	    path: function(state) {
	      return state.parent ? state.parent.path.concat(state) : []; // exclude root from path
	    },
	
	    // Speed up $state.contains() as it's used a lot
	    includes: function(state) {
	      var includes = state.parent ? extend({}, state.parent.includes) : {};
	      includes[state.name] = true;
	      return includes;
	    },
	
	    $delegates: {}
	  };
	
	  function isRelative(stateName) {
	    return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
	  }
	
	  function findState(stateOrName, base) {
	    if (!stateOrName) return undefined;
	
	    var isStr = isString(stateOrName),
	        name  = isStr ? stateOrName : stateOrName.name,
	        path  = isRelative(name);
	
	    if (path) {
	      if (!base) throw new Error("No reference point given for path '"  + name + "'");
	      base = findState(base);
	      
	      var rel = name.split("."), i = 0, pathLength = rel.length, current = base;
	
	      for (; i < pathLength; i++) {
	        if (rel[i] === "" && i === 0) {
	          current = base;
	          continue;
	        }
	        if (rel[i] === "^") {
	          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + base.name + "'");
	          current = current.parent;
	          continue;
	        }
	        break;
	      }
	      rel = rel.slice(i).join(".");
	      name = current.name + (current.name && rel ? "." : "") + rel;
	    }
	    var state = states[name];
	
	    if (state && (isStr || (!isStr && (state === stateOrName || state.self === stateOrName)))) {
	      return state;
	    }
	    return undefined;
	  }
	
	  function queueState(parentName, state) {
	    if (!queue[parentName]) {
	      queue[parentName] = [];
	    }
	    queue[parentName].push(state);
	  }
	
	  function flushQueuedChildren(parentName) {
	    var queued = queue[parentName] || [];
	    while(queued.length) {
	      registerState(queued.shift());
	    }
	  }
	
	  function registerState(state) {
	    // Wrap a new object around the state so we can store our private details easily.
	    state = inherit(state, {
	      self: state,
	      resolve: state.resolve || {},
	      toString: function() { return this.name; }
	    });
	
	    var name = state.name;
	    if (!isString(name) || name.indexOf('@') >= 0) throw new Error("State must have a valid name");
	    if (states.hasOwnProperty(name)) throw new Error("State '" + name + "' is already defined");
	
	    // Get parent name
	    var parentName = (name.indexOf('.') !== -1) ? name.substring(0, name.lastIndexOf('.'))
	        : (isString(state.parent)) ? state.parent
	        : (isObject(state.parent) && isString(state.parent.name)) ? state.parent.name
	        : '';
	
	    // If parent is not registered yet, add state to queue and register later
	    if (parentName && !states[parentName]) {
	      return queueState(parentName, state.self);
	    }
	
	    for (var key in stateBuilder) {
	      if (isFunction(stateBuilder[key])) state[key] = stateBuilder[key](state, stateBuilder.$delegates[key]);
	    }
	    states[name] = state;
	
	    // Register the state in the global state list and with $urlRouter if necessary.
	    if (!state[abstractKey] && state.url) {
	      $urlRouterProvider.when(state.url, ['$match', '$stateParams', function ($match, $stateParams) {
	        if ($state.$current.navigable != state || !equalForKeys($match, $stateParams)) {
	          $state.transitionTo(state, $match, { inherit: true, location: false });
	        }
	      }]);
	    }
	
	    // Register any queued children
	    flushQueuedChildren(name);
	
	    return state;
	  }
	
	  // Checks text to see if it looks like a glob.
	  function isGlob (text) {
	    return text.indexOf('*') > -1;
	  }
	
	  // Returns true if glob matches current $state name.
	  function doesStateMatchGlob (glob) {
	    var globSegments = glob.split('.'),
	        segments = $state.$current.name.split('.');
	
	    //match single stars
	    for (var i = 0, l = globSegments.length; i < l; i++) {
	      if (globSegments[i] === '*') {
	        segments[i] = '*';
	      }
	    }
	
	    //match greedy starts
	    if (globSegments[0] === '**') {
	       segments = segments.slice(indexOf(segments, globSegments[1]));
	       segments.unshift('**');
	    }
	    //match greedy ends
	    if (globSegments[globSegments.length - 1] === '**') {
	       segments.splice(indexOf(segments, globSegments[globSegments.length - 2]) + 1, Number.MAX_VALUE);
	       segments.push('**');
	    }
	
	    if (globSegments.length != segments.length) {
	      return false;
	    }
	
	    return segments.join('') === globSegments.join('');
	  }
	
	
	  // Implicit root state that is always active
	  root = registerState({
	    name: '',
	    url: '^',
	    views: null,
	    'abstract': true
	  });
	  root.navigable = null;
	
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#decorator
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Allows you to extend (carefully) or override (at your own peril) the 
	   * `stateBuilder` object used internally by `$stateProvider`. This can be used 
	   * to add custom functionality to ui-router, for example inferring templateUrl 
	   * based on the state name.
	   *
	   * When passing only a name, it returns the current (original or decorated) builder
	   * function that matches `name`.
	   *
	   * The builder functions that can be decorated are listed below. Though not all
	   * necessarily have a good use case for decoration, that is up to you to decide.
	   *
	   * In addition, users can attach custom decorators, which will generate new 
	   * properties within the state's internal definition. There is currently no clear 
	   * use-case for this beyond accessing internal states (i.e. $state.$current), 
	   * however, expect this to become increasingly relevant as we introduce additional 
	   * meta-programming features.
	   *
	   * **Warning**: Decorators should not be interdependent because the order of 
	   * execution of the builder functions in non-deterministic. Builder functions 
	   * should only be dependent on the state definition object and super function.
	   *
	   *
	   * Existing builder functions and current return values:
	   *
	   * - **parent** `{object}` - returns the parent state object.
	   * - **data** `{object}` - returns state data, including any inherited data that is not
	   *   overridden by own values (if any).
	   * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
	   *   or `null`.
	   * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is 
	   *   navigable).
	   * - **params** `{object}` - returns an array of state params that are ensured to 
	   *   be a super-set of parent's params.
	   * - **views** `{object}` - returns a views object where each key is an absolute view 
	   *   name (i.e. "viewName@stateName") and each value is the config object 
	   *   (template, controller) for the view. Even when you don't use the views object 
	   *   explicitly on a state config, one is still created for you internally.
	   *   So by decorating this builder function you have access to decorating template 
	   *   and controller properties.
	   * - **ownParams** `{object}` - returns an array of params that belong to the state, 
	   *   not including any params defined by ancestor states.
	   * - **path** `{string}` - returns the full path from the root down to this state. 
	   *   Needed for state activation.
	   * - **includes** `{object}` - returns an object that includes every state that 
	   *   would pass a `$state.includes()` test.
	   *
	   * @example
	   * <pre>
	   * // Override the internal 'views' builder with a function that takes the state
	   * // definition, and a reference to the internal function being overridden:
	   * $stateProvider.decorator('views', function (state, parent) {
	   *   var result = {},
	   *       views = parent(state);
	   *
	   *   angular.forEach(views, function (config, name) {
	   *     var autoName = (state.name + '.' + name).replace('.', '/');
	   *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
	   *     result[name] = config;
	   *   });
	   *   return result;
	   * });
	   *
	   * $stateProvider.state('home', {
	   *   views: {
	   *     'contact.list': { controller: 'ListController' },
	   *     'contact.item': { controller: 'ItemController' }
	   *   }
	   * });
	   *
	   * // ...
	   *
	   * $state.go('home');
	   * // Auto-populates list and item views with /partials/home/contact/list.html,
	   * // and /partials/home/contact/item.html, respectively.
	   * </pre>
	   *
	   * @param {string} name The name of the builder function to decorate. 
	   * @param {object} func A function that is responsible for decorating the original 
	   * builder function. The function receives two parameters:
	   *
	   *   - `{object}` - state - The state config object.
	   *   - `{object}` - super - The original builder function.
	   *
	   * @return {object} $stateProvider - $stateProvider instance
	   */
	  this.decorator = decorator;
	  function decorator(name, func) {
	    /*jshint validthis: true */
	    if (isString(name) && !isDefined(func)) {
	      return stateBuilder[name];
	    }
	    if (!isFunction(func) || !isString(name)) {
	      return this;
	    }
	    if (stateBuilder[name] && !stateBuilder.$delegates[name]) {
	      stateBuilder.$delegates[name] = stateBuilder[name];
	    }
	    stateBuilder[name] = func;
	    return this;
	  }
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$stateProvider#state
	   * @methodOf ui.router.state.$stateProvider
	   *
	   * @description
	   * Registers a state configuration under a given state name. The stateConfig object
	   * has the following acceptable properties.
	   *
	   * @param {string} name A unique state name, e.g. "home", "about", "contacts".
	   * To create a parent/child state use a dot, e.g. "about.sales", "home.newest".
	   * @param {object} stateConfig State configuration object.
	   * @param {string|function=} stateConfig.template
	   * <a id='template'></a>
	   *   html template as a string or a function that returns
	   *   an html template as a string which should be used by the uiView directives. This property 
	   *   takes precedence over templateUrl.
	   *   
	   *   If `template` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by
	   *     applying the current state
	   *
	   * <pre>template:
	   *   "<h1>inline template definition</h1>" +
	   *   "<div ui-view></div>"</pre>
	   * <pre>template: function(params) {
	   *       return "<h1>generated template</h1>"; }</pre>
	   * </div>
	   *
	   * @param {string|function=} stateConfig.templateUrl
	   * <a id='templateUrl'></a>
	   *
	   *   path or function that returns a path to an html
	   *   template that should be used by uiView.
	   *   
	   *   If `templateUrl` is a function, it will be called with the following parameters:
	   *
	   *   - {array.&lt;object&gt;} - state parameters extracted from the current $location.path() by 
	   *     applying the current state
	   *
	   * <pre>templateUrl: "home.html"</pre>
	   * <pre>templateUrl: function(params) {
	   *     return myTemplates[params.pageId]; }</pre>
	   *
	   * @param {function=} stateConfig.templateProvider
	   * <a id='templateProvider'></a>
	   *    Provider function that returns HTML content string.
	   * <pre> templateProvider:
	   *       function(MyTemplateService, params) {
	   *         return MyTemplateService.getTemplate(params.pageId);
	   *       }</pre>
	   *
	   * @param {string|function=} stateConfig.controller
	   * <a id='controller'></a>
	   *
	   *  Controller fn that should be associated with newly
	   *   related scope or the name of a registered controller if passed as a string.
	   *   Optionally, the ControllerAs may be declared here.
	   * <pre>controller: "MyRegisteredController"</pre>
	   * <pre>controller:
	   *     "MyRegisteredController as fooCtrl"}</pre>
	   * <pre>controller: function($scope, MyService) {
	   *     $scope.data = MyService.getData(); }</pre>
	   *
	   * @param {function=} stateConfig.controllerProvider
	   * <a id='controllerProvider'></a>
	   *
	   * Injectable provider function that returns the actual controller or string.
	   * <pre>controllerProvider:
	   *   function(MyResolveData) {
	   *     if (MyResolveData.foo)
	   *       return "FooCtrl"
	   *     else if (MyResolveData.bar)
	   *       return "BarCtrl";
	   *     else return function($scope) {
	   *       $scope.baz = "Qux";
	   *     }
	   *   }</pre>
	   *
	   * @param {string=} stateConfig.controllerAs
	   * <a id='controllerAs'></a>
	   * 
	   * A controller alias name. If present the controller will be
	   *   published to scope under the controllerAs name.
	   * <pre>controllerAs: "myCtrl"</pre>
	   *
	   * @param {string|object=} stateConfig.parent
	   * <a id='parent'></a>
	   * Optionally specifies the parent state of this state.
	   *
	   * <pre>parent: 'parentState'</pre>
	   * <pre>parent: parentState // JS variable</pre>
	   *
	   * @param {object=} stateConfig.resolve
	   * <a id='resolve'></a>
	   *
	   * An optional map&lt;string, function&gt; of dependencies which
	   *   should be injected into the controller. If any of these dependencies are promises, 
	   *   the router will wait for them all to be resolved before the controller is instantiated.
	   *   If all the promises are resolved successfully, the $stateChangeSuccess event is fired
	   *   and the values of the resolved promises are injected into any controllers that reference them.
	   *   If any  of the promises are rejected the $stateChangeError event is fired.
	   *
	   *   The map object is:
	   *   
	   *   - key - {string}: name of dependency to be injected into controller
	   *   - factory - {string|function}: If string then it is alias for service. Otherwise if function, 
	   *     it is injected and return value it treated as dependency. If result is a promise, it is 
	   *     resolved before its value is injected into controller.
	   *
	   * <pre>resolve: {
	   *     myResolve1:
	   *       function($http, $stateParams) {
	   *         return $http.get("/api/foos/"+stateParams.fooID);
	   *       }
	   *     }</pre>
	   *
	   * @param {string=} stateConfig.url
	   * <a id='url'></a>
	   *
	   *   A url fragment with optional parameters. When a state is navigated or
	   *   transitioned to, the `$stateParams` service will be populated with any 
	   *   parameters that were passed.
	   *
	   *   (See {@link ui.router.util.type:UrlMatcher UrlMatcher} `UrlMatcher`} for
	   *   more details on acceptable patterns )
	   *
	   * examples:
	   * <pre>url: "/home"
	   * url: "/users/:userid"
	   * url: "/books/{bookid:[a-zA-Z_-]}"
	   * url: "/books/{categoryid:int}"
	   * url: "/books/{publishername:string}/{categoryid:int}"
	   * url: "/messages?before&after"
	   * url: "/messages?{before:date}&{after:date}"
	   * url: "/messages/:mailboxid?{before:date}&{after:date}"
	   * </pre>
	   *
	   * @param {object=} stateConfig.views
	   * <a id='views'></a>
	   * an optional map&lt;string, object&gt; which defined multiple views, or targets views
	   * manually/explicitly.
	   *
	   * Examples:
	   *
	   * Targets three named `ui-view`s in the parent state's template
	   * <pre>views: {
	   *     header: {
	   *       controller: "headerCtrl",
	   *       templateUrl: "header.html"
	   *     }, body: {
	   *       controller: "bodyCtrl",
	   *       templateUrl: "body.html"
	   *     }, footer: {
	   *       controller: "footCtrl",
	   *       templateUrl: "footer.html"
	   *     }
	   *   }</pre>
	   *
	   * Targets named `ui-view="header"` from grandparent state 'top''s template, and named `ui-view="body" from parent state's template.
	   * <pre>views: {
	   *     'header@top': {
	   *       controller: "msgHeaderCtrl",
	   *       templateUrl: "msgHeader.html"
	   *     }, 'body': {
	   *       controller: "messagesCtrl",
	   *       templateUrl: "messages.html"
	   *     }
	   *   }</pre>
	   *
	   * @param {boolean=} [stateConfig.abstract=false]
	   * <a id='abstract'></a>
	   * An abstract state will never be directly activated,
	   *   but can provide inherited properties to its common children states.
	   * <pre>abstract: true</pre>
	   *
	   * @param {function=} stateConfig.onEnter
	   * <a id='onEnter'></a>
	   *
	   * Callback function for when a state is entered. Good way
	   *   to trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onEnter: function(MyService, $stateParams) {
	   *     MyService.foo($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {function=} stateConfig.onExit
	   * <a id='onExit'></a>
	   *
	   * Callback function for when a state is exited. Good way to
	   *   trigger an action or dispatch an event, such as opening a dialog.
	   * If minifying your scripts, make sure to explicitly annotate this function,
	   * because it won't be automatically annotated by your build tools.
	   *
	   * <pre>onExit: function(MyService, $stateParams) {
	   *     MyService.cleanup($stateParams.myParam);
	   * }</pre>
	   *
	   * @param {boolean=} [stateConfig.reloadOnSearch=true]
	   * <a id='reloadOnSearch'></a>
	   *
	   * If `false`, will not retrigger the same state
	   *   just because a search/query parameter has changed (via $location.search() or $location.hash()). 
	   *   Useful for when you'd like to modify $location.search() without triggering a reload.
	   * <pre>reloadOnSearch: false</pre>
	   *
	   * @param {object=} stateConfig.data
	   * <a id='data'></a>
	   *
	   * Arbitrary data object, useful for custom configuration.  The parent state's `data` is
	   *   prototypally inherited.  In other words, adding a data property to a state adds it to
	   *   the entire subtree via prototypal inheritance.
	   *
	   * <pre>data: {
	   *     requiredRole: 'foo'
	   * } </pre>
	   *
	   * @param {object=} stateConfig.params
	   * <a id='params'></a>
	   *
	   * A map which optionally configures parameters declared in the `url`, or
	   *   defines additional non-url parameters.  For each parameter being
	   *   configured, add a configuration object keyed to the name of the parameter.
	   *
	   *   Each parameter configuration object may contain the following properties:
	   *
	   *   - ** value ** - {object|function=}: specifies the default value for this
	   *     parameter.  This implicitly sets this parameter as optional.
	   *
	   *     When UI-Router routes to a state and no value is
	   *     specified for this parameter in the URL or transition, the
	   *     default value will be used instead.  If `value` is a function,
	   *     it will be injected and invoked, and the return value used.
	   *
	   *     *Note*: `undefined` is treated as "no default value" while `null`
	   *     is treated as "the default value is `null`".
	   *
	   *     *Shorthand*: If you only need to configure the default value of the
	   *     parameter, you may use a shorthand syntax.   In the **`params`**
	   *     map, instead mapping the param name to a full parameter configuration
	   *     object, simply set map it to the default parameter value, e.g.:
	   *
	   * <pre>// define a parameter's default value
	   * params: {
	   *     param1: { value: "defaultValue" }
	   * }
	   * // shorthand default values
	   * params: {
	   *     param1: "defaultValue",
	   *     param2: "param2Default"
	   * }</pre>
	   *
	   *   - ** array ** - {boolean=}: *(default: false)* If true, the param value will be
	   *     treated as an array of values.  If you specified a Type, the value will be
	   *     treated as an array of the specified Type.  Note: query parameter values
	   *     default to a special `"auto"` mode.
	   *
	   *     For query parameters in `"auto"` mode, if multiple  values for a single parameter
	   *     are present in the URL (e.g.: `/foo?bar=1&bar=2&bar=3`) then the values
	   *     are mapped to an array (e.g.: `{ foo: [ '1', '2', '3' ] }`).  However, if
	   *     only one value is present (e.g.: `/foo?bar=1`) then the value is treated as single
	   *     value (e.g.: `{ foo: '1' }`).
	   *
	   * <pre>params: {
	   *     param1: { array: true }
	   * }</pre>
	   *
	   *   - ** squash ** - {bool|string=}: `squash` configures how a default parameter value is represented in the URL when
	   *     the current parameter value is the same as the default value. If `squash` is not set, it uses the
	   *     configured default squash policy.
	   *     (See {@link ui.router.util.$urlMatcherFactory#methods_defaultSquashPolicy `defaultSquashPolicy()`})
	   *
	   *   There are three squash settings:
	   *
	   *     - false: The parameter's default value is not squashed.  It is encoded and included in the URL
	   *     - true: The parameter's default value is omitted from the URL.  If the parameter is preceeded and followed
	   *       by slashes in the state's `url` declaration, then one of those slashes are omitted.
	   *       This can allow for cleaner looking URLs.
	   *     - `"<arbitrary string>"`: The parameter's default value is replaced with an arbitrary placeholder of  your choice.
	   *
	   * <pre>params: {
	   *     param1: {
	   *       value: "defaultId",
	   *       squash: true
	   * } }
	   * // squash "defaultValue" to "~"
	   * params: {
	   *     param1: {
	   *       value: "defaultValue",
	   *       squash: "~"
	   * } }
	   * </pre>
	   *
	   *
	   * @example
	   * <pre>
	   * // Some state name examples
	   *
	   * // stateName can be a single top-level name (must be unique).
	   * $stateProvider.state("home", {});
	   *
	   * // Or it can be a nested state name. This state is a child of the
	   * // above "home" state.
	   * $stateProvider.state("home.newest", {});
	   *
	   * // Nest states as deeply as needed.
	   * $stateProvider.state("home.newest.abc.xyz.inception", {});
	   *
	   * // state() returns $stateProvider, so you can chain state declarations.
	   * $stateProvider
	   *   .state("home", {})
	   *   .state("about", {})
	   *   .state("contacts", {});
	   * </pre>
	   *
	   */
	  this.state = state;
	  function state(name, definition) {
	    /*jshint validthis: true */
	    if (isObject(name)) definition = name;
	    else definition.name = name;
	    registerState(definition);
	    return this;
	  }
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$state
	   *
	   * @requires $rootScope
	   * @requires $q
	   * @requires ui.router.state.$view
	   * @requires $injector
	   * @requires ui.router.util.$resolve
	   * @requires ui.router.state.$stateParams
	   * @requires ui.router.router.$urlRouter
	   *
	   * @property {object} params A param object, e.g. {sectionId: section.id)}, that 
	   * you'd like to test against the current active state.
	   * @property {object} current A reference to the state's config object. However 
	   * you passed it in. Useful for accessing custom data.
	   * @property {object} transition Currently pending transition. A promise that'll 
	   * resolve or reject.
	   *
	   * @description
	   * `$state` service is responsible for representing states as well as transitioning
	   * between them. It also provides interfaces to ask for current state or even states
	   * you're coming from.
	   */
	  this.$get = $get;
	  $get.$inject = ['$rootScope', '$q', '$view', '$injector', '$resolve', '$stateParams', '$urlRouter', '$location', '$urlMatcherFactory'];
	  function $get(   $rootScope,   $q,   $view,   $injector,   $resolve,   $stateParams,   $urlRouter,   $location,   $urlMatcherFactory) {
	
	    var TransitionSupersededError = new Error('transition superseded');
	
	    var TransitionSuperseded = silenceUncaughtInPromise($q.reject(TransitionSupersededError));
	    var TransitionPrevented = silenceUncaughtInPromise($q.reject(new Error('transition prevented')));
	    var TransitionAborted = silenceUncaughtInPromise($q.reject(new Error('transition aborted')));
	    var TransitionFailed = silenceUncaughtInPromise($q.reject(new Error('transition failed')));
	
	    // Handles the case where a state which is the target of a transition is not found, and the user
	    // can optionally retry or defer the transition
	    function handleRedirect(redirect, state, params, options) {
	      /**
	       * @ngdoc event
	       * @name ui.router.state.$state#$stateNotFound
	       * @eventOf ui.router.state.$state
	       * @eventType broadcast on root scope
	       * @description
	       * Fired when a requested state **cannot be found** using the provided state name during transition.
	       * The event is broadcast allowing any handlers a single chance to deal with the error (usually by
	       * lazy-loading the unfound state). A special `unfoundState` object is passed to the listener handler,
	       * you can see its three properties in the example. You can use `event.preventDefault()` to abort the
	       * transition and the promise returned from `go` will be rejected with a `'transition aborted'` value.
	       *
	       * @param {Object} event Event object.
	       * @param {Object} unfoundState Unfound State information. Contains: `to, toParams, options` properties.
	       * @param {State} fromState Current state object.
	       * @param {Object} fromParams Current state params.
	       *
	       * @example
	       *
	       * <pre>
	       * // somewhere, assume lazy.state has not been defined
	       * $state.go("lazy.state", {a:1, b:2}, {inherit:false});
	       *
	       * // somewhere else
	       * $scope.$on('$stateNotFound',
	       * function(event, unfoundState, fromState, fromParams){
	       *     console.log(unfoundState.to); // "lazy.state"
	       *     console.log(unfoundState.toParams); // {a:1, b:2}
	       *     console.log(unfoundState.options); // {inherit:false} + default options
	       * })
	       * </pre>
	       */
	      var evt = $rootScope.$broadcast('$stateNotFound', redirect, state, params);
	
	      if (evt.defaultPrevented) {
	        $urlRouter.update();
	        return TransitionAborted;
	      }
	
	      if (!evt.retry) {
	        return null;
	      }
	
	      // Allow the handler to return a promise to defer state lookup retry
	      if (options.$retry) {
	        $urlRouter.update();
	        return TransitionFailed;
	      }
	      var retryTransition = $state.transition = $q.when(evt.retry);
	
	      retryTransition.then(function() {
	        if (retryTransition !== $state.transition) {
	          $rootScope.$broadcast('$stateChangeCancel', redirect.to, redirect.toParams, state, params);
	          return TransitionSuperseded;
	        }
	        redirect.options.$retry = true;
	        return $state.transitionTo(redirect.to, redirect.toParams, redirect.options);
	      }, function() {
	        return TransitionAborted;
	      });
	      $urlRouter.update();
	
	      return retryTransition;
	    }
	
	    root.locals = { resolve: null, globals: { $stateParams: {} } };
	
	    $state = {
	      params: {},
	      current: root.self,
	      $current: root,
	      transition: null
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#reload
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method that force reloads the current state. All resolves are re-resolved,
	     * controllers reinstantiated, and events re-fired.
	     *
	     * @example
	     * <pre>
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     $state.reload();
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	     *
	     * @param {string=|object=} state - A state name or a state object, which is the root of the resolves to be re-resolved.
	     * @example
	     * <pre>
	     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item' 
	     * //and current state is 'contacts.detail.item'
	     * var app angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.reload = function(){
	     *     //will reload 'contact.detail' and 'contact.detail.item' states
	     *     $state.reload('contact.detail');
	     *   }
	     * });
	     * </pre>
	     *
	     * `reload()` is just an alias for:
	     * <pre>
	     * $state.transitionTo($state.current, $stateParams, { 
	     *   reload: true, inherit: false, notify: true
	     * });
	     * </pre>
	
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.reload = function reload(state) {
	      return $state.transitionTo($state.current, $stateParams, { reload: state || true, inherit: false, notify: true});
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#go
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Convenience method for transitioning to a new state. `$state.go` calls 
	     * `$state.transitionTo` internally but automatically sets options to 
	     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`. 
	     * This allows you to easily use an absolute or relative to path and specify 
	     * only the parameters you'd like to update (while letting unspecified parameters 
	     * inherit from the currently active ancestor states).
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.go('contact.detail');
	     *   };
	     * });
	     * </pre>
	     * <img src='../ngdoc_assets/StateGoExamples.png'/>
	     *
	     * @param {string} to Absolute state name or relative state path. Some examples:
	     *
	     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
	     * - `$state.go('^')` - will go to a parent state
	     * - `$state.go('^.sibling')` - will go to a sibling state
	     * - `$state.go('.child.grandchild')` - will go to grandchild state
	     *
	     * @param {object=} params A map of the parameters that will be sent to the state, 
	     * will populate $stateParams. Any parameters that are not specified will be inherited from currently 
	     * defined parameters. Only parameters specified in the state definition can be overridden, new 
	     * parameters will be ignored. This allows, for example, going to a sibling state that shares parameters
	     * specified in a parent state. Parameter inheritance only works between common ancestor states, I.e.
	     * transitioning to a sibling will get you the parameters for all parents, transitioning to a child
	     * will get you all current parameters, etc.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string|object}, If `true` will force transition even if no state or params
	     *    have changed.  It will reload the resolves and views of the current state and parent states.
	     *    If `reload` is a string (or state object), the state object is fetched (by name, or object reference); and \
	     *    the transition reloads the resolves and views for that matched state, and all its children states.
	     *
	     * @returns {promise} A promise representing the state of the new transition.
	     *
	     * Possible success values:
	     *
	     * - $state.current
	     *
	     * <br/>Possible rejection values:
	     *
	     * - 'transition superseded' - when a newer transition has been started after this one
	     * - 'transition prevented' - when `event.preventDefault()` has been called in a `$stateChangeStart` listener
	     * - 'transition aborted' - when `event.preventDefault()` has been called in a `$stateNotFound` listener or
	     *   when a `$stateNotFound` `event.retry` promise errors.
	     * - 'transition failed' - when a state has been unsuccessfully found after 2 tries.
	     * - *resolve error* - when an error has occurred with a `resolve`
	     *
	     */
	    $state.go = function go(to, params, options) {
	      return $state.transitionTo(to, params, extend({ inherit: true, relative: $state.$current }, options));
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#transitionTo
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Low-level method for transitioning to a new state. {@link ui.router.state.$state#methods_go $state.go}
	     * uses `transitionTo` internally. `$state.go` is recommended in most situations.
	     *
	     * @example
	     * <pre>
	     * var app = angular.module('app', ['ui.router']);
	     *
	     * app.controller('ctrl', function ($scope, $state) {
	     *   $scope.changeState = function () {
	     *     $state.transitionTo('contact.detail');
	     *   };
	     * });
	     * </pre>
	     *
	     * @param {string} to State name.
	     * @param {object=} toParams A map of the parameters that will be sent to the state,
	     * will populate $stateParams.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`location`** - {boolean=true|string=} - If `true` will update the url in the location bar, if `false`
	     *    will not. If string, must be `"replace"`, which will update url and also replace last history record.
	     * - **`inherit`** - {boolean=false}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`notify`** - {boolean=true}, If `true` will broadcast $stateChangeStart and $stateChangeSuccess events.
	     * - **`reload`** (v0.2.5) - {boolean=false|string=|object=}, If `true` will force transition even if the state or params 
	     *    have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd
	     *    use this when you want to force a reload when *everything* is the same, including search params.
	     *    if String, then will reload the state with the name given in reload, and any children.
	     *    if Object, then a stateObj is expected, will reload the state found in stateObj, and any children.
	     *
	     * @returns {promise} A promise representing the state of the new transition. See
	     * {@link ui.router.state.$state#methods_go $state.go}.
	     */
	    $state.transitionTo = function transitionTo(to, toParams, options) {
	      toParams = toParams || {};
	      options = extend({
	        location: true, inherit: false, relative: null, notify: true, reload: false, $retry: false
	      }, options || {});
	
	      var from = $state.$current, fromParams = $state.params, fromPath = from.path;
	      var evt, toState = findState(to, options.relative);
	
	      // Store the hash param for later (since it will be stripped out by various methods)
	      var hash = toParams['#'];
	
	      if (!isDefined(toState)) {
	        var redirect = { to: to, toParams: toParams, options: options };
	        var redirectResult = handleRedirect(redirect, from.self, fromParams, options);
	
	        if (redirectResult) {
	          return redirectResult;
	        }
	
	        // Always retry once if the $stateNotFound was not prevented
	        // (handles either redirect changed or state lazy-definition)
	        to = redirect.to;
	        toParams = redirect.toParams;
	        options = redirect.options;
	        toState = findState(to, options.relative);
	
	        if (!isDefined(toState)) {
	          if (!options.relative) throw new Error("No such state '" + to + "'");
	          throw new Error("Could not resolve '" + to + "' from state '" + options.relative + "'");
	        }
	      }
	      if (toState[abstractKey]) throw new Error("Cannot transition to abstract state '" + to + "'");
	      if (options.inherit) toParams = inheritParams($stateParams, toParams || {}, $state.$current, toState);
	      if (!toState.params.$$validates(toParams)) return TransitionFailed;
	
	      toParams = toState.params.$$values(toParams);
	      to = toState;
	
	      var toPath = to.path;
	
	      // Starting from the root of the path, keep all levels that haven't changed
	      var keep = 0, state = toPath[keep], locals = root.locals, toLocals = [];
	
	      if (!options.reload) {
	        while (state && state === fromPath[keep] && state.ownParams.$$equals(toParams, fromParams)) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      } else if (isString(options.reload) || isObject(options.reload)) {
	        if (isObject(options.reload) && !options.reload.name) {
	          throw new Error('Invalid reload state object');
	        }
	        
	        var reloadState = options.reload === true ? fromPath[0] : findState(options.reload);
	        if (options.reload && !reloadState) {
	          throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
	        }
	
	        while (state && state === fromPath[keep] && state !== reloadState) {
	          locals = toLocals[keep] = state.locals;
	          keep++;
	          state = toPath[keep];
	        }
	      }
	
	      // If we're going to the same state and all locals are kept, we've got nothing to do.
	      // But clear 'transition', as we still want to cancel any other pending transitions.
	      // TODO: We may not want to bump 'transition' if we're called from a location change
	      // that we've initiated ourselves, because we might accidentally abort a legitimate
	      // transition initiated from code?
	      if (shouldSkipReload(to, toParams, from, fromParams, locals, options)) {
	        if (hash) toParams['#'] = hash;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        copy(filterByKeys(to.params.$$keys(), $stateParams), to.locals.globals.$stateParams);
	        if (options.location && to.navigable && to.navigable.url) {
	          $urlRouter.push(to.navigable.url, toParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	          $urlRouter.update(true);
	        }
	        $state.transition = null;
	        return $q.when($state.current);
	      }
	
	      // Filter parameters before we pass them to event handlers etc.
	      toParams = filterByKeys(to.params.$$keys(), toParams || {});
	      
	      // Re-add the saved hash before we start returning things or broadcasting $stateChangeStart
	      if (hash) toParams['#'] = hash;
	      
	      // Broadcast start event and cancel the transition if requested
	      if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeStart
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when the state transition **begins**. You can use `event.preventDefault()`
	         * to prevent the transition from happening and then the transition promise will be
	         * rejected with a `'transition prevented'` value.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         *
	         * @example
	         *
	         * <pre>
	         * $rootScope.$on('$stateChangeStart',
	         * function(event, toState, toParams, fromState, fromParams){
	         *     event.preventDefault();
	         *     // transitionTo() promise will be rejected with
	         *     // a 'transition prevented' error
	         * })
	         * </pre>
	         */
	        if ($rootScope.$broadcast('$stateChangeStart', to.self, toParams, from.self, fromParams, options).defaultPrevented) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          //Don't update and resync url if there's been a new transition started. see issue #2238, #600
	          if ($state.transition == null) $urlRouter.update();
	          return TransitionPrevented;
	        }
	      }
	
	      // Resolve locals for the remaining states, but don't update any global state just
	      // yet -- if anything fails to resolve the current state needs to remain untouched.
	      // We also set up an inheritance chain for the locals here. This allows the view directive
	      // to quickly look up the correct definition for each view in the current state. Even
	      // though we create the locals object itself outside resolveState(), it is initially
	      // empty and gets filled asynchronously. We need to keep track of the promise for the
	      // (fully resolved) current locals, and pass this down the chain.
	      var resolved = $q.when(locals);
	
	      for (var l = keep; l < toPath.length; l++, state = toPath[l]) {
	        locals = toLocals[l] = inherit(locals);
	        resolved = resolveState(state, toParams, state === to, resolved, locals, options);
	      }
	
	      // Once everything is resolved, we are ready to perform the actual transition
	      // and return a promise for the new state. We also keep track of what the
	      // current promise is, so that we can detect overlapping transitions and
	      // keep only the outcome of the last transition.
	      var transition = $state.transition = resolved.then(function () {
	        var l, entering, exiting;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Exit 'from' states not kept
	        for (l = fromPath.length - 1; l >= keep; l--) {
	          exiting = fromPath[l];
	          if (exiting.self.onExit) {
	            $injector.invoke(exiting.self.onExit, exiting.self, exiting.locals.globals);
	          }
	          exiting.locals = null;
	        }
	
	        // Enter 'to' states not kept
	        for (l = keep; l < toPath.length; l++) {
	          entering = toPath[l];
	          entering.locals = toLocals[l];
	          if (entering.self.onEnter) {
	            $injector.invoke(entering.self.onEnter, entering.self, entering.locals.globals);
	          }
	        }
	
	        // Run it again, to catch any transitions in callbacks
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        // Update globals in $state
	        $state.$current = to;
	        $state.current = to.self;
	        $state.params = toParams;
	        copy($state.params, $stateParams);
	        $state.transition = null;
	
	        if (options.location && to.navigable) {
	          $urlRouter.push(to.navigable.url, to.navigable.locals.globals.$stateParams, {
	            $$avoidResync: true, replace: options.location === 'replace'
	          });
	        }
	
	        if (options.notify) {
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeSuccess
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired once the state transition is **complete**.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         */
	          $rootScope.$broadcast('$stateChangeSuccess', to.self, toParams, from.self, fromParams);
	        }
	        $urlRouter.update(true);
	
	        return $state.current;
	      }).then(null, function (error) {
	        // propagate TransitionSuperseded error without emitting $stateChangeCancel
	        // as it was already emitted in the success handler above
	        if (error === TransitionSupersededError) return TransitionSuperseded;
	
	        if ($state.transition !== transition) {
	          $rootScope.$broadcast('$stateChangeCancel', to.self, toParams, from.self, fromParams);
	          return TransitionSuperseded;
	        }
	
	        $state.transition = null;
	        /**
	         * @ngdoc event
	         * @name ui.router.state.$state#$stateChangeError
	         * @eventOf ui.router.state.$state
	         * @eventType broadcast on root scope
	         * @description
	         * Fired when an **error occurs** during transition. It's important to note that if you
	         * have any errors in your resolve functions (javascript errors, non-existent services, etc)
	         * they will not throw traditionally. You must listen for this $stateChangeError event to
	         * catch **ALL** errors.
	         *
	         * @param {Object} event Event object.
	         * @param {State} toState The state being transitioned to.
	         * @param {Object} toParams The params supplied to the `toState`.
	         * @param {State} fromState The current state, pre-transition.
	         * @param {Object} fromParams The params supplied to the `fromState`.
	         * @param {Error} error The resolve error object.
	         */
	        evt = $rootScope.$broadcast('$stateChangeError', to.self, toParams, from.self, fromParams, error);
	
	        if (!evt.defaultPrevented) {
	          $urlRouter.update();
	        }
	
	        return $q.reject(error);
	      });
	
	      return transition;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#is
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Similar to {@link ui.router.state.$state#methods_includes $state.includes},
	     * but only checks for the full state name. If params is supplied then it will be
	     * tested for strict equality against the current active params object, so all params
	     * must match with none missing and no extras.
	     *
	     * @example
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // absolute name
	     * $state.is('contact.details.item'); // returns true
	     * $state.is(contactDetailItemStateObject); // returns true
	     *
	     * // relative name (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name (absolute or relative) or state object you'd like to check.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`, that you'd like
	     * to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object} -  If `stateOrName` is a relative state name and `options.relative` is set, .is will
	     * test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it is the state.
	     */
	    $state.is = function is(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) { return undefined; }
	      if ($state.$current !== state) { return false; }
	      return params ? equalForKeys(state.params.$$values(params), $stateParams) : true;
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#includes
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A method to determine if the current active state is equal to or is the child of the
	     * state stateName. If any params are passed then they will be tested for a match as well.
	     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
	     *
	     * @example
	     * Partial and relative names
	     * <pre>
	     * $state.$current.name = 'contacts.details.item';
	     *
	     * // Using partial names
	     * $state.includes("contacts"); // returns true
	     * $state.includes("contacts.details"); // returns true
	     * $state.includes("contacts.details.item"); // returns true
	     * $state.includes("contacts.list"); // returns false
	     * $state.includes("about"); // returns false
	     *
	     * // Using relative names (. and ^), typically from a template
	     * // E.g. from the 'contacts.details' template
	     * <div ng-class="{highlighted: $state.includes('.item')}">Item</div>
	     * </pre>
	     *
	     * Basic globbing patterns
	     * <pre>
	     * $state.$current.name = 'contacts.details.item.url';
	     *
	     * $state.includes("*.details.*.*"); // returns true
	     * $state.includes("*.details.**"); // returns true
	     * $state.includes("**.item.**"); // returns true
	     * $state.includes("*.details.item.url"); // returns true
	     * $state.includes("*.details.*.url"); // returns true
	     * $state.includes("*.details.*"); // returns false
	     * $state.includes("item.**"); // returns false
	     * </pre>
	     *
	     * @param {string} stateOrName A partial name, relative name, or glob pattern
	     * to be searched for within the current state name.
	     * @param {object=} params A param object, e.g. `{sectionId: section.id}`,
	     * that you'd like to test against the current active state.
	     * @param {object=} options An options object.  The options are:
	     *
	     * - **`relative`** - {string|object=} -  If `stateOrName` is a relative state reference and `options.relative` is set,
	     * .includes will test relative to `options.relative` state (or name).
	     *
	     * @returns {boolean} Returns true if it does include the state
	     */
	    $state.includes = function includes(stateOrName, params, options) {
	      options = extend({ relative: $state.$current }, options || {});
	      if (isString(stateOrName) && isGlob(stateOrName)) {
	        if (!doesStateMatchGlob(stateOrName)) {
	          return false;
	        }
	        stateOrName = $state.$current.name;
	      }
	
	      var state = findState(stateOrName, options.relative);
	      if (!isDefined(state)) { return undefined; }
	      if (!isDefined($state.$current.includes[state.name])) { return false; }
	      if (!params) { return true; }
	
	      var keys = objectKeys(params);
	      for (var i = 0; i < keys.length; i++) {
	        var key = keys[i], paramDef = state.params[key];
	        if (paramDef && !paramDef.type.equals($stateParams[key], params[key])) {
	          return false;
	        }
	      }
	
	      return true;
	    };
	
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#href
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * A url generation method that returns the compiled url for the given state populated with the given params.
	     *
	     * @example
	     * <pre>
	     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
	     * </pre>
	     *
	     * @param {string|object} stateOrName The state name or state object you'd like to generate a url from.
	     * @param {object=} params An object of parameter values to fill the state's required parameters.
	     * @param {object=} options Options object. The options are:
	     *
	     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
	     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
	     *    ancestor with a valid url).
	     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
	     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'), 
	     *    defines which state to be relative from.
	     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
	     * 
	     * @returns {string} compiled state url
	     */
	    $state.href = function href(stateOrName, params, options) {
	      options = extend({
	        lossy:    true,
	        inherit:  true,
	        absolute: false,
	        relative: $state.$current
	      }, options || {});
	
	      var state = findState(stateOrName, options.relative);
	
	      if (!isDefined(state)) return null;
	      if (options.inherit) params = inheritParams($stateParams, params || {}, $state.$current, state);
	      
	      var nav = (state && options.lossy) ? state.navigable : state;
	
	      if (!nav || nav.url === undefined || nav.url === null) {
	        return null;
	      }
	      return $urlRouter.href(nav.url, filterByKeys(state.params.$$keys().concat('#'), params || {}), {
	        absolute: options.absolute
	      });
	    };
	
	    /**
	     * @ngdoc function
	     * @name ui.router.state.$state#get
	     * @methodOf ui.router.state.$state
	     *
	     * @description
	     * Returns the state configuration object for any specific state or all states.
	     *
	     * @param {string|object=} stateOrName (absolute or relative) If provided, will only get the config for
	     * the requested state. If not provided, returns an array of ALL state configs.
	     * @param {string|object=} context When stateOrName is a relative state reference, the state will be retrieved relative to context.
	     * @returns {Object|Array} State configuration object or array of all objects.
	     */
	    $state.get = function (stateOrName, context) {
	      if (arguments.length === 0) return map(objectKeys(states), function(name) { return states[name].self; });
	      var state = findState(stateOrName, context || $state.$current);
	      return (state && state.self) ? state.self : null;
	    };
	
	    function resolveState(state, params, paramsAreFiltered, inherited, dst, options) {
	      // Make a restricted $stateParams with only the parameters that apply to this state if
	      // necessary. In addition to being available to the controller and onEnter/onExit callbacks,
	      // we also need $stateParams to be available for any $injector calls we make during the
	      // dependency resolution process.
	      var $stateParams = (paramsAreFiltered) ? params : filterByKeys(state.params.$$keys(), params);
	      var locals = { $stateParams: $stateParams };
	
	      // Resolve 'global' dependencies for the state, i.e. those not specific to a view.
	      // We're also including $stateParams in this; that way the parameters are restricted
	      // to the set that should be visible to the state, and are independent of when we update
	      // the global $state and $stateParams values.
	      dst.resolve = $resolve.resolve(state.resolve, locals, dst.resolve, state);
	      var promises = [dst.resolve.then(function (globals) {
	        dst.globals = globals;
	      })];
	      if (inherited) promises.push(inherited);
	
	      function resolveViews() {
	        var viewsPromises = [];
	
	        // Resolve template and dependencies for all views.
	        forEach(state.views, function (view, name) {
	          var injectables = (view.resolve && view.resolve !== state.resolve ? view.resolve : {});
	          injectables.$template = [ function () {
	            return $view.load(name, { view: view, locals: dst.globals, params: $stateParams, notify: options.notify }) || '';
	          }];
	
	          viewsPromises.push($resolve.resolve(injectables, dst.globals, dst.resolve, state).then(function (result) {
	            // References to the controller (only instantiated at link time)
	            if (isFunction(view.controllerProvider) || isArray(view.controllerProvider)) {
	              var injectLocals = angular.extend({}, injectables, dst.globals);
	              result.$$controller = $injector.invoke(view.controllerProvider, null, injectLocals);
	            } else {
	              result.$$controller = view.controller;
	            }
	            // Provide access to the state itself for internal use
	            result.$$state = state;
	            result.$$controllerAs = view.controllerAs;
	            result.$$resolveAs = view.resolveAs;
	            dst[name] = result;
	          }));
	        });
	
	        return $q.all(viewsPromises).then(function(){
	          return dst.globals;
	        });
	      }
	
	      // Wait for all the promises and then return the activation object
	      return $q.all(promises).then(resolveViews).then(function (values) {
	        return dst;
	      });
	    }
	
	    return $state;
	  }
	
	  function shouldSkipReload(to, toParams, from, fromParams, locals, options) {
	    // Return true if there are no differences in non-search (path/object) params, false if there are differences
	    function nonSearchParamsEqual(fromAndToState, fromParams, toParams) {
	      // Identify whether all the parameters that differ between `fromParams` and `toParams` were search params.
	      function notSearchParam(key) {
	        return fromAndToState.params[key].location != "search";
	      }
	      var nonQueryParamKeys = fromAndToState.params.$$keys().filter(notSearchParam);
	      var nonQueryParams = pick.apply({}, [fromAndToState.params].concat(nonQueryParamKeys));
	      var nonQueryParamSet = new $$UMFP.ParamSet(nonQueryParams);
	      return nonQueryParamSet.$$equals(fromParams, toParams);
	    }
	
	    // If reload was not explicitly requested
	    // and we're transitioning to the same state we're already in
	    // and    the locals didn't change
	    //     or they changed in a way that doesn't merit reloading
	    //        (reloadOnParams:false, or reloadOnSearch.false and only search params changed)
	    // Then return true.
	    if (!options.reload && to === from &&
	      (locals === from.locals || (to.self.reloadOnSearch === false && nonSearchParamsEqual(from, fromParams, toParams)))) {
	      return true;
	    }
	  }
	}
	
	angular.module('ui.router.state')
	  .factory('$stateParams', function () { return {}; })
	  .constant("$state.runtime", { autoinject: true })
	  .provider('$state', $StateProvider)
	  // Inject $state to initialize when entering runtime. #2574
	  .run(['$injector', function ($injector) {
	    // Allow tests (stateSpec.js) to turn this off by defining this constant
	    if ($injector.get("$state.runtime").autoinject) {
	      $injector.get('$state');
	    }
	  }]);
	
	
	$ViewProvider.$inject = [];
	function $ViewProvider() {
	
	  this.$get = $get;
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$view
	   *
	   * @requires ui.router.util.$templateFactory
	   * @requires $rootScope
	   *
	   * @description
	   *
	   */
	  $get.$inject = ['$rootScope', '$templateFactory'];
	  function $get(   $rootScope,   $templateFactory) {
	    return {
	      // $view.load('full.viewName', { template: ..., controller: ..., resolve: ..., async: false, params: ... })
	      /**
	       * @ngdoc function
	       * @name ui.router.state.$view#load
	       * @methodOf ui.router.state.$view
	       *
	       * @description
	       *
	       * @param {string} name name
	       * @param {object} options option object.
	       */
	      load: function load(name, options) {
	        var result, defaults = {
	          template: null, controller: null, view: null, locals: null, notify: true, async: true, params: {}
	        };
	        options = extend(defaults, options);
	
	        if (options.view) {
	          result = $templateFactory.fromConfig(options.view, options.params, options.locals);
	        }
	        return result;
	      }
	    };
	  }
	}
	
	angular.module('ui.router.state').provider('$view', $ViewProvider);
	
	/**
	 * @ngdoc object
	 * @name ui.router.state.$uiViewScrollProvider
	 *
	 * @description
	 * Provider that returns the {@link ui.router.state.$uiViewScroll} service function.
	 */
	function $ViewScrollProvider() {
	
	  var useAnchorScroll = false;
	
	  /**
	   * @ngdoc function
	   * @name ui.router.state.$uiViewScrollProvider#useAnchorScroll
	   * @methodOf ui.router.state.$uiViewScrollProvider
	   *
	   * @description
	   * Reverts back to using the core [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll) service for
	   * scrolling based on the url anchor.
	   */
	  this.useAnchorScroll = function () {
	    useAnchorScroll = true;
	  };
	
	  /**
	   * @ngdoc object
	   * @name ui.router.state.$uiViewScroll
	   *
	   * @requires $anchorScroll
	   * @requires $timeout
	   *
	   * @description
	   * When called with a jqLite element, it scrolls the element into view (after a
	   * `$timeout` so the DOM has time to refresh).
	   *
	   * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
	   * this can be enabled by calling {@link ui.router.state.$uiViewScrollProvider#methods_useAnchorScroll `$uiViewScrollProvider.useAnchorScroll()`}.
	   */
	  this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
	    if (useAnchorScroll) {
	      return $anchorScroll;
	    }
	
	    return function ($element) {
	      return $timeout(function () {
	        $element[0].scrollIntoView();
	      }, 0, false);
	    };
	  }];
	}
	
	angular.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-view
	 *
	 * @requires ui.router.state.$state
	 * @requires $compile
	 * @requires $controller
	 * @requires $injector
	 * @requires ui.router.state.$uiViewScroll
	 * @requires $document
	 *
	 * @restrict ECA
	 *
	 * @description
	 * The ui-view directive tells $state where to place your templates.
	 *
	 * @param {string=} name A view name. The name should be unique amongst the other views in the
	 * same state. You can have views of the same name that live in different states.
	 *
	 * @param {string=} autoscroll It allows you to set the scroll behavior of the browser window
	 * when a view is populated. By default, $anchorScroll is overridden by ui-router's custom scroll
	 * service, {@link ui.router.state.$uiViewScroll}. This custom service let's you
	 * scroll ui-view elements into view when they are populated during a state activation.
	 *
	 * *Note: To revert back to old [`$anchorScroll`](http://docs.angularjs.org/api/ng.$anchorScroll)
	 * functionality, call `$uiViewScrollProvider.useAnchorScroll()`.*
	 *
	 * @param {string=} onload Expression to evaluate whenever the view updates.
	 *
	 * @example
	 * A view can be unnamed or named.
	 * <pre>
	 * <!-- Unnamed -->
	 * <div ui-view></div>
	 *
	 * <!-- Named -->
	 * <div ui-view="viewName"></div>
	 * </pre>
	 *
	 * You can only have one unnamed view within any template (or root html). If you are only using a
	 * single view and it is unnamed then you can populate it like so:
	 * <pre>
	 * <div ui-view></div>
	 * $stateProvider.state("home", {
	 *   template: "<h1>HELLO!</h1>"
	 * })
	 * </pre>
	 *
	 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#methods_state `views`}
	 * config property, by name, in this case an empty name:
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * But typically you'll only use the views property if you name your view or have more than one view
	 * in the same template. There's not really a compelling reason to name a view if its the only one,
	 * but you could if you wanted, like so:
	 * <pre>
	 * <div ui-view="main"></div>
	 * </pre>
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "main": {
	 *       template: "<h1>HELLO!</h1>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Really though, you'll use views to set up multiple views:
	 * <pre>
	 * <div ui-view></div>
	 * <div ui-view="chart"></div>
	 * <div ui-view="data"></div>
	 * </pre>
	 *
	 * <pre>
	 * $stateProvider.state("home", {
	 *   views: {
	 *     "": {
	 *       template: "<h1>HELLO!</h1>"
	 *     },
	 *     "chart": {
	 *       template: "<chart_thing/>"
	 *     },
	 *     "data": {
	 *       template: "<data_thing/>"
	 *     }
	 *   }    
	 * })
	 * </pre>
	 *
	 * Examples for `autoscroll`:
	 *
	 * <pre>
	 * <!-- If autoscroll present with no expression,
	 *      then scroll ui-view into view -->
	 * <ui-view autoscroll/>
	 *
	 * <!-- If autoscroll present with valid expression,
	 *      then scroll ui-view into view if expression evaluates to true -->
	 * <ui-view autoscroll='true'/>
	 * <ui-view autoscroll='false'/>
	 * <ui-view autoscroll='scopeVariable'/>
	 * </pre>
	 *
	 * Resolve data:
	 *
	 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
	 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
	 *
	 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
	 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
	 * depends on `$resolve` data.
	 *
	 * Example usage of $resolve in a view template
	 * <pre>
	 * $stateProvider.state('home', {
	 *   template: '<my-component user="$resolve.user"></my-component>',
	 *   resolve: {
	 *     user: function(UserService) { return UserService.fetchUser(); }
	 *   }
	 * });
	 * </pre>
	 */
	$ViewDirective.$inject = ['$state', '$injector', '$uiViewScroll', '$interpolate', '$q'];
	function $ViewDirective(   $state,   $injector,   $uiViewScroll,   $interpolate,   $q) {
	
	  function getService() {
	    return ($injector.has) ? function(service) {
	      return $injector.has(service) ? $injector.get(service) : null;
	    } : function(service) {
	      try {
	        return $injector.get(service);
	      } catch (e) {
	        return null;
	      }
	    };
	  }
	
	  var service = getService(),
	      $animator = service('$animator'),
	      $animate = service('$animate');
	
	  // Returns a set of DOM manipulation functions based on which Angular version
	  // it should use
	  function getRenderer(attrs, scope) {
	    var statics = function() {
	      return {
	        enter: function (element, target, cb) { target.after(element); cb(); },
	        leave: function (element, cb) { element.remove(); cb(); }
	      };
	    };
	
	    if ($animate) {
	      return {
	        enter: function(element, target, cb) {
	          if (angular.version.minor > 2) {
	            $animate.enter(element, null, target).then(cb);
	          } else {
	            $animate.enter(element, null, target, cb);
	          }
	        },
	        leave: function(element, cb) {
	          if (angular.version.minor > 2) {
	            $animate.leave(element).then(cb);
	          } else {
	            $animate.leave(element, cb);
	          }
	        }
	      };
	    }
	
	    if ($animator) {
	      var animate = $animator && $animator(scope, attrs);
	
	      return {
	        enter: function(element, target, cb) {animate.enter(element, null, target); cb(); },
	        leave: function(element, cb) { animate.leave(element); cb(); }
	      };
	    }
	
	    return statics();
	  }
	
	  var directive = {
	    restrict: 'ECA',
	    terminal: true,
	    priority: 400,
	    transclude: 'element',
	    compile: function (tElement, tAttrs, $transclude) {
	      return function (scope, $element, attrs) {
	        var previousEl, currentEl, currentScope, latestLocals,
	            onloadExp     = attrs.onload || '',
	            autoScrollExp = attrs.autoscroll,
	            renderer      = getRenderer(attrs, scope),
	            inherited     = $element.inheritedData('$uiView');
	
	        scope.$on('$stateChangeSuccess', function() {
	          updateView(false);
	        });
	
	        updateView(true);
	
	        function cleanupLastView() {
	          if (previousEl) {
	            previousEl.remove();
	            previousEl = null;
	          }
	
	          if (currentScope) {
	            currentScope.$destroy();
	            currentScope = null;
	          }
	
	          if (currentEl) {
	            var $uiViewData = currentEl.data('$uiViewAnim');
	            renderer.leave(currentEl, function() {
	              $uiViewData.$$animLeave.resolve();
	              previousEl = null;
	            });
	
	            previousEl = currentEl;
	            currentEl = null;
	          }
	        }
	
	        function updateView(firstTime) {
	          var newScope,
	              name            = getUiViewName(scope, attrs, $element, $interpolate),
	              previousLocals  = name && $state.$current && $state.$current.locals[name];
	
	          if (!firstTime && previousLocals === latestLocals) return; // nothing to do
	          newScope = scope.$new();
	          latestLocals = $state.$current.locals[name];
	
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoading
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           *
	           * Fired once the view **begins loading**, *before* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          newScope.$emit('$viewContentLoading', name);
	
	          var clone = $transclude(newScope, function(clone) {
	            var animEnter = $q.defer(), animLeave = $q.defer();
	            var viewAnimData = {
	              $animEnter: animEnter.promise,
	              $animLeave: animLeave.promise,
	              $$animLeave: animLeave
	            };
	
	            clone.data('$uiViewAnim', viewAnimData);
	            renderer.enter(clone, $element, function onUiViewEnter() {
	              animEnter.resolve();
	              if(currentScope) {
	                currentScope.$emit('$viewContentAnimationEnded');
	              }
	
	              if (angular.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
	                $uiViewScroll(clone);
	              }
	            });
	            cleanupLastView();
	          });
	
	          currentEl = clone;
	          currentScope = newScope;
	          /**
	           * @ngdoc event
	           * @name ui.router.state.directive:ui-view#$viewContentLoaded
	           * @eventOf ui.router.state.directive:ui-view
	           * @eventType emits on ui-view directive scope
	           * @description
	           * Fired once the view is **loaded**, *after* the DOM is rendered.
	           *
	           * @param {Object} event Event object.
	           * @param {string} viewName Name of the view.
	           */
	          currentScope.$emit('$viewContentLoaded', name);
	          currentScope.$eval(onloadExp);
	        }
	      };
	    }
	  };
	
	  return directive;
	}
	
	$ViewDirectiveFill.$inject = ['$compile', '$controller', '$state', '$interpolate'];
	function $ViewDirectiveFill (  $compile,   $controller,   $state,   $interpolate) {
	  return {
	    restrict: 'ECA',
	    priority: -400,
	    compile: function (tElement) {
	      var initial = tElement.html();
	      return function (scope, $element, attrs) {
	        var current = $state.$current,
	            name = getUiViewName(scope, attrs, $element, $interpolate),
	            locals  = current && current.locals[name];
	
	        if (! locals) {
	          return;
	        }
	
	        $element.data('$uiView', { name: name, state: locals.$$state });
	        $element.html(locals.$template ? locals.$template : initial);
	
	        var resolveData = angular.extend({}, locals);
	        scope[locals.$$resolveAs] = resolveData;
	
	        var link = $compile($element.contents());
	
	        if (locals.$$controller) {
	          locals.$scope = scope;
	          locals.$element = $element;
	          var controller = $controller(locals.$$controller, locals);
	          if (locals.$$controllerAs) {
	            scope[locals.$$controllerAs] = controller;
	            scope[locals.$$controllerAs][locals.$$resolveAs] = resolveData;
	          }
	          if (isFunction(controller.$onInit)) controller.$onInit();
	          $element.data('$ngControllerController', controller);
	          $element.children().data('$ngControllerController', controller);
	        }
	
	        link(scope);
	      };
	    }
	  };
	}
	
	/**
	 * Shared ui-view code for both directives:
	 * Given scope, element, and its attributes, return the view's name
	 */
	function getUiViewName(scope, attrs, element, $interpolate) {
	  var name = $interpolate(attrs.uiView || attrs.name || '')(scope);
	  var uiViewCreatedBy = element.inheritedData('$uiView');
	  return name.indexOf('@') >= 0 ?  name :  (name + '@' + (uiViewCreatedBy ? uiViewCreatedBy.state.name : ''));
	}
	
	angular.module('ui.router.state').directive('uiView', $ViewDirective);
	angular.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
	
	function parseStateRef(ref, current) {
	  var preparsed = ref.match(/^\s*({[^}]*})\s*$/), parsed;
	  if (preparsed) ref = current + '(' + preparsed[1] + ')';
	  parsed = ref.replace(/\n/g, " ").match(/^([^(]+?)\s*(\((.*)\))?$/);
	  if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
	  return { state: parsed[1], paramExpr: parsed[3] || null };
	}
	
	function stateContext(el) {
	  var stateData = el.parent().inheritedData('$uiView');
	
	  if (stateData && stateData.state && stateData.state.name) {
	    return stateData.state;
	  }
	}
	
	function getTypeInfo(el) {
	  // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
	  var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
	  var isForm = el[0].nodeName === "FORM";
	
	  return {
	    attr: isForm ? "action" : (isSvg ? 'xlink:href' : 'href'),
	    isAnchor: el.prop("tagName").toUpperCase() === "A",
	    clickable: !isForm
	  };
	}
	
	function clickHook(el, $state, $timeout, type, current) {
	  return function(e) {
	    var button = e.which || e.button, target = current();
	
	    if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
	      // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
	      var transition = $timeout(function() {
	        $state.go(target.state, target.params, target.options);
	      });
	      e.preventDefault();
	
	      // if the state has no URL, ignore one preventDefault from the <a> directive.
	      var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1: 0;
	
	      e.preventDefault = function() {
	        if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
	      };
	    }
	  };
	}
	
	function defaultOpts(el, $state) {
	  return { relative: stateContext(el) || $state.$current, inherit: true };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref
	 *
	 * @requires ui.router.state.$state
	 * @requires $timeout
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive that binds a link (`<a>` tag) to a state. If the state has an associated
	 * URL, the directive will automatically generate & update the `href` attribute via
	 * the {@link ui.router.state.$state#methods_href $state.href()} method. Clicking
	 * the link will trigger a state transition with optional parameters.
	 *
	 * Also middle-clicking, right-clicking, and ctrl-clicking on the link will be
	 * handled natively by the browser.
	 *
	 * You can also use relative state paths within ui-sref, just like the relative
	 * paths passed to `$state.go()`. You just need to be aware that the path is relative
	 * to the state that the link lives in, in other words the state that loaded the
	 * template containing the link.
	 *
	 * You can specify options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 * using the `ui-sref-opts` attribute. Options are restricted to `location`, `inherit`,
	 * and `reload`.
	 *
	 * @example
	 * Here's an example of how you'd use ui-sref and how it would compile. If you have the
	 * following template:
	 * <pre>
	 * <a ui-sref="home">Home</a> | <a ui-sref="about">About</a> | <a ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
	 *     </li>
	 * </ul>
	 * </pre>
	 *
	 * Then the compiled html would be (assuming Html5Mode is off and current state is contacts):
	 * <pre>
	 * <a href="#/home" ui-sref="home">Home</a> | <a href="#/about" ui-sref="about">About</a> | <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
	 *
	 * <ul>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
	 *     </li>
	 *     <li ng-repeat="contact in contacts">
	 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
	 *     </li>
	 * </ul>
	 *
	 * <a ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
	 * </pre>
	 *
	 * @param {string} ui-sref 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-sref-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDirective.$inject = ['$state', '$timeout'];
	function $StateRefDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var ref    = parseStateRef(attrs.uiSref, $state.current.name);
	      var def    = { state: ref.state, href: null, params: null };
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      def.options = extend(defaultOpts(element, $state), attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {});
	
	      var update = function(val) {
	        if (val) def.params = angular.copy(val);
	        def.href = $state.href(ref.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(ref.state, def.params);
	        if (def.href !== null) attrs.$set(type.attr, def.href);
	      };
	
	      if (ref.paramExpr) {
	        scope.$watch(ref.paramExpr, function(val) { if (val !== def.params) update(val); }, true);
	        def.params = angular.copy(scope.$eval(ref.paramExpr));
	      }
	      update();
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-state
	 *
	 * @requires ui.router.state.uiSref
	 *
	 * @restrict A
	 *
	 * @description
	 * Much like ui-sref, but will accept named $scope properties to evaluate for a state definition,
	 * params and override options.
	 *
	 * @param {string} ui-state 'stateName' can be any valid absolute or relative state
	 * @param {Object} ui-state-params params to pass to {@link ui.router.state.$state#methods_href $state.href()}
	 * @param {Object} ui-state-opts options to pass to {@link ui.router.state.$state#methods_go $state.go()}
	 */
	$StateRefDynamicDirective.$inject = ['$state', '$timeout'];
	function $StateRefDynamicDirective($state, $timeout) {
	  return {
	    restrict: 'A',
	    require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
	    link: function(scope, element, attrs, uiSrefActive) {
	      var type   = getTypeInfo(element);
	      var active = uiSrefActive[1] || uiSrefActive[0];
	      var group  = [attrs.uiState, attrs.uiStateParams || null, attrs.uiStateOpts || null];
	      var watch  = '[' + group.map(function(val) { return val || 'null'; }).join(', ') + ']';
	      var def    = { state: null, params: null, options: null, href: null };
	      var unlinkInfoFn = null;
	      var hookFn;
	
	      function runStateRefLink (group) {
	        def.state = group[0]; def.params = group[1]; def.options = group[2];
	        def.href = $state.href(def.state, def.params, def.options);
	
	        if (unlinkInfoFn) unlinkInfoFn();
	        if (active) unlinkInfoFn = active.$$addStateInfo(def.state, def.params);
	        if (def.href) attrs.$set(type.attr, def.href);
	      }
	
	      scope.$watch(watch, runStateRefLink, true);
	      runStateRefLink(scope.$eval(watch));
	
	      if (!type.clickable) return;
	      hookFn = clickHook(element, $state, $timeout, type, function() { return def; });
	      element[element.on ? 'on' : 'bind']("click", hookFn);
	      scope.$on('$destroy', function() {
	        element[element.off ? 'off' : 'unbind']("click", hookFn);
	      });
	    }
	  };
	}
	
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * A directive working alongside ui-sref to add classes to an element when the
	 * related ui-sref directive's state is active, and removing them when it is inactive.
	 * The primary use-case is to simplify the special appearance of navigation menus
	 * relying on `ui-sref`, by having the "active" state's menu button appear different,
	 * distinguishing it from the inactive menu items.
	 *
	 * ui-sref-active can live on the same element as ui-sref or on a parent element. The first
	 * ui-sref-active found at the same level or above the ui-sref will be used.
	 *
	 * Will activate when the ui-sref's target state or any child state is active. If you
	 * need to activate only when the ui-sref target state is active and *not* any of
	 * it's children, then you will use
	 * {@link ui.router.state.directive:ui-sref-active-eq ui-sref-active-eq}
	 *
	 * @example
	 * Given the following template:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item">
	 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 *
	 * When the app state is "app.user" (or any children states), and contains the state parameter "user" with value "bilbobaggins",
	 * the resulting HTML will appear as (note the 'active' class):
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active="active" class="item active">
	 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * The class name is interpolated **once** during the directives link time (any further changes to the
	 * interpolated value are ignored).
	 *
	 * Multiple classes may be specified in a space-separated format:
	 * <pre>
	 * <ul>
	 *   <li ui-sref-active='class1 class2 class3'>
	 *     <a ui-sref="app.user">link</a>
	 *   </li>
	 * </ul>
	 * </pre>
	 *
	 * It is also possible to pass ui-sref-active an expression that evaluates
	 * to an object hash, whose keys represent active class names and whose
	 * values represent the respective state names/globs.
	 * ui-sref-active will match if the current active state **includes** any of
	 * the specified state names/globs, even the abstract ones.
	 *
	 * @Example
	 * Given the following template, with "admin" being an abstract state:
	 * <pre>
	 * <div ui-sref-active="{'active': 'admin.*'}">
	 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
	 * </div>
	 * </pre>
	 *
	 * When the current state is "admin.roles" the "active" class will be applied
	 * to both the <div> and <a> elements. It is important to note that the state
	 * names/globs passed to ui-sref-active shadow the state provided by ui-sref.
	 */
	
	/**
	 * @ngdoc directive
	 * @name ui.router.state.directive:ui-sref-active-eq
	 *
	 * @requires ui.router.state.$state
	 * @requires ui.router.state.$stateParams
	 * @requires $interpolate
	 *
	 * @restrict A
	 *
	 * @description
	 * The same as {@link ui.router.state.directive:ui-sref-active ui-sref-active} but will only activate
	 * when the exact target state used in the `ui-sref` is active; no child states.
	 *
	 */
	$StateRefActiveDirective.$inject = ['$state', '$stateParams', '$interpolate'];
	function $StateRefActiveDirective($state, $stateParams, $interpolate) {
	  return  {
	    restrict: "A",
	    controller: ['$scope', '$element', '$attrs', '$timeout', function ($scope, $element, $attrs, $timeout) {
	      var states = [], activeClasses = {}, activeEqClass, uiSrefActive;
	
	      // There probably isn't much point in $observing this
	      // uiSrefActive and uiSrefActiveEq share the same directive object with some
	      // slight difference in logic routing
	      activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
	
	      try {
	        uiSrefActive = $scope.$eval($attrs.uiSrefActive);
	      } catch (e) {
	        // Do nothing. uiSrefActive is not a valid expression.
	        // Fall back to using $interpolate below
	      }
	      uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
	      if (isObject(uiSrefActive)) {
	        forEach(uiSrefActive, function(stateOrName, activeClass) {
	          if (isString(stateOrName)) {
	            var ref = parseStateRef(stateOrName, $state.current.name);
	            addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
	          }
	        });
	      }
	
	      // Allow uiSref to communicate with uiSrefActive[Equals]
	      this.$$addStateInfo = function (newState, newParams) {
	        // we already got an explicit state provided by ui-sref-active, so we
	        // shadow the one that comes from ui-sref
	        if (isObject(uiSrefActive) && states.length > 0) {
	          return;
	        }
	        var deregister = addState(newState, newParams, uiSrefActive);
	        update();
	        return deregister;
	      };
	
	      $scope.$on('$stateChangeSuccess', update);
	
	      function addState(stateName, stateParams, activeClass) {
	        var state = $state.get(stateName, stateContext($element));
	        var stateHash = createStateHash(stateName, stateParams);
	
	        var stateInfo = {
	          state: state || { name: stateName },
	          params: stateParams,
	          hash: stateHash
	        };
	
	        states.push(stateInfo);
	        activeClasses[stateHash] = activeClass;
	
	        return function removeState() {
	          var idx = states.indexOf(stateInfo);
	          if (idx !== -1) states.splice(idx, 1);
	        };
	      }
	
	      /**
	       * @param {string} state
	       * @param {Object|string} [params]
	       * @return {string}
	       */
	      function createStateHash(state, params) {
	        if (!isString(state)) {
	          throw new Error('state should be a string');
	        }
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        params = $scope.$eval(params);
	        if (isObject(params)) {
	          return state + toJson(params);
	        }
	        return state;
	      }
	
	      // Update route state
	      function update() {
	        for (var i = 0; i < states.length; i++) {
	          if (anyMatch(states[i].state, states[i].params)) {
	            addClass($element, activeClasses[states[i].hash]);
	          } else {
	            removeClass($element, activeClasses[states[i].hash]);
	          }
	
	          if (exactMatch(states[i].state, states[i].params)) {
	            addClass($element, activeEqClass);
	          } else {
	            removeClass($element, activeEqClass);
	          }
	        }
	      }
	
	      function addClass(el, className) { $timeout(function () { el.addClass(className); }); }
	      function removeClass(el, className) { el.removeClass(className); }
	      function anyMatch(state, params) { return $state.includes(state.name, params); }
	      function exactMatch(state, params) { return $state.is(state.name, params); }
	
	      update();
	    }]
	  };
	}
	
	angular.module('ui.router.state')
	  .directive('uiSref', $StateRefDirective)
	  .directive('uiSrefActive', $StateRefActiveDirective)
	  .directive('uiSrefActiveEq', $StateRefActiveDirective)
	  .directive('uiState', $StateRefDynamicDirective);
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:isState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
	 */
	$IsStateFilter.$inject = ['$state'];
	function $IsStateFilter($state) {
	  var isFilter = function (state, params) {
	    return $state.is(state, params);
	  };
	  isFilter.$stateful = true;
	  return isFilter;
	}
	
	/**
	 * @ngdoc filter
	 * @name ui.router.state.filter:includedByState
	 *
	 * @requires ui.router.state.$state
	 *
	 * @description
	 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
	 */
	$IncludedByStateFilter.$inject = ['$state'];
	function $IncludedByStateFilter($state) {
	  var includesFilter = function (state, params, options) {
	    return $state.includes(state, params, options);
	  };
	  includesFilter.$stateful = true;
	  return  includesFilter;
	}
	
	angular.module('ui.router.state')
	  .filter('isState', $IsStateFilter)
	  .filter('includedByState', $IncludedByStateFilter);
	})(window, window.angular);

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routing;
	/**
	 * Created by Julio Perez on 5/24/2016.
	 */
	
	routing.$inject = ['$urlRouterProvider', '$locationProvider', '$compileProvider'];
	
	function routing($urlRouterProvider, $locationProvider, $compileProvider) {
	    $locationProvider.html5Mode(true);
	    $urlRouterProvider.otherwise('/');
	    $compileProvider.debugInfoEnabled(false);
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _appView = __webpack_require__(76);
	
	var _appView2 = _interopRequireDefault(_appView);
	
	var _appView3 = __webpack_require__(78);
	
	var _appView4 = _interopRequireDefault(_appView3);
	
	var _appView5 = __webpack_require__(79);
	
	var _appView6 = _interopRequireDefault(_appView5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('app.appView', [_appView6.default]).config(_appView2.default).controller('AppViewController', _appView4.default).name; /**
	                                                                                                                                                         * Created by Julio Perez on 9/1/2016.
	                                                                                                                                                         */

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/**
	 * Created by Julio Perez on 5/24/2016.
	 */
	routes.$inject = ['$stateProvider'];
	function routes($stateProvider) {
	
	    $stateProvider.state('appView', {
	        url: '/',
	        template: __webpack_require__(77)
	    });
	}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	module.exports = "<app-view></app-view>\r\n"

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//'use strict';
	var AppViewController = function AppViewController($scope, $state) {
	        _classCallCheck(this, AppViewController);
	
	        var vm = this;
	        vm.pageTitle = 'Getting Down To Earth';
	        // $state.go('appView.contentSection', {section: "Bag Free, Hassle Free Travel"});
	
	        $('#map-content').animate({ opacity: 1 }).delay(500).animate({ opacity: .25, top: "0px" });
	        $('#section-content').animate({ opacity: 1 }).delay(500).animate({ opacity: .25, top: "0px" });
	
	        $('#intro').animate({ opacity: 0 }).delay(300).animate({ opacity: 1 });
	
	        vm.viewContent = function () {
	
	                $('#intro').animate({ opacity: 0 }, 300).slideUp(500);
	                $('#map-content').animate({ opacity: 1 }, 500);
	                $('#section-content').animate({ opacity: 1 }, 500);
	        };
	
	        $scope.$on('$locationChangeSuccess', function () {
	
	                if ($state.params.section === "Bag Free, Hassle Free Travel") {
	
	                        // $state.go('appView.contentSection', {section: $state.params.section});
	                }
	        });
	};
	
	exports.default = AppViewController;
	
	AppViewController.$inject = ['$scope', '$state'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Created by Julio Perez on 5/24/2016.
	 */
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(71);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _appView = __webpack_require__(78);
	
	var _appView2 = _interopRequireDefault(_appView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function appView() {
	    return {
	        restrict: "E",
	        scope: {
	            name: '='
	        },
	        template: __webpack_require__(80),
	        controller: _appView2.default,
	        controllerAs: 'ctrl'
	    };
	}
	
	exports.default = _angular2.default.module('app-view.directive', []).directive('appView', appView).name;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = "<!--<nav-menu-strip></nav-menu-strip>-->\r\n\r\n<div class=\"container kill-sides-padding\" style=\"max-width: 750px\">\r\n\r\n    <!--<div ui-view=\"header-section\">-->\r\n        <!--<header-section></header-section>-->\r\n    <!--</div>-->\r\n    <nav-links-strip></nav-links-strip>\r\n\r\n    <div ui-view=\"map-section\">\r\n        <div id=\"map-content\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">\r\n            <map-page></map-page>\r\n        </div>\r\n\r\n    </div>\r\n\r\n    <!--<div ui-view=\"footer-section\">-->\r\n        <!--<footer-section></footer-section>-->\r\n    <!--</div>-->\r\n\r\n</div>"

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _headerSection = __webpack_require__(82);
	
	var _headerSection2 = _interopRequireDefault(_headerSection);
	
	var _headerSection3 = __webpack_require__(84);
	
	var _headerSection4 = _interopRequireDefault(_headerSection3);
	
	var _headerSection5 = __webpack_require__(86);
	
	var _headerSection6 = _interopRequireDefault(_headerSection5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////SERVICES
	
	////CONTROLLER
	exports.default = angular.module('headerSection', [_headerSection6.default]).config(_headerSection2.default).controller('HeaderSectionController', _headerSection4.default).name;
	
	////DIRECTIVES
	/**
	 * Created by Julio Perez on 4/10/2017.
	 */
	
	////ROUTING

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/**
	 * Created by Julio Perez on 5/24/2016.
	 */
	routes.$inject = ['$stateProvider'];
	
	function routes($stateProvider) {
	
	    $stateProvider.state('appView.headerSection', {
	        url: ':section/:toggle',
	        views: {
	            "header-section@appView": {
	                template: __webpack_require__(83)
	            }
	        }
	    });
	}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = "<header-section></header-section>"

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _selectedLink = __webpack_require__(85);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } //'use strict';
	
	
	var HeaderSectionController = function HeaderSectionController() {
	    _classCallCheck(this, HeaderSectionController);
	
	    var vm = this;
	    vm.header = 'Wealth Distribution Atlas';
	    vm.description = 'Wealth data by segment can be used to spot new markets for many products, particularly those in the luxury industry, and can help to position products alongside value/premium offerings. Learn more about the entire spectrum of wealth segment sizes and trends around the world in the interactive chart below. You can switch between the five net-wealth segments by clicking on the corresponding segment button.';
	    vm.selectedLink = (0, _selectedLink.getSelectedLink)();
	
	    _selectedLink.selectedLink.name = "HELLO";
	
	    (0, _selectedLink.setSelectedLink)("this is new");
	};
	
	exports.default = HeaderSectionController;
	
	HeaderSectionController.$inject = [];

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getSelectedLink = getSelectedLink;
	exports.setSelectedLink = setSelectedLink;
	/**
	 * Created by Julio Perez on 6/23/2017.
	 */
	var selectedLink = exports.selectedLink = {
	    name: "DEFAULT"
	};
	
	function getSelectedLink() {
	    return selectedLink.name;
	}
	
	function setSelectedLink(newName) {
	    exports.selectedLink = selectedLink = {
	        name: newName
	    };
	}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _headerSection = __webpack_require__(84);
	
	var _headerSection2 = _interopRequireDefault(_headerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function headerSection() {
	    return {
	        restrict: "E",
	        scope: {
	            name: '='
	        },
	        template: __webpack_require__(87),
	        controller: _headerSection2.default,
	        controllerAs: "ctrl"
	    };
	} /**
	   * Created by Julio Perez on 5/24/2016.
	   */
	exports.default = angular.module('header-section.directive', []).directive('headerSection', headerSection).name;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = "            <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 kill-sides\">\r\n                <h3 class=\"thin\">{{ctrl.header}}: {{ctrl.selectedLink}}</h3>\r\n                <p class=\"description\">{{ctrl.description}}</p>\r\n            </div>\r\n"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footerSection = __webpack_require__(89);
	
	var _footerSection2 = _interopRequireDefault(_footerSection);
	
	var _footerSection3 = __webpack_require__(91);
	
	var _footerSection4 = _interopRequireDefault(_footerSection3);
	
	var _footerSection5 = __webpack_require__(92);
	
	var _footerSection6 = _interopRequireDefault(_footerSection5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////SERVICES
	
	////CONTROLLER
	exports.default = angular.module('footerSection', [_footerSection6.default]).config(_footerSection2.default).controller('FooterSectionController', _footerSection4.default).name;
	
	////DIRECTIVES
	/**
	 * Created by Julio Perez on 4/10/2017.
	 */
	
	////ROUTING

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/**
	 * Created by Julio Perez on 6/22/2017.
	 */
	routes.$inject = ['$stateProvider'];
	
	function routes($stateProvider) {
	
	    $stateProvider.state('appView.footerSection', {
	        url: ':section/:toggle',
	        views: {
	            "footer-section@appView": {
	                template: __webpack_require__(90)
	            }
	        }
	    });
	}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = "<footer-section></footer-section>"

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	//'use strict';
	var FooterSectionController = function FooterSectionController() {
	    _classCallCheck(this, FooterSectionController);
	
	    var vm = this;
	    vm.header = 'Wealth Distribution Atlas';
	    vm.description = 'Wealth data by segment can be used to spot new markets for many products, particularly those in the luxury industry, and can help to position products alongside value/premium offerings. Learn more about the entire spectrum of wealth segment sizes and trends around the world in the interactive chart below. You can switch between the five net-wealth segments by clicking on the corresponding segment button.';
	};
	
	exports.default = FooterSectionController;
	
	FooterSectionController.$inject = [];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footerSection = __webpack_require__(91);
	
	var _footerSection2 = _interopRequireDefault(_footerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function footerSection() {
	    return {
	        restrict: "E",
	        scope: {
	            name: '='
	        },
	        template: __webpack_require__(93),
	        controller: _footerSection2.default,
	        controllerAs: "ctrl"
	    };
	} /**
	   * Created by Julio Perez on 5/24/2016.
	   */
	exports.default = angular.module('footer-section.directive', []).directive('footerSection', footerSection).name;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "            <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 kill-sides\">\r\n                <div>\r\n                    <div>\r\n                        <small><b>Source:</b> Euromonitor Income and Wealth Distribution Model</small>\r\n                    </div>\r\n                    <div>\r\n                        <small><b>Note:</b> Net wealth is defined as the sum of all financial and non-financial assets minus all liabilities. 2030 data refers to current prices.</small>\r\n                    </div>\r\n                    <div class=\"margin-top-15\">\r\n                        <small>For further insight please contact Aleksej Baksajev, at <a href=\"mailto:aleksej.baksajev@euromonitor.com\">aleksej.baksajev@euromonitor.com</a></small>\r\n\r\n                    </div>\r\n                </div>\r\n\r\n                <h6 class=\"kill-sides margin-top-20\">COUNTRIES COVERED</h6>\r\n                <div>\r\n                    <small><b>Africa and Middle East:</b> Egypt, Israel, Nigeria, South Africa, United Arab Emirates</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>Asia-Pacific:</b> Azerbaijan, China, Hong Kong, India, Indonesia, Japan, Kazakhstan, Malaysia, Pakistan, Philippines, Singapore, South Korea, Taiwan, Thailand, Turkmenistan, Uzbekistan, Vietnam</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>Australasia:</b> Australia, New Zealand</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>Eastern Europe:</b> Belarus, Bosnia-Herzegovina, Bulgaria, Croatia, Czech Republic, Estonia, Georgia, Hungary, Latvia, Lithuania, Macedonia, Poland, Romania, Russia, Serbia, Slovakia, Slovenia, Ukraine</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>Western Europe:</b> Austria, Belgium, Denmark, Finland, France, Germany, Greece, Ireland, Italy, Netherlands, Norway, Portugal, Spain, Sweden, Switzerland, Turkey, UK</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>Latin America:</b> Argentina, Bolivia, Brazil, Chile, Colombia, Costa Rica, Dominican Republic, Ecuador, Guatemala, Mexico, Peru, Uruguay</small>\r\n                </div>\r\n                <div>\r\n                    <small><b>North America:</b> Canada, USA</small>\r\n\r\n                </div>\r\n            </div>\r\n"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	__webpack_require__(95);
	
	var _mapPage = __webpack_require__(99);
	
	var _mapPage2 = _interopRequireDefault(_mapPage);
	
	var _mapPage3 = __webpack_require__(101);
	
	var _mapPage4 = _interopRequireDefault(_mapPage3);
	
	var _mapPage5 = __webpack_require__(104);
	
	var _mapPage6 = _interopRequireDefault(_mapPage5);
	
	var _map = __webpack_require__(106);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _incomeWealth = __webpack_require__(108);
	
	var _incomeWealth2 = _interopRequireDefault(_incomeWealth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	////SERVICES
	
	
	////CONTROLLER
	/**
	 * Created by Julio Perez on 9/24/2016.
	 */
	
	__webpack_require__(112);
	
	////DIRECTIVES
	
	
	////ROUTING
	exports.default = angular.module('mapPage', [_mapPage6.default, _incomeWealth2.default, _map2.default]).config(_mapPage2.default).controller('MapPageController', _mapPage4.default).name;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/**
	 * Created by Julio Perez on 4/10/2017.
	 */
	
	function routes($stateProvider) {
	
	    $stateProvider.state('appView.mapSection', {
	        url: '/mapPage',
	        views: {
	            "map-section@appView": {
	                template: __webpack_require__(100)
	            }
	        }
	
	    });
	}
	
	routes.$inject = ['$stateProvider'];

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = "<map-page></map-page>"

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _d = __webpack_require__(102);
	
	var _d2 = _interopRequireDefault(_d);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Created by Julio Perez on 9/29/2016.
	                                                                                                                                                           */
	//'use strict';
	
	
	var MapPageController = function MapPageController($state, $scope, incomeWealthService, mapLeafletService) {
	    _classCallCheck(this, MapPageController);
	
	    var vm = this;
	    vm.pageTitle = 'Map Page';
	    vm.currentSection = $state.params.section = "Bottom";
	    vm.toggleSelected = $state.params.toggle = "Current";
	
	    vm.getLegendHeader = function () {
	
	        if (vm.toggleSelected === "Current") {
	            return "Current Year: 2016";
	        } else {
	            return "Forecast Year: 2030";
	        }
	    };
	
	    vm.incomeWealthService = incomeWealthService;
	    vm.mapLeafletService = mapLeafletService;
	
	    vm.mapLeafletService.init();
	
	    var map = vm.mapLeafletService.getMap();
	
	    var defaultStyle = {
	        fillColor: "#00AED9",
	        weight: 1,
	        opacity: 1,
	        color: '#00AED9',
	        fillOpacity: 1
	    };
	
	    function stylize(feature) {
	
	        return {
	            fillColor: "#00AED9",
	            weight: 1,
	            opacity: 1,
	            color: '#00AED9',
	            fillOpacity: 0.7
	        };
	    }
	
	    // vm.popOps = vm.mapLeafletService.popOps;
	    // vm.blueIcon = vm.mapLeafletService.blueIcon;
	    vm.section = $state.params.section;
	
	    // vm.latlngData = vm.incomeWealthService.getCountryLatLng();
	    vm.segmentData = vm.incomeWealthService.getCountrySegment(vm.currentSection);
	
	    vm.currentMax = vm.incomeWealthService.getCurrentMax(vm.currentSection);
	    vm.forecastMax = vm.incomeWealthService.getForecastMax(vm.currentSection);
	
	    // vm.mapLeafletService.mapData = vm.latlngData;
	    vm.mapLeafletService.segmentData = vm.segmentData;
	
	    vm.scale;
	    vm.minVal;
	    vm.maxVal;
	    vm.rects;
	    vm.lgd;
	    vm.rectLgd;
	    vm.labelLgd;
	    vm.mapCenter;
	    vm.selection;
	    vm.proj;
	    vm.cty;
	    vm.d3Overlay;
	    vm.zLevel;
	    vm.coordinates = [];
	    vm.legend = [];
	    vm.bounds;
	
	    // let bounds;
	    var tooltip = void 0;
	
	    vm.mapCenter = map.getCenter();
	    vm.config = {
	        zoomDraw: false,
	        zoomHide: true
	    };
	
	    vm.xScale = _d2.default.scale.sqrt();
	    vm.xScale.range([2, 75]);
	
	    vm.segmentData.forEach(function (d) {
	
	        if (vm.toggleSelected === "Current") {
	            d.val = +d.metricValueCurrent;
	        } else {
	            d.val = +d.metricValueForecast;
	        }
	    });
	
	    vm.minVal = _d2.default.min(vm.segmentData, function (d) {
	        return d.val;
	    });
	    vm.maxVal = _d2.default.max(vm.segmentData, function (d) {
	        return d.val;
	    });
	
	    vm.zoomCountry = function (country) {
	
	        var ll = vm.proj.layerPointToLatLng([getCoordinates(country).x, getCoordinates(country).y]);
	
	        map.setView(ll, 3.5);
	    };
	
	    drawTooltip();
	    updateLegend();
	    drawLegend();
	
	    function updateLegend() {
	        vm.legend = [];
	        vm.legend.push({ "range": vm.maxVal * .9 });
	        vm.legend.push({ "range": vm.maxVal * .6 });
	        vm.legend.push({ "range": vm.maxVal * .3 });
	        vm.legend.push({ "range": vm.maxVal * .1 });
	    }
	
	    function drawLegend() {
	
	        vm.zLevel = map.getZoom();
	        vm.xScale.domain([vm.minVal, vm.maxVal]);
	
	        if (!vm.lgd) {
	            vm.lgd = _d2.default.select("#legend").append('svg').attr({
	                'class': 'legend',
	                'width': 700,
	                'height': 85
	            });
	        }
	
	        _d2.default.selectAll(".rect-lgd").remove();
	
	        vm.rectLgd = vm.lgd.selectAll('.rect-lgd').data(vm.legend);
	
	        vm.rectLgd.enter().append('rect').transition().duration(500).ease("quad-in-out").attr({
	            'class': '.rect-lgd',
	            'x': function x(d) {
	                return 75 - getScaledValue(d.range) * .5;
	            },
	            'y': function y(d) {
	                return 70 - getScaledValue(d.range);
	            },
	            'width': function width(d) {
	                return getScaledValue(d.range);
	            },
	            'height': function height(d) {
	                return getScaledValue(d.range);
	            },
	            'fill': function fill(d) {
	                return "#00AED9";
	            },
	            "fill-opacity": 0,
	            "stroke": "#00AED9",
	            "stroke-width": ".5px"
	        });
	
	        _d2.default.selectAll(".label-legend").remove();
	
	        vm.labelLgd = vm.lgd.selectAll('.label-legend').data(vm.legend);
	
	        vm.labelLgd.enter().append('text').transition().duration(500).ease("quad-in-out").text(function (d) {
	            var numeral = __webpack_require__(103);
	            var num = numeral(d.range).format('0a');
	
	            return numeral(num).format('0,0');
	        }).attr({
	            'class': 'label-legend',
	            'x': function x() {
	                return 45;
	            },
	            'y': function y(d, i) {
	                return i * 13 + 30;
	            }
	        }).style({
	            // "font-size": 11,
	            "text-anchor": "end"
	        });
	    }
	
	    function drawTooltip() {
	
	        _d2.default.selectAll(".tooltip").remove();
	
	        ////ADD TOOLTIP
	        tooltip = _d2.default.select("body").append("div").attr({
	            "id": "tooltip",
	            "class": "tooltip"
	        }).style("opacity", 0);
	    }
	
	    function getCoordinates(country) {
	
	        var obj = vm.coordinates.filter(function (item) {
	            return item.country === country;
	        }).map(function (selectedItem) {
	            return selectedItem;
	        }).shift();
	
	        return obj;
	    }
	
	    function getScaledValue(val) {
	
	        return vm.xScale(val) / vm.zLevel;
	    }
	
	    var geojsonLayer = new L.geoJson(vm.mapLeafletService.wMap, {
	        style: stylize,
	        onEachFeature: onEachFeature
	    });
	
	    function onEachFeature(feature, featureLayer) {}
	
	    geojsonLayer.addTo(map);
	
	    var d3Overlay = L.d3SvgOverlay(function (selection, proj) {
	        vm.selection = selection;
	        vm.proj = proj;
	        vm.proj.layer.options = vm.config;
	
	        vm.coordinates = [];
	
	        vm.segmentData.forEach(function (d) {
	            var xPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).x;
	            var yPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).y;
	
	            d.xPoint = +xPoint;
	            d.yPoint = +yPoint;
	        });
	
	        vm.minVal = _d2.default.min(vm.segmentData, function (d) {
	            return d.val;
	        });
	        vm.maxVal = _d2.default.max(vm.segmentData, function (d) {
	            return d.val;
	        });
	
	        vm.xScale.domain([vm.minVal, vm.maxVal]);
	
	        var bnds = [];
	
	        vm.rects = vm.selection.selectAll('rect').data(vm.segmentData);
	
	        vm.rects.enter().append('rect').transition().duration(500).ease("quad-in-out").attr({
	            'class': '.rect',
	            'x': function x(d) {
	                return d.xPoint - getScaledValue(d.val) * .5;
	            },
	            'y': function y(d) {
	                return d.yPoint - getScaledValue(d.val) * .5;
	            },
	            'width': function width(d) {
	                return getScaledValue(d.val);
	            },
	            'height': function height(d) {
	                return getScaledValue(d.val);
	            },
	            'fill': function fill(d) {
	                return "#00AED9";
	            },
	            "fill-opacity": .25,
	            "stroke": "#00AED9",
	            "stroke-width": .5 / vm.zLevel,
	            "cursor": "pointer"
	        });
	
	        vm.rects.on("mouseover", function (d) {
	
	            var xPos = parseFloat(_d2.default.select(this).attr('x'));
	            var yPos = parseFloat(_d2.default.select(this).attr('y'));
	            var ll = vm.proj.layerPointToLatLng([xPos, yPos]);
	
	            tooltip.transition().duration(200).style("opacity", 1);
	
	            tooltip.html("<div><h3>" + d.country + "</h3></div>" + "<div>" + "<h6>" + "Number of Adults, '000s" + "</h6>" + "<h1 class='kpi thin'>" + _d2.default.format(",.1f")(d.val) + "</h1>" + "</div>").style("border", "1px solid " + d.country).style("left", _d2.default.event.pageX - _d2.default.mouse(this)[0] + getNewX(xPos, ll) + "px").style("top", _d2.default.event.pageY - _d2.default.mouse(this)[1] + getNewY(yPos, ll) + "px");
	        });
	
	        vm.rects.on("mouseout", function () {
	            tooltip.transition().duration(350).style("opacity", 0);
	        });
	
	        vm.cty = vm.segmentData.map(function (d) {
	            // d.latlng = [+d.lat, +d.lng];
	            d.latlng = [d.latlng[0], d.latlng[1]];
	            return d;
	        });
	
	        map.on('zoomend', update);
	
	        update();
	
	        function getNewX(x, ll) {
	            var val = 0;
	            var lng = ll.lng;
	
	            if (lng > vm.mapCenter.lng) {
	                val = x - 220;
	            } else {
	                val = x + 20;
	            }
	
	            return val;
	        }
	
	        function getNewY(y, ll) {
	            var val = 0;
	            var lat = ll.lat;
	            if (lat > vm.mapCenter.lat) {
	                val = y + 10;
	            }
	            if (lat <= vm.mapCenter.lat) {
	                val = y - 70;
	            }
	
	            return val;
	        }
	
	        function update() {
	
	            vm.bounds = map.getBounds();
	            map.fitBounds(vm.bounds);
	            vm.zLevel = map.getZoom();
	            map.setZoom(vm.zLevel);
	
	            vm.mapCenter = map.getCenter();
	
	            vm.segmentData.forEach(function (d) {
	
	                var xPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).x;
	                var yPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).y;
	
	                d.xPoint = +xPoint;
	                d.yPoint = +yPoint;
	            });
	            vm.rects.transition().duration(1000).ease("quad-in-out").attr({
	                'x': function x(d) {
	                    return d.xPoint - getScaledValue(d.val) * .5;
	                },
	                'y': function y(d) {
	                    return d.yPoint - getScaledValue(d.val) * .5;
	                },
	                'width': function width(d) {
	                    return getScaledValue(d.val);
	                },
	                'height': function height(d) {
	                    return getScaledValue(d.val);
	                },
	                'fill': function fill(d) {
	                    return "#00AED9";
	                },
	                "fill-opacity": .5,
	                "stroke": "#00AED9",
	                "stroke-width": .75 / vm.zLevel,
	                "cursor": "pointer"
	            });
	        }
	    });
	
	    d3Overlay.addTo(map);
	
	    $scope.$on('$locationChangeSuccess', function () {
	
	        vm.currentSection = $state.params.section;
	        vm.toggleSelected = $state.params.toggle;
	        vm.segmentData = vm.incomeWealthService.getCountrySegment(vm.currentSection);
	        vm.currentMax = vm.incomeWealthService.getCurrentMax(vm.currentSection);
	        vm.forecastMax = vm.incomeWealthService.getForecastMax(vm.currentSection);
	
	        vm.mapLeafletService.segmentData = vm.segmentData;
	        vm.coordinates = [];
	
	        vm.segmentData.forEach(function (d) {
	            if (vm.toggleSelected === "Current") {
	                d.val = +d.metricValueCurrent;
	            } else {
	                d.val = +d.metricValueForecast;
	            }
	            var xPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).x;
	            var yPoint = vm.proj.latLngToLayerPoint({ lat: d.latlng[0], lng: d.latlng[1] }).y;
	
	            d.xPoint = +xPoint;
	            d.yPoint = +yPoint;
	        });
	
	        vm.cty = vm.segmentData.map(function (d) {
	            d.latlng = [+d.latlng[0], +d.latlng[1]];
	            return d;
	        });
	
	        vm.minVal = _d2.default.min(vm.segmentData, function (d) {
	            return d.val;
	        });
	        vm.maxVal = _d2.default.max(vm.segmentData, function (d) {
	            return d.val;
	        });
	
	        vm.xScale.domain([vm.minVal, vm.maxVal]);
	
	        vm.bounds = map.getBounds();
	        map.fitBounds(vm.bounds);
	        vm.zLevel = map.getZoom();
	        map.setZoom(vm.zLevel);
	
	        vm.rects = vm.selection.selectAll('rect').data(vm.segmentData);
	
	        vm.rects.transition().duration(1000).ease("quad-in-out").attr({
	            'x': function x(d) {
	                return d.xPoint - getScaledValue(d.val) * .5;
	            },
	            'y': function y(d) {
	                return d.yPoint - getScaledValue(d.val) * .5;
	            },
	            'width': function width(d) {
	                return getScaledValue(d.val);
	            },
	            'height': function height(d) {
	                return getScaledValue(d.val);
	            }
	        });
	
	        updateLegend();
	
	        vm.labelLgd = _d2.default.selectAll('.label-legend').data(vm.legend);
	
	        vm.labelLgd.text(function (d) {
	            var numeral = __webpack_require__(103);
	            var num = numeral(d.range).format('0 a');
	            return numeral(num).format('0,0');
	        });
	    });
	};
	
	exports.default = MapPageController;
	
	
	MapPageController.$inject = ['$state', '$scope', 'incomeWealthService', 'mapLeafletService'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
	  var d3 = {
	    version: "3.5.17"
	  };
	  var d3_arraySlice = [].slice, d3_array = function(list) {
	    return d3_arraySlice.call(list);
	  };
	  var d3_document = this.document;
	  function d3_documentElement(node) {
	    return node && (node.ownerDocument || node.document || node).documentElement;
	  }
	  function d3_window(node) {
	    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
	  }
	  if (d3_document) {
	    try {
	      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
	    } catch (e) {
	      d3_array = function(list) {
	        var i = list.length, array = new Array(i);
	        while (i--) array[i] = list[i];
	        return array;
	      };
	    }
	  }
	  if (!Date.now) Date.now = function() {
	    return +new Date();
	  };
	  if (d3_document) {
	    try {
	      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
	    } catch (error) {
	      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
	      d3_element_prototype.setAttribute = function(name, value) {
	        d3_element_setAttribute.call(this, name, value + "");
	      };
	      d3_element_prototype.setAttributeNS = function(space, local, value) {
	        d3_element_setAttributeNS.call(this, space, local, value + "");
	      };
	      d3_style_prototype.setProperty = function(name, value, priority) {
	        d3_style_setProperty.call(this, name, value + "", priority);
	      };
	    }
	  }
	  d3.ascending = d3_ascending;
	  function d3_ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	  d3.descending = function(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  };
	  d3.min = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
	    }
	    return a;
	  };
	  d3.max = function(array, f) {
	    var i = -1, n = array.length, a, b;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
	    }
	    return a;
	  };
	  d3.extent = function(array, f) {
	    var i = -1, n = array.length, a, b, c;
	    if (arguments.length === 1) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    } else {
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
	        a = c = b;
	        break;
	      }
	      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	    return [ a, c ];
	  };
	  function d3_number(x) {
	    return x === null ? NaN : +x;
	  }
	  function d3_numeric(x) {
	    return !isNaN(x);
	  }
	  d3.sum = function(array, f) {
	    var s = 0, n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
	    } else {
	      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
	    }
	    return s;
	  };
	  d3.mean = function(array, f) {
	    var s = 0, n = array.length, a, i = -1, j = n;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
	    }
	    if (j) return s / j;
	  };
	  d3.quantile = function(values, p) {
	    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
	    return e ? v + e * (values[h] - v) : v;
	  };
	  d3.median = function(array, f) {
	    var numbers = [], n = array.length, a, i = -1;
	    if (arguments.length === 1) {
	      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
	    } else {
	      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
	    }
	    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
	  };
	  d3.variance = function(array, f) {
	    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
	    if (arguments.length === 1) {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    } else {
	      while (++i < n) {
	        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	    if (j > 1) return s / (j - 1);
	  };
	  d3.deviation = function() {
	    var v = d3.variance.apply(this, arguments);
	    return v ? Math.sqrt(v) : v;
	  };
	  function d3_bisector(compare) {
	    return {
	      left: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (arguments.length < 3) lo = 0;
	        if (arguments.length < 4) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	  var d3_bisect = d3_bisector(d3_ascending);
	  d3.bisectLeft = d3_bisect.left;
	  d3.bisect = d3.bisectRight = d3_bisect.right;
	  d3.bisector = function(f) {
	    return d3_bisector(f.length === 1 ? function(d, x) {
	      return d3_ascending(f(d), x);
	    } : f);
	  };
	  d3.shuffle = function(array, i0, i1) {
	    if ((m = arguments.length) < 3) {
	      i1 = array.length;
	      if (m < 2) i0 = 0;
	    }
	    var m = i1 - i0, t, i;
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
	    }
	    return array;
	  };
	  d3.permute = function(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  };
	  d3.pairs = function(array) {
	    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
	    return pairs;
	  };
	  d3.transpose = function(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  };
	  function d3_transposeLength(d) {
	    return d.length;
	  }
	  d3.zip = function() {
	    return d3.transpose(arguments);
	  };
	  d3.keys = function(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  };
	  d3.values = function(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  };
	  d3.entries = function(map) {
	    var entries = [];
	    for (var key in map) entries.push({
	      key: key,
	      value: map[key]
	    });
	    return entries;
	  };
	  d3.merge = function(arrays) {
	    var n = arrays.length, m, i = -1, j = 0, merged, array;
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	    return merged;
	  };
	  var abs = Math.abs;
	  d3.range = function(start, stop, step) {
	    if (arguments.length < 3) {
	      step = 1;
	      if (arguments.length < 2) {
	        stop = start;
	        start = 0;
	      }
	    }
	    if ((stop - start) / step === Infinity) throw new Error("infinite range");
	    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
	    start *= k, stop *= k, step *= k;
	    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
	    return range;
	  };
	  function d3_range_integerScale(x) {
	    var k = 1;
	    while (x * k % 1) k *= 10;
	    return k;
	  }
	  function d3_class(ctor, properties) {
	    for (var key in properties) {
	      Object.defineProperty(ctor.prototype, key, {
	        value: properties[key],
	        enumerable: false
	      });
	    }
	  }
	  d3.map = function(object, f) {
	    var map = new d3_Map();
	    if (object instanceof d3_Map) {
	      object.forEach(function(key, value) {
	        map.set(key, value);
	      });
	    } else if (Array.isArray(object)) {
	      var i = -1, n = object.length, o;
	      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
	    } else {
	      for (var key in object) map.set(key, object[key]);
	    }
	    return map;
	  };
	  function d3_Map() {
	    this._ = Object.create(null);
	  }
	  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
	  d3_class(d3_Map, {
	    has: d3_map_has,
	    get: function(key) {
	      return this._[d3_map_escape(key)];
	    },
	    set: function(key, value) {
	      return this._[d3_map_escape(key)] = value;
	    },
	    remove: d3_map_remove,
	    keys: d3_map_keys,
	    values: function() {
	      var values = [];
	      for (var key in this._) values.push(this._[key]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var key in this._) entries.push({
	        key: d3_map_unescape(key),
	        value: this._[key]
	      });
	      return entries;
	    },
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
	    }
	  });
	  function d3_map_escape(key) {
	    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
	  }
	  function d3_map_unescape(key) {
	    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
	  }
	  function d3_map_has(key) {
	    return d3_map_escape(key) in this._;
	  }
	  function d3_map_remove(key) {
	    return (key = d3_map_escape(key)) in this._ && delete this._[key];
	  }
	  function d3_map_keys() {
	    var keys = [];
	    for (var key in this._) keys.push(d3_map_unescape(key));
	    return keys;
	  }
	  function d3_map_size() {
	    var size = 0;
	    for (var key in this._) ++size;
	    return size;
	  }
	  function d3_map_empty() {
	    for (var key in this._) return false;
	    return true;
	  }
	  d3.nest = function() {
	    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
	    function map(mapType, array, depth) {
	      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
	      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
	          values.push(object);
	        } else {
	          valuesByKey.set(keyValue, [ object ]);
	        }
	      }
	      if (mapType) {
	        object = mapType();
	        setter = function(keyValue, values) {
	          object.set(keyValue, map(mapType, values, depth));
	        };
	      } else {
	        object = {};
	        setter = function(keyValue, values) {
	          object[keyValue] = map(mapType, values, depth);
	        };
	      }
	      valuesByKey.forEach(setter);
	      return object;
	    }
	    function entries(map, depth) {
	      if (depth >= keys.length) return map;
	      var array = [], sortKey = sortKeys[depth++];
	      map.forEach(function(key, keyMap) {
	        array.push({
	          key: key,
	          values: entries(keyMap, depth)
	        });
	      });
	      return sortKey ? array.sort(function(a, b) {
	        return sortKey(a.key, b.key);
	      }) : array;
	    }
	    nest.map = function(array, mapType) {
	      return map(mapType, array, 0);
	    };
	    nest.entries = function(array) {
	      return entries(map(d3.map, array, 0), 0);
	    };
	    nest.key = function(d) {
	      keys.push(d);
	      return nest;
	    };
	    nest.sortKeys = function(order) {
	      sortKeys[keys.length - 1] = order;
	      return nest;
	    };
	    nest.sortValues = function(order) {
	      sortValues = order;
	      return nest;
	    };
	    nest.rollup = function(f) {
	      rollup = f;
	      return nest;
	    };
	    return nest;
	  };
	  d3.set = function(array) {
	    var set = new d3_Set();
	    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
	    return set;
	  };
	  function d3_Set() {
	    this._ = Object.create(null);
	  }
	  d3_class(d3_Set, {
	    has: d3_map_has,
	    add: function(key) {
	      this._[d3_map_escape(key += "")] = true;
	      return key;
	    },
	    remove: d3_map_remove,
	    values: d3_map_keys,
	    size: d3_map_size,
	    empty: d3_map_empty,
	    forEach: function(f) {
	      for (var key in this._) f.call(this, d3_map_unescape(key));
	    }
	  });
	  d3.behavior = {};
	  function d3_identity(d) {
	    return d;
	  }
	  d3.rebind = function(target, source) {
	    var i = 1, n = arguments.length, method;
	    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
	    return target;
	  };
	  function d3_rebind(target, source, method) {
	    return function() {
	      var value = method.apply(source, arguments);
	      return value === source ? target : value;
	    };
	  }
	  function d3_vendorSymbol(object, name) {
	    if (name in object) return name;
	    name = name.charAt(0).toUpperCase() + name.slice(1);
	    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
	      var prefixName = d3_vendorPrefixes[i] + name;
	      if (prefixName in object) return prefixName;
	    }
	  }
	  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
	  function d3_noop() {}
	  d3.dispatch = function() {
	    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    return dispatch;
	  };
	  function d3_dispatch() {}
	  d3_dispatch.prototype.on = function(type, listener) {
	    var i = type.indexOf("."), name = "";
	    if (i >= 0) {
	      name = type.slice(i + 1);
	      type = type.slice(0, i);
	    }
	    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
	    if (arguments.length === 2) {
	      if (listener == null) for (type in this) {
	        if (this.hasOwnProperty(type)) this[type].on(name, null);
	      }
	      return this;
	    }
	  };
	  function d3_dispatch_event(dispatch) {
	    var listeners = [], listenerByName = new d3_Map();
	    function event() {
	      var z = listeners, i = -1, n = z.length, l;
	      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
	      return dispatch;
	    }
	    event.on = function(name, listener) {
	      var l = listenerByName.get(name), i;
	      if (arguments.length < 2) return l && l.on;
	      if (l) {
	        l.on = null;
	        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
	        listenerByName.remove(name);
	      }
	      if (listener) listeners.push(listenerByName.set(name, {
	        on: listener
	      }));
	      return dispatch;
	    };
	    return event;
	  }
	  d3.event = null;
	  function d3_eventPreventDefault() {
	    d3.event.preventDefault();
	  }
	  function d3_eventSource() {
	    var e = d3.event, s;
	    while (s = e.sourceEvent) e = s;
	    return e;
	  }
	  function d3_eventDispatch(target) {
	    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
	    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
	    dispatch.of = function(thiz, argumentz) {
	      return function(e1) {
	        try {
	          var e0 = e1.sourceEvent = d3.event;
	          e1.target = target;
	          d3.event = e1;
	          dispatch[e1.type].apply(thiz, argumentz);
	        } finally {
	          d3.event = e0;
	        }
	      };
	    };
	    return dispatch;
	  }
	  d3.requote = function(s) {
	    return s.replace(d3_requote_re, "\\$&");
	  };
	  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  var d3_subclass = {}.__proto__ ? function(object, prototype) {
	    object.__proto__ = prototype;
	  } : function(object, prototype) {
	    for (var property in prototype) object[property] = prototype[property];
	  };
	  function d3_selection(groups) {
	    d3_subclass(groups, d3_selectionPrototype);
	    return groups;
	  }
	  var d3_select = function(s, n) {
	    return n.querySelector(s);
	  }, d3_selectAll = function(s, n) {
	    return n.querySelectorAll(s);
	  }, d3_selectMatches = function(n, s) {
	    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
	    d3_selectMatches = function(n, s) {
	      return d3_selectMatcher.call(n, s);
	    };
	    return d3_selectMatches(n, s);
	  };
	  if (typeof Sizzle === "function") {
	    d3_select = function(s, n) {
	      return Sizzle(s, n)[0] || null;
	    };
	    d3_selectAll = Sizzle;
	    d3_selectMatches = Sizzle.matchesSelector;
	  }
	  d3.selection = function() {
	    return d3.select(d3_document.documentElement);
	  };
	  var d3_selectionPrototype = d3.selection.prototype = [];
	  d3_selectionPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, group, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
	          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selector(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_select(selector, this);
	    };
	  }
	  d3_selectionPrototype.selectAll = function(selector) {
	    var subgroups = [], subgroup, node;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
	          subgroup.parentNode = node;
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_selectorAll(selector) {
	    return typeof selector === "function" ? selector : function() {
	      return d3_selectAll(selector, this);
	    };
	  }
	  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
	  var d3_nsPrefix = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: d3_nsXhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	  d3.ns = {
	    prefix: d3_nsPrefix,
	    qualify: function(name) {
	      var i = name.indexOf(":"), prefix = name;
	      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	      return d3_nsPrefix.hasOwnProperty(prefix) ? {
	        space: d3_nsPrefix[prefix],
	        local: name
	      } : name;
	    }
	  };
	  d3_selectionPrototype.attr = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node();
	        name = d3.ns.qualify(name);
	        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
	      }
	      for (value in name) this.each(d3_selection_attr(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_attr(name, value));
	  };
	  function d3_selection_attr(name, value) {
	    name = d3.ns.qualify(name);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrConstant() {
	      this.setAttribute(name, value);
	    }
	    function attrConstantNS() {
	      this.setAttributeNS(name.space, name.local, value);
	    }
	    function attrFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
	    }
	    function attrFunctionNS() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
	    }
	    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
	  }
	  function d3_collapse(s) {
	    return s.trim().replace(/\s+/g, " ");
	  }
	  d3_selectionPrototype.classed = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") {
	        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
	        if (value = node.classList) {
	          while (++i < n) if (!value.contains(name[i])) return false;
	        } else {
	          value = node.getAttribute("class");
	          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
	        }
	        return true;
	      }
	      for (value in name) this.each(d3_selection_classed(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_classed(name, value));
	  };
	  function d3_selection_classedRe(name) {
	    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
	  }
	  function d3_selection_classes(name) {
	    return (name + "").trim().split(/^|\s+/);
	  }
	  function d3_selection_classed(name, value) {
	    name = d3_selection_classes(name).map(d3_selection_classedName);
	    var n = name.length;
	    function classedConstant() {
	      var i = -1;
	      while (++i < n) name[i](this, value);
	    }
	    function classedFunction() {
	      var i = -1, x = value.apply(this, arguments);
	      while (++i < n) name[i](this, x);
	    }
	    return typeof value === "function" ? classedFunction : classedConstant;
	  }
	  function d3_selection_classedName(name) {
	    var re = d3_selection_classedRe(name);
	    return function(node, value) {
	      if (c = node.classList) return value ? c.add(name) : c.remove(name);
	      var c = node.getAttribute("class") || "";
	      if (value) {
	        re.lastIndex = 0;
	        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
	      } else {
	        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
	      }
	    };
	  }
	  d3_selectionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
	        return this;
	      }
	      if (n < 2) {
	        var node = this.node();
	        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
	      }
	      priority = "";
	    }
	    return this.each(d3_selection_style(name, value, priority));
	  };
	  function d3_selection_style(name, value, priority) {
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleConstant() {
	      this.style.setProperty(name, value, priority);
	    }
	    function styleFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
	    }
	    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
	  }
	  d3_selectionPrototype.property = function(name, value) {
	    if (arguments.length < 2) {
	      if (typeof name === "string") return this.node()[name];
	      for (value in name) this.each(d3_selection_property(value, name[value]));
	      return this;
	    }
	    return this.each(d3_selection_property(name, value));
	  };
	  function d3_selection_property(name, value) {
	    function propertyNull() {
	      delete this[name];
	    }
	    function propertyConstant() {
	      this[name] = value;
	    }
	    function propertyFunction() {
	      var x = value.apply(this, arguments);
	      if (x == null) delete this[name]; else this[name] = x;
	    }
	    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
	  }
	  d3_selectionPrototype.text = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    } : value == null ? function() {
	      this.textContent = "";
	    } : function() {
	      this.textContent = value;
	    }) : this.node().textContent;
	  };
	  d3_selectionPrototype.html = function(value) {
	    return arguments.length ? this.each(typeof value === "function" ? function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    } : value == null ? function() {
	      this.innerHTML = "";
	    } : function() {
	      this.innerHTML = value;
	    }) : this.node().innerHTML;
	  };
	  d3_selectionPrototype.append = function(name) {
	    name = d3_selection_creator(name);
	    return this.select(function() {
	      return this.appendChild(name.apply(this, arguments));
	    });
	  };
	  function d3_selection_creator(name) {
	    function create() {
	      var document = this.ownerDocument, namespace = this.namespaceURI;
	      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
	    }
	    function createNS() {
	      return this.ownerDocument.createElementNS(name.space, name.local);
	    }
	    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
	  }
	  d3_selectionPrototype.insert = function(name, before) {
	    name = d3_selection_creator(name);
	    before = d3_selection_selector(before);
	    return this.select(function() {
	      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
	    });
	  };
	  d3_selectionPrototype.remove = function() {
	    return this.each(d3_selectionRemove);
	  };
	  function d3_selectionRemove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	  d3_selectionPrototype.data = function(value, key) {
	    var i = -1, n = this.length, group, node;
	    if (!arguments.length) {
	      value = new Array(n = (group = this[0]).length);
	      while (++i < n) {
	        if (node = group[i]) {
	          value[i] = node.__data__;
	        }
	      }
	      return value;
	    }
	    function bind(group, groupData) {
	      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
	      if (key) {
	        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
	        for (i = -1; ++i < n; ) {
	          if (node = group[i]) {
	            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
	              exitNodes[i] = node;
	            } else {
	              nodeByKeyValue.set(keyValue, node);
	            }
	            keyValues[i] = keyValue;
	          }
	        }
	        for (i = -1; ++i < m; ) {
	          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          } else if (node !== true) {
	            updateNodes[i] = node;
	            node.__data__ = nodeData;
	          }
	          nodeByKeyValue.set(keyValue, true);
	        }
	        for (i = -1; ++i < n; ) {
	          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
	            exitNodes[i] = group[i];
	          }
	        }
	      } else {
	        for (i = -1; ++i < n0; ) {
	          node = group[i];
	          nodeData = groupData[i];
	          if (node) {
	            node.__data__ = nodeData;
	            updateNodes[i] = node;
	          } else {
	            enterNodes[i] = d3_selection_dataNode(nodeData);
	          }
	        }
	        for (;i < m; ++i) {
	          enterNodes[i] = d3_selection_dataNode(groupData[i]);
	        }
	        for (;i < n; ++i) {
	          exitNodes[i] = group[i];
	        }
	      }
	      enterNodes.update = updateNodes;
	      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
	      enter.push(enterNodes);
	      update.push(updateNodes);
	      exit.push(exitNodes);
	    }
	    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
	    if (typeof value === "function") {
	      while (++i < n) {
	        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
	      }
	    } else {
	      while (++i < n) {
	        bind(group = this[i], value);
	      }
	    }
	    update.enter = function() {
	      return enter;
	    };
	    update.exit = function() {
	      return exit;
	    };
	    return update;
	  };
	  function d3_selection_dataNode(data) {
	    return {
	      __data__: data
	    };
	  }
	  d3_selectionPrototype.datum = function(value) {
	    return arguments.length ? this.property("__data__", value) : this.property("__data__");
	  };
	  d3_selectionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = (group = this[j]).parentNode;
	      for (var i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  function d3_selection_filter(selector) {
	    return function() {
	      return d3_selectMatches(this, selector);
	    };
	  }
	  d3_selectionPrototype.order = function() {
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	    return this;
	  };
	  d3_selectionPrototype.sort = function(comparator) {
	    comparator = d3_selection_sortComparator.apply(this, arguments);
	    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
	    return this.order();
	  };
	  function d3_selection_sortComparator(comparator) {
	    if (!arguments.length) comparator = d3_ascending;
	    return function(a, b) {
	      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
	    };
	  }
	  d3_selectionPrototype.each = function(callback) {
	    return d3_selection_each(this, function(node, i, j) {
	      callback.call(node, node.__data__, i, j);
	    });
	  };
	  function d3_selection_each(groups, callback) {
	    for (var j = 0, m = groups.length; j < m; j++) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
	        if (node = group[i]) callback(node, i, j);
	      }
	    }
	    return groups;
	  }
	  d3_selectionPrototype.call = function(callback) {
	    var args = d3_array(arguments);
	    callback.apply(args[0] = this, args);
	    return this;
	  };
	  d3_selectionPrototype.empty = function() {
	    return !this.node();
	  };
	  d3_selectionPrototype.node = function() {
	    for (var j = 0, m = this.length; j < m; j++) {
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	    return null;
	  };
	  d3_selectionPrototype.size = function() {
	    var n = 0;
	    d3_selection_each(this, function() {
	      ++n;
	    });
	    return n;
	  };
	  function d3_selection_enter(selection) {
	    d3_subclass(selection, d3_selection_enterPrototype);
	    return selection;
	  }
	  var d3_selection_enterPrototype = [];
	  d3.selection.enter = d3_selection_enter;
	  d3.selection.enter.prototype = d3_selection_enterPrototype;
	  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
	  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
	  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
	  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
	  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
	  d3_selection_enterPrototype.select = function(selector) {
	    var subgroups = [], subgroup, subnode, upgroup, group, node;
	    for (var j = -1, m = this.length; ++j < m; ) {
	      upgroup = (group = this[j]).update;
	      subgroups.push(subgroup = []);
	      subgroup.parentNode = group.parentNode;
	      for (var i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
	          subnode.__data__ = node.__data__;
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_selection(subgroups);
	  };
	  d3_selection_enterPrototype.insert = function(name, before) {
	    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
	    return d3_selectionPrototype.insert.call(this, name, before);
	  };
	  function d3_selection_enterInsertBefore(enter) {
	    var i0, j0;
	    return function(d, i, j) {
	      var group = enter[j].update, n = group.length, node;
	      if (j != j0) j0 = j, i0 = 0;
	      if (i >= i0) i0 = i + 1;
	      while (!(node = group[i0]) && ++i0 < n) ;
	      return node;
	    };
	  }
	  d3.select = function(node) {
	    var group;
	    if (typeof node === "string") {
	      group = [ d3_select(node, d3_document) ];
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = [ node ];
	      group.parentNode = d3_documentElement(node);
	    }
	    return d3_selection([ group ]);
	  };
	  d3.selectAll = function(nodes) {
	    var group;
	    if (typeof nodes === "string") {
	      group = d3_array(d3_selectAll(nodes, d3_document));
	      group.parentNode = d3_document.documentElement;
	    } else {
	      group = d3_array(nodes);
	      group.parentNode = null;
	    }
	    return d3_selection([ group ]);
	  };
	  d3_selectionPrototype.on = function(type, listener, capture) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof type !== "string") {
	        if (n < 2) listener = false;
	        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
	        return this;
	      }
	      if (n < 2) return (n = this.node()["__on" + type]) && n._;
	      capture = false;
	    }
	    return this.each(d3_selection_on(type, listener, capture));
	  };
	  function d3_selection_on(type, listener, capture) {
	    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
	    if (i > 0) type = type.slice(0, i);
	    var filter = d3_selection_onFilters.get(type);
	    if (filter) type = filter, wrap = d3_selection_onFilter;
	    function onRemove() {
	      var l = this[name];
	      if (l) {
	        this.removeEventListener(type, l, l.$);
	        delete this[name];
	      }
	    }
	    function onAdd() {
	      var l = wrap(listener, d3_array(arguments));
	      onRemove.call(this);
	      this.addEventListener(type, this[name] = l, l.$ = capture);
	      l._ = listener;
	    }
	    function removeAll() {
	      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
	      for (var name in this) {
	        if (match = name.match(re)) {
	          var l = this[name];
	          this.removeEventListener(match[1], l, l.$);
	          delete this[name];
	        }
	      }
	    }
	    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
	  }
	  var d3_selection_onFilters = d3.map({
	    mouseenter: "mouseover",
	    mouseleave: "mouseout"
	  });
	  if (d3_document) {
	    d3_selection_onFilters.forEach(function(k) {
	      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
	    });
	  }
	  function d3_selection_onListener(listener, argumentz) {
	    return function(e) {
	      var o = d3.event;
	      d3.event = e;
	      argumentz[0] = this.__data__;
	      try {
	        listener.apply(this, argumentz);
	      } finally {
	        d3.event = o;
	      }
	    };
	  }
	  function d3_selection_onFilter(listener, argumentz) {
	    var l = d3_selection_onListener(listener, argumentz);
	    return function(e) {
	      var target = this, related = e.relatedTarget;
	      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
	        l.call(target, e);
	      }
	    };
	  }
	  var d3_event_dragSelect, d3_event_dragId = 0;
	  function d3_event_dragSuppress(node) {
	    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
	    if (d3_event_dragSelect == null) {
	      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
	    }
	    if (d3_event_dragSelect) {
	      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
	      style[d3_event_dragSelect] = "none";
	    }
	    return function(suppressClick) {
	      w.on(name, null);
	      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
	      if (suppressClick) {
	        var off = function() {
	          w.on(click, null);
	        };
	        w.on(click, function() {
	          d3_eventPreventDefault();
	          off();
	        }, true);
	        setTimeout(off, 0);
	      }
	    };
	  }
	  d3.mouse = function(container) {
	    return d3_mousePoint(container, d3_eventSource());
	  };
	  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
	  function d3_mousePoint(container, e) {
	    if (e.changedTouches) e = e.changedTouches[0];
	    var svg = container.ownerSVGElement || container;
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      if (d3_mouse_bug44083 < 0) {
	        var window = d3_window(container);
	        if (window.scrollX || window.scrollY) {
	          svg = d3.select("body").append("svg").style({
	            position: "absolute",
	            top: 0,
	            left: 0,
	            margin: 0,
	            padding: 0,
	            border: "none"
	          }, "important");
	          var ctm = svg[0][0].getScreenCTM();
	          d3_mouse_bug44083 = !(ctm.f || ctm.e);
	          svg.remove();
	        }
	      }
	      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
	      point.y = e.clientY;
	      point = point.matrixTransform(container.getScreenCTM().inverse());
	      return [ point.x, point.y ];
	    }
	    var rect = container.getBoundingClientRect();
	    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
	  }
	  d3.touch = function(container, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
	    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return d3_mousePoint(container, touch);
	      }
	    }
	  };
	  d3.behavior.drag = function() {
	    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
	    function drag() {
	      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
	    }
	    function dragstart(id, position, subject, move, end) {
	      return function() {
	        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
	        if (origin) {
	          dragOffset = origin.apply(that, arguments);
	          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
	        } else {
	          dragOffset = [ 0, 0 ];
	        }
	        dispatch({
	          type: "dragstart"
	        });
	        function moved() {
	          var position1 = position(parent, dragId), dx, dy;
	          if (!position1) return;
	          dx = position1[0] - position0[0];
	          dy = position1[1] - position0[1];
	          dragged |= dx | dy;
	          position0 = position1;
	          dispatch({
	            type: "drag",
	            x: position1[0] + dragOffset[0],
	            y: position1[1] + dragOffset[1],
	            dx: dx,
	            dy: dy
	          });
	        }
	        function ended() {
	          if (!position(parent, dragId)) return;
	          dragSubject.on(move + dragName, null).on(end + dragName, null);
	          dragRestore(dragged);
	          dispatch({
	            type: "dragend"
	          });
	        }
	      };
	    }
	    drag.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return drag;
	    };
	    return d3.rebind(drag, event, "on");
	  };
	  function d3_behavior_dragTouchId() {
	    return d3.event.changedTouches[0].identifier;
	  }
	  d3.touches = function(container, touches) {
	    if (arguments.length < 2) touches = d3_eventSource().touches;
	    return touches ? d3_array(touches).map(function(touch) {
	      var point = d3_mousePoint(container, touch);
	      point.identifier = touch.identifier;
	      return point;
	    }) : [];
	  };
	  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
	  function d3_sgn(x) {
	    return x > 0 ? 1 : x < 0 ? -1 : 0;
	  }
	  function d3_cross2d(a, b, c) {
	    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
	  }
	  function d3_acos(x) {
	    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
	  }
	  function d3_asin(x) {
	    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
	  }
	  function d3_sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	  function d3_cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	  function d3_tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	  function d3_haversin(x) {
	    return (x = Math.sin(x / 2)) * x;
	  }
	  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
	  d3.interpolateZoom = function(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
	    if (d2 < ε2) {
	      S = Math.log(w1 / w0) / ρ;
	      i = function(t) {
	        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
	      };
	    } else {
	      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / ρ;
	      i = function(t) {
	        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
	        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
	      };
	    }
	    i.duration = S * 1e3;
	    return i;
	  };
	  d3.behavior.zoom = function() {
	    var view = {
	      x: 0,
	      y: 0,
	      k: 1
	    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
	    if (!d3_behavior_zoomWheel) {
	      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
	      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
	        return d3.event.wheelDelta;
	      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
	        return -d3.event.detail;
	      }, "MozMousePixelScroll");
	    }
	    function zoom(g) {
	      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
	    }
	    zoom.event = function(g) {
	      g.each(function() {
	        var dispatch = event.of(this, arguments), view1 = view;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.zoom", function() {
	            view = this.__chart__ || {
	              x: 0,
	              y: 0,
	              k: 1
	            };
	            zoomstarted(dispatch);
	          }).tween("zoom:zoom", function() {
	            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
	            return function(t) {
	              var l = i(t), k = dx / l[2];
	              this.__chart__ = view = {
	                x: cx - l[0] * k,
	                y: cy - l[1] * k,
	                k: k
	              };
	              zoomed(dispatch);
	            };
	          }).each("interrupt.zoom", function() {
	            zoomended(dispatch);
	          }).each("end.zoom", function() {
	            zoomended(dispatch);
	          });
	        } else {
	          this.__chart__ = view;
	          zoomstarted(dispatch);
	          zoomed(dispatch);
	          zoomended(dispatch);
	        }
	      });
	    };
	    zoom.translate = function(_) {
	      if (!arguments.length) return [ view.x, view.y ];
	      view = {
	        x: +_[0],
	        y: +_[1],
	        k: view.k
	      };
	      rescale();
	      return zoom;
	    };
	    zoom.scale = function(_) {
	      if (!arguments.length) return view.k;
	      view = {
	        x: view.x,
	        y: view.y,
	        k: null
	      };
	      scaleTo(+_);
	      rescale();
	      return zoom;
	    };
	    zoom.scaleExtent = function(_) {
	      if (!arguments.length) return scaleExtent;
	      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.center = function(_) {
	      if (!arguments.length) return center;
	      center = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.size = function(_) {
	      if (!arguments.length) return size;
	      size = _ && [ +_[0], +_[1] ];
	      return zoom;
	    };
	    zoom.duration = function(_) {
	      if (!arguments.length) return duration;
	      duration = +_;
	      return zoom;
	    };
	    zoom.x = function(z) {
	      if (!arguments.length) return x1;
	      x1 = z;
	      x0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    zoom.y = function(z) {
	      if (!arguments.length) return y1;
	      y1 = z;
	      y0 = z.copy();
	      view = {
	        x: 0,
	        y: 0,
	        k: 1
	      };
	      return zoom;
	    };
	    function location(p) {
	      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
	    }
	    function point(l) {
	      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
	    }
	    function scaleTo(s) {
	      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
	    }
	    function translateTo(p, l) {
	      l = point(l);
	      view.x += p[0] - l[0];
	      view.y += p[1] - l[1];
	    }
	    function zoomTo(that, p, l, k) {
	      that.__chart__ = {
	        x: view.x,
	        y: view.y,
	        k: view.k
	      };
	      scaleTo(Math.pow(2, k));
	      translateTo(center0 = p, l);
	      that = d3.select(that);
	      if (duration > 0) that = that.transition().duration(duration);
	      that.call(zoom.event);
	    }
	    function rescale() {
	      if (x1) x1.domain(x0.range().map(function(x) {
	        return (x - view.x) / view.k;
	      }).map(x0.invert));
	      if (y1) y1.domain(y0.range().map(function(y) {
	        return (y - view.y) / view.k;
	      }).map(y0.invert));
	    }
	    function zoomstarted(dispatch) {
	      if (!zooming++) dispatch({
	        type: "zoomstart"
	      });
	    }
	    function zoomed(dispatch) {
	      rescale();
	      dispatch({
	        type: "zoom",
	        scale: view.k,
	        translate: [ view.x, view.y ]
	      });
	    }
	    function zoomended(dispatch) {
	      if (!--zooming) dispatch({
	        type: "zoomend"
	      }), center0 = null;
	    }
	    function mousedowned() {
	      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
	      d3_selection_interrupt.call(that);
	      zoomstarted(dispatch);
	      function moved() {
	        dragged = 1;
	        translateTo(d3.mouse(that), location0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        subject.on(mousemove, null).on(mouseup, null);
	        dragRestore(dragged);
	        zoomended(dispatch);
	      }
	    }
	    function touchstarted() {
	      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
	      started();
	      zoomstarted(dispatch);
	      subject.on(mousedown, null).on(touchstart, started);
	      function relocate() {
	        var touches = d3.touches(that);
	        scale0 = view.k;
	        touches.forEach(function(t) {
	          if (t.identifier in locations0) locations0[t.identifier] = location(t);
	        });
	        return touches;
	      }
	      function started() {
	        var target = d3.event.target;
	        d3.select(target).on(touchmove, moved).on(touchend, ended);
	        targets.push(target);
	        var changed = d3.event.changedTouches;
	        for (var i = 0, n = changed.length; i < n; ++i) {
	          locations0[changed[i].identifier] = null;
	        }
	        var touches = relocate(), now = Date.now();
	        if (touches.length === 1) {
	          if (now - touchtime < 500) {
	            var p = touches[0];
	            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
	            d3_eventPreventDefault();
	          }
	          touchtime = now;
	        } else if (touches.length > 1) {
	          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
	          distance0 = dx * dx + dy * dy;
	        }
	      }
	      function moved() {
	        var touches = d3.touches(that), p0, l0, p1, l1;
	        d3_selection_interrupt.call(that);
	        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
	          p1 = touches[i];
	          if (l1 = locations0[p1.identifier]) {
	            if (l0) break;
	            p0 = p1, l0 = l1;
	          }
	        }
	        if (l1) {
	          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
	          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
	          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
	          scaleTo(scale1 * scale0);
	        }
	        touchtime = null;
	        translateTo(p0, l0);
	        zoomed(dispatch);
	      }
	      function ended() {
	        if (d3.event.touches.length) {
	          var changed = d3.event.changedTouches;
	          for (var i = 0, n = changed.length; i < n; ++i) {
	            delete locations0[changed[i].identifier];
	          }
	          for (var identifier in locations0) {
	            return void relocate();
	          }
	        }
	        d3.selectAll(targets).on(zoomName, null);
	        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
	        dragRestore();
	        zoomended(dispatch);
	      }
	    }
	    function mousewheeled() {
	      var dispatch = event.of(this, arguments);
	      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
	      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
	      mousewheelTimer = setTimeout(function() {
	        mousewheelTimer = null;
	        zoomended(dispatch);
	      }, 50);
	      d3_eventPreventDefault();
	      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
	      translateTo(center0, translate0);
	      zoomed(dispatch);
	    }
	    function dblclicked() {
	      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
	      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
	    }
	    return d3.rebind(zoom, event, "on");
	  };
	  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
	  d3.color = d3_color;
	  function d3_color() {}
	  d3_color.prototype.toString = function() {
	    return this.rgb() + "";
	  };
	  d3.hsl = d3_hsl;
	  function d3_hsl(h, s, l) {
	    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
	  }
	  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
	  d3_hslPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, this.l / k);
	  };
	  d3_hslPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_hsl(this.h, this.s, k * this.l);
	  };
	  d3_hslPrototype.rgb = function() {
	    return d3_hsl_rgb(this.h, this.s, this.l);
	  };
	  function d3_hsl_rgb(h, s, l) {
	    var m1, m2;
	    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
	    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
	    l = l < 0 ? 0 : l > 1 ? 1 : l;
	    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
	    m1 = 2 * l - m2;
	    function v(h) {
	      if (h > 360) h -= 360; else if (h < 0) h += 360;
	      if (h < 60) return m1 + (m2 - m1) * h / 60;
	      if (h < 180) return m2;
	      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
	      return m1;
	    }
	    function vv(h) {
	      return Math.round(v(h) * 255);
	    }
	    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
	  }
	  d3.hcl = d3_hcl;
	  function d3_hcl(h, c, l) {
	    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
	  }
	  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
	  d3_hclPrototype.brighter = function(k) {
	    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.darker = function(k) {
	    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
	  };
	  d3_hclPrototype.rgb = function() {
	    return d3_hcl_lab(this.h, this.c, this.l).rgb();
	  };
	  function d3_hcl_lab(h, c, l) {
	    if (isNaN(h)) h = 0;
	    if (isNaN(c)) c = 0;
	    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
	  }
	  d3.lab = d3_lab;
	  function d3_lab(l, a, b) {
	    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
	  }
	  var d3_lab_K = 18;
	  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
	  var d3_labPrototype = d3_lab.prototype = new d3_color();
	  d3_labPrototype.brighter = function(k) {
	    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.darker = function(k) {
	    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
	  };
	  d3_labPrototype.rgb = function() {
	    return d3_lab_rgb(this.l, this.a, this.b);
	  };
	  function d3_lab_rgb(l, a, b) {
	    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
	    x = d3_lab_xyz(x) * d3_lab_X;
	    y = d3_lab_xyz(y) * d3_lab_Y;
	    z = d3_lab_xyz(z) * d3_lab_Z;
	    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
	  }
	  function d3_lab_hcl(l, a, b) {
	    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
	  }
	  function d3_lab_xyz(x) {
	    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
	  }
	  function d3_xyz_lab(x) {
	    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
	  }
	  function d3_xyz_rgb(r) {
	    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
	  }
	  d3.rgb = d3_rgb;
	  function d3_rgb(r, g, b) {
	    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
	  }
	  function d3_rgbNumber(value) {
	    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
	  }
	  function d3_rgbString(value) {
	    return d3_rgbNumber(value) + "";
	  }
	  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
	  d3_rgbPrototype.brighter = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    var r = this.r, g = this.g, b = this.b, i = 30;
	    if (!r && !g && !b) return new d3_rgb(i, i, i);
	    if (r && r < i) r = i;
	    if (g && g < i) g = i;
	    if (b && b < i) b = i;
	    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
	  };
	  d3_rgbPrototype.darker = function(k) {
	    k = Math.pow(.7, arguments.length ? k : 1);
	    return new d3_rgb(k * this.r, k * this.g, k * this.b);
	  };
	  d3_rgbPrototype.hsl = function() {
	    return d3_rgb_hsl(this.r, this.g, this.b);
	  };
	  d3_rgbPrototype.toString = function() {
	    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
	  };
	  function d3_rgb_hex(v) {
	    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
	  }
	  function d3_rgb_parse(format, rgb, hsl) {
	    var r = 0, g = 0, b = 0, m1, m2, color;
	    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
	    if (m1) {
	      m2 = m1[2].split(",");
	      switch (m1[1]) {
	       case "hsl":
	        {
	          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
	        }
	
	       case "rgb":
	        {
	          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
	        }
	      }
	    }
	    if (color = d3_rgb_names.get(format)) {
	      return rgb(color.r, color.g, color.b);
	    }
	    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
	      if (format.length === 4) {
	        r = (color & 3840) >> 4;
	        r = r >> 4 | r;
	        g = color & 240;
	        g = g >> 4 | g;
	        b = color & 15;
	        b = b << 4 | b;
	      } else if (format.length === 7) {
	        r = (color & 16711680) >> 16;
	        g = (color & 65280) >> 8;
	        b = color & 255;
	      }
	    }
	    return rgb(r, g, b);
	  }
	  function d3_rgb_hsl(r, g, b) {
	    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
	    if (d) {
	      s = l < .5 ? d / (max + min) : d / (2 - max - min);
	      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
	      h *= 60;
	    } else {
	      h = NaN;
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new d3_hsl(h, s, l);
	  }
	  function d3_rgb_lab(r, g, b) {
	    r = d3_rgb_xyz(r);
	    g = d3_rgb_xyz(g);
	    b = d3_rgb_xyz(b);
	    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
	    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
	  }
	  function d3_rgb_xyz(r) {
	    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
	  }
	  function d3_rgb_parseNumber(c) {
	    var f = parseFloat(c);
	    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
	  }
	  var d3_rgb_names = d3.map({
	    aliceblue: 15792383,
	    antiquewhite: 16444375,
	    aqua: 65535,
	    aquamarine: 8388564,
	    azure: 15794175,
	    beige: 16119260,
	    bisque: 16770244,
	    black: 0,
	    blanchedalmond: 16772045,
	    blue: 255,
	    blueviolet: 9055202,
	    brown: 10824234,
	    burlywood: 14596231,
	    cadetblue: 6266528,
	    chartreuse: 8388352,
	    chocolate: 13789470,
	    coral: 16744272,
	    cornflowerblue: 6591981,
	    cornsilk: 16775388,
	    crimson: 14423100,
	    cyan: 65535,
	    darkblue: 139,
	    darkcyan: 35723,
	    darkgoldenrod: 12092939,
	    darkgray: 11119017,
	    darkgreen: 25600,
	    darkgrey: 11119017,
	    darkkhaki: 12433259,
	    darkmagenta: 9109643,
	    darkolivegreen: 5597999,
	    darkorange: 16747520,
	    darkorchid: 10040012,
	    darkred: 9109504,
	    darksalmon: 15308410,
	    darkseagreen: 9419919,
	    darkslateblue: 4734347,
	    darkslategray: 3100495,
	    darkslategrey: 3100495,
	    darkturquoise: 52945,
	    darkviolet: 9699539,
	    deeppink: 16716947,
	    deepskyblue: 49151,
	    dimgray: 6908265,
	    dimgrey: 6908265,
	    dodgerblue: 2003199,
	    firebrick: 11674146,
	    floralwhite: 16775920,
	    forestgreen: 2263842,
	    fuchsia: 16711935,
	    gainsboro: 14474460,
	    ghostwhite: 16316671,
	    gold: 16766720,
	    goldenrod: 14329120,
	    gray: 8421504,
	    green: 32768,
	    greenyellow: 11403055,
	    grey: 8421504,
	    honeydew: 15794160,
	    hotpink: 16738740,
	    indianred: 13458524,
	    indigo: 4915330,
	    ivory: 16777200,
	    khaki: 15787660,
	    lavender: 15132410,
	    lavenderblush: 16773365,
	    lawngreen: 8190976,
	    lemonchiffon: 16775885,
	    lightblue: 11393254,
	    lightcoral: 15761536,
	    lightcyan: 14745599,
	    lightgoldenrodyellow: 16448210,
	    lightgray: 13882323,
	    lightgreen: 9498256,
	    lightgrey: 13882323,
	    lightpink: 16758465,
	    lightsalmon: 16752762,
	    lightseagreen: 2142890,
	    lightskyblue: 8900346,
	    lightslategray: 7833753,
	    lightslategrey: 7833753,
	    lightsteelblue: 11584734,
	    lightyellow: 16777184,
	    lime: 65280,
	    limegreen: 3329330,
	    linen: 16445670,
	    magenta: 16711935,
	    maroon: 8388608,
	    mediumaquamarine: 6737322,
	    mediumblue: 205,
	    mediumorchid: 12211667,
	    mediumpurple: 9662683,
	    mediumseagreen: 3978097,
	    mediumslateblue: 8087790,
	    mediumspringgreen: 64154,
	    mediumturquoise: 4772300,
	    mediumvioletred: 13047173,
	    midnightblue: 1644912,
	    mintcream: 16121850,
	    mistyrose: 16770273,
	    moccasin: 16770229,
	    navajowhite: 16768685,
	    navy: 128,
	    oldlace: 16643558,
	    olive: 8421376,
	    olivedrab: 7048739,
	    orange: 16753920,
	    orangered: 16729344,
	    orchid: 14315734,
	    palegoldenrod: 15657130,
	    palegreen: 10025880,
	    paleturquoise: 11529966,
	    palevioletred: 14381203,
	    papayawhip: 16773077,
	    peachpuff: 16767673,
	    peru: 13468991,
	    pink: 16761035,
	    plum: 14524637,
	    powderblue: 11591910,
	    purple: 8388736,
	    rebeccapurple: 6697881,
	    red: 16711680,
	    rosybrown: 12357519,
	    royalblue: 4286945,
	    saddlebrown: 9127187,
	    salmon: 16416882,
	    sandybrown: 16032864,
	    seagreen: 3050327,
	    seashell: 16774638,
	    sienna: 10506797,
	    silver: 12632256,
	    skyblue: 8900331,
	    slateblue: 6970061,
	    slategray: 7372944,
	    slategrey: 7372944,
	    snow: 16775930,
	    springgreen: 65407,
	    steelblue: 4620980,
	    tan: 13808780,
	    teal: 32896,
	    thistle: 14204888,
	    tomato: 16737095,
	    turquoise: 4251856,
	    violet: 15631086,
	    wheat: 16113331,
	    white: 16777215,
	    whitesmoke: 16119285,
	    yellow: 16776960,
	    yellowgreen: 10145074
	  });
	  d3_rgb_names.forEach(function(key, value) {
	    d3_rgb_names.set(key, d3_rgbNumber(value));
	  });
	  function d3_functor(v) {
	    return typeof v === "function" ? v : function() {
	      return v;
	    };
	  }
	  d3.functor = d3_functor;
	  d3.xhr = d3_xhrType(d3_identity);
	  function d3_xhrType(response) {
	    return function(url, mimeType, callback) {
	      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
	      mimeType = null;
	      return d3_xhr(url, mimeType, response, callback);
	    };
	  }
	  function d3_xhr(url, mimeType, response, callback) {
	    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
	    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
	    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
	      request.readyState > 3 && respond();
	    };
	    function respond() {
	      var status = request.status, result;
	      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
	        try {
	          result = response.call(xhr, request);
	        } catch (e) {
	          dispatch.error.call(xhr, e);
	          return;
	        }
	        dispatch.load.call(xhr, result);
	      } else {
	        dispatch.error.call(xhr, request);
	      }
	    }
	    request.onprogress = function(event) {
	      var o = d3.event;
	      d3.event = event;
	      try {
	        dispatch.progress.call(xhr, request);
	      } finally {
	        d3.event = o;
	      }
	    };
	    xhr.header = function(name, value) {
	      name = (name + "").toLowerCase();
	      if (arguments.length < 2) return headers[name];
	      if (value == null) delete headers[name]; else headers[name] = value + "";
	      return xhr;
	    };
	    xhr.mimeType = function(value) {
	      if (!arguments.length) return mimeType;
	      mimeType = value == null ? null : value + "";
	      return xhr;
	    };
	    xhr.responseType = function(value) {
	      if (!arguments.length) return responseType;
	      responseType = value;
	      return xhr;
	    };
	    xhr.response = function(value) {
	      response = value;
	      return xhr;
	    };
	    [ "get", "post" ].forEach(function(method) {
	      xhr[method] = function() {
	        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
	      };
	    });
	    xhr.send = function(method, data, callback) {
	      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
	      request.open(method, url, true);
	      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
	      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
	      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
	      if (responseType != null) request.responseType = responseType;
	      if (callback != null) xhr.on("error", callback).on("load", function(request) {
	        callback(null, request);
	      });
	      dispatch.beforesend.call(xhr, request);
	      request.send(data == null ? null : data);
	      return xhr;
	    };
	    xhr.abort = function() {
	      request.abort();
	      return xhr;
	    };
	    d3.rebind(xhr, dispatch, "on");
	    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
	  }
	  function d3_xhr_fixCallback(callback) {
	    return callback.length === 1 ? function(error, request) {
	      callback(error == null ? request : null);
	    } : callback;
	  }
	  function d3_xhrHasResponse(request) {
	    var type = request.responseType;
	    return type && type !== "text" ? request.response : request.responseText;
	  }
	  d3.dsv = function(delimiter, mimeType) {
	    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
	    function dsv(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
	      xhr.row = function(_) {
	        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
	      };
	      return xhr;
	    }
	    function response(request) {
	      return dsv.parse(request.responseText);
	    }
	    function typedResponse(f) {
	      return function(request) {
	        return dsv.parse(request.responseText, f);
	      };
	    }
	    dsv.parse = function(text, f) {
	      var o;
	      return dsv.parseRows(text, function(row, i) {
	        if (o) return o(row, i - 1);
	        var a = new Function("d", "return {" + row.map(function(name, i) {
	          return JSON.stringify(name) + ": d[" + i + "]";
	        }).join(",") + "}");
	        o = f ? function(row, i) {
	          return f(a(row), i);
	        } : a;
	      });
	    };
	    dsv.parseRows = function(text, f) {
	      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
	      function token() {
	        if (I >= N) return EOF;
	        if (eol) return eol = false, EOL;
	        var j = I;
	        if (text.charCodeAt(j) === 34) {
	          var i = j;
	          while (i++ < N) {
	            if (text.charCodeAt(i) === 34) {
	              if (text.charCodeAt(i + 1) !== 34) break;
	              ++i;
	            }
	          }
	          I = i + 2;
	          var c = text.charCodeAt(i + 1);
	          if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(i + 2) === 10) ++I;
	          } else if (c === 10) {
	            eol = true;
	          }
	          return text.slice(j + 1, i).replace(/""/g, '"');
	        }
	        while (I < N) {
	          var c = text.charCodeAt(I++), k = 1;
	          if (c === 10) eol = true; else if (c === 13) {
	            eol = true;
	            if (text.charCodeAt(I) === 10) ++I, ++k;
	          } else if (c !== delimiterCode) continue;
	          return text.slice(j, I - k);
	        }
	        return text.slice(j);
	      }
	      while ((t = token()) !== EOF) {
	        var a = [];
	        while (t !== EOL && t !== EOF) {
	          a.push(t);
	          t = token();
	        }
	        if (f && (a = f(a, n++)) == null) continue;
	        rows.push(a);
	      }
	      return rows;
	    };
	    dsv.format = function(rows) {
	      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
	      var fieldSet = new d3_Set(), fields = [];
	      rows.forEach(function(row) {
	        for (var field in row) {
	          if (!fieldSet.has(field)) {
	            fields.push(fieldSet.add(field));
	          }
	        }
	      });
	      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
	        return fields.map(function(field) {
	          return formatValue(row[field]);
	        }).join(delimiter);
	      })).join("\n");
	    };
	    dsv.formatRows = function(rows) {
	      return rows.map(formatRow).join("\n");
	    };
	    function formatRow(row) {
	      return row.map(formatValue).join(delimiter);
	    }
	    function formatValue(text) {
	      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
	    }
	    return dsv;
	  };
	  d3.csv = d3.dsv(",", "text/csv");
	  d3.tsv = d3.dsv("	", "text/tab-separated-values");
	  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
	    setTimeout(callback, 17);
	  };
	  d3.timer = function() {
	    d3_timer.apply(this, arguments);
	  };
	  function d3_timer(callback, delay, then) {
	    var n = arguments.length;
	    if (n < 2) delay = 0;
	    if (n < 3) then = Date.now();
	    var time = then + delay, timer = {
	      c: callback,
	      t: time,
	      n: null
	    };
	    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
	    d3_timer_queueTail = timer;
	    if (!d3_timer_interval) {
	      d3_timer_timeout = clearTimeout(d3_timer_timeout);
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	    return timer;
	  }
	  function d3_timer_step() {
	    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
	    if (delay > 24) {
	      if (isFinite(delay)) {
	        clearTimeout(d3_timer_timeout);
	        d3_timer_timeout = setTimeout(d3_timer_step, delay);
	      }
	      d3_timer_interval = 0;
	    } else {
	      d3_timer_interval = 1;
	      d3_timer_frame(d3_timer_step);
	    }
	  }
	  d3.timer.flush = function() {
	    d3_timer_mark();
	    d3_timer_sweep();
	  };
	  function d3_timer_mark() {
	    var now = Date.now(), timer = d3_timer_queueHead;
	    while (timer) {
	      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
	      timer = timer.n;
	    }
	    return now;
	  }
	  function d3_timer_sweep() {
	    var t0, t1 = d3_timer_queueHead, time = Infinity;
	    while (t1) {
	      if (t1.c) {
	        if (t1.t < time) time = t1.t;
	        t1 = (t0 = t1).n;
	      } else {
	        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
	      }
	    }
	    d3_timer_queueTail = t0;
	    return time;
	  }
	  function d3_format_precision(x, p) {
	    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
	  }
	  d3.round = function(x, n) {
	    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
	  };
	  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
	  d3.formatPrefix = function(value, precision) {
	    var i = 0;
	    if (value = +value) {
	      if (value < 0) value *= -1;
	      if (precision) value = d3.round(value, d3_format_precision(value, precision));
	      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
	      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
	    }
	    return d3_formatPrefixes[8 + i / 3];
	  };
	  function d3_formatPrefix(d, i) {
	    var k = Math.pow(10, abs(8 - i) * 3);
	    return {
	      scale: i > 8 ? function(d) {
	        return d / k;
	      } : function(d) {
	        return d * k;
	      },
	      symbol: d
	    };
	  }
	  function d3_locale_numberFormat(locale) {
	    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
	      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = locale_grouping[j = (j + 1) % locale_grouping.length];
	      }
	      return t.reverse().join(locale_thousands);
	    } : d3_identity;
	    return function(specifier) {
	      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
	      if (precision) precision = +precision.substring(1);
	      if (zfill || fill === "0" && align === "=") {
	        zfill = fill = "0";
	        align = "=";
	      }
	      switch (type) {
	       case "n":
	        comma = true;
	        type = "g";
	        break;
	
	       case "%":
	        scale = 100;
	        suffix = "%";
	        type = "f";
	        break;
	
	       case "p":
	        scale = 100;
	        suffix = "%";
	        type = "r";
	        break;
	
	       case "b":
	       case "o":
	       case "x":
	       case "X":
	        if (symbol === "#") prefix = "0" + type.toLowerCase();
	
	       case "c":
	        exponent = false;
	
	       case "d":
	        integer = true;
	        precision = 0;
	        break;
	
	       case "s":
	        scale = -1;
	        type = "r";
	        break;
	      }
	      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
	      if (type == "r" && !precision) type = "g";
	      if (precision != null) {
	        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
	      }
	      type = d3_format_types.get(type) || d3_format_typeDefault;
	      var zcomma = zfill && comma;
	      return function(value) {
	        var fullSuffix = suffix;
	        if (integer && value % 1) return "";
	        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
	        if (scale < 0) {
	          var unit = d3.formatPrefix(value, precision);
	          value = unit.scale(value);
	          fullSuffix = unit.symbol + suffix;
	        } else {
	          value *= scale;
	        }
	        value = type(value, precision);
	        var i = value.lastIndexOf("."), before, after;
	        if (i < 0) {
	          var j = exponent ? value.lastIndexOf("e") : -1;
	          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
	        } else {
	          before = value.substring(0, i);
	          after = locale_decimal + value.substring(i + 1);
	        }
	        if (!zfill && comma) before = formatGroup(before, Infinity);
	        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
	        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
	        negative += prefix;
	        value = before + after;
	        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
	      };
	    };
	  }
	  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
	  var d3_format_types = d3.map({
	    b: function(x) {
	      return x.toString(2);
	    },
	    c: function(x) {
	      return String.fromCharCode(x);
	    },
	    o: function(x) {
	      return x.toString(8);
	    },
	    x: function(x) {
	      return x.toString(16);
	    },
	    X: function(x) {
	      return x.toString(16).toUpperCase();
	    },
	    g: function(x, p) {
	      return x.toPrecision(p);
	    },
	    e: function(x, p) {
	      return x.toExponential(p);
	    },
	    f: function(x, p) {
	      return x.toFixed(p);
	    },
	    r: function(x, p) {
	      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
	    }
	  });
	  function d3_format_typeDefault(x) {
	    return x + "";
	  }
	  var d3_time = d3.time = {}, d3_date = Date;
	  function d3_date_utc() {
	    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
	  }
	  d3_date_utc.prototype = {
	    getDate: function() {
	      return this._.getUTCDate();
	    },
	    getDay: function() {
	      return this._.getUTCDay();
	    },
	    getFullYear: function() {
	      return this._.getUTCFullYear();
	    },
	    getHours: function() {
	      return this._.getUTCHours();
	    },
	    getMilliseconds: function() {
	      return this._.getUTCMilliseconds();
	    },
	    getMinutes: function() {
	      return this._.getUTCMinutes();
	    },
	    getMonth: function() {
	      return this._.getUTCMonth();
	    },
	    getSeconds: function() {
	      return this._.getUTCSeconds();
	    },
	    getTime: function() {
	      return this._.getTime();
	    },
	    getTimezoneOffset: function() {
	      return 0;
	    },
	    valueOf: function() {
	      return this._.valueOf();
	    },
	    setDate: function() {
	      d3_time_prototype.setUTCDate.apply(this._, arguments);
	    },
	    setDay: function() {
	      d3_time_prototype.setUTCDay.apply(this._, arguments);
	    },
	    setFullYear: function() {
	      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
	    },
	    setHours: function() {
	      d3_time_prototype.setUTCHours.apply(this._, arguments);
	    },
	    setMilliseconds: function() {
	      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
	    },
	    setMinutes: function() {
	      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
	    },
	    setMonth: function() {
	      d3_time_prototype.setUTCMonth.apply(this._, arguments);
	    },
	    setSeconds: function() {
	      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
	    },
	    setTime: function() {
	      d3_time_prototype.setTime.apply(this._, arguments);
	    }
	  };
	  var d3_time_prototype = Date.prototype;
	  function d3_time_interval(local, step, number) {
	    function round(date) {
	      var d0 = local(date), d1 = offset(d0, 1);
	      return date - d0 < d1 - date ? d0 : d1;
	    }
	    function ceil(date) {
	      step(date = local(new d3_date(date - 1)), 1);
	      return date;
	    }
	    function offset(date, k) {
	      step(date = new d3_date(+date), k);
	      return date;
	    }
	    function range(t0, t1, dt) {
	      var time = ceil(t0), times = [];
	      if (dt > 1) {
	        while (time < t1) {
	          if (!(number(time) % dt)) times.push(new Date(+time));
	          step(time, 1);
	        }
	      } else {
	        while (time < t1) times.push(new Date(+time)), step(time, 1);
	      }
	      return times;
	    }
	    function range_utc(t0, t1, dt) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = t0;
	        return range(utc, t1, dt);
	      } finally {
	        d3_date = Date;
	      }
	    }
	    local.floor = local;
	    local.round = round;
	    local.ceil = ceil;
	    local.offset = offset;
	    local.range = range;
	    var utc = local.utc = d3_time_interval_utc(local);
	    utc.floor = utc;
	    utc.round = d3_time_interval_utc(round);
	    utc.ceil = d3_time_interval_utc(ceil);
	    utc.offset = d3_time_interval_utc(offset);
	    utc.range = range_utc;
	    return local;
	  }
	  function d3_time_interval_utc(method) {
	    return function(date, k) {
	      try {
	        d3_date = d3_date_utc;
	        var utc = new d3_date_utc();
	        utc._ = date;
	        return method(utc, k)._;
	      } finally {
	        d3_date = Date;
	      }
	    };
	  }
	  d3_time.year = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setMonth(0, 1);
	    return date;
	  }, function(date, offset) {
	    date.setFullYear(date.getFullYear() + offset);
	  }, function(date) {
	    return date.getFullYear();
	  });
	  d3_time.years = d3_time.year.range;
	  d3_time.years.utc = d3_time.year.utc.range;
	  d3_time.day = d3_time_interval(function(date) {
	    var day = new d3_date(2e3, 0);
	    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
	    return day;
	  }, function(date, offset) {
	    date.setDate(date.getDate() + offset);
	  }, function(date) {
	    return date.getDate() - 1;
	  });
	  d3_time.days = d3_time.day.range;
	  d3_time.days.utc = d3_time.day.utc.range;
	  d3_time.dayOfYear = function(date) {
	    var year = d3_time.year(date);
	    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
	  };
	  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
	    i = 7 - i;
	    var interval = d3_time[day] = d3_time_interval(function(date) {
	      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
	      return date;
	    }, function(date, offset) {
	      date.setDate(date.getDate() + Math.floor(offset) * 7);
	    }, function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
	    });
	    d3_time[day + "s"] = interval.range;
	    d3_time[day + "s"].utc = interval.utc.range;
	    d3_time[day + "OfYear"] = function(date) {
	      var day = d3_time.year(date).getDay();
	      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
	    };
	  });
	  d3_time.week = d3_time.sunday;
	  d3_time.weeks = d3_time.sunday.range;
	  d3_time.weeks.utc = d3_time.sunday.utc.range;
	  d3_time.weekOfYear = d3_time.sundayOfYear;
	  function d3_locale_timeFormat(locale) {
	    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
	    function d3_time_format(template) {
	      var n = template.length;
	      function format(date) {
	        var string = [], i = -1, j = 0, c, p, f;
	        while (++i < n) {
	          if (template.charCodeAt(i) === 37) {
	            string.push(template.slice(j, i));
	            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
	            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	        string.push(template.slice(j, i));
	        return string.join("");
	      }
	      format.parse = function(string) {
	        var d = {
	          y: 1900,
	          m: 0,
	          d: 1,
	          H: 0,
	          M: 0,
	          S: 0,
	          L: 0,
	          Z: null
	        }, i = d3_time_parse(d, template, string, 0);
	        if (i != string.length) return null;
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
	        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          date.setFullYear(d.y, 0, 1);
	          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
	        } else date.setFullYear(d.y, d.m, d.d);
	        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
	        return localZ ? date._ : date;
	      };
	      format.toString = function() {
	        return template;
	      };
	      return format;
	    }
	    function d3_time_parse(date, template, string, j) {
	      var c, p, t, i = 0, n = template.length, m = string.length;
	      while (i < n) {
	        if (j >= m) return -1;
	        c = template.charCodeAt(i++);
	        if (c === 37) {
	          t = template.charAt(i++);
	          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
	          if (!p || (j = p(date, string, j)) < 0) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	      return j;
	    }
	    d3_time_format.utc = function(template) {
	      var local = d3_time_format(template);
	      function format(date) {
	        try {
	          d3_date = d3_date_utc;
	          var utc = new d3_date();
	          utc._ = date;
	          return local(utc);
	        } finally {
	          d3_date = Date;
	        }
	      }
	      format.parse = function(string) {
	        try {
	          d3_date = d3_date_utc;
	          var date = local.parse(string);
	          return date && date._;
	        } finally {
	          d3_date = Date;
	        }
	      };
	      format.toString = local.toString;
	      return format;
	    };
	    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
	    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
	    locale_periods.forEach(function(p, i) {
	      d3_time_periodLookup.set(p.toLowerCase(), i);
	    });
	    var d3_time_formats = {
	      a: function(d) {
	        return locale_shortDays[d.getDay()];
	      },
	      A: function(d) {
	        return locale_days[d.getDay()];
	      },
	      b: function(d) {
	        return locale_shortMonths[d.getMonth()];
	      },
	      B: function(d) {
	        return locale_months[d.getMonth()];
	      },
	      c: d3_time_format(locale_dateTime),
	      d: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      e: function(d, p) {
	        return d3_time_formatPad(d.getDate(), p, 2);
	      },
	      H: function(d, p) {
	        return d3_time_formatPad(d.getHours(), p, 2);
	      },
	      I: function(d, p) {
	        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
	      },
	      j: function(d, p) {
	        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
	      },
	      L: function(d, p) {
	        return d3_time_formatPad(d.getMilliseconds(), p, 3);
	      },
	      m: function(d, p) {
	        return d3_time_formatPad(d.getMonth() + 1, p, 2);
	      },
	      M: function(d, p) {
	        return d3_time_formatPad(d.getMinutes(), p, 2);
	      },
	      p: function(d) {
	        return locale_periods[+(d.getHours() >= 12)];
	      },
	      S: function(d, p) {
	        return d3_time_formatPad(d.getSeconds(), p, 2);
	      },
	      U: function(d, p) {
	        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
	      },
	      w: function(d) {
	        return d.getDay();
	      },
	      W: function(d, p) {
	        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
	      },
	      x: d3_time_format(locale_date),
	      X: d3_time_format(locale_time),
	      y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
	      },
	      Y: function(d, p) {
	        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
	      },
	      Z: d3_time_zone,
	      "%": function() {
	        return "%";
	      }
	    };
	    var d3_time_parsers = {
	      a: d3_time_parseWeekdayAbbrev,
	      A: d3_time_parseWeekday,
	      b: d3_time_parseMonthAbbrev,
	      B: d3_time_parseMonth,
	      c: d3_time_parseLocaleFull,
	      d: d3_time_parseDay,
	      e: d3_time_parseDay,
	      H: d3_time_parseHour24,
	      I: d3_time_parseHour24,
	      j: d3_time_parseDayOfYear,
	      L: d3_time_parseMilliseconds,
	      m: d3_time_parseMonthNumber,
	      M: d3_time_parseMinutes,
	      p: d3_time_parseAmPm,
	      S: d3_time_parseSeconds,
	      U: d3_time_parseWeekNumberSunday,
	      w: d3_time_parseWeekdayNumber,
	      W: d3_time_parseWeekNumberMonday,
	      x: d3_time_parseLocaleDate,
	      X: d3_time_parseLocaleTime,
	      y: d3_time_parseYear,
	      Y: d3_time_parseFullYear,
	      Z: d3_time_parseZone,
	      "%": d3_time_parseLiteralPercent
	    };
	    function d3_time_parseWeekdayAbbrev(date, string, i) {
	      d3_time_dayAbbrevRe.lastIndex = 0;
	      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseWeekday(date, string, i) {
	      d3_time_dayRe.lastIndex = 0;
	      var n = d3_time_dayRe.exec(string.slice(i));
	      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonthAbbrev(date, string, i) {
	      d3_time_monthAbbrevRe.lastIndex = 0;
	      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseMonth(date, string, i) {
	      d3_time_monthRe.lastIndex = 0;
	      var n = d3_time_monthRe.exec(string.slice(i));
	      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
	    }
	    function d3_time_parseLocaleFull(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
	    }
	    function d3_time_parseLocaleDate(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
	    }
	    function d3_time_parseLocaleTime(date, string, i) {
	      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
	    }
	    function d3_time_parseAmPm(date, string, i) {
	      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
	      return n == null ? -1 : (date.p = n, i);
	    }
	    return d3_time_format;
	  }
	  var d3_time_formatPads = {
	    "-": "",
	    _: " ",
	    "0": "0"
	  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
	  function d3_time_formatPad(value, fill, width) {
	    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	  function d3_time_formatRe(names) {
	    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
	  }
	  function d3_time_formatLookup(names) {
	    var map = new d3_Map(), i = -1, n = names.length;
	    while (++i < n) map.set(names[i].toLowerCase(), i);
	    return map;
	  }
	  function d3_time_parseWeekdayNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
	    return n ? (date.w = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberSunday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.U = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseWeekNumberMonday(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i));
	    return n ? (date.W = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseFullYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
	    return n ? (date.y = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
	  }
	  function d3_time_parseZone(date, string, i) {
	    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
	    i + 5) : -1;
	  }
	  function d3_time_expandYear(d) {
	    return d + (d > 68 ? 1900 : 2e3);
	  }
	  function d3_time_parseMonthNumber(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
	  }
	  function d3_time_parseDay(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.d = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseDayOfYear(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.j = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseHour24(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.H = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMinutes(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.M = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseSeconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
	    return n ? (date.S = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_parseMilliseconds(date, string, i) {
	    d3_time_numberRe.lastIndex = 0;
	    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
	    return n ? (date.L = +n[0], i + n[0].length) : -1;
	  }
	  function d3_time_zone(d) {
	    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
	    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
	  }
	  function d3_time_parseLiteralPercent(date, string, i) {
	    d3_time_percentRe.lastIndex = 0;
	    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	  function d3_time_formatMulti(formats) {
	    var n = formats.length, i = -1;
	    while (++i < n) formats[i][0] = this(formats[i][0]);
	    return function(date) {
	      var i = 0, f = formats[i];
	      while (!f[1](date)) f = formats[++i];
	      return f[0](date);
	    };
	  }
	  d3.locale = function(locale) {
	    return {
	      numberFormat: d3_locale_numberFormat(locale),
	      timeFormat: d3_locale_timeFormat(locale)
	    };
	  };
	  var d3_locale_enUS = d3.locale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [ 3 ],
	    currency: [ "$", "" ],
	    dateTime: "%a %b %e %X %Y",
	    date: "%m/%d/%Y",
	    time: "%H:%M:%S",
	    periods: [ "AM", "PM" ],
	    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
	    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
	    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
	    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
	  });
	  d3.format = d3_locale_enUS.numberFormat;
	  d3.geo = {};
	  function d3_adder() {}
	  d3_adder.prototype = {
	    s: 0,
	    t: 0,
	    add: function(y) {
	      d3_adderSum(y, this.t, d3_adderTemp);
	      d3_adderSum(d3_adderTemp.s, this.s, this);
	      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
	    },
	    reset: function() {
	      this.s = this.t = 0;
	    },
	    valueOf: function() {
	      return this.s;
	    }
	  };
	  var d3_adderTemp = new d3_adder();
	  function d3_adderSum(a, b, o) {
	    var x = o.s = a + b, bv = x - a, av = x - bv;
	    o.t = a - av + (b - bv);
	  }
	  d3.geo.stream = function(object, listener) {
	    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
	      d3_geo_streamObjectType[object.type](object, listener);
	    } else {
	      d3_geo_streamGeometry(object, listener);
	    }
	  };
	  function d3_geo_streamGeometry(geometry, listener) {
	    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
	      d3_geo_streamGeometryType[geometry.type](geometry, listener);
	    }
	  }
	  var d3_geo_streamObjectType = {
	    Feature: function(feature, listener) {
	      d3_geo_streamGeometry(feature.geometry, listener);
	    },
	    FeatureCollection: function(object, listener) {
	      var features = object.features, i = -1, n = features.length;
	      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
	    }
	  };
	  var d3_geo_streamGeometryType = {
	    Sphere: function(object, listener) {
	      listener.sphere();
	    },
	    Point: function(object, listener) {
	      object = object.coordinates;
	      listener.point(object[0], object[1], object[2]);
	    },
	    MultiPoint: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
	    },
	    LineString: function(object, listener) {
	      d3_geo_streamLine(object.coordinates, listener, 0);
	    },
	    MultiLineString: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
	    },
	    Polygon: function(object, listener) {
	      d3_geo_streamPolygon(object.coordinates, listener);
	    },
	    MultiPolygon: function(object, listener) {
	      var coordinates = object.coordinates, i = -1, n = coordinates.length;
	      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
	    },
	    GeometryCollection: function(object, listener) {
	      var geometries = object.geometries, i = -1, n = geometries.length;
	      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
	    }
	  };
	  function d3_geo_streamLine(coordinates, listener, closed) {
	    var i = -1, n = coordinates.length - closed, coordinate;
	    listener.lineStart();
	    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
	    listener.lineEnd();
	  }
	  function d3_geo_streamPolygon(coordinates, listener) {
	    var i = -1, n = coordinates.length;
	    listener.polygonStart();
	    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
	    listener.polygonEnd();
	  }
	  d3.geo.area = function(object) {
	    d3_geo_areaSum = 0;
	    d3.geo.stream(object, d3_geo_area);
	    return d3_geo_areaSum;
	  };
	  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
	  var d3_geo_area = {
	    sphere: function() {
	      d3_geo_areaSum += 4 * π;
	    },
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_areaRingSum.reset();
	      d3_geo_area.lineStart = d3_geo_areaRingStart;
	    },
	    polygonEnd: function() {
	      var area = 2 * d3_geo_areaRingSum;
	      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
	      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
	    }
	  };
	  function d3_geo_areaRingStart() {
	    var λ00, φ00, λ0, cosφ0, sinφ0;
	    d3_geo_area.point = function(λ, φ) {
	      d3_geo_area.point = nextPoint;
	      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
	      sinφ0 = Math.sin(φ);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      φ = φ * d3_radians / 2 + π / 4;
	      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
	      d3_geo_areaRingSum.add(Math.atan2(v, u));
	      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
	    }
	    d3_geo_area.lineEnd = function() {
	      nextPoint(λ00, φ00);
	    };
	  }
	  function d3_geo_cartesian(spherical) {
	    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
	    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
	  }
	  function d3_geo_cartesianDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	  }
	  function d3_geo_cartesianCross(a, b) {
	    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
	  }
	  function d3_geo_cartesianAdd(a, b) {
	    a[0] += b[0];
	    a[1] += b[1];
	    a[2] += b[2];
	  }
	  function d3_geo_cartesianScale(vector, k) {
	    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
	  }
	  function d3_geo_cartesianNormalize(d) {
	    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	    d[0] /= l;
	    d[1] /= l;
	    d[2] /= l;
	  }
	  function d3_geo_spherical(cartesian) {
	    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
	  }
	  function d3_geo_sphericalEqual(a, b) {
	    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
	  }
	  d3.geo.bounds = function() {
	    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
	    var bound = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        bound.point = ringPoint;
	        bound.lineStart = ringStart;
	        bound.lineEnd = ringEnd;
	        dλSum = 0;
	        d3_geo_area.polygonStart();
	      },
	      polygonEnd: function() {
	        d3_geo_area.polygonEnd();
	        bound.point = point;
	        bound.lineStart = lineStart;
	        bound.lineEnd = lineEnd;
	        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
	        range[0] = λ0, range[1] = λ1;
	      }
	    };
	    function point(λ, φ) {
	      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
	      if (φ < φ0) φ0 = φ;
	      if (φ > φ1) φ1 = φ;
	    }
	    function linePoint(λ, φ) {
	      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
	      if (p0) {
	        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
	        d3_geo_cartesianNormalize(inflection);
	        inflection = d3_geo_spherical(inflection);
	        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
	        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = inflection[1] * d3_degrees;
	          if (φi > φ1) φ1 = φi;
	        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
	          var φi = -inflection[1] * d3_degrees;
	          if (φi < φ0) φ0 = φi;
	        } else {
	          if (φ < φ0) φ0 = φ;
	          if (φ > φ1) φ1 = φ;
	        }
	        if (antimeridian) {
	          if (λ < λ_) {
	            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	          } else {
	            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	          }
	        } else {
	          if (λ1 >= λ0) {
	            if (λ < λ0) λ0 = λ;
	            if (λ > λ1) λ1 = λ;
	          } else {
	            if (λ > λ_) {
	              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
	            } else {
	              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
	            }
	          }
	        }
	      } else {
	        point(λ, φ);
	      }
	      p0 = p, λ_ = λ;
	    }
	    function lineStart() {
	      bound.point = linePoint;
	    }
	    function lineEnd() {
	      range[0] = λ0, range[1] = λ1;
	      bound.point = point;
	      p0 = null;
	    }
	    function ringPoint(λ, φ) {
	      if (p0) {
	        var dλ = λ - λ_;
	        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
	      } else λ__ = λ, φ__ = φ;
	      d3_geo_area.point(λ, φ);
	      linePoint(λ, φ);
	    }
	    function ringStart() {
	      d3_geo_area.lineStart();
	    }
	    function ringEnd() {
	      ringPoint(λ__, φ__);
	      d3_geo_area.lineEnd();
	      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
	      range[0] = λ0, range[1] = λ1;
	      p0 = null;
	    }
	    function angle(λ0, λ1) {
	      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
	    }
	    function compareRanges(a, b) {
	      return a[0] - b[0];
	    }
	    function withinRange(x, range) {
	      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
	    }
	    return function(feature) {
	      φ1 = λ1 = -(λ0 = φ0 = Infinity);
	      ranges = [];
	      d3.geo.stream(feature, bound);
	      var n = ranges.length;
	      if (n) {
	        ranges.sort(compareRanges);
	        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
	          b = ranges[i];
	          if (withinRange(b[0], a) || withinRange(b[1], a)) {
	            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	          } else {
	            merged.push(a = b);
	          }
	        }
	        var best = -Infinity, dλ;
	        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
	          b = merged[i];
	          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
	        }
	      }
	      ranges = range = null;
	      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
	    };
	  }();
	  d3.geo.centroid = function(object) {
	    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	    d3.geo.stream(object, d3_geo_centroid);
	    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
	    if (m < ε2) {
	      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
	      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
	      m = x * x + y * y + z * z;
	      if (m < ε2) return [ NaN, NaN ];
	    }
	    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
	  };
	  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
	  var d3_geo_centroid = {
	    sphere: d3_noop,
	    point: d3_geo_centroidPoint,
	    lineStart: d3_geo_centroidLineStart,
	    lineEnd: d3_geo_centroidLineEnd,
	    polygonStart: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
	    }
	  };
	  function d3_geo_centroidPoint(λ, φ) {
	    λ *= d3_radians;
	    var cosφ = Math.cos(φ *= d3_radians);
	    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
	  }
	  function d3_geo_centroidPointXYZ(x, y, z) {
	    ++d3_geo_centroidW0;
	    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
	    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
	    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
	  }
	  function d3_geo_centroidLineStart() {
	    var x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroid.point = nextPoint;
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_centroidLineEnd() {
	    d3_geo_centroid.point = d3_geo_centroidPoint;
	  }
	  function d3_geo_centroidRingStart() {
	    var λ00, φ00, x0, y0, z0;
	    d3_geo_centroid.point = function(λ, φ) {
	      λ00 = λ, φ00 = φ;
	      d3_geo_centroid.point = nextPoint;
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians);
	      x0 = cosφ * Math.cos(λ);
	      y0 = cosφ * Math.sin(λ);
	      z0 = Math.sin(φ);
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    };
	    d3_geo_centroid.lineEnd = function() {
	      nextPoint(λ00, φ00);
	      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
	      d3_geo_centroid.point = d3_geo_centroidPoint;
	    };
	    function nextPoint(λ, φ) {
	      λ *= d3_radians;
	      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
	      d3_geo_centroidX2 += v * cx;
	      d3_geo_centroidY2 += v * cy;
	      d3_geo_centroidZ2 += v * cz;
	      d3_geo_centroidW1 += w;
	      d3_geo_centroidX1 += w * (x0 + (x0 = x));
	      d3_geo_centroidY1 += w * (y0 + (y0 = y));
	      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
	      d3_geo_centroidPointXYZ(x0, y0, z0);
	    }
	  }
	  function d3_geo_compose(a, b) {
	    function compose(x, y) {
	      return x = a(x, y), b(x[0], x[1]);
	    }
	    if (a.invert && b.invert) compose.invert = function(x, y) {
	      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	    };
	    return compose;
	  }
	  function d3_true() {
	    return true;
	  }
	  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
	    var subject = [], clip = [];
	    segments.forEach(function(segment) {
	      if ((n = segment.length - 1) <= 0) return;
	      var n, p0 = segment[0], p1 = segment[n];
	      if (d3_geo_sphericalEqual(p0, p1)) {
	        listener.lineStart();
	        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
	        listener.lineEnd();
	        return;
	      }
	      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
	      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
	      a.o = b;
	      subject.push(a);
	      clip.push(b);
	    });
	    clip.sort(compare);
	    d3_geo_clipPolygonLinkCircular(subject);
	    d3_geo_clipPolygonLinkCircular(clip);
	    if (!subject.length) return;
	    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
	      clip[i].e = entry = !entry;
	    }
	    var start = subject[0], points, point;
	    while (1) {
	      var current = start, isSubject = true;
	      while (current.v) if ((current = current.n) === start) return;
	      points = current.z;
	      listener.lineStart();
	      do {
	        current.v = current.o.v = true;
	        if (current.e) {
	          if (isSubject) {
	            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.n.x, 1, listener);
	          }
	          current = current.n;
	        } else {
	          if (isSubject) {
	            points = current.p.z;
	            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
	          } else {
	            interpolate(current.x, current.p.x, -1, listener);
	          }
	          current = current.p;
	        }
	        current = current.o;
	        points = current.z;
	        isSubject = !isSubject;
	      } while (!current.v);
	      listener.lineEnd();
	    }
	  }
	  function d3_geo_clipPolygonLinkCircular(array) {
	    if (!(n = array.length)) return;
	    var n, i = 0, a = array[0], b;
	    while (++i < n) {
	      a.n = b = array[i];
	      b.p = a;
	      a = b;
	    }
	    a.n = b = array[0];
	    b.p = a;
	  }
	  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
	    this.x = point;
	    this.z = points;
	    this.o = other;
	    this.e = entry;
	    this.v = false;
	    this.n = this.p = null;
	  }
	  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
	    return function(rotate, listener) {
	      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          clip.point = pointRing;
	          clip.lineStart = ringStart;
	          clip.lineEnd = ringEnd;
	          segments = [];
	          polygon = [];
	        },
	        polygonEnd: function() {
	          clip.point = point;
	          clip.lineStart = lineStart;
	          clip.lineEnd = lineEnd;
	          segments = d3.merge(segments);
	          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
	          if (segments.length) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
	          } else if (clipStartInside) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            interpolate(null, null, 1, listener);
	            listener.lineEnd();
	          }
	          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
	          segments = polygon = null;
	        },
	        sphere: function() {
	          listener.polygonStart();
	          listener.lineStart();
	          interpolate(null, null, 1, listener);
	          listener.lineEnd();
	          listener.polygonEnd();
	        }
	      };
	      function point(λ, φ) {
	        var point = rotate(λ, φ);
	        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
	      }
	      function pointLine(λ, φ) {
	        var point = rotate(λ, φ);
	        line.point(point[0], point[1]);
	      }
	      function lineStart() {
	        clip.point = pointLine;
	        line.lineStart();
	      }
	      function lineEnd() {
	        clip.point = point;
	        line.lineEnd();
	      }
	      var segments;
	      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
	      function pointRing(λ, φ) {
	        ring.push([ λ, φ ]);
	        var point = rotate(λ, φ);
	        ringListener.point(point[0], point[1]);
	      }
	      function ringStart() {
	        ringListener.lineStart();
	        ring = [];
	      }
	      function ringEnd() {
	        pointRing(ring[0][0], ring[0][1]);
	        ringListener.lineEnd();
	        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
	        ring.pop();
	        polygon.push(ring);
	        ring = null;
	        if (!n) return;
	        if (clean & 1) {
	          segment = ringSegments[0];
	          var n = segment.length - 1, i = -1, point;
	          if (n > 0) {
	            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
	            listener.lineStart();
	            while (++i < n) listener.point((point = segment[i])[0], point[1]);
	            listener.lineEnd();
	          }
	          return;
	        }
	        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
	      }
	      return clip;
	    };
	  }
	  function d3_geo_clipSegmentLength1(segment) {
	    return segment.length > 1;
	  }
	  function d3_geo_clipBufferListener() {
	    var lines = [], line;
	    return {
	      lineStart: function() {
	        lines.push(line = []);
	      },
	      point: function(λ, φ) {
	        line.push([ λ, φ ]);
	      },
	      lineEnd: d3_noop,
	      buffer: function() {
	        var buffer = lines;
	        lines = [];
	        line = null;
	        return buffer;
	      },
	      rejoin: function() {
	        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	      }
	    };
	  }
	  function d3_geo_clipSort(a, b) {
	    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
	  }
	  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
	  function d3_geo_clipAntimeridianLine(listener) {
	    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
	    return {
	      lineStart: function() {
	        listener.lineStart();
	        clean = 1;
	      },
	      point: function(λ1, φ1) {
	        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
	        if (abs(dλ - π) < ε) {
	          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          listener.point(λ1, φ0);
	          clean = 0;
	        } else if (sλ0 !== sλ1 && dλ >= π) {
	          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
	          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
	          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
	          listener.point(sλ0, φ0);
	          listener.lineEnd();
	          listener.lineStart();
	          listener.point(sλ1, φ0);
	          clean = 0;
	        }
	        listener.point(λ0 = λ1, φ0 = φ1);
	        sλ0 = sλ1;
	      },
	      lineEnd: function() {
	        listener.lineEnd();
	        λ0 = φ0 = NaN;
	      },
	      clean: function() {
	        return 2 - clean;
	      }
	    };
	  }
	  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
	    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
	    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
	  }
	  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
	    var φ;
	    if (from == null) {
	      φ = direction * halfπ;
	      listener.point(-π, φ);
	      listener.point(0, φ);
	      listener.point(π, φ);
	      listener.point(π, 0);
	      listener.point(π, -φ);
	      listener.point(0, -φ);
	      listener.point(-π, -φ);
	      listener.point(-π, 0);
	      listener.point(-π, φ);
	    } else if (abs(from[0] - to[0]) > ε) {
	      var s = from[0] < to[0] ? π : -π;
	      φ = direction * s / 2;
	      listener.point(-s, φ);
	      listener.point(0, φ);
	      listener.point(s, φ);
	    } else {
	      listener.point(to[0], to[1]);
	    }
	  }
	  function d3_geo_pointInPolygon(point, polygon) {
	    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
	    d3_geo_areaRingSum.reset();
	    for (var i = 0, n = polygon.length; i < n; ++i) {
	      var ring = polygon[i], m = ring.length;
	      if (!m) continue;
	      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
	      while (true) {
	        if (j === m) j = 0;
	        point = ring[j];
	        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
	        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
	        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
	        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
	          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
	          d3_geo_cartesianNormalize(arc);
	          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
	          d3_geo_cartesianNormalize(intersection);
	          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
	          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
	            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
	          }
	        }
	        if (!j++) break;
	        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
	      }
	    }
	    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
	  }
	  function d3_geo_clipCircle(radius) {
	    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
	    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
	    function visible(λ, φ) {
	      return Math.cos(λ) * Math.cos(φ) > cr;
	    }
	    function clipLine(listener) {
	      var point0, c0, v0, v00, clean;
	      return {
	        lineStart: function() {
	          v00 = v0 = false;
	          clean = 1;
	        },
	        point: function(λ, φ) {
	          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
	          if (!point0 && (v00 = v0 = v)) listener.lineStart();
	          if (v !== v0) {
	            point2 = intersect(point0, point1);
	            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
	              point1[0] += ε;
	              point1[1] += ε;
	              v = visible(point1[0], point1[1]);
	            }
	          }
	          if (v !== v0) {
	            clean = 0;
	            if (v) {
	              listener.lineStart();
	              point2 = intersect(point1, point0);
	              listener.point(point2[0], point2[1]);
	            } else {
	              point2 = intersect(point0, point1);
	              listener.point(point2[0], point2[1]);
	              listener.lineEnd();
	            }
	            point0 = point2;
	          } else if (notHemisphere && point0 && smallRadius ^ v) {
	            var t;
	            if (!(c & c0) && (t = intersect(point1, point0, true))) {
	              clean = 0;
	              if (smallRadius) {
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	              } else {
	                listener.point(t[1][0], t[1][1]);
	                listener.lineEnd();
	                listener.lineStart();
	                listener.point(t[0][0], t[0][1]);
	              }
	            }
	          }
	          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
	            listener.point(point1[0], point1[1]);
	          }
	          point0 = point1, v0 = v, c0 = c;
	        },
	        lineEnd: function() {
	          if (v0) listener.lineEnd();
	          point0 = null;
	        },
	        clean: function() {
	          return clean | (v00 && v0) << 1;
	        }
	      };
	    }
	    function intersect(a, b, two) {
	      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
	      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
	      if (!determinant) return !two && a;
	      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
	      d3_geo_cartesianAdd(A, B);
	      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
	      if (t2 < 0) return;
	      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
	      d3_geo_cartesianAdd(q, A);
	      q = d3_geo_spherical(q);
	      if (!two) return q;
	      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
	      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
	      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
	      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
	      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
	        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
	        d3_geo_cartesianAdd(q1, A);
	        return [ q, d3_geo_spherical(q1) ];
	      }
	    }
	    function code(λ, φ) {
	      var r = smallRadius ? radius : π - radius, code = 0;
	      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
	      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
	      return code;
	    }
	  }
	  function d3_geom_clipLine(x0, y0, x1, y1) {
	    return function(line) {
	      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
	      r = x0 - ax;
	      if (!dx && r > 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dx > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = x1 - ax;
	      if (!dx && r < 0) return;
	      r /= dx;
	      if (dx < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dx > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      r = y0 - ay;
	      if (!dy && r > 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      } else if (dy > 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      }
	      r = y1 - ay;
	      if (!dy && r < 0) return;
	      r /= dy;
	      if (dy < 0) {
	        if (r > t1) return;
	        if (r > t0) t0 = r;
	      } else if (dy > 0) {
	        if (r < t0) return;
	        if (r < t1) t1 = r;
	      }
	      if (t0 > 0) line.a = {
	        x: ax + t0 * dx,
	        y: ay + t0 * dy
	      };
	      if (t1 < 1) line.b = {
	        x: ax + t1 * dx,
	        y: ay + t1 * dy
	      };
	      return line;
	    };
	  }
	  var d3_geo_clipExtentMAX = 1e9;
	  d3.geo.clipExtent = function() {
	    var x0, y0, x1, y1, stream, clip, clipExtent = {
	      stream: function(output) {
	        if (stream) stream.valid = false;
	        stream = clip(output);
	        stream.valid = true;
	        return stream;
	      },
	      extent: function(_) {
	        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
	        if (stream) stream.valid = false, stream = null;
	        return clipExtent;
	      }
	    };
	    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
	  };
	  function d3_geo_clipExtent(x0, y0, x1, y1) {
	    return function(listener) {
	      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
	      var clip = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          listener = bufferListener;
	          segments = [];
	          polygon = [];
	          clean = true;
	        },
	        polygonEnd: function() {
	          listener = listener_;
	          segments = d3.merge(segments);
	          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
	          if (inside || visible) {
	            listener.polygonStart();
	            if (inside) {
	              listener.lineStart();
	              interpolate(null, null, 1, listener);
	              listener.lineEnd();
	            }
	            if (visible) {
	              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
	            }
	            listener.polygonEnd();
	          }
	          segments = polygon = ring = null;
	        }
	      };
	      function insidePolygon(p) {
	        var wn = 0, n = polygon.length, y = p[1];
	        for (var i = 0; i < n; ++i) {
	          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
	            b = v[j];
	            if (a[1] <= y) {
	              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
	            } else {
	              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
	            }
	            a = b;
	          }
	        }
	        return wn !== 0;
	      }
	      function interpolate(from, to, direction, listener) {
	        var a = 0, a1 = 0;
	        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
	          do {
	            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	          } while ((a = (a + direction + 4) % 4) !== a1);
	        } else {
	          listener.point(to[0], to[1]);
	        }
	      }
	      function pointVisible(x, y) {
	        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	      }
	      function point(x, y) {
	        if (pointVisible(x, y)) listener.point(x, y);
	      }
	      var x__, y__, v__, x_, y_, v_, first, clean;
	      function lineStart() {
	        clip.point = linePoint;
	        if (polygon) polygon.push(ring = []);
	        first = true;
	        v_ = false;
	        x_ = y_ = NaN;
	      }
	      function lineEnd() {
	        if (segments) {
	          linePoint(x__, y__);
	          if (v__ && v_) bufferListener.rejoin();
	          segments.push(bufferListener.buffer());
	        }
	        clip.point = point;
	        if (v_) listener.lineEnd();
	      }
	      function linePoint(x, y) {
	        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
	        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
	        var v = pointVisible(x, y);
	        if (polygon) ring.push([ x, y ]);
	        if (first) {
	          x__ = x, y__ = y, v__ = v;
	          first = false;
	          if (v) {
	            listener.lineStart();
	            listener.point(x, y);
	          }
	        } else {
	          if (v && v_) listener.point(x, y); else {
	            var l = {
	              a: {
	                x: x_,
	                y: y_
	              },
	              b: {
	                x: x,
	                y: y
	              }
	            };
	            if (clipLine(l)) {
	              if (!v_) {
	                listener.lineStart();
	                listener.point(l.a.x, l.a.y);
	              }
	              listener.point(l.b.x, l.b.y);
	              if (!v) listener.lineEnd();
	              clean = false;
	            } else if (v) {
	              listener.lineStart();
	              listener.point(x, y);
	              clean = false;
	            }
	          }
	        }
	        x_ = x, y_ = y, v_ = v;
	      }
	      return clip;
	    };
	    function corner(p, direction) {
	      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
	    }
	    function compare(a, b) {
	      return comparePoints(a.x, b.x);
	    }
	    function comparePoints(a, b) {
	      var ca = corner(a, 1), cb = corner(b, 1);
	      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
	    }
	  }
	  function d3_geo_conic(projectAt) {
	    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
	    p.parallels = function(_) {
	      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
	      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
	    };
	    return p;
	  }
	  function d3_geo_conicEqualArea(φ0, φ1) {
	    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
	    function forward(λ, φ) {
	      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
	      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = ρ0 - y;
	      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEqualArea = function() {
	    return d3_geo_conic(d3_geo_conicEqualArea);
	  }).raw = d3_geo_conicEqualArea;
	  d3.geo.albers = function() {
	    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
	  };
	  d3.geo.albersUsa = function() {
	    var lower48 = d3.geo.albers();
	    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
	    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
	    var point, pointStream = {
	      point: function(x, y) {
	        point = [ x, y ];
	      }
	    }, lower48Point, alaskaPoint, hawaiiPoint;
	    function albersUsa(coordinates) {
	      var x = coordinates[0], y = coordinates[1];
	      point = null;
	      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
	      return point;
	    }
	    albersUsa.invert = function(coordinates) {
	      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
	      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
	    };
	    albersUsa.stream = function(stream) {
	      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
	      return {
	        point: function(x, y) {
	          lower48Stream.point(x, y);
	          alaskaStream.point(x, y);
	          hawaiiStream.point(x, y);
	        },
	        sphere: function() {
	          lower48Stream.sphere();
	          alaskaStream.sphere();
	          hawaiiStream.sphere();
	        },
	        lineStart: function() {
	          lower48Stream.lineStart();
	          alaskaStream.lineStart();
	          hawaiiStream.lineStart();
	        },
	        lineEnd: function() {
	          lower48Stream.lineEnd();
	          alaskaStream.lineEnd();
	          hawaiiStream.lineEnd();
	        },
	        polygonStart: function() {
	          lower48Stream.polygonStart();
	          alaskaStream.polygonStart();
	          hawaiiStream.polygonStart();
	        },
	        polygonEnd: function() {
	          lower48Stream.polygonEnd();
	          alaskaStream.polygonEnd();
	          hawaiiStream.polygonEnd();
	        }
	      };
	    };
	    albersUsa.precision = function(_) {
	      if (!arguments.length) return lower48.precision();
	      lower48.precision(_);
	      alaska.precision(_);
	      hawaii.precision(_);
	      return albersUsa;
	    };
	    albersUsa.scale = function(_) {
	      if (!arguments.length) return lower48.scale();
	      lower48.scale(_);
	      alaska.scale(_ * .35);
	      hawaii.scale(_);
	      return albersUsa.translate(lower48.translate());
	    };
	    albersUsa.translate = function(_) {
	      if (!arguments.length) return lower48.translate();
	      var k = lower48.scale(), x = +_[0], y = +_[1];
	      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
	      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
	      return albersUsa;
	    };
	    return albersUsa.scale(1070);
	  };
	  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
	    point: d3_noop,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: function() {
	      d3_geo_pathAreaPolygon = 0;
	      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
	      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
	    }
	  };
	  function d3_geo_pathAreaRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathArea.point = function(x, y) {
	      d3_geo_pathArea.point = nextPoint;
	      x00 = x0 = x, y00 = y0 = y;
	    };
	    function nextPoint(x, y) {
	      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
	      x0 = x, y0 = y;
	    }
	    d3_geo_pathArea.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
	  var d3_geo_pathBounds = {
	    point: d3_geo_pathBoundsPoint,
	    lineStart: d3_noop,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_pathBoundsPoint(x, y) {
	    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
	    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
	    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
	    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
	  }
	  function d3_geo_pathBuffer() {
	    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointCircle = d3_geo_pathBufferCircle(_);
	        return stream;
	      },
	      result: function() {
	        if (buffer.length) {
	          var result = buffer.join("");
	          buffer = [];
	          return result;
	        }
	      }
	    };
	    function point(x, y) {
	      buffer.push("M", x, ",", y, pointCircle);
	    }
	    function pointLineStart(x, y) {
	      buffer.push("M", x, ",", y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      buffer.push("L", x, ",", y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      buffer.push("Z");
	    }
	    return stream;
	  }
	  function d3_geo_pathBufferCircle(radius) {
	    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
	  }
	  var d3_geo_pathCentroid = {
	    point: d3_geo_pathCentroidPoint,
	    lineStart: d3_geo_pathCentroidLineStart,
	    lineEnd: d3_geo_pathCentroidLineEnd,
	    polygonStart: function() {
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
	    },
	    polygonEnd: function() {
	      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
	      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
	    }
	  };
	  function d3_geo_pathCentroidPoint(x, y) {
	    d3_geo_centroidX0 += x;
	    d3_geo_centroidY0 += y;
	    ++d3_geo_centroidZ0;
	  }
	  function d3_geo_pathCentroidLineStart() {
	    var x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	  }
	  function d3_geo_pathCentroidLineEnd() {
	    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
	  }
	  function d3_geo_pathCentroidRingStart() {
	    var x00, y00, x0, y0;
	    d3_geo_pathCentroid.point = function(x, y) {
	      d3_geo_pathCentroid.point = nextPoint;
	      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
	    };
	    function nextPoint(x, y) {
	      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
	      d3_geo_centroidX1 += z * (x0 + x) / 2;
	      d3_geo_centroidY1 += z * (y0 + y) / 2;
	      d3_geo_centroidZ1 += z;
	      z = y0 * x - x0 * y;
	      d3_geo_centroidX2 += z * (x0 + x);
	      d3_geo_centroidY2 += z * (y0 + y);
	      d3_geo_centroidZ2 += z * 3;
	      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
	    }
	    d3_geo_pathCentroid.lineEnd = function() {
	      nextPoint(x00, y00);
	    };
	  }
	  function d3_geo_pathContext(context) {
	    var pointRadius = 4.5;
	    var stream = {
	      point: point,
	      lineStart: function() {
	        stream.point = pointLineStart;
	      },
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        stream.lineEnd = lineEndPolygon;
	      },
	      polygonEnd: function() {
	        stream.lineEnd = lineEnd;
	        stream.point = point;
	      },
	      pointRadius: function(_) {
	        pointRadius = _;
	        return stream;
	      },
	      result: d3_noop
	    };
	    function point(x, y) {
	      context.moveTo(x + pointRadius, y);
	      context.arc(x, y, pointRadius, 0, τ);
	    }
	    function pointLineStart(x, y) {
	      context.moveTo(x, y);
	      stream.point = pointLine;
	    }
	    function pointLine(x, y) {
	      context.lineTo(x, y);
	    }
	    function lineEnd() {
	      stream.point = point;
	    }
	    function lineEndPolygon() {
	      context.closePath();
	    }
	    return stream;
	  }
	  function d3_geo_resample(project) {
	    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
	    function resample(stream) {
	      return (maxDepth ? resampleRecursive : resampleNone)(stream);
	    }
	    function resampleNone(stream) {
	      return d3_geo_transformPoint(stream, function(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      });
	    }
	    function resampleRecursive(stream) {
	      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
	      var resample = {
	        point: point,
	        lineStart: lineStart,
	        lineEnd: lineEnd,
	        polygonStart: function() {
	          stream.polygonStart();
	          resample.lineStart = ringStart;
	        },
	        polygonEnd: function() {
	          stream.polygonEnd();
	          resample.lineStart = lineStart;
	        }
	      };
	      function point(x, y) {
	        x = project(x, y);
	        stream.point(x[0], x[1]);
	      }
	      function lineStart() {
	        x0 = NaN;
	        resample.point = linePoint;
	        stream.lineStart();
	      }
	      function linePoint(λ, φ) {
	        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	        stream.point(x0, y0);
	      }
	      function lineEnd() {
	        resample.point = point;
	        stream.lineEnd();
	      }
	      function ringStart() {
	        lineStart();
	        resample.point = ringPoint;
	        resample.lineEnd = ringEnd;
	      }
	      function ringPoint(λ, φ) {
	        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	        resample.point = linePoint;
	      }
	      function ringEnd() {
	        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
	        resample.lineEnd = lineEnd;
	        lineEnd();
	      }
	      return resample;
	    }
	    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
	      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
	      if (d2 > 4 * δ2 && depth--) {
	        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
	        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
	          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
	          stream.point(x2, y2);
	          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
	        }
	      }
	    }
	    resample.precision = function(_) {
	      if (!arguments.length) return Math.sqrt(δ2);
	      maxDepth = (δ2 = _ * _) > 0 && 16;
	      return resample;
	    };
	    return resample;
	  }
	  d3.geo.path = function() {
	    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
	    function path(object) {
	      if (object) {
	        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
	        d3.geo.stream(object, cacheStream);
	      }
	      return contextStream.result();
	    }
	    path.area = function(object) {
	      d3_geo_pathAreaSum = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathArea));
	      return d3_geo_pathAreaSum;
	    };
	    path.centroid = function(object) {
	      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
	      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
	      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
	    };
	    path.bounds = function(object) {
	      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
	      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
	      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
	    };
	    path.projection = function(_) {
	      if (!arguments.length) return projection;
	      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
	      return reset();
	    };
	    path.context = function(_) {
	      if (!arguments.length) return context;
	      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
	      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	      return reset();
	    };
	    path.pointRadius = function(_) {
	      if (!arguments.length) return pointRadius;
	      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	      return path;
	    };
	    function reset() {
	      cacheStream = null;
	      return path;
	    }
	    return path.projection(d3.geo.albersUsa()).context(null);
	  };
	  function d3_geo_pathProjectStream(project) {
	    var resample = d3_geo_resample(function(x, y) {
	      return project([ x * d3_degrees, y * d3_degrees ]);
	    });
	    return function(stream) {
	      return d3_geo_projectionRadians(resample(stream));
	    };
	  }
	  d3.geo.transform = function(methods) {
	    return {
	      stream: function(stream) {
	        var transform = new d3_geo_transform(stream);
	        for (var k in methods) transform[k] = methods[k];
	        return transform;
	      }
	    };
	  };
	  function d3_geo_transform(stream) {
	    this.stream = stream;
	  }
	  d3_geo_transform.prototype = {
	    point: function(x, y) {
	      this.stream.point(x, y);
	    },
	    sphere: function() {
	      this.stream.sphere();
	    },
	    lineStart: function() {
	      this.stream.lineStart();
	    },
	    lineEnd: function() {
	      this.stream.lineEnd();
	    },
	    polygonStart: function() {
	      this.stream.polygonStart();
	    },
	    polygonEnd: function() {
	      this.stream.polygonEnd();
	    }
	  };
	  function d3_geo_transformPoint(stream, point) {
	    return {
	      point: point,
	      sphere: function() {
	        stream.sphere();
	      },
	      lineStart: function() {
	        stream.lineStart();
	      },
	      lineEnd: function() {
	        stream.lineEnd();
	      },
	      polygonStart: function() {
	        stream.polygonStart();
	      },
	      polygonEnd: function() {
	        stream.polygonEnd();
	      }
	    };
	  }
	  d3.geo.projection = d3_geo_projection;
	  d3.geo.projectionMutator = d3_geo_projectionMutator;
	  function d3_geo_projection(project) {
	    return d3_geo_projectionMutator(function() {
	      return project;
	    })();
	  }
	  function d3_geo_projectionMutator(projectAt) {
	    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
	      x = project(x, y);
	      return [ x[0] * k + δx, δy - x[1] * k ];
	    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
	    function projection(point) {
	      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
	      return [ point[0] * k + δx, δy - point[1] * k ];
	    }
	    function invert(point) {
	      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
	      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
	    }
	    projection.stream = function(output) {
	      if (stream) stream.valid = false;
	      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
	      stream.valid = true;
	      return stream;
	    };
	    projection.clipAngle = function(_) {
	      if (!arguments.length) return clipAngle;
	      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
	      return invalidate();
	    };
	    projection.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent;
	      clipExtent = _;
	      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
	      return invalidate();
	    };
	    projection.scale = function(_) {
	      if (!arguments.length) return k;
	      k = +_;
	      return reset();
	    };
	    projection.translate = function(_) {
	      if (!arguments.length) return [ x, y ];
	      x = +_[0];
	      y = +_[1];
	      return reset();
	    };
	    projection.center = function(_) {
	      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
	      λ = _[0] % 360 * d3_radians;
	      φ = _[1] % 360 * d3_radians;
	      return reset();
	    };
	    projection.rotate = function(_) {
	      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
	      δλ = _[0] % 360 * d3_radians;
	      δφ = _[1] % 360 * d3_radians;
	      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
	      return reset();
	    };
	    d3.rebind(projection, projectResample, "precision");
	    function reset() {
	      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
	      var center = project(λ, φ);
	      δx = x - center[0] * k;
	      δy = y + center[1] * k;
	      return invalidate();
	    }
	    function invalidate() {
	      if (stream) stream.valid = false, stream = null;
	      return projection;
	    }
	    return function() {
	      project = projectAt.apply(this, arguments);
	      projection.invert = project.invert && invert;
	      return reset();
	    };
	  }
	  function d3_geo_projectionRadians(stream) {
	    return d3_geo_transformPoint(stream, function(x, y) {
	      stream.point(x * d3_radians, y * d3_radians);
	    });
	  }
	  function d3_geo_equirectangular(λ, φ) {
	    return [ λ, φ ];
	  }
	  (d3.geo.equirectangular = function() {
	    return d3_geo_projection(d3_geo_equirectangular);
	  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
	  d3.geo.rotation = function(rotate) {
	    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
	    function forward(coordinates) {
	      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    }
	    forward.invert = function(coordinates) {
	      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
	      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
	    };
	    return forward;
	  };
	  function d3_geo_identityRotation(λ, φ) {
	    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	  }
	  d3_geo_identityRotation.invert = d3_geo_equirectangular;
	  function d3_geo_rotation(δλ, δφ, δγ) {
	    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
	  }
	  function d3_geo_forwardRotationλ(δλ) {
	    return function(λ, φ) {
	      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
	    };
	  }
	  function d3_geo_rotationλ(δλ) {
	    var rotation = d3_geo_forwardRotationλ(δλ);
	    rotation.invert = d3_geo_forwardRotationλ(-δλ);
	    return rotation;
	  }
	  function d3_geo_rotationφγ(δφ, δγ) {
	    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
	    function rotation(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
	      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
	    }
	    rotation.invert = function(λ, φ) {
	      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
	      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
	    };
	    return rotation;
	  }
	  d3.geo.circle = function() {
	    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
	    function circle() {
	      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
	      interpolate(null, null, 1, {
	        point: function(x, y) {
	          ring.push(x = rotate(x, y));
	          x[0] *= d3_degrees, x[1] *= d3_degrees;
	        }
	      });
	      return {
	        type: "Polygon",
	        coordinates: [ ring ]
	      };
	    }
	    circle.origin = function(x) {
	      if (!arguments.length) return origin;
	      origin = x;
	      return circle;
	    };
	    circle.angle = function(x) {
	      if (!arguments.length) return angle;
	      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
	      return circle;
	    };
	    circle.precision = function(_) {
	      if (!arguments.length) return precision;
	      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
	      return circle;
	    };
	    return circle.angle(90);
	  };
	  function d3_geo_circleInterpolate(radius, precision) {
	    var cr = Math.cos(radius), sr = Math.sin(radius);
	    return function(from, to, direction, listener) {
	      var step = direction * precision;
	      if (from != null) {
	        from = d3_geo_circleAngle(cr, from);
	        to = d3_geo_circleAngle(cr, to);
	        if (direction > 0 ? from < to : from > to) from += direction * τ;
	      } else {
	        from = radius + direction * τ;
	        to = radius - .5 * step;
	      }
	      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
	        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
	      }
	    };
	  }
	  function d3_geo_circleAngle(cr, point) {
	    var a = d3_geo_cartesian(point);
	    a[0] -= cr;
	    d3_geo_cartesianNormalize(a);
	    var angle = d3_acos(-a[1]);
	    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
	  }
	  d3.geo.distance = function(a, b) {
	    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
	    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
	  };
	  d3.geo.graticule = function() {
	    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
	    function graticule() {
	      return {
	        type: "MultiLineString",
	        coordinates: lines()
	      };
	    }
	    function lines() {
	      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
	        return abs(x % DX) > ε;
	      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
	        return abs(y % DY) > ε;
	      }).map(y));
	    }
	    graticule.lines = function() {
	      return lines().map(function(coordinates) {
	        return {
	          type: "LineString",
	          coordinates: coordinates
	        };
	      });
	    };
	    graticule.outline = function() {
	      return {
	        type: "Polygon",
	        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
	      };
	    };
	    graticule.extent = function(_) {
	      if (!arguments.length) return graticule.minorExtent();
	      return graticule.majorExtent(_).minorExtent(_);
	    };
	    graticule.majorExtent = function(_) {
	      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
	      X0 = +_[0][0], X1 = +_[1][0];
	      Y0 = +_[0][1], Y1 = +_[1][1];
	      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.minorExtent = function(_) {
	      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
	      x0 = +_[0][0], x1 = +_[1][0];
	      y0 = +_[0][1], y1 = +_[1][1];
	      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	      return graticule.precision(precision);
	    };
	    graticule.step = function(_) {
	      if (!arguments.length) return graticule.minorStep();
	      return graticule.majorStep(_).minorStep(_);
	    };
	    graticule.majorStep = function(_) {
	      if (!arguments.length) return [ DX, DY ];
	      DX = +_[0], DY = +_[1];
	      return graticule;
	    };
	    graticule.minorStep = function(_) {
	      if (!arguments.length) return [ dx, dy ];
	      dx = +_[0], dy = +_[1];
	      return graticule;
	    };
	    graticule.precision = function(_) {
	      if (!arguments.length) return precision;
	      precision = +_;
	      x = d3_geo_graticuleX(y0, y1, 90);
	      y = d3_geo_graticuleY(x0, x1, precision);
	      X = d3_geo_graticuleX(Y0, Y1, 90);
	      Y = d3_geo_graticuleY(X0, X1, precision);
	      return graticule;
	    };
	    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
	  };
	  function d3_geo_graticuleX(y0, y1, dy) {
	    var y = d3.range(y0, y1 - ε, dy).concat(y1);
	    return function(x) {
	      return y.map(function(y) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_geo_graticuleY(x0, x1, dx) {
	    var x = d3.range(x0, x1 - ε, dx).concat(x1);
	    return function(y) {
	      return x.map(function(x) {
	        return [ x, y ];
	      });
	    };
	  }
	  function d3_source(d) {
	    return d.source;
	  }
	  function d3_target(d) {
	    return d.target;
	  }
	  d3.geo.greatArc = function() {
	    var source = d3_source, source_, target = d3_target, target_;
	    function greatArc() {
	      return {
	        type: "LineString",
	        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
	      };
	    }
	    greatArc.distance = function() {
	      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
	    };
	    greatArc.source = function(_) {
	      if (!arguments.length) return source;
	      source = _, source_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.target = function(_) {
	      if (!arguments.length) return target;
	      target = _, target_ = typeof _ === "function" ? null : _;
	      return greatArc;
	    };
	    greatArc.precision = function() {
	      return arguments.length ? greatArc : 0;
	    };
	    return greatArc;
	  };
	  d3.geo.interpolate = function(source, target) {
	    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
	  };
	  function d3_geo_interpolate(x0, y0, x1, y1) {
	    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
	    var interpolate = d ? function(t) {
	      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
	      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
	    } : function() {
	      return [ x0 * d3_degrees, y0 * d3_degrees ];
	    };
	    interpolate.distance = d;
	    return interpolate;
	  }
	  d3.geo.length = function(object) {
	    d3_geo_lengthSum = 0;
	    d3.geo.stream(object, d3_geo_length);
	    return d3_geo_lengthSum;
	  };
	  var d3_geo_lengthSum;
	  var d3_geo_length = {
	    sphere: d3_noop,
	    point: d3_noop,
	    lineStart: d3_geo_lengthLineStart,
	    lineEnd: d3_noop,
	    polygonStart: d3_noop,
	    polygonEnd: d3_noop
	  };
	  function d3_geo_lengthLineStart() {
	    var λ0, sinφ0, cosφ0;
	    d3_geo_length.point = function(λ, φ) {
	      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
	      d3_geo_length.point = nextPoint;
	    };
	    d3_geo_length.lineEnd = function() {
	      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
	    };
	    function nextPoint(λ, φ) {
	      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
	      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
	      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
	    }
	  }
	  function d3_geo_azimuthal(scale, angle) {
	    function azimuthal(λ, φ) {
	      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
	      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
	    }
	    azimuthal.invert = function(x, y) {
	      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
	      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
	    };
	    return azimuthal;
	  }
	  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
	    return Math.sqrt(2 / (1 + cosλcosφ));
	  }, function(ρ) {
	    return 2 * Math.asin(ρ / 2);
	  });
	  (d3.geo.azimuthalEqualArea = function() {
	    return d3_geo_projection(d3_geo_azimuthalEqualArea);
	  }).raw = d3_geo_azimuthalEqualArea;
	  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
	    var c = Math.acos(cosλcosφ);
	    return c && c / Math.sin(c);
	  }, d3_identity);
	  (d3.geo.azimuthalEquidistant = function() {
	    return d3_geo_projection(d3_geo_azimuthalEquidistant);
	  }).raw = d3_geo_azimuthalEquidistant;
	  function d3_geo_conicConformal(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), t = function(φ) {
	      return Math.tan(π / 4 + φ / 2);
	    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
	    if (!n) return d3_geo_mercator;
	    function forward(λ, φ) {
	      if (F > 0) {
	        if (φ < -halfπ + ε) φ = -halfπ + ε;
	      } else {
	        if (φ > halfπ - ε) φ = halfπ - ε;
	      }
	      var ρ = F / Math.pow(t(φ), n);
	      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
	      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
	    };
	    return forward;
	  }
	  (d3.geo.conicConformal = function() {
	    return d3_geo_conic(d3_geo_conicConformal);
	  }).raw = d3_geo_conicConformal;
	  function d3_geo_conicEquidistant(φ0, φ1) {
	    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
	    if (abs(n) < ε) return d3_geo_equirectangular;
	    function forward(λ, φ) {
	      var ρ = G - φ;
	      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
	    }
	    forward.invert = function(x, y) {
	      var ρ0_y = G - y;
	      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
	    };
	    return forward;
	  }
	  (d3.geo.conicEquidistant = function() {
	    return d3_geo_conic(d3_geo_conicEquidistant);
	  }).raw = d3_geo_conicEquidistant;
	  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / cosλcosφ;
	  }, Math.atan);
	  (d3.geo.gnomonic = function() {
	    return d3_geo_projection(d3_geo_gnomonic);
	  }).raw = d3_geo_gnomonic;
	  function d3_geo_mercator(λ, φ) {
	    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
	  }
	  d3_geo_mercator.invert = function(x, y) {
	    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
	  };
	  function d3_geo_mercatorProjection(project) {
	    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
	    m.scale = function() {
	      var v = scale.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.translate = function() {
	      var v = translate.apply(m, arguments);
	      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
	    };
	    m.clipExtent = function(_) {
	      var v = clipExtent.apply(m, arguments);
	      if (v === m) {
	        if (clipAuto = _ == null) {
	          var k = π * scale(), t = translate();
	          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
	        }
	      } else if (clipAuto) {
	        v = null;
	      }
	      return v;
	    };
	    return m.clipExtent(null);
	  }
	  (d3.geo.mercator = function() {
	    return d3_geo_mercatorProjection(d3_geo_mercator);
	  }).raw = d3_geo_mercator;
	  var d3_geo_orthographic = d3_geo_azimuthal(function() {
	    return 1;
	  }, Math.asin);
	  (d3.geo.orthographic = function() {
	    return d3_geo_projection(d3_geo_orthographic);
	  }).raw = d3_geo_orthographic;
	  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
	    return 1 / (1 + cosλcosφ);
	  }, function(ρ) {
	    return 2 * Math.atan(ρ);
	  });
	  (d3.geo.stereographic = function() {
	    return d3_geo_projection(d3_geo_stereographic);
	  }).raw = d3_geo_stereographic;
	  function d3_geo_transverseMercator(λ, φ) {
	    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
	  }
	  d3_geo_transverseMercator.invert = function(x, y) {
	    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
	  };
	  (d3.geo.transverseMercator = function() {
	    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
	    projection.center = function(_) {
	      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
	    };
	    projection.rotate = function(_) {
	      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
	      [ _[0], _[1], _[2] - 90 ]);
	    };
	    return rotate([ 0, 0, 90 ]);
	  }).raw = d3_geo_transverseMercator;
	  d3.geom = {};
	  function d3_geom_pointX(d) {
	    return d[0];
	  }
	  function d3_geom_pointY(d) {
	    return d[1];
	  }
	  d3.geom.hull = function(vertices) {
	    var x = d3_geom_pointX, y = d3_geom_pointY;
	    if (arguments.length) return hull(vertices);
	    function hull(data) {
	      if (data.length < 3) return [];
	      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
	      for (i = 0; i < n; i++) {
	        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
	      }
	      points.sort(d3_geom_hullOrder);
	      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
	      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
	      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
	      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
	      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
	      return polygon;
	    }
	    hull.x = function(_) {
	      return arguments.length ? (x = _, hull) : x;
	    };
	    hull.y = function(_) {
	      return arguments.length ? (y = _, hull) : y;
	    };
	    return hull;
	  };
	  function d3_geom_hullUpper(points) {
	    var n = points.length, hull = [ 0, 1 ], hs = 2;
	    for (var i = 2; i < n; i++) {
	      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
	      hull[hs++] = i;
	    }
	    return hull.slice(0, hs);
	  }
	  function d3_geom_hullOrder(a, b) {
	    return a[0] - b[0] || a[1] - b[1];
	  }
	  d3.geom.polygon = function(coordinates) {
	    d3_subclass(coordinates, d3_geom_polygonPrototype);
	    return coordinates;
	  };
	  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
	  d3_geom_polygonPrototype.area = function() {
	    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      area += a[1] * b[0] - a[0] * b[1];
	    }
	    return area * .5;
	  };
	  d3_geom_polygonPrototype.centroid = function(k) {
	    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
	    if (!arguments.length) k = -1 / (6 * this.area());
	    while (++i < n) {
	      a = b;
	      b = this[i];
	      c = a[0] * b[1] - b[0] * a[1];
	      x += (a[0] + b[0]) * c;
	      y += (a[1] + b[1]) * c;
	    }
	    return [ x * k, y * k ];
	  };
	  d3_geom_polygonPrototype.clip = function(subject) {
	    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
	    while (++i < n) {
	      input = subject.slice();
	      subject.length = 0;
	      b = this[i];
	      c = input[(m = input.length - closed) - 1];
	      j = -1;
	      while (++j < m) {
	        d = input[j];
	        if (d3_geom_polygonInside(d, a, b)) {
	          if (!d3_geom_polygonInside(c, a, b)) {
	            subject.push(d3_geom_polygonIntersect(c, d, a, b));
	          }
	          subject.push(d);
	        } else if (d3_geom_polygonInside(c, a, b)) {
	          subject.push(d3_geom_polygonIntersect(c, d, a, b));
	        }
	        c = d;
	      }
	      if (closed) subject.push(subject[0]);
	      a = b;
	    }
	    return subject;
	  };
	  function d3_geom_polygonInside(p, a, b) {
	    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
	  }
	  function d3_geom_polygonIntersect(c, d, a, b) {
	    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
	    return [ x1 + ua * x21, y1 + ua * y21 ];
	  }
	  function d3_geom_polygonClosed(coordinates) {
	    var a = coordinates[0], b = coordinates[coordinates.length - 1];
	    return !(a[0] - b[0] || a[1] - b[1]);
	  }
	  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
	  function d3_geom_voronoiBeach() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.edge = this.site = this.circle = null;
	  }
	  function d3_geom_voronoiCreateBeach(site) {
	    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
	    beach.site = site;
	    return beach;
	  }
	  function d3_geom_voronoiDetachBeach(beach) {
	    d3_geom_voronoiDetachCircle(beach);
	    d3_geom_voronoiBeaches.remove(beach);
	    d3_geom_voronoiBeachPool.push(beach);
	    d3_geom_voronoiRedBlackNode(beach);
	  }
	  function d3_geom_voronoiRemoveBeach(beach) {
	    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
	      x: x,
	      y: y
	    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
	    d3_geom_voronoiDetachBeach(beach);
	    var lArc = previous;
	    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
	      previous = lArc.P;
	      disappearing.unshift(lArc);
	      d3_geom_voronoiDetachBeach(lArc);
	      lArc = previous;
	    }
	    disappearing.unshift(lArc);
	    d3_geom_voronoiDetachCircle(lArc);
	    var rArc = next;
	    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
	      next = rArc.N;
	      disappearing.push(rArc);
	      d3_geom_voronoiDetachBeach(rArc);
	      rArc = next;
	    }
	    disappearing.push(rArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var nArcs = disappearing.length, iArc;
	    for (iArc = 1; iArc < nArcs; ++iArc) {
	      rArc = disappearing[iArc];
	      lArc = disappearing[iArc - 1];
	      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
	    }
	    lArc = disappearing[0];
	    rArc = disappearing[nArcs - 1];
	    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiAddBeach(site) {
	    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
	    while (node) {
	      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
	      if (dxl > ε) node = node.L; else {
	        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
	        if (dxr > ε) {
	          if (!node.R) {
	            lArc = node;
	            break;
	          }
	          node = node.R;
	        } else {
	          if (dxl > -ε) {
	            lArc = node.P;
	            rArc = node;
	          } else if (dxr > -ε) {
	            lArc = node;
	            rArc = node.N;
	          } else {
	            lArc = rArc = node;
	          }
	          break;
	        }
	      }
	    }
	    var newArc = d3_geom_voronoiCreateBeach(site);
	    d3_geom_voronoiBeaches.insert(lArc, newArc);
	    if (!lArc && !rArc) return;
	    if (lArc === rArc) {
	      d3_geom_voronoiDetachCircle(lArc);
	      rArc = d3_geom_voronoiCreateBeach(lArc.site);
	      d3_geom_voronoiBeaches.insert(newArc, rArc);
	      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      d3_geom_voronoiAttachCircle(lArc);
	      d3_geom_voronoiAttachCircle(rArc);
	      return;
	    }
	    if (!rArc) {
	      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
	      return;
	    }
	    d3_geom_voronoiDetachCircle(lArc);
	    d3_geom_voronoiDetachCircle(rArc);
	    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
	      x: (cy * hb - by * hc) / d + ax,
	      y: (bx * hc - cx * hb) / d + ay
	    };
	    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
	    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
	    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
	    d3_geom_voronoiAttachCircle(lArc);
	    d3_geom_voronoiAttachCircle(rArc);
	  }
	  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
	    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
	    if (!pby2) return rfocx;
	    var lArc = arc.P;
	    if (!lArc) return -Infinity;
	    site = lArc.site;
	    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
	    if (!plby2) return lfocx;
	    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
	    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
	    return (rfocx + lfocx) / 2;
	  }
	  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
	    var rArc = arc.N;
	    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
	    var site = arc.site;
	    return site.y === directrix ? site.x : Infinity;
	  }
	  function d3_geom_voronoiCell(site) {
	    this.site = site;
	    this.edges = [];
	  }
	  d3_geom_voronoiCell.prototype.prepare = function() {
	    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
	    while (iHalfEdge--) {
	      edge = halfEdges[iHalfEdge].edge;
	      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
	    }
	    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
	    return halfEdges.length;
	  };
	  function d3_geom_voronoiCloseCells(extent) {
	    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
	    while (iCell--) {
	      cell = cells[iCell];
	      if (!cell || !cell.prepare()) continue;
	      halfEdges = cell.edges;
	      nHalfEdges = halfEdges.length;
	      iHalfEdge = 0;
	      while (iHalfEdge < nHalfEdges) {
	        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
	        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
	        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
	          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
	            x: x0,
	            y: abs(x2 - x0) < ε ? y2 : y1
	          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
	            x: abs(y2 - y1) < ε ? x2 : x1,
	            y: y1
	          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
	            x: x1,
	            y: abs(x2 - x1) < ε ? y2 : y0
	          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
	            x: abs(y2 - y0) < ε ? x2 : x0,
	            y: y0
	          } : null), cell.site, null));
	          ++nHalfEdges;
	        }
	      }
	    }
	  }
	  function d3_geom_voronoiHalfEdgeOrder(a, b) {
	    return b.angle - a.angle;
	  }
	  function d3_geom_voronoiCircle() {
	    d3_geom_voronoiRedBlackNode(this);
	    this.x = this.y = this.arc = this.site = this.cy = null;
	  }
	  function d3_geom_voronoiAttachCircle(arc) {
	    var lArc = arc.P, rArc = arc.N;
	    if (!lArc || !rArc) return;
	    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
	    if (lSite === rSite) return;
	    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
	    var d = 2 * (ax * cy - ay * cx);
	    if (d >= -ε2) return;
	    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
	    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
	    circle.arc = arc;
	    circle.site = cSite;
	    circle.x = x + bx;
	    circle.y = cy + Math.sqrt(x * x + y * y);
	    circle.cy = cy;
	    arc.circle = circle;
	    var before = null, node = d3_geom_voronoiCircles._;
	    while (node) {
	      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
	        if (node.L) node = node.L; else {
	          before = node.P;
	          break;
	        }
	      } else {
	        if (node.R) node = node.R; else {
	          before = node;
	          break;
	        }
	      }
	    }
	    d3_geom_voronoiCircles.insert(before, circle);
	    if (!before) d3_geom_voronoiFirstCircle = circle;
	  }
	  function d3_geom_voronoiDetachCircle(arc) {
	    var circle = arc.circle;
	    if (circle) {
	      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
	      d3_geom_voronoiCircles.remove(circle);
	      d3_geom_voronoiCirclePool.push(circle);
	      d3_geom_voronoiRedBlackNode(circle);
	      arc.circle = null;
	    }
	  }
	  function d3_geom_voronoiClipEdges(extent) {
	    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
	    while (i--) {
	      e = edges[i];
	      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
	        e.a = e.b = null;
	        edges.splice(i, 1);
	      }
	    }
	  }
	  function d3_geom_voronoiConnectEdge(edge, extent) {
	    var vb = edge.b;
	    if (vb) return true;
	    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
	    if (ry === ly) {
	      if (fx < x0 || fx >= x1) return;
	      if (lx > rx) {
	        if (!va) va = {
	          x: fx,
	          y: y0
	        }; else if (va.y >= y1) return;
	        vb = {
	          x: fx,
	          y: y1
	        };
	      } else {
	        if (!va) va = {
	          x: fx,
	          y: y1
	        }; else if (va.y < y0) return;
	        vb = {
	          x: fx,
	          y: y0
	        };
	      }
	    } else {
	      fm = (lx - rx) / (ry - ly);
	      fb = fy - fm * fx;
	      if (fm < -1 || fm > 1) {
	        if (lx > rx) {
	          if (!va) va = {
	            x: (y0 - fb) / fm,
	            y: y0
	          }; else if (va.y >= y1) return;
	          vb = {
	            x: (y1 - fb) / fm,
	            y: y1
	          };
	        } else {
	          if (!va) va = {
	            x: (y1 - fb) / fm,
	            y: y1
	          }; else if (va.y < y0) return;
	          vb = {
	            x: (y0 - fb) / fm,
	            y: y0
	          };
	        }
	      } else {
	        if (ly < ry) {
	          if (!va) va = {
	            x: x0,
	            y: fm * x0 + fb
	          }; else if (va.x >= x1) return;
	          vb = {
	            x: x1,
	            y: fm * x1 + fb
	          };
	        } else {
	          if (!va) va = {
	            x: x1,
	            y: fm * x1 + fb
	          }; else if (va.x < x0) return;
	          vb = {
	            x: x0,
	            y: fm * x0 + fb
	          };
	        }
	      }
	    }
	    edge.a = va;
	    edge.b = vb;
	    return true;
	  }
	  function d3_geom_voronoiEdge(lSite, rSite) {
	    this.l = lSite;
	    this.r = rSite;
	    this.a = this.b = null;
	  }
	  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, rSite);
	    d3_geom_voronoiEdges.push(edge);
	    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
	    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
	    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
	    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
	    return edge;
	  }
	  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
	    var edge = new d3_geom_voronoiEdge(lSite, null);
	    edge.a = va;
	    edge.b = vb;
	    d3_geom_voronoiEdges.push(edge);
	    return edge;
	  }
	  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
	    if (!edge.a && !edge.b) {
	      edge.a = vertex;
	      edge.l = lSite;
	      edge.r = rSite;
	    } else if (edge.l === rSite) {
	      edge.b = vertex;
	    } else {
	      edge.a = vertex;
	    }
	  }
	  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
	    var va = edge.a, vb = edge.b;
	    this.edge = edge;
	    this.site = lSite;
	    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
	  }
	  d3_geom_voronoiHalfEdge.prototype = {
	    start: function() {
	      return this.edge.l === this.site ? this.edge.a : this.edge.b;
	    },
	    end: function() {
	      return this.edge.l === this.site ? this.edge.b : this.edge.a;
	    }
	  };
	  function d3_geom_voronoiRedBlackTree() {
	    this._ = null;
	  }
	  function d3_geom_voronoiRedBlackNode(node) {
	    node.U = node.C = node.L = node.R = node.P = node.N = null;
	  }
	  d3_geom_voronoiRedBlackTree.prototype = {
	    insert: function(after, node) {
	      var parent, grandpa, uncle;
	      if (after) {
	        node.P = after;
	        node.N = after.N;
	        if (after.N) after.N.P = node;
	        after.N = node;
	        if (after.R) {
	          after = after.R;
	          while (after.L) after = after.L;
	          after.L = node;
	        } else {
	          after.R = node;
	        }
	        parent = after;
	      } else if (this._) {
	        after = d3_geom_voronoiRedBlackFirst(this._);
	        node.P = null;
	        node.N = after;
	        after.P = after.L = node;
	        parent = after;
	      } else {
	        node.P = node.N = null;
	        this._ = node;
	        parent = null;
	      }
	      node.L = node.R = null;
	      node.U = parent;
	      node.C = true;
	      after = node;
	      while (parent && parent.C) {
	        grandpa = parent.U;
	        if (parent === grandpa.L) {
	          uncle = grandpa.R;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.R) {
	              d3_geom_voronoiRedBlackRotateLeft(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
	          }
	        } else {
	          uncle = grandpa.L;
	          if (uncle && uncle.C) {
	            parent.C = uncle.C = false;
	            grandpa.C = true;
	            after = grandpa;
	          } else {
	            if (after === parent.L) {
	              d3_geom_voronoiRedBlackRotateRight(this, parent);
	              after = parent;
	              parent = after.U;
	            }
	            parent.C = false;
	            grandpa.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
	          }
	        }
	        parent = after.U;
	      }
	      this._.C = false;
	    },
	    remove: function(node) {
	      if (node.N) node.N.P = node.P;
	      if (node.P) node.P.N = node.N;
	      node.N = node.P = null;
	      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
	      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
	      if (parent) {
	        if (parent.L === node) parent.L = next; else parent.R = next;
	      } else {
	        this._ = next;
	      }
	      if (left && right) {
	        red = next.C;
	        next.C = node.C;
	        next.L = left;
	        left.U = next;
	        if (next !== right) {
	          parent = next.U;
	          next.U = node.U;
	          node = next.R;
	          parent.L = node;
	          next.R = right;
	          right.U = next;
	        } else {
	          next.U = parent;
	          parent = next;
	          node = next.R;
	        }
	      } else {
	        red = node.C;
	        node = next;
	      }
	      if (node) node.U = parent;
	      if (red) return;
	      if (node && node.C) {
	        node.C = false;
	        return;
	      }
	      do {
	        if (node === this._) break;
	        if (node === parent.L) {
	          sibling = parent.R;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            sibling = parent.R;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.R || !sibling.R.C) {
	              sibling.L.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateRight(this, sibling);
	              sibling = parent.R;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.R.C = false;
	            d3_geom_voronoiRedBlackRotateLeft(this, parent);
	            node = this._;
	            break;
	          }
	        } else {
	          sibling = parent.L;
	          if (sibling.C) {
	            sibling.C = false;
	            parent.C = true;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            sibling = parent.L;
	          }
	          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
	            if (!sibling.L || !sibling.L.C) {
	              sibling.R.C = false;
	              sibling.C = true;
	              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
	              sibling = parent.L;
	            }
	            sibling.C = parent.C;
	            parent.C = sibling.L.C = false;
	            d3_geom_voronoiRedBlackRotateRight(this, parent);
	            node = this._;
	            break;
	          }
	        }
	        sibling.C = true;
	        node = parent;
	        parent = parent.U;
	      } while (!node.C);
	      if (node) node.C = false;
	    }
	  };
	  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
	    var p = node, q = node.R, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.R = q.L;
	    if (p.R) p.R.U = p;
	    q.L = p;
	  }
	  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
	    var p = node, q = node.L, parent = p.U;
	    if (parent) {
	      if (parent.L === p) parent.L = q; else parent.R = q;
	    } else {
	      tree._ = q;
	    }
	    q.U = parent;
	    p.U = q;
	    p.L = q.R;
	    if (p.L) p.L.U = p;
	    q.R = p;
	  }
	  function d3_geom_voronoiRedBlackFirst(node) {
	    while (node.L) node = node.L;
	    return node;
	  }
	  function d3_geom_voronoi(sites, bbox) {
	    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
	    d3_geom_voronoiEdges = [];
	    d3_geom_voronoiCells = new Array(sites.length);
	    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
	    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
	    while (true) {
	      circle = d3_geom_voronoiFirstCircle;
	      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
	        if (site.x !== x0 || site.y !== y0) {
	          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
	          d3_geom_voronoiAddBeach(site);
	          x0 = site.x, y0 = site.y;
	        }
	        site = sites.pop();
	      } else if (circle) {
	        d3_geom_voronoiRemoveBeach(circle.arc);
	      } else {
	        break;
	      }
	    }
	    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
	    var diagram = {
	      cells: d3_geom_voronoiCells,
	      edges: d3_geom_voronoiEdges
	    };
	    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
	    return diagram;
	  }
	  function d3_geom_voronoiVertexOrder(a, b) {
	    return b.y - a.y || b.x - a.x;
	  }
	  d3.geom.voronoi = function(points) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
	    if (points) return voronoi(points);
	    function voronoi(data) {
	      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
	      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
	        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
	          var s = e.start();
	          return [ s.x, s.y ];
	        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
	        polygon.point = data[i];
	      });
	      return polygons;
	    }
	    function sites(data) {
	      return data.map(function(d, i) {
	        return {
	          x: Math.round(fx(d, i) / ε) * ε,
	          y: Math.round(fy(d, i) / ε) * ε,
	          i: i
	        };
	      });
	    }
	    voronoi.links = function(data) {
	      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
	        return edge.l && edge.r;
	      }).map(function(edge) {
	        return {
	          source: data[edge.l.i],
	          target: data[edge.r.i]
	        };
	      });
	    };
	    voronoi.triangles = function(data) {
	      var triangles = [];
	      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
	        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
	        while (++j < m) {
	          e0 = e1;
	          s0 = s1;
	          e1 = edges[j].edge;
	          s1 = e1.l === site ? e1.r : e1.l;
	          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
	            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
	          }
	        }
	      });
	      return triangles;
	    };
	    voronoi.x = function(_) {
	      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
	    };
	    voronoi.y = function(_) {
	      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
	    };
	    voronoi.clipExtent = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
	      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
	      return voronoi;
	    };
	    voronoi.size = function(_) {
	      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
	      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
	    };
	    return voronoi;
	  };
	  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
	  function d3_geom_voronoiTriangleArea(a, b, c) {
	    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
	  }
	  d3.geom.delaunay = function(vertices) {
	    return d3.geom.voronoi().triangles(vertices);
	  };
	  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
	    if (compat = arguments.length) {
	      x = d3_geom_quadtreeCompatX;
	      y = d3_geom_quadtreeCompatY;
	      if (compat === 3) {
	        y2 = y1;
	        x2 = x1;
	        y1 = x1 = 0;
	      }
	      return quadtree(points);
	    }
	    function quadtree(data) {
	      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
	      if (x1 != null) {
	        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
	      } else {
	        x2_ = y2_ = -(x1_ = y1_ = Infinity);
	        xs = [], ys = [];
	        n = data.length;
	        if (compat) for (i = 0; i < n; ++i) {
	          d = data[i];
	          if (d.x < x1_) x1_ = d.x;
	          if (d.y < y1_) y1_ = d.y;
	          if (d.x > x2_) x2_ = d.x;
	          if (d.y > y2_) y2_ = d.y;
	          xs.push(d.x);
	          ys.push(d.y);
	        } else for (i = 0; i < n; ++i) {
	          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
	          if (x_ < x1_) x1_ = x_;
	          if (y_ < y1_) y1_ = y_;
	          if (x_ > x2_) x2_ = x_;
	          if (y_ > y2_) y2_ = y_;
	          xs.push(x_);
	          ys.push(y_);
	        }
	      }
	      var dx = x2_ - x1_, dy = y2_ - y1_;
	      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
	      function insert(n, d, x, y, x1, y1, x2, y2) {
	        if (isNaN(x) || isNaN(y)) return;
	        if (n.leaf) {
	          var nx = n.x, ny = n.y;
	          if (nx != null) {
	            if (abs(nx - x) + abs(ny - y) < .01) {
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            } else {
	              var nPoint = n.point;
	              n.x = n.y = n.point = null;
	              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
	              insertChild(n, d, x, y, x1, y1, x2, y2);
	            }
	          } else {
	            n.x = x, n.y = y, n.point = d;
	          }
	        } else {
	          insertChild(n, d, x, y, x1, y1, x2, y2);
	        }
	      }
	      function insertChild(n, d, x, y, x1, y1, x2, y2) {
	        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
	        n.leaf = false;
	        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
	        if (right) x1 = xm; else x2 = xm;
	        if (below) y1 = ym; else y2 = ym;
	        insert(n, d, x, y, x1, y1, x2, y2);
	      }
	      var root = d3_geom_quadtreeNode();
	      root.add = function(d) {
	        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
	      };
	      root.visit = function(f) {
	        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
	      };
	      root.find = function(point) {
	        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
	      };
	      i = -1;
	      if (x1 == null) {
	        while (++i < n) {
	          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
	        }
	        --i;
	      } else data.forEach(root.add);
	      xs = ys = data = d = null;
	      return root;
	    }
	    quadtree.x = function(_) {
	      return arguments.length ? (x = _, quadtree) : x;
	    };
	    quadtree.y = function(_) {
	      return arguments.length ? (y = _, quadtree) : y;
	    };
	    quadtree.extent = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
	      y2 = +_[1][1];
	      return quadtree;
	    };
	    quadtree.size = function(_) {
	      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
	      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
	      return quadtree;
	    };
	    return quadtree;
	  };
	  function d3_geom_quadtreeCompatX(d) {
	    return d.x;
	  }
	  function d3_geom_quadtreeCompatY(d) {
	    return d.y;
	  }
	  function d3_geom_quadtreeNode() {
	    return {
	      leaf: true,
	      nodes: [],
	      point: null,
	      x: null,
	      y: null
	    };
	  }
	  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
	    if (!f(node, x1, y1, x2, y2)) {
	      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
	      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
	      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
	      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
	      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
	    }
	  }
	  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
	    var minDistance2 = Infinity, closestPoint;
	    (function find(node, x1, y1, x2, y2) {
	      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
	      if (point = node.point) {
	        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
	        if (distance2 < minDistance2) {
	          var distance = Math.sqrt(minDistance2 = distance2);
	          x0 = x - distance, y0 = y - distance;
	          x3 = x + distance, y3 = y + distance;
	          closestPoint = point;
	        }
	      }
	      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
	      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
	        if (node = children[i & 3]) switch (i & 3) {
	         case 0:
	          find(node, x1, y1, xm, ym);
	          break;
	
	         case 1:
	          find(node, xm, y1, x2, ym);
	          break;
	
	         case 2:
	          find(node, x1, ym, xm, y2);
	          break;
	
	         case 3:
	          find(node, xm, ym, x2, y2);
	          break;
	        }
	      }
	    })(root, x0, y0, x3, y3);
	    return closestPoint;
	  }
	  d3.interpolateRgb = d3_interpolateRgb;
	  function d3_interpolateRgb(a, b) {
	    a = d3.rgb(a);
	    b = d3.rgb(b);
	    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
	    return function(t) {
	      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
	    };
	  }
	  d3.interpolateObject = d3_interpolateObject;
	  function d3_interpolateObject(a, b) {
	    var i = {}, c = {}, k;
	    for (k in a) {
	      if (k in b) {
	        i[k] = d3_interpolate(a[k], b[k]);
	      } else {
	        c[k] = a[k];
	      }
	    }
	    for (k in b) {
	      if (!(k in a)) {
	        c[k] = b[k];
	      }
	    }
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	  d3.interpolateNumber = d3_interpolateNumber;
	  function d3_interpolateNumber(a, b) {
	    a = +a, b = +b;
	    return function(t) {
	      return a * (1 - t) + b * t;
	    };
	  }
	  d3.interpolateString = d3_interpolateString;
	  function d3_interpolateString(a, b) {
	    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
	    a = a + "", b = b + "";
	    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
	      if ((bs = bm.index) > bi) {
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) {
	        if (s[i]) s[i] += bm; else s[++i] = bm;
	      } else {
	        s[++i] = null;
	        q.push({
	          i: i,
	          x: d3_interpolateNumber(am, bm)
	        });
	      }
	      bi = d3_interpolate_numberB.lastIndex;
	    }
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; else s[++i] = bs;
	    }
	    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
	      return b(t) + "";
	    }) : function() {
	      return b;
	    } : (b = q.length, function(t) {
	      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    });
	  }
	  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
	  d3.interpolate = d3_interpolate;
	  function d3_interpolate(a, b) {
	    var i = d3.interpolators.length, f;
	    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
	    return f;
	  }
	  d3.interpolators = [ function(a, b) {
	    var t = typeof b;
	    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
	  } ];
	  d3.interpolateArray = d3_interpolateArray;
	  function d3_interpolateArray(a, b) {
	    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
	    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
	    for (;i < na; ++i) c[i] = a[i];
	    for (;i < nb; ++i) c[i] = b[i];
	    return function(t) {
	      for (i = 0; i < n0; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	  var d3_ease_default = function() {
	    return d3_identity;
	  };
	  var d3_ease = d3.map({
	    linear: d3_ease_default,
	    poly: d3_ease_poly,
	    quad: function() {
	      return d3_ease_quad;
	    },
	    cubic: function() {
	      return d3_ease_cubic;
	    },
	    sin: function() {
	      return d3_ease_sin;
	    },
	    exp: function() {
	      return d3_ease_exp;
	    },
	    circle: function() {
	      return d3_ease_circle;
	    },
	    elastic: d3_ease_elastic,
	    back: d3_ease_back,
	    bounce: function() {
	      return d3_ease_bounce;
	    }
	  });
	  var d3_ease_mode = d3.map({
	    "in": d3_identity,
	    out: d3_ease_reverse,
	    "in-out": d3_ease_reflect,
	    "out-in": function(f) {
	      return d3_ease_reflect(d3_ease_reverse(f));
	    }
	  });
	  d3.ease = function(name) {
	    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
	    t = d3_ease.get(t) || d3_ease_default;
	    m = d3_ease_mode.get(m) || d3_identity;
	    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
	  };
	  function d3_ease_clamp(f) {
	    return function(t) {
	      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
	    };
	  }
	  function d3_ease_reverse(f) {
	    return function(t) {
	      return 1 - f(1 - t);
	    };
	  }
	  function d3_ease_reflect(f) {
	    return function(t) {
	      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
	    };
	  }
	  function d3_ease_quad(t) {
	    return t * t;
	  }
	  function d3_ease_cubic(t) {
	    return t * t * t;
	  }
	  function d3_ease_cubicInOut(t) {
	    if (t <= 0) return 0;
	    if (t >= 1) return 1;
	    var t2 = t * t, t3 = t2 * t;
	    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
	  }
	  function d3_ease_poly(e) {
	    return function(t) {
	      return Math.pow(t, e);
	    };
	  }
	  function d3_ease_sin(t) {
	    return 1 - Math.cos(t * halfπ);
	  }
	  function d3_ease_exp(t) {
	    return Math.pow(2, 10 * (t - 1));
	  }
	  function d3_ease_circle(t) {
	    return 1 - Math.sqrt(1 - t * t);
	  }
	  function d3_ease_elastic(a, p) {
	    var s;
	    if (arguments.length < 2) p = .45;
	    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
	    return function(t) {
	      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
	    };
	  }
	  function d3_ease_back(s) {
	    if (!s) s = 1.70158;
	    return function(t) {
	      return t * t * ((s + 1) * t - s);
	    };
	  }
	  function d3_ease_bounce(t) {
	    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
	  }
	  d3.interpolateHcl = d3_interpolateHcl;
	  function d3_interpolateHcl(a, b) {
	    a = d3.hcl(a);
	    b = d3.hcl(b);
	    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
	    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateHsl = d3_interpolateHsl;
	  function d3_interpolateHsl(a, b) {
	    a = d3.hsl(a);
	    b = d3.hsl(b);
	    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
	    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
	    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
	    return function(t) {
	      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
	    };
	  }
	  d3.interpolateLab = d3_interpolateLab;
	  function d3_interpolateLab(a, b) {
	    a = d3.lab(a);
	    b = d3.lab(b);
	    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
	    return function(t) {
	      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
	    };
	  }
	  d3.interpolateRound = d3_interpolateRound;
	  function d3_interpolateRound(a, b) {
	    b -= a;
	    return function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	  d3.transform = function(string) {
	    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
	    return (d3.transform = function(string) {
	      if (string != null) {
	        g.setAttribute("transform", string);
	        var t = g.transform.baseVal.consolidate();
	      }
	      return new d3_transform(t ? t.matrix : d3_transformIdentity);
	    })(string);
	  };
	  function d3_transform(m) {
	    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
	    if (r0[0] * r1[1] < r1[0] * r0[1]) {
	      r0[0] *= -1;
	      r0[1] *= -1;
	      kx *= -1;
	      kz *= -1;
	    }
	    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
	    this.translate = [ m.e, m.f ];
	    this.scale = [ kx, ky ];
	    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
	  }
	  d3_transform.prototype.toString = function() {
	    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
	  };
	  function d3_transformDot(a, b) {
	    return a[0] * b[0] + a[1] * b[1];
	  }
	  function d3_transformNormalize(a) {
	    var k = Math.sqrt(d3_transformDot(a, a));
	    if (k) {
	      a[0] /= k;
	      a[1] /= k;
	    }
	    return k;
	  }
	  function d3_transformCombine(a, b, k) {
	    a[0] += k * b[0];
	    a[1] += k * b[1];
	    return a;
	  }
	  var d3_transformIdentity = {
	    a: 1,
	    b: 0,
	    c: 0,
	    d: 1,
	    e: 0,
	    f: 0
	  };
	  d3.interpolateTransform = d3_interpolateTransform;
	  function d3_interpolateTransformPop(s) {
	    return s.length ? s.pop() + "," : "";
	  }
	  function d3_interpolateTranslate(ta, tb, s, q) {
	    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
	      var i = s.push("translate(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ta[0], tb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ta[1], tb[1])
	      });
	    } else if (tb[0] || tb[1]) {
	      s.push("translate(" + tb + ")");
	    }
	  }
	  function d3_interpolateRotate(ra, rb, s, q) {
	    if (ra !== rb) {
	      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
	        x: d3_interpolateNumber(ra, rb)
	      });
	    } else if (rb) {
	      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
	    }
	  }
	  function d3_interpolateSkew(wa, wb, s, q) {
	    if (wa !== wb) {
	      q.push({
	        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
	        x: d3_interpolateNumber(wa, wb)
	      });
	    } else if (wb) {
	      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
	    }
	  }
	  function d3_interpolateScale(ka, kb, s, q) {
	    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
	      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
	      q.push({
	        i: i - 4,
	        x: d3_interpolateNumber(ka[0], kb[0])
	      }, {
	        i: i - 2,
	        x: d3_interpolateNumber(ka[1], kb[1])
	      });
	    } else if (kb[0] !== 1 || kb[1] !== 1) {
	      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
	    }
	  }
	  function d3_interpolateTransform(a, b) {
	    var s = [], q = [];
	    a = d3.transform(a), b = d3.transform(b);
	    d3_interpolateTranslate(a.translate, b.translate, s, q);
	    d3_interpolateRotate(a.rotate, b.rotate, s, q);
	    d3_interpolateSkew(a.skew, b.skew, s, q);
	    d3_interpolateScale(a.scale, b.scale, s, q);
	    a = b = null;
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  }
	  function d3_uninterpolateNumber(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return (x - a) / b;
	    };
	  }
	  function d3_uninterpolateClamp(a, b) {
	    b = (b -= a = +a) || 1 / b;
	    return function(x) {
	      return Math.max(0, Math.min(1, (x - a) / b));
	    };
	  }
	  d3.layout = {};
	  d3.layout.bundle = function() {
	    return function(links) {
	      var paths = [], i = -1, n = links.length;
	      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
	      return paths;
	    };
	  };
	  function d3_layout_bundlePath(link) {
	    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
	    while (start !== lca) {
	      start = start.parent;
	      points.push(start);
	    }
	    var k = points.length;
	    while (end !== lca) {
	      points.splice(k, 0, end);
	      end = end.parent;
	    }
	    return points;
	  }
	  function d3_layout_bundleAncestors(node) {
	    var ancestors = [], parent = node.parent;
	    while (parent != null) {
	      ancestors.push(node);
	      node = parent;
	      parent = parent.parent;
	    }
	    ancestors.push(node);
	    return ancestors;
	  }
	  function d3_layout_bundleLeastCommonAncestor(a, b) {
	    if (a === b) return a;
	    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
	    while (aNode === bNode) {
	      sharedNode = aNode;
	      aNode = aNodes.pop();
	      bNode = bNodes.pop();
	    }
	    return sharedNode;
	  }
	  d3.layout.chord = function() {
	    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
	    function relayout() {
	      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
	      chords = [];
	      groups = [];
	      k = 0, i = -1;
	      while (++i < n) {
	        x = 0, j = -1;
	        while (++j < n) {
	          x += matrix[i][j];
	        }
	        groupSums.push(x);
	        subgroupIndex.push(d3.range(n));
	        k += x;
	      }
	      if (sortGroups) {
	        groupIndex.sort(function(a, b) {
	          return sortGroups(groupSums[a], groupSums[b]);
	        });
	      }
	      if (sortSubgroups) {
	        subgroupIndex.forEach(function(d, i) {
	          d.sort(function(a, b) {
	            return sortSubgroups(matrix[i][a], matrix[i][b]);
	          });
	        });
	      }
	      k = (τ - padding * n) / k;
	      x = 0, i = -1;
	      while (++i < n) {
	        x0 = x, j = -1;
	        while (++j < n) {
	          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
	          subgroups[di + "-" + dj] = {
	            index: di,
	            subindex: dj,
	            startAngle: a0,
	            endAngle: a1,
	            value: v
	          };
	        }
	        groups[di] = {
	          index: di,
	          startAngle: x0,
	          endAngle: x,
	          value: groupSums[di]
	        };
	        x += padding;
	      }
	      i = -1;
	      while (++i < n) {
	        j = i - 1;
	        while (++j < n) {
	          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
	          if (source.value || target.value) {
	            chords.push(source.value < target.value ? {
	              source: target,
	              target: source
	            } : {
	              source: source,
	              target: target
	            });
	          }
	        }
	      }
	      if (sortChords) resort();
	    }
	    function resort() {
	      chords.sort(function(a, b) {
	        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
	      });
	    }
	    chord.matrix = function(x) {
	      if (!arguments.length) return matrix;
	      n = (matrix = x) && matrix.length;
	      chords = groups = null;
	      return chord;
	    };
	    chord.padding = function(x) {
	      if (!arguments.length) return padding;
	      padding = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortGroups = function(x) {
	      if (!arguments.length) return sortGroups;
	      sortGroups = x;
	      chords = groups = null;
	      return chord;
	    };
	    chord.sortSubgroups = function(x) {
	      if (!arguments.length) return sortSubgroups;
	      sortSubgroups = x;
	      chords = null;
	      return chord;
	    };
	    chord.sortChords = function(x) {
	      if (!arguments.length) return sortChords;
	      sortChords = x;
	      if (chords) resort();
	      return chord;
	    };
	    chord.chords = function() {
	      if (!chords) relayout();
	      return chords;
	    };
	    chord.groups = function() {
	      if (!groups) relayout();
	      return groups;
	    };
	    return chord;
	  };
	  d3.layout.force = function() {
	    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
	    function repulse(node) {
	      return function(quad, x1, _, x2) {
	        if (quad.point !== node) {
	          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
	          if (dw * dw / theta2 < dn) {
	            if (dn < chargeDistance2) {
	              var k = quad.charge / dn;
	              node.px -= dx * k;
	              node.py -= dy * k;
	            }
	            return true;
	          }
	          if (quad.point && dn && dn < chargeDistance2) {
	            var k = quad.pointCharge / dn;
	            node.px -= dx * k;
	            node.py -= dy * k;
	          }
	        }
	        return !quad.charge;
	      };
	    }
	    force.tick = function() {
	      if ((alpha *= .99) < .005) {
	        timer = null;
	        event.end({
	          type: "end",
	          alpha: alpha = 0
	        });
	        return true;
	      }
	      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        s = o.source;
	        t = o.target;
	        x = t.x - s.x;
	        y = t.y - s.y;
	        if (l = x * x + y * y) {
	          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
	          x *= l;
	          y *= l;
	          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
	          t.y -= y * k;
	          s.x += x * (k = 1 - k);
	          s.y += y * k;
	        }
	      }
	      if (k = alpha * gravity) {
	        x = size[0] / 2;
	        y = size[1] / 2;
	        i = -1;
	        if (k) while (++i < n) {
	          o = nodes[i];
	          o.x += (x - o.x) * k;
	          o.y += (y - o.y) * k;
	        }
	      }
	      if (charge) {
	        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
	        i = -1;
	        while (++i < n) {
	          if (!(o = nodes[i]).fixed) {
	            q.visit(repulse(o));
	          }
	        }
	      }
	      i = -1;
	      while (++i < n) {
	        o = nodes[i];
	        if (o.fixed) {
	          o.x = o.px;
	          o.y = o.py;
	        } else {
	          o.x -= (o.px - (o.px = o.x)) * friction;
	          o.y -= (o.py - (o.py = o.y)) * friction;
	        }
	      }
	      event.tick({
	        type: "tick",
	        alpha: alpha
	      });
	    };
	    force.nodes = function(x) {
	      if (!arguments.length) return nodes;
	      nodes = x;
	      return force;
	    };
	    force.links = function(x) {
	      if (!arguments.length) return links;
	      links = x;
	      return force;
	    };
	    force.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return force;
	    };
	    force.linkDistance = function(x) {
	      if (!arguments.length) return linkDistance;
	      linkDistance = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.distance = force.linkDistance;
	    force.linkStrength = function(x) {
	      if (!arguments.length) return linkStrength;
	      linkStrength = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.friction = function(x) {
	      if (!arguments.length) return friction;
	      friction = +x;
	      return force;
	    };
	    force.charge = function(x) {
	      if (!arguments.length) return charge;
	      charge = typeof x === "function" ? x : +x;
	      return force;
	    };
	    force.chargeDistance = function(x) {
	      if (!arguments.length) return Math.sqrt(chargeDistance2);
	      chargeDistance2 = x * x;
	      return force;
	    };
	    force.gravity = function(x) {
	      if (!arguments.length) return gravity;
	      gravity = +x;
	      return force;
	    };
	    force.theta = function(x) {
	      if (!arguments.length) return Math.sqrt(theta2);
	      theta2 = x * x;
	      return force;
	    };
	    force.alpha = function(x) {
	      if (!arguments.length) return alpha;
	      x = +x;
	      if (alpha) {
	        if (x > 0) {
	          alpha = x;
	        } else {
	          timer.c = null, timer.t = NaN, timer = null;
	          event.end({
	            type: "end",
	            alpha: alpha = 0
	          });
	        }
	      } else if (x > 0) {
	        event.start({
	          type: "start",
	          alpha: alpha = x
	        });
	        timer = d3_timer(force.tick);
	      }
	      return force;
	    };
	    force.start = function() {
	      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
	      for (i = 0; i < n; ++i) {
	        (o = nodes[i]).index = i;
	        o.weight = 0;
	      }
	      for (i = 0; i < m; ++i) {
	        o = links[i];
	        if (typeof o.source == "number") o.source = nodes[o.source];
	        if (typeof o.target == "number") o.target = nodes[o.target];
	        ++o.source.weight;
	        ++o.target.weight;
	      }
	      for (i = 0; i < n; ++i) {
	        o = nodes[i];
	        if (isNaN(o.x)) o.x = position("x", w);
	        if (isNaN(o.y)) o.y = position("y", h);
	        if (isNaN(o.px)) o.px = o.x;
	        if (isNaN(o.py)) o.py = o.y;
	      }
	      distances = [];
	      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
	      strengths = [];
	      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
	      charges = [];
	      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
	      function position(dimension, size) {
	        if (!neighbors) {
	          neighbors = new Array(n);
	          for (j = 0; j < n; ++j) {
	            neighbors[j] = [];
	          }
	          for (j = 0; j < m; ++j) {
	            var o = links[j];
	            neighbors[o.source.index].push(o.target);
	            neighbors[o.target.index].push(o.source);
	          }
	        }
	        var candidates = neighbors[i], j = -1, l = candidates.length, x;
	        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
	        return Math.random() * size;
	      }
	      return force.resume();
	    };
	    force.resume = function() {
	      return force.alpha(.1);
	    };
	    force.stop = function() {
	      return force.alpha(0);
	    };
	    force.drag = function() {
	      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
	      if (!arguments.length) return drag;
	      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
	    };
	    function dragmove(d) {
	      d.px = d3.event.x, d.py = d3.event.y;
	      force.resume();
	    }
	    return d3.rebind(force, event, "on");
	  };
	  function d3_layout_forceDragstart(d) {
	    d.fixed |= 2;
	  }
	  function d3_layout_forceDragend(d) {
	    d.fixed &= ~6;
	  }
	  function d3_layout_forceMouseover(d) {
	    d.fixed |= 4;
	    d.px = d.x, d.py = d.y;
	  }
	  function d3_layout_forceMouseout(d) {
	    d.fixed &= ~4;
	  }
	  function d3_layout_forceAccumulate(quad, alpha, charges) {
	    var cx = 0, cy = 0;
	    quad.charge = 0;
	    if (!quad.leaf) {
	      var nodes = quad.nodes, n = nodes.length, i = -1, c;
	      while (++i < n) {
	        c = nodes[i];
	        if (c == null) continue;
	        d3_layout_forceAccumulate(c, alpha, charges);
	        quad.charge += c.charge;
	        cx += c.charge * c.cx;
	        cy += c.charge * c.cy;
	      }
	    }
	    if (quad.point) {
	      if (!quad.leaf) {
	        quad.point.x += Math.random() - .5;
	        quad.point.y += Math.random() - .5;
	      }
	      var k = alpha * charges[quad.point.index];
	      quad.charge += quad.pointCharge = k;
	      cx += k * quad.point.x;
	      cy += k * quad.point.y;
	    }
	    quad.cx = cx / quad.charge;
	    quad.cy = cy / quad.charge;
	  }
	  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
	  d3.layout.hierarchy = function() {
	    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
	    function hierarchy(root) {
	      var stack = [ root ], nodes = [], node;
	      root.depth = 0;
	      while ((node = stack.pop()) != null) {
	        nodes.push(node);
	        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
	          var n, childs, child;
	          while (--n >= 0) {
	            stack.push(child = childs[n]);
	            child.parent = node;
	            child.depth = node.depth + 1;
	          }
	          if (value) node.value = 0;
	          node.children = childs;
	        } else {
	          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          delete node.children;
	        }
	      }
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var childs, parent;
	        if (sort && (childs = node.children)) childs.sort(sort);
	        if (value && (parent = node.parent)) parent.value += node.value;
	      });
	      return nodes;
	    }
	    hierarchy.sort = function(x) {
	      if (!arguments.length) return sort;
	      sort = x;
	      return hierarchy;
	    };
	    hierarchy.children = function(x) {
	      if (!arguments.length) return children;
	      children = x;
	      return hierarchy;
	    };
	    hierarchy.value = function(x) {
	      if (!arguments.length) return value;
	      value = x;
	      return hierarchy;
	    };
	    hierarchy.revalue = function(root) {
	      if (value) {
	        d3_layout_hierarchyVisitBefore(root, function(node) {
	          if (node.children) node.value = 0;
	        });
	        d3_layout_hierarchyVisitAfter(root, function(node) {
	          var parent;
	          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
	          if (parent = node.parent) parent.value += node.value;
	        });
	      }
	      return root;
	    };
	    return hierarchy;
	  };
	  function d3_layout_hierarchyRebind(object, hierarchy) {
	    d3.rebind(object, hierarchy, "sort", "children", "value");
	    object.nodes = object;
	    object.links = d3_layout_hierarchyLinks;
	    return object;
	  }
	  function d3_layout_hierarchyVisitBefore(node, callback) {
	    var nodes = [ node ];
	    while ((node = nodes.pop()) != null) {
	      callback(node);
	      if ((children = node.children) && (n = children.length)) {
	        var n, children;
	        while (--n >= 0) nodes.push(children[n]);
	      }
	    }
	  }
	  function d3_layout_hierarchyVisitAfter(node, callback) {
	    var nodes = [ node ], nodes2 = [];
	    while ((node = nodes.pop()) != null) {
	      nodes2.push(node);
	      if ((children = node.children) && (n = children.length)) {
	        var i = -1, n, children;
	        while (++i < n) nodes.push(children[i]);
	      }
	    }
	    while ((node = nodes2.pop()) != null) {
	      callback(node);
	    }
	  }
	  function d3_layout_hierarchyChildren(d) {
	    return d.children;
	  }
	  function d3_layout_hierarchyValue(d) {
	    return d.value;
	  }
	  function d3_layout_hierarchySort(a, b) {
	    return b.value - a.value;
	  }
	  function d3_layout_hierarchyLinks(nodes) {
	    return d3.merge(nodes.map(function(parent) {
	      return (parent.children || []).map(function(child) {
	        return {
	          source: parent,
	          target: child
	        };
	      });
	    }));
	  }
	  d3.layout.partition = function() {
	    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
	    function position(node, x, dx, dy) {
	      var children = node.children;
	      node.x = x;
	      node.y = node.depth * dy;
	      node.dx = dx;
	      node.dy = dy;
	      if (children && (n = children.length)) {
	        var i = -1, n, c, d;
	        dx = node.value ? dx / node.value : 0;
	        while (++i < n) {
	          position(c = children[i], x, d = c.value * dx, dy);
	          x += d;
	        }
	      }
	    }
	    function depth(node) {
	      var children = node.children, d = 0;
	      if (children && (n = children.length)) {
	        var i = -1, n;
	        while (++i < n) d = Math.max(d, depth(children[i]));
	      }
	      return 1 + d;
	    }
	    function partition(d, i) {
	      var nodes = hierarchy.call(this, d, i);
	      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
	      return nodes;
	    }
	    partition.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return partition;
	    };
	    return d3_layout_hierarchyRebind(partition, hierarchy);
	  };
	  d3.layout.pie = function() {
	    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
	    function pie(data) {
	      var n = data.length, values = data.map(function(d, i) {
	        return +value.call(pie, d, i);
	      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
	      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
	        return values[j] - values[i];
	      } : function(i, j) {
	        return sort(data[i], data[j]);
	      });
	      index.forEach(function(i) {
	        arcs[i] = {
	          data: data[i],
	          value: v = values[i],
	          startAngle: a,
	          endAngle: a += v * k + pa,
	          padAngle: p
	        };
	      });
	      return arcs;
	    }
	    pie.value = function(_) {
	      if (!arguments.length) return value;
	      value = _;
	      return pie;
	    };
	    pie.sort = function(_) {
	      if (!arguments.length) return sort;
	      sort = _;
	      return pie;
	    };
	    pie.startAngle = function(_) {
	      if (!arguments.length) return startAngle;
	      startAngle = _;
	      return pie;
	    };
	    pie.endAngle = function(_) {
	      if (!arguments.length) return endAngle;
	      endAngle = _;
	      return pie;
	    };
	    pie.padAngle = function(_) {
	      if (!arguments.length) return padAngle;
	      padAngle = _;
	      return pie;
	    };
	    return pie;
	  };
	  var d3_layout_pieSortByValue = {};
	  d3.layout.stack = function() {
	    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
	    function stack(data, index) {
	      if (!(n = data.length)) return data;
	      var series = data.map(function(d, i) {
	        return values.call(stack, d, i);
	      });
	      var points = series.map(function(d) {
	        return d.map(function(v, i) {
	          return [ x.call(stack, v, i), y.call(stack, v, i) ];
	        });
	      });
	      var orders = order.call(stack, points, index);
	      series = d3.permute(series, orders);
	      points = d3.permute(points, orders);
	      var offsets = offset.call(stack, points, index);
	      var m = series[0].length, n, i, j, o;
	      for (j = 0; j < m; ++j) {
	        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
	        for (i = 1; i < n; ++i) {
	          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
	        }
	      }
	      return data;
	    }
	    stack.values = function(x) {
	      if (!arguments.length) return values;
	      values = x;
	      return stack;
	    };
	    stack.order = function(x) {
	      if (!arguments.length) return order;
	      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
	      return stack;
	    };
	    stack.offset = function(x) {
	      if (!arguments.length) return offset;
	      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
	      return stack;
	    };
	    stack.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      return stack;
	    };
	    stack.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      return stack;
	    };
	    stack.out = function(z) {
	      if (!arguments.length) return out;
	      out = z;
	      return stack;
	    };
	    return stack;
	  };
	  function d3_layout_stackX(d) {
	    return d.x;
	  }
	  function d3_layout_stackY(d) {
	    return d.y;
	  }
	  function d3_layout_stackOut(d, y0, y) {
	    d.y0 = y0;
	    d.y = y;
	  }
	  var d3_layout_stackOrders = d3.map({
	    "inside-out": function(data) {
	      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
	        return max[a] - max[b];
	      }), top = 0, bottom = 0, tops = [], bottoms = [];
	      for (i = 0; i < n; ++i) {
	        j = index[i];
	        if (top < bottom) {
	          top += sums[j];
	          tops.push(j);
	        } else {
	          bottom += sums[j];
	          bottoms.push(j);
	        }
	      }
	      return bottoms.reverse().concat(tops);
	    },
	    reverse: function(data) {
	      return d3.range(data.length).reverse();
	    },
	    "default": d3_layout_stackOrderDefault
	  });
	  var d3_layout_stackOffsets = d3.map({
	    silhouette: function(data) {
	      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o > max) max = o;
	        sums.push(o);
	      }
	      for (j = 0; j < m; ++j) {
	        y0[j] = (max - sums[j]) / 2;
	      }
	      return y0;
	    },
	    wiggle: function(data) {
	      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
	      y0[0] = o = o0 = 0;
	      for (j = 1; j < m; ++j) {
	        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
	        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
	          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
	            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
	          }
	          s2 += s3 * data[i][j][1];
	        }
	        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
	        if (o < o0) o0 = o;
	      }
	      for (j = 0; j < m; ++j) y0[j] -= o0;
	      return y0;
	    },
	    expand: function(data) {
	      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
	      for (j = 0; j < m; ++j) {
	        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
	        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
	      }
	      for (j = 0; j < m; ++j) y0[j] = 0;
	      return y0;
	    },
	    zero: d3_layout_stackOffsetZero
	  });
	  function d3_layout_stackOrderDefault(data) {
	    return d3.range(data.length);
	  }
	  function d3_layout_stackOffsetZero(data) {
	    var j = -1, m = data[0].length, y0 = [];
	    while (++j < m) y0[j] = 0;
	    return y0;
	  }
	  function d3_layout_stackMaxIndex(array) {
	    var i = 1, j = 0, v = array[0][1], k, n = array.length;
	    for (;i < n; ++i) {
	      if ((k = array[i][1]) > v) {
	        j = i;
	        v = k;
	      }
	    }
	    return j;
	  }
	  function d3_layout_stackReduceSum(d) {
	    return d.reduce(d3_layout_stackSum, 0);
	  }
	  function d3_layout_stackSum(p, d) {
	    return p + d[1];
	  }
	  d3.layout.histogram = function() {
	    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
	    function histogram(data, i) {
	      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
	      while (++i < m) {
	        bin = bins[i] = [];
	        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
	        bin.y = 0;
	      }
	      if (m > 0) {
	        i = -1;
	        while (++i < n) {
	          x = values[i];
	          if (x >= range[0] && x <= range[1]) {
	            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
	            bin.y += k;
	            bin.push(data[i]);
	          }
	        }
	      }
	      return bins;
	    }
	    histogram.value = function(x) {
	      if (!arguments.length) return valuer;
	      valuer = x;
	      return histogram;
	    };
	    histogram.range = function(x) {
	      if (!arguments.length) return ranger;
	      ranger = d3_functor(x);
	      return histogram;
	    };
	    histogram.bins = function(x) {
	      if (!arguments.length) return binner;
	      binner = typeof x === "number" ? function(range) {
	        return d3_layout_histogramBinFixed(range, x);
	      } : d3_functor(x);
	      return histogram;
	    };
	    histogram.frequency = function(x) {
	      if (!arguments.length) return frequency;
	      frequency = !!x;
	      return histogram;
	    };
	    return histogram;
	  };
	  function d3_layout_histogramBinSturges(range, values) {
	    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
	  }
	  function d3_layout_histogramBinFixed(range, n) {
	    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
	    while (++x <= n) f[x] = m * x + b;
	    return f;
	  }
	  function d3_layout_histogramRange(values) {
	    return [ d3.min(values), d3.max(values) ];
	  }
	  d3.layout.pack = function() {
	    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
	    function pack(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
	        return radius;
	      };
	      root.x = root.y = 0;
	      d3_layout_hierarchyVisitAfter(root, function(d) {
	        d.r = +r(d.value);
	      });
	      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	      if (padding) {
	        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r += dr;
	        });
	        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
	        d3_layout_hierarchyVisitAfter(root, function(d) {
	          d.r -= dr;
	        });
	      }
	      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
	      return nodes;
	    }
	    pack.size = function(_) {
	      if (!arguments.length) return size;
	      size = _;
	      return pack;
	    };
	    pack.radius = function(_) {
	      if (!arguments.length) return radius;
	      radius = _ == null || typeof _ === "function" ? _ : +_;
	      return pack;
	    };
	    pack.padding = function(_) {
	      if (!arguments.length) return padding;
	      padding = +_;
	      return pack;
	    };
	    return d3_layout_hierarchyRebind(pack, hierarchy);
	  };
	  function d3_layout_packSort(a, b) {
	    return a.value - b.value;
	  }
	  function d3_layout_packInsert(a, b) {
	    var c = a._pack_next;
	    a._pack_next = b;
	    b._pack_prev = a;
	    b._pack_next = c;
	    c._pack_prev = b;
	  }
	  function d3_layout_packSplice(a, b) {
	    a._pack_next = b;
	    b._pack_prev = a;
	  }
	  function d3_layout_packIntersects(a, b) {
	    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
	    return .999 * dr * dr > dx * dx + dy * dy;
	  }
	  function d3_layout_packSiblings(node) {
	    if (!(nodes = node.children) || !(n = nodes.length)) return;
	    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
	    function bound(node) {
	      xMin = Math.min(node.x - node.r, xMin);
	      xMax = Math.max(node.x + node.r, xMax);
	      yMin = Math.min(node.y - node.r, yMin);
	      yMax = Math.max(node.y + node.r, yMax);
	    }
	    nodes.forEach(d3_layout_packLink);
	    a = nodes[0];
	    a.x = -a.r;
	    a.y = 0;
	    bound(a);
	    if (n > 1) {
	      b = nodes[1];
	      b.x = b.r;
	      b.y = 0;
	      bound(b);
	      if (n > 2) {
	        c = nodes[2];
	        d3_layout_packPlace(a, b, c);
	        bound(c);
	        d3_layout_packInsert(a, c);
	        a._pack_prev = c;
	        d3_layout_packInsert(c, b);
	        b = a._pack_next;
	        for (i = 3; i < n; i++) {
	          d3_layout_packPlace(a, b, c = nodes[i]);
	          var isect = 0, s1 = 1, s2 = 1;
	          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
	            if (d3_layout_packIntersects(j, c)) {
	              isect = 1;
	              break;
	            }
	          }
	          if (isect == 1) {
	            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
	              if (d3_layout_packIntersects(k, c)) {
	                break;
	              }
	            }
	          }
	          if (isect) {
	            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
	            i--;
	          } else {
	            d3_layout_packInsert(a, c);
	            b = c;
	            bound(c);
	          }
	        }
	      }
	    }
	    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
	    for (i = 0; i < n; i++) {
	      c = nodes[i];
	      c.x -= cx;
	      c.y -= cy;
	      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
	    }
	    node.r = cr;
	    nodes.forEach(d3_layout_packUnlink);
	  }
	  function d3_layout_packLink(node) {
	    node._pack_next = node._pack_prev = node;
	  }
	  function d3_layout_packUnlink(node) {
	    delete node._pack_next;
	    delete node._pack_prev;
	  }
	  function d3_layout_packTransform(node, x, y, k) {
	    var children = node.children;
	    node.x = x += k * node.x;
	    node.y = y += k * node.y;
	    node.r *= k;
	    if (children) {
	      var i = -1, n = children.length;
	      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
	    }
	  }
	  function d3_layout_packPlace(a, b, c) {
	    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
	    if (db && (dx || dy)) {
	      var da = b.r + c.r, dc = dx * dx + dy * dy;
	      da *= da;
	      db *= db;
	      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
	      c.x = a.x + x * dx + y * dy;
	      c.y = a.y + x * dy - y * dx;
	    } else {
	      c.x = a.x + db;
	      c.y = a.y;
	    }
	  }
	  d3.layout.tree = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
	    function tree(d, i) {
	      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
	      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
	      d3_layout_hierarchyVisitBefore(root1, secondWalk);
	      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
	        var left = root0, right = root0, bottom = root0;
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          if (node.x < left.x) left = node;
	          if (node.x > right.x) right = node;
	          if (node.depth > bottom.depth) bottom = node;
	        });
	        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
	        d3_layout_hierarchyVisitBefore(root0, function(node) {
	          node.x = (node.x + tx) * kx;
	          node.y = node.depth * ky;
	        });
	      }
	      return nodes;
	    }
	    function wrapTree(root0) {
	      var root1 = {
	        A: null,
	        children: [ root0 ]
	      }, queue = [ root1 ], node1;
	      while ((node1 = queue.pop()) != null) {
	        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
	          queue.push((children[i] = child = {
	            _: children[i],
	            parent: node1,
	            children: (child = children[i].children) && child.slice() || [],
	            A: null,
	            a: null,
	            z: 0,
	            m: 0,
	            c: 0,
	            s: 0,
	            t: null,
	            i: i
	          }).a = child);
	        }
	      }
	      return root1.children[0];
	    }
	    function firstWalk(v) {
	      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
	      if (children.length) {
	        d3_layout_treeShift(v);
	        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	        if (w) {
	          v.z = w.z + separation(v._, w._);
	          v.m = v.z - midpoint;
	        } else {
	          v.z = midpoint;
	        }
	      } else if (w) {
	        v.z = w.z + separation(v._, w._);
	      }
	      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	    }
	    function secondWalk(v) {
	      v._.x = v.z + v.parent.m;
	      v.m += v.parent.m;
	    }
	    function apportion(v, w, ancestor) {
	      if (w) {
	        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
	        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
	          vom = d3_layout_treeLeft(vom);
	          vop = d3_layout_treeRight(vop);
	          vop.a = v;
	          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	          if (shift > 0) {
	            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
	            sip += shift;
	            sop += shift;
	          }
	          sim += vim.m;
	          sip += vip.m;
	          som += vom.m;
	          sop += vop.m;
	        }
	        if (vim && !d3_layout_treeRight(vop)) {
	          vop.t = vim;
	          vop.m += sim - sop;
	        }
	        if (vip && !d3_layout_treeLeft(vom)) {
	          vom.t = vip;
	          vom.m += sip - som;
	          ancestor = v;
	        }
	      }
	      return ancestor;
	    }
	    function sizeNode(node) {
	      node.x *= size[0];
	      node.y = node.depth * size[1];
	    }
	    tree.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return tree;
	    };
	    tree.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null ? sizeNode : null;
	      return tree;
	    };
	    tree.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) == null ? null : sizeNode;
	      return tree;
	    };
	    return d3_layout_hierarchyRebind(tree, hierarchy);
	  };
	  function d3_layout_treeSeparation(a, b) {
	    return a.parent == b.parent ? 1 : 2;
	  }
	  function d3_layout_treeLeft(v) {
	    var children = v.children;
	    return children.length ? children[0] : v.t;
	  }
	  function d3_layout_treeRight(v) {
	    var children = v.children, n;
	    return (n = children.length) ? children[n - 1] : v.t;
	  }
	  function d3_layout_treeMove(wm, wp, shift) {
	    var change = shift / (wp.i - wm.i);
	    wp.c -= change;
	    wp.s += shift;
	    wm.c += change;
	    wp.z += shift;
	    wp.m += shift;
	  }
	  function d3_layout_treeShift(v) {
	    var shift = 0, change = 0, children = v.children, i = children.length, w;
	    while (--i >= 0) {
	      w = children[i];
	      w.z += shift;
	      w.m += shift;
	      shift += w.s + (change += w.c);
	    }
	  }
	  function d3_layout_treeAncestor(vim, v, ancestor) {
	    return vim.a.parent === v.parent ? vim.a : ancestor;
	  }
	  d3.layout.cluster = function() {
	    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
	    function cluster(d, i) {
	      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
	      d3_layout_hierarchyVisitAfter(root, function(node) {
	        var children = node.children;
	        if (children && children.length) {
	          node.x = d3_layout_clusterX(children);
	          node.y = d3_layout_clusterY(children);
	        } else {
	          node.x = previousNode ? x += separation(node, previousNode) : 0;
	          node.y = 0;
	          previousNode = node;
	        }
	      });
	      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
	      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
	        node.x = (node.x - root.x) * size[0];
	        node.y = (root.y - node.y) * size[1];
	      } : function(node) {
	        node.x = (node.x - x0) / (x1 - x0) * size[0];
	        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
	      });
	      return nodes;
	    }
	    cluster.separation = function(x) {
	      if (!arguments.length) return separation;
	      separation = x;
	      return cluster;
	    };
	    cluster.size = function(x) {
	      if (!arguments.length) return nodeSize ? null : size;
	      nodeSize = (size = x) == null;
	      return cluster;
	    };
	    cluster.nodeSize = function(x) {
	      if (!arguments.length) return nodeSize ? size : null;
	      nodeSize = (size = x) != null;
	      return cluster;
	    };
	    return d3_layout_hierarchyRebind(cluster, hierarchy);
	  };
	  function d3_layout_clusterY(children) {
	    return 1 + d3.max(children, function(child) {
	      return child.y;
	    });
	  }
	  function d3_layout_clusterX(children) {
	    return children.reduce(function(x, child) {
	      return x + child.x;
	    }, 0) / children.length;
	  }
	  function d3_layout_clusterLeft(node) {
	    var children = node.children;
	    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
	  }
	  function d3_layout_clusterRight(node) {
	    var children = node.children, n;
	    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
	  }
	  d3.layout.treemap = function() {
	    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
	    function scale(children, k) {
	      var i = -1, n = children.length, child, area;
	      while (++i < n) {
	        area = (child = children[i]).value * (k < 0 ? 0 : k);
	        child.area = isNaN(area) || area <= 0 ? 0 : area;
	      }
	    }
	    function squarify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while ((n = remaining.length) > 0) {
	          row.push(child = remaining[n - 1]);
	          row.area += child.area;
	          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
	            remaining.pop();
	            best = score;
	          } else {
	            row.area -= row.pop().area;
	            position(row, u, rect, false);
	            u = Math.min(rect.dx, rect.dy);
	            row.length = row.area = 0;
	            best = Infinity;
	          }
	        }
	        if (row.length) {
	          position(row, u, rect, true);
	          row.length = row.area = 0;
	        }
	        children.forEach(squarify);
	      }
	    }
	    function stickify(node) {
	      var children = node.children;
	      if (children && children.length) {
	        var rect = pad(node), remaining = children.slice(), child, row = [];
	        scale(remaining, rect.dx * rect.dy / node.value);
	        row.area = 0;
	        while (child = remaining.pop()) {
	          row.push(child);
	          row.area += child.area;
	          if (child.z != null) {
	            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
	            row.length = row.area = 0;
	          }
	        }
	        children.forEach(stickify);
	      }
	    }
	    function worst(row, u) {
	      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
	      while (++i < n) {
	        if (!(r = row[i].area)) continue;
	        if (r < rmin) rmin = r;
	        if (r > rmax) rmax = r;
	      }
	      s *= s;
	      u *= u;
	      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
	    }
	    function position(row, u, rect, flush) {
	      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
	      if (u == rect.dx) {
	        if (flush || v > rect.dy) v = rect.dy;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dy = v;
	          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
	        }
	        o.z = true;
	        o.dx += rect.x + rect.dx - x;
	        rect.y += v;
	        rect.dy -= v;
	      } else {
	        if (flush || v > rect.dx) v = rect.dx;
	        while (++i < n) {
	          o = row[i];
	          o.x = x;
	          o.y = y;
	          o.dx = v;
	          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
	        }
	        o.z = false;
	        o.dy += rect.y + rect.dy - y;
	        rect.x += v;
	        rect.dx -= v;
	      }
	    }
	    function treemap(d) {
	      var nodes = stickies || hierarchy(d), root = nodes[0];
	      root.x = root.y = 0;
	      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
	      if (stickies) hierarchy.revalue(root);
	      scale([ root ], root.dx * root.dy / root.value);
	      (stickies ? stickify : squarify)(root);
	      if (sticky) stickies = nodes;
	      return nodes;
	    }
	    treemap.size = function(x) {
	      if (!arguments.length) return size;
	      size = x;
	      return treemap;
	    };
	    treemap.padding = function(x) {
	      if (!arguments.length) return padding;
	      function padFunction(node) {
	        var p = x.call(treemap, node, node.depth);
	        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
	      }
	      function padConstant(node) {
	        return d3_layout_treemapPad(node, x);
	      }
	      var type;
	      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
	      padConstant) : padConstant;
	      return treemap;
	    };
	    treemap.round = function(x) {
	      if (!arguments.length) return round != Number;
	      round = x ? Math.round : Number;
	      return treemap;
	    };
	    treemap.sticky = function(x) {
	      if (!arguments.length) return sticky;
	      sticky = x;
	      stickies = null;
	      return treemap;
	    };
	    treemap.ratio = function(x) {
	      if (!arguments.length) return ratio;
	      ratio = x;
	      return treemap;
	    };
	    treemap.mode = function(x) {
	      if (!arguments.length) return mode;
	      mode = x + "";
	      return treemap;
	    };
	    return d3_layout_hierarchyRebind(treemap, hierarchy);
	  };
	  function d3_layout_treemapPadNull(node) {
	    return {
	      x: node.x,
	      y: node.y,
	      dx: node.dx,
	      dy: node.dy
	    };
	  }
	  function d3_layout_treemapPad(node, padding) {
	    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
	    if (dx < 0) {
	      x += dx / 2;
	      dx = 0;
	    }
	    if (dy < 0) {
	      y += dy / 2;
	      dy = 0;
	    }
	    return {
	      x: x,
	      y: y,
	      dx: dx,
	      dy: dy
	    };
	  }
	  d3.random = {
	    normal: function(µ, σ) {
	      var n = arguments.length;
	      if (n < 2) σ = 1;
	      if (n < 1) µ = 0;
	      return function() {
	        var x, y, r;
	        do {
	          x = Math.random() * 2 - 1;
	          y = Math.random() * 2 - 1;
	          r = x * x + y * y;
	        } while (!r || r > 1);
	        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
	      };
	    },
	    logNormal: function() {
	      var random = d3.random.normal.apply(d3, arguments);
	      return function() {
	        return Math.exp(random());
	      };
	    },
	    bates: function(m) {
	      var random = d3.random.irwinHall(m);
	      return function() {
	        return random() / m;
	      };
	    },
	    irwinHall: function(m) {
	      return function() {
	        for (var s = 0, j = 0; j < m; j++) s += Math.random();
	        return s;
	      };
	    }
	  };
	  d3.scale = {};
	  function d3_scaleExtent(domain) {
	    var start = domain[0], stop = domain[domain.length - 1];
	    return start < stop ? [ start, stop ] : [ stop, start ];
	  }
	  function d3_scaleRange(scale) {
	    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
	  }
	  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
	    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
	    return function(x) {
	      return i(u(x));
	    };
	  }
	  function d3_scale_nice(domain, nice) {
	    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
	    if (x1 < x0) {
	      dx = i0, i0 = i1, i1 = dx;
	      dx = x0, x0 = x1, x1 = dx;
	    }
	    domain[i0] = nice.floor(x0);
	    domain[i1] = nice.ceil(x1);
	    return domain;
	  }
	  function d3_scale_niceStep(step) {
	    return step ? {
	      floor: function(x) {
	        return Math.floor(x / step) * step;
	      },
	      ceil: function(x) {
	        return Math.ceil(x / step) * step;
	      }
	    } : d3_scale_niceIdentity;
	  }
	  var d3_scale_niceIdentity = {
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
	    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
	    if (domain[k] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	    while (++j <= k) {
	      u.push(uninterpolate(domain[j - 1], domain[j]));
	      i.push(interpolate(range[j - 1], range[j]));
	    }
	    return function(x) {
	      var j = d3.bisect(domain, x, 1, k) - 1;
	      return i[j](u[j](x));
	    };
	  }
	  d3.scale.linear = function() {
	    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
	  };
	  function d3_scale_linear(domain, range, interpolate, clamp) {
	    var output, input;
	    function rescale() {
	      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
	      output = linear(domain, range, uninterpolate, interpolate);
	      input = linear(range, domain, uninterpolate, d3_interpolate);
	      return scale;
	    }
	    function scale(x) {
	      return output(x);
	    }
	    scale.invert = function(y) {
	      return input(y);
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(Number);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.rangeRound = function(x) {
	      return scale.range(x).interpolate(d3_interpolateRound);
	    };
	    scale.clamp = function(x) {
	      if (!arguments.length) return clamp;
	      clamp = x;
	      return rescale();
	    };
	    scale.interpolate = function(x) {
	      if (!arguments.length) return interpolate;
	      interpolate = x;
	      return rescale();
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      d3_scale_linearNice(domain, m);
	      return rescale();
	    };
	    scale.copy = function() {
	      return d3_scale_linear(domain, range, interpolate, clamp);
	    };
	    return rescale();
	  }
	  function d3_scale_linearRebind(scale, linear) {
	    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
	  }
	  function d3_scale_linearNice(domain, m) {
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
	    return domain;
	  }
	  function d3_scale_linearTickRange(domain, m) {
	    if (m == null) m = 10;
	    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
	    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
	    extent[0] = Math.ceil(extent[0] / step) * step;
	    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
	    extent[2] = step;
	    return extent;
	  }
	  function d3_scale_linearTicks(domain, m) {
	    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
	  }
	  function d3_scale_linearTickFormat(domain, m, format) {
	    var range = d3_scale_linearTickRange(domain, m);
	    if (format) {
	      var match = d3_format_re.exec(format);
	      match.shift();
	      if (match[8] === "s") {
	        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
	        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
	        match[8] = "f";
	        format = d3.format(match.join(""));
	        return function(d) {
	          return format(prefix.scale(d)) + prefix.symbol;
	        };
	      }
	      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
	      format = match.join("");
	    } else {
	      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
	    }
	    return d3.format(format);
	  }
	  var d3_scale_linearFormatSignificant = {
	    s: 1,
	    g: 1,
	    p: 1,
	    r: 1,
	    e: 1
	  };
	  function d3_scale_linearPrecision(value) {
	    return -Math.floor(Math.log(value) / Math.LN10 + .01);
	  }
	  function d3_scale_linearFormatPrecision(type, range) {
	    var p = d3_scale_linearPrecision(range[2]);
	    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
	  }
	  d3.scale.log = function() {
	    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
	  };
	  function d3_scale_log(linear, base, positive, domain) {
	    function log(x) {
	      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
	    }
	    function pow(x) {
	      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
	    }
	    function scale(x) {
	      return linear(log(x));
	    }
	    scale.invert = function(x) {
	      return pow(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      positive = x[0] >= 0;
	      linear.domain((domain = x.map(Number)).map(log));
	      return scale;
	    };
	    scale.base = function(_) {
	      if (!arguments.length) return base;
	      base = +_;
	      linear.domain(domain.map(log));
	      return scale;
	    };
	    scale.nice = function() {
	      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
	      linear.domain(niced);
	      domain = niced.map(pow);
	      return scale;
	    };
	    scale.ticks = function() {
	      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
	      if (isFinite(j - i)) {
	        if (positive) {
	          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
	          ticks.push(pow(i));
	        } else {
	          ticks.push(pow(i));
	          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
	        }
	        for (i = 0; ticks[i] < u; i++) {}
	        for (j = ticks.length; ticks[j - 1] > v; j--) {}
	        ticks = ticks.slice(i, j);
	      }
	      return ticks;
	    };
	    scale.tickFormat = function(n, format) {
	      if (!arguments.length) return d3_scale_logFormat;
	      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
	      var k = Math.max(1, base * n / scale.ticks().length);
	      return function(d) {
	        var i = d / pow(Math.round(log(d)));
	        if (i * base < base - .5) i *= base;
	        return i <= k ? format(d) : "";
	      };
	    };
	    scale.copy = function() {
	      return d3_scale_log(linear.copy(), base, positive, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
	    floor: function(x) {
	      return -Math.ceil(-x);
	    },
	    ceil: function(x) {
	      return -Math.floor(-x);
	    }
	  };
	  d3.scale.pow = function() {
	    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
	  };
	  function d3_scale_pow(linear, exponent, domain) {
	    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
	    function scale(x) {
	      return linear(powp(x));
	    }
	    scale.invert = function(x) {
	      return powb(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      linear.domain((domain = x.map(Number)).map(powp));
	      return scale;
	    };
	    scale.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    scale.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    scale.nice = function(m) {
	      return scale.domain(d3_scale_linearNice(domain, m));
	    };
	    scale.exponent = function(x) {
	      if (!arguments.length) return exponent;
	      powp = d3_scale_powPow(exponent = x);
	      powb = d3_scale_powPow(1 / exponent);
	      linear.domain(domain.map(powp));
	      return scale;
	    };
	    scale.copy = function() {
	      return d3_scale_pow(linear.copy(), exponent, domain);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_scale_powPow(e) {
	    return function(x) {
	      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
	    };
	  }
	  d3.scale.sqrt = function() {
	    return d3.scale.pow().exponent(.5);
	  };
	  d3.scale.ordinal = function() {
	    return d3_scale_ordinal([], {
	      t: "range",
	      a: [ [] ]
	    });
	  };
	  function d3_scale_ordinal(domain, ranger) {
	    var index, range, rangeBand;
	    function scale(x) {
	      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
	    }
	    function steps(start, step) {
	      return d3.range(domain.length).map(function(i) {
	        return start + step * i;
	      });
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = [];
	      index = new d3_Map();
	      var i = -1, n = x.length, xi;
	      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
	      return scale[ranger.t].apply(scale, ranger.a);
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      rangeBand = 0;
	      ranger = {
	        t: "range",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangePoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
	      0) : (stop - start) / (domain.length - 1 + padding);
	      range = steps(start + step * padding / 2, step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangePoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundPoints = function(x, padding) {
	      if (arguments.length < 2) padding = 0;
	      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
	      0) : (stop - start) / (domain.length - 1 + padding) | 0;
	      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
	      rangeBand = 0;
	      ranger = {
	        t: "rangeRoundPoints",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
	      range = steps(start + step * outerPadding, step);
	      if (reverse) range.reverse();
	      rangeBand = step * (1 - padding);
	      ranger = {
	        t: "rangeBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeRoundBands = function(x, padding, outerPadding) {
	      if (arguments.length < 2) padding = 0;
	      if (arguments.length < 3) outerPadding = padding;
	      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
	      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
	      if (reverse) range.reverse();
	      rangeBand = Math.round(step * (1 - padding));
	      ranger = {
	        t: "rangeRoundBands",
	        a: arguments
	      };
	      return scale;
	    };
	    scale.rangeBand = function() {
	      return rangeBand;
	    };
	    scale.rangeExtent = function() {
	      return d3_scaleExtent(ranger.a[0]);
	    };
	    scale.copy = function() {
	      return d3_scale_ordinal(domain, ranger);
	    };
	    return scale.domain(domain);
	  }
	  d3.scale.category10 = function() {
	    return d3.scale.ordinal().range(d3_category10);
	  };
	  d3.scale.category20 = function() {
	    return d3.scale.ordinal().range(d3_category20);
	  };
	  d3.scale.category20b = function() {
	    return d3.scale.ordinal().range(d3_category20b);
	  };
	  d3.scale.category20c = function() {
	    return d3.scale.ordinal().range(d3_category20c);
	  };
	  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
	  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
	  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
	  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
	  d3.scale.quantile = function() {
	    return d3_scale_quantile([], []);
	  };
	  function d3_scale_quantile(domain, range) {
	    var thresholds;
	    function rescale() {
	      var k = 0, q = range.length;
	      thresholds = [];
	      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
	      return scale;
	    }
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.quantiles = function() {
	      return thresholds;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantile(domain, range);
	    };
	    return rescale();
	  }
	  d3.scale.quantize = function() {
	    return d3_scale_quantize(0, 1, [ 0, 1 ]);
	  };
	  function d3_scale_quantize(x0, x1, range) {
	    var kx, i;
	    function scale(x) {
	      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
	    }
	    function rescale() {
	      kx = range.length / (x1 - x0);
	      i = range.length - 1;
	      return scale;
	    }
	    scale.domain = function(x) {
	      if (!arguments.length) return [ x0, x1 ];
	      x0 = +x[0];
	      x1 = +x[x.length - 1];
	      return rescale();
	    };
	    scale.range = function(x) {
	      if (!arguments.length) return range;
	      range = x;
	      return rescale();
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      y = y < 0 ? NaN : y / kx + x0;
	      return [ y, y + 1 / kx ];
	    };
	    scale.copy = function() {
	      return d3_scale_quantize(x0, x1, range);
	    };
	    return rescale();
	  }
	  d3.scale.threshold = function() {
	    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
	  };
	  function d3_scale_threshold(domain, range) {
	    function scale(x) {
	      if (x <= x) return range[d3.bisect(domain, x)];
	    }
	    scale.domain = function(_) {
	      if (!arguments.length) return domain;
	      domain = _;
	      return scale;
	    };
	    scale.range = function(_) {
	      if (!arguments.length) return range;
	      range = _;
	      return scale;
	    };
	    scale.invertExtent = function(y) {
	      y = range.indexOf(y);
	      return [ domain[y - 1], domain[y] ];
	    };
	    scale.copy = function() {
	      return d3_scale_threshold(domain, range);
	    };
	    return scale;
	  }
	  d3.scale.identity = function() {
	    return d3_scale_identity([ 0, 1 ]);
	  };
	  function d3_scale_identity(domain) {
	    function identity(x) {
	      return +x;
	    }
	    identity.invert = identity;
	    identity.domain = identity.range = function(x) {
	      if (!arguments.length) return domain;
	      domain = x.map(identity);
	      return identity;
	    };
	    identity.ticks = function(m) {
	      return d3_scale_linearTicks(domain, m);
	    };
	    identity.tickFormat = function(m, format) {
	      return d3_scale_linearTickFormat(domain, m, format);
	    };
	    identity.copy = function() {
	      return d3_scale_identity(domain);
	    };
	    return identity;
	  }
	  d3.svg = {};
	  function d3_zero() {
	    return 0;
	  }
	  d3.svg.arc = function() {
	    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
	    function arc() {
	      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
	      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
	      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
	      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
	      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
	        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
	        if (!cw) p1 *= -1;
	        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
	        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
	      }
	      if (r1) {
	        x0 = r1 * Math.cos(a0 + p1);
	        y0 = r1 * Math.sin(a0 + p1);
	        x1 = r1 * Math.cos(a1 - p1);
	        y1 = r1 * Math.sin(a1 - p1);
	        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
	        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
	          var h1 = (a0 + a1) / 2;
	          x0 = r1 * Math.cos(h1);
	          y0 = r1 * Math.sin(h1);
	          x1 = y1 = null;
	        }
	      } else {
	        x0 = y0 = 0;
	      }
	      if (r0) {
	        x2 = r0 * Math.cos(a1 - p0);
	        y2 = r0 * Math.sin(a1 - p0);
	        x3 = r0 * Math.cos(a0 + p0);
	        y3 = r0 * Math.sin(a0 + p0);
	        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
	        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
	          var h0 = (a0 + a1) / 2;
	          x2 = r0 * Math.cos(h0);
	          y2 = r0 * Math.sin(h0);
	          x3 = y3 = null;
	        }
	      } else {
	        x2 = y2 = 0;
	      }
	      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
	        cr = r0 < r1 ^ cw ? 0 : 1;
	        var rc1 = rc, rc0 = rc;
	        if (da < π) {
	          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	        if (x1 != null) {
	          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
	          if (rc === rc1) {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
	          } else {
	            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
	          }
	        } else {
	          path.push("M", x0, ",", y0);
	        }
	        if (x3 != null) {
	          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
	          if (rc === rc0) {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          } else {
	            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
	          }
	        } else {
	          path.push("L", x2, ",", y2);
	        }
	      } else {
	        path.push("M", x0, ",", y0);
	        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
	        path.push("L", x2, ",", y2);
	        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
	      }
	      path.push("Z");
	      return path.join("");
	    }
	    function circleSegment(r1, cw) {
	      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
	    }
	    arc.innerRadius = function(v) {
	      if (!arguments.length) return innerRadius;
	      innerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.outerRadius = function(v) {
	      if (!arguments.length) return outerRadius;
	      outerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.cornerRadius = function(v) {
	      if (!arguments.length) return cornerRadius;
	      cornerRadius = d3_functor(v);
	      return arc;
	    };
	    arc.padRadius = function(v) {
	      if (!arguments.length) return padRadius;
	      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
	      return arc;
	    };
	    arc.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return arc;
	    };
	    arc.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return arc;
	    };
	    arc.padAngle = function(v) {
	      if (!arguments.length) return padAngle;
	      padAngle = d3_functor(v);
	      return arc;
	    };
	    arc.centroid = function() {
	      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
	      return [ Math.cos(a) * r, Math.sin(a) * r ];
	    };
	    return arc;
	  };
	  var d3_svg_arcAuto = "auto";
	  function d3_svg_arcInnerRadius(d) {
	    return d.innerRadius;
	  }
	  function d3_svg_arcOuterRadius(d) {
	    return d.outerRadius;
	  }
	  function d3_svg_arcStartAngle(d) {
	    return d.startAngle;
	  }
	  function d3_svg_arcEndAngle(d) {
	    return d.endAngle;
	  }
	  function d3_svg_arcPadAngle(d) {
	    return d && d.padAngle;
	  }
	  function d3_svg_arcSweep(x0, y0, x1, y1) {
	    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
	  }
	  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
	    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
	    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
	  }
	  function d3_svg_line(projection) {
	    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
	    function line(data) {
	      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
	      function segment() {
	        segments.push("M", interpolate(projection(points), tension));
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
	        } else if (points.length) {
	          segment();
	          points = [];
	        }
	      }
	      if (points.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    line.x = function(_) {
	      if (!arguments.length) return x;
	      x = _;
	      return line;
	    };
	    line.y = function(_) {
	      if (!arguments.length) return y;
	      y = _;
	      return line;
	    };
	    line.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return line;
	    };
	    line.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      return line;
	    };
	    line.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return line;
	    };
	    return line;
	  }
	  d3.svg.line = function() {
	    return d3_svg_line(d3_identity);
	  };
	  var d3_svg_lineInterpolators = d3.map({
	    linear: d3_svg_lineLinear,
	    "linear-closed": d3_svg_lineLinearClosed,
	    step: d3_svg_lineStep,
	    "step-before": d3_svg_lineStepBefore,
	    "step-after": d3_svg_lineStepAfter,
	    basis: d3_svg_lineBasis,
	    "basis-open": d3_svg_lineBasisOpen,
	    "basis-closed": d3_svg_lineBasisClosed,
	    bundle: d3_svg_lineBundle,
	    cardinal: d3_svg_lineCardinal,
	    "cardinal-open": d3_svg_lineCardinalOpen,
	    "cardinal-closed": d3_svg_lineCardinalClosed,
	    monotone: d3_svg_lineMonotone
	  });
	  d3_svg_lineInterpolators.forEach(function(key, value) {
	    value.key = key;
	    value.closed = /-closed$/.test(key);
	  });
	  function d3_svg_lineLinear(points) {
	    return points.length > 1 ? points.join("L") : points + "Z";
	  }
	  function d3_svg_lineLinearClosed(points) {
	    return points.join("L") + "Z";
	  }
	  function d3_svg_lineStep(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
	    if (n > 1) path.push("H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepBefore(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
	    return path.join("");
	  }
	  function d3_svg_lineStepAfter(points) {
	    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
	    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
	    return path.join("");
	  }
	  function d3_svg_lineCardinalOpen(points, tension) {
	    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineCardinalClosed(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
	    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
	  }
	  function d3_svg_lineCardinal(points, tension) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
	  }
	  function d3_svg_lineHermite(points, tangents) {
	    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
	      return d3_svg_lineLinear(points);
	    }
	    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
	    if (quad) {
	      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
	      p0 = points[1];
	      pi = 2;
	    }
	    if (tangents.length > 1) {
	      t = tangents[1];
	      p = points[pi];
	      pi++;
	      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      for (var i = 2; i < tangents.length; i++, pi++) {
	        p = points[pi];
	        t = tangents[i];
	        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
	      }
	    }
	    if (quad) {
	      var lp = points[pi];
	      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
	    }
	    return path;
	  }
	  function d3_svg_lineCardinalTangents(points, tension) {
	    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
	    while (++i < n) {
	      p0 = p1;
	      p1 = p2;
	      p2 = points[i];
	      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineBasis(points) {
	    if (points.length < 3) return d3_svg_lineLinear(points);
	    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    points.push(points[n - 1]);
	    while (++i <= n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    points.pop();
	    path.push("L", pi);
	    return path.join("");
	  }
	  function d3_svg_lineBasisOpen(points) {
	    if (points.length < 4) return d3_svg_lineLinear(points);
	    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
	    while (++i < 3) {
	      pi = points[i];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
	    --i;
	    while (++i < n) {
	      pi = points[i];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBasisClosed(points) {
	    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
	    while (++i < 4) {
	      pi = points[i % n];
	      px.push(pi[0]);
	      py.push(pi[1]);
	    }
	    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
	    --i;
	    while (++i < m) {
	      pi = points[i % n];
	      px.shift();
	      px.push(pi[0]);
	      py.shift();
	      py.push(pi[1]);
	      d3_svg_lineBasisBezier(path, px, py);
	    }
	    return path.join("");
	  }
	  function d3_svg_lineBundle(points, tension) {
	    var n = points.length - 1;
	    if (n) {
	      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
	      while (++i <= n) {
	        p = points[i];
	        t = i / n;
	        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
	        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
	      }
	    }
	    return d3_svg_lineBasis(points);
	  }
	  function d3_svg_lineDot4(a, b) {
	    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
	  }
	  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
	  function d3_svg_lineBasisBezier(path, x, y) {
	    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
	  }
	  function d3_svg_lineSlope(p0, p1) {
	    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
	  }
	  function d3_svg_lineFiniteDifferences(points) {
	    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
	    while (++i < j) {
	      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
	    }
	    m[i] = d;
	    return m;
	  }
	  function d3_svg_lineMonotoneTangents(points) {
	    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
	    while (++i < j) {
	      d = d3_svg_lineSlope(points[i], points[i + 1]);
	      if (abs(d) < ε) {
	        m[i] = m[i + 1] = 0;
	      } else {
	        a = m[i] / d;
	        b = m[i + 1] / d;
	        s = a * a + b * b;
	        if (s > 9) {
	          s = d * 3 / Math.sqrt(s);
	          m[i] = s * a;
	          m[i + 1] = s * b;
	        }
	      }
	    }
	    i = -1;
	    while (++i <= j) {
	      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
	      tangents.push([ s || 0, m[i] * s || 0 ]);
	    }
	    return tangents;
	  }
	  function d3_svg_lineMonotone(points) {
	    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
	  }
	  d3.svg.line.radial = function() {
	    var line = d3_svg_line(d3_svg_lineRadial);
	    line.radius = line.x, delete line.x;
	    line.angle = line.y, delete line.y;
	    return line;
	  };
	  function d3_svg_lineRadial(points) {
	    var point, i = -1, n = points.length, r, a;
	    while (++i < n) {
	      point = points[i];
	      r = point[0];
	      a = point[1] - halfπ;
	      point[0] = r * Math.cos(a);
	      point[1] = r * Math.sin(a);
	    }
	    return points;
	  }
	  function d3_svg_area(projection) {
	    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
	    function area(data) {
	      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
	        return x;
	      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
	        return y;
	      } : d3_functor(y1), x, y;
	      function segment() {
	        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
	      }
	      while (++i < n) {
	        if (defined.call(this, d = data[i], i)) {
	          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
	          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
	        } else if (points0.length) {
	          segment();
	          points0 = [];
	          points1 = [];
	        }
	      }
	      if (points0.length) segment();
	      return segments.length ? segments.join("") : null;
	    }
	    area.x = function(_) {
	      if (!arguments.length) return x1;
	      x0 = x1 = _;
	      return area;
	    };
	    area.x0 = function(_) {
	      if (!arguments.length) return x0;
	      x0 = _;
	      return area;
	    };
	    area.x1 = function(_) {
	      if (!arguments.length) return x1;
	      x1 = _;
	      return area;
	    };
	    area.y = function(_) {
	      if (!arguments.length) return y1;
	      y0 = y1 = _;
	      return area;
	    };
	    area.y0 = function(_) {
	      if (!arguments.length) return y0;
	      y0 = _;
	      return area;
	    };
	    area.y1 = function(_) {
	      if (!arguments.length) return y1;
	      y1 = _;
	      return area;
	    };
	    area.defined = function(_) {
	      if (!arguments.length) return defined;
	      defined = _;
	      return area;
	    };
	    area.interpolate = function(_) {
	      if (!arguments.length) return interpolateKey;
	      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
	      interpolateReverse = interpolate.reverse || interpolate;
	      L = interpolate.closed ? "M" : "L";
	      return area;
	    };
	    area.tension = function(_) {
	      if (!arguments.length) return tension;
	      tension = _;
	      return area;
	    };
	    return area;
	  }
	  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
	  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
	  d3.svg.area = function() {
	    return d3_svg_area(d3_identity);
	  };
	  d3.svg.area.radial = function() {
	    var area = d3_svg_area(d3_svg_lineRadial);
	    area.radius = area.x, delete area.x;
	    area.innerRadius = area.x0, delete area.x0;
	    area.outerRadius = area.x1, delete area.x1;
	    area.angle = area.y, delete area.y;
	    area.startAngle = area.y0, delete area.y0;
	    area.endAngle = area.y1, delete area.y1;
	    return area;
	  };
	  d3.svg.chord = function() {
	    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
	    function chord(d, i) {
	      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
	      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
	    }
	    function subgroup(self, f, d, i) {
	      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
	      return {
	        r: r,
	        a0: a0,
	        a1: a1,
	        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
	        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
	      };
	    }
	    function equals(a, b) {
	      return a.a0 == b.a0 && a.a1 == b.a1;
	    }
	    function arc(r, p, a) {
	      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
	    }
	    function curve(r0, p0, r1, p1) {
	      return "Q 0,0 " + p1;
	    }
	    chord.radius = function(v) {
	      if (!arguments.length) return radius;
	      radius = d3_functor(v);
	      return chord;
	    };
	    chord.source = function(v) {
	      if (!arguments.length) return source;
	      source = d3_functor(v);
	      return chord;
	    };
	    chord.target = function(v) {
	      if (!arguments.length) return target;
	      target = d3_functor(v);
	      return chord;
	    };
	    chord.startAngle = function(v) {
	      if (!arguments.length) return startAngle;
	      startAngle = d3_functor(v);
	      return chord;
	    };
	    chord.endAngle = function(v) {
	      if (!arguments.length) return endAngle;
	      endAngle = d3_functor(v);
	      return chord;
	    };
	    return chord;
	  };
	  function d3_svg_chordRadius(d) {
	    return d.radius;
	  }
	  d3.svg.diagonal = function() {
	    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
	    function diagonal(d, i) {
	      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
	        x: p0.x,
	        y: m
	      }, {
	        x: p3.x,
	        y: m
	      }, p3 ];
	      p = p.map(projection);
	      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
	    }
	    diagonal.source = function(x) {
	      if (!arguments.length) return source;
	      source = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.target = function(x) {
	      if (!arguments.length) return target;
	      target = d3_functor(x);
	      return diagonal;
	    };
	    diagonal.projection = function(x) {
	      if (!arguments.length) return projection;
	      projection = x;
	      return diagonal;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalProjection(d) {
	    return [ d.x, d.y ];
	  }
	  d3.svg.diagonal.radial = function() {
	    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
	    diagonal.projection = function(x) {
	      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
	    };
	    return diagonal;
	  };
	  function d3_svg_diagonalRadialProjection(projection) {
	    return function() {
	      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
	      return [ r * Math.cos(a), r * Math.sin(a) ];
	    };
	  }
	  d3.svg.symbol = function() {
	    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
	    function symbol(d, i) {
	      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
	    }
	    symbol.type = function(x) {
	      if (!arguments.length) return type;
	      type = d3_functor(x);
	      return symbol;
	    };
	    symbol.size = function(x) {
	      if (!arguments.length) return size;
	      size = d3_functor(x);
	      return symbol;
	    };
	    return symbol;
	  };
	  function d3_svg_symbolSize() {
	    return 64;
	  }
	  function d3_svg_symbolType() {
	    return "circle";
	  }
	  function d3_svg_symbolCircle(size) {
	    var r = Math.sqrt(size / π);
	    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
	  }
	  var d3_svg_symbols = d3.map({
	    circle: d3_svg_symbolCircle,
	    cross: function(size) {
	      var r = Math.sqrt(size / 5) / 2;
	      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
	    },
	    diamond: function(size) {
	      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
	      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
	    },
	    square: function(size) {
	      var r = Math.sqrt(size) / 2;
	      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
	    },
	    "triangle-down": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
	    },
	    "triangle-up": function(size) {
	      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
	      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
	    }
	  });
	  d3.svg.symbolTypes = d3_svg_symbols.keys();
	  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
	  d3_selectionPrototype.transition = function(name) {
	    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
	      time: Date.now(),
	      ease: d3_ease_cubicInOut,
	      delay: 0,
	      duration: 250
	    };
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_selectionPrototype.interrupt = function(name) {
	    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
	  };
	  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
	  function d3_selection_interruptNS(ns) {
	    return function() {
	      var lock, activeId, active;
	      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        if (--lock.count) delete lock[activeId]; else delete this[ns];
	        lock.active += .5;
	        active.event && active.event.interrupt.call(this, this.__data__, active.index);
	      }
	    };
	  }
	  function d3_transition(groups, ns, id) {
	    d3_subclass(groups, d3_transitionPrototype);
	    groups.namespace = ns;
	    groups.id = id;
	    return groups;
	  }
	  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
	  d3_transitionPrototype.call = d3_selectionPrototype.call;
	  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
	  d3_transitionPrototype.node = d3_selectionPrototype.node;
	  d3_transitionPrototype.size = d3_selectionPrototype.size;
	  d3.transition = function(selection, name) {
	    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
	  };
	  d3.transition.prototype = d3_transitionPrototype;
	  d3_transitionPrototype.select = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
	    selector = d3_selection_selector(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
	          subgroup.push(subnode);
	        } else {
	          subgroup.push(null);
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.selectAll = function(selector) {
	    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
	    selector = d3_selection_selectorAll(selector);
	    for (var j = -1, m = this.length; ++j < m; ) {
	      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
	        if (node = group[i]) {
	          transition = node[ns][id];
	          subnodes = selector.call(node, node.__data__, i, j);
	          subgroups.push(subgroup = []);
	          for (var k = -1, o = subnodes.length; ++k < o; ) {
	            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
	            subgroup.push(subnode);
	          }
	        }
	      }
	    }
	    return d3_transition(subgroups, ns, id);
	  };
	  d3_transitionPrototype.filter = function(filter) {
	    var subgroups = [], subgroup, group, node;
	    if (typeof filter !== "function") filter = d3_selection_filter(filter);
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
	          subgroup.push(node);
	        }
	      }
	    }
	    return d3_transition(subgroups, this.namespace, this.id);
	  };
	  d3_transitionPrototype.tween = function(name, tween) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
	    return d3_selection_each(this, tween == null ? function(node) {
	      node[ns][id].tween.remove(name);
	    } : function(node) {
	      node[ns][id].tween.set(name, tween);
	    });
	  };
	  function d3_transition_tween(groups, name, value, tween) {
	    var id = groups.id, ns = groups.namespace;
	    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
	    } : (value = tween(value), function(node) {
	      node[ns][id].tween.set(name, value);
	    }));
	  }
	  d3_transitionPrototype.attr = function(nameNS, value) {
	    if (arguments.length < 2) {
	      for (value in nameNS) this.attr(value, nameNS[value]);
	      return this;
	    }
	    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
	    function attrNull() {
	      this.removeAttribute(name);
	    }
	    function attrNullNS() {
	      this.removeAttributeNS(name.space, name.local);
	    }
	    function attrTween(b) {
	      return b == null ? attrNull : (b += "", function() {
	        var a = this.getAttribute(name), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttribute(name, i(t));
	        });
	      });
	    }
	    function attrTweenNS(b) {
	      return b == null ? attrNullNS : (b += "", function() {
	        var a = this.getAttributeNS(name.space, name.local), i;
	        return a !== b && (i = interpolate(a, b), function(t) {
	          this.setAttributeNS(name.space, name.local, i(t));
	        });
	      });
	    }
	    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.attrTween = function(nameNS, tween) {
	    var name = d3.ns.qualify(nameNS);
	    function attrTween(d, i) {
	      var f = tween.call(this, d, i, this.getAttribute(name));
	      return f && function(t) {
	        this.setAttribute(name, f(t));
	      };
	    }
	    function attrTweenNS(d, i) {
	      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
	      return f && function(t) {
	        this.setAttributeNS(name.space, name.local, f(t));
	      };
	    }
	    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
	  };
	  d3_transitionPrototype.style = function(name, value, priority) {
	    var n = arguments.length;
	    if (n < 3) {
	      if (typeof name !== "string") {
	        if (n < 2) value = "";
	        for (priority in name) this.style(priority, name[priority], value);
	        return this;
	      }
	      priority = "";
	    }
	    function styleNull() {
	      this.style.removeProperty(name);
	    }
	    function styleString(b) {
	      return b == null ? styleNull : (b += "", function() {
	        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
	        return a !== b && (i = d3_interpolate(a, b), function(t) {
	          this.style.setProperty(name, i(t), priority);
	        });
	      });
	    }
	    return d3_transition_tween(this, "style." + name, value, styleString);
	  };
	  d3_transitionPrototype.styleTween = function(name, tween, priority) {
	    if (arguments.length < 3) priority = "";
	    function styleTween(d, i) {
	      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
	      return f && function(t) {
	        this.style.setProperty(name, f(t), priority);
	      };
	    }
	    return this.tween("style." + name, styleTween);
	  };
	  d3_transitionPrototype.text = function(value) {
	    return d3_transition_tween(this, "text", value, d3_transition_text);
	  };
	  function d3_transition_text(b) {
	    if (b == null) b = "";
	    return function() {
	      this.textContent = b;
	    };
	  }
	  d3_transitionPrototype.remove = function() {
	    var ns = this.namespace;
	    return this.each("end.transition", function() {
	      var p;
	      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
	    });
	  };
	  d3_transitionPrototype.ease = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].ease;
	    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
	    return d3_selection_each(this, function(node) {
	      node[ns][id].ease = value;
	    });
	  };
	  d3_transitionPrototype.delay = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].delay;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].delay = +value.call(node, node.__data__, i, j);
	    } : (value = +value, function(node) {
	      node[ns][id].delay = value;
	    }));
	  };
	  d3_transitionPrototype.duration = function(value) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 1) return this.node()[ns][id].duration;
	    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
	      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
	    } : (value = Math.max(1, value), function(node) {
	      node[ns][id].duration = value;
	    }));
	  };
	  d3_transitionPrototype.each = function(type, listener) {
	    var id = this.id, ns = this.namespace;
	    if (arguments.length < 2) {
	      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
	      try {
	        d3_transitionInheritId = id;
	        d3_selection_each(this, function(node, i, j) {
	          d3_transitionInherit = node[ns][id];
	          type.call(node, node.__data__, i, j);
	        });
	      } finally {
	        d3_transitionInherit = inherit;
	        d3_transitionInheritId = inheritId;
	      }
	    } else {
	      d3_selection_each(this, function(node) {
	        var transition = node[ns][id];
	        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
	      });
	    }
	    return this;
	  };
	  d3_transitionPrototype.transition = function() {
	    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
	    for (var j = 0, m = this.length; j < m; j++) {
	      subgroups.push(subgroup = []);
	      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
	        if (node = group[i]) {
	          transition = node[ns][id0];
	          d3_transitionNode(node, i, ns, id1, {
	            time: transition.time,
	            ease: transition.ease,
	            delay: transition.delay + transition.duration,
	            duration: transition.duration
	          });
	        }
	        subgroup.push(node);
	      }
	    }
	    return d3_transition(subgroups, ns, id1);
	  };
	  function d3_transitionNamespace(name) {
	    return name == null ? "__transition__" : "__transition_" + name + "__";
	  }
	  function d3_transitionNode(node, i, ns, id, inherit) {
	    var lock = node[ns] || (node[ns] = {
	      active: 0,
	      count: 0
	    }), transition = lock[id], time, timer, duration, ease, tweens;
	    function schedule(elapsed) {
	      var delay = transition.delay;
	      timer.t = delay + time;
	      if (delay <= elapsed) return start(elapsed - delay);
	      timer.c = start;
	    }
	    function start(elapsed) {
	      var activeId = lock.active, active = lock[activeId];
	      if (active) {
	        active.timer.c = null;
	        active.timer.t = NaN;
	        --lock.count;
	        delete lock[activeId];
	        active.event && active.event.interrupt.call(node, node.__data__, active.index);
	      }
	      for (var cancelId in lock) {
	        if (+cancelId < id) {
	          var cancel = lock[cancelId];
	          cancel.timer.c = null;
	          cancel.timer.t = NaN;
	          --lock.count;
	          delete lock[cancelId];
	        }
	      }
	      timer.c = tick;
	      d3_timer(function() {
	        if (timer.c && tick(elapsed || 1)) {
	          timer.c = null;
	          timer.t = NaN;
	        }
	        return 1;
	      }, 0, time);
	      lock.active = id;
	      transition.event && transition.event.start.call(node, node.__data__, i);
	      tweens = [];
	      transition.tween.forEach(function(key, value) {
	        if (value = value.call(node, node.__data__, i)) {
	          tweens.push(value);
	        }
	      });
	      ease = transition.ease;
	      duration = transition.duration;
	    }
	    function tick(elapsed) {
	      var t = elapsed / duration, e = ease(t), n = tweens.length;
	      while (n > 0) {
	        tweens[--n].call(node, e);
	      }
	      if (t >= 1) {
	        transition.event && transition.event.end.call(node, node.__data__, i);
	        if (--lock.count) delete lock[id]; else delete node[ns];
	        return 1;
	      }
	    }
	    if (!transition) {
	      time = inherit.time;
	      timer = d3_timer(schedule, 0, time);
	      transition = lock[id] = {
	        tween: new d3_Map(),
	        time: time,
	        timer: timer,
	        delay: inherit.delay,
	        duration: inherit.duration,
	        ease: inherit.ease,
	        index: i
	      };
	      inherit = null;
	      ++lock.count;
	    }
	  }
	  d3.svg.axis = function() {
	    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
	    function axis(g) {
	      g.each(function() {
	        var g = d3.select(this);
	        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
	        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
	        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
	        d3.transition(path));
	        tickEnter.append("line");
	        tickEnter.append("text");
	        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
	        if (orient === "bottom" || orient === "top") {
	          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
	          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
	          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
	        } else {
	          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
	          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
	          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
	        }
	        lineEnter.attr(y2, sign * innerTickSize);
	        textEnter.attr(y1, sign * tickSpacing);
	        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
	        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
	        if (scale1.rangeBand) {
	          var x = scale1, dx = x.rangeBand() / 2;
	          scale0 = scale1 = function(d) {
	            return x(d) + dx;
	          };
	        } else if (scale0.rangeBand) {
	          scale0 = scale1;
	        } else {
	          tickExit.call(tickTransform, scale1, scale0);
	        }
	        tickEnter.call(tickTransform, scale0, scale1);
	        tickUpdate.call(tickTransform, scale1, scale1);
	      });
	    }
	    axis.scale = function(x) {
	      if (!arguments.length) return scale;
	      scale = x;
	      return axis;
	    };
	    axis.orient = function(x) {
	      if (!arguments.length) return orient;
	      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
	      return axis;
	    };
	    axis.ticks = function() {
	      if (!arguments.length) return tickArguments_;
	      tickArguments_ = d3_array(arguments);
	      return axis;
	    };
	    axis.tickValues = function(x) {
	      if (!arguments.length) return tickValues;
	      tickValues = x;
	      return axis;
	    };
	    axis.tickFormat = function(x) {
	      if (!arguments.length) return tickFormat_;
	      tickFormat_ = x;
	      return axis;
	    };
	    axis.tickSize = function(x) {
	      var n = arguments.length;
	      if (!n) return innerTickSize;
	      innerTickSize = +x;
	      outerTickSize = +arguments[n - 1];
	      return axis;
	    };
	    axis.innerTickSize = function(x) {
	      if (!arguments.length) return innerTickSize;
	      innerTickSize = +x;
	      return axis;
	    };
	    axis.outerTickSize = function(x) {
	      if (!arguments.length) return outerTickSize;
	      outerTickSize = +x;
	      return axis;
	    };
	    axis.tickPadding = function(x) {
	      if (!arguments.length) return tickPadding;
	      tickPadding = +x;
	      return axis;
	    };
	    axis.tickSubdivide = function() {
	      return arguments.length && axis;
	    };
	    return axis;
	  };
	  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
	    top: 1,
	    right: 1,
	    bottom: 1,
	    left: 1
	  };
	  function d3_svg_axisX(selection, x0, x1) {
	    selection.attr("transform", function(d) {
	      var v0 = x0(d);
	      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
	    });
	  }
	  function d3_svg_axisY(selection, y0, y1) {
	    selection.attr("transform", function(d) {
	      var v0 = y0(d);
	      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
	    });
	  }
	  d3.svg.brush = function() {
	    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
	    function brush(g) {
	      g.each(function() {
	        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
	        var background = g.selectAll(".background").data([ 0 ]);
	        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
	        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
	        var resize = g.selectAll(".resize").data(resizes, d3_identity);
	        resize.exit().remove();
	        resize.enter().append("g").attr("class", function(d) {
	          return "resize " + d;
	        }).style("cursor", function(d) {
	          return d3_svg_brushCursor[d];
	        }).append("rect").attr("x", function(d) {
	          return /[ew]$/.test(d) ? -3 : null;
	        }).attr("y", function(d) {
	          return /^[ns]/.test(d) ? -3 : null;
	        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
	        resize.style("display", brush.empty() ? "none" : null);
	        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
	        if (x) {
	          range = d3_scaleRange(x);
	          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
	          redrawX(gUpdate);
	        }
	        if (y) {
	          range = d3_scaleRange(y);
	          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
	          redrawY(gUpdate);
	        }
	        redraw(gUpdate);
	      });
	    }
	    brush.event = function(g) {
	      g.each(function() {
	        var event_ = event.of(this, arguments), extent1 = {
	          x: xExtent,
	          y: yExtent,
	          i: xExtentDomain,
	          j: yExtentDomain
	        }, extent0 = this.__chart__ || extent1;
	        this.__chart__ = extent1;
	        if (d3_transitionInheritId) {
	          d3.select(this).transition().each("start.brush", function() {
	            xExtentDomain = extent0.i;
	            yExtentDomain = extent0.j;
	            xExtent = extent0.x;
	            yExtent = extent0.y;
	            event_({
	              type: "brushstart"
	            });
	          }).tween("brush:brush", function() {
	            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
	            xExtentDomain = yExtentDomain = null;
	            return function(t) {
	              xExtent = extent1.x = xi(t);
	              yExtent = extent1.y = yi(t);
	              event_({
	                type: "brush",
	                mode: "resize"
	              });
	            };
	          }).each("end.brush", function() {
	            xExtentDomain = extent1.i;
	            yExtentDomain = extent1.j;
	            event_({
	              type: "brush",
	              mode: "resize"
	            });
	            event_({
	              type: "brushend"
	            });
	          });
	        } else {
	          event_({
	            type: "brushstart"
	          });
	          event_({
	            type: "brush",
	            mode: "resize"
	          });
	          event_({
	            type: "brushend"
	          });
	        }
	      });
	    };
	    function redraw(g) {
	      g.selectAll(".resize").attr("transform", function(d) {
	        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
	      });
	    }
	    function redrawX(g) {
	      g.select(".extent").attr("x", xExtent[0]);
	      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
	    }
	    function redrawY(g) {
	      g.select(".extent").attr("y", yExtent[0]);
	      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
	    }
	    function brushstart() {
	      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
	      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
	      if (d3.event.changedTouches) {
	        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
	      } else {
	        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
	      }
	      g.interrupt().selectAll("*").interrupt();
	      if (dragging) {
	        origin[0] = xExtent[0] - origin[0];
	        origin[1] = yExtent[0] - origin[1];
	      } else if (resizing) {
	        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
	        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
	        origin[0] = xExtent[ex];
	        origin[1] = yExtent[ey];
	      } else if (d3.event.altKey) center = origin.slice();
	      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
	      d3.select("body").style("cursor", eventTarget.style("cursor"));
	      event_({
	        type: "brushstart"
	      });
	      brushmove();
	      function keydown() {
	        if (d3.event.keyCode == 32) {
	          if (!dragging) {
	            center = null;
	            origin[0] -= xExtent[1];
	            origin[1] -= yExtent[1];
	            dragging = 2;
	          }
	          d3_eventPreventDefault();
	        }
	      }
	      function keyup() {
	        if (d3.event.keyCode == 32 && dragging == 2) {
	          origin[0] += xExtent[1];
	          origin[1] += yExtent[1];
	          dragging = 0;
	          d3_eventPreventDefault();
	        }
	      }
	      function brushmove() {
	        var point = d3.mouse(target), moved = false;
	        if (offset) {
	          point[0] += offset[0];
	          point[1] += offset[1];
	        }
	        if (!dragging) {
	          if (d3.event.altKey) {
	            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
	            origin[0] = xExtent[+(point[0] < center[0])];
	            origin[1] = yExtent[+(point[1] < center[1])];
	          } else center = null;
	        }
	        if (resizingX && move1(point, x, 0)) {
	          redrawX(g);
	          moved = true;
	        }
	        if (resizingY && move1(point, y, 1)) {
	          redrawY(g);
	          moved = true;
	        }
	        if (moved) {
	          redraw(g);
	          event_({
	            type: "brush",
	            mode: dragging ? "move" : "resize"
	          });
	        }
	      }
	      function move1(point, scale, i) {
	        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
	        if (dragging) {
	          r0 -= position;
	          r1 -= size + position;
	        }
	        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
	        if (dragging) {
	          max = (min += position) + size;
	        } else {
	          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
	          if (position < min) {
	            max = min;
	            min = position;
	          } else {
	            max = position;
	          }
	        }
	        if (extent[0] != min || extent[1] != max) {
	          if (i) yExtentDomain = null; else xExtentDomain = null;
	          extent[0] = min;
	          extent[1] = max;
	          return true;
	        }
	      }
	      function brushend() {
	        brushmove();
	        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
	        d3.select("body").style("cursor", null);
	        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
	        dragRestore();
	        event_({
	          type: "brushend"
	        });
	      }
	    }
	    brush.x = function(z) {
	      if (!arguments.length) return x;
	      x = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.y = function(z) {
	      if (!arguments.length) return y;
	      y = z;
	      resizes = d3_svg_brushResizes[!x << 1 | !y];
	      return brush;
	    };
	    brush.clamp = function(z) {
	      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
	      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
	      return brush;
	    };
	    brush.extent = function(z) {
	      var x0, x1, y0, y1, t;
	      if (!arguments.length) {
	        if (x) {
	          if (xExtentDomain) {
	            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
	          } else {
	            x0 = xExtent[0], x1 = xExtent[1];
	            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
	            if (x1 < x0) t = x0, x0 = x1, x1 = t;
	          }
	        }
	        if (y) {
	          if (yExtentDomain) {
	            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
	          } else {
	            y0 = yExtent[0], y1 = yExtent[1];
	            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
	            if (y1 < y0) t = y0, y0 = y1, y1 = t;
	          }
	        }
	        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
	      }
	      if (x) {
	        x0 = z[0], x1 = z[1];
	        if (y) x0 = x0[0], x1 = x1[0];
	        xExtentDomain = [ x0, x1 ];
	        if (x.invert) x0 = x(x0), x1 = x(x1);
	        if (x1 < x0) t = x0, x0 = x1, x1 = t;
	        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
	      }
	      if (y) {
	        y0 = z[0], y1 = z[1];
	        if (x) y0 = y0[1], y1 = y1[1];
	        yExtentDomain = [ y0, y1 ];
	        if (y.invert) y0 = y(y0), y1 = y(y1);
	        if (y1 < y0) t = y0, y0 = y1, y1 = t;
	        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
	      }
	      return brush;
	    };
	    brush.clear = function() {
	      if (!brush.empty()) {
	        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
	        xExtentDomain = yExtentDomain = null;
	      }
	      return brush;
	    };
	    brush.empty = function() {
	      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
	    };
	    return d3.rebind(brush, event, "on");
	  };
	  var d3_svg_brushCursor = {
	    n: "ns-resize",
	    e: "ew-resize",
	    s: "ns-resize",
	    w: "ew-resize",
	    nw: "nwse-resize",
	    ne: "nesw-resize",
	    se: "nwse-resize",
	    sw: "nesw-resize"
	  };
	  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
	  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
	  var d3_time_formatUtc = d3_time_format.utc;
	  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
	  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
	  function d3_time_formatIsoNative(date) {
	    return date.toISOString();
	  }
	  d3_time_formatIsoNative.parse = function(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  };
	  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
	  d3_time.second = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 1e3) * 1e3);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
	  }, function(date) {
	    return date.getSeconds();
	  });
	  d3_time.seconds = d3_time.second.range;
	  d3_time.seconds.utc = d3_time.second.utc.range;
	  d3_time.minute = d3_time_interval(function(date) {
	    return new d3_date(Math.floor(date / 6e4) * 6e4);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
	  }, function(date) {
	    return date.getMinutes();
	  });
	  d3_time.minutes = d3_time.minute.range;
	  d3_time.minutes.utc = d3_time.minute.utc.range;
	  d3_time.hour = d3_time_interval(function(date) {
	    var timezone = date.getTimezoneOffset() / 60;
	    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
	  }, function(date, offset) {
	    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
	  }, function(date) {
	    return date.getHours();
	  });
	  d3_time.hours = d3_time.hour.range;
	  d3_time.hours.utc = d3_time.hour.utc.range;
	  d3_time.month = d3_time_interval(function(date) {
	    date = d3_time.day(date);
	    date.setDate(1);
	    return date;
	  }, function(date, offset) {
	    date.setMonth(date.getMonth() + offset);
	  }, function(date) {
	    return date.getMonth();
	  });
	  d3_time.months = d3_time.month.range;
	  d3_time.months.utc = d3_time.month.utc.range;
	  function d3_time_scale(linear, methods, format) {
	    function scale(x) {
	      return linear(x);
	    }
	    scale.invert = function(x) {
	      return d3_time_scaleDate(linear.invert(x));
	    };
	    scale.domain = function(x) {
	      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
	      linear.domain(x);
	      return scale;
	    };
	    function tickMethod(extent, count) {
	      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
	      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
	        return d / 31536e6;
	      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
	    }
	    scale.nice = function(interval, skip) {
	      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
	      if (method) interval = method[0], skip = method[1];
	      function skipped(date) {
	        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
	      }
	      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
	        floor: function(date) {
	          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
	          return date;
	        },
	        ceil: function(date) {
	          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
	          return date;
	        }
	      } : interval));
	    };
	    scale.ticks = function(interval, skip) {
	      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
	        range: interval
	      }, skip ];
	      if (method) interval = method[0], skip = method[1];
	      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
	    };
	    scale.tickFormat = function() {
	      return format;
	    };
	    scale.copy = function() {
	      return d3_time_scale(linear.copy(), methods, format);
	    };
	    return d3_scale_linearRebind(scale, linear);
	  }
	  function d3_time_scaleDate(t) {
	    return new Date(t);
	  }
	  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
	  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
	  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
	    return d.getMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getHours();
	  } ], [ "%a %d", function(d) {
	    return d.getDay() && d.getDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getMonth();
	  } ], [ "%Y", d3_true ] ]);
	  var d3_time_scaleMilliseconds = {
	    range: function(start, stop, step) {
	      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
	    },
	    floor: d3_identity,
	    ceil: d3_identity
	  };
	  d3_time_scaleLocalMethods.year = d3_time.year;
	  d3_time.scale = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
	  };
	  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
	    return [ m[0].utc, m[1] ];
	  });
	  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
	    return d.getUTCMilliseconds();
	  } ], [ ":%S", function(d) {
	    return d.getUTCSeconds();
	  } ], [ "%I:%M", function(d) {
	    return d.getUTCMinutes();
	  } ], [ "%I %p", function(d) {
	    return d.getUTCHours();
	  } ], [ "%a %d", function(d) {
	    return d.getUTCDay() && d.getUTCDate() != 1;
	  } ], [ "%b %d", function(d) {
	    return d.getUTCDate() != 1;
	  } ], [ "%B", function(d) {
	    return d.getUTCMonth();
	  } ], [ "%Y", d3_true ] ]);
	  d3_time_scaleUtcMethods.year = d3_time.year.utc;
	  d3_time.scale.utc = function() {
	    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
	  };
	  d3.text = d3_xhrType(function(request) {
	    return request.responseText;
	  });
	  d3.json = function(url, callback) {
	    return d3_xhr(url, "application/json", d3_json, callback);
	  };
	  function d3_json(request) {
	    return JSON.parse(request.responseText);
	  }
	  d3.html = function(url, callback) {
	    return d3_xhr(url, "text/html", d3_html, callback);
	  };
	  function d3_html(request) {
	    var range = d3_document.createRange();
	    range.selectNode(d3_document.body);
	    return range.createContextualFragment(request.responseText);
	  }
	  d3.xml = d3_xhrType(function(request) {
	    return request.responseXML;
	  });
	  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else if (typeof module === "object" && module.exports) module.exports = d3; else this.d3 = d3;
	}();

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
	 * numeral.js
	 * version : 2.0.6
	 * author : Adam Draper
	 * license : MIT
	 * http://adamwdraper.github.com/Numeral-js/
	 */
	
	(function (global, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        module.exports = factory();
	    } else {
	        global.numeral = factory();
	    }
	}(this, function () {
	    /************************************
	        Variables
	    ************************************/
	
	    var numeral,
	        _,
	        VERSION = '2.0.6',
	        formats = {},
	        locales = {},
	        defaults = {
	            currentLocale: 'en',
	            zeroFormat: null,
	            nullFormat: null,
	            defaultFormat: '0,0',
	            scalePercentBy100: true
	        },
	        options = {
	            currentLocale: defaults.currentLocale,
	            zeroFormat: defaults.zeroFormat,
	            nullFormat: defaults.nullFormat,
	            defaultFormat: defaults.defaultFormat,
	            scalePercentBy100: defaults.scalePercentBy100
	        };
	
	
	    /************************************
	        Constructors
	    ************************************/
	
	    // Numeral prototype object
	    function Numeral(input, number) {
	        this._input = input;
	
	        this._value = number;
	    }
	
	    numeral = function(input) {
	        var value,
	            kind,
	            unformatFunction,
	            regexp;
	
	        if (numeral.isNumeral(input)) {
	            value = input.value();
	        } else if (input === 0 || typeof input === 'undefined') {
	            value = 0;
	        } else if (input === null || _.isNaN(input)) {
	            value = null;
	        } else if (typeof input === 'string') {
	            if (options.zeroFormat && input === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                for (kind in formats) {
	                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
	
	                    if (regexp && input.match(regexp)) {
	                        unformatFunction = formats[kind].unformat;
	
	                        break;
	                    }
	                }
	
	                unformatFunction = unformatFunction || numeral._.stringToNumber;
	
	                value = unformatFunction(input);
	            }
	        } else {
	            value = Number(input)|| null;
	        }
	
	        return new Numeral(input, value);
	    };
	
	    // version number
	    numeral.version = VERSION;
	
	    // compare numeral object
	    numeral.isNumeral = function(obj) {
	        return obj instanceof Numeral;
	    };
	
	    // helper functions
	    numeral._ = _ = {
	        // formats numbers separators, decimals places, signs, abbreviations
	        numberToFormat: function(value, format, roundingFunction) {
	            var locale = locales[numeral.options.currentLocale],
	                negP = false,
	                optDec = false,
	                leadingCount = 0,
	                abbr = '',
	                trillion = 1000000000000,
	                billion = 1000000000,
	                million = 1000000,
	                thousand = 1000,
	                decimal = '',
	                neg = false,
	                abbrForce, // force abbreviation
	                abs,
	                min,
	                max,
	                power,
	                int,
	                precision,
	                signed,
	                thousands,
	                output;
	
	            // make sure we never format a null value
	            value = value || 0;
	
	            abs = Math.abs(value);
	
	            // see if we should use parentheses for negative number or if we should prefix with a sign
	            // if both are present we default to parentheses
	            if (numeral._.includes(format, '(')) {
	                negP = true;
	                format = format.replace(/[\(|\)]/g, '');
	            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
	                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
	                format = format.replace(/[\+|\-]/g, '');
	            }
	
	            // see if abbreviation is wanted
	            if (numeral._.includes(format, 'a')) {
	                abbrForce = format.match(/a(k|m|b|t)?/);
	
	                abbrForce = abbrForce ? abbrForce[1] : false;
	
	                // check for space before abbreviation
	                if (numeral._.includes(format, ' a')) {
	                    abbr = ' ';
	                }
	
	                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
	
	                if (abs >= trillion && !abbrForce || abbrForce === 't') {
	                    // trillion
	                    abbr += locale.abbreviations.trillion;
	                    value = value / trillion;
	                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
	                    // billion
	                    abbr += locale.abbreviations.billion;
	                    value = value / billion;
	                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
	                    // million
	                    abbr += locale.abbreviations.million;
	                    value = value / million;
	                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
	                    // thousand
	                    abbr += locale.abbreviations.thousand;
	                    value = value / thousand;
	                }
	            }
	
	            // check for optional decimals
	            if (numeral._.includes(format, '[.]')) {
	                optDec = true;
	                format = format.replace('[.]', '.');
	            }
	
	            // break number and format
	            int = value.toString().split('.')[0];
	            precision = format.split('.')[1];
	            thousands = format.indexOf(',');
	            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
	
	            if (precision) {
	                if (numeral._.includes(precision, '[')) {
	                    precision = precision.replace(']', '');
	                    precision = precision.split('[');
	                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
	                } else {
	                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
	                }
	
	                int = decimal.split('.')[0];
	
	                if (numeral._.includes(decimal, '.')) {
	                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
	                } else {
	                    decimal = '';
	                }
	
	                if (optDec && Number(decimal.slice(1)) === 0) {
	                    decimal = '';
	                }
	            } else {
	                int = numeral._.toFixed(value, 0, roundingFunction);
	            }
	
	            // check abbreviation again after rounding
	            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
	                int = String(Number(int) / 1000);
	
	                switch (abbr) {
	                    case locale.abbreviations.thousand:
	                        abbr = locale.abbreviations.million;
	                        break;
	                    case locale.abbreviations.million:
	                        abbr = locale.abbreviations.billion;
	                        break;
	                    case locale.abbreviations.billion:
	                        abbr = locale.abbreviations.trillion;
	                        break;
	                }
	            }
	
	
	            // format number
	            if (numeral._.includes(int, '-')) {
	                int = int.slice(1);
	                neg = true;
	            }
	
	            if (int.length < leadingCount) {
	                for (var i = leadingCount - int.length; i > 0; i--) {
	                    int = '0' + int;
	                }
	            }
	
	            if (thousands > -1) {
	                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
	            }
	
	            if (format.indexOf('.') === 0) {
	                int = '';
	            }
	
	            output = int + decimal + (abbr ? abbr : '');
	
	            if (negP) {
	                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
	            } else {
	                if (signed >= 0) {
	                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
	                } else if (neg) {
	                    output = '-' + output;
	                }
	            }
	
	            return output;
	        },
	        // unformats numbers separators, decimals places, signs, abbreviations
	        stringToNumber: function(string) {
	            var locale = locales[options.currentLocale],
	                stringOriginal = string,
	                abbreviations = {
	                    thousand: 3,
	                    million: 6,
	                    billion: 9,
	                    trillion: 12
	                },
	                abbreviation,
	                value,
	                i,
	                regexp;
	
	            if (options.zeroFormat && string === options.zeroFormat) {
	                value = 0;
	            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
	                value = null;
	            } else {
	                value = 1;
	
	                if (locale.delimiters.decimal !== '.') {
	                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
	                }
	
	                for (abbreviation in abbreviations) {
	                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
	
	                    if (stringOriginal.match(regexp)) {
	                        value *= Math.pow(10, abbreviations[abbreviation]);
	                        break;
	                    }
	                }
	
	                // check for negative number
	                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
	
	                // remove non numbers
	                string = string.replace(/[^0-9\.]+/g, '');
	
	                value *= Number(string);
	            }
	
	            return value;
	        },
	        isNaN: function(value) {
	            return typeof value === 'number' && isNaN(value);
	        },
	        includes: function(string, search) {
	            return string.indexOf(search) !== -1;
	        },
	        insert: function(string, subString, start) {
	            return string.slice(0, start) + subString + string.slice(start);
	        },
	        reduce: function(array, callback /*, initialValue*/) {
	            if (this === null) {
	                throw new TypeError('Array.prototype.reduce called on null or undefined');
	            }
	
	            if (typeof callback !== 'function') {
	                throw new TypeError(callback + ' is not a function');
	            }
	
	            var t = Object(array),
	                len = t.length >>> 0,
	                k = 0,
	                value;
	
	            if (arguments.length === 3) {
	                value = arguments[2];
	            } else {
	                while (k < len && !(k in t)) {
	                    k++;
	                }
	
	                if (k >= len) {
	                    throw new TypeError('Reduce of empty array with no initial value');
	                }
	
	                value = t[k++];
	            }
	            for (; k < len; k++) {
	                if (k in t) {
	                    value = callback(value, t[k], k, t);
	                }
	            }
	            return value;
	        },
	        /**
	         * Computes the multiplier necessary to make x >= 1,
	         * effectively eliminating miscalculations caused by
	         * finite precision.
	         */
	        multiplier: function (x) {
	            var parts = x.toString().split('.');
	
	            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
	        },
	        /**
	         * Given a variable number of arguments, returns the maximum
	         * multiplier that must be used to normalize an operation involving
	         * all of them.
	         */
	        correctionFactor: function () {
	            var args = Array.prototype.slice.call(arguments);
	
	            return args.reduce(function(accum, next) {
	                var mn = _.multiplier(next);
	                return accum > mn ? accum : mn;
	            }, 1);
	        },
	        /**
	         * Implementation of toFixed() that treats floats more like decimals
	         *
	         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
	         * problems for accounting- and finance-related software.
	         */
	        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
	            var splitValue = value.toString().split('.'),
	                minDecimals = maxDecimals - (optionals || 0),
	                boundedPrecision,
	                optionalsRegExp,
	                power,
	                output;
	
	            // Use the smallest precision value possible to avoid errors from floating point representation
	            if (splitValue.length === 2) {
	              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
	            } else {
	              boundedPrecision = minDecimals;
	            }
	
	            power = Math.pow(10, boundedPrecision);
	
	            // Multiply up by precision, round accurately, then divide and use native toFixed():
	            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
	
	            if (optionals > maxDecimals - boundedPrecision) {
	                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
	                output = output.replace(optionalsRegExp, '');
	            }
	
	            return output;
	        }
	    };
	
	    // avaliable options
	    numeral.options = options;
	
	    // avaliable formats
	    numeral.formats = formats;
	
	    // avaliable formats
	    numeral.locales = locales;
	
	    // This function sets the current locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    numeral.locale = function(key) {
	        if (key) {
	            options.currentLocale = key.toLowerCase();
	        }
	
	        return options.currentLocale;
	    };
	
	    // This function provides access to the loaded locale data.  If
	    // no arguments are passed in, it will simply return the current
	    // global locale object.
	    numeral.localeData = function(key) {
	        if (!key) {
	            return locales[options.currentLocale];
	        }
	
	        key = key.toLowerCase();
	
	        if (!locales[key]) {
	            throw new Error('Unknown locale : ' + key);
	        }
	
	        return locales[key];
	    };
	
	    numeral.reset = function() {
	        for (var property in defaults) {
	            options[property] = defaults[property];
	        }
	    };
	
	    numeral.zeroFormat = function(format) {
	        options.zeroFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.nullFormat = function (format) {
	        options.nullFormat = typeof(format) === 'string' ? format : null;
	    };
	
	    numeral.defaultFormat = function(format) {
	        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
	    };
	
	    numeral.register = function(type, name, format) {
	        name = name.toLowerCase();
	
	        if (this[type + 's'][name]) {
	            throw new TypeError(name + ' ' + type + ' already registered.');
	        }
	
	        this[type + 's'][name] = format;
	
	        return format;
	    };
	
	
	    numeral.validate = function(val, culture) {
	        var _decimalSep,
	            _thousandSep,
	            _currSymbol,
	            _valArray,
	            _abbrObj,
	            _thousandRegEx,
	            localeData,
	            temp;
	
	        //coerce val to string
	        if (typeof val !== 'string') {
	            val += '';
	
	            if (console.warn) {
	                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
	            }
	        }
	
	        //trim whitespaces from either sides
	        val = val.trim();
	
	        //if val is just digits return true
	        if (!!val.match(/^\d+$/)) {
	            return true;
	        }
	
	        //if val is empty return false
	        if (val === '') {
	            return false;
	        }
	
	        //get the decimal and thousands separator from numeral.localeData
	        try {
	            //check if the culture is understood by numeral. if not, default it to current locale
	            localeData = numeral.localeData(culture);
	        } catch (e) {
	            localeData = numeral.localeData(numeral.locale());
	        }
	
	        //setup the delimiters and currency symbol based on culture/locale
	        _currSymbol = localeData.currency.symbol;
	        _abbrObj = localeData.abbreviations;
	        _decimalSep = localeData.delimiters.decimal;
	        if (localeData.delimiters.thousands === '.') {
	            _thousandSep = '\\.';
	        } else {
	            _thousandSep = localeData.delimiters.thousands;
	        }
	
	        // validating currency symbol
	        temp = val.match(/^[^\d]+/);
	        if (temp !== null) {
	            val = val.substr(1);
	            if (temp[0] !== _currSymbol) {
	                return false;
	            }
	        }
	
	        //validating abbreviation symbol
	        temp = val.match(/[^\d]+$/);
	        if (temp !== null) {
	            val = val.slice(0, -1);
	            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
	                return false;
	            }
	        }
	
	        _thousandRegEx = new RegExp(_thousandSep + '{2}');
	
	        if (!val.match(/[^\d.,]/g)) {
	            _valArray = val.split(_decimalSep);
	            if (_valArray.length > 2) {
	                return false;
	            } else {
	                if (_valArray.length < 2) {
	                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
	                } else {
	                    if (_valArray[0].length === 1) {
	                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    } else {
	                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
	                    }
	                }
	            }
	        }
	
	        return false;
	    };
	
	
	    /************************************
	        Numeral Prototype
	    ************************************/
	
	    numeral.fn = Numeral.prototype = {
	        clone: function() {
	            return numeral(this);
	        },
	        format: function(inputString, roundingFunction) {
	            var value = this._value,
	                format = inputString || options.defaultFormat,
	                kind,
	                output,
	                formatFunction;
	
	            // make sure we have a roundingFunction
	            roundingFunction = roundingFunction || Math.round;
	
	            // format based on value
	            if (value === 0 && options.zeroFormat !== null) {
	                output = options.zeroFormat;
	            } else if (value === null && options.nullFormat !== null) {
	                output = options.nullFormat;
	            } else {
	                for (kind in formats) {
	                    if (format.match(formats[kind].regexps.format)) {
	                        formatFunction = formats[kind].format;
	
	                        break;
	                    }
	                }
	
	                formatFunction = formatFunction || numeral._.numberToFormat;
	
	                output = formatFunction(value, format, roundingFunction);
	            }
	
	            return output;
	        },
	        value: function() {
	            return this._value;
	        },
	        input: function() {
	            return this._input;
	        },
	        set: function(value) {
	            this._value = Number(value);
	
	            return this;
	        },
	        add: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum + Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;
	
	            return this;
	        },
	        subtract: function(value) {
	            var corrFactor = _.correctionFactor.call(null, this._value, value);
	
	            function cback(accum, curr, currI, O) {
	                return accum - Math.round(corrFactor * curr);
	            }
	
	            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;
	
	            return this;
	        },
	        multiply: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback, 1);
	
	            return this;
	        },
	        divide: function(value) {
	            function cback(accum, curr, currI, O) {
	                var corrFactor = _.correctionFactor(accum, curr);
	                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
	            }
	
	            this._value = _.reduce([this._value, value], cback);
	
	            return this;
	        },
	        difference: function(value) {
	            return Math.abs(numeral(this._value).subtract(value).value());
	        }
	    };
	
	    /************************************
	        Default Locale && Format
	    ************************************/
	
	    numeral.register('locale', 'en', {
	        delimiters: {
	            thousands: ',',
	            decimal: '.'
	        },
	        abbreviations: {
	            thousand: 'k',
	            million: 'm',
	            billion: 'b',
	            trillion: 't'
	        },
	        ordinal: function(number) {
	            var b = number % 10;
	            return (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	        },
	        currency: {
	            symbol: '$'
	        }
	    });
	
	    
	
	(function() {
	        numeral.register('format', 'bps', {
	            regexps: {
	                format: /(BPS)/,
	                unformat: /(BPS)/
	            },
	            format: function(value, format, roundingFunction) {
	                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
	                    output;
	
	                value = value * 10000;
	
	                // check for space before BPS
	                format = format.replace(/\s?BPS/, '');
	
	                output = numeral._.numberToFormat(value, format, roundingFunction);
	
	                if (numeral._.includes(output, ')')) {
	                    output = output.split('');
	
	                    output.splice(-1, 0, space + 'BPS');
	
	                    output = output.join('');
	                } else {
	                    output = output + space + 'BPS';
	                }
	
	                return output;
	            },
	            unformat: function(string) {
	                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
	            }
	        });
	})();
	
	
	(function() {
	        var decimal = {
	            base: 1000,
	            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
	        },
	        binary = {
	            base: 1024,
	            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
	        };
	
	    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
	            return decimal.suffixes.indexOf(item) < 0;
	        }));
	        var unformatRegex = allSuffixes.join('|');
	        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
	        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
	
	    numeral.register('format', 'bytes', {
	        regexps: {
	            format: /([0\s]i?b)/,
	            unformat: new RegExp(unformatRegex)
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
	                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
	                power,
	                min,
	                max;
	
	            // check for space before
	            format = format.replace(/\s?i?b/, '');
	
	            for (power = 0; power <= bytes.suffixes.length; power++) {
	                min = Math.pow(bytes.base, power);
	                max = Math.pow(bytes.base, power + 1);
	
	                if (value === null || value === 0 || value >= min && value < max) {
	                    suffix += bytes.suffixes[power];
	
	                    if (min > 0) {
	                        value = value / min;
	                    }
	
	                    break;
	                }
	            }
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + suffix;
	        },
	        unformat: function(string) {
	            var value = numeral._.stringToNumber(string),
	                power,
	                bytesMultiplier;
	
	            if (value) {
	                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
	                    if (numeral._.includes(string, decimal.suffixes[power])) {
	                        bytesMultiplier = Math.pow(decimal.base, power);
	
	                        break;
	                    }
	
	                    if (numeral._.includes(string, binary.suffixes[power])) {
	                        bytesMultiplier = Math.pow(binary.base, power);
	
	                        break;
	                    }
	                }
	
	                value *= (bytesMultiplier || 1);
	            }
	
	            return value;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'currency', {
	        regexps: {
	            format: /(\$)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                symbols = {
	                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
	                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
	                },
	                output,
	                symbol,
	                i;
	
	            // strip format of spaces and $
	            format = format.replace(/\s?\$\s?/, '');
	
	            // format the number
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            // update the before and after based on value
	            if (value >= 0) {
	                symbols.before = symbols.before.replace(/[\-\(]/, '');
	                symbols.after = symbols.after.replace(/[\-\)]/, '');
	            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
	                symbols.before = '-' + symbols.before;
	            }
	
	            // loop through each before symbol
	            for (i = 0; i < symbols.before.length; i++) {
	                symbol = symbols.before[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = numeral._.insert(output, locale.currency.symbol, i);
	                        break;
	                    case ' ':
	                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
	                        break;
	                }
	            }
	
	            // loop through each after symbol
	            for (i = symbols.after.length - 1; i >= 0; i--) {
	                symbol = symbols.after[i];
	
	                switch (symbol) {
	                    case '$':
	                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
	                        break;
	                    case ' ':
	                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
	                        break;
	                }
	            }
	
	
	            return output;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'exponential', {
	        regexps: {
	            format: /(e\+|e-)/,
	            unformat: /(e\+|e-)/
	        },
	        format: function(value, format, roundingFunction) {
	            var output,
	                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
	                parts = exponential.split('e');
	
	            format = format.replace(/e[\+|\-]{1}0/, '');
	
	            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
	
	            return output + 'e' + parts[1];
	        },
	        unformat: function(string) {
	            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
	                value = Number(parts[0]),
	                power = Number(parts[1]);
	
	            power = numeral._.includes(string, 'e-') ? power *= -1 : power;
	
	            function cback(accum, curr, currI, O) {
	                var corrFactor = numeral._.correctionFactor(accum, curr),
	                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
	                return num;
	            }
	
	            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'ordinal', {
	        regexps: {
	            format: /(o)/
	        },
	        format: function(value, format, roundingFunction) {
	            var locale = numeral.locales[numeral.options.currentLocale],
	                output,
	                ordinal = numeral._.includes(format, ' o') ? ' ' : '';
	
	            // check for space before
	            format = format.replace(/\s?o/, '');
	
	            ordinal += locale.ordinal(value);
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            return output + ordinal;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'percentage', {
	        regexps: {
	            format: /(%)/,
	            unformat: /(%)/
	        },
	        format: function(value, format, roundingFunction) {
	            var space = numeral._.includes(format, ' %') ? ' ' : '',
	                output;
	
	            if (numeral.options.scalePercentBy100) {
	                value = value * 100;
	            }
	
	            // check for space before %
	            format = format.replace(/\s?\%/, '');
	
	            output = numeral._.numberToFormat(value, format, roundingFunction);
	
	            if (numeral._.includes(output, ')')) {
	                output = output.split('');
	
	                output.splice(-1, 0, space + '%');
	
	                output = output.join('');
	            } else {
	                output = output + space + '%';
	            }
	
	            return output;
	        },
	        unformat: function(string) {
	            var number = numeral._.stringToNumber(string);
	            if (numeral.options.scalePercentBy100) {
	                return number * 0.01;
	            }
	            return number;
	        }
	    });
	})();
	
	
	(function() {
	        numeral.register('format', 'time', {
	        regexps: {
	            format: /(:)/,
	            unformat: /(:)/
	        },
	        format: function(value, format, roundingFunction) {
	            var hours = Math.floor(value / 60 / 60),
	                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
	                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));
	
	            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
	        },
	        unformat: function(string) {
	            var timeArray = string.split(':'),
	                seconds = 0;
	
	            // turn hours and minutes into seconds and add them all up
	            if (timeArray.length === 3) {
	                // hours
	                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
	                // minutes
	                seconds = seconds + (Number(timeArray[1]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[2]);
	            } else if (timeArray.length === 2) {
	                // minutes
	                seconds = seconds + (Number(timeArray[0]) * 60);
	                // seconds
	                seconds = seconds + Number(timeArray[1]);
	            }
	            return Number(seconds);
	        }
	    });
	})();
	
	return numeral;
	}));


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _mapPage = __webpack_require__(101);
	
	var _mapPage2 = _interopRequireDefault(_mapPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapPage() {
	    return {
	        restrict: "E",
	        scope: {
	            name: '='
	        },
	        template: __webpack_require__(105),
	        controller: _mapPage2.default,
	        controllerAs: 'ctrl' //,
	        // link:link
	    };
	
	    // function link(scope, element, attrs){
	
	
	    //
	    // // var map = L.map('mapID').setView([51.505, -0.09], 13);
	    // var mapID = L.map('mapID',
	    //     {
	    //         center: [37.5, -122.23],
	    //         zoom: 1
	    //     });
	    //
	    // L.tileLayer.provider('Stamen.Watercolor').addTo(mapID);
	    // // L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
	    //
	    // console.log("MAP DIRECTIVE", L);
	    //
	    // // L.esri.basemapLayer('DarkGray').addTo(map);
	
	    // }
	} /**
	   * Created by Julio Perez on 9/29/2016.
	   */
	exports.default = angular.module('map-page.directive', []).directive('mapPage', mapPage).name;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container-fluid kill-sides\">\r\n    <div id=\"map\"></div>\r\n</div>\r\n<div class=\"container-fluid legend-container kill-sides\">\r\n    <!--<h6 class=\"legend-title\">LEGEND</h6>-->\r\n    <div class=\"legend-headers\">\r\n        <h6 class=\"legend-header\">{{ctrl.getLegendHeader()}}</h6>\r\n        <h6 class=\"legend-sub-header\">'000 Thousands</h6>\r\n    </div>\r\n    <div id=\"legend\" class=\"legend-range\"></div>\r\n</div>\r\n\r\n<div class=\"container-fluid legend-container kill-sides\">\r\n\r\n    <!--<div>-->\r\n        <!--<div>-->\r\n            <!--<small><b>Source:</b> Euromonitor Income and Wealth Distribution Model</small>-->\r\n        <!--</div>-->\r\n        <!--<div>-->\r\n            <!--<small><b>Note:</b> Net wealth is defined as the sum of all financial and non-financial assets minus all liabilities. 2030 data refers to current prices.</small>-->\r\n        <!--</div>-->\r\n        <!--<div class=\"margin-top-15\">-->\r\n            <!--<small>For further insight please contact Aleksej Baksajev, at <a href=\"mailto:aleksej.baksajev@euromonitor.com\">aleksej.baksajev@euromonitor.com</a></small>-->\r\n\r\n        <!--</div>-->\r\n    <!--</div>-->\r\n\r\n    <!--<h6 class=\"kill-sides margin-top-20\">COUNTRIES COVERED</h6>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Africa and Middle East:</b> Egypt, Israel, Nigeria, South Africa, United Arab Emirates</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Asia-Pacific:</b> Azerbaijan, China, Hong Kong, India, Indonesia, Japan, Kazakhstan, Malaysia, Pakistan, Philippines, Singapore, South Korea, Taiwan, Thailand, Turkmenistan, Uzbekistan, Vietnam</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Australasia:</b> Australia, New Zealand</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Eastern Europe:</b> Belarus, Bosnia-Herzegovina, Bulgaria, Croatia, Czech Republic, Estonia, Georgia, Hungary, Latvia, Lithuania, Macedonia, Poland, Romania, Russia, Serbia, Slovakia, Slovenia, Ukraine</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Western Europe:</b> Austria, Belgium, Denmark, Finland, France, Germany, Greece, Ireland, Italy, Netherlands, Norway, Portugal, Spain, Sweden, Switzerland, Turkey, UK</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>Latin America:</b> Argentina, Bolivia, Brazil, Chile, Colombia, Costa Rica, Dominican Republic, Ecuador, Guatemala, Mexico, Peru, Uruguay</small>-->\r\n    <!--</div>-->\r\n    <!--<div>-->\r\n        <!--<small><b>North America:</b> Canada, USA</small>-->\r\n\r\n    <!--</div>-->\r\n\r\n</div>\r\n"

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	        value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by julio perez on 10/19/2016.
	 */
	
	var MapLeafletService = function () {
	        function MapLeafletService() {
	                _classCallCheck(this, MapLeafletService);
	
	                var vm = this;
	                vm.mapData = null;
	                vm.segmentData = null;
	
	                vm.markers = [];
	                vm.zoom = 2;
	
	                // here's the SVG for the marker
	                vm.icon = "<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='10' height='10'><rect width='5' height='5' stroke='blue' stroke-width='1' d='M 0,0 L 10,10 M 10,0 L 0,10 Z'/></svg>";
	
	                // here's the trick, base64 encode the URL
	                vm.svgURL = "data:image/svg+xml;base64," + btoa(vm.icon);
	
	                vm.dIcon = L.divIcon({
	                        className: 'div-icon',
	                        iconSize: [5, 5]
	                });
	
	                // create icon
	                vm.SVGIcon = L.icon({
	                        iconUrl: vm.svgURL,
	                        iconSize: [10, 10],
	                        shadowSize: [12, 10],
	                        iconAnchor: [5, 5],
	                        popupAnchor: [5, -5]
	                });
	
	                // vm.map = new L.Map("map", {
	                //     attributionControl: false,
	                //     zoomControl: false,
	                //     dragging: false,
	                //     scrollWheelZoom:false,
	                //     doubleClickZoom: false,
	                //     boxZoom: false,
	                //     center: new L.LatLng(28.0902, 100.7129),
	                //     zoomSnap: .25,
	                //     zoom: 1.5
	                // });
	
	
	                vm.map = new L.Map("map", {
	                        attributionControl: true,
	                        zoomControl: true,
	                        dragging: true,
	                        scrollWheelZoom: true,
	                        doubleClickZoom: true,
	                        boxZoom: true,
	                        center: new L.LatLng(22.1583, 2.9638),
	                        zoomSnap: .25,
	                        zoom: 1.5,
	                        minZoom: 1.5,
	                        maxZoom: 3.5
	                });
	
	                vm.map.invalidateSize();
	                vm.maxBounds = vm.map.getBounds();
	
	                vm.wMap = __webpack_require__(107);
	
	                // L.tileLayer.provider('CartoDB.Positron').addTo(vm.map);
	                L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_nolabels/{z}/{x}/{y}.png', {
	                        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy;<a href="https://carto.com/attribution">CARTO</a>',
	                        noWrap: false,
	                        continuousWorld: false
	                }).addTo(vm.map);
	                L.Projection.Mercator;
	
	                vm.map.setMaxBounds(vm.maxBounds);
	
	                // vm.bounds = vm.map.getBounds();
	                // vm.map.fitBounds(vm.bounds);
	
	                // vm.z = vm.map.getZoom();
	                //
	                // vm.map.setZoom(vm.z);
	                // vm.map.on('zoomend', update);
	                //
	                // update();
	
	                function update() {}
	
	                // var largestSide = Math.max(bounds[1][0] - bounds[0][0],
	                //         bounds[1][1] - bounds[0][1]) / 40;
	                // var zoomLevel = map.getZoom();
	                // rects.style('stroke-width', largestSide / zoomLevel);
	
	
	                // vm.blueIcon = L.icon({
	                //     iconUrl: 'http://commscdn.euromonitor.com/WTM-2016/images/map_marker_blue.png',
	                //     shadowUrl: 'http://commscdn.euromonitor.com/WTM-2016/images/map_marker_blue_shadow.png',
	                //     iconSize: [40,40],
	                //     shadowSize: [40,40],
	                //     iconAnchor: [25, 25],
	                //     shadowAnchor: [25,25],
	                //     popupAnchor: [-5, -15]
	                // })
	                //
	                // vm.popOps =  {
	                //     'maxWidth': '400',
	                //     closeButton: false,
	                //     'className': 'popOps'
	                // }
	
	                // vm.createMarker=(item, index)=>{
	                //
	                //     var marker =  new L.marker(item.latlng, {icon: vm.dIcon, title: item.country})
	                //         .bindPopup(vm.getPop(item.country, item.latlng ), vm.popOps);
	                //
	                //     marker.id = item.country;
	                //     marker.name = item.country;
	                //     vm.markers.push(marker);
	                //     vm.map.addLayer(marker);
	                //
	                //     return marker;
	                // }
	                //
	                // vm.getPop=(countryName, location)=>{
	                //
	                //
	                //     return "<h6 class='pop-section'>" + countryName.toUpperCase() + "</h6>" + "<h4 class='pop-country'>" + location + "</h4>";
	                //
	                // }
	
	                // vm.displayMarker=()=>{
	                //     let vm = this;
	                //
	                //     console.log("segment LEN:: ", vm.segmentData)
	                //     vm.markers.forEach(function(marker) {
	                //
	                //        let size = vm.segmentData
	                //             .filter(function(item){
	                //                 return marker.id == item.country;
	                //             })
	                //             .map(function(val) {
	                //                 // console.log("--- ", val.metricValueCurrent);
	                //                 return parseFloat(3);
	                //             }).shift();
	                //
	                //         // console.log(":: ", size);
	                //        //
	                //         let icon = marker.options.icon;
	                //        icon.options.iconSize = [size,size];
	                //        marker.setIcon(icon);
	                //        console.log("displayMarker() :: ", marker.options.icon.options.iconSize);
	                //         // marker.iconSize[size,size];
	                //
	                //     });
	                // }
	
	        }
	
	        _createClass(MapLeafletService, [{
	                key: "createMarkers",
	                value: function createMarkers() {
	
	                        var vm = this;
	
	                        vm.mapData.forEach(vm.createMarker);
	                        vm.displayMarker();
	                }
	
	                // createMarker(id){
	                //     let vm = this;
	                //
	                //     var marker =  new L.marker(getLocation(id), {icon: vm.dIcon, title: id})
	                //         .addTo(vm.map)
	                //         .bindPopup(getPop(id), vm.popOps);
	                //     return marker;
	                // }
	
	        }, {
	                key: "getMap",
	                value: function getMap() {
	                        var vm = this;
	                        return vm.map;
	                }
	
	                // getZoom(id){
	                //
	                //     let vm = this;
	                //
	                //     vm.zoom = 2;
	                //
	                //     switch(id){
	                //         case 'GLOBAL':
	                //             vm.zoom = 2;
	                //             break;
	                //         case 'US':
	                //             vm.zoom = 4;
	                //             break;
	                //         case 'EU':
	                //             vm.zoom = 4;
	                //             break;
	                //         case 'ME':
	                //             vm.zoom = 4;
	                //             break;
	                //         case 'AF':
	                //             vm.zoom = 3;
	                //             break;
	                //         case 'UK':
	                //             vm.zoom = 5;
	                //             break;
	                //         case 'IN':
	                //             vm.zoom = 4;
	                //             break;
	                //         case 'AS':
	                //             vm.zoom = 4;
	                //             break;
	                //         case 'CM':
	                //             vm.zoom = 2;
	                //             break;
	                //         default:
	                //             vm.zoom = 2;
	                //             break;
	                //
	                //     }
	                //
	                //     return vm.zoom;
	                // }
	
	                // getSection(id){
	                //
	                //     var section = "";
	                //
	                //     switch(id){
	                //         case "GLOBAL":
	                //             section = "Bag Free, Hassle Free Travel";
	                //             break;
	                //         case "US":
	                //             section = "Roamies: Co-living Nomads"
	                //             break;
	                //         case "EU":
	                //             section = "Microadventure, Maximum Impact"
	                //             break;
	                //         case "UK":
	                //             section = "Supersonic Travel Boom"
	                //             break;
	                //         case "ME":
	                //             section = "Hiking Through History"
	                //             break;
	                //         case "AF":
	                //             section = "Mindfulness in the Wilderness"
	                //             break;
	                //         case "AS":
	                //             section = "Walking in a Chinese Wanda-Land"
	                //             break;
	                //         case "IN":
	                //             section = "New Travel Gig for Women"
	                //             break;
	                //         case 'CM':
	                //             section = "Clicks and Mortar 2.0"
	                //             break;
	                //         default:
	                //             section = "Bag Free, Hassle Free Travel";
	                //             break;
	                //     }
	                //
	                //
	                //     return section;
	                //
	                // }
	
	
	        }, {
	                key: "init",
	                value: function init() {
	                        console.log('init');
	                }
	
	                // updateMap(id){
	                //
	                //     let vm = this;
	                //
	                //     switch(id){
	                //         case 'Bag Free, Hassle Free Travel':
	                //             vm.map.setView([37.0902, -1.7129], 2);
	                //             break;
	                //         case 'Roamies: Co-living Nomads':
	                //             vm.map.setView([37.0902, -95.7129], 4);
	                //             break;
	                //         case 'Microadventure, Maximum Impact':
	                //             vm.map.setView([47.100817, 2.640566], 4);
	                //             break;
	                //         case 'Hiking Through History':
	                //             vm.map.setView([29.2985278, 42.5509603], 4);
	                //             break;
	                //         case 'Mindfulness in the Wilderness':
	                //             vm.map.setView([8.7832, 34.5085], 3);
	                //             break;
	                //         case 'Supersonic Travel Boom':
	                //             vm.map.setView([53.489543, -1.583047], 5);
	                //             break;
	                //         case 'New Travel Gig for Women':
	                //             vm.map.setView([20.593684, 78.96288],4);
	                //             break;
	                //         case 'Walking in a Chinese Wanda-Land':
	                //             vm.map.setView([30.304745, 113.117144], 4);
	                //             break;
	                //         case 'Clicks and Mortar 2.0':
	                //             vm.map.setView([37.0902, -1.7129], 2);
	                //             break;
	                //         default:
	                //             vm.map.setView([37.0902, -1.7129], 2);
	                //             break;
	                //
	                //     }
	                //
	                //     return;
	                // }
	
	
	                // getPopUP(country){
	                //
	                //     var countryName = "";
	                //     var section = "";
	                //
	                //     switch(country){
	                //         case "US":
	                //             countryName = "USA";
	                //             section = "Roamies: Co-living Nomads"
	                //             break;
	                //         case "EU":
	                //             countryName = "Europe";
	                //             section = "Microadventures, Maximum Impact"
	                //             break;
	                //         case "UK":
	                //             countryName = "United Kingdom";
	                //             section = "Supersonic Travel Boom"
	                //             break;
	                //         case "ME":
	                //             countryName = "Middle East";
	                //             section = "History and Hiking Trails"
	                //             break;
	                //         case "AF":
	                //             countryName = "Africa";
	                //             section = "Mindfulness in the Wilderness"
	                //             break;
	                //         case "AS":
	                //             countryName = "Asia";
	                //             section = "Walking in a Chinese Wanda-Land"
	                //             break;
	                //         case "IN":
	                //             countryName = "India";
	                //             section = "New Travel Gig for Women"
	                //             break;
	                //
	                //         default:
	                //             break;
	                //     }
	                //
	                //
	                //     return "<h4>" + countryName.toUpperCase() + "</h4>" + "<h6>" + section + "</h6>";
	                //
	                // }
	
	
	        }]);
	
	        return MapLeafletService;
	}();
	
	// function getZoom(id){
	//
	//     var zm = 2;
	//
	//     switch(id){
	//         case 'GLOBAL':
	//             zm = 2;
	//             break;
	//         case 'US':
	//             zm = 4;
	//             break;
	//         case 'EU':
	//             zm = 4;
	//             break;
	//         case 'ME':
	//             zm = 4;
	//             break;
	//         case 'AF':
	//             zm = 3;
	//             break;
	//         case 'UK':
	//             zm = 5;
	//             break;
	//         case 'IN':
	//             zm = 4;
	//             break;
	//         case 'AS':
	//             zm = 4;
	//             break;
	//         default:
	//             zm = 2;
	//             break;
	//
	//     }
	//
	//     return zm;
	// }
	
	//
	// function onMarkClick(evt){
	//
	//    let vm = this;
	//
	//     var zm = getZoom(evt.target.options.title);
	//     this._map.setView(this.getLatLng(), zm);
	//
	// }
	//
	//
	// function getPop(country){
	//     var countryName = "";
	//     var section = "";
	//
	//     switch(country){
	//         case "US":
	//             countryName = "USA";
	//             section = "Roamies: Co-living Nomads"
	//             break;
	//         case "EU":
	//             countryName = "Europe";
	//             section = "Microadventure, Maximum Impact"
	//             break;
	//         case "UK":
	//             countryName = "United Kingdom";
	//             section = "Supersonic Travel Boom"
	//             break;
	//         case "ME":
	//             countryName = "Middle East";
	//             section = "Hiking Through History"
	//             break;
	//         case "AF":
	//             countryName = "Africa";
	//             section = "Mindfulness in the Wilderness"
	//             break;
	//         case "AS":
	//             countryName = "Asia";
	//             section = "Walking in a Chinese Wanda-Land"
	//             break;
	//         case "IN":
	//             countryName = "India";
	//             section = "New Travel Gig for Women"
	//             break;
	//
	//         default:
	//             break;
	//     }
	//
	//
	//     return "<h6 class='pop-section'>" + section + "</h6>" + "<h4 class='pop-country'>" + countryName.toUpperCase() + "</h4>";
	//
	// }
	
	// function getLocation(id){
	//
	//     let vm = this;
	//     var loc = [];
	//
	//     switch(id){
	//         case 'GLOBAL':
	//             loc = [37.0902, -1.7129];
	//             break;
	//         case 'US':
	//             loc = [37.0902, -95.7129];
	//             break;
	//         case 'EU':
	//             loc = [47.100817, 2.640566];
	//             break;
	//         case 'ME':
	//             loc = [29.2985278, 42.5509603];
	//             break;
	//         case 'AF':
	//             loc = [8.7832, 34.5085];
	//             break;
	//         case 'UK':
	//             loc = [53.489543, -1.583047];
	//             break;
	//         case 'IN':
	//             loc = [20.593684, 78.96288];
	//             break;
	//         case 'AS':
	//             loc = [30.304745, 113.117144];
	//             break;
	//         case 'CM':
	//             loc = [37.0902, -1.7129];
	//             break;
	//         default:
	//             loc = [37.0902, -1.7129];
	//             break;
	//
	//     }
	//
	//     return loc;
	// }
	
	
	exports.default = angular.module('mapLeafletService', []).service('mapLeafletService', MapLeafletService).name;

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	module.exports = {
		"features": [
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									53.92783203125009,
									24.17719726562504
								],
								[
									53.928124999999966,
									24.143359375000074
								],
								[
									53.82636718750001,
									24.153125000000017
								],
								[
									53.79912109375016,
									24.13554687499999
								],
								[
									53.7158203125,
									24.145312500000017
								],
								[
									53.63447265625001,
									24.169775390625034
								],
								[
									53.68964843750018,
									24.21079101562495
								],
								[
									53.833789062500045,
									24.25893554687508
								],
								[
									53.89375000000018,
									24.21513671875013
								],
								[
									53.92783203125009,
									24.17719726562504
								]
							]
						],
						[
							[
								[
									52.61689453125018,
									24.288574218750085
								],
								[
									52.600000000000136,
									24.281298828125017
								],
								[
									52.58222656250007,
									24.33525390624999
								],
								[
									52.58359375000009,
									24.352343750000102
								],
								[
									52.62939453125,
									24.376757812500102
								],
								[
									52.657617187500136,
									24.33261718750009
								],
								[
									52.61689453125018,
									24.288574218750085
								]
							]
						],
						[
							[
								[
									53.33222656250018,
									24.258593750000102
								],
								[
									53.258300781250114,
									24.252929687500085
								],
								[
									53.19091796875,
									24.290917968750023
								],
								[
									53.33251953124994,
									24.341601562500045
								],
								[
									53.37089843750016,
									24.364453125000068
								],
								[
									53.41240234375016,
									24.41103515625008
								],
								[
									53.445312500000114,
									24.371191406250034
								],
								[
									53.40898437499999,
									24.307910156250017
								],
								[
									53.38261718750016,
									24.28085937500009
								],
								[
									53.33222656250018,
									24.258593750000102
								]
							]
						],
						[
							[
								[
									54.465429687500034,
									24.44277343750005
								],
								[
									54.45664062500009,
									24.42333984375
								],
								[
									54.42841796875001,
									24.425097656250102
								],
								[
									54.35771484374999,
									24.44277343750005
								],
								[
									54.33476562500016,
									24.47104492187495
								],
								[
									54.37890625,
									24.50458984375004
								],
								[
									54.398339843750136,
									24.506347656249943
								],
								[
									54.42656249999999,
									24.47104492187495
								],
								[
									54.465429687500034,
									24.44277343750005
								]
							]
						],
						[
							[
								[
									56.297851562500114,
									25.650683593750017
								],
								[
									56.36347656250018,
									25.569384765625074
								],
								[
									56.372851562500045,
									25.01831054687497
								],
								[
									56.38798828124999,
									24.979199218750097
								],
								[
									56.352929687499966,
									24.97329101562505
								],
								[
									56.313574218750034,
									24.931298828125108
								],
								[
									56.26787109375016,
									24.866699218750085
								],
								[
									56.204687500000034,
									24.83330078125013
								],
								[
									56.15449218750007,
									24.795507812500063
								],
								[
									56.106542968750034,
									24.748681640625023
								],
								[
									56.063867187500136,
									24.738769531250057
								],
								[
									56.008398437500034,
									24.798242187499994
								],
								[
									55.97031250000009,
									24.858935546875102
								],
								[
									55.97968750000007,
									24.87207031250003
								],
								[
									56.00634765625,
									24.876416015624926
								],
								[
									56.016699218750034,
									24.90771484375
								],
								[
									56.000585937500034,
									24.95322265624995
								],
								[
									55.96308593750007,
									24.970263671875045
								],
								[
									55.91582031249999,
									24.97177734375009
								],
								[
									55.870703125000034,
									24.95141601562503
								],
								[
									55.82285156250009,
									24.911279296875023
								],
								[
									55.79570312500016,
									24.868115234374926
								],
								[
									55.79160156250009,
									24.781298828125102
								],
								[
									55.804199218750114,
									24.683593750000085
								],
								[
									55.80390625000001,
									24.63623046875003
								],
								[
									55.77753906250018,
									24.577343749999926
								],
								[
									55.768164062500034,
									24.490624999999937
								],
								[
									55.78681640625018,
									24.42353515625004
								],
								[
									55.80400390625016,
									24.38354492187497
								],
								[
									55.805664062500114,
									24.34980468750004
								],
								[
									55.760839843750034,
									24.242675781250057
								],
								[
									55.799707031249966,
									24.22265624999997
								],
								[
									55.928613281250136,
									24.21513671875013
								],
								[
									55.96630859375,
									24.142626953125102
								],
								[
									55.992187500000114,
									24.092968749999926
								],
								[
									55.98515624999999,
									24.063378906249937
								],
								[
									55.894140625000034,
									24.041406249999994
								],
								[
									55.779101562500045,
									24.017089843750114
								],
								[
									55.69658203124999,
									24.02412109375001
								],
								[
									55.547851562500114,
									23.991357421875108
								],
								[
									55.46845703125018,
									23.941113281249983
								],
								[
									55.491796875000034,
									23.90966796874997
								],
								[
									55.51933593750016,
									23.88549804687503
								],
								[
									55.531640624999966,
									23.819042968749983
								],
								[
									55.50849609375018,
									23.72460937500003
								],
								[
									55.466308593750114,
									23.63291015625009
								],
								[
									55.41386718750016,
									23.51875000000001
								],
								[
									55.35322265625007,
									23.387451171875085
								],
								[
									55.27021484375001,
									23.189941406250085
								],
								[
									55.19990234375018,
									23.03476562500009
								],
								[
									55.192187500000045,
									22.92294921874995
								],
								[
									55.19404296875007,
									22.850000000000108
								],
								[
									55.18583984375016,
									22.70410156250003
								],
								[
									55.119433593750045,
									22.62392578125005
								],
								[
									55.10429687500016,
									22.621484374999994
								],
								[
									55.02500000000009,
									22.631152343750102
								],
								[
									54.99824218750001,
									22.634375000000034
								],
								[
									54.922460937500034,
									22.643652343749977
								],
								[
									54.80488281250018,
									22.658007812500074
								],
								[
									54.652246093749966,
									22.67666015625005
								],
								[
									54.47167968749994,
									22.698730468750114
								],
								[
									54.270117187500034,
									22.72333984375004
								],
								[
									54.054589843749966,
									22.749658203124994
								],
								[
									53.832128906250034,
									22.776806640624926
								],
								[
									53.60957031250018,
									22.80400390624996
								],
								[
									53.39404296875,
									22.830322265625
								],
								[
									53.192382812500114,
									22.85493164062504
								],
								[
									53.01191406250001,
									22.877001953125102
								],
								[
									52.85927734375002,
									22.895605468749977
								],
								[
									52.74160156250002,
									22.910009765624977
								],
								[
									52.665917968750136,
									22.919287109375006
								],
								[
									52.639160156250114,
									22.92250976562505
								],
								[
									52.555078125000136,
									22.93281250000001
								],
								[
									52.50957031249999,
									22.986962890624937
								],
								[
									52.45458984375,
									23.052441406249955
								],
								[
									52.39960937500007,
									23.117968750000074
								],
								[
									52.344531250000045,
									23.183496093750108
								],
								[
									52.289550781250114,
									23.24897460937501
								],
								[
									52.23457031250018,
									23.31445312500003
								],
								[
									52.17949218750016,
									23.379980468749977
								],
								[
									52.12451171875,
									23.445458984374994
								],
								[
									52.069433593750034,
									23.51098632812503
								],
								[
									52.014453125000045,
									23.576464843750045
								],
								[
									51.959472656250114,
									23.64199218750008
								],
								[
									51.90439453125009,
									23.70751953125
								],
								[
									51.84941406250016,
									23.772998046875017
								],
								[
									51.794335937500136,
									23.83847656249995
								],
								[
									51.739355468750034,
									23.904003906250068
								],
								[
									51.68437499999999,
									23.969531250000102
								],
								[
									51.629296874999966,
									24.03500976562512
								],
								[
									51.59257812500016,
									24.078857421875085
								],
								[
									51.572167968749966,
									24.128320312499937
								],
								[
									51.568359375000114,
									24.257910156250034
								],
								[
									51.568359375000114,
									24.28618164062513
								],
								[
									51.605468750000114,
									24.338427734375017
								],
								[
									51.623144531250034,
									24.30107421874996
								],
								[
									51.66455078124994,
									24.25043945312504
								],
								[
									51.734765624999966,
									24.262792968749977
								],
								[
									51.767578125000114,
									24.25439453125003
								],
								[
									51.79169921875001,
									24.07475585937513
								],
								[
									51.843164062500136,
									24.010888671874994
								],
								[
									51.90605468750016,
									23.985351562499943
								],
								[
									52.11855468750002,
									23.971093749999966
								],
								[
									52.250878906250136,
									23.99521484375009
								],
								[
									52.51142578125001,
									24.112500000000097
								],
								[
									52.64824218749999,
									24.154638671875063
								],
								[
									53.026367187500114,
									24.147314453125063
								],
								[
									53.32958984375,
									24.098437500000074
								],
								[
									53.8017578125,
									24.069482421874937
								],
								[
									53.89335937499999,
									24.077050781249966
								],
								[
									54.147949218750114,
									24.17119140624996
								],
								[
									54.304296875000034,
									24.254296875000023
								],
								[
									54.397070312500034,
									24.27817382812509
								],
								[
									54.45839843750002,
									24.358251953125063
								],
								[
									54.49882812500016,
									24.462695312500017
								],
								[
									54.534667968750114,
									24.530957031249983
								],
								[
									54.58046875000002,
									24.56352539062496
								],
								[
									54.624121093750034,
									24.621289062500097
								],
								[
									54.65898437499999,
									24.715527343749926
								],
								[
									54.74677734375007,
									24.810449218749994
								],
								[
									55.09814453124994,
									25.041601562500006
								],
								[
									55.30351562500016,
									25.236816406250085
								],
								[
									55.321679687500136,
									25.299804687499943
								],
								[
									55.43339843750016,
									25.394482421874955
								],
								[
									55.522851562499966,
									25.498144531250034
								],
								[
									55.941210937500045,
									25.79399414062499
								],
								[
									56.02519531249999,
									25.916015625000085
								],
								[
									56.074609375000136,
									26.05278320312496
								],
								[
									56.080468749999966,
									26.062646484375108
								],
								[
									56.116503906250045,
									26.068164062500074
								],
								[
									56.167480468750114,
									26.047460937500034
								],
								[
									56.17255859375018,
									25.945166015625063
								],
								[
									56.15410156250016,
									25.84848632812509
								],
								[
									56.151953125000034,
									25.74609375
								],
								[
									56.14462890625009,
									25.690527343750063
								],
								[
									56.183593750000114,
									25.644921874999994
								],
								[
									56.24951171874994,
									25.625390625000023
								],
								[
									56.27851562500018,
									25.62773437499996
								],
								[
									56.297851562500114,
									25.650683593750017
								]
							],
							[
								[
									56.21054687500009,
									25.213281249999994
								],
								[
									56.240234375000114,
									25.208837890624977
								],
								[
									56.281835937500034,
									25.235546875000097
								],
								[
									56.28779296875001,
									25.278613281250074
								],
								[
									56.277343750000114,
									25.300878906250063
								],
								[
									56.234277343750136,
									25.303808593750063
								],
								[
									56.21650390625018,
									25.26669921874995
								],
								[
									56.21054687500009,
									25.213281249999994
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "ARE",
					"su_a3": "ARE",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "ARE",
					"gu_a3": "ARE",
					"abbrev": "U.A.E.",
					"region_un": "Asia",
					"adm0_a3_us": "ARE",
					"scalerank": 1,
					"pop_est": 4798491,
					"adm0_dif": 0,
					"un_a3": "784",
					"pop_year": -99,
					"gdp_md_est": 184300,
					"name": "United Arab Emirates",
					"sovereignt": "United Arab Emirates",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "United Arab Emirates",
					"postal": "AE",
					"sov_a3": "ARE",
					"note_brk": "",
					"brk_a3": "ARE",
					"wb_a2": "AE",
					"brk_diff": 0,
					"admin": "United Arab Emirates",
					"name_long": "United Arab Emirates",
					"iso_a3": "ARE",
					"iso_a2": "AE",
					"adm0_a3_is": "ARE",
					"level": 2,
					"formal_en": "United Arab Emirates",
					"name_len": 20,
					"mapcolor7": 2,
					"long_len": 20,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "784",
					"homepart": 1,
					"subunit": "United Arab Emirates",
					"name_alt": "",
					"brk_name": "United Arab Emirates",
					"name_sort": "United Arab Emirates",
					"continent": "Asia",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-64.54916992187498,
									-54.716210937500016
								],
								[
									-64.43881835937495,
									-54.73935546875002
								],
								[
									-64.22050781249999,
									-54.72197265625003
								],
								[
									-64.10532226562498,
									-54.721679687500064
								],
								[
									-64.054931640625,
									-54.729882812500044
								],
								[
									-64.03242187499995,
									-54.74238281250002
								],
								[
									-63.881933593750006,
									-54.72294921875005
								],
								[
									-63.81542968749997,
									-54.72509765625005
								],
								[
									-63.83256835937499,
									-54.76796874999999
								],
								[
									-63.97124023437502,
									-54.81064453125007
								],
								[
									-64.0283203125,
									-54.79257812500003
								],
								[
									-64.32290039062497,
									-54.79648437500003
								],
								[
									-64.45327148437497,
									-54.840332031249986
								],
								[
									-64.50869140625,
									-54.83994140625
								],
								[
									-64.637353515625,
									-54.90253906250005
								],
								[
									-64.73144531249997,
									-54.862988281250075
								],
								[
									-64.75732421875,
									-54.82656250000002
								],
								[
									-64.689208984375,
									-54.77470703125003
								],
								[
									-64.62509765624998,
									-54.773632812500075
								],
								[
									-64.58134765624996,
									-54.75273437500008
								],
								[
									-64.54916992187498,
									-54.716210937500016
								]
							]
						],
						[
							[
								[
									-68.65322265624994,
									-54.85361328125003
								],
								[
									-68.64750976562493,
									-54.62783203125004
								],
								[
									-68.63979492187497,
									-54.32402343750005
								],
								[
									-68.63823242187499,
									-54.05292968750007
								],
								[
									-68.63666992187495,
									-53.7888671875
								],
								[
									-68.63505859374999,
									-53.515429687500074
								],
								[
									-68.633447265625,
									-53.24189453125004
								],
								[
									-68.631689453125,
									-52.94951171875007
								],
								[
									-68.62993164062499,
									-52.652636718750074
								],
								[
									-68.57119140625002,
									-52.69492187500007
								],
								[
									-68.33876953125002,
									-52.90009765625004
								],
								[
									-68.27822265625002,
									-52.98398437500008
								],
								[
									-68.24013671875,
									-53.081835937500024
								],
								[
									-68.3330078125,
									-53.019628906250055
								],
								[
									-68.43115234375,
									-53.055273437500034
								],
								[
									-68.4794921875,
									-53.11376953125005
								],
								[
									-68.52080078124996,
									-53.177246093750014
								],
								[
									-68.5205078125,
									-53.22187500000005
								],
								[
									-68.48852539062497,
									-53.26093750000001
								],
								[
									-68.39311523437499,
									-53.29492187500001
								],
								[
									-68.16113281249997,
									-53.306445312500045
								],
								[
									-68.14409179687496,
									-53.31904296875003
								],
								[
									-68.00849609374995,
									-53.564062500000034
								],
								[
									-67.940283203125,
									-53.61875000000008
								],
								[
									-67.86108398437494,
									-53.66220703125005
								],
								[
									-67.67812499999997,
									-53.787109375
								],
								[
									-67.50258789062502,
									-53.921972656250034
								],
								[
									-67.29423828125002,
									-54.04980468750005
								],
								[
									-67.06948242187497,
									-54.14804687499999
								],
								[
									-66.86513671875,
									-54.22255859374999
								],
								[
									-66.67006835937497,
									-54.313574218750055
								],
								[
									-66.46201171875003,
									-54.44101562499999
								],
								[
									-66.23564453125002,
									-54.53349609375
								],
								[
									-65.99257812499997,
									-54.59892578125001
								],
								[
									-65.74707031250003,
									-54.65341796875001
								],
								[
									-65.369287109375,
									-54.632128906250024
								],
								[
									-65.25195312499997,
									-54.638085937499994
								],
								[
									-65.17900390624993,
									-54.67812499999998
								],
								[
									-65.25234374999997,
									-54.788867187500074
								],
								[
									-65.34599609374996,
									-54.87792968750001
								],
								[
									-65.47114257812495,
									-54.91464843750003
								],
								[
									-65.60332031249996,
									-54.92812500000002
								],
								[
									-65.72275390624998,
									-54.92636718750002
								],
								[
									-65.84199218750001,
									-54.90996093750005
								],
								[
									-65.95375976562497,
									-54.91933593750001
								],
								[
									-66.06064453124998,
									-54.956738281250075
								],
								[
									-66.17202148437502,
									-54.97529296875004
								],
								[
									-66.28676757812502,
									-54.977734375000004
								],
								[
									-66.398681640625,
									-55.009375000000055
								],
								[
									-66.5111328125,
									-55.03212890624998
								],
								[
									-66.62768554687503,
									-55.01328125000005
								],
								[
									-66.93046874999999,
									-54.92490234375008
								],
								[
									-67.127099609375,
									-54.90380859375004
								],
								[
									-67.79326171874999,
									-54.86865234375007
								],
								[
									-68.00712890624996,
									-54.84843750000004
								],
								[
									-68.2201171875,
									-54.81757812500006
								],
								[
									-68.331689453125,
									-54.816308593750065
								],
								[
									-68.49101562499993,
									-54.83623046875004
								],
								[
									-68.61865234375,
									-54.833789062500074
								],
								[
									-68.65322265624994,
									-54.85361328125003
								]
							]
						],
						[
							[
								[
									-61.87578124999996,
									-39.171875000000014
								],
								[
									-61.865966796875,
									-39.23486328125006
								],
								[
									-61.91801757812496,
									-39.22744140625005
								],
								[
									-62.041601562500006,
									-39.166894531250065
								],
								[
									-62.08330078124996,
									-39.11015625000006
								],
								[
									-62.093017578125,
									-39.08623046875006
								],
								[
									-61.966650390625006,
									-39.11220703125002
								],
								[
									-61.907128906249966,
									-39.13564453124992
								],
								[
									-61.87578124999996,
									-39.171875000000014
								]
							]
						],
						[
							[
								[
									-62.65097656249998,
									-22.233691406250003
								],
								[
									-62.62568359374998,
									-22.26152343749999
								],
								[
									-62.62597656250003,
									-22.290429687500023
								],
								[
									-62.54155273437496,
									-22.349609375
								],
								[
									-62.37250976562498,
									-22.439160156250026
								],
								[
									-62.21416015624999,
									-22.612402343749977
								],
								[
									-62.066601562499926,
									-22.86943359375003
								],
								[
									-61.92802734374996,
									-23.059277343749983
								],
								[
									-61.798535156249955,
									-23.182031250000023
								],
								[
									-61.67949218749993,
									-23.268750000000026
								],
								[
									-61.570996093749955,
									-23.31943359375005
								],
								[
									-61.51303710937495,
									-23.360449218749963
								],
								[
									-61.50551757812502,
									-23.391992187499994
								],
								[
									-61.40395507812494,
									-23.457519531250014
								],
								[
									-61.208398437499966,
									-23.557031250000037
								],
								[
									-61.084716796875,
									-23.65644531250004
								],
								[
									-61.032910156249926,
									-23.755664062500003
								],
								[
									-60.83984374999994,
									-23.85810546875001
								],
								[
									-60.50537109375003,
									-23.963574218749997
								],
								[
									-60.26220703124994,
									-24.01396484374996
								],
								[
									-60.11030273437501,
									-24.009179687499966
								],
								[
									-59.89248046874994,
									-24.093554687500017
								],
								[
									-59.60859375000001,
									-24.26679687500004
								],
								[
									-59.435400390625006,
									-24.387011718750017
								],
								[
									-59.372949218749966,
									-24.453906249999974
								],
								[
									-59.18725585937497,
									-24.562304687499946
								],
								[
									-58.72402343750002,
									-24.786621093749986
								],
								[
									-58.51962890624995,
									-24.84287109374999
								],
								[
									-58.422802734374926,
									-24.89414062500005
								],
								[
									-58.365380859374966,
									-24.95927734374999
								],
								[
									-58.30869140624995,
									-24.97910156249995
								],
								[
									-58.25278320312495,
									-24.953808593750026
								],
								[
									-58.13647460937494,
									-24.97714843749999
								],
								[
									-57.95981445312495,
									-25.049218750000023
								],
								[
									-57.82167968749994,
									-25.136425781250026
								],
								[
									-57.64389648437498,
									-25.32841796874996
								],
								[
									-57.58715820312494,
									-25.405078125000045
								],
								[
									-57.56313476562494,
									-25.47373046874999
								],
								[
									-57.571679687499994,
									-25.534179687499957
								],
								[
									-57.62583007812492,
									-25.598730468749963
								],
								[
									-57.725488281249994,
									-25.66718749999997
								],
								[
									-57.754785156249994,
									-25.697070312500017
								],
								[
									-57.75708007812503,
									-25.72597656250005
								],
								[
									-57.78247070312494,
									-25.783691406249986
								],
								[
									-57.86523437500003,
									-25.90693359374997
								],
								[
									-57.88623046874994,
									-25.964257812499923
								],
								[
									-57.89062499999997,
									-26.00654296875001
								],
								[
									-57.943115234375,
									-26.05292968750004
								],
								[
									-58.082421874999966,
									-26.138574218749994
								],
								[
									-58.11113281249993,
									-26.18017578125003
								],
								[
									-58.11806640625002,
									-26.22490234374999
								],
								[
									-58.135644531249966,
									-26.251464843749986
								],
								[
									-58.15468750000002,
									-26.26259765624995
								],
								[
									-58.18149414062498,
									-26.307421875000017
								],
								[
									-58.20302734375002,
									-26.381445312500006
								],
								[
									-58.205175781250006,
									-26.476562500000014
								],
								[
									-58.187939453124955,
									-26.59257812500003
								],
								[
									-58.19130859375002,
									-26.629980468750006
								],
								[
									-58.222070312499994,
									-26.650000000000006
								],
								[
									-58.23935546874995,
									-26.676855468749963
								],
								[
									-58.24555664062498,
									-26.73105468749999
								],
								[
									-58.271679687499955,
									-26.770703124999983
								],
								[
									-58.31767578125002,
									-26.79589843749997
								],
								[
									-58.33466796875001,
									-26.82490234375001
								],
								[
									-58.32255859374993,
									-26.857617187500026
								],
								[
									-58.3564453125,
									-26.890039062499966
								],
								[
									-58.43632812499993,
									-26.92197265624999
								],
								[
									-58.485253906249966,
									-26.96845703125004
								],
								[
									-58.50322265624999,
									-27.02949218750004
								],
								[
									-58.54770507812498,
									-27.083984374999957
								],
								[
									-58.618603515624955,
									-27.13212890624999
								],
								[
									-58.641748046874966,
									-27.19609374999996
								],
								[
									-58.60483398437498,
									-27.314355468749994
								],
								[
									-58.16826171874996,
									-27.2734375
								],
								[
									-57.81220703124998,
									-27.316601562499997
								],
								[
									-57.39125976562502,
									-27.430468750000017
								],
								[
									-57.11181640625003,
									-27.47011718750001
								],
								[
									-56.973974609375006,
									-27.435742187500026
								],
								[
									-56.871728515624966,
									-27.44062500000004
								],
								[
									-56.80517578124997,
									-27.48466796874996
								],
								[
									-56.715722656249966,
									-27.49374999999995
								],
								[
									-56.603369140625006,
									-27.467871093750006
								],
								[
									-56.51054687499999,
									-27.48789062499999
								],
								[
									-56.437158203124966,
									-27.553808593750006
								],
								[
									-56.370507812499994,
									-27.53740234374996
								],
								[
									-56.31054687500003,
									-27.438769531250017
								],
								[
									-56.24169921875003,
									-27.36679687500002
								],
								[
									-56.16406250000003,
									-27.321484375000026
								],
								[
									-56.067333984374955,
									-27.307714843749963
								],
								[
									-55.95146484374996,
									-27.325683593749986
								],
								[
									-55.859033203124966,
									-27.36191406249999
								],
								[
									-55.789990234374926,
									-27.416406249999994
								],
								[
									-55.71464843749996,
									-27.41484375000003
								],
								[
									-55.632910156250006,
									-27.357128906249997
								],
								[
									-55.59379882812502,
									-27.28808593749997
								],
								[
									-55.59726562499992,
									-27.20761718749992
								],
								[
									-55.56489257812498,
									-27.14999999999999
								],
								[
									-55.496728515624966,
									-27.11533203124995
								],
								[
									-55.45063476562498,
									-27.06835937499997
								],
								[
									-55.426660156249994,
									-27.009277343750014
								],
								[
									-55.34580078124995,
									-26.973144531250014
								],
								[
									-55.20800781250003,
									-26.960156249999955
								],
								[
									-55.13593750000001,
									-26.931152343749986
								],
								[
									-55.12963867187497,
									-26.88603515625003
								],
								[
									-55.0888671875,
									-26.844531250000017
								],
								[
									-55.013623046874955,
									-26.806640624999943
								],
								[
									-54.96215820312494,
									-26.75937499999999
								],
								[
									-54.934472656249994,
									-26.70253906250005
								],
								[
									-54.88891601562494,
									-26.66679687499996
								],
								[
									-54.82548828124999,
									-26.65224609375001
								],
								[
									-54.755078124999955,
									-26.532910156249955
								],
								[
									-54.677734375,
									-26.308789062500026
								],
								[
									-54.631933593750006,
									-26.005761718750023
								],
								[
									-54.61586914062502,
									-25.576074218750065
								],
								[
									-54.537841796875,
									-25.576464843750045
								],
								[
									-54.50151367187499,
									-25.60830078125005
								],
								[
									-54.44394531249998,
									-25.624999999999986
								],
								[
									-54.38334960937499,
									-25.588671875000045
								],
								[
									-54.33188476562498,
									-25.57187499999992
								],
								[
									-54.250097656250006,
									-25.570410156249977
								],
								[
									-54.206152343750034,
									-25.529589843750003
								],
								[
									-54.15458984375002,
									-25.52304687499992
								],
								[
									-54.119238281250006,
									-25.54521484374999
								],
								[
									-54.08500976562496,
									-25.57187499999992
								],
								[
									-54.01230468749998,
									-25.57792968749999
								],
								[
									-53.95478515624998,
									-25.647656250000082
								],
								[
									-53.89116210937499,
									-25.668847656250037
								],
								[
									-53.86420898437501,
									-25.74882812499999
								],
								[
									-53.8232421875,
									-25.959570312500034
								],
								[
									-53.746923828125006,
									-26.083691406249997
								],
								[
									-53.671289062499966,
									-26.22509765625003
								],
								[
									-53.668554687500006,
									-26.288183593750006
								],
								[
									-53.71093750000003,
									-26.351855468750017
								],
								[
									-53.718164062499994,
									-26.443164062500045
								],
								[
									-53.744580078124955,
									-26.666503906249986
								],
								[
									-53.753320312499966,
									-26.74863281250002
								],
								[
									-53.72714843749998,
									-26.80468750000007
								],
								[
									-53.71728515625,
									-26.8828125
								],
								[
									-53.758496093749955,
									-26.978320312500003
								],
								[
									-53.83818359375002,
									-27.121093750000057
								],
								[
									-53.915625000000006,
									-27.15957031250008
								],
								[
									-53.93535156250002,
									-27.161132812500043
								],
								[
									-54.04013671874995,
									-27.24374999999999
								],
								[
									-54.11381835937496,
									-27.27470703124999
								],
								[
									-54.156445312499926,
									-27.253808593749994
								],
								[
									-54.20522460937502,
									-27.289648437499935
								],
								[
									-54.26015625000002,
									-27.382031249999926
								],
								[
									-54.32700195312495,
									-27.423535156250026
								],
								[
									-54.44814453124994,
									-27.446484375000082
								],
								[
									-54.484326171874955,
									-27.45732421874999
								],
								[
									-54.55493164062503,
									-27.454101562500043
								],
								[
									-54.61542968750001,
									-27.47714843750002
								],
								[
									-54.66586914062498,
									-27.526562500000054
								],
								[
									-54.71972656250003,
									-27.54492187500007
								],
								[
									-54.777099609375,
									-27.53251953125003
								],
								[
									-54.82910156250003,
									-27.55058593750006
								],
								[
									-54.87573242187503,
									-27.59921875000002
								],
								[
									-54.90278320312501,
									-27.65195312500002
								],
								[
									-54.91020507812502,
									-27.70859375000002
								],
								[
									-54.955908203125006,
									-27.747167968750063
								],
								[
									-55.039941406249994,
									-27.767773437499997
								],
								[
									-55.068994140624966,
									-27.796289062500023
								],
								[
									-55.063867187499966,
									-27.83593750000003
								],
								[
									-55.10151367187501,
									-27.86679687499992
								],
								[
									-55.243750000000034,
									-27.89882812500005
								],
								[
									-55.34648437499999,
									-27.955957031249966
								],
								[
									-55.40981445312502,
									-28.03779296874994
								],
								[
									-55.47666015624995,
									-28.089355468750043
								],
								[
									-55.582373046875006,
									-28.12099609375001
								],
								[
									-55.72548828125002,
									-28.20410156250007
								],
								[
									-55.74599609375002,
									-28.25546875000005
								],
								[
									-55.691503906250034,
									-28.302832031249935
								],
								[
									-55.67197265624995,
									-28.344921874999983
								],
								[
									-55.68725585937497,
									-28.381640625000003
								],
								[
									-55.73198242187502,
									-28.38662109374995
								],
								[
									-55.80605468750002,
									-28.359765625000065
								],
								[
									-55.85888671875003,
									-28.354199218749997
								],
								[
									-55.890527343749994,
									-28.370019531250023
								],
								[
									-55.905419921874994,
									-28.39960937500001
								],
								[
									-55.903662109375006,
									-28.443261718750023
								],
								[
									-55.93017578124997,
									-28.47285156250001
								],
								[
									-55.98491210937493,
									-28.488574218750017
								],
								[
									-56.019628906250006,
									-28.524609374999997
								],
								[
									-56.03422851562496,
									-28.58085937499999
								],
								[
									-56.102880859375006,
									-28.651757812499966
								],
								[
									-56.225537109374926,
									-28.737207031249966
								],
								[
									-56.322363281250034,
									-28.852441406249994
								],
								[
									-56.39326171875001,
									-28.99726562500001
								],
								[
									-56.475976562499966,
									-29.09248046875004
								],
								[
									-56.570703124999994,
									-29.138085937499923
								],
								[
									-56.635839843750034,
									-29.20302734375001
								],
								[
									-56.67153320312502,
									-29.287304687500026
								],
								[
									-56.77246093749997,
									-29.41787109375008
								],
								[
									-56.938623046874994,
									-29.594824218750063
								],
								[
									-57.08935546874997,
									-29.71621093750001
								],
								[
									-57.22465820312499,
									-29.782128906250037
								],
								[
									-57.30068359374994,
									-29.85654296874992
								],
								[
									-57.317480468750006,
									-29.939453125000014
								],
								[
									-57.40522460937501,
									-30.033886718750068
								],
								[
									-57.563867187499994,
									-30.139941406250003
								],
								[
									-57.60888671875003,
									-30.187792968750074
								],
								[
									-57.645751953125,
									-30.226953124999966
								],
								[
									-57.65087890624997,
									-30.295019531249977
								],
								[
									-57.71269531249996,
									-30.384472656249997
								],
								[
									-57.83120117187502,
									-30.495214843750006
								],
								[
									-57.87250976562501,
									-30.591015624999983
								],
								[
									-57.818554687499926,
									-30.71201171875002
								],
								[
									-57.81059570312499,
									-30.85859375000004
								],
								[
									-57.83408203124998,
									-30.917480468749957
								],
								[
									-57.88632812499998,
									-30.937402343750023
								],
								[
									-57.89829101562492,
									-30.97519531249999
								],
								[
									-57.870068359374955,
									-31.031054687500003
								],
								[
									-57.86840820312497,
									-31.104394531250023
								],
								[
									-57.89335937499999,
									-31.195312499999986
								],
								[
									-57.948339843750006,
									-31.299414062499963
								],
								[
									-58.03339843750001,
									-31.416601562500034
								],
								[
									-58.053857421874994,
									-31.494921875000003
								],
								[
									-58.009667968749966,
									-31.53437499999997
								],
								[
									-57.98798828124998,
									-31.576171874999957
								],
								[
									-57.988867187500006,
									-31.62060546875003
								],
								[
									-58.006982421874966,
									-31.684960937499994
								],
								[
									-58.04233398437495,
									-31.769238281250026
								],
								[
									-58.09584960937494,
									-31.83183593749999
								],
								[
									-58.16748046874997,
									-31.872656249999963
								],
								[
									-58.18901367187499,
									-31.92421874999998
								],
								[
									-58.16040039062494,
									-31.98652343749997
								],
								[
									-58.156347656250006,
									-32.05156249999999
								],
								[
									-58.17700195312494,
									-32.119042968749966
								],
								[
									-58.16479492187494,
									-32.184863281249974
								],
								[
									-58.119726562500006,
									-32.248925781249966
								],
								[
									-58.12304687499997,
									-32.32187499999999
								],
								[
									-58.201171875,
									-32.47167968749996
								],
								[
									-58.219970703125,
									-32.563964843750014
								],
								[
									-58.17099609374998,
									-32.95927734375
								],
								[
									-58.200781250000006,
									-33.014648437499915
								],
								[
									-58.250390624999994,
									-33.0783203125
								],
								[
									-58.30888671874999,
									-33.082910156249966
								],
								[
									-58.3759765625,
									-33.07187500000002
								],
								[
									-58.424462890624994,
									-33.11152343750001
								],
								[
									-58.45483398437497,
									-33.28593750000002
								],
								[
									-58.54721679687498,
									-33.66347656249994
								],
								[
									-58.53056640624996,
									-33.75302734375006
								],
								[
									-58.45659179687499,
									-33.898339843749994
								],
								[
									-58.42949218749996,
									-33.990917968750026
								],
								[
									-58.40903320312498,
									-34.06074218750004
								],
								[
									-58.392480468749966,
									-34.19296875000006
								],
								[
									-58.435498046874955,
									-34.252539062500034
								],
								[
									-58.475244140624966,
									-34.26298828125003
								],
								[
									-58.52548828124998,
									-34.296191406250045
								],
								[
									-58.466210937499994,
									-34.45742187500004
								],
								[
									-58.41894531249994,
									-34.53164062500005
								],
								[
									-58.28334960937494,
									-34.68349609375008
								],
								[
									-57.76357421875002,
									-34.894531249999915
								],
								[
									-57.54785156250003,
									-35.01894531250004
								],
								[
									-57.303662109374926,
									-35.188476562500014
								],
								[
									-57.170654296875,
									-35.36250000000004
								],
								[
									-57.15888671875001,
									-35.505957031250034
								],
								[
									-57.353906249999966,
									-35.720312500000006
								],
								[
									-57.37548828125,
									-35.900292968749994
								],
								[
									-57.33544921875,
									-36.02675781250001
								],
								[
									-57.26499023437495,
									-36.14414062500002
								],
								[
									-57.07617187499994,
									-36.29677734374995
								],
								[
									-56.937158203124966,
									-36.35253906249994
								],
								[
									-56.74946289062501,
									-36.34648437500003
								],
								[
									-56.717382812500034,
									-36.38906249999992
								],
								[
									-56.698095703125006,
									-36.42646484375008
								],
								[
									-56.66826171874999,
									-36.73525390625001
								],
								[
									-56.67202148437494,
									-36.85126953124994
								],
								[
									-56.72714843749998,
									-36.957714843749955
								],
								[
									-57.08769531249999,
									-37.446386718750034
								],
								[
									-57.39575195312494,
									-37.74462890625004
								],
								[
									-57.507275390624926,
									-37.909277343750006
								],
								[
									-57.546972656250034,
									-38.085644531250054
								],
								[
									-57.64560546874995,
									-38.16962890624994
								],
								[
									-58.17919921874994,
									-38.435839843750074
								],
								[
									-59.007226562499994,
									-38.67333984375006
								],
								[
									-59.67626953124994,
									-38.796679687500045
								],
								[
									-59.82832031250001,
									-38.838183593750074
								],
								[
									-60.90395507812494,
									-38.97392578125002
								],
								[
									-61.11220703125002,
									-38.99296874999999
								],
								[
									-61.38286132812499,
									-38.98085937500001
								],
								[
									-61.60253906249997,
									-38.99882812500002
								],
								[
									-61.84790039062497,
									-38.96181640625004
								],
								[
									-62.06689453125,
									-38.91914062500004
								],
								[
									-62.18925781249996,
									-38.813281249999974
								],
								[
									-62.33476562499993,
									-38.80009765625003
								],
								[
									-62.374462890624955,
									-38.85292968750005
								],
								[
									-62.303613281249994,
									-38.98808593750006
								],
								[
									-62.33808593750001,
									-39.150585937500026
								],
								[
									-62.29506835937502,
									-39.24326171874999
								],
								[
									-62.209082031250006,
									-39.26181640625005
								],
								[
									-62.12646484374997,
									-39.30976562500004
								],
								[
									-62.053662109374955,
									-39.37382812500003
								],
								[
									-62.179345703124994,
									-39.38046875000006
								],
								[
									-62.13056640625001,
									-39.43154296874998
								],
								[
									-62.076806640624966,
									-39.46152343750005
								],
								[
									-62.08276367187503,
									-39.56835937499997
								],
								[
									-62.131542968749926,
									-39.82539062500001
								],
								[
									-62.25395507812499,
									-39.88046874999996
								],
								[
									-62.28691406249996,
									-39.895312500000045
								],
								[
									-62.32397460937497,
									-39.95068359375006
								],
								[
									-62.40185546875003,
									-40.19658203125006
								],
								[
									-62.427001953125,
									-40.355957031250014
								],
								[
									-62.39360351562493,
									-40.4587890625
								],
								[
									-62.24633789062497,
									-40.674609375
								],
								[
									-62.30185546874998,
									-40.814648437500026
								],
								[
									-62.39501953124997,
									-40.8908203125
								],
								[
									-62.797998046874994,
									-41.047167968749974
								],
								[
									-62.95903320312493,
									-41.10966796875009
								],
								[
									-63.212841796874955,
									-41.152441406250006
								],
								[
									-63.621777343749955,
									-41.15976562499999
								],
								[
									-63.77299804687493,
									-41.14999999999996
								],
								[
									-64.12319335937497,
									-41.00781250000003
								],
								[
									-64.38344726562497,
									-40.92246093750005
								],
								[
									-64.62148437499997,
									-40.85449218750006
								],
								[
									-64.85297851562495,
									-40.81376953125003
								],
								[
									-64.81987304687496,
									-40.79326171875002
								],
								[
									-64.80439453125001,
									-40.75654296875
								],
								[
									-64.86948242187503,
									-40.73583984375004
								],
								[
									-64.91689453125002,
									-40.73134765624994
								],
								[
									-65.06943359375,
									-40.80527343750008
								],
								[
									-65.13339843749998,
									-40.88066406250006
								],
								[
									-65.15185546875,
									-40.94697265625007
								],
								[
									-65.15498046874993,
									-41.10566406250007
								],
								[
									-65.12788085937501,
									-41.23876953124993
								],
								[
									-65.01826171874998,
									-41.566894531249986
								],
								[
									-65.00703124999998,
									-41.74511718750006
								],
								[
									-65.05908203125003,
									-41.969921875000026
								],
								[
									-64.98637695312496,
									-42.10205078124994
								],
								[
									-64.898046875,
									-42.16181640625004
								],
								[
									-64.69951171874996,
									-42.22080078124998
								],
								[
									-64.6224609375,
									-42.26103515625
								],
								[
									-64.53774414062497,
									-42.25458984375001
								],
								[
									-64.51171874999997,
									-42.27021484375
								],
								[
									-64.52421874999996,
									-42.299218749999966
								],
								[
									-64.57412109375,
									-42.35595703125006
								],
								[
									-64.57099609374998,
									-42.41601562499996
								],
								[
									-64.42041015625003,
									-42.433789062500026
								],
								[
									-64.26459960937498,
									-42.421679687500045
								],
								[
									-64.10087890624996,
									-42.39511718749996
								],
								[
									-64.06220703124998,
									-42.353417968749994
								],
								[
									-64.06118164062494,
									-42.26611328124997
								],
								[
									-64.25292968750003,
									-42.250781250000045
								],
								[
									-64.22851562500003,
									-42.218261718749986
								],
								[
									-64.083251953125,
									-42.182812500000054
								],
								[
									-63.89287109374993,
									-42.12460937499992
								],
								[
									-63.795556640624994,
									-42.113867187500034
								],
								[
									-63.72949218749997,
									-42.152929687500006
								],
								[
									-63.68476562499998,
									-42.188671875
								],
								[
									-63.6298828125,
									-42.28271484375006
								],
								[
									-63.59589843750001,
									-42.40654296875006
								],
								[
									-63.59443359374998,
									-42.555566406249966
								],
								[
									-63.61733398437502,
									-42.695800781250014
								],
								[
									-63.644482421874955,
									-42.74570312499998
								],
								[
									-63.69248046874998,
									-42.805273437500034
								],
								[
									-64.03476562499998,
									-42.88125000000005
								],
								[
									-64.13066406249999,
									-42.861425781250006
								],
								[
									-64.21992187499995,
									-42.755566406250026
								],
								[
									-64.24794921874997,
									-42.646093749999935
								],
								[
									-64.32426757812499,
									-42.572265624999986
								],
								[
									-64.48784179687499,
									-42.51347656250009
								],
								[
									-64.65048828125,
									-42.531445312500026
								],
								[
									-64.81196289062495,
									-42.63320312500005
								],
								[
									-64.97070312499997,
									-42.666308593750045
								],
								[
									-65.02690429687496,
									-42.75888671874999
								],
								[
									-64.62919921875002,
									-42.90898437500002
								],
								[
									-64.441552734375,
									-42.950683593749986
								],
								[
									-64.38037109374994,
									-42.94921875000004
								],
								[
									-64.31914062500002,
									-42.96894531249998
								],
								[
									-64.37568359374998,
									-43.024609374999955
								],
								[
									-64.43222656250003,
									-43.05917968750006
								],
								[
									-64.71523437499997,
									-43.135546875000074
								],
								[
									-64.83994140624998,
									-43.18886718750002
								],
								[
									-64.98554687499995,
									-43.293554687500034
								],
								[
									-65.18974609374999,
									-43.52207031250005
								],
								[
									-65.25234374999997,
									-43.57187500000006
								],
								[
									-65.28359375000002,
									-43.629980468750006
								],
								[
									-65.30468749999997,
									-43.78750000000002
								],
								[
									-65.23857421874999,
									-44.04873046875005
								],
								[
									-65.30839843750002,
									-44.15820312499997
								],
								[
									-65.26552734375,
									-44.27968750000002
								],
								[
									-65.28984374999996,
									-44.36074218750002
								],
								[
									-65.36127929687495,
									-44.477343749999974
								],
								[
									-65.64760742187502,
									-44.661425781250074
								],
								[
									-65.69833984374998,
									-44.79619140625009
								],
								[
									-65.59912109375,
									-44.875585937500006
								],
								[
									-65.605712890625,
									-44.94501953125004
								],
								[
									-65.63876953125,
									-45.00781250000004
								],
								[
									-65.75771484375,
									-45.007128906250074
								],
								[
									-66.19013671874998,
									-44.96474609375005
								],
								[
									-66.34775390625,
									-45.033593749999966
								],
								[
									-66.49360351562498,
									-45.11757812500002
								],
								[
									-66.533447265625,
									-45.15781250000005
								],
								[
									-66.58505859374995,
									-45.18291015625
								],
								[
									-66.88247070312497,
									-45.22763671875006
								],
								[
									-66.94140625,
									-45.25732421875007
								],
								[
									-67.25761718750002,
									-45.57724609375005
								],
								[
									-67.39301757812498,
									-45.77558593750004
								],
								[
									-67.556640625,
									-45.97011718749998
								],
								[
									-67.59956054687495,
									-46.052539062500074
								],
								[
									-67.60888671875,
									-46.166796875000074
								],
								[
									-67.58608398437497,
									-46.26953125000004
								],
								[
									-67.56337890624997,
									-46.345410156250054
								],
								[
									-67.5064453125,
									-46.442773437499994
								],
								[
									-67.38662109375002,
									-46.55380859375005
								],
								[
									-66.77685546874994,
									-47.00585937499996
								],
								[
									-66.65039062500003,
									-47.045312499999994
								],
								[
									-65.99853515625003,
									-47.09375
								],
								[
									-65.853662109375,
									-47.15673828125004
								],
								[
									-65.76909179687499,
									-47.25673828124991
								],
								[
									-65.73808593749999,
									-47.34492187500001
								],
								[
									-65.77539062500003,
									-47.56835937500006
								],
								[
									-65.81430664062498,
									-47.638183593749986
								],
								[
									-65.88632812499998,
									-47.70156249999994
								],
								[
									-66.04062499999998,
									-47.78330078125006
								],
								[
									-66.22524414062502,
									-47.826757812500034
								],
								[
									-66.17236328125,
									-47.85761718750001
								],
								[
									-66.09736328124998,
									-47.853222656249926
								],
								[
									-65.93422851562497,
									-47.826757812500034
								],
								[
									-65.863671875,
									-47.853222656249926
								],
								[
									-65.81005859375,
									-47.94111328125007
								],
								[
									-65.91215820312502,
									-47.97675781250004
								],
								[
									-65.94340820312499,
									-48.01933593750002
								],
								[
									-66.0171875,
									-48.08427734375
								],
								[
									-66.39335937499999,
									-48.342382812500006
								],
								[
									-66.59628906250003,
									-48.419531250000006
								],
								[
									-66.7828125,
									-48.52294921874994
								],
								[
									-67.03310546875002,
									-48.62773437500006
								],
								[
									-67.13095703124998,
									-48.68789062500006
								],
								[
									-67.26333007812502,
									-48.814257812500045
								],
								[
									-67.46630859375,
									-48.95175781250008
								],
								[
									-67.68486328125002,
									-49.246679687500034
								],
								[
									-67.69370117187495,
									-49.304003906250074
								],
								[
									-67.66196289062498,
									-49.34218750000004
								],
								[
									-67.78349609374996,
									-49.85888671875006
								],
								[
									-67.82597656249999,
									-49.91962890625008
								],
								[
									-67.91396484374997,
									-49.98447265625006
								],
								[
									-68.14565429687502,
									-50.09140625
								],
								[
									-68.2572265625,
									-50.10458984375002
								],
								[
									-68.404638671875,
									-50.04267578125002
								],
								[
									-68.487890625,
									-49.97792968750006
								],
								[
									-68.56928710937498,
									-49.86699218750002
								],
								[
									-68.66757812500003,
									-49.75253906250006
								],
								[
									-68.67265624999999,
									-49.79345703125005
								],
								[
									-68.63847656249996,
									-49.862988281250004
								],
								[
									-68.66162109374997,
									-49.93574218750008
								],
								[
									-68.91298828125002,
									-49.96875000000006
								],
								[
									-68.97958984375,
									-50.00302734375002
								],
								[
									-68.75268554687497,
									-49.98769531250001
								],
								[
									-68.59794921874996,
									-50.009472656250004
								],
								[
									-68.53256835937498,
									-50.036132812500014
								],
								[
									-68.47373046874998,
									-50.09140625
								],
								[
									-68.42187499999997,
									-50.15791015625005
								],
								[
									-68.46542968749998,
									-50.194726562499994
								],
								[
									-68.58935546875,
									-50.22519531250008
								],
								[
									-68.749853515625,
									-50.281152343750016
								],
								[
									-68.939453125,
									-50.38232421875002
								],
								[
									-69.04477539062495,
									-50.49912109375001
								],
								[
									-69.09018554687498,
									-50.58310546875007
								],
								[
									-69.14140625000002,
									-50.75253906250004
								],
								[
									-69.15498046874993,
									-50.86445312500001
								],
								[
									-69.23515625000002,
									-50.950585937500065
								],
								[
									-69.35859374999995,
									-51.02812500000005
								],
								[
									-69.35175781249998,
									-51.04580078125001
								],
								[
									-69.26796874999997,
									-51.00615234375002
								],
								[
									-69.201025390625,
									-50.99365234375004
								],
								[
									-69.14350585937501,
									-51.096972656250045
								],
								[
									-69.06572265624996,
									-51.303515625000024
								],
								[
									-69.02958984374996,
									-51.44648437500002
								],
								[
									-69.035302734375,
									-51.488964843750054
								],
								[
									-69.05830078124995,
									-51.54716796875001
								],
								[
									-69.21806640624999,
									-51.56123046875003
								],
								[
									-69.36054687499998,
									-51.55947265625003
								],
								[
									-69.46542968750003,
									-51.584472656250064
								],
								[
									-69.40908203125002,
									-51.61025390624999
								],
								[
									-69.31303710937499,
									-51.60107421875007
								],
								[
									-69.18012695312501,
									-51.66230468750002
								],
								[
									-69.03251953124996,
									-51.636230468750036
								],
								[
									-68.96533203125003,
									-51.67714843750002
								],
								[
									-68.91679687499999,
									-51.714648437500024
								],
								[
									-68.69082031249997,
									-52.01308593749999
								],
								[
									-68.493505859375,
									-52.19755859375009
								],
								[
									-68.39374999999993,
									-52.30703125000001
								],
								[
									-68.443359375,
									-52.356640625000075
								],
								[
									-68.46098632812496,
									-52.2904296875
								],
								[
									-68.58979492187498,
									-52.27333984374998
								],
								[
									-68.71518554687495,
									-52.25546875000007
								],
								[
									-68.92456054687497,
									-52.20810546875001
								],
								[
									-69.206201171875,
									-52.13613281250001
								],
								[
									-69.48842773437502,
									-52.13613281250001
								],
								[
									-69.71259765624995,
									-52.07539062500007
								],
								[
									-69.96025390624996,
									-52.00820312500006
								],
								[
									-70.48286132812501,
									-52.00224609375009
								],
								[
									-70.94316406249999,
									-51.99814453125005
								],
								[
									-71.41474609374998,
									-51.99394531250008
								],
								[
									-71.71660156250002,
									-51.99130859375008
								],
								[
									-71.91865234374995,
									-51.989550781250074
								],
								[
									-71.97109375,
									-51.96416015625005
								],
								[
									-71.95346679687503,
									-51.880371093750036
								],
								[
									-72.02841796875003,
									-51.818652343750074
								],
								[
									-72.13696289062503,
									-51.744042968750065
								],
								[
									-72.26899414062501,
									-51.691113281250026
								],
								[
									-72.33452148437496,
									-51.62031250000008
								],
								[
									-72.40766601562501,
									-51.54082031250005
								],
								[
									-72.36640624999995,
									-51.47031250000008
								],
								[
									-72.30322265624997,
									-51.29892578125006
								],
								[
									-72.30185546874995,
									-51.22333984375003
								],
								[
									-72.35917968749999,
									-51.17041015624999
								],
								[
									-72.37680664062503,
									-51.09541015625008
								],
								[
									-72.35917968749999,
									-51.060156250000006
								],
								[
									-72.307373046875,
									-51.03339843750006
								],
								[
									-72.27631835937498,
									-50.91025390625002
								],
								[
									-72.30063476562498,
									-50.78955078125003
								],
								[
									-72.34023437499997,
									-50.681835937500026
								],
								[
									-72.39257812499997,
									-50.634277343750014
								],
								[
									-72.46015624999995,
									-50.61171875000004
								],
								[
									-72.50981445312496,
									-50.60751953125007
								],
								[
									-72.62041015625002,
									-50.647656250000075
								],
								[
									-72.80361328124994,
									-50.6376953125
								],
								[
									-72.86591796874993,
									-50.65312500000004
								],
								[
									-72.95556640625,
									-50.696484375000075
								],
								[
									-73.08237304687498,
									-50.760351562500034
								],
								[
									-73.15292968749998,
									-50.738281250000064
								],
								[
									-73.17451171875001,
									-50.67001953125001
								],
								[
									-73.22163085937493,
									-50.610742187500016
								],
								[
									-73.251611328125,
									-50.55849609375003
								],
								[
									-73.27416992187497,
									-50.47255859375002
								],
								[
									-73.31171874999998,
									-50.36191406250004
								],
								[
									-73.38662109374997,
									-50.23115234375005
								],
								[
									-73.50126953124996,
									-50.12529296875006
								],
								[
									-73.50771484374994,
									-50.030273437500064
								],
								[
									-73.52890625,
									-49.91093750000009
								],
								[
									-73.47041015624998,
									-49.79453125
								],
								[
									-73.50454101562502,
									-49.69804687500006
								],
								[
									-73.57626953124998,
									-49.58291015625005
								],
								[
									-73.55419921875,
									-49.46386718750005
								],
								[
									-73.48364257812503,
									-49.39765625000006
								],
								[
									-73.46157226562497,
									-49.313867187500044
								],
								[
									-73.13525390625,
									-49.30068359375002
								],
								[
									-73.14887695312495,
									-49.187988281250064
								],
								[
									-73.09458007812498,
									-49.09687500000007
								],
								[
									-73.03364257812501,
									-49.01435546875004
								],
								[
									-72.98173828124999,
									-48.97675781250002
								],
								[
									-72.86542968750001,
									-48.9439453125
								],
								[
									-72.72846679687501,
									-48.89628906250006
								],
								[
									-72.65126953125,
									-48.84160156250002
								],
								[
									-72.61440429687494,
									-48.79287109375004
								],
								[
									-72.59174804687495,
									-48.72968750000005
								],
								[
									-72.5859375,
									-48.66250000000004
								],
								[
									-72.60839843749997,
									-48.51933593750009
								],
								[
									-72.582861328125,
									-48.47539062500002
								],
								[
									-72.49814453124998,
									-48.41738281250001
								],
								[
									-72.35473632812497,
									-48.36582031250008
								],
								[
									-72.29301757812502,
									-48.22910156250002
								],
								[
									-72.32832031250001,
									-48.110058593750026
								],
								[
									-72.40791015624998,
									-48.01591796875003
								],
								[
									-72.50908203124999,
									-47.973339843750054
								],
								[
									-72.517919921875,
									-47.87636718750002
								],
								[
									-72.47221679687502,
									-47.78417968750007
								],
								[
									-72.41259765624994,
									-47.68554687500004
								],
								[
									-72.34150390624995,
									-47.57207031250002
								],
								[
									-72.34594726562497,
									-47.492675781250014
								],
								[
									-72.28291015625001,
									-47.44628906250006
								],
								[
									-72.10341796875002,
									-47.34277343750003
								],
								[
									-72.04169921874998,
									-47.24140624999998
								],
								[
									-71.97851562499997,
									-47.21386718750006
								],
								[
									-71.90498046875001,
									-47.20166015625006
								],
								[
									-71.900537109375,
									-47.1443359375
								],
								[
									-71.95424804687502,
									-47.08750000000006
								],
								[
									-71.96298828125,
									-47.016015625000065
								],
								[
									-71.95664062499998,
									-46.93681640625
								],
								[
									-71.94023437499999,
									-46.83125000000008
								],
								[
									-71.85644531249997,
									-46.791601562500006
								],
								[
									-71.73271484374999,
									-46.705859374999946
								],
								[
									-71.69965820312501,
									-46.65136718750003
								],
								[
									-71.69521484375,
									-46.57841796875009
								],
								[
									-71.73129882812498,
									-46.42783203125005
								],
								[
									-71.76210937499994,
									-46.319824218749986
								],
								[
									-71.77763671875002,
									-46.27998046875004
								],
								[
									-71.83413085937497,
									-46.20673828125004
								],
								[
									-71.87568359374998,
									-46.16054687500005
								],
								[
									-71.80927734374995,
									-46.102734375
								],
								[
									-71.68447265624994,
									-46.04189453125004
								],
								[
									-71.63154296874998,
									-45.953710937500006
								],
								[
									-71.68007812500002,
									-45.8787109375
								],
								[
									-71.75063476562502,
									-45.839062499999926
								],
								[
									-71.77265624999995,
									-45.72441406250002
								],
								[
									-71.74619140625,
									-45.57890625000003
								],
								[
									-71.69331054687495,
									-45.534765625000006
								],
								[
									-71.50810546874999,
									-45.51269531250004
								],
								[
									-71.49042968749993,
									-45.43769531250004
								],
								[
									-71.34931640624995,
									-45.331933593749994
								],
								[
									-71.35375976562497,
									-45.23046874999993
								],
								[
									-71.44345703124995,
									-45.168261718750045
								],
								[
									-71.53129882812499,
									-45.067871093750014
								],
								[
									-71.5962890625,
									-44.97919921875007
								],
								[
									-71.81235351562498,
									-44.93066406249996
								],
								[
									-72.04169921874998,
									-44.904199218750065
								],
								[
									-72.07250976562494,
									-44.82041015625005
								],
								[
									-72.06372070312503,
									-44.77187499999994
								],
								[
									-71.95703124999997,
									-44.79150390625003
								],
								[
									-71.7828125,
									-44.7744140625
								],
								[
									-71.65166015625002,
									-44.770410156249994
								],
								[
									-71.56040039062498,
									-44.76201171875006
								],
								[
									-71.45517578125003,
									-44.74980468750006
								],
								[
									-71.358154296875,
									-44.78515625000006
								],
								[
									-71.26113281250002,
									-44.76308593749992
								],
								[
									-71.22148437499993,
									-44.630761718749966
								],
								[
									-71.15971679687496,
									-44.56025390625007
								],
								[
									-71.15087890624994,
									-44.494042968749994
								],
								[
									-71.21259765625001,
									-44.441210937500074
								],
								[
									-71.32573242187496,
									-44.42490234374995
								],
								[
									-71.82001953124993,
									-44.38310546874996
								],
								[
									-71.83505859374998,
									-44.330175781250006
								],
								[
									-71.83076171874998,
									-44.24140625000004
								],
								[
									-71.812109375,
									-44.15078125000005
								],
								[
									-71.81235351562498,
									-44.106054687500006
								],
								[
									-71.7671875,
									-44.06669921875006
								],
								[
									-71.716162109375,
									-43.984472656250006
								],
								[
									-71.68007812500002,
									-43.92958984374994
								],
								[
									-71.71596679687497,
									-43.8583984375
								],
								[
									-71.79472656250002,
									-43.75322265625006
								],
								[
									-71.73740234374998,
									-43.70468749999995
								],
								[
									-71.732763671875,
									-43.646777343750045
								],
								[
									-71.75063476562502,
									-43.59013671875006
								],
								[
									-71.83242187499997,
									-43.52714843750002
								],
								[
									-71.90498046875001,
									-43.440136718750054
								],
								[
									-71.90498046875001,
									-43.34755859375002
								],
								[
									-71.82021484374997,
									-43.32294921874998
								],
								[
									-71.76386718749995,
									-43.29462890625007
								],
								[
									-71.75063476562502,
									-43.23730468749994
								],
								[
									-71.781494140625,
									-43.166796875000045
								],
								[
									-71.89858398437497,
									-43.14531250000003
								],
								[
									-72.05468749999997,
									-43.10195312499998
								],
								[
									-72.102392578125,
									-43.06562500000004
								],
								[
									-72.14643554687501,
									-42.99003906250002
								],
								[
									-72.11362304687498,
									-42.77675781249991
								],
								[
									-72.13002929687494,
									-42.64824218750002
								],
								[
									-72.14370117187497,
									-42.5771484375
								],
								[
									-72.10541992187498,
									-42.52246093749997
								],
								[
									-72.05346679687497,
									-42.47324218750006
								],
								[
									-72.07812500000003,
									-42.35849609374996
								],
								[
									-72.124609375,
									-42.29833984375004
								],
								[
									-72.10820312499993,
									-42.25185546874991
								],
								[
									-72.06440429687498,
									-42.20537109375003
								],
								[
									-72.026123046875,
									-42.14794921875006
								],
								[
									-71.99331054687497,
									-42.134277343750014
								],
								[
									-71.944091796875,
									-42.16708984375005
								],
								[
									-71.86079101562498,
									-42.14785156250004
								],
								[
									-71.76093749999998,
									-42.101464843749994
								],
								[
									-71.74999999999997,
									-42.04677734375005
								],
								[
									-71.77001953124997,
									-41.9685546875
								],
								[
									-71.84448242187503,
									-41.771972656250014
								],
								[
									-71.91127929687497,
									-41.65039062499994
								],
								[
									-71.89760742187502,
									-41.60664062500008
								],
								[
									-71.87114257812496,
									-41.560546875000014
								],
								[
									-71.89218749999998,
									-41.39335937500006
								],
								[
									-71.88559570312498,
									-41.29238281250001
								],
								[
									-71.88071289062495,
									-40.99462890624993
								],
								[
									-71.873046875,
									-40.892968749999994
								],
								[
									-71.94135742187495,
									-40.78916015624999
								],
								[
									-71.93212890624994,
									-40.69169921875003
								],
								[
									-71.88378906249997,
									-40.620605468750014
								],
								[
									-71.83852539062497,
									-40.52441406250006
								],
								[
									-71.80463867187501,
									-40.43916015625
								],
								[
									-71.76914062499995,
									-40.400878906250014
								],
								[
									-71.70898437499997,
									-40.38173828125002
								],
								[
									-71.69531250000003,
									-40.33525390625006
								],
								[
									-71.72265625,
									-40.29970703125001
								],
								[
									-71.80058593749996,
									-40.24433593750001
								],
								[
									-71.81831054687495,
									-40.17666015624991
								],
								[
									-71.80195312499998,
									-40.12470703124998
								],
								[
									-71.763671875,
									-40.094628906250065
								],
								[
									-71.70439453125002,
									-40.094921874999955
								],
								[
									-71.65976562499998,
									-40.02080078125003
								],
								[
									-71.64711914062497,
									-39.92919921874994
								],
								[
									-71.63789062499995,
									-39.886816406250006
								],
								[
									-71.67207031249998,
									-39.833300781249946
								],
								[
									-71.69682617187496,
									-39.70703125000006
								],
								[
									-71.71992187499998,
									-39.63525390625
								],
								[
									-71.69257812499998,
									-39.60517578125001
								],
								[
									-71.654296875,
									-39.594238281249915
								],
								[
									-71.58701171874998,
									-39.61113281250006
								],
								[
									-71.53945312499997,
									-39.60244140624998
								],
								[
									-71.53125,
									-39.56416015625
								],
								[
									-71.52578124999994,
									-39.52314453125
								],
								[
									-71.50776367187501,
									-39.49521484374999
								],
								[
									-71.46538085937499,
									-39.40234375000007
								],
								[
									-71.42001953124998,
									-39.28720703125006
								],
								[
									-71.40937499999995,
									-39.20595703125004
								],
								[
									-71.42558593749996,
									-38.98564453125009
								],
								[
									-71.40156249999995,
									-38.935058593749915
								],
								[
									-71.35317382812494,
									-38.8888671875
								],
								[
									-71.28574218749998,
									-38.845410156250026
								],
								[
									-71.19726562499997,
									-38.80937500000006
								],
								[
									-71.08710937500001,
									-38.75751953124998
								],
								[
									-70.95161132812495,
									-38.73847656250001
								],
								[
									-70.89692382812498,
									-38.68105468750004
								],
								[
									-70.858642578125,
									-38.60449218750007
								],
								[
									-70.84765625,
									-38.54160156250005
								],
								[
									-70.89965820312503,
									-38.49785156250002
								],
								[
									-70.96796874999998,
									-38.44589843749999
								],
								[
									-71.00048828124994,
									-38.31484375000004
								],
								[
									-71.0181640625,
									-38.19394531249992
								],
								[
									-71.028173828125,
									-38.04121093750007
								],
								[
									-71.09619140625,
									-37.909960937499974
								],
								[
									-71.16757812499998,
									-37.76230468749999
								],
								[
									-71.18671874999995,
									-37.6310546875
								],
								[
									-71.162841796875,
									-37.55917968749992
								],
								[
									-71.13481445312496,
									-37.44511718750003
								],
								[
									-71.16489257812495,
									-37.39326171875004
								],
								[
									-71.20039062500001,
									-37.300292968750014
								],
								[
									-71.16347656250002,
									-37.22744140625001
								],
								[
									-71.118408203125,
									-37.11435546875006
								],
								[
									-71.12382812499993,
									-37.05693359374992
								],
								[
									-71.15937499999998,
									-36.92021484375003
								],
								[
									-71.19218750000002,
									-36.843652343750065
								],
								[
									-71.15937499999998,
									-36.76162109375005
								],
								[
									-71.10742187499997,
									-36.68505859375
								],
								[
									-71.06640624999997,
									-36.64404296875
								],
								[
									-71.07324218750003,
									-36.57802734375005
								],
								[
									-71.05551757812498,
									-36.52373046875
								],
								[
									-70.97792968749997,
									-36.48730468750004
								],
								[
									-70.90512695312498,
									-36.419921874999986
								],
								[
									-70.85317382812497,
									-36.41171874999992
								],
								[
									-70.79028320312503,
									-36.41171874999992
								],
								[
									-70.74926757812503,
									-36.39257812499993
								],
								[
									-70.73286132812495,
									-36.340625
								],
								[
									-70.72192382812494,
									-36.28320312500003
								],
								[
									-70.62187499999999,
									-36.21191406250007
								],
								[
									-70.56337890625,
									-36.14638671875004
								],
								[
									-70.45673828124993,
									-36.13271484374992
								],
								[
									-70.40478515625,
									-36.061718750000026
								],
								[
									-70.40366210937495,
									-35.97050781249992
								],
								[
									-70.41572265625001,
									-35.878515625000006
								],
								[
									-70.38017578124996,
									-35.77187499999995
								],
								[
									-70.41972656249993,
									-35.60917968750002
								],
								[
									-70.41572265625001,
									-35.52304687500006
								],
								[
									-70.45673828124993,
									-35.451953125000045
								],
								[
									-70.44853515624996,
									-35.375390624999994
								],
								[
									-70.47041015624995,
									-35.326171875
								],
								[
									-70.53232421874998,
									-35.30791015624993
								],
								[
									-70.55517578125,
									-35.24687499999993
								],
								[
									-70.52509765625001,
									-35.216796875000014
								],
								[
									-70.46660156249999,
									-35.19365234375
								],
								[
									-70.39316406250003,
									-35.146875000000065
								],
								[
									-70.33813476562503,
									-34.92177734375004
								],
								[
									-70.31210937499995,
									-34.85498046875003
								],
								[
									-70.28676757812494,
									-34.77451171874998
								],
								[
									-70.28994140624997,
									-34.73281250000001
								],
								[
									-70.25468749999999,
									-34.67265625
								],
								[
									-70.210693359375,
									-34.58125000000004
								],
								[
									-70.14125976562497,
									-34.492871093750054
								],
								[
									-70.10146484375002,
									-34.43203125000001
								],
								[
									-70.06298828125,
									-34.349999999999994
								],
								[
									-70.05205078124999,
									-34.30078125
								],
								[
									-70.00283203125,
									-34.27626953125008
								],
								[
									-69.94633789062496,
									-34.26992187500002
								],
								[
									-69.87978515625,
									-34.25439453125006
								],
								[
									-69.85244140625002,
									-34.224316406250054
								],
								[
									-69.85737304687495,
									-34.18046875
								],
								[
									-69.86152343749998,
									-34.08359375000008
								],
								[
									-69.88149414062497,
									-33.929785156250006
								],
								[
									-69.89433593750002,
									-33.73134765625008
								],
								[
									-69.88256835937503,
									-33.600976562499994
								],
								[
									-69.83876953124997,
									-33.46972656250007
								],
								[
									-69.79775390624997,
									-33.39863281249998
								],
								[
									-69.80869140624998,
									-33.343945312500026
								],
								[
									-69.81962890624999,
									-33.283789062500034
								],
								[
									-69.89619140624995,
									-33.2509765625
								],
								[
									-69.96904296874996,
									-33.27939453125002
								],
								[
									-70.01982421875002,
									-33.271484375000014
								],
								[
									-70.08486328125002,
									-33.20175781250002
								],
								[
									-70.10400390625,
									-33.12792968750007
								],
								[
									-70.09306640625002,
									-33.026757812500065
								],
								[
									-70.04213867187502,
									-32.963671875
								],
								[
									-70.02197265625,
									-32.88457031250006
								],
								[
									-70.05205078124999,
									-32.85996093750002
								],
								[
									-70.11616210937501,
									-32.807421874999974
								],
								[
									-70.17695312499995,
									-32.62607421874998
								],
								[
									-70.16962890624998,
									-32.47167968750004
								],
								[
									-70.22978515624996,
									-32.43066406249996
								],
								[
									-70.2578125,
									-32.30996093750005
								],
								[
									-70.32001953124995,
									-32.26669921874995
								],
								[
									-70.34462890625,
									-32.17646484375004
								],
								[
									-70.36376953125,
									-32.08349609374993
								],
								[
									-70.35556640625,
									-32.04238281250008
								],
								[
									-70.29091796875,
									-32.031054687500074
								],
								[
									-70.25439453125,
									-31.957714843750054
								],
								[
									-70.28173828124997,
									-31.916601562500034
								],
								[
									-70.33095703124997,
									-31.881054687500068
								],
								[
									-70.39384765624999,
									-31.8837890625
								],
								[
									-70.45014648437501,
									-31.84189453124999
								],
								[
									-70.52563476562503,
									-31.666406250000037
								],
								[
									-70.585205078125,
									-31.569433593750006
								],
								[
									-70.56640624999997,
									-31.427929687499955
								],
								[
									-70.5546875,
									-31.317382812499986
								],
								[
									-70.529052734375,
									-31.222851562499997
								],
								[
									-70.51958007812493,
									-31.14843750000003
								],
								[
									-70.47309570312498,
									-31.112792968750057
								],
								[
									-70.42939453124995,
									-31.129296875000037
								],
								[
									-70.38837890624995,
									-31.12109374999997
								],
								[
									-70.35058593749997,
									-31.06044921875005
								],
								[
									-70.30908203124997,
									-31.022656250000068
								],
								[
									-70.31181640624999,
									-30.99257812500008
								],
								[
									-70.33642578125003,
									-30.959765625000045
								],
								[
									-70.34814453125,
									-30.902343749999986
								],
								[
									-70.31923828125,
									-30.833984375
								],
								[
									-70.26938476562495,
									-30.677246093750043
								],
								[
									-70.19394531250003,
									-30.50468750000006
								],
								[
									-70.16142578124999,
									-30.44023437499999
								],
								[
									-70.16962890624998,
									-30.385546875000045
								],
								[
									-70.15322265625,
									-30.360937500000006
								],
								[
									-70.10200195312495,
									-30.388281250000063
								],
								[
									-69.95634765624996,
									-30.35820312500006
								],
								[
									-69.90712890624997,
									-30.28164062500001
								],
								[
									-69.88803710937498,
									-30.213281250000023
								],
								[
									-69.84428710937496,
									-30.17500000000004
								],
								[
									-69.86337890625,
									-30.12031250000001
								],
								[
									-69.92353515625001,
									-30.103906250000037
								],
								[
									-69.95996093749997,
									-30.078320312499983
								],
								[
									-69.94545898437497,
									-30.01640625000006
								],
								[
									-69.92412109374996,
									-29.87402343749993
								],
								[
									-69.92763671874997,
									-29.76914062500005
								],
								[
									-69.98261718749998,
									-29.54541015625003
								],
								[
									-70.02680664062501,
									-29.324023437500045
								],
								[
									-69.99560546874994,
									-29.249999999999986
								],
								[
									-69.90034179687501,
									-29.14882812499998
								],
								[
									-69.82788085937497,
									-29.103222656249926
								],
								[
									-69.81484375,
									-29.045507812500063
								],
								[
									-69.74316406249994,
									-28.783886718750054
								],
								[
									-69.73491210937496,
									-28.64111328124993
								],
								[
									-69.68789062499997,
									-28.562011718750057
								],
								[
									-69.65693359374998,
									-28.413574218750014
								],
								[
									-69.52714843749999,
									-28.285644531249986
								],
								[
									-69.4888671875,
									-28.200878906250026
								],
								[
									-69.4369140625,
									-28.192675781250045
								],
								[
									-69.40957031250002,
									-28.16533203124999
								],
								[
									-69.34072265624994,
									-28.070800781249915
								],
								[
									-69.251220703125,
									-27.973632812500014
								],
								[
									-69.17441406249998,
									-27.924707031249994
								],
								[
									-69.1552734375,
									-27.84814453125003
								],
								[
									-69.11850585937498,
									-27.743554687500037
								],
								[
									-69.04218749999995,
									-27.570019531250026
								],
								[
									-68.99941406249997,
									-27.449023437500074
								],
								[
									-68.94199218749998,
									-27.405175781250023
								],
								[
									-68.87509765625003,
									-27.246679687500063
								],
								[
									-68.84633789062494,
									-27.15371093749995
								],
								[
									-68.76977539062497,
									-27.11542968749997
								],
								[
									-68.70961914062497,
									-27.104492187500043
								],
								[
									-68.652197265625,
									-27.148339843749923
								],
								[
									-68.59208984375002,
									-27.14003906250001
								],
								[
									-68.53735351562497,
									-27.08535156250005
								],
								[
									-68.40537109374998,
									-27.048144531250017
								],
								[
									-68.34599609374996,
									-27.027929687500077
								],
								[
									-68.31865234374999,
									-26.973242187500034
								],
								[
									-68.31865234374999,
									-26.87753906249999
								],
								[
									-68.37333984374996,
									-26.806445312500074
								],
								[
									-68.48510742187497,
									-26.67031250000005
								],
								[
									-68.58115234375,
									-26.518359375000003
								],
								[
									-68.59160156250002,
									-26.47041015625001
								],
								[
									-68.59218749999994,
									-26.418066406250006
								],
								[
									-68.57578124999998,
									-26.351953125000037
								],
								[
									-68.52983398437493,
									-26.276953125000034
								],
								[
									-68.41450195312498,
									-26.15371093750005
								],
								[
									-68.4267578125,
									-26.06542968749993
								],
								[
									-68.51083984374998,
									-25.741015624999918
								],
								[
									-68.54189453125,
									-25.651562500000068
								],
								[
									-68.60029296875001,
									-25.485644531250017
								],
								[
									-68.59208984375002,
									-25.420019531250063
								],
								[
									-68.54082031249996,
									-25.236718750000023
								],
								[
									-68.49633789062497,
									-25.16298828125001
								],
								[
									-68.43071289062499,
									-25.149316406250065
								],
								[
									-68.39521484374995,
									-25.124707031250026
								],
								[
									-68.38422851562495,
									-25.091894531250006
								],
								[
									-68.42802734374999,
									-25.050976562500026
								],
								[
									-68.44711914062498,
									-24.99892578125008
								],
								[
									-68.46630859374997,
									-24.92519531249998
								],
								[
									-68.52705078125001,
									-24.899218750000017
								],
								[
									-68.56201171875003,
									-24.837695312499918
								],
								[
									-68.56201171875003,
									-24.74736328124999
								],
								[
									-68.50727539062495,
									-24.62978515625001
								],
								[
									-68.44711914062498,
									-24.596972656250074
								],
								[
									-68.42255859374993,
									-24.545117187499997
								],
								[
									-68.35810546874995,
									-24.49726562500001
								],
								[
									-68.29951171875001,
									-24.460351562500037
								],
								[
									-68.25029296875002,
									-24.391992187500065
								],
								[
									-68.04736328124997,
									-24.308300781250068
								],
								[
									-67.88623046875,
									-24.243359374999983
								],
								[
									-67.57177734374997,
									-24.11894531250003
								],
								[
									-67.35620117187503,
									-24.03378906249992
								],
								[
									-67.335595703125,
									-23.974804687499983
								],
								[
									-67.31914062499993,
									-23.934667968749977
								],
								[
									-67.219140625,
									-23.633984374999997
								],
								[
									-67.08974609375002,
									-23.2451171875
								],
								[
									-67.00878906249994,
									-23.00136718750008
								],
								[
									-67.19487304687493,
									-22.821679687500065
								],
								[
									-67.16191406249996,
									-22.773828124999994
								],
								[
									-67.05541992187494,
									-22.650878906249915
								],
								[
									-67.03354492187492,
									-22.55224609374997
								],
								[
									-66.99111328125,
									-22.509863281249963
								],
								[
									-66.80029296875003,
									-22.40966796874997
								],
								[
									-66.76748046875,
									-22.34306640624999
								],
								[
									-66.75063476562494,
									-22.26933593749999
								],
								[
									-66.71171875000002,
									-22.216308593750014
								],
								[
									-66.63901367187495,
									-22.205371093750003
								],
								[
									-66.50698242187494,
									-22.158398437500026
								],
								[
									-66.36518554687501,
									-22.113769531249915
								],
								[
									-66.32246093750001,
									-22.053124999999994
								],
								[
									-66.28212890624997,
									-21.94746093750004
								],
								[
									-66.24760742187496,
									-21.83046875000001
								],
								[
									-66.22016601562495,
									-21.802539062500003
								],
								[
									-66.17465820312492,
									-21.80566406250003
								],
								[
									-66.09858398437498,
									-21.835058593749977
								],
								[
									-66.05859375,
									-21.879492187499963
								],
								[
									-65.86015624999999,
									-22.01972656249994
								],
								[
									-65.77104492187493,
									-22.099609374999957
								],
								[
									-65.68618164062497,
									-22.110253906249994
								],
								[
									-65.51879882812497,
									-22.09453124999999
								],
								[
									-65.48486328125,
									-22.09814453124993
								],
								[
									-65.05781249999995,
									-22.10273437499997
								],
								[
									-64.99262695312498,
									-22.10966796874996
								],
								[
									-64.84306640624999,
									-22.143945312500023
								],
								[
									-64.75864257812492,
									-22.171289062499994
								],
								[
									-64.70009765625,
									-22.18554687499997
								],
								[
									-64.60551757812499,
									-22.22880859374999
								],
								[
									-64.52363281250001,
									-22.37158203125003
								],
								[
									-64.47773437499998,
									-22.485351562499943
								],
								[
									-64.44550781249998,
									-22.585351562499966
								],
								[
									-64.37397460937498,
									-22.761035156249974
								],
								[
									-64.32529296874992,
									-22.827636718750043
								],
								[
									-64.30791015624993,
									-22.795312500000023
								],
								[
									-64.26640625000002,
									-22.60332031249999
								],
								[
									-64.20908203124998,
									-22.49130859374999
								],
								[
									-64.13183593749994,
									-22.365820312500006
								],
								[
									-63.97612304687493,
									-22.072558593750045
								],
								[
									-63.92167968749993,
									-22.028613281249974
								],
								[
									-63.861035156249926,
									-22.007226562499966
								],
								[
									-63.81865234375002,
									-22.005468749999963
								],
								[
									-63.775585937499926,
									-22.02724609375005
								],
								[
									-63.716943359374966,
									-22.02753906250001
								],
								[
									-63.67534179687493,
									-22.004296874999994
								],
								[
									-63.26718749999992,
									-22.00058593749995
								],
								[
									-62.843359375000006,
									-21.997265624999983
								],
								[
									-62.83427734375002,
									-21.999121093750006
								],
								[
									-62.81508789062502,
									-22.04960937499999
								],
								[
									-62.744580078124955,
									-22.15986328124997
								],
								[
									-62.66528320312494,
									-22.217968749999997
								],
								[
									-62.65097656249998,
									-22.233691406250003
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "ARG",
					"su_a3": "ARG",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "ARG",
					"gu_a3": "ARG",
					"abbrev": "Arg.",
					"region_un": "Americas",
					"adm0_a3_us": "ARG",
					"scalerank": 1,
					"pop_est": 40913584,
					"adm0_dif": 0,
					"un_a3": "032",
					"pop_year": -99,
					"gdp_md_est": 573900,
					"name": "Argentina",
					"sovereignt": "Argentina",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Argentina",
					"postal": "AR",
					"sov_a3": "ARG",
					"note_brk": "",
					"brk_a3": "ARG",
					"wb_a2": "AR",
					"brk_diff": 0,
					"admin": "Argentina",
					"name_long": "Argentina",
					"iso_a3": "ARG",
					"iso_a2": "AR",
					"adm0_a3_is": "ARG",
					"level": 2,
					"formal_en": "Argentine Republic",
					"name_len": 9,
					"mapcolor7": 3,
					"long_len": 9,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "032",
					"homepart": 1,
					"subunit": "Argentina",
					"name_alt": "",
					"brk_name": "Argentina",
					"name_sort": "Argentina",
					"continent": "South America",
					"mapcolor13": 13,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									158.87880859375014,
									-54.70976562500003
								],
								[
									158.8452148437501,
									-54.749218750000075
								],
								[
									158.8359375000001,
									-54.704003906250016
								],
								[
									158.8969726562501,
									-54.50605468750001
								],
								[
									158.95888671875002,
									-54.472363281250075
								],
								[
									158.94560546875016,
									-54.575000000000024
								],
								[
									158.87880859375014,
									-54.70976562500003
								]
							]
						],
						[
							[
								[
									147.3560546875001,
									-43.39697265625004
								],
								[
									147.30888671875016,
									-43.500781249999974
								],
								[
									147.2314453125001,
									-43.483105468749926
								],
								[
									147.1538085937501,
									-43.500195312500026
								],
								[
									147.1049804687501,
									-43.43115234375
								],
								[
									147.1046875,
									-43.412890625
								],
								[
									147.1630859375001,
									-43.43027343749999
								],
								[
									147.1846679687501,
									-43.407812500000034
								],
								[
									147.1984375,
									-43.379199218750074
								],
								[
									147.2197265625001,
									-43.371386718750074
								],
								[
									147.2339843750001,
									-43.330468749999994
								],
								[
									147.28388671875,
									-43.27890625000006
								],
								[
									147.3125000000001,
									-43.280273437499986
								],
								[
									147.34248046875018,
									-43.34628906250002
								],
								[
									147.3560546875001,
									-43.39697265625004
								]
							]
						],
						[
							[
								[
									147.4345703125001,
									-43.24072265624993
								],
								[
									147.37187500000005,
									-43.24082031249995
								],
								[
									147.348828125,
									-43.232421875000014
								],
								[
									147.33759765625007,
									-43.183300781249955
								],
								[
									147.29609375,
									-43.16171874999999
								],
								[
									147.31914062500005,
									-43.14531250000003
								],
								[
									147.32734375000018,
									-43.114648437499994
								],
								[
									147.3525390625,
									-43.080273437499926
								],
								[
									147.39726562500016,
									-43.11826171875002
								],
								[
									147.4345703125001,
									-43.24072265624993
								]
							]
						],
						[
							[
								[
									148.10429687500005,
									-42.71044921875007
								],
								[
									148.04814453125005,
									-42.719238281249915
								],
								[
									148.02968750000002,
									-42.714843749999986
								],
								[
									148.0308593750001,
									-42.663378906250074
								],
								[
									148.02275390625005,
									-42.64042968750002
								],
								[
									148.07255859375005,
									-42.59316406249998
								],
								[
									148.14277343750007,
									-42.61591796875
								],
								[
									148.1695312500001,
									-42.65175781250002
								],
								[
									148.1005859375,
									-42.68056640625002
								],
								[
									148.10429687500005,
									-42.71044921875007
								]
							]
						],
						[
							[
								[
									145.0429687500001,
									-40.78671875000002
								],
								[
									145.15869140625,
									-40.790624999999935
								],
								[
									145.22431640625,
									-40.76513671875007
								],
								[
									145.2830078125,
									-40.76992187499998
								],
								[
									145.34941406250005,
									-40.82636718750001
								],
								[
									145.42939453125007,
									-40.85820312500002
								],
								[
									145.48515625000016,
									-40.852343750000074
								],
								[
									145.53349609375005,
									-40.863964843749955
								],
								[
									145.57646484375,
									-40.90410156249996
								],
								[
									145.6860351562501,
									-40.93906249999998
								],
								[
									145.73378906249997,
									-40.962011718750034
								],
								[
									145.7753906250001,
									-40.99716796874999
								],
								[
									145.82148437500018,
									-41.024609375
								],
								[
									146.11113281250005,
									-41.11806640625002
								],
								[
									146.3174804687501,
									-41.16347656250004
								],
								[
									146.57441406250018,
									-41.1423828125
								],
								[
									146.65058593750018,
									-41.1162109375
								],
								[
									146.7234375,
									-41.07802734375004
								],
								[
									146.78603515625014,
									-41.11367187500002
								],
								[
									146.84814453125,
									-41.16806640624999
								],
								[
									146.8360351562502,
									-41.10937500000003
								],
								[
									146.856640625,
									-41.05830078125001
								],
								[
									146.91943359374994,
									-41.017773437500026
								],
								[
									146.9898437500001,
									-40.9923828125
								],
								[
									147.10576171875016,
									-40.99423828125002
								],
								[
									147.2188476562502,
									-40.98339843750003
								],
								[
									147.26894531250002,
									-40.95976562499993
								],
								[
									147.3205078125,
									-40.956445312499966
								],
								[
									147.38769531249994,
									-40.985546875000026
								],
								[
									147.45478515625,
									-41.00166015624994
								],
								[
									147.50078125,
									-40.96416015625002
								],
								[
									147.57929687500018,
									-40.875585937500006
								],
								[
									147.6216796875002,
									-40.84472656249994
								],
								[
									147.81767578125016,
									-40.871679687500006
								],
								[
									147.87294921875014,
									-40.87255859374993
								],
								[
									147.9687500000001,
									-40.779589843750074
								],
								[
									148.0328125000002,
									-40.78095703125
								],
								[
									148.21523437499997,
									-40.85488281250005
								],
								[
									148.29287109374997,
									-40.9470703125
								],
								[
									148.28544921875016,
									-41.115332031250006
								],
								[
									148.2916015625001,
									-41.174609375
								],
								[
									148.30625000000003,
									-41.23310546875001
								],
								[
									148.31220703125,
									-41.34970703125005
								],
								[
									148.28984375000016,
									-41.46503906250001
								],
								[
									148.2869140625,
									-41.554980468750045
								],
								[
									148.29658203125,
									-41.646191406250054
								],
								[
									148.28759765625,
									-41.815722656250045
								],
								[
									148.31572265625005,
									-41.92773437499996
								],
								[
									148.30166015625002,
									-42.004199218750074
								],
								[
									148.30146484375007,
									-42.03994140624998
								],
								[
									148.32802734375014,
									-42.07373046875003
								],
								[
									148.3408203125,
									-42.11113281250002
								],
								[
									148.33105468749994,
									-42.15917968750003
								],
								[
									148.34257812500016,
									-42.21533203124993
								],
								[
									148.33125000000018,
									-42.26162109375002
								],
								[
									148.29033203125,
									-42.254980468750006
								],
								[
									148.2769531250002,
									-42.219433593750054
								],
								[
									148.28457031249997,
									-42.17343749999992
								],
								[
									148.27714843750016,
									-42.13642578125001
								],
								[
									148.25576171874997,
									-42.10263671875006
								],
								[
									148.1831054687501,
									-42.06474609375006
								],
								[
									148.20439453125016,
									-42.04199218750004
								],
								[
									148.24160156250002,
									-42.02187499999995
								],
								[
									148.213671875,
									-41.970019531250045
								],
								[
									148.16718750000007,
									-42.012304687500034
								],
								[
									148.1412109375001,
									-42.06982421875003
								],
								[
									148.15624999999994,
									-42.08828124999998
								],
								[
									148.12753906250003,
									-42.103710937499926
								],
								[
									148.06660156250018,
									-42.170312499999994
								],
								[
									148.02275390625005,
									-42.25947265625004
								],
								[
									148.0048828125001,
									-42.34511718749998
								],
								[
									148.00937500000003,
									-42.43593750000001
								],
								[
									147.97353515625014,
									-42.50585937500004
								],
								[
									147.92441406250003,
									-42.572460937500026
								],
								[
									147.91210937499994,
									-42.658496093749974
								],
								[
									147.9150390625001,
									-42.816406249999986
								],
								[
									147.95771484375018,
									-42.96044921875003
								],
								[
									147.98085937500002,
									-43.15703124999993
								],
								[
									147.9454101562501,
									-43.18183593750001
								],
								[
									147.83857421875018,
									-43.195117187500045
								],
								[
									147.78583984375018,
									-43.220019531249974
								],
								[
									147.69892578125,
									-43.122558593750014
								],
								[
									147.64794921874994,
									-43.02060546875002
								],
								[
									147.68730468750016,
									-42.97988281249998
								],
								[
									147.77392578124994,
									-43.00341796875007
								],
								[
									147.8003906250002,
									-42.98027343750006
								],
								[
									147.80742187500005,
									-42.95410156250006
								],
								[
									147.8,
									-42.92812500000001
								],
								[
									147.6934570312501,
									-42.87197265625002
								],
								[
									147.57382812500003,
									-42.845703125
								],
								[
									147.53583984375,
									-42.878027343749935
								],
								[
									147.54902343750007,
									-42.97451171875005
								],
								[
									147.5367187500002,
									-42.99648437499991
								],
								[
									147.45234375000018,
									-43.03339843749997
								],
								[
									147.4080078125,
									-42.89384765624996
								],
								[
									147.29794921875003,
									-42.79091796874995
								],
								[
									147.30195312500018,
									-42.84052734375001
								],
								[
									147.34765625,
									-42.926562500000045
								],
								[
									147.34267578125014,
									-42.964453125000034
								],
								[
									147.32500000000016,
									-43.013476562500074
								],
								[
									147.2807617187501,
									-43.031738281249986
								],
								[
									147.2597656250001,
									-43.07109375
								],
								[
									147.2597656250001,
									-43.12646484375
								],
								[
									147.24501953125014,
									-43.21591796875002
								],
								[
									147.1728515625,
									-43.255859374999986
								],
								[
									146.99697265625014,
									-43.15634765625005
								],
								[
									146.98486328124994,
									-43.18984375000004
								],
								[
									146.98750000000007,
									-43.21875000000007
								],
								[
									147.07734375000007,
									-43.275878906249986
								],
								[
									147.03593750000016,
									-43.31904296875007
								],
								[
									147.0046875,
									-43.36962890625007
								],
								[
									146.9546875000002,
									-43.50244140624996
								],
								[
									146.87392578125002,
									-43.6125
								],
								[
									146.83427734375,
									-43.61933593749997
								],
								[
									146.6992187500001,
									-43.60195312499998
								],
								[
									146.54853515625007,
									-43.50888671875002
								],
								[
									146.4131835937502,
									-43.51953125000006
								],
								[
									146.18671875000018,
									-43.512792968749935
								],
								[
									146.04316406250007,
									-43.54716796875
								],
								[
									146.01308593750014,
									-43.44482421874994
								],
								[
									145.98173828125016,
									-43.40839843749998
								],
								[
									145.99443359375016,
									-43.37607421875005
								],
								[
									146.10878906250002,
									-43.354394531249994
								],
								[
									146.22636718750016,
									-43.355273437500074
								],
								[
									146.20800781249994,
									-43.31621093750003
								],
								[
									146.17646484375,
									-43.30175781249993
								],
								[
									146.12509765625003,
									-43.31123046875008
								],
								[
									145.97529296875018,
									-43.27714843750006
								],
								[
									145.87324218750018,
									-43.29238281250005
								],
								[
									145.8027343750001,
									-43.244042968750065
								],
								[
									145.68154296875002,
									-43.07597656250002
								],
								[
									145.6099609375001,
									-42.99824218750008
								],
								[
									145.5673828125001,
									-42.96796875000004
								],
								[
									145.517578125,
									-42.951367187499955
								],
								[
									145.48759765625,
									-42.926660156250065
								],
								[
									145.2681640625001,
									-42.54433593749998
								],
								[
									145.23710937500016,
									-42.455566406250014
								],
								[
									145.1988281250001,
									-42.230859375000065
								],
								[
									145.37294921875002,
									-42.33847656250005
								],
								[
									145.43486328125005,
									-42.40654296875006
								],
								[
									145.46826171875,
									-42.49287109374998
								],
								[
									145.52724609375002,
									-42.38818359374997
								],
								[
									145.5166015625,
									-42.35449218750003
								],
								[
									145.3603515625001,
									-42.22753906249993
								],
								[
									145.33964843750016,
									-42.19072265625006
								],
								[
									145.3310546875001,
									-42.14707031250005
								],
								[
									145.2944335937501,
									-42.19101562499995
								],
								[
									145.23486328124994,
									-42.19697265625
								],
								[
									145.25898437500018,
									-42.10732421874995
								],
								[
									145.23818359375002,
									-42.01962890625002
								],
								[
									145.05537109375018,
									-41.82675781249999
								],
								[
									144.9155273437501,
									-41.64404296875007
								],
								[
									144.7779296875002,
									-41.41884765625002
								],
								[
									144.7661132812501,
									-41.39003906250001
								],
								[
									144.76435546875,
									-41.34150390625007
								],
								[
									144.69775390624994,
									-41.19072265625009
								],
								[
									144.66240234375005,
									-41.078906250000045
								],
								[
									144.6460937500001,
									-40.980859374999966
								],
								[
									144.70966796875018,
									-40.78291015625004
								],
								[
									144.7185546875,
									-40.67226562499998
								],
								[
									144.81855468750007,
									-40.7216796875
								],
								[
									145.0429687500001,
									-40.78671875000002
								]
							]
						],
						[
							[
								[
									148.23691406250003,
									-40.51513671874994
								],
								[
									148.18779296875016,
									-40.59257812500009
								],
								[
									148.1269531250001,
									-40.54394531250003
								],
								[
									148.1172851562502,
									-40.521484374999986
								],
								[
									148.1931640625,
									-40.50312499999998
								],
								[
									148.2183593750001,
									-40.505078125000026
								],
								[
									148.23691406250003,
									-40.51513671874994
								]
							]
						],
						[
							[
								[
									144.784375,
									-40.50673828125001
								],
								[
									144.748046875,
									-40.58945312500006
								],
								[
									144.71015625000018,
									-40.485253906250065
								],
								[
									144.75117187500018,
									-40.47021484375003
								],
								[
									144.78339843750018,
									-40.43486328124993
								],
								[
									144.7908203125,
									-40.44033203124998
								],
								[
									144.784375,
									-40.50673828125001
								]
							]
						],
						[
							[
								[
									148.32626953125003,
									-40.30693359375006
								],
								[
									148.420703125,
									-40.3671875
								],
								[
									148.4742187500001,
									-40.432421875000045
								],
								[
									148.40400390625007,
									-40.486523437500054
								],
								[
									148.35273437500018,
									-40.497265625000026
								],
								[
									148.3194335937501,
									-40.43457031250004
								],
								[
									148.21406250000018,
									-40.45751953124993
								],
								[
									148.1025390625001,
									-40.45166015625006
								],
								[
									148.0201171875002,
									-40.40419921874998
								],
								[
									148.01044921875018,
									-40.380566406250054
								],
								[
									148.05878906250018,
									-40.35683593750002
								],
								[
									148.19814453125014,
									-40.35791015625006
								],
								[
									148.32626953125003,
									-40.30693359375006
								]
							]
						],
						[
							[
								[
									148.00039062499997,
									-39.75761718750006
								],
								[
									148.1779296875,
									-39.93847656250006
								],
								[
									148.27001953124994,
									-39.96669921875002
								],
								[
									148.2973632812501,
									-39.985742187499994
								],
								[
									148.28984375000016,
									-40.065429687499986
								],
								[
									148.25078125000005,
									-40.099511718749994
								],
								[
									148.32324218749994,
									-40.144433593749994
								],
								[
									148.3135742187502,
									-40.17353515624998
								],
								[
									148.2994140625001,
									-40.17246093750002
								],
								[
									148.21035156250014,
									-40.23369140625006
								],
								[
									148.1056640625,
									-40.26210937499991
								],
								[
									148.07363281249997,
									-40.240820312500006
								],
								[
									148.04687499999994,
									-40.21279296874998
								],
								[
									148.02480468749997,
									-40.17197265625002
								],
								[
									147.89052734374997,
									-40.01455078124992
								],
								[
									147.90595703125,
									-39.97138671875001
								],
								[
									147.87626953125005,
									-39.90546875000008
								],
								[
									147.81230468750016,
									-39.91044921875003
								],
								[
									147.7671875000002,
									-39.870312500000026
								],
								[
									147.83916015625,
									-39.83154296874994
								],
								[
									147.93300781250014,
									-39.72597656250001
								],
								[
									148.00039062499997,
									-39.75761718750006
								]
							]
						],
						[
							[
								[
									143.92792968750007,
									-40.11611328125001
								],
								[
									143.89873046875016,
									-40.120214843750034
								],
								[
									143.87578125,
									-40.06396484375004
								],
								[
									143.88759765625002,
									-39.98359375000001
								],
								[
									143.83857421875007,
									-39.90410156250006
								],
								[
									143.865234375,
									-39.82421875000004
								],
								[
									143.8618164062501,
									-39.73798828125007
								],
								[
									143.8793945312501,
									-39.700000000000045
								],
								[
									143.93935546874997,
									-39.65810546875004
								],
								[
									143.94882812500003,
									-39.58369140625007
								],
								[
									144.00078125000016,
									-39.58017578125006
								],
								[
									144.09130859374994,
									-39.638085937499966
								],
								[
									144.12089843750005,
									-39.785253906250006
								],
								[
									144.1060546875002,
									-39.87402343750007
								],
								[
									144.14101562500014,
									-39.95380859374998
								],
								[
									144.11191406250003,
									-40.022070312500034
								],
								[
									144.03505859375014,
									-40.078222656250006
								],
								[
									143.92792968750007,
									-40.11611328125001
								]
							]
						],
						[
							[
								[
									145.3144531250001,
									-38.490820312500006
								],
								[
									145.3492187500001,
									-38.53818359375006
								],
								[
									145.3550781250002,
									-38.557031249999994
								],
								[
									145.27089843750002,
									-38.519726562500026
								],
								[
									145.1284179687501,
									-38.527636718750045
								],
								[
									145.2177734375001,
									-38.458593750000006
								],
								[
									145.287890625,
									-38.472167968750014
								],
								[
									145.3144531250001,
									-38.490820312500006
								]
							]
						],
						[
							[
								[
									145.48652343750007,
									-38.35488281250002
								],
								[
									145.33583984375002,
									-38.42099609374999
								],
								[
									145.28027343749994,
									-38.390625000000014
								],
								[
									145.28583984375,
									-38.34101562500004
								],
								[
									145.29531250000002,
									-38.31894531250006
								],
								[
									145.4265625,
									-38.31416015625007
								],
								[
									145.48652343750007,
									-38.35488281250002
								]
							]
						],
						[
							[
								[
									137.59648437500016,
									-35.73867187499994
								],
								[
									137.8359375000001,
									-35.762109374999994
								],
								[
									137.92890625,
									-35.72607421875003
								],
								[
									138.04658203125,
									-35.75517578125
								],
								[
									138.12343750000014,
									-35.85234375
								],
								[
									138.0665039062501,
									-35.900585937500054
								],
								[
									138.01191406250018,
									-35.907617187500065
								],
								[
									137.8355468750002,
									-35.86777343749995
								],
								[
									137.67089843749994,
									-35.89794921875006
								],
								[
									137.62226562500018,
									-35.93808593750006
								],
								[
									137.59023437500014,
									-36.02714843749999
								],
								[
									137.4484375,
									-36.07480468750002
								],
								[
									137.38222656250014,
									-36.02089843750005
								],
								[
									137.2095703125002,
									-35.98242187500003
								],
								[
									137.14775390625016,
									-36.03906250000003
								],
								[
									137.0258789062501,
									-36.02392578125004
								],
								[
									136.91269531250003,
									-36.04667968750006
								],
								[
									136.75507812500018,
									-36.03310546875005
								],
								[
									136.58925781250014,
									-35.93535156250003
								],
								[
									136.5406250000001,
									-35.89013671875006
								],
								[
									136.5791015625001,
									-35.80869140624999
								],
								[
									136.638671875,
									-35.748828125000045
								],
								[
									137.0917968750001,
									-35.663867187499974
								],
								[
									137.3340820312501,
									-35.59248046875
								],
								[
									137.53046875,
									-35.60507812500008
								],
								[
									137.58496093749994,
									-35.62021484374996
								],
								[
									137.63544921875,
									-35.656445312500054
								],
								[
									137.59814453124994,
									-35.72226562500005
								],
								[
									137.59648437500016,
									-35.73867187499994
								]
							]
						],
						[
							[
								[
									153.53876953125007,
									-27.436425781249994
								],
								[
									153.4527343750002,
									-27.711718749999946
								],
								[
									153.42656250000005,
									-27.706445312499937
								],
								[
									153.39580078125016,
									-27.66503906250003
								],
								[
									153.4008789062501,
									-27.50566406250006
								],
								[
									153.43544921874997,
									-27.405371093750063
								],
								[
									153.52187499999997,
									-27.42246093749999
								],
								[
									153.53876953125007,
									-27.436425781249994
								]
							]
						],
						[
							[
								[
									153.4424804687501,
									-27.316015624999977
								],
								[
									153.4208984375001,
									-27.330957031249994
								],
								[
									153.37656250000003,
									-27.235351562500057
								],
								[
									153.3650390625,
									-27.138867187500026
								],
								[
									153.3798828125001,
									-27.04941406250002
								],
								[
									153.43232421875007,
									-27.02988281249995
								],
								[
									153.46679687499994,
									-27.038085937500014
								],
								[
									153.4263671875001,
									-27.20146484374999
								],
								[
									153.4424804687501,
									-27.316015624999977
								]
							]
						],
						[
							[
								[
									113.18300781250014,
									-26.05312500000008
								],
								[
									113.15644531250001,
									-26.09453124999999
								],
								[
									112.96425781250014,
									-25.783105468749966
								],
								[
									112.908203125,
									-25.56982421875003
								],
								[
									112.94707031249999,
									-25.531542968750045
								],
								[
									112.98242187500011,
									-25.520214843750054
								],
								[
									113.0962890625002,
									-25.815039062500077
								],
								[
									113.13154296875001,
									-25.88261718749999
								],
								[
									113.1318359375,
									-25.951953125000074
								],
								[
									113.14833984374997,
									-25.973828124999997
								],
								[
									113.18300781250014,
									-26.05312500000008
								]
							]
						],
						[
							[
								[
									153.07744140625005,
									-25.75078125000003
								],
								[
									153.05195312500018,
									-25.778320312500057
								],
								[
									153.0069335937501,
									-25.728906249999937
								],
								[
									152.9766601562502,
									-25.551367187500006
								],
								[
									152.99902343749994,
									-25.448437499999997
								],
								[
									153.0515625,
									-25.354296875000003
								],
								[
									153.0607421875,
									-25.302246093750057
								],
								[
									153.0380859375001,
									-25.19316406250003
								],
								[
									153.1892578125,
									-25.070507812499997
								],
								[
									153.2275390625,
									-25.00576171875005
								],
								[
									153.2419921875,
									-24.922558593750054
								],
								[
									153.18632812500005,
									-24.83261718749995
								],
								[
									153.14375000000007,
									-24.81484375000005
								],
								[
									153.18095703125,
									-24.764843749999997
								],
								[
									153.22314453124994,
									-24.73955078124999
								],
								[
									153.2569335937502,
									-24.728906250000037
								],
								[
									153.28212890625002,
									-24.738281249999915
								],
								[
									153.2979492187502,
									-24.915234375000082
								],
								[
									153.35927734374997,
									-24.977734375000026
								],
								[
									153.3501953125002,
									-25.063085937500006
								],
								[
									153.14140625,
									-25.512792968749963
								],
								[
									153.0837890625,
									-25.68251953125008
								],
								[
									153.07744140625005,
									-25.75078125000003
								]
							]
						],
						[
							[
								[
									151.14658203125003,
									-23.49082031250005
								],
								[
									151.1807617187501,
									-23.51621093749999
								],
								[
									151.21201171875003,
									-23.513085937500065
								],
								[
									151.24013671875002,
									-23.529687500000065
								],
								[
									151.22880859375,
									-23.59492187500004
								],
								[
									151.27431640625014,
									-23.66845703125
								],
								[
									151.29580078124997,
									-23.720312500000006
								],
								[
									151.2615234375,
									-23.762304687500034
								],
								[
									151.23828125,
									-23.775781249999937
								],
								[
									151.1841796875001,
									-23.74072265625007
								],
								[
									151.03330078125003,
									-23.530175781249994
								],
								[
									151.05996093749997,
									-23.46054687500002
								],
								[
									151.14658203125003,
									-23.49082031250005
								]
							]
						],
						[
							[
								[
									150.5166992187501,
									-22.32255859374999
								],
								[
									150.48847656250018,
									-22.32470703125007
								],
								[
									150.4624023437501,
									-22.30771484374999
								],
								[
									150.48466796875005,
									-22.267871093750045
								],
								[
									150.48847656250018,
									-22.21074218750003
								],
								[
									150.521484375,
									-22.22832031250006
								],
								[
									150.54882812499994,
									-22.306933593750003
								],
								[
									150.5166992187501,
									-22.32255859374999
								]
							]
						],
						[
							[
								[
									149.9283203125002,
									-22.193066406250082
								],
								[
									149.89365234375003,
									-22.223242187500006
								],
								[
									149.86953125000014,
									-22.150390624999915
								],
								[
									149.87539062499997,
									-22.07402343749999
								],
								[
									149.9123046875,
									-22.048730468750065
								],
								[
									149.9279296875,
									-22.14931640625005
								],
								[
									149.9283203125002,
									-22.193066406250082
								]
							]
						],
						[
							[
								[
									115.44619140625014,
									-20.78779296875004
								],
								[
									115.38808593750002,
									-20.86601562499999
								],
								[
									115.31806640625007,
									-20.850585937500043
								],
								[
									115.30859375,
									-20.81113281249992
								],
								[
									115.35429687500016,
									-20.746289062500026
								],
								[
									115.4345703125,
									-20.667968750000057
								],
								[
									115.45761718750003,
									-20.716308593750043
								],
								[
									115.44619140625014,
									-20.78779296875004
								]
							]
						],
						[
							[
								[
									149.04375,
									-20.29150390624993
								],
								[
									149.01992187500014,
									-20.302539062500045
								],
								[
									148.9874023437501,
									-20.301757812500057
								],
								[
									148.93886718750014,
									-20.283691406250014
								],
								[
									148.9810546875002,
									-20.153515625000054
								],
								[
									149.00439453125,
									-20.221484375000045
								],
								[
									149.04531249999997,
									-20.277539062499926
								],
								[
									149.04375,
									-20.29150390624993
								]
							]
						],
						[
							[
								[
									148.935546875,
									-20.14990234375003
								],
								[
									148.91347656250014,
									-20.154296875000043
								],
								[
									148.8869140625,
									-20.143554687499986
								],
								[
									148.9064453125,
									-20.101953125000037
								],
								[
									148.9316406250001,
									-20.068945312500063
								],
								[
									148.9678710937502,
									-20.044335937500023
								],
								[
									148.95625,
									-20.13466796874995
								],
								[
									148.935546875,
									-20.14990234375003
								]
							]
						],
						[
							[
								[
									146.2783203125,
									-18.23125000000003
								],
								[
									146.298828125,
									-18.32607421875008
								],
								[
									146.34199218750018,
									-18.400097656250068
								],
								[
									146.32705078124997,
									-18.44863281250001
								],
								[
									146.298828125,
									-18.48476562500008
								],
								[
									146.23564453125,
									-18.45078124999999
								],
								[
									146.19130859375014,
									-18.36289062499995
								],
								[
									146.1162109375001,
									-18.29238281250005
								],
								[
									146.098828125,
									-18.251757812500045
								],
								[
									146.18671875000018,
									-18.25517578125003
								],
								[
									146.23085937500002,
									-18.241406250000068
								],
								[
									146.2491210937501,
									-18.225878906250003
								],
								[
									146.2783203125,
									-18.23125000000003
								]
							]
						],
						[
							[
								[
									139.4591796875,
									-17.114550781250003
								],
								[
									139.42167968750005,
									-17.131640624999932
								],
								[
									139.40820312499994,
									-17.090625000000003
								],
								[
									139.4591796875,
									-17.04912109374999
								],
								[
									139.49277343750003,
									-16.99042968749994
								],
								[
									139.56005859375,
									-17.041992187500043
								],
								[
									139.57089843750003,
									-17.094433593750068
								],
								[
									139.4591796875,
									-17.114550781250003
								]
							]
						],
						[
							[
								[
									139.5078125000001,
									-16.57304687499999
								],
								[
									139.43056640624997,
									-16.66103515624998
								],
								[
									139.39150390625002,
									-16.64863281249994
								],
								[
									139.35429687500016,
									-16.696582031250017
								],
								[
									139.28300781250005,
									-16.719433593750054
								],
								[
									139.23906250000016,
									-16.718652343749994
								],
								[
									139.15957031250002,
									-16.74169921875007
								],
								[
									139.14765625000018,
									-16.713867187499986
								],
								[
									139.1626953125002,
									-16.625878906249923
								],
								[
									139.22871093750018,
									-16.52753906250004
								],
								[
									139.2929687500001,
									-16.467285156249943
								],
								[
									139.45888671874997,
									-16.438476562500014
								],
								[
									139.58789062499994,
									-16.395214843749997
								],
								[
									139.6044921875,
									-16.403222656250037
								],
								[
									139.69775390624994,
									-16.51494140625006
								],
								[
									139.5596679687501,
									-16.529492187499997
								],
								[
									139.5078125000001,
									-16.57304687499999
								]
							]
						],
						[
							[
								[
									137.09365234375014,
									-15.778125000000045
								],
								[
									137.0508789062502,
									-15.824414062500068
								],
								[
									136.99648437500014,
									-15.775781250000009
								],
								[
									136.98505859375,
									-15.72597656250008
								],
								[
									136.94267578125,
									-15.711718750000017
								],
								[
									136.96337890624994,
									-15.665722656250068
								],
								[
									136.98574218750002,
									-15.65244140625002
								],
								[
									137.00957031250016,
									-15.594824218750006
								],
								[
									137.0645507812501,
									-15.662890625000017
								],
								[
									137.07109375000016,
									-15.73808593750006
								],
								[
									137.09365234375014,
									-15.778125000000045
								]
							]
						],
						[
							[
								[
									136.59101562500007,
									-15.62822265625006
								],
								[
									136.53115234375014,
									-15.632421875000034
								],
								[
									136.51425781250003,
									-15.627343750000065
								],
								[
									136.502734375,
									-15.583105468749935
								],
								[
									136.52255859375003,
									-15.543164062499969
								],
								[
									136.5860351562502,
									-15.533691406249986
								],
								[
									136.61230468749994,
									-15.544140625000068
								],
								[
									136.59101562500007,
									-15.62822265625006
								]
							]
						],
						[
							[
								[
									136.86269531249997,
									-15.619921874999974
								],
								[
									136.8467773437502,
									-15.627343750000065
								],
								[
									136.84560546875014,
									-15.544042968750048
								],
								[
									136.87685546875002,
									-15.502539062500034
								],
								[
									136.8902343750001,
									-15.588867187500043
								],
								[
									136.86269531249997,
									-15.619921874999974
								]
							]
						],
						[
							[
								[
									124.59726562500009,
									-15.401953124999977
								],
								[
									124.55957031250011,
									-15.430175781250043
								],
								[
									124.52421875000005,
									-15.421484375000048
								],
								[
									124.52373046874999,
									-15.382421875000077
								],
								[
									124.48281250000014,
									-15.340332031250028
								],
								[
									124.50410156250018,
									-15.292480468750057
								],
								[
									124.51933593749999,
									-15.267480468749937
								],
								[
									124.5508789062502,
									-15.27031250000006
								],
								[
									124.56455078125009,
									-15.31083984375006
								],
								[
									124.60507812500003,
									-15.356542968749963
								],
								[
									124.59726562500009,
									-15.401953124999977
								]
							]
						],
						[
							[
								[
									125.19882812500003,
									-14.579492187500009
								],
								[
									125.13476562499994,
									-14.641699218749991
								],
								[
									125.09121093749997,
									-14.591699218750009
								],
								[
									125.11738281250018,
									-14.491992187500045
								],
								[
									125.15996093750005,
									-14.4560546875
								],
								[
									125.19814453125002,
									-14.474804687499997
								],
								[
									125.19355468750007,
									-14.552636718749966
								],
								[
									125.19882812500003,
									-14.579492187500009
								]
							]
						],
						[
							[
								[
									136.7146484375,
									-13.803906250000011
								],
								[
									136.75800781250007,
									-13.845410156250026
								],
								[
									136.80449218750005,
									-13.842480468750054
								],
								[
									136.8453125000001,
									-13.750976562500071
								],
								[
									136.8707031250002,
									-13.763671874999986
								],
								[
									136.8908203125,
									-13.786621093750043
								],
								[
									136.90556640625,
									-13.826953124999918
								],
								[
									136.84296875000007,
									-13.896582031250063
								],
								[
									136.8149414062501,
									-13.907324218749949
								],
								[
									136.7881835937501,
									-13.945800781249972
								],
								[
									136.74531250000007,
									-14.072656250000051
								],
								[
									136.74990234375002,
									-14.115234375000028
								],
								[
									136.78701171875002,
									-14.157812499999991
								],
								[
									136.88544921875018,
									-14.197265625000043
								],
								[
									136.93388671875,
									-14.179003906250045
								],
								[
									136.9507812500001,
									-14.184277343750054
								],
								[
									136.93134765625,
									-14.245996093750023
								],
								[
									136.89433593750005,
									-14.29306640625002
								],
								[
									136.76318359374994,
									-14.273437499999929
								],
								[
									136.64970703125,
									-14.28046874999994
								],
								[
									136.4605468750002,
									-14.234570312499997
								],
								[
									136.3632812500001,
									-14.228906249999994
								],
								[
									136.3354492187501,
									-14.211816406250065
								],
								[
									136.39218750000003,
									-14.17548828125004
								],
								[
									136.4277343750001,
									-14.12646484375
								],
								[
									136.4111328125,
									-14.011132812500037
								],
								[
									136.42470703125002,
									-13.864843749999991
								],
								[
									136.5337890625002,
									-13.793750000000074
								],
								[
									136.58281250000016,
									-13.721093750000023
								],
								[
									136.65566406249997,
									-13.675878906250048
								],
								[
									136.701953125,
									-13.681640625000057
								],
								[
									136.69599609375,
									-13.726171874999991
								],
								[
									136.7146484375,
									-13.803906250000011
								]
							]
						],
						[
							[
								[
									136.23740234375003,
									-13.824511718750031
								],
								[
									136.213671875,
									-13.835937499999972
								],
								[
									136.1226562500002,
									-13.81660156249994
								],
								[
									136.122265625,
									-13.78056640625006
								],
								[
									136.1343750000002,
									-13.753125000000054
								],
								[
									136.15957031249997,
									-13.736718750000009
								],
								[
									136.2154296875002,
									-13.664746093750082
								],
								[
									136.2574218750002,
									-13.70664062499992
								],
								[
									136.27539062499994,
									-13.791113281250077
								],
								[
									136.23740234375003,
									-13.824511718750031
								]
							]
						],
						[
							[
								[
									136.33867187500016,
									-11.602343749999932
								],
								[
									136.18027343750003,
									-11.676757812499915
								],
								[
									136.26738281250005,
									-11.576464843749903
								],
								[
									136.4492187500001,
									-11.487109374999903
								],
								[
									136.47929687500005,
									-11.465917968749949
								],
								[
									136.4705078125,
									-11.5092773437499
								],
								[
									136.3793945312501,
									-11.58320312499994
								],
								[
									136.33867187500016,
									-11.602343749999932
								]
							]
						],
						[
							[
								[
									130.45927734375016,
									-11.679296874999977
								],
								[
									130.541796875,
									-11.703124999999957
								],
								[
									130.57988281250005,
									-11.737109374999946
								],
								[
									130.60273437500018,
									-11.773242187499932
								],
								[
									130.60625,
									-11.816601562499983
								],
								[
									130.5025390625002,
									-11.835644531249955
								],
								[
									130.31748046875003,
									-11.771777343749903
								],
								[
									130.13125000000014,
									-11.824511718749989
								],
								[
									130.07656250000002,
									-11.825488281249918
								],
								[
									130.04326171875016,
									-11.787304687499955
								],
								[
									130.07207031250016,
									-11.68076171874992
								],
								[
									130.13906250000014,
									-11.69707031249996
								],
								[
									130.19755859375016,
									-11.658203124999943
								],
								[
									130.18710937500003,
									-11.541210937499912
								],
								[
									130.15283203125,
									-11.4775390625
								],
								[
									130.25117187500007,
									-11.360546874999969
								],
								[
									130.294921875,
									-11.336816406249937
								],
								[
									130.33925781250014,
									-11.337011718749977
								],
								[
									130.37675781250016,
									-11.420117187500026
								],
								[
									130.38564453124997,
									-11.50986328124992
								],
								[
									130.43281250000018,
									-11.592187499999909
								],
								[
									130.45927734375016,
									-11.679296874999977
								]
							]
						],
						[
							[
								[
									130.61884765625018,
									-11.376074218749935
								],
								[
									130.75224609375016,
									-11.384374999999935
								],
								[
									130.91279296875018,
									-11.309277343749912
								],
								[
									130.9874023437502,
									-11.339843750000014
								],
								[
									131.0230468750001,
									-11.334374999999966
								],
								[
									131.14062499999994,
									-11.263085937500009
								],
								[
									131.21718750000014,
									-11.242578124999923
								],
								[
									131.26826171875,
									-11.189843750000009
								],
								[
									131.3205078125,
									-11.246874999999903
								],
								[
									131.43691406250014,
									-11.313183593749912
								],
								[
									131.47333984375018,
									-11.382519531249912
								],
								[
									131.522265625,
									-11.415234374999926
								],
								[
									131.53857421874994,
									-11.43691406249998
								],
								[
									131.4678710937502,
									-11.50957031249996
								],
								[
									131.4585937500002,
									-11.587890624999929
								],
								[
									131.3828125000001,
									-11.5825195312499
								],
								[
									131.2920898437502,
									-11.710937499999943
								],
								[
									130.95097656250016,
									-11.926464843749983
								],
								[
									130.64492187499997,
									-11.742382812499955
								],
								[
									130.51191406250007,
									-11.617871093749898
								],
								[
									130.42275390625002,
									-11.445800781249929
								],
								[
									130.40478515625,
									-11.304980468750017
								],
								[
									130.36855468749997,
									-11.214941406249977
								],
								[
									130.38457031250005,
									-11.19218749999996
								],
								[
									130.40292968750003,
									-11.18046874999996
								],
								[
									130.42666015625002,
									-11.183105468750057
								],
								[
									130.5191406250002,
									-11.279492187499983
								],
								[
									130.559765625,
									-11.305957031249946
								],
								[
									130.61884765625018,
									-11.376074218749935
								]
							]
						],
						[
							[
								[
									136.59853515624997,
									-11.378906249999886
								],
								[
									136.52656250000007,
									-11.438867187499937
								],
								[
									136.52167968750007,
									-11.393847656250003
								],
								[
									136.55976562500018,
									-11.357910156249972
								],
								[
									136.64902343750003,
									-11.211621093749912
								],
								[
									136.6879882812501,
									-11.177636718750009
								],
								[
									136.7105468750001,
									-11.158398437499997
								],
								[
									136.72734375000005,
									-11.104785156249918
								],
								[
									136.73173828125005,
									-11.024609374999926
								],
								[
									136.78027343749994,
									-11.012499999999946
								],
								[
									136.74140625000007,
									-11.194628906249918
								],
								[
									136.59853515624997,
									-11.378906249999886
								]
							]
						],
						[
							[
								[
									132.5933593750001,
									-11.302832031249935
								],
								[
									132.57363281249997,
									-11.3183593749999
								],
								[
									132.49375000000003,
									-11.163671875000006
								],
								[
									132.51630859375,
									-11.116015624999974
								],
								[
									132.48378906250014,
									-11.037304687499926
								],
								[
									132.53779296875,
									-11.028417968749892
								],
								[
									132.57880859375007,
									-10.968847656249935
								],
								[
									132.59326171874994,
									-10.997656249999935
								],
								[
									132.59687500000018,
									-11.1064453124999
								],
								[
									132.62910156250018,
									-11.169140625000054
								],
								[
									132.5933593750001,
									-11.302832031249935
								]
							]
						],
						[
							[
								[
									143.17890625000007,
									-11.954492187499909
								],
								[
									143.1529296875002,
									-12.07587890625004
								],
								[
									143.1046875,
									-12.169628906249955
								],
								[
									143.09902343750014,
									-12.225976562500065
								],
								[
									143.11025390625002,
									-12.30351562499996
								],
								[
									143.19062500000007,
									-12.361230468749909
								],
								[
									143.25410156250018,
									-12.397656249999955
								],
								[
									143.28964843750003,
									-12.49882812499996
								],
								[
									143.4015625,
									-12.639941406250031
								],
								[
									143.3975585937502,
									-12.736132812499989
								],
								[
									143.45771484375018,
									-12.855761718749946
								],
								[
									143.51201171875016,
									-13.094531249999918
								],
								[
									143.52949218750018,
									-13.30380859374992
								],
								[
									143.58662109375018,
									-13.443652343749989
								],
								[
									143.5484375000002,
									-13.741015624999989
								],
								[
									143.58925781249997,
									-13.862792968750014
								],
								[
									143.643359375,
									-13.96367187500006
								],
								[
									143.7072265625,
									-14.164550781250028
								],
								[
									143.7563476562501,
									-14.348828125000011
								],
								[
									143.82236328125003,
									-14.401074218749997
								],
								[
									143.96181640625014,
									-14.462890625000057
								],
								[
									144.10585937499997,
									-14.394531249999986
								],
								[
									144.20986328125014,
									-14.301953125000054
								],
								[
									144.32167968749997,
									-14.279394531250077
								],
								[
									144.47304687500002,
									-14.23183593749998
								],
								[
									144.5864257812501,
									-14.35468750000004
								],
								[
									144.64804687500003,
									-14.492480468750045
								],
								[
									144.91572265625,
									-14.674316406250057
								],
								[
									145.06445312499994,
									-14.791015625000028
								],
								[
									145.17998046875016,
									-14.856933593750043
								],
								[
									145.28769531250003,
									-14.943164062499946
								],
								[
									145.2769531250002,
									-15.029394531250006
								],
								[
									145.25166015625018,
									-15.097460937500017
								],
								[
									145.27617187500005,
									-15.203906250000031
								],
								[
									145.2930664062501,
									-15.327246093750034
								],
								[
									145.27158203125003,
									-15.47666015624992
								],
								[
									145.34951171875014,
									-15.70156250000008
								],
								[
									145.37539062499997,
									-15.881054687500054
								],
								[
									145.4580078125001,
									-16.05644531249999
								],
								[
									145.45185546875,
									-16.236914062500077
								],
								[
									145.43642578124997,
									-16.304980468749918
								],
								[
									145.42607421875,
									-16.406152343749923
								],
								[
									145.49042968750007,
									-16.53212890625001
								],
								[
									145.5499023437502,
									-16.62509765625002
								],
								[
									145.6382812500001,
									-16.726074218749986
								],
								[
									145.75478515625002,
									-16.879492187500077
								],
								[
									145.83789062499994,
									-16.91035156249997
								],
								[
									145.912109375,
									-16.91250000000005
								],
								[
									145.90195312500003,
									-17.070214843750023
								],
								[
									146.0498046875,
									-17.38105468749994
								],
								[
									146.12587890625014,
									-17.63525390625003
								],
								[
									146.07402343750005,
									-17.977343749999918
								],
								[
									146.02285156249997,
									-18.175781250000014
								],
								[
									146.03222656249994,
									-18.27285156250008
								],
								[
									146.22304687500002,
									-18.50986328125005
								],
								[
									146.33320312500018,
									-18.5537109375
								],
								[
									146.31171875000007,
									-18.666699218750026
								],
								[
									146.29687499999994,
									-18.84121093750005
								],
								[
									146.3833984375001,
									-18.977050781250014
								],
								[
									146.48115234375,
									-19.07871093750002
								],
								[
									146.58730468749997,
									-19.13945312500006
								],
								[
									146.6919921875001,
									-19.18740234375005
								],
								[
									146.82900390625002,
									-19.235742187500037
								],
								[
									147.00263671875,
									-19.25605468750001
								],
								[
									147.0927734375001,
									-19.332617187499977
								],
								[
									147.13876953125003,
									-19.39316406250005
								],
								[
									147.27812500000005,
									-19.414160156250063
								],
								[
									147.34150390625007,
									-19.40292968749999
								],
								[
									147.4185546875002,
									-19.37812500000001
								],
								[
									147.4708984375,
									-19.41933593750005
								],
								[
									147.50976562499994,
									-19.47412109375003
								],
								[
									147.58603515625003,
									-19.62275390625001
								],
								[
									147.74238281250018,
									-19.770117187499935
								],
								[
									147.85322265625,
									-19.794726562499974
								],
								[
									147.91562500000003,
									-19.86923828125005
								],
								[
									148.0044921875002,
									-19.88955078125001
								],
								[
									148.0810546875,
									-19.898632812499997
								],
								[
									148.18964843750018,
									-19.955859375000017
								],
								[
									148.36689453125007,
									-20.087499999999935
								],
								[
									148.52675781250014,
									-20.10888671875003
								],
								[
									148.60048828125014,
									-20.14521484374997
								],
								[
									148.7593750000001,
									-20.289550781250057
								],
								[
									148.82099609375,
									-20.366406250000082
								],
								[
									148.88476562499994,
									-20.480859375000037
								],
								[
									148.80507812499997,
									-20.49169921875003
								],
								[
									148.72998046874994,
									-20.467773437499957
								],
								[
									148.6836914062502,
									-20.58017578125002
								],
								[
									148.78945312499997,
									-20.73564453124999
								],
								[
									148.91240234375016,
									-20.845214843750014
								],
								[
									149.06054687499994,
									-20.961132812499926
								],
								[
									149.20488281250016,
									-21.125097656249935
								],
								[
									149.24140625000007,
									-21.25019531250001
								],
								[
									149.28027343749994,
									-21.29951171874994
								],
								[
									149.32929687500018,
									-21.47607421875003
								],
								[
									149.45410156249994,
									-21.578710937499977
								],
								[
									149.4600585937502,
									-21.765429687500003
								],
								[
									149.5240234375001,
									-22.023632812500026
								],
								[
									149.5957031250001,
									-22.25761718749999
								],
								[
									149.6453125,
									-22.328320312499926
								],
								[
									149.70390625000005,
									-22.44052734375005
								],
								[
									149.77158203125003,
									-22.426269531249986
								],
								[
									149.8224609375,
									-22.389843750000026
								],
								[
									149.92031249999997,
									-22.50136718750001
								],
								[
									149.97441406250016,
									-22.55068359375001
								],
								[
									150.00556640625,
									-22.521582031250034
								],
								[
									149.9418945312501,
									-22.30810546875007
								],
								[
									149.98125000000016,
									-22.184277343750068
								],
								[
									150.0206054687501,
									-22.168359375000023
								],
								[
									150.0761718750001,
									-22.164453124999937
								],
								[
									150.14296875000014,
									-22.265429687500074
								],
								[
									150.2348632812501,
									-22.372949218750037
								],
								[
									150.40507812500016,
									-22.468945312500054
								],
								[
									150.54130859375,
									-22.559082031250043
								],
								[
									150.5795898437501,
									-22.555761718750077
								],
								[
									150.56435546875002,
									-22.486132812500003
								],
								[
									150.56855468750007,
									-22.383984375000068
								],
								[
									150.62285156250005,
									-22.36728515625005
								],
								[
									150.6724609375002,
									-22.41816406250001
								],
								[
									150.76386718750007,
									-22.57617187499997
								],
								[
									150.7828125000002,
									-22.902929687500006
								],
								[
									150.78300781250016,
									-23.176562500000074
								],
								[
									150.84316406250014,
									-23.45800781250003
								],
								[
									150.93105468750002,
									-23.531933593749997
								],
								[
									150.98876953124994,
									-23.60175781250001
								],
								[
									151.08769531250005,
									-23.696093750000045
								],
								[
									151.1538085937501,
									-23.784082031250023
								],
								[
									151.23632812499994,
									-23.825000000000017
								],
								[
									151.50078125,
									-24.012402343749997
								],
								[
									151.57539062500018,
									-24.03359375000005
								],
								[
									151.6909179687501,
									-24.038378906250045
								],
								[
									151.8316406250001,
									-24.122949218749966
								],
								[
									151.90273437500002,
									-24.200976562500045
								],
								[
									152.05537109375018,
									-24.494433593749974
								],
								[
									152.1298828125001,
									-24.597558593750023
								],
								[
									152.28203125,
									-24.69931640625005
								],
								[
									152.3531250000002,
									-24.732519531250063
								],
								[
									152.45634765625016,
									-24.80244140625001
								],
								[
									152.4931640625001,
									-24.904003906249926
								],
								[
									152.50205078125003,
									-24.963964843750063
								],
								[
									152.56328125,
									-25.07207031250006
								],
								[
									152.654296875,
									-25.201953125000045
								],
								[
									152.7891601562502,
									-25.27412109375001
								],
								[
									152.91347656250014,
									-25.432128906250043
								],
								[
									152.92050781250003,
									-25.688574218750063
								],
								[
									152.9849609375002,
									-25.81621093749996
								],
								[
									153.02822265625014,
									-25.87031249999997
								],
								[
									153.12548828124994,
									-25.922656249999974
								],
								[
									153.16494140625002,
									-25.964160156250074
								],
								[
									153.08417968750018,
									-26.30380859374999
								],
								[
									153.16210937499994,
									-26.982714843749932
								],
								[
									153.1167968750001,
									-27.194433593750077
								],
								[
									153.19794921875018,
									-27.404687499999923
								],
								[
									153.38574218749994,
									-27.768554687500057
								],
								[
									153.42841796875007,
									-27.897656250000068
								],
								[
									153.45488281250005,
									-28.048339843749957
								],
								[
									153.5756835937501,
									-28.24052734375003
								],
								[
									153.56914062500005,
									-28.53339843750001
								],
								[
									153.61689453125018,
									-28.67304687500004
								],
								[
									153.60458984375003,
									-28.854492187500057
								],
								[
									153.46220703125,
									-29.050195312500037
								],
								[
									153.34804687500002,
									-29.29042968750005
								],
								[
									153.34697265625016,
									-29.49658203125003
								],
								[
									153.27236328125014,
									-29.892480468750037
								],
								[
									153.223828125,
									-29.99863281249999
								],
								[
									153.18818359375007,
									-30.163867187500003
								],
								[
									153.03056640625,
									-30.563378906250037
								],
								[
									153.02373046875005,
									-30.720117187499994
								],
								[
									153.04785156249994,
									-30.90712890625008
								],
								[
									153.0215820312502,
									-31.086621093750054
								],
								[
									152.9822265625,
									-31.208789062500074
								],
								[
									152.9439453125002,
									-31.434863281249946
								],
								[
									152.78583984375007,
									-31.78632812500004
								],
								[
									152.55927734375018,
									-32.045703125000045
								],
								[
									152.54531249999997,
									-32.24306640625001
								],
								[
									152.5166015625001,
									-32.33017578124999
								],
								[
									152.47041015625018,
									-32.43906250000006
								],
								[
									152.33125000000018,
									-32.55751953125004
								],
								[
									152.24746093749997,
									-32.60869140624999
								],
								[
									152.21572265624997,
									-32.67812499999992
								],
								[
									152.13652343750005,
									-32.67812499999992
								],
								[
									152.13457031250016,
									-32.69990234375
								],
								[
									152.18808593750003,
									-32.721679687499915
								],
								[
									152.16425781250018,
									-32.75742187499999
								],
								[
									151.954296875,
									-32.820312500000014
								],
								[
									151.81289062499997,
									-32.90107421875004
								],
								[
									151.66835937500014,
									-33.09863281249997
								],
								[
									151.60771484375005,
									-33.20185546875004
								],
								[
									151.530078125,
									-33.30097656249998
								],
								[
									151.48378906250002,
									-33.34746093750003
								],
								[
									151.4633789062501,
									-33.39736328125008
								],
								[
									151.43203125000014,
									-33.52158203125006
								],
								[
									151.3575195312502,
									-33.5439453125
								],
								[
									151.2920898437502,
									-33.580957031249994
								],
								[
									151.32275390624994,
									-33.699316406250034
								],
								[
									151.28837890625016,
									-33.83486328125004
								],
								[
									151.2802734375001,
									-33.92666015625008
								],
								[
									151.24462890624994,
									-33.98505859375008
								],
								[
									151.20166015625,
									-33.96406250000007
								],
								[
									151.16787109375014,
									-33.97343750000002
								],
								[
									151.12480468750016,
									-34.00527343749994
								],
								[
									151.1912109375,
									-34.015234375000006
								],
								[
									151.23154296875003,
									-34.02968749999994
								],
								[
									151.08994140625003,
									-34.162499999999994
								],
								[
									150.96035156250014,
									-34.297070312500054
								],
								[
									150.92744140625018,
									-34.386621093749994
								],
								[
									150.87128906250018,
									-34.499121093750006
								],
								[
									150.8218750000001,
									-34.749218750000054
								],
								[
									150.7810546875,
									-34.89218750000005
								],
								[
									150.80917968750003,
									-34.99384765625007
								],
								[
									150.80458984375002,
									-35.01289062500004
								],
								[
									150.774609375,
									-35.02041015624998
								],
								[
									150.75605468750018,
									-35.00712890625002
								],
								[
									150.6973632812502,
									-35.041894531249994
								],
								[
									150.68095703125016,
									-35.07666015625007
								],
								[
									150.7056640625002,
									-35.11972656249996
								],
								[
									150.7221679687501,
									-35.134570312500045
								],
								[
									150.71464843750016,
									-35.15517578125008
								],
								[
									150.69033203125002,
									-35.17773437500006
								],
								[
									150.63447265625018,
									-35.17763671875004
								],
								[
									150.5674804687502,
									-35.21425781250004
								],
								[
									150.37412109375003,
									-35.58417968750008
								],
								[
									150.29218750000018,
									-35.68232421875
								],
								[
									150.19531249999994,
									-35.83359374999999
								],
								[
									150.15849609375,
									-35.97060546874994
								],
								[
									150.1289062500001,
									-36.120410156250074
								],
								[
									150.0953125000002,
									-36.372656250000034
								],
								[
									150.06279296875016,
									-36.550390625000006
								],
								[
									149.98818359375014,
									-36.72275390625005
								],
								[
									149.96025390625005,
									-36.8455078125
								],
								[
									149.95058593750002,
									-37.080273437500054
								],
								[
									149.9863281250001,
									-37.258398437500006
								],
								[
									149.96289062499994,
									-37.353027343750014
								],
								[
									149.96230468750002,
									-37.44384765625004
								],
								[
									149.9327148437502,
									-37.52851562500007
								],
								[
									149.80937500000005,
									-37.5478515625
								],
								[
									149.7089843750001,
									-37.616992187499974
								],
								[
									149.5654296875,
									-37.72998046875007
								],
								[
									149.48085937499997,
									-37.771191406250026
								],
								[
									149.2984375000002,
									-37.80214843750004
								],
								[
									148.9439453125002,
									-37.788476562499994
								],
								[
									148.2625,
									-37.83066406250006
								],
								[
									148.13066406250016,
									-37.856054687500006
								],
								[
									147.87675781250005,
									-37.934179687499935
								],
								[
									147.63144531250003,
									-38.055664062499986
								],
								[
									147.39560546875003,
									-38.21914062499998
								],
								[
									146.85683593749997,
									-38.66347656250001
								],
								[
									146.43574218750018,
									-38.71181640624991
								],
								[
									146.35625000000016,
									-38.71181640624991
								],
								[
									146.29257812500003,
									-38.69980468749995
								],
								[
									146.21748046875,
									-38.727441406250065
								],
								[
									146.21621093750014,
									-38.78271484375004
								],
								[
									146.28554687500014,
									-38.84023437500004
								],
								[
									146.33662109375007,
									-38.894238281250026
								],
								[
									146.42695312500018,
									-38.81962890625002
								],
								[
									146.46660156250016,
									-38.84033203125006
								],
								[
									146.481640625,
									-38.97792968750002
								],
								[
									146.48378906250002,
									-39.065039062500006
								],
								[
									146.4566406250001,
									-39.11230468750004
								],
								[
									146.4000000000002,
									-39.14550781250006
								],
								[
									146.34003906250007,
									-39.123828125
								],
								[
									146.3320312500001,
									-39.076660156249986
								],
								[
									146.25429687499997,
									-38.964453125000034
								],
								[
									146.15839843750018,
									-38.86572265625
								],
								[
									146.0699218750001,
									-38.83408203124995
								],
								[
									146.0181640625002,
									-38.86708984374992
								],
								[
									145.93535156250005,
									-38.90175781250005
								],
								[
									145.86552734375,
									-38.775976562500006
								],
								[
									145.79082031250016,
									-38.666992187500014
								],
								[
									145.69189453125,
									-38.65566406250001
								],
								[
									145.60634765625014,
									-38.65683593750008
								],
								[
									145.53535156250007,
									-38.60966796875006
								],
								[
									145.397265625,
									-38.53535156250001
								],
								[
									145.42421874999997,
									-38.47734375
								],
								[
									145.46279296875014,
									-38.41630859375
								],
								[
									145.5421875,
									-38.393847656250045
								],
								[
									145.51835937500016,
									-38.31142578125005
								],
								[
									145.47578125000018,
									-38.24375000000002
								],
								[
									145.36640625,
									-38.22568359374999
								],
								[
									145.29277343750005,
									-38.23759765624993
								],
								[
									145.24892578124997,
									-38.29121093750001
								],
								[
									145.19121093750005,
									-38.38359375
								],
								[
									144.9595703125002,
									-38.500781250000074
								],
								[
									144.84726562500003,
									-38.43632812500009
								],
								[
									144.71777343749994,
									-38.34033203125007
								],
								[
									144.7802734375,
									-38.34736328125008
								],
								[
									144.91142578125016,
									-38.344042968749946
								],
								[
									145.0201171875001,
									-38.25839843750008
								],
								[
									145.06699218750003,
									-38.20488281250002
								],
								[
									145.11992187500016,
									-38.09130859374997
								],
								[
									145.04960937500016,
									-38.01093749999994
								],
								[
									144.9848632812501,
									-37.95224609375006
								],
								[
									144.89130859375,
									-37.89980468750004
								],
								[
									144.53847656250002,
									-38.07714843749993
								],
								[
									144.4653320312501,
									-38.10253906250003
								],
								[
									144.3955078125001,
									-38.136914062500026
								],
								[
									144.51777343750007,
									-38.166406249999994
								],
								[
									144.5894531250002,
									-38.15761718749998
								],
								[
									144.66523437500018,
									-38.209960937499986
								],
								[
									144.54365234375018,
									-38.28408203124998
								],
								[
									144.4478515625002,
									-38.30371093750007
								],
								[
									144.3287109375001,
									-38.34824218749999
								],
								[
									144.1015625,
									-38.46230468750005
								],
								[
									143.81171875000018,
									-38.698828125000006
								],
								[
									143.68671875,
									-38.76689453125002
								],
								[
									143.53896484375014,
									-38.820898437500006
								],
								[
									143.33847656250003,
									-38.75781250000004
								],
								[
									143.22646484374997,
									-38.74316406250007
								],
								[
									143.0826171875001,
									-38.64589843749998
								],
								[
									142.84023437499997,
									-38.580859375000045
								],
								[
									142.61210937500016,
									-38.451660156250014
								],
								[
									142.455859375,
									-38.386328125000034
								],
								[
									142.34453125000016,
									-38.37216796874999
								],
								[
									142.18769531250018,
									-38.39941406250003
								],
								[
									141.92470703124997,
									-38.283789062500006
								],
								[
									141.72499999999997,
									-38.271386718750065
								],
								[
									141.59394531250018,
									-38.38779296874998
								],
								[
									141.4917968750001,
									-38.37978515625002
								],
								[
									141.42421874999997,
									-38.3634765625
								],
								[
									141.2138671875001,
									-38.17197265625006
								],
								[
									141.01093750000018,
									-38.07695312500006
								],
								[
									140.62724609375016,
									-38.02841796874995
								],
								[
									140.39042968750016,
									-37.89667968750001
								],
								[
									140.21210937500007,
									-37.642187500000034
								],
								[
									139.87480468750016,
									-37.35205078125
								],
								[
									139.7842773437502,
									-37.245800781250026
								],
								[
									139.7422851562501,
									-37.141699218750034
								],
								[
									139.73847656250018,
									-37.0595703125
								],
								[
									139.78388671875,
									-36.90263671875
								],
								[
									139.84658203125002,
									-36.74804687500004
								],
								[
									139.85732421874997,
									-36.66210937500003
								],
								[
									139.7290039062501,
									-36.371386718750045
								],
								[
									139.54873046874997,
									-36.09667968750004
								],
								[
									139.4659179687501,
									-36.010351562500034
								],
								[
									139.244921875,
									-35.827343750000054
								],
								[
									139.03769531250003,
									-35.68925781249999
								],
								[
									138.98505859375018,
									-35.61757812500004
								],
								[
									138.96894531250018,
									-35.58076171875
								],
								[
									139.06689453124994,
									-35.598437500000045
								],
								[
									139.1125,
									-35.542285156250074
								],
								[
									139.17802734375016,
									-35.52304687500006
								],
								[
									139.2305664062502,
									-35.597656249999986
								],
								[
									139.28945312500002,
									-35.61132812499993
								],
								[
									139.2920898437502,
									-35.48593749999996
								],
								[
									139.32509765624997,
									-35.426660156249966
								],
								[
									139.3025390625,
									-35.3994140625
								],
								[
									139.28251953125005,
									-35.375390624999994
								],
								[
									139.19277343750014,
									-35.347265625000034
								],
								[
									139.0937500000001,
									-35.38955078125004
								],
								[
									139.0176757812501,
									-35.44326171875005
								],
								[
									138.91523437500018,
									-35.48886718750002
								],
								[
									138.87529296875,
									-35.536816406250026
								],
								[
									138.77099609375,
									-35.53837890624999
								],
								[
									138.7296875,
									-35.55078125000003
								],
								[
									138.52187500000014,
									-35.64238281250003
								],
								[
									138.3892578125002,
									-35.64472656249998
								],
								[
									138.18437500000005,
									-35.61269531250002
								],
								[
									138.25214843750018,
									-35.48652343750008
								],
								[
									138.33291015625002,
									-35.41171875000002
								],
								[
									138.39980468750014,
									-35.32578125000002
								],
								[
									138.51113281249997,
									-35.024414062499986
								],
								[
									138.48994140625,
									-34.76357421875005
								],
								[
									138.43623046875018,
									-34.65625000000004
								],
								[
									138.26435546875018,
									-34.44033203125001
								],
								[
									138.18623046875007,
									-34.30722656249999
								],
								[
									138.08925781250002,
									-34.169824218750065
								],
								[
									138.04130859375,
									-34.24980468750002
								],
								[
									138.01230468750003,
									-34.334082031250034
								],
								[
									137.91923828125,
									-34.456054687500014
								],
								[
									137.87412109375003,
									-34.72744140624998
								],
								[
									137.69169921875005,
									-35.14296875000008
								],
								[
									137.56640625,
									-35.14804687500005
								],
								[
									137.4595703125001,
									-35.131347656250014
								],
								[
									137.27236328125014,
									-35.17871093750007
								],
								[
									137.14443359375002,
									-35.236425781249935
								],
								[
									137.0298828125002,
									-35.236523437499955
								],
								[
									136.9666015625,
									-35.25488281250004
								],
								[
									136.88359375000016,
									-35.23974609375007
								],
								[
									137.0142578125002,
									-34.91582031249999
								],
								[
									137.1284179687501,
									-34.92470703125002
								],
								[
									137.2520507812501,
									-34.911523437499994
								],
								[
									137.3083984375,
									-34.91699218750004
								],
								[
									137.39101562500014,
									-34.91328125
								],
								[
									137.45429687500007,
									-34.76445312500006
								],
								[
									137.49296875000005,
									-34.59775390625002
								],
								[
									137.46855468750005,
									-34.49023437499997
								],
								[
									137.45898437499994,
									-34.37890625000003
								],
								[
									137.48359375000018,
									-34.25214843750004
								],
								[
									137.49384765625,
									-34.16113281250007
								],
								[
									137.65039062499994,
									-33.85908203125
								],
								[
									137.7808593750001,
									-33.703125000000014
								],
								[
									137.93183593750018,
									-33.57910156250006
								],
								[
									137.91396484375002,
									-33.461328124999966
								],
								[
									137.866015625,
									-33.31406250000006
								],
								[
									137.85234375000016,
									-33.20078124999999
								],
								[
									137.92431640625,
									-33.16513671875002
								],
								[
									137.99257812500014,
									-33.09423828125004
								],
								[
									137.9131835937502,
									-32.770703124999955
								],
								[
									137.86308593750005,
									-32.673730468749994
								],
								[
									137.7832031250001,
									-32.57812500000006
								],
								[
									137.7818359375002,
									-32.70195312500006
								],
								[
									137.79091796874997,
									-32.8232421875
								],
								[
									137.68017578125,
									-32.978027343749915
								],
								[
									137.53623046875003,
									-33.08916015624999
								],
								[
									137.44228515625002,
									-33.193554687500026
								],
								[
									137.35419921875018,
									-33.430175781250014
								],
								[
									137.2373046875001,
									-33.62949218750002
								],
								[
									137.13027343750014,
									-33.703027343749994
								],
								[
									137.03447265625016,
									-33.71953124999999
								],
								[
									136.9365234375001,
									-33.75019531250001
								],
								[
									136.78349609375,
									-33.82968750000005
								],
								[
									136.63554687500016,
									-33.89658203124999
								],
								[
									136.5258789062501,
									-33.984179687500074
								],
								[
									136.4306640625,
									-34.02998046875
								],
								[
									136.12109374999994,
									-34.42871093750004
								],
								[
									135.9796875,
									-34.56191406250001
								],
								[
									135.95058593750014,
									-34.61572265624996
								],
								[
									135.89101562499997,
									-34.66093749999993
								],
								[
									135.90263671875016,
									-34.723828124999955
								],
								[
									135.95058593750014,
									-34.766796875
								],
								[
									135.99853515624994,
									-34.943749999999994
								],
								[
									135.96972656249994,
									-34.98183593749994
								],
								[
									135.919140625,
									-34.96191406250004
								],
								[
									135.79238281249997,
									-34.86328124999994
								],
								[
									135.71250000000003,
									-34.89921875000006
								],
								[
									135.64755859375003,
									-34.93964843750004
								],
								[
									135.48085937500002,
									-34.75820312500002
								],
								[
									135.41171875000003,
									-34.71552734375004
								],
								[
									135.32421875,
									-34.64267578125002
								],
								[
									135.2306640625,
									-34.57978515625
								],
								[
									135.19082031249997,
									-34.572656250000065
								],
								[
									135.12304687499994,
									-34.58574218750006
								],
								[
									135.12958984375,
									-34.536523437500065
								],
								[
									135.17597656250018,
									-34.496582031250014
								],
								[
									135.21679687499994,
									-34.487304687499986
								],
								[
									135.2924804687501,
									-34.545605468750054
								],
								[
									135.37871093750016,
									-34.59765625
								],
								[
									135.4273437500002,
									-34.601953124999994
								],
								[
									135.45000000000005,
									-34.5810546875
								],
								[
									135.36796875,
									-34.37558593750006
								],
								[
									135.31201171875,
									-34.19550781249997
								],
								[
									135.28632812500018,
									-34.14228515625004
								],
								[
									135.2189453125,
									-33.959765625000074
								],
								[
									135.18544921875014,
									-33.906738281250014
								],
								[
									135.04208984375003,
									-33.77773437500002
								],
								[
									134.8887695312502,
									-33.62636718750001
								],
								[
									134.84667968749994,
									-33.44462890625002
								],
								[
									134.791015625,
									-33.32832031250004
								],
								[
									134.71904296875016,
									-33.25517578125006
								],
								[
									134.60771484375005,
									-33.19013671875004
								],
								[
									134.30126953124994,
									-33.1650390625
								],
								[
									134.17353515625,
									-32.979101562500034
								],
								[
									134.10039062500016,
									-32.74863281250008
								],
								[
									134.15839843750007,
									-32.733398437499986
								],
								[
									134.22714843750003,
									-32.73056640624995
								],
								[
									134.24921875000018,
									-32.65869140625004
								],
								[
									134.23417968750016,
									-32.54853515625007
								],
								[
									133.9301757812501,
									-32.411718750000006
								],
								[
									133.7867187500002,
									-32.26884765625003
								],
								[
									133.66533203125016,
									-32.20722656250008
								],
								[
									133.5513671875002,
									-32.18291015624993
								],
								[
									133.40058593750007,
									-32.1884765625
								],
								[
									133.212109375,
									-32.18378906250001
								],
								[
									132.7574218750002,
									-31.95624999999994
								],
								[
									132.64863281250007,
									-31.94931640624995
								],
								[
									132.32363281250002,
									-32.02001953125004
								],
								[
									132.21464843750005,
									-32.00712890625
								],
								[
									131.7211914062501,
									-31.696289062499915
								],
								[
									131.3931640625001,
									-31.54853515625001
								],
								[
									131.28496093750016,
									-31.520996093749986
								],
								[
									131.14365234375003,
									-31.495703125000077
								],
								[
									131.0292968750001,
									-31.531835937500063
								],
								[
									130.94814453125002,
									-31.56582031249998
								],
								[
									130.78300781250005,
									-31.604003906249943
								],
								[
									130.12978515625002,
									-31.579101562500014
								],
								[
									129.56884765624994,
									-31.62724609375006
								],
								[
									129.18769531250018,
									-31.659960937499974
								],
								[
									128.94619140625002,
									-31.702636718750043
								],
								[
									128.54609375,
									-31.8876953125
								],
								[
									128.06767578125,
									-32.06650390625002
								],
								[
									127.67802734375005,
									-32.15126953125005
								],
								[
									127.31982421874994,
									-32.26406250000002
								],
								[
									127.08408203125009,
									-32.29687500000006
								],
								[
									126.779296875,
									-32.31093750000008
								],
								[
									126.13652343750005,
									-32.25683593750007
								],
								[
									125.91718750000001,
									-32.29697265625008
								],
								[
									125.5674804687502,
									-32.505859375
								],
								[
									125.46367187499999,
									-32.55654296875002
								],
								[
									125.26660156250011,
									-32.614453125
								],
								[
									124.75878906250011,
									-32.88271484375004
								],
								[
									124.52460937500018,
									-32.94013671875001
								],
								[
									124.37324218750018,
									-32.958398437499994
								],
								[
									124.24375000000009,
									-33.015234375000034
								],
								[
									124.12607421875009,
									-33.129394531250014
								],
								[
									123.96718750000014,
									-33.4462890625
								],
								[
									123.86835937500018,
									-33.596386718750026
								],
								[
									123.650390625,
									-33.83632812499998
								],
								[
									123.50683593749994,
									-33.91621093750008
								],
								[
									123.36542968750001,
									-33.905371093750006
								],
								[
									123.2076171875002,
									-33.98828125000003
								],
								[
									123.06757812500018,
									-33.900585937499926
								],
								[
									122.9556640625002,
									-33.88378906250006
								],
								[
									122.77753906250018,
									-33.89082031250007
								],
								[
									122.15097656250003,
									-33.991796875000034
								],
								[
									122.06113281250003,
									-33.87441406249992
								],
								[
									121.9463867187502,
									-33.856738281250045
								],
								[
									121.72968750000001,
									-33.86249999999998
								],
								[
									121.40507812500016,
									-33.82675781250006
								],
								[
									120.8145507812502,
									-33.8712890625
								],
								[
									120.53056640625016,
									-33.91972656249992
								],
								[
									120.41835937500014,
									-33.96308593750004
								],
								[
									120.20937500000002,
									-33.93544921874992
								],
								[
									119.8541015625002,
									-33.974707031250006
								],
								[
									119.7291015625002,
									-34.04150390625003
								],
								[
									119.63515624999997,
									-34.101171874999935
								],
								[
									119.45058593750014,
									-34.36826171874999
								],
								[
									119.2476562500002,
									-34.45644531250001
								],
								[
									119.08134765625016,
									-34.45937500000008
								],
								[
									118.89531250000016,
									-34.479882812499994
								],
								[
									118.5201171875002,
									-34.73710937499999
								],
								[
									118.13554687499999,
									-34.98662109375002
								],
								[
									118.0064453125002,
									-35.01328124999995
								],
								[
									117.86308593749999,
									-35.05498046874992
								],
								[
									117.67539062500003,
									-35.07490234375007
								],
								[
									117.58193359375014,
									-35.097753906250006
								],
								[
									117.14394531249997,
									-35.033691406250014
								],
								[
									116.86542968750018,
									-35.02656250000007
								],
								[
									116.5171875000002,
									-34.987890625000006
								],
								[
									116.21708984375016,
									-34.865820312500006
								],
								[
									115.98671875000014,
									-34.79501953125006
								],
								[
									115.72626953125018,
									-34.52607421875007
								],
								[
									115.5650390625002,
									-34.425781249999986
								],
								[
									115.27763671875016,
									-34.303906250000026
								],
								[
									115.19482421875,
									-34.308496093750065
								],
								[
									115.12792968749994,
									-34.34179687499993
								],
								[
									115.00878906250011,
									-34.255859375
								],
								[
									115.00566406249999,
									-34.145117187500006
								],
								[
									114.97343749999999,
									-34.05117187500005
								],
								[
									114.9756835937502,
									-33.80419921875
								],
								[
									114.99384765625018,
									-33.515332031249955
								],
								[
									115.09892578125016,
									-33.58027343750004
								],
								[
									115.18164062499994,
									-33.64345703125002
								],
								[
									115.35878906249997,
									-33.63994140625002
								],
								[
									115.51533203125018,
									-33.53134765625002
								],
								[
									115.60449218749994,
									-33.37226562499994
								],
								[
									115.68300781250014,
									-33.192871093749986
								],
								[
									115.6708984375,
									-33.002148437500026
								],
								[
									115.61855468749997,
									-32.66699218750004
								],
								[
									115.654296875,
									-32.59658203125001
								],
								[
									115.70791015624997,
									-32.567968750000034
								],
								[
									115.72539062500016,
									-32.40107421874997
								],
								[
									115.73808593749999,
									-31.88789062500004
								],
								[
									115.69843750000018,
									-31.694531250000082
								],
								[
									115.45458984374994,
									-31.30253906249999
								],
								[
									115.29433593750002,
									-30.961816406250023
								],
								[
									115.17685546875003,
									-30.808007812500037
								],
								[
									115.07792968750016,
									-30.56044921875005
								],
								[
									114.99453125000014,
									-30.21621093750001
								],
								[
									114.96884765625003,
									-30.042285156250003
								],
								[
									114.94208984375018,
									-29.721582031250037
								],
								[
									114.97138671875001,
									-29.53974609375004
								],
								[
									114.958984375,
									-29.433593749999986
								],
								[
									114.85683593750014,
									-29.142968750000023
								],
								[
									114.62841796874994,
									-28.871777343750026
								],
								[
									114.59062499999999,
									-28.771679687500054
								],
								[
									114.59179687499994,
									-28.666210937500068
								],
								[
									114.53740234375016,
									-28.542871093750065
								],
								[
									114.35351562500011,
									-28.294921875
								],
								[
									114.1651367187502,
									-28.08066406250005
								],
								[
									114.13349609375001,
									-27.97646484375005
								],
								[
									114.09843749999999,
									-27.544238281249932
								],
								[
									114.02812500000016,
									-27.34726562499995
								],
								[
									113.70937500000014,
									-26.84775390625005
								],
								[
									113.33300781250011,
									-26.417382812500037
								],
								[
									113.23105468750003,
									-26.241406250000068
								],
								[
									113.18476562500001,
									-26.18222656249992
								],
								[
									113.21074218750016,
									-26.174218750000065
								],
								[
									113.25312500000018,
									-26.197265625000043
								],
								[
									113.30009765625016,
									-26.240234375000014
								],
								[
									113.3232421875,
									-26.24384765625004
								],
								[
									113.34531250000003,
									-26.208300781250074
								],
								[
									113.34287109375009,
									-26.12607421875002
								],
								[
									113.3560546875002,
									-26.08046875000005
								],
								[
									113.38896484375016,
									-26.105566406249935
								],
								[
									113.42744140625018,
									-26.198046874999946
								],
								[
									113.54658203125001,
									-26.436718750000068
								],
								[
									113.58164062500003,
									-26.558105468750014
								],
								[
									113.73369140625005,
									-26.59511718750001
								],
								[
									113.78037109375003,
									-26.563281250000003
								],
								[
									113.83642578125011,
									-26.50058593750002
								],
								[
									113.85283203125016,
									-26.332128906250077
								],
								[
									113.77578124999997,
									-26.25595703125002
								],
								[
									113.70644531249997,
									-26.2236328125
								],
								[
									113.58906250000007,
									-26.098632812499943
								],
								[
									113.51337890625018,
									-25.898339843749994
								],
								[
									113.39531250000005,
									-25.71328124999995
								],
								[
									113.39736328124997,
									-25.647167968749983
								],
								[
									113.45136718750018,
									-25.599121093750043
								],
								[
									113.53945312499997,
									-25.625195312500026
								],
								[
									113.6211914062502,
									-25.73164062500004
								],
								[
									113.71308593750018,
									-25.830761718750082
								],
								[
									113.6978515625002,
									-26.00419921875006
								],
								[
									113.68359374999994,
									-26.051660156249966
								],
								[
									113.69169921874999,
									-26.09169921874995
								],
								[
									113.72373046875003,
									-26.129785156250065
								],
								[
									113.76582031250018,
									-26.159765624999963
								],
								[
									113.81181640625016,
									-26.115820312500063
								],
								[
									113.85390625000002,
									-26.014453125000017
								],
								[
									113.8798828125,
									-26.027636718750045
								],
								[
									113.94238281250011,
									-26.258691406250037
								],
								[
									113.99199218750016,
									-26.32148437500004
								],
								[
									114.09033203124994,
									-26.393652343750006
								],
								[
									114.17597656250018,
									-26.337499999999935
								],
								[
									114.21572265625002,
									-26.289453124999994
								],
								[
									114.20332031250007,
									-26.12636718750008
								],
								[
									114.22851562500011,
									-25.96875000000003
								],
								[
									114.21425781249997,
									-25.851562500000057
								],
								[
									113.99277343750003,
									-25.544824218749994
								],
								[
									113.79238281250002,
									-25.165722656249955
								],
								[
									113.67080078125002,
									-24.977050781250057
								],
								[
									113.56923828125002,
									-24.69296874999992
								],
								[
									113.5035156250002,
									-24.594628906250037
								],
								[
									113.41767578125007,
									-24.435644531250077
								],
								[
									113.41298828124997,
									-24.25400390625002
								],
								[
									113.42128906249997,
									-24.13232421875
								],
								[
									113.4898437500002,
									-23.869628906250043
								],
								[
									113.55292968750018,
									-23.732812500000065
								],
								[
									113.75703125000018,
									-23.418164062500082
								],
								[
									113.76699218749997,
									-23.28251953124999
								],
								[
									113.76484375000018,
									-23.18046875000006
								],
								[
									113.794921875,
									-23.023632812499997
								],
								[
									113.79511718750001,
									-22.914550781249986
								],
								[
									113.76787109375016,
									-22.81289062500005
								],
								[
									113.68281250000007,
									-22.63779296874999
								],
								[
									113.7950195312502,
									-22.33212890624999
								],
								[
									113.95839843749997,
									-21.93916015625004
								],
								[
									114.02285156250014,
									-21.881445312500006
								],
								[
									114.12392578125014,
									-21.828613281249986
								],
								[
									114.14257812500011,
									-21.90976562499992
								],
								[
									114.09277343750011,
									-22.181347656249997
								],
								[
									114.16386718749999,
									-22.323339843749977
								],
								[
									114.14160156250011,
									-22.48310546875001
								],
								[
									114.20517578125009,
									-22.455859374999974
								],
								[
									114.30351562500005,
									-22.425390625000063
								],
								[
									114.37773437500016,
									-22.341503906250026
								],
								[
									114.4169921875,
									-22.261035156250074
								],
								[
									114.60283203124999,
									-21.94218750000003
								],
								[
									114.70927734374999,
									-21.823437499999997
								],
								[
									114.85908203125007,
									-21.735937500000034
								],
								[
									115.16171875000009,
									-21.630566406250054
								],
								[
									115.4561523437502,
									-21.491699218750014
								],
								[
									115.59609375000014,
									-21.358105468750054
								],
								[
									115.77148437499994,
									-21.242285156250006
								],
								[
									115.89355468749994,
									-21.11669921875
								],
								[
									116.01093750000018,
									-21.03037109374999
								],
								[
									116.60585937500014,
									-20.71337890625007
								],
								[
									116.70673828125018,
									-20.653808593750014
								],
								[
									116.83632812500002,
									-20.647070312500063
								],
								[
									116.99531250000007,
									-20.65761718750008
								],
								[
									117.13906250000014,
									-20.64091796875006
								],
								[
									117.29277343749999,
									-20.71308593750001
								],
								[
									117.40625000000011,
									-20.72119140625007
								],
								[
									117.68388671874999,
									-20.642773437500082
								],
								[
									117.83232421875016,
									-20.57255859374999
								],
								[
									118.08730468750014,
									-20.419042968749977
								],
								[
									118.19921875000011,
									-20.375195312499926
								],
								[
									118.45830078125005,
									-20.326660156249986
								],
								[
									118.75146484375,
									-20.26191406249994
								],
								[
									119.10449218749994,
									-19.995312499999983
								],
								[
									119.35878906250002,
									-20.012304687500063
								],
								[
									119.58593750000011,
									-20.038281250000026
								],
								[
									119.76777343750018,
									-19.958398437499923
								],
								[
									120.19628906250011,
									-19.909472656250074
								],
								[
									120.43369140625003,
									-19.84199218750001
								],
								[
									120.87841796874994,
									-19.665039062500014
								],
								[
									120.99794921874997,
									-19.604394531249923
								],
								[
									121.17978515625009,
									-19.477929687499994
								],
								[
									121.33769531249999,
									-19.31992187500005
								],
								[
									121.49355468750014,
									-19.106445312499986
								],
								[
									121.58945312500003,
									-18.915136718750006
								],
								[
									121.63066406249999,
									-18.81660156250001
								],
								[
									121.72197265625016,
									-18.659960937500074
								],
								[
									121.78486328125018,
									-18.53593750000003
								],
								[
									121.83378906249999,
									-18.477050781250014
								],
								[
									122.00625000000014,
									-18.39365234374999
								],
								[
									122.26210937500014,
									-18.159082031249994
								],
								[
									122.34541015625007,
									-18.111914062499977
								],
								[
									122.3609375000002,
									-18.036914062499974
								],
								[
									122.30576171875003,
									-17.994921874999946
								],
								[
									122.23740234375009,
									-17.968554687500074
								],
								[
									122.19130859375002,
									-17.720312500000034
								],
								[
									122.14746093749994,
									-17.549023437500054
								],
								[
									122.14316406250003,
									-17.428417968749997
								],
								[
									122.16025390625009,
									-17.313671875000068
								],
								[
									122.26093750000018,
									-17.135742187500057
								],
								[
									122.33271484375001,
									-17.05937500000003
								],
								[
									122.43203125000014,
									-16.970410156250026
								],
								[
									122.52255859375009,
									-16.942871093750014
								],
								[
									122.59794921875016,
									-16.864941406249955
								],
								[
									122.72041015625007,
									-16.78769531250002
								],
								[
									122.7720703125002,
									-16.71015625000004
								],
								[
									122.84804687500014,
									-16.552441406250054
								],
								[
									122.91679687499999,
									-16.432617187499986
								],
								[
									122.970703125,
									-16.43681640625003
								],
								[
									123.07441406250007,
									-16.71533203125003
								],
								[
									123.14208984375,
									-16.863085937499932
								],
								[
									123.26591796874999,
									-17.036816406250054
								],
								[
									123.38320312500002,
									-17.292773437500074
								],
								[
									123.47880859375005,
									-17.409960937500045
								],
								[
									123.52519531250016,
									-17.48574218749995
								],
								[
									123.56308593750003,
									-17.52089843750001
								],
								[
									123.57148437500018,
									-17.47226562500005
								],
								[
									123.56181640625016,
									-17.41542968750001
								],
								[
									123.60791015624994,
									-17.219921875000054
								],
								[
									123.58632812499997,
									-17.082714843750082
								],
								[
									123.59355468750016,
									-17.030371093750077
								],
								[
									123.61767578125,
									-17.00830078125003
								],
								[
									123.66406250000011,
									-17.023242187500045
								],
								[
									123.75380859375002,
									-17.09980468750001
								],
								[
									123.79902343750018,
									-17.127148437500082
								],
								[
									123.83105468750011,
									-17.120800781250026
								],
								[
									123.82949218749997,
									-16.996875000000003
								],
								[
									123.87441406249997,
									-16.918652343750054
								],
								[
									123.85634765625014,
									-16.864746093749915
								],
								[
									123.77812500000016,
									-16.86777343749999
								],
								[
									123.74501953124997,
									-16.800976562500068
								],
								[
									123.68046875000016,
									-16.723632812499943
								],
								[
									123.60712890625007,
									-16.66806640624999
								],
								[
									123.51796875000002,
									-16.540722656249983
								],
								[
									123.49042968750018,
									-16.49072265625
								],
								[
									123.52509765625007,
									-16.467578125000003
								],
								[
									123.58134765625016,
									-16.47089843749997
								],
								[
									123.6259765625,
									-16.41630859375003
								],
								[
									123.646484375,
									-16.34306640625003
								],
								[
									123.60703125000003,
									-16.224023437500023
								],
								[
									123.64746093750011,
									-16.17988281250001
								],
								[
									123.72890625000002,
									-16.19248046874999
								],
								[
									123.85917968750016,
									-16.382324218750043
								],
								[
									123.91523437500001,
									-16.36357421875003
								],
								[
									123.96132812500002,
									-16.286914062500045
								],
								[
									124.04443359375,
									-16.264941406249932
								],
								[
									124.12978515625014,
									-16.278808593749915
								],
								[
									124.18603515624994,
									-16.333593750000063
								],
								[
									124.30039062500009,
									-16.388281250000006
								],
								[
									124.4527343750002,
									-16.382031249999983
								],
								[
									124.52998046875001,
									-16.395214843749997
								],
								[
									124.6923828125,
									-16.38613281250001
								],
								[
									124.77197265624994,
									-16.402636718749918
								],
								[
									124.75703125000001,
									-16.37333984374999
								],
								[
									124.66923828125016,
									-16.33876953125005
								],
								[
									124.5703125,
									-16.33183593750006
								],
								[
									124.45449218750014,
									-16.335253906250045
								],
								[
									124.40488281250003,
									-16.298925781250006
								],
								[
									124.38828125000003,
									-16.20302734375001
								],
								[
									124.41640624999997,
									-16.133496093750054
								],
								[
									124.43457031249994,
									-16.103808593750045
								],
								[
									124.50996093750007,
									-16.11630859375002
								],
								[
									124.57685546875018,
									-16.113671875000023
								],
								[
									124.58505859375009,
									-16.02011718750005
								],
								[
									124.60859375000018,
									-15.937500000000014
								],
								[
									124.6485351562502,
									-15.870214843750063
								],
								[
									124.64833984374997,
									-15.805468750000017
								],
								[
									124.60664062500001,
									-15.822656250000065
								],
								[
									124.50429687500014,
									-15.972460937500031
								],
								[
									124.45527343750018,
									-15.850585937500071
								],
								[
									124.38164062499999,
									-15.75820312500008
								],
								[
									124.39658203125003,
									-15.625878906250023
								],
								[
									124.4395507812502,
									-15.493554687500065
								],
								[
									124.50566406250016,
									-15.475390625000017
								],
								[
									124.5616210937502,
									-15.496289062500011
								],
								[
									124.64433593750016,
									-15.418847656250037
								],
								[
									124.69091796874994,
									-15.35966796875006
								],
								[
									124.68017578125,
									-15.311035156249929
								],
								[
									124.69257812500001,
									-15.273632812500026
								],
								[
									124.75048828125011,
									-15.285253906250006
								],
								[
									124.97207031250014,
									-15.404296875
								],
								[
									125.01640624999999,
									-15.466503906249983
								],
								[
									125.06298828125011,
									-15.442285156250023
								],
								[
									125.07792968750005,
									-15.374511718750071
								],
								[
									125.07294921875018,
									-15.30673828125002
								],
								[
									125.02402343750003,
									-15.316992187500077
								],
								[
									124.90917968750011,
									-15.310058593749986
								],
								[
									124.88271484375014,
									-15.271972656250043
								],
								[
									124.8926757812502,
									-15.240527343750031
								],
								[
									124.83906250000001,
									-15.160742187500034
								],
								[
									124.91416015625003,
									-15.109960937499991
								],
								[
									124.97871093750007,
									-15.106640625000026
								],
								[
									125.02333984375002,
									-15.071875000000048
								],
								[
									125.02402343750003,
									-15.024414062500057
								],
								[
									125.0381835937502,
									-15.004101562499926
								],
								[
									125.07294921875018,
									-15.032324218749991
								],
								[
									125.18867187500001,
									-15.045410156249986
								],
								[
									125.3023437500002,
									-15.106835937500065
								],
								[
									125.35566406250001,
									-15.119824218750054
								],
								[
									125.3755859375002,
									-15.08681640625008
								],
								[
									125.3837890625,
									-15.015625000000043
								],
								[
									125.24326171875003,
									-14.94453125000004
								],
								[
									125.23945312500018,
									-14.874609375000006
								],
								[
									125.18037109375001,
									-14.79404296875002
								],
								[
									125.17871093749994,
									-14.714746093749952
								],
								[
									125.26650390624997,
									-14.648437499999943
								],
								[
									125.28457031250014,
									-14.584082031249977
								],
								[
									125.33544921875011,
									-14.557910156249974
								],
								[
									125.43593750000014,
									-14.556835937500011
								],
								[
									125.50371093749999,
									-14.502246093750003
								],
								[
									125.57978515625001,
									-14.483203125000031
								],
								[
									125.59833984375018,
									-14.361621093750031
								],
								[
									125.59707031250002,
									-14.278124999999989
								],
								[
									125.62773437500005,
									-14.25664062500006
								],
								[
									125.70458984375,
									-14.291406250000037
								],
								[
									125.6812500000002,
									-14.387988281249989
								],
								[
									125.68095703125016,
									-14.480175781250026
								],
								[
									125.66162109375011,
									-14.52949218750004
								],
								[
									125.69052734375003,
									-14.525390625
								],
								[
									125.70839843750014,
									-14.5048828125
								],
								[
									125.73847656250001,
									-14.444335937499929
								],
								[
									125.81953125000001,
									-14.469140625000009
								],
								[
									125.83955078125001,
									-14.533886718750054
								],
								[
									125.85009765624994,
									-14.597265624999991
								],
								[
									125.89062499999994,
									-14.617968750000031
								],
								[
									125.94609375000016,
									-14.520410156250051
								],
								[
									126.02070312500018,
									-14.494531250000023
								],
								[
									126.01660156249994,
									-14.371289062499969
								],
								[
									126.04482421875002,
									-14.283007812500003
								],
								[
									126.05361328125014,
									-14.216699218749994
								],
								[
									126.10087890625016,
									-14.184375000000074
								],
								[
									126.11132812499994,
									-14.114062500000045
								],
								[
									126.07343750000018,
									-14.06552734375002
								],
								[
									126.05390625000018,
									-13.977246093749983
								],
								[
									126.11904296875014,
									-13.957714843750082
								],
								[
									126.18427734375018,
									-14.002050781250063
								],
								[
									126.22822265625018,
									-14.113378906250006
								],
								[
									126.25849609375001,
									-14.163574218749929
								],
								[
									126.298828125,
									-14.136230468750043
								],
								[
									126.32304687500005,
									-14.062109375000034
								],
								[
									126.40312499999999,
									-14.018945312499952
								],
								[
									126.482421875,
									-14.078906249999989
								],
								[
									126.56972656250002,
									-14.160937500000003
								],
								[
									126.67910156250002,
									-14.089355468749986
								],
								[
									126.78066406250002,
									-13.955175781250006
								],
								[
									126.76445312500016,
									-13.873046875000071
								],
								[
									126.77558593750001,
									-13.788476562500065
								],
								[
									126.90322265625002,
									-13.744140625
								],
								[
									127.00605468750018,
									-13.776757812499994
								],
								[
									127.09921875000003,
									-13.867382812499983
								],
								[
									127.2930664062502,
									-13.934765625000026
								],
								[
									127.45761718750009,
									-14.031445312500011
								],
								[
									127.53105468749999,
									-14.094628906249994
								],
								[
									127.67285156249994,
									-14.19511718749996
								],
								[
									127.76347656250005,
									-14.299414062500063
								],
								[
									127.88759765625002,
									-14.485156250000074
								],
								[
									128.18046875000016,
									-14.711621093750026
								],
								[
									128.1994140625,
									-14.751757812500031
								],
								[
									128.15986328125007,
									-14.827343750000054
								],
								[
									128.12441406250002,
									-14.924121093749974
								],
								[
									128.08046875000014,
									-15.087988281249963
								],
								[
									128.0694335937502,
									-15.329296874999997
								],
								[
									128.11171875000002,
									-15.312011718750028
								],
								[
									128.15546875,
									-15.225585937499929
								],
								[
									128.20175781250003,
									-15.243359374999997
								],
								[
									128.2546875,
									-15.29853515625004
								],
								[
									128.25898437500018,
									-15.24560546875
								],
								[
									128.22724609375018,
									-15.213574218749969
								],
								[
									128.17294921875003,
									-15.102246093750026
								],
								[
									128.175,
									-15.043164062500068
								],
								[
									128.21835937500003,
									-14.995703124999991
								],
								[
									128.28515625,
									-14.938867187500037
								],
								[
									128.35820312500005,
									-14.901660156250017
								],
								[
									128.40322265624997,
									-14.869140625000043
								],
								[
									128.40986328125018,
									-14.828906250000017
								],
								[
									128.47744140625002,
									-14.787988281249952
								],
								[
									128.57578125000003,
									-14.774511718750048
								],
								[
									128.63554687500016,
									-14.78095703124994
								],
								[
									129.0582031250002,
									-14.884375000000048
								],
								[
									129.1651367187502,
									-14.987597656250017
								],
								[
									129.17519531250014,
									-15.115039062500045
								],
								[
									129.21582031249994,
									-15.16025390625002
								],
								[
									129.2378906250002,
									-15.080175781250048
								],
								[
									129.23359375,
									-14.906054687500017
								],
								[
									129.2675781250001,
									-14.87148437500008
								],
								[
									129.38125000000002,
									-14.898437500000071
								],
								[
									129.45898437499994,
									-14.933203125000048
								],
								[
									129.56708984375,
									-15.047363281250028
								],
								[
									129.58769531250016,
									-15.10332031250006
								],
								[
									129.63476562499994,
									-15.13974609375002
								],
								[
									129.65029296875002,
									-15.08681640625008
								],
								[
									129.62822265625016,
									-15.011816406250077
								],
								[
									129.61269531250002,
									-14.925878906249977
								],
								[
									129.63710937500002,
									-14.850976562499994
								],
								[
									129.76347656250016,
									-14.845019531250017
								],
								[
									129.8487304687502,
									-14.828906250000017
								],
								[
									129.80839843750016,
									-14.799707031250023
								],
								[
									129.7535156250001,
									-14.789550781249915
								],
								[
									129.66298828125014,
									-14.72089843750004
								],
								[
									129.60468750000007,
									-14.64707031250002
								],
								[
									129.69863281250002,
									-14.575292968749963
								],
								[
									129.69794921875007,
									-14.557421875000045
								],
								[
									129.6079101562501,
									-14.559667968749977
								],
								[
									129.48388671874994,
									-14.489746093749943
								],
								[
									129.37871093750005,
									-14.392480468750023
								],
								[
									129.45917968750018,
									-14.213476562500048
								],
								[
									129.61962890625,
									-14.038378906250003
								],
								[
									129.70986328124997,
									-13.97998046875
								],
								[
									129.7183593750002,
									-13.920898437500043
								],
								[
									129.76171875,
									-13.811914062500051
								],
								[
									129.78925781250018,
									-13.71992187500004
								],
								[
									129.79716796875,
									-13.648437500000043
								],
								[
									129.8388671875,
									-13.57294921875004
								],
								[
									129.93789062499997,
									-13.501660156250082
								],
								[
									130.07265625000002,
									-13.476171875000034
								],
								[
									130.1359375,
									-13.448339843750048
								],
								[
									130.19931640625003,
									-13.382617187499989
								],
								[
									130.2597656250001,
									-13.302246093749957
								],
								[
									130.13496093750018,
									-13.1455078125
								],
								[
									130.14531250000016,
									-13.059179687499991
								],
								[
									130.16816406250018,
									-12.957421875000051
								],
								[
									130.31796875000003,
									-12.882910156250048
								],
								[
									130.39990234374994,
									-12.687890625000023
								],
								[
									130.4541992187502,
									-12.658593749999923
								],
								[
									130.5718750000002,
									-12.664355468750031
								],
								[
									130.61748046875016,
									-12.646875000000023
								],
								[
									130.60957031250007,
									-12.491308593749949
								],
								[
									130.62265625000003,
									-12.431054687499923
								],
								[
									130.67236328124994,
									-12.406933593749983
								],
								[
									130.73613281250016,
									-12.427734374999957
								],
								[
									130.77656250000007,
									-12.495312499999955
								],
								[
									130.86738281250018,
									-12.557812499999898
								],
								[
									130.89824218750016,
									-12.523632812499955
								],
								[
									130.88291015625003,
									-12.455078124999929
								],
								[
									130.87382812500016,
									-12.367187500000057
								],
								[
									130.95664062500003,
									-12.348242187499935
								],
								[
									131.0234375,
									-12.342871093749906
								],
								[
									131.030078125,
									-12.27109375000002
								],
								[
									131.01953125,
									-12.213867187499915
								],
								[
									131.045703125,
									-12.189648437499955
								],
								[
									131.21992187500007,
									-12.177929687499955
								],
								[
									131.2654296875,
									-12.119042968749952
								],
								[
									131.2916015625001,
									-12.067871093749915
								],
								[
									131.31376953125016,
									-12.09589843749994
								],
								[
									131.34208984375016,
									-12.21005859375002
								],
								[
									131.43828125000005,
									-12.276953124999977
								],
								[
									131.72626953125018,
									-12.278125000000031
								],
								[
									131.88798828125,
									-12.231933593749943
								],
								[
									131.95673828125007,
									-12.259277343749929
								],
								[
									132.0640625000001,
									-12.280761718749943
								],
								[
									132.18232421875018,
									-12.226953124999909
								],
								[
									132.25322265625016,
									-12.186035156249929
								],
								[
									132.3720703125001,
									-12.239160156249909
								],
								[
									132.41103515624997,
									-12.29511718749994
								],
								[
									132.44160156250018,
									-12.176367187499906
								],
								[
									132.510546875,
									-12.134863281249977
								],
								[
									132.5837890625,
									-12.110253906249937
								],
								[
									132.6763671875002,
									-12.130078125000068
								],
								[
									132.71279296874997,
									-12.123437499999966
								],
								[
									132.6304687500002,
									-12.035156249999915
								],
								[
									132.6352539062501,
									-11.954687499999949
								],
								[
									132.62988281249994,
									-11.835839843749895
								],
								[
									132.64472656250007,
									-11.727148437500048
								],
								[
									132.67421875000014,
									-11.649023437499949
								],
								[
									132.4751953125001,
									-11.491503906250003
								],
								[
									132.2779296875002,
									-11.467675781249952
								],
								[
									132.13359375000005,
									-11.500683593749926
								],
								[
									132.0728515625001,
									-11.474707031249963
								],
								[
									131.94462890625016,
									-11.348535156250009
								],
								[
									131.82246093750007,
									-11.30244140624994
								],
								[
									131.81181640625005,
									-11.271386718749923
								],
								[
									131.96152343750003,
									-11.180859374999955
								],
								[
									132.01855468749994,
									-11.19638671874992
								],
								[
									132.10576171875005,
									-11.281152343749966
								],
								[
									132.15546875000007,
									-11.311132812499935
								],
								[
									132.19775390624994,
									-11.304980468750017
								],
								[
									132.22500000000002,
									-11.238769531250028
								],
								[
									132.26269531249994,
									-11.204003906250051
								],
								[
									132.333984375,
									-11.223535156249952
								],
								[
									132.55732421875,
									-11.366894531249926
								],
								[
									132.68281250000018,
									-11.505566406250026
								],
								[
									132.74707031249994,
									-11.468945312500026
								],
								[
									132.85712890625018,
									-11.391113281249886
								],
								[
									132.9610351562502,
									-11.407324218749906
								],
								[
									133.02490234375,
									-11.45283203124994
								],
								[
									133.1143554687501,
									-11.621777343749983
								],
								[
									133.18525390625007,
									-11.705664062499935
								],
								[
									133.35615234375007,
									-11.728222656249912
								],
								[
									133.4431640625,
									-11.760351562500063
								],
								[
									133.53320312499994,
									-11.816210937499903
								],
								[
									133.65449218750018,
									-11.811328124999974
								],
								[
									133.90419921874997,
									-11.832031249999929
								],
								[
									134.13945312500005,
									-11.940136718749926
								],
								[
									134.23710937500005,
									-12.007714843750009
								],
								[
									134.35107421874994,
									-12.025781249999966
								],
								[
									134.41738281249997,
									-12.052734374999943
								],
								[
									134.53808593749994,
									-12.060839843749903
								],
								[
									134.73027343750005,
									-11.984374999999957
								],
								[
									134.8164062500001,
									-12.054687499999986
								],
								[
									134.85468750000018,
									-12.102539062499972
								],
								[
									135.02968750000014,
									-12.19374999999998
								],
								[
									135.21796875000018,
									-12.2216796874999
								],
								[
									135.35234375000005,
									-12.129199218749974
								],
								[
									135.54873046874997,
									-12.060644531249963
								],
								[
									135.68554687499994,
									-11.956152343749892
								],
								[
									135.78847656249997,
									-11.907031249999932
								],
								[
									135.88525390625,
									-11.821679687499952
								],
								[
									135.9224609375002,
									-11.825781249999977
								],
								[
									135.8435546875,
									-11.905468749999969
								],
								[
									135.8339843750001,
									-11.950683593749943
								],
								[
									135.89580078125,
									-11.969531250000045
								],
								[
									135.88945312500005,
									-11.992773437499892
								],
								[
									135.8042968750002,
									-12.054785156250006
								],
								[
									135.70253906250014,
									-12.151562499999912
								],
								[
									135.70439453125016,
									-12.20986328124998
								],
								[
									135.74394531250016,
									-12.2416992187499
								],
								[
									135.7908203125,
									-12.227539062500028
								],
								[
									135.857421875,
									-12.178515624999989
								],
								[
									135.93779296875005,
									-12.152148437499946
								],
								[
									136.00849609375,
									-12.191406249999957
								],
								[
									136.03144531250018,
									-12.330859374999946
								],
								[
									136.08183593750016,
									-12.422460937499949
								],
								[
									136.19267578125016,
									-12.435156250000048
								],
								[
									136.26064453124997,
									-12.433789062499955
								],
								[
									136.32851562500014,
									-12.305566406249937
								],
								[
									136.29189453125014,
									-12.196386718749906
								],
								[
									136.24990234375002,
									-12.17304687499994
								],
								[
									136.27011718750003,
									-12.131640625000031
								],
								[
									136.443359375,
									-11.951464843749918
								],
								[
									136.54023437500018,
									-11.957617187499935
								],
								[
									136.60976562500014,
									-12.133593749999903
								],
								[
									136.71943359375018,
									-12.226464843749895
								],
								[
									136.83642578124994,
									-12.219140624999923
								],
								[
									136.89746093749994,
									-12.243554687499923
								],
								[
									136.9474609375,
									-12.349902343749918
								],
								[
									136.53701171874997,
									-12.784277343749949
								],
								[
									136.51777343750007,
									-12.83281250000006
								],
								[
									136.57304687500005,
									-12.911621093749957
								],
								[
									136.5943359375002,
									-13.00380859375008
								],
								[
									136.46103515625003,
									-13.225195312500063
								],
								[
									136.41191406250016,
									-13.236132812499989
								],
								[
									136.36455078125,
									-13.176367187500063
								],
								[
									136.29414062500007,
									-13.13798828125006
								],
								[
									136.23232421874997,
									-13.164941406250051
								],
								[
									136.1661132812501,
									-13.181054687500037
								],
								[
									135.9273437500002,
									-13.30429687500002
								],
								[
									135.92919921874994,
									-13.62158203125
								],
								[
									135.98955078125,
									-13.810156250000048
								],
								[
									135.95449218750014,
									-13.934863281250045
								],
								[
									135.88339843750003,
									-14.153124999999932
								],
								[
									135.80634765625007,
									-14.234179687500003
								],
								[
									135.74453124999997,
									-14.286621093750028
								],
								[
									135.5388671875,
									-14.584960937500057
								],
								[
									135.47324218750003,
									-14.656640625000009
								],
								[
									135.40517578125014,
									-14.758203124999923
								],
								[
									135.42802734375,
									-14.855664062500054
								],
								[
									135.45332031250018,
									-14.923144531250031
								],
								[
									135.53076171874994,
									-15.000390625000051
								],
								[
									135.8326171875001,
									-15.16015625
								],
								[
									135.96953125,
									-15.27021484375004
								],
								[
									136.20537109375,
									-15.40341796874992
								],
								[
									136.25927734374994,
									-15.495214843750048
								],
								[
									136.29140625000014,
									-15.570117187500031
								],
								[
									136.46191406249994,
									-15.655273437500071
								],
								[
									136.58359375000003,
									-15.706542968750028
								],
								[
									136.6187500000002,
									-15.693359375000014
								],
								[
									136.64414062500003,
									-15.675585937499946
								],
								[
									136.67460937500005,
									-15.675390625000077
								],
								[
									136.70488281250016,
									-15.68525390625004
								],
								[
									136.70009765624997,
									-15.751953125000043
								],
								[
									136.68671875000018,
									-15.788476562500023
								],
								[
									136.69814453125014,
									-15.834960937499986
								],
								[
									136.78466796875,
									-15.894238281250082
								],
								[
									136.92265625000005,
									-15.89238281250006
								],
								[
									137.00214843750007,
									-15.878320312500037
								],
								[
									137.08984375,
									-15.94130859375008
								],
								[
									137.1689453125001,
									-15.98212890625004
								],
								[
									137.2993164062501,
									-16.066308593749966
								],
								[
									137.5263671875001,
									-16.167089843750063
								],
								[
									137.7037109375001,
									-16.23300781249999
								],
								[
									137.91289062500016,
									-16.476562500000057
								],
								[
									138.07158203125016,
									-16.61699218750006
								],
								[
									138.24501953125014,
									-16.718359374999935
								],
								[
									138.50566406250005,
									-16.789550781250043
								],
								[
									138.62568359375007,
									-16.77783203124997
								],
								[
									138.8203125000001,
									-16.860644531250045
								],
								[
									139.0098632812501,
									-16.899316406250023
								],
								[
									139.1103515625001,
									-17.014062500000037
								],
								[
									139.14453125,
									-17.10107421875
								],
								[
									139.15410156250016,
									-17.167773437500003
								],
								[
									139.24843750000002,
									-17.328613281249915
								],
								[
									139.44052734375003,
									-17.38056640625001
								],
								[
									139.68964843750018,
									-17.54072265625004
								],
								[
									139.8945312500001,
									-17.611328124999957
								],
								[
									139.94599609375018,
									-17.653613281250045
								],
								[
									140.03583984375,
									-17.702636718749986
								],
								[
									140.20966796875018,
									-17.70439453124999
								],
								[
									140.51113281250014,
									-17.624511718750057
								],
								[
									140.6484375000001,
									-17.543750000000045
								],
								[
									140.83046874999997,
									-17.414453124999994
								],
								[
									140.91582031250016,
									-17.192578125000082
								],
								[
									140.96601562500018,
									-17.01455078125005
								],
								[
									141.21914062500014,
									-16.646191406250054
								],
								[
									141.29140625000002,
									-16.46347656250005
								],
								[
									141.35566406250007,
									-16.22109375000005
								],
								[
									141.41191406250016,
									-16.069531250000082
								],
								[
									141.39316406250003,
									-15.90468750000008
								],
								[
									141.45156250000014,
									-15.605273437500003
								],
								[
									141.58144531250014,
									-15.195410156249991
								],
								[
									141.62548828124994,
									-15.056640624999972
								],
								[
									141.6035156250001,
									-14.852734374999997
								],
								[
									141.5229492187501,
									-14.470117187500023
								],
								[
									141.55898437499997,
									-14.337890624999915
								],
								[
									141.5943359375001,
									-14.152832031250043
								],
								[
									141.53544921875,
									-14.018652343750063
								],
								[
									141.4806640625,
									-13.9267578125
								],
								[
									141.47255859374997,
									-13.797558593749969
								],
								[
									141.5341796875001,
									-13.553808593750048
								],
								[
									141.58876953125002,
									-13.425097656250017
								],
								[
									141.64541015625002,
									-13.259082031250045
								],
								[
									141.61357421875,
									-12.943457031250048
								],
								[
									141.73457031250007,
									-12.833496093750028
								],
								[
									141.7822265625,
									-12.778710937500051
								],
								[
									141.87578125000016,
									-12.778222656250037
								],
								[
									141.92031249999997,
									-12.802929687500011
								],
								[
									141.92978515625003,
									-12.739843750000034
								],
								[
									141.89287109375016,
									-12.68134765624994
								],
								[
									141.87832031250014,
									-12.613281249999929
								],
								[
									141.8521484375002,
									-12.578710937499991
								],
								[
									141.7945312500002,
									-12.566601562499912
								],
								[
									141.74667968750003,
									-12.529394531250063
								],
								[
									141.6777343750001,
									-12.491406249999969
								],
								[
									141.6885742187502,
									-12.351074218749972
								],
								[
									141.8057617187501,
									-12.080078124999915
								],
								[
									141.87050781250014,
									-11.975585937499943
								],
								[
									141.91298828124997,
									-12.019238281249955
								],
								[
									141.9611328125,
									-12.054296874999906
								],
								[
									141.96777343749994,
									-11.976269531249997
								],
								[
									141.95156250000014,
									-11.896191406250026
								],
								[
									142.04052734374994,
									-11.63173828124998
								],
								[
									142.13896484375005,
									-11.273242187499946
								],
								[
									142.16835937499997,
									-10.946582031249918
								],
								[
									142.32646484375005,
									-10.884179687499909
								],
								[
									142.40683593750003,
									-10.802246093749915
								],
								[
									142.45644531250014,
									-10.707324218749946
								],
								[
									142.54482421875002,
									-10.707324218749946
								],
								[
									142.6050781250002,
									-10.748242187499926
								],
								[
									142.56542968749994,
									-10.819433593749949
								],
								[
									142.5527343750001,
									-10.874414062500051
								],
								[
									142.72304687500002,
									-11.010449218750054
								],
								[
									142.77968749999997,
									-11.115332031249935
								],
								[
									142.8033203125002,
									-11.213964843749949
								],
								[
									142.83681640624997,
									-11.30693359375006
								],
								[
									142.85292968749997,
									-11.432226562500006
								],
								[
									142.85058593749994,
									-11.632324218749915
								],
								[
									142.87255859375,
									-11.821386718750063
								],
								[
									142.93398437499997,
									-11.880761718749909
								],
								[
									142.98847656250018,
									-11.919042968750063
								],
								[
									143.06640624999994,
									-11.924121093750031
								],
								[
									143.17890625000007,
									-11.954492187499909
								]
							]
						],
						[
							[
								[
									142.27480468749997,
									-10.704785156249955
								],
								[
									142.19140624999994,
									-10.762011718749974
								],
								[
									142.1372070312501,
									-10.731933593749886
								],
								[
									142.1254882812501,
									-10.668457031250014
								],
								[
									142.13105468750018,
									-10.640625000000028
								],
								[
									142.19794921875007,
									-10.591992187500068
								],
								[
									142.27480468749997,
									-10.704785156249955
								]
							]
						],
						[
							[
								[
									142.3389648437501,
									-10.192187499999974
								],
								[
									142.2793945312502,
									-10.254199218749903
								],
								[
									142.21621093750014,
									-10.235644531249946
								],
								[
									142.1951171875,
									-10.199316406250006
								],
								[
									142.2187500000001,
									-10.149414062499972
								],
								[
									142.29873046874997,
									-10.140429687499918
								],
								[
									142.3389648437501,
									-10.192187499999974
								]
							]
						],
						[
							[
								[
									142.1675781250001,
									-10.154101562500031
								],
								[
									142.14199218750002,
									-10.181249999999963
								],
								[
									142.09765624999994,
									-10.121777343749926
								],
								[
									142.14882812499997,
									-10.051757812499972
								],
								[
									142.1919921875001,
									-10.085253906249946
								],
								[
									142.1675781250001,
									-10.154101562500031
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Australia and New Zealand",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "AUS",
					"su_a3": "AUS",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "AUS",
					"gu_a3": "AUS",
					"abbrev": "Auz.",
					"region_un": "Oceania",
					"adm0_a3_us": "AUS",
					"scalerank": 1,
					"pop_est": 21262641,
					"adm0_dif": 1,
					"un_a3": "036",
					"pop_year": -99,
					"gdp_md_est": 800200,
					"name": "Australia",
					"sovereignt": "Australia",
					"economy": "2. Developed region: nonG7",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Australia",
					"postal": "AU",
					"sov_a3": "AU1",
					"note_brk": "",
					"brk_a3": "AUS",
					"wb_a2": "AU",
					"brk_diff": 0,
					"admin": "Australia",
					"name_long": "Australia",
					"iso_a3": "AUS",
					"iso_a2": "AU",
					"adm0_a3_is": "AUS",
					"level": 2,
					"formal_en": "Commonwealth of Australia",
					"name_len": 9,
					"mapcolor7": 1,
					"long_len": 9,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "036",
					"homepart": 1,
					"subunit": "Australia",
					"name_alt": "",
					"brk_name": "Australia",
					"name_sort": "Australia",
					"continent": "Oceania",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								16.953125,
								48.59882812500007
							],
							[
								16.948828125000006,
								48.58857421875001
							],
							[
								16.943359375000057,
								48.550927734374994
							],
							[
								16.90449218750004,
								48.503515625000006
							],
							[
								16.86269531250005,
								48.44140624999997
							],
							[
								16.865429687500068,
								48.38691406250007
							],
							[
								16.97265624999997,
								48.19809570312506
							],
							[
								17.06787109375003,
								48.083251953125
							],
							[
								17.085937500000057,
								48.03955078125
							],
							[
								17.14736328125005,
								48.00595703124998
							],
							[
								17.089062500000068,
								47.96362304687497
							],
							[
								17.077734375000063,
								47.90087890624997
							],
							[
								17.039941406250023,
								47.872949218749966
							],
							[
								17.030078125000045,
								47.83710937500004
							],
							[
								17.04589843749997,
								47.80454101562498
							],
							[
								17.04560546875001,
								47.763769531250034
							],
							[
								17.06660156250001,
								47.707568359375045
							],
							[
								16.973437500000045,
								47.69531250000003
							],
							[
								16.86269531250005,
								47.69726562499997
							],
							[
								16.823046875000045,
								47.69399414062502
							],
							[
								16.785937500000045,
								47.67866210937501
							],
							[
								16.74755859375003,
								47.68627929687506
							],
							[
								16.6474609375,
								47.73901367187506
							],
							[
								16.590917968750006,
								47.75053710937499
							],
							[
								16.55097656250004,
								47.74736328124996
							],
							[
								16.521093750000006,
								47.724462890625006
							],
							[
								16.46962890625008,
								47.69506835937497
							],
							[
								16.421289062499994,
								47.67446289062505
							],
							[
								16.43212890625,
								47.65629882812499
							],
							[
								16.639746093750006,
								47.60888671875
							],
							[
								16.676562500000045,
								47.536035156249994
							],
							[
								16.63662109375008,
								47.47661132812496
							],
							[
								16.623046875,
								47.44755859374999
							],
							[
								16.57441406250004,
								47.424658203125034
							],
							[
								16.514746093750034,
								47.40454101562503
							],
							[
								16.442871093750057,
								47.39951171874998
							],
							[
								16.434375000000017,
								47.36743164062503
							],
							[
								16.462597656250068,
								47.27314453124998
							],
							[
								16.439746093750045,
								47.25273437500002
							],
							[
								16.41689453125008,
								47.22343749999999
							],
							[
								16.438378906250023,
								47.145898437499994
							],
							[
								16.482812500000023,
								47.14038085937503
							],
							[
								16.49267578124997,
								47.12265624999998
							],
							[
								16.48476562500005,
								47.09125976562507
							],
							[
								16.47695312500008,
								47.057861328125
							],
							[
								16.461230468750074,
								47.0224609375
							],
							[
								16.453417968750074,
								47.00678710937501
							],
							[
								16.423925781250006,
								46.99697265625005
							],
							[
								16.331835937500074,
								47.00219726562503
							],
							[
								16.252539062500006,
								46.971923828125
							],
							[
								16.093066406250017,
								46.86328124999997
							],
							[
								16.037207031250006,
								46.844824218750034
							],
							[
								15.976855468750045,
								46.80136718749998
							],
							[
								15.98046875,
								46.70585937499999
							],
							[
								15.972265625000006,
								46.69721679687498
							],
							[
								15.957617187500034,
								46.677636718749994
							],
							[
								15.766894531250017,
								46.711279296875006
							],
							[
								15.760253906249972,
								46.71074218749999
							],
							[
								15.632617187500017,
								46.69843750000007
							],
							[
								15.54531250000008,
								46.654638671875034
							],
							[
								15.439257812500045,
								46.629638671875
							],
							[
								15.216992187500068,
								46.64296875000005
							],
							[
								15.00068359375004,
								46.62597656250006
							],
							[
								14.949414062499983,
								46.61323242187501
							],
							[
								14.893261718750011,
								46.60590820312504
							],
							[
								14.840625000000045,
								46.58046875000002
							],
							[
								14.810546875000028,
								46.544580078124994
							],
							[
								14.75673828125008,
								46.499121093750034
							],
							[
								14.680175781250028,
								46.46342773437496
							],
							[
								14.596972656250045,
								46.43608398437499
							],
							[
								14.5771484375,
								46.41293945312498
							],
							[
								14.549804687500028,
								46.399707031250045
							],
							[
								14.503515625000006,
								46.41704101562502
							],
							[
								14.465917968750006,
								46.416113281250006
							],
							[
								14.419921875000028,
								46.42792968750001
							],
							[
								14.26728515625004,
								46.44072265624996
							],
							[
								14.099511718750051,
								46.46191406250003
							],
							[
								14.019628906250034,
								46.48217773437497
							],
							[
								13.928808593750006,
								46.49819335937502
							],
							[
								13.831347656250045,
								46.51123046875003
							],
							[
								13.743945312500074,
								46.51430664062502
							],
							[
								13.700000000000017,
								46.520263671875
							],
							[
								13.490039062500045,
								46.555566406249994
							],
							[
								13.3515625,
								46.557910156250045
							],
							[
								13.168750000000045,
								46.57265625000002
							],
							[
								12.805566406250051,
								46.62587890625002
							],
							[
								12.699804687499977,
								46.64746093750006
							],
							[
								12.598632812499972,
								46.6541015625001
							],
							[
								12.479199218750068,
								46.67250976562502
							],
							[
								12.388281250000034,
								46.70263671875003
							],
							[
								12.330078124999972,
								46.759814453125045
							],
							[
								12.267968750000023,
								46.8358886718751
							],
							[
								12.154101562500017,
								46.93525390625007
							],
							[
								12.130761718750051,
								46.98476562500005
							],
							[
								12.165527343750028,
								47.028173828125006
							],
							[
								12.201269531250034,
								47.060888671875006
							],
							[
								12.19716796875008,
								47.075000000000045
							],
							[
								12.169433593750028,
								47.08212890624998
							],
							[
								11.969531250000074,
								47.03969726562505
							],
							[
								11.775683593750017,
								46.98608398437506
							],
							[
								11.699414062500011,
								46.98466796875002
							],
							[
								11.625488281250057,
								46.99658203125006
							],
							[
								11.527539062500011,
								46.997412109375034
							],
							[
								11.433203125000063,
								46.98305664062505
							],
							[
								11.244433593750045,
								46.97568359375006
							],
							[
								11.133886718750006,
								46.93618164062508
							],
							[
								11.063476562500057,
								46.85913085937503
							],
							[
								11.02509765625004,
								46.79697265624998
							],
							[
								10.993261718750034,
								46.777001953124994
							],
							[
								10.927343750000034,
								46.76948242187507
							],
							[
								10.828906250000045,
								46.77524414062509
							],
							[
								10.759765625,
								46.793310546875034
							],
							[
								10.689257812500017,
								46.84638671875001
							],
							[
								10.579785156250011,
								46.85371093749998
							],
							[
								10.47939453125008,
								46.85512695312511
							],
							[
								10.452832031250068,
								46.86494140625007
							],
							[
								10.45458984375,
								46.89941406249997
							],
							[
								10.41494140625008,
								46.96440429687499
							],
							[
								10.349414062500045,
								46.98476562500005
							],
							[
								10.179785156250063,
								46.86235351562496
							],
							[
								10.13349609375004,
								46.85151367187498
							],
							[
								9.996874999999989,
								46.885351562500034
							],
							[
								9.877734375000074,
								46.93769531250004
							],
							[
								9.864648437500051,
								46.97597656250002
							],
							[
								9.845312500000034,
								47.00737304687502
							],
							[
								9.745019531250023,
								47.03710937500006
							],
							[
								9.619921875000045,
								47.057470703125034
							],
							[
								9.58027343750004,
								47.057373046875
							],
							[
								9.595703124999972,
								47.07583007812502
							],
							[
								9.610546875000068,
								47.10712890625001
							],
							[
								9.601171875000034,
								47.13208007812503
							],
							[
								9.571875000000006,
								47.15791015625007
							],
							[
								9.555761718750006,
								47.18549804687498
							],
							[
								9.551074218750045,
								47.212255859375034
							],
							[
								9.542187500000011,
								47.23413085937503
							],
							[
								9.536816406250068,
								47.25463867187506
							],
							[
								9.52753906250004,
								47.27075195312503
							],
							[
								9.60908203125004,
								47.39179687500001
							],
							[
								9.625878906249994,
								47.46704101562497
							],
							[
								9.554394531250011,
								47.511132812499994
							],
							[
								9.685449218750051,
								47.50639648437499
							],
							[
								9.718554687500045,
								47.51489257812503
							],
							[
								9.73066406250004,
								47.52690429687499
							],
							[
								9.695204109211062,
								47.54309166538212
							],
							[
								9.715136718750074,
								47.55078125000006
							],
							[
								9.748925781250023,
								47.57553710937506
							],
							[
								9.839160156250017,
								47.55229492187502
							],
							[
								9.97158203125008,
								47.50532226562504
							],
							[
								10.034082031250023,
								47.47358398437507
							],
							[
								10.059863281250045,
								47.449072265625034
							],
							[
								10.074218750000028,
								47.42851562500002
							],
							[
								10.066308593750023,
								47.393359375000074
							],
							[
								10.096484375000045,
								47.37958984375001
							],
							[
								10.158789062500034,
								47.374267578125085
							],
							[
								10.200292968750063,
								47.36342773437508
							],
							[
								10.185742187500011,
								47.317187500000074
							],
							[
								10.18300781250008,
								47.278808593750085
							],
							[
								10.240625000000023,
								47.28413085937501
							],
							[
								10.312792968750045,
								47.31342773437504
							],
							[
								10.369140625,
								47.366064453125006
							],
							[
								10.403906250000063,
								47.416992187500085
							],
							[
								10.43037109375004,
								47.541064453125045
							],
							[
								10.439453125000028,
								47.55156249999996
							],
							[
								10.482812500000051,
								47.54179687500002
							],
							[
								10.65869140625,
								47.54721679687506
							],
							[
								10.741601562500023,
								47.52412109375007
							],
							[
								10.873046875000057,
								47.52021484375007
							],
							[
								10.87060546875,
								47.5007812500001
							],
							[
								10.893945312500051,
								47.47045898437506
							],
							[
								10.952148437500028,
								47.42670898437501
							],
							[
								10.980859374999994,
								47.39814453125007
							],
							[
								11.041992187500028,
								47.39311523437502
							],
							[
								11.136035156249989,
								47.40888671875004
							],
							[
								11.191210937500045,
								47.42519531250005
							],
							[
								11.2119140625,
								47.41362304687502
							],
							[
								11.297949218750034,
								47.424902343750006
							],
							[
								11.374121093750006,
								47.46025390625002
							],
							[
								11.392968750000023,
								47.48715820312506
							],
							[
								11.469921875000068,
								47.50610351562503
							],
							[
								11.57392578125004,
								47.54975585937504
							],
							[
								11.716796875,
								47.583496093750085
							],
							[
								12.185644531250034,
								47.61953125000005
							],
							[
								12.203808593750011,
								47.646728515625085
							],
							[
								12.196875000000034,
								47.70908203125009
							],
							[
								12.209277343750074,
								47.718261718750085
							],
							[
								12.268359375000017,
								47.702734375000034
							],
							[
								12.36318359375008,
								47.6881835937501
							],
							[
								12.435742187500011,
								47.666113281250034
							],
							[
								12.482910156250028,
								47.63730468750012
							],
							[
								12.52656250000004,
								47.63613281250005
							],
							[
								12.594238281250057,
								47.656298828125074
							],
							[
								12.685839843750074,
								47.66933593750005
							],
							[
								12.771386718749994,
								47.639404296875
							],
							[
								12.796191406249989,
								47.60703124999998
							],
							[
								12.781152343750051,
								47.59042968749998
							],
							[
								12.782812500000034,
								47.56416015625004
							],
							[
								12.809375000000017,
								47.54218750000001
							],
							[
								12.878906250000057,
								47.506445312500006
							],
							[
								12.968066406250017,
								47.475683593750034
							],
							[
								13.01435546875004,
								47.4780761718751
							],
							[
								13.031542968750074,
								47.50800781250007
							],
							[
								13.047949218750034,
								47.57915039062499
							],
							[
								13.054101562500051,
								47.655126953125006
							],
							[
								13.033593750000051,
								47.698730468750114
							],
							[
								12.98554687500004,
								47.70942382812507
							],
							[
								12.928125000000051,
								47.71284179687504
							],
							[
								12.897656250000068,
								47.72187500000001
							],
							[
								12.908300781250006,
								47.74580078125001
							],
							[
								12.954199218750034,
								47.80776367187502
							],
							[
								12.95351562500008,
								47.89062500000003
							],
							[
								12.849902343750017,
								47.98481445312504
							],
							[
								12.760058593750017,
								48.075976562500045
							],
							[
								12.760351562500063,
								48.10698242187496
							],
							[
								12.814257812500045,
								48.16083984375001
							],
							[
								12.897460937500028,
								48.203710937500034
							],
							[
								13.082128906249977,
								48.27509765625001
							],
							[
								13.140429687500045,
								48.28994140625002
							],
							[
								13.215234375000023,
								48.301904296874966
							],
							[
								13.322851562500006,
								48.3312500000001
							],
							[
								13.374609375000063,
								48.3613769531251
							],
							[
								13.40937500000004,
								48.39414062500012
							],
							[
								13.459863281250023,
								48.564550781250006
							],
							[
								13.471679687500028,
								48.571826171875074
							],
							[
								13.486621093750045,
								48.581835937500074
							],
							[
								13.675195312500023,
								48.52304687500009
							],
							[
								13.692187500000017,
								48.53276367187502
							],
							[
								13.723925781249989,
								48.54238281250002
							],
							[
								13.785351562500068,
								48.587451171875045
							],
							[
								13.798828124999972,
								48.62167968750009
							],
							[
								13.797460937500063,
								48.686425781249966
							],
							[
								13.802929687500011,
								48.74750976562498
							],
							[
								13.814746093750017,
								48.766943359375034
							],
							[
								13.843164062500051,
								48.759863281250006
							],
							[
								13.924316406250057,
								48.72802734375
							],
							[
								13.988769531250028,
								48.692431640625045
							],
							[
								14.049121093750074,
								48.60249023437501
							],
							[
								14.189843750000051,
								48.57856445312501
							],
							[
								14.367578125000023,
								48.57622070312499
							],
							[
								14.43105468750008,
								48.61625976562499
							],
							[
								14.488671875000023,
								48.62553710937499
							],
							[
								14.553906250000068,
								48.61333007812499
							],
							[
								14.69130859375008,
								48.59921875000006
							],
							[
								14.706640625000006,
								48.671923828125045
							],
							[
								14.785937499999989,
								48.747363281250045
							],
							[
								14.821875000000034,
								48.77402343750006
							],
							[
								14.92255859375004,
								48.77138671875005
							],
							[
								14.947363281250034,
								48.82773437499998
							],
							[
								14.97216796875,
								48.98393554687502
							],
							[
								14.993457031249989,
								49.00112304687505
							],
							[
								15.066796875000023,
								48.99785156249999
							],
							[
								15.139746093750034,
								48.96933593750006
							],
							[
								15.161718750000006,
								48.94628906249997
							],
							[
								15.19960937500008,
								48.948144531249994
							],
							[
								15.252734375000074,
								48.9638671875
							],
							[
								15.310937500000023,
								48.97402343750002
							],
							[
								15.402929687500006,
								48.957373046875006
							],
							[
								15.599414062500074,
								48.88637695312502
							],
							[
								15.700781250000034,
								48.86044921874998
							],
							[
								15.76503906250008,
								48.86542968750001
							],
							[
								15.825195312499972,
								48.86445312500001
							],
							[
								16.057226562500006,
								48.75478515625005
							],
							[
								16.219335937499977,
								48.73940429687502
							],
							[
								16.367285156250006,
								48.73896484375001
							],
							[
								16.414843750000017,
								48.772070312500006
							],
							[
								16.47792968750008,
								48.800097656250045
							],
							[
								16.543554687500034,
								48.79624023437506
							],
							[
								16.600976562500023,
								48.781884765624966
							],
							[
								16.712695312500045,
								48.734228515625034
							],
							[
								16.764453125000017,
								48.722021484375034
							],
							[
								16.833203124999983,
								48.71430664062507
							],
							[
								16.88369140625005,
								48.703710937500034
							],
							[
								16.928320312500006,
								48.620898437500045
							],
							[
								16.953125,
								48.59882812500007
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "AUT",
					"su_a3": "AUT",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "AUT",
					"gu_a3": "AUT",
					"abbrev": "Aust.",
					"region_un": "Europe",
					"adm0_a3_us": "AUT",
					"scalerank": 1,
					"pop_est": 8210281,
					"adm0_dif": 0,
					"un_a3": "040",
					"pop_year": -99,
					"gdp_md_est": 329500,
					"name": "Austria",
					"sovereignt": "Austria",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Austria",
					"postal": "A",
					"sov_a3": "AUT",
					"note_brk": "",
					"brk_a3": "AUT",
					"wb_a2": "AT",
					"brk_diff": 0,
					"admin": "Austria",
					"name_long": "Austria",
					"iso_a3": "AUT",
					"iso_a2": "AT",
					"adm0_a3_is": "AUT",
					"level": 2,
					"formal_en": "Republic of Austria",
					"name_len": 7,
					"mapcolor7": 3,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "040",
					"homepart": 1,
					"subunit": "Austria",
					"name_alt": "",
					"brk_name": "Austria",
					"name_sort": "Austria",
					"continent": "Europe",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									46.11445312500018,
									38.87778320312509
								],
								[
									45.921875000000114,
									38.90791015625001
								],
								[
									45.57500000000016,
									38.972802734374994
								],
								[
									45.47968750000018,
									39.006249999999966
								],
								[
									45.389257812500034,
									39.09589843750004
								],
								[
									45.335546875000034,
									39.13916015625006
								],
								[
									45.25595703125009,
									39.19467773437509
								],
								[
									45.19062500000018,
									39.21562499999999
								],
								[
									45.141210937500034,
									39.254296874999966
								],
								[
									45.11308593749999,
									39.3115722656251
								],
								[
									45.07167968750002,
									39.36289062499998
								],
								[
									45.00019531250001,
									39.42353515624998
								],
								[
									44.83818359375016,
									39.62910156250004
								],
								[
									44.817187500000045,
									39.65043945312493
								],
								[
									44.78339843750018,
									39.68466796874998
								],
								[
									44.76826171875001,
									39.70351562500008
								],
								[
									44.867187500000114,
									39.71914062500008
								],
								[
									45.031640625000136,
									39.76513671874994
								],
								[
									45.07646484374999,
									39.74282226562502
								],
								[
									45.124609375000034,
									39.69633789062496
								],
								[
									45.14863281250007,
									39.65659179687495
								],
								[
									45.152832031250114,
									39.58266601562508
								],
								[
									45.17255859375007,
									39.57060546875002
								],
								[
									45.25253906250009,
									39.595458984375114
								],
								[
									45.28828125000018,
									39.565576171874966
								],
								[
									45.349902343750045,
									39.52988281249998
								],
								[
									45.45683593750016,
									39.49448242187506
								],
								[
									45.610742187499966,
									39.54980468750003
								],
								[
									45.687402343750136,
									39.56406250000009
								],
								[
									45.750488281250114,
									39.56293945312504
								],
								[
									45.78447265624999,
									39.54560546874998
								],
								[
									45.79648437500009,
									39.48813476562509
								],
								[
									45.78417968749994,
									39.41723632812494
								],
								[
									45.76630859375007,
									39.378466796875045
								],
								[
									45.79863281250016,
									39.35019531250006
								],
								[
									45.92500000000007,
									39.2819335937501
								],
								[
									45.977441406249966,
									39.24389648437506
								],
								[
									45.95185546875018,
									39.178124999999994
								],
								[
									46.0458984375,
									39.017529296874955
								],
								[
									46.07744140624999,
									38.95488281249999
								],
								[
									46.11445312500018,
									38.87778320312509
								]
							]
						],
						[
							[
								[
									44.96904296875016,
									41.02724609374994
								],
								[
									44.958886718750136,
									41.052636718749966
								],
								[
									44.961425781250114,
									41.079248046874966
								],
								[
									44.99433593750018,
									41.08559570312502
								],
								[
									45.021093750000034,
									41.07797851562498
								],
								[
									45.028710937500136,
									41.05385742187502
								],
								[
									45.02363281250018,
									41.02724609374994
								],
								[
									45.002050781250034,
									41.015820312499926
								],
								[
									44.96904296875016,
									41.02724609374994
								]
							]
						],
						[
							[
								[
									48.57285156250009,
									41.844482421875085
								],
								[
									48.664648437500034,
									41.786621093750114
								],
								[
									48.82392578125018,
									41.6295898437501
								],
								[
									49.050878906250034,
									41.37397460937507
								],
								[
									49.10664062500001,
									41.30170898437507
								],
								[
									49.14326171875001,
									41.21777343749994
								],
								[
									49.174707031250136,
									41.11611328125002
								],
								[
									49.226464843750136,
									41.02622070312509
								],
								[
									49.45673828125007,
									40.799853515625074
								],
								[
									49.55615234374994,
									40.716308593750114
								],
								[
									49.718359375000034,
									40.6081054687501
								],
								[
									49.77597656250009,
									40.58398437500006
								],
								[
									49.85175781250007,
									40.5771972656251
								],
								[
									49.99062500000002,
									40.57680664062511
								],
								[
									50.119140625,
									40.53452148437509
								],
								[
									50.182519531250136,
									40.504785156249994
								],
								[
									50.24804687499994,
									40.46176757812512
								],
								[
									50.30683593750001,
									40.41220703125006
								],
								[
									50.36591796875018,
									40.279492187499926
								],
								[
									50.14316406250009,
									40.32324218750006
								],
								[
									49.918847656250136,
									40.316406250000085
								],
								[
									49.79199218749994,
									40.287890625000045
								],
								[
									49.669042968750034,
									40.24902343750003
								],
								[
									49.55117187500002,
									40.194140625000045
								],
								[
									49.47734375000016,
									40.08725585937512
								],
								[
									49.41513671875009,
									39.83984374999997
								],
								[
									49.32441406250018,
									39.60834960937507
								],
								[
									49.32753906250002,
									39.501220703125
								],
								[
									49.36738281250007,
									39.398388671874926
								],
								[
									49.362792968750114,
									39.349560546874926
								],
								[
									49.321191406250136,
									39.328906250000074
								],
								[
									49.26933593750016,
									39.28515624999994
								],
								[
									49.19980468750009,
									39.072656249999994
								],
								[
									49.16533203124999,
									39.03027343750006
								],
								[
									49.120996093750136,
									39.00390625000003
								],
								[
									49.10869140624999,
									39.029052734375
								],
								[
									49.111328125000114,
									39.08471679687497
								],
								[
									49.01347656250016,
									39.13398437500007
								],
								[
									48.96171874999999,
									39.078759765624994
								],
								[
									48.926171875000136,
									38.96176757812506
								],
								[
									48.854492187500114,
									38.83881835937507
								],
								[
									48.85087890625016,
									38.81533203125008
								],
								[
									48.86875000000009,
									38.435498046874955
								],
								[
									48.84033203124994,
									38.43725585937506
								],
								[
									48.63554687500016,
									38.39873046875002
								],
								[
									48.592675781250136,
									38.411083984374955
								],
								[
									48.417382812500136,
									38.58623046874993
								],
								[
									48.381250000000136,
									38.60561523437505
								],
								[
									48.30556640625002,
									38.61347656250007
								],
								[
									48.261328125000034,
									38.64228515624998
								],
								[
									48.225195312500034,
									38.68920898437503
								],
								[
									48.204687500000034,
									38.72412109375006
								],
								[
									48.023242187500045,
									38.81904296875001
								],
								[
									47.99648437500002,
									38.853759765625085
								],
								[
									47.992675781250114,
									38.884277343750085
								],
								[
									48.019335937500045,
									38.91181640625001
								],
								[
									48.05009765624999,
									38.93500976562501
								],
								[
									48.138574218749966,
									38.95864257812505
								],
								[
									48.24199218749999,
									38.97895507812501
								],
								[
									48.27509765625018,
									38.99360351562507
								],
								[
									48.29208984375009,
									39.01884765624996
								],
								[
									48.29101562499994,
									39.05927734375004
								],
								[
									48.27412109375018,
									39.09912109374997
								],
								[
									48.12548828125,
									39.171630859375
								],
								[
									48.10917968750016,
									39.20283203125004
								],
								[
									48.104394531250136,
									39.24111328125002
								],
								[
									48.11289062500009,
									39.281103515625006
								],
								[
									48.13603515624999,
									39.31235351562498
								],
								[
									48.25722656250002,
									39.35498046875006
								],
								[
									48.32216796875002,
									39.39907226562505
								],
								[
									48.281738281250114,
									39.44833984374998
								],
								[
									48.15107421875007,
									39.560546875000085
								],
								[
									47.99589843750016,
									39.683935546875006
								],
								[
									47.89228515625018,
									39.68505859374997
								],
								[
									47.77285156250002,
									39.64858398437508
								],
								[
									47.58183593750016,
									39.543359374999966
								],
								[
									47.476171875000034,
									39.498339843750045
								],
								[
									47.338476562500034,
									39.42387695312496
								],
								[
									47.188378906250136,
									39.34096679687505
								],
								[
									47.065429687500114,
									39.25288085937504
								],
								[
									46.98886718750009,
									39.18017578125006
								],
								[
									46.852539062500114,
									39.148437500000085
								],
								[
									46.783203125000114,
									39.087402343750085
								],
								[
									46.55478515625009,
									38.904394531250006
								],
								[
									46.490624999999966,
									38.90668945312504
								],
								[
									46.48671875000002,
									38.99746093750005
								],
								[
									46.48984375000009,
									39.06943359375006
								],
								[
									46.47539062499999,
									39.110888671875074
								],
								[
									46.401464843750034,
									39.1676757812501
								],
								[
									46.400292968749966,
									39.19218750000002
								],
								[
									46.420312500000136,
									39.20737304687509
								],
								[
									46.47714843750009,
									39.1981933593751
								],
								[
									46.55000000000018,
									39.20141601562494
								],
								[
									46.58476562500016,
									39.223681640625045
								],
								[
									46.50664062500016,
									39.29853515625001
								],
								[
									46.43730468750016,
									39.34853515625008
								],
								[
									46.37841796874994,
									39.382275390624926
								],
								[
									46.365234375000114,
									39.40249023437505
								],
								[
									46.36513671875002,
									39.416796875000045
								],
								[
									46.37763671875018,
									39.43388671874996
								],
								[
									46.478125000000034,
									39.475097656250085
								],
								[
									46.48808593749999,
									39.512841796874966
								],
								[
									46.4814453125,
									39.55517578125006
								],
								[
									46.321679687500136,
									39.61743164062506
								],
								[
									46.20205078125002,
									39.594482421875085
								],
								[
									46.09482421875009,
									39.66445312500005
								],
								[
									46.02587890625,
									39.71855468749996
								],
								[
									45.93994140625,
									39.77656250000004
								],
								[
									45.863183593749966,
									39.80834960937506
								],
								[
									45.78964843750009,
									39.88110351562494
								],
								[
									45.66181640625018,
									39.956201171874966
								],
								[
									45.57978515625007,
									39.97753906250006
								],
								[
									45.580957031250136,
									39.989013671875085
								],
								[
									45.59599609375016,
									40.002832031249966
								],
								[
									45.630175781250045,
									40.014208984375074
								],
								[
									45.85810546875018,
									40.011279296875074
								],
								[
									45.88593750000018,
									40.02485351562501
								],
								[
									45.90009765625001,
									40.0570800781251
								],
								[
									45.93125000000009,
									40.104687499999926
								],
								[
									45.96757812499999,
									40.1748046875
								],
								[
									45.964648437500045,
									40.23378906249994
								],
								[
									45.735742187500136,
									40.3291015625
								],
								[
									45.56953125000018,
									40.41684570312512
								],
								[
									45.45439453124999,
									40.53237304687502
								],
								[
									45.37617187500007,
									40.63808593750005
								],
								[
									45.37890625,
									40.673583984375114
								],
								[
									45.40136718749994,
									40.707128906250006
								],
								[
									45.57939453125016,
									40.804492187500045
								],
								[
									45.591406250000034,
									40.82973632812494
								],
								[
									45.587500000000034,
									40.84692382812497
								],
								[
									45.52402343750009,
									40.896728515625
								],
								[
									45.444238281249966,
									40.94799804687506
								],
								[
									45.41914062500001,
									40.985693359375006
								],
								[
									45.36894531249999,
									41.0048828125
								],
								[
									45.273437500000114,
									41.00625000000002
								],
								[
									45.10605468750009,
									41.069335937500085
								],
								[
									45.07050781250007,
									41.07558593750002
								],
								[
									45.062597656250034,
									41.088134765625
								],
								[
									45.07070312500002,
									41.100830078125114
								],
								[
									45.19023437499999,
									41.12636718750005
								],
								[
									45.188574218750034,
									41.1474121093751
								],
								[
									45.152343750000114,
									41.17514648437506
								],
								[
									45.084765625000045,
									41.19545898437502
								],
								[
									45.02294921874994,
									41.24570312499995
								],
								[
									45.001367187499966,
									41.29096679687501
								],
								[
									45.21718750000008,
									41.42319335937506
								],
								[
									45.28095703125001,
									41.449560546875006
								],
								[
									45.422265625000136,
									41.42529296875003
								],
								[
									45.715625000000045,
									41.33764648437503
								],
								[
									45.695703125000136,
									41.28901367187498
								],
								[
									45.72548828125008,
									41.261621093749994
								],
								[
									45.792773437500045,
									41.22441406249996
								],
								[
									45.921972656250034,
									41.18671875000001
								],
								[
									46.031250000000114,
									41.16728515624996
								],
								[
									46.08652343750009,
									41.18383789062506
								],
								[
									46.17070312499999,
									41.19785156250006
								],
								[
									46.27998046875018,
									41.15444335937511
								],
								[
									46.38076171875008,
									41.09931640625007
								],
								[
									46.43095703124999,
									41.077050781249966
								],
								[
									46.45791015625008,
									41.070214843749994
								],
								[
									46.53437500000001,
									41.0885742187501
								],
								[
									46.626367187500136,
									41.159667968750085
								],
								[
									46.66240234374999,
									41.245507812499994
								],
								[
									46.67255859375001,
									41.28681640625007
								],
								[
									46.618945312500045,
									41.34375000000003
								],
								[
									46.50878906250006,
									41.40556640625002
								],
								[
									46.38496093750007,
									41.459863281249966
								],
								[
									46.305468750000045,
									41.50771484375005
								],
								[
									46.254687500000045,
									41.602148437500006
								],
								[
									46.203515625000136,
									41.6125976562501
								],
								[
									46.190527343750034,
									41.624853515625006
								],
								[
									46.182128906250114,
									41.657080078125006
								],
								[
									46.18427734375001,
									41.70214843750003
								],
								[
									46.20185546875007,
									41.7368652343751
								],
								[
									46.251855468750136,
									41.75175781250002
								],
								[
									46.30253906250016,
									41.75708007812503
								],
								[
									46.348242187500034,
									41.79018554687502
								],
								[
									46.40546875000007,
									41.85507812500012
								],
								[
									46.42988281250007,
									41.890966796875034
								],
								[
									46.53769531250009,
									41.870410156250045
								],
								[
									46.55214843750002,
									41.8123046875001
								],
								[
									46.5712890625,
									41.8000976562501
								],
								[
									46.61601562500016,
									41.806933593750074
								],
								[
									46.69033203125002,
									41.831347656250074
								],
								[
									46.749316406250045,
									41.81259765624998
								],
								[
									46.825585937500136,
									41.743408203125
								],
								[
									46.93085937500007,
									41.67041015625006
								],
								[
									46.987792968750114,
									41.62138671875002
								],
								[
									47.010156250000136,
									41.58749999999995
								],
								[
									47.063964843750114,
									41.554687500000114
								],
								[
									47.142578125000114,
									41.51606445312504
								],
								[
									47.20527343750018,
									41.45561523437499
								],
								[
									47.261132812500136,
									41.315087890624966
								],
								[
									47.31767578124999,
									41.28242187500007
								],
								[
									47.520605468750034,
									41.22905273437493
								],
								[
									47.591796875,
									41.21811523437509
								],
								[
									47.791015625,
									41.19926757812499
								],
								[
									47.86113281250016,
									41.21274414062506
								],
								[
									47.96367187500016,
									41.333984375000085
								],
								[
									48.056054687500136,
									41.4586914062501
								],
								[
									48.14228515625001,
									41.48476562500008
								],
								[
									48.29814453124999,
									41.54501953125009
								],
								[
									48.39140625000016,
									41.60190429687495
								],
								[
									48.4306640625,
									41.66333007812494
								],
								[
									48.51865234375009,
									41.779345703125045
								],
								[
									48.57285156250009,
									41.844482421875085
								]
							],
							[
								[
									45.55234375000009,
									40.61606445312512
								],
								[
									45.56230468750016,
									40.649169921875114
								],
								[
									45.534179687500114,
									40.664013671874926
								],
								[
									45.50449218750009,
									40.6648437500001
								],
								[
									45.47880859374999,
									40.64833984375002
								],
								[
									45.47880859374999,
									40.606982421875045
								],
								[
									45.51435546875007,
									40.59956054687504
								],
								[
									45.55234375000009,
									40.61606445312512
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "AZE",
					"su_a3": "AZE",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "AZE",
					"gu_a3": "AZE",
					"abbrev": "Aze.",
					"region_un": "Asia",
					"adm0_a3_us": "AZE",
					"scalerank": 1,
					"pop_est": 8238672,
					"adm0_dif": 0,
					"un_a3": "031",
					"pop_year": -99,
					"gdp_md_est": 77610,
					"name": "Azerbaijan",
					"sovereignt": "Azerbaijan",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Azerbaijan",
					"postal": "AZ",
					"sov_a3": "AZE",
					"note_brk": "",
					"brk_a3": "AZE",
					"wb_a2": "AZ",
					"brk_diff": 0,
					"admin": "Azerbaijan",
					"name_long": "Azerbaijan",
					"iso_a3": "AZE",
					"iso_a2": "AZ",
					"adm0_a3_is": "AZE",
					"level": 2,
					"formal_en": "Republic of Azerbaijan",
					"name_len": 10,
					"mapcolor7": 1,
					"long_len": 10,
					"mapcolor8": 6,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "031",
					"homepart": 1,
					"subunit": "Azerbaijan",
					"name_alt": "",
					"brk_name": "Azerbaijan",
					"name_sort": "Azerbaijan",
					"continent": "Asia",
					"mapcolor13": 8,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								5.693554687500011,
								50.77475585937498
							],
							[
								5.69453125000004,
								50.78105468749993
							],
							[
								5.830957031250023,
								50.809130859375045
							],
							[
								5.89246112249532,
								50.75255685798356
							],
							[
								5.993945312500017,
								50.7504394531251
							],
							[
								6.005957031249977,
								50.73222656249993
							],
							[
								6.119433593750017,
								50.679248046875074
							],
							[
								6.15449218750004,
								50.637255859375045
							],
							[
								6.235937500000034,
								50.59667968749994
							],
							[
								6.168457031250057,
								50.54536132812507
							],
							[
								6.1787109375,
								50.52250976562493
							],
							[
								6.20302734375008,
								50.49912109375006
							],
							[
								6.294921875000057,
								50.48549804687494
							],
							[
								6.340917968750006,
								50.45175781250009
							],
							[
								6.343652343750023,
								50.40024414062498
							],
							[
								6.364453125000011,
								50.316162109375085
							],
							[
								6.175097656250074,
								50.23266601562494
							],
							[
								6.12128906250004,
								50.13935546875004
							],
							[
								6.1165039062500455,
								50.12099609375002
							],
							[
								6.11005859375004,
								50.12377929687506
							],
							[
								6.08906250000004,
								50.15458984375002
							],
							[
								6.0547851562500625,
								50.15429687500006
							],
							[
								5.976269531250068,
								50.16718750000001
							],
							[
								5.866894531250068,
								50.082812500000045
							],
							[
								5.817382812500028,
								50.012695312500085
							],
							[
								5.7880859375,
								49.961230468750074
							],
							[
								5.744042968749994,
								49.91962890625004
							],
							[
								5.73525390625008,
								49.87563476562505
							],
							[
								5.7408203125000625,
								49.857177734375085
							],
							[
								5.725781250000011,
								49.833349609375034
							],
							[
								5.725000000000023,
								49.8083007812501
							],
							[
								5.78798828125008,
								49.75888671875006
							],
							[
								5.8037109375,
								49.73217773437503
							],
							[
								5.880371093750057,
								49.644775390625085
							],
							[
								5.856542968750006,
								49.612841796875045
							],
							[
								5.837597656250068,
								49.57832031250004
							],
							[
								5.815429687499972,
								49.55380859375012
							],
							[
								5.789746093749983,
								49.53828125000007
							],
							[
								5.71044921875,
								49.53920898437508
							],
							[
								5.610058593750068,
								49.52822265625005
							],
							[
								5.542382812500051,
								49.51103515625002
							],
							[
								5.50732421875,
								49.51088867187508
							],
							[
								5.434667968750034,
								49.554492187500074
							],
							[
								5.353515625000028,
								49.61982421875007
							],
							[
								5.301953125000011,
								49.650976562500006
							],
							[
								5.27880859375,
								49.6779296875001
							],
							[
								5.215039062500068,
								49.68925781249999
							],
							[
								5.124121093750006,
								49.72148437499999
							],
							[
								5.061035156250028,
								49.75654296875001
							],
							[
								5.006933593750034,
								49.77836914062502
							],
							[
								4.930566406250023,
								49.78925781250004
							],
							[
								4.867578125000051,
								49.788134765625074
							],
							[
								4.849121093750028,
								49.8471191406251
							],
							[
								4.841503906250068,
								49.91450195312504
							],
							[
								4.790039062499972,
								49.95957031250009
							],
							[
								4.86054687500004,
								50.13588867187502
							],
							[
								4.8186523437500455,
								50.153173828125006
							],
							[
								4.772851562500023,
								50.139062499999966
							],
							[
								4.706640625000034,
								50.09707031249994
							],
							[
								4.675097656250017,
								50.046875000000114
							],
							[
								4.656152343750051,
								50.00244140625003
							],
							[
								4.5450195312500625,
								49.96025390624996
							],
							[
								4.368750000000034,
								49.94497070312505
							],
							[
								4.1760742187500455,
								49.96025390624996
							],
							[
								4.149316406250023,
								49.97158203125005
							],
							[
								4.137011718750074,
								49.984472656250006
							],
							[
								4.136816406250034,
								49.99999999999997
							],
							[
								4.150292968750023,
								50.023876953124955
							],
							[
								4.1838867187500455,
								50.05283203125009
							],
							[
								4.1921875000000455,
								50.094140624999966
							],
							[
								4.157714843750028,
								50.12988281250006
							],
							[
								4.13525390625,
								50.14379882812506
							],
							[
								4.144140625000034,
								50.1784179687501
							],
							[
								4.169628906250068,
								50.22177734374995
							],
							[
								4.174609375000017,
								50.24648437500011
							],
							[
								4.044140624999983,
								50.321337890625074
							],
							[
								3.9497070312500284,
								50.33593750000003
							],
							[
								3.8581054687500114,
								50.33857421875004
							],
							[
								3.788574218750057,
								50.34697265624996
							],
							[
								3.748046875000057,
								50.34350585937506
							],
							[
								3.7188476562500625,
								50.32167968750005
							],
							[
								3.6893554687499943,
								50.30605468750005
							],
							[
								3.6672851562500455,
								50.32480468749998
							],
							[
								3.6267578125000455,
								50.457324218750074
							],
							[
								3.59541015625004,
								50.47734374999996
							],
							[
								3.4769531250000796,
								50.49946289062504
							],
							[
								3.316210937500017,
								50.507373046875045
							],
							[
								3.2733398437500796,
								50.53154296874999
							],
							[
								3.249804687500074,
								50.59116210937506
							],
							[
								3.2349609374999773,
								50.662939453125034
							],
							[
								3.1820312500000227,
								50.731689453125
							],
							[
								3.1548828125000057,
								50.74892578125005
							],
							[
								3.1068359375000796,
								50.77944335937505
							],
							[
								3.0228515625000227,
								50.766894531250074
							],
							[
								2.9219726562499773,
								50.72705078124994
							],
							[
								2.862402343750034,
								50.71601562500001
							],
							[
								2.8397460937500227,
								50.711767578125034
							],
							[
								2.7593750000000057,
								50.75063476562505
							],
							[
								2.669140624999983,
								50.811425781249994
							],
							[
								2.5967773437500057,
								50.87592773437498
							],
							[
								2.579296874999983,
								50.91176757812511
							],
							[
								2.601464843750051,
								50.95527343749998
							],
							[
								2.5748046875000625,
								50.98857421874993
							],
							[
								2.536035156250051,
								51.0495117187501
							],
							[
								2.52490234375,
								51.097119140624926
							],
							[
								2.96015625000004,
								51.26542968749993
							],
							[
								3.225195312500034,
								51.351611328125074
							],
							[
								3.35009765625,
								51.37768554687506
							],
							[
								3.380078125000068,
								51.29111328125012
							],
							[
								3.40283203125,
								51.263623046874926
							],
							[
								3.4325195312500796,
								51.24575195312511
							],
							[
								3.4719726562500455,
								51.2422363281251
							],
							[
								3.51708984375,
								51.263623046874926
							],
							[
								3.580273437499983,
								51.28618164062499
							],
							[
								3.681835937500068,
								51.275683593750074
							],
							[
								3.755664062500017,
								51.2548339843751
							],
							[
								3.78193359375004,
								51.233203125000045
							],
							[
								3.83076171875004,
								51.21259765625001
							],
							[
								3.902050781249983,
								51.20766601562508
							],
							[
								4.040039062500028,
								51.247070312500114
							],
							[
								4.17255859375004,
								51.30708007812498
							],
							[
								4.211425781250057,
								51.348730468750034
							],
							[
								4.226171875000034,
								51.386474609375085
							],
							[
								4.304492187500017,
								51.36152343750007
							],
							[
								4.373730468749983,
								51.3560058593751
							],
							[
								4.40400390625004,
								51.36708984375005
							],
							[
								4.384765625000028,
								51.42758789062512
							],
							[
								4.44091796875,
								51.45981445312509
							],
							[
								4.503417968750028,
								51.474707031250034
							],
							[
								4.531640624999994,
								51.44858398437495
							],
							[
								4.588769531250023,
								51.42192382812493
							],
							[
								4.633984375000068,
								51.42172851562498
							],
							[
								4.755664062499989,
								51.491113281249994
							],
							[
								4.784179687500028,
								51.47739257812495
							],
							[
								4.810546874999972,
								51.45273437500009
							],
							[
								4.816015625000034,
								51.432812499999926
							],
							[
								4.820703125000023,
								51.41206054687507
							],
							[
								4.84804687500008,
								51.403271484374955
							],
							[
								4.943945312499977,
								51.407763671875074
							],
							[
								4.992578125000023,
								51.4453613281251
							],
							[
								5.03095703125004,
								51.46909179687495
							],
							[
								5.05947265625008,
								51.453125000000085
							],
							[
								5.073437500000068,
								51.40683593750006
							],
							[
								5.0999023437500455,
								51.34648437499993
							],
							[
								5.2141601562500455,
								51.27895507812494
							],
							[
								5.3108398437500455,
								51.259716796874926
							],
							[
								5.429785156250006,
								51.272998046875045
							],
							[
								5.476855468750017,
								51.28505859374994
							],
							[
								5.508789062500028,
								51.27500000000012
							],
							[
								5.540429687499994,
								51.239306640625045
							],
							[
								5.60878906250008,
								51.19843750000007
							],
							[
								5.752343749999994,
								51.16948242187493
							],
							[
								5.796484375000034,
								51.15307617187506
							],
							[
								5.827148437500057,
								51.125634765624966
							],
							[
								5.818261718750023,
								51.08642578124997
							],
							[
								5.749804687500017,
								50.98876953124997
							],
							[
								5.7408203125000625,
								50.959912109374955
							],
							[
								5.750000000000057,
								50.95024414062502
							],
							[
								5.736621093749989,
								50.93212890625006
							],
							[
								5.6475585937500625,
								50.86665039062504
							],
							[
								5.639453125000017,
								50.84360351562498
							],
							[
								5.669140625000011,
								50.805957031250045
							],
							[
								5.693554687500011,
								50.77475585937498
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "BEL",
					"su_a3": "BEL",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "BEL",
					"gu_a3": "BEL",
					"abbrev": "Belg.",
					"region_un": "Europe",
					"adm0_a3_us": "BEL",
					"scalerank": 1,
					"pop_est": 10414336,
					"adm0_dif": 0,
					"un_a3": "056",
					"pop_year": -99,
					"gdp_md_est": 389300,
					"name": "Belgium",
					"sovereignt": "Belgium",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Belgium",
					"postal": "B",
					"sov_a3": "BEL",
					"note_brk": "",
					"brk_a3": "BEL",
					"wb_a2": "BE",
					"brk_diff": 0,
					"admin": "Belgium",
					"name_long": "Belgium",
					"iso_a3": "BEL",
					"iso_a2": "BE",
					"adm0_a3_is": "BEL",
					"level": 2,
					"formal_en": "Kingdom of Belgium",
					"name_len": 7,
					"mapcolor7": 3,
					"long_len": 7,
					"mapcolor8": 2,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "056",
					"homepart": 1,
					"subunit": "Belgium",
					"name_alt": "",
					"brk_name": "Belgium",
					"name_sort": "Belgium",
					"continent": "Europe",
					"mapcolor13": 8,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								28.58535156250005,
								43.74223632812499
							],
							[
								28.561816406250045,
								43.501318359375034
							],
							[
								28.465429687500034,
								43.38930664062502
							],
							[
								28.31962890624999,
								43.426855468750034
							],
							[
								28.13369140625005,
								43.39560546874998
							],
							[
								28.035156250000057,
								43.26826171875007
							],
							[
								27.979296875000045,
								43.23051757812502
							],
							[
								27.928906250000068,
								43.186132812500034
							],
							[
								27.89648437500003,
								43.02070312499998
							],
							[
								27.888867187499983,
								42.74970703125001
							],
							[
								27.81835937500003,
								42.716650390625034
							],
							[
								27.753710937500074,
								42.70654296875003
							],
							[
								27.484765624999994,
								42.46806640625002
							],
							[
								27.639550781249994,
								42.400976562500034
							],
							[
								27.70820312500004,
								42.349951171875034
							],
							[
								27.821386718750006,
								42.20800781249997
							],
							[
								27.982714843750017,
								42.047412109375045
							],
							[
								28.01445312499999,
								41.96904296874996
							],
							[
								27.879199218750074,
								41.98662109374999
							],
							[
								27.831933593750023,
								41.98129882812498
							],
							[
								27.80166015625008,
								41.956542968750085
							],
							[
								27.738867187499977,
								41.961523437500034
							],
							[
								27.661132812500057,
								41.961328124999994
							],
							[
								27.579882812500017,
								41.932910156250074
							],
							[
								27.534863281249983,
								41.920800781249994
							],
							[
								27.47480468750001,
								41.94687499999998
							],
							[
								27.362890625000034,
								42.02504882812511
							],
							[
								27.294921875000057,
								42.07954101562501
							],
							[
								27.24433593750004,
								42.09326171875006
							],
							[
								27.193359375000057,
								42.07709960937504
							],
							[
								27.01171875,
								42.05864257812502
							],
							[
								26.96875000000003,
								42.026855468750114
							],
							[
								26.884863281250006,
								41.991845703124994
							],
							[
								26.800390625000034,
								41.97514648437496
							],
							[
								26.67919921875003,
								41.96333007812504
							],
							[
								26.615332031250063,
								41.9648925781251
							],
							[
								26.579687500000006,
								41.94794921875001
							],
							[
								26.549707031250023,
								41.89672851562497
							],
							[
								26.52929687500003,
								41.846679687500085
							],
							[
								26.51142578125004,
								41.82636718750004
							],
							[
								26.3603515625,
								41.801562500000045
							],
							[
								26.327246093750006,
								41.772802734375034
							],
							[
								26.317968750000063,
								41.744677734375074
							],
							[
								26.320898437500034,
								41.71655273437503
							],
							[
								26.20058593750005,
								41.743798828124994
							],
							[
								26.107421875000057,
								41.725683593750034
							],
							[
								26.085546875000063,
								41.7041503906251
							],
							[
								26.066015625000063,
								41.67324218750011
							],
							[
								26.076953125000074,
								41.64018554687502
							],
							[
								26.11123046875005,
								41.60820312499999
							],
							[
								26.143554687500057,
								41.52153320312502
							],
							[
								26.155175781250023,
								41.43486328125002
							],
							[
								26.135351562500063,
								41.38574218749997
							],
							[
								26.066406250000057,
								41.35068359375012
							],
							[
								25.923339843750057,
								41.31191406250002
							],
							[
								25.784960937500017,
								41.33041992187498
							],
							[
								25.723925781250017,
								41.315039062500034
							],
							[
								25.621484375000023,
								41.31010742187502
							],
							[
								25.52705078125004,
								41.29980468750006
							],
							[
								25.381933593750063,
								41.26435546875001
							],
							[
								25.251171875000068,
								41.24355468750005
							],
							[
								25.133398437500063,
								41.31577148437509
							],
							[
								24.99355468750008,
								41.364990234375
							],
							[
								24.84687500000004,
								41.39423828125001
							],
							[
								24.795800781250023,
								41.37290039062512
							],
							[
								24.773730468750045,
								41.356103515624966
							],
							[
								24.65107421875001,
								41.41997070312502
							],
							[
								24.595996093750074,
								41.442724609375034
							],
							[
								24.569335937500057,
								41.46738281250009
							],
							[
								24.51826171875004,
								41.55253906250002
							],
							[
								24.487890625000006,
								41.555224609375045
							],
							[
								24.38671875,
								41.52353515624998
							],
							[
								24.28945312500008,
								41.52504882812502
							],
							[
								24.230371093750023,
								41.530810546875045
							],
							[
								24.056054687500023,
								41.52724609375002
							],
							[
								24.03291015625004,
								41.46909179687506
							],
							[
								24.011328125000063,
								41.460058593750006
							],
							[
								23.973535156250023,
								41.45229492187502
							],
							[
								23.880859375000057,
								41.45595703125005
							],
							[
								23.762304687500063,
								41.41298828125011
							],
							[
								23.63515625000008,
								41.3867675781251
							],
							[
								23.53583984375001,
								41.38603515625002
							],
							[
								23.433398437500017,
								41.398730468750045
							],
							[
								23.372070312500057,
								41.38964843750006
							],
							[
								23.239843750000006,
								41.38496093749998
							],
							[
								23.155957031250068,
								41.32207031249996
							],
							[
								23.025585937500068,
								41.32563476562498
							],
							[
								22.91601562500003,
								41.336279296875006
							],
							[
								22.92968749999997,
								41.356103515624966
							],
							[
								22.951464843750074,
								41.605615234374994
							],
							[
								23.005664062500017,
								41.71694335937502
							],
							[
								23.00361328125004,
								41.73984374999998
							],
							[
								22.991992187500074,
								41.75717773437506
							],
							[
								22.943945312500034,
								41.77509765625007
							],
							[
								22.909179687500057,
								41.83520507812506
							],
							[
								22.83681640625008,
								41.99360351562498
							],
							[
								22.79609375000004,
								42.02568359374996
							],
							[
								22.68232421875004,
								42.05913085937502
							],
							[
								22.582714843749983,
								42.104833984375006
							],
							[
								22.49824218750001,
								42.16508789062502
							],
							[
								22.344042968750045,
								42.31396484374997
							],
							[
								22.42207031250004,
								42.328857421875085
							],
							[
								22.44570312500005,
								42.35913085937503
							],
							[
								22.523535156250006,
								42.4409667968751
							],
							[
								22.53242187500004,
								42.48120117187503
							],
							[
								22.524218750000074,
								42.50390625000003
							],
							[
								22.472070312500023,
								42.54331054687506
							],
							[
								22.436230468749983,
								42.62910156250007
							],
							[
								22.46328125000008,
								42.70947265625
							],
							[
								22.465625000000017,
								42.750781250000074
							],
							[
								22.439257812500074,
								42.79165039062505
							],
							[
								22.466796875,
								42.84248046875001
							],
							[
								22.522753906250045,
								42.87031250000007
							],
							[
								22.55810546875003,
								42.87846679687496
							],
							[
								22.706152343750006,
								42.88393554687511
							],
							[
								22.799902343750006,
								42.985742187499966
							],
							[
								22.85683593750005,
								43.01826171875001
							],
							[
								22.915234375000068,
								43.075976562500045
							],
							[
								22.94228515625005,
								43.09707031250008
							],
							[
								22.96796875000004,
								43.14204101562501
							],
							[
								22.97685546874999,
								43.18798828125006
							],
							[
								22.859570312499983,
								43.25234375000002
							],
							[
								22.81972656250005,
								43.30073242187501
							],
							[
								22.767578125,
								43.35415039062505
							],
							[
								22.69697265625001,
								43.39106445312504
							],
							[
								22.554589843750023,
								43.45449218750008
							],
							[
								22.499121093750006,
								43.518847656250045
							],
							[
								22.47412109374997,
								43.60224609374998
							],
							[
								22.436328125000017,
								43.66547851562498
							],
							[
								22.394824218750074,
								43.70664062500012
							],
							[
								22.386914062500068,
								43.74013671875011
							],
							[
								22.36962890625,
								43.781298828125045
							],
							[
								22.36542968750004,
								43.86210937499999
							],
							[
								22.399023437500063,
								43.96953125000002
							],
							[
								22.42080078125005,
								44.00742187500009
							],
							[
								22.469042968750017,
								44.01801757812504
							],
							[
								22.597460937500074,
								44.07529296875006
							],
							[
								22.603417968750023,
								44.148583984374994
							],
							[
								22.626562500000034,
								44.19409179687503
							],
							[
								22.66748046875003,
								44.22021484375003
							],
							[
								22.705078125000057,
								44.23779296875006
							],
							[
								22.775195312500045,
								44.195214843749994
							],
							[
								22.945410156249977,
								44.127294921875006
							],
							[
								23.02851562500004,
								44.077978515625006
							],
							[
								23.0244140625,
								44.047216796875034
							],
							[
								22.98535156250003,
								44.01699218750002
							],
							[
								22.911328125000068,
								43.987207031249994
							],
							[
								22.868261718749977,
								43.947900390624966
							],
							[
								22.85644531249997,
								43.899023437500034
							],
							[
								22.867675781250057,
								43.864550781250045
							],
							[
								22.919042968750034,
								43.83447265625003
							],
							[
								23.22460937500003,
								43.87387695312498
							],
							[
								23.534570312500023,
								43.85356445312502
							],
							[
								23.950781250000006,
								43.78666992187499
							],
							[
								24.226757812499983,
								43.76347656249996
							],
							[
								24.43056640625005,
								43.79438476562504
							],
							[
								24.808203125000063,
								43.73842773437502
							],
							[
								25.15966796874997,
								43.68632812499996
							],
							[
								25.497070312500057,
								43.670800781249994
							],
							[
								25.686132812500034,
								43.711767578125006
							],
							[
								25.81884765624997,
								43.76684570312503
							],
							[
								25.933398437500045,
								43.87055664062501
							],
							[
								26.21582031250003,
								44.00727539062498
							],
							[
								26.489257812500057,
								44.08398437499997
							],
							[
								26.847753906249977,
								44.14619140625004
							],
							[
								27.08691406250003,
								44.167382812499994
							],
							[
								27.120703125000006,
								44.14614257812502
							],
							[
								27.425390624999977,
								44.02050781250003
							],
							[
								27.56103515625,
								44.02006835937502
							],
							[
								27.6708984375,
								43.997802734375
							],
							[
								27.710742187500045,
								43.964599609375
							],
							[
								27.738574218750017,
								43.956298828125
							],
							[
								27.88427734375003,
								43.98735351562502
							],
							[
								27.948925781250068,
								43.91860351562505
							],
							[
								28.05000000000004,
								43.822412109374994
							],
							[
								28.22197265624999,
								43.77285156250002
							],
							[
								28.37519531250004,
								43.744775390624966
							],
							[
								28.423437500000006,
								43.740478515625
							],
							[
								28.58535156250005,
								43.74223632812499
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "BGR",
					"su_a3": "BGR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "BGR",
					"gu_a3": "BGR",
					"abbrev": "Bulg.",
					"region_un": "Europe",
					"adm0_a3_us": "BGR",
					"scalerank": 1,
					"pop_est": 7204687,
					"adm0_dif": 0,
					"un_a3": "100",
					"pop_year": -99,
					"gdp_md_est": 93750,
					"name": "Bulgaria",
					"sovereignt": "Bulgaria",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Bulgaria",
					"postal": "BG",
					"sov_a3": "BGR",
					"note_brk": "",
					"brk_a3": "BGR",
					"wb_a2": "BG",
					"brk_diff": 0,
					"admin": "Bulgaria",
					"name_long": "Bulgaria",
					"iso_a3": "BGR",
					"iso_a2": "BG",
					"adm0_a3_is": "BGR",
					"level": 2,
					"formal_en": "Republic of Bulgaria",
					"name_len": 8,
					"mapcolor7": 4,
					"long_len": 8,
					"mapcolor8": 5,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "100",
					"homepart": 1,
					"subunit": "Bulgaria",
					"name_alt": "",
					"brk_name": "Bulgaria",
					"name_sort": "Bulgaria",
					"continent": "Europe",
					"mapcolor13": 8,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								50.607226562500045,
								25.883105468750017
							],
							[
								50.57490234375001,
								25.806787109375023
							],
							[
								50.544042968750034,
								25.833496093750057
							],
							[
								50.465917968750034,
								25.96552734375004
							],
							[
								50.48945312500001,
								26.058447265625034
							],
							[
								50.452441406250045,
								26.190820312500023
							],
							[
								50.46992187500007,
								26.228955078125068
							],
							[
								50.564062500000034,
								26.246435546874977
							],
							[
								50.58593750000006,
								26.240722656250057
							],
							[
								50.55781250000001,
								26.198291015625017
							],
							[
								50.60976562500002,
								26.124462890624983
							],
							[
								50.61748046874999,
								26.002343749999994
							],
							[
								50.607226562500045,
								25.883105468750017
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "BHR",
					"su_a3": "BHR",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "BHR",
					"gu_a3": "BHR",
					"abbrev": "Bahr.",
					"region_un": "Asia",
					"adm0_a3_us": "BHR",
					"scalerank": 1,
					"pop_est": 727785,
					"adm0_dif": 0,
					"un_a3": "048",
					"pop_year": -99,
					"gdp_md_est": 26820,
					"name": "Bahrain",
					"sovereignt": "Bahrain",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Bahrain",
					"postal": "BH",
					"sov_a3": "BHR",
					"note_brk": "",
					"brk_a3": "BHR",
					"wb_a2": "BH",
					"brk_diff": 0,
					"admin": "Bahrain",
					"name_long": "Bahrain",
					"iso_a3": "BHR",
					"iso_a2": "BH",
					"adm0_a3_is": "BHR",
					"level": 2,
					"formal_en": "Kingdom of Bahrain",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "048",
					"homepart": 1,
					"subunit": "Bahrain",
					"name_alt": "",
					"brk_name": "Bahrain",
					"name_sort": "Bahrain",
					"continent": "Asia",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": 2,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								19.007128906250045,
								44.86918945312499
							],
							[
								19.042089843750063,
								44.87133789062506
							],
							[
								19.131542968750068,
								44.89960937500007
							],
							[
								19.23681640625003,
								44.914257812499926
							],
							[
								19.31269531250001,
								44.89746093749997
							],
							[
								19.348632812500057,
								44.880908203125074
							],
							[
								19.35683593750005,
								44.85854492187505
							],
							[
								19.33447265625003,
								44.78066406250008
							],
							[
								19.29189453125005,
								44.69677734374994
							],
							[
								19.22314453125,
								44.60957031250004
							],
							[
								19.15136718750003,
								44.52734374999997
							],
							[
								19.132421875000063,
								44.48378906250008
							],
							[
								19.127343750000023,
								44.41455078125
							],
							[
								19.118457031250074,
								44.35996093749998
							],
							[
								19.128320312500023,
								44.33027343750007
							],
							[
								19.15185546875003,
								44.3025390625001
							],
							[
								19.231542968750006,
								44.280566406250074
							],
							[
								19.33886718750003,
								44.225830078125114
							],
							[
								19.43017578124997,
								44.154492187499955
							],
							[
								19.547167968750017,
								44.07348632812497
							],
							[
								19.583789062500017,
								44.043457031250085
							],
							[
								19.583691406249983,
								44.01108398437506
							],
							[
								19.54951171875004,
								43.98710937499996
							],
							[
								19.449414062499983,
								43.97802734374997
							],
							[
								19.34521484375,
								43.985107421875
							],
							[
								19.305273437500034,
								43.99335937500007
							],
							[
								19.26806640625,
								43.98344726562502
							],
							[
								19.245019531249994,
								43.9650390625001
							],
							[
								19.257226562499994,
								43.94331054687501
							],
							[
								19.364062500000017,
								43.8447753906251
							],
							[
								19.48818359375008,
								43.703564453124926
							],
							[
								19.495117187500057,
								43.642871093750074
							],
							[
								19.47998046875,
								43.595166015624955
							],
							[
								19.451269531250006,
								43.56206054687496
							],
							[
								19.399609375000068,
								43.56757812500001
							],
							[
								19.360351562500057,
								43.59345703125007
							],
							[
								19.30078125,
								43.591796875000085
							],
							[
								19.254492187500063,
								43.58437500000008
							],
							[
								19.19433593749997,
								43.53330078125006
							],
							[
								19.16435546874999,
								43.53544921874996
							],
							[
								19.112792968750057,
								43.52773437500008
							],
							[
								19.080078125000057,
								43.517724609374994
							],
							[
								19.0283203125,
								43.53251953124999
							],
							[
								18.974218749999977,
								43.542333984375034
							],
							[
								18.95068359375,
								43.526660156250045
							],
							[
								18.940234375000074,
								43.49672851562508
							],
							[
								18.97382812500001,
								43.442382812500085
							],
							[
								19.036718750000034,
								43.357324218749994
							],
							[
								19.026660156250017,
								43.29243164062501
							],
							[
								18.97871093750001,
								43.285400390625
							],
							[
								18.934667968750006,
								43.33945312500009
							],
							[
								18.895605468750063,
								43.3481933593751
							],
							[
								18.85107421875003,
								43.34633789062508
							],
							[
								18.749218750000068,
								43.28354492187498
							],
							[
								18.67421875000008,
								43.23081054687498
							],
							[
								18.656835937499977,
								43.19394531250012
							],
							[
								18.629980468750034,
								43.15366210937506
							],
							[
								18.621875000000074,
								43.12460937500012
							],
							[
								18.623632812500063,
								43.02768554687509
							],
							[
								18.488476562500068,
								43.01215820312501
							],
							[
								18.460156250000068,
								42.99790039062506
							],
							[
								18.44384765625003,
								42.9684570312501
							],
							[
								18.455078125,
								42.84409179687498
							],
							[
								18.46601562500001,
								42.77724609375005
							],
							[
								18.543261718750045,
								42.67416992187509
							],
							[
								18.54589843750003,
								42.64160156250003
							],
							[
								18.534960937500017,
								42.6201171875
							],
							[
								18.480078125000034,
								42.57919921875009
							],
							[
								18.453906250000045,
								42.564501953125045
							],
							[
								18.436328125000017,
								42.55971679687505
							],
							[
								18.346582031250023,
								42.58666992187503
							],
							[
								18.304003906250045,
								42.59941406249996
							],
							[
								18.12392578125005,
								42.690576171874966
							],
							[
								18.044531250000034,
								42.74125976562499
							],
							[
								17.918847656250023,
								42.807421875000045
							],
							[
								17.84130859375003,
								42.84506835937509
							],
							[
								17.80195312500001,
								42.90224609375011
							],
							[
								17.74023437500003,
								42.915478515624955
							],
							[
								17.667578125000063,
								42.89711914062502
							],
							[
								17.585156250000068,
								42.93837890625008
							],
							[
								17.64345703125005,
								42.9597656250001
							],
							[
								17.657812500000034,
								42.98007812500006
							],
							[
								17.650488281250063,
								43.00659179687506
							],
							[
								17.624804687500045,
								43.042773437500045
							],
							[
								17.402246093750023,
								43.19892578125007
							],
							[
								17.293066406250063,
								43.30561523437504
							],
							[
								17.27529296875008,
								43.343847656250006
							],
							[
								17.27382812500005,
								43.44575195312498
							],
							[
								17.24804687500003,
								43.470214843750085
							],
							[
								17.084570312500034,
								43.516552734374926
							],
							[
								16.90185546875003,
								43.649023437500006
							],
							[
								16.713476562500034,
								43.77880859375006
							],
							[
								16.68769531250001,
								43.81503906250009
							],
							[
								16.59052734375001,
								43.91318359375009
							],
							[
								16.47207031250005,
								44.00258789062511
							],
							[
								16.377539062500063,
								44.05961914062499
							],
							[
								16.300097656250017,
								44.12451171874997
							],
							[
								16.214257812500023,
								44.21513671874996
							],
							[
								16.169824218750023,
								44.352001953124955
							],
							[
								16.13027343750005,
								44.47373046874998
							],
							[
								16.10341796875008,
								44.520996093750114
							],
							[
								16.04902343750001,
								44.53759765625003
							],
							[
								15.880078125000068,
								44.68193359375002
							],
							[
								15.736621093750045,
								44.76582031250007
							],
							[
								15.737988281250068,
								44.856396484374955
							],
							[
								15.761523437500074,
								45.007519531249926
							],
							[
								15.788085937500057,
								45.17895507812494
							],
							[
								15.822851562500034,
								45.20278320312508
							],
							[
								15.888281250000034,
								45.21572265625005
							],
							[
								15.963183593750017,
								45.21079101562495
							],
							[
								16.028320312500057,
								45.18959960937508
							],
							[
								16.157324218750063,
								45.072216796874955
							],
							[
								16.231054687500063,
								45.026611328125085
							],
							[
								16.29335937500005,
								45.00883789062502
							],
							[
								16.365039062500017,
								45.05834960937497
							],
							[
								16.453515624999994,
								45.16201171875005
							],
							[
								16.53066406250008,
								45.216699218749994
							],
							[
								16.790820312500074,
								45.19687499999995
							],
							[
								16.918652343749983,
								45.27656250000001
							],
							[
								17.125390625000023,
								45.171777343749994
							],
							[
								17.210644531250068,
								45.15605468749999
							],
							[
								17.25869140625008,
								45.17055664062511
							],
							[
								17.32412109375008,
								45.163964843749994
							],
							[
								17.46914062500005,
								45.13330078124997
							],
							[
								17.50263671875004,
								45.120361328125
							],
							[
								17.54628906250005,
								45.12255859375
							],
							[
								17.65351562500004,
								45.16347656250008
							],
							[
								17.69013671875004,
								45.158398437499926
							],
							[
								17.812792968750074,
								45.078125000000085
							],
							[
								17.874414062500023,
								45.077246093750006
							],
							[
								17.94863281250005,
								45.111865234375045
							],
							[
								17.996289062500068,
								45.141796874999926
							],
							[
								18.13720703125,
								45.11938476562497
							],
							[
								18.21796875000001,
								45.13291015624998
							],
							[
								18.284960937500074,
								45.134277343750085
							],
							[
								18.35761718750004,
								45.12055664062504
							],
							[
								18.423925781250063,
								45.10200195312498
							],
							[
								18.48828125000003,
								45.08583984375008
							],
							[
								18.66259765625,
								45.07744140624996
							],
							[
								18.746093750000057,
								45.02651367187505
							],
							[
								18.779394531250006,
								44.97724609375007
							],
							[
								18.78017578125008,
								44.94721679687498
							],
							[
								18.788378906250045,
								44.91489257812506
							],
							[
								18.83642578124997,
								44.88325195312501
							],
							[
								18.941308593750023,
								44.86518554687507
							],
							[
								19.007128906250045,
								44.86918945312499
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "BIH",
					"su_a3": "BIH",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "BIH",
					"gu_a3": "BIH",
					"abbrev": "B.H.",
					"region_un": "Europe",
					"adm0_a3_us": "BIH",
					"scalerank": 1,
					"pop_est": 4613414,
					"adm0_dif": 0,
					"un_a3": "070",
					"pop_year": -99,
					"gdp_md_est": 29700,
					"name": "Bosnia and Herz.",
					"sovereignt": "Bosnia and Herzegovina",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Bosnia and Herzegovina",
					"postal": "BiH",
					"sov_a3": "BIH",
					"note_brk": "",
					"brk_a3": "BIH",
					"wb_a2": "BA",
					"brk_diff": 0,
					"admin": "Bosnia and Herzegovina",
					"name_long": "Bosnia and Herzegovina",
					"iso_a3": "BIH",
					"iso_a2": "BA",
					"adm0_a3_is": "BIH",
					"level": 2,
					"formal_en": "Bosnia and Herzegovina",
					"name_len": 16,
					"mapcolor7": 1,
					"long_len": 22,
					"mapcolor8": 1,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "070",
					"homepart": 1,
					"subunit": "Bosnia and Herzegovina",
					"name_alt": "",
					"brk_name": "Bosnia and Herz.",
					"name_sort": "Bosnia and Herzegovina",
					"continent": "Europe",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 1991
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								28.14794921875003,
								56.142919921875006
							],
							[
								28.284277343750006,
								56.05590820312506
							],
							[
								28.316308593750023,
								56.052539062500074
							],
							[
								28.39208984375003,
								56.08671875000002
							],
							[
								28.407031250000045,
								56.08901367187505
							],
							[
								28.56396484375003,
								56.09199218750001
							],
							[
								28.636914062500068,
								56.061767578125085
							],
							[
								28.69082031250005,
								56.00263671875004
							],
							[
								28.740820312500006,
								55.95537109374999
							],
							[
								28.794726562500074,
								55.94257812500004
							],
							[
								28.94746093750001,
								56.00209960937511
							],
							[
								29.03173828125003,
								56.02177734375002
							],
							[
								29.08740234375,
								56.02114257812508
							],
							[
								29.283007812500045,
								55.96787109375006
							],
							[
								29.375,
								55.93872070312497
							],
							[
								29.396093750000034,
								55.91220703125009
							],
							[
								29.397949218750057,
								55.88105468750004
							],
							[
								29.373144531250034,
								55.834716796875114
							],
							[
								29.353417968750136,
								55.78437500000007
							],
							[
								29.41298828125008,
								55.724853515625114
							],
							[
								29.482226562500045,
								55.68457031249997
							],
							[
								29.630078125000182,
								55.75117187500004
							],
							[
								29.6845703125,
								55.76972656250001
							],
							[
								29.744140625000057,
								55.770410156249966
							],
							[
								29.823925781250068,
								55.79511718750004
							],
							[
								29.881640625000102,
								55.832324218750045
							],
							[
								29.93701171875,
								55.84526367187502
							],
							[
								30.04267578125001,
								55.83642578125
							],
							[
								30.23359375000001,
								55.845214843750114
							],
							[
								30.456250000000068,
								55.78681640625001
							],
							[
								30.475390625000045,
								55.768798828125085
							],
							[
								30.58671874999999,
								55.70029296874998
							],
							[
								30.625585937500034,
								55.66625976562497
							],
							[
								30.662304687500068,
								55.6554687500001
							],
							[
								30.721679687500057,
								55.622119140625045
							],
							[
								30.800781250000114,
								55.60112304687502
							],
							[
								30.855957031250057,
								55.60751953125009
							],
							[
								30.88222656250008,
								55.59638671875004
							],
							[
								30.906835937500034,
								55.5700195312501
							],
							[
								30.90878906250009,
								55.52534179687504
							],
							[
								30.900585937500125,
								55.39741210937501
							],
							[
								30.861816406250114,
								55.36040039062502
							],
							[
								30.820996093750068,
								55.33027343750001
							],
							[
								30.810546875000057,
								55.30698242187506
							],
							[
								30.814453125000057,
								55.27871093750008
							],
							[
								30.877441406250114,
								55.2234375000001
							],
							[
								30.95888671875008,
								55.13759765625011
							],
							[
								30.977734375000068,
								55.08779296875008
							],
							[
								30.977734375000068,
								55.05048828125004
							],
							[
								30.866796875000034,
								54.94072265624996
							],
							[
								30.82988281249999,
								54.91499023437504
							],
							[
								30.804492187500045,
								54.860937500000034
							],
							[
								30.791015625,
								54.806005859375034
							],
							[
								30.798828125000057,
								54.78325195312502
							],
							[
								30.984179687500102,
								54.69589843750009
							],
							[
								31.12128906250001,
								54.64848632812502
							],
							[
								31.15214843749999,
								54.625341796875006
							],
							[
								31.154882812500034,
								54.610937500000006
							],
							[
								31.081933593750023,
								54.517089843750085
							],
							[
								31.07480468750009,
								54.49179687499998
							],
							[
								31.184765625000068,
								54.45297851562498
							],
							[
								31.245507812500136,
								54.3916503906251
							],
							[
								31.299121093750045,
								54.29169921874998
							],
							[
								31.40361328124999,
								54.19594726562502
							],
							[
								31.628417968750057,
								54.11118164062498
							],
							[
								31.7919921875,
								54.055908203125
							],
							[
								31.825976562500045,
								54.03071289062501
							],
							[
								31.83779296875008,
								54.00078124999996
							],
							[
								31.825292968750034,
								53.93500976562507
							],
							[
								31.78300781249999,
								53.854980468750085
							],
							[
								31.75419921874999,
								53.810449218749994
							],
							[
								31.82080078125,
								53.79194335937504
							],
							[
								31.992187500000114,
								53.796875000000085
							],
							[
								32.20039062500007,
								53.78125
							],
							[
								32.45019531250006,
								53.692919921875045
							],
							[
								32.450976562500045,
								53.65332031250006
							],
							[
								32.42519531250002,
								53.61728515625009
							],
							[
								32.44238281250006,
								53.579248046874966
							],
							[
								32.46962890625002,
								53.54697265625006
							],
							[
								32.68574218750018,
								53.448144531249994
							],
							[
								32.706445312500136,
								53.41943359375
							],
							[
								32.71025390624999,
								53.37143554687509
							],
							[
								32.70429687500001,
								53.33632812500005
							],
							[
								32.64443359375002,
								53.328906250000045
							],
							[
								32.57802734375008,
								53.31240234375005
							],
							[
								32.469335937500034,
								53.2703125000001
							],
							[
								32.42626953125006,
								53.21059570312508
							],
							[
								32.25068359375007,
								53.12836914062504
							],
							[
								32.141992187500136,
								53.091162109375006
							],
							[
								32.05546874999999,
								53.08945312500009
							],
							[
								31.849707031250034,
								53.10620117187506
							],
							[
								31.777441406250034,
								53.14687500000008
							],
							[
								31.747460937500136,
								53.184179687500034
							],
							[
								31.66826171874999,
								53.200927734375085
							],
							[
								31.562988281250057,
								53.202490234375034
							],
							[
								31.417871093750136,
								53.19604492187497
							],
							[
								31.388378906250068,
								53.184814453125085
							],
							[
								31.364550781250045,
								53.138964843750074
							],
							[
								31.302929687500068,
								53.06088867187506
							],
							[
								31.258789062500057,
								53.01669921875012
							],
							[
								31.295117187500068,
								52.98979492187496
							],
							[
								31.35302734375,
								52.933447265625034
							],
							[
								31.44277343750008,
								52.86181640625
							],
							[
								31.535156250000057,
								52.79824218750002
							],
							[
								31.56484375000008,
								52.75922851562507
							],
							[
								31.563476562500057,
								52.7314453125
							],
							[
								31.519433593750136,
								52.698730468750085
							],
							[
								31.52617187499999,
								52.63300781250001
							],
							[
								31.615917968750068,
								52.5461914062501
							],
							[
								31.585546875000034,
								52.53247070312506
							],
							[
								31.576562500000136,
								52.42602539062503
							],
							[
								31.57734375000001,
								52.31230468749996
							],
							[
								31.601562500000114,
								52.28481445312505
							],
							[
								31.64990234375,
								52.26220703124997
							],
							[
								31.69062500000001,
								52.22065429687504
							],
							[
								31.75859374999999,
								52.12583007812506
							],
							[
								31.763378906250125,
								52.10107421875
							],
							[
								31.573730468750114,
								52.10810546875001
							],
							[
								31.345996093750045,
								52.105371093749994
							],
							[
								31.217968750000125,
								52.05024414062504
							],
							[
								31.168457031250057,
								52.06293945312504
							],
							[
								31.079296875000068,
								52.076953125000074
							],
							[
								30.980664062500182,
								52.04619140625002
							],
							[
								30.845703125000114,
								51.95307617187504
							],
							[
								30.75527343750008,
								51.89516601562508
							],
							[
								30.66728515624999,
								51.81411132812508
							],
							[
								30.63945312499999,
								51.770068359375074
							],
							[
								30.58388671875008,
								51.68896484375006
							],
							[
								30.53300781249999,
								51.59633789062502
							],
							[
								30.560742187500068,
								51.53149414062506
							],
							[
								30.60234374999999,
								51.471240234375045
							],
							[
								30.611718750000136,
								51.406347656250034
							],
							[
								30.63251953125001,
								51.35541992187507
							],
							[
								30.576953125000045,
								51.31835937499997
							],
							[
								30.544531250000034,
								51.26503906250002
							],
							[
								30.449511718750045,
								51.274316406249966
							],
							[
								30.333398437500023,
								51.32553710937509
							],
							[
								30.308984375000023,
								51.39960937500001
							],
							[
								30.21953124999999,
								51.451220703125045
							],
							[
								30.16074218750009,
								51.47788085937506
							],
							[
								30.063769531250045,
								51.482031250000006
							],
							[
								29.908789062500034,
								51.4580078125
							],
							[
								29.706054687500114,
								51.43955078125006
							],
							[
								29.553125000000136,
								51.43457031250003
							],
							[
								29.46962890625008,
								51.40834960937511
							],
							[
								29.346484375000045,
								51.382568359375
							],
							[
								29.298828125000114,
								51.41303710937498
							],
							[
								29.230468750000114,
								51.49702148437504
							],
							[
								29.174218750000023,
								51.58061523437502
							],
							[
								29.13564453125008,
								51.617285156250034
							],
							[
								29.102050781250057,
								51.62753906250009
							],
							[
								29.060742187499983,
								51.62543945312501
							],
							[
								29.01308593750005,
								51.59892578125002
							],
							[
								28.97773437500004,
								51.57177734375
							],
							[
								28.927539062500045,
								51.562158203124994
							],
							[
								28.84951171875005,
								51.54018554687505
							],
							[
								28.793261718750045,
								51.510351562500006
							],
							[
								28.731250000000017,
								51.43339843749996
							],
							[
								28.690234375000017,
								51.43886718750011
							],
							[
								28.647753906250045,
								51.45654296874997
							],
							[
								28.59902343750008,
								51.54262695312511
							],
							[
								28.532031250000017,
								51.56245117187504
							],
							[
								28.424609375000074,
								51.56362304687502
							],
							[
								28.291601562500063,
								51.5818359375001
							],
							[
								28.18378906250004,
								51.60786132812507
							],
							[
								28.144433593750023,
								51.601660156250034
							],
							[
								28.08027343750001,
								51.565039062500034
							],
							[
								28.010742187500057,
								51.55976562500004
							],
							[
								27.85859375000004,
								51.59238281250012
							],
							[
								27.82880859375001,
								51.577441406250074
							],
							[
								27.788867187500045,
								51.52915039062512
							],
							[
								27.741308593750034,
								51.48256835937502
							],
							[
								27.700000000000074,
								51.47797851562498
							],
							[
								27.67675781250003,
								51.48994140625001
							],
							[
								27.689746093750017,
								51.57241210937505
							],
							[
								27.601367187500045,
								51.601611328125045
							],
							[
								27.452343750000068,
								51.60610351562505
							],
							[
								27.347656250000057,
								51.59414062500002
							],
							[
								27.29628906250005,
								51.59741210937506
							],
							[
								27.270117187500063,
								51.61357421874999
							],
							[
								27.14199218750008,
								51.752050781250034
							],
							[
								27.074121093750023,
								51.76083984375006
							],
							[
								26.952832031249983,
								51.75400390625009
							],
							[
								26.77343750000003,
								51.77070312500001
							],
							[
								26.566894531250057,
								51.80190429687508
							],
							[
								26.453417968750045,
								51.81342773437501
							],
							[
								26.394335937500074,
								51.84443359375004
							],
							[
								26.26708984375,
								51.855029296875074
							],
							[
								25.92529296875,
								51.91352539062498
							],
							[
								25.785742187499977,
								51.92382812500006
							],
							[
								25.58027343750004,
								51.92475585937507
							],
							[
								25.267187500000034,
								51.93774414062503
							],
							[
								25.066699218750045,
								51.93051757812506
							],
							[
								24.97382812500004,
								51.91113281250003
							],
							[
								24.86640625000001,
								51.89912109374998
							],
							[
								24.685156250000034,
								51.88828125000009
							],
							[
								24.611328125,
								51.88950195312498
							],
							[
								24.495214843750063,
								51.883056640625
							],
							[
								24.361914062500006,
								51.867529296875034
							],
							[
								24.32373046875003,
								51.83842773437496
							],
							[
								24.280078125000017,
								51.774707031250045
							],
							[
								24.12685546875008,
								51.66464843750009
							],
							[
								23.978320312500017,
								51.59130859375006
							],
							[
								23.95117187499997,
								51.585058593750034
							],
							[
								23.86425781250003,
								51.62397460937507
							],
							[
								23.79169921875001,
								51.63710937500008
							],
							[
								23.706835937500045,
								51.64130859375004
							],
							[
								23.64667968750004,
								51.62885742187507
							],
							[
								23.60859375000001,
								51.61049804687508
							],
							[
								23.61376953125,
								51.52539062500006
							],
							[
								23.605273437500045,
								51.517919921875034
							],
							[
								23.539648437499977,
								51.618896484375
							],
							[
								23.54482421875008,
								51.71025390624996
							],
							[
								23.581347656250045,
								51.76240234375001
							],
							[
								23.62568359375001,
								51.809326171875
							],
							[
								23.60742187500003,
								51.87978515625005
							],
							[
								23.65107421875004,
								51.972998046875034
							],
							[
								23.652441406250063,
								52.04038085937498
							],
							[
								23.633300781250057,
								52.06958007812497
							],
							[
								23.597949218750045,
								52.10307617187496
							],
							[
								23.501171875000068,
								52.14038085937503
							],
							[
								23.45839843750005,
								52.169531250000006
							],
							[
								23.32714843750003,
								52.20844726562504
							],
							[
								23.196972656250068,
								52.25693359375006
							],
							[
								23.175097656250074,
								52.28662109374997
							],
							[
								23.181250000000063,
								52.306982421875034
							],
							[
								23.20410156250003,
								52.33789062500003
							],
							[
								23.303320312500063,
								52.428369140624994
							],
							[
								23.410937500000045,
								52.516210937500034
							],
							[
								23.479589843750006,
								52.551562500000045
							],
							[
								23.844726562500057,
								52.664208984374966
							],
							[
								23.901269531250023,
								52.70361328125
							],
							[
								23.91542968750008,
								52.770263671875
							],
							[
								23.916308593750074,
								52.81875000000002
							],
							[
								23.909374999999983,
								52.90488281249998
							],
							[
								23.88710937500008,
								53.02753906250001
							],
							[
								23.859179687500074,
								53.11210937500002
							],
							[
								23.78925781250004,
								53.27094726562504
							],
							[
								23.598925781250074,
								53.599218750000034
							],
							[
								23.484667968750074,
								53.93979492187506
							],
							[
								23.55908203125003,
								53.91982421875008
							],
							[
								23.73369140624999,
								53.91225585937505
							],
							[
								23.872558593750057,
								53.93569335937502
							],
							[
								23.944433593750034,
								53.93896484374997
							],
							[
								24.00849609375004,
								53.931640625000085
							],
							[
								24.103906250000023,
								53.94501953125007
							],
							[
								24.19130859375005,
								53.950439453125
							],
							[
								24.236621093750045,
								53.91997070312502
							],
							[
								24.317968750000006,
								53.89296875000002
							],
							[
								24.47851562500003,
								53.93183593750004
							],
							[
								24.620703125000063,
								53.979833984375034
							],
							[
								24.768164062500063,
								53.97465820312496
							],
							[
								24.78925781250001,
								53.99824218750007
							],
							[
								24.825683593750057,
								54.11899414062506
							],
							[
								24.869531250000023,
								54.14516601562505
							],
							[
								25.04609375000004,
								54.133056640625085
							],
							[
								25.111425781250006,
								54.15493164062511
							],
							[
								25.179492187500017,
								54.21425781250002
							],
							[
								25.28369140625003,
								54.2512695312501
							],
							[
								25.370605468750057,
								54.251220703125
							],
							[
								25.46113281250004,
								54.29277343750002
							],
							[
								25.505664062500045,
								54.264941406250045
							],
							[
								25.52734375000003,
								54.21513671875002
							],
							[
								25.497363281250045,
								54.17524414062507
							],
							[
								25.510351562500006,
								54.15961914062498
							],
							[
								25.57304687499999,
								54.13989257812506
							],
							[
								25.68056640625005,
								54.14047851562509
							],
							[
								25.74921875000001,
								54.156982421875085
							],
							[
								25.765234374999977,
								54.179785156250006
							],
							[
								25.765039062500023,
								54.221191406250085
							],
							[
								25.748144531250063,
								54.25966796875002
							],
							[
								25.702539062499994,
								54.29296874999997
							],
							[
								25.61689453125004,
								54.3101074218751
							],
							[
								25.557519531250023,
								54.31069335937502
							],
							[
								25.54736328125,
								54.33183593749999
							],
							[
								25.56757812500004,
								54.37705078125006
							],
							[
								25.62031250000004,
								54.46040039062498
							],
							[
								25.685156250000006,
								54.53579101562505
							],
							[
								25.72480468750001,
								54.5642578125001
							],
							[
								25.731640625000068,
								54.59038085937499
							],
							[
								25.723925781250017,
								54.636035156250045
							],
							[
								25.722460937500074,
								54.717871093750034
							],
							[
								25.780859375000063,
								54.833251953125
							],
							[
								25.85927734375005,
								54.919287109375034
							],
							[
								25.964453125000063,
								54.94716796875002
							],
							[
								26.09296875000004,
								54.96230468750008
							],
							[
								26.175195312500023,
								55.00327148437509
							],
							[
								26.21582031250003,
								55.050390625000006
							],
							[
								26.231250000000074,
								55.09013671875002
							],
							[
								26.250781250000045,
								55.124511718750085
							],
							[
								26.291796875000045,
								55.13959960937507
							],
							[
								26.601171875000034,
								55.1301757812501
							],
							[
								26.648437500000057,
								55.20419921875009
							],
							[
								26.675000000000068,
								55.224902343750045
							],
							[
								26.73437499999997,
								55.24677734375004
							],
							[
								26.775683593750045,
								55.273095703124994
							],
							[
								26.76015625000008,
								55.29335937500002
							],
							[
								26.681250000000006,
								55.306445312500045
							],
							[
								26.49531250000004,
								55.318017578124994
							],
							[
								26.457617187500006,
								55.34248046875001
							],
							[
								26.469531250000017,
								55.37192382812506
							],
							[
								26.51923828125004,
								55.44814453125005
							],
							[
								26.56660156250001,
								55.54648437500009
							],
							[
								26.590820312500057,
								55.62265624999998
							],
							[
								26.593554687500074,
								55.66752929687496
							],
							[
								26.620214843750006,
								55.67963867187504
							],
							[
								26.77187500000008,
								55.69399414062502
							],
							[
								26.822460937500068,
								55.70922851562503
							],
							[
								26.953027343750023,
								55.81293945312501
							],
							[
								27.052539062500045,
								55.83056640625006
							],
							[
								27.309179687500034,
								55.80390625000004
							],
							[
								27.42714843750008,
								55.80595703125002
							],
							[
								27.45917968750004,
								55.80351562499996
							],
							[
								27.576757812500006,
								55.79877929687507
							],
							[
								27.589453125000006,
								55.80917968750006
							],
							[
								27.64228515625004,
								55.91171874999998
							],
							[
								27.69423828125005,
								55.94155273437502
							],
							[
								27.89628906249999,
								56.076171875
							],
							[
								28.032031250000017,
								56.13330078125
							],
							[
								28.11787109375001,
								56.14580078124996
							],
							[
								28.14794921875003,
								56.142919921875006
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "BLR",
					"su_a3": "BLR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "BLR",
					"gu_a3": "BLR",
					"abbrev": "Bela.",
					"region_un": "Europe",
					"adm0_a3_us": "BLR",
					"scalerank": 1,
					"pop_est": 9648533,
					"adm0_dif": 0,
					"un_a3": "112",
					"pop_year": -99,
					"gdp_md_est": 114100,
					"name": "Belarus",
					"sovereignt": "Belarus",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Belarus",
					"postal": "BY",
					"sov_a3": "BLR",
					"note_brk": "",
					"brk_a3": "BLR",
					"wb_a2": "BY",
					"brk_diff": 0,
					"admin": "Belarus",
					"name_long": "Belarus",
					"iso_a3": "BLR",
					"iso_a2": "BY",
					"adm0_a3_is": "BLR",
					"level": 2,
					"formal_en": "Republic of Belarus",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "112",
					"homepart": 1,
					"subunit": "Belarus",
					"name_alt": "",
					"brk_name": "Belarus",
					"name_sort": "Belarus",
					"continent": "Europe",
					"mapcolor13": 11,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-68.97995539471842,
									-16.239762601672524
								],
								[
									-69.04624023437498,
									-16.21767578124998
								],
								[
									-69.13280677061198,
									-16.22190557313712
								],
								[
									-69.12065429687496,
									-16.17812500000001
								],
								[
									-69.10703124999995,
									-16.13242187500002
								],
								[
									-69.10258789062502,
									-16.08662109375001
								],
								[
									-69.07744140624996,
									-16.081347656250003
								],
								[
									-69.01474609374998,
									-16.11083984374997
								],
								[
									-68.94677734374997,
									-16.17587890624999
								],
								[
									-68.89091796874996,
									-16.20566406250002
								],
								[
									-68.88520507812495,
									-16.24072265624997
								],
								[
									-68.90532226562496,
									-16.24140625000001
								],
								[
									-68.946044921875,
									-16.223339843749983
								],
								[
									-68.97995539471842,
									-16.239762601672524
								]
							]
						],
						[
							[
								[
									-58.159765625000006,
									-20.16464843750002
								],
								[
									-58.13994140624996,
									-19.99882812499999
								],
								[
									-58.160058593749966,
									-19.854882812499966
								],
								[
									-58.18017578124997,
									-19.81787109374997
								],
								[
									-58.47421874999992,
									-19.646093749999977
								],
								[
									-58.74111328124994,
									-19.490234375000014
								],
								[
									-59.09052734374998,
									-19.28623046875002
								],
								[
									-59.54086914062498,
									-19.291796875000003
								],
								[
									-60.00737304687499,
									-19.297558593750026
								],
								[
									-60.45161132812498,
									-19.38876953125005
								],
								[
									-60.88876953124998,
									-19.47851562500003
								],
								[
									-61.09599609374999,
									-19.520996093749986
								],
								[
									-61.51181640624998,
									-19.606445312499986
								],
								[
									-61.75683593749997,
									-19.64531249999999
								],
								[
									-61.82089843749998,
									-19.809472656250037
								],
								[
									-61.91694335937501,
									-20.05537109375004
								],
								[
									-62.01181640624998,
									-20.199023437500003
								],
								[
									-62.12163085937496,
									-20.349902343750003
								],
								[
									-62.27631835937504,
									-20.56249999999997
								],
								[
									-62.276513671874966,
									-20.820800781250014
								],
								[
									-62.27666015625002,
									-21.066015624999977
								],
								[
									-62.385449218749955,
									-21.411718749999963
								],
								[
									-62.47783203124996,
									-21.705273437499997
								],
								[
									-62.56694335937499,
									-21.98867187500001
								],
								[
									-62.62851562499992,
									-22.18398437500001
								],
								[
									-62.65097656249998,
									-22.233691406250003
								],
								[
									-62.66528320312494,
									-22.217968749999997
								],
								[
									-62.744580078124955,
									-22.15986328124997
								],
								[
									-62.81508789062502,
									-22.04960937499999
								],
								[
									-62.83427734375002,
									-21.999121093750006
								],
								[
									-62.843359375000006,
									-21.997265624999983
								],
								[
									-63.26718749999992,
									-22.00058593749995
								],
								[
									-63.67534179687493,
									-22.004296874999994
								],
								[
									-63.716943359374966,
									-22.02753906250001
								],
								[
									-63.775585937499926,
									-22.02724609375005
								],
								[
									-63.81865234375002,
									-22.005468749999963
								],
								[
									-63.861035156249926,
									-22.007226562499966
								],
								[
									-63.92167968749993,
									-22.028613281249974
								],
								[
									-63.97612304687493,
									-22.072558593750045
								],
								[
									-64.13183593749994,
									-22.365820312500006
								],
								[
									-64.20908203124998,
									-22.49130859374999
								],
								[
									-64.26640625000002,
									-22.60332031249999
								],
								[
									-64.30791015624993,
									-22.795312500000023
								],
								[
									-64.32529296874992,
									-22.827636718750043
								],
								[
									-64.37397460937498,
									-22.761035156249974
								],
								[
									-64.44550781249998,
									-22.585351562499966
								],
								[
									-64.47773437499998,
									-22.485351562499943
								],
								[
									-64.52363281250001,
									-22.37158203125003
								],
								[
									-64.60551757812499,
									-22.22880859374999
								],
								[
									-64.70009765625,
									-22.18554687499997
								],
								[
									-64.75864257812492,
									-22.171289062499994
								],
								[
									-64.84306640624999,
									-22.143945312500023
								],
								[
									-64.99262695312498,
									-22.10966796874996
								],
								[
									-65.05781249999995,
									-22.10273437499997
								],
								[
									-65.48486328125,
									-22.09814453124993
								],
								[
									-65.51879882812497,
									-22.09453124999999
								],
								[
									-65.68618164062497,
									-22.110253906249994
								],
								[
									-65.77104492187493,
									-22.099609374999957
								],
								[
									-65.86015624999999,
									-22.01972656249994
								],
								[
									-66.05859375,
									-21.879492187499963
								],
								[
									-66.09858398437498,
									-21.835058593749977
								],
								[
									-66.17465820312492,
									-21.80566406250003
								],
								[
									-66.22016601562495,
									-21.802539062500003
								],
								[
									-66.24760742187496,
									-21.83046875000001
								],
								[
									-66.28212890624997,
									-21.94746093750004
								],
								[
									-66.32246093750001,
									-22.053124999999994
								],
								[
									-66.36518554687501,
									-22.113769531249915
								],
								[
									-66.50698242187494,
									-22.158398437500026
								],
								[
									-66.63901367187495,
									-22.205371093750003
								],
								[
									-66.71171875000002,
									-22.216308593750014
								],
								[
									-66.75063476562494,
									-22.26933593749999
								],
								[
									-66.76748046875,
									-22.34306640624999
								],
								[
									-66.80029296875003,
									-22.40966796874997
								],
								[
									-66.99111328125,
									-22.509863281249963
								],
								[
									-67.03354492187492,
									-22.55224609374997
								],
								[
									-67.05541992187494,
									-22.650878906249915
								],
								[
									-67.16191406249996,
									-22.773828124999994
								],
								[
									-67.19487304687493,
									-22.821679687500065
								],
								[
									-67.36225585937493,
									-22.85517578124997
								],
								[
									-67.57993164062495,
									-22.89169921874995
								],
								[
									-67.70732421874999,
									-22.889160156249957
								],
								[
									-67.79443359374997,
									-22.87949218749995
								],
								[
									-67.82050781249995,
									-22.85771484375003
								],
								[
									-67.87944335937496,
									-22.82294921874997
								],
								[
									-67.88916015624997,
									-22.78417968749997
								],
								[
									-67.88999023437498,
									-22.72919921874997
								],
								[
									-67.87373046874995,
									-22.63056640625004
								],
								[
									-67.88173828125,
									-22.49335937499997
								],
								[
									-67.95039062499993,
									-22.333691406249955
								],
								[
									-67.94492187499998,
									-22.28222656250003
								],
								[
									-67.95390624999993,
									-22.204003906249994
								],
								[
									-67.98837890624995,
									-22.05712890625
								],
								[
									-68.07675781249992,
									-21.982812499999966
								],
								[
									-68.10180664062497,
									-21.86064453125003
								],
								[
									-68.11215820312495,
									-21.753027343749963
								],
								[
									-68.18642578124997,
									-21.618554687499923
								],
								[
									-68.19853515624996,
									-21.447265625000014
								],
								[
									-68.197021484375,
									-21.30029296875
								],
								[
									-68.3138671875,
									-21.129687499999974
								],
								[
									-68.43549804687501,
									-20.948242187499957
								],
								[
									-68.53383789062497,
									-20.923632812500003
								],
								[
									-68.55825195312497,
									-20.90195312499995
								],
								[
									-68.5689453125,
									-20.849804687499983
								],
								[
									-68.571044921875,
									-20.769140624999977
								],
								[
									-68.56318359374998,
									-20.720117187500023
								],
								[
									-68.48740234375,
									-20.64072265625002
								],
								[
									-68.48432617187501,
									-20.62841796875
								],
								[
									-68.49985351562498,
									-20.612011718750026
								],
								[
									-68.69580078125,
									-20.492968750000017
								],
								[
									-68.74516601562493,
									-20.458593750000034
								],
								[
									-68.76054687499996,
									-20.41621093750001
								],
								[
									-68.75922851562495,
									-20.378027343749963
								],
								[
									-68.7123046875,
									-20.338964843750006
								],
								[
									-68.68857421874995,
									-20.31005859374997
								],
								[
									-68.73457031250001,
									-20.22519531249992
								],
								[
									-68.73002929687496,
									-20.148437499999915
								],
								[
									-68.75932617187499,
									-20.11552734374996
								],
								[
									-68.75581054687498,
									-20.090820312499986
								],
								[
									-68.72749023437498,
									-20.069628906250017
								],
								[
									-68.60019531249998,
									-20.044921874999957
								],
								[
									-68.56069335937502,
									-19.967089843749918
								],
								[
									-68.55937500000002,
									-19.902343749999957
								],
								[
									-68.57827148437497,
									-19.856542968750034
								],
								[
									-68.69619140625,
									-19.740722656249986
								],
								[
									-68.69829101562499,
									-19.72109374999998
								],
								[
									-68.57529296874998,
									-19.560156249999963
								],
								[
									-68.48701171875001,
									-19.454394531249918
								],
								[
									-68.46289062499997,
									-19.43281250000004
								],
								[
									-68.47016601562495,
									-19.409960937500003
								],
								[
									-68.49199218749996,
									-19.381933593749977
								],
								[
									-68.54785156249997,
									-19.341113281249932
								],
								[
									-68.62055664062495,
									-19.296679687500017
								],
								[
									-68.68066406250003,
									-19.24238281249997
								],
								[
									-68.75908203125002,
									-19.162207031249977
								],
								[
									-68.85795898437499,
									-19.09335937499999
								],
								[
									-68.93100585937495,
									-19.02519531249996
								],
								[
									-68.96831054687502,
									-18.96796874999994
								],
								[
									-68.969091796875,
									-18.909667968749957
								],
								[
									-68.97885742187495,
									-18.812988281249986
								],
								[
									-69.02680664062493,
									-18.65625000000003
								],
								[
									-69.03940429687492,
									-18.550097656249974
								],
								[
									-69.06015624999998,
									-18.433007812500023
								],
								[
									-69.08095703124997,
									-18.356640624999997
								],
								[
									-69.09228515624994,
									-18.282421874999983
								],
								[
									-69.12636718749997,
									-18.202441406249946
								],
								[
									-69.14545898437495,
									-18.14404296875003
								],
								[
									-69.11806640624997,
									-18.10273437499997
								],
								[
									-69.09042968749992,
									-18.07070312500001
								],
								[
									-69.09394531249993,
									-18.050488281249983
								],
								[
									-69.28232421874995,
									-17.96484375000003
								],
								[
									-69.31337890624997,
									-17.94316406249996
								],
								[
									-69.3580078125,
									-17.77167968749994
								],
								[
									-69.49501953125002,
									-17.619531250000023
								],
								[
									-69.51093749999998,
									-17.506054687499997
								],
								[
									-69.51108398437492,
									-17.50488281250003
								],
								[
									-69.510986328125,
									-17.46035156250001
								],
								[
									-69.52192382812501,
									-17.38896484375003
								],
								[
									-69.563818359375,
									-17.33291015624998
								],
								[
									-69.62587890624994,
									-17.294433593749957
								],
								[
									-69.64570312499998,
									-17.24853515625003
								],
								[
									-69.624853515625,
									-17.200195312500043
								],
								[
									-69.50332031249994,
									-17.10478515624996
								],
								[
									-69.43833007812492,
									-17.08837890625
								],
								[
									-69.42109374999998,
									-17.0400390625
								],
								[
									-69.38154296875001,
									-17.001367187500037
								],
								[
									-69.267236328125,
									-16.86093750000002
								],
								[
									-69.19980468749992,
									-16.76845703125001
								],
								[
									-69.13251953124998,
									-16.71308593750001
								],
								[
									-69.054541015625,
									-16.674316406250014
								],
								[
									-69.02070312500004,
									-16.64218750000005
								],
								[
									-69.03837890624999,
									-16.542675781250026
								],
								[
									-69.03753779494983,
									-16.532417227357527
								],
								[
									-69.00639648437496,
									-16.55058593750003
								],
								[
									-68.94223632812495,
									-16.582324218750017
								],
								[
									-68.904150390625,
									-16.58935546875003
								],
								[
									-68.87104492187501,
									-16.58935546875003
								],
								[
									-68.86250000000004,
									-16.56865234374999
								],
								[
									-68.85625000000002,
									-16.54746093750002
								],
								[
									-68.85786132812498,
									-16.524023437500034
								],
								[
									-68.86816406249994,
									-16.500097656249963
								],
								[
									-68.89726562500002,
									-16.464550781249997
								],
								[
									-68.92841796874995,
									-16.44824218749997
								],
								[
									-68.90634765625,
									-16.42392578124999
								],
								[
									-68.86005859374998,
									-16.415136718749977
								],
								[
									-68.78749999999994,
									-16.406933593749983
								],
								[
									-68.73906249999993,
									-16.382812499999957
								],
								[
									-68.71245117187493,
									-16.358789062500037
								],
								[
									-68.70537109374999,
									-16.339257812499966
								],
								[
									-68.69331054687504,
									-16.32626953124999
								],
								[
									-68.65468749999997,
									-16.318261718750037
								],
								[
									-68.61152343749998,
									-16.3115234375
								],
								[
									-68.58833007812495,
									-16.30175781249997
								],
								[
									-68.58613281249995,
									-16.28808593750003
								],
								[
									-68.59350585937494,
									-16.27187500000001
								],
								[
									-68.59326171875,
									-16.238769531250014
								],
								[
									-68.63515625,
									-16.221093749999966
								],
								[
									-68.69404296875001,
									-16.21923828125003
								],
								[
									-68.76440429687494,
									-16.20234374999997
								],
								[
									-68.82919921875,
									-16.19023437499999
								],
								[
									-68.87094726562498,
									-16.13603515624996
								],
								[
									-68.88872070312496,
									-16.084374999999994
								],
								[
									-68.853173828125,
									-16.049023437499997
								],
								[
									-68.82641601562497,
									-16.01718749999999
								],
								[
									-68.80932617187494,
									-15.99404296874998
								],
								[
									-68.79609375000001,
									-15.971972656250017
								],
								[
									-68.83134765624999,
									-15.947656250000037
								],
								[
									-68.90380859375003,
									-15.943457031249977
								],
								[
									-68.99453125000002,
									-15.925683593749994
								],
								[
									-69.014404296875,
									-15.910156250000028
								],
								[
									-69.014404296875,
									-15.848437499999989
								],
								[
									-69.03867187499995,
									-15.795605468749969
								],
								[
									-69.10263671874992,
									-15.764746093749991
								],
								[
									-69.14667968750001,
									-15.724511718749966
								],
								[
									-69.17011718750001,
									-15.69697265625004
								],
								[
									-69.18950195312496,
									-15.678515625000003
								],
								[
									-69.22373046875,
									-15.66015625
								],
								[
									-69.26953125,
									-15.627539062500006
								],
								[
									-69.29882812500003,
									-15.621386718750003
								],
								[
									-69.36054687499998,
									-15.511132812500009
								],
								[
									-69.36469483081456,
									-15.509271202700901
								],
								[
									-69.30190429687494,
									-15.399414062499986
								],
								[
									-69.25429687500002,
									-15.332910156250023
								],
								[
									-69.17246093749995,
									-15.236621093750045
								],
								[
									-69.187109375,
									-15.198730468749957
								],
								[
									-69.33071289062494,
									-15.038964843750009
								],
								[
									-69.37470703125004,
									-14.962988281249977
								],
								[
									-69.37373046875001,
									-14.887499999999974
								],
								[
									-69.35947265624995,
									-14.795312500000023
								],
								[
									-69.276025390625,
									-14.745898437499989
								],
								[
									-69.25234374999997,
									-14.671093750000026
								],
								[
									-69.23491210937496,
									-14.597070312500037
								],
								[
									-69.19926757812499,
									-14.572558593750017
								],
								[
									-69.1626953125,
									-14.530957031249983
								],
								[
									-69.11972656249995,
									-14.470312499999977
								],
								[
									-69.05278320312499,
									-14.417578124999977
								],
								[
									-69.01313476562498,
									-14.377246093750017
								],
								[
									-69.00449218749992,
									-14.265039062499994
								],
								[
									-68.97177734375,
									-14.234374999999957
								],
								[
									-68.88032226562504,
									-14.198828125000006
								],
								[
									-68.87089843749996,
									-14.169726562500017
								],
								[
									-68.89169921874995,
									-14.094335937500034
								],
								[
									-68.93745117187504,
									-14.014648437499957
								],
								[
									-68.974267578125,
									-13.97597656249998
								],
								[
									-69.02304687499998,
									-13.7802734375
								],
								[
									-69.07412109375,
									-13.68281250000004
								],
								[
									-69.05283203125,
									-13.643945312500023
								],
								[
									-69.01752929687501,
									-13.594433593749969
								],
								[
									-68.98344726562499,
									-13.496386718749974
								],
								[
									-68.97226562499992,
									-13.382324218750014
								],
								[
									-68.98051757812502,
									-12.96259765625004
								],
								[
									-68.97861328124998,
									-12.880078125000011
								],
								[
									-68.933740234375,
									-12.822070312500003
								],
								[
									-68.86767578125003,
									-12.75517578124996
								],
								[
									-68.81181640625002,
									-12.729589843749991
								],
								[
									-68.75908203125002,
									-12.687207031249969
								],
								[
									-68.76289062499998,
									-12.607714843750031
								],
								[
									-68.72812499999992,
									-12.560742187499969
								],
								[
									-68.68525390624998,
									-12.501953124999986
								],
								[
									-68.818701171875,
									-12.270410156249966
								],
								[
									-68.93603515625,
									-12.066796874999966
								],
								[
									-69.04619140624999,
									-11.875683593750026
								],
								[
									-69.17373046874994,
									-11.654296874999957
								],
								[
									-69.25771484375,
									-11.508593750000017
								],
								[
									-69.36201171875001,
									-11.327539062499994
								],
								[
									-69.45361328125003,
									-11.168749999999974
								],
								[
									-69.57861328125,
									-10.951757812500006
								],
								[
									-69.462548828125,
									-10.94814453124998
								],
								[
									-69.228515625,
									-10.955664062499906
								],
								[
									-69.00166015624995,
									-10.994335937499969
								],
								[
									-68.84833984374998,
									-11.011132812499923
								],
								[
									-68.78408203124997,
									-11.044628906249912
								],
								[
									-68.769921875,
									-11.097656249999972
								],
								[
									-68.72749023437498,
									-11.122460937499966
								],
								[
									-68.678369140625,
									-11.112792968749943
								],
								[
									-68.62265624999995,
									-11.109179687499918
								],
								[
									-68.49833984375002,
									-11.054785156249935
								],
								[
									-68.39799804687499,
									-11.018749999999969
								],
								[
									-68.31113281249998,
									-10.975195312499977
								],
								[
									-68.26660156249997,
									-10.933105468749929
								],
								[
									-68.15864257812498,
									-10.785058593749966
								],
								[
									-68.07167968749997,
									-10.703124999999972
								],
								[
									-67.99169921875,
									-10.674414062499892
								],
								[
									-67.83500976562496,
									-10.662792968749926
								],
								[
									-67.78569335937496,
									-10.686035156249957
								],
								[
									-67.72177734374998,
									-10.683105468749886
								],
								[
									-67.66665039062494,
									-10.598925781249974
								],
								[
									-67.58242187500002,
									-10.505957031249949
								],
								[
									-67.41694335937498,
									-10.389843749999926
								],
								[
									-67.33271484374995,
									-10.357910156249986
								],
								[
									-67.28046874999995,
									-10.317285156249966
								],
								[
									-67.19047851562502,
									-10.311425781249937
								],
								[
									-67.11152343750001,
									-10.26894531249998
								],
								[
									-66.72998046875,
									-9.975488281249966
								],
								[
									-66.57534179687502,
									-9.899902343749943
								],
								[
									-66.47890625,
									-9.88613281249998
								],
								[
									-66.39921874999993,
									-9.868164062499957
								],
								[
									-66.26357421875002,
									-9.826074218749994
								],
								[
									-65.92470703125,
									-9.785449218749974
								],
								[
									-65.706787109375,
									-9.76845703124998
								],
								[
									-65.63710937500002,
									-9.809082031249915
								],
								[
									-65.55869140624995,
									-9.797460937499935
								],
								[
									-65.49199218749993,
									-9.73173828124996
								],
								[
									-65.43676757812497,
									-9.710449218749972
								],
								[
									-65.39614257812494,
									-9.712402343749929
								],
								[
									-65.33789062499997,
									-9.790234374999983
								],
								[
									-65.30932617187503,
									-9.872656249999977
								],
								[
									-65.32812499999994,
									-9.935546874999915
								],
								[
									-65.32456054687492,
									-10.026953124999977
								],
								[
									-65.29858398437497,
									-10.14677734374996
								],
								[
									-65.3130859375,
									-10.253027343749935
								],
								[
									-65.39545898437498,
									-10.392285156249969
								],
								[
									-65.4369140625,
									-10.449023437499903
								],
								[
									-65.44711914062495,
									-10.507421874999977
								],
								[
									-65.43999023437499,
									-10.58623046874996
								],
								[
									-65.40229492187495,
									-10.714746093749937
								],
								[
									-65.33403320312499,
									-10.892773437499969
								],
								[
									-65.32377929687496,
									-11.024804687499966
								],
								[
									-65.37158203125,
									-11.110351562499886
								],
								[
									-65.39360351562496,
									-11.18427734374994
								],
								[
									-65.389892578125,
									-11.246289062499969
								],
								[
									-65.37285156249999,
									-11.28994140624998
								],
								[
									-65.34238281249992,
									-11.315039062499935
								],
								[
									-65.32548828124993,
									-11.364746093749943
								],
								[
									-65.32202148437494,
									-11.439160156249997
								],
								[
									-65.28227539062493,
									-11.511035156249903
								],
								[
									-65.20620117187497,
									-11.580566406250028
								],
								[
									-65.175390625,
									-11.646875000000037
								],
								[
									-65.18974609374999,
									-11.710058593749949
								],
								[
									-65.18574218749998,
									-11.749511718749986
								],
								[
									-65.16337890624996,
									-11.765136718749972
								],
								[
									-65.14267578125,
									-11.752343749999937
								],
								[
									-65.11513671875,
									-11.735058593749969
								],
								[
									-65.09028320312498,
									-11.7412109374999
								],
								[
									-65.037109375,
									-11.829394531249918
								],
								[
									-65.03027343750003,
									-11.847363281250026
								],
								[
									-65.00122070312497,
									-11.920019531249906
								],
								[
									-64.99252929687498,
									-11.975195312499963
								],
								[
									-64.91435546874993,
									-12.005957031250006
								],
								[
									-64.82988281249996,
									-12.030273437499986
								],
								[
									-64.783447265625,
									-12.05937499999996
								],
								[
									-64.69003906249998,
									-12.146484374999943
								],
								[
									-64.611669921875,
									-12.203906249999918
								],
								[
									-64.51342773437497,
									-12.250976562499915
								],
								[
									-64.48076171874999,
									-12.326171874999957
								],
								[
									-64.42050781249995,
									-12.439746093749918
								],
								[
									-64.255029296875,
									-12.483300781249909
								],
								[
									-64.06162109374995,
									-12.505078124999912
								],
								[
									-63.93857421874992,
									-12.529687499999952
								],
								[
									-63.7880859375,
									-12.469433593749926
								],
								[
									-63.68857421874998,
									-12.4780273437499
								],
								[
									-63.585644531249955,
									-12.51894531249998
								],
								[
									-63.54189453125002,
									-12.546679687500031
								],
								[
									-63.46523437499994,
									-12.605175781250054
								],
								[
									-63.34667968749994,
									-12.680078125000037
								],
								[
									-63.249755859375,
									-12.707910156250023
								],
								[
									-63.18066406249997,
									-12.666210937500054
								],
								[
									-63.11679687499992,
									-12.651660156249932
								],
								[
									-63.067480468750006,
									-12.66914062499994
								],
								[
									-63.04135742187492,
									-12.750390624999966
								],
								[
									-63.01518554687502,
									-12.805566406250023
								],
								[
									-62.957910156249966,
									-12.847070312499952
								],
								[
									-62.83515625000001,
									-12.953710937500006
								],
								[
									-62.76547851562495,
									-12.997265624999997
								],
								[
									-62.68706054687496,
									-12.994335937500011
								],
								[
									-62.525537109374994,
									-13.06425781249996
								],
								[
									-62.35283203124999,
									-13.132421874999991
								],
								[
									-62.263916015625,
									-13.143652343749977
								],
								[
									-62.17607421874993,
									-13.13369140624998
								],
								[
									-62.11801757812492,
									-13.159765624999963
								],
								[
									-62.09477539062499,
									-13.241992187500017
								],
								[
									-61.944726562499966,
									-13.40625
								],
								[
									-61.87412109374998,
									-13.470410156250011
								],
								[
									-61.789941406249966,
									-13.525585937499983
								],
								[
									-61.57568359375003,
									-13.524804687499994
								],
								[
									-61.51157226562492,
									-13.541210937499969
								],
								[
									-61.41606445312502,
									-13.526562499999997
								],
								[
									-61.129150390625,
									-13.498535156249972
								],
								[
									-61.07700195312495,
									-13.489746093749957
								],
								[
									-60.914501953124955,
									-13.561425781249994
								],
								[
									-60.72236328124998,
									-13.664355468750003
								],
								[
									-60.59531249999995,
									-13.745312499999983
								],
								[
									-60.506591796875,
									-13.789843749999989
								],
								[
									-60.460156249999955,
									-13.862402343750034
								],
								[
									-60.42236328124997,
									-13.937988281249972
								],
								[
									-60.40498046874998,
									-14.019238281250011
								],
								[
									-60.42807617187498,
									-14.100000000000023
								],
								[
									-60.462988281250006,
									-14.132421874999977
								],
								[
									-60.47465820312499,
									-14.184765624999983
								],
								[
									-60.460156249999955,
									-14.263085937499952
								],
								[
									-60.396240234375,
									-14.332812499999946
								],
								[
									-60.372705078124994,
									-14.418750000000045
								],
								[
									-60.33803710937494,
									-14.570507812500054
								],
								[
									-60.29887695312496,
									-14.61855468749998
								],
								[
									-60.273339843749994,
									-15.088769531250023
								],
								[
									-60.402001953124994,
									-15.092773437499957
								],
								[
									-60.58320312499998,
									-15.09833984374994
								],
								[
									-60.53046874999998,
									-15.143164062500006
								],
								[
									-60.38046874999998,
									-15.31826171874998
								],
								[
									-60.242333984374994,
									-15.479589843749977
								],
								[
									-60.220410156249955,
									-15.738671875000009
								],
								[
									-60.206640625000006,
									-15.901953124999963
								],
								[
									-60.187207031249955,
									-16.13212890624996
								],
								[
									-60.17558593749999,
									-16.269335937500017
								],
								[
									-59.83115234374998,
									-16.28173828124997
								],
								[
									-59.434277343749955,
									-16.295996093750034
								],
								[
									-58.95727539062503,
									-16.313183593749983
								],
								[
									-58.53793945312495,
									-16.328222656250034
								],
								[
									-58.49658203124994,
									-16.32666015624997
								],
								[
									-58.42368164062495,
									-16.307910156249974
								],
								[
									-58.375390624999966,
									-16.283593749999994
								],
								[
									-58.34560546875002,
									-16.284374999999983
								],
								[
									-58.34057617187497,
									-16.339941406249935
								],
								[
									-58.35078125000001,
									-16.41025390625005
								],
								[
									-58.35039062500002,
									-16.49082031250002
								],
								[
									-58.470605468749994,
									-16.65019531249999
								],
								[
									-58.47812499999992,
									-16.70068359374997
								],
								[
									-58.45981445312492,
									-16.91074218750005
								],
								[
									-58.417382812499994,
									-17.08056640625
								],
								[
									-58.39599609374997,
									-17.234277343749966
								],
								[
									-58.34775390624992,
									-17.282128906250037
								],
								[
									-58.20556640625,
									-17.363085937500003
								],
								[
									-57.990917968749955,
									-17.51289062499997
								],
								[
									-57.90502929687497,
									-17.53232421875002
								],
								[
									-57.83247070312501,
									-17.512109374999994
								],
								[
									-57.78886718750002,
									-17.573046874999974
								],
								[
									-57.78017578125002,
									-17.67177734375001
								],
								[
									-57.66166992187496,
									-17.94736328125002
								],
								[
									-57.58647460937499,
									-18.122265624999955
								],
								[
									-57.55205078124999,
									-18.183105468749915
								],
								[
									-57.49565429687496,
									-18.214648437499946
								],
								[
									-57.50615234374996,
									-18.237304687499943
								],
								[
									-57.55312499999994,
									-18.246484375000037
								],
								[
									-57.57402343749993,
									-18.27929687499997
								],
								[
									-57.63916015624997,
									-18.47500000000005
								],
								[
									-57.724999999999966,
									-18.733203124999974
								],
								[
									-57.783105468749994,
									-18.91425781250001
								],
								[
									-57.73085937500002,
									-18.917187499999983
								],
								[
									-57.728613281250006,
									-18.96738281249999
								],
								[
									-57.716796875,
									-19.044042968749977
								],
								[
									-57.78144531250001,
									-19.05351562499996
								],
								[
									-57.80039062499998,
									-19.080957031250037
								],
								[
									-57.87451171874997,
									-19.22949218749993
								],
								[
									-57.97167968749994,
									-19.42421874999998
								],
								[
									-58.07202148437497,
									-19.625292968749918
								],
								[
									-58.131494140624994,
									-19.74453125000005
								],
								[
									-58.02993164062502,
									-19.832714843749983
								],
								[
									-57.860742187499994,
									-19.979589843749977
								],
								[
									-57.887597656249966,
									-20.020410156250023
								],
								[
									-57.96015625000001,
									-20.040722656249997
								],
								[
									-58.021142578124994,
									-20.05517578125
								],
								[
									-58.06762695312497,
									-20.11035156249997
								],
								[
									-58.09374999999994,
									-20.151074218749997
								],
								[
									-58.159765625000006,
									-20.16464843750002
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "BOL",
					"su_a3": "BOL",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "BOL",
					"gu_a3": "BOL",
					"abbrev": "Bolivia",
					"region_un": "Americas",
					"adm0_a3_us": "BOL",
					"scalerank": 1,
					"pop_est": 9775246,
					"adm0_dif": 0,
					"un_a3": "068",
					"pop_year": -99,
					"gdp_md_est": 43270,
					"name": "Bolivia",
					"sovereignt": "Bolivia",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 7,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Bolivia",
					"postal": "BO",
					"sov_a3": "BOL",
					"note_brk": "",
					"brk_a3": "BOL",
					"wb_a2": "BO",
					"brk_diff": 0,
					"admin": "Bolivia",
					"name_long": "Bolivia",
					"iso_a3": "BOL",
					"iso_a2": "BO",
					"adm0_a3_is": "BOL",
					"level": 2,
					"formal_en": "Plurinational State of Bolivia",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 5,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "068",
					"homepart": 1,
					"subunit": "Bolivia",
					"name_alt": "",
					"brk_name": "Bolivia",
					"name_sort": "Bolivia",
					"continent": "South America",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-48.48588867187496,
									-27.76699218750001
								],
								[
									-48.554589843749994,
									-27.812207031250068
								],
								[
									-48.542187499999955,
									-27.57480468750002
								],
								[
									-48.50517578124996,
									-27.49550781249995
								],
								[
									-48.464746093749994,
									-27.436328124999974
								],
								[
									-48.41489257812495,
									-27.399609374999955
								],
								[
									-48.37792968749997,
									-27.45146484375003
								],
								[
									-48.40957031250002,
									-27.566308593750065
								],
								[
									-48.496777343749955,
									-27.707031250000057
								],
								[
									-48.48588867187496,
									-27.76699218750001
								]
							]
						],
						[
							[
								[
									-48.584423828124955,
									-26.40156250000001
								],
								[
									-48.60307617187502,
									-26.41376953125001
								],
								[
									-48.665771484375,
									-26.289648437500034
								],
								[
									-48.53974609374998,
									-26.17031249999998
								],
								[
									-48.49760742187502,
									-26.21875000000007
								],
								[
									-48.531103515625006,
									-26.313183593749955
								],
								[
									-48.56806640624998,
									-26.379687500000003
								],
								[
									-48.584423828124955,
									-26.40156250000001
								]
							]
						],
						[
							[
								[
									-45.26025390624997,
									-23.889160156249943
								],
								[
									-45.260888671874994,
									-23.94130859375008
								],
								[
									-45.30253906249996,
									-23.914746093749997
								],
								[
									-45.41284179687497,
									-23.934960937500037
								],
								[
									-45.451416015625,
									-23.895605468750006
								],
								[
									-45.302343750000006,
									-23.727539062500057
								],
								[
									-45.27226562500002,
									-23.751953125000057
								],
								[
									-45.24907226562499,
									-23.78261718750008
								],
								[
									-45.233105468749926,
									-23.825390624999997
								],
								[
									-45.25029296874999,
									-23.853027343750043
								],
								[
									-45.26025390624997,
									-23.889160156249943
								]
							]
						],
						[
							[
								[
									-44.12929687499994,
									-23.141894531250017
								],
								[
									-44.098046874999966,
									-23.169335937500023
								],
								[
									-44.15576171875,
									-23.16660156249999
								],
								[
									-44.22050781249996,
									-23.190820312500037
								],
								[
									-44.320068359375,
									-23.212304687500065
								],
								[
									-44.36015624999999,
									-23.17207031250004
								],
								[
									-44.274121093749955,
									-23.11621093750003
								],
								[
									-44.24287109374998,
									-23.074121093750065
								],
								[
									-44.220410156249955,
									-23.082910156249994
								],
								[
									-44.191601562499955,
									-23.11328124999997
								],
								[
									-44.12929687499994,
									-23.141894531250017
								]
							]
						],
						[
							[
								[
									-38.903564453125,
									-13.473437500000017
								],
								[
									-38.937890624999966,
									-13.532324218749935
								],
								[
									-38.97758789062496,
									-13.52353515624992
								],
								[
									-38.99321289062496,
									-13.484082031250054
								],
								[
									-39.02216796874998,
									-13.445605468750031
								],
								[
									-39.00659179687503,
									-13.415527343749943
								],
								[
									-38.980126953124966,
									-13.398437500000014
								],
								[
									-38.907128906249994,
									-13.401074218750011
								],
								[
									-38.903564453125,
									-13.473437500000017
								]
							]
						],
						[
							[
								[
									-38.743847656249955,
									-13.09707031250008
								],
								[
									-38.78300781249993,
									-13.118652343750028
								],
								[
									-38.786962890625034,
									-13.055078125000051
								],
								[
									-38.68486328125002,
									-12.97490234375006
								],
								[
									-38.668115234374994,
									-12.880175781249946
								],
								[
									-38.61455078124999,
									-12.924023437499997
								],
								[
									-38.60029296875001,
									-12.972460937499918
								],
								[
									-38.601171875000034,
									-12.992578125000009
								],
								[
									-38.743847656249955,
									-13.09707031250008
								]
							]
						],
						[
							[
								[
									-44.49931640625002,
									-2.9396484375000114
								],
								[
									-44.597753906250006,
									-3.0375976562499005
								],
								[
									-44.565332031249966,
									-2.9239257812500057
								],
								[
									-44.58188476562495,
									-2.845605468750037
								],
								[
									-44.56909179687503,
									-2.784960937499946
								],
								[
									-44.50195312500003,
									-2.7262695312499687
								],
								[
									-44.48144531250003,
									-2.7175781249999744
								],
								[
									-44.48730468749997,
									-2.7897460937500256
								],
								[
									-44.482568359374966,
									-2.8119140624999233
								],
								[
									-44.49931640625002,
									-2.9396484375000114
								]
							]
						],
						[
							[
								[
									-44.88310546874996,
									-1.3178710937500142
								],
								[
									-44.947119140625034,
									-1.3660156249999602
								],
								[
									-44.967871093750006,
									-1.3908203124999545
								],
								[
									-45.020849609375034,
									-1.3723632812499318
								],
								[
									-45.01123046875003,
									-1.3447265624998863
								],
								[
									-44.99560546874997,
									-1.3475585937500227
								],
								[
									-44.978662109374966,
									-1.2672851562500114
								],
								[
									-44.888281250000034,
									-1.2768554687499147
								],
								[
									-44.88310546874996,
									-1.3178710937500142
								]
							]
						],
						[
							[
								[
									-51.83251953124997,
									-1.433789062499912
								],
								[
									-51.938378906249966,
									-1.4526367187499432
								],
								[
									-51.80205078124999,
									-1.202539062499966
								],
								[
									-51.680029296875006,
									-1.086132812500054
								],
								[
									-51.67827148437499,
									-0.855078124999963
								],
								[
									-51.546044921874966,
									-0.6496093749999403
								],
								[
									-51.424462890624994,
									-0.5659179687499432
								],
								[
									-51.25400390624998,
									-0.5414062499999233
								],
								[
									-51.16074218749998,
									-0.6666992187499545
								],
								[
									-51.27631835937501,
									-1.0217773437499176
								],
								[
									-51.31010742187496,
									-1.02382812499998
								],
								[
									-51.46513671875002,
									-1.2111328124999403
								],
								[
									-51.6376953125,
									-1.3418945312499346
								],
								[
									-51.83251953124997,
									-1.433789062499912
								]
							]
						],
						[
							[
								[
									-49.62866210937497,
									-0.2291992187499119
								],
								[
									-49.53520507812502,
									-0.2335937499999261
								],
								[
									-49.40288085937499,
									-0.21464843749997442
								],
								[
									-49.31425781249996,
									-0.16787109374993747
								],
								[
									-49.215087890625,
									-0.15869140624994316
								],
								[
									-49.11699218749999,
									-0.16357421875004263
								],
								[
									-48.78657226562501,
									-0.21552734374996874
								],
								[
									-48.588037109374966,
									-0.231640625000054
								],
								[
									-48.51542968750002,
									-0.24824218749996874
								],
								[
									-48.44448242187494,
									-0.27187499999990905
								],
								[
									-48.39267578124998,
									-0.29736328124994316
								],
								[
									-48.37968749999999,
									-0.3528320312499602
								],
								[
									-48.42802734374996,
									-0.4415039062499062
								],
								[
									-48.463964843750006,
									-0.5347656249999915
								],
								[
									-48.497460937499994,
									-0.6649414062499517
								],
								[
									-48.52333984375002,
									-0.691406249999929
								],
								[
									-48.56665039062497,
									-0.6844726562499375
								],
								[
									-48.539697265624994,
									-0.8009765624999545
								],
								[
									-48.549511718749955,
									-0.8475585937499517
								],
								[
									-48.570947265624966,
									-0.892871093749946
								],
								[
									-48.62407226562493,
									-0.9869140624999204
								],
								[
									-48.70458984375,
									-1.1066406249999687
								],
								[
									-48.728515625,
									-1.1317382812499375
								],
								[
									-48.78984374999996,
									-1.1733398437500568
								],
								[
									-48.839697265625006,
									-1.2265624999999716
								],
								[
									-48.82900390624994,
									-1.2765624999999545
								],
								[
									-48.804052734375006,
									-1.3269531249999176
								],
								[
									-48.833593750000006,
									-1.39003906249998
								],
								[
									-48.928906249999955,
									-1.4823242187499517
								],
								[
									-48.985937500000034,
									-1.5046875000000597
								],
								[
									-49.038476562499994,
									-1.5140624999999233
								],
								[
									-49.08686523437498,
									-1.5050781249999687
								],
								[
									-49.17270507812498,
									-1.4125976562499574
								],
								[
									-49.18168945312496,
									-1.4849609374999488
								],
								[
									-49.204785156249955,
									-1.5589843749999375
								],
								[
									-49.233984375000034,
									-1.5995117187499233
								],
								[
									-49.34482421874998,
									-1.5952148437500284
								],
								[
									-49.406591796875034,
									-1.5555664062499517
								],
								[
									-49.50664062499999,
									-1.5116210937500512
								],
								[
									-49.52568359374996,
									-1.6304687499999346
								],
								[
									-49.587890625,
									-1.712402343749929
								],
								[
									-49.65058593749998,
									-1.7380859375000028
								],
								[
									-49.74877929687503,
									-1.7553710937499716
								],
								[
									-49.805126953124955,
									-1.7902343749999687
								],
								[
									-49.91132812500001,
									-1.7629882812499318
								],
								[
									-50.009960937499926,
									-1.7084960937500142
								],
								[
									-50.06572265625002,
									-1.7038085937499545
								],
								[
									-50.109277343749994,
									-1.747851562499946
								],
								[
									-50.33842773437496,
									-1.7559570312499204
								],
								[
									-50.44345703124998,
									-1.800683593749966
								],
								[
									-50.50761718749999,
									-1.7879882812499517
								],
								[
									-50.60205078125003,
									-1.6977539062499574
								],
								[
									-50.6171875,
									-1.6376953124998863
								],
								[
									-50.67338867187499,
									-1.516015624999966
								],
								[
									-50.72382812499998,
									-1.3714843749999233
								],
								[
									-50.759765625,
									-1.2402343749999147
								],
								[
									-50.72949218749997,
									-1.1267578124998892
								],
								[
									-50.668310546875034,
									-1.1305664062499545
								],
								[
									-50.595898437499926,
									-1.1474609374999432
								],
								[
									-50.58051757812501,
									-1.1394531249999034
								],
								[
									-50.57695312499999,
									-1.103124999999963
								],
								[
									-50.59291992187494,
									-1.0729492187499403
								],
								[
									-50.70961914062502,
									-1.0777343749999488
								],
								[
									-50.783300781250006,
									-1.0103515624999773
								],
								[
									-50.796093749999955,
									-0.90625
								],
								[
									-50.78095703124998,
									-0.6898437499999659
								],
								[
									-50.771386718749994,
									-0.6454101562499801
								],
								[
									-50.71992187499998,
									-0.5833984374999517
								],
								[
									-50.70307617187501,
									-0.5285156249999687
								],
								[
									-50.71582031250003,
									-0.4702148437499858
								],
								[
									-50.69370117187498,
									-0.3644531249999403
								],
								[
									-50.6455078125,
									-0.27285156249992326
								],
								[
									-50.46157226562502,
									-0.15742187499994031
								],
								[
									-50.24824218749998,
									-0.11640625000002558
								],
								[
									-49.62866210937497,
									-0.2291992187499119
								]
							]
						],
						[
							[
								[
									-50.65288085937499,
									-0.1316406249999318
								],
								[
									-50.926367187500034,
									-0.32734375000001137
								],
								[
									-51.01899414062498,
									-0.26308593750006537
								],
								[
									-51.03808593749997,
									-0.225878906249946
								],
								[
									-51.022363281249966,
									-0.18837890624995168
								],
								[
									-51.025732421875006,
									-0.17236328125005684
								],
								[
									-50.99506835937498,
									-0.10527343749997442
								],
								[
									-50.84218750000002,
									-0.05019531250003695
								],
								[
									-50.765283203124994,
									-0.04086914062492042
								],
								[
									-50.66699218750003,
									-0.05800781249993747
								],
								[
									-50.65058593749998,
									-0.10585937500000853
								],
								[
									-50.65288085937499,
									-0.1316406249999318
								]
							]
						],
						[
							[
								[
									-49.44389648437499,
									-0.11240234374992042
								],
								[
									-49.70883789062495,
									-0.1437499999999119
								],
								[
									-49.83007812499997,
									-0.0938964843749659
								],
								[
									-49.80268554687498,
									-0.051855468750019895
								],
								[
									-49.712304687499966,
									0.015136718750042633
								],
								[
									-49.602197265624994,
									0.06269531250003979
								],
								[
									-49.50346679687496,
									0.083691406250054
								],
								[
									-49.400488281250034,
									0.05722656250009095
								],
								[
									-49.37231445312497,
									0.0010742187500198952
								],
								[
									-49.38085937500003,
									-0.055468750000045475
								],
								[
									-49.44389648437499,
									-0.11240234374992042
								]
							]
						],
						[
							[
								[
									-49.73823242187501,
									0.26816406250007674
								],
								[
									-49.697265625,
									0.21596679687500853
								],
								[
									-49.838964843750006,
									0.006884765625045475
								],
								[
									-49.917089843750034,
									-0.023193359375042633
								],
								[
									-50.00249023437502,
									-0.029296875000042633
								],
								[
									-50.113134765625006,
									0.033007812500031264
								],
								[
									-50.285595703124955,
									0.028564453125113687
								],
								[
									-50.339453125000006,
									0.043359375000108
								],
								[
									-50.345117187499994,
									0.13447265625009663
								],
								[
									-50.27265624999998,
									0.23173828125001705
								],
								[
									-50.12797851562499,
									0.22651367187502558
								],
								[
									-49.87900390624998,
									0.30454101562493463
								],
								[
									-49.73823242187501,
									0.26816406250007674
								]
							]
						],
						[
							[
								[
									-50.42612304687498,
									0.13925781250010516
								],
								[
									-50.44394531249998,
									-0.007666015624906208
								],
								[
									-50.623925781249966,
									0.054394531249954525
								],
								[
									-50.61044921874998,
									0.2047851562500398
								],
								[
									-50.526220703125034,
									0.24692382812509095
								],
								[
									-50.45156250000002,
									0.32690429687504263
								],
								[
									-50.42607421874999,
									0.4249511718749517
								],
								[
									-50.42456054687503,
									0.5582519531250227
								],
								[
									-50.396874999999966,
									0.5813964843750199
								],
								[
									-50.372753906249955,
									0.5908691406250028
								],
								[
									-50.350976562499966,
									0.5817382812500966
								],
								[
									-50.342529296875,
									0.381591796875
								],
								[
									-50.33227539062497,
									0.25903320312507105
								],
								[
									-50.42612304687498,
									0.13925781250010516
								]
							]
						],
						[
							[
								[
									-50.152929687500006,
									0.39301757812511084
								],
								[
									-50.26132812499998,
									0.3591796875000455
								],
								[
									-50.28154296875002,
									0.39082031250009663
								],
								[
									-50.281689453124955,
									0.5165039062499517
								],
								[
									-50.251171874999955,
									0.5854492187500568
								],
								[
									-50.11279296875,
									0.6047363281249858
								],
								[
									-50.09863281249997,
									0.6250000000000284
								],
								[
									-50.05883789062503,
									0.6380371093750199
								],
								[
									-50.03681640624998,
									0.594824218750091
								],
								[
									-50.04003906250003,
									0.5228027343749915
								],
								[
									-50.152929687500006,
									0.39301757812511084
								]
							]
						],
						[
							[
								[
									-50.29897460937502,
									1.9385253906249318
								],
								[
									-50.398779296875006,
									1.8928710937500455
								],
								[
									-50.45610351562496,
									1.9104980468750767
								],
								[
									-50.50898437499998,
									2.029541015625
								],
								[
									-50.49101562499996,
									2.1286132812500256
								],
								[
									-50.41874999999999,
									2.1614746093750483
								],
								[
									-50.362646484375034,
									2.154443359375037
								],
								[
									-50.34199218749998,
									2.141748046875037
								],
								[
									-50.292089843750034,
									1.9795898437499488
								],
								[
									-50.29897460937502,
									1.9385253906249318
								]
							]
						],
						[
							[
								[
									-56.48281249999994,
									1.9421386718750426
								],
								[
									-56.452832031249955,
									1.9323242187500824
								],
								[
									-56.385839843750006,
									1.9238769531250597
								],
								[
									-56.227148437500006,
									1.88535156250002
								],
								[
									-56.019921874999966,
									1.8422363281250256
								],
								[
									-55.96333007812498,
									1.857080078125037
								],
								[
									-55.929638671874955,
									1.887500000000017
								],
								[
									-55.92163085937503,
									1.9766601562500625
								],
								[
									-55.91533203124999,
									2.0395507812500853
								],
								[
									-55.96196289062499,
									2.095117187500037
								],
								[
									-56.02006835937499,
									2.1581542968750824
								],
								[
									-56.073632812499994,
									2.2367675781250256
								],
								[
									-56.13769531249997,
									2.2590332031250284
								],
								[
									-56.12939453124997,
									2.2995117187500256
								],
								[
									-56.08779296874994,
									2.3413085937500995
								],
								[
									-56.045117187499955,
									2.3644042968750085
								],
								[
									-56.02036132812498,
									2.3927734375000966
								],
								[
									-55.993505859375006,
									2.49750976562504
								],
								[
									-55.9755859375,
									2.5159667968749773
								],
								[
									-55.957470703124955,
									2.5204589843750966
								],
								[
									-55.935937499999994,
									2.5166015625000995
								],
								[
									-55.893749999999926,
									2.4895019531250853
								],
								[
									-55.730566406250006,
									2.4061523437500796
								],
								[
									-55.65893554687497,
									2.4187500000000597
								],
								[
									-55.385351562500006,
									2.4406250000000824
								],
								[
									-55.34399414062503,
									2.4887695312500284
								],
								[
									-55.28603515625002,
									2.4996582031250227
								],
								[
									-55.18769531249998,
									2.5475097656250085
								],
								[
									-55.148828124999966,
									2.550781250000057
								],
								[
									-55.114111328125006,
									2.539208984375094
								],
								[
									-55.07031249999994,
									2.54833984375
								],
								[
									-55.005810546874955,
									2.5929687500000256
								],
								[
									-54.97866210937502,
									2.5976562500000995
								],
								[
									-54.968408203124966,
									2.54833984375
								],
								[
									-54.92656249999999,
									2.497363281250088
								],
								[
									-54.876074218750006,
									2.4503906250000256
								],
								[
									-54.851660156250006,
									2.439550781250034
								],
								[
									-54.76684570312494,
									2.4547363281250227
								],
								[
									-54.72221679687502,
									2.4416503906250284
								],
								[
									-54.70292968749999,
									2.3979492187500853
								],
								[
									-54.69741210937502,
									2.359814453125054
								],
								[
									-54.66186523437497,
									2.327539062500051
								],
								[
									-54.61625976562499,
									2.3267578124999773
								],
								[
									-54.59194335937502,
									2.313769531250088
								],
								[
									-54.55048828125001,
									2.293066406250034
								],
								[
									-54.51508789062498,
									2.2454589843749346
								],
								[
									-54.43310546875,
									2.2075195312501137
								],
								[
									-54.29306640624998,
									2.1542480468750966
								],
								[
									-54.227978515624955,
									2.1533203125000853
								],
								[
									-54.16738281249994,
									2.1370605468750483
								],
								[
									-54.13007812499998,
									2.1210449218750824
								],
								[
									-54.08974609375002,
									2.150488281249949
								],
								[
									-53.946435546874966,
									2.2325683593750654
								],
								[
									-53.87661132812494,
									2.27827148437504
								],
								[
									-53.829541015624955,
									2.3129394531250966
								],
								[
									-53.79423828124996,
									2.3459960937499886
								],
								[
									-53.76777343749998,
									2.354833984375105
								],
								[
									-53.75014648437502,
									2.3350097656250597
								],
								[
									-53.734716796875006,
									2.308544921874997
								],
								[
									-53.683691406250006,
									2.2929199218750114
								],
								[
									-53.56396484375003,
									2.2619140625000824
								],
								[
									-53.50898437500001,
									2.253125000000068
								],
								[
									-53.43183593750001,
									2.2794433593750227
								],
								[
									-53.36601562500002,
									2.3242187500000853
								],
								[
									-53.33442382812498,
									2.339746093750051
								],
								[
									-53.28549804687495,
									2.295214843749946
								],
								[
									-53.25219726562503,
									2.232275390625091
								],
								[
									-53.22978515624999,
									2.204882812500017
								],
								[
									-53.180078124999966,
									2.2113281250000796
								],
								[
									-53.08227539062503,
									2.201708984375074
								],
								[
									-53.00971679687501,
									2.181738281250091
								],
								[
									-52.96484375,
									2.1835449218750256
								],
								[
									-52.90346679687502,
									2.211523437499949
								],
								[
									-52.87041015624996,
									2.2666503906249886
								],
								[
									-52.78339843749998,
									2.317187500000074
								],
								[
									-52.70063476562501,
									2.363671875000037
								],
								[
									-52.653173828125006,
									2.425732421875068
								],
								[
									-52.58300781250003,
									2.528906249999949
								],
								[
									-52.55947265625002,
									2.5731445312500796
								],
								[
									-52.55468750000003,
									2.647656249999983
								],
								[
									-52.45585937499996,
									2.864160156250037
								],
								[
									-52.41840820312498,
									2.9038574218750455
								],
								[
									-52.39638671875002,
									2.972216796875017
								],
								[
									-52.35664062500001,
									3.051562500000017
								],
								[
									-52.35664062500001,
									3.117724609375003
								],
								[
									-52.327880859375,
									3.1817382812500767
								],
								[
									-52.271240234375,
									3.2371093749999886
								],
								[
									-52.22944335937501,
									3.2716796875000966
								],
								[
									-52.16259765625,
									3.36469726562504
								],
								[
									-52.11611328125002,
									3.4522949218749517
								],
								[
									-51.99951171874997,
									3.64687499999998
								],
								[
									-51.99062499999994,
									3.70200195312502
								],
								[
									-51.94433593750003,
									3.735107421875014
								],
								[
									-51.92890624999998,
									3.776953125000105
								],
								[
									-51.87949218749995,
									3.82856445312504
								],
								[
									-51.827490234375034,
									3.869580078125054
								],
								[
									-51.805273437500034,
									3.9299316406250853
								],
								[
									-51.76708984374997,
									3.9926757812500853
								],
								[
									-51.68344726562498,
									4.039697265625065
								],
								[
									-51.65253906249998,
									4.061279296875028
								],
								[
									-51.55781249999998,
									4.233789062500094
								],
								[
									-51.54707031250001,
									4.310888671875077
								],
								[
									-51.46152343749998,
									4.3137695312500455
								],
								[
									-51.327099609374955,
									4.2247558593749375
								],
								[
									-51.219921874999955,
									4.093603515625034
								],
								[
									-51.076269531250006,
									3.6716796875000597
								],
								[
									-51.05239257812502,
									3.281835937500034
								],
								[
									-50.99414062499997,
									3.0775390625000796
								],
								[
									-50.82719726562499,
									2.6518554687500426
								],
								[
									-50.816503906250034,
									2.5730468750000597
								],
								[
									-50.789697265624994,
									2.477783203125014
								],
								[
									-50.736962890624994,
									2.3767578125000313
								],
								[
									-50.67875976562493,
									2.2103515625000654
								],
								[
									-50.67656250000002,
									2.179443359374986
								],
								[
									-50.71440429687502,
									2.1340332031249716
								],
								[
									-50.658935546875,
									2.1309570312500483
								],
								[
									-50.60869140624996,
									2.104101562500091
								],
								[
									-50.575878906249955,
									1.998583984375088
								],
								[
									-50.53442382812503,
									1.9272460937499432
								],
								[
									-50.458886718749994,
									1.8295898437499432
								],
								[
									-50.304296875000034,
									1.7976562500001023
								],
								[
									-50.18759765624998,
									1.785986328125034
								],
								[
									-50.0546875,
									1.7307128906250426
								],
								[
									-49.957128906250006,
									1.6598632812500966
								],
								[
									-49.88159179687497,
									1.4199218749999716
								],
								[
									-49.90625000000003,
									1.2690429687500568
								],
								[
									-49.898876953124955,
									1.1629882812500227
								],
								[
									-49.93793945312501,
									1.121435546875091
								],
								[
									-50.04721679687498,
									1.0519531249999687
								],
								[
									-50.070996093749926,
									1.0150878906250966
								],
								[
									-50.29443359374997,
									0.8357421874999744
								],
								[
									-50.34326171874997,
									0.751025390624946
								],
								[
									-50.462988281250034,
									0.6373046875000483
								],
								[
									-50.58154296875003,
									0.42050781249993463
								],
								[
									-50.755078124999955,
									0.22255859375002274
								],
								[
									-50.81635742187498,
									0.1725585937500398
								],
								[
									-50.91015625,
									0.16098632812509095
								],
								[
									-50.96708984374996,
									0.13027343750005116
								],
								[
									-51.101953124999994,
									-0.031249999999914735
								],
								[
									-51.28291015625001,
									-0.08520507812497158
								],
								[
									-51.29956054687503,
									-0.17880859374994884
								],
								[
									-51.404150390625006,
									-0.3926757812499062
								],
								[
									-51.496289062499955,
									-0.5094726562498977
								],
								[
									-51.555029296875034,
									-0.5491210937499034
								],
								[
									-51.70263671875,
									-0.762304687499892
								],
								[
									-51.721533203125006,
									-0.8554687499999574
								],
								[
									-51.720605468749994,
									-1.0184570312499517
								],
								[
									-51.81914062500002,
									-1.1177734374999346
								],
								[
									-51.92163085937503,
									-1.1808593749998977
								],
								[
									-51.934472656249966,
									-1.3203124999998863
								],
								[
									-51.980810546875006,
									-1.3679687499999176
								],
								[
									-52.02045898437498,
									-1.3990234374999346
								],
								[
									-52.22924804687497,
									-1.3624999999999545
								],
								[
									-52.553417968749955,
									-1.5140624999999233
								],
								[
									-52.664160156250034,
									-1.5517578125000568
								],
								[
									-52.31030273437497,
									-1.5595703124999574
								],
								[
									-52.196679687499994,
									-1.6401367187499432
								],
								[
									-51.94755859374996,
									-1.5867187499999034
								],
								[
									-51.64628906249996,
									-1.3943359374999602
								],
								[
									-51.531201171874955,
									-1.3541015624999346
								],
								[
									-51.29736328125003,
									-1.22353515624998
								],
								[
									-51.202343749999926,
									-1.136523437500017
								],
								[
									-51.028955078124966,
									-1.0321289062500654
								],
								[
									-50.992041015625006,
									-0.9863281249999716
								],
								[
									-50.89492187500002,
									-0.9375976562499915
								],
								[
									-50.84228515625003,
									-0.9996093749999204
								],
								[
									-50.83818359374999,
									-1.038867187500017
								],
								[
									-50.917871093749994,
									-1.1152343749999432
								],
								[
									-50.897167968749926,
									-1.1644531250000227
								],
								[
									-50.84458007812498,
									-1.226269531249912
								],
								[
									-50.825537109375006,
									-1.3114257812499517
								],
								[
									-50.81865234375002,
									-1.3762695312499176
								],
								[
									-50.78613281249997,
									-1.489941406249983
								],
								[
									-50.67895507812497,
									-1.6438476562499886
								],
								[
									-50.67529296875003,
									-1.6947265625000512
								],
								[
									-50.690039062500006,
									-1.761718749999929
								],
								[
									-50.63876953124998,
									-1.8170898437499403
								],
								[
									-50.585595703124966,
									-1.8499023437500455
								],
								[
									-50.40322265625002,
									-2.015527343750037
								],
								[
									-50.26044921874998,
									-1.9229492187500057
								],
								[
									-50.17270507812495,
									-1.8961914062499687
								],
								[
									-50.116601562499994,
									-1.8575195312499062
								],
								[
									-49.999218749999955,
									-1.8318359374999176
								],
								[
									-49.902978515624994,
									-1.87060546875
								],
								[
									-49.71953125000002,
									-1.9263671874999915
								],
								[
									-49.58535156250002,
									-1.8671875000000142
								],
								[
									-49.31367187500001,
									-1.7317382812499602
								],
								[
									-49.39863281250001,
									-1.971582031249966
								],
								[
									-49.46015625000001,
									-2.1915039062500057
								],
								[
									-49.506982421874966,
									-2.2802734374999716
								],
								[
									-49.553369140624994,
									-2.5199218749999517
								],
								[
									-49.599316406249955,
									-2.5838867187500085
								],
								[
									-49.63652343749996,
									-2.6569335937499687
								],
								[
									-49.575878906249955,
									-2.6314453124999346
								],
								[
									-49.52392578125003,
									-2.5968749999998977
								],
								[
									-49.45751953125,
									-2.504589843749926
								],
								[
									-49.40766601562498,
									-2.344335937499963
								],
								[
									-49.21103515624998,
									-1.9165039062499432
								],
								[
									-49.15478515624997,
									-1.8785156249999204
								],
								[
									-48.99130859374998,
									-1.8297851562499403
								],
								[
									-48.71000976562496,
									-1.48769531249998
								],
								[
									-48.60000000000002,
									-1.4887695312500142
								],
								[
									-48.52958984374996,
									-1.5674804687500625
								],
								[
									-48.46293945312499,
									-1.6139648437499403
								],
								[
									-48.44584960937496,
									-1.5204101562500654
								],
								[
									-48.349804687499926,
									-1.482128906249912
								],
								[
									-48.45146484374996,
									-1.4358398437499744
								],
								[
									-48.46806640624996,
									-1.393847656249946
								],
								[
									-48.47773437499998,
									-1.323828124999892
								],
								[
									-48.40859375000002,
									-1.2291992187500682
								],
								[
									-48.44980468749998,
									-1.1455078124999005
								],
								[
									-48.306494140625006,
									-1.039843749999946
								],
								[
									-48.317578124999955,
									-0.9605468750000483
								],
								[
									-48.266455078125006,
									-0.8951171874999488
								],
								[
									-48.20175781249998,
									-0.8279296875000313
								],
								[
									-48.12846679687496,
									-0.795214843749946
								],
								[
									-48.11508789062498,
									-0.7374999999999119
								],
								[
									-48.06884765624997,
									-0.7136718749999318
								],
								[
									-48.03256835937498,
									-0.7050781249999574
								],
								[
									-47.96093750000003,
									-0.769628906249963
								],
								[
									-47.883398437500034,
									-0.6933593749999716
								],
								[
									-47.80766601562499,
									-0.6634765624999233
								],
								[
									-47.77373046874999,
									-0.6767578124999716
								],
								[
									-47.73149414062499,
									-0.7104492187499005
								],
								[
									-47.687109375000006,
									-0.724804687499983
								],
								[
									-47.651074218749955,
									-0.7187499999999005
								],
								[
									-47.557324218749955,
									-0.6699218749999005
								],
								[
									-47.47070312499997,
									-0.748535156249929
								],
								[
									-47.418652343749955,
									-0.7659179687499176
								],
								[
									-47.43291015625002,
									-0.7218749999999261
								],
								[
									-47.460351562499994,
									-0.6809570312499318
								],
								[
									-47.439062500000034,
									-0.647656249999983
								],
								[
									-47.39809570312502,
									-0.6266601562499687
								],
								[
									-47.26860351562502,
									-0.6454101562499801
								],
								[
									-47.200537109375006,
									-0.6804687499999176
								],
								[
									-47.12690429687501,
									-0.7454101562499176
								],
								[
									-47.024609374999955,
									-0.7501953124999119
								],
								[
									-46.94433593749994,
									-0.7433593749999403
								],
								[
									-46.893652343750006,
									-0.7798828124999204
								],
								[
									-46.81123046875001,
									-0.7796874999999801
								],
								[
									-46.76992187499994,
									-0.8365234375000057
								],
								[
									-46.644433593749966,
									-0.9164062499999375
								],
								[
									-46.61723632812502,
									-0.9706054687499659
								],
								[
									-46.51630859374998,
									-0.9968749999999886
								],
								[
									-46.42172851562498,
									-1.0300781250000028
								],
								[
									-46.32084960937493,
									-1.0391601562499062
								],
								[
									-46.219140624999994,
									-1.0312499999999716
								],
								[
									-46.214990234374966,
									-1.0998046874999972
								],
								[
									-46.14038085937503,
									-1.1183593749999545
								],
								[
									-46.04462890624998,
									-1.1030273437499432
								],
								[
									-45.97226562499998,
									-1.187402343749909
								],
								[
									-45.77880859375,
									-1.2507812499999318
								],
								[
									-45.64477539062497,
									-1.347851562499912
								],
								[
									-45.55693359375002,
									-1.330664062499963
								],
								[
									-45.45859374999995,
									-1.356250000000017
								],
								[
									-45.35302734375003,
									-1.5673828125000426
								],
								[
									-45.32915039062496,
									-1.7172851562500284
								],
								[
									-45.282128906249966,
									-1.6965820312499034
								],
								[
									-45.23857421874999,
									-1.6294921874999062
								],
								[
									-45.182080078124926,
									-1.507031249999912
								],
								[
									-45.07636718749998,
									-1.4664062499999062
								],
								[
									-45.025781249999966,
									-1.5134765624999034
								],
								[
									-44.91977539062498,
									-1.5888671874998863
								],
								[
									-44.828369140625,
									-1.6716796874999744
								],
								[
									-44.78984374999996,
									-1.7248046874999687
								],
								[
									-44.72114257812501,
									-1.733496093749963
								],
								[
									-44.778515624999955,
									-1.7988281249999432
								],
								[
									-44.72094726562497,
									-1.7922851562500313
								],
								[
									-44.651269531249966,
									-1.745800781249983
								],
								[
									-44.591650390625006,
									-1.8417968749999005
								],
								[
									-44.546777343749994,
									-1.9462890624999716
								],
								[
									-44.537792968749955,
									-2.0527343749998863
								],
								[
									-44.580029296874926,
									-2.113867187499906
								],
								[
									-44.61728515624998,
									-2.152148437499889
								],
								[
									-44.658642578124955,
									-2.2275390624999716
								],
								[
									-44.70751953124997,
									-2.241113281249895
								],
								[
									-44.75634765624997,
									-2.265527343749895
								],
								[
									-44.70063476562498,
									-2.3204101562499773
								],
								[
									-44.66240234375002,
									-2.373242187499912
								],
								[
									-44.579003906249994,
									-2.2304687499999574
								],
								[
									-44.520361328125034,
									-2.1903320312499517
								],
								[
									-44.435449218749966,
									-2.1680664062499346
								],
								[
									-44.391308593749955,
									-2.2696289062499346
								],
								[
									-44.38183593749997,
									-2.365527343749932
								],
								[
									-44.52011718749998,
									-2.405468749999983
								],
								[
									-44.52065429687502,
									-2.4812500000000597
								],
								[
									-44.56201171875,
									-2.524218749999932
								],
								[
									-44.589013671874994,
									-2.5734375000000114
								],
								[
									-44.61079101562498,
									-2.676855468749949
								],
								[
									-44.63896484374996,
									-2.762499999999889
								],
								[
									-44.721386718749955,
									-3.142285156249912
								],
								[
									-44.72304687500002,
									-3.2047851562500256
								],
								[
									-44.622656250000006,
									-3.137890624999983
								],
								[
									-44.43754882812496,
									-2.9444335937499204
								],
								[
									-44.38115234375002,
									-2.738378906249949
								],
								[
									-44.30815429687496,
									-2.5351562500000284
								],
								[
									-44.228613281250034,
									-2.471289062499892
								],
								[
									-44.179394531249955,
									-2.4711914062499716
								],
								[
									-44.105566406250006,
									-2.4934570312500597
								],
								[
									-44.10136718749993,
									-2.5600585937499574
								],
								[
									-44.112646484375034,
									-2.59853515624998
								],
								[
									-44.191601562499955,
									-2.699609374999966
								],
								[
									-44.225195312500034,
									-2.7549804687500483
								],
								[
									-44.19267578124999,
									-2.8095703124998863
								],
								[
									-44.01323242187502,
									-2.642187499999892
								],
								[
									-43.93291015624999,
									-2.583496093749929
								],
								[
									-43.86445312499998,
									-2.5954101562499545
								],
								[
									-43.728613281250034,
									-2.518164062499949
								],
								[
									-43.45512695312502,
									-2.502050781250034
								],
								[
									-43.43461914062499,
									-2.4136718749999773
								],
								[
									-43.38007812499998,
									-2.376074218749949
								],
								[
									-43.22968749999998,
									-2.386035156249932
								],
								[
									-42.93671874999998,
									-2.4650390624999545
								],
								[
									-42.83227539062503,
									-2.52958984374996
								],
								[
									-42.67587890624998,
									-2.589648437499946
								],
								[
									-42.59355468749999,
									-2.6610351562499233
								],
								[
									-42.24960937499998,
									-2.7919921874999574
								],
								[
									-41.999853515625006,
									-2.80605468749998
								],
								[
									-41.876171874999926,
									-2.746582031249943
								],
								[
									-41.721874999999955,
									-2.808886718750017
								],
								[
									-41.64013671875,
									-2.8786132812500114
								],
								[
									-41.479931640624955,
									-2.9165039062499147
								],
								[
									-41.318212890625034,
									-2.9362304687500256
								],
								[
									-41.19453124999998,
									-2.8861328124999517
								],
								[
									-40.875585937500006,
									-2.8696289062499574
								],
								[
									-40.474560546874955,
									-2.795605468749983
								],
								[
									-40.23535156249997,
									-2.813183593749912
								],
								[
									-39.96469726562498,
									-2.861523437499912
								],
								[
									-39.771826171875034,
									-2.9858398437499147
								],
								[
									-39.60942382812499,
									-3.056249999999963
								],
								[
									-39.511181640624955,
									-3.125585937499963
								],
								[
									-39.352685546874994,
									-3.1973632812499346
								],
								[
									-39.01435546875001,
									-3.3902343749999773
								],
								[
									-38.89599609374994,
									-3.50175781249996
								],
								[
									-38.686230468749955,
									-3.653710937499909
								],
								[
									-38.475781249999955,
									-3.7174804687500256
								],
								[
									-38.361914062500034,
									-3.8764648437499147
								],
								[
									-38.271874999999994,
									-3.948046874999932
								],
								[
									-38.04882812500003,
									-4.2164062500000625
								],
								[
									-37.79565429687497,
									-4.404296874999972
								],
								[
									-37.626318359375006,
									-4.592089843749946
								],
								[
									-37.30146484375001,
									-4.713085937499997
								],
								[
									-37.174658203125006,
									-4.912402343749932
								],
								[
									-36.95488281250002,
									-4.936718749999912
								],
								[
									-36.86113281249999,
									-4.96660156249996
								],
								[
									-36.74736328125002,
									-5.0506835937499375
								],
								[
									-36.590722656249966,
									-5.097558593749895
								],
								[
									-36.38671874999997,
									-5.084277343749946
								],
								[
									-36.161767578124994,
									-5.093749999999929
								],
								[
									-35.979882812499966,
									-5.054394531249983
								],
								[
									-35.549414062500034,
									-5.1293945312499005
								],
								[
									-35.481689453125,
									-5.1660156249999005
								],
								[
									-35.39257812499994,
									-5.250878906249966
								],
								[
									-35.235449218750006,
									-5.566699218749903
								],
								[
									-35.14174804687502,
									-5.917187499999898
								],
								[
									-35.095458984375,
									-6.185351562499918
								],
								[
									-34.988183593749994,
									-6.393749999999912
								],
								[
									-34.929589843749966,
									-6.785058593750051
								],
								[
									-34.87988281249994,
									-6.908203124999915
								],
								[
									-34.87597656249997,
									-7.002929687500028
								],
								[
									-34.833886718749994,
									-7.024414062499972
								],
								[
									-34.80546874999999,
									-7.288378906249918
								],
								[
									-34.816601562499955,
									-7.394824218749932
								],
								[
									-34.85776367187498,
									-7.533300781249906
								],
								[
									-34.86083984374997,
									-7.595019531249946
								],
								[
									-34.85478515624999,
									-7.634277343750043
								],
								[
									-34.87299804687498,
									-7.692089843749926
								],
								[
									-34.878613281249955,
									-7.7474609375000085
								],
								[
									-34.8369140625,
									-7.87177734374994
								],
								[
									-34.83466796874998,
									-7.971484374999903
								],
								[
									-34.890527343749994,
									-8.09218749999998
								],
								[
									-34.96665039062495,
									-8.407617187499937
								],
								[
									-35.15776367187499,
									-8.930566406249895
								],
								[
									-35.34086914062499,
									-9.230664062499926
								],
								[
									-35.597070312499966,
									-9.540624999999935
								],
								[
									-35.76396484374993,
									-9.702539062500051
								],
								[
									-35.83012695312502,
									-9.719042968749946
								],
								[
									-35.890820312499955,
									-9.687011718749915
								],
								[
									-35.84775390624995,
									-9.772460937499915
								],
								[
									-35.88544921875001,
									-9.847656249999957
								],
								[
									-36.05498046874999,
									-10.075781250000063
								],
								[
									-36.223535156249966,
									-10.225097656249929
								],
								[
									-36.398339843749966,
									-10.48408203124994
								],
								[
									-36.41162109375,
									-10.489941406249969
								],
								[
									-36.6357421875,
									-10.589941406250006
								],
								[
									-36.768310546875,
									-10.67167968749996
								],
								[
									-36.93779296874999,
									-10.820410156250063
								],
								[
									-37.09335937499998,
									-11.054785156249935
								],
								[
									-37.12548828125003,
									-11.084960937499957
								],
								[
									-37.18281249999998,
									-11.068457031249977
								],
								[
									-37.18120117187502,
									-11.187499999999972
								],
								[
									-37.315136718749955,
									-11.375976562499915
								],
								[
									-37.35600585937502,
									-11.40390624999992
								],
								[
									-37.354882812499966,
									-11.350488281250051
								],
								[
									-37.331640625000034,
									-11.309863281249946
								],
								[
									-37.32080078125003,
									-11.266601562500014
								],
								[
									-37.32177734374997,
									-11.215136718749918
								],
								[
									-37.35922851562495,
									-11.252539062499991
								],
								[
									-37.43847656250003,
									-11.393749999999983
								],
								[
									-37.41181640625001,
									-11.49726562499994
								],
								[
									-37.469335937500006,
									-11.653613281249989
								],
								[
									-37.68872070312503,
									-12.09999999999998
								],
								[
									-37.95732421874996,
									-12.475488281249923
								],
								[
									-38.019238281249955,
									-12.591308593750071
								],
								[
									-38.23974609375003,
									-12.844238281249986
								],
								[
									-38.401757812499994,
									-12.966210937500065
								],
								[
									-38.44731445312493,
									-12.96708984375006
								],
								[
									-38.498925781249966,
									-12.956640625000063
								],
								[
									-38.52490234375003,
									-12.762304687499991
								],
								[
									-38.654003906249955,
									-12.64462890624992
								],
								[
									-38.69096679687502,
									-12.623925781249966
								],
								[
									-38.74389648437497,
									-12.748535156250028
								],
								[
									-38.787988281249966,
									-12.782714843749986
								],
								[
									-38.85175781250001,
									-12.790136718750077
								],
								[
									-38.783593749999966,
									-12.844433593750026
								],
								[
									-38.76372070312502,
									-12.907226562500028
								],
								[
									-38.83315429687502,
									-13.032910156250054
								],
								[
									-38.835302734375034,
									-13.147167968749983
								],
								[
									-38.959179687499955,
									-13.273046875000048
								],
								[
									-39.030908203124994,
									-13.36513671874998
								],
								[
									-39.06738281249997,
									-13.480468750000028
								],
								[
									-39.08935546875,
									-13.588183593749946
								],
								[
									-39.034912109375,
									-13.558789062499997
								],
								[
									-39.00908203124999,
									-13.581445312499994
								],
								[
									-38.988623046875006,
									-13.615039062499989
								],
								[
									-39.001220703125,
									-13.664550781250043
								],
								[
									-39.041113281250034,
									-13.758105468750003
								],
								[
									-39.034912109375,
									-13.991015624999946
								],
								[
									-39.04814453124996,
									-14.043945312500071
								],
								[
									-39.008496093749955,
									-14.101171875000006
								],
								[
									-38.96650390625001,
									-14.003417968749986
								],
								[
									-38.94233398437498,
									-14.030664062500023
								],
								[
									-39.05957031249997,
									-14.654785156249986
								],
								[
									-39.01337890624998,
									-14.935644531250006
								],
								[
									-38.996191406250034,
									-15.253808593749994
								],
								[
									-38.94321289062498,
									-15.564355468750023
								],
								[
									-38.88525390625,
									-15.841992187499997
								],
								[
									-38.88061523437503,
									-15.864257812500014
								],
								[
									-38.960791015625006,
									-16.186523437499943
								],
								[
									-39.063232421875,
									-16.504394531250043
								],
								[
									-39.12504882812499,
									-16.76357421875008
								],
								[
									-39.16396484375002,
									-17.043554687500006
								],
								[
									-39.20288085937503,
									-17.178125000000065
								],
								[
									-39.215234374999966,
									-17.31582031250005
								],
								[
									-39.170605468749955,
									-17.64208984375
								],
								[
									-39.154003906249926,
									-17.70390624999999
								],
								[
									-39.27836914062496,
									-17.849414062500045
								],
								[
									-39.41259765624994,
									-17.920019531249963
								],
								[
									-39.486767578124955,
									-17.990136718750037
								],
								[
									-39.650781249999994,
									-18.252343750000065
								],
								[
									-39.73979492187499,
									-18.639843750000054
								],
								[
									-39.741943359375,
									-18.84599609374996
								],
								[
									-39.69985351562502,
									-19.27783203125
								],
								[
									-39.73144531249997,
									-19.45390624999999
								],
								[
									-39.78330078124998,
									-19.57177734375003
								],
								[
									-39.84472656249997,
									-19.649121093750054
								],
								[
									-40.001367187499994,
									-19.74199218750006
								],
								[
									-40.14169921874998,
									-19.968261718750057
								],
								[
									-40.20273437499998,
									-20.20605468749993
								],
								[
									-40.29887695312493,
									-20.292675781250068
								],
								[
									-40.318554687499955,
									-20.42578124999993
								],
								[
									-40.39594726562501,
									-20.569433593750063
								],
								[
									-40.59658203125002,
									-20.783789062500034
								],
								[
									-40.72705078124994,
									-20.846191406249957
								],
								[
									-40.78925781250001,
									-20.906054687500074
								],
								[
									-40.828759765624994,
									-21.03134765625002
								],
								[
									-40.954541015624926,
									-21.23789062499999
								],
								[
									-41.047265624999994,
									-21.505664062500017
								],
								[
									-41.02314453124998,
									-21.596875000000026
								],
								[
									-41.021582031250006,
									-21.61083984375003
								],
								[
									-40.98784179687496,
									-21.920312499999937
								],
								[
									-41.00029296875002,
									-21.999023437499986
								],
								[
									-41.122509765624955,
									-22.084374999999966
								],
								[
									-41.582910156249966,
									-22.243652343749986
								],
								[
									-41.70551757812498,
									-22.309667968750034
								],
								[
									-41.980419921874955,
									-22.58066406249999
								],
								[
									-41.99755859374997,
									-22.644628906250063
								],
								[
									-41.98613281249996,
									-22.735839843749986
								],
								[
									-41.94091796874997,
									-22.78828125000001
								],
								[
									-41.98749999999998,
									-22.84511718750005
								],
								[
									-42.042382812499966,
									-22.94707031250003
								],
								[
									-42.12246093750002,
									-22.94082031250001
								],
								[
									-42.5810546875,
									-22.94101562500005
								],
								[
									-42.829296874999955,
									-22.973339843750054
								],
								[
									-42.95830078124996,
									-22.96708984375003
								],
								[
									-43.016210937500034,
									-22.94257812500001
								],
								[
									-43.081152343750034,
									-22.902539062500026
								],
								[
									-43.100683593750006,
									-22.85009765625
								],
								[
									-43.06542968750003,
									-22.770703125000068
								],
								[
									-43.086279296875006,
									-22.72333984375001
								],
								[
									-43.154296875,
									-22.725195312500034
								],
								[
									-43.22900390625003,
									-22.74765624999999
								],
								[
									-43.241943359375,
									-22.795117187500068
								],
								[
									-43.23662109374999,
									-22.828808593749926
								],
								[
									-43.208837890625006,
									-22.878125000000026
								],
								[
									-43.19360351562503,
									-22.938574218750077
								],
								[
									-43.22416992187502,
									-22.99121093749997
								],
								[
									-43.36948242187498,
									-22.998046874999943
								],
								[
									-43.532812500000034,
									-23.046386718750014
								],
								[
									-43.736523437499955,
									-23.066601562500054
								],
								[
									-43.898828124999994,
									-23.10146484375005
								],
								[
									-43.97382812499998,
									-23.05732421874994
								],
								[
									-43.898828124999994,
									-23.035253906250063
								],
								[
									-43.79140624999994,
									-23.04599609375002
								],
								[
									-43.675976562499955,
									-23.00947265625004
								],
								[
									-43.70292968749996,
									-22.966308593750043
								],
								[
									-43.86616210937498,
									-22.91054687500005
								],
								[
									-44.04746093749998,
									-22.944726562499994
								],
								[
									-44.14799804687493,
									-23.011035156250003
								],
								[
									-44.36791992187497,
									-23.004980468749935
								],
								[
									-44.63725585937496,
									-23.055468749999918
								],
								[
									-44.68115234375003,
									-23.10693359375
								],
								[
									-44.67382812499994,
									-23.206640625000063
								],
								[
									-44.62109374999994,
									-23.228515625
								],
								[
									-44.56967773437495,
									-23.274023437500034
								],
								[
									-44.61909179687498,
									-23.316406250000043
								],
								[
									-44.66718750000001,
									-23.335156250000054
								],
								[
									-44.95166015624997,
									-23.381445312500063
								],
								[
									-45.21542968749998,
									-23.57558593750001
								],
								[
									-45.32539062500001,
									-23.59970703124995
								],
								[
									-45.423291015624955,
									-23.68535156249999
								],
								[
									-45.43339843749999,
									-23.75849609374997
								],
								[
									-45.464306640624955,
									-23.80253906250006
								],
								[
									-45.52709960937497,
									-23.804785156250063
								],
								[
									-45.664648437500006,
									-23.76484375000001
								],
								[
									-45.843164062499966,
									-23.763671874999957
								],
								[
									-45.97207031250002,
									-23.79550781250005
								],
								[
									-46.63076171875002,
									-24.110351562500057
								],
								[
									-46.86728515624998,
									-24.23632812499997
								],
								[
									-47.13720703125,
									-24.49316406250007
								],
								[
									-47.592187499999966,
									-24.781054687500003
								],
								[
									-47.83115234374998,
									-24.952929687499946
								],
								[
									-47.87656249999998,
									-24.997460937500037
								],
								[
									-47.91430664062503,
									-24.999902343749923
								],
								[
									-47.989160156249994,
									-25.03574218750002
								],
								[
									-47.959374999999966,
									-25.06542968750003
								],
								[
									-47.908349609374966,
									-25.068164062499974
								],
								[
									-47.92939453124998,
									-25.168261718750017
								],
								[
									-48.02436523437498,
									-25.236718750000023
								],
								[
									-48.202734375000006,
									-25.416503906250057
								],
								[
									-48.242431640625,
									-25.403320312500043
								],
								[
									-48.18593749999994,
									-25.309863281250003
								],
								[
									-48.27348632812502,
									-25.306347656249997
								],
								[
									-48.40249023437502,
									-25.27207031249995
								],
								[
									-48.45849609374997,
									-25.31074218750001
								],
								[
									-48.427636718749994,
									-25.403320312500043
								],
								[
									-48.47612304687499,
									-25.44296874999995
								],
								[
									-48.56416015624998,
									-25.447460937500054
								],
								[
									-48.64399414062501,
									-25.436523437500057
								],
								[
									-48.73173828124993,
									-25.368750000000006
								],
								[
									-48.69218749999996,
									-25.49150390625006
								],
								[
									-48.50703124999998,
									-25.521289062499918
								],
								[
									-48.42988281249998,
									-25.550195312500023
								],
								[
									-48.40117187500002,
									-25.59736328125004
								],
								[
									-48.54516601562503,
									-25.81591796875007
								],
								[
									-48.665771484375,
									-25.844335937500006
								],
								[
									-48.67900390624993,
									-25.875195312500068
								],
								[
									-48.61284179687496,
									-25.87500000000003
								],
								[
									-48.576318359374994,
									-25.935449218749994
								],
								[
									-48.61943359374999,
									-26.179394531250054
								],
								[
									-48.67900390624993,
									-26.225781250000082
								],
								[
									-48.71376953125002,
									-26.22695312500005
								],
								[
									-48.74829101562503,
									-26.26865234375002
								],
								[
									-48.70068359375,
									-26.34833984375001
								],
								[
									-48.65161132812497,
									-26.406445312500026
								],
								[
									-48.658154296874955,
									-26.51914062499999
								],
								[
									-48.67651367187497,
									-26.612402343750063
								],
								[
									-48.67773437499994,
									-26.70292968750003
								],
								[
									-48.61567382812501,
									-26.87812499999994
								],
								[
									-48.593408203124994,
									-27.058007812499994
								],
								[
									-48.56835937499997,
									-27.123437499999994
								],
								[
									-48.55415039062501,
									-27.19599609375004
								],
								[
									-48.59550781249999,
									-27.26386718750001
								],
								[
									-48.57197265624998,
									-27.372753906250068
								],
								[
									-48.64257812499997,
									-27.557910156250045
								],
								[
									-48.60566406250001,
									-27.82519531249997
								],
								[
									-48.62080078124998,
									-28.075585937499994
								],
								[
									-48.64843750000003,
									-28.207226562499997
								],
								[
									-48.693212890625006,
									-28.310156250000006
								],
								[
									-48.797265624999966,
									-28.442675781250003
								],
								[
									-48.799658203125006,
									-28.57529296875002
								],
								[
									-49.023583984374966,
									-28.698632812499923
								],
								[
									-49.27128906249999,
									-28.871191406250077
								],
								[
									-49.49990234375002,
									-29.07539062499994
								],
								[
									-49.745996093749994,
									-29.36318359374995
								],
								[
									-50.033349609374994,
									-29.80097656249997
								],
								[
									-50.299511718749955,
									-30.42578125000007
								],
								[
									-50.619970703125034,
									-30.897656249999926
								],
								[
									-50.748144531250034,
									-31.068066406249997
								],
								[
									-50.92138671875,
									-31.25839843750005
								],
								[
									-51.15175781250002,
									-31.48037109374998
								],
								[
									-51.46040039062501,
									-31.702441406250003
								],
								[
									-51.79814453124999,
									-31.90029296875008
								],
								[
									-51.92021484374999,
									-31.989550781249974
								],
								[
									-52.039208984374994,
									-32.11484374999992
								],
								[
									-52.068945312500006,
									-32.063085937500034
								],
								[
									-52.04316406249998,
									-31.977539062500014
								],
								[
									-52.05957031249997,
									-31.91347656250001
								],
								[
									-52.063232421875,
									-31.830371093750045
								],
								[
									-51.99511718749997,
									-31.81503906249995
								],
								[
									-51.89316406249998,
									-31.867773437500034
								],
								[
									-51.841210937499966,
									-31.83203125000003
								],
								[
									-51.80341796875001,
									-31.796679687500017
								],
								[
									-51.68066406249994,
									-31.774609375000054
								],
								[
									-51.446191406249966,
									-31.557324218750026
								],
								[
									-51.272167968749955,
									-31.476953124999994
								],
								[
									-51.17431640625,
									-31.33974609375001
								],
								[
									-51.15751953124996,
									-31.266796875000068
								],
								[
									-51.16142578124996,
									-31.11884765625004
								],
								[
									-51.10595703125003,
									-31.081347656250045
								],
								[
									-50.980078125000034,
									-31.09423828125
								],
								[
									-50.95439453124996,
									-31.052148437500037
								],
								[
									-50.96533203124997,
									-31.005468750000034
								],
								[
									-50.94082031249994,
									-30.903710937499994
								],
								[
									-50.770166015624994,
									-30.813378906250065
								],
								[
									-50.68930664062495,
									-30.70419921874995
								],
								[
									-50.71630859374994,
									-30.42597656250001
								],
								[
									-50.68505859374997,
									-30.41347656250005
								],
								[
									-50.61484374999998,
									-30.456835937500003
								],
								[
									-50.58193359375002,
									-30.438867187500065
								],
								[
									-50.546533203124994,
									-30.316894531249915
								],
								[
									-50.56352539062499,
									-30.253613281250068
								],
								[
									-50.646191406249955,
									-30.236816406249943
								],
								[
									-50.931884765625,
									-30.37431640625006
								],
								[
									-51.02495117187496,
									-30.368652343750057
								],
								[
									-51.04038085937498,
									-30.260644531249994
								],
								[
									-51.179296875000034,
									-30.21103515625002
								],
								[
									-51.23359375000001,
									-30.121386718750045
								],
								[
									-51.249853515625034,
									-30.05996093750005
								],
								[
									-51.29804687499998,
									-30.03486328125001
								],
								[
									-51.29501953124998,
									-30.141015624999966
								],
								[
									-51.28178710937496,
									-30.244140625000014
								],
								[
									-51.15727539062499,
									-30.36425781249997
								],
								[
									-51.18754882812493,
									-30.41191406249999
								],
								[
									-51.24658203124997,
									-30.46757812500006
								],
								[
									-51.287695312500006,
									-30.591210937500023
								],
								[
									-51.283056640625034,
									-30.751562500000006
								],
								[
									-51.31640625,
									-30.702734375000006
								],
								[
									-51.35908203124998,
									-30.67451171874994
								],
								[
									-51.37646484374997,
									-30.846875000000054
								],
								[
									-51.45913085937502,
									-30.912792968750068
								],
								[
									-51.48525390625002,
									-30.97753906250003
								],
								[
									-51.46367187499999,
									-31.05263671875005
								],
								[
									-51.506298828124955,
									-31.104492187500043
								],
								[
									-51.71689453124995,
									-31.24374999999999
								],
								[
									-51.92680664062502,
									-31.33886718749993
								],
								[
									-51.97246093749999,
									-31.383789062500014
								],
								[
									-51.99487304687503,
									-31.489941406250054
								],
								[
									-52.02695312499998,
									-31.599023437499994
								],
								[
									-52.11982421874998,
									-31.69492187499999
								],
								[
									-52.19355468749998,
									-31.885546875000003
								],
								[
									-52.19155273437502,
									-31.967578125000017
								],
								[
									-52.167089843750006,
									-32.08847656250005
								],
								[
									-52.12739257812501,
									-32.167773437500045
								],
								[
									-52.19018554687503,
									-32.220800781250006
								],
								[
									-52.27460937499998,
									-32.323730468750014
								],
								[
									-52.34165039062498,
									-32.43974609375003
								],
								[
									-52.508496093749926,
									-32.875292968749946
								],
								[
									-52.652246093749994,
									-33.137792968750034
								],
								[
									-52.76289062499998,
									-33.266406250000045
								],
								[
									-52.92084960937501,
									-33.40195312499995
								],
								[
									-53.37060546874997,
									-33.742187499999986
								],
								[
									-53.39755859374998,
									-33.73730468749996
								],
								[
									-53.46357421875001,
									-33.709863281249966
								],
								[
									-53.51884765624999,
									-33.677246093749986
								],
								[
									-53.53134765624995,
									-33.65546874999998
								],
								[
									-53.53764648437499,
									-33.6228515625
								],
								[
									-53.533192151790786,
									-33.54781549010977
								],
								[
									-53.52695312499995,
									-33.552734375000014
								],
								[
									-53.50849609375001,
									-33.55722656249996
								],
								[
									-53.49052734374999,
									-33.546777343749966
								],
								[
									-53.453955078125006,
									-33.53173828125
								],
								[
									-53.437402343749994,
									-33.47275390624998
								],
								[
									-53.45268554687502,
									-33.35058593749996
								],
								[
									-53.4365234375,
									-33.235449218750034
								],
								[
									-53.408593749999994,
									-33.15869140625003
								],
								[
									-53.37695312500003,
									-33.119531249999966
								],
								[
									-53.351757812499955,
									-33.095117187499966
								],
								[
									-53.325585937499966,
									-33.08525390624999
								],
								[
									-53.29160156249995,
									-33.08134765625
								],
								[
									-53.22758789062499,
									-33.05546874999996
								],
								[
									-53.17333984375003,
									-32.95644531250004
								],
								[
									-53.130957031250006,
									-32.84560546875002
								],
								[
									-53.06757812499998,
									-32.808203125000034
								],
								[
									-53.01523437499998,
									-32.79873046874998
								],
								[
									-52.975732421874994,
									-32.82226562499997
								],
								[
									-52.93857421874998,
									-32.86113281249999
								],
								[
									-52.894921874999966,
									-32.909765625000034
								],
								[
									-52.84721679687502,
									-32.91708984375002
								],
								[
									-52.80791015625002,
									-32.90693359375
								],
								[
									-52.77260742187502,
									-32.875781250000045
								],
								[
									-52.73125000000002,
									-32.81171875000004
								],
								[
									-52.69355468749998,
									-32.75693359374999
								],
								[
									-52.65932617187502,
									-32.697656249999994
								],
								[
									-52.61699218750002,
									-32.63818359374996
								],
								[
									-52.59833984375004,
									-32.58535156250002
								],
								[
									-52.59140624999995,
									-32.53984374999999
								],
								[
									-52.59326171874997,
									-32.49912109375005
								],
								[
									-52.62548828124997,
									-32.453613281250014
								],
								[
									-52.65327148437504,
									-32.39404296874996
								],
								[
									-52.69003906249998,
									-32.348144531250014
								],
								[
									-52.69003906249998,
									-32.23740234375002
								],
								[
									-52.70126953124995,
									-32.204003906249966
								],
								[
									-52.72031249999992,
									-32.19853515625
								],
								[
									-52.74472656249992,
									-32.21738281250002
								],
								[
									-52.77963867187492,
									-32.26328124999996
								],
								[
									-52.79218750000001,
									-32.31074218750004
								],
								[
									-52.80380859374998,
									-32.34765625
								],
								[
									-52.81030273437497,
									-32.39062499999997
								],
								[
									-52.87714843749998,
									-32.432031249999966
								],
								[
									-52.95883789062495,
									-32.46835937499999
								],
								[
									-52.99111328125002,
									-32.533984375000045
								],
								[
									-53.02954101562494,
									-32.59804687500004
								],
								[
									-53.09155273437497,
									-32.61992187499996
								],
								[
									-53.13886718750001,
									-32.649023437500034
								],
								[
									-53.16853192343419,
									-32.67175646378118
								],
								[
									-53.23125000000002,
									-32.62539062500001
								],
								[
									-53.36274414062498,
									-32.58115234374996
								],
								[
									-53.48940429687502,
									-32.50322265624999
								],
								[
									-53.601708984374994,
									-32.40302734375001
								],
								[
									-53.65361328124999,
									-32.29873046874998
								],
								[
									-53.70112304687498,
									-32.18632812499992
								],
								[
									-53.74658203125003,
									-32.09746093749993
								],
								[
									-53.76171875,
									-32.0568359375
								],
								[
									-53.80610351562498,
									-32.03994140624994
								],
								[
									-53.87651367187502,
									-31.994531249999923
								],
								[
									-53.920605468749955,
									-31.952343750000026
								],
								[
									-53.98515624999996,
									-31.92812499999998
								],
								[
									-54.10043945312498,
									-31.901562499999983
								],
								[
									-54.22055664062495,
									-31.855175781249955
								],
								[
									-54.36992187499999,
									-31.74501953124998
								],
								[
									-54.47768554687502,
									-31.622753906250026
								],
								[
									-54.53090820312502,
									-31.5419921875
								],
								[
									-54.58764648437503,
									-31.485156249999974
								],
								[
									-54.89599609374997,
									-31.391210937499935
								],
								[
									-55.036035156249994,
									-31.279003906249983
								],
								[
									-55.09116210937495,
									-31.31396484375
								],
								[
									-55.173535156249926,
									-31.279589843749932
								],
								[
									-55.25463867187503,
									-31.225585937499943
								],
								[
									-55.278955078124994,
									-31.184179687500034
								],
								[
									-55.31328124999999,
									-31.14169921874999
								],
								[
									-55.34550781249999,
									-31.092968749999926
								],
								[
									-55.36606445312498,
									-31.04619140624999
								],
								[
									-55.44956054687495,
									-30.964453125000034
								],
								[
									-55.557324218749955,
									-30.87597656250003
								],
								[
									-55.60302734374994,
									-30.85078124999997
								],
								[
									-55.62714843749998,
									-30.85810546875004
								],
								[
									-55.65048828124995,
									-30.89208984375003
								],
								[
									-55.66523437500001,
									-30.924902343749963
								],
								[
									-55.705957031249966,
									-30.946582031249946
								],
								[
									-55.75634765625,
									-30.98710937500003
								],
								[
									-55.807763671874994,
									-31.036718750000006
								],
								[
									-55.87368164062502,
									-31.06962890624996
								],
								[
									-55.95200195312498,
									-31.080859374999946
								],
								[
									-56.00468749999999,
									-31.079199218749963
								],
								[
									-56.015527343749966,
									-31.059667968749977
								],
								[
									-56.01845703125002,
									-30.99189453124994
								],
								[
									-55.998974609374955,
									-30.837207031250045
								],
								[
									-56.044824218749994,
									-30.77763671874999
								],
								[
									-56.105859374999994,
									-30.713769531250023
								],
								[
									-56.176171874999994,
									-30.628417968749957
								],
								[
									-56.4072265625,
									-30.44746093750004
								],
								[
									-56.72167968750003,
									-30.18691406249998
								],
								[
									-56.83271484375001,
									-30.107226562500003
								],
								[
									-56.93725585937497,
									-30.10107421875
								],
								[
									-57.03271484374997,
									-30.109960937500034
								],
								[
									-57.12050781250002,
									-30.14443359374995
								],
								[
									-57.18691406249994,
									-30.26484374999997
								],
								[
									-57.21445312499998,
									-30.28339843750001
								],
								[
									-57.38383789062502,
									-30.280664062499994
								],
								[
									-57.55229492187496,
									-30.261230468749943
								],
								[
									-57.60888671875003,
									-30.187792968750074
								],
								[
									-57.563867187499994,
									-30.139941406250003
								],
								[
									-57.40522460937501,
									-30.033886718750068
								],
								[
									-57.317480468750006,
									-29.939453125000014
								],
								[
									-57.30068359374994,
									-29.85654296874992
								],
								[
									-57.22465820312499,
									-29.782128906250037
								],
								[
									-57.08935546874997,
									-29.71621093750001
								],
								[
									-56.938623046874994,
									-29.594824218750063
								],
								[
									-56.77246093749997,
									-29.41787109375008
								],
								[
									-56.67153320312502,
									-29.287304687500026
								],
								[
									-56.635839843750034,
									-29.20302734375001
								],
								[
									-56.570703124999994,
									-29.138085937499923
								],
								[
									-56.475976562499966,
									-29.09248046875004
								],
								[
									-56.39326171875001,
									-28.99726562500001
								],
								[
									-56.322363281250034,
									-28.852441406249994
								],
								[
									-56.225537109374926,
									-28.737207031249966
								],
								[
									-56.102880859375006,
									-28.651757812499966
								],
								[
									-56.03422851562496,
									-28.58085937499999
								],
								[
									-56.019628906250006,
									-28.524609374999997
								],
								[
									-55.98491210937493,
									-28.488574218750017
								],
								[
									-55.93017578124997,
									-28.47285156250001
								],
								[
									-55.903662109375006,
									-28.443261718750023
								],
								[
									-55.905419921874994,
									-28.39960937500001
								],
								[
									-55.890527343749994,
									-28.370019531250023
								],
								[
									-55.85888671875003,
									-28.354199218749997
								],
								[
									-55.80605468750002,
									-28.359765625000065
								],
								[
									-55.73198242187502,
									-28.38662109374995
								],
								[
									-55.68725585937497,
									-28.381640625000003
								],
								[
									-55.67197265624995,
									-28.344921874999983
								],
								[
									-55.691503906250034,
									-28.302832031249935
								],
								[
									-55.74599609375002,
									-28.25546875000005
								],
								[
									-55.72548828125002,
									-28.20410156250007
								],
								[
									-55.582373046875006,
									-28.12099609375001
								],
								[
									-55.47666015624995,
									-28.089355468750043
								],
								[
									-55.40981445312502,
									-28.03779296874994
								],
								[
									-55.34648437499999,
									-27.955957031249966
								],
								[
									-55.243750000000034,
									-27.89882812500005
								],
								[
									-55.10151367187501,
									-27.86679687499992
								],
								[
									-55.063867187499966,
									-27.83593750000003
								],
								[
									-55.068994140624966,
									-27.796289062500023
								],
								[
									-55.039941406249994,
									-27.767773437499997
								],
								[
									-54.955908203125006,
									-27.747167968750063
								],
								[
									-54.91020507812502,
									-27.70859375000002
								],
								[
									-54.90278320312501,
									-27.65195312500002
								],
								[
									-54.87573242187503,
									-27.59921875000002
								],
								[
									-54.82910156250003,
									-27.55058593750006
								],
								[
									-54.777099609375,
									-27.53251953125003
								],
								[
									-54.71972656250003,
									-27.54492187500007
								],
								[
									-54.66586914062498,
									-27.526562500000054
								],
								[
									-54.61542968750001,
									-27.47714843750002
								],
								[
									-54.55493164062503,
									-27.454101562500043
								],
								[
									-54.484326171874955,
									-27.45732421874999
								],
								[
									-54.44814453124994,
									-27.446484375000082
								],
								[
									-54.32700195312495,
									-27.423535156250026
								],
								[
									-54.26015625000002,
									-27.382031249999926
								],
								[
									-54.20522460937502,
									-27.289648437499935
								],
								[
									-54.156445312499926,
									-27.253808593749994
								],
								[
									-54.11381835937496,
									-27.27470703124999
								],
								[
									-54.04013671874995,
									-27.24374999999999
								],
								[
									-53.93535156250002,
									-27.161132812500043
								],
								[
									-53.915625000000006,
									-27.15957031250008
								],
								[
									-53.83818359375002,
									-27.121093750000057
								],
								[
									-53.758496093749955,
									-26.978320312500003
								],
								[
									-53.71728515625,
									-26.8828125
								],
								[
									-53.72714843749998,
									-26.80468750000007
								],
								[
									-53.753320312499966,
									-26.74863281250002
								],
								[
									-53.744580078124955,
									-26.666503906249986
								],
								[
									-53.718164062499994,
									-26.443164062500045
								],
								[
									-53.71093750000003,
									-26.351855468750017
								],
								[
									-53.668554687500006,
									-26.288183593750006
								],
								[
									-53.671289062499966,
									-26.22509765625003
								],
								[
									-53.746923828125006,
									-26.083691406249997
								],
								[
									-53.8232421875,
									-25.959570312500034
								],
								[
									-53.86420898437501,
									-25.74882812499999
								],
								[
									-53.89116210937499,
									-25.668847656250037
								],
								[
									-53.95478515624998,
									-25.647656250000082
								],
								[
									-54.01230468749998,
									-25.57792968749999
								],
								[
									-54.08500976562496,
									-25.57187499999992
								],
								[
									-54.119238281250006,
									-25.54521484374999
								],
								[
									-54.15458984375002,
									-25.52304687499992
								],
								[
									-54.206152343750034,
									-25.529589843750003
								],
								[
									-54.250097656250006,
									-25.570410156249977
								],
								[
									-54.33188476562498,
									-25.57187499999992
								],
								[
									-54.38334960937499,
									-25.588671875000045
								],
								[
									-54.44394531249998,
									-25.624999999999986
								],
								[
									-54.50151367187499,
									-25.60830078125005
								],
								[
									-54.537841796875,
									-25.576464843750045
								],
								[
									-54.61586914062502,
									-25.576074218750065
								],
								[
									-54.61054687499998,
									-25.43271484374999
								],
								[
									-54.47314453124997,
									-25.220214843750043
								],
								[
									-54.43623046875001,
									-25.12128906250004
								],
								[
									-54.4541015625,
									-25.06523437499999
								],
								[
									-54.412988281249966,
									-24.867480468749946
								],
								[
									-54.312939453124926,
									-24.52812499999999
								],
								[
									-54.281005859375,
									-24.306054687499966
								],
								[
									-54.31728515625002,
									-24.201269531249935
								],
								[
									-54.318261718749966,
									-24.128124999999955
								],
								[
									-54.26689453124996,
									-24.06582031250005
								],
								[
									-54.241796875000006,
									-24.047265624999994
								],
								[
									-54.37080078125001,
									-23.971191406249957
								],
								[
									-54.44023437500002,
									-23.901757812500023
								],
								[
									-54.52958984375002,
									-23.852148437500034
								],
								[
									-54.62548828125003,
									-23.812499999999957
								],
								[
									-54.67177734374994,
									-23.829003906250023
								],
								[
									-54.72138671875001,
									-23.852148437500034
								],
								[
									-54.81728515625002,
									-23.888476562499974
								],
								[
									-54.926464843749955,
									-23.951367187499997
								],
								[
									-54.98266601562494,
									-23.974511718749923
								],
								[
									-55.081884765625006,
									-23.99765625000002
								],
								[
									-55.1943359375,
									-24.017480468749966
								],
								[
									-55.28691406249993,
									-24.00429687499995
								],
								[
									-55.36630859374995,
									-23.99101562499999
								],
								[
									-55.41591796875002,
									-23.951367187499997
								],
								[
									-55.4423828125,
									-23.865332031249963
								],
								[
									-55.4423828125,
									-23.792578124999977
								],
								[
									-55.458886718749994,
									-23.686718749999997
								],
								[
									-55.51845703124994,
									-23.62724609374996
								],
								[
									-55.53828124999998,
									-23.580957031250037
								],
								[
									-55.54160156249995,
									-23.524707031249946
								],
								[
									-55.53496093749993,
									-23.461914062499943
								],
								[
									-55.51845703124994,
									-23.415625000000006
								],
								[
									-55.52836914062502,
									-23.359375000000014
								],
								[
									-55.554833984374994,
									-23.31962890624999
								],
								[
									-55.54819335937498,
									-23.25019531249997
								],
								[
									-55.561425781249994,
									-23.15429687499997
								],
								[
									-55.60112304687502,
									-23.0947265625
								],
								[
									-55.620996093749966,
									-23.02529296874998
								],
								[
									-55.620996093749966,
									-22.95585937499996
								],
								[
									-55.65073242187498,
									-22.88642578124994
								],
								[
									-55.65405273437494,
									-22.810351562499974
								],
								[
									-55.627587890624966,
									-22.74091796875004
								],
								[
									-55.61767578125,
									-22.67148437500002
								],
								[
									-55.64741210937501,
									-22.621875000000045
								],
								[
									-55.70366210937502,
									-22.592089843750017
								],
								[
									-55.74663085937499,
									-22.5126953125
								],
								[
									-55.753271484375006,
									-22.410156249999986
								],
								[
									-55.79956054687503,
									-22.35390624999998
								],
								[
									-55.84916992187499,
									-22.30761718749997
								],
								[
									-55.905371093750006,
									-22.30761718749997
								],
								[
									-55.991406249999926,
									-22.281152343749994
								],
								[
									-56.06748046874998,
									-22.28447265624996
								],
								[
									-56.18984374999994,
									-22.281152343749994
								],
								[
									-56.246044921874926,
									-22.2646484375
								],
								[
									-56.275781249999966,
									-22.22822265625004
								],
								[
									-56.35185546874999,
									-22.17861328124998
								],
								[
									-56.39487304687498,
									-22.092675781249966
								],
								[
									-56.44780273437502,
									-22.07617187499997
								],
								[
									-56.523828124999966,
									-22.102539062500014
								],
								[
									-56.55029296875003,
									-22.13564453125001
								],
								[
									-56.58007812499994,
									-22.181933593749946
								],
								[
									-56.63300781249998,
									-22.23486328124997
								],
								[
									-56.70244140625002,
									-22.231542968750006
								],
								[
									-56.77519531250002,
									-22.261328125000034
								],
								[
									-56.844677734374955,
									-22.2646484375
								],
								[
									-56.93725585937497,
									-22.27128906250003
								],
								[
									-57.02988281249992,
									-22.24482421874997
								],
								[
									-57.14233398437503,
									-22.21503906249994
								],
								[
									-57.23823242187501,
									-22.19521484374998
								],
								[
									-57.33085937499996,
									-22.21503906249994
								],
								[
									-57.39365234374998,
									-22.19843750000001
								],
								[
									-57.47636718749993,
									-22.188574218749963
								],
								[
									-57.56894531249998,
									-22.181933593749946
								],
								[
									-57.64169921874998,
									-22.12900390624999
								],
								[
									-57.721093749999966,
									-22.099218749999963
								],
								[
									-57.76406250000002,
									-22.109179687500045
								],
								[
									-57.82031250000003,
									-22.14228515625004
								],
								[
									-57.87983398437498,
									-22.13564453125001
								],
								[
									-57.95590820312495,
									-22.109179687500045
								],
								[
									-57.98569335937498,
									-22.046386718750043
								],
								[
									-57.97905273437496,
									-22.006640625000017
								],
								[
									-57.96249999999995,
									-21.966992187500026
								],
								[
									-57.93276367187502,
									-21.91074218750002
								],
								[
									-57.94931640624992,
									-21.851171874999963
								],
								[
									-57.94267578124999,
									-21.798339843749957
								],
								[
									-57.92944335937497,
									-21.751953125
								],
								[
									-57.916210937499926,
									-21.699121093749994
								],
								[
									-57.92617187500002,
									-21.649511718750006
								],
								[
									-57.92944335937497,
									-21.596582031249966
								],
								[
									-57.93608398437499,
									-21.54697265624999
								],
								[
									-57.945996093749955,
									-21.494042968750037
								],
								[
									-57.90629882812496,
									-21.417968749999915
								],
								[
									-57.87324218749998,
									-21.355078124999977
								],
								[
									-57.89306640625003,
									-21.302246093749957
								],
								[
									-57.886474609375,
									-21.265820312499997
								],
								[
									-57.86000976562494,
									-21.206250000000026
								],
								[
									-57.82695312499996,
									-21.133593749999974
								],
								[
									-57.830224609374994,
									-20.997949218749966
								],
								[
									-57.86000976562494,
									-20.918554687500034
								],
								[
									-57.89223632812502,
									-20.89707031250002
								],
								[
									-57.90048828124992,
									-20.873046875
								],
								[
									-57.88481445312493,
									-20.84169921875001
								],
								[
									-57.90190429687496,
									-20.809374999999918
								],
								[
									-57.90849609374996,
									-20.776367187499943
								],
								[
									-57.89140624999993,
									-20.747460937499994
								],
								[
									-57.91513671874998,
									-20.690332031249994
								],
								[
									-57.96249999999995,
									-20.673828125000014
								],
								[
									-57.97905273437496,
									-20.65732421875002
								],
								[
									-57.99560546874994,
									-20.594433593749997
								],
								[
									-58.00883789062499,
									-20.521679687499926
								],
								[
									-58.00224609374996,
									-20.465429687500006
								],
								[
									-58.02539062499997,
									-20.41582031250003
								],
								[
									-58.05844726562495,
									-20.386132812500023
								],
								[
									-58.091503906249955,
									-20.333203124999983
								],
								[
									-58.12460937499995,
									-20.29345703124997
								],
								[
									-58.13779296874995,
									-20.237304687499986
								],
								[
									-58.159765625000006,
									-20.16464843750002
								],
								[
									-58.09374999999994,
									-20.151074218749997
								],
								[
									-58.06762695312497,
									-20.11035156249997
								],
								[
									-58.021142578124994,
									-20.05517578125
								],
								[
									-57.96015625000001,
									-20.040722656249997
								],
								[
									-57.887597656249966,
									-20.020410156250023
								],
								[
									-57.860742187499994,
									-19.979589843749977
								],
								[
									-58.02993164062502,
									-19.832714843749983
								],
								[
									-58.131494140624994,
									-19.74453125000005
								],
								[
									-58.07202148437497,
									-19.625292968749918
								],
								[
									-57.97167968749994,
									-19.42421874999998
								],
								[
									-57.87451171874997,
									-19.22949218749993
								],
								[
									-57.80039062499998,
									-19.080957031250037
								],
								[
									-57.78144531250001,
									-19.05351562499996
								],
								[
									-57.716796875,
									-19.044042968749977
								],
								[
									-57.728613281250006,
									-18.96738281249999
								],
								[
									-57.73085937500002,
									-18.917187499999983
								],
								[
									-57.783105468749994,
									-18.91425781250001
								],
								[
									-57.724999999999966,
									-18.733203124999974
								],
								[
									-57.63916015624997,
									-18.47500000000005
								],
								[
									-57.57402343749993,
									-18.27929687499997
								],
								[
									-57.55312499999994,
									-18.246484375000037
								],
								[
									-57.50615234374996,
									-18.237304687499943
								],
								[
									-57.49565429687496,
									-18.214648437499946
								],
								[
									-57.55205078124999,
									-18.183105468749915
								],
								[
									-57.58647460937499,
									-18.122265624999955
								],
								[
									-57.66166992187496,
									-17.94736328125002
								],
								[
									-57.78017578125002,
									-17.67177734375001
								],
								[
									-57.78886718750002,
									-17.573046874999974
								],
								[
									-57.83247070312501,
									-17.512109374999994
								],
								[
									-57.90502929687497,
									-17.53232421875002
								],
								[
									-57.990917968749955,
									-17.51289062499997
								],
								[
									-58.20556640625,
									-17.363085937500003
								],
								[
									-58.34775390624992,
									-17.282128906250037
								],
								[
									-58.39599609374997,
									-17.234277343749966
								],
								[
									-58.417382812499994,
									-17.08056640625
								],
								[
									-58.45981445312492,
									-16.91074218750005
								],
								[
									-58.47812499999992,
									-16.70068359374997
								],
								[
									-58.470605468749994,
									-16.65019531249999
								],
								[
									-58.35039062500002,
									-16.49082031250002
								],
								[
									-58.35078125000001,
									-16.41025390625005
								],
								[
									-58.34057617187497,
									-16.339941406249935
								],
								[
									-58.34560546875002,
									-16.284374999999983
								],
								[
									-58.375390624999966,
									-16.283593749999994
								],
								[
									-58.42368164062495,
									-16.307910156249974
								],
								[
									-58.49658203124994,
									-16.32666015624997
								],
								[
									-58.53793945312495,
									-16.328222656250034
								],
								[
									-58.95727539062503,
									-16.313183593749983
								],
								[
									-59.434277343749955,
									-16.295996093750034
								],
								[
									-59.83115234374998,
									-16.28173828124997
								],
								[
									-60.17558593749999,
									-16.269335937500017
								],
								[
									-60.187207031249955,
									-16.13212890624996
								],
								[
									-60.206640625000006,
									-15.901953124999963
								],
								[
									-60.220410156249955,
									-15.738671875000009
								],
								[
									-60.242333984374994,
									-15.479589843749977
								],
								[
									-60.38046874999998,
									-15.31826171874998
								],
								[
									-60.53046874999998,
									-15.143164062500006
								],
								[
									-60.58320312499998,
									-15.09833984374994
								],
								[
									-60.402001953124994,
									-15.092773437499957
								],
								[
									-60.273339843749994,
									-15.088769531250023
								],
								[
									-60.29887695312496,
									-14.61855468749998
								],
								[
									-60.33803710937494,
									-14.570507812500054
								],
								[
									-60.372705078124994,
									-14.418750000000045
								],
								[
									-60.396240234375,
									-14.332812499999946
								],
								[
									-60.460156249999955,
									-14.263085937499952
								],
								[
									-60.47465820312499,
									-14.184765624999983
								],
								[
									-60.462988281250006,
									-14.132421874999977
								],
								[
									-60.42807617187498,
									-14.100000000000023
								],
								[
									-60.40498046874998,
									-14.019238281250011
								],
								[
									-60.42236328124997,
									-13.937988281249972
								],
								[
									-60.460156249999955,
									-13.862402343750034
								],
								[
									-60.506591796875,
									-13.789843749999989
								],
								[
									-60.59531249999995,
									-13.745312499999983
								],
								[
									-60.72236328124998,
									-13.664355468750003
								],
								[
									-60.914501953124955,
									-13.561425781249994
								],
								[
									-61.07700195312495,
									-13.489746093749957
								],
								[
									-61.129150390625,
									-13.498535156249972
								],
								[
									-61.41606445312502,
									-13.526562499999997
								],
								[
									-61.51157226562492,
									-13.541210937499969
								],
								[
									-61.57568359375003,
									-13.524804687499994
								],
								[
									-61.789941406249966,
									-13.525585937499983
								],
								[
									-61.87412109374998,
									-13.470410156250011
								],
								[
									-61.944726562499966,
									-13.40625
								],
								[
									-62.09477539062499,
									-13.241992187500017
								],
								[
									-62.11801757812492,
									-13.159765624999963
								],
								[
									-62.17607421874993,
									-13.13369140624998
								],
								[
									-62.263916015625,
									-13.143652343749977
								],
								[
									-62.35283203124999,
									-13.132421874999991
								],
								[
									-62.525537109374994,
									-13.06425781249996
								],
								[
									-62.68706054687496,
									-12.994335937500011
								],
								[
									-62.76547851562495,
									-12.997265624999997
								],
								[
									-62.83515625000001,
									-12.953710937500006
								],
								[
									-62.957910156249966,
									-12.847070312499952
								],
								[
									-63.01518554687502,
									-12.805566406250023
								],
								[
									-63.04135742187492,
									-12.750390624999966
								],
								[
									-63.067480468750006,
									-12.66914062499994
								],
								[
									-63.11679687499992,
									-12.651660156249932
								],
								[
									-63.18066406249997,
									-12.666210937500054
								],
								[
									-63.249755859375,
									-12.707910156250023
								],
								[
									-63.34667968749994,
									-12.680078125000037
								],
								[
									-63.46523437499994,
									-12.605175781250054
								],
								[
									-63.54189453125002,
									-12.546679687500031
								],
								[
									-63.585644531249955,
									-12.51894531249998
								],
								[
									-63.68857421874998,
									-12.4780273437499
								],
								[
									-63.7880859375,
									-12.469433593749926
								],
								[
									-63.93857421874992,
									-12.529687499999952
								],
								[
									-64.06162109374995,
									-12.505078124999912
								],
								[
									-64.255029296875,
									-12.483300781249909
								],
								[
									-64.42050781249995,
									-12.439746093749918
								],
								[
									-64.48076171874999,
									-12.326171874999957
								],
								[
									-64.51342773437497,
									-12.250976562499915
								],
								[
									-64.611669921875,
									-12.203906249999918
								],
								[
									-64.69003906249998,
									-12.146484374999943
								],
								[
									-64.783447265625,
									-12.05937499999996
								],
								[
									-64.82988281249996,
									-12.030273437499986
								],
								[
									-64.91435546874993,
									-12.005957031250006
								],
								[
									-64.99252929687498,
									-11.975195312499963
								],
								[
									-65.00122070312497,
									-11.920019531249906
								],
								[
									-65.03027343750003,
									-11.847363281250026
								],
								[
									-65.037109375,
									-11.829394531249918
								],
								[
									-65.09028320312498,
									-11.7412109374999
								],
								[
									-65.11513671875,
									-11.735058593749969
								],
								[
									-65.14267578125,
									-11.752343749999937
								],
								[
									-65.16337890624996,
									-11.765136718749972
								],
								[
									-65.18574218749998,
									-11.749511718749986
								],
								[
									-65.18974609374999,
									-11.710058593749949
								],
								[
									-65.175390625,
									-11.646875000000037
								],
								[
									-65.20620117187497,
									-11.580566406250028
								],
								[
									-65.28227539062493,
									-11.511035156249903
								],
								[
									-65.32202148437494,
									-11.439160156249997
								],
								[
									-65.32548828124993,
									-11.364746093749943
								],
								[
									-65.34238281249992,
									-11.315039062499935
								],
								[
									-65.37285156249999,
									-11.28994140624998
								],
								[
									-65.389892578125,
									-11.246289062499969
								],
								[
									-65.39360351562496,
									-11.18427734374994
								],
								[
									-65.37158203125,
									-11.110351562499886
								],
								[
									-65.32377929687496,
									-11.024804687499966
								],
								[
									-65.33403320312499,
									-10.892773437499969
								],
								[
									-65.40229492187495,
									-10.714746093749937
								],
								[
									-65.43999023437499,
									-10.58623046874996
								],
								[
									-65.44711914062495,
									-10.507421874999977
								],
								[
									-65.4369140625,
									-10.449023437499903
								],
								[
									-65.39545898437498,
									-10.392285156249969
								],
								[
									-65.3130859375,
									-10.253027343749935
								],
								[
									-65.29858398437497,
									-10.14677734374996
								],
								[
									-65.32456054687492,
									-10.026953124999977
								],
								[
									-65.32812499999994,
									-9.935546874999915
								],
								[
									-65.30932617187503,
									-9.872656249999977
								],
								[
									-65.33789062499997,
									-9.790234374999983
								],
								[
									-65.39614257812494,
									-9.712402343749929
								],
								[
									-65.43676757812497,
									-9.710449218749972
								],
								[
									-65.49199218749993,
									-9.73173828124996
								],
								[
									-65.55869140624995,
									-9.797460937499935
								],
								[
									-65.63710937500002,
									-9.809082031249915
								],
								[
									-65.706787109375,
									-9.76845703124998
								],
								[
									-65.92470703125,
									-9.785449218749974
								],
								[
									-66.26357421875002,
									-9.826074218749994
								],
								[
									-66.39921874999993,
									-9.868164062499957
								],
								[
									-66.47890625,
									-9.88613281249998
								],
								[
									-66.57534179687502,
									-9.899902343749943
								],
								[
									-66.72998046875,
									-9.975488281249966
								],
								[
									-67.11152343750001,
									-10.26894531249998
								],
								[
									-67.19047851562502,
									-10.311425781249937
								],
								[
									-67.28046874999995,
									-10.317285156249966
								],
								[
									-67.33271484374995,
									-10.357910156249986
								],
								[
									-67.41694335937498,
									-10.389843749999926
								],
								[
									-67.58242187500002,
									-10.505957031249949
								],
								[
									-67.66665039062494,
									-10.598925781249974
								],
								[
									-67.72177734374998,
									-10.683105468749886
								],
								[
									-67.78569335937496,
									-10.686035156249957
								],
								[
									-67.83500976562496,
									-10.662792968749926
								],
								[
									-67.99169921875,
									-10.674414062499892
								],
								[
									-68.07167968749997,
									-10.703124999999972
								],
								[
									-68.15864257812498,
									-10.785058593749966
								],
								[
									-68.26660156249997,
									-10.933105468749929
								],
								[
									-68.31113281249998,
									-10.975195312499977
								],
								[
									-68.39799804687499,
									-11.018749999999969
								],
								[
									-68.49833984375002,
									-11.054785156249935
								],
								[
									-68.62265624999995,
									-11.109179687499918
								],
								[
									-68.678369140625,
									-11.112792968749943
								],
								[
									-68.72749023437498,
									-11.122460937499966
								],
								[
									-68.769921875,
									-11.097656249999972
								],
								[
									-68.78408203124997,
									-11.044628906249912
								],
								[
									-68.84833984374998,
									-11.011132812499923
								],
								[
									-69.00166015624995,
									-10.994335937499969
								],
								[
									-69.228515625,
									-10.955664062499906
								],
								[
									-69.462548828125,
									-10.94814453124998
								],
								[
									-69.57861328125,
									-10.951757812500006
								],
								[
									-69.67402343749998,
									-10.954101562499943
								],
								[
									-69.83979492187501,
									-10.933398437499989
								],
								[
									-69.96035156249997,
									-10.929882812499983
								],
								[
									-70.06630859374997,
									-10.982421875000028
								],
								[
									-70.22006835937495,
									-11.047656249999903
								],
								[
									-70.29038085937498,
									-11.064257812500003
								],
								[
									-70.34199218750001,
									-11.066699218749974
								],
								[
									-70.39228515624995,
									-11.058593749999915
								],
								[
									-70.45087890624998,
									-11.024804687499966
								],
								[
									-70.53325195312499,
									-10.946874999999977
								],
								[
									-70.59653320312498,
									-10.97685546874996
								],
								[
									-70.642333984375,
									-11.010253906250014
								],
								[
									-70.64155273437501,
									-10.840820312499957
								],
								[
									-70.64033203124995,
									-10.58603515624992
								],
								[
									-70.63935546875001,
									-10.361328124999972
								],
								[
									-70.63852539062492,
									-10.181542968749937
								],
								[
									-70.63759765625,
									-9.97177734374992
								],
								[
									-70.63691406249995,
									-9.823730468749957
								],
								[
									-70.59379882812496,
									-9.767480468749966
								],
								[
									-70.56723632812498,
									-9.704589843749943
								],
								[
									-70.59916992187499,
									-9.620507812500037
								],
								[
									-70.59223632812501,
									-9.543457031249972
								],
								[
									-70.57016601562495,
									-9.489843749999977
								],
								[
									-70.54111328124998,
									-9.437499999999972
								],
								[
									-70.60791015625,
									-9.463671874999974
								],
								[
									-70.63691406249995,
									-9.478222656249912
								],
								[
									-70.6724609375,
									-9.517968749999937
								],
								[
									-70.75849609374995,
									-9.571679687500037
								],
								[
									-70.81625976562498,
									-9.625292968749946
								],
								[
									-70.88452148437494,
									-9.669042968749977
								],
								[
									-70.97075195312493,
									-9.765722656249963
								],
								[
									-71.041748046875,
									-9.818749999999923
								],
								[
									-71.11528320312499,
									-9.852441406250037
								],
								[
									-71.23793945312502,
									-9.966015624999912
								],
								[
									-71.33940429687499,
									-9.988574218749974
								],
								[
									-71.6080078125,
									-10.006054687499983
								],
								[
									-71.887451171875,
									-10.005566406249969
								],
								[
									-72.14296875,
									-10.005175781249974
								],
								[
									-72.18159179687495,
									-10.003710937499946
								],
								[
									-72.1791015625,
									-9.9101562499999
								],
								[
									-72.17285156249997,
									-9.844042968749932
								],
								[
									-72.25996093749995,
									-9.774316406249937
								],
								[
									-72.26582031249998,
									-9.688476562500028
								],
								[
									-72.28901367187501,
									-9.629199218750031
								],
								[
									-72.31806640624998,
									-9.5566406249999
								],
								[
									-72.37905273437497,
									-9.510156249999937
								],
								[
									-72.46474609375002,
									-9.492187499999915
								],
								[
									-72.60546875,
									-9.452050781249909
								],
								[
									-72.81425781249999,
									-9.41035156249994
								],
								[
									-73.01376953124995,
									-9.407421874999969
								],
								[
									-73.20942382812493,
									-9.411425781249903
								],
								[
									-73.08984375,
									-9.265722656249963
								],
								[
									-72.970361328125,
									-9.120117187499972
								],
								[
									-72.97402343750002,
									-8.993164062499957
								],
								[
									-73.07050781249995,
									-8.882812500000028
								],
								[
									-73.12255859375,
									-8.814062499999963
								],
								[
									-73.20312499999997,
									-8.719335937499949
								],
								[
									-73.30244140624995,
									-8.654003906249955
								],
								[
									-73.35673828125002,
									-8.566992187499991
								],
								[
									-73.35170898437497,
									-8.514160156249972
								],
								[
									-73.36040039062496,
									-8.479296874999974
								],
								[
									-73.39814453125001,
									-8.458984375000014
								],
								[
									-73.43588867187498,
									-8.427050781249903
								],
								[
									-73.48813476562495,
									-8.392187499999906
								],
								[
									-73.54912109374996,
									-8.345800781249963
								],
								[
									-73.54912109374996,
									-8.2993164062499
								],
								[
									-73.57236328124998,
									-8.249902343749966
								],
								[
									-73.61010742187503,
									-8.191894531249957
								],
								[
									-73.61010742187503,
									-8.145410156249909
								],
								[
									-73.64492187500002,
									-8.072851562499949
								],
								[
									-73.68266601562499,
									-8.020605468749963
								],
								[
									-73.72041015624993,
									-7.985742187499966
								],
								[
									-73.77558593749998,
									-7.936425781249966
								],
								[
									-73.77270507812503,
									-7.895703125000011
								],
								[
									-73.73203125,
									-7.875390624999966
								],
								[
									-73.714599609375,
									-7.829003906249923
								],
								[
									-73.72041015624993,
									-7.78251953124996
								],
								[
									-73.76689453124999,
									-7.753515624999906
								],
								[
									-73.82207031249996,
									-7.738964843749969
								],
								[
									-73.89462890625,
									-7.654785156249957
								],
								[
									-73.94687499999998,
									-7.611230468749966
								],
								[
									-73.98173828124999,
									-7.585058593749963
								],
								[
									-74.00205078124995,
									-7.556054687499923
								],
								[
									-73.98173828124999,
									-7.535742187499949
								],
								[
									-73.95849609374994,
									-7.506640624999974
								],
								[
									-73.95268554687502,
									-7.460253906249946
								],
								[
									-73.96430664062498,
									-7.4166992187499545
								],
								[
									-73.96430664062498,
									-7.378906249999972
								],
								[
									-73.92944335937497,
									-7.367285156250006
								],
								[
									-73.89174804687494,
									-7.373144531249963
								],
								[
									-73.85400390624997,
									-7.349902343750017
								],
								[
									-73.80463867187495,
									-7.341210937500023
								],
								[
									-73.74946289062498,
									-7.33535156249998
								],
								[
									-73.72041015624993,
									-7.309277343749912
								],
								[
									-73.72333984375001,
									-7.262792968750034
								],
								[
									-73.758203125,
									-7.172753906249895
								],
								[
									-73.79301757812499,
									-7.135058593749946
								],
								[
									-73.80463867187495,
									-7.079882812499903
								],
								[
									-73.77626953124994,
									-6.973535156249909
								],
								[
									-73.75810546874999,
									-6.905761718749957
								],
								[
									-73.69453124999998,
									-6.833789062500031
								],
								[
									-73.49990234374997,
									-6.679492187499946
								],
								[
									-73.32548828124996,
									-6.574707031249915
								],
								[
									-73.24033203124992,
									-6.564062499999977
								],
								[
									-73.17744140624998,
									-6.52519531249996
								],
								[
									-73.137353515625,
									-6.465820312500028
								],
								[
									-73.12631835937498,
									-6.400878906249943
								],
								[
									-73.13535156249995,
									-6.344335937499977
								],
								[
									-73.16772460937497,
									-6.26064453124998
								],
								[
									-73.20649414062495,
									-6.156445312499969
								],
								[
									-73.23554687500001,
									-6.098437499999974
								],
								[
									-73.20937500000002,
									-6.02871093749998
								],
								[
									-73.16289062499996,
									-5.933398437499918
								],
								[
									-73.06806640625001,
									-5.789550781249929
								],
								[
									-72.97988281249997,
									-5.634863281249935
								],
								[
									-72.97021484374997,
									-5.58964843749996
								],
								[
									-72.95893554687498,
									-5.495214843749906
								],
								[
									-72.91826171874993,
									-5.302539062500003
								],
								[
									-72.89580078124999,
									-5.1982421874999005
								],
								[
									-72.90747070312497,
									-5.157714843749986
								],
								[
									-72.88706054687498,
									-5.122753906249969
								],
								[
									-72.83193359374994,
									-5.093749999999929
								],
								[
									-72.69873046874997,
									-5.067187500000017
								],
								[
									-72.60834960937495,
									-5.009570312500003
								],
								[
									-72.468994140625,
									-4.901269531249966
								],
								[
									-72.35283203124996,
									-4.7860351562499375
								],
								[
									-72.25678710937501,
									-4.748925781249923
								],
								[
									-72.08251953124994,
									-4.642285156249969
								],
								[
									-71.98242187499997,
									-4.5746093749999375
								],
								[
									-71.94316406249999,
									-4.553320312499963
								],
								[
									-71.8447265625,
									-4.504394531249943
								],
								[
									-71.66835937499994,
									-4.487304687499915
								],
								[
									-71.52133789062492,
									-4.469726562499886
								],
								[
									-71.43828124999996,
									-4.437597656250006
								],
								[
									-71.316796875,
									-4.424316406249972
								],
								[
									-71.23500976562494,
									-4.388183593749972
								],
								[
									-71.14423828125001,
									-4.387207031249957
								],
								[
									-70.97368164062499,
									-4.350488281250023
								],
								[
									-70.91562499999998,
									-4.29531249999998
								],
								[
									-70.86601562499999,
									-4.229589843749906
								],
								[
									-70.79951171874995,
									-4.1733398437499005
								],
								[
									-70.72158203124997,
									-4.158886718749983
								],
								[
									-70.63457031250002,
									-4.168652343749926
								],
								[
									-70.5306640625,
									-4.167578124999977
								],
								[
									-70.40463867187498,
									-4.150097656249969
								],
								[
									-70.34365234375,
									-4.19365234374996
								],
								[
									-70.31689453124994,
									-4.24697265624998
								],
								[
									-70.23916015625002,
									-4.301171874999923
								],
								[
									-70.18398437499997,
									-4.298144531250017
								],
								[
									-70.12880859375,
									-4.286621093749886
								],
								[
									-70.05332031249998,
									-4.333105468750034
								],
								[
									-70.00395507812496,
									-4.327246093749906
								],
								[
									-69.97202148437495,
									-4.301171874999923
								],
								[
									-69.96591796875003,
									-4.235937499999963
								],
								[
									-69.94819335937498,
									-4.200585937500037
								],
								[
									-69.91103515624997,
									-3.9965820312500426
								],
								[
									-69.849755859375,
									-3.6598632812500114
								],
								[
									-69.79414062499995,
									-3.3545898437499915
								],
								[
									-69.73261718749993,
									-3.016699218749906
								],
								[
									-69.66904296875003,
									-2.6676757812500256
								],
								[
									-69.60468749999998,
									-2.3142578124999744
								],
								[
									-69.55185546874998,
									-2.0242187500000313
								],
								[
									-69.50644531249995,
									-1.7749023437500426
								],
								[
									-69.47861328124998,
									-1.62197265624998
								],
								[
									-69.43491210937503,
									-1.4216796874999318
								],
								[
									-69.41787109375002,
									-1.245703124999963
								],
								[
									-69.40024414062498,
									-1.1949218749999204
								],
								[
									-69.41142578124996,
									-1.1522460937500227
								],
								[
									-69.44912109375,
									-1.0916015624999318
								],
								[
									-69.44873046875,
									-1.06494140625
								],
								[
									-69.4443359375,
									-1.0295898437499034
								],
								[
									-69.44873046875,
									-0.9987304687500114
								],
								[
									-69.48842773437502,
									-0.965722656250037
								],
								[
									-69.519287109375,
									-0.9458007812499716
								],
								[
									-69.54355468749998,
									-0.9171874999999261
								],
								[
									-69.55458984375,
									-0.8774414062499005
								],
								[
									-69.57441406249995,
									-0.837792968749909
								],
								[
									-69.58325195312497,
									-0.7958984374999005
								],
								[
									-69.61191406250003,
									-0.7627929687499062
								],
								[
									-69.62070312499995,
									-0.720898437499983
								],
								[
									-69.60087890625002,
									-0.6812499999999915
								],
								[
									-69.59204101562497,
									-0.639355468749983
								],
								[
									-69.60087890625002,
									-0.5996093750000568
								],
								[
									-69.61191406250003,
									-0.5533203124999488
								],
								[
									-69.63398437500001,
									-0.5092773437499574
								],
								[
									-69.66748046875,
									-0.4824218749999858
								],
								[
									-69.74746093750002,
									-0.45253906249993747
								],
								[
									-69.82792968749999,
									-0.38134765625
								],
								[
									-69.92275390624994,
									-0.31748046874996305
								],
								[
									-70.04404296874998,
									-0.19619140624993747
								],
								[
									-70.07050781249993,
									-0.13886718749998295
								],
								[
									-70.07094726562502,
									0.01855468750002842
								],
								[
									-70.06572265624993,
									0.1893554687500938
								],
								[
									-70.05791015624996,
									0.44736328125007674
								],
								[
									-70.05390624999993,
									0.5786132812500853
								],
								[
									-69.98544921875,
									0.585839843750037
								],
								[
									-69.92509765624999,
									0.5894042968750597
								],
								[
									-69.86206054687503,
									0.5984863281250483
								],
								[
									-69.80712890625003,
									0.6074707031251023
								],
								[
									-69.75673828124997,
									0.6263671874999517
								],
								[
									-69.718896484375,
									0.6498046875000227
								],
								[
									-69.67382812499994,
									0.665087890625017
								],
								[
									-69.63872070312499,
									0.6596679687499858
								],
								[
									-69.60361328125003,
									0.6803710937499403
								],
								[
									-69.56484374999994,
									0.700195312500071
								],
								[
									-69.52705078124998,
									0.716406250000091
								],
								[
									-69.47211914062498,
									0.7299316406250824
								],
								[
									-69.42080078125,
									0.6983886718750512
								],
								[
									-69.3919921875,
									0.666894531250037
								],
								[
									-69.35864257812494,
									0.6515625000000256
								],
								[
									-69.32714843750003,
									0.6551757812500512
								],
								[
									-69.30551757812498,
									0.6524414062499346
								],
								[
									-69.28300781249999,
									0.6272460937500455
								],
								[
									-69.25419921874999,
									0.6254394531249403
								],
								[
									-69.21279296875,
									0.6299316406250597
								],
								[
									-69.174072265625,
									0.6353515625000057
								],
								[
									-69.15605468749999,
									0.6425292968750398
								],
								[
									-69.15332031249994,
									0.6587890625000767
								],
								[
									-69.16323242187502,
									0.6866699218749801
								],
								[
									-69.17675781250003,
									0.712841796874983
								],
								[
									-69.16596679687495,
									0.7533203125000512
								],
								[
									-69.16503906250003,
									0.8019531250001108
								],
								[
									-69.16323242187502,
									0.8640625000000597
								],
								[
									-69.19384765624994,
									0.8982910156250199
								],
								[
									-69.22446289062498,
									0.9631347656250853
								],
								[
									-69.25869140625002,
									1.015380859375071
								],
								[
									-69.31181640625002,
									1.0504882812500256
								],
								[
									-69.36137695312499,
									1.0640136718750313
								],
								[
									-69.40278320312498,
									1.0423828125000654
								],
								[
									-69.44150390624995,
									1.0388183593749574
								],
								[
									-69.47031249999998,
									1.058593750000071
								],
								[
									-69.51713867187499,
									1.0594726562500796
								],
								[
									-69.56757812499998,
									1.065771484375034
								],
								[
									-69.62089843749999,
									1.0732421875000426
								],
								[
									-69.71699218749995,
									1.05908203125
								],
								[
									-69.751318359375,
									1.0766113281251108
								],
								[
									-69.79814453124996,
									1.0784179687500313
								],
								[
									-69.85214843750003,
									1.0595214843750824
								],
								[
									-69.85078124999993,
									1.3087890625000682
								],
								[
									-69.84946289062503,
									1.5438964843750966
								],
								[
									-69.84858398437493,
									1.7087402343750142
								],
								[
									-69.79995117187497,
									1.705175781250091
								],
								[
									-69.73959960937503,
									1.7348632812500995
								],
								[
									-69.650048828125,
									1.739453125000054
								],
								[
									-69.58125000000001,
									1.7707519531250284
								],
								[
									-69.54291992187501,
									1.7732421875001023
								],
								[
									-69.47016601562493,
									1.7579101562500767
								],
								[
									-69.39433593749993,
									1.7257812500000256
								],
								[
									-69.31972656250002,
									1.721240234375074
								],
								[
									-69.124267578125,
									1.7212890625000767
								],
								[
									-68.91318359374998,
									1.7213867187500966
								],
								[
									-68.67846679687503,
									1.721484374999946
								],
								[
									-68.44345703125003,
									1.721582031249966
								],
								[
									-68.23955078124996,
									1.7216796874999858
								],
								[
									-68.17656250000002,
									1.719824218749963
								],
								[
									-68.21328125000002,
									1.7745605468750938
								],
								[
									-68.25595703125,
									1.8455078124999886
								],
								[
									-68.23945312499993,
									1.9013671875
								],
								[
									-68.218359375,
									1.957617187500091
								],
								[
									-68.19379882812495,
									1.9870117187500398
								],
								[
									-68.1302734375,
									1.9557617187500682
								],
								[
									-68.07705078125,
									1.8601074218749432
								],
								[
									-68.03286132812494,
									1.7880371093750966
								],
								[
									-67.98974609374997,
									1.7525390625000483
								],
								[
									-67.93623046874998,
									1.7484863281249403
								],
								[
									-67.87553710937496,
									1.760595703125091
								],
								[
									-67.815087890625,
									1.7900878906250597
								],
								[
									-67.71186523437501,
									1.9221191406250568
								],
								[
									-67.60922851562498,
									2.035058593750051
								],
								[
									-67.55605468749997,
									2.0729980468749716
								],
								[
									-67.49965820312494,
									2.107910156250071
								],
								[
									-67.45776367187503,
									2.1211425781251023
								],
								[
									-67.40043945312499,
									2.1166992187500853
								],
								[
									-67.35195312499997,
									2.085839843750094
								],
								[
									-67.32060546874996,
									2.0320800781250767
								],
								[
									-67.20581054687503,
									1.84482421875002
								],
								[
									-67.11923828124998,
									1.7036132812500284
								],
								[
									-67.09013671875002,
									1.615576171875034
								],
								[
									-67.08828125,
									1.4005859374999403
								],
								[
									-67.09365234375002,
									1.210009765625017
								],
								[
									-67.082275390625,
									1.1854003906249773
								],
								[
									-67.06523437499999,
									1.178369140624966
								],
								[
									-66.87602539062499,
									1.2230468750000085
								],
								[
									-66.61904296874997,
									0.9921386718750398
								],
								[
									-66.42924804687502,
									0.8216796874999517
								],
								[
									-66.34711914062498,
									0.7671875000000341
								],
								[
									-66.30166015624997,
									0.7519531249999574
								],
								[
									-66.19121093750002,
									0.7632812500000483
								],
								[
									-66.06005859375003,
									0.7853515625000114
								],
								[
									-65.996337890625,
									0.8097656250000114
								],
								[
									-65.92587890624995,
									0.8631347656250483
								],
								[
									-65.81132812499999,
									0.9372558593750426
								],
								[
									-65.718115234375,
									0.9780273437500995
								],
								[
									-65.68144531249999,
									0.9834472656250455
								],
								[
									-65.64467773437497,
									0.970361328125037
								],
								[
									-65.566015625,
									0.9260742187500739
								],
								[
									-65.52299804687496,
									0.8434082031249375
								],
								[
									-65.56269531249995,
									0.7475097656249403
								],
								[
									-65.55605468750002,
									0.687988281250071
								],
								[
									-65.47338867187497,
									0.6912597656250199
								],
								[
									-65.4072265625,
									0.7904785156250824
								],
								[
									-65.36083984374994,
									0.8686523437500995
								],
								[
									-65.26396484375002,
									0.9318847656251137
								],
								[
									-65.16962890624998,
									1.0222167968750426
								],
								[
									-65.10375976562497,
									1.1081054687500398
								],
								[
									-65.02656249999998,
									1.1584472656250853
								],
								[
									-64.91010742187495,
									1.2197265625000426
								],
								[
									-64.81796875000003,
									1.257128906250017
								],
								[
									-64.73154296875,
									1.2533203125000512
								],
								[
									-64.66743164062498,
									1.293847656250037
								],
								[
									-64.58437499999994,
									1.369873046875071
								],
								[
									-64.52626953125002,
									1.431005859375091
								],
								[
									-64.48603515624998,
									1.4527832031250938
								],
								[
									-64.40512695312503,
									1.4468750000000483
								],
								[
									-64.30419921874997,
									1.4552734375000682
								],
								[
									-64.20502929687493,
									1.5294921875000824
								],
								[
									-64.11484375000003,
									1.6192871093750796
								],
								[
									-64.067041015625,
									1.7705078124999858
								],
								[
									-64.03544921874993,
									1.9044433593750938
								],
								[
									-64.00849609374995,
									1.9315917968749403
								],
								[
									-63.975781249999955,
									1.953027343750037
								],
								[
									-63.937158203124994,
									1.9669921875000398
								],
								[
									-63.84448242187503,
									1.9767089843750654
								],
								[
									-63.68212890625,
									2.0481445312500597
								],
								[
									-63.570263671874926,
									2.120507812500051
								],
								[
									-63.46391601562493,
									2.136035156250017
								],
								[
									-63.43251953124994,
									2.155566406250088
								],
								[
									-63.393945312499994,
									2.2225097656250483
								],
								[
									-63.374853515625006,
									2.340429687500091
								],
								[
									-63.389257812500006,
									2.411914062500088
								],
								[
									-63.58461914062502,
									2.433935546874963
								],
								[
									-63.712548828124966,
									2.434033203124983
								],
								[
									-63.924169921875006,
									2.452441406250003
								],
								[
									-64.02490234375,
									2.481884765625054
								],
								[
									-64.04658203124998,
									2.502392578125054
								],
								[
									-64.048828125,
									2.525097656250054
								],
								[
									-64.0287109375,
									2.576074218749966
								],
								[
									-64.00903320312497,
									2.671874999999943
								],
								[
									-64.03779296874998,
									2.801513671875057
								],
								[
									-64.14355468750003,
									3.0048828125000995
								],
								[
									-64.21884765625,
									3.2046875000000483
								],
								[
									-64.22875976562497,
									3.3439941406250853
								],
								[
									-64.22705078124997,
									3.491210937500057
								],
								[
									-64.22109375000002,
									3.587402343749943
								],
								[
									-64.27529296874997,
									3.6626953125000057
								],
								[
									-64.56791992187496,
									3.8998046874999943
								],
								[
									-64.66899414062496,
									4.011816406250077
								],
								[
									-64.70258789062495,
									4.089306640625054
								],
								[
									-64.81787109375,
									4.232275390625048
								],
								[
									-64.788671875,
									4.27602539062508
								],
								[
									-64.72226562499998,
									4.2744140625000995
								],
								[
									-64.66552734374997,
									4.23710937500006
								],
								[
									-64.61367187499997,
									4.157714843749957
								],
								[
									-64.57636718750001,
									4.139892578125057
								],
								[
									-64.52553710937497,
									4.139990234375077
								],
								[
									-64.25566406249996,
									4.140332031249969
								],
								[
									-64.19248046874995,
									4.126855468750065
								],
								[
									-64.154296875,
									4.1001464843750455
								],
								[
									-64.12172851562502,
									4.066992187499949
								],
								[
									-64.07338867187494,
									3.974414062500088
								],
								[
									-64.02148437500003,
									3.929101562500094
								],
								[
									-63.914648437500034,
									3.930664062500057
								],
								[
									-63.746972656249966,
									3.9325683593750966
								],
								[
									-63.652929687500006,
									3.940820312500094
								],
								[
									-63.59663085937498,
									3.915039062500071
								],
								[
									-63.526806640624955,
									3.8937011718749943
								],
								[
									-63.37978515624994,
									3.942871093750057
								],
								[
									-63.33867187500002,
									3.943896484375088
								],
								[
									-63.29472656249993,
									3.9222656249999517
								],
								[
									-63.13623046874997,
									3.756445312500091
								],
								[
									-63.04531250000002,
									3.686474609375054
								],
								[
									-62.96865234374994,
									3.5939453125000256
								],
								[
									-62.85698242187502,
									3.5934570312500256
								],
								[
									-62.764599609374926,
									3.672949218749963
								],
								[
									-62.73994140624998,
									3.9403320312500796
								],
								[
									-62.71210937499998,
									4.017919921875077
								],
								[
									-62.66533203124996,
									4.0396484375000625
								],
								[
									-62.60976562500002,
									4.04228515625006
								],
								[
									-62.54394531250003,
									4.08432617187502
								],
								[
									-62.47255859374994,
									4.138525390625048
								],
								[
									-62.41064453124994,
									4.156738281250028
								],
								[
									-62.15312499999999,
									4.098388671875043
								],
								[
									-62.08159179687496,
									4.126318359375048
								],
								[
									-61.82084960937496,
									4.197021484374972
								],
								[
									-61.55424804687502,
									4.287792968750082
								],
								[
									-61.47939453124994,
									4.402246093750037
								],
								[
									-61.36752929687498,
									4.43300781250008
								],
								[
									-61.28007812500002,
									4.516894531249946
								],
								[
									-61.20942382812501,
									4.5080566406250995
								],
								[
									-61.102441406249966,
									4.504687499999946
								],
								[
									-61.036279296874994,
									4.519335937500088
								],
								[
									-61.00283203125002,
									4.535253906250048
								],
								[
									-60.96640624999998,
									4.57470703125
								],
								[
									-60.90624999999997,
									4.686816406250017
								],
								[
									-60.833398437499966,
									4.729199218750026
								],
								[
									-60.74174804687493,
									4.77412109375004
								],
								[
									-60.67915039062498,
									4.827099609375082
								],
								[
									-60.627587890624966,
									4.892529296875082
								],
								[
									-60.603857421875006,
									4.949365234375037
								],
								[
									-60.60449218749997,
									4.994580078125097
								],
								[
									-60.63500976562497,
									5.081982421875054
								],
								[
									-60.671972656250034,
									5.1643554687500455
								],
								[
									-60.71196289062502,
									5.19155273437508
								],
								[
									-60.742138671874926,
									5.20205078125008
								],
								[
									-60.6513671875,
									5.221142578125068
								],
								[
									-60.576416015625,
									5.192480468750091
								],
								[
									-60.45952148437499,
									5.188085937500077
								],
								[
									-60.40878906249998,
									5.210156250000054
								],
								[
									-60.335205078125,
									5.1993164062500625
								],
								[
									-60.241650390624926,
									5.257958984375023
								],
								[
									-60.18173828124998,
									5.238818359375031
								],
								[
									-60.14204101562498,
									5.238818359375031
								],
								[
									-60.10595703125,
									5.194238281250094
								],
								[
									-60.07807617187501,
									5.143994140624983
								],
								[
									-59.990673828124955,
									5.082861328124963
								],
								[
									-59.99936523437495,
									4.98984375000002
								],
								[
									-60.01547851562495,
									4.907519531250031
								],
								[
									-60.02675781249994,
									4.812695312500082
								],
								[
									-60.03178710937499,
									4.740527343750031
								],
								[
									-60.06894531249992,
									4.66665039062508
								],
								[
									-60.12456054687496,
									4.597656250000057
								],
								[
									-60.14091796875002,
									4.569628906250031
								],
								[
									-60.14863281249998,
									4.533251953125074
								],
								[
									-60.11113281249999,
									4.511181640625026
								],
								[
									-60.04501953124992,
									4.504589843750097
								],
								[
									-59.962353515624955,
									4.501708984375043
								],
								[
									-59.90610351562498,
									4.480322265625048
								],
								[
									-59.83334960937498,
									4.475927734375034
								],
								[
									-59.74580078124998,
									4.416650390625037
								],
								[
									-59.70327148437494,
									4.381103515625085
								],
								[
									-59.69970703125003,
									4.353515625000057
								],
								[
									-59.72749023437498,
									4.28764648437496
								],
								[
									-59.73857421874993,
									4.226757812500082
								],
								[
									-59.71689453124998,
									4.18818359375004
								],
								[
									-59.69121093749996,
									4.160400390624972
								],
								[
									-59.62021484374998,
									4.023144531250068
								],
								[
									-59.58642578125003,
									3.9753906250000313
								],
								[
									-59.557763671874966,
									3.960009765625003
								],
								[
									-59.55112304687495,
									3.9335449218750256
								],
								[
									-59.57539062500001,
									3.883447265625037
								],
								[
									-59.60444335937498,
									3.819677734375105
								],
								[
									-59.67021484374996,
									3.7527343750000455
								],
								[
									-59.67900390624996,
									3.69980468750002
								],
								[
									-59.731640624999955,
									3.666552734375074
								],
								[
									-59.854394531249994,
									3.587499999999963
								],
								[
									-59.83305664062502,
									3.4621582031250995
								],
								[
									-59.828808593749926,
									3.3985839843750227
								],
								[
									-59.83115234374998,
									3.349218750000091
								],
								[
									-59.87304687499997,
									3.283105468750037
								],
								[
									-59.94565429687495,
									3.08784179687504
								],
								[
									-59.972314453124966,
									2.990478515625014
								],
								[
									-59.99589843749996,
									2.765429687500088
								],
								[
									-59.99433593750001,
									2.689990234375074
								],
								[
									-59.960791015625006,
									2.588378906249986
								],
								[
									-59.8896484375,
									2.3629394531250654
								],
								[
									-59.84912109375,
									2.327050781250037
								],
								[
									-59.75522460937495,
									2.2741210937500824
								],
								[
									-59.74350585937498,
									2.121630859375017
								],
								[
									-59.75175781249996,
									1.96240234375
								],
								[
									-59.75620117187498,
									1.9006347656250284
								],
								[
									-59.74072265625003,
									1.874169921874966
								],
								[
									-59.69853515624996,
									1.861474609375037
								],
								[
									-59.66850585937496,
									1.8423339843750455
								],
								[
									-59.66376953124998,
									1.7952148437500455
								],
								[
									-59.66660156249992,
									1.7462890625000256
								],
								[
									-59.59663085937498,
									1.7180175781250426
								],
								[
									-59.53569335937499,
									1.7000000000001023
								],
								[
									-59.47944335937498,
									1.632421875000091
								],
								[
									-59.37768554687497,
									1.5273437500000995
								],
								[
									-59.33725585937498,
									1.508203125000108
								],
								[
									-59.31699218749995,
									1.4645996093750142
								],
								[
									-59.23120117187497,
									1.376025390625088
								],
								[
									-59.10039062499996,
									1.3436523437500654
								],
								[
									-58.968505859375,
									1.3045898437500938
								],
								[
									-58.916601562500006,
									1.248876953125034
								],
								[
									-58.86249999999998,
									1.2036132812500426
								],
								[
									-58.82177734374994,
									1.2012207031250028
								],
								[
									-58.78720703124992,
									1.2084960937500568
								],
								[
									-58.73032226562498,
									1.2475097656251108
								],
								[
									-58.68461914062499,
									1.281054687500017
								],
								[
									-58.60507812499995,
									1.2791503906250625
								],
								[
									-58.511865234374966,
									1.2846679687500426
								],
								[
									-58.49570312499995,
									1.3122558593750568
								],
								[
									-58.48686523437502,
									1.3477539062501052
								],
								[
									-58.506054687499926,
									1.438671875000054
								],
								[
									-58.47294921874993,
									1.4662597656249972
								],
								[
									-58.39580078124993,
									1.4817382812500455
								],
								[
									-58.38037109375,
									1.530224609375054
								],
								[
									-58.36269531249994,
									1.5566894531250313
								],
								[
									-58.34067382812498,
									1.587548828125108
								],
								[
									-58.31420898437503,
									1.5919433593750227
								],
								[
									-58.28115234374994,
									1.5743164062500767
								],
								[
									-58.23041992187501,
									1.5632812500000455
								],
								[
									-58.17309570312494,
									1.5478515625000995
								],
								[
									-58.142236328124966,
									1.5169921875000227
								],
								[
									-58.09130859375,
									1.5143554687500256
								],
								[
									-58.03466796875,
									1.5202636718749858
								],
								[
									-58.01176757812496,
									1.5399414062500796
								],
								[
									-57.99511718750003,
									1.5743164062500767
								],
								[
									-57.982812499999994,
									1.6484374999999858
								],
								[
									-57.94633789062493,
									1.6505859375000682
								],
								[
									-57.87343750000002,
									1.667285156250088
								],
								[
									-57.79565429687497,
									1.7000000000001023
								],
								[
									-57.69174804687495,
									1.7047851562500966
								],
								[
									-57.59443359375001,
									1.7041015625000426
								],
								[
									-57.54575195312495,
									1.7260742187500853
								],
								[
									-57.500439453124955,
									1.773828125000037
								],
								[
									-57.41269531249995,
									1.9089355468750284
								],
								[
									-57.366796875000006,
									1.9401367187500824
								],
								[
									-57.317480468750006,
									1.963476562500034
								],
								[
									-57.27558593749998,
									1.9592285156250568
								],
								[
									-57.189599609374966,
									1.9815917968750938
								],
								[
									-57.11889648437494,
									2.013964843750017
								],
								[
									-57.09267578125002,
									2.005810546875054
								],
								[
									-57.03759765625,
									1.9364746093750398
								],
								[
									-57.01005859374999,
									1.921240234374963
								],
								[
									-56.96953124999999,
									1.916406250000037
								],
								[
									-56.83671875000002,
									1.8812500000000796
								],
								[
									-56.766259765624966,
									1.8921875000000767
								],
								[
									-56.68984375000002,
									1.9143066406249716
								],
								[
									-56.616455078125,
									1.922656250000074
								],
								[
									-56.56357421874998,
									1.9072265625000426
								],
								[
									-56.52548828124995,
									1.9272460937500284
								],
								[
									-56.48281249999994,
									1.9421386718750426
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "BRA",
					"su_a3": "BRA",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "BRA",
					"gu_a3": "BRA",
					"abbrev": "Brazil",
					"region_un": "Americas",
					"adm0_a3_us": "BRA",
					"scalerank": 1,
					"pop_est": 198739269,
					"adm0_dif": 0,
					"un_a3": "076",
					"pop_year": -99,
					"gdp_md_est": 1993000,
					"name": "Brazil",
					"sovereignt": "Brazil",
					"economy": "3. Emerging region: BRIC",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Brazil",
					"postal": "BR",
					"sov_a3": "BRA",
					"note_brk": "",
					"brk_a3": "BRA",
					"wb_a2": "BR",
					"brk_diff": 0,
					"admin": "Brazil",
					"name_long": "Brazil",
					"iso_a3": "BRA",
					"iso_a2": "BR",
					"adm0_a3_is": "BRA",
					"level": 2,
					"formal_en": "Federative Republic of Brazil",
					"name_len": 6,
					"mapcolor7": 5,
					"long_len": 6,
					"mapcolor8": 6,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "076",
					"homepart": 1,
					"subunit": "Brazil",
					"name_alt": "",
					"brk_name": "Brazil",
					"name_sort": "Brazil",
					"continent": "South America",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-82.63823242187496,
									41.74687499999999
								],
								[
									-82.68452148437498,
									41.73583984374997
								],
								[
									-82.68544921875,
									41.75708007812503
								],
								[
									-82.67441406249998,
									41.806054687499966
								],
								[
									-82.65439453124998,
									41.82744140624999
								],
								[
									-82.64287109374993,
									41.81542968750003
								],
								[
									-82.62719726562503,
									41.771142578124966
								],
								[
									-82.63823242187496,
									41.74687499999999
								]
							]
						],
						[
							[
								[
									-59.78759765624997,
									43.939599609374966
								],
								[
									-59.922265624999966,
									43.90390624999998
								],
								[
									-60.037744140624966,
									43.906640624999994
								],
								[
									-60.1142578125,
									43.93911132812505
								],
								[
									-60.11748046874996,
									43.953369140625114
								],
								[
									-59.93603515625003,
									43.939599609374966
								],
								[
									-59.86635742187494,
									43.947167968749994
								],
								[
									-59.727148437500006,
									44.002832031249966
								],
								[
									-59.78759765624997,
									43.939599609374966
								]
							]
						],
						[
							[
								[
									-76.68754882812502,
									44.13749999999996
								],
								[
									-76.7310546875,
									44.12670898437497
								],
								[
									-76.78671874999998,
									44.13041992187502
								],
								[
									-76.80947265625,
									44.139892578125
								],
								[
									-76.79936523437496,
									44.155126953125006
								],
								[
									-76.76069335937501,
									44.17216796875002
								],
								[
									-76.64262695312502,
									44.19926757812502
								],
								[
									-76.63955078125002,
									44.18139648437503
								],
								[
									-76.68754882812502,
									44.13749999999996
								]
							]
						],
						[
							[
								[
									-76.36489257812502,
									44.15634765624998
								],
								[
									-76.42270507812498,
									44.12153320312498
								],
								[
									-76.46933593749998,
									44.12451171874997
								],
								[
									-76.48452148437497,
									44.127783203125034
								],
								[
									-76.47431640625001,
									44.14145507812506
								],
								[
									-76.47670898437497,
									44.15283203124997
								],
								[
									-76.49179687499992,
									44.16196289062506
								],
								[
									-76.48334960937498,
									44.17851562499996
								],
								[
									-76.45146484374996,
									44.20229492187502
								],
								[
									-76.43046874999996,
									44.22680664062503
								],
								[
									-76.32875976562502,
									44.23920898437498
								],
								[
									-76.27915039062495,
									44.24663085937499
								],
								[
									-76.22705078125,
									44.25410156250001
								],
								[
									-76.23696289062497,
									44.23261718750007
								],
								[
									-76.32958984375,
									44.20781249999999
								],
								[
									-76.35273437500001,
									44.17553710937497
								],
								[
									-76.36489257812502,
									44.15634765624998
								]
							]
						],
						[
							[
								[
									-66.27377929687495,
									44.29228515624996
								],
								[
									-66.32412109375,
									44.25732421874994
								],
								[
									-66.3119140625,
									44.29160156250009
								],
								[
									-66.25048828125,
									44.37900390624995
								],
								[
									-66.2103515625,
									44.39204101562504
								],
								[
									-66.27377929687495,
									44.29228515624996
								]
							]
						],
						[
							[
								[
									-66.76249999999996,
									44.681787109374994
								],
								[
									-66.8970703125,
									44.62890624999997
								],
								[
									-66.8447265625,
									44.76391601562494
								],
								[
									-66.80214843749997,
									44.805371093749955
								],
								[
									-66.74541015624993,
									44.79140625000005
								],
								[
									-66.75336914062495,
									44.70981445312512
								],
								[
									-66.76249999999996,
									44.681787109374994
								]
							]
						],
						[
							[
								[
									-80.17431640625,
									44.80888671874996
								],
								[
									-80.17304687500001,
									44.796240234375034
								],
								[
									-80.21572265625,
									44.82265625000002
								],
								[
									-80.23281250000002,
									44.843310546875045
								],
								[
									-80.23627929687501,
									44.864501953125
								],
								[
									-80.21582031250003,
									44.87167968750006
								],
								[
									-80.17143554687496,
									44.86484374999998
								],
								[
									-80.15766601562498,
									44.847900390625
								],
								[
									-80.17431640625,
									44.80888671874996
								]
							]
						],
						[
							[
								[
									-81.78808593749997,
									45.46582031250003
								],
								[
									-81.81494140625003,
									45.463232421875034
								],
								[
									-81.83286132812495,
									45.47250976562498
								],
								[
									-81.8375,
									45.483984375000006
								],
								[
									-81.82880859375001,
									45.497656250000034
								],
								[
									-81.73505859375001,
									45.53056640624999
								],
								[
									-81.71259765625004,
									45.52631835937501
								],
								[
									-81.72729492187503,
									45.50048828125
								],
								[
									-81.78808593749997,
									45.46582031250003
								]
							]
						],
						[
							[
								[
									-60.961572265624966,
									45.48994140625007
								],
								[
									-61.002880859374955,
									45.48173828124999
								],
								[
									-61.01249999999996,
									45.49604492187507
								],
								[
									-61.07617187499994,
									45.53730468750004
								],
								[
									-61.081738281249926,
									45.55781250000004
								],
								[
									-61.025976562500034,
									45.577343749999926
								],
								[
									-60.912451171875006,
									45.56728515625011
								],
								[
									-60.953027343749994,
									45.51552734375002
								],
								[
									-60.961572265624966,
									45.48994140625007
								]
							]
						],
						[
							[
								[
									-73.69531249999997,
									45.58549804687499
								],
								[
									-73.81591796875003,
									45.56489257812507
								],
								[
									-73.85771484375002,
									45.57358398437506
								],
								[
									-73.72465820312502,
									45.67182617187507
								],
								[
									-73.57236328124998,
									45.69448242187508
								],
								[
									-73.69531249999997,
									45.58549804687499
								]
							]
						],
						[
							[
								[
									-73.56650390625003,
									45.46909179687509
								],
								[
									-73.6435546875,
									45.44912109375011
								],
								[
									-73.77534179687493,
									45.467626953125034
								],
								[
									-73.92021484374996,
									45.44194335937496
								],
								[
									-73.960546875,
									45.44140624999994
								],
								[
									-73.85292968750002,
									45.51572265625006
								],
								[
									-73.68745117187498,
									45.561425781249966
								],
								[
									-73.52246093750003,
									45.701171875000114
								],
								[
									-73.47607421875,
									45.70473632812502
								],
								[
									-73.53886718749999,
									45.54643554687493
								],
								[
									-73.55166015625002,
									45.48984374999995
								],
								[
									-73.56650390625003,
									45.46909179687509
								]
							]
						],
						[
							[
								[
									-82.82099609374998,
									45.9765625
								],
								[
									-82.83208007812493,
									45.93618164062502
								],
								[
									-82.82294921875004,
									45.909814453124994
								],
								[
									-82.79345703124997,
									45.89755859375006
								],
								[
									-82.77402343749992,
									45.88032226562501
								],
								[
									-82.76459960937495,
									45.85815429687503
								],
								[
									-82.73686523437499,
									45.85234374999999
								],
								[
									-82.69091796874994,
									45.862890625000006
								],
								[
									-82.66025390624992,
									45.85966796874999
								],
								[
									-82.64482421874999,
									45.84262695312506
								],
								[
									-82.62734374999997,
									45.83857421875004
								],
								[
									-82.6078125,
									45.84750976562498
								],
								[
									-82.58344726562501,
									45.83701171874998
								],
								[
									-82.55424804687499,
									45.807031249999994
								],
								[
									-82.53139648437497,
									45.805761718750006
								],
								[
									-82.51489257812497,
									45.833349609375034
								],
								[
									-82.52041015624994,
									45.84892578125002
								],
								[
									-82.56000976562501,
									45.85961914062497
								],
								[
									-82.55624999999998,
									45.86992187500002
								],
								[
									-82.58046875000002,
									45.8955078125
								],
								[
									-82.56850585937497,
									45.914404296875034
								],
								[
									-82.52724609375,
									45.938623046874994
								],
								[
									-82.49794921875,
									45.94389648437499
								],
								[
									-82.48056640625,
									45.93027343749998
								],
								[
									-82.462646484375,
									45.93388671874999
								],
								[
									-82.44414062499996,
									45.95478515624998
								],
								[
									-82.40063476562497,
									45.970849609374994
								],
								[
									-82.33203125000003,
									45.98198242187502
								],
								[
									-82.29453124999995,
									45.97343749999999
								],
								[
									-82.28798828125002,
									45.94516601562498
								],
								[
									-82.26835937499993,
									45.935937499999966
								],
								[
									-82.23554687500001,
									45.94580078125003
								],
								[
									-82.20458984375,
									45.924218749999994
								],
								[
									-82.17534179687499,
									45.87114257812502
								],
								[
									-82.14257812499997,
									45.86943359375002
								],
								[
									-82.10639648437498,
									45.919091796874994
								],
								[
									-82.05458984375,
									45.95498046875002
								],
								[
									-81.98730468749997,
									45.97705078125
								],
								[
									-81.93886718749997,
									45.979248046875
								],
								[
									-81.90932617187497,
									45.961767578125006
								],
								[
									-81.89545898437498,
									45.93876953125002
								],
								[
									-81.89731445312492,
									45.910302734374994
								],
								[
									-81.87900390624992,
									45.892480468749994
								],
								[
									-81.840576171875,
									45.885400390624994
								],
								[
									-81.82822265624998,
									45.862158203125034
								],
								[
									-81.84184570312499,
									45.82275390625
								],
								[
									-81.83842773437502,
									45.788427734375034
								],
								[
									-81.80375976562496,
									45.74321289062496
								],
								[
									-81.79584960937504,
									45.74038085937502
								],
								[
									-81.76308593750002,
									45.82119140625005
								],
								[
									-81.73505859375001,
									45.863671874999994
								],
								[
									-81.69819335937504,
									45.89374999999998
								],
								[
									-81.67475585937498,
									45.89648437500003
								],
								[
									-81.66484374999999,
									45.87192382812498
								],
								[
									-81.67275390625,
									45.84467773437504
								],
								[
									-81.69858398437495,
									45.814843749999994
								],
								[
									-81.68505859375003,
									45.801367187500006
								],
								[
									-81.60146484374997,
									45.801171874999966
								],
								[
									-81.59301757812503,
									45.79169921874998
								],
								[
									-81.68574218749998,
									45.65668945312501
								],
								[
									-81.75473632812492,
									45.59111328124999
								],
								[
									-81.82807617187504,
									45.54667968749999
								],
								[
									-81.88124999999994,
									45.535498046875006
								],
								[
									-81.91425781250001,
									45.55747070312506
								],
								[
									-81.94619140625002,
									45.56611328125004
								],
								[
									-81.97719726562494,
									45.561425781249966
								],
								[
									-81.97670898437502,
									45.56987304687502
								],
								[
									-81.92246093749998,
									45.60371093750007
								],
								[
									-81.90234374999997,
									45.60307617187502
								],
								[
									-81.864501953125,
									45.61059570312503
								],
								[
									-81.75957031250002,
									45.685156250000034
								],
								[
									-81.75976562499997,
									45.69755859374999
								],
								[
									-81.82114257812495,
									45.69155273437502
								],
								[
									-82.02900390625001,
									45.56596679687502
								],
								[
									-82.05527343749995,
									45.561328125000045
								],
								[
									-82.07597656249999,
									45.56967773437506
								],
								[
									-82.09111328124996,
									45.59086914062502
								],
								[
									-82.20805664062499,
									45.62749023437502
								],
								[
									-82.25605468750001,
									45.66010742187501
								],
								[
									-82.32319335937501,
									45.68359375
								],
								[
									-82.40947265624999,
									45.697998046875
								],
								[
									-82.51040039062494,
									45.72749023437504
								],
								[
									-82.62597656249997,
									45.77216796875001
								],
								[
									-82.73579101562504,
									45.796728515625034
								],
								[
									-82.93666992187502,
									45.81098632812501
								],
								[
									-82.96225585937498,
									45.83344726562507
								],
								[
									-83.16005859374997,
									45.87519531250004
								],
								[
									-83.22182617187502,
									45.90214843750002
								],
								[
									-83.21582031249994,
									45.93266601562502
								],
								[
									-83.20058593749997,
									45.95488281250002
								],
								[
									-83.17617187499997,
									45.96889648437502
								],
								[
									-83.15083007812504,
									45.963232421875034
								],
								[
									-83.12451171875,
									45.93793945312504
								],
								[
									-83.09731445312497,
									45.93505859374997
								],
								[
									-83.06933593749994,
									45.95458984375006
								],
								[
									-83.03540039062497,
									45.957421874999994
								],
								[
									-82.99570312499998,
									45.943457031250006
								],
								[
									-82.96547851562502,
									45.945214843749994
								],
								[
									-82.94482421875,
									45.96269531250002
								],
								[
									-82.90473632812498,
									45.97778320312497
								],
								[
									-82.84521484374994,
									45.99042968750007
								],
								[
									-82.82099609374998,
									45.9765625
								]
							]
						],
						[
							[
								[
									-83.33198242187498,
									45.88037109375003
								],
								[
									-83.38657226562492,
									45.86855468750002
								],
								[
									-83.45332031250001,
									45.88427734375003
								],
								[
									-83.47998046874994,
									45.90673828124997
								],
								[
									-83.46665039062498,
									45.93603515625
								],
								[
									-83.43740234374997,
									45.963232421875034
								],
								[
									-83.39228515625001,
									45.98823242187507
								],
								[
									-83.34526367187496,
									45.992773437500006
								],
								[
									-83.29638671875003,
									45.976660156250006
								],
								[
									-83.27104492187502,
									45.961328124999994
								],
								[
									-83.269189453125,
									45.94658203125002
								],
								[
									-83.33198242187498,
									45.88037109375003
								]
							]
						],
						[
							[
								[
									-83.80830078124995,
									46.16660156249998
								],
								[
									-83.82895507812498,
									46.14765625000004
								],
								[
									-83.85649414062502,
									46.157470703125
								],
								[
									-83.87592773437495,
									46.14790039062498
								],
								[
									-83.88725585937496,
									46.11889648437503
								],
								[
									-83.90683593749995,
									46.09721679687496
								],
								[
									-83.93027343749995,
									46.091699218749994
								],
								[
									-83.97861328124992,
									46.10942382812496
								],
								[
									-84.03876953125001,
									46.17705078124999
								],
								[
									-84.07822265624998,
									46.236425781250006
								],
								[
									-84.09702148437498,
									46.28759765625003
								],
								[
									-84.06113281249995,
									46.30976562500001
								],
								[
									-83.970703125,
									46.30297851562506
								],
								[
									-83.89106445312504,
									46.28417968750006
								],
								[
									-83.82211914062492,
									46.25346679687502
								],
								[
									-83.794580078125,
									46.21430664062501
								],
								[
									-83.80830078124995,
									46.16660156249998
								]
							]
						],
						[
							[
								[
									-71.02573242187503,
									46.872949218749994
								],
								[
									-71.11665039062498,
									46.86484374999995
								],
								[
									-71.09497070312503,
									46.89956054687508
								],
								[
									-70.97084960937497,
									46.961425781250085
								],
								[
									-70.87963867187503,
									46.99609375000003
								],
								[
									-70.82578124999998,
									46.99536132812506
								],
								[
									-70.9134765625,
									46.91953125000006
								],
								[
									-71.02573242187503,
									46.872949218749994
								]
							]
						],
						[
							[
								[
									-61.10517578125001,
									45.94472656250008
								],
								[
									-61.07133789062493,
									45.93710937499995
								],
								[
									-60.93657226562502,
									45.985546874999955
								],
								[
									-60.86523437499997,
									45.98349609374998
								],
								[
									-60.868408203125,
									45.94863281250008
								],
								[
									-60.984277343749966,
									45.910693359375074
								],
								[
									-61.03754882812498,
									45.88222656250005
								],
								[
									-60.97060546875002,
									45.85581054687509
								],
								[
									-60.971533203125034,
									45.837988281250006
								],
								[
									-61.05195312499998,
									45.79501953124995
								],
								[
									-61.09208984374999,
									45.748388671875034
								],
								[
									-61.05903320312501,
									45.70336914062503
								],
								[
									-60.93037109375001,
									45.747705078124994
								],
								[
									-60.877587890624994,
									45.74809570312499
								],
								[
									-60.80610351562501,
									45.73808593749999
								],
								[
									-60.73789062499995,
									45.751416015624955
								],
								[
									-60.69907226562495,
									45.77333984375008
								],
								[
									-60.472363281249955,
									45.946533203125
								],
								[
									-60.460595703124966,
									45.96870117187498
								],
								[
									-60.70488281249999,
									45.932910156250074
								],
								[
									-60.733300781249994,
									45.9565917968751
								],
								[
									-60.57319335937498,
									46.06142578125005
								],
								[
									-60.58574218749996,
									46.116650390624926
								],
								[
									-60.50493164062502,
									46.20385742187503
								],
								[
									-60.430859374999926,
									46.255615234375
								],
								[
									-60.37651367187496,
									46.28457031250002
								],
								[
									-60.297949218750034,
									46.311230468749955
								],
								[
									-60.243847656249926,
									46.27011718750012
								],
								[
									-60.22646484374994,
									46.195556640625114
								],
								[
									-60.09248046875001,
									46.206005859374926
								],
								[
									-59.96142578124994,
									46.190966796875074
								],
								[
									-59.86503906249996,
									46.15952148437506
								],
								[
									-59.849999999999994,
									46.1414062500001
								],
								[
									-59.84877929687502,
									46.11293945312505
								],
								[
									-59.88090820312499,
									46.06162109375009
								],
								[
									-59.93403320312498,
									46.01943359375002
								],
								[
									-59.828027343749966,
									45.965136718750074
								],
								[
									-59.842187499999994,
									45.941552734374966
								],
								[
									-60.015820312499926,
									45.88046874999995
								],
								[
									-60.114453124999955,
									45.81889648437493
								],
								[
									-60.20507812500003,
									45.74301757812512
								],
								[
									-60.38608398437495,
									45.65463867187495
								],
								[
									-60.67294921874995,
									45.590820312500085
								],
								[
									-60.76372070312499,
									45.590820312500085
								],
								[
									-60.87158203125003,
									45.61069335937506
								],
								[
									-60.97861328124998,
									45.60615234375001
								],
								[
									-61.08369140624998,
									45.58237304687498
								],
								[
									-61.18642578124994,
									45.585009765625074
								],
								[
									-61.23632812499997,
									45.572509765625085
								],
								[
									-61.28369140624994,
									45.57387695312502
								],
								[
									-61.323437499999955,
									45.59848632812506
								],
								[
									-61.40834960937494,
									45.669091796874966
								],
								[
									-61.44980468749995,
									45.71621093750005
								],
								[
									-61.49531249999998,
									45.941455078125045
								],
								[
									-61.48061523437502,
									46.05976562500007
								],
								[
									-61.40864257812501,
									46.17036132812504
								],
								[
									-61.30219726562498,
									46.2438476562501
								],
								[
									-61.24052734374996,
									46.30253906249996
								],
								[
									-60.98251953124998,
									46.65048828124998
								],
								[
									-60.93198242187498,
									46.72944335937498
								],
								[
									-60.87016601562499,
									46.79677734374994
								],
								[
									-60.759667968749966,
									46.863378906250006
								],
								[
									-60.616650390624955,
									46.97578124999998
								],
								[
									-60.57104492187497,
									46.998828125000074
								],
								[
									-60.48906249999999,
									47.00971679687507
								],
								[
									-60.40820312500003,
									47.00351562499995
								],
								[
									-60.431347656249955,
									46.962939453125045
								],
								[
									-60.425439453124994,
									46.92319335937512
								],
								[
									-60.33173828124998,
									46.767822265625085
								],
								[
									-60.332910156249966,
									46.737011718749926
								],
								[
									-60.38408203124999,
									46.613330078125045
								],
								[
									-60.48242187499997,
									46.413525390624926
								],
								[
									-60.507714843749966,
									46.30336914062505
								],
								[
									-60.49453125000002,
									46.27026367187506
								],
								[
									-60.53442382812497,
									46.21455078124998
								],
								[
									-60.57685546875001,
									46.17216796874996
								],
								[
									-60.744824218749955,
									46.09267578125002
								],
								[
									-60.83056640625,
									46.074121093749966
								],
								[
									-60.912207031250034,
									46.044580078124994
								],
								[
									-61.10517578125001,
									45.94472656250008
								]
							]
						],
						[
							[
								[
									-63.811279296875,
									46.46870117187507
								],
								[
									-63.78422851562502,
									46.454638671875045
								],
								[
									-63.73701171874998,
									46.48051757812499
								],
								[
									-63.68144531249993,
									46.56191406250005
								],
								[
									-63.53437500000001,
									46.54062499999998
								],
								[
									-63.456494140624955,
									46.50390625000006
								],
								[
									-63.41313476562499,
									46.5120117187501
								],
								[
									-63.36865234375,
									46.508251953124955
								],
								[
									-63.286083984374955,
									46.46020507812503
								],
								[
									-63.12939453125,
									46.422216796875006
								],
								[
									-62.964013671874966,
									46.42773437500006
								],
								[
									-62.71201171874998,
									46.450292968750034
								],
								[
									-62.68193359374996,
									46.459423828124955
								],
								[
									-62.423095703125,
									46.47827148437497
								],
								[
									-62.16357421874997,
									46.48720703125002
								],
								[
									-62.07426757812499,
									46.465722656249994
								],
								[
									-62.040869140625034,
									46.445703124999994
								],
								[
									-62.02373046874999,
									46.42158203125007
								],
								[
									-62.171777343749966,
									46.35537109375008
								],
								[
									-62.31997070312494,
									46.2783203125
								],
								[
									-62.52607421875001,
									46.202880859375
								],
								[
									-62.55200195312497,
									46.16591796875002
								],
								[
									-62.53920898437502,
									46.09794921875002
								],
								[
									-62.54326171874996,
									46.02866210937495
								],
								[
									-62.50258789062502,
									46.02294921875003
								],
								[
									-62.47807617187502,
									45.9997070312501
								],
								[
									-62.531347656250034,
									45.97729492187506
								],
								[
									-62.7431640625,
									45.96689453124998
								],
								[
									-62.80488281249998,
									45.97319335937502
								],
								[
									-62.878369140624926,
									46.00136718750008
								],
								[
									-62.90351562499998,
									46.06826171875002
								],
								[
									-62.99462890625,
									46.05844726562498
								],
								[
									-63.02207031249998,
									46.06660156250004
								],
								[
									-62.89453125000003,
									46.12358398437502
								],
								[
									-62.95263671874997,
									46.195166015625034
								],
								[
									-63.015039062499966,
									46.18994140624994
								],
								[
									-63.056347656249955,
									46.22392578124993
								],
								[
									-63.05292968749998,
									46.26982421874996
								],
								[
									-62.9951171875,
									46.29213867187508
								],
								[
									-62.97846679687498,
									46.31635742187504
								],
								[
									-63.05688476562497,
									46.295361328124926
								],
								[
									-63.11699218749996,
									46.252832031249966
								],
								[
									-63.194726562499994,
									46.236718749999966
								],
								[
									-63.27080078124996,
									46.200000000000045
								],
								[
									-63.15278320312498,
									46.18833007812506
								],
								[
									-63.213476562500006,
									46.15986328125004
								],
								[
									-63.27661132812497,
									46.153271484374926
								],
								[
									-63.56889648437502,
									46.20922851562506
								],
								[
									-63.641015624999966,
									46.23046875000003
								],
								[
									-63.73178710937498,
									46.28906249999997
								],
								[
									-63.80053710937494,
									46.36733398437502
								],
								[
									-63.76323242187499,
									46.370361328125114
								],
								[
									-63.75053710937499,
									46.384375000000034
								],
								[
									-63.758642578125034,
									46.397607421874966
								],
								[
									-63.86054687500001,
									46.40815429687498
								],
								[
									-64.01972656249993,
									46.40483398437493
								],
								[
									-64.11083984375003,
									46.42543945312505
								],
								[
									-64.10654296875003,
									46.56210937500009
								],
								[
									-64.13603515625002,
									46.59970703125012
								],
								[
									-64.23564453124996,
									46.631445312500006
								],
								[
									-64.388037109375,
									46.64086914062497
								],
								[
									-64.40312499999996,
									46.6916015625001
								],
								[
									-64.35458984375003,
									46.76923828125001
								],
								[
									-64.27998046874993,
									46.835742187500045
								],
								[
									-64.2232421875,
									46.901269531249994
								],
								[
									-64.15693359375001,
									46.95488281249999
								],
								[
									-63.99355468750002,
									47.061572265625045
								],
								[
									-63.99726562499998,
									46.98173828124996
								],
								[
									-63.98149414062496,
									46.91298828125008
								],
								[
									-64.08789062499997,
									46.77543945312502
								],
								[
									-63.903027343749955,
									46.63911132812507
								],
								[
									-63.87929687500002,
									46.608984375000034
								],
								[
									-63.863720703124955,
									46.572363281250034
								],
								[
									-63.875634765624966,
									46.53867187500012
								],
								[
									-63.90556640624996,
									46.50878906249997
								],
								[
									-63.833593750000034,
									46.49389648437506
								],
								[
									-63.811279296875,
									46.46870117187507
								]
							]
						],
						[
							[
								[
									-61.91411132812496,
									47.284521484375006
								],
								[
									-61.87871093749993,
									47.26552734375005
								],
								[
									-61.81547851562502,
									47.267578125000114
								],
								[
									-61.77255859374998,
									47.259814453125045
								],
								[
									-61.833740234375,
									47.2226074218751
								],
								[
									-61.950830078124966,
									47.21899414062497
								],
								[
									-62.00830078124997,
									47.23427734375008
								],
								[
									-61.924707031249994,
									47.42514648437506
								],
								[
									-61.82729492187494,
									47.46909179687495
								],
								[
									-61.627832031249994,
									47.59384765625006
								],
								[
									-61.54804687499998,
									47.63178710937504
								],
								[
									-61.47407226562501,
									47.646777343750074
								],
								[
									-61.3955078125,
									47.6376464843751
								],
								[
									-61.475537109374955,
									47.56396484375
								],
								[
									-61.582226562499926,
									47.5600097656251
								],
								[
									-61.68408203125,
									47.49873046875004
								],
								[
									-61.750878906249994,
									47.430810546874966
								],
								[
									-61.831249999999955,
									47.39204101562507
								],
								[
									-61.88662109374994,
									47.344628906249994
								],
								[
									-61.91411132812496,
									47.284521484375006
								]
							]
						],
						[
							[
								[
									-54.227148437500034,
									47.44135742187498
								],
								[
									-54.27607421874998,
									47.40654296874999
								],
								[
									-54.32597656250002,
									47.40810546875005
								],
								[
									-54.32011718749999,
									47.43852539062493
								],
								[
									-54.258691406249994,
									47.49765625000009
								],
								[
									-54.227392578125006,
									47.5399902343751
								],
								[
									-54.226269531249955,
									47.56552734375006
								],
								[
									-54.214941406250034,
									47.58510742187505
								],
								[
									-54.168359374999966,
									47.607080078124994
								],
								[
									-54.12817382812494,
									47.646826171875006
								],
								[
									-54.147558593750006,
									47.57309570312509
								],
								[
									-54.227148437500034,
									47.44135742187498
								]
							]
						],
						[
							[
								[
									-85.66601562499997,
									47.73334960937504
								],
								[
									-85.85859375000004,
									47.71909179687498
								],
								[
									-85.94218750000002,
									47.733740234375034
								],
								[
									-85.95073242187499,
									47.74731445312506
								],
								[
									-85.93090820312503,
									47.766455078125034
								],
								[
									-85.88271484374997,
									47.79101562499997
								],
								[
									-85.82744140624999,
									47.80449218749999
								],
								[
									-85.76513671875,
									47.80673828124998
								],
								[
									-85.64111328124997,
									47.78178710937496
								],
								[
									-85.59609375000002,
									47.757080078125
								],
								[
									-85.60585937499997,
									47.74213867187507
								],
								[
									-85.66601562499997,
									47.73334960937504
								]
							]
						],
						[
							[
								[
									-64.50859374999996,
									47.88671874999994
								],
								[
									-64.53388671874995,
									47.8137695312501
								],
								[
									-64.62128906250001,
									47.75190429687501
								],
								[
									-64.66464843749995,
									47.74760742187493
								],
								[
									-64.68457031250003,
									47.7536132812501
								],
								[
									-64.660498046875,
									47.79355468750006
								],
								[
									-64.66328124999995,
									47.863037109375
								],
								[
									-64.59111328124999,
									47.872460937499966
								],
								[
									-64.56484374999997,
									47.866259765625045
								],
								[
									-64.50859374999996,
									47.88671874999994
								]
							]
						],
						[
							[
								[
									-64.47607421875,
									47.95888671875008
								],
								[
									-64.59130859375003,
									47.90722656249994
								],
								[
									-64.54072265624993,
									47.98496093750006
								],
								[
									-64.51958007812499,
									48.00507812499998
								],
								[
									-64.50019531249995,
									48.01376953124998
								],
								[
									-64.48124999999999,
									48.006933593750006
								],
								[
									-64.47607421875,
									47.95888671875008
								]
							]
						],
						[
							[
								[
									-87.62167968749995,
									48.75688476562502
								],
								[
									-87.69028320312498,
									48.75000000000006
								],
								[
									-87.73046875,
									48.75468750000002
								],
								[
									-87.74370117187493,
									48.76416015625
								],
								[
									-87.72993164062498,
									48.77841796875006
								],
								[
									-87.73105468749995,
									48.793847656249994
								],
								[
									-87.752685546875,
									48.824072265625034
								],
								[
									-87.74819335937497,
									48.83466796875007
								],
								[
									-87.73134765625,
									48.840478515624994
								],
								[
									-87.70209960937498,
									48.841406250000006
								],
								[
									-87.66699218749994,
									48.82143554687502
								],
								[
									-87.62602539062496,
									48.78041992187502
								],
								[
									-87.62167968749995,
									48.75688476562502
								]
							]
						],
						[
							[
								[
									-88.03090820312502,
									48.717529296875
								],
								[
									-88.05668945312493,
									48.71669921875002
								],
								[
									-88.07568359375,
									48.740624999999994
								],
								[
									-88.086572265625,
									48.80800781250005
								],
								[
									-88.05673828124995,
									48.836767578125034
								],
								[
									-87.99614257812496,
									48.857226562500045
								],
								[
									-87.91503906249994,
									48.86464843750005
								],
								[
									-87.81342773437504,
									48.859033203124966
								],
								[
									-87.76513671874997,
									48.841113281250045
								],
								[
									-87.77021484375001,
									48.81093750000002
								],
								[
									-87.78212890624997,
									48.79541015624997
								],
								[
									-87.81235351562498,
									48.78535156250004
								],
								[
									-87.81630859375,
									48.767871093750045
								],
								[
									-87.85922851562495,
									48.75834960937496
								],
								[
									-87.94121093749996,
									48.75683593750003
								],
								[
									-87.99843749999997,
									48.74321289062499
								],
								[
									-88.03090820312502,
									48.717529296875
								]
							]
						],
						[
							[
								[
									-123.43540039062496,
									48.754443359375074
								],
								[
									-123.47724609374995,
									48.72875976562506
								],
								[
									-123.49960937499999,
									48.73217773437506
								],
								[
									-123.517529296875,
									48.75014648437508
								],
								[
									-123.58232421874996,
									48.92578124999997
								],
								[
									-123.55468750000001,
									48.922070312499926
								],
								[
									-123.46787109375,
									48.86738281250007
								],
								[
									-123.48754882812501,
									48.845703125
								],
								[
									-123.42275390624997,
									48.793359374999994
								],
								[
									-123.40678710937499,
									48.75605468750004
								],
								[
									-123.43540039062496,
									48.754443359375074
								]
							]
						],
						[
							[
								[
									-123.37236328125,
									48.88613281250008
								],
								[
									-123.38481445312496,
									48.87519531250007
								],
								[
									-123.54101562499999,
									48.945947265624994
								],
								[
									-123.64560546874998,
									49.03862304687496
								],
								[
									-123.68925781249999,
									49.09511718750011
								],
								[
									-123.48232421875002,
									48.95468750000009
								],
								[
									-123.37792968749997,
									48.908251953125045
								],
								[
									-123.37236328125,
									48.88613281250008
								]
							]
						],
						[
							[
								[
									-74.70888671874997,
									45.00385742187507
								],
								[
									-74.56630859374997,
									45.041601562500034
								],
								[
									-74.26904296874997,
									45.188281250000074
								],
								[
									-74.0498046875,
									45.24140625000007
								],
								[
									-73.76464843749997,
									45.3954589843751
								],
								[
									-73.55810546875,
									45.425097656250074
								],
								[
									-73.518798828125,
									45.45898437499997
								],
								[
									-73.48417968749996,
									45.58676757812498
								],
								[
									-73.46528320312501,
									45.63232421875003
								],
								[
									-73.36884765624998,
									45.757812500000114
								],
								[
									-73.25302734375003,
									45.863671874999994
								],
								[
									-73.1595703125,
									46.010058593750074
								],
								[
									-72.98994140624998,
									46.103613281250034
								],
								[
									-72.73344726562496,
									46.18183593750007
								],
								[
									-72.49619140625003,
									46.352685546874966
								],
								[
									-72.36616210937501,
									46.404785156250114
								],
								[
									-72.24013671875,
									46.44208984375007
								],
								[
									-72.18720703124995,
									46.511523437500074
								],
								[
									-72.10927734374997,
									46.5512207031251
								],
								[
									-71.90092773437499,
									46.63193359375009
								],
								[
									-71.67128906250002,
									46.653759765624926
								],
								[
									-71.43920898437497,
									46.72075195312499
								],
								[
									-71.26118164062495,
									46.75624999999994
								],
								[
									-71.152001953125,
									46.81909179687503
								],
								[
									-70.99326171874998,
									46.85219726562502
								],
								[
									-70.51948242187501,
									47.0325195312501
								],
								[
									-70.38808593749997,
									47.11694335937497
								],
								[
									-70.2177734375,
									47.28984374999993
								],
								[
									-70.06958007812503,
									47.37778320312509
								],
								[
									-70.01713867187499,
									47.47143554687506
								],
								[
									-69.80224609375,
									47.62343750000005
								],
								[
									-69.58105468749997,
									47.82368164062507
								],
								[
									-69.47104492187503,
									47.967285156250114
								],
								[
									-69.30634765624995,
									48.04702148437508
								],
								[
									-68.987060546875,
									48.27500000000009
								],
								[
									-68.815673828125,
									48.366015625000074
								],
								[
									-68.74604492187493,
									48.37641601562504
								],
								[
									-68.55200195312503,
									48.45732421875002
								],
								[
									-68.43149414062498,
									48.54169921875007
								],
								[
									-68.23818359374994,
									48.6264160156251
								],
								[
									-67.88901367187495,
									48.73090820312507
								],
								[
									-67.56088867187498,
									48.85595703125006
								],
								[
									-67.11748046874999,
									48.964160156250074
								],
								[
									-66.59809570312495,
									49.12636718750008
								],
								[
									-66.17817382812493,
									49.213134765625085
								],
								[
									-65.88281249999997,
									49.22568359375006
								],
								[
									-65.52338867187493,
									49.266162109375045
								],
								[
									-65.39614257812494,
									49.262060546875006
								],
								[
									-64.83632812499994,
									49.19174804687498
								],
								[
									-64.56772460937503,
									49.10478515624993
								],
								[
									-64.26181640624995,
									48.92187499999997
								],
								[
									-64.2162109375,
									48.873632812500006
								],
								[
									-64.20878906249999,
									48.806201171875045
								],
								[
									-64.37075195312494,
									48.83896484375006
								],
								[
									-64.51372070312493,
									48.841113281250045
								],
								[
									-64.41455078125,
									48.80361328125005
								],
								[
									-64.24609374999994,
									48.69111328125004
								],
								[
									-64.253759765625,
									48.55039062500006
								],
								[
									-64.34882812500001,
									48.42319335937509
								],
								[
									-64.63315429687503,
									48.36049804687511
								],
								[
									-64.70576171874998,
									48.31059570312496
								],
								[
									-64.76450195312498,
									48.22807617187502
								],
								[
									-64.82207031249996,
									48.19648437499998
								],
								[
									-64.95991210937498,
									48.15986328124998
								],
								[
									-65.03608398437495,
									48.10624999999999
								],
								[
									-65.259423828125,
									48.021240234375085
								],
								[
									-65.36000976562497,
									48.01113281250005
								],
								[
									-65.47587890624993,
									48.03149414062494
								],
								[
									-65.75468749999999,
									48.111669921875034
								],
								[
									-65.92670898437495,
									48.18886718750002
								],
								[
									-66.01254882812503,
									48.14667968750007
								],
								[
									-66.08310546875,
									48.10268554687505
								],
								[
									-66.24863281249998,
									48.11733398437494
								],
								[
									-66.32426757812493,
									48.09790039062497
								],
								[
									-66.44897460937503,
									48.11962890625006
								],
								[
									-66.70439453125002,
									48.02246093749997
								],
								[
									-66.63154296875001,
									48.01108398437506
								],
								[
									-66.42880859375,
									48.066943359375074
								],
								[
									-66.35961914062494,
									48.06064453125012
								],
								[
									-66.21020507812497,
									47.988574218750074
								],
								[
									-65.84941406250002,
									47.91103515625011
								],
								[
									-65.755712890625,
									47.85976562500005
								],
								[
									-65.66645507812495,
									47.69614257812512
								],
								[
									-65.60722656249996,
									47.67001953125012
								],
								[
									-65.48349609374998,
									47.68701171875003
								],
								[
									-65.34394531249998,
									47.76791992187506
								],
								[
									-65.22817382812502,
									47.81127929687503
								],
								[
									-65.00166015624995,
									47.84682617187508
								],
								[
									-65.04638671875003,
									47.793017578125045
								],
								[
									-64.87397460937498,
									47.797216796875006
								],
								[
									-64.70322265625,
									47.724853515625
								],
								[
									-64.76630859374998,
									47.67348632812502
								],
								[
									-64.85214843749998,
									47.56987304687496
								],
								[
									-64.91220703125003,
									47.36865234375
								],
								[
									-65.08613281249995,
									47.233789062499966
								],
								[
									-65.31889648437502,
									47.101220703124966
								],
								[
									-65.26020507812495,
									47.06923828125002
								],
								[
									-65.19208984374995,
									47.049560546875085
								],
								[
									-65.0423828125,
									47.088818359374926
								],
								[
									-64.94243164062499,
									47.086181640625085
								],
								[
									-64.831396484375,
									47.060791015625085
								],
								[
									-64.86586914062502,
									46.957812500000045
								],
								[
									-64.90576171874997,
									46.88793945312494
								],
								[
									-64.88251953124993,
									46.822851562500006
								],
								[
									-64.81669921874993,
									46.69868164062501
								],
								[
									-64.72587890624999,
									46.671435546875074
								],
								[
									-64.68950195312496,
									46.51230468749998
								],
								[
									-64.641357421875,
									46.42558593749999
								],
								[
									-64.6478515625,
									46.355957031250114
								],
								[
									-64.55683593749993,
									46.311425781249994
								],
								[
									-64.54150390625,
									46.24033203125009
								],
								[
									-64.21181640625,
									46.22021484375006
								],
								[
									-64.14501953124997,
									46.19287109375
								],
								[
									-63.91591796875002,
									46.1658203125001
								],
								[
									-63.872656250000006,
									46.1461914062501
								],
								[
									-63.831933593749966,
									46.10717773437506
								],
								[
									-64.05639648437503,
									46.02133789062506
								],
								[
									-63.874707031249955,
									45.959228515625114
								],
								[
									-63.70288085937494,
									45.85800781250009
								],
								[
									-63.56767578124993,
									45.87792968749997
								],
								[
									-63.509228515624926,
									45.87470703125001
								],
								[
									-63.358007812500034,
									45.81127929687506
								],
								[
									-63.31591796875,
									45.77988281249998
								],
								[
									-63.29277343749999,
									45.75195312499997
								],
								[
									-63.21689453124998,
									45.75795898437505
								],
								[
									-63.10791015624997,
									45.78242187500004
								],
								[
									-62.910791015624966,
									45.77636718749997
								],
								[
									-62.70068359374997,
									45.74057617187506
								],
								[
									-62.718359375000034,
									45.68598632812504
								],
								[
									-62.750097656250006,
									45.648242187500074
								],
								[
									-62.58564453124998,
									45.660693359375045
								],
								[
									-62.483056640624966,
									45.621826171875114
								],
								[
									-62.44726562499994,
									45.64052734375011
								],
								[
									-62.42187500000003,
									45.66464843749995
								],
								[
									-62.21772460937498,
									45.73085937499994
								],
								[
									-61.955517578124955,
									45.86816406250003
								],
								[
									-61.92358398437503,
									45.85117187500012
								],
								[
									-61.91162109374997,
									45.79912109374999
								],
								[
									-61.87724609374999,
									45.714208984375006
								],
								[
									-61.776513671874994,
									45.65561523437498
								],
								[
									-61.656884765624966,
									45.64218750000009
								],
								[
									-61.492285156250006,
									45.68701171874997
								],
								[
									-61.427636718749966,
									45.64829101562509
								],
								[
									-61.350488281249966,
									45.57368164062498
								],
								[
									-61.277050781249926,
									45.47602539062498
								],
								[
									-61.28198242187497,
									45.441064453124966
								],
								[
									-61.376123046874966,
									45.41059570312507
								],
								[
									-61.46098632812502,
									45.36669921875
								],
								[
									-61.10673828124996,
									45.34863281250006
								],
								[
									-61.07080078125,
									45.33017578125012
								],
								[
									-61.03154296875002,
									45.291748046875085
								],
								[
									-61.06767578124999,
									45.25283203125008
								],
								[
									-61.10107421874997,
									45.233447265625045
								],
								[
									-61.16533203124999,
									45.25610351562494
								],
								[
									-61.28378906249998,
									45.23549804687511
								],
								[
									-61.38725585937499,
									45.18505859374994
								],
								[
									-61.49790039062498,
									45.1570312500001
								],
								[
									-61.56875000000002,
									45.15380859374997
								],
								[
									-61.64741210937498,
									45.13051757812494
								],
								[
									-61.71923828124994,
									45.09448242187506
								],
								[
									-61.79389648437498,
									45.084423828124955
								],
								[
									-62.02680664062501,
									44.99448242187512
								],
								[
									-62.264990234375034,
									44.936474609374926
								],
								[
									-62.51401367187495,
									44.84365234374994
								],
								[
									-62.76806640625003,
									44.7851074218751
								],
								[
									-63.031835937500034,
									44.71479492187507
								],
								[
									-63.08920898437498,
									44.708544921875045
								],
								[
									-63.155712890624955,
									44.71132812500008
								],
								[
									-63.306298828124994,
									44.642578125
								],
								[
									-63.38081054687498,
									44.651904296875045
								],
								[
									-63.45683593750002,
									44.6399414062501
								],
								[
									-63.544335937499994,
									44.655078125000074
								],
								[
									-63.60400390624997,
									44.68320312500012
								],
								[
									-63.558251953124966,
									44.61059570312497
								],
								[
									-63.544824218749994,
									44.543750000000045
								],
								[
									-63.56767578124993,
									44.51445312500002
								],
								[
									-63.609765624999994,
									44.479980468750085
								],
								[
									-63.76113281250002,
									44.48642578125009
								],
								[
									-63.82065429687498,
									44.51064453125005
								],
								[
									-63.89130859374998,
									44.54633789062504
								],
								[
									-63.923681640625006,
									44.60385742187512
								],
								[
									-63.999707031249955,
									44.64492187500005
								],
								[
									-64.044921875,
									44.58789062500006
								],
								[
									-64.04462890624995,
									44.545410156250114
								],
								[
									-64.10087890624996,
									44.48745117187502
								],
								[
									-64.1669921875,
									44.586669921875085
								],
								[
									-64.28608398437493,
									44.550341796875045
								],
								[
									-64.33852539062497,
									44.44487304687496
								],
								[
									-64.31225585937503,
									44.414746093749955
								],
								[
									-64.27568359374993,
									44.33408203124995
								],
								[
									-64.33457031250003,
									44.291992187500085
								],
								[
									-64.37822265624996,
									44.30356445312495
								],
								[
									-64.46879882812493,
									44.18515625000006
								],
								[
									-64.57846679687498,
									44.1420410156251
								],
								[
									-64.69160156249995,
									44.021337890625006
								],
								[
									-64.82563476562498,
									43.92934570312511
								],
								[
									-64.86235351562502,
									43.86787109375001
								],
								[
									-65.08681640625,
									43.72719726562502
								],
								[
									-65.17207031249995,
									43.7313964843751
								],
								[
									-65.23491210937496,
									43.72675781250004
								],
								[
									-65.32958984374997,
									43.66811523437508
								],
								[
									-65.34428710937496,
									43.5496093750001
								],
								[
									-65.38608398437503,
									43.56528320312509
								],
								[
									-65.42851562499996,
									43.56142578125011
								],
								[
									-65.450439453125,
									43.524218750000074
								],
								[
									-65.48168945312497,
									43.51806640624997
								],
								[
									-65.56445312499994,
									43.553271484375045
								],
								[
									-65.66191406250002,
									43.534033203125034
								],
								[
									-65.73813476562498,
									43.56074218750004
								],
								[
									-65.83530273437498,
									43.734375000000085
								],
								[
									-65.88691406250001,
									43.795214843750045
								],
								[
									-65.97841796875,
									43.81484375000005
								],
								[
									-66.00214843749995,
									43.77812499999993
								],
								[
									-66.03764648437499,
									43.74218750000006
								],
								[
									-66.125732421875,
									43.813818359375006
								],
								[
									-66.19252929687502,
									44.07968750000009
								],
								[
									-66.19306640624995,
									44.1438476562501
								],
								[
									-66.09956054687498,
									44.3674804687501
								],
								[
									-65.86801757812498,
									44.56879882812498
								],
								[
									-65.94194335937493,
									44.57553710937512
								],
								[
									-66.14638671875002,
									44.43593750000011
								],
								[
									-66.12529296874999,
									44.46972656250006
								],
								[
									-66.09062499999996,
									44.50493164062502
								],
								[
									-66.02167968749993,
									44.56171875000004
								],
								[
									-65.91704101562502,
									44.61508789062509
								],
								[
									-65.77768554687498,
									44.64619140625004
								],
								[
									-65.68183593749998,
									44.65092773437493
								],
								[
									-65.61577148437502,
									44.680419921875085
								],
								[
									-65.52001953124997,
									44.73266601562497
								],
								[
									-65.50224609374999,
									44.76040039062494
								],
								[
									-65.58715820312497,
									44.728515625000114
								],
								[
									-65.72822265625001,
									44.69711914062509
								],
								[
									-65.69204101562502,
									44.73828125000006
								],
								[
									-65.65673828125003,
									44.7603027343751
								],
								[
									-64.9029296875,
									45.1208007812501
								],
								[
									-64.75126953125002,
									45.18022460937493
								],
								[
									-64.44882812499995,
									45.256054687499926
								],
								[
									-64.40688476562502,
									45.30571289062502
								],
								[
									-64.44814453125,
									45.33745117187499
								],
								[
									-64.33076171874998,
									45.30932617187494
								],
								[
									-64.34042968749998,
									45.26821289062511
								],
								[
									-64.35883789062501,
									45.23823242187504
								],
								[
									-64.36572265625,
									45.18725585937494
								],
								[
									-64.35424804687497,
									45.138232421875074
								],
								[
									-64.235009765625,
									45.1143066406251
								],
								[
									-64.13549804687497,
									45.02304687499998
								],
								[
									-64.18271484375,
									45.14702148437502
								],
								[
									-64.09316406249997,
									45.21708984374999
								],
								[
									-63.74833984374999,
									45.31088867187509
								],
								[
									-63.46025390624999,
									45.321093750000045
								],
								[
									-63.368017578125034,
									45.364794921875045
								],
								[
									-63.61445312499998,
									45.39414062500009
								],
								[
									-63.906445312499955,
									45.37817382812494
								],
								[
									-64.087158203125,
									45.41088867187494
								],
								[
									-64.33642578124997,
									45.38955078125005
								],
								[
									-64.60019531249998,
									45.41005859375005
								],
								[
									-64.68110351562493,
									45.38295898437494
								],
								[
									-64.74667968749998,
									45.324365234374994
								],
								[
									-64.83193359375002,
									45.35024414062494
								],
								[
									-64.87314453124998,
									45.35458984375012
								],
								[
									-64.91289062499999,
									45.37480468749996
								],
								[
									-64.827392578125,
									45.47553710937507
								],
								[
									-64.56005859374997,
									45.62548828125006
								],
								[
									-64.39707031249998,
									45.75585937499997
								],
								[
									-64.35112304687496,
									45.78320312499994
								],
								[
									-64.31464843749998,
									45.83569335937506
								],
								[
									-64.40405273437497,
									45.82690429687506
								],
								[
									-64.48222656250002,
									45.806347656249955
								],
								[
									-64.53632812499993,
									45.866601562499966
								],
								[
									-64.63271484375002,
									45.94663085937512
								],
								[
									-64.64204101562498,
									45.913330078125085
								],
								[
									-64.59365234374997,
									45.81367187500001
								],
								[
									-64.77851562499998,
									45.63842773437503
								],
								[
									-64.89790039062495,
									45.62597656249997
								],
								[
									-65.05727539062502,
									45.54423828124993
								],
								[
									-65.28232421875003,
									45.47309570312501
								],
								[
									-65.54501953125,
									45.337304687499966
								],
								[
									-65.88447265624995,
									45.222900390625114
								],
								[
									-65.95561523437499,
									45.22246093750002
								],
								[
									-66.10976562500002,
									45.31660156250001
								],
								[
									-66.06665039062494,
									45.35947265624995
								],
								[
									-66.02656249999995,
									45.41757812499998
								],
								[
									-66.06489257812495,
									45.40083007812504
								],
								[
									-66.08974609374994,
									45.37563476562505
								],
								[
									-66.18271484374998,
									45.33520507812506
								],
								[
									-66.10732421874997,
									45.25693359375012
								],
								[
									-66.14374999999993,
									45.22758789062499
								],
								[
									-66.25156249999995,
									45.189013671875045
								],
								[
									-66.351953125,
									45.13320312500005
								],
								[
									-66.43984374999994,
									45.09589843749998
								],
								[
									-66.51093749999995,
									45.143359375000074
								],
								[
									-66.70717773437497,
									45.08339843750002
								],
								[
									-66.87246093749997,
									45.06728515625002
								],
								[
									-66.90820312499997,
									45.097656250000085
								],
								[
									-66.91870117187497,
									45.14560546875009
								],
								[
									-66.97656249999997,
									45.15717773437504
								],
								[
									-67.08408203125,
									45.14394531250011
								],
								[
									-67.12485351562498,
									45.16943359375006
								],
								[
									-67.17099609374995,
									45.181982421875034
								],
								[
									-67.21323242187503,
									45.19252929687505
								],
								[
									-67.24960937499998,
									45.20078124999995
								],
								[
									-67.27070312499993,
									45.186718749999926
								],
								[
									-67.290673828125,
									45.16791992187501
								],
								[
									-67.31528320312495,
									45.15380859374997
								],
								[
									-67.366943359375,
									45.173779296874955
								],
								[
									-67.39980468749994,
									45.2101562500001
								],
								[
									-67.45258789062495,
									45.24765625000009
								],
								[
									-67.47255859375002,
									45.27587890624997
								],
								[
									-67.46196289062499,
									45.30869140625009
								],
								[
									-67.43852539062502,
									45.340380859375045
								],
								[
									-67.42792968749998,
									45.37792968750006
								],
								[
									-67.45375976562502,
									45.421240234375006
								],
								[
									-67.47724609375001,
									45.44589843750006
								],
								[
									-67.49365234374997,
									45.47407226562504
								],
								[
									-67.48779296875003,
									45.50102539062502
								],
								[
									-67.45493164062498,
									45.513964843750074
								],
								[
									-67.42441406249998,
									45.53041992187505
								],
								[
									-67.41386718749996,
									45.56557617187502
								],
								[
									-67.43266601562499,
									45.603125000000034
								],
								[
									-67.44970446134872,
									45.60795127467105
								],
								[
									-67.46093749999997,
									45.64165039062496
								],
								[
									-67.48007812499995,
									45.68305664062507
								],
								[
									-67.53271484375003,
									45.64252929687507
								],
								[
									-67.60043945312495,
									45.63730468749998
								],
								[
									-67.70776367187497,
									45.69208984375004
								],
								[
									-67.78706054687495,
									45.75898437499998
								],
								[
									-67.800694304263,
									45.75550360221345
								],
								[
									-67.79990234375,
									45.76977539062506
								],
								[
									-67.79169921874993,
									45.79555664062505
								],
								[
									-67.77529296874997,
									45.817871093750085
								],
								[
									-67.77412109374998,
									45.84252929687503
								],
								[
									-67.78115234375,
									45.86015624999999
								],
								[
									-67.78227539062496,
									45.87416992187508
								],
								[
									-67.77763671874999,
									45.891796874999955
								],
								[
									-67.76704101562498,
									45.927001953125114
								],
								[
									-67.78466796875,
									45.95278320312494
								],
								[
									-67.78647460937503,
									46.04213867187494
								],
								[
									-67.78994140625002,
									46.20932617187498
								],
								[
									-67.79252929687502,
									46.33740234375006
								],
								[
									-67.79580078124997,
									46.49838867187506
								],
								[
									-67.797705078125,
									46.61562500000008
								],
								[
									-67.80034179687502,
									46.779882812500034
								],
								[
									-67.80283203124998,
									46.9357421875001
								],
								[
									-67.806787109375,
									47.082812500000045
								],
								[
									-67.93486328124996,
									47.167626953124994
								],
								[
									-68.09677734375,
									47.27485351562498
								],
								[
									-68.23549804687502,
									47.345947265625085
								],
								[
									-68.310888671875,
									47.35449218750006
								],
								[
									-68.35800781250003,
									47.344531250000074
								],
								[
									-68.37690429687495,
									47.31616210937506
								],
								[
									-68.48037109375,
									47.285791015624994
								],
								[
									-68.66855468749995,
									47.253466796875074
								],
								[
									-68.8287109375,
									47.20332031249998
								],
								[
									-68.88740234374995,
									47.20283203125007
								],
								[
									-68.93720703124998,
									47.21123046874999
								],
								[
									-69.00312500000001,
									47.23642578124998
								],
								[
									-69.04858398437503,
									47.27363281250001
								],
								[
									-69.06425781250002,
									47.338134765625
								],
								[
									-69.0501953125,
									47.42661132812509
								],
								[
									-69.14628906249993,
									47.44477539062507
								],
								[
									-69.24287109374998,
									47.46298828124995
								],
								[
									-69.3021484375,
									47.40200195312505
								],
								[
									-69.35888671875,
									47.350634765625074
								],
								[
									-69.47148437499993,
									47.23867187500008
								],
								[
									-69.62978515624994,
									47.0813476562501
								],
								[
									-69.71752929687497,
									46.99487304687497
								],
								[
									-69.87172851562494,
									46.84291992187511
								],
								[
									-70.00771484375002,
									46.70893554687498
								],
								[
									-70.03823242187502,
									46.57143554687502
								],
								[
									-70.06718749999996,
									46.44106445312494
								],
								[
									-70.17968749999997,
									46.341845703125074
								],
								[
									-70.248291015625,
									46.25087890625011
								],
								[
									-70.27890625000003,
									46.14999999999998
								],
								[
									-70.30449218749999,
									46.05737304687503
								],
								[
									-70.30644531249996,
									45.97983398437495
								],
								[
									-70.28715820312502,
									45.93916015625001
								],
								[
									-70.296240234375,
									45.90610351562512
								],
								[
									-70.33344726562495,
									45.86806640625008
								],
								[
									-70.40786132812502,
									45.80190429687494
								],
								[
									-70.42109374999995,
									45.738232421874926
								],
								[
									-70.46660156249999,
									45.70683593749993
								],
								[
									-70.59638671874995,
									45.64399414062501
								],
								[
									-70.70224609375003,
									45.55136718750006
								],
								[
									-70.70742187500002,
									45.49892578124994
								],
								[
									-70.69213867187503,
									45.455371093750045
								],
								[
									-70.68979492187498,
									45.428320312500034
								],
								[
									-70.71093750000003,
									45.40947265625002
								],
								[
									-70.75332031249997,
									45.41069335937499
								],
								[
									-70.79916992187498,
									45.40478515624994
								],
								[
									-70.83779296875002,
									45.36616210937498
								],
								[
									-70.83681640625,
									45.31069335937505
								],
								[
									-70.86503906249999,
									45.27070312499998
								],
								[
									-70.89799804687493,
									45.262451171875085
								],
								[
									-70.92622070312501,
									45.29072265625007
								],
								[
									-70.96015624999998,
									45.33310546875009
								],
								[
									-70.99990234375002,
									45.33725585937495
								],
								[
									-71.06025390624995,
									45.309130859375074
								],
								[
									-71.13466796875002,
									45.26284179687508
								],
								[
									-71.20161132812498,
									45.260351562500006
								],
								[
									-71.327294921875,
									45.29008789062493
								],
								[
									-71.41904296874995,
									45.20034179687505
								],
								[
									-71.51752929687495,
									45.00756835937503
								],
								[
									-71.93364257812499,
									45.007080078125114
								],
								[
									-72.34975585937494,
									45.006591796875
								],
								[
									-72.76591796874999,
									45.006103515625085
								],
								[
									-73.18203124999994,
									45.00561523437506
								],
								[
									-73.59814453125,
									45.005175781250074
								],
								[
									-74.01425781250003,
									45.004687500000045
								],
								[
									-74.43037109374998,
									45.00419921874996
								],
								[
									-74.663232421875,
									45.003906250000085
								],
								[
									-74.70888671874997,
									45.00385742187507
								]
							]
						],
						[
							[
								[
									-126.09208984374995,
									49.354003906250085
								],
								[
									-126.064013671875,
									49.26362304687507
								],
								[
									-126.18681640624997,
									49.27812499999999
								],
								[
									-126.229638671875,
									49.295654296875085
								],
								[
									-126.2314453125,
									49.33906250000007
								],
								[
									-126.20854492187496,
									49.37978515625011
								],
								[
									-126.11528320312496,
									49.36503906249993
								],
								[
									-126.09208984374995,
									49.354003906250085
								]
							]
						],
						[
							[
								[
									-54.55439453125001,
									49.58886718749997
								],
								[
									-54.70869140625001,
									49.53066406250011
								],
								[
									-54.74384765624998,
									49.50776367187507
								],
								[
									-54.786523437499966,
									49.496142578125074
								],
								[
									-54.818505859374994,
									49.514453125000074
								],
								[
									-54.86357421875002,
									49.57607421874994
								],
								[
									-54.855419921874955,
									49.59658203124994
								],
								[
									-54.813085937500034,
									49.59936523437497
								],
								[
									-54.78876953124998,
									49.59121093750008
								],
								[
									-54.782617187499966,
									49.57207031250002
								],
								[
									-54.764062499999994,
									49.56235351562506
								],
								[
									-54.73310546875001,
									49.56215820312502
								],
								[
									-54.61874999999998,
									49.622070312500085
								],
								[
									-54.559179687500006,
									49.63149414062505
								],
								[
									-54.53769531249998,
									49.61997070312509
								],
								[
									-54.55439453125001,
									49.58886718749997
								]
							]
						],
						[
							[
								[
									-54.093701171874955,
									49.744433593750045
								],
								[
									-54.01992187500002,
									49.67949218749996
								],
								[
									-53.98066406250001,
									49.661962890625034
								],
								[
									-54.238378906250034,
									49.591650390625006
								],
								[
									-54.26923828125001,
									49.58701171874995
								],
								[
									-54.28613281249997,
									49.59536132812505
								],
								[
									-54.28876953124998,
									49.66083984375007
								],
								[
									-54.27763671875002,
									49.71147460937499
								],
								[
									-54.258984374999955,
									49.718994140625114
								],
								[
									-54.199365234374966,
									49.68852539062493
								],
								[
									-54.13769531250003,
									49.7511718750001
								],
								[
									-54.093701171874955,
									49.744433593750045
								]
							]
						],
						[
							[
								[
									-124.153662109375,
									49.53115234374994
								],
								[
									-124.13979492187502,
									49.51035156250006
								],
								[
									-124.36230468749997,
									49.5881835937501
								],
								[
									-124.45722656249994,
									49.63422851562507
								],
								[
									-124.49394531249996,
									49.66748046875
								],
								[
									-124.51782226562503,
									49.68632812499993
								],
								[
									-124.63095703124999,
									49.73569335937495
								],
								[
									-124.64985351562503,
									49.758349609375045
								],
								[
									-124.62329101562503,
									49.77509765624998
								],
								[
									-124.54716796874997,
									49.76494140624996
								],
								[
									-124.42148437500003,
									49.72778320312503
								],
								[
									-124.30913085937497,
									49.66728515624996
								],
								[
									-124.153662109375,
									49.53115234374994
								]
							]
						],
						[
							[
								[
									-126.64121093749999,
									49.605810546875034
								],
								[
									-126.68041992187499,
									49.60136718750002
								],
								[
									-126.74340820312503,
									49.61347656250001
								],
								[
									-126.81420898437497,
									49.64208984374997
								],
								[
									-126.93857421875,
									49.71845703125007
								],
								[
									-126.95126953125,
									49.73569335937495
								],
								[
									-126.94003906250003,
									49.75048828124994
								],
								[
									-126.90488281249998,
									49.76279296875006
								],
								[
									-126.89687500000004,
									49.78291015625007
								],
								[
									-126.92583007812497,
									49.837744140625034
								],
								[
									-126.82607421875,
									49.87236328124999
								],
								[
									-126.73813476562502,
									49.84365234375011
								],
								[
									-126.69814453124995,
									49.80849609375005
								],
								[
									-126.64990234374999,
									49.74580078125007
								],
								[
									-126.628173828125,
									49.67514648437506
								],
								[
									-126.62578124999996,
									49.62680664062506
								],
								[
									-126.64121093749999,
									49.605810546875034
								]
							]
						],
						[
							[
								[
									-61.801123046875034,
									49.09389648437494
								],
								[
									-62.21953125000002,
									49.07910156249994
								],
								[
									-62.55263671875002,
									49.140869140625
								],
								[
									-62.79960937499996,
									49.170703125000045
								],
								[
									-63.04150390624994,
									49.22495117187509
								],
								[
									-63.565869140624926,
									49.39931640625008
								],
								[
									-63.625878906249994,
									49.45991210937498
								],
								[
									-63.676220703124955,
									49.53432617187505
								],
								[
									-63.77661132812497,
									49.60200195312498
								],
								[
									-63.884912109374994,
									49.65771484375006
								],
								[
									-64.44003906250003,
									49.82773437500006
								],
								[
									-64.485205078125,
									49.88696289062494
								],
								[
									-64.37294921874997,
									49.92592773437508
								],
								[
									-64.24375,
									49.94438476562502
								],
								[
									-64.13144531249995,
									49.941650390625085
								],
								[
									-63.760156249999994,
									49.87524414062506
								],
								[
									-63.2919921875,
									49.81684570312504
								],
								[
									-63.08881835937501,
									49.77270507812494
								],
								[
									-62.858544921874994,
									49.70546875000011
								],
								[
									-62.633447265624966,
									49.62392578125011
								],
								[
									-62.133007812499955,
									49.40708007812506
								],
								[
									-62.043066406250034,
									49.38979492187508
								],
								[
									-61.817138671875,
									49.283544921875034
								],
								[
									-61.73583984374997,
									49.20375976562494
								],
								[
									-61.69614257812495,
									49.13901367187498
								],
								[
									-61.745507812499966,
									49.10576171874996
								],
								[
									-61.801123046875034,
									49.09389648437494
								]
							]
						],
						[
							[
								[
									-124.97773437500003,
									50.02958984374996
								],
								[
									-125.00156249999999,
									50.02075195312503
								],
								[
									-125.02597656249999,
									50.13408203124993
								],
								[
									-124.99565429687495,
									50.17519531250005
								],
								[
									-124.98701171874997,
									50.19584960937499
								],
								[
									-124.99082031250003,
									50.21713867187498
								],
								[
									-124.93784179687498,
									50.16591796874994
								],
								[
									-124.91640624999997,
									50.13154296875004
								],
								[
									-124.90747070312501,
									50.08398437499994
								],
								[
									-124.90844726562503,
									50.071289062500114
								],
								[
									-124.97773437500003,
									50.02958984374996
								]
							]
						],
						[
							[
								[
									-125.18413085937497,
									50.097119140624955
								],
								[
									-125.19511718749999,
									50.04433593750002
								],
								[
									-125.25957031249997,
									50.130029296874994
								],
								[
									-125.35844726562496,
									50.31152343750003
								],
								[
									-125.34531250000003,
									50.35395507812504
								],
								[
									-125.30117187500002,
									50.41406250000003
								],
								[
									-125.2609375,
									50.417822265625006
								],
								[
									-125.19599609375,
									50.38974609375006
								],
								[
									-125.13950195312503,
									50.33969726562509
								],
								[
									-125.12646484374996,
									50.32026367187504
								],
								[
									-125.09140625,
									50.26777343750007
								],
								[
									-125.07402343750002,
									50.22065429687498
								],
								[
									-125.11298828124995,
									50.163476562499966
								],
								[
									-125.18413085937497,
									50.097119140624955
								]
							]
						],
						[
							[
								[
									-55.5361328125,
									50.719677734374955
								],
								[
									-55.569677734375006,
									50.70869140625001
								],
								[
									-55.600781249999926,
									50.7090332031251
								],
								[
									-55.62934570312498,
									50.720800781250006
								],
								[
									-55.633886718750006,
									50.740185546874955
								],
								[
									-55.60449218749997,
									50.780712890624955
								],
								[
									-55.527197265625034,
									50.801220703124955
								],
								[
									-55.46928710937496,
									50.79638671874994
								],
								[
									-55.47275390624998,
									50.775927734375045
								],
								[
									-55.503808593749994,
									50.7421386718751
								],
								[
									-55.5361328125,
									50.719677734374955
								]
							]
						],
						[
							[
								[
									-127.19731445312496,
									50.64038085937506
								],
								[
									-126.70092773437499,
									50.51552734375002
								],
								[
									-126.20385742187497,
									50.45385742187497
								],
								[
									-125.83916015625002,
									50.380810546874926
								],
								[
									-125.61523437499996,
									50.35854492187511
								],
								[
									-125.534326171875,
									50.34248046875001
								],
								[
									-125.48208007812501,
									50.31679687499994
								],
								[
									-125.42045898437499,
									50.25463867187506
								],
								[
									-125.31396484374996,
									50.10668945312494
								],
								[
									-125.23320312499993,
									50.01220703124997
								],
								[
									-125.06640624999997,
									49.848193359375045
								],
								[
									-124.93466796874996,
									49.731640624999926
								],
								[
									-124.90463867187496,
									49.685351562500074
								],
								[
									-124.93242187499995,
									49.670458984375074
								],
								[
									-124.93066406250003,
									49.64316406250012
								],
								[
									-124.83061523437499,
									49.530078125000074
								],
								[
									-124.64287109375002,
									49.428662109374926
								],
								[
									-124.49594726562502,
									49.38027343750002
								],
								[
									-124.185888671875,
									49.300585937500045
								],
								[
									-123.99580078125,
									49.22402343750008
								],
								[
									-123.93715820312495,
									49.17080078125005
								],
								[
									-123.85449218749999,
									49.11918945312502
								],
								[
									-123.82001953124998,
									49.08349609375003
								],
								[
									-123.75229492187503,
									48.9512207031251
								],
								[
									-123.6265625,
									48.82402343749993
								],
								[
									-123.497021484375,
									48.58208007812502
								],
								[
									-123.47285156249995,
									48.60229492187497
								],
								[
									-123.45795898437503,
									48.674414062500006
								],
								[
									-123.44306640625001,
									48.690478515625074
								],
								[
									-123.41547851562498,
									48.69819335937507
								],
								[
									-123.38989257812501,
									48.670214843750045
								],
								[
									-123.36630859375,
									48.606445312500114
								],
								[
									-123.28378906249998,
									48.45517578125012
								],
								[
									-123.31064453125003,
									48.411035156249994
								],
								[
									-123.33452148437502,
									48.40649414062506
								],
								[
									-123.44589843749996,
									48.427246093750114
								],
								[
									-123.48457031250003,
									48.40009765625007
								],
								[
									-123.53647460937503,
									48.34497070312503
								],
								[
									-123.57314453124995,
									48.32280273437496
								],
								[
									-123.59462890624998,
									48.33354492187493
								],
								[
									-123.91694335937501,
									48.38657226562509
								],
								[
									-124.115234375,
									48.43642578125002
								],
								[
									-124.37622070312496,
									48.51523437500009
								],
								[
									-124.689404296875,
									48.59731445312494
								],
								[
									-124.86826171875002,
									48.653613281250045
								],
								[
									-125.017236328125,
									48.71147460937502
								],
								[
									-125.12070312500002,
									48.76079101562493
								],
								[
									-125.14028320312501,
									48.80263671875002
								],
								[
									-125.13569335937497,
									48.822412109374966
								],
								[
									-124.93476562499998,
									48.956347656250074
								],
								[
									-124.84965820312496,
									49.02827148437498
								],
								[
									-124.81704101562498,
									49.0833007812501
								],
								[
									-124.80024414062501,
									49.14155273437507
								],
								[
									-124.81264648437497,
									49.21264648437497
								],
								[
									-124.82075195312503,
									49.207128906250006
								],
								[
									-124.83872070312503,
									49.139062499999994
								],
								[
									-124.86831054687502,
									49.07851562500008
								],
								[
									-124.90444335937502,
									49.031005859375
								],
								[
									-124.92734374999998,
									49.01420898437496
								],
								[
									-125.16821289062501,
									48.99101562500002
								],
								[
									-125.36274414062495,
									48.99824218750007
								],
								[
									-125.46030273437502,
									48.94106445312508
								],
								[
									-125.48945312500001,
									48.93378906250001
								],
								[
									-125.54311523437501,
									48.95283203125007
								],
								[
									-125.66049804687503,
									49.02915039062498
								],
								[
									-125.82851562499998,
									49.09184570312496
								],
								[
									-125.81196289062498,
									49.10722656249999
								],
								[
									-125.70229492187502,
									49.13920898437493
								],
								[
									-125.64423828125001,
									49.185791015625085
								],
								[
									-125.65463867187499,
									49.193212890625006
								],
								[
									-125.69370117187496,
									49.19038085937507
								],
								[
									-125.72802734375003,
									49.19985351562494
								],
								[
									-125.79638671875001,
									49.26020507812498
								],
								[
									-125.83544921874997,
									49.27666015624996
								],
								[
									-125.918359375,
									49.24951171875003
								],
								[
									-125.95166015625003,
									49.248046875000085
								],
								[
									-125.98383789062501,
									49.28789062499993
								],
								[
									-125.93769531250003,
									49.37978515625011
								],
								[
									-125.93540039062499,
									49.40146484374998
								],
								[
									-126.02031249999997,
									49.368017578125006
								],
								[
									-126.04833984375,
									49.37900390625012
								],
								[
									-126.07490234375,
									49.40878906250006
								],
								[
									-126.09985351562501,
									49.42128906249994
								],
								[
									-126.16884765624995,
									49.41518554687494
								],
								[
									-126.243603515625,
									49.44267578125002
								],
								[
									-126.26972656249998,
									49.43188476562506
								],
								[
									-126.27963867187496,
									49.392187500000034
								],
								[
									-126.30449218749996,
									49.382031249999926
								],
								[
									-126.41860351562502,
									49.44902343749999
								],
								[
									-126.44453124999998,
									49.45112304687507
								],
								[
									-126.49985351562498,
									49.39995117187502
								],
								[
									-126.51914062499999,
									49.3967773437501
								],
								[
									-126.54853515625003,
									49.418945312500085
								],
								[
									-126.56372070312501,
									49.5432617187501
								],
								[
									-126.55747070312499,
									49.578613281250114
								],
								[
									-126.54189453125001,
									49.59047851562494
								],
								[
									-126.44277343749998,
									49.61928710937505
								],
								[
									-126.1578125,
									49.650146484375114
								],
								[
									-126.13408203124997,
									49.67231445312501
								],
								[
									-126.34755859374994,
									49.66083984375007
								],
								[
									-126.40317382812499,
									49.67773437500006
								],
								[
									-126.46279296874997,
									49.720214843750085
								],
								[
									-126.52524414062499,
									49.71958007812495
								],
								[
									-126.55825195312497,
									49.733398437500114
								],
								[
									-126.59287109375,
									49.76411132812507
								],
								[
									-126.68310546875,
									49.87646484374994
								],
								[
									-126.74462890625001,
									49.904931640624966
								],
								[
									-126.84936523437503,
									49.92280273437507
								],
								[
									-126.90332031250001,
									49.94414062499996
								],
								[
									-126.92607421875003,
									49.934716796874994
								],
								[
									-126.94794921874995,
									49.90268554687495
								],
								[
									-126.97709960937495,
									49.882812500000085
								],
								[
									-127.04873046874997,
									49.8715332031251
								],
								[
									-127.114306640625,
									49.87973632812506
								],
								[
									-127.16552734374996,
									49.91044921874993
								],
								[
									-127.19589843750002,
									49.94916992187501
								],
								[
									-127.20751953124999,
									49.99243164062494
								],
								[
									-127.17910156249998,
									50.05029296875
								],
								[
									-127.179638671875,
									50.07314453125005
								],
								[
									-127.19233398437501,
									50.09990234374999
								],
								[
									-127.21567382812496,
									50.12148437499994
								],
								[
									-127.24980468749999,
									50.13798828124993
								],
								[
									-127.26840820312496,
									50.12934570312504
								],
								[
									-127.27153320312497,
									50.09555664062509
								],
								[
									-127.29003906250001,
									50.07084960937493
								],
								[
									-127.34941406249995,
									50.05195312499998
								],
								[
									-127.39790039062497,
									50.085009765625074
								],
								[
									-127.42978515624998,
									50.130859375000085
								],
								[
									-127.46713867187503,
									50.16342773437506
								],
								[
									-127.67485351562499,
									50.16333007812494
								],
								[
									-127.77045898437501,
									50.12114257812496
								],
								[
									-127.81630859375002,
									50.117724609375074
								],
								[
									-127.86391601562495,
									50.127734375000074
								],
								[
									-127.87299804687503,
									50.1500976562501
								],
								[
									-127.82817382812496,
									50.21142578124997
								],
								[
									-127.83916015624997,
									50.29321289062503
								],
								[
									-127.85083007812496,
									50.31372070312503
								],
								[
									-127.94667968750004,
									50.326220703125074
								],
								[
									-127.96293945312497,
									50.34599609375002
								],
								[
									-127.90585937499998,
									50.445214843749994
								],
								[
									-127.87402343749997,
									50.46396484375009
								],
								[
									-127.83154296875003,
									50.47104492187509
								],
								[
									-127.64140625000002,
									50.47910156250006
								],
								[
									-127.578125,
									50.46494140625009
								],
								[
									-127.48652343749998,
									50.40463867187506
								],
								[
									-127.48935546875003,
									50.42734375000009
								],
								[
									-127.52402343749999,
									50.49575195312508
								],
								[
									-127.52900390625003,
									50.536767578124994
								],
								[
									-127.46591796874996,
									50.58310546875012
								],
								[
									-127.52622070312499,
									50.59667968749994
								],
								[
									-127.75146484374996,
									50.60737304687498
								],
								[
									-127.74970703124995,
									50.57773437500009
								],
								[
									-127.73115234375,
									50.53574218750006
								],
								[
									-127.86469726562503,
									50.49887695312509
								],
								[
									-127.96367187500003,
									50.49262695312507
								],
								[
									-128.05834960937494,
									50.49848632812501
								],
								[
									-128.13564453124997,
									50.520556640625074
								],
								[
									-128.267431640625,
									50.60927734375002
								],
								[
									-128.34990234375002,
									50.696582031250045
								],
								[
									-128.34604492187503,
									50.74423828124998
								],
								[
									-128.300830078125,
									50.79414062500001
								],
								[
									-128.24155273437498,
									50.82817382812502
								],
								[
									-128.101318359375,
									50.85776367187512
								],
								[
									-127.91806640624998,
									50.86054687500004
								],
								[
									-127.71303710937495,
									50.82075195312504
								],
								[
									-127.19731445312496,
									50.64038085937506
								]
							]
						],
						[
							[
								[
									-55.45874023437494,
									51.53652343750011
								],
								[
									-55.532421874999955,
									51.43696289062507
								],
								[
									-55.58339843749994,
									51.38857421875008
								],
								[
									-55.630761718749994,
									51.37290039062498
								],
								[
									-55.73071289062503,
									51.35869140624993
								],
								[
									-55.941162109375,
									51.34301757812503
								],
								[
									-56.031103515625034,
									51.32836914062497
								],
								[
									-56.04394531249997,
									51.26186523437511
								],
								[
									-56.03066406250002,
									51.22690429687509
								],
								[
									-55.999902343749966,
									51.19926757812496
								],
								[
									-55.96083984375002,
									51.19140625000006
								],
								[
									-55.87353515625,
									51.20791015624994
								],
								[
									-55.84111328124996,
									51.205078125000085
								],
								[
									-55.815087890624994,
									51.191162109375085
								],
								[
									-55.795507812500006,
									51.166162109374966
								],
								[
									-55.785351562499955,
									51.13144531250009
								],
								[
									-55.78471679687502,
									51.08706054687511
								],
								[
									-55.80000000000001,
									51.03330078125006
								],
								[
									-55.87138671874999,
									50.907373046874994
								],
								[
									-55.96201171874998,
									50.83769531250002
								],
								[
									-56.07812500000003,
									50.7809570312501
								],
								[
									-56.106542968750034,
									50.75927734375003
								],
								[
									-56.121191406250006,
									50.73378906250008
								],
								[
									-56.135644531249994,
									50.65097656250009
								],
								[
									-56.19575195312498,
									50.5847656250001
								],
								[
									-56.382421875000006,
									50.416992187500114
								],
								[
									-56.454345703125,
									50.38002929687502
								],
								[
									-56.45478515625001,
									50.350488281249966
								],
								[
									-56.48393554687499,
									50.27084960937509
								],
								[
									-56.53935546875002,
									50.20673828125007
								],
								[
									-56.693994140624994,
									50.05966796875006
								],
								[
									-56.732324218749966,
									50.00771484375002
								],
								[
									-56.74956054687502,
									49.966552734375
								],
								[
									-56.74716796874998,
									49.908496093750074
								],
								[
									-56.75410156249998,
									49.882910156250006
								],
								[
									-56.78950195312498,
									49.83374023437494
								],
								[
									-56.8388671875,
									49.78774414062508
								],
								[
									-56.84863281249994,
									49.76533203125004
								],
								[
									-56.829199218750006,
									49.724609375
								],
								[
									-56.80922851562502,
									49.71040039062504
								],
								[
									-56.80688476562497,
									49.67333984374994
								],
								[
									-56.822167968749994,
									49.61347656250001
								],
								[
									-56.75678710937498,
									49.65161132812506
								],
								[
									-56.61064453124996,
									49.78769531249998
								],
								[
									-56.50092773437498,
									49.86962890624997
								],
								[
									-56.42758789062498,
									49.89741210937504
								],
								[
									-56.376416015624955,
									49.93369140625006
								],
								[
									-56.32182617187502,
									50.01376953125012
								],
								[
									-56.24707031249997,
									50.09008789062494
								],
								[
									-56.179394531249955,
									50.11499023437503
								],
								[
									-56.148388671874926,
									50.100341796875085
								],
								[
									-56.122167968750006,
									50.06284179687506
								],
								[
									-56.12744140625003,
									50.01513671874994
								],
								[
									-56.16416015624995,
									49.95727539062497
								],
								[
									-56.161279296874994,
									49.94013671875004
								],
								[
									-56.07499999999999,
									49.98261718749998
								],
								[
									-55.92700195312497,
									50.017773437499955
								],
								[
									-55.87333984374996,
									50.01313476562498
								],
								[
									-55.764746093750034,
									49.96044921875
								],
								[
									-55.67446289062502,
									49.966552734375
								],
								[
									-55.530029296875,
									49.99716796875012
								],
								[
									-55.50292968749997,
									49.983154296875
								],
								[
									-55.527001953124994,
									49.93676757812497
								],
								[
									-55.58369140625001,
									49.89238281249999
								],
								[
									-55.717626953125034,
									49.82900390625005
								],
								[
									-56.03999023437498,
									49.704687500000034
								],
								[
									-56.14018554687496,
									49.619140625000085
								],
								[
									-56.121191406250006,
									49.62172851562508
								],
								[
									-56.051611328125034,
									49.658398437499926
								],
								[
									-55.97851562499997,
									49.67812500000002
								],
								[
									-55.90185546875,
									49.68085937500007
								],
								[
									-55.869824218749955,
									49.670166015625114
								],
								[
									-55.88232421875,
									49.64594726562504
								],
								[
									-55.892041015624955,
									49.5802734375001
								],
								[
									-56.08730468750002,
									49.45195312499996
								],
								[
									-56.041210937499955,
									49.456835937500074
								],
								[
									-55.81523437500002,
									49.51528320312508
								],
								[
									-55.678124999999966,
									49.43461914062499
								],
								[
									-55.48974609374997,
									49.46249999999998
								],
								[
									-55.375927734374955,
									49.48974609375003
								],
								[
									-55.379150390625,
									49.47290039062497
								],
								[
									-55.35449218750003,
									49.43769531250007
								],
								[
									-55.35537109375002,
									49.38085937500006
								],
								[
									-55.343847656250006,
									49.37290039062512
								],
								[
									-55.28994140625002,
									49.39194335937509
								],
								[
									-55.280175781249994,
									49.412744140624966
								],
								[
									-55.28300781249993,
									49.51381835937505
								],
								[
									-55.26635742187503,
									49.52392578124997
								],
								[
									-55.22954101562499,
									49.508154296875034
								],
								[
									-55.20703125,
									49.48203125000006
								],
								[
									-55.20029296874998,
									49.40849609374999
								],
								[
									-55.22500000000002,
									49.33466796875004
								],
								[
									-55.25932617187502,
									49.26699218749994
								],
								[
									-55.34248046874998,
									49.16811523437505
								],
								[
									-55.331933593749966,
									49.12558593750009
								],
								[
									-55.35317382812502,
									49.07944335937509
								],
								[
									-55.33476562500002,
									49.07788085937506
								],
								[
									-55.252343749999994,
									49.12089843749993
								],
								[
									-55.24736328124996,
									49.13857421875008
								],
								[
									-55.25380859374994,
									49.1796386718751
								],
								[
									-55.24453125000002,
									49.19980468750012
								],
								[
									-55.176123046875006,
									49.24443359374996
								],
								[
									-55.06318359375001,
									49.29736328125
								],
								[
									-55.02617187500002,
									49.30537109375004
								],
								[
									-55.010400390624994,
									49.2930175781251
								],
								[
									-55.01591796874999,
									49.260351562500006
								],
								[
									-54.982617187499955,
									49.26811523437499
								],
								[
									-54.910546874999994,
									49.316259765625034
								],
								[
									-54.843652343749966,
									49.345410156249926
								],
								[
									-54.781884765624994,
									49.35546875000003
								],
								[
									-54.71762695312495,
									49.38857421875002
								],
								[
									-54.65087890625003,
									49.44453125000004
								],
								[
									-54.57905273437498,
									49.49082031249998
								],
								[
									-54.50219726562503,
									49.52734375000006
								],
								[
									-54.46918945312498,
									49.529785156250114
								],
								[
									-54.480615234374994,
									49.46933593749995
								],
								[
									-54.465429687500006,
									49.400537109374966
								],
								[
									-54.46347656249995,
									49.34174804687498
								],
								[
									-54.44824218749997,
									49.32944335937506
								],
								[
									-54.389062499999994,
									49.392138671875045
								],
								[
									-54.356152343749955,
									49.415039062500085
								],
								[
									-54.316748046875006,
									49.424121093750074
								],
								[
									-54.27080078124996,
									49.41928710937506
								],
								[
									-53.957714843749955,
									49.44184570312504
								],
								[
									-53.862451171874994,
									49.426318359375074
								],
								[
									-53.754980468750034,
									49.385302734375074
								],
								[
									-53.61943359374996,
									49.32163085937506
								],
								[
									-53.56958007812503,
									49.264160156250085
								],
								[
									-53.56005859375003,
									49.191699218750045
								],
								[
									-53.57343750000001,
									49.14121093750006
								],
								[
									-53.671142578125,
									49.07753906250008
								],
								[
									-53.75805664062494,
									49.035400390625114
								],
								[
									-53.809326171875,
									48.993408203125085
								],
								[
									-53.82490234374998,
									48.95136718750004
								],
								[
									-53.84521484375003,
									48.925439453124994
								],
								[
									-53.903222656249966,
									48.88916015624997
								],
								[
									-54.16127929687494,
									48.78769531250009
								],
								[
									-54.099511718749966,
									48.78476562500012
								],
								[
									-53.95068359375003,
									48.80678710937508
								],
								[
									-53.852880859375006,
									48.81132812500002
								],
								[
									-53.847753906250034,
									48.79667968749996
								],
								[
									-53.88681640624998,
									48.76782226562494
								],
								[
									-53.961523437500006,
									48.73886718750009
								],
								[
									-53.96958007812498,
									48.72490234374999
								],
								[
									-53.966015624999955,
									48.70668945312511
								],
								[
									-53.88613281250002,
									48.68466796875006
								],
								[
									-53.78408203125002,
									48.69541015625012
								],
								[
									-53.69804687499999,
									48.67983398437505
								],
								[
									-53.70634765624999,
									48.65551757812506
								],
								[
									-53.774609374999955,
									48.57631835937511
								],
								[
									-53.794628906249955,
									48.52636718750006
								],
								[
									-53.88554687499999,
									48.48457031250007
								],
								[
									-54.067773437499994,
									48.418847656249994
								],
								[
									-54.11445312500001,
									48.3936035156251
								],
								[
									-54.10424804687497,
									48.3883789062501
								],
								[
									-53.93701171875,
									48.43662109375006
								],
								[
									-53.85273437499998,
									48.44882812500006
								],
								[
									-53.79931640625,
									48.44921875000006
								],
								[
									-53.738867187500034,
									48.49580078125004
								],
								[
									-53.644433593749994,
									48.511230468750085
								],
								[
									-53.55205078124999,
									48.48178710937512
								],
								[
									-53.41132812500001,
									48.562158203124966
								],
								[
									-53.361083984375,
									48.57260742187506
								],
								[
									-53.27543945312496,
									48.563330078125034
								],
								[
									-53.22026367187499,
									48.57788085937497
								],
								[
									-53.127343749999994,
									48.632568359375114
								],
								[
									-53.057275390624994,
									48.65903320312506
								],
								[
									-53.042675781249955,
									48.65664062499994
								],
								[
									-53.027587890625,
									48.63471679687501
								],
								[
									-53.02075195312503,
									48.571630859375034
								],
								[
									-53.037304687499926,
									48.51586914062503
								],
								[
									-53.060205078124994,
									48.48032226562509
								],
								[
									-53.1357421875,
									48.401855468750085
								],
								[
									-53.18212890624994,
									48.37436523437509
								],
								[
									-53.22509765625,
									48.364013671875114
								],
								[
									-53.301171874999966,
									48.36816406249997
								],
								[
									-53.33432617187495,
									48.35595703124997
								],
								[
									-53.405517578125,
									48.29433593749994
								],
								[
									-53.53120117187501,
									48.23188476562501
								],
								[
									-53.60976562500002,
									48.20771484375007
								],
								[
									-53.560205078124966,
									48.173828125000085
								],
								[
									-53.54184570312495,
									48.10844726562499
								],
								[
									-53.56943359374998,
									48.088085937499926
								],
								[
									-53.70429687500001,
									48.067919921875074
								],
								[
									-53.710156249999955,
									48.056835937499955
								],
								[
									-53.758203124999994,
									48.04238281250002
								],
								[
									-53.869580078124926,
									48.01967773437494
								],
								[
									-53.793554687500006,
									48.009716796874955
								],
								[
									-53.653027343749955,
									48.02573242187512
								],
								[
									-53.63823242187496,
									48.01464843750006
								],
								[
									-53.65761718750002,
									47.96865234374994
								],
								[
									-53.69501953124998,
									47.921191406250045
								],
								[
									-53.861669921875006,
									47.79926757812507
								],
								[
									-53.863671874999966,
									47.787011718749966
								],
								[
									-53.837744140625034,
									47.727246093749955
								],
								[
									-53.80537109375001,
									47.68203125000008
								],
								[
									-53.76513671874997,
									47.65009765625004
								],
								[
									-53.67236328125,
									47.64824218750002
								],
								[
									-53.60375976562497,
									47.66230468750004
								],
								[
									-53.503759765625006,
									47.74384765625007
								],
								[
									-53.28271484375003,
									47.99785156249993
								],
								[
									-53.08544921874997,
									48.06850585937494
								],
								[
									-52.920996093750034,
									48.147070312500034
								],
								[
									-52.88330078125,
									48.1311523437501
								],
								[
									-52.86601562499993,
									48.11298828125004
								],
								[
									-52.87202148437501,
									48.09394531250007
								],
								[
									-52.95498046874994,
									48.02929687499994
								],
								[
									-52.99824218749998,
									47.97592773437509
								],
								[
									-53.11083984375,
									47.81191406250008
								],
								[
									-53.15385742187496,
									47.73457031250004
								],
								[
									-53.17553710937503,
									47.65297851562502
								],
								[
									-53.16982421875002,
									47.51210937500011
								],
								[
									-53.157666015624955,
									47.48779296875003
								],
								[
									-53.122460937499966,
									47.455126953125045
								],
								[
									-53.05683593750001,
									47.483105468749955
								],
								[
									-52.945019531249955,
									47.55283203124995
								],
								[
									-52.873193359374994,
									47.61943359374993
								],
								[
									-52.81694335937499,
									47.72788085937509
								],
								[
									-52.782421874999955,
									47.76943359374994
								],
								[
									-52.74492187499996,
									47.76894531250002
								],
								[
									-52.71142578124997,
									47.7453125000001
								],
								[
									-52.703271484374994,
									47.69301757812508
								],
								[
									-52.67216796874999,
									47.62177734375007
								],
								[
									-52.653662109375034,
									47.54941406250006
								],
								[
									-52.66850585937493,
									47.469824218750006
								],
								[
									-52.68364257812502,
									47.42631835937493
								],
								[
									-52.91240234374999,
									47.103222656249926
								],
								[
									-52.88813476562501,
									47.04584960937504
								],
								[
									-52.88208007812503,
									47.01108398437506
								],
								[
									-52.88920898437496,
									46.97412109375
								],
								[
									-52.96171874999999,
									46.81943359375012
								],
								[
									-53.03193359374998,
									46.72275390624995
								],
								[
									-53.06977539062498,
									46.68125000000012
								],
								[
									-53.114843750000006,
									46.65581054687499
								],
								[
									-53.16699218749997,
									46.64648437500006
								],
								[
									-53.21367187499999,
									46.66049804687506
								],
								[
									-53.25488281250003,
									46.6977050781251
								],
								[
									-53.29130859374999,
									46.71704101562494
								],
								[
									-53.32304687499996,
									46.71835937499995
								],
								[
									-53.38173828125002,
									46.71142578125006
								],
								[
									-53.53613281249994,
									46.632519531249955
								],
								[
									-53.567773437499994,
									46.62827148437498
								],
								[
									-53.589794921874955,
									46.63886718750001
								],
								[
									-53.616357421874966,
									46.680273437500006
								],
								[
									-53.59516601562498,
									46.88847656249996
								],
								[
									-53.58134765625002,
									46.95727539062494
								],
								[
									-53.61215820312498,
									47.01035156250009
								],
								[
									-53.57963867187502,
									47.099414062500045
								],
								[
									-53.57846679687495,
									47.13325195312501
								],
								[
									-53.59736328124998,
									47.14599609375003
								],
								[
									-53.63637695312494,
									47.13769531250003
								],
								[
									-53.69536132812496,
									47.09291992187505
								],
								[
									-53.774316406249994,
									47.011816406250034
								],
								[
									-53.86000976562502,
									46.93945312500006
								],
								[
									-54.00957031249996,
									46.83959960937506
								],
								[
									-54.07602539062498,
									46.81997070312505
								],
								[
									-54.102392578125034,
									46.82490234374998
								],
								[
									-54.1328125,
									46.838574218749926
								],
								[
									-54.173730468749994,
									46.88037109375
								],
								[
									-54.17329101562498,
									46.917187499999955
								],
								[
									-54.155224609374955,
									46.96748046874998
								],
								[
									-54.092675781249994,
									47.08623046874993
								],
								[
									-53.97050781249999,
									47.26196289062503
								],
								[
									-53.86909179687501,
									47.38701171875002
								],
								[
									-53.84951171875002,
									47.44033203125005
								],
								[
									-53.877880859374955,
									47.46357421875007
								],
								[
									-53.90083007812501,
									47.509326171875074
								],
								[
									-53.93974609375002,
									47.64467773437511
								],
								[
									-53.98901367187503,
									47.75620117187509
								],
								[
									-54.047265624999994,
									47.80561523437504
								],
								[
									-54.191845703124955,
									47.85981445312507
								],
								[
									-54.21840820312494,
									47.84672851562496
								],
								[
									-54.23388671875,
									47.771679687499955
								],
								[
									-54.404687499999966,
									47.55590820312506
								],
								[
									-54.434472656249994,
									47.46230468750008
								],
								[
									-54.455908203125006,
									47.42758789062512
								],
								[
									-54.488134765625006,
									47.403857421875074
								],
								[
									-54.56254882812499,
									47.3751953125001
								],
								[
									-54.542382812499966,
									47.425097656250045
								],
								[
									-54.463232421875006,
									47.53623046874995
								],
								[
									-54.47392578124996,
									47.54707031250001
								],
								[
									-54.57451171875002,
									47.45776367187494
								],
								[
									-54.65117187500002,
									47.40820312499997
								],
								[
									-54.74467773437496,
									47.395458984374955
								],
								[
									-54.801513671875,
									47.39863281249998
								],
								[
									-54.856640624999955,
									47.38500976562506
								],
								[
									-55.09042968749998,
									47.173925781250034
								],
								[
									-55.09921874999998,
									47.103564453125074
								],
								[
									-55.13964843749997,
									47.045947265625074
								],
								[
									-55.25493164062499,
									46.94174804687498
								],
								[
									-55.31572265624996,
									46.905712890624926
								],
								[
									-55.401269531249966,
									46.899267578125034
								],
								[
									-55.47929687499996,
									46.917285156250074
								],
								[
									-55.530712890624955,
									46.914013671874926
								],
								[
									-55.65234374999997,
									46.88144531249995
								],
								[
									-55.78852539062498,
									46.86723632812499
								],
								[
									-55.84472656249997,
									46.8738281250001
								],
								[
									-55.880615234375,
									46.88720703124997
								],
								[
									-55.94990234375001,
									46.927685546874955
								],
								[
									-55.95820312500001,
									46.95639648437495
								],
								[
									-55.954492187499966,
									46.973242187500006
								],
								[
									-55.91923828124999,
									47.01689453125002
								],
								[
									-55.83837890625003,
									47.07163085937498
								],
								[
									-55.77182617187498,
									47.092089843750045
								],
								[
									-55.610058593749955,
									47.119628906250085
								],
								[
									-55.49150390624996,
									47.160644531250085
								],
								[
									-55.40122070312495,
									47.221484375000045
								],
								[
									-55.36088867187499,
									47.25859374999996
								],
								[
									-55.190820312499994,
									47.44897460937503
								],
								[
									-54.97563476562493,
									47.516162109375045
								],
								[
									-54.869531249999994,
									47.57089843750009
								],
								[
									-54.79536132812498,
									47.640332031249926
								],
								[
									-54.78461914062501,
									47.664746093749926
								],
								[
									-54.89101562500002,
									47.629492187500034
								],
								[
									-54.94594726562502,
									47.62084960937506
								],
								[
									-55.03500976562495,
									47.63388671874995
								],
								[
									-55.074560546875034,
									47.65756835937498
								],
								[
									-55.19658203125002,
									47.65004882812505
								],
								[
									-55.366308593750034,
									47.66108398437498
								],
								[
									-55.390771484374966,
									47.6428710937501
								],
								[
									-55.41269531249998,
									47.55039062500009
								],
								[
									-55.434667968750034,
									47.50126953124993
								],
								[
									-55.46064453124998,
									47.48476562499994
								],
								[
									-55.498632812500006,
									47.47504882812501
								],
								[
									-55.57612304687498,
									47.46523437500005
								],
								[
									-55.77470703125002,
									47.49829101562494
								],
								[
									-55.811376953125034,
									47.516357421875085
								],
								[
									-55.86206054687497,
									47.53007812499993
								],
								[
									-56.08134765624996,
									47.499951171874926
								],
								[
									-56.12724609374999,
									47.50283203125008
								],
								[
									-56.08369140624998,
									47.524511718750034
								],
								[
									-55.86708984375002,
									47.5923339843751
								],
								[
									-55.844384765624994,
									47.78784179687506
								],
								[
									-55.85791015625,
									47.81918945312495
								],
								[
									-55.91845703125,
									47.79189453125008
								],
								[
									-56.020117187500006,
									47.76372070312493
								],
								[
									-56.08964843749996,
									47.771874999999994
								],
								[
									-56.12143554687495,
									47.78916015625006
								],
								[
									-56.150585937499955,
									47.77451171875009
								],
								[
									-56.22128906249995,
									47.67138671874994
								],
								[
									-56.26298828125002,
									47.65844726562497
								],
								[
									-56.325781250000006,
									47.65449218750007
								],
								[
									-56.459570312500006,
									47.61694335937506
								],
								[
									-56.722314453124966,
									47.59228515625
								],
								[
									-56.774121093749955,
									47.564990234375045
								],
								[
									-56.95249023437498,
									47.574462890625085
								],
								[
									-57.47343749999996,
									47.631103515625
								],
								[
									-57.65981445312502,
									47.625390624999994
								],
								[
									-57.88408203124996,
									47.660009765625034
								],
								[
									-57.92553710937497,
									47.67490234374995
								],
								[
									-58.23930664062493,
									47.668847656249966
								],
								[
									-58.33320312499998,
									47.67685546875009
								],
								[
									-58.32695312499996,
									47.719873046874966
								],
								[
									-58.33686523437501,
									47.73085937500008
								],
								[
									-58.42802734375002,
									47.683398437500074
								],
								[
									-58.50888671874998,
									47.65258789062503
								],
								[
									-58.61313476562498,
									47.626220703125085
								],
								[
									-58.94116210937503,
									47.58046875000008
								],
								[
									-59.11694335937494,
									47.57070312500005
								],
								[
									-59.21928710937502,
									47.60253906250006
								],
								[
									-59.259765625,
									47.63417968750011
								],
								[
									-59.32065429687498,
									47.73691406249998
								],
								[
									-59.36240234374995,
									47.86567382812501
								],
								[
									-59.36206054687497,
									47.888964843750045
								],
								[
									-59.34086914062502,
									47.933642578125074
								],
								[
									-59.272070312500034,
									47.9955566406251
								],
								[
									-58.96083984374994,
									48.15937500000007
								],
								[
									-58.71059570312494,
									48.32504882812498
								],
								[
									-58.60498046875,
									48.41132812500007
								],
								[
									-58.502636718749955,
									48.44204101562511
								],
								[
									-58.335546875000006,
									48.51367187499994
								],
								[
									-58.330224609374994,
									48.52211914062508
								],
								[
									-58.49223632812496,
									48.51303710937509
								],
								[
									-58.60615234374998,
									48.53286132812505
								],
								[
									-58.722558593749994,
									48.540722656249955
								],
								[
									-58.943798828124926,
									48.5217773437501
								],
								[
									-59.16679687499999,
									48.5217773437501
								],
								[
									-59.16767578124998,
									48.55849609375002
								],
								[
									-59.06342773437498,
									48.627685546875085
								],
								[
									-58.84179687500003,
									48.746435546875034
								],
								[
									-58.81918945312495,
									48.746826171875114
								],
								[
									-58.88710937500002,
									48.69155273437505
								],
								[
									-58.906445312499955,
									48.65019531249996
								],
								[
									-58.87724609374996,
									48.62270507812505
								],
								[
									-58.843408203124994,
									48.60532226562506
								],
								[
									-58.716455078124994,
									48.598046874999994
								],
								[
									-58.687353515625006,
									48.6220703125
								],
								[
									-58.6416015625,
									48.74941406250011
								],
								[
									-58.54560546874998,
									48.89687500000002
								],
								[
									-58.493750000000006,
									49.00322265625002
								],
								[
									-58.403662109375034,
									49.084326171875034
								],
								[
									-58.35869140625002,
									49.096533203125034
								],
								[
									-58.318749999999966,
									49.08134765624996
								],
								[
									-58.186132812500034,
									49.061914062499994
								],
								[
									-58.049658203125034,
									48.98754882812494
								],
								[
									-58.005566406249926,
									48.98124999999999
								],
								[
									-57.99052734374999,
									48.98793945312494
								],
								[
									-58.04057617187496,
									49.00976562499994
								],
								[
									-58.08183593750002,
									49.04472656249996
								],
								[
									-58.09892578124993,
									49.07744140624996
								],
								[
									-58.049072265625,
									49.179980468750074
								],
								[
									-57.99067382812501,
									49.20947265624994
								],
								[
									-57.98007812499998,
									49.229638671874966
								],
								[
									-58.09687499999998,
									49.23007812500006
								],
								[
									-58.19091796875003,
									49.25874023437504
								],
								[
									-58.218896484374966,
									49.30512695312498
								],
								[
									-58.21337890625,
									49.38666992187498
								],
								[
									-58.18271484374995,
									49.43540039062506
								],
								[
									-58.107421875,
									49.499707031249926
								],
								[
									-58.01582031249998,
									49.54248046875003
								],
								[
									-57.96123046874996,
									49.53154296875002
								],
								[
									-57.856054687500034,
									49.47382812499998
								],
								[
									-57.79130859374999,
									49.489990234375085
								],
								[
									-57.798828125,
									49.50854492187494
								],
								[
									-57.89746093750003,
									49.6003906250001
								],
								[
									-57.92905273437498,
									49.66840820312501
								],
								[
									-57.92617187500002,
									49.70083007812505
								],
								[
									-57.712500000000006,
									50.024902343750085
								],
								[
									-57.60795898437502,
									50.198779296875045
								],
								[
									-57.465527343749955,
									50.46367187499993
								],
								[
									-57.4326171875,
									50.50581054687507
								],
								[
									-57.36044921874995,
									50.58393554687501
								],
								[
									-57.33056640625,
									50.60517578124998
								],
								[
									-57.237402343750034,
									50.60537109374994
								],
								[
									-57.179589843749966,
									50.61484375000009
								],
								[
									-57.26416015624997,
									50.649365234374926
								],
								[
									-57.29443359375,
									50.67338867187493
								],
								[
									-57.29799804687502,
									50.69873046874994
								],
								[
									-57.27490234375003,
									50.72529296875004
								],
								[
									-57.24213867187501,
									50.744921875000045
								],
								[
									-57.13164062499996,
									50.787402343750074
								],
								[
									-57.05327148437499,
									50.85732421875002
								],
								[
									-57.00566406249996,
									50.9396484375001
								],
								[
									-57.01274414062499,
									50.96772460937504
								],
								[
									-57.037304687499926,
									50.995654296875045
								],
								[
									-57.03593750000002,
									51.010839843750034
								],
								[
									-56.97636718749996,
									51.027978515624966
								],
								[
									-56.825146484374955,
									51.125732421875085
								],
								[
									-56.80546874999996,
									51.14448242187498
								],
								[
									-56.75019531249998,
									51.27490234375
								],
								[
									-56.68242187500002,
									51.33276367187497
								],
								[
									-56.619042968749994,
									51.36245117187508
								],
								[
									-56.517968749999994,
									51.39931640625002
								],
								[
									-56.20737304687498,
									51.48862304687512
								],
								[
									-56.02558593749998,
									51.568359375000114
								],
								[
									-55.90209960937503,
									51.5639160156251
								],
								[
									-55.865820312500006,
									51.50830078124994
								],
								[
									-55.6904296875,
									51.471337890624966
								],
								[
									-55.65957031250002,
									51.511035156250045
								],
								[
									-55.700634765624926,
									51.55942382812506
								],
								[
									-55.666406249999994,
									51.57890625000002
								],
								[
									-55.521630859374966,
									51.59638671875004
								],
								[
									-55.496435546875006,
									51.58984374999994
								],
								[
									-55.45322265624998,
									51.56230468749993
								],
								[
									-55.45874023437494,
									51.53652343750011
								]
							]
						],
						[
							[
								[
									-127.92465820312499,
									51.47387695312494
								],
								[
									-127.94125976562499,
									51.45717773437511
								],
								[
									-127.98124999999997,
									51.457226562499926
								],
								[
									-128.04453124999998,
									51.47402343750008
								],
								[
									-128.091796875,
									51.51113281250008
								],
								[
									-128.14877929687498,
									51.626708984375
								],
								[
									-128.14238281250002,
									51.64658203125006
								],
								[
									-128.12275390625,
									51.66679687499999
								],
								[
									-128.03173828125006,
									51.70839843749994
								],
								[
									-127.99868164062497,
									51.70380859374998
								],
								[
									-127.98681640625004,
									51.67358398437506
								],
								[
									-127.93251953125,
									51.60546875000003
								],
								[
									-127.91635742187498,
									51.58544921874994
								],
								[
									-127.91630859374997,
									51.50620117187506
								],
								[
									-127.92465820312499,
									51.47387695312494
								]
							]
						],
						[
							[
								[
									-55.361230468749994,
									51.889648437500085
								],
								[
									-55.40888671875001,
									51.88881835937502
								],
								[
									-55.41962890624998,
									51.900048828124994
								],
								[
									-55.39980468750002,
									51.938476562500085
								],
								[
									-55.34648437499999,
									51.98286132812507
								],
								[
									-55.274072265624994,
									51.99516601562502
								],
								[
									-55.29355468749995,
									51.92998046874996
								],
								[
									-55.361230468749994,
									51.889648437500085
								]
							]
						],
						[
							[
								[
									-79.38427734375,
									51.9519531250001
								],
								[
									-79.42558593749996,
									51.944873046875074
								],
								[
									-79.52060546874995,
									51.95292968749993
								],
								[
									-79.59687499999995,
									51.978027343750085
								],
								[
									-79.64375000000001,
									52.01005859374993
								],
								[
									-79.33486328124997,
									52.09814453124994
								],
								[
									-79.27128906249996,
									52.08681640624994
								],
								[
									-79.27021484374993,
									52.07109374999993
								],
								[
									-79.31660156249995,
									52.023925781250085
								],
								[
									-79.328955078125,
									51.992285156250034
								],
								[
									-79.35151367187498,
									51.96831054687496
								],
								[
									-79.38427734375,
									51.9519531250001
								]
							]
						],
						[
							[
								[
									-131.029296875,
									51.961621093749926
								],
								[
									-131.04726562500002,
									51.959716796875085
								],
								[
									-131.08051757812495,
									51.98041992187504
								],
								[
									-131.10341796875002,
									52.0138671875001
								],
								[
									-131.11733398437502,
									52.1010253906251
								],
								[
									-131.10712890624995,
									52.13657226562495
								],
								[
									-131.098095703125,
									52.15063476562497
								],
								[
									-131.01064453125002,
									52.095263671875074
								],
								[
									-131.029296875,
									51.961621093749926
								]
							]
						],
						[
							[
								[
									-128.36875000000003,
									52.40087890624997
								],
								[
									-128.44541015625003,
									52.3875000000001
								],
								[
									-128.41987304687498,
									52.4411132812501
								],
								[
									-128.41249999999997,
									52.47285156249998
								],
								[
									-128.42626953125006,
									52.502734375000045
								],
								[
									-128.43593749999997,
									52.56035156249996
								],
								[
									-128.43979492187503,
									52.69638671875006
								],
								[
									-128.36489257812497,
									52.781884765624966
								],
								[
									-128.24726562499998,
									52.78437500000004
								],
								[
									-128.24843749999997,
									52.74121093749994
								],
								[
									-128.29814453124996,
									52.54824218750008
								],
								[
									-128.32377929687505,
									52.458984375
								],
								[
									-128.3435546875,
									52.42607421874996
								],
								[
									-128.36875000000003,
									52.40087890624997
								]
							]
						],
						[
							[
								[
									-128.93686523437498,
									52.510009765625
								],
								[
									-128.96870117187495,
									52.46425781250011
								],
								[
									-129.10234375000002,
									52.574365234374966
								],
								[
									-129.15102539062497,
									52.60532226562506
								],
								[
									-129.25048828125,
									52.72216796874997
								],
								[
									-129.26777343749995,
									52.77236328125008
								],
								[
									-129.26352539062498,
									52.80078125
								],
								[
									-129.24594726562498,
									52.8112304687501
								],
								[
									-129.21503906249995,
									52.80385742187511
								],
								[
									-129.18618164062497,
									52.791259765625114
								],
								[
									-128.99399414062498,
									52.661718750000006
								],
								[
									-128.94033203124997,
									52.60073242187511
								],
								[
									-128.93686523437498,
									52.510009765625
								]
							]
						],
						[
							[
								[
									-129.313720703125,
									52.9921875
								],
								[
									-129.32871093750003,
									52.98422851562498
								],
								[
									-129.37001953125002,
									52.997607421875045
								],
								[
									-129.40971679687502,
									53.023730468750045
								],
								[
									-129.47778320312503,
									53.09775390625012
								],
								[
									-129.50014648437497,
									53.12890624999997
								],
								[
									-129.51474609375,
									53.179394531249955
								],
								[
									-129.50107421874998,
									53.18833007812509
								],
								[
									-129.471435546875,
									53.18300781250008
								],
								[
									-129.45073242187505,
									53.17470703125005
								],
								[
									-129.34350585937503,
									53.0527832031251
								],
								[
									-129.313720703125,
									52.9921875
								]
							]
						],
						[
							[
								[
									-80.73168945312494,
									52.74726562500001
								],
								[
									-80.80234374999995,
									52.73398437499998
								],
								[
									-81.00986328124995,
									52.760644531249994
								],
								[
									-81.09658203124997,
									52.779882812500006
								],
								[
									-81.35224609374998,
									52.852001953124955
								],
								[
									-81.83906249999995,
									52.95791015625005
								],
								[
									-82.00502929687502,
									53.010498046875
								],
								[
									-82.03925781249998,
									53.04990234374995
								],
								[
									-81.95112304687495,
									53.13222656249994
								],
								[
									-81.90136718749994,
									53.165576171875074
								],
								[
									-81.84731445312497,
									53.18627929687503
								],
								[
									-81.33535156250002,
									53.22426757812502
								],
								[
									-81.135595703125,
									53.205810546875
								],
								[
									-80.90039062499994,
									53.03715820312493
								],
								[
									-80.76533203124998,
									52.923242187499994
								],
								[
									-80.71044921874997,
									52.831591796875074
								],
								[
									-80.70952148437496,
									52.78740234375002
								],
								[
									-80.73168945312494,
									52.74726562500001
								]
							]
						],
						[
							[
								[
									-131.7537109375,
									53.19555664062506
								],
								[
									-131.65234375000003,
									53.102978515624926
								],
								[
									-131.62216796875,
									53.0200683593751
								],
								[
									-131.63466796874997,
									52.922167968750045
								],
								[
									-131.795263671875,
									52.88505859375002
								],
								[
									-131.8796875,
									52.91464843750012
								],
								[
									-131.91635742187498,
									52.909130859374955
								],
								[
									-131.97177734374998,
									52.87983398437504
								],
								[
									-131.90439453125003,
									52.866699218750114
								],
								[
									-131.81005859375,
									52.818701171875006
								],
								[
									-131.727294921875,
									52.75639648437493
								],
								[
									-131.61059570312494,
									52.74521484375006
								],
								[
									-131.45522460937502,
									52.701708984375074
								],
								[
									-131.572802734375,
									52.6233398437501
								],
								[
									-131.59057617187494,
									52.578222656250034
								],
								[
									-131.44389648437502,
									52.4533203125001
								],
								[
									-131.42998046875002,
									52.42211914062503
								],
								[
									-131.38300781250004,
									52.41572265624998
								],
								[
									-131.27363281250007,
									52.425830078125074
								],
								[
									-131.25971679687495,
									52.41591796875002
								],
								[
									-131.2599609375,
									52.39003906250008
								],
								[
									-131.32705078125002,
									52.31752929687505
								],
								[
									-131.31992187499998,
									52.30307617187495
								],
								[
									-131.25917968749997,
									52.29165039062502
								],
								[
									-131.142626953125,
									52.29111328125009
								],
								[
									-131.11616210937504,
									52.21909179687498
								],
								[
									-131.221533203125,
									52.15361328124996
								],
								[
									-131.42187499999997,
									52.23798828125001
								],
								[
									-131.51113281250002,
									52.322070312500074
								],
								[
									-131.56206054687502,
									52.39995117187496
								],
								[
									-131.62368164062497,
									52.443994140624966
								],
								[
									-131.80966796875,
									52.54169921875007
								],
								[
									-132.092236328125,
									52.75278320312509
								],
								[
									-132.16508789062493,
									52.78330078125009
								],
								[
									-132.23857421875,
									52.86679687499995
								],
								[
									-132.2599609375,
									52.90698242187506
								],
								[
									-132.25810546875,
									52.93388671875002
								],
								[
									-132.22954101562502,
									52.94809570312509
								],
								[
									-132.14492187500002,
									52.95747070312504
								],
								[
									-132.14375000000004,
									52.999316406250045
								],
								[
									-132.46870117187498,
									53.07187500000006
								],
								[
									-132.50483398437495,
									53.08671874999999
								],
								[
									-132.54677734375,
									53.137500000000045
								],
								[
									-132.52421875000002,
									53.14492187500002
								],
								[
									-132.34541015625,
									53.136083984375006
								],
								[
									-132.15390624999998,
									53.160498046875006
								],
								[
									-132.03593750000002,
									53.17915039062507
								],
								[
									-131.98950195312497,
									53.20195312499993
								],
								[
									-131.89311523437496,
									53.231445312500085
								],
								[
									-131.85346679687507,
									53.229736328125085
								],
								[
									-131.7537109375,
									53.19555664062506
								]
							]
						],
						[
							[
								[
									-128.55244140624998,
									52.939746093750074
								],
								[
									-128.50654296875007,
									52.62070312500009
								],
								[
									-128.50991210937502,
									52.518603515625074
								],
								[
									-128.57680664062497,
									52.45180664062505
								],
								[
									-128.6240234375,
									52.33989257812499
								],
								[
									-128.678955078125,
									52.28964843750006
								],
								[
									-128.730908203125,
									52.356542968750006
								],
								[
									-128.73554687499998,
									52.46772460937501
								],
								[
									-128.74941406249997,
									52.556054687499966
								],
								[
									-128.76645507812498,
									52.59838867187506
								],
								[
									-128.74633789062494,
									52.763378906249926
								],
								[
									-128.76962890625,
									52.75122070312494
								],
								[
									-128.83120117187502,
									52.67880859375012
								],
								[
									-128.89980468749997,
									52.673828125000085
								],
								[
									-129.02285156249997,
									52.75595703125012
								],
								[
									-129.08471679687497,
									52.82246093750007
								],
								[
									-129.09487304687502,
									52.891845703125085
								],
								[
									-129.175927734375,
									52.96494140625006
								],
								[
									-129.184326171875,
									52.99067382812504
								],
								[
									-129.177685546875,
									53.017919921875006
								],
								[
									-129.111083984375,
									53.09067382812509
								],
								[
									-129.08408203125003,
									53.139697265625045
								],
								[
									-129.0603515625,
									53.240624999999994
								],
								[
									-129.033251953125,
									53.27993164062511
								],
								[
									-128.97021484375,
									53.27436523437504
								],
								[
									-128.85771484375,
									53.22856445312493
								],
								[
									-128.740380859375,
									53.17885742187502
								],
								[
									-128.63266601562498,
									53.1125000000001
								],
								[
									-128.55244140624998,
									52.939746093750074
								]
							]
						],
						[
							[
								[
									-129.167724609375,
									53.11787109375004
								],
								[
									-129.17324218749997,
									53.110742187499994
								],
								[
									-129.27685546875006,
									53.11093749999995
								],
								[
									-129.305712890625,
									53.12114257812499
								],
								[
									-129.32387695312502,
									53.1421386718751
								],
								[
									-129.33125,
									53.17397460937508
								],
								[
									-129.31435546874997,
									53.212304687499994
								],
								[
									-129.253076171875,
									53.28549804687506
								],
								[
									-129.25117187500007,
									53.316699218750045
								],
								[
									-129.23818359374997,
									53.330078125000085
								],
								[
									-129.19521484375002,
									53.29321289062506
								],
								[
									-129.17700195312506,
									53.259130859375034
								],
								[
									-129.167724609375,
									53.11787109375004
								]
							]
						],
						[
							[
								[
									-79.93823242187494,
									53.30415039062507
								],
								[
									-79.939306640625,
									53.274267578125006
								],
								[
									-80.00410156249995,
									53.280078125000045
								],
								[
									-80.03935546874996,
									53.29716796874996
								],
								[
									-80.06787109375,
									53.324072265625034
								],
								[
									-80.07402343749999,
									53.344287109375074
								],
								[
									-80.04970703125002,
									53.3644531250001
								],
								[
									-79.97456054687498,
									53.3522460937501
								],
								[
									-79.93823242187494,
									53.30415039062507
								]
							]
						],
						[
							[
								[
									-129.84858398437498,
									53.167919921874926
								],
								[
									-129.86855468749997,
									53.16450195312504
								],
								[
									-129.934375,
									53.17666015625002
								],
								[
									-130.15141601562496,
									53.345703125000085
								],
								[
									-130.30566406250003,
									53.40737304687502
								],
								[
									-130.41074218750003,
									53.49082031249998
								],
								[
									-130.51757812500003,
									53.54423828125002
								],
								[
									-130.45200195312498,
									53.631152343750074
								],
								[
									-130.39482421875,
									53.6204101562501
								],
								[
									-130.19501953125004,
									53.54965820312498
								],
								[
									-130.03540039062503,
									53.48110351562505
								],
								[
									-129.94472656250002,
									53.43637695312509
								],
								[
									-129.75483398437498,
									53.24477539062505
								],
								[
									-129.76894531250002,
									53.21728515624994
								],
								[
									-129.84858398437498,
									53.167919921874926
								]
							]
						],
						[
							[
								[
									-130.236279296875,
									53.958544921875045
								],
								[
									-130.26723632812502,
									53.922607421875114
								],
								[
									-130.33754882812497,
									53.866259765625074
								],
								[
									-130.38422851562504,
									53.84394531249998
								],
								[
									-130.40722656250003,
									53.85551757812502
								],
								[
									-130.470263671875,
									53.86176757812507
								],
								[
									-130.53750000000002,
									53.91787109374994
								],
								[
									-130.58984375,
									53.94028320312498
								],
								[
									-130.62460937499998,
									53.94140624999994
								],
								[
									-130.64184570312506,
									53.921142578125085
								],
								[
									-130.64628906249996,
									53.89404296874997
								],
								[
									-130.637890625,
									53.860009765624966
								],
								[
									-130.64370117187497,
									53.84453125000002
								],
								[
									-130.66357421875003,
									53.84755859375011
								],
								[
									-130.68344726562498,
									53.86347656250004
								],
								[
									-130.703173828125,
									53.89223632812505
								],
								[
									-130.70727539062494,
									53.92148437500006
								],
								[
									-130.695703125,
									53.95126953125009
								],
								[
									-130.646923828125,
									53.991259765625074
								],
								[
									-130.49462890624997,
									54.07416992187498
								],
								[
									-130.447998046875,
									54.089013671874994
								],
								[
									-130.39731445312503,
									54.08569335937503
								],
								[
									-130.31586914062495,
									54.046923828125045
								],
								[
									-130.29848632812497,
									54.03564453125006
								],
								[
									-130.236279296875,
									53.958544921875045
								]
							]
						],
						[
							[
								[
									-132.65551757812503,
									54.12749023437502
								],
								[
									-132.56406250000003,
									54.06865234374993
								],
								[
									-132.34443359374998,
									54.10605468750009
								],
								[
									-132.30336914062497,
									54.09887695312506
								],
								[
									-132.26162109374997,
									54.07631835937508
								],
								[
									-132.21591796874998,
									54.02841796875009
								],
								[
									-132.16611328124998,
									53.95522460937508
								],
								[
									-132.15512695312503,
									53.875195312499955
								],
								[
									-132.17509765625005,
									53.84653320312498
								],
								[
									-132.21450195312497,
									53.814746093750074
								],
								[
									-132.56489257812504,
									53.68764648437494
								],
								[
									-132.57412109374997,
									53.67539062500009
								],
								[
									-132.56713867187494,
									53.663964843749994
								],
								[
									-132.53466796875,
									53.65170898437506
								],
								[
									-132.464404296875,
									53.65332031250006
								],
								[
									-132.18696289062507,
									53.68481445312506
								],
								[
									-132.17167968749996,
									53.70683593749993
								],
								[
									-132.15224609375,
									53.80698242187509
								],
								[
									-132.114013671875,
									53.860156250000074
								],
								[
									-132.11059570312503,
									53.90029296875008
								],
								[
									-132.13588867187502,
									53.995849609375114
								],
								[
									-132.13442382812502,
									54.034277343750034
								],
								[
									-131.9408203125,
									54.0419921875
								],
								[
									-131.81962890625,
									54.077343749999926
								],
								[
									-131.69594726562502,
									54.143164062500006
								],
								[
									-131.66762695312502,
									54.141357421875
								],
								[
									-131.685400390625,
									54.022802734375006
								],
								[
									-131.70253906250002,
									53.986376953125045
								],
								[
									-131.82114257812503,
									53.841503906249926
								],
								[
									-131.88916015625006,
									53.71396484375006
								],
								[
									-131.92231445312504,
									53.58789062500003
								],
								[
									-131.92807617187498,
									53.379199218750074
								],
								[
									-131.95742187500002,
									53.308691406250006
								],
								[
									-132.01132812499998,
									53.26518554687493
								],
								[
									-132.34726562500003,
									53.189208984375
								],
								[
									-132.52045898437504,
									53.19404296875001
								],
								[
									-132.67480468749994,
									53.26318359374997
								],
								[
									-132.747509765625,
									53.310498046874926
								],
								[
									-132.692578125,
									53.36787109374998
								],
								[
									-132.65478515624997,
									53.3705566406251
								],
								[
									-132.54624023437498,
									53.35927734375011
								],
								[
									-132.46240234375003,
									53.337890625
								],
								[
									-132.42500000000007,
									53.33696289062499
								],
								[
									-132.43134765625,
									53.35043945312498
								],
								[
									-132.670166015625,
									53.45859375000009
								],
								[
									-132.84501953125,
									53.50771484375005
								],
								[
									-132.89799804687496,
									53.56269531250007
								],
								[
									-132.89956054687502,
									53.60537109375005
								],
								[
									-132.91337890625,
									53.62919921874993
								],
								[
									-133.05224609375003,
									53.778125000000074
								],
								[
									-133.07949218749997,
									53.83701171875009
								],
								[
									-133.09765625000006,
									53.92026367187506
								],
								[
									-133.09794921875002,
									54.00561523437506
								],
								[
									-133.0638671875,
									54.144042968750114
								],
								[
									-133.04838867187493,
									54.15893554687503
								],
								[
									-132.991455078125,
									54.15781249999998
								],
								[
									-132.89306640625,
									54.140771484374966
								],
								[
									-132.65551757812503,
									54.12749023437502
								]
							]
						],
						[
							[
								[
									-130.92714843749997,
									54.47905273437496
								],
								[
									-130.95029296874998,
									54.47778320312497
								],
								[
									-130.959033203125,
									54.498681640624966
								],
								[
									-130.95346679687503,
									54.54184570312506
								],
								[
									-130.92177734374997,
									54.61489257812511
								],
								[
									-130.90683593750003,
									54.63178710937507
								],
								[
									-130.77705078125007,
									54.61889648437494
								],
								[
									-130.75800781249998,
									54.61376953125006
								],
								[
									-130.75341796875003,
									54.599707031250034
								],
								[
									-130.76337890625,
									54.57670898437496
								],
								[
									-130.805126953125,
									54.543798828125006
								],
								[
									-130.92714843749997,
									54.47905273437496
								]
							]
						],
						[
							[
								[
									-130.575341796875,
									54.76967773437502
								],
								[
									-130.49326171874998,
									54.834179687499926
								],
								[
									-130.312548828125,
									54.94594726562505
								],
								[
									-130.2140625,
									55.025878906250085
								],
								[
									-130.20390625,
									54.947021484375
								],
								[
									-130.3494140625,
									54.814550781250006
								],
								[
									-130.53549804687503,
									54.748730468749926
								],
								[
									-130.575341796875,
									54.76967773437502
								]
							]
						],
						[
							[
								[
									-60.994482421875006,
									56.03930664062494
								],
								[
									-60.98271484375002,
									56.01513671875
								],
								[
									-61.13701171874999,
									56.03256835937509
								],
								[
									-61.191308593749966,
									56.0478515625
								],
								[
									-61.19584960937499,
									56.06391601562498
								],
								[
									-61.188183593749955,
									56.088964843750034
								],
								[
									-61.157568359375006,
									56.11835937500007
								],
								[
									-61.0869140625,
									56.14082031250001
								],
								[
									-61.04853515625001,
									56.12924804687498
								],
								[
									-60.96640624999998,
									56.0988281250001
								],
								[
									-60.95537109374993,
									56.08041992187498
								],
								[
									-60.994482421875006,
									56.03930664062494
								]
							]
						],
						[
							[
								[
									-78.82651367187495,
									56.14531249999996
								],
								[
									-78.877294921875,
									56.13144531249998
								],
								[
									-78.91381835937497,
									56.132812500000085
								],
								[
									-78.90703125000002,
									56.16635742187506
								],
								[
									-78.85688476562501,
									56.232080078124966
								],
								[
									-78.82841796874999,
									56.2898437500001
								],
								[
									-78.82158203125002,
									56.33964843750002
								],
								[
									-78.79941406250003,
									56.38330078125003
								],
								[
									-78.76186523437502,
									56.42070312499993
								],
								[
									-78.72451171874997,
									56.43920898437497
								],
								[
									-78.66874999999996,
									56.43862304687494
								],
								[
									-78.65717773437501,
									56.31738281250003
								],
								[
									-78.67280273437498,
									56.26049804687506
								],
								[
									-78.71015624999995,
									56.21289062500006
								],
								[
									-78.761376953125,
									56.174511718749955
								],
								[
									-78.82651367187495,
									56.14531249999996
								]
							]
						],
						[
							[
								[
									-79.97758789062499,
									56.207031250000114
								],
								[
									-80.02861328124999,
									56.19941406250007
								],
								[
									-80.0888671875,
									56.213867187500085
								],
								[
									-80.057470703125,
									56.28735351562494
								],
								[
									-80.00507812499998,
									56.317919921875045
								],
								[
									-79.87446289062493,
									56.348437500000045
								],
								[
									-79.8521484375,
									56.36718750000006
								],
								[
									-79.81040039062503,
									56.37651367187499
								],
								[
									-79.749169921875,
									56.37651367187499
								],
								[
									-79.68100585937495,
									56.40395507812508
								],
								[
									-79.60585937500002,
									56.45883789062498
								],
								[
									-79.57973632812502,
									56.466357421875074
								],
								[
									-79.63256835937503,
									56.38652343749999
								],
								[
									-79.68793945312495,
									56.32680664062508
								],
								[
									-79.97758789062499,
									56.207031250000114
								]
							]
						],
						[
							[
								[
									-78.93559570312496,
									56.266064453124955
								],
								[
									-79.01796874999997,
									56.16499023437507
								],
								[
									-79.08388671875,
									56.067871093750085
								],
								[
									-79.17548828124998,
									55.88505859374996
								],
								[
									-79.22783203124999,
									55.87851562500006
								],
								[
									-79.27363281250001,
									55.92246093749995
								],
								[
									-79.14228515624998,
									56.136425781249926
								],
								[
									-79.13608398437495,
									56.16025390625006
								],
								[
									-79.14228515624998,
									56.180712890625074
								],
								[
									-79.18212890625003,
									56.212158203125085
								],
								[
									-79.22182617187502,
									56.17597656250007
								],
								[
									-79.40742187499998,
									55.93486328124999
								],
								[
									-79.45532226562497,
									55.896191406249926
								],
								[
									-79.4951171875,
									55.874755859375
								],
								[
									-79.52675781249997,
									55.87065429687496
								],
								[
									-79.60571289062497,
									55.87568359375001
								],
								[
									-79.76474609374995,
									55.80678710937511
								],
								[
									-79.49746093749997,
									56.093164062499994
								],
								[
									-79.49467773437502,
									56.114990234375
								],
								[
									-79.54472656249999,
									56.12836914062507
								],
								[
									-79.56455078125003,
									56.12094726562506
								],
								[
									-79.781103515625,
									55.940576171874994
								],
								[
									-79.90458984374993,
									55.871044921874955
								],
								[
									-79.98749999999995,
									55.89213867187499
								],
								[
									-80.00825195312501,
									55.91103515625002
								],
								[
									-80.00078124999999,
									55.932080078124955
								],
								[
									-79.79003906249997,
									56.11416015625011
								],
								[
									-79.59633789062502,
									56.244482421875006
								],
								[
									-79.51528320312494,
									56.32651367187512
								],
								[
									-79.48237304687498,
									56.40380859375006
								],
								[
									-79.46791992187497,
									56.46035156250002
								],
								[
									-79.46894531250001,
									56.522607421874994
								],
								[
									-79.45888671875,
									56.53974609375004
								],
								[
									-79.44765625000002,
									56.5365722656251
								],
								[
									-79.435302734375,
									56.513037109375006
								],
								[
									-79.43203124999994,
									56.44746093750007
								],
								[
									-79.47626953124998,
									56.31284179687506
								],
								[
									-79.51181640625003,
									56.246582031250085
								],
								[
									-79.55419921874997,
									56.19199218750006
								],
								[
									-79.53632812499995,
									56.18007812499994
								],
								[
									-79.45830078124996,
									56.21108398437505
								],
								[
									-79.39262695312499,
									56.27646484374995
								],
								[
									-79.33935546874997,
									56.37631835937495
								],
								[
									-79.30532226562497,
									56.463085937499955
								],
								[
									-79.27241210937493,
									56.600439453125034
								],
								[
									-79.26113281249994,
									56.595654296874955
								],
								[
									-79.24575195312502,
									56.56826171875005
								],
								[
									-79.21044921875,
									56.548925781250034
								],
								[
									-79.15517578124994,
									56.53759765624994
								],
								[
									-79.12353515624997,
									56.5199707031251
								],
								[
									-79.10024414062494,
									56.47392578125002
								],
								[
									-79.07773437499998,
									56.45361328124997
								],
								[
									-78.99497070312498,
									56.43642578124994
								],
								[
									-78.96318359374999,
									56.42172851562506
								],
								[
									-78.94033203124997,
									56.37143554687512
								],
								[
									-78.94243164062493,
									56.34492187500004
								],
								[
									-78.93120117187496,
									56.327929687500045
								],
								[
									-78.90664062500002,
									56.32041015625012
								],
								[
									-78.93559570312496,
									56.266064453124955
								]
							]
						],
						[
							[
								[
									-79.5181640625,
									56.656689453124955
								],
								[
									-79.553466796875,
									56.6438476562501
								],
								[
									-79.57739257812497,
									56.64492187500005
								],
								[
									-79.55073242187498,
									56.73349609374998
								],
								[
									-79.58173828124998,
									56.76484375000007
								],
								[
									-79.58354492187499,
									56.78095703125004
								],
								[
									-79.57011718750002,
									56.795703125000045
								],
								[
									-79.55288085937497,
									56.79873046874994
								],
								[
									-79.51123046875,
									56.77143554687507
								],
								[
									-79.49106445312498,
									56.74267578125006
								],
								[
									-79.48217773437494,
									56.71440429687499
								],
								[
									-79.48457031249998,
									56.6865234375
								],
								[
									-79.49653320312495,
									56.66728515624999
								],
								[
									-79.5181640625,
									56.656689453124955
								]
							]
						],
						[
							[
								[
									-79.86699218750002,
									56.774560546874994
								],
								[
									-79.89448242187501,
									56.75712890624999
								],
								[
									-79.94365234374999,
									56.776757812499994
								],
								[
									-79.94570312499997,
									56.826904296875
								],
								[
									-79.89814453124995,
									56.8652832031251
								],
								[
									-79.86054687499993,
									56.863525390625
								],
								[
									-79.82666015624997,
									56.84311523437509
								],
								[
									-79.83500976562499,
									56.81601562500009
								],
								[
									-79.86699218750002,
									56.774560546874994
								]
							]
						],
						[
							[
								[
									-61.743603515624955,
									57.55458984375011
								],
								[
									-61.65952148437495,
									57.52495117187502
								],
								[
									-61.63749999999999,
									57.416064453125045
								],
								[
									-61.79526367187498,
									57.422460937500006
								],
								[
									-61.97548828125002,
									57.495410156250045
								],
								[
									-62.01123046875003,
									57.54848632812511
								],
								[
									-62.007226562499994,
									57.5576171875
								],
								[
									-61.98330078125002,
									57.56674804687509
								],
								[
									-61.9375,
									57.554101562499994
								],
								[
									-61.89306640625003,
									57.573144531249966
								],
								[
									-61.848339843749955,
									57.579345703125085
								],
								[
									-61.743603515624955,
									57.55458984375011
								]
							]
						],
						[
							[
								[
									-79.71650390624998,
									57.51552734375005
								],
								[
									-79.73222656249999,
									57.507519531249926
								],
								[
									-79.77519531249996,
									57.5144531250001
								],
								[
									-79.79204101562502,
									57.44858398437509
								],
								[
									-79.80844726562498,
									57.44243164062499
								],
								[
									-79.838232421875,
									57.48300781250009
								],
								[
									-79.81591796875,
									57.51772460937505
								],
								[
									-79.81914062499993,
									57.541601562500034
								],
								[
									-79.81083984374993,
									57.55927734374998
								],
								[
									-79.76787109374999,
									57.598730468750034
								],
								[
									-79.74257812499997,
									57.60795898437496
								],
								[
									-79.72670898437502,
									57.60458984374998
								],
								[
									-79.7134765625,
									57.555029296875006
								],
								[
									-79.71650390624998,
									57.51552734375005
								]
							]
						],
						[
							[
								[
									-69.16005859375,
									59.04023437499998
								],
								[
									-69.22084960937494,
									58.96757812500002
								],
								[
									-69.30170898437498,
									58.97661132812499
								],
								[
									-69.33081054687497,
									58.961621093749955
								],
								[
									-69.35283203125002,
									58.960742187500045
								],
								[
									-69.31630859374994,
									59.028955078124994
								],
								[
									-69.31152343750003,
									59.074804687500006
								],
								[
									-69.32998046874997,
									59.121240234374966
								],
								[
									-69.30322265625003,
									59.14487304687498
								],
								[
									-69.19516601562495,
									59.14614257812505
								],
								[
									-69.19379882812495,
									59.09277343749994
								],
								[
									-69.18066406250003,
									59.07270507812501
								],
								[
									-69.15517578124997,
									59.063574218750034
								],
								[
									-69.16005859375,
									59.04023437499998
								]
							]
						],
						[
							[
								[
									-80.28525390624995,
									59.624121093750006
								],
								[
									-80.31723632812498,
									59.62104492187501
								],
								[
									-80.32465820312498,
									59.633203124999994
								],
								[
									-80.298974609375,
									59.67416992187509
								],
								[
									-80.25664062499999,
									59.67915039062504
								],
								[
									-80.20996093749997,
									59.72460937500006
								],
								[
									-80.16723632812497,
									59.70888671875005
								],
								[
									-80.18305664062501,
									59.68349609374994
								],
								[
									-80.24052734374999,
									59.64492187500008
								],
								[
									-80.28525390624995,
									59.624121093750006
								]
							]
						],
						[
							[
								[
									-80.06420898437494,
									59.77080078124996
								],
								[
									-80.16708984375003,
									59.76386718750007
								],
								[
									-80.12221679687497,
									59.82319335937507
								],
								[
									-80.083642578125,
									59.851855468750045
								],
								[
									-80.04116210937497,
									59.870166015625045
								],
								[
									-79.95585937499999,
									59.876953125
								],
								[
									-79.89863281249998,
									59.85312499999995
								],
								[
									-79.94960937499997,
									59.80991210937512
								],
								[
									-80.06420898437494,
									59.77080078124996
								]
							]
						],
						[
							[
								[
									-64.40703124999996,
									60.36708984374994
								],
								[
									-64.44194335937499,
									60.29785156250003
								],
								[
									-64.55820312500003,
									60.32324218749997
								],
								[
									-64.73793945312497,
									60.375634765624994
								],
								[
									-64.80898437499997,
									60.41040039062497
								],
								[
									-64.83378906249996,
									60.44843749999998
								],
								[
									-64.83642578124997,
									60.50102539062496
								],
								[
									-64.782568359375,
									60.50961914062512
								],
								[
									-64.64628906249996,
									60.51459960937507
								],
								[
									-64.53251953124996,
									60.44140624999997
								],
								[
									-64.49980468749996,
									60.4302246093751
								],
								[
									-64.40703124999996,
									60.36708984374994
								]
							]
						],
						[
							[
								[
									-68.23378906250002,
									60.24091796874998
								],
								[
									-68.32412109374997,
									60.23291015625006
								],
								[
									-68.36523437499997,
									60.254052734374994
								],
								[
									-68.36787109374998,
									60.31474609375002
								],
								[
									-68.33828125,
									60.36059570312494
								],
								[
									-68.23476562499997,
									60.45556640625003
								],
								[
									-68.14189453124996,
									60.56201171874994
								],
								[
									-68.08759765625001,
									60.58784179687507
								],
								[
									-67.97802734374997,
									60.57041015625006
								],
								[
									-67.91420898437502,
									60.53984374999996
								],
								[
									-67.84755859374994,
									60.48881835937496
								],
								[
									-67.81884765624997,
									60.44951171875013
								],
								[
									-67.84423828124997,
									60.39165039062496
								],
								[
									-67.92231445312498,
									60.33989257812499
								],
								[
									-68.01230468750003,
									60.30463867187501
								],
								[
									-68.23378906250002,
									60.24091796874998
								]
							]
						],
						[
							[
								[
									-78.53164062500002,
									60.728564453125045
								],
								[
									-78.66889648437498,
									60.71689453125006
								],
								[
									-78.66909179687494,
									60.73134765625008
								],
								[
									-78.61201171874995,
									60.77231445312498
								],
								[
									-78.39956054687502,
									60.808105468750085
								],
								[
									-78.24169921875,
									60.8186523437501
								],
								[
									-78.27885742187493,
									60.78388671875004
								],
								[
									-78.3724609375,
									60.75639648437502
								],
								[
									-78.53164062500002,
									60.728564453125045
								]
							]
						],
						[
							[
								[
									-64.83261718749998,
									61.36606445312498
								],
								[
									-64.85683593749994,
									61.35444335937501
								],
								[
									-64.87978515625,
									61.35708007812511
								],
								[
									-64.954248046875,
									61.41040039062494
								],
								[
									-65.05439453124995,
									61.432031249999994
								],
								[
									-65.09150390624998,
									61.452978515625006
								],
								[
									-65.39389648437503,
									61.562841796875006
								],
								[
									-65.42680664062499,
									61.61103515625004
								],
								[
									-65.43212890625,
									61.64951171875006
								],
								[
									-65.33164062499995,
									61.66826171874999
								],
								[
									-65.12978515624997,
									61.68569335937508
								],
								[
									-64.95444335937503,
									61.68510742187496
								],
								[
									-64.78964843750003,
									61.66220703125009
								],
								[
									-64.75634765625,
									61.63764648437507
								],
								[
									-64.669580078125,
									61.59301757812503
								],
								[
									-64.69096679687499,
									61.53935546875002
								],
								[
									-64.69638671875003,
									61.47148437499996
								],
								[
									-64.73232421875,
									61.43842773437507
								],
								[
									-64.78759765624997,
									61.4132812500001
								],
								[
									-64.83261718749998,
									61.36606445312498
								]
							]
						],
						[
							[
								[
									-93.0439453125,
									61.84409179687509
								],
								[
									-93.08481445312498,
									61.841699218749966
								],
								[
									-93.17656250000002,
									61.89272460937505
								],
								[
									-93.19667968750002,
									61.91855468750009
								],
								[
									-93.07578124999998,
									61.93500976562507
								],
								[
									-92.993017578125,
									61.889697265625074
								],
								[
									-92.99995117187498,
									61.86748046874999
								],
								[
									-93.0439453125,
									61.84409179687509
								]
							]
						],
						[
							[
								[
									-65.03056640624999,
									61.87905273437494
								],
								[
									-65.00805664062503,
									61.87026367187502
								],
								[
									-64.98105468750003,
									61.880615234375
								],
								[
									-64.96054687500003,
									61.87167968749995
								],
								[
									-64.94667968749997,
									61.84335937499995
								],
								[
									-64.92353515624995,
									61.82373046875003
								],
								[
									-64.86513671874994,
									61.798144531250074
								],
								[
									-64.84550781249996,
									61.77988281250009
								],
								[
									-64.8470703125,
									61.761523437500074
								],
								[
									-64.89658203124995,
									61.73330078125008
								],
								[
									-64.927734375,
									61.73251953125012
								],
								[
									-65.16591796874994,
									61.797656250000045
								],
								[
									-65.23027343749999,
									61.864013671875085
								],
								[
									-65.23535156249997,
									61.897705078125114
								],
								[
									-65.21054687499998,
									61.92836914062505
								],
								[
									-65.17392578124998,
									61.943212890625034
								],
								[
									-65.125634765625,
									61.942236328125034
								],
								[
									-65.06835937499997,
									61.926025390625085
								],
								[
									-65.03056640624999,
									61.87905273437494
								]
							]
						],
						[
							[
								[
									-79.54531250000002,
									62.41171875000009
								],
								[
									-79.4662109375,
									62.38452148437506
								],
								[
									-79.33603515625,
									62.29370117187503
								],
								[
									-79.28647460937495,
									62.24765625000006
								],
								[
									-79.27202148437493,
									62.18598632812504
								],
								[
									-79.30644531249993,
									62.10351562500003
								],
								[
									-79.32392578124995,
									62.02607421875004
								],
								[
									-79.37226562499993,
									61.967773437500085
								],
								[
									-79.46215820312494,
									61.89409179687499
								],
								[
									-79.54184570312503,
									61.80800781250002
								],
								[
									-79.61132812499997,
									61.70961914062505
								],
								[
									-79.66874999999993,
									61.64443359375002
								],
								[
									-79.71425781249997,
									61.612548828125
								],
								[
									-79.76333007812502,
									61.595947265625
								],
								[
									-79.81611328124995,
									61.594628906249994
								],
								[
									-79.89633789062503,
									61.63012695312494
								],
								[
									-80.00415039062497,
									61.70253906250005
								],
								[
									-80.09199218750001,
									61.746826171875
								],
								[
									-80.20493164062503,
									61.77724609375008
								],
								[
									-80.26518554687496,
									61.81821289062498
								],
								[
									-80.27617187499996,
									61.858593749999955
								],
								[
									-80.27983398437502,
									61.98950195312497
								],
								[
									-80.27509765625001,
									62.054638671874926
								],
								[
									-80.26005859374996,
									62.109033203124994
								],
								[
									-80.23466796874996,
									62.152685546875006
								],
								[
									-80.17856445312498,
									62.212792968749994
								],
								[
									-80.02158203124998,
									62.342968749999955
								],
								[
									-79.92675781250003,
									62.39287109374999
								],
								[
									-79.86806640624997,
									62.40434570312502
								],
								[
									-79.712548828125,
									62.395019531250085
								],
								[
									-79.64956054687494,
									62.39829101562495
								],
								[
									-79.59765625000003,
									62.413232421874966
								],
								[
									-79.54531250000002,
									62.41171875000009
								]
							]
						],
						[
							[
								[
									-64.82382812499998,
									62.55874023437502
								],
								[
									-64.63183593750003,
									62.54799804687508
								],
								[
									-64.51533203125001,
									62.55180664062496
								],
								[
									-64.46503906249998,
									62.5359375000001
								],
								[
									-64.41806640625,
									62.48740234374998
								],
								[
									-64.47832031250002,
									62.41787109374994
								],
								[
									-64.54648437499995,
									62.39140624999996
								],
								[
									-64.65742187500001,
									62.383593750000045
								],
								[
									-64.83730468749997,
									62.40624999999997
								],
								[
									-64.901220703125,
									62.421044921874966
								],
								[
									-64.95649414062501,
									62.458349609375006
								],
								[
									-64.93076171875,
									62.48500976562494
								],
								[
									-64.84194335937502,
									62.49414062500003
								],
								[
									-64.82709960937501,
									62.504980468750006
								],
								[
									-64.84985351562503,
									62.5254394531251
								],
								[
									-64.848779296875,
									62.543310546875006
								],
								[
									-64.82382812499998,
									62.55874023437502
								]
							]
						],
						[
							[
								[
									-74.00043945312495,
									62.61840820312503
								],
								[
									-74.05356445312495,
									62.60966796875002
								],
								[
									-74.253515625,
									62.62197265625005
								],
								[
									-74.49951171875003,
									62.66879882812506
								],
								[
									-74.62646484374997,
									62.71274414062506
								],
								[
									-74.61997070312498,
									62.72631835937506
								],
								[
									-74.56420898437497,
									62.73330078125008
								],
								[
									-74.50092773437495,
									62.726513671874926
								],
								[
									-74.394775390625,
									62.69580078125006
								],
								[
									-74.10893554687496,
									62.68032226562494
								],
								[
									-74.01679687500001,
									62.66269531250006
								],
								[
									-73.98818359374997,
									62.63608398437498
								],
								[
									-74.00043945312495,
									62.61840820312503
								]
							]
						],
						[
							[
								[
									-70.33706054687497,
									62.54873046875005
								],
								[
									-70.40634765624998,
									62.54482421875005
								],
								[
									-70.54150390624997,
									62.55234374999998
								],
								[
									-70.68657226562496,
									62.573193359374955
								],
								[
									-70.76606445312498,
									62.59687499999998
								],
								[
									-70.83754882812497,
									62.64809570312494
								],
								[
									-70.85126953125001,
									62.70434570312494
								],
								[
									-70.98613281249996,
									62.78779296874998
								],
								[
									-71.13691406249995,
									62.81591796874994
								],
								[
									-71.22011718750002,
									62.87392578124994
								],
								[
									-71.13486328124998,
									62.877978515625045
								],
								[
									-71.01367187499997,
									62.86533203125006
								],
								[
									-70.834619140625,
									62.84008789062497
								],
								[
									-70.67431640625003,
									62.807031249999994
								],
								[
									-70.442626953125,
									62.733789062499994
								],
								[
									-70.366796875,
									62.6658203125001
								],
								[
									-70.29150390625003,
									62.61596679687497
								],
								[
									-70.26884765625002,
									62.57807617187498
								],
								[
									-70.28857421874994,
									62.56157226562499
								],
								[
									-70.33706054687497,
									62.54873046875005
								]
							]
						],
						[
							[
								[
									-82.00048828124997,
									62.95419921874995
								],
								[
									-81.960546875,
									62.92622070312504
								],
								[
									-81.94858398437498,
									62.88403320312506
								],
								[
									-81.96440429687502,
									62.827636718750114
								],
								[
									-81.99018554687501,
									62.776318359374955
								],
								[
									-82.02583007812498,
									62.73007812499995
								],
								[
									-82.11372070312495,
									62.652246093749994
								],
								[
									-82.38803710937498,
									62.51914062500006
								],
								[
									-82.490966796875,
									62.44658203125002
								],
								[
									-82.56826171875002,
									62.403222656249966
								],
								[
									-83.01582031249998,
									62.20991210937501
								],
								[
									-83.07138671875,
									62.200390624999955
								],
								[
									-83.12968749999999,
									62.2041015625
								],
								[
									-83.25239257812495,
									62.23295898437502
								],
								[
									-83.37680664062498,
									62.238134765625006
								],
								[
									-83.69887695312497,
									62.16025390624995
								],
								[
									-83.71440429687502,
									62.173583984375
								],
								[
									-83.72861328124998,
									62.25717773437498
								],
								[
									-83.76093749999998,
									62.303515625000074
								],
								[
									-83.90312499999999,
									62.402490234374994
								],
								[
									-83.91240234374993,
									62.425537109375085
								],
								[
									-83.910498046875,
									62.45415039062496
								],
								[
									-83.899267578125,
									62.476464843749966
								],
								[
									-83.73906249999996,
									62.56884765625006
								],
								[
									-83.37641601562498,
									62.90493164062505
								],
								[
									-83.28945312499994,
									62.92158203125007
								],
								[
									-83.1109375,
									62.88413085937498
								],
								[
									-83.02626953124997,
									62.872070312500085
								],
								[
									-82.96577148437498,
									62.87392578124994
								],
								[
									-82.70644531250002,
									62.94453125000004
								],
								[
									-82.45971679687503,
									62.93618164062502
								],
								[
									-82.23476562500002,
									62.97744140625008
								],
								[
									-82.129248046875,
									62.97768554687494
								],
								[
									-82.047607421875,
									62.970556640625006
								],
								[
									-82.00048828124997,
									62.95419921874995
								]
							]
						],
						[
							[
								[
									-77.876708984375,
									63.47055664062509
								],
								[
									-77.79208984374998,
									63.42783203125009
								],
								[
									-77.7037109375,
									63.43085937499998
								],
								[
									-77.65478515624997,
									63.395996093750085
								],
								[
									-77.5384765625,
									63.2870605468751
								],
								[
									-77.52729492187495,
									63.26894531250005
								],
								[
									-77.53271484374997,
									63.23364257812503
								],
								[
									-77.59389648437502,
									63.18842773437498
								],
								[
									-77.65766601562495,
									63.1645996093751
								],
								[
									-77.79145507812493,
									63.12958984374998
								],
								[
									-77.94243164062496,
									63.114404296874994
								],
								[
									-78.02441406249997,
									63.13886718750001
								],
								[
									-78.25595703124998,
									63.23984374999998
								],
								[
									-78.46875,
									63.35791015625006
								],
								[
									-78.536767578125,
									63.42373046875005
								],
								[
									-78.50732421875003,
									63.45112304687504
								],
								[
									-78.41728515624999,
									63.46997070312506
								],
								[
									-78.23491210937496,
									63.489550781250045
								],
								[
									-77.933935546875,
									63.478955078124926
								],
								[
									-77.876708984375,
									63.47055664062509
								]
							]
						],
						[
							[
								[
									-76.67758789062503,
									63.39394531250002
								],
								[
									-76.78315429687495,
									63.38403320312494
								],
								[
									-76.92187499999997,
									63.40634765625006
								],
								[
									-77.0572265625,
									63.44975585937502
								],
								[
									-77.36474609374997,
									63.58833007812501
								],
								[
									-77.13369140624997,
									63.682031249999994
								],
								[
									-76.76362304687498,
									63.57358398437512
								],
								[
									-76.65244140624998,
									63.503564453124966
								],
								[
									-76.67758789062503,
									63.39394531250002
								]
							]
						],
						[
							[
								[
									-77.64208984374997,
									63.99189453125007
								],
								[
									-77.71406249999998,
									63.94570312500008
								],
								[
									-77.92880859375003,
									63.96201171875009
								],
								[
									-77.95791015625002,
									63.97602539062504
								],
								[
									-77.96596679687497,
									63.992919921875
								],
								[
									-77.93134765625001,
									64.01479492187494
								],
								[
									-77.71079101562503,
									64.03564453125
								],
								[
									-77.61728515624998,
									64.03720703125006
								],
								[
									-77.56938476562499,
									64.03041992187511
								],
								[
									-77.56362304687497,
									64.02207031250009
								],
								[
									-77.64208984374997,
									63.99189453125007
								]
							]
						],
						[
							[
								[
									-84.91962890624995,
									65.26108398437509
								],
								[
									-84.88510742187503,
									65.24897460937493
								],
								[
									-84.84208984374999,
									65.2559082031251
								],
								[
									-84.77128906249993,
									65.30527343750003
								],
								[
									-84.61250000000001,
									65.4473144531251
								],
								[
									-84.56791992187499,
									65.46064453125007
								],
								[
									-84.50112304687497,
									65.45844726562507
								],
								[
									-84.26640624999993,
									65.36723632812505
								],
								[
									-84.17998046875002,
									65.31630859374997
								],
								[
									-84.13349609374995,
									65.245458984375
								],
								[
									-84.08486328125,
									65.21782226562507
								],
								[
									-83.90009765625001,
									65.18124999999998
								],
								[
									-83.72255859375,
									65.16899414062507
								],
								[
									-83.49077148437502,
									65.13178710937504
								],
								[
									-83.40712890625002,
									65.10390625000002
								],
								[
									-83.22226562500003,
									64.96796875000004
								],
								[
									-83.20097656249996,
									64.95966796874995
								],
								[
									-82.99057617187498,
									64.9041015625001
								],
								[
									-82.667626953125,
									64.78032226562502
								],
								[
									-82.58579101562503,
									64.7619140625001
								],
								[
									-82.27167968749998,
									64.72114257812495
								],
								[
									-82.15888671875001,
									64.69067382812506
								],
								[
									-82.04999999999995,
									64.64428710937511
								],
								[
									-81.92890624999995,
									64.55942382812495
								],
								[
									-81.78720703124998,
									64.42597656250004
								],
								[
									-81.67612304687498,
									64.212646484375
								],
								[
									-81.66738281249997,
									64.17050781249995
								],
								[
									-81.68090820312497,
									64.14555664062502
								],
								[
									-81.72094726562497,
									64.118896484375
								],
								[
									-81.90263671874993,
									64.03125
								],
								[
									-81.88710937499997,
									64.01640624999999
								],
								[
									-81.71611328124996,
									64.02187500000005
								],
								[
									-81.33564453124998,
									64.07578125
								],
								[
									-81.10405273437496,
									64.03710937499994
								],
								[
									-81.023583984375,
									64.03105468749996
								],
								[
									-81.00502929687497,
									64.03330078124998
								],
								[
									-80.921142578125,
									64.10048828125008
								],
								[
									-80.82895507812498,
									64.08994140625006
								],
								[
									-80.69428710937498,
									64.024755859375
								],
								[
									-80.607568359375,
									63.97207031249994
								],
								[
									-80.56884765625,
									63.93193359375002
								],
								[
									-80.57919921874998,
									63.9092285156251
								],
								[
									-80.66826171874999,
									63.901464843750034
								],
								[
									-80.45058593749997,
									63.862939453124994
								],
								[
									-80.26132812499998,
									63.80195312500001
								],
								[
									-80.30205078124999,
									63.762207031250085
								],
								[
									-80.50405273437494,
									63.67377929687501
								],
								[
									-80.71176757812498,
									63.596386718749955
								],
								[
									-80.95351562500002,
									63.48027343750002
								],
								[
									-81.01386718749998,
									63.46254882812505
								],
								[
									-81.04638671875003,
									63.46157226562494
								],
								[
									-81.1796875,
									63.48320312499999
								],
								[
									-81.37172851562497,
									63.53808593750006
								],
								[
									-81.96333007812495,
									63.664453124999966
								],
								[
									-82.14599609374997,
									63.691162109375085
								],
								[
									-82.37812500000001,
									63.70678710937497
								],
								[
									-82.41171875,
									63.7365234375001
								],
								[
									-82.46708984375002,
									63.92695312499998
								],
								[
									-82.57148437499995,
									63.960693359375114
								],
								[
									-82.92968750000003,
									64.00043945312504
								],
								[
									-83.03388671875001,
									64.02324218749996
								],
								[
									-83.038671875,
									64.06142578125002
								],
								[
									-83.01616210937496,
									64.12700195312496
								],
								[
									-83.06513671874998,
									64.159033203125
								],
								[
									-83.185546875,
									64.15751953124996
								],
								[
									-83.30395507812497,
									64.14379882812511
								],
								[
									-83.49433593749995,
									64.09921875000009
								],
								[
									-83.58359375,
									64.05810546875006
								],
								[
									-83.61708984375,
									64.01342773437509
								],
								[
									-83.63798828124999,
									63.91782226562498
								],
								[
									-83.66162109375,
									63.8726074218751
								],
								[
									-83.728271484375,
									63.81337890624994
								],
								[
									-84.022119140625,
									63.659863281249926
								],
								[
									-84.1416015625,
									63.61372070312501
								],
								[
									-84.26044921874995,
									63.600488281249994
								],
								[
									-84.30761718749997,
									63.58579101562512
								],
								[
									-84.38750000000002,
									63.52910156250002
								],
								[
									-84.50620117187503,
									63.39003906250002
								],
								[
									-84.55458984375002,
									63.34999999999994
								],
								[
									-84.63291015625,
									63.30922851562508
								],
								[
									-84.795556640625,
									63.24692382812509
								],
								[
									-84.96152343749998,
									63.19721679687507
								],
								[
									-85.238134765625,
									63.13930664062511
								],
								[
									-85.39262695312496,
									63.1196777343751
								],
								[
									-85.49550781249997,
									63.13911132812507
								],
								[
									-85.56611328124995,
									63.270898437499994
								],
								[
									-85.71416015625002,
									63.65795898437497
								],
								[
									-85.73872070312495,
									63.684130859375074
								],
								[
									-85.76894531249997,
									63.700341796874994
								],
								[
									-85.80468749999997,
									63.706542968750114
								],
								[
									-86.30156249999996,
									63.6567871093751
								],
								[
									-86.57568359375003,
									63.66230468750007
								],
								[
									-86.84687499999993,
									63.575292968750006
								],
								[
									-86.91523437500001,
									63.568994140624966
								],
								[
									-87.05292968749998,
									63.57177734375
								],
								[
									-87.15190429687499,
									63.58564453124998
								],
								[
									-87.1771484375,
									63.595117187499966
								],
								[
									-87.19384765625,
									63.6328125
								],
								[
									-87.18891601562498,
									63.672265624999966
								],
								[
									-87.15439453124998,
									63.71489257812513
								],
								[
									-87.03193359374998,
									63.830419921875034
								],
								[
									-86.93203124999997,
									63.901660156250074
								],
								[
									-86.88603515625002,
									63.92373046874994
								],
								[
									-86.421728515625,
									64.05156249999996
								],
								[
									-86.30859374999997,
									64.09365234375011
								],
								[
									-86.252099609375,
									64.13686523437494
								],
								[
									-86.25219726562503,
									64.18125
								],
								[
									-86.27416992187497,
									64.23803710937494
								],
								[
									-86.3544921875,
									64.37651367187499
								],
								[
									-86.37490234374997,
									64.5029785156251
								],
								[
									-86.37426757812503,
									64.56582031250002
								],
								[
									-86.34384765625003,
									64.66235351562506
								],
								[
									-86.22763671874998,
									64.89633789062503
								],
								[
									-86.18828124999996,
									65.01030273437507
								],
								[
									-86.11420898437498,
									65.41728515625002
								],
								[
									-86.074609375,
									65.53383789062497
								],
								[
									-86.01708984375,
									65.64028320312505
								],
								[
									-85.96166992187497,
									65.70424804687505
								],
								[
									-85.81396484375,
									65.83193359374994
								],
								[
									-85.69907226562495,
									65.88315429687498
								],
								[
									-85.55468750000003,
									65.91865234374993
								],
								[
									-85.52304687499998,
									65.91455078125009
								],
								[
									-85.49550781249997,
									65.89970703125007
								],
								[
									-85.44243164062499,
									65.84555664062506
								],
								[
									-85.24111328125,
									65.79550781249998
								],
								[
									-85.17622070312501,
									65.74687500000002
								],
								[
									-85.13037109375,
									65.69291992187505
								],
								[
									-85.10537109374997,
									65.62270507812502
								],
								[
									-85.13032226562498,
									65.59208984375002
								],
								[
									-85.226318359375,
									65.54575195312509
								],
								[
									-85.24277343749998,
									65.526220703125
								],
								[
									-85.23994140624995,
									65.51030273437496
								],
								[
									-85.05605468749997,
									65.43740234374994
								],
								[
									-84.91962890624995,
									65.26108398437509
								]
							]
						],
						[
							[
								[
									-84.67475585937498,
									65.57500000000007
								],
								[
									-84.72700195312498,
									65.56372070312509
								],
								[
									-84.78291015625001,
									65.57006835937497
								],
								[
									-84.83027343749998,
									65.59897460937509
								],
								[
									-84.86894531249993,
									65.65053710937494
								],
								[
									-84.93115234375,
									65.68916015624998
								],
								[
									-85.07197265625001,
									65.73735351562513
								],
								[
									-85.096337890625,
									65.75620117187506
								],
								[
									-85.13627929687496,
									65.82084960937499
								],
								[
									-85.14404296875003,
									65.88535156250006
								],
								[
									-85.17416992187495,
									65.94375000000008
								],
								[
									-85.17568359375,
									65.97241210937506
								],
								[
									-85.14960937500001,
									66.01538085937509
								],
								[
									-85.031396484375,
									66.02548828125003
								],
								[
									-84.93857421875,
									66.00854492187494
								],
								[
									-84.91982421875,
									65.9970214843751
								],
								[
									-84.88945312499996,
									65.97207031250008
								],
								[
									-84.86953124999997,
									65.94150390625006
								],
								[
									-84.75737304687496,
									65.85893554687502
								],
								[
									-84.691748046875,
									65.79316406250004
								],
								[
									-84.60263671874995,
									65.657373046875
								],
								[
									-84.60224609374995,
									65.63149414062497
								],
								[
									-84.62626953124999,
									65.60405273437496
								],
								[
									-84.67475585937498,
									65.57500000000007
								]
							]
						],
						[
							[
								[
									-83.72597656249997,
									65.79672851562506
								],
								[
									-83.597509765625,
									65.75747070312505
								],
								[
									-83.46943359374993,
									65.73520507812495
								],
								[
									-83.26318359375,
									65.72329101562511
								],
								[
									-83.23374023437498,
									65.71503906249993
								],
								[
									-83.23393554687502,
									65.69658203124999
								],
								[
									-83.26367187500003,
									65.66782226562509
								],
								[
									-83.332421875,
									65.63105468749995
								],
								[
									-83.38144531250003,
									65.62998046875
								],
								[
									-83.49541015624999,
									65.65595703125007
								],
								[
									-83.53710937499994,
									65.669189453125
								],
								[
									-83.58320312500001,
									65.69863281249997
								],
								[
									-83.60654296874998,
									65.70136718749998
								],
								[
									-83.63637695312502,
									65.69150390625012
								],
								[
									-83.64438476562495,
									65.67851562500005
								],
								[
									-83.63066406250002,
									65.66235351562494
								],
								[
									-83.64951171875003,
									65.65776367187499
								],
								[
									-83.78754882812498,
									65.66889648437504
								],
								[
									-83.80922851562497,
									65.67832031250009
								],
								[
									-83.79819335937503,
									65.71000976562505
								],
								[
									-83.70190429687494,
									65.75620117187506
								],
								[
									-83.78652343749997,
									65.77041015625002
								],
								[
									-83.81357421874998,
									65.78750000000002
								],
								[
									-83.93896484375003,
									65.75844726562508
								],
								[
									-84.00849609374998,
									65.75151367187499
								],
								[
									-84.11826171874995,
									65.77177734375013
								],
								[
									-84.12993164062502,
									65.87744140624997
								],
								[
									-84.14321289062497,
									65.91596679687501
								],
								[
									-84.19321289062503,
									65.94213867187509
								],
								[
									-84.22294921874996,
									65.96977539062496
								],
								[
									-84.27089843749997,
									65.99062499999994
								],
								[
									-84.37011718750003,
									66.01181640625009
								],
								[
									-84.45058593749997,
									66.06440429687495
								],
								[
									-84.46738281250003,
									66.08828124999994
								],
								[
									-84.45634765624999,
									66.10624999999996
								],
								[
									-84.40717773437501,
									66.13100585937494
								],
								[
									-84.12226562499998,
									66.07783203125004
								],
								[
									-83.95039062499995,
									66.027490234375
								],
								[
									-83.78696289062495,
									65.96577148437504
								],
								[
									-83.70136718749993,
									65.92011718750004
								],
								[
									-83.69365234374996,
									65.89038085937494
								],
								[
									-83.71489257812502,
									65.86074218750002
								],
								[
									-83.76513671874994,
									65.83115234375003
								],
								[
									-83.72597656249997,
									65.79672851562506
								]
							]
						],
						[
							[
								[
									-83.12348632812498,
									66.28281250000003
								],
								[
									-83.02387695312493,
									66.27065429687497
								],
								[
									-82.94814453124997,
									66.27192382812495
								],
								[
									-82.93134765625001,
									66.25732421875
								],
								[
									-83.01083984375003,
									66.2084472656251
								],
								[
									-83.05986328124999,
									66.19926757812499
								],
								[
									-83.14790039062498,
									66.234228515625
								],
								[
									-83.21391601562502,
									66.27705078125004
								],
								[
									-83.232568359375,
									66.30297851562506
								],
								[
									-83.23784179687499,
									66.33154296874994
								],
								[
									-83.22226562500003,
									66.33647460937496
								],
								[
									-83.12348632812498,
									66.28281250000003
								]
							]
						],
						[
							[
								[
									-108.09272460937501,
									67.00517578125005
								],
								[
									-107.96645507812495,
									66.99726562500004
								],
								[
									-107.80551757812495,
									66.99858398437513
								],
								[
									-107.83334960937502,
									66.92133789062493
								],
								[
									-107.895166015625,
									66.87187500000007
								],
								[
									-107.94394531249999,
									66.85781250000005
								],
								[
									-107.96513671874996,
									66.88486328124995
								],
								[
									-108.05971679687495,
									66.94687499999998
								],
								[
									-108.09272460937501,
									67.00517578125005
								]
							]
						],
						[
							[
								[
									-62.681542968749994,
									67.05629882812505
								],
								[
									-62.805419921875,
									67.02880859374997
								],
								[
									-62.87163085937499,
									67.06259765625009
								],
								[
									-62.825097656249994,
									67.072119140625
								],
								[
									-62.756982421874994,
									67.11254882812497
								],
								[
									-62.66440429687495,
									67.14824218749996
								],
								[
									-62.62529296874999,
									67.17695312499995
								],
								[
									-62.4697265625,
									67.19003906249995
								],
								[
									-62.41679687499996,
									67.18847656250009
								],
								[
									-62.39633789062498,
									67.17832031250006
								],
								[
									-62.484619140625,
									67.13422851562495
								],
								[
									-62.681542968749994,
									67.05629882812505
								]
							]
						],
						[
							[
								[
									-107.89985351562498,
									67.40180664062493
								],
								[
									-107.95024414062503,
									67.31821289062495
								],
								[
									-107.96953124999996,
									67.32602539062495
								],
								[
									-108.00395507812496,
									67.36591796875007
								],
								[
									-108.07333984374998,
									67.38505859374999
								],
								[
									-108.15224609374997,
									67.42944335937497
								],
								[
									-108.15112304687501,
									67.52480468749994
								],
								[
									-108.12084960937497,
									67.56816406249999
								],
								[
									-108.1275390625,
									67.62856445312494
								],
								[
									-108.04897460937498,
									67.66489257812498
								],
								[
									-107.99086914062495,
									67.62211914062496
								],
								[
									-107.97490234374999,
									67.54936523437507
								],
								[
									-107.98935546875,
									67.51357421874997
								],
								[
									-107.931787109375,
									67.47646484375005
								],
								[
									-107.90517578125,
									67.46704101562509
								],
								[
									-107.89096679687495,
									67.43720703124995
								],
								[
									-107.89985351562498,
									67.40180664062493
								]
							]
						],
						[
							[
								[
									-109.16640625,
									67.98237304687507
								],
								[
									-109.05390624999998,
									67.97187499999998
								],
								[
									-108.97050781249996,
									67.97973632812509
								],
								[
									-108.909619140625,
									67.93940429687504
								],
								[
									-108.88603515624999,
									67.89853515625006
								],
								[
									-108.89384765624997,
									67.88447265625004
								],
								[
									-108.92016601562501,
									67.87880859374994
								],
								[
									-109.096240234375,
									67.92402343750001
								],
								[
									-109.16152343749998,
									67.95170898437496
								],
								[
									-109.18359375000003,
									67.975
								],
								[
									-109.16640625,
									67.98237304687507
								]
							]
						],
						[
							[
								[
									-73.621728515625,
									67.78383789062505
								],
								[
									-74.10908203124998,
									67.78251953124996
								],
								[
									-74.37407226562496,
									67.78959960937507
								],
								[
									-74.48071289062503,
									67.80488281249998
								],
								[
									-74.573388671875,
									67.82866210937513
								],
								[
									-74.67861328125002,
									67.90556640625007
								],
								[
									-74.74599609374997,
									67.98481445312495
								],
								[
									-74.74926757812503,
									68.01845703124997
								],
								[
									-74.73144531250003,
									68.04877929687493
								],
								[
									-74.70654296875003,
									68.06708984374993
								],
								[
									-74.37939453125,
									68.09345703125007
								],
								[
									-74.11137695312502,
									68.06059570312513
								],
								[
									-73.880712890625,
									68.02192382812507
								],
								[
									-73.58403320312496,
									68.01533203124995
								],
								[
									-73.49375000000003,
									68.00063476562508
								],
								[
									-73.45922851562503,
									67.98989257812502
								],
								[
									-73.43525390624993,
									67.97001953124996
								],
								[
									-73.40156249999998,
									67.87871093750002
								],
								[
									-73.39819335937503,
									67.82993164062512
								],
								[
									-73.40717773437498,
									67.79306640624998
								],
								[
									-73.621728515625,
									67.78383789062505
								]
							]
						],
						[
							[
								[
									-109.32314453124995,
									67.99086914062502
								],
								[
									-109.36083984374999,
									67.98759765624999
								],
								[
									-109.49794921874995,
									68.04702148437502
								],
								[
									-109.46914062500002,
									68.097998046875
								],
								[
									-109.34169921875,
									68.04584960937495
								],
								[
									-109.32353515625003,
									68.013330078125
								],
								[
									-109.32314453124995,
									67.99086914062502
								]
							]
						],
						[
							[
								[
									-86.59555664062498,
									67.73593750000006
								],
								[
									-86.63818359374997,
									67.73486328125011
								],
								[
									-86.70595703125,
									67.75014648437494
								],
								[
									-86.861083984375,
									67.81049804687507
								],
								[
									-86.89252929687501,
									67.83657226562505
								],
								[
									-86.90830078125,
									67.86704101562495
								],
								[
									-86.90844726562494,
									67.90195312499995
								],
								[
									-86.89458007812496,
									67.93808593750003
								],
								[
									-86.84707031249997,
									68.01025390625009
								],
								[
									-86.93774414062497,
									68.06757812500004
								],
								[
									-86.95981445312503,
									68.10024414062494
								],
								[
									-86.94916992187498,
									68.11870117187496
								],
								[
									-86.898681640625,
									68.16289062500007
								],
								[
									-86.88486328125003,
									68.19052734374995
								],
								[
									-86.83398437499997,
									68.22968749999993
								],
								[
									-86.70209960937501,
									68.30561523437504
								],
								[
									-86.569921875,
									68.28769531250012
								],
								[
									-86.45195312499996,
									68.22548828124997
								],
								[
									-86.42114257812497,
									68.183447265625
								],
								[
									-86.430322265625,
									68.13872070312496
								],
								[
									-86.42001953125,
									68.07392578125007
								],
								[
									-86.39033203125001,
									67.988916015625
								],
								[
									-86.382421875,
									67.92729492187496
								],
								[
									-86.39643554687501,
									67.88896484375005
								],
								[
									-86.446923828125,
									67.81699218750006
								],
								[
									-86.4896484375,
									67.78359375
								],
								[
									-86.54604492187502,
									67.752197265625
								],
								[
									-86.59555664062498,
									67.73593750000006
								]
							]
						],
						[
							[
								[
									-75.67587890624998,
									68.32250976562509
								],
								[
									-75.15380859375003,
									68.23403320312502
								],
								[
									-75.103125,
									68.20190429687503
								],
								[
									-75.07812499999997,
									68.17314453124996
								],
								[
									-75.0634765625,
									68.14121093750012
								],
								[
									-75.06235351562503,
									68.07539062500001
								],
								[
									-75.07285156249995,
									68.04902343749998
								],
								[
									-75.12387695312495,
									67.98525390625005
								],
								[
									-75.12734374999997,
									67.96523437499997
								],
								[
									-75.08637695312495,
									67.75141601562493
								],
								[
									-75.09052734375001,
									67.63476562500006
								],
								[
									-75.12729492187503,
									67.53730468750001
								],
								[
									-75.20195312499996,
									67.45917968749998
								],
								[
									-75.31450195312499,
									67.4004394531251
								],
								[
									-75.40009765625001,
									67.36669921874997
								],
								[
									-75.78007812499996,
									67.28354492187509
								],
								[
									-76.04897460937497,
									67.26201171874996
								],
								[
									-76.33276367187494,
									67.25810546874996
								],
								[
									-76.69394531249998,
									67.23583984375006
								],
								[
									-76.85883789062501,
									67.24047851562511
								],
								[
									-76.94418945312498,
									67.25029296875007
								],
								[
									-77.0048828125,
									67.26694335937509
								],
								[
									-77.075927734375,
									67.31962890625007
								],
								[
									-77.157080078125,
									67.40834960937494
								],
								[
									-77.22421875,
									67.50820312499994
								],
								[
									-77.30439453125001,
									67.6851074218751
								],
								[
									-77.30590820312497,
									67.70610351562502
								],
								[
									-77.22856445312502,
									67.85009765625006
								],
								[
									-77.12587890624997,
									67.94707031249999
								],
								[
									-76.94472656250002,
									68.090966796875
								],
								[
									-76.740234375,
									68.23125000000007
								],
								[
									-76.68823242187497,
									68.25439453125009
								],
								[
									-76.59580078124998,
									68.27895507812502
								],
								[
									-76.36445312500001,
									68.31870117187495
								],
								[
									-76.17280273437495,
									68.30878906250007
								],
								[
									-76.08828124999997,
									68.31381835937509
								],
								[
									-75.98276367187498,
									68.33232421874996
								],
								[
									-75.86650390624999,
									68.33681640625
								],
								[
									-75.67587890624998,
									68.32250976562509
								]
							]
						],
						[
							[
								[
									-78.98271484374999,
									68.19282226562507
								],
								[
									-79.06406250000003,
									68.18178710937494
								],
								[
									-79.17402343749995,
									68.23496093750003
								],
								[
									-79.17475585937493,
									68.26445312499999
								],
								[
									-79.15346679687494,
									68.33525390625013
								],
								[
									-78.95258789062498,
									68.35302734375009
								],
								[
									-78.86870117187502,
									68.31030273437509
								],
								[
									-78.828515625,
									68.26816406249995
								],
								[
									-78.98271484374999,
									68.19282226562507
								]
							]
						],
						[
							[
								[
									-104.54067382812497,
									68.40590820312502
								],
								[
									-104.59599609374996,
									68.40219726562509
								],
								[
									-104.69946289062499,
									68.41826171875007
								],
								[
									-104.85112304687497,
									68.45395507812506
								],
								[
									-104.96523437499995,
									68.4917480468751
								],
								[
									-105.041748046875,
									68.53154296874996
								],
								[
									-105.0513671875,
									68.55903320312507
								],
								[
									-104.99399414062495,
									68.57421875000003
								],
								[
									-104.90727539062496,
									68.58178710937509
								],
								[
									-104.700390625,
									68.57670898437502
								],
								[
									-104.60200195312503,
									68.56152343749994
								],
								[
									-104.47211914062503,
									68.50351562500003
								],
								[
									-104.44453125000001,
									68.470703125
								],
								[
									-104.44047851562497,
									68.44951171875005
								],
								[
									-104.45712890624999,
									68.43115234374994
								],
								[
									-104.54067382812497,
									68.40590820312502
								]
							]
						],
						[
							[
								[
									-74.880859375,
									68.34868164062502
								],
								[
									-74.959326171875,
									68.34223632812504
								],
								[
									-75.07250976562497,
									68.40415039062495
								],
								[
									-75.31015624999998,
									68.47446289062506
								],
								[
									-75.40024414062503,
									68.52548828124998
								],
								[
									-75.40341796874998,
									68.55014648437512
								],
								[
									-75.39619140625001,
									68.5888183593751
								],
								[
									-75.37016601562496,
									68.63608398437495
								],
								[
									-75.28740234374996,
									68.68774414062509
								],
								[
									-75.19975585937496,
									68.6960937500001
								],
								[
									-75.07470703124997,
									68.684716796875
								],
								[
									-74.983642578125,
									68.64760742187508
								],
								[
									-74.884765625,
									68.54462890625004
								],
								[
									-74.8189453125,
									68.49443359375005
								],
								[
									-74.79824218749997,
									68.45795898437498
								],
								[
									-74.83095703124997,
									68.44072265625002
								],
								[
									-74.82792968749996,
									68.42377929687504
								],
								[
									-74.81289062500002,
									68.41333007812494
								],
								[
									-74.81855468750001,
									68.3940917968751
								],
								[
									-74.84497070312497,
									68.36596679687506
								],
								[
									-74.880859375,
									68.34868164062502
								]
							]
						],
						[
							[
								[
									-101.84589843749995,
									68.58632812499994
								],
								[
									-101.88720703125001,
									68.58496093750009
								],
								[
									-101.94462890624999,
									68.6028320312501
								],
								[
									-102.26635742187499,
									68.66367187500006
								],
								[
									-102.30815429687497,
									68.68198242187506
								],
								[
									-102.27050781250003,
									68.70756835937513
								],
								[
									-102.15332031249996,
									68.74047851562509
								],
								[
									-102.07436523437495,
									68.77402343749998
								],
								[
									-102.01337890624997,
									68.82539062500004
								],
								[
									-101.82836914062501,
									68.798974609375
								],
								[
									-101.75932617187499,
									68.77460937499993
								],
								[
									-101.73295898437495,
									68.75341796875006
								],
								[
									-101.72163085937494,
									68.72412109374994
								],
								[
									-101.73203125000002,
									68.65214843750002
								],
								[
									-101.794287109375,
									68.63686523437502
								],
								[
									-101.84589843749995,
									68.58632812499994
								]
							]
						],
						[
							[
								[
									-100.21723632812497,
									68.80668945312507
								],
								[
									-100.248779296875,
									68.77504882812511
								],
								[
									-100.28793945312499,
									68.76606445312495
								],
								[
									-100.36572265625003,
									68.7288085937501
								],
								[
									-100.39731445312498,
									68.72382812500007
								],
								[
									-100.44257812499995,
									68.74755859375
								],
								[
									-100.4806640625,
									68.78618164062505
								],
								[
									-100.49692382812502,
									68.79223632812506
								],
								[
									-100.52104492187496,
									68.790673828125
								],
								[
									-100.57338867187497,
									68.76606445312495
								],
								[
									-100.59653320312498,
									68.7664062500001
								],
								[
									-100.61596679687503,
									68.78291015624993
								],
								[
									-100.625390625,
									68.81591796875009
								],
								[
									-100.62465820312502,
									68.8652832031251
								],
								[
									-100.59990234374995,
									68.94135742187504
								],
								[
									-100.59833984374998,
									68.96909179687512
								],
								[
									-100.61157226562501,
									68.99018554687504
								],
								[
									-100.600634765625,
									69.00942382812505
								],
								[
									-100.56547851562495,
									69.02680664062504
								],
								[
									-100.52031249999999,
									69.03505859375005
								],
								[
									-100.41396484375,
									69.02807617187506
								],
								[
									-100.32993164062502,
									68.99755859375006
								],
								[
									-100.28896484375002,
									68.957666015625
								],
								[
									-100.20688476562499,
									68.92617187500008
								],
								[
									-100.17846679687497,
									68.90390624999998
								],
								[
									-100.21723632812497,
									68.80668945312507
								]
							]
						],
						[
							[
								[
									-99.99467773437502,
									69.013525390625
								],
								[
									-100.01801757812497,
									68.95400390624997
								],
								[
									-100.14130859374995,
									68.96992187499993
								],
								[
									-100.19570312500002,
									68.99145507812506
								],
								[
									-100.24199218749995,
									69.04038085937498
								],
								[
									-100.24736328124997,
									69.05278320312502
								],
								[
									-100.23706054687501,
									69.07148437500001
								],
								[
									-100.18696289062503,
									69.11401367187497
								],
								[
									-100.15312499999996,
									69.1294921875
								],
								[
									-100.07280273437495,
									69.11147460937508
								],
								[
									-100.03535156249995,
									69.08657226562497
								],
								[
									-100.00561523437503,
									69.04711914062511
								],
								[
									-99.99467773437502,
									69.013525390625
								]
							]
						],
						[
							[
								[
									-90.49257812499997,
									69.22109374999994
								],
								[
									-90.57441406249995,
									69.20942382812495
								],
								[
									-90.62578125000002,
									69.25092773437507
								],
								[
									-90.66743164062498,
									69.25947265625001
								],
								[
									-90.685888671875,
									69.28715820312507
								],
								[
									-90.77158203124998,
									69.29257812500012
								],
								[
									-90.76567382812502,
									69.33598632812507
								],
								[
									-90.74238281249995,
									69.35732421875005
								],
								[
									-90.66279296875001,
									69.37416992187494
								],
								[
									-90.59970703125003,
									69.36782226562508
								],
								[
									-90.53984375000002,
									69.32460937499997
								],
								[
									-90.51064453125,
									69.29042968749994
								],
								[
									-90.4853515625,
									69.24663085937499
								],
								[
									-90.49257812499997,
									69.22109374999994
								]
							]
						],
						[
							[
								[
									-79.21064453124995,
									68.84545898437497
								],
								[
									-79.27973632812501,
									68.83872070312509
								],
								[
									-79.36137695312493,
									68.85766601562497
								],
								[
									-79.390478515625,
									68.89018554687502
								],
								[
									-79.40576171875,
									68.92304687500004
								],
								[
									-79.39116210937496,
									68.93994140624994
								],
								[
									-79.354736328125,
									68.95590820312509
								],
								[
									-79.30522460937496,
									68.99233398437505
								],
								[
									-79.24267578125,
									69.04926757812493
								],
								[
									-79.14497070312498,
									69.08745117187507
								],
								[
									-78.93046874999999,
									69.122900390625
								],
								[
									-78.9,
									69.13540039062497
								],
								[
									-78.8041015625,
									69.23510742187494
								],
								[
									-78.771826171875,
									69.25219726562506
								],
								[
									-78.66201171875002,
									69.262353515625
								],
								[
									-78.65019531250002,
									69.27519531250013
								],
								[
									-78.6890625,
									69.29975585937507
								],
								[
									-78.6890625,
									69.32509765625008
								],
								[
									-78.65019531250002,
									69.35122070312505
								],
								[
									-78.59667968750003,
									69.37060546875011
								],
								[
									-78.45791015625,
									69.38950195312503
								],
								[
									-78.33256835937496,
									69.38603515624996
								],
								[
									-78.30048828124998,
									69.37871093750007
								],
								[
									-78.27246093749997,
									69.36123046874997
								],
								[
									-78.23408203124995,
									69.31459960937505
								],
								[
									-78.22895507812498,
									69.30400390625005
								],
								[
									-78.28701171875,
									69.26269531249997
								],
								[
									-78.43896484374997,
									69.1991699218751
								],
								[
									-78.53291015625001,
									69.1460449218751
								],
								[
									-78.55175781250003,
									69.12866210937503
								],
								[
									-78.560302734375,
									69.10624999999999
								],
								[
									-78.59565429687498,
									69.07905273437495
								],
								[
									-78.70537109374996,
									69.01367187500003
								],
								[
									-78.77919921875,
									68.95048828124996
								],
								[
									-78.85268554687497,
									68.91567382812497
								],
								[
									-79.05361328124994,
									68.88291015625003
								],
								[
									-79.21064453124995,
									68.84545898437497
								]
							]
						],
						[
							[
								[
									-90.1998046875,
									69.41909179687502
								],
								[
									-90.17739257812497,
									69.35708007812502
								],
								[
									-90.26728515624998,
									69.27290039062501
								],
								[
									-90.29545898437496,
									69.25781250000003
								],
								[
									-90.33027343749995,
									69.25219726562506
								],
								[
									-90.36406249999999,
									69.26259765625005
								],
								[
									-90.46469726562498,
									69.3287109375
								],
								[
									-90.49204101562503,
									69.36987304687506
								],
								[
									-90.45512695312499,
									69.39047851562498
								],
								[
									-90.37724609375002,
									69.41621093749998
								],
								[
									-90.32207031249996,
									69.42871093750003
								],
								[
									-90.25283203124997,
									69.41791992187507
								],
								[
									-90.22856445312502,
									69.43603515625003
								],
								[
									-90.1998046875,
									69.41909179687502
								]
							]
						],
						[
							[
								[
									-76.99536132812503,
									69.14374999999998
								],
								[
									-77.12163085937499,
									69.13212890625002
								],
								[
									-77.21503906250001,
									69.13808593750008
								],
								[
									-77.27558593750001,
									69.16166992187499
								],
								[
									-77.32192382812502,
									69.19360351562511
								],
								[
									-77.37939453125,
									69.27402343750006
								],
								[
									-77.35805664062502,
									69.31152343749997
								],
								[
									-77.35151367187501,
									69.37866210937497
								],
								[
									-77.34091796874998,
									69.40385742187505
								],
								[
									-77.318701171875,
									69.4163085937501
								],
								[
									-77.18754882812502,
									69.44008789062497
								],
								[
									-77.10917968749993,
									69.43740234375002
								],
								[
									-76.99409179687495,
									69.41176757812497
								],
								[
									-76.74570312499998,
									69.40400390624998
								],
								[
									-76.68408203125003,
									69.38041992187507
								],
								[
									-76.66884765625002,
									69.3661621093751
								],
								[
									-76.67001953125,
									69.34858398437507
								],
								[
									-76.68745117187501,
									69.32768554687507
								],
								[
									-76.81030273437497,
									69.266748046875
								],
								[
									-76.86933593750001,
									69.22485351562509
								],
								[
									-76.91123046875003,
									69.17465820312498
								],
								[
									-76.99536132812503,
									69.14374999999998
								]
							]
						],
						[
							[
								[
									-101.171728515625,
									69.39707031250009
								],
								[
									-101.25351562499996,
									69.38847656250002
								],
								[
									-101.268505859375,
									69.3905761718751
								],
								[
									-101.2615234375,
									69.41782226562495
								],
								[
									-101.267626953125,
									69.43149414062506
								],
								[
									-101.28950195312501,
									69.44125976562512
								],
								[
									-101.21777343749997,
									69.46293945312507
								],
								[
									-101.20732421874997,
									69.47983398437498
								],
								[
									-101.230126953125,
									69.49282226562505
								],
								[
									-101.32846679687496,
									69.51743164062509
								],
								[
									-101.35649414062499,
									69.53969726562508
								],
								[
									-101.351318359375,
									69.55922851562508
								],
								[
									-101.31289062499998,
									69.57607421875005
								],
								[
									-101.24487304687499,
									69.57353515625005
								],
								[
									-101.09833984374997,
									69.54077148437506
								],
								[
									-101.03115234374997,
									69.49545898437506
								],
								[
									-101.00063476562497,
									69.46191406249997
								],
								[
									-101.04916992187499,
									69.45693359375002
								],
								[
									-101.08686523437494,
									69.443359375
								],
								[
									-101.12695312500003,
									69.41469726562494
								],
								[
									-101.171728515625,
									69.39707031250009
								]
							]
						],
						[
							[
								[
									-95.51367187499997,
									69.5736328125
								],
								[
									-95.38090820312493,
									69.50659179687509
								],
								[
									-95.382080078125,
									69.47407226562495
								],
								[
									-95.39941406249997,
									69.41977539062509
								],
								[
									-95.43745117187501,
									69.37846679687502
								],
								[
									-95.496240234375,
									69.35009765625011
								],
								[
									-95.57851562499997,
									69.33583984375005
								],
								[
									-95.68437499999993,
									69.33569335937509
								],
								[
									-95.73012695312502,
									69.34755859374994
								],
								[
									-95.69589843749998,
									69.38955078124997
								],
								[
									-95.67016601562497,
									69.40200195312502
								],
								[
									-95.66582031249999,
									69.43896484375
								],
								[
									-95.68281249999998,
									69.50029296875005
								],
								[
									-95.70410156249997,
									69.53803710937493
								],
								[
									-95.76362304687501,
									69.55961914062507
								],
								[
									-95.80620117187499,
									69.56049804687498
								],
								[
									-95.81777343749994,
									69.5405761718751
								],
								[
									-95.79833984374997,
									69.49980468749996
								],
								[
									-95.81181640624996,
									69.44702148437503
								],
								[
									-95.85820312500002,
									69.38222656250008
								],
								[
									-95.89345703125,
									69.3517578125001
								],
								[
									-95.95605468749997,
									69.36713867187493
								],
								[
									-95.9859375,
									69.3918945312501
								],
								[
									-95.97792968749997,
									69.43271484375006
								],
								[
									-95.99477539062494,
									69.46967773437495
								],
								[
									-95.97885742187498,
									69.50883789062502
								],
								[
									-95.93623046875001,
									69.56704101562508
								],
								[
									-95.87583007812495,
									69.60600585937502
								],
								[
									-95.79775390624994,
									69.62573242187494
								],
								[
									-95.70664062500003,
									69.62431640625002
								],
								[
									-95.60249023437495,
									69.60180664062506
								],
								[
									-95.51367187499997,
									69.5736328125
								]
							]
						],
						[
							[
								[
									-139.043115234375,
									69.57690429687494
								],
								[
									-139.12573242187506,
									69.53930664062511
								],
								[
									-139.25698242187497,
									69.57856445312493
								],
								[
									-139.29140624999997,
									69.59785156249995
								],
								[
									-139.139599609375,
									69.64960937499993
								],
								[
									-139.07265624999997,
									69.64765625000007
								],
								[
									-138.93154296875,
									69.61694335937503
								],
								[
									-138.878857421875,
									69.58969726562498
								],
								[
									-139.043115234375,
									69.57690429687494
								]
							]
						],
						[
							[
								[
									-67.91469726562494,
									69.5409667968751
								],
								[
									-67.940283203125,
									69.5348632812501
								],
								[
									-68.20234375000001,
									69.58041992187495
								],
								[
									-68.22138671874998,
									69.61674804687507
								],
								[
									-68.09326171875,
									69.65703125000002
								],
								[
									-67.989111328125,
									69.6787597656251
								],
								[
									-67.908837890625,
									69.68183593750001
								],
								[
									-67.8291015625,
									69.67500000000004
								],
								[
									-67.75458984375001,
									69.63144531249995
								],
								[
									-67.84492187499995,
									69.59174804687495
								],
								[
									-67.91469726562494,
									69.5409667968751
								]
							]
						],
						[
							[
								[
									-78.02910156249996,
									69.71489257812499
								],
								[
									-77.97783203124999,
									69.66489257812512
								],
								[
									-77.969140625,
									69.63896484375007
								],
								[
									-78.03999023437495,
									69.60839843749997
								],
								[
									-78.30722656250003,
									69.55180664062499
								],
								[
									-78.47006835937498,
									69.50253906249998
								],
								[
									-78.55239257812497,
									69.49155273437506
								],
								[
									-78.66206054687493,
									69.50263671875001
								],
								[
									-78.7953125,
									69.47973632812506
								],
								[
									-78.84819335937502,
									69.48281249999997
								],
								[
									-78.789306640625,
									69.52314453125001
								],
								[
									-78.57856445312498,
									69.63881835937502
								],
								[
									-78.40185546874994,
									69.65063476562506
								],
								[
									-78.34418945312501,
									69.6748046875
								],
								[
									-78.29550781249995,
									69.66713867187494
								],
								[
									-78.267333984375,
									69.68715820312494
								],
								[
									-78.26245117187497,
									69.71684570312513
								],
								[
									-78.20073242187502,
									69.73950195312494
								],
								[
									-78.14521484374998,
									69.73920898437507
								],
								[
									-78.02910156249996,
									69.71489257812499
								]
							]
						],
						[
							[
								[
									-79.43066406250003,
									69.78779296874993
								],
								[
									-79.39028320312497,
									69.73041992187495
								],
								[
									-79.36499023437497,
									69.71235351562501
								],
								[
									-79.40244140624995,
									69.68515624999998
								],
								[
									-79.55283203124995,
									69.63085937500011
								],
								[
									-79.88168945312498,
									69.6086914062501
								],
								[
									-80.04750976562502,
									69.6343261718751
								],
								[
									-79.97114257812501,
									69.55634765624993
								],
								[
									-79.9544921875,
									69.52348632812499
								],
								[
									-79.97783203124993,
									69.50966796875002
								],
								[
									-80.04687499999997,
									69.51386718749998
								],
								[
									-80.16147460937495,
									69.53593750000005
								],
								[
									-80.22734374999996,
									69.56240234375011
								],
								[
									-80.244482421875,
									69.59316406249997
								],
								[
									-80.26865234375003,
									69.59999999999994
								],
								[
									-80.29970703124997,
									69.582861328125
								],
								[
									-80.32958984375003,
									69.586767578125
								],
								[
									-80.39785156249997,
									69.63261718750002
								],
								[
									-80.44804687499999,
									69.64970703125013
								],
								[
									-80.77822265625002,
									69.677001953125
								],
								[
									-80.794775390625,
									69.6892578125001
								],
								[
									-80.77753906249998,
									69.71035156250005
								],
								[
									-80.72661132812499,
									69.74042968749995
								],
								[
									-80.65253906249998,
									69.75058593749998
								],
								[
									-80.46591796874998,
									69.73710937499999
								],
								[
									-80.45068359375,
									69.74477539062505
								],
								[
									-80.43833007812498,
									69.78271484375003
								],
								[
									-80.42421875000002,
									69.79760742187497
								],
								[
									-80.29492187499997,
									69.79379882812509
								],
								[
									-80.21367187499993,
									69.80195312500004
								],
								[
									-80.16884765624997,
									69.78242187499998
								],
								[
									-80.124609375,
									69.73725585937493
								],
								[
									-80.061767578125,
									69.74550781250011
								],
								[
									-79.97084960937502,
									69.73896484374993
								],
								[
									-79.86958007812501,
									69.75551757812511
								],
								[
									-79.71484375,
									69.79570312500002
								],
								[
									-79.593994140625,
									69.81049804687493
								],
								[
									-79.43066406250003,
									69.78779296874993
								]
							]
						],
						[
							[
								[
									-97.439453125,
									69.64267578125012
								],
								[
									-97.40864257812495,
									69.63076171875
								],
								[
									-97.35068359374995,
									69.64086914062509
								],
								[
									-97.30576171875003,
									69.673486328125
								],
								[
									-97.278466796875,
									69.67963867187501
								],
								[
									-97.23608398437497,
									69.673486328125
								],
								[
									-97.096337890625,
									69.61499023437497
								],
								[
									-96.98906249999999,
									69.55361328125
								],
								[
									-96.87519531249998,
									69.510009765625
								],
								[
									-96.69453124999995,
									69.47109374999997
								],
								[
									-96.29995117187494,
									69.34438476562508
								],
								[
									-96.183740234375,
									69.25869140625005
								],
								[
									-96.06098632812493,
									69.12543945312498
								],
								[
									-95.95136718749998,
									69.02373046874996
								],
								[
									-95.85488281249997,
									68.95356445312504
								],
								[
									-95.7513671875,
									68.89765625000004
								],
								[
									-95.58549804687496,
									68.835107421875
								],
								[
									-95.43754882812502,
									68.88061523437503
								],
								[
									-95.374169921875,
									68.89213867187507
								],
								[
									-95.31953124999995,
									68.87319335937494
								],
								[
									-95.26777343749998,
									68.82607421875002
								],
								[
									-95.29516601562497,
									68.80502929687509
								],
								[
									-95.35947265625,
									68.77836914062507
								],
								[
									-95.46557617187494,
									68.74726562500004
								],
								[
									-95.61420898437495,
									68.74501953124994
								],
								[
									-95.68564453125003,
									68.73583984375011
								],
								[
									-95.80214843749997,
									68.6864746093751
								],
								[
									-95.89462890624998,
									68.6272460937501
								],
								[
									-96.02402343750003,
									68.60727539062503
								],
								[
									-96.26762695312502,
									68.50791015624995
								],
								[
									-96.40156249999995,
									68.470703125
								],
								[
									-96.59882812499998,
									68.46083984375002
								],
								[
									-97.00839843750003,
									68.53867187500009
								],
								[
									-97.263671875,
									68.52773437500008
								],
								[
									-97.47202148437498,
									68.54370117187503
								],
								[
									-97.70478515624998,
									68.62592773437501
								],
								[
									-97.88535156249998,
									68.67246093749998
								],
								[
									-98.23505859375001,
									68.73935546875012
								],
								[
									-98.25795898437497,
									68.749267578125
								],
								[
									-98.273046875,
									68.77187500000008
								],
								[
									-98.28017578124997,
									68.80717773437499
								],
								[
									-98.296044921875,
									68.83076171875007
								],
								[
									-98.320556640625,
									68.84272460937504
								],
								[
									-98.37558593750003,
									68.84169921875
								],
								[
									-98.43183593749995,
									68.81835937500003
								],
								[
									-98.53964843749998,
									68.79824218749994
								],
								[
									-98.70380859374993,
									68.80278320312507
								],
								[
									-98.775244140625,
									68.81674804687498
								],
								[
									-98.82963867187499,
									68.838623046875
								],
								[
									-98.85913085937496,
									68.86435546875009
								],
								[
									-98.863720703125,
									68.89379882812506
								],
								[
									-98.87885742187498,
									68.91645507812495
								],
								[
									-98.90449218749995,
									68.9324218750001
								],
								[
									-98.96401367187501,
									68.93286132812509
								],
								[
									-99.05737304687501,
									68.91767578125001
								],
								[
									-99.09384765624999,
									68.89887695312493
								],
								[
									-99.073388671875,
									68.87656250000009
								],
								[
									-99.09062499999996,
									68.86333007812496
								],
								[
									-99.25400390625002,
									68.86318359374994
								],
								[
									-99.31796874999999,
									68.8762695312501
								],
								[
									-99.44086914062498,
									68.91767578125001
								],
								[
									-99.49467773437493,
									68.95957031249995
								],
								[
									-99.56406249999995,
									69.03413085937504
								],
								[
									-99.55737304687501,
									69.05429687500006
								],
								[
									-99.51328124999999,
									69.09960937500006
								],
								[
									-99.455712890625,
									69.131201171875
								],
								[
									-99.08544921874997,
									69.14975585937506
								],
								[
									-98.91220703125002,
									69.16757812499995
								],
								[
									-98.72363281249997,
									69.21914062500008
								],
								[
									-98.50351562499998,
									69.30830078125001
								],
								[
									-98.45595703124997,
									69.33466796874998
								],
								[
									-98.45039062499998,
									69.35405273437502
								],
								[
									-98.46660156250002,
									69.37500000000003
								],
								[
									-98.53535156249998,
									69.42631835937507
								],
								[
									-98.55854492187501,
									69.46142578125006
								],
								[
									-98.53671875,
									69.47802734375006
								],
								[
									-98.44838867187494,
									69.4795410156251
								],
								[
									-98.494873046875,
									69.49936523437503
								],
								[
									-98.53437499999995,
									69.52744140625009
								],
								[
									-98.54824218749994,
									69.54497070312502
								],
								[
									-98.54599609375003,
									69.57290039062502
								],
								[
									-98.47583007812503,
									69.57905273437504
								],
								[
									-98.38935546874998,
									69.56503906250009
								],
								[
									-98.222314453125,
									69.48452148437505
								],
								[
									-98.15576171875,
									69.46884765625003
								],
								[
									-98.04135742187498,
									69.45664062500003
								],
								[
									-98.16298828124997,
									69.51220703125
								],
								[
									-98.28881835937503,
									69.62900390625009
								],
								[
									-98.30449218749993,
									69.66928710937503
								],
								[
									-98.30122070312498,
									69.69169921875007
								],
								[
									-98.268212890625,
									69.75444335937496
								],
								[
									-98.23867187500002,
									69.78002929687494
								],
								[
									-98.20048828124999,
									69.79697265625009
								],
								[
									-98.08076171875001,
									69.83305664062499
								],
								[
									-97.88896484375002,
									69.85825195312498
								],
								[
									-97.79072265624998,
									69.86162109375005
								],
								[
									-97.69121093749996,
									69.84125976562498
								],
								[
									-97.60434570312503,
									69.80219726562493
								],
								[
									-97.41137695312497,
									69.7384765625001
								],
								[
									-97.38256835937497,
									69.71240234375011
								],
								[
									-97.38569335937498,
									69.7002441406251
								],
								[
									-97.46015624999995,
									69.68271484375
								],
								[
									-97.46943359374998,
									69.66679687499996
								],
								[
									-97.439453125,
									69.64267578125012
								]
							]
						],
						[
							[
								[
									-86.91303710937501,
									70.11323242187504
								],
								[
									-86.79877929687498,
									70.10527343750013
								],
								[
									-86.69121093750002,
									70.11503906250007
								],
								[
									-86.61274414062493,
									70.10571289062494
								],
								[
									-86.56337890625,
									70.07724609375
								],
								[
									-86.53090820312497,
									70.04765625000002
								],
								[
									-86.51523437499995,
									70.0170410156251
								],
								[
									-86.55766601562499,
									69.99531249999993
								],
								[
									-86.73432617187501,
									69.97631835937506
								],
								[
									-86.85493164062498,
									69.98574218750002
								],
								[
									-86.98398437499998,
									70.01113281250002
								],
								[
									-87.043798828125,
									69.99985351562503
								],
								[
									-87.19082031250002,
									70.01855468749994
								],
								[
									-87.263916015625,
									70.04394531249997
								],
								[
									-87.3232421875,
									70.08012695312505
								],
								[
									-87.32314453124997,
									70.10224609375004
								],
								[
									-87.16811523437502,
									70.12724609375007
								],
								[
									-87.10727539062495,
									70.14667968750004
								],
								[
									-86.91303710937501,
									70.11323242187504
								]
							]
						],
						[
							[
								[
									-100.30834960937497,
									70.49580078124993
								],
								[
									-100.32124023437503,
									70.48769531250005
								],
								[
									-100.53725585937498,
									70.525
								],
								[
									-100.620654296875,
									70.54692382812513
								],
								[
									-100.64775390625002,
									70.56313476562497
								],
								[
									-100.66694335937501,
									70.59624023437496
								],
								[
									-100.67832031250002,
									70.64619140625001
								],
								[
									-100.63530273437496,
									70.67031250000002
								],
								[
									-100.53793945312502,
									70.66860351562505
								],
								[
									-100.43393554687498,
									70.64941406250003
								],
								[
									-100.27612304687497,
									70.59462890625008
								],
								[
									-100.32109374999999,
									70.57836914062506
								],
								[
									-100.32324218749999,
									70.54243164062501
								],
								[
									-100.30551757812502,
									70.5083984375
								],
								[
									-100.30834960937497,
									70.49580078124993
								]
							]
						],
						[
							[
								[
									-74.70888671874997,
									45.00385742187507
								],
								[
									-74.76245117187494,
									44.999072265625074
								],
								[
									-74.85664062499995,
									45.00390625000017
								],
								[
									-74.99614257812496,
									44.97011718749994
								],
								[
									-75.17939453124998,
									44.8993652343751
								],
								[
									-75.40126953125,
									44.77226562499996
								],
								[
									-75.79194335937498,
									44.49707031250003
								],
								[
									-75.79796599199037,
									44.49068267184725
								],
								[
									-75.80512695312501,
									44.49467773437499
								],
								[
									-75.83139648437495,
									44.489990234375
								],
								[
									-75.94160156250001,
									44.41079101562502
								],
								[
									-76.05722656249995,
									44.366601562499994
								],
								[
									-76.34072265624997,
									44.29472656250002
								],
								[
									-76.40781249999995,
									44.262451171875
								],
								[
									-76.49047851562503,
									44.24370117187502
								],
								[
									-76.5888671875,
									44.23847656250001
								],
								[
									-76.68769531249995,
									44.21796875000001
								],
								[
									-76.78701171874994,
									44.182226562500006
								],
								[
									-76.99150390624996,
									44.07412109375002
								],
								[
									-77.04130859374996,
									44.07109375000002
								],
								[
									-77.06225585937497,
									44.091162109375034
								],
								[
									-77.05527343749998,
									44.10639648437501
								],
								[
									-77.02094726562498,
									44.133105468750045
								],
								[
									-76.89604492187496,
									44.18754882812502
								],
								[
									-76.91308593749997,
									44.19775390624997
								],
								[
									-76.95107421874997,
									44.18623046875004
								],
								[
									-77.010009765625,
									44.15288085937499
								],
								[
									-77.03310546875,
									44.15644531250001
								],
								[
									-77.02045898437498,
									44.196923828124994
								],
								[
									-77.05869140624995,
									44.20507812500006
								],
								[
									-77.14775390624999,
									44.180810546874994
								],
								[
									-77.20332031250001,
									44.175390625000034
								],
								[
									-77.22534179687497,
									44.18876953125002
								],
								[
									-77.25078125000002,
									44.188818359375034
								],
								[
									-77.27963867187495,
									44.17558593749999
								],
								[
									-77.32568359375,
									44.17807617187506
								],
								[
									-77.398095703125,
									44.16064453125006
								],
								[
									-77.547216796875,
									44.12373046874998
								],
								[
									-77.58437499999994,
									44.094335937500034
								],
								[
									-77.58574218749996,
									44.08432617187506
								],
								[
									-77.44584960937496,
									44.130761718749994
								],
								[
									-77.38071289062492,
									44.14580078124996
								],
								[
									-77.33271484375001,
									44.152929687500006
								],
								[
									-77.31396484375,
									44.142675781250034
								],
								[
									-77.33134765624999,
									44.11904296875002
								],
								[
									-77.33164062499998,
									44.10419921875001
								],
								[
									-77.29599609374998,
									44.09794921874999
								],
								[
									-77.27485351562504,
									44.10419921875001
								],
								[
									-77.27294921875,
									44.110693359375006
								],
								[
									-77.29033203124999,
									44.11752929687498
								],
								[
									-77.28984374999999,
									44.12685546875002
								],
								[
									-77.27148437499997,
									44.13867187500003
								],
								[
									-77.11528320312493,
									44.17294921874998
								],
								[
									-77.08320312499998,
									44.148095703124994
								],
								[
									-77.11699218749993,
									44.07949218750005
								],
								[
									-77.10273437499995,
									44.04633789062504
								],
								[
									-77.04023437500001,
									44.04863281249996
								],
								[
									-76.96933593749995,
									44.06630859375002
								],
								[
									-76.88994140624996,
									44.09931640624998
								],
								[
									-76.86298828124995,
									44.09990234375002
								],
								[
									-76.888427734375,
									44.06801757812502
								],
								[
									-76.93017578124997,
									44.03837890625002
								],
								[
									-77.0240234375,
									43.987207031249994
								],
								[
									-77.04379882812495,
									43.95190429687497
								],
								[
									-77.042333984375,
									43.942773437499994
								],
								[
									-77.0130859375,
									43.95654296875003
								],
								[
									-76.91000976562495,
									43.96494140624998
								],
								[
									-76.87031250000004,
									43.96494140624998
								],
								[
									-76.87910156249995,
									43.94291992187502
								],
								[
									-76.934228515625,
									43.9296875
								],
								[
									-77.05449218749999,
									43.88300781249998
								],
								[
									-77.15117187499996,
									43.86645507812497
								],
								[
									-77.20795898437498,
									43.87597656249997
								],
								[
									-77.21923828124997,
									43.899658203125
								],
								[
									-77.18515624999998,
									43.93749999999997
								],
								[
									-77.19003906249998,
									43.947607421875006
								],
								[
									-77.26718749999998,
									43.92163085937503
								],
								[
									-77.28940429687498,
									43.922753906249994
								],
								[
									-77.314794921875,
									43.94653320312506
								],
								[
									-77.31059570312493,
									43.95209960937501
								],
								[
									-77.27558593750001,
									43.95166015625003
								],
								[
									-77.25898437499998,
									43.963964843750034
								],
								[
									-77.32451171874993,
									43.971582031249994
								],
								[
									-77.42065429687497,
									43.954003906249966
								],
								[
									-77.50288085937504,
									43.96254882812502
								],
								[
									-77.55400390624996,
									43.990332031250006
								],
								[
									-77.567626953125,
									44.00766601562498
								],
								[
									-77.54375000000002,
									44.01445312500002
								],
								[
									-77.54902343750001,
									44.024755859375006
								],
								[
									-77.58344726562501,
									44.03837890625002
								],
								[
									-77.68178710937497,
									44.044824218749994
								],
								[
									-77.70869140625004,
									44.033300781250034
								],
								[
									-77.72646484375002,
									44.00927734375003
								],
								[
									-77.82905273437495,
									44.01069335937507
								],
								[
									-77.88076171875002,
									43.99394531250002
								],
								[
									-77.99985351562495,
									43.978906249999966
								],
								[
									-78.18632812500002,
									43.96552734375001
								],
								[
									-78.3349609375,
									43.94443359375006
								],
								[
									-78.44589843749995,
									43.91562500000006
								],
								[
									-78.52783203124994,
									43.90483398437499
								],
								[
									-78.58090820312492,
									43.911962890625006
								],
								[
									-78.6693359375,
									43.902441406250034
								],
								[
									-78.79306640624998,
									43.87626953125002
								],
								[
									-78.98867187499994,
									43.85546875000006
								],
								[
									-79.06064453124995,
									43.83515625000001
								],
								[
									-79.16533203124996,
									43.779882812500034
								],
								[
									-79.30278320312499,
									43.68969726562503
								],
								[
									-79.39633789062495,
									43.645410156249994
								],
								[
									-79.44599609375004,
									43.647119140624966
								],
								[
									-79.48012695312497,
									43.63598632812503
								],
								[
									-79.49882812499996,
									43.611962890624994
								],
								[
									-79.56904296874998,
									43.578271484374994
								],
								[
									-79.59628906249992,
									43.55180664062502
								],
								[
									-79.610107421875,
									43.51328124999998
								],
								[
									-79.65644531250001,
									43.45283203125001
								],
								[
									-79.77416992187503,
									43.31982421875
								],
								[
									-79.77304687499998,
									43.301123046875006
								],
								[
									-79.72783203124999,
									43.25283203125002
								],
								[
									-79.63842773437497,
									43.23491210937502
								],
								[
									-79.52788085937493,
									43.20952148437499
								],
								[
									-79.40146484374995,
									43.20869140625001
								],
								[
									-79.33754882812497,
									43.19770507812498
								],
								[
									-79.29135742187498,
									43.20747070312501
								],
								[
									-79.21337890625,
									43.242285156250006
								],
								[
									-79.0613893338681,
									43.2829114454847
								],
								[
									-79.05922851562494,
									43.278076171875114
								],
								[
									-79.066064453125,
									43.10610351562508
								],
								[
									-79.07319335937504,
									43.09306640624999
								],
								[
									-79.04287109374997,
									43.06362304687502
								],
								[
									-79.03452148437498,
									43.04389648437501
								],
								[
									-79.03969726562497,
									43.02128906250002
								],
								[
									-79.01054687499996,
									42.99052734374996
								],
								[
									-78.94707031249999,
									42.95156250000002
								],
								[
									-78.92236328125003,
									42.92382812499997
								],
								[
									-78.93642578124997,
									42.90722656250006
								],
								[
									-79.05693359374999,
									42.86225585937504
								],
								[
									-79.12187499999999,
									42.85751953125006
								],
								[
									-79.175927734375,
									42.87260742187502
								],
								[
									-79.26396484374999,
									42.88032226562498
								],
								[
									-79.38593749999998,
									42.88066406249996
								],
								[
									-79.59384765624995,
									42.85395507812504
								],
								[
									-79.66147460937498,
									42.85058593749997
								],
								[
									-79.69868164062501,
									42.86162109374999
								],
								[
									-79.74658203125,
									42.85844726562496
								],
								[
									-79.92285156250003,
									42.822412109374994
								],
								[
									-80.09946289062495,
									42.802343750000006
								],
								[
									-80.220458984375,
									42.77436523437498
								],
								[
									-80.28583984374998,
									42.73847656250004
								],
								[
									-80.32583007812497,
									42.707373046875006
								],
								[
									-80.36474609374997,
									42.68310546875006
								],
								[
									-80.39555664062496,
									42.675878906250006
								],
								[
									-80.45122070312502,
									42.61347656249998
								],
								[
									-80.44604492187503,
									42.60419921875004
								],
								[
									-80.36777343749998,
									42.60791015625
								],
								[
									-80.30493164062497,
									42.589697265625034
								],
								[
									-80.10483398437498,
									42.57153320312506
								],
								[
									-80.06210937499998,
									42.55415039062507
								],
								[
									-80.09384765624995,
									42.54638671875
								],
								[
									-80.396630859375,
									42.577392578125
								],
								[
									-80.47304687500002,
									42.57392578125001
								],
								[
									-80.61660156249997,
									42.59584960937502
								],
								[
									-80.82719726562496,
									42.64316406249998
								],
								[
									-81.03916015624998,
									42.662451171875006
								],
								[
									-81.25249023437502,
									42.65375976562501
								],
								[
									-81.40439453124995,
									42.62998046875006
								],
								[
									-81.49492187500002,
									42.59116210937506
								],
								[
									-81.72993164062501,
									42.44658203124999
								],
								[
									-81.80903320312498,
									42.36840820312497
								],
								[
									-81.84082031249997,
									42.29545898437502
								],
								[
									-81.86679687499992,
									42.25834960937502
								],
								[
									-81.88701171874996,
									42.25703125000001
								],
								[
									-81.88671875,
									42.27363281250001
								],
								[
									-81.86591796875001,
									42.30805664062501
								],
								[
									-81.87446289062498,
									42.315039062500034
								],
								[
									-81.92934570312497,
									42.27924804687501
								],
								[
									-81.93789062500002,
									42.268896484375034
								],
								[
									-82.04438476562495,
									42.257226562499966
								],
								[
									-82.16015625,
									42.22275390625006
								],
								[
									-82.311376953125,
									42.15825195312496
								],
								[
									-82.41191406249996,
									42.10322265625004
								],
								[
									-82.46176757812498,
									42.057714843750006
								],
								[
									-82.48984374999995,
									42.00463867187503
								],
								[
									-82.49599609374994,
									41.94404296875001
								],
								[
									-82.51152343749999,
									41.93217773437502
								],
								[
									-82.56723632812498,
									41.99995117187504
								],
								[
									-82.60419921874995,
									42.025244140625034
								],
								[
									-82.64511718749995,
									42.037255859374994
								],
								[
									-82.69003906249995,
									42.03593750000002
								],
								[
									-82.83383789062495,
									41.99721679687502
								],
								[
									-82.93662109375,
									42.00639648437502
								],
								[
									-83.06123046874998,
									42.050195312499966
								],
								[
									-83.10786132812498,
									42.07099609375004
								],
								[
									-83.11723632812493,
									42.11977539062502
								],
								[
									-83.10454101562493,
									42.215185546875006
								],
								[
									-83.07646484374999,
									42.275488281250034
								],
								[
									-83.04667968749996,
									42.297021484374994
								],
								[
									-83.01362304687498,
									42.311865234375006
								],
								[
									-82.97060546875,
									42.326757812500006
								],
								[
									-82.86733398437502,
									42.33525390624996
								],
								[
									-82.589501953125,
									42.314550781250006
								],
								[
									-82.51572265624998,
									42.32177734374997
								],
								[
									-82.46186523437501,
									42.33911132812503
								],
								[
									-82.42797851562494,
									42.36669921874997
								],
								[
									-82.41352539062501,
									42.41108398437504
								],
								[
									-82.41845703124997,
									42.47226562499998
								],
								[
									-82.43212890625,
									42.49780273437503
								],
								[
									-82.45302734375,
									42.495458984375006
								],
								[
									-82.48110351562502,
									42.499853515625006
								],
								[
									-82.613037109375,
									42.52460937499998
								],
								[
									-82.633935546875,
									42.542382812499966
								],
								[
									-82.64511718749995,
									42.55805664062515
								],
								[
									-82.54531249999997,
									42.624707031249955
								],
								[
									-82.4883300781249,
									42.73950195312517
								],
								[
									-82.41723632812497,
									43.01738281250002
								],
								[
									-82.31201171874994,
									43.04326171874996
								],
								[
									-82.1810546875,
									43.085107421874966
								],
								[
									-82.08808593749998,
									43.13266601562506
								],
								[
									-82.03305664062495,
									43.18579101562506
								],
								[
									-81.97412109375003,
									43.22343749999999
								],
								[
									-81.91137695312494,
									43.24560546874997
								],
								[
									-81.84819335937496,
									43.280126953125006
								],
								[
									-81.78452148437495,
									43.32685546875001
								],
								[
									-81.739404296875,
									43.39155273437504
								],
								[
									-81.71279296875,
									43.47407226562498
								],
								[
									-81.70517578124995,
									43.55761718750003
								],
								[
									-81.71650390625004,
									43.64213867187502
								],
								[
									-81.71835937499998,
									43.981591796874994
								],
								[
									-81.73198242187499,
									44.06040039062506
								],
								[
									-81.70810546874992,
									44.130712890625006
								],
								[
									-81.64663085937502,
									44.19248046875006
								],
								[
									-81.60893554687496,
									44.252539062500034
								],
								[
									-81.59497070312497,
									44.31083984375002
								],
								[
									-81.56494140624997,
									44.35966796875002
								],
								[
									-81.51884765625002,
									44.39892578125003
								],
								[
									-81.47431640624998,
									44.424560546875
								],
								[
									-81.43134765625004,
									44.43647460937504
								],
								[
									-81.40219726562495,
									44.460595703124966
								],
								[
									-81.38676757812502,
									44.496923828125006
								],
								[
									-81.35190429687492,
									44.54228515624999
								],
								[
									-81.29750976562494,
									44.59667968749997
								],
								[
									-81.277734375,
									44.643701171874966
								],
								[
									-81.28071289062498,
									44.71625976562501
								],
								[
									-81.278173828125,
									44.789941406249994
								],
								[
									-81.30004882812503,
									44.83198242187504
								],
								[
									-81.34111328124993,
									44.86992187499996
								],
								[
									-81.35834960937498,
									44.911035156249994
								],
								[
									-81.35522460937497,
									44.97753906250003
								],
								[
									-81.37695312499997,
									44.98413085937506
								],
								[
									-81.41547851562498,
									44.98735351562499
								],
								[
									-81.45117187499997,
									45.014990234375034
								],
								[
									-81.49931640624993,
									45.081445312499966
								],
								[
									-81.54145507812498,
									45.12490234375002
								],
								[
									-81.57744140624996,
									45.14541015625005
								],
								[
									-81.59033203125,
									45.165869140625034
								],
								[
									-81.62880859375002,
									45.189111328124966
								],
								[
									-81.68315429687499,
									45.20283203125001
								],
								[
									-81.70605468749994,
									45.223486328125034
								],
								[
									-81.69736328124995,
									45.251220703125
								],
								[
									-81.59536132812497,
									45.26196289062497
								],
								[
									-81.39990234375003,
									45.25561523437503
								],
								[
									-81.296484375,
									45.24873046875004
								],
								[
									-81.28520507812502,
									45.24125976562502
								],
								[
									-81.31582031249994,
									45.18867187500007
								],
								[
									-81.31254882812499,
									45.15625000000003
								],
								[
									-81.28183593749995,
									45.12397460937501
								],
								[
									-81.26416015625,
									45.081347656250045
								],
								[
									-81.25952148437503,
									45.0283203125
								],
								[
									-81.20737304687498,
									45.008691406249994
								],
								[
									-81.19331054687504,
									45.00263671874998
								],
								[
									-81.17998046874999,
									44.974365234375
								],
								[
									-81.13793945312503,
									44.96806640624996
								],
								[
									-81.12499999999997,
									44.952539062499994
								],
								[
									-81.14111328124997,
									44.92778320312502
								],
								[
									-81.13359374999993,
									44.91787109375005
								],
								[
									-81.07402343749999,
									44.91376953125001
								],
								[
									-81.03203124999996,
									44.95693359375002
								],
								[
									-81.01201171874996,
									44.96733398437499
								],
								[
									-80.97275390624995,
									44.96962890625002
								],
								[
									-80.96625976562495,
									44.958642578124994
								],
								[
									-80.992578125,
									44.934375000000045
								],
								[
									-81.00595703124998,
									44.90693359375004
								],
								[
									-81.00634765624994,
									44.87617187499998
								],
								[
									-81.03642578124996,
									44.842822265625045
								],
								[
									-81.12753906249995,
									44.78242187499998
								],
								[
									-81.13017578124996,
									44.769677734374966
								],
								[
									-81.11025390625,
									44.76533203125007
								],
								[
									-81.02197265625003,
									44.802148437499994
								],
								[
									-80.96347656249992,
									44.808984374999966
								],
								[
									-80.91943359375,
									44.796777343749966
								],
								[
									-80.895361328125,
									44.78095703125004
								],
								[
									-80.89116210937493,
									44.761328125000034
								],
								[
									-80.90117187499993,
									44.712011718750034
								],
								[
									-80.92539062499998,
									44.63286132812499
								],
								[
									-80.90966796874997,
									44.617578124999966
								],
								[
									-80.85405273437502,
									44.666113281250006
								],
								[
									-80.78984374999999,
									44.700292968750034
								],
								[
									-80.67016601562494,
									44.72700195312507
								],
								[
									-80.64951171875,
									44.72128906250006
								],
								[
									-80.59287109375,
									44.63852539062498
								],
								[
									-80.46025390624999,
									44.57778320312505
								],
								[
									-80.22597656249997,
									44.509521484375
								],
								[
									-80.08481445312498,
									44.48935546875006
								],
								[
									-80.036962890625,
									44.51738281249999
								],
								[
									-80.0078125,
									44.57167968750005
								],
								[
									-79.99746093749994,
									44.65234375000003
								],
								[
									-80.02114257812497,
									44.70952148437496
								],
								[
									-80.07890625000002,
									44.74311523437507
								],
								[
									-80.10791015624997,
									44.775488281250006
								],
								[
									-80.10820312499993,
									44.806787109374966
								],
								[
									-80.06474609374996,
									44.833593750000006
								],
								[
									-79.99677734374998,
									44.855712890625
								],
								[
									-79.92958984374997,
									44.86298828125007
								],
								[
									-79.92041015624997,
									44.85454101562502
								],
								[
									-79.93530273437497,
									44.82353515625002
								],
								[
									-79.924951171875,
									44.812890624999966
								],
								[
									-79.89130859374998,
									44.80937499999996
								],
								[
									-79.87626953124993,
									44.79853515624998
								],
								[
									-79.82695312499993,
									44.76801757812498
								],
								[
									-79.7173828125,
									44.76118164062501
								],
								[
									-79.67792968750004,
									44.768945312499994
								],
								[
									-79.70859374999998,
									44.791162109374994
								],
								[
									-79.71337890624997,
									44.82114257812506
								],
								[
									-79.69238281249997,
									44.858789062499994
								],
								[
									-79.69594726562497,
									44.87514648437505
								],
								[
									-79.73247070312496,
									44.86293945312505
								],
								[
									-79.73276367187492,
									44.83203125000006
								],
								[
									-79.74960937499998,
									44.81547851562496
								],
								[
									-79.77158203124992,
									44.81933593750006
								],
								[
									-79.7845703125,
									44.85415039062502
								],
								[
									-79.79995117187494,
									44.88486328124998
								],
								[
									-79.82836914062494,
									44.93632812499999
								],
								[
									-79.90239257812493,
									44.95654296875003
								],
								[
									-79.92890625000001,
									44.974365234375
								],
								[
									-79.93178710937497,
									45.00122070312497
								],
								[
									-79.94609374999996,
									45.017187500000034
								],
								[
									-79.97187499999998,
									45.02216796875007
								],
								[
									-80.02158203124998,
									45.072119140625034
								],
								[
									-80.08593750000003,
									45.10937499999997
								],
								[
									-80.08334960937495,
									45.12641601562498
								],
								[
									-80.02265625000001,
									45.13613281250002
								],
								[
									-80.006494140625,
									45.15327148437504
								],
								[
									-80.01538085937494,
									45.175878906250034
								],
								[
									-80.04936523437496,
									45.20405273437498
								],
								[
									-80.07490234375001,
									45.211035156250006
								],
								[
									-80.09218749999997,
									45.196875000000034
								],
								[
									-80.107568359375,
									45.20097656249999
								],
								[
									-80.12109375,
									45.22333984375001
								],
								[
									-80.111474609375,
									45.25922851562504
								],
								[
									-80.04970703125002,
									45.30112304687506
								],
								[
									-80.04111328124995,
									45.342382812500034
								],
								[
									-80.05708007812501,
									45.37456054687502
								],
								[
									-80.09165039062495,
									45.39335937500002
								],
								[
									-80.14482421874993,
									45.398828124999966
								],
								[
									-80.17612304687492,
									45.39658203125006
								],
								[
									-80.18549804687498,
									45.38657226562506
								],
								[
									-80.16767578124998,
									45.348486328125034
								],
								[
									-80.17729492187499,
									45.34384765625006
								],
								[
									-80.27070312500001,
									45.36015624999999
								],
								[
									-80.302490234375,
									45.38310546874996
								],
								[
									-80.349609375,
									45.39926757812498
								],
								[
									-80.38486328125,
									45.45839843750002
								],
								[
									-80.39174804687497,
									45.50053710937499
								],
								[
									-80.38852539062495,
									45.57358398437506
								],
								[
									-80.41401367187498,
									45.61987304687497
								],
								[
									-80.42949218749993,
									45.625244140625
								],
								[
									-80.42705078124999,
									45.59780273437502
								],
								[
									-80.44428710937501,
									45.584130859374966
								],
								[
									-80.48554687499998,
									45.57695312500002
								],
								[
									-80.51069335937495,
									45.589746093749966
								],
								[
									-80.51992187499997,
									45.62255859375
								],
								[
									-80.54550781249995,
									45.650048828124994
								],
								[
									-80.59267578124997,
									45.68203125000002
								],
								[
									-80.62885742187495,
									45.72714843749998
								],
								[
									-80.64101562499997,
									45.74726562499998
								],
								[
									-80.64311523437493,
									45.76718750000006
								],
								[
									-80.65615234375002,
									45.79023437500004
								],
								[
									-80.69643554687497,
									45.81591796875003
								],
								[
									-80.71337890624994,
									45.858496093750006
								],
								[
									-80.73159179687502,
									45.87724609375002
								],
								[
									-80.78662109374994,
									45.91914062500001
								],
								[
									-80.80517578125,
									45.94248046874998
								],
								[
									-80.8177734375,
									45.951025390625034
								],
								[
									-80.89042968749996,
									45.951025390625034
								],
								[
									-80.96796875000004,
									45.95180664062502
								],
								[
									-81.09702148437495,
									45.94160156250007
								],
								[
									-81.16025390624995,
									45.95488281250002
								],
								[
									-81.15751953124993,
									45.99169921875006
								],
								[
									-81.16201171874997,
									46.012060546875034
								],
								[
									-81.17368164062495,
									46.01606445312504
								],
								[
									-81.19130859374997,
									46.00615234374999
								],
								[
									-81.19697265624998,
									45.990966796875
								],
								[
									-81.23681640625,
									45.97412109375003
								],
								[
									-81.30351562500002,
									45.97412109375003
								],
								[
									-81.44941406249998,
									45.99443359374999
								],
								[
									-81.50239257812504,
									45.99296874999996
								],
								[
									-81.59672851562496,
									45.966552734375
								],
								[
									-81.62705078124992,
									45.97802734375003
								],
								[
									-81.59497070312497,
									45.996386718750045
								],
								[
									-81.597265625,
									46.01191406250001
								],
								[
									-81.62382812499999,
									46.016699218750006
								],
								[
									-81.62949218749998,
									46.025390625
								],
								[
									-81.64023437499995,
									46.04003906250006
								],
								[
									-81.54165039062494,
									46.07465820312498
								],
								[
									-81.54453125,
									46.09038085937499
								],
								[
									-81.61533203124995,
									46.11938476562506
								],
								[
									-81.64619140625001,
									46.11528320312502
								],
								[
									-81.66171874999998,
									46.09287109375006
								],
								[
									-81.68867187499995,
									46.07880859375004
								],
								[
									-81.72705078124997,
									46.073095703125034
								],
								[
									-81.75019531249998,
									46.057470703125034
								],
								[
									-81.76518554687502,
									46.057910156250045
								],
								[
									-81.76577148437494,
									46.07143554687505
								],
								[
									-81.76928710937494,
									46.10444335937501
								],
								[
									-81.81660156250001,
									46.11474609375
								],
								[
									-82.01176757812496,
									46.12871093749999
								],
								[
									-82.11582031249995,
									46.13164062499996
								],
								[
									-82.19599609375001,
									46.133935546874994
								],
								[
									-82.31772460937495,
									46.162939453125034
								],
								[
									-82.35004882812495,
									46.193261718749994
								],
								[
									-82.59765624999997,
									46.17709960937498
								],
								[
									-82.63813476562504,
									46.17241210937502
								],
								[
									-82.66362304687499,
									46.17592773437502
								],
								[
									-82.71914062500002,
									46.20712890624998
								],
								[
									-82.89472656250001,
									46.18842773437498
								],
								[
									-83.02548828125,
									46.18129882812505
								],
								[
									-83.45913085937497,
									46.23764648437498
								],
								[
									-83.57172851562498,
									46.26049804687503
								],
								[
									-83.5927734375,
									46.27783203125
								],
								[
									-83.66064453124997,
									46.289843750000045
								],
								[
									-83.84272460937504,
									46.30195312500001
								],
								[
									-83.86313476562495,
									46.30620117187499
								],
								[
									-83.88173828125,
									46.33291015625002
								],
								[
									-83.93422851562494,
									46.34204101562503
								],
								[
									-84.03364257812504,
									46.34379882812502
								],
								[
									-84.09184570312499,
									46.36083984375003
								],
								[
									-84.10878906249997,
									46.393212890624966
								],
								[
									-84.10615234374998,
									46.43046875000002
								],
								[
									-84.08383789062495,
									46.472509765625034
								],
								[
									-84.08710937500001,
									46.50698242187505
								],
								[
									-84.11826171874995,
									46.539453124999994
								],
								[
									-84.16538085937495,
									46.562597656250006
								],
								[
									-84.23564453124999,
									46.556787109374994
								],
								[
									-84.34394531250001,
									46.531152343749994
								],
								[
									-84.43242187500002,
									46.522070312500006
								],
								[
									-84.45888671875,
									46.50385742187504
								],
								[
									-84.47543945312498,
									46.48901367187503
								],
								[
									-84.50053710937493,
									46.483251953125006
								],
								[
									-84.56845703124992,
									46.54331054687498
								],
								[
									-84.56855468750004,
									46.57666015625003
								],
								[
									-84.54760742187503,
									46.59995117187498
								],
								[
									-84.465966796875,
									46.67407226562497
								],
								[
									-84.43813476562502,
									46.72304687500002
								],
								[
									-84.46401367187497,
									46.746923828125006
								],
								[
									-84.48808593749999,
									46.743505859375006
								],
								[
									-84.51025390624997,
									46.712744140625034
								],
								[
									-84.52753906250001,
									46.697363281250034
								],
								[
									-84.53994140624997,
									46.69731445312502
								],
								[
									-84.56103515625,
									46.72978515624996
								],
								[
									-84.55346679687497,
									46.80556640625005
								],
								[
									-84.52773437499997,
									46.83398437500006
								],
								[
									-84.48457031249998,
									46.84765625
								],
								[
									-84.40776367187496,
									46.843652343749994
								],
								[
									-84.38203124999995,
									46.85332031249999
								],
								[
									-84.367431640625,
									46.879980468750006
								],
								[
									-84.38500976562503,
									46.90576171875003
								],
								[
									-84.43476562500004,
									46.93076171875006
								],
								[
									-84.48798828124995,
									46.94404296875001
								],
								[
									-84.54458007812494,
									46.945703124999994
								],
								[
									-84.58208007812493,
									46.93715820312502
								],
								[
									-84.60034179687503,
									46.91840820312501
								],
								[
									-84.62490234374997,
									46.92236328125003
								],
								[
									-84.65566406250002,
									46.94897460937503
								],
								[
									-84.75039062499994,
									46.981250000000045
								],
								[
									-84.77514648437503,
									47.00400390625006
								],
								[
									-84.77167968750001,
									47.03671875000006
								],
								[
									-84.7123046875,
									47.11987304687503
								],
								[
									-84.71953124999996,
									47.14208984375003
								],
								[
									-84.68818359374998,
									47.191162109375
								],
								[
									-84.61826171874995,
									47.267187500000034
								],
								[
									-84.59433593749995,
									47.320214843749994
								],
								[
									-84.61645507812503,
									47.350244140624994
								],
								[
									-84.64116210937499,
									47.367041015625034
								],
								[
									-84.66845703124994,
									47.37060546875006
								],
								[
									-84.69331054687495,
									47.390478515625006
								],
								[
									-84.71562499999996,
									47.426660156249994
								],
								[
									-84.77133789062495,
									47.46166992187503
								],
								[
									-84.86044921874998,
									47.495507812499994
								],
								[
									-84.93583984374999,
									47.53984374999996
								],
								[
									-84.99760742187496,
									47.59477539062496
								],
								[
									-85.01425781249998,
									47.63876953125006
								],
								[
									-84.98583984374994,
									47.671728515625006
								],
								[
									-84.97480468750001,
									47.69799804687503
								],
								[
									-84.98110351562497,
									47.717626953125034
								],
								[
									-84.96098632812496,
									47.74580078125001
								],
								[
									-84.92246093749992,
									47.792578125000034
								],
								[
									-84.920263671875,
									47.82788085937503
								],
								[
									-84.91518554687494,
									47.855126953124994
								],
								[
									-84.86738281249998,
									47.89643554687507
								],
								[
									-84.84726562499998,
									47.92802734375002
								],
								[
									-84.85473632812497,
									47.94995117187503
								],
								[
									-84.96357421875004,
									47.960205078125
								],
								[
									-85.17382812499997,
									47.958984375
								],
								[
									-85.34248046874995,
									47.95024414062502
								],
								[
									-85.46953124999999,
									47.93408203125
								],
								[
									-85.61459960937498,
									47.94072265625002
								],
								[
									-85.77768554687498,
									47.97016601562507
								],
								[
									-85.91362304687496,
									48.029541015625
								],
								[
									-86.02241210937501,
									48.118798828124966
								],
								[
									-86.10415039062497,
									48.21030273437506
								],
								[
									-86.15893554687503,
									48.30395507812503
								],
								[
									-86.181005859375,
									48.385351562500006
								],
								[
									-86.19135742187498,
									48.405566406250045
								],
								[
									-86.21552734375001,
									48.422949218750034
								],
								[
									-86.23740234374995,
									48.470605468749966
								],
								[
									-86.25698242187502,
									48.548437500000006
								],
								[
									-86.28256835937498,
									48.59794921874999
								],
								[
									-86.31425781249996,
									48.61909179687501
								],
								[
									-86.324951171875,
									48.63662109375005
								],
								[
									-86.37099609374997,
									48.68754882812502
								],
								[
									-86.39018554687499,
									48.71411132812503
								],
								[
									-86.39614257812494,
									48.73129882812506
								],
								[
									-86.43242187499996,
									48.758154296875006
								],
								[
									-86.45927734375002,
									48.76494140624999
								],
								[
									-86.58095703124994,
									48.753027343750034
								],
								[
									-86.62143554687492,
									48.77749023437505
								],
								[
									-86.64287109374993,
									48.794580078124966
								],
								[
									-86.69252929687502,
									48.80791015625002
								],
								[
									-86.75156249999998,
									48.80058593749996
								],
								[
									-86.81987304687493,
									48.772558593750034
								],
								[
									-86.88764648437498,
									48.77241210937498
								],
								[
									-87.008544921875,
									48.78881835937506
								],
								[
									-87.08471679687497,
									48.77890624999998
								],
								[
									-87.22363281249994,
									48.775781249999966
								],
								[
									-87.31142578125,
									48.79941406249998
								],
								[
									-87.40708007812492,
									48.834814453125006
								],
								[
									-87.46372070312492,
									48.84204101562506
								],
								[
									-87.51728515625001,
									48.83857421875007
								],
								[
									-87.55200195312497,
									48.84833984375001
								],
								[
									-87.5677734375,
									48.871240234374966
								],
								[
									-87.59160156249996,
									48.87817382812506
								],
								[
									-87.68525390625004,
									48.89921874999999
								],
								[
									-87.76093749999998,
									48.91992187500003
								],
								[
									-87.96562499999996,
									48.95869140625001
								],
								[
									-88.02250976562499,
									48.998681640624994
								],
								[
									-88.06982421874994,
									49.00141601562501
								],
								[
									-88.12822265624993,
									48.99814453125006
								],
								[
									-88.16064453124997,
									48.98164062499998
								],
								[
									-88.200439453125,
									48.97744140625002
								],
								[
									-88.24755859375,
									48.98554687499998
								],
								[
									-88.26357421875,
									48.97368164062496
								],
								[
									-88.24863281249995,
									48.94189453124997
								],
								[
									-88.24658203125,
									48.91699218750006
								],
								[
									-88.22431640624998,
									48.86713867187501
								],
								[
									-88.147216796875,
									48.82075195312498
								],
								[
									-88.1087890625,
									48.775976562500006
								],
								[
									-88.10917968749996,
									48.73291015625003
								],
								[
									-88.13842773437497,
									48.68286132812506
								],
								[
									-88.23310546874998,
									48.596972656250045
								],
								[
									-88.24799804687501,
									48.595947265625
								],
								[
									-88.32548828124999,
									48.58447265624997
								],
								[
									-88.36875,
									48.56240234375002
								],
								[
									-88.399658203125,
									48.55727539062505
								],
								[
									-88.41816406250004,
									48.56914062499996
								],
								[
									-88.44350585937497,
									48.56025390625001
								],
								[
									-88.47583007812497,
									48.53066406250002
								],
								[
									-88.48945312499998,
									48.50659179687503
								],
								[
									-88.48447265624995,
									48.48808593749999
								],
								[
									-88.50092773437501,
									48.46699218750004
								],
								[
									-88.53876953125001,
									48.44340820312502
								],
								[
									-88.55937499999993,
									48.44682617187502
								],
								[
									-88.56933593750003,
									48.47392578125002
								],
								[
									-88.58452148437499,
									48.49243164062497
								],
								[
									-88.56650390624998,
									48.52802734375004
								],
								[
									-88.39379882812497,
									48.655810546875045
								],
								[
									-88.33359374999995,
									48.70908203125006
								],
								[
									-88.32285156249998,
									48.73847656250001
								],
								[
									-88.32915039062493,
									48.775683593750045
								],
								[
									-88.35244140624997,
									48.82080078125
								],
								[
									-88.39531249999999,
									48.84487304687502
								],
								[
									-88.4576171875,
									48.84785156249998
								],
								[
									-88.50263671875001,
									48.83305664062499
								],
								[
									-88.53515624999997,
									48.785693359375045
								],
								[
									-88.54243164062504,
									48.75322265624999
								],
								[
									-88.55195312500004,
									48.68374023437505
								],
								[
									-88.54960937499999,
									48.65815429687498
								],
								[
									-88.56533203125,
									48.63984374999998
								],
								[
									-88.60209960937493,
									48.62993164062502
								],
								[
									-88.62529296874996,
									48.598730468750034
								],
								[
									-88.63486328124995,
									48.54609374999998
								],
								[
									-88.65410156249996,
									48.51655273437501
								],
								[
									-88.68315429687493,
									48.510107421875034
								],
								[
									-88.705712890625,
									48.47612304687502
								],
								[
									-88.72192382812503,
									48.41459960937502
								],
								[
									-88.73437499999997,
									48.38408203125002
								],
								[
									-88.782861328125,
									48.368310546874994
								],
								[
									-88.88847656250002,
									48.337304687499994
								],
								[
									-88.93271484374998,
									48.33540039062504
								],
								[
									-88.91567382812497,
									48.36274414062501
								],
								[
									-88.89692382812495,
									48.37807617187502
								],
								[
									-88.87641601562495,
									48.38149414062502
								],
								[
									-88.81826171875002,
									48.50644531249998
								],
								[
									-88.76376953124992,
									48.572363281250006
								],
								[
									-88.774560546875,
									48.58305664062496
								],
								[
									-89.08642578125003,
									48.49765625000006
								],
								[
									-89.20073242187496,
									48.45083007812502
								],
								[
									-89.22500000000002,
									48.417578125000006
								],
								[
									-89.22939453125002,
									48.38227539062501
								],
								[
									-89.21391601562496,
									48.34492187500004
								],
								[
									-89.22148437500002,
									48.31074218749998
								],
								[
									-89.25224609374996,
									48.27973632812498
								],
								[
									-89.29667968749996,
									48.204248046874966
								],
								[
									-89.31513671874998,
									48.15898437499999
								],
								[
									-89.34541015625004,
									48.12114257812502
								],
								[
									-89.43847656249997,
									48.098779296874966
								],
								[
									-89.44965820312504,
									48.09223632812507
								],
								[
									-89.54746093749998,
									48.012939453125
								],
								[
									-89.57755546283573,
									48.00175342324741
								],
								[
									-89.77539062499997,
									48.015332031250125
								],
								[
									-89.90102539062497,
									47.99545898437506
								],
								[
									-89.99365234374994,
									48.015332031250125
								],
								[
									-90.03994140624994,
									48.078173828125045
								],
								[
									-90.09179687500003,
									48.11811523437501
								],
								[
									-90.3201171874999,
									48.09916992187516
								],
								[
									-90.60708007812494,
									48.112597656250045
								],
								[
									-90.74438476562494,
									48.104589843750006
								],
								[
									-90.79731445312495,
									48.13105468749998
								],
								[
									-90.84033203125003,
									48.200537109375006
								],
								[
									-90.9160644531249,
									48.20913085937508
								],
								[
									-91.04345703124994,
									48.19370117187495
								],
								[
									-91.22065429687498,
									48.104589843750006
								],
								[
									-91.38720703124997,
									48.058544921874955
								],
								[
									-91.51831054687494,
									48.05830078125018
								],
								[
									-91.64731445312495,
									48.104589843750006
								],
								[
									-91.85839843749994,
									48.19755859375013
								],
								[
									-92.00517578125002,
									48.30185546875006
								],
								[
									-92.17177734374994,
									48.33837890624994
								],
								[
									-92.29868164062495,
									48.32890624999996
								],
								[
									-92.34843749999996,
									48.27661132812497
								],
								[
									-92.41459960937493,
									48.27661132812497
								],
								[
									-92.46088867187495,
									48.365869140625136
								],
								[
									-92.50058593749995,
									48.435351562500074
								],
								[
									-92.58325195312491,
									48.465087890625
								],
								[
									-92.73266601562489,
									48.531835937500006
								],
								[
									-92.83671874999996,
									48.56777343750005
								],
								[
									-92.99624023437494,
									48.61181640625014
								],
								[
									-93.05170898437498,
									48.619873046875085
								],
								[
									-93.15522460937493,
									48.62534179687506
								],
								[
									-93.25795898437497,
									48.62885742187507
								],
								[
									-93.37788085937498,
									48.61655273437495
								],
								[
									-93.46362304687494,
									48.56127929687506
								],
								[
									-93.56425781249993,
									48.53691406250016
								],
								[
									-93.70771484374995,
									48.52543945312513
								],
								[
									-93.80356445312492,
									48.54892578125012
								],
								[
									-93.85161132812496,
									48.607275390625006
								],
								[
									-94.05517578125003,
									48.65903320312498
								],
								[
									-94.41416015624989,
									48.704101562500114
								],
								[
									-94.6208984374999,
									48.74262695312515
								],
								[
									-94.6753417968749,
									48.77441406250006
								],
								[
									-94.70507812499991,
									48.808496093749966
								],
								[
									-94.71254882812494,
									48.86298828125015
								],
								[
									-94.71279296875,
									48.863427734374966
								],
								[
									-94.80346679687497,
									49.00292968749997
								],
								[
									-94.84257812499996,
									49.11918945312513
								],
								[
									-94.86040039062493,
									49.2585937500001
								],
								[
									-94.85434570312495,
									49.304589843749966
								],
								[
									-94.87480468749996,
									49.31904296875007
								],
								[
									-94.93935546874997,
									49.34941406250013
								],
								[
									-95.15527343749997,
									49.369677734375074
								],
								[
									-95.15825195312496,
									49.20307617187507
								],
								[
									-95.16206054687493,
									48.9917480468751
								],
								[
									-95.39790039062493,
									48.99316406250003
								],
								[
									-95.82431640624995,
									48.99316406250003
								],
								[
									-96.25068359374995,
									48.99316406250003
								],
								[
									-96.67705078124993,
									48.99316406250003
								],
								[
									-97.10346679687495,
									48.99316406250003
								],
								[
									-97.52983398437496,
									48.99316406250003
								],
								[
									-97.95620117187494,
									48.99316406250003
								],
								[
									-98.38261718749996,
									48.99316406250003
								],
								[
									-98.80898437499995,
									48.99316406250003
								],
								[
									-99.23535156249996,
									48.99311523437501
								],
								[
									-99.66171874999995,
									48.99311523437501
								],
								[
									-100.08813476562496,
									48.99311523437501
								],
								[
									-100.51450195312496,
									48.99311523437501
								],
								[
									-100.94086914062495,
									48.99311523437501
								],
								[
									-101.36728515624988,
									48.99311523437501
								],
								[
									-101.79365234374997,
									48.99311523437501
								],
								[
									-102.22001953124996,
									48.99311523437501
								],
								[
									-102.64643554687497,
									48.99311523437501
								],
								[
									-103.07280273437497,
									48.99311523437501
								],
								[
									-103.49916992187497,
									48.99311523437501
								],
								[
									-103.92558593749989,
									48.99311523437501
								],
								[
									-104.35195312499998,
									48.99311523437501
								],
								[
									-104.77832031249997,
									48.99311523437501
								],
								[
									-105.20468749999988,
									48.99311523437501
								],
								[
									-105.63110351562499,
									48.99311523437501
								],
								[
									-106.05747070312489,
									48.99311523437501
								],
								[
									-106.48383789062498,
									48.99311523437501
								],
								[
									-106.91025390624989,
									48.99311523437501
								],
								[
									-107.33662109374998,
									48.99311523437501
								],
								[
									-107.76298828124989,
									48.99311523437501
								],
								[
									-108.189404296875,
									48.99311523437501
								],
								[
									-108.6157714843749,
									48.99311523437501
								],
								[
									-109.042138671875,
									48.99311523437501
								],
								[
									-109.4685546874999,
									48.99306640625019
								],
								[
									-109.894921875,
									48.99306640625019
								],
								[
									-110.3212890624999,
									48.99306640625019
								],
								[
									-110.7476562499999,
									48.99306640625019
								],
								[
									-111.17407226562491,
									48.99306640625019
								],
								[
									-111.6004394531249,
									48.99306640625019
								],
								[
									-112.02680664062491,
									48.99306640625019
								],
								[
									-112.45322265625,
									48.99306640625019
								],
								[
									-112.87958984374991,
									48.99306640625019
								],
								[
									-113.30595703124992,
									48.99306640625019
								],
								[
									-113.73237304687493,
									48.99306640625019
								],
								[
									-114.15874023437492,
									48.99306640625019
								],
								[
									-114.58510742187492,
									48.99306640625019
								],
								[
									-115.01152343750002,
									48.99306640625019
								],
								[
									-115.43789062499992,
									48.99306640625019
								],
								[
									-115.86425781249993,
									48.99306640625019
								],
								[
									-116.29062499999992,
									48.99306640625019
								],
								[
									-116.71704101562493,
									48.99306640625019
								],
								[
									-117.14340820312493,
									48.99306640625019
								],
								[
									-117.56977539062493,
									48.99306640625019
								],
								[
									-117.99619140624993,
									48.99306640625019
								],
								[
									-118.42255859374994,
									48.99306640625019
								],
								[
									-118.84892578124993,
									48.99306640625019
								],
								[
									-119.27534179687494,
									48.99306640625019
								],
								[
									-119.70170898437495,
									48.99301757812509
								],
								[
									-120.12807617187494,
									48.99301757812509
								],
								[
									-120.55449218749995,
									48.99301757812509
								],
								[
									-120.98085937499995,
									48.99301757812509
								],
								[
									-121.40722656249994,
									48.99301757812509
								],
								[
									-121.83359374999995,
									48.99301757812509
								],
								[
									-122.26000976562496,
									48.99301757812509
								],
								[
									-122.68637695312495,
									48.99301757812509
								],
								[
									-122.78876953124994,
									48.99301757812509
								],
								[
									-122.82670898437495,
									49.028417968750006
								],
								[
									-122.9241699218749,
									49.07465820312501
								],
								[
									-122.96269531249993,
									49.07460937500011
								],
								[
									-123.002294921875,
									49.06088867187515
								],
								[
									-123.02724609374994,
									49.03852539062504
								],
								[
									-123.04921874999998,
									48.99301757812509
								],
								[
									-123.06328125,
									48.97773437499998
								],
								[
									-123.07729492187501,
									48.98022460937506
								],
								[
									-123.08642578124991,
									48.99301757812509
								],
								[
									-123.11762695312497,
									49.05634765625001
								],
								[
									-123.10932617187497,
									49.08461914062519
								],
								[
									-123.07729492187492,
									49.11835937500004
								],
								[
									-123.07954101562494,
									49.13061523437514
								],
								[
									-123.15014648437493,
									49.12104492187515
								],
								[
									-123.18188476562491,
									49.12949218750009
								],
								[
									-123.19633789062502,
									49.14770507812497
								],
								[
									-123.19106445312492,
									49.219531250000045
								],
								[
									-123.22944335937493,
									49.26049804687514
								],
								[
									-123.18393554687489,
									49.277734374999994
								],
								[
									-123.06728515624992,
									49.291552734375074
								],
								[
									-122.94765624999998,
									49.29326171874996
								],
								[
									-122.91298828124994,
									49.323193359375125
								],
								[
									-122.87910156249995,
									49.39892578125
								],
								[
									-122.96445312499993,
									49.32934570312503
								],
								[
									-123.01552734374995,
									49.322167968749994
								],
								[
									-123.17426757812497,
									49.34819335937496
								],
								[
									-123.27675781249997,
									49.34394531249998
								],
								[
									-123.29052734374993,
									49.35947265624995
								],
								[
									-123.28627929687495,
									49.37495117187518
								],
								[
									-123.26406250000005,
									49.39047851562515
								],
								[
									-123.24770507812501,
									49.44301757812519
								],
								[
									-123.22299804687495,
									49.59047851562494
								],
								[
									-123.19067382812493,
									49.64428710937517
								],
								[
									-123.17958984374998,
									49.67353515624998
								],
								[
									-123.1874999999999,
									49.68032226562505
								],
								[
									-123.32499999999995,
									49.5776855468751
								],
								[
									-123.33666992187491,
									49.54511718750004
								],
								[
									-123.32241210937495,
									49.516992187500165
								],
								[
									-123.33564453124998,
									49.45917968750001
								],
								[
									-123.39897460937492,
									49.44189453125014
								],
								[
									-123.43696289062493,
									49.45131835937511
								],
								[
									-123.50820312500005,
									49.402441406250006
								],
								[
									-123.5305664062499,
									49.39731445312512
								],
								[
									-123.85893554687492,
									49.48286132812504
								],
								[
									-123.89184570312496,
									49.49472656249998
								],
								[
									-123.94838867187494,
									49.534716796875045
								],
								[
									-124.02861328125002,
									49.60288085937498
								],
								[
									-124.05380859375,
									49.66171875000006
								],
								[
									-124.02402343749989,
									49.71132812500005
								],
								[
									-123.99262695312497,
									49.73618164062506
								],
								[
									-123.95952148437489,
									49.73618164062506
								],
								[
									-123.92275390624995,
									49.71752929687517
								],
								[
									-123.847119140625,
									49.63666992187504
								],
								[
									-123.81718749999993,
									49.586572265625136
								],
								[
									-123.73906249999992,
									49.59355468750013
								],
								[
									-123.61274414062494,
									49.657568359375034
								],
								[
									-123.582470703125,
									49.68125000000006
								],
								[
									-123.70830078124996,
									49.65693359374998
								],
								[
									-123.76269531250003,
									49.658496093750045
								],
								[
									-123.81801757812492,
									49.68515625000015
								],
								[
									-123.87441406250005,
									49.736816406250085
								],
								[
									-123.90380859374991,
									49.79545898437496
								],
								[
									-123.90424804687491,
									49.981152343749955
								],
								[
									-123.88496093749998,
									50.01704101562498
								],
								[
									-123.82382812499996,
									50.043701171875085
								],
								[
									-123.78466796874997,
									50.08798828125015
								],
								[
									-123.78769531249988,
									50.10673828124996
								],
								[
									-123.82543945312493,
									50.144238281249955
								],
								[
									-123.88012695312497,
									50.1736328124999
								],
								[
									-123.93359375000003,
									50.188281250000045
								],
								[
									-123.94589843749996,
									50.18393554687515
								],
								[
									-123.86303710937496,
									50.1025878906251
								],
								[
									-123.86572265624997,
									50.0720703125001
								],
								[
									-123.957421875,
									49.992773437500006
								],
								[
									-123.97138671874991,
									49.969531250000074
								],
								[
									-123.97211914062497,
									49.8920410156251
								],
								[
									-123.98491210937492,
									49.875585937500034
								],
								[
									-124.05878906250004,
									49.85366210937519
								],
								[
									-124.14160156249994,
									49.7926757812501
								],
								[
									-124.28124999999997,
									49.772119140624994
								],
								[
									-124.41259765624991,
									49.778125000000074
								],
								[
									-124.483251953125,
									49.80820312500006
								],
								[
									-124.70229492187495,
									49.957666015624966
								],
								[
									-124.78237304687492,
									50.02011718749989
								],
								[
									-124.78427734374996,
									50.072802734375074
								],
								[
									-124.93417968749995,
									50.25805664062506
								],
								[
									-124.93334960937496,
									50.2979003906251
								],
								[
									-124.98559570312503,
									50.355615234375136
								],
								[
									-125.04360351562495,
									50.363769531249915
								],
								[
									-125.05668945312495,
									50.41865234375018
								],
								[
									-124.93681640624995,
									50.537402343750045
								],
								[
									-124.86264648437493,
									50.63730468750015
								],
								[
									-124.85424804687491,
									50.66865234375004
								],
								[
									-124.85751953124996,
									50.7173339843751
								],
								[
									-124.87543945312497,
									50.82563476562504
								],
								[
									-124.8598632812499,
									50.87241210937498
								],
								[
									-124.93359374999991,
									50.8105957031251
								],
								[
									-124.94926757812492,
									50.76469726562516
								],
								[
									-124.93105468749994,
									50.71840820312505
								],
								[
									-124.94252929687505,
									50.665673828124966
								],
								[
									-124.9854003906249,
									50.591943359375136
								],
								[
									-125.05878906249993,
									50.51386718750004
								],
								[
									-125.20986328124998,
									50.47631835937503
								],
								[
									-125.4763183593749,
									50.49716796874992
								],
								[
									-125.50717773437489,
									50.507275390625125
								],
								[
									-125.52597656249989,
									50.53413085937498
								],
								[
									-125.53935546874996,
									50.64902343749995
								],
								[
									-125.55556640624998,
									50.634863281250006
								],
								[
									-125.58583984374992,
									50.573632812500136
								],
								[
									-125.6101562499999,
									50.486035156249955
								],
								[
									-125.64130859374994,
									50.46621093750011
								],
								[
									-125.69755859374995,
									50.464550781250125
								],
								[
									-125.74121093749996,
									50.47856445312513
								],
								[
									-125.77241210937493,
									50.508203125000136
								],
								[
									-125.83959960937493,
									50.510644531249994
								],
								[
									-125.9650390625,
									50.487353515625045
								],
								[
									-126.02412109375004,
									50.49672851562511
								],
								[
									-126.09433593749996,
									50.4976074218751
								],
								[
									-126.23657226562499,
									50.523291015625006
								],
								[
									-126.4044921875,
									50.529882812500006
								],
								[
									-126.44995117187493,
									50.549707031249966
								],
								[
									-126.44746093750004,
									50.58774414062489
								],
								[
									-126.41611328124988,
									50.6069824218749
								],
								[
									-126.23891601562492,
									50.62382812499996
								],
								[
									-126.06723632812495,
									50.66430664062514
								],
								[
									-125.89760742187494,
									50.684375000000045
								],
								[
									-125.90410156250002,
									50.70493164062506
								],
								[
									-125.9807128906249,
									50.71137695312504
								],
								[
									-126.37031249999995,
									50.666748046875
								],
								[
									-126.4929687499999,
									50.67211914062503
								],
								[
									-126.51435546875,
									50.6793945312501
								],
								[
									-126.51733398437499,
									50.724462890625034
								],
								[
									-126.47221679687493,
									50.76728515625015
								],
								[
									-126.39711914062501,
									50.8070800781251
								],
								[
									-126.37460937499995,
									50.83735351562504
								],
								[
									-126.41821289062494,
									50.85019531249989
								],
								[
									-126.48818359375,
									50.841845703125074
								],
								[
									-126.5217773437499,
									50.866064453125034
								],
								[
									-126.48461914062497,
									50.96049804687499
								],
								[
									-126.51733398437499,
									51.05683593750007
								],
								[
									-126.56289062499994,
									50.96547851562511
								],
								[
									-126.63178710937494,
									50.91513671874998
								],
								[
									-126.96040039062491,
									50.89370117187505
								],
								[
									-127.01406249999992,
									50.866796875000006
								],
								[
									-127.057568359375,
									50.86752929687515
								],
								[
									-127.26748046874995,
									50.91606445312499
								],
								[
									-127.35693359374997,
									50.94555664062506
								],
								[
									-127.4412109374999,
									50.98940429687511
								],
								[
									-127.59086914062502,
									51.08754882812511
								],
								[
									-127.70810546875,
									51.15117187499993
								],
								[
									-127.71430664062494,
									51.26865234375006
								],
								[
									-127.68916015624997,
									51.343457031250125
								],
								[
									-127.63271484374992,
									51.427294921875045
								],
								[
									-127.41967773437496,
									51.60805664062511
								],
								[
									-127.34658203125,
									51.64238281249999
								],
								[
									-127.28066406250007,
									51.654101562500074
								],
								[
									-126.96811523437489,
									51.669921874999915
								],
								[
									-126.7354003906249,
									51.69262695312503
								],
								[
									-126.69145507812502,
									51.70341796874999
								],
								[
									-127.03408203125001,
									51.716699218750136
								],
								[
									-127.33872070312489,
									51.707373046875006
								],
								[
									-127.44272460937495,
									51.678955078125085
								],
								[
									-127.57573242187496,
									51.56293945312507
								],
								[
									-127.60957031249993,
									51.514062499999966
								],
								[
									-127.644873046875,
									51.4784667968751
								],
								[
									-127.66870117187497,
									51.47758789062499
								],
								[
									-127.71406249999998,
									51.49018554687507
								],
								[
									-127.72871093749994,
									51.505517578124994
								],
								[
									-127.74750976562504,
									51.543554687500034
								],
								[
									-127.81894531249995,
									51.603906249999966
								],
								[
									-127.85053710937498,
									51.67319335937515
								],
								[
									-127.86914062499996,
									51.77524414062506
								],
								[
									-127.863232421875,
									51.82080078125003
								],
								[
									-127.82998046875007,
									51.87900390625006
								],
								[
									-127.7276367187499,
									51.99321289062516
								],
								[
									-127.85878906249998,
									51.99028320312499
								],
								[
									-127.84331054687502,
									52.086474609375045
								],
								[
									-127.79536132812494,
									52.191015625000034
								],
								[
									-127.67333984375003,
									52.25292968750003
								],
								[
									-127.54970703124998,
									52.29760742187517
								],
								[
									-127.43793945312504,
									52.3561523437501
								],
								[
									-127.24223632812496,
									52.39511718750015
								],
								[
									-127.17573242187491,
									52.314843750000136
								],
								[
									-127.00795898437492,
									52.29067382812508
								],
								[
									-126.9594726562499,
									52.25454101562511
								],
								[
									-126.89999999999996,
									52.18833007812512
								],
								[
									-126.82631835937495,
									52.12514648437511
								],
								[
									-126.73857421875002,
									52.06494140625003
								],
								[
									-126.71396484374989,
									52.06069335937505
								],
								[
									-126.75263671875004,
									52.11235351562499
								],
								[
									-126.89521484375005,
									52.22548828125005
								],
								[
									-126.90141601562489,
									52.26533203125007
								],
								[
									-126.93818359374993,
									52.30859375
								],
								[
									-127.12705078124993,
									52.37094726562492
								],
								[
									-127.16059570312494,
									52.39487304687509
								],
								[
									-127.193994140625,
									52.457666015624994
								],
								[
									-127.20825195312496,
									52.4982421875001
								],
								[
									-127.187109375,
									52.53769531250006
								],
								[
									-126.9952148437499,
									52.65791015625004
								],
								[
									-126.95131835937494,
									52.721240234375045
								],
								[
									-126.95136718749994,
									52.751025390625074
								],
								[
									-126.96640624999989,
									52.78466796875
								],
								[
									-127.00825195312498,
									52.842578125000074
								],
								[
									-127.01933593750002,
									52.84248046875015
								],
								[
									-127.00639648437496,
									52.7545898437501
								],
								[
									-127.01323242187502,
									52.71997070312497
								],
								[
									-127.03486328124998,
									52.68173828125009
								],
								[
									-127.06621093749989,
									52.652685546875034
								],
								[
									-127.10708007812495,
									52.63281249999997
								],
								[
									-127.51923828125,
									52.35927734375002
								],
								[
									-127.56030273437491,
									52.343212890624955
								],
								[
									-127.71337890624993,
									52.318505859375165
								],
								[
									-127.79189453124994,
									52.28935546874999
								],
								[
									-127.83432617187488,
									52.250976562500085
								],
								[
									-127.90219726562493,
									52.15087890625003
								],
								[
									-127.99541015624992,
									51.95053710937506
								],
								[
									-128.10224609374993,
									51.788427734375006
								],
								[
									-128.19355468749995,
									51.99829101562503
								],
								[
									-128.3576171875,
									52.15888671875015
								],
								[
									-128.03750000000008,
									52.3181640625001
								],
								[
									-128.02915039062498,
									52.34248046874998
								],
								[
									-128.06030273437491,
									52.427539062500074
								],
								[
									-128.0515624999999,
									52.4533203125001
								],
								[
									-128.02128906249996,
									52.49067382812507
								],
								[
									-127.94023437499996,
									52.54516601562506
								],
								[
									-127.94335937499997,
									52.550732421874955
								],
								[
									-128.03823242187494,
									52.53115234375005
								],
								[
									-128.18398437500008,
									52.40791015624998
								],
								[
									-128.24096679687503,
									52.368261718750006
								],
								[
									-128.27153320312496,
									52.36298828125007
								],
								[
									-128.275146484375,
									52.4354980468751
								],
								[
									-128.19677734374991,
									52.623291015625085
								],
								[
									-128.13237304687505,
									52.80581054687505
								],
								[
									-128.1087890624999,
									52.858056640625136
								],
								[
									-128.0532714843749,
									52.91069335937502
								],
								[
									-128.10595703124997,
									52.906884765625136
								],
								[
									-128.3650390624999,
									52.825781250000034
								],
								[
									-128.45195312500005,
									52.87661132812508
								],
								[
									-128.52470703125002,
									53.14067382812516
								],
								[
									-128.65234374999991,
									53.24384765625004
								],
								[
									-128.8685546875,
									53.32812500000006
								],
								[
									-129.08090820312492,
									53.367285156250034
								],
								[
									-129.12954101562505,
									53.442285156250136
								],
								[
									-129.1715820312499,
									53.533593749999994
								],
								[
									-129.114453125,
									53.64111328125014
								],
								[
									-129.02143554687507,
									53.69213867187506
								],
								[
									-128.935595703125,
									53.715185546875034
								],
								[
									-128.85458984374992,
									53.7045410156251
								],
								[
									-128.85043945312495,
									53.66518554687508
								],
								[
									-128.90561523437492,
									53.559326171875085
								],
								[
									-128.83305664062496,
									53.54941406250012
								],
								[
									-128.5421386718749,
									53.42065429687517
								],
								[
									-128.47861328124995,
									53.41030273437519
								],
								[
									-128.358056640625,
									53.45981445312506
								],
								[
									-128.29106445312505,
									53.45786132812512
								],
								[
									-128.13271484375002,
									53.41777343750002
								],
								[
									-128.07919921874992,
									53.369433593750045
								],
								[
									-127.92783203125,
									53.2747070312501
								],
								[
									-127.950048828125,
									53.32983398437514
								],
								[
									-128.11513671874997,
									53.44594726562508
								],
								[
									-128.2072265624999,
									53.48320312500013
								],
								[
									-128.36914062500003,
									53.490380859375165
								],
								[
									-128.46962890625,
									53.47089843750001
								],
								[
									-128.51176757812496,
									53.476562499999915
								],
								[
									-128.60034179687497,
									53.50610351562517
								],
								[
									-128.67553710937494,
									53.55458984375011
								],
								[
									-128.75078124999987,
									53.66083984374998
								],
								[
									-128.7678710937499,
									53.710205078125085
								],
								[
									-128.76367187500003,
									53.74687500000002
								],
								[
									-128.74594726562486,
									53.78017578125005
								],
								[
									-128.7147460937499,
									53.8100097656251
								],
								[
									-128.65288085937502,
									53.83164062500006
								],
								[
									-128.5604492187499,
									53.845068359375034
								],
								[
									-128.53212890624994,
									53.858105468750125
								],
								[
									-128.65087890624997,
									53.918847656249966
								],
								[
									-128.70478515624995,
									53.91860351562519
								],
								[
									-128.89018554687496,
									53.82978515625004
								],
								[
									-128.92783203124992,
									53.82280273437493
								],
								[
									-128.943994140625,
									53.84003906250007
								],
								[
									-128.95937499999994,
									53.84145507812511
								],
								[
									-129.01396484374993,
									53.79746093749992
								],
								[
									-129.056396484375,
									53.7777832031251
								],
								[
									-129.2081054687499,
									53.64160156249997
								],
								[
									-129.2317382812499,
									53.576416015625114
								],
								[
									-129.24033203124986,
									53.479052734375074
								],
								[
									-129.2578613281249,
									53.41796875000006
								],
								[
									-129.28427734374995,
									53.39316406249998
								],
								[
									-129.46240234374991,
									53.34658203125008
								],
								[
									-129.56372070312506,
									53.25146484375017
								],
								[
									-129.68671875000007,
									53.33354492187502
								],
								[
									-129.82177734375003,
									53.412744140625165
								],
								[
									-129.91186523437491,
									53.55136718750006
								],
								[
									-130.07436523437497,
									53.575634765625125
								],
								[
									-130.26328125,
									53.654150390625034
								],
								[
									-130.33525390625002,
									53.723925781250045
								],
								[
									-130.23286132812495,
									53.86743164062497
								],
								[
									-130.08593750000003,
									53.97578125000001
								],
								[
									-130.0635253906249,
									54.10566406250001
								],
								[
									-130.04331054687498,
									54.133544921875
								],
								[
									-129.79077148437494,
									54.165771484375
								],
								[
									-129.62602539062493,
									54.23027343749999
								],
								[
									-129.7949707031249,
									54.236132812500045
								],
								[
									-129.89843749999994,
									54.2263671874999
								],
								[
									-130.08422851562503,
									54.181396484375085
								],
								[
									-130.29033203124993,
									54.27036132812509
								],
								[
									-130.39677734375005,
									54.351660156250034
								],
								[
									-130.4302734375,
									54.42099609374995
								],
								[
									-130.39345703125008,
									54.479638671874994
								],
								[
									-130.38862304687507,
									54.539355468750074
								],
								[
									-130.37001953125,
									54.620019531249994
								],
								[
									-130.3504882812499,
									54.655322265625074
								],
								[
									-130.30722656249992,
									54.700292968750006
								],
								[
									-130.21894531249995,
									54.730273437500074
								],
								[
									-130.14086914062503,
									54.822753906250085
								],
								[
									-130.10864257812503,
									54.887255859375074
								],
								[
									-129.94853515624993,
									55.08105468749994
								],
								[
									-129.89013671874994,
									55.16464843749992
								],
								[
									-129.78076171875003,
									55.28046875000007
								],
								[
									-129.56064453124995,
									55.462548828125136
								],
								[
									-129.630126953125,
									55.45224609374989
								],
								[
									-129.66665039062505,
									55.43666992187519
								],
								[
									-129.70131835937502,
									55.43857421874995
								],
								[
									-129.73417968749993,
									55.4580078125
								],
								[
									-129.76547851562492,
									55.498242187500125
								],
								[
									-129.79516601562503,
									55.559570312500085
								],
								[
									-129.81191406249997,
									55.53261718750011
								],
								[
									-129.81562499999995,
									55.417578125000034
								],
								[
									-129.83774414062492,
									55.31909179687494
								],
								[
									-129.87714843749995,
									55.250634765625136
								],
								[
									-129.98520507812492,
									55.11147460937511
								],
								[
									-130.04848632812497,
									55.05727539062508
								],
								[
									-130.09179687499997,
									55.10776367187506
								],
								[
									-130.05839843749993,
									55.194775390625125
								],
								[
									-129.99584960937497,
									55.26406250000011
								],
								[
									-129.98515624999993,
									55.35883789062515
								],
								[
									-130.04404296875003,
									55.471923828125
								],
								[
									-130.07998046875005,
									55.56289062500005
								],
								[
									-130.09296875000004,
									55.63183593750017
								],
								[
									-130.09467773437495,
									55.6947753906251
								],
								[
									-130.08510742187497,
									55.75170898437497
								],
								[
									-130.06035156249996,
									55.813720703125
								],
								[
									-130.02031249999987,
									55.88076171875008
								],
								[
									-130.02509765624998,
									55.888232421875074
								],
								[
									-130.01406249999997,
									55.95053710937498
								],
								[
									-130.02290039062495,
									56.01450195312515
								],
								[
									-130.05595703124996,
									56.065234375000074
								],
								[
									-130.09785156249995,
									56.109277343749994
								],
								[
									-130.21469726562486,
									56.08281249999993
								],
								[
									-130.41313476562487,
									56.122509765625125
								],
								[
									-130.47709960937496,
									56.230566406250006
								],
								[
									-130.649072265625,
									56.263671875
								],
								[
									-130.74169921875006,
									56.340820312500085
								],
								[
									-130.9302246093749,
									56.37861328125007
								],
								[
									-131.0829101562499,
									56.40483398437499
								],
								[
									-131.19941406249995,
									56.44921874999997
								],
								[
									-131.33579101562503,
									56.501220703125085
								],
								[
									-131.47187499999995,
									56.55673828125012
								],
								[
									-131.57509765625002,
									56.59882812500007
								],
								[
									-131.65151367187494,
									56.59609375000005
								],
								[
									-131.82426757812496,
									56.58999023437505
								],
								[
									-131.83310546874992,
									56.684814453125
								],
								[
									-131.88598632812494,
									56.742138671874955
								],
								[
									-131.86616210937495,
									56.79282226562498
								],
								[
									-131.96249999999986,
									56.818701171875006
								],
								[
									-132.1042968749999,
									56.85678710937515
								],
								[
									-132.062890625,
									56.953369140625
								],
								[
									-132.03154296874993,
									57.0265625000001
								],
								[
									-132.1570312499999,
									57.04819335937506
								],
								[
									-132.33798828124992,
									57.07944335937512
								],
								[
									-132.27939453124998,
									57.145361328125034
								],
								[
									-132.23217773437494,
									57.19853515625013
								],
								[
									-132.30166015624997,
									57.27631835937507
								],
								[
									-132.44248046874986,
									57.40673828125
								],
								[
									-132.55048828124995,
									57.499902343749966
								],
								[
									-132.6915039062499,
									57.64511718750006
								],
								[
									-132.81552734374992,
									57.77270507812494
								],
								[
									-132.9168457031249,
									57.87700195312516
								],
								[
									-133.00141601562495,
									57.94897460937497
								],
								[
									-133.12041015625,
									58.077734375000006
								],
								[
									-133.27529296875,
									58.22285156250007
								],
								[
									-133.42255859374995,
									58.337060546874994
								],
								[
									-133.40112304687494,
									58.41088867187503
								],
								[
									-133.54638671874997,
									58.50346679687496
								],
								[
									-133.67392578124992,
									58.59716796875014
								],
								[
									-133.8207519531249,
									58.70502929687507
								],
								[
									-133.96572265624997,
									58.7578613281251
								],
								[
									-134.06918945312492,
									58.79550781249995
								],
								[
									-134.21850585937506,
									58.84990234375002
								],
								[
									-134.29697265624995,
									58.898486328125045
								],
								[
									-134.32963867187505,
									58.939697265625114
								],
								[
									-134.36352539062491,
									58.96875000000017
								],
								[
									-134.39306640625,
									59.009179687499966
								],
								[
									-134.41020507812493,
									59.056250000000034
								],
								[
									-134.44077148437492,
									59.08535156250002
								],
								[
									-134.62197265625,
									59.155322265625074
								],
								[
									-134.67724609374997,
									59.19926757812496
								],
								[
									-134.80239257812497,
									59.25
								],
								[
									-134.90722656249994,
									59.27119140625004
								],
								[
									-134.94375,
									59.28828124999998
								],
								[
									-135.07128906249994,
									59.4414550781251
								],
								[
									-135.05083007812496,
									59.496044921875125
								],
								[
									-135.03666992187493,
									59.550683593749966
								],
								[
									-135.05102539062491,
									59.57866210937499
								],
								[
									-135.26079101562502,
									59.69501953125007
								],
								[
									-135.36787109374998,
									59.74331054687505
								],
								[
									-135.47592773437486,
									59.7932617187501
								],
								[
									-135.70258789062507,
									59.728759765625085
								],
								[
									-135.93466796874992,
									59.662646484375045
								],
								[
									-136.09716796874997,
									59.63837890625007
								],
								[
									-136.3218261718749,
									59.60483398437506
								],
								[
									-136.24711914062496,
									59.53291015625007
								],
								[
									-136.27797851562494,
									59.48032226562512
								],
								[
									-136.34785156249995,
									59.45605468750006
								],
								[
									-136.46635742187493,
									59.459082031250034
								],
								[
									-136.46674804687495,
									59.27993164062505
								],
								[
									-136.57875976562494,
									59.15224609375005
								],
								[
									-136.81328125000002,
									59.15004882812505
								],
								[
									-136.93930664062492,
									59.106103515624994
								],
								[
									-137.12622070312491,
									59.04096679687504
								],
								[
									-137.27753906249993,
									58.98818359375002
								],
								[
									-137.43857421874995,
									58.9031250000001
								],
								[
									-137.52089843749994,
									58.915380859375034
								],
								[
									-137.48417968749993,
									58.99121093750003
								],
								[
									-137.54370117187497,
									59.119433593750045
								],
								[
									-137.59331054687493,
									59.226269531249955
								],
								[
									-137.69663085937495,
									59.28115234375002
								],
								[
									-137.87055664062495,
									59.373583984375045
								],
								[
									-138.00112304687497,
									59.442919921875045
								],
								[
									-138.18745117187493,
									59.54194335937504
								],
								[
									-138.317626953125,
									59.6111328125001
								],
								[
									-138.45361328124997,
									59.6833984375001
								],
								[
									-138.63227539062507,
									59.77827148437507
								],
								[
									-138.70546874999997,
									59.90131835937507
								],
								[
									-138.86874999999992,
									59.94575195312498
								],
								[
									-139.04345703124997,
									59.99326171874998
								],
								[
									-139.1851562499999,
									60.083593750000006
								],
								[
									-139.13696289062494,
									60.172705078125034
								],
								[
									-139.07924804687497,
									60.27944335937502
								],
								[
									-139.07924804687497,
									60.34370117187515
								],
								[
									-139.23476562499997,
									60.339746093749966
								],
								[
									-139.46796875000004,
									60.33369140625007
								],
								[
									-139.67631835937505,
									60.32832031250004
								],
								[
									-139.83066406249995,
									60.252880859375125
								],
								[
									-139.97329101562497,
									60.18315429687513
								],
								[
									-140.19692382812497,
									60.2375000000001
								],
								[
									-140.45283203125004,
									60.29970703125005
								],
								[
									-140.52543945312493,
									60.218359375000006
								],
								[
									-140.76274414062505,
									60.25913085937506
								],
								[
									-141.00214843750004,
									60.30024414062518
								],
								[
									-141.00214843750004,
									60.59243164062511
								],
								[
									-141.00214843750004,
									60.88466796875005
								],
								[
									-141.00214843750004,
									61.17685546874998
								],
								[
									-141.00214843750004,
									61.46904296874999
								],
								[
									-141.00214843750004,
									61.76127929687502
								],
								[
									-141.00214843750004,
									62.05346679687503
								],
								[
									-141.00214843750004,
									62.34570312500006
								],
								[
									-141.00214843750004,
									62.63789062500018
								],
								[
									-141.00214843750004,
									62.93007812500011
								],
								[
									-141.00214843750004,
									63.22226562499995
								],
								[
									-141.00214843750004,
									63.51445312499996
								],
								[
									-141.00214843750004,
									63.80668945312499
								],
								[
									-141.00214843750004,
									64.09887695312509
								],
								[
									-141.00214843750004,
									64.39111328125003
								],
								[
									-141.00214843750004,
									64.68330078125015
								],
								[
									-141.00214843750004,
									64.97553710937518
								],
								[
									-141.00214843750004,
									65.26772460937511
								],
								[
									-141.00214843750004,
									65.55991210937495
								],
								[
									-141.00214843750004,
									65.85214843749998
								],
								[
									-141.00214843750004,
									66.14433593749999
								],
								[
									-141.00214843750004,
									66.43652343750009
								],
								[
									-141.00214843750004,
									66.72875976562503
								],
								[
									-141.00214843750004,
									67.02094726562515
								],
								[
									-141.00214843750004,
									67.31313476562508
								],
								[
									-141.00214843750004,
									67.60537109375011
								],
								[
									-141.00214843750004,
									67.89755859374995
								],
								[
									-141.00214843750004,
									68.18974609374996
								],
								[
									-141.00214843750004,
									68.48198242187499
								],
								[
									-141.00214843750004,
									68.77416992187509
								],
								[
									-141.00214843750004,
									69.06635742187513
								],
								[
									-141.00214843750004,
									69.35859375000015
								],
								[
									-141.00214843750004,
									69.65078125000008
								],
								[
									-140.86000976562497,
									69.63525390625003
								],
								[
									-140.405126953125,
									69.60249023437501
								],
								[
									-139.97661132812493,
									69.62172851562502
								],
								[
									-139.18154296874997,
									69.51552734375005
								],
								[
									-138.68989257812495,
									69.31679687500016
								],
								[
									-138.291015625,
									69.21904296875005
								],
								[
									-138.12836914062495,
									69.15195312500006
								],
								[
									-137.86943359374987,
									69.09282226562499
								],
								[
									-137.25996093749998,
									68.96411132812506
								],
								[
									-137.07041015624992,
									68.95087890624995
								],
								[
									-136.71733398437493,
									68.88916015625009
								],
								[
									-136.49868164062505,
									68.89731445312515
								],
								[
									-136.12236328124993,
									68.8822265625
								],
								[
									-135.86665039062498,
									68.83261718750009
								],
								[
									-135.36215820312486,
									68.69643554687508
								],
								[
									-135.258837890625,
									68.684326171875
								],
								[
									-135.23120117187503,
									68.69428710937515
								],
								[
									-135.40693359374995,
									68.82895507812498
								],
								[
									-135.4345703125,
									68.84199218750007
								],
								[
									-135.63798828124993,
									68.89223632812508
								],
								[
									-135.876318359375,
									68.91699218749997
								],
								[
									-135.89472656249995,
									68.9267089843751
								],
								[
									-135.9390136718749,
									68.97416992187507
								],
								[
									-135.92475585937493,
									68.99262695312493
								],
								[
									-135.87285156249993,
									69.00102539062505
								],
								[
									-135.69521484375005,
									69.00063476562497
								],
								[
									-135.58999023437494,
									69.0082519531251
								],
								[
									-135.575537109375,
									69.02695312500009
								],
								[
									-135.65126953124997,
									69.03129882812499
								],
								[
									-135.74262695312495,
									69.04941406249995
								],
								[
									-135.84970703124992,
									69.08139648437489
								],
								[
									-135.91020507812487,
									69.11147460937508
								],
								[
									-135.69145507812493,
									69.311181640625
								],
								[
									-135.61494140625004,
									69.29101562499997
								],
								[
									-135.4995605468749,
									69.33715820312503
								],
								[
									-135.29282226562486,
									69.30786132812503
								],
								[
									-135.2549804687499,
									69.32382812499998
								],
								[
									-135.22978515624993,
									69.42519531250002
								],
								[
									-135.19902343749996,
									69.44960937500002
								],
								[
									-135.1408203124999,
									69.46782226562493
								],
								[
									-134.85288085937498,
									69.48588867187513
								],
								[
									-134.4938476562499,
									69.46791992187502
								],
								[
									-134.45683593749993,
									69.47763671874998
								],
								[
									-134.4912109374999,
									69.54531250000008
								],
								[
									-134.49536132812506,
									69.571923828125
								],
								[
									-134.47368164062487,
									69.63281249999997
								],
								[
									-134.45146484374987,
									69.66547851562513
								],
								[
									-134.40893554687494,
									69.681787109375
								],
								[
									-134.24204101562495,
									69.66884765625002
								],
								[
									-134.18989257812498,
									69.63881835937502
								],
								[
									-134.13403320312497,
									69.58725585937492
								],
								[
									-134.07749023437492,
									69.55786132812497
								],
								[
									-133.89995117187487,
									69.52822265625005
								],
								[
									-133.87978515624997,
									69.50771484375014
								],
								[
									-133.94746093749995,
									69.42949218749993
								],
								[
									-134.01840820312495,
									69.38847656249993
								],
								[
									-134.1650390625,
									69.28056640625005
								],
								[
									-134.17431640624991,
									69.25283203125008
								],
								[
									-133.94804687499993,
									69.30131835937493
								],
								[
									-133.69404296875004,
									69.368408203125
								],
								[
									-133.475927734375,
									69.40537109375009
								],
								[
									-133.2936523437499,
									69.41215820312496
								],
								[
									-133.163134765625,
									69.43388671875002
								],
								[
									-133.08442382812493,
									69.47065429687507
								],
								[
									-133.02827148437495,
									69.50825195312507
								],
								[
									-132.91533203125002,
									69.62963867187503
								],
								[
									-132.84033203124994,
									69.65068359375013
								],
								[
									-132.5268066406249,
									69.64326171875004
								],
								[
									-132.45234374999995,
									69.6469238281251
								],
								[
									-132.40390625000003,
									69.65874023437502
								],
								[
									-132.41274414062497,
									69.67407226562503
								],
								[
									-132.47895507812495,
									69.69287109374994
								],
								[
									-132.56835937500003,
									69.69814453125005
								],
								[
									-132.57060546874996,
									69.7066894531252
								],
								[
									-132.53754882812495,
									69.72656250000006
								],
								[
									-132.48847656249993,
									69.73808593750002
								],
								[
									-132.333984375,
									69.75180664062515
								],
								[
									-132.232421875,
									69.70815429687514
								],
								[
									-132.16342773437498,
									69.70498046875011
								],
								[
									-131.93413085937496,
									69.75346679687513
								],
								[
									-131.58183593749996,
									69.88212890624996
								],
								[
									-131.44091796875003,
									69.91791992187504
								],
								[
									-131.31894531249998,
									69.92416992187509
								],
								[
									-131.21586914062493,
									69.90078125000002
								],
								[
									-131.13637695312497,
									69.90688476562502
								],
								[
									-131.03183593749992,
									69.97949218750017
								],
								[
									-130.99062499999997,
									70.01811523437505
								],
								[
									-130.92617187500005,
									70.05161132812512
								],
								[
									-130.66547851562495,
									70.12705078125003
								],
								[
									-130.49843749999997,
									70.14316406250012
								],
								[
									-130.39638671874997,
									70.12924804687503
								],
								[
									-130.2749511718749,
									70.09799804687506
								],
								[
									-130.17495117187497,
									70.08588867187515
								],
								[
									-130.04331054687498,
									70.09506835937509
								],
								[
									-129.944970703125,
									70.09091796875003
								],
								[
									-129.89804687499992,
									70.10615234375004
								],
								[
									-129.730078125,
									70.19208984375004
								],
								[
									-129.67563476562503,
									70.19296875000012
								],
								[
									-129.62299804687504,
									70.16762695312511
								],
								[
									-129.53842773437495,
									70.1051757812501
								],
								[
									-129.53818359374992,
									70.07392578124995
								],
								[
									-129.64829101562495,
									69.99775390625007
								],
								[
									-130.45883789062486,
									69.77998046874993
								],
								[
									-130.70854492187493,
									69.68598632812504
								],
								[
									-130.83208007812487,
									69.65146484375003
								],
								[
									-130.96010742187497,
									69.63203124999998
								],
								[
									-131.207958984375,
									69.61577148437505
								],
								[
									-131.30634765624995,
									69.59663085937515
								],
								[
									-131.47294921874987,
									69.57949218749994
								],
								[
									-131.86279296874991,
									69.54936523437502
								],
								[
									-131.93779296874993,
									69.53471679687513
								],
								[
									-131.9887695312499,
									69.51762695312505
								],
								[
									-132.128759765625,
									69.40234375000009
								],
								[
									-132.19682617187502,
									69.36469726562515
								],
								[
									-132.33076171874995,
									69.30795898437512
								],
								[
									-132.48120117187506,
									69.27314453125015
								],
								[
									-132.68671874999998,
									69.25986328125009
								],
								[
									-132.8174804687499,
									69.20576171875001
								],
								[
									-132.9679687499999,
									69.10141601562506
								],
								[
									-133.08945312499986,
									69.02875976562501
								],
								[
									-133.22822265625,
									68.96713867187506
								],
								[
									-133.378955078125,
									68.88666992187501
								],
								[
									-133.41831054687492,
									68.8442871093749
								],
								[
									-133.37338867187492,
									68.78847656250008
								],
								[
									-133.34838867187494,
									68.76987304687512
								],
								[
									-133.1968261718749,
									68.73984374999995
								],
								[
									-133.138037109375,
									68.74658203125017
								],
								[
									-133.19218750000005,
									68.77651367187505
								],
								[
									-133.31953124999995,
									68.81972656250005
								],
								[
									-133.33666992187497,
									68.83525390625002
								],
								[
									-133.30400390624987,
									68.84741210937509
								],
								[
									-132.70600585937493,
									68.81489257812495
								],
								[
									-132.57763671874997,
									68.84780273437516
								],
								[
									-132.53266601562504,
									68.87563476562508
								],
								[
									-132.54223632812506,
									68.88994140625005
								],
								[
									-132.70434570312503,
									68.89589843749994
								],
								[
									-132.739111328125,
									68.92246093750012
								],
								[
									-132.76469726562487,
									68.9724609374999
								],
								[
									-132.77011718750003,
									69.0121582031251
								],
								[
									-132.75546874999998,
									69.04160156250003
								],
								[
									-132.71894531249998,
									69.07919921874998
								],
								[
									-132.54516601562494,
									69.14062500000006
								],
								[
									-132.358056640625,
									69.1669433593751
								],
								[
									-132.21396484374995,
									69.20166015625006
								],
								[
									-132.13437499999992,
									69.23447265625009
								],
								[
									-131.91962890624995,
									69.29052734375014
								],
								[
									-131.83339843750005,
									69.33598632812507
								],
								[
									-131.7869140624999,
									69.37128906249998
								],
								[
									-131.78105468749996,
									69.38886718750001
								],
								[
									-131.82016601562503,
									69.40161132812494
								],
								[
									-131.78837890625005,
									69.431982421875
								],
								[
									-131.63178710937493,
									69.45908203124992
								],
								[
									-131.56293945312493,
									69.46137695312504
								],
								[
									-131.34291992187497,
									69.43540039062489
								],
								[
									-131.30302734374993,
									69.41508789062502
								],
								[
									-131.32470703124997,
									69.36118164062515
								],
								[
									-131.2938964843749,
									69.36372070312504
								],
								[
									-131.20903320312493,
									69.43217773437505
								],
								[
									-131.16171874999992,
									69.45498046875005
								],
								[
									-131.11284179687487,
									69.45947265625
								],
								[
									-131.06342773437504,
									69.45068359375009
								],
								[
									-131.01342773437497,
									69.42871093750003
								],
								[
									-130.98627929687504,
									69.36289062500012
								],
								[
									-130.98198242187496,
									69.25327148437492
								],
								[
									-130.97065429687495,
									69.20908203124998
								],
								[
									-130.91430664062503,
									69.28486328124995
								],
								[
									-130.87504882812505,
									69.32001953125001
								],
								[
									-130.660693359375,
									69.481298828125
								],
								[
									-130.51596679687486,
									69.56967773437489
								],
								[
									-130.35361328124992,
									69.65581054687513
								],
								[
									-130.1176269531249,
									69.72006835937498
								],
								[
									-129.5721191406249,
									69.82670898437513
								],
								[
									-129.26484375,
									69.8554199218751
								],
								[
									-129.10913085937497,
									69.88193359374992
								],
								[
									-129.03291015625,
									69.90498046875007
								],
								[
									-128.98432617187504,
									69.933447265625
								],
								[
									-128.89892578124994,
									69.96616210937512
								],
								[
									-128.88369140625005,
									69.9634765625
								],
								[
									-128.91679687499996,
									69.89487304687506
								],
								[
									-128.93862304687505,
									69.875
								],
								[
									-129.13833007812508,
									69.83251953124997
								],
								[
									-129.15791015624995,
									69.80009765625002
								],
								[
									-129.1362304687499,
									69.75004882812505
								],
								[
									-129.10170898437508,
									69.71704101562517
								],
								[
									-129.05434570312502,
									69.70107421875002
								],
								[
									-128.9714355468749,
									69.71240234375011
								],
								[
									-128.85302734375003,
									69.75102539062507
								],
								[
									-128.705517578125,
									69.81015625000003
								],
								[
									-128.38671874999997,
									69.96015625000004
								],
								[
									-128.35917968749996,
									69.98759765625005
								],
								[
									-128.27861328124987,
									70.10810546874998
								],
								[
									-128.09584960937497,
									70.16132812500007
								],
								[
									-127.76494140624996,
									70.22187500000007
								],
								[
									-127.68378906249994,
									70.26035156249992
								],
								[
									-127.97402343750001,
									70.29291992187498
								],
								[
									-128.03417968749991,
									70.31533203125011
								],
								[
									-128.04365234374998,
									70.328759765625
								],
								[
									-127.98891601562494,
									70.36313476562489
								],
								[
									-128.12148437499994,
									70.39736328124994
								],
								[
									-128.17011718749998,
									70.41845703124997
								],
								[
									-128.16806640625003,
									70.47978515625013
								],
								[
									-128.12729492187486,
									70.52382812500002
								],
								[
									-128.04047851562504,
									70.56640624999991
								],
								[
									-127.99101562499992,
									70.573828125
								],
								[
									-127.86162109375002,
									70.54907226562494
								],
								[
									-127.75283203125007,
									70.5171386718751
								],
								[
									-127.37685546874994,
									70.36874999999998
								],
								[
									-127.22597656249994,
									70.296142578125
								],
								[
									-127.13847656249996,
									70.23935546874998
								],
								[
									-126.92680664062492,
									70.06171874999995
								],
								[
									-126.83349609374991,
									69.95908203125
								],
								[
									-126.75869140624995,
									69.85336914062503
								],
								[
									-126.68491210937492,
									69.77709960937506
								],
								[
									-126.61215820312493,
									69.73032226562503
								],
								[
									-126.25043945312497,
									69.54526367187489
								],
								[
									-126.06381835937496,
									69.46708984374996
								],
								[
									-125.90742187499998,
									69.41855468750009
								],
								[
									-125.72778320312497,
									69.37998046874998
								],
								[
									-125.52495117187496,
									69.35156250000014
								],
								[
									-125.38676757812496,
									69.34921874999992
								],
								[
									-125.17187499999997,
									69.42797851562506
								],
								[
									-125.166845703125,
									69.47978515625013
								],
								[
									-125.26157226562495,
									69.56616210937514
								],
								[
									-125.35693359374991,
									69.6259765625
								],
								[
									-125.3455078124999,
									69.66245117187506
								],
								[
									-125.21938476562505,
									69.7323730468751
								],
								[
									-125.227880859375,
									69.75673828125
								],
								[
									-125.20117187499999,
									69.82880859374993
								],
								[
									-125.1140136718749,
									69.81503906250006
								],
								[
									-125.0795898437499,
									69.8178222656251
								],
								[
									-125.03100585937496,
									69.84428710937516
								],
								[
									-124.96826171874996,
									69.89438476562506
								],
								[
									-124.88916015624993,
									69.93579101562506
								],
								[
									-124.79365234374991,
									69.96850585937497
								],
								[
									-124.767919921875,
									69.99003906249999
								],
								[
									-124.86259765625002,
									70.00551757812505
								],
								[
									-124.9200195312499,
									70.00556640625015
								],
								[
									-124.96259765624997,
									70.01259765625016
								],
								[
									-124.99038085937494,
									70.02661132812509
								],
								[
									-124.95244140624993,
									70.04174804687497
								],
								[
									-124.74511718749997,
									70.08017578124998
								],
								[
									-124.70634765624989,
									70.11699218750002
								],
								[
									-124.63994140624996,
									70.14145507812503
								],
								[
									-124.55502929687489,
									70.15122070312506
								],
								[
									-124.50258789062495,
									70.14111328125006
								],
								[
									-124.44448242187492,
									70.11059570312506
								],
								[
									-124.44150390624993,
									70.0619140625
								],
								[
									-124.46718749999994,
									69.982568359375
								],
								[
									-124.47192382812491,
									69.9185058593749
								],
								[
									-124.40693359374991,
									69.76743164062503
								],
								[
									-124.34936523437491,
									69.73452148437508
								],
								[
									-124.12460937499995,
									69.68999023437507
								],
								[
									-124.13847656250002,
									69.65317382812503
								],
								[
									-124.39838867187504,
									69.49384765625015
								],
								[
									-124.45390624999989,
									69.45483398437494
								],
								[
									-124.48134765624998,
									69.42514648437503
								],
								[
									-124.47207031249995,
									69.40004882812505
								],
								[
									-124.42617187499992,
									69.37944335937505
								],
								[
									-124.33808593749993,
									69.36484375
								],
								[
									-124.11171875,
									69.35888671874994
								],
								[
									-124.04965820312496,
									69.37285156250002
								],
								[
									-123.60913085937491,
									69.37744140625009
								],
								[
									-123.5284179687499,
									69.38935546874993
								],
								[
									-123.46044921874991,
									69.42001953125003
								],
								[
									-123.361474609375,
									69.49663085937493
								],
								[
									-123.248974609375,
									69.52001953125009
								],
								[
									-123.2136718749999,
									69.54150390625011
								],
								[
									-123.14448242187494,
									69.63247070312508
								],
								[
									-123.11040039062492,
									69.738134765625
								],
								[
									-123.07661132812497,
									69.78247070312509
								],
								[
									-123.02578125,
									69.81000976562501
								],
								[
									-122.95668945312495,
									69.81884765625003
								],
								[
									-122.78540039062497,
									69.80844726562512
								],
								[
									-122.7048828124999,
									69.81738281250009
								],
								[
									-122.3874999999999,
									69.80844726562512
								],
								[
									-122.07006835937499,
									69.81616210937511
								],
								[
									-121.741845703125,
									69.79750976562502
								],
								[
									-121.53110351562496,
									69.77578124999997
								],
								[
									-121.33623046874996,
									69.74155273437492
								],
								[
									-120.96245117187502,
									69.66040039062509
								],
								[
									-120.81464843749993,
									69.61684570312516
								],
								[
									-120.29252929687496,
									69.42055664062516
								],
								[
									-120.13999023437488,
									69.3805664062501
								],
								[
									-119.85283203124992,
									69.34233398437502
								],
								[
									-118.86870117187497,
									69.257177734375
								],
								[
									-118.74487304687497,
									69.23427734375005
								],
								[
									-118.4855957031249,
									69.14487304687503
								],
								[
									-118.30698242187493,
									69.09272460937507
								],
								[
									-118.09521484374996,
									69.04291992187513
								],
								[
									-117.8303222656249,
									68.99990234375
								],
								[
									-117.31127929687503,
									68.93491210937489
								],
								[
									-117.226953125,
									68.91342773437503
								],
								[
									-117.13173828124995,
									68.9071289062502
								],
								[
									-117.02573242187493,
									68.91596679687504
								],
								[
									-116.549951171875,
									68.87880859375011
								],
								[
									-116.42456054687503,
									68.88061523437503
								],
								[
									-116.33408203124989,
									68.87363281250012
								],
								[
									-116.22270507812495,
									68.84682617187516
								],
								[
									-116.05947265625,
									68.83701171875012
								],
								[
									-116.06523437500002,
									68.85541992187504
								],
								[
									-116.25161132812497,
									68.95791015624997
								],
								[
									-116.2434082031249,
									68.97407226562515
								],
								[
									-116.16674804687491,
									68.97534179687506
								],
								[
									-115.9360839843749,
									68.95810546875
								],
								[
									-115.88325195312498,
									68.98730468750009
								],
								[
									-115.80634765624994,
									68.98662109375005
								],
								[
									-115.63115234374996,
									68.97255859375011
								],
								[
									-115.44228515624994,
									68.94091796875006
								],
								[
									-115.2398437499999,
									68.891845703125
								],
								[
									-114.99374999999995,
									68.85004882812501
								],
								[
									-114.62016601562496,
									68.74609374999997
								],
								[
									-114.41386718749995,
									68.65957031250011
								],
								[
									-114.21816406249995,
									68.55205078125013
								],
								[
									-114.11083984374993,
									68.47734374999993
								],
								[
									-114.09204101562493,
									68.43540039062492
								],
								[
									-114.05112304687493,
									68.41464843749995
								],
								[
									-113.98818359375,
									68.4149902343751
								],
								[
									-113.96440429687495,
									68.39907226562505
								],
								[
									-114.02080078124989,
									68.30649414062495
								],
								[
									-114.05322265624991,
									68.28339843750004
								],
								[
									-114.09594726562491,
									68.26679687500013
								],
								[
									-114.27475585937493,
									68.24785156250007
								],
								[
									-114.76528320312495,
									68.27021484375001
								],
								[
									-114.85219726562498,
									68.1952636718751
								],
								[
									-115.12705078124993,
									68.13203124999993
								],
								[
									-115.17592773437494,
									68.10439453125008
								],
								[
									-115.18676757812493,
									68.08417968749995
								],
								[
									-115.16708984375,
									68.01855468750009
								],
								[
									-115.20185546874998,
									67.99843750000016
								],
								[
									-115.4268554687499,
									67.92353515625018
								],
								[
									-115.43447265624994,
									67.90234375000003
								],
								[
									-115.28847656249995,
									67.8716796875
								],
								[
									-115.13320312499994,
									67.81918945312506
								],
								[
									-115.01118164062504,
									67.80639648437503
								],
								[
									-114.85673828125002,
									67.81357421875006
								],
								[
									-114.66289062499996,
									67.79521484375013
								],
								[
									-114.42939453125,
									67.75122070312497
								],
								[
									-114.26704101562495,
									67.73115234375007
								],
								[
									-114.17573242187493,
									67.73500976562505
								],
								[
									-114.05107421875002,
									67.72690429687509
								],
								[
									-113.89321289062501,
									67.706884765625
								],
								[
									-113.68193359374995,
									67.69995117187509
								],
								[
									-113.21499023437495,
									67.70175781250012
								],
								[
									-113.07495117187493,
									67.68666992187497
								],
								[
									-112.87944335937489,
									67.67988281250001
								],
								[
									-112.50302734374993,
									67.68193359375007
								],
								[
									-112.43515624999988,
									67.68476562500001
								],
								[
									-112.3145507812499,
									67.71958007812492
								],
								[
									-112.23671874999995,
									67.73110351562497
								],
								[
									-112.1013183593749,
									67.73173828124999
								],
								[
									-111.71088867187494,
									67.75732421874997
								],
								[
									-111.57573242187495,
									67.75683593750006
								],
								[
									-111.45068359374996,
									67.7761718749999
								],
								[
									-111.29082031249989,
									67.81523437500005
								],
								[
									-111.19218749999996,
									67.82255859375002
								],
								[
									-111.15478515624999,
									67.79824218749997
								],
								[
									-111.08740234374993,
									67.78764648437493
								],
								[
									-110.9900390624999,
									67.79082031250005
								],
								[
									-110.80488281249993,
									67.83232421875007
								],
								[
									-110.37197265624992,
									67.95419921875003
								],
								[
									-110.21625976562491,
									67.95400390625008
								],
								[
									-110.10195312499998,
									67.99223632812505
								],
								[
									-110.07392578124995,
									67.99291992187509
								],
								[
									-110.04248046874994,
									67.97719726562508
								],
								[
									-109.93652343750003,
									67.88789062499993
								],
								[
									-109.90424804687494,
									67.87353515625003
								],
								[
									-109.83134765624992,
									67.86582031250015
								],
								[
									-109.76015624999998,
									67.82011718750007
								],
								[
									-109.68603515624999,
									67.7517578124999
								],
								[
									-109.63037109374993,
									67.73271484374993
								],
								[
									-109.22431640624998,
									67.72978515625005
								],
								[
									-109.08124999999997,
									67.71074218750007
								],
								[
									-109.03803710937504,
									67.691162109375
								],
								[
									-108.99448242187496,
									67.637109375
								],
								[
									-108.96767578125001,
									67.53237304687505
								],
								[
									-108.94990234374994,
									67.49394531249996
								],
								[
									-108.890966796875,
									67.43808593749995
								],
								[
									-108.85200195312498,
									67.42197265625012
								],
								[
									-108.81518554687503,
									67.43750000000009
								],
								[
									-108.71513671874989,
									67.58281250000005
								],
								[
									-108.68022460937489,
									67.60620117187491
								],
								[
									-108.61333007812493,
									67.59804687500011
								],
								[
									-108.59291992187495,
									67.59086914062499
								],
								[
									-108.4915039062499,
									67.48330078125011
								],
								[
									-108.34697265624995,
									67.40341796875009
								],
								[
									-107.98872070312497,
									67.25639648437516
								],
								[
									-107.930517578125,
									67.20249023437492
								],
								[
									-107.90917968749993,
									67.16254882812495
								],
								[
									-107.92944335937497,
									67.12680664062495
								],
								[
									-107.99130859374996,
									67.09516601562515
								],
								[
									-108.08842773437493,
									67.06977539062515
								],
								[
									-108.2208007812499,
									67.05058593750013
								],
								[
									-108.34433593749993,
									67.05751953125005
								],
								[
									-108.45908203124995,
									67.0904296875
								],
								[
									-108.49604492187494,
									67.09228515625003
								],
								[
									-108.45527343749998,
									67.06298828124991
								],
								[
									-108.2181640625,
									66.94125976562506
								],
								[
									-108.15766601562493,
									66.8926269531251
								],
								[
									-108.10146484374992,
									66.86035156250003
								],
								[
									-108.04960937500002,
									66.84433593750003
								],
								[
									-108.00175781249996,
									66.81801757812511
								],
								[
									-107.95795898437491,
									66.7812988281249
								],
								[
									-107.76093749999993,
									66.68369140624992
								],
								[
									-107.70488281249996,
									66.63710937500002
								],
								[
									-107.48032226562495,
									66.49179687499998
								],
								[
									-107.37368164062498,
									66.43466796875006
								],
								[
									-107.2913574218749,
									66.40180664062504
								],
								[
									-107.25947265624998,
									66.39853515625
								],
								[
									-107.27807617187496,
									66.42490234374995
								],
								[
									-107.56445312499994,
									66.61850585937503
								],
								[
									-107.71035156250001,
									66.7400390625001
								],
								[
									-107.73085937499992,
									66.76918945312511
								],
								[
									-107.74023437499997,
									66.81376953125005
								],
								[
									-107.74599609374998,
									66.96147460937502
								],
								[
									-107.7250976562499,
									66.98413085937511
								],
								[
									-107.62617187499991,
									67.00312499999998
								],
								[
									-107.49921874999998,
									66.93618164062502
								],
								[
									-107.45126953124989,
									66.92675781250006
								],
								[
									-107.41884765624995,
									66.93071289062505
								],
								[
									-107.40209960937491,
									66.94799804687494
								],
								[
									-107.32919921874989,
									66.93198242187515
								],
								[
									-107.2001953124999,
									66.88256835937503
								],
								[
									-107.15649414062497,
									66.88173828124994
								],
								[
									-107.25375976562489,
									66.97636718750013
								],
								[
									-107.32333984374995,
									67.02255859375003
								],
								[
									-107.34785156249997,
									67.05478515625012
								],
								[
									-107.28315429687493,
									67.10327148437503
								],
								[
									-107.31845703124992,
									67.12778320312498
								],
								[
									-107.48237304687493,
									67.19912109374994
								],
								[
									-107.56748046874995,
									67.27304687499998
								],
								[
									-107.64404296874991,
									67.384765625
								],
								[
									-107.65092773437489,
									67.42822265625017
								],
								[
									-107.63837890624991,
									67.47421875000003
								],
								[
									-107.64990234374994,
									67.51127929687502
								],
								[
									-107.7530273437499,
									67.58686523437507
								],
								[
									-107.8650878906249,
									67.63920898437507
								],
								[
									-107.95405273437491,
									67.70000000000002
								],
								[
									-107.97211914062504,
									67.73203124999998
								],
								[
									-107.95839843750001,
									67.81860351562503
								],
								[
									-107.89091796875002,
									67.85634765625008
								],
								[
									-107.76308593750001,
									67.90683593750006
								],
								[
									-107.7286132812499,
									67.95883789062509
								],
								[
									-107.7874511718749,
									68.01249999999999
								],
								[
									-107.79829101562498,
									68.03691406249999
								],
								[
									-107.76103515624995,
									68.03217773437501
								],
								[
									-107.509375,
									68.05913085937507
								],
								[
									-107.44619140624992,
									68.04965820312512
								],
								[
									-107.35112304687492,
									68.06118164062514
								],
								[
									-107.22412109374999,
									68.09379882812496
								],
								[
									-107.1248046874999,
									68.10844726562502
								],
								[
									-106.99365234374993,
									68.10629882812509
								],
								[
									-106.92255859374991,
									68.11416015625002
								],
								[
									-106.83564453124997,
									68.12861328125004
								],
								[
									-106.79072265624997,
									68.14482421875005
								],
								[
									-106.71098632812489,
									68.20678710937506
								],
								[
									-106.66840820312493,
									68.21601562499998
								],
								[
									-106.53486328124998,
									68.20927734375013
								],
								[
									-106.4594726562499,
									68.19565429687492
								],
								[
									-106.42426757812493,
									68.20058593750014
								],
								[
									-106.42949218749992,
									68.28847656250008
								],
								[
									-106.40439453124996,
									68.31933593750017
								],
								[
									-106.27124023437491,
									68.38320312499994
								],
								[
									-106.13212890624992,
									68.38989257812506
								],
								[
									-106.03930664062491,
									68.40732421875006
								],
								[
									-105.93305664062494,
									68.44311523437514
								],
								[
									-105.85693359374999,
									68.47514648437502
								],
								[
									-105.78120117187491,
									68.52656250000001
								],
								[
									-105.7501953125,
									68.59228515625009
								],
								[
									-105.77431640624994,
									68.61113281250002
								],
								[
									-105.93222656249995,
									68.63652343750013
								],
								[
									-106.02714843750002,
									68.62333984375002
								],
								[
									-106.23730468749993,
									68.57656250000008
								],
								[
									-106.45805664062496,
									68.516455078125
								],
								[
									-106.54331054687492,
									68.46059570312508
								],
								[
									-106.56665039062497,
									68.38896484375005
								],
								[
									-106.60849609374988,
									68.35737304687501
								],
								[
									-106.78041992187501,
									68.38730468750006
								],
								[
									-106.85371093749993,
									68.38681640625006
								],
								[
									-106.94580078125003,
									68.37436523437492
								],
								[
									-107.043310546875,
									68.346826171875
								],
								[
									-107.14619140624991,
									68.30419921875009
								],
								[
									-107.29814453124996,
									68.2964355468751
								],
								[
									-107.49912109374996,
									68.32353515625005
								],
								[
									-107.61933593749994,
									68.33105468749997
								],
								[
									-107.74150390624996,
									68.28574218749998
								],
								[
									-107.73422851562489,
									68.25205078125012
								],
								[
									-107.67763671875001,
									68.20292968749999
								],
								[
									-107.73417968749989,
									68.17373046875008
								],
								[
									-108.02719726562489,
									68.162939453125
								],
								[
									-108.10458984374995,
									68.16928710937506
								],
								[
									-108.26103515625002,
									68.14990234375011
								],
								[
									-108.3228027343749,
									68.15410156249999
								],
								[
									-108.36791992187503,
									68.17753906249996
								],
								[
									-108.68657226562493,
									68.27734375000014
								],
								[
									-108.71811523437488,
									68.29746093750006
								],
								[
									-108.64091796874996,
									68.37851562500015
								],
								[
									-108.34575195312496,
									68.59780273437497
								],
								[
									-108.31347656249996,
									68.61079101562504
								],
								[
									-107.76635742187496,
									68.64892578125017
								],
								[
									-107.43593750000005,
									68.68886718750014
								],
								[
									-106.83066406249993,
									68.8094726562502
								],
								[
									-106.71347656249995,
									68.81948242187508
								],
								[
									-106.32426757812489,
									68.89946289062496
								],
								[
									-106.16445312499992,
									68.91987304687513
								],
								[
									-106.0156738281249,
									68.90605468750013
								],
								[
									-105.79794921874995,
									68.86479492187507
								],
								[
									-105.68559570312489,
									68.82817382812507
								],
								[
									-105.60605468749993,
									68.7824218750001
								],
								[
									-105.53984374999995,
									68.71865234375016
								],
								[
									-105.45693359374994,
									68.57807617187513
								],
								[
									-105.42861328124994,
									68.45825195312503
								],
								[
									-105.3774414062499,
									68.41381835937506
								],
								[
									-105.19497070312495,
									68.33037109375002
								],
								[
									-105.10131835937496,
									68.297998046875
								],
								[
									-105.04360351562492,
									68.28789062500016
								],
								[
									-104.993798828125,
									68.30742187499996
								],
								[
									-104.9598144531249,
									68.31054687500006
								],
								[
									-104.93671874999991,
									68.30302734375005
								],
								[
									-104.91196289062493,
									68.25048828125009
								],
								[
									-104.87944335937497,
									68.24526367187508
								],
								[
									-104.76962890624989,
									68.25175781249999
								],
								[
									-104.65317382812488,
									68.230078125
								],
								[
									-104.63637695312492,
									68.21391601562499
								],
								[
									-104.6611328124999,
									68.14877929687506
								],
								[
									-104.62817382812503,
									68.12148437500016
								],
								[
									-104.48681640624991,
									68.06318359375001
								],
								[
									-104.350732421875,
									68.04121093750015
								],
								[
									-104.19355468749994,
									68.03120117187507
								],
								[
									-103.90156249999997,
									68.04106445312505
								],
								[
									-103.65722656249993,
									68.06909179687517
								],
								[
									-103.47412109374993,
									68.11503906250002
								],
								[
									-103.32324218749991,
									68.06381835937506
								],
								[
									-103.02177734374996,
									67.94023437499993
								],
								[
									-102.84155273437493,
									67.85273437500013
								],
								[
									-102.69199218749992,
									67.81157226562502
								],
								[
									-102.38911132812504,
									67.76220703125009
								],
								[
									-102.32036132812489,
									67.73564453125007
								],
								[
									-102.20976562499992,
									67.73271484374993
								],
								[
									-102.05722656249992,
									67.75332031250005
								],
								[
									-101.8836425781249,
									67.74531250000001
								],
								[
									-101.68886718749994,
									67.70864257812508
								],
								[
									-101.55498046874992,
									67.69316406250005
								],
								[
									-101.09638671874993,
									67.76235351562511
								],
								[
									-101.02641601562489,
									67.76567382812507
								],
								[
									-100.855615234375,
									67.79897460937511
								],
								[
									-100.74560546874997,
									67.80908203125011
								],
								[
									-100.61611328125005,
									67.80825195312505
								],
								[
									-100.51962890624993,
									67.81840820312499
								],
								[
									-100.45610351562496,
									67.839453125
								],
								[
									-100.21293945312489,
									67.83857421875001
								],
								[
									-99.77294921874996,
									67.81484374999997
								],
								[
									-99.4722656249999,
									67.7840820312502
								],
								[
									-99.2935546874999,
									67.74531250000001
								],
								[
									-99.14687499999995,
									67.72363281250011
								],
								[
									-99.03217773437504,
									67.71884765624995
								],
								[
									-98.92045898437502,
									67.72578125000004
								],
								[
									-98.81171874999998,
									67.74443359375002
								],
								[
									-98.69726562499994,
									67.7797363281251
								],
								[
									-98.45278320312494,
									67.79790039062507
								],
								[
									-98.41210937499991,
									67.8071777343751
								],
								[
									-98.41713867187497,
									67.8264648437501
								],
								[
									-98.4678222656249,
									67.85581054687506
								],
								[
									-98.6064941406249,
									67.91142578124993
								],
								[
									-98.70356445312498,
									67.96572265625005
								],
								[
									-98.72221679687496,
									68.00019531250007
								],
								[
									-98.72006835937495,
									68.04199218750006
								],
								[
									-98.68984374999994,
									68.0661132812501
								],
								[
									-98.63154296875004,
									68.07255859375007
								],
								[
									-98.53984374999993,
									68.04663085937494
								],
								[
									-98.41479492187503,
									67.98842773437508
								],
								[
									-98.06254882812493,
									67.76967773437508
								],
								[
									-97.97763671874995,
									67.73862304687489
								],
								[
									-97.93076171875,
									67.710791015625
								],
								[
									-97.60742187500003,
									67.63105468750001
								],
								[
									-97.45493164062486,
									67.61699218749999
								],
								[
									-97.27426757812492,
									67.66625976562517
								],
								[
									-97.19443359375,
									67.69692382812511
								],
								[
									-97.15541992187505,
									67.72641601562489
								],
								[
									-97.15717773437495,
									67.7548339843751
								],
								[
									-97.13984374999998,
									67.796240234375
								],
								[
									-97.15805664062489,
									67.821923828125
								],
								[
									-97.20654296874989,
									67.85507812500009
								],
								[
									-97.33613281249993,
									67.90136718750009
								],
								[
									-97.54663085937491,
									67.9607421875001
								],
								[
									-97.73911132812495,
									67.97817382812502
								],
								[
									-97.91333007812491,
									67.95356445312498
								],
								[
									-98.11049804687494,
									67.90302734375007
								],
								[
									-98.19252929687497,
									67.92299804687505
								],
								[
									-98.43837890624994,
									68.06469726562514
								],
								[
									-98.50029296874996,
									68.11767578125003
								],
								[
									-98.50024414062503,
									68.13227539062498
								],
								[
									-98.38608398437495,
									68.11533203124998
								],
								[
									-98.38085937499994,
									68.13247070312502
								],
								[
									-98.44916992187493,
									68.20078124999998
								],
								[
									-98.49125976562496,
									68.22363281249994
								],
								[
									-98.63300781249998,
									68.33115234375009
								],
								[
									-98.65048828124989,
									68.36352539062511
								],
								[
									-98.56225585937497,
									68.37084960937509
								],
								[
									-98.52221679687497,
									68.38339843749998
								],
								[
									-98.46855468749996,
									68.38212890625007
								],
								[
									-98.21855468750002,
									68.31743164062505
								],
								[
									-98.09052734375004,
									68.34633789062516
								],
								[
									-97.7942382812499,
									68.38759765625002
								],
								[
									-97.91103515625,
									68.44951171875005
								],
								[
									-97.93886718750005,
									68.51044921874993
								],
								[
									-97.9250976562499,
									68.52368164062506
								],
								[
									-97.82856445312495,
									68.53276367187513
								],
								[
									-97.63955078125,
									68.48198242187499
								],
								[
									-97.54804687499993,
									68.47495117187498
								],
								[
									-97.48110351562505,
									68.49516601562502
								],
								[
									-97.41035156249995,
									68.49653320312501
								],
								[
									-97.33579101562495,
									68.47915039062502
								],
								[
									-97.2659179687499,
									68.45292968749993
								],
								[
									-97.13598632812491,
									68.37797851562502
								],
								[
									-97.07177734374997,
									68.33286132812506
								],
								[
									-96.99956054687493,
									68.2649414062501
								],
								[
									-96.97670898437497,
									68.25541992187502
								],
								[
									-96.62817382812494,
									68.25029296875005
								],
								[
									-96.43066406249991,
									68.31059570312507
								],
								[
									-96.4349609375,
									68.29008789062507
								],
								[
									-96.48022460937489,
									68.24282226562494
								],
								[
									-96.72514648437496,
									68.06123046875007
								],
								[
									-96.72207031250005,
									68.03876953125001
								],
								[
									-96.59218749999997,
									68.04843749999995
								],
								[
									-96.5312988281249,
									68.06313476562511
								],
								[
									-96.4937011718749,
									68.08496093750003
								],
								[
									-96.46118164062491,
									68.13583984375009
								],
								[
									-96.43935546874991,
									68.15087890625011
								],
								[
									-96.07558593749997,
									68.23652343750015
								],
								[
									-95.97031249999992,
									68.24912109374998
								],
								[
									-96.03603515625,
									68.15776367187502
								],
								[
									-96.17133789062495,
									67.83168945312502
								],
								[
									-96.19882812499995,
									67.71782226562502
								],
								[
									-96.22846679687495,
									67.67919921875014
								],
								[
									-96.37138671875002,
									67.55385742187516
								],
								[
									-96.36914062499991,
									67.50976562500009
								],
								[
									-96.21284179687495,
									67.404296875
								],
								[
									-96.18500976562498,
									67.3755859375
								],
								[
									-96.16923828124996,
									67.28896484375002
								],
								[
									-96.14145507812489,
									67.271826171875
								],
								[
									-96.01259765624994,
									67.2708984375
								],
								[
									-95.87910156249993,
									67.29848632812511
								],
								[
									-95.71992187499998,
									67.31679687500011
								],
								[
									-95.695166015625,
									67.29873046875008
								],
								[
									-95.78251953124996,
									67.1937988281251
								],
								[
									-95.77768554687495,
									67.1846191406251
								],
								[
									-95.62641601562504,
									67.211572265625
								],
								[
									-95.55703124999994,
									67.21528320312504
								],
								[
									-95.52871093749994,
									67.20917968750004
								],
								[
									-95.41591796875005,
									67.15556640625005
								],
								[
									-95.40458984374996,
									67.11557617187498
								],
								[
									-95.40698242187491,
									67.05610351562501
								],
								[
									-95.41889648437504,
									67.0132324218749
								],
								[
									-95.45698242187498,
									66.98945312500004
								],
								[
									-95.50224609374996,
									66.97988281250014
								],
								[
									-95.55937499999996,
									66.97275390625
								],
								[
									-95.61064453125002,
									66.97568359374989
								],
								[
									-95.76865234374989,
									66.96669921875002
								],
								[
									-95.86181640625003,
									66.97817382812505
								],
								[
									-95.95405273437498,
									67.01088867187497
								],
								[
									-96.01953124999991,
									67.01875000000004
								],
								[
									-96.09545898437503,
									66.99355468750008
								],
								[
									-96.21557617187497,
									66.99770507812494
								],
								[
									-96.35043945312492,
									67.07001953124993
								],
								[
									-96.40424804687495,
									67.06323242187497
								],
								[
									-96.42255859374995,
									67.05175781249994
								],
								[
									-96.42026367187495,
									67.03618164062496
								],
								[
									-96.359521484375,
									66.98940429687502
								],
								[
									-95.88530273437502,
									66.74135742187494
								],
								[
									-95.8132812499999,
									66.69013671874998
								],
								[
									-95.79736328124997,
									66.61655273437492
								],
								[
									-95.78754882812493,
									66.61679687500006
								],
								[
									-95.74316406249994,
									66.69042968750014
								],
								[
									-95.77211914062505,
									66.72607421875003
								],
								[
									-96.01611328125003,
									66.87045898437495
								],
								[
									-96.04536132812495,
									66.9231445312501
								],
								[
									-96.03686523437491,
									66.93750000000003
								],
								[
									-95.97236328124998,
									66.95224609374992
								],
								[
									-95.62504882812493,
									66.91625976562514
								],
								[
									-95.49038085937494,
									66.92412109375005
								],
								[
									-95.39965820312503,
									66.94946289062506
								],
								[
									-95.35410156249989,
									66.98071289062503
								],
								[
									-95.32109374999993,
									67.15249023437511
								],
								[
									-95.25874023437493,
									67.26254882812489
								],
								[
									-95.29560546874995,
									67.36103515625007
								],
								[
									-95.38955078124991,
									67.51782226562503
								],
								[
									-95.46337890624994,
									67.61020507812512
								],
								[
									-95.63369140624991,
									67.70385742187491
								],
								[
									-95.65048828124989,
									67.73745117187511
								],
								[
									-95.46069335937503,
									68.02138671875002
								],
								[
									-95.42651367187491,
									68.04526367187509
								],
								[
									-95.38408203124996,
									68.05556640625008
								],
								[
									-95.23471679687492,
									68.05971679687494
								],
								[
									-95.12587890624994,
									68.08330078125005
								],
								[
									-94.955224609375,
									68.05029296874997
								],
								[
									-94.86103515624998,
									68.041650390625
								],
								[
									-94.74443359374993,
									68.0708984375
								],
								[
									-94.4853027343749,
									68.19008789062511
								],
								[
									-94.38383789062502,
									68.2270019531251
								],
								[
									-94.25478515624994,
									68.29682617187493
								],
								[
									-94.09814453124991,
									68.39941406250014
								],
								[
									-93.92773437499991,
									68.47382812499993
								],
								[
									-93.65170898437489,
									68.54311523437511
								],
								[
									-93.48300781249992,
									68.598876953125
								],
								[
									-93.44892578124998,
									68.618896484375
								],
								[
									-93.60581054687489,
									68.62368164062508
								],
								[
									-93.64394531249991,
									68.63310546875005
								],
								[
									-93.676171875,
									68.68598632812498
								],
								[
									-93.65986328124995,
									68.7837402343751
								],
								[
									-93.66279296874995,
									68.8381835937499
								],
								[
									-93.68144531249993,
									68.88725585937496
								],
								[
									-93.71577148437498,
									68.9310546875
								],
								[
									-93.76572265624995,
									68.96958007812503
								],
								[
									-93.8113281249999,
									68.99267578124994
								],
								[
									-93.85244140624994,
									69.00034179687498
								],
								[
									-93.88071289062492,
									68.99682617187517
								],
								[
									-93.89609374999995,
									68.98217773437503
								],
								[
									-93.93808593749989,
									68.88906249999997
								],
								[
									-93.99155273437495,
									68.82060546875013
								],
								[
									-94.06489257812498,
									68.78476562500003
								],
								[
									-94.21694335937494,
									68.76054687500007
								],
								[
									-94.4783203124999,
									68.7427734375
								],
								[
									-94.58676757812489,
									68.77553710937511
								],
								[
									-94.600439453125,
									68.80322265625014
								],
								[
									-94.56254882812502,
									68.91166992187496
								],
								[
									-94.4756347656249,
									68.95815429687511
								],
								[
									-94.23662109374996,
									69.0497558593751
								],
								[
									-94.08364257812497,
									69.12309570312505
								],
								[
									-94.08115234374992,
									69.13583984374998
								],
								[
									-94.22182617187505,
									69.13637695312508
								],
								[
									-94.25537109374997,
									69.15146484375003
								],
								[
									-94.28496093749996,
									69.24160156250002
								],
								[
									-94.27675781250005,
									69.27524414062495
								],
								[
									-94.254736328125,
									69.31376953124999
								],
								[
									-94.15634765624995,
									69.3417480468751
								],
								[
									-93.85439453125,
									69.37636718750002
								],
								[
									-93.61948242187492,
									69.41699218750006
								],
								[
									-93.61264648437495,
									69.40283203125009
								],
								[
									-93.80097656249993,
									69.28090820312514
								],
								[
									-93.820458984375,
									69.25263671875004
								],
								[
									-93.74853515624991,
									69.22612304687507
								],
								[
									-93.56748046874989,
									69.29687499999991
								],
								[
									-93.45058593750005,
									69.35517578125007
								],
								[
									-93.43095703124996,
									69.37504882812513
								],
								[
									-93.53706054687498,
									69.38232421874991
								],
								[
									-93.54287109374994,
									69.40644531250004
								],
								[
									-93.52241210937495,
									69.45068359375009
								],
								[
									-93.5322753906249,
									69.48090820312493
								],
								[
									-93.64980468750005,
									69.51904296875006
								],
								[
									-93.79438476562493,
									69.4978515625001
								],
								[
									-93.9150878906249,
									69.457666015625
								],
								[
									-94.015283203125,
									69.44672851562507
								],
								[
									-94.16318359375,
									69.44594726562516
								],
								[
									-94.2708007812499,
									69.4551269531251
								],
								[
									-94.33813476562494,
									69.474267578125
								],
								[
									-94.41918945312503,
									69.51704101562501
								],
								[
									-94.51391601562497,
									69.58344726562504
								],
								[
									-94.63383789062496,
									69.64965820312503
								],
								[
									-94.67626953124991,
									69.65688476562508
								],
								[
									-94.71269531249996,
									69.64941406249997
								],
								[
									-94.78925781249993,
									69.58544921875009
								],
								[
									-94.82250976562494,
									69.57778320312502
								],
								[
									-95.29208984374995,
									69.66738281250008
								],
								[
									-95.49125976562496,
									69.71762695312509
								],
								[
									-95.58759765624995,
									69.75571289062503
								],
								[
									-95.70742187499994,
									69.77822265625011
								],
								[
									-95.85068359374989,
									69.78510742187518
								],
								[
									-95.96494140624989,
									69.80278320312496
								],
								[
									-96.05014648437495,
									69.83115234375015
								],
								[
									-96.11909179687504,
									69.87187500000007
								],
								[
									-96.17177734374994,
									69.92495117187505
								],
								[
									-96.26938476562492,
									69.99179687499992
								],
								[
									-96.49238281249998,
									70.12490234375011
								],
								[
									-96.5513671875,
									70.21030273437512
								],
								[
									-96.55957031249989,
									70.24301757812503
								],
								[
									-96.54560546874998,
									70.32724609375012
								],
								[
									-96.33657226562494,
									70.47016601562513
								],
								[
									-96.29770507812492,
									70.51137695312508
								],
								[
									-96.22641601562489,
									70.54169921875004
								],
								[
									-96.12275390624998,
									70.56123046874993
								],
								[
									-96.0481445312499,
									70.56708984375015
								],
								[
									-95.87861328124998,
									70.5489746093752
								],
								[
									-95.98017578124998,
									70.59321289062513
								],
								[
									-95.98818359374994,
									70.61684570312516
								],
								[
									-95.88632812499986,
									70.69428710937504
								],
								[
									-95.90639648437505,
									70.69775390625003
								],
								[
									-96.18642578125,
									70.63828125000009
								],
								[
									-96.25800781249993,
									70.6422851562501
								],
								[
									-96.35888671874997,
									70.67866210937513
								],
								[
									-96.54892578124995,
									70.80874023437508
								],
								[
									-96.55107421874993,
									70.88974609375006
								],
								[
									-96.49130859374995,
									71.00234375000016
								],
								[
									-96.47041015624995,
									71.06972656249997
								],
								[
									-96.52475585937492,
									71.12705078124992
								],
								[
									-96.50444335937496,
									71.1431640625
								],
								[
									-96.44545898437491,
									71.15922851562507
								],
								[
									-96.42075195312495,
									71.17646484375004
								],
								[
									-96.44658203124996,
									71.239892578125
								],
								[
									-96.4056640625,
									71.27363281250001
								],
								[
									-96.27133789062489,
									71.33911132812503
								],
								[
									-96.13964843749997,
									71.39638671875008
								],
								[
									-96.06201171874997,
									71.4138671874999
								],
								[
									-95.99443359374996,
									71.41064453125006
								],
								[
									-95.92407226562491,
									71.39306640625003
								],
								[
									-95.85087890624993,
									71.36108398437509
								],
								[
									-95.72539062499996,
									71.32817382812513
								],
								[
									-95.63256835937497,
									71.31879882812515
								],
								[
									-95.5642578124999,
									71.336767578125
								],
								[
									-95.44750976562491,
									71.46005859374998
								],
								[
									-95.40624999999994,
									71.49165039062504
								],
								[
									-95.44541015624992,
									71.50537109375017
								],
								[
									-95.67421875,
									71.50405273437508
								],
								[
									-95.77338867187495,
									71.5142578125
								],
								[
									-95.83037109375002,
									71.52607421875013
								],
								[
									-95.87231445312494,
									71.57314453125002
								],
								[
									-95.83774414062492,
									71.59824218750006
								],
								[
									-95.61591796874995,
									71.68540039062498
								],
								[
									-95.51166992187493,
									71.77680664062495
								],
								[
									-95.20122070312493,
									71.90371093750005
								],
								[
									-94.88696289062503,
									71.96337890624994
								],
								[
									-94.73486328124994,
									71.9829589843751
								],
								[
									-94.61113281249996,
									71.98686523437493
								],
								[
									-94.55708007812495,
									71.9789550781251
								],
								[
									-94.49106445312492,
									71.91552734374997
								],
								[
									-94.47880859374993,
									71.84858398437501
								],
								[
									-94.30834960937491,
									71.76489257812509
								],
								[
									-94.17124023437486,
									71.75844726562494
								],
								[
									-94.0859863281249,
									71.77114257812514
								],
								[
									-93.81020507812497,
									71.76625976562511
								],
								[
									-93.74628906249998,
									71.74282226562505
								],
								[
									-93.75087890624994,
									71.71665039062495
								],
								[
									-93.781640625,
									71.67431640625003
								],
								[
									-93.762841796875,
									71.63803710937492
								],
								[
									-93.5758789062499,
									71.568701171875
								],
								[
									-93.40747070312497,
									71.5207031250001
								],
								[
									-93.25634765624991,
									71.46083984375014
								],
								[
									-93.0312988281249,
									71.33569335937497
								],
								[
									-92.982568359375,
									71.30034179687505
								],
								[
									-92.94868164062495,
									71.26210937500008
								],
								[
									-92.89018554687502,
									71.1223632812501
								],
								[
									-92.88271484375,
									71.06933593750006
								],
								[
									-92.90419921874994,
									70.91606445312502
								],
								[
									-92.92197265625,
									70.88710937500014
								],
								[
									-92.98144531249994,
									70.85224609375007
								],
								[
									-92.96088867187495,
									70.83813476562503
								],
								[
									-92.78300781249993,
									70.79814453125013
								],
								[
									-92.64169921874992,
									70.71879882812513
								],
								[
									-92.56748046874992,
									70.69321289062509
								],
								[
									-92.38847656249993,
									70.65043945312499
								],
								[
									-92.35581054687495,
									70.63427734375014
								],
								[
									-92.31538085937498,
									70.60751953124995
								],
								[
									-92.21445312499992,
									70.49291992187514
								],
								[
									-92.0491210937499,
									70.38964843749997
								],
								[
									-92.03720703124989,
									70.36738281250013
								],
								[
									-92.07260742187489,
									70.31875000000016
								],
								[
									-92.04736328124991,
									70.30332031250006
								],
								[
									-91.98354492187505,
									70.28554687500008
								],
								[
									-91.92622070312493,
									70.294775390625
								],
								[
									-91.8755371093749,
									70.33115234374995
								],
								[
									-91.82041015624995,
									70.34165039062503
								],
								[
									-91.76083984374989,
									70.32626953125012
								],
								[
									-91.7156249999999,
									70.29921875000002
								],
								[
									-91.65405273437497,
									70.23295898437502
								],
								[
									-91.56406249999995,
									70.17827148437507
								],
								[
									-91.57163085937489,
									70.16157226562504
								],
								[
									-91.61611328124997,
									70.14785156250016
								],
								[
									-91.85859374999998,
									70.13266601562509
								],
								[
									-91.99497070312489,
									70.14321289062511
								],
								[
									-92.12104492187498,
									70.16992187499997
								],
								[
									-92.208642578125,
									70.19750976562509
								],
								[
									-92.29033203125002,
									70.23984375
								],
								[
									-92.32050781250004,
									70.23535156249997
								],
								[
									-92.36328124999997,
									70.20083007812505
								],
								[
									-92.45468749999992,
									70.1504394531249
								],
								[
									-92.51186523437494,
									70.103857421875
								],
								[
									-92.44575195312498,
									70.08315429687505
								],
								[
									-92.12700195312496,
									70.08452148437507
								],
								[
									-92.05771484374989,
									70.07143554687505
								],
								[
									-91.976708984375,
									70.03867187500015
								],
								[
									-92.06904296874998,
									69.98398437499992
								],
								[
									-92.28476562499995,
									69.89213867187505
								],
								[
									-92.75092773437498,
									69.71391601562505
								],
								[
									-92.88779296874989,
									69.66821289062517
								],
								[
									-92.85454101562496,
									69.65488281250012
								],
								[
									-92.80263671874994,
									69.65146484375003
								],
								[
									-92.64282226562497,
									69.65927734375003
								],
								[
									-92.49345703125002,
									69.683203125
								],
								[
									-92.31166992187494,
									69.67290039062496
								],
								[
									-92.23076171874996,
									69.65336914062507
								],
								[
									-92.25830078124997,
									69.63432617187502
								],
								[
									-92.20908203124989,
									69.60332031250007
								],
								[
									-91.91196289062495,
									69.53125000000006
								],
								[
									-91.72412109374994,
									69.54560546875004
								],
								[
									-91.53237304687497,
									69.61503906250007
								],
								[
									-91.38422851562498,
									69.64946289062499
								],
								[
									-91.20180664062494,
									69.64477539062491
								],
								[
									-91.15087890624997,
									69.63715820312504
								],
								[
									-91.17031249999994,
									69.62031250000018
								],
								[
									-91.30502929687492,
									69.58129882812503
								],
								[
									-91.42685546874989,
									69.537939453125
								],
								[
									-91.43994140624997,
									69.52568359374999
								],
								[
									-91.28813476562496,
									69.54321289062509
								],
								[
									-90.95019531250003,
									69.51547851562512
								],
								[
									-90.7857421875,
									69.50859375000016
								],
								[
									-90.666650390625,
									69.51552734375005
								],
								[
									-90.55493164062497,
									69.50449218750003
								],
								[
									-90.45053710937492,
									69.47543945312506
								],
								[
									-90.4155761718749,
									69.45698242187513
								],
								[
									-90.51328125,
									69.44511718750002
								],
								[
									-90.60556640624989,
									69.44531250000006
								],
								[
									-90.68398437499997,
									69.42773437500003
								],
								[
									-90.74853515624997,
									69.39248046875011
								],
								[
									-90.79458007812494,
									69.34672851562505
								],
								[
									-90.82211914062495,
									69.29047851562504
								],
								[
									-90.89228515625004,
									69.26728515624993
								],
								[
									-91.00498046874992,
									69.27709960937497
								],
								[
									-91.04921874999994,
									69.29301757812502
								],
								[
									-91.02485351562495,
									69.31523437499993
								],
								[
									-91.057763671875,
									69.31840820312505
								],
								[
									-91.14785156249997,
									69.30258789062509
								],
								[
									-91.21796875000004,
									69.30209960937492
								],
								[
									-91.23720703125005,
									69.2855468750002
								],
								[
									-90.74477539062491,
									69.1059082031251
								],
								[
									-90.5873046875,
									68.94687500000012
								],
								[
									-90.47900390624994,
									68.88115234374996
								],
								[
									-90.468359375,
									68.86376953124997
								],
								[
									-90.53896484375,
									68.81958007812503
								],
								[
									-90.54252929687502,
									68.785986328125
								],
								[
									-90.51015625,
									68.68886718750014
								],
								[
									-90.52524414062495,
									68.61127929687504
								],
								[
									-90.57363281250005,
									68.47470703125
								],
								[
									-90.52832031249997,
									68.43222656249998
								],
								[
									-90.42304687499993,
									68.39472656249998
								],
								[
									-90.36005859374998,
									68.34672851562505
								],
								[
									-90.31723632812495,
									68.330322265625
								],
								[
									-90.28525390625,
									68.29165039062494
								],
								[
									-90.24775390624993,
									68.26743164062498
								],
								[
									-90.20478515625004,
									68.25747070312508
								],
								[
									-90.17441406249989,
									68.27021484375001
								],
								[
									-90.15683593749995,
									68.30551757812492
								],
								[
									-90.11640624999998,
									68.33857421875018
								],
								[
									-90.0053222656249,
									68.39804687499995
								],
								[
									-89.89770507812491,
									68.4907714843751
								],
								[
									-89.87949218749995,
									68.52153320312513
								],
								[
									-89.89658203124995,
									68.59438476562505
								],
								[
									-89.88422851562493,
									68.62558593750003
								],
								[
									-89.78310546874994,
									68.73593750000003
								],
								[
									-89.75083007812492,
									68.81245117187507
								],
								[
									-89.72016601562498,
									68.93159179687493
								],
								[
									-89.6666015625,
									69.01459960937504
								],
								[
									-89.55200195312491,
									69.08491210937515
								],
								[
									-89.35190429687492,
									69.22700195312507
								],
								[
									-89.27954101562494,
									69.25546875
								],
								[
									-89.19848632812503,
									69.2694824218751
								],
								[
									-89.05673828124992,
									69.26611328125014
								],
								[
									-88.95351562499994,
									69.22041015625007
								],
								[
									-88.81455078124989,
									69.13588867187508
								],
								[
									-88.63774414062493,
									69.05883789062491
								],
								[
									-88.31552734374992,
									68.95444335937506
								],
								[
									-88.22353515625,
									68.91503906250003
								],
								[
									-88.041357421875,
									68.8117187500001
								],
								[
									-87.96435546874994,
									68.70927734374993
								],
								[
									-87.91152343749994,
									68.56469726562497
								],
								[
									-87.86596679687497,
									68.47763671875009
								],
								[
									-87.827734375,
									68.44809570312509
								],
								[
									-87.81030273437491,
									68.40415039062495
								],
								[
									-87.81357421874989,
									68.34570312499994
								],
								[
									-87.82792968749996,
									68.29995117187511
								],
								[
									-87.85327148437497,
									68.26689453125005
								],
								[
									-87.89267578125,
									68.24814453125003
								],
								[
									-87.99096679687497,
									68.24204101562503
								],
								[
									-88.11113281250002,
									68.25117187500004
								],
								[
									-88.14580078124996,
									68.26601562500005
								],
								[
									-88.20908203124989,
									68.33486328125014
								],
								[
									-88.23525390625,
									68.33906250000001
								],
								[
									-88.34697265624993,
									68.28828125000004
								],
								[
									-88.36069335937486,
									68.25986328125003
								],
								[
									-88.31962890624996,
									68.16577148437506
								],
								[
									-88.32509765625,
									67.98876953125006
								],
								[
									-88.313818359375,
									67.95034179687514
								],
								[
									-88.19589843749986,
									67.76582031249993
								],
								[
									-87.99716796874989,
									67.62568359374998
								],
								[
									-87.49912109374995,
									67.35532226562506
								],
								[
									-87.47080078124995,
									67.32460937500011
								],
								[
									-87.41791992187493,
									67.21416015624999
								],
								[
									-87.39194335937495,
									67.19106445312508
								],
								[
									-87.35937499999997,
									67.17724609375
								],
								[
									-87.32026367187493,
									67.17285156249991
								],
								[
									-87.26625976562494,
									67.18383789062503
								],
								[
									-87.08320312499995,
									67.26777343750007
								],
								[
									-86.92392578124992,
									67.35625000000007
								],
								[
									-86.81279296874993,
									67.40239257812496
								],
								[
									-86.74985351562489,
									67.406103515625
								],
								[
									-86.68203124999994,
									67.42231445312501
								],
								[
									-86.60937499999994,
									67.45083007812514
								],
								[
									-86.56079101562491,
									67.48212890625004
								],
								[
									-86.53642578125002,
									67.51616210937505
								],
								[
									-86.50351562499989,
									67.6494628906251
								],
								[
									-86.47553710937504,
									67.71313476562503
								],
								[
									-86.39804687499989,
									67.80009765624999
								],
								[
									-86.36967773437496,
									67.82480468750012
								],
								[
									-85.98447265625,
									68.04536132812504
								],
								[
									-85.9525878906249,
									68.07246093750013
								],
								[
									-85.78886718749996,
									68.32802734375016
								],
								[
									-85.731103515625,
									68.4450195312501
								],
								[
									-85.722802734375,
									68.51547851562506
								],
								[
									-85.74487304687497,
									68.57827148437516
								],
								[
									-85.73383789062493,
									68.63012695312497
								],
								[
									-85.68979492187492,
									68.67094726562502
								],
								[
									-85.64316406249992,
									68.69970703124994
								],
								[
									-85.56245117187493,
									68.7288085937501
								],
								[
									-85.51777343749995,
									68.76982421875002
								],
								[
									-85.49106445312495,
									68.77397460937505
								],
								[
									-85.42504882812491,
									68.77426757812503
								],
								[
									-85.33808593750004,
									68.74628906250001
								],
								[
									-85.2750976562499,
									68.74135742187508
								],
								[
									-84.86757812499994,
									68.77333984375002
								],
								[
									-84.8674804687499,
									68.79038085937503
								],
								[
									-85.10664062499995,
									68.84404296875013
								],
								[
									-85.10434570312495,
									68.870947265625
								],
								[
									-85.08339843749994,
									68.90791015625015
								],
								[
									-85.00830078124991,
									68.94921874999997
								],
								[
									-84.91606445312496,
									68.96225585937503
								],
								[
									-84.8953124999999,
									68.98852539062506
								],
								[
									-84.892724609375,
									69.02099609375003
								],
								[
									-84.86220703125,
									69.07397460937506
								],
								[
									-84.89003906249997,
									69.09277343750009
								],
								[
									-85.11352539062503,
									69.16586914062515
								],
								[
									-85.24262695312504,
									69.16274414062502
								],
								[
									-85.27548828124989,
									69.17231445312504
								],
								[
									-85.38676757812493,
									69.2318847656251
								],
								[
									-85.42753906249996,
									69.31840820312505
								],
								[
									-85.43193359374987,
									69.35385742187498
								],
								[
									-85.41640624999991,
									69.41088867187506
								],
								[
									-85.40224609375005,
									69.42675781250009
								],
								[
									-85.40917968749997,
									69.452490234375
								],
								[
									-85.43720703124998,
									69.4882324218751
								],
								[
									-85.43950195312493,
									69.51992187500014
								],
								[
									-85.41596679687493,
									69.54775390625005
								],
								[
									-85.43012695312495,
									69.5806640625
								],
								[
									-85.48203124999989,
									69.61874999999995
								],
								[
									-85.50244140624994,
									69.65151367187505
								],
								[
									-85.44790039062494,
									69.74814453125009
								],
								[
									-85.44609375000002,
									69.77778320312501
								],
								[
									-85.4974609375,
									69.81904296875007
								],
								[
									-85.53481445312497,
									69.83505859375003
								],
								[
									-85.5073730468749,
									69.8452636718749
								],
								[
									-85.41513671874992,
									69.84951171875014
								],
								[
									-85.30498046874996,
									69.8361328125001
								],
								[
									-85.17680664062496,
									69.80512695312515
								],
								[
									-85.01982421874996,
									69.80478515625
								],
								[
									-84.83398437499991,
									69.83505859375003
								],
								[
									-84.64511718749992,
									69.84970703124992
								],
								[
									-84.31879882812504,
									69.84370117187504
								],
								[
									-84.24165039062504,
									69.83500976562505
								],
								[
									-83.91718749999993,
									69.74536132812506
								],
								[
									-83.66533203124996,
									69.69970703124991
								],
								[
									-83.55170898437498,
									69.70395507812489
								],
								[
									-82.99135742187505,
									69.68588867187495
								],
								[
									-82.74560546874991,
									69.69511718750005
								],
								[
									-82.61835937499993,
									69.69106445312511
								],
								[
									-82.374169921875,
									69.6417968750001
								],
								[
									-82.39023437499989,
									69.60087890625013
								],
								[
									-82.49570312499989,
									69.53222656250009
								],
								[
									-82.63330078125003,
									69.51811523437505
								],
								[
									-82.75483398437493,
									69.49438476562509
								],
								[
									-82.64204101562495,
									69.45839843749997
								],
								[
									-82.30986328124996,
									69.41000976562515
								],
								[
									-82.23183593749997,
									69.3325683593749
								],
								[
									-82.20815429687494,
									69.29702148437502
								],
								[
									-82.24677734374998,
									69.26499023437509
								],
								[
									-82.22753906249997,
									69.248876953125
								],
								[
									-82.150537109375,
									69.248876953125
								],
								[
									-81.95180664062494,
									69.27607421875004
								],
								[
									-81.73217773437503,
									69.25810546875002
								],
								[
									-81.41230468749998,
									69.19814453125005
								],
								[
									-81.37783203125005,
									69.18564453125009
								],
								[
									-81.32158203124996,
									69.13891601562514
								],
								[
									-81.3286621093749,
									69.11992187499993
								],
								[
									-81.61142578124995,
									69.00302734374992
								],
								[
									-81.75834960937496,
									68.95673828125015
								],
								[
									-81.95166015624997,
									68.90908203124997
								],
								[
									-81.95791015624994,
									68.883642578125
								],
								[
									-81.68691406250005,
									68.87895507812505
								],
								[
									-81.47602539062498,
									68.86557617187498
								],
								[
									-81.38090820312496,
									68.85004882812501
								],
								[
									-81.33129882812489,
									68.82797851562503
								],
								[
									-81.26352539062495,
									68.78061523437498
								],
								[
									-81.25249023437493,
									68.74316406250009
								],
								[
									-81.25913085937495,
									68.69243164062513
								],
								[
									-81.28154296874987,
									68.65722656250009
								],
								[
									-81.52685546874994,
									68.55595703124996
								],
								[
									-81.63950195312489,
									68.5243652343751
								],
								[
									-81.83139648437492,
									68.48686523437502
								],
								[
									-81.91484374999993,
									68.45878906250016
								],
								[
									-82.00649414062505,
									68.46264648437506
								],
								[
									-82.10634765625005,
									68.49853515625009
								],
								[
									-82.21015624999998,
									68.50624999999997
								],
								[
									-82.39721679687497,
									68.47758789062499
								],
								[
									-82.49873046874998,
									68.47861328125009
								],
								[
									-82.54863281249993,
									68.468603515625
								],
								[
									-82.55268554687504,
									68.44648437500004
								],
								[
									-82.46416015624993,
									68.38242187500003
								],
								[
									-82.41298828125,
									68.35717773437497
								],
								[
									-82.3928710937499,
									68.33833007812504
								],
								[
									-82.43066406249997,
									68.30659179687504
								],
								[
									-82.42270507812495,
									68.29658203125015
								],
								[
									-82.39252929687493,
									68.28525390625006
								],
								[
									-82.22241210937489,
									68.14526367187506
								],
								[
									-82.18657226562496,
									68.13442382812514
								],
								[
									-82.15131835937498,
									68.13969726562507
								],
								[
									-82.07763671874997,
									68.17968750000014
								],
								[
									-82.03388671875004,
									68.19594726562508
								],
								[
									-82.01249999999993,
									68.19389648437502
								],
								[
									-82.01337890624995,
									68.1733886718751
								],
								[
									-82.09189453124995,
									68.05146484375004
								],
								[
									-82.10214843749992,
									68.01889648437498
								],
								[
									-82.10048828124994,
									67.98984374999992
								],
								[
									-82.06254882812502,
									67.92817382812504
								],
								[
									-81.97646484374997,
									67.86201171874998
								],
								[
									-81.8693359374999,
									67.80249023437494
								],
								[
									-81.70859374999995,
									67.72236328124995
								],
								[
									-81.49277343749992,
									67.63691406249995
								],
								[
									-81.41230468749998,
									67.59536132812502
								],
								[
									-81.2943359375,
									67.49741210937503
								],
								[
									-81.27011718749995,
									67.45991210937495
								],
								[
									-81.30107421874996,
									67.35698242187505
								],
								[
									-81.38720703124991,
									67.18857421874992
								],
								[
									-81.44272460937495,
									67.09287109375006
								],
								[
									-81.46757812499996,
									67.06987304687507
								],
								[
									-81.63007812499993,
									67.00200195312493
								],
								[
									-81.72236328124998,
									66.98608398437506
								],
								[
									-81.87446289062498,
									66.98793945312508
								],
								[
									-81.92553710937491,
									66.97470703125015
								],
								[
									-82.00507812499995,
									66.92041015625
								],
								[
									-82.11318359374994,
									66.82509765625002
								],
								[
									-82.19833984374989,
									66.76464843750014
								],
								[
									-82.26054687499993,
									66.73911132812509
								],
								[
									-82.37475585937503,
									66.70942382812501
								],
								[
									-82.55366210937498,
									66.62138671875002
								],
								[
									-82.64150390624994,
									66.58750000000003
								],
								[
									-82.94887695312494,
									66.5508300781251
								],
								[
									-83.19877929687496,
									66.43149414062515
								],
								[
									-83.2983886718749,
									66.3921386718751
								],
								[
									-83.40644531249998,
									66.37124023437511
								],
								[
									-83.52309570312494,
									66.36875000000006
								],
								[
									-83.59028320312504,
									66.38784179687514
								],
								[
									-83.62836914062498,
									66.46069335937506
								],
								[
									-83.65107421874998,
									66.48461914062511
								],
								[
									-83.73920898437493,
									66.53437500000013
								],
								[
									-83.92021484375002,
									66.67905273437503
								],
								[
									-83.99804687499997,
									66.72851562500009
								],
								[
									-84.04999999999998,
									66.73950195312491
								],
								[
									-84.15444335937497,
									66.731689453125
								],
								[
									-84.20800781250003,
									66.73632812500006
								],
								[
									-84.32436523437494,
									66.7817871093751
								],
								[
									-84.36625976562493,
									66.81113281249995
								],
								[
									-84.36108398437494,
									66.82255859374996
								],
								[
									-84.27255859374995,
									66.83920898437498
								],
								[
									-84.31035156249993,
									66.86274414062498
								],
								[
									-84.46606445312494,
									66.92744140625001
								],
								[
									-84.53066406249994,
									66.961328125
								],
								[
									-84.53847656249994,
									66.97280273437502
								],
								[
									-84.69257812499998,
									67.01660156250006
								],
								[
									-84.84575195312502,
									67.02871093750014
								],
								[
									-85.04003906249997,
									66.95605468750006
								],
								[
									-85.11372070312498,
									66.9069335937501
								],
								[
									-85.11127929687493,
									66.89091796875013
								],
								[
									-85.01826171874998,
									66.8720703125
								],
								[
									-84.97797851562504,
									66.88125000000002
								],
								[
									-84.89902343749995,
									66.92656250000002
								],
								[
									-84.85737304687498,
									66.94067382812514
								],
								[
									-84.73774414062504,
									66.93359375000003
								],
								[
									-84.63857421875,
									66.90234375000006
								],
								[
									-84.60253906250003,
									66.87514648437502
								],
								[
									-84.58950195312494,
									66.85664062499998
								],
								[
									-84.31894531249989,
									66.71181640624997
								],
								[
									-84.223046875,
									66.68247070312512
								],
								[
									-84.18310546874994,
									66.64785156250008
								],
								[
									-84.15273437500005,
									66.59023437500014
								],
								[
									-84.09423828125003,
									66.52622070312506
								],
								[
									-83.964208984375,
									66.42055664062505
								],
								[
									-83.82583007812497,
									66.2899902343751
								],
								[
									-83.79755859374998,
									66.23847656249998
								],
								[
									-83.86904296875,
									66.21357421875007
								],
								[
									-83.90507812499996,
									66.21176757812515
								],
								[
									-84.0116699218749,
									66.231201171875
								],
								[
									-84.29306640624995,
									66.29179687500002
								],
								[
									-84.3242675781249,
									66.29067382812497
								],
								[
									-84.39843749999991,
									66.25874023437513
								],
								[
									-84.459375,
									66.1862304687501
								],
								[
									-84.47841796875005,
									66.179296875
								],
								[
									-84.628076171875,
									66.20771484375001
								],
								[
									-84.90839843749998,
									66.271337890625
								],
								[
									-85.09619140624997,
									66.3253417968752
								],
								[
									-85.19150390624992,
									66.36967773437507
								],
								[
									-85.30683593749998,
									66.44033203125008
								],
								[
									-85.44223632812495,
									66.53735351562494
								],
								[
									-85.603857421875,
									66.56826171875002
								],
								[
									-85.79174804687491,
									66.53295898437494
								],
								[
									-86.06323242187497,
									66.52036132812503
								],
								[
									-86.63320312499994,
									66.53134765625006
								],
								[
									-86.708154296875,
									66.52304687500015
								],
								[
									-86.73710937499996,
									66.51088867187514
								],
								[
									-86.68862304687494,
									66.45747070312501
								],
								[
									-86.70014648437498,
									66.44277343750014
								],
								[
									-86.73837890624995,
									66.43286132812497
								],
								[
									-86.74697265624991,
									66.41708984375003
								],
								[
									-86.68510742187502,
									66.36040039062496
								],
								[
									-86.5847656249999,
									66.32192382812511
								],
								[
									-86.30102539062494,
									66.269921875
								],
								[
									-86.11308593749993,
									66.22529296875004
								],
								[
									-86.00083007812489,
									66.18681640625002
								],
								[
									-85.96425781249997,
									66.1544433593752
								],
								[
									-85.95874023437491,
									66.11904296875
								],
								[
									-86.0122558593749,
									66.04848632812508
								],
								[
									-86.04287109375,
									66.02255859375015
								],
								[
									-86.7019531249999,
									65.67055664062511
								],
								[
									-86.95317382812493,
									65.52827148437507
								],
								[
									-87.08110351562496,
									65.44082031250002
								],
								[
									-87.19379882812493,
									65.38305664062497
								],
								[
									-87.29145507812493,
									65.354833984375
								],
								[
									-87.45288085937503,
									65.33896484375015
								],
								[
									-87.678125,
									65.33535156250002
								],
								[
									-87.96997070312503,
									65.34892578125005
								],
								[
									-88.12099609375,
									65.39458007812502
								],
								[
									-88.39487304687492,
									65.51621093749992
								],
								[
									-88.5867187499999,
									65.58764648437509
								],
								[
									-88.67246093749989,
									65.61157226562509
								],
								[
									-88.74394531249996,
									65.67875976562507
								],
								[
									-88.80849609374997,
									65.69165039062506
								],
								[
									-88.94614257812495,
									65.70302734374997
								],
								[
									-89.08774414062495,
									65.73896484375001
								],
								[
									-89.42036132812493,
									65.86079101562495
								],
								[
									-89.59267578124997,
									65.90932617187508
								],
								[
									-89.7494140625,
									65.93603515625009
								],
								[
									-89.89047851562495,
									65.9408203125002
								],
								[
									-89.94399414062494,
									65.93359375000014
								],
								[
									-89.84775390624995,
									65.87226562499998
								],
								[
									-89.8896972656249,
									65.86855468749994
								],
								[
									-90.00380859374997,
									65.88256835937503
								],
								[
									-90.11660156249994,
									65.88242187499992
								],
								[
									-90.31625976562492,
									65.92636718750009
								],
								[
									-90.51328125,
									65.92050781250012
								],
								[
									-90.65546874999993,
									65.92934570312516
								],
								[
									-90.8257324218749,
									65.95385742187509
								],
								[
									-91.00952148437503,
									65.96572265625002
								],
								[
									-91.30546875000002,
									65.96455078124995
								],
								[
									-91.41152343749997,
									65.95937499999997
								],
								[
									-91.42724609374997,
									65.94790039062494
								],
								[
									-91.28515624999997,
									65.89443359375014
								],
								[
									-91.04111328124989,
									65.82983398437514
								],
								[
									-91.07363281249994,
									65.8855468750001
								],
								[
									-91.06494140624994,
									65.89990234375003
								],
								[
									-90.98344726562496,
									65.91923828124996
								],
								[
									-90.59682617187497,
									65.88481445312513
								],
								[
									-90.15864257812498,
									65.81269531249993
								],
								[
									-90.04755859374998,
									65.80561523437518
								],
								[
									-89.92407226562497,
									65.78027343750017
								],
								[
									-89.78798828124997,
									65.73671875000008
								],
								[
									-89.60039062500002,
									65.64775390625007
								],
								[
									-89.24174804687496,
									65.44638671875
								],
								[
									-89.12656249999995,
									65.39560546875012
								],
								[
									-88.97402343749994,
									65.348291015625
								],
								[
									-88.1978027343749,
									65.27988281249992
								],
								[
									-87.92954101562489,
									65.2803222656251
								],
								[
									-87.39194335937495,
									65.26054687500016
								],
								[
									-87.10800781249992,
									65.22480468750007
								],
								[
									-87.02753906249998,
									65.19809570312495
								],
								[
									-87.00268554687497,
									65.10859375000001
								],
								[
									-87.02851562499998,
									65.06362304687516
								],
								[
									-87.1829101562499,
									64.92680664062493
								],
								[
									-87.28051757812491,
									64.82617187500003
								],
								[
									-87.88500976562494,
									64.40043945312499
								],
								[
									-87.96357421874998,
									64.302490234375
								],
								[
									-87.99755859374997,
									64.24394531250007
								],
								[
									-88.10561523437497,
									64.18330078124998
								],
								[
									-88.37895507812496,
									64.08925781250008
								],
								[
									-88.65302734374993,
									64.00937499999989
								],
								[
									-88.81772460937489,
									63.99223632812496
								],
								[
									-88.96440429687493,
									64.01123046874991
								],
								[
									-89.0596191406249,
									64.03442382812503
								],
								[
									-89.20063476562493,
									64.11376953125003
								],
								[
									-89.20942382812495,
									64.1054199218751
								],
								[
									-89.10766601562491,
									63.981103515624994
								],
								[
									-89.13154296874998,
									63.968505859374915
								],
								[
									-89.21455078124993,
									63.984130859375085
								],
								[
									-89.40351562499995,
									64.0399902343751
								],
								[
									-89.46474609375,
									64.02968750000002
								],
								[
									-89.50092773437493,
									64.01450195312515
								],
								[
									-89.55131835937496,
									64.01479492187511
								],
								[
									-89.61582031249995,
									64.03061523437503
								],
								[
									-89.73271484374996,
									64.07695312499999
								],
								[
									-89.763818359375,
									64.09951171874997
								],
								[
									-89.79208984374989,
									64.16826171874993
								],
								[
									-89.8113281249999,
									64.18056640625005
								],
								[
									-90.04165039062494,
									64.14086914062511
								],
								[
									-90.08002929687495,
									64.1277343750001
								],
								[
									-89.98559570312497,
									64.10019531249992
								],
								[
									-89.95356445312493,
									64.08061523437502
								],
								[
									-89.86059570312491,
									63.97880859375016
								],
								[
									-89.85571289062497,
									63.95698242187515
								],
								[
									-89.92187499999997,
									63.94355468749998
								],
								[
									-90.14189453125002,
									63.981982421875074
								],
								[
									-90.16816406250004,
									63.97875976562506
								],
								[
									-90.05961914062496,
									63.8774902343751
								],
								[
									-90.01796875,
									63.829345703125085
								],
								[
									-90.01342773437497,
									63.804296875000034
								],
								[
									-90.15473632812498,
									63.689648437499955
								],
								[
									-90.24531250000004,
									63.64189453124999
								],
								[
									-90.36884765624998,
									63.62441406250008
								],
								[
									-90.44624023437495,
									63.63618164062507
								],
								[
									-90.53349609374996,
									63.665429687499994
								],
								[
									-90.59638671874998,
									63.66127929687511
								],
								[
									-90.63500976562503,
									63.62377929687503
								],
								[
									-90.70683593749993,
									63.59692382812514
								],
								[
									-90.81191406249991,
									63.580908203125006
								],
								[
									-90.94565429687489,
									63.58784179687507
								],
								[
									-91.10805664062494,
									63.617822265625136
								],
								[
									-91.53881835937494,
									63.725585937500085
								],
								[
									-91.674658203125,
									63.7422363281251
								],
								[
									-91.92602539062497,
									63.757080078125085
								],
								[
									-91.95600585937495,
									63.77231445312492
								],
								[
									-91.95380859374995,
									63.786816406250125
								],
								[
									-91.91943359374994,
									63.80058593749999
								],
								[
									-91.92890624999993,
									63.8124511718751
								],
								[
									-91.98222656249996,
									63.822412109374994
								],
								[
									-92.03759765624997,
									63.813037109375045
								],
								[
									-92.094873046875,
									63.78442382812517
								],
								[
									-92.19521484375,
									63.77597656249995
								],
								[
									-92.33842773437496,
									63.78764648437502
								],
								[
									-92.55009765624993,
									63.829541015625125
								],
								[
									-92.97021484374997,
									63.93764648437502
								],
								[
									-93.42968749999997,
									64.02880859374994
								],
								[
									-93.69633789062493,
									64.14716796875015
								],
								[
									-93.5967285156249,
									64.04057617187513
								],
								[
									-93.60488281249997,
									64.00449218750006
								],
								[
									-93.65581054687493,
									63.97280273437508
								],
								[
									-93.66416015624995,
									63.941406250000085
								],
								[
									-93.55981445312491,
									63.8652832031251
								],
								[
									-93.41557617187493,
									63.83798828124998
								],
								[
									-93.27021484374998,
									63.8408691406251
								],
								[
									-93.26621093749989,
									63.853320312500074
								],
								[
									-93.32685546874998,
									63.872265625000125
								],
								[
									-93.38027343749994,
									63.90004882812508
								],
								[
									-93.40585937499992,
									63.941210937500045
								],
								[
									-93.37851562499995,
									63.948486328125
								],
								[
									-93.25043945312504,
									63.926904296874966
								],
								[
									-93.16591796875005,
									63.901757812499994
								],
								[
									-92.52924804687493,
									63.76123046874997
								],
								[
									-92.33920898437495,
									63.73491210937493
								],
								[
									-92.1964843749999,
									63.70781250000002
								],
								[
									-92.15688476562494,
									63.69169921875002
								],
								[
									-92.20502929687495,
									63.6567871093751
								],
								[
									-92.46103515624989,
									63.56943359374998
								],
								[
									-92.46508789062491,
									63.555078125000165
								],
								[
									-92.28955078124994,
									63.562988281250085
								],
								[
									-92.07661132812493,
									63.639990234375034
								],
								[
									-91.95683593749993,
									63.675634765625034
								],
								[
									-91.84184570312496,
									63.69755859374996
								],
								[
									-91.68603515624991,
									63.659716796875074
								],
								[
									-91.4893066406249,
									63.5622070312501
								],
								[
									-91.33007812499997,
									63.506835937500085
								],
								[
									-91.1030761718749,
									63.47587890625002
								],
								[
									-90.97006835937489,
									63.44277343750011
								],
								[
									-90.74658203124994,
									63.3515625
								],
								[
									-90.71127929687495,
									63.304052734375006
								],
								[
									-90.69072265624993,
									63.1105468750001
								],
								[
									-90.69858398437492,
									63.06386718750008
								],
								[
									-90.72763671874989,
									63.017480468749966
								],
								[
									-90.7778808593749,
									62.97163085937504
								],
								[
									-90.87119140625,
									62.945947265624966
								],
								[
									-91.00771484374994,
									62.940429687500085
								],
								[
									-91.114892578125,
									62.92158203125007
								],
								[
									-91.349462890625,
									62.81889648437502
								],
								[
									-91.44897460937503,
									62.804052734375006
								],
								[
									-91.86962890624994,
									62.834716796875114
								],
								[
									-92.0342285156249,
									62.86342773437502
								],
								[
									-92.11005859374998,
									62.86171875000011
								],
								[
									-92.15209960937491,
									62.83906250000004
								],
								[
									-92.19614257812492,
									62.82880859375015
								],
								[
									-92.3612792968749,
									62.81938476562493
								],
								[
									-92.38813476562495,
									62.80087890624989
								],
								[
									-92.37773437499987,
									62.772412109374955
								],
								[
									-92.34526367187502,
									62.7338378906251
								],
								[
									-92.30517578125003,
									62.711669921875114
								],
								[
									-92.24316406249991,
									62.68364257812499
								],
								[
									-92.14912109374995,
									62.66528320312506
								],
								[
									-91.9558593749999,
									62.64477539062514
								],
								[
									-91.93583984374993,
									62.59238281250015
								],
								[
									-91.94443359374989,
									62.57548828124999
								],
								[
									-92.00786132812493,
									62.54052734374997
								],
								[
									-92.08115234374995,
									62.54409179687508
								],
								[
									-92.20722656249995,
									62.585351562500136
								],
								[
									-92.26953124999997,
									62.58696289062502
								],
								[
									-92.32407226562489,
									62.56459960937508
								],
								[
									-92.39999999999989,
									62.55722656250009
								],
								[
									-92.49736328124993,
									62.56484375000002
								],
								[
									-92.55141601562491,
									62.54672851562506
								],
								[
									-92.56220703124998,
									62.50288085937501
								],
								[
									-92.59497070312491,
									62.470068359375006
								],
								[
									-92.707421875,
									62.418212890624915
								],
								[
									-92.76796875,
									62.37998046874995
								],
								[
									-92.76596679687492,
									62.34995117187512
								],
								[
									-92.70146484374993,
									62.32822265625006
								],
								[
									-92.62744140624994,
									62.279052734375085
								],
								[
									-92.54404296874992,
									62.20229492187508
								],
								[
									-92.52797851562494,
									62.16840820312501
								],
								[
									-92.57919921874989,
									62.17734375000015
								],
								[
									-92.648095703125,
									62.20776367187503
								],
								[
									-92.73476562499997,
									62.259716796874955
								],
								[
									-92.86582031249995,
									62.30620117187502
								],
								[
									-93.15444335937494,
									62.36684570312511
								],
								[
									-93.20537109374993,
									62.36494140625015
								],
								[
									-93.17924804687502,
									62.34956054687504
								],
								[
									-92.98779296874991,
									62.285937500000045
								],
								[
									-92.914453125,
									62.24497070312498
								],
								[
									-92.90551757812503,
									62.21513671874993
								],
								[
									-93.06586914062493,
									62.149755859375034
								],
								[
									-93.07026367187493,
									62.127832031250165
								],
								[
									-93.02773437499997,
									62.108642578125085
								],
								[
									-93.01625976562494,
									62.09267578125011
								],
								[
									-93.07338867187494,
									62.06054687500006
								],
								[
									-93.16748046874994,
									62.03364257812518
								],
								[
									-93.34975585937494,
									62.029785156250085
								],
								[
									-93.36635742187494,
									62.01455078125011
								],
								[
									-93.29687499999991,
									61.981591796874966
								],
								[
									-93.27343749999994,
									61.96108398437505
								],
								[
									-93.3330566406249,
									61.93291015624999
								],
								[
									-93.37202148437495,
									61.92895507812517
								],
								[
									-93.58178710937497,
									61.94204101562508
								],
								[
									-93.52670898437492,
									61.87163085937502
								],
								[
									-93.49423828124989,
									61.84692382812506
								],
								[
									-93.42993164062494,
									61.81210937499989
								],
								[
									-93.31440429687493,
									61.77978515625006
								],
								[
									-93.31201171874997,
									61.7672851562501
								],
								[
									-93.35234375000002,
									61.73955078125013
								],
								[
									-93.42060546874998,
									61.705810546875085
								],
								[
									-93.70966796874998,
									61.602539062500085
								],
								[
									-93.91274414062497,
									61.48144531250003
								],
								[
									-93.94086914062493,
									61.443652343750045
								],
								[
									-93.88925781249989,
									61.36406250000002
								],
								[
									-93.888818359375,
									61.34404296874993
								],
								[
									-93.94199218749989,
									61.30800781250005
								],
								[
									-94.06074218749993,
									61.3178222656251
								],
								[
									-94.08344726562493,
									61.303662109375125
								],
								[
									-94.05522460937496,
									61.266162109375045
								],
								[
									-94.04995117187494,
									61.21127929687506
								],
								[
									-94.06777343749994,
									61.138867187500125
								],
								[
									-94.15405273437491,
									61.02543945312513
								],
								[
									-94.30869140624989,
									60.87099609375011
								],
								[
									-94.42719726562498,
									60.73071289062503
								],
								[
									-94.50937499999992,
									60.6045410156249
								],
								[
									-94.56889648437487,
									60.54199218750003
								],
								[
									-94.67875976562487,
									60.53769531250006
								],
								[
									-94.76171874999991,
									60.4982421875001
								],
								[
									-94.70527343749995,
									60.47753906249997
								],
								[
									-94.67065429687491,
									60.45332031250001
								],
								[
									-94.64677734374993,
									60.41640625000002
								],
								[
									-94.67041015624997,
									60.301074218750074
								],
								[
									-94.7416015625,
									60.107373046875125
								],
								[
									-94.78579101562494,
									59.953320312499926
								],
								[
									-94.77666015624993,
									59.478125000000006
								],
								[
									-94.78828124999998,
									59.2678710937499
								],
								[
									-94.81953124999995,
									59.15131835937504
								],
								[
									-94.870263671875,
									59.087988281250034
								],
								[
									-94.95732421874996,
									59.068847656250114
								],
								[
									-94.84658203124997,
									59.050341796875074
								],
								[
									-94.77617187500002,
									59.02060546874998
								],
								[
									-94.74374999999989,
									58.97543945312509
								],
								[
									-94.71337890624991,
									58.90332031250014
								],
								[
									-94.67338867187496,
									58.87011718750006
								],
								[
									-94.62373046875004,
									58.87573242187503
								],
								[
									-94.57919921874995,
									58.868457031250074
								],
								[
									-94.53969726562497,
									58.84838867187514
								],
								[
									-94.41923828124996,
									58.745507812500165
								],
								[
									-94.28706054687493,
									58.7160156250001
								],
								[
									-94.2808105468749,
									58.658935546875114
								],
								[
									-94.33261718749989,
									58.33911132812506
								],
								[
									-94.33222656249998,
									58.29736328125017
								],
								[
									-94.27216796874993,
									58.37802734375006
								],
								[
									-94.20893554687493,
									58.62636718750005
								],
								[
									-94.12319335937494,
									58.73671875000005
								],
								[
									-94.05576171874989,
									58.760009765625
								],
								[
									-93.78002929687494,
									58.77255859374989
								],
								[
									-93.48618164062492,
									58.744482421875034
								],
								[
									-93.37504882812493,
									58.741015625000045
								],
								[
									-93.2781249999999,
									58.756396484375074
								],
								[
									-93.17875976562493,
									58.72563476562493
								],
								[
									-93.15458984374996,
									58.694580078125
								],
								[
									-93.12651367187502,
									58.56440429687504
								],
								[
									-93.10019531249989,
									58.489843750000034
								],
								[
									-92.92514648437495,
									58.22451171875005
								],
								[
									-92.84174804687493,
									58.07587890625007
								],
								[
									-92.73984374999995,
									57.84404296875002
								],
								[
									-92.70166015624997,
									57.7777832031251
								],
								[
									-92.48964843749994,
									57.46860351562509
								],
								[
									-92.44941406249993,
									57.38486328124998
								],
								[
									-92.43281249999993,
									57.32031249999997
								],
								[
									-92.439794921875,
									57.275048828124994
								],
								[
									-92.47836914062495,
									57.20527343749998
								],
								[
									-92.54848632812494,
									57.11093749999995
								],
								[
									-92.61411132812489,
									57.03901367187504
								],
								[
									-92.67524414062493,
									56.98955078125002
								],
								[
									-92.73798828124993,
									56.95263671875003
								],
								[
									-92.802392578125,
									56.92832031250015
								],
								[
									-92.7981445312499,
									56.921972656250006
								],
								[
									-92.72529296874998,
									56.93354492187515
								],
								[
									-92.65097656249995,
									56.958300781250045
								],
								[
									-92.5103027343749,
									57.02231445312512
								],
								[
									-92.45629882812491,
									57.036718750000034
								],
								[
									-92.30336914062494,
									57.04584960937501
								],
								[
									-92.29829101562504,
									57.02275390624993
								],
								[
									-92.3721191406249,
									56.9751464843751
								],
								[
									-92.35571289062494,
									56.970605468749966
								],
								[
									-92.24902343749994,
									57.00898437500007
								],
								[
									-92.01801757812495,
									57.06376953124993
								],
								[
									-91.11127929687498,
									57.24121093750003
								],
								[
									-90.89746093750003,
									57.256933593750034
								],
								[
									-90.59218749999991,
									57.22446289062509
								],
								[
									-90.34482421874989,
									57.14907226562508
								],
								[
									-90.07519531249994,
									57.05190429687511
								],
								[
									-89.7908203124999,
									56.98134765625002
								],
								[
									-89.34233398437502,
									56.91542968750019
								],
								[
									-89.21157226562494,
									56.883837890625045
								],
								[
									-88.94848632812489,
									56.851318359375
								],
								[
									-88.8264648437499,
									56.8142578124999
								],
								[
									-88.67988281249998,
									56.725048828125125
								],
								[
									-88.44707031249987,
									56.608691406250045
								],
								[
									-88.27133789062489,
									56.5356933593751
								],
								[
									-88.07509765624997,
									56.467285156249915
								],
								[
									-87.87812499999998,
									56.341601562500074
								],
								[
									-87.560888671875,
									56.05634765625004
								],
								[
									-87.48242187499991,
									56.0212890625001
								],
								[
									-87.28686523437494,
									55.97465820312502
								],
								[
									-86.91938476562495,
									55.91455078125003
								],
								[
									-86.37695312500003,
									55.77324218750002
								],
								[
									-86.13867187499997,
									55.717871093750006
								],
								[
									-85.98447265625,
									55.69589843749998
								],
								[
									-85.8305175781249,
									55.656933593750125
								],
								[
									-85.67666015625,
									55.601074218750114
								],
								[
									-85.55932617187491,
									55.54018554687505
								],
								[
									-85.47846679687504,
									55.47426757812494
								],
								[
									-85.40727539062502,
									55.43115234375014
								],
								[
									-85.28271484374994,
									55.38330078125006
								],
								[
									-85.21801757812491,
									55.34897460937509
								],
								[
									-85.21201171874995,
									55.29746093749998
								],
								[
									-85.36201171874995,
									55.09545898437514
								],
								[
									-85.3652832031249,
									55.07929687500004
								],
								[
									-85.21357421874998,
									55.224365234375114
								],
								[
									-85.12885742187495,
									55.266210937500006
								],
								[
									-85.06093749999997,
									55.28564453125006
								],
								[
									-84.91992187500003,
									55.28334960937505
								],
								[
									-84.70576171874993,
									55.25922851562501
								],
								[
									-84.51796874999994,
									55.258886718750034
								],
								[
									-84.3564941406249,
									55.28251953124996
								],
								[
									-84.21894531250004,
									55.29311523437508
								],
								[
									-84.10537109375,
									55.290820312500045
								],
								[
									-84.0229980468749,
									55.29780273437515
								],
								[
									-83.97177734374995,
									55.31416015625001
								],
								[
									-83.91059570312493,
									55.314648437499926
								],
								[
									-83.66767578124998,
									55.26450195312512
								],
								[
									-83.56948242187497,
									55.261816406250006
								],
								[
									-83.21435546874991,
									55.21459960937497
								],
								[
									-82.9862792968749,
									55.231396484375125
								],
								[
									-82.94702148437491,
									55.22221679687493
								],
								[
									-82.86777343749992,
									55.1606933593751
								],
								[
									-82.80068359374994,
									55.15590820312519
								],
								[
									-82.68749999999997,
									55.16552734375003
								],
								[
									-82.57744140625002,
									55.14873046875016
								],
								[
									-82.39326171874998,
									55.0678222656251
								],
								[
									-82.30825195312497,
									54.998144531250034
								],
								[
									-82.22661132812496,
									54.85590820312518
								],
								[
									-82.219384765625,
									54.81347656249997
								],
								[
									-82.37060546874997,
									54.48349609375006
								],
								[
									-82.41806640624989,
									54.35581054687509
								],
								[
									-82.42416992187489,
									54.24458007812507
								],
								[
									-82.39414062499989,
									54.180468750000074
								],
								[
									-82.26357421874994,
									54.07299804687503
								],
								[
									-82.239892578125,
									54.04482421875005
								],
								[
									-82.1626464843749,
									53.885693359374955
								],
								[
									-82.14145507812492,
									53.81762695312494
								],
								[
									-82.14999999999989,
									53.73955078125013
								],
								[
									-82.19062499999998,
									53.610937500000034
								],
								[
									-82.18037109375004,
									53.51284179687502
								],
								[
									-82.14619140624993,
									53.36459960937512
								],
								[
									-82.15917968749997,
									53.264160156250085
								],
								[
									-82.21923828124997,
									53.21147460937502
								],
								[
									-82.259912109375,
									53.15981445312505
								],
								[
									-82.29160156249995,
									53.06611328125007
								],
								[
									-82.29155273437496,
									53.03071289062504
								],
								[
									-82.26044921874993,
									52.96113281250007
								],
								[
									-82.20268554687496,
									52.92167968750013
								],
								[
									-82.10795898437493,
									52.87739257812507
								],
								[
									-82.02001953124997,
									52.81162109375009
								],
								[
									-81.85927734375,
									52.65141601562513
								],
								[
									-81.74233398437497,
									52.56362304687519
								],
								[
									-81.5994140624999,
									52.43261718750014
								],
								[
									-81.57167968749994,
									52.36728515625006
								],
								[
									-81.61152343749995,
									52.32407226562506
								],
								[
									-81.66123046874989,
									52.293896484375125
								],
								[
									-81.77636718749997,
									52.2536132812501
								],
								[
									-81.82788085937491,
									52.22421875000015
								],
								[
									-81.81455078124995,
									52.217187500000136
								],
								[
									-81.64799804687493,
									52.239062500000045
								],
								[
									-81.54951171874995,
									52.23676757812504
								],
								[
									-81.46621093749994,
									52.20449218750011
								],
								[
									-81.398095703125,
									52.142236328125136
								],
								[
									-81.28505859375,
									52.08920898437489
								],
								[
									-81.12719726562497,
									52.04541015625003
								],
								[
									-80.96850585937497,
									51.972216796875045
								],
								[
									-80.70551757812504,
									51.79833984374997
								],
								[
									-80.65795898437503,
									51.75834960937499
								],
								[
									-80.588037109375,
									51.667236328125085
								],
								[
									-80.49584960937497,
									51.52509765625018
								],
								[
									-80.44760742187489,
									51.43222656250009
								],
								[
									-80.44331054687493,
									51.38857421875008
								],
								[
									-80.49550781249997,
									51.3446777343751
								],
								[
									-80.67270507812492,
									51.26474609374998
								],
								[
									-80.85122070312497,
									51.12500000000003
								],
								[
									-80.79497070312496,
									51.13183593750017
								],
								[
									-80.67724609374997,
									51.190869140625125
								],
								[
									-80.47832031249993,
									51.30732421875004
								],
								[
									-80.36796875000002,
									51.32988281250002
								],
								[
									-80.26567382812496,
									51.31635742187501
								],
								[
									-80.10356445312487,
									51.28286132812511
								],
								[
									-79.96040039062495,
									51.23515624999999
								],
								[
									-79.83623046874996,
									51.17333984375
								],
								[
									-79.651513671875,
									51.00781250000003
								],
								[
									-79.45615234374989,
									50.87558593749992
								],
								[
									-79.34790039062494,
									50.7626464843751
								],
								[
									-79.38071289062489,
									50.834521484375074
								],
								[
									-79.45263671874997,
									50.91728515625016
								],
								[
									-79.63618164062498,
									51.04902343750018
								],
								[
									-79.71445312499992,
									51.11757812500011
								],
								[
									-79.73139648437493,
									51.15048828125006
								],
								[
									-79.737451171875,
									51.18627929687497
								],
								[
									-79.72324218749995,
									51.25166015625007
								],
								[
									-79.68881835937495,
									51.34658203125005
								],
								[
									-79.64296874999994,
									51.41352539062518
								],
								[
									-79.5857421874999,
									51.45244140625002
								],
								[
									-79.54746093749992,
									51.493847656249926
								],
								[
									-79.52802734374995,
									51.53769531249998
								],
								[
									-79.49755859374997,
									51.56992187499998
								],
								[
									-79.33867187500002,
									51.62817382812494
								],
								[
									-79.29697265624986,
									51.622802734375085
								],
								[
									-79.26425781249995,
									51.55200195312506
								],
								[
									-79.22612304687493,
									51.53730468750018
								],
								[
									-79.15273437499997,
									51.52622070312495
								],
								[
									-79.0908691406249,
									51.50170898437503
								],
								[
									-79.04052734375003,
									51.46376953125002
								],
								[
									-79.005029296875,
									51.4253417968751
								],
								[
									-78.98432617187504,
									51.386376953125165
								],
								[
									-78.93691406249997,
									51.25913085937489
								],
								[
									-78.90317382812495,
									51.20029296875009
								],
								[
									-78.89750976562493,
									51.27167968750007
								],
								[
									-78.85800781249989,
									51.38393554687519
								],
								[
									-78.82744140624996,
									51.42998046875016
								],
								[
									-78.73134765624994,
									51.49746093750005
								],
								[
									-78.73642578124989,
									51.52661132812503
								],
								[
									-78.77631835937495,
									51.56577148437512
								],
								[
									-78.97773437499995,
									51.733789062499966
								],
								[
									-78.98164062499993,
									51.77456054687519
								],
								[
									-78.927880859375,
									51.79882812500017
								],
								[
									-78.89111328124997,
									51.84511718750008
								],
								[
									-78.871240234375,
									51.91342773437506
								],
								[
									-78.82822265624995,
									51.962988281250034
								],
								[
									-78.70200195312489,
									52.03271484375003
								],
								[
									-78.59331054687496,
									52.13969726562516
								],
								[
									-78.53735351562494,
									52.21328125000005
								],
								[
									-78.49165039062495,
									52.252099609375136
								],
								[
									-78.44809570312495,
									52.26137695312508
								],
								[
									-78.51308593750005,
									52.29111328125009
								],
								[
									-78.52607421874995,
									52.31069335937508
								],
								[
									-78.52910156249993,
									52.399169921875085
								],
								[
									-78.55708007812504,
									52.49189453125004
								],
								[
									-78.60058593749994,
									52.53510742187507
								],
								[
									-78.723779296875,
									52.6277343750001
								],
								[
									-78.74414062499997,
									52.65537109374995
								],
								[
									-78.76577148437494,
									52.76005859374996
								],
								[
									-78.75361328124993,
									52.812402343749966
								],
								[
									-78.72167968749991,
									52.85644531250006
								],
								[
									-78.73984374999989,
									52.89897460937502
								],
								[
									-78.85410156249989,
									52.976074218749915
								],
								[
									-78.8982421874999,
									53.04335937500005
								],
								[
									-78.947119140625,
									53.20620117187508
								],
								[
									-78.99204101562492,
									53.410351562499926
								],
								[
									-79.04311523437494,
									53.56049804687507
								],
								[
									-79.10034179687497,
									53.65664062500011
								],
								[
									-79.11313476562489,
									53.71718750000019
								],
								[
									-79.08144531249994,
									53.74228515625015
								],
								[
									-79.0403320312499,
									53.81796875000012
								],
								[
									-79.00317382812497,
									53.83657226562508
								],
								[
									-78.945703125,
									53.831591796875045
								],
								[
									-78.9443847656249,
									53.84023437500011
								],
								[
									-79.0320312499999,
									53.88105468750018
								],
								[
									-79.07514648437498,
									53.93237304687506
								],
								[
									-79.07329101562496,
									53.95141601562503
								],
								[
									-78.99604492187495,
									54.002490234375045
								],
								[
									-79.00991210937494,
									54.02397460937516
								],
								[
									-79.06713867187494,
									54.05195312500018
								],
								[
									-79.241796875,
									54.09887695312514
								],
								[
									-79.17880859374995,
									54.116943359375
								],
								[
									-79.138818359375,
									54.15722656250003
								],
								[
									-79.14672851562491,
									54.16923828124999
								],
								[
									-79.215966796875,
									54.185693359374966
								],
								[
									-79.29565429687497,
									54.21684570312502
								],
								[
									-79.35615234374995,
									54.26337890624998
								],
								[
									-79.43056640625,
									54.33662109374998
								],
								[
									-79.47597656249994,
									54.39477539062503
								],
								[
									-79.52065429687497,
									54.491552734375034
								],
								[
									-79.5979492187499,
									54.60166015624998
								],
								[
									-79.63173828124997,
									54.62910156250007
								],
								[
									-79.67041015624991,
									54.64682617187495
								],
								[
									-79.71396484375,
									54.65498046875001
								],
								[
									-79.71235351562495,
									54.67182617187507
								],
								[
									-79.66552734374991,
									54.697460937499955
								],
								[
									-78.90922851562502,
									54.881494140624966
								],
								[
									-78.84624023437487,
									54.908007812500045
								],
								[
									-78.47504882812493,
									55.011035156250074
								],
								[
									-78.30361328125,
									55.06855468750007
								],
								[
									-78.12885742187493,
									55.15131835937515
								],
								[
									-77.89111328124991,
									55.23642578124998
								],
								[
									-77.77529296874994,
									55.29125976562506
								],
								[
									-77.70214843749994,
									55.34418945312518
								],
								[
									-77.32495117187494,
									55.55551757812498
								],
								[
									-77.16508789062496,
									55.663525390624955
								],
								[
									-77.07255859374993,
									55.756298828125125
								],
								[
									-76.93808593749989,
									55.86723632812516
								],
								[
									-76.76181640624995,
									55.99643554687492
								],
								[
									-76.65048828124992,
									56.10722656249993
								],
								[
									-76.60405273437496,
									56.199560546875006
								],
								[
									-76.54638671874994,
									56.35878906250002
								],
								[
									-76.52983398437496,
									56.4999511718751
								],
								[
									-76.51962890625,
									56.70698242187518
								],
								[
									-76.52558593749998,
									56.89179687500007
								],
								[
									-76.5728515625,
									57.18120117187516
								],
								[
									-76.60141601562489,
									57.27226562499996
								],
								[
									-76.65541992187497,
									57.3805664062501
								],
								[
									-76.78627929687497,
									57.5985839843751
								],
								[
									-76.80981445312497,
									57.657958984375114
								],
								[
									-76.89091796874996,
									57.75810546874999
								],
								[
									-77.15678710937496,
									58.018896484375006
								],
								[
									-77.48916015625,
									58.19531250000014
								],
								[
									-77.55244140624993,
									58.239599609375034
								],
								[
									-77.68408203124991,
									58.29135742187492
								],
								[
									-77.88413085937489,
									58.35073242187511
								],
								[
									-78.01357421875,
									58.39916992187503
								],
								[
									-78.35170898437494,
									58.58066406250006
								],
								[
									-78.46298828124989,
									58.60244140625005
								],
								[
									-78.50590820312493,
									58.64912109375007
								],
								[
									-78.51508789062493,
									58.682373046875
								],
								[
									-78.50229492187489,
									58.769091796875074
								],
								[
									-78.48261718749998,
									58.82910156250014
								],
								[
									-78.45869140624998,
									58.873291015625085
								],
								[
									-78.43051757812492,
									58.90175781250011
								],
								[
									-78.24443359374993,
									59.03505859375008
								],
								[
									-78.14023437499995,
									59.141748046874966
								],
								[
									-78.0676757812499,
									59.20019531249997
								],
								[
									-77.98764648437495,
									59.245507812499966
								],
								[
									-77.84282226562493,
									59.30502929687509
								],
								[
									-77.76069335937498,
									59.38002929687502
								],
								[
									-77.77944335937497,
									59.410400390625085
								],
								[
									-77.84467773437495,
									59.44350585937508
								],
								[
									-77.85903320312494,
									59.47578124999998
								],
								[
									-77.74902343749991,
									59.558154296875074
								],
								[
									-77.73349609374995,
									59.58095703125019
								],
								[
									-77.74750976562504,
									59.6584960937499
								],
								[
									-77.72617187499995,
									59.67587890624989
								],
								[
									-77.59042968749992,
									59.68051757812495
								],
								[
									-77.39667968749998,
									59.56923828125002
								],
								[
									-77.34907226562495,
									59.57895507812512
								],
								[
									-77.41103515624997,
									59.60961914062517
								],
								[
									-77.48530273437493,
									59.68457031250014
								],
								[
									-77.47456054687504,
									59.715673828125006
								],
								[
									-77.33164062499986,
									59.79663085937506
								],
								[
									-77.32763671874994,
									59.83339843750011
								],
								[
									-77.36840820312491,
									59.88437499999992
								],
								[
									-77.37294921874994,
									59.925097656250045
								],
								[
									-77.28920898437494,
									60.022021484375074
								],
								[
									-77.31181640624993,
									60.04238281250005
								],
								[
									-77.5471679687499,
									60.06113281250012
								],
								[
									-77.58588867187498,
									60.088183593750045
								],
								[
									-77.57216796874994,
									60.100976562499994
								],
								[
									-77.46137695312493,
									60.13349609375004
								],
								[
									-77.45288085937497,
									60.14580078125016
								],
								[
									-77.64863281249998,
									60.36249999999998
								],
								[
									-77.6814453124999,
									60.42709960937509
								],
								[
									-77.59814453124991,
									60.50673828125005
								],
								[
									-77.503564453125,
									60.542724609375
								],
								[
									-77.51557617187504,
									60.56318359375001
								],
								[
									-77.63945312499996,
									60.56689453125006
								],
								[
									-77.714990234375,
									60.577783203124966
								],
								[
									-77.7908203124999,
									60.63984375000007
								],
								[
									-77.76123046874991,
									60.67905273437506
								],
								[
									-77.734228515625,
									60.69697265625018
								],
								[
									-77.66064453124994,
									60.789501953124926
								],
								[
									-77.58955078124993,
									60.808593750000085
								],
								[
									-77.60302734374991,
									60.825195312499915
								],
								[
									-77.8715332031249,
									60.78583984375007
								],
								[
									-77.99814453124995,
									60.81821289062492
								],
								[
									-78.12246093750005,
									60.80961914062502
								],
								[
									-78.18134765624995,
									60.81914062499993
								],
								[
									-78.15966796874991,
									60.852197265625165
								],
								[
									-77.93417968749989,
									61.00263671875001
								],
								[
									-77.8301269531249,
									61.084033203125074
								],
								[
									-77.76503906249997,
									61.15751953125002
								],
								[
									-77.73061523437497,
									61.20639648437495
								],
								[
									-77.72680664062491,
									61.2306640625001
								],
								[
									-77.74960937499995,
									61.393017578124955
								],
								[
									-77.73618164062495,
									61.437353515625006
								],
								[
									-77.64887695312493,
									61.478662109374994
								],
								[
									-77.51435546874998,
									61.55629882812508
								],
								[
									-77.69843749999998,
									61.62641601562515
								],
								[
									-77.81376953124996,
									61.69477539062507
								],
								[
									-77.88989257812491,
									61.728710937499955
								],
								[
									-77.94755859374993,
									61.761865234374966
								],
								[
									-78.02138671874997,
									61.83208007812513
								],
								[
									-78.07749023437495,
									61.9233886718751
								],
								[
									-78.13715820312493,
									62.10737304687501
								],
								[
									-78.14697265624997,
									62.20869140625004
								],
								[
									-78.13339843749989,
									62.28227539062493
								],
								[
									-78.10859374999998,
									62.31811523437503
								],
								[
									-78.06811523437491,
									62.3554199218751
								],
								[
									-77.89990234374991,
									62.42656250000002
								],
								[
									-77.60395507812493,
									62.531396484375136
								],
								[
									-77.372412109375,
									62.572509765625085
								],
								[
									-77.20527343749998,
									62.54995117187511
								],
								[
									-76.87939453124994,
									62.525390625000085
								],
								[
									-76.616357421875,
									62.46567382812509
								],
								[
									-75.81689453124991,
									62.315869140625125
								],
								[
									-75.67553710937491,
									62.249511718750085
								],
								[
									-75.80922851562505,
									62.193408203125045
								],
								[
									-75.78984374999993,
									62.17958984375005
								],
								[
									-75.48881835937496,
									62.286425781250074
								],
								[
									-75.4092285156249,
									62.30708007812501
								],
								[
									-75.3412109375,
									62.31210937499998
								],
								[
									-75.11401367187491,
									62.27075195312517
								],
								[
									-75.02275390624996,
									62.26445312500013
								],
								[
									-74.90756835937495,
									62.230029296875045
								],
								[
									-74.63256835937497,
									62.1156738281251
								],
								[
									-74.61289062499995,
									62.12519531250018
								],
								[
									-74.68989257812493,
									62.18344726562515
								],
								[
									-74.6458007812499,
									62.21113281250001
								],
								[
									-74.42919921874991,
									62.271826171875034
								],
								[
									-74.20546875,
									62.321386718750006
								],
								[
									-74.04648437499992,
									62.37001953125005
								],
								[
									-73.87783203124994,
									62.43437500000002
								],
								[
									-73.76396484375002,
									62.468750000000085
								],
								[
									-73.70507812499991,
									62.473144531249915
								],
								[
									-73.62998046874989,
									62.45419921875006
								],
								[
									-73.42836914062494,
									62.36884765624998
								],
								[
									-73.29897460937505,
									62.32504882812495
								],
								[
									-73.19516601562495,
									62.279150390625006
								],
								[
									-73.04936523437493,
									62.19824218750014
								],
								[
									-72.99238281249995,
									62.18041992187497
								],
								[
									-72.88183593749997,
									62.12539062500002
								],
								[
									-72.73496093749989,
									62.13110351562514
								],
								[
									-72.68696289062498,
									62.12456054687496
								],
								[
									-72.67080078124997,
									62.113867187500006
								],
								[
									-72.64599609374989,
									62.076611328124955
								],
								[
									-72.63310546874993,
									62.052783203125074
								],
								[
									-72.6321289062499,
									62.02724609375002
								],
								[
									-72.66601562499997,
									61.95532226562494
								],
								[
									-72.771630859375,
									61.84042968749998
								],
								[
									-72.72739257812495,
									61.83862304687497
								],
								[
									-72.66064453124994,
									61.86323242187501
								],
								[
									-72.57387695312494,
									61.907128906250165
								],
								[
									-72.50556640624998,
									61.92265625000013
								],
								[
									-72.36074218750005,
									61.887792968750034
								],
								[
									-72.2261230468749,
									61.83159179687496
								],
								[
									-72.17846679687494,
									61.80180664062493
								],
								[
									-72.12612304687494,
									61.753222656250074
								],
								[
									-72.0814453125,
									61.72827148437514
								],
								[
									-72.04003906249991,
									61.680273437500034
								],
								[
									-72.04296874999997,
									61.664697265625136
								],
								[
									-72.08203124999994,
									61.64140624999993
								],
								[
									-72.24707031249997,
									61.602050781250085
								],
								[
									-72.21586914062502,
									61.58725585937492
								],
								[
									-72.023095703125,
									61.61196289062505
								],
								[
									-71.96440429687496,
									61.63627929687496
								],
								[
									-71.922265625,
									61.67695312500007
								],
								[
									-71.86611328125,
									61.68852539062502
								],
								[
									-71.63828124999995,
									61.61718749999997
								],
								[
									-71.60478515624996,
									61.59238281249989
								],
								[
									-71.61943359375002,
									61.57290039062511
								],
								[
									-71.65620117187504,
									61.55092773437505
								],
								[
									-71.75576171875,
									61.52675781250002
								],
								[
									-71.84101562500004,
									61.46601562500018
								],
								[
									-71.85439453124991,
									61.43979492187489
								],
								[
									-71.79365234374998,
									61.42119140625002
								],
								[
									-71.64531249999996,
									61.413134765625045
								],
								[
									-71.64643554687493,
									61.39873046875013
								],
								[
									-71.73212890624998,
									61.37207031250003
								],
								[
									-71.74345703124996,
									61.33725585937506
								],
								[
									-71.55151367187503,
									61.21328125000011
								],
								[
									-71.42270507812489,
									61.15893554687506
								],
								[
									-71.34843749999996,
									61.148974609375074
								],
								[
									-71.175146484375,
									61.14653320312502
								],
								[
									-71.03496093749996,
									61.125537109375074
								],
								[
									-70.72324218749995,
									61.05517578125006
								],
								[
									-70.54077148437491,
									61.04248046875003
								],
								[
									-70.38364257812495,
									61.06396484375014
								],
								[
									-70.27929687499994,
									61.06865234374996
								],
								[
									-70.1872070312499,
									61.040527343750085
								],
								[
									-70.15795898437491,
									61.02065429687502
								],
								[
									-70.14414062499992,
									60.981103515625136
								],
								[
									-70.14589843749994,
									60.92182617187507
								],
								[
									-70.09531249999992,
									60.88027343750002
								],
								[
									-69.99243164062494,
									60.856494140625074
								],
								[
									-69.90922851562493,
									60.860107421875
								],
								[
									-69.800439453125,
									60.9066894531251
								],
								[
									-69.70839843749997,
									60.91464843750012
								],
								[
									-69.677587890625,
									60.949560546875034
								],
								[
									-69.6504394531249,
									61.01416015625014
								],
								[
									-69.62363281249995,
									61.04951171875004
								],
								[
									-69.55698242187495,
									61.05966796874998
								],
								[
									-69.50332031249994,
									61.040429687500165
								],
								[
									-69.47192382812503,
									61.0109375000001
								],
								[
									-69.41435546875002,
									60.92246093750009
								],
								[
									-69.39833984374997,
									60.88286132812502
								],
								[
									-69.40473632812493,
									60.84677734375015
								],
								[
									-69.433447265625,
									60.814257812500074
								],
								[
									-69.48994140624995,
									60.779589843750045
								],
								[
									-69.57421874999991,
									60.74272460937499
								],
								[
									-69.64047851562489,
									60.68979492187512
								],
								[
									-69.72138671875004,
									60.56743164062499
								],
								[
									-69.7512695312499,
									60.48745117187511
								],
								[
									-69.75947265624998,
									60.4402343750001
								],
								[
									-69.75590820312496,
									60.38852539062495
								],
								[
									-69.74057617187495,
									60.332275390625114
								],
								[
									-69.70849609374991,
									60.28593750000002
								],
								[
									-69.6331054687499,
									60.22036132812505
								],
								[
									-69.628759765625,
									60.19858398437498
								],
								[
									-69.62314453124992,
									60.14545898437507
								],
								[
									-69.62978515624994,
									60.12211914062513
								],
								[
									-69.67373046874994,
									60.075878906250125
								],
								[
									-69.79565429687489,
									60.02973632812504
								],
								[
									-69.96284179687495,
									60.017822265625
								],
								[
									-70.5093261718749,
									60.01518554687502
								],
								[
									-70.65483398437496,
									60.026220703125034
								],
								[
									-70.6197265625,
									59.98427734375002
								],
								[
									-70.46665039062492,
									59.97084960937502
								],
								[
									-70.32685546874993,
									59.97138671875015
								],
								[
									-69.80566406249997,
									59.94487304687499
								],
								[
									-69.73393554687493,
									59.91801757812502
								],
								[
									-69.67343749999995,
									59.87075195312508
								],
								[
									-69.63022460937495,
									59.82182617187496
								],
								[
									-69.58740234374991,
									59.72231445312494
								],
								[
									-69.5793945312499,
									59.67509765624999
								],
								[
									-69.60234374999996,
									59.62270507812508
								],
								[
									-69.6562011718749,
									59.565087890625136
								],
								[
									-69.69238281249991,
									59.48842773437508
								],
								[
									-69.71088867187504,
									59.39252929687515
								],
								[
									-69.68188476562491,
									59.34174804687504
								],
								[
									-69.39999999999995,
									59.33779296874994
								],
								[
									-69.3440429687499,
									59.30307617187498
								],
								[
									-69.35043945312489,
									59.277197265625034
								],
								[
									-69.45048828124993,
									59.18002929687495
								],
								[
									-69.45976562499996,
									59.15244140625009
								],
								[
									-69.41411132812496,
									59.08686523437498
								],
								[
									-69.4203125,
									59.068212890625006
								],
								[
									-69.44809570312489,
									59.049169921875034
								],
								[
									-69.47465820312496,
									59.00000000000014
								],
								[
									-69.50009765624989,
									58.92065429687514
								],
								[
									-69.53164062499994,
									58.86923828125015
								],
								[
									-69.6082031249999,
									58.82949218750002
								],
								[
									-69.64838867187493,
									58.82080078125003
								],
								[
									-69.67734374999995,
									58.831347656250045
								],
								[
									-69.75302734375,
									58.939599609374994
								],
								[
									-69.78417968749997,
									58.95571289062508
								],
								[
									-69.81367187499993,
									58.94555664062497
								],
								[
									-69.82851562499994,
									58.92875976562502
								],
								[
									-69.82861328124994,
									58.90537109374995
								],
								[
									-69.84160156250002,
									58.88115234374999
								],
								[
									-69.867578125,
									58.856152343750125
								],
								[
									-69.97915039062497,
									58.81635742187501
								],
								[
									-70.15996093749996,
									58.78940429687495
								],
								[
									-70.15434570312496,
									58.76059570312495
								],
								[
									-70.03300781249993,
									58.745166015625074
								],
								[
									-69.878564453125,
									58.696972656249955
								],
								[
									-69.78989257812489,
									58.68930664062506
								],
								[
									-69.650537109375,
									58.72827148437503
								],
								[
									-69.38183593749997,
									58.85073242187511
								],
								[
									-69.27109374999989,
									58.88393554687502
								],
								[
									-69.17348632812497,
									58.89663085937502
								],
								[
									-69.06362304687497,
									58.89824218750002
								],
								[
									-68.94150390624989,
									58.88891601562497
								],
								[
									-68.69819335937495,
									58.90454101562506
								],
								[
									-68.63730468749989,
									58.892871093750074
								],
								[
									-68.56289062499994,
									58.86591796875018
								],
								[
									-68.47490234374993,
									58.82348632812497
								],
								[
									-68.41430664062503,
									58.782714843750085
								],
								[
									-68.38115234374993,
									58.74350585937509
								],
								[
									-68.3264648437499,
									58.59541015625004
								],
								[
									-68.25297851562493,
									58.55664062500006
								],
								[
									-68.23515624999996,
									58.52817382812512
								],
								[
									-68.22939453124994,
									58.4845703125001
								],
								[
									-68.23388671874997,
									58.399218750000045
								],
								[
									-68.31469726562491,
									58.226904296875006
								],
								[
									-68.35654296874989,
									58.16323242187511
								],
								[
									-68.4681640625,
									58.07631835937508
								],
								[
									-68.59687499999993,
									58.03686523437494
								],
								[
									-68.82578124999992,
									57.999853515625034
								],
								[
									-68.94531250000003,
									57.96879882812493
								],
								[
									-69.03544921874993,
									57.926025390624915
								],
								[
									-69.04082031249996,
									57.90249023437519
								],
								[
									-68.78095703124995,
									57.97583007812494
								],
								[
									-68.49506835937495,
									58.011669921874955
								],
								[
									-68.41357421874997,
									58.05175781250006
								],
								[
									-68.35185546874993,
									58.09072265625008
								],
								[
									-68.28911132812502,
									58.177685546875125
								],
								[
									-68.17553710937497,
									58.402587890625114
								],
								[
									-68.11103515624998,
									58.47333984375004
								],
								[
									-68.02104492187493,
									58.48530273437507
								],
								[
									-67.98115234374998,
									58.46123046875016
								],
								[
									-67.88779296874989,
									58.3293945312501
								],
								[
									-67.88828124999989,
									58.29575195312492
								],
								[
									-67.9114257812499,
									58.26723632812505
								],
								[
									-68.06386718750005,
									58.13896484374996
								],
								[
									-68.00898437499998,
									58.152050781249955
								],
								[
									-67.85585937499994,
									58.27260742187508
								],
								[
									-67.82333984374989,
									58.31025390625004
								],
								[
									-67.80522460937493,
									58.365478515624915
								],
								[
									-67.75595703124995,
									58.404589843750074
								],
								[
									-67.73706054687491,
									58.38544921875015
								],
								[
									-67.68969726562503,
									58.243798828124994
								],
								[
									-67.68818359374998,
									58.140234375000034
								],
								[
									-67.68056640624994,
									58.10703125000012
								],
								[
									-67.69765625000005,
									58.00874023437507
								],
								[
									-67.67827148437493,
									57.991113281250136
								],
								[
									-67.63222656249997,
									58.07612304687504
								],
								[
									-67.61718749999991,
									58.14033203125015
								],
								[
									-67.59633789062494,
									58.18613281249998
								],
								[
									-67.5696289062499,
									58.213476562500034
								],
								[
									-67.38198242187497,
									58.30000000000015
								],
								[
									-67.16284179687497,
									58.37036132812503
								],
								[
									-67.01943359375,
									58.432910156250074
								],
								[
									-66.90039062499997,
									58.46279296875002
								],
								[
									-66.72216796874991,
									58.49101562499999
								],
								[
									-66.60791015624991,
									58.54892578125006
								],
								[
									-66.55771484374989,
									58.636621093750165
								],
								[
									-66.5150390625,
									58.69731445312502
								],
								[
									-66.47998046874994,
									58.73090820312501
								],
								[
									-66.36240234374989,
									58.79116210937505
								],
								[
									-66.29853515624993,
									58.794531250000006
								],
								[
									-66.23740234375,
									58.77226562500002
								],
								[
									-66.16821289062503,
									58.727099609375045
								],
								[
									-66.09091796875,
									58.659033203125034
								],
								[
									-66.04462890624998,
									58.605615234374994
								],
								[
									-66.02954101562503,
									58.56679687500008
								],
								[
									-66.01704101562495,
									58.43081054687508
								],
								[
									-66.00239257812493,
									58.43120117187499
								],
								[
									-65.93124999999989,
									58.53505859375008
								],
								[
									-65.92290039062496,
									58.57197265625007
								],
								[
									-65.92792968749993,
									58.610937500000006
								],
								[
									-65.94965820312493,
									58.64985351562504
								],
								[
									-66.02128906249993,
									58.73476562500011
								],
								[
									-66.0493652343749,
									58.787890625000074
								],
								[
									-66.04306640624995,
									58.82065429687492
								],
								[
									-65.96704101562491,
									58.83920898437498
								],
								[
									-65.85483398437495,
									58.84663085937507
								],
								[
									-65.83593749999994,
									58.86049804687505
								],
								[
									-65.91840820312495,
									58.89560546874992
								],
								[
									-65.92070312499996,
									58.91464843750006
								],
								[
									-65.84140624999989,
									58.977050781250085
								],
								[
									-65.79482421875,
									58.98046874999997
								],
								[
									-65.70356445312495,
									58.97060546875019
								],
								[
									-65.72192382812497,
									59.002587890625136
								],
								[
									-65.72099609374996,
									59.02377929687492
								],
								[
									-65.69526367187495,
									59.032031250000074
								],
								[
									-65.54399414062496,
									59.01186523437505
								],
								[
									-65.52631835937493,
									59.03623046875006
								],
								[
									-65.39624023437497,
									59.03842773437506
								],
								[
									-65.38354492187497,
									59.06020507812505
								],
								[
									-65.49599609374997,
									59.09130859375
								],
								[
									-65.60624999999993,
									59.11074218750005
								],
								[
									-65.63984375000004,
									59.12773437499996
								],
								[
									-65.66562499999995,
									59.15278320312518
								],
								[
									-65.69999999999996,
									59.21333007812498
								],
								[
									-65.69169921874993,
									59.229394531250136
								],
								[
									-65.66074218749995,
									59.22968750000004
								],
								[
									-65.60712890624995,
									59.21313476562494
								],
								[
									-65.57802734375005,
									59.244970703125034
								],
								[
									-65.54531250000005,
									59.319726562499994
								],
								[
									-65.51279296874992,
									59.35039062500002
								],
								[
									-65.41171874999992,
									59.31499023437499
								],
								[
									-65.4072753906249,
									59.330224609374994
								],
								[
									-65.48935546874992,
									59.44775390625006
								],
								[
									-65.47509765624997,
									59.470312500000034
								],
								[
									-65.34970703124989,
									59.478808593750074
								],
								[
									-65.27377929687489,
									59.46416015624993
								],
								[
									-65.07431640624992,
									59.37802734375006
								],
								[
									-65.03823242187497,
									59.3878906250001
								],
								[
									-65.06884765624997,
									59.411474609375034
								],
								[
									-65.1709472656249,
									59.46225585937489
								],
								[
									-65.26318359374994,
									59.495458984375006
								],
								[
									-65.34550781249993,
									59.51103515625016
								],
								[
									-65.40742187499993,
									59.539355468750045
								],
								[
									-65.47519531249989,
									59.616796875000034
								],
								[
									-65.48647460937505,
									59.648681640625114
								],
								[
									-65.48085937499997,
									59.690234375000074
								],
								[
									-65.4333984374999,
									59.776513671874966
								],
								[
									-65.40615234374994,
									59.795214843750045
								],
								[
									-65.35791015624997,
									59.80908203125003
								],
								[
									-65.28876953124993,
									59.81806640625018
								],
								[
									-65.21225585937489,
									59.80952148437504
								],
								[
									-65.0544921874999,
									59.752783203125006
								],
								[
									-65.02817382812495,
									59.770703125000125
								],
								[
									-65.11328124999997,
									59.801611328125006
								],
								[
									-65.1592285156249,
									59.83012695312513
								],
								[
									-65.18139648437489,
									59.86665039062504
								],
								[
									-65.17172851562489,
									59.90800781249993
								],
								[
									-65.10488281249994,
									59.993408203125
								],
								[
									-65.07338867187491,
									60.06220703125018
								],
								[
									-64.93125,
									60.2520019531251
								],
								[
									-64.88955078124994,
									60.28652343750005
								],
								[
									-64.84501953124993,
									60.308300781249955
								],
								[
									-64.81733398437498,
									60.33105468749997
								],
								[
									-64.70585937499993,
									60.33613281250001
								],
								[
									-64.49941406250005,
									60.26826171875004
								],
								[
									-64.4363281249999,
									60.228125000000034
								],
								[
									-64.41958007812494,
									60.17138671874994
								],
								[
									-64.52773437499997,
									60.09453125000002
								],
								[
									-64.71328124999991,
									60.03715820312496
								],
								[
									-64.76845703124997,
									60.01210937500008
								],
								[
									-64.73256835937494,
									59.99755859375006
								],
								[
									-64.55917968749989,
									60.04340820312498
								],
								[
									-64.40771484374994,
									60.06479492187498
								],
								[
									-64.28349609374993,
									60.064062500000006
								],
								[
									-64.18286132812494,
									59.97294921875002
								],
								[
									-64.16879882812492,
									59.84653320312512
								],
								[
									-64.22631835937491,
									59.74121093750006
								],
								[
									-64.15068359374996,
									59.79360351562508
								],
								[
									-64.05605468750005,
									59.82255859374993
								],
								[
									-63.978710937499926,
									59.75371093750002
								],
								[
									-63.969482421874915,
									59.69760742187506
								],
								[
									-63.92880859374989,
									59.64492187500008
								],
								[
									-63.84125976562498,
									59.57441406250001
								],
								[
									-63.750195312499926,
									59.51259765625002
								],
								[
									-63.8503906249999,
									59.447802734375045
								],
								[
									-63.97070312499997,
									59.40908203125008
								],
								[
									-63.945458984374994,
									59.380175781250045
								],
								[
									-63.78085937499995,
									59.349267578124966
								],
								[
									-63.75859374999993,
									59.318652343750045
								],
								[
									-63.775878906249915,
									59.27714843750002
								],
								[
									-63.75200195312502,
									59.27734375000006
								],
								[
									-63.63749999999996,
									59.34145507812505
								],
								[
									-63.53989257812489,
									59.332861328125006
								],
								[
									-63.41513671874995,
									59.19438476562513
								],
								[
									-63.50620117187495,
									59.11518554687507
								],
								[
									-63.645507812499915,
									59.07890624999996
								],
								[
									-63.75639648437502,
									59.063476562500085
								],
								[
									-63.91049804687489,
									59.06557617187508
								],
								[
									-63.97114257812498,
									59.05380859375009
								],
								[
									-63.94101562499989,
									59.02739257812502
								],
								[
									-63.79365234374998,
									59.027001953125136
								],
								[
									-63.56787109374997,
									59.04702148437511
								],
								[
									-63.39897460937496,
									59.07963867187493
								],
								[
									-63.32553710937492,
									59.081591796875045
								],
								[
									-63.24843749999991,
									59.068310546874926
								],
								[
									-63.22250976562489,
									59.057177734375045
								],
								[
									-63.303710937499915,
									59.03442382812503
								],
								[
									-63.3098632812499,
									59.026464843750006
								],
								[
									-63.27944335937494,
									59.00317382812506
								],
								[
									-63.21640624999989,
									58.92797851562494
								],
								[
									-63.22192382812503,
									58.911035156250136
								],
								[
									-63.28212890624994,
									58.867382812500125
								],
								[
									-63.18535156249996,
									58.85776367187512
								],
								[
									-63.05029296874997,
									58.878173828124915
								],
								[
									-63.00834960937496,
									58.85541992187515
								],
								[
									-62.92607421874996,
									58.765039062499966
								],
								[
									-62.87387695312492,
									58.672460937500006
								],
								[
									-63.1023437499999,
									58.54575195312515
								],
								[
									-63.218652343749994,
									58.519531250000114
								],
								[
									-63.38994140624996,
									58.452539062500165
								],
								[
									-63.43793945312498,
									58.398828124999966
								],
								[
									-63.537060546874926,
									58.329931640625034
								],
								[
									-63.47363281249997,
									58.330664062500006
								],
								[
									-63.29648437499995,
									58.441210937500074
								],
								[
									-63.209960937499886,
									58.46694335937508
								],
								[
									-63.145507812499915,
									58.460449218750085
								],
								[
									-63.11953124999994,
									58.441748046875006
								],
								[
									-63.13212890624993,
									58.4108398437501
								],
								[
									-63.075683593749886,
									58.414794921875114
								],
								[
									-62.83740234375003,
									58.47939453125011
								],
								[
									-62.73730468749997,
									58.49218749999997
								],
								[
									-62.60786132812498,
									58.49638671875002
								],
								[
									-62.59384765624989,
									58.47402343750008
								],
								[
									-62.67431640624994,
									58.31918945312498
								],
								[
									-62.81206054687502,
									58.20039062500004
								],
								[
									-63.06279296874993,
									58.12709960937502
								],
								[
									-63.15166015624993,
									58.08417968749998
								],
								[
									-63.26152343749993,
									58.014697265625045
								],
								[
									-63.2200195312499,
									58.00214843750007
								],
								[
									-62.98090820312504,
									58.093310546875074
								],
								[
									-62.817529296874966,
									58.129248046875006
								],
								[
									-62.58808593750004,
									58.15810546875002
								],
								[
									-62.486230468749994,
									58.154052734375085
								],
								[
									-62.30566406249997,
									57.97226562499992
								],
								[
									-62.20151367187489,
									57.95463867187516
								],
								[
									-62.117431640624886,
									57.96411132812514
								],
								[
									-61.95864257812505,
									57.911767578125136
								],
								[
									-61.899072265624994,
									57.86132812500006
								],
								[
									-61.91406250000003,
									57.82504882812495
								],
								[
									-61.96777343749997,
									57.80332031250006
								],
								[
									-61.9949218749999,
									57.769433593749994
								],
								[
									-61.93124999999989,
									57.66855468750015
								],
								[
									-61.967968749999926,
									57.61191406250015
								],
								[
									-62.083984374999915,
									57.561914062499994
								],
								[
									-62.16689453124994,
									57.53657226562498
								],
								[
									-62.253613281249926,
									57.52875976562498
								],
								[
									-62.338574218749926,
									57.484521484375136
								],
								[
									-62.377148437499955,
									57.47797851562504
								],
								[
									-62.495556640624926,
									57.4892089843751
								],
								[
									-62.45498046874991,
									57.46196289062516
								],
								[
									-62.396484374999915,
									57.4481933593751
								],
								[
									-62.303222656249915,
									57.440673828125085
								],
								[
									-62.194238281249994,
									57.45458984374997
								],
								[
									-62.088085937499955,
									57.45283203125007
								],
								[
									-61.92114257812497,
									57.42080078125002
								],
								[
									-61.851074218749915,
									57.38129882812507
								],
								[
									-61.8498046874999,
									57.37041015625016
								],
								[
									-61.88583984374989,
									57.34785156250018
								],
								[
									-61.93886718749994,
									57.274365234375125
								],
								[
									-61.977441406249966,
									57.24794921875008
								],
								[
									-61.944531249999926,
									57.22812500000012
								],
								[
									-61.86083984375003,
									57.19755859375002
								],
								[
									-61.798339843749915,
									57.18623046875001
								],
								[
									-61.71630859374997,
									57.19619140625019
								],
								[
									-61.62851562499995,
									57.18315429687502
								],
								[
									-61.33374023437494,
									57.010595703125034
								],
								[
									-61.3457519531249,
									56.9215820312501
								],
								[
									-61.39047851562495,
									56.85297851562498
								],
								[
									-61.372802734374886,
									56.77583007812507
								],
								[
									-61.37163085937502,
									56.68081054687508
								],
								[
									-61.531689453124926,
									56.65458984375016
								],
								[
									-62.062499999999886,
									56.69907226562506
								],
								[
									-62.36611328124994,
									56.76699218750005
								],
								[
									-62.38173828124991,
									56.787695312500006
								],
								[
									-62.295800781249994,
									56.83281249999996
								],
								[
									-62.37202148437498,
									56.83618164062503
								],
								[
									-62.460205078124915,
									56.81845703125015
								],
								[
									-62.497265624999926,
									56.80170898437501
								],
								[
									-62.39550781249997,
									56.730029296875074
								],
								[
									-62.116503906249875,
									56.66684570312489
								],
								[
									-61.99160156249994,
									56.59082031250014
								],
								[
									-61.85493164062498,
									56.584277343750045
								],
								[
									-61.81337890624994,
									56.57050781249998
								],
								[
									-61.73774414062498,
									56.52602539062508
								],
								[
									-61.76005859374993,
									56.51074218750017
								],
								[
									-61.89941406249997,
									56.505419921875045
								],
								[
									-62.009667968749966,
									56.45385742187503
								],
								[
									-61.940429687499886,
									56.42358398437517
								],
								[
									-61.692480468750006,
									56.397070312500006
								],
								[
									-61.514599609374926,
									56.39033203125015
								],
								[
									-61.42529296874994,
									56.360644531250045
								],
								[
									-61.49868164062505,
									56.32758789062515
								],
								[
									-61.70712890624989,
									56.28872070312505
								],
								[
									-61.713085937499955,
									56.230957031250085
								],
								[
									-61.558593749999915,
									56.20781249999999
								],
								[
									-61.421093749999955,
									56.22182617187511
								],
								[
									-61.364697265624926,
									56.21601562500007
								],
								[
									-61.32441406249998,
									56.0762207031251
								],
								[
									-61.30112304687495,
									56.047167968750045
								],
								[
									-61.44892578125004,
									56.02236328125005
								],
								[
									-61.4495117187499,
									55.99570312499995
								],
								[
									-61.35126953125004,
									55.973681640625074
								],
								[
									-61.187890624999966,
									55.955371093750074
								],
								[
									-61.13388671874989,
									55.930273437500034
								],
								[
									-61.12299804687498,
									55.888574218749966
								],
								[
									-61.08935546874997,
									55.866357421875165
								],
								[
									-60.995751953124994,
									55.86235351562496
								],
								[
									-60.89267578124995,
									55.914208984375136
								],
								[
									-60.8318359374999,
									55.95786132812515
								],
								[
									-60.74326171874989,
									55.9414550781249
								],
								[
									-60.73662109374996,
									55.886962890625
								],
								[
									-60.63095703124992,
									55.82499999999999
								],
								[
									-60.59257812500002,
									55.81484375000005
								],
								[
									-60.56210937499995,
									55.7270019531251
								],
								[
									-60.47583007812494,
									55.805126953125125
								],
								[
									-60.41259765625003,
									55.78857421875003
								],
								[
									-60.341015624999926,
									55.78466796874994
								],
								[
									-60.365429687499926,
									55.70908203125009
								],
								[
									-60.40830078124995,
									55.64956054687505
								],
								[
									-60.35195312499994,
									55.6123535156251
								],
								[
									-60.308300781249926,
									55.55698242187492
								],
								[
									-60.19238281249994,
									55.48090820312515
								],
								[
									-60.224023437499994,
									55.444384765625074
								],
								[
									-60.36093749999989,
									55.36630859374998
								],
								[
									-60.43310546874994,
									55.242773437500034
								],
								[
									-60.45009765624994,
									55.199951171875114
								],
								[
									-60.520507812499915,
									55.12900390624995
								],
								[
									-60.617138671874955,
									55.060205078124966
								],
								[
									-60.55654296875005,
									55.06748046875012
								],
								[
									-60.340771484374955,
									55.193945312500034
								],
								[
									-60.212548828124966,
									55.23642578124998
								],
								[
									-59.93032226562494,
									55.25942382812505
								],
								[
									-59.86210937499996,
									55.29487304687498
								],
								[
									-59.75878906249997,
									55.30957031250006
								],
								[
									-59.695507812499955,
									55.26914062499989
								],
								[
									-59.68906249999989,
									55.19633789062499
								],
								[
									-59.605468749999915,
									55.173339843749915
								],
								[
									-59.51767578124989,
									55.19736328125012
								],
								[
									-59.43789062500005,
									55.17592773437519
								],
								[
									-59.48583984374997,
									55.1301757812501
								],
								[
									-59.74169921874994,
									54.94257812499998
								],
								[
									-59.816406249999886,
									54.8672363281249
								],
								[
									-59.837792968749994,
									54.81396484375017
								],
								[
									-59.74990234374994,
									54.88701171875013
								],
								[
									-59.42856445312492,
									55.05551757812489
								],
								[
									-59.39418945312494,
									55.08071289062505
								],
								[
									-59.32416992187498,
									55.15283203125
								],
								[
									-59.25957031249996,
									55.199951171875114
								],
								[
									-59.08632812499994,
									55.18325195312508
								],
								[
									-58.99711914062496,
									55.14946289062513
								],
								[
									-58.955810546874886,
									55.05507812500008
								],
								[
									-58.88579101562502,
									54.95224609375009
								],
								[
									-58.780175781249994,
									54.83837890625017
								],
								[
									-58.49990234374991,
									54.783105468749994
								],
								[
									-58.39814453124998,
									54.77412109375004
								],
								[
									-58.222851562499955,
									54.81269531249998
								],
								[
									-58.195263671874955,
									54.8659179687501
								],
								[
									-58.05849609375005,
									54.88222656249994
								],
								[
									-57.96245117187493,
									54.87573242187514
								],
								[
									-57.92929687499995,
									54.7731445312501
								],
								[
									-57.826855468749926,
									54.71865234375011
								],
								[
									-57.72490234374996,
									54.67373046875019
								],
								[
									-57.626611328124994,
									54.650341796874955
								],
								[
									-57.483007812499864,
									54.640283203125136
								],
								[
									-57.40449218750004,
									54.59086914062502
								],
								[
									-57.40444335937494,
									54.570410156250006
								],
								[
									-57.485351562499915,
									54.517480468750165
								],
								[
									-57.56323242187497,
									54.4404296875
								],
								[
									-57.69926757812496,
									54.386572265625034
								],
								[
									-57.889111328124926,
									54.38408203125016
								],
								[
									-58.15136718749997,
									54.35043945312506
								],
								[
									-58.1619140624999,
									54.319970703124966
								],
								[
									-58.21972656249994,
									54.28647460937489
								],
								[
									-58.35913085937494,
									54.253320312500165
								],
								[
									-58.435205078124966,
									54.228125000000006
								],
								[
									-58.55839843749993,
									54.1029785156251
								],
								[
									-58.633203124999994,
									54.04956054687494
								],
								[
									-58.71943359374998,
									54.039404296875006
								],
								[
									-58.840820312499915,
									54.044482421875074
								],
								[
									-58.92021484375002,
									54.033105468749966
								],
								[
									-58.97846679687498,
									54.01025390625003
								],
								[
									-59.012646484374926,
									53.97626953125004
								],
								[
									-59.03881835937494,
									53.96362304687503
								],
								[
									-59.20141601562494,
									53.92910156250019
								],
								[
									-59.496533203124926,
									53.83417968750004
								],
								[
									-59.65268554687495,
									53.83125000000015
								],
								[
									-59.749462890624926,
									53.84228515625
								],
								[
									-59.82304687499993,
									53.8344238281251
								],
								[
									-59.87333984374996,
									53.807763671875165
								],
								[
									-60.01416015624994,
									53.76157226562489
								],
								[
									-60.056542968749966,
									53.73334960937501
								],
								[
									-60.08134765624996,
									53.70102539062509
								],
								[
									-60.100488281249966,
									53.63422851562507
								],
								[
									-60.11728515624992,
									53.61010742187494
								],
								[
									-60.14492187499994,
									53.59614257812504
								],
								[
									-60.263330078124994,
									53.61005859375004
								],
								[
									-60.395410156249994,
									53.65332031250014
								],
								[
									-60.36953125000005,
									53.607470703125045
								],
								[
									-60.16025390624995,
									53.52998046875007
								],
								[
									-60.100292968749926,
									53.48696289062508
								],
								[
									-60.15712890624994,
									53.44980468749998
								],
								[
									-60.29028320312497,
									53.39145507812509
								],
								[
									-60.30576171874995,
									53.360107421875
								],
								[
									-60.251171874999926,
									53.3435546875001
								],
								[
									-60.27270507812494,
									53.31708984375004
								],
								[
									-60.345703124999915,
									53.28901367187518
								],
								[
									-60.337500000000006,
									53.277441406250034
								],
								[
									-60.329492187499966,
									53.26611328125003
								],
								[
									-60.14833984374994,
									53.30654296875019
								],
								[
									-59.98710937499996,
									53.392822265625085
								],
								[
									-59.881738281249966,
									53.48007812499992
								],
								[
									-59.82905273437498,
									53.50454101562511
								],
								[
									-59.621093749999886,
									53.53681640625004
								],
								[
									-59.49814453124989,
									53.57475585937513
								],
								[
									-59.32226562499994,
									53.64375000000015
								],
								[
									-59.129394531249915,
									53.74394531250013
								],
								[
									-58.919580078124966,
									53.875292968750074
								],
								[
									-58.652050781249926,
									53.977880859375006
								],
								[
									-58.3267089843749,
									54.051806640625045
								],
								[
									-58.08808593750004,
									54.08950195312519
								],
								[
									-57.935986328124955,
									54.09116210937489
								],
								[
									-57.9282714843749,
									54.10356445312493
								],
								[
									-58.06484374999994,
									54.126757812500045
								],
								[
									-58.17744140625004,
									54.13129882812518
								],
								[
									-58.31748046874989,
									54.114453125000125
								],
								[
									-58.360791015624926,
									54.15449218750001
								],
								[
									-58.35615234375004,
									54.1719238281251
								],
								[
									-58.30996093749994,
									54.20166015625003
								],
								[
									-58.192089843749926,
									54.22817382812519
								],
								[
									-57.614941406249926,
									54.19111328125001
								],
								[
									-57.4160644531249,
									54.16274414062519
								],
								[
									-57.198876953124994,
									53.92436523437502
								],
								[
									-57.14897460937496,
									53.84770507812513
								],
								[
									-57.134960937499926,
									53.79184570312512
								],
								[
									-57.15693359374998,
									53.7568847656251
								],
								[
									-57.24399414062495,
									53.71547851562519
								],
								[
									-57.48945312500004,
									53.63310546875002
								],
								[
									-57.524072265624994,
									53.611425781250034
								],
								[
									-57.52734375000003,
									53.5999023437501
								],
								[
									-57.42021484374996,
									53.583251953125085
								],
								[
									-57.38613281249994,
									53.56054687499997
								],
								[
									-57.331738281249955,
									53.46909179687509
								],
								[
									-57.22138671875004,
									53.528515625000125
								],
								[
									-57.012158203124955,
									53.67260742187517
								],
								[
									-56.84086914062496,
									53.73945312500001
								],
								[
									-56.696582031249875,
									53.75766601562509
								],
								[
									-56.52431640625005,
									53.766455078125006
								],
								[
									-56.46499023437505,
									53.765039062500165
								],
								[
									-56.444335937499915,
									53.71831054687496
								],
								[
									-56.354003906249915,
									53.624462890625125
								],
								[
									-56.27021484374998,
									53.60009765625014
								],
								[
									-56.11015624999996,
									53.58759765624998
								],
								[
									-55.96611328125002,
									53.47114257812515
								],
								[
									-55.91123046874995,
									53.39082031250004
								],
								[
									-55.85937500000003,
									53.343896484375165
								],
								[
									-55.86337890624998,
									53.312255859375114
								],
								[
									-55.8547851562499,
									53.28583984375007
								],
								[
									-55.816894531249915,
									53.245751953124966
								],
								[
									-55.79794921874995,
									53.21196289062502
								],
								[
									-55.808203125000006,
									53.13466796875008
								],
								[
									-55.892333984374915,
									53.00043945312518
								],
								[
									-55.8298828124999,
									52.878417968749915
								],
								[
									-55.857910156249915,
									52.82338867187508
								],
								[
									-55.87250976562504,
									52.73569335937498
								],
								[
									-55.8186523437499,
									52.67714843750005
								],
								[
									-55.80283203124989,
									52.64316406249995
								],
								[
									-55.84843749999993,
									52.6233398437501
								],
								[
									-56.166992187499915,
									52.574755859375045
								],
								[
									-56.29238281250005,
									52.57377929687513
								],
								[
									-56.324902343749926,
									52.544531250000034
								],
								[
									-56.228417968749994,
									52.53598632812506
								],
								[
									-56.05258789062498,
									52.537402343750074
								],
								[
									-55.84018554687495,
									52.507617187500045
								],
								[
									-55.746484374999966,
									52.47456054687507
								],
								[
									-55.705957031249966,
									52.428271484375045
								],
								[
									-55.716210937499994,
									52.39150390625002
								],
								[
									-55.7771484374999,
									52.36425781249997
								],
								[
									-55.89667968750001,
									52.3695800781251
								],
								[
									-56.01171875,
									52.3944824218751
								],
								[
									-56.00463867187497,
									52.37041015624999
								],
								[
									-55.83364257812494,
									52.31040039062512
								],
								[
									-55.78349609374993,
									52.27993164062502
								],
								[
									-55.69106445312494,
									52.241601562500136
								],
								[
									-55.67280273437504,
									52.190136718750125
								],
								[
									-55.695214843749994,
									52.13779296875012
								],
								[
									-56.017480468749994,
									51.929296875000006
								],
								[
									-56.282568359375006,
									51.79707031250007
								],
								[
									-56.54858398437503,
									51.68100585937515
								],
								[
									-56.97597656250005,
									51.45766601562502
								],
								[
									-57.018261718749955,
									51.44677734375003
								],
								[
									-57.095605468749994,
									51.44252929687505
								],
								[
									-57.299218749999994,
									51.47827148437506
								],
								[
									-57.46166992187497,
									51.469091796875034
								],
								[
									-57.7695800781249,
									51.42592773437505
								],
								[
									-57.853759765624915,
									51.39951171874989
								],
								[
									-58.02265625000004,
									51.32207031249993
								],
								[
									-58.08940429687496,
									51.31098632812498
								],
								[
									-58.27045898437498,
									51.29521484374996
								],
								[
									-58.442285156249994,
									51.305908203125114
								],
								[
									-58.510351562500006,
									51.29506835937511
								],
								[
									-58.59326171875003,
									51.25712890625002
								],
								[
									-58.61474609374997,
									51.237060546875114
								],
								[
									-58.637597656249994,
									51.17167968750002
								],
								[
									-59.05493164062494,
									50.8791015625001
								],
								[
									-59.16538085937495,
									50.77988281250006
								],
								[
									-59.37802734374995,
									50.675439453124994
								],
								[
									-59.61191406249989,
									50.49208984375005
								],
								[
									-59.81533203124994,
									50.4182617187501
								],
								[
									-59.88632812499992,
									50.31640625000014
								],
								[
									-60.08017578124989,
									50.25458984375015
								],
								[
									-60.43808593749989,
									50.23886718750015
								],
								[
									-60.6082031249999,
									50.2211425781251
								],
								[
									-60.80722656249995,
									50.249804687500074
								],
								[
									-60.95629882812494,
									50.20541992187509
								],
								[
									-61.18071289062502,
									50.19150390625009
								],
								[
									-61.289746093749955,
									50.20195312499999
								],
								[
									-61.72485351562503,
									50.104052734375045
								],
								[
									-61.835351562499994,
									50.19697265625004
								],
								[
									-61.91953124999989,
									50.23286132812507
								],
								[
									-62.16523437500004,
									50.238916015625165
								],
								[
									-62.361669921875006,
									50.27729492187507
								],
								[
									-62.54091796874994,
									50.284521484375034
								],
								[
									-62.71542968749995,
									50.30166015625005
								],
								[
									-62.830224609374994,
									50.30146484375001
								],
								[
									-62.9497558593749,
									50.291357421875006
								],
								[
									-63.13564453124994,
									50.29379882812515
								],
								[
									-63.238623046874864,
									50.24257812500019
								],
								[
									-63.586669921874915,
									50.25820312500008
								],
								[
									-63.73359374999998,
									50.304638671874955
								],
								[
									-63.853955078124926,
									50.31435546875008
								],
								[
									-64.01582031249993,
									50.303955078125085
								],
								[
									-64.17041015624991,
									50.269433593750165
								],
								[
									-64.50893554687494,
									50.308935546875034
								],
								[
									-64.86787109374998,
									50.27548828125015
								],
								[
									-65.18090820312497,
									50.2979003906251
								],
								[
									-65.2686035156249,
									50.32001953125007
								],
								[
									-65.76245117187497,
									50.25927734374994
								],
								[
									-65.95537109375002,
									50.29414062500004
								],
								[
									-66.12553710937496,
									50.20102539062498
								],
								[
									-66.24218749999991,
									50.22036132812511
								],
								[
									-66.36884765624995,
									50.20664062500006
								],
								[
									-66.41108398437504,
									50.22426757812519
								],
								[
									-66.49550781249991,
									50.21186523437515
								],
								[
									-66.55004882812494,
									50.16118164062513
								],
								[
									-66.62172851562505,
									50.15541992187511
								],
								[
									-66.740869140625,
									50.065527343750006
								],
								[
									-66.94116210937503,
									49.99370117187502
								],
								[
									-67.23437499999991,
									49.601757812499926
								],
								[
									-67.26191406249993,
									49.451171875000085
								],
								[
									-67.37202148437495,
									49.34843750000002
								],
								[
									-67.46923828124997,
									49.334619140625136
								],
								[
									-67.54926757812493,
									49.332275390624915
								],
								[
									-68.05625,
									49.2567871093751
								],
								[
									-68.28193359374998,
									49.19716796875011
								],
								[
									-68.22060546875,
									49.149658203125114
								],
								[
									-68.29453124999989,
									49.114355468750034
								],
								[
									-68.41440429687486,
									49.09951171875011
								],
								[
									-68.54384765624997,
									49.05615234374997
								],
								[
									-68.62788085937493,
									49.00717773437495
								],
								[
									-68.66904296874989,
									48.93950195312502
								],
								[
									-68.929052734375,
									48.82895507812515
								],
								[
									-69.23076171874993,
									48.57363281250008
								],
								[
									-69.37495117187498,
									48.386425781249955
								],
								[
									-69.55009765624996,
									48.25078125000013
								],
								[
									-69.67387695312496,
									48.1991699218751
								],
								[
									-69.76191406250004,
									48.19116210937497
								],
								[
									-69.85170898437494,
									48.20737304687489
								],
								[
									-70.0010253906249,
									48.27094726562515
								],
								[
									-70.11064453124993,
									48.277978515625165
								],
								[
									-70.38369140624997,
									48.36650390624999
								],
								[
									-71.01826171874993,
									48.45561523437502
								],
								[
									-70.92260742187497,
									48.42231445312498
								],
								[
									-70.83876953124997,
									48.36738281249998
								],
								[
									-70.67109374999998,
									48.35322265625004
								],
								[
									-70.500634765625,
									48.35434570312509
								],
								[
									-70.1453124999999,
									48.24355468750008
								],
								[
									-69.97119140624994,
									48.2057617187501
								],
								[
									-69.86552734374993,
									48.17226562500002
								],
								[
									-69.77499999999995,
									48.09809570312501
								],
								[
									-69.83984374999994,
									47.95258789062504
								],
								[
									-69.9055664062499,
									47.832226562500125
								],
								[
									-69.9944335937499,
									47.73989257812505
								],
								[
									-70.3000976562499,
									47.503027343750034
								],
								[
									-70.44804687499993,
									47.42343750000006
								],
								[
									-70.70585937499996,
									47.13979492187511
								],
								[
									-70.97270507812487,
									47.00668945312506
								],
								[
									-71.11562500000005,
									46.92495117187511
								],
								[
									-71.26777343749995,
									46.795947265625045
								],
								[
									-71.62475585937503,
									46.698388671874966
								],
								[
									-71.75727539062495,
									46.67358398437506
								],
								[
									-71.87958984374998,
									46.68681640625002
								],
								[
									-72.02846679687494,
									46.607421875000085
								],
								[
									-72.20463867187496,
									46.55888671874996
								],
								[
									-72.2566406249999,
									46.485058593750125
								],
								[
									-72.68012695312493,
									46.28730468750015
								],
								[
									-72.84267578125,
									46.262402343749955
								],
								[
									-72.98100585937493,
									46.20971679687506
								],
								[
									-73.02192382812493,
									46.12026367187505
								],
								[
									-73.14541015624994,
									46.06630859375008
								],
								[
									-73.17968749999991,
									46.025000000000006
								],
								[
									-73.28354492187492,
									45.8998535156251
								],
								[
									-73.47661132812493,
									45.738232421874926
								],
								[
									-73.71186523437498,
									45.71118164062503
								],
								[
									-73.79785156249991,
									45.65493164062511
								],
								[
									-73.89741210937493,
									45.5641601562501
								],
								[
									-74.03784179687494,
									45.50185546875019
								],
								[
									-74.31508789062494,
									45.5310546875001
								],
								[
									-74.24765624999989,
									45.49287109375004
								],
								[
									-73.99960937499989,
									45.433349609375085
								],
								[
									-73.97382812499995,
									45.34511718750005
								],
								[
									-74.09809570312495,
									45.32402343750002
								],
								[
									-74.35830078124997,
									45.206396484375034
								],
								[
									-74.70888671874997,
									45.00385742187507
								]
							]
						],
						[
							[
								[
									-96.78232421874998,
									72.93662109374998
								],
								[
									-96.94379882812501,
									72.92670898437501
								],
								[
									-97.0927734375,
									72.996923828125
								],
								[
									-97.09765625,
									73.06240234374994
								],
								[
									-97.08769531250002,
									73.098486328125
								],
								[
									-97.06923828125,
									73.13017578125007
								],
								[
									-97.01499023437495,
									73.15727539062499
								],
								[
									-96.86240234374995,
									73.18881835937512
								],
								[
									-96.79316406249998,
									73.16547851562507
								],
								[
									-96.76777343749995,
									73.1373046875
								],
								[
									-96.74443359374999,
									73.12626953125007
								],
								[
									-96.64599609375,
									73.10190429687509
								],
								[
									-96.598486328125,
									73.07382812499995
								],
								[
									-96.60351562499997,
									73.04155273437505
								],
								[
									-96.635400390625,
									72.99243164062506
								],
								[
									-96.67060546874995,
									72.96093750000006
								],
								[
									-96.709228515625,
									72.94697265624995
								],
								[
									-96.78232421874998,
									72.93662109374998
								]
							]
						],
						[
							[
								[
									-114.52153320312503,
									72.59291992187502
								],
								[
									-114.45810546874998,
									72.58037109374996
								],
								[
									-114.34243164062495,
									72.59077148437495
								],
								[
									-114.17446289062502,
									72.62407226562499
								],
								[
									-113.95781250000002,
									72.65146484374998
								],
								[
									-113.69243164062496,
									72.67280273437507
								],
								[
									-113.62216796874995,
									72.646826171875
								],
								[
									-113.57807617187503,
									72.65209960937511
								],
								[
									-113.50004882812502,
									72.69443359375012
								],
								[
									-113.48613281250003,
									72.722265625
								],
								[
									-113.49589843749997,
									72.75366210937509
								],
								[
									-113.49140624999995,
									72.8220703125001
								],
								[
									-113.44985351562501,
									72.86323242187495
								],
								[
									-113.2923828125,
									72.9498046875
								],
								[
									-113.20800781250003,
									72.98100585937496
								],
								[
									-113.07353515624999,
									72.99526367187494
								],
								[
									-112.75361328125001,
									72.98603515624993
								],
								[
									-112.45375976562502,
									72.93662109374998
								],
								[
									-112.04809570312499,
									72.88803710937503
								],
								[
									-111.45541992187495,
									72.76591796875002
								],
								[
									-111.26972656249995,
									72.71372070312495
								],
								[
									-111.25039062500001,
									72.66855468750009
								],
								[
									-111.35551757812502,
									72.57211914062498
								],
								[
									-111.610888671875,
									72.43559570312496
								],
								[
									-111.81601562499995,
									72.38632812500003
								],
								[
									-111.89516601562501,
									72.35610351562502
								],
								[
									-111.76162109374998,
									72.33525390625013
								],
								[
									-111.67509765625002,
									72.30014648437506
								],
								[
									-111.54355468749996,
									72.35092773437503
								],
								[
									-111.44736328124999,
									72.40771484375006
								],
								[
									-111.31118164062495,
									72.45483398437497
								],
								[
									-111.26479492187501,
									72.4590332031251
								],
								[
									-111.25341796875,
									72.44907226562495
								],
								[
									-111.27714843749995,
									72.42485351562499
								],
								[
									-111.28725585937497,
									72.40112304687503
								],
								[
									-111.28374023437496,
									72.37797851562513
								],
								[
									-111.26806640624997,
									72.3638671875
								],
								[
									-111.18461914062502,
									72.35664062499995
								],
								[
									-111.13989257812497,
									72.36533203124995
								],
								[
									-110.95898437499997,
									72.43198242187512
								],
								[
									-110.78154296874997,
									72.5338867187501
								],
								[
									-110.51254882812496,
									72.59970703125009
								],
								[
									-110.43930664062496,
									72.63334960937502
								],
								[
									-110.20512695312496,
									72.66127929687502
								],
								[
									-110.207958984375,
									72.68105468749997
								],
								[
									-110.19716796875002,
									72.75888671875
								],
								[
									-110.27910156250002,
									72.79204101562502
								],
								[
									-110.55361328124998,
									72.86142578125003
								],
								[
									-110.68940429687503,
									72.94453125000007
								],
								[
									-110.66083984374998,
									73.008203125
								],
								[
									-110.50927734375001,
									72.99892578124997
								],
								[
									-110.09462890625001,
									72.99213867187493
								],
								[
									-110.00844726562494,
									72.98364257812497
								],
								[
									-109.60996093749993,
									72.8756835937501
								],
								[
									-109.46909179687502,
									72.80844726562498
								],
								[
									-109.35712890624994,
									72.77504882812502
								],
								[
									-109.12192382812499,
									72.72641601562506
								],
								[
									-109.04301757812499,
									72.68686523437509
								],
								[
									-108.98740234374993,
									72.67080078125008
								],
								[
									-108.96816406250002,
									72.65410156250007
								],
								[
									-108.98540039062497,
									72.63681640625
								],
								[
									-108.99443359374995,
									72.59599609375005
								],
								[
									-108.95078124999993,
									72.58286132812503
								],
								[
									-108.79785156249996,
									72.56752929687502
								],
								[
									-108.75498046875002,
									72.55107421875005
								],
								[
									-108.69829101562502,
									72.49926757812506
								],
								[
									-108.62773437500003,
									72.41201171875005
								],
								[
									-108.56635742187495,
									72.31733398437501
								],
								[
									-108.46958007812496,
									72.13876953124998
								],
								[
									-108.27641601562496,
									71.90039062500009
								],
								[
									-108.21040039062501,
									71.75117187500007
								],
								[
									-108.18823242187501,
									71.72377929687508
								],
								[
									-108.14467773437502,
									71.70493164062506
								],
								[
									-108.02080078125002,
									71.67749023437497
								],
								[
									-107.92534179687502,
									71.63867187500006
								],
								[
									-107.81284179687502,
									71.62617187500007
								],
								[
									-107.78544921875003,
									71.62968750000007
								],
								[
									-107.75747070312501,
									71.66303710937495
								],
								[
									-107.68725585937501,
									71.71611328125002
								],
								[
									-107.34692382812496,
									71.81923828125008
								],
								[
									-107.329296875,
									71.83525390624996
								],
								[
									-107.36943359375,
									71.85898437500009
								],
								[
									-107.38178710937495,
									71.875146484375
								],
								[
									-107.37685546875001,
									71.886083984375
								],
								[
									-107.30600585937496,
									71.89467773437508
								],
								[
									-107.54262695312494,
									72.02534179687495
								],
								[
									-107.69584960937499,
									72.14931640625
								],
								[
									-107.79404296875,
									72.30263671874997
								],
								[
									-107.80903320312495,
									72.34746093750013
								],
								[
									-107.82373046875001,
									72.4427734375
								],
								[
									-107.85561523437502,
									72.46782226562505
								],
								[
									-107.90981445312497,
									72.4907714843751
								],
								[
									-107.93251953124997,
									72.52041015625011
								],
								[
									-107.92368164062495,
									72.55664062500011
								],
								[
									-107.93437499999999,
									72.58774414062503
								],
								[
									-107.99716796874999,
									72.65268554687495
								],
								[
									-108.238232421875,
									73.10581054687506
								],
								[
									-108.23740234375,
									73.14990234375
								],
								[
									-108.20415039062497,
									73.18305664062501
								],
								[
									-108.11831054687498,
									73.20205078124997
								],
								[
									-107.97993164062495,
									73.20673828125004
								],
								[
									-107.93618164062501,
									73.21713867187512
								],
								[
									-107.98706054687499,
									73.23310546874998
								],
								[
									-108.07749023437502,
									73.28139648437497
								],
								[
									-108.08940429687496,
									73.30371093750006
								],
								[
									-108.02905273437501,
									73.34873046875
								],
								[
									-107.72001953125002,
									73.32905273437507
								],
								[
									-107.49628906250001,
									73.28837890624996
								],
								[
									-107.1134765625,
									73.19213867187509
								],
								[
									-107.07441406249994,
									73.197412109375
								],
								[
									-107.03251953125003,
									73.24531249999998
								],
								[
									-106.95078124999998,
									73.27602539062494
								],
								[
									-106.828369140625,
									73.2659179687501
								],
								[
									-106.48212890624998,
									73.19619140625002
								],
								[
									-106.08164062500002,
									73.07192382812511
								],
								[
									-105.81269531250003,
									73.01064453124997
								],
								[
									-105.624169921875,
									72.92749023437509
								],
								[
									-105.49594726562498,
									72.84897460937498
								],
								[
									-105.41513671874995,
									72.78833007812497
								],
								[
									-105.41166992187495,
									72.76464843749994
								],
								[
									-105.43007812499997,
									72.74038085937497
								],
								[
									-105.41108398437501,
									72.708740234375
								],
								[
									-105.35454101562503,
									72.66972656249996
								],
								[
									-105.32319335937495,
									72.63481445312496
								],
								[
									-105.29755859374997,
									72.56044921875
								],
								[
									-105.24692382812496,
									72.46357421875007
								],
								[
									-105.23408203125001,
									72.41508789062496
								],
								[
									-104.87832031250001,
									71.97998046875003
								],
								[
									-104.810302734375,
									71.90317382812503
								],
								[
									-104.76699218749998,
									71.86757812499997
								],
								[
									-104.51831054687503,
									71.69921875000003
								],
								[
									-104.38593749999997,
									71.5769531250001
								],
								[
									-104.37314453124993,
									71.49511718749994
								],
								[
									-104.35537109374997,
									71.47167968750006
								],
								[
									-104.34956054687503,
									71.43398437500011
								],
								[
									-104.35581054687496,
									71.382080078125
								],
								[
									-104.38486328125002,
									71.337548828125
								],
								[
									-104.43681640625003,
									71.30029296874994
								],
								[
									-104.48706054687497,
									71.24790039062512
								],
								[
									-104.5630859375,
									71.13242187499995
								],
								[
									-104.56958007812499,
									71.1040527343751
								],
								[
									-104.51479492187502,
									71.0642578125001
								],
								[
									-104.166845703125,
									70.92719726562507
								],
								[
									-103.95346679687498,
									70.76264648437493
								],
								[
									-103.85346679687503,
									70.7337890625
								],
								[
									-103.58457031249996,
									70.63085937500009
								],
								[
									-103.29467773437496,
									70.5724609375001
								],
								[
									-103.19716796875,
									70.54731445312501
								],
								[
									-103.10498046874996,
									70.51025390625003
								],
								[
									-103.07719726562497,
									70.5088378906251
								],
								[
									-103.02119140625003,
									70.51582031250001
								],
								[
									-103.00517578124996,
									70.52592773437502
								],
								[
									-103.00122070312496,
									70.54096679687507
								],
								[
									-103.08281249999996,
									70.61909179687507
								],
								[
									-103.08857421874998,
									70.64970703125002
								],
								[
									-103.04956054687503,
									70.65507812500005
								],
								[
									-102.75048828125003,
									70.521875
								],
								[
									-102.58916015624993,
									70.46884765625003
								],
								[
									-102.36874999999998,
									70.41323242187505
								],
								[
									-101.98984374999996,
									70.28505859375005
								],
								[
									-101.93720703124998,
									70.27456054687497
								],
								[
									-101.73222656249997,
									70.28637695312497
								],
								[
									-101.67631835937495,
									70.27827148437493
								],
								[
									-101.64116210937499,
									70.26557617187501
								],
								[
									-101.62680664062499,
									70.24833984374996
								],
								[
									-101.61845703124997,
									70.17241210937513
								],
								[
									-101.56240234375001,
									70.13500976562506
								],
								[
									-101.23916015624998,
									70.15097656250009
								],
								[
									-101.14853515624999,
									70.14760742187505
								],
								[
									-101.09077148437503,
									70.13569335937493
								],
								[
									-101.04267578125,
									70.1107910156251
								],
								[
									-100.97333984375,
									70.02949218749995
								],
								[
									-100.90908203124997,
									69.86918945312499
								],
								[
									-100.90571289062498,
									69.8117187500001
								],
								[
									-100.93510742187493,
									69.71533203125009
								],
								[
									-100.98237304687497,
									69.67988281250004
								],
								[
									-101.04370117187503,
									69.668701171875
								],
								[
									-101.21621093750001,
									69.67963867187501
								],
								[
									-101.33725585937498,
									69.71025390625002
								],
								[
									-101.40009765624998,
									69.74926757812497
								],
								[
									-101.45673828124998,
									69.83388671875008
								],
								[
									-101.483837890625,
									69.85019531250012
								],
								[
									-101.50839843750002,
									69.83315429687502
								],
								[
									-101.56508789062502,
									69.75566406250005
								],
								[
									-101.60249023437501,
									69.72128906250006
								],
								[
									-101.64765624999997,
									69.69853515625013
								],
								[
									-101.73359374999998,
									69.70415039062502
								],
								[
									-101.86025390624994,
									69.7380859375001
								],
								[
									-102.09794921874996,
									69.82460937499997
								],
								[
									-102.18212890624997,
									69.84594726562506
								],
								[
									-102.23432617187494,
									69.8422363281251
								],
								[
									-102.34809570312503,
									69.81298828125009
								],
								[
									-102.52348632812497,
									69.75820312499994
								],
								[
									-102.59589843749998,
									69.71791992187508
								],
								[
									-102.56523437499995,
									69.69218749999999
								],
								[
									-102.54492187499999,
									69.65981445312497
								],
								[
									-102.53486328124998,
									69.62080078125001
								],
								[
									-102.54091796874997,
									69.59208984375002
								],
								[
									-102.56313476562497,
									69.57358398437498
								],
								[
									-102.62109374999996,
									69.55151367187511
								],
								[
									-102.74360351562495,
									69.54775390625005
								],
								[
									-102.91977539062496,
									69.56464843750001
								],
								[
									-103.05917968749995,
									69.59467773437493
								],
								[
									-103.30322265625001,
									69.67431640625009
								],
								[
									-103.35927734374998,
									69.68535156250002
								],
								[
									-103.434765625,
									69.66767578125004
								],
								[
									-103.464892578125,
									69.64448242187504
								],
								[
									-103.41801757812496,
									69.61142578125006
								],
								[
									-103.29404296875,
									69.56845703125
								],
								[
									-103.14243164062495,
									69.49726562500007
								],
								[
									-103.10185546874993,
									69.48334960937498
								],
								[
									-103.06274414062496,
									69.48491210937513
								],
								[
									-103.04892578124999,
									69.47177734375012
								],
								[
									-103.03183593749998,
									69.43349609375005
								],
								[
									-103.039794921875,
									69.36757812499994
								],
								[
									-103.11269531250001,
									69.23598632812502
								],
								[
									-103.12021484374995,
									69.20458984374994
								],
								[
									-103.09033203124999,
									69.21201171874995
								],
								[
									-102.88408203124997,
									69.34130859375
								],
								[
									-102.77744140625002,
									69.37758789062502
								],
								[
									-102.54648437499995,
									69.43447265624997
								],
								[
									-102.44677734374997,
									69.47631835937497
								],
								[
									-102.15141601562502,
									69.48769531250008
								],
								[
									-102.04594726562493,
									69.46484374999994
								],
								[
									-101.97822265625,
									69.42509765625002
								],
								[
									-101.97553710937498,
									69.40703125000007
								],
								[
									-102.05288085937502,
									69.36044921875009
								],
								[
									-102.06689453125003,
									69.33710937500004
								],
								[
									-102.07089843749996,
									69.30761718749997
								],
								[
									-102.06401367187497,
									69.28115234375
								],
								[
									-102.04609374999997,
									69.257666015625
								],
								[
									-101.99296874999997,
									69.23603515624995
								],
								[
									-101.89912109374995,
									69.24550781249994
								],
								[
									-101.87285156250002,
									69.23994140624995
								],
								[
									-101.82250976562499,
									69.2170898437501
								],
								[
									-101.78925781249995,
									69.18164062499997
								],
								[
									-101.78779296875001,
									69.13227539062495
								],
								[
									-101.85712890625001,
									69.0239746093751
								],
								[
									-101.98056640624993,
									68.98852539062506
								],
								[
									-102.3587890625,
									68.92285156250011
								],
								[
									-102.48842773437502,
									68.88891601562494
								],
								[
									-102.73833007812495,
									68.86499023437494
								],
								[
									-102.83486328125,
									68.83325195312497
								],
								[
									-102.895068359375,
									68.82363281249997
								],
								[
									-103.16225585937498,
									68.82871093750012
								],
								[
									-103.46821289062497,
									68.8085449218751
								],
								[
									-103.82036132812503,
									68.84799804687495
								],
								[
									-104.06733398437498,
									68.86557617187498
								],
								[
									-104.35268554687495,
									68.92817382812504
								],
								[
									-104.46015625,
									68.91240234375002
								],
								[
									-104.57143554687501,
									68.87211914062507
								],
								[
									-105.105859375,
									68.92041015625006
								],
								[
									-105.16928710937495,
									68.95537109375007
								],
								[
									-105.14833984374995,
									68.97812500000009
								],
								[
									-105.02163085937498,
									69.05249023437506
								],
								[
									-105.01357421875002,
									69.06806640624993
								],
								[
									-105.019580078125,
									69.08124999999995
								],
								[
									-105.262353515625,
									69.09399414062497
								],
								[
									-105.53300781249997,
									69.13354492187494
								],
								[
									-105.80498046874996,
									69.15317382812495
								],
								[
									-106.00839843750002,
									69.14760742187497
								],
								[
									-106.140869140625,
									69.16201171875005
								],
								[
									-106.27016601562497,
									69.19458007812494
								],
								[
									-106.34116210937495,
									69.22436523437497
								],
								[
									-106.35395507812498,
									69.25122070312494
								],
								[
									-106.35571289062499,
									69.28061523437498
								],
								[
									-106.34423828124996,
									69.33964843750002
								],
								[
									-106.36137695312499,
									69.38105468749993
								],
								[
									-106.41997070312502,
									69.41376953124993
								],
								[
									-106.53979492187501,
									69.44306640625004
								],
								[
									-106.65908203124998,
									69.43959960937505
								],
								[
									-106.75996093750001,
									69.40712890625
								],
								[
									-106.85581054687499,
									69.34731445312508
								],
								[
									-107.03344726562494,
									69.18076171874998
								],
								[
									-107.12250976562497,
									69.15229492187495
								],
								[
									-107.35336914062502,
									69.03168945312498
								],
								[
									-107.43989257812497,
									69.00214843750001
								],
								[
									-107.86337890625,
									68.95434570312494
								],
								[
									-108.36499023437497,
									68.93476562499995
								],
								[
									-108.55253906249999,
									68.89741210937498
								],
								[
									-108.73041992187498,
									68.8274414062501
								],
								[
									-108.9458984375,
									68.75981445312502
								],
								[
									-109.47211914062501,
									68.67670898437495
								],
								[
									-109.95854492187499,
									68.63027343750008
								],
								[
									-110.46762695312496,
									68.61000976562497
								],
								[
									-110.84809570312503,
									68.5784179687501
								],
								[
									-110.95722656249997,
									68.59418945312501
								],
								[
									-111.12758789062495,
									68.58833007812498
								],
								[
									-111.3109375,
									68.54204101562505
								],
								[
									-111.51806640625,
									68.533056640625
								],
								[
									-112.304931640625,
									68.51621093749995
								],
								[
									-112.66621093749997,
									68.48525390625002
								],
								[
									-112.86425781249999,
									68.47709960937507
								],
								[
									-113.01953125,
									68.48134765625005
								],
								[
									-113.12773437500002,
									68.49414062500006
								],
								[
									-113.231396484375,
									68.53540039062494
								],
								[
									-113.33808593749998,
									68.59877929687508
								],
								[
									-113.554833984375,
									68.767578125
								],
								[
									-113.61684570312501,
									68.83847656250006
								],
								[
									-113.59252929687503,
									68.95986328125008
								],
								[
									-113.60854492187501,
									69.03017578124994
								],
								[
									-113.68066406249996,
									69.18198242187503
								],
								[
									-113.69414062499995,
									69.19501953124995
								],
								[
									-114.07343749999995,
									69.25131835937506
								],
								[
									-114.32294921874998,
									69.26914062499995
								],
								[
									-114.69907226562496,
									69.27275390625007
								],
								[
									-115.15903320312496,
									69.26474609374995
								],
								[
									-115.61811523437497,
									69.28295898437511
								],
								[
									-115.86074218750001,
									69.30356445312495
								],
								[
									-116.10156249999996,
									69.33715820312503
								],
								[
									-116.51347656249995,
									69.4246093750001
								],
								[
									-116.53681640624998,
									69.43354492187495
								],
								[
									-116.56879882812503,
									69.46269531250005
								],
								[
									-116.60947265624996,
									69.51201171874996
								],
								[
									-116.71201171874998,
									69.57622070312499
								],
								[
									-116.99277343749998,
									69.71938476562502
								],
								[
									-117.10400390624999,
									69.80424804687499
								],
								[
									-117.12197265625001,
									69.82587890624995
								],
								[
									-117.14863281250003,
									69.88813476562501
								],
								[
									-117.18403320312495,
									69.99106445312495
								],
								[
									-117.19541015624996,
									70.05405273437506
								],
								[
									-117.16274414062497,
									70.0924804687501
								],
								[
									-117.13544921875,
									70.10014648437496
								],
								[
									-116.55380859374999,
									70.17504882812494
								],
								[
									-115.52910156250003,
									70.25712890625005
								],
								[
									-114.59233398437497,
									70.31245117187495
								],
								[
									-114.1669921875,
									70.307470703125
								],
								[
									-113.91660156249998,
									70.28154296875005
								],
								[
									-113.66552734374999,
									70.26967773437505
								],
								[
									-113.21074218749997,
									70.263818359375
								],
								[
									-112.63789062499997,
									70.22524414062505
								],
								[
									-112.52275390624996,
									70.22856445312502
								],
								[
									-112.26596679687496,
									70.2546875000001
								],
								[
									-112.18964843749995,
									70.2755859375001
								],
								[
									-111.78369140625003,
									70.27290039062498
								],
								[
									-111.70488281249996,
									70.28574218750003
								],
								[
									-111.63256835937497,
									70.30883789062503
								],
								[
									-111.72583007812497,
									70.35205078124994
								],
								[
									-112.11416015624994,
									70.44687500000009
								],
								[
									-113.1455078125,
									70.61635742187497
								],
								[
									-113.39702148437499,
									70.6523925781251
								],
								[
									-113.75727539062503,
									70.69072265625002
								],
								[
									-113.96606445312501,
									70.69619140625008
								],
								[
									-114.23217773437496,
									70.67426757812495
								],
								[
									-114.33139648437502,
									70.67524414062507
								],
								[
									-114.59262695312495,
									70.642236328125
								],
								[
									-114.84072265624995,
									70.62138671875002
								],
								[
									-115.31123046874997,
									70.60117187499998
								],
								[
									-115.99091796874997,
									70.58627929687506
								],
								[
									-116.086083984375,
									70.59067382812498
								],
								[
									-116.22587890624997,
									70.61640624999998
								],
								[
									-116.32729492187502,
									70.62373046874995
								],
								[
									-116.99252929687502,
									70.60366210937505
								],
								[
									-117.587060546875,
									70.629541015625
								],
								[
									-118.26406249999998,
									70.88833007812505
								],
								[
									-118.37651367187497,
									70.96772460937504
								],
								[
									-118.35253906249997,
									71.00004882812507
								],
								[
									-118.26909179687493,
									71.03471679687502
								],
								[
									-117.93383789062503,
									71.13466796875005
								],
								[
									-117.81406249999996,
									71.158447265625
								],
								[
									-117.31396484374996,
									71.21210937499993
								],
								[
									-116.81528320312496,
									71.27695312500009
								],
								[
									-116.42153320312495,
									71.33798828125009
								],
								[
									-116.22822265625,
									71.35917968749996
								],
								[
									-116.04208984375,
									71.36166992187512
								],
								[
									-115.891650390625,
									71.38178710937504
								],
								[
									-115.92226562500002,
									71.40107421875004
								],
								[
									-116.04531249999995,
									71.42309570312509
								],
								[
									-116.04394531250003,
									71.45429687500007
								],
								[
									-115.98027343750003,
									71.4692871093751
								],
								[
									-115.73374023437498,
									71.48510742187494
								],
								[
									-115.47187500000001,
									71.46582031250009
								],
								[
									-115.341015625,
									71.47241210937503
								],
								[
									-115.30341796874998,
									71.4937011718751
								],
								[
									-115.33813476562503,
									71.51088867187505
								],
								[
									-115.58666992187496,
									71.54638671875009
								],
								[
									-116.78027343750003,
									71.44418945312495
								],
								[
									-117.33710937499995,
									71.43461914062496
								],
								[
									-117.72333984374995,
									71.39067382812507
								],
								[
									-117.93564453125003,
									71.39208984375
								],
								[
									-118.18818359374997,
									71.43593749999997
								],
								[
									-118.221875,
									71.44907226562498
								],
								[
									-118.22646484374995,
									71.4670898437501
								],
								[
									-118.14833984375002,
									71.52573242187503
								],
								[
									-117.87841796875001,
									71.5608398437501
								],
								[
									-117.74233398437501,
									71.659326171875
								],
								[
									-117.88759765625002,
									71.66103515625
								],
								[
									-118.37153320312503,
									71.63994140624996
								],
								[
									-118.58300781250003,
									71.64902343750003
								],
								[
									-118.868408203125,
									71.68676757812509
								],
								[
									-118.952099609375,
									71.7317382812501
								],
								[
									-118.98769531249997,
									71.76425781250006
								],
								[
									-118.99374999999995,
									71.80302734374996
								],
								[
									-118.98417968749996,
									71.9130859375
								],
								[
									-118.95981445312496,
									71.97221679687505
								],
								[
									-118.94462890624999,
									71.98554687499993
								],
								[
									-118.58984375,
									72.16748046875006
								],
								[
									-118.36865234374997,
									72.20546874999997
								],
								[
									-118.21347656249998,
									72.26289062500004
								],
								[
									-118.207470703125,
									72.28691406249996
								],
								[
									-118.2458984375,
									72.31103515625009
								],
								[
									-118.39047851562498,
									72.36953125
								],
								[
									-118.44863281250001,
									72.3992187500001
								],
								[
									-118.481298828125,
									72.42768554687504
								],
								[
									-118.45659179687495,
									72.47250976562512
								],
								[
									-118.37451171875001,
									72.5338867187501
								],
								[
									-118.13310546874995,
									72.63281250000009
								],
								[
									-117.55170898437498,
									72.83110351562507
								],
								[
									-117.25644531249996,
									72.91440429687498
								],
								[
									-116.97167968750003,
									72.95932617187506
								],
								[
									-116.57324218749994,
									73.05493164062511
								],
								[
									-115.55219726562494,
									73.21347656249998
								],
								[
									-114.638232421875,
									73.37265625000009
								],
								[
									-114.30190429687495,
									73.33071289062505
								],
								[
									-114.20639648437495,
									73.29780273437493
								],
								[
									-114.16396484375001,
									73.2698242187501
								],
								[
									-114.12705078124995,
									73.23071289062494
								],
								[
									-114.095458984375,
									73.18027343750006
								],
								[
									-114.05170898437497,
									73.0709960937501
								],
								[
									-114.04614257812499,
									73.01459960937507
								],
								[
									-114.05375976562503,
									72.95805664062499
								],
								[
									-114.07475585937496,
									72.90683593749995
								],
								[
									-114.10917968749995,
									72.86098632812494
								],
								[
									-114.17768554687497,
									72.80507812500008
								],
								[
									-114.280322265625,
									72.73906249999996
								],
								[
									-114.4978515625,
									72.62587890625
								],
								[
									-114.52153320312503,
									72.59291992187502
								]
							]
						],
						[
							[
								[
									-105.28891601562499,
									72.91992187500003
								],
								[
									-105.33935546874996,
									72.91489257812509
								],
								[
									-105.43408203124999,
									72.93798828125009
								],
								[
									-105.57299804687496,
									72.98930664062496
								],
								[
									-105.80014648437496,
									73.09331054687502
								],
								[
									-106.07104492187499,
									73.19638671875006
								],
								[
									-106.11264648437493,
									73.25810546875002
								],
								[
									-106.18002929687499,
									73.30410156249997
								],
								[
									-106.52573242187499,
									73.41337890625013
								],
								[
									-106.75039062500001,
									73.45771484375001
								],
								[
									-106.92153320312498,
									73.47983398437498
								],
								[
									-106.94965820312503,
									73.51035156249998
								],
								[
									-106.83100585937501,
									73.59907226562501
								],
								[
									-106.69482421874997,
									73.66992187500006
								],
								[
									-106.61396484375003,
									73.69560546875007
								],
								[
									-106.36210937499996,
									73.71860351562495
								],
								[
									-105.51230468750002,
									73.76577148437497
								],
								[
									-105.31796874999996,
									73.76713867187507
								],
								[
									-105.11445312499997,
									73.74443359375007
								],
								[
									-104.83466796875,
									73.64726562499999
								],
								[
									-104.71826171875,
									73.63627929687496
								],
								[
									-104.64877929687496,
									73.61440429687505
								],
								[
									-104.5875,
									73.57807617187493
								],
								[
									-104.55507812499997,
									73.54111328125003
								],
								[
									-104.55234374999995,
									73.465576171875
								],
								[
									-104.58286132812495,
									73.35390625
								],
								[
									-104.62172851562495,
									73.31113281249998
								],
								[
									-104.79101562499999,
									73.16762695312497
								],
								[
									-104.96865234375002,
									73.08867187499996
								],
								[
									-105.00258789062501,
									73.03754882812501
								],
								[
									-105.07460937500002,
									72.99702148437504
								],
								[
									-105.20063476562494,
									72.9473144531251
								],
								[
									-105.28891601562499,
									72.91992187500003
								]
							]
						],
						[
							[
								[
									-79.53730468749998,
									73.65449218750004
								],
								[
									-79.36679687499998,
									73.64135742187503
								],
								[
									-78.2865234375,
									73.66582031250013
								],
								[
									-78.06293945312501,
									73.64765625000007
								],
								[
									-77.38212890624996,
									73.53666992187502
								],
								[
									-77.20654296874997,
									73.4995605468751
								],
								[
									-77.11977539062497,
									73.45048828125005
								],
								[
									-77.04150390625,
									73.37304687500009
								],
								[
									-77.00532226562501,
									73.35605468750006
								],
								[
									-76.75869140624994,
									73.31000976562493
								],
								[
									-76.65727539062499,
									73.25419921875002
								],
								[
									-76.62158203125,
									73.225341796875
								],
								[
									-76.56977539062501,
									73.15927734374995
								],
								[
									-76.45844726562498,
									73.12182617187506
								],
								[
									-76.33115234374998,
									73.10048828124997
								],
								[
									-76.28955078125003,
									73.0810058593751
								],
								[
									-76.30957031250003,
									72.99790039062503
								],
								[
									-76.25527343749997,
									72.95922851562497
								],
								[
									-76.13505859374999,
									72.91240234375002
								],
								[
									-76.08999023437497,
									72.88120117187506
								],
								[
									-76.18339843749999,
									72.84306640625002
								],
								[
									-76.400537109375,
									72.82065429687498
								],
								[
									-77.01357421875,
									72.84399414062494
								],
								[
									-77.83593750000003,
									72.89682617187495
								],
								[
									-78.31420898437503,
									72.88183593750009
								],
								[
									-78.55405273437495,
									72.85771484375007
								],
								[
									-79.13417968750002,
									72.77163085937494
								],
								[
									-79.3193359375,
									72.75771484375002
								],
								[
									-79.50053710937496,
									72.75595703124995
								],
								[
									-79.820703125,
									72.82631835937508
								],
								[
									-79.93686523437503,
									72.86362304687503
								],
								[
									-79.97529296874995,
									72.89248046875005
								],
								[
									-80.05161132812495,
									72.97700195312504
								],
								[
									-80.11445312499998,
									73.07822265625006
								],
								[
									-80.14643554687501,
									73.16132812499993
								],
								[
									-80.18330078124995,
									73.22465820312505
								],
								[
									-80.29272460937497,
									73.24560546875006
								],
								[
									-80.61791992187497,
									73.2708007812501
								],
								[
									-80.72685546874996,
									73.30546874999999
								],
								[
									-80.77641601562502,
									73.33417968750007
								],
								[
									-80.82416992187495,
									73.3806640625001
								],
								[
									-80.82294921874998,
									73.428955078125
								],
								[
									-80.79799804687497,
									73.47153320312498
								],
								[
									-80.77695312500003,
									73.48198242187507
								],
								[
									-80.73583984375,
									73.48310546875001
								],
								[
									-80.827001953125,
									73.53466796875006
								],
								[
									-80.85849609375003,
									73.59140624999998
								],
								[
									-80.86074218749997,
									73.67055664062494
								],
								[
									-80.84887695312503,
									73.72124023437496
								],
								[
									-80.82285156249998,
									73.74345703125005
								],
								[
									-80.76274414062499,
									73.75776367187501
								],
								[
									-80.62138671874996,
									73.76733398437503
								],
								[
									-80.41230468749998,
									73.76542968749999
								],
								[
									-80.120263671875,
									73.7070800781251
								],
								[
									-79.88935546874995,
									73.70151367187512
								],
								[
									-79.53730468749998,
									73.65449218750004
								]
							]
						],
						[
							[
								[
									-86.58935546874997,
									71.01079101562513
								],
								[
									-86.54965820312495,
									70.98876953125009
								],
								[
									-86.32128906249997,
									71.01679687499993
								],
								[
									-86.12714843749995,
									71.048974609375
								],
								[
									-85.82456054687503,
									71.125732421875
								],
								[
									-85.64384765624999,
									71.15244140625003
								],
								[
									-85.09487304687497,
									71.15195312500009
								],
								[
									-85.00156249999995,
									71.13745117187509
								],
								[
									-85.04277343750002,
									71.09160156250007
								],
								[
									-85.06577148437498,
									71.07861328125
								],
								[
									-85.04765624999993,
									71.05869140625012
								],
								[
									-84.98847656249995,
									71.03173828124994
								],
								[
									-84.87031249999995,
									71.00180664062498
								],
								[
									-84.82373046874997,
									71.02861328125002
								],
								[
									-84.78959960937493,
									71.09326171875006
								],
								[
									-84.70859374999995,
									71.35869140625013
								],
								[
									-84.67431640625,
									71.4387695312501
								],
								[
									-84.65810546874997,
									71.5145996093751
								],
								[
									-84.65996093749999,
									71.58613281250001
								],
								[
									-84.69941406249995,
									71.6314453125
								],
								[
									-84.84013671874993,
									71.65864257812504
								],
								[
									-85.0322265625,
									71.65405273437509
								],
								[
									-85.13090820312502,
									71.66123046875003
								],
								[
									-85.25048828124997,
									71.67529296875006
								],
								[
									-85.33906249999998,
									71.697265625
								],
								[
									-85.39667968749998,
									71.72705078124994
								],
								[
									-85.51152343749993,
									71.81655273437497
								],
								[
									-85.59619140624994,
									71.8664062500001
								],
								[
									-85.81333007812495,
									71.95644531250005
								],
								[
									-85.91162109375,
									71.98652343749995
								],
								[
									-85.86210937499996,
									72.02197265625006
								],
								[
									-85.664794921875,
									72.06279296875005
								],
								[
									-85.54580078125,
									72.10156249999994
								],
								[
									-85.405908203125,
									72.21484375000011
								],
								[
									-85.32187500000003,
									72.23315429687511
								],
								[
									-85.01875000000001,
									72.21816406250008
								],
								[
									-84.60849609375,
									72.12949218749995
								],
								[
									-84.35166015624998,
									72.05263671875011
								],
								[
									-84.28374023437502,
									72.04448242187505
								],
								[
									-84.28232421874998,
									72.05844726562495
								],
								[
									-84.34746093750002,
									72.0944335937501
								],
								[
									-84.64296875,
									72.18955078125009
								],
								[
									-84.77753906249998,
									72.2587890625
								],
								[
									-84.84199218749995,
									72.30815429687502
								],
								[
									-84.81103515624997,
									72.32954101562501
								],
								[
									-84.644677734375,
									72.35141601562495
								],
								[
									-84.62304687500003,
									72.3765625
								],
								[
									-84.84941406249996,
									72.40625000000003
								],
								[
									-84.96416015624999,
									72.40561523437498
								],
								[
									-85.05683593749995,
									72.384375
								],
								[
									-85.15639648437497,
									72.38291015624998
								],
								[
									-85.34111328124996,
									72.42153320312494
								],
								[
									-85.39130859374995,
									72.44399414062508
								],
								[
									-85.49775390624998,
									72.51059570312506
								],
								[
									-85.5537109375,
									72.56860351562497
								],
								[
									-85.615576171875,
									72.60463867187494
								],
								[
									-85.63789062500001,
									72.63320312500008
								],
								[
									-85.64990234374997,
									72.72216796875009
								],
								[
									-85.64453125000003,
									72.77446289062499
								],
								[
									-85.61943359374999,
									72.81918945312495
								],
								[
									-85.574609375,
									72.85639648437498
								],
								[
									-85.45478515625001,
									72.92514648437495
								],
								[
									-85.38759765625,
									72.94501953125001
								],
								[
									-85.26210937500002,
									72.95400390624997
								],
								[
									-84.98955078124999,
									72.91987304687504
								],
								[
									-84.25664062499999,
									72.79672851562509
								],
								[
									-84.27426757812503,
									72.83642578125
								],
								[
									-85.09404296874996,
									73.00263671874993
								],
								[
									-85.38388671874995,
									73.04541015624994
								],
								[
									-85.454736328125,
									73.10546875
								],
								[
									-85.018408203125,
									73.33549804687507
								],
								[
									-84.61606445312503,
									73.38955078124997
								],
								[
									-84.41606445312496,
									73.45649414062493
								],
								[
									-84.08896484375003,
									73.45937500000008
								],
								[
									-83.781884765625,
									73.41689453125002
								],
								[
									-83.77651367187497,
									73.428466796875
								],
								[
									-83.91499023437493,
									73.50839843750003
								],
								[
									-83.904052734375,
									73.5283203125
								],
								[
									-83.72983398437495,
									73.57587890625001
								],
								[
									-83.41035156249998,
									73.631689453125
								],
								[
									-83.02045898437495,
									73.67602539062506
								],
								[
									-82.943212890625,
									73.69912109375008
								],
								[
									-82.84331054687502,
									73.71542968750009
								],
								[
									-82.65961914062498,
									73.72958984375006
								],
								[
									-82.202783203125,
									73.73647460937505
								],
								[
									-81.946142578125,
									73.72983398437512
								],
								[
									-81.60537109374997,
									73.69599609375004
								],
								[
									-81.40615234374997,
									73.63452148437506
								],
								[
									-81.344091796875,
									73.59775390625012
								],
								[
									-81.23833007812496,
									73.4795410156251
								],
								[
									-81.1517578125,
									73.31401367187505
								],
								[
									-81.02514648437497,
									73.24521484375006
								],
								[
									-80.82172851562501,
									73.20717773437494
								],
								[
									-80.68115234374997,
									73.16582031249996
								],
								[
									-80.60346679687495,
									73.12119140625
								],
								[
									-80.582763671875,
									73.06494140625009
								],
								[
									-80.61914062500003,
									72.99716796875006
								],
								[
									-80.59189453124998,
									72.92768554687501
								],
								[
									-80.50092773437501,
									72.85659179687502
								],
								[
									-80.43081054687494,
									72.81625976562498
								],
								[
									-80.27724609375002,
									72.770166015625
								],
								[
									-80.27470703124993,
									72.74555664062495
								],
								[
									-80.32265625000002,
									72.71748046874993
								],
								[
									-80.42431640624994,
									72.67890625000007
								],
								[
									-80.67509765624996,
									72.55864257812507
								],
								[
									-80.99873046875001,
									72.42622070312501
								],
								[
									-81.229345703125,
									72.31171875000004
								],
								[
									-81.24057617187498,
									72.27792968750009
								],
								[
									-80.76079101562502,
									72.45717773437508
								],
								[
									-80.61147460937497,
									72.45083007812505
								],
								[
									-80.60468750000001,
									72.42578125
								],
								[
									-80.70244140624996,
									72.33828124999994
								],
								[
									-80.82148437499995,
									72.26025390624994
								],
								[
									-80.94121093750002,
									72.21015624999995
								],
								[
									-80.9193359375,
									72.191259765625
								],
								[
									-80.69140625,
									72.10346679687507
								],
								[
									-80.733251953125,
									72.08901367187497
								],
								[
									-80.84326171874994,
									72.09619140625
								],
								[
									-80.88837890624998,
									72.08828125
								],
								[
									-80.92109374999998,
									72.07231445312502
								],
								[
									-80.94140624999997,
									72.04824218750008
								],
								[
									-80.94267578124996,
									72.01435546875004
								],
								[
									-80.925048828125,
									71.97070312500011
								],
								[
									-80.92680664062502,
									71.93808593749995
								],
								[
									-80.94790039062494,
									71.91655273437507
								],
								[
									-80.92514648437503,
									71.90766601562504
								],
								[
									-80.85844726562502,
									71.91142578125002
								],
								[
									-80.80224609375003,
									71.92919921875
								],
								[
									-80.70541992187503,
									71.98813476562509
								],
								[
									-80.3861328125,
									72.14877929687506
								],
								[
									-80.18193359374996,
									72.2087890625001
								],
								[
									-80.11611328124997,
									72.21406250000004
								],
								[
									-79.92832031249998,
									72.17495117187497
								],
								[
									-79.884375,
									72.17719726562498
								],
								[
									-80.09091796874998,
									72.30087890625003
								],
								[
									-80.10893554687502,
									72.33217773437494
								],
								[
									-80.06699218749998,
									72.37832031250002
								],
								[
									-80.04179687500002,
									72.39423828125007
								],
								[
									-79.92670898437501,
									72.42817382812495
								],
								[
									-79.83129882812503,
									72.4462890625
								],
								[
									-79.77788085937496,
									72.43872070312497
								],
								[
									-79.69331054687498,
									72.37592773437507
								],
								[
									-79.65385742187502,
									72.33217773437494
								],
								[
									-79.58369140624993,
									72.31464843749993
								],
								[
									-79.42744140624998,
									72.33730468750011
								],
								[
									-79.32333984375,
									72.39082031249998
								],
								[
									-79.19438476562493,
									72.35571289062494
								],
								[
									-79.000244140625,
									72.27202148437513
								],
								[
									-79.01796874999997,
									72.18823242187511
								],
								[
									-79.01777343750001,
									72.10434570312498
								],
								[
									-79.00781250000003,
									72.04291992187498
								],
								[
									-78.77592773437496,
									71.93037109375007
								],
								[
									-78.61445312500001,
									71.88100585937505
								],
								[
									-78.58510742187497,
									71.88061523437506
								],
								[
									-78.58886718750003,
									71.8975097656251
								],
								[
									-78.62255859374997,
									71.93496093750002
								],
								[
									-78.71113281249998,
									71.97241210937509
								],
								[
									-78.79082031249996,
									72.03027343750009
								],
								[
									-78.86274414062495,
									72.10083007812497
								],
								[
									-78.82011718749999,
									72.26542968750002
								],
								[
									-78.69926757812496,
									72.35141601562495
								],
								[
									-78.58247070312498,
									72.32934570312509
								],
								[
									-78.42880859375003,
									72.27978515625011
								],
								[
									-78.307470703125,
									72.27514648437506
								],
								[
									-78.11635742187497,
									72.28032226562513
								],
								[
									-77.72602539062493,
									72.17998046875002
								],
								[
									-77.51650390624997,
									72.17778320312502
								],
								[
									-77.53574218749998,
									72.21875000000011
								],
								[
									-77.694482421875,
									72.23842773437494
								],
								[
									-77.92617187500002,
									72.29384765625002
								],
								[
									-78.28720703125003,
									72.35981445312507
								],
								[
									-78.45307617187498,
									72.43520507812497
								],
								[
									-78.48427734374997,
									72.47060546875008
								],
								[
									-78.47949218749994,
									72.50874023437504
								],
								[
									-78.458837890625,
									72.54233398437495
								],
								[
									-78.42241210937496,
									72.57153320312494
								],
								[
									-78.350244140625,
									72.6001953125
								],
								[
									-78.00102539062499,
									72.68759765625006
								],
								[
									-77.75322265624996,
									72.72475585937508
								],
								[
									-77.566796875,
									72.73686523437496
								],
								[
									-77.25537109374997,
									72.73588867187513
								],
								[
									-76.89350585937495,
									72.72065429687504
								],
								[
									-76.69794921875001,
									72.69506835937497
								],
								[
									-76.47324218749998,
									72.63334960937502
								],
								[
									-76.18876953125002,
									72.57221679687507
								],
								[
									-76.08730468749994,
									72.56132812499999
								],
								[
									-75.96874999999994,
									72.56274414062511
								],
								[
									-75.83320312499995,
									72.57651367187498
								],
								[
									-75.70429687499998,
									72.57153320312494
								],
								[
									-75.29423828124993,
									72.48085937499994
								],
								[
									-75.18579101562497,
									72.43422851562502
								],
								[
									-75.12006835937498,
									72.37773437499999
								],
								[
									-75.07148437499995,
									72.32285156250009
								],
								[
									-75.03984374999999,
									72.26958007812507
								],
								[
									-75.05268554687493,
									72.22636718749996
								],
								[
									-75.39414062500003,
									72.03979492187497
								],
								[
									-75.54277343749993,
									72.00795898437497
								],
								[
									-75.64096679687498,
									71.93715820312494
								],
								[
									-75.78740234374996,
									71.80307617187498
								],
								[
									-75.91127929687497,
									71.731298828125
								],
								[
									-75.92280273437501,
									71.71723632812498
								],
								[
									-75.89682617187495,
									71.71372070312498
								],
								[
									-75.82207031249999,
									71.74589843749996
								],
								[
									-75.69335937499997,
									71.83857421874993
								],
								[
									-75.59990234374996,
									71.91845703124994
								],
								[
									-75.428369140625,
									71.98437500000006
								],
								[
									-75.14765625000001,
									72.06298828125009
								],
								[
									-74.90317382812503,
									72.10048828125
								],
								[
									-74.69492187499998,
									72.09692382812497
								],
								[
									-74.51967773437497,
									72.08564453124998
								],
								[
									-74.37744140625003,
									72.06655273437508
								],
								[
									-74.29296874999997,
									72.05058593750005
								],
								[
									-74.26635742187497,
									72.03769531250006
								],
								[
									-74.20932617187498,
									71.97866210937505
								],
								[
									-74.21259765624993,
									71.93867187500007
								],
								[
									-74.24824218750001,
									71.89365234374995
								],
								[
									-74.31572265624999,
									71.84267578125005
								],
								[
									-74.62148437500002,
									71.78627929687502
								],
								[
									-74.78906249999997,
									71.74199218749996
								],
								[
									-74.89296875,
									71.72553710937498
								],
								[
									-75.20478515625001,
									71.70913085937502
								],
								[
									-75.19106445312497,
									71.6916015625001
								],
								[
									-74.95947265624994,
									71.66748046874997
								],
								[
									-74.70078125,
									71.67558593750002
								],
								[
									-74.707373046875,
									71.64692382812495
								],
								[
									-74.828955078125,
									71.5708984375
								],
								[
									-74.86831054687502,
									71.50473632812495
								],
								[
									-74.83447265624997,
									71.45058593750002
								],
								[
									-74.84072265625,
									71.40659179687512
								],
								[
									-74.931298828125,
									71.3140625
								],
								[
									-75.03535156249995,
									71.23051757812513
								],
								[
									-74.99619140624998,
									71.21811523437509
								],
								[
									-74.75893554687494,
									71.33813476562503
								],
								[
									-74.69531249999994,
									71.46943359375004
								],
								[
									-74.59956054687498,
									71.58486328125002
								],
								[
									-74.48808593750002,
									71.64838867187498
								],
								[
									-74.40410156249996,
									71.67250976562502
								],
								[
									-74.13906249999997,
									71.68222656249995
								],
								[
									-73.99208984374997,
									71.749609375
								],
								[
									-73.86660156249997,
									71.77104492187502
								],
								[
									-73.8140625,
									71.77143554687493
								],
								[
									-73.70722656250001,
									71.74633789062506
								],
								[
									-73.71357421874995,
									71.71987304687508
								],
								[
									-73.86860351562493,
									71.59936523437494
								],
								[
									-74.197265625,
									71.40415039062506
								],
								[
									-74.06333007812498,
									71.42646484374998
								],
								[
									-73.97250976562495,
									71.47285156249993
								],
								[
									-73.85087890624996,
									71.51914062499995
								],
								[
									-73.71284179687498,
									71.58759765624995
								],
								[
									-73.62167968749998,
									71.52553710937511
								],
								[
									-73.48159179687497,
									71.47924804687509
								],
								[
									-73.39780273437503,
									71.37343750000002
								],
								[
									-73.26240234374998,
									71.32246093750001
								],
								[
									-73.18061523437501,
									71.28286132812505
								],
								[
									-73.19218749999996,
									71.34985351562509
								],
								[
									-73.31044921875,
									71.48427734375005
								],
								[
									-73.27822265625,
									71.53798828124997
								],
								[
									-73.18681640624993,
									71.56489257812504
								],
								[
									-72.901953125,
									71.6777832031251
								],
								[
									-72.70302734374997,
									71.64013671875
								],
								[
									-72.58061523437499,
									71.60678710937495
								],
								[
									-72.51928710937503,
									71.61562500000005
								],
								[
									-72.36459960937503,
									71.61098632812511
								],
								[
									-72.11650390624993,
									71.59277343749994
								],
								[
									-71.87519531249998,
									71.5612304687501
								],
								[
									-71.64067382812499,
									71.51625976562508
								],
								[
									-71.45991210937493,
									71.46372070312503
								],
								[
									-71.33295898437501,
									71.40346679687511
								],
								[
									-71.25605468749998,
									71.36181640625006
								],
								[
									-71.22939453124997,
									71.33876953124997
								],
								[
									-71.18652343750003,
									71.2787109375
								],
								[
									-71.21938476562497,
									71.23881835937505
								],
								[
									-71.39658203125,
									71.14687500000005
								],
								[
									-71.49501953125,
									71.10512695312508
								],
								[
									-71.59306640624996,
									71.08637695312498
								],
								[
									-71.85615234375001,
									71.10478515625007
								],
								[
									-71.93793945312498,
									71.09428710937499
								],
								[
									-72.02387695312498,
									71.06533203125005
								],
								[
									-72.297705078125,
									70.93881835937503
								],
								[
									-72.44912109375002,
									70.88408203125007
								],
								[
									-72.598046875,
									70.84921874999998
								],
								[
									-72.63271484374994,
									70.83076171874995
								],
								[
									-72.31254882812499,
									70.83251953125003
								],
								[
									-72.22392578124999,
									70.87016601562499
								],
								[
									-72.15,
									70.94067382812506
								],
								[
									-72.00917968750002,
									71.01342773437494
								],
								[
									-71.74252929687495,
									71.04687500000011
								],
								[
									-71.370849609375,
									70.97514648437496
								],
								[
									-71.18623046874995,
									70.97802734375003
								],
								[
									-71.04536132812495,
									71.05000000000004
								],
								[
									-70.88803710937495,
									71.09902343750008
								],
								[
									-70.82607421874994,
									71.108740234375
								],
								[
									-70.79248046875003,
									71.10332031249996
								],
								[
									-70.67265624999996,
									71.05219726562504
								],
								[
									-70.63647460937494,
									71.00659179687497
								],
								[
									-70.63911132812495,
									70.90244140625006
								],
								[
									-70.65522460937495,
									70.87089843749996
								],
								[
									-70.76171874999997,
									70.792236328125
								],
								[
									-71.02177734374993,
									70.67412109375002
								],
								[
									-71.19179687500002,
									70.62978515625005
								],
								[
									-71.38046875,
									70.60595703125006
								],
								[
									-71.58593750000003,
									70.56586914062498
								],
								[
									-71.65844726562497,
									70.53354492187498
								],
								[
									-71.72939453124994,
									70.48769531250005
								],
								[
									-71.80014648437498,
									70.45703125000011
								],
								[
									-71.89018554687502,
									70.43154296875005
								],
								[
									-71.77236328125,
									70.39418945312508
								],
								[
									-71.72724609374995,
									70.39521484375004
								],
								[
									-71.68369140624995,
									70.41757812499998
								],
								[
									-71.56499023437493,
									70.50566406250007
								],
								[
									-71.47666015624998,
									70.54404296874998
								],
								[
									-71.42666015625,
									70.55209960937512
								],
								[
									-71.37509765624998,
									70.54843750000006
								],
								[
									-71.32485351562497,
									70.53115234375002
								],
								[
									-71.27587890625,
									70.50029296875005
								],
								[
									-71.27958984374996,
									70.42519531250002
								],
								[
									-71.42944335937503,
									70.12778320312509
								],
								[
									-71.40512695312498,
									70.128662109375
								],
								[
									-71.31308593749995,
									70.209326171875
								],
								[
									-71.045263671875,
									70.51904296874994
								],
								[
									-70.97978515624999,
									70.58105468749997
								],
								[
									-70.85053710937495,
									70.64360351562502
								],
								[
									-70.56093750000002,
									70.73828124999994
								],
								[
									-70.337255859375,
									70.787841796875
								],
								[
									-70.084716796875,
									70.82954101562507
								],
								[
									-69.94980468750003,
									70.84501953125002
								],
								[
									-69.79570312499999,
									70.83457031250009
								],
								[
									-69.69550781250001,
									70.78588867187506
								],
								[
									-69.56010742187496,
									70.77714843750005
								],
								[
									-69.39536132812498,
									70.78925781249993
								],
								[
									-69.2890625,
									70.78344726562509
								],
								[
									-69.16870117187497,
									70.76416015624997
								],
								[
									-69.06572265624996,
									70.72807617187499
								],
								[
									-68.89072265625,
									70.68710937500009
								],
								[
									-68.49575195312502,
									70.61025390624997
								],
								[
									-68.44667968749997,
									70.59409179687506
								],
								[
									-68.40083007812495,
									70.56499023437499
								],
								[
									-68.35825195312498,
									70.52290039062501
								],
								[
									-68.363525390625,
									70.48125000000007
								],
								[
									-68.41665039062497,
									70.4399902343751
								],
								[
									-68.482568359375,
									70.41484375000005
								],
								[
									-68.56132812499996,
									70.40566406249994
								],
								[
									-68.64282226562497,
									70.38320312500008
								],
								[
									-68.79365234374995,
									70.3244140625001
								],
								[
									-68.84291992187497,
									70.31445312500011
								],
								[
									-69.079443359375,
									70.28916015625
								],
								[
									-69.29873046875,
									70.27680664062498
								],
								[
									-69.43569335937502,
									70.25312499999995
								],
								[
									-69.698974609375,
									70.189306640625
								],
								[
									-70.06142578124997,
									70.07084960937513
								],
								[
									-70.05771484375,
									70.04262695312497
								],
								[
									-69.91308593750003,
									70.02905273437506
								],
								[
									-69.79584960937493,
									70.04692382812496
								],
								[
									-69.63457031249993,
									70.12875976562512
								],
								[
									-69.48300781249998,
									70.16005859375
								],
								[
									-69.24619140624995,
									70.18510742187505
								],
								[
									-68.9185546875,
									70.20698242187507
								],
								[
									-68.77822265625002,
									70.20356445312498
								],
								[
									-68.7529296875,
									70.19916992187507
								],
								[
									-68.734619140625,
									70.17983398437494
								],
								[
									-68.72329101562502,
									70.145654296875
								],
								[
									-68.776953125,
									70.10102539062504
								],
								[
									-68.83911132812497,
									70.07993164062512
								],
								[
									-69.00830078125,
									69.97895507812504
								],
								[
									-68.89702148437496,
									69.95273437499995
								],
								[
									-68.74404296874997,
									69.94140625000003
								],
								[
									-68.65673828124994,
									69.96845703124995
								],
								[
									-68.57783203124995,
									70.03046874999998
								],
								[
									-68.48935546874995,
									70.06484374999997
								],
								[
									-68.39125976562497,
									70.07163085937509
								],
								[
									-68.305078125,
									70.08740234374994
								],
								[
									-68.23066406250001,
									70.11220703124994
								],
								[
									-68.21044921874997,
									70.12841796874994
								],
								[
									-68.318603515625,
									70.16059570312493
								],
								[
									-68.32719726562496,
									70.18017578125011
								],
								[
									-68.28310546874994,
									70.22827148437503
								],
								[
									-68.203515625,
									70.28149414062506
								],
								[
									-68.12065429687499,
									70.31459960937505
								],
								[
									-68.05908203124997,
									70.31723632812503
								],
								[
									-67.855322265625,
									70.28178710937502
								],
								[
									-67.71601562499998,
									70.21982421875
								],
								[
									-67.36367187499997,
									70.03442382812509
								],
								[
									-67.31840820312496,
									69.99843749999994
								],
								[
									-67.19589843749998,
									69.86069335937503
								],
								[
									-67.17265624999993,
									69.799462890625
								],
								[
									-67.19277343749997,
									69.75683593750009
								],
								[
									-67.22163085937498,
									69.73071289062511
								],
								[
									-67.25927734375,
									69.72128906250006
								],
								[
									-67.33671874999996,
									69.72099609374999
								],
								[
									-67.80620117187496,
									69.77739257812502
								],
								[
									-68.02041015625,
									69.77006835937505
								],
								[
									-68.11396484374995,
									69.75429687499994
								],
								[
									-68.18945312499997,
									69.730615234375
								],
								[
									-68.24809570312502,
									69.70078125000003
								],
								[
									-68.28979492187497,
									69.66469726562508
								],
								[
									-68.37207031249994,
									69.64438476562509
								],
								[
									-68.66992187499997,
									69.64365234374995
								],
								[
									-68.83710937500001,
									69.62353515624994
								],
								[
									-69.12451171874994,
									69.57451171874999
								],
								[
									-69.227685546875,
									69.54741210937507
								],
								[
									-69.25078125000002,
									69.51191406250004
								],
								[
									-69.07490234374995,
									69.51811523437496
								],
								[
									-68.78525390625003,
									69.56420898437503
								],
								[
									-68.51303710937498,
									69.57729492187494
								],
								[
									-68.05815429687496,
									69.47587890625005
								],
								[
									-67.90825195312496,
									69.46010742187505
								],
								[
									-67.82485351562502,
									69.47470703125009
								],
								[
									-67.72451171875002,
									69.47924804687494
								],
								[
									-67.3609375,
									69.47250976562509
								],
								[
									-67.236962890625,
									69.46010742187505
								],
								[
									-67.05268554687501,
									69.42119140625002
								],
								[
									-66.77084960937498,
									69.33666992187494
								],
								[
									-66.71674804687495,
									69.31186523437495
								],
								[
									-66.68525390624995,
									69.28574218750003
								],
								[
									-66.67626953124997,
									69.258447265625
								],
								[
									-66.67929687499998,
									69.19106445312494
								],
								[
									-66.70742187500002,
									69.168212890625
								],
								[
									-66.80288085937502,
									69.15273437500005
								],
								[
									-67.20800781249994,
									69.17065429687506
								],
								[
									-67.331640625,
									69.18471679687508
								],
								[
									-67.4837890625,
									69.16699218750011
								],
								[
									-67.60722656250002,
									69.17319335937495
								],
								[
									-67.76503906250002,
									69.20024414062505
								],
								[
									-67.9384765625,
									69.24814453125003
								],
								[
									-68.19819335937498,
									69.2026855468751
								],
								[
									-68.40629882812499,
									69.23222656250007
								],
								[
									-68.61889648437497,
									69.20600585937507
								],
								[
									-69.040625,
									69.09799804687509
								],
								[
									-68.99345703124999,
									69.07934570312509
								],
								[
									-68.41552734375003,
									69.17207031249998
								],
								[
									-68.30395507812503,
									69.16640625000008
								],
								[
									-68.12128906249993,
									69.1326171875001
								],
								[
									-67.8326171875,
									69.06596679687505
								],
								[
									-67.75170898437497,
									69.03867187499998
								],
								[
									-67.75102539062499,
									68.93383789062494
								],
								[
									-67.79511718750001,
									68.86333007812496
								],
								[
									-67.88320312500002,
									68.78398437499996
								],
								[
									-68.015625,
									68.79467773437511
								],
								[
									-68.32421874999997,
									68.84404296875013
								],
								[
									-68.45039062500001,
									68.850830078125
								],
								[
									-68.54277343750002,
									68.84277343750003
								],
								[
									-68.66669921874993,
									68.81132812500013
								],
								[
									-68.72529296874998,
									68.81020507812508
								],
								[
									-69.21884765624998,
									68.87280273437494
								],
								[
									-69.32978515624993,
									68.87578125000002
								],
								[
									-69.34267578125,
									68.86938476562506
								],
								[
									-69.31909179687497,
									68.8569824218751
								],
								[
									-68.871435546875,
									68.75996093749995
								],
								[
									-68.540625,
									68.74936523437512
								],
								[
									-68.33320312499995,
									68.73256835937497
								],
								[
									-68.21040039062498,
									68.70297851562498
								],
								[
									-68.152490234375,
									68.68105468750005
								],
								[
									-68.14833984375002,
									68.61611328124997
								],
								[
									-68.037939453125,
									68.55073242187504
								],
								[
									-67.9384765625,
									68.52416992187497
								],
								[
									-67.87504882812496,
									68.52294921875009
								],
								[
									-67.76601562499994,
									68.54702148437511
								],
								[
									-67.65595703124998,
									68.55073242187504
								],
								[
									-67.56694335937499,
									68.53398437500002
								],
								[
									-67.45551757812501,
									68.49790039062495
								],
								[
									-67.320703125,
									68.48779296875003
								],
								[
									-67.20249023437498,
									68.46586914062499
								],
								[
									-67.11118164062503,
									68.46147460937499
								],
								[
									-66.85419921874998,
									68.47163085937493
								],
								[
									-66.74272460937502,
									68.45776367187494
								],
								[
									-66.71391601562502,
									68.44570312499997
								],
								[
									-66.76240234374993,
									68.42465820312495
								],
								[
									-66.99726562500001,
									68.37416992187497
								],
								[
									-67.032958984375,
									68.32607421874994
								],
								[
									-66.90039062499997,
									68.26352539062498
								],
								[
									-66.83095703124997,
									68.21562499999999
								],
								[
									-66.83432617187503,
									68.1798828125001
								],
								[
									-66.90512695312498,
									68.09848632812512
								],
								[
									-66.923095703125,
									68.0657226562501
								],
								[
									-66.89980468749997,
									68.0630859375
								],
								[
									-66.72900390624997,
									68.12900390625012
								],
								[
									-66.70234374999995,
									68.12055664062498
								],
								[
									-66.68457031249997,
									68.02924804687495
								],
								[
									-66.66269531249998,
									68.03442382812494
								],
								[
									-66.60546875000003,
									68.11000976562497
								],
								[
									-66.63095703124998,
									68.21064453124995
								],
								[
									-66.53076171875,
									68.25034179687506
								],
								[
									-66.21240234374997,
									68.28041992187497
								],
								[
									-66.26630859374995,
									68.12270507812508
								],
								[
									-66.27470703124996,
									68.04077148437509
								],
								[
									-66.41386718749999,
									67.90429687500009
								],
								[
									-66.52998046875001,
									67.86030273437507
								],
								[
									-66.52646484375,
									67.85117187500009
								],
								[
									-66.44394531249998,
									67.83383789062512
								],
								[
									-66.39238281249996,
									67.83193359375008
								],
								[
									-66.34296874999993,
									67.85327148437506
								],
								[
									-66.2251953125,
									67.95874023437497
								],
								[
									-65.98583984375,
									68.06855468750004
								],
								[
									-65.94238281250003,
									68.07094726562511
								],
								[
									-65.943994140625,
									68.03120117187507
								],
								[
									-65.97490234374999,
									67.95742187499997
								],
								[
									-65.86435546875003,
									67.92285156249994
								],
								[
									-65.75893554687497,
									67.95708007812499
								],
								[
									-65.70170898437493,
									67.98666992187498
								],
								[
									-65.56933593749997,
									67.98232421875008
								],
								[
									-65.50908203124996,
									67.96826171875006
								],
								[
									-65.49111328125002,
									67.93569335937508
								],
								[
									-65.552001953125,
									67.79936523437502
								],
								[
									-65.54086914062503,
									67.76562499999997
								],
								[
									-65.40126953125002,
									67.67485351562496
								],
								[
									-65.38710937499997,
									67.68027343750009
								],
								[
									-65.41347656250002,
									67.72407226562495
								],
								[
									-65.442236328125,
									67.83232421875007
								],
								[
									-65.41533203124996,
									67.87924804687495
								],
								[
									-65.30034179687496,
									67.93950195312496
								],
								[
									-65.06440429687495,
									68.02622070312495
								],
								[
									-64.97690429687498,
									68.04340820312507
								],
								[
									-64.92231445312495,
									68.031640625
								],
								[
									-64.83544921875003,
									67.98999023437494
								],
								[
									-64.86254882812494,
									67.96513671875013
								],
								[
									-64.95639648437498,
									67.93911132812497
								],
								[
									-65.02602539062497,
									67.89204101562507
								],
								[
									-65.07143554687497,
									67.82382812500012
								],
								[
									-65.02109375,
									67.78754882812501
								],
								[
									-64.82988281249996,
									67.78427734375003
								],
								[
									-64.63779296875,
									67.840234375
								],
								[
									-64.52753906250001,
									67.81269531250007
								],
								[
									-64.39643554687495,
									67.73994140624998
								],
								[
									-64.15624999999994,
									67.62299804687504
								],
								[
									-64.01943359374997,
									67.65488281249998
								],
								[
									-63.850195312500034,
									67.566064453125
								],
								[
									-64.07749023437498,
									67.49560546874994
								],
								[
									-64.00795898437502,
									67.34731445312494
								],
								[
									-64.30327148437496,
									67.35346679687504
								],
								[
									-64.46928710937496,
									67.34184570312507
								],
								[
									-64.58046874999997,
									67.35517578125001
								],
								[
									-64.69995117187497,
									67.35053710937507
								],
								[
									-64.58925781249997,
									67.31552734375003
								],
								[
									-64.37592773437493,
									67.30107421875002
								],
								[
									-64.35644531249997,
									67.25615234375002
								],
								[
									-64.18896484374994,
									67.25727539062507
								],
								[
									-64.063232421875,
									67.26591796874996
								],
								[
									-63.83623046874993,
									67.26411132812504
								],
								[
									-63.824121093749966,
									67.31567382812497
								],
								[
									-63.67646484374998,
									67.34511718750002
								],
								[
									-63.59160156250002,
									67.37753906250006
								],
								[
									-63.52109374999995,
									67.35834960937495
								],
								[
									-63.315820312499966,
									67.33632812500008
								],
								[
									-63.040136718750034,
									67.23500976562497
								],
								[
									-63.16162109375,
									67.17436523437496
								],
								[
									-63.19467773437498,
									67.117041015625
								],
								[
									-63.235546874999955,
									67.06850585937505
								],
								[
									-63.258398437500006,
									67.02465820312511
								],
								[
									-63.306787109374994,
									66.99448242187509
								],
								[
									-63.701562499999966,
									66.82236328125
								],
								[
									-63.63623046874997,
									66.82080078125006
								],
								[
									-63.469189453124955,
									66.86240234375009
								],
								[
									-63.143701171874994,
									66.92431640625
								],
								[
									-62.962304687499994,
									66.94926757812502
								],
								[
									-62.833349609375006,
									66.93271484375012
								],
								[
									-62.76816406249995,
									66.93198242187506
								],
								[
									-62.71044921875,
									66.95410156249994
								],
								[
									-62.602880859375034,
									66.92861328125008
								],
								[
									-62.37973632812495,
									66.90537109375003
								],
								[
									-62.12358398437499,
									67.04672851562498
								],
								[
									-61.96855468749993,
									67.01904296875003
								],
								[
									-61.824121093749994,
									66.93173828125
								],
								[
									-61.51469726562493,
									66.77846679687505
								],
								[
									-61.35341796874994,
									66.68920898437497
								],
								[
									-61.29970703125002,
									66.64873046874999
								],
								[
									-61.307226562500034,
									66.60883789062504
								],
								[
									-61.45307617187501,
									66.56660156249995
								],
								[
									-61.52783203124994,
									66.55810546875
								],
								[
									-61.72412109374997,
									66.63779296874998
								],
								[
									-61.904492187499955,
									66.67812499999994
								],
								[
									-62.014257812500006,
									66.67377929687504
								],
								[
									-62.12333984374996,
									66.64306640625009
								],
								[
									-62.089306640624955,
									66.62592773437495
								],
								[
									-61.65263671874999,
									66.50312499999998
								],
								[
									-61.576416015625,
									66.4125
								],
								[
									-61.57080078125,
									66.37290039062509
								],
								[
									-61.862695312499966,
									66.31284179687495
								],
								[
									-61.95634765624993,
									66.30932617187494
								],
								[
									-62.158447265625,
									66.33798828125
								],
								[
									-62.27690429687496,
									66.39150390625008
								],
								[
									-62.37451171874997,
									66.41083984374993
								],
								[
									-62.50981445312499,
									66.41718749999998
								],
								[
									-62.55312500000002,
									66.4068359375
								],
								[
									-62.405664062499994,
									66.31591796875003
								],
								[
									-62.419824218749966,
									66.28857421874997
								],
								[
									-62.49599609375002,
									66.27089843750002
								],
								[
									-62.53359374999994,
									66.22700195312495
								],
								[
									-62.242089843749994,
									66.14794921875011
								],
								[
									-62.02392578125003,
									66.06752929687505
								],
								[
									-61.99160156250002,
									66.03530273437508
								],
								[
									-62.13867187499997,
									66.011376953125
								],
								[
									-62.24433593749998,
									66.00585937500003
								],
								[
									-62.46777343749994,
									66.01748046875
								],
								[
									-62.59033203124997,
									66.03442382812506
								],
								[
									-62.624121093750006,
									66.01625976562511
								],
								[
									-62.49736328124993,
									65.97402343749994
								],
								[
									-62.448388671874994,
									65.94550781249998
								],
								[
									-62.410302734374966,
									65.90576171874997
								],
								[
									-62.38818359375,
									65.86831054687508
								],
								[
									-62.381982421874966,
									65.83330078125005
								],
								[
									-62.48564453124996,
									65.80449218750013
								],
								[
									-62.61025390625002,
									65.72363281250009
								],
								[
									-62.65888671874998,
									65.63994140624999
								],
								[
									-62.77172851562497,
									65.63198242187497
								],
								[
									-62.81728515625002,
									65.64770507812497
								],
								[
									-62.968896484374994,
									65.62236328124996
								],
								[
									-63.16894531249997,
									65.65732421874998
								],
								[
									-63.240673828124926,
									65.69555664062506
								],
								[
									-63.45874023437494,
									65.85302734374997
								],
								[
									-63.46435546875003,
									65.83535156250002
								],
								[
									-63.409765625000006,
									65.75581054687507
								],
								[
									-63.42089843749997,
									65.70859374999995
								],
								[
									-63.65195312499998,
									65.67431640625006
								],
								[
									-63.65107421874998,
									65.66098632812512
								],
								[
									-63.509228515624926,
									65.63603515625007
								],
								[
									-63.33745117187493,
									65.61674804687507
								],
								[
									-63.36425781249997,
									65.543212890625
								],
								[
									-63.36337890624998,
									65.229736328125
								],
								[
									-63.40180664062498,
									65.11845703125007
								],
								[
									-63.48583984374997,
									65.02124023437506
								],
								[
									-63.606591796874966,
									64.928076171875
								],
								[
									-63.737158203125006,
									64.989111328125
								],
								[
									-63.78935546874999,
									65.05136718750009
								],
								[
									-63.833203124999955,
									65.08330078125002
								],
								[
									-63.89560546874995,
									65.10927734375005
								],
								[
									-63.976269531249955,
									65.12148437500005
								],
								[
									-64.06142578125,
									65.12192382812498
								],
								[
									-64.15185546875003,
									65.06616210937509
								],
								[
									-64.25043945312495,
									65.11430664062502
								],
								[
									-64.345703125,
									65.17241210937496
								],
								[
									-64.30976562499995,
									65.32456054687503
								],
								[
									-64.26967773437497,
									65.40078124999994
								],
								[
									-64.28574218750003,
									65.4001953125001
								],
								[
									-64.33994140624998,
									65.36416015624994
								],
								[
									-64.46982421874998,
									65.25273437500007
								],
								[
									-64.55507812500002,
									65.11660156250005
								],
								[
									-64.66533203125002,
									65.16894531250006
								],
								[
									-64.76479492187502,
									65.2340820312501
								],
								[
									-64.84692382812497,
									65.29956054687511
								],
								[
									-64.979638671875,
									65.37509765624995
								],
								[
									-65.10849609374998,
									65.46376953125008
								],
								[
									-65.17568359374997,
									65.5681640625001
								],
								[
									-65.20698242187495,
									65.58964843749996
								],
								[
									-65.28203124999996,
									65.67666015625002
								],
								[
									-65.31147460937493,
									65.70151367187509
								],
								[
									-65.33740234374997,
									65.7097656250001
								],
								[
									-65.401611328125,
									65.76401367187503
								],
								[
									-65.37812500000001,
									65.82207031250007
								],
								[
									-65.276953125,
									65.8906738281251
								],
								[
									-65.18486328124999,
									65.93994140625
								],
								[
									-65.03222656249997,
									65.98852539062506
								],
								[
									-64.85371093749993,
									66.01591796875013
								],
								[
									-64.77250976562499,
									66.07856445312501
								],
								[
									-64.67299804687497,
									66.19272460937509
								],
								[
									-64.56396484374997,
									66.27216796874993
								],
								[
									-64.44536132812496,
									66.31713867187503
								],
								[
									-64.50439453125,
									66.32548828125005
								],
								[
									-64.65517578125,
									66.28701171875002
								],
								[
									-64.7611328125,
									66.23090820312495
								],
								[
									-64.88725585937502,
									66.1374023437501
								],
								[
									-65.0044921875,
									66.077734375
								],
								[
									-65.30537109374993,
									66.00844726562502
								],
								[
									-65.41557617187499,
									65.99458007812504
								],
								[
									-65.543701171875,
									65.98720703125005
								],
								[
									-65.82573242187499,
									65.99692382812498
								],
								[
									-65.89106445312498,
									66.02021484374993
								],
								[
									-65.857177734375,
									66.08642578125
								],
								[
									-65.65634765625003,
									66.20473632812505
								],
								[
									-65.68837890624997,
									66.21308593750004
								],
								[
									-65.75898437499998,
									66.17119140624996
								],
								[
									-65.85595703125,
									66.14223632812511
								],
								[
									-65.9400390625,
									66.12744140625011
								],
								[
									-66.06372070312497,
									66.13271484374994
								],
								[
									-66.20859375,
									66.20639648437512
								],
								[
									-66.27739257812499,
									66.22910156250003
								],
								[
									-66.419189453125,
									66.25449218750006
								],
								[
									-66.47695312499997,
									66.27973632812495
								],
								[
									-66.71230468749994,
									66.46044921875
								],
								[
									-66.75976562500003,
									66.50849609374993
								],
								[
									-66.78740234374996,
									66.55566406249994
								],
								[
									-66.86289062499998,
									66.59531250000003
								],
								[
									-66.986328125,
									66.62749023437502
								],
								[
									-67.01479492187502,
									66.62221679687508
								],
								[
									-66.97041015624995,
									66.58188476562503
								],
								[
									-66.96899414062503,
									66.54716796874999
								],
								[
									-67.07685546874995,
									66.52548828125009
								],
								[
									-67.18964843749993,
									66.53300781250005
								],
								[
									-67.30732421874993,
									66.56972656249997
								],
								[
									-67.31767578124999,
									66.52036132812495
								],
								[
									-67.191748046875,
									66.43276367187505
								],
								[
									-67.18974609374996,
									66.32172851562498
								],
								[
									-67.22539062499993,
									66.31025390624995
								],
								[
									-67.31123046875001,
									66.30375976562496
								],
								[
									-67.36884765624995,
									66.31748046875
								],
								[
									-67.55976562499993,
									66.40043945312513
								],
								[
									-67.74077148437496,
									66.45820312499998
								],
								[
									-67.86845703124993,
									66.49013671875011
								],
								[
									-67.88339843749998,
									66.467431640625
								],
								[
									-67.80058593749996,
									66.36733398437502
								],
								[
									-67.70449218750002,
									66.26860351562499
								],
								[
									-67.54721679687495,
									66.18720703124993
								],
								[
									-67.296728515625,
									66.09028320312507
								],
								[
									-67.18320312499995,
									66.03442382812506
								],
								[
									-67.27265624999998,
									65.95556640625009
								],
								[
									-67.350439453125,
									65.92973632812505
								],
								[
									-67.398779296875,
									65.92172851562503
								],
								[
									-67.55078124999997,
									65.921630859375
								],
								[
									-67.82802734374997,
									65.96518554687509
								],
								[
									-67.95820312500001,
									66.01381835937505
								],
								[
									-68.14726562499999,
									66.12983398437507
								],
								[
									-68.45991210937501,
									66.24926757812506
								],
								[
									-68.52778320312498,
									66.2486328125
								],
								[
									-68.74892578125,
									66.20004882812498
								],
								[
									-68.71420898437503,
									66.19223632812498
								],
								[
									-68.57167968749994,
									66.18872070312497
								],
								[
									-68.46708984374996,
									66.173193359375
								],
								[
									-68.21718750000002,
									66.07885742187497
								],
								[
									-68.19833984375,
									66.03896484375002
								],
								[
									-68.26069335937501,
									65.99458007812504
								],
								[
									-68.25683593750003,
									65.93862304687508
								],
								[
									-68.18671874999995,
									65.87099609375
								],
								[
									-68.11503906249999,
									65.82778320312508
								],
								[
									-67.96806640624999,
									65.79726562500008
								],
								[
									-67.89418945312494,
									65.79326171874996
								],
								[
									-67.86645507812497,
									65.77368164062497
								],
								[
									-67.95434570312503,
									65.6230957031251
								],
								[
									-67.96181640624997,
									65.58193359375
								],
								[
									-67.936767578125,
									65.56489257812498
								],
								[
									-67.90605468749996,
									65.56347656250006
								],
								[
									-67.71713867187503,
									65.62534179687495
								],
								[
									-67.6380859375,
									65.6404296875001
								],
								[
									-67.56962890624999,
									65.64355468750003
								],
								[
									-67.49013671874997,
									65.62622070312503
								],
								[
									-67.39970703125002,
									65.58837890624997
								],
								[
									-67.34638671874998,
									65.54936523437502
								],
								[
									-67.330322265625,
									65.5091796875
								],
								[
									-67.30341796874993,
									65.48291015624997
								],
								[
									-67.11796874999999,
									65.44038085937493
								],
								[
									-67.13496093749998,
									65.42050781250006
								],
								[
									-67.32607421875002,
									65.35664062499993
								],
								[
									-67.3365234375,
									65.34658203125008
								],
								[
									-67.29833984374997,
									65.34194335937502
								],
								[
									-67.17758789062498,
									65.30380859375009
								],
								[
									-67.06650390624998,
									65.2440917968751
								],
								[
									-66.99858398437502,
									65.172998046875
								],
								[
									-66.98491210937496,
									65.13803710937498
								],
								[
									-66.98564453124993,
									65.10483398437503
								],
								[
									-66.97036132812502,
									65.08491210937498
								],
								[
									-66.91152343749994,
									65.08134765625005
								],
								[
									-66.88750000000002,
									65.09399414062497
								],
								[
									-66.86064453124996,
									65.09160156250002
								],
								[
									-66.83090820312503,
									65.07416992187493
								],
								[
									-66.79960937499996,
									65.01967773437502
								],
								[
									-66.73276367187503,
									64.86005859375001
								],
								[
									-66.69741210937502,
									64.81518554687511
								],
								[
									-66.67714843749997,
									64.81367187500007
								],
								[
									-66.66669921874998,
									64.97382812500001
								],
								[
									-66.63549804687503,
									65.00034179687506
								],
								[
									-66.51777343750001,
									64.97197265625007
								],
								[
									-66.34521484375003,
									64.90961914062498
								],
								[
									-66.22373046874998,
									64.85410156249995
								],
								[
									-66.20971679687497,
									64.82812500000009
								],
								[
									-66.301513671875,
									64.77773437499994
								],
								[
									-66.28212890624997,
									64.75532226562498
								],
								[
									-66.21464843749999,
									64.72241210937494
								],
								[
									-66.15249023437502,
									64.7349121093751
								],
								[
									-66.10751953125,
									64.79121093749993
								],
								[
									-66.03017578124997,
									64.84658203125002
								],
								[
									-65.93852539062496,
									64.8857421875
								],
								[
									-65.76806640624997,
									64.85356445312502
								],
								[
									-65.62675781249996,
									64.77075195312503
								],
								[
									-65.60527343750002,
									64.74233398437508
								],
								[
									-65.51318359375,
									64.70649414062498
								],
								[
									-65.43193359374996,
									64.72641601562503
								],
								[
									-65.27480468750002,
									64.63154296875007
								],
								[
									-65.34931640625001,
									64.58852539062494
								],
								[
									-65.51279296875,
									64.52597656249998
								],
								[
									-65.52934570312499,
									64.50478515625002
								],
								[
									-65.48999023437497,
									64.50961914062512
								],
								[
									-65.17861328124997,
									64.50971679687495
								],
								[
									-65.09453124999996,
									64.48457031249998
								],
								[
									-65.074609375,
									64.436669921875
								],
								[
									-65.21298828125003,
									64.30327148437499
								],
								[
									-65.33989257812496,
									64.31508789062508
								],
								[
									-65.507470703125,
									64.31831054687495
								],
								[
									-65.59365234374997,
									64.31113281250009
								],
								[
									-65.580322265625,
									64.29384765624994
								],
								[
									-65.34780273437497,
									64.23232421875002
								],
								[
									-65.28198242187497,
									64.181640625
								],
								[
									-65.1927734375,
									64.12983398437493
								],
								[
									-65.14960937499998,
									64.08715820312503
								],
								[
									-65.15063476562503,
									64.06752929687502
								],
								[
									-65.18730468749996,
									64.03798828125005
								],
								[
									-65.16987304687495,
									64.02817382812509
								],
								[
									-65.010595703125,
									64.00883789062496
								],
								[
									-64.91181640624995,
									64.02617187500013
								],
								[
									-64.78779296875001,
									64.03276367187505
								],
								[
									-64.67846679687503,
									64.02797851562505
								],
								[
									-64.66972656250002,
									64.00957031250002
								],
								[
									-64.686181640625,
									63.96093749999997
								],
								[
									-64.79814453124999,
									63.915966796874955
								],
								[
									-64.7681640625,
									63.90541992187494
								],
								[
									-64.63671874999994,
									63.91835937500008
								],
								[
									-64.576318359375,
									63.897363281249994
								],
								[
									-64.49848632812495,
									63.79033203125013
								],
								[
									-64.41093749999996,
									63.706347656250074
								],
								[
									-64.48222656250002,
									63.68706054687496
								],
								[
									-64.56157226562502,
									63.67968750000006
								],
								[
									-64.55029296875003,
									63.57255859374999
								],
								[
									-64.49863281249998,
									63.46279296875011
								],
								[
									-64.49809570312496,
									63.35756835937505
								],
								[
									-64.51435546874998,
									63.2639648437501
								],
								[
									-64.58691406250003,
									63.24316406249994
								],
								[
									-64.66464843749995,
									63.24536132812494
								],
								[
									-64.69560546874996,
									63.26884765625002
								],
								[
									-64.88627929687499,
									63.54873046875002
								],
								[
									-64.93330078124998,
									63.59926757812511
								],
								[
									-64.98969726562501,
									63.64335937500002
								],
								[
									-65.19184570312498,
									63.76425781250006
								],
								[
									-65.18393554687498,
									63.7448242187501
								],
								[
									-65.13383789062499,
									63.689062500000006
								],
								[
									-65.08940429687499,
									63.60595703125003
								],
								[
									-65.03134765624998,
									63.440136718749926
								],
								[
									-65.00478515624997,
									63.33339843749994
								],
								[
									-65.01669921875,
									63.29282226562512
								],
								[
									-65.05805664062498,
									63.28286132812494
								],
								[
									-65.0689453125,
									63.26347656249999
								],
								[
									-65.04931640625,
									63.23461914062497
								],
								[
									-64.89482421874996,
									63.12563476562505
								],
								[
									-64.82016601562503,
									63.060009765624926
								],
								[
									-64.76738281250002,
									62.99179687499998
								],
								[
									-64.718115234375,
									62.94580078125003
								],
								[
									-64.67236328125003,
									62.92197265625006
								],
								[
									-64.68364257812502,
									62.902392578125045
								],
								[
									-64.75185546874997,
									62.88715820312507
								],
								[
									-64.86870117187496,
									62.8798828125
								],
								[
									-64.92324218749997,
									62.88916015624994
								],
								[
									-65.13295898437497,
									62.952343749999926
								],
								[
									-65.16279296875001,
									62.9326171875
								],
								[
									-65.04658203124995,
									62.701464843750074
								],
								[
									-65.0501953125,
									62.646142578124994
								],
								[
									-65.10849609374998,
									62.62646484374997
								],
								[
									-65.18032226562494,
									62.64946289062496
								],
								[
									-65.26582031249995,
									62.715087890625
								],
								[
									-65.39653320312493,
									62.78818359374998
								],
								[
									-65.57241210937497,
									62.868896484375085
								],
								[
									-65.740380859375,
									62.931982421875034
								],
								[
									-65.77988281249998,
									62.93027343750006
								],
								[
									-65.80566406249997,
									62.91157226562507
								],
								[
									-65.83369140625001,
									62.90854492187498
								],
								[
									-65.86406249999999,
									62.92114257812497
								],
								[
									-65.92026367187498,
									62.96850585937494
								],
								[
									-65.978857421875,
									63.000683593749926
								],
								[
									-66.22402343749994,
									63.10717773437494
								],
								[
									-66.24921875000001,
									63.10825195312506
								],
								[
									-66.22607421875,
									63.076318359374966
								],
								[
									-66.20107421874997,
									63.006249999999994
								],
								[
									-66.228662109375,
									62.990966796875085
								],
								[
									-66.29277343750002,
									62.99667968750009
								],
								[
									-66.41445312500002,
									63.02719726562509
								],
								[
									-66.49638671875002,
									63.09726562500006
								],
								[
									-66.60048828125,
									63.218896484374966
								],
								[
									-66.65498046874998,
									63.26474609374998
								],
								[
									-66.659814453125,
									63.23491210937513
								],
								[
									-66.63085937499997,
									63.119042968749966
								],
								[
									-66.63642578124995,
									63.08012695312513
								],
								[
									-66.69746093749995,
									63.06953125000001
								],
								[
									-66.72324218749995,
									63.08017578124995
								],
								[
									-66.74853515624994,
									63.11108398437494
								],
								[
									-66.77324218750002,
									63.16225585937505
								],
								[
									-66.83144531249997,
									63.20112304687498
								],
								[
									-66.92329101562495,
									63.22768554687508
								],
								[
									-66.97470703125003,
									63.25556640624998
								],
								[
									-67.00014648437497,
									63.305126953124955
								],
								[
									-67.01791992187503,
									63.316503906250034
								],
								[
									-67.17978515624998,
									63.30502929687512
								],
								[
									-67.26093749999998,
									63.34072265625011
								],
								[
									-67.49501953124997,
									63.481445312500085
								],
								[
									-67.709228515625,
									63.633935546874966
								],
								[
									-67.84423828124997,
									63.714550781249955
								],
								[
									-67.89326171874993,
									63.73374023437506
								],
								[
									-67.82143554687497,
									63.635009765625085
								],
								[
									-67.74252929687495,
									63.48925781250006
								],
								[
									-67.72255859374997,
									63.42275390624994
								],
								[
									-67.75878906249997,
									63.4197265625001
								],
								[
									-67.83789062500003,
									63.44921875
								],
								[
									-68.24355468749997,
									63.63706054687498
								],
								[
									-68.49374999999998,
									63.725488281249966
								],
								[
									-68.63286132812496,
									63.74111328125005
								],
								[
									-68.85893554687502,
									63.75185546875011
								],
								[
									-68.91108398437498,
									63.70322265625006
								],
								[
									-68.78925781249995,
									63.595117187499966
								],
								[
									-68.67055664062502,
									63.51367187500006
								],
								[
									-68.55512695312495,
									63.458935546874926
								],
								[
									-68.37392578124997,
									63.35219726562502
								],
								[
									-68.20805664062493,
									63.214697265625006
								],
								[
									-68.141259765625,
									63.17231445312498
								],
								[
									-67.91533203124999,
									63.11367187499994
								],
								[
									-67.79746093749995,
									63.098095703124955
								],
								[
									-67.67597656249998,
									63.09355468750002
								],
								[
									-67.66489257812503,
									63.07265625000002
								],
								[
									-67.72377929687497,
									63.033691406250085
								],
								[
									-67.73696289062497,
									63.00957031249996
								],
								[
									-67.46821289062493,
									62.948242187500085
								],
								[
									-67.36665039062493,
									62.91416015625006
								],
								[
									-67.26850585937501,
									62.85756835937508
								],
								[
									-67.21269531250002,
									62.84350585937506
								],
								[
									-66.97954101562493,
									62.70083007812494
								],
								[
									-66.92153320312502,
									62.678076171875006
								],
								[
									-66.71401367187502,
									62.6317871093751
								],
								[
									-66.64487304687498,
									62.60205078124997
								],
								[
									-66.53051757812494,
									62.509960937499955
								],
								[
									-66.45874023437497,
									62.463134765625085
								],
								[
									-66.357275390625,
									62.35190429687509
								],
								[
									-66.28124999999997,
									62.30268554687501
								],
								[
									-66.09501953124996,
									62.24638671874999
								],
								[
									-66.01562500000003,
									62.230273437500074
								],
								[
									-65.98017578125001,
									62.208886718749994
								],
								[
									-66.00434570312495,
									62.15830078125009
								],
								[
									-66.02695312500003,
									62.13720703125006
								],
								[
									-66.133154296875,
									62.10239257812506
								],
								[
									-66.11640624999995,
									62.053906249999955
								],
								[
									-66.05644531249999,
									61.967480468749926
								],
								[
									-66.05888671874996,
									61.91386718750002
								],
								[
									-66.12387695312498,
									61.89306640625006
								],
								[
									-66.25668945312503,
									61.86826171875006
								],
								[
									-66.32373046875,
									61.87026367187502
								],
								[
									-66.42451171874993,
									61.890722656250006
								],
								[
									-66.55131835937502,
									61.9255859375001
								],
								[
									-66.80312499999997,
									62.012597656249966
								],
								[
									-67.18105468749997,
									62.07285156250009
								],
								[
									-67.322021484375,
									62.105029296875074
								],
								[
									-67.36899414062498,
									62.13408203125013
								],
								[
									-67.44013671874998,
									62.15126953125008
								],
								[
									-68.37861328124995,
									62.23515625000002
								],
								[
									-68.53588867187503,
									62.255615234375085
								],
								[
									-68.63364257812495,
									62.2812988281251
								],
								[
									-68.72436523437497,
									62.31899414062505
								],
								[
									-69.08232421874996,
									62.40517578125002
								],
								[
									-69.12558593749998,
									62.42397460937494
								],
								[
									-69.36601562499993,
									62.571875000000034
								],
								[
									-69.54516601562503,
									62.74458007812507
								],
								[
									-69.604736328125,
									62.76772460937508
								],
								[
									-69.79951171874998,
									62.7904785156251
								],
								[
									-69.96210937499998,
									62.77617187500002
								],
								[
									-70.07094726562502,
									62.757226562499966
								],
								[
									-70.23613281250002,
									62.76337890624998
								],
								[
									-70.34404296874999,
									62.79150390624994
								],
								[
									-70.57133789062502,
									62.86918945312496
								],
								[
									-70.801416015625,
									62.91049804687512
								],
								[
									-71.00214843749993,
									62.97827148437497
								],
								[
									-71.10576171874999,
									63.002246093750074
								],
								[
									-71.09619140625,
									63.019677734374966
								],
								[
									-70.94604492187497,
									63.12070312499995
								],
								[
									-70.99267578124997,
									63.11928710937502
								],
								[
									-71.25371093749993,
									63.0425292968751
								],
								[
									-71.34726562499998,
									63.066113281249926
								],
								[
									-71.50126953125002,
									63.126416015624955
								],
								[
									-71.61713867187498,
									63.1872070312501
								],
								[
									-71.85546874999997,
									63.355273437500045
								],
								[
									-71.99223632812493,
									63.41616210937511
								],
								[
									-71.97304687500002,
									63.42988281250004
								],
								[
									-71.81918945312503,
									63.43544921874994
								],
								[
									-71.696533203125,
									63.43022460937513
								],
								[
									-71.61425781250003,
									63.444091796875114
								],
								[
									-71.45585937499999,
									63.51225585937496
								],
								[
									-71.38740234374998,
									63.55502929687506
								],
								[
									-71.380859375,
									63.58032226562497
								],
								[
									-71.51347656250002,
									63.586572265624994
								],
								[
									-71.54189453125002,
									63.598828124999926
								],
								[
									-71.56562499999998,
									63.62675781250002
								],
								[
									-71.62675781249999,
									63.66259765624994
								],
								[
									-71.72529296875001,
									63.706152343750034
								],
								[
									-71.83754882812497,
									63.72495117187495
								],
								[
									-72.22294921874996,
									63.708886718749966
								],
								[
									-72.29013671874998,
									63.72797851562504
								],
								[
									-72.28876953124995,
									63.756982421874994
								],
								[
									-72.21347656249998,
									63.83872070312495
								],
								[
									-72.17246093749998,
									63.87167968750009
								],
								[
									-72.15937499999998,
									63.88989257812497
								],
								[
									-72.17426757812498,
									63.89340820312498
								],
								[
									-72.22646484374997,
									63.891357421875085
								],
								[
									-72.44999999999993,
									63.818115234375085
								],
								[
									-72.49843749999994,
									63.82348632812494
								],
								[
									-72.58613281249995,
									63.90078125000005
								],
								[
									-72.63930664062497,
									63.98906250000002
								],
								[
									-72.67807617187503,
									64.02001953125003
								],
								[
									-72.72958984374998,
									64.03046874999993
								],
								[
									-72.91318359374998,
									64.11718750000009
								],
								[
									-73.17431640624997,
									64.281884765625
								],
								[
									-73.27031249999999,
									64.33349609375003
								],
								[
									-73.377099609375,
									64.3795898437501
								],
								[
									-73.45454101562495,
									64.399267578125
								],
								[
									-73.44365234374996,
									64.42348632812497
								],
								[
									-73.278173828125,
									64.56025390625004
								],
								[
									-73.27128906250002,
									64.58251953125003
								],
								[
									-73.41308593750003,
									64.57416992187504
								],
								[
									-73.626953125,
									64.60253906249994
								],
								[
									-73.72841796874997,
									64.56826171875008
								],
								[
									-73.79277343749993,
									64.5662109375001
								],
								[
									-73.86787109374995,
									64.5853515625
								],
								[
									-73.91035156250001,
									64.57812499999994
								],
								[
									-73.95039062499998,
									64.46582031250006
								],
								[
									-73.98110351562502,
									64.43774414062494
								],
								[
									-74.02558593749993,
									64.42265625000007
								],
								[
									-74.06479492187503,
									64.42465820312495
								],
								[
									-74.09873046875,
									64.443701171875
								],
								[
									-74.09790039062503,
									64.46992187499993
								],
								[
									-74.13046874999998,
									64.60781250000005
								],
								[
									-74.205078125,
									64.62812500000001
								],
								[
									-74.41586914062495,
									64.63349609375004
								],
								[
									-74.46123046874996,
									64.64467773437508
								],
								[
									-74.512451171875,
									64.67016601562506
								],
								[
									-74.55624999999995,
									64.71733398437507
								],
								[
									-74.59257812499999,
									64.78618164062496
								],
								[
									-74.63427734374994,
									64.82392578124993
								],
								[
									-74.68139648437497,
									64.83066406250006
								],
								[
									-74.71918945312493,
									64.8251464843751
								],
								[
									-74.74775390624998,
									64.80732421874993
								],
								[
									-74.81342773437495,
									64.79624023437498
								],
								[
									-74.91625976562503,
									64.7919921875
								],
								[
									-74.91943359374997,
									64.76552734374994
								],
								[
									-74.82304687499996,
									64.71689453124998
								],
								[
									-74.72983398437498,
									64.64736328125002
								],
								[
									-74.64003906249997,
									64.55708007812493
								],
								[
									-74.69472656250002,
									64.49658203124994
								],
								[
									-74.89394531250002,
									64.46572265624997
								],
								[
									-75.0673828125,
									64.45668945312508
								],
								[
									-75.21503906249995,
									64.469384765625
								],
								[
									-75.32841796874996,
									64.49042968749993
								],
								[
									-75.48779296875003,
									64.54077148437497
								],
								[
									-75.71503906249995,
									64.52436523437501
								],
								[
									-75.76669921875,
									64.39194335937503
								],
								[
									-75.81523437499993,
									64.38466796874997
								],
								[
									-76.0318359375,
									64.38808593750005
								],
								[
									-76.11806640625,
									64.37631835937495
								],
								[
									-76.40683593750003,
									64.30317382812507
								],
								[
									-76.4947265625,
									64.29296874999994
								],
								[
									-76.5615234375,
									64.301611328125
								],
								[
									-76.62651367187502,
									64.28393554687506
								],
								[
									-76.72382812499995,
									64.24204101562495
								],
								[
									-76.85615234374998,
									64.23764648437495
								],
								[
									-77.02353515624998,
									64.27084960937506
								],
								[
									-77.165673828125,
									64.28505859375002
								],
								[
									-77.28251953124999,
									64.28037109374995
								],
								[
									-77.40288085937499,
									64.29990234375012
								],
								[
									-77.52675781250002,
									64.34375000000006
								],
								[
									-77.62778320312498,
									64.36347656250001
								],
								[
									-77.76049804687503,
									64.36015625000005
								],
								[
									-77.79116210937497,
									64.36708984374994
								],
								[
									-77.98486328125,
									64.461083984375
								],
								[
									-78.04521484374993,
									64.49926757812506
								],
								[
									-78.174560546875,
									64.61772460937502
								],
								[
									-78.19755859374999,
									64.66464843750006
								],
								[
									-78.20087890624995,
									64.71474609375008
								],
								[
									-78.18969726562497,
									64.75180664062498
								],
								[
									-78.14462890625003,
									64.80771484375
								],
								[
									-78.09560546875,
									64.93925781250007
								],
								[
									-78.05527343750003,
									64.98291015625009
								],
								[
									-77.99458007812493,
									65.022607421875
								],
								[
									-77.87617187499995,
									65.07294921875004
								],
								[
									-77.44746093749993,
									65.16157226562507
								],
								[
									-77.36088867187496,
									65.19653320312509
								],
								[
									-77.36386718749995,
									65.21977539062502
								],
								[
									-77.46147460937496,
									65.32817382812499
								],
								[
									-77.46040039062498,
									65.35590820312495
								],
								[
									-77.42768554687498,
									65.37211914062496
								],
								[
									-77.3580078125,
									65.43544921875
								],
								[
									-77.32670898437493,
									65.45312499999994
								],
								[
									-77.25117187500001,
									65.46289062500009
								],
								[
									-77.094140625,
									65.43085937500004
								],
								[
									-76.95859375,
									65.41801757812499
								],
								[
									-76.77890624999998,
									65.41386718750013
								],
								[
									-76.481689453125,
									65.3697265625
								],
								[
									-76.06699218749998,
									65.28544921874999
								],
								[
									-75.82832031249995,
									65.22705078125009
								],
								[
									-75.64814453125001,
									65.14082031250001
								],
								[
									-75.519921875,
									65.05600585937503
								],
								[
									-75.50156249999998,
									65.01308593750011
								],
								[
									-75.5609375,
									64.94702148437506
								],
								[
									-75.59086914062496,
									64.92768554687493
								],
								[
									-75.58911132812497,
									64.90502929687503
								],
								[
									-75.55576171875,
									64.87919921875007
								],
								[
									-75.45209960937495,
									64.84160156250007
								],
								[
									-75.42714843750002,
									64.85585937500005
								],
								[
									-75.43515624999995,
									64.90078125000005
								],
								[
									-75.41367187500003,
									64.9385253906251
								],
								[
									-75.36279296874997,
									64.9690429687501
								],
								[
									-75.35712890624995,
									65.00874023437493
								],
								[
									-75.39667968749993,
									65.05756835937493
								],
								[
									-75.44580078125,
									65.09970703124998
								],
								[
									-75.50468749999999,
									65.13515625000011
								],
								[
									-75.77294921875003,
									65.25703125000007
								],
								[
									-75.79868164062503,
									65.29750976562505
								],
								[
									-75.70859374999998,
									65.31572265625002
								],
								[
									-75.31665039062497,
									65.27480468750002
								],
								[
									-75.16630859374999,
									65.28393554687494
								],
								[
									-75.10927734375,
									65.33144531249994
								],
								[
									-75.04775390625,
									65.36396484375007
								],
								[
									-74.98173828124996,
									65.3814453125
								],
								[
									-74.849853515625,
									65.38906250000005
								],
								[
									-74.66547851562501,
									65.36694335937497
								],
								[
									-74.57490234374993,
									65.36367187499994
								],
								[
									-74.49477539062497,
									65.37167968750006
								],
								[
									-74.39072265624998,
									65.39755859375009
								],
								[
									-74.23686523437499,
									65.48388671875
								],
								[
									-74.13847656250002,
									65.50346679687499
								],
								[
									-73.98959960937498,
									65.5169921875
								],
								[
									-73.87792968749997,
									65.51884765625002
								],
								[
									-73.675390625,
									65.4843261718751
								],
								[
									-73.55078125000003,
									65.48525390625011
								],
								[
									-73.56074218750001,
									65.54291992187504
								],
								[
									-73.64340820312498,
									65.65322265625002
								],
								[
									-73.74609375000003,
									65.76669921874998
								],
								[
									-73.82607421874997,
									65.80517578125
								],
								[
									-74.03310546874997,
									65.87705078124998
								],
								[
									-74.27617187500002,
									66.0127441406251
								],
								[
									-74.40107421874995,
									66.09697265625002
								],
								[
									-74.433935546875,
									66.13901367187498
								],
								[
									-74.41640624999997,
									66.16708984375
								],
								[
									-74.37490234374997,
									66.20815429687494
								],
								[
									-73.93369140624995,
									66.35805664062511
								],
								[
									-73.584228515625,
									66.50693359375006
								],
								[
									-73.43095703124993,
									66.58315429687505
								],
								[
									-73.35737304687495,
									66.6362792968751
								],
								[
									-73.28081054687499,
									66.674951171875
								],
								[
									-73.20112304687501,
									66.69916992187495
								],
								[
									-73.03325195312502,
									66.72817382812511
								],
								[
									-72.98535156250003,
									66.76538085937494
								],
								[
									-72.97485351562503,
									66.82851562499994
								],
								[
									-72.94677734374997,
									66.88325195312498
								],
								[
									-72.78881835937494,
									67.03061523437498
								],
								[
									-72.66772460937497,
									67.07045898437502
								],
								[
									-72.48515624999999,
									67.09809570312504
								],
								[
									-72.36494140625001,
									67.13339843750006
								],
								[
									-72.22001953124999,
									67.254296875
								],
								[
									-72.234130859375,
									67.284423828125
								],
								[
									-72.30107421874996,
									67.30727539062502
								],
								[
									-72.35288085937495,
									67.34189453124998
								],
								[
									-72.57646484374993,
									67.65864257812504
								],
								[
									-72.72529296874998,
									67.81162109375012
								],
								[
									-72.90395507812497,
									67.94477539062507
								],
								[
									-73.06342773437495,
									68.10698242187507
								],
								[
									-73.32822265624998,
									68.26674804687502
								],
								[
									-73.33144531250002,
									68.30898437500011
								],
								[
									-73.28447265624993,
									68.35698242187502
								],
								[
									-73.30688476562497,
									68.36782226562508
								],
								[
									-73.58017578124998,
									68.29775390624994
								],
								[
									-73.64448242187501,
									68.29453125000009
								],
								[
									-73.74946289062498,
									68.32499999999999
								],
								[
									-73.82050781249998,
									68.36293945312508
								],
								[
									-73.87934570312498,
									68.42939453125001
								],
								[
									-73.87333984375002,
									68.4641601562501
								],
								[
									-73.83442382812498,
									68.49707031250006
								],
								[
									-73.78251953124999,
									68.57802734375002
								],
								[
									-73.78061523437503,
									68.61928710937508
								],
								[
									-73.79843750000003,
									68.65864257812493
								],
								[
									-73.82211914062498,
									68.68598632812498
								],
								[
									-73.8515625,
									68.70136718749993
								],
								[
									-73.93515624999998,
									68.71098632812502
								],
								[
									-74.072998046875,
									68.71494140625012
								],
								[
									-74.11796875000002,
									68.70092773437509
								],
								[
									-73.96606445312497,
									68.578759765625
								],
								[
									-73.9892578125,
									68.54863281250007
								],
								[
									-74.18281249999998,
									68.53544921874996
								],
								[
									-74.2701171875,
									68.54121093749998
								],
								[
									-74.34999999999994,
									68.55605468750008
								],
								[
									-74.42241210937496,
									68.57993164062506
								],
								[
									-74.64794921875,
									68.70751953125003
								],
								[
									-74.69580078124997,
									68.75556640624995
								],
								[
									-74.68051757812495,
									68.790283203125
								],
								[
									-74.699951171875,
									68.80834960937506
								],
								[
									-74.74599609374997,
									68.79672851562506
								],
								[
									-74.80834960937497,
									68.7958984375
								],
								[
									-74.89296875,
									68.8081542968751
								],
								[
									-74.910400390625,
									68.82314453125005
								],
								[
									-74.75239257812495,
									68.89208984375006
								],
								[
									-74.74326171874995,
									68.91337890625005
								],
								[
									-74.81611328124995,
									68.93613281250006
								],
								[
									-74.92509765624996,
									68.94072265625002
								],
								[
									-74.95400390625,
									68.96108398437508
								],
								[
									-74.91728515624996,
									68.98286132812498
								],
								[
									-74.76933593749993,
									69.02065429687505
								],
								[
									-74.71669921874997,
									69.04550781249995
								],
								[
									-74.80546875000002,
									69.06425781249996
								],
								[
									-74.85488281249997,
									69.06582031250011
								],
								[
									-74.95444335937498,
									69.02460937499995
								],
								[
									-75.10424804687494,
									68.94057617187508
								],
								[
									-75.21328124999997,
									68.90937499999993
								],
								[
									-75.36274414062495,
									68.94829101562496
								],
								[
									-75.45698242187495,
									68.96127929687503
								],
								[
									-75.52265624999993,
									68.95273437499998
								],
								[
									-75.62304687499994,
									68.88774414062496
								],
								[
									-75.84223632812493,
									68.84018554687503
								],
								[
									-76.23471679687495,
									68.72802734375003
								],
								[
									-76.40341796874995,
									68.69233398437504
								],
								[
									-76.58505859375,
									68.69873046875
								],
								[
									-76.61943359374999,
									68.72138671875001
								],
								[
									-76.61625976562496,
									68.75986328125003
								],
								[
									-76.603662109375,
									68.79155273437507
								],
								[
									-76.58173828124995,
									68.81630859375008
								],
								[
									-76.574560546875,
									68.84667968749994
								],
								[
									-76.58769531250002,
									68.97446289062503
								],
								[
									-76.55722656250003,
									69.00947265624998
								],
								[
									-76.49516601562499,
									69.030419921875
								],
								[
									-76.38090820312499,
									69.05244140625004
								],
								[
									-76.08920898437498,
									69.02617187500002
								],
								[
									-75.9537109375,
									69.03081054687507
								],
								[
									-75.85859374999998,
									69.06030273437494
								],
								[
									-75.76337890624995,
									69.10292968750002
								],
								[
									-75.66796874999997,
									69.15883789062505
								],
								[
									-75.64775390625002,
									69.21254882812497
								],
								[
									-75.74907226562496,
									69.29956054687503
								],
								[
									-75.78715820312499,
									69.3186523437501
								],
								[
									-76.04648437499998,
									69.38637695312494
								],
								[
									-76.18979492187495,
									69.41098632812498
								],
								[
									-76.31621093749996,
									69.42163085937503
								],
								[
									-76.407958984375,
									69.44111328125007
								],
								[
									-76.46494140624998,
									69.46943359374998
								],
								[
									-76.52036132812498,
									69.5166015625
								],
								[
									-76.52495117187502,
									69.54868164062506
								],
								[
									-76.51611328125,
									69.59091796875003
								],
								[
									-76.46328125,
									69.61997070312509
								],
								[
									-76.23110351562502,
									69.653466796875
								],
								[
									-76.23408203125001,
									69.66210937500009
								],
								[
									-76.42382812500003,
									69.68681640624996
								],
								[
									-76.51328124999995,
									69.68393554687509
								],
								[
									-76.59003906249995,
									69.65624999999994
								],
								[
									-76.6865234375,
									69.59125976562504
								],
								[
									-76.742333984375,
									69.57290039062502
								],
								[
									-76.91557617187502,
									69.611181640625
								],
								[
									-77.01962890625,
									69.616845703125
								],
								[
									-77.08994140625,
									69.63510742187509
								],
								[
									-77.12880859374994,
									69.65273437499994
								],
								[
									-77.105078125,
									69.67075195312506
								],
								[
									-77.018701171875,
									69.68906250000006
								],
								[
									-76.86860351562495,
									69.74516601562513
								],
								[
									-76.85859374999995,
									69.77539062499997
								],
								[
									-76.96225585937503,
									69.82485351562511
								],
								[
									-77.01596679687495,
									69.8361328125001
								],
								[
									-77.23247070312502,
									69.85458984375003
								],
								[
									-77.49428710937497,
									69.83623046875002
								],
								[
									-77.591650390625,
									69.84560546875005
								],
								[
									-77.63530273437502,
									69.90043945312496
								],
								[
									-77.66298828124997,
									69.96572265624994
								],
								[
									-77.67475585937495,
									70.04150390625
								],
								[
									-77.72192382812497,
									70.17080078124997
								],
								[
									-77.77402343750003,
									70.238525390625
								],
								[
									-77.84252929687494,
									70.24707031250006
								],
								[
									-78.15678710937493,
									70.21914062500005
								],
								[
									-78.23144531249997,
									70.21879882812507
								],
								[
									-78.28281250000003,
									70.22915039062505
								],
								[
									-78.49072265625003,
									70.31557617187505
								],
								[
									-78.5748046875,
									70.34619140625
								],
								[
									-78.621435546875,
									70.35341796875005
								],
								[
									-78.77265624999998,
									70.44531249999994
								],
								[
									-78.83085937499996,
									70.4631835937501
								],
								[
									-78.89990234374997,
									70.50854492187494
								],
								[
									-78.97978515625002,
									70.58134765625013
								],
								[
									-79.06640624999997,
									70.6035644531251
								],
								[
									-79.15976562499998,
									70.57524414062513
								],
								[
									-79.253173828125,
									70.53471679687513
								],
								[
									-79.34663085937495,
									70.48188476562493
								],
								[
									-79.39731445312498,
									70.43725585937509
								],
								[
									-79.40522460937498,
									70.400732421875
								],
								[
									-79.34741210937503,
									70.37231445312509
								],
								[
									-79.01752929687495,
									70.32519531250006
								],
								[
									-78.93383789062497,
									70.29370117187506
								],
								[
									-78.86284179687499,
									70.24189453125007
								],
								[
									-78.80981445312503,
									70.17856445312495
								],
								[
									-78.77485351562501,
									70.10361328125003
								],
								[
									-78.77783203124997,
									70.04765625000002
								],
								[
									-78.81879882812498,
									70.01044921874998
								],
								[
									-78.88964843750003,
									69.97749023437493
								],
								[
									-79.09287109375003,
									69.92534179687496
								],
								[
									-79.3033203125,
									69.89482421874996
								],
								[
									-79.51542968749996,
									69.88759765625008
								],
								[
									-79.61591796875001,
									69.89472656250004
								],
								[
									-80.162109375,
									69.99599609374997
								],
								[
									-80.26040039062497,
									69.99677734374995
								],
								[
									-80.38681640625003,
									70.01044921874998
								],
								[
									-80.67031249999997,
									70.05209960937495
								],
								[
									-80.82578125000003,
									70.05664062500006
								],
								[
									-81.09829101562494,
									70.09116210937509
								],
								[
									-81.55957031249994,
									70.11123046875
								],
								[
									-81.65195312500003,
									70.09462890625
								],
								[
									-81.52924804687498,
									70.04804687500001
								],
								[
									-81.42172851562503,
									70.02460937500004
								],
								[
									-81.32949218749997,
									70.02436523437498
								],
								[
									-81.19682617187496,
									69.98281250000005
								],
								[
									-81.02373046874993,
									69.89999999999995
								],
								[
									-80.92480468749994,
									69.85058593750011
								],
								[
									-80.84287109374995,
									69.791650390625
								],
								[
									-80.84028320312495,
									69.77138671875005
								],
								[
									-80.92172851562503,
									69.73090820312507
								],
								[
									-81.56469726562503,
									69.94272460937495
								],
								[
									-81.95771484374998,
									69.86874999999998
								],
								[
									-82.13872070312499,
									69.84121093749997
								],
								[
									-82.29384765624997,
									69.83691406250006
								],
								[
									-82.48774414062495,
									69.86596679687494
								],
								[
									-82.92539062500003,
									69.96816406250008
								],
								[
									-83.09116210937495,
									70.00390625000009
								],
								[
									-83.14995117187496,
									70.00908203125007
								],
								[
									-83.53076171875,
									69.96479492187493
								],
								[
									-83.85908203125001,
									69.96274414062495
								],
								[
									-84.52187500000002,
									70.00522460937506
								],
								[
									-84.76513671875003,
									70.03364257812501
								],
								[
									-84.82919921875,
									70.063330078125
								],
								[
									-84.90908203124994,
									70.07822265625003
								],
								[
									-85.05263671874997,
									70.07822265625003
								],
								[
									-85.43237304687497,
									70.11137695312513
								],
								[
									-85.78002929687503,
									70.03666992187507
								],
								[
									-86.19819335937495,
									70.105126953125
								],
								[
									-86.32202148437503,
									70.14541015625002
								],
								[
									-86.36142578124998,
									70.17304687499998
								],
								[
									-86.48310546874998,
									70.28857421875006
								],
								[
									-86.49980468750002,
									70.35039062499996
								],
								[
									-86.46538085937502,
									70.40624999999997
								],
								[
									-86.43100585937503,
									70.44453124999995
								],
								[
									-86.396875,
									70.46533203125003
								],
								[
									-86.62431640624999,
									70.40126953124994
								],
								[
									-86.70415039062499,
									70.39072265625
								],
								[
									-86.80927734375001,
									70.38828124999995
								],
								[
									-87.12246093749994,
									70.41196289062498
								],
								[
									-87.17197265625,
									70.39985351562501
								],
								[
									-87.15581054687499,
									70.37744140624997
								],
								[
									-87.07402343749993,
									70.34482421874998
								],
								[
									-87.06328124999996,
									70.32509765624997
								],
								[
									-87.237890625,
									70.30971679687494
								],
								[
									-87.50244140625,
									70.32568359375009
								],
								[
									-87.61777343749995,
									70.31875
								],
								[
									-87.67021484374999,
									70.30981445312506
								],
								[
									-87.78945312500002,
									70.25825195312493
								],
								[
									-87.838134765625,
									70.24658203125003
								],
								[
									-87.90068359374996,
									70.25190429687507
								],
								[
									-88.17832031250003,
									70.36860351562504
								],
								[
									-88.40209960937497,
									70.44248046874998
								],
								[
									-88.66298828125,
									70.470849609375
								],
								[
									-88.78271484374997,
									70.494482421875
								],
								[
									-88.84843749999993,
									70.52290039062501
								],
								[
									-89.20830078124999,
									70.75971679687495
								],
								[
									-89.25751953124998,
									70.81069335937502
								],
								[
									-89.37153320312493,
									70.99614257812507
								],
								[
									-89.409765625,
									71.03569335937496
								],
								[
									-89.45590820312498,
									71.06171874999993
								],
								[
									-89.36552734374996,
									71.06718750000007
								],
								[
									-89.02514648437497,
									71.0446289062501
								],
								[
									-88.695654296875,
									71.04560546874993
								],
								[
									-88.51665039062493,
									71.03056640625007
								],
								[
									-88.30908203125003,
									70.98432617187507
								],
								[
									-88.03857421874997,
									70.951318359375
								],
								[
									-87.84492187499995,
									70.9443847656251
								],
								[
									-87.53442382812503,
									70.9565917968751
								],
								[
									-87.18159179687501,
									70.987548828125
								],
								[
									-87.14008789062498,
									71.01162109374994
								],
								[
									-87.36860351562501,
									71.05283203124998
								],
								[
									-87.57231445312502,
									71.10756835937494
								],
								[
									-87.76025390625003,
									71.1785156250001
								],
								[
									-87.87246093749997,
									71.20854492187507
								],
								[
									-88.06064453125003,
									71.22724609374998
								],
								[
									-88.58950195312494,
									71.24028320312507
								],
								[
									-89.079345703125,
									71.287939453125
								],
								[
									-89.41767578125001,
									71.35219726562505
								],
								[
									-89.69331054687493,
									71.423486328125
								],
								[
									-89.80537109374995,
									71.46230468750008
								],
								[
									-89.84575195312499,
									71.49228515624998
								],
								[
									-89.888525390625,
									71.58574218750002
								],
								[
									-89.93369140624998,
									71.74272460937502
								],
								[
									-89.97734374999999,
									71.84804687500008
								],
								[
									-90.01953124999997,
									71.90180664062493
								],
								[
									-90.02519531249996,
									71.94877929687499
								],
								[
									-89.93149414062498,
									72.04902343749998
								],
								[
									-89.66381835937497,
									72.15795898437497
								],
								[
									-89.65727539062496,
									72.17504882812509
								],
								[
									-89.71054687499998,
									72.18012695312495
								],
								[
									-89.82290039062497,
									72.2078125000001
								],
								[
									-89.85869140624996,
									72.2483398437501
								],
								[
									-89.87309570312496,
									72.31264648437505
								],
								[
									-89.87402343749997,
									72.36718749999997
								],
								[
									-89.86152343750001,
									72.41191406250002
								],
								[
									-89.81684570312498,
									72.46772460937493
								],
								[
									-89.701513671875,
									72.56806640625004
								],
								[
									-89.53642578124996,
									72.68984375000005
								],
								[
									-89.35771484374996,
									72.80415039062507
								],
								[
									-89.32709960937493,
									72.84155273437497
								],
								[
									-89.31137695312503,
									72.94296875000003
								],
								[
									-89.2876953125,
									73.016943359375
								],
								[
									-89.26323242187499,
									73.06899414062502
								],
								[
									-89.225341796875,
									73.108056640625
								],
								[
									-89.11474609375003,
									73.1821777343751
								],
								[
									-88.97680664062497,
									73.2524902343751
								],
								[
									-88.76093749999998,
									73.31240234375005
								],
								[
									-88.74252929687503,
									73.33457031250006
								],
								[
									-88.73959960937498,
									73.3652832031251
								],
								[
									-88.7271484375,
									73.38818359375006
								],
								[
									-88.70517578124998,
									73.40327148437493
								],
								[
									-88.17001953125003,
									73.59531250000006
								],
								[
									-87.92641601562497,
									73.67333984374997
								],
								[
									-87.71977539062496,
									73.72290039062494
								],
								[
									-87.47236328125001,
									73.75942382812511
								],
								[
									-86.76875000000001,
									73.83398437500009
								],
								[
									-86.406396484375,
									73.85478515624999
								],
								[
									-85.95078124999998,
									73.85014648437502
								],
								[
									-85.11049804687494,
									73.80815429687499
								],
								[
									-85.00932617187493,
									73.7786132812501
								],
								[
									-84.98359374999995,
									73.76372070312499
								],
								[
									-84.94677734375,
									73.72163085937504
								],
								[
									-84.97451171874997,
									73.69477539062498
								],
								[
									-85.20429687499995,
									73.60356445312496
								],
								[
									-85.49360351562501,
									73.52768554687503
								],
								[
									-85.681884765625,
									73.46147460937505
								],
								[
									-86.00053710937499,
									73.3125488281251
								],
								[
									-86.08647460937502,
									73.26025390625009
								],
								[
									-86.48139648437498,
									72.96025390625007
								],
								[
									-86.57465820312498,
									72.910546875
								],
								[
									-86.62934570312493,
									72.87080078124998
								],
								[
									-86.66777343749996,
									72.76254882812495
								],
								[
									-86.65629882812502,
									72.72402343750011
								],
								[
									-86.59462890624997,
									72.66113281250009
								],
								[
									-86.38032226562501,
									72.52465820312509
								],
								[
									-86.32255859374996,
									72.46083984375005
								],
								[
									-86.32402343749999,
									72.40214843749999
								],
								[
									-86.348046875,
									72.26225585937499
								],
								[
									-86.3509765625,
									72.19130859375002
								],
								[
									-86.34135742187499,
									72.123193359375
								],
								[
									-86.29716796874993,
									72.02578125000005
								],
								[
									-86.21845703124998,
									71.8991210937501
								],
								[
									-86.03613281249997,
									71.7709472656251
								],
								[
									-85.75009765624995,
									71.64135742187497
								],
								[
									-85.53715820312502,
									71.55541992187497
								],
								[
									-85.32719726562496,
									71.49213867187495
								],
								[
									-85.07871093749995,
									71.39848632812505
								],
								[
									-85.02338867187495,
									71.35322265624998
								],
								[
									-85.13759765624997,
									71.30341796875004
								],
								[
									-85.40537109374998,
									71.22675781249998
								],
								[
									-85.75727539062501,
									71.19394531249995
								],
								[
									-85.94541015624995,
									71.16264648437507
								],
								[
									-86.17944335937503,
									71.09589843750004
								],
								[
									-86.47324218750003,
									71.04262695312502
								],
								[
									-86.58935546874997,
									71.01079101562513
								]
							]
						],
						[
							[
								[
									-100.00190429687498,
									73.94589843749998
								],
								[
									-99.157958984375,
									73.73159179687494
								],
								[
									-99.03964843749996,
									73.74926757812506
								],
								[
									-98.78452148437503,
									73.76054687500005
								],
								[
									-98.51933593750002,
									73.79208984375
								],
								[
									-98.15185546875003,
									73.81821289062509
								],
								[
									-97.927734375,
									73.8657714843751
								],
								[
									-97.832177734375,
									73.87934570312493
								],
								[
									-97.66997070312499,
									73.88774414062505
								],
								[
									-97.58183593749996,
									73.88754882812509
								],
								[
									-97.32705078125002,
									73.8618652343751
								],
								[
									-97.22475585937497,
									73.84379882812496
								],
								[
									-97.1705078125,
									73.82485351562502
								],
								[
									-97.11171874999994,
									73.79033203125007
								],
								[
									-97.01127929687499,
									73.70615234375009
								],
								[
									-96.99658203125003,
									73.67490234375012
								],
								[
									-97.001708984375,
									73.66650390625
								],
								[
									-97.094580078125,
									73.61474609375003
								],
								[
									-97.156396484375,
									73.59218750000005
								],
								[
									-97.2841796875,
									73.57075195312504
								],
								[
									-97.39477539062497,
									73.56420898437494
								],
								[
									-97.48979492187496,
									73.526611328125
								],
								[
									-97.59697265624996,
									73.53662109375
								],
								[
									-97.62587890624997,
									73.50229492187503
								],
								[
									-97.61459960937498,
									73.48134765624994
								],
								[
									-97.58583984375,
									73.47114257812498
								],
								[
									-97.5318359375,
									73.47358398437495
								],
								[
									-97.47011718749994,
									73.48823242187501
								],
								[
									-97.35029296874995,
									73.48095703124994
								],
								[
									-97.28710937499997,
									73.45844726562507
								],
								[
									-97.23037109374997,
									73.42128906250005
								],
								[
									-97.27250976562502,
									73.38681640624995
								],
								[
									-97.48408203124995,
									73.33920898437512
								],
								[
									-97.79589843749997,
									73.28530273437497
								],
								[
									-98.17583007812502,
									73.11577148437507
								],
								[
									-98.37558593750003,
									73.04467773437497
								],
								[
									-98.416845703125,
									73.02250976562507
								],
								[
									-98.43696289062501,
									73.00024414062497
								],
								[
									-98.43090820312503,
									72.95805664062499
								],
								[
									-98.42177734375002,
									72.94101562500006
								],
								[
									-98.36665039062498,
									72.9341308593751
								],
								[
									-98.18081054687497,
									72.99306640624994
								],
								[
									-98.06103515625,
									73.02050781250011
								],
								[
									-97.93940429687498,
									73.03559570312498
								],
								[
									-97.72480468749995,
									73.03666992187502
								],
								[
									-97.63632812499998,
									73.02763671874996
								],
								[
									-97.47568359375,
									72.99228515624995
								],
								[
									-97.32875976562502,
									72.93784179687506
								],
								[
									-97.29584960937498,
									72.9180175781251
								],
								[
									-97.309912109375,
									72.89814453124995
								],
								[
									-97.37099609375,
									72.87812500000004
								],
								[
									-97.37768554687494,
									72.86494140625004
								],
								[
									-97.23759765625002,
									72.8374511718751
								],
								[
									-97.08300781249994,
									72.76284179687502
								],
								[
									-97.07290039062502,
									72.71757812500013
								],
								[
									-97.14047851562503,
									72.67275390625005
								],
								[
									-97.15893554687497,
									72.64277343749998
								],
								[
									-97.12812500000001,
									72.627587890625
								],
								[
									-97.05180664062499,
									72.63681640625
								],
								[
									-96.86904296874997,
									72.68701171875003
								],
								[
									-96.67128906250002,
									72.71318359375002
								],
								[
									-96.59208984374996,
									72.71025390624996
								],
								[
									-96.54208984374998,
									72.69873046875009
								],
								[
									-96.48920898437495,
									72.62988281250011
								],
								[
									-96.44560546874996,
									72.55244140624995
								],
								[
									-96.44013671874998,
									72.48730468750011
								],
								[
									-96.47285156249998,
									72.43437500000007
								],
								[
									-96.51987304687498,
									72.3931152343751
								],
								[
									-96.63828125000003,
									72.342041015625
								],
								[
									-96.74550781249994,
									72.32260742187495
								],
								[
									-96.80146484374998,
									72.322412109375
								],
								[
									-96.7958984375,
									72.3137695312501
								],
								[
									-96.66874999999993,
									72.27124023437506
								],
								[
									-96.61557617187503,
									72.23725585937504
								],
								[
									-96.59287109375003,
									72.20449218750005
								],
								[
									-96.6005859375,
									72.17285156250009
								],
								[
									-96.61811523437501,
									72.14589843750008
								],
								[
									-96.76630859375001,
									72.04594726562507
								],
								[
									-96.75830078124997,
									72.03168945312501
								],
								[
									-96.71728515624997,
									72.025146484375
								],
								[
									-96.62436523437495,
									71.9675781250001
								],
								[
									-96.61342773437494,
									71.83383789062512
								],
								[
									-96.94648437499995,
									71.79189453125008
								],
								[
									-97.02465820312497,
									71.76074218750006
								],
								[
									-97.11669921874997,
									71.71083984375011
								],
								[
									-97.22221679687499,
									71.67348632812505
								],
								[
									-97.46123046875002,
									71.63422851562504
								],
								[
									-97.58227539062497,
									71.62968750000007
								],
								[
									-98.18134765624998,
									71.662451171875
								],
								[
									-98.24194335937497,
									71.68149414062498
								],
								[
									-98.28388671875001,
									71.71552734374998
								],
								[
									-98.30708007812493,
									71.76450195312512
								],
								[
									-98.31337890624997,
									71.80307617187498
								],
								[
									-98.30268554687501,
									71.83110351562507
								],
								[
									-98.30581054687502,
									71.84755859375005
								],
								[
									-98.32270507812501,
									71.85234375000007
								],
								[
									-98.389306640625,
									71.8242675781251
								],
								[
									-98.45883789062503,
									71.77319335937511
								],
								[
									-98.42080078125,
									71.71650390624993
								],
								[
									-98.23144531249997,
									71.55893554687498
								],
								[
									-98.1953125,
									71.49121093749994
								],
								[
									-98.19013671875001,
									71.46245117187513
								],
								[
									-98.19863281249997,
									71.44086914062498
								],
								[
									-98.41230468749995,
									71.34882812499998
								],
								[
									-98.53593750000002,
									71.31762695312511
								],
								[
									-98.66289062499993,
									71.30209960937506
								],
								[
									-98.783837890625,
									71.31367187499993
								],
								[
									-98.89877929687495,
									71.35234374999999
								],
								[
									-98.98623046875001,
									71.369482421875
								],
								[
									-99.167138671875,
									71.36718750000009
								],
								[
									-99.22363281249996,
									71.38710937499997
								],
								[
									-99.276171875,
									71.42421874999997
								],
								[
									-99.40366210937496,
									71.55717773437505
								],
								[
									-99.58144531250002,
									71.65156249999993
								],
								[
									-99.73471679687499,
									71.75722656250005
								],
								[
									-100.12412109375,
									71.91152343750005
								],
								[
									-100.32568359374994,
									72.00385742187493
								],
								[
									-100.594482421875,
									72.15234375000009
								],
								[
									-100.70683593749997,
									72.1859375
								],
								[
									-100.80019531249998,
									72.19941406249998
								],
								[
									-100.98364257812497,
									72.21005859375012
								],
								[
									-101.02622070312502,
									72.22856445312505
								],
								[
									-101.09311523437498,
									72.27905273437503
								],
								[
									-101.20854492187496,
									72.31699218749995
								],
								[
									-101.25068359375001,
									72.32177734375003
								],
								[
									-101.31870117187502,
									72.31284179687509
								],
								[
									-101.49833984375002,
									72.27788085937507
								],
								[
									-101.72392578124997,
									72.31489257812507
								],
								[
									-101.77451171874998,
									72.34091796874995
								],
								[
									-101.80444335937503,
									72.38505859374996
								],
								[
									-101.83291015624997,
									72.40927734375009
								],
								[
									-101.909326171875,
									72.43105468750011
								],
								[
									-101.97368164062496,
									72.48613281250005
								],
								[
									-102.40224609374997,
									72.59472656250006
								],
								[
									-102.657080078125,
									72.71943359375004
								],
								[
									-102.70874023437496,
									72.76450195312509
								],
								[
									-102.71367187499999,
									72.78291015624993
								],
								[
									-102.68749999999999,
									72.84282226562496
								],
								[
									-102.62846679687495,
									72.91079101562505
								],
								[
									-102.55107421874999,
									72.97827148437494
								],
								[
									-102.50380859374995,
									73.00590820312507
								],
								[
									-102.3361328125,
									73.06411132812502
								],
								[
									-102.20400390624998,
									73.07729492187505
								],
								[
									-102.01962890624999,
									73.06992187500003
								],
								[
									-101.9224609375,
									73.05698242187506
								],
								[
									-101.83540039062503,
									73.01801757812495
								],
								[
									-101.79804687499997,
									72.97309570312495
								],
								[
									-101.754541015625,
									72.9428222656251
								],
								[
									-101.61777343750002,
									72.9097167968751
								],
								[
									-101.54360351562501,
									72.88305664062509
								],
								[
									-101.434619140625,
									72.82104492187497
								],
								[
									-101.35058593750003,
									72.74628906249993
								],
								[
									-101.27319335937499,
									72.72167968749997
								],
								[
									-101.08759765625001,
									72.71328125000005
								],
								[
									-100.89604492187497,
									72.72592773437495
								],
								[
									-100.48476562500002,
									72.77294921874994
								],
								[
									-100.46801757812499,
									72.77880859375006
								],
								[
									-100.44257812499995,
									72.80683593750001
								],
								[
									-100.395703125,
									72.97700195312504
								],
								[
									-100.36752929687495,
									72.97773437500001
								],
								[
									-100.22792968750002,
									72.89892578124994
								],
								[
									-100.18833007812495,
									72.89028320312505
								],
								[
									-100.12812500000003,
									72.90668945312493
								],
								[
									-100.09238281250002,
									72.944970703125
								],
								[
									-100.09672851562502,
									72.96313476562506
								],
								[
									-100.18447265624995,
									73.05532226562508
								],
								[
									-100.236181640625,
									73.0954101562501
								],
								[
									-100.28266601562498,
									73.12031249999993
								],
								[
									-100.33437499999994,
									73.12846679687499
								],
								[
									-100.44619140624998,
									73.12055664062507
								],
								[
									-100.53139648437502,
									73.13828125000003
								],
								[
									-100.55019531249995,
									73.16372070312497
								],
								[
									-100.53637695312497,
									73.19785156250009
								],
								[
									-100.48930664062497,
									73.23393554687507
								],
								[
									-100.43881835937499,
									73.25458984374993
								],
								[
									-100.34072265625,
									73.26518554687505
								],
								[
									-100.22587890624996,
									73.25468750000013
								],
								[
									-100.0669921875,
									73.21108398437494
								],
								[
									-99.96640624999993,
									73.20141601562511
								],
								[
									-99.82514648437503,
									73.21386718749997
								],
								[
									-100.00590820312499,
									73.23950195312506
								],
								[
									-100.25795898437501,
									73.34023437499997
								],
								[
									-100.36611328125001,
									73.35903320312497
								],
								[
									-100.49799804687497,
									73.31582031249997
								],
								[
									-100.58701171874999,
									73.29956054687503
								],
								[
									-100.755322265625,
									73.278466796875
								],
								[
									-100.88935546875003,
									73.27534179687507
								],
								[
									-101.45087890625003,
									73.43095703125005
								],
								[
									-101.482080078125,
									73.44584960937499
								],
								[
									-101.52319335937501,
									73.48637695312507
								],
								[
									-101.51845703124994,
									73.50502929687497
								],
								[
									-101.46303710937502,
									73.53383789062497
								],
								[
									-101.32314453124994,
									73.57197265624993
								],
								[
									-101.11494140624998,
									73.595849609375
								],
								[
									-100.97578124999997,
									73.59975585937508
								],
								[
									-100.85410156249995,
									73.57128906250006
								],
								[
									-100.67680664062499,
									73.494287109375
								],
								[
									-100.5216796875,
									73.44931640624998
								],
								[
									-100.50893554687498,
									73.46547851562508
								],
								[
									-100.53632812499997,
									73.50971679687504
								],
								[
									-100.60712890625,
									73.5753906250001
								],
								[
									-100.65791015624995,
									73.59335937500009
								],
								[
									-100.78271484374997,
									73.61293945312511
								],
								[
									-100.89824218749997,
									73.65805664062506
								],
								[
									-100.95258789062494,
									73.69140625
								],
								[
									-100.98154296874998,
									73.72719726562502
								],
								[
									-100.985107421875,
									73.76533203125007
								],
								[
									-100.96298828125002,
									73.79140625000005
								],
								[
									-100.91513671874995,
									73.80537109374995
								],
								[
									-100.48364257812497,
									73.843505859375
								],
								[
									-100.18232421874997,
									73.80126953125
								],
								[
									-99.99111328125,
									73.795166015625
								],
								[
									-99.91186523437501,
									73.847021484375
								],
								[
									-99.93950195312496,
									73.85712890624993
								],
								[
									-100.04008789062495,
									73.84379882812496
								],
								[
									-100.15380859375001,
									73.84409179687503
								],
								[
									-100.2248046875,
									73.87250976562495
								],
								[
									-100.22705078125001,
									73.88911132812495
								],
								[
									-100.1384765625,
									73.92885742187505
								],
								[
									-100.00190429687498,
									73.94589843749998
								]
							]
						],
						[
							[
								[
									-98.270361328125,
									73.86850585937503
								],
								[
									-98.55820312500003,
									73.84741210937509
								],
								[
									-98.691064453125,
									73.85649414062507
								],
								[
									-98.76137695312502,
									73.82885742187494
								],
								[
									-98.8166015625,
									73.81713867187503
								],
								[
									-98.97392578124999,
									73.81206054687499
								],
								[
									-99.29804687500003,
									73.86196289062494
								],
								[
									-99.38515625000001,
									73.87929687500008
								],
								[
									-99.41699218750001,
									73.89541015625
								],
								[
									-99.40380859374999,
									73.91088867187506
								],
								[
									-99.34560546874994,
									73.92573242187495
								],
								[
									-99.09687499999998,
									73.9482910156251
								],
								[
									-99.00468749999995,
									73.96494140624995
								],
								[
									-98.96669921875002,
									73.98818359375008
								],
								[
									-98.90449218749995,
									74.00688476562507
								],
								[
									-98.81816406249996,
									74.02099609375
								],
								[
									-98.58496093749997,
									74.034521484375
								],
								[
									-98.06103515625,
									74.10468750000001
								],
								[
									-97.80043945312502,
									74.1146484375
								],
								[
									-97.69824218749997,
									74.10869140625002
								],
								[
									-97.66743164062501,
									74.09013671875005
								],
								[
									-97.65913085937501,
									74.07163085937512
								],
								[
									-97.67333984374997,
									74.05302734374996
								],
								[
									-97.75473632812503,
									74.00551757812497
								],
								[
									-97.86108398437503,
									73.96845703124995
								],
								[
									-98.14697265625,
									73.888818359375
								],
								[
									-98.270361328125,
									73.86850585937503
								]
							]
						],
						[
							[
								[
									-93.17084960937498,
									74.16098632812509
								],
								[
									-92.77802734374998,
									74.11372070312498
								],
								[
									-92.58681640625002,
									74.08271484375007
								],
								[
									-92.49282226562497,
									74.06206054687502
								],
								[
									-92.31386718750002,
									73.99238281249995
								],
								[
									-92.22270507812502,
									73.97236328124995
								],
								[
									-91.87416992187497,
									74.01279296875012
								],
								[
									-91.63041992187496,
									74.02778320312507
								],
								[
									-91.08798828125003,
									74.00927734375011
								],
								[
									-90.62744140625,
									73.95170898437502
								],
								[
									-90.45800781250003,
									73.90839843749998
								],
								[
									-90.35458984375,
									73.86865234374997
								],
								[
									-90.38139648437496,
									73.82475585937499
								],
								[
									-90.466162109375,
									73.75385742187504
								],
								[
									-90.565576171875,
									73.68642578124997
								],
								[
									-90.76455078124997,
									73.58061523437499
								],
								[
									-90.93369140625003,
									73.52768554687503
								],
								[
									-90.97548828125002,
									73.50229492187503
								],
								[
									-91.001953125,
									73.46708984374996
								],
								[
									-91.06762695312497,
									73.41552734375003
								],
								[
									-91.24931640624996,
									73.30400390625005
								],
								[
									-91.29780273437495,
									73.28491210937497
								],
								[
									-91.55371093749997,
									73.23608398437497
								],
								[
									-91.46601562499995,
									73.21420898437495
								],
								[
									-91.42592773437497,
									73.19487304687502
								],
								[
									-91.459619140625,
									73.14536132812506
								],
								[
									-91.62099609375,
									73.02587890625006
								],
								[
									-91.78833007812497,
									72.915380859375
								],
								[
									-91.90532226562502,
									72.84931640624995
								],
								[
									-92.11791992187497,
									72.75380859375005
								],
								[
									-92.23491210937502,
									72.72680664062506
								],
								[
									-92.39194335937503,
									72.71845703125004
								],
								[
									-93.34062499999993,
									72.80185546875006
								],
								[
									-93.57866210937493,
									72.80053710937497
								],
								[
									-94.21132812499997,
									72.75693359375006
								],
								[
									-94.15170898437498,
									72.73564453125007
								],
								[
									-93.92001953125003,
									72.70336914062497
								],
								[
									-93.77055664062496,
									72.66821289062509
								],
								[
									-93.57226562499997,
									72.55864257812507
								],
								[
									-93.54648437499995,
									72.5312988281251
								],
								[
									-93.53393554687497,
									72.49946289062501
								],
								[
									-93.54160156250003,
									72.43701171875006
								],
								[
									-93.55517578124994,
									72.42114257812494
								],
								[
									-93.87060546875,
									72.25263671874998
								],
								[
									-93.97255859375,
									72.12998046875003
								],
								[
									-94.03754882812498,
									72.02875976562504
								],
								[
									-94.14374999999995,
									72.00083007812503
								],
								[
									-94.49716796875,
									72.04360351562502
								],
								[
									-94.61123046875,
									72.04233398437495
								],
								[
									-95.00786132812496,
									72.01279296874998
								],
								[
									-95.19296875,
									72.02744140625003
								],
								[
									-95.16679687500002,
									72.18002929687503
								],
								[
									-95.19267578124996,
									72.34477539062502
								],
								[
									-95.25102539062493,
									72.50195312499997
								],
								[
									-95.54760742187497,
									72.7815429687501
								],
								[
									-95.58032226562497,
									72.83115234375006
								],
								[
									-95.60214843749998,
									72.88447265624993
								],
								[
									-95.61318359375,
									72.94160156249993
								],
								[
									-95.61220703125,
									72.9990722656251
								],
								[
									-95.59160156249996,
									73.11528320312496
								],
								[
									-95.58925781250002,
									73.17416992187506
								],
								[
									-95.60410156250003,
									73.32773437500009
								],
								[
									-95.64423828124993,
									73.55747070312506
								],
								[
									-95.64799804687499,
									73.63852539062498
								],
								[
									-95.64526367187497,
									73.67080078125008
								],
								[
									-95.63291015625003,
									73.69545898437494
								],
								[
									-95.56943359374998,
									73.72817382812502
								],
								[
									-95.447412109375,
									73.75166015625001
								],
								[
									-95.385986328125,
									73.75512695312503
								],
								[
									-94.99614257812499,
									73.68574218750001
								],
								[
									-94.81684570312495,
									73.66254882812498
								],
								[
									-94.697607421875,
									73.66357421875003
								],
								[
									-94.69101562499998,
									73.67143554687502
								],
								[
									-94.79716796874993,
									73.68608398437499
								],
								[
									-94.89692382812501,
									73.71601562499995
								],
								[
									-95.05947265625,
									73.80507812500008
								],
								[
									-95.13413085937503,
									73.88125000000005
								],
								[
									-95.14902343750003,
									73.90639648437502
								],
								[
									-95.15258789062497,
									73.93276367187497
								],
								[
									-95.14477539062497,
									73.96030273437506
								],
								[
									-95.12119140624995,
									73.98505859375007
								],
								[
									-95.03984374999999,
									74.02387695312507
								],
								[
									-94.97353515625,
									74.04140625
								],
								[
									-94.72895507812498,
									74.08598632812502
								],
								[
									-94.48256835937497,
									74.11313476562495
								],
								[
									-93.93881835937495,
									74.13159179687497
								],
								[
									-93.78461914062498,
									74.11835937500004
								],
								[
									-93.54921875,
									74.16713867187494
								],
								[
									-93.41030273437502,
									74.17875976562499
								],
								[
									-93.17084960937498,
									74.16098632812509
								]
							]
						],
						[
							[
								[
									-119.73632812499999,
									74.11264648437503
								],
								[
									-119.728564453125,
									74.10844726562505
								],
								[
									-119.47109374999995,
									74.20122070312505
								],
								[
									-119.31484375,
									74.2062500000001
								],
								[
									-119.20595703125002,
									74.197998046875
								],
								[
									-119.171435546875,
									74.186181640625
								],
								[
									-119.149609375,
									74.16787109375
								],
								[
									-119.13876953125,
									74.12758789062497
								],
								[
									-119.13188476562495,
									74.02788085937499
								],
								[
									-119.11796874999995,
									74.01552734375005
								],
								[
									-119.08251953125001,
									74.02119140624995
								],
								[
									-119.02568359374997,
									74.04472656249996
								],
								[
									-118.744140625,
									74.19208984374995
								],
								[
									-118.62529296874995,
									74.23251953125012
								],
								[
									-118.54399414062499,
									74.24462890625
								],
								[
									-118.199658203125,
									74.26674804687508
								],
								[
									-117.96586914062497,
									74.26606445312493
								],
								[
									-117.70747070312501,
									74.25234375000005
								],
								[
									-117.51484375000003,
									74.23173828125005
								],
								[
									-117.19882812500003,
									74.17114257812503
								],
								[
									-116.95039062499995,
									74.10141601562503
								],
								[
									-116.72236328124995,
									74.02714843750002
								],
								[
									-115.95771484374995,
									73.74794921875008
								],
								[
									-115.63432617187497,
									73.66552734374997
								],
								[
									-115.51069335937501,
									73.61874999999995
								],
								[
									-115.45566406249999,
									73.58466796874993
								],
								[
									-115.40751953124996,
									73.54189453125011
								],
								[
									-115.39282226562499,
									73.50195312500006
								],
								[
									-115.41157226562498,
									73.46479492187501
								],
								[
									-115.44687499999998,
									73.43886718750008
								],
								[
									-115.52446289062497,
									73.416748046875
								],
								[
									-115.99228515624999,
									73.32324218750006
								],
								[
									-116.23862304687499,
									73.29458007812508
								],
								[
									-116.48251953125003,
									73.25322265625007
								],
								[
									-117.06542968750003,
									73.10727539062512
								],
								[
									-117.46445312499996,
									73.03774414062505
								],
								[
									-117.98320312499996,
									72.90219726562498
								],
								[
									-118.96157226562497,
									72.68413085937496
								],
								[
									-119.07797851562498,
									72.64033203124993
								],
								[
									-119.13154296874995,
									72.60883789062507
								],
								[
									-119.40776367187502,
									72.3604003906251
								],
								[
									-119.51284179687501,
									72.30268554687507
								],
								[
									-119.76748046875002,
									72.24384765625007
								],
								[
									-120.08974609374995,
									72.229150390625
								],
								[
									-120.17988281250001,
									72.21264648437511
								],
								[
									-120.19443359374996,
									72.12675781250002
								],
								[
									-120.31000976562497,
									71.98408203124998
								],
								[
									-120.36625976562497,
									71.88803710937506
								],
								[
									-120.4431640625,
									71.63081054687495
								],
								[
									-120.46093749999999,
									71.60507812500003
								],
								[
									-120.51967773437497,
									71.55742187500002
								],
								[
									-120.61933593750001,
									71.50576171875005
								],
								[
									-120.93032226562495,
									71.44624023437493
								],
								[
									-121.159814453125,
									71.41499023437495
								],
								[
									-121.47216796875003,
									71.38901367187509
								],
								[
									-121.54682617187497,
									71.40678710937507
								],
								[
									-121.62216796875003,
									71.44760742187503
								],
								[
									-121.70068359374996,
									71.45117187500006
								],
								[
									-121.74936523437502,
									71.44477539062498
								],
								[
									-122.15664062499995,
									71.26591796874996
								],
								[
									-122.54951171874995,
									71.19355468750004
								],
								[
									-122.719775390625,
									71.12817382812497
								],
								[
									-122.83994140624998,
									71.09746093750002
								],
								[
									-122.93652343750003,
									71.08798828124995
								],
								[
									-123.09565429687503,
									71.09379882812507
								],
								[
									-123.210595703125,
									71.12343750000008
								],
								[
									-123.31474609374999,
									71.16918945312497
								],
								[
									-123.39335937500002,
									71.21884765625006
								],
								[
									-123.595166015625,
									71.42319335937503
								],
								[
									-123.68183593749998,
									71.49311523437507
								],
								[
									-123.75556640625,
									71.52802734374998
								],
								[
									-123.95327148437495,
									71.65249023437494
								],
								[
									-124.00776367187495,
									71.67744140624995
								],
								[
									-124.75996093749998,
									71.83515625000001
								],
								[
									-125.12612304687497,
									71.92363281250002
								],
								[
									-125.21464843749997,
									71.95478515625007
								],
								[
									-125.29667968749999,
									71.97304687499997
								],
								[
									-125.76689453124995,
									71.96083984374997
								],
								[
									-125.82910156250001,
									71.96562499999996
								],
								[
									-125.84531250000003,
									71.97866210937505
								],
								[
									-125.78964843749996,
									72.02499999999998
								],
								[
									-125.76772460937494,
									72.05424804687499
								],
								[
									-125.76049804687499,
									72.08291015624997
								],
								[
									-125.76860351562495,
									72.12915039062497
								],
								[
									-125.76259765624997,
									72.13750000000007
								],
								[
									-125.58378906249995,
									72.18305664062501
								],
								[
									-125.61279296875,
									72.192529296875
								],
								[
									-125.63378906250001,
									72.21030273437498
								],
								[
									-125.64677734374999,
									72.23652343750007
								],
								[
									-125.62729492187502,
									72.25483398437507
								],
								[
									-125.57548828124995,
									72.265283203125
								],
								[
									-125.51240234374997,
									72.30771484375012
								],
								[
									-125.43808593750002,
									72.38208007812506
								],
								[
									-125.38276367187503,
									72.42382812500006
								],
								[
									-125.30600585937502,
									72.45073242187502
								],
								[
									-125.16831054687503,
									72.52260742187511
								],
								[
									-125.07021484374995,
									72.55161132812506
								],
								[
									-124.98710937499999,
									72.58798828125
								],
								[
									-124.98466796875002,
									72.60439453125005
								],
								[
									-125.0185546875,
									72.61699218749996
								],
								[
									-125.03022460937497,
									72.64477539062494
								],
								[
									-125.01474609375002,
									72.73144531250011
								],
								[
									-125.01542968749997,
									72.77607421874995
								],
								[
									-125.00039062500002,
									72.81333007812509
								],
								[
									-124.96967773437498,
									72.84331054687507
								],
								[
									-124.93085937499998,
									72.86318359374994
								],
								[
									-124.58256835937499,
									72.92592773437494
								],
								[
									-124.56494140624996,
									72.9441406250001
								],
								[
									-124.56083984375,
									72.9650390625001
								],
								[
									-124.57021484374997,
									72.98872070312501
								],
								[
									-124.58828125,
									73.00532226562504
								],
								[
									-124.64331054687501,
									73.01894531249997
								],
								[
									-124.73642578124998,
									73.02270507812503
								],
								[
									-124.81708984374998,
									73.0587890625001
								],
								[
									-124.83642578125001,
									73.07626953125
								],
								[
									-124.80405273437499,
									73.12568359374995
								],
								[
									-124.64692382812495,
									73.204443359375
								],
								[
									-124.59399414062501,
									73.24331054687494
								],
								[
									-124.42421874999997,
									73.41870117187506
								],
								[
									-124.11416015624995,
									73.52739257812499
								],
								[
									-124.03017578124998,
									73.64423828124998
								],
								[
									-123.79726562499997,
									73.7681640625
								],
								[
									-123.79780273437498,
									73.78530273437505
								],
								[
									-123.87304687499994,
									73.82758789062495
								],
								[
									-124.08803710937497,
									73.85688476562507
								],
								[
									-124.19150390624999,
									73.90200195312511
								],
								[
									-124.26074218749997,
									73.95327148437505
								],
								[
									-124.57534179687502,
									74.24814453125
								],
								[
									-124.62910156249997,
									74.27001953125003
								],
								[
									-124.64501953125001,
									74.304345703125
								],
								[
									-124.70932617187496,
									74.32700195312509
								],
								[
									-124.69624023437497,
									74.34819335937496
								],
								[
									-123.468310546875,
									74.43613281250003
								],
								[
									-122.62314453125003,
									74.46416015624996
								],
								[
									-121.74790039062499,
									74.54062500000009
								],
								[
									-121.50415039062497,
									74.54511718750001
								],
								[
									-121.31523437499995,
									74.52998046874995
								],
								[
									-121.12871093749996,
									74.49023437499994
								],
								[
									-120.88164062499999,
									74.420751953125
								],
								[
									-120.55449218749995,
									74.35292968750005
								],
								[
									-119.94360351562501,
									74.25371093749999
								],
								[
									-119.56264648437495,
									74.2328125
								],
								[
									-119.71538085937497,
									74.15366210937495
								],
								[
									-119.7369140625,
									74.12993164062499
								],
								[
									-119.73632812499999,
									74.11264648437503
								]
							]
						],
						[
							[
								[
									-97.35551757812496,
									74.52631835937493
								],
								[
									-97.656103515625,
									74.465673828125
								],
								[
									-97.72158203125002,
									74.48920898437501
								],
								[
									-97.74999999999994,
									74.51054687500007
								],
								[
									-97.51630859374995,
									74.60249023437498
								],
								[
									-97.41650390624994,
									74.6265625
								],
								[
									-97.318212890625,
									74.59799804687506
								],
								[
									-97.29130859374993,
									74.5763671875001
								],
								[
									-97.303857421875,
									74.55966796875006
								],
								[
									-97.35551757812496,
									74.52631835937493
								]
							]
						],
						[
							[
								[
									-95.306640625,
									74.50541992187502
								],
								[
									-95.35244140625,
									74.50039062499997
								],
								[
									-95.44150390625003,
									74.50610351562506
								],
								[
									-95.77719726562503,
									74.55073242187493
								],
								[
									-95.83437499999994,
									74.56904296874993
								],
								[
									-95.850732421875,
									74.5824707031251
								],
								[
									-95.7744140625,
									74.59868164062502
								],
								[
									-95.74560546874997,
									74.61596679687506
								],
								[
									-95.66044921874996,
									74.63691406249998
								],
								[
									-95.51020507812498,
									74.63676757812496
								],
								[
									-95.35253906250003,
									74.58569335937494
								],
								[
									-95.27836914062502,
									74.53955078125006
								],
								[
									-95.27446289062502,
									74.51918945312508
								],
								[
									-95.306640625,
									74.50541992187502
								]
							]
						],
						[
							[
								[
									-104.11992187499996,
									75.0363281250001
								],
								[
									-104.30869140624995,
									75.03095703125007
								],
								[
									-104.63432617187503,
									75.06127929687503
								],
								[
									-104.828125,
									75.11972656250003
								],
								[
									-104.88740234375,
									75.14775390624996
								],
								[
									-104.88164062499997,
									75.16049804687498
								],
								[
									-104.84809570312498,
									75.17304687500004
								],
								[
									-104.80131835937495,
									75.21103515624998
								],
								[
									-104.690380859375,
									75.32070312499994
								],
								[
									-104.64882812499997,
									75.349755859375
								],
								[
									-104.474169921875,
									75.41303710937501
								],
								[
									-104.34619140624996,
									75.42993164062509
								],
								[
									-104.07465820312497,
									75.42451171875004
								],
								[
									-103.9169921875,
									75.39184570312503
								],
								[
									-103.851171875,
									75.37080078124993
								],
								[
									-103.80410156250001,
									75.34550781250002
								],
								[
									-103.75791015625,
									75.28906249999997
								],
								[
									-103.746484375,
									75.25244140624997
								],
								[
									-103.66723632812501,
									75.210693359375
								],
								[
									-103.64350585937497,
									75.18657226562496
								],
								[
									-103.64213867187496,
									75.16293945312495
								],
								[
									-103.66425781250003,
									75.13906249999997
								],
								[
									-103.70971679687496,
									75.11499023437494
								],
								[
									-103.81391601562497,
									75.07973632812497
								],
								[
									-104.11992187499996,
									75.0363281250001
								]
							]
						],
						[
							[
								[
									-93.54257812499998,
									75.02792968749998
								],
								[
									-93.478271484375,
									74.95195312500005
								],
								[
									-93.46660156249993,
									74.92133789062493
								],
								[
									-93.4634765625,
									74.85649414062496
								],
								[
									-93.490869140625,
									74.77197265624997
								],
								[
									-93.5091796875,
									74.75649414062511
								],
								[
									-93.53564453124997,
									74.74931640625005
								],
								[
									-93.54829101562498,
									74.72753906249997
								],
								[
									-93.54716796875002,
									74.69106445312508
								],
								[
									-93.57309570312498,
									74.66884765625011
								],
								[
									-93.62617187499995,
									74.66088867187509
								],
								[
									-93.98457031249995,
									74.64418945312505
								],
								[
									-94.20605468749994,
									74.64741210937507
								],
								[
									-94.53452148437498,
									74.63671874999994
								],
								[
									-94.69726562500003,
									74.64218750000009
								],
								[
									-94.80385742187497,
									74.66010742187501
								],
								[
									-94.958740234375,
									74.69995117187494
								],
								[
									-95.28608398437498,
									74.79409179687494
								],
								[
									-95.45122070312496,
									74.79736328125009
								],
								[
									-95.86542968749998,
									74.83041992187498
								],
								[
									-96.09423828124994,
									74.93251953125
								],
								[
									-96.18173828125,
									74.95078124999998
								],
								[
									-96.2701171875,
									74.9203125
								],
								[
									-96.294189453125,
									74.92719726562507
								],
								[
									-96.31855468750001,
									74.94770507812507
								],
								[
									-96.34316406249997,
									74.98193359375003
								],
								[
									-96.38632812499995,
									74.99946289062495
								],
								[
									-96.55986328124996,
									74.99038085937497
								],
								[
									-96.59116210937503,
									75.00185546875
								],
								[
									-96.59960937499997,
									75.03178710937496
								],
								[
									-96.59692382812497,
									75.05786132812494
								],
								[
									-96.565771484375,
									75.09873046875
								],
								[
									-96.38286132812496,
									75.21137695312495
								],
								[
									-96.2923828125,
									75.21928710937505
								],
								[
									-96.18037109375001,
									75.24008789062495
								],
								[
									-96.118408203125,
									75.300927734375
								],
								[
									-96.12490234375,
									75.35830078125005
								],
								[
									-95.95463867187493,
									75.44379882812507
								],
								[
									-95.85317382812497,
									75.46904296874996
								],
								[
									-95.67080078125002,
									75.52866210937503
								],
								[
									-95.04951171875001,
									75.621826171875
								],
								[
									-94.878173828125,
									75.63002929687508
								],
								[
									-94.64863281249995,
									75.62304687500006
								],
								[
									-94.42724609374997,
									75.59335937499998
								],
								[
									-94.25668945312498,
									75.54409179687497
								],
								[
									-93.90908203125002,
									75.42250976562508
								],
								[
									-93.75083007812503,
									75.34902343749994
								],
								[
									-93.66684570312498,
									75.27353515625
								],
								[
									-93.59121093750002,
									75.23022460937497
								],
								[
									-93.49755859375003,
									75.13686523437497
								],
								[
									-93.53173828124997,
									75.10034179687509
								],
								[
									-93.55180664062499,
									75.05117187500008
								],
								[
									-93.54257812499998,
									75.02792968749998
								]
							]
						],
						[
							[
								[
									-96.07856445312495,
									75.51010742187498
								],
								[
									-96.156396484375,
									75.47724609375004
								],
								[
									-96.23662109375002,
									75.47480468749998
								],
								[
									-96.34448242187494,
									75.50595703125012
								],
								[
									-96.46162109375001,
									75.49423828125003
								],
								[
									-96.62197265625,
									75.431298828125
								],
								[
									-96.67900390624999,
									75.39418945312508
								],
								[
									-96.72285156249995,
									75.38076171875008
								],
								[
									-96.85712890624995,
									75.36914062499994
								],
								[
									-96.91513671875003,
									75.37968749999996
								],
								[
									-96.96962890624994,
									75.41264648437502
								],
								[
									-97.02065429687497,
									75.4680664062501
								],
								[
									-96.98281249999997,
									75.5098144531251
								],
								[
									-96.85615234375001,
									75.53793945312506
								],
								[
									-96.52290039062498,
									75.58364257812502
								],
								[
									-96.42768554687495,
									75.60634765625005
								],
								[
									-96.41723632812503,
									75.63071289062495
								],
								[
									-96.39726562499996,
									75.64682617187503
								],
								[
									-96.367822265625,
									75.65463867187512
								],
								[
									-96.14541015625,
									75.613525390625
								],
								[
									-96.03984374999999,
									75.58579101562503
								],
								[
									-95.95986328125002,
									75.55434570312502
								],
								[
									-95.96860351562503,
									75.54184570312503
								],
								[
									-96.07856445312495,
									75.51010742187498
								]
							]
						],
						[
							[
								[
									-121.07622070312502,
									75.74526367187511
								],
								[
									-121.15429687500003,
									75.74062500000005
								],
								[
									-121.24091796875,
									75.75185546874994
								],
								[
									-121.22109374999995,
									75.77749023437508
								],
								[
									-121.02631835937497,
									75.84750976562506
								],
								[
									-121.01542968749997,
									75.86752929687506
								],
								[
									-121.01806640624999,
									75.88383789062507
								],
								[
									-121.04228515624995,
									75.902978515625
								],
								[
									-120.99301757812503,
									75.9274414062501
								],
								[
									-120.91396484375,
									75.9375
								],
								[
									-120.88779296874999,
									75.92797851562503
								],
								[
									-120.87871093750002,
									75.90668945312504
								],
								[
									-120.89687499999998,
									75.84453124999999
								],
								[
									-120.92124023437498,
									75.81445312500009
								],
								[
									-120.95493164062499,
									75.78876953125007
								],
								[
									-121.00664062499996,
									75.76572265625
								],
								[
									-121.07622070312502,
									75.74526367187511
								]
							]
						],
						[
							[
								[
									-94.52656249999995,
									75.74931640625005
								],
								[
									-94.624365234375,
									75.74887695312495
								],
								[
									-94.75146484374994,
									75.76967773437511
								],
								[
									-94.78735351562497,
									75.79140625
								],
								[
									-94.81474609374996,
									75.82119140624994
								],
								[
									-94.833642578125,
									75.85898437500009
								],
								[
									-94.86010742187497,
									75.8892089843751
								],
								[
									-94.89409179687496,
									75.91186523437503
								],
								[
									-94.901220703125,
									75.93076171875006
								],
								[
									-94.88134765624994,
									75.94594726562505
								],
								[
									-94.83979492187501,
									75.95444335937509
								],
								[
									-94.74482421874993,
									75.95722656250004
								],
								[
									-94.53789062499996,
									75.99643554687512
								],
								[
									-94.49868164062497,
									75.99218750000006
								],
								[
									-94.47128906249998,
									75.97143554687509
								],
								[
									-94.44335937499997,
									75.91708984375012
								],
								[
									-94.41376953124998,
									75.88486328125003
								],
								[
									-94.33222656249998,
									75.82597656250002
								],
								[
									-94.29628906249994,
									75.78808593749994
								],
								[
									-94.30400390625002,
									75.77631835937504
								],
								[
									-94.32954101562498,
									75.76591796874996
								],
								[
									-94.52656249999995,
									75.74931640625005
								]
							]
						],
						[
							[
								[
									-118.32812499999997,
									75.57968750000003
								],
								[
									-118.6138671875,
									75.51542968749999
								],
								[
									-118.81713867187503,
									75.52211914062494
								],
								[
									-119.08666992187497,
									75.56933593750006
								],
								[
									-119.30605468749998,
									75.58535156249994
								],
								[
									-119.383251953125,
									75.60102539062501
								],
								[
									-119.39458007812499,
									75.61733398437497
								],
								[
									-119.32016601562502,
									75.66254882812504
								],
								[
									-119.226806640625,
									75.69863281250002
								],
								[
									-119.00346679687497,
									75.76958007812499
								],
								[
									-118.62607421875,
									75.90624999999994
								],
								[
									-118.37900390625003,
									75.9579589843751
								],
								[
									-118.13666992187495,
									75.99448242187498
								],
								[
									-117.88935546875003,
									76.07607421875
								],
								[
									-117.75249023437495,
									76.11245117187494
								],
								[
									-117.63369140624998,
									76.11508789062495
								],
								[
									-117.51259765625001,
									76.09941406250005
								],
								[
									-117.49912109375002,
									76.07719726562496
								],
								[
									-117.62636718750001,
									75.96596679687494
								],
								[
									-117.71596679687497,
									75.92114257812506
								],
								[
									-117.89082031249997,
									75.80546875000002
								],
								[
									-118.22651367187497,
									75.61118164062506
								],
								[
									-118.32812499999997,
									75.57968750000003
								]
							]
						],
						[
							[
								[
									-79.0630859375,
									75.92587890624995
								],
								[
									-79.0517578125,
									75.86699218750013
								],
								[
									-79.1244140625,
									75.86967773437496
								],
								[
									-79.35566406249993,
									75.83115234375
								],
								[
									-79.54453125000003,
									75.82563476562495
								],
								[
									-79.63876953124998,
									75.84291992187511
								],
								[
									-79.69873046875,
									75.88325195312507
								],
								[
									-79.55126953125,
									75.95834960937509
								],
								[
									-79.38178710937501,
									76.01083984375003
								],
								[
									-79.17832031250003,
									76.09238281250003
								],
								[
									-79.00932617187499,
									76.14589843750011
								],
								[
									-78.92587890625003,
									76.13466796874994
								],
								[
									-78.84516601562493,
									76.10629882812512
								],
								[
									-78.94643554687497,
									76.02543945312507
								],
								[
									-79.05664062500003,
									75.98515625000013
								],
								[
									-79.0630859375,
									75.92587890624995
								]
							]
						],
						[
							[
								[
									-102.22734374999995,
									76.01489257812506
								],
								[
									-102.01787109374999,
									75.95351562500008
								],
								[
									-102.00800781250003,
									75.93940429687495
								],
								[
									-102.04746093749998,
									75.92773437499997
								],
								[
									-102.31811523437496,
									75.895166015625
								],
								[
									-102.42343750000002,
									75.86918945312513
								],
								[
									-102.511376953125,
									75.80839843749999
								],
								[
									-102.57958984375003,
									75.78022460937504
								],
								[
									-102.94355468750001,
									75.76342773437506
								],
								[
									-103.31474609374996,
									75.76420898437496
								],
								[
									-103.2447265625,
									75.82294921875004
								],
								[
									-103.04150390624999,
									75.91884765624994
								],
								[
									-103.2015625,
									75.95849609375003
								],
								[
									-103.76977539062503,
									75.89238281249996
								],
								[
									-103.98525390624997,
									75.93310546875
								],
								[
									-103.80078124999996,
									76.03701171874994
								],
								[
									-103.984521484375,
									76.04653320312502
								],
								[
									-104.24248046874996,
									76.04697265625009
								],
								[
									-104.40605468749999,
									76.10849609375003
								],
								[
									-104.35063476562497,
									76.18232421875007
								],
								[
									-104.012060546875,
									76.22299804687509
								],
								[
									-103.57143554687495,
									76.25820312499997
								],
								[
									-103.0982421875,
									76.31147460937498
								],
								[
									-102.72802734374999,
									76.30703124999997
								],
								[
									-102.58408203124996,
									76.28164062500005
								],
								[
									-102.53613281249997,
									76.196435546875
								],
								[
									-102.49003906249999,
									76.09506835937495
								],
								[
									-102.42568359375002,
									76.08642578124997
								],
								[
									-102.22734374999995,
									76.01489257812506
								]
							]
						],
						[
							[
								[
									-104.02285156249998,
									76.58310546875009
								],
								[
									-103.97348632812496,
									76.57758789062501
								],
								[
									-103.82109375,
									76.59750976562509
								],
								[
									-103.72275390624995,
									76.60107421875011
								],
								[
									-103.613134765625,
									76.56342773437498
								],
								[
									-103.58461914062497,
									76.53886718750005
								],
								[
									-103.19013671874998,
									76.47744140624997
								],
								[
									-103.05131835937495,
									76.44985351562494
								],
								[
									-103.03354492187496,
									76.43149414062509
								],
								[
									-103.082958984375,
									76.40517578125008
								],
								[
									-103.19951171874993,
									76.370849609375
								],
								[
									-103.31137695312499,
									76.34755859374997
								],
								[
									-103.47221679687499,
									76.32905273437493
								],
								[
									-104.27065429687502,
									76.32626953124998
								],
								[
									-104.35751953124995,
									76.334619140625
								],
								[
									-104.40766601562495,
									76.36513671875
								],
								[
									-104.5064453125,
									76.47895507812501
								],
								[
									-104.576611328125,
									76.54018554687505
								],
								[
									-104.60302734374997,
									76.58271484375001
								],
								[
									-104.58569335937499,
									76.60649414062496
								],
								[
									-104.50039062500002,
									76.63037109374994
								],
								[
									-104.20512695312499,
									76.66611328125003
								],
								[
									-104.07451171875003,
									76.66611328125003
								],
								[
									-103.99248046875002,
									76.65698242187494
								],
								[
									-103.95908203124996,
									76.63876953125006
								],
								[
									-103.96918945312498,
									76.61416015625002
								],
								[
									-104.02285156249998,
									76.58310546875009
								]
							]
						],
						[
							[
								[
									-97.700927734375,
									76.46650390624995
								],
								[
									-97.68974609375002,
									76.4218261718751
								],
								[
									-97.70185546875001,
									76.38740234375001
								],
								[
									-97.73710937499999,
									76.36313476562495
								],
								[
									-97.73876953124997,
									76.33525390625005
								],
								[
									-97.70683593749996,
									76.3037109375
								],
								[
									-97.57314453124997,
									76.22421874999998
								],
								[
									-97.53066406250002,
									76.18154296875008
								],
								[
									-97.52426757812498,
									76.13872070312496
								],
								[
									-97.53105468750002,
									76.10942382812505
								],
								[
									-97.61347656249993,
									76.05263671875002
								],
								[
									-97.65,
									75.97915039062497
								],
								[
									-97.65214843749999,
									75.94018554687503
								],
								[
									-97.60302734375003,
									75.87934570312507
								],
								[
									-97.60166015625,
									75.85107421875009
								],
								[
									-97.69423828124997,
									75.80258789062506
								],
								[
									-97.89052734374997,
									75.76035156249998
								],
								[
									-97.86279296875,
									75.73808593750005
								],
								[
									-97.43955078125003,
									75.68457031250009
								],
								[
									-97.40751953124999,
									75.67250976562494
								],
								[
									-97.40961914062498,
									75.552099609375
								],
								[
									-97.33603515624998,
									75.41982421874997
								],
								[
									-97.36347656249998,
									75.41723632812497
								],
								[
									-97.46523437500002,
									75.45864257812497
								],
								[
									-97.65332031249997,
									75.50776367187504
								],
								[
									-97.87822265624996,
									75.41611328125
								],
								[
									-97.85273437500001,
									75.26030273437507
								],
								[
									-97.70488281249999,
									75.19082031249994
								],
								[
									-97.65991210937497,
									75.15117187500005
								],
								[
									-97.67431640624997,
									75.12729492187506
								],
								[
									-97.79936523437496,
									75.11665039062493
								],
								[
									-97.84272460937501,
									75.12182617187509
								],
								[
									-97.970849609375,
									75.15327148437493
								],
								[
									-98.0453125,
									75.20083007812494
								],
								[
									-98.06874999999997,
									75.19916992187495
								],
								[
									-98.09169921875002,
									75.17622070312498
								],
								[
									-98.0767578125,
									75.15297851562497
								],
								[
									-97.989990234375,
									75.11069335937506
								],
								[
									-97.95332031249998,
									75.06015625000006
								],
								[
									-97.991796875,
									75.04580078125005
								],
								[
									-98.12094726562503,
									75.03271484374997
								],
								[
									-98.295166015625,
									75.03217773437495
								],
								[
									-98.56865234375002,
									75.0093261718751
								],
								[
									-98.70351562499997,
									75.0058105468751
								],
								[
									-98.83481445312498,
									75.01816406250003
								],
								[
									-99.01005859374997,
									75.02109375
								],
								[
									-99.155810546875,
									75.01572265624998
								],
								[
									-99.24492187499995,
									75.02578125000008
								],
								[
									-99.32612304687497,
									75.0494140625
								],
								[
									-99.42060546874994,
									75.0437500000001
								],
								[
									-99.62690429687497,
									74.98374023437495
								],
								[
									-99.94663085937499,
									75.00283203125002
								],
								[
									-100.234375,
									75.00771484374994
								],
								[
									-100.29228515624999,
									75.02773437499994
								],
								[
									-100.35664062499995,
									75.06674804687498
								],
								[
									-100.48349609374995,
									75.18842773437498
								],
								[
									-100.45947265625003,
									75.21909179687512
								],
								[
									-100.15205078125001,
									75.23564453125002
								],
								[
									-100.14570312499997,
									75.24614257812502
								],
								[
									-100.36411132812496,
									75.28955078125009
								],
								[
									-100.61489257812498,
									75.321435546875
								],
								[
									-100.73115234374995,
									75.34653320312503
								],
								[
									-100.70424804687498,
									75.39433593750002
								],
								[
									-100.71191406250003,
									75.40634765624998
								],
								[
									-100.27963867187498,
									75.4609863281251
								],
								[
									-99.96528320312498,
									75.56850585937497
								],
								[
									-99.77021484375003,
									75.61225585937501
								],
								[
									-99.75600585937498,
									75.63339843750003
								],
								[
									-99.59116210937496,
									75.65537109375009
								],
								[
									-99.209423828125,
									75.66860351562494
								],
								[
									-99.194580078125,
									75.69838867187497
								],
								[
									-99.91513671874998,
									75.68125000000003
								],
								[
									-100.90175781249998,
									75.62041015625007
								],
								[
									-101.20683593749996,
									75.59042968750009
								],
								[
									-101.46132812500002,
									75.60791015625
								],
								[
									-102.54140624999998,
									75.51362304687498
								],
								[
									-102.58740234375003,
									75.51367187500009
								],
								[
									-102.70039062499995,
									75.54360351562497
								],
								[
									-102.79750976562502,
									75.59965820312502
								],
								[
									-102.72783203124995,
									75.63872070312507
								],
								[
									-102.41069335937499,
									75.71284179687498
								],
								[
									-102.25205078125,
									75.77773437499997
								],
								[
									-102.27065429687498,
									75.8127929687501
								],
								[
									-102.14472656249998,
									75.87504882812499
								],
								[
									-101.94282226562498,
									75.88383789062507
								],
								[
									-101.59965820312496,
									75.83266601562497
								],
								[
									-101.42124023437495,
									75.78193359374993
								],
								[
									-101.26142578124998,
									75.75820312500008
								],
								[
									-101.119384765625,
									75.76289062499995
								],
								[
									-100.97280273437498,
									75.7984375
								],
								[
									-101.009912109375,
									75.80239257812502
								],
								[
									-101.25883789062499,
									75.78364257812493
								],
								[
									-101.28803710937498,
									75.78911132812507
								],
								[
									-101.414990234375,
									75.84584960937508
								],
								[
									-101.47031249999999,
									75.88193359375006
								],
								[
									-101.50590820312496,
									75.91806640624995
								],
								[
									-101.507861328125,
									75.943603515625
								],
								[
									-101.43134765624995,
									75.9919921875001
								],
								[
									-101.71679687500003,
									76.00791015625006
								],
								[
									-101.82338867187498,
									76.04135742187503
								],
								[
									-101.87211914062496,
									76.08310546875
								],
								[
									-101.86137695312499,
									76.10126953125007
								],
								[
									-101.77138671874995,
									76.15009765625007
								],
								[
									-101.52895507812495,
									76.21728515625009
								],
								[
									-101.55703124999998,
									76.23583984374994
								],
								[
									-101.90981445312501,
									76.234375
								],
								[
									-101.98745117187501,
									76.24311523437501
								],
								[
									-102.13774414062499,
									76.28486328124998
								],
								[
									-102.1046875,
									76.33120117187511
								],
								[
									-101.96420898437498,
									76.39902343749998
								],
								[
									-101.85849609374993,
									76.43901367187505
								],
								[
									-101.78754882812497,
									76.45126953125003
								],
								[
									-101.67724609374996,
									76.45102539062509
								],
								[
									-101.41518554687495,
									76.42490234375
								],
								[
									-101.33974609374995,
									76.410498046875
								],
								[
									-101.13906250000001,
									76.34516601562493
								],
								[
									-101.08789062499997,
									76.30786132812506
								],
								[
									-101.09418945312501,
									76.27192382812493
								],
								[
									-101.05581054687501,
									76.24555664062507
								],
								[
									-100.90009765625,
									76.20708007812505
								],
								[
									-100.23066406249995,
									76.007666015625
								],
								[
									-100.10571289062499,
									75.96044921874997
								],
								[
									-100.02011718749996,
									75.93955078124998
								],
								[
									-99.86547851562499,
									75.92421874999997
								],
								[
									-99.774853515625,
									75.927392578125
								],
								[
									-99.70126953125002,
									75.94145507812502
								],
								[
									-99.68891601562498,
									75.959716796875
								],
								[
									-99.97832031249997,
									76.02949218750001
								],
								[
									-100.05097656250003,
									76.06660156249993
								],
								[
									-100.11284179687502,
									76.11723632812513
								],
								[
									-100.08579101562502,
									76.13354492187497
								],
								[
									-100.00175781249995,
									76.13920898437507
								],
								[
									-99.79018554687501,
									76.13261718749996
								],
								[
									-99.54106445312497,
									76.14628906250007
								],
								[
									-99.81723632812502,
									76.16757812499998
								],
								[
									-99.99760742187499,
									76.19584960937505
								],
								[
									-100.18276367187497,
									76.19721679687498
								],
								[
									-100.41420898437495,
									76.24252929687498
								],
								[
									-100.41435546874999,
									76.25668945312512
								],
								[
									-100.35761718749997,
									76.27114257812494
								],
								[
									-100.04272460937503,
									76.29125976562506
								],
								[
									-99.98310546874997,
									76.29990234375003
								],
								[
									-99.97773437500003,
									76.31245117187493
								],
								[
									-100.08188476562502,
									76.34277343749997
								],
								[
									-100.174658203125,
									76.35927734375005
								],
								[
									-100.65068359374999,
									76.39594726562507
								],
								[
									-100.819873046875,
									76.43701171875009
								],
								[
									-100.87363281250002,
									76.45659179687507
								],
								[
									-100.89077148437497,
									76.47548828125011
								],
								[
									-100.82973632812497,
									76.52387695312501
								],
								[
									-100.57373046875003,
									76.58461914062502
								],
								[
									-100.38793945312501,
									76.61357421874999
								],
								[
									-100.06870117187499,
									76.63476562499994
								],
								[
									-99.81406249999999,
									76.63222656249997
								],
								[
									-99.66904296875002,
									76.62412109375
								],
								[
									-99.32949218749995,
									76.52128906250002
								],
								[
									-99.16962890624997,
									76.4536621093751
								],
								[
									-98.89033203125001,
									76.46557617187494
								],
								[
									-98.97099609375,
									76.53657226562493
								],
								[
									-99.02363281249998,
									76.6145507812501
								],
								[
									-98.940869140625,
									76.64316406249998
								],
								[
									-98.71083984374994,
									76.69384765625
								],
								[
									-98.527587890625,
									76.66738281249994
								],
								[
									-98.288671875,
									76.59873046874998
								],
								[
									-98.23618164062498,
									76.57534179687511
								],
								[
									-97.96733398437499,
									76.53291015624998
								],
								[
									-97.80839843749993,
									76.51879882812494
								],
								[
									-97.72587890625002,
									76.49609374999994
								],
								[
									-97.700927734375,
									76.46650390624995
								]
							]
						],
						[
							[
								[
									-101.22612304687499,
									76.57934570312494
								],
								[
									-101.485205078125,
									76.57500000000013
								],
								[
									-101.60498046874999,
									76.58701171875009
								],
								[
									-101.61308593749995,
									76.60458984375012
								],
								[
									-101.50947265624998,
									76.6277343750001
								],
								[
									-101.16503906249997,
									76.66542968750008
								],
								[
									-100.96215820312503,
									76.73417968750005
								],
								[
									-100.88647460937497,
									76.74267578125
								],
								[
									-100.62158203125001,
									76.75249023437505
								],
								[
									-100.46723632812501,
									76.75034179687503
								],
								[
									-100.26914062499998,
									76.73413085937494
								],
								[
									-100.74658203124999,
									76.64916992187503
								],
								[
									-101.22612304687499,
									76.57934570312494
								]
							]
						],
						[
							[
								[
									-108.29238281250001,
									76.05712890625003
								],
								[
									-108.16630859374999,
									76.05429687500009
								],
								[
									-108.01874999999995,
									76.0652343750001
								],
								[
									-107.85229492187497,
									76.05771484374998
								],
								[
									-107.77685546874997,
									76.03530273437502
								],
								[
									-107.72348632812502,
									75.99541015624999
								],
								[
									-107.72128906250002,
									75.97402343750008
								],
								[
									-107.73183593749994,
									75.95561523437496
								],
								[
									-107.75517578124999,
									75.94028320312495
								],
								[
									-107.97041015624997,
									75.83959960937506
								],
								[
									-108.020703125,
									75.80478515625006
								],
								[
									-107.95107421875002,
									75.79628906250002
								],
								[
									-107.91752929687503,
									75.80214843749997
								],
								[
									-107.70258789062503,
									75.87758789062497
								],
								[
									-107.54091796874995,
									75.90117187500007
								],
								[
									-107.41826171875,
									75.90659179687509
								],
								[
									-107.21621093749997,
									75.89155273437507
								],
								[
									-107.135693359375,
									75.878564453125
								],
								[
									-107.08041992187502,
									75.86318359374997
								],
								[
									-107.05039062500002,
									75.84541015624998
								],
								[
									-106.970947265625,
									75.773095703125
								],
								[
									-106.91352539062503,
									75.67963867187504
								],
								[
									-106.90419921875,
									75.68925781250005
								],
								[
									-106.90278320312497,
									75.74165039062498
								],
								[
									-106.89169921875002,
									75.78242187500004
								],
								[
									-106.69311523437499,
									75.80996093750005
								],
								[
									-106.68808593750002,
									75.81904296875004
								],
								[
									-106.75937499999998,
									75.8416015625001
								],
								[
									-106.820068359375,
									75.87241210937498
								],
								[
									-106.86206054687503,
									75.93007812500008
								],
								[
									-106.84565429687497,
									75.95156249999994
								],
								[
									-106.80410156249994,
									75.9746582031251
								],
								[
									-106.67700195312499,
									76.02373046874999
								],
								[
									-106.52861328124995,
									76.0530273437501
								],
								[
									-106.39658203124996,
									76.0601074218751
								],
								[
									-105.90483398437497,
									76.00898437500001
								],
								[
									-105.71132812499998,
									75.96699218750007
								],
								[
									-105.63266601562495,
									75.9453613281251
								],
								[
									-105.60444335937497,
									75.92993164062497
								],
								[
									-105.56328125000002,
									75.88066406250007
								],
								[
									-105.48090820312503,
									75.7456542968751
								],
								[
									-105.48144531249996,
									75.70224609374995
								],
								[
									-105.51948242187498,
									75.63237304687502
								],
								[
									-105.67841796875003,
									75.50136718749997
								],
								[
									-105.70263671874999,
									75.41250000000008
								],
								[
									-105.86259765624997,
									75.19155273437508
								],
								[
									-105.97197265624997,
									75.13149414062494
								],
								[
									-106.09262695312495,
									75.08945312500006
								],
								[
									-106.58823242187502,
									75.0154296875001
								],
								[
									-106.96113281249995,
									74.94008789062494
								],
								[
									-107.05561523437503,
									74.92817382812507
								],
								[
									-107.15341796874996,
									74.92714843749997
								],
								[
									-107.46191406250001,
									74.95214843750009
								],
								[
									-107.82006835937497,
									75.00004882812507
								],
								[
									-108.02363281249997,
									74.98647460937497
								],
								[
									-108.22661132812502,
									74.95190429687494
								],
								[
									-108.35444335937495,
									74.942626953125
								],
								[
									-108.47475585937495,
									74.94721679687504
								],
								[
									-108.59418945312494,
									74.95957031250009
								],
								[
									-108.75131835937498,
									74.99194335937511
								],
								[
									-108.67026367187499,
									75.00673828125011
								],
								[
									-108.63330078125001,
									75.023291015625
								],
								[
									-108.66601562500001,
									75.04033203125002
								],
								[
									-108.83129882812503,
									75.06489257812495
								],
								[
									-109.0025390625,
									75.0103027343751
								],
								[
									-109.50312500000003,
									74.88276367187498
								],
								[
									-110.17578125000001,
									74.83999023437497
								],
								[
									-110.38671875,
									74.81396484375
								],
								[
									-110.54340820312495,
									74.78037109375009
								],
								[
									-110.624755859375,
									74.75268554687494
								],
								[
									-110.74931640624997,
									74.68769531250004
								],
								[
									-110.94086914062501,
									74.63872070312507
								],
								[
									-111.28754882812503,
									74.58515624999993
								],
								[
									-111.72871093750003,
									74.50195312500003
								],
								[
									-112.51933593749997,
									74.416845703125
								],
								[
									-113.01689453125,
									74.40190429687507
								],
								[
									-113.51406249999995,
									74.43007812500002
								],
								[
									-113.67158203124997,
									74.45302734375008
								],
								[
									-113.83681640624998,
									74.48896484374995
								],
								[
									-114.17475585937498,
									74.57373046875009
								],
								[
									-114.26826171875003,
									74.604345703125
								],
								[
									-114.37695312499997,
									74.67084960937507
								],
								[
									-114.31269531250003,
									74.71508789062511
								],
								[
									-114.132470703125,
									74.76611328125011
								],
								[
									-113.86289062499996,
									74.81254882812507
								],
								[
									-113.32431640625002,
									74.87529296874996
								],
								[
									-112.835986328125,
									74.97558593749997
								],
								[
									-112.66303710937503,
									74.99443359374999
								],
								[
									-112.19282226562498,
									75.009765625
								],
								[
									-111.95576171875,
									75.00039062499997
								],
								[
									-111.78422851562496,
									75.00566406250005
								],
								[
									-111.67109375000001,
									75.01943359374994
								],
								[
									-111.503271484375,
									75.05561523437493
								],
								[
									-111.25795898437495,
									75.12773437500005
								],
								[
									-111.07890624999997,
									75.19521484375005
								],
								[
									-111.03349609374996,
									75.22675781249998
								],
								[
									-111.09345703125001,
									75.25629882812495
								],
								[
									-111.18120117187503,
									75.26044921875001
								],
								[
									-111.47392578124999,
									75.19111328125001
								],
								[
									-111.62084960937499,
									75.16777343749996
								],
								[
									-111.78085937499999,
									75.16616210937508
								],
								[
									-112.00048828124997,
									75.14243164062495
								],
								[
									-112.21416015624997,
									75.13291015625003
								],
								[
									-112.25551757812497,
									75.13369140624994
								],
								[
									-112.478076171875,
									75.20000000000005
								],
								[
									-112.59707031250001,
									75.21166992187511
								],
								[
									-112.65239257812499,
									75.20468750000009
								],
								[
									-112.70312500000003,
									75.187158203125
								],
								[
									-112.79960937499996,
									75.13818359374997
								],
								[
									-112.85532226562495,
									75.12060546874994
								],
								[
									-112.95136718749997,
									75.1078125
								],
								[
									-113.33964843750003,
									75.09326171875006
								],
								[
									-113.71176757812499,
									75.068603515625
								],
								[
									-113.79462890625,
									75.08383789062509
								],
								[
									-113.84497070312494,
									75.11220703125008
								],
								[
									-113.85537109375002,
									75.12949218749998
								],
								[
									-113.8609375,
									75.18774414062494
								],
								[
									-113.88603515624996,
									75.21093750000006
								],
								[
									-113.85332031249996,
									75.25937500000006
								],
								[
									-113.81088867187502,
									75.29633789062504
								],
								[
									-113.75878906249997,
									75.32172851562507
								],
								[
									-113.50302734375,
									75.39667968749995
								],
								[
									-113.46708984374997,
									75.41611328125
								],
								[
									-113.58896484375002,
									75.412109375
								],
								[
									-113.87851562499995,
									75.37543945312498
								],
								[
									-113.91635742187502,
									75.38818359375
								],
								[
									-113.98413085937497,
									75.43007812500002
								],
								[
									-114.01650390625,
									75.43427734374998
								],
								[
									-114.05341796874995,
									75.41689453125
								],
								[
									-114.07490234374998,
									75.39238281250007
								],
								[
									-114.124658203125,
									75.29121093750007
								],
								[
									-114.16845703124994,
									75.239501953125
								],
								[
									-114.28496093749997,
									75.2499511718751
								],
								[
									-114.42900390625,
									75.28115234374997
								],
								[
									-114.48281249999995,
									75.28540039062494
								],
								[
									-114.51381835937497,
									75.27548828125006
								],
								[
									-114.503955078125,
									75.25800781249995
								],
								[
									-114.35776367187496,
									75.17128906249997
								],
								[
									-114.35610351562498,
									75.140966796875
								],
								[
									-114.45175781250002,
									75.08789062500003
								],
								[
									-114.85917968749997,
									74.99975585937509
								],
								[
									-115.02011718749999,
									74.976171875
								],
								[
									-115.07705078124995,
									74.9853027343751
								],
								[
									-115.12832031250001,
									75.00947265625004
								],
								[
									-115.17382812499996,
									75.04882812499997
								],
								[
									-115.27963867187502,
									75.10156249999997
								],
								[
									-115.34262695312498,
									75.11337890624998
								],
								[
									-115.41318359374996,
									75.11499023437494
								],
								[
									-115.47807617187503,
									75.10410156249995
								],
								[
									-115.53730468750003,
									75.08071289062508
								],
								[
									-115.57407226562496,
									75.05585937499998
								],
								[
									-115.60898437499996,
									75.00957031249996
								],
								[
									-115.68315429687497,
									74.97416992187505
								],
								[
									-115.72885742187496,
									74.96811523437503
								],
								[
									-116.14262695312497,
									75.04155273437507
								],
								[
									-116.47607421874996,
									75.17177734374997
								],
								[
									-116.84101562499997,
									75.15151367187502
								],
								[
									-117.00483398437494,
									75.15610351562498
								],
								[
									-117.50195312499997,
									75.20385742187503
								],
								[
									-117.56523437499999,
									75.23334960937507
								],
								[
									-117.60009765624999,
									75.27167968749998
								],
								[
									-117.596728515625,
									75.29252929687505
								],
								[
									-117.57607421874997,
									75.3140625
								],
								[
									-117.51313476562503,
									75.356787109375
								],
								[
									-117.38779296874998,
									75.42148437499995
								],
								[
									-117.33554687499999,
									75.44233398437501
								],
								[
									-117.25761718750002,
									75.45952148437507
								],
								[
									-117.15419921875,
									75.47299804687506
								],
								[
									-116.89077148437498,
									75.48051757812499
								],
								[
									-116.21274414062496,
									75.48295898437505
								],
								[
									-116.07714843749996,
									75.49296875000005
								],
								[
									-115.3353515625,
									75.61806640624994
								],
								[
									-115.25068359374998,
									75.63857421875002
								],
								[
									-115.14184570312501,
									75.6785156250001
								],
								[
									-115.11723632812497,
									75.69501953124998
								],
								[
									-115.12187500000003,
									75.70581054687497
								],
								[
									-116.03432617187502,
									75.60668945312503
								],
								[
									-116.42563476562499,
									75.58535156249994
								],
								[
									-117.0251953125,
									75.60151367187504
								],
								[
									-117.13793945312497,
									75.61713867187493
								],
								[
									-117.16362304687496,
									75.64487304687506
								],
								[
									-117.03857421874999,
									75.71840820312505
								],
								[
									-116.97265624999996,
									75.74575195312494
								],
								[
									-116.80214843749995,
									75.77158203124995
								],
								[
									-116.38964843750003,
									75.80820312499995
								],
								[
									-115.83808593750001,
									75.84057617187497
								],
								[
									-115.47685546874996,
									75.84130859374994
								],
								[
									-115.17373046875002,
									75.86699218750013
								],
								[
									-114.99150390625003,
									75.89633789062506
								],
								[
									-115.60224609375001,
									75.89482421875002
								],
								[
									-116.33789062499996,
									75.88105468750004
								],
								[
									-116.44423828124995,
									75.89062500000006
								],
								[
									-116.65429687500003,
									75.92929687500012
								],
								[
									-116.66455078124999,
									75.9575683593751
								],
								[
									-116.58046875,
									75.991552734375
								],
								[
									-116.54965820312503,
									76.016845703125
								],
								[
									-116.60976562500002,
									76.07373046875006
								],
								[
									-116.59130859374999,
									76.09580078125009
								],
								[
									-116.45424804687495,
									76.143212890625
								],
								[
									-116.20986328125,
									76.19443359374995
								],
								[
									-116.05913085937502,
									76.2017089843751
								],
								[
									-115.76826171875,
									76.184228515625
								],
								[
									-114.93940429687498,
									76.16611328124995
								],
								[
									-114.77861328125,
									76.17260742187494
								],
								[
									-114.88017578124999,
									76.19487304687505
								],
								[
									-115.02456054687501,
									76.21147460937496
								],
								[
									-115.664453125,
									76.23984375000006
								],
								[
									-115.79687499999997,
									76.25253906249998
								],
								[
									-115.82216796874997,
									76.27001953125006
								],
								[
									-115.83173828124997,
									76.29580078125
								],
								[
									-115.82558593749995,
									76.329833984375
								],
								[
									-115.77929687500003,
									76.3646972656251
								],
								[
									-115.58066406249998,
									76.4375
								],
								[
									-114.99848632812503,
									76.49746093750005
								],
								[
									-114.766845703125,
									76.50571289062495
								],
								[
									-114.53476562499996,
									76.50175781250013
								],
								[
									-114.29897460937498,
									76.47480468749995
								],
								[
									-114.19394531249999,
									76.45146484375007
								],
								[
									-114.14125976562501,
									76.42265624999999
								],
								[
									-114.11577148437496,
									76.39584960937495
								],
								[
									-114.11279296874997,
									76.349462890625
								],
								[
									-114.10146484374998,
									76.33120117187511
								],
								[
									-114.058837890625,
									76.30073242187493
								],
								[
									-113.92329101562501,
									76.22915039062508
								],
								[
									-113.82348632812501,
									76.20683593749999
								],
								[
									-113.36298828124998,
									76.24843749999994
								],
								[
									-113.17128906250001,
									76.25776367187507
								],
								[
									-112.97846679687498,
									76.24467773437505
								],
								[
									-112.69760742187496,
									76.2017089843751
								],
								[
									-112.33388671874994,
									76.07187500000003
								],
								[
									-111.86523437500003,
									75.93930664062512
								],
								[
									-111.86762695312498,
									75.91074218749998
								],
								[
									-112.04716796874997,
									75.8664062500001
								],
								[
									-112.080908203125,
									75.84741210937494
								],
								[
									-112.05668945312496,
									75.83422851562511
								],
								[
									-111.87739257812503,
									75.82553710937512
								],
								[
									-111.709375,
									75.83208007812502
								],
								[
									-111.54912109375003,
									75.82211914062495
								],
								[
									-111.513232421875,
									75.81069335937502
								],
								[
									-111.454443359375,
									75.76215820312498
								],
								[
									-111.37275390624998,
									75.67646484375004
								],
								[
									-111.27568359375,
									75.61250000000004
								],
								[
									-111.16328125000003,
									75.57021484374997
								],
								[
									-111.05268554687497,
									75.54853515624998
								],
								[
									-110.88959960937495,
									75.54692382812502
								],
								[
									-110.72558593750003,
									75.55952148437501
								],
								[
									-110.45937499999997,
									75.55532226562505
								],
								[
									-109.08637695312503,
									75.50649414062505
								],
								[
									-109.00502929687498,
									75.51499023437509
								],
								[
									-108.94716796875001,
									75.54179687500005
								],
								[
									-108.91259765624997,
									75.5869628906251
								],
								[
									-108.89951171874998,
									75.62407226562502
								],
								[
									-108.91821289062497,
									75.67475585937504
								],
								[
									-108.94477539062495,
									75.698974609375
								],
								[
									-109.79604492187501,
									75.86303710937503
								],
								[
									-109.8705078125,
									75.92905273437498
								],
								[
									-109.454638671875,
									76.02124023437511
								],
								[
									-109.42475585937495,
									76.04252929687507
								],
								[
									-109.41660156249998,
									76.07182617187502
								],
								[
									-109.43037109374994,
									76.10913085937497
								],
								[
									-109.48681640624999,
									76.14467773437494
								],
								[
									-109.71015625000001,
									76.21245117187507
								],
								[
									-109.90781249999996,
									76.22265625000011
								],
								[
									-110.20078124999996,
									76.28945312499994
								],
								[
									-110.24702148437497,
									76.30634765624993
								],
								[
									-110.28486328124994,
									76.33295898437493
								],
								[
									-110.31445312500003,
									76.36938476562497
								],
								[
									-110.30947265624998,
									76.3974121093751
								],
								[
									-110.27001953125003,
									76.41699218750009
								],
								[
									-109.98159179687498,
									76.48476562499994
								],
								[
									-109.86484374999999,
									76.52236328124997
								],
								[
									-109.50502929687497,
									76.69165039062509
								],
								[
									-109.33852539062498,
									76.75996093750004
								],
								[
									-109.21953124999997,
									76.7919921875
								],
								[
									-109.09824218749996,
									76.81186523437506
								],
								[
									-108.831640625,
									76.82114257812509
								],
								[
									-108.55390625,
									76.75805664062503
								],
								[
									-108.49238281249998,
									76.75419921875013
								],
								[
									-108.46699218749997,
									76.7375976562501
								],
								[
									-108.47778320312503,
									76.708251953125
								],
								[
									-108.51245117187499,
									76.68027343749998
								],
								[
									-108.61181640624999,
									76.62973632812509
								],
								[
									-108.63515624999994,
									76.60854492187494
								],
								[
									-108.62763671875001,
									76.58671875000002
								],
								[
									-108.55952148437498,
									76.53632812500007
								],
								[
									-108.53862304687499,
									76.50312499999995
								],
								[
									-108.52353515624993,
									76.44716796875011
								],
								[
									-108.5125,
									76.43891601562493
								],
								[
									-108.34545898437499,
									76.39165039062507
								],
								[
									-108.19355468749995,
									76.33007812500006
								],
								[
									-108.12319335937501,
									76.23344726562499
								],
								[
									-108.17792968749997,
									76.20004882812503
								],
								[
									-108.305810546875,
									76.15405273437506
								],
								[
									-108.38188476562503,
									76.11572265625009
								],
								[
									-108.40615234375001,
									76.08505859375003
								],
								[
									-108.38681640624998,
									76.06655273437511
								],
								[
									-108.29238281250001,
									76.05712890625003
								]
							]
						],
						[
							[
								[
									-89.72646484374994,
									76.50742187500003
								],
								[
									-89.77329101562498,
									76.49384765624993
								],
								[
									-89.92412109374999,
									76.50087890624994
								],
								[
									-89.97412109374994,
									76.48754882812497
								],
								[
									-90.05429687500003,
									76.49511718750009
								],
								[
									-90.16455078125003,
									76.52358398437502
								],
								[
									-90.29350585937499,
									76.57949218749997
								],
								[
									-90.44096679687502,
									76.66279296875007
								],
								[
									-90.55624999999998,
									76.73457031250004
								],
								[
									-90.5625,
									76.75429687499997
								],
								[
									-90.52480468749997,
									76.78784179687506
								],
								[
									-90.409521484375,
									76.81015624999998
								],
								[
									-90.13632812499995,
									76.83696289062502
								],
								[
									-89.94877929687493,
									76.83623046874996
								],
								[
									-89.77456054687497,
									76.78203125000002
								],
								[
									-89.72529296874998,
									76.76342773437506
								],
								[
									-89.69541015625,
									76.74116210937495
								],
								[
									-89.69443359374998,
									76.71982421875003
								],
								[
									-89.70864257812497,
									76.70117187499997
								],
								[
									-89.78754882812495,
									76.65961914062495
								],
								[
									-89.82211914062498,
									76.63061523437509
								],
								[
									-89.82192382812502,
									76.60219726562505
								],
								[
									-89.80478515625,
									76.56108398437505
								],
								[
									-89.77294921875,
									76.53393554687511
								],
								[
									-89.72636718750002,
									76.5208007812501
								],
								[
									-89.72646484374994,
									76.50742187500003
								]
							]
						],
						[
							[
								[
									-113.56069335937494,
									76.74326171875003
								],
								[
									-113.71245117187495,
									76.71054687500012
								],
								[
									-114.75146484374997,
									76.75888671875
								],
								[
									-114.80830078125001,
									76.774072265625
								],
								[
									-114.83525390624999,
									76.79467773437503
								],
								[
									-114.64707031250002,
									76.85102539062495
								],
								[
									-114.41987304687501,
									76.87534179687512
								],
								[
									-113.89165039062496,
									76.894873046875
								],
								[
									-113.70751953125001,
									76.87294921875008
								],
								[
									-113.585400390625,
									76.847314453125
								],
								[
									-113.51650390625,
									76.82504882812509
								],
								[
									-113.48759765624997,
									76.7832519531251
								],
								[
									-113.56069335937494,
									76.74326171875003
								]
							]
						],
						[
							[
								[
									-94.29497070312496,
									76.91245117187495
								],
								[
									-94.10795898437496,
									76.90375976562495
								],
								[
									-93.94804687499996,
									76.91708984375
								],
								[
									-93.81093750000002,
									76.91416015625003
								],
								[
									-93.60839843749997,
									76.87382812500007
								],
								[
									-93.420751953125,
									76.81220703124995
								],
								[
									-93.27656249999995,
									76.78432617187505
								],
								[
									-93.23002929687496,
									76.77026367187503
								],
								[
									-93.21186523437501,
									76.75468749999996
								],
								[
									-93.18925781250002,
									76.70800781249994
								],
								[
									-93.18999023437499,
									76.68637695312498
								],
								[
									-93.20058593750002,
									76.66909179687502
								],
								[
									-93.263671875,
									76.62646484374994
								],
								[
									-93.31674804687498,
									76.57368164062504
								],
								[
									-93.42626953124997,
									76.52714843749996
								],
								[
									-93.48457031249995,
									76.492041015625
								],
								[
									-93.53457031250002,
									76.44770507812504
								],
								[
									-93.42187499999997,
									76.47412109375
								],
								[
									-92.99536132812494,
									76.62041015624996
								],
								[
									-92.71625976562493,
									76.60297851562495
								],
								[
									-92.29702148437497,
									76.61601562500005
								],
								[
									-91.78945312499994,
									76.67578125000006
								],
								[
									-91.54843749999995,
									76.68510742187499
								],
								[
									-91.305029296875,
									76.68076171875009
								],
								[
									-91.12426757812497,
									76.66191406250007
								],
								[
									-90.73842773437497,
									76.58134765624999
								],
								[
									-90.60478515624999,
									76.54296875000009
								],
								[
									-90.55463867187501,
									76.51577148437505
								],
								[
									-90.54262695312494,
									76.49575195312497
								],
								[
									-90.62163085937496,
									76.46469726562503
								],
								[
									-90.86406249999999,
									76.48359375000007
								],
								[
									-91.26303710937498,
									76.50024414062509
								],
								[
									-91.33598632812502,
									76.51059570312506
								],
								[
									-91.39809570312497,
									76.50976562499997
								],
								[
									-91.44326171875002,
									76.49853515625
								],
								[
									-91.41508789062496,
									76.4558593750001
								],
								[
									-91.33388671874994,
									76.44648437499995
								],
								[
									-90.85478515624996,
									76.43730468749996
								],
								[
									-89.28452148437498,
									76.30161132812512
								],
								[
									-89.21909179687495,
									76.25820312499997
								],
								[
									-89.23652343749995,
									76.23901367187497
								],
								[
									-89.29208984375,
									76.21772460937498
								],
								[
									-89.40659179687498,
									76.18916015625004
								],
								[
									-90.31206054687496,
									76.15800781249999
								],
								[
									-90.82734374999995,
									76.18559570312502
								],
								[
									-91.260400390625,
									76.22998046875
								],
								[
									-91.40732421874998,
									76.22006835937512
								],
								[
									-91.27944335937497,
									76.15991210937503
								],
								[
									-91.019775390625,
									76.14155273437493
								],
								[
									-90.80239257812502,
									76.10595703125003
								],
								[
									-90.71210937500001,
									76.07617187500011
								],
								[
									-90.25136718749994,
									76.053466796875
								],
								[
									-90.17602539062497,
									76.03027343750009
								],
								[
									-90.03276367187499,
									75.97089843750007
								],
								[
									-89.91254882812501,
									75.96630859375011
								],
								[
									-89.79340820312498,
									75.9248535156251
								],
								[
									-89.6953125,
									75.85361328125006
								],
								[
									-89.650048828125,
									75.84409179687498
								],
								[
									-89.51123046874997,
									75.85693359375003
								],
								[
									-89.27758789062497,
									75.79506835937494
								],
								[
									-89.20488281249999,
									75.76201171874996
								],
								[
									-89.20454101562501,
									75.73725585937498
								],
								[
									-89.25664062499996,
									75.69848632812509
								],
								[
									-89.36123046874997,
									75.64580078125007
								],
								[
									-89.62543945312495,
									75.58374023437497
								],
								[
									-89.64604492187499,
									75.56503906249998
								],
								[
									-89.33730468749997,
									75.57236328125003
								],
								[
									-89.28041992187502,
									75.56411132812497
								],
								[
									-88.91669921874998,
									75.45395507812509
								],
								[
									-88.86884765625001,
									75.45195312500013
								],
								[
									-88.83891601562496,
									75.46347656249998
								],
								[
									-88.80410156249997,
									75.50249023437502
								],
								[
									-88.81962890624993,
									75.53857421875
								],
								[
									-88.86406250000002,
									75.58862304687509
								],
								[
									-88.85214843749998,
									75.62490234375008
								],
								[
									-88.78393554687494,
									75.64746093750006
								],
								[
									-88.71489257812502,
									75.65864257812495
								],
								[
									-88.64497070312498,
									75.658447265625
								],
								[
									-88.56904296874995,
									75.64511718749995
								],
								[
									-88.201318359375,
									75.5120117187501
								],
								[
									-87.72973632812503,
									75.57563476562501
								],
								[
									-87.64365234374998,
									75.54707031249995
								],
								[
									-87.57241210937497,
									75.49365234375
								],
								[
									-87.53911132812502,
									75.48486328125009
								],
								[
									-87.3646484375,
									75.59130859375
								],
								[
									-87.25693359374998,
									75.61772460937496
								],
								[
									-86.814453125,
									75.49135742187505
								],
								[
									-86.54472656250002,
									75.46337890625006
								],
								[
									-86.4365234375,
									75.43627929687494
								],
								[
									-86.23632812499997,
									75.40634765624998
								],
								[
									-85.95146484374996,
									75.39501953124997
								],
								[
									-85.90454101562497,
									75.44194335937513
								],
								[
									-86.06874999999994,
									75.50224609375007
								],
								[
									-85.97299804687498,
									75.52871093750002
								],
								[
									-85.58124999999993,
									75.57978515624995
								],
								[
									-85.372314453125,
									75.572607421875
								],
								[
									-84.98676757812495,
									75.644921875
								],
								[
									-84.75019531250001,
									75.65468749999994
								],
								[
									-84.60488281249997,
									75.65346679687497
								],
								[
									-84.12763671875001,
									75.7626464843751
								],
								[
									-84.0142578125,
									75.77993164062497
								],
								[
									-83.931982421875,
									75.8189453125
								],
								[
									-83.74458007812495,
									75.812841796875
								],
								[
									-83.23710937499993,
									75.75083007812509
								],
								[
									-83.09340820312497,
									75.75644531249998
								],
								[
									-82.55346679687503,
									75.81826171874997
								],
								[
									-82.35385742187503,
									75.83334960937509
								],
								[
									-82.153662109375,
									75.83105468750009
								],
								[
									-81.64736328125,
									75.794921875
								],
								[
									-81.2685546875,
									75.75600585937508
								],
								[
									-81.15078125,
									75.73554687499998
								],
								[
									-81.19267578124999,
									75.68437500000005
								],
								[
									-81.17353515625001,
									75.66923828125007
								],
								[
									-81.12441406250002,
									75.65815429687504
								],
								[
									-81.00078124999999,
									75.64311523437499
								],
								[
									-80.52773437499997,
									75.64213867187496
								],
								[
									-80.32197265624998,
									75.62910156250007
								],
								[
									-80.15834960937494,
									75.58115234374998
								],
								[
									-80.11918945312496,
									75.56206054687499
								],
								[
									-80.12573242187497,
									75.54213867187502
								],
								[
									-80.28662109374997,
									75.49038085937505
								],
								[
									-80.26044921874995,
									75.47944335937504
								],
								[
									-80.09960937499997,
									75.46743164062508
								],
								[
									-79.73769531249997,
									75.46147460937502
								],
								[
									-79.66020507812499,
									75.44951171875007
								],
								[
									-79.58574218749999,
									75.38486328124995
								],
								[
									-79.50781250000003,
									75.29536132812493
								],
								[
									-79.50908203125002,
									75.25981445312496
								],
								[
									-79.63442382812497,
									75.19931640625006
								],
								[
									-79.97714843749998,
									75.11860351562507
								],
								[
									-80.35756835937494,
									75.05156249999999
								],
								[
									-80.38198242187494,
									75.0341796875
								],
								[
									-80.26064453125,
									75.00214843750004
								],
								[
									-80.13525390624994,
									74.98808593750013
								],
								[
									-80.03642578124999,
									74.99091796874998
								],
								[
									-79.73300781249998,
									75.02143554687498
								],
								[
									-79.66406249999997,
									75.02084960937495
								],
								[
									-79.52480468750002,
									74.98969726562501
								],
								[
									-79.46040039062495,
									74.95878906250002
								],
								[
									-79.40141601562502,
									74.91762695312505
								],
								[
									-79.50795898437497,
									74.88012695312497
								],
								[
									-79.944482421875,
									74.83364257812511
								],
								[
									-80.20244140624996,
									74.89482421875005
								],
								[
									-80.28920898437497,
									74.90830078125003
								],
								[
									-80.34775390624998,
									74.90297851562511
								],
								[
									-80.31455078124998,
									74.87617187500007
								],
								[
									-80.18974609374996,
									74.82768554687505
								],
								[
									-80.14892578124997,
									74.7957031250001
								],
								[
									-80.192236328125,
									74.78017578125005
								],
								[
									-80.21269531250002,
									74.7494628906251
								],
								[
									-80.21025390624996,
									74.70361328125009
								],
								[
									-80.22060546875002,
									74.65703125000007
								],
								[
									-80.26274414062499,
									74.58447265625006
								],
								[
									-80.27773437500002,
									74.58159179687499
								],
								[
									-81.226220703125,
									74.56665039062497
								],
								[
									-81.340478515625,
									74.55351562499996
								],
								[
									-81.60717773437497,
									74.50234375000002
								],
								[
									-81.80883789062503,
									74.47661132812502
								],
								[
									-81.94018554687494,
									74.47270507812502
								],
								[
									-82.068505859375,
									74.48208007812497
								],
								[
									-82.41474609375001,
									74.53520507812496
								],
								[
									-82.64541015625002,
									74.52519531249996
								],
								[
									-82.73579101562495,
									74.53027343750003
								],
								[
									-82.93105468750002,
									74.56557617187502
								],
								[
									-82.97841796875,
									74.58344726562493
								],
								[
									-83.05761718749997,
									74.62978515625005
								],
								[
									-83.11699218749999,
									74.69311523437497
								],
								[
									-83.1123046875,
									74.73212890624993
								],
								[
									-83.08730468749997,
									74.78837890625002
								],
								[
									-83.10263671874998,
									74.816552734375
								],
								[
									-83.15830078124995,
									74.81674804687503
								],
								[
									-83.22031249999998,
									74.8284179687501
								],
								[
									-83.40703125000002,
									74.88481445312505
								],
								[
									-83.5220703125,
									74.90146484375006
								],
								[
									-83.54355468750003,
									74.89228515625004
								],
								[
									-83.50976562499997,
									74.84819335937505
								],
								[
									-83.48730468750003,
									74.83413085937502
								],
								[
									-83.36420898437498,
									74.80190429687494
								],
								[
									-83.34130859375003,
									74.76459960937507
								],
								[
									-83.39370117187497,
									74.67016601562509
								],
								[
									-83.41220703125,
									74.65498046875001
								],
								[
									-83.53188476562497,
									74.58569335937494
								],
								[
									-83.62187499999999,
									74.56591796875
								],
								[
									-83.86806640624997,
									74.56440429687495
								],
								[
									-84.24516601562496,
									74.51518554687496
								],
								[
									-84.42553710937503,
									74.50810546875013
								],
								[
									-84.66708984375003,
									74.51958007812507
								],
								[
									-84.81826171875002,
									74.54199218750009
								],
								[
									-84.91630859374999,
									74.5676757812501
								],
								[
									-85.01152343749996,
									74.60419921874998
								],
								[
									-85.06142578125,
									74.60693359375
								],
								[
									-85.086767578125,
									74.52768554687503
								],
								[
									-85.133447265625,
									74.51743164062498
								],
								[
									-85.21430664062495,
									74.51865234375006
								],
								[
									-85.33925781250002,
									74.543310546875
								],
								[
									-85.44233398437495,
									74.60058593750006
								],
								[
									-85.47441406250002,
									74.600341796875
								],
								[
									-85.488671875,
									74.56699218749995
								],
								[
									-85.51171874999997,
									74.54511718750001
								],
								[
									-85.54350585937496,
									74.53476562500003
								],
								[
									-85.80800781249994,
									74.49897460937495
								],
								[
									-85.95561523437499,
									74.498779296875
								],
								[
									-86.10986328124997,
									74.5397460937501
								],
								[
									-86.21093749999997,
									74.53559570312495
								],
								[
									-86.340576171875,
									74.51347656250007
								],
								[
									-86.65541992187502,
									74.55541992187509
								],
								[
									-86.73076171874999,
									74.55703124999997
								],
								[
									-86.66611328124998,
									74.48911132812498
								],
								[
									-86.77016601562502,
									74.47861328124998
								],
								[
									-86.99472656250003,
									74.48032226562506
								],
								[
									-87.36376953125,
									74.50219726562509
								],
								[
									-87.59257812499999,
									74.47036132812508
								],
								[
									-88.00585937499997,
									74.48935546874995
								],
								[
									-88.42304687499995,
									74.49414062499994
								],
								[
									-88.50073242187497,
									74.50971679687501
								],
								[
									-88.55566406249997,
									74.54145507812498
								],
								[
									-88.557861328125,
									74.56972656250005
								],
								[
									-88.53764648437496,
									74.60878906249994
								],
								[
									-88.47661132812496,
									74.66689453124997
								],
								[
									-88.37470703124998,
									74.74414062500006
								],
								[
									-88.33955078125001,
									74.78486328124993
								],
								[
									-88.43144531249999,
									74.80371093749994
								],
								[
									-88.48818359375,
									74.82890625000002
								],
								[
									-88.53496093749993,
									74.83173828125007
								],
								[
									-88.68203124999997,
									74.80200195312506
								],
								[
									-88.77783203124994,
									74.71518554687495
								],
								[
									-88.85107421874994,
									74.68999023437496
								],
								[
									-88.88339843749995,
									74.711083984375
								],
								[
									-88.90781249999995,
									74.763818359375
								],
								[
									-88.94013671874998,
									74.78950195312498
								],
								[
									-88.98037109375,
									74.78808593750006
								],
								[
									-89.01962890625,
									74.77402343750003
								],
								[
									-89.05786132812497,
									74.7472656250001
								],
								[
									-89.11528320312496,
									74.73759765625007
								],
								[
									-89.19194335937493,
									74.74487304687503
								],
								[
									-89.21914062499997,
									74.73178710937495
								],
								[
									-89.19682617187496,
									74.69824218750006
								],
								[
									-89.18906249999998,
									74.66684570312495
								],
								[
									-89.19580078125,
									74.63754882812503
								],
								[
									-89.26186523437497,
									74.60917968750002
								],
								[
									-89.45000000000002,
									74.56791992187496
								],
								[
									-89.55869140624995,
									74.55473632812513
								],
								[
									-89.844384765625,
									74.54858398437503
								],
								[
									-90.01533203124998,
									74.56088867187495
								],
								[
									-90.36162109375002,
									74.61044921875
								],
								[
									-90.55327148437499,
									74.61274414062504
								],
								[
									-90.78408203125002,
									74.6958984375
								],
								[
									-90.96679687500003,
									74.71508789062511
								],
								[
									-90.95751953125,
									74.74516601562502
								],
								[
									-90.87763671874998,
									74.80107421875013
								],
								[
									-90.88022460937498,
									74.81777343749997
								],
								[
									-91.12988281249994,
									74.73627929687498
								],
								[
									-91.163720703125,
									74.7102539062501
								],
								[
									-91.13457031250002,
									74.64985351562495
								],
								[
									-91.16772460937503,
									74.64550781250006
								],
								[
									-91.339453125,
									74.66723632812494
								],
								[
									-91.50834960937496,
									74.65068359375005
								],
								[
									-91.54912109375002,
									74.65556640624996
								],
								[
									-91.66577148437497,
									74.69916992187507
								],
								[
									-91.87104492187495,
									74.74350585937503
								],
								[
									-91.96157226562502,
									74.79321289062494
								],
								[
									-92.10253906249994,
									74.94838867187494
								],
								[
									-92.17416992187498,
									75.05107421874999
								],
								[
									-92.16523437499993,
									75.07202148437509
								],
								[
									-92.06049804687501,
									75.10097656249994
								],
								[
									-92.07631835937494,
									75.12353515625
								],
								[
									-92.20683593749999,
									75.18124999999995
								],
								[
									-92.34746093749993,
									75.22978515625007
								],
								[
									-92.3892578125,
									75.26333007812497
								],
								[
									-92.408349609375,
									75.29726562500005
								],
								[
									-92.427099609375,
									75.34638671874993
								],
								[
									-92.427978515625,
									75.38271484375005
								],
								[
									-92.41108398437493,
									75.40625000000006
								],
								[
									-92.33066406249998,
									75.47944335937504
								],
								[
									-92.11044921874998,
									75.61064453125013
								],
								[
									-92.08071289062494,
									75.6344726562501
								],
								[
									-92.06884765625003,
									75.65791015624998
								],
								[
									-92.09916992187499,
									75.72729492187509
								],
								[
									-92.14184570312497,
									75.79682617187504
								],
								[
									-92.18510742187499,
									75.84653320312495
								],
								[
									-92.30659179687495,
									75.91513671874998
								],
								[
									-92.47373046875,
									75.98647460937502
								],
								[
									-92.70888671875002,
									76.1144531250001
								],
								[
									-92.88330078125003,
									76.21396484375012
								],
								[
									-93.09174804687495,
									76.35400390624994
								],
								[
									-93.19228515625002,
									76.36601562500007
								],
								[
									-93.30859375,
									76.35961914062494
								],
								[
									-93.55996093749997,
									76.31142578125008
								],
								[
									-93.64443359375002,
									76.28852539062493
								],
								[
									-93.665185546875,
									76.2731445312501
								],
								[
									-93.85234375000002,
									76.269677734375
								],
								[
									-94.38256835937503,
									76.28232421875
								],
								[
									-94.58535156249997,
									76.2971679687501
								],
								[
									-94.73671874999997,
									76.2932617187501
								],
								[
									-94.99663085937499,
									76.25771484374997
								],
								[
									-95.27387695312498,
									76.26440429687509
								],
								[
									-95.447412109375,
									76.36303710937511
								],
								[
									-95.841650390625,
									76.416162109375
								],
								[
									-95.95927734374999,
									76.44599609374995
								],
								[
									-96.03969726562494,
									76.48671875000008
								],
								[
									-96.01308593749994,
									76.513330078125
								],
								[
									-95.78886718750002,
									76.53720703125006
								],
								[
									-95.69570312499994,
									76.56342773437498
								],
								[
									-95.65097656249998,
									76.58466796874995
								],
								[
									-95.87319335937497,
									76.56640624999997
								],
								[
									-95.97133789062497,
									76.5696289062501
								],
								[
									-96.63969726562496,
									76.70292968750007
								],
								[
									-96.84565429687501,
									76.72641601562506
								],
								[
									-96.88071289062495,
									76.73833007812507
								],
								[
									-96.89799804687502,
									76.75400390625009
								],
								[
									-96.89755859375,
									76.77348632812496
								],
								[
									-96.87802734375003,
									76.80278320312499
								],
								[
									-96.67939453124998,
									76.765771484375
								],
								[
									-96.59028320312493,
									76.76303710937506
								],
								[
									-96.45117187500003,
									76.774072265625
								],
								[
									-96.40156249999995,
									76.797216796875
								],
								[
									-96.433203125,
									76.810693359375
								],
								[
									-96.66103515624997,
									76.8551757812501
								],
								[
									-96.77114257812502,
									76.88891601562494
								],
								[
									-96.81352539062493,
									76.91347656250005
								],
								[
									-96.76982421875002,
									76.94824218750003
								],
								[
									-96.75830078124997,
									76.97177734374995
								],
								[
									-96.68510742187499,
									76.98500976562508
								],
								[
									-96.55009765625002,
									76.98793945312505
								],
								[
									-96.37729492187498,
									77.00458984375007
								],
								[
									-96.06123046874998,
									77.050048828125
								],
								[
									-95.84951171875002,
									77.0662109375001
								],
								[
									-95.63823242187496,
									77.06376953125005
								],
								[
									-95.12641601562495,
									77.017333984375
								],
								[
									-94.61611328125,
									76.95834960937506
								],
								[
									-94.29497070312496,
									76.91245117187495
								]
							]
						],
						[
							[
								[
									-115.55126953125003,
									77.36328125000003
								],
								[
									-115.47558593749997,
									77.32431640625
								],
								[
									-115.47021484375003,
									77.30864257812502
								],
								[
									-115.50664062499999,
									77.29213867187494
								],
								[
									-115.62392578125,
									77.26591796875002
								],
								[
									-116.21372070312498,
									77.17822265625
								],
								[
									-116.32919921874996,
									77.13706054687506
								],
								[
									-116.28574218749999,
									77.10166015624995
								],
								[
									-116.07309570312502,
									77.0299804687501
								],
								[
									-115.85683593750001,
									76.96923828124997
								],
								[
									-115.81005859374999,
									76.93911132812505
								],
								[
									-115.91289062499997,
									76.90844726562511
								],
								[
									-116.10976562500002,
									76.91821289062506
								],
								[
									-116.183251953125,
									76.91557617187496
								],
								[
									-116.25273437500002,
									76.9014160156251
								],
								[
									-116.23398437500002,
									76.87431640624999
								],
								[
									-116.01621093749998,
									76.78452148437509
								],
								[
									-115.94458007812494,
									76.73623046875002
								],
								[
									-115.94628906250003,
									76.71127929687509
								],
								[
									-115.98481445312497,
									76.68691406250008
								],
								[
									-116.07622070312495,
									76.65351562499995
								],
								[
									-116.22045898437501,
									76.61108398437509
								],
								[
									-116.46762695312502,
									76.57714843750003
								],
								[
									-116.99921874999995,
									76.53159179687498
								],
								[
									-117.01679687499998,
									76.49609374999994
								],
								[
									-117.01328124999998,
									76.46909179687495
								],
								[
									-117.02617187499995,
									76.4035156250001
								],
								[
									-117.04448242187495,
									76.37309570312502
								],
								[
									-117.10776367187495,
									76.32192382812508
								],
								[
									-117.15390625000003,
									76.297998046875
								],
								[
									-117.23359375000001,
									76.28154296875002
								],
								[
									-117.346923828125,
									76.27255859375006
								],
								[
									-117.49238281249997,
									76.272705078125
								],
								[
									-117.73242187500003,
									76.31674804687509
								],
								[
									-117.84140625000002,
									76.34482421874995
								],
								[
									-117.99296874999999,
									76.40581054687502
								],
								[
									-118.02021484374995,
									76.44653320312497
								],
								[
									-118.00541992187496,
									76.49667968749998
								],
								[
									-117.96542968749998,
									76.5740234375001
								],
								[
									-117.89951171874996,
									76.65307617187494
								],
								[
									-117.80761718749999,
									76.73393554687499
								],
								[
									-117.78046874999995,
									76.78427734374995
								],
								[
									-117.81791992187495,
									76.80410156250008
								],
								[
									-117.88081054687497,
									76.80507812500011
								],
								[
									-118.07641601562503,
									76.77236328125008
								],
								[
									-118.20278320312502,
									76.76049804687509
								],
								[
									-118.30058593749996,
									76.73666992187509
								],
								[
									-118.36987304687496,
									76.7009765625001
								],
								[
									-118.40913085937495,
									76.66230468750004
								],
								[
									-118.43100585937498,
									76.58798828125
								],
								[
									-118.4681640625,
									76.54736328125
								],
								[
									-118.573681640625,
									76.5251953125001
								],
								[
									-118.73154296875,
									76.5255859375001
								],
								[
									-118.79140624999994,
									76.5129882812501
								],
								[
									-118.82075195312497,
									76.48583984375009
								],
								[
									-118.799560546875,
									76.46376953125002
								],
								[
									-118.643896484375,
									76.41752929687502
								],
								[
									-118.62451171874996,
									76.36586914062497
								],
								[
									-118.64340820312499,
									76.33466796875001
								],
								[
									-118.81157226562496,
									76.277099609375
								],
								[
									-118.85112304687495,
									76.25781250000006
								],
								[
									-118.95546874999997,
									76.16767578125001
								],
								[
									-118.99394531249999,
									76.14487304687498
								],
								[
									-119.080712890625,
									76.1240722656251
								],
								[
									-119.16821289062497,
									76.12651367187496
								],
								[
									-119.24926757812496,
									76.15947265625002
								],
								[
									-119.36791992187497,
									76.22177734375
								],
								[
									-119.447802734375,
									76.27539062500009
								],
								[
									-119.488818359375,
									76.32031250000011
								],
								[
									-119.52373046875002,
									76.3402832031251
								],
								[
									-119.58037109375,
									76.32651367187495
								],
								[
									-119.64892578125003,
									76.27988281249995
								],
								[
									-119.65078124999997,
									76.24370117187505
								],
								[
									-119.63583984375002,
									76.1898925781251
								],
								[
									-119.6396484375,
									76.15668945312498
								],
								[
									-119.73964843749995,
									76.11772460937505
								],
								[
									-119.72519531250002,
									76.09995117187498
								],
								[
									-119.54970703124998,
									76.05205078124999
								],
								[
									-119.5271484375,
									76.03056640624996
								],
								[
									-119.52612304687497,
									75.99721679687508
								],
								[
									-119.53774414062502,
									75.98217773437506
								],
								[
									-119.60795898437495,
									75.98457031250001
								],
								[
									-119.66713867187501,
									75.94599609374995
								],
								[
									-119.73481445312503,
									75.91542968750005
								],
								[
									-119.91289062499997,
									75.85883789062507
								],
								[
									-120.16054687499998,
									75.85195312500008
								],
								[
									-120.36538085937497,
									75.82475585937505
								],
								[
									-120.40888671874995,
									75.82563476562495
								],
								[
									-120.45830078124999,
									75.87016601562496
								],
								[
									-120.51381835937501,
									75.95834960937509
								],
								[
									-120.56328124999996,
									76.00844726562508
								],
								[
									-120.63715820312501,
									76.03403320312495
								],
								[
									-120.728662109375,
									76.13408203125007
								],
								[
									-120.77158203125003,
									76.16630859374999
								],
								[
									-120.81337890625002,
									76.17929687499998
								],
								[
									-120.84838867187496,
									76.18266601562505
								],
								[
									-120.90009765625001,
									76.16342773437503
								],
								[
									-121.01928710937496,
									76.02026367187509
								],
								[
									-121.2134765625,
									75.9836914062501
								],
								[
									-121.32016601562498,
									75.97700195312507
								],
								[
									-121.427978515625,
									75.98110351562511
								],
								[
									-121.69453124999995,
									76.0203125000001
								],
								[
									-121.90820312499996,
									76.03476562500009
								],
								[
									-122.05742187499999,
									76.01821289062502
								],
								[
									-122.30273437499996,
									75.95981445312512
								],
								[
									-122.40048828124998,
									75.94423828125005
								],
								[
									-122.53305664062498,
									75.95092773437509
								],
								[
									-122.59111328125,
									75.97299804687495
								],
								[
									-122.64047851562502,
									76.00908203125002
								],
								[
									-122.64594726562498,
									76.03100585937506
								],
								[
									-122.60737304687503,
									76.038671875
								],
								[
									-122.546240234375,
									76.08051757812493
								],
								[
									-122.54819335937496,
									76.09731445312497
								],
								[
									-122.60864257812501,
									76.12143554687509
								],
								[
									-122.60947265625,
									76.14028320312502
								],
								[
									-122.58789062499996,
									76.15297851562494
								],
								[
									-122.59272460937497,
									76.16206054687493
								],
								[
									-122.62392578125002,
									76.16748046875006
								],
								[
									-122.68466796874996,
									76.16240234374999
								],
								[
									-122.90278320312498,
									76.13471679687495
								],
								[
									-122.87827148437496,
									76.16479492187494
								],
								[
									-122.77402343749996,
									76.22768554687497
								],
								[
									-122.51938476562503,
									76.35317382812505
								],
								[
									-122.42304687499995,
									76.39008789062493
								],
								[
									-122.36538085937502,
									76.40122070312498
								],
								[
									-121.61376953125001,
									76.4414550781251
								],
								[
									-121.56113281250003,
									76.45346679687506
								],
								[
									-121.20390625,
									76.62216796875003
								],
								[
									-121.10200195312503,
									76.6607421875
								],
								[
									-120.99760742187499,
									76.69145507812505
								],
								[
									-120.48535156249999,
									76.79321289062509
								],
								[
									-120.43759765625003,
									76.81645507812502
								],
								[
									-120.357666015625,
									76.88691406249998
								],
								[
									-120.31093749999998,
									76.90458984375013
								],
								[
									-120.20034179687501,
									76.93134765625007
								],
								[
									-119.83115234375002,
									77.07387695312497
								],
								[
									-119.49482421874998,
									77.176904296875
								],
								[
									-119.323974609375,
									77.24067382812493
								],
								[
									-119.09018554687498,
									77.305078125
								],
								[
									-118.82001953125,
									77.33271484375004
								],
								[
									-118.00517578124999,
									77.38120117187506
								],
								[
									-117.41860351562495,
									77.31738281250011
								],
								[
									-117.27910156249996,
									77.31337890625
								],
								[
									-117.21079101562498,
									77.33144531250005
								],
								[
									-117.148974609375,
									77.36083984375009
								],
								[
									-117.061376953125,
									77.34848632812503
								],
								[
									-116.84355468749995,
									77.33955078125001
								],
								[
									-116.79531249999998,
									77.34658203125002
								],
								[
									-116.70361328124996,
									77.37993164062505
								],
								[
									-116.76625976562501,
									77.39824218750005
								],
								[
									-117.02978515624997,
									77.43188476562509
								],
								[
									-117.04575195312502,
									77.448974609375
								],
								[
									-117.03974609374995,
									77.4651367187501
								],
								[
									-116.94716796875001,
									77.50385742187507
								],
								[
									-116.83530273437496,
									77.52885742187502
								],
								[
									-116.51132812500003,
									77.54760742187503
								],
								[
									-116.36259765625002,
									77.54282226562503
								],
								[
									-116.20888671874997,
									77.51601562500008
								],
								[
									-116.0080078125,
									77.46064453124998
								],
								[
									-115.55126953125003,
									77.36328125000003
								]
							]
						],
						[
							[
								[
									-89.83325195312503,
									77.2676269531251
								],
								[
									-90.0947265625,
									77.21040039062498
								],
								[
									-90.22827148437503,
									77.21245117187496
								],
								[
									-90.99321289062499,
									77.3294921875
								],
								[
									-91.14726562499993,
									77.38730468750006
								],
								[
									-91.17661132812498,
									77.42626953125
								],
								[
									-91.18505859375,
									77.48154296874998
								],
								[
									-91.18266601562496,
									77.55717773437502
								],
								[
									-91.14946289062493,
									77.608056640625
								],
								[
									-91.109130859375,
									77.62573242187503
								],
								[
									-91.01904296875003,
									77.643896484375
								],
								[
									-90.84257812499996,
									77.65498046874995
								],
								[
									-90.67485351562499,
									77.6486328125001
								],
								[
									-90.42275390624997,
									77.62836914062495
								],
								[
									-90.17192382812502,
									77.59467773437493
								],
								[
									-89.83896484375003,
									77.49140625000004
								],
								[
									-89.71948242187503,
									77.44213867187494
								],
								[
									-89.69418945312503,
									77.37812499999995
								],
								[
									-89.69458007812503,
									77.33896484374998
								],
								[
									-89.71201171875,
									77.31040039062509
								],
								[
									-89.74667968749998,
									77.29257812500003
								],
								[
									-89.83325195312503,
									77.2676269531251
								]
							]
						],
						[
							[
								[
									-104.55815429687497,
									77.14174804687494
								],
								[
									-104.71137695312501,
									77.12397460937495
								],
								[
									-105.015576171875,
									77.16459960937507
								],
								[
									-105.21508789062496,
									77.18208007812498
								],
								[
									-105.37993164062497,
									77.25424804687495
								],
								[
									-105.55634765625003,
									77.35263671875
								],
								[
									-105.69511718749996,
									77.46137695312495
								],
								[
									-105.74721679687501,
									77.52539062499994
								],
								[
									-105.84814453124997,
									77.56342773437495
								],
								[
									-105.88315429687499,
									77.62651367187502
								],
								[
									-106.06611328124997,
									77.7253906250001
								],
								[
									-106.03559570312497,
									77.73984375000012
								],
								[
									-105.86298828124997,
									77.75439453125006
								],
								[
									-105.58789062499997,
									77.73598632812494
								],
								[
									-105.45610351562503,
									77.700927734375
								],
								[
									-105.28964843749996,
									77.64208984375
								],
								[
									-105.07387695312497,
									77.54829101562498
								],
								[
									-105.00722656249998,
									77.50673828125005
								],
								[
									-104.99428710937501,
									77.44965820312504
								],
								[
									-104.95532226562497,
									77.41870117187506
								],
								[
									-104.77021484375001,
									77.41323242187508
								],
								[
									-104.54223632812501,
									77.33774414062509
								],
								[
									-104.50078125,
									77.30854492187507
								],
								[
									-104.4537109375,
									77.24912109375006
								],
								[
									-104.45698242187497,
									77.22080078125006
								],
								[
									-104.49335937500001,
									77.16235351562506
								],
								[
									-104.55815429687497,
									77.14174804687494
								]
							]
						],
						[
							[
								[
									-95.48437499999997,
									77.79199218750009
								],
								[
									-95.23305664062502,
									77.75380859374994
								],
								[
									-94.95991210937495,
									77.77407226562505
								],
								[
									-94.66679687499993,
									77.77622070312506
								],
								[
									-94.01474609374998,
									77.75991210937494
								],
								[
									-93.582861328125,
									77.77075195312509
								],
								[
									-93.47109374999997,
									77.76430664062494
								],
								[
									-93.30097656249995,
									77.7397949218751
								],
								[
									-93.21074218749996,
									77.71020507812503
								],
								[
									-93.12871093749993,
									77.66015624999994
								],
								[
									-93.33916015624999,
									77.62968749999996
								],
								[
									-93.51958007812499,
									77.47441406250013
								],
								[
									-93.54394531249997,
									77.46665039062506
								],
								[
									-93.74018554687498,
									77.46455078124998
								],
								[
									-93.836181640625,
									77.45224609375003
								],
								[
									-94.40898437499999,
									77.47421875000009
								],
								[
									-95.98706054687497,
									77.48413085937497
								],
								[
									-96.05610351562501,
									77.5034667968751
								],
								[
									-96.26386718749995,
									77.59453124999999
								],
								[
									-96.27661132812497,
									77.63056640624995
								],
								[
									-96.23916015625,
									77.67255859374998
								],
								[
									-96.19458007812497,
									77.700537109375
								],
								[
									-96.14296875000002,
									77.71435546874997
								],
								[
									-95.68393554687503,
									77.78227539062496
								],
								[
									-95.48437499999997,
									77.79199218750009
								]
							]
						],
						[
							[
								[
									-101.6935546875,
									77.69658203125007
								],
								[
									-101.83105468750003,
									77.68735351562498
								],
								[
									-102.079833984375,
									77.69218749999999
								],
								[
									-102.37783203124997,
									77.72812500000003
								],
								[
									-102.458203125,
									77.77016601562508
								],
								[
									-102.47504882812495,
									77.83666992187494
								],
								[
									-102.47153320312495,
									77.87348632812498
								],
								[
									-102.44770507812498,
									77.88061523437509
								],
								[
									-102.26318359374996,
									77.88935546874993
								],
								[
									-101.91787109374995,
									77.89960937500007
								],
								[
									-101.63940429687499,
									77.89208984374994
								],
								[
									-101.32202148437499,
									77.85415039062502
								],
								[
									-101.19321289062493,
									77.82978515624995
								],
								[
									-101.12758789062498,
									77.81259765625
								],
								[
									-101.04624023437502,
									77.77783203124994
								],
								[
									-101.019580078125,
									77.762451171875
								],
								[
									-101.00205078124999,
									77.73510742187494
								],
								[
									-101.39765625000003,
									77.72905273437505
								],
								[
									-101.5845703125,
									77.71831054687499
								],
								[
									-101.6935546875,
									77.69658203125007
								]
							]
						],
						[
							[
								[
									-113.83247070312498,
									77.75463867187511
								],
								[
									-114.105908203125,
									77.72070312499994
								],
								[
									-114.28720703124998,
									77.7214843750001
								],
								[
									-114.60834960937495,
									77.76933593749999
								],
								[
									-114.98041992187498,
									77.9154296875
								],
								[
									-115.029345703125,
									77.96752929687503
								],
								[
									-114.89042968749995,
									77.97690429687509
								],
								[
									-114.789501953125,
									77.99291992187497
								],
								[
									-114.72646484374994,
									78.01552734374997
								],
								[
									-114.60688476562501,
									78.04033203125005
								],
								[
									-114.33037109374999,
									78.07753906250008
								],
								[
									-114.296875,
									78.06318359374998
								],
								[
									-114.30288085937498,
									78.03271484375
								],
								[
									-114.27983398437499,
									78.00429687500008
								],
								[
									-114.18095703125,
									77.99824218750007
								],
								[
									-114.08720703125,
									77.97792968749994
								],
								[
									-113.89775390624996,
									77.9155761718751
								],
								[
									-113.768017578125,
									77.90356445312497
								],
								[
									-113.72138671875,
									77.88989257812494
								],
								[
									-113.69667968750002,
									77.86894531250013
								],
								[
									-113.61791992187497,
									77.83242187499997
								],
								[
									-113.619384765625,
									77.81347656250009
								],
								[
									-113.72583007812501,
									77.77578124999997
								],
								[
									-113.83247070312498,
									77.75463867187511
								]
							]
						],
						[
							[
								[
									-110.45805664062497,
									78.10322265625007
								],
								[
									-109.656884765625,
									78.07924804687505
								],
								[
									-109.62226562499995,
									78.07475585937505
								],
								[
									-109.61904296875001,
									78.05683593750004
								],
								[
									-109.67939453124997,
									77.99931640625013
								],
								[
									-109.77177734374996,
									77.95742187499994
								],
								[
									-110.19951171874996,
									77.90483398437505
								],
								[
									-110.751123046875,
									77.85722656250005
								],
								[
									-110.86562499999995,
									77.83413085937505
								],
								[
									-110.85654296874998,
									77.82036132812499
								],
								[
									-110.81162109374996,
									77.80317382812495
								],
								[
									-110.71938476562501,
									77.78144531250007
								],
								[
									-110.29218750000001,
									77.786376953125
								],
								[
									-110.189208984375,
									77.77700195312505
								],
								[
									-110.15273437500002,
									77.76293945312511
								],
								[
									-110.13085937500001,
									77.74238281250001
								],
								[
									-110.11757812499997,
									77.71557617187506
								],
								[
									-110.11689453125001,
									77.62470703124993
								],
								[
									-110.13945312499999,
									77.57211914062495
								],
								[
									-110.19848632812503,
									77.52451171875003
								],
								[
									-110.37153320312501,
									77.49062499999997
								],
								[
									-110.68286132812503,
									77.44589843750009
								],
								[
									-110.89399414062497,
									77.42597656250001
								],
								[
									-111.06044921874995,
									77.43315429687507
								],
								[
									-111.22622070312497,
									77.4285156250001
								],
								[
									-111.95195312500003,
									77.34418945312507
								],
								[
									-112.17651367187503,
									77.34374999999997
								],
								[
									-112.37265625000002,
									77.36411132812495
								],
								[
									-112.64379882812501,
									77.44370117187509
								],
								[
									-112.92563476562498,
									77.47495117187506
								],
								[
									-113.046044921875,
									77.51074218749997
								],
								[
									-113.16435546875002,
									77.53027343750006
								],
								[
									-113.19711914062495,
									77.558837890625
								],
								[
									-113.20854492187496,
									77.58017578125009
								],
								[
									-113.188623046875,
									77.599755859375
								],
								[
									-113.13740234374995,
									77.61752929687506
								],
								[
									-113.120654296875,
									77.63261718750002
								],
								[
									-113.1677734375,
									77.67646484374998
								],
								[
									-113.18950195312499,
									77.71831054687499
								],
								[
									-113.27128906249996,
									77.77841796874998
								],
								[
									-113.28344726562494,
									77.8130371093751
								],
								[
									-113.28295898437503,
									77.8356445312501
								],
								[
									-113.2693359375,
									77.8600585937501
								],
								[
									-113.21518554687499,
									77.90351562500007
								],
								[
									-113.18706054687503,
									77.91235351562509
								],
								[
									-113.021630859375,
									77.91914062499995
								],
								[
									-112.80454101562499,
									77.9416015625001
								],
								[
									-112.30458984375001,
									78.00678710937495
								],
								[
									-111.20659179687496,
									78.08813476562509
								],
								[
									-110.8732421875,
									78.08061523437499
								],
								[
									-110.72734375000003,
									78.09658203125005
								],
								[
									-110.45805664062497,
									78.10322265625007
								]
							]
						],
						[
							[
								[
									-103.00336914062494,
									78.14643554687498
								],
								[
									-103.11821289062499,
									78.12636718750008
								],
								[
									-103.25224609375002,
									78.13813476562498
								],
								[
									-103.27099609375003,
									78.15063476562503
								],
								[
									-103.27358398437502,
									78.16577148437511
								],
								[
									-103.26005859375002,
									78.18349609375008
								],
								[
									-103.11044921875,
									78.24584960937509
								],
								[
									-102.97329101562495,
									78.267236328125
								],
								[
									-102.89179687499995,
									78.27124023437509
								],
								[
									-102.82553710937495,
									78.25004882812496
								],
								[
									-102.78828125,
									78.21816406249994
								],
								[
									-103.00336914062494,
									78.14643554687498
								]
							]
						],
						[
							[
								[
									-109.81596679687499,
									78.65039062500006
								],
								[
									-109.64096679687495,
									78.5920898437501
								],
								[
									-109.58085937499996,
									78.59326171874997
								],
								[
									-109.50415039062497,
									78.5824707031251
								],
								[
									-109.46728515625,
									78.56718749999999
								],
								[
									-109.36220703125001,
									78.49287109374995
								],
								[
									-109.342138671875,
									78.45600585937507
								],
								[
									-109.33603515625,
									78.40844726562509
								],
								[
									-109.35209960937499,
									78.36865234375006
								],
								[
									-109.39052734375,
									78.33666992187511
								],
								[
									-109.48447265624995,
									78.31640624999997
								],
								[
									-109.7087890625,
									78.30375976562507
								],
								[
									-110.02187500000001,
									78.32280273437513
								],
								[
									-110.29345703125001,
									78.29819335937509
								],
								[
									-110.41835937499997,
									78.29497070312496
								],
								[
									-110.755078125,
									78.31074218750007
								],
								[
									-110.84003906249998,
									78.32231445312502
								],
								[
									-111.02675781250001,
									78.36762695312493
								],
								[
									-111.16918945312499,
									78.38627929687507
								],
								[
									-111.22900390625,
									78.376318359375
								],
								[
									-111.30048828125,
									78.336572265625
								],
								[
									-111.43505859374997,
									78.287353515625
								],
								[
									-111.51748046874998,
									78.2747070312501
								],
								[
									-111.75971679687503,
									78.282958984375
								],
								[
									-112.13124999999997,
									78.36606445312506
								],
								[
									-112.5578125,
									78.34150390625001
								],
								[
									-112.99990234375001,
									78.29291992187498
								],
								[
									-113.172509765625,
									78.28378906250009
								],
								[
									-113.223046875,
									78.29790039062502
								],
								[
									-113.29257812499995,
									78.334375
								],
								[
									-113.28168945312494,
									78.35278320312511
								],
								[
									-113.14995117187502,
									78.40839843750007
								],
								[
									-112.85585937499997,
									78.46684570312507
								],
								[
									-112.64082031249994,
									78.49980468750013
								],
								[
									-112.21401367187495,
									78.54780273437495
								],
								[
									-111.70878906249996,
									78.57470703125011
								],
								[
									-111.51987304687502,
									78.60322265625004
								],
								[
									-111.400341796875,
									78.64404296875003
								],
								[
									-111.07148437499997,
									78.70839843750008
								],
								[
									-110.877587890625,
									78.7350585937501
								],
								[
									-110.61806640624997,
									78.75781250000011
								],
								[
									-110.40781249999995,
									78.75664062499996
								],
								[
									-110.14047851562502,
									78.70444335937498
								],
								[
									-109.94086914062503,
									78.67846679687511
								],
								[
									-109.81596679687499,
									78.65039062500006
								]
							]
						],
						[
							[
								[
									-96.20449218749994,
									78.53129882812496
								],
								[
									-95.96845703125001,
									78.50512695312506
								],
								[
									-95.56113281249998,
									78.51660156250009
								],
								[
									-95.41293945312498,
									78.49755859375003
								],
								[
									-95.03120117187501,
									78.43027343750009
								],
								[
									-94.91538085937495,
									78.39052734375005
								],
								[
									-94.88774414062502,
									78.36049804687508
								],
								[
									-94.88715820312498,
									78.34521484375006
								],
								[
									-95.01386718749995,
									78.31259765625009
								],
								[
									-95.26787109374999,
									78.26264648437504
								],
								[
									-95.329248046875,
									78.22504882812493
								],
								[
									-95.10273437499993,
									78.17807617187495
								],
								[
									-94.98779296874997,
									78.13627929687496
								],
								[
									-94.93603515625,
									78.1063964843751
								],
								[
									-94.93427734374998,
									78.07563476562495
								],
								[
									-95.08701171875,
									77.99262695312501
								],
								[
									-95.19912109375002,
									77.9681640625
								],
								[
									-95.37050781249994,
									77.97080078125009
								],
								[
									-95.45156249999994,
									77.96323242187506
								],
								[
									-95.67080078125002,
									77.92446289062497
								],
								[
									-96.01157226562498,
									77.88740234375007
								],
								[
									-96.47685546875002,
									77.87216796874998
								],
								[
									-96.60302734374997,
									77.84931640625004
								],
								[
									-96.83398437500003,
									77.81191406250005
								],
								[
									-96.98964843749994,
									77.80600585937509
								],
								[
									-97.04047851562498,
									77.82744140625002
								],
								[
									-97.06381835937495,
									77.85908203125007
								],
								[
									-97.05195312499993,
									77.88095703125009
								],
								[
									-97.01909179687499,
									77.90810546875002
								],
								[
									-97.09331054687502,
									77.93349609375002
								],
								[
									-97.42666015624997,
									77.98227539062503
								],
								[
									-97.62084960937503,
									78.05024414062493
								],
								[
									-97.64838867187495,
									78.07163085937512
								],
								[
									-97.65815429687498,
									78.09062499999999
								],
								[
									-97.22661132812499,
									78.10322265625007
								],
								[
									-97.04091796875,
									78.11694335937511
								],
								[
									-96.95834960937495,
									78.13901367187498
								],
								[
									-96.944677734375,
									78.15185546875003
								],
								[
									-97.02734374999997,
									78.15742187500001
								],
								[
									-97.32304687500002,
									78.20322265625
								],
								[
									-97.81904296874998,
									78.230615234375
								],
								[
									-97.84272460937501,
									78.26235351562505
								],
								[
									-98.04951171874995,
									78.32592773437506
								],
								[
									-98.06928710937498,
									78.386328125
								],
								[
									-98.11430664062502,
									78.40302734375004
								],
								[
									-98.25493164062496,
									78.42924804687496
								],
								[
									-98.27568359375002,
									78.43789062499994
								],
								[
									-98.31733398437498,
									78.47685546875007
								],
								[
									-98.32373046874994,
									78.49814453125006
								],
								[
									-98.31562499999998,
									78.51748046875
								],
								[
									-98.06035156249993,
									78.55834960937497
								],
								[
									-98.09599609375002,
									78.58666992187497
								],
								[
									-98.28989257812498,
									78.69238281250009
								],
								[
									-98.34082031249997,
									78.751220703125
								],
								[
									-98.33261718749998,
									78.77353515625012
								],
								[
									-98.21210937499995,
									78.80454101562495
								],
								[
									-98.04287109375002,
									78.80522460937499
								],
								[
									-97.59589843749998,
									78.79580078124994
								],
								[
									-97.38232421875,
									78.78291015624998
								],
								[
									-97.16933593749997,
									78.75766601562506
								],
								[
									-96.93579101562497,
									78.7202636718751
								],
								[
									-96.587060546875,
									78.687109375
								],
								[
									-96.47534179687497,
									78.66518554687505
								],
								[
									-96.265283203125,
									78.59536132812497
								],
								[
									-96.24262695312498,
									78.57319335937507
								],
								[
									-96.25649414062497,
									78.551123046875
								],
								[
									-96.20449218749994,
									78.53129882812496
								]
							]
						],
						[
							[
								[
									-103.42602539062499,
									79.31562500000007
								],
								[
									-103.19165039062503,
									79.29531250000011
								],
								[
									-102.91435546875002,
									79.23110351562508
								],
								[
									-102.65229492187501,
									79.09501953125005
								],
								[
									-102.63896484374996,
									79.07758789062507
								],
								[
									-102.63759765624995,
									79.05498046874999
								],
								[
									-102.64819335937497,
									79.02714843750007
								],
								[
									-102.68286132812501,
									78.9910156250001
								],
								[
									-102.73051757812496,
									78.96933593749995
								],
								[
									-102.59560546875001,
									78.94296875000009
								],
								[
									-102.58076171875,
									78.93012695312495
								],
								[
									-102.59277343749996,
									78.90092773437505
								],
								[
									-102.57617187499996,
									78.87939453125
								],
								[
									-102.49458007812503,
									78.90068359374999
								],
								[
									-102.42480468750003,
									78.93320312499995
								],
								[
									-102.40732421875002,
									78.95410156249994
								],
								[
									-102.39316406249998,
									79.01030273437513
								],
								[
									-102.18857421874995,
									79.03837890625007
								],
								[
									-101.97363281249994,
									79.07919921874995
								],
								[
									-101.87260742187497,
									79.08837890624994
								],
								[
									-101.70366210937502,
									79.07890625000007
								],
								[
									-101.2990234375,
									78.98217773437509
								],
								[
									-101.14458007812497,
									78.97290039062506
								],
								[
									-101.0884765625,
									78.96152343749995
								],
								[
									-101.03715820312495,
									78.93901367187499
								],
								[
									-101.03369140624994,
									78.91469726562508
								],
								[
									-101.11591796875,
									78.85830078124997
								],
								[
									-101.14746093750003,
									78.823974609375
								],
								[
									-101.128125,
									78.80166015625008
								],
								[
									-100.91699218749997,
									78.78291015624998
								],
								[
									-100.43549804687503,
									78.82031250000006
								],
								[
									-100.01474609375002,
									78.72861328125012
								],
								[
									-99.78183593749999,
									78.61962890625003
								],
								[
									-99.60942382812496,
									78.58305664062513
								],
								[
									-99.58212890624999,
									78.56328125000007
								],
								[
									-99.63110351562501,
									78.54467773437494
								],
								[
									-99.68017578124999,
									78.49350585937509
								],
								[
									-99.81831054687497,
									78.45537109375005
								],
								[
									-99.84780273437502,
									78.43823242187511
								],
								[
									-99.77412109375003,
									78.39296874999994
								],
								[
									-99.76865234374998,
									78.36455078125002
								],
								[
									-99.77822265624997,
									78.32509765624997
								],
								[
									-99.75136718750001,
									78.30297851562509
								],
								[
									-99.56245117187498,
									78.27934570312507
								],
								[
									-99.13154296875003,
									78.11752929687503
								],
								[
									-99.05312499999995,
									78.07236328125009
								],
								[
									-99.00458984375001,
									78.01596679687506
								],
								[
									-98.99960937499998,
									77.99687500000007
								],
								[
									-99.061181640625,
									77.9656250000001
								],
								[
									-99.12836914062501,
									77.87714843749993
								],
								[
									-99.16640625000002,
									77.85693359375006
								],
								[
									-99.34130859374996,
									77.83964843750002
								],
								[
									-99.65913085937495,
									77.82407226562495
								],
								[
									-99.95590820312502,
									77.79379882812509
								],
								[
									-100.27465820312503,
									77.83271484374993
								],
								[
									-100.58603515624996,
									77.89179687499998
								],
								[
									-100.68027343749998,
									77.93066406250009
								],
								[
									-100.75791015624999,
									77.97768554687508
								],
								[
									-100.77822265624995,
									77.99604492187498
								],
								[
									-100.80957031250003,
									78.07163085937512
								],
								[
									-100.82617187499994,
									78.08774414062512
								],
								[
									-100.95761718749999,
									78.13022460937506
								],
								[
									-101.07412109375001,
									78.19384765625006
								],
								[
									-101.29799804687497,
									78.19936523437494
								],
								[
									-101.82949218749998,
									78.26411132812498
								],
								[
									-102.05698242187496,
									78.27954101562511
								],
								[
									-102.28447265624995,
									78.27499999999998
								],
								[
									-102.60698242187502,
									78.24892578125
								],
								[
									-102.66767578124994,
									78.25590820312499
								],
								[
									-102.72270507812496,
									78.27524414062503
								],
								[
									-102.77207031249999,
									78.30688476562509
								],
								[
									-102.784326171875,
									78.33017578125003
								],
								[
									-102.73134765624995,
									78.37104492187501
								],
								[
									-103.67724609375001,
									78.319580078125
								],
								[
									-103.94658203124999,
									78.26000976562494
								],
								[
									-104.32421875000001,
									78.26948242187501
								],
								[
									-104.51264648437503,
									78.29462890624998
								],
								[
									-104.76357421875,
									78.35166015625006
								],
								[
									-104.87934570312495,
									78.40126953124994
								],
								[
									-104.98540039062497,
									78.46801757812503
								],
								[
									-104.995556640625,
									78.51850585937501
								],
								[
									-104.90961914062498,
									78.55263671874997
								],
								[
									-104.82011718749996,
									78.57290039062508
								],
								[
									-104.72705078125001,
									78.57939453124999
								],
								[
									-104.21396484375002,
									78.5397460937501
								],
								[
									-103.76435546875,
									78.51953124999997
								],
								[
									-103.57050781250003,
									78.53984375000002
								],
								[
									-103.48256835937497,
									78.59394531250004
								],
								[
									-103.58798828124995,
									78.6229980468751
								],
								[
									-104.02084960937502,
									78.63491210937494
								],
								[
									-103.92851562499995,
									78.66337890624996
								],
								[
									-103.56269531250003,
									78.69267578125007
								],
								[
									-103.37158203125,
									78.73632812500009
								],
								[
									-103.40839843749995,
									78.751611328125
								],
								[
									-103.51835937499997,
									78.76914062500009
								],
								[
									-104.00874023437495,
									78.76401367187495
								],
								[
									-104.18500976562498,
									78.7812988281251
								],
								[
									-104.19458007812497,
									78.79560546874998
								],
								[
									-104.15498046875,
									78.81396484375
								],
								[
									-103.87563476562501,
									78.90268554687495
								],
								[
									-103.88715820312497,
									78.91879882812495
								],
								[
									-104.0072265625,
									78.9478515625
								],
								[
									-104.112744140625,
									78.98559570312497
								],
								[
									-104.15195312499999,
									78.98989257812505
								],
								[
									-104.39482421875,
									78.95615234375
								],
								[
									-104.73603515624997,
									78.82592773437494
								],
								[
									-104.81743164062503,
									78.80708007812493
								],
								[
									-104.89550781249996,
									78.80815429687505
								],
								[
									-104.97021484374999,
									78.82915039062499
								],
								[
									-104.96953125000003,
									78.85649414062496
								],
								[
									-104.89340820312498,
									78.89018554687499
								],
								[
									-104.73525390625,
									78.99111328124994
								],
								[
									-104.74677734375003,
									79.02709960937509
								],
								[
									-104.9013671875,
									79.05112304687509
								],
								[
									-105.30878906249995,
									79.03320312500009
								],
								[
									-105.53564453124999,
									79.0325195312501
								],
								[
									-105.57075195312503,
									79.06098632812504
								],
								[
									-105.58017578124999,
									79.11420898437507
								],
								[
									-105.571044921875,
									79.16420898437494
								],
								[
									-105.51455078124995,
									79.24248046874999
								],
								[
									-105.43569335937497,
									79.30224609375
								],
								[
									-105.38769531249996,
									79.32358398437509
								],
								[
									-104.84736328125001,
									79.31098632812501
								],
								[
									-103.96459960937501,
									79.34814453125003
								],
								[
									-103.70639648437499,
									79.35205078125003
								],
								[
									-103.42602539062499,
									79.31562500000007
								]
							]
						],
						[
							[
								[
									-98.79160156249998,
									79.98110351562511
								],
								[
									-98.76894531249997,
									79.85087890625005
								],
								[
									-98.78979492187494,
									79.78540039062503
								],
								[
									-98.840625,
									79.73706054687494
								],
								[
									-98.88520507812503,
									79.72568359375012
								],
								[
									-98.94521484375,
									79.72407226562495
								],
								[
									-99.21845703124997,
									79.76186523437494
								],
								[
									-99.30175781249999,
									79.78408203125002
								],
								[
									-99.30625,
									79.80288085937494
								],
								[
									-99.33300781249996,
									79.83955078124995
								],
								[
									-99.51562500000003,
									79.88715820312507
								],
								[
									-99.85747070312495,
									79.8794921875
								],
								[
									-99.99990234375001,
									79.88403320312503
								],
								[
									-100.05683593749998,
									79.8982421875001
								],
								[
									-100.09243164062495,
									79.91865234374998
								],
								[
									-100.12602539062495,
									80.00126953125013
								],
								[
									-100.12036132812496,
									80.03041992187494
								],
								[
									-100.07851562499995,
									80.08110351562496
								],
								[
									-100.05327148437496,
									80.09335937500006
								],
								[
									-99.802783203125,
									80.14013671875009
								],
								[
									-99.73120117187499,
									80.14409179687507
								],
								[
									-99.42485351562502,
									80.12641601562495
								],
								[
									-99.15322265625001,
									80.12421875000004
								],
								[
									-99.01660156249997,
									80.11113281250013
								],
								[
									-98.89467773437501,
									80.081787109375
								],
								[
									-98.82319335937501,
									80.03735351562511
								],
								[
									-98.79160156249998,
									79.98110351562511
								]
							]
						],
						[
							[
								[
									-91.88554687499999,
									81.13286132812507
								],
								[
									-91.75498046875003,
									81.04931640624994
								],
								[
									-91.27246093749994,
									80.85009765624994
								],
								[
									-91.05390625000001,
									80.77768554687503
								],
								[
									-90.68291015625002,
									80.68769531249998
								],
								[
									-90.63671875000003,
									80.65532226562496
								],
								[
									-90.63247070312497,
									80.64169921874995
								],
								[
									-90.64301757812498,
									80.59370117187501
								],
								[
									-90.53725585937502,
									80.57592773437506
								],
								[
									-90.217626953125,
									80.5482421875
								],
								[
									-89.86186523437499,
									80.49843750000008
								],
								[
									-89.7978515625,
									80.50126953125002
								],
								[
									-89.67382812499997,
									80.53076171875009
								],
								[
									-89.5248046875,
									80.53881835937494
								],
								[
									-89.32905273437498,
									80.53173828125011
								],
								[
									-89.23559570312494,
									80.51064453125008
								],
								[
									-89.16689453125,
									80.47963867187497
								],
								[
									-89.13828125,
									80.45742187499997
								],
								[
									-89.1341796875,
									80.44023437500002
								],
								[
									-89.20439453124999,
									80.40693359374998
								],
								[
									-89.19658203124999,
									80.39404296874994
								],
								[
									-89.1546875,
									80.37851562499998
								],
								[
									-89.14726562499999,
									80.3603515625
								],
								[
									-89.21767578125002,
									80.2892578125001
								],
								[
									-89.19833984375,
									80.26318359375011
								],
								[
									-89.01923828125001,
									80.19848632812497
								],
								[
									-88.85732421874997,
									80.16621093750007
								],
								[
									-88.53754882812493,
									80.1311523437501
								],
								[
									-88.32924804687497,
									80.13369140625011
								],
								[
									-88.19990234374998,
									80.11147460937502
								],
								[
									-88.19682617187499,
									80.12519531250007
								],
								[
									-88.25537109375,
									80.16650390624994
								],
								[
									-88.38076171874997,
									80.2251953125
								],
								[
									-88.61250000000001,
									80.25537109375003
								],
								[
									-88.64624023437497,
									80.28974609375001
								],
								[
									-88.663427734375,
									80.34829101562494
								],
								[
									-88.64365234374998,
									80.38686523437508
								],
								[
									-88.5248046875,
									80.4180175781251
								],
								[
									-88.42436523437496,
									80.42807617187495
								],
								[
									-88.12524414062497,
									80.42949218749996
								],
								[
									-87.96000976562496,
									80.41562499999998
								],
								[
									-87.67499999999998,
									80.3721191406251
								],
								[
									-87.6455078125,
									80.34843750000007
								],
								[
									-87.63027343750002,
									80.30161132812503
								],
								[
									-87.61835937499998,
									80.20747070312504
								],
								[
									-87.62548828125003,
									80.18720703124998
								],
								[
									-87.869140625,
									80.13388671875006
								],
								[
									-87.92231445312501,
									80.09770507812496
								],
								[
									-87.86069335937498,
									80.08750000000009
								],
								[
									-87.65136718749997,
									80.07944335937498
								],
								[
									-87.328515625,
									80.04653320312502
								],
								[
									-87.20205078125,
									80.04321289062506
								],
								[
									-87.07617187500003,
									79.96694335937497
								],
								[
									-86.97719726562502,
									79.89423828124998
								],
								[
									-87.04951171875001,
									79.80541992187511
								],
								[
									-87.14423828124995,
									79.66264648437505
								],
								[
									-87.22026367187499,
									79.62993164062496
								],
								[
									-87.29516601562497,
									79.58017578124995
								],
								[
									-87.24287109374995,
									79.57114257812498
								],
								[
									-86.92524414062501,
									79.59096679687494
								],
								[
									-86.86103515624998,
									79.59770507812507
								],
								[
									-86.648828125,
									79.646240234375
								],
								[
									-86.33696289062496,
									79.63496093749993
								],
								[
									-86.23222656249996,
									79.62241210937495
								],
								[
									-86.18046874999996,
									79.60541992187504
								],
								[
									-86.085546875,
									79.55122070312501
								],
								[
									-86.00703124999998,
									79.47944335937495
								],
								[
									-85.94897460937497,
									79.48598632812505
								],
								[
									-85.803857421875,
									79.57304687500002
								],
								[
									-85.75092773437495,
									79.59453125000005
								],
								[
									-85.67861328124997,
									79.6152832031251
								],
								[
									-85.6478515625,
									79.61142578125009
								],
								[
									-85.5013671875,
									79.53032226562502
								],
								[
									-85.17558593749999,
									79.38725585937507
								],
								[
									-85.06376953125002,
									79.32817382812505
								],
								[
									-85.04213867187497,
									79.28457031250005
								],
								[
									-85.18134765624998,
									79.23374023437506
								],
								[
									-85.28984374999999,
									79.20834960937506
								],
								[
									-86.091650390625,
									79.10000000000011
								],
								[
									-86.450537109375,
									79.03867187499995
								],
								[
									-86.62944335937496,
									78.99130859374998
								],
								[
									-86.72080078125,
									78.97548828125005
								],
								[
									-86.9134765625,
									78.98281249999994
								],
								[
									-86.95717773437502,
									78.97490234375002
								],
								[
									-87.01645507812503,
									78.89868164062494
								],
								[
									-87.08037109374999,
									78.86611328124997
								],
								[
									-87.24638671874996,
									78.81347656250009
								],
								[
									-87.47875976562497,
									78.71816406249994
								],
								[
									-87.61738281249995,
									78.67631835937502
								],
								[
									-87.86147460937497,
									78.70683593750002
								],
								[
									-87.92231445312501,
									78.75136718750002
								],
								[
									-87.95624999999998,
									78.85161132812513
								],
								[
									-87.96074218750002,
									78.89311523437496
								],
								[
									-87.95317382812499,
									78.91503906250009
								],
								[
									-87.92260742187497,
									78.95058593749994
								],
								[
									-87.816748046875,
									79.03632812500001
								],
								[
									-87.82939453124999,
									79.04531249999997
								],
								[
									-87.87836914062493,
									79.03818359375003
								],
								[
									-88.04018554687494,
									78.9953125000001
								],
								[
									-88.10405273437499,
									78.97280273437494
								],
								[
									-88.163818359375,
									78.93349609375002
								],
								[
									-88.19023437499996,
									78.86743164062497
								],
								[
									-88.16660156250003,
									78.7455078125
								],
								[
									-88.18969726562503,
									78.69638671875003
								],
								[
									-88.25375976562503,
									78.67197265625003
								],
								[
									-88.227880859375,
									78.65302734374998
								],
								[
									-88.03701171875002,
									78.626953125
								],
								[
									-88.00312499999995,
									78.61552734374999
								],
								[
									-87.98198242187499,
									78.59472656250009
								],
								[
									-87.97363281249997,
									78.56474609375013
								],
								[
									-87.98286132812498,
									78.53706054687498
								],
								[
									-88.04023437499995,
									78.4944335937501
								],
								[
									-88.14755859374998,
									78.4770996093751
								],
								[
									-88.2845703125,
									78.49653320312498
								],
								[
									-88.5806640625,
									78.60190429687506
								],
								[
									-88.70927734375002,
									78.59609374999994
								],
								[
									-88.74160156250002,
									78.58403320312496
								],
								[
									-88.71396484375,
									78.54643554687513
								],
								[
									-88.62304687500003,
									78.46210937500007
								],
								[
									-88.60644531250003,
									78.39199218750011
								],
								[
									-88.64838867187495,
									78.33374023437503
								],
								[
									-88.73295898437496,
									78.24169921874994
								],
								[
									-88.79101562499997,
									78.19243164062513
								],
								[
									-88.82241210937497,
									78.18588867187503
								],
								[
									-88.96962890624994,
									78.18442382812509
								],
								[
									-89.09570312499997,
									78.20922851562509
								],
								[
									-89.47001953125002,
									78.37021484375
								],
								[
									-89.6552734375,
									78.43886718749997
								],
								[
									-89.92622070312495,
									78.57304687500013
								],
								[
									-89.995361328125,
									78.60068359374998
								],
								[
									-90.037109375,
									78.6068359375
								],
								[
									-90.076318359375,
									78.54916992187506
								],
								[
									-90.00102539062502,
									78.49580078124993
								],
								[
									-89.75727539062501,
									78.37021484375
								],
								[
									-89.611669921875,
									78.27890624999998
								],
								[
									-89.50683593749997,
									78.20327148437502
								],
								[
									-89.48984374999998,
									78.1719238281251
								],
								[
									-89.52568359374999,
									78.15961914062501
								],
								[
									-89.57949218750002,
									78.1666015625
								],
								[
									-89.65112304687497,
									78.19301757812497
								],
								[
									-89.87304687499997,
									78.23759765624999
								],
								[
									-89.965185546875,
									78.262451171875
								],
								[
									-90.02543945312502,
									78.291259765625
								],
								[
									-90.136083984375,
									78.3130859375
								],
								[
									-90.29721679687495,
									78.32802734374994
								],
								[
									-90.45903320312496,
									78.33090820312509
								],
								[
									-90.62158203124997,
									78.32172851562507
								],
								[
									-90.65239257812502,
									78.30771484374998
								],
								[
									-90.46918945312501,
									78.2685546875
								],
								[
									-90.40541992187497,
									78.24667968749998
								],
								[
									-90.35795898437499,
									78.21874999999997
								],
								[
									-90.32675781250003,
									78.18476562499998
								],
								[
									-90.38696289062503,
									78.16328124999995
								],
								[
									-90.614404296875,
									78.14985351562507
								],
								[
									-90.91811523437497,
									78.15839843750001
								],
								[
									-91.40961914062501,
									78.18798828125011
								],
								[
									-91.899169921875,
									78.23686523437502
								],
								[
									-92.35126953125001,
									78.31289062499997
								],
								[
									-92.67827148437502,
									78.38911132812495
								],
								[
									-92.80761718749997,
									78.42973632812505
								],
								[
									-92.8482421875,
									78.46010742187494
								],
								[
									-92.72558593749997,
									78.48666992187512
								],
								[
									-92.296728515625,
									78.52080078124996
								],
								[
									-91.86689453125001,
									78.54267578125007
								],
								[
									-91.93496093750002,
									78.56171875000004
								],
								[
									-92.71552734374995,
									78.60502929687507
								],
								[
									-92.972509765625,
									78.612939453125
								],
								[
									-93.109375,
									78.60156250000006
								],
								[
									-93.26660156249997,
									78.60830078124994
								],
								[
									-93.38945312499993,
									78.64267578125
								],
								[
									-93.55205078124993,
									78.70781249999996
								],
								[
									-93.63442382812502,
									78.75092773437504
								],
								[
									-93.62333984374999,
									78.76777343750001
								],
								[
									-93.56142578125,
									78.77734375
								],
								[
									-93.208349609375,
									78.76918945312494
								],
								[
									-93.15986328124998,
									78.775634765625
								],
								[
									-93.33647460937499,
									78.80805664062495
								],
								[
									-93.90224609374997,
									78.87221679687497
								],
								[
									-94.11459960937498,
									78.92890625000007
								],
								[
									-94.15361328125002,
									78.95102539062495
								],
								[
									-94.169677734375,
									78.97280273437494
								],
								[
									-94.16279296874993,
									78.99418945312513
								],
								[
									-93.95019531249997,
									79.03740234374996
								],
								[
									-93.29389648437501,
									79.13950195312498
								],
								[
									-93.06845703125,
									79.15537109375
								],
								[
									-92.84160156249999,
									79.15639648437505
								],
								[
									-92.68364257812496,
									79.18579101562509
								],
								[
									-92.54721679687495,
									79.2826171875
								],
								[
									-91.86757812499997,
									79.31743164062499
								],
								[
									-91.34365234375,
									79.36088867187496
								],
								[
									-91.29990234375003,
									79.37270507812497
								],
								[
									-91.69262695312503,
									79.36474609374994
								],
								[
									-92.24794921875,
									79.37343749999994
								],
								[
									-92.48457031249998,
									79.43925781250002
								],
								[
									-92.64472656250001,
									79.45043945312509
								],
								[
									-92.82192382812497,
									79.44990234375007
								],
								[
									-93.02812499999996,
									79.4292480468751
								],
								[
									-93.38085937499997,
									79.36816406250011
								],
								[
									-93.55043945312497,
									79.35395507812504
								],
								[
									-93.93315429687496,
									79.29072265624995
								],
								[
									-94.03984375000002,
									79.29521484374999
								],
								[
									-94.093359375,
									79.30273437500009
								],
								[
									-94.10937499999997,
									79.31508789062505
								],
								[
									-94.04028320312503,
									79.35703125000006
								],
								[
									-93.93969726562494,
									79.38569335937504
								],
								[
									-93.96025390624996,
									79.39550781250009
								],
								[
									-94.11030273437498,
									79.40156249999998
								],
								[
									-94.28413085937495,
									79.40043945312502
								],
								[
									-94.40488281249995,
									79.39052734375005
								],
								[
									-94.84604492187503,
									79.33505859375012
								],
								[
									-95.04370117187497,
									79.2935546875
								],
								[
									-95.10317382812502,
									79.28989257812506
								],
								[
									-95.31660156249998,
									79.35473632812494
								],
								[
									-95.65703124999996,
									79.39038085937511
								],
								[
									-95.7330078125,
									79.418212890625
								],
								[
									-95.66289062500002,
									79.52734374999994
								],
								[
									-95.5634765625,
									79.54975585937507
								],
								[
									-95.30234375,
									79.56806640625007
								],
								[
									-94.519677734375,
									79.667138671875
								],
								[
									-94.47553710937495,
									79.68618164062497
								],
								[
									-94.40185546874997,
									79.73632812499997
								],
								[
									-94.58085937500002,
									79.72563476562502
								],
								[
									-94.97304687499997,
									79.67719726562501
								],
								[
									-95.29697265624998,
									79.65307617187497
								],
								[
									-95.552490234375,
									79.65322265625008
								],
								[
									-95.73935546874995,
									79.66015625
								],
								[
									-95.85751953124995,
									79.67377929687493
								],
								[
									-95.99965820312497,
									79.7046875
								],
								[
									-96.46274414062498,
									79.84750976562498
								],
								[
									-96.58906249999995,
									79.91665039062494
								],
								[
									-96.60673828125002,
									79.97768554687494
								],
								[
									-96.63920898437496,
									80.02416992187509
								],
								[
									-96.77324218749999,
									80.13579101562499
								],
								[
									-95.78198242187503,
									80.06640625000006
								],
								[
									-95.39384765624999,
									80.05327148437505
								],
								[
									-94.64589843749994,
									80.04873046874994
								],
								[
									-94.61083984375,
									80.05551757812498
								],
								[
									-94.59980468749995,
									80.07363281249994
								],
								[
									-94.61269531250002,
									80.10297851562507
								],
								[
									-94.60698242187502,
									80.12558593750003
								],
								[
									-94.5826171875,
									80.14140624999999
								],
								[
									-94.304443359375,
									80.18164062500009
								],
								[
									-94.26259765625002,
									80.19487304687505
								],
								[
									-94.59013671874996,
									80.20151367187498
								],
								[
									-95.1923828125,
									80.13437499999998
								],
								[
									-95.40507812499999,
									80.13500976562511
								],
								[
									-95.646240234375,
									80.23095703125003
								],
								[
									-95.90400390625001,
									80.21411132812506
								],
								[
									-96.02568359375002,
									80.2217285156251
								],
								[
									-96.21508789062497,
									80.24589843749996
								],
								[
									-96.30830078124995,
									80.2669921875
								],
								[
									-96.36840820312503,
									80.29306640624998
								],
								[
									-96.39409179687493,
									80.3150390625
								],
								[
									-96.38535156250003,
									80.33286132812509
								],
								[
									-96.33437500000002,
									80.35278320312497
								],
								[
									-96.11215820312498,
									80.3804199218751
								],
								[
									-96.01186523437497,
									80.38305664062509
								],
								[
									-95.74736328124999,
									80.36528320312513
								],
								[
									-95.549072265625,
									80.36660156249994
								],
								[
									-95.61445312500001,
									80.39624023437494
								],
								[
									-95.90107421874995,
									80.47084960937505
								],
								[
									-96.15180664062495,
									80.553466796875
								],
								[
									-96.1328125,
									80.69140624999994
								],
								[
									-95.92695312499998,
									80.72065429687495
								],
								[
									-95.71362304687494,
									80.72543945312495
								],
								[
									-95.50527343749997,
									80.69057617187505
								],
								[
									-95.22583007812497,
									80.68579101562506
								],
								[
									-95.02573242187498,
									80.64643554687493
								],
								[
									-94.89257812500003,
									80.57089843750009
								],
								[
									-94.73447265624995,
									80.57236328125003
								],
								[
									-94.48540039062502,
									80.55805664062495
								],
								[
									-93.92792968749995,
									80.5591796875
								],
								[
									-94.02871093749997,
									80.586181640625
								],
								[
									-94.20214843749994,
									80.609716796875
								],
								[
									-94.59628906249995,
									80.64062500000009
								],
								[
									-94.78847656249994,
									80.75126953125007
								],
								[
									-95.19584960937499,
									80.80830078124995
								],
								[
									-95.51474609375003,
									80.838134765625
								],
								[
									-95.50927734374997,
									80.86323242187495
								],
								[
									-95.26977539062503,
									81.0007812500001
								],
								[
									-94.98051757812499,
									81.049658203125
								],
								[
									-94.51943359375002,
									81.03120117187498
								],
								[
									-94.21630859375,
									81.05717773437513
								],
								[
									-93.82597656249996,
									81.10571289062497
								],
								[
									-93.44375,
									81.08325195312511
								],
								[
									-93.34511718749997,
									81.0853515625
								],
								[
									-93.28671874999998,
									81.10029296875001
								],
								[
									-93.23564453124996,
									81.12885742187498
								],
								[
									-93.23540039062499,
									81.155126953125
								],
								[
									-93.28593749999999,
									81.17924804687513
								],
								[
									-93.40654296874996,
									81.20908203124998
								],
								[
									-93.89443359374997,
									81.21328125000005
								],
								[
									-94.1103515625,
									81.22499999999994
								],
								[
									-94.19443359374998,
									81.24091796874998
								],
								[
									-94.21865234374994,
									81.26494140624999
								],
								[
									-94.23149414062499,
									81.28969726562505
								],
								[
									-94.23295898437502,
									81.31513671875001
								],
								[
									-94.22011718749997,
									81.33076171875007
								],
								[
									-94.17934570312502,
									81.33925781250002
								],
								[
									-94.059716796875,
									81.34931640624995
								],
								[
									-93.60488281249997,
									81.35058593749994
								],
								[
									-93.33276367187503,
									81.36440429687511
								],
								[
									-93.03466796874997,
									81.34628906250003
								],
								[
									-92.41259765624997,
									81.27827148437495
								],
								[
									-92.211767578125,
									81.2436035156251
								],
								[
									-91.99785156249993,
									81.18549804687507
								],
								[
									-91.88554687499999,
									81.13286132812507
								]
							]
						],
						[
							[
								[
									-69.4888671875,
									83.01679687500001
								],
								[
									-68.67324218750002,
									82.998779296875
								],
								[
									-68.40903320312503,
									83.00527343750008
								],
								[
									-68.10688476562493,
									82.96118164062497
								],
								[
									-67.92460937500002,
									82.95600585937498
								],
								[
									-67.62446289062498,
									82.9644042968751
								],
								[
									-67.4056640625,
									82.9539062500001
								],
								[
									-66.59165039062498,
									82.94404296875004
								],
								[
									-66.42255859374998,
									82.92685546875009
								],
								[
									-66.4248046875,
									82.90615234375005
								],
								[
									-66.60039062499996,
									82.86123046875005
								],
								[
									-66.836328125,
									82.8179199218751
								],
								[
									-68.35756835937502,
									82.67680664062505
								],
								[
									-68.46933593749998,
									82.65336914062505
								],
								[
									-68.17285156249997,
									82.64594726562507
								],
								[
									-67.73588867187502,
									82.65244140625003
								],
								[
									-67.3970703125,
									82.66811523437505
								],
								[
									-66.997705078125,
									82.71606445312503
								],
								[
									-66.86572265625003,
									82.71884765625006
								],
								[
									-66.61186523437499,
									82.74208984375002
								],
								[
									-66.12045898437498,
									82.80712890624994
								],
								[
									-65.72744140624994,
									82.84243164062494
								],
								[
									-65.54960937499996,
									82.82695312499999
								],
								[
									-65.40000000000003,
									82.80239257812505
								],
								[
									-65.29902343749998,
									82.7996093750001
								],
								[
									-65.24658203125003,
									82.81850585937505
								],
								[
									-65.16240234374993,
									82.87011718750009
								],
								[
									-65.11318359374994,
									82.888916015625
								],
								[
									-64.98388671874997,
									82.90229492187507
								],
								[
									-64.90488281249998,
									82.90083007812501
								],
								[
									-64.77675781249997,
									82.87646484374994
								],
								[
									-64.634765625,
									82.81860351562497
								],
								[
									-64.50400390625,
									82.77841796874995
								],
								[
									-64.43339843750002,
									82.777734375
								],
								[
									-64.13422851562498,
									82.82319335937493
								],
								[
									-63.983593749999955,
									82.82910156249997
								],
								[
									-63.641015624999966,
									82.81259765625009
								],
								[
									-63.498730468749926,
									82.79257812500009
								],
								[
									-63.47304687500002,
									82.771240234375
								],
								[
									-63.564062500000006,
									82.74873046875004
								],
								[
									-63.62060546874997,
									82.72929687499999
								],
								[
									-63.64252929687501,
									82.71298828124995
								],
								[
									-63.592675781249966,
									82.6940429687501
								],
								[
									-63.38540039062502,
									82.653466796875
								],
								[
									-63.085351562499994,
									82.56523437499996
								],
								[
									-63.087060546874994,
									82.5328125
								],
								[
									-63.25083007812498,
									82.46684570312499
								],
								[
									-63.246777343749926,
									82.45019531249997
								],
								[
									-62.47519531249995,
									82.51958007812507
								],
								[
									-61.697167968749994,
									82.48862304687498
								],
								[
									-61.47705078125,
									82.46743164062502
								],
								[
									-61.392480468749994,
									82.44189453125006
								],
								[
									-61.30249023437497,
									82.39975585937509
								],
								[
									-61.20722656250001,
									82.34106445312494
								],
								[
									-61.273535156250006,
									82.27983398437499
								],
								[
									-61.61538085937502,
									82.184423828125
								],
								[
									-61.968652343749966,
									82.11025390625
								],
								[
									-62.17670898437498,
									82.04340820312495
								],
								[
									-62.49648437500002,
									82.00678710937495
								],
								[
									-63.59228515624997,
									81.84550781249996
								],
								[
									-64.12792968749994,
									81.79365234375007
								],
								[
									-64.43579101562497,
									81.74262695312507
								],
								[
									-64.57402343749996,
									81.73374023437512
								],
								[
									-65.22617187499995,
									81.74350585937506
								],
								[
									-65.39916992187503,
									81.71538085937502
								],
								[
									-65.49541015625002,
									81.66806640625006
								],
								[
									-65.70107421875,
									81.64555664062507
								],
								[
									-66.00473632812503,
									81.6294433593751
								],
								[
									-66.62573242187497,
									81.61640624999993
								],
								[
									-66.76503906249994,
									81.56303710937507
								],
								[
									-66.80058593749999,
									81.52680664062504
								],
								[
									-66.86113281249999,
									81.49868164062511
								],
								[
									-66.91406250000003,
									81.485107421875
								],
								[
									-68.68852539062493,
									81.293310546875
								],
								[
									-68.72119140625003,
									81.26123046874994
								],
								[
									-68.54257812499998,
									81.24799804687501
								],
								[
									-68.31767578124999,
									81.26123046874994
								],
								[
									-65.73569335937503,
									81.49423828125009
								],
								[
									-65.23999023437503,
									81.50966796874994
								],
								[
									-64.78007812499993,
									81.49287109374998
								],
								[
									-64.83276367187503,
									81.43862304687494
								],
								[
									-65.483984375,
									81.28476562499995
								],
								[
									-66.312841796875,
									81.14614257812505
								],
								[
									-66.72685546874999,
									81.04091796875011
								],
								[
									-67.77436523437495,
									80.85942382812507
								],
								[
									-68.63046875,
									80.67871093750003
								],
								[
									-68.95937499999997,
									80.58686523437504
								],
								[
									-69.40009765624995,
									80.42285156249994
								],
								[
									-69.55068359375,
									80.38325195312495
								],
								[
									-69.7337890625,
									80.36694335937511
								],
								[
									-69.94931640625003,
									80.37377929687509
								],
								[
									-70.14350585937498,
									80.39765625000004
								],
								[
									-70.40263671875002,
									80.45898437500003
								],
								[
									-70.63867187499997,
									80.52753906249995
								],
								[
									-70.71259765625001,
									80.53959960937502
								],
								[
									-70.66782226562503,
									80.50556640624993
								],
								[
									-70.21279296874997,
									80.27773437500005
								],
								[
									-70.26489257812503,
									80.23359375000001
								],
								[
									-71.10029296874995,
									80.18706054687496
								],
								[
									-71.47006835937495,
									80.14589843750011
								],
								[
									-71.66083984375001,
									80.13593750000001
								],
								[
									-71.7958984375,
									80.1433593750001
								],
								[
									-71.92763671875002,
									80.13916015624997
								],
								[
									-72.05595703124996,
									80.12324218749993
								],
								[
									-72.06298828124997,
									80.10556640625006
								],
								[
									-71.94868164062495,
									80.08618164062511
								],
								[
									-71.61611328124997,
									80.07104492187494
								],
								[
									-70.87705078125003,
									80.122314453125
								],
								[
									-70.75849609374995,
									80.11865234374997
								],
								[
									-70.56840820312493,
									80.09370117187504
								],
								[
									-70.55908203125,
									80.07099609375004
								],
								[
									-70.75751953125001,
									79.99824218749995
								],
								[
									-71.35581054687495,
									79.911279296875
								],
								[
									-71.27763671875002,
									79.90634765625006
								],
								[
									-71.10634765625002,
									79.87553710937507
								],
								[
									-71.11015624999999,
									79.84780273437494
								],
								[
									-71.29858398437503,
									79.78256835937498
								],
								[
									-71.387841796875,
									79.7617675781251
								],
								[
									-71.96455078124998,
									79.70107421875008
								],
								[
									-72.21552734374995,
									79.6868164062501
								],
								[
									-72.43652343750003,
									79.69438476562505
								],
								[
									-73.44814453125,
									79.82709960937498
								],
								[
									-73.80507812499997,
									79.84628906250009
								],
								[
									-74.14423828124995,
									79.87978515625005
								],
								[
									-74.39448242187495,
									79.87407226562496
								],
								[
									-74.66020507812499,
									79.83515625000004
								],
								[
									-74.54072265624998,
									79.81557617187505
								],
								[
									-74.05102539062497,
									79.77822265625008
								],
								[
									-73.64208984374997,
									79.77099609375011
								],
								[
									-73.47246093749996,
									79.75644531249998
								],
								[
									-73.405908203125,
									79.73217773437511
								],
								[
									-73.22939453125,
									79.64399414062498
								],
								[
									-73.20112304687501,
									79.59658203125011
								],
								[
									-73.24013671874997,
									79.552490234375
								],
								[
									-73.2935546875,
									79.52158203125
								],
								[
									-73.36152343750001,
									79.50400390624998
								],
								[
									-73.466064453125,
									79.49516601562496
								],
								[
									-73.86596679687503,
									79.50141601562498
								],
								[
									-74.015380859375,
									79.49052734374999
								],
								[
									-74.18867187499995,
									79.46474609375005
								],
								[
									-74.406005859375,
									79.45356445312501
								],
								[
									-74.79794921875,
									79.45869140624998
								],
								[
									-75.25947265624995,
									79.42104492187505
								],
								[
									-75.50341796875,
									79.41416015624998
								],
								[
									-75.77382812499994,
									79.43115234374997
								],
								[
									-76.06689453124997,
									79.4731933593751
								],
								[
									-76.37607421874998,
									79.49443359374999
								],
								[
									-76.898828125,
									79.51230468749998
								],
								[
									-76.85507812499995,
									79.48823242187504
								],
								[
									-76.6708984375,
									79.4780761718751
								],
								[
									-76.29570312499996,
									79.41362304687505
								],
								[
									-76.116357421875,
									79.32612304687498
								],
								[
									-75.94750976562497,
									79.31132812499999
								],
								[
									-75.60273437499998,
									79.23955078125002
								],
								[
									-75.35366210937497,
									79.22832031250005
								],
								[
									-75.093603515625,
									79.20390625000005
								],
								[
									-74.72724609374998,
									79.23535156250006
								],
								[
									-74.48120117187503,
									79.22949218750009
								],
								[
									-74.53232421874998,
									79.05273437499997
								],
								[
									-74.64091796874999,
									79.03554687499994
								],
								[
									-75.23315429687503,
									79.03554687499994
								],
								[
									-75.5146484375,
									79.06123046874993
								],
								[
									-75.63896484374999,
									79.08774414062509
								],
								[
									-75.91181640624998,
									79.11777343750006
								],
								[
									-76.15756835937495,
									79.10039062500007
								],
								[
									-76.38037109374997,
									79.10415039062497
								],
								[
									-76.53144531250001,
									79.08652343750009
								],
								[
									-76.771142578125,
									79.08715820312497
								],
								[
									-77.398046875,
									79.05727539062511
								],
								[
									-77.72924804687497,
									79.0569335937501
								],
								[
									-77.97377929687497,
									79.07622070312496
								],
								[
									-78.25791015625003,
									79.08217773437502
								],
								[
									-78.58164062499998,
									79.07500000000007
								],
								[
									-78.558984375,
									79.05458984375
								],
								[
									-78.42177734375002,
									79.04838867187507
								],
								[
									-78.22197265624999,
									79.01513671874994
								],
								[
									-78.03681640625001,
									78.96391601562499
								],
								[
									-77.88276367187498,
									78.94238281250006
								],
								[
									-77.69824218749994,
									78.95454101562495
								],
								[
									-77.51040039062497,
									78.97846679687504
								],
								[
									-76.8248046875,
									79.01787109375007
								],
								[
									-76.52412109374995,
									79.02421875000002
								],
								[
									-76.255859375,
									79.00683593749994
								],
								[
									-76.07734374999995,
									78.98515625000005
								],
								[
									-75.95268554687496,
									78.95903320312507
								],
								[
									-75.795068359375,
									78.88974609374998
								],
								[
									-75.39985351562495,
									78.88129882812495
								],
								[
									-75.09853515624994,
									78.85830078124997
								],
								[
									-74.618408203125,
									78.75771484375
								],
								[
									-74.486328125,
									78.75009765624995
								],
								[
									-74.43310546875,
									78.72412109375009
								],
								[
									-74.53505859375,
									78.65927734375009
								],
								[
									-74.54658203124995,
									78.62031249999998
								],
								[
									-74.87861328124998,
									78.54482421874997
								],
								[
									-75.39658203125,
									78.52285156249994
								],
								[
									-75.96582031249997,
									78.52983398437502
								],
								[
									-76.37348632812498,
									78.52109375000012
								],
								[
									-76.41611328124998,
									78.51152343750002
								],
								[
									-76.13652343749993,
									78.49169921875006
								],
								[
									-75.48837890624998,
									78.40351562499995
								],
								[
									-75.23720703124997,
									78.35571289062509
								],
								[
									-75.19345703125,
									78.32773437499998
								],
								[
									-75.55068359374997,
									78.22109375000011
								],
								[
									-75.86596679687497,
									78.00981445312505
								],
								[
									-75.96962890624997,
									77.99311523437493
								],
								[
									-76.0775390625,
									77.98730468750009
								],
								[
									-76.35556640624998,
									77.99101562500013
								],
								[
									-76.70810546875003,
									77.93789062500005
								],
								[
									-76.97402343750002,
									77.92724609375
								],
								[
									-77.45595703124997,
									77.94716796875008
								],
								[
									-78.01259765624997,
									77.94604492187511
								],
								[
									-78.056396484375,
									77.91171874999995
								],
								[
									-78.08413085937497,
									77.84609375
								],
								[
									-78.08105468749997,
									77.74736328125005
								],
								[
									-78.04716796874999,
									77.615478515625
								],
								[
									-78.07617187500003,
									77.51904296874997
								],
								[
									-78.16796875,
									77.45810546875009
								],
								[
									-78.28374023437496,
									77.41308593749997
								],
								[
									-78.49321289062499,
									77.36938476562503
								],
								[
									-78.70849609374997,
									77.34213867187509
								],
								[
									-78.86953125000002,
									77.33251953125009
								],
								[
									-79.13759765625,
									77.33100585937495
								],
								[
									-79.90639648437497,
									77.29956054687494
								],
								[
									-80.28168945312493,
									77.30146484375007
								],
								[
									-80.57304687499996,
									77.31479492187512
								],
								[
									-80.87460937500003,
									77.35859375000007
								],
								[
									-81.37685546874994,
									77.48212890625001
								],
								[
									-81.519287109375,
									77.5095703125001
								],
								[
									-81.65908203124997,
									77.52543945312505
								],
								[
									-81.65380859374997,
									77.49882812500013
								],
								[
									-81.503564453125,
									77.42978515625
								],
								[
									-81.37817382812503,
									77.38520507812498
								],
								[
									-81.277734375,
									77.36518554687498
								],
								[
									-81.3013671875,
									77.34404296875013
								],
								[
									-81.52294921874994,
									77.31083984375002
								],
								[
									-81.767333984375,
									77.2959472656251
								],
								[
									-82.056787109375,
									77.29653320312494
								],
								[
									-82.066015625,
									77.28364257812498
								],
								[
									-81.96782226562499,
									77.24785156250007
								],
								[
									-81.84023437500002,
									77.21411132812494
								],
								[
									-81.75634765624997,
									77.20400390625011
								],
								[
									-81.53447265624999,
									77.214453125
								],
								[
									-81.27744140625003,
									77.25708007812509
								],
								[
									-81.11718749999997,
									77.26962890625006
								],
								[
									-80.798193359375,
									77.25947265625004
								],
								[
									-80.67255859374998,
									77.24428710937505
								],
								[
									-80.27421875000002,
									77.15092773437513
								],
								[
									-80.21870117187498,
									77.14658203124995
								],
								[
									-79.92373046875002,
									77.19360351562503
								],
								[
									-79.49726562500001,
									77.19609375000007
								],
								[
									-79.34086914062493,
									77.15839843749995
								],
								[
									-79.281103515625,
									77.08515624999995
								],
								[
									-79.27382812499997,
									77.02578124999994
								],
								[
									-79.3189453125,
									76.98037109375002
								],
								[
									-79.22075195312499,
									76.93603515625003
								],
								[
									-78.97919921874998,
									76.89287109375005
								],
								[
									-78.79179687499999,
									76.88359375000002
								],
								[
									-78.658544921875,
									76.90800781250002
								],
								[
									-78.45595703124997,
									76.96723632812501
								],
								[
									-78.37001953124994,
									76.98125000000002
								],
								[
									-78.28886718750002,
									76.97797851562507
								],
								[
									-78.16508789062493,
									76.93491210937509
								],
								[
									-77.99873046874998,
									76.85195312499997
								],
								[
									-77.98330078124994,
									76.75498046875009
								],
								[
									-78.11870117187499,
									76.64404296874997
								],
								[
									-78.284326171875,
									76.57124023437507
								],
								[
									-78.93427734374998,
									76.45117187499994
								],
								[
									-79.13071289062503,
									76.403955078125
								],
								[
									-79.28588867187503,
									76.35478515625002
								],
								[
									-79.51103515624996,
									76.31049804687507
								],
								[
									-79.95356445312498,
									76.25126953125007
								],
								[
									-80.18681640624996,
									76.24018554687504
								],
								[
									-80.69028320312495,
									76.17646484374993
								],
								[
									-80.79970703124997,
									76.17358398437506
								],
								[
									-80.96293945312499,
									76.18393554687503
								],
								[
									-80.99667968750003,
									76.21499023437497
								],
								[
									-80.95517578125,
									76.27016601562511
								],
								[
									-80.90122070312503,
									76.321533203125
								],
								[
									-80.834814453125,
									76.36914062500011
								],
								[
									-80.83237304687503,
									76.40864257812498
								],
								[
									-80.97451171874997,
									76.47006835937506
								],
								[
									-81.07436523437497,
									76.49848632812498
								],
								[
									-81.17070312499996,
									76.51274414062496
								],
								[
									-81.36479492187496,
									76.50449218750006
								],
								[
									-81.47446289062503,
									76.48764648437509
								],
								[
									-81.59199218749998,
									76.48442382812496
								],
								[
									-81.71738281250003,
									76.49497070312498
								],
								[
									-81.82294921874995,
									76.520849609375
								],
								[
									-82.0341796875,
									76.62939453125009
								],
								[
									-82.11372070312495,
									76.64321289062508
								],
								[
									-82.21791992187497,
									76.639794921875
								],
								[
									-82.31113281250003,
									76.65537109374998
								],
								[
									-82.39345703125002,
									76.68989257812498
								],
								[
									-82.52983398437499,
									76.72329101562505
								],
								[
									-82.49340820312494,
									76.6978027343751
								],
								[
									-82.35698242187496,
									76.63603515625013
								],
								[
									-82.26196289062497,
									76.57470703124997
								],
								[
									-82.20834960937498,
									76.51376953125009
								],
								[
									-82.23315429687494,
									76.46582031250009
								],
								[
									-83.38896484374996,
									76.43925781250007
								],
								[
									-83.88569335937501,
									76.45312500000006
								],
								[
									-83.986328125,
									76.49501953125
								],
								[
									-84.22377929687497,
									76.67534179687496
								],
								[
									-84.27534179687498,
									76.35654296875012
								],
								[
									-85.141259765625,
									76.30458984375011
								],
								[
									-85.343603515625,
									76.31337890624994
								],
								[
									-85.68056640625,
									76.3490234375
								],
								[
									-86.11582031250003,
									76.434912109375
								],
								[
									-86.29619140625002,
									76.49184570312497
								],
								[
									-86.36684570312502,
									76.54863281249999
								],
								[
									-86.41943359374997,
									76.57963867187507
								],
								[
									-86.45371093750003,
									76.58486328125
								],
								[
									-86.56191406249997,
									76.51650390625002
								],
								[
									-86.68022460937499,
									76.37661132812494
								],
								[
									-86.97768554687502,
									76.41274414062502
								],
								[
									-87.35419921874998,
									76.44804687500002
								],
								[
									-87.48979492187499,
									76.58583984375002
								],
								[
									-87.49755859374997,
									76.38627929687505
								],
								[
									-88.10434570312498,
									76.41274414062502
								],
								[
									-88.39599609374997,
									76.4052734375
								],
								[
									-88.48164062500001,
									76.580078125
								],
								[
									-88.49584960937497,
									76.77285156250002
								],
								[
									-88.61411132812498,
									76.65087890624994
								],
								[
									-88.56254882812496,
									76.54721679687506
								],
								[
									-88.54580078125002,
									76.42089843750009
								],
								[
									-88.80371093749997,
									76.4568359375001
								],
								[
									-89.36962890625,
									76.47446289062498
								],
								[
									-89.57006835937497,
									76.49194335937509
								],
								[
									-89.54433593749997,
									76.65966796875006
								],
								[
									-89.49975585937503,
									76.826806640625
								],
								[
									-88.77089843749997,
									76.9933593750001
								],
								[
									-88.55620117187502,
									77.07221679687498
								],
								[
									-88.39814453124995,
									77.10395507812507
								],
								[
									-88.14794921874997,
									77.12402343749997
								],
								[
									-87.82841796874996,
									77.13647460937503
								],
								[
									-87.610498046875,
									77.12685546875002
								],
								[
									-87.36171875000002,
									77.13623046874997
								],
								[
									-87.06445312500003,
									77.16586914062506
								],
								[
									-86.85219726562497,
									77.17441406250012
								],
								[
									-86.812255859375,
									77.18491210937503
								],
								[
									-86.873779296875,
									77.20029296875006
								],
								[
									-87.10087890624999,
									77.30771484375
								],
								[
									-87.18242187499999,
									77.33212890625
								],
								[
									-87.26538085937503,
									77.343017578125
								],
								[
									-87.4296875,
									77.347802734375
								],
								[
									-87.58916015624999,
									77.39482421874999
								],
								[
									-87.68144531249996,
									77.436376953125
								],
								[
									-87.78017578125,
									77.49282226562497
								],
								[
									-87.93793945312498,
									77.5998046875001
								],
								[
									-88.09467773437495,
									77.71918945312498
								],
								[
									-88.01699218750002,
									77.78471679687502
								],
								[
									-87.75712890625002,
									77.8362304687501
								],
								[
									-87.49677734375001,
									77.87192382812509
								],
								[
									-87.23603515624998,
									77.89179687499998
								],
								[
									-87.01796874999997,
									77.89223632812508
								],
								[
									-86.75507812499998,
									77.86372070312504
								],
								[
									-86.385107421875,
									77.80859375000009
								],
								[
									-86.17299804687497,
									77.74614257812505
								],
								[
									-85.90664062499997,
									77.61391601562494
								],
								[
									-85.73120117187503,
									77.50864257812509
								],
								[
									-85.58847656249998,
									77.46113281250007
								],
								[
									-84.95087890624993,
									77.37495117187493
								],
								[
									-84.73867187499997,
									77.36103515625004
								],
								[
									-84.48701171874993,
									77.36796875000002
								],
								[
									-83.97358398437495,
									77.39052734375
								],
								[
									-83.7212890625,
									77.41420898437494
								],
								[
									-83.60805664062502,
									77.44223632812506
								],
								[
									-83.54980468749997,
									77.48256835937511
								],
								[
									-83.47734374999993,
									77.51362304687504
								],
								[
									-83.25029296874996,
									77.58481445312506
								],
								[
									-82.90273437499994,
									77.73271484374999
								],
								[
									-82.7103515625,
									77.84951171875008
								],
								[
									-82.66469726562494,
									77.888818359375
								],
								[
									-82.62631835937503,
									77.93632812499999
								],
								[
									-82.5953125,
									77.99213867187507
								],
								[
									-82.70356445312495,
									77.96240234374997
								],
								[
									-83.30375976562502,
									77.67373046874997
								],
								[
									-83.42822265624997,
									77.62128906250001
								],
								[
									-83.77939453125,
									77.5326171875
								],
								[
									-83.92817382812495,
									77.518310546875
								],
								[
									-84.167822265625,
									77.52270507812511
								],
								[
									-84.48583984374997,
									77.56196289062493
								],
								[
									-84.86054687500001,
									77.49951171875
								],
								[
									-85.08789062499997,
									77.51538085937494
								],
								[
									-85.28935546874996,
									77.55903320312495
								],
								[
									-85.29204101562499,
									77.76386718750004
								],
								[
									-85.54755859374998,
									77.92768554687501
								],
								[
									-85.26533203124995,
									78.01059570312512
								],
								[
									-85.03149414062503,
									78.06201171875011
								],
								[
									-84.61542968749998,
									78.19570312500008
								],
								[
									-84.52416992187497,
									78.19707031250007
								],
								[
									-84.22270507812502,
									78.17602539062497
								],
								[
									-84.38813476562495,
									78.20634765625002
								],
								[
									-84.54999999999998,
									78.25136718750005
								],
								[
									-84.91035156249995,
									78.23969726562498
								],
								[
									-84.78320312499997,
									78.52758789062509
								],
								[
									-85.02431640624997,
									78.31240234375005
								],
								[
									-85.27016601562497,
									78.19951171874996
								],
								[
									-85.41899414062502,
									78.14243164062506
								],
								[
									-85.5859375,
									78.10957031250001
								],
								[
									-86.21777343750003,
									78.08120117187502
								],
								[
									-86.06259765625003,
									78.18696289062498
								],
								[
									-85.92006835937494,
									78.34287109374995
								],
								[
									-86.07094726562497,
									78.28461914062498
								],
								[
									-86.42705078124993,
									78.19702148437509
								],
								[
									-86.69360351562497,
									78.15102539062494
								],
								[
									-86.91323242187497,
									78.12680664062498
								],
								[
									-87.33935546875,
									78.13266601562512
								],
								[
									-87.5517578125,
									78.176611328125
								],
								[
									-87.49111328125,
									78.28442382812494
								],
								[
									-87.49130859375003,
									78.41718749999998
								],
								[
									-87.36127929687501,
									78.4787109375001
								],
								[
									-87.16430664062503,
									78.5576171875
								],
								[
									-86.95292968749996,
									78.66391601562498
								],
								[
									-86.80791015624999,
									78.77436523437493
								],
								[
									-86.24189453124995,
									78.82363281250002
								],
								[
									-85.691015625,
									78.84370117187493
								],
								[
									-85.22968749999998,
									78.902001953125
								],
								[
									-85.00375976562498,
									78.91225585937505
								],
								[
									-84.787255859375,
									78.88457031249999
								],
								[
									-83.90791015625001,
									78.83916015625007
								],
								[
									-83.54702148437502,
									78.80449218750002
								],
								[
									-83.38872070312502,
									78.77934570312496
								],
								[
									-83.27143554687501,
									78.77031249999999
								],
								[
									-83.14741210937495,
									78.807861328125
								],
								[
									-82.98979492187502,
									78.84414062500002
								],
								[
									-82.441796875,
									78.84042968749998
								],
								[
									-82.29067382812494,
									78.8470703125
								],
								[
									-82.15107421874993,
									78.864111328125
								],
								[
									-81.98110351562494,
									78.89848632812499
								],
								[
									-81.78081054687499,
									78.95034179687508
								],
								[
									-81.75009765624995,
									78.97578124999993
								],
								[
									-81.88911132812495,
									78.974853515625
								],
								[
									-82.02832031249997,
									78.96186523437493
								],
								[
									-82.23740234375003,
									78.92407226562506
								],
								[
									-82.43876953125002,
									78.90366210937498
								],
								[
									-82.64409179687502,
									78.90751953124996
								],
								[
									-83.05854492187498,
									78.93950195312499
								],
								[
									-83.77861328124996,
									78.94526367187493
								],
								[
									-84.14580078124996,
									78.95981445312503
								],
								[
									-84.31611328124993,
									78.97529296875001
								],
								[
									-84.41201171875002,
									78.99658203125009
								],
								[
									-84.49584960937497,
									79.02856445312503
								],
								[
									-84.56777343749997,
									79.07128906250003
								],
								[
									-84.53027343749997,
									79.1012695312501
								],
								[
									-84.38359375000002,
									79.11855468749997
								],
								[
									-84.25664062499999,
									79.12216796875009
								],
								[
									-84.05302734374999,
									79.0986816406251
								],
								[
									-83.824609375,
									79.05883789062497
								],
								[
									-83.57587890624995,
									79.05366210937498
								],
								[
									-83.66201171875,
									79.09003906249993
								],
								[
									-83.978125,
									79.16313476562499
								],
								[
									-84.19736328125,
									79.22509765625
								],
								[
									-84.38105468749993,
									79.30126953124997
								],
								[
									-84.52241210937495,
									79.37661132812497
								],
								[
									-84.83642578124997,
									79.49472656249995
								],
								[
									-85.08979492187498,
									79.61215820312506
								],
								[
									-85.26850585937498,
									79.6641113281251
								],
								[
									-85.45693359375,
									79.68984375000008
								],
								[
									-86.031494140625,
									79.72192382812497
								],
								[
									-86.146630859375,
									79.74282226562497
								],
								[
									-86.42075195312498,
									79.84521484374994
								],
								[
									-86.49433593749995,
									80.0181640625
								],
								[
									-86.61450195312503,
									80.12353515625009
								],
								[
									-86.49853515625003,
									80.25825195312498
								],
								[
									-86.30717773437493,
									80.3193359375
								],
								[
									-85.15961914062501,
									80.27177734374999
								],
								[
									-84.67543945312497,
									80.27890625000012
								],
								[
									-84.05654296875,
									80.26196289062494
								],
								[
									-83.72363281250003,
									80.22895507812507
								],
								[
									-83.34375,
									80.14697265625006
								],
								[
									-83.00429687500002,
									80.05458984374997
								],
								[
									-82.67749023437497,
									79.99277343750009
								],
								[
									-82.37700195312496,
									79.9082519531251
								],
								[
									-82.04877929687495,
									79.78276367187502
								],
								[
									-81.85571289062497,
									79.72255859375011
								],
								[
									-81.68837890625,
									79.68579101562497
								],
								[
									-81.463037109375,
									79.65415039062509
								],
								[
									-81.03808593750003,
									79.61420898437495
								],
								[
									-80.667822265625,
									79.60102539062504
								],
								[
									-80.47592773437498,
									79.6062500000001
								],
								[
									-80.27060546874998,
									79.63520507812507
								],
								[
									-80.12446289062498,
									79.66948242187513
								],
								[
									-80.28745117187495,
									79.678955078125
								],
								[
									-80.714013671875,
									79.674951171875
								],
								[
									-81.01015625000002,
									79.69311523437506
								],
								[
									-81.17905273437498,
									79.7334472656251
								],
								[
									-81.35869140624996,
									79.78779296875007
								],
								[
									-81.64423828124998,
									79.89023437499998
								],
								[
									-81.86025390625002,
									79.95717773437494
								],
								[
									-82.332373046875,
									80.06635742187507
								],
								[
									-82.68129882812494,
									80.17490234375006
								],
								[
									-82.96113281249993,
									80.27788085937499
								],
								[
									-82.98701171874998,
									80.32260742187495
								],
								[
									-82.784814453125,
									80.35375976562509
								],
								[
									-82.53613281249994,
									80.37553710937499
								],
								[
									-80.97963867187502,
									80.44526367187498
								],
								[
									-80.05107421874993,
									80.52856445312509
								],
								[
									-79.67436523437502,
									80.62524414062497
								],
								[
									-79.62934570312501,
									80.64785156250005
								],
								[
									-78.38618164062495,
									80.78437500000007
								],
								[
									-77.50712890625002,
									80.83476562500002
								],
								[
									-77.16914062499998,
									80.842919921875
								],
								[
									-76.86298828124995,
									80.8647949218751
								],
								[
									-76.85034179687497,
									80.87817382812506
								],
								[
									-77.1185546875,
									80.89643554687507
								],
								[
									-77.38945312500002,
									80.90541992187494
								],
								[
									-78.00380859374994,
									80.90483398437499
								],
								[
									-78.55097656249995,
									80.9214355468751
								],
								[
									-78.71621093749997,
									80.95166015624994
								],
								[
									-78.68193359374999,
									81.00107421874998
								],
								[
									-78.62929687500002,
									81.04345703125009
								],
								[
									-78.46396484374998,
									81.11435546875003
								],
								[
									-78.28681640624995,
									81.16762695312505
								],
								[
									-77.53603515624994,
									81.32109375000007
								],
								[
									-77.03071289062495,
									81.38569335937507
								],
								[
									-76.88510742187503,
									81.43027343750009
								],
								[
									-77.97236328124993,
									81.330810546875
								],
								[
									-78.35214843750003,
									81.25893554687502
								],
								[
									-78.73388671875,
									81.15102539062497
								],
								[
									-78.93154296874994,
									81.11923828124998
								],
								[
									-79.07246093749995,
									81.1276367187501
								],
								[
									-79.19833984375003,
									81.117578125
								],
								[
									-79.30917968749998,
									81.08906249999995
								],
								[
									-79.40214843749999,
									81.03686523437506
								],
								[
									-79.47724609375001,
									80.96098632812507
								],
								[
									-79.54541015624994,
									80.90932617187494
								],
								[
									-79.60664062499998,
									80.88178710937501
								],
								[
									-79.76132812499998,
									80.84194335937497
								],
								[
									-80.13354492187494,
									80.76391601562497
								],
								[
									-81.00703125000001,
									80.65488281250006
								],
								[
									-81.30097656249993,
									80.62719726562509
								],
								[
									-81.55268554687498,
									80.622802734375
								],
								[
									-82.36821289062493,
									80.5613281250001
								],
								[
									-82.613037109375,
									80.55888671875005
								],
								[
									-82.88432617187502,
									80.57753906250002
								],
								[
									-82.768310546875,
									80.6306640625001
								],
								[
									-82.336767578125,
									80.72866210937508
								],
								[
									-82.22236328124998,
									80.77231445312509
								],
								[
									-82.4984375,
									80.76279296875
								],
								[
									-82.77998046874998,
									80.73603515624998
								],
								[
									-83.40141601562502,
									80.71396484375
								],
								[
									-83.647119140625,
									80.67407226562497
								],
								[
									-83.88535156250003,
									80.60175781249998
								],
								[
									-84.07626953125,
									80.55624999999995
								],
								[
									-84.21977539062493,
									80.53779296875001
								],
								[
									-84.41782226562498,
									80.52675781250005
								],
								[
									-85.14584960937495,
									80.52114257812508
								],
								[
									-85.30742187500002,
									80.52597656250009
								],
								[
									-85.72622070312497,
									80.58115234374995
								],
								[
									-86.09716796874997,
									80.56210937499998
								],
								[
									-86.250341796875,
									80.56577148437512
								],
								[
									-86.531591796875,
									80.60473632812506
								],
								[
									-86.61542968749995,
									80.63002929687497
								],
								[
									-86.60307617187502,
									80.66401367187495
								],
								[
									-86.44047851562502,
									80.72802734374994
								],
								[
									-86.252099609375,
									80.78955078125006
								],
								[
									-85.63930664062494,
									80.9246093750001
								],
								[
									-85.24628906249998,
									80.98789062499995
								],
								[
									-84.67993164062497,
									81.04238281250005
								],
								[
									-83.34921874999995,
									81.10332031250002
								],
								[
									-83.288818359375,
									81.14794921875006
								],
								[
									-84.63544921874998,
									81.09809570312493
								],
								[
									-85.780859375,
									81.03505859374997
								],
								[
									-85.96679687499997,
									81.01191406249995
								],
								[
									-86.23344726562502,
									80.95009765625008
								],
								[
									-87.08027343749995,
									80.72626953125004
								],
								[
									-87.32988281250002,
									80.66977539062498
								],
								[
									-87.711669921875,
									80.65624999999997
								],
								[
									-88.00366210937497,
									80.67539062500006
								],
								[
									-88.23198242187493,
									80.70380859374998
								],
								[
									-88.62509765625,
									80.77006835937499
								],
								[
									-88.92143554687499,
									80.80561523437504
								],
								[
									-89.06166992187497,
									80.82954101562493
								],
								[
									-89.14458007812496,
									80.85366210937497
								],
								[
									-89.21176757812498,
									80.88193359374995
								],
								[
									-89.26328125,
									80.91430664062497
								],
								[
									-89.16689453125,
									80.94130859374997
								],
								[
									-88.41308593749997,
									80.99975585937497
								],
								[
									-87.388671875,
									80.98837890625006
								],
								[
									-86.92900390624996,
									81.00043945312493
								],
								[
									-86.47675781249993,
									81.03574218750012
								],
								[
									-85.8095703125,
									81.12358398437507
								],
								[
									-85.08330078125002,
									81.24687499999996
								],
								[
									-84.94121093750002,
									81.28623046874998
								],
								[
									-85.20629882812503,
									81.29487304687504
								],
								[
									-85.40249023437502,
									81.28530273437497
								],
								[
									-85.87504882812502,
									81.24121093750006
								],
								[
									-86.62275390625001,
									81.12265625000006
								],
								[
									-87.27509765624995,
									81.08081054687506
								],
								[
									-88.88681640625003,
									81.05849609375002
								],
								[
									-89.39838867187498,
									81.02534179687504
								],
								[
									-89.623046875,
									81.03247070312497
								],
								[
									-89.79228515624993,
									81.06484375
								],
								[
									-89.98095703125,
									81.12470703125001
								],
								[
									-89.94731445312499,
									81.17265625000002
								],
								[
									-89.56337890625002,
									81.22646484374997
								],
								[
									-89.26254882812503,
									81.23906249999996
								],
								[
									-89.20869140624998,
									81.25009765625009
								],
								[
									-89.63569335937501,
									81.3020507812501
								],
								[
									-89.67368164062503,
									81.32861328125
								],
								[
									-89.42700195312494,
									81.387451171875
								],
								[
									-88.89228515624998,
									81.47412109374997
								],
								[
									-88.62192382812498,
									81.50141601562504
								],
								[
									-88.12651367187496,
									81.51879882812503
								],
								[
									-87.61669921875,
									81.50932617187496
								],
								[
									-87.597021484375,
									81.52583007812504
								],
								[
									-88.10136718749999,
									81.55864257812496
								],
								[
									-88.47905273437502,
									81.56464843750004
								],
								[
									-88.97836914062503,
									81.54150390624994
								],
								[
									-90.30351562499999,
									81.40112304687494
								],
								[
									-90.41630859374996,
									81.40537109375
								],
								[
									-90.60903320312497,
									81.42954101562495
								],
								[
									-90.55375976562499,
									81.464208984375
								],
								[
									-89.84521484374997,
									81.61166992187512
								],
								[
									-89.82167968749997,
									81.63486328124995
								],
								[
									-90.33085937499996,
									81.63154296874998
								],
								[
									-90.48037109374997,
									81.63852539062506
								],
								[
									-90.62631835937503,
									81.656005859375
								],
								[
									-90.83374023437503,
									81.64047851562503
								],
								[
									-91.10273437500001,
									81.59199218749993
								],
								[
									-91.29238281250002,
									81.57124023437495
								],
								[
									-91.40278320312495,
									81.57822265625003
								],
								[
									-91.68408203124997,
									81.63569335937504
								],
								[
									-91.64755859374998,
									81.68383789062506
								],
								[
									-91.42382812499997,
									81.74423828125003
								],
								[
									-91.219482421875,
									81.78774414062511
								],
								[
									-90.94194335937493,
									81.82744140625002
								],
								[
									-90.49018554687501,
									81.87724609375005
								],
								[
									-90.16303710937498,
									81.89404296875
								],
								[
									-89.63334960937499,
									81.89453125
								],
								[
									-89.381005859375,
									81.916748046875
								],
								[
									-89.15634765624998,
									81.95541992187498
								],
								[
									-88.875244140625,
									82.01801757812504
								],
								[
									-88.56684570312495,
									82.0610839843751
								],
								[
									-88.06318359375001,
									82.0964843750001
								],
								[
									-87.638916015625,
									82.08505859375
								],
								[
									-87.40439453125,
									82.05419921874994
								],
								[
									-87.2181640625,
									82.00009765625012
								],
								[
									-87.01821289062502,
									81.95874023437494
								],
								[
									-86.99921874999998,
									81.9921386718751
								],
								[
									-86.83403320312499,
									82.03334960937505
								],
								[
									-86.62680664062495,
									82.051025390625
								],
								[
									-86.37753906249998,
									82.04511718749995
								],
								[
									-86.158349609375,
									82.02553710937497
								],
								[
									-85.87480468749996,
									81.97568359375012
								],
								[
									-85.645654296875,
									81.95327148437508
								],
								[
									-85.53798828125,
									81.95463867187499
								],
								[
									-85.40317382812498,
									81.98222656250002
								],
								[
									-85.04482421875,
									81.98281249999997
								],
								[
									-85.05224609374997,
									81.99453125000005
								],
								[
									-85.16923828125002,
									82.02338867187507
								],
								[
									-85.31059570312496,
									82.04399414062499
								],
								[
									-86.58061523437496,
									82.18720703125004
								],
								[
									-86.615625,
									82.2185546875001
								],
								[
									-86.18759765625,
									82.24794921875005
								],
								[
									-85.92001953125003,
									82.28305664062512
								],
								[
									-85.79443359375003,
									82.29160156250006
								],
								[
									-85.480859375,
									82.36630859375012
								],
								[
									-85.2759765625,
									82.40522460937495
								],
								[
									-84.89682617187503,
									82.44941406249998
								],
								[
									-84.74472656250003,
									82.43735351562509
								],
								[
									-84.55336914062497,
									82.39833984374997
								],
								[
									-84.36811523437495,
									82.37392578124997
								],
								[
									-83.82363281249997,
									82.35068359374995
								],
								[
									-83.59067382812503,
									82.32646484374999
								],
								[
									-83.17568359374994,
									82.18720703125004
								],
								[
									-83.01015624999997,
									82.14169921875
								],
								[
									-82.77421874999996,
									82.09492187500007
								],
								[
									-82.63369140625002,
									82.07729492187494
								],
								[
									-82.35600585937493,
									82.06601562499995
								],
								[
									-82.32744140624999,
									82.09248046874993
								],
								[
									-82.65708007812498,
									82.15830078125
								],
								[
									-82.74746093750002,
									82.19643554687497
								],
								[
									-82.70859375,
									82.22871093750004
								],
								[
									-82.63837890625001,
									82.24575195312497
								],
								[
									-82.53691406250002,
									82.24726562499993
								],
								[
									-82.27656250000001,
									82.21845703125001
								],
								[
									-81.58447265624997,
									82.12055664062495
								],
								[
									-80.54990234374995,
									82.00458984374995
								],
								[
									-80.15336914062499,
									81.97763671874998
								],
								[
									-79.90864257812495,
									81.93623046875007
								],
								[
									-79.685546875,
									81.88588867187494
								],
								[
									-79.46562499999996,
									81.85112304687496
								],
								[
									-79.42485351562499,
									81.85444335937493
								],
								[
									-79.62949218750003,
									81.93232421874998
								],
								[
									-80.12983398437501,
									82.0283691406251
								],
								[
									-81.46826171875,
									82.19238281250003
								],
								[
									-81.99760742187502,
									82.27827148437501
								],
								[
									-82.25366210937497,
									82.33632812500005
								],
								[
									-82.44755859374993,
									82.39501953125
								],
								[
									-82.45136718750001,
									82.42709960937506
								],
								[
									-82.26889648437495,
									82.46464843750007
								],
								[
									-82.02324218749999,
									82.494384765625
								],
								[
									-81.71777343750003,
									82.50625000000002
								],
								[
									-81.68115234375003,
									82.51865234375006
								],
								[
									-81.95859374999998,
									82.56323242187509
								],
								[
									-82.12250976562498,
									82.60175781250001
								],
								[
									-82.11684570312497,
									82.628662109375
								],
								[
									-81.78535156249995,
									82.64921875000002
								],
								[
									-81.57968749999998,
									82.64301757812507
								],
								[
									-81.18886718750002,
									82.59448242187506
								],
								[
									-80.86249999999995,
									82.571533203125
								],
								[
									-80.80966796875003,
									82.5863769531251
								],
								[
									-81.14663085937502,
									82.71557617187494
								],
								[
									-81.17807617187503,
									82.7446777343751
								],
								[
									-81.128173828125,
									82.76171875000011
								],
								[
									-81.01015625000002,
									82.779052734375
								],
								[
									-80.65712890624997,
									82.7690917968751
								],
								[
									-80.07578125,
									82.70620117187508
								],
								[
									-79.03505859375,
									82.67465820312495
								],
								[
									-78.74877929687503,
									82.67939453125004
								],
								[
									-78.79179687499999,
									82.69389648437496
								],
								[
									-79.20722656249998,
									82.73276367187498
								],
								[
									-79.6419921875,
									82.78496093749996
								],
								[
									-79.83378906249999,
									82.81650390625006
								],
								[
									-79.97431640624993,
									82.85898437500003
								],
								[
									-80.14116210937499,
									82.89423828124993
								],
								[
									-80.15493164062497,
									82.91113281250009
								],
								[
									-79.88632812500003,
									82.93852539062507
								],
								[
									-79.18056640624997,
									82.93320312500003
								],
								[
									-78.52495117187499,
									82.89111328125
								],
								[
									-77.96865234374997,
									82.90634765625009
								],
								[
									-77.61806640624997,
									82.89584960937506
								],
								[
									-77.47958984375,
									82.88315429687498
								],
								[
									-77.22587890624999,
									82.83720703125013
								],
								[
									-76.42099609374998,
									82.67089843750009
								],
								[
									-76.33554687499998,
									82.64443359375002
								],
								[
									-76.24404296875,
									82.60410156250006
								],
								[
									-76.146484375,
									82.54985351562502
								],
								[
									-76.00937499999998,
									82.53515625000006
								],
								[
									-75.74433593749998,
									82.572412109375
								],
								[
									-75.56562499999998,
									82.60854492187508
								],
								[
									-75.64287109374999,
									82.64350585937501
								],
								[
									-76.08696289062496,
									82.72363281250009
								],
								[
									-76.18779296874999,
									82.75791015624995
								],
								[
									-76.40996093749996,
									82.81582031249994
								],
								[
									-76.908447265625,
									82.91943359375
								],
								[
									-77.04121093749995,
									82.96752929687503
								],
								[
									-77.12490234374994,
									83.00854492187494
								],
								[
									-75.74492187500002,
									83.04716796874999
								],
								[
									-74.41416015624998,
									83.01313476562498
								],
								[
									-74.19775390625003,
									82.98901367187506
								],
								[
									-74.05585937499998,
									82.95537109375013
								],
								[
									-73.91650390625,
									82.90419921875
								],
								[
									-73.70312499999997,
									82.85185546874999
								],
								[
									-73.27202148437499,
									82.77158203124998
								],
								[
									-72.65869140625,
									82.72163085937493
								],
								[
									-72.77592773437499,
									82.7556640625001
								],
								[
									-73.23466796875002,
									82.84423828125003
								],
								[
									-73.44189453124994,
									82.90483398437505
								],
								[
									-73.44072265624999,
									82.94584960937496
								],
								[
									-73.40380859375,
									82.97714843750003
								],
								[
									-73.33115234375003,
									82.998779296875
								],
								[
									-72.811669921875,
									83.081201171875
								],
								[
									-72.06923828125,
									83.1060546875
								],
								[
									-71.98320312499996,
									83.10141601562495
								],
								[
									-71.40595703124995,
									82.974853515625
								],
								[
									-71.13203125000001,
									82.92304687499993
								],
								[
									-70.94038085937495,
									82.90224609375005
								],
								[
									-70.93300781249997,
									82.91127929687494
								],
								[
									-71.19833984375003,
									82.96958007812509
								],
								[
									-71.40239257812493,
									83.00126953125005
								],
								[
									-71.42353515624998,
									83.02114257812494
								],
								[
									-71.08481445312498,
									83.08266601562494
								],
								[
									-70.87055664062495,
									83.09814453125009
								],
								[
									-69.96992187499995,
									83.11611328125011
								],
								[
									-69.86767578125,
									83.10961914062511
								],
								[
									-69.78212890625,
									83.092529296875
								],
								[
									-69.56938476562499,
									83.02490234375009
								],
								[
									-69.4888671875,
									83.01679687500001
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "CAN",
					"su_a3": "CAN",
					"brk_group": "",
					"region_wb": "North America",
					"wb_a3": "CAN",
					"gu_a3": "CAN",
					"abbrev": "Can.",
					"region_un": "Americas",
					"adm0_a3_us": "CAN",
					"scalerank": 1,
					"pop_est": 33487208,
					"adm0_dif": 0,
					"un_a3": "124",
					"pop_year": -99,
					"gdp_md_est": 1300000,
					"name": "Canada",
					"sovereignt": "Canada",
					"economy": "1. Developed region: G7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Canada",
					"postal": "CA",
					"sov_a3": "CAN",
					"note_brk": "",
					"brk_a3": "CAN",
					"wb_a2": "CA",
					"brk_diff": 0,
					"admin": "Canada",
					"name_long": "Canada",
					"iso_a3": "CAN",
					"iso_a2": "CA",
					"adm0_a3_is": "CAN",
					"level": 2,
					"formal_en": "Canada",
					"name_len": 6,
					"mapcolor7": 6,
					"long_len": 6,
					"mapcolor8": 6,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "124",
					"homepart": 1,
					"subunit": "Canada",
					"name_alt": "",
					"brk_name": "Canada",
					"name_sort": "Canada",
					"continent": "North America",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								9.182812500000068,
								47.67070312499999
							],
							[
								9.250292968750045,
								47.59794921874999
							],
							[
								9.452343750000011,
								47.51396484375002
							],
							[
								9.554394531250011,
								47.511132812499994
							],
							[
								9.625878906249994,
								47.46704101562497
							],
							[
								9.60908203125004,
								47.39179687500001
							],
							[
								9.52753906250004,
								47.27075195312503
							],
							[
								9.484277343750023,
								47.172656250000045
							],
							[
								9.479492187500028,
								47.097509765625006
							],
							[
								9.487695312499994,
								47.06225585937503
							],
							[
								9.502343750000051,
								47.06274414062503
							],
							[
								9.58027343750004,
								47.057373046875
							],
							[
								9.619921875000045,
								47.057470703125034
							],
							[
								9.745019531250023,
								47.03710937500006
							],
							[
								9.845312500000034,
								47.00737304687502
							],
							[
								9.864648437500051,
								46.97597656250002
							],
							[
								9.877734375000074,
								46.93769531250004
							],
							[
								9.996874999999989,
								46.885351562500034
							],
							[
								10.13349609375004,
								46.85151367187498
							],
							[
								10.179785156250063,
								46.86235351562496
							],
							[
								10.349414062500045,
								46.98476562500005
							],
							[
								10.41494140625008,
								46.96440429687499
							],
							[
								10.45458984375,
								46.89941406249997
							],
							[
								10.452832031250068,
								46.86494140625007
							],
							[
								10.406054687500045,
								46.73486328125003
							],
							[
								10.39794921875,
								46.665039062500085
							],
							[
								10.438281250000045,
								46.61884765625001
							],
							[
								10.442480468750006,
								46.58286132812506
							],
							[
								10.4306640625,
								46.55004882812503
							],
							[
								10.363085937499989,
								46.54707031250004
							],
							[
								10.272265625000074,
								46.56484375000002
							],
							[
								10.195507812500068,
								46.62109375000003
							],
							[
								10.137500000000045,
								46.61435546875006
							],
							[
								10.087011718750063,
								46.599902343750074
							],
							[
								10.061230468750068,
								46.54677734375008
							],
							[
								10.038281250000011,
								46.4832031250001
							],
							[
								10.045605468750068,
								46.44790039062508
							],
							[
								10.081933593750023,
								46.42075195312498
							],
							[
								10.109667968750074,
								46.36284179687499
							],
							[
								10.1298828125,
								46.28798828125002
							],
							[
								10.145214843750011,
								46.25351562500009
							],
							[
								10.128320312500051,
								46.23823242187501
							],
							[
								10.08056640625,
								46.22797851562504
							],
							[
								10.041015625000028,
								46.238085937500074
							],
							[
								9.971679687500028,
								46.32768554687502
							],
							[
								9.939257812500074,
								46.36181640625006
							],
							[
								9.884472656250011,
								46.36777343750012
							],
							[
								9.78779296875004,
								46.346044921875034
							],
							[
								9.639453125000017,
								46.29589843750003
							],
							[
								9.57958984375,
								46.29609374999998
							],
							[
								9.528710937500023,
								46.3062011718751
							],
							[
								9.481054687499977,
								46.348779296874966
							],
							[
								9.440625000000011,
								46.43081054687508
							],
							[
								9.427636718750023,
								46.482324218749994
							],
							[
								9.399316406250023,
								46.48066406250001
							],
							[
								9.304394531250068,
								46.49555664062504
							],
							[
								9.260156250000023,
								46.47519531250006
							],
							[
								9.259765625000028,
								46.39125976562511
							],
							[
								9.251074218750034,
								46.28676757812505
							],
							[
								9.203417968749989,
								46.21923828125006
							],
							[
								9.070996093750011,
								46.102441406249966
							],
							[
								9.022363281250051,
								46.05146484375007
							],
							[
								9.003027343750034,
								46.014892578125085
							],
							[
								8.99892578125008,
								45.98310546875007
							],
							[
								9.019140625000034,
								45.92812500000008
							],
							[
								9.046679687500045,
								45.87558593750012
							],
							[
								9.023730468750074,
								45.84570312499997
							],
							[
								8.953710937500034,
								45.83002929687498
							],
							[
								8.904296875,
								45.86196289062508
							],
							[
								8.88515625000008,
								45.918701171875114
							],
							[
								8.778027343750011,
								45.99619140625009
							],
							[
								8.826757812500006,
								46.06103515624997
							],
							[
								8.818554687500011,
								46.07714843750006
							],
							[
								8.641699218750063,
								46.11079101562498
							],
							[
								8.565429687500057,
								46.15981445312502
							],
							[
								8.458398437500023,
								46.245898437500074
							],
							[
								8.438476562500028,
								46.28286132812505
							],
							[
								8.442968750000063,
								46.40278320312504
							],
							[
								8.436816406250045,
								46.43188476562503
							],
							[
								8.422558593749983,
								46.44604492187506
							],
							[
								8.370703125000006,
								46.445117187500045
							],
							[
								8.29853515625004,
								46.40341796875009
							],
							[
								8.231933593750057,
								46.34121093750002
							],
							[
								8.095703125000028,
								46.271044921875045
							],
							[
								8.081542968750057,
								46.25600585937508
							],
							[
								8.127246093750045,
								46.18759765625009
							],
							[
								8.125195312500068,
								46.160937500000074
							],
							[
								8.014257812500034,
								46.05190429687505
							],
							[
								7.9931640625,
								46.01591796875002
							],
							[
								7.852343749999989,
								45.94746093750001
							],
							[
								7.787890625000017,
								45.92182617187504
							],
							[
								7.592578125000017,
								45.97221679687499
							],
							[
								7.538574218750028,
								45.978173828124966
							],
							[
								7.451562500000051,
								45.94443359375012
							],
							[
								7.327929687500017,
								45.91235351562506
							],
							[
								7.1290039062500625,
								45.880419921875045
							],
							[
								7.0557617187500625,
								45.90380859375
							],
							[
								7.021093750000034,
								45.92578124999994
							],
							[
								7.00390625,
								45.95883789062512
							],
							[
								6.9537109375000625,
								46.017138671875074
							],
							[
								6.897265625000017,
								46.05175781250003
							],
							[
								6.858007812500006,
								46.089404296875074
							],
							[
								6.8056640625,
								46.130664062500045
							],
							[
								6.772070312500006,
								46.165136718750034
							],
							[
								6.816796875000051,
								46.27519531249999
							],
							[
								6.7841796875,
								46.313964843750085
							],
							[
								6.767382812500017,
								46.369189453125045
							],
							[
								6.776074218750011,
								46.40664062500002
							],
							[
								6.758105468750017,
								46.41577148437503
							],
							[
								6.578222656250034,
								46.43735351562506
							],
							[
								6.428906249999983,
								46.43051757812509
							],
							[
								6.321875000000034,
								46.39370117187505
							],
							[
								6.2346679687500455,
								46.33261718750006
							],
							[
								6.224218750000034,
								46.319433593750034
							],
							[
								6.2295898437500625,
								46.30844726562509
							],
							[
								6.272949218750028,
								46.25224609375002
							],
							[
								6.19941406250004,
								46.19306640625004
							],
							[
								6.086621093750068,
								46.14702148437499
							],
							[
								6.0066406250000455,
								46.142333984375114
							],
							[
								5.971484375000074,
								46.151220703125034
							],
							[
								5.9700195312500455,
								46.214697265625006
							],
							[
								6.0361328125,
								46.238085937500074
							],
							[
								6.095898437500011,
								46.279394531250034
							],
							[
								6.115917968750011,
								46.337646484375114
							],
							[
								6.123242187500068,
								46.37861328125001
							],
							[
								6.06025390625004,
								46.42817382812498
							],
							[
								6.067968750000006,
								46.458544921875045
							],
							[
								6.1070312500000625,
								46.51606445312504
							],
							[
								6.1296875000000455,
								46.56699218750012
							],
							[
								6.160742187499977,
								46.61103515625001
							],
							[
								6.285156250000028,
								46.68305664062504
							],
							[
								6.41015625,
								46.755419921875045
							],
							[
								6.429003906250017,
								46.83227539062497
							],
							[
								6.438574218750006,
								46.925878906250034
							],
							[
								6.456250000000068,
								46.94833984375009
							],
							[
								6.624804687500017,
								47.00434570312504
							],
							[
								6.66689453125008,
								47.02651367187502
							],
							[
								6.688085937500034,
								47.05825195312508
							],
							[
								6.820703125000051,
								47.16318359374998
							],
							[
								6.95205078125008,
								47.26718750000012
							],
							[
								6.978515625000057,
								47.30205078125002
							],
							[
								7.000585937500034,
								47.322509765625114
							],
							[
								7.000585937500034,
								47.339453125000006
							],
							[
								6.98408203125004,
								47.3525390625
							],
							[
								6.9214843750000625,
								47.361230468749994
							],
							[
								6.900390625000028,
								47.39423828125007
							],
							[
								6.968359375000034,
								47.45322265625009
							],
							[
								7.05341796875004,
								47.48935546875009
							],
							[
								7.136035156250074,
								47.48984375000009
							],
							[
								7.169238281250017,
								47.47324218750009
							],
							[
								7.16748046875,
								47.453710937500006
							],
							[
								7.203124999999972,
								47.43271484375009
							],
							[
								7.265722656250034,
								47.42578125
							],
							[
								7.343164062499994,
								47.433105468750085
							],
							[
								7.420019531250034,
								47.455175781250034
							],
							[
								7.467382812500006,
								47.50766601562509
							],
							[
								7.494921875000017,
								47.547363281250085
							],
							[
								7.615624999999994,
								47.5927246093751
							],
							[
								7.698046875000017,
								47.56987304687496
							],
							[
								7.927050781250017,
								47.56386718750008
							],
							[
								8.093750000000057,
								47.576171875
							],
							[
								8.198242187500028,
								47.60693359375006
							],
							[
								8.327832031250068,
								47.60693359375006
							],
							[
								8.414746093750011,
								47.589599609375085
							],
							[
								8.430078125000023,
								47.59213867187506
							],
							[
								8.454003906249994,
								47.596191406250085
							],
							[
								8.477636718750034,
								47.61269531250008
							],
							[
								8.55947265625008,
								47.62402343750006
							],
							[
								8.570507812500011,
								47.637792968750034
							],
							[
								8.56708984375004,
								47.651904296875074
							],
							[
								8.552343750000063,
								47.65913085937504
							],
							[
								8.451757812499977,
								47.65180664062504
							],
							[
								8.413281250000068,
								47.662695312500034
							],
							[
								8.403417968750006,
								47.6877929687501
							],
							[
								8.435742187500011,
								47.731347656249994
							],
							[
								8.509863281250006,
								47.766894531250045
							],
							[
								8.572656250000023,
								47.77563476562506
							],
							[
								8.617871093749983,
								47.76611328124997
							],
							[
								8.728320312500017,
								47.70004882812509
							],
							[
								8.75478515625008,
								47.69804687499996
							],
							[
								8.770117187500006,
								47.70991210937498
							],
							[
								8.793066406250063,
								47.716552734375
							],
							[
								8.831152343750006,
								47.70361328125003
							],
							[
								8.874023437500028,
								47.662695312500034
							],
							[
								8.881152343750074,
								47.65639648437508
							],
							[
								9.127539062500006,
								47.67070312499999
							],
							[
								9.182812500000068,
								47.67070312499999
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "CHE",
					"su_a3": "CHE",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "CHE",
					"gu_a3": "CHE",
					"abbrev": "Switz.",
					"region_un": "Europe",
					"adm0_a3_us": "CHE",
					"scalerank": 1,
					"pop_est": 7604467,
					"adm0_dif": 0,
					"un_a3": "756",
					"pop_year": -99,
					"gdp_md_est": 316700,
					"name": "Switzerland",
					"sovereignt": "Switzerland",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Switzerland",
					"postal": "CH",
					"sov_a3": "CHE",
					"note_brk": "",
					"brk_a3": "CHE",
					"wb_a2": "CH",
					"brk_diff": 0,
					"admin": "Switzerland",
					"name_long": "Switzerland",
					"iso_a3": "CHE",
					"iso_a2": "CH",
					"adm0_a3_is": "CHE",
					"level": 2,
					"formal_en": "Swiss Confederation",
					"name_len": 11,
					"mapcolor7": 5,
					"long_len": 11,
					"mapcolor8": 2,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "756",
					"homepart": 1,
					"subunit": "Switzerland",
					"name_alt": "",
					"brk_name": "Switzerland",
					"name_sort": "Switzerland",
					"continent": "Europe",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-67.57519531249997,
									-55.889648437500064
								],
								[
									-67.61142578124998,
									-55.89169921875004
								],
								[
									-67.69951171874999,
									-55.87314453125008
								],
								[
									-67.83154296874997,
									-55.86484375000008
								],
								[
									-67.84643554687497,
									-55.85722656250003
								],
								[
									-67.84970703125003,
									-55.84257812500007
								],
								[
									-67.83408203124995,
									-55.82753906250002
								],
								[
									-67.76206054687503,
									-55.816113281250004
								],
								[
									-67.54482421875,
									-55.82597656250006
								],
								[
									-67.51728515624998,
									-55.83281250000003
								],
								[
									-67.50981445312496,
									-55.84433593750007
								],
								[
									-67.545263671875,
									-55.877441406250064
								],
								[
									-67.57519531249997,
									-55.889648437500064
								]
							]
						],
						[
							[
								[
									-67.28886718749999,
									-55.77685546875
								],
								[
									-67.32529296875003,
									-55.78476562500001
								],
								[
									-67.35224609374993,
									-55.766015625000016
								],
								[
									-67.39335937499996,
									-55.75273437500006
								],
								[
									-67.55996093749997,
									-55.724804687500054
								],
								[
									-67.56347656249997,
									-55.70781250000006
								],
								[
									-67.546142578125,
									-55.68369140625003
								],
								[
									-67.51279296874995,
									-55.66201171875005
								],
								[
									-67.44882812499998,
									-55.64062500000005
								],
								[
									-67.39736328124997,
									-55.585156250000026
								],
								[
									-67.37407226562493,
									-55.58935546874999
								],
								[
									-67.35058593749994,
									-55.61210937500001
								],
								[
									-67.31044921874994,
									-55.68867187500007
								],
								[
									-67.26245117187503,
									-55.743750000000006
								],
								[
									-67.26728515624995,
									-55.76279296875007
								],
								[
									-67.28886718749999,
									-55.77685546875
								]
							]
						],
						[
							[
								[
									-66.47211914062495,
									-55.229101562500055
								],
								[
									-66.55170898437501,
									-55.272851562499994
								],
								[
									-66.61113281249993,
									-55.26992187500002
								],
								[
									-66.63017578124999,
									-55.25410156250008
								],
								[
									-66.63662109375,
									-55.234375000000064
								],
								[
									-66.62475585937497,
									-55.213085937500075
								],
								[
									-66.59970703125,
									-55.193652343750024
								],
								[
									-66.54155273437499,
									-55.169433593750064
								],
								[
									-66.52314453124995,
									-55.16552734375007
								],
								[
									-66.435791015625,
									-55.18974609375003
								],
								[
									-66.47211914062495,
									-55.229101562500055
								]
							]
						],
						[
							[
								[
									-67.07993164062498,
									-55.15380859374999
								],
								[
									-67.10947265625003,
									-55.19208984375006
								],
								[
									-67.17255859375001,
									-55.242578125000044
								],
								[
									-67.25742187499998,
									-55.28183593750005
								],
								[
									-67.33969726562495,
									-55.29257812500002
								],
								[
									-67.399267578125,
									-55.27226562500005
								],
								[
									-67.42939453124993,
									-55.236523437500054
								],
								[
									-67.44326171875,
									-55.20117187500005
								],
								[
									-67.46347656250003,
									-55.18173828125
								],
								[
									-67.4947265625,
									-55.17744140625001
								],
								[
									-67.53525390625,
									-55.17851562500005
								],
								[
									-67.58520507812497,
									-55.19199218750004
								],
								[
									-67.69145507812493,
									-55.24296875000004
								],
								[
									-67.73696289062497,
									-55.25644531250003
								],
								[
									-67.76777343749995,
									-55.259570312500045
								],
								[
									-68.07001953124998,
									-55.22109375000002
								],
								[
									-68.09951171875002,
									-55.206835937500045
								],
								[
									-68.135107421875,
									-55.17265625000001
								],
								[
									-68.17431640625,
									-55.07128906250006
								],
								[
									-68.30136718750003,
									-54.98066406250007
								],
								[
									-68.10693359375003,
									-54.92939453125001
								],
								[
									-67.87412109375003,
									-54.92968750000007
								],
								[
									-67.424560546875,
									-54.968945312500075
								],
								[
									-67.245263671875,
									-54.97763671875007
								],
								[
									-67.10732421874997,
									-55.06357421874999
								],
								[
									-67.08549804687496,
									-55.115234375000036
								],
								[
									-67.07993164062498,
									-55.15380859374999
								]
							]
						],
						[
							[
								[
									-69.70297851562503,
									-54.919042968750034
								],
								[
									-68.90078125000002,
									-55.017773437500075
								],
								[
									-68.65351562500001,
									-54.95791015625005
								],
								[
									-68.45800781249997,
									-54.959667968750054
								],
								[
									-68.39980468750002,
									-55.041992187500036
								],
								[
									-68.59809570312498,
									-55.12832031250004
								],
								[
									-68.61328124999997,
									-55.15556640625008
								],
								[
									-68.585546875,
									-55.17773437500007
								],
								[
									-68.38173828124997,
									-55.191601562500054
								],
								[
									-68.33007812500003,
									-55.21943359375004
								],
								[
									-68.28266601562495,
									-55.25517578125004
								],
								[
									-68.32275390625003,
									-55.308203125000006
								],
								[
									-68.32656250000002,
									-55.332714843750026
								],
								[
									-68.30541992187497,
									-55.35664062500001
								],
								[
									-68.152587890625,
									-55.43691406250002
								],
								[
									-68.08989257812502,
									-55.478320312500024
								],
								[
									-68.05830078124998,
									-55.517968750000016
								],
								[
									-68.04555664062497,
									-55.58750000000006
								],
								[
									-68.04833984375,
									-55.643164062500034
								],
								[
									-68.08266601562497,
									-55.65058593750003
								],
								[
									-68.15708007812503,
									-55.63369140625006
								],
								[
									-68.229638671875,
									-55.60156249999999
								],
								[
									-68.293359375,
									-55.52138671875
								],
								[
									-68.33803710937494,
									-55.50527343750001
								],
								[
									-68.46669921874997,
									-55.48906250000008
								],
								[
									-68.59418945312501,
									-55.450000000000024
								],
								[
									-68.69355468749998,
									-55.45224609375004
								],
								[
									-68.78500976562498,
									-55.435644531250034
								],
								[
									-68.86704101562498,
									-55.450195312500064
								],
								[
									-68.89614257812497,
									-55.42382812500002
								],
								[
									-68.93129882812502,
									-55.370605468750014
								],
								[
									-68.93208007812501,
									-55.347363281250075
								],
								[
									-68.88896484375002,
									-55.26328125
								],
								[
									-68.89008789062498,
									-55.241210937500036
								],
								[
									-68.91264648437496,
									-55.23857421875003
								],
								[
									-69.00820312499997,
									-55.255761718750065
								],
								[
									-69.04682617187493,
									-55.24433593750005
								],
								[
									-69.15078124999997,
									-55.18339843750007
								],
								[
									-69.19262695312497,
									-55.17187500000003
								],
								[
									-69.29707031249993,
									-55.16582031250004
								],
								[
									-69.35615234374998,
									-55.273925781250036
								],
								[
									-69.35922851562498,
									-55.30068359374998
								],
								[
									-69.29902343749998,
									-55.369335937500026
								],
								[
									-69.18085937499998,
									-55.47480468750002
								],
								[
									-69.2408203125,
									-55.47675781250006
								],
								[
									-69.41181640624995,
									-55.44423828125001
								],
								[
									-69.45571289062502,
									-55.42402343750006
								],
								[
									-69.50869140624997,
									-55.370898437500074
								],
								[
									-69.61025390624997,
									-55.33994140625008
								],
								[
									-69.64589843749994,
									-55.32089843750001
								],
								[
									-69.65629882812502,
									-55.298437500000055
								],
								[
									-69.65737304687497,
									-55.229003906250036
								],
								[
									-69.67983398437502,
									-55.218945312500026
								],
								[
									-69.82402343749999,
									-55.236523437500054
								],
								[
									-69.85371093750001,
									-55.21982421875003
								],
								[
									-69.86577148437496,
									-55.19062500000003
								],
								[
									-69.88676757812499,
									-55.174121093750045
								],
								[
									-69.97978515625002,
									-55.14746093750003
								],
								[
									-69.98798828125001,
									-55.13076171875
								],
								[
									-69.946533203125,
									-55.11103515625007
								],
								[
									-69.92084960937501,
									-55.06113281250003
								],
								[
									-69.88442382812497,
									-54.88203125000005
								],
								[
									-69.70297851562503,
									-54.919042968750034
								]
							]
						],
						[
							[
								[
									-70.9916015625,
									-54.867968750000024
								],
								[
									-70.94511718749996,
									-54.931347656250054
								],
								[
									-70.92792968750001,
									-54.94296875000003
								],
								[
									-70.80483398437497,
									-54.967675781249994
								],
								[
									-70.74931640624993,
									-54.95273437500006
								],
								[
									-70.61528320312499,
									-54.94560546875003
								],
								[
									-70.534765625,
									-54.92128906250005
								],
								[
									-70.41752929687493,
									-54.90888671875001
								],
								[
									-70.28305664062498,
									-55.06591796875003
								],
								[
									-70.29785156249997,
									-55.11376953125001
								],
								[
									-70.40415039062498,
									-55.165625
								],
								[
									-70.47558593749994,
									-55.17705078125002
								],
								[
									-70.54345703125,
									-55.16132812500001
								],
								[
									-70.53872070312502,
									-55.13496093750006
								],
								[
									-70.55107421874996,
									-55.11191406250007
								],
								[
									-70.59746093749999,
									-55.08203125000002
								],
								[
									-70.64091796874996,
									-55.084863281250065
								],
								[
									-70.71098632812496,
									-55.106933593750036
								],
								[
									-70.74443359375002,
									-55.10419921875001
								],
								[
									-70.81547851562502,
									-55.07988281250003
								],
								[
									-70.93984374999994,
									-55.06191406250001
								],
								[
									-70.964501953125,
									-55.039648437500006
								],
								[
									-70.96728515625003,
									-55.00683593750007
								],
								[
									-70.99072265625,
									-54.99042968750001
								],
								[
									-71.12036132812494,
									-54.93779296875004
								],
								[
									-71.20332031249998,
									-54.89296875000005
								],
								[
									-71.27363281250001,
									-54.88691406250006
								],
								[
									-71.29931640625,
									-54.892285156250004
								],
								[
									-71.32534179687497,
									-54.913769531250026
								],
								[
									-71.38857421874997,
									-54.93427734375003
								],
								[
									-71.406640625,
									-54.93085937500005
								],
								[
									-71.42690429687497,
									-54.913769531250026
								],
								[
									-71.43720703125001,
									-54.889257812500006
								],
								[
									-71.410546875,
									-54.83935546875006
								],
								[
									-71.37426757812497,
									-54.834570312500055
								],
								[
									-71.19707031249993,
									-54.844433593750026
								],
								[
									-71.08862304687497,
									-54.86748046875001
								],
								[
									-70.9916015625,
									-54.867968750000024
								]
							]
						],
						[
							[
								[
									-71.390478515625,
									-54.032812500000055
								],
								[
									-71.16874999999996,
									-54.11259765625005
								],
								[
									-71.02192382812495,
									-54.11181640625007
								],
								[
									-71.02285156249997,
									-54.16171875000003
								],
								[
									-71.00488281249997,
									-54.24667968750001
								],
								[
									-71.02802734374995,
									-54.28115234375002
								],
								[
									-71.08295898437495,
									-54.31630859374999
								],
								[
									-71.117529296875,
									-54.36630859375005
								],
								[
									-71.14326171874998,
									-54.37402343750002
								],
								[
									-71.30463867187501,
									-54.313574218750055
								],
								[
									-71.473291015625,
									-54.23115234375005
								],
								[
									-71.55810546874994,
									-54.245605468750064
								],
								[
									-71.67060546874995,
									-54.22539062500003
								],
								[
									-71.76123046874994,
									-54.22978515625004
								],
								[
									-71.81757812499998,
									-54.27646484375004
								],
								[
									-71.94853515625002,
									-54.30087890625004
								],
								[
									-71.97236328124998,
									-54.20722656250006
								],
								[
									-72.091552734375,
									-54.11875000000006
								],
								[
									-72.21044921874997,
									-54.04775390624999
								],
								[
									-72.14604492187502,
									-53.93886718750001
								],
								[
									-72.06894531250003,
									-53.92128906249998
								],
								[
									-71.996484375,
									-53.88486328125002
								],
								[
									-71.70512695312499,
									-53.92333984375004
								],
								[
									-71.55415039062495,
									-53.95605468750005
								],
								[
									-71.390478515625,
									-54.032812500000055
								]
							]
						],
						[
							[
								[
									-72.9232421875,
									-53.48164062500003
								],
								[
									-72.89628906249999,
									-53.562792968750045
								],
								[
									-72.88222656249997,
									-53.57832031250001
								],
								[
									-72.80937499999996,
									-53.56533203125003
								],
								[
									-72.68549804687495,
									-53.557910156250024
								],
								[
									-72.48227539062503,
									-53.58808593750005
								],
								[
									-72.45922851562494,
									-53.59882812500001
								],
								[
									-72.37290039062503,
									-53.68750000000005
								],
								[
									-72.30668945312496,
									-53.72539062500004
								],
								[
									-72.20541992187503,
									-53.80742187500005
								],
								[
									-72.30624999999995,
									-53.862109375
								],
								[
									-72.36596679687497,
									-53.94082031250005
								],
								[
									-72.36914062499997,
									-53.98076171875002
								],
								[
									-72.408544921875,
									-54.00380859375001
								],
								[
									-72.47050781249993,
									-54.027734374999994
								],
								[
									-72.56289062500002,
									-54.07373046875004
								],
								[
									-72.67656249999999,
									-54.07890625000003
								],
								[
									-72.78862304687499,
									-54.10312500000008
								],
								[
									-72.84038085937499,
									-54.12509765625003
								],
								[
									-72.87099609375,
									-54.126562500000055
								],
								[
									-72.90727539062502,
									-54.11464843750003
								],
								[
									-72.94609375000002,
									-54.09208984375005
								],
								[
									-72.95859374999998,
									-54.06591796875005
								],
								[
									-72.88173828124997,
									-54.04160156250007
								],
								[
									-72.78168945312501,
									-53.954785156250054
								],
								[
									-72.76376953125,
									-53.86484375000003
								],
								[
									-72.87172851562497,
									-53.848535156249994
								],
								[
									-72.93613281250003,
									-53.860839843750014
								],
								[
									-72.98422851562498,
									-53.86054687500004
								],
								[
									-73.03945312499994,
									-53.832812500000074
								],
								[
									-73.07304687499996,
									-53.875292968750024
								],
								[
									-73.085546875,
									-53.915917968750044
								],
								[
									-73.07084960937493,
									-53.97802734374999
								],
								[
									-73.08076171875001,
									-53.998046874999986
								],
								[
									-73.119970703125,
									-54.00937500000008
								],
								[
									-73.21064453125001,
									-53.985839843749986
								],
								[
									-73.30473632812499,
									-53.94394531250007
								],
								[
									-73.312158203125,
									-53.91962890625
								],
								[
									-73.29287109374997,
									-53.83583984374998
								],
								[
									-73.29492187500003,
									-53.79208984375004
								],
								[
									-73.31435546875,
									-53.72919921875002
								],
								[
									-73.32480468749998,
									-53.722656250000014
								],
								[
									-73.360107421875,
									-53.72402343750003
								],
								[
									-73.470947265625,
									-53.73613281250001
								],
								[
									-73.581640625,
									-53.655468750000004
								],
								[
									-73.64150390625002,
									-53.570312500000064
								],
								[
									-73.845458984375,
									-53.545800781250044
								],
								[
									-73.68652343749997,
									-53.42685546875006
								],
								[
									-73.44707031249993,
									-53.410058593750016
								],
								[
									-73.365869140625,
									-53.470214843750014
								],
								[
									-73.09936523437497,
									-53.51191406250007
								],
								[
									-73.11533203125003,
									-53.448046875000024
								],
								[
									-73.11088867187502,
									-53.42519531249999
								],
								[
									-73.07431640625003,
									-53.39677734375006
								],
								[
									-73.05361328125,
									-53.39443359375003
								],
								[
									-73.02207031249995,
									-53.41455078125004
								],
								[
									-72.97094726562503,
									-53.42304687500008
								],
								[
									-72.947265625,
									-53.44248046875005
								],
								[
									-72.9232421875,
									-53.48164062500003
								]
							]
						],
						[
							[
								[
									-74.38574218749994,
									-52.92236328125004
								],
								[
									-74.36933593749998,
									-52.93144531250003
								],
								[
									-74.32998046874997,
									-52.929296875000034
								],
								[
									-74.27460937499995,
									-52.945507812500054
								],
								[
									-74.06596679687499,
									-52.96533203125001
								],
								[
									-73.87919921874996,
									-53.01220703125005
								],
								[
									-73.78178710937502,
									-53.056054687500016
								],
								[
									-73.65400390625001,
									-53.069824218750064
								],
								[
									-73.54926757812498,
									-53.125683593750075
								],
								[
									-73.50454101562502,
									-53.14003906249998
								],
								[
									-73.45058593749994,
									-53.14433593750006
								],
								[
									-73.31035156249999,
									-53.247656250000055
								],
								[
									-73.30249023437497,
									-53.25947265625007
								],
								[
									-73.14335937499996,
									-53.34091796875005
								],
								[
									-73.13520507812501,
									-53.35390625000003
								],
								[
									-73.22573242187497,
									-53.35839843750006
								],
								[
									-73.40937499999998,
									-53.32050781250007
								],
								[
									-73.50102539062502,
									-53.318457031250006
								],
								[
									-73.56728515625,
									-53.30683593750003
								],
								[
									-73.58281249999996,
									-53.300195312500016
								],
								[
									-73.59594726562497,
									-53.252929687500064
								],
								[
									-73.61708984375002,
									-53.22968750000004
								],
								[
									-73.79350585937499,
									-53.12070312500004
								],
								[
									-73.86694335937494,
									-53.09687500000007
								],
								[
									-73.99399414062498,
									-53.075781250000034
								],
								[
									-74.13857421874997,
									-53.09052734375002
								],
								[
									-74.23637695312499,
									-53.07646484375009
								],
								[
									-74.27021484374995,
									-53.08154296875006
								],
								[
									-74.414404296875,
									-52.99492187500008
								],
								[
									-74.55830078124993,
									-52.921875000000036
								],
								[
									-74.61992187499996,
									-52.83476562500005
								],
								[
									-74.71152343749998,
									-52.76816406250007
								],
								[
									-74.71201171874998,
									-52.74873046875002
								],
								[
									-74.66997070312493,
									-52.733886718750014
								],
								[
									-74.57153320312497,
									-52.77128906250009
								],
								[
									-74.47456054687501,
									-52.835644531250054
								],
								[
									-74.42226562500002,
									-52.860058593750054
								],
								[
									-74.38574218749994,
									-52.92236328125004
								]
							]
						],
						[
							[
								[
									-68.62993164062499,
									-52.652636718750074
								],
								[
									-68.631689453125,
									-52.94951171875007
								],
								[
									-68.633447265625,
									-53.24189453125004
								],
								[
									-68.63505859374999,
									-53.515429687500074
								],
								[
									-68.63666992187495,
									-53.7888671875
								],
								[
									-68.63823242187499,
									-54.05292968750007
								],
								[
									-68.63979492187497,
									-54.32402343750005
								],
								[
									-68.64750976562493,
									-54.62783203125004
								],
								[
									-68.65322265624994,
									-54.85361328125003
								],
								[
									-68.803857421875,
									-54.85361328125003
								],
								[
									-68.84355468749999,
									-54.87675781250004
								],
								[
									-69.081640625,
									-54.90986328125003
								],
								[
									-69.48627929687493,
									-54.858886718750036
								],
								[
									-69.58754882812497,
									-54.81279296875006
								],
								[
									-69.72343750000002,
									-54.71210937500007
								],
								[
									-69.771826171875,
									-54.73916015624998
								],
								[
									-69.89946289062499,
									-54.78183593750006
								],
								[
									-70.03051757812497,
									-54.81552734375
								],
								[
									-70.13808593750002,
									-54.819238281250044
								],
								[
									-70.23779296875,
									-54.777539062500075
								],
								[
									-70.25908203124999,
									-54.75634765625002
								],
								[
									-70.28173828124997,
									-54.75175781250006
								],
								[
									-70.49716796875,
									-54.80957031250003
								],
								[
									-70.73515624999999,
									-54.7505859375
								],
								[
									-70.92470703124997,
									-54.71435546874999
								],
								[
									-71.22924804687503,
									-54.694140625000045
								],
								[
									-71.44091796874997,
									-54.61962890625006
								],
								[
									-71.83154296874997,
									-54.626171875000054
								],
								[
									-71.90156249999993,
									-54.601562500000014
								],
								[
									-71.92773437500003,
									-54.52871093750001
								],
								[
									-71.90698242187497,
									-54.49482421875003
								],
								[
									-71.82343750000001,
									-54.474414062500045
								],
								[
									-71.80014648437498,
									-54.43398437499998
								],
								[
									-71.71582031250003,
									-54.44365234375009
								],
								[
									-71.606298828125,
									-54.49716796875006
								],
								[
									-71.57275390625,
									-54.49531250000004
								],
								[
									-71.50039062500002,
									-54.44492187500008
								],
								[
									-71.39340820312498,
									-54.400195312500024
								],
								[
									-71.355224609375,
									-54.39541015625003
								],
								[
									-71.15883789062497,
									-54.45058593749999
								],
								[
									-71.07993164062498,
									-54.44423828125003
								],
								[
									-70.96645507812494,
									-54.419531250000055
								],
								[
									-70.94619140625,
									-54.398046875000034
								],
								[
									-70.92817382812495,
									-54.36005859375002
								],
								[
									-70.89824218749999,
									-54.337890625000036
								],
								[
									-70.79726562500002,
									-54.32724609375
								],
								[
									-70.69882812499995,
									-54.34882812500004
								],
								[
									-70.68754882812496,
									-54.41474609375006
								],
								[
									-70.70112304687498,
									-54.48544921875008
								],
								[
									-70.572998046875,
									-54.50439453125003
								],
								[
									-70.41791992187501,
									-54.50224609375003
								],
								[
									-70.31098632812498,
									-54.528515625000054
								],
								[
									-70.29765624999993,
									-54.485546875000004
								],
								[
									-70.46831054687499,
									-54.37324218750004
								],
								[
									-70.53999023437501,
									-54.303417968750026
								],
								[
									-70.63613281249997,
									-54.2623046875
								],
								[
									-70.75986328124995,
									-54.24130859375008
								],
								[
									-70.86308593749993,
									-54.11044921875006
								],
								[
									-70.85673828124999,
									-53.99580078125006
								],
								[
									-70.86772460937499,
									-53.88417968750006
								],
								[
									-70.64448242187498,
									-53.8228515625
								],
								[
									-70.69560546875002,
									-53.727441406250016
								],
								[
									-70.61874999999998,
									-53.65507812500002
								],
								[
									-70.53129882812502,
									-53.62734375000005
								],
								[
									-70.44316406250002,
									-53.893457031249994
								],
								[
									-70.37973632812498,
									-53.98671874999999
								],
								[
									-70.460546875,
									-54.00566406250003
								],
								[
									-70.62983398437493,
									-54.00556640625001
								],
								[
									-70.53530273437494,
									-54.13613281250005
								],
								[
									-70.37998046875,
									-54.180664062500064
								],
								[
									-70.24609375,
									-54.27744140625006
								],
								[
									-70.24335937499998,
									-54.34765625000007
								],
								[
									-70.16899414062502,
									-54.37929687500003
								],
								[
									-69.99013671875,
									-54.38134765625001
								],
								[
									-69.86699218749996,
									-54.367480468750024
								],
								[
									-69.80908203124997,
									-54.320800781250014
								],
								[
									-69.74184570312494,
									-54.30585937500008
								],
								[
									-69.62167968749998,
									-54.36406250000004
								],
								[
									-69.41928710937495,
									-54.407128906250016
								],
								[
									-69.36479492187496,
									-54.437597656250006
								],
								[
									-69.32509765624997,
									-54.48818359375001
								],
								[
									-69.32246093749995,
									-54.54267578125001
								],
								[
									-69.31206054687496,
									-54.57148437500002
								],
								[
									-69.25317382812497,
									-54.55742187500008
								],
								[
									-69.169189453125,
									-54.483300781249994
								],
								[
									-69.12788085937501,
									-54.4576171875
								],
								[
									-69.07724609375,
									-54.44501953125001
								],
								[
									-69.04521484374996,
									-54.428417968750004
								],
								[
									-69.04433593749997,
									-54.40673828125003
								],
								[
									-69.19565429687498,
									-54.35439453125002
								],
								[
									-69.98813476562503,
									-54.10908203125005
								],
								[
									-70.085595703125,
									-54.01113281249999
								],
								[
									-70.15112304687503,
									-53.88808593750006
								],
								[
									-70.148828125,
									-53.76113281250004
								],
								[
									-70.09111328124996,
									-53.72177734375001
								],
								[
									-69.94970703125003,
									-53.671582031250004
								],
								[
									-69.68974609374999,
									-53.600878906250074
								],
								[
									-69.38994140625002,
									-53.49941406250001
								],
								[
									-69.35244140625002,
									-53.47998046875005
								],
								[
									-69.35595703125003,
									-53.416308593750045
								],
								[
									-69.39355468749997,
									-53.373437500000016
								],
								[
									-69.51254882812495,
									-53.341992187500004
								],
								[
									-69.63701171874999,
									-53.33408203125008
								],
								[
									-69.755615234375,
									-53.33720703125
								],
								[
									-69.87412109374998,
									-53.350488281250044
								],
								[
									-70.09038085937499,
									-53.41816406250007
								],
								[
									-70.21284179687498,
									-53.41396484375001
								],
								[
									-70.32929687499998,
									-53.37763671875007
								],
								[
									-70.415673828125,
									-53.30478515625006
								],
								[
									-70.46025390624993,
									-53.20625000000006
								],
								[
									-70.45996093749997,
									-53.14335937500004
								],
								[
									-70.44335937499997,
									-53.08554687500007
								],
								[
									-70.39067382812496,
									-53.02646484375003
								],
								[
									-70.32001953124995,
									-53.00068359375001
								],
								[
									-70.25634765624997,
									-53.0041015625
								],
								[
									-70.19648437499993,
									-52.990234375000014
								],
								[
									-70.16088867187497,
									-52.969921875000054
								],
								[
									-70.13061523437503,
									-52.94277343750003
								],
								[
									-70.13955078124997,
									-52.91933593750005
								],
								[
									-70.162744140625,
									-52.8990234375
								],
								[
									-70.2591796875,
									-52.85722656250001
								],
								[
									-70.29736328124997,
									-52.81699218750007
								],
								[
									-70.38012695312494,
									-52.75195312500006
								],
								[
									-70.33491210937498,
									-52.733789062499994
								],
								[
									-70.18964843749995,
									-52.72363281250006
								],
								[
									-70.088232421875,
									-52.768554687500064
								],
								[
									-69.9935546875,
									-52.82128906250006
								],
								[
									-69.93544921874997,
									-52.82109375000002
								],
								[
									-69.88320312499997,
									-52.799023437500054
								],
								[
									-69.76357421875002,
									-52.73134765625003
								],
								[
									-69.66328124999993,
									-52.646289062500024
								],
								[
									-69.57187499999995,
									-52.54931640625007
								],
								[
									-69.498388671875,
									-52.49140625
								],
								[
									-69.41406249999997,
									-52.48623046875001
								],
								[
									-69.16704101562499,
									-52.667578125000006
								],
								[
									-69.079931640625,
									-52.67431640625005
								],
								[
									-68.78979492187497,
									-52.57675781250007
								],
								[
									-68.75751953124995,
									-52.582031249999986
								],
								[
									-68.65922851562502,
									-52.63154296875004
								],
								[
									-68.62993164062499,
									-52.652636718750074
								]
							]
						],
						[
							[
								[
									-74.14218749999998,
									-51.93105468750006
								],
								[
									-74.17207031249993,
									-51.94208984375
								],
								[
									-74.28310546875,
									-51.91875000000004
								],
								[
									-74.33867187499996,
									-51.897949218750064
								],
								[
									-74.42363281249993,
									-51.84511718750005
								],
								[
									-74.43710937500003,
									-51.79062500000005
								],
								[
									-74.47539062500002,
									-51.725683593750055
								],
								[
									-74.45078124999998,
									-51.724902343750074
								],
								[
									-74.36210937500002,
									-51.75068359375008
								],
								[
									-74.32568359374997,
									-51.77021484375007
								],
								[
									-74.27705078125001,
									-51.81162109375006
								],
								[
									-74.13339843749998,
									-51.87089843750006
								],
								[
									-74.11542968749995,
									-51.88847656250009
								],
								[
									-74.11889648437503,
									-51.9111328125
								],
								[
									-74.14218749999998,
									-51.93105468750006
								]
							]
						],
						[
							[
								[
									-74.82294921874993,
									-51.630175781250045
								],
								[
									-74.780126953125,
									-51.824707031250064
								],
								[
									-74.74951171874997,
									-51.85185546875009
								],
								[
									-74.64746093749997,
									-51.86621093749999
								],
								[
									-74.53681640624998,
									-51.965136718750074
								],
								[
									-74.53183593749995,
									-51.99199218750004
								],
								[
									-74.66596679687501,
									-52.160058593749994
								],
								[
									-74.69448242187497,
									-52.27919921875002
								],
								[
									-74.85180664062494,
									-52.27070312500007
								],
								[
									-74.91772460937497,
									-52.15224609375
								],
								[
									-75.01713867187496,
									-52.03789062500007
								],
								[
									-75.05068359374997,
									-51.903906250000034
								],
								[
									-75.10537109375,
									-51.788867187500045
								],
								[
									-75.00810546874999,
									-51.72373046875001
								],
								[
									-74.915185546875,
									-51.73828125000004
								],
								[
									-74.90966796875003,
									-51.65
								],
								[
									-74.82294921874993,
									-51.630175781250045
								]
							]
						],
						[
							[
								[
									-74.55864257812499,
									-51.27705078125005
								],
								[
									-74.560888671875,
									-51.360839843750064
								],
								[
									-74.59257812499999,
									-51.38750000000008
								],
								[
									-74.62036132812497,
									-51.39570312500006
								],
								[
									-74.69072265624999,
									-51.37021484375002
								],
								[
									-74.73090820312501,
									-51.36738281250007
								],
								[
									-74.79736328124997,
									-51.41171875000004
								],
								[
									-74.85332031249999,
									-51.4341796875
								],
								[
									-74.93666992187502,
									-51.42832031250005
								],
								[
									-75.04736328125,
									-51.398339843750065
								],
								[
									-75.14628906249999,
									-51.524316406250065
								],
								[
									-75.19243164062499,
									-51.56669921875008
								],
								[
									-75.28911132812496,
									-51.62539062500005
								],
								[
									-75.30004882812497,
									-51.55644531250004
								],
								[
									-75.23847656249995,
									-51.45351562500003
								],
								[
									-75.21000976562502,
									-51.38330078125002
								],
								[
									-75.15366210937498,
									-51.27880859375005
								],
								[
									-75.04033203124999,
									-51.318164062500074
								],
								[
									-74.88144531250003,
									-51.27949218750001
								],
								[
									-74.73666992187503,
									-51.20761718750003
								],
								[
									-74.61157226562494,
									-51.20712890625001
								],
								[
									-74.57050781249993,
									-51.24541015625009
								],
								[
									-74.55864257812499,
									-51.27705078125005
								]
							]
						],
						[
							[
								[
									-75.302001953125,
									-50.67998046875009
								],
								[
									-75.33046874999994,
									-50.772363281249994
								],
								[
									-75.411376953125,
									-50.76435546875005
								],
								[
									-75.43852539062502,
									-50.74111328125002
								],
								[
									-75.45263671874997,
									-50.68251953124999
								],
								[
									-75.47739257812503,
									-50.65419921874999
								],
								[
									-75.44267578124999,
									-50.595507812500024
								],
								[
									-75.41977539062503,
									-50.53037109375008
								],
								[
									-75.42763671875002,
									-50.480566406250055
								],
								[
									-75.3037109375,
									-50.48398437500004
								],
								[
									-75.15615234374997,
									-50.49677734375007
								],
								[
									-75.11533203125,
									-50.51044921875001
								],
								[
									-75.16044921874996,
									-50.55439453125008
								],
								[
									-75.20341796874999,
									-50.58066406250002
								],
								[
									-75.292333984375,
									-50.59687500000003
								],
								[
									-75.302001953125,
									-50.67998046875009
								]
							]
						],
						[
							[
								[
									-75.05478515625,
									-50.29609375000004
								],
								[
									-75.25039062499997,
									-50.37626953125003
								],
								[
									-75.30786132812497,
									-50.34306640625002
								],
								[
									-75.44912109374997,
									-50.34335937500008
								],
								[
									-75.41210937499997,
									-50.25664062500009
								],
								[
									-75.3978515625,
									-50.192675781250024
								],
								[
									-75.37670898437494,
									-50.16796875000005
								],
								[
									-75.36884765624995,
									-50.11269531249998
								],
								[
									-75.32666015624997,
									-50.011816406250034
								],
								[
									-75.20966796874993,
									-50.04541015625004
								],
								[
									-75.12255859374994,
									-50.055273437500006
								],
								[
									-75.004248046875,
									-50.08867187500006
								],
								[
									-74.8759765625,
									-50.10996093750005
								],
								[
									-74.83857421875001,
									-50.19726562500007
								],
								[
									-74.96337890625003,
									-50.23730468750006
								],
								[
									-75.05478515625,
									-50.29609375000004
								]
							]
						],
						[
							[
								[
									-75.106689453125,
									-48.83652343750005
								],
								[
									-75.11508789062503,
									-48.91601562499999
								],
								[
									-75.2626953125,
									-49.06894531250006
								],
								[
									-75.38994140624999,
									-49.15917968750006
								],
								[
									-75.50610351562503,
									-49.230664062500054
								],
								[
									-75.58037109374996,
									-49.22998046875001
								],
								[
									-75.64116210937502,
									-49.19541015625007
								],
								[
									-75.57285156250003,
									-49.138867187500004
								],
								[
									-75.487646484375,
									-49.08242187500005
								],
								[
									-75.51455078124997,
									-49.009570312500045
								],
								[
									-75.54013671875003,
									-48.98847656250001
								],
								[
									-75.576171875,
									-48.98076171875004
								],
								[
									-75.63784179687494,
									-48.942578125000075
								],
								[
									-75.61914062499997,
									-48.88593750000008
								],
								[
									-75.58310546874998,
									-48.858886718749986
								],
								[
									-75.53525390625,
									-48.83818359375003
								],
								[
									-75.49047851562494,
									-48.85048828125005
								],
								[
									-75.29726562500002,
									-48.81064453125002
								],
								[
									-75.236181640625,
									-48.77861328125007
								],
								[
									-75.11860351562495,
									-48.772949218750064
								],
								[
									-75.106689453125,
									-48.83652343750005
								]
							]
						],
						[
							[
								[
									-74.47617187499998,
									-49.14785156250006
								],
								[
									-74.46679687500003,
									-49.29453125000001
								],
								[
									-74.48359374999998,
									-49.441894531250014
								],
								[
									-74.5220703125,
									-49.62294921875004
								],
								[
									-74.51577148437497,
									-49.65957031250004
								],
								[
									-74.47084960937497,
									-49.668554687500006
								],
								[
									-74.458837890625,
									-49.69111328125007
								],
								[
									-74.47197265625002,
									-49.78623046875
								],
								[
									-74.49609374999997,
									-49.85947265625
								],
								[
									-74.542578125,
									-49.919140625000075
								],
								[
									-74.56982421874997,
									-49.99072265625
								],
								[
									-74.59472656249997,
									-50.006640625000045
								],
								[
									-74.703369140625,
									-50.01923828125004
								],
								[
									-74.76298828124999,
									-50.01142578125005
								],
								[
									-74.81083984374996,
									-49.9296875
								],
								[
									-74.82470703125003,
									-49.87949218750008
								],
								[
									-74.821923828125,
									-49.81386718750003
								],
								[
									-74.88041992187502,
									-49.725878906250045
								],
								[
									-74.88222656250002,
									-49.692187500000024
								],
								[
									-74.85932617187498,
									-49.634179687500016
								],
								[
									-74.81201171875003,
									-49.60527343750008
								],
								[
									-74.80483398437497,
									-49.516015625000016
								],
								[
									-74.781005859375,
									-49.48925781250007
								],
								[
									-74.72705078125003,
									-49.45234375000001
								],
								[
									-74.71884765624995,
									-49.43701171874999
								],
								[
									-74.72382812499998,
									-49.423828125000064
								],
								[
									-74.74384765624998,
									-49.42246093750005
								],
								[
									-74.960107421875,
									-49.53300781250001
								],
								[
									-74.98129882812495,
									-49.564160156250054
								],
								[
									-74.99082031250003,
									-49.60566406250007
								],
								[
									-74.99350585937495,
									-49.75175781250008
								],
								[
									-75.03154296874999,
									-49.83623046875006
								],
								[
									-75.06601562499998,
									-49.85234375000005
								],
								[
									-75.16694335937493,
									-49.85595703124999
								],
								[
									-75.30009765624999,
									-49.84746093750004
								],
								[
									-75.45117187500003,
									-49.76992187500005
								],
								[
									-75.54980468749994,
									-49.79130859375005
								],
								[
									-75.57011718750002,
									-49.69707031250004
								],
								[
									-75.520751953125,
									-49.62167968750005
								],
								[
									-75.33706054687497,
									-49.628222656250045
								],
								[
									-75.30585937499998,
									-49.494042968750065
								],
								[
									-75.36420898437498,
									-49.462500000000034
								],
								[
									-75.428857421875,
									-49.408398437500026
								],
								[
									-75.46748046874998,
									-49.358886718750064
								],
								[
									-75.43315429687499,
									-49.322070312500024
								],
								[
									-75.32666015624997,
									-49.26865234375007
								],
								[
									-75.26962890624998,
									-49.26289062500005
								],
								[
									-75.21684570312499,
									-49.29277343750001
								],
								[
									-75.08603515624998,
									-49.27021484375003
								],
								[
									-75.09370117187493,
									-49.18535156250006
								],
								[
									-75.21015624999995,
									-49.14804687500001
								],
								[
									-75.184228515625,
									-49.08359375000003
								],
								[
									-75.03710937499994,
									-49.02207031250001
								],
								[
									-74.94921875,
									-48.96015625000001
								],
								[
									-74.94521484374997,
									-48.88945312500009
								],
								[
									-74.98076171875002,
									-48.81884765625
								],
								[
									-74.96953124999996,
									-48.791308593750074
								],
								[
									-74.89624023437503,
									-48.73320312500005
								],
								[
									-74.79345703124997,
									-48.70507812500001
								],
								[
									-74.74667968750003,
									-48.70888671874998
								],
								[
									-74.65156250000001,
									-48.74990234374999
								],
								[
									-74.56660156249993,
									-48.75478515625001
								],
								[
									-74.54609374999993,
									-48.766894531250074
								],
								[
									-74.5306640625,
									-48.81259765625006
								],
								[
									-74.47617187499998,
									-49.14785156250006
								]
							]
						],
						[
							[
								[
									-75.51025390624997,
									-48.76347656250009
								],
								[
									-75.62285156250002,
									-48.764648437500064
								],
								[
									-75.65092773437496,
									-48.58632812500006
								],
								[
									-75.51845703124997,
									-48.32880859375
								],
								[
									-75.509033203125,
									-48.23066406250008
								],
								[
									-75.55351562499999,
									-48.15673828124994
								],
								[
									-75.57148437499993,
									-48.09589843749998
								],
								[
									-75.56069335937497,
									-48.070898437500034
								],
								[
									-75.39140625000002,
									-48.0197265625
								],
								[
									-75.33837890624997,
									-48.074023437500045
								],
								[
									-75.27548828125003,
									-48.21845703125008
								],
								[
									-75.155517578125,
									-48.42519531249992
								],
								[
									-75.15849609374999,
									-48.62265625
								],
								[
									-75.22509765624997,
									-48.67138671875007
								],
								[
									-75.433984375,
									-48.72119140625
								],
								[
									-75.51025390624997,
									-48.76347656250009
								]
							]
						],
						[
							[
								[
									-74.56728515625,
									-48.59199218750006
								],
								[
									-74.58627929687503,
									-48.61572265625001
								],
								[
									-74.7095703125,
									-48.60117187500006
								],
								[
									-74.92304687499998,
									-48.626464843750064
								],
								[
									-75.012841796875,
									-48.53574218750006
								],
								[
									-75.0521484375,
									-48.391406250000045
								],
								[
									-75.07890624999993,
									-48.3615234375
								],
								[
									-75.13193359375,
									-48.27929687500004
								],
								[
									-75.15849609374999,
									-48.225292968750054
								],
								[
									-75.21289062499997,
									-48.14169921875008
								],
								[
									-75.23388671875,
									-48.053417968750026
								],
								[
									-75.24726562499995,
									-48.02675781250001
								],
								[
									-75.19829101562502,
									-47.97460937500004
								],
								[
									-74.97509765625003,
									-47.92285156250007
								],
								[
									-74.895654296875,
									-47.83935546874994
								],
								[
									-74.82744140624996,
									-47.85039062500006
								],
								[
									-74.84619140624997,
									-48.02080078124996
								],
								[
									-74.80522460937496,
									-48.078222656249935
								],
								[
									-74.72929687499996,
									-48.12587890625005
								],
								[
									-74.71523437500002,
									-48.14550781250004
								],
								[
									-74.70239257812497,
									-48.205859375
								],
								[
									-74.66435546874996,
									-48.29931640625003
								],
								[
									-74.61513671874997,
									-48.34306640625006
								],
								[
									-74.60244140624997,
									-48.37031250000001
								],
								[
									-74.60014648437502,
									-48.39306640625003
								],
								[
									-74.61821289062496,
									-48.42519531249992
								],
								[
									-74.56728515625,
									-48.59199218750006
								]
							]
						],
						[
							[
								[
									-75.11220703124997,
									-47.83769531249996
								],
								[
									-75.18583984374996,
									-47.85068359375002
								],
								[
									-75.1943359375,
									-47.81806640625004
								],
								[
									-75.26103515625002,
									-47.76386718750001
								],
								[
									-75.20312500000003,
									-47.72802734375
								],
								[
									-75.08984374999994,
									-47.69062500000001
								],
								[
									-75.00395507812496,
									-47.694726562499966
								],
								[
									-74.92646484374998,
									-47.72314453125007
								],
								[
									-74.91601562499997,
									-47.756640625000045
								],
								[
									-75.05126953125,
									-47.80048828125001
								],
								[
									-75.08447265625,
									-47.82451171875002
								],
								[
									-75.11220703124997,
									-47.83769531249996
								]
							]
						],
						[
							[
								[
									-74.31289062500002,
									-45.69150390625006
								],
								[
									-74.36845703124999,
									-45.73583984375003
								],
								[
									-74.46552734374995,
									-45.75722656249995
								],
								[
									-74.56162109374998,
									-45.722460937499974
								],
								[
									-74.67773437500003,
									-45.73857421875006
								],
								[
									-74.68984375,
									-45.66259765625003
								],
								[
									-74.64643554687495,
									-45.600000000000065
								],
								[
									-74.55839843749996,
									-45.52558593750001
								],
								[
									-74.49467773437493,
									-45.42587890624995
								],
								[
									-74.50234375,
									-45.28515625000006
								],
								[
									-74.44999999999999,
									-45.25292968750006
								],
								[
									-74.42187500000003,
									-45.20322265625006
								],
								[
									-74.310546875,
									-45.172656250000045
								],
								[
									-74.28540039062503,
									-45.27724609375004
								],
								[
									-74.3154296875,
									-45.46406250000008
								],
								[
									-74.24003906250002,
									-45.57451171875003
								],
								[
									-74.22919921874995,
									-45.61132812500007
								],
								[
									-74.243896484375,
									-45.65361328125006
								],
								[
									-74.31289062500002,
									-45.69150390625006
								]
							]
						],
						[
							[
								[
									-75.04248046874997,
									-44.89013671875004
								],
								[
									-75.06748046875,
									-44.90654296875002
								],
								[
									-75.09873046874998,
									-44.90175781250001
								],
								[
									-75.12421874999993,
									-44.86992187500002
								],
								[
									-75.14213867187496,
									-44.81562499999997
								],
								[
									-75.10742187499997,
									-44.795117187500054
								],
								[
									-75.07949218749997,
									-44.795117187500054
								],
								[
									-75.04843749999995,
									-44.823925781250054
								],
								[
									-75.03222656250003,
									-44.87050781250004
								],
								[
									-75.04248046874997,
									-44.89013671875004
								]
							]
						],
						[
							[
								[
									-73.632177734375,
									-44.821484375
								],
								[
									-73.66484374999999,
									-44.83291015624994
								],
								[
									-73.694580078125,
									-44.831152343749935
								],
								[
									-73.72475585937502,
									-44.79687500000006
								],
								[
									-73.73486328124994,
									-44.75166015625008
								],
								[
									-73.800146484375,
									-44.684082031249986
								],
								[
									-73.81845703125,
									-44.65214843750006
								],
								[
									-73.81699218749998,
									-44.61396484375
								],
								[
									-73.77949218749998,
									-44.55917968749995
								],
								[
									-73.72392578124993,
									-44.54423828125
								],
								[
									-73.68647460937495,
									-44.54628906249998
								],
								[
									-73.64121093749998,
									-44.610839843749986
								],
								[
									-73.62822265624999,
									-44.68076171875002
								],
								[
									-73.61660156250002,
									-44.752929687499986
								],
								[
									-73.632177734375,
									-44.821484375
								]
							]
						],
						[
							[
								[
									-72.98613281250002,
									-44.780078125
								],
								[
									-73.22846679687498,
									-44.85996093750002
								],
								[
									-73.34999999999997,
									-44.833203125
								],
								[
									-73.39707031249998,
									-44.77431640624998
								],
								[
									-73.42006835937494,
									-44.72480468749994
								],
								[
									-73.44506835937497,
									-44.64101562499992
								],
								[
									-73.40366210937498,
									-44.59609375000001
								],
								[
									-73.31494140625003,
									-44.53134765624996
								],
								[
									-73.28198242187497,
									-44.489550781249974
								],
								[
									-73.266015625,
									-44.440234375000045
								],
								[
									-73.27158203124998,
									-44.39414062500008
								],
								[
									-73.26000976562503,
									-44.350292968750026
								],
								[
									-73.20771484374993,
									-44.3349609375
								],
								[
									-73.02841796875,
									-44.38408203125006
								],
								[
									-72.84243164062494,
									-44.457714843750054
								],
								[
									-72.7763671875,
									-44.508593749999946
								],
								[
									-72.76406249999997,
									-44.54902343750001
								],
								[
									-72.8453125,
									-44.63847656250002
								],
								[
									-72.89716796875001,
									-44.71201171874999
								],
								[
									-72.98613281250002,
									-44.780078125
								]
							]
						],
						[
							[
								[
									-73.73535156249997,
									-44.39453125000006
								],
								[
									-73.78457031249997,
									-44.43750000000003
								],
								[
									-73.86230468749997,
									-44.44511718750006
								],
								[
									-73.98330078125002,
									-44.49482421874998
								],
								[
									-73.99604492187495,
									-44.537988281250065
								],
								[
									-74.00205078125003,
									-44.59091796875002
								],
								[
									-73.91855468749998,
									-44.65468750000004
								],
								[
									-73.87739257812495,
									-44.728808593750045
								],
								[
									-73.82788085937497,
									-44.83984374999993
								],
								[
									-73.792138671875,
									-44.945800781250014
								],
								[
									-73.79536132812493,
									-44.978613281250034
								],
								[
									-73.78647460937498,
									-45.033593749999966
								],
								[
									-73.72714843749998,
									-45.119042968749966
								],
								[
									-73.72167968750003,
									-45.15761718750001
								],
								[
									-73.72817382812502,
									-45.19589843749999
								],
								[
									-73.752099609375,
									-45.26679687500004
								],
								[
									-73.77099609375003,
									-45.27656250000008
								],
								[
									-73.82988281249996,
									-45.283496093750074
								],
								[
									-73.83447265625,
									-45.326562499999966
								],
								[
									-73.848974609375,
									-45.34062499999999
								],
								[
									-74.016259765625,
									-45.344921875000054
								],
								[
									-74.09907226562498,
									-45.32539062500008
								],
								[
									-74.08925781249994,
									-45.19570312499995
								],
								[
									-74.19521484374994,
									-45.14482421875006
								],
								[
									-74.26796875000002,
									-45.05898437499998
								],
								[
									-74.34990234375002,
									-44.91083984375
								],
								[
									-74.41875000000002,
									-44.86523437500003
								],
								[
									-74.49882812499999,
									-44.74814453125008
								],
								[
									-74.61777343749998,
									-44.647949218749915
								],
								[
									-74.48051757812499,
									-44.58457031250005
								],
								[
									-74.50180664062498,
									-44.47353515624991
								],
								[
									-74.42167968749999,
									-44.435449218749966
								],
								[
									-74.30122070312495,
									-44.39570312500004
								],
								[
									-74.2125,
									-44.42695312500001
								],
								[
									-74.13281250000003,
									-44.415917968750065
								],
								[
									-74.09721679687496,
									-44.38935546875007
								],
								[
									-74.10810546874995,
									-44.27587890625004
								],
								[
									-74.08281249999996,
									-44.18642578125004
								],
								[
									-73.99492187499999,
									-44.140234375000034
								],
								[
									-73.90019531249996,
									-44.134863281250006
								],
								[
									-73.86455078124999,
									-44.185351562500074
								],
								[
									-73.81777343749997,
									-44.23496093749998
								],
								[
									-73.70322265624998,
									-44.27412109375004
								],
								[
									-73.7037109375,
									-44.325390624999926
								],
								[
									-73.73535156249997,
									-44.39453125000006
								]
							]
						],
						[
							[
								[
									-73.81064453125003,
									-43.82724609375005
								],
								[
									-73.7896484375,
									-43.87646484375003
								],
								[
									-73.833642578125,
									-43.88320312499998
								],
								[
									-73.90415039062498,
									-43.87539062499991
								],
								[
									-73.93828125000002,
									-43.91425781250001
								],
								[
									-73.9556640625,
									-43.92197265625006
								],
								[
									-74.11777343749998,
									-43.88750000000006
								],
								[
									-74.14296874999997,
									-43.87216796874996
								],
								[
									-74.13994140624996,
									-43.82099609375001
								],
								[
									-73.96718749999994,
									-43.81650390624999
								],
								[
									-73.85693359374994,
									-43.78378906250008
								],
								[
									-73.84140624999998,
									-43.788964843750065
								],
								[
									-73.81064453125003,
									-43.82724609375005
								]
							]
						],
						[
							[
								[
									-74.66874999999996,
									-43.60781250000001
								],
								[
									-74.81044921874997,
									-43.62539062500004
								],
								[
									-74.84267578124997,
									-43.59550781250009
								],
								[
									-74.84199218749998,
									-43.57031249999993
								],
								[
									-74.81767578125002,
									-43.549414062499935
								],
								[
									-74.74501953124997,
									-43.53593750000003
								],
								[
									-74.69746093749995,
									-43.55302734374996
								],
								[
									-74.67265624999996,
									-43.57744140624996
								],
								[
									-74.66479492187494,
									-43.59960937500003
								],
								[
									-74.66874999999996,
									-43.60781250000001
								]
							]
						],
						[
							[
								[
									-73.77338867187498,
									-43.34589843750004
								],
								[
									-73.84858398437493,
									-43.366796875000034
								],
								[
									-73.918701171875,
									-43.37197265625002
								],
								[
									-73.98994140624995,
									-43.356640625
								],
								[
									-74.114404296875,
									-43.35791015625
								],
								[
									-74.23857421874999,
									-43.31884765625003
								],
								[
									-74.35493164062498,
									-43.263574218749966
								],
								[
									-74.38735351562502,
									-43.231640625000026
								],
								[
									-74.37314453124995,
									-43.1857421875
								],
								[
									-74.28935546874993,
									-43.07949218750002
								],
								[
									-74.20947265625,
									-42.878710937500074
								],
								[
									-74.15629882812502,
									-42.59052734374998
								],
								[
									-74.19882812499998,
									-42.48134765625002
								],
								[
									-74.19355468749995,
									-42.43603515625003
								],
								[
									-74.174072265625,
									-42.38154296875004
								],
								[
									-74.16435546874996,
									-42.32548828124999
								],
								[
									-74.17031250000002,
									-42.26894531250001
								],
								[
									-74.16020507812502,
									-42.21640625000005
								],
								[
									-74.07231445312496,
									-42.10585937500001
								],
								[
									-74.05937499999999,
									-42.05625000000002
								],
								[
									-74.05683593750001,
									-42.00234375000005
								],
								[
									-74.01879882812497,
									-41.89091796875009
								],
								[
									-74.03051757812497,
									-41.85400390625003
								],
								[
									-74.06303710937502,
									-41.82275390625006
								],
								[
									-74.03666992187499,
									-41.79550781250002
								],
								[
									-73.73095703124994,
									-41.877246093749974
								],
								[
									-73.52783203124997,
									-41.896289062499946
								],
								[
									-73.51694335937498,
									-41.98085937500002
								],
								[
									-73.47778320312497,
									-42.04716796875003
								],
								[
									-73.45449218749994,
									-42.16591796874998
								],
								[
									-73.42290039062499,
									-42.19287109374997
								],
								[
									-73.43925781249996,
									-42.27783203125004
								],
								[
									-73.5328125,
									-42.31445312500004
								],
								[
									-73.524560546875,
									-42.39257812500006
								],
								[
									-73.47080078124998,
									-42.46630859375007
								],
								[
									-73.54926757812498,
									-42.49257812499992
								],
								[
									-73.63388671874998,
									-42.50820312499991
								],
								[
									-73.65346679687497,
									-42.528710937499994
								],
								[
									-73.71474609375002,
									-42.54472656250006
								],
								[
									-73.78925781249993,
									-42.585742187500074
								],
								[
									-73.76684570312497,
									-42.621874999999974
								],
								[
									-73.67304687499998,
									-42.70439453125009
								],
								[
									-73.56826171875002,
									-42.76162109375002
								],
								[
									-73.51074218750003,
									-42.84716796875004
								],
								[
									-73.43632812499996,
									-42.93652343750003
								],
								[
									-73.47265625,
									-42.99326171874996
								],
								[
									-73.54082031249993,
									-43.073730468750014
								],
								[
									-73.64960937499998,
									-43.127148437500054
								],
								[
									-73.74965820312494,
									-43.159082031249994
								],
								[
									-73.73789062500003,
									-43.29140624999995
								],
								[
									-73.77338867187498,
									-43.34589843750004
								]
							]
						],
						[
							[
								[
									-78.80415039062501,
									-33.64648437500003
								],
								[
									-78.98334960937493,
									-33.6677734375
								],
								[
									-78.98945312499993,
									-33.661718749999935
								],
								[
									-78.97929687499999,
									-33.64414062500008
								],
								[
									-78.93813476562497,
									-33.613574218750074
								],
								[
									-78.88828125,
									-33.576367187499955
								],
								[
									-78.87744140625003,
									-33.57519531250007
								],
								[
									-78.859033203125,
									-33.57812499999996
								],
								[
									-78.83818359375002,
									-33.58505859374995
								],
								[
									-78.78466796874994,
									-33.61015624999999
								],
								[
									-78.76894531249994,
									-33.62734375000004
								],
								[
									-78.77470703124996,
									-33.6416015625
								],
								[
									-78.80415039062501,
									-33.64648437500003
								]
							]
						],
						[
							[
								[
									-109.27998046874995,
									-27.14042968749999
								],
								[
									-109.434130859375,
									-27.17128906249998
								],
								[
									-109.42915039062497,
									-27.11621093750003
								],
								[
									-109.39047851562499,
									-27.06835937499997
								],
								[
									-109.27646484374995,
									-27.095898437500068
								],
								[
									-109.22285156249994,
									-27.101074218750057
								],
								[
									-109.27998046874995,
									-27.14042968749999
								]
							]
						],
						[
							[
								[
									-67.19487304687493,
									-22.821679687500065
								],
								[
									-67.00878906249994,
									-23.00136718750008
								],
								[
									-67.08974609375002,
									-23.2451171875
								],
								[
									-67.219140625,
									-23.633984374999997
								],
								[
									-67.31914062499993,
									-23.934667968749977
								],
								[
									-67.335595703125,
									-23.974804687499983
								],
								[
									-67.35620117187503,
									-24.03378906249992
								],
								[
									-67.57177734374997,
									-24.11894531250003
								],
								[
									-67.88623046875,
									-24.243359374999983
								],
								[
									-68.04736328124997,
									-24.308300781250068
								],
								[
									-68.25029296875002,
									-24.391992187500065
								],
								[
									-68.29951171875001,
									-24.460351562500037
								],
								[
									-68.35810546874995,
									-24.49726562500001
								],
								[
									-68.42255859374993,
									-24.545117187499997
								],
								[
									-68.44711914062498,
									-24.596972656250074
								],
								[
									-68.50727539062495,
									-24.62978515625001
								],
								[
									-68.56201171875003,
									-24.74736328124999
								],
								[
									-68.56201171875003,
									-24.837695312499918
								],
								[
									-68.52705078125001,
									-24.899218750000017
								],
								[
									-68.46630859374997,
									-24.92519531249998
								],
								[
									-68.44711914062498,
									-24.99892578125008
								],
								[
									-68.42802734374999,
									-25.050976562500026
								],
								[
									-68.38422851562495,
									-25.091894531250006
								],
								[
									-68.39521484374995,
									-25.124707031250026
								],
								[
									-68.43071289062499,
									-25.149316406250065
								],
								[
									-68.49633789062497,
									-25.16298828125001
								],
								[
									-68.54082031249996,
									-25.236718750000023
								],
								[
									-68.59208984375002,
									-25.420019531250063
								],
								[
									-68.60029296875001,
									-25.485644531250017
								],
								[
									-68.54189453125,
									-25.651562500000068
								],
								[
									-68.51083984374998,
									-25.741015624999918
								],
								[
									-68.4267578125,
									-26.06542968749993
								],
								[
									-68.41450195312498,
									-26.15371093750005
								],
								[
									-68.52983398437493,
									-26.276953125000034
								],
								[
									-68.57578124999998,
									-26.351953125000037
								],
								[
									-68.59218749999994,
									-26.418066406250006
								],
								[
									-68.59160156250002,
									-26.47041015625001
								],
								[
									-68.58115234375,
									-26.518359375000003
								],
								[
									-68.48510742187497,
									-26.67031250000005
								],
								[
									-68.37333984374996,
									-26.806445312500074
								],
								[
									-68.31865234374999,
									-26.87753906249999
								],
								[
									-68.31865234374999,
									-26.973242187500034
								],
								[
									-68.34599609374996,
									-27.027929687500077
								],
								[
									-68.40537109374998,
									-27.048144531250017
								],
								[
									-68.53735351562497,
									-27.08535156250005
								],
								[
									-68.59208984375002,
									-27.14003906250001
								],
								[
									-68.652197265625,
									-27.148339843749923
								],
								[
									-68.70961914062497,
									-27.104492187500043
								],
								[
									-68.76977539062497,
									-27.11542968749997
								],
								[
									-68.84633789062494,
									-27.15371093749995
								],
								[
									-68.87509765625003,
									-27.246679687500063
								],
								[
									-68.94199218749998,
									-27.405175781250023
								],
								[
									-68.99941406249997,
									-27.449023437500074
								],
								[
									-69.04218749999995,
									-27.570019531250026
								],
								[
									-69.11850585937498,
									-27.743554687500037
								],
								[
									-69.1552734375,
									-27.84814453125003
								],
								[
									-69.17441406249998,
									-27.924707031249994
								],
								[
									-69.251220703125,
									-27.973632812500014
								],
								[
									-69.34072265624994,
									-28.070800781249915
								],
								[
									-69.40957031250002,
									-28.16533203124999
								],
								[
									-69.4369140625,
									-28.192675781250045
								],
								[
									-69.4888671875,
									-28.200878906250026
								],
								[
									-69.52714843749999,
									-28.285644531249986
								],
								[
									-69.65693359374998,
									-28.413574218750014
								],
								[
									-69.68789062499997,
									-28.562011718750057
								],
								[
									-69.73491210937496,
									-28.64111328124993
								],
								[
									-69.74316406249994,
									-28.783886718750054
								],
								[
									-69.81484375,
									-29.045507812500063
								],
								[
									-69.82788085937497,
									-29.103222656249926
								],
								[
									-69.90034179687501,
									-29.14882812499998
								],
								[
									-69.99560546874994,
									-29.249999999999986
								],
								[
									-70.02680664062501,
									-29.324023437500045
								],
								[
									-69.98261718749998,
									-29.54541015625003
								],
								[
									-69.92763671874997,
									-29.76914062500005
								],
								[
									-69.92412109374996,
									-29.87402343749993
								],
								[
									-69.94545898437497,
									-30.01640625000006
								],
								[
									-69.95996093749997,
									-30.078320312499983
								],
								[
									-69.92353515625001,
									-30.103906250000037
								],
								[
									-69.86337890625,
									-30.12031250000001
								],
								[
									-69.84428710937496,
									-30.17500000000004
								],
								[
									-69.88803710937498,
									-30.213281250000023
								],
								[
									-69.90712890624997,
									-30.28164062500001
								],
								[
									-69.95634765624996,
									-30.35820312500006
								],
								[
									-70.10200195312495,
									-30.388281250000063
								],
								[
									-70.15322265625,
									-30.360937500000006
								],
								[
									-70.16962890624998,
									-30.385546875000045
								],
								[
									-70.16142578124999,
									-30.44023437499999
								],
								[
									-70.19394531250003,
									-30.50468750000006
								],
								[
									-70.26938476562495,
									-30.677246093750043
								],
								[
									-70.31923828125,
									-30.833984375
								],
								[
									-70.34814453125,
									-30.902343749999986
								],
								[
									-70.33642578125003,
									-30.959765625000045
								],
								[
									-70.31181640624999,
									-30.99257812500008
								],
								[
									-70.30908203124997,
									-31.022656250000068
								],
								[
									-70.35058593749997,
									-31.06044921875005
								],
								[
									-70.38837890624995,
									-31.12109374999997
								],
								[
									-70.42939453124995,
									-31.129296875000037
								],
								[
									-70.47309570312498,
									-31.112792968750057
								],
								[
									-70.51958007812493,
									-31.14843750000003
								],
								[
									-70.529052734375,
									-31.222851562499997
								],
								[
									-70.5546875,
									-31.317382812499986
								],
								[
									-70.56640624999997,
									-31.427929687499955
								],
								[
									-70.585205078125,
									-31.569433593750006
								],
								[
									-70.52563476562503,
									-31.666406250000037
								],
								[
									-70.45014648437501,
									-31.84189453124999
								],
								[
									-70.39384765624999,
									-31.8837890625
								],
								[
									-70.33095703124997,
									-31.881054687500068
								],
								[
									-70.28173828124997,
									-31.916601562500034
								],
								[
									-70.25439453125,
									-31.957714843750054
								],
								[
									-70.29091796875,
									-32.031054687500074
								],
								[
									-70.35556640625,
									-32.04238281250008
								],
								[
									-70.36376953125,
									-32.08349609374993
								],
								[
									-70.34462890625,
									-32.17646484375004
								],
								[
									-70.32001953124995,
									-32.26669921874995
								],
								[
									-70.2578125,
									-32.30996093750005
								],
								[
									-70.22978515624996,
									-32.43066406249996
								],
								[
									-70.16962890624998,
									-32.47167968750004
								],
								[
									-70.17695312499995,
									-32.62607421874998
								],
								[
									-70.11616210937501,
									-32.807421874999974
								],
								[
									-70.05205078124999,
									-32.85996093750002
								],
								[
									-70.02197265625,
									-32.88457031250006
								],
								[
									-70.04213867187502,
									-32.963671875
								],
								[
									-70.09306640625002,
									-33.026757812500065
								],
								[
									-70.10400390625,
									-33.12792968750007
								],
								[
									-70.08486328125002,
									-33.20175781250002
								],
								[
									-70.01982421875002,
									-33.271484375000014
								],
								[
									-69.96904296874996,
									-33.27939453125002
								],
								[
									-69.89619140624995,
									-33.2509765625
								],
								[
									-69.81962890624999,
									-33.283789062500034
								],
								[
									-69.80869140624998,
									-33.343945312500026
								],
								[
									-69.79775390624997,
									-33.39863281249998
								],
								[
									-69.83876953124997,
									-33.46972656250007
								],
								[
									-69.88256835937503,
									-33.600976562499994
								],
								[
									-69.89433593750002,
									-33.73134765625008
								],
								[
									-69.88149414062497,
									-33.929785156250006
								],
								[
									-69.86152343749998,
									-34.08359375000008
								],
								[
									-69.85737304687495,
									-34.18046875
								],
								[
									-69.85244140625002,
									-34.224316406250054
								],
								[
									-69.87978515625,
									-34.25439453125006
								],
								[
									-69.94633789062496,
									-34.26992187500002
								],
								[
									-70.00283203125,
									-34.27626953125008
								],
								[
									-70.05205078124999,
									-34.30078125
								],
								[
									-70.06298828125,
									-34.349999999999994
								],
								[
									-70.10146484375002,
									-34.43203125000001
								],
								[
									-70.14125976562497,
									-34.492871093750054
								],
								[
									-70.210693359375,
									-34.58125000000004
								],
								[
									-70.25468749999999,
									-34.67265625
								],
								[
									-70.28994140624997,
									-34.73281250000001
								],
								[
									-70.28676757812494,
									-34.77451171874998
								],
								[
									-70.31210937499995,
									-34.85498046875003
								],
								[
									-70.33813476562503,
									-34.92177734375004
								],
								[
									-70.39316406250003,
									-35.146875000000065
								],
								[
									-70.46660156249999,
									-35.19365234375
								],
								[
									-70.52509765625001,
									-35.216796875000014
								],
								[
									-70.55517578125,
									-35.24687499999993
								],
								[
									-70.53232421874998,
									-35.30791015624993
								],
								[
									-70.47041015624995,
									-35.326171875
								],
								[
									-70.44853515624996,
									-35.375390624999994
								],
								[
									-70.45673828124993,
									-35.451953125000045
								],
								[
									-70.41572265625001,
									-35.52304687500006
								],
								[
									-70.41972656249993,
									-35.60917968750002
								],
								[
									-70.38017578124996,
									-35.77187499999995
								],
								[
									-70.41572265625001,
									-35.878515625000006
								],
								[
									-70.40366210937495,
									-35.97050781249992
								],
								[
									-70.40478515625,
									-36.061718750000026
								],
								[
									-70.45673828124993,
									-36.13271484374992
								],
								[
									-70.56337890625,
									-36.14638671875004
								],
								[
									-70.62187499999999,
									-36.21191406250007
								],
								[
									-70.72192382812494,
									-36.28320312500003
								],
								[
									-70.73286132812495,
									-36.340625
								],
								[
									-70.74926757812503,
									-36.39257812499993
								],
								[
									-70.79028320312503,
									-36.41171874999992
								],
								[
									-70.85317382812497,
									-36.41171874999992
								],
								[
									-70.90512695312498,
									-36.419921874999986
								],
								[
									-70.97792968749997,
									-36.48730468750004
								],
								[
									-71.05551757812498,
									-36.52373046875
								],
								[
									-71.07324218750003,
									-36.57802734375005
								],
								[
									-71.06640624999997,
									-36.64404296875
								],
								[
									-71.10742187499997,
									-36.68505859375
								],
								[
									-71.15937499999998,
									-36.76162109375005
								],
								[
									-71.19218750000002,
									-36.843652343750065
								],
								[
									-71.15937499999998,
									-36.92021484375003
								],
								[
									-71.12382812499993,
									-37.05693359374992
								],
								[
									-71.118408203125,
									-37.11435546875006
								],
								[
									-71.16347656250002,
									-37.22744140625001
								],
								[
									-71.20039062500001,
									-37.300292968750014
								],
								[
									-71.16489257812495,
									-37.39326171875004
								],
								[
									-71.13481445312496,
									-37.44511718750003
								],
								[
									-71.162841796875,
									-37.55917968749992
								],
								[
									-71.18671874999995,
									-37.6310546875
								],
								[
									-71.16757812499998,
									-37.76230468749999
								],
								[
									-71.09619140625,
									-37.909960937499974
								],
								[
									-71.028173828125,
									-38.04121093750007
								],
								[
									-71.0181640625,
									-38.19394531249992
								],
								[
									-71.00048828124994,
									-38.31484375000004
								],
								[
									-70.96796874999998,
									-38.44589843749999
								],
								[
									-70.89965820312503,
									-38.49785156250002
								],
								[
									-70.84765625,
									-38.54160156250005
								],
								[
									-70.858642578125,
									-38.60449218750007
								],
								[
									-70.89692382812498,
									-38.68105468750004
								],
								[
									-70.95161132812495,
									-38.73847656250001
								],
								[
									-71.08710937500001,
									-38.75751953124998
								],
								[
									-71.19726562499997,
									-38.80937500000006
								],
								[
									-71.28574218749998,
									-38.845410156250026
								],
								[
									-71.35317382812494,
									-38.8888671875
								],
								[
									-71.40156249999995,
									-38.935058593749915
								],
								[
									-71.42558593749996,
									-38.98564453125009
								],
								[
									-71.40937499999995,
									-39.20595703125004
								],
								[
									-71.42001953124998,
									-39.28720703125006
								],
								[
									-71.46538085937499,
									-39.40234375000007
								],
								[
									-71.50776367187501,
									-39.49521484374999
								],
								[
									-71.52578124999994,
									-39.52314453125
								],
								[
									-71.53125,
									-39.56416015625
								],
								[
									-71.53945312499997,
									-39.60244140624998
								],
								[
									-71.58701171874998,
									-39.61113281250006
								],
								[
									-71.654296875,
									-39.594238281249915
								],
								[
									-71.69257812499998,
									-39.60517578125001
								],
								[
									-71.71992187499998,
									-39.63525390625
								],
								[
									-71.69682617187496,
									-39.70703125000006
								],
								[
									-71.67207031249998,
									-39.833300781249946
								],
								[
									-71.63789062499995,
									-39.886816406250006
								],
								[
									-71.64711914062497,
									-39.92919921874994
								],
								[
									-71.65976562499998,
									-40.02080078125003
								],
								[
									-71.70439453125002,
									-40.094921874999955
								],
								[
									-71.763671875,
									-40.094628906250065
								],
								[
									-71.80195312499998,
									-40.12470703124998
								],
								[
									-71.81831054687495,
									-40.17666015624991
								],
								[
									-71.80058593749996,
									-40.24433593750001
								],
								[
									-71.72265625,
									-40.29970703125001
								],
								[
									-71.69531250000003,
									-40.33525390625006
								],
								[
									-71.70898437499997,
									-40.38173828125002
								],
								[
									-71.76914062499995,
									-40.400878906250014
								],
								[
									-71.80463867187501,
									-40.43916015625
								],
								[
									-71.83852539062497,
									-40.52441406250006
								],
								[
									-71.88378906249997,
									-40.620605468750014
								],
								[
									-71.93212890624994,
									-40.69169921875003
								],
								[
									-71.94135742187495,
									-40.78916015624999
								],
								[
									-71.873046875,
									-40.892968749999994
								],
								[
									-71.88071289062495,
									-40.99462890624993
								],
								[
									-71.88559570312498,
									-41.29238281250001
								],
								[
									-71.89218749999998,
									-41.39335937500006
								],
								[
									-71.87114257812496,
									-41.560546875000014
								],
								[
									-71.89760742187502,
									-41.60664062500008
								],
								[
									-71.91127929687497,
									-41.65039062499994
								],
								[
									-71.84448242187503,
									-41.771972656250014
								],
								[
									-71.77001953124997,
									-41.9685546875
								],
								[
									-71.74999999999997,
									-42.04677734375005
								],
								[
									-71.76093749999998,
									-42.101464843749994
								],
								[
									-71.86079101562498,
									-42.14785156250004
								],
								[
									-71.944091796875,
									-42.16708984375005
								],
								[
									-71.99331054687497,
									-42.134277343750014
								],
								[
									-72.026123046875,
									-42.14794921875006
								],
								[
									-72.06440429687498,
									-42.20537109375003
								],
								[
									-72.10820312499993,
									-42.25185546874991
								],
								[
									-72.124609375,
									-42.29833984375004
								],
								[
									-72.07812500000003,
									-42.35849609374996
								],
								[
									-72.05346679687497,
									-42.47324218750006
								],
								[
									-72.10541992187498,
									-42.52246093749997
								],
								[
									-72.14370117187497,
									-42.5771484375
								],
								[
									-72.13002929687494,
									-42.64824218750002
								],
								[
									-72.11362304687498,
									-42.77675781249991
								],
								[
									-72.14643554687501,
									-42.99003906250002
								],
								[
									-72.102392578125,
									-43.06562500000004
								],
								[
									-72.05468749999997,
									-43.10195312499998
								],
								[
									-71.89858398437497,
									-43.14531250000003
								],
								[
									-71.781494140625,
									-43.166796875000045
								],
								[
									-71.75063476562502,
									-43.23730468749994
								],
								[
									-71.76386718749995,
									-43.29462890625007
								],
								[
									-71.82021484374997,
									-43.32294921874998
								],
								[
									-71.90498046875001,
									-43.34755859375002
								],
								[
									-71.90498046875001,
									-43.440136718750054
								],
								[
									-71.83242187499997,
									-43.52714843750002
								],
								[
									-71.75063476562502,
									-43.59013671875006
								],
								[
									-71.732763671875,
									-43.646777343750045
								],
								[
									-71.73740234374998,
									-43.70468749999995
								],
								[
									-71.79472656250002,
									-43.75322265625006
								],
								[
									-71.71596679687497,
									-43.8583984375
								],
								[
									-71.68007812500002,
									-43.92958984374994
								],
								[
									-71.716162109375,
									-43.984472656250006
								],
								[
									-71.7671875,
									-44.06669921875006
								],
								[
									-71.81235351562498,
									-44.106054687500006
								],
								[
									-71.812109375,
									-44.15078125000005
								],
								[
									-71.83076171874998,
									-44.24140625000004
								],
								[
									-71.83505859374998,
									-44.330175781250006
								],
								[
									-71.82001953124993,
									-44.38310546874996
								],
								[
									-71.32573242187496,
									-44.42490234374995
								],
								[
									-71.21259765625001,
									-44.441210937500074
								],
								[
									-71.15087890624994,
									-44.494042968749994
								],
								[
									-71.15971679687496,
									-44.56025390625007
								],
								[
									-71.22148437499993,
									-44.630761718749966
								],
								[
									-71.26113281250002,
									-44.76308593749992
								],
								[
									-71.358154296875,
									-44.78515625000006
								],
								[
									-71.45517578125003,
									-44.74980468750006
								],
								[
									-71.56040039062498,
									-44.76201171875006
								],
								[
									-71.65166015625002,
									-44.770410156249994
								],
								[
									-71.7828125,
									-44.7744140625
								],
								[
									-71.95703124999997,
									-44.79150390625003
								],
								[
									-72.06372070312503,
									-44.77187499999994
								],
								[
									-72.07250976562494,
									-44.82041015625005
								],
								[
									-72.04169921874998,
									-44.904199218750065
								],
								[
									-71.81235351562498,
									-44.93066406249996
								],
								[
									-71.5962890625,
									-44.97919921875007
								],
								[
									-71.53129882812499,
									-45.067871093750014
								],
								[
									-71.44345703124995,
									-45.168261718750045
								],
								[
									-71.35375976562497,
									-45.23046874999993
								],
								[
									-71.34931640624995,
									-45.331933593749994
								],
								[
									-71.49042968749993,
									-45.43769531250004
								],
								[
									-71.50810546874999,
									-45.51269531250004
								],
								[
									-71.69331054687495,
									-45.534765625000006
								],
								[
									-71.74619140625,
									-45.57890625000003
								],
								[
									-71.77265624999995,
									-45.72441406250002
								],
								[
									-71.75063476562502,
									-45.839062499999926
								],
								[
									-71.68007812500002,
									-45.8787109375
								],
								[
									-71.63154296874998,
									-45.953710937500006
								],
								[
									-71.68447265624994,
									-46.04189453125004
								],
								[
									-71.80927734374995,
									-46.102734375
								],
								[
									-71.87568359374998,
									-46.16054687500005
								],
								[
									-71.83413085937497,
									-46.20673828125004
								],
								[
									-71.77763671875002,
									-46.27998046875004
								],
								[
									-71.76210937499994,
									-46.319824218749986
								],
								[
									-71.73129882812498,
									-46.42783203125005
								],
								[
									-71.69521484375,
									-46.57841796875009
								],
								[
									-71.69965820312501,
									-46.65136718750003
								],
								[
									-71.73271484374999,
									-46.705859374999946
								],
								[
									-71.85644531249997,
									-46.791601562500006
								],
								[
									-71.94023437499999,
									-46.83125000000008
								],
								[
									-71.95664062499998,
									-46.93681640625
								],
								[
									-71.96298828125,
									-47.016015625000065
								],
								[
									-71.95424804687502,
									-47.08750000000006
								],
								[
									-71.900537109375,
									-47.1443359375
								],
								[
									-71.90498046875001,
									-47.20166015625006
								],
								[
									-71.97851562499997,
									-47.21386718750006
								],
								[
									-72.04169921874998,
									-47.24140624999998
								],
								[
									-72.10341796875002,
									-47.34277343750003
								],
								[
									-72.28291015625001,
									-47.44628906250006
								],
								[
									-72.34594726562497,
									-47.492675781250014
								],
								[
									-72.34150390624995,
									-47.57207031250002
								],
								[
									-72.41259765624994,
									-47.68554687500004
								],
								[
									-72.47221679687502,
									-47.78417968750007
								],
								[
									-72.517919921875,
									-47.87636718750002
								],
								[
									-72.50908203124999,
									-47.973339843750054
								],
								[
									-72.40791015624998,
									-48.01591796875003
								],
								[
									-72.32832031250001,
									-48.110058593750026
								],
								[
									-72.29301757812502,
									-48.22910156250002
								],
								[
									-72.35473632812497,
									-48.36582031250008
								],
								[
									-72.49814453124998,
									-48.41738281250001
								],
								[
									-72.582861328125,
									-48.47539062500002
								],
								[
									-72.60839843749997,
									-48.51933593750009
								],
								[
									-72.5859375,
									-48.66250000000004
								],
								[
									-72.59174804687495,
									-48.72968750000005
								],
								[
									-72.61440429687494,
									-48.79287109375004
								],
								[
									-72.65126953125,
									-48.84160156250002
								],
								[
									-72.72846679687501,
									-48.89628906250006
								],
								[
									-72.86542968750001,
									-48.9439453125
								],
								[
									-72.98173828124999,
									-48.97675781250002
								],
								[
									-73.03364257812501,
									-49.01435546875004
								],
								[
									-73.09458007812498,
									-49.09687500000007
								],
								[
									-73.14887695312495,
									-49.187988281250064
								],
								[
									-73.13525390625,
									-49.30068359375002
								],
								[
									-73.46157226562497,
									-49.313867187500044
								],
								[
									-73.48364257812503,
									-49.39765625000006
								],
								[
									-73.55419921875,
									-49.46386718750005
								],
								[
									-73.57626953124998,
									-49.58291015625005
								],
								[
									-73.50454101562502,
									-49.69804687500006
								],
								[
									-73.47041015624998,
									-49.79453125
								],
								[
									-73.52890625,
									-49.91093750000009
								],
								[
									-73.50771484374994,
									-50.030273437500064
								],
								[
									-73.50126953124996,
									-50.12529296875006
								],
								[
									-73.38662109374997,
									-50.23115234375005
								],
								[
									-73.31171874999998,
									-50.36191406250004
								],
								[
									-73.27416992187497,
									-50.47255859375002
								],
								[
									-73.251611328125,
									-50.55849609375003
								],
								[
									-73.22163085937493,
									-50.610742187500016
								],
								[
									-73.17451171875001,
									-50.67001953125001
								],
								[
									-73.15292968749998,
									-50.738281250000064
								],
								[
									-73.08237304687498,
									-50.760351562500034
								],
								[
									-72.95556640625,
									-50.696484375000075
								],
								[
									-72.86591796874993,
									-50.65312500000004
								],
								[
									-72.80361328124994,
									-50.6376953125
								],
								[
									-72.62041015625002,
									-50.647656250000075
								],
								[
									-72.50981445312496,
									-50.60751953125007
								],
								[
									-72.46015624999995,
									-50.61171875000004
								],
								[
									-72.39257812499997,
									-50.634277343750014
								],
								[
									-72.34023437499997,
									-50.681835937500026
								],
								[
									-72.30063476562498,
									-50.78955078125003
								],
								[
									-72.27631835937498,
									-50.91025390625002
								],
								[
									-72.307373046875,
									-51.03339843750006
								],
								[
									-72.35917968749999,
									-51.060156250000006
								],
								[
									-72.37680664062503,
									-51.09541015625008
								],
								[
									-72.35917968749999,
									-51.17041015624999
								],
								[
									-72.30185546874995,
									-51.22333984375003
								],
								[
									-72.30322265624997,
									-51.29892578125006
								],
								[
									-72.36640624999995,
									-51.47031250000008
								],
								[
									-72.40766601562501,
									-51.54082031250005
								],
								[
									-72.33452148437496,
									-51.62031250000008
								],
								[
									-72.26899414062501,
									-51.691113281250026
								],
								[
									-72.13696289062503,
									-51.744042968750065
								],
								[
									-72.02841796875003,
									-51.818652343750074
								],
								[
									-71.95346679687503,
									-51.880371093750036
								],
								[
									-71.97109375,
									-51.96416015625005
								],
								[
									-71.91865234374995,
									-51.989550781250074
								],
								[
									-71.71660156250002,
									-51.99130859375008
								],
								[
									-71.41474609374998,
									-51.99394531250008
								],
								[
									-70.94316406249999,
									-51.99814453125005
								],
								[
									-70.48286132812501,
									-52.00224609375009
								],
								[
									-69.96025390624996,
									-52.00820312500006
								],
								[
									-69.71259765624995,
									-52.07539062500007
								],
								[
									-69.48842773437502,
									-52.13613281250001
								],
								[
									-69.206201171875,
									-52.13613281250001
								],
								[
									-68.92456054687497,
									-52.20810546875001
								],
								[
									-68.71518554687495,
									-52.25546875000007
								],
								[
									-68.58979492187498,
									-52.27333984374998
								],
								[
									-68.46098632812496,
									-52.2904296875
								],
								[
									-68.443359375,
									-52.356640625000075
								],
								[
									-69.00722656249994,
									-52.262695312500036
								],
								[
									-69.13378906249997,
									-52.21142578125007
								],
								[
									-69.24101562499996,
									-52.20546875000001
								],
								[
									-69.44687499999998,
									-52.26943359374999
								],
								[
									-69.56059570312496,
									-52.421582031250075
								],
								[
									-69.62031249999998,
									-52.46474609374999
								],
								[
									-69.76333007812497,
									-52.50556640625004
								],
								[
									-69.90722656249997,
									-52.51357421874999
								],
								[
									-70.39096679687503,
									-52.660839843750054
								],
								[
									-70.56293945312498,
									-52.67343750000005
								],
								[
									-70.680322265625,
									-52.71250000000001
								],
								[
									-70.79511718749995,
									-52.76875000000001
								],
								[
									-70.83906250000001,
									-52.88955078125002
								],
								[
									-70.82119140625002,
									-52.96308593750008
								],
								[
									-70.95205078124994,
									-53.226953125000016
								],
								[
									-70.98432617187495,
									-53.373632812500055
								],
								[
									-70.98510742187503,
									-53.44833984375
								],
								[
									-70.94780273437496,
									-53.57041015625
								],
								[
									-70.99584960937497,
									-53.77929687500001
								],
								[
									-71.08281249999993,
									-53.82500000000008
								],
								[
									-71.29775390625002,
									-53.88339843750008
								],
								[
									-71.44389648437496,
									-53.84091796875004
								],
								[
									-71.69379882812498,
									-53.803125000000065
								],
								[
									-71.87187500000002,
									-53.722656250000014
								],
								[
									-72.10092773437498,
									-53.665820312500074
								],
								[
									-72.1744140625,
									-53.63232421875
								],
								[
									-72.37680664062503,
									-53.471191406250036
								],
								[
									-72.39824218749996,
									-53.417773437500074
								],
								[
									-72.41289062500002,
									-53.35019531250008
								],
								[
									-72.30605468750002,
									-53.253710937500045
								],
								[
									-72.24863281250003,
									-53.246679687500034
								],
								[
									-72.08115234375003,
									-53.24960937500001
								],
								[
									-71.94169921874993,
									-53.23408203125005
								],
								[
									-71.85273437499993,
									-53.2857421875
								],
								[
									-71.82822265625,
									-53.39833984375002
								],
								[
									-71.867333984375,
									-53.4583984375
								],
								[
									-71.90278320312501,
									-53.495507812500016
								],
								[
									-71.89169921874998,
									-53.52353515625004
								],
								[
									-71.79145507812498,
									-53.484570312500004
								],
								[
									-71.74052734374999,
									-53.23261718750001
								],
								[
									-71.40034179687495,
									-53.107031250000006
								],
								[
									-71.28896484375002,
									-53.033691406249986
								],
								[
									-71.18022460937499,
									-52.92050781250002
								],
								[
									-71.16328124999998,
									-52.88808593749999
								],
								[
									-71.15507812500002,
									-52.84560546875004
								],
								[
									-71.22714843750003,
									-52.81064453125002
								],
								[
									-71.38774414062499,
									-52.76425781250008
								],
								[
									-71.89799804687502,
									-53.00175781250005
								],
								[
									-72.12910156249993,
									-53.064355468750016
								],
								[
									-72.27802734374998,
									-53.13232421875001
								],
								[
									-72.45830078124993,
									-53.25449218750003
								],
								[
									-72.492578125,
									-53.29062500000002
								],
								[
									-72.53081054687496,
									-53.37167968750001
								],
								[
									-72.54892578125,
									-53.46074218750004
								],
								[
									-72.72680664062503,
									-53.42001953125
								],
								[
									-72.998388671875,
									-53.29072265625004
								],
								[
									-73.05273437499997,
									-53.24345703125009
								],
								[
									-72.99824218749998,
									-53.177246093750014
								],
								[
									-72.91552734375,
									-53.12197265625003
								],
								[
									-72.90991210937503,
									-52.9365234375
								],
								[
									-72.88916015624997,
									-52.87158203125
								],
								[
									-72.83188476562503,
									-52.819531250000054
								],
								[
									-72.72768554687502,
									-52.762304687500034
								],
								[
									-72.67597656249995,
									-52.74902343749999
								],
								[
									-72.632080078125,
									-52.77382812499998
								],
								[
									-72.62661132812494,
									-52.81757812500001
								],
								[
									-72.45346679687503,
									-52.814453125
								],
								[
									-72.117578125,
									-52.65000000000007
								],
								[
									-71.97929687499996,
									-52.64609375000007
								],
								[
									-71.79707031249995,
									-52.682812500000004
								],
								[
									-71.59121093749994,
									-52.660742187500034
								],
								[
									-71.55415039062495,
									-52.64394531249999
								],
								[
									-71.51127929687502,
									-52.60537109375004
								],
								[
									-71.66474609375001,
									-52.56005859375004
								],
								[
									-71.81191406249997,
									-52.53701171875005
								],
								[
									-72.22568359374998,
									-52.520996093749986
								],
								[
									-72.31538085937495,
									-52.538574218750014
								],
								[
									-72.43769531250001,
									-52.62578125000002
								],
								[
									-72.478271484375,
									-52.60400390625002
								],
								[
									-72.50439453125,
									-52.56005859375004
								],
								[
									-72.64482421875002,
									-52.52910156250004
								],
								[
									-72.71210937499995,
									-52.53554687500002
								],
								[
									-72.77656249999995,
									-52.57744140625003
								],
								[
									-72.76601562500002,
									-52.642578125000064
								],
								[
									-72.80190429687497,
									-52.71240234374999
								],
								[
									-72.93188476562497,
									-52.781640625000065
								],
								[
									-73.02026367187503,
									-52.89179687500003
								],
								[
									-73.01611328124997,
									-52.97744140624999
								],
								[
									-73.02299804687496,
									-53.02207031250002
								],
								[
									-73.05546875000002,
									-53.04560546875002
								],
								[
									-73.12246093749997,
									-53.07392578125001
								],
								[
									-73.33818359374996,
									-53.0546875
								],
								[
									-73.45986328124997,
									-52.96484374999999
								],
								[
									-73.50751953125001,
									-52.903515625000026
								],
								[
									-73.64521484374998,
									-52.83701171875006
								],
								[
									-73.34594726562503,
									-52.754296875
								],
								[
									-73.24082031250003,
									-52.70712890625007
								],
								[
									-73.14482421875002,
									-52.60195312500005
								],
								[
									-73.07319335937498,
									-52.53505859375001
								],
								[
									-73.12392578125002,
									-52.48798828125001
								],
								[
									-73.18378906249995,
									-52.48789062499999
								],
								[
									-73.17817382812495,
									-52.56269531250005
								],
								[
									-73.244140625,
									-52.624023437500014
								],
								[
									-73.38212890624993,
									-52.59511718749999
								],
								[
									-73.58569335937503,
									-52.68574218750007
								],
								[
									-73.71083984374994,
									-52.661523437500016
								],
								[
									-73.914697265625,
									-52.68818359375003
								],
								[
									-74.01445312499999,
									-52.63935546875003
								],
								[
									-74.03583984374998,
									-52.57724609375008
								],
								[
									-73.99990234374994,
									-52.51259765625005
								],
								[
									-74.03735351562503,
									-52.402929687500006
								],
								[
									-74.093505859375,
									-52.37626953125008
								],
								[
									-74.15083007812495,
									-52.38251953125002
								],
								[
									-74.17656249999996,
									-52.31718750000003
								],
								[
									-74.23847656249995,
									-52.20234375000008
								],
								[
									-74.26596679687498,
									-52.171289062500065
								],
								[
									-74.29565429687497,
									-52.11787109375002
								],
								[
									-74.26494140624993,
									-52.10488281250004
								],
								[
									-74.19492187499998,
									-52.12021484375005
								],
								[
									-74.133544921875,
									-52.154785156249986
								],
								[
									-74.04023437499998,
									-52.15917968749999
								],
								[
									-73.83447265625,
									-52.23398437500005
								],
								[
									-73.74912109375,
									-52.216015625000026
								],
								[
									-73.702783203125,
									-52.19882812500008
								],
								[
									-73.685400390625,
									-52.136718750000036
								],
								[
									-73.68432617187497,
									-52.07773437500001
								],
								[
									-73.64902343749995,
									-52.07773437500001
								],
								[
									-73.53222656249997,
									-52.153125
								],
								[
									-73.45795898437493,
									-52.145996093750064
								],
								[
									-73.32675781250003,
									-52.16591796875004
								],
								[
									-73.26044921874993,
									-52.15781250000007
								],
								[
									-73.137353515625,
									-52.129687500000024
								],
								[
									-72.94370117187498,
									-52.04687500000003
								],
								[
									-72.84321289062493,
									-51.96113281250006
								],
								[
									-72.79501953124998,
									-51.94951171875009
								],
								[
									-72.73540039062499,
									-51.96054687500003
								],
								[
									-72.69545898437502,
									-51.98515625000007
								],
								[
									-72.69482421875,
									-52.04472656250004
								],
								[
									-72.649560546875,
									-52.09990234375009
								],
								[
									-72.58798828124998,
									-52.14511718750006
								],
								[
									-72.57084960937496,
									-52.20009765624998
								],
								[
									-72.58344726562495,
									-52.25419921875008
								],
								[
									-72.693603515625,
									-52.33027343750003
								],
								[
									-72.714013671875,
									-52.35673828125001
								],
								[
									-72.67705078125002,
									-52.384667968750016
								],
								[
									-72.63149414062497,
									-52.371582031250014
								],
								[
									-72.56870117187495,
									-52.33398437499999
								],
								[
									-72.53291015624995,
									-52.282324218750034
								],
								[
									-72.52333984374997,
									-52.25546875000007
								],
								[
									-72.51933593749993,
									-52.21708984375007
								],
								[
									-72.52412109374993,
									-52.170312500000044
								],
								[
									-72.61357421874996,
									-52.037011718750065
								],
								[
									-72.624755859375,
									-52.00693359375006
								],
								[
									-72.62460937499998,
									-51.946484375000004
								],
								[
									-72.52285156249994,
									-51.89091796875005
								],
								[
									-72.49414062499997,
									-51.847558593750016
								],
								[
									-72.48964843750002,
									-51.763671875000064
								],
								[
									-72.54252929687496,
									-51.70615234375007
								],
								[
									-72.76123046875003,
									-51.57324218749999
								],
								[
									-73.12675781249996,
									-51.439941406250014
								],
								[
									-73.16874999999999,
									-51.45390625000002
								],
								[
									-73.19702148437497,
									-51.47802734375005
								],
								[
									-73.16337890624996,
									-51.495605468749986
								],
								[
									-73.11499023437497,
									-51.50449218750002
								],
								[
									-72.78935546874996,
									-51.6142578125
								],
								[
									-72.70458984375003,
									-51.677929687500004
								],
								[
									-72.649072265625,
									-51.695019531250026
								],
								[
									-72.58330078125002,
									-51.73730468750002
								],
								[
									-72.60004882812495,
									-51.79912109375
								],
								[
									-72.92836914062497,
									-51.859863281250036
								],
								[
									-73.18867187499995,
									-51.99062500000003
								],
								[
									-73.38325195312498,
									-52.07001953125004
								],
								[
									-73.51816406250003,
									-52.04101562499999
								],
								[
									-73.58232421874996,
									-51.96035156249999
								],
								[
									-73.65029296874997,
									-51.85625000000001
								],
								[
									-73.75263671874993,
									-51.79550781250007
								],
								[
									-73.81064453125003,
									-51.801171875000065
								],
								[
									-73.857568359375,
									-51.78994140625
								],
								[
									-73.89443359374997,
									-51.75781250000003
								],
								[
									-73.97324218750003,
									-51.78447265625004
								],
								[
									-74.14643554687495,
									-51.71210937500004
								],
								[
									-74.19667968749997,
									-51.68056640625001
								],
								[
									-74.06958007812503,
									-51.57871093750004
								],
								[
									-73.92978515624995,
									-51.617871093750026
								],
								[
									-73.8958984375,
									-51.33144531250003
								],
								[
									-73.93950195312499,
									-51.26630859375008
								],
								[
									-74.12124023437497,
									-51.19541015625003
								],
								[
									-74.21049804687496,
									-51.20458984375003
								],
								[
									-74.33232421874999,
									-51.19501953125003
								],
								[
									-74.41435546875002,
									-51.16249999999998
								],
								[
									-74.50786132812496,
									-51.14960937500002
								],
								[
									-74.58686523437498,
									-51.13066406250007
								],
								[
									-74.69008789062497,
									-51.08652343750005
								],
								[
									-74.81474609374996,
									-51.06289062500003
								],
								[
									-74.98310546874995,
									-50.88105468750002
								],
								[
									-75.05532226562502,
									-50.785546875000016
								],
								[
									-75.09467773437495,
									-50.68124999999999
								],
								[
									-74.83662109374995,
									-50.67890625000005
								],
								[
									-74.68574218749995,
									-50.66201171874998
								],
								[
									-74.64892578125,
									-50.61845703125008
								],
								[
									-74.70205078125,
									-50.535351562500026
								],
								[
									-74.77587890625003,
									-50.46992187500002
								],
								[
									-74.7216796875,
									-50.408496093750024
								],
								[
									-74.64448242187498,
									-50.36093750000002
								],
								[
									-74.56411132812497,
									-50.382031250000054
								],
								[
									-74.365576171875,
									-50.487890625000034
								],
								[
									-74.3314453125,
									-50.55957031250007
								],
								[
									-74.190185546875,
									-50.77802734375008
								],
								[
									-74.15610351562498,
									-50.79746093750004
								],
								[
									-74.13940429687503,
									-50.81777343750001
								],
								[
									-73.84746093749999,
									-50.94003906250005
								],
								[
									-73.80654296875,
									-50.938378906250065
								],
								[
									-73.82460937500002,
									-50.835839843750044
								],
								[
									-73.74057617187495,
									-50.69667968750003
								],
								[
									-73.65903320312495,
									-50.650683593750074
								],
								[
									-73.61816406249997,
									-50.65117187500008
								],
								[
									-73.61396484375001,
									-50.62792968750006
								],
								[
									-73.69326171875,
									-50.57001953125007
								],
								[
									-73.654443359375,
									-50.492675781250036
								],
								[
									-73.67993164062494,
									-50.49023437500007
								],
								[
									-73.75019531249995,
									-50.53984375000005
								],
								[
									-73.89150390624997,
									-50.78271484375006
								],
								[
									-73.97802734375003,
									-50.82705078125003
								],
								[
									-74.09672851562496,
									-50.71708984375001
								],
								[
									-74.16411132812502,
									-50.63789062500004
								],
								[
									-74.19721679687501,
									-50.609765624999994
								],
								[
									-74.18559570312493,
									-50.48535156250005
								],
								[
									-73.95034179687497,
									-50.51054687500003
								],
								[
									-74.03105468749999,
									-50.46982421875
								],
								[
									-74.30556640624997,
									-50.39804687500003
								],
								[
									-74.37412109374998,
									-50.36298828125008
								],
								[
									-74.42509765624996,
									-50.35019531250005
								],
								[
									-74.51640625000002,
									-50.26562500000005
								],
								[
									-74.62958984374998,
									-50.19404296875003
								],
								[
									-74.434326171875,
									-50.06523437500008
								],
								[
									-74.333740234375,
									-49.97460937500001
								],
								[
									-74.01943359375002,
									-50.022753906250045
								],
								[
									-73.95859374999998,
									-49.99472656250002
								],
								[
									-74.01123046875003,
									-49.92851562500003
								],
								[
									-74.07329101562499,
									-49.948535156250024
								],
								[
									-74.17133789062495,
									-49.90732421875006
								],
								[
									-74.32392578124995,
									-49.78339843750004
								],
								[
									-74.31874999999997,
									-49.72011718750003
								],
								[
									-74.29082031249996,
									-49.60410156250002
								],
								[
									-74.23037109375,
									-49.579296875000026
								],
								[
									-74.10200195312495,
									-49.55537109375004
								],
								[
									-73.95551757812495,
									-49.59306640625008
								],
								[
									-73.89155273437498,
									-49.62373046875002
								],
								[
									-73.83637695312493,
									-49.60937500000003
								],
								[
									-73.89248046875,
									-49.523437500000014
								],
								[
									-73.98803710937503,
									-49.490917968750054
								],
								[
									-74.09443359374993,
									-49.429687500000014
								],
								[
									-74.08349609375,
									-49.36181640625004
								],
								[
									-74.04921874999997,
									-49.30566406250006
								],
								[
									-74.02343750000003,
									-49.24414062500005
								],
								[
									-74.00561523437494,
									-49.15800781250009
								],
								[
									-74.015380859375,
									-49.090917968750006
								],
								[
									-73.98476562499997,
									-49.05996093750001
								],
								[
									-73.93789062500002,
									-49.046093750000026
								],
								[
									-73.93496093749994,
									-49.020898437500044
								],
								[
									-74.02773437500002,
									-49.02617187500005
								],
								[
									-74.06132812499993,
									-49.11103515625002
								],
								[
									-74.073876953125,
									-49.18837890625006
								],
								[
									-74.13979492187502,
									-49.25048828125001
								],
								[
									-74.16787109374997,
									-49.32050781250006
								],
								[
									-74.1845703125,
									-49.40439453125001
								],
								[
									-74.2212890625,
									-49.50058593750007
								],
								[
									-74.30151367187503,
									-49.46396484375007
								],
								[
									-74.34853515625,
									-49.42626953125003
								],
								[
									-74.36655273437503,
									-49.40048828125001
								],
								[
									-74.358154296875,
									-49.351367187500045
								],
								[
									-74.37998046875,
									-49.04785156250003
								],
								[
									-74.38212890625002,
									-48.79365234375002
								],
								[
									-74.34101562499998,
									-48.595703125000014
								],
								[
									-74.227685546875,
									-48.51699218750005
								],
								[
									-74.17622070312498,
									-48.494140625000014
								],
								[
									-74.12929687500002,
									-48.50419921875003
								],
								[
									-74.05693359375002,
									-48.50361328125008
								],
								[
									-74.00908203124996,
									-48.47500000000002
								],
								[
									-74.171533203125,
									-48.427441406250026
								],
								[
									-74.27006835937502,
									-48.45458984375004
								],
								[
									-74.34296874999993,
									-48.49257812500005
								],
								[
									-74.47441406249999,
									-48.463964843750006
								],
								[
									-74.49941406250002,
									-48.36230468750007
								],
								[
									-74.57719726562496,
									-48.274414062500014
								],
								[
									-74.59072265624997,
									-48.16191406249993
								],
								[
									-74.58466796874998,
									-47.99902343750004
								],
								[
									-74.40048828125003,
									-48.01308593749998
								],
								[
									-74.25043945312501,
									-48.04492187500007
								],
								[
									-73.85380859374993,
									-48.042187500000054
								],
								[
									-73.52817382812503,
									-48.19824218750004
								],
								[
									-73.38447265624998,
									-48.17734375000005
								],
								[
									-73.39106445312498,
									-48.14589843750004
								],
								[
									-73.5009765625,
									-48.10664062500004
								],
								[
									-73.56958007812503,
									-48.01933593750002
								],
								[
									-73.60991210937499,
									-47.993945312500074
								],
								[
									-73.62890624999994,
									-47.94150390625005
								],
								[
									-73.63510742187498,
									-47.88037109375003
								],
								[
									-73.71586914062499,
									-47.65546875000004
								],
								[
									-73.74824218750001,
									-47.66132812500008
								],
								[
									-73.77924804687493,
									-47.7384765625
								],
								[
									-73.8466796875,
									-47.86699218750006
								],
								[
									-73.94086914062501,
									-47.92939453125007
								],
								[
									-74.08476562500002,
									-47.95468749999999
								],
								[
									-74.22705078124994,
									-47.968945312500054
								],
								[
									-74.35058593749997,
									-47.944335937500014
								],
								[
									-74.37934570312498,
									-47.89121093750002
								],
								[
									-74.37622070312497,
									-47.829687500000006
								],
								[
									-74.42968750000003,
									-47.79960937500002
								],
								[
									-74.56923828125002,
									-47.772949218749915
								],
								[
									-74.60888671875003,
									-47.75800781250007
								],
								[
									-74.654931640625,
									-47.70224609375008
								],
								[
									-74.58842773437493,
									-47.61796874999996
								],
								[
									-74.5337890625,
									-47.56767578125002
								],
								[
									-74.46689453124995,
									-47.577636718749915
								],
								[
									-74.40356445312503,
									-47.60039062499993
								],
								[
									-74.32255859374996,
									-47.66669921874994
								],
								[
									-74.24296874999999,
									-47.67929687500002
								],
								[
									-74.151953125,
									-47.626660156249955
								],
								[
									-74.13408203125002,
									-47.590820312500014
								],
								[
									-74.19101562499998,
									-47.56835937500006
								],
								[
									-74.24291992187497,
									-47.55966796875006
								],
								[
									-74.32368164062501,
									-47.5314453125
								],
								[
									-74.48266601562497,
									-47.43046875000003
								],
								[
									-74.40327148437495,
									-47.32753906250002
								],
								[
									-74.21567382812503,
									-47.20957031250006
								],
								[
									-74.15839843749998,
									-47.182519531250065
								],
								[
									-74.20805664062499,
									-47.08310546875006
								],
								[
									-74.15190429687502,
									-46.974414062499946
								],
								[
									-74.20947265625,
									-46.88476562500006
								],
								[
									-74.31357421874998,
									-46.78818359375002
								],
								[
									-74.45419921875003,
									-46.766796874999926
								],
								[
									-74.48442382812499,
									-46.79501953124999
								],
								[
									-74.48935546875,
									-46.83457031250005
								],
								[
									-74.46699218749998,
									-46.86435546875008
								],
								[
									-74.48017578125001,
									-46.88583984375002
								],
								[
									-74.51225585937496,
									-46.88515625000005
								],
								[
									-74.69082031250002,
									-46.86396484375
								],
								[
									-74.81064453125,
									-46.79970703125005
								],
								[
									-75.00595703125,
									-46.74111328125002
								],
								[
									-75.03144531249995,
									-46.69531249999993
								],
								[
									-75.05253906249999,
									-46.62802734375008
								],
								[
									-74.98417968750002,
									-46.51210937499991
								],
								[
									-75.01874999999995,
									-46.510546874999946
								],
								[
									-75.14575195312497,
									-46.60009765625007
								],
								[
									-75.33740234375003,
									-46.64707031250005
								],
								[
									-75.47841796874997,
									-46.662402343749974
								],
								[
									-75.54033203124999,
									-46.698730468749915
								],
								[
									-75.56508789062497,
									-46.72871093749998
								],
								[
									-75.52758789062497,
									-46.74638671875003
								],
								[
									-75.44599609374995,
									-46.75078125000003
								],
								[
									-75.38642578124998,
									-46.86269531249992
								],
								[
									-75.40122070312498,
									-46.90566406250005
								],
								[
									-75.43037109374995,
									-46.9345703125
								],
								[
									-75.49663085937496,
									-46.94013671875007
								],
								[
									-75.63525390624994,
									-46.86279296874994
								],
								[
									-75.70810546874998,
									-46.77499999999999
								],
								[
									-75.70639648437498,
									-46.7052734375
								],
								[
									-75.65678710937499,
									-46.61035156250003
								],
								[
									-75.43691406249997,
									-46.48300781250002
								],
								[
									-75.37602539062499,
									-46.42910156250005
								],
								[
									-75.24702148437501,
									-46.369335937499955
								],
								[
									-75.074853515625,
									-46.234570312500026
								],
								[
									-74.92446289062502,
									-46.15966796875004
								],
								[
									-74.99765625,
									-46.09765625000003
								],
								[
									-75.07451171874993,
									-46.00449218750005
								],
								[
									-75.06669921874993,
									-45.87490234375002
								],
								[
									-74.76313476562501,
									-45.82363281249998
								],
								[
									-74.63066406250002,
									-45.844726562500014
								],
								[
									-74.46279296875002,
									-45.84072265624991
								],
								[
									-74.36914062500003,
									-45.80966796874998
								],
								[
									-74.30117187499994,
									-45.803027343750045
								],
								[
									-74.15786132812497,
									-45.76718750000002
								],
								[
									-74.09619140625003,
									-45.71679687500006
								],
								[
									-74.08183593749993,
									-45.678320312500034
								],
								[
									-74.08251953125,
									-45.644726562500026
								],
								[
									-74.09926757812502,
									-45.60341796875005
								],
								[
									-74.122705078125,
									-45.49619140625006
								],
								[
									-74.09892578124996,
									-45.46035156250004
								],
								[
									-74.03754882812498,
									-45.417675781250054
								],
								[
									-73.95717773437494,
									-45.404394531250006
								],
								[
									-73.9203125,
									-45.40771484375006
								],
								[
									-73.82500000000002,
									-45.44687499999996
								],
								[
									-73.84414062500002,
									-45.502441406249915
								],
								[
									-73.88232421874997,
									-45.56933593750004
								],
								[
									-73.96025390624996,
									-45.83525390625003
								],
								[
									-73.99951171874994,
									-45.89531250000002
								],
								[
									-74.06103515624997,
									-45.94736328124996
								],
								[
									-74.01992187500002,
									-46.05585937500004
								],
								[
									-74.08154296874997,
									-46.13183593750006
								],
								[
									-74.356787109375,
									-46.21269531250002
								],
								[
									-74.39296875,
									-46.21738281250008
								],
								[
									-74.3724609375,
									-46.24628906250001
								],
								[
									-74.21313476562494,
									-46.23945312500004
								],
								[
									-74.08974609374997,
									-46.222363281250026
								],
								[
									-73.96757812500002,
									-46.15410156250006
								],
								[
									-73.92919921875003,
									-46.04990234375006
								],
								[
									-73.87871093749996,
									-45.846875
								],
								[
									-73.81254882812496,
									-45.81816406249993
								],
								[
									-73.73525390624994,
									-45.81171875000004
								],
								[
									-73.69487304687499,
									-45.85957031250001
								],
								[
									-73.70791015624997,
									-45.966699218749994
								],
								[
									-73.70815429687502,
									-46.07031250000004
								],
								[
									-73.81064453125003,
									-46.37734374999998
								],
								[
									-73.934814453125,
									-46.50068359375007
								],
								[
									-73.9486328125,
									-46.53310546874992
								],
								[
									-73.94374999999997,
									-46.571582031249946
								],
								[
									-73.845361328125,
									-46.56601562500005
								],
								[
									-73.77026367187497,
									-46.49980468750006
								],
								[
									-73.71621093749997,
									-46.41523437500007
								],
								[
									-73.66206054687495,
									-46.29746093750005
								],
								[
									-73.66821289062497,
									-46.21210937500007
								],
								[
									-73.65166015624996,
									-46.15927734375005
								],
								[
									-73.62944335937496,
									-45.986523437500026
								],
								[
									-73.59184570312496,
									-45.89912109375008
								],
								[
									-73.5943359375,
									-45.77685546875004
								],
								[
									-73.66196289062503,
									-45.73076171875006
								],
								[
									-73.75659179687503,
									-45.702832031250054
								],
								[
									-73.78037109374998,
									-45.62792968750007
								],
								[
									-73.73076171875002,
									-45.47998046874996
								],
								[
									-73.54990234375,
									-45.48378906250002
								],
								[
									-73.37856445312502,
									-45.38281250000006
								],
								[
									-73.26621093749995,
									-45.34619140625006
								],
								[
									-73.20234375000001,
									-45.35380859375
								],
								[
									-72.978173828125,
									-45.45117187500003
								],
								[
									-72.933837890625,
									-45.45234375000001
								],
								[
									-72.94082031250002,
									-45.417285156249974
								],
								[
									-72.97553710937498,
									-45.392578124999915
								],
								[
									-73.06386718749994,
									-45.35976562499998
								],
								[
									-73.22636718750002,
									-45.25517578124999
								],
								[
									-73.44497070312497,
									-45.23818359374998
								],
								[
									-73.40488281249995,
									-45.10234375000002
								],
								[
									-73.36245117187502,
									-44.978222656250054
								],
								[
									-73.2564453125,
									-44.961035156250006
								],
								[
									-73.07841796874999,
									-44.92021484374996
								],
								[
									-72.73896484375001,
									-44.734179687500074
								],
								[
									-72.680078125,
									-44.593945312499926
								],
								[
									-72.66386718749999,
									-44.43642578124998
								],
								[
									-72.82753906250002,
									-44.39541015624998
								],
								[
									-73.00102539062502,
									-44.29238281249995
								],
								[
									-73.140966796875,
									-44.23750000000004
								],
								[
									-73.26508789062498,
									-44.16865234374997
								],
								[
									-73.24072265625,
									-44.06572265624996
								],
								[
									-73.22446289062498,
									-43.89794921875006
								],
								[
									-73.06879882812498,
									-43.862011718750026
								],
								[
									-72.99658203125,
									-43.63154296874997
								],
								[
									-73.10097656249997,
									-43.45517578124992
								],
								[
									-73.07597656250002,
									-43.32363281250002
								],
								[
									-72.93999023437502,
									-43.21132812499998
								],
								[
									-72.91547851562501,
									-43.13359375000003
								],
								[
									-72.87802734375,
									-43.04814453125003
								],
								[
									-72.75800781249998,
									-43.03945312500004
								],
								[
									-72.75537109374997,
									-42.992968750000074
								],
								[
									-72.76601562500002,
									-42.90820312500004
								],
								[
									-72.84497070312503,
									-42.80800781250005
								],
								[
									-72.84804687500002,
									-42.66914062500001
								],
								[
									-72.77392578125003,
									-42.50517578125
								],
								[
									-72.65483398437502,
									-42.516601562500014
								],
								[
									-72.63183593750003,
									-42.50966796875002
								],
								[
									-72.71630859375,
									-42.41044921875006
								],
								[
									-72.78515625,
									-42.30126953125003
								],
								[
									-72.77324218749999,
									-42.25771484375004
								],
								[
									-72.70737304687498,
									-42.22050781250009
								],
								[
									-72.63105468749995,
									-42.19980468749996
								],
								[
									-72.5484375,
									-42.255761718749994
								],
								[
									-72.4302734375,
									-42.433886718750045
								],
								[
									-72.412353515625,
									-42.38818359374997
								],
								[
									-72.46010742187497,
									-42.206640624999935
								],
								[
									-72.49941406249997,
									-41.98085937500002
								],
								[
									-72.62397460937495,
									-42.01054687500003
								],
								[
									-72.73818359375002,
									-41.994628906249986
								],
								[
									-72.78120117187501,
									-41.95957031250005
								],
								[
									-72.82407226562503,
									-41.908789062500006
								],
								[
									-72.783837890625,
									-41.84677734375006
								],
								[
									-72.74370117187499,
									-41.80058593749999
								],
								[
									-72.65986328124998,
									-41.742480468750045
								],
								[
									-72.48603515624998,
									-41.72207031249998
								],
								[
									-72.36040039062499,
									-41.64912109375004
								],
								[
									-72.31826171875002,
									-41.499023437500014
								],
								[
									-72.35947265624998,
									-41.51386718750001
								],
								[
									-72.42773437500003,
									-41.645898437499994
								],
								[
									-72.54238281250002,
									-41.69062499999997
								],
								[
									-72.60083007812503,
									-41.68408203125006
								],
								[
									-72.66977539062503,
									-41.659375
								],
								[
									-72.80512695312498,
									-41.54433593750001
								],
								[
									-72.87998046874995,
									-41.51757812500006
								],
								[
									-72.95283203124998,
									-41.51474609375002
								],
								[
									-73.01499023437503,
									-41.54384765624991
								],
								[
									-73.174072265625,
									-41.74658203125
								],
								[
									-73.24179687499995,
									-41.78085937500005
								],
								[
									-73.52128906249996,
									-41.79707031249998
								],
								[
									-73.62402343750003,
									-41.7736328125
								],
								[
									-73.73515625000002,
									-41.742480468750045
								],
								[
									-73.72187499999998,
									-41.69248046874999
								],
								[
									-73.6880859375,
									-41.63925781250006
								],
								[
									-73.62504882812496,
									-41.61191406249992
								],
								[
									-73.62392578125,
									-41.58134765625009
								],
								[
									-73.71064453124998,
									-41.57363281249994
								],
								[
									-73.81074218749995,
									-41.51748046875004
								],
								[
									-73.85502929687502,
									-41.44638671874995
								],
								[
									-73.87617187499995,
									-41.3193359375
								],
								[
									-73.96586914062493,
									-41.11826171875006
								],
								[
									-73.98359375000001,
									-40.974316406250054
								],
								[
									-73.9203125,
									-40.871582031249986
								],
								[
									-73.78403320312503,
									-40.468457031250026
								],
								[
									-73.74248046874999,
									-40.26298828125009
								],
								[
									-73.66943359375003,
									-40.082324218750045
								],
								[
									-73.67099609375,
									-39.96318359375002
								],
								[
									-73.48222656249999,
									-39.85429687499996
								],
								[
									-73.41040039062503,
									-39.789160156250006
								],
								[
									-73.24990234375,
									-39.42236328125007
								],
								[
									-73.22646484375002,
									-39.22441406250006
								],
								[
									-73.48076171874996,
									-38.62402343750004
								],
								[
									-73.52021484375001,
									-38.50937500000005
								],
								[
									-73.53256835937503,
									-38.36679687499996
								],
								[
									-73.47187499999993,
									-38.130078125000054
								],
								[
									-73.46479492187501,
									-38.04033203125006
								],
								[
									-73.51674804687502,
									-37.910546874999994
								],
								[
									-73.66181640624998,
									-37.69853515625006
								],
								[
									-73.66459960937493,
									-37.59042968750006
								],
								[
									-73.60341796875,
									-37.47910156249995
								],
								[
									-73.66240234375002,
									-37.341015625000054
								],
								[
									-73.63364257812503,
									-37.255468750000034
								],
								[
									-73.60166015625,
									-37.18847656250007
								],
								[
									-73.37456054687499,
									-37.22431640625008
								],
								[
									-73.27109374999998,
									-37.20742187500002
								],
								[
									-73.21596679687502,
									-37.16689453124994
								],
								[
									-73.17285156250003,
									-37.05351562499993
								],
								[
									-73.15126953125,
									-36.87617187500004
								],
								[
									-73.13779296875,
									-36.799902343750034
								],
								[
									-73.11806640624997,
									-36.68837890625005
								],
								[
									-73.006591796875,
									-36.64345703125005
								],
								[
									-72.96782226562502,
									-36.537792968750026
								],
								[
									-72.87456054687502,
									-36.39042968750002
								],
								[
									-72.77841796874998,
									-35.97851562500003
								],
								[
									-72.68339843749996,
									-35.87695312500004
								],
								[
									-72.58735351562495,
									-35.75966796874995
								],
								[
									-72.62392578125002,
									-35.585742187500045
								],
								[
									-72.56206054687493,
									-35.505371093750014
								],
								[
									-72.50517578124999,
									-35.44697265625001
								],
								[
									-72.45498046874997,
									-35.34082031250006
								],
								[
									-72.38671875,
									-35.24042968750004
								],
								[
									-72.22377929687494,
									-35.09619140625004
								],
								[
									-72.18242187499996,
									-34.92021484374999
								],
								[
									-72.05595703124996,
									-34.61582031249998
								],
								[
									-72.03076171874997,
									-34.42050781249998
								],
								[
									-71.99150390624996,
									-34.28847656250008
								],
								[
									-72.00283203124997,
									-34.16533203125003
								],
								[
									-71.92685546875003,
									-34.015624999999915
								],
								[
									-71.85395507812501,
									-33.889550781250065
								],
								[
									-71.83095703124994,
									-33.81953125000001
								],
								[
									-71.66435546875002,
									-33.65263671875003
								],
								[
									-71.63627929687499,
									-33.51923828125004
								],
								[
									-71.69550781249998,
									-33.42900390625003
								],
								[
									-71.69658203125002,
									-33.28906250000004
								],
								[
									-71.74296874999996,
									-33.095117187499966
								],
								[
									-71.63554687500002,
									-33.022558593750006
								],
								[
									-71.59204101562503,
									-32.96953124999996
								],
								[
									-71.45224609374998,
									-32.65957031250005
								],
								[
									-71.46142578124997,
									-32.53789062500003
								],
								[
									-71.42128906249997,
									-32.38681640625008
								],
								[
									-71.513037109375,
									-32.20791015625005
								],
								[
									-71.52587890624997,
									-31.805859375000026
								],
								[
									-71.57729492187497,
									-31.496386718750045
								],
								[
									-71.66196289062498,
									-31.169531250000063
								],
								[
									-71.65390625000003,
									-30.986621093749932
								],
								[
									-71.7056640625,
									-30.759277343750057
								],
								[
									-71.70893554687495,
									-30.628027343750063
								],
								[
									-71.66948242187499,
									-30.33037109374999
								],
								[
									-71.40039062499997,
									-30.14296875000001
								],
								[
									-71.34804687499997,
									-29.933203125000077
								],
								[
									-71.31572265624996,
									-29.64970703125006
								],
								[
									-71.32670898437499,
									-29.443164062500074
								],
								[
									-71.35327148437497,
									-29.350390625000003
								],
								[
									-71.48583984374997,
									-29.1982421875
								],
								[
									-71.51923828124995,
									-28.926464843750054
								],
								[
									-71.49360351562495,
									-28.85527343750003
								],
								[
									-71.38408203124993,
									-28.778710937500065
								],
								[
									-71.30673828125,
									-28.67246093749992
								],
								[
									-71.26684570312494,
									-28.507519531250068
								],
								[
									-71.18642578125,
									-28.377832031249937
								],
								[
									-71.15449218749998,
									-28.064062499999963
								],
								[
									-71.08652343749998,
									-27.814453124999915
								],
								[
									-71.05263671875,
									-27.727343749999932
								],
								[
									-70.94580078125,
									-27.61787109375001
								],
								[
									-70.92578125,
									-27.588671875000003
								],
								[
									-70.90927734375003,
									-27.505175781250045
								],
								[
									-70.91425781249998,
									-27.307910156250003
								],
								[
									-70.89790039062501,
									-27.187499999999986
								],
								[
									-70.81274414062497,
									-26.950585937500037
								],
								[
									-70.80292968749993,
									-26.84091796874999
								],
								[
									-70.70839843749997,
									-26.59697265625003
								],
								[
									-70.68696289062493,
									-26.42177734375005
								],
								[
									-70.64658203124998,
									-26.32939453125006
								],
								[
									-70.66225585937497,
									-26.225390625000003
								],
								[
									-70.63544921875001,
									-25.99267578125003
								],
								[
									-70.69960937500002,
									-25.861132812500045
								],
								[
									-70.71372070312498,
									-25.7841796875
								],
								[
									-70.63300781249995,
									-25.545605468750068
								],
								[
									-70.57812499999997,
									-25.48750000000004
								],
								[
									-70.48950195312503,
									-25.37646484375007
								],
								[
									-70.45219726562499,
									-25.251855468749994
								],
								[
									-70.44536132812502,
									-25.172656249999946
								],
								[
									-70.55864257812499,
									-24.77851562499994
								],
								[
									-70.57412109374997,
									-24.64433593749996
								],
								[
									-70.54643554687499,
									-24.33164062500002
								],
								[
									-70.50742187499995,
									-24.129687499999918
								],
								[
									-70.52006835937496,
									-23.96855468750003
								],
								[
									-70.50742187499995,
									-23.885742187499957
								],
								[
									-70.48779296874994,
									-23.781738281249986
								],
								[
									-70.40996093749999,
									-23.65556640624996
								],
								[
									-70.39233398437494,
									-23.565917968749986
								],
								[
									-70.41962890625001,
									-23.52851562500001
								],
								[
									-70.511962890625,
									-23.482812499999937
								],
								[
									-70.58813476562497,
									-23.368359375000068
								],
								[
									-70.59335937499998,
									-23.255468750000063
								],
								[
									-70.56884765625003,
									-23.17333984375003
								],
								[
									-70.56318359374995,
									-23.05703125000005
								],
								[
									-70.44965820312501,
									-23.034179687500014
								],
								[
									-70.38916015625003,
									-22.96962890625001
								],
								[
									-70.33168945312494,
									-22.848632812500057
								],
								[
									-70.259521484375,
									-22.556054687500037
								],
								[
									-70.22851562499997,
									-22.193164062500003
								],
								[
									-70.18544921875,
									-21.974609374999986
								],
								[
									-70.15507812499993,
									-21.86660156250001
								],
								[
									-70.12958984374998,
									-21.64082031250001
								],
								[
									-70.08754882812494,
									-21.493066406249937
								],
								[
									-70.08002929687501,
									-21.356835937500065
								],
								[
									-70.08837890625003,
									-21.253222656250003
								],
								[
									-70.19702148437494,
									-20.72539062500003
								],
								[
									-70.19365234374999,
									-20.53144531250004
								],
								[
									-70.14746093749997,
									-20.229785156250045
								],
								[
									-70.14814453124995,
									-19.80507812499995
								],
								[
									-70.15742187499998,
									-19.70585937499999
								],
								[
									-70.19833984374995,
									-19.612988281250068
								],
								[
									-70.21040039062501,
									-19.48691406250005
								],
								[
									-70.27578125000002,
									-19.267578125000043
								],
								[
									-70.33486328124997,
									-18.82753906250001
								],
								[
									-70.33608398437497,
									-18.59521484375003
								],
								[
									-70.36162109375002,
									-18.398046875000006
								],
								[
									-70.41826171874999,
									-18.34560546874998
								],
								[
									-70.37749023437496,
									-18.33359375000002
								],
								[
									-70.28227539062502,
									-18.325390625000026
								],
								[
									-70.18378906250001,
									-18.325195312499986
								],
								[
									-70.05908203125,
									-18.283496093750017
								],
								[
									-69.92636718749998,
									-18.20605468749997
								],
								[
									-69.83969726562498,
									-18.093457031250026
								],
								[
									-69.80258789062498,
									-17.990234374999957
								],
								[
									-69.80244140624995,
									-17.899999999999963
								],
								[
									-69.84150390625001,
									-17.785156250000014
								],
								[
									-69.85209960937493,
									-17.70380859374997
								],
								[
									-69.80610351562498,
									-17.664941406250037
								],
								[
									-69.68476562499995,
									-17.64980468749998
								],
								[
									-69.58642578125,
									-17.573242187500014
								],
								[
									-69.51093749999998,
									-17.506054687499997
								],
								[
									-69.49501953125002,
									-17.619531250000023
								],
								[
									-69.3580078125,
									-17.77167968749994
								],
								[
									-69.31337890624997,
									-17.94316406249996
								],
								[
									-69.28232421874995,
									-17.96484375000003
								],
								[
									-69.09394531249993,
									-18.050488281249983
								],
								[
									-69.09042968749992,
									-18.07070312500001
								],
								[
									-69.11806640624997,
									-18.10273437499997
								],
								[
									-69.14545898437495,
									-18.14404296875003
								],
								[
									-69.12636718749997,
									-18.202441406249946
								],
								[
									-69.09228515624994,
									-18.282421874999983
								],
								[
									-69.08095703124997,
									-18.356640624999997
								],
								[
									-69.06015624999998,
									-18.433007812500023
								],
								[
									-69.03940429687492,
									-18.550097656249974
								],
								[
									-69.02680664062493,
									-18.65625000000003
								],
								[
									-68.97885742187495,
									-18.812988281249986
								],
								[
									-68.969091796875,
									-18.909667968749957
								],
								[
									-68.96831054687502,
									-18.96796874999994
								],
								[
									-68.93100585937495,
									-19.02519531249996
								],
								[
									-68.85795898437499,
									-19.09335937499999
								],
								[
									-68.75908203125002,
									-19.162207031249977
								],
								[
									-68.68066406250003,
									-19.24238281249997
								],
								[
									-68.62055664062495,
									-19.296679687500017
								],
								[
									-68.54785156249997,
									-19.341113281249932
								],
								[
									-68.49199218749996,
									-19.381933593749977
								],
								[
									-68.47016601562495,
									-19.409960937500003
								],
								[
									-68.46289062499997,
									-19.43281250000004
								],
								[
									-68.48701171875001,
									-19.454394531249918
								],
								[
									-68.57529296874998,
									-19.560156249999963
								],
								[
									-68.69829101562499,
									-19.72109374999998
								],
								[
									-68.69619140625,
									-19.740722656249986
								],
								[
									-68.57827148437497,
									-19.856542968750034
								],
								[
									-68.55937500000002,
									-19.902343749999957
								],
								[
									-68.56069335937502,
									-19.967089843749918
								],
								[
									-68.60019531249998,
									-20.044921874999957
								],
								[
									-68.72749023437498,
									-20.069628906250017
								],
								[
									-68.75581054687498,
									-20.090820312499986
								],
								[
									-68.75932617187499,
									-20.11552734374996
								],
								[
									-68.73002929687496,
									-20.148437499999915
								],
								[
									-68.73457031250001,
									-20.22519531249992
								],
								[
									-68.68857421874995,
									-20.31005859374997
								],
								[
									-68.7123046875,
									-20.338964843750006
								],
								[
									-68.75922851562495,
									-20.378027343749963
								],
								[
									-68.76054687499996,
									-20.41621093750001
								],
								[
									-68.74516601562493,
									-20.458593750000034
								],
								[
									-68.69580078125,
									-20.492968750000017
								],
								[
									-68.49985351562498,
									-20.612011718750026
								],
								[
									-68.48432617187501,
									-20.62841796875
								],
								[
									-68.48740234375,
									-20.64072265625002
								],
								[
									-68.56318359374998,
									-20.720117187500023
								],
								[
									-68.571044921875,
									-20.769140624999977
								],
								[
									-68.5689453125,
									-20.849804687499983
								],
								[
									-68.55825195312497,
									-20.90195312499995
								],
								[
									-68.53383789062497,
									-20.923632812500003
								],
								[
									-68.43549804687501,
									-20.948242187499957
								],
								[
									-68.3138671875,
									-21.129687499999974
								],
								[
									-68.197021484375,
									-21.30029296875
								],
								[
									-68.19853515624996,
									-21.447265625000014
								],
								[
									-68.18642578124997,
									-21.618554687499923
								],
								[
									-68.11215820312495,
									-21.753027343749963
								],
								[
									-68.10180664062497,
									-21.86064453125003
								],
								[
									-68.07675781249992,
									-21.982812499999966
								],
								[
									-67.98837890624995,
									-22.05712890625
								],
								[
									-67.95390624999993,
									-22.204003906249994
								],
								[
									-67.94492187499998,
									-22.28222656250003
								],
								[
									-67.95039062499993,
									-22.333691406249955
								],
								[
									-67.88173828125,
									-22.49335937499997
								],
								[
									-67.87373046874995,
									-22.63056640625004
								],
								[
									-67.88999023437498,
									-22.72919921874997
								],
								[
									-67.88916015624997,
									-22.78417968749997
								],
								[
									-67.87944335937496,
									-22.82294921874997
								],
								[
									-67.82050781249995,
									-22.85771484375003
								],
								[
									-67.79443359374997,
									-22.87949218749995
								],
								[
									-67.70732421874999,
									-22.889160156249957
								],
								[
									-67.57993164062495,
									-22.89169921874995
								],
								[
									-67.36225585937493,
									-22.85517578124997
								],
								[
									-67.19487304687493,
									-22.821679687500065
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "CHL",
					"su_a3": "CHL",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "CHL",
					"gu_a3": "CHL",
					"abbrev": "Chile",
					"region_un": "Americas",
					"adm0_a3_us": "CHL",
					"scalerank": 1,
					"pop_est": 16601707,
					"adm0_dif": 0,
					"un_a3": "152",
					"pop_year": -99,
					"gdp_md_est": 244500,
					"name": "Chile",
					"sovereignt": "Chile",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Chile",
					"postal": "CL",
					"sov_a3": "CHL",
					"note_brk": "",
					"brk_a3": "CHL",
					"wb_a2": "CL",
					"brk_diff": 0,
					"admin": "Chile",
					"name_long": "Chile",
					"iso_a3": "CHL",
					"iso_a2": "CL",
					"adm0_a3_is": "CHL",
					"level": 2,
					"formal_en": "Republic of Chile",
					"name_len": 5,
					"mapcolor7": 5,
					"long_len": 5,
					"mapcolor8": 1,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "152",
					"homepart": 1,
					"subunit": "Chile",
					"name_alt": "",
					"brk_name": "Chile",
					"name_sort": "Chile",
					"continent": "South America",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2002
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									110.88876953125009,
									19.991943359374943
								],
								[
									110.93828125000005,
									19.94755859374996
								],
								[
									110.970703125,
									19.883300781250114
								],
								[
									110.99765625000003,
									19.764697265625017
								],
								[
									111.01367187500011,
									19.655468750000068
								],
								[
									110.91269531250003,
									19.58608398437505
								],
								[
									110.82226562500011,
									19.55791015624999
								],
								[
									110.64091796875005,
									19.29121093750001
								],
								[
									110.60312500000003,
									19.20703125
								],
								[
									110.57216796875014,
									19.171874999999943
								],
								[
									110.56249999999994,
									19.135156250000108
								],
								[
									110.56601562500003,
									19.098535156250108
								],
								[
									110.51933593750005,
									18.970214843750085
								],
								[
									110.47763671875009,
									18.81259765625012
								],
								[
									110.4512695312502,
									18.747949218749994
								],
								[
									110.39951171875003,
									18.69833984375012
								],
								[
									110.33369140625007,
									18.673291015625068
								],
								[
									110.29082031250005,
									18.669531250000006
								],
								[
									110.25175781250016,
									18.655761718750057
								],
								[
									110.15624999999994,
									18.569824218749943
								],
								[
									110.04853515625007,
									18.50522460937512
								],
								[
									110.06640624999994,
									18.47563476562513
								],
								[
									110.0673828125,
									18.447558593750074
								],
								[
									110.02021484375007,
									18.416259765625114
								],
								[
									109.96767578125002,
									18.422070312499955
								],
								[
									109.81562500000001,
									18.39667968750001
								],
								[
									109.75976562500011,
									18.348291015624937
								],
								[
									109.7027343750002,
									18.259130859374977
								],
								[
									109.68105468750014,
									18.247119140625017
								],
								[
									109.58955078125007,
									18.226318359375057
								],
								[
									109.51933593750016,
									18.21826171875
								],
								[
									109.40009765625018,
									18.28110351562509
								],
								[
									109.3409179687502,
									18.29960937499996
								],
								[
									109.18320312500003,
									18.325146484374926
								],
								[
									109.02988281250009,
									18.36777343750009
								],
								[
									108.92226562500002,
									18.416113281250063
								],
								[
									108.70156249999997,
									18.535253906250006
								],
								[
									108.67607421875005,
									18.75024414062503
								],
								[
									108.63808593750014,
									18.86630859374995
								],
								[
									108.63564453124997,
									18.90771484375003
								],
								[
									108.65000000000003,
									19.265039062500108
								],
								[
									108.66552734375011,
									19.304101562499966
								],
								[
									108.69355468750007,
									19.338281250000108
								],
								[
									108.79101562500011,
									19.41816406250004
								],
								[
									108.90283203124994,
									19.481347656250023
								],
								[
									109.06289062499997,
									19.61357421874996
								],
								[
									109.17910156250014,
									19.67412109375013
								],
								[
									109.27666015624999,
									19.761132812499994
								],
								[
									109.21953124999999,
									19.757470703124966
								],
								[
									109.17744140625001,
									19.76845703125008
								],
								[
									109.21894531250007,
									19.84282226562513
								],
								[
									109.26347656250016,
									19.882666015624977
								],
								[
									109.31484375000014,
									19.904394531250063
								],
								[
									109.41816406250007,
									19.88881835937508
								],
								[
									109.51367187499994,
									19.90424804687501
								],
								[
									109.58427734375016,
									19.970312499999977
								],
								[
									109.65136718749994,
									19.984375
								],
								[
									109.90625000000011,
									19.96274414062495
								],
								[
									110.08300781249994,
									19.99291992187497
								],
								[
									110.17158203125018,
									20.053710937500085
								],
								[
									110.21337890624994,
									20.05605468750005
								],
								[
									110.34394531250018,
									20.038818359375085
								],
								[
									110.39228515625018,
									19.975585937500085
								],
								[
									110.38798828124999,
									20.018017578124926
								],
								[
									110.3935546875,
									20.05922851562508
								],
								[
									110.4175781250002,
									20.054736328125045
								],
								[
									110.58818359375005,
									19.976367187500074
								],
								[
									110.58876953124997,
									20.07246093750001
								],
								[
									110.59833984375007,
									20.097607421874983
								],
								[
									110.65175781250002,
									20.13774414062499
								],
								[
									110.67851562500016,
									20.13706054687512
								],
								[
									110.74453125000002,
									20.059472656249937
								],
								[
									110.80908203125011,
									20.014404296875085
								],
								[
									110.88876953125009,
									19.991943359374943
								]
							]
						],
						[
							[
								[
									110.38515625000014,
									21.093164062499937
								],
								[
									110.42236328125011,
									21.05859375
								],
								[
									110.52158203125003,
									21.08310546875012
								],
								[
									110.53955078125,
									21.039013671874926
								],
								[
									110.53886718750005,
									21.018457031249994
								],
								[
									110.50390625000011,
									20.967724609375068
								],
								[
									110.421875,
									21.006884765625045
								],
								[
									110.33994140625009,
									20.997753906249955
								],
								[
									110.28095703125007,
									21.00117187500004
								],
								[
									110.26464843750011,
									21.025195312500045
								],
								[
									110.30986328124999,
									21.074755859375102
								],
								[
									110.38515625000014,
									21.093164062499937
								]
							]
						],
						[
							[
								[
									112.64375000000001,
									21.639648437500085
								],
								[
									112.54560546875001,
									21.618505859375034
								],
								[
									112.52500000000009,
									21.623046875000057
								],
								[
									112.55898437499997,
									21.67475585937504
								],
								[
									112.64765625000001,
									21.710253906250074
								],
								[
									112.64375000000001,
									21.639648437500085
								]
							]
						],
						[
							[
								[
									112.79023437500001,
									21.601855468750017
								],
								[
									112.7710937500002,
									21.581835937500017
								],
								[
									112.74199218750016,
									21.618066406249937
								],
								[
									112.7334960937502,
									21.66992187500003
								],
								[
									112.71269531250005,
									21.69794921875004
								],
								[
									112.76054687500005,
									21.733251953125063
								],
								[
									112.78203125000016,
									21.772265625000102
								],
								[
									112.83906250000001,
									21.76450195312512
								],
								[
									112.86259765625005,
									21.752636718750097
								],
								[
									112.81259765625003,
									21.712158203125114
								],
								[
									112.80068359375014,
									21.69487304687496
								],
								[
									112.79023437500001,
									21.601855468750017
								]
							]
						],
						[
							[
								[
									113.5552734375002,
									22.80419921875
								],
								[
									113.56367187500001,
									22.75791015625009
								],
								[
									113.48564453125005,
									22.82832031250004
								],
								[
									113.46337890625011,
									22.832373046875063
								],
								[
									113.42607421875016,
									22.858593749999983
								],
								[
									113.4043945312502,
									22.90283203125003
								],
								[
									113.46494140625009,
									22.904541015625114
								],
								[
									113.52050781250011,
									22.852050781250085
								],
								[
									113.5552734375002,
									22.80419921875
								]
							]
						],
						[
							[
								[
									118.18300781250002,
									24.49628906250004
								],
								[
									118.1495117187502,
									24.436132812500034
								],
								[
									118.09052734375018,
									24.44614257812512
								],
								[
									118.08876953124997,
									24.48886718750012
								],
								[
									118.0767578125002,
									24.50141601562501
								],
								[
									118.09296875000007,
									24.54121093750004
								],
								[
									118.10380859375005,
									24.55234375000009
								],
								[
									118.17070312500016,
									24.51850585937501
								],
								[
									118.18300781250002,
									24.49628906250004
								]
							]
						],
						[
							[
								[
									119.82089843750009,
									25.456982421875068
								],
								[
									119.74667968750003,
									25.410693359375074
								],
								[
									119.7002929687502,
									25.43271484375012
								],
								[
									119.69941406250001,
									25.49472656249995
								],
								[
									119.72304687500014,
									25.55058593749996
								],
								[
									119.69599609375001,
									25.590869140625102
								],
								[
									119.72255859375014,
									25.638818359374994
								],
								[
									119.7779296875002,
									25.65317382812509
								],
								[
									119.7974609375002,
									25.62324218750001
								],
								[
									119.82871093750009,
									25.607373046874983
								],
								[
									119.83837890625011,
									25.59106445312503
								],
								[
									119.83867187500016,
									25.55966796874995
								],
								[
									119.80908203125,
									25.507812500000057
								],
								[
									119.83242187500014,
									25.479589843749977
								],
								[
									119.82089843750009,
									25.456982421875068
								]
							]
						],
						[
							[
								[
									121.25136718750002,
									28.086425781250114
								],
								[
									121.16425781250001,
									28.062499999999943
								],
								[
									121.13154296875001,
									28.062597656250063
								],
								[
									121.13398437500018,
									28.135253906250114
								],
								[
									121.20546874999997,
									28.204394531250074
								],
								[
									121.23437500000011,
									28.18129882812508
								],
								[
									121.25097656250011,
									28.14521484375001
								],
								[
									121.25136718750002,
									28.086425781250114
								]
							]
						],
						[
							[
								[
									122.17255859375018,
									29.679003906249932
								],
								[
									122.1690429687502,
									29.66025390625012
								],
								[
									122.08378906250005,
									29.725341796875057
								],
								[
									122.04267578125001,
									29.735937499999977
								],
								[
									122.06230468749999,
									29.772753906249932
								],
								[
									122.11962890624994,
									29.7822265625
								],
								[
									122.1650390625,
									29.70078125000009
								],
								[
									122.17255859375018,
									29.679003906249932
								]
							]
						],
						[
							[
								[
									122.40390625000009,
									29.892382812500045
								],
								[
									122.39404296875011,
									29.84609375000005
								],
								[
									122.36757812500014,
									29.852685546874966
								],
								[
									122.33183593750005,
									29.934960937499937
								],
								[
									122.35097656250014,
									29.95522460937508
								],
								[
									122.40156250000001,
									29.950244140625045
								],
								[
									122.40390625000009,
									29.892382812500045
								]
							]
						],
						[
							[
								[
									122.29589843750011,
									29.96342773437496
								],
								[
									122.28154296874999,
									29.94384765624997
								],
								[
									122.1578125000002,
									30.001269531250045
								],
								[
									122.0240234375002,
									30.013330078125108
								],
								[
									121.97783203125005,
									30.06381835937509
								],
								[
									121.96943359375001,
									30.143115234375074
								],
								[
									122.11054687500018,
									30.139746093750006
								],
								[
									122.28447265625016,
									30.06801757812505
								],
								[
									122.32226562499994,
									30.03139648437505
								],
								[
									122.29589843750011,
									29.96342773437496
								]
							]
						],
						[
							[
								[
									121.86269531250014,
									31.49228515624995
								],
								[
									121.78046875000007,
									31.46376953125008
								],
								[
									121.51992187500002,
									31.54960937499999
								],
								[
									121.33642578125011,
									31.643749999999983
								],
								[
									121.22685546875016,
									31.758105468750017
								],
								[
									121.21113281250018,
									31.80537109375004
								],
								[
									121.3389648437502,
									31.797363281250114
								],
								[
									121.46416015624999,
									31.756445312500034
								],
								[
									121.49179687500003,
									31.693652343750017
								],
								[
									121.54228515625005,
									31.673925781250006
								],
								[
									121.57656250000002,
									31.637304687500006
								],
								[
									121.80830078125007,
									31.55214843750008
								],
								[
									121.84365234374997,
									31.526367187500057
								],
								[
									121.86269531250014,
									31.49228515624995
								]
							]
						],
						[
							[
								[
									132.80953302719712,
									45.066034444547995
								],
								[
									132.80820312500003,
									45.148779296875006
								],
								[
									132.72519531250003,
									45.23007812500006
								],
								[
									132.57949218750002,
									45.296240234375034
								],
								[
									132.4019531250001,
									45.328955078125034
								],
								[
									132.23017578125007,
									45.32841796875002
								],
								[
									132.0710937500001,
									45.28681640624998
								],
								[
									132.02378418738732,
									45.23471998242755
								],
								[
									131.9775390625001,
									45.24399414062506
								],
								[
									131.9092773437501,
									45.273730468750074
								],
								[
									131.85185546875,
									45.32685546875007
								],
								[
									131.79492187499994,
									45.305273437500006
								],
								[
									131.74208984375014,
									45.24262695312504
								],
								[
									131.65400390625,
									45.205371093750074
								],
								[
									131.61396484375,
									45.13657226562509
								],
								[
									131.57871093750003,
									45.08364257812508
								],
								[
									131.4875,
									45.0131347656251
								],
								[
									131.4468750000002,
									44.98403320312494
								],
								[
									131.26826171875,
									44.93613281249995
								],
								[
									131.22792968749997,
									44.92016601562506
								],
								[
									131.08232421875,
									44.91000976562495
								],
								[
									131.03300781250016,
									44.8888671875001
								],
								[
									130.98164062500018,
									44.84433593750006
								],
								[
									130.9677734375001,
									44.79995117187508
								],
								[
									131.0039062500001,
									44.75322265624999
								],
								[
									131.0606445312502,
									44.65966796875003
								],
								[
									131.08691406249994,
									44.59565429687504
								],
								[
									131.12578125000016,
									44.46918945312504
								],
								[
									131.25527343749997,
									44.07158203125002
								],
								[
									131.21328125000014,
									44.002929687500085
								],
								[
									131.17421874999997,
									43.70473632812508
								],
								[
									131.1835937500001,
									43.65087890624994
								],
								[
									131.18007812500002,
									43.567089843749926
								],
								[
									131.18242187500016,
									43.5055664062501
								],
								[
									131.20917968750018,
									43.49042968750004
								],
								[
									131.24394531250016,
									43.46904296874993
								],
								[
									131.26181640625003,
									43.43305664062507
								],
								[
									131.2573242187501,
									43.378076171874966
								],
								[
									131.2393554687502,
									43.337646484375085
								],
								[
									131.2119140625001,
									43.25776367187507
								],
								[
									131.17558593750016,
									43.142187500000034
								],
								[
									131.135546875,
									43.09760742187501
								],
								[
									131.1089843750002,
									43.06245117187507
								],
								[
									131.08613281250007,
									43.03808593749997
								],
								[
									131.08349609374994,
									42.956298828125114
								],
								[
									131.0685546875,
									42.90224609375011
								],
								[
									131.00556640625018,
									42.88310546874993
								],
								[
									130.9428710937501,
									42.85175781250004
								],
								[
									130.86855468750014,
									42.86333007812499
								],
								[
									130.8033203125001,
									42.856835937499994
								],
								[
									130.72246093750016,
									42.83583984375008
								],
								[
									130.57724609375003,
									42.81162109375012
								],
								[
									130.49296875,
									42.779101562500074
								],
								[
									130.4527343750001,
									42.755419921875045
								],
								[
									130.4248046875,
									42.72705078125003
								],
								[
									130.41992187499994,
									42.699853515624994
								],
								[
									130.4392578125,
									42.685546875000085
								],
								[
									130.52060546875003,
									42.67431640624994
								],
								[
									130.57656249999997,
									42.623242187499926
								],
								[
									130.5844726562501,
									42.5673339843751
								],
								[
									130.5269531250002,
									42.53540039062497
								],
								[
									130.4982421875,
									42.570507812499926
								],
								[
									130.4502929687502,
									42.58168945312508
								],
								[
									130.36074218749997,
									42.63085937499997
								],
								[
									130.29560546875,
									42.68496093750008
								],
								[
									130.2466796875002,
									42.74482421875001
								],
								[
									130.248828125,
									42.87260742187502
								],
								[
									130.24033203125003,
									42.891796874999926
								],
								[
									130.15126953125014,
									42.917968750000114
								],
								[
									130.12480468750016,
									42.956005859374955
								],
								[
									130.0826171875001,
									42.97416992187502
								],
								[
									130.02226562500005,
									42.96259765625004
								],
								[
									129.97695312500014,
									42.97485351562497
								],
								[
									129.94121093750016,
									42.995654296875045
								],
								[
									129.8982421875,
									42.998144531250006
								],
								[
									129.86103515625007,
									42.96508789062503
								],
								[
									129.84150390625018,
									42.89423828124998
								],
								[
									129.77919921874997,
									42.77656249999998
								],
								[
									129.77343749999994,
									42.70546875000008
								],
								[
									129.74648437499997,
									42.60380859374996
								],
								[
									129.71972656249994,
									42.47500000000011
								],
								[
									129.6978515625002,
									42.44814453125005
								],
								[
									129.6279296875,
									42.44428710937507
								],
								[
									129.60390624999997,
									42.43588867187495
								],
								[
									129.56757812500007,
									42.39208984375
								],
								[
									129.52373046875,
									42.384667968749994
								],
								[
									129.48486328125,
									42.41030273437508
								],
								[
									129.42363281250005,
									42.43588867187495
								],
								[
									129.36582031250003,
									42.439208984375
								],
								[
									129.31367187500018,
									42.41357421875003
								],
								[
									129.2525390625001,
									42.357861328124955
								],
								[
									129.2177734375001,
									42.31269531249998
								],
								[
									129.20537109375016,
									42.27055664062493
								],
								[
									129.19550781250018,
									42.21845703125007
								],
								[
									129.13369140625014,
									42.16850585937502
								],
								[
									129.0772460937501,
									42.14238281249993
								],
								[
									128.96064453125,
									42.06879882812504
								],
								[
									128.9234375000001,
									42.03823242187494
								],
								[
									128.8398437500001,
									42.03784179687494
								],
								[
									128.7490234375,
									42.040673828124994
								],
								[
									128.62675781250005,
									42.02084960937495
								],
								[
									128.42724609375,
									42.01074218750003
								],
								[
									128.30781250000018,
									42.02563476562494
								],
								[
									128.1601562500001,
									42.01162109374994
								],
								[
									128.04521484375016,
									41.9875000000001
								],
								[
									128.02871093749997,
									41.95161132812507
								],
								[
									128.03291015625,
									41.898486328125074
								],
								[
									128.05605468750014,
									41.863769531250114
								],
								[
									128.08417968750018,
									41.840576171875085
								],
								[
									128.13193359375003,
									41.769140625000006
								],
								[
									128.18173828125003,
									41.70004882812506
								],
								[
									128.2578125000001,
									41.655371093750006
								],
								[
									128.2892578125,
									41.607421875000114
								],
								[
									128.29091796875002,
									41.562792968750074
								],
								[
									128.25488281249994,
									41.50654296875007
								],
								[
									128.2002929687502,
									41.43300781250011
								],
								[
									128.14941406249994,
									41.38774414062493
								],
								[
									128.11123046875002,
									41.38925781249998
								],
								[
									128.052734375,
									41.41562500000012
								],
								[
									128.01308593749997,
									41.4486816406251
								],
								[
									127.91865234375001,
									41.46113281250004
								],
								[
									127.68769531250007,
									41.4399902343751
								],
								[
									127.57216796875014,
									41.454736328124994
								],
								[
									127.51699218749997,
									41.48173828124999
								],
								[
									127.42031250000002,
									41.48378906250005
								],
								[
									127.27080078125005,
									41.51982421874993
								],
								[
									127.17968750000011,
									41.53134765625006
								],
								[
									127.13671874999994,
									41.55454101562506
								],
								[
									127.12841796874994,
									41.607421875000114
								],
								[
									127.08535156249997,
									41.64379882812506
								],
								[
									127.06132812500016,
									41.68735351562495
								],
								[
									127.00693359375009,
									41.74204101562509
								],
								[
									126.95478515625001,
									41.76948242187498
								],
								[
									126.90351562500018,
									41.781054687500045
								],
								[
									126.84726562500009,
									41.74799804687504
								],
								[
									126.7876953125002,
									41.71821289062501
								],
								[
									126.74306640624997,
									41.72485351562506
								],
								[
									126.72158203125014,
									41.71655273437503
								],
								[
									126.69697265625018,
									41.691894531250085
								],
								[
									126.60126953125007,
									41.640966796875006
								],
								[
									126.57832031250018,
									41.594335937500006
								],
								[
									126.5401367187502,
									41.495556640624955
								],
								[
									126.51357421875014,
									41.39399414062504
								],
								[
									126.49042968750001,
									41.35805664062511
								],
								[
									126.45146484375016,
									41.35185546874999
								],
								[
									126.41181640625018,
									41.32133789062499
								],
								[
									126.3287109375002,
									41.225683593750034
								],
								[
									126.25361328125018,
									41.13779296875009
								],
								[
									126.14453125,
									41.07827148437502
								],
								[
									126.09316406250002,
									41.023681640625114
								],
								[
									126.06679687500014,
									40.97407226562504
								],
								[
									125.98906250000005,
									40.904638671875006
								],
								[
									125.87490234375014,
									40.892236328124966
								],
								[
									125.78398437500016,
									40.87202148437504
								],
								[
									125.72832031249999,
									40.866699218750085
								],
								[
									125.68828125000005,
									40.838671875000074
								],
								[
									125.65917968749994,
									40.79589843749997
								],
								[
									125.6451171875002,
									40.77895507812508
								],
								[
									125.59384765625003,
									40.77895507812508
								],
								[
									125.5425781250002,
									40.74257812500002
								],
								[
									125.41689453124997,
									40.65991210937506
								],
								[
									125.314453125,
									40.64462890624998
								],
								[
									125.18593750000002,
									40.5894042968751
								],
								[
									125.07294921875018,
									40.54746093750006
								],
								[
									125.0259765625002,
									40.52387695312507
								],
								[
									125.01337890625001,
									40.4978515625001
								],
								[
									124.99687500000005,
									40.46474609375011
								],
								[
									124.94228515625002,
									40.458154296874994
								],
								[
									124.88935546875018,
									40.45981445312498
								],
								[
									124.77197265624994,
									40.38374023437504
								],
								[
									124.71240234375,
									40.31923828124994
								],
								[
									124.4810546875002,
									40.18164062499997
								],
								[
									124.38662109375014,
									40.104248046875114
								],
								[
									124.36210937500005,
									40.00405273437502
								],
								[
									124.35000000000014,
									40.01157226562506
								],
								[
									124.26748046875014,
									39.92416992187509
								],
								[
									124.10576171875005,
									39.84101562500004
								],
								[
									123.76015624999997,
									39.82241210937508
								],
								[
									123.65087890625011,
									39.88159179687506
								],
								[
									123.61123046875002,
									39.8408203125
								],
								[
									123.58066406250009,
									39.78613281250006
								],
								[
									123.49003906249999,
									39.767871093750045
								],
								[
									123.34814453124994,
									39.76293945312494
								],
								[
									123.26894531249997,
									39.72690429687506
								],
								[
									123.2265625,
									39.68662109375012
								],
								[
									123.0322265625,
									39.67353515625001
								],
								[
									122.96093749999994,
									39.61992187499993
								],
								[
									122.84003906250018,
									39.60083007812506
								],
								[
									122.33486328125014,
									39.36611328125011
								],
								[
									122.22500000000014,
									39.26733398437506
								],
								[
									122.12089843750016,
									39.151904296875074
								],
								[
									122.04765625000016,
									39.093798828125045
								],
								[
									121.98232421874997,
									39.05317382812504
								],
								[
									121.92265625000016,
									39.03652343750011
								],
								[
									121.8643554687502,
									38.99648437499994
								],
								[
									121.80517578124994,
									38.99140625000007
								],
								[
									121.74482421875018,
									39.00966796875005
								],
								[
									121.67724609375,
									39.003417968750114
								],
								[
									121.63281250000011,
									38.95483398437497
								],
								[
									121.67041015625011,
									38.891796874999926
								],
								[
									121.64990234375011,
									38.86508789062509
								],
								[
									121.51718750000009,
									38.830761718749926
								],
								[
									121.32011718750016,
									38.80820312499995
								],
								[
									121.23632812499994,
									38.76694335937498
								],
								[
									121.20742187500014,
									38.74350585937509
								],
								[
									121.16357421875,
									38.73164062499998
								],
								[
									121.12167968750003,
									38.8132812500001
								],
								[
									121.10673828125005,
									38.920800781249966
								],
								[
									121.18828125000005,
									38.94667968750008
								],
								[
									121.26328125000003,
									38.96025390625002
								],
								[
									121.67988281250018,
									39.108691406250045
								],
								[
									121.62763671875001,
									39.22016601562504
								],
								[
									121.66455078125,
									39.26874999999998
								],
								[
									121.7578125,
									39.34755859375005
								],
								[
									121.81845703125009,
									39.38652343749999
								],
								[
									121.78544921874999,
									39.40083007812507
								],
								[
									121.51249999999999,
									39.37485351562509
								],
								[
									121.35566406250001,
									39.37680664062506
								],
								[
									121.27548828125003,
									39.384765625000085
								],
								[
									121.29980468750011,
									39.45219726562496
								],
								[
									121.28632812500001,
									39.51943359375008
								],
								[
									121.26748046875002,
									39.54467773437497
								],
								[
									121.40644531250018,
									39.62124023437494
								],
								[
									121.46953125000016,
									39.64013671874997
								],
								[
									121.517578125,
									39.638964843750074
								],
								[
									121.5142578125002,
									39.685253906249926
								],
								[
									121.4742187500002,
									39.754882812500085
								],
								[
									121.51738281250005,
									39.84482421875009
								],
								[
									121.80097656250018,
									39.95053710937506
								],
								[
									121.86894531250016,
									40.04638671875006
								],
								[
									121.98281249999997,
									40.13583984375006
								],
								[
									122.19091796875011,
									40.35825195312506
								],
								[
									122.20332031250007,
									40.39604492187496
								],
								[
									122.26386718750007,
									40.50019531250004
								],
								[
									122.2750000000002,
									40.54184570312509
								],
								[
									122.17871093750011,
									40.60273437500007
								],
								[
									122.14042968750005,
									40.68818359375007
								],
								[
									121.85878906250014,
									40.842089843750045
								],
								[
									121.83486328125014,
									40.97426757812508
								],
								[
									121.80859375000011,
									40.96850585937506
								],
								[
									121.76562499999994,
									40.87587890625011
								],
								[
									121.72929687500005,
									40.8461425781251
								],
								[
									121.59892578125005,
									40.843408203124966
								],
								[
									121.53710937499994,
									40.87841796875
								],
								[
									121.17451171875018,
									40.90126953125002
								],
								[
									121.08593749999994,
									40.84160156249996
								],
								[
									121.00292968750011,
									40.74912109374995
								],
								[
									120.92226562500002,
									40.68310546875
								],
								[
									120.84130859374994,
									40.64921874999993
								],
								[
									120.77070312500007,
									40.58906250000001
								],
								[
									120.47910156250003,
									40.230957031250085
								],
								[
									120.36894531249999,
									40.20385742187497
								],
								[
									119.85039062500016,
									39.98745117187494
								],
								[
									119.59111328125016,
									39.902636718750074
								],
								[
									119.39111328125011,
									39.752490234375045
								],
								[
									119.32236328125003,
									39.661621093750085
								],
								[
									119.26132812500003,
									39.56088867187509
								],
								[
									119.22460937500011,
									39.408056640625034
								],
								[
									119.0401367187502,
									39.22236328125004
								],
								[
									118.97695312500002,
									39.18256835937501
								],
								[
									118.91230468750018,
									39.16640625000008
								],
								[
									118.82646484374999,
									39.172119140625114
								],
								[
									118.75244140625011,
									39.16049804687495
								],
								[
									118.62636718750002,
									39.17685546875009
								],
								[
									118.47197265625016,
									39.118017578125006
								],
								[
									118.29785156249994,
									39.067089843749926
								],
								[
									118.14785156250014,
									39.19506835937506
								],
								[
									118.04091796875002,
									39.226757812499955
								],
								[
									117.86572265625011,
									39.191259765625006
								],
								[
									117.78466796875011,
									39.13447265624998
								],
								[
									117.61669921875011,
									38.85288085937509
								],
								[
									117.55380859375009,
									38.69145507812496
								],
								[
									117.55781250000018,
									38.62514648437505
								],
								[
									117.65605468750005,
									38.424218749999966
								],
								[
									117.7666992187502,
									38.31166992187505
								],
								[
									118.01494140625016,
									38.18339843749993
								],
								[
									118.54326171875005,
									38.09492187500004
								],
								[
									118.6670898437502,
									38.12636718750005
								],
								[
									118.80000000000001,
									38.12666015625001
								],
								[
									118.94003906250003,
									38.042773437500074
								],
								[
									119.02753906250001,
									37.90400390625004
								],
								[
									119.03564453125,
									37.80917968750009
								],
								[
									119.03847656250014,
									37.776513671874994
								],
								[
									119.07031250000011,
									37.74858398437499
								],
								[
									119.08916015625016,
									37.70073242187502
								],
								[
									119.03349609375016,
									37.66103515625011
								],
								[
									118.99082031250009,
									37.641357421875085
								],
								[
									118.95488281250016,
									37.494091796874926
								],
								[
									118.95263671875011,
									37.33115234374995
								],
								[
									118.99814453125009,
									37.27709960937494
								],
								[
									119.11181640624994,
									37.20117187500003
								],
								[
									119.28740234375005,
									37.13828125000009
								],
								[
									119.44990234375018,
									37.124755859375
								],
								[
									119.76054687500016,
									37.15507812499996
								],
								[
									119.88750000000016,
									37.2533691406251
								],
								[
									119.87998046875003,
									37.29580078124994
								],
								[
									119.8829101562502,
									37.35083007812506
								],
								[
									120.1558593750002,
									37.49501953124994
								],
								[
									120.31152343750011,
									37.62270507812511
								],
								[
									120.28710937500011,
									37.65649414062497
								],
								[
									120.25722656249997,
									37.67900390624993
								],
								[
									120.28466796875,
									37.69208984375004
								],
								[
									120.3701171875,
									37.70102539062498
								],
								[
									120.75000000000011,
									37.83393554687507
								],
								[
									121.04902343750018,
									37.72519531250012
								],
								[
									121.21953124999999,
									37.600146484375045
								],
								[
									121.38808593749997,
									37.57895507812498
								],
								[
									121.50527343750014,
									37.51503906250002
								],
								[
									121.6402343750002,
									37.46035156250008
								],
								[
									121.81640625000011,
									37.45664062500012
								],
								[
									121.96484374999994,
									37.44531250000003
								],
								[
									122.01015625000014,
									37.495751953124994
								],
								[
									122.05664062500011,
									37.52890625000009
								],
								[
									122.10957031250007,
									37.52231445312509
								],
								[
									122.16914062500001,
									37.456152343750006
								],
								[
									122.33769531250016,
									37.40527343749994
								],
								[
									122.49326171875003,
									37.40795898437506
								],
								[
									122.60234374999999,
									37.426416015624994
								],
								[
									122.66699218750011,
									37.402832031250085
								],
								[
									122.5733398437502,
									37.3179199218751
								],
								[
									122.58730468750014,
									37.181103515624926
								],
								[
									122.51552734374997,
									37.137841796874994
								],
								[
									122.44667968749997,
									37.068115234375
								],
								[
									122.4874023437502,
									37.02226562499999
								],
								[
									122.5234375,
									37.00263671874998
								],
								[
									122.51972656250001,
									36.94682617187499
								],
								[
									122.45703124999994,
									36.91513671875009
								],
								[
									122.3409179687502,
									36.8322265625001
								],
								[
									122.27421875000005,
									36.83383789062506
								],
								[
									122.2422851562502,
									36.84985351562494
								],
								[
									122.21972656250011,
									36.87954101562505
								],
								[
									122.20322265625003,
									36.92719726562498
								],
								[
									122.16240234375016,
									36.958642578124994
								],
								[
									122.04951171875018,
									36.970751953125074
								],
								[
									121.93271484375009,
									36.959472656250085
								],
								[
									121.66962890625007,
									36.836376953124955
								],
								[
									121.41308593750011,
									36.73837890624998
								],
								[
									121.14404296875,
									36.660449218750074
								],
								[
									121.05380859375009,
									36.611376953125045
								],
								[
									120.98994140625001,
									36.59794921874996
								],
								[
									120.87851562500009,
									36.635156249999994
								],
								[
									120.81083984375016,
									36.63281250000006
								],
								[
									120.79667968749999,
									36.60722656249999
								],
								[
									120.88261718750005,
									36.53891601562512
								],
								[
									120.90498046875007,
									36.485302734374926
								],
								[
									120.89580078125016,
									36.444140625000074
								],
								[
									120.84707031249997,
									36.426074218750045
								],
								[
									120.77617187499999,
									36.45629882812497
								],
								[
									120.71152343750009,
									36.4132812500001
								],
								[
									120.68222656250003,
									36.340722656249966
								],
								[
									120.68095703125016,
									36.16835937500002
								],
								[
									120.63789062500018,
									36.1299316406251
								],
								[
									120.51933593749999,
									36.108691406250045
								],
								[
									120.39306640625011,
									36.053857421874966
								],
								[
									120.34824218750003,
									36.07919921874998
								],
								[
									120.33027343750001,
									36.11010742187506
								],
								[
									120.34345703125007,
									36.18945312500006
								],
								[
									120.32773437500003,
									36.22817382812505
								],
								[
									120.2701171875002,
									36.22617187500006
								],
								[
									120.18330078125001,
									36.202441406250045
								],
								[
									120.11699218749999,
									36.15029296875008
								],
								[
									120.09414062499997,
									36.11889648437506
								],
								[
									120.18144531249999,
									36.01748046875011
								],
								[
									120.2647460937502,
									36.007226562499966
								],
								[
									120.28476562500009,
									35.98442382812502
								],
								[
									120.21904296874999,
									35.93491210937498
								],
								[
									120.05468750000011,
									35.86113281249996
								],
								[
									120.02744140625003,
									35.79936523437499
								],
								[
									119.97871093750018,
									35.740234375000114
								],
								[
									119.9117187500002,
									35.693212890625034
								],
								[
									119.8662109375,
									35.64365234375006
								],
								[
									119.81054687500011,
									35.61772460937493
								],
								[
									119.7197265625,
									35.58872070312506
								],
								[
									119.60839843749994,
									35.46987304687511
								],
								[
									119.52646484375003,
									35.35859374999998
								],
								[
									119.42968749999994,
									35.301416015624966
								],
								[
									119.35283203125005,
									35.113818359375045
								],
								[
									119.21582031250011,
									35.01176757812493
								],
								[
									119.16533203125005,
									34.848828124999955
								],
								[
									119.20097656249999,
									34.74843749999994
								],
								[
									119.35136718749999,
									34.74941406250005
								],
								[
									119.4267578125,
									34.714160156250045
								],
								[
									119.58291015625002,
									34.5822265625001
								],
								[
									119.76972656250007,
									34.49619140625006
								],
								[
									119.96367187500005,
									34.447802734375074
								],
								[
									120.20146484375016,
									34.32568359375006
								],
								[
									120.26669921875003,
									34.274023437500006
								],
								[
									120.32265624999997,
									34.16899414062502
								],
								[
									120.42568359375002,
									33.86630859375009
								],
								[
									120.49980468749999,
									33.71645507812511
								],
								[
									120.50478515625014,
									33.63818359375006
								],
								[
									120.61562499999997,
									33.49052734374999
								],
								[
									120.73447265625003,
									33.23662109374996
								],
								[
									120.87109375,
									33.016503906249966
								],
								[
									120.89736328125002,
									32.843212890624926
								],
								[
									120.85302734374994,
									32.76411132812507
								],
								[
									120.85322265625018,
									32.661376953125
								],
								[
									120.98994140625001,
									32.567041015624966
								],
								[
									121.29335937500014,
									32.4573242187501
								],
								[
									121.34169921875014,
									32.425048828125
								],
								[
									121.4009765625002,
									32.371923828125006
								],
								[
									121.40390625000009,
									32.20625000000001
								],
								[
									121.45078125000003,
									32.15332031249997
								],
								[
									121.49052734375016,
									32.12109375000006
								],
								[
									121.67421875000002,
									32.051025390625
								],
								[
									121.7510742187502,
									31.992871093750068
								],
								[
									121.83242187499997,
									31.899755859375006
								],
								[
									121.85634765624997,
									31.816455078125102
								],
								[
									121.86630859375003,
									31.70356445312501
								],
								[
									121.76357421875002,
									31.699511718750074
								],
								[
									121.68085937500001,
									31.712158203125057
								],
								[
									121.35195312499997,
									31.858789062500108
								],
								[
									121.26640625000016,
									31.862695312500108
								],
								[
									121.14580078124999,
									31.842333984375045
								],
								[
									120.97353515624997,
									31.869384765624943
								],
								[
									120.79169921875007,
									32.031738281250085
								],
								[
									120.66054687499997,
									32.081054687500085
								],
								[
									120.52011718750009,
									32.10585937500008
								],
								[
									120.18408203125011,
									31.96616210937495
								],
								[
									120.0987304687502,
									31.975976562499994
								],
								[
									120.07392578125001,
									31.96025390624999
								],
								[
									120.03593749999999,
									31.936279296875085
								],
								[
									120.19160156250001,
									31.90634765625012
								],
								[
									120.34746093750016,
									31.952099609374926
								],
								[
									120.4971679687502,
									32.019824218750045
								],
								[
									120.71552734375018,
									31.983740234374977
								],
								[
									120.75224609375005,
									31.9228515625
								],
								[
									120.78779296875018,
									31.819775390625068
								],
								[
									120.93750000000011,
									31.750195312500097
								],
								[
									121.05537109375007,
									31.719433593749955
								],
								[
									121.20488281250005,
									31.628076171874994
								],
								[
									121.35097656250014,
									31.485351562500057
								],
								[
									121.66064453125,
									31.319726562499966
								],
								[
									121.78593750000005,
									31.16289062499999
								],
								[
									121.83447265624994,
									31.061621093750063
								],
								[
									121.87792968750011,
									30.916992187500085
								],
								[
									121.76943359375014,
									30.870361328125085
								],
								[
									121.67519531250014,
									30.863769531250057
								],
								[
									121.52753906250007,
									30.84096679687505
								],
								[
									121.41894531249994,
									30.789794921875085
								],
								[
									121.30996093750014,
									30.69970703125003
								],
								[
									120.9976562500002,
									30.558251953124994
								],
								[
									120.93828124999999,
									30.469726562500085
								],
								[
									120.89746093750011,
									30.392626953125102
								],
								[
									120.82148437500018,
									30.354638671874994
								],
								[
									120.62998046875009,
									30.390869140625
								],
								[
									120.44980468750003,
									30.387841796875108
								],
								[
									120.24550781249997,
									30.28354492187509
								],
								[
									120.19462890624999,
									30.24130859375009
								],
								[
									120.228515625,
									30.24956054687499
								],
								[
									120.26054687500005,
									30.263037109375063
								],
								[
									120.35253906249994,
									30.24741210937509
								],
								[
									120.49453125000002,
									30.303076171875063
								],
								[
									120.63339843750003,
									30.13315429687509
								],
								[
									120.90449218750001,
									30.16064453125
								],
								[
									121.15937500000018,
									30.30175781249997
								],
								[
									121.25800781250001,
									30.30410156250008
								],
								[
									121.34062500000016,
									30.282373046875023
								],
								[
									121.4327148437502,
									30.22666015624995
								],
								[
									121.67792968750007,
									29.979101562500063
								],
								[
									121.81230468750016,
									29.95214843749997
								],
								[
									121.94433593749994,
									29.89409179687496
								],
								[
									122.01728515625018,
									29.887695312500085
								],
								[
									122.08291015625014,
									29.870361328125114
								],
								[
									121.90576171875011,
									29.779687500000108
								],
								[
									121.67656250000005,
									29.583789062500074
								],
								[
									121.57460937500014,
									29.53701171875005
								],
								[
									121.50624999999997,
									29.484570312499926
								],
								[
									121.69042968750011,
									29.510986328125085
								],
								[
									121.82187500000003,
									29.604638671874966
								],
								[
									121.88798828125005,
									29.627783203124977
								],
								[
									121.94121093750005,
									29.605908203124955
								],
								[
									121.96835937500003,
									29.490625000000108
								],
								[
									121.91777343750016,
									29.135009765624943
								],
								[
									121.85351562500011,
									29.128906249999943
								],
								[
									121.79082031250005,
									29.22568359374995
								],
								[
									121.71748046875001,
									29.25634765624997
								],
								[
									121.65595703125018,
									29.236132812500045
								],
								[
									121.53369140624994,
									29.23671875000005
								],
								[
									121.48710937500016,
									29.193164062500074
								],
								[
									121.44765625000014,
									29.13134765625
								],
								[
									121.52089843750014,
									29.118457031250045
								],
								[
									121.66494140624997,
									29.010595703125006
								],
								[
									121.67968749999994,
									28.953125000000114
								],
								[
									121.64101562499997,
									28.91591796875008
								],
								[
									121.54003906250011,
									28.931884765625057
								],
								[
									121.66250000000002,
									28.85141601562509
								],
								[
									121.63007812500018,
									28.76791992187495
								],
								[
									121.59033203124994,
									28.734814453124955
								],
								[
									121.5191406250002,
									28.713671875000074
								],
								[
									121.47519531250003,
									28.641406249999932
								],
								[
									121.5380859375,
									28.52109375000012
								],
								[
									121.60205078124994,
									28.36660156250008
								],
								[
									121.60996093750003,
									28.292138671875108
								],
								[
									121.50996093750001,
									28.324267578125074
								],
								[
									121.35458984375009,
									28.229882812499937
								],
								[
									121.27226562499999,
									28.222119140624955
								],
								[
									121.216796875,
									28.34619140625
								],
								[
									121.14570312500007,
									28.32666015625003
								],
								[
									121.09843750000005,
									28.290527343749943
								],
								[
									121.03544921875016,
									28.157275390625074
								],
								[
									120.95859375000003,
									28.03701171875008
								],
								[
									120.89248046874997,
									28.003906250000085
								],
								[
									120.81298828124994,
									28.013378906250068
								],
								[
									120.74765625000003,
									28.009960937499983
								],
								[
									120.76347656249999,
									27.977441406250023
								],
								[
									120.83300781249994,
									27.937792968749932
								],
								[
									120.83300781249994,
									27.89145507812509
								],
								[
									120.6851562500002,
									27.74458007812501
								],
								[
									120.66132812500007,
									27.687890625000108
								],
								[
									120.66484375000016,
									27.639453125000074
								],
								[
									120.5875000000002,
									27.58076171875004
								],
								[
									120.62910156250018,
									27.48212890625001
								],
								[
									120.6075195312502,
									27.412402343750017
								],
								[
									120.53984374999999,
									27.31835937500003
								],
								[
									120.46865234374997,
									27.256249999999994
								],
								[
									120.38457031250016,
									27.155517578125085
								],
								[
									120.27871093750002,
									27.09707031250008
								],
								[
									120.13857421875014,
									26.88613281250008
								],
								[
									120.09746093750005,
									26.780664062500108
								],
								[
									120.08671875000016,
									26.671582031250068
								],
								[
									120.04296875000011,
									26.633837890625017
								],
								[
									119.9677734375,
									26.586376953124955
								],
								[
									119.88222656250014,
									26.610449218750063
								],
								[
									119.8794921875002,
									26.683007812500108
								],
								[
									119.8423828125002,
									26.689306640625063
								],
								[
									119.8212890625,
									26.736914062499977
								],
								[
									119.81513671875007,
									26.797607421875
								],
								[
									119.82421874999994,
									26.846386718749983
								],
								[
									119.7886718750002,
									26.831494140625068
								],
								[
									119.76669921875003,
									26.774707031250045
								],
								[
									119.71044921874994,
									26.72866210937508
								],
								[
									119.65156250000007,
									26.747265624999955
								],
								[
									119.58818359374999,
									26.784960937500074
								],
								[
									119.5899414062502,
									26.73046875
								],
								[
									119.62363281250003,
									26.675878906249977
								],
								[
									119.63818359375,
									26.621191406250034
								],
								[
									119.72597656250002,
									26.609423828125017
								],
								[
									119.7847656250002,
									26.54663085937503
								],
								[
									119.83115234375003,
									26.450195312500085
								],
								[
									119.84033203124994,
									26.41416015624995
								],
								[
									119.87646484374994,
									26.370947265625034
								],
								[
									119.88105468750018,
									26.334179687500097
								],
								[
									119.79726562499997,
									26.30014648437509
								],
								[
									119.69267578125016,
									26.236425781249977
								],
								[
									119.56708984375018,
									26.12734375000005
								],
								[
									119.46308593750001,
									26.054687500000085
								],
								[
									119.3697265625002,
									26.05405273437495
								],
								[
									119.3130859375002,
									26.06254882812499
								],
								[
									119.23212890625001,
									26.104394531249994
								],
								[
									119.13945312500016,
									26.121777343749983
								],
								[
									119.2637695312502,
									25.974804687500068
								],
								[
									119.33203124999994,
									25.948730468750085
								],
								[
									119.41777343750005,
									25.95434570312497
								],
								[
									119.50087890624997,
									26.00917968750005
								],
								[
									119.6187500000002,
									26.003564453124966
								],
								[
									119.64824218749999,
									25.918701171875
								],
								[
									119.61689453125018,
									25.822900390625023
								],
								[
									119.5528320312502,
									25.69868164062504
								],
								[
									119.53945312500014,
									25.591259765625068
								],
								[
									119.61914062500011,
									25.43745117187501
								],
								[
									119.62246093749997,
									25.39116210937499
								],
								[
									119.59277343749994,
									25.368017578125063
								],
								[
									119.49921875000018,
									25.408642578125097
								],
								[
									119.42177734375014,
									25.459619140624994
								],
								[
									119.34374999999994,
									25.446289062499943
								],
								[
									119.26308593750014,
									25.468017578125114
								],
								[
									119.18007812500002,
									25.44980468749995
								],
								[
									119.14628906250016,
									25.414306640625
								],
								[
									119.16933593750014,
									25.355712890625057
								],
								[
									119.24355468749997,
									25.307031249999994
								],
								[
									119.28554687500002,
									25.23222656250013
								],
								[
									119.23554687500001,
									25.205957031250108
								],
								[
									119.02460937500001,
									25.223437500000017
								],
								[
									118.97753906249994,
									25.209277343750074
								],
								[
									118.91445312499997,
									25.126806640625063
								],
								[
									118.9556640625002,
									25.004785156249966
								],
								[
									118.90908203125014,
									24.928906250000068
								],
								[
									118.82207031250016,
									24.911132812500085
								],
								[
									118.70751953125011,
									24.849804687499926
								],
								[
									118.63691406250001,
									24.83554687499995
								],
								[
									118.64023437500009,
									24.809082031250057
								],
								[
									118.69179687500002,
									24.78232421874995
								],
								[
									118.71914062499997,
									24.74614257812513
								],
								[
									118.65703125000005,
									24.621435546875034
								],
								[
									118.56035156250016,
									24.580371093750017
								],
								[
									118.41201171875014,
									24.60073242187508
								],
								[
									118.29531250000014,
									24.57275390624997
								],
								[
									118.19453125000001,
									24.62583007812495
								],
								[
									118.08710937500018,
									24.627001953125102
								],
								[
									118.01386718750018,
									24.55991210937512
								],
								[
									118.00595703125009,
									24.481982421875045
								],
								[
									117.93505859375011,
									24.474218750000063
								],
								[
									117.89687499999997,
									24.479833984375063
								],
								[
									117.84267578125014,
									24.474316406250068
								],
								[
									117.8482421875002,
									24.43247070312509
								],
								[
									117.87900390625003,
									24.39589843750008
								],
								[
									118.02421875000016,
									24.37963867187497
								],
								[
									118.05058593750005,
									24.327148437499943
								],
								[
									118.05605468749997,
									24.246093749999943
								],
								[
									117.90410156250005,
									24.106445312500085
								],
								[
									117.83945312500009,
									24.01230468750009
								],
								[
									117.74169921875,
									24.01479492187508
								],
								[
									117.66787109375014,
									23.93925781249996
								],
								[
									117.62822265625005,
									23.83671875000013
								],
								[
									117.5791992187502,
									23.85698242187499
								],
								[
									117.4664062500002,
									23.84057617187503
								],
								[
									117.43310546875,
									23.791699218749926
								],
								[
									117.45957031250003,
									23.771484375000057
								],
								[
									117.46220703125016,
									23.736230468749994
								],
								[
									117.4169921875,
									23.620996093749966
								],
								[
									117.36767578125,
									23.588623046874943
								],
								[
									117.34667968749994,
									23.635742187499943
								],
								[
									117.33076171875001,
									23.708789062500074
								],
								[
									117.29082031250016,
									23.71435546874997
								],
								[
									117.22500000000014,
									23.647021484375102
								],
								[
									117.14814453125001,
									23.598779296874966
								],
								[
									117.08251953125,
									23.57875976562505
								],
								[
									117.03281250000009,
									23.623437500000023
								],
								[
									116.91064453124994,
									23.646679687499955
								],
								[
									116.86093750000003,
									23.45307617187504
								],
								[
									116.75957031249999,
									23.38251953125004
								],
								[
									116.71210937500018,
									23.360498046875108
								],
								[
									116.62939453124994,
									23.353857421875063
								],
								[
									116.68232421875018,
									23.327392578125114
								],
								[
									116.69882812500003,
									23.27778320312504
								],
								[
									116.66914062500007,
									23.22817382812505
								],
								[
									116.58642578125,
									23.218261718750085
								],
								[
									116.53828125000001,
									23.179687499999943
								],
								[
									116.51982421874999,
									23.00659179687503
								],
								[
									116.47070312499994,
									22.945898437500006
								],
								[
									116.34550781250005,
									22.941064453124994
								],
								[
									116.25185546875014,
									22.981347656250023
								],
								[
									116.22207031250002,
									22.94956054687495
								],
								[
									116.20634765624999,
									22.91865234375004
								],
								[
									116.15742187500018,
									22.887451171875
								],
								[
									116.0625976562502,
									22.879101562499983
								],
								[
									115.85214843750003,
									22.801562500000102
								],
								[
									115.755859375,
									22.82392578125004
								],
								[
									115.64042968749999,
									22.853417968749994
								],
								[
									115.5611328125002,
									22.824707031250085
								],
								[
									115.53466796875011,
									22.76518554687496
								],
								[
									115.49833984374999,
									22.71884765625012
								],
								[
									115.38251953125001,
									22.71884765625012
								],
								[
									115.28994140625002,
									22.775976562500034
								],
								[
									115.19580078125011,
									22.817285156250108
								],
								[
									115.09150390625018,
									22.78168945312504
								],
								[
									115.01210937499997,
									22.708935546874955
								],
								[
									114.91445312499997,
									22.684619140625074
								],
								[
									114.89638671875014,
									22.63950195312512
								],
								[
									114.85380859375016,
									22.61679687500012
								],
								[
									114.75039062500014,
									22.626318359375006
								],
								[
									114.71113281250001,
									22.738720703124983
								],
								[
									114.65166015624999,
									22.75527343750008
								],
								[
									114.5927734375,
									22.698437499999955
								],
								[
									114.57197265625001,
									22.65405273437497
								],
								[
									114.54443359375011,
									22.620605468750085
								],
								[
									114.55419921874994,
									22.528906250000063
								],
								[
									114.4961914062502,
									22.52705078125004
								],
								[
									114.42011718750018,
									22.58325195312503
								],
								[
									114.34062500000016,
									22.59321289062501
								],
								[
									114.26601562500014,
									22.54096679687501
								],
								[
									114.22822265625007,
									22.553955078125
								],
								[
									114.18818359375018,
									22.56499023437513
								],
								[
									114.12285156249999,
									22.56499023437513
								],
								[
									114.09785156250007,
									22.551269531250085
								],
								[
									114.05039062500009,
									22.542968750000085
								],
								[
									114.01826171875018,
									22.514453125000045
								],
								[
									114.01542968750016,
									22.511914062500068
								],
								[
									113.93115234375011,
									22.53105468749996
								],
								[
									113.82832031250001,
									22.607226562500017
								],
								[
									113.7544921875002,
									22.733642578125114
								],
								[
									113.6611328125,
									22.801660156250023
								],
								[
									113.61962890625,
									22.861425781250034
								],
								[
									113.60341796875014,
									22.96889648437508
								],
								[
									113.58632812500014,
									23.020019531250085
								],
								[
									113.59218749999997,
									23.076953125000074
								],
								[
									113.62050781249997,
									23.12749023437496
								],
								[
									113.51972656250007,
									23.10209960937513
								],
								[
									113.4453125,
									23.05507812500005
								],
								[
									113.46035156250014,
									22.995703125000034
								],
								[
									113.44189453125011,
									22.94057617187508
								],
								[
									113.3310546875,
									22.912011718749937
								],
								[
									113.33779296875014,
									22.888818359375108
								],
								[
									113.3448242187502,
									22.864599609375063
								],
								[
									113.43203125000014,
									22.789404296875006
								],
								[
									113.4498046875002,
									22.726123046875074
								],
								[
									113.48476562500014,
									22.692382812500057
								],
								[
									113.55302734374999,
									22.594042968750102
								],
								[
									113.55146484375001,
									22.40415039062495
								],
								[
									113.58886718750011,
									22.350488281249937
								],
								[
									113.57646484375016,
									22.297265624999937
								],
								[
									113.54912109374999,
									22.22519531250009
								],
								[
									113.54677734375014,
									22.224121093750057
								],
								[
									113.52705078125001,
									22.245947265625063
								],
								[
									113.494140625,
									22.24155273437495
								],
								[
									113.48105468750009,
									22.21748046875001
								],
								[
									113.47890625000008,
									22.195556640625
								],
								[
									113.47343750000005,
									22.19443359374995
								],
								[
									113.41572265625018,
									22.17836914062505
								],
								[
									113.36738281250018,
									22.16484374999996
								],
								[
									113.3277343750002,
									22.145410156249994
								],
								[
									113.26640625000016,
									22.08876953125008
								],
								[
									113.1490234375002,
									22.075000000000045
								],
								[
									113.08876953125002,
									22.20795898437504
								],
								[
									113.00820312500014,
									22.119335937499926
								],
								[
									112.98378906250014,
									21.93823242187497
								],
								[
									112.95390625000016,
									21.907324218750063
								],
								[
									112.90380859375,
									21.88144531249995
								],
								[
									112.80859374999994,
									21.94462890625013
								],
								[
									112.72539062500016,
									21.902343749999943
								],
								[
									112.6607421875002,
									21.859472656250006
								],
								[
									112.63408203124999,
									21.819873046875017
								],
								[
									112.58632812500014,
									21.776855468750057
								],
								[
									112.49472656250003,
									21.818310546875068
								],
								[
									112.42128906250002,
									21.880615234375057
								],
								[
									112.439453125,
									21.927343749999977
								],
								[
									112.4292968750002,
									21.958105468750034
								],
								[
									112.3960937500002,
									21.981347656249966
								],
								[
									112.35966796875016,
									21.97802734375
								],
								[
									112.37744140624994,
									21.917480468750114
								],
								[
									112.38974609375003,
									21.801220703124955
								],
								[
									112.35644531250011,
									21.76757812500003
								],
								[
									112.30498046875005,
									21.741699218750085
								],
								[
									112.19335937500011,
									21.76313476562501
								],
								[
									112.11718749999994,
									21.806494140625063
								],
								[
									112.02519531250016,
									21.843017578124943
								],
								[
									111.9439453125002,
									21.84965820312496
								],
								[
									111.92646484375018,
									21.776269531250023
								],
								[
									111.87343750000014,
									21.717138671875063
								],
								[
									111.82460937500014,
									21.709765625000074
								],
								[
									111.77597656250009,
									21.719238281249943
								],
								[
									111.7119140625,
									21.65522460937504
								],
								[
									111.68164062499994,
									21.60849609374995
								],
								[
									111.60273437500007,
									21.55908203125
								],
								[
									111.39238281249999,
									21.53510742187501
								],
								[
									111.31914062499999,
									21.486132812500074
								],
								[
									111.22060546875002,
									21.493896484375057
								],
								[
									111.14423828125018,
									21.482226562500074
								],
								[
									111.10058593749994,
									21.48471679687495
								],
								[
									111.0611328125002,
									21.51098632812497
								],
								[
									111.01689453125016,
									21.511718749999943
								],
								[
									110.99677734375007,
									21.430273437500063
								],
								[
									110.8780273437502,
									21.395947265624983
								],
								[
									110.77109375000009,
									21.386523437500017
								],
								[
									110.65214843749999,
									21.27910156249999
								],
								[
									110.56718749999999,
									21.214062500000068
								],
								[
									110.50429687499997,
									21.20742187500005
								],
								[
									110.4580078125,
									21.230566406250034
								],
								[
									110.43457031250011,
									21.326904296875057
								],
								[
									110.41093750000016,
									21.33813476562503
								],
								[
									110.3974609375,
									21.24770507812508
								],
								[
									110.37460937500003,
									21.17236328125
								],
								[
									110.33115234375009,
									21.131347656250085
								],
								[
									110.19355468750018,
									21.037646484375102
								],
								[
									110.15400390625001,
									20.944628906250045
								],
								[
									110.18037109375018,
									20.85859375000004
								],
								[
									110.36542968750001,
									20.837597656249926
								],
								[
									110.38847656250005,
									20.790527343750114
								],
								[
									110.37050781250002,
									20.75205078125009
								],
								[
									110.32617187500011,
									20.719921874999926
								],
								[
									110.3130859375002,
									20.67167968749996
								],
								[
									110.51152343750016,
									20.518261718750068
								],
								[
									110.51757812500011,
									20.460009765625102
								],
								[
									110.4869140625002,
									20.42685546875009
								],
								[
									110.44951171875005,
									20.355419921874926
								],
								[
									110.3447265625,
									20.294824218750108
								],
								[
									110.12314453125003,
									20.263720703125074
								],
								[
									109.93847656250011,
									20.295117187499983
								],
								[
									109.88251953125007,
									20.364062500000074
								],
								[
									109.8858398437502,
									20.41313476562496
								],
								[
									109.93164062500011,
									20.398876953124983
								],
								[
									109.98388671875011,
									20.403271484375068
								],
								[
									109.96835937500003,
									20.44814453125008
								],
								[
									109.9463867187502,
									20.474365234375
								],
								[
									109.86103515625001,
									20.514306640624966
								],
								[
									109.79199218750011,
									20.62187500000013
								],
								[
									109.80527343750003,
									20.71147460937499
								],
								[
									109.76738281250016,
									20.780712890625068
								],
								[
									109.72626953125001,
									20.83876953125008
								],
								[
									109.68476562500018,
									20.873632812499977
								],
								[
									109.66259765625011,
									20.91689453125008
								],
								[
									109.70449218750014,
									21.052734375000057
								],
								[
									109.6812500000002,
									21.13164062499996
								],
								[
									109.76015625000002,
									21.22836914062495
								],
								[
									109.77958984375016,
									21.337451171875074
								],
								[
									109.92109375000001,
									21.376464843750114
								],
								[
									109.9307617187502,
									21.48056640625009
								],
								[
									109.82958984375011,
									21.483593750000068
								],
								[
									109.7593750000002,
									21.56005859375003
								],
								[
									109.74335937500007,
									21.52797851562505
								],
								[
									109.68691406250002,
									21.524609375000097
								],
								[
									109.59433593750003,
									21.67197265625009
								],
								[
									109.56640624999994,
									21.690576171874966
								],
								[
									109.52148437499994,
									21.693408203125017
								],
								[
									109.5440429687502,
									21.537939453125063
								],
								[
									109.43554687499994,
									21.479492187500057
								],
								[
									109.34667968749994,
									21.45395507812509
								],
								[
									109.22041015625018,
									21.443408203125074
								],
								[
									109.14863281250001,
									21.42553710937497
								],
								[
									109.08154296874994,
									21.440283203125063
								],
								[
									109.09814453124994,
									21.48735351562496
								],
								[
									109.13349609375007,
									21.54360351562505
								],
								[
									109.10175781250018,
									21.590478515625108
								],
								[
									109.03056640625016,
									21.626513671875074
								],
								[
									108.92177734375002,
									21.624414062499994
								],
								[
									108.84638671875018,
									21.634472656250097
								],
								[
									108.77167968750007,
									21.630468749999977
								],
								[
									108.74394531249999,
									21.65126953125005
								],
								[
									108.67451171875018,
									21.72465820312499
								],
								[
									108.6158203125002,
									21.770458984375068
								],
								[
									108.58935546874994,
									21.815966796875102
								],
								[
									108.6158203125002,
									21.86889648437497
								],
								[
									108.59374999999994,
									21.901025390625023
								],
								[
									108.47988281250014,
									21.904638671875063
								],
								[
									108.48085937500014,
									21.828808593750068
								],
								[
									108.49257812500014,
									21.739404296874966
								],
								[
									108.52568359375005,
									21.67138671874997
								],
								[
									108.50214843750007,
									21.633447265624966
								],
								[
									108.4443359375,
									21.60732421875005
								],
								[
									108.3828125,
									21.679199218750057
								],
								[
									108.3545898437502,
									21.696923828125023
								],
								[
									108.32480468750003,
									21.693505859375023
								],
								[
									108.30214843749997,
									21.62192382812512
								],
								[
									108.24628906250007,
									21.558398437500045
								],
								[
									108.14560546875003,
									21.565185546875
								],
								[
									108.06738281250011,
									21.525976562500006
								],
								[
									107.97265625,
									21.50795898437508
								],
								[
									107.90839843750007,
									21.560400390625006
								],
								[
									107.80205078125016,
									21.64516601562505
								],
								[
									107.75927734374994,
									21.655029296875114
								],
								[
									107.64101562500014,
									21.61391601562508
								],
								[
									107.47138671875018,
									21.59833984375001
								],
								[
									107.43349609375014,
									21.642285156250068
								],
								[
									107.3511718750002,
									21.60888671875003
								],
								[
									107.27207031250009,
									21.710644531250068
								],
								[
									107.17851562500005,
									21.717089843750045
								],
								[
									107.0616210937502,
									21.794189453124943
								],
								[
									107.01982421875005,
									21.834863281249966
								],
								[
									107.00644531250003,
									21.89340820312509
								],
								[
									106.97099609375005,
									21.92392578125009
								],
								[
									106.92519531250014,
									21.920117187499926
								],
								[
									106.87451171875011,
									21.951269531250063
								],
								[
									106.79414062500007,
									21.981982421875102
								],
								[
									106.72949218749994,
									22.00034179687512
								],
								[
									106.69765625000014,
									21.986181640624977
								],
								[
									106.66357421875011,
									21.97890625000008
								],
								[
									106.65771484375,
									22.018212890625023
								],
								[
									106.66005859375002,
									22.13647460937503
								],
								[
									106.65419921874997,
									22.24145507812503
								],
								[
									106.63652343749999,
									22.288623046875045
								],
								[
									106.59316406249997,
									22.324511718750074
								],
								[
									106.55361328125002,
									22.341699218750023
								],
								[
									106.53632812500001,
									22.395410156250023
								],
								[
									106.55039062500003,
									22.50136718750005
								],
								[
									106.58242187500002,
									22.57324218750003
								],
								[
									106.63310546875005,
									22.586035156250063
								],
								[
									106.70156250000014,
									22.637744140625017
								],
								[
									106.73632812500011,
									22.710937500000114
								],
								[
									106.7802734375,
									22.778906250000006
								],
								[
									106.62402343749994,
									22.874267578125057
								],
								[
									106.54179687500016,
									22.908349609374994
								],
								[
									106.45087890625001,
									22.893896484374977
								],
								[
									106.33808593750007,
									22.863476562500097
								],
								[
									106.27900390625018,
									22.857470703125017
								],
								[
									106.24941406250014,
									22.869433593750074
								],
								[
									106.18398437500002,
									22.955126953125017
								],
								[
									106.14843749999994,
									22.970068359375034
								],
								[
									106.0684570312502,
									22.97553710937501
								],
								[
									106.00097656250011,
									22.974755859374937
								],
								[
									105.96230468749997,
									22.937451171875068
								],
								[
									105.90263671875016,
									22.92495117187508
								],
								[
									105.84296875000018,
									22.92280273437501
								],
								[
									105.78232421875009,
									22.969335937500063
								],
								[
									105.69121093750016,
									23.02993164062508
								],
								[
									105.54814453125016,
									23.07265625000008
								],
								[
									105.5308593750002,
									23.121972656249994
								],
								[
									105.49453124999997,
									23.180859375000097
								],
								[
									105.44013671875018,
									23.2353515625
								],
								[
									105.35048828125014,
									23.30766601562499
								],
								[
									105.27539062500011,
									23.34521484375
								],
								[
									105.23876953125011,
									23.322119140625006
								],
								[
									105.1890625000002,
									23.28105468749999
								],
								[
									104.99570312500003,
									23.194335937500085
								],
								[
									104.91015625000011,
									23.16054687500005
								],
								[
									104.86474609375011,
									23.136376953124994
								],
								[
									104.82656250000014,
									23.10019531250009
								],
								[
									104.81474609375005,
									23.01079101562499
								],
								[
									104.79570312500016,
									22.911132812499943
								],
								[
									104.74003906249999,
									22.860498046875023
								],
								[
									104.68730468749999,
									22.82221679687504
								],
								[
									104.63173828124997,
									22.81821289062512
								],
								[
									104.57753906250014,
									22.82001953125004
								],
								[
									104.52685546875011,
									22.80410156250008
								],
								[
									104.37177734375001,
									22.70405273437504
								],
								[
									104.29833984375,
									22.712011718750063
								],
								[
									104.23828125000011,
									22.768505859374926
								],
								[
									104.2125000000002,
									22.809423828125006
								],
								[
									104.14306640625,
									22.800146484374977
								],
								[
									104.05390625000001,
									22.75229492187509
								],
								[
									104.0126953125,
									22.66635742187509
								],
								[
									103.99082031250003,
									22.586132812499983
								],
								[
									103.97138671875018,
									22.55048828125001
								],
								[
									103.94150390625003,
									22.540087890625017
								],
								[
									103.9150390625,
									22.538232421874994
								],
								[
									103.63730468750003,
									22.77001953124997
								],
								[
									103.62021484375003,
									22.782031250000017
								],
								[
									103.57070312499997,
									22.734423828125102
								],
								[
									103.52539062500011,
									22.611572265625114
								],
								[
									103.49296875000016,
									22.587988281250006
								],
								[
									103.47099609375005,
									22.59741210937497
								],
								[
									103.35605468750003,
									22.754687500000045
								],
								[
									103.32666015625011,
									22.769775390625085
								],
								[
									103.30058593750005,
									22.764404296875057
								],
								[
									103.26630859375007,
									22.713525390625108
								],
								[
									103.19335937500011,
									22.638525390625006
								],
								[
									103.13759765625014,
									22.592968749999955
								],
								[
									103.13632812500003,
									22.542236328125114
								],
								[
									103.07587890625018,
									22.49750976562504
								],
								[
									103.00537109375011,
									22.45297851562495
								],
								[
									102.98193359374994,
									22.448242187500057
								],
								[
									102.9351562500002,
									22.466162109375063
								],
								[
									102.87421875000001,
									22.525390625000057
								],
								[
									102.83007812500011,
									22.587158203125114
								],
								[
									102.72099609375016,
									22.64848632812499
								],
								[
									102.59853515625002,
									22.700390625000097
								],
								[
									102.5171875000002,
									22.741015625000102
								],
								[
									102.47089843750001,
									22.750927734374983
								],
								[
									102.42792968750007,
									22.732812499999937
								],
								[
									102.40644531250001,
									22.708007812499943
								],
								[
									102.37578124999999,
									22.646630859374966
								],
								[
									102.30224609375011,
									22.545996093749977
								],
								[
									102.23701171875018,
									22.46601562500004
								],
								[
									102.17597656250018,
									22.414648437500034
								],
								[
									102.12744140625006,
									22.379199218750017
								],
								[
									102.09150390625018,
									22.412255859375193
								],
								[
									102.02441406250011,
									22.43920898437517
								],
								[
									101.94541015625015,
									22.43940429687504
								],
								[
									101.84179687500011,
									22.38847656250013
								],
								[
									101.75996093750007,
									22.490332031250006
								],
								[
									101.73876953125006,
									22.49526367187505
								],
								[
									101.70751953125011,
									22.486572265625057
								],
								[
									101.67148437500015,
									22.46230468750008
								],
								[
									101.64619140625013,
									22.405419921874937
								],
								[
									101.6199218750001,
									22.32744140625013
								],
								[
									101.56787109375006,
									22.27636718750003
								],
								[
									101.52451171875003,
									22.25366210937503
								],
								[
									101.53730468750018,
									22.209863281250165
								],
								[
									101.56181640624999,
									22.162402343750074
								],
								[
									101.56025390625001,
									22.12089843750016
								],
								[
									101.5757812500002,
									22.05527343750012
								],
								[
									101.60292968750014,
									21.989697265624983
								],
								[
									101.69960937500008,
									21.88247070312508
								],
								[
									101.73652343750018,
									21.82651367187495
								],
								[
									101.74394531250016,
									21.777978515625108
								],
								[
									101.74726562500013,
									21.605761718750102
								],
								[
									101.74345703125016,
									21.533837890625108
								],
								[
									101.72421875000003,
									21.39501953124997
								],
								[
									101.72294921875016,
									21.314941406250085
								],
								[
									101.76308593750008,
									21.27890624999995
								],
								[
									101.8020507812501,
									21.23598632812508
								],
								[
									101.80058593750016,
									21.21259765625004
								],
								[
									101.78349609375016,
									21.204150390625074
								],
								[
									101.72812500000015,
									21.156396484375136
								],
								[
									101.70478515625018,
									21.150146484375085
								],
								[
									101.66855468750009,
									21.169628906250153
								],
								[
									101.6216796875002,
									21.184423828125063
								],
								[
									101.58388671875014,
									21.20356445312504
								],
								[
									101.54238281250014,
									21.234277343750193
								],
								[
									101.44355468750018,
									21.230810546875006
								],
								[
									101.28144531250018,
									21.184130859375102
								],
								[
									101.2478515625001,
									21.197314453125017
								],
								[
									101.22441406249999,
									21.223730468749977
								],
								[
									101.21181640625008,
									21.27822265625008
								],
								[
									101.21992187500018,
									21.342431640625193
								],
								[
									101.20556640625006,
									21.38330078125017
								],
								[
									101.17539062500015,
									21.40751953125013
								],
								[
									101.19667968750014,
									21.52207031250009
								],
								[
									101.13886718750018,
									21.567480468750034
								],
								[
									101.14726562499999,
									21.581640624999977
								],
								[
									101.12812500000001,
									21.705126953125102
								],
								[
									101.13085937499994,
									21.735546874999983
								],
								[
									101.1207031250002,
									21.74609375
								],
								[
									101.07978515625001,
									21.755859374999943
								],
								[
									101.01933593750016,
									21.736376953125074
								],
								[
									100.83515625000001,
									21.65517578125005
								],
								[
									100.67714843749997,
									21.50493164062499
								],
								[
									100.6045898437502,
									21.471777343749977
								],
								[
									100.5313476562502,
									21.45810546874995
								],
								[
									100.44570312499997,
									21.484082031250097
								],
								[
									100.3505859375,
									21.50102539062499
								],
								[
									100.21474609375002,
									21.462988281250063
								],
								[
									100.14765625000001,
									21.48051757812499
								],
								[
									100.11679687500003,
									21.511181640624926
								],
								[
									100.08925781250014,
									21.55791015625013
								],
								[
									100.10576171874999,
									21.61704101562509
								],
								[
									100.09550781250016,
									21.66064453125
								],
								[
									100.04121093750018,
									21.68276367187508
								],
								[
									99.97822265625007,
									21.701611328125097
								],
								[
									99.94072265625016,
									21.758740234375097
								],
								[
									99.92558593750016,
									21.820800781249943
								],
								[
									99.9404296875,
									21.90161132812497
								],
								[
									99.94785156250009,
									21.988330078125045
								],
								[
									99.91767578125018,
									22.028027343750068
								],
								[
									99.82539062500018,
									22.04970703125005
								],
								[
									99.59267578125014,
									22.08916015624999
								],
								[
									99.38867187500011,
									22.110791015624955
								],
								[
									99.30312500000002,
									22.100634765625017
								],
								[
									99.23339843750011,
									22.110156250000102
								],
								[
									99.19296875000003,
									22.125976562499943
								],
								[
									99.17343750000003,
									22.153320312500085
								],
								[
									99.17236328125011,
									22.19248046875009
								],
								[
									99.20537109375016,
									22.282568359375063
								],
								[
									99.24306640625014,
									22.370361328125085
								],
								[
									99.33769531250005,
									22.498046875000085
								],
								[
									99.34316406250002,
									22.586523437499977
								],
								[
									99.33828124999997,
									22.68867187500001
								],
								[
									99.38515625000014,
									22.825097656249994
								],
								[
									99.46679687499994,
									22.92729492187513
								],
								[
									99.50712890624999,
									22.95913085937505
								],
								[
									99.49726562500001,
									23.004589843750068
								],
								[
									99.46455078125001,
									23.04624023437512
								],
								[
									99.41806640625009,
									23.069238281249994
								],
								[
									99.34082031249994,
									23.095898437499926
								],
								[
									99.2203125000002,
									23.103320312500017
								],
								[
									99.05507812500002,
									23.130566406250068
								],
								[
									98.86376953125011,
									23.19125976562509
								],
								[
									98.88554687500005,
									23.30747070312495
								],
								[
									98.88261718750016,
									23.380322265624955
								],
								[
									98.85888671875011,
									23.440087890624966
								],
								[
									98.81972656250014,
									23.48251953125009
								],
								[
									98.79785156250011,
									23.52041015625008
								],
								[
									98.83222656250018,
									23.624365234375034
								],
								[
									98.78769531250009,
									23.73784179687496
								],
								[
									98.73505859375018,
									23.78310546875005
								],
								[
									98.68085937500018,
									23.841796875
								],
								[
									98.67675781250011,
									23.905078125000017
								],
								[
									98.70156250000014,
									23.964062499999955
								],
								[
									98.83398437500011,
									24.09057617187497
								],
								[
									98.83505859375003,
									24.12119140625009
								],
								[
									98.80234375000003,
									24.118701171875017
								],
								[
									98.76435546875001,
									24.11606445312509
								],
								[
									98.58339843750014,
									24.069824218750085
								],
								[
									98.56416015625018,
									24.098828125000068
								],
								[
									98.49941406250014,
									24.11567382812501
								],
								[
									98.36728515625003,
									24.119042968749994
								],
								[
									98.21250000000003,
									24.110644531250074
								],
								[
									98.01689453125016,
									24.0654296875
								],
								[
									97.83769531250016,
									23.986279296874955
								],
								[
									97.75566406250016,
									23.93188476562497
								],
								[
									97.68603515625,
									23.898095703125023
								],
								[
									97.62968750000016,
									23.88715820312501
								],
								[
									97.5645507812502,
									23.91103515625008
								],
								[
									97.56826171874997,
									23.988476562499955
								],
								[
									97.69062500000001,
									24.130810546875097
								],
								[
									97.70820312500018,
									24.22875976562497
								],
								[
									97.67070312500016,
									24.31274414062503
								],
								[
									97.6666015625002,
									24.379980468750034
								],
								[
									97.62363281250009,
									24.422949218750006
								],
								[
									97.56328125000005,
									24.44384765625
								],
								[
									97.53144531250001,
									24.491699218750057
								],
								[
									97.52939453125003,
									24.631201171874977
								],
								[
									97.58330078125005,
									24.774804687500108
								],
								[
									97.67070312500016,
									24.820117187500102
								],
								[
									97.72382812500007,
									24.84199218750001
								],
								[
									97.73789062500009,
									24.869873046875114
								],
								[
									97.71074218750016,
									24.97036132812505
								],
								[
									97.7149414062502,
									25.03432617187505
								],
								[
									97.76738281250016,
									25.15805664062512
								],
								[
									97.81953125000018,
									25.251855468750023
								],
								[
									97.91796875,
									25.23613281250013
								],
								[
									97.96201171875009,
									25.25932617187496
								],
								[
									98.0107421875,
									25.292529296875074
								],
								[
									98.0640625000002,
									25.34897460937509
								],
								[
									98.09960937499994,
									25.41572265625001
								],
								[
									98.14287109375016,
									25.571093750000045
								],
								[
									98.17255859375018,
									25.59453125000013
								],
								[
									98.29658203125001,
									25.568847656250057
								],
								[
									98.33378906250016,
									25.586767578125063
								],
								[
									98.40166015625005,
									25.677978515625085
								],
								[
									98.46552734375018,
									25.788867187500017
								],
								[
									98.55839843750016,
									25.8232421875
								],
								[
									98.62539062500014,
									25.826708984375074
								],
								[
									98.65625000000011,
									25.86357421874996
								],
								[
									98.65468749999997,
									25.91777343749999
								],
								[
									98.59101562500007,
									26.003710937500074
								],
								[
									98.56406250000009,
									26.07241210937505
								],
								[
									98.57197265625018,
									26.114062500000102
								],
								[
									98.6631835937502,
									26.139453125000017
								],
								[
									98.68554687499994,
									26.18935546875008
								],
								[
									98.67187500000011,
									26.298535156249926
								],
								[
									98.70947265624994,
									26.4296875
								],
								[
									98.73183593749997,
									26.583398437499966
								],
								[
									98.73935546875009,
									26.69814453125008
								],
								[
									98.73847656250018,
									26.785742187499977
								],
								[
									98.72949218750011,
									26.877392578125097
								],
								[
									98.71650390625007,
									27.04492187500003
								],
								[
									98.6748046875,
									27.190624999999955
								],
								[
									98.68242187500005,
									27.245312500000068
								],
								[
									98.67675781250011,
									27.421923828125102
								],
								[
									98.65117187500016,
									27.57246093750004
								],
								[
									98.59980468750018,
									27.598828124999983
								],
								[
									98.5044921875002,
									27.647656249999983
								],
								[
									98.45253906250002,
									27.65722656249997
								],
								[
									98.40888671875018,
									27.639453125000074
								],
								[
									98.39238281249999,
									27.58706054687508
								],
								[
									98.35048828125002,
									27.53808593750003
								],
								[
									98.29882812499994,
									27.550097656250102
								],
								[
									98.27421874999999,
									27.59907226562504
								],
								[
									98.24101562500016,
									27.66318359374995
								],
								[
									98.1304687500002,
									27.96757812499996
								],
								[
									98.11835937500007,
									28.055224609375045
								],
								[
									98.09892578124999,
									28.14228515625004
								],
								[
									98.0616210937502,
									28.185888671875034
								],
								[
									98.02226562499999,
									28.21152343750009
								],
								[
									97.93408203125,
									28.313818359374977
								],
								[
									97.88759765625014,
									28.356494140625074
								],
								[
									97.86494140625001,
									28.36357421874999
								],
								[
									97.8165039062502,
									28.356347656249937
								],
								[
									97.76904296875011,
									28.356152343750068
								],
								[
									97.73007812500009,
									28.40712890625008
								],
								[
									97.69462890625016,
									28.469335937500034
								],
								[
									97.65888671875007,
									28.500000000000085
								],
								[
									97.59921875000009,
									28.517041015625097
								],
								[
									97.53789062499999,
									28.51020507812501
								],
								[
									97.50214843750018,
									28.456347656250074
								],
								[
									97.47773437500018,
									28.42563476562512
								],
								[
									97.43144531249999,
									28.35390625000008
								],
								[
									97.3564453125,
									28.254492187499977
								],
								[
									97.32246093750018,
									28.217968750000097
								],
								[
									97.28945312500014,
									28.236816406250114
								],
								[
									97.1451171875002,
									28.340332031250057
								],
								[
									97.07539062500001,
									28.368945312500017
								],
								[
									96.98085937500014,
									28.337695312500045
								],
								[
									96.83300781250023,
									28.36240234375012
								],
								[
									96.77578125000008,
									28.36704101562509
								],
								[
									96.65283203125011,
									28.44975585937496
								],
								[
									96.60263671875009,
									28.459912109375182
								],
								[
									96.42773437500017,
									28.40600585937503
								],
								[
									96.38906250000002,
									28.367919921875085
								],
								[
									96.36640625000018,
									28.367285156250034
								],
								[
									96.31982421875011,
									28.386523437500045
								],
								[
									96.28144531250013,
									28.41206054687501
								],
								[
									96.27890625000032,
									28.42817382812501
								],
								[
									96.326171875,
									28.46855468750016
								],
								[
									96.32988281250005,
									28.496826171875057
								],
								[
									96.32734375000001,
									28.525390625
								],
								[
									96.39560546875015,
									28.60654296875012
								],
								[
									96.58085937500016,
									28.76367187499997
								],
								[
									96.55000000000013,
									28.82958984375017
								],
								[
									96.4771484375002,
									28.959326171875034
								],
								[
									96.46708984374999,
									29.022265625000074
								],
								[
									96.4357421875003,
									29.050683593749994
								],
								[
									96.34687500000001,
									29.027441406250063
								],
								[
									96.16220703125003,
									28.90971679687516
								],
								[
									96.13710937500008,
									28.922607421875114
								],
								[
									96.14140625000016,
									28.96347656250009
								],
								[
									96.12236328125005,
									29.082080078125102
								],
								[
									96.18085937500001,
									29.11767578124997
								],
								[
									96.27050781250011,
									29.161230468750063
								],
								[
									96.33974609375014,
									29.20981445312509
								],
								[
									96.35585937499997,
									29.249072265625102
								],
								[
									96.33720703124999,
									29.26098632812503
								],
								[
									96.23496093750003,
									29.245800781249955
								],
								[
									96.19472656250008,
									29.272460937500057
								],
								[
									96.1285156250002,
									29.381396484375045
								],
								[
									96.07958984375011,
									29.424121093750045
								],
								[
									96.03535156250013,
									29.44716796875005
								],
								[
									95.88505859375016,
									29.39091796875013
								],
								[
									95.71035156250008,
									29.313818359375063
								],
								[
									95.51582031250018,
									29.206347656250102
								],
								[
									95.51699218750014,
									29.151171875000045
								],
								[
									95.4937500000002,
									29.137011718750102
								],
								[
									95.45654296875011,
									29.10229492187503
								],
								[
									95.42021484375016,
									29.05429687500012
								],
								[
									95.38925781250003,
									29.03740234374996
								],
								[
									95.35312500000009,
									29.035888671875
								],
								[
									95.27910156249999,
									29.049560546874943
								],
								[
									95.14472656250018,
									29.10405273437513
								],
								[
									94.99882812499999,
									29.149169921875085
								],
								[
									94.96748046875001,
									29.144042968750114
								],
								[
									94.7694335937502,
									29.175878906250006
								],
								[
									94.76308593750014,
									29.20126953124995
								],
								[
									94.73339843750023,
									29.25161132812508
								],
								[
									94.67705078124999,
									29.297021484375193
								],
								[
									94.62304687500011,
									29.312402343750023
								],
								[
									94.46806640625016,
									29.216210937499966
								],
								[
									94.29326171875016,
									29.14462890624995
								],
								[
									94.19345703125009,
									29.059912109375006
								],
								[
									94.11152343750018,
									28.97587890625013
								],
								[
									94.01767578125003,
									28.959521484375074
								],
								[
									94.01328125000003,
									28.90751953124996
								],
								[
									93.97363281249994,
									28.86079101562504
								],
								[
									93.90224609374997,
									28.80322265625003
								],
								[
									93.76074218750011,
									28.72978515624999
								],
								[
									93.66494140625014,
									28.690234374999932
								],
								[
									93.36054687500001,
									28.654052734375114
								],
								[
									93.25195312500011,
									28.62949218750009
								],
								[
									93.20654296875011,
									28.590820312500114
								],
								[
									93.1578125000002,
									28.492724609375017
								],
								[
									93.11923828125009,
									28.402294921875068
								],
								[
									93.0349609375001,
									28.327636718750057
								],
								[
									92.88183593750011,
									28.22812500000012
								],
								[
									92.70185546875001,
									28.14711914062505
								],
								[
									92.65253906250001,
									28.093359375000006
								],
								[
									92.64345703125014,
									28.0615234375
								],
								[
									92.66562500000032,
									28.04985351562513
								],
								[
									92.68749999999994,
									28.02573242187509
								],
								[
									92.68779296874999,
									27.988964843750153
								],
								[
									92.6643554687501,
									27.948925781250068
								],
								[
									92.5466796875001,
									27.879199218750074
								],
								[
									92.4806640625003,
									27.845947265625057
								],
								[
									92.41484374999999,
									27.824609374999966
								],
								[
									92.34101562500013,
									27.820751953125068
								],
								[
									92.2701171875002,
									27.83022460937505
								],
								[
									92.25048828125011,
									27.84150390625004
								],
								[
									92.2222656250002,
									27.826953125000102
								],
								[
									92.15761718750008,
									27.812255859374943
								],
								[
									92.10126953125018,
									27.807617187500057
								],
								[
									91.9776367187502,
									27.73037109375005
								],
								[
									91.90937500000013,
									27.729687500000097
								],
								[
									91.82470703125011,
									27.746435546875034
								],
								[
									91.71259765625001,
									27.759814453125102
								],
								[
									91.63193359375009,
									27.75996093750004
								],
								[
									91.62939453125006,
									27.80087890625012
								],
								[
									91.64189453124999,
									27.923242187499994
								],
								[
									91.60556640625009,
									27.951708984375017
								],
								[
									91.49335937500001,
									27.98178710937512
								],
								[
									91.36757812500008,
									28.021630859374966
								],
								[
									91.30683593750007,
									28.064013671875074
								],
								[
									91.2730468750002,
									28.07836914062497
								],
								[
									91.2258789062501,
									28.07124023437504
								],
								[
									91.14990234375006,
									28.026757812500023
								],
								[
									91.0777343750002,
									27.974462890625034
								],
								[
									91.02080078125005,
									27.970068359375034
								],
								[
									90.96250000000009,
									27.99458007812504
								],
								[
									90.90664062500014,
									28.02651367187508
								],
								[
									90.71572265625008,
									28.07172851562504
								],
								[
									90.63007812500001,
									28.07856445312501
								],
								[
									90.4773437500001,
									28.070849609375045
								],
								[
									90.35273437500007,
									28.080224609374994
								],
								[
									90.3331054687502,
									28.093994140625057
								],
								[
									90.33378906250016,
									28.11914062500003
								],
								[
									90.35214843750009,
									28.168164062500068
								],
								[
									90.36298828125007,
									28.21650390625004
								],
								[
									90.34824218750009,
									28.24394531249996
								],
								[
									90.22080078125003,
									28.27773437500008
								],
								[
									90.10449218750006,
									28.302050781250074
								],
								[
									89.98105468750003,
									28.31118164062508
								],
								[
									89.89785156250008,
									28.294140625000068
								],
								[
									89.81689453125011,
									28.256298828124983
								],
								[
									89.74980468749999,
									28.188183593750068
								],
								[
									89.65273437500014,
									28.158300781250006
								],
								[
									89.53691406250005,
									28.10742187500003
								],
								[
									89.48066406250018,
									28.05996093750005
								],
								[
									89.39589843750014,
									27.958154296874994
								],
								[
									89.27265625000007,
									27.833154296875023
								],
								[
									89.16044921875005,
									27.711279296874977
								],
								[
									89.10234374999999,
									27.592578125000045
								],
								[
									89.02548828125003,
									27.517871093750102
								],
								[
									88.94755859374999,
									27.46401367187505
								],
								[
									88.89140624999999,
									27.316064453125023
								],
								[
									88.83251953125011,
									27.362841796875045
								],
								[
									88.76484375000018,
									27.429882812500125
								],
								[
									88.74902343749994,
									27.521875000000023
								],
								[
									88.82988281249999,
									27.76738281250013
								],
								[
									88.84882812500007,
									27.868652343750057
								],
								[
									88.82861328125011,
									27.907275390624932
								],
								[
									88.80371093750011,
									28.00693359375009
								],
								[
									88.75625000000008,
									28.039697265625193
								],
								[
									88.62109375000011,
									28.09184570312516
								],
								[
									88.57792968749999,
									28.093359375000006
								],
								[
									88.5316406250002,
									28.057373046875057
								],
								[
									88.48613281250016,
									28.034472656250102
								],
								[
									88.42597656250013,
									28.011669921875068
								],
								[
									88.27519531250016,
									27.968847656250148
								],
								[
									88.14111328125011,
									27.948925781250068
								],
								[
									88.10898437500003,
									27.933007812500023
								],
								[
									88.0989257812501,
									27.904541015625085
								],
								[
									88.10976562500014,
									27.87060546875003
								],
								[
									88.02333984375008,
									27.883398437500034
								],
								[
									87.93339843750005,
									27.89082031250004
								],
								[
									87.86074218750002,
									27.886083984375063
								],
								[
									87.68271484375003,
									27.82138671875012
								],
								[
									87.62255859375006,
									27.815185546875
								],
								[
									87.55527343750015,
									27.821826171875017
								],
								[
									87.46416015625005,
									27.82382812500009
								],
								[
									87.29072265625007,
									27.82192382812505
								],
								[
									87.14140624999999,
									27.83833007812501
								],
								[
									87.02011718750009,
									27.92866210937504
								],
								[
									86.93378906250018,
									27.968457031250068
								],
								[
									86.84238281250009,
									27.999169921875108
								],
								[
									86.75039062500002,
									28.022070312500063
								],
								[
									86.71962890625014,
									28.070654296875006
								],
								[
									86.69052734375009,
									28.094921875000068
								],
								[
									86.61445312500001,
									28.10302734375003
								],
								[
									86.55449218750005,
									28.08520507812503
								],
								[
									86.51689453125016,
									27.963525390625023
								],
								[
									86.48496093750009,
									27.939550781250034
								],
								[
									86.40869140625011,
									27.92866210937504
								],
								[
									86.32861328125006,
									27.959521484375017
								],
								[
									86.21796875000007,
									28.022070312500063
								],
								[
									86.17421875000014,
									28.091699218750023
								],
								[
									86.13701171875005,
									28.11435546875012
								],
								[
									86.07871093750003,
									28.083593749999977
								],
								[
									86.07548828124999,
									27.99458007812504
								],
								[
									86.06416015625013,
									27.934716796875023
								],
								[
									85.99453125000014,
									27.91040039062503
								],
								[
									85.95410156250006,
									27.92822265625003
								],
								[
									85.92167968750005,
									27.98969726562504
								],
								[
									85.84023437500014,
									28.135351562500034
								],
								[
									85.75947265625001,
									28.22065429687501
								],
								[
									85.6783203125002,
									28.277441406250034
								],
								[
									85.41064453125011,
									28.276025390625108
								],
								[
									85.21210937500007,
									28.292626953125023
								],
								[
									85.12246093750002,
									28.315966796875074
								],
								[
									85.08857421875001,
									28.372265624999983
								],
								[
									85.12148437500008,
									28.48427734375008
								],
								[
									85.16015625000006,
									28.571874999999977
								],
								[
									85.15908203125002,
									28.59223632812504
								],
								[
									85.12636718750002,
									28.60263671875012
								],
								[
									85.06914062500005,
									28.609667968750045
								],
								[
									84.85507812500009,
									28.55361328125008
								],
								[
									84.79687500000011,
									28.560205078124994
								],
								[
									84.75937500000009,
									28.579248046874966
								],
								[
									84.71425781250008,
									28.595556640625006
								],
								[
									84.67675781250006,
									28.621533203125068
								],
								[
									84.65058593750007,
									28.65957031250008
								],
								[
									84.4654296875002,
									28.7529296875
								],
								[
									84.41074218750003,
									28.803906250000097
								],
								[
									84.31210937500009,
									28.86811523437501
								],
								[
									84.22871093750007,
									28.911767578125023
								],
								[
									84.17558593749999,
									29.036376953125114
								],
								[
									84.12783203125014,
									29.156298828125017
								],
								[
									84.10136718749999,
									29.21997070312503
								],
								[
									84.02197265625,
									29.253857421875097
								],
								[
									83.93593750000014,
									29.279492187499983
								],
								[
									83.79042968750008,
									29.22744140625005
								],
								[
									83.67109375000007,
									29.187597656250006
								],
								[
									83.58349609375011,
									29.183593750000085
								],
								[
									83.4566406250002,
									29.30634765625004
								],
								[
									83.35517578125001,
									29.43916015625001
								],
								[
									83.23515624999999,
									29.55458984375008
								],
								[
									83.15546875000001,
									29.61264648437509
								],
								[
									83.01396484375005,
									29.61806640625005
								],
								[
									82.85429687500005,
									29.683398437500017
								],
								[
									82.64082031250018,
									29.831201171875023
								],
								[
									82.48652343750018,
									29.941503906250034
								],
								[
									82.22070312500011,
									30.063867187499994
								],
								[
									82.15898437500016,
									30.115185546875068
								],
								[
									82.13535156250015,
									30.158984375000017
								],
								[
									82.09892578125005,
									30.245068359375068
								],
								[
									82.04335937500014,
									30.32675781250009
								],
								[
									81.85488281250002,
									30.362402343749977
								],
								[
									81.64189453125016,
									30.387500000000017
								],
								[
									81.41718750000007,
									30.337597656249983
								],
								[
									81.25507812500001,
									30.09331054687496
								],
								[
									81.17714843750014,
									30.03989257812509
								],
								[
									81.11035156250011,
									30.036816406250097
								],
								[
									81.05556640625014,
									30.098974609375034
								],
								[
									81.01025390625006,
									30.164501953124983
								],
								[
									80.98544921875009,
									30.237109375000045
								],
								[
									80.87353515625011,
									30.290576171875102
								],
								[
									80.74677734375001,
									30.360400390625017
								],
								[
									80.68212890625011,
									30.414843750000102
								],
								[
									80.60888671875011,
									30.448876953125193
								],
								[
									80.54101562500023,
									30.463525390625165
								],
								[
									80.40957031250014,
									30.50947265625001
								],
								[
									80.26093750000018,
									30.561328125000102
								],
								[
									80.19121093749999,
									30.568408203124932
								],
								[
									80.18623046875013,
									30.60532226562509
								],
								[
									80.20712890625003,
									30.68374023437508
								],
								[
									80.19433593750011,
									30.759228515625182
								],
								[
									80.14941406250011,
									30.789843749999932
								],
								[
									80.08144531250008,
									30.781933593750097
								],
								[
									79.92451171875001,
									30.888769531250006
								],
								[
									79.9166015625002,
									30.89418945312505
								],
								[
									79.87187500000016,
									30.92460937500013
								],
								[
									79.79462890625001,
									30.968261718750142
								],
								[
									79.66425781250001,
									30.96523437500005
								],
								[
									79.56542968750011,
									30.949072265625034
								],
								[
									79.49316406250006,
									30.993701171875074
								],
								[
									79.38847656250016,
									31.064208984375142
								],
								[
									79.36962890624994,
									31.079931640625148
								],
								[
									79.33876953125014,
									31.10571289062497
								],
								[
									79.23261718750001,
									31.241748046875074
								],
								[
									79.10712890625001,
									31.402636718750074
								],
								[
									79.04374999999999,
									31.426220703125182
								],
								[
									79.01113281250008,
									31.414111328125017
								],
								[
									78.97392578125016,
									31.328613281250085
								],
								[
									78.94599609375018,
									31.33720703125016
								],
								[
									78.8995117187502,
									31.331347656249932
								],
								[
									78.84453124999999,
									31.30151367187517
								],
								[
									78.79160156250003,
									31.293652343750068
								],
								[
									78.75781250000011,
									31.302490234375
								],
								[
									78.74355468750014,
									31.32377929687499
								],
								[
									78.75859375000016,
									31.43657226562516
								],
								[
									78.72675781250018,
									31.47182617187505
								],
								[
									78.75507812500018,
									31.550292968750057
								],
								[
									78.80292968750007,
									31.61806640625008
								],
								[
									78.75390625000011,
									31.668359375000023
								],
								[
									78.69345703125003,
									31.74038085937505
								],
								[
									78.68701171875,
									31.80551757812509
								],
								[
									78.71972656250006,
									31.88764648437504
								],
								[
									78.73544921875015,
									31.957958984375153
								],
								[
									78.72558593750011,
									31.98378906250008
								],
								[
									78.67773437500011,
									32.02304687500009
								],
								[
									78.49589843750005,
									32.2157714843751
								],
								[
									78.48613281249999,
									32.23623046875008
								],
								[
									78.45527343750018,
									32.30034179687499
								],
								[
									78.44130859375008,
									32.397363281250136
								],
								[
									78.41748046874994,
									32.46669921875005
								],
								[
									78.38964843749994,
									32.51987304687495
								],
								[
									78.3916992187502,
									32.544726562500045
								],
								[
									78.41250000000008,
									32.55771484375012
								],
								[
									78.52636718750011,
									32.57080078125003
								],
								[
									78.63154296875007,
									32.57895507812509
								],
								[
									78.70087890625007,
									32.597021484375034
								],
								[
									78.73671874999997,
									32.55839843749999
								],
								[
									78.7535156250002,
									32.499267578125114
								],
								[
									78.77128906249999,
									32.46806640625016
								],
								[
									78.83789062500006,
									32.41196289062509
								],
								[
									78.9189453125,
									32.35820312500016
								],
								[
									78.9976562500002,
									32.36513671875005
								],
								[
									79.06699218750032,
									32.38818359374994
								],
								[
									79.12734374999997,
									32.475781250000125
								],
								[
									79.16992187500011,
									32.49721679687505
								],
								[
									79.21933593750009,
									32.501074218750034
								],
								[
									79.21904296874999,
									32.50756835937503
								],
								[
									79.21650390625001,
									32.56401367187516
								],
								[
									79.23388671875011,
									32.70307617187507
								],
								[
									79.22792968750014,
									32.75878906250006
								],
								[
									79.20556640625011,
									32.80903320312507
								],
								[
									79.2095703125002,
									32.86484375000006
								],
								[
									79.20224609375003,
									32.946044921875085
								],
								[
									79.14550781250011,
									33.001464843750114
								],
								[
									79.10859375000013,
									33.02265625000007
								],
								[
									79.10283203125016,
									33.05253906249993
								],
								[
									79.12167968750009,
									33.10810546875007
								],
								[
									79.13515625000014,
									33.17192382812502
								],
								[
									79.11562499999997,
									33.2189453125001
								],
								[
									79.11250000000007,
									33.22626953124998
								],
								[
									79.0665039062502,
									33.25039062500019
								],
								[
									79.01259765625025,
									33.29145507812504
								],
								[
									78.94843750000001,
									33.34653320312506
								],
								[
									78.91669921875013,
									33.38676757812499
								],
								[
									78.86503906249999,
									33.43110351562507
								],
								[
									78.8018554687502,
									33.49970703125018
								],
								[
									78.78994140624997,
									33.65034179687504
								],
								[
									78.78378906250003,
									33.8087890625001
								],
								[
									78.76171875000011,
									33.887597656250165
								],
								[
									78.72666015625003,
									34.013378906249926
								],
								[
									78.7317382812501,
									34.055566406249994
								],
								[
									78.7530273437502,
									34.087695312500074
								],
								[
									78.9317382812502,
									34.18896484375
								],
								[
									78.97060546875008,
									34.2282226562501
								],
								[
									78.97695312500014,
									34.258105468750045
								],
								[
									78.97011718750008,
									34.302636718750165
								],
								[
									78.93642578124997,
									34.35195312500008
								],
								[
									78.86484375000003,
									34.39033203124998
								],
								[
									78.76308593750008,
									34.452929687500045
								],
								[
									78.67080078125025,
									34.518164062500006
								],
								[
									78.51572265625015,
									34.557958984375034
								],
								[
									78.32695312500016,
									34.606396484374955
								],
								[
									78.28203125000027,
									34.653906250000034
								],
								[
									78.23613281250016,
									34.76982421875013
								],
								[
									78.15849609375005,
									34.946484374999955
								],
								[
									78.07578125000003,
									35.13491210937508
								],
								[
									78.01220703125006,
									35.2510253906251
								],
								[
									78.0091796875002,
									35.30693359375013
								],
								[
									78.04746093750009,
									35.44941406250001
								],
								[
									78.04267578125018,
									35.479785156250074
								],
								[
									78.00947265625007,
									35.49023437500017
								],
								[
									77.94589843750009,
									35.47163085937501
								],
								[
									77.89492187500014,
									35.44902343750002
								],
								[
									77.85156250000011,
									35.46079101562512
								],
								[
									77.81093750000008,
									35.484521484374966
								],
								[
									77.80253906249999,
									35.49277343750006
								],
								[
									77.79941406250009,
									35.495898437500074
								],
								[
									77.72402343750008,
									35.48056640625006
								],
								[
									77.57255859375005,
									35.47182617187505
								],
								[
									77.52001953125,
									35.47343750000002
								],
								[
									77.44648437500001,
									35.475585937500114
								],
								[
									77.29482421875014,
									35.50815429687509
								],
								[
									77.09003906250007,
									35.55205078124996
								],
								[
									76.87890625000011,
									35.61328125
								],
								[
									76.76689453125005,
									35.661718750000006
								],
								[
									76.72753906250011,
									35.6786621093751
								],
								[
									76.63183593750006,
									35.72939453125002
								],
								[
									76.5634765625,
									35.772998046875045
								],
								[
									76.55126953125,
									35.88706054687509
								],
								[
									76.50205078125009,
									35.878222656250074
								],
								[
									76.38574218750011,
									35.83715820312506
								],
								[
									76.25166015625007,
									35.81093750000002
								],
								[
									76.17783203125009,
									35.81054687500006
								],
								[
									76.14785156250014,
									35.82900390625008
								],
								[
									76.10332031250005,
									35.94921875000006
								],
								[
									76.07089843750009,
									35.983007812500006
								],
								[
									76.01044921875001,
									35.99633789062497
								],
								[
									75.94511718750005,
									36.01757812500003
								],
								[
									75.91230468750001,
									36.04897460937502
								],
								[
									75.90488281250003,
									36.08847656250009
								],
								[
									75.93408203125011,
									36.13393554687502
								],
								[
									75.96865234375014,
									36.16884765625002
								],
								[
									75.97441406250005,
									36.38242187500012
								],
								[
									75.95185546875007,
									36.45810546875006
								],
								[
									75.93300781250008,
									36.521582031250034
								],
								[
									75.88496093750007,
									36.600732421874994
								],
								[
									75.84023437500008,
									36.64970703125002
								],
								[
									75.77216796875018,
									36.694921875000006
								],
								[
									75.66718750000007,
									36.7419921875001
								],
								[
									75.57373046875006,
									36.759326171875074
								],
								[
									75.46025390625005,
									36.72504882812501
								],
								[
									75.42421875000014,
									36.73823242187504
								],
								[
									75.37685546875008,
									36.88369140625008
								],
								[
									75.3466796875,
									36.91347656250002
								],
								[
									75.14521484375007,
									36.973242187500034
								],
								[
									75.05390625000001,
									36.987158203125034
								],
								[
									74.94912109375008,
									36.96835937500012
								],
								[
									74.88925781250003,
									36.952441406250074
								],
								[
									74.84121093750014,
									36.97910156250009
								],
								[
									74.76601562500008,
									37.0127441406251
								],
								[
									74.69218750000016,
									37.03574218749998
								],
								[
									74.60058593750006,
									37.03666992187499
								],
								[
									74.54140624999997,
									37.02216796875007
								],
								[
									74.52646484375003,
									37.03066406250011
								],
								[
									74.49794921875008,
									37.057226562500006
								],
								[
									74.37617187500007,
									37.13735351562508
								],
								[
									74.37216796875003,
									37.15771484375006
								],
								[
									74.55898437500008,
									37.23662109374996
								],
								[
									74.66894531250011,
									37.26669921875006
								],
								[
									74.72666015625003,
									37.29072265625007
								],
								[
									74.73896484375018,
									37.28564453125
								],
								[
									74.76738281249999,
									37.24916992187502
								],
								[
									74.84023437500002,
									37.2250488281251
								],
								[
									74.89130859375001,
									37.231640624999926
								],
								[
									74.91816406250018,
									37.25000000000003
								],
								[
									75.00839843750009,
									37.29355468750009
								],
								[
									75.07900390624997,
									37.344042968750074
								],
								[
									75.11875000000009,
									37.385693359374955
								],
								[
									75.09746093749999,
									37.45126953125009
								],
								[
									74.98642578125003,
									37.530371093750034
								],
								[
									74.91582031250016,
									37.572802734375074
								],
								[
									74.89423828125018,
									37.601416015625034
								],
								[
									74.91230468750001,
									37.68730468750002
								],
								[
									74.93828124999999,
									37.772509765625074
								],
								[
									74.92128906250002,
									37.80498046874993
								],
								[
									74.90029296874997,
									37.83271484374998
								],
								[
									74.89082031250018,
									37.92578124999994
								],
								[
									74.84248046875001,
									38.038085937500085
								],
								[
									74.78964843750009,
									38.10361328125012
								],
								[
									74.77509765625007,
									38.19189453124997
								],
								[
									74.77207031250009,
									38.27475585937498
								],
								[
									74.83593750000011,
									38.404296875000085
								],
								[
									74.81230468749999,
									38.46030273437495
								],
								[
									74.74501953124997,
									38.51000976562494
								],
								[
									74.51406250000002,
									38.60000000000008
								],
								[
									74.27744140625003,
									38.65976562500009
								],
								[
									74.18730468750005,
									38.657519531250074
								],
								[
									74.13134765625011,
									38.66118164062502
								],
								[
									74.06533203124997,
									38.608496093750034
								],
								[
									74.02558593750007,
									38.53984374999999
								],
								[
									73.97001953124999,
									38.53369140624997
								],
								[
									73.86914062499994,
									38.56289062500005
								],
								[
									73.80166015624997,
									38.60688476562507
								],
								[
									73.75410156250018,
									38.69892578125007
								],
								[
									73.71679687500011,
									38.817236328125006
								],
								[
									73.69609375000016,
									38.85429687500002
								],
								[
									73.70683593750005,
									38.88623046874994
								],
								[
									73.72998046874994,
									38.914697265624966
								],
								[
									73.79453125000003,
									38.94130859375005
								],
								[
									73.80527343750003,
									38.96865234375005
								],
								[
									73.79560546875018,
									39.00214843750001
								],
								[
									73.74375000000009,
									39.04453124999995
								],
								[
									73.6904296875,
									39.10454101562502
								],
								[
									73.60732421875002,
									39.22919921875001
								],
								[
									73.62314453125003,
									39.29785156250006
								],
								[
									73.63632812500003,
									39.396679687499926
								],
								[
									73.6316406250001,
									39.448876953124994
								],
								[
									73.71572265625008,
									39.46225585937506
								],
								[
									73.82294921875007,
									39.48896484375007
								],
								[
									73.87275390625007,
									39.53330078125006
								],
								[
									73.90712890625008,
									39.57851562500002
								],
								[
									73.91464843750009,
									39.606494140625045
								],
								[
									73.88251953125001,
									39.71455078125004
								],
								[
									73.83974609375014,
									39.76284179687511
								],
								[
									73.83535156250002,
									39.80014648437506
								],
								[
									73.85624999999999,
									39.8286621093751
								],
								[
									73.88457031249999,
									39.877929687500085
								],
								[
									73.93876953125005,
									39.978808593750045
								],
								[
									73.99160156250014,
									40.043115234374994
								],
								[
									74.0205078125,
									40.05937500000002
								],
								[
									74.08515625000013,
									40.07431640625006
								],
								[
									74.24267578125006,
									40.092041015625114
								],
								[
									74.41191406250005,
									40.137207031250085
								],
								[
									74.61308593749999,
									40.27216796875004
								],
								[
									74.67988281250001,
									40.31059570312496
								],
								[
									74.76777343750007,
									40.329882812500074
								],
								[
									74.83046875000008,
									40.328515624999966
								],
								[
									74.84179687500006,
									40.34497070312503
								],
								[
									74.80126953125006,
									40.4285156250001
								],
								[
									74.81113281250003,
									40.458789062500045
								],
								[
									74.83515625000007,
									40.48261718750001
								],
								[
									74.86562500000014,
									40.493505859375006
								],
								[
									75.00449218750009,
									40.44951171875002
								],
								[
									75.111328125,
									40.45410156249997
								],
								[
									75.24101562500005,
									40.480273437500074
								],
								[
									75.52080078124999,
									40.627539062500034
								],
								[
									75.55556640625008,
									40.62519531250001
								],
								[
									75.58349609375011,
									40.60532226562506
								],
								[
									75.61738281250007,
									40.5166015625
								],
								[
									75.65595703125001,
									40.32924804687502
								],
								[
									75.67714843750008,
									40.30581054687505
								],
								[
									75.87197265625008,
									40.30322265625006
								],
								[
									76.00429687500002,
									40.371435546875006
								],
								[
									76.06230468750005,
									40.387548828125006
								],
								[
									76.15664062500014,
									40.37646484375006
								],
								[
									76.20605468750011,
									40.40839843749998
								],
								[
									76.25830078125,
									40.43076171875009
								],
								[
									76.31855468750007,
									40.35224609375001
								],
								[
									76.39638671875014,
									40.38979492187502
								],
								[
									76.48017578125018,
									40.44951171875002
								],
								[
									76.52089843750002,
									40.51123046874997
								],
								[
									76.57792968749999,
									40.57788085937506
								],
								[
									76.62216796875003,
									40.66235351562503
								],
								[
									76.63984375000007,
									40.74223632812496
								],
								[
									76.6611328125,
									40.779638671875034
								],
								[
									76.70839843750014,
									40.81811523437497
								],
								[
									76.82402343750005,
									40.98232421875002
								],
								[
									76.90771484375006,
									41.02416992187503
								],
								[
									76.98662109375005,
									41.03916015625006
								],
								[
									77.18203125000014,
									41.01074218750006
								],
								[
									77.28398437500016,
									41.01435546874998
								],
								[
									77.58173828125007,
									40.99277343750012
								],
								[
									77.7193359375002,
									41.024316406249966
								],
								[
									77.81523437499999,
									41.05561523437504
								],
								[
									77.95644531250008,
									41.05068359375011
								],
								[
									78.12343750000008,
									41.07563476562504
								],
								[
									78.34628906250009,
									41.28144531250004
								],
								[
									78.34882812500007,
									41.32519531250006
								],
								[
									78.3624023437502,
									41.37163085937502
								],
								[
									78.44287109375006,
									41.41752929687496
								],
								[
									78.54316406250018,
									41.45957031250009
								],
								[
									78.74257812500002,
									41.56005859375006
								],
								[
									79.14843750000011,
									41.71914062500002
								],
								[
									79.29355468750009,
									41.782812500000034
								],
								[
									79.35439453125014,
									41.781054687500045
								],
								[
									79.50390625000006,
									41.8209960937501
								],
								[
									79.76611328125,
									41.89887695312507
								],
								[
									79.84042968750015,
									41.99575195312508
								],
								[
									79.90966796875011,
									42.01499023437509
								],
								[
									80.21621093750014,
									42.0324218750001
								],
								[
									80.23515625000005,
									42.04345703125003
								],
								[
									80.2461914062502,
									42.059814453125085
								],
								[
									80.22919921875013,
									42.12983398437504
								],
								[
									80.20937500000014,
									42.190039062500034
								],
								[
									80.23300781250009,
									42.20781249999993
								],
								[
									80.25908203125016,
									42.23540039062496
								],
								[
									80.25507812500007,
									42.27416992187506
								],
								[
									80.20576171875001,
									42.39941406250006
								],
								[
									80.17929687500003,
									42.51835937499996
								],
								[
									80.16191406250016,
									42.625537109375045
								],
								[
									80.1650390625,
									42.665527343750114
								],
								[
									80.2022460937502,
									42.734472656250034
								],
								[
									80.25029296875016,
									42.79726562499994
								],
								[
									80.42402343750018,
									42.85576171874996
								],
								[
									80.53896484375014,
									42.873486328124926
								],
								[
									80.54375000000016,
									42.91171875000009
								],
								[
									80.45068359375011,
									42.93554687500006
								],
								[
									80.38339843750009,
									42.97377929687502
								],
								[
									80.37128906250018,
									42.99560546875003
								],
								[
									80.37451171874994,
									43.02041015625002
								],
								[
									80.39023437500003,
									43.04311523437494
								],
								[
									80.50703125000001,
									43.08579101562509
								],
								[
									80.61699218750016,
									43.12827148437506
								],
								[
									80.75117187500001,
									43.102490234374955
								],
								[
									80.77773437500014,
									43.11894531249993
								],
								[
									80.78574218750003,
									43.1615722656251
								],
								[
									80.75703125000018,
									43.204345703125085
								],
								[
									80.72978515625005,
									43.27426757812495
								],
								[
									80.66777343749999,
									43.31005859375006
								],
								[
									80.66542968749997,
									43.3529785156251
								],
								[
									80.70380859375018,
									43.42705078124999
								],
								[
									80.65078125000002,
									43.56416015625004
								],
								[
									80.59345703125007,
									43.68510742187499
								],
								[
									80.49599609375002,
									43.89208984375006
								],
								[
									80.43154296875014,
									43.95175781249995
								],
								[
									80.39580078125005,
									44.04716796875002
								],
								[
									80.35527343750005,
									44.09726562500012
								],
								[
									80.35898437500009,
									44.17128906250008
								],
								[
									80.3653320312502,
									44.22329101562494
								],
								[
									80.35488281250014,
									44.326513671875006
								],
								[
									80.33632812499997,
									44.438378906249966
								],
								[
									80.35507812500009,
									44.55200195312503
								],
								[
									80.39101562500014,
									44.62680664062509
								],
								[
									80.3814453125002,
									44.65541992187505
								],
								[
									80.40058593750001,
									44.67690429687508
								],
								[
									80.45546875000002,
									44.68408203125003
								],
								[
									80.48154296875009,
									44.714648437500045
								],
								[
									80.45546875000002,
									44.74609375000006
								],
								[
									80.36083984375011,
									44.7703125000001
								],
								[
									80.25507812500007,
									44.80810546874997
								],
								[
									80.12783203125014,
									44.803759765625074
								],
								[
									79.99716796875009,
									44.79721679687498
								],
								[
									79.93212890625,
									44.825195312500085
								],
								[
									79.87529296875005,
									44.86083984374997
								],
								[
									79.87187500000016,
									44.88378906249994
								],
								[
									79.95019531250011,
									44.94409179687497
								],
								[
									80.0591796875002,
									45.00644531250006
								],
								[
									80.22822265625018,
									45.03398437499999
								],
								[
									80.41494140625002,
									45.07509765625011
								],
								[
									80.50917968750014,
									45.10498046874997
								],
								[
									80.63476562500011,
									45.1265136718751
								],
								[
									80.78007812500016,
									45.135546875000074
								],
								[
									80.85332031250016,
									45.12929687500005
								],
								[
									81.04033203125016,
									45.16914062499998
								],
								[
									81.33476562499999,
									45.24619140625006
								],
								[
									81.60205078125011,
									45.31083984374999
								],
								[
									81.6919921875002,
									45.34936523437503
								],
								[
									81.75888671875009,
									45.31083984374999
								],
								[
									81.7896484375002,
									45.22602539062504
								],
								[
									81.86748046874999,
									45.182080078124955
								],
								[
									81.94492187500003,
									45.16083984374998
								],
								[
									81.98925781250011,
									45.161865234375114
								],
								[
									82.12275390625007,
									45.19487304687499
								],
								[
									82.26660156249994,
									45.21909179687495
								],
								[
									82.32343750000018,
									45.2058593750001
								],
								[
									82.39667968750018,
									45.162451171875034
								],
								[
									82.47871093750018,
									45.123583984375045
								],
								[
									82.52148437500011,
									45.12548828124997
								],
								[
									82.55898437500002,
									45.15541992187502
								],
								[
									82.59697265625005,
									45.21596679687494
								],
								[
									82.62109374999994,
									45.29311523437502
								],
								[
									82.62578125000005,
									45.37441406250005
								],
								[
									82.61162109375016,
									45.42426757812501
								],
								[
									82.58251953125011,
									45.44257812500001
								],
								[
									82.45166015625,
									45.471972656250045
								],
								[
									82.32666015625011,
									45.51992187500005
								],
								[
									82.31220703125018,
									45.563720703125085
								],
								[
									82.31523437499999,
									45.594921874999955
								],
								[
									82.34814453124994,
									45.67153320312502
								],
								[
									82.42968749999994,
									45.81191406250002
								],
								[
									82.51171874999994,
									46.0058105468751
								],
								[
									82.55507812500002,
									46.15869140624997
								],
								[
									82.69218750000016,
									46.38666992187504
								],
								[
									82.80000000000018,
									46.6244628906251
								],
								[
									82.97490234374999,
									46.966015624999955
								],
								[
									83.00410156250018,
									47.03349609374993
								],
								[
									83.02011718750009,
									47.14145507812509
								],
								[
									83.02949218750001,
									47.185937499999994
								],
								[
									83.09033203125,
									47.209374999999966
								],
								[
									83.19306640625007,
									47.186572265625045
								],
								[
									83.44355468750018,
									47.10864257812506
								],
								[
									83.63408203124999,
									47.04321289062506
								],
								[
									83.7139648437502,
									47.021044921875074
								],
								[
									83.83261718750003,
									46.997851562500045
								],
								[
									84.01601562500002,
									46.970507812500074
								],
								[
									84.12207031249994,
									46.978613281250034
								],
								[
									84.21513671875016,
									46.994726562500034
								],
								[
									84.3388671875,
									46.99614257812496
								],
								[
									84.53242187500007,
									46.97578124999998
								],
								[
									84.59228515625011,
									46.97495117187509
								],
								[
									84.66660156250003,
									46.9723632812501
								],
								[
									84.71953125000016,
									46.93935546874994
								],
								[
									84.74599609375014,
									46.86435546875012
								],
								[
									84.78613281249994,
									46.83071289062511
								],
								[
									84.85820312499999,
									46.843164062499966
								],
								[
									85.01220703125011,
									46.90922851562493
								],
								[
									85.11054687500018,
									46.961230468750045
								],
								[
									85.23349609375009,
									47.036376953125085
								],
								[
									85.35537109375014,
									47.04672851562506
								],
								[
									85.48476562500002,
									47.06352539062502
								],
								[
									85.52968750000002,
									47.10078125000004
								],
								[
									85.5772460937502,
									47.18847656249997
								],
								[
									85.65664062500014,
									47.25463867187506
								],
								[
									85.66982421875014,
									47.33837890625006
								],
								[
									85.64179687500001,
									47.3974121093751
								],
								[
									85.58662109375018,
									47.49365234374997
								],
								[
									85.58828125000014,
									47.55849609375005
								],
								[
									85.5616210937502,
									47.746484374999966
								],
								[
									85.52597656250003,
									47.91562500000006
								],
								[
									85.56230468749999,
									48.051855468750006
								],
								[
									85.62636718749997,
									48.20400390625011
								],
								[
									85.65156250000007,
									48.25053710937499
								],
								[
									85.69218750000016,
									48.311816406250045
								],
								[
									85.74941406250002,
									48.385058593750045
								],
								[
									85.82988281250016,
									48.40805664062509
								],
								[
									86.05615234375,
									48.42373046875011
								],
								[
									86.26562500000011,
									48.45454101562498
								],
								[
									86.37255859374994,
									48.48623046875005
								],
								[
									86.48330078125014,
									48.50537109374994
								],
								[
									86.5494140625002,
									48.528613281250074
								],
								[
									86.66376953125007,
									48.635546875000074
								],
								[
									86.71796875000018,
									48.69716796874994
								],
								[
									86.75781250000011,
									48.86074218750005
								],
								[
									86.7286132812502,
									48.93935546875008
								],
								[
									86.75312500000001,
									49.00883789062493
								],
								[
									86.80830078125018,
									49.049707031249994
								],
								[
									86.88593750000018,
									49.09057617187497
								],
								[
									86.93798828124994,
									49.09755859375005
								],
								[
									87.04853515625018,
									49.1099121093751
								],
								[
									87.22998046875011,
									49.10585937500008
								],
								[
									87.3228515625002,
									49.08579101562498
								],
								[
									87.41669921875007,
									49.07661132812507
								],
								[
									87.47617187500009,
									49.09145507812505
								],
								[
									87.51582031250018,
									49.12241210937498
								],
								[
									87.57656250000002,
									49.13237304687496
								],
								[
									87.66835937499997,
									49.14721679687506
								],
								[
									87.76250000000016,
									49.16582031249993
								],
								[
									87.81425781250005,
									49.162304687499926
								],
								[
									87.82519531250006,
									49.11630859374998
								],
								[
									87.81630859375002,
									49.08027343750001
								],
								[
									87.83466796875001,
									49.03193359375001
								],
								[
									87.87216796875009,
									49.00014648437502
								],
								[
									87.85986328125011,
									48.96552734374998
								],
								[
									87.80683593750001,
									48.9455078125001
								],
								[
									87.75468750000005,
									48.918554687500006
								],
								[
									87.74316406250011,
									48.881640625000045
								],
								[
									87.80917968750009,
									48.83574218750002
								],
								[
									87.83183593750005,
									48.79165039062508
								],
								[
									87.9421875000001,
									48.76528320312505
								],
								[
									88.02792968750003,
									48.73559570312503
								],
								[
									88.06005859375011,
									48.70717773437502
								],
								[
									88.05019531250014,
									48.67504882812506
								],
								[
									88.01064453125008,
									48.64042968750002
								],
								[
									87.97226562500009,
									48.6033203125001
								],
								[
									87.96738281250003,
									48.5810546875
								],
								[
									87.97968750000018,
									48.55512695312504
								],
								[
									88.0625976562502,
									48.537841796875085
								],
								[
									88.15820312500011,
									48.50908203124999
								],
								[
									88.30996093750014,
									48.472070312499994
								],
								[
									88.41396484375008,
									48.403417968750034
								],
								[
									88.51708984375006,
									48.38447265625001
								],
								[
									88.56679687500014,
									48.31743164062502
								],
								[
									88.57597656250016,
									48.22016601562501
								],
								[
									88.68183593750001,
									48.17055664062502
								],
								[
									88.83828125000014,
									48.10170898437505
								],
								[
									88.91777343750016,
									48.08901367187502
								],
								[
									88.97109375000008,
									48.04995117187508
								],
								[
									89.04765625000016,
									48.00253906250009
								],
								[
									89.11562500000014,
									47.987695312499994
								],
								[
									89.19628906250006,
									47.98090820312504
								],
								[
									89.3298828125001,
									48.02485351562501
								],
								[
									89.47919921875001,
									48.029052734375085
								],
								[
									89.56093750000008,
									48.00395507812502
								],
								[
									89.63847656250005,
									47.909082031249966
								],
								[
									89.69316406249999,
									47.879150390625
								],
								[
									89.72558593750006,
									47.85249023437498
								],
								[
									89.77812499999999,
									47.827001953125034
								],
								[
									89.83134765624999,
									47.82329101562499
								],
								[
									89.91044921875016,
									47.844335937500006
								],
								[
									89.95869140625001,
									47.886328125000034
								],
								[
									90.0279296875002,
									47.87768554687506
								],
								[
									90.05390625000007,
									47.85048828125002
								],
								[
									90.06660156250018,
									47.80356445312506
								],
								[
									90.10322265625018,
									47.74541015625002
								],
								[
									90.1910156250002,
									47.70209960937498
								],
								[
									90.31328125000016,
									47.67617187500002
								],
								[
									90.33066406250003,
									47.65517578125002
								],
								[
									90.34746093749999,
									47.596972656250074
								],
								[
									90.38066406249999,
									47.556640625000114
								],
								[
									90.42519531250014,
									47.50410156250007
								],
								[
									90.46748046875001,
									47.40815429687507
								],
								[
									90.47646484375008,
									47.32880859375007
								],
								[
									90.4961914062502,
									47.28515625000006
								],
								[
									90.55292968750001,
									47.21401367187502
								],
								[
									90.64335937500005,
									47.10029296875004
								],
								[
									90.71552734375001,
									47.00385742187501
								],
								[
									90.79902343750018,
									46.985156250000045
								],
								[
									90.86992187500005,
									46.95449218750008
								],
								[
									90.91054687500014,
									46.88325195312507
								],
								[
									90.98574218750002,
									46.74902343749997
								],
								[
									90.99785156250005,
									46.6610839843751
								],
								[
									91.00429687500014,
									46.59575195312502
								],
								[
									91.0289062500002,
									46.56606445312511
								],
								[
									91.03388671875007,
									46.52900390625001
								],
								[
									90.97148437500005,
									46.38798828124996
								],
								[
									90.91826171875005,
									46.324267578125045
								],
								[
									90.91152343750008,
									46.27065429687505
								],
								[
									90.94755859375005,
									46.17729492187502
								],
								[
									90.99677734375001,
									46.10498046875003
								],
								[
									91.00175781250005,
									46.03579101562508
								],
								[
									90.95976562500005,
									45.98505859375004
								],
								[
									90.88710937500008,
									45.921630859375085
								],
								[
									90.85244140625014,
									45.88540039062508
								],
								[
									90.79589843750006,
									45.85351562499997
								],
								[
									90.70966796875018,
									45.73081054687512
								],
								[
									90.67070312500005,
									45.59516601562501
								],
								[
									90.66181640625007,
									45.52524414062506
								],
								[
									90.69443359375009,
									45.474658203125045
								],
								[
									90.74960937500015,
									45.418945312500085
								],
								[
									90.76318359375006,
									45.3706542968751
								],
								[
									90.85322265625007,
									45.26289062500007
								],
								[
									90.87724609374999,
									45.196093750000074
								],
								[
									90.91396484375014,
									45.19394531249998
								],
								[
									90.95361328125011,
									45.21591796875009
								],
								[
									91.05000000000001,
									45.217431640624966
								],
								[
									91.13769531250006,
									45.19394531249998
								],
								[
									91.22177734375003,
									45.14453125000003
								],
								[
									91.31210937500003,
									45.11811523437498
								],
								[
									91.44101562500009,
									45.124755859375
								],
								[
									91.51005859375005,
									45.09824218750012
								],
								[
									91.58437500000002,
									45.076513671875034
								],
								[
									91.73779296875011,
									45.068945312500006
								],
								[
									91.85283203124999,
									45.069335937500085
								],
								[
									92.02978515625,
									45.06850585937508
								],
								[
									92.17265625000016,
									45.03525390624998
								],
								[
									92.42382812500006,
									45.00893554687502
								],
								[
									92.57890625000005,
									45.010986328125085
								],
								[
									92.78789062500005,
									45.03574218750009
								],
								[
									92.91601562500006,
									45.02016601562511
								],
								[
									93.29433593750014,
									44.98315429687503
								],
								[
									93.51621093750009,
									44.94448242187505
								],
								[
									93.65644531250007,
									44.90097656249998
								],
								[
									93.75527343750008,
									44.83193359375002
								],
								[
									93.86816406250006,
									44.724218750000034
								],
								[
									93.95791015625014,
									44.67495117187502
								],
								[
									94.19931640625009,
									44.645166015624994
								],
								[
									94.36474609375006,
									44.51948242187507
								],
								[
									94.49433593750007,
									44.47250976562509
								],
								[
									94.71201171875009,
									44.350830078125085
								],
								[
									94.86601562500005,
									44.30332031250009
								],
								[
									95.04980468750011,
									44.25942382812502
								],
								[
									95.35029296875001,
									44.278076171875
								],
								[
									95.3667968750002,
									44.2615234375001
								],
								[
									95.34365234375002,
									44.195410156250034
								],
								[
									95.32558593750014,
									44.10488281250005
								],
								[
									95.32558593750014,
									44.039355468750045
								],
								[
									95.35644531250011,
									44.00595703124998
								],
								[
									95.47128906250009,
									43.986181640625034
								],
								[
									95.52558593750001,
									43.953955078125034
								],
								[
									95.56718750000005,
									43.892236328124994
								],
								[
									95.59121093750008,
									43.853613281250034
								],
								[
									95.68730468750005,
									43.66406250000006
								],
								[
									95.84199218750013,
									43.38369140625005
								],
								[
									95.85957031250001,
									43.275976562500034
								],
								[
									95.91250000000008,
									43.2064941406251
								],
								[
									96.08027343750007,
									43.09614257812507
								],
								[
									96.16845703125,
									43.01450195312506
								],
								[
									96.29951171875007,
									42.928710937500085
								],
								[
									96.34248046875013,
									42.84931640625007
								],
								[
									96.35234375000005,
									42.74677734375004
								],
								[
									96.38544921875007,
									42.720361328124994
								],
								[
									96.62529296875005,
									42.74384765624998
								],
								[
									96.83300781250011,
									42.76025390625003
								],
								[
									97.2056640625002,
									42.789794921875114
								],
								[
									97.71894531250001,
									42.73627929687504
								],
								[
									98.24824218750007,
									42.68452148437507
								],
								[
									98.71630859375011,
									42.638720703125074
								],
								[
									98.94687500000009,
									42.6162109375
								],
								[
									99.4678710937502,
									42.56821289062509
								],
								[
									99.75742187500009,
									42.629443359375045
								],
								[
									99.98378906250014,
									42.67734375000012
								],
								[
									100.08632812500014,
									42.67075195312509
								],
								[
									100.51904296875011,
									42.616796875000034
								],
								[
									100.77255859375003,
									42.58779296875008
								],
								[
									101.09199218750001,
									42.55131835937502
								],
								[
									101.31376953124999,
									42.537890625000045
								],
								[
									101.49531250000007,
									42.53876953125004
								],
								[
									101.57910156250006,
									42.523535156250034
								],
								[
									101.65996093749999,
									42.50004882812496
								],
								[
									101.7138671875,
									42.465820312500085
								],
								[
									101.87988281250006,
									42.29233398437509
								],
								[
									101.97294921874999,
									42.215869140625074
								],
								[
									102.15664062500014,
									42.15810546875002
								],
								[
									102.57519531250006,
									42.09208984374999
								],
								[
									102.80683593750018,
									42.052001953125085
								],
								[
									103.07285156250009,
									42.00595703125012
								],
								[
									103.24785156250005,
									41.93657226562502
								],
								[
									103.44970703125011,
									41.855859374999994
								],
								[
									103.71113281250007,
									41.75131835937512
								],
								[
									103.99726562500001,
									41.79697265625009
								],
								[
									104.30517578125006,
									41.84614257812507
								],
								[
									104.49824218750007,
									41.877001953125045
								],
								[
									104.49824218750007,
									41.65869140624997
								],
								[
									104.77363281250013,
									41.64116210937496
								],
								[
									104.86035156250011,
									41.64375000000004
								],
								[
									104.98203125000009,
									41.595507812500074
								],
								[
									105.05058593750005,
									41.61591796875007
								],
								[
									105.11542968750013,
									41.66328125000001
								],
								[
									105.19707031250005,
									41.73803710937497
								],
								[
									105.31435546875014,
									41.77089843750011
								],
								[
									105.51708984375006,
									41.85473632812503
								],
								[
									105.56640625000006,
									41.875097656250006
								],
								[
									105.86757812500014,
									41.99399414062506
								],
								[
									106.31718750000005,
									42.14057617187501
								],
								[
									106.51875000000007,
									42.211572265624994
								],
								[
									106.57910156250006,
									42.2273437500001
								],
								[
									106.69316406249999,
									42.26357421875002
								],
								[
									106.77001953125011,
									42.28872070312508
								],
								[
									106.90605468750005,
									42.30888671875002
								],
								[
									107.09072265625008,
									42.321533203125114
								],
								[
									107.29238281250014,
									42.34926757812508
								],
								[
									107.74873046875001,
									42.400976562500034
								],
								[
									107.80595703125016,
									42.40585937500006
								],
								[
									108.06230468750016,
									42.42719726562504
								],
								[
									108.17119140625005,
									42.447314453125045
								],
								[
									108.33398437500006,
									42.43676757812503
								],
								[
									108.54648437500009,
									42.429296875000034
								],
								[
									108.68730468749999,
									42.416113281250006
								],
								[
									108.87451171875006,
									42.42646484374998
								],
								[
									109.13164062500005,
									42.44057617187502
								],
								[
									109.33984375,
									42.43837890625011
								],
								[
									109.44316406249999,
									42.45595703125005
								],
								[
									109.59550781250005,
									42.510546875000074
								],
								[
									109.69804687500016,
									42.55380859375009
								],
								[
									109.85878906250014,
									42.60625000000002
								],
								[
									110.05800781250014,
									42.66059570312498
								],
								[
									110.19687500000009,
									42.71000976562502
								],
								[
									110.28886718750005,
									42.74272460937502
								],
								[
									110.40039062500006,
									42.77368164062503
								],
								[
									110.42958984375014,
									42.81357421874998
								],
								[
									110.46171875000005,
									42.84414062500008
								],
								[
									110.52089843750008,
									42.895263671875114
								],
								[
									110.62753906250003,
									42.990527343750045
								],
								[
									110.70859375000003,
									43.07387695312508
								],
								[
									110.74853515625011,
									43.11079101562504
								],
								[
									110.83955078125007,
									43.19409179687506
								],
								[
									110.91328125000007,
									43.25688476562496
								],
								[
									111.00722656250014,
									43.341406250000034
								],
								[
									111.08652343750015,
									43.36875000000012
								],
								[
									111.18681640625005,
									43.39199218750005
								],
								[
									111.45107421875014,
									43.474902343750074
								],
								[
									111.50351562500009,
									43.49277343750006
								],
								[
									111.54736328125006,
									43.49628906250007
								],
								[
									111.64082031250018,
									43.56318359375001
								],
								[
									111.7197265625,
									43.62114257812502
								],
								[
									111.77109375000003,
									43.664599609375074
								],
								[
									111.87812500000013,
									43.68017578125006
								],
								[
									111.93320312500003,
									43.711425781250114
								],
								[
									111.94287109375006,
									43.75244140625003
								],
								[
									111.9317382812502,
									43.81494140624997
								],
								[
									111.88027343750002,
									43.87890625000003
								],
								[
									111.83691406250006,
									43.93466796875012
								],
								[
									111.68378906250001,
									44.041113281250034
								],
								[
									111.60263671875009,
									44.10712890624998
								],
								[
									111.51972656250007,
									44.19189453125003
								],
								[
									111.48623046875014,
									44.27163085937502
								],
								[
									111.42958984375014,
									44.32236328125006
								],
								[
									111.40224609375014,
									44.36728515625006
								],
								[
									111.41093750000016,
									44.41918945312497
								],
								[
									111.48945312500007,
									44.51157226562506
								],
								[
									111.51474609375003,
									44.569824218750114
								],
								[
									111.54746093750003,
									44.67290039062496
								],
								[
									111.62128906250007,
									44.82714843750003
								],
								[
									111.68144531249999,
									44.89916992187506
								],
								[
									111.75107421875009,
									44.9695312500001
								],
								[
									111.89804687500009,
									45.06406250000006
								],
								[
									112.03261718750014,
									45.08164062500009
								],
								[
									112.11289062500003,
									45.06293945312501
								],
								[
									112.29208984375003,
									45.063037109375045
								],
								[
									112.41132812500001,
									45.058203125000034
								],
								[
									112.49931640624999,
									45.0109375000001
								],
								[
									112.59677734375003,
									44.91767578125001
								],
								[
									112.70673828125018,
									44.88344726562505
								],
								[
									113.04941406250009,
									44.81035156249999
								],
								[
									113.19609375000005,
									44.79482421875002
								],
								[
									113.30097656250018,
									44.791650390624994
								],
								[
									113.45566406250003,
									44.767431640625034
								],
								[
									113.50791015625003,
									44.76235351562508
								],
								[
									113.58701171875009,
									44.74570312500006
								],
								[
									113.65263671875005,
									44.763476562500045
								],
								[
									113.75214843750007,
									44.82592773437506
								],
								[
									113.87705078125009,
									44.89619140624998
								],
								[
									113.93085937500007,
									44.91230468750007
								],
								[
									114.03027343750006,
									44.94257812500001
								],
								[
									114.08027343750001,
									44.97114257812507
								],
								[
									114.16738281250002,
									45.04985351562502
								],
								[
									114.2810546875001,
									45.11088867187502
								],
								[
									114.41914062500007,
									45.20258789062504
								],
								[
									114.48730468750011,
									45.271728515625114
								],
								[
									114.50224609375005,
									45.31630859375005
								],
								[
									114.51718750000003,
									45.36459960937512
								],
								[
									114.5601562500002,
									45.389990234375034
								],
								[
									114.64433593749999,
									45.41328124999998
								],
								[
									114.73876953125,
									45.41962890625004
								],
								[
									114.91923828125005,
									45.37827148437506
								],
								[
									115.16259765625,
									45.39023437500009
								],
								[
									115.21748046875018,
									45.39619140625007
								],
								[
									115.439453125,
									45.41997070312502
								],
								[
									115.53945312500014,
									45.4395019531251
								],
								[
									115.68105468750002,
									45.458251953125
								],
								[
									115.7891601562502,
									45.534814453124966
								],
								[
									115.93417968750009,
									45.62617187500001
								],
								[
									116.03955078125006,
									45.67695312500007
								],
								[
									116.10986328125006,
									45.68671875000001
								],
								[
									116.19765625000002,
									45.73935546874998
								],
								[
									116.24062500000008,
									45.79599609374998
								],
								[
									116.22910156250009,
									45.84575195312499
								],
								[
									116.21298828125009,
									45.88691406250001
								],
								[
									116.26455078125014,
									45.96303710937508
								],
								[
									116.35761718750007,
									46.09658203125002
								],
								[
									116.44482421875011,
									46.15878906250009
								],
								[
									116.51669921875009,
									46.20908203125012
								],
								[
									116.56259765625009,
									46.28979492187503
								],
								[
									116.61933593750001,
									46.31308593749998
								],
								[
									116.68886718750008,
									46.32197265625001
								],
								[
									116.78701171875008,
									46.37666015625007
								],
								[
									116.85908203125001,
									46.38793945312506
								],
								[
									116.9788085937501,
									46.36176757812504
								],
								[
									117.15595703125001,
									46.355078125000006
								],
								[
									117.26904296875006,
									46.35224609375007
								],
								[
									117.33339843750002,
									46.3620117187501
								],
								[
									117.35693359375011,
									46.39130859375001
								],
								[
									117.35634765625008,
									46.43666992187502
								],
								[
									117.3921875000002,
									46.53759765625006
								],
								[
									117.40556640625005,
									46.57089843750009
								],
								[
									117.43808593750009,
									46.58623046875002
								],
								[
									117.546875,
									46.58828125000008
								],
								[
									117.62050781250008,
									46.552001953125085
								],
								[
									117.67109375000018,
									46.52207031250009
								],
								[
									117.74121093750006,
									46.51816406250012
								],
								[
									117.81347656250006,
									46.53769531250009
								],
								[
									117.91044921875005,
									46.61933593750001
								],
								[
									118.0712890625,
									46.66660156250006
								],
								[
									118.15683593750009,
									46.678564453125006
								],
								[
									118.30869140625009,
									46.71704101562503
								],
								[
									118.40439453125009,
									46.70317382812496
								],
								[
									118.58046875000008,
									46.69189453124997
								],
								[
									118.64873046875005,
									46.701660156250085
								],
								[
									118.72294921875016,
									46.69189453124997
								],
								[
									118.79033203124999,
									46.74707031250003
								],
								[
									118.84394531250007,
									46.76020507812504
								],
								[
									118.95712890625003,
									46.73486328125003
								],
								[
									119.02851562500001,
									46.692187500000045
								],
								[
									119.162109375,
									46.63867187500006
								],
								[
									119.33183593749999,
									46.61381835937496
								],
								[
									119.47402343750014,
									46.62666015625001
								],
								[
									119.62021484375003,
									46.6039550781251
								],
								[
									119.70664062500009,
									46.606005859375074
								],
								[
									119.74746093750014,
									46.62719726562503
								],
								[
									119.86718750000011,
									46.672167968750045
								],
								[
									119.89589843750008,
									46.73286132812507
								],
								[
									119.88417968750002,
									46.79145507812501
								],
								[
									119.89785156250014,
									46.85781250000002
								],
								[
									119.86269531250008,
									46.90659179687509
								],
								[
									119.78847656250014,
									46.978808593750074
								],
								[
									119.75986328125009,
									47.02700195312502
								],
								[
									119.75722656250008,
									47.0900390625001
								],
								[
									119.71113281250001,
									47.150000000000034
								],
								[
									119.60019531250003,
									47.222460937500074
								],
								[
									119.52695312500003,
									47.255908203125045
								],
								[
									119.37666015625007,
									47.380859375
								],
								[
									119.32597656250005,
									47.410156250000114
								],
								[
									119.30859375,
									47.430712890625045
								],
								[
									119.29082031249999,
									47.47265625000006
								],
								[
									119.23525390625014,
									47.49257812500002
								],
								[
									119.16240234375016,
									47.5251953125001
								],
								[
									119.12294921875002,
									47.55849609375005
								],
								[
									119.0972656250002,
									47.616259765625074
								],
								[
									119.08193359375008,
									47.65415039062509
								],
								[
									119.01757812500011,
									47.685351562500045
								],
								[
									118.95312500000006,
									47.702929687500074
								],
								[
									118.88027343750014,
									47.72509765625006
								],
								[
									118.75996093750001,
									47.75761718750002
								],
								[
									118.69052734375009,
									47.82226562500006
								],
								[
									118.56777343750014,
									47.94326171875008
								],
								[
									118.49843750000014,
									47.983984375000034
								],
								[
									118.23964843750008,
									47.99951171875
								],
								[
									118.14707031250003,
									48.028906250000034
								],
								[
									118.04189453125014,
									48.018945312499966
								],
								[
									117.97919921875007,
									47.99960937500012
								],
								[
									117.84042968750009,
									47.99985351562506
								],
								[
									117.76835937499999,
									47.987890625000034
								],
								[
									117.67666015625014,
									47.90830078125006
								],
								[
									117.55537109375001,
									47.804687500000114
								],
								[
									117.45507812500011,
									47.741357421874994
								],
								[
									117.38398437500001,
									47.67573242187504
								],
								[
									117.35078125000007,
									47.652197265625034
								],
								[
									117.28593750000005,
									47.66635742187509
								],
								[
									117.19707031250016,
									47.740283203125045
								],
								[
									117.06972656250014,
									47.806396484375085
								],
								[
									116.95166015625006,
									47.83657226562502
								],
								[
									116.90117187500005,
									47.85307617187502
								],
								[
									116.76054687500005,
									47.86977539062505
								],
								[
									116.65195312500009,
									47.86450195312503
								],
								[
									116.51347656250016,
									47.83955078125001
								],
								[
									116.37822265625005,
									47.844042968750045
								],
								[
									116.31718750000005,
									47.85986328124997
								],
								[
									116.23115234375007,
									47.85820312499999
								],
								[
									116.07480468750009,
									47.78955078125003
								],
								[
									115.99384765625007,
									47.71132812500008
								],
								[
									115.89824218750005,
									47.68691406250008
								],
								[
									115.81171875000018,
									47.73823242187507
								],
								[
									115.71171875000005,
									47.79892578125009
								],
								[
									115.61640625000018,
									47.8748046875001
								],
								[
									115.55761718750011,
									47.94501953125001
								],
								[
									115.52509765625001,
									48.13085937500003
								],
								[
									115.63945312500005,
									48.18623046875004
								],
								[
									115.78554687500008,
									48.24824218750004
								],
								[
									115.79658203125013,
									48.346337890624966
								],
								[
									115.79169921875007,
									48.45571289062505
								],
								[
									115.82050781250007,
									48.57724609375012
								],
								[
									115.95380859375018,
									48.68935546875002
								],
								[
									116.02548828125009,
									48.78227539062496
								],
								[
									116.03437500000007,
									48.8400390625001
								],
								[
									116.0982421875002,
									48.936132812500034
								],
								[
									116.15966796875,
									49.03745117187506
								],
								[
									116.24335937500007,
									49.17036132812507
								],
								[
									116.40214843749999,
									49.40620117187507
								],
								[
									116.58974609375014,
									49.68481445312497
								],
								[
									116.68330078125007,
									49.823779296875045
								],
								[
									116.88896484375016,
									49.73779296875003
								],
								[
									117.02167968750001,
									49.69296874999995
								],
								[
									117.24560546875,
									49.62485351562512
								],
								[
									117.47714843750009,
									49.609423828125074
								],
								[
									117.69843750000007,
									49.5358398437501
								],
								[
									117.8125976562502,
									49.51352539062506
								],
								[
									117.87343749999997,
									49.513476562500074
								],
								[
									118.1866210937502,
									49.692773437499994
								],
								[
									118.45156250000002,
									49.844482421875
								],
								[
									118.7559570312502,
									49.962841796874955
								],
								[
									118.9794921875,
									49.97885742187512
								],
								[
									119.14746093750011,
									50.01337890625004
								],
								[
									119.2598632812502,
									50.06640625
								],
								[
									119.32607421874997,
									50.15493164062511
								],
								[
									119.3462890625002,
									50.27895507812505
								],
								[
									119.30156250000016,
									50.35390625000005
								],
								[
									119.19189453125011,
									50.3798339843751
								],
								[
									119.16367187500003,
									50.406005859375
								],
								[
									119.21669921875002,
									50.43251953125008
								],
								[
									119.255859375,
									50.48417968749993
								],
								[
									119.28066406249997,
									50.560986328124955
								],
								[
									119.34404296874999,
									50.63388671875006
								],
								[
									119.44570312500014,
									50.70283203124998
								],
								[
									119.50175781249999,
									50.77924804687501
								],
								[
									119.5123046875002,
									50.863134765625034
								],
								[
									119.57343750000001,
									50.94677734374994
								],
								[
									119.68496093750002,
									51.03012695312506
								],
								[
									119.74599609375002,
									51.10771484374996
								],
								[
									119.75664062500016,
									51.17949218750002
								],
								[
									119.81318359375001,
									51.2670410156251
								],
								[
									119.96699218750018,
									51.42211914062497
								],
								[
									120.06689453125011,
									51.60068359375012
								],
								[
									120.23701171875001,
									51.72299804687506
								],
								[
									120.51054687500016,
									51.84853515625008
								],
								[
									120.68144531250016,
									51.97304687500002
								],
								[
									120.74980468750016,
									52.09653320312506
								],
								[
									120.74453125000014,
									52.20546875000005
								],
								[
									120.66542968750002,
									52.299902343750006
								],
								[
									120.65039062499994,
									52.39589843749994
								],
								[
									120.69921874999994,
									52.49360351562504
								],
								[
									120.65615234374997,
									52.566650390625
								],
								[
									120.5210937500002,
									52.615039062500074
								],
								[
									120.36005859375007,
									52.627001953125045
								],
								[
									120.17275390625002,
									52.602490234374926
								],
								[
									120.06757812500018,
									52.63291015625009
								],
								[
									120.04433593750014,
									52.71821289062507
								],
								[
									120.09453125000016,
									52.78720703125009
								],
								[
									120.21816406250002,
									52.839892578125074
								],
								[
									120.42128906250002,
									52.968066406250074
								],
								[
									120.7041015625,
									53.17182617187501
								],
								[
									120.9854492187502,
									53.28457031250005
								],
								[
									121.40546875000007,
									53.31704101562502
								],
								[
									121.74394531249999,
									53.38359374999999
								],
								[
									122.08886718750011,
									53.45146484374996
								],
								[
									122.33779296875002,
									53.48500976562505
								],
								[
									122.38017578125005,
									53.46250000000006
								],
								[
									122.51582031250001,
									53.456982421874926
								],
								[
									122.74472656250003,
									53.46850585937506
								],
								[
									122.95761718750009,
									53.497705078124966
								],
								[
									123.15410156250016,
									53.54458007812511
								],
								[
									123.30957031250011,
									53.55561523437504
								],
								[
									123.42402343750007,
									53.53076171874994
								],
								[
									123.48945312500007,
									53.52944335937502
								],
								[
									123.53476562500003,
									53.52646484375006
								],
								[
									123.55976562500018,
									53.5266601562501
								],
								[
									123.60781250000002,
									53.546533203124966
								],
								[
									123.74091796875007,
									53.510986328125
								],
								[
									123.99472656250003,
									53.405615234375034
								],
								[
									124.154296875,
									53.358691406250074
								],
								[
									124.21992187500001,
									53.370117187500085
								],
								[
									124.29140625000002,
									53.34086914062499
								],
								[
									124.36914062499994,
									53.270947265624955
								],
								[
									124.46591796875003,
									53.22963867187505
								],
								[
									124.63984375000001,
									53.210644531249926
								],
								[
									124.81230468749999,
									53.133837890625074
								],
								[
									124.88212890624999,
									53.12973632812506
								],
								[
									124.90664062500014,
									53.1726562500001
								],
								[
									124.97089843750018,
									53.19731445312496
								],
								[
									125.07500000000016,
									53.20366210937502
								],
								[
									125.22558593750011,
									53.16582031250002
								],
								[
									125.42246093750003,
									53.083740234375
								],
								[
									125.54599609375009,
									53.047607421875114
								],
								[
									125.59599609375016,
									53.05747070312498
								],
								[
									125.6490234375002,
									53.042285156250074
								],
								[
									125.69169921874999,
									53.003710937500045
								],
								[
									125.69531249999994,
									52.95629882812497
								],
								[
									125.6807617187502,
									52.93081054687494
								],
								[
									125.72812500000003,
									52.890722656250034
								],
								[
									125.7828125000002,
									52.890722656250034
								],
								[
									125.87187500000005,
									52.87153320312504
								],
								[
									125.94160156250001,
									52.80068359375008
								],
								[
									126.00429687500002,
									52.76787109374996
								],
								[
									126.04814453125016,
									52.73945312500004
								],
								[
									126.05605468749997,
									52.71586914062493
								],
								[
									126.0601562500002,
									52.69199218749995
								],
								[
									126.04707031250001,
									52.67348632812508
								],
								[
									126.02324218750016,
									52.643017578124926
								],
								[
									126.01601562500002,
									52.61020507812509
								],
								[
									126.04589843749994,
									52.573339843750034
								],
								[
									126.15664062500014,
									52.546630859375
								],
								[
									126.1944335937502,
									52.51914062500009
								],
								[
									126.20292968750016,
									52.4838378906251
								],
								[
									126.23759765625005,
									52.44482421875006
								],
								[
									126.31289062500002,
									52.39975585937509
								],
								[
									126.34169921875002,
									52.36201171875004
								],
								[
									126.32421875000011,
									52.33164062500009
								],
								[
									126.34628906250003,
									52.30625000000006
								],
								[
									126.38349609375018,
									52.28652343750005
								],
								[
									126.39150390625014,
									52.21450195312502
								],
								[
									126.39482421874999,
									52.17299804687508
								],
								[
									126.45556640625011,
									52.12646484375003
								],
								[
									126.46806640624999,
									52.0312988281251
								],
								[
									126.51054687500005,
									51.9258300781251
								],
								[
									126.65371093749997,
									51.78129882812496
								],
								[
									126.70078125000009,
									51.70302734375008
								],
								[
									126.68867187500018,
									51.609912109375045
								],
								[
									126.70917968750018,
									51.56630859375005
								],
								[
									126.77451171875009,
									51.54506835937505
								],
								[
									126.80546875000016,
									51.50566406250002
								],
								[
									126.80175781250011,
									51.44804687500002
								],
								[
									126.82734375000018,
									51.41225585937511
								],
								[
									126.84775390625009,
									51.37416992187505
								],
								[
									126.83378906250016,
									51.31489257812507
								],
								[
									126.85439453125002,
									51.261376953124994
								],
								[
									126.88769531249994,
									51.23012695312494
								],
								[
									126.91152343750002,
									51.17231445312507
								],
								[
									126.92480468749994,
									51.10014648437502
								],
								[
									127.02041015624997,
									50.9858886718751
								],
								[
									127.1982421875,
									50.82944335937512
								],
								[
									127.30703125000014,
									50.70795898437504
								],
								[
									127.34687500000007,
									50.621337890625085
								],
								[
									127.34716796874994,
									50.550097656250045
								],
								[
									127.3082031250002,
									50.49418945312493
								],
								[
									127.30605468750002,
									50.453515624999994
								],
								[
									127.3408203125,
									50.42807617187506
								],
								[
									127.35117187500003,
									50.39360351562496
								],
								[
									127.33720703125016,
									50.35014648437499
								],
								[
									127.39531250000016,
									50.29858398437506
								],
								[
									127.59023437499997,
									50.208984375
								],
								[
									127.5123046875002,
									50.07167968750011
								],
								[
									127.4917968750002,
									49.975048828124955
								],
								[
									127.50244140624994,
									49.87343750000002
								],
								[
									127.55078124999994,
									49.8018066406251
								],
								[
									127.63671874999994,
									49.76020507812507
								],
								[
									127.69013671875018,
									49.7167480468751
								],
								[
									127.71113281250001,
									49.67153320312494
								],
								[
									127.81425781250016,
									49.62211914062499
								],
								[
									127.99960937500009,
									49.568603515625114
								],
								[
									128.23710937500016,
									49.55927734374998
								],
								[
									128.52675781250002,
									49.59423828125
								],
								[
									128.70400390624997,
									49.60014648437496
								],
								[
									128.76904296875,
									49.57695312500002
								],
								[
									128.7910156250001,
									49.54184570312498
								],
								[
									128.77031250000016,
									49.49472656249998
								],
								[
									128.8193359375001,
									49.46376953125005
								],
								[
									128.93828125,
									49.44892578125007
								],
								[
									129.0203125,
									49.41923828124996
								],
								[
									129.06513671875018,
									49.37465820312494
								],
								[
									129.1201171875001,
									49.36206054687494
								],
								[
									129.1851562500002,
									49.381396484375074
								],
								[
									129.24843750000014,
									49.37866210937506
								],
								[
									129.30986328125005,
									49.35385742187506
								],
								[
									129.35009765624994,
									49.3623535156251
								],
								[
									129.38466796874997,
									49.38945312499993
								],
								[
									129.44072265625016,
									49.38945312499993
								],
								[
									129.4981445312502,
									49.38881835937508
								],
								[
									129.53369140625,
									49.32343749999998
								],
								[
									129.5914062500002,
									49.286669921875045
								],
								[
									129.67109375000018,
									49.27851562499998
								],
								[
									129.79257812500003,
									49.19887695312511
								],
								[
									130.03710937499994,
									48.972265625000034
								],
								[
									130.19599609375018,
									48.891650390625045
								],
								[
									130.35527343750005,
									48.86635742187502
								],
								[
									130.55312500000002,
									48.861181640625034
								],
								[
									130.6171875000001,
									48.77319335937497
								],
								[
									130.56562500000018,
									48.680126953124926
								],
								[
									130.55214843749997,
									48.602490234374926
								],
								[
									130.5972656250002,
									48.57465820312504
								],
								[
									130.6591796875001,
									48.4833984375
								],
								[
									130.74687500000016,
									48.43037109375004
								],
								[
									130.76347656250016,
									48.388427734375114
								],
								[
									130.8042968750002,
									48.341503906249955
								],
								[
									130.7872070312502,
									48.254589843749926
								],
								[
									130.71210937500018,
									48.1276367187501
								],
								[
									130.73261718750018,
									48.01923828125004
								],
								[
									130.8486328125,
									47.92944335937494
								],
								[
									130.91542968750002,
									47.84291992187508
								],
								[
									130.93281250000018,
									47.75981445312493
								],
								[
									130.9619140625,
									47.70932617187495
								],
								[
									131.00273437500005,
									47.691455078125045
								],
								[
									131.12187500000016,
									47.697656249999966
								],
								[
									131.31933593749994,
									47.72783203124999
								],
								[
									131.46425781250002,
									47.72260742187507
								],
								[
									131.5567382812502,
									47.68203125000008
								],
								[
									131.7852539062502,
									47.680517578125034
								],
								[
									132.14980468750014,
									47.71796875000001
								],
								[
									132.38017578125,
									47.72949218749997
								],
								[
									132.47626953125,
									47.71499023437505
								],
								[
									132.56191406249997,
									47.768505859374926
								],
								[
									132.63691406250018,
									47.89008789062501
								],
								[
									132.70722656250018,
									47.947265625000114
								],
								[
									132.77285156250014,
									47.94008789062508
								],
								[
									132.87714843750018,
									47.97910156250012
								],
								[
									133.0201171875001,
									48.06440429687507
								],
								[
									133.1440429687501,
									48.105664062499955
								],
								[
									133.30117187500014,
									48.1015136718751
								],
								[
									133.4683593750001,
									48.09716796875
								],
								[
									133.57324218749994,
									48.13300781250001
								],
								[
									133.67177734375014,
									48.20771484375007
								],
								[
									133.84218750000014,
									48.2737304687501
								],
								[
									134.20585937500016,
									48.359912109375074
								],
								[
									134.29335937500014,
									48.37343750000008
								],
								[
									134.3349609375,
									48.368847656249926
								],
								[
									134.45615234375003,
									48.35532226562512
								],
								[
									134.5635742187502,
									48.321728515624926
								],
								[
									134.665234375,
									48.25390625000006
								],
								[
									134.68085937500018,
									48.210449218750085
								],
								[
									134.66933593749997,
									48.153320312500085
								],
								[
									134.647265625,
									48.120166015625074
								],
								[
									134.60537109375002,
									48.08291015624994
								],
								[
									134.56601562500003,
									48.022509765625074
								],
								[
									134.59130859375,
									47.97519531250012
								],
								[
									134.65029296875002,
									47.87426757812506
								],
								[
									134.69863281249997,
									47.801416015624966
								],
								[
									134.75234375000002,
									47.71542968749995
								],
								[
									134.72812500000003,
									47.68447265625005
								],
								[
									134.69580078124994,
									47.62485351562506
								],
								[
									134.59619140625,
									47.52387695312501
								],
								[
									134.54189453125014,
									47.48515624999993
								],
								[
									134.48349609375003,
									47.44736328125006
								],
								[
									134.38251953125018,
									47.43823242187506
								],
								[
									134.3394531250002,
									47.42949218749996
								],
								[
									134.29082031250005,
									47.41357421875
								],
								[
									134.26005859375,
									47.37773437499999
								],
								[
									134.2251953125001,
									47.35263671875012
								],
								[
									134.16767578125018,
									47.30219726562504
								],
								[
									134.16298828125014,
									47.25874023437507
								],
								[
									134.18925781250016,
									47.194238281249994
								],
								[
									134.2021484375001,
									47.12807617187502
								],
								[
									134.1369140625,
									47.068994140624966
								],
								[
									134.08642578124994,
									46.97812500000012
								],
								[
									134.0713867187502,
									46.950781250000034
								],
								[
									134.0459960937501,
									46.88198242187505
								],
								[
									134.03857421875,
									46.858154296875
								],
								[
									134.02265625,
									46.71318359374996
								],
								[
									133.95751953125,
									46.61425781250006
								],
								[
									133.86660156250014,
									46.499121093750034
								],
								[
									133.88671874999994,
									46.43056640624994
								],
								[
									133.90273437500014,
									46.36694335937494
								],
								[
									133.88027343749997,
									46.33603515624995
								],
								[
									133.87480468750005,
									46.30908203125006
								],
								[
									133.8613281250001,
									46.2477539062501
								],
								[
									133.8328125,
									46.22426757812511
								],
								[
									133.7501953125,
									46.18593750000011
								],
								[
									133.70068359375,
									46.13974609375012
								],
								[
									133.71113281250018,
									46.069628906250045
								],
								[
									133.68574218750007,
									46.00893554687511
								],
								[
									133.64785156249997,
									45.955224609374994
								],
								[
									133.6080078125002,
									45.92031250000008
								],
								[
									133.55117187499997,
									45.89780273437512
								],
								[
									133.51308593750014,
									45.878808593749966
								],
								[
									133.48466796875005,
									45.81044921875008
								],
								[
									133.47578125000018,
									45.75766601562498
								],
								[
									133.44912109374997,
									45.705078125000114
								],
								[
									133.46562500000016,
									45.65122070312506
								],
								[
									133.43642578124997,
									45.60468750000007
								],
								[
									133.3554687500001,
									45.57221679687504
								],
								[
									133.3095703125,
									45.553076171875034
								],
								[
									133.26699218750002,
									45.54526367187506
								],
								[
									133.1860351562501,
									45.49482421875007
								],
								[
									133.11337890625003,
									45.32143554687502
								],
								[
									133.09687500000018,
									45.22045898437506
								],
								[
									133.11347656250018,
									45.13071289062498
								],
								[
									133.01171874999994,
									45.07456054687509
								],
								[
									132.93603515625,
									45.02993164062505
								],
								[
									132.88876953125003,
									45.04604492187505
								],
								[
									132.83867187500016,
									45.061132812500006
								],
								[
									132.80953302719712,
									45.066034444547995
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "CHN",
					"su_a3": "CHN",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "CHN",
					"gu_a3": "CHN",
					"abbrev": "China",
					"region_un": "Asia",
					"adm0_a3_us": "CHN",
					"scalerank": 1,
					"pop_est": 1338612970,
					"adm0_dif": 1,
					"un_a3": "156",
					"pop_year": -99,
					"gdp_md_est": 7973000,
					"name": "China",
					"sovereignt": "China",
					"economy": "3. Emerging region: BRIC",
					"type": "Country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "China",
					"postal": "CN",
					"sov_a3": "CH1",
					"note_brk": "",
					"brk_a3": "CHN",
					"wb_a2": "CN",
					"brk_diff": 0,
					"admin": "China",
					"name_long": "China",
					"iso_a3": "CHN",
					"iso_a2": "CN",
					"adm0_a3_is": "CHN",
					"level": 2,
					"formal_en": "People's Republic of China",
					"name_len": 5,
					"mapcolor7": 4,
					"long_len": 5,
					"mapcolor8": 4,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "156",
					"homepart": 1,
					"subunit": "China",
					"name_alt": "",
					"brk_name": "China",
					"name_sort": "China",
					"continent": "Asia",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								15.480078125000006,
								7.523779296875034
							],
							[
								15.37910156250004,
								7.358154296875043
							],
							[
								15.245898437499989,
								7.263574218749966
							],
							[
								15.206738281250011,
								7.2061523437499915
							],
							[
								15.185839843750017,
								7.134912109375037
							],
							[
								15.157128906250023,
								7.0635742187499915
							],
							[
								15.08632812500008,
								6.909912109375028
							],
							[
								15.034570312500023,
								6.784423828125043
							],
							[
								14.982714843750017,
								6.745312499999983
							],
							[
								14.861914062500034,
								6.555712890624989
							],
							[
								14.780371093750006,
								6.365722656250014
							],
							[
								14.76406250000008,
								6.316357421874997
							],
							[
								14.7392578125,
								6.27978515625
							],
							[
								14.699511718750074,
								6.250244140625028
							],
							[
								14.559375000000017,
								6.191210937499989
							],
							[
								14.51210937500008,
								6.161914062499974
							],
							[
								14.47500000000008,
								6.126806640625006
							],
							[
								14.440722656250017,
								6.086718750000017
							],
							[
								14.431152343750028,
								6.0387207031250085
							],
							[
								14.463867187500028,
								5.970703125
							],
							[
								14.503125000000011,
								5.916894531249966
							],
							[
								14.542480468750057,
								5.91357421875
							],
							[
								14.577246093750034,
								5.916015625000057
							],
							[
								14.598828125000068,
								5.883984375000011
							],
							[
								14.616894531250011,
								5.865136718749994
							],
							[
								14.616894531250011,
								5.4955078125000085
							],
							[
								14.583593749999977,
								5.439648437499997
							],
							[
								14.584375000000051,
								5.414746093749983
							],
							[
								14.568066406250011,
								5.351074218749986
							],
							[
								14.562988281250057,
								5.279931640624966
							],
							[
								14.573535156250074,
								5.251708984374986
							],
							[
								14.60175781250004,
								5.228808593750031
							],
							[
								14.640625000000057,
								5.17905273437502
							],
							[
								14.661718750000006,
								5.065527343749977
							],
							[
								14.708984375000028,
								4.665576171875031
							],
							[
								14.731250000000045,
								4.602392578125048
							],
							[
								14.770410156250023,
								4.558105468749986
							],
							[
								14.893554687499972,
								4.471875000000011
							],
							[
								15.022753906250017,
								4.3585449218750085
							],
							[
								15.063574218750063,
								4.284863281250011
							],
							[
								15.087500000000063,
								4.16396484374998
							],
							[
								15.136914062500011,
								4.069140625000031
							],
							[
								15.135839843750063,
								4.036914062500031
							],
							[
								15.115429687500068,
								4.024462890624989
							],
							[
								15.067382812500057,
								4.022949218750028
							],
							[
								15.034863281249983,
								4.016357421875028
							],
							[
								15.062109375000034,
								3.9472167968749687
							],
							[
								15.128710937500017,
								3.8269042968749716
							],
							[
								15.239843750000006,
								3.7021484375000426
							],
							[
								15.360156250000017,
								3.567138671874986
							],
							[
								15.458398437500051,
								3.4568359374999886
							],
							[
								15.580859375000017,
								3.3292968750000256
							],
							[
								15.676562500000074,
								3.229687499999983
							],
							[
								15.775000000000063,
								3.1271972656249716
							],
							[
								15.849316406250011,
								3.1030761718750313
							],
							[
								15.904882812500063,
								3.09584960937498
							],
							[
								15.928710937500028,
								3.0757812499999773
							],
							[
								15.958007812500028,
								3.02871093749998
							],
							[
								16.00820312500005,
								2.976660156250034
							],
							[
								16.06347656250003,
								2.9085937500000227
							],
							[
								16.08242187500008,
								2.839111328125
							],
							[
								16.059277343750068,
								2.7729980468750313
							],
							[
								16.082128906250006,
								2.678173828124983
							],
							[
								16.08349609375003,
								2.6700195312500057
							],
							[
								16.101855468750045,
								2.632666015625034
							],
							[
								16.095507812500074,
								2.5992187499999773
							],
							[
								16.106738281250045,
								2.47348632812502
							],
							[
								16.13613281250008,
								2.363769531250057
							],
							[
								16.183398437500045,
								2.2700683593749744
							],
							[
								16.182617187500057,
								2.262451171875014
							],
							[
								16.176562500000074,
								2.204785156249997
							],
							[
								16.11572265625003,
								2.16782226562502
							],
							[
								16.08007812500003,
								2.10678710937502
							],
							[
								16.069628906250045,
								2.021679687499997
							],
							[
								16.08789062500003,
								1.91806640625002
							],
							[
								16.13496093750004,
								1.795947265625017
							],
							[
								16.13613281250008,
								1.724218749999963
							],
							[
								16.11953125000008,
								1.7141113281250426
							],
							[
								16.09033203125,
								1.6912597656250057
							],
							[
								16.059375000000074,
								1.676220703125054
							],
							[
								15.975195312499977,
								1.7600097656249716
							],
							[
								15.881640625000017,
								1.816601562500054
							],
							[
								15.741601562499994,
								1.9149902343750256
							],
							[
								15.600292968749983,
								1.9503906250000398
							],
							[
								15.417480468750057,
								1.9567382812499972
							],
							[
								15.338769531249994,
								1.944726562500037
							],
							[
								15.282421875000068,
								1.9817382812500313
							],
							[
								15.20351562500008,
								2.0244628906250313
							],
							[
								15.160058593750023,
								2.035595703124983
							],
							[
								15.099609375000028,
								2.002343749999966
							],
							[
								15.05781250000004,
								2.0008789062500227
							],
							[
								15.006445312500063,
								2.0137695312499773
							],
							[
								14.902441406250006,
								2.012304687500034
							],
							[
								14.892773437500011,
								2.0693359375000284
							],
							[
								14.875000000000028,
								2.08046874999998
							],
							[
								14.762890625000011,
								2.0751953124999716
							],
							[
								14.728320312500074,
								2.1224121093750057
							],
							[
								14.713281250000023,
								2.117138671874997
							],
							[
								14.669140625000011,
								2.132080078125014
							],
							[
								14.578906250000017,
								2.1991210937499943
							],
							[
								14.48408203125004,
								2.1547363281250114
							],
							[
								14.287011718750051,
								2.160351562499997
							],
							[
								14.034375000000011,
								2.1588867187499687
							],
							[
								13.772753906249989,
								2.1574218750000256
							],
							[
								13.533496093750017,
								2.1595214843750057
							],
							[
								13.293554687500063,
								2.161572265624983
							],
							[
								13.269921875000051,
								2.2242187500000483
							],
							[
								13.220312500000063,
								2.256445312500034
							],
							[
								13.130859375000057,
								2.2594238281250227
							],
							[
								12.867480468750045,
								2.2467773437500256
							],
							[
								12.665722656250068,
								2.2567871093750256
							],
							[
								12.601367187500017,
								2.2650390625000085
							],
							[
								12.52978515625,
								2.281347656249963
							],
							[
								12.361328125000057,
								2.29599609375002
							],
							[
								12.153417968750063,
								2.28437500000004
							],
							[
								12.106152343750011,
								2.287499999999966
							],
							[
								11.939746093750045,
								2.2851562500000284
							],
							[
								11.558984375000023,
								2.30219726562504
							],
							[
								11.348437500000017,
								2.299707031249966
							],
							[
								11.353320312500045,
								2.261425781249983
							],
							[
								11.339941406250063,
								2.233837890625054
							],
							[
								11.328710937500006,
								2.1674316406250256
							],
							[
								11.096582031250051,
								2.1674804687500284
							],
							[
								10.790917968750023,
								2.1675781250000483
							],
							[
								10.502246093750017,
								2.1676269531250654
							],
							[
								10.307031250000051,
								2.1677246093750853
							],
							[
								9.979882812499994,
								2.167773437500088
							],
							[
								9.870117187500028,
								2.213281250000037
							],
							[
								9.8369140625,
								2.242382812500111
							],
							[
								9.830371093750017,
								2.275488281250105
							],
							[
								9.826171875000028,
								2.2978027343750256
							],
							[
								9.800781250000028,
								2.3044433593750426
							],
							[
								9.821777343750028,
								2.5392578125000114
							],
							[
								9.867578125000051,
								2.7349609375000057
							],
							[
								9.88544921875004,
								2.91655273437496
							],
							[
								9.948437499999983,
								3.0790527343750256
							],
							[
								9.915039062500028,
								3.239648437499966
							],
							[
								9.876171875000011,
								3.30976562500004
							],
							[
								9.672070312500011,
								3.537597656250014
							],
							[
								9.765722656250063,
								3.6238281249999886
							],
							[
								9.642382812500074,
								3.6117675781250256
							],
							[
								9.615917968750011,
								3.696484375000054
							],
							[
								9.55615234375,
								3.79804687500004
							],
							[
								9.5927734375,
								3.8143066406249773
							],
							[
								9.628125000000011,
								3.870019531249966
							],
							[
								9.73964843750008,
								3.852929687500037
							],
							[
								9.736132812500074,
								3.880126953124986
							],
							[
								9.639941406250017,
								3.965332031250014
							],
							[
								9.649218750000045,
								4.008349609374989
							],
							[
								9.688867187500051,
								4.056396484375014
							],
							[
								9.669531250000006,
								4.076660156250057
							],
							[
								9.600390625000045,
								4.0269042968750455
							],
							[
								9.550585937500017,
								4.0284179687499915
							],
							[
								9.511816406250034,
								4.0606445312499915
							],
							[
								9.483691406250074,
								4.06611328125004
							],
							[
								9.500781250000017,
								4.000732421875043
							],
							[
								9.462011718750006,
								3.9425292968749943
							],
							[
								9.42529296875,
								3.922314453125054
							],
							[
								9.362304687500028,
								3.92573242187504
							],
							[
								9.310937500000051,
								3.940380859374997
							],
							[
								9.297363281250057,
								3.9729492187499744
							],
							[
								9.249121093749977,
								3.9978515624999886
							],
							[
								9.113867187500063,
								4.041064453124989
							],
							[
								9.000097656250063,
								4.091601562499989
							],
							[
								8.977050781249972,
								4.230419921875026
							],
							[
								8.932031250000051,
								4.29023437500004
							],
							[
								8.913574218750028,
								4.357812500000037
							],
							[
								8.902832031250057,
								4.4351562499999915
							],
							[
								8.918261718750074,
								4.553759765624989
							],
							[
								8.889453125000074,
								4.572753906250043
							],
							[
								8.8564453125,
								4.579248046875037
							],
							[
								8.80712890625,
								4.573437500000011
							],
							[
								8.76191406250004,
								4.580029296875011
							],
							[
								8.707910156250051,
								4.645703124999983
							],
							[
								8.66035156250004,
								4.6709960937499915
							],
							[
								8.68964843750004,
								4.550244140624983
							],
							[
								8.65625,
								4.516357421875014
							],
							[
								8.574414062500011,
								4.526220703124977
							],
							[
								8.539550781250028,
								4.571875000000048
							],
							[
								8.532812500000063,
								4.605859375000037
							],
							[
								8.570507812500011,
								4.752099609374994
							],
							[
								8.555859375000068,
								4.755224609375006
							],
							[
								8.585156250000068,
								4.832812500000003
							],
							[
								8.64052734375008,
								4.9270019531250995
							],
							[
								8.715625000000017,
								5.046875000000085
							],
							[
								8.800976562499983,
								5.19746093750004
							],
							[
								8.859179687500045,
								5.463769531250023
							],
							[
								8.898828125000023,
								5.629687499999989
							],
							[
								8.935058593750028,
								5.781005859375085
							],
							[
								8.997167968750006,
								5.917724609375043
							],
							[
								9.060156250000034,
								6.009082031250102
							],
							[
								9.23876953125,
								6.18613281250002
							],
							[
								9.373339843750074,
								6.319628906250031
							],
							[
								9.442187500000074,
								6.373388671874977
							],
							[
								9.490234375,
								6.418652343750054
							],
							[
								9.574023437500017,
								6.470410156250026
							],
							[
								9.659960937500017,
								6.531982421875043
							],
							[
								9.725585937500057,
								6.65000000000002
							],
							[
								9.779882812500034,
								6.76015625000008
							],
							[
								9.82070312500008,
								6.783935546875043
							],
							[
								9.874218750000068,
								6.803271484375074
							],
							[
								10.038867187500017,
								6.921386718750057
							],
							[
								10.143554687500028,
								6.996435546875077
							],
							[
								10.167773437499989,
								6.95917968750004
							],
							[
								10.185546874999972,
								6.912792968750082
							],
							[
								10.205468750000051,
								6.891601562500028
							],
							[
								10.293066406250034,
								6.876757812500031
							],
							[
								10.413183593750006,
								6.8777343750000455
							],
							[
								10.482324218750051,
								6.891259765624966
							],
							[
								10.519042968750057,
								6.93046874999996
							],
							[
								10.55634765625004,
								7.037451171875077
							],
							[
								10.578125000000028,
								7.057714843750034
							],
							[
								10.606250000000074,
								7.063085937499977
							],
							[
								10.737597656250017,
								6.988281250000014
							],
							[
								10.846484375000074,
								6.881787109375082
							],
							[
								10.954199218749977,
								6.77656250000004
							],
							[
								11.00869140625008,
								6.739111328125048
							],
							[
								11.032519531250045,
								6.6979003906250085
							],
							[
								11.079687500000063,
								6.505517578125065
							],
							[
								11.1064453125,
								6.457714843750097
							],
							[
								11.153320312500057,
								6.437939453124983
							],
							[
								11.237304687500028,
								6.4505371093750625
							],
							[
								11.324609375000051,
								6.484667968750088
							],
							[
								11.401757812500051,
								6.533935546875
							],
							[
								11.477539062500028,
								6.597412109375057
							],
							[
								11.529101562500045,
								6.655029296875071
							],
							[
								11.551660156250023,
								6.697265625000057
							],
							[
								11.562988281250028,
								6.854638671874966
							],
							[
								11.580078125000057,
								6.888867187500011
							],
							[
								11.657519531250017,
								6.951562499999994
							],
							[
								11.787011718750023,
								7.056201171875088
							],
							[
								11.861425781249977,
								7.116406250000097
							],
							[
								11.854785156250045,
								7.13798828124996
							],
							[
								11.808593750000057,
								7.201953125000017
							],
							[
								11.767382812500017,
								7.27226562499996
							],
							[
								11.809179687500006,
								7.345068359375048
							],
							[
								11.852441406250023,
								7.40073242187502
							],
							[
								12.016015625000051,
								7.58974609374998
							],
							[
								12.016601562499972,
								7.652001953125051
							],
							[
								12.025195312500045,
								7.727783203125028
							],
							[
								12.15595703125004,
								7.942480468750077
							],
							[
								12.231152343749983,
								8.227392578125034
							],
							[
								12.2333984375,
								8.282324218750034
							],
							[
								12.311328125000074,
								8.41972656249996
							],
							[
								12.403515625000011,
								8.595556640625077
							],
							[
								12.58271484375004,
								8.624121093750034
							],
							[
								12.651562500000011,
								8.667773437500045
							],
							[
								12.731152343750068,
								8.745654296875017
							],
							[
								12.7822265625,
								8.817871093750071
							],
							[
								12.806542968750051,
								8.886621093750037
							],
							[
								12.824414062500068,
								9.019433593750094
							],
							[
								12.85595703125,
								9.17075195312502
							],
							[
								12.87568359375004,
								9.30351562500006
							],
							[
								12.929492187500074,
								9.426269531250028
							],
							[
								13.019433593749994,
								9.48833007812506
							],
							[
								13.175488281250011,
								9.539648437500034
							],
							[
								13.198730468750028,
								9.563769531249974
							],
							[
								13.221191406249972,
								9.645166015625037
							],
							[
								13.23876953125,
								9.814013671874974
							],
							[
								13.243750000000063,
								9.915917968750037
							],
							[
								13.249804687500045,
								9.960058593750063
							],
							[
								13.269921875000051,
								10.036181640625031
							],
							[
								13.414550781250028,
								10.17143554687496
							],
							[
								13.478515625,
								10.38325195312504
							],
							[
								13.53535156250004,
								10.60507812500002
							],
							[
								13.699902343750068,
								10.873144531250091
							],
							[
								13.892089843750057,
								11.14008789062504
							],
							[
								13.981445312500057,
								11.211865234375097
							],
							[
								14.056738281250034,
								11.245019531250009
							],
							[
								14.143261718750068,
								11.248535156250014
							],
							[
								14.20234375000004,
								11.26816406250002
							],
							[
								14.409472656250045,
								11.401171875000017
							],
							[
								14.49609375,
								11.446142578125034
							],
							[
								14.559765625000011,
								11.49228515625002
							],
							[
								14.575390625000011,
								11.532421875000026
							],
							[
								14.581640625000034,
								11.591162109375006
							],
							[
								14.561816406250074,
								11.728710937500054
							],
							[
								14.59736328125004,
								11.829833984375043
							],
							[
								14.6181640625,
								11.986621093750017
							],
							[
								14.627148437500068,
								12.108691406250017
							],
							[
								14.619726562500063,
								12.150976562500105
							],
							[
								14.587011718750063,
								12.20942382812511
							],
							[
								14.58095703125008,
								12.222070312500023
							],
							[
								14.518945312500051,
								12.298242187499994
							],
							[
								14.415429687500023,
								12.344140625000023
							],
							[
								14.272851562499994,
								12.35649414062496
							],
							[
								14.197460937500011,
								12.383789062500014
							],
							[
								14.184863281250017,
								12.447216796874969
							],
							[
								14.177636718750051,
								12.48408203125011
							],
							[
								14.17031250000008,
								12.524072265624994
							],
							[
								14.160058593750023,
								12.612792968750043
							],
							[
								14.06396484375,
								13.078515624999966
							],
							[
								14.244824218750068,
								13.077343749999997
							],
							[
								14.461718750000017,
								13.02177734374996
							],
							[
								14.516210937500034,
								12.979736328125014
							],
							[
								14.544726562500074,
								12.820214843750023
							],
							[
								14.623242187500068,
								12.729931640625011
							],
							[
								14.761230468750028,
								12.655615234374963
							],
							[
								14.847070312500023,
								12.502099609375051
							],
							[
								14.880664062500017,
								12.269384765624977
							],
							[
								14.956738281250068,
								12.130371093749986
							],
							[
								14.973828124999983,
								12.108349609375026
							],
							[
								15.059863281250017,
								11.90712890624998
							],
							[
								15.08125000000004,
								11.845507812500045
							],
							[
								15.087695312500017,
								11.724365234375057
							],
							[
								15.07802734375008,
								11.642578125
							],
							[
								15.12197265625008,
								11.541259765625057
							],
							[
								15.055468750000017,
								11.368554687500037
							],
							[
								15.035742187500006,
								11.262500000000017
							],
							[
								15.029882812500034,
								11.11367187499998
							],
							[
								15.068652343750045,
								10.851074218750043
							],
							[
								15.132226562500023,
								10.648486328124974
							],
							[
								15.200976562499989,
								10.484521484374966
							],
							[
								15.276074218750011,
								10.357373046874997
							],
							[
								15.399902343750028,
								10.216894531249977
							],
							[
								15.531933593750011,
								10.08847656250002
							],
							[
								15.654882812500006,
								10.007812500000014
							],
							[
								15.540917968750051,
								9.96030273437502
							],
							[
								15.320019531250011,
								9.95429687500004
							],
							[
								15.193164062500017,
								9.981494140624989
							],
							[
								15.132714843750023,
								9.982861328124997
							],
							[
								15.071582031250017,
								9.965966796875023
							],
							[
								14.835839843750051,
								9.94169921874996
							],
							[
								14.597949218750074,
								9.953076171874969
							],
							[
								14.377246093750045,
								9.985058593749997
							],
							[
								14.243261718750006,
								9.979736328124986
							],
							[
								14.139746093750063,
								9.901806640625011
							],
							[
								14.055957031250045,
								9.784374999999969
							],
							[
								13.977246093750011,
								9.69155273437498
							],
							[
								14.004980468750063,
								9.588720703124991
							],
							[
								14.06416015625004,
								9.531738281250014
							],
							[
								14.17792968750004,
								9.406494140625
							],
							[
								14.280078125000045,
								9.285058593750037
							],
							[
								14.332324218750045,
								9.203515625000037
							],
							[
								14.5361328125,
								9.025244140625034
							],
							[
								14.732812500000023,
								8.86567382812504
							],
							[
								14.771289062500045,
								8.83916015624996
							],
							[
								14.826269531250034,
								8.810302734375043
							],
							[
								14.860742187500051,
								8.798632812499974
							],
							[
								14.96796875000004,
								8.707275390625014
							],
							[
								15.116210937500057,
								8.557324218750011
							],
							[
								15.25234375000008,
								8.32236328125002
							],
							[
								15.349023437500051,
								8.083837890625006
							],
							[
								15.442968750000006,
								7.851855468750003
							],
							[
								15.484472656250034,
								7.812744140625028
							],
							[
								15.5498046875,
								7.787890625000017
							],
							[
								15.55781250000004,
								7.738037109374986
							],
							[
								15.552636718750051,
								7.664501953125026
							],
							[
								15.532421875000011,
								7.604394531250037
							],
							[
								15.480078125000006,
								7.523779296875034
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Middle Africa",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "CMR",
					"su_a3": "CMR",
					"brk_group": "",
					"region_wb": "Sub-Saharan Africa",
					"wb_a3": "CMR",
					"gu_a3": "CMR",
					"abbrev": "Cam.",
					"region_un": "Africa",
					"adm0_a3_us": "CMR",
					"scalerank": 1,
					"pop_est": 18879301,
					"adm0_dif": 0,
					"un_a3": "120",
					"pop_year": -99,
					"gdp_md_est": 42750,
					"name": "Cameroon",
					"sovereignt": "Cameroon",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Cameroon",
					"postal": "CM",
					"sov_a3": "CMR",
					"note_brk": "",
					"brk_a3": "CMR",
					"wb_a2": "CM",
					"brk_diff": 0,
					"admin": "Cameroon",
					"name_long": "Cameroon",
					"iso_a3": "CMR",
					"iso_a2": "CM",
					"adm0_a3_is": "CMR",
					"level": 2,
					"formal_en": "Republic of Cameroon",
					"name_len": 8,
					"mapcolor7": 1,
					"long_len": 8,
					"mapcolor8": 4,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "120",
					"homepart": 1,
					"subunit": "Cameroon",
					"name_alt": "",
					"brk_name": "Cameroon",
					"name_sort": "Cameroon",
					"continent": "Africa",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2005
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-78.11372070312495,
									2.541748046875071
								],
								[
									-78.14082031249998,
									2.5196777343750227
								],
								[
									-78.19248046875,
									2.5592773437500966
								],
								[
									-78.21010742187497,
									2.60917968749996
								],
								[
									-78.17841796874998,
									2.6463378906250625
								],
								[
									-78.13764648437495,
									2.6341796875000796
								],
								[
									-78.119140625,
									2.6036132812500625
								],
								[
									-78.11372070312495,
									2.541748046875071
								]
							]
						],
						[
							[
								[
									-71.31972656249997,
									11.861914062500091
								],
								[
									-71.35556640625,
									11.849755859375023
								],
								[
									-71.40019531249993,
									11.823535156250088
								],
								[
									-71.53608398437501,
									11.774072265624966
								],
								[
									-71.71948242187497,
									11.726855468750031
								],
								[
									-71.95810546875,
									11.666406250000051
								],
								[
									-72.01230468750003,
									11.601953125000065
								],
								[
									-72.24848632812501,
									11.196435546875051
								],
								[
									-72.44609374999993,
									11.114257812500014
								],
								[
									-72.51801757812493,
									11.053906250000068
								],
								[
									-72.57226562499997,
									10.977148437500063
								],
								[
									-72.690087890625,
									10.835839843750051
								],
								[
									-72.73916015624997,
									10.727197265625023
								],
								[
									-72.86933593750001,
									10.491259765625017
								],
								[
									-72.94038085937501,
									10.19575195312494
								],
								[
									-72.9673828125,
									10.02973632812504
								],
								[
									-73.00654296874998,
									9.789160156250063
								],
								[
									-73.06406249999998,
									9.668212890625028
								],
								[
									-73.141259765625,
									9.554638671875068
								],
								[
									-73.22426757812502,
									9.4436035156251
								],
								[
									-73.295654296875,
									9.3220214843751
								],
								[
									-73.35634765625002,
									9.226855468750074
								],
								[
									-73.3662109375,
									9.194140624999989
								],
								[
									-73.33671875000002,
									9.167919921875068
								],
								[
									-73.19316406249999,
									9.194140624999989
								],
								[
									-73.13671874999994,
									9.222802734374966
								],
								[
									-73.05839843749999,
									9.259570312500088
								],
								[
									-73.00927734375,
									9.239941406250082
								],
								[
									-72.96015624999995,
									9.135156250000051
								],
								[
									-72.90444335937497,
									9.122070312500043
								],
								[
									-72.85209960937496,
									9.135156250000051
								],
								[
									-72.79638671874997,
									9.108984375000048
								],
								[
									-72.72553710937493,
									8.848291015625051
								],
								[
									-72.66542968749994,
									8.627587890625023
								],
								[
									-72.525732421875,
									8.489697265625097
								],
								[
									-72.41655273437496,
									8.38198242187508
								],
								[
									-72.39033203124995,
									8.287060546875026
								],
								[
									-72.36416015624994,
									8.152783203125026
								],
								[
									-72.35761718749995,
									8.087304687500094
								],
								[
									-72.39169921874995,
									8.04770507812502
								],
								[
									-72.44604492187503,
									7.966113281250088
								],
								[
									-72.45957031250003,
									7.80986328125006
								],
								[
									-72.46889648437497,
									7.757958984374966
								],
								[
									-72.47895507812498,
									7.613232421874969
								],
								[
									-72.47197265624996,
									7.524267578124963
								],
								[
									-72.44296875,
									7.454882812500031
								],
								[
									-72.39462890625003,
									7.415087890625017
								],
								[
									-72.29633789062498,
									7.39453125
								],
								[
									-72.20771484374995,
									7.370263671875023
								],
								[
									-72.15668945312495,
									7.249707031249983
								],
								[
									-72.08427734374996,
									7.096875000000026
								],
								[
									-72.00664062499993,
									7.03261718750008
								],
								[
									-71.89267578125,
									6.990332031250077
								],
								[
									-71.81127929687503,
									7.005810546875026
								],
								[
									-71.62089843749996,
									7.03291015625004
								],
								[
									-71.45712890624998,
									7.026367187499957
								],
								[
									-71.21782226562499,
									6.985205078125091
								],
								[
									-71.12861328124995,
									6.986718750000051
								],
								[
									-71.01328124999998,
									6.994433593750017
								],
								[
									-70.81069335937502,
									7.077587890625082
								],
								[
									-70.73715820312503,
									7.090039062500054
								],
								[
									-70.65507812500002,
									7.082763671875071
								],
								[
									-70.535546875,
									7.04052734375
								],
								[
									-70.47065429687501,
									7.007128906249946
								],
								[
									-70.38749999999996,
									6.972607421875111
								],
								[
									-70.26611328125,
									6.947949218749969
								],
								[
									-70.18813476562502,
									6.952050781250094
								],
								[
									-70.12919921874999,
									6.953613281250057
								],
								[
									-70.09501953124996,
									6.937939453125054
								],
								[
									-69.90419921875,
									6.7002441406250455
								],
								[
									-69.73896484374998,
									6.494384765625028
								],
								[
									-69.59482421875,
									6.321484375000054
								],
								[
									-69.43925781249993,
									6.134912109375065
								],
								[
									-69.42714843749997,
									6.123974609374969
								],
								[
									-69.357080078125,
									6.14799804687506
								],
								[
									-69.31083984374999,
									6.13759765625008
								],
								[
									-69.2681640625,
									6.099707031250091
								],
								[
									-69.19453125000001,
									6.115332031250077
								],
								[
									-69.08994140625,
									6.184375000000017
								],
								[
									-68.93720703124998,
									6.198193359375082
								],
								[
									-68.73647460937494,
									6.156787109375074
								],
								[
									-68.47177734375,
									6.156542968750031
								],
								[
									-68.14306640625003,
									6.197509765625028
								],
								[
									-67.9388671875,
									6.241943359375114
								],
								[
									-67.85917968750002,
									6.28989257812502
								],
								[
									-67.7271484375,
									6.284960937500074
								],
								[
									-67.56806640624993,
									6.2417968749999915
								],
								[
									-67.48198242187499,
									6.1802734375000625
								],
								[
									-67.47158203125,
									6.119775390625094
								],
								[
									-67.43935546875,
									6.02553710937508
								],
								[
									-67.47387695312503,
									5.92998046875006
								],
								[
									-67.57519531249997,
									5.833105468750034
								],
								[
									-67.63134765624994,
									5.709375000000051
								],
								[
									-67.64228515624995,
									5.558789062500026
								],
								[
									-67.69462890624996,
									5.447509765625
								],
								[
									-67.78842773437498,
									5.375488281250071
								],
								[
									-67.82490234374995,
									5.270458984375082
								],
								[
									-67.80419921875,
									5.1325195312499545
								],
								[
									-67.814306640625,
									4.930810546875065
								],
								[
									-67.85527343750002,
									4.665478515625111
								],
								[
									-67.85527343750002,
									4.506884765625031
								],
								[
									-67.814306640625,
									4.455078125000057
								],
								[
									-67.79541015624997,
									4.380712890625091
								],
								[
									-67.79863281250002,
									4.283886718750082
								],
								[
									-67.78320312499997,
									4.198242187500043
								],
								[
									-67.73232421875,
									4.08652343750002
								],
								[
									-67.66162109375,
									3.8642578125000284
								],
								[
									-67.60253906250003,
									3.7687988281250426
								],
								[
									-67.55112304687503,
									3.7338378906250256
								],
								[
									-67.49868164062502,
									3.6911132812500256
								],
								[
									-67.34770507812499,
									3.46376953124998
								],
								[
									-67.3111328125,
									3.4158691406249915
								],
								[
									-67.32216796875002,
									3.373974609374983
								],
								[
									-67.33627929687498,
									3.3426269531249915
								],
								[
									-67.35361328125003,
									3.3226562500000085
								],
								[
									-67.51484374999993,
									3.1872558593749574
								],
								[
									-67.83476562500002,
									2.892822265625014
								],
								[
									-67.86123046874997,
									2.855322265625105
								],
								[
									-67.85908203124998,
									2.793603515625051
								],
								[
									-67.76645507812503,
									2.8333007812500597
								],
								[
									-67.66723632812497,
									2.8001953125000654
								],
								[
									-67.61870117187496,
									2.793603515625051
								],
								[
									-67.5966796875,
									2.769335937500074
								],
								[
									-67.56801757812502,
									2.689941406250071
								],
								[
									-67.53496093749993,
									2.6767578125000426
								],
								[
									-67.48642578125,
									2.6436523437500483
								],
								[
									-67.39160156249997,
									2.5599121093750483
								],
								[
									-67.31225585937497,
									2.471679687500014
								],
								[
									-67.25273437499999,
									2.4294433593750284
								],
								[
									-67.21083984375,
									2.3901367187500995
								],
								[
									-67.19760742187495,
									2.3327636718749574
								],
								[
									-67.215234375,
									2.275488281250105
								],
								[
									-67.16547851562498,
									2.1425781250000284
								],
								[
									-67.13144531249998,
									2.10126953125004
								],
								[
									-67.11381835937493,
									2.050585937500017
								],
								[
									-67.13144531249998,
									1.9998535156249915
								],
								[
									-67.08955078124998,
									1.940332031250037
								],
								[
									-67.04389648437501,
									1.823193359375054
								],
								[
									-66.988134765625,
									1.6801757812500568
								],
								[
									-66.98154296875,
									1.6007812500000398
								],
								[
									-66.95834960937498,
									1.5642089843750568
								],
								[
									-66.93110351562493,
									1.4580078125000853
								],
								[
									-66.88447265624993,
									1.35825195312502
								],
								[
									-66.89550781249997,
									1.2898925781249488
								],
								[
									-66.87602539062499,
									1.2230468750000085
								],
								[
									-67.06523437499999,
									1.178369140624966
								],
								[
									-67.082275390625,
									1.1854003906249773
								],
								[
									-67.09365234375002,
									1.210009765625017
								],
								[
									-67.08828125,
									1.4005859374999403
								],
								[
									-67.09013671875002,
									1.615576171875034
								],
								[
									-67.11923828124998,
									1.7036132812500284
								],
								[
									-67.20581054687503,
									1.84482421875002
								],
								[
									-67.32060546874996,
									2.0320800781250767
								],
								[
									-67.35195312499997,
									2.085839843750094
								],
								[
									-67.40043945312499,
									2.1166992187500853
								],
								[
									-67.45776367187503,
									2.1211425781251023
								],
								[
									-67.49965820312494,
									2.107910156250071
								],
								[
									-67.55605468749997,
									2.0729980468749716
								],
								[
									-67.60922851562498,
									2.035058593750051
								],
								[
									-67.71186523437501,
									1.9221191406250568
								],
								[
									-67.815087890625,
									1.7900878906250597
								],
								[
									-67.87553710937496,
									1.760595703125091
								],
								[
									-67.93623046874998,
									1.7484863281249403
								],
								[
									-67.98974609374997,
									1.7525390625000483
								],
								[
									-68.03286132812494,
									1.7880371093750966
								],
								[
									-68.07705078125,
									1.8601074218749432
								],
								[
									-68.1302734375,
									1.9557617187500682
								],
								[
									-68.19379882812495,
									1.9870117187500398
								],
								[
									-68.218359375,
									1.957617187500091
								],
								[
									-68.23945312499993,
									1.9013671875
								],
								[
									-68.25595703125,
									1.8455078124999886
								],
								[
									-68.21328125000002,
									1.7745605468750938
								],
								[
									-68.17656250000002,
									1.719824218749963
								],
								[
									-68.23955078124996,
									1.7216796874999858
								],
								[
									-68.44345703125003,
									1.721582031249966
								],
								[
									-68.67846679687503,
									1.721484374999946
								],
								[
									-68.91318359374998,
									1.7213867187500966
								],
								[
									-69.124267578125,
									1.7212890625000767
								],
								[
									-69.31972656250002,
									1.721240234375074
								],
								[
									-69.39433593749993,
									1.7257812500000256
								],
								[
									-69.47016601562493,
									1.7579101562500767
								],
								[
									-69.54291992187501,
									1.7732421875001023
								],
								[
									-69.58125000000001,
									1.7707519531250284
								],
								[
									-69.650048828125,
									1.739453125000054
								],
								[
									-69.73959960937503,
									1.7348632812500995
								],
								[
									-69.79995117187497,
									1.705175781250091
								],
								[
									-69.84858398437493,
									1.7087402343750142
								],
								[
									-69.84946289062503,
									1.5438964843750966
								],
								[
									-69.85078124999993,
									1.3087890625000682
								],
								[
									-69.85214843750003,
									1.0595214843750824
								],
								[
									-69.79814453124996,
									1.0784179687500313
								],
								[
									-69.751318359375,
									1.0766113281251108
								],
								[
									-69.71699218749995,
									1.05908203125
								],
								[
									-69.62089843749999,
									1.0732421875000426
								],
								[
									-69.56757812499998,
									1.065771484375034
								],
								[
									-69.51713867187499,
									1.0594726562500796
								],
								[
									-69.47031249999998,
									1.058593750000071
								],
								[
									-69.44150390624995,
									1.0388183593749574
								],
								[
									-69.40278320312498,
									1.0423828125000654
								],
								[
									-69.36137695312499,
									1.0640136718750313
								],
								[
									-69.31181640625002,
									1.0504882812500256
								],
								[
									-69.25869140625002,
									1.015380859375071
								],
								[
									-69.22446289062498,
									0.9631347656250853
								],
								[
									-69.19384765624994,
									0.8982910156250199
								],
								[
									-69.16323242187502,
									0.8640625000000597
								],
								[
									-69.16503906250003,
									0.8019531250001108
								],
								[
									-69.16596679687495,
									0.7533203125000512
								],
								[
									-69.17675781250003,
									0.712841796874983
								],
								[
									-69.16323242187502,
									0.6866699218749801
								],
								[
									-69.15332031249994,
									0.6587890625000767
								],
								[
									-69.15605468749999,
									0.6425292968750398
								],
								[
									-69.174072265625,
									0.6353515625000057
								],
								[
									-69.21279296875,
									0.6299316406250597
								],
								[
									-69.25419921874999,
									0.6254394531249403
								],
								[
									-69.28300781249999,
									0.6272460937500455
								],
								[
									-69.30551757812498,
									0.6524414062499346
								],
								[
									-69.32714843750003,
									0.6551757812500512
								],
								[
									-69.35864257812494,
									0.6515625000000256
								],
								[
									-69.3919921875,
									0.666894531250037
								],
								[
									-69.42080078125,
									0.6983886718750512
								],
								[
									-69.47211914062498,
									0.7299316406250824
								],
								[
									-69.52705078124998,
									0.716406250000091
								],
								[
									-69.56484374999994,
									0.700195312500071
								],
								[
									-69.60361328125003,
									0.6803710937499403
								],
								[
									-69.63872070312499,
									0.6596679687499858
								],
								[
									-69.67382812499994,
									0.665087890625017
								],
								[
									-69.718896484375,
									0.6498046875000227
								],
								[
									-69.75673828124997,
									0.6263671874999517
								],
								[
									-69.80712890625003,
									0.6074707031251023
								],
								[
									-69.86206054687503,
									0.5984863281250483
								],
								[
									-69.92509765624999,
									0.5894042968750597
								],
								[
									-69.98544921875,
									0.585839843750037
								],
								[
									-70.05390624999993,
									0.5786132812500853
								],
								[
									-70.05791015624996,
									0.44736328125007674
								],
								[
									-70.06572265624993,
									0.1893554687500938
								],
								[
									-70.07094726562502,
									0.01855468750002842
								],
								[
									-70.07050781249993,
									-0.13886718749998295
								],
								[
									-70.04404296874998,
									-0.19619140624993747
								],
								[
									-69.92275390624994,
									-0.31748046874996305
								],
								[
									-69.82792968749999,
									-0.38134765625
								],
								[
									-69.74746093750002,
									-0.45253906249993747
								],
								[
									-69.66748046875,
									-0.4824218749999858
								],
								[
									-69.63398437500001,
									-0.5092773437499574
								],
								[
									-69.61191406250003,
									-0.5533203124999488
								],
								[
									-69.60087890625002,
									-0.5996093750000568
								],
								[
									-69.59204101562497,
									-0.639355468749983
								],
								[
									-69.60087890625002,
									-0.6812499999999915
								],
								[
									-69.62070312499995,
									-0.720898437499983
								],
								[
									-69.61191406250003,
									-0.7627929687499062
								],
								[
									-69.58325195312497,
									-0.7958984374999005
								],
								[
									-69.57441406249995,
									-0.837792968749909
								],
								[
									-69.55458984375,
									-0.8774414062499005
								],
								[
									-69.54355468749998,
									-0.9171874999999261
								],
								[
									-69.519287109375,
									-0.9458007812499716
								],
								[
									-69.48842773437502,
									-0.965722656250037
								],
								[
									-69.44873046875,
									-0.9987304687500114
								],
								[
									-69.4443359375,
									-1.0295898437499034
								],
								[
									-69.44873046875,
									-1.06494140625
								],
								[
									-69.44912109375,
									-1.0916015624999318
								],
								[
									-69.41142578124996,
									-1.1522460937500227
								],
								[
									-69.40024414062498,
									-1.1949218749999204
								],
								[
									-69.41787109375002,
									-1.245703124999963
								],
								[
									-69.43491210937503,
									-1.4216796874999318
								],
								[
									-69.47861328124998,
									-1.62197265624998
								],
								[
									-69.50644531249995,
									-1.7749023437500426
								],
								[
									-69.55185546874998,
									-2.0242187500000313
								],
								[
									-69.60468749999998,
									-2.3142578124999744
								],
								[
									-69.66904296875003,
									-2.6676757812500256
								],
								[
									-69.73261718749993,
									-3.016699218749906
								],
								[
									-69.79414062499995,
									-3.3545898437499915
								],
								[
									-69.849755859375,
									-3.6598632812500114
								],
								[
									-69.91103515624997,
									-3.9965820312500426
								],
								[
									-69.94819335937498,
									-4.200585937500037
								],
								[
									-69.96591796875003,
									-4.235937499999963
								],
								[
									-70.0171875,
									-4.162011718749994
								],
								[
									-70.09477539062499,
									-4.09218749999998
								],
								[
									-70.16752929687499,
									-4.050195312499952
								],
								[
									-70.19838867187497,
									-3.995117187499929
								],
								[
									-70.24028320312499,
									-3.8827148437499375
								],
								[
									-70.29843749999992,
									-3.8442382812499147
								],
								[
									-70.33950195312494,
									-3.8143554687499517
								],
								[
									-70.37919921874993,
									-3.818749999999966
								],
								[
									-70.42109374999995,
									-3.849609374999943
								],
								[
									-70.48583984375,
									-3.8693359374999687
								],
								[
									-70.52968749999997,
									-3.8664062499998977
								],
								[
									-70.70620117187494,
									-3.7889648437500227
								],
								[
									-70.73510742187497,
									-3.781542968749932
								],
								[
									-70.62167968749995,
									-3.604589843749949
								],
								[
									-70.41899414062496,
									-3.288281249999983
								],
								[
									-70.29013671875,
									-3.08730468749998
								],
								[
									-70.1470703125,
									-2.8640624999999744
								],
								[
									-70.07402343749993,
									-2.7501953124999687
								],
								[
									-70.06445312499994,
									-2.7307617187499176
								],
								[
									-70.06474609375002,
									-2.701660156249929
								],
								[
									-70.09584960937494,
									-2.6582031249999574
								],
								[
									-70.16474609374995,
									-2.63984375000004
								],
								[
									-70.24443359374993,
									-2.6065429687500057
								],
								[
									-70.29462890624995,
									-2.552539062500017
								],
								[
									-70.36416015625,
									-2.5292968749999005
								],
								[
									-70.418212890625,
									-2.490722656249943
								],
								[
									-70.51679687500001,
									-2.453125000000014
								],
								[
									-70.57587890624995,
									-2.418261718750017
								],
								[
									-70.64799804687499,
									-2.4057617187499574
								],
								[
									-70.70537109374996,
									-2.3419921874999403
								],
								[
									-70.91455078125003,
									-2.2185546874999176
								],
								[
									-70.96855468750002,
									-2.206835937499932
								],
								[
									-71.02729492187498,
									-2.2257812499999687
								],
								[
									-71.11337890624995,
									-2.2454101562499744
								],
								[
									-71.19638671874998,
									-2.313085937499906
								],
								[
									-71.30009765624996,
									-2.334863281249909
								],
								[
									-71.39697265625,
									-2.3340820312499204
								],
								[
									-71.44746093749998,
									-2.29374999999996
								],
								[
									-71.49609375000003,
									-2.2791992187499375
								],
								[
									-71.55947265624997,
									-2.2242187499999204
								],
								[
									-71.67148437499995,
									-2.1821289062499574
								],
								[
									-71.75253906249995,
									-2.1527343749999233
								],
								[
									-71.80273437499997,
									-2.166308593749932
								],
								[
									-71.86728515624998,
									-2.227734374999926
								],
								[
									-71.93247070312492,
									-2.288671874999906
								],
								[
									-71.98427734375,
									-2.326562499999895
								],
								[
									-72.05380859374995,
									-2.3246093749999517
								],
								[
									-72.13681640625,
									-2.3806640624999034
								],
								[
									-72.21845703125001,
									-2.400488281249949
								],
								[
									-72.30073242187498,
									-2.409277343749963
								],
								[
									-72.39560546874995,
									-2.4289062499999687
								],
								[
									-72.50068359374995,
									-2.3950195312499005
								],
								[
									-72.58671874999999,
									-2.3651367187499375
								],
								[
									-72.62534179687495,
									-2.351660156249949
								],
								[
									-72.66015625000003,
									-2.361035156249912
								],
								[
									-72.71416015625002,
									-2.392187500000034
								],
								[
									-72.81123046874998,
									-2.405468749999983
								],
								[
									-72.88715820312501,
									-2.408496093749889
								],
								[
									-72.94111328124998,
									-2.3940429687499716
								],
								[
									-72.98964843750002,
									-2.3397460937500085
								],
								[
									-73.06816406250002,
									-2.3120117187499574
								],
								[
									-73.15449218749993,
									-2.278222656249909
								],
								[
									-73.17265624999999,
									-2.20839843749998
								],
								[
									-73.16020507812493,
									-2.156347656249949
								],
								[
									-73.12651367187502,
									-2.0810546874999716
								],
								[
									-73.14521484374998,
									-2.003320312500037
								],
								[
									-73.18149414062492,
									-1.8803710937499432
								],
								[
									-73.19697265624998,
									-1.8302734374999545
								],
								[
									-73.22397460937498,
									-1.787695312499892
								],
								[
									-73.266455078125,
									-1.772265624999946
								],
								[
									-73.34951171874997,
									-1.783886718749926
								],
								[
									-73.44028320312498,
									-1.7374023437499488
								],
								[
									-73.49628906249993,
									-1.693066406249983
								],
								[
									-73.52524414062498,
									-1.6388671875000398
								],
								[
									-73.49433593749998,
									-1.5366210937499005
								],
								[
									-73.52138671875,
									-1.4497070312499574
								],
								[
									-73.57548828124999,
									-1.4013671874999716
								],
								[
									-73.61025390624997,
									-1.3164062499999005
								],
								[
									-73.66430664062497,
									-1.2488281249998892
								],
								[
									-73.73574218749997,
									-1.2141601562499318
								],
								[
									-73.80717773437493,
									-1.217968749999912
								],
								[
									-73.86318359375,
									-1.1966796874999233
								],
								[
									-73.92695312500001,
									-1.125195312499926
								],
								[
									-73.98681640624994,
									-1.0981445312500142
								],
								[
									-74.05439453124995,
									-1.0286132812499744
								],
								[
									-74.18076171874992,
									-0.9977539062498977
								],
								[
									-74.24638671874999,
									-0.9706054687499659
								],
								[
									-74.28388671874998,
									-0.927832031249963
								],
								[
									-74.33442382812498,
									-0.8508789062499176
								],
								[
									-74.32861328124994,
									-0.8083984374999602
								],
								[
									-74.35312499999998,
									-0.7666015624999716
								],
								[
									-74.37490234374997,
									-0.691406249999929
								],
								[
									-74.41787109375002,
									-0.5806640624999346
								],
								[
									-74.46518554687498,
									-0.5176757812499773
								],
								[
									-74.51386718749993,
									-0.4701171874999659
								],
								[
									-74.555078125,
									-0.4298828124999403
								],
								[
									-74.61635742187494,
									-0.37001953124990905
								],
								[
									-74.691650390625,
									-0.3352539062499318
								],
								[
									-74.75537109375003,
									-0.2986328124999318
								],
								[
									-74.78046874999998,
									-0.24453124999992326
								],
								[
									-74.80175781249997,
									-0.20009765625002274
								],
								[
									-74.83749999999998,
									-0.20332031249996874
								],
								[
									-74.88881835937494,
									-0.19941406249996874
								],
								[
									-74.9453125,
									-0.1881835937499119
								],
								[
									-75.00498046874998,
									-0.15585937499997726
								],
								[
									-75.05468749999997,
									-0.11669921874991473
								],
								[
									-75.13837890624998,
									-0.050488281249926104
								],
								[
									-75.18408203124997,
									-0.041748046874914735
								],
								[
									-75.22460937499997,
									-0.041748046874914735
								],
								[
									-75.28447265624999,
									-0.10654296874997726
								],
								[
									-75.46396484374998,
									-0.03842773437494884
								],
								[
									-75.61733398437494,
									0.06289062500007958
								],
								[
									-75.77666015624999,
									0.08925781249995168
								],
								[
									-75.87978515624994,
									0.15097656250009095
								],
								[
									-75.97485351562494,
									0.24775390625008242
								],
								[
									-76.02617187500002,
									0.31308593750007674
								],
								[
									-76.06791992187499,
									0.3455566406250341
								],
								[
									-76.27060546874998,
									0.439404296875054
								],
								[
									-76.31103515624997,
									0.44848632812504263
								],
								[
									-76.38818359374997,
									0.40498046874996874
								],
								[
									-76.41337890624993,
									0.3788574218750682
								],
								[
									-76.41796875,
									0.30390624999998295
								],
								[
									-76.42729492187502,
									0.26123046875008527
								],
								[
									-76.49462890624997,
									0.23544921875006253
								],
								[
									-76.60302734375003,
									0.24096679687504263
								],
								[
									-76.67851562499996,
									0.26816406250007674
								],
								[
									-76.72900390625003,
									0.2721191406250796
								],
								[
									-76.73930664062499,
									0.2508300781250057
								],
								[
									-76.76772460937502,
									0.24165039062508242
								],
								[
									-76.82934570312494,
									0.24775390625008242
								],
								[
									-76.92011718749998,
									0.268505859375054
								],
								[
									-77.00244140624994,
									0.2962402343750199
								],
								[
									-77.11411132812498,
									0.3550781250000199
								],
								[
									-77.16572265625001,
									0.3477539062500341
								],
								[
									-77.29267578124993,
									0.360400390624946
								],
								[
									-77.396337890625,
									0.3938964843750199
								],
								[
									-77.42275390624997,
									0.4248535156249318
								],
								[
									-77.46767578124997,
									0.6365234375000597
								],
								[
									-77.48139648437501,
									0.6511718750000313
								],
								[
									-77.52612304687497,
									0.6603515625000398
								],
								[
									-77.60131835937503,
									0.689501953125017
								],
								[
									-77.64863281249998,
									0.7236328125000426
								],
								[
									-77.673193359375,
									0.7822265625000853
								],
								[
									-77.702880859375,
									0.8378417968750398
								],
								[
									-77.82954101562498,
									0.8253906249999972
								],
								[
									-78.03701171874997,
									0.898730468750017
								],
								[
									-78.1806640625,
									0.9685546875000313
								],
								[
									-78.31210937499995,
									1.0460937500001108
								],
								[
									-78.51152343749999,
									1.1988281250000483
								],
								[
									-78.58764648437497,
									1.236669921875034
								],
								[
									-78.68164062500003,
									1.2834472656250568
								],
								[
									-78.73710937499996,
									1.3586914062499318
								],
								[
									-78.828857421875,
									1.4346679687500483
								],
								[
									-78.85966796874996,
									1.455371093750088
								],
								[
									-78.88847656249996,
									1.5240722656250512
								],
								[
									-79.02543945312499,
									1.6236816406250938
								],
								[
									-78.95766601562502,
									1.7521972656249858
								],
								[
									-78.79296874999997,
									1.8487304687499346
								],
								[
									-78.576904296875,
									1.773779296875034
								],
								[
									-78.55043945312502,
									1.923632812500088
								],
								[
									-78.62861328124995,
									2.0562499999999346
								],
								[
									-78.617041015625,
									2.3067871093749943
								],
								[
									-78.59169921875,
									2.3566406250000256
								],
								[
									-78.53471679687502,
									2.4236816406250057
								],
								[
									-78.46044921874997,
									2.470068359375034
								],
								[
									-78.41689453125,
									2.4834960937499346
								],
								[
									-78.34287109375,
									2.4605468750000483
								],
								[
									-78.296142578125,
									2.5104980468750995
								],
								[
									-78.12001953125,
									2.488183593750094
								],
								[
									-78.06665039062497,
									2.5091308593750057
								],
								[
									-78.03017578125,
									2.5430664062499915
								],
								[
									-77.98720703125002,
									2.568994140625037
								],
								[
									-77.93227539062502,
									2.629248046874963
								],
								[
									-77.90078125,
									2.69882812500002
								],
								[
									-77.87451171874997,
									2.725878906249932
								],
								[
									-77.81357421875,
									2.716357421874946
								],
								[
									-77.807958984375,
									2.746386718750017
								],
								[
									-77.77666015624993,
									2.7873046875000114
								],
								[
									-77.67001953124998,
									2.8788574218750114
								],
								[
									-77.67109374999993,
									2.9193359375000796
								],
								[
									-77.70097656249999,
									3.007568359374943
								],
								[
									-77.69365234374999,
									3.039941406249966
								],
								[
									-77.63203124999995,
									3.051171875000037
								],
								[
									-77.55913085937496,
									3.075976562500017
								],
								[
									-77.52026367187503,
									3.160253906249963
								],
								[
									-77.47221679687502,
									3.2337890625000227
								],
								[
									-77.41713867187497,
									3.341796875
								],
								[
									-77.35654296874998,
									3.348583984375054
								],
								[
									-77.32441406250001,
									3.4747558593750796
								],
								[
									-77.24277343749998,
									3.585351562500051
								],
								[
									-77.076806640625,
									3.913281250000068
								],
								[
									-77.12685546875,
									3.906054687500017
								],
								[
									-77.1666015625,
									3.862255859374983
								],
								[
									-77.21201171875,
									3.8674316406249716
								],
								[
									-77.26352539062503,
									3.8932128906250654
								],
								[
									-77.24838867187498,
									4.040966796875068
								],
								[
									-77.27802734374995,
									4.058496093749994
								],
								[
									-77.35820312499996,
									3.9447265625000796
								],
								[
									-77.42729492187499,
									4.060449218750037
								],
								[
									-77.43354492187495,
									4.130957031250105
								],
								[
									-77.40449218749998,
									4.20078125000002
								],
								[
									-77.40874023437496,
									4.247753906250097
								],
								[
									-77.52070312499993,
									4.21279296875008
								],
								[
									-77.51552734374994,
									4.256298828124969
								],
								[
									-77.44584960937496,
									4.301025390625114
								],
								[
									-77.41425781250001,
									4.347607421875097
								],
								[
									-77.35351562499997,
									4.398291015625034
								],
								[
									-77.32832031250001,
									4.4749999999999375
								],
								[
									-77.31367187499995,
									4.5938476562499915
								],
								[
									-77.28632812499998,
									4.721728515624932
								],
								[
									-77.30654296875,
									4.784667968750057
								],
								[
									-77.33945312499995,
									4.838525390625094
								],
								[
									-77.36674804687502,
									5.076562500000094
								],
								[
									-77.35917968749999,
									5.215185546875091
								],
								[
									-77.373291015625,
									5.323974609375057
								],
								[
									-77.40175781249994,
									5.4161621093750085
								],
								[
									-77.53442382812497,
									5.537109374999957
								],
								[
									-77.32460937499997,
									5.675634765624935
								],
								[
									-77.24926757812497,
									5.780175781250094
								],
								[
									-77.34467773437495,
									5.995361328125057
								],
								[
									-77.46943359374998,
									6.176757812500057
								],
								[
									-77.473046875,
									6.285644531250043
								],
								[
									-77.44008789062494,
									6.271728515625043
								],
								[
									-77.39824218749993,
									6.275000000000006
								],
								[
									-77.35986328125003,
									6.504492187500034
								],
								[
									-77.368798828125,
									6.575585937500051
								],
								[
									-77.43886718749997,
									6.690332031250065
								],
								[
									-77.52597656250003,
									6.6931152343750995
								],
								[
									-77.6021484375,
									6.83730468750008
								],
								[
									-77.64584960937503,
									6.86962890625
								],
								[
									-77.68095703124999,
									6.960400390625111
								],
								[
									-77.80371093749994,
									7.137255859374989
								],
								[
									-77.90117187499999,
									7.229345703125091
								],
								[
									-77.82832031249998,
									7.442822265625068
								],
								[
									-77.76469726562499,
									7.4836914062500455
								],
								[
									-77.74389648437503,
									7.5369628906250625
								],
								[
									-77.76874999999993,
									7.668066406249949
								],
								[
									-77.76191406249995,
									7.698828125000091
								],
								[
									-77.746923828125,
									7.711865234375082
								],
								[
									-77.73203125,
									7.710937500000071
								],
								[
									-77.70634765625002,
									7.6912109375000455
								],
								[
									-77.65859374999997,
									7.6346191406250625
								],
								[
									-77.61860351562498,
									7.564550781250091
								],
								[
									-77.58657226562494,
									7.5430664062500625
								],
								[
									-77.53828124999995,
									7.5662597656249915
								],
								[
									-77.35078124999995,
									7.705859375000102
								],
								[
									-77.36274414062498,
									7.749072265624932
								],
								[
									-77.34560546874997,
									7.836523437500077
								],
								[
									-77.282958984375,
									7.908154296875011
								],
								[
									-77.21596679687502,
									7.932519531250094
								],
								[
									-77.19599609374995,
									7.97246093750006
								],
								[
									-77.2123046875,
									8.03388671875004
								],
								[
									-77.28261718750002,
									8.187060546874989
								],
								[
									-77.34550781249996,
									8.269531250000085
								],
								[
									-77.385888671875,
									8.351660156249949
								],
								[
									-77.40727539062502,
									8.427246093750071
								],
								[
									-77.47851562499994,
									8.498437500000009
								],
								[
									-77.44833984375003,
									8.565869140625068
								],
								[
									-77.39306640624994,
									8.644677734375051
								],
								[
									-77.37421874999993,
									8.658300781250063
								],
								[
									-77.34414062500002,
									8.636718750000028
								],
								[
									-77.26157226562498,
									8.493701171874932
								],
								[
									-77.13012695312503,
									8.400585937499969
								],
								[
									-76.99228515625,
									8.250341796875091
								],
								[
									-76.93583984374999,
									8.146826171874963
								],
								[
									-76.89096679687498,
									8.127978515625031
								],
								[
									-76.85185546875002,
									8.090478515625023
								],
								[
									-76.86909179687495,
									8.062695312500054
								],
								[
									-76.91220703124995,
									8.03339843750004
								],
								[
									-76.924658203125,
									7.973193359375031
								],
								[
									-76.896630859375,
									7.939453125000085
								],
								[
									-76.86689453124995,
									7.917968750000057
								],
								[
									-76.78657226562495,
									7.931591796875082
								],
								[
									-76.742333984375,
									8.002148437500068
								],
								[
									-76.7720703125,
									8.3105468750001
								],
								[
									-76.81860351562497,
									8.464697265625063
								],
								[
									-76.872216796875,
									8.512744140625074
								],
								[
									-76.92045898437496,
									8.573730468750071
								],
								[
									-76.88798828124999,
									8.619873046875057
								],
								[
									-76.80224609375003,
									8.640673828125031
								],
								[
									-76.68935546874994,
									8.694726562500023
								],
								[
									-76.27685546875003,
									8.989111328124963
								],
								[
									-76.135498046875,
									9.265624999999986
								],
								[
									-76.02724609374997,
									9.36577148437496
								],
								[
									-75.90502929687503,
									9.430908203125085
								],
								[
									-75.75556640624995,
									9.415624999999991
								],
								[
									-75.63935546874998,
									9.450439453125071
								],
								[
									-75.60361328125,
									9.538476562500065
								],
								[
									-75.63535156249998,
									9.657812499999949
								],
								[
									-75.680029296875,
									9.729785156250045
								],
								[
									-75.63710937499997,
									9.834277343750017
								],
								[
									-75.59267578125,
									9.99272460937506
								],
								[
									-75.59589843749993,
									10.125830078125077
								],
								[
									-75.53857421874997,
									10.205175781250077
								],
								[
									-75.55839843750002,
									10.236425781250048
								],
								[
									-75.64218750000003,
									10.172167968749932
								],
								[
									-75.708349609375,
									10.143408203124935
								],
								[
									-75.67089843750003,
									10.19633789062506
								],
								[
									-75.55371093749994,
									10.327734375000006
								],
								[
									-75.49277343749998,
									10.527636718750045
								],
								[
									-75.44599609374995,
									10.61088867187496
								],
								[
									-75.280615234375,
									10.727197265625023
								],
								[
									-75.24794921875002,
									10.783251953125074
								],
								[
									-75.12304687499997,
									10.870410156250074
								],
								[
									-74.92158203124995,
									11.057568359375011
								],
								[
									-74.84458007812498,
									11.109716796874977
								],
								[
									-74.45424804687497,
									10.989062500000088
								],
								[
									-74.330224609375,
									10.996679687500034
								],
								[
									-74.352392578125,
									10.974658203125088
								],
								[
									-74.4095703125,
									10.967187500000065
								],
								[
									-74.49228515624998,
									10.93447265624998
								],
								[
									-74.516259765625,
									10.862500000000054
								],
								[
									-74.46025390624993,
									10.787060546874969
								],
								[
									-74.40087890625,
									10.765234374999963
								],
								[
									-74.35019531249998,
									10.813720703125071
								],
								[
									-74.29995117187497,
									10.952246093750048
								],
								[
									-74.21914062500002,
									11.105322265625063
								],
								[
									-74.20019531249997,
									11.265722656249963
								],
								[
									-74.14291992187503,
									11.320849609375003
								],
								[
									-74.05913085937502,
									11.340624999999946
								],
								[
									-73.90957031250002,
									11.308886718750045
								],
								[
									-73.79570312499999,
									11.275683593750031
								],
								[
									-73.67690429687497,
									11.271484375000071
								],
								[
									-73.31337890624997,
									11.295751953125034
								],
								[
									-72.721826171875,
									11.712158203125057
								],
								[
									-72.44707031249996,
									11.801708984375082
								],
								[
									-72.27499999999998,
									11.889257812500077
								],
								[
									-72.16523437500001,
									12.060205078124994
								],
								[
									-72.13574218749994,
									12.188574218750034
								],
								[
									-72.05507812499994,
									12.238427734375065
								],
								[
									-71.97011718749997,
									12.238281250000028
								],
								[
									-71.93125000000003,
									12.2695312500001
								],
								[
									-71.91914062499995,
									12.309082031250071
								],
								[
									-71.71455078124995,
									12.419970703125017
								],
								[
									-71.59746093749999,
									12.434375000000017
								],
								[
									-71.49399414062503,
									12.432275390625037
								],
								[
									-71.26210937499997,
									12.335302734375077
								],
								[
									-71.155029296875,
									12.164160156250034
								],
								[
									-71.13730468750003,
									12.046337890625011
								],
								[
									-71.28417968750003,
									11.918310546875034
								],
								[
									-71.31972656249997,
									11.861914062500091
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "COL",
					"su_a3": "COL",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "COL",
					"gu_a3": "COL",
					"abbrev": "Col.",
					"region_un": "Americas",
					"adm0_a3_us": "COL",
					"scalerank": 1,
					"pop_est": 45644023,
					"adm0_dif": 0,
					"un_a3": "170",
					"pop_year": -99,
					"gdp_md_est": 395400,
					"name": "Colombia",
					"sovereignt": "Colombia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Colombia",
					"postal": "CO",
					"sov_a3": "COL",
					"note_brk": "",
					"brk_a3": "COL",
					"wb_a2": "CO",
					"brk_diff": 0,
					"admin": "Colombia",
					"name_long": "Colombia",
					"iso_a3": "COL",
					"iso_a2": "CO",
					"adm0_a3_is": "COL",
					"level": 2,
					"formal_en": "Republic of Colombia",
					"name_len": 8,
					"mapcolor7": 2,
					"long_len": 8,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "170",
					"homepart": 1,
					"subunit": "Colombia",
					"name_alt": "",
					"brk_name": "Colombia",
					"name_sort": "Colombia",
					"continent": "South America",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-83.6419921875,
								10.917236328125014
							],
							[
								-83.61728515624995,
								10.877490234375003
							],
							[
								-83.58818359374996,
								10.814990234374974
							],
							[
								-83.57529296875,
								10.734716796874963
							],
							[
								-83.44824218749997,
								10.465917968750006
							],
							[
								-83.346826171875,
								10.315380859374969
							],
							[
								-83.12460937499995,
								10.041601562499977
							],
							[
								-83.02851562499998,
								9.991259765625017
							],
							[
								-82.86630859374998,
								9.770947265624997
							],
							[
								-82.81030273437503,
								9.73457031250004
							],
							[
								-82.77841796874992,
								9.66953125000002
							],
							[
								-82.61015624999993,
								9.61601562499996
							],
							[
								-82.56357421874995,
								9.576660156250028
							],
							[
								-82.56923828124994,
								9.558203125000077
							],
							[
								-82.5865234375,
								9.538818359375043
							],
							[
								-82.61127929687498,
								9.519238281250054
							],
							[
								-82.64409179687502,
								9.505859375000071
							],
							[
								-82.723388671875,
								9.546093750000097
							],
							[
								-82.801025390625,
								9.591796875
							],
							[
								-82.84399414062497,
								9.570800781249986
							],
							[
								-82.86015624999996,
								9.511474609375071
							],
							[
								-82.88896484374999,
								9.481005859374989
							],
							[
								-82.92504882812497,
								9.469042968750031
							],
							[
								-82.93984374999997,
								9.449169921875068
							],
							[
								-82.94282226562493,
								9.248876953125034
							],
							[
								-82.94033203124997,
								9.060107421875031
							],
							[
								-82.88134765625003,
								9.055859375000054
							],
							[
								-82.78305664062498,
								8.990283203125017
							],
							[
								-82.74116210937498,
								8.951708984375074
							],
							[
								-82.72783203125002,
								8.916064453125003
							],
							[
								-82.739990234375,
								8.898583984374994
							],
							[
								-82.8119140625,
								8.857421875000043
							],
							[
								-82.88198242187497,
								8.805322265625094
							],
							[
								-82.91704101562502,
								8.740332031250077
							],
							[
								-82.85571289062494,
								8.635302734375003
							],
							[
								-82.84262695312495,
								8.563964843750028
							],
							[
								-82.84477539062496,
								8.48935546875002
							],
							[
								-82.86162109375002,
								8.453515625000094
							],
							[
								-82.99755859375,
								8.367773437500034
							],
							[
								-83.02734375000003,
								8.337744140625048
							],
							[
								-83.02338867187501,
								8.316015625000063
							],
							[
								-82.94843750000001,
								8.256835937500085
							],
							[
								-82.91289062499996,
								8.199609375000051
							],
							[
								-82.88330078124997,
								8.130566406250026
							],
							[
								-82.87934570312498,
								8.070654296875077
							],
							[
								-82.94726562499994,
								8.181738281249963
							],
							[
								-83.04145507812495,
								8.28774414062498
							],
							[
								-83.12333984374993,
								8.353076171874974
							],
							[
								-83.12958984374998,
								8.50546875000002
							],
							[
								-83.16240234374999,
								8.588183593749989
							],
							[
								-83.285791015625,
								8.664355468749974
							],
							[
								-83.39140624999993,
								8.717724609375011
							],
							[
								-83.4697265625,
								8.706835937500003
							],
							[
								-83.42177734375,
								8.61923828125002
							],
							[
								-83.29775390624994,
								8.506884765625045
							],
							[
								-83.28955078124997,
								8.463818359374969
							],
							[
								-83.29150390625,
								8.406005859375
							],
							[
								-83.37680664062498,
								8.414892578125034
							],
							[
								-83.45205078124994,
								8.438476562500043
							],
							[
								-83.54374999999996,
								8.445849609375045
							],
							[
								-83.60473632812497,
								8.480322265625048
							],
							[
								-83.73408203125001,
								8.614453125000011
							],
							[
								-83.64218749999995,
								8.72890624999998
							],
							[
								-83.61372070312501,
								8.804052734375006
							],
							[
								-83.61616210937498,
								8.959814453125034
							],
							[
								-83.63725585937502,
								9.035351562499969
							],
							[
								-83.73691406249998,
								9.150292968750023
							],
							[
								-83.89555664062496,
								9.27641601562496
							],
							[
								-84.11787109374995,
								9.379443359374989
							],
							[
								-84.22236328125001,
								9.462500000000034
							],
							[
								-84.48266601562503,
								9.526171875000045
							],
							[
								-84.58159179687493,
								9.568359375000014
							],
							[
								-84.65888671874995,
								9.646679687499983
							],
							[
								-84.67045898437502,
								9.702880859374986
							],
							[
								-84.64306640625003,
								9.78940429687502
							],
							[
								-84.71494140624992,
								9.899414062500057
							],
							[
								-85.02504882812494,
								10.115722656249972
							],
							[
								-85.19843750000001,
								10.195312500000028
							],
							[
								-85.23564453124996,
								10.242089843749966
							],
							[
								-85.26318359374997,
								10.256640625000003
							],
							[
								-85.23652343749995,
								10.107373046875054
							],
							[
								-85.16074218749998,
								10.01743164062502
							],
							[
								-84.96279296874997,
								9.933447265624963
							],
							[
								-84.90834960937497,
								9.88457031249996
							],
							[
								-84.88642578125004,
								9.820947265624966
							],
							[
								-85.00126953124999,
								9.699267578125045
							],
							[
								-85.059716796875,
								9.668310546875048
							],
							[
								-85.07705078124997,
								9.601953125000023
							],
							[
								-85.11450195312497,
								9.581787109375
							],
							[
								-85.15400390625001,
								9.620068359374983
							],
							[
								-85.31455078124995,
								9.810937499999966
							],
							[
								-85.62485351562492,
								9.902441406250048
							],
							[
								-85.681005859375,
								9.958593750000034
							],
							[
								-85.796484375,
								10.132861328125003
							],
							[
								-85.84965820312499,
								10.292041015625017
							],
							[
								-85.83061523437502,
								10.398144531250054
							],
							[
								-85.70312499999997,
								10.563476562499986
							],
							[
								-85.66333007812494,
								10.635449218749983
							],
							[
								-85.67143554687502,
								10.679785156249963
							],
							[
								-85.66723632812494,
								10.745019531250023
							],
							[
								-85.71484374999997,
								10.790576171874974
							],
							[
								-85.83286132812495,
								10.849951171874991
							],
							[
								-85.90800781249999,
								10.897558593750006
							],
							[
								-85.88740234375004,
								10.921289062500051
							],
							[
								-85.75224609374996,
								10.985253906250023
							],
							[
								-85.74370117187499,
								11.042968750000057
							],
							[
								-85.74433593750004,
								11.062109375000048
							],
							[
								-85.72226562499998,
								11.066259765625006
							],
							[
								-85.70263671874997,
								11.081542968750014
							],
							[
								-85.69052734374998,
								11.09746093749996
							],
							[
								-85.65366210937495,
								11.153076171875014
							],
							[
								-85.62138671874993,
								11.184472656250023
							],
							[
								-85.58417968749998,
								11.189453125000057
							],
							[
								-85.53872070312497,
								11.16630859374996
							],
							[
								-85.36835937499998,
								11.106445312500014
							],
							[
								-85.17895507812494,
								11.039941406249966
							],
							[
								-84.90917968749997,
								10.945312500000057
							],
							[
								-84.79736328125003,
								11.00590820312496
							],
							[
								-84.70117187499997,
								11.052197265624983
							],
							[
								-84.6341796875,
								11.045605468749969
							],
							[
								-84.48916015625002,
								10.991650390624997
							],
							[
								-84.40185546875,
								10.974462890625048
							],
							[
								-84.34829101562502,
								10.979882812499994
							],
							[
								-84.25556640625004,
								10.900732421875034
							],
							[
								-84.20498046874994,
								10.84130859375
							],
							[
								-84.19658203125002,
								10.801708984375026
							],
							[
								-84.16835937499994,
								10.78037109375002
							],
							[
								-84.09619140625,
								10.77568359374996
							],
							[
								-83.919287109375,
								10.7353515625
							],
							[
								-83.81118164062502,
								10.74326171875002
							],
							[
								-83.71293945312499,
								10.785888671875
							],
							[
								-83.658935546875,
								10.836865234374983
							],
							[
								-83.6419921875,
								10.917236328125014
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central America",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "CRI",
					"su_a3": "CRI",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "CRI",
					"gu_a3": "CRI",
					"abbrev": "C.R.",
					"region_un": "Americas",
					"adm0_a3_us": "CRI",
					"scalerank": 1,
					"pop_est": 4253877,
					"adm0_dif": 0,
					"un_a3": "188",
					"pop_year": -99,
					"gdp_md_est": 48320,
					"name": "Costa Rica",
					"sovereignt": "Costa Rica",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Costa Rica",
					"postal": "CR",
					"sov_a3": "CRI",
					"note_brk": "",
					"brk_a3": "CRI",
					"wb_a2": "CR",
					"brk_diff": 0,
					"admin": "Costa Rica",
					"name_long": "Costa Rica",
					"iso_a3": "CRI",
					"iso_a2": "CR",
					"adm0_a3_is": "CRI",
					"level": 2,
					"formal_en": "Republic of Costa Rica",
					"name_len": 10,
					"mapcolor7": 3,
					"long_len": 10,
					"mapcolor8": 2,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "188",
					"homepart": 1,
					"subunit": "Costa Rica",
					"name_alt": "",
					"brk_name": "Costa Rica",
					"name_sort": "Costa Rica",
					"continent": "North America",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								14.809375000000074,
								50.858984375000006
							],
							[
								14.895800781249989,
								50.861376953125045
							],
							[
								14.982910156249972,
								50.886572265625034
							],
							[
								14.989941406249983,
								50.92724609375006
							],
							[
								14.984472656250034,
								51.00341796875003
							],
							[
								14.993750000000063,
								51.01435546875004
							],
							[
								15.1259765625,
								50.99287109375001
							],
							[
								15.258593750000017,
								50.958544921875045
							],
							[
								15.27705078125004,
								50.88300781250001
							],
							[
								15.312597656250006,
								50.84575195312496
							],
							[
								15.35439453125008,
								50.81176757812497
							],
							[
								15.394628906250006,
								50.79628906250002
							],
							[
								15.463964843750006,
								50.793847656249966
							],
							[
								15.643945312499994,
								50.748876953125034
							],
							[
								15.730566406250063,
								50.73969726562504
							],
							[
								15.819238281250023,
								50.70869140625001
							],
							[
								15.893945312500051,
								50.67690429687502
							],
							[
								15.948535156250074,
								50.670263671875006
							],
							[
								15.973828125000068,
								50.63544921875001
							],
							[
								16.007226562500023,
								50.61162109374996
							],
							[
								16.06640625,
								50.62993164062496
							],
							[
								16.2822265625,
								50.655615234375034
							],
							[
								16.359960937500034,
								50.62138671874999
							],
							[
								16.41250000000008,
								50.58515624999998
							],
							[
								16.419726562500045,
								50.57363281250005
							],
							[
								16.39228515625004,
								50.54165039062502
							],
							[
								16.37910156250004,
								50.51689453125002
							],
							[
								16.356640625000068,
								50.50048828124997
							],
							[
								16.282519531250074,
								50.48300781250006
							],
							[
								16.24072265625,
								50.45468750000006
							],
							[
								16.210351562500023,
								50.423730468749966
							],
							[
								16.230761718750017,
								50.39409179687496
							],
							[
								16.291308593750074,
								50.37187499999996
							],
							[
								16.33417968750001,
								50.36689453125001
							],
							[
								16.35048828125005,
								50.34521484375006
							],
							[
								16.487597656250017,
								50.248388671875034
							],
							[
								16.59667968750003,
								50.121923828125034
							],
							[
								16.63916015624997,
								50.102148437500006
							],
							[
								16.67910156250005,
								50.09746093750002
							],
							[
								16.72529296875004,
								50.116064453125006
							],
							[
								16.778613281250074,
								50.15703124999999
							],
							[
								16.841796875000057,
								50.18671875000001
							],
							[
								16.895312500000045,
								50.20195312499999
							],
							[
								16.98964843750008,
								50.236914062500006
							],
							[
								16.99335937500001,
								50.25971679687504
							],
							[
								16.914746093749983,
								50.34521484375006
							],
							[
								16.86914062500003,
								50.41450195312504
							],
							[
								16.88007812500004,
								50.42705078125002
							],
							[
								16.980761718750045,
								50.416113281250006
							],
							[
								17.151953125000006,
								50.37832031250005
							],
							[
								17.415234374999983,
								50.25478515625002
							],
							[
								17.46230468750008,
								50.25478515625002
							],
							[
								17.55458984375005,
								50.26406250000002
							],
							[
								17.654687500000023,
								50.28422851562496
							],
							[
								17.702246093750034,
								50.30717773437502
							],
							[
								17.720117187500023,
								50.29863281249996
							],
							[
								17.735449218750034,
								50.23076171874999
							],
							[
								17.709277343750045,
								50.19355468750007
							],
							[
								17.58935546875003,
								50.157470703125
							],
							[
								17.596289062500034,
								50.13950195312506
							],
							[
								17.627050781250063,
								50.11640625000007
							],
							[
								17.68105468750005,
								50.10078124999998
							],
							[
								17.74658203125,
								50.056787109374994
							],
							[
								17.79169921875004,
								50.00659179687497
							],
							[
								17.83125000000001,
								49.98330078125002
							],
							[
								17.874804687500017,
								49.972265625000006
							],
							[
								17.983789062499994,
								49.99907226562496
							],
							[
								18.0146484375,
								50.02026367187503
							],
							[
								18.02832031250003,
								50.03525390625006
							],
							[
								18.049511718750068,
								50.03193359374998
							],
							[
								18.087695312500045,
								50.00727539062504
							],
							[
								18.099218749999977,
								49.992773437500006
							],
							[
								18.20527343750001,
								49.964746093749994
							],
							[
								18.26630859375001,
								49.93027343749998
							],
							[
								18.305273437500034,
								49.91406250000006
							],
							[
								18.348437500000045,
								49.929833984374966
							],
							[
								18.516210937500034,
								49.90239257812499
							],
							[
								18.562402343750023,
								49.87934570312498
							],
							[
								18.5771484375,
								49.84111328125002
							],
							[
								18.56884765625,
								49.81791992187502
							],
							[
								18.594628906250023,
								49.75781250000003
							],
							[
								18.806933593750017,
								49.61372070312507
							],
							[
								18.82929687500004,
								49.54013671874998
							],
							[
								18.83222656250001,
								49.51079101562496
							],
							[
								18.807031250000023,
								49.50922851562501
							],
							[
								18.749707031249983,
								49.493994140625006
							],
							[
								18.676171875000023,
								49.48847656250004
							],
							[
								18.596484375000045,
								49.49145507812503
							],
							[
								18.53457031250005,
								49.46469726562498
							],
							[
								18.47607421875003,
								49.42109374999998
							],
							[
								18.415820312500017,
								49.39091796874996
							],
							[
								18.38310546874999,
								49.363916015624966
							],
							[
								18.364843750000006,
								49.33623046875002
							],
							[
								18.160937500000045,
								49.25737304687502
							],
							[
								18.132617187500045,
								49.22456054687501
							],
							[
								18.109960937500034,
								49.179785156250034
							],
							[
								18.100390625000045,
								49.11933593750007
							],
							[
								18.08593750000003,
								49.06513671875004
							],
							[
								18.050878906250006,
								49.036523437499966
							],
							[
								17.940722656250017,
								49.01196289062503
							],
							[
								17.91328125000004,
								48.99873046875001
							],
							[
								17.892675781250006,
								48.97114257812507
							],
							[
								17.830859375000017,
								48.92861328125002
							],
							[
								17.75849609375004,
								48.88813476562504
							],
							[
								17.62539062500008,
								48.84184570312502
							],
							[
								17.48261718750004,
								48.827783203124994
							],
							[
								17.29687500000003,
								48.842822265625045
							],
							[
								17.18847656249997,
								48.860937500000006
							],
							[
								17.13564453125005,
								48.84106445312503
							],
							[
								17.063281250000045,
								48.78076171875
							],
							[
								16.98525390625005,
								48.676904296874994
							],
							[
								16.953125,
								48.59882812500007
							],
							[
								16.928320312500006,
								48.620898437500045
							],
							[
								16.88369140625005,
								48.703710937500034
							],
							[
								16.833203124999983,
								48.71430664062507
							],
							[
								16.764453125000017,
								48.722021484375034
							],
							[
								16.712695312500045,
								48.734228515625034
							],
							[
								16.600976562500023,
								48.781884765624966
							],
							[
								16.543554687500034,
								48.79624023437506
							],
							[
								16.47792968750008,
								48.800097656250045
							],
							[
								16.414843750000017,
								48.772070312500006
							],
							[
								16.367285156250006,
								48.73896484375001
							],
							[
								16.219335937499977,
								48.73940429687502
							],
							[
								16.057226562500006,
								48.75478515625005
							],
							[
								15.825195312499972,
								48.86445312500001
							],
							[
								15.76503906250008,
								48.86542968750001
							],
							[
								15.700781250000034,
								48.86044921874998
							],
							[
								15.599414062500074,
								48.88637695312502
							],
							[
								15.402929687500006,
								48.957373046875006
							],
							[
								15.310937500000023,
								48.97402343750002
							],
							[
								15.252734375000074,
								48.9638671875
							],
							[
								15.19960937500008,
								48.948144531249994
							],
							[
								15.161718750000006,
								48.94628906249997
							],
							[
								15.139746093750034,
								48.96933593750006
							],
							[
								15.066796875000023,
								48.99785156249999
							],
							[
								14.993457031249989,
								49.00112304687505
							],
							[
								14.97216796875,
								48.98393554687502
							],
							[
								14.947363281250034,
								48.82773437499998
							],
							[
								14.92255859375004,
								48.77138671875005
							],
							[
								14.821875000000034,
								48.77402343750006
							],
							[
								14.785937499999989,
								48.747363281250045
							],
							[
								14.706640625000006,
								48.671923828125045
							],
							[
								14.69130859375008,
								48.59921875000006
							],
							[
								14.553906250000068,
								48.61333007812499
							],
							[
								14.488671875000023,
								48.62553710937499
							],
							[
								14.43105468750008,
								48.61625976562499
							],
							[
								14.367578125000023,
								48.57622070312499
							],
							[
								14.189843750000051,
								48.57856445312501
							],
							[
								14.049121093750074,
								48.60249023437501
							],
							[
								13.988769531250028,
								48.692431640625045
							],
							[
								13.924316406250057,
								48.72802734375
							],
							[
								13.843164062500051,
								48.759863281250006
							],
							[
								13.814746093750017,
								48.766943359375034
							],
							[
								13.769921875000051,
								48.815966796875074
							],
							[
								13.684960937500051,
								48.876708984375114
							],
							[
								13.547656250000045,
								48.95966796875004
							],
							[
								13.440722656250045,
								48.95556640625
							],
							[
								13.401171875000045,
								48.97758789062496
							],
							[
								13.383691406250051,
								49.00810546874996
							],
							[
								13.339062500000011,
								49.06079101562503
							],
							[
								13.288769531250068,
								49.097460937500045
							],
							[
								13.227832031250017,
								49.111669921875006
							],
							[
								13.14052734375008,
								49.15834960937511
							],
							[
								13.023730468750074,
								49.26010742187506
							],
							[
								12.91669921875004,
								49.330468749999994
							],
							[
								12.813378906250023,
								49.32934570312503
							],
							[
								12.747851562500017,
								49.366210937500085
							],
							[
								12.68115234375,
								49.41450195312507
							],
							[
								12.63203125000004,
								49.46123046874999
							],
							[
								12.555761718750034,
								49.57485351562505
							],
							[
								12.500292968750017,
								49.63969726562502
							],
							[
								12.45703125,
								49.67978515625012
							],
							[
								12.408203125,
								49.713183593750074
							],
							[
								12.390527343750051,
								49.73964843750005
							],
							[
								12.450195312500028,
								49.80014648437512
							],
							[
								12.471875000000011,
								49.830078125000085
							],
							[
								12.49755859375,
								49.853076171875074
							],
							[
								12.512500000000017,
								49.87744140625006
							],
							[
								12.512011718750017,
								49.895800781250074
							],
							[
								12.457617187500034,
								49.95551757812507
							],
							[
								12.38417968750008,
								49.998583984375045
							],
							[
								12.276464843749977,
								50.04233398437498
							],
							[
								12.207812500000045,
								50.097509765625034
							],
							[
								12.182519531250023,
								50.14804687500012
							],
							[
								12.175000000000011,
								50.1758300781251
							],
							[
								12.12783203125008,
								50.21342773437502
							],
							[
								12.089746093750051,
								50.26855468749997
							],
							[
								12.089843749999972,
								50.301757812500085
							],
							[
								12.099218750000034,
								50.3109863281251
							],
							[
								12.134863281250006,
								50.310937499999994
							],
							[
								12.174804687500057,
								50.28837890625002
							],
							[
								12.231152343749983,
								50.24487304687503
							],
							[
								12.27734375,
								50.18144531249999
							],
							[
								12.305664062499972,
								50.20571289062505
							],
							[
								12.358593750000011,
								50.273242187500045
							],
							[
								12.45263671875,
								50.34980468750001
							],
							[
								12.549023437500011,
								50.393408203125006
							],
							[
								12.635546875000045,
								50.397070312500034
							],
							[
								12.706445312500023,
								50.40913085937501
							],
							[
								12.765429687500045,
								50.43095703125002
							],
							[
								12.868261718750034,
								50.42221679687509
							],
							[
								12.942675781249989,
								50.4064453125001
							],
							[
								12.966796875000028,
								50.41621093750004
							],
							[
								12.997070312500057,
								50.45605468750006
							],
							[
								13.016406250000017,
								50.49038085937505
							],
							[
								13.18115234375,
								50.51049804687497
							],
							[
								13.237695312500051,
								50.57675781250006
							],
							[
								13.269531250000057,
								50.576416015625085
							],
							[
								13.306054687500051,
								50.586328124999966
							],
							[
								13.341015625000068,
								50.61142578125009
							],
							[
								13.374609375000063,
								50.62172851562508
							],
							[
								13.401171875000045,
								50.60932617187504
							],
							[
								13.436132812499977,
								50.60107421875003
							],
							[
								13.472558593750023,
								50.616943359375085
							],
							[
								13.526562500000011,
								50.69282226562498
							],
							[
								13.556738281250034,
								50.704638671875074
							],
							[
								13.701367187500011,
								50.71650390625001
							],
							[
								13.898535156250034,
								50.76127929687499
							],
							[
								13.998437500000051,
								50.80112304687512
							],
							[
								14.096484375000045,
								50.822753906250085
							],
							[
								14.201757812500006,
								50.86123046875011
							],
							[
								14.369042968750051,
								50.89873046875002
							],
							[
								14.377050781250006,
								50.91406250000003
							],
							[
								14.299414062500006,
								50.95258789062507
							],
							[
								14.273339843750023,
								50.976904296875034
							],
							[
								14.255859375,
								51.00185546875005
							],
							[
								14.283203124999972,
								51.02949218750001
							],
							[
								14.319726562500051,
								51.03779296875001
							],
							[
								14.367285156250063,
								51.02626953125005
							],
							[
								14.50732421875,
								51.009863281250006
							],
							[
								14.545703125000074,
								50.99394531249996
							],
							[
								14.559667968750006,
								50.954931640625006
							],
							[
								14.595214843750057,
								50.91860351562508
							],
							[
								14.623828125000017,
								50.91474609375007
							],
							[
								14.613574218750045,
								50.85556640625009
							],
							[
								14.658203125,
								50.832617187500034
							],
							[
								14.72333984375004,
								50.81469726562503
							],
							[
								14.766503906250023,
								50.81831054687507
							],
							[
								14.797460937500034,
								50.842333984375074
							],
							[
								14.809375000000074,
								50.858984375000006
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "CZE",
					"su_a3": "CZE",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "CZE",
					"gu_a3": "CZE",
					"abbrev": "Cz. Rep.",
					"region_un": "Europe",
					"adm0_a3_us": "CZE",
					"scalerank": 1,
					"pop_est": 10211904,
					"adm0_dif": 0,
					"un_a3": "203",
					"pop_year": -99,
					"gdp_md_est": 265200,
					"name": "Czech Rep.",
					"sovereignt": "Czech Republic",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 8,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Czech Republic",
					"postal": "CZ",
					"sov_a3": "CZE",
					"note_brk": "",
					"brk_a3": "CZE",
					"wb_a2": "CZ",
					"brk_diff": 0,
					"admin": "Czech Republic",
					"name_long": "Czech Republic",
					"iso_a3": "CZE",
					"iso_a2": "CZ",
					"adm0_a3_is": "CZE",
					"level": 2,
					"formal_en": "Czech Republic",
					"name_len": 10,
					"mapcolor7": 1,
					"long_len": 14,
					"mapcolor8": 1,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "203",
					"homepart": 1,
					"subunit": "Czech Republic",
					"name_alt": "",
					"brk_name": "Czech Rep.",
					"name_sort": "Czech Republic",
					"continent": "Europe",
					"mapcolor13": 6,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									14.213671875000017,
									53.87075195312502
								],
								[
									14.172167968750017,
									53.87436523437506
								],
								[
									14.04833984375,
									53.863085937500074
								],
								[
									13.92578125,
									53.87905273437494
								],
								[
									13.902148437500074,
									53.93896484374997
								],
								[
									13.921679687500045,
									53.9966308593751
								],
								[
									13.872460937500051,
									54.036279296874994
								],
								[
									13.827148437499972,
									54.05957031249994
								],
								[
									13.820410156250034,
									54.092822265625045
								],
								[
									13.827734375000006,
									54.12724609374996
								],
								[
									14.038867187500045,
									54.03457031250008
								],
								[
									14.211425781250028,
									53.95034179687508
								],
								[
									14.1982421875,
									53.919042968750006
								],
								[
									14.213671875000017,
									53.87075195312502
								]
							]
						],
						[
							[
								[
									11.282812500000063,
									54.41796875000003
								],
								[
									11.129296875000051,
									54.416015625
								],
								[
									11.070703125000023,
									54.45600585937507
								],
								[
									11.011718749999972,
									54.46616210937509
								],
								[
									11.043457031250057,
									54.515478515625006
								],
								[
									11.084960937499972,
									54.533398437499926
								],
								[
									11.233593750000068,
									54.50126953124996
								],
								[
									11.280273437499972,
									54.43837890624994
								],
								[
									11.282812500000063,
									54.41796875000003
								]
							]
						],
						[
							[
								[
									13.709179687500011,
									54.382714843749966
								],
								[
									13.734179687500045,
									54.31542968750003
								],
								[
									13.707324218750074,
									54.281152343749966
								],
								[
									13.594921875000011,
									54.338183593750045
								],
								[
									13.482031250000006,
									54.33740234374997
								],
								[
									13.414550781250028,
									54.24956054687502
								],
								[
									13.364355468750006,
									54.24584960937497
								],
								[
									13.190039062500034,
									54.32563476562507
								],
								[
									13.162109375000028,
									54.36455078124999
								],
								[
									13.156347656250006,
									54.396923828124926
								],
								[
									13.181250000000006,
									54.508984374999926
								],
								[
									13.176660156250051,
									54.5442382812501
								],
								[
									13.231445312500028,
									54.58276367187503
								],
								[
									13.239941406250068,
									54.638427734375114
								],
								[
									13.336816406249994,
									54.69711914062498
								],
								[
									13.422753906250023,
									54.69931640624998
								],
								[
									13.45009765625008,
									54.64960937499998
								],
								[
									13.491210937500028,
									54.61538085937494
								],
								[
									13.636035156250045,
									54.57700195312512
								],
								[
									13.65761718750008,
									54.55957031250003
								],
								[
									13.670703125000074,
									54.53544921874999
								],
								[
									13.603320312500017,
									54.48818359375005
								],
								[
									13.58046875000008,
									54.46396484375009
								],
								[
									13.601855468749989,
									54.42514648437509
								],
								[
									13.709179687500011,
									54.382714843749966
								]
							]
						],
						[
							[
								[
									8.587890625,
									54.712695312500045
								],
								[
									8.548925781250063,
									54.68818359375001
								],
								[
									8.45380859375004,
									54.69106445312508
								],
								[
									8.400390625,
									54.71411132812497
								],
								[
									8.417675781250068,
									54.73867187500011
								],
								[
									8.468164062500051,
									54.757421875000006
								],
								[
									8.50996093750004,
									54.760302734375074
								],
								[
									8.573437500000011,
									54.748730468749926
								],
								[
									8.587890625,
									54.712695312500045
								]
							]
						],
						[
							[
								[
									9.739746093750028,
									54.825537109375034
								],
								[
									9.745898437500017,
									54.80717773437493
								],
								[
									9.892285156250011,
									54.78061523437512
								],
								[
									9.953808593750011,
									54.738281250000114
								],
								[
									10.022167968750011,
									54.67392578125006
								],
								[
									10.028808593750028,
									54.581298828125085
								],
								[
									9.941308593750051,
									54.514648437500114
								],
								[
									9.86865234375,
									54.472460937500045
								],
								[
									10.143457031250023,
									54.48842773437511
								],
								[
									10.17080078125008,
									54.45019531249994
								],
								[
									10.212402343750028,
									54.40893554687497
								],
								[
									10.360449218750006,
									54.43833007812509
								],
								[
									10.731542968750006,
									54.31625976562509
								],
								[
									10.95595703125008,
									54.375683593749955
								],
								[
									11.013378906250068,
									54.37915039062494
								],
								[
									11.064355468750051,
									54.280517578125114
								],
								[
									11.008593750000045,
									54.18115234375003
								],
								[
									10.810742187500068,
									54.07514648437501
								],
								[
									10.854589843750034,
									54.00981445312493
								],
								[
									10.917773437500017,
									53.9953125000001
								],
								[
									11.104296875000017,
									54.00917968750008
								],
								[
									11.39960937500004,
									53.944628906250074
								],
								[
									11.461132812500068,
									53.96474609375008
								],
								[
									11.70058593750008,
									54.113525390625114
								],
								[
									11.796289062500051,
									54.14545898437504
								],
								[
									12.111328125,
									54.16831054687498
								],
								[
									12.16865234375004,
									54.22587890624999
								],
								[
									12.296289062500023,
									54.28378906250006
								],
								[
									12.378515625000006,
									54.34702148437498
								],
								[
									12.57539062500004,
									54.46738281249998
								],
								[
									12.779101562500074,
									54.44570312500011
								],
								[
									12.898046875000063,
									54.42265624999993
								],
								[
									13.028613281250017,
									54.41103515625005
								],
								[
									13.147460937500057,
									54.282714843750114
								],
								[
									13.448046875000017,
									54.140869140625085
								],
								[
									13.724218750000063,
									54.15322265625002
								],
								[
									13.822265625000057,
									54.01904296874994
								],
								[
									13.865527343750074,
									53.85336914062495
								],
								[
									13.95039062500004,
									53.801367187500006
								],
								[
									14.025000000000063,
									53.76743164062512
								],
								[
									14.250000000000057,
									53.73188476562507
								],
								[
									14.258886718750006,
									53.729638671874966
								],
								[
									14.266113281250057,
									53.70712890625009
								],
								[
									14.279882812500006,
									53.624755859375
								],
								[
									14.298730468750051,
									53.55644531250002
								],
								[
									14.41455078125,
									53.28349609375002
								],
								[
									14.412304687499983,
									53.21674804687501
								],
								[
									14.410937500000074,
									53.199023437500045
								],
								[
									14.368554687500051,
									53.105566406250006
								],
								[
									14.293164062500068,
									53.02675781250002
								],
								[
									14.193652343750045,
									52.98232421875005
								],
								[
									14.138867187500068,
									52.932861328125
								],
								[
									14.128613281250011,
									52.878222656250045
								],
								[
									14.253710937500017,
									52.78251953125002
								],
								[
									14.514062500000023,
									52.645605468750006
								],
								[
									14.619433593750017,
									52.52851562500004
								],
								[
									14.569726562499994,
									52.43110351562501
								],
								[
									14.554589843750023,
									52.35966796875002
								],
								[
									14.573925781250068,
									52.31416015624998
								],
								[
									14.615625000000023,
									52.2776367187501
								],
								[
									14.679882812500068,
									52.24999999999997
								],
								[
									14.705371093750017,
									52.20747070312501
								],
								[
									14.692382812500028,
									52.15004882812502
								],
								[
									14.704589843750028,
									52.11020507812509
								],
								[
									14.752539062500034,
									52.08183593749999
								],
								[
									14.748144531250034,
									52.07080078125006
								],
								[
									14.724804687500068,
									52.03085937500009
								],
								[
									14.692968750000063,
									51.958007812500085
								],
								[
									14.674902343750034,
									51.90483398437499
								],
								[
									14.601660156250034,
									51.83237304687498
								],
								[
									14.623925781250023,
									51.770800781250045
								],
								[
									14.681347656250011,
									51.6981933593751
								],
								[
									14.724902343749989,
									51.66171875000012
								],
								[
									14.738671875000051,
									51.6271484375001
								],
								[
									14.7109375,
									51.54492187500003
								],
								[
									14.724707031250034,
									51.52387695312501
								],
								[
									14.905957031250011,
									51.46333007812501
								],
								[
									14.935546875,
									51.4353515625001
								],
								[
									14.953125000000028,
									51.37714843750004
								],
								[
									15.0166015625,
									51.25273437500002
								],
								[
									14.9638671875,
									51.095117187499966
								],
								[
									14.917480468750057,
									51.00874023437504
								],
								[
									14.814257812500074,
									50.8716308593751
								],
								[
									14.809375000000074,
									50.858984375000006
								],
								[
									14.797460937500034,
									50.842333984375074
								],
								[
									14.766503906250023,
									50.81831054687507
								],
								[
									14.72333984375004,
									50.81469726562503
								],
								[
									14.658203125,
									50.832617187500034
								],
								[
									14.613574218750045,
									50.85556640625009
								],
								[
									14.623828125000017,
									50.91474609375007
								],
								[
									14.595214843750057,
									50.91860351562508
								],
								[
									14.559667968750006,
									50.954931640625006
								],
								[
									14.545703125000074,
									50.99394531249996
								],
								[
									14.50732421875,
									51.009863281250006
								],
								[
									14.367285156250063,
									51.02626953125005
								],
								[
									14.319726562500051,
									51.03779296875001
								],
								[
									14.283203124999972,
									51.02949218750001
								],
								[
									14.255859375,
									51.00185546875005
								],
								[
									14.273339843750023,
									50.976904296875034
								],
								[
									14.299414062500006,
									50.95258789062507
								],
								[
									14.377050781250006,
									50.91406250000003
								],
								[
									14.369042968750051,
									50.89873046875002
								],
								[
									14.201757812500006,
									50.86123046875011
								],
								[
									14.096484375000045,
									50.822753906250085
								],
								[
									13.998437500000051,
									50.80112304687512
								],
								[
									13.898535156250034,
									50.76127929687499
								],
								[
									13.701367187500011,
									50.71650390625001
								],
								[
									13.556738281250034,
									50.704638671875074
								],
								[
									13.526562500000011,
									50.69282226562498
								],
								[
									13.472558593750023,
									50.616943359375085
								],
								[
									13.436132812499977,
									50.60107421875003
								],
								[
									13.401171875000045,
									50.60932617187504
								],
								[
									13.374609375000063,
									50.62172851562508
								],
								[
									13.341015625000068,
									50.61142578125009
								],
								[
									13.306054687500051,
									50.586328124999966
								],
								[
									13.269531250000057,
									50.576416015625085
								],
								[
									13.237695312500051,
									50.57675781250006
								],
								[
									13.18115234375,
									50.51049804687497
								],
								[
									13.016406250000017,
									50.49038085937505
								],
								[
									12.997070312500057,
									50.45605468750006
								],
								[
									12.966796875000028,
									50.41621093750004
								],
								[
									12.942675781249989,
									50.4064453125001
								],
								[
									12.868261718750034,
									50.42221679687509
								],
								[
									12.765429687500045,
									50.43095703125002
								],
								[
									12.706445312500023,
									50.40913085937501
								],
								[
									12.635546875000045,
									50.397070312500034
								],
								[
									12.549023437500011,
									50.393408203125006
								],
								[
									12.45263671875,
									50.34980468750001
								],
								[
									12.358593750000011,
									50.273242187500045
								],
								[
									12.305664062499972,
									50.20571289062505
								],
								[
									12.27734375,
									50.18144531249999
								],
								[
									12.231152343749983,
									50.24487304687503
								],
								[
									12.174804687500057,
									50.28837890625002
								],
								[
									12.134863281250006,
									50.310937499999994
								],
								[
									12.099218750000034,
									50.3109863281251
								],
								[
									12.089843749999972,
									50.301757812500085
								],
								[
									12.089746093750051,
									50.26855468749997
								],
								[
									12.12783203125008,
									50.21342773437502
								],
								[
									12.175000000000011,
									50.1758300781251
								],
								[
									12.182519531250023,
									50.14804687500012
								],
								[
									12.207812500000045,
									50.097509765625034
								],
								[
									12.276464843749977,
									50.04233398437498
								],
								[
									12.38417968750008,
									49.998583984375045
								],
								[
									12.457617187500034,
									49.95551757812507
								],
								[
									12.512011718750017,
									49.895800781250074
								],
								[
									12.512500000000017,
									49.87744140625006
								],
								[
									12.49755859375,
									49.853076171875074
								],
								[
									12.471875000000011,
									49.830078125000085
								],
								[
									12.450195312500028,
									49.80014648437512
								],
								[
									12.390527343750051,
									49.73964843750005
								],
								[
									12.408203125,
									49.713183593750074
								],
								[
									12.45703125,
									49.67978515625012
								],
								[
									12.500292968750017,
									49.63969726562502
								],
								[
									12.555761718750034,
									49.57485351562505
								],
								[
									12.63203125000004,
									49.46123046874999
								],
								[
									12.68115234375,
									49.41450195312507
								],
								[
									12.747851562500017,
									49.366210937500085
								],
								[
									12.813378906250023,
									49.32934570312503
								],
								[
									12.91669921875004,
									49.330468749999994
								],
								[
									13.023730468750074,
									49.26010742187506
								],
								[
									13.14052734375008,
									49.15834960937511
								],
								[
									13.227832031250017,
									49.111669921875006
								],
								[
									13.288769531250068,
									49.097460937500045
								],
								[
									13.339062500000011,
									49.06079101562503
								],
								[
									13.383691406250051,
									49.00810546874996
								],
								[
									13.401171875000045,
									48.97758789062496
								],
								[
									13.440722656250045,
									48.95556640625
								],
								[
									13.547656250000045,
									48.95966796875004
								],
								[
									13.684960937500051,
									48.876708984375114
								],
								[
									13.769921875000051,
									48.815966796875074
								],
								[
									13.814746093750017,
									48.766943359375034
								],
								[
									13.802929687500011,
									48.74750976562498
								],
								[
									13.797460937500063,
									48.686425781249966
								],
								[
									13.798828124999972,
									48.62167968750009
								],
								[
									13.785351562500068,
									48.587451171875045
								],
								[
									13.723925781249989,
									48.54238281250002
								],
								[
									13.692187500000017,
									48.53276367187502
								],
								[
									13.675195312500023,
									48.52304687500009
								],
								[
									13.486621093750045,
									48.581835937500074
								],
								[
									13.471679687500028,
									48.571826171875074
								],
								[
									13.459863281250023,
									48.564550781250006
								],
								[
									13.40937500000004,
									48.39414062500012
								],
								[
									13.374609375000063,
									48.3613769531251
								],
								[
									13.322851562500006,
									48.3312500000001
								],
								[
									13.215234375000023,
									48.301904296874966
								],
								[
									13.140429687500045,
									48.28994140625002
								],
								[
									13.082128906249977,
									48.27509765625001
								],
								[
									12.897460937500028,
									48.203710937500034
								],
								[
									12.814257812500045,
									48.16083984375001
								],
								[
									12.760351562500063,
									48.10698242187496
								],
								[
									12.760058593750017,
									48.075976562500045
								],
								[
									12.849902343750017,
									47.98481445312504
								],
								[
									12.95351562500008,
									47.89062500000003
								],
								[
									12.954199218750034,
									47.80776367187502
								],
								[
									12.908300781250006,
									47.74580078125001
								],
								[
									12.897656250000068,
									47.72187500000001
								],
								[
									12.928125000000051,
									47.71284179687504
								],
								[
									12.98554687500004,
									47.70942382812507
								],
								[
									13.033593750000051,
									47.698730468750114
								],
								[
									13.054101562500051,
									47.655126953125006
								],
								[
									13.047949218750034,
									47.57915039062499
								],
								[
									13.031542968750074,
									47.50800781250007
								],
								[
									13.01435546875004,
									47.4780761718751
								],
								[
									12.968066406250017,
									47.475683593750034
								],
								[
									12.878906250000057,
									47.506445312500006
								],
								[
									12.809375000000017,
									47.54218750000001
								],
								[
									12.782812500000034,
									47.56416015625004
								],
								[
									12.781152343750051,
									47.59042968749998
								],
								[
									12.796191406249989,
									47.60703124999998
								],
								[
									12.771386718749994,
									47.639404296875
								],
								[
									12.685839843750074,
									47.66933593750005
								],
								[
									12.594238281250057,
									47.656298828125074
								],
								[
									12.52656250000004,
									47.63613281250005
								],
								[
									12.482910156250028,
									47.63730468750012
								],
								[
									12.435742187500011,
									47.666113281250034
								],
								[
									12.36318359375008,
									47.6881835937501
								],
								[
									12.268359375000017,
									47.702734375000034
								],
								[
									12.209277343750074,
									47.718261718750085
								],
								[
									12.196875000000034,
									47.70908203125009
								],
								[
									12.203808593750011,
									47.646728515625085
								],
								[
									12.185644531250034,
									47.61953125000005
								],
								[
									11.716796875,
									47.583496093750085
								],
								[
									11.57392578125004,
									47.54975585937504
								],
								[
									11.469921875000068,
									47.50610351562503
								],
								[
									11.392968750000023,
									47.48715820312506
								],
								[
									11.374121093750006,
									47.46025390625002
								],
								[
									11.297949218750034,
									47.424902343750006
								],
								[
									11.2119140625,
									47.41362304687502
								],
								[
									11.191210937500045,
									47.42519531250005
								],
								[
									11.136035156249989,
									47.40888671875004
								],
								[
									11.041992187500028,
									47.39311523437502
								],
								[
									10.980859374999994,
									47.39814453125007
								],
								[
									10.952148437500028,
									47.42670898437501
								],
								[
									10.893945312500051,
									47.47045898437506
								],
								[
									10.87060546875,
									47.5007812500001
								],
								[
									10.873046875000057,
									47.52021484375007
								],
								[
									10.741601562500023,
									47.52412109375007
								],
								[
									10.65869140625,
									47.54721679687506
								],
								[
									10.482812500000051,
									47.54179687500002
								],
								[
									10.439453125000028,
									47.55156249999996
								],
								[
									10.43037109375004,
									47.541064453125045
								],
								[
									10.403906250000063,
									47.416992187500085
								],
								[
									10.369140625,
									47.366064453125006
								],
								[
									10.312792968750045,
									47.31342773437504
								],
								[
									10.240625000000023,
									47.28413085937501
								],
								[
									10.18300781250008,
									47.278808593750085
								],
								[
									10.185742187500011,
									47.317187500000074
								],
								[
									10.200292968750063,
									47.36342773437508
								],
								[
									10.158789062500034,
									47.374267578125085
								],
								[
									10.096484375000045,
									47.37958984375001
								],
								[
									10.066308593750023,
									47.393359375000074
								],
								[
									10.074218750000028,
									47.42851562500002
								],
								[
									10.059863281250045,
									47.449072265625034
								],
								[
									10.034082031250023,
									47.47358398437507
								],
								[
									9.97158203125008,
									47.50532226562504
								],
								[
									9.839160156250017,
									47.55229492187502
								],
								[
									9.748925781250023,
									47.57553710937506
								],
								[
									9.715136718750074,
									47.55078125000006
								],
								[
									9.695204109211062,
									47.54309166538212
								],
								[
									9.644238281250011,
									47.56635742187504
								],
								[
									9.513964843750017,
									47.62475585937503
								],
								[
									9.372851562500045,
									47.67666015625005
								],
								[
									9.230761718750074,
									47.73330078125005
								],
								[
									9.132031250000011,
									47.78217773437504
								],
								[
									9.113183593749994,
									47.77211914062505
								],
								[
									9.182812500000068,
									47.67070312499999
								],
								[
									9.127539062500006,
									47.67070312499999
								],
								[
									8.881152343750074,
									47.65639648437508
								],
								[
									8.874023437500028,
									47.662695312500034
								],
								[
									8.831152343750006,
									47.70361328125003
								],
								[
									8.793066406250063,
									47.716552734375
								],
								[
									8.770117187500006,
									47.70991210937498
								],
								[
									8.75478515625008,
									47.69804687499996
								],
								[
									8.728320312500017,
									47.70004882812509
								],
								[
									8.617871093749983,
									47.76611328124997
								],
								[
									8.572656250000023,
									47.77563476562506
								],
								[
									8.509863281250006,
									47.766894531250045
								],
								[
									8.435742187500011,
									47.731347656249994
								],
								[
									8.403417968750006,
									47.6877929687501
								],
								[
									8.413281250000068,
									47.662695312500034
								],
								[
									8.451757812499977,
									47.65180664062504
								],
								[
									8.552343750000063,
									47.65913085937504
								],
								[
									8.56708984375004,
									47.651904296875074
								],
								[
									8.570507812500011,
									47.637792968750034
								],
								[
									8.55947265625008,
									47.62402343750006
								],
								[
									8.477636718750034,
									47.61269531250008
								],
								[
									8.454003906249994,
									47.596191406250085
								],
								[
									8.430078125000023,
									47.59213867187506
								],
								[
									8.414746093750011,
									47.589599609375085
								],
								[
									8.327832031250068,
									47.60693359375006
								],
								[
									8.198242187500028,
									47.60693359375006
								],
								[
									8.093750000000057,
									47.576171875
								],
								[
									7.927050781250017,
									47.56386718750008
								],
								[
									7.698046875000017,
									47.56987304687496
								],
								[
									7.615624999999994,
									47.5927246093751
								],
								[
									7.5654296875,
									47.60654296875006
								],
								[
									7.529394531250006,
									47.67387695312502
								],
								[
									7.538574218750028,
									47.7736328125001
								],
								[
									7.593261718750057,
									47.90566406250008
								],
								[
									7.6084960937500625,
									48.00258789062511
								],
								[
									7.584179687499983,
									48.06430664062506
								],
								[
									7.616601562500023,
									48.156787109375074
								],
								[
									7.705664062500034,
									48.28002929687506
								],
								[
									7.76513671875,
									48.41000976562506
								],
								[
									7.794824218749994,
									48.546826171874955
								],
								[
									7.837988281250006,
									48.6360351562501
								],
								[
									7.922753906250051,
									48.698535156250045
								],
								[
									8.1240234375,
									48.87329101562503
								],
								[
									8.14033203125004,
									48.88642578125004
								],
								[
									8.134863281250006,
									48.97358398437504
								],
								[
									8.080664062500063,
									48.98588867187496
								],
								[
									8.001269531250045,
									49.0109375000001
								],
								[
									7.799218750000023,
									49.04189453125008
								],
								[
									7.610937500000034,
									49.06176757812506
								],
								[
									7.525488281250034,
									49.08637695312501
								],
								[
									7.450585937500051,
									49.152197265625006
								],
								[
									7.404199218749994,
									49.153076171875
								],
								[
									7.313378906250051,
									49.12954101562511
								],
								[
									7.19990234375004,
									49.11362304687506
								],
								[
									7.117382812500011,
									49.12753906249995
								],
								[
									7.0657226562500455,
									49.124853515625034
								],
								[
									7.036718750000006,
									49.11269531250005
								],
								[
									7.022167968750068,
									49.12343750000011
								],
								[
									7.001464843750028,
									49.179882812499955
								],
								[
									6.958300781250017,
									49.194628906250045
								],
								[
									6.891210937500034,
									49.207519531250085
								],
								[
									6.849511718750051,
									49.20195312500002
								],
								[
									6.820703125000051,
									49.17392578125009
								],
								[
									6.776269531250051,
									49.154150390625034
								],
								[
									6.735449218750006,
									49.16059570312504
								],
								[
									6.607617187499983,
									49.290869140625006
								],
								[
									6.574707031250028,
									49.31967773437512
								],
								[
									6.566308593750023,
									49.34619140625
								],
								[
									6.5342773437500625,
									49.39467773437502
								],
								[
									6.458105468750006,
									49.44287109375006
								],
								[
									6.38222656250008,
									49.45815429687508
								],
								[
									6.344335937500006,
									49.45273437499995
								],
								[
									6.3484375000000455,
									49.512695312500085
								],
								[
									6.37832031250008,
									49.59960937500003
								],
								[
									6.40673828125,
									49.64497070312504
								],
								[
									6.444628906249989,
									49.68203125000002
								],
								[
									6.484765624999994,
									49.707812500000045
								],
								[
									6.4937500000000625,
									49.75439453125003
								],
								[
									6.4873046875,
									49.79848632812505
								],
								[
									6.440917968750057,
									49.80532226562511
								],
								[
									6.324609375000051,
									49.837890625000085
								],
								[
									6.25605468750004,
									49.872167968750034
								],
								[
									6.204882812500017,
									49.915136718750006
								],
								[
									6.13818359375,
									49.97431640624998
								],
								[
									6.10976562500008,
									50.03437500000004
								],
								[
									6.108300781250051,
									50.094238281250085
								],
								[
									6.1165039062500455,
									50.12099609375002
								],
								[
									6.12128906250004,
									50.13935546875004
								],
								[
									6.175097656250074,
									50.23266601562494
								],
								[
									6.364453125000011,
									50.316162109375085
								],
								[
									6.343652343750023,
									50.40024414062498
								],
								[
									6.340917968750006,
									50.45175781250009
								],
								[
									6.294921875000057,
									50.48549804687494
								],
								[
									6.20302734375008,
									50.49912109375006
								],
								[
									6.1787109375,
									50.52250976562493
								],
								[
									6.168457031250057,
									50.54536132812507
								],
								[
									6.235937500000034,
									50.59667968749994
								],
								[
									6.15449218750004,
									50.637255859375045
								],
								[
									6.119433593750017,
									50.679248046875074
								],
								[
									6.005957031249977,
									50.73222656249993
								],
								[
									5.993945312500017,
									50.7504394531251
								],
								[
									6.048437500000034,
									50.90488281250012
								],
								[
									6.006835937499972,
									50.94995117187497
								],
								[
									5.955078125,
									50.972949218750045
								],
								[
									5.894726562500068,
									50.98422851562512
								],
								[
									5.867187500000057,
									51.005664062500045
								],
								[
									5.857519531250034,
									51.03012695312506
								],
								[
									5.868359375000011,
									51.04531250000002
								],
								[
									5.939257812500074,
									51.0408203125001
								],
								[
									5.9610351562500625,
									51.056689453125045
								],
								[
									6.129980468750034,
									51.14741210937504
								],
								[
									6.136914062500011,
									51.16484374999996
								],
								[
									6.113378906250006,
									51.17470703125002
								],
								[
									6.082421875000023,
									51.17998046874993
								],
								[
									6.0748046875000625,
									51.199023437500074
								],
								[
									6.075878906250011,
									51.22412109375006
								],
								[
									6.16621093750004,
									51.354833984375034
								],
								[
									6.192871093750057,
									51.41059570312501
								],
								[
									6.198828125000006,
									51.450000000000045
								],
								[
									6.193261718750051,
									51.488916015624994
								],
								[
									6.1416015625,
									51.55009765624993
								],
								[
									6.091113281250017,
									51.59892578124993
								],
								[
									6.08935546875,
									51.63779296874995
								],
								[
									6.052734375,
									51.65825195312502
								],
								[
									5.948535156250017,
									51.762402343749926
								],
								[
									5.948730468750057,
									51.80268554687507
								],
								[
									6.0076171875000455,
									51.83398437499994
								],
								[
									6.089843750000028,
									51.853955078124926
								],
								[
									6.1171875,
									51.870410156250074
								],
								[
									6.16650390625,
									51.88076171875005
								],
								[
									6.29707031250004,
									51.85073242187508
								],
								[
									6.355664062499983,
									51.8246582031251
								],
								[
									6.372167968749977,
									51.83002929687504
								],
								[
									6.425000000000011,
									51.85839843749994
								],
								[
									6.517578125000028,
									51.853955078124926
								],
								[
									6.7417968750000625,
									51.910888671875085
								],
								[
									6.775195312500017,
									51.938281250000045
								],
								[
									6.800390625000006,
									51.96738281249995
								],
								[
									6.802441406250068,
									51.98017578125007
								],
								[
									6.7156250000000455,
									52.03618164062493
								],
								[
									6.7129882812500625,
									52.05688476562497
								],
								[
									6.724511718749994,
									52.08022460937502
								],
								[
									6.749023437500028,
									52.09868164062496
								],
								[
									6.800390625000006,
									52.11123046874994
								],
								[
									6.855078125000034,
									52.135791015625074
								],
								[
									6.977246093750068,
									52.20551757812507
								],
								[
									7.019628906250006,
									52.26601562500002
								],
								[
									7.032617187500051,
									52.33149414062504
								],
								[
									7.035156250000057,
									52.380224609375034
								],
								[
									7.001855468750023,
									52.41899414062493
								],
								[
									6.96816406250008,
									52.444091796875085
								],
								[
									6.922070312500011,
									52.440283203125006
								],
								[
									6.832519531249972,
									52.44228515625005
								],
								[
									6.748828125000074,
									52.46401367187505
								],
								[
									6.7029296875000455,
									52.49921875000004
								],
								[
									6.69160156250004,
									52.53017578124994
								],
								[
									6.712402343750028,
									52.54965820312509
								],
								[
									6.718749999999972,
									52.57358398437509
								],
								[
									6.705371093750017,
									52.597656250000085
								],
								[
									6.7107421875000455,
									52.617871093749955
								],
								[
									6.74843750000008,
									52.634082031250045
								],
								[
									7.01318359375,
									52.63354492187494
								],
								[
									7.0330078125000455,
									52.65136718750003
								],
								[
									7.0508789062500625,
									52.74477539062505
								],
								[
									7.117089843750051,
									52.887011718750074
								],
								[
									7.1794921875000455,
									52.96621093750005
								],
								[
									7.189941406250057,
									52.999511718750085
								],
								[
									7.188964843750028,
									53.18720703125004
								],
								[
									7.197265625000028,
									53.282275390625045
								],
								[
									7.152050781250068,
									53.32695312499999
								],
								[
									7.053320312500006,
									53.375830078125006
								],
								[
									7.074316406250034,
									53.47763671875006
								],
								[
									7.107128906250068,
									53.55698242187506
								],
								[
									7.206445312500051,
									53.65454101562494
								],
								[
									7.285253906250006,
									53.68134765624998
								],
								[
									7.629199218750017,
									53.69726562499994
								],
								[
									8.00927734375,
									53.69072265625002
								],
								[
									8.167089843750006,
									53.54340820312504
								],
								[
									8.108496093750034,
									53.46767578125005
								],
								[
									8.200781250000006,
									53.43242187499999
								],
								[
									8.245214843750006,
									53.44531249999994
								],
								[
									8.279003906250068,
									53.511181640624955
								],
								[
									8.301562500000045,
									53.58413085937508
								],
								[
									8.333886718750051,
									53.60620117187503
								],
								[
									8.451367187500011,
									53.551708984374955
								],
								[
									8.492675781249972,
									53.51435546874998
								],
								[
									8.495214843750063,
									53.39423828125001
								],
								[
									8.53847656250008,
									53.55688476562494
								],
								[
									8.50625000000008,
									53.670751953125034
								],
								[
									8.528417968750063,
									53.78110351562506
								],
								[
									8.57558593750008,
									53.83847656250012
								],
								[
									8.618945312500045,
									53.875
								],
								[
									8.897753906250074,
									53.835693359375085
								],
								[
									9.20556640625,
									53.85595703124994
								],
								[
									9.321972656249983,
									53.813476562500085
								],
								[
									9.585351562499994,
									53.60048828124994
								],
								[
									9.673144531250045,
									53.56562500000004
								],
								[
									9.783984375000074,
									53.554638671874926
								],
								[
									9.631250000000023,
									53.60019531250006
								],
								[
									9.31201171875,
									53.85913085937506
								],
								[
									9.216406249999977,
									53.89121093750012
								],
								[
									9.069628906250017,
									53.900927734375045
								],
								[
									8.978125000000034,
									53.926220703124955
								],
								[
									8.92041015625,
									53.965332031250114
								],
								[
									8.903515625000011,
									54.000292968750045
								],
								[
									8.906640625000023,
									54.26079101562499
								],
								[
									8.8515625,
									54.299560546875085
								],
								[
									8.780371093750063,
									54.313037109375074
								],
								[
									8.736035156249983,
									54.29521484374999
								],
								[
									8.64492187500008,
									54.29497070312502
								],
								[
									8.625781250000017,
									54.35395507812507
								],
								[
									8.648046875000006,
									54.39765624999998
								],
								[
									8.831152343750006,
									54.427539062500045
								],
								[
									8.951855468750011,
									54.46757812499993
								],
								[
									8.95722656250004,
									54.53833007812506
								],
								[
									8.880957031250034,
									54.59394531250001
								],
								[
									8.789648437500006,
									54.69594726562511
								],
								[
									8.682324218750068,
									54.791845703125006
								],
								[
									8.670312500000023,
									54.90341796875009
								],
								[
									8.670703125000017,
									54.90332031249997
								],
								[
									8.857226562499989,
									54.90112304687497
								],
								[
									8.902929687500063,
									54.89692382812501
								],
								[
									9.185839843750074,
									54.844677734374926
								],
								[
									9.254980468750034,
									54.80800781250011
								],
								[
									9.341992187499983,
									54.80629882812502
								],
								[
									9.49873046875004,
									54.84042968749995
								],
								[
									9.615820312500006,
									54.85541992187498
								],
								[
									9.661230468750006,
									54.834374999999966
								],
								[
									9.725000000000023,
									54.825537109375034
								],
								[
									9.739746093750028,
									54.825537109375034
								]
							]
						],
						[
							[
								[
									8.307714843750034,
									54.78696289062506
								],
								[
									8.284667968750057,
									54.76708984375003
								],
								[
									8.295703124999989,
									54.90830078125009
								],
								[
									8.405175781249994,
									55.05874023437502
								],
								[
									8.451464843750017,
									55.055371093749955
								],
								[
									8.404101562500045,
									55.014746093750034
								],
								[
									8.390429687500017,
									54.9862792968751
								],
								[
									8.371191406250006,
									54.929394531249955
								],
								[
									8.3798828125,
									54.89985351562498
								],
								[
									8.629589843750068,
									54.89174804687502
								],
								[
									8.600585937500028,
									54.86538085937505
								],
								[
									8.34736328125004,
									54.8476074218751
								],
								[
									8.307714843750034,
									54.78696289062506
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "DEU",
					"su_a3": "DEU",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "DEU",
					"gu_a3": "DEU",
					"abbrev": "Ger.",
					"region_un": "Europe",
					"adm0_a3_us": "DEU",
					"scalerank": 1,
					"pop_est": 82329758,
					"adm0_dif": 0,
					"un_a3": "276",
					"pop_year": -99,
					"gdp_md_est": 2918000,
					"name": "Germany",
					"sovereignt": "Germany",
					"economy": "1. Developed region: G7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Germany",
					"postal": "D",
					"sov_a3": "DEU",
					"note_brk": "",
					"brk_a3": "DEU",
					"wb_a2": "DE",
					"brk_diff": 0,
					"admin": "Germany",
					"name_long": "Germany",
					"iso_a3": "DEU",
					"iso_a2": "DE",
					"adm0_a3_is": "DEU",
					"level": 2,
					"formal_en": "Federal Republic of Germany",
					"name_len": 7,
					"mapcolor7": 2,
					"long_len": 7,
					"mapcolor8": 5,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "276",
					"homepart": 1,
					"subunit": "Germany",
					"name_alt": "",
					"brk_name": "Germany",
					"name_sort": "Germany",
					"continent": "Europe",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									11.361425781250006,
									54.891650390625074
								],
								[
									11.538378906250074,
									54.82958984375006
								],
								[
									11.658105468750051,
									54.83315429687508
								],
								[
									11.739550781250017,
									54.807421875000074
								],
								[
									11.758984374999983,
									54.76767578125006
								],
								[
									11.765917968750074,
									54.679443359375114
								],
								[
									11.68037109375004,
									54.65371093750002
								],
								[
									11.5859375,
									54.66245117187512
								],
								[
									11.457421875000023,
									54.628857421874926
								],
								[
									11.035546875000051,
									54.77309570312508
								],
								[
									11.04169921875004,
									54.89335937499999
								],
								[
									11.058593750000028,
									54.94057617187502
								],
								[
									11.258496093749983,
									54.951806640624994
								],
								[
									11.361425781250006,
									54.891650390625074
								]
							]
						],
						[
							[
								[
									10.484375000000028,
									54.84755859375008
								],
								[
									10.417285156250017,
									54.837158203125
								],
								[
									10.340527343750011,
									54.85893554687499
								],
								[
									10.215625000000074,
									54.9409667968751
								],
								[
									10.199902343750068,
									54.962744140625006
								],
								[
									10.265527343750023,
									54.948828125000006
								],
								[
									10.346972656250017,
									54.90595703124998
								],
								[
									10.413671875000006,
									54.89682617187506
								],
								[
									10.504882812500028,
									54.86054687500007
								],
								[
									10.484375000000028,
									54.84755859375008
								]
							]
						],
						[
							[
								[
									12.549218750000051,
									54.9657714843751
								],
								[
									12.511035156250074,
									54.95087890624998
								],
								[
									12.357519531250063,
									54.961816406249994
								],
								[
									12.18447265625008,
									54.89248046875008
								],
								[
									12.11884765625004,
									54.91440429687509
								],
								[
									12.143652343750006,
									54.95869140625007
								],
								[
									12.161718750000063,
									54.97480468750007
								],
								[
									12.219921875000011,
									54.99360351562498
								],
								[
									12.258789062500028,
									55.02109375000009
								],
								[
									12.274023437500034,
									55.06411132812505
								],
								[
									12.31005859375,
									55.04091796874994
								],
								[
									12.417187500000068,
									55.03120117187501
								],
								[
									12.469531250000074,
									55.017480468749966
								],
								[
									12.513281250000006,
									54.99731445312494
								],
								[
									12.549218750000051,
									54.9657714843751
								]
							]
						],
						[
							[
								[
									10.061230468750068,
									54.88637695312508
								],
								[
									9.957128906249977,
									54.872460937499994
								],
								[
									9.903906250000063,
									54.89663085937502
								],
								[
									9.806250000000063,
									54.906005859375085
								],
								[
									9.77119140625004,
									55.05991210937509
								],
								[
									9.781250000000028,
									55.06904296874998
								],
								[
									9.830371093750017,
									55.05825195312511
								],
								[
									9.998828125000045,
									54.98647460937505
								],
								[
									10.057714843750063,
									54.90791015625001
								],
								[
									10.061230468750068,
									54.88637695312508
								]
							]
						],
						[
							[
								[
									10.734082031250011,
									54.75073242187497
								],
								[
									10.689746093750017,
									54.74506835937507
								],
								[
									10.629492187500006,
									54.82607421875005
								],
								[
									10.621679687500006,
									54.85141601562506
								],
								[
									10.692480468750063,
									54.90327148437507
								],
								[
									10.738281250000057,
									54.962011718750034
								],
								[
									10.856738281250017,
									55.052197265624926
								],
								[
									10.924999999999983,
									55.157861328124966
								],
								[
									10.951074218750051,
									55.15620117187498
								],
								[
									10.920800781250023,
									55.06210937500009
								],
								[
									10.765234375000034,
									54.79965820312509
								],
								[
									10.734082031250011,
									54.75073242187497
								]
							]
						],
						[
							[
								[
									15.087695312500017,
									55.021874999999966
								],
								[
									15.050781250000028,
									55.004931640625074
								],
								[
									14.885546875000045,
									55.032958984375085
								],
								[
									14.684179687500063,
									55.1022460937501
								],
								[
									14.713671875000017,
									55.23803710937506
								],
								[
									14.765332031250068,
									55.296728515625006
								],
								[
									15.132617187500017,
									55.14453125
								],
								[
									15.137109375000051,
									55.08715820312494
								],
								[
									15.087695312500017,
									55.021874999999966
								]
							]
						],
						[
							[
								[
									10.645117187500006,
									55.60981445312501
								],
								[
									10.686816406250045,
									55.55761718750006
								],
								[
									10.738085937500017,
									55.44633789062493
								],
								[
									10.819238281250023,
									55.32187499999998
								],
								[
									10.78535156250004,
									55.26977539062503
								],
								[
									10.808398437500045,
									55.20302734375002
								],
								[
									10.785253906250034,
									55.13339843749995
								],
								[
									10.623828125000017,
									55.05244140624998
								],
								[
									10.44277343750008,
									55.04877929687504
								],
								[
									10.254589843750011,
									55.087890625000085
								],
								[
									9.988769531250028,
									55.16318359374998
								],
								[
									9.967382812500034,
									55.20546875000008
								],
								[
									9.93007812500008,
									55.22890625000005
								],
								[
									9.858984375000063,
									55.35722656249999
								],
								[
									9.860644531250045,
									55.51547851562509
								],
								[
									9.994238281250006,
									55.53530273437494
								],
								[
									10.286132812500057,
									55.61083984375006
								],
								[
									10.353613281250034,
									55.59897460937495
								],
								[
									10.424023437500068,
									55.560351562500074
								],
								[
									10.505078125000068,
									55.558056640624955
								],
								[
									10.622753906250068,
									55.61284179687493
								],
								[
									10.645117187500006,
									55.60981445312501
								]
							]
						],
						[
							[
								[
									12.665722656250068,
									55.59653320312498
								],
								[
									12.571582031250074,
									55.55400390624993
								],
								[
									12.550878906250034,
									55.55624999999995
								],
								[
									12.520312500000017,
									55.61459960937512
								],
								[
									12.569921875000006,
									55.65009765625007
								],
								[
									12.599218750000006,
									55.680224609375074
								],
								[
									12.62001953125008,
									55.67934570312508
								],
								[
									12.6484375,
									55.6467773437501
								],
								[
									12.665722656250068,
									55.59653320312498
								]
							]
						],
						[
							[
								[
									10.607324218750023,
									55.78305664062506
								],
								[
									10.590332031250028,
									55.76508789062504
								],
								[
									10.526953124999977,
									55.783789062500034
								],
								[
									10.520312500000045,
									55.84848632812498
								],
								[
									10.54433593750008,
									55.90659179687509
								],
								[
									10.51611328125,
									55.95854492187502
								],
								[
									10.547167968750017,
									55.99194335937506
								],
								[
									10.636328125000063,
									55.914160156250034
								],
								[
									10.661718750000006,
									55.87758789062505
								],
								[
									10.627343750000023,
									55.83388671875002
								],
								[
									10.607324218750023,
									55.78305664062506
								]
							]
						],
						[
							[
								[
									12.568750000000023,
									55.78505859375002
								],
								[
									12.57119140625008,
									55.684960937499966
								],
								[
									12.545214843750017,
									55.655810546875074
								],
								[
									12.507031250000068,
									55.63662109375008
								],
								[
									12.407128906250051,
									55.6162597656251
								],
								[
									12.320605468750017,
									55.58784179687498
								],
								[
									12.243457031250017,
									55.53789062499993
								],
								[
									12.215039062499983,
									55.466503906249955
								],
								[
									12.275390625000028,
									55.41425781250007
								],
								[
									12.385156250000023,
									55.38564453125011
								],
								[
									12.413085937500028,
									55.28618164062499
								],
								[
									12.32246093750004,
									55.237109375000045
								],
								[
									12.089941406250006,
									55.18813476562508
								],
								[
									12.065527343750006,
									55.06992187500009
								],
								[
									12.073046875000017,
									54.976757812499926
								],
								[
									12.068847656250057,
									54.90903320312506
								],
								[
									12.050390625000034,
									54.815332031249994
								],
								[
									11.8623046875,
									54.772607421874994
								],
								[
									11.74091796875004,
									54.91533203124993
								],
								[
									11.739843750000006,
									54.97246093750002
								],
								[
									11.70361328125,
									55.039160156250034
								],
								[
									11.696777343750028,
									55.095996093750074
								],
								[
									11.653808593750057,
									55.18691406250002
								],
								[
									11.475878906250045,
									55.21152343750006
								],
								[
									11.406835937500006,
									55.21474609375011
								],
								[
									11.31025390625004,
									55.197851562500034
								],
								[
									11.286328125000068,
									55.20444335937495
								],
								[
									11.170703125000045,
									55.32861328125003
								],
								[
									11.189746093750017,
									55.46562499999996
								],
								[
									11.128027343750063,
									55.534765625000006
								],
								[
									11.119531250000023,
									55.566064453124994
								],
								[
									11.120996093750051,
									55.60073242187505
								],
								[
									11.070312500000028,
									55.629296874999994
								],
								[
									11.0087890625,
									55.644433593749966
								],
								[
									10.978906250000051,
									55.721533203125034
								],
								[
									11.049609375000074,
									55.74023437499994
								],
								[
									11.224414062500074,
									55.73120117187497
								],
								[
									11.275488281249977,
									55.73647460937508
								],
								[
									11.322265625,
									55.75253906250006
								],
								[
									11.463671875000045,
									55.87929687500002
								],
								[
									11.459570312500006,
									55.90722656250003
								],
								[
									11.474707031249977,
									55.94345703125006
								],
								[
									11.627734375000074,
									55.956884765625034
								],
								[
									11.695898437500006,
									55.9079101562501
								],
								[
									11.682226562499977,
									55.82949218750011
								],
								[
									11.690917968749972,
									55.72900390624997
								],
								[
									11.783593750000023,
									55.701660156250085
								],
								[
									11.819726562500023,
									55.69765625000008
								],
								[
									11.858300781250051,
									55.771874999999994
								],
								[
									11.885351562500063,
									55.80795898437498
								],
								[
									11.922070312499983,
									55.82807617187507
								],
								[
									11.934570312500057,
									55.89589843750005
								],
								[
									11.912792968750068,
									55.937304687500045
								],
								[
									11.866406250000011,
									55.96816406250002
								],
								[
									12.039648437500063,
									56.05214843750008
								],
								[
									12.218945312499983,
									56.11865234374994
								],
								[
									12.3232421875,
									56.122119140625045
								],
								[
									12.42822265625,
									56.10585937500011
								],
								[
									12.525781250000051,
									56.08339843750005
								],
								[
									12.578710937500006,
									56.06406250000012
								],
								[
									12.608398437500028,
									56.033007812500074
								],
								[
									12.54296875,
									55.958984375000114
								],
								[
									12.524804687500051,
									55.918457031250114
								],
								[
									12.568750000000023,
									55.78505859375002
								]
							]
						],
						[
							[
								[
									11.052148437500051,
									57.25253906250012
								],
								[
									11.011425781250011,
									57.229101562500034
								],
								[
									10.873828125000045,
									57.26225585937496
								],
								[
									10.9345703125,
									57.308593750000085
								],
								[
									11.085742187500045,
									57.32993164062498
								],
								[
									11.174511718750011,
									57.322900390624966
								],
								[
									11.076855468750011,
									57.27690429687502
								],
								[
									11.052148437500051,
									57.25253906250012
								]
							]
						],
						[
							[
								[
									9.739746093750028,
									54.825537109375034
								],
								[
									9.725000000000023,
									54.825537109375034
								],
								[
									9.661230468750006,
									54.834374999999966
								],
								[
									9.615820312500006,
									54.85541992187498
								],
								[
									9.49873046875004,
									54.84042968749995
								],
								[
									9.341992187499983,
									54.80629882812502
								],
								[
									9.254980468750034,
									54.80800781250011
								],
								[
									9.185839843750074,
									54.844677734374926
								],
								[
									8.902929687500063,
									54.89692382812501
								],
								[
									8.857226562499989,
									54.90112304687497
								],
								[
									8.670703125000017,
									54.90332031249997
								],
								[
									8.670312500000023,
									54.90341796875009
								],
								[
									8.661425781250074,
									54.98593750000012
								],
								[
									8.638281250000063,
									55.045556640624994
								],
								[
									8.572949218749983,
									55.13427734375006
								],
								[
									8.669824218749994,
									55.15566406250005
								],
								[
									8.651074218750011,
									55.328564453124926
								],
								[
									8.61591796875004,
									55.41821289062506
								],
								[
									8.345312500000063,
									55.5103027343751
								],
								[
									8.132128906250074,
									55.59980468750004
								],
								[
									8.181347656250068,
									55.90117187499996
								],
								[
									8.202343750000068,
									55.98237304687498
								],
								[
									8.121484375000023,
									56.139892578125114
								],
								[
									8.129882812500057,
									56.321191406249994
								],
								[
									8.16396484375008,
									56.60688476562504
								],
								[
									8.231738281250017,
									56.618066406249994
								],
								[
									8.281445312500011,
									56.616699218750085
								],
								[
									8.47314453125,
									56.565429687500114
								],
								[
									8.552929687499983,
									56.56030273437503
								],
								[
									8.60761718750004,
									56.51450195312495
								],
								[
									8.671679687500017,
									56.49565429687502
								],
								[
									8.718066406250074,
									56.54428710937498
								],
								[
									8.736132812500017,
									56.62744140625003
								],
								[
									8.888085937500051,
									56.73505859375004
								],
								[
									8.99453125000008,
									56.77480468750005
								],
								[
									9.06708984375004,
									56.79384765625011
								],
								[
									9.14033203125004,
									56.75043945312504
								],
								[
									9.196386718749977,
									56.70166015624997
								],
								[
									9.20966796875004,
									56.80839843749996
								],
								[
									9.2548828125,
									57.011718750000085
								],
								[
									9.110449218750063,
									57.043652343749926
								],
								[
									8.992773437499977,
									57.01611328125
								],
								[
									8.876074218750006,
									56.887255859375045
								],
								[
									8.771972656250028,
									56.72529296875007
								],
								[
									8.603125000000006,
									56.71040039062507
								],
								[
									8.468359375000006,
									56.66455078125006
								],
								[
									8.3466796875,
									56.71210937500007
								],
								[
									8.268261718750011,
									56.75400390624998
								],
								[
									8.26630859375004,
									56.81533203125005
								],
								[
									8.284082031250023,
									56.85234375000002
								],
								[
									8.427050781250017,
									56.98442382812493
								],
								[
									8.618554687500051,
									57.11127929687501
								],
								[
									8.8115234375,
									57.110058593749955
								],
								[
									8.952246093749977,
									57.15058593750004
								],
								[
									9.036328125000068,
									57.15541992187505
								],
								[
									9.298828125,
									57.14653320312502
								],
								[
									9.43359375,
									57.174316406250085
								],
								[
									9.554296874999977,
									57.23247070312493
								],
								[
									9.815136718750011,
									57.47841796875002
								],
								[
									9.962304687500051,
									57.580957031249966
								],
								[
									10.259082031250045,
									57.617041015625034
								],
								[
									10.533300781250034,
									57.73540039062499
								],
								[
									10.609960937500034,
									57.736914062500034
								],
								[
									10.480957031250028,
									57.648681640625085
								],
								[
									10.460253906250074,
									57.614550781250045
								],
								[
									10.444628906250017,
									57.56220703125004
								],
								[
									10.537109375000028,
									57.44853515624999
								],
								[
									10.517578125000028,
									57.379345703124926
								],
								[
									10.52412109375004,
									57.24321289062499
								],
								[
									10.436914062500023,
									57.17226562500011
								],
								[
									10.338476562500063,
									57.02133789062509
								],
								[
									10.29609375000004,
									56.99912109375009
								],
								[
									10.287011718750051,
									56.82294921875007
								],
								[
									10.296679687500074,
									56.78090820312505
								],
								[
									10.282714843750057,
									56.62050781250005
								],
								[
									10.383593750000017,
									56.554833984374994
								],
								[
									10.490234375000057,
									56.520507812500114
								],
								[
									10.84589843750004,
									56.521728515625
								],
								[
									10.8828125,
									56.49287109374998
								],
								[
									10.926171875000051,
									56.443261718749994
								],
								[
									10.89443359375008,
									56.35903320312508
								],
								[
									10.856445312500057,
									56.295507812500006
								],
								[
									10.753417968750028,
									56.24199218750002
								],
								[
									10.621191406250006,
									56.20209960937498
								],
								[
									10.538964843750051,
									56.20034179687508
								],
								[
									10.42695312500004,
									56.276171875000074
								],
								[
									10.37373046875004,
									56.25156250000012
								],
								[
									10.318750000000023,
									56.21289062500006
								],
								[
									10.226660156250006,
									56.00537109375006
								],
								[
									10.18300781250008,
									55.8651855468751
								],
								[
									10.159375000000068,
									55.85380859374999
								],
								[
									10.107324218750023,
									55.87446289062504
								],
								[
									10.017382812500017,
									55.87607421875009
								],
								[
									9.903710937500023,
									55.842822265625074
								],
								[
									9.962011718750006,
									55.813085937500034
								],
								[
									10.02363281250004,
									55.7614257812501
								],
								[
									9.9990234375,
									55.73554687500007
								],
								[
									9.899023437500063,
									55.707568359375045
								],
								[
									9.810351562500017,
									55.65097656250006
								],
								[
									9.773242187500017,
									55.60815429687503
								],
								[
									9.661425781250045,
									55.55747070312512
								],
								[
									9.591113281250017,
									55.493212890625074
								],
								[
									9.625585937500034,
									55.413574218750114
								],
								[
									9.640234375000006,
									55.34365234375008
								],
								[
									9.670996093750034,
									55.26640624999996
								],
								[
									9.643261718749983,
									55.20473632812511
								],
								[
									9.504785156250023,
									55.11625976562502
								],
								[
									9.453710937500006,
									55.039550781250114
								],
								[
									9.572363281250034,
									55.04052734375003
								],
								[
									9.64541015625008,
									55.02280273437498
								],
								[
									9.688183593749983,
									55.00014648437508
								],
								[
									9.732324218750023,
									54.968017578125114
								],
								[
									9.705273437500011,
									54.928320312500006
								],
								[
									9.739746093750028,
									54.825537109375034
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "DNK",
					"su_a3": "DNK",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "DNK",
					"gu_a3": "DNK",
					"abbrev": "Den.",
					"region_un": "Europe",
					"adm0_a3_us": "DNK",
					"scalerank": 1,
					"pop_est": 5500510,
					"adm0_dif": 1,
					"un_a3": "208",
					"pop_year": -99,
					"gdp_md_est": 203600,
					"name": "Denmark",
					"sovereignt": "Denmark",
					"economy": "2. Developed region: nonG7",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Denmark",
					"postal": "DK",
					"sov_a3": "DN1",
					"note_brk": "",
					"brk_a3": "DNK",
					"wb_a2": "DK",
					"brk_diff": 0,
					"admin": "Denmark",
					"name_long": "Denmark",
					"iso_a3": "DNK",
					"iso_a2": "DK",
					"adm0_a3_is": "DNK",
					"level": 2,
					"formal_en": "Kingdom of Denmark",
					"name_len": 7,
					"mapcolor7": 4,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "208",
					"homepart": 1,
					"subunit": "Denmark",
					"name_alt": "",
					"brk_name": "Denmark",
					"name_sort": "Denmark",
					"continent": "Europe",
					"mapcolor13": 12,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-71.76831054687497,
								18.03916015625012
							],
							[
								-71.76376953124992,
								18.20395507812512
							],
							[
								-71.73725585937495,
								18.27080078124996
							],
							[
								-71.76191406250001,
								18.34130859375003
							],
							[
								-71.87255859374997,
								18.41621093750001
							],
							[
								-71.94038085937495,
								18.512597656250108
							],
							[
								-72.000390625,
								18.597900390625085
							],
							[
								-71.98686523437499,
								18.61035156250003
							],
							[
								-71.86650390624999,
								18.614160156250108
							],
							[
								-71.82421875,
								18.6455078125
							],
							[
								-71.74321289062502,
								18.732910156250057
							],
							[
								-71.72705078125,
								18.803222656250057
							],
							[
								-71.733642578125,
								18.856396484375068
							],
							[
								-71.786376953125,
								18.920019531250063
							],
							[
								-71.80712890624997,
								18.98701171875004
							],
							[
								-71.74204101562495,
								19.045507812500034
							],
							[
								-71.65703124999996,
								19.130761718750108
							],
							[
								-71.64531249999996,
								19.16352539062501
							],
							[
								-71.647216796875,
								19.195947265624966
							],
							[
								-71.74648437499997,
								19.285839843749983
							],
							[
								-71.753173828125,
								19.32446289062503
							],
							[
								-71.70693359375,
								19.421972656250006
							],
							[
								-71.71147460937493,
								19.486572265625114
							],
							[
								-71.75742187499998,
								19.688183593750068
							],
							[
								-71.77924804687498,
								19.71816406250005
							],
							[
								-71.73510742187494,
								19.73510742187503
							],
							[
								-71.7060546875,
								19.795166015625
							],
							[
								-71.66738281250002,
								19.84863281249997
							],
							[
								-71.61596679687503,
								19.87744140624997
							],
							[
								-71.55776367187497,
								19.895361328124977
							],
							[
								-71.44169921874996,
								19.893994140625068
							],
							[
								-71.28134765624998,
								19.847363281249983
							],
							[
								-71.23593749999995,
								19.848144531250057
							],
							[
								-71.08193359375002,
								19.890478515624977
							],
							[
								-70.95415039062502,
								19.91396484375005
							],
							[
								-70.83388671874994,
								19.887255859375017
							],
							[
								-70.78525390624998,
								19.85087890624999
							],
							[
								-70.6859375,
								19.79326171874996
							],
							[
								-70.63618164062498,
								19.77563476562503
							],
							[
								-70.479345703125,
								19.776953125000034
							],
							[
								-70.43642578124997,
								19.77124023437503
							],
							[
								-70.30473632812496,
								19.67607421874999
							],
							[
								-70.19384765625003,
								19.638037109374977
							],
							[
								-70.12944335937496,
								19.636132812500023
							],
							[
								-70.0140625,
								19.672949218749977
							],
							[
								-69.95683593749996,
								19.67187500000003
							],
							[
								-69.8912109375,
								19.589746093749994
							],
							[
								-69.87832031249997,
								19.473291015624966
							],
							[
								-69.82343749999995,
								19.36713867187501
							],
							[
								-69.739404296875,
								19.29921875000005
							],
							[
								-69.32495117187503,
								19.327734374999977
							],
							[
								-69.23247070312502,
								19.271826171874977
							],
							[
								-69.2642578125,
								19.225683593749977
							],
							[
								-69.32275390625,
								19.201074218750023
							],
							[
								-69.51972656249998,
								19.21201171874995
							],
							[
								-69.60595703124997,
								19.206494140624983
							],
							[
								-69.62324218750004,
								19.160498046875034
							],
							[
								-69.62363281249995,
								19.117822265625023
							],
							[
								-69.50834960937499,
								19.10761718750001
							],
							[
								-69.39526367187494,
								19.086083984374966
							],
							[
								-69.28022460937495,
								19.051904296875023
							],
							[
								-69.16303710937498,
								19.02846679687505
							],
							[
								-69.03129882812496,
								19.01318359375003
							],
							[
								-68.90136718749997,
								18.988476562500068
							],
							[
								-68.68476562499998,
								18.90478515624997
							],
							[
								-68.44541015624998,
								18.714453125000006
							],
							[
								-68.38139648437499,
								18.67114257812497
							],
							[
								-68.33916015624999,
								18.61152343750001
							],
							[
								-68.35927734375002,
								18.538085937500057
							],
							[
								-68.44482421874994,
								18.417724609375057
							],
							[
								-68.49321289062493,
								18.379003906249977
							],
							[
								-68.56376953125002,
								18.35546874999997
							],
							[
								-68.61220703124994,
								18.306249999999977
							],
							[
								-68.65883789062502,
								18.222021484374977
							],
							[
								-68.68740234375,
								18.21494140624995
							],
							[
								-68.72099609374999,
								18.218408203125023
							],
							[
								-68.77846679687497,
								18.26611328124997
							],
							[
								-68.81953124999998,
								18.339306640625068
							],
							[
								-68.93496093749997,
								18.408007812500017
							],
							[
								-69.07226562499997,
								18.399218750000017
							],
							[
								-69.27451171874995,
								18.439843750000023
							],
							[
								-69.39697265624994,
								18.42011718750001
							],
							[
								-69.51943359375002,
								18.415673828124994
							],
							[
								-69.64472656249998,
								18.436376953125034
							],
							[
								-69.77065429687497,
								18.443554687499983
							],
							[
								-69.89638671875,
								18.417724609375057
							],
							[
								-70.01831054687497,
								18.37363281249995
							],
							[
								-70.06333007812498,
								18.34565429687501
							],
							[
								-70.14160156249994,
								18.277099609375
							],
							[
								-70.18310546874997,
								18.25175781249999
							],
							[
								-70.47993164062504,
								18.21728515624997
							],
							[
								-70.56542968749997,
								18.267578125
							],
							[
								-70.64467773437494,
								18.33623046874996
							],
							[
								-70.75883789062502,
								18.345605468750023
							],
							[
								-70.92431640624997,
								18.29248046875003
							],
							[
								-71.02783203125003,
								18.273193359375
							],
							[
								-71.069970703125,
								18.250341796874977
							],
							[
								-71.08222656249998,
								18.224365234375
							],
							[
								-71.08261718749998,
								18.128369140624983
							],
							[
								-71.10600585937496,
								18.07001953125001
							],
							[
								-71.26728515625004,
								17.84960937500003
							],
							[
								-71.35830078125002,
								17.69414062499999
							],
							[
								-71.39570312500001,
								17.646093749999977
							],
							[
								-71.43896484375003,
								17.63559570312495
							],
							[
								-71.51835937499993,
								17.724999999999966
							],
							[
								-71.56904296874995,
								17.75737304687499
							],
							[
								-71.63173828124994,
								17.77363281250001
							],
							[
								-71.65830078124995,
								17.821142578125006
							],
							[
								-71.6572265625,
								17.888671875
							],
							[
								-71.67373046874997,
								17.9541015625
							],
							[
								-71.71245117187496,
								18.005468750000006
							],
							[
								-71.76831054687497,
								18.03916015625012
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Caribbean",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "DOM",
					"su_a3": "DOM",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "DOM",
					"gu_a3": "DOM",
					"abbrev": "Dom. Rep.",
					"region_un": "Americas",
					"adm0_a3_us": "DOM",
					"scalerank": 1,
					"pop_est": 9650054,
					"adm0_dif": 0,
					"un_a3": "214",
					"pop_year": -99,
					"gdp_md_est": 78000,
					"name": "Dominican Rep.",
					"sovereignt": "Dominican Republic",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 9,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Dominican Republic",
					"postal": "DO",
					"sov_a3": "DOM",
					"note_brk": "",
					"brk_a3": "DOM",
					"wb_a2": "DO",
					"brk_diff": 0,
					"admin": "Dominican Republic",
					"name_long": "Dominican Republic",
					"iso_a3": "DOM",
					"iso_a2": "DO",
					"adm0_a3_is": "DOM",
					"level": 2,
					"formal_en": "Dominican Republic",
					"name_len": 14,
					"mapcolor7": 5,
					"long_len": 18,
					"mapcolor8": 2,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "214",
					"homepart": 1,
					"subunit": "Dominican Republic",
					"name_alt": "",
					"brk_name": "Dominican Rep.",
					"name_sort": "Dominican Republic",
					"continent": "North America",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								8.576562500000023,
								36.93720703124998
							],
							[
								8.597656250000057,
								36.883886718750034
							],
							[
								8.601269531250068,
								36.83393554687507
							],
							[
								8.50673828125008,
								36.78750000000002
							],
							[
								8.444238281250051,
								36.7607421875
							],
							[
								8.369628906250057,
								36.63251953125007
							],
							[
								8.230761718749989,
								36.54526367187498
							],
							[
								8.207617187499977,
								36.51894531250002
							],
							[
								8.208789062500045,
								36.49511718749997
							],
							[
								8.302734375,
								36.45561523437502
							],
							[
								8.333984375000057,
								36.41816406250001
							],
							[
								8.348730468750063,
								36.3679687500001
							],
							[
								8.306738281250034,
								36.1887695312501
							],
							[
								8.280273437500057,
								36.0509765625001
							],
							[
								8.245703125000034,
								35.87055664062501
							],
							[
								8.247070312500028,
								35.801806640625045
							],
							[
								8.28291015625004,
								35.71928710937502
							],
							[
								8.318066406250011,
								35.65493164062505
							],
							[
								8.329003906250023,
								35.58222656249998
							],
							[
								8.316406250000028,
								35.403125000000074
							],
							[
								8.35986328125,
								35.29960937499996
							],
							[
								8.394238281249983,
								35.203857421875085
							],
							[
								8.312109375000063,
								35.08461914062502
							],
							[
								8.276855468750057,
								34.97949218750003
							],
							[
								8.254687500000074,
								34.82895507812509
							],
							[
								8.24560546875,
								34.73408203125004
							],
							[
								8.19277343750008,
								34.646289062500074
							],
							[
								8.12343750000008,
								34.5639160156251
							],
							[
								8.045605468750011,
								34.51269531250006
							],
							[
								7.949414062500068,
								34.46870117187507
							],
							[
								7.838281250000051,
								34.410302734374966
							],
							[
								7.74853515625,
								34.25449218750012
							],
							[
								7.554492187500074,
								34.12500000000003
							],
							[
								7.51386718750004,
								34.08051757812501
							],
							[
								7.495605468750057,
								33.97651367187507
							],
							[
								7.500195312500011,
								33.83247070312501
							],
							[
								7.534375000000068,
								33.71791992187505
							],
							[
								7.627539062500034,
								33.54863281250002
							],
							[
								7.70917968750004,
								33.362304687500085
							],
							[
								7.731347656250051,
								33.26850585937507
							],
							[
								7.762695312500028,
								33.23310546875004
							],
							[
								7.877246093750017,
								33.17211914062506
							],
							[
								8.075585937499994,
								33.08906250000001
							],
							[
								8.112500000000068,
								33.055322265624966
							],
							[
								8.210937500000057,
								32.92670898437507
							],
							[
								8.304199218750028,
								32.696289062500114
							],
							[
								8.333398437500023,
								32.543603515624994
							],
							[
								8.515136718750028,
								32.42231445312507
							],
							[
								8.682910156250017,
								32.31044921875011
							],
							[
								8.844042968750074,
								32.21210937500004
							],
							[
								9.01894531250008,
								32.10537109375005
							],
							[
								9.044042968750034,
								32.07236328125009
							],
							[
								9.102343750000017,
								31.84614257812501
							],
							[
								9.160253906250006,
								31.62133789062503
							],
							[
								9.224023437500023,
								31.373681640625023
							],
							[
								9.287890625000074,
								31.125341796874977
							],
							[
								9.363281250000057,
								30.832910156249994
							],
							[
								9.406054687500074,
								30.666796875000074
							],
							[
								9.4580078125,
								30.465380859375074
							],
							[
								9.51875000000004,
								30.229394531249966
							],
							[
								9.420996093750006,
								30.179296874999977
							],
							[
								9.310253906250011,
								30.11523437499997
							],
							[
								9.391015625000023,
								29.99365234375
							],
							[
								9.546191406250017,
								29.795947265625045
							],
							[
								9.640136718750057,
								29.63642578125004
							],
							[
								9.672656250000017,
								29.566992187500034
							],
							[
								9.745898437500017,
								29.36894531249999
							],
							[
								9.805273437500034,
								29.176953125000068
							],
							[
								9.82070312500008,
								29.114794921875017
							],
							[
								9.842578125000017,
								28.96699218750001
							],
							[
								9.815625000000011,
								28.560205078124994
							],
							[
								9.858203125000074,
								28.043310546875034
							],
							[
								9.916015625000057,
								27.785693359375045
							],
							[
								9.825292968750034,
								27.552978515625057
							],
							[
								9.74755859375,
								27.330859375000017
							],
							[
								9.752539062500063,
								27.219335937500034
							],
							[
								9.79541015625,
								27.044775390625006
							],
							[
								9.83710937500004,
								26.915820312500017
							],
							[
								9.894433593749994,
								26.847949218750045
							],
							[
								9.883203125000023,
								26.63081054687504
							],
							[
								9.859375000000057,
								26.55195312500004
							],
							[
								9.684960937500051,
								26.43823242187497
							],
							[
								9.49140625000004,
								26.333740234375
							],
							[
								9.43789062500008,
								26.245507812499966
							],
							[
								9.422363281250028,
								26.147070312499977
							],
							[
								9.448242187500057,
								26.06713867187503
							],
							[
								9.581250000000068,
								25.89013671875003
							],
							[
								9.781054687499989,
								25.624267578125057
							],
							[
								10.000683593750068,
								25.332080078125045
							],
							[
								10.01904296875,
								25.25854492187497
							],
							[
								10.028125000000074,
								25.05102539062497
							],
							[
								10.119531250000023,
								24.79023437500004
							],
							[
								10.218652343750051,
								24.67622070312501
							],
							[
								10.255859375,
								24.59101562500004
							],
							[
								10.325781250000034,
								24.53022460937501
							],
							[
								10.395898437500023,
								24.48559570312497
							],
							[
								10.43896484375,
								24.48022460937503
							],
							[
								10.686132812500006,
								24.551367187499977
							],
							[
								11.108203125000017,
								24.43403320312504
							],
							[
								11.507617187500017,
								24.314355468749994
							],
							[
								11.536914062500045,
								24.29082031249999
							],
							[
								11.624218750000068,
								24.139697265625045
							],
							[
								11.766992187500023,
								23.892578125000057
							],
							[
								11.873046875000057,
								23.69482421875
							],
							[
								11.967871093750006,
								23.517871093750017
							],
							[
								11.450000000000017,
								23.212597656249983
							],
							[
								10.932226562500034,
								22.907275390625045
							],
							[
								10.414355468750045,
								22.60200195312501
							],
							[
								9.896484375000057,
								22.296728515625006
							],
							[
								9.378710937500017,
								21.991406250000068
							],
							[
								8.860937500000034,
								21.68613281249995
							],
							[
								8.343066406250045,
								21.38085937500003
							],
							[
								7.825195312500057,
								21.075585937499994
							],
							[
								7.481738281250074,
								20.87309570312496
							],
							[
								7.263378906250011,
								20.694482421874994
							],
							[
								6.989355468750034,
								20.470507812500017
							],
							[
								6.730664062500011,
								20.248046875
							],
							[
								6.527050781250011,
								20.07294921875001
							],
							[
								6.263378906250011,
								19.84614257812501
							],
							[
								6.130664062500074,
								19.731982421875017
							],
							[
								5.83662109375004,
								19.479150390625023
							],
							[
								5.748339843750074,
								19.434228515625023
							],
							[
								5.358691406250017,
								19.359521484374994
							],
							[
								5.001367187500051,
								19.29106445312499
							],
							[
								4.671289062500023,
								19.227783203125057
							],
							[
								4.44570312500008,
								19.18452148437504
							],
							[
								4.2276367187500625,
								19.142773437500068
							],
							[
								3.910156250000057,
								19.08374023437503
							],
							[
								3.683496093750051,
								19.04160156249995
							],
							[
								3.438769531250017,
								18.996142578125017
							],
							[
								3.4008789062500284,
								18.988427734374966
							],
							[
								3.3564453125000284,
								18.986621093750045
							],
							[
								3.323437500000068,
								18.98837890624995
							],
							[
								3.2559570312500057,
								19.013281249999977
							],
							[
								3.174218750000051,
								19.072900390625023
							],
							[
								3.119726562500034,
								19.103173828124994
							],
							[
								3.1060546875000057,
								19.15009765625004
							],
							[
								3.1378906250000114,
								19.21215820312497
							],
							[
								3.1772460937500284,
								19.268164062500034
							],
							[
								3.1923828125,
								19.31206054687499
							],
							[
								3.219628906250051,
								19.34541015625004
							],
							[
								3.2543945312500284,
								19.37260742187499
							],
							[
								3.255859375000057,
								19.41093749999999
							],
							[
								3.227050781250057,
								19.47358398437504
							],
							[
								3.2016601562500284,
								19.56040039062495
							],
							[
								3.2027343749999773,
								19.71831054687499
							],
							[
								3.2034179687500455,
								19.770751953125
							],
							[
								3.2037109375000057,
								19.78969726562505
							],
							[
								3.130273437500051,
								19.850195312500034
							],
							[
								2.9924804687500455,
								19.916601562499977
							],
							[
								2.86572265625,
								19.955957031249994
							],
							[
								2.807910156250017,
								19.969433593749983
							],
							[
								2.667773437500074,
								19.99291992187497
							],
							[
								2.4742187499999773,
								20.035009765625006
							],
							[
								2.406152343750051,
								20.063867187500023
							],
							[
								2.280859375000034,
								20.210302734375034
							],
							[
								2.2193359375000057,
								20.24780273437503
							],
							[
								1.9288085937500625,
								20.27270507812503
							],
							[
								1.8324218750000512,
								20.296875
							],
							[
								1.753222656250017,
								20.331591796875045
							],
							[
								1.6854492187500512,
								20.378369140624983
							],
							[
								1.6473632812500227,
								20.458837890625034
							],
							[
								1.636035156250017,
								20.524365234375068
							],
							[
								1.6106445312499886,
								20.555566406250023
							],
							[
								1.2902343750000114,
								20.713574218750068
							],
							[
								1.2088867187500512,
								20.767285156249983
							],
							[
								1.1657226562500398,
								20.81743164062499
							],
							[
								1.1640625000000568,
								20.89130859375004
							],
							[
								1.1727539062500512,
								20.981982421875017
							],
							[
								1.1591796875000284,
								21.0625
							],
							[
								1.1455078125,
								21.10224609375001
							],
							[
								0.9994140625000796,
								21.19775390625003
							],
							[
								0.6718750000000568,
								21.41186523437503
							],
							[
								0.3444335937500682,
								21.625976562500057
							],
							[
								0.01699218750005116,
								21.84013671874999
							],
							[
								-0.3105468749999716,
								22.05419921874997
							],
							[
								-0.6379882812499886,
								22.268310546875
							],
							[
								-0.9654785156249943,
								22.482470703125017
							],
							[
								-1.2929687500000284,
								22.696533203125
							],
							[
								-1.6204101562499318,
								22.91064453125003
							],
							[
								-1.9479003906249375,
								23.124804687500045
							],
							[
								-2.2753906249999716,
								23.33886718750003
							],
							[
								-2.6029296874999943,
								23.55302734374996
							],
							[
								-2.9303710937500114,
								23.76713867187499
							],
							[
								-3.257861328124932,
								23.98124999999999
							],
							[
								-3.5853515624999375,
								24.195361328125017
							],
							[
								-3.9127929687499545,
								24.409472656250017
							],
							[
								-4.240332031249977,
								24.62353515625003
							],
							[
								-4.5169921874999375,
								24.804492187500017
							],
							[
								-4.822607421874949,
								24.995605468750057
							],
							[
								-5.049511718749983,
								25.13544921875004
							],
							[
								-5.27499999999992,
								25.274511718750034
							],
							[
								-5.516943359375006,
								25.423779296875068
							],
							[
								-5.6745117187499545,
								25.516406250000017
							],
							[
								-5.862548828124972,
								25.62700195312499
							],
							[
								-6.050585937499989,
								25.73759765624996
							],
							[
								-6.2386718749999375,
								25.848193359375017
							],
							[
								-6.426708984374983,
								25.95878906249999
							],
							[
								-6.61474609375,
								26.069433593749977
							],
							[
								-6.802832031249949,
								26.179980468750017
							],
							[
								-6.990869140624994,
								26.290576171875074
							],
							[
								-7.178906249999926,
								26.401171875000045
							],
							[
								-7.36699218749996,
								26.511767578125017
							],
							[
								-7.555078124999994,
								26.622363281250102
							],
							[
								-7.743115234374926,
								26.732958984375074
							],
							[
								-7.931152343749972,
								26.843554687500045
							],
							[
								-8.11923828124992,
								26.954150390625102
							],
							[
								-8.307275390624937,
								27.064746093750074
							],
							[
								-8.495312499999955,
								27.175341796875045
							],
							[
								-8.683349609375,
								27.285937500000017
							],
							[
								-8.683349609375,
								27.49023437499997
							],
							[
								-8.683349609375,
								27.656445312499983
							],
							[
								-8.683349609375,
								27.900390625000057
							],
							[
								-8.683349609375,
								28.112011718750068
							],
							[
								-8.683349609375,
								28.32368164062504
							],
							[
								-8.683349609375,
								28.46923828125003
							],
							[
								-8.683349609375,
								28.62075195312508
							],
							[
								-8.678417968749955,
								28.68940429687504
							],
							[
								-8.659912109375028,
								28.71860351562512
							],
							[
								-8.558349609375028,
								28.767871093750017
							],
							[
								-8.399316406249937,
								28.88017578124999
							],
							[
								-8.340478515624966,
								28.930175781250057
							],
							[
								-8.265185546874989,
								28.980517578125102
							],
							[
								-7.998925781249994,
								29.132421875000034
							],
							[
								-7.943847656249972,
								29.17475585937504
							],
							[
								-7.685156249999949,
								29.34951171875005
							],
							[
								-7.624609374999949,
								29.37519531250004
							],
							[
								-7.485742187499994,
								29.39223632812505
							],
							[
								-7.427685546874983,
								29.42500000000004
							],
							[
								-7.349755859374994,
								29.494726562500034
							],
							[
								-7.23491210937496,
								29.57490234375004
							],
							[
								-7.160205078124932,
								29.61264648437509
							],
							[
								-7.142431640624949,
								29.619580078125068
							],
							[
								-7.0949218749999545,
								29.625195312499983
							],
							[
								-6.855566406249949,
								29.601611328125074
							],
							[
								-6.755126953125,
								29.58383789062509
							],
							[
								-6.635351562499949,
								29.56879882812504
							],
							[
								-6.59775390624992,
								29.578955078124977
							],
							[
								-6.565673828124943,
								29.603857421875063
							],
							[
								-6.520556640624989,
								29.65986328125004
							],
							[
								-6.5106933593749545,
								29.72602539062501
							],
							[
								-6.50791015624992,
								29.783789062500063
							],
							[
								-6.500878906249994,
								29.809130859375074
							],
							[
								-6.479736328124943,
								29.820361328125045
							],
							[
								-6.427636718749994,
								29.816113281250068
							],
							[
								-6.357617187499926,
								29.808300781249983
							],
							[
								-6.214794921874983,
								29.810693359375023
							],
							[
								-6.16650390625,
								29.81894531250012
							],
							[
								-6.004296874999994,
								29.83125000000004
							],
							[
								-5.774999999999977,
								29.869042968750108
							],
							[
								-5.593310546874932,
								29.91796875000003
							],
							[
								-5.44877929687496,
								29.95693359375005
							],
							[
								-5.293652343749983,
								30.058642578125102
							],
							[
								-5.1801269531249545,
								30.166162109374966
							],
							[
								-5.0619140624999375,
								30.326416015625114
							],
							[
								-4.968261718749943,
								30.465380859375074
							],
							[
								-4.778515624999926,
								30.55239257812505
							],
							[
								-4.619628906249972,
								30.604785156250074
							],
							[
								-4.52915039062492,
								30.625537109375017
							],
							[
								-4.32285156249992,
								30.69887695312505
							],
							[
								-4.148779296874977,
								30.80957031250003
							],
							[
								-3.9853515625,
								30.913525390625068
							],
							[
								-3.8600585937499545,
								30.92724609375003
							],
							[
								-3.7020019531250057,
								30.944482421874994
							],
							[
								-3.666796874999932,
								30.96401367187505
							],
							[
								-3.626904296874983,
								31.00092773437504
							],
							[
								-3.6245117187500284,
								31.065771484375006
							],
							[
								-3.6725097656249375,
								31.111376953125074
							],
							[
								-3.7301757812499545,
								31.13540039062508
							],
							[
								-3.7709960937500284,
								31.16181640625004
							],
							[
								-3.8118164062499886,
								31.166601562500034
							],
							[
								-3.8333984374999375,
								31.197802734375074
							],
							[
								-3.8213867187499773,
								31.25546875000012
							],
							[
								-3.8151367187499545,
								31.30883789062497
							],
							[
								-3.7891601562499773,
								31.361816406250114
							],
							[
								-3.79643554687496,
								31.43710937500009
							],
							[
								-3.837109374999983,
								31.51235351562505
							],
							[
								-3.8495605468749545,
								31.56640625000003
							],
							[
								-3.8466796874999716,
								31.619873046875085
							],
							[
								-3.8267578124999204,
								31.66191406249996
							],
							[
								-3.7681640624999773,
								31.68955078125009
							],
							[
								-3.7002441406249886,
								31.700097656250108
							],
							[
								-3.604589843749949,
								31.686767578125057
							],
							[
								-3.439794921874949,
								31.70454101562504
							],
							[
								-3.01738281249996,
								31.83427734374999
							],
							[
								-2.988232421874983,
								31.87421875000004
							],
							[
								-2.9611328124999545,
								31.963964843750034
							],
							[
								-2.930859374999926,
								32.04252929687496
							],
							[
								-2.88720703125,
								32.068847656250085
							],
							[
								-2.8634277343749375,
								32.07470703125003
							],
							[
								-2.7226074218749545,
								32.095751953125045
							],
							[
								-2.523242187499932,
								32.12568359375004
							],
							[
								-2.4483886718749375,
								32.12998046875009
							],
							[
								-2.231249999999932,
								32.12133789062503
							],
							[
								-2.0728027343749886,
								32.11503906249999
							],
							[
								-1.8169921874999204,
								32.104785156250045
							],
							[
								-1.6351562499999943,
								32.09956054687504
							],
							[
								-1.4770507812499432,
								32.094873046874966
							],
							[
								-1.275341796874983,
								32.08901367187502
							],
							[
								-1.2259277343749488,
								32.107226562500074
							],
							[
								-1.2259277343749488,
								32.16455078125003
							],
							[
								-1.2621093749999375,
								32.271142578124994
							],
							[
								-1.2403320312499488,
								32.33759765625004
							],
							[
								-1.16259765625,
								32.39916992187506
							],
							[
								-1.0655273437499488,
								32.46831054687502
							],
							[
								-1.111035156249983,
								32.55229492187499
							],
							[
								-1.188232421875,
								32.60849609374998
							],
							[
								-1.29638671875,
								32.67568359375008
							],
							[
								-1.3521484375000057,
								32.70336914062503
							],
							[
								-1.4499999999999318,
								32.78481445312502
							],
							[
								-1.510009765625,
								32.87763671875001
							],
							[
								-1.5507324218749545,
								33.07358398437506
							],
							[
								-1.6250976562499204,
								33.18334960937503
							],
							[
								-1.67919921875,
								33.318652343750074
							],
							[
								-1.6312500000000227,
								33.56674804687498
							],
							[
								-1.7029785156249773,
								33.7168457031251
							],
							[
								-1.7141113281250284,
								33.781835937500006
							],
							[
								-1.7146972656249488,
								33.85820312500002
							],
							[
								-1.6926757812499886,
								33.99028320312502
							],
							[
								-1.706933593749966,
								34.176074218750045
							],
							[
								-1.7917968749999318,
								34.36791992187503
							],
							[
								-1.751855468749966,
								34.43325195312502
							],
							[
								-1.7333007812499375,
								34.467041015625085
							],
							[
								-1.739453124999926,
								34.49609375000003
							],
							[
								-1.816601562499926,
								34.55708007812504
							],
							[
								-1.849658203125017,
								34.607324218749966
							],
							[
								-1.832421874999966,
								34.654638671875006
							],
							[
								-1.792187499999926,
								34.723193359375045
							],
							[
								-1.795605468749926,
								34.75190429687501
							],
							[
								-1.9208984374999432,
								34.835546875000006
							],
							[
								-2.131787109374926,
								34.97084960937505
							],
							[
								-2.190771484374949,
								35.02978515625006
							],
							[
								-2.219628906249966,
								35.10419921875004
							],
							[
								-2.017773437499983,
								35.085058593750034
							],
							[
								-1.9132812500000114,
								35.09423828125003
							],
							[
								-1.6736328124999318,
								35.18310546875003
							],
							[
								-1.4837402343749773,
								35.303076171875034
							],
							[
								-1.335839843749966,
								35.36425781249997
							],
							[
								-1.2053710937499318,
								35.49575195312505
							],
							[
								-1.0876953124999318,
								35.578857421875
							],
							[
								-0.91748046875,
								35.66840820312504
							],
							[
								-0.42612304687497726,
								35.86152343750004
							],
							[
								-0.35078125000001137,
								35.86318359375002
							],
							[
								-0.1891601562499261,
								35.819091796875
							],
							[
								-0.048242187499994316,
								35.83281249999996
							],
							[
								0.04794921875006253,
								35.900537109374994
							],
							[
								0.15166015625004547,
								36.063134765624994
							],
							[
								0.3122070312500682,
								36.16235351562503
							],
							[
								0.5149414062500739,
								36.26181640625006
							],
							[
								0.7908203125000455,
								36.35654296874998
							],
							[
								0.9716796875000284,
								36.443945312500034
							],
							[
								1.2572265625000227,
								36.51958007812499
							],
							[
								1.9745117187500512,
								36.56757812499998
							],
							[
								2.3428710937500625,
								36.61030273437498
							],
							[
								2.5933593750000057,
								36.60068359374998
							],
							[
								2.846484375000074,
								36.73886718749998
							],
							[
								2.97285156250004,
								36.784472656250045
							],
							[
								3.5205078124999716,
								36.79511718749998
							],
							[
								3.779003906250068,
								36.89619140625007
							],
							[
								4.7581054687500455,
								36.896337890625006
							],
							[
								4.877832031250023,
								36.862402343750006
							],
							[
								4.995410156250074,
								36.80805664062504
							],
							[
								5.195605468750017,
								36.676806640625045
							],
							[
								5.29541015625,
								36.64824218749999
							],
							[
								5.424609375000017,
								36.67543945312502
							],
							[
								5.725488281250051,
								36.79960937500002
							],
							[
								6.0647460937500455,
								36.86425781250003
							],
							[
								6.2491210937500625,
								36.938330078125034
							],
							[
								6.327832031250011,
								37.04604492187505
							],
							[
								6.486523437500011,
								37.085742187500045
							],
							[
								6.575878906250011,
								37.00302734374998
							],
							[
								6.927539062500074,
								36.91943359375
							],
							[
								7.14345703125008,
								36.943359375
							],
							[
								7.238476562499983,
								36.96850585937506
							],
							[
								7.20429687500004,
								37.09238281249998
							],
							[
								7.432421875000074,
								37.05927734374998
							],
							[
								7.607714843750074,
								36.99975585937503
							],
							[
								7.7916015625000625,
								36.88027343750002
							],
							[
								7.910449218750017,
								36.85634765625002
							],
							[
								8.12714843750004,
								36.91035156250001
							],
							[
								8.576562500000023,
								36.93720703124998
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Africa",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "DZA",
					"su_a3": "DZA",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "DZA",
					"gu_a3": "DZA",
					"abbrev": "Alg.",
					"region_un": "Africa",
					"adm0_a3_us": "DZA",
					"scalerank": 1,
					"pop_est": 34178188,
					"adm0_dif": 0,
					"un_a3": "012",
					"pop_year": -99,
					"gdp_md_est": 232900,
					"name": "Algeria",
					"sovereignt": "Algeria",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Algeria",
					"postal": "DZ",
					"sov_a3": "DZA",
					"note_brk": "",
					"brk_a3": "DZA",
					"wb_a2": "DZ",
					"brk_diff": 0,
					"admin": "Algeria",
					"name_long": "Algeria",
					"iso_a3": "DZA",
					"iso_a2": "DZ",
					"adm0_a3_is": "DZA",
					"level": 2,
					"formal_en": "People's Democratic Republic of Algeria",
					"name_len": 7,
					"mapcolor7": 5,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "012",
					"homepart": 1,
					"subunit": "Algeria",
					"name_alt": "",
					"brk_name": "Algeria",
					"name_sort": "Algeria",
					"continent": "Africa",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2008
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-80.131591796875,
									-2.9731445312499147
								],
								[
									-80.15068359374999,
									-3.0117187499999574
								],
								[
									-80.24570312499998,
									-3.0083007812499716
								],
								[
									-80.27294921875003,
									-2.995898437499932
								],
								[
									-80.27216796874995,
									-2.9517578124999915
								],
								[
									-80.24980468750002,
									-2.8119140624999233
								],
								[
									-80.22368164062502,
									-2.7531250000000256
								],
								[
									-80.14570312499995,
									-2.6962890624999005
								],
								[
									-80.08076171874995,
									-2.668847656249909
								],
								[
									-79.99726562499998,
									-2.673828124999943
								],
								[
									-79.90903320312495,
									-2.725585937499929
								],
								[
									-80.01323242187496,
									-2.819531250000054
								],
								[
									-80.07119140624997,
									-2.833789062499946
								],
								[
									-80.09340820312494,
									-2.845898437499926
								],
								[
									-80.131591796875,
									-2.9731445312499147
								]
							]
						],
						[
							[
								[
									-90.42392578125,
									-1.3399414062499773
								],
								[
									-90.46440429687499,
									-1.3419921874999545
								],
								[
									-90.51953124999994,
									-1.2991210937499318
								],
								[
									-90.47719726562494,
									-1.2209960937499034
								],
								[
									-90.43198242187498,
									-1.2398437499999346
								],
								[
									-90.39873046874993,
									-1.2623046875000625
								],
								[
									-90.37915039062494,
									-1.2922851562499602
								],
								[
									-90.42392578125,
									-1.3399414062499773
								]
							]
						],
						[
							[
								[
									-89.41889648437498,
									-0.911035156249909
								],
								[
									-89.53662109375,
									-0.952343749999983
								],
								[
									-89.57729492187502,
									-0.9337890624999261
								],
								[
									-89.60263671875003,
									-0.9134765625000512
								],
								[
									-89.60859375000001,
									-0.8885742187499517
								],
								[
									-89.54345703124997,
									-0.8268554687498977
								],
								[
									-89.47993164062498,
									-0.7933593749999233
								],
								[
									-89.42314453124996,
									-0.7222656249999062
								],
								[
									-89.31840820312493,
									-0.6800781249999375
								],
								[
									-89.28784179687503,
									-0.6898437499999659
								],
								[
									-89.26743164062503,
									-0.7045898437499574
								],
								[
									-89.259375,
									-0.7284179687500085
								],
								[
									-89.29487304687495,
									-0.7859375000000028
								],
								[
									-89.35834960937501,
									-0.8260742187500085
								],
								[
									-89.41889648437498,
									-0.911035156249909
								]
							]
						],
						[
							[
								[
									-90.33486328125,
									-0.7715820312499204
								],
								[
									-90.38710937499997,
									-0.7733398437499233
								],
								[
									-90.54213867187502,
									-0.6764648437499119
								],
								[
									-90.53168945312495,
									-0.581445312499909
								],
								[
									-90.46972656250003,
									-0.5173828125000028
								],
								[
									-90.26938476562498,
									-0.4846679687499176
								],
								[
									-90.18530273437497,
									-0.544824218749909
								],
								[
									-90.19272460937498,
									-0.6587890625000341
								],
								[
									-90.26108398437498,
									-0.7419921874999318
								],
								[
									-90.31542968750003,
									-0.7572265624999233
								],
								[
									-90.33486328125,
									-0.7715820312499204
								]
							]
						],
						[
							[
								[
									-91.42597656249995,
									-0.46083984374993747
								],
								[
									-91.5263671875,
									-0.4782226562499261
								],
								[
									-91.61074218749994,
									-0.44394531249996305
								],
								[
									-91.64658203124998,
									-0.39082031249998295
								],
								[
									-91.654150390625,
									-0.3109374999999517
								],
								[
									-91.64667968749998,
									-0.28447265624988916
								],
								[
									-91.46015625000001,
									-0.2556640624999744
								],
								[
									-91.39936523437495,
									-0.3224609374999119
								],
								[
									-91.39995117187499,
									-0.4208984374999716
								],
								[
									-91.42597656249995,
									-0.46083984374993747
								]
							]
						],
						[
							[
								[
									-90.57392578124993,
									-0.33398437499994316
								],
								[
									-90.620458984375,
									-0.3642578124999005
								],
								[
									-90.80903320312495,
									-0.32939453124990337
								],
								[
									-90.86777343750003,
									-0.2713867187499801
								],
								[
									-90.82036132812496,
									-0.19218749999991758
								],
								[
									-90.78037109374998,
									-0.160449218749946
								],
								[
									-90.66752929687499,
									-0.18984375000006537
								],
								[
									-90.5533203125,
									-0.2784179687499915
								],
								[
									-90.57392578124993,
									-0.33398437499994316
								]
							]
						],
						[
							[
								[
									-91.27216796874998,
									0.02514648437502842
								],
								[
									-91.21005859375003,
									-0.03930664062495737
								],
								[
									-91.17622070312498,
									-0.22304687499990905
								],
								[
									-90.97553710937495,
									-0.4168945312499659
								],
								[
									-90.95063476562493,
									-0.5251953124999034
								],
								[
									-90.96845703125001,
									-0.5755859374999659
								],
								[
									-90.95893554687495,
									-0.5953124999999773
								],
								[
									-90.86254882812503,
									-0.6717773437499233
								],
								[
									-90.799658203125,
									-0.7520507812499346
								],
								[
									-90.90551757812497,
									-0.940527343749963
								],
								[
									-91.13105468750001,
									-1.0196289062500057
								],
								[
									-91.37153320312498,
									-1.016992187499909
								],
								[
									-91.41904296874998,
									-0.9966796874999488
								],
								[
									-91.48354492187497,
									-0.9246093749999176
								],
								[
									-91.49541015624999,
									-0.8609375000000057
								],
								[
									-91.45830078124999,
									-0.7995117187499261
								],
								[
									-91.33408203124998,
									-0.7062499999999403
								],
								[
									-91.14467773437494,
									-0.6228515624999034
								],
								[
									-91.120947265625,
									-0.5590820312499716
								],
								[
									-91.19702148437494,
									-0.49697265624993747
								],
								[
									-91.24951171875,
									-0.37363281249993463
								],
								[
									-91.36918945312493,
									-0.2872070312500057
								],
								[
									-91.42885742187502,
									-0.023388671874911893
								],
								[
									-91.46870117187495,
									-0.010302734374903366
								],
								[
									-91.55000000000001,
									-0.046679687500031264
								],
								[
									-91.590087890625,
									-0.014794921874937472
								],
								[
									-91.59682617187497,
									0.002099609375051159
								],
								[
									-91.50917968749997,
									0.06225585937495737
								],
								[
									-91.49101562499999,
									0.10517578124999716
								],
								[
									-91.36137695312496,
									0.1258300781250341
								],
								[
									-91.30576171874998,
									0.0914062500000341
								],
								[
									-91.27216796874998,
									0.02514648437502842
								]
							]
						],
						[
							[
								[
									-78.90922851562502,
									1.25278320312502
								],
								[
									-78.96562499999996,
									1.2453613281250284
								],
								[
									-78.99169921875003,
									1.2932128906250853
								],
								[
									-78.92324218749994,
									1.348925781250074
								],
								[
									-78.89980468749997,
									1.3597656250000654
								],
								[
									-78.90922851562502,
									1.25278320312502
								]
							]
						],
						[
							[
								[
									-75.28447265624999,
									-0.10654296874997726
								],
								[
									-75.34047851562494,
									-0.14218749999994884
								],
								[
									-75.39838867187501,
									-0.1459960937500142
								],
								[
									-75.47597656250002,
									-0.1571289062499801
								],
								[
									-75.58374023437503,
									-0.12285156249991758
								],
								[
									-75.62626953124999,
									-0.12285156249991758
								],
								[
									-75.63203125000001,
									-0.1576171874999801
								],
								[
									-75.56059570312493,
									-0.20009765625002274
								],
								[
									-75.49106445312498,
									-0.24833984374990337
								],
								[
									-75.46596679687502,
									-0.32177734374994316
								],
								[
									-75.42470703124997,
									-0.4088867187499261
								],
								[
									-75.32524414062496,
									-0.5065429687499261
								],
								[
									-75.26323242187502,
									-0.5553710937499261
								],
								[
									-75.25937499999995,
									-0.5901367187499034
								],
								[
									-75.27871093749997,
									-0.6539062499999346
								],
								[
									-75.28359375,
									-0.7071289062499346
								],
								[
									-75.249609375,
									-0.9518554687499687
								],
								[
									-75.27241210937493,
									-0.9667968749999005
								],
								[
									-75.30917968749995,
									-0.9680664062498892
								],
								[
									-75.34819335937502,
									-0.9667968749999005
								],
								[
									-75.38012695312503,
									-0.9402343749999034
								],
								[
									-75.40805664062495,
									-0.9243164062499574
								],
								[
									-75.42041015624997,
									-0.9622070312500313
								],
								[
									-75.44916992187498,
									-1.0711914062499375
								],
								[
									-75.51386718750001,
									-1.316308593749966
								],
								[
									-75.570556640625,
									-1.5312499999999716
								],
								[
									-75.64165039062502,
									-1.6073242187500085
								],
								[
									-75.74453125000002,
									-1.7281249999999346
								],
								[
									-75.88544921874995,
									-1.893457031250037
								],
								[
									-76.08979492187501,
									-2.1331054687499176
								],
								[
									-76.24091796874998,
									-2.2439453125000313
								],
								[
									-76.36015624999993,
									-2.3313476562499034
								],
								[
									-76.49936523437495,
									-2.43232421875004
								],
								[
									-76.6791015625,
									-2.5625976562499346
								],
								[
									-76.88076171874994,
									-2.6359374999999545
								],
								[
									-77.16147460937495,
									-2.737695312499909
								],
								[
									-77.36005859374998,
									-2.809667968749906
								],
								[
									-77.50649414062497,
									-2.859960937499949
								],
								[
									-77.65898437499996,
									-2.9124023437499744
								],
								[
									-77.860595703125,
									-2.98164062500004
								],
								[
									-77.93847656249997,
									-3.0469726562499346
								],
								[
									-78.06791992187496,
									-3.2068359374999176
								],
								[
									-78.12822265624999,
									-3.283886718749983
								],
								[
									-78.18330078125001,
									-3.350195312499892
								],
								[
									-78.19462890625002,
									-3.3804687499999346
								],
								[
									-78.18745117187495,
									-3.399804687499966
								],
								[
									-78.160986328125,
									-3.4321289062498863
								],
								[
									-78.15849609375002,
									-3.46513671874996
								],
								[
									-78.19487304687496,
									-3.4858398437499147
								],
								[
									-78.22631835937497,
									-3.489160156249966
								],
								[
									-78.240380859375,
									-3.4725585937499517
								],
								[
									-78.25073242187497,
									-3.436132812499906
								],
								[
									-78.28417968749994,
									-3.399023437499892
								],
								[
									-78.32304687499996,
									-3.3882812499999346
								],
								[
									-78.345361328125,
									-3.397363281249909
								],
								[
									-78.34726562499992,
									-3.4312499999999773
								],
								[
									-78.39804687499998,
									-3.594824218749906
								],
								[
									-78.39995117187502,
									-3.674316406249943
								],
								[
									-78.42143554687493,
									-3.7057617187499545
								],
								[
									-78.41977539062495,
									-3.7768554687499574
								],
								[
									-78.47104492187492,
									-3.8430664062500313
								],
								[
									-78.49345703124996,
									-3.9020507812499687
								],
								[
									-78.50908203124993,
									-3.9521484374999574
								],
								[
									-78.55043945312502,
									-3.9869140624999346
								],
								[
									-78.56513671874998,
									-4.041601562499977
								],
								[
									-78.60336914062498,
									-4.157324218749935
								],
								[
									-78.64799804687499,
									-4.248144531249963
								],
								[
									-78.67939453125001,
									-4.325878906249983
								],
								[
									-78.68515624999992,
									-4.383984374999926
								],
								[
									-78.66123046874995,
									-4.425097656249946
								],
								[
									-78.65292968749995,
									-4.45820312499994
								],
								[
									-78.67446289062497,
									-4.517675781249977
								],
								[
									-78.68603515625003,
									-4.5624023437499375
								],
								[
									-78.74306640625,
									-4.59267578124998
								],
								[
									-78.86152343749998,
									-4.665039062499886
								],
								[
									-78.90761718749997,
									-4.71445312499992
								],
								[
									-78.92578125000003,
									-4.770703125000011
								],
								[
									-78.91420898437497,
									-4.818652343749918
								],
								[
									-78.919189453125,
									-4.858398437499943
								],
								[
									-78.97539062499999,
									-4.87324218749994
								],
								[
									-78.99526367187497,
									-4.908007812499918
								],
								[
									-79.03330078124998,
									-4.9691406249999375
								],
								[
									-79.07626953124995,
									-4.990624999999966
								],
								[
									-79.18666992187497,
									-4.958203124999926
								],
								[
									-79.26811523437496,
									-4.957617187499906
								],
								[
									-79.33095703124997,
									-4.927832031249963
								],
								[
									-79.39941406249997,
									-4.840039062499926
								],
								[
									-79.45576171874998,
									-4.766210937499892
								],
								[
									-79.50190429687498,
									-4.6706054687499545
								],
								[
									-79.51616210937493,
									-4.53916015624992
								],
								[
									-79.57768554687496,
									-4.500585937499963
								],
								[
									-79.638525390625,
									-4.454882812499974
								],
								[
									-79.71098632812493,
									-4.467578124999903
								],
								[
									-79.79726562500002,
									-4.476367187499918
								],
								[
									-79.8451171875,
									-4.44589843749992
								],
								[
									-79.962890625,
									-4.390332031249969
								],
								[
									-80.06352539062499,
									-4.327539062499966
								],
								[
									-80.13955078125002,
									-4.2960937499999545
								],
								[
									-80.19746093750001,
									-4.311035156249886
								],
								[
									-80.23217773437497,
									-4.349023437499909
								],
								[
									-80.293359375,
									-4.416796875000031
								],
								[
									-80.38349609374998,
									-4.463671874999989
								],
								[
									-80.42416992187492,
									-4.461425781249972
								],
								[
									-80.47856445312499,
									-4.43007812499998
								],
								[
									-80.48847656249995,
									-4.393652343749935
								],
								[
									-80.44384765625003,
									-4.335839843749966
								],
								[
									-80.35288085937498,
									-4.208496093749957
								],
								[
									-80.453759765625,
									-4.205175781249906
								],
								[
									-80.48847656249995,
									-4.16552734375
								],
								[
									-80.49345703125002,
									-4.119140624999972
								],
								[
									-80.510009765625,
									-4.069531249999983
								],
								[
									-80.49013671874994,
									-4.010058593749946
								],
								[
									-80.43720703125001,
									-3.9786132812499346
								],
								[
									-80.35786132812501,
									-4.003417968750014
								],
								[
									-80.30327148437499,
									-4.005078124999997
								],
								[
									-80.26689453124993,
									-3.948828124999906
								],
								[
									-80.23051757812499,
									-3.924023437499912
								],
								[
									-80.19414062499996,
									-3.905859375000034
								],
								[
									-80.17924804687493,
									-3.8777343749999886
								],
								[
									-80.21757812499993,
									-3.787695312499949
								],
								[
									-80.22885742187492,
									-3.738867187499949
								],
								[
									-80.21728515624997,
									-3.7107421874999034
								],
								[
									-80.21894531249995,
									-3.654492187499983
								],
								[
									-80.22060546875002,
									-3.6131835937499233
								],
								[
									-80.24374999999995,
									-3.576757812499963
								],
								[
									-80.24541015625002,
									-3.5221679687500256
								],
								[
									-80.26523437499995,
									-3.492480468750017
								],
								[
									-80.271875,
									-3.4610351562500057
								],
								[
									-80.27353515624998,
									-3.42460937499996
								],
								[
									-80.29833984374994,
									-3.406445312499983
								],
								[
									-80.32465820312498,
									-3.3878906250000256
								],
								[
									-80.30312499999997,
									-3.374804687499932
								],
								[
									-80.15986328124998,
									-3.324316406249949
								],
								[
									-80.10034179687503,
									-3.2740234374999204
								],
								[
									-80.02666015624993,
									-3.228124999999892
								],
								[
									-79.96333007812501,
									-3.1577148437500284
								],
								[
									-79.92158203124993,
									-3.090136718749946
								],
								[
									-79.82270507812495,
									-2.776953124999906
								],
								[
									-79.72988281249997,
									-2.579101562499929
								],
								[
									-79.74550781249994,
									-2.4846679687500455
								],
								[
									-79.822412109375,
									-2.356542968749963
								],
								[
									-79.83974609374997,
									-2.167871093749895
								],
								[
									-79.83261718750003,
									-2.1105468749999403
								],
								[
									-79.842138671875,
									-2.067382812499943
								],
								[
									-79.89340820312498,
									-2.145703124999912
								],
								[
									-79.88032226562498,
									-2.4236328125000455
								],
								[
									-79.92558593749996,
									-2.548535156249912
								],
								[
									-79.989013671875,
									-2.57871093750002
								],
								[
									-80.03017578124994,
									-2.556738281249892
								],
								[
									-80.00664062499996,
									-2.3538085937500313
								],
								[
									-80.053076171875,
									-2.3907226562499204
								],
								[
									-80.12714843749998,
									-2.528417968749906
								],
								[
									-80.24863281249995,
									-2.630566406249926
								],
								[
									-80.25527343749997,
									-2.664648437499949
								],
								[
									-80.28471679687502,
									-2.7067382812498977
								],
								[
									-80.37856445312497,
									-2.6679687499999147
								],
								[
									-80.45009765624997,
									-2.625976562500057
								],
								[
									-80.68486328125002,
									-2.3968749999999233
								],
								[
									-80.83906249999998,
									-2.3490234374999517
								],
								[
									-80.93217773437493,
									-2.2691406249999204
								],
								[
									-80.95161132812498,
									-2.235449218749906
								],
								[
									-80.96279296874997,
									-2.1892578124999034
								],
								[
									-80.86762695312493,
									-2.1412109375000625
								],
								[
									-80.770361328125,
									-2.076660156250057
								],
								[
									-80.76059570312498,
									-1.9345703124999716
								],
								[
									-80.76313476562495,
									-1.8229492187499687
								],
								[
									-80.83500976562496,
									-1.6324218749999773
								],
								[
									-80.80141601562494,
									-1.3833984374999488
								],
								[
									-80.82001953125001,
									-1.2858398437499687
								],
								[
									-80.90239257812502,
									-1.0789062500000028
								],
								[
									-80.84140625,
									-0.9747070312499204
								],
								[
									-80.62368164062497,
									-0.8987304687499744
								],
								[
									-80.55390624999998,
									-0.8479492187499318
								],
								[
									-80.50507812499998,
									-0.683789062499983
								],
								[
									-80.45546875,
									-0.5854492187500142
								],
								[
									-80.35839843750003,
									-0.6250976562499204
								],
								[
									-80.282373046875,
									-0.6205078125000512
								],
								[
									-80.38476562499997,
									-0.5839843749999005
								],
								[
									-80.46831054687493,
									-0.43603515624995737
								],
								[
									-80.48227539062503,
									-0.3682617187499062
								],
								[
									-80.3212890625,
									-0.16582031249997442
								],
								[
									-80.23701171874998,
									-0.11308593750005969
								],
								[
									-80.1333984375,
									-0.0060546874999261036
								],
								[
									-80.046142578125,
									0.15537109375009095
								],
								[
									-80.02499999999995,
									0.41015624999995737
								],
								[
									-80.06103515625003,
									0.5922851562500284
								],
								[
									-80.08828124999997,
									0.7847656250000625
								],
								[
									-80.03593749999996,
									0.834570312500091
								],
								[
									-79.90351562499998,
									0.8602050781250767
								],
								[
									-79.79584960937498,
									0.922265625000108
								],
								[
									-79.74121093749997,
									0.9797851562501023
								],
								[
									-79.61318359375,
									0.9711425781250256
								],
								[
									-79.46538085937499,
									1.0600585937501137
								],
								[
									-79.22905273437499,
									1.104589843750034
								],
								[
									-78.89965820312503,
									1.206250000000054
								],
								[
									-78.82705078124997,
									1.2959472656250313
								],
								[
									-78.85966796874996,
									1.455371093750088
								],
								[
									-78.828857421875,
									1.4346679687500483
								],
								[
									-78.73710937499996,
									1.3586914062499318
								],
								[
									-78.68164062500003,
									1.2834472656250568
								],
								[
									-78.58764648437497,
									1.236669921875034
								],
								[
									-78.51152343749999,
									1.1988281250000483
								],
								[
									-78.31210937499995,
									1.0460937500001108
								],
								[
									-78.1806640625,
									0.9685546875000313
								],
								[
									-78.03701171874997,
									0.898730468750017
								],
								[
									-77.82954101562498,
									0.8253906249999972
								],
								[
									-77.702880859375,
									0.8378417968750398
								],
								[
									-77.673193359375,
									0.7822265625000853
								],
								[
									-77.64863281249998,
									0.7236328125000426
								],
								[
									-77.60131835937503,
									0.689501953125017
								],
								[
									-77.52612304687497,
									0.6603515625000398
								],
								[
									-77.48139648437501,
									0.6511718750000313
								],
								[
									-77.46767578124997,
									0.6365234375000597
								],
								[
									-77.42275390624997,
									0.4248535156249318
								],
								[
									-77.396337890625,
									0.3938964843750199
								],
								[
									-77.29267578124993,
									0.360400390624946
								],
								[
									-77.16572265625001,
									0.3477539062500341
								],
								[
									-77.11411132812498,
									0.3550781250000199
								],
								[
									-77.00244140624994,
									0.2962402343750199
								],
								[
									-76.92011718749998,
									0.268505859375054
								],
								[
									-76.82934570312494,
									0.24775390625008242
								],
								[
									-76.76772460937502,
									0.24165039062508242
								],
								[
									-76.73930664062499,
									0.2508300781250057
								],
								[
									-76.72900390625003,
									0.2721191406250796
								],
								[
									-76.67851562499996,
									0.26816406250007674
								],
								[
									-76.60302734375003,
									0.24096679687504263
								],
								[
									-76.49462890624997,
									0.23544921875006253
								],
								[
									-76.42729492187502,
									0.26123046875008527
								],
								[
									-76.41796875,
									0.30390624999998295
								],
								[
									-76.41337890624993,
									0.3788574218750682
								],
								[
									-76.38818359374997,
									0.40498046874996874
								],
								[
									-76.31103515624997,
									0.44848632812504263
								],
								[
									-76.27060546874998,
									0.439404296875054
								],
								[
									-76.06791992187499,
									0.3455566406250341
								],
								[
									-76.02617187500002,
									0.31308593750007674
								],
								[
									-75.97485351562494,
									0.24775390625008242
								],
								[
									-75.87978515624994,
									0.15097656250009095
								],
								[
									-75.77666015624999,
									0.08925781249995168
								],
								[
									-75.61733398437494,
									0.06289062500007958
								],
								[
									-75.46396484374998,
									-0.03842773437494884
								],
								[
									-75.28447265624999,
									-0.10654296874997726
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "ECU",
					"su_a3": "ECU",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "ECU",
					"gu_a3": "ECU",
					"abbrev": "Ecu.",
					"region_un": "Americas",
					"adm0_a3_us": "ECU",
					"scalerank": 1,
					"pop_est": 14573101,
					"adm0_dif": 0,
					"un_a3": "218",
					"pop_year": -99,
					"gdp_md_est": 107700,
					"name": "Ecuador",
					"sovereignt": "Ecuador",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Ecuador",
					"postal": "EC",
					"sov_a3": "ECU",
					"note_brk": "",
					"brk_a3": "ECU",
					"wb_a2": "EC",
					"brk_diff": 0,
					"admin": "Ecuador",
					"name_long": "Ecuador",
					"iso_a3": "ECU",
					"iso_a2": "EC",
					"adm0_a3_is": "ECU",
					"level": 2,
					"formal_en": "Republic of Ecuador",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 5,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "218",
					"homepart": 1,
					"subunit": "Ecuador",
					"name_alt": "",
					"brk_name": "Ecuador",
					"name_sort": "Ecuador",
					"continent": "South America",
					"mapcolor13": 12,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								34.19814453125008,
								31.32260742187512
							],
							[
								34.21250000000009,
								31.292285156250074
							],
							[
								34.245312500000125,
								31.208300781250017
							],
							[
								34.32851562500008,
								30.995019531249994
							],
							[
								34.400976562500034,
								30.82783203125004
							],
							[
								34.48994140625001,
								30.596289062500034
							],
							[
								34.51777343750001,
								30.507373046875017
							],
							[
								34.52968750000002,
								30.446044921875057
							],
							[
								34.65859375000002,
								30.19145507812496
							],
							[
								34.73505859375007,
								29.982031250000034
							],
							[
								34.79111328125009,
								29.812109375000034
							],
							[
								34.86982421875007,
								29.56391601562501
							],
							[
								34.90429687500006,
								29.47734374999996
							],
							[
								34.84853515625008,
								29.43212890625
							],
							[
								34.736425781250034,
								29.270605468750034
							],
							[
								34.6171875,
								28.757910156250034
							],
							[
								34.44648437500007,
								28.357324218749966
							],
							[
								34.42714843750002,
								28.106494140625017
							],
							[
								34.399707031250045,
								28.016015624999966
							],
							[
								34.31855468750001,
								27.888964843750017
							],
							[
								34.22011718750002,
								27.764306640625023
							],
							[
								34.04511718750001,
								27.82885742187503
							],
							[
								33.76025390625006,
								28.047656250000017
							],
							[
								33.59414062500002,
								28.25556640625001
							],
							[
								33.41611328125009,
								28.38984375000001
							],
							[
								33.24775390625001,
								28.567724609375006
							],
							[
								33.20195312499999,
								28.695703124999966
							],
							[
								33.20371093750009,
								28.77778320312501
							],
							[
								33.130175781250045,
								28.978271484375
							],
							[
								33.075781250000034,
								29.073046875000017
							],
							[
								32.87060546875,
								29.286230468750034
							],
							[
								32.81171875000007,
								29.400000000000034
							],
							[
								32.766699218750034,
								29.44999999999999
							],
							[
								32.72148437499999,
								29.52177734374996
							],
							[
								32.64716796875001,
								29.798437500000006
							],
							[
								32.565722656250045,
								29.973974609374977
							],
							[
								32.47304687500008,
								29.92543945312505
							],
							[
								32.48945312500007,
								29.851513671874983
							],
							[
								32.40859375000002,
								29.749316406250045
							],
							[
								32.35976562500002,
								29.630664062500017
							],
							[
								32.39726562499999,
								29.533789062500006
							],
							[
								32.56503906250009,
								29.386328124999977
							],
							[
								32.59902343750008,
								29.321923828125023
							],
							[
								32.63808593750002,
								29.18217773437496
							],
							[
								32.6318359375,
								28.99223632812499
							],
							[
								32.65888671875001,
								28.927734375
							],
							[
								32.784472656250045,
								28.78662109375003
							],
							[
								32.82949218750002,
								28.70288085937503
							],
							[
								32.856542968750034,
								28.63061523437503
							],
							[
								32.898242187500045,
								28.565234375000045
							],
							[
								33.02285156250002,
								28.44228515625005
							],
							[
								33.20214843750006,
								28.20830078124999
							],
							[
								33.37226562500007,
								28.05058593749999
							],
							[
								33.49492187499999,
								27.974462890625034
							],
							[
								33.54707031250007,
								27.89814453125004
							],
							[
								33.55878906250001,
								27.70122070312496
							],
							[
								33.5498046875,
								27.60737304687504
							],
							[
								33.65742187500007,
								27.430566406249994
							],
							[
								33.697265625,
								27.34111328124996
							],
							[
								33.80166015625002,
								27.268164062500034
							],
							[
								33.84931640625007,
								27.184912109375034
							],
							[
								33.89306640625,
								27.049462890624966
							],
							[
								33.959082031250034,
								26.649023437500006
							],
							[
								34.04951171875001,
								26.550732421875068
							],
							[
								34.32929687500007,
								26.02436523437504
							],
							[
								34.56513671875007,
								25.691162109375
							],
							[
								34.679296875000034,
								25.442529296874966
							],
							[
								34.85322265625007,
								25.139794921875023
							],
							[
								35.194140625000045,
								24.47514648437499
							],
							[
								35.39707031250009,
								24.26997070312501
							],
							[
								35.477832031250045,
								24.15478515625
							],
							[
								35.62470703125001,
								24.066015625000034
							],
							[
								35.78388671875001,
								23.937792968750017
							],
							[
								35.63203125000001,
								23.950341796874994
							],
							[
								35.593847656250034,
								23.94257812500001
							],
							[
								35.54082031249999,
								23.920654296875
							],
							[
								35.51523437500009,
								23.84287109374995
							],
							[
								35.50439453125,
								23.77929687499997
							],
							[
								35.522753906250045,
								23.442529296875023
							],
							[
								35.56435546875008,
								23.271093750000006
							],
							[
								35.69785156250009,
								22.946191406249966
							],
							[
								35.79736328125,
								22.848730468750006
							],
							[
								35.845800781250034,
								22.78569335937496
							],
							[
								35.913378906250045,
								22.739648437499994
							],
							[
								36.22968750000007,
								22.628808593749966
							],
							[
								36.41455078125,
								22.394189453124966
							],
							[
								36.82968750000009,
								22.09765625000003
							],
							[
								36.870410156250045,
								22.015771484374966
							],
							[
								36.87138671874999,
								21.996728515624994
							],
							[
								36.54326171874999,
								21.99663085937496
							],
							[
								36.21523437500008,
								21.996582031250057
							],
							[
								35.88701171874999,
								21.99653320312504
							],
							[
								35.55898437500002,
								21.996484375000023
							],
							[
								35.23085937500008,
								21.996435546875034
							],
							[
								34.90273437500002,
								21.996386718750017
							],
							[
								34.57460937500002,
								21.996337890625
							],
							[
								34.24648437500008,
								21.996289062499983
							],
							[
								33.91845703125006,
								21.996240234374994
							],
							[
								33.59033203125006,
								21.996191406249977
							],
							[
								33.26220703125,
								21.99614257812496
							],
							[
								32.93408203125006,
								21.99609375000003
							],
							[
								32.60605468750009,
								21.995996093750023
							],
							[
								32.27783203125,
								21.995996093750023
							],
							[
								31.94980468750009,
								21.99589843749999
							],
							[
								31.62167968750009,
								21.995849609375
							],
							[
								31.43447265625008,
								21.995849609375
							],
							[
								31.46640625000009,
								22.084667968750068
							],
							[
								31.486132812500045,
								22.14780273437495
							],
							[
								31.464257812500023,
								22.191503906249977
							],
							[
								31.400292968750023,
								22.20244140624999
							],
							[
								31.358496093750034,
								22.188623046874994
							],
							[
								31.26064453125008,
								22.002294921874977
							],
							[
								31.20917968750001,
								21.99487304687497
							],
							[
								31.09267578125008,
								21.99487304687497
							],
							[
								30.71064453125001,
								21.99492187499999
							],
							[
								30.32861328125,
								21.995019531249994
							],
							[
								29.946679687500023,
								21.99511718750003
							],
							[
								29.564550781250034,
								21.99511718750003
							],
							[
								29.182519531250023,
								21.99521484374995
							],
							[
								28.800585937500017,
								21.99526367187505
							],
							[
								28.418554687500006,
								21.995312500000068
							],
							[
								28.036425781250045,
								21.99536132812497
							],
							[
								27.65449218750004,
								21.995458984375006
							],
							[
								27.2724609375,
								21.995507812500023
							],
							[
								26.890429687500074,
								21.99555664062501
							],
							[
								26.508398437500034,
								21.99560546875003
							],
							[
								26.126367187500023,
								21.995654296875045
							],
							[
								25.744335937499983,
								21.995751953124966
							],
							[
								25.362304687500057,
								21.995800781249983
							],
							[
								24.980273437500017,
								21.995849609375
							],
							[
								24.980273437500017,
								22.22041015625001
							],
							[
								24.980273437500017,
								22.444970703124994
							],
							[
								24.980273437500017,
								22.669531250000006
							],
							[
								24.980273437500017,
								22.894091796875017
							],
							[
								24.980273437500017,
								23.11865234375003
							],
							[
								24.980273437500017,
								23.34321289062504
							],
							[
								24.980273437500017,
								23.567822265625068
							],
							[
								24.980273437500017,
								23.792382812499966
							],
							[
								24.980273437500017,
								24.016943359374977
							],
							[
								24.980273437500017,
								24.24150390624999
							],
							[
								24.980273437500017,
								24.466064453125
							],
							[
								24.980273437500017,
								24.69062500000001
							],
							[
								24.980273437500017,
								24.915185546875023
							],
							[
								24.980273437500017,
								25.139746093750034
							],
							[
								24.980273437500017,
								25.364306640625017
							],
							[
								24.980273437500017,
								25.58886718750003
							],
							[
								24.980273437500017,
								25.81342773437504
							],
							[
								24.980273437500017,
								26.037988281249966
							],
							[
								24.980273437500017,
								26.262548828125063
							],
							[
								24.980273437500017,
								26.48710937499999
							],
							[
								24.980273437500017,
								26.711669921875
							],
							[
								24.980273437500017,
								26.936230468749983
							],
							[
								24.980273437500017,
								27.16083984375001
							],
							[
								24.980273437500017,
								27.385400390625023
							],
							[
								24.980273437500017,
								27.609960937500034
							],
							[
								24.980273437500017,
								27.834521484375045
							],
							[
								24.980273437500017,
								28.059082031250057
							],
							[
								24.980273437500017,
								28.28364257812504
							],
							[
								24.980273437500017,
								28.508203124999966
							],
							[
								24.980273437500017,
								28.732763671874977
							],
							[
								24.980273437500017,
								28.95732421874999
							],
							[
								24.980273437500017,
								29.181884765625
							],
							[
								24.971679687500057,
								29.22382812500001
							],
							[
								24.916113281250006,
								29.37626953124999
							],
							[
								24.86591796875001,
								29.570263671874983
							],
							[
								24.810839843750074,
								29.808740234374994
							],
							[
								24.80371093750003,
								29.886035156250017
							],
							[
								24.71162109375001,
								30.13154296875001
							],
							[
								24.703222656249977,
								30.201074218749966
							],
							[
								24.726464843750023,
								30.250585937500034
							],
							[
								24.877539062500063,
								30.45751953125
							],
							[
								24.92304687500001,
								30.55800781250005
							],
							[
								24.96142578125,
								30.67851562499999
							],
							[
								24.973925781250074,
								30.776562500000068
							],
							[
								24.929492187500074,
								30.92646484375004
							],
							[
								24.877539062500063,
								31.061230468750068
							],
							[
								24.859960937500034,
								31.19916992187501
							],
							[
								24.852734375000068,
								31.334814453125034
							],
							[
								24.92998046874999,
								31.42749023437497
							],
							[
								25.02265625000004,
								31.514013671875034
							],
							[
								25.057226562499977,
								31.567187500000017
							],
							[
								25.11201171875004,
								31.62690429687501
							],
							[
								25.150488281250063,
								31.654980468750068
							],
							[
								25.22548828125008,
								31.533789062500063
							],
							[
								25.382226562500023,
								31.512792968750034
							],
							[
								25.89326171875004,
								31.620898437500045
							],
							[
								26.457324218750017,
								31.512109374999994
							],
							[
								26.768652343750034,
								31.470361328125023
							],
							[
								27.248046875,
								31.37788085937501
							],
							[
								27.54003906249997,
								31.212695312500017
							],
							[
								27.620117187500057,
								31.191748046875006
							],
							[
								27.82998046875008,
								31.19501953125004
							],
							[
								27.967578125000045,
								31.09741210937497
							],
							[
								28.514843750000068,
								31.050439453124994
							],
							[
								28.806933593750074,
								30.94267578124999
							],
							[
								28.972753906250006,
								30.85673828124996
							],
							[
								29.072070312500074,
								30.830273437499983
							],
							[
								29.159960937500045,
								30.834570312499977
							],
							[
								29.278906250000034,
								30.866943359375
							],
							[
								29.428515625000045,
								30.927441406249983
							],
							[
								29.591601562500045,
								31.01152343749996
							],
							[
								29.929785156250034,
								31.22749023437501
							],
							[
								30.04941406250009,
								31.265429687500017
							],
							[
								30.12753906250009,
								31.25566406249996
							],
							[
								30.22265625,
								31.258398437500006
							],
							[
								30.26230468750009,
								31.31684570312501
							],
							[
								30.31230468749999,
								31.357031250000006
							],
							[
								30.34375,
								31.402734374999994
							],
							[
								30.395117187500034,
								31.457617187500006
							],
							[
								30.57099609375001,
								31.472998046875006
							],
							[
								30.923535156250068,
								31.56684570312504
							],
							[
								30.884179687500023,
								31.52236328125005
							],
							[
								30.562988281250057,
								31.41699218749997
							],
							[
								30.70048828124999,
								31.40385742187496
							],
							[
								30.841406250000034,
								31.43989257812501
							],
							[
								31.00175781249999,
								31.462792968749994
							],
							[
								31.03085937500009,
								31.507568359375057
							],
							[
								31.05195312500001,
								31.591552734375
							],
							[
								31.082910156250023,
								31.603320312500017
							],
							[
								31.19394531250009,
								31.58759765625001
							],
							[
								31.5244140625,
								31.45825195312503
							],
							[
								31.606542968750034,
								31.455761718750068
							],
							[
								31.839257812500023,
								31.52631835937504
							],
							[
								31.888964843750045,
								31.541406250000023
							],
							[
								31.96425781250008,
								31.502099609374994
							],
							[
								32.13603515624999,
								31.341064453125057
							],
							[
								32.07607421875002,
								31.34448242187503
							],
							[
								31.892187500000034,
								31.48247070312499
							],
							[
								31.875878906250023,
								31.413720703125023
							],
							[
								31.77109375000009,
								31.292578125000034
							],
							[
								31.90205078125001,
								31.24018554687501
							],
							[
								32.00849609375001,
								31.220507812500017
							],
							[
								32.06562500000001,
								31.152978515625023
							],
							[
								32.10175781250001,
								31.092822265625017
							],
							[
								32.20654296875006,
								31.119042968750023
							],
							[
								32.281835937500034,
								31.20087890625001
							],
							[
								32.24277343750009,
								31.246533203125068
							],
							[
								32.21621093750008,
								31.293750000000017
							],
							[
								32.250585937500034,
								31.29492187499997
							],
							[
								32.32353515624999,
								31.25605468750004
							],
							[
								32.53281250000009,
								31.100732421875023
							],
							[
								32.60332031249999,
								31.068749999999994
							],
							[
								32.6845703125,
								31.074023437500017
							],
							[
								32.8544921875,
								31.117724609375017
							],
							[
								32.90156250000007,
								31.110937499999977
							],
							[
								33.12988281250006,
								31.16816406250001
							],
							[
								33.15673828125,
								31.12622070312497
							],
							[
								33.19433593750006,
								31.084521484375017
							],
							[
								33.37792968750006,
								31.130957031250063
							],
							[
								33.66650390625006,
								31.130419921875045
							],
							[
								33.90253906250007,
								31.180957031250017
							],
							[
								34.17626953125006,
								31.30390625000004
							],
							[
								34.19814453125008,
								31.32260742187512
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Africa",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "EGY",
					"su_a3": "EGY",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "EGY",
					"gu_a3": "EGY",
					"abbrev": "Egypt",
					"region_un": "Africa",
					"adm0_a3_us": "EGY",
					"scalerank": 1,
					"pop_est": 83082869,
					"adm0_dif": 0,
					"un_a3": "818",
					"pop_year": -99,
					"gdp_md_est": 443700,
					"name": "Egypt",
					"sovereignt": "Egypt",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Egypt",
					"postal": "EG",
					"sov_a3": "EGY",
					"note_brk": "",
					"brk_a3": "EGY",
					"wb_a2": "EG",
					"brk_diff": 0,
					"admin": "Egypt",
					"name_long": "Egypt",
					"iso_a3": "EGY",
					"iso_a2": "EG",
					"adm0_a3_is": "EGY",
					"level": 2,
					"formal_en": "Arab Republic of Egypt",
					"name_len": 5,
					"mapcolor7": 4,
					"long_len": 5,
					"mapcolor8": 6,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "818",
					"homepart": 1,
					"subunit": "Egypt",
					"name_alt": "",
					"brk_name": "Egypt",
					"name_sort": "Egypt, Arab Rep.",
					"continent": "Africa",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-17.887939453125,
									27.809570312500114
								],
								[
									-17.984765625000023,
									27.64638671875008
								],
								[
									-18.106591796874966,
									27.707470703125097
								],
								[
									-18.135937499999983,
									27.727929687499994
								],
								[
									-18.160546874999937,
									27.761474609375085
								],
								[
									-18.043359374999966,
									27.768115234375102
								],
								[
									-17.924511718749983,
									27.850146484374932
								],
								[
									-17.887939453125,
									27.809570312500114
								]
							]
						],
						[
							[
								[
									-15.400585937499983,
									28.147363281249994
								],
								[
									-15.406689453124983,
									28.070507812500068
								],
								[
									-15.383154296874977,
									27.99282226562505
								],
								[
									-15.389160156249943,
									27.87470703125004
								],
								[
									-15.436767578124972,
									27.81069335937508
								],
								[
									-15.559374999999989,
									27.746972656249966
								],
								[
									-15.65576171875,
									27.758398437499977
								],
								[
									-15.71030273437492,
									27.78408203125005
								],
								[
									-15.807324218749955,
									27.887548828125006
								],
								[
									-15.809472656249966,
									27.994482421875034
								],
								[
									-15.720947265624943,
									28.064160156249926
								],
								[
									-15.682763671874994,
									28.154052734374943
								],
								[
									-15.452783203124937,
									28.136914062500097
								],
								[
									-15.432714843749949,
									28.154248046874983
								],
								[
									-15.415478515624983,
									28.15932617187505
								],
								[
									-15.400585937499983,
									28.147363281249994
								]
							]
						],
						[
							[
								[
									-17.184667968750006,
									28.021972656249943
								],
								[
									-17.225390624999932,
									28.01352539062509
								],
								[
									-17.27392578124997,
									28.038281249999983
								],
								[
									-17.324902343749955,
									28.117675781250085
								],
								[
									-17.290332031249932,
									28.176318359375045
								],
								[
									-17.25859374999996,
									28.203173828125102
								],
								[
									-17.21435546875,
									28.199267578125102
								],
								[
									-17.12963867187497,
									28.155957031250068
								],
								[
									-17.103759765624943,
									28.11113281249999
								],
								[
									-17.10107421875003,
									28.08344726562504
								],
								[
									-17.184667968750006,
									28.021972656249943
								]
							]
						],
						[
							[
								[
									-16.33447265624997,
									28.379931640625045
								],
								[
									-16.418212890625,
									28.151416015624932
								],
								[
									-16.496240234374994,
									28.061914062499994
								],
								[
									-16.54277343749996,
									28.032080078125063
								],
								[
									-16.65800781249999,
									28.00717773437495
								],
								[
									-16.79472656249996,
									28.149169921875114
								],
								[
									-16.86601562499999,
									28.293261718750045
								],
								[
									-16.905322265625017,
									28.339599609375085
								],
								[
									-16.843066406249932,
									28.37612304687505
								],
								[
									-16.752050781249977,
									28.36982421875001
								],
								[
									-16.556835937499983,
									28.400488281250063
								],
								[
									-16.51743164062495,
									28.412695312500063
								],
								[
									-16.318994140624937,
									28.558203125000034
								],
								[
									-16.12363281249992,
									28.575976562500017
								],
								[
									-16.119140625,
									28.528271484375068
								],
								[
									-16.33447265624997,
									28.379931640625045
								]
							]
						],
						[
							[
								[
									-14.196777343749943,
									28.16928710937512
								],
								[
									-14.332617187500006,
									28.05600585937495
								],
								[
									-14.468603515625006,
									28.08237304687509
								],
								[
									-14.49179687499992,
									28.10092773437495
								],
								[
									-14.355566406249977,
									28.129687500000045
								],
								[
									-14.231982421875017,
									28.2158203125
								],
								[
									-14.152587890625,
									28.40664062500005
								],
								[
									-14.028369140625017,
									28.617431640625114
								],
								[
									-14.003369140624983,
									28.706689453124994
								],
								[
									-13.954150390624989,
									28.74145507812497
								],
								[
									-13.886279296874932,
									28.744677734375102
								],
								[
									-13.85722656249996,
									28.738037109375085
								],
								[
									-13.827148437499972,
									28.691210937500045
								],
								[
									-13.827587890624955,
									28.585156249999926
								],
								[
									-13.862988281249983,
									28.40932617187508
								],
								[
									-13.928027343749989,
									28.253466796875045
								],
								[
									-14.196777343749943,
									28.16928710937512
								]
							]
						],
						[
							[
								[
									-17.83427734374999,
									28.493212890624932
								],
								[
									-17.85937499999997,
									28.485693359375006
								],
								[
									-17.88212890624999,
									28.56459960937508
								],
								[
									-18.00078124999999,
									28.758251953124926
								],
								[
									-17.928808593749977,
									28.84458007812512
								],
								[
									-17.797558593749983,
									28.84677734375012
								],
								[
									-17.744531250000023,
									28.786572265624926
								],
								[
									-17.7265625,
									28.724462890624977
								],
								[
									-17.751611328124937,
									28.68857421874995
								],
								[
									-17.74438476562497,
									28.616015625000074
								],
								[
									-17.75800781250001,
									28.569091796874943
								],
								[
									-17.83427734374999,
									28.493212890624932
								]
							]
						],
						[
							[
								[
									-13.715966796874966,
									28.911230468750006
								],
								[
									-13.78398437499996,
									28.84545898437503
								],
								[
									-13.859912109374989,
									28.869091796874955
								],
								[
									-13.823632812499966,
									29.013330078124937
								],
								[
									-13.78818359374992,
									29.05610351562504
								],
								[
									-13.650097656249955,
									29.118994140625063
								],
								[
									-13.535058593749966,
									29.14428710937497
								],
								[
									-13.501416015624955,
									29.211230468749932
								],
								[
									-13.463574218749955,
									29.23720703125008
								],
								[
									-13.422949218749949,
									29.197509765625057
								],
								[
									-13.453759765625023,
									29.151367187500085
								],
								[
									-13.477929687499966,
									29.006591796875085
								],
								[
									-13.554687499999972,
									28.96020507812503
								],
								[
									-13.715966796874966,
									28.911230468750006
								]
							]
						],
						[
							[
								[
									1.5939453125000682,
									38.672070312499926
								],
								[
									1.5711914062500512,
									38.65883789062508
								],
								[
									1.5049804687500625,
									38.67099609375006
								],
								[
									1.40576171875,
									38.67099609375006
								],
								[
									1.401953125000034,
									38.71142578124994
								],
								[
									1.4171875000000114,
									38.73964843750011
								],
								[
									1.436328125000017,
									38.768212890624966
								],
								[
									1.496875000000017,
									38.71191406250006
								],
								[
									1.5926757812500796,
									38.70146484374996
								],
								[
									1.5939453125000682,
									38.672070312499926
								]
							]
						],
						[
							[
								[
									1.4452148437500512,
									38.918701171875085
								],
								[
									1.4089843750000455,
									38.85727539062509
								],
								[
									1.2569335937500625,
									38.87900390624998
								],
								[
									1.2233398437500682,
									38.903857421875074
								],
								[
									1.2562500000000227,
									38.97338867187503
								],
								[
									1.2998046875,
									38.981738281250045
								],
								[
									1.302539062500017,
									39.03115234375008
								],
								[
									1.3486328125,
									39.08081054687497
								],
								[
									1.564453125,
									39.1210449218751
								],
								[
									1.6131835937500796,
									39.087402343750085
								],
								[
									1.6236328124999773,
									39.03881835937494
								],
								[
									1.4945312500000512,
									38.93251953125005
								],
								[
									1.4452148437500512,
									38.918701171875085
								]
							]
						],
						[
							[
								[
									3.145312500000017,
									39.79008789062496
								],
								[
									3.2411132812500796,
									39.75668945312509
								],
								[
									3.3421875000000796,
									39.78671875000009
								],
								[
									3.3958984375000796,
									39.77729492187501
								],
								[
									3.44892578125004,
									39.76123046874994
								],
								[
									3.4618164062500227,
									39.697753906250085
								],
								[
									3.4146484375000057,
									39.62714843749998
								],
								[
									3.3487304687500625,
									39.555664062500085
								],
								[
									3.29296875,
									39.47705078125006
								],
								[
									3.2447265625000057,
									39.38662109375011
								],
								[
									3.1545898437500455,
									39.33325195312497
								],
								[
									3.0728515625000057,
									39.30126953124994
								],
								[
									2.900097656250068,
									39.36835937500001
								],
								[
									2.799804687500057,
									39.38505859374996
								],
								[
									2.769824218750074,
									39.410253906250034
								],
								[
									2.7459960937500227,
									39.51025390624997
								],
								[
									2.7005859374999943,
									39.54213867187508
								],
								[
									2.6340820312500455,
									39.55620117187502
								],
								[
									2.5758789062500114,
									39.53066406250005
								],
								[
									2.49951171875,
									39.47788085937495
								],
								[
									2.4587890625000455,
									39.53046875000001
								],
								[
									2.3943359375000455,
									39.54038085937506
								],
								[
									2.3700195312500796,
									39.57207031249996
								],
								[
									2.371289062500068,
									39.61308593749996
								],
								[
									2.7849609375000455,
									39.854833984375006
								],
								[
									2.9047851562500284,
									39.90830078124998
								],
								[
									3.15869140625,
									39.970507812500045
								],
								[
									3.1975585937499886,
									39.96108398437508
								],
								[
									3.1644531249999943,
									39.92421874999994
								],
								[
									3.1669921875,
									39.90771484374994
								],
								[
									3.198632812500051,
									39.88984375000004
								],
								[
									3.1909179687499716,
									39.86137695312502
								],
								[
									3.15869140625,
									39.83657226562502
								],
								[
									3.145312500000017,
									39.79008789062496
								]
							]
						],
						[
							[
								[
									4.293652343750011,
									39.84184570312502
								],
								[
									4.275292968749994,
									39.83027343749998
								],
								[
									3.967675781250051,
									39.94584960937499
								],
								[
									3.8671875,
									39.95874023437503
								],
								[
									3.8426757812500796,
									39.97636718749999
								],
								[
									3.8454101562500114,
									40.03647460937498
								],
								[
									3.8534179687500227,
									40.063037109375074
								],
								[
									4.059179687500034,
									40.07509765624994
								],
								[
									4.22578125000004,
									40.03237304687494
								],
								[
									4.31513671875004,
									39.91723632812503
								],
								[
									4.3220703125000455,
									39.8975097656251
								],
								[
									4.293652343750011,
									39.84184570312502
								]
							]
						],
						[
							[
								[
									-1.7940429687499488,
									43.40732421875006
								],
								[
									-1.7927246093749432,
									43.372558593750085
								],
								[
									-1.7532714843750057,
									43.324707031250114
								],
								[
									-1.712841796874926,
									43.307031249999966
								],
								[
									-1.627148437499983,
									43.28247070312503
								],
								[
									-1.5614746093750114,
									43.27919921875008
								],
								[
									-1.4717285156249318,
									43.267675781250034
								],
								[
									-1.4106933593749318,
									43.240087890625006
								],
								[
									-1.4073242187499488,
									43.197119140625034
								],
								[
									-1.4226074218749716,
									43.14912109375004
								],
								[
									-1.4594238281250114,
									43.104980468750114
								],
								[
									-1.4804687500000284,
									43.07114257812506
								],
								[
									-1.4608398437499375,
									43.051757812500085
								],
								[
									-1.4287597656249602,
									43.03676757812505
								],
								[
									-1.39404296875,
									43.03261718750002
								],
								[
									-1.3705078124999943,
									43.03759765625006
								],
								[
									-1.352734374999926,
									43.064257812500074
								],
								[
									-1.3188476562499716,
									43.096972656250074
								],
								[
									-1.3000488281249432,
									43.100976562499994
								],
								[
									-1.3015624999999886,
									43.082470703124955
								],
								[
									-1.2854492187499886,
									43.05961914062502
								],
								[
									-1.175439453124966,
									43.02114257812508
								],
								[
									-0.9338378906249432,
									42.94951171874996
								],
								[
									-0.8392089843749488,
									42.948193359374955
								],
								[
									-0.762646484374983,
									42.93979492187512
								],
								[
									-0.7401855468749261,
									42.90952148437506
								],
								[
									-0.5864257812499716,
									42.79897460937494
								],
								[
									-0.5498046874999716,
									42.802001953125114
								],
								[
									-0.48115234375001137,
									42.79931640625
								],
								[
									-0.39843749999994316,
									42.808105468750114
								],
								[
									-0.33857421875001137,
									42.82880859375007
								],
								[
									-0.29931640625,
									42.82534179687508
								],
								[
									-0.25605468749998295,
									42.80395507812497
								],
								[
									-0.20532226562494316,
									42.785302734374994
								],
								[
									-0.1400390624999659,
									42.74892578125005
								],
								[
									-0.08149414062495453,
									42.703857421875085
								],
								[
									-0.041162109374994316,
									42.68911132812494
								],
								[
									0.2013671875000398,
									42.71933593750006
								],
								[
									0.25546875000006253,
									42.6929199218751
								],
								[
									0.31289062500002274,
									42.69326171875008
								],
								[
									0.3772460937500739,
									42.70014648437504
								],
								[
									0.5176757812500057,
									42.68627929687506
								],
								[
									0.6316406250000455,
									42.68959960937502
								],
								[
									0.6419921875000227,
									42.70063476562507
								],
								[
									0.6517578125000512,
									42.800439453124966
								],
								[
									0.6698242187499943,
									42.83574218749996
								],
								[
									0.6968750000000057,
									42.84511718750011
								],
								[
									0.764453125000017,
									42.83803710937508
								],
								[
									1.0100585937500455,
									42.77895507812494
								],
								[
									1.111132812500017,
									42.74204101562506
								],
								[
									1.208300781250017,
									42.71313476562494
								],
								[
									1.2932617187499886,
									42.709960937500085
								],
								[
									1.349414062500074,
									42.690673828125085
								],
								[
									1.4283203124999773,
									42.595898437499955
								],
								[
									1.414843750000074,
									42.548388671875045
								],
								[
									1.421972656250034,
									42.53081054687502
								],
								[
									1.430273437500034,
									42.49785156249996
								],
								[
									1.4281250000000227,
									42.46132812500008
								],
								[
									1.4488281249999773,
									42.4374511718751
								],
								[
									1.4862304687500512,
									42.43447265625002
								],
								[
									1.5340820312500227,
									42.441699218750074
								],
								[
									1.5864257812500284,
									42.45595703125005
								],
								[
									1.678515625000074,
									42.49667968750009
								],
								[
									1.7060546875,
									42.50332031250011
								],
								[
									1.8597656250000512,
									42.4570800781251
								],
								[
									1.9279296875000682,
									42.426318359375045
								],
								[
									1.951464843750074,
									42.392773437499955
								],
								[
									1.9865234375000114,
									42.35849609375009
								],
								[
									2.03271484375,
									42.35351562500006
								],
								[
									2.098339843750068,
									42.38608398437512
								],
								[
									2.200390625000068,
									42.42094726562502
								],
								[
									2.3744140625000796,
									42.39028320312508
								],
								[
									2.5679687499999773,
									42.34580078124998
								],
								[
									2.651660156250074,
									42.340478515624966
								],
								[
									2.65478515625,
									42.36210937499993
								],
								[
									2.6700195312500057,
									42.39301757812501
								],
								[
									2.7018554687500114,
									42.40849609374996
								],
								[
									2.7494140624999943,
									42.4130371093751
								],
								[
									2.815624999999983,
									42.42924804687493
								],
								[
									2.891406250000074,
									42.45605468749997
								],
								[
									2.970019531250017,
									42.46723632812504
								],
								[
									3.052636718750051,
									42.44721679687504
								],
								[
									3.152148437500074,
									42.43100585937512
								],
								[
									3.2114257812499716,
									42.43115234375006
								],
								[
									3.2398437500000057,
									42.36787109375004
								],
								[
									3.287890625000017,
									42.3437011718751
								],
								[
									3.306738281250034,
									42.28896484375005
								],
								[
									3.2186523437500227,
									42.26035156249998
								],
								[
									3.166406250000051,
									42.256494140624994
								],
								[
									3.1503906249999716,
									42.16245117187512
								],
								[
									3.175195312500051,
									42.13598632812506
								],
								[
									3.224609375,
									42.11113281249996
								],
								[
									3.2380859374999886,
									42.082226562499926
								],
								[
									3.2480468749999716,
									41.94423828125005
								],
								[
									3.1468750000000796,
									41.86103515624998
								],
								[
									3.0048828125,
									41.76743164062509
								],
								[
									2.3109375000000227,
									41.46650390625007
								],
								[
									2.1456054687500057,
									41.32075195312504
								],
								[
									2.0826171875000625,
									41.2874023437501
								],
								[
									1.5666015625000114,
									41.19560546874996
								],
								[
									1.2058593750000455,
									41.097558593749966
								],
								[
									1.0329101562500682,
									41.06206054687493
								],
								[
									0.8168945312500284,
									40.891601562500114
								],
								[
									0.7146484375000739,
									40.822851562500034
								],
								[
									0.7960937500000682,
									40.80380859375006
								],
								[
									0.8911132812500568,
									40.7223632812501
								],
								[
									0.859179687500017,
									40.686230468749926
								],
								[
									0.7206054687500512,
									40.63046875000012
								],
								[
									0.6600585937500512,
									40.61333007812499
								],
								[
									0.6271484375000114,
									40.62221679687494
								],
								[
									0.5960937500000796,
									40.61450195312506
								],
								[
									0.3636718750000796,
									40.31904296875007
								],
								[
									0.15839843749998295,
									40.106591796874966
								],
								[
									0.043066406250034106,
									40.01396484375002
								],
								[
									-0.07514648437498295,
									39.875927734374955
								],
								[
									-0.32700195312494884,
									39.51987304687498
								],
								[
									-0.3289550781250057,
									39.417089843750006
								],
								[
									-0.20493164062494884,
									39.06259765625009
								],
								[
									-0.13378906249994316,
									38.96948242187494
								],
								[
									-0.03413085937498295,
									38.89121093749998
								],
								[
									0.15488281249997726,
									38.824658203124926
								],
								[
									0.20156250000007958,
									38.759179687499994
								],
								[
									0.1363281250000341,
									38.696777343750085
								],
								[
									-0.05273437499994316,
									38.585693359375
								],
								[
									-0.3812499999999943,
									38.43564453125006
								],
								[
									-0.5208007812499886,
									38.31728515624994
								],
								[
									-0.5506835937499659,
									38.20312500000006
								],
								[
									-0.6467773437499886,
									38.151855468750085
								],
								[
									-0.6832031249999488,
									37.992041015625034
								],
								[
									-0.7415527343749488,
									37.88613281250002
								],
								[
									-0.7527343749999886,
									37.85024414062511
								],
								[
									-0.8146484375000114,
									37.76992187500008
								],
								[
									-0.8230957031249488,
									37.71162109375001
								],
								[
									-0.7215820312499659,
									37.63105468750004
								],
								[
									-0.7718749999999943,
									37.596240234375045
								],
								[
									-0.8221679687499375,
									37.5807617187501
								],
								[
									-0.9380859374999204,
									37.57133789062502
								],
								[
									-1.327539062499966,
									37.56113281250009
								],
								[
									-1.6409667968749488,
									37.38696289062494
								],
								[
									-1.7976074218749716,
									37.2328613281251
								],
								[
									-1.9393066406249773,
									36.94584960937496
								],
								[
									-2.111523437499983,
									36.77666015624996
								],
								[
									-2.1876953124999545,
									36.74545898437509
								],
								[
									-2.3055664062499943,
									36.81982421875006
								],
								[
									-2.4528320312499545,
									36.831152343750034
								],
								[
									-2.595703124999943,
									36.80649414062509
								],
								[
									-2.670605468749926,
									36.74755859375006
								],
								[
									-2.7875488281249545,
									36.71474609375005
								],
								[
									-2.9018554687499716,
									36.74316406249997
								],
								[
									-3.149169921875,
									36.75849609374998
								],
								[
									-3.2591308593749204,
									36.755761718749966
								],
								[
									-3.4312499999999773,
									36.70791015625008
								],
								[
									-3.5788085937499545,
									36.739843750000006
								],
								[
									-3.8277832031249375,
									36.75605468750001
								],
								[
									-4.366845703124994,
									36.71811523437512
								],
								[
									-4.434863281249989,
									36.70024414062493
								],
								[
									-4.50224609374996,
									36.629150390625114
								],
								[
									-4.674121093749989,
									36.50644531249998
								],
								[
									-4.935302734374972,
									36.50205078125006
								],
								[
									-5.171484374999949,
									36.42377929687501
								],
								[
									-5.230517578124989,
									36.373632812500006
								],
								[
									-5.329687499999949,
									36.23574218750008
								],
								[
									-5.36093749999992,
									36.13491210937505
								],
								[
									-5.381591796874943,
									36.13408203124996
								],
								[
									-5.407226562499943,
									36.158886718749955
								],
								[
									-5.443603515624972,
									36.150585937499955
								],
								[
									-5.46249999999992,
									36.07377929687493
								],
								[
									-5.551269531249972,
									36.038818359375085
								],
								[
									-5.62548828125,
									36.02592773437496
								],
								[
									-5.80839843749996,
									36.08833007812507
								],
								[
									-5.960693359374972,
									36.18173828125009
								],
								[
									-6.0406738281249375,
									36.18842773437501
								],
								[
									-6.170458984374989,
									36.333789062500074
								],
								[
									-6.226269531250011,
									36.42646484375001
								],
								[
									-6.265917968749989,
									36.52651367187508
								],
								[
									-6.257714843750023,
									36.564843749999966
								],
								[
									-6.268945312499994,
									36.596728515625074
								],
								[
									-6.38413085937492,
									36.63701171874993
								],
								[
									-6.412255859374966,
									36.72885742187509
								],
								[
									-6.328320312500011,
									36.84814453125006
								],
								[
									-6.259423828124994,
									36.8989746093751
								],
								[
									-6.216796875000028,
									36.91357421875006
								],
								[
									-6.320947265625023,
									36.90849609374999
								],
								[
									-6.396191406249983,
									36.83164062500006
								],
								[
									-6.492431640624943,
									36.954638671875074
								],
								[
									-6.88461914062492,
									37.19423828124994
								],
								[
									-6.859375000000028,
									37.24916992187494
								],
								[
									-6.863769531250028,
									37.27890625000006
								],
								[
									-6.929492187499989,
									37.21494140625006
								],
								[
									-6.97465820312496,
									37.1984375000001
								],
								[
									-7.174951171874994,
									37.208789062500074
								],
								[
									-7.4061523437499375,
									37.17944335937494
								],
								[
									-7.4671874999999375,
									37.42802734374996
								],
								[
									-7.4960449218749545,
									37.52358398437508
								],
								[
									-7.503515624999977,
									37.585498046875074
								],
								[
									-7.44394531249992,
									37.72827148437503
								],
								[
									-7.37890625,
									37.78637695312506
								],
								[
									-7.292236328125,
									37.9064453125001
								],
								[
									-7.185449218750023,
									38.006347656250114
								],
								[
									-7.072509765625,
									38.03002929687503
								],
								[
									-7.022851562500023,
									38.04472656250002
								],
								[
									-6.9811035156249375,
									38.12197265624994
								],
								[
									-6.95756835937496,
									38.18789062500005
								],
								[
									-6.974804687499983,
									38.19443359375006
								],
								[
									-7.106396484374983,
									38.18100585937498
								],
								[
									-7.343017578124972,
									38.45742187500008
								],
								[
									-7.335791015625006,
									38.501464843750085
								],
								[
									-7.30595703124996,
									38.56684570312498
								],
								[
									-7.286376953124972,
									38.64936523437501
								],
								[
									-7.28154296874996,
									38.71455078125004
								],
								[
									-7.219921874999926,
									38.770507812500085
								],
								[
									-7.125488281249972,
									38.826953125000045
								],
								[
									-7.0460449218749375,
									38.9070312500001
								],
								[
									-7.006249999999994,
									38.98525390625005
								],
								[
									-6.997949218749994,
									39.056445312500074
								],
								[
									-7.042968749999943,
									39.107080078124994
								],
								[
									-7.172412109374932,
									39.135205078124955
								],
								[
									-7.30576171874992,
									39.338134765625085
								],
								[
									-7.335449218750028,
									39.46513671874993
								],
								[
									-7.362695312499966,
									39.478320312500045
								],
								[
									-7.445117187499989,
									39.53618164062493
								],
								[
									-7.524218749999932,
									39.644726562499926
								],
								[
									-7.53569335937496,
									39.66157226562498
								],
								[
									-7.454101562499943,
									39.68066406250006
								],
								[
									-7.117675781249972,
									39.681689453125074
								],
								[
									-7.04741210937496,
									39.70556640624997
								],
								[
									-7.036718750000006,
									39.71396484375009
								],
								[
									-6.975390624999932,
									39.798388671875045
								],
								[
									-6.911181640624989,
									39.93710937500006
								],
								[
									-6.896093749999949,
									40.02182617187509
								],
								[
									-6.916406249999994,
									40.056835937499955
								],
								[
									-7.027832031249972,
									40.14262695312493
								],
								[
									-7.032617187499966,
									40.16791992187501
								],
								[
									-7.01469726562496,
									40.20834960937509
								],
								[
									-6.9484374999999545,
									40.25161132812502
								],
								[
									-6.85888671875,
									40.30073242187507
								],
								[
									-6.810156249999949,
									40.343115234375006
								],
								[
									-6.82177734375,
									40.37626953125002
								],
								[
									-6.847949218749989,
									40.41098632812498
								],
								[
									-6.852050781249943,
									40.44326171875008
								],
								[
									-6.835693359375,
									40.48315429687494
								],
								[
									-6.829833984374943,
									40.619091796874926
								],
								[
									-6.818359375,
									40.65405273437494
								],
								[
									-6.835888671874926,
									40.77749023437505
								],
								[
									-6.857714843749932,
									40.87832031250008
								],
								[
									-6.928466796874972,
									41.00913085937498
								],
								[
									-6.91552734375,
									41.03803710937501
								],
								[
									-6.8828125,
									41.062402343749994
								],
								[
									-6.7757812499999375,
									41.10771484374999
								],
								[
									-6.690136718750011,
									41.21450195312508
								],
								[
									-6.56591796875,
									41.30371093750006
								],
								[
									-6.40312499999996,
									41.375390624999994
								],
								[
									-6.28935546874996,
									41.45502929687504
								],
								[
									-6.2443359374999545,
									41.51591796874993
								],
								[
									-6.212499999999949,
									41.53203124999993
								],
								[
									-6.221679687499943,
									41.56044921875002
								],
								[
									-6.2431152343749545,
									41.60180664062503
								],
								[
									-6.3080566406249545,
									41.64218750000009
								],
								[
									-6.391699218749949,
									41.665380859375006
								],
								[
									-6.48466796874996,
									41.66440429687506
								],
								[
									-6.5421874999999545,
									41.67250976562505
								],
								[
									-6.558984375000023,
									41.70405273437498
								],
								[
									-6.552587890624949,
									41.789550781250085
								],
								[
									-6.557519531249994,
									41.87412109375009
								],
								[
									-6.575341796874966,
									41.91308593750003
								],
								[
									-6.61826171874992,
									41.94238281250003
								],
								[
									-6.70361328125,
									41.93457031250006
								],
								[
									-6.777294921874983,
									41.95849609374994
								],
								[
									-6.833203124999926,
									41.964160156250045
								],
								[
									-6.865527343749932,
									41.94526367187501
								],
								[
									-7.0304687499999545,
									41.95063476562504
								],
								[
									-7.09912109375,
									41.964208984375034
								],
								[
									-7.147119140625023,
									41.98115234375004
								],
								[
									-7.177929687499983,
									41.97167968749997
								],
								[
									-7.195361328124989,
									41.955224609374994
								],
								[
									-7.198339843749977,
									41.92939453125007
								],
								[
									-7.209619140624966,
									41.89526367187494
								],
								[
									-7.268554687499972,
									41.864404296874966
								],
								[
									-7.40361328124996,
									41.833691406249926
								],
								[
									-7.512597656249966,
									41.835986328125045
								],
								[
									-7.612597656249989,
									41.857958984375074
								],
								[
									-7.644677734374966,
									41.873974609374955
								],
								[
									-7.6930664062499545,
									41.888476562500074
								],
								[
									-7.896386718749994,
									41.87055664062507
								],
								[
									-7.920849609374983,
									41.88364257812498
								],
								[
									-7.990966796874972,
									41.85190429687509
								],
								[
									-8.094433593749926,
									41.81420898437503
								],
								[
									-8.152490234374937,
									41.81196289062504
								],
								[
									-8.173535156249955,
									41.819970703124966
								],
								[
									-8.18124999999992,
									41.836962890625045
								],
								[
									-8.224755859374994,
									41.89584960937498
								],
								[
									-8.213330078124983,
									41.92709960937495
								],
								[
									-8.129980468749977,
									42.01816406250012
								],
								[
									-8.139306640624994,
									42.03994140625002
								],
								[
									-8.173583984374972,
									42.069384765625074
								],
								[
									-8.204199218749977,
									42.11186523437493
								],
								[
									-8.213085937499926,
									42.13369140624994
								],
								[
									-8.266064453124983,
									42.13740234374998
								],
								[
									-8.322558593749932,
									42.11508789062506
								],
								[
									-8.538085937499972,
									42.06933593749997
								],
								[
									-8.589648437499989,
									42.05273437500006
								],
								[
									-8.68295898437492,
									42.00849609375001
								],
								[
									-8.777148437500017,
									41.94106445312505
								],
								[
									-8.85234374999996,
									41.926904296874994
								],
								[
									-8.878320312500023,
									41.94687499999998
								],
								[
									-8.887207031249972,
									42.1052734375001
								],
								[
									-8.772460937499943,
									42.210595703124966
								],
								[
									-8.690917968749943,
									42.27416992187506
								],
								[
									-8.729199218749926,
									42.287011718749994
								],
								[
									-8.815820312499994,
									42.28525390625009
								],
								[
									-8.809960937499937,
									42.334472656250085
								],
								[
									-8.769384765624949,
									42.358154296875114
								],
								[
									-8.730029296874989,
									42.41171875000009
								],
								[
									-8.776171874999989,
									42.434814453125
								],
								[
									-8.812109374999949,
									42.47006835937506
								],
								[
									-8.80991210937492,
									42.562353515625034
								],
								[
									-8.799902343749949,
									42.599902343750045
								],
								[
									-8.8115234375,
									42.64033203125004
								],
								[
									-8.987792968750028,
									42.5856445312501
								],
								[
									-9.033105468750023,
									42.59384765624998
								],
								[
									-9.035058593749966,
									42.662353515625085
								],
								[
									-8.937207031249926,
									42.76669921875012
								],
								[
									-8.927197265624926,
									42.79858398437494
								],
								[
									-9.041601562499977,
									42.814013671875074
								],
								[
									-9.127197265625,
									42.86523437500003
								],
								[
									-9.179443359375,
									42.91098632812512
								],
								[
									-9.235205078124977,
									42.97690429687495
								],
								[
									-9.235644531249989,
									43.03579101562505
								],
								[
									-9.178076171874977,
									43.174023437499955
								],
								[
									-9.095556640624949,
									43.21420898437498
								],
								[
									-9.024511718749949,
									43.238964843749955
								],
								[
									-8.873681640624966,
									43.334423828124955
								],
								[
									-8.665624999999949,
									43.31660156250004
								],
								[
									-8.537060546874955,
									43.33706054687505
								],
								[
									-8.421582031249955,
									43.38583984374995
								],
								[
									-8.35546875,
									43.39682617187506
								],
								[
									-8.248925781249966,
									43.43940429687501
								],
								[
									-8.25229492187492,
									43.49692382812512
								],
								[
									-8.288867187500017,
									43.5395996093751
								],
								[
									-8.256738281249937,
									43.579882812500045
								],
								[
									-8.137158203124926,
									43.62905273437494
								],
								[
									-8.004687499999932,
									43.69438476562502
								],
								[
									-7.852734374999983,
									43.7069824218751
								],
								[
									-7.698144531250023,
									43.76455078125011
								],
								[
									-7.594580078124949,
									43.727343750000074
								],
								[
									-7.503613281249983,
									43.73994140625007
								],
								[
									-7.399316406249966,
									43.69580078124994
								],
								[
									-7.261962890624972,
									43.59462890624994
								],
								[
									-7.0609863281249545,
									43.553955078125
								],
								[
									-6.900683593749989,
									43.58564453125007
								],
								[
									-6.617285156249977,
									43.59238281250009
								],
								[
									-6.47568359374992,
									43.57890624999993
								],
								[
									-6.22412109375,
									43.60385742187495
								],
								[
									-6.080126953124989,
									43.5949218750001
								],
								[
									-5.846679687499943,
									43.6450683593751
								],
								[
									-5.66582031249996,
									43.58247070312504
								],
								[
									-5.31572265624996,
									43.553173828124926
								],
								[
									-5.10527343749996,
									43.50185546875005
								],
								[
									-4.52304687499992,
									43.4157226562501
								],
								[
									-4.312792968749989,
									43.41474609375007
								],
								[
									-4.0153320312499545,
									43.46308593750004
								],
								[
									-3.889355468749983,
									43.499414062499994
								],
								[
									-3.7740234374999204,
									43.477880859375034
								],
								[
									-3.604638671874966,
									43.5194824218751
								],
								[
									-3.523632812499983,
									43.51103515624996
								],
								[
									-3.4178710937500227,
									43.451708984375045
								],
								[
									-3.045605468749926,
									43.37158203124997
								],
								[
									-2.947705078124983,
									43.439697265625085
								],
								[
									-2.875048828125017,
									43.45444335937498
								],
								[
									-2.6070800781249375,
									43.41274414062511
								],
								[
									-2.337109374999926,
									43.32802734375008
								],
								[
									-2.1966796874999943,
									43.32192382812508
								],
								[
									-1.9913085937500057,
									43.34506835937509
								],
								[
									-1.828515624999966,
									43.40083007812498
								],
								[
									-1.7940429687499488,
									43.40732421875006
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "ESP",
					"su_a3": "ESP",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "ESP",
					"gu_a3": "ESP",
					"abbrev": "Sp.",
					"region_un": "Europe",
					"adm0_a3_us": "ESP",
					"scalerank": 1,
					"pop_est": 40525002,
					"adm0_dif": 0,
					"un_a3": "724",
					"pop_year": -99,
					"gdp_md_est": 1403000,
					"name": "Spain",
					"sovereignt": "Spain",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 3,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Spain",
					"postal": "E",
					"sov_a3": "ESP",
					"note_brk": "",
					"brk_a3": "ESP",
					"wb_a2": "ES",
					"brk_diff": 0,
					"admin": "Spain",
					"name_long": "Spain",
					"iso_a3": "ESP",
					"iso_a2": "ES",
					"adm0_a3_is": "ESP",
					"level": 2,
					"formal_en": "Kingdom of Spain",
					"name_len": 5,
					"mapcolor7": 4,
					"long_len": 5,
					"mapcolor8": 5,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "724",
					"homepart": 1,
					"subunit": "Spain",
					"name_alt": "",
					"brk_name": "Spain",
					"name_sort": "Spain",
					"continent": "Europe",
					"mapcolor13": 5,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									22.61738281250004,
									58.62124023437505
								],
								[
									22.688378906250023,
									58.59702148437509
								],
								[
									22.753808593750023,
									58.60468749999998
								],
								[
									22.820117187500045,
									58.62153320312504
								],
								[
									22.964257812499994,
									58.605712890625085
								],
								[
									23.29287109375008,
									58.48349609374998
								],
								[
									23.323242187500057,
									58.45083007812508
								],
								[
									23.127148437500068,
									58.43598632812498
								],
								[
									23.082617187500063,
									58.398486328125074
								],
								[
									23.035449218750045,
									58.37231445312497
								],
								[
									22.97988281250008,
									58.36386718749995
								],
								[
									22.88515625000005,
									58.31127929687497
								],
								[
									22.757031250000068,
									58.26088867187502
								],
								[
									22.730273437500045,
									58.23066406249998
								],
								[
									22.49843750000005,
									58.236230468749966
								],
								[
									22.371679687499977,
									58.21713867187498
								],
								[
									22.269335937500017,
									58.16074218749995
								],
								[
									22.227343750000074,
									58.05180664062496
								],
								[
									22.152441406250006,
									57.96679687500006
								],
								[
									22.076269531250034,
									57.93603515625
								],
								[
									21.996875000000017,
									57.93134765625004
								],
								[
									21.97802734375,
									57.96328125000005
								],
								[
									21.98554687500001,
									57.995166015625074
								],
								[
									22.152929687500006,
									58.115332031250034
								],
								[
									22.187695312500068,
									58.154345703125074
								],
								[
									22.10439453125008,
									58.17167968749996
								],
								[
									22.03457031250005,
									58.213378906250114
								],
								[
									21.88212890624999,
									58.26235351562505
								],
								[
									21.854492187500057,
									58.301660156249966
								],
								[
									21.891015625000023,
									58.30458984375002
								],
								[
									21.924414062500006,
									58.31586914062501
								],
								[
									21.96503906250001,
									58.34882812499998
								],
								[
									21.984082031250068,
									58.38666992187507
								],
								[
									21.86230468750003,
									58.497167968750006
								],
								[
									21.924414062500006,
									58.514257812500034
								],
								[
									22.00185546875005,
									58.510253906250114
								],
								[
									22.081347656250074,
									58.47812499999995
								],
								[
									22.168554687500006,
									58.51582031250007
								],
								[
									22.20556640624997,
									58.521386718749966
								],
								[
									22.26660156249997,
									58.507958984374994
								],
								[
									22.328125,
									58.5808593750001
								],
								[
									22.474414062500045,
									58.60488281250002
								],
								[
									22.546972656250006,
									58.62739257812498
								],
								[
									22.61738281250004,
									58.62124023437505
								]
							]
						],
						[
							[
								[
									23.343554687500017,
									58.5503417968751
								],
								[
									23.260351562500034,
									58.53999023437504
								],
								[
									23.063476562500057,
									58.61108398437494
								],
								[
									23.10908203125001,
									58.65922851562499
								],
								[
									23.16542968750005,
									58.67812500000002
								],
								[
									23.332812500000045,
									58.64858398437505
								],
								[
									23.356445312500057,
									58.57553710937509
								],
								[
									23.343554687500017,
									58.5503417968751
								]
							]
						],
						[
							[
								[
									22.923730468750023,
									58.82690429687503
								],
								[
									22.84169921875008,
									58.777441406250006
								],
								[
									22.79287109375008,
									58.79721679687495
								],
								[
									22.76728515625001,
									58.82089843749998
								],
								[
									22.661425781250045,
									58.709179687499955
								],
								[
									22.542187499999983,
									58.689990234375045
								],
								[
									22.47265625000003,
									58.71206054687508
								],
								[
									22.47890625000008,
									58.75380859375008
								],
								[
									22.411035156250023,
									58.863378906250006
								],
								[
									22.307421875000045,
									58.89545898437507
								],
								[
									22.161914062500074,
									58.898486328125045
								],
								[
									22.056250000000034,
									58.943603515625114
								],
								[
									22.46259765625004,
									58.97431640625004
								],
								[
									22.504589843750068,
									59.02646484375012
								],
								[
									22.587207031250017,
									59.08120117187508
								],
								[
									22.6494140625,
									59.08710937500004
								],
								[
									22.702246093750006,
									59.074414062499926
								],
								[
									22.71220703124999,
									59.031982421875085
								],
								[
									22.725488281250023,
									59.015087890624926
								],
								[
									22.90986328125004,
									58.99121093749994
								],
								[
									22.981640624999983,
									58.919824218749966
								],
								[
									23.008691406249994,
									58.83393554687504
								],
								[
									22.923730468750023,
									58.82690429687503
								]
							]
						],
						[
							[
								[
									28.012500000000045,
									59.48427734374994
								],
								[
									28.06582031250008,
									59.453173828125074
								],
								[
									28.133007812499983,
									59.403076171875
								],
								[
									28.15107421875004,
									59.37441406249994
								],
								[
									28.128320312500023,
									59.357568359374966
								],
								[
									28.061328125000045,
									59.343261718750085
								],
								[
									28.04609375000004,
									59.327832031249955
								],
								[
									28.016406250000045,
									59.301708984374955
								],
								[
									27.93818359375001,
									59.29702148437508
								],
								[
									27.89765625000001,
									59.27763671875013
								],
								[
									27.84951171875005,
									59.192675781250045
								],
								[
									27.757617187500074,
									59.05200195312506
								],
								[
									27.668854749312345,
									58.9820640435249
								],
								[
									27.523730468750045,
									59.006933593750034
								],
								[
									27.29814453124999,
									58.99492187499999
								],
								[
									27.107324218750023,
									58.954199218750034
								],
								[
									26.974121093750057,
									58.88427734375
								],
								[
									26.966406250000006,
									58.80556640625005
								],
								[
									27.156738281250057,
									58.64794921875
								],
								[
									27.236621093750074,
									58.452246093750006
								],
								[
									27.32392578125001,
									58.40190429687496
								],
								[
									27.42548828125001,
									58.303076171875006
								],
								[
									27.47265625000003,
									58.21674804687498
								],
								[
									27.49707031250003,
									58.18413085937502
								],
								[
									27.62382812499999,
									58.014257812500034
								],
								[
									27.643057672481802,
									58.01575689012634
								],
								[
									27.644140625000063,
									58.01391601562497
								],
								[
									27.673437499999977,
									57.934619140625074
								],
								[
									27.721972656250017,
									57.9054687500001
								],
								[
									27.76875000000004,
									57.88413085937509
								],
								[
									27.778515625000068,
									57.87070312500012
								],
								[
									27.776953125000034,
									57.85673828125002
								],
								[
									27.75283203125008,
									57.84101562500001
								],
								[
									27.542089843750034,
									57.79941406250006
								],
								[
									27.514746093749977,
									57.76420898437499
								],
								[
									27.491992187500045,
									57.72495117187509
								],
								[
									27.400000000000063,
									57.666796875000045
								],
								[
									27.371777343749983,
									57.612548828125
								],
								[
									27.354296875000074,
									57.55029296875003
								],
								[
									27.351953125000023,
									57.528125000000045
								],
								[
									27.326562500000023,
									57.525488281250034
								],
								[
									27.187109375000034,
									57.538330078125085
								],
								[
									27.033398437500068,
									57.57875976562505
								],
								[
									26.96601562500001,
									57.609130859375114
								],
								[
									26.899804687500023,
									57.60878906250005
								],
								[
									26.81972656250005,
									57.588720703125034
								],
								[
									26.532617187499994,
									57.531005859375
								],
								[
									26.46210937500004,
									57.54448242187499
								],
								[
									26.29804687500001,
									57.60107421874997
								],
								[
									26.21503906250004,
									57.66274414062502
								],
								[
									26.030371093750006,
									57.78554687500008
								],
								[
									26.015234375000034,
									57.81474609374999
								],
								[
									25.99111328125008,
									57.83818359374996
								],
								[
									25.793750000000017,
									57.86855468750002
								],
								[
									25.72089843750001,
									57.913818359375085
								],
								[
									25.66015624999997,
									57.92016601562497
								],
								[
									25.5712890625,
									57.94277343750005
								],
								[
									25.34003906250004,
									58.03945312500002
								],
								[
									25.28261718750008,
									58.048486328124994
								],
								[
									25.268652343750063,
									58.03222656249997
								],
								[
									25.27265625000001,
									58.00937500000012
								],
								[
									25.25830078125,
									57.99614257812499
								],
								[
									25.22871093750001,
									57.996582031250085
								],
								[
									25.17519531250005,
									58.03212890625005
								],
								[
									25.11103515625001,
									58.06342773437501
								],
								[
									24.91132812500001,
									58.00458984375004
								],
								[
									24.83906250000004,
									57.98872070312507
								],
								[
									24.775781250000023,
									57.985253906249994
								],
								[
									24.458886718750023,
									57.90786132812505
								],
								[
									24.36250000000004,
									57.86616210937498
								],
								[
									24.322558593750074,
									57.87060546875
								],
								[
									24.33203125000003,
									57.90976562499998
								],
								[
									24.46386718749997,
									58.10595703125006
								],
								[
									24.48750000000001,
									58.26162109375008
								],
								[
									24.535742187500063,
									58.28300781249999
								],
								[
									24.54970703125005,
									58.30458984375002
								],
								[
									24.529101562500045,
									58.35424804687494
								],
								[
									24.392187500000034,
									58.386083984375034
								],
								[
									24.336914062500057,
									58.38139648437496
								],
								[
									24.287207031250063,
									58.32802734375002
								],
								[
									24.235644531250017,
									58.289550781250085
								],
								[
									24.114843750000034,
									58.266113281250114
								],
								[
									24.010937499999983,
									58.306640625000085
								],
								[
									23.767578125000057,
									58.36083984374994
								],
								[
									23.706054687500057,
									58.433007812499994
								],
								[
									23.691503906250006,
									58.50561523437506
								],
								[
									23.56279296874999,
									58.575830078124966
								],
								[
									23.50927734375003,
									58.658544921875034
								],
								[
									23.530664062500023,
									58.71625976562507
								],
								[
									23.64746093750003,
									58.75415039062506
								],
								[
									23.680761718750063,
									58.7871582031251
								],
								[
									23.533593749999994,
									58.78193359375004
								],
								[
									23.50361328125001,
									58.789843750000045
								],
								[
									23.497167968750034,
									58.819531249999955
								],
								[
									23.432031249999994,
									58.92065429687506
								],
								[
									23.489648437500023,
									58.96049804687499
								],
								[
									23.51503906250005,
									58.99921875000007
								],
								[
									23.4677734375,
									59.03217773437504
								],
								[
									23.48017578125004,
									59.069677734375034
								],
								[
									23.51699218750008,
									59.10756835937494
								],
								[
									23.494433593750017,
									59.195654296875034
								],
								[
									23.640527343750023,
									59.24233398437494
								],
								[
									23.78251953124999,
									59.27514648437497
								],
								[
									24.083398437500023,
									59.29189453125008
								],
								[
									24.05361328125008,
									59.37231445312506
								],
								[
									24.175390625000006,
									59.37592773437498
								],
								[
									24.38037109375003,
									59.47265624999997
								],
								[
									24.583593750000034,
									59.45566406249998
								],
								[
									24.877539062500063,
									59.522070312500006
								],
								[
									25.44375000000005,
									59.521142578124994
								],
								[
									25.520898437500023,
									59.55947265625008
								],
								[
									25.507421875000034,
									59.59799804687509
								],
								[
									25.50927734374997,
									59.63901367187512
								],
								[
									25.61572265625,
									59.62753906250009
								],
								[
									25.793750000000017,
									59.63466796874994
								],
								[
									26.460839843750023,
									59.55390625000001
								],
								[
									26.625,
									59.55390625000001
								],
								[
									26.85205078124997,
									59.47177734375006
								],
								[
									26.974707031250006,
									59.450634765624926
								],
								[
									27.33583984375005,
									59.45048828124999
								],
								[
									27.89257812500003,
									59.414208984374966
								],
								[
									28.001855468750023,
									59.46982421875009
								],
								[
									28.012500000000045,
									59.48427734374994
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "EST",
					"su_a3": "EST",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "EST",
					"gu_a3": "EST",
					"abbrev": "Est.",
					"region_un": "Europe",
					"adm0_a3_us": "EST",
					"scalerank": 1,
					"pop_est": 1299371,
					"adm0_dif": 0,
					"un_a3": "233",
					"pop_year": -99,
					"gdp_md_est": 27410,
					"name": "Estonia",
					"sovereignt": "Estonia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Estonia",
					"postal": "EST",
					"sov_a3": "EST",
					"note_brk": "",
					"brk_a3": "EST",
					"wb_a2": "EE",
					"brk_diff": 0,
					"admin": "Estonia",
					"name_long": "Estonia",
					"iso_a3": "EST",
					"iso_a2": "EE",
					"adm0_a3_is": "EST",
					"level": 2,
					"formal_en": "Republic of Estonia",
					"name_len": 7,
					"mapcolor7": 3,
					"long_len": 7,
					"mapcolor8": 2,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "233",
					"homepart": 1,
					"subunit": "Estonia",
					"name_alt": "",
					"brk_name": "Estonia",
					"name_sort": "Estonia",
					"continent": "Europe",
					"mapcolor13": 10,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2000
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									21.62832031250008,
									60.107812499999966
								],
								[
									21.540625000000063,
									60.097900390625085
								],
								[
									21.48603515625004,
									60.126806640625006
								],
								[
									21.50673828125008,
									60.14833984375005
								],
								[
									21.567968750000034,
									60.172314453124955
								],
								[
									21.63408203124999,
									60.16899414062499
								],
								[
									21.64814453125001,
									60.14086914062494
								],
								[
									21.62832031250008,
									60.107812499999966
								]
							]
						],
						[
							[
								[
									21.833203125000068,
									60.140527343749966
								],
								[
									21.73310546875001,
									60.10615234374998
								],
								[
									21.695019531250068,
									60.11435546875006
								],
								[
									21.70478515625001,
									60.172314453124955
								],
								[
									21.764257812500063,
									60.198828125000034
								],
								[
									21.864355468750006,
									60.20180664062502
								],
								[
									21.833203125000068,
									60.140527343749966
								]
							]
						],
						[
							[
								[
									22.17509765624999,
									60.370751953124966
								],
								[
									22.30175781250003,
									60.34755859375005
								],
								[
									22.354980468750057,
									60.35585937500005
								],
								[
									22.41552734375003,
									60.30336914062511
								],
								[
									22.312890624999994,
									60.269970703124955
								],
								[
									22.305761718750063,
									60.22856445312496
								],
								[
									22.346289062500063,
									60.202832031249955
								],
								[
									22.36054687500004,
									60.1655761718751
								],
								[
									22.25830078124997,
									60.16562500000009
								],
								[
									22.20937500000005,
									60.19697265625001
								],
								[
									22.188085937500063,
									60.23676757812504
								],
								[
									22.14052734375005,
									60.264892578125085
								],
								[
									22.07714843750003,
									60.28632812500001
								],
								[
									22.108203125000045,
									60.314892578124955
								],
								[
									22.125878906249994,
									60.35585937500005
								],
								[
									22.17509765624999,
									60.370751953124966
								]
							]
						],
						[
							[
								[
									21.994238281250006,
									60.33666992187506
								],
								[
									21.921484375000006,
									60.33227539062494
								],
								[
									21.818652343750017,
									60.381835937500085
								],
								[
									21.805664062500057,
									60.40122070312506
								],
								[
									21.845996093750017,
									60.412451171875034
								],
								[
									21.8193359375,
									60.45229492187505
								],
								[
									21.827246093750006,
									60.469921874999926
								],
								[
									21.906835937500063,
									60.4384765625
								],
								[
									21.950292968750034,
									60.40170898437498
								],
								[
									21.907812499999977,
									60.393164062500006
								],
								[
									21.97978515624999,
									60.355224609375
								],
								[
									21.994238281250006,
									60.33666992187506
								]
							]
						],
						[
							[
								[
									21.450878906250068,
									60.5295898437501
								],
								[
									21.43691406250005,
									60.48305664062494
								],
								[
									21.369042968749994,
									60.488232421874926
								],
								[
									21.300000000000068,
									60.479785156250074
								],
								[
									21.24433593750001,
									60.52597656249998
								],
								[
									21.214550781250068,
									60.60385742187495
								],
								[
									21.224707031250006,
									60.62060546875006
								],
								[
									21.26806640625003,
									60.638281250000034
								],
								[
									21.301269531250057,
									60.595556640625034
								],
								[
									21.450878906250068,
									60.5295898437501
								]
							]
						],
						[
							[
								[
									21.2177734375,
									63.241308593750006
								],
								[
									21.228515625000057,
									63.22265625000003
								],
								[
									21.287109375,
									63.227783203125
								],
								[
									21.366015625000017,
									63.261767578125074
								],
								[
									21.421972656250034,
									63.24589843749996
								],
								[
									21.415624999999977,
									63.19736328125012
								],
								[
									21.377636718750068,
									63.19921875000006
								],
								[
									21.36718749999997,
									63.20722656249998
								],
								[
									21.318457031250006,
									63.17949218750002
								],
								[
									21.30976562500001,
									63.16269531249998
								],
								[
									21.25341796874997,
									63.15200195312502
								],
								[
									21.149316406249994,
									63.199462890625
								],
								[
									21.08388671875008,
									63.277539062499926
								],
								[
									21.236328125000057,
									63.277734374999966
								],
								[
									21.221777343750034,
									63.25913085937509
								],
								[
									21.2177734375,
									63.241308593750006
								]
							]
						],
						[
							[
								[
									24.848242187500034,
									64.99101562500005
								],
								[
									24.69892578125001,
									64.9578125000001
								],
								[
									24.57861328125,
									64.97856445312499
								],
								[
									24.576562500000023,
									65.04287109375002
								],
								[
									24.651171875000045,
									65.07397460937497
								],
								[
									24.78603515625008,
									65.08642578124994
								],
								[
									24.970605468750023,
									65.055322265625
								],
								[
									24.99755859375,
									65.038720703125
								],
								[
									24.89179687500004,
									65.02626953124994
								],
								[
									24.848242187500034,
									64.99101562500005
								]
							]
						],
						[
							[
								[
									28.96582031250003,
									69.02197265625006
								],
								[
									28.89892578124997,
									69.00966796874994
								],
								[
									28.692187500000045,
									68.96103515624998
								],
								[
									28.566015625000006,
									68.92822265625003
								],
								[
									28.414062500000057,
									68.90415039062512
								],
								[
									28.453515625000023,
									68.87226562499993
								],
								[
									28.705957031250023,
									68.86552734375005
								],
								[
									28.74482421875004,
									68.85644531250009
								],
								[
									28.77285156250005,
									68.84003906249993
								],
								[
									28.777636718750045,
									68.813818359375
								],
								[
									28.752050781249977,
									68.77143554687498
								],
								[
									28.479296875000017,
									68.53764648437496
								],
								[
									28.470703125000057,
									68.48837890625006
								],
								[
									28.560156250000063,
									68.3513671875001
								],
								[
									28.685156250000034,
									68.18979492187498
								],
								[
									29.06298828125,
									68.11796874999999
								],
								[
									29.343847656250034,
									68.06186523437512
								],
								[
									29.52421874999999,
									67.92910156250005
								],
								[
									29.82158203124999,
									67.75400390625
								],
								[
									29.979199218750068,
									67.68857421875
								],
								[
									29.98808593749999,
									67.66826171875005
								],
								[
									29.94121093750016,
									67.54746093750003
								],
								[
									29.750585937500034,
									67.42641601562497
								],
								[
									29.572265625000114,
									67.32436523437497
								],
								[
									29.3876953125,
									67.20141601562506
								],
								[
									29.243359375000182,
									67.09658203125011
								],
								[
									29.087011718750006,
									66.970947265625
								],
								[
									29.06904296875001,
									66.93022460937496
								],
								[
									29.066210937500045,
									66.89174804687494
								],
								[
									29.093066406250017,
									66.84921874999998
								],
								[
									29.293261718750045,
									66.69550781249993
								],
								[
									29.37119140625009,
									66.61704101562509
								],
								[
									29.46435546875,
									66.53217773437495
								],
								[
									29.544335937500023,
									66.43969726562494
								],
								[
									29.590722656250136,
									66.35683593749994
								],
								[
									29.670898437499943,
									66.27612304687511
								],
								[
									29.720703125,
									66.23486328125006
								],
								[
									29.80351562500016,
									66.17705078124999
								],
								[
									29.90341796875009,
									66.09106445312497
								],
								[
									29.93662109375009,
									66.02294921875003
								],
								[
									30.08750000000009,
									65.78652343750002
								],
								[
									30.102734375000182,
									65.7262695312501
								],
								[
									30.09531250000009,
									65.68168945312507
								],
								[
									30.029003906250182,
									65.67070312499996
								],
								[
									29.88261718749999,
									65.66362304687502
								],
								[
									29.72392578124999,
									65.63437500000009
								],
								[
									29.71591796875009,
									65.62456054687505
								],
								[
									29.819433593750034,
									65.56874999999997
								],
								[
									29.728027343749943,
									65.4734375000001
								],
								[
									29.714843750000114,
									65.33696289062507
								],
								[
									29.617187500000114,
									65.26533203125007
								],
								[
									29.608007812500034,
									65.24868164062505
								],
								[
									29.612402343750034,
									65.23476562499997
								],
								[
									29.62968749999999,
									65.22387695312506
								],
								[
									29.810546875,
									65.20473632812497
								],
								[
									29.826171874999943,
									65.18530273437509
								],
								[
									29.826953125000045,
									65.14506835937499
								],
								[
									29.81083984375016,
									65.10791015625006
								],
								[
									29.72001953124999,
									65.08032226562494
								],
								[
									29.622460937500136,
									65.03950195312507
								],
								[
									29.60087890625016,
									65.00195312500006
								],
								[
									29.604199218750068,
									64.96840820312497
								],
								[
									29.63750000000016,
									64.91176757812497
								],
								[
									29.701660156250114,
									64.84575195312502
								],
								[
									29.783203125000114,
									64.80429687500009
								],
								[
									30.072851562500034,
									64.76503906250011
								],
								[
									30.110253906250136,
									64.73256835937497
								],
								[
									30.126171875000182,
									64.68808593750006
								],
								[
									30.1201171875,
									64.64462890625009
								],
								[
									29.98554687500001,
									64.55771484375006
								],
								[
									29.98662109375016,
									64.52426757812506
								],
								[
									30.041894531250136,
									64.44335937500003
								],
								[
									30.10810546875001,
									64.36611328125011
								],
								[
									30.390625000000114,
									64.28242187499993
								],
								[
									30.487890625000034,
									64.23652343749998
								],
								[
									30.51376953125009,
									64.2000000000001
								],
								[
									30.527929687500034,
									64.14111328125
								],
								[
									30.526074218750182,
									64.07729492187497
								],
								[
									30.503906250000114,
									64.02060546875006
								],
								[
									30.41533203124999,
									63.947509765625085
								],
								[
									30.21025390625016,
									63.80332031250009
								],
								[
									30.004101562500182,
									63.74731445312497
								],
								[
									29.99150390625016,
									63.73515624999999
								],
								[
									30.05537109375001,
									63.689013671875074
								],
								[
									30.418554687500034,
									63.50405273437505
								],
								[
									30.655273437499943,
									63.417480468750114
								],
								[
									30.97480468750001,
									63.300634765625006
								],
								[
									31.180859375000182,
									63.20830078125013
								],
								[
									31.247460937499966,
									63.1418945312501
								],
								[
									31.33671875000016,
									63.06806640625007
								],
								[
									31.437011718749943,
									63.00771484374994
								],
								[
									31.509277343750114,
									62.955322265625
								],
								[
									31.536523437499966,
									62.92163085937506
								],
								[
									31.53398437499999,
									62.885400390624966
								],
								[
									31.437304687500045,
									62.776123046875
								],
								[
									31.382421875000034,
									62.69165039062503
								],
								[
									31.285644531250114,
									62.567822265624926
								],
								[
									31.18671875000001,
									62.4813964843751
								],
								[
									30.935742187500182,
									62.323779296875045
								],
								[
									30.565625000000182,
									62.12758789062505
								],
								[
									30.479687500000068,
									62.06821289062512
								],
								[
									30.306445312500045,
									61.964843750000114
								],
								[
									30.00996093750001,
									61.75737304687502
								],
								[
									29.933203125000034,
									61.71157226562502
								],
								[
									29.690136718750068,
									61.54609375000007
								],
								[
									29.57939453125016,
									61.49345703124999
								],
								[
									29.492382812500182,
									61.444238281249994
								],
								[
									29.251660156250182,
									61.287792968749926
								],
								[
									28.992968750000045,
									61.16904296874998
								],
								[
									28.739062500000017,
									61.05874023437508
								],
								[
									28.662890625000045,
									61.00283203125005
								],
								[
									28.568164062500017,
									60.96020507812497
								],
								[
									28.455078125000057,
									60.91962890625007
								],
								[
									28.40742187500004,
									60.89692382812504
								],
								[
									28.151953125000034,
									60.745849609375
								],
								[
									27.797656250000074,
									60.5361328125
								],
								[
									27.761621093749994,
									60.53286132812505
								],
								[
									27.669335937500023,
									60.49897460937498
								],
								[
									27.52509765625004,
									60.490771484375074
								],
								[
									27.46240234374997,
									60.46484375000006
								],
								[
									27.241894531249983,
									60.53867187500006
								],
								[
									27.205273437499983,
									60.543457031250085
								],
								[
									27.07558593750005,
									60.525146484375085
								],
								[
									26.951171875,
									60.471484375000074
								],
								[
									26.721484375000017,
									60.455078125000085
								],
								[
									26.607421875000057,
									60.437695312499926
								],
								[
									26.53466796874997,
									60.41289062500013
								],
								[
									26.51972656250004,
									60.471582031249994
								],
								[
									26.55117187500005,
									60.54599609375006
								],
								[
									26.601757812500068,
									60.59560546875005
								],
								[
									26.60644531250003,
									60.62792968750006
								],
								[
									26.56933593750003,
									60.62456054687499
								],
								[
									26.49580078125004,
									60.551806640625074
								],
								[
									26.456445312500023,
									60.466796875
								],
								[
									26.377734375000074,
									60.424072265625
								],
								[
									26.204687499999977,
									60.40659179687509
								],
								[
									26.036035156249994,
									60.47490234374996
								],
								[
									25.955957031250023,
									60.474218750000006
								],
								[
									26.00625000000005,
									60.42529296875006
								],
								[
									26.040234375000068,
									60.37158203125006
								],
								[
									26.03583984375004,
									60.34150390625004
								],
								[
									25.945898437500034,
									60.34677734374998
								],
								[
									25.845800781250063,
									60.314599609374994
								],
								[
									25.75800781250001,
									60.26752929687507
								],
								[
									25.715429687500063,
									60.26743164062498
								],
								[
									25.65644531250004,
									60.333203124999955
								],
								[
									25.548242187500023,
									60.302490234375085
								],
								[
									25.45576171875001,
									60.26123046875003
								],
								[
									25.26787109374999,
									60.24833984374999
								],
								[
									25.155859375000006,
									60.19409179687503
								],
								[
									24.957617187500034,
									60.15747070312503
								],
								[
									24.848730468750063,
									60.15834960937505
								],
								[
									24.600488281250023,
									60.11425781249994
								],
								[
									24.51796875000008,
									60.04628906250005
								],
								[
									24.44560546874999,
									60.0212890625001
								],
								[
									24.342578125000045,
									60.04233398437495
								],
								[
									24.025195312500045,
									60.00917968749994
								],
								[
									23.721777343750063,
									59.965673828125034
								],
								[
									23.59267578125005,
									59.96816406249994
								],
								[
									23.46357421875004,
									59.986230468749966
								],
								[
									23.326757812500063,
									59.92578125
								],
								[
									23.181445312500017,
									59.844921874999955
								],
								[
									23.021289062500074,
									59.81601562500012
								],
								[
									22.96386718750003,
									59.8263671875001
								],
								[
									23.00976562500003,
									59.86879882812494
								],
								[
									23.115722656250057,
									59.912695312500006
								],
								[
									23.18847656250003,
									59.97221679687496
								],
								[
									23.19843750000001,
									60.021826171875034
								],
								[
									23.148437500000057,
									60.0413085937501
								],
								[
									23.080175781250006,
									60.047265624999966
								],
								[
									22.994140625000057,
									60.09853515624994
								],
								[
									22.911718750000063,
									60.20971679687494
								],
								[
									22.867089843750023,
									60.21582031249994
								],
								[
									22.84443359375001,
									60.186621093750034
								],
								[
									22.819140625000017,
									60.101367187500074
								],
								[
									22.79345703125003,
									60.07680664062505
								],
								[
									22.749804687500017,
									60.057275390624966
								],
								[
									22.697363281249977,
									60.03759765625006
								],
								[
									22.64619140625004,
									60.028027343749955
								],
								[
									22.462695312500045,
									60.02919921874994
								],
								[
									22.438574218750034,
									60.072265625
								],
								[
									22.438574218750034,
									60.09028320312504
								],
								[
									22.47109375000008,
									60.14697265624994
								],
								[
									22.442675781250074,
									60.15688476562511
								],
								[
									22.46972656249997,
									60.20131835937508
								],
								[
									22.51298828124999,
									60.198925781249955
								],
								[
									22.564257812500045,
									60.20551757812507
								],
								[
									22.589941406250034,
									60.228369140625006
								],
								[
									22.587988281250006,
									60.255664062500074
								],
								[
									22.516699218750034,
									60.26274414062499
								],
								[
									22.512304687500034,
									60.28134765625006
								],
								[
									22.57587890625001,
									60.35908203125007
								],
								[
									22.5849609375,
									60.380566406249926
								],
								[
									22.560351562500045,
									60.38500976562494
								],
								[
									22.52050781250003,
									60.376562500000006
								],
								[
									22.257910156249977,
									60.40092773437499
								],
								[
									21.93398437500008,
									60.50029296874999
								],
								[
									21.854296875000017,
									60.50541992187496
								],
								[
									21.805273437500063,
									60.59414062500011
								],
								[
									21.727148437500034,
									60.58291015624994
								],
								[
									21.61328125000003,
									60.530957031249926
								],
								[
									21.52783203125003,
									60.57041015625006
								],
								[
									21.436035156250057,
									60.596386718749926
								],
								[
									21.41064453125003,
									60.63696289062494
								],
								[
									21.411914062500045,
									60.69682617187496
								],
								[
									21.40400390625001,
									60.76743164062506
								],
								[
									21.378906250000057,
									60.85004882812501
								],
								[
									21.36054687500004,
									60.967480468749955
								],
								[
									21.37773437499999,
									61.059228515624994
								],
								[
									21.45097656249999,
									61.12714843750007
								],
								[
									21.479101562500034,
									61.170507812500006
								],
								[
									21.513476562500017,
									61.28120117187501
								],
								[
									21.52119140625001,
									61.41083984375004
								],
								[
									21.501757812500045,
									61.454980468749966
								],
								[
									21.506640625000045,
									61.4843261718751
								],
								[
									21.565039062500063,
									61.4843261718751
								],
								[
									21.552343750000034,
									61.50952148437497
								],
								[
									21.526660156250045,
									61.523291015625034
								],
								[
									21.49824218750004,
									61.55195312500001
								],
								[
									21.5224609375,
									61.567138671875085
								],
								[
									21.592382812500034,
									61.56821289062495
								],
								[
									21.598046875000023,
									61.57788085937506
								],
								[
									21.60595703125003,
									61.591552734375085
								],
								[
									21.551855468750034,
									61.66684570312506
								],
								[
									21.54560546875001,
									61.70273437500009
								],
								[
									21.470507812500074,
									61.81166992187508
								],
								[
									21.384863281250034,
									61.914941406249966
								],
								[
									21.255957031250063,
									61.98964843750008
								],
								[
									21.30166015625005,
									62.11264648437509
								],
								[
									21.353710937499983,
									62.223828124999926
								],
								[
									21.343359375000006,
									62.2773925781251
								],
								[
									21.32343750000004,
									62.34257812499996
								],
								[
									21.165625000000034,
									62.41406250000006
								],
								[
									21.142187500000063,
									62.514794921874966
								],
								[
									21.103613281250006,
									62.622949218749966
								],
								[
									21.118164062500057,
									62.689257812500074
								],
								[
									21.143847656250045,
									62.739990234375114
								],
								[
									21.19570312500005,
									62.79052734375
								],
								[
									21.45751953125,
									62.94999999999999
								],
								[
									21.47353515625005,
									63.03325195312499
								],
								[
									21.650976562500063,
									63.03930664062497
								],
								[
									21.568652343750074,
									63.11372070312504
								],
								[
									21.549218750000023,
									63.15551757812503
								],
								[
									21.545117187499983,
									63.204296874999926
								],
								[
									21.800390625000034,
									63.23769531250008
								],
								[
									21.89570312500001,
									63.21025390624999
								],
								[
									22.12031250000001,
									63.24414062500006
								],
								[
									22.31972656250005,
									63.310449218749966
								],
								[
									22.316210937500045,
									63.34565429687504
								],
								[
									22.285546875000023,
									63.37719726562497
								],
								[
									22.243261718750034,
									63.43793945312501
								],
								[
									22.273242187500017,
									63.45478515625007
								],
								[
									22.34599609374999,
									63.44238281250003
								],
								[
									22.312597656250034,
									63.47255859375005
								],
								[
									22.318652343750017,
									63.50439453125006
								],
								[
									22.398046875000034,
									63.491162109374926
								],
								[
									22.527636718750045,
									63.579980468749994
								],
								[
									22.532324218750034,
									63.647851562499966
								],
								[
									22.75625000000008,
									63.683349609375
								],
								[
									23.014453125000017,
									63.82182617187496
								],
								[
									23.133593750000045,
									63.864941406249955
								],
								[
									23.24873046875004,
									63.89614257812511
								],
								[
									23.493945312500017,
									64.03447265625013
								],
								[
									23.598925781250074,
									64.04091796875002
								],
								[
									23.652929687500063,
									64.13417968750011
								],
								[
									23.861425781250006,
									64.25825195312507
								],
								[
									23.92480468750003,
									64.27412109375001
								],
								[
									24.022265625000074,
									64.38598632812497
								],
								[
									24.27832031250003,
									64.51528320312494
								],
								[
									24.44062500000004,
									64.68012695312504
								],
								[
									24.53017578125008,
									64.73867187499997
								],
								[
									24.557910156250045,
									64.80102539062497
								],
								[
									24.657617187500023,
									64.80629882812508
								],
								[
									24.747558593750057,
									64.85209960937499
								],
								[
									24.94218749999999,
									64.884033203125
								],
								[
									25.134277343750057,
									64.87519531249998
								],
								[
									25.214257812499994,
									64.8534667968751
								],
								[
									25.288183593750063,
									64.86035156249997
								],
								[
									25.280761718750057,
									64.91640624999994
								],
								[
									25.228027343750057,
									64.95102539062498
								],
								[
									25.271093750000034,
									64.98427734375
								],
								[
									25.372656250000034,
									65.00947265624998
								],
								[
									25.362304687500057,
									65.06513671874995
								],
								[
									25.340234374999994,
									65.09863281249994
								],
								[
									25.25585937500003,
									65.14326171875007
								],
								[
									25.29785156249997,
									65.24321289062499
								],
								[
									25.307910156250074,
									65.35273437499993
								],
								[
									25.34785156250004,
									65.47924804687494
								],
								[
									25.241796875000006,
									65.54628906250011
								],
								[
									24.83935546875,
									65.66035156249998
								],
								[
									24.764257812499977,
									65.65639648437497
								],
								[
									24.674902343749977,
									65.67070312499996
								],
								[
									24.58154296874997,
									65.75712890625007
								],
								[
									24.62324218750004,
									65.83168945312508
								],
								[
									24.628027343750034,
									65.85917968749999
								],
								[
									24.591601562500074,
									65.85834960937507
								],
								[
									24.53261718750005,
									65.82202148437506
								],
								[
									24.40429687500003,
									65.78046875000001
								],
								[
									24.23750000000004,
									65.81235351562495
								],
								[
									24.15546875000004,
									65.80527343750009
								],
								[
									24.04902343750001,
									65.98984375000003
								],
								[
									23.994628906250057,
									66.06035156250002
								],
								[
									23.907324218750034,
									66.14824218749999
								],
								[
									23.75146484374997,
									66.19116210937494
								],
								[
									23.720996093750074,
									66.21542968750009
								],
								[
									23.700292968750034,
									66.25263671875004
								],
								[
									23.693554687499983,
									66.30429687499998
								],
								[
									23.673828125000057,
									66.380712890625
								],
								[
									23.68203125000005,
									66.44340820312499
								],
								[
									23.70117187500003,
									66.48076171874996
								],
								[
									23.768359375000045,
									66.50585937500011
								],
								[
									23.865527343750045,
									66.57661132812495
								],
								[
									23.885839843750006,
									66.62802734374995
								],
								[
									23.894140625000006,
									66.70688476562512
								],
								[
									23.93886718750005,
									66.77573242187509
								],
								[
									23.988574218750045,
									66.810546875
								],
								[
									23.97607421875,
									66.83823242187503
								],
								[
									23.941796875000023,
									66.87783203124994
								],
								[
									23.86933593750001,
									66.93403320312501
								],
								[
									23.75898437500001,
									67.00258789062505
								],
								[
									23.677343750000063,
									67.06811523437509
								],
								[
									23.64150390625005,
									67.12939453124994
								],
								[
									23.62304687500003,
									67.18413085937499
								],
								[
									23.626074218750006,
									67.23393554687502
								],
								[
									23.656640625000023,
									67.26782226562509
								],
								[
									23.76093750000004,
									67.31049804687498
								],
								[
									23.774902343750057,
									67.32861328124994
								],
								[
									23.733593750000068,
									67.42290039062496
								],
								[
									23.660839843749983,
									67.44003906250009
								],
								[
									23.537109375,
									67.44916992187498
								],
								[
									23.468066406250074,
									67.44995117187497
								],
								[
									23.454882812500045,
									67.4602539062501
								],
								[
									23.451464843750045,
									67.47919921874998
								],
								[
									23.465429687500063,
									67.51787109375005
								],
								[
									23.504492187500034,
									67.56215820312508
								],
								[
									23.53701171875008,
									67.59038085937507
								],
								[
									23.541308593750074,
									67.61430664062505
								],
								[
									23.50019531250004,
									67.69619140625005
								],
								[
									23.48779296875,
									67.79658203124998
								],
								[
									23.501855468750023,
									67.87519531250001
								],
								[
									23.632910156249977,
									67.933203125
								],
								[
									23.63886718750004,
									67.95439453125007
								],
								[
									23.474218749999977,
									68.01733398437509
								],
								[
									23.35546875000003,
									68.08867187500007
								],
								[
									23.318554687500068,
									68.13032226562501
								],
								[
									23.18251953125005,
									68.13662109375005
								],
								[
									23.09785156250004,
									68.25756835937511
								],
								[
									22.975390625000045,
									68.31645507812502
								],
								[
									22.854101562500034,
									68.367333984375
								],
								[
									22.78242187500001,
									68.39101562499994
								],
								[
									22.362109375000074,
									68.46406249999998
								],
								[
									22.195117187500074,
									68.47797851562507
								],
								[
									21.99746093750005,
									68.52060546874995
								],
								[
									21.850195312500063,
									68.57412109374994
								],
								[
									21.724023437500023,
									68.60854492187502
								],
								[
									21.616015625000045,
									68.65097656250003
								],
								[
									21.465429687500006,
									68.69067382812506
								],
								[
									21.42236328125003,
									68.72460937499994
								],
								[
									21.25976562500003,
									68.78745117187506
								],
								[
									21.183398437500017,
									68.82880859374995
								],
								[
									20.918554687500063,
									68.90693359375007
								],
								[
									20.908984375000074,
									68.93774414062494
								],
								[
									20.907031250000017,
									68.96748046874995
								],
								[
									20.895117187500006,
									68.97983398437506
								],
								[
									20.622167968749977,
									69.03686523437497
								],
								[
									20.675878906250006,
									69.06948242187505
								],
								[
									20.889257812500034,
									69.071435546875
								],
								[
									21.065722656250017,
									69.04174804687509
								],
								[
									21.10449218750003,
									69.054443359375
								],
								[
									21.12783203125008,
									69.08081054687503
								],
								[
									21.052636718750023,
									69.1865722656251
								],
								[
									21.06611328125001,
									69.21411132812503
								],
								[
									21.14375000000001,
									69.24726562500001
								],
								[
									21.26679687500004,
									69.27368164062509
								],
								[
									21.461230468750045,
									69.27749023437497
								],
								[
									21.59375000000003,
									69.27358398437497
								],
								[
									21.621777343750068,
									69.27070312500001
								],
								[
									21.81972656250008,
									69.15449218749995
								],
								[
									21.98945312500001,
									69.04111328124995
								],
								[
									22.079687500000006,
									68.99277343750003
								],
								[
									22.300390625000034,
									68.85585937500005
								],
								[
									22.382910156250063,
									68.77661132812497
								],
								[
									22.410937500000074,
									68.71987304687497
								],
								[
									22.500683593750068,
									68.72021484374994
								],
								[
									22.811035156250057,
									68.69531250000003
								],
								[
									23.07167968750005,
									68.67436523437502
								],
								[
									23.144335937500017,
									68.64257812500003
								],
								[
									23.324023437500017,
									68.64897460937499
								],
								[
									23.462500000000006,
									68.67763671874997
								],
								[
									23.70703124999997,
									68.71386718750006
								],
								[
									23.772558593750006,
									68.75839843750009
								],
								[
									23.85400390625,
									68.80590820312509
								],
								[
									23.997363281250074,
									68.79843749999998
								],
								[
									24.154101562500017,
									68.76088867187497
								],
								[
									24.33203125000003,
									68.71152343749995
								],
								[
									24.49052734374999,
									68.6886718750001
								],
								[
									24.703222656249977,
									68.65283203125006
								],
								[
									24.80244140625004,
									68.60649414062496
								],
								[
									24.94140625000003,
									68.59326171875011
								],
								[
									25.0869140625,
									68.63959960937495
								],
								[
									25.1728515625,
									68.76528320312505
								],
								[
									25.249121093750006,
									68.8213378906251
								],
								[
									25.357128906250068,
									68.86245117187497
								],
								[
									25.48085937500005,
									68.88061523437503
								],
								[
									25.575292968750006,
									68.88715820312501
								],
								[
									25.646679687499983,
									68.91914062500007
								],
								[
									25.748339843750017,
									68.99013671875005
								],
								[
									25.768164062500063,
									69.07612304687507
								],
								[
									25.748632812500063,
									69.2314453125
								],
								[
									25.767187500000034,
									69.28266601562495
								],
								[
									25.850195312500063,
									69.36650390625007
								],
								[
									25.961523437500006,
									69.58862304687503
								],
								[
									26.011523437500074,
									69.6526367187501
								],
								[
									26.07246093750004,
									69.69155273437494
								],
								[
									26.15615234375005,
									69.71469726562495
								],
								[
									26.308203125000034,
									69.78193359375007
								],
								[
									26.52539062500003,
									69.9150390625
								],
								[
									26.584277343750045,
									69.92631835937499
								],
								[
									26.74023437500003,
									69.93305664062504
								],
								[
									26.93427734375004,
									69.928125
								],
								[
									27.108691406250045,
									69.90468749999994
								],
								[
									27.127539062500063,
									69.90649414062494
								],
								[
									27.205664062499977,
									69.91870117187494
								],
								[
									27.34804687500005,
									69.96005859375012
								],
								[
									27.591699218750023,
									70.04223632812497
								],
								[
									27.747851562500045,
									70.06484374999997
								],
								[
									27.889941406250045,
									70.06166992187494
								],
								[
									28.047265625000023,
									69.97167968750009
								],
								[
									28.269140625000006,
									69.87143554687509
								],
								[
									28.411718750000034,
									69.82275390624994
								],
								[
									28.800390625000063,
									69.73149414062507
								],
								[
									29.14160156250003,
									69.67143554687502
								],
								[
									29.333398437500136,
									69.472998046875
								],
								[
									29.238867187500034,
									69.39394531250005
								],
								[
									29.19179687500005,
									69.36669921875003
								],
								[
									29.02490234374997,
									69.28798828124997
								],
								[
									28.846289062500006,
									69.176904296875
								],
								[
									28.832617187500063,
									69.118994140625
								],
								[
									28.891894531250045,
									69.0605957031251
								],
								[
									28.96582031250003,
									69.02197265625006
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "FIN",
					"su_a3": "FIN",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "FIN",
					"gu_a3": "FIN",
					"abbrev": "Fin.",
					"region_un": "Europe",
					"adm0_a3_us": "FIN",
					"scalerank": 1,
					"pop_est": 5250275,
					"adm0_dif": 1,
					"un_a3": "246",
					"pop_year": -99,
					"gdp_md_est": 193500,
					"name": "Finland",
					"sovereignt": "Finland",
					"economy": "2. Developed region: nonG7",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Finland",
					"postal": "FIN",
					"sov_a3": "FI1",
					"note_brk": "",
					"brk_a3": "FIN",
					"wb_a2": "FI",
					"brk_diff": 0,
					"admin": "Finland",
					"name_long": "Finland",
					"iso_a3": "FIN",
					"iso_a2": "FI",
					"adm0_a3_is": "FIN",
					"level": 2,
					"formal_en": "Republic of Finland",
					"name_len": 7,
					"mapcolor7": 4,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "246",
					"homepart": 1,
					"subunit": "Finland",
					"name_alt": "",
					"brk_name": "Finland",
					"name_sort": "Finland",
					"continent": "Europe",
					"mapcolor13": 6,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									55.797363281250114,
									-21.339355468750057
								],
								[
									55.656152343750136,
									-21.369042968750065
								],
								[
									55.55761718749994,
									-21.35830078125001
								],
								[
									55.362695312500136,
									-21.273632812499997
								],
								[
									55.310351562500045,
									-21.217382812500077
								],
								[
									55.232812500000136,
									-21.058398437500017
								],
								[
									55.25,
									-21.002441406249986
								],
								[
									55.31132812500016,
									-20.90410156250003
								],
								[
									55.45048828125016,
									-20.86513671875008
								],
								[
									55.59648437500016,
									-20.87958984375001
								],
								[
									55.66191406250016,
									-20.906250000000014
								],
								[
									55.739160156249966,
									-21.021484375000043
								],
								[
									55.83906250000018,
									-21.13857421875001
								],
								[
									55.82246093750018,
									-21.277832031250043
								],
								[
									55.797363281250114,
									-21.339355468750057
								]
							]
						],
						[
							[
								[
									45.180273437500034,
									-12.976757812500082
								],
								[
									45.117578125000136,
									-12.984960937499977
								],
								[
									45.08769531249999,
									-12.958496093749915
								],
								[
									45.06943359375009,
									-12.895605468750063
								],
								[
									45.088281250000136,
									-12.835058593749991
								],
								[
									45.093554687500045,
									-12.786132812499972
								],
								[
									45.042578125000034,
									-12.701269531249991
								],
								[
									45.092382812500034,
									-12.653027343750026
								],
								[
									45.134765625,
									-12.709179687499926
								],
								[
									45.15878906250009,
									-12.712988281249991
								],
								[
									45.22314453124994,
									-12.752148437500054
								],
								[
									45.20429687500001,
									-12.824316406249935
								],
								[
									45.208593750000034,
									-12.847949218750031
								],
								[
									45.17939453125001,
									-12.920214843749932
								],
								[
									45.180273437500034,
									-12.976757812500082
								]
							]
						],
						[
							[
								[
									-51.65253906249998,
									4.061279296875028
								],
								[
									-51.68344726562498,
									4.039697265625065
								],
								[
									-51.76708984374997,
									3.9926757812500853
								],
								[
									-51.805273437500034,
									3.9299316406250853
								],
								[
									-51.827490234375034,
									3.869580078125054
								],
								[
									-51.87949218749995,
									3.82856445312504
								],
								[
									-51.92890624999998,
									3.776953125000105
								],
								[
									-51.94433593750003,
									3.735107421875014
								],
								[
									-51.99062499999994,
									3.70200195312502
								],
								[
									-51.99951171874997,
									3.64687499999998
								],
								[
									-52.11611328125002,
									3.4522949218749517
								],
								[
									-52.16259765625,
									3.36469726562504
								],
								[
									-52.22944335937501,
									3.2716796875000966
								],
								[
									-52.271240234375,
									3.2371093749999886
								],
								[
									-52.327880859375,
									3.1817382812500767
								],
								[
									-52.35664062500001,
									3.117724609375003
								],
								[
									-52.35664062500001,
									3.051562500000017
								],
								[
									-52.39638671875002,
									2.972216796875017
								],
								[
									-52.41840820312498,
									2.9038574218750455
								],
								[
									-52.45585937499996,
									2.864160156250037
								],
								[
									-52.55468750000003,
									2.647656249999983
								],
								[
									-52.55947265625002,
									2.5731445312500796
								],
								[
									-52.58300781250003,
									2.528906249999949
								],
								[
									-52.653173828125006,
									2.425732421875068
								],
								[
									-52.70063476562501,
									2.363671875000037
								],
								[
									-52.78339843749998,
									2.317187500000074
								],
								[
									-52.87041015624996,
									2.2666503906249886
								],
								[
									-52.90346679687502,
									2.211523437499949
								],
								[
									-52.96484375,
									2.1835449218750256
								],
								[
									-53.00971679687501,
									2.181738281250091
								],
								[
									-53.08227539062503,
									2.201708984375074
								],
								[
									-53.180078124999966,
									2.2113281250000796
								],
								[
									-53.22978515624999,
									2.204882812500017
								],
								[
									-53.25219726562503,
									2.232275390625091
								],
								[
									-53.28549804687495,
									2.295214843749946
								],
								[
									-53.33442382812498,
									2.339746093750051
								],
								[
									-53.36601562500002,
									2.3242187500000853
								],
								[
									-53.43183593750001,
									2.2794433593750227
								],
								[
									-53.50898437500001,
									2.253125000000068
								],
								[
									-53.56396484375003,
									2.2619140625000824
								],
								[
									-53.683691406250006,
									2.2929199218750114
								],
								[
									-53.734716796875006,
									2.308544921874997
								],
								[
									-53.75014648437502,
									2.3350097656250597
								],
								[
									-53.76777343749998,
									2.354833984375105
								],
								[
									-53.79423828124996,
									2.3459960937499886
								],
								[
									-53.829541015624955,
									2.3129394531250966
								],
								[
									-53.87661132812494,
									2.27827148437504
								],
								[
									-53.946435546874966,
									2.2325683593750654
								],
								[
									-54.08974609375002,
									2.150488281249949
								],
								[
									-54.13007812499998,
									2.1210449218750824
								],
								[
									-54.16738281249994,
									2.1370605468750483
								],
								[
									-54.227978515624955,
									2.1533203125000853
								],
								[
									-54.29306640624998,
									2.1542480468750966
								],
								[
									-54.43310546875,
									2.2075195312501137
								],
								[
									-54.51508789062498,
									2.2454589843749346
								],
								[
									-54.55048828125001,
									2.293066406250034
								],
								[
									-54.59194335937502,
									2.313769531250088
								],
								[
									-54.61625976562499,
									2.3267578124999773
								],
								[
									-54.60473632812497,
									2.335791015625034
								],
								[
									-54.56840820312502,
									2.342578125000003
								],
								[
									-54.53593749999999,
									2.3433105468749744
								],
								[
									-54.48554687500001,
									2.4161132812500625
								],
								[
									-54.402001953124966,
									2.4615234375000767
								],
								[
									-54.25673828124994,
									2.713720703125034
								],
								[
									-54.19550781249998,
									2.8178710937501137
								],
								[
									-54.18808593749998,
									2.8748535156250767
								],
								[
									-54.17070312499999,
									2.9936035156250256
								],
								[
									-54.20312500000003,
									3.1381835937500853
								],
								[
									-54.18803710937499,
									3.178759765625003
								],
								[
									-54.063183593749955,
									3.3533203125000313
								],
								[
									-54.00957031249996,
									3.448535156250074
								],
								[
									-54.005957031250006,
									3.530517578125071
								],
								[
									-53.99047851562497,
									3.5895507812500256
								],
								[
									-54.00590820312499,
									3.620410156250088
								],
								[
									-54.03422851562499,
									3.6293945312499716
								],
								[
									-54.081982421874955,
									3.7059570312500227
								],
								[
									-54.11279296875003,
									3.7694335937500796
								],
								[
									-54.197460937499955,
									3.834423828124997
								],
								[
									-54.255517578124966,
									3.901074218750068
								],
								[
									-54.350732421874994,
									4.05410156250008
								],
								[
									-54.34213867187492,
									4.14003906250008
								],
								[
									-54.36914062500003,
									4.170947265624989
								],
								[
									-54.398388671874926,
									4.20249023437502
								],
								[
									-54.39624023437503,
									4.24140625000004
								],
								[
									-54.41601562499997,
									4.337646484375114
								],
								[
									-54.44067382812503,
									4.42802734374996
								],
								[
									-54.449609374999966,
									4.485009765625023
								],
								[
									-54.42607421874999,
									4.583007812500085
								],
								[
									-54.44023437500002,
									4.691992187500091
								],
								[
									-54.47114257812501,
									4.7493164062500455
								],
								[
									-54.47968749999998,
									4.836523437500048
								],
								[
									-54.47333984375001,
									4.91469726562508
								],
								[
									-54.44687499999995,
									4.958789062500088
								],
								[
									-54.45219726562496,
									5.013476562500031
								],
								[
									-54.33164062499992,
									5.187402343750037
								],
								[
									-54.240185546874955,
									5.288232421875051
								],
								[
									-54.15595703125001,
									5.358984375000077
								],
								[
									-54.085302734375006,
									5.411816406250011
								],
								[
									-53.98959960937498,
									5.676025390625014
								],
								[
									-53.91992187499997,
									5.76899414062504
								],
								[
									-53.84716796875,
									5.782226562500071
								],
								[
									-53.454443359375006,
									5.5634765625
								],
								[
									-53.27036132812498,
									5.54326171875006
								],
								[
									-52.899316406249966,
									5.425048828125043
								],
								[
									-52.76499023437498,
									5.273486328125074
								],
								[
									-52.453955078125006,
									5.021337890625034
								],
								[
									-52.29052734375003,
									4.942187500000074
								],
								[
									-52.28891601562498,
									4.876123046875037
								],
								[
									-52.324609374999966,
									4.770898437500094
								],
								[
									-52.21997070312494,
									4.862792968750071
								],
								[
									-52.05810546875003,
									4.717382812499935
								],
								[
									-52.012304687500006,
									4.645996093749957
								],
								[
									-51.96191406249997,
									4.514404296874972
								],
								[
									-51.97934570312495,
									4.429882812499983
								],
								[
									-52.001708984375,
									4.386230468749972
								],
								[
									-52.00292968749997,
									4.352294921874986
								],
								[
									-51.95478515625001,
									4.399072265625094
								],
								[
									-51.92768554687501,
									4.436132812500105
								],
								[
									-51.919580078124966,
									4.524316406250037
								],
								[
									-51.88027343750002,
									4.63374023437504
								],
								[
									-51.82753906250002,
									4.635693359375082
								],
								[
									-51.78564453125003,
									4.570507812500026
								],
								[
									-51.698632812499966,
									4.286816406249969
								],
								[
									-51.66582031249996,
									4.2288085937500455
								],
								[
									-51.653271484374955,
									4.138769531250006
								],
								[
									-51.658105468749966,
									4.0984863281250625
								],
								[
									-51.65253906249998,
									4.061279296875028
								]
							]
						],
						[
							[
								[
									-60.826269531250034,
									14.494482421874963
								],
								[
									-60.83662109375001,
									14.437402343750051
								],
								[
									-60.86210937499996,
									14.4262695312501
								],
								[
									-60.8994140625,
									14.473779296875009
								],
								[
									-61.063720703125,
									14.46708984375006
								],
								[
									-61.08886718749997,
									14.509570312500017
								],
								[
									-61.09033203125,
									14.529687500000023
								],
								[
									-61.01132812499998,
									14.601904296875091
								],
								[
									-61.10429687499999,
									14.621240234375023
								],
								[
									-61.14111328124994,
									14.652392578125074
								],
								[
									-61.21972656249997,
									14.80439453125004
								],
								[
									-61.21333007812501,
									14.848583984374983
								],
								[
									-61.180810546874966,
									14.871923828125034
								],
								[
									-61.12739257812498,
									14.875292968750088
								],
								[
									-61.027099609375,
									14.826171875000028
								],
								[
									-60.952539062499994,
									14.756250000000094
								],
								[
									-60.927148437499966,
									14.75517578124996
								],
								[
									-60.91865234375001,
									14.7353515625001
								],
								[
									-60.93369140624998,
									14.686181640624937
								],
								[
									-60.88916015624994,
									14.644531250000071
								],
								[
									-60.86997070312495,
									14.613720703125097
								],
								[
									-60.826269531250034,
									14.494482421874963
								]
							]
						],
						[
							[
								[
									-61.23046875000003,
									15.88994140625013
								],
								[
									-61.286230468750034,
									15.886035156250045
								],
								[
									-61.310742187499955,
									15.894677734374937
								],
								[
									-61.31840820312502,
									15.95488281250013
								],
								[
									-61.27529296875002,
									15.996240234375023
								],
								[
									-61.25000000000003,
									16.00629882812504
								],
								[
									-61.21235351562498,
									15.959912109375068
								],
								[
									-61.20341796874993,
									15.92124023437512
								],
								[
									-61.23046875000003,
									15.88994140625013
								]
							]
						],
						[
							[
								[
									-61.58955078125001,
									16.006933593749977
								],
								[
									-61.67045898437496,
									15.96206054687508
								],
								[
									-61.71025390624999,
									15.975927734375063
								],
								[
									-61.759423828124966,
									16.062060546875017
								],
								[
									-61.79409179687502,
									16.300976562499926
								],
								[
									-61.76713867187493,
									16.34047851562508
								],
								[
									-61.74804687499997,
									16.355273437500074
								],
								[
									-61.64150390625002,
									16.32597656249996
								],
								[
									-61.597021484375006,
									16.29218750000001
								],
								[
									-61.55234374999998,
									16.270898437500023
								],
								[
									-61.57504882812498,
									16.22714843750009
								],
								[
									-61.56386718750002,
									16.047753906250023
								],
								[
									-61.58955078125001,
									16.006933593749977
								]
							]
						],
						[
							[
								[
									-61.3271484375,
									16.23041992187504
								],
								[
									-61.44482421875,
									16.21928710937499
								],
								[
									-61.522167968749955,
									16.228027343750085
								],
								[
									-61.539990234374955,
									16.299609375000102
								],
								[
									-61.500585937500006,
									16.360205078125006
								],
								[
									-61.528906250000006,
									16.433789062499983
								],
								[
									-61.510644531249994,
									16.47768554687505
								],
								[
									-61.47119140624997,
									16.506640625000074
								],
								[
									-61.40644531250001,
									16.468310546875102
								],
								[
									-61.39614257812494,
									16.41342773437509
								],
								[
									-61.35546875,
									16.363183593749994
								],
								[
									-61.17260742187497,
									16.25610351562503
								],
								[
									-61.3271484375,
									16.23041992187504
								]
							]
						],
						[
							[
								[
									9.480371093750023,
									42.805419921875
								],
								[
									9.454199218750034,
									42.65859374999994
								],
								[
									9.473242187500006,
									42.61557617187506
								],
								[
									9.509374999999977,
									42.58559570312508
								],
								[
									9.526171875000017,
									42.55263671875002
								],
								[
									9.556445312500074,
									42.160937500000074
								],
								[
									9.550683593750051,
									42.12973632812512
								],
								[
									9.428417968750011,
									41.97241210937494
								],
								[
									9.40087890625,
									41.92622070312504
								],
								[
									9.394824218750017,
									41.731201171875
								],
								[
									9.374218750000068,
									41.67880859375009
								],
								[
									9.330859375000017,
									41.62714843750004
								],
								[
									9.253417968750057,
									41.460058593750006
								],
								[
									9.186132812500034,
									41.38491210937508
								],
								[
									9.003027343750034,
									41.4765625
								],
								[
									8.895019531250057,
									41.516162109375074
								],
								[
									8.842089843750017,
									41.558886718750074
								],
								[
									8.80751953125008,
									41.58837890625003
								],
								[
									8.829785156250011,
									41.62768554687506
								],
								[
									8.879003906249977,
									41.668554687500034
								],
								[
									8.886816406249977,
									41.70068359375
								],
								[
									8.77099609375,
									41.73710937499996
								],
								[
									8.71796875000004,
									41.76142578125004
								],
								[
									8.718652343749994,
									41.8040039062501
								],
								[
									8.75869140625008,
									41.870410156250045
								],
								[
									8.740429687500011,
									41.92514648437509
								],
								[
									8.673632812500074,
									41.92236328125006
								],
								[
									8.621875000000017,
									41.930712890625074
								],
								[
									8.615136718750051,
									41.95913085937508
								],
								[
									8.653417968750034,
									41.99555664062504
								],
								[
									8.702539062500023,
									42.04311523437505
								],
								[
									8.700976562500045,
									42.095605468749994
								],
								[
									8.641601562500028,
									42.118212890625074
								],
								[
									8.58779296875008,
									42.160839843749955
								],
								[
									8.566210937500045,
									42.218798828125045
								],
								[
									8.60791015625,
									42.25844726562505
								],
								[
									8.675488281250011,
									42.284033203125006
								],
								[
									8.625878906250023,
									42.34340820312494
								],
								[
									8.592382812500034,
									42.34472656249994
								],
								[
									8.565625000000011,
									42.35771484375002
								],
								[
									8.587500000000034,
									42.385302734375045
								],
								[
									8.64003906250008,
									42.4265625000001
								],
								[
									8.71308593750004,
									42.54975585937507
								],
								[
									8.814843750000051,
									42.60791015625
								],
								[
									8.994921875000074,
									42.645312500000074
								],
								[
									9.04365234375004,
									42.66166992187502
								],
								[
									9.08837890625,
									42.704980468749966
								],
								[
									9.137890625000068,
									42.73291015624997
								],
								[
									9.198046875000074,
									42.729199218749926
								],
								[
									9.253515625000006,
									42.712451171875074
								],
								[
									9.287695312500034,
									42.69462890624999
								],
								[
									9.313378906250023,
									42.713183593750045
								],
								[
									9.338378906250057,
									42.766894531250074
								],
								[
									9.323046875000045,
									42.81406250000009
								],
								[
									9.330957031250051,
									42.943798828124955
								],
								[
									9.363183593750051,
									43.01738281249993
								],
								[
									9.415234374999983,
									43.02148437499997
								],
								[
									9.463281249999994,
									42.981005859375074
								],
								[
									9.460839843750051,
									42.94521484375005
								],
								[
									9.478613281250034,
									42.86049804687502
								],
								[
									9.480371093750023,
									42.805419921875
								]
							]
						],
						[
							[
								[
									-1.1783203124999204,
									45.90405273437506
								],
								[
									-1.2135742187500114,
									45.8166015625001
								],
								[
									-1.2802734375,
									45.897119140624966
								],
								[
									-1.3687011718749886,
									45.96767578125005
								],
								[
									-1.388867187499926,
									46.03295898437503
								],
								[
									-1.3886718749999716,
									46.05039062500012
								],
								[
									-1.2850585937499943,
									46.002685546875085
								],
								[
									-1.1783203124999204,
									45.90405273437506
								]
							]
						],
						[
							[
								[
									5.789746093749983,
									49.53828125000007
								],
								[
									5.823437500000011,
									49.50507812500004
								],
								[
									5.9013671875,
									49.48974609375003
								],
								[
									5.928906250000011,
									49.47753906250003
								],
								[
									5.959472656250028,
									49.454638671875074
								],
								[
									6.01142578125004,
									49.44545898437505
								],
								[
									6.074121093750023,
									49.454638671875074
								],
								[
									6.119921875000017,
									49.48520507812509
								],
								[
									6.181054687500051,
									49.49892578125002
								],
								[
									6.242187500000057,
									49.49433593749998
								],
								[
									6.277343750000028,
									49.47753906250003
								],
								[
									6.344335937500006,
									49.45273437499995
								],
								[
									6.38222656250008,
									49.45815429687508
								],
								[
									6.458105468750006,
									49.44287109375006
								],
								[
									6.5342773437500625,
									49.39467773437502
								],
								[
									6.566308593750023,
									49.34619140625
								],
								[
									6.574707031250028,
									49.31967773437512
								],
								[
									6.607617187499983,
									49.290869140625006
								],
								[
									6.735449218750006,
									49.16059570312504
								],
								[
									6.776269531250051,
									49.154150390625034
								],
								[
									6.820703125000051,
									49.17392578125009
								],
								[
									6.849511718750051,
									49.20195312500002
								],
								[
									6.891210937500034,
									49.207519531250085
								],
								[
									6.958300781250017,
									49.194628906250045
								],
								[
									7.001464843750028,
									49.179882812499955
								],
								[
									7.022167968750068,
									49.12343750000011
								],
								[
									7.036718750000006,
									49.11269531250005
								],
								[
									7.0657226562500455,
									49.124853515625034
								],
								[
									7.117382812500011,
									49.12753906249995
								],
								[
									7.19990234375004,
									49.11362304687506
								],
								[
									7.313378906250051,
									49.12954101562511
								],
								[
									7.404199218749994,
									49.153076171875
								],
								[
									7.450585937500051,
									49.152197265625006
								],
								[
									7.525488281250034,
									49.08637695312501
								],
								[
									7.610937500000034,
									49.06176757812506
								],
								[
									7.799218750000023,
									49.04189453125008
								],
								[
									8.001269531250045,
									49.0109375000001
								],
								[
									8.080664062500063,
									48.98588867187496
								],
								[
									8.134863281250006,
									48.97358398437504
								],
								[
									8.14033203125004,
									48.88642578125004
								],
								[
									8.1240234375,
									48.87329101562503
								],
								[
									7.922753906250051,
									48.698535156250045
								],
								[
									7.837988281250006,
									48.6360351562501
								],
								[
									7.794824218749994,
									48.546826171874955
								],
								[
									7.76513671875,
									48.41000976562506
								],
								[
									7.705664062500034,
									48.28002929687506
								],
								[
									7.616601562500023,
									48.156787109375074
								],
								[
									7.584179687499983,
									48.06430664062506
								],
								[
									7.6084960937500625,
									48.00258789062511
								],
								[
									7.593261718750057,
									47.90566406250008
								],
								[
									7.538574218750028,
									47.7736328125001
								],
								[
									7.529394531250006,
									47.67387695312502
								],
								[
									7.5654296875,
									47.60654296875006
								],
								[
									7.615624999999994,
									47.5927246093751
								],
								[
									7.494921875000017,
									47.547363281250085
								],
								[
									7.467382812500006,
									47.50766601562509
								],
								[
									7.420019531250034,
									47.455175781250034
								],
								[
									7.343164062499994,
									47.433105468750085
								],
								[
									7.265722656250034,
									47.42578125
								],
								[
									7.203124999999972,
									47.43271484375009
								],
								[
									7.16748046875,
									47.453710937500006
								],
								[
									7.169238281250017,
									47.47324218750009
								],
								[
									7.136035156250074,
									47.48984375000009
								],
								[
									7.05341796875004,
									47.48935546875009
								],
								[
									6.968359375000034,
									47.45322265625009
								],
								[
									6.900390625000028,
									47.39423828125007
								],
								[
									6.9214843750000625,
									47.361230468749994
								],
								[
									6.98408203125004,
									47.3525390625
								],
								[
									7.000585937500034,
									47.339453125000006
								],
								[
									7.000585937500034,
									47.322509765625114
								],
								[
									6.978515625000057,
									47.30205078125002
								],
								[
									6.95205078125008,
									47.26718750000012
								],
								[
									6.820703125000051,
									47.16318359374998
								],
								[
									6.688085937500034,
									47.05825195312508
								],
								[
									6.66689453125008,
									47.02651367187502
								],
								[
									6.624804687500017,
									47.00434570312504
								],
								[
									6.456250000000068,
									46.94833984375009
								],
								[
									6.438574218750006,
									46.925878906250034
								],
								[
									6.429003906250017,
									46.83227539062497
								],
								[
									6.41015625,
									46.755419921875045
								],
								[
									6.285156250000028,
									46.68305664062504
								],
								[
									6.160742187499977,
									46.61103515625001
								],
								[
									6.1296875000000455,
									46.56699218750012
								],
								[
									6.1070312500000625,
									46.51606445312504
								],
								[
									6.067968750000006,
									46.458544921875045
								],
								[
									6.06025390625004,
									46.42817382812498
								],
								[
									6.123242187500068,
									46.37861328125001
								],
								[
									6.115917968750011,
									46.337646484375114
								],
								[
									6.095898437500011,
									46.279394531250034
								],
								[
									6.0361328125,
									46.238085937500074
								],
								[
									5.9700195312500455,
									46.214697265625006
								],
								[
									5.971484375000074,
									46.151220703125034
								],
								[
									6.0066406250000455,
									46.142333984375114
								],
								[
									6.086621093750068,
									46.14702148437499
								],
								[
									6.19941406250004,
									46.19306640625004
								],
								[
									6.272949218750028,
									46.25224609375002
								],
								[
									6.2295898437500625,
									46.30844726562509
								],
								[
									6.224218750000034,
									46.319433593750034
								],
								[
									6.2346679687500455,
									46.33261718750006
								],
								[
									6.321875000000034,
									46.39370117187505
								],
								[
									6.428906249999983,
									46.43051757812509
								],
								[
									6.578222656250034,
									46.43735351562506
								],
								[
									6.758105468750017,
									46.41577148437503
								],
								[
									6.776074218750011,
									46.40664062500002
								],
								[
									6.767382812500017,
									46.369189453125045
								],
								[
									6.7841796875,
									46.313964843750085
								],
								[
									6.816796875000051,
									46.27519531249999
								],
								[
									6.772070312500006,
									46.165136718750034
								],
								[
									6.8056640625,
									46.130664062500045
								],
								[
									6.858007812500006,
									46.089404296875074
								],
								[
									6.897265625000017,
									46.05175781250003
								],
								[
									6.9537109375000625,
									46.017138671875074
								],
								[
									7.00390625,
									45.95883789062512
								],
								[
									7.021093750000034,
									45.92578124999994
								],
								[
									6.940820312500023,
									45.86835937500007
								],
								[
									6.8044921875000455,
									45.81455078125012
								],
								[
									6.789160156250034,
									45.78007812499993
								],
								[
									6.790917968750023,
									45.74086914062494
								],
								[
									6.806250000000034,
									45.710009765625045
								],
								[
									6.881445312500006,
									45.670361328124955
								],
								[
									6.962402343750057,
									45.58056640625006
								],
								[
									7.013671875000028,
									45.500488281250085
								],
								[
									7.126074218750006,
									45.42368164062498
								],
								[
									7.153417968749977,
									45.40092773437496
								],
								[
									7.146386718750051,
									45.38173828125005
								],
								[
									7.116796874999977,
									45.34902343750005
								],
								[
									7.07832031250004,
									45.23994140625001
								],
								[
									7.032421875000011,
									45.222607421874955
								],
								[
									6.981250000000074,
									45.21557617187494
								],
								[
									6.84228515625,
									45.13564453125008
								],
								[
									6.780371093750006,
									45.14531249999993
								],
								[
									6.692285156249994,
									45.144287109375085
								],
								[
									6.627734374999989,
									45.117968750000045
								],
								[
									6.634765625,
									45.06816406249993
								],
								[
									6.69140625,
									45.02260742187508
								],
								[
									6.724707031250034,
									44.97299804687509
								],
								[
									6.738183593750023,
									44.92138671875006
								],
								[
									6.8010742187500455,
									44.88315429687509
								],
								[
									6.889355468750011,
									44.860302734374955
								],
								[
									6.93984375000008,
									44.85874023437509
								],
								[
									6.972851562500068,
									44.845019531250045
								],
								[
									6.99267578125,
									44.82729492187508
								],
								[
									7.030664062500023,
									44.71669921875011
								],
								[
									7.007910156250006,
									44.68896484375003
								],
								[
									6.96035156250008,
									44.67714843749994
								],
								[
									6.931933593750074,
									44.631640625000074
								],
								[
									6.875195312500068,
									44.564550781250006
								],
								[
									6.842968750000068,
									44.510693359374955
								],
								[
									6.87861328125004,
									44.46328125000008
								],
								[
									6.8938476562500455,
									44.42817382812501
								],
								[
									6.874804687500074,
									44.39204101562504
								],
								[
									6.900195312499989,
									44.33574218749993
								],
								[
									6.96728515625,
									44.28002929687503
								],
								[
									7.149414062500057,
									44.201708984375074
								],
								[
									7.31855468750004,
									44.137988281250045
								],
								[
									7.3708984375000455,
									44.12739257812504
								],
								[
									7.599414062500074,
									44.16835937499994
								],
								[
									7.637207031250057,
									44.16484374999993
								],
								[
									7.665039062500028,
									44.11601562499993
								],
								[
									7.677148437500023,
									44.08315429687508
								],
								[
									7.651464843750006,
									44.03364257812504
								],
								[
									7.5896484375000455,
									43.96542968750006
								],
								[
									7.522656250000068,
									43.911083984374926
								],
								[
									7.4820312500000625,
									43.86489257812502
								],
								[
									7.490527343750017,
									43.8229492187501
								],
								[
									7.4931640625,
									43.7671386718751
								],
								[
									7.438671875000011,
									43.75043945312507
								],
								[
									7.436914062499994,
									43.761474609375
								],
								[
									7.414453125000051,
									43.770898437499966
								],
								[
									7.39501953125,
									43.76533203124998
								],
								[
									7.380078125000068,
									43.7532226562501
								],
								[
									7.377734375000017,
									43.731738281250074
								],
								[
									7.261523437500074,
									43.6960937500001
								],
								[
									7.181445312500017,
									43.65913085937501
								],
								[
									6.864746093750057,
									43.43833007812498
								],
								[
									6.716601562500074,
									43.37358398437493
								],
								[
									6.68740234375008,
									43.33457031249998
								],
								[
									6.657226562500057,
									43.26166992187504
								],
								[
									6.570214843749994,
									43.19907226562509
								],
								[
									6.494042968750023,
									43.16928710937506
								],
								[
									6.30537109375004,
									43.13872070312496
								],
								[
									6.115917968750011,
									43.072363281250034
								],
								[
									6.030566406250017,
									43.100976562499994
								],
								[
									5.809472656250023,
									43.097900390625085
								],
								[
									5.671582031250068,
									43.17783203125012
								],
								[
									5.406542968750074,
									43.22851562500006
								],
								[
									5.32021484375008,
									43.344921874999955
								],
								[
									5.199511718749989,
									43.35249023437507
								],
								[
									5.1204101562500455,
									43.34897460937506
								],
								[
									5.073144531250023,
									43.36660156249994
								],
								[
									5.060839843749989,
									43.40629882812502
								],
								[
									5.05976562500004,
									43.4445312500001
								],
								[
									4.975976562500023,
									43.42695312500007
								],
								[
									4.911914062500017,
									43.42695312500007
								],
								[
									4.873730468750068,
									43.41162109375006
								],
								[
									4.8435546875000455,
									43.393945312499994
								],
								[
									4.807910156250074,
									43.40522460937498
								],
								[
									4.787207031250034,
									43.40141601562502
								],
								[
									4.789062500000057,
									43.37890625000006
								],
								[
									4.712109375000011,
									43.37329101562506
								],
								[
									4.628710937500074,
									43.38710937499994
								],
								[
									4.409765625000034,
									43.447216796874926
								],
								[
									4.37617187500004,
									43.45639648437512
								],
								[
									4.224218750000006,
									43.47963867187505
								],
								[
									4.162792968750011,
									43.50366210937497
								],
								[
									4.113085937499989,
									43.56303710937499
								],
								[
									4.07509765625008,
									43.581835937500074
								],
								[
									4.052636718750023,
									43.593066406250074
								],
								[
									3.9108398437500114,
									43.56308593750009
								],
								[
									3.861621093750017,
									43.51635742187506
								],
								[
									3.7847656250000057,
									43.461621093749926
								],
								[
									3.2588867187500625,
									43.19321289062506
								],
								[
									3.1628906250000455,
									43.08076171875007
								],
								[
									3.051757812500057,
									42.91513671874998
								],
								[
									3.0430664062500625,
									42.83789062500006
								],
								[
									3.090917968750034,
									42.59086914062499
								],
								[
									3.1978515625000625,
									42.46118164062503
								],
								[
									3.2114257812499716,
									42.43115234375006
								],
								[
									3.152148437500074,
									42.43100585937512
								],
								[
									3.052636718750051,
									42.44721679687504
								],
								[
									2.970019531250017,
									42.46723632812504
								],
								[
									2.891406250000074,
									42.45605468749997
								],
								[
									2.815624999999983,
									42.42924804687493
								],
								[
									2.7494140624999943,
									42.4130371093751
								],
								[
									2.7018554687500114,
									42.40849609374996
								],
								[
									2.6700195312500057,
									42.39301757812501
								],
								[
									2.65478515625,
									42.36210937499993
								],
								[
									2.651660156250074,
									42.340478515624966
								],
								[
									2.5679687499999773,
									42.34580078124998
								],
								[
									2.3744140625000796,
									42.39028320312508
								],
								[
									2.200390625000068,
									42.42094726562502
								],
								[
									2.098339843750068,
									42.38608398437512
								],
								[
									2.03271484375,
									42.35351562500006
								],
								[
									1.9865234375000114,
									42.35849609375009
								],
								[
									1.951464843750074,
									42.392773437499955
								],
								[
									1.9279296875000682,
									42.426318359375045
								],
								[
									1.8597656250000512,
									42.4570800781251
								],
								[
									1.7060546875,
									42.50332031250011
								],
								[
									1.7139648437500057,
									42.52563476562503
								],
								[
									1.7402343750000284,
									42.55673828125006
								],
								[
									1.7394531250000398,
									42.57592773437497
								],
								[
									1.7098632812500512,
									42.60444335937501
								],
								[
									1.5681640625000455,
									42.635009765625114
								],
								[
									1.5013671875000227,
									42.64272460937508
								],
								[
									1.4588867187500796,
									42.62167968750006
								],
								[
									1.4283203124999773,
									42.595898437499955
								],
								[
									1.349414062500074,
									42.690673828125085
								],
								[
									1.2932617187499886,
									42.709960937500085
								],
								[
									1.208300781250017,
									42.71313476562494
								],
								[
									1.111132812500017,
									42.74204101562506
								],
								[
									1.0100585937500455,
									42.77895507812494
								],
								[
									0.764453125000017,
									42.83803710937508
								],
								[
									0.6968750000000057,
									42.84511718750011
								],
								[
									0.6698242187499943,
									42.83574218749996
								],
								[
									0.6517578125000512,
									42.800439453124966
								],
								[
									0.6419921875000227,
									42.70063476562507
								],
								[
									0.6316406250000455,
									42.68959960937502
								],
								[
									0.5176757812500057,
									42.68627929687506
								],
								[
									0.3772460937500739,
									42.70014648437504
								],
								[
									0.31289062500002274,
									42.69326171875008
								],
								[
									0.25546875000006253,
									42.6929199218751
								],
								[
									0.2013671875000398,
									42.71933593750006
								],
								[
									-0.041162109374994316,
									42.68911132812494
								],
								[
									-0.08149414062495453,
									42.703857421875085
								],
								[
									-0.1400390624999659,
									42.74892578125005
								],
								[
									-0.20532226562494316,
									42.785302734374994
								],
								[
									-0.25605468749998295,
									42.80395507812497
								],
								[
									-0.29931640625,
									42.82534179687508
								],
								[
									-0.33857421875001137,
									42.82880859375007
								],
								[
									-0.39843749999994316,
									42.808105468750114
								],
								[
									-0.48115234375001137,
									42.79931640625
								],
								[
									-0.5498046874999716,
									42.802001953125114
								],
								[
									-0.5864257812499716,
									42.79897460937494
								],
								[
									-0.7401855468749261,
									42.90952148437506
								],
								[
									-0.762646484374983,
									42.93979492187512
								],
								[
									-0.8392089843749488,
									42.948193359374955
								],
								[
									-0.9338378906249432,
									42.94951171874996
								],
								[
									-1.175439453124966,
									43.02114257812508
								],
								[
									-1.2854492187499886,
									43.05961914062502
								],
								[
									-1.3015624999999886,
									43.082470703124955
								],
								[
									-1.3000488281249432,
									43.100976562499994
								],
								[
									-1.3188476562499716,
									43.096972656250074
								],
								[
									-1.352734374999926,
									43.064257812500074
								],
								[
									-1.3705078124999943,
									43.03759765625006
								],
								[
									-1.39404296875,
									43.03261718750002
								],
								[
									-1.4287597656249602,
									43.03676757812505
								],
								[
									-1.4608398437499375,
									43.051757812500085
								],
								[
									-1.4804687500000284,
									43.07114257812506
								],
								[
									-1.4594238281250114,
									43.104980468750114
								],
								[
									-1.4226074218749716,
									43.14912109375004
								],
								[
									-1.4073242187499488,
									43.197119140625034
								],
								[
									-1.4106933593749318,
									43.240087890625006
								],
								[
									-1.4717285156249318,
									43.267675781250034
								],
								[
									-1.5614746093750114,
									43.27919921875008
								],
								[
									-1.627148437499983,
									43.28247070312503
								],
								[
									-1.712841796874926,
									43.307031249999966
								],
								[
									-1.7532714843750057,
									43.324707031250114
								],
								[
									-1.7927246093749432,
									43.372558593750085
								],
								[
									-1.7940429687499488,
									43.40732421875006
								],
								[
									-1.6314453124999488,
									43.43803710937502
								],
								[
									-1.4848632812499432,
									43.56376953124996
								],
								[
									-1.3459960937499886,
									44.020214843749955
								],
								[
									-1.2455078124999375,
									44.55986328125002
								],
								[
									-1.1708007812499943,
									44.661816406249926
								],
								[
									-1.0769531249999602,
									44.68984375000005
								],
								[
									-1.1528808593749886,
									44.76401367187506
								],
								[
									-1.200390624999983,
									44.72646484375005
								],
								[
									-1.2203124999999488,
									44.686621093750006
								],
								[
									-1.2452148437499773,
									44.66669921875004
								],
								[
									-1.1890624999999773,
									45.16147460937512
								],
								[
									-1.1490722656250227,
									45.34262695312498
								],
								[
									-1.0810058593750114,
									45.532421874999926
								],
								[
									-0.9417480468749488,
									45.45708007812502
								],
								[
									-0.8263183593749943,
									45.3806640625001
								],
								[
									-0.7666503906249886,
									45.314355468749994
								],
								[
									-0.691113281249983,
									45.09345703125001
								],
								[
									-0.6339843749999545,
									45.047119140625
								],
								[
									-0.5484863281249659,
									45.00058593750012
								],
								[
									-0.582275390625,
									45.05136718749998
								],
								[
									-0.64111328125,
									45.09018554687498
								],
								[
									-0.7331054687500114,
									45.384619140625006
								],
								[
									-0.7907714843750284,
									45.46801757812494
								],
								[
									-0.8806640624999602,
									45.538183593750034
								],
								[
									-1.169970703125017,
									45.68593749999994
								],
								[
									-1.195996093749983,
									45.71445312500006
								],
								[
									-1.2099609374999716,
									45.77089843750011
								],
								[
									-1.1143554687499488,
									45.76850585937507
								],
								[
									-1.03173828125,
									45.74106445312498
								],
								[
									-1.0415039062499432,
									45.772656249999926
								],
								[
									-1.0660156249999773,
									45.805664062500085
								],
								[
									-1.104394531249966,
									45.925341796875045
								],
								[
									-1.1363769531249943,
									46.20483398437506
								],
								[
									-1.1320312500000114,
									46.25268554687503
								],
								[
									-1.1462890624999886,
									46.31137695312509
								],
								[
									-1.2388183593749886,
									46.3245117187501
								],
								[
									-1.3127929687499602,
									46.32690429687506
								],
								[
									-1.3924804687499375,
									46.35009765624997
								],
								[
									-1.7865234374999375,
									46.51484375000004
								],
								[
									-1.9214355468749886,
									46.68481445312503
								],
								[
									-2.059375000000017,
									46.81030273437503
								],
								[
									-2.0924804687500114,
									46.86503906249999
								],
								[
									-2.0902832031250114,
									46.920507812500006
								],
								[
									-2.018896484374949,
									47.037646484375074
								],
								[
									-2.0819335937499943,
									47.111621093750045
								],
								[
									-2.1435546875000284,
									47.12631835937509
								],
								[
									-2.1970703124999886,
									47.16293945312509
								],
								[
									-2.148583984374966,
									47.2239257812501
								],
								[
									-2.1083007812499375,
									47.26293945312506
								],
								[
									-2.0275878906250284,
									47.273583984374994
								],
								[
									-1.9217285156249488,
									47.26064453124994
								],
								[
									-1.8212890625,
									47.22534179687503
								],
								[
									-1.7425292968749488,
									47.21596679687508
								],
								[
									-1.9753906249999602,
									47.31069335937511
								],
								[
									-2.3530273437499716,
									47.27875976562498
								],
								[
									-2.434423828124949,
									47.29096679687498
								],
								[
									-2.5031250000000114,
									47.31206054687493
								],
								[
									-2.5300292968749716,
									47.38159179687497
								],
								[
									-2.476318359374943,
									47.41293945312506
								],
								[
									-2.427685546874983,
									47.470898437499955
								],
								[
									-2.482714843749932,
									47.511621093749994
								],
								[
									-2.5540527343749773,
									47.52705078125004
								],
								[
									-2.6659179687499375,
									47.52617187500002
								],
								[
									-2.7703124999999886,
									47.51386718750001
								],
								[
									-2.796777343749966,
									47.53725585937508
								],
								[
									-2.7331054687499545,
									47.601806640625085
								],
								[
									-2.7872070312499773,
									47.62553710937493
								],
								[
									-2.859375,
									47.61445312499998
								],
								[
									-2.964062499999926,
									47.601074218750114
								],
								[
									-3.064208984375,
									47.62133789062506
								],
								[
									-3.1588378906249943,
									47.69467773437506
								],
								[
									-3.2215820312499943,
									47.69414062499996
								],
								[
									-3.2646972656249886,
									47.68510742187499
								],
								[
									-3.328613281249943,
									47.71333007812507
								],
								[
									-3.3958984374999943,
									47.72041015624998
								],
								[
									-3.4439453125000057,
									47.711035156250034
								],
								[
									-3.507812499999943,
									47.75312500000007
								],
								[
									-3.900927734374932,
									47.83754882812505
								],
								[
									-4.070703124999966,
									47.847851562499926
								],
								[
									-4.226416015624977,
									47.809619140625045
								],
								[
									-4.312109374999949,
									47.822900390624994
								],
								[
									-4.375097656249977,
									47.87744140625
								],
								[
									-4.427978515625,
									47.9689453125001
								],
								[
									-4.678808593749949,
									48.03950195312498
								],
								[
									-4.62919921874996,
									48.08579101562509
								],
								[
									-4.512402343749983,
									48.0967285156251
								],
								[
									-4.377832031250023,
									48.128808593749966
								],
								[
									-4.32944335937492,
									48.1699707031251
								],
								[
									-4.434619140624932,
									48.217968749999926
								],
								[
									-4.512207031249943,
									48.229736328125114
								],
								[
									-4.544335937499994,
									48.246972656249966
								],
								[
									-4.577148437499943,
									48.29003906250003
								],
								[
									-4.530664062499966,
									48.309716796874966
								],
								[
									-4.497900390624949,
									48.29926757812507
								],
								[
									-4.403320312499972,
									48.29306640624995
								],
								[
									-4.241406249999926,
									48.30366210937507
								],
								[
									-4.301757812499972,
									48.34707031249994
								],
								[
									-4.3644042968749375,
									48.356738281250045
								],
								[
									-4.393164062499949,
									48.36762695312504
								],
								[
									-4.5248046874999375,
									48.372314453125114
								],
								[
									-4.584716796874972,
									48.35751953125012
								],
								[
									-4.719384765624966,
									48.363134765625006
								],
								[
									-4.748535156249943,
									48.41000976562506
								],
								[
									-4.76249999999996,
									48.45024414062499
								],
								[
									-4.72075195312496,
									48.53989257812506
								],
								[
									-4.531201171874983,
									48.61997070312512
								],
								[
									-4.05888671874996,
									48.70751953125
								],
								[
									-3.8556640624999545,
									48.69472656250005
								],
								[
									-3.714794921874926,
									48.71049804687499
								],
								[
									-3.5459960937499204,
									48.765673828125045
								],
								[
									-3.471484374999932,
									48.81293945312498
								],
								[
									-3.2314453124999716,
									48.840820312500085
								],
								[
									-3.003222656250017,
									48.79067382812508
								],
								[
									-2.792871093749966,
									48.601074218750085
								],
								[
									-2.6923339843750114,
									48.536816406249955
								],
								[
									-2.4461914062499375,
									48.64829101562512
								],
								[
									-2.0794433593749204,
									48.64501953124997
								],
								[
									-2.00371093749996,
									48.58208007812502
								],
								[
									-1.9731445312499432,
									48.63510742187509
								],
								[
									-1.905712890624983,
									48.69711914062512
								],
								[
									-1.8519531249999375,
									48.66884765624994
								],
								[
									-1.82470703125,
									48.63051757812505
								],
								[
									-1.4376464843749943,
									48.641406250000045
								],
								[
									-1.3764648437499716,
									48.652587890625
								],
								[
									-1.4804687500000284,
									48.697607421875034
								],
								[
									-1.5654785156249318,
									48.80551757812506
								],
								[
									-1.5831054687499773,
									49.202392578125114
								],
								[
									-1.690332031249966,
									49.31318359375004
								],
								[
									-1.8134277343750114,
									49.49013671875002
								],
								[
									-1.870068359374983,
									49.595117187499994
								],
								[
									-1.8753906250000227,
									49.63139648437493
								],
								[
									-1.8564453124999716,
									49.68378906250004
								],
								[
									-1.7051269531249602,
									49.68095703124999
								],
								[
									-1.5882324218749488,
									49.66767578125004
								],
								[
									-1.36572265625,
									49.70727539062503
								],
								[
									-1.2586425781249488,
									49.680175781250085
								],
								[
									-1.2649414062499886,
									49.59824218750009
								],
								[
									-1.2322753906250057,
									49.494873046875
								],
								[
									-1.1949707031249375,
									49.44482421875003
								],
								[
									-1.1385253906250057,
									49.38789062500007
								],
								[
									-0.9591308593749375,
									49.39316406249998
								],
								[
									-0.7655273437499375,
									49.359716796875006
								],
								[
									-0.5208984374999375,
									49.35454101562502
								],
								[
									-0.16347656249993747,
									49.296777343749966
								],
								[
									-0.011181640625011369,
									49.33022460937502
								],
								[
									0.13613281250007958,
									49.401513671874994
								],
								[
									0.4168945312500796,
									49.44838867187505
								],
								[
									0.43925781250001705,
									49.47319335937502
								],
								[
									0.2776367187500455,
									49.463281249999966
								],
								[
									0.12939453125002842,
									49.50844726562502
								],
								[
									0.10937500000002842,
									49.55751953125008
								],
								[
									0.12656249999997726,
									49.60156250000006
								],
								[
									0.18671874999998295,
									49.70302734375005
								],
								[
									0.6162109375,
									49.86293945312494
								],
								[
									0.924121093750017,
									49.910205078125074
								],
								[
									1.2455078125000512,
									49.99824218750007
								],
								[
									1.4072265625000284,
									50.08852539062508
								],
								[
									1.5140625000000512,
									50.205078125000085
								],
								[
									1.548437500000034,
									50.230712890625085
								],
								[
									1.5927734375,
									50.252197265625114
								],
								[
									1.5515625000000455,
									50.293945312500085
								],
								[
									1.5794921875000512,
									50.73925781249994
								],
								[
									1.6095703125000398,
									50.81948242187502
								],
								[
									1.6722656250000227,
									50.88500976562497
								],
								[
									1.7676757812500057,
									50.935693359374994
								],
								[
									1.9125000000000227,
									50.990624999999994
								],
								[
									2.445703125000051,
									51.06650390625009
								],
								[
									2.52490234375,
									51.097119140624926
								],
								[
									2.536035156250051,
									51.0495117187501
								],
								[
									2.5748046875000625,
									50.98857421874993
								],
								[
									2.601464843750051,
									50.95527343749998
								],
								[
									2.579296874999983,
									50.91176757812511
								],
								[
									2.5967773437500057,
									50.87592773437498
								],
								[
									2.669140624999983,
									50.811425781249994
								],
								[
									2.7593750000000057,
									50.75063476562505
								],
								[
									2.8397460937500227,
									50.711767578125034
								],
								[
									2.862402343750034,
									50.71601562500001
								],
								[
									2.9219726562499773,
									50.72705078124994
								],
								[
									3.0228515625000227,
									50.766894531250074
								],
								[
									3.1068359375000796,
									50.77944335937505
								],
								[
									3.1548828125000057,
									50.74892578125005
								],
								[
									3.1820312500000227,
									50.731689453125
								],
								[
									3.2349609374999773,
									50.662939453125034
								],
								[
									3.249804687500074,
									50.59116210937506
								],
								[
									3.2733398437500796,
									50.53154296874999
								],
								[
									3.316210937500017,
									50.507373046875045
								],
								[
									3.4769531250000796,
									50.49946289062504
								],
								[
									3.59541015625004,
									50.47734374999996
								],
								[
									3.6267578125000455,
									50.457324218750074
								],
								[
									3.6672851562500455,
									50.32480468749998
								],
								[
									3.6893554687499943,
									50.30605468750005
								],
								[
									3.7188476562500625,
									50.32167968750005
								],
								[
									3.748046875000057,
									50.34350585937506
								],
								[
									3.788574218750057,
									50.34697265624996
								],
								[
									3.8581054687500114,
									50.33857421875004
								],
								[
									3.9497070312500284,
									50.33593750000003
								],
								[
									4.044140624999983,
									50.321337890625074
								],
								[
									4.174609375000017,
									50.24648437500011
								],
								[
									4.169628906250068,
									50.22177734374995
								],
								[
									4.144140625000034,
									50.1784179687501
								],
								[
									4.13525390625,
									50.14379882812506
								],
								[
									4.157714843750028,
									50.12988281250006
								],
								[
									4.1921875000000455,
									50.094140624999966
								],
								[
									4.1838867187500455,
									50.05283203125009
								],
								[
									4.150292968750023,
									50.023876953124955
								],
								[
									4.136816406250034,
									49.99999999999997
								],
								[
									4.137011718750074,
									49.984472656250006
								],
								[
									4.149316406250023,
									49.97158203125005
								],
								[
									4.1760742187500455,
									49.96025390624996
								],
								[
									4.368750000000034,
									49.94497070312505
								],
								[
									4.5450195312500625,
									49.96025390624996
								],
								[
									4.656152343750051,
									50.00244140625003
								],
								[
									4.675097656250017,
									50.046875000000114
								],
								[
									4.706640625000034,
									50.09707031249994
								],
								[
									4.772851562500023,
									50.139062499999966
								],
								[
									4.8186523437500455,
									50.153173828125006
								],
								[
									4.86054687500004,
									50.13588867187502
								],
								[
									4.790039062499972,
									49.95957031250009
								],
								[
									4.841503906250068,
									49.91450195312504
								],
								[
									4.849121093750028,
									49.8471191406251
								],
								[
									4.867578125000051,
									49.788134765625074
								],
								[
									4.930566406250023,
									49.78925781250004
								],
								[
									5.006933593750034,
									49.77836914062502
								],
								[
									5.061035156250028,
									49.75654296875001
								],
								[
									5.124121093750006,
									49.72148437499999
								],
								[
									5.215039062500068,
									49.68925781249999
								],
								[
									5.27880859375,
									49.6779296875001
								],
								[
									5.301953125000011,
									49.650976562500006
								],
								[
									5.353515625000028,
									49.61982421875007
								],
								[
									5.434667968750034,
									49.554492187500074
								],
								[
									5.50732421875,
									49.51088867187508
								],
								[
									5.542382812500051,
									49.51103515625002
								],
								[
									5.610058593750068,
									49.52822265625005
								],
								[
									5.71044921875,
									49.53920898437508
								],
								[
									5.789746093749983,
									49.53828125000007
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "FRA",
					"su_a3": "FRA",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "FRA",
					"gu_a3": "FRA",
					"abbrev": "Fr.",
					"region_un": "Europe",
					"adm0_a3_us": "FRA",
					"scalerank": 1,
					"pop_est": 64057792,
					"adm0_dif": 1,
					"un_a3": "250",
					"pop_year": -99,
					"gdp_md_est": 2128000,
					"name": "France",
					"sovereignt": "France",
					"economy": "1. Developed region: G7",
					"type": "Country",
					"abbrev_len": 3,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "France",
					"postal": "F",
					"sov_a3": "FR1",
					"note_brk": "",
					"brk_a3": "FRA",
					"wb_a2": "FR",
					"brk_diff": 0,
					"admin": "France",
					"name_long": "France",
					"iso_a3": "FRA",
					"iso_a2": "FR",
					"adm0_a3_is": "FRA",
					"level": 2,
					"formal_en": "French Republic",
					"name_len": 6,
					"mapcolor7": 7,
					"long_len": 6,
					"mapcolor8": 5,
					"mapcolor9": 9,
					"note_adm0": "",
					"iso_n3": "250",
					"homepart": 1,
					"subunit": "France",
					"name_alt": "",
					"brk_name": "France",
					"name_sort": "France",
					"continent": "Europe",
					"mapcolor13": 11,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": -99
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-1.065576171874966,
									50.69023437499999
								],
								[
									-1.149365234374983,
									50.65571289062507
								],
								[
									-1.1758300781249602,
									50.615234375000085
								],
								[
									-1.1960937499999886,
									50.59921875000009
								],
								[
									-1.25146484375,
									50.58881835937504
								],
								[
									-1.306298828124966,
									50.588525390624966
								],
								[
									-1.515332031249926,
									50.66977539062509
								],
								[
									-1.5634277343749545,
									50.66611328125006
								],
								[
									-1.5156738281249886,
									50.7033203125001
								],
								[
									-1.3858398437499204,
									50.73354492187494
								],
								[
									-1.3127929687499602,
									50.77348632812499
								],
								[
									-1.1442382812500114,
									50.73471679687509
								],
								[
									-1.065576171874966,
									50.69023437499999
								]
							]
						],
						[
							[
								[
									-4.196777343749972,
									53.32143554687494
								],
								[
									-4.154882812499977,
									53.30283203125006
								],
								[
									-4.04936523437496,
									53.305761718750034
								],
								[
									-4.084277343749989,
									53.26430664062502
								],
								[
									-4.200390624999926,
									53.21806640625002
								],
								[
									-4.27861328124996,
									53.172412109375045
								],
								[
									-4.373046875,
									53.13417968750008
								],
								[
									-4.418847656250023,
									53.17802734375002
								],
								[
									-4.471972656250017,
									53.176367187500034
								],
								[
									-4.553222656249943,
									53.26044921875004
								],
								[
									-4.56787109375,
									53.38647460937503
								],
								[
									-4.46171874999996,
									53.41928710937498
								],
								[
									-4.315087890625023,
									53.417236328125
								],
								[
									-4.196777343749972,
									53.32143554687494
								]
							]
						],
						[
							[
								[
									-6.218017578125,
									54.08872070312512
								],
								[
									-6.3036621093749545,
									54.09487304687494
								],
								[
									-6.363671875000023,
									54.07709960937504
								],
								[
									-6.402587890624943,
									54.06064453125006
								],
								[
									-6.440283203124977,
									54.063623046874966
								],
								[
									-6.548144531249932,
									54.05727539062511
								],
								[
									-6.649804687499966,
									54.05864257812493
								],
								[
									-6.664208984374966,
									54.08476562500002
								],
								[
									-6.646874999999966,
									54.16342773437506
								],
								[
									-6.669531249999977,
									54.18471679687505
								],
								[
									-6.766601562499943,
									54.195605468750045
								],
								[
									-6.802587890625006,
									54.21435546874994
								],
								[
									-6.858349609374983,
									54.26865234375009
								],
								[
									-6.869238281249977,
									54.29404296875012
								],
								[
									-6.877246093749932,
									54.32910156250006
								],
								[
									-6.93613281249992,
									54.37431640625002
								],
								[
									-7.0077148437499375,
									54.40668945312504
								],
								[
									-7.049707031249966,
									54.40825195312502
								],
								[
									-7.133496093749983,
									54.35537109375008
								],
								[
									-7.2025878906249545,
									54.3018066406251
								],
								[
									-7.17807617187492,
									54.27490234375003
								],
								[
									-7.1554687499999545,
									54.239501953125085
								],
								[
									-7.1930664062499545,
									54.214111328125085
								],
								[
									-7.306738281249949,
									54.15600585937506
								],
								[
									-7.324511718750017,
									54.13344726562508
								],
								[
									-7.3551757812499545,
									54.12124023437508
								],
								[
									-7.409423828125,
									54.13730468750006
								],
								[
									-7.544433593749972,
									54.13359375000002
								],
								[
									-7.606542968750006,
									54.143847656250074
								],
								[
									-7.67875976562496,
									54.186669921874994
								],
								[
									-7.854931640624983,
									54.215283203124955
								],
								[
									-7.8844726562499545,
									54.28378906250006
								],
								[
									-7.918457031249943,
									54.2965820312501
								],
								[
									-8.118261718749977,
									54.4142578125001
								],
								[
									-8.14482421874996,
									54.453515624999994
								],
								[
									-8.118945312499932,
									54.47695312500008
								],
								[
									-8.044335937500023,
									54.512451171875114
								],
								[
									-7.793798828124949,
									54.5712402343751
								],
								[
									-7.75439453125,
									54.59492187500004
								],
								[
									-7.7462890624999545,
									54.61582031250012
								],
								[
									-7.819824218750028,
									54.6396972656251
								],
								[
									-7.8861328124999375,
									54.66606445312496
								],
								[
									-7.908740234374932,
									54.683349609375114
								],
								[
									-7.9105957031249545,
									54.69833984375006
								],
								[
									-7.872949218749994,
									54.717871093750034
								],
								[
									-7.797265624999966,
									54.71928710937496
								],
								[
									-7.7374999999999545,
									54.71044921874994
								],
								[
									-7.68999023437496,
									54.72802734374997
								],
								[
									-7.606445312499972,
									54.74570312500012
								],
								[
									-7.55039062499992,
									54.76796874999994
								],
								[
									-7.502197265624972,
									54.825439453125085
								],
								[
									-7.451269531249977,
									54.877099609374966
								],
								[
									-7.445996093749983,
									54.90512695312509
								],
								[
									-7.40141601562496,
									55.00332031250011
								],
								[
									-7.376904296874926,
									55.02768554687509
								],
								[
									-7.2186523437499375,
									55.091992187499955
								],
								[
									-7.1786132812499375,
									55.056884765625
								],
								[
									-7.10063476562496,
									55.04829101562501
								],
								[
									-7.030761718749943,
									55.080615234375045
								],
								[
									-6.947167968749966,
									55.18251953125011
								],
								[
									-6.888964843750017,
									55.18891601562498
								],
								[
									-6.824853515624994,
									55.180664062500085
								],
								[
									-6.698828125000006,
									55.19345703125012
								],
								[
									-6.4750488281249545,
									55.24101562500002
								],
								[
									-6.375292968749989,
									55.241796875000006
								],
								[
									-6.23422851562492,
									55.21684570312499
								],
								[
									-6.129150390625028,
									55.217382812500006
								],
								[
									-6.035791015624994,
									55.14453125
								],
								[
									-5.9857421874999375,
									55.029687499999966
								],
								[
									-5.869189453124989,
									54.91621093750004
								],
								[
									-5.71684570312496,
									54.81748046875006
								],
								[
									-5.71074218749996,
									54.75708007812503
								],
								[
									-5.765185546874932,
									54.72465820312499
								],
								[
									-5.879101562499983,
									54.68437499999996
								],
								[
									-5.8786132812499545,
									54.64130859375007
								],
								[
									-5.803466796875028,
									54.66303710937504
								],
								[
									-5.738623046874949,
									54.673046874999955
								],
								[
									-5.582519531249943,
									54.66342773437495
								],
								[
									-5.52792968749992,
									54.61962890625
								],
								[
									-5.4901855468749545,
									54.55405273437506
								],
								[
									-5.470410156249926,
									54.50019531250001
								],
								[
									-5.48388671875,
									54.44165039062506
								],
								[
									-5.525878906249943,
									54.46020507812494
								],
								[
									-5.5685546874999545,
									54.51259765625005
								],
								[
									-5.615966796875,
									54.53671875000006
								],
								[
									-5.6710937499999545,
									54.54975585937507
								],
								[
									-5.64609374999992,
									54.47788085937509
								],
								[
									-5.655957031249983,
									54.38173828124994
								],
								[
									-5.63188476562496,
									54.372656250000034
								],
								[
									-5.557812499999983,
									54.37099609375005
								],
								[
									-5.60678710937492,
									54.27255859375009
								],
								[
									-5.708056640624932,
									54.24584960937497
								],
								[
									-5.826171875000028,
									54.23583984374997
								],
								[
									-5.854638671874966,
									54.200976562500074
								],
								[
									-5.876074218749977,
									54.156054687500074
								],
								[
									-5.937744140625028,
									54.0890625000001
								],
								[
									-6.019042968749972,
									54.05126953124994
								],
								[
									-6.119531250000023,
									54.058886718750074
								],
								[
									-6.218017578125,
									54.08872070312512
								]
							]
						],
						[
							[
								[
									-5.105419921875011,
									55.44882812500009
								],
								[
									-5.231494140624932,
									55.448095703125034
								],
								[
									-5.277050781249983,
									55.456738281249926
								],
								[
									-5.3314941406249545,
									55.48105468750009
								],
								[
									-5.392675781250006,
									55.61835937499998
								],
								[
									-5.370800781249983,
									55.66694335937504
								],
								[
									-5.345703125000028,
									55.69072265624999
								],
								[
									-5.318115234375,
									55.709179687499926
								],
								[
									-5.2516113281249375,
									55.716943359374994
								],
								[
									-5.185449218749966,
									55.690966796875045
								],
								[
									-5.160400390625,
									55.666796875000074
								],
								[
									-5.10498046875,
									55.573974609375
								],
								[
									-5.094726562499943,
									55.49433593750004
								],
								[
									-5.105419921875011,
									55.44882812500009
								]
							]
						],
						[
							[
								[
									-6.128906249999972,
									55.930566406249994
								],
								[
									-6.092822265624989,
									55.80214843750005
								],
								[
									-6.0576171875,
									55.72250976562498
								],
								[
									-6.055322265624994,
									55.69531249999994
								],
								[
									-6.088378906249972,
									55.657519531250074
								],
								[
									-6.253173828124972,
									55.60722656250002
								],
								[
									-6.305078124999966,
									55.60693359374997
								],
								[
									-6.307226562499977,
									55.61914062499997
								],
								[
									-6.270019531249943,
									55.67031250000008
								],
								[
									-6.302050781249989,
									55.72836914062512
								],
								[
									-6.286425781249989,
									55.772509765625045
								],
								[
									-6.3017578125,
									55.780615234375006
								],
								[
									-6.333886718749994,
									55.77436523437507
								],
								[
									-6.45195312499996,
									55.70424804687508
								],
								[
									-6.491357421874994,
									55.697314453125074
								],
								[
									-6.495654296874989,
									55.711572265624966
								],
								[
									-6.466455078124994,
									55.76899414062504
								],
								[
									-6.4628417968749545,
									55.80825195312505
								],
								[
									-6.445263671874926,
									55.83237304687498
								],
								[
									-6.413183593749977,
									55.85463867187508
								],
								[
									-6.374951171875011,
									55.871337890625114
								],
								[
									-6.3441406249999375,
									55.87373046875007
								],
								[
									-6.311279296875,
									55.8564941406251
								],
								[
									-6.215673828124977,
									55.904589843750045
								],
								[
									-6.128906249999972,
									55.930566406249994
								]
							]
						],
						[
							[
								[
									-5.970068359374949,
									55.81455078125009
								],
								[
									-5.990917968749926,
									55.80380859375012
								],
								[
									-6.041552734374932,
									55.80678710937511
								],
								[
									-6.06035156249996,
									55.82290039062508
								],
								[
									-6.070703125000023,
									55.847656250000085
								],
								[
									-6.071972656250011,
									55.8931152343751
								],
								[
									-6.041308593749989,
									55.92563476562506
								],
								[
									-5.911767578124966,
									55.97475585937494
								],
								[
									-5.970312499999977,
									55.99218749999994
								],
								[
									-5.972656250000028,
									56.004443359375045
								],
								[
									-5.93906249999992,
									56.045263671875006
								],
								[
									-5.799609374999932,
									56.10878906250008
								],
								[
									-5.76225585937496,
									56.120312499999926
								],
								[
									-5.72514648437496,
									56.11855468750002
								],
								[
									-5.797216796874977,
									56.005615234375114
								],
								[
									-5.970068359374949,
									55.81455078125009
								]
							]
						],
						[
							[
								[
									-5.77788085937496,
									56.344335937500006
								],
								[
									-6.176171874999994,
									56.28872070312505
								],
								[
									-6.313427734374983,
									56.29365234374998
								],
								[
									-6.3258300781249375,
									56.32094726562505
								],
								[
									-6.298486328124966,
									56.33916015624993
								],
								[
									-6.184863281249989,
									56.35688476562498
								],
								[
									-6.1388671874999545,
									56.490624999999966
								],
								[
									-6.310644531249949,
									56.55214843750008
								],
								[
									-6.31967773437492,
									56.56943359374995
								],
								[
									-6.306249999999949,
									56.59877929687505
								],
								[
									-6.286328124999983,
									56.611865234375074
								],
								[
									-6.1820800781249545,
									56.64296875000011
								],
								[
									-6.13828124999992,
									56.64985351562498
								],
								[
									-6.1027343749999545,
									56.64565429687502
								],
								[
									-6.029589843749989,
									56.6098144531251
								],
								[
									-5.946679687499966,
									56.534521484375034
								],
								[
									-5.836035156249977,
									56.52255859375009
								],
								[
									-5.760839843749949,
									56.49067382812507
								],
								[
									-5.77788085937496,
									56.344335937500006
								]
							]
						],
						[
							[
								[
									-6.607617187499983,
									56.58500976562502
								],
								[
									-6.664453124999994,
									56.579443359375034
								],
								[
									-6.668554687499949,
									56.59360351562506
								],
								[
									-6.56992187499992,
									56.66123046875009
								],
								[
									-6.506054687499983,
									56.67236328125006
								],
								[
									-6.48369140624996,
									56.66577148437494
								],
								[
									-6.530078124999989,
									56.62661132812505
								],
								[
									-6.607617187499983,
									56.58500976562502
								]
							]
						],
						[
							[
								[
									-7.416894531249994,
									56.96542968749998
								],
								[
									-7.504785156249966,
									56.951660156250114
								],
								[
									-7.53740234374996,
									56.95971679687506
								],
								[
									-7.542968750000028,
									56.97236328125007
								],
								[
									-7.522949218750028,
									57.00678710937504
								],
								[
									-7.455468749999966,
									57.01894531250005
								],
								[
									-7.4066894531249545,
									57.000292968750074
								],
								[
									-7.398925781249972,
									56.98334960937498
								],
								[
									-7.416894531249994,
									56.96542968749998
								]
							]
						],
						[
							[
								[
									-6.279052734375,
									56.964697265625006
								],
								[
									-6.308740234375023,
									56.95180664062505
								],
								[
									-6.346240234374932,
									56.954296874999926
								],
								[
									-6.383398437499949,
									56.97089843750001
								],
								[
									-6.432617187499943,
									57.017919921875006
								],
								[
									-6.322363281249949,
									57.050537109375085
								],
								[
									-6.278222656250023,
									57.03139648437508
								],
								[
									-6.261279296874932,
									57.009521484375085
								],
								[
									-6.26054687499996,
									56.98525390625002
								],
								[
									-6.279052734375,
									56.964697265625006
								]
							]
						],
						[
							[
								[
									-7.249853515624977,
									57.11533203125006
								],
								[
									-7.29204101562496,
									57.10976562500008
								],
								[
									-7.347412109374972,
									57.11513671875011
								],
								[
									-7.381494140624994,
									57.130664062500074
								],
								[
									-7.415917968749966,
									57.19213867187497
								],
								[
									-7.422363281249972,
									57.229345703125006
								],
								[
									-7.407031249999932,
									57.298486328124966
								],
								[
									-7.4105468749999375,
									57.381103515625114
								],
								[
									-7.296386718749972,
									57.38369140625011
								],
								[
									-7.26713867187496,
									57.37177734374998
								],
								[
									-7.247558593749972,
									57.12636718750008
								],
								[
									-7.249853515624977,
									57.11533203125006
								]
							]
						],
						[
							[
								[
									-6.144726562499983,
									57.504980468750034
								],
								[
									-6.146142578125023,
									57.46079101562509
								],
								[
									-6.1637695312499545,
									57.40883789062508
								],
								[
									-6.140820312500011,
									57.35366210937502
								],
								[
									-6.135546874999989,
									57.31425781249999
								],
								[
									-6.0934082031249375,
									57.30170898437501
								],
								[
									-6.067626953125,
									57.28354492187495
								],
								[
									-5.8802734374999375,
									57.263232421875074
								],
								[
									-5.7060058593749545,
									57.268945312499994
								],
								[
									-5.672460937499977,
									57.25268554687506
								],
								[
									-5.668652343749983,
									57.22690429687495
								],
								[
									-5.696191406250023,
									57.198437499999926
								],
								[
									-5.795410156249972,
									57.14653320312502
								],
								[
									-5.913769531249926,
									57.06264648437505
								],
								[
									-5.94907226562492,
									57.04516601562506
								],
								[
									-5.9873046875,
									57.044433593750085
								],
								[
									-6.014746093749977,
									57.051953124999926
								],
								[
									-6.034374999999983,
									57.20122070312496
								],
								[
									-6.1627441406249375,
									57.18212890625006
								],
								[
									-6.266113281249943,
									57.184326171875085
								],
								[
									-6.322705078124926,
									57.20249023437495
								],
								[
									-6.36240234374992,
									57.23749999999998
								],
								[
									-6.442431640624989,
									57.32749023437512
								],
								[
									-6.6754394531249375,
									57.36289062499995
								],
								[
									-6.741308593749949,
									57.412451171875006
								],
								[
									-6.761132812499994,
									57.44238281249997
								],
								[
									-6.75273437499996,
									57.45893554687507
								],
								[
									-6.70419921874992,
									57.49575195312511
								],
								[
									-6.643457031249994,
									57.4826171875001
								],
								[
									-6.605859374999966,
									57.490673828124955
								],
								[
									-6.583007812500028,
									57.50712890624993
								],
								[
									-6.583496093749943,
									57.52065429687494
								],
								[
									-6.615283203124932,
									57.552734375000085
								],
								[
									-6.616796874999977,
									57.56269531250007
								],
								[
									-6.37851562499992,
									57.60332031249999
								],
								[
									-6.357666015624943,
									57.666796875000045
								],
								[
									-6.305957031249989,
									57.671972656250034
								],
								[
									-6.246923828124949,
									57.65122070312498
								],
								[
									-6.166064453124989,
									57.58530273437506
								],
								[
									-6.144726562499983,
									57.504980468750034
								]
							]
						],
						[
							[
								[
									-7.205566406250028,
									57.68295898437506
								],
								[
									-7.092773437499972,
									57.62666015625004
								],
								[
									-7.182617187499972,
									57.53330078125012
								],
								[
									-7.320556640625,
									57.53374023437493
								],
								[
									-7.514746093749949,
									57.60195312500008
								],
								[
									-7.515624999999943,
									57.615869140624966
								],
								[
									-7.4994140624999375,
									57.63632812500006
								],
								[
									-7.470312499999949,
									57.65253906249998
								],
								[
									-7.44003906249992,
									57.656396484374966
								],
								[
									-7.39189453124996,
									57.6452148437501
								],
								[
									-7.324853515624994,
									57.6631347656251
								],
								[
									-7.271191406249983,
									57.657470703125085
								],
								[
									-7.205566406250028,
									57.68295898437506
								]
							]
						],
						[
							[
								[
									-6.198681640624983,
									58.36328125
								],
								[
									-6.3258300781249375,
									58.188867187499994
								],
								[
									-6.375585937499949,
									58.184570312500085
								],
								[
									-6.419287109374977,
									58.140966796875006
								],
								[
									-6.554589843749994,
									58.09287109374998
								],
								[
									-6.436523437500028,
									58.09189453125006
								],
								[
									-6.403369140624932,
									58.07587890624998
								],
								[
									-6.40244140624992,
									58.04135742187506
								],
								[
									-6.4251953124999375,
									58.02128906249996
								],
								[
									-6.578125,
									57.94135742187501
								],
								[
									-6.683300781249926,
									57.91103515625005
								],
								[
									-6.796582031249926,
									57.82753906250002
								],
								[
									-6.853759765624943,
									57.82651367187506
								],
								[
									-6.910351562499926,
									57.7733886718751
								],
								[
									-6.956933593749994,
									57.750048828125045
								],
								[
									-6.983105468750011,
									57.74999999999994
								],
								[
									-7.01318359375,
									57.76176757812502
								],
								[
									-7.083447265624926,
									57.81376953124996
								],
								[
									-6.955957031249966,
									57.86489257812508
								],
								[
									-6.94414062499996,
									57.89365234375006
								],
								[
									-6.8568359374999375,
									57.92353515625004
								],
								[
									-6.864160156250023,
									57.93286132812506
								],
								[
									-7.002539062499949,
									57.97490234374993
								],
								[
									-7.057080078124983,
									58.003173828125
								],
								[
									-7.051904296874994,
									58.017968749999994
								],
								[
									-6.985302734375011,
									58.05048828125004
								],
								[
									-7.01689453124996,
									58.05478515624995
								],
								[
									-7.0382324218749375,
									58.072314453125045
								],
								[
									-7.076904296875,
									58.079003906249994
								],
								[
									-7.088476562499977,
									58.09536132812505
								],
								[
									-7.095605468749994,
									58.13828125000009
								],
								[
									-7.085253906249932,
									58.18217773437496
								],
								[
									-7.044921874999972,
									58.20156250000011
								],
								[
									-7.028417968750006,
									58.222314453124966
								],
								[
									-7.012060546874949,
									58.22871093750004
								],
								[
									-6.94956054687492,
									58.21767578125008
								],
								[
									-6.886230468749972,
									58.182568359374955
								],
								[
									-6.812304687499932,
									58.19609374999996
								],
								[
									-6.7264648437499375,
									58.189404296874926
								],
								[
									-6.724707031249949,
									58.19755859374999
								],
								[
									-6.787744140624994,
									58.28388671875007
								],
								[
									-6.776464843750006,
									58.30151367187494
								],
								[
									-6.742285156249977,
									58.32163085937495
								],
								[
									-6.544189453125028,
									58.38315429687506
								],
								[
									-6.29716796874996,
									58.48662109374999
								],
								[
									-6.237451171874966,
									58.50283203125011
								],
								[
									-6.219433593749926,
									58.48872070312498
								],
								[
									-6.194238281249966,
									58.435107421875074
								],
								[
									-6.198681640624983,
									58.36328125
								]
							]
						],
						[
							[
								[
									-3.109667968749932,
									58.515478515625006
								],
								[
									-3.10112304687496,
									58.433691406250034
								],
								[
									-3.1128906249999773,
									58.40888671875007
								],
								[
									-3.13676757812496,
									58.37832031250005
								],
								[
									-3.212353515624983,
									58.32124023437504
								],
								[
									-3.410986328124949,
									58.23964843750005
								],
								[
									-3.774999999999949,
									58.05209960937512
								],
								[
									-3.99003906249996,
									57.959033203125074
								],
								[
									-4.019628906249949,
									57.91425781250001
								],
								[
									-4.035595703124926,
									57.85200195312504
								],
								[
									-3.9068359374999773,
									57.839648437500074
								],
								[
									-3.857128906249983,
									57.81855468750004
								],
								[
									-3.887939453124943,
									57.7869140625001
								],
								[
									-4.078417968749932,
									57.6770507812501
								],
								[
									-4.134521484375,
									57.57773437500012
								],
								[
									-3.9884765625000114,
									57.58125000000001
								],
								[
									-3.8681640625,
									57.600341796875
								],
								[
									-3.62822265624996,
									57.66225585937511
								],
								[
									-3.4027832031249545,
									57.70825195312506
								],
								[
									-3.294531249999949,
									57.7101562500001
								],
								[
									-3.083935546874926,
									57.67348632812508
								],
								[
									-3.0360351562499375,
									57.672314453124926
								],
								[
									-2.9466796874999375,
									57.6892578125001
								],
								[
									-2.8562988281249204,
									57.692285156249994
								],
								[
									-2.244140625,
									57.68085937500007
								],
								[
									-2.0740722656249773,
									57.702392578125114
								],
								[
									-1.9615234374999773,
									57.67666015625011
								],
								[
									-1.867382812499983,
									57.61235351562496
								],
								[
									-1.7779296874999488,
									57.49375000000006
								],
								[
									-1.7806640624999943,
									57.47402343749994
								],
								[
									-1.8347167968749716,
									57.41997070312502
								],
								[
									-1.934472656249966,
									57.35219726562508
								],
								[
									-2.02031249999996,
									57.25888671875006
								],
								[
									-2.045507812499949,
									57.208544921875045
								],
								[
									-2.0623535156250057,
									57.15346679687508
								],
								[
									-2.0895507812499545,
									57.102539062500114
								],
								[
									-2.26025390625,
									56.86333007812496
								],
								[
									-2.426660156249966,
									56.73071289062494
								],
								[
									-2.5009765625,
									56.63657226562495
								],
								[
									-2.5926757812499375,
									56.561572265625045
								],
								[
									-2.6809570312499886,
									56.514404296875114
								],
								[
									-2.775195312500017,
									56.4829589843751
								],
								[
									-3.04741210937496,
									56.449365234374994
								],
								[
									-3.123583984374932,
									56.42529296875006
								],
								[
									-3.2144531249999773,
									56.383935546874994
								],
								[
									-3.309960937499966,
									56.3634765625001
								],
								[
									-3.197998046875,
									56.36606445312509
								],
								[
									-3.087011718749949,
									56.389062499999966
								],
								[
									-2.8851562499999375,
									56.3975097656251
								],
								[
									-2.6527343750000227,
									56.31826171874994
								],
								[
									-2.6742675781249545,
									56.25341796875006
								],
								[
									-2.7675781249999716,
									56.202148437500085
								],
								[
									-2.979785156249932,
									56.19409179687503
								],
								[
									-3.178222656249943,
									56.0801269531251
								],
								[
									-3.267773437499983,
									56.045068359374966
								],
								[
									-3.3622558593749545,
									56.027636718750045
								],
								[
									-3.480419921874983,
									56.032812500000034
								],
								[
									-3.695117187500017,
									56.063330078125034
								],
								[
									-3.7890624999999716,
									56.09521484374997
								],
								[
									-3.7041503906249886,
									56.04316406250001
								],
								[
									-3.6078124999999943,
									56.016015624999994
								],
								[
									-3.048730468749966,
									55.9519531250001
								],
								[
									-3.015087890624926,
									55.95859375000012
								],
								[
									-2.8368652343749545,
									56.02626953125005
								],
								[
									-2.5993164062499545,
									56.02729492187498
								],
								[
									-2.147070312499949,
									55.90297851562505
								],
								[
									-2.0168457031249716,
									55.80795898437498
								],
								[
									-1.8302734374999545,
									55.67172851562512
								],
								[
									-1.7287597656249716,
									55.61855468749994
								],
								[
									-1.6553710937499488,
									55.570361328125074
								],
								[
									-1.6101562499999886,
									55.4980957031251
								],
								[
									-1.5225585937499773,
									55.25952148437506
								],
								[
									-1.4226562499999602,
									55.0264160156251
								],
								[
									-1.2917480468749432,
									54.77387695312498
								],
								[
									-1.2324218749999432,
									54.70371093750009
								],
								[
									-1.1543945312499488,
									54.6544921875001
								],
								[
									-0.759326171875017,
									54.541406249999966
								],
								[
									-0.6713867187499432,
									54.50390625000006
								],
								[
									-0.5181152343749886,
									54.395117187500006
								],
								[
									-0.370361328125,
									54.27919921875011
								],
								[
									-0.23286132812495453,
									54.19013671874998
								],
								[
									-0.08437499999999432,
									54.11806640625005
								],
								[
									-0.15629882812498863,
									54.080615234375045
								],
								[
									-0.20556640625,
									54.02172851562506
								],
								[
									-0.1687499999999602,
									53.941650390625085
								],
								[
									-0.10825195312497726,
									53.865185546874955
								],
								[
									0.010546875000073896,
									53.74282226562508
								],
								[
									0.11533203125000568,
									53.60927734375005
								],
								[
									0.07670898437504547,
									53.629443359375074
								],
								[
									0.03608398437503979,
									53.64052734375002
								],
								[
									-0.019433593749994316,
									53.63720703125006
								],
								[
									-0.07373046874997158,
									53.643652343750034
								],
								[
									-0.173828125,
									53.68544921875002
								],
								[
									-0.2700195312499716,
									53.7367675781251
								],
								[
									-0.46137695312498295,
									53.71616210937506
								],
								[
									-0.5676757812499602,
									53.72539062499999
								],
								[
									-0.659912109375,
									53.72402343750005
								],
								[
									-0.48505859375001137,
									53.694384765625074
								],
								[
									-0.293701171875,
									53.6923339843751
								],
								[
									0.12832031250007958,
									53.46826171875
								],
								[
									0.2709960937500284,
									53.33549804687496
								],
								[
									0.3557617187500455,
									53.15996093749999
								],
								[
									0.29804687500001137,
									53.0811035156251
								],
								[
									0.20820312500001137,
									53.030029296875085
								],
								[
									0.12441406250007958,
									52.97158203125008
								],
								[
									0.0458984375,
									52.90561523437495
								],
								[
									0.2797851562500284,
									52.80869140625009
								],
								[
									0.3301757812500057,
									52.81162109375009
								],
								[
									0.38193359375006253,
									52.8251953125
								],
								[
									0.43164062500005684,
									52.85815429687506
								],
								[
									0.5155273437499943,
									52.938378906249966
								],
								[
									0.5587890625000398,
									52.96694335937511
								],
								[
									0.7044921875000512,
									52.97724609374998
								],
								[
									0.8267578125000057,
									52.971093749999966
								],
								[
									0.948535156250017,
									52.953369140625
								],
								[
									1.0555664062500796,
									52.958984375000085
								],
								[
									1.2712890625000455,
									52.924560546875085
								],
								[
									1.382128906250074,
									52.89350585937507
								],
								[
									1.6567382812499716,
									52.7537109375001
								],
								[
									1.7161132812499886,
									52.67724609374997
								],
								[
									1.7433593750000398,
									52.57851562500002
								],
								[
									1.7465820312499716,
									52.468994140625
								],
								[
									1.700390624999983,
									52.36889648437494
								],
								[
									1.6473632812500227,
									52.27851562500001
								],
								[
									1.6146484375000227,
									52.16181640625004
								],
								[
									1.5914062499999773,
									52.119775390624994
								],
								[
									1.5589843750000512,
									52.086865234374955
								],
								[
									1.4134765625000796,
									51.99477539062502
								],
								[
									1.3167968749999943,
									51.95693359375005
								],
								[
									1.275976562500034,
									51.97353515625005
								],
								[
									1.2324218750000284,
									51.97124023437493
								],
								[
									1.2278320312499886,
									51.94912109375005
								],
								[
									1.2738281250000512,
									51.90209960937497
								],
								[
									1.2744140624999716,
									51.84536132812505
								],
								[
									1.1884765625000568,
									51.80336914062502
								],
								[
									1.101171875000034,
									51.7854492187501
								],
								[
									0.9550781250000284,
									51.80781250000004
								],
								[
									0.752246093750017,
									51.72958984375009
								],
								[
									0.8980468750000341,
									51.68940429687498
								],
								[
									0.927441406249983,
									51.646630859374966
								],
								[
									0.890917968750017,
									51.57143554687502
								],
								[
									0.7992187500000796,
									51.53789062499993
								],
								[
									0.6975585937500455,
									51.52304687500012
								],
								[
									0.5934570312500682,
									51.5194824218751
								],
								[
									0.5072265624999943,
									51.50107421874998
								],
								[
									0.4245117187500398,
									51.465625000000045
								],
								[
									0.5283203125000284,
									51.48447265624998
								],
								[
									0.6002929687500398,
									51.46796874999998
								],
								[
									0.6455078125000284,
									51.40468750000005
								],
								[
									0.6865234375000284,
									51.38657226562509
								],
								[
									0.8893554687500398,
									51.35952148437511
								],
								[
									1.0149414062500455,
									51.35971679687506
								],
								[
									1.257128906250017,
									51.37509765625006
								],
								[
									1.3734375000000796,
									51.3747070312501
								],
								[
									1.4149414062500227,
									51.36328124999997
								],
								[
									1.4156250000000625,
									51.310839843750045
								],
								[
									1.397558593750034,
									51.182031249999994
								],
								[
									1.365527343750074,
									51.15546875000001
								],
								[
									1.0444335937500284,
									51.04726562500008
								],
								[
									0.9786132812500341,
									50.97167968750006
								],
								[
									0.960156249999983,
									50.92587890624995
								],
								[
									0.7723632812500227,
									50.93398437500008
								],
								[
									0.6843750000000455,
									50.88554687499999
								],
								[
									0.5323242187500625,
									50.85341796875002
								],
								[
									0.41474609374998295,
									50.81918945312498
								],
								[
									0.2997070312499943,
									50.77597656250006
								],
								[
									0.205078125,
									50.76303710937509
								],
								[
									-0.20390625000001705,
									50.814355468749966
								],
								[
									-0.45078124999994884,
									50.81015625000009
								],
								[
									-0.7852539062499773,
									50.765429687500045
								],
								[
									-0.8713867187499318,
									50.772802734375034
								],
								[
									-1.0005859374999488,
									50.815624999999955
								],
								[
									-1.1328613281249886,
									50.84458007812509
								],
								[
									-1.2850585937499943,
									50.85732421875002
								],
								[
									-1.4164550781249545,
									50.896874999999994
								],
								[
									-1.3344726562499432,
									50.82080078124994
								],
								[
									-1.516748046874966,
									50.74746093750002
								],
								[
									-1.6008300781249432,
									50.73286132812507
								],
								[
									-1.6878906249999943,
									50.735156250000074
								],
								[
									-1.8660156249999602,
									50.71523437499994
								],
								[
									-2.031054687499932,
									50.72539062499996
								],
								[
									-2.0062499999999375,
									50.673242187499994
								],
								[
									-1.9620605468749943,
									50.62778320312506
								],
								[
									-1.9979003906249204,
									50.608007812500034
								],
								[
									-2.035839843749926,
									50.6030761718751
								],
								[
									-2.350146484375017,
									50.63740234375007
								],
								[
									-2.3946777343749375,
									50.63090820312499
								],
								[
									-2.4334472656249204,
									50.59921875000009
								],
								[
									-2.5477539062499375,
									50.616308593750034
								],
								[
									-2.6588378906250227,
									50.66972656249999
								],
								[
									-2.7769531249999204,
									50.705566406250085
								],
								[
									-2.900878906249943,
									50.72241210937497
								],
								[
									-2.9994140624999375,
									50.716601562500045
								],
								[
									-3.4045898437499886,
									50.632421875000034
								],
								[
									-3.4854492187499204,
									50.54794921875006
								],
								[
									-3.52587890625,
									50.42817382812498
								],
								[
									-3.5843750000000227,
									50.32182617187499
								],
								[
									-3.6797851562500057,
									50.23994140625001
								],
								[
									-3.793359374999966,
									50.22924804687506
								],
								[
									-3.90019531249996,
									50.28593749999996
								],
								[
									-4.103417968749966,
									50.34853515625011
								],
								[
									-4.172558593749926,
									50.390820312499926
								],
								[
									-4.194580078124972,
									50.393310546875085
								],
								[
									-4.21728515625,
									50.378173828125114
								],
								[
									-4.296972656249977,
									50.35908203125004
								],
								[
									-4.379492187500006,
									50.35820312500002
								],
								[
									-4.506689453124977,
									50.341357421875074
								],
								[
									-4.727978515624926,
									50.2904785156251
								],
								[
									-4.817382812499943,
									50.25595703124998
								],
								[
									-5.009521484375,
									50.16074218749995
								],
								[
									-5.048632812499989,
									50.13437500000009
								],
								[
									-5.11850585937492,
									50.03833007812506
								],
								[
									-5.225244140624994,
									50.02138671875008
								],
								[
									-5.322851562499977,
									50.0829589843751
								],
								[
									-5.433984374999966,
									50.10444335937501
								],
								[
									-5.5512207031249545,
									50.083398437499994
								],
								[
									-5.622119140624932,
									50.050683593749994
								],
								[
									-5.655175781249994,
									50.07724609375009
								],
								[
									-5.656249999999943,
									50.13188476562493
								],
								[
									-5.57065429687492,
									50.196972656249955
								],
								[
									-5.342285156249943,
									50.24614257812493
								],
								[
									-5.1417968749999545,
									50.3737304687501
								],
								[
									-5.04345703125,
									50.451513671875034
								],
								[
									-5.00444335937496,
									50.49526367187505
								],
								[
									-4.95639648437492,
									50.52314453125007
								],
								[
									-4.8935546875,
									50.533691406250085
								],
								[
									-4.861279296875011,
									50.58203124999997
								],
								[
									-4.582910156249966,
									50.77636718750006
								],
								[
									-4.559960937499994,
									50.82094726562508
								],
								[
									-4.546093750000011,
									50.900683593750045
								],
								[
									-4.5230957031249375,
									50.97744140625005
								],
								[
									-4.296484374999949,
									51.027148437500074
								],
								[
									-4.188183593749926,
									51.18852539062499
								],
								[
									-4.158398437499983,
									51.20131835937502
								],
								[
									-3.8423339843749886,
									51.23090820312501
								],
								[
									-3.60791015625,
									51.228564453125074
								],
								[
									-3.3750976562499204,
									51.19697265625001
								],
								[
									-3.2557617187499375,
									51.194140625000074
								],
								[
									-3.1359863281249716,
									51.20502929687507
								],
								[
									-3.042041015625017,
									51.248583984375045
								],
								[
									-2.8812499999999375,
									51.405664062499994
								],
								[
									-2.7908203124999886,
									51.474804687499955
								],
								[
									-2.687207031249926,
									51.53725585937508
								],
								[
									-2.590283203124983,
									51.60859375000004
								],
								[
									-2.433056640624926,
									51.74072265625006
								],
								[
									-2.539355468750017,
									51.69521484375011
								],
								[
									-2.6676757812499545,
									51.622998046874955
								],
								[
									-2.742138671874926,
									51.581103515625045
								],
								[
									-2.978515624999943,
									51.538867187500045
								],
								[
									-3.080371093750017,
									51.49580078125007
								],
								[
									-3.258789062499943,
									51.398486328125045
								],
								[
									-3.2931152343749943,
									51.3904296875001
								],
								[
									-3.5623535156249773,
									51.41381835937497
								],
								[
									-3.7626953125,
									51.539941406249994
								],
								[
									-3.8907714843749943,
									51.59165039062506
								],
								[
									-3.943652343749932,
									51.59750976562509
								],
								[
									-3.99833984374996,
									51.58212890624998
								],
								[
									-4.115283203124989,
									51.56640624999997
								],
								[
									-4.2345703124999545,
									51.569091796875085
								],
								[
									-4.173681640624977,
									51.62734375000005
								],
								[
									-4.091015624999926,
									51.659912109375114
								],
								[
									-4.276171874999989,
									51.682519531249994
								],
								[
									-4.32763671875,
									51.700244140625045
								],
								[
									-4.38627929687496,
									51.74106445312512
								],
								[
									-4.531494140624972,
									51.74804687500003
								],
								[
									-4.6007812499999545,
									51.73764648437495
								],
								[
									-4.717626953124949,
									51.68369140625006
								],
								[
									-4.902294921874926,
									51.626269531250074
								],
								[
									-5.124755859374943,
									51.70585937499996
								],
								[
									-5.1683593749999375,
									51.74072265625006
								],
								[
									-5.167236328124972,
									51.8080566406251
								],
								[
									-5.2005859374999375,
									51.86137695312493
								],
								[
									-5.262304687499977,
									51.880175781250045
								],
								[
									-5.183349609374972,
									51.94965820312507
								],
								[
									-5.088085937499926,
									51.995898437500074
								],
								[
									-4.878515624999949,
									52.04184570312512
								],
								[
									-4.561132812499949,
									52.15087890625003
								],
								[
									-4.383154296874949,
									52.197314453125074
								],
								[
									-4.217724609374983,
									52.27744140625006
								],
								[
									-4.149365234375011,
									52.32626953125006
								],
								[
									-4.0997558593749375,
									52.39311523437499
								],
								[
									-4.050537109374943,
									52.4751464843751
								],
								[
									-3.980322265624949,
									52.541748046875085
								],
								[
									-4.048437499999949,
									52.55761718750003
								],
								[
									-4.07890624999996,
									52.607861328124955
								],
								[
									-4.070703124999966,
									52.65883789062505
								],
								[
									-4.0392578124999545,
									52.704052734374926
								],
								[
									-4.067431640625017,
									52.760742187500114
								],
								[
									-4.11752929687492,
									52.820019531249926
								],
								[
									-4.114746093749972,
									52.8661621093751
								],
								[
									-4.101464843750023,
									52.91547851562501
								],
								[
									-4.229150390624994,
									52.912841796875
								],
								[
									-4.3564453125,
									52.89741210937507
								],
								[
									-4.471826171874966,
									52.86245117187505
								],
								[
									-4.583691406249926,
									52.81494140625006
								],
								[
									-4.683056640624926,
									52.80615234374994
								],
								[
									-4.68144531249996,
									52.84414062500005
								],
								[
									-4.638330078124966,
									52.891113281250114
								],
								[
									-4.525683593749932,
									52.95820312500001
								],
								[
									-4.40507812499996,
									53.013818359374966
								],
								[
									-4.3622070312499375,
									53.05605468750005
								],
								[
									-4.328417968749989,
									53.10512695312511
								],
								[
									-4.268554687499943,
									53.14453125000006
								],
								[
									-4.111035156249926,
									53.218945312499926
								],
								[
									-3.8092773437500114,
									53.30268554687501
								],
								[
									-3.76420898437496,
									53.30761718750006
								],
								[
									-3.6458984374999375,
									53.29790039062493
								],
								[
									-3.52958984374996,
									53.31054687500003
								],
								[
									-3.4277343749999716,
									53.34067382812495
								],
								[
									-3.326171875,
									53.34716796875003
								],
								[
									-3.097558593749966,
									53.2603027343751
								],
								[
									-3.16557617187496,
									53.39467773437494
								],
								[
									-3.064746093749932,
									53.426855468750006
								],
								[
									-2.9185546874999773,
									53.30537109375004
								],
								[
									-2.8641601562500227,
									53.292578125000006
								],
								[
									-2.74951171875,
									53.31020507812505
								],
								[
									-2.79374999999996,
									53.33071289062505
								],
								[
									-2.845410156249926,
									53.33193359374994
								],
								[
									-2.913085937499943,
									53.35024414062494
								],
								[
									-2.9699707031249716,
									53.389208984375074
								],
								[
									-3.0645996093749943,
									53.51284179687494
								],
								[
									-3.0594726562500227,
									53.586230468750045
								],
								[
									-2.9957031249999773,
									53.66254882812507
								],
								[
									-2.9250976562499886,
									53.73276367187498
								],
								[
									-2.984326171874983,
									53.74672851562508
								],
								[
									-3.03178710937496,
									53.77358398437502
								],
								[
									-3.045361328124983,
									53.84384765625006
								],
								[
									-3.0267578124999943,
									53.905908203124994
								],
								[
									-2.8998535156250114,
									53.96069335937506
								],
								[
									-2.8624023437499204,
									54.04384765624994
								],
								[
									-2.84648437499996,
									54.1353027343751
								],
								[
									-2.8675781249999943,
									54.17724609375003
								],
								[
									-2.9935058593749773,
									54.17050781250006
								],
								[
									-3.054736328124932,
									54.15341796875006
								],
								[
									-3.109667968749932,
									54.12631835937495
								],
								[
									-3.1659667968749545,
									54.127929687500114
								],
								[
									-3.3215332031250284,
									54.22910156250012
								],
								[
									-3.4102539062499773,
									54.30561523437507
								],
								[
									-3.5693847656249886,
									54.46757812499993
								],
								[
									-3.5920410156249716,
									54.56435546875002
								],
								[
									-3.464599609374943,
									54.77309570312508
								],
								[
									-3.2679199218749204,
									54.90659179687512
								],
								[
									-3.0362304687499773,
									54.95307617187498
								],
								[
									-3.0810546874999716,
									54.96196289062493
								],
								[
									-3.434082031249943,
									54.96376953125002
								],
								[
									-3.5504394531249375,
									54.94741210937508
								],
								[
									-3.6583007812499773,
									54.892871093750074
								],
								[
									-3.719238281249943,
									54.87612304687494
								],
								[
									-3.783251953124932,
									54.86992187500002
								],
								[
									-3.841601562500017,
									54.842773437500085
								],
								[
									-3.8985839843749943,
									54.80507812500002
								],
								[
									-3.9579101562499943,
									54.78095703125001
								],
								[
									-4.075781249999949,
									54.78720703124995
								],
								[
									-4.1329589843749375,
									54.779248046874926
								],
								[
									-4.1740234374999545,
									54.80107421874993
								],
								[
									-4.208398437499966,
									54.837158203125
								],
								[
									-4.253417968749972,
									54.846777343750006
								],
								[
									-4.303662109375011,
									54.83569335937506
								],
								[
									-4.409912109374972,
									54.78706054687501
								],
								[
									-4.5174804687499375,
									54.75834960937493
								],
								[
									-4.647558593749977,
									54.789013671874955
								],
								[
									-4.818066406249983,
									54.84614257812504
								],
								[
									-4.851708984374994,
									54.82529296874998
								],
								[
									-4.889501953124977,
									54.77226562500002
								],
								[
									-4.911230468749977,
									54.689453125000114
								],
								[
									-5.032324218749949,
									54.76137695312511
								],
								[
									-5.135498046875,
									54.85751953125006
								],
								[
									-5.1701171874999545,
									54.917919921874926
								],
								[
									-5.172705078124949,
									54.98588867187502
								],
								[
									-5.11669921875,
									55.01225585937496
								],
								[
									-5.0558593749999545,
									54.98813476562512
								],
								[
									-4.965185546874949,
									55.14946289062502
								],
								[
									-4.784814453124966,
									55.35942382812499
								],
								[
									-4.7211425781249545,
									55.42099609375009
								],
								[
									-4.676757812499972,
									55.50131835937495
								],
								[
									-4.684374999999932,
									55.5539062500001
								],
								[
									-4.72416992187496,
									55.59829101562508
								],
								[
									-4.891845703125,
									55.69912109375011
								],
								[
									-4.8896484375,
									55.78120117187504
								],
								[
									-4.871679687499977,
									55.87392578125011
								],
								[
									-4.8260742187499375,
									55.92954101562506
								],
								[
									-4.806835937499926,
									55.9401367187501
								],
								[
									-4.58408203124992,
									55.93867187500004
								],
								[
									-4.67094726562496,
									55.96738281249995
								],
								[
									-4.844091796874977,
									56.051171874999966
								],
								[
									-4.8410156249999545,
									56.080859375000074
								],
								[
									-4.80029296875,
									56.15834960937505
								],
								[
									-4.819140624999932,
									56.15048828124995
								],
								[
									-4.85624999999996,
									56.11469726562504
								],
								[
									-4.927099609375006,
									56.02807617187497
								],
								[
									-4.9703613281249375,
									56.00786132812493
								],
								[
									-5.092822265625017,
									55.987304687500114
								],
								[
									-5.114990234375,
									55.94462890624993
								],
								[
									-5.134667968750023,
									55.93349609375005
								],
								[
									-5.19584960937496,
									55.92866210937507
								],
								[
									-5.214599609374943,
									55.88886718750004
								],
								[
									-5.228222656249983,
									55.886328125000034
								],
								[
									-5.245605468749972,
									55.929248046875074
								],
								[
									-5.247314453124943,
									56.00039062500011
								],
								[
									-5.22294921874996,
									56.06582031250002
								],
								[
									-5.176416015624994,
									56.11699218749996
								],
								[
									-4.9969726562499375,
									56.233349609374955
								],
								[
									-5.084326171874977,
									56.197460937499926
								],
								[
									-5.282324218749977,
									56.08994140625006
								],
								[
									-5.383447265624966,
									56.01923828125004
								],
								[
									-5.41044921874996,
									55.99536132812506
								],
								[
									-5.418896484375011,
									55.97524414062505
								],
								[
									-5.418310546874977,
									55.95205078124994
								],
								[
									-5.372900390624949,
									55.8276855468751
								],
								[
									-5.38583984374992,
									55.77011718750009
								],
								[
									-5.55644531249996,
									55.389599609374926
								],
								[
									-5.588769531249966,
									55.35141601562506
								],
								[
									-5.618457031249989,
									55.33144531250008
								],
								[
									-5.646533203124932,
									55.326855468749926
								],
								[
									-5.730664062499926,
									55.334130859374994
								],
								[
									-5.7682128906249375,
									55.362646484375034
								],
								[
									-5.76787109374996,
									55.394970703124955
								],
								[
									-5.7520996093749375,
									55.44345703125006
								],
								[
									-5.681347656250011,
									55.62397460937507
								],
								[
									-5.650634765624972,
									55.674121093750074
								],
								[
									-5.605029296874989,
									55.720751953125074
								],
								[
									-5.504492187499949,
									55.802392578124994
								],
								[
									-5.506933593750006,
									55.80771484375012
								],
								[
									-5.573876953124966,
									55.791699218749955
								],
								[
									-5.602392578125006,
									55.79697265625006
								],
								[
									-5.622851562499989,
									55.813134765624966
								],
								[
									-5.6095703124999545,
									56.055273437500006
								],
								[
									-5.555273437499977,
									56.13496093749998
								],
								[
									-5.534960937499932,
									56.25083007812506
								],
								[
									-5.487890624999949,
									56.350048828124926
								],
								[
									-5.433398437499932,
									56.4223144531251
								],
								[
									-5.39194335937492,
									56.51479492187511
								],
								[
									-5.329443359374977,
									56.55590820312494
								],
								[
									-5.3126953124999545,
									56.618798828124966
								],
								[
									-5.242578124999966,
									56.68686523437498
								],
								[
									-5.1883789062499375,
									56.758056640625
								],
								[
									-5.217578124999932,
									56.75102539062499
								],
								[
									-5.564208984374943,
									56.56572265624999
								],
								[
									-5.652441406249977,
									56.53198242187506
								],
								[
									-5.772802734374977,
									56.541015625000114
								],
								[
									-5.864843750000006,
									56.561865234375006
								],
								[
									-5.936767578125,
									56.60571289062506
								],
								[
									-5.968896484374966,
									56.68989257812507
								],
								[
									-6.057714843749949,
									56.692138671875085
								],
								[
									-6.133691406249966,
									56.70668945312502
								],
								[
									-6.1327636718749545,
									56.718017578125114
								],
								[
									-6.03471679687496,
									56.76391601562506
								],
								[
									-5.877636718749926,
									56.77963867187506
								],
								[
									-5.730615234374994,
									56.8530761718751
								],
								[
									-5.86142578124992,
									56.90268554687498
								],
								[
									-5.850390624999989,
									56.91840820312498
								],
								[
									-5.736279296875011,
									56.96064453125007
								],
								[
									-5.591308593749972,
									57.102343750000074
								],
								[
									-5.561914062500023,
									57.232714843750074
								],
								[
									-5.631250000000023,
									57.29394531250003
								],
								[
									-5.656347656249977,
									57.334082031250034
								],
								[
									-5.794921874999972,
									57.378808593749994
								],
								[
									-5.818066406249983,
									57.43608398437493
								],
								[
									-5.801953124999983,
									57.46801757812506
								],
								[
									-5.756738281249994,
									57.49921875000001
								],
								[
									-5.688623046874966,
									57.52353515625009
								],
								[
									-5.581787109374972,
									57.54677734375002
								],
								[
									-5.678759765625017,
									57.57167968749994
								],
								[
									-5.71494140624992,
									57.60107421874997
								],
								[
									-5.742382812500011,
									57.64365234374995
								],
								[
									-5.744921874999989,
									57.66831054687509
								],
								[
									-5.694726562499966,
									57.77822265625011
								],
								[
									-5.665478515624983,
									57.8235351562501
								],
								[
									-5.6083496093749545,
									57.88134765625006
								],
								[
									-5.349023437499994,
									57.87807617187511
								],
								[
									-5.319189453124949,
									57.903613281250074
								],
								[
									-5.289794921875,
									57.90458984374999
								],
								[
									-5.1572265625,
									57.88134765625006
								],
								[
									-5.176904296874994,
									57.90639648437511
								],
								[
									-5.3937499999999545,
									58.04360351562508
								],
								[
									-5.413183593750006,
									58.06972656250005
								],
								[
									-5.351367187499932,
									58.14370117187494
								],
								[
									-5.346874999999983,
									58.176660156249994
								],
								[
									-5.355957031249972,
									58.211914062500085
								],
								[
									-5.338281250000023,
									58.23872070312504
								],
								[
									-5.269531249999943,
									58.251416015624955
								],
								[
									-5.059960937499966,
									58.25014648437505
								],
								[
									-5.008300781250028,
									58.262646484374926
								],
								[
									-5.03183593749992,
									58.2982910156251
								],
								[
									-5.080615234375017,
									58.345166015624955
								],
								[
									-5.090136718749989,
									58.38452148437497
								],
								[
									-5.078710937499977,
									58.41928710937495
								],
								[
									-5.076025390624977,
									58.4892578125
								],
								[
									-5.066503906249977,
									58.5202148437501
								],
								[
									-5.016748046874966,
									58.56655273437494
								],
								[
									-4.975634765624932,
									58.580322265625085
								],
								[
									-4.924658203124949,
									58.58837890624994
								],
								[
									-4.80961914062496,
									58.57290039062508
								],
								[
									-4.765771484374994,
									58.55419921875
								],
								[
									-4.715429687499949,
									58.51000976562506
								],
								[
									-4.67822265625,
									58.51357421875008
								],
								[
									-4.53496093749996,
									58.56157226562499
								],
								[
									-4.491894531249983,
									58.56845703125006
								],
								[
									-4.4332519531249375,
									58.51284179687511
								],
								[
									-4.188623046875023,
									58.55722656250009
								],
								[
									-3.8595214843749375,
									58.577099609374955
								],
								[
									-3.661816406249983,
									58.60629882812495
								],
								[
									-3.4535644531250114,
									58.61689453124998
								],
								[
									-3.2591308593749204,
									58.64999999999998
								],
								[
									-3.053076171874949,
									58.63481445312499
								],
								[
									-3.04619140624996,
									58.61552734374996
								],
								[
									-3.056982421874949,
									58.58876953124994
								],
								[
									-3.109667968749932,
									58.515478515625006
								]
							]
						],
						[
							[
								[
									-2.929394531249983,
									58.74160156250008
								],
								[
									-2.9389648437499716,
									58.73862304687509
								],
								[
									-2.975390624999932,
									58.75693359375009
								],
								[
									-3.0354492187499886,
									58.82265625000005
								],
								[
									-2.9412109374999886,
									58.83569335937497
								],
								[
									-2.896435546874926,
									58.82758789062501
								],
								[
									-2.913085937499943,
									58.79960937499999
								],
								[
									-2.929394531249983,
									58.74160156250008
								]
							]
						],
						[
							[
								[
									-3.1649414062499943,
									58.79418945312494
								],
								[
									-3.222119140624926,
									58.78095703125001
								],
								[
									-3.2788085937500284,
									58.78193359375004
								],
								[
									-3.3671875,
									58.839746093749994
								],
								[
									-3.400830078124926,
									58.88178710937504
								],
								[
									-3.394726562499926,
									58.909619140624926
								],
								[
									-3.3574218749999716,
									58.918994140625074
								],
								[
									-3.2719238281249545,
									58.90527343750003
								],
								[
									-3.2276367187499773,
									58.857177734375085
								],
								[
									-3.222119140624926,
									58.825878906249926
								],
								[
									-3.211621093749926,
									58.81357421875009
								],
								[
									-3.158544921874949,
									58.801220703124955
								],
								[
									-3.1649414062499943,
									58.79418945312494
								]
							]
						],
						[
							[
								[
									-3.05742187499996,
									59.02963867187495
								],
								[
									-3.0707031249999943,
									59.00498046875009
								],
								[
									-2.99467773437496,
									59.00556640625001
								],
								[
									-2.8845703124999886,
									58.984521484374994
								],
								[
									-2.817919921875017,
									58.9818847656251
								],
								[
									-2.7624511718749716,
									58.955810546875114
								],
								[
									-2.7930175781249886,
									58.90693359375001
								],
								[
									-2.826220703125017,
									58.89326171875007
								],
								[
									-2.8637695312500284,
									58.89052734375002
								],
								[
									-2.994824218749983,
									58.93935546875002
								],
								[
									-3.1666015624999773,
									58.919091796874994
								],
								[
									-3.2007812499999204,
									58.925292968750114
								],
								[
									-3.2233398437500114,
									58.9387695312501
								],
								[
									-3.232617187499926,
									58.955517578124955
								],
								[
									-3.232812499999966,
									58.98964843750008
								],
								[
									-3.242138671874926,
									58.99970703124998
								],
								[
									-3.3043457031249943,
									58.96743164062508
								],
								[
									-3.331640624999949,
									58.97124023437496
								],
								[
									-3.3470703124999943,
									58.98671875000008
								],
								[
									-3.3537109375000114,
									59.018749999999955
								],
								[
									-3.3468261718749375,
									59.06499023437496
								],
								[
									-3.31035156249996,
									59.130810546874955
								],
								[
									-3.2485839843749886,
									59.143945312499966
								],
								[
									-3.1564941406249716,
									59.13632812500012
								],
								[
									-3.0511230468750057,
									59.099023437499966
								],
								[
									-3.019238281249983,
									59.07602539062509
								],
								[
									-3.0200195312499716,
									59.057666015625074
								],
								[
									-3.05742187499996,
									59.02963867187495
								]
							]
						],
						[
							[
								[
									-2.5488769531249886,
									59.23134765625002
								],
								[
									-2.6620605468749545,
									59.230175781249955
								],
								[
									-2.603613281249949,
									59.289306640625085
								],
								[
									-2.5356445312499716,
									59.304150390624926
								],
								[
									-2.406982421874943,
									59.29755859375001
								],
								[
									-2.4298339843749943,
									59.27104492187502
								],
								[
									-2.5488769531249886,
									59.23134765625002
								]
							]
						],
						[
							[
								[
									-2.7293945312499943,
									59.186767578125085
								],
								[
									-2.8152343749999886,
									59.16191406249999
								],
								[
									-2.8518554687499886,
									59.182470703125006
								],
								[
									-2.8614257812499773,
									59.24682617187497
								],
								[
									-2.963769531249966,
									59.27436523437498
								],
								[
									-3.01347656249996,
									59.29145507812501
								],
								[
									-3.052050781250017,
									59.32387695312502
								],
								[
									-3.0422363281249716,
									59.33383789062512
								],
								[
									-2.9755371093749545,
									59.34711914062507
								],
								[
									-2.861621093749932,
									59.288330078125085
								],
								[
									-2.815039062499949,
									59.24082031250009
								],
								[
									-2.730664062499983,
									59.22675781250007
								],
								[
									-2.719921874999926,
									59.219482421875
								],
								[
									-2.7293945312499943,
									59.186767578125085
								]
							]
						],
						[
							[
								[
									-1.30810546875,
									60.53750000000002
								],
								[
									-1.2874023437499602,
									60.46704101562506
								],
								[
									-1.2357421874999943,
									60.485302734374955
								],
								[
									-1.157763671875017,
									60.41772460937494
								],
								[
									-1.1179687499999886,
									60.41762695312502
								],
								[
									-1.0524414062499545,
									60.44448242187508
								],
								[
									-1.0656738281249716,
									60.38159179687506
								],
								[
									-1.1336914062499943,
									60.20698242187501
								],
								[
									-1.1527832031249545,
									60.177343750000006
								],
								[
									-1.165722656249926,
									60.12426757812494
								],
								[
									-1.1792480468749318,
									60.113916015624966
								],
								[
									-1.1993164062499488,
									60.00659179687494
								],
								[
									-1.245312499999983,
									59.9712402343751
								],
								[
									-1.2837890624999204,
									59.88691406249998
								],
								[
									-1.2994628906249943,
									59.878662109375
								],
								[
									-1.3558593749999375,
									59.91113281249994
								],
								[
									-1.299511718749926,
									60.039843750000045
								],
								[
									-1.2761718749999602,
									60.11464843749994
								],
								[
									-1.290917968749966,
									60.15346679687494
								],
								[
									-1.3228027343749602,
									60.18837890624994
								],
								[
									-1.4090332031249488,
									60.18950195312499
								],
								[
									-1.4814941406249602,
									60.173388671875074
								],
								[
									-1.4968749999999886,
									60.19399414062494
								],
								[
									-1.4991210937499204,
									60.22177734375009
								],
								[
									-1.5166015625,
									60.23100585937502
								],
								[
									-1.6130371093749432,
									60.22910156249998
								],
								[
									-1.6413574218749432,
									60.23676757812504
								],
								[
									-1.6600585937500227,
									60.26225585937499
								],
								[
									-1.663769531249983,
									60.2825195312501
								],
								[
									-1.57666015625,
									60.298388671875074
								],
								[
									-1.4944335937499318,
									60.292480468750114
								],
								[
									-1.3746093749999488,
									60.332910156249994
								],
								[
									-1.4495605468749488,
									60.4685546875001
								],
								[
									-1.548828125,
									60.48129882812512
								],
								[
									-1.5717773437499716,
									60.49443359375013
								],
								[
									-1.5526367187499943,
									60.517431640625006
								],
								[
									-1.4981445312499773,
									60.52983398437496
								],
								[
									-1.4142089843749375,
									60.59873046875006
								],
								[
									-1.3639648437500114,
									60.609570312499955
								],
								[
									-1.301708984374926,
									60.607666015625085
								],
								[
									-1.30810546875,
									60.53750000000002
								]
							]
						],
						[
							[
								[
									-1.0425292968749886,
									60.5138671875001
								],
								[
									-1.06787109375,
									60.50229492187495
								],
								[
									-1.16552734375,
									60.60390625000005
								],
								[
									-1.0933105468749318,
									60.72021484375003
								],
								[
									-1.005615234375,
									60.71650390624998
								],
								[
									-0.9916503906250114,
									60.686035156250085
								],
								[
									-1.0003417968750057,
									60.65800781249996
								],
								[
									-1.0450195312499488,
									60.655517578125085
								],
								[
									-1.0490234374999545,
									60.646923828124926
								],
								[
									-1.035107421874983,
									60.59291992187494
								],
								[
									-1.0342285156249602,
									60.53017578124994
								],
								[
									-1.0425292968749886,
									60.5138671875001
								]
							]
						],
						[
							[
								[
									-0.7742675781249488,
									60.81196289062507
								],
								[
									-0.7743164062499659,
									60.80048828125004
								],
								[
									-0.8261718749999432,
									60.71616210937509
								],
								[
									-0.8254882812499886,
									60.683935546875006
								],
								[
									-0.909130859374983,
									60.687011718750085
								],
								[
									-0.9222656249999943,
									60.69726562499997
								],
								[
									-0.9380859374999204,
									60.74565429687496
								],
								[
									-0.9275390624999886,
									60.797167968750074
								],
								[
									-0.915820312500017,
									60.81044921874994
								],
								[
									-0.891406250000017,
									60.81591796875006
								],
								[
									-0.8649414062499545,
									60.805810546874966
								],
								[
									-0.8234374999999261,
									60.83188476562495
								],
								[
									-0.8018066406249602,
									60.8312500000001
								],
								[
									-0.7742675781249488,
									60.81196289062507
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "GBR",
					"su_a3": "GBR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "GBR",
					"gu_a3": "GBR",
					"abbrev": "U.K.",
					"region_un": "Europe",
					"adm0_a3_us": "GBR",
					"scalerank": 1,
					"pop_est": 62262000,
					"adm0_dif": 1,
					"un_a3": "826",
					"pop_year": 0,
					"gdp_md_est": 1977704,
					"name": "United Kingdom",
					"sovereignt": "United Kingdom",
					"economy": "1. Developed region: G7",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": 2009,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "United Kingdom",
					"postal": "GB",
					"sov_a3": "GB1",
					"note_brk": "",
					"brk_a3": "GBR",
					"wb_a2": "GB",
					"brk_diff": 0,
					"admin": "United Kingdom",
					"name_long": "United Kingdom",
					"iso_a3": "GBR",
					"iso_a2": "GB",
					"adm0_a3_is": "GBR",
					"level": 2,
					"formal_en": "United Kingdom of Great Britain and Northern Ireland",
					"name_len": 14,
					"mapcolor7": 6,
					"long_len": 14,
					"mapcolor8": 6,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "826",
					"homepart": 1,
					"subunit": "United Kingdom",
					"name_alt": "",
					"brk_name": "United Kingdom",
					"name_sort": "United Kingdom",
					"continent": "Europe",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								46.42988281250007,
								41.890966796875034
							],
							[
								46.40546875000007,
								41.85507812500012
							],
							[
								46.348242187500034,
								41.79018554687502
							],
							[
								46.30253906250016,
								41.75708007812503
							],
							[
								46.251855468750136,
								41.75175781250002
							],
							[
								46.20185546875007,
								41.7368652343751
							],
							[
								46.18427734375001,
								41.70214843750003
							],
							[
								46.182128906250114,
								41.657080078125006
							],
							[
								46.190527343750034,
								41.624853515625006
							],
							[
								46.203515625000136,
								41.6125976562501
							],
							[
								46.254687500000045,
								41.602148437500006
							],
							[
								46.305468750000045,
								41.50771484375005
							],
							[
								46.38496093750007,
								41.459863281249966
							],
							[
								46.50878906250006,
								41.40556640625002
							],
							[
								46.618945312500045,
								41.34375000000003
							],
							[
								46.67255859375001,
								41.28681640625007
							],
							[
								46.66240234374999,
								41.245507812499994
							],
							[
								46.626367187500136,
								41.159667968750085
							],
							[
								46.53437500000001,
								41.0885742187501
							],
							[
								46.45791015625008,
								41.070214843749994
							],
							[
								46.43095703124999,
								41.077050781249966
							],
							[
								46.38076171875008,
								41.09931640625007
							],
							[
								46.27998046875018,
								41.15444335937511
							],
							[
								46.17070312499999,
								41.19785156250006
							],
							[
								46.08652343750009,
								41.18383789062506
							],
							[
								46.031250000000114,
								41.16728515624996
							],
							[
								45.921972656250034,
								41.18671875000001
							],
							[
								45.792773437500045,
								41.22441406249996
							],
							[
								45.72548828125008,
								41.261621093749994
							],
							[
								45.695703125000136,
								41.28901367187498
							],
							[
								45.715625000000045,
								41.33764648437503
							],
							[
								45.422265625000136,
								41.42529296875003
							],
							[
								45.28095703125001,
								41.449560546875006
							],
							[
								45.21718750000008,
								41.42319335937506
							],
							[
								45.001367187499966,
								41.29096679687501
							],
							[
								44.975878906250045,
								41.27749023437502
							],
							[
								44.81132812499999,
								41.25937499999998
							],
							[
								44.81093750000002,
								41.2485839843751
							],
							[
								44.848535156250136,
								41.22016601562498
							],
							[
								44.84140625000009,
								41.21137695312507
							],
							[
								44.564843750000136,
								41.20820312500004
							],
							[
								44.47304687500002,
								41.19101562500009
							],
							[
								44.22734375000016,
								41.21333007812501
							],
							[
								44.146484375000114,
								41.20336914062503
							],
							[
								44.077246093750034,
								41.18251953125005
							],
							[
								43.90917968750006,
								41.15898437499996
							],
							[
								43.79316406250007,
								41.13110351562506
							],
							[
								43.64501953125,
								41.11665039062504
							],
							[
								43.491992187500045,
								41.11552734374999
							],
							[
								43.439453125000114,
								41.10712890625004
							],
							[
								43.44160156250001,
								41.125976562500085
							],
							[
								43.433398437500045,
								41.15551757812506
							],
							[
								43.402343750000114,
								41.17656249999999
							],
							[
								43.358984375000034,
								41.1901367187501
							],
							[
								43.279296875,
								41.185205078124966
							],
							[
								43.205468750000136,
								41.19916992187507
							],
							[
								43.15283203125,
								41.23642578125009
							],
							[
								43.14101562500008,
								41.26484375000004
							],
							[
								43.17128906250002,
								41.287939453125034
							],
							[
								43.14902343750009,
								41.30712890625003
							],
							[
								43.057128906250114,
								41.35283203125002
							],
							[
								42.906738281250114,
								41.466845703125074
							],
							[
								42.821679687500136,
								41.49238281250001
							],
							[
								42.787890625000045,
								41.563720703125085
							],
							[
								42.75410156250001,
								41.578906250000074
							],
							[
								42.682421875000045,
								41.585742187500045
							],
							[
								42.606835937500136,
								41.57880859375004
							],
							[
								42.59042968750009,
								41.570703124999994
							],
							[
								42.5673828125,
								41.55927734375007
							],
							[
								42.507910156250034,
								41.470068359375006
							],
							[
								42.466406250000034,
								41.43984375000008
							],
							[
								42.364355468750034,
								41.45400390625002
							],
							[
								42.27998046875007,
								41.47500000000002
							],
							[
								42.21113281250018,
								41.48671875000002
							],
							[
								42.07773437500009,
								41.49409179687501
							],
							[
								41.925781250000114,
								41.495654296875074
							],
							[
								41.823535156250045,
								41.43237304687506
							],
							[
								41.779394531250034,
								41.440527343750034
							],
							[
								41.701757812500034,
								41.47158203125005
							],
							[
								41.576562500000136,
								41.49731445312506
							],
							[
								41.510058593750045,
								41.51748046875008
							],
							[
								41.701757812500034,
								41.705419921875006
							],
							[
								41.7587890625,
								41.81713867187503
							],
							[
								41.76074218750006,
								41.884863281250034
							],
							[
								41.76298828124999,
								41.97001953124999
							],
							[
								41.66328125000001,
								42.14687500000005
							],
							[
								41.57773437500009,
								42.39785156250002
							],
							[
								41.48876953125,
								42.659326171874994
							],
							[
								41.41943359375,
								42.73764648437506
							],
							[
								41.12871093749999,
								42.828125
							],
							[
								41.06162109375009,
								42.93085937499998
							],
							[
								40.83662109375001,
								43.0634765625
							],
							[
								40.52402343750009,
								43.12104492187501
							],
							[
								40.46210937500001,
								43.14570312500004
							],
							[
								40.19062500000001,
								43.312402343749994
							],
							[
								39.978320312500045,
								43.41982421875002
							],
							[
								40.023730468750045,
								43.48486328125006
							],
							[
								40.08457031250009,
								43.55312500000011
							],
							[
								40.15019531250016,
								43.56977539062504
							],
							[
								40.342285156250114,
								43.54272460937503
							],
							[
								40.518945312500136,
								43.512011718750074
							],
							[
								40.648046875000034,
								43.5338867187501
							],
							[
								40.80166015625008,
								43.47993164062501
							],
							[
								40.941992187500034,
								43.418066406250034
							],
							[
								41.083105468750034,
								43.37446289062504
							],
							[
								41.358203125000045,
								43.33339843750011
							],
							[
								41.46074218750016,
								43.27631835937501
							],
							[
								41.58056640625006,
								43.21923828125003
							],
							[
								42.05000000000001,
								43.19013671875004
							],
							[
								42.08779296875008,
								43.19912109375011
							],
							[
								42.12226562500007,
								43.20732421874999
							],
							[
								42.27968750000002,
								43.22807617187496
							],
							[
								42.419042968750034,
								43.22421875000006
							],
							[
								42.56601562500009,
								43.15512695312512
							],
							[
								42.66025390625009,
								43.15908203125002
							],
							[
								42.760644531250136,
								43.16958007812502
							],
							[
								42.89003906250002,
								43.13261718749996
							],
							[
								42.99160156250008,
								43.09150390625001
							],
							[
								43.00019531250007,
								43.04965820312512
							],
							[
								43.089160156250045,
								42.98906250000002
							],
							[
								43.347949218750045,
								42.89667968750004
							],
							[
								43.55781250000018,
								42.84448242187497
							],
							[
								43.623046875000114,
								42.807714843750034
							],
							[
								43.782617187500136,
								42.74702148437501
							],
							[
								43.798730468750136,
								42.727783203125
							],
							[
								43.79541015625006,
								42.702978515625006
							],
							[
								43.749902343750136,
								42.657519531250074
							],
							[
								43.73837890625009,
								42.61699218749999
							],
							[
								43.759863281250034,
								42.59384765624998
							],
							[
								43.8259765625001,
								42.57153320312506
							],
							[
								43.957421875000136,
								42.56655273437511
							],
							[
								44.004687500000045,
								42.59560546875008
							],
							[
								44.10273437500007,
								42.61635742187502
							],
							[
								44.199707031250114,
								42.65361328124999
							],
							[
								44.32949218750008,
								42.70351562500002
							],
							[
								44.505859375000114,
								42.74863281249998
							],
							[
								44.576464843750045,
								42.74848632812504
							],
							[
								44.64433593749999,
								42.73471679687509
							],
							[
								44.69179687500008,
								42.70961914062502
							],
							[
								44.77109375000009,
								42.616796875000034
							],
							[
								44.85048828125008,
								42.74682617187497
							],
							[
								44.87099609375008,
								42.75639648437496
							],
							[
								44.943359375,
								42.730273437500074
							],
							[
								45.07158203124999,
								42.694140625000074
							],
							[
								45.160253906250034,
								42.67500000000007
							],
							[
								45.20820312500001,
								42.64824218749996
							],
							[
								45.343750000000114,
								42.529785156250085
							],
							[
								45.56289062500008,
								42.535742187500034
							],
							[
								45.65556640625016,
								42.517675781250006
							],
							[
								45.70527343750007,
								42.49809570312502
							],
							[
								45.72753906250006,
								42.47504882812501
							],
							[
								45.68837890625008,
								42.35737304687504
							],
							[
								45.63427734375006,
								42.23471679687509
							],
							[
								45.638574218750136,
								42.205078125
							],
							[
								45.726562500000114,
								42.15888671875001
							],
							[
								45.845996093750045,
								42.10996093750006
							],
							[
								45.91035156250007,
								42.07070312500008
							],
							[
								45.95400390625002,
								42.035400390625085
							],
							[
								46.048437500000034,
								42.00874023437507
							],
							[
								46.15976562500009,
								41.992041015625034
							],
							[
								46.212695312500045,
								41.98989257812505
							],
							[
								46.26777343750018,
								41.960351562499966
							],
							[
								46.411523437500136,
								41.90463867187509
							],
							[
								46.42988281250007,
								41.890966796875034
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "GEO",
					"su_a3": "GEO",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "GEO",
					"gu_a3": "GEO",
					"abbrev": "Geo.",
					"region_un": "Asia",
					"adm0_a3_us": "GEO",
					"scalerank": 1,
					"pop_est": 4615807,
					"adm0_dif": 0,
					"un_a3": "268",
					"pop_year": -99,
					"gdp_md_est": 21510,
					"name": "Georgia",
					"sovereignt": "Georgia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Georgia",
					"postal": "GE",
					"sov_a3": "GEO",
					"note_brk": "",
					"brk_a3": "GEO",
					"wb_a2": "GE",
					"brk_diff": 0,
					"admin": "Georgia",
					"name_long": "Georgia",
					"iso_a3": "GEO",
					"iso_a2": "GE",
					"adm0_a3_is": "GEO",
					"level": 2,
					"formal_en": "Georgia",
					"name_len": 7,
					"mapcolor7": 5,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "268",
					"homepart": 1,
					"subunit": "Georgia",
					"name_alt": "",
					"brk_name": "Georgia",
					"name_sort": "Georgia",
					"continent": "Asia",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2002
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									23.852246093749983,
									35.535449218750045
								],
								[
									23.920605468750068,
									35.52817382812498
								],
								[
									24.013281250000034,
									35.52944335937505
								],
								[
									24.034375000000068,
									35.53540039062494
								],
								[
									24.093359375000006,
									35.59384765624995
								],
								[
									24.166015625000057,
									35.59521484375006
								],
								[
									24.19775390625003,
									35.537451171875006
								],
								[
									24.12402343750003,
									35.510839843750006
								],
								[
									24.108984374999977,
									35.495800781249955
								],
								[
									24.123144531250034,
									35.48364257812497
								],
								[
									24.178515625000017,
									35.45952148437502
								],
								[
									24.255371093750057,
									35.46860351562509
								],
								[
									24.25771484375008,
									35.42314453124999
								],
								[
									24.27490234375003,
									35.38598632812497
								],
								[
									24.31289062500005,
									35.363818359375074
								],
								[
									24.35400390624997,
									35.35947265625006
								],
								[
									24.444921875000034,
									35.36601562499999
								],
								[
									24.534570312499994,
									35.380761718749966
								],
								[
									24.626953125,
									35.40991210937506
								],
								[
									24.721289062500034,
									35.42480468749997
								],
								[
									25.003125000000068,
									35.40986328125004
								],
								[
									25.104296875000074,
									35.346923828125
								],
								[
									25.296777343750023,
									35.33935546874997
								],
								[
									25.475683593750063,
									35.306201171875045
								],
								[
									25.569628906250017,
									35.32807617187498
								],
								[
									25.73017578125004,
									35.34858398437498
								],
								[
									25.75585937500003,
									35.32636718750007
								],
								[
									25.735156250000074,
									35.18403320312504
								],
								[
									25.74501953125005,
									35.142724609374966
								],
								[
									25.791308593750045,
									35.1228515625001
								],
								[
									25.837109375000068,
									35.13256835937494
								],
								[
									25.893359375000074,
									35.17919921874994
								],
								[
									26.028027343750068,
									35.21528320312501
								],
								[
									26.167871093750023,
									35.21508789062497
								],
								[
									26.285546875000023,
									35.30976562499998
								],
								[
									26.32021484375008,
									35.315136718749926
								],
								[
									26.298632812500017,
									35.268603515625045
								],
								[
									26.280859375000063,
									35.15922851562496
								],
								[
									26.25556640625004,
									35.09516601562504
								],
								[
									26.244335937500068,
									35.04467773437506
								],
								[
									26.165625000000034,
									35.018603515625074
								],
								[
									26.046679687500045,
									35.01416015625006
								],
								[
									25.829687500000063,
									35.0251953125001
								],
								[
									25.610937500000006,
									35.007324218750085
								],
								[
									25.20576171875004,
									34.95927734374999
								],
								[
									24.79980468750003,
									34.934472656249994
								],
								[
									24.745214843750006,
									34.95063476562501
								],
								[
									24.743945312500017,
									35.014355468749926
								],
								[
									24.735156250000017,
									35.0583007812501
								],
								[
									24.70888671875008,
									35.08906250000004
								],
								[
									24.583398437499994,
									35.11533203125006
								],
								[
									24.463671875000045,
									35.16035156250001
								],
								[
									23.994335937500068,
									35.22192382812494
								],
								[
									23.883593750000074,
									35.24609375000006
								],
								[
									23.703906250000045,
									35.23349609375009
								],
								[
									23.63808593750005,
									35.235156250000074
								],
								[
									23.59277343749997,
									35.25722656249994
								],
								[
									23.561621093750034,
									35.29516601562494
								],
								[
									23.54755859375001,
									35.41557617187496
								],
								[
									23.56982421875,
									35.53476562500009
								],
								[
									23.608691406250017,
									35.56625976562509
								],
								[
									23.626562500000034,
									35.53037109375006
								],
								[
									23.67265624999999,
									35.513916015625085
								],
								[
									23.715429687500006,
									35.55014648437512
								],
								[
									23.71503906250001,
									35.60473632812494
								],
								[
									23.736914062500034,
									35.655517578125085
								],
								[
									23.770800781250017,
									35.63422851562501
								],
								[
									23.79335937500008,
									35.5562011718751
								],
								[
									23.852246093749983,
									35.535449218750045
								]
							]
						],
						[
							[
								[
									27.17607421874999,
									35.465283203124955
								],
								[
									27.13789062500004,
									35.409082031249966
								],
								[
									27.09912109375003,
									35.45644531249994
								],
								[
									27.115820312500063,
									35.51113281250005
								],
								[
									27.070703125000023,
									35.59775390624995
								],
								[
									27.156054687500017,
									35.726269531249926
								],
								[
									27.158007812500045,
									35.788671875000034
								],
								[
									27.22314453125,
									35.82045898437502
								],
								[
									27.20703125,
									35.714453125000006
								],
								[
									27.15722656249997,
									35.62949218750012
								],
								[
									27.208886718750023,
									35.558935546875034
								],
								[
									27.233593749999983,
									35.4785644531251
								],
								[
									27.17607421874999,
									35.465283203124955
								]
							]
						],
						[
							[
								[
									23.053808593750034,
									36.18979492187495
								],
								[
									23.042187500000068,
									36.14638671875008
								],
								[
									22.93945312500003,
									36.17622070312501
								],
								[
									22.91083984375004,
									36.220996093750074
								],
								[
									22.90566406250005,
									36.32031250000006
								],
								[
									22.932617187500057,
									36.36875000000009
								],
								[
									22.950488281250045,
									36.38393554687505
								],
								[
									22.997851562500017,
									36.32812499999997
								],
								[
									23.09707031250005,
									36.24658203124997
								],
								[
									23.053808593750034,
									36.18979492187495
								]
							]
						],
						[
							[
								[
									27.84277343750003,
									35.92929687500009
								],
								[
									27.770605468750063,
									35.90830078124998
								],
								[
									27.745703125000063,
									35.911035156249994
								],
								[
									27.71552734375004,
									35.95732421875002
								],
								[
									27.75732421875003,
									36.06918945312498
								],
								[
									27.71865234375005,
									36.14111328124997
								],
								[
									27.71630859375,
									36.17158203125007
								],
								[
									27.77441406250003,
									36.21376953125002
								],
								[
									27.815234375000017,
									36.276953125000034
								],
								[
									27.91445312500005,
									36.345312500000006
								],
								[
									28.171484375000006,
									36.42622070312507
								],
								[
									28.23183593750005,
									36.433642578125074
								],
								[
									28.230078125000063,
									36.37026367187494
								],
								[
									28.14404296875003,
									36.20986328125005
								],
								[
									28.067675781250017,
									36.12968749999996
								],
								[
									28.087792968750023,
									36.065332031249994
								],
								[
									27.965527343750068,
									36.04750976562508
								],
								[
									27.84277343750003,
									35.92929687500009
								]
							]
						],
						[
							[
								[
									25.482421875,
									36.392626953125045
								],
								[
									25.43593750000005,
									36.340087890625114
								],
								[
									25.37050781250005,
									36.358935546875045
								],
								[
									25.39716796875004,
									36.37895507812493
								],
								[
									25.412890625000045,
									36.40488281249998
								],
								[
									25.414648437500063,
									36.44228515625005
								],
								[
									25.39687500000008,
									36.46533203124994
								],
								[
									25.408984375000074,
									36.47373046875006
								],
								[
									25.467382812500063,
									36.43505859375
								],
								[
									25.482421875,
									36.392626953125045
								]
							]
						],
						[
							[
								[
									26.460644531249983,
									36.58540039062498
								],
								[
									26.381640625000074,
									36.5615234375
								],
								[
									26.33144531250005,
									36.51137695312508
								],
								[
									26.270019531250057,
									36.54692382812496
								],
								[
									26.269824218750017,
									36.59541015624998
								],
								[
									26.337011718750034,
									36.58056640624997
								],
								[
									26.38417968750005,
									36.60786132812504
								],
								[
									26.370019531249994,
									36.63857421875008
								],
								[
									26.42128906250005,
									36.62421874999998
								],
								[
									26.460644531249983,
									36.58540039062498
								]
							]
						],
						[
							[
								[
									27.860156250000017,
									36.55390625000004
								],
								[
									27.83828125000008,
									36.53798828125011
								],
								[
									27.78808593749997,
									36.58369140625007
								],
								[
									27.785742187500034,
									36.60751953125006
								],
								[
									27.83681640625005,
									36.63486328125012
								],
								[
									27.86250000000004,
									36.641162109375074
								],
								[
									27.86982421875001,
									36.6225097656251
								],
								[
									27.86904296875005,
									36.58266601562505
								],
								[
									27.860156250000017,
									36.55390625000004
								]
							]
						],
						[
							[
								[
									24.535742187500063,
									36.76376953125009
								],
								[
									24.53750000000005,
									36.705029296874926
								],
								[
									24.530664062499994,
									36.683984374999994
								],
								[
									24.325976562500045,
									36.65561523437509
								],
								[
									24.34492187500001,
									36.72299804687495
								],
								[
									24.357421875000057,
									36.74428710937494
								],
								[
									24.425195312500023,
									36.712939453125045
								],
								[
									24.45019531250003,
									36.72895507812501
								],
								[
									24.46035156250008,
									36.74746093750005
								],
								[
									24.535742187500063,
									36.76376953125009
								]
							]
						],
						[
							[
								[
									25.381738281250023,
									36.67402343750001
								],
								[
									25.364355468750034,
									36.65834960937511
								],
								[
									25.288671875000063,
									36.721533203125006
								],
								[
									25.259960937499983,
									36.75844726562508
								],
								[
									25.29589843750003,
									36.78916015625012
								],
								[
									25.40693359375001,
									36.717333984375045
								],
								[
									25.381738281250023,
									36.67402343750001
								]
							]
						],
						[
							[
								[
									26.94960937500005,
									36.72709960937499
								],
								[
									26.91835937500008,
									36.72592773437509
								],
								[
									26.95556640625003,
									36.77421874999999
								],
								[
									27.061132812500034,
									36.840380859375074
								],
								[
									27.214941406250006,
									36.89863281250004
								],
								[
									27.26562500000003,
									36.90512695312512
								],
								[
									27.352148437499977,
									36.868896484375085
								],
								[
									27.193164062500017,
									36.8091308593751
								],
								[
									27.150976562500034,
									36.77758789062497
								],
								[
									27.033593750000023,
									36.770751953125
								],
								[
									26.94960937500005,
									36.72709960937499
								]
							]
						],
						[
							[
								[
									25.85937499999997,
									36.79042968750011
								],
								[
									25.771093750000034,
									36.78222656250003
								],
								[
									25.74316406250003,
									36.789746093749955
								],
								[
									25.796777343750023,
									36.80703125000002
								],
								[
									25.83437500000005,
									36.82539062500004
								],
								[
									25.85244140625008,
									36.84755859375011
								],
								[
									25.941992187500034,
									36.88657226562506
								],
								[
									26.000683593749983,
									36.93740234375002
								],
								[
									26.06445312500003,
									36.90273437500005
								],
								[
									25.984667968750017,
									36.87968749999999
								],
								[
									25.85937499999997,
									36.79042968750011
								]
							]
						],
						[
							[
								[
									24.72089843750004,
									36.92143554687496
								],
								[
									24.702636718750057,
									36.91708984375006
								],
								[
									24.67646484375004,
									36.959277343750045
								],
								[
									24.670996093750006,
									36.99858398437496
								],
								[
									24.681445312500074,
									37.02163085937505
								],
								[
									24.716113281250045,
									37.02382812500005
								],
								[
									24.76318359375003,
									36.94921874999994
								],
								[
									24.72089843750004,
									36.92143554687496
								]
							]
						],
						[
							[
								[
									27.01972656250004,
									36.95903320312499
								],
								[
									26.91992187500003,
									36.94521484375011
								],
								[
									26.93769531250001,
									37.02460937500001
								],
								[
									26.88867187499997,
									37.08725585937509
								],
								[
									26.966601562500045,
									37.052099609375034
								],
								[
									27.01601562500008,
									37.009667968749994
								],
								[
									27.040136718750006,
									37.00156249999995
								],
								[
									27.034570312500023,
									36.97597656250005
								],
								[
									27.01972656250004,
									36.95903320312499
								]
							]
						],
						[
							[
								[
									25.278906250000034,
									37.068408203125074
								],
								[
									25.19941406250001,
									36.99130859375009
								],
								[
									25.13330078125003,
									36.99965820312508
								],
								[
									25.105468750000057,
									37.0349609375001
								],
								[
									25.146484375000057,
									37.107421875000114
								],
								[
									25.235058593750068,
									37.148535156250034
								],
								[
									25.275292968749994,
									37.137841796874994
								],
								[
									25.27148437500003,
									37.08417968750007
								],
								[
									25.278906250000034,
									37.068408203125074
								]
							]
						],
						[
							[
								[
									25.54589843749997,
									36.967578125000045
								],
								[
									25.45673828125001,
									36.92968750000006
								],
								[
									25.39589843750005,
									36.984375
								],
								[
									25.361914062500063,
									37.070410156250034
								],
								[
									25.52529296875005,
									37.19638671875012
								],
								[
									25.564355468749994,
									37.185107421875045
								],
								[
									25.587890625,
									37.15253906250007
								],
								[
									25.584277343750074,
									37.039306640625
								],
								[
									25.54589843749997,
									36.967578125000045
								]
							]
						],
						[
							[
								[
									24.523535156250063,
									37.12509765624998
								],
								[
									24.486523437500068,
									37.11005859375001
								],
								[
									24.42480468750003,
									37.13198242187505
								],
								[
									24.441210937500074,
									37.18686523437495
								],
								[
									24.48378906250005,
									37.210205078125
								],
								[
									24.529101562500045,
									37.1923339843751
								],
								[
									24.535937500000017,
									37.16767578125004
								],
								[
									24.523535156250063,
									37.12509765624998
								]
							]
						],
						[
							[
								[
									24.43574218750004,
									37.34443359374998
								],
								[
									24.37890625,
									37.31411132812494
								],
								[
									24.397753906250017,
									37.38344726562494
								],
								[
									24.369726562499977,
									37.41962890625004
								],
								[
									24.394824218750045,
									37.45039062500007
								],
								[
									24.431250000000006,
									37.47519531249998
								],
								[
									24.448535156250045,
									37.44956054687509
								],
								[
									24.4814453125,
									37.408007812500074
								],
								[
									24.43574218750004,
									37.34443359374998
								]
							]
						],
						[
							[
								[
									24.942871093750057,
									37.49350585937498
								],
								[
									24.937890625000023,
									37.389697265625074
								],
								[
									24.91152343750005,
									37.39057617187507
								],
								[
									24.89619140625004,
									37.40659179687495
								],
								[
									24.895312500000045,
									37.44633789062496
								],
								[
									24.906542968750017,
									37.508886718750006
								],
								[
									24.942871093750057,
									37.49350585937498
								]
							]
						],
						[
							[
								[
									25.402734375000023,
									37.419140624999926
								],
								[
									25.30712890625,
									37.41298828125011
								],
								[
									25.312695312500068,
									37.48930664062502
								],
								[
									25.34814453125,
									37.50917968750008
								],
								[
									25.462988281250063,
									37.47109375000002
								],
								[
									25.45742187500008,
									37.44707031249993
								],
								[
									25.402734375000023,
									37.419140624999926
								]
							]
						],
						[
							[
								[
									26.029296875000057,
									37.529394531250006
								],
								[
									25.982421875,
									37.52558593750004
								],
								[
									25.996777343749983,
									37.56557617187511
								],
								[
									26.086328125000023,
									37.63491210937511
								],
								[
									26.211523437500034,
									37.63828125000009
								],
								[
									26.325585937500023,
									37.67304687500007
								],
								[
									26.351367187500017,
									37.67431640625006
								],
								[
									26.29687500000003,
									37.6195800781251
								],
								[
									26.204882812500017,
									37.56850585937508
								],
								[
									26.029296875000057,
									37.529394531250006
								]
							]
						],
						[
							[
								[
									25.25585937500003,
									37.599609375000114
								],
								[
									25.21875000000003,
									37.535107421874926
								],
								[
									25.156347656250006,
									37.54506835937511
								],
								[
									25.051953125000068,
									37.614453124999926
								],
								[
									25.01630859375001,
									37.645947265624955
								],
								[
									24.99648437500005,
									37.67690429687505
								],
								[
									25.039355468750074,
									37.680664062500085
								],
								[
									25.091796875,
									37.64799804687502
								],
								[
									25.225390625000045,
									37.630664062500045
								],
								[
									25.25585937500003,
									37.599609375000114
								]
							]
						],
						[
							[
								[
									24.35595703125003,
									37.5768554687501
								],
								[
									24.28896484375005,
									37.528271484374955
								],
								[
									24.277441406250006,
									37.601123046875045
								],
								[
									24.320410156250063,
									37.67773437499994
								],
								[
									24.37910156250004,
									37.68271484374998
								],
								[
									24.400781250000023,
									37.649023437500034
								],
								[
									24.35595703125003,
									37.5768554687501
								]
							]
						],
						[
							[
								[
									26.82441406250004,
									37.81142578125008
								],
								[
									26.947363281250034,
									37.77846679687505
								],
								[
									26.981542968750063,
									37.78198242187506
								],
								[
									27.039648437500006,
									37.77001953125
								],
								[
									27.05507812500005,
									37.709277343750074
								],
								[
									26.978125000000006,
									37.70048828124996
								],
								[
									26.84492187500004,
									37.64472656250007
								],
								[
									26.78828125000004,
									37.65698242187506
								],
								[
									26.72050781249999,
									37.705468749999994
								],
								[
									26.612890625000006,
									37.71049804687496
								],
								[
									26.5810546875,
									37.72373046875009
								],
								[
									26.63867187500003,
									37.78085937500009
								],
								[
									26.74335937500004,
									37.809765624999926
								],
								[
									26.82441406250004,
									37.81142578125008
								]
							]
						],
						[
							[
								[
									20.888476562500074,
									37.805371093749926
								],
								[
									20.993945312500045,
									37.708007812500085
								],
								[
									20.909082031249994,
									37.732128906249926
								],
								[
									20.81855468750004,
									37.66474609375004
								],
								[
									20.70380859375001,
									37.74345703125002
								],
								[
									20.635058593750045,
									37.823144531249994
								],
								[
									20.61953125000008,
									37.8550292968751
								],
								[
									20.691503906250006,
									37.92954101562509
								],
								[
									20.758691406249994,
									37.85297851562504
								],
								[
									20.83984375000003,
									37.84072265625002
								],
								[
									20.888476562500074,
									37.805371093749926
								]
							]
						],
						[
							[
								[
									24.991699218750057,
									37.75961914062512
								],
								[
									24.962207031250074,
									37.6923828125
								],
								[
									24.884082031250074,
									37.770507812500114
								],
								[
									24.79853515625004,
									37.82402343749999
								],
								[
									24.766503906249994,
									37.87070312500009
								],
								[
									24.71435546875003,
									37.89887695312507
								],
								[
									24.7001953125,
									37.96166992187497
								],
								[
									24.763378906250068,
									37.98750000000007
								],
								[
									24.79042968750008,
									37.990136718749994
								],
								[
									24.855078125000006,
									37.91367187500006
								],
								[
									24.956347656250045,
									37.904785156250114
								],
								[
									24.94843750000004,
									37.857666015625085
								],
								[
									24.98046874999997,
									37.796923828125074
								],
								[
									24.991699218750057,
									37.75961914062512
								]
							]
						],
						[
							[
								[
									23.550976562499983,
									37.92587890625006
								],
								[
									23.51142578125001,
									37.90117187499999
								],
								[
									23.46679687499997,
									37.902392578125074
								],
								[
									23.43525390625004,
									37.911474609375034
								],
								[
									23.41933593750008,
									37.93125000000009
								],
								[
									23.439062500000006,
									37.94067382812506
								],
								[
									23.462207031250017,
									37.98037109375005
								],
								[
									23.483691406250045,
									37.99111328125002
								],
								[
									23.51552734375005,
									37.986035156249955
								],
								[
									23.534863281249983,
									37.97021484375003
								],
								[
									23.550976562499983,
									37.92587890625006
								]
							]
						],
						[
							[
								[
									20.61230468750003,
									38.38334960937499
								],
								[
									20.624707031250068,
									38.2678710937501
								],
								[
									20.69521484375005,
									38.24619140625012
								],
								[
									20.788867187500017,
									38.14208984375006
								],
								[
									20.780761718750057,
									38.08881835937504
								],
								[
									20.761328125000006,
									38.07055664062494
								],
								[
									20.60615234375001,
									38.11972656250012
								],
								[
									20.568945312499977,
									38.09765625000006
								],
								[
									20.523535156250063,
									38.106640624999926
								],
								[
									20.495507812500023,
									38.164160156250006
								],
								[
									20.498730468750068,
									38.184375000000045
								],
								[
									20.47333984375004,
									38.218798828125045
								],
								[
									20.4521484375,
									38.234179687500074
								],
								[
									20.39101562500005,
									38.18842773437498
								],
								[
									20.35253906250003,
									38.179882812499926
								],
								[
									20.352246093750068,
									38.22172851562502
								],
								[
									20.40869140625003,
									38.336767578125006
								],
								[
									20.435058593750057,
									38.35620117187506
								],
								[
									20.4814453125,
									38.31821289062495
								],
								[
									20.519628906250063,
									38.33232421874999
								],
								[
									20.548339843750057,
									38.39453125000006
								],
								[
									20.55029296875,
									38.45654296875006
								],
								[
									20.56318359375004,
									38.47495117187509
								],
								[
									20.61230468750003,
									38.38334960937499
								]
							]
						],
						[
							[
								[
									20.758691406249994,
									38.32944335937512
								],
								[
									20.709277343750074,
									38.31860351562494
								],
								[
									20.64638671875005,
									38.414306640625085
								],
								[
									20.623632812500034,
									38.480322265625034
								],
								[
									20.649707031250017,
									38.48398437499998
								],
								[
									20.674804687500057,
									38.476318359375114
								],
								[
									20.701269531250034,
									38.451416015625
								],
								[
									20.70107421875008,
									38.42592773437505
								],
								[
									20.71162109375001,
									38.3986328125001
								],
								[
									20.739160156250023,
									38.36577148437496
								],
								[
									20.758691406249994,
									38.32944335937512
								]
							]
						],
						[
							[
								[
									26.094042968750017,
									38.218066406250074
								],
								[
									25.99853515625,
									38.16152343750011
								],
								[
									25.891894531250045,
									38.243310546874966
								],
								[
									25.874316406250017,
									38.269628906250006
								],
								[
									25.952636718750057,
									38.30263671875008
								],
								[
									25.991406250000068,
									38.35351562500003
								],
								[
									25.959960937500057,
									38.416015625000085
								],
								[
									25.85126953125001,
									38.50839843749998
								],
								[
									25.846093750000023,
									38.57402343749993
								],
								[
									26.01249999999999,
									38.60170898437508
								],
								[
									26.110449218750063,
									38.54462890624998
								],
								[
									26.16035156250001,
									38.54072265624998
								],
								[
									26.141210937500034,
									38.48618164062498
								],
								[
									26.14960937500004,
									38.46845703125001
								],
								[
									26.157031250000045,
									38.30292968750004
								],
								[
									26.110742187500023,
									38.27963867187509
								],
								[
									26.103124999999977,
									38.234179687500074
								],
								[
									26.094042968750017,
									38.218066406250074
								]
							]
						],
						[
							[
								[
									20.686718749999983,
									38.608691406250074
								],
								[
									20.64785156250008,
									38.60097656250011
								],
								[
									20.614355468750006,
									38.60625000000002
								],
								[
									20.58398437500003,
									38.60170898437508
								],
								[
									20.5546875,
									38.58256835937499
								],
								[
									20.557910156250045,
									38.66186523437497
								],
								[
									20.592480468750068,
									38.76015625000002
								],
								[
									20.63466796875005,
									38.81757812500007
								],
								[
									20.69414062499999,
									38.84423828125
								],
								[
									20.71962890625005,
									38.79916992187506
								],
								[
									20.71484375000003,
									38.63833007812508
								],
								[
									20.686718749999983,
									38.608691406250074
								]
							]
						],
						[
							[
								[
									24.67470703125005,
									38.80922851562508
								],
								[
									24.56904296875001,
									38.78481445312508
								],
								[
									24.54101562499997,
									38.78867187500006
								],
								[
									24.564550781250063,
									38.81943359375009
								],
								[
									24.56640625,
									38.83237304687506
								],
								[
									24.461035156250034,
									38.88862304687498
								],
								[
									24.473437500000074,
									38.96166992187494
								],
								[
									24.485644531250074,
									38.9802734375001
								],
								[
									24.564062500000063,
									38.94223632812506
								],
								[
									24.58125000000001,
									38.878857421874955
								],
								[
									24.67470703125005,
									38.80922851562508
								]
							]
						],
						[
							[
								[
									23.41542968750008,
									38.95864257812505
								],
								[
									23.471972656250045,
									38.85009765625006
								],
								[
									23.525000000000034,
									38.81347656250006
								],
								[
									23.63623046875003,
									38.77021484375001
								],
								[
									23.68847656250003,
									38.76469726562496
								],
								[
									23.878222656250045,
									38.686572265625045
								],
								[
									24.09902343750008,
									38.67099609375006
								],
								[
									24.127539062500034,
									38.6484863281251
								],
								[
									24.15468750000005,
									38.588281249999994
								],
								[
									24.19970703125,
									38.54101562500006
								],
								[
									24.211035156249977,
									38.50424804687512
								],
								[
									24.1875,
									38.46342773437496
								],
								[
									24.22011718750005,
									38.33862304687503
								],
								[
									24.275781250000023,
									38.22001953124993
								],
								[
									24.359667968750074,
									38.16249999999994
								],
								[
									24.463964843750006,
									38.14511718749995
								],
								[
									24.563281250000074,
									38.14750976562499
								],
								[
									24.58837890625003,
									38.1239746093751
								],
								[
									24.57851562500008,
									38.02016601562508
								],
								[
									24.53652343750005,
									37.979736328125085
								],
								[
									24.502343749999994,
									37.96992187500004
								],
								[
									24.47265625,
									37.98051757812499
								],
								[
									24.44580078125003,
									38.00498046875009
								],
								[
									24.41650390625003,
									38.016552734374955
								],
								[
									24.359472656250034,
									38.018554687500114
								],
								[
									24.31777343750005,
									38.0603515625001
								],
								[
									24.212011718750006,
									38.11752929687509
								],
								[
									24.19257812500004,
									38.151660156250045
								],
								[
									24.189062500000034,
									38.204296874999926
								],
								[
									24.144140625000034,
									38.24306640625011
								],
								[
									24.102832031250074,
									38.31684570312504
								],
								[
									24.063574218750063,
									38.3372070312501
								],
								[
									24.04189453125008,
									38.37412109374998
								],
								[
									24.040136718749977,
									38.389990234375006
								],
								[
									23.88623046875,
									38.40073242187498
								],
								[
									23.758789062500057,
									38.40122070312509
								],
								[
									23.65078125000008,
									38.44306640624998
								],
								[
									23.61738281250001,
									38.552539062500074
								],
								[
									23.553320312500034,
									38.581982421874955
								],
								[
									23.505273437499994,
									38.61293945312505
								],
								[
									23.465234375000023,
									38.65585937500009
								],
								[
									23.364062500000017,
									38.73500976562505
								],
								[
									23.25214843750004,
									38.80122070312504
								],
								[
									23.143945312500023,
									38.84482421874995
								],
								[
									23.029101562500074,
									38.87338867187509
								],
								[
									22.935742187500068,
									38.83964843749996
								],
								[
									22.88134765625,
									38.847656250000085
								],
								[
									22.87031250000004,
									38.87050781249994
								],
								[
									22.986328125000057,
									38.91591796875005
								],
								[
									23.145800781250045,
									39.00268554687506
								],
								[
									23.258203125000023,
									39.03134765625012
								],
								[
									23.31269531250004,
									39.03491210937494
								],
								[
									23.41542968750008,
									38.95864257812505
								]
							]
						],
						[
							[
								[
									23.779785156250057,
									39.11440429687508
								],
								[
									23.735156250000017,
									39.080566406250114
								],
								[
									23.666113281250006,
									39.09536132812511
								],
								[
									23.59394531250004,
									39.20859374999998
								],
								[
									23.779785156250057,
									39.11440429687508
								]
							]
						],
						[
							[
								[
									23.887988281250074,
									39.15830078124995
								],
								[
									23.84121093750005,
									39.14658203125006
								],
								[
									23.888085937500023,
									39.22636718749996
								],
								[
									23.97089843750001,
									39.26772460937505
								],
								[
									23.939746093750045,
									39.200537109375034
								],
								[
									23.887988281250074,
									39.15830078124995
								]
							]
						],
						[
							[
								[
									26.41015625,
									39.32944335937509
								],
								[
									26.39277343750001,
									39.27011718750009
								],
								[
									26.531054687500045,
									39.17177734374994
								],
								[
									26.578222656250063,
									39.10952148437505
								],
								[
									26.59560546875005,
									39.04882812499994
								],
								[
									26.583984375,
									39.031445312499955
								],
								[
									26.531542968750045,
									39.064355468749994
								],
								[
									26.488671875000023,
									39.07480468750009
								],
								[
									26.50312500000004,
									39.031445312499955
								],
								[
									26.547167968750045,
									38.994140625000085
								],
								[
									26.468750000000057,
									38.972802734374994
								],
								[
									26.39013671875003,
									38.97392578124996
								],
								[
									26.16083984375001,
									39.02587890624997
								],
								[
									26.10791015625,
									39.08105468750003
								],
								[
									26.245117187500057,
									39.164111328125074
								],
								[
									26.273144531249983,
									39.197558593750045
								],
								[
									26.17597656250001,
									39.1942871093751
								],
								[
									26.072363281250034,
									39.095605468749966
								],
								[
									25.90625000000003,
									39.1389648437501
								],
								[
									25.85546874999997,
									39.178662109374926
								],
								[
									25.84414062500008,
									39.20004882812512
								],
								[
									25.90957031250008,
									39.28754882812507
								],
								[
									26.026464843750006,
									39.284619140624926
								],
								[
									26.08837890625,
									39.304296875000034
								],
								[
									26.164843750000045,
									39.33198242187498
								],
								[
									26.16542968750008,
									39.373535156250114
								],
								[
									26.347753906250006,
									39.38300781249998
								],
								[
									26.41015625,
									39.32944335937509
								]
							]
						],
						[
							[
								[
									20.077929687500045,
									39.43271484375009
								],
								[
									20.09960937500003,
									39.37661132812502
								],
								[
									19.97500000000005,
									39.4114257812501
								],
								[
									19.883984375000068,
									39.46152343750009
								],
								[
									19.808886718750045,
									39.58530273437509
								],
								[
									19.648925781250057,
									39.72617187500009
								],
								[
									19.646484375,
									39.767089843750085
								],
								[
									19.707324218750045,
									39.798095703125
								],
								[
									19.83857421875004,
									39.820117187500045
								],
								[
									19.891699218750034,
									39.79726562500011
								],
								[
									19.926074218750017,
									39.7737304687501
								],
								[
									19.936816406250074,
									39.74672851562511
								],
								[
									19.86220703125005,
									39.692626953125
								],
								[
									19.8466796875,
									39.66811523437508
								],
								[
									19.904101562500074,
									39.61948242187512
								],
								[
									19.903125000000045,
									39.599999999999966
								],
								[
									19.927343750000006,
									39.505908203125074
								],
								[
									19.95527343750001,
									39.47041015625004
								],
								[
									20.027734375000023,
									39.44208984375004
								],
								[
									20.077929687500045,
									39.43271484375009
								]
							]
						],
						[
							[
								[
									25.43769531250004,
									39.98330078125008
								],
								[
									25.39990234375,
									39.94956054687495
								],
								[
									25.3720703125,
									39.89130859374998
								],
								[
									25.357031250000034,
									39.808105468750085
								],
								[
									25.29873046875008,
									39.80610351562504
								],
								[
									25.263378906250068,
									39.8229492187501
								],
								[
									25.251757812500017,
									39.85439453125011
								],
								[
									25.24941406250005,
									39.89414062500012
								],
								[
									25.22382812500001,
									39.89257812499997
								],
								[
									25.203222656250063,
									39.849414062500074
								],
								[
									25.185156250000034,
									39.82993164062509
								],
								[
									25.126464843750057,
									39.825830078124966
								],
								[
									25.06220703125001,
									39.852392578125034
								],
								[
									25.065234375000017,
									39.90986328125004
								],
								[
									25.052343750000063,
									39.97636718749999
								],
								[
									25.05800781250005,
									39.99965820312494
								],
								[
									25.234179687500074,
									40.00541992187496
								],
								[
									25.285742187500006,
									39.956298828125085
								],
								[
									25.34804687500008,
									39.98476562500011
								],
								[
									25.373632812500063,
									40.01552734375005
								],
								[
									25.44912109375008,
									40.034814453124994
								],
								[
									25.43769531250004,
									39.98330078125008
								]
							]
						],
						[
							[
								[
									25.68574218750004,
									40.42656249999996
								],
								[
									25.572656250000023,
									40.40043945312496
								],
								[
									25.448046875000017,
									40.48281250000005
								],
								[
									25.568554687500068,
									40.51586914062494
								],
								[
									25.624316406250045,
									40.49199218749996
								],
								[
									25.66425781250001,
									40.463867187500085
								],
								[
									25.68574218750004,
									40.42656249999996
								]
							]
						],
						[
							[
								[
									24.774218750000074,
									40.615185546874926
								],
								[
									24.645898437500023,
									40.57944335937512
								],
								[
									24.515527343750023,
									40.64702148437493
								],
								[
									24.516699218750006,
									40.68720703125004
								],
								[
									24.585546875000006,
									40.76875000000004
								],
								[
									24.623339843750045,
									40.79291992187498
								],
								[
									24.719140625000023,
									40.786279296874966
								],
								[
									24.77363281250004,
									40.73027343750002
								],
								[
									24.78632812500004,
									40.70385742187506
								],
								[
									24.768652343750006,
									40.65888671875004
								],
								[
									24.774218750000074,
									40.615185546874926
								]
							]
						],
						[
							[
								[
									26.03896484375005,
									40.72675781250001
								],
								[
									26.0107421875,
									40.769140625000034
								],
								[
									25.85566406250001,
									40.84409179687512
								],
								[
									25.49677734375001,
									40.88779296874995
								],
								[
									25.325292968750063,
									40.94311523437494
								],
								[
									25.250097656250034,
									40.93281250000007
								],
								[
									25.10449218750003,
									40.99472656249998
								],
								[
									25.004687500000017,
									40.96752929687494
								],
								[
									24.792968750000057,
									40.857519531250006
								],
								[
									24.678710937500057,
									40.86948242187495
								],
								[
									24.556542968750023,
									40.93559570312502
								],
								[
									24.47705078125,
									40.94775390625
								],
								[
									24.3837890625,
									40.91274414062505
								],
								[
									24.23437500000003,
									40.78613281250003
								],
								[
									24.082324218750045,
									40.7240722656251
								],
								[
									23.946093750000017,
									40.74833984374996
								],
								[
									23.762792968750063,
									40.74780273437494
								],
								[
									23.743261718750006,
									40.677001953125
								],
								[
									23.778710937500023,
									40.62797851562496
								],
								[
									23.87890625,
									40.54438476562498
								],
								[
									23.831933593750023,
									40.48154296875006
								],
								[
									23.866796875000034,
									40.41855468750009
								],
								[
									23.93203125000008,
									40.405761718750085
								],
								[
									24.03056640624999,
									40.409326171874994
								],
								[
									24.21279296875008,
									40.327783203124994
								],
								[
									24.292480468750057,
									40.24179687499998
								],
								[
									24.343359375000034,
									40.147705078125085
								],
								[
									24.232421875,
									40.21518554687506
								],
								[
									24.158789062500006,
									40.28002929687494
								],
								[
									24.056054687500023,
									40.30356445312495
								],
								[
									23.913183593750063,
									40.35878906250011
								],
								[
									23.823437500000068,
									40.36801757812512
								],
								[
									23.72792968750008,
									40.32973632812505
								],
								[
									23.720507812500074,
									40.28627929687508
								],
								[
									23.823437500000068,
									40.20512695312496
								],
								[
									23.917578125000063,
									40.155224609374926
								],
								[
									23.96748046875001,
									40.11455078124999
								],
								[
									24.000781250000045,
									40.024609374999955
								],
								[
									23.981835937500023,
									39.99404296875005
								],
								[
									23.947070312500045,
									39.965576171875114
								],
								[
									23.835351562500023,
									40.02226562500002
								],
								[
									23.66455078125003,
									40.223828124999955
								],
								[
									23.42626953124997,
									40.26396484374996
								],
								[
									23.38642578125004,
									40.22197265624993
								],
								[
									23.433203125000063,
									40.11542968749998
								],
								[
									23.467089843750045,
									40.07392578125007
								],
								[
									23.674121093750017,
									39.95888671875008
								],
								[
									23.657519531250017,
									39.93447265625008
								],
								[
									23.627343749999994,
									39.924072265625085
								],
								[
									23.395605468750034,
									39.98984374999998
								],
								[
									23.328222656250006,
									40.08994140624995
								],
								[
									23.31201171874997,
									40.216455078124966
								],
								[
									23.09814453125003,
									40.304296875000006
								],
								[
									22.896484375000057,
									40.39990234374994
								],
								[
									22.851367187500017,
									40.49062500000005
								],
								[
									22.892871093750017,
									40.52426757812506
								],
								[
									22.92226562500008,
									40.590869140625045
								],
								[
									22.81142578125005,
									40.57861328125003
								],
								[
									22.74189453125001,
									40.53647460937506
								],
								[
									22.629492187500006,
									40.49555664062498
								],
								[
									22.62490234375005,
									40.42861328125002
								],
								[
									22.642675781250034,
									40.366601562499994
								],
								[
									22.60546875,
									40.27641601562502
								],
								[
									22.56933593750003,
									40.11933593749998
								],
								[
									22.59218750000005,
									40.036914062500074
								],
								[
									22.835742187500017,
									39.800585937500074
								],
								[
									22.919042968750034,
									39.628906250000085
								],
								[
									22.978808593750045,
									39.56381835937506
								],
								[
									23.103417968750023,
									39.49204101562509
								],
								[
									23.23339843750003,
									39.35844726562496
								],
								[
									23.28847656250008,
									39.288818359375085
								],
								[
									23.327734374999977,
									39.174902343750034
								],
								[
									23.218359375000006,
									39.10439453125008
								],
								[
									23.15468750000008,
									39.10146484375011
								],
								[
									23.11943359374999,
									39.13276367187498
								],
								[
									23.168750000000017,
									39.21044921875
								],
								[
									23.161718750000006,
									39.25776367187504
								],
								[
									22.992871093750068,
									39.33105468749997
								],
								[
									22.92138671874997,
									39.3063476562501
								],
								[
									22.838964843750063,
									39.258593750000045
								],
								[
									22.886035156250045,
									39.16997070312493
								],
								[
									22.93896484375,
									39.111523437499926
								],
								[
									22.96552734375001,
									39.03090820312502
								],
								[
									23.066699218750017,
									39.037939453125034
								],
								[
									22.930468750000045,
									38.94770507812504
								],
								[
									22.802636718750023,
									38.90161132812497
								],
								[
									22.676855468749977,
									38.89892578125006
								],
								[
									22.596777343750006,
									38.89057617187504
								],
								[
									22.569140625000074,
									38.867480468750045
								],
								[
									22.63427734375003,
									38.85068359375006
								],
								[
									22.68750000000003,
									38.849169921875045
								],
								[
									22.774023437500063,
									38.80039062499995
								],
								[
									23.020312500000045,
									38.74189453125004
								],
								[
									23.1376953125,
									38.66796874999997
								],
								[
									23.25292968750003,
									38.66123046875012
								],
								[
									23.368945312500017,
									38.52553710937508
								],
								[
									23.569628906250045,
									38.48940429687511
								],
								[
									23.68398437500008,
									38.352441406249994
								],
								[
									23.836035156250063,
									38.32548828125002
								],
								[
									23.96699218750001,
									38.275000000000034
								],
								[
									24.00537109375,
									38.226806640625085
								],
								[
									24.024511718750006,
									38.13979492187502
								],
								[
									24.033007812500045,
									37.955322265625085
								],
								[
									24.061328125000045,
									37.81791992187499
								],
								[
									24.062304687500074,
									37.774511718750034
								],
								[
									24.055371093750068,
									37.70961914062505
								],
								[
									24.01972656250001,
									37.67773437499994
								],
								[
									23.97158203125005,
									37.676757812500114
								],
								[
									23.87734375000005,
									37.77778320312498
								],
								[
									23.73281250000008,
									37.884082031250074
								],
								[
									23.58046875000005,
									38.010546875000074
								],
								[
									23.537207031250034,
									38.032763671875074
								],
								[
									23.50175781249999,
									38.034863281249955
								],
								[
									23.42021484374999,
									37.99208984375005
								],
								[
									23.193652343750017,
									37.95903320312496
								],
								[
									23.087402343750057,
									37.91284179687497
								],
								[
									23.047460937500006,
									37.90263671874993
								],
								[
									23.03632812500004,
									37.87836914062504
								],
								[
									23.086132812500068,
									37.85312500000006
								],
								[
									23.147167968750068,
									37.79531250000011
								],
								[
									23.147167968750068,
									37.71625976562507
								],
								[
									23.197558593750017,
									37.62021484374995
								],
								[
									23.262695312500057,
									37.595410156249955
								],
								[
									23.347558593750023,
									37.59755859375005
								],
								[
									23.396191406250068,
									37.57978515625007
								],
								[
									23.408789062500063,
									37.5415527343751
								],
								[
									23.458105468749977,
									37.49692382812506
								],
								[
									23.49062500000005,
									37.463867187500085
								],
								[
									23.48925781250003,
									37.44018554687506
								],
								[
									23.252539062500034,
									37.37729492187512
								],
								[
									23.20302734375008,
									37.34853515624994
								],
								[
									23.16152343750005,
									37.33383789062506
								],
								[
									23.10000000000005,
									37.363769531250114
								],
								[
									23.096484375000045,
									37.44057617187502
								],
								[
									23.01513671874997,
									37.48178710937509
								],
								[
									22.940527343750063,
									37.517089843750085
								],
								[
									22.85107421875003,
									37.53222656250006
								],
								[
									22.775000000000006,
									37.585107421874994
								],
								[
									22.725390625000017,
									37.54213867187494
								],
								[
									22.765039062500023,
									37.393310546875
								],
								[
									22.85107421875003,
									37.29082031249999
								],
								[
									22.99501953125005,
									37.015869140625114
								],
								[
									23.060351562500045,
									36.853515625000085
								],
								[
									23.073535156250074,
									36.77495117187496
								],
								[
									23.041015625,
									36.64453125000003
								],
								[
									23.111718750000023,
									36.547607421875114
								],
								[
									23.16015625000003,
									36.44809570312509
								],
								[
									23.106835937500023,
									36.451855468749955
								],
								[
									23.060546875,
									36.48696289062508
								],
								[
									22.98291015625,
									36.5283691406251
								],
								[
									22.832324218750045,
									36.687109375000006
								],
								[
									22.779882812500006,
									36.786181640625045
								],
								[
									22.717187500000023,
									36.793945312500114
								],
								[
									22.60839843749997,
									36.77973632812504
								],
								[
									22.489062500000017,
									36.56816406249993
								],
								[
									22.48945312500001,
									36.44692382812502
								],
								[
									22.42773437500003,
									36.47578125000004
								],
								[
									22.37480468749999,
									36.51357421875011
								],
								[
									22.38125000000008,
									36.64619140625001
								],
								[
									22.375976562500057,
									36.701904296875
								],
								[
									22.23115234375004,
									36.88256835937503
								],
								[
									22.16474609375001,
									36.902832031250085
								],
								[
									22.13378906250003,
									36.9639160156251
								],
								[
									22.08046875000008,
									37.02895507812502
								],
								[
									22.01171875000003,
									37.016503906249966
								],
								[
									21.95556640625003,
									36.990087890625006
								],
								[
									21.940039062500063,
									36.89179687500007
								],
								[
									21.93427734375004,
									36.803662109374955
								],
								[
									21.892382812500045,
									36.73730468750003
								],
								[
									21.738085937500045,
									36.86323242187501
								],
								[
									21.58291015625005,
									37.08095703125005
								],
								[
									21.57880859375001,
									37.200390624999955
								],
								[
									21.692480468750006,
									37.309277343749926
								],
								[
									21.678906250000068,
									37.38720703125
								],
								[
									21.5712890625,
									37.54101562500006
								],
								[
									21.41621093750001,
									37.639941406250074
								],
								[
									21.329296874999983,
									37.66933593750011
								],
								[
									21.288476562500023,
									37.774511718750034
								],
								[
									21.20527343750004,
									37.828857421875
								],
								[
									21.137988281250017,
									37.85415039062508
								],
								[
									21.12470703125004,
									37.891601562500085
								],
								[
									21.14501953125003,
									37.91928710937495
								],
								[
									21.30810546875003,
									38.027441406250034
								],
								[
									21.40371093750005,
									38.19667968750005
								],
								[
									21.45117187500003,
									38.20473632812502
								],
								[
									21.548730468750023,
									38.16459960937502
								],
								[
									21.658398437500068,
									38.17509765624993
								],
								[
									21.748437500000023,
									38.27421874999996
								],
								[
									21.82470703125003,
									38.328125000000114
								],
								[
									21.95332031250001,
									38.32119140624994
								],
								[
									22.243750000000034,
									38.18872070312503
								],
								[
									22.55585937500004,
									38.11323242187504
								],
								[
									22.711523437500034,
									38.04692382812493
								],
								[
									22.799609375000045,
									37.98120117187503
								],
								[
									22.846386718750068,
									37.96757812499993
								],
								[
									22.920312500000023,
									37.95830078124999
								],
								[
									22.916992187500057,
									38.00747070312505
								],
								[
									22.893164062500006,
									38.05092773437502
								],
								[
									22.95478515625004,
									38.07460937500005
								],
								[
									23.1220703125,
									38.07333984374998
								],
								[
									23.152539062499983,
									38.09638671875007
								],
								[
									23.18349609375008,
									38.13369140625002
								],
								[
									23.148925781250057,
									38.176074218750045
								],
								[
									23.093554687500045,
									38.19643554687511
								],
								[
									23.034374999999983,
									38.202099609374926
								],
								[
									22.995410156250045,
									38.2155273437501
								],
								[
									22.932519531250023,
									38.201953125000074
								],
								[
									22.834375000000023,
									38.23471679687509
								],
								[
									22.78369140625,
									38.261718750000085
								],
								[
									22.753906250000057,
									38.28950195312507
								],
								[
									22.58339843750005,
									38.34492187500007
								],
								[
									22.421679687500045,
									38.438525390625045
								],
								[
									22.38525390625,
									38.38554687499999
								],
								[
									22.319921875000006,
									38.35683593750011
								],
								[
									22.226855468750045,
									38.35283203124999
								],
								[
									21.96533203124997,
									38.41245117187506
								],
								[
									21.80468750000003,
									38.36694335937503
								],
								[
									21.717089843750045,
									38.35502929687499
								],
								[
									21.650097656250068,
									38.35400390625006
								],
								[
									21.567675781250045,
									38.33359374999998
								],
								[
									21.47255859375005,
									38.32138671874998
								],
								[
									21.39013671875003,
									38.40781250000009
								],
								[
									21.35546875,
									38.47480468750007
								],
								[
									21.3310546875,
									38.48730468749994
								],
								[
									21.32978515625001,
									38.424365234375074
								],
								[
									21.303320312500034,
									38.37392578124994
								],
								[
									21.18261718750003,
									38.34555664062512
								],
								[
									21.113183593750023,
									38.384667968749994
								],
								[
									21.059765625000068,
									38.50327148437509
								],
								[
									20.992187500000057,
									38.65400390625007
								],
								[
									20.873242187500068,
									38.77573242187509
								],
								[
									20.776855468750057,
									38.80751953125008
								],
								[
									20.768554687500057,
									38.87441406249994
								],
								[
									20.77734374999997,
									38.927880859374994
								],
								[
									20.893164062500034,
									38.94111328125001
								],
								[
									21.07421874999997,
									38.885156249999994
								],
								[
									21.111621093750045,
									38.896289062500045
								],
								[
									21.15234375,
									38.92207031250004
								],
								[
									21.14453125,
									38.97919921875007
								],
								[
									21.11835937500001,
									39.02998046875001
								],
								[
									21.068554687500068,
									39.032275390625045
								],
								[
									21.03408203125005,
									39.026269531249966
								],
								[
									20.922753906250023,
									39.036767578124966
								],
								[
									20.779687500000023,
									39.008544921875085
								],
								[
									20.71337890625,
									39.03515625
								],
								[
									20.69130859375005,
									39.067480468750006
								],
								[
									20.571679687499994,
									39.147705078125114
								],
								[
									20.46826171875,
									39.25527343750008
								],
								[
									20.300781250000057,
									39.32709960937507
								],
								[
									20.19140624999997,
									39.54580078124994
								],
								[
									20.099414062500074,
									39.64125976562502
								],
								[
									20.001269531250074,
									39.70942382812504
								],
								[
									20.022558593750034,
									39.71069335937506
								],
								[
									20.059765625000068,
									39.699121093749994
								],
								[
									20.13105468750004,
									39.661621093750085
								],
								[
									20.206835937500017,
									39.65351562500004
								],
								[
									20.24824218750001,
									39.67836914062502
								],
								[
									20.272070312499977,
									39.70117187499997
								],
								[
									20.28759765625003,
									39.738574218750045
								],
								[
									20.29384765625008,
									39.78222656250006
								],
								[
									20.30615234375,
									39.796679687500074
								],
								[
									20.364062500000074,
									39.79174804687503
								],
								[
									20.382421875000006,
									39.80263671875002
								],
								[
									20.381640625000017,
									39.841796875000114
								],
								[
									20.34423828125003,
									39.890625000000114
								],
								[
									20.311328125000074,
									39.95078125000012
								],
								[
									20.311132812500034,
									39.9794433593751
								],
								[
									20.338476562500006,
									39.99106445312506
								],
								[
									20.38369140625008,
									40.017187500000034
								],
								[
									20.408007812500045,
									40.04946289062505
								],
								[
									20.4560546875,
									40.06557617187505
								],
								[
									20.527050781250068,
									40.06850585937502
								],
								[
									20.606250000000045,
									40.08266601562505
								],
								[
									20.657421875000068,
									40.11738281250004
								],
								[
									20.66494140625008,
									40.15175781250002
								],
								[
									20.69697265625004,
									40.24638671875002
								],
								[
									20.717871093750034,
									40.29267578125004
								],
								[
									20.751660156249983,
									40.33491210937504
								],
								[
									20.77001953125,
									40.3918945312501
								],
								[
									20.80605468750005,
									40.44545898437508
								],
								[
									20.881640625000017,
									40.46791992187502
								],
								[
									20.95019531250003,
									40.494384765625085
								],
								[
									21.001953125,
									40.56337890625002
								],
								[
									21.030859375000034,
									40.62246093750008
								],
								[
									21.031054687500074,
									40.65864257812498
								],
								[
									20.987890625000063,
									40.71777343750006
								],
								[
									20.95576171875001,
									40.77529296875005
								],
								[
									20.96425781250005,
									40.84990234374996
								],
								[
									21.10000000000008,
									40.85615234375007
								],
								[
									21.147558593750006,
									40.86313476562509
								],
								[
									21.32373046875,
									40.86713867187501
								],
								[
									21.404101562500045,
									40.9071777343751
								],
								[
									21.459667968749983,
									40.903613281250074
								],
								[
									21.575781250000034,
									40.86894531250002
								],
								[
									21.627539062500006,
									40.896337890625006
								],
								[
									21.77949218750004,
									40.950439453125114
								],
								[
									21.929492187500045,
									41.10742187500003
								],
								[
									21.99335937500001,
									41.13095703125012
								],
								[
									22.138867187500068,
									41.14052734375002
								],
								[
									22.18447265625005,
									41.15864257812507
								],
								[
									22.23769531250005,
									41.15517578125008
								],
								[
									22.40078125000005,
									41.12338867187509
								],
								[
									22.493554687500023,
									41.11850585937506
								],
								[
									22.603613281249977,
									41.140185546875045
								],
								[
									22.724804687500068,
									41.17851562500002
								],
								[
									22.75507812500001,
									41.312744140625114
								],
								[
									22.78388671875004,
									41.33198242187504
								],
								[
									22.859277343750023,
									41.33735351562507
								],
								[
									22.91601562500003,
									41.336279296875006
								],
								[
									23.025585937500068,
									41.32563476562498
								],
								[
									23.155957031250068,
									41.32207031249996
								],
								[
									23.239843750000006,
									41.38496093749998
								],
								[
									23.372070312500057,
									41.38964843750006
								],
								[
									23.433398437500017,
									41.398730468750045
								],
								[
									23.53583984375001,
									41.38603515625002
								],
								[
									23.63515625000008,
									41.3867675781251
								],
								[
									23.762304687500063,
									41.41298828125011
								],
								[
									23.880859375000057,
									41.45595703125005
								],
								[
									23.973535156250023,
									41.45229492187502
								],
								[
									24.011328125000063,
									41.460058593750006
								],
								[
									24.03291015625004,
									41.46909179687506
								],
								[
									24.056054687500023,
									41.52724609375002
								],
								[
									24.230371093750023,
									41.530810546875045
								],
								[
									24.28945312500008,
									41.52504882812502
								],
								[
									24.38671875,
									41.52353515624998
								],
								[
									24.487890625000006,
									41.555224609375045
								],
								[
									24.51826171875004,
									41.55253906250002
								],
								[
									24.569335937500057,
									41.46738281250009
								],
								[
									24.595996093750074,
									41.442724609375034
								],
								[
									24.65107421875001,
									41.41997070312502
								],
								[
									24.773730468750045,
									41.356103515624966
								],
								[
									24.795800781250023,
									41.37290039062512
								],
								[
									24.84687500000004,
									41.39423828125001
								],
								[
									24.99355468750008,
									41.364990234375
								],
								[
									25.133398437500063,
									41.31577148437509
								],
								[
									25.251171875000068,
									41.24355468750005
								],
								[
									25.381933593750063,
									41.26435546875001
								],
								[
									25.52705078125004,
									41.29980468750006
								],
								[
									25.621484375000023,
									41.31010742187502
								],
								[
									25.723925781250017,
									41.315039062500034
								],
								[
									25.784960937500017,
									41.33041992187498
								],
								[
									25.923339843750057,
									41.31191406250002
								],
								[
									26.066406250000057,
									41.35068359375012
								],
								[
									26.135351562500063,
									41.38574218749997
								],
								[
									26.155175781250023,
									41.43486328125002
								],
								[
									26.143554687500057,
									41.52153320312502
								],
								[
									26.11123046875005,
									41.60820312499999
								],
								[
									26.076953125000074,
									41.64018554687502
								],
								[
									26.066015625000063,
									41.67324218750011
								],
								[
									26.085546875000063,
									41.7041503906251
								],
								[
									26.107421875000057,
									41.725683593750034
								],
								[
									26.20058593750005,
									41.743798828124994
								],
								[
									26.320898437500034,
									41.71655273437503
								],
								[
									26.410546874999994,
									41.6963378906251
								],
								[
									26.462500000000006,
									41.663378906250045
								],
								[
									26.49501953125008,
									41.63325195312504
								],
								[
									26.544531250000034,
									41.607226562500074
								],
								[
									26.581347656250074,
									41.6012695312501
								],
								[
									26.609765624999994,
									41.51215820312507
								],
								[
									26.62490234375005,
									41.40175781250002
								],
								[
									26.60234374999999,
									41.35415039062502
								],
								[
									26.536425781250074,
									41.34311523437509
								],
								[
									26.330664062499977,
									41.23876953125006
								],
								[
									26.32568359375003,
									41.143261718749955
								],
								[
									26.328417968750045,
									41.09702148437495
								],
								[
									26.332617187500034,
									41.064306640625034
								],
								[
									26.354101562500063,
									41.03676757812502
								],
								[
									26.354101562500063,
									40.997070312500114
								],
								[
									26.331054687500057,
									40.95449218750005
								],
								[
									26.241210937500057,
									40.883203124999994
								],
								[
									26.178906250000068,
									40.82651367187509
								],
								[
									26.109179687500074,
									40.749658203124966
								],
								[
									26.069726562500023,
									40.74028320312502
								],
								[
									26.03896484375005,
									40.72675781250001
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "GRC",
					"su_a3": "GRC",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "GRC",
					"gu_a3": "GRC",
					"abbrev": "Greece",
					"region_un": "Europe",
					"adm0_a3_us": "GRC",
					"scalerank": 1,
					"pop_est": 10737428,
					"adm0_dif": 0,
					"un_a3": "300",
					"pop_year": -99,
					"gdp_md_est": 343000,
					"name": "Greece",
					"sovereignt": "Greece",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Greece",
					"postal": "GR",
					"sov_a3": "GRC",
					"note_brk": "",
					"brk_a3": "GRC",
					"wb_a2": "GR",
					"brk_diff": 0,
					"admin": "Greece",
					"name_long": "Greece",
					"iso_a3": "GRC",
					"iso_a2": "GR",
					"adm0_a3_is": "GRC",
					"level": 2,
					"formal_en": "Hellenic Republic",
					"name_len": 6,
					"mapcolor7": 2,
					"long_len": 6,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "300",
					"homepart": 1,
					"subunit": "Greece",
					"name_alt": "",
					"brk_name": "Greece",
					"name_sort": "Greece",
					"continent": "Europe",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-89.16147460937503,
								17.814843749999966
							],
							[
								-89.17109374999995,
								17.57226562500003
							],
							[
								-89.18217773437499,
								17.29121093750004
							],
							[
								-89.19038085937498,
								17.084667968749983
							],
							[
								-89.20126953124998,
								16.80898437500005
							],
							[
								-89.21245117187493,
								16.527148437500102
							],
							[
								-89.22763671874992,
								16.14282226562503
							],
							[
								-89.23749999999998,
								15.894433593750051
							],
							[
								-89.2328125,
								15.888671875000057
							],
							[
								-89.11357421874996,
								15.900683593750102
							],
							[
								-88.937158203125,
								15.889843750000011
							],
							[
								-88.89404296875,
								15.890625
							],
							[
								-88.839990234375,
								15.868994140625034
							],
							[
								-88.79833984374994,
								15.86250000000004
							],
							[
								-88.70864257812497,
								15.806542968750023
							],
							[
								-88.60336914062492,
								15.76416015625
							],
							[
								-88.53623046874992,
								15.849609375
							],
							[
								-88.57158203124993,
								15.901074218749983
							],
							[
								-88.597998046875,
								15.927343750000006
							],
							[
								-88.59394531249995,
								15.950292968749977
							],
							[
								-88.22832031249999,
								15.729003906250028
							],
							[
								-88.27143554687498,
								15.694873046875074
							],
							[
								-88.36455078124996,
								15.616015625000102
							],
							[
								-88.53330078124995,
								15.481201171875085
							],
							[
								-88.68447265625002,
								15.360498046875094
							],
							[
								-88.829931640625,
								15.251025390625074
							],
							[
								-88.96098632812496,
								15.152441406250063
							],
							[
								-88.976416015625,
								15.142675781250034
							],
							[
								-89.142578125,
								15.072314453125088
							],
							[
								-89.17031249999997,
								15.039892578125048
							],
							[
								-89.20610351562499,
								14.900585937500097
							],
							[
								-89.22236328125001,
								14.866064453124991
							],
							[
								-89.192236328125,
								14.788720703125037
							],
							[
								-89.16220703125,
								14.669238281250031
							],
							[
								-89.17177734375,
								14.60688476562504
							],
							[
								-89.28671874999998,
								14.529980468750082
							],
							[
								-89.33940429687496,
								14.460742187500017
							],
							[
								-89.36259765624999,
								14.416015625000057
							],
							[
								-89.38325195312501,
								14.427636718750023
							],
							[
								-89.41884765624997,
								14.431103515625011
							],
							[
								-89.50087890625,
								14.41376953125004
							],
							[
								-89.54052734375,
								14.409912109375057
							],
							[
								-89.5736328125,
								14.390087890625011
							],
							[
								-89.57695312499996,
								14.347070312500037
							],
							[
								-89.55502929687492,
								14.277246093750023
							],
							[
								-89.54716796875002,
								14.241259765624974
							],
							[
								-89.57026367187501,
								14.22465820312506
							],
							[
								-89.6712890625,
								14.182714843750034
							],
							[
								-89.71113281250001,
								14.14130859375004
							],
							[
								-89.74936523437498,
								14.077001953124991
							],
							[
								-89.79370117187497,
								14.050097656250017
							],
							[
								-89.83994140624998,
								14.055078124999966
							],
							[
								-89.872705078125,
								14.045605468749997
							],
							[
								-89.94267578124993,
								13.997363281250031
							],
							[
								-90.04814453125002,
								13.904052734375028
							],
							[
								-90.104736328125,
								13.834765625000031
							],
							[
								-90.10590820312498,
								13.78300781250006
							],
							[
								-90.09521484375003,
								13.736523437499997
							],
							[
								-90.47910156249998,
								13.900927734375003
							],
							[
								-90.60693359375,
								13.929003906250045
							],
							[
								-91.14604492187496,
								13.92558593750006
							],
							[
								-91.37734375,
								13.990185546874983
							],
							[
								-91.64091796874996,
								14.114941406249997
							],
							[
								-91.81909179687503,
								14.228222656249983
							],
							[
								-92.23515624999996,
								14.545410156250028
							],
							[
								-92.20903320312499,
								14.570996093750097
							],
							[
								-92.18706054687493,
								14.630078125000054
							],
							[
								-92.159912109375,
								14.691015625000034
							],
							[
								-92.17646484375001,
								14.761328125000063
							],
							[
								-92.18637695312498,
								14.818359375000043
							],
							[
								-92.15566406249994,
								14.901318359375068
							],
							[
								-92.158544921875,
								14.963574218750054
							],
							[
								-92.14423828125001,
								15.001953125000057
							],
							[
								-92.09873046874998,
								15.026757812500037
							],
							[
								-92.07480468749998,
								15.074218750000028
							],
							[
								-92.204345703125,
								15.237695312500023
							],
							[
								-92.204248046875,
								15.274999999999991
							],
							[
								-92.18715820312497,
								15.32089843750002
							],
							[
								-92.08212890624998,
								15.495556640624983
							],
							[
								-91.95722656250001,
								15.703222656250006
							],
							[
								-91.81943359374992,
								15.932373046874972
							],
							[
								-91.736572265625,
								16.070166015624977
							],
							[
								-91.433984375,
								16.07045898437505
							],
							[
								-91.2337890625,
								16.07065429687509
							],
							[
								-90.97958984374998,
								16.07080078125003
							],
							[
								-90.70322265624998,
								16.071044921875085
							],
							[
								-90.52197265625,
								16.071191406250108
							],
							[
								-90.44716796874997,
								16.072705078125068
							],
							[
								-90.45986328124997,
								16.16235351562503
							],
							[
								-90.45014648437493,
								16.261376953125023
							],
							[
								-90.41699218750003,
								16.35131835937497
							],
							[
								-90.41699218750003,
								16.39101562500008
							],
							[
								-90.47109374999994,
								16.439550781250006
							],
							[
								-90.57578124999995,
								16.46782226562499
							],
							[
								-90.63408203125002,
								16.51074218750003
							],
							[
								-90.63437499999998,
								16.56513671875001
							],
							[
								-90.65996093749996,
								16.630908203125102
							],
							[
								-90.710693359375,
								16.708105468750006
							],
							[
								-90.81601562499995,
								16.78710937500003
							],
							[
								-90.975830078125,
								16.86782226562505
							],
							[
								-91.11186523437502,
								16.97617187500009
							],
							[
								-91.22416992187499,
								17.11225585937501
							],
							[
								-91.31918945312498,
								17.19980468750009
							],
							[
								-91.39233398437494,
								17.23642578125009
							],
							[
								-91.40961914062501,
								17.255859375000057
							],
							[
								-91.19550781250001,
								17.25410156250004
							],
							[
								-90.99296874999996,
								17.25244140624997
							],
							[
								-90.99160156250002,
								17.447460937500097
							],
							[
								-90.99042968749995,
								17.62075195312505
							],
							[
								-90.98916015624997,
								17.81640625000003
							],
							[
								-90.62202148437495,
								17.81611328125004
							],
							[
								-90.18359375,
								17.815722656250074
							],
							[
								-89.72880859374999,
								17.81533203125008
							],
							[
								-89.37153320312493,
								17.814990234375102
							],
							[
								-89.16147460937503,
								17.814843749999966
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central America",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "GTM",
					"su_a3": "GTM",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "GTM",
					"gu_a3": "GTM",
					"abbrev": "Guat.",
					"region_un": "Americas",
					"adm0_a3_us": "GTM",
					"scalerank": 1,
					"pop_est": 13276517,
					"adm0_dif": 0,
					"un_a3": "320",
					"pop_year": -99,
					"gdp_md_est": 68580,
					"name": "Guatemala",
					"sovereignt": "Guatemala",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Guatemala",
					"postal": "GT",
					"sov_a3": "GTM",
					"note_brk": "",
					"brk_a3": "GTM",
					"wb_a2": "GT",
					"brk_diff": 0,
					"admin": "Guatemala",
					"name_long": "Guatemala",
					"iso_a3": "GTM",
					"iso_a2": "GT",
					"adm0_a3_is": "GTM",
					"level": 2,
					"formal_en": "Republic of Guatemala",
					"name_len": 9,
					"mapcolor7": 3,
					"long_len": 9,
					"mapcolor8": 3,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "320",
					"homepart": 1,
					"subunit": "Guatemala",
					"name_alt": "",
					"brk_name": "Guatemala",
					"name_sort": "Guatemala",
					"continent": "North America",
					"mapcolor13": 6,
					"fips_10": "",
					"tiny": 4,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2002
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									114.23203125000003,
									22.210546875000034
								],
								[
									114.20722656250007,
									22.195166015625006
								],
								[
									114.13876953125003,
									22.268359375000074
								],
								[
									114.13447265625007,
									22.29223632812497
								],
								[
									114.18740234375002,
									22.296630859375085
								],
								[
									114.24687500000016,
									22.263574218749994
								],
								[
									114.24355468749997,
									22.233544921875108
								],
								[
									114.23203125000003,
									22.210546875000034
								]
							]
						],
						[
							[
								[
									113.99775390625018,
									22.210498046875017
								],
								[
									113.87734374999997,
									22.210449218750114
								],
								[
									113.8515625,
									22.220458984375085
								],
								[
									113.83886718749994,
									22.241699218750085
								],
								[
									113.88154296875007,
									22.28027343750003
								],
								[
									114.04394531250011,
									22.333398437500108
								],
								[
									114.00332031249997,
									22.277539062500097
								],
								[
									113.99775390625018,
									22.210498046875017
								]
							]
						],
						[
							[
								[
									114.01542968750016,
									22.511914062500068
								],
								[
									114.01826171875018,
									22.514453125000045
								],
								[
									114.05039062500009,
									22.542968750000085
								],
								[
									114.09785156250007,
									22.551269531250085
								],
								[
									114.12285156249999,
									22.56499023437513
								],
								[
									114.18818359375018,
									22.56499023437513
								],
								[
									114.22822265625007,
									22.553955078125
								],
								[
									114.26601562500014,
									22.54096679687501
								],
								[
									114.26962890625003,
									22.536767578124966
								],
								[
									114.29111328125009,
									22.49946289062501
								],
								[
									114.28457031250002,
									22.457617187500006
								],
								[
									114.32519531250011,
									22.43740234375005
								],
								[
									114.33525390625005,
									22.39624023437503
								],
								[
									114.29052734374994,
									22.373779296875057
								],
								[
									114.28789062500016,
									22.325292968750063
								],
								[
									114.26796874999997,
									22.295556640624937
								],
								[
									114.13906250000002,
									22.348437500000045
								],
								[
									114.03281250000003,
									22.375878906249966
								],
								[
									113.93730468750005,
									22.364990234375057
								],
								[
									113.90253906250007,
									22.39609375000009
								],
								[
									113.896484375,
									22.428173828124955
								],
								[
									114.00673828124997,
									22.484033203124966
								],
								[
									114.01542968750016,
									22.511914062500068
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "HKG",
					"su_a3": "HKG",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "HKG",
					"gu_a3": "HKG",
					"abbrev": "H.K.",
					"region_un": "Asia",
					"adm0_a3_us": "HKG",
					"scalerank": 3,
					"pop_est": 7061200,
					"adm0_dif": 1,
					"un_a3": "344",
					"pop_year": 2010,
					"gdp_md_est": 351119,
					"name": "Hong Kong",
					"sovereignt": "China",
					"economy": "6. Developing region",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": 2011,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Hong Kong S.A.R.",
					"postal": "HK",
					"sov_a3": "CH1",
					"note_brk": "",
					"brk_a3": "HKG",
					"wb_a2": "HK",
					"brk_diff": 0,
					"admin": "Hong Kong S.A.R.",
					"name_long": "Hong Kong",
					"iso_a3": "HKG",
					"iso_a2": "HK",
					"adm0_a3_is": "HKG",
					"level": 2,
					"formal_en": "Hong Kong Special Administrative Region, PRC",
					"name_len": 9,
					"mapcolor7": 4,
					"long_len": 9,
					"mapcolor8": 4,
					"mapcolor9": 4,
					"note_adm0": "China",
					"iso_n3": "344",
					"homepart": -99,
					"subunit": "Hong Kong S.A.R.",
					"name_alt": "",
					"brk_name": "Hong Kong",
					"name_sort": "Hong Kong SAR, China",
					"continent": "Asia",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": 0,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									17.60781250000005,
									42.76904296875006
								],
								[
									17.744238281250063,
									42.70034179687508
								],
								[
									17.34414062500008,
									42.79038085937506
								],
								[
									17.389550781249994,
									42.798632812500045
								],
								[
									17.431933593750017,
									42.800390625000034
								],
								[
									17.60781250000005,
									42.76904296875006
								]
							]
						],
						[
							[
								[
									16.650683593750017,
									42.99658203125006
								],
								[
									16.835546875000034,
									42.96865234375005
								],
								[
									16.971093750000023,
									42.98149414062499
								],
								[
									17.093652343750023,
									42.96435546875006
								],
								[
									17.169824218749994,
									42.932617187500085
								],
								[
									17.188281250000045,
									42.9170410156251
								],
								[
									17.08935546875003,
									42.91489257812509
								],
								[
									16.9775390625,
									42.927783203125074
								],
								[
									16.850683593750006,
									42.89550781249997
								],
								[
									16.738867187500034,
									42.91274414062502
								],
								[
									16.696386718750006,
									42.93369140625012
								],
								[
									16.666308593750017,
									42.95991210937504
								],
								[
									16.650683593750017,
									42.99658203125006
								]
							]
						],
						[
							[
								[
									17.667578125000063,
									42.89711914062502
								],
								[
									17.74023437500003,
									42.915478515624955
								],
								[
									17.80195312500001,
									42.90224609375011
								],
								[
									17.84130859375003,
									42.84506835937509
								],
								[
									17.918847656250023,
									42.807421875000045
								],
								[
									18.044531250000034,
									42.74125976562499
								],
								[
									18.12392578125005,
									42.690576171874966
								],
								[
									18.304003906250045,
									42.59941406249996
								],
								[
									18.346582031250023,
									42.58666992187503
								],
								[
									18.436328125000017,
									42.55971679687505
								],
								[
									18.438085937500006,
									42.522949218750114
								],
								[
									18.476660156250063,
									42.48110351562511
								],
								[
									18.517480468750023,
									42.43291015624996
								],
								[
									18.3330078125,
									42.527880859375045
								],
								[
									18.16064453124997,
									42.634033203125085
								],
								[
									17.823828125000006,
									42.797412109375074
								],
								[
									17.58496093750003,
									42.837158203125085
								],
								[
									17.25820312500008,
									42.9684570312501
								],
								[
									17.045410156250057,
									43.01489257812506
								],
								[
									17.126464843750057,
									43.02558593750001
								],
								[
									17.219824218750063,
									43.02587890624997
								],
								[
									17.72363281250003,
									42.85068359375009
								],
								[
									17.667578125000063,
									42.89711914062502
								]
							]
						],
						[
							[
								[
									17.19404296875004,
									43.12578124999999
								],
								[
									17.124121093750006,
									43.115429687499926
								],
								[
									16.679199218750057,
									43.12314453125006
								],
								[
									16.5498046875,
									43.14389648437495
								],
								[
									16.405859375000063,
									43.197363281250006
								],
								[
									16.37646484375003,
									43.21376953125005
								],
								[
									16.52138671875005,
									43.229248046875114
								],
								[
									16.65595703125004,
									43.21376953125005
								],
								[
									16.697265625,
									43.174951171874966
								],
								[
									17.061132812500063,
									43.14389648437495
								],
								[
									17.19404296875004,
									43.12578124999999
								]
							]
						],
						[
							[
								[
									16.785253906250006,
									43.27065429687502
								],
								[
									16.62744140625,
									43.26806640625003
								],
								[
									16.490332031250034,
									43.286181640625074
								],
								[
									16.423144531250017,
									43.317236328125006
								],
								[
									16.42812500000008,
									43.34340820312511
								],
								[
									16.44892578125004,
									43.38706054687512
								],
								[
									16.601562500000057,
									43.38188476562502
								],
								[
									16.83437500000005,
									43.350830078125085
								],
								[
									16.89130859375001,
									43.31464843750001
								],
								[
									16.873632812500063,
									43.29794921874998
								],
								[
									16.785253906250006,
									43.27065429687502
								]
							]
						],
						[
							[
								[
									15.371386718750074,
									43.97382812500001
								],
								[
									15.437207031250068,
									43.89951171875006
								],
								[
									15.37421875000004,
									43.91479492187497
								],
								[
									15.308593749999972,
									43.96079101562512
								],
								[
									15.270019531250028,
									44.01074218750006
								],
								[
									15.371386718750074,
									43.97382812500001
								]
							]
						],
						[
							[
								[
									15.231054687500006,
									44.0623046875001
								],
								[
									15.246679687499977,
									44.027050781249926
								],
								[
									15.121875000000045,
									44.09331054687502
								],
								[
									15.074609375000023,
									44.13784179687494
								],
								[
									15.06582031250008,
									44.15766601562498
								],
								[
									15.231054687500006,
									44.0623046875001
								]
							]
						],
						[
							[
								[
									15.188769531249989,
									43.92236328125
								],
								[
									15.203027343750051,
									43.90771484375003
								],
								[
									15.201660156250057,
									43.89775390624996
								],
								[
									15.149804687500051,
									43.91181640624998
								],
								[
									15.135839843750063,
									43.907275390625045
								],
								[
									14.891308593750068,
									44.1255371093751
								],
								[
									14.865039062500045,
									44.16796874999994
								],
								[
									14.952539062500023,
									44.117187500000085
								],
								[
									15.188769531249989,
									43.92236328125
								]
							]
						],
						[
							[
								[
									15.188476562500028,
									44.33574218749993
								],
								[
									15.16259765625,
									44.309179687500034
								],
								[
									15.097949218750045,
									44.35815429687497
								],
								[
									15.038574218750028,
									44.39301757812507
								],
								[
									14.99609375,
									44.43432617187494
								],
								[
									14.912792968749983,
									44.48583984375006
								],
								[
									14.884667968750051,
									44.54472656249996
								],
								[
									14.76044921875004,
									44.66474609375007
								],
								[
									14.741894531249983,
									44.69736328124998
								],
								[
									14.803808593750006,
									44.648681640625
								],
								[
									14.855371093750023,
									44.61826171875012
								],
								[
									14.898046875000006,
									44.61083984375003
								],
								[
									15.006445312500063,
									44.53422851562496
								],
								[
									15.112988281250011,
									44.43574218750007
								],
								[
									15.23994140625004,
									44.35019531249995
								],
								[
									15.213574218749983,
									44.34755859374994
								],
								[
									15.188476562500028,
									44.33574218749993
								]
							]
						],
						[
							[
								[
									14.831445312500023,
									44.758935546874994
								],
								[
									14.856640625000011,
									44.714843750000085
								],
								[
									14.762500000000017,
									44.754638671875085
								],
								[
									14.67822265625,
									44.769873046875006
								],
								[
									14.660351562499983,
									44.79980468749997
								],
								[
									14.672460937500063,
									44.82436523437508
								],
								[
									14.690527343750006,
									44.84814453125006
								],
								[
									14.754199218750017,
									44.84482421875009
								],
								[
									14.763769531250006,
									44.82138671875012
								],
								[
									14.831445312500023,
									44.758935546874994
								]
							]
						],
						[
							[
								[
									14.488085937500074,
									44.66005859375011
								],
								[
									14.480371093749994,
									44.62124023437511
								],
								[
									14.419531250000034,
									44.670312499999966
								],
								[
									14.388867187500011,
									44.75830078125006
								],
								[
									14.31240234375008,
									44.90039062499994
								],
								[
									14.302539062500017,
									44.94042968750003
								],
								[
									14.342187500000023,
									44.97993164062498
								],
								[
									14.340039062500011,
									45.01997070312507
								],
								[
									14.285839843749983,
									45.14462890625006
								],
								[
									14.331250000000011,
									45.16499023437504
								],
								[
									14.358203125000074,
									45.1674316406251
								],
								[
									14.369140625,
									45.080957031249966
								],
								[
									14.39375000000004,
									45.03125000000006
								],
								[
									14.467382812500034,
									44.97021484375006
								],
								[
									14.452539062500023,
									44.86918945312499
								],
								[
									14.467578125000074,
									44.725341796875085
								],
								[
									14.482519531250006,
									44.69335937500006
								],
								[
									14.488085937500074,
									44.66005859375011
								]
							]
						],
						[
							[
								[
									14.810253906250068,
									44.97705078125003
								],
								[
									14.68701171875,
									44.9556152343751
								],
								[
									14.628320312500051,
									44.9939453125001
								],
								[
									14.612988281250011,
									45.02543945312493
								],
								[
									14.51171875,
									45.035400390625085
								],
								[
									14.45039062500004,
									45.07919921875006
								],
								[
									14.437890625000051,
									45.098632812500114
								],
								[
									14.52460937500004,
									45.14682617187506
								],
								[
									14.571093750000017,
									45.22475585937505
								],
								[
									14.629980468750034,
									45.17802734374993
								],
								[
									14.701171875000057,
									45.09003906250004
								],
								[
									14.739160156250051,
									45.0654785156251
								],
								[
									14.810253906250068,
									44.97705078125003
								]
							]
						],
						[
							[
								[
									18.905371093750006,
									45.931738281250006
								],
								[
									18.90107421875001,
									45.90761718750008
								],
								[
									18.8935546875,
									45.86552734374993
								],
								[
									18.839062499999983,
									45.83574218749999
								],
								[
									18.89453125,
									45.76708984374994
								],
								[
									18.947265625,
									45.65581054687502
								],
								[
									18.91787109375005,
									45.600830078125
								],
								[
									18.953710937499977,
									45.55800781250008
								],
								[
									19.055078125000023,
									45.52724609374994
								],
								[
									19.064257812500045,
									45.51499023437509
								],
								[
									19.033300781250034,
									45.502197265625085
								],
								[
									19.007617187500045,
									45.46582031249994
								],
								[
									19.004687500000074,
									45.39951171875012
								],
								[
									19.093066406250045,
									45.33691406249997
								],
								[
									19.27285156250008,
									45.27797851562505
								],
								[
									19.33027343750004,
									45.26806640625006
								],
								[
									19.35224609375001,
									45.245410156250074
								],
								[
									19.38232421875,
									45.23061523437508
								],
								[
									19.400000000000034,
									45.212500000000034
								],
								[
									19.400976562500063,
									45.18906250000006
								],
								[
									19.388085937500023,
									45.17299804687505
								],
								[
									19.303027343750017,
									45.16728515624996
								],
								[
									19.20595703125005,
									45.167773437500074
								],
								[
									19.13691406250001,
									45.1962402343751
								],
								[
									19.13076171875008,
									45.17548828125004
								],
								[
									19.129687500000045,
									45.15170898437509
								],
								[
									19.062890625000023,
									45.13720703125006
								],
								[
									19.100000000000023,
									44.97377929687508
								],
								[
									19.085253906250045,
									44.926757812500085
								],
								[
									19.060546875,
									44.91098632812498
								],
								[
									19.03759765625003,
									44.917529296875074
								],
								[
									19.00957031249999,
									44.9193847656251
								],
								[
									18.99550781250005,
									44.90400390625007
								],
								[
									19.007128906250045,
									44.86918945312499
								],
								[
									18.941308593750023,
									44.86518554687507
								],
								[
									18.83642578124997,
									44.88325195312501
								],
								[
									18.788378906250045,
									44.91489257812506
								],
								[
									18.78017578125008,
									44.94721679687498
								],
								[
									18.779394531250006,
									44.97724609375007
								],
								[
									18.746093750000057,
									45.02651367187505
								],
								[
									18.66259765625,
									45.07744140624996
								],
								[
									18.48828125000003,
									45.08583984375008
								],
								[
									18.423925781250063,
									45.10200195312498
								],
								[
									18.35761718750004,
									45.12055664062504
								],
								[
									18.284960937500074,
									45.134277343750085
								],
								[
									18.21796875000001,
									45.13291015624998
								],
								[
									18.13720703125,
									45.11938476562497
								],
								[
									17.996289062500068,
									45.141796874999926
								],
								[
									17.94863281250005,
									45.111865234375045
								],
								[
									17.874414062500023,
									45.077246093750006
								],
								[
									17.812792968750074,
									45.078125000000085
								],
								[
									17.69013671875004,
									45.158398437499926
								],
								[
									17.65351562500004,
									45.16347656250008
								],
								[
									17.54628906250005,
									45.12255859375
								],
								[
									17.50263671875004,
									45.120361328125
								],
								[
									17.46914062500005,
									45.13330078124997
								],
								[
									17.32412109375008,
									45.163964843749994
								],
								[
									17.25869140625008,
									45.17055664062511
								],
								[
									17.210644531250068,
									45.15605468749999
								],
								[
									17.125390625000023,
									45.171777343749994
								],
								[
									16.918652343749983,
									45.27656250000001
								],
								[
									16.790820312500074,
									45.19687499999995
								],
								[
									16.53066406250008,
									45.216699218749994
								],
								[
									16.453515624999994,
									45.16201171875005
								],
								[
									16.365039062500017,
									45.05834960937497
								],
								[
									16.29335937500005,
									45.00883789062502
								],
								[
									16.231054687500063,
									45.026611328125085
								],
								[
									16.157324218750063,
									45.072216796874955
								],
								[
									16.028320312500057,
									45.18959960937508
								],
								[
									15.963183593750017,
									45.21079101562495
								],
								[
									15.888281250000034,
									45.21572265625005
								],
								[
									15.822851562500034,
									45.20278320312508
								],
								[
									15.788085937500057,
									45.17895507812494
								],
								[
									15.761523437500074,
									45.007519531249926
								],
								[
									15.737988281250068,
									44.856396484374955
								],
								[
									15.736621093750045,
									44.76582031250007
								],
								[
									15.880078125000068,
									44.68193359375002
								],
								[
									16.04902343750001,
									44.53759765625003
								],
								[
									16.10341796875008,
									44.520996093750114
								],
								[
									16.13027343750005,
									44.47373046874998
								],
								[
									16.169824218750023,
									44.352001953124955
								],
								[
									16.214257812500023,
									44.21513671874996
								],
								[
									16.300097656250017,
									44.12451171874997
								],
								[
									16.377539062500063,
									44.05961914062499
								],
								[
									16.47207031250005,
									44.00258789062511
								],
								[
									16.59052734375001,
									43.91318359375009
								],
								[
									16.68769531250001,
									43.81503906250009
								],
								[
									16.713476562500034,
									43.77880859375006
								],
								[
									16.90185546875003,
									43.649023437500006
								],
								[
									17.084570312500034,
									43.516552734374926
								],
								[
									17.24804687500003,
									43.470214843750085
								],
								[
									17.27382812500005,
									43.44575195312498
								],
								[
									17.27529296875008,
									43.343847656250006
								],
								[
									17.293066406250063,
									43.30561523437504
								],
								[
									17.402246093750023,
									43.19892578125007
								],
								[
									17.624804687500045,
									43.042773437500045
								],
								[
									17.650488281250063,
									43.00659179687506
								],
								[
									17.657812500000034,
									42.98007812500006
								],
								[
									17.64345703125005,
									42.9597656250001
								],
								[
									17.585156250000068,
									42.93837890625008
								],
								[
									17.537304687499983,
									42.96225585937498
								],
								[
									17.329882812500017,
									43.114892578124994
								],
								[
									17.12939453125003,
									43.21113281250007
								],
								[
									16.903125000000017,
									43.392431640625034
								],
								[
									16.600292968750068,
									43.46406249999998
								],
								[
									16.393945312500023,
									43.54335937500005
								],
								[
									16.26894531250005,
									43.531250000000085
								],
								[
									16.13105468750004,
									43.50629882812507
								],
								[
									16.045996093750034,
									43.505517578124994
								],
								[
									15.98554687500004,
									43.51977539062506
								],
								[
									15.942578125000011,
									43.56894531249995
								],
								[
									15.949121093749994,
									43.606982421875045
								],
								[
									15.941503906250063,
									43.65664062500005
								],
								[
									15.820605468750017,
									43.73593749999995
								],
								[
									15.65566406250008,
									43.81127929687503
								],
								[
									15.499414062500051,
									43.90878906250009
								],
								[
									15.185839843750017,
									44.172119140625085
								],
								[
									15.122949218749994,
									44.256787109374926
								],
								[
									15.184667968750063,
									44.27290039062501
								],
								[
									15.231347656250051,
									44.27143554687507
								],
								[
									15.284277343750006,
									44.28881835937506
								],
								[
									15.369726562500006,
									44.28925781250007
								],
								[
									15.470996093750017,
									44.27197265625
								],
								[
									15.381347656250057,
									44.32827148437511
								],
								[
									15.269824218750074,
									44.38349609374998
								],
								[
									14.981347656250023,
									44.60292968750011
								],
								[
									14.895214843750068,
									44.70659179687499
								],
								[
									14.885253906249972,
									44.81826171875008
								],
								[
									14.906542968750045,
									44.97138671875001
								],
								[
									14.854589843750034,
									45.08100585937507
								],
								[
									14.632031249999983,
									45.222900390625114
								],
								[
									14.550488281249983,
									45.29770507812498
								],
								[
									14.38613281250008,
									45.34213867187506
								],
								[
									14.31269531250004,
									45.33779296875005
								],
								[
									14.268554687500028,
									45.28251953124999
								],
								[
									14.236328125000028,
									45.159667968750114
								],
								[
									14.090625000000017,
									44.997607421875045
								],
								[
									14.041992187500057,
									44.92719726562507
								],
								[
									13.965820312499972,
									44.83564453125007
								],
								[
									13.899804687500023,
									44.82934570312503
								],
								[
									13.86074218750008,
									44.837402343750085
								],
								[
									13.742480468750045,
									44.991503906250045
								],
								[
									13.62929687500008,
									45.1082031250001
								],
								[
									13.613476562500068,
									45.16342773437498
								],
								[
									13.603320312500017,
									45.23139648437507
								],
								[
									13.517187500000063,
									45.48178710937509
								],
								[
									13.577929687500017,
									45.51689453124996
								],
								[
									13.615234375000057,
									45.47675781250004
								],
								[
									13.878710937499989,
									45.42836914062505
								],
								[
									13.935644531250063,
									45.44980468750006
								],
								[
									13.970117187500051,
									45.48261718750007
								],
								[
									13.970312500000006,
									45.50336914062504
								],
								[
									13.992773437500063,
									45.50942382812502
								],
								[
									14.085546875000034,
									45.47783203124999
								],
								[
									14.161230468750006,
									45.485156250000074
								],
								[
									14.283007812500045,
									45.4866210937501
								],
								[
									14.369921875000074,
									45.481445312500114
								],
								[
									14.427343750000034,
									45.505761718749994
								],
								[
									14.505175781249989,
									45.595214843750114
								],
								[
									14.533984375000017,
									45.645263671875
								],
								[
									14.56884765625,
									45.65722656250003
								],
								[
									14.591796875000057,
									45.65126953125008
								],
								[
									14.608593750000011,
									45.61010742187503
								],
								[
									14.649511718750006,
									45.57148437500007
								],
								[
									14.733593749999983,
									45.50849609375001
								],
								[
									14.793066406250034,
									45.47822265624998
								],
								[
									14.847070312500023,
									45.46733398437499
								],
								[
									14.900000000000063,
									45.49267578125
								],
								[
									14.954589843749972,
									45.49990234375005
								],
								[
									15.110449218750034,
									45.45078125000009
								],
								[
									15.242089843750023,
									45.44140625000003
								],
								[
									15.339453125000063,
									45.467041015625114
								],
								[
									15.326660156250028,
									45.502294921875006
								],
								[
									15.291210937499983,
									45.5415527343751
								],
								[
									15.283593750000051,
									45.57968750000006
								],
								[
									15.290136718750034,
									45.61264648437509
								],
								[
									15.356933593750057,
									45.64550781250006
								],
								[
									15.35371093750004,
									45.65991210937506
								],
								[
									15.27294921875,
									45.71772460937501
								],
								[
									15.27705078125004,
									45.73261718750004
								],
								[
									15.454101562500057,
									45.79760742187503
								],
								[
									15.624804687500017,
									45.834033203125074
								],
								[
									15.652148437500074,
									45.862158203125034
								],
								[
									15.668066406250034,
									45.90444335937505
								],
								[
									15.675585937500045,
									45.98369140625002
								],
								[
									15.666210937500011,
									46.04848632812508
								],
								[
									15.596875000000011,
									46.10922851562512
								],
								[
									15.592578125000017,
									46.13999023437498
								],
								[
									15.608984374999977,
									46.1719238281251
								],
								[
									15.635937500000068,
									46.2007324218751
								],
								[
									15.704199218750034,
									46.21323242187498
								],
								[
									15.784277343750006,
									46.233984375000034
								],
								[
									15.847558593749994,
									46.25786132812502
								],
								[
									15.933300781250068,
									46.277636718750045
								],
								[
									16.00068359375004,
									46.30537109375001
								],
								[
									16.066503906250034,
									46.37133789062503
								],
								[
									16.1064453125,
									46.38222656250002
								],
								[
									16.22744140625005,
									46.37285156249999
								],
								[
									16.25332031250008,
									46.38911132812501
								],
								[
									16.23671875000005,
									46.48383789062504
								],
								[
									16.258398437500034,
									46.50791015625006
								],
								[
									16.30117187500005,
									46.521386718749966
								],
								[
									16.32119140625005,
									46.5346191406251
								],
								[
									16.42763671875005,
									46.52441406250006
								],
								[
									16.516210937500063,
									46.49990234375002
								],
								[
									16.569921875000006,
									46.48500976562511
								],
								[
									16.748046875000057,
									46.41640625000008
								],
								[
									16.87148437500005,
									46.3393066406251
								],
								[
									16.939941406250057,
									46.25366210937506
								],
								[
									17.032714843750057,
									46.18730468750002
								],
								[
									17.149609375000068,
									46.14033203125004
								],
								[
									17.2421875,
									46.07661132812504
								],
								[
									17.310644531250006,
									45.996142578125074
								],
								[
									17.406347656250063,
									45.95107421875005
								],
								[
									17.529199218750023,
									45.94130859375008
								],
								[
									17.607031249999977,
									45.91376953124998
								],
								[
									17.639648437500057,
									45.86835937500007
								],
								[
									17.70644531250008,
									45.827246093750034
								],
								[
									17.80712890625,
									45.790429687499994
								],
								[
									17.96386718750003,
									45.77026367187497
								],
								[
									18.263964843750074,
									45.76547851562498
								],
								[
									18.290624999999977,
									45.764453125000045
								],
								[
									18.358300781250023,
									45.75302734375009
								],
								[
									18.437304687500017,
									45.767333984375
								],
								[
									18.533593750000023,
									45.796142578125
								],
								[
									18.56464843750004,
									45.813281250000045
								],
								[
									18.666015625,
									45.90747070312503
								],
								[
									18.721777343749977,
									45.89936523437498
								],
								[
									18.8330078125,
									45.91083984375001
								],
								[
									18.900292968750023,
									45.931738281250006
								],
								[
									18.905371093750006,
									45.931738281250006
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "HRV",
					"su_a3": "HRV",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "HRV",
					"gu_a3": "HRV",
					"abbrev": "Cro.",
					"region_un": "Europe",
					"adm0_a3_us": "HRV",
					"scalerank": 1,
					"pop_est": 4489409,
					"adm0_dif": 0,
					"un_a3": "191",
					"pop_year": -99,
					"gdp_md_est": 82390,
					"name": "Croatia",
					"sovereignt": "Croatia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Croatia",
					"postal": "HR",
					"sov_a3": "HRV",
					"note_brk": "",
					"brk_a3": "HRV",
					"wb_a2": "HR",
					"brk_diff": 0,
					"admin": "Croatia",
					"name_long": "Croatia",
					"iso_a3": "HRV",
					"iso_a2": "HR",
					"adm0_a3_is": "HRV",
					"level": 2,
					"formal_en": "Republic of Croatia",
					"name_len": 7,
					"mapcolor7": 5,
					"long_len": 7,
					"mapcolor8": 4,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "191",
					"homepart": 1,
					"subunit": "Croatia",
					"name_alt": "",
					"brk_name": "Croatia",
					"name_sort": "Croatia",
					"continent": "Europe",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								22.131835937500057,
								48.40532226562499
							],
							[
								22.227148437500034,
								48.413427734375034
							],
							[
								22.23115234375004,
								48.41215820312496
							],
							[
								22.253710937500017,
								48.407373046874966
							],
							[
								22.269433593750023,
								48.360888671875074
							],
							[
								22.27216796875004,
								48.358007812500034
							],
							[
								22.29511718750001,
								48.327294921874994
							],
							[
								22.316699218750074,
								48.28662109375006
							],
							[
								22.350195312500063,
								48.25605468750004
							],
							[
								22.42382812500003,
								48.24331054687502
							],
							[
								22.520117187500034,
								48.20537109375002
							],
							[
								22.582421875000023,
								48.13403320312506
							],
							[
								22.676367187500063,
								48.104394531249966
							],
							[
								22.68310546875003,
								48.10361328125006
							],
							[
								22.70156250000005,
								48.10703125000006
							],
							[
								22.769140625000034,
								48.10961914062506
							],
							[
								22.782226562500057,
								48.09521484375006
							],
							[
								22.836230468750045,
								48.06030273437506
							],
							[
								22.857226562500045,
								48.029541015625085
							],
							[
								22.846484375000074,
								47.99707031250003
							],
							[
								22.856054687499977,
								47.960302734375006
							],
							[
								22.87666015625001,
								47.94726562500003
							],
							[
								22.85175781250001,
								47.92255859375004
							],
							[
								22.676757812500057,
								47.79902343750001
							],
							[
								22.60839843749997,
								47.76630859375001
							],
							[
								22.56289062500005,
								47.75957031249996
							],
							[
								22.49140625000004,
								47.772558593750034
							],
							[
								22.41748046875,
								47.76264648437507
							],
							[
								22.35146484375005,
								47.73623046875002
							],
							[
								22.290625000000006,
								47.72783203124999
							],
							[
								22.24462890625003,
								47.69638671874998
							],
							[
								22.18505859374997,
								47.62905273437502
							],
							[
								22.111914062500006,
								47.57202148437506
							],
							[
								22.03798828125005,
								47.53662109375003
							],
							[
								21.999707031250068,
								47.505029296874994
							],
							[
								21.99531250000004,
								47.39570312500001
							],
							[
								21.95429687500004,
								47.3642578125
							],
							[
								21.899218750000017,
								47.33256835937502
							],
							[
								21.86933593750004,
								47.304589843749994
							],
							[
								21.785449218750017,
								47.13813476562501
							],
							[
								21.721777343750006,
								47.084814453125006
							],
							[
								21.661425781250074,
								47.04389648437501
							],
							[
								21.651464843749977,
								47.00654296875004
							],
							[
								21.652636718750045,
								46.96376953125002
							],
							[
								21.58417968750004,
								46.87836914062504
							],
							[
								21.494433593750045,
								46.78974609375001
							],
							[
								21.47705078124997,
								46.75336914062507
							],
							[
								21.497070312500057,
								46.70429687500001
							],
							[
								21.411035156250023,
								46.647851562499966
							],
							[
								21.36132812500003,
								46.62075195312505
							],
							[
								21.320214843749994,
								46.607812499999994
							],
							[
								21.294531250000006,
								46.57246093750007
							],
							[
								21.252246093750017,
								46.48637695312502
							],
							[
								21.263281250000034,
								46.44775390624997
							],
							[
								21.264550781250023,
								46.41230468750004
							],
							[
								21.19179687500005,
								46.39155273437498
							],
							[
								21.17041015625003,
								46.352685546874966
							],
							[
								21.151953125000006,
								46.304345703124966
							],
							[
								21.121679687500063,
								46.28242187500004
							],
							[
								21.039843750000074,
								46.24223632812502
							],
							[
								20.837011718750063,
								46.25971679687504
							],
							[
								20.760253906250057,
								46.24624023437505
							],
							[
								20.737402343750006,
								46.21748046875004
							],
							[
								20.732714843750045,
								46.19443359375006
							],
							[
								20.70742187500005,
								46.17280273437501
							],
							[
								20.661035156249994,
								46.145654296874966
							],
							[
								20.613671875000023,
								46.13349609374998
							],
							[
								20.508105468750017,
								46.16694335937504
							],
							[
								20.28095703125001,
								46.13300781250007
							],
							[
								20.241796875000034,
								46.10859375000007
							],
							[
								20.210156250000068,
								46.126025390625074
							],
							[
								20.161425781250017,
								46.14189453125002
							],
							[
								19.934082031250057,
								46.161474609375006
							],
							[
								19.844433593749983,
								46.14589843750002
							],
							[
								19.72451171875008,
								46.1519042968751
							],
							[
								19.61347656250001,
								46.16918945312497
							],
							[
								19.53076171875003,
								46.155175781249966
							],
							[
								19.45751953125003,
								46.0873535156251
							],
							[
								19.421289062500023,
								46.06445312500006
							],
							[
								19.392871093750017,
								46.049804687500085
							],
							[
								19.33027343750004,
								46.02851562500001
							],
							[
								19.27812499999999,
								46.00288085937501
							],
							[
								19.208398437499994,
								45.98442382812499
							],
							[
								19.146289062500045,
								45.98701171874998
							],
							[
								19.087304687500023,
								46.016162109375074
							],
							[
								19.066210937500074,
								46.00952148437506
							],
							[
								19.047656250000017,
								45.982666015625085
							],
							[
								19.015722656250006,
								45.95971679687503
							],
							[
								18.927832031250034,
								45.93139648437503
							],
							[
								18.905371093750006,
								45.931738281250006
							],
							[
								18.900292968750023,
								45.931738281250006
							],
							[
								18.8330078125,
								45.91083984375001
							],
							[
								18.721777343749977,
								45.89936523437498
							],
							[
								18.666015625,
								45.90747070312503
							],
							[
								18.56464843750004,
								45.813281250000045
							],
							[
								18.533593750000023,
								45.796142578125
							],
							[
								18.437304687500017,
								45.767333984375
							],
							[
								18.358300781250023,
								45.75302734375009
							],
							[
								18.290624999999977,
								45.764453125000045
							],
							[
								18.263964843750074,
								45.76547851562498
							],
							[
								17.96386718750003,
								45.77026367187497
							],
							[
								17.80712890625,
								45.790429687499994
							],
							[
								17.70644531250008,
								45.827246093750034
							],
							[
								17.639648437500057,
								45.86835937500007
							],
							[
								17.607031249999977,
								45.91376953124998
							],
							[
								17.529199218750023,
								45.94130859375008
							],
							[
								17.406347656250063,
								45.95107421875005
							],
							[
								17.310644531250006,
								45.996142578125074
							],
							[
								17.2421875,
								46.07661132812504
							],
							[
								17.149609375000068,
								46.14033203125004
							],
							[
								17.032714843750057,
								46.18730468750002
							],
							[
								16.939941406250057,
								46.25366210937506
							],
							[
								16.87148437500005,
								46.3393066406251
							],
							[
								16.748046875000057,
								46.41640625000008
							],
							[
								16.569921875000006,
								46.48500976562511
							],
							[
								16.516210937500063,
								46.49990234375002
							],
							[
								16.505664062500045,
								46.522070312500006
							],
							[
								16.418457031250057,
								46.607226562500045
							],
							[
								16.381250000000023,
								46.63867187500006
							],
							[
								16.384570312500074,
								46.68081054687502
							],
							[
								16.3671875,
								46.70478515625001
							],
							[
								16.33544921875003,
								46.72163085937498
							],
							[
								16.318457031250006,
								46.78251953124996
							],
							[
								16.308496093750023,
								46.82797851562498
							],
							[
								16.283593750000023,
								46.857275390625006
							],
							[
								16.093066406250017,
								46.86328124999997
							],
							[
								16.252539062500006,
								46.971923828125
							],
							[
								16.331835937500074,
								47.00219726562503
							],
							[
								16.423925781250006,
								46.99697265625005
							],
							[
								16.453417968750074,
								47.00678710937501
							],
							[
								16.461230468750074,
								47.0224609375
							],
							[
								16.47695312500008,
								47.057861328125
							],
							[
								16.48476562500005,
								47.09125976562507
							],
							[
								16.49267578124997,
								47.12265624999998
							],
							[
								16.482812500000023,
								47.14038085937503
							],
							[
								16.438378906250023,
								47.145898437499994
							],
							[
								16.41689453125008,
								47.22343749999999
							],
							[
								16.439746093750045,
								47.25273437500002
							],
							[
								16.462597656250068,
								47.27314453124998
							],
							[
								16.434375000000017,
								47.36743164062503
							],
							[
								16.442871093750057,
								47.39951171874998
							],
							[
								16.514746093750034,
								47.40454101562503
							],
							[
								16.57441406250004,
								47.424658203125034
							],
							[
								16.623046875,
								47.44755859374999
							],
							[
								16.63662109375008,
								47.47661132812496
							],
							[
								16.676562500000045,
								47.536035156249994
							],
							[
								16.639746093750006,
								47.60888671875
							],
							[
								16.43212890625,
								47.65629882812499
							],
							[
								16.421289062499994,
								47.67446289062505
							],
							[
								16.46962890625008,
								47.69506835937497
							],
							[
								16.521093750000006,
								47.724462890625006
							],
							[
								16.55097656250004,
								47.74736328124996
							],
							[
								16.590917968750006,
								47.75053710937499
							],
							[
								16.6474609375,
								47.73901367187506
							],
							[
								16.74755859375003,
								47.68627929687506
							],
							[
								16.785937500000045,
								47.67866210937501
							],
							[
								16.823046875000045,
								47.69399414062502
							],
							[
								16.86269531250005,
								47.69726562499997
							],
							[
								16.973437500000045,
								47.69531250000003
							],
							[
								17.06660156250001,
								47.707568359375045
							],
							[
								17.04560546875001,
								47.763769531250034
							],
							[
								17.04589843749997,
								47.80454101562498
							],
							[
								17.030078125000045,
								47.83710937500004
							],
							[
								17.039941406250023,
								47.872949218749966
							],
							[
								17.077734375000063,
								47.90087890624997
							],
							[
								17.089062500000068,
								47.96362304687497
							],
							[
								17.14736328125005,
								48.00595703124998
							],
							[
								17.17460937499999,
								48.01206054687498
							],
							[
								17.27724609375005,
								48.00434570312501
							],
							[
								17.301562500000017,
								47.99335937499998
							],
							[
								17.317285156250023,
								47.99091796875004
							],
							[
								17.48066406250001,
								47.88759765625002
							],
							[
								17.635253906250057,
								47.809912109375006
							],
							[
								17.76191406250001,
								47.770166015624994
							],
							[
								17.947949218750068,
								47.766894531250045
							],
							[
								18.145605468750034,
								47.76342773437506
							],
							[
								18.476269531250068,
								47.777001953124966
							],
							[
								18.724218750000034,
								47.78715820312499
							],
							[
								18.740624999999994,
								47.806494140625034
							],
							[
								18.778027343750068,
								47.85288085937498
							],
							[
								18.748339843750074,
								47.892675781250006
							],
							[
								18.750097656250063,
								47.93945312500003
							],
							[
								18.79189453125005,
								48.00029296874999
							],
							[
								18.914160156250006,
								48.05083007812499
							],
							[
								19.26513671875003,
								48.07304687499999
							],
							[
								19.46699218750001,
								48.110693359375006
							],
							[
								19.497460937499994,
								48.162109375
							],
							[
								19.564257812500017,
								48.21284179687504
							],
							[
								19.62539062500005,
								48.22309570312498
							],
							[
								19.709179687500068,
								48.199804687500034
							],
							[
								19.81005859375,
								48.15502929687497
							],
							[
								19.89863281250001,
								48.13134765625003
							],
							[
								19.95039062500001,
								48.14663085937505
							],
							[
								20.128613281250068,
								48.222021484375034
							],
							[
								20.333789062500045,
								48.29555664062502
							],
							[
								20.475000000000023,
								48.4951171875
							],
							[
								20.490039062500074,
								48.52690429687499
							],
							[
								20.643164062500006,
								48.549707031249994
							],
							[
								20.86660156250005,
								48.54565429687497
							],
							[
								20.98115234375004,
								48.51967773437502
							],
							[
								21.06728515625008,
								48.50590820312496
							],
							[
								21.196386718750006,
								48.510595703125034
							],
							[
								21.382421875000063,
								48.55346679687497
							],
							[
								21.451367187500068,
								48.55224609375
							],
							[
								21.504687500000017,
								48.52187500000002
							],
							[
								21.56318359375004,
								48.495703125000006
							],
							[
								21.602636718749977,
								48.46367187499999
							],
							[
								21.63251953125004,
								48.41850585937502
							],
							[
								21.64863281250004,
								48.401464843750006
							],
							[
								21.674609375000074,
								48.37836914062501
							],
							[
								21.721484375000045,
								48.34658203125002
							],
							[
								21.76699218750008,
								48.33808593750007
							],
							[
								22.111328125000057,
								48.393359375000045
							],
							[
								22.131835937500057,
								48.40532226562499
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "HUN",
					"su_a3": "HUN",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "HUN",
					"gu_a3": "HUN",
					"abbrev": "Hun.",
					"region_un": "Europe",
					"adm0_a3_us": "HUN",
					"scalerank": 1,
					"pop_est": 9905596,
					"adm0_dif": 0,
					"un_a3": "348",
					"pop_year": -99,
					"gdp_md_est": 196600,
					"name": "Hungary",
					"sovereignt": "Hungary",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Hungary",
					"postal": "HU",
					"sov_a3": "HUN",
					"note_brk": "",
					"brk_a3": "HUN",
					"wb_a2": "HU",
					"brk_diff": 0,
					"admin": "Hungary",
					"name_long": "Hungary",
					"iso_a3": "HUN",
					"iso_a2": "HU",
					"adm0_a3_is": "HUN",
					"level": 2,
					"formal_en": "Republic of Hungary",
					"name_len": 7,
					"mapcolor7": 4,
					"long_len": 7,
					"mapcolor8": 6,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "348",
					"homepart": 1,
					"subunit": "Hungary",
					"name_alt": "",
					"brk_name": "Hungary",
					"name_sort": "Hungary",
					"continent": "Europe",
					"mapcolor13": 5,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									122.94892578125018,
									-10.909277343750048
								],
								[
									122.85585937500014,
									-10.909667968749957
								],
								[
									122.82617187500011,
									-10.89912109374994
								],
								[
									122.81845703125003,
									-10.811035156249929
								],
								[
									122.84570312500011,
									-10.761816406249935
								],
								[
									123.06142578124997,
									-10.698437499999912
								],
								[
									123.14580078125005,
									-10.639941406249974
								],
								[
									123.26542968750016,
									-10.518164062499949
								],
								[
									123.33964843749999,
									-10.486230468749923
								],
								[
									123.3584960937502,
									-10.47246093749996
								],
								[
									123.37109375000011,
									-10.474902343750017
								],
								[
									123.38310546875016,
									-10.567578125000068
								],
								[
									123.41289062499999,
									-10.62265624999992
								],
								[
									123.41816406250001,
									-10.651269531250065
								],
								[
									123.31074218750018,
									-10.698437499999912
								],
								[
									123.21484375,
									-10.80615234375
								],
								[
									123.00527343750002,
									-10.876367187499923
								],
								[
									122.94892578125018,
									-10.909277343750048
								]
							]
						],
						[
							[
								[
									121.88300781250018,
									-10.590332031249915
								],
								[
									121.83310546875003,
									-10.602148437500006
								],
								[
									121.7261718750002,
									-10.573144531249966
								],
								[
									121.70468750000009,
									-10.555664062499957
								],
								[
									121.79628906250002,
									-10.507421874999977
								],
								[
									121.86699218749999,
									-10.438867187499966
								],
								[
									121.94951171875005,
									-10.433007812500009
								],
								[
									121.99833984375005,
									-10.446972656250011
								],
								[
									121.98134765625014,
									-10.528417968749906
								],
								[
									121.88300781250018,
									-10.590332031249915
								]
							]
						],
						[
							[
								[
									123.41621093750007,
									-10.302636718749923
								],
								[
									123.32597656250016,
									-10.33749999999992
								],
								[
									123.32558593749997,
									-10.2641601562499
								],
								[
									123.39531250000016,
									-10.17138671875
								],
								[
									123.45878906250005,
									-10.139941406249989
								],
								[
									123.49394531249999,
									-10.176953125000068
								],
								[
									123.49677734375007,
									-10.193945312499977
								],
								[
									123.40507812499999,
									-10.227148437499991
								],
								[
									123.41621093750007,
									-10.302636718749923
								]
							]
						],
						[
							[
								[
									120.01250000000005,
									-9.374707031250054
								],
								[
									120.0576171875,
									-9.419726562499989
								],
								[
									120.22109374999997,
									-9.506347656249957
								],
								[
									120.248046875,
									-9.542871093749937
								],
								[
									120.25830078125011,
									-9.603125000000048
								],
								[
									120.29111328125003,
									-9.647851562499923
								],
								[
									120.36474609374994,
									-9.65468749999998
								],
								[
									120.44365234375005,
									-9.645605468749906
								],
								[
									120.50371093749999,
									-9.674023437499926
								],
								[
									120.55556640625002,
									-9.719042968749946
								],
								[
									120.63261718750016,
									-9.806445312499903
								],
								[
									120.70039062500001,
									-9.90312500000006
								],
								[
									120.78447265624999,
									-9.957031250000028
								],
								[
									120.83261718750003,
									-10.037499999999909
								],
								[
									120.80419921874994,
									-10.108496093749977
								],
								[
									120.69804687499999,
									-10.206640624999906
								],
								[
									120.64042968750016,
									-10.22792968749998
								],
								[
									120.56171875000001,
									-10.235644531249946
								],
								[
									120.43916015625018,
									-10.294042968749949
								],
								[
									120.39453125,
									-10.263476562499932
								],
								[
									120.25546875000009,
									-10.242285156249963
								],
								[
									120.14482421874999,
									-10.200097656249895
								],
								[
									120.05195312500018,
									-10.12285156250006
								],
								[
									119.99843750000002,
									-10.039746093749912
								],
								[
									119.9306640625,
									-9.966503906249912
								],
								[
									119.81279296875005,
									-9.917480468749972
								],
								[
									119.60107421875,
									-9.773535156249949
								],
								[
									119.47031250000009,
									-9.760546874999974
								],
								[
									119.41650390625011,
									-9.771093749999892
								],
								[
									119.36259765625016,
									-9.771777343749946
								],
								[
									119.08544921875011,
									-9.706933593749966
								],
								[
									119.04238281250002,
									-9.669042968749977
								],
								[
									119.0083984375002,
									-9.620507812500037
								],
								[
									118.97734374999999,
									-9.57285156249992
								],
								[
									118.95878906250005,
									-9.519335937500031
								],
								[
									118.99414062499994,
									-9.472070312499994
								],
								[
									119.03144531250018,
									-9.440234374999903
								],
								[
									119.18564453125009,
									-9.384472656249912
								],
								[
									119.2958984375,
									-9.367187499999943
								],
								[
									119.4239257812502,
									-9.369824218749955
								],
								[
									119.61474609375011,
									-9.352441406249966
								],
								[
									119.79511718750018,
									-9.380468749999892
								],
								[
									119.85078125000007,
									-9.359570312499898
								],
								[
									119.94208984375018,
									-9.301464843750054
								],
								[
									119.97382812500007,
									-9.321582031249974
								],
								[
									120.01250000000005,
									-9.374707031250054
								]
							]
						],
						[
							[
								[
									125.06816406249999,
									-9.51191406249994
								],
								[
									124.99794921874997,
									-9.565332031249895
								],
								[
									124.96308593750018,
									-9.665624999999991
								],
								[
									124.84179687499994,
									-9.759765624999986
								],
								[
									124.70839843749997,
									-9.914160156249906
								],
								[
									124.60185546875005,
									-9.992968749999974
								],
								[
									124.50820312500014,
									-10.08613281250004
								],
								[
									124.42753906250005,
									-10.148632812499983
								],
								[
									124.3267578125002,
									-10.169824218750037
								],
								[
									124.17597656250001,
									-10.18330078124994
								],
								[
									123.97109375000014,
									-10.294824218749923
								],
								[
									123.85761718750001,
									-10.343554687499903
								],
								[
									123.74726562500018,
									-10.347167968749929
								],
								[
									123.64414062500003,
									-10.310937500000009
								],
								[
									123.60478515625005,
									-10.270117187499949
								],
								[
									123.61406250000016,
									-10.215039062500011
								],
								[
									123.64824218749999,
									-10.167773437499974
								],
								[
									123.69013671875018,
									-10.128808593749937
								],
								[
									123.7164062500002,
									-10.078613281249929
								],
								[
									123.59941406249999,
									-10.015136718749972
								],
								[
									123.58925781249997,
									-9.966796874999972
								],
								[
									123.63574218750011,
									-9.838085937499955
								],
								[
									123.66582031250005,
									-9.705273437499983
								],
								[
									123.70937500000002,
									-9.614843749999949
								],
								[
									123.87675781249999,
									-9.453125000000043
								],
								[
									123.9771484375002,
									-9.372949218750051
								],
								[
									124.03632812500018,
									-9.34160156250006
								],
								[
									124.05244140625018,
									-9.375390624999923
								],
								[
									124.09013671875016,
									-9.416406250000023
								],
								[
									124.11552734375016,
									-9.423144531249974
								],
								[
									124.13457031250005,
									-9.413867187499946
								],
								[
									124.2823242187502,
									-9.427929687499969
								],
								[
									124.31933593750011,
									-9.413769531249926
								],
								[
									124.37568359375007,
									-9.349902343749974
								],
								[
									124.41298828125002,
									-9.314355468749923
								],
								[
									124.43828124999999,
									-9.238574218750031
								],
								[
									124.4444335937502,
									-9.19033203124998
								],
								[
									124.57548828125016,
									-9.155371093749963
								],
								[
									124.64589843750014,
									-9.1166992187499
								],
								[
									124.70820312500001,
									-9.061816406249903
								],
								[
									124.88974609375003,
									-8.968457031250068
								],
								[
									124.92226562500014,
									-8.942480468749935
								],
								[
									124.91503906249994,
									-9.03154296874996
								],
								[
									124.93681640625016,
									-9.053417968749969
								],
								[
									124.9732421875002,
									-9.064257812500045
								],
								[
									125.10039062500016,
									-9.004003906249935
								],
								[
									125.12441406249997,
									-9.015429687500045
								],
								[
									125.1490234375002,
									-9.042578124999977
								],
								[
									125.14941406250011,
									-9.122949218749923
								],
								[
									125.10048828125002,
									-9.189843750000051
								],
								[
									124.97753906250011,
									-9.19492187500002
								],
								[
									124.96015625000001,
									-9.213769531249952
								],
								[
									124.95859375000003,
									-9.254687499999946
								],
								[
									124.96826171875,
									-9.294238281250003
								],
								[
									124.99697265625014,
									-9.325976562499903
								],
								[
									125.03359375000014,
									-9.381835937499915
								],
								[
									125.06816406249999,
									-9.51191406249994
								]
							]
						],
						[
							[
								[
									115.6099609375002,
									-8.769824218749932
								],
								[
									115.58193359374997,
									-8.80419921875
								],
								[
									115.50087890624997,
									-8.74287109374994
								],
								[
									115.48046875000011,
									-8.715429687500034
								],
								[
									115.5406250000002,
									-8.675390625000048
								],
								[
									115.56142578124997,
									-8.669921875
								],
								[
									115.61328124999994,
									-8.713183593749932
								],
								[
									115.6099609375002,
									-8.769824218749932
								]
							]
						],
						[
							[
								[
									122.97734374999999,
									-8.545214843749903
								],
								[
									122.94550781250018,
									-8.6040039062499
								],
								[
									122.88779296875003,
									-8.587304687499952
								],
								[
									122.90351562500007,
									-8.530664062500051
								],
								[
									122.93281250000018,
									-8.497070312499957
								],
								[
									123.01054687500005,
									-8.448339843749977
								],
								[
									123.0894531250002,
									-8.439843750000023
								],
								[
									123.13789062500001,
									-8.456933593749952
								],
								[
									123.15312500000005,
									-8.475781249999969
								],
								[
									123.03007812499999,
									-8.49482421874994
								],
								[
									122.97734374999999,
									-8.545214843749903
								]
							]
						],
						[
							[
								[
									119.46406250000001,
									-8.741015624999918
								],
								[
									119.42490234375003,
									-8.7504882812499
								],
								[
									119.38554687500005,
									-8.736035156249969
								],
								[
									119.40166015625005,
									-8.647070312499963
								],
								[
									119.37890625000011,
									-8.586523437500063
								],
								[
									119.41992187500011,
									-8.539062499999986
								],
								[
									119.43017578125,
									-8.454980468749909
								],
								[
									119.44648437500018,
									-8.429199218749986
								],
								[
									119.47050781250005,
									-8.455664062500048
								],
								[
									119.48173828124999,
									-8.472949218750017
								],
								[
									119.50214843750018,
									-8.481054687499977
								],
								[
									119.54697265625003,
									-8.48261718749994
								],
								[
									119.5572265625002,
									-8.51884765624996
								],
								[
									119.55546874999999,
									-8.553417968750068
								],
								[
									119.53632812500001,
									-8.589355468749929
								],
								[
									119.48281250000014,
									-8.628222656250031
								],
								[
									119.44404296875007,
									-8.671777343750023
								],
								[
									119.46406250000001,
									-8.741015624999918
								]
							]
						],
						[
							[
								[
									123.3174804687502,
									-8.354785156249932
								],
								[
									123.29726562499997,
									-8.398632812499983
								],
								[
									123.0250000000002,
									-8.395507812499957
								],
								[
									123.03261718749997,
									-8.337792968749923
								],
								[
									123.10830078125014,
									-8.27480468749998
								],
								[
									123.13349609375001,
									-8.253808593749966
								],
								[
									123.21708984374999,
									-8.235449218749949
								],
								[
									123.33603515625009,
									-8.269042968750043
								],
								[
									123.3174804687502,
									-8.354785156249932
								]
							]
						],
						[
							[
								[
									116.64082031250007,
									-8.613867187499949
								],
								[
									116.5142578125002,
									-8.820996093749955
								],
								[
									116.55937500000016,
									-8.854394531249923
								],
								[
									116.5865234375002,
									-8.886132812499994
								],
								[
									116.37724609374999,
									-8.929003906249932
								],
								[
									116.28984375000016,
									-8.906152343749895
								],
								[
									116.23935546875009,
									-8.912109374999957
								],
								[
									116.02675781250002,
									-8.87314453124992
								],
								[
									115.8746093750002,
									-8.825585937499923
								],
								[
									115.85732421875014,
									-8.78789062499996
								],
								[
									115.86933593750018,
									-8.74277343749992
								],
								[
									115.91445312500014,
									-8.758007812499912
								],
								[
									116.03164062500014,
									-8.765234374999963
								],
								[
									116.07646484374999,
									-8.744921875000003
								],
								[
									116.0777343750002,
									-8.611328124999972
								],
								[
									116.06113281250009,
									-8.437402343749966
								],
								[
									116.21982421875009,
									-8.295214843750045
								],
								[
									116.30429687500003,
									-8.23798828124994
								],
								[
									116.40156250000018,
									-8.204199218749977
								],
								[
									116.64697265625,
									-8.282714843749986
								],
								[
									116.68749999999994,
									-8.304101562499909
								],
								[
									116.71894531250018,
									-8.33603515624992
								],
								[
									116.73408203125007,
									-8.386914062499983
								],
								[
									116.64082031250007,
									-8.613867187499949
								]
							]
						],
						[
							[
								[
									124.28662109375011,
									-8.329492187499923
								],
								[
									124.22578125000007,
									-8.391308593749912
								],
								[
									124.18437500000016,
									-8.49873046874994
								],
								[
									124.14667968750001,
									-8.53144531249994
								],
								[
									124.06572265625016,
									-8.551660156250065
								],
								[
									124.01728515625001,
									-8.443847656249957
								],
								[
									123.92773437500011,
									-8.448925781249926
								],
								[
									123.97148437500005,
									-8.354101562499963
								],
								[
									124.0137695312502,
									-8.318652343749932
								],
								[
									124.06875000000014,
									-8.317773437500023
								],
								[
									124.09580078125003,
									-8.356152343750026
								],
								[
									124.11054687500001,
									-8.3642578124999
								],
								[
									124.23955078125005,
									-8.203417968749903
								],
								[
									124.26562500000011,
									-8.20175781249992
								],
								[
									124.28710937500011,
									-8.208691406249912
								],
								[
									124.30449218750005,
									-8.228808593750017
								],
								[
									124.28662109375011,
									-8.329492187499923
								]
							]
						],
						[
							[
								[
									123.92480468750011,
									-8.272460937500028
								],
								[
									123.78388671875018,
									-8.29960937499996
								],
								[
									123.69785156250009,
									-8.424414062499906
								],
								[
									123.62919921875005,
									-8.422460937500034
								],
								[
									123.59160156249999,
									-8.477929687499966
								],
								[
									123.58261718750003,
									-8.501660156249912
								],
								[
									123.58789062499994,
									-8.523828124999909
								],
								[
									123.58017578125009,
									-8.544921874999943
								],
								[
									123.55302734375016,
									-8.566796874999952
								],
								[
									123.48867187499997,
									-8.532324218750034
								],
								[
									123.43378906250018,
									-8.576074218750065
								],
								[
									123.4107421875002,
									-8.586621093749912
								],
								[
									123.32998046874997,
									-8.53564453125
								],
								[
									123.25332031250002,
									-8.538574218749972
								],
								[
									123.23007812500009,
									-8.530664062500051
								],
								[
									123.32500000000016,
									-8.439062499999949
								],
								[
									123.45458984375,
									-8.353710937499969
								],
								[
									123.47587890625016,
									-8.322265624999957
								],
								[
									123.42519531250014,
									-8.313378906249923
								],
								[
									123.39492187499997,
									-8.300585937499903
								],
								[
									123.3912109375002,
									-8.280468749999969
								],
								[
									123.47324218750003,
									-8.26708984375
								],
								[
									123.52998046875007,
									-8.265234374999977
								],
								[
									123.57314453124997,
									-8.29150390625
								],
								[
									123.60058593749994,
									-8.29130859374996
								],
								[
									123.77597656250009,
									-8.190429687500014
								],
								[
									123.84550781250005,
									-8.2133789062499
								],
								[
									123.89609375000003,
									-8.239257812500014
								],
								[
									123.92480468750011,
									-8.272460937500028
								]
							]
						],
						[
							[
								[
									138.89511718750003,
									-8.3886718749999
								],
								[
									138.84550781250016,
									-8.401757812499909
								],
								[
									138.59423828124994,
									-8.371484374999952
								],
								[
									138.56718750000005,
									-8.330273437499912
								],
								[
									138.56337890624997,
									-8.309082031250028
								],
								[
									138.62099609374997,
									-8.268457031249923
								],
								[
									138.67666015625014,
									-8.199218750000028
								],
								[
									138.7626953125,
									-8.173437499999935
								],
								[
									138.79619140625016,
									-8.173632812499974
								],
								[
									138.89765625,
									-8.337499999999963
								],
								[
									138.89511718750003,
									-8.3886718749999
								]
							]
						],
						[
							[
								[
									117.55634765625007,
									-8.367285156249892
								],
								[
									117.53359375000014,
									-8.367968749999946
								],
								[
									117.49042968750001,
									-8.348730468749935
								],
								[
									117.5059570312502,
									-8.307031249999966
								],
								[
									117.48212890625001,
									-8.239257812500014
								],
								[
									117.49052734375016,
									-8.183398437500003
								],
								[
									117.54609375000018,
									-8.151953124999991
								],
								[
									117.6650390625,
									-8.148242187499946
								],
								[
									117.66923828125016,
									-8.18925781249996
								],
								[
									117.55634765625007,
									-8.367285156249892
								]
							]
						],
						[
							[
								[
									119.0738281250002,
									-8.238867187499935
								],
								[
									119.02998046875018,
									-8.240039062499903
								],
								[
									119.02089843749997,
									-8.199902343749898
								],
								[
									119.03662109375011,
									-8.157812499999949
								],
								[
									119.07871093750003,
									-8.14023437499992
								],
								[
									119.0977539062502,
									-8.139160156249957
								],
								[
									119.12832031250014,
									-8.17714843749998
								],
								[
									119.1348632812502,
									-8.197070312499946
								],
								[
									119.10673828125016,
									-8.223437499999989
								],
								[
									119.0738281250002,
									-8.238867187499935
								]
							]
						],
						[
							[
								[
									124.57558593750002,
									-8.14082031249994
								],
								[
									124.59960937500011,
									-8.20175781249992
								],
								[
									124.6768554687502,
									-8.168066406249906
								],
								[
									124.75224609375005,
									-8.159570312499952
								],
								[
									124.92412109375016,
									-8.166015625000014
								],
								[
									125.05029296875,
									-8.179589843749937
								],
								[
									125.1246093750002,
									-8.204785156249926
								],
								[
									125.13173828124997,
									-8.326464843750017
								],
								[
									125.09677734375003,
									-8.35283203125006
								],
								[
									124.44423828124997,
									-8.444628906249932
								],
								[
									124.38066406249999,
									-8.415136718749963
								],
								[
									124.3555664062502,
									-8.385937500000054
								],
								[
									124.42597656250018,
									-8.295800781249895
								],
								[
									124.39355468749994,
									-8.253027343749977
								],
								[
									124.43066406249994,
									-8.183203124999963
								],
								[
									124.50859375000005,
									-8.135449218749912
								],
								[
									124.57558593750002,
									-8.14082031249994
								]
							]
						],
						[
							[
								[
									127.82343750000018,
									-8.098828124999912
								],
								[
									127.99843750000014,
									-8.139062499999937
								],
								[
									128.09882812500007,
									-8.134863281250063
								],
								[
									128.1192382812502,
									-8.170703124999903
								],
								[
									128.0235351562501,
									-8.255371093749929
								],
								[
									127.8208984375002,
									-8.190234374999974
								],
								[
									127.78623046875003,
									-8.12031249999994
								],
								[
									127.82343750000018,
									-8.098828124999912
								]
							]
						],
						[
							[
								[
									122.78291015625018,
									-8.611718749999952
								],
								[
									122.64150390624997,
									-8.647265625000003
								],
								[
									122.55380859375003,
									-8.680957031249946
								],
								[
									122.47021484375,
									-8.725488281249952
								],
								[
									122.41728515625005,
									-8.734667968750045
								],
								[
									122.32148437500007,
									-8.7382812499999
								],
								[
									122.18574218750001,
									-8.730273437499946
								],
								[
									122.09414062500002,
									-8.744726562499963
								],
								[
									121.83867187500005,
									-8.8603515624999
								],
								[
									121.73828125,
									-8.870410156249989
								],
								[
									121.65136718749994,
									-8.898730468749903
								],
								[
									121.62128906250007,
									-8.85380859374989
								],
								[
									121.5845703125002,
									-8.820605468749974
								],
								[
									121.49960937500003,
									-8.81220703124994
								],
								[
									121.41464843750003,
									-8.814843750000037
								],
								[
									121.32832031250007,
									-8.916894531249952
								],
								[
									121.19082031250002,
									-8.895507812499957
								],
								[
									121.13749999999999,
									-8.904492187499912
								],
								[
									121.08613281250018,
									-8.92597656249994
								],
								[
									121.0352539062502,
									-8.935449218749923
								],
								[
									120.98183593749997,
									-8.928320312500063
								],
								[
									120.78095703125018,
									-8.84882812499994
								],
								[
									120.55048828125001,
									-8.801855468749963
								],
								[
									120.31953125000007,
									-8.820312499999915
								],
								[
									120.12089843749999,
									-8.776953124999963
								],
								[
									120.01210937500014,
									-8.810156249999977
								],
								[
									119.90937500000018,
									-8.857617187499955
								],
								[
									119.87910156250001,
									-8.807617187499986
								],
								[
									119.84140625000009,
									-8.76357421874998
								],
								[
									119.80791015624999,
									-8.697656249999966
								],
								[
									119.80703125000002,
									-8.622949218750023
								],
								[
									119.81816406250016,
									-8.570507812499997
								],
								[
									119.84765625000011,
									-8.522851562499966
								],
								[
									119.86611328124997,
									-8.473144531250057
								],
								[
									119.87480468750016,
									-8.419824218749937
								],
								[
									119.91826171875005,
									-8.445117187500031
								],
								[
									119.96376953124997,
									-8.435546874999943
								],
								[
									120.0992187500002,
									-8.377539062499949
								],
								[
									120.23115234375018,
									-8.289843750000017
								],
								[
									120.35410156250009,
									-8.257812499999972
								],
								[
									120.4249023437502,
									-8.248925781249937
								],
								[
									120.48554687500007,
									-8.266113281249886
								],
								[
									120.54716796875016,
									-8.259863281249949
								],
								[
									120.61025390625014,
									-8.240429687499983
								],
								[
									120.7095703125002,
									-8.307812499999955
								],
								[
									120.75136718750002,
									-8.321484375000068
								],
								[
									120.88613281250014,
									-8.326660156250057
								],
								[
									121.00869140625014,
									-8.36552734374989
								],
								[
									121.11816406249994,
									-8.423535156249983
								],
								[
									121.27666015624999,
									-8.477929687499966
								],
								[
									121.37197265624997,
									-8.550878906249906
								],
								[
									121.44453125000001,
									-8.577832031250068
								],
								[
									121.49843749999997,
									-8.585156249999969
								],
								[
									121.5479492187502,
									-8.575292968749906
								],
								[
									121.61035156249994,
									-8.526171874999932
								],
								[
									121.68339843749999,
									-8.505859374999972
								],
								[
									121.74707031250011,
									-8.50664062499996
								],
								[
									121.86289062500009,
									-8.493945312500031
								],
								[
									121.91171875000009,
									-8.48212890624994
								],
								[
									121.96650390625001,
									-8.455175781249949
								],
								[
									122.02011718750003,
									-8.471874999999983
								],
								[
									122.06708984375001,
									-8.496679687499963
								],
								[
									122.26308593749997,
									-8.624902343750065
								],
								[
									122.3232421875,
									-8.628320312500051
								],
								[
									122.43349609375014,
									-8.600781249999955
								],
								[
									122.46660156250016,
									-8.566406249999957
								],
								[
									122.48359375000007,
									-8.513574218749952
								],
								[
									122.51376953125009,
									-8.469628906250051
								],
								[
									122.55585937500001,
									-8.431542968749937
								],
								[
									122.60351562499994,
									-8.402441406249949
								],
								[
									122.74999999999994,
									-8.353124999999949
								],
								[
									122.85048828125002,
									-8.304394531249969
								],
								[
									122.91914062500007,
									-8.221875000000026
								],
								[
									122.75859375000005,
									-8.185937499999895
								],
								[
									122.79238281249997,
									-8.126562499999977
								],
								[
									122.84570312500011,
									-8.093261718749943
								],
								[
									122.91699218749994,
									-8.105566406249963
								],
								[
									122.97832031250005,
									-8.151953124999991
								],
								[
									123.00595703125003,
									-8.329101562499929
								],
								[
									122.95546874999997,
									-8.354101562499963
								],
								[
									122.92363281250016,
									-8.380957031249935
								],
								[
									122.90214843750016,
									-8.416308593749932
								],
								[
									122.81113281250009,
									-8.481152343749912
								],
								[
									122.84677734375003,
									-8.562207031249912
								],
								[
									122.82001953125001,
									-8.595703124999886
								],
								[
									122.78291015625018,
									-8.611718749999952
								]
							]
						],
						[
							[
								[
									130.86220703125002,
									-8.318749999999952
								],
								[
									130.77519531250005,
									-8.349902343749903
								],
								[
									130.83339843750002,
									-8.270800781250045
								],
								[
									131.0201171875002,
									-8.0913085937499
								],
								[
									131.08740234374994,
									-8.124511718749915
								],
								[
									131.17636718750003,
									-8.130761718749937
								],
								[
									131.04375000000005,
									-8.212011718749977
								],
								[
									130.90810546875014,
									-8.245703124999906
								],
								[
									130.86220703125002,
									-8.318749999999952
								]
							]
						],
						[
							[
								[
									118.24238281250001,
									-8.317773437500023
								],
								[
									118.29238281249997,
									-8.357226562499974
								],
								[
									118.33789062500011,
									-8.353515624999929
								],
								[
									118.43320312500009,
									-8.293261718750003
								],
								[
									118.49062500000014,
									-8.271484374999915
								],
								[
									118.55214843749997,
									-8.270410156249966
								],
								[
									118.61191406250009,
									-8.280664062499923
								],
								[
									118.67060546875001,
									-8.32343749999994
								],
								[
									118.69179687500002,
									-8.393457031249895
								],
								[
									118.71386718749994,
									-8.414941406249923
								],
								[
									118.74833984375016,
									-8.331152343749906
								],
								[
									118.79423828124999,
									-8.305859374999912
								],
								[
									118.84570312500011,
									-8.293066406249963
								],
								[
									118.92617187499997,
									-8.297656249999918
								],
								[
									118.98779296875011,
									-8.337695312499903
								],
								[
									119.04384765625014,
									-8.456738281249912
								],
								[
									119.04208984375003,
									-8.560937499999909
								],
								[
									119.06250000000011,
									-8.599804687499926
								],
								[
									119.10107421875,
									-8.628222656250031
								],
								[
									119.12968750000005,
									-8.668164062499997
								],
								[
									119.10419921875018,
									-8.709960937499986
								],
								[
									119.07890624999999,
									-8.7304687499999
								],
								[
									119.00625000000014,
									-8.749609374999977
								],
								[
									118.97148437500016,
									-8.741210937499957
								],
								[
									118.93935546874997,
									-8.713085937499912
								],
								[
									118.90332031250011,
									-8.702734374999935
								],
								[
									118.82119140624997,
									-8.712109375000068
								],
								[
									118.74589843749999,
									-8.735449218749935
								],
								[
									118.75624999999997,
									-8.773632812499898
								],
								[
									118.81806640625007,
									-8.790820312499946
								],
								[
									118.83671875000005,
									-8.808886718749974
								],
								[
									118.8326171875002,
									-8.833398437499909
								],
								[
									118.80830078125001,
									-8.838281249999923
								],
								[
									118.72792968749997,
									-8.805273437499949
								],
								[
									118.67363281250005,
									-8.81191406249998
								],
								[
									118.4786132812502,
									-8.856445312499986
								],
								[
									118.42695312500007,
									-8.855468749999972
								],
								[
									118.39785156249997,
									-8.813378906249923
								],
								[
									118.39990234374994,
									-8.703710937499963
								],
								[
									118.37890625000011,
									-8.674609374999974
								],
								[
									118.23398437500009,
									-8.807812500000026
								],
								[
									118.18994140625,
									-8.84052734374994
								],
								[
									118.13154296875018,
									-8.855957031249972
								],
								[
									118.07070312500014,
									-8.850585937499943
								],
								[
									117.86123046874997,
									-8.931445312499989
								],
								[
									117.79541015625,
									-8.920117187499898
								],
								[
									117.73164062500007,
									-8.919921874999957
								],
								[
									117.50791015625003,
									-9.00751953124994
								],
								[
									117.38789062500001,
									-9.03193359374994
								],
								[
									117.32636718750018,
									-9.033691406249943
								],
								[
									117.26503906250014,
									-9.026171874999932
								],
								[
									117.21025390625016,
									-9.034082031249937
								],
								[
									117.1612304687502,
									-9.069238281249994
								],
								[
									117.06132812499999,
									-9.099023437500023
								],
								[
									116.95820312500007,
									-9.076367187500026
								],
								[
									116.87109375,
									-9.046191406249918
								],
								[
									116.78847656250014,
									-9.006347656249972
								],
								[
									116.76796875000014,
									-8.955468749999909
								],
								[
									116.77207031250003,
									-8.894335937499974
								],
								[
									116.80693359375016,
									-8.810937499999952
								],
								[
									116.78310546875002,
									-8.664648437499991
								],
								[
									116.80126953124994,
									-8.597949218749903
								],
								[
									116.8350585937502,
									-8.532421875000054
								],
								[
									116.88623046874994,
									-8.508300781249943
								],
								[
									116.953125,
									-8.503417968749915
								],
								[
									117.06367187500007,
									-8.444433593749977
								],
								[
									117.16484375000016,
									-8.367187499999972
								],
								[
									117.22363281249994,
									-8.374511718749943
								],
								[
									117.35664062500007,
									-8.428515624999932
								],
								[
									117.43457031250011,
									-8.434960937499923
								],
								[
									117.56708984375001,
									-8.426367187499949
								],
								[
									117.62177734375007,
									-8.459570312499963
								],
								[
									117.64335937499999,
									-8.53554687499998
								],
								[
									117.6728515625,
									-8.563281249999946
								],
								[
									117.71210937500018,
									-8.582617187499977
								],
								[
									117.80605468750014,
									-8.711132812499955
								],
								[
									117.8931640625002,
									-8.704394531249918
								],
								[
									117.96953125000005,
									-8.728027343749943
								],
								[
									118.1041015625002,
									-8.650292968749909
								],
								[
									118.20595703124997,
									-8.652148437499932
								],
								[
									118.23486328125,
									-8.59189453124992
								],
								[
									118.17402343750001,
									-8.527539062499955
								],
								[
									118.10048828124997,
									-8.475195312499949
								],
								[
									118.06103515625011,
									-8.464257812500023
								],
								[
									118.01787109375005,
									-8.467382812499949
								],
								[
									117.9791015625002,
									-8.458886718749994
								],
								[
									117.81484375000014,
									-8.342089843750003
								],
								[
									117.76640625000005,
									-8.27900390624994
								],
								[
									117.7383789062502,
									-8.204589843750057
								],
								[
									117.75527343749997,
									-8.149511718749935
								],
								[
									117.8682617187502,
									-8.100878906249974
								],
								[
									117.9209960937502,
									-8.089062499999969
								],
								[
									118.11748046875016,
									-8.122265624999983
								],
								[
									118.15068359375016,
									-8.149999999999949
								],
								[
									118.20283203125007,
									-8.26728515625004
								],
								[
									118.24238281250001,
									-8.317773437500023
								]
							]
						],
						[
							[
								[
									115.4478515625002,
									-8.155175781249937
								],
								[
									115.5494140625002,
									-8.208300781249932
								],
								[
									115.69091796875,
									-8.363574218749946
								],
								[
									115.70429687500001,
									-8.407128906249937
								],
								[
									115.66142578124999,
									-8.448242187499957
								],
								[
									115.55996093750014,
									-8.514160156249972
								],
								[
									115.33378906250016,
									-8.615722656249972
								],
								[
									115.29501953125003,
									-8.663671874999977
								],
								[
									115.24716796875009,
									-8.757519531249912
								],
								[
									115.23613281250016,
									-8.797558593750068
								],
								[
									115.22021484375011,
									-8.819531249999926
								],
								[
									115.19423828125014,
									-8.835449218749972
								],
								[
									115.14492187500014,
									-8.84902343749998
								],
								[
									115.09150390625018,
									-8.82939453124989
								],
								[
									115.13974609375003,
									-8.768945312499923
								],
								[
									115.1416015625,
									-8.696874999999892
								],
								[
									115.10566406250001,
									-8.629492187499935
								],
								[
									115.05507812500014,
									-8.57304687499989
								],
								[
									114.95205078125002,
									-8.496386718749903
								],
								[
									114.84208984375016,
									-8.428515624999932
								],
								[
									114.73134765624997,
									-8.393945312499909
								],
								[
									114.61318359374997,
									-8.378320312499923
								],
								[
									114.57089843750003,
									-8.345410156249969
								],
								[
									114.50175781249999,
									-8.260839843749977
								],
								[
									114.47890624999997,
									-8.214746093749994
								],
								[
									114.46757812500016,
									-8.166308593749903
								],
								[
									114.47529296875001,
									-8.119433593749946
								],
								[
									114.50429687500002,
									-8.11660156249998
								],
								[
									114.62001953125014,
									-8.127734375000031
								],
								[
									114.8330078125,
									-8.182617187499929
								],
								[
									114.9384765625,
									-8.187109375000048
								],
								[
									114.99814453125003,
									-8.174414062499949
								],
								[
									115.15400390625001,
									-8.065722656249918
								],
								[
									115.1910156250002,
									-8.06748046874992
								],
								[
									115.34023437500014,
									-8.115429687500011
								],
								[
									115.4478515625002,
									-8.155175781249937
								]
							]
						],
						[
							[
								[
									129.8388671875,
									-7.954589843749929
								],
								[
									129.7797851562501,
									-8.046484374999906
								],
								[
									129.7134765625002,
									-8.040722656250068
								],
								[
									129.5918945312502,
									-7.917382812499895
								],
								[
									129.5987304687501,
									-7.8313476562500455
								],
								[
									129.60898437500003,
									-7.80341796875004
								],
								[
									129.65546875000018,
									-7.794824218750065
								],
								[
									129.81298828124994,
									-7.819726562499895
								],
								[
									129.84355468750016,
									-7.889355468749969
								],
								[
									129.8388671875,
									-7.954589843749929
								]
							]
						],
						[
							[
								[
									126.80097656250007,
									-7.667871093749966
								],
								[
									126.81445312499994,
									-7.716503906249926
								],
								[
									126.81269531250001,
									-7.73789062499992
								],
								[
									126.69287109374994,
									-7.753515624999906
								],
								[
									126.57734375000007,
									-7.807617187499915
								],
								[
									126.51816406250009,
									-7.869921874999918
								],
								[
									126.47207031250002,
									-7.950390624999969
								],
								[
									126.31289062500002,
									-7.9176757812499545
								],
								[
									126.17109375000018,
									-7.912304687499926
								],
								[
									126.1083984375,
									-7.88398437499994
								],
								[
									126.04003906250011,
									-7.885839843749963
								],
								[
									125.95156250000002,
									-7.910937499999918
								],
								[
									125.82617187499994,
									-7.979296874999989
								],
								[
									125.79824218750014,
									-7.984570312499997
								],
								[
									125.80839843750016,
									-7.880664062499974
								],
								[
									125.84316406250014,
									-7.816699218749903
								],
								[
									125.97529296875007,
									-7.663378906249932
								],
								[
									126.08535156250002,
									-7.697363281249935
								],
								[
									126.21367187500005,
									-7.706738281249969
								],
								[
									126.35937499999994,
									-7.6767578124999005
								],
								[
									126.46289062500011,
									-7.60781249999998
								],
								[
									126.60957031250007,
									-7.571777343749929
								],
								[
									126.72636718750005,
									-7.662207031250048
								],
								[
									126.80097656250007,
									-7.667871093749966
								]
							]
						],
						[
							[
								[
									127.41943359375011,
									-7.623046874999972
								],
								[
									127.35527343749999,
									-7.646484375000043
								],
								[
									127.37500000000011,
									-7.572460937499969
								],
								[
									127.3707031250002,
									-7.512792968749892
								],
								[
									127.4751953125002,
									-7.531054687499974
								],
								[
									127.47402343750014,
									-7.578515625000051
								],
								[
									127.4639648437502,
									-7.596874999999969
								],
								[
									127.41943359375011,
									-7.623046874999972
								]
							]
						],
						[
							[
								[
									138.5353515625,
									-8.273632812499912
								],
								[
									138.29628906250002,
									-8.405175781250065
								],
								[
									137.98281250000002,
									-8.381933593749949
								],
								[
									137.87187500000016,
									-8.379687499999932
								],
								[
									137.68769531250018,
									-8.411718749999977
								],
								[
									137.65039062499994,
									-8.386132812499923
								],
								[
									137.6851562500002,
									-8.2622070312499
								],
								[
									137.8325195312501,
									-7.9322265624999915
								],
								[
									138.00751953125007,
									-7.641601562499943
								],
								[
									138.0818359375,
									-7.566210937500031
								],
								[
									138.18535156250016,
									-7.495312499999983
								],
								[
									138.2955078125002,
									-7.438476562499943
								],
								[
									138.54384765624997,
									-7.379589843750026
								],
								[
									138.76982421875005,
									-7.390429687499932
								],
								[
									138.80195312500018,
									-7.4146484375000625
								],
								[
									138.89941406249994,
									-7.511621093749923
								],
								[
									138.96259765625,
									-7.587988281249935
								],
								[
									138.9890625,
									-7.696093749999932
								],
								[
									138.89296874999997,
									-7.882128906249918
								],
								[
									138.7859375,
									-8.0590820312499
								],
								[
									138.61171875000014,
									-8.198339843749935
								],
								[
									138.5353515625,
									-8.273632812499912
								]
							]
						],
						[
							[
								[
									131.32558593749997,
									-7.999511718749929
								],
								[
									131.3091796875002,
									-8.01083984375002
								],
								[
									131.18496093750014,
									-7.997851562499946
								],
								[
									131.1137695312501,
									-7.997363281249946
								],
								[
									131.12343750000014,
									-7.921875000000014
								],
								[
									131.08681640625014,
									-7.865039062499889
								],
								[
									131.1368164062501,
									-7.781738281249972
								],
								[
									131.1377929687502,
									-7.6848632812500455
								],
								[
									131.1900390625002,
									-7.671874999999972
								],
								[
									131.1973632812501,
									-7.616699218750014
								],
								[
									131.26005859375016,
									-7.470507812499903
								],
								[
									131.2968750000001,
									-7.438085937499949
								],
								[
									131.3492187500002,
									-7.425390624999949
								],
								[
									131.41103515624997,
									-7.340136718749889
								],
								[
									131.44619140625014,
									-7.315332031249909
								],
								[
									131.48261718750018,
									-7.250683593750054
								],
								[
									131.5352539062501,
									-7.220605468749966
								],
								[
									131.5308593750001,
									-7.165136718750034
								],
								[
									131.5607421875,
									-7.135742187499915
								],
								[
									131.64345703125002,
									-7.112792968750028
								],
								[
									131.70078125000003,
									-7.140234374999935
								],
								[
									131.73613281250016,
									-7.197070312499974
								],
								[
									131.64384765625,
									-7.266894531249889
								],
								[
									131.69111328125,
									-7.438867187500023
								],
								[
									131.62441406250014,
									-7.626171874999898
								],
								[
									131.58027343750018,
									-7.682226562499949
								],
								[
									131.49843750000014,
									-7.730664062499969
								],
								[
									131.47353515625014,
									-7.776660156249918
								],
								[
									131.3770507812501,
									-7.869140624999929
								],
								[
									131.3477539062501,
									-7.948046875000017
								],
								[
									131.34345703125018,
									-7.9814453124999005
								],
								[
									131.32558593749997,
									-7.999511718749929
								]
							]
						],
						[
							[
								[
									131.98203125000003,
									-7.202050781249923
								],
								[
									131.96953125,
									-7.251367187499923
								],
								[
									131.9268554687502,
									-7.22499999999998
								],
								[
									131.88447265625018,
									-7.167480468749886
								],
								[
									131.82285156250003,
									-7.159179687499972
								],
								[
									131.77753906250007,
									-7.14394531249998
								],
								[
									131.75078125000005,
									-7.116796874999963
								],
								[
									131.92226562500014,
									-7.104492187499943
								],
								[
									131.98203125000003,
									-7.202050781249923
								]
							]
						],
						[
							[
								[
									114.41259765624994,
									-7.133496093749983
								],
								[
									114.39765625000001,
									-7.173144531249974
								],
								[
									114.34687500000018,
									-7.163281250000011
								],
								[
									114.29882812499994,
									-7.097558593749952
								],
								[
									114.32216796875002,
									-7.080371093749903
								],
								[
									114.34892578125016,
									-7.073437499999912
								],
								[
									114.38359374999999,
									-7.080664062499963
								],
								[
									114.41259765624994,
									-7.133496093749983
								]
							]
						],
						[
							[
								[
									128.67011718750018,
									-7.183300781249912
								],
								[
									128.62499999999994,
									-7.208593750000006
								],
								[
									128.55019531249997,
									-7.15634765625002
								],
								[
									128.5297851562501,
									-7.134570312499932
								],
								[
									128.57734375000018,
									-7.08320312500004
								],
								[
									128.62773437500016,
									-7.0687499999999375
								],
								[
									128.6583007812501,
									-7.09111328124996
								],
								[
									128.67324218750002,
									-7.113378906249977
								],
								[
									128.66689453125014,
									-7.137988281249918
								],
								[
									128.67011718750018,
									-7.183300781249912
								]
							]
						],
						[
							[
								[
									120.77441406250011,
									-7.118945312499946
								],
								[
									120.67236328125011,
									-7.124707031249969
								],
								[
									120.64082031250007,
									-7.115820312499935
								],
								[
									120.63339843750003,
									-7.0182617187499545
								],
								[
									120.74550781249997,
									-7.060156249999963
								],
								[
									120.78173828125,
									-7.063085937499935
								],
								[
									120.77441406250011,
									-7.118945312499946
								]
							]
						],
						[
							[
								[
									113.84453125000016,
									-7.1053710937499375
								],
								[
									113.82558593750002,
									-7.11992187500006
								],
								[
									113.65585937500009,
									-7.111718749999895
								],
								[
									113.54638671875,
									-7.193359374999929
								],
								[
									113.47070312500011,
									-7.218457031249969
								],
								[
									113.19843750000007,
									-7.218359374999949
								],
								[
									113.16601562500011,
									-7.207324218749932
								],
								[
									113.14189453124999,
									-7.207617187499892
								],
								[
									113.12695312499994,
									-7.224121093749972
								],
								[
									113.04042968750002,
									-7.211816406249952
								],
								[
									112.76376953125003,
									-7.1396484374999005
								],
								[
									112.72587890625016,
									-7.072753906250043
								],
								[
									112.76875000000018,
									-7.0012695312500455
								],
								[
									112.86806640624997,
									-6.89990234375
								],
								[
									113.06738281250011,
									-6.879980468749935
								],
								[
									113.9747070312502,
									-6.873046874999943
								],
								[
									114.07363281250002,
									-6.960156249999926
								],
								[
									114.08300781249994,
									-6.989355468749935
								],
								[
									113.8853515625002,
									-7.049023437499912
								],
								[
									113.84453125000016,
									-7.1053710937499375
								]
							]
						],
						[
							[
								[
									115.37705078125009,
									-6.970800781249963
								],
								[
									115.29580078125014,
									-6.987792968749972
								],
								[
									115.2203125000002,
									-6.952539062500065
								],
								[
									115.22216796874994,
									-6.9051757812500085
								],
								[
									115.24052734375016,
									-6.8612304687499375
								],
								[
									115.35371093750001,
									-6.83847656249992
								],
								[
									115.41445312500014,
									-6.839746093749909
								],
								[
									115.47919921875018,
									-6.8702148437499915
								],
								[
									115.52421875000005,
									-6.901855468750043
								],
								[
									115.54609375000007,
									-6.938671874999912
								],
								[
									115.42412109375016,
									-6.9406249999999545
								],
								[
									115.37705078125009,
									-6.970800781249963
								]
							]
						],
						[
							[
								[
									134.6744140625002,
									-6.749804687499974
								],
								[
									134.657421875,
									-6.76533203124994
								],
								[
									134.6314453125001,
									-6.732910156249915
								],
								[
									134.6291015625,
									-6.71279296874998
								],
								[
									134.66347656250014,
									-6.657714843750043
								],
								[
									134.69765624999997,
									-6.625683593749912
								],
								[
									134.73574218750002,
									-6.623339843749974
								],
								[
									134.72607421875,
									-6.668652343749969
								],
								[
									134.6744140625002,
									-6.749804687499974
								]
							]
						],
						[
							[
								[
									105.25283203125014,
									-6.640429687499903
								],
								[
									105.19042968750011,
									-6.662499999999952
								],
								[
									105.14277343750018,
									-6.6430664062499005
								],
								[
									105.12138671875016,
									-6.61494140624994
								],
								[
									105.19228515625014,
									-6.54560546874994
								],
								[
									105.2256835937502,
									-6.52910156249996
								],
								[
									105.26054687499999,
									-6.523925781249972
								],
								[
									105.27744140625009,
									-6.561425781249966
								],
								[
									105.25283203125014,
									-6.640429687499903
								]
							]
						],
						[
							[
								[
									134.71611328125,
									-6.549414062500006
								],
								[
									134.66083984375,
									-6.558886718749889
								],
								[
									134.63369140624997,
									-6.4772460937499545
								],
								[
									134.67910156250002,
									-6.4560546874999005
								],
								[
									134.72851562499994,
									-6.505859375000014
								],
								[
									134.71611328125,
									-6.549414062500006
								]
							]
						],
						[
							[
								[
									134.81953125,
									-6.434179687499977
								],
								[
									134.7951171875,
									-6.442382812499957
								],
								[
									134.79531249999997,
									-6.393066406249957
								],
								[
									134.82294921875018,
									-6.349609374999886
								],
								[
									134.85185546875005,
									-6.324609375000037
								],
								[
									134.8858398437502,
									-6.323535156249903
								],
								[
									134.81953125,
									-6.434179687499977
								]
							]
						],
						[
							[
								[
									134.53681640625007,
									-6.4422851562499375
								],
								[
									134.52041015625002,
									-6.512695312499986
								],
								[
									134.50429687500002,
									-6.591406250000034
								],
								[
									134.41250000000014,
									-6.6796874999999005
								],
								[
									134.35595703125,
									-6.814843749999909
								],
								[
									134.32275390625,
									-6.848730468749963
								],
								[
									134.2,
									-6.908789062500034
								],
								[
									134.0908203125,
									-6.833789062500031
								],
								[
									134.0591796875002,
									-6.7693359375000455
								],
								[
									134.1070312500001,
									-6.471582031249966
								],
								[
									134.15419921875002,
									-6.481445312500014
								],
								[
									134.184765625,
									-6.479296874999932
								],
								[
									134.19462890625016,
									-6.459765624999946
								],
								[
									134.1246093750002,
									-6.426464843749912
								],
								[
									134.11123046875014,
									-6.255371093749972
								],
								[
									134.11464843750014,
									-6.190820312499966
								],
								[
									134.1680664062501,
									-6.176269531250014
								],
								[
									134.23417968750016,
									-6.226367187499918
								],
								[
									134.31777343750014,
									-6.316113281249912
								],
								[
									134.41503906249994,
									-6.3867187499999005
								],
								[
									134.53681640625007,
									-6.4422851562499375
								]
							]
						],
						[
							[
								[
									107.37392578125014,
									-6.007617187499946
								],
								[
									107.47470703125009,
									-6.121777343749926
								],
								[
									107.56298828125011,
									-6.182714843749906
								],
								[
									107.66679687500005,
									-6.2158203124999005
								],
								[
									107.77607421875018,
									-6.218945312499912
								],
								[
									107.88378906250011,
									-6.233300781249909
								],
								[
									108.0087890625,
									-6.27695312499992
								],
								[
									108.13759765625014,
									-6.296679687500031
								],
								[
									108.19746093750007,
									-6.2890624999999005
								],
								[
									108.2544921875002,
									-6.266601562499943
								],
								[
									108.2950195312502,
									-6.26503906249998
								],
								[
									108.3301757812502,
									-6.286035156249994
								],
								[
									108.41914062500018,
									-6.3828124999999005
								],
								[
									108.51591796874999,
									-6.471191406250057
								],
								[
									108.53798828124997,
									-6.5162109374999915
								],
								[
									108.6036132812502,
									-6.72919921875004
								],
								[
									108.67783203125003,
									-6.790527343749929
								],
								[
									108.77968750000002,
									-6.808300781249898
								],
								[
									108.8994140625,
									-6.808398437499918
								],
								[
									109.01835937500016,
									-6.817285156249952
								],
								[
									109.29423828125005,
									-6.8669921875000455
								],
								[
									109.40371093750014,
									-6.860156249999903
								],
								[
									109.50058593750003,
									-6.81015624999992
								],
								[
									109.58691406249994,
									-6.8425781250000455
								],
								[
									109.82099609375007,
									-6.902441406249892
								],
								[
									109.93623046875018,
									-6.9158203125000455
								],
								[
									110.06708984375018,
									-6.898730468749946
								],
								[
									110.19843750000001,
									-6.89511718749992
								],
								[
									110.26093750000007,
									-6.91240234375006
								],
								[
									110.32109375000016,
									-6.938378906250023
								],
								[
									110.37275390625001,
									-6.947753906249886
								],
								[
									110.42626953125,
									-6.947265625000057
								],
								[
									110.52089843750002,
									-6.897265624999903
								],
								[
									110.58359375000009,
									-6.805664062499986
								],
								[
									110.63427734375011,
									-6.690136718749983
								],
								[
									110.67402343750001,
									-6.5698242187499005
								],
								[
									110.70078125000003,
									-6.518066406250014
								],
								[
									110.73691406250003,
									-6.47236328124994
								],
								[
									110.7841796875,
									-6.442675781249932
								],
								[
									110.83476562499999,
									-6.424218749999909
								],
								[
									110.9722656250002,
									-6.43564453124992
								],
								[
									111.00068359375007,
									-6.464746093749895
								],
								[
									111.1543945312502,
									-6.669042968749949
								],
								[
									111.18154296875014,
									-6.686718749999912
								],
								[
									111.34208984375016,
									-6.699511718750031
								],
								[
									111.38652343750016,
									-6.692871093749929
								],
								[
									111.4844726562502,
									-6.651855468749915
								],
								[
									111.54033203125005,
									-6.648242187499974
								],
								[
									111.64355468750011,
									-6.698730468749957
								],
								[
									111.6880859375002,
									-6.741699218749929
								],
								[
									111.73759765625016,
									-6.7734374999999005
								],
								[
									111.9898437500002,
									-6.8059570312500455
								],
								[
									112.08730468750002,
									-6.893359374999918
								],
								[
									112.13671875000011,
									-6.905078124999989
								],
								[
									112.31230468749999,
									-6.894433593749952
								],
								[
									112.43359375000011,
									-6.903027343749926
								],
								[
									112.53925781250007,
									-6.926464843749912
								],
								[
									112.5869140625,
									-7.050585937499974
								],
								[
									112.62597656249994,
									-7.178027343749903
								],
								[
									112.64873046875016,
									-7.221289062499935
								],
								[
									112.75195312499994,
									-7.265039062499966
								],
								[
									112.79433593749997,
									-7.304492187500003
								],
								[
									112.78291015625007,
									-7.431640624999972
								],
								[
									112.7945312500002,
									-7.552441406250068
								],
								[
									113.01357421875014,
									-7.657714843749929
								],
								[
									113.24843750000014,
									-7.718164062499909
								],
								[
									113.49765625000009,
									-7.723828124999898
								],
								[
									113.74746093750002,
									-7.703027343749923
								],
								[
									113.87626953125005,
									-7.677246093749915
								],
								[
									114.03730468750018,
									-7.63212890624996
								],
								[
									114.07070312500014,
									-7.633007812499969
								],
								[
									114.38271484375002,
									-7.771093749999935
								],
								[
									114.4092773437502,
									-7.792480468749943
								],
								[
									114.44423828125002,
									-7.8956054687499915
								],
								[
									114.44326171875002,
									-8.004589843749898
								],
								[
									114.38496093750001,
									-8.263281249999935
								],
								[
									114.38134765625,
									-8.334277343749918
								],
								[
									114.38691406250007,
									-8.405175781250065
								],
								[
									114.44882812500009,
									-8.559277343749926
								],
								[
									114.48173828125005,
									-8.603808593750031
								],
								[
									114.59501953124999,
									-8.684765624999912
								],
								[
									114.59921875000003,
									-8.727246093749955
								],
								[
									114.58378906250005,
									-8.769628906250063
								],
								[
									114.45917968750007,
									-8.740527343749903
								],
								[
									114.38320312500002,
									-8.705371093749946
								],
								[
									114.33925781250014,
									-8.647363281250023
								],
								[
									114.27695312500003,
									-8.614648437499937
								],
								[
									114.15966796874994,
									-8.626464843750028
								],
								[
									113.94033203125014,
									-8.568359374999915
								],
								[
									113.69257812500018,
									-8.478027343749986
								],
								[
									113.25332031250014,
									-8.28671874999992
								],
								[
									113.13369140625002,
									-8.288281250000054
								],
								[
									113.01894531249997,
									-8.312695312500054
								],
								[
									112.89775390624999,
									-8.361425781250034
								],
								[
									112.77167968750018,
									-8.396093749999991
								],
								[
									112.67880859375009,
									-8.4091796874999
								],
								[
									112.58603515625009,
									-8.399609374999997
								],
								[
									112.35156250000011,
									-8.353613281249949
								],
								[
									112.11513671874997,
									-8.32392578124994
								],
								[
									111.50996093750007,
									-8.305078124999923
								],
								[
									111.33857421875007,
									-8.261718749999972
								],
								[
									111.05537109375018,
									-8.239550781249903
								],
								[
									110.8301757812502,
									-8.20195312499996
								],
								[
									110.60722656249999,
									-8.149414062499915
								],
								[
									110.03867187500009,
									-7.890527343750023
								],
								[
									109.8526367187502,
									-7.828417968749889
								],
								[
									109.28164062500014,
									-7.704882812499946
								],
								[
									109.19355468750001,
									-7.694921874999963
								],
								[
									108.98671875000002,
									-7.704101562500057
								],
								[
									108.85625000000016,
									-7.667871093749966
								],
								[
									108.7412109375,
									-7.667089843749977
								],
								[
									108.57050781250001,
									-7.707226562499983
								],
								[
									108.51796874999997,
									-7.736035156249898
								],
								[
									108.45175781250009,
									-7.796972656249977
								],
								[
									108.3355468750002,
									-7.794042968749906
								],
								[
									108.22050781250005,
									-7.782324218750006
								],
								[
									107.91748046875011,
									-7.724121093749957
								],
								[
									107.80439453125018,
									-7.688378906250051
								],
								[
									107.69580078125,
									-7.635546874999946
								],
								[
									107.59785156250001,
									-7.56669921874996
								],
								[
									107.54687500000011,
									-7.541894531250051
								],
								[
									107.28496093750016,
									-7.471679687499957
								],
								[
									107.07119140625002,
									-7.447460937499997
								],
								[
									106.63144531250003,
									-7.415527343749972
								],
								[
									106.53535156250018,
									-7.394238281249898
								],
								[
									106.45527343750001,
									-7.368652343749929
								],
								[
									106.41132812500007,
									-7.311718750000054
								],
								[
									106.41689453125014,
									-7.239355468749963
								],
								[
									106.44843750000018,
									-7.176757812499915
								],
								[
									106.49150390625016,
									-7.113867187499977
								],
								[
									106.51972656250001,
									-7.0537109374999005
								],
								[
									106.1982421875,
									-6.927832031250006
								],
								[
									105.94433593749994,
									-6.85898437499992
								],
								[
									105.83476562499999,
									-6.8458007812499915
								],
								[
									105.72480468750018,
									-6.846093750000051
								],
								[
									105.60097656249997,
									-6.860351562499943
								],
								[
									105.47841796874997,
									-6.853710937499912
								],
								[
									105.42080078125014,
									-6.833203124999912
								],
								[
									105.36191406250003,
									-6.8261718749999005
								],
								[
									105.30292968750001,
									-6.841015624999912
								],
								[
									105.2554687500002,
									-6.835253906249974
								],
								[
									105.24316406250011,
									-6.77802734375004
								],
								[
									105.27343749999994,
									-6.729394531249909
								],
								[
									105.33564453125001,
									-6.674121093749918
								],
								[
									105.37089843749999,
									-6.664355468749974
								],
								[
									105.38701171874999,
									-6.750781249999903
								],
								[
									105.40468750000014,
									-6.767968749999952
								],
								[
									105.45976562499999,
									-6.786914062499903
								],
								[
									105.48369140625016,
									-6.7815429687500455
								],
								[
									105.58085937500016,
									-6.670996093749906
								],
								[
									105.6080078125002,
									-6.616699218749943
								],
								[
									105.65507812499999,
									-6.469531249999903
								],
								[
									105.7060546875,
									-6.497949218749909
								],
								[
									105.75742187500009,
									-6.48037109374998
								],
								[
									105.78691406250005,
									-6.456933593749994
								],
								[
									105.86826171875009,
									-6.116406249999983
								],
								[
									105.93613281250003,
									-6.01699218749998
								],
								[
									106.02880859375011,
									-5.934277343749926
								],
								[
									106.07499999999999,
									-5.914160156249906
								],
								[
									106.16582031250016,
									-5.964746093749909
								],
								[
									106.3497070312502,
									-5.98408203124994
								],
								[
									106.4590820312502,
									-6.017578125000014
								],
								[
									106.56874999999997,
									-6.021874999999909
								],
								[
									106.67587890625003,
									-6.038378906249989
								],
								[
									106.8251953125,
									-6.098242187499935
								],
								[
									106.8779296875,
									-6.091992187499983
								],
								[
									106.93164062500011,
									-6.073437500000026
								],
								[
									107.01162109375014,
									-6.00849609374994
								],
								[
									107.04628906250002,
									-5.9041992187500085
								],
								[
									107.162109375,
									-5.957128906249963
								],
								[
									107.33183593749999,
									-5.978124999999977
								],
								[
									107.37392578125014,
									-6.007617187499946
								]
							]
						],
						[
							[
								[
									124.05126953124994,
									-5.973730468749963
								],
								[
									124.0420898437502,
									-6.021582031249949
								],
								[
									124.00566406250016,
									-5.966699218749952
								],
								[
									123.9722656250002,
									-5.939355468750065
								],
								[
									123.97578125000001,
									-5.880175781249918
								],
								[
									124.02294921874994,
									-5.902148437499946
								],
								[
									124.05126953124994,
									-5.973730468749963
								]
							]
						],
						[
							[
								[
									120.52832031249994,
									-6.298437500000034
								],
								[
									120.48730468749994,
									-6.464843749999915
								],
								[
									120.46796875000001,
									-6.406152343749952
								],
								[
									120.46074218750016,
									-6.254003906249949
								],
								[
									120.435546875,
									-6.180175781249929
								],
								[
									120.45156250000014,
									-6.094921874999969
								],
								[
									120.44648437500018,
									-5.876269531250003
								],
								[
									120.47734375000016,
									-5.775292968750037
								],
								[
									120.53417968750011,
									-5.903808593749929
								],
								[
									120.54921875000014,
									-5.969238281249943
								],
								[
									120.52832031249994,
									-6.298437500000034
								]
							]
						],
						[
							[
								[
									112.71943359375018,
									-5.811035156249943
								],
								[
									112.69794921875007,
									-5.846484374999974
								],
								[
									112.60214843750009,
									-5.8436523437499375
								],
								[
									112.58603515625009,
									-5.803613281249952
								],
								[
									112.6485351562502,
									-5.730859374999952
								],
								[
									112.69003906250003,
									-5.726171874999977
								],
								[
									112.72734374999999,
									-5.75273437500006
								],
								[
									112.71943359375018,
									-5.811035156249943
								]
							]
						],
						[
							[
								[
									132.8071289062501,
									-5.850781249999969
								],
								[
									132.74628906250007,
									-5.947070312499946
								],
								[
									132.70488281250016,
									-5.913085937500043
								],
								[
									132.6814453125,
									-5.912597656249943
								],
								[
									132.66728515625005,
									-5.856054687499977
								],
								[
									132.68134765625007,
									-5.738867187499906
								],
								[
									132.63017578125005,
									-5.607031249999949
								],
								[
									132.69785156250003,
									-5.608984374999906
								],
								[
									132.71650390625,
									-5.6483398437499375
								],
								[
									132.7377929687501,
									-5.6617187499999915
								],
								[
									132.8042968750001,
									-5.78886718749996
								],
								[
									132.8071289062501,
									-5.850781249999969
								]
							]
						],
						[
							[
								[
									134.74697265624997,
									-5.707031249999986
								],
								[
									134.73906250000016,
									-5.745605468750028
								],
								[
									134.7383789062502,
									-5.816796874999966
								],
								[
									134.7549804687502,
									-5.88271484374998
								],
								[
									134.71220703125,
									-5.949707031250043
								],
								[
									134.75214843750007,
									-6.050097656249974
								],
								[
									134.75810546875005,
									-6.0999999999999375
								],
								[
									134.7558593750001,
									-6.170605468749926
								],
								[
									134.74443359375,
									-6.202343749999997
								],
								[
									134.71416015625016,
									-6.295117187500068
								],
								[
									134.68388671875,
									-6.328125000000043
								],
								[
									134.6611328125,
									-6.337304687499966
								],
								[
									134.63759765624997,
									-6.365332031249892
								],
								[
									134.44111328125,
									-6.334863281249994
								],
								[
									134.35615234375,
									-6.270507812500028
								],
								[
									134.28046875000007,
									-6.200781250000034
								],
								[
									134.264453125,
									-6.171679687499974
								],
								[
									134.17539062500003,
									-6.090332031249915
								],
								[
									134.15488281250003,
									-6.0628906250000085
								],
								[
									134.15312500000016,
									-6.019531250000057
								],
								[
									134.22509765625,
									-6.00849609374994
								],
								[
									134.30195312500018,
									-6.009765624999929
								],
								[
									134.29863281250005,
									-5.970703125000057
								],
								[
									134.34306640625005,
									-5.8330078124999005
								],
								[
									134.2261718750002,
									-5.744433593749974
								],
								[
									134.20537109375005,
									-5.707226562500026
								],
								[
									134.24726562500007,
									-5.681933593749932
								],
								[
									134.3413085937501,
									-5.712890624999943
								],
								[
									134.45634765625,
									-5.557519531249909
								],
								[
									134.4903320312502,
									-5.5250976562499545
								],
								[
									134.5064453125002,
									-5.438476562499986
								],
								[
									134.57080078124994,
									-5.427343749999935
								],
								[
									134.61650390625016,
									-5.438574218750006
								],
								[
									134.6460937500002,
									-5.4923828124999545
								],
								[
									134.6578125000002,
									-5.539257812499912
								],
								[
									134.6455078125001,
									-5.58134765624996
								],
								[
									134.7007812500001,
									-5.603027343749943
								],
								[
									134.74697265624997,
									-5.707031249999986
								]
							]
						],
						[
							[
								[
									132.92626953124994,
									-5.902050781249926
								],
								[
									132.84501953125,
									-5.987988281250026
								],
								[
									132.9216796875,
									-5.785253906249935
								],
								[
									132.93769531250007,
									-5.682617187499986
								],
								[
									133.0087890625,
									-5.621386718749946
								],
								[
									133.11464843750014,
									-5.310644531249963
								],
								[
									133.13847656250005,
									-5.317871093749929
								],
								[
									133.1728515625001,
									-5.348144531250057
								],
								[
									133.1196289062501,
									-5.575976562499932
								],
								[
									132.97109375000014,
									-5.7358398437499005
								],
								[
									132.92626953124994,
									-5.902050781249926
								]
							]
						],
						[
							[
								[
									102.36718750000011,
									-5.478710937500011
								],
								[
									102.28593749999999,
									-5.48349609374992
								],
								[
									102.13554687499999,
									-5.360546874999926
								],
								[
									102.11074218750002,
									-5.322558593749903
								],
								[
									102.15351562500001,
									-5.286230468749963
								],
								[
									102.19843750000001,
									-5.28886718750006
								],
								[
									102.37177734375018,
									-5.3664062499999545
								],
								[
									102.40546875000018,
									-5.404785156249957
								],
								[
									102.36718750000011,
									-5.478710937500011
								]
							]
						],
						[
							[
								[
									123.62675781250016,
									-5.27158203124992
								],
								[
									123.62275390625007,
									-5.373046874999886
								],
								[
									123.58261718750003,
									-5.367382812500068
								],
								[
									123.55009765625016,
									-5.331835937499932
								],
								[
									123.54091796874997,
									-5.298339843749943
								],
								[
									123.54277343749999,
									-5.2710937499999915
								],
								[
									123.5606445312502,
									-5.249804687499918
								],
								[
									123.62675781250016,
									-5.27158203124992
								]
							]
						],
						[
							[
								[
									122.04296875,
									-5.437988281249972
								],
								[
									121.97958984375003,
									-5.4647460937500085
								],
								[
									121.859375,
									-5.350292968749969
								],
								[
									121.80849609375002,
									-5.256152343749974
								],
								[
									121.82070312500002,
									-5.20292968749996
								],
								[
									121.85664062500001,
									-5.156250000000043
								],
								[
									121.87373046875007,
									-5.144628906249892
								],
								[
									121.86630859375003,
									-5.095996093749932
								],
								[
									121.9136718750002,
									-5.072265624999986
								],
								[
									121.96572265624997,
									-5.075585937499952
								],
								[
									121.99990234375002,
									-5.140820312499926
								],
								[
									122.04101562500011,
									-5.158789062499935
								],
								[
									122.06181640624999,
									-5.221289062499977
								],
								[
									122.04296875,
									-5.437988281249972
								]
							]
						],
						[
							[
								[
									122.6451171875002,
									-5.2694335937500085
								],
								[
									122.61933593750018,
									-5.335839843750037
								],
								[
									122.56386718749997,
									-5.387499999999903
								],
								[
									122.51972656250001,
									-5.391210937499949
								],
								[
									122.47363281249994,
									-5.380664062499932
								],
								[
									122.39199218750014,
									-5.335449218749957
								],
								[
									122.37128906250018,
									-5.383105468749903
								],
								[
									122.30703125000014,
									-5.3809570312499915
								],
								[
									122.28310546874997,
									-5.319531249999912
								],
								[
									122.32900390624997,
									-5.1376953124999005
								],
								[
									122.39628906250005,
									-5.069824218749929
								],
								[
									122.39003906249997,
									-4.998535156249972
								],
								[
									122.33447265624994,
									-4.846582031249923
								],
								[
									122.36894531250016,
									-4.767187500000006
								],
								[
									122.52441406250011,
									-4.707128906249935
								],
								[
									122.65996093749999,
									-4.633886718749935
								],
								[
									122.70195312500005,
									-4.618652343749943
								],
								[
									122.73974609375011,
									-4.675000000000054
								],
								[
									122.7598632812502,
									-4.933886718749946
								],
								[
									122.61406250000016,
									-5.138671875000014
								],
								[
									122.6451171875002,
									-5.2694335937500085
								]
							]
						],
						[
							[
								[
									123.17978515625003,
									-4.551171875000051
								],
								[
									123.20302734374997,
									-4.766210937499892
								],
								[
									123.19570312499997,
									-4.8226562499999375
								],
								[
									123.13945312499999,
									-4.739941406249969
								],
								[
									123.11923828125003,
									-4.723437499999974
								],
								[
									123.10380859374999,
									-4.739941406249969
								],
								[
									123.08388671875014,
									-4.749023437499943
								],
								[
									123.05517578124994,
									-4.748242187500054
								],
								[
									123.01796875000014,
									-4.831738281250011
								],
								[
									123.01464843749994,
									-4.91025390625002
								],
								[
									122.98652343750018,
									-4.9630859374999545
								],
								[
									122.97167968750011,
									-5.138476562499974
								],
								[
									122.98105468750003,
									-5.185742187500011
								],
								[
									123.02460937500007,
									-5.16240234374996
								],
								[
									123.05146484375018,
									-5.156445312499912
								],
								[
									123.14990234375,
									-5.224023437499994
								],
								[
									123.20195312500005,
									-5.273339843749923
								],
								[
									123.18730468750016,
									-5.3330078124999005
								],
								[
									123.12070312500009,
									-5.3931640624999915
								],
								[
									123.04335937500014,
									-5.419335937499994
								],
								[
									122.98574218750014,
									-5.3935546874999005
								],
								[
									122.96875000000011,
									-5.4057617187499005
								],
								[
									122.9346679687502,
									-5.436718749999983
								],
								[
									122.90878906250009,
									-5.4774414062499375
								],
								[
									122.91621093750018,
									-5.519335937499946
								],
								[
									122.85019531250003,
									-5.63798828124996
								],
								[
									122.8121093750002,
									-5.671289062499895
								],
								[
									122.73310546875018,
									-5.6349609374999545
								],
								[
									122.68437499999999,
									-5.666210937499926
								],
								[
									122.64501953125,
									-5.663378906249974
								],
								[
									122.58496093750011,
									-5.54462890624994
								],
								[
									122.58642578124994,
									-5.488867187499949
								],
								[
									122.6421875000002,
									-5.426269531249986
								],
								[
									122.64257812500011,
									-5.381152343750031
								],
								[
									122.67011718750001,
									-5.330859374999918
								],
								[
									122.73144531250011,
									-5.261914062499983
								],
								[
									122.76650390625014,
									-5.210156250000011
								],
								[
									122.767578125,
									-5.177246093750057
								],
								[
									122.79365234375007,
									-5.05244140624994
								],
								[
									122.8038085937502,
									-5.000097656249935
								],
								[
									122.82148437500007,
									-4.944433593749963
								],
								[
									122.84941406250016,
									-4.831249999999912
								],
								[
									122.85332031250016,
									-4.618359374999969
								],
								[
									122.9468750000002,
									-4.442675781249974
								],
								[
									123.03828125000018,
									-4.394726562499983
								],
								[
									123.07460937500002,
									-4.386914062499983
								],
								[
									123.0689453125002,
									-4.4335937499999005
								],
								[
									123.17978515625003,
									-4.551171875000051
								]
							]
						],
						[
							[
								[
									133.57080078125,
									-4.245898437500031
								],
								[
									133.621875,
									-4.2993164062499005
								],
								[
									133.5029296875001,
									-4.257421874999977
								],
								[
									133.33300781249994,
									-4.1696289062499545
								],
								[
									133.32089843750003,
									-4.111035156249912
								],
								[
									133.46435546875,
									-4.199804687499963
								],
								[
									133.57080078125,
									-4.245898437500031
								]
							]
						],
						[
							[
								[
									123.24238281250018,
									-4.1129882812499545
								],
								[
									123.14453124999994,
									-4.233300781249952
								],
								[
									123.076171875,
									-4.227148437499949
								],
								[
									122.99472656250009,
									-4.1480468749999915
								],
								[
									122.97089843750001,
									-4.061328124999918
								],
								[
									122.96904296874999,
									-4.029980468749926
								],
								[
									123.02490234375011,
									-3.980957031250057
								],
								[
									123.21191406250011,
									-3.9975585937499716
								],
								[
									123.24697265625014,
									-4.040917968749923
								],
								[
									123.24238281250018,
									-4.1129882812499545
								]
							]
						],
						[
							[
								[
									128.5625976562502,
									-3.5854492187499574
								],
								[
									128.3916015625001,
									-3.637890624999983
								],
								[
									128.4283203125002,
									-3.5404296874999233
								],
								[
									128.45156250000014,
									-3.5147460937499346
								],
								[
									128.53632812500018,
									-3.541308593750017
								],
								[
									128.5625976562502,
									-3.5854492187499574
								]
							]
						],
						[
							[
								[
									128.27558593750018,
									-3.6746093749999034
								],
								[
									128.24990234375002,
									-3.711132812499983
								],
								[
									128.19179687499997,
									-3.7352539062499233
								],
								[
									128.1431640625002,
									-3.732714843749932
								],
								[
									128.15898437500016,
									-3.69765624999998
								],
								[
									128.14687499999997,
									-3.67714843749998
								],
								[
									128.1108398437501,
									-3.6864257812499233
								],
								[
									128.05224609374994,
									-3.7145507812499687
								],
								[
									127.97802734374994,
									-3.7709960937499147
								],
								[
									127.93437500000005,
									-3.743066406249909
								],
								[
									127.92500000000018,
									-3.699316406249963
								],
								[
									127.92753906250016,
									-3.679394531249912
								],
								[
									128.0162109375002,
									-3.6008789062499034
								],
								[
									128.1191406250001,
									-3.5874999999999204
								],
								[
									128.26435546875,
									-3.5123046874999773
								],
								[
									128.3291015625,
									-3.5159179687499034
								],
								[
									128.313671875,
									-3.5636718749999545
								],
								[
									128.2910156250001,
									-3.5976562499999574
								],
								[
									128.2774414062502,
									-3.633203124999909
								],
								[
									128.27558593750018,
									-3.6746093749999034
								]
							]
						],
						[
							[
								[
									128.7224609375,
									-3.5468749999999147
								],
								[
									128.72011718750014,
									-3.5891601562499034
								],
								[
									128.71328124999997,
									-3.602539062500057
								],
								[
									128.6587890625001,
									-3.58779296874998
								],
								[
									128.61953124999997,
									-3.588574218750054
								],
								[
									128.58515625000018,
									-3.5122070312499574
								],
								[
									128.594921875,
									-3.4948242187499687
								],
								[
									128.66650390624994,
									-3.5166992187499773
								],
								[
									128.69355468750007,
									-3.5245117187499773
								],
								[
									128.7224609375,
									-3.5468749999999147
								]
							]
						],
						[
							[
								[
									116.42412109375016,
									-3.4644531249999915
								],
								[
									116.3877929687502,
									-3.6367187499999147
								],
								[
									116.32656249999997,
									-3.5390624999999147
								],
								[
									116.39531250000005,
									-3.4233398437499716
								],
								[
									116.42695312500018,
									-3.399902343749986
								],
								[
									116.42412109375016,
									-3.4644531249999915
								]
							]
						],
						[
							[
								[
									127.60625000000016,
									-3.3151367187499545
								],
								[
									127.62929687500014,
									-3.359179687499946
								],
								[
									127.53105468749999,
									-3.33134765624996
								],
								[
									127.48769531249997,
									-3.288183593749963
								],
								[
									127.53046875000018,
									-3.261523437499946
								],
								[
									127.55449218749999,
									-3.254296874999895
								],
								[
									127.60625000000016,
									-3.3151367187499545
								]
							]
						],
						[
							[
								[
									116.30332031250003,
									-3.8681640624999005
								],
								[
									116.09335937500009,
									-4.054101562500037
								],
								[
									116.05878906250007,
									-4.00693359375002
								],
								[
									116.07695312500005,
									-3.8174804687499773
								],
								[
									116.01835937500016,
									-3.699902343749997
								],
								[
									116.02246093750011,
									-3.6124023437499346
								],
								[
									116.06357421875003,
									-3.457910156249909
								],
								[
									116.11738281250018,
									-3.3395507812499545
								],
								[
									116.23935546875009,
									-3.2603515624999773
								],
								[
									116.26972656250001,
									-3.251074218749949
								],
								[
									116.26210937499997,
									-3.394824218750017
								],
								[
									116.28652343749997,
									-3.4488281250000057
								],
								[
									116.29511718750007,
									-3.495019531249909
								],
								[
									116.28203125000016,
									-3.5347656249999346
								],
								[
									116.30517578125,
									-3.7185546874999744
								],
								[
									116.31865234375016,
									-3.7629882812500597
								],
								[
									116.28925781250001,
									-3.820898437499963
								],
								[
									116.30332031250003,
									-3.8681640624999005
								]
							]
						],
						[
							[
								[
									126.86113281250016,
									-3.087890625000014
								],
								[
									127.02548828125003,
									-3.166015624999943
								],
								[
									127.06289062500014,
									-3.2169921875000256
								],
								[
									127.09238281250009,
									-3.277539062499926
								],
								[
									127.12470703125018,
									-3.31083984374996
								],
								[
									127.16347656250002,
									-3.338085937499912
								],
								[
									127.22734375000016,
									-3.3910156249999517
								],
								[
									127.2442382812502,
									-3.4710937499999233
								],
								[
									127.22958984375003,
									-3.6330078124999545
								],
								[
									127.15517578125002,
									-3.647265624999932
								],
								[
									127.0850585937502,
									-3.6708984374999574
								],
								[
									126.94091796874994,
									-3.7645507812500227
								],
								[
									126.86992187500016,
									-3.7829101562499403
								],
								[
									126.79414062500018,
									-3.7891601562500625
								],
								[
									126.74033203125003,
									-3.813671874999912
								],
								[
									126.68632812500016,
									-3.82363281249998
								],
								[
									126.54667968750005,
									-3.771679687500054
								],
								[
									126.41113281250011,
									-3.710644531250054
								],
								[
									126.21455078125001,
									-3.6051757812499687
								],
								[
									126.1783203125002,
									-3.57939453124996
								],
								[
									126.14667968750018,
									-3.5227539062499744
								],
								[
									126.05654296875002,
									-3.42099609375002
								],
								[
									126.03398437500005,
									-3.35585937499998
								],
								[
									126.0264648437502,
									-3.1705078124999773
								],
								[
									126.05009765625005,
									-3.12812500000004
								],
								[
									126.08828124999997,
									-3.1054687500000426
								],
								[
									126.21962890625002,
									-3.1481445312499403
								],
								[
									126.30625000000009,
									-3.1032226562499403
								],
								[
									126.55507812500014,
									-3.065234375000017
								],
								[
									126.80830078125001,
									-3.069140624999932
								],
								[
									126.86113281250016,
									-3.087890625000014
								]
							]
						],
						[
							[
								[
									127.9878906250002,
									-2.9365234374999147
								],
								[
									127.93769531250018,
									-3.0200195312500426
								],
								[
									127.849609375,
									-3.016308593749997
								],
								[
									127.83427734375016,
									-3.004394531250057
								],
								[
									127.93837890625014,
									-2.9523437499999403
								],
								[
									127.9878906250002,
									-2.9365234374999147
								]
							]
						],
						[
							[
								[
									106.88642578125001,
									-3.005273437499966
								],
								[
									106.8697265625002,
									-3.025292968750051
								],
								[
									106.81425781250016,
									-3.0144531249999744
								],
								[
									106.77431640625014,
									-2.9868164062500284
								],
								[
									106.74921875000007,
									-2.960449218749986
								],
								[
									106.74287109375018,
									-2.93281250000004
								],
								[
									106.79687500000011,
									-2.8989257812499716
								],
								[
									106.91064453125,
									-2.9339843749999233
								],
								[
									106.88642578125001,
									-3.005273437499966
								]
							]
						],
						[
							[
								[
									107.47333984375007,
									-2.8995117187500057
								],
								[
									107.43281250000007,
									-2.925292968749929
								],
								[
									107.40927734375003,
									-2.9005859374999545
								],
								[
									107.4024414062502,
									-2.8729492187499233
								],
								[
									107.41933593749997,
									-2.838085937499926
								],
								[
									107.47441406249999,
									-2.8346679687499403
								],
								[
									107.49970703125018,
									-2.8450195312499176
								],
								[
									107.47333984375007,
									-2.8995117187500057
								]
							]
						],
						[
							[
								[
									129.75468750000016,
									-2.8658203124999773
								],
								[
									129.98437499999994,
									-2.9766601562499204
								],
								[
									130.10341796875014,
									-2.992968749999946
								],
								[
									130.30361328124997,
									-2.978515624999943
								],
								[
									130.37910156250018,
									-2.9893554687499204
								],
								[
									130.56992187500003,
									-3.1308593749999716
								],
								[
									130.6255859375002,
									-3.2280273437499716
								],
								[
									130.6416992187502,
									-3.311914062499909
								],
								[
									130.67109375000007,
									-3.391503906250051
								],
								[
									130.71806640625005,
									-3.411328124999912
								],
								[
									130.77343749999994,
									-3.4187499999999176
								],
								[
									130.84560546875002,
									-3.533300781249892
								],
								[
									130.8599609375001,
									-3.5703124999999716
								],
								[
									130.80507812500002,
									-3.8577148437499034
								],
								[
									130.58037109375016,
									-3.748828125000017
								],
								[
									130.3630859375,
									-3.625195312500054
								],
								[
									130.26972656250018,
									-3.5792968749999403
								],
								[
									130.0195312500001,
									-3.474707031249949
								],
								[
									129.98115234375018,
									-3.4388671874999375
								],
								[
									129.953125,
									-3.3916015624999005
								],
								[
									129.84414062499997,
									-3.3271484374999147
								],
								[
									129.62666015625018,
									-3.3171874999999176
								],
								[
									129.5450195312501,
									-3.3188476562499005
								],
								[
									129.5117187500001,
									-3.3285156250000085
								],
								[
									129.52041015625014,
									-3.363183593749966
								],
								[
									129.5216796875,
									-3.433691406249949
								],
								[
									129.46767578125014,
									-3.4532226562499204
								],
								[
									129.3328125,
									-3.40869140625
								],
								[
									129.21210937500018,
									-3.3926757812499346
								],
								[
									129.1076171875,
									-3.349218749999963
								],
								[
									128.96748046875018,
									-3.3260742187499517
								],
								[
									128.95205078125014,
									-3.3041992187500284
								],
								[
									128.9640625,
									-3.271679687499983
								],
								[
									128.95781250000016,
									-3.241113281249966
								],
								[
									128.92539062500003,
									-3.2292968750000455
								],
								[
									128.8625,
									-3.234960937499963
								],
								[
									128.8017578125,
									-3.265624999999986
								],
								[
									128.75126953125,
									-3.300488281249983
								],
								[
									128.67695312500007,
									-3.39658203125002
								],
								[
									128.63896484375005,
									-3.4333984375000597
								],
								[
									128.5166015625,
									-3.4491210937500654
								],
								[
									128.46591796875003,
									-3.4398437499999517
								],
								[
									128.41923828125005,
									-3.4160156249999005
								],
								[
									128.27998046875018,
									-3.240527343749932
								],
								[
									128.2330078125002,
									-3.202636718749943
								],
								[
									128.1806640625001,
									-3.1716796875000313
								],
								[
									128.13203125000007,
									-3.1574218749999687
								],
								[
									128.0821289062502,
									-3.1840820312499005
								],
								[
									128.0557617187501,
									-3.238574218749889
								],
								[
									128.04394531249994,
									-3.3033203124999346
								],
								[
									128.03007812500016,
									-3.3405273437499687
								],
								[
									127.97001953124999,
									-3.4443359374998863
								],
								[
									127.92041015625011,
									-3.5060546874999403
								],
								[
									127.90234375,
									-3.496289062499912
								],
								[
									127.9278320312502,
									-3.397265624999889
								],
								[
									127.92792968750007,
									-3.3414062499999773
								],
								[
									127.89716796875018,
									-3.2823242187499204
								],
								[
									127.8779296875,
									-3.2220703124999943
								],
								[
									128.1133789062501,
									-2.9345703125000426
								],
								[
									128.19853515625005,
									-2.865917968749912
								],
								[
									128.56982421875,
									-2.842187500000051
								],
								[
									128.7905273437501,
									-2.856640624999983
								],
								[
									128.9107421875001,
									-2.8496093749999716
								],
								[
									128.99111328125002,
									-2.8285156249999375
								],
								[
									129.0577148437501,
									-2.8384765625000057
								],
								[
									129.0743164062502,
									-2.895117187499906
								],
								[
									129.1163085937502,
									-2.9370117187499147
								],
								[
									129.17441406250003,
									-2.933496093749909
								],
								[
									129.27958984375,
									-2.8890625000000085
								],
								[
									129.37109375,
									-2.820507812499983
								],
								[
									129.4273437500001,
									-2.7907226562499545
								],
								[
									129.4841796875,
									-2.7857421874999204
								],
								[
									129.5429687500001,
									-2.7903320312499744
								],
								[
									129.60048828125002,
									-2.8061523437499005
								],
								[
									129.75468750000016,
									-2.8658203124999773
								]
							]
						],
						[
							[
								[
									100.42509765625016,
									-3.1829101562499176
								],
								[
									100.46513671875016,
									-3.3285156250000085
								],
								[
									100.34609375000014,
									-3.2291992187500256
								],
								[
									100.34843750000016,
									-3.1587890624999773
								],
								[
									100.33203125000011,
									-3.1130859374999034
								],
								[
									100.25996093750018,
									-3.056933593749932
								],
								[
									100.20429687500001,
									-2.9868164062500284
								],
								[
									100.17929687500009,
									-2.8202148437499233
								],
								[
									100.19853515624999,
									-2.785546874999966
								],
								[
									100.24560546875,
									-2.783203124999943
								],
								[
									100.45458984375011,
									-3.0019531249999147
								],
								[
									100.4688476562502,
									-3.0389648437499943
								],
								[
									100.46425781250014,
									-3.1168945312499687
								],
								[
									100.43388671875016,
									-3.1413085937499687
								],
								[
									100.42509765625016,
									-3.1829101562499176
								]
							]
						],
						[
							[
								[
									108.20722656250018,
									-2.9976562499999346
								],
								[
									108.19179687500014,
									-3.1030273437499005
								],
								[
									108.16728515625005,
									-3.142773437499912
								],
								[
									108.0835937500002,
									-3.1949218749999773
								],
								[
									108.05527343750003,
									-3.2268554687499034
								],
								[
									107.9771484375002,
									-3.2217773437499346
								],
								[
									107.96728515624994,
									-3.1666015625000625
								],
								[
									107.94111328125007,
									-3.1292968749999233
								],
								[
									107.85820312500005,
									-3.086328125000051
								],
								[
									107.83662109375018,
									-3.0966796875000284
								],
								[
									107.82177734375,
									-3.1607421874999346
								],
								[
									107.65957031249997,
									-3.2055664062499147
								],
								[
									107.61445312500001,
									-3.20937499999998
								],
								[
									107.63671875000011,
									-3.1248046874999034
								],
								[
									107.59492187500007,
									-3.0583984375000455
								],
								[
									107.59160156250016,
									-2.9765624999999005
								],
								[
									107.58388671875002,
									-2.94072265624996
								],
								[
									107.56347656250011,
									-2.9201171874999403
								],
								[
									107.60488281250014,
									-2.8630859375000455
								],
								[
									107.59814453125,
									-2.7997070312499233
								],
								[
									107.64160156249994,
									-2.7315429687499773
								],
								[
									107.66630859375005,
									-2.56630859374998
								],
								[
									107.83779296875014,
									-2.530273437499929
								],
								[
									107.87470703125001,
									-2.5596679687500483
								],
								[
									108.07441406250001,
									-2.5969726562499176
								],
								[
									108.21513671874999,
									-2.6969726562499545
								],
								[
									108.2906250000002,
									-2.829980468750051
								],
								[
									108.20722656250018,
									-2.9976562499999346
								]
							]
						],
						[
							[
								[
									100.2041015625,
									-2.7410156250000455
								],
								[
									100.13271484375002,
									-2.821386718749906
								],
								[
									100.01494140625016,
									-2.8197265624999233
								],
								[
									99.99189453125018,
									-2.76982421874996
								],
								[
									99.99687500000005,
									-2.6493164062499233
								],
								[
									99.96816406250014,
									-2.6097656249999517
								],
								[
									99.9693359375002,
									-2.594140624999966
								],
								[
									99.98789062500009,
									-2.5253906249999005
								],
								[
									100.01191406250018,
									-2.510253906249929
								],
								[
									100.20195312500016,
									-2.679687499999986
								],
								[
									100.2041015625,
									-2.7410156250000455
								]
							]
						],
						[
							[
								[
									134.37421875000018,
									-2.123535156250014
								],
								[
									134.3452148437501,
									-2.1387695312499204
								],
								[
									134.3350585937501,
									-2.095214843749929
								],
								[
									134.35078125000018,
									-2.03691406249996
								],
								[
									134.36953125000002,
									-2.027636718750017
								],
								[
									134.39101562500014,
									-2.030761718749943
								],
								[
									134.41904296875003,
									-2.0517578124999574
								],
								[
									134.37421875000018,
									-2.123535156250014
								]
							]
						],
						[
							[
								[
									99.84306640625016,
									-2.3430664062499744
								],
								[
									99.84785156250007,
									-2.369726562499906
								],
								[
									99.6851562500002,
									-2.2817382812499147
								],
								[
									99.6070312500002,
									-2.2575195312499545
								],
								[
									99.53740234375016,
									-2.1615234374999375
								],
								[
									99.55888671875016,
									-2.1154296874999687
								],
								[
									99.56181640625016,
									-2.0511718749999233
								],
								[
									99.57216796875014,
									-2.0257812499999943
								],
								[
									99.6220703125,
									-2.0166015624999005
								],
								[
									99.68642578125014,
									-2.0633789062499233
								],
								[
									99.73476562500002,
									-2.1777343750000426
								],
								[
									99.81572265625016,
									-2.284374999999926
								],
								[
									99.84306640625016,
									-2.3430664062499744
								]
							]
						],
						[
							[
								[
									126.05507812499997,
									-2.4512695312499915
								],
								[
									126.03789062500005,
									-2.4694335937499687
								],
								[
									125.97792968749997,
									-2.41542968749998
								],
								[
									125.9375976562502,
									-2.262792968749963
								],
								[
									125.90322265625014,
									-2.222167968749943
								],
								[
									125.86289062500009,
									-2.0771484374998863
								],
								[
									125.87324218750007,
									-2.035937499999932
								],
								[
									125.92275390625002,
									-1.974804687499912
								],
								[
									125.96279296875002,
									-1.9757812499999403
								],
								[
									125.99267578124994,
									-2.0118164062499915
								],
								[
									125.97597656250002,
									-2.1680664062499346
								],
								[
									126.06572265624999,
									-2.3658203124999915
								],
								[
									126.05507812499997,
									-2.4512695312499915
								]
							]
						],
						[
							[
								[
									123.84824218750003,
									-1.955468749999966
								],
								[
									123.86601562500005,
									-1.9957031249999062
								],
								[
									123.80351562499999,
									-1.994335937499983
								],
								[
									123.77724609374997,
									-1.918652343749926
								],
								[
									123.78349609374999,
									-1.87832031249998
								],
								[
									123.84824218750003,
									-1.955468749999966
								]
							]
						],
						[
							[
								[
									126.02421875000016,
									-1.7897460937499545
								],
								[
									126.33173828125001,
									-1.8228515624999488
								],
								[
									126.28808593750011,
									-1.858886718749929
								],
								[
									125.95644531250014,
									-1.916601562499963
								],
								[
									125.8388671875,
									-1.906152343749966
								],
								[
									125.47919921875007,
									-1.9400390624999346
								],
								[
									125.4326171875,
									-1.9380859374999773
								],
								[
									125.42597656250007,
									-1.882226562499966
								],
								[
									125.38720703125,
									-1.8430664062499034
								],
								[
									125.44472656249997,
									-1.808984374999966
								],
								[
									125.52089843750014,
									-1.8008789062500057
								],
								[
									125.72031250000009,
									-1.8137695312499744
								],
								[
									126.02421875000016,
									-1.7897460937499545
								]
							]
						],
						[
							[
								[
									123.15253906250018,
									-1.8165039062499915
								],
								[
									123.07880859375018,
									-1.8989257812499147
								],
								[
									123.07089843750003,
									-1.8548828124999943
								],
								[
									123.08583984374997,
									-1.8148437500000085
								],
								[
									123.10644531250011,
									-1.786718749999963
								],
								[
									123.13750000000005,
									-1.7726562499999403
								],
								[
									123.15253906250018,
									-1.8165039062499915
								]
							]
						],
						[
							[
								[
									130.35332031250016,
									-1.6905273437499062
								],
								[
									130.36542968750007,
									-1.7498046874999034
								],
								[
									130.425,
									-1.8045898437500512
								],
								[
									130.404296875,
									-1.8898437500000114
								],
								[
									130.38056640625,
									-1.9026367187499602
								],
								[
									130.39335937500016,
									-1.941601562499983
								],
								[
									130.41884765625002,
									-1.9712890624999062
								],
								[
									130.3726562500002,
									-1.991894531249926
								],
								[
									130.3389648437501,
									-1.9818359374999233
								],
								[
									130.2841796875001,
									-2.0093749999999346
								],
								[
									130.2480468750001,
									-2.0477539062499375
								],
								[
									130.13349609375007,
									-2.0638671874999375
								],
								[
									130.09335937500003,
									-2.0283203124998863
								],
								[
									129.8865234375,
									-1.9864257812499773
								],
								[
									129.7543945312501,
									-1.894433593749966
								],
								[
									129.73769531249997,
									-1.8668945312499545
								],
								[
									129.99365234375,
									-1.7588867187499773
								],
								[
									130.10576171875,
									-1.7304687499999574
								],
								[
									130.19960937500002,
									-1.7322265624999602
								],
								[
									130.31796875000003,
									-1.6919921874999346
								],
								[
									130.35332031250016,
									-1.6905273437499062
								]
							]
						],
						[
							[
								[
									124.96953125000016,
									-1.7054687499999375
								],
								[
									125.06298828125011,
									-1.7410156249999744
								],
								[
									125.09589843750007,
									-1.7408203124999346
								],
								[
									125.12675781250005,
									-1.6993164062499204
								],
								[
									125.14580078124999,
									-1.6925781249999687
								],
								[
									125.18789062500014,
									-1.712890624999929
								],
								[
									125.19765624999997,
									-1.7802734374999005
								],
								[
									125.25820312499997,
									-1.7708984374999375
								],
								[
									125.30537109375018,
									-1.7939453125000142
								],
								[
									125.32021484375002,
									-1.810058593749929
								],
								[
									125.31406250000009,
									-1.877148437499912
								],
								[
									125.13476562499994,
									-1.8889648437499176
								],
								[
									125.00673828125002,
									-1.943066406249926
								],
								[
									124.83447265625,
									-1.894433593749966
								],
								[
									124.63916015625,
									-1.978222656249983
								],
								[
									124.52060546875009,
									-2.0069335937500625
								],
								[
									124.41777343749999,
									-2.0051757812500597
								],
								[
									124.3296875000002,
									-1.858886718749929
								],
								[
									124.38085937499994,
									-1.6875
								],
								[
									124.41757812500003,
									-1.6592773437499346
								],
								[
									124.48300781250003,
									-1.6443359374999176
								],
								[
									124.66396484374997,
									-1.635937499999983
								],
								[
									124.96953125000016,
									-1.7054687499999375
								]
							]
						],
						[
							[
								[
									135.4742187500001,
									-1.5917968750000426
								],
								[
									135.869140625,
									-1.641992187499966
								],
								[
									135.9761718750002,
									-1.6355468749999034
								],
								[
									136.20156250000014,
									-1.6549804687499545
								],
								[
									136.38964843749994,
									-1.7215820312499233
								],
								[
									136.7185546875,
									-1.733984374999963
								],
								[
									136.81669921875005,
									-1.7538085937500085
								],
								[
									136.8925781250001,
									-1.7997070312499517
								],
								[
									136.7085937500002,
									-1.8376953125000455
								],
								[
									136.62187500000005,
									-1.8730468749999716
								],
								[
									136.46083984375002,
									-1.8904296874999602
								],
								[
									136.32607421874997,
									-1.8724609375000227
								],
								[
									136.2281250000002,
									-1.8936523437499062
								],
								[
									136.19257812500007,
									-1.8591796874998892
								],
								[
									136.04921874999997,
									-1.8241210937499517
								],
								[
									135.86572265625,
									-1.7521484375000256
								],
								[
									135.48759765625016,
									-1.6683593750000085
								],
								[
									135.46972656249994,
									-1.6162109375000426
								],
								[
									135.4742187500001,
									-1.5917968750000426
								]
							]
						],
						[
							[
								[
									108.953125,
									-1.6196289062500284
								],
								[
									108.83789062499994,
									-1.6616210937500568
								],
								[
									108.80371093750011,
									-1.5677734374999517
								],
								[
									108.87724609375016,
									-1.539843749999946
								],
								[
									108.95683593750005,
									-1.5640624999999062
								],
								[
									108.953125,
									-1.6196289062500284
								]
							]
						],
						[
							[
								[
									106.04570312499999,
									-1.6694335937499574
								],
								[
									106.080078125,
									-1.7382812500000426
								],
								[
									106.12714843750018,
									-1.8001953124999517
								],
								[
									106.1617187500002,
									-1.8669921874999744
								],
								[
									106.20878906249999,
									-2.1886718749999687
								],
								[
									106.36591796875007,
									-2.4648437499999147
								],
								[
									106.81845703125003,
									-2.5733398437499915
								],
								[
									106.74433593750007,
									-2.617968749999932
								],
								[
									106.7066406250002,
									-2.6580078124999176
								],
								[
									106.6788085937502,
									-2.704003906249966
								],
								[
									106.61201171875018,
									-2.8955078124999005
								],
								[
									106.61855468750002,
									-2.9361328125000057
								],
								[
									106.65761718750014,
									-3.0011718749999403
								],
								[
									106.66718750000007,
									-3.071777343749929
								],
								[
									106.61054687500007,
									-3.0713867187499346
								],
								[
									106.54677734375014,
									-3.055566406249909
								],
								[
									106.49609375000011,
									-3.029003906249926
								],
								[
									106.44873046874994,
									-2.994238281249949
								],
								[
									106.39736328125014,
									-2.9666015624999034
								],
								[
									106.34160156250016,
									-2.9487304687499147
								],
								[
									106.25009765625009,
									-2.8940429687499574
								],
								[
									106.12587890624997,
									-2.85537109374998
								],
								[
									105.99873046875001,
									-2.824902343749912
								],
								[
									105.93720703125018,
									-2.7435546874999375
								],
								[
									105.90800781249999,
									-2.6432617187500256
								],
								[
									105.9390625000002,
									-2.4934570312500597
								],
								[
									105.90761718750014,
									-2.45195312499996
								],
								[
									105.86240234375003,
									-2.41542968749998
								],
								[
									105.80683593750018,
									-2.3074218749999034
								],
								[
									105.78583984375018,
									-2.181347656250068
								],
								[
									105.70527343750018,
									-2.1326171874999176
								],
								[
									105.59902343750014,
									-2.103124999999949
								],
								[
									105.55273437500011,
									-2.079003906249909
								],
								[
									105.34287109375009,
									-2.1250976562499773
								],
								[
									105.29257812500003,
									-2.1142578124999005
								],
								[
									105.24765625000003,
									-2.0793945312499034
								],
								[
									105.1333984375002,
									-2.042578124999949
								],
								[
									105.13769531250011,
									-1.9726562499999147
								],
								[
									105.19101562500003,
									-1.9168945312499233
								],
								[
									105.31621093750016,
									-1.860546874999912
								],
								[
									105.37480468749999,
									-1.8131835937500256
								],
								[
									105.38652343749999,
									-1.7507812499999318
								],
								[
									105.3642578125,
									-1.7050781250000284
								],
								[
									105.3731445312502,
									-1.6573242187499773
								],
								[
									105.4126953125002,
									-1.611035156250054
								],
								[
									105.45957031250003,
									-1.5747070312499432
								],
								[
									105.58544921875011,
									-1.5267578124999375
								],
								[
									105.64042968750005,
									-1.6104492187499346
								],
								[
									105.66757812500003,
									-1.6803710937499687
								],
								[
									105.70087890625018,
									-1.7310546874999915
								],
								[
									105.7544921875002,
									-1.6586914062499005
								],
								[
									105.72041015625018,
									-1.5338867187499687
								],
								[
									105.81611328125001,
									-1.506054687499983
								],
								[
									105.91005859374997,
									-1.5049804687499488
								],
								[
									105.98095703124994,
									-1.5391601562499773
								],
								[
									106.02734375,
									-1.593164062499966
								],
								[
									106.04570312499999,
									-1.6694335937499574
								]
							]
						],
						[
							[
								[
									123.59755859374997,
									-1.7042968749999545
								],
								[
									123.52861328125016,
									-1.710839843749966
								],
								[
									123.48251953125009,
									-1.6814453124999176
								],
								[
									123.48662109375005,
									-1.5348632812498977
								],
								[
									123.52851562500001,
									-1.502832031250037
								],
								[
									123.54853515625001,
									-1.5082031250000654
								],
								[
									123.56132812500016,
									-1.5518554687499062
								],
								[
									123.58203125000011,
									-1.5909179687499488
								],
								[
									123.61640625000018,
									-1.627441406249929
								],
								[
									123.59755859374997,
									-1.7042968749999545
								]
							]
						],
						[
							[
								[
									128.15302734375018,
									-1.6605468749999233
								],
								[
									128.09179687499994,
									-1.7011718749999432
								],
								[
									128.06123046875,
									-1.712402343749929
								],
								[
									127.91376953125018,
									-1.685156249999963
								],
								[
									127.74101562500016,
									-1.690820312499966
								],
								[
									127.5616210937502,
									-1.7285156249999147
								],
								[
									127.45761718750009,
									-1.6966796874999233
								],
								[
									127.39218750000003,
									-1.6448242187499176
								],
								[
									127.39501953125011,
									-1.58984375
								],
								[
									127.45673828125007,
									-1.4537109374999773
								],
								[
									127.59179687499994,
									-1.3507812499999687
								],
								[
									127.64667968750001,
									-1.332421874999966
								],
								[
									127.74296875000005,
									-1.3602539062499517
								],
								[
									127.90507812499999,
									-1.4390624999999204
								],
								[
									128.0328125000002,
									-1.5316406249999517
								],
								[
									128.14873046875,
									-1.603710937499983
								],
								[
									128.15302734375018,
									-1.6605468749999233
								]
							]
						],
						[
							[
								[
									123.21230468750002,
									-1.1712890624999943
								],
								[
									123.23427734375014,
									-1.2336914062499176
								],
								[
									123.19804687500005,
									-1.2876953124999062
								],
								[
									123.23779296874994,
									-1.3893554687500114
								],
								[
									123.33857421875007,
									-1.2540039062499773
								],
								[
									123.43476562500001,
									-1.236816406249929
								],
								[
									123.48935546875003,
									-1.2592773437498863
								],
								[
									123.52685546874994,
									-1.2860351562499233
								],
								[
									123.54726562500014,
									-1.3374023437499147
								],
								[
									123.51191406250001,
									-1.4473632812499346
								],
								[
									123.44873046875011,
									-1.4988281249999318
								],
								[
									123.36699218750016,
									-1.5071289062499318
								],
								[
									123.32861328125,
									-1.4430664062499403
								],
								[
									123.27490234374994,
									-1.4372070312498977
								],
								[
									123.23740234375003,
									-1.576953124999946
								],
								[
									123.22050781250016,
									-1.5983398437499545
								],
								[
									123.17294921875009,
									-1.6160156250000028
								],
								[
									123.13037109375011,
									-1.5774414062499602
								],
								[
									123.12294921875002,
									-1.5560546874999517
								],
								[
									123.18291015625016,
									-1.4927734374999488
								],
								[
									123.15039062500011,
									-1.3044921874999602
								],
								[
									123.10517578125001,
									-1.3398437499999574
								],
								[
									122.98437500000011,
									-1.5106445312499375
								],
								[
									122.89042968750016,
									-1.5872070312499034
								],
								[
									122.85849609375003,
									-1.5482421875000512
								],
								[
									122.81083984374999,
									-1.432128906249929
								],
								[
									122.83222656250001,
									-1.283007812500017
								],
								[
									122.90800781249999,
									-1.1822265624999204
								],
								[
									122.97246093750016,
									-1.189160156249912
								],
								[
									123.1583007812502,
									-1.1575195312500313
								],
								[
									123.21230468750002,
									-1.1712890624999943
								]
							]
						],
						[
							[
								[
									109.71025390625016,
									-1.1806640624999574
								],
								[
									109.5108398437502,
									-1.2828124999999773
								],
								[
									109.46367187499999,
									-1.2775390624999687
								],
								[
									109.42812500000014,
									-1.2412109375000284
								],
								[
									109.4502929687502,
									-1.0441406250000256
								],
								[
									109.47597656250002,
									-0.9853515624999574
								],
								[
									109.61464843750014,
									-0.9791015624999204
								],
								[
									109.69951171874999,
									-1.0073242187499858
								],
								[
									109.74335937500007,
									-1.039355468749946
								],
								[
									109.76054687499999,
									-1.1051757812500256
								],
								[
									109.75078125000016,
									-1.1450195312499716
								],
								[
									109.71025390625016,
									-1.1806640624999574
								]
							]
						],
						[
							[
								[
									134.96533203124994,
									-1.1160156249999318
								],
								[
									134.91738281249997,
									-1.1342773437499147
								],
								[
									134.86171875000002,
									-1.114160156249909
								],
								[
									134.80888671875016,
									-1.0375976562499432
								],
								[
									134.82792968750005,
									-0.978808593749946
								],
								[
									134.8892578125002,
									-0.9384765624999005
								],
								[
									134.94082031250014,
									-0.9789062499999659
								],
								[
									134.95673828125018,
									-1.0305664062499318
								],
								[
									134.99628906250007,
									-1.0340820312499375
								],
								[
									134.96533203124994,
									-1.1160156249999318
								]
							]
						],
						[
							[
								[
									99.16386718750016,
									-1.7779296874999488
								],
								[
									99.07177734374994,
									-1.783496093750017
								],
								[
									98.87431640625016,
									-1.6636718749999488
								],
								[
									98.82773437500003,
									-1.6099609374999204
								],
								[
									98.81630859375014,
									-1.538281249999983
								],
								[
									98.62695312500011,
									-1.2613281249999488
								],
								[
									98.60175781250001,
									-1.1978515624999062
								],
								[
									98.67607421875016,
									-0.970507812499946
								],
								[
									98.86904296875014,
									-0.915624999999963
								],
								[
									98.93261718750011,
									-0.9540039062499659
								],
								[
									98.95478515625018,
									-1.0562500000000057
								],
								[
									99.0650390625002,
									-1.240722656249929
								],
								[
									99.10146484375014,
									-1.3401367187499318
								],
								[
									99.12890624999994,
									-1.3841796875000227
								],
								[
									99.14042968749999,
									-1.4184570312499005
								],
								[
									99.13066406250016,
									-1.4423828124998863
								],
								[
									99.21035156250014,
									-1.5592773437498977
								],
								[
									99.26728515625018,
									-1.6277343749999034
								],
								[
									99.27148437499994,
									-1.738476562499912
								],
								[
									99.16386718750016,
									-1.7779296874999488
								]
							]
						],
						[
							[
								[
									131.00185546875014,
									-1.3155273437499773
								],
								[
									130.96660156250016,
									-1.343457031249983
								],
								[
									130.84511718749997,
									-1.31728515624998
								],
								[
									130.7823242187501,
									-1.2554687499999204
								],
								[
									130.7393554687502,
									-1.172558593749983
								],
								[
									130.71210937500018,
									-1.1043945312499517
								],
								[
									130.70439453125,
									-1.0501953124999233
								],
								[
									130.66796874999994,
									-0.9839843749999346
								],
								[
									130.6729492187501,
									-0.9597656249999744
								],
								[
									130.89716796875,
									-0.8900390624999801
								],
								[
									130.9394531250001,
									-0.9153320312499034
								],
								[
									131.03300781250016,
									-0.9175781249999062
								],
								[
									131.07392578125007,
									-0.968261718749929
								],
								[
									131.04619140625,
									-1.1881835937499687
								],
								[
									131.00185546875014,
									-1.3155273437499773
								]
							]
						],
						[
							[
								[
									130.9052734375,
									-0.7774414062500483
								],
								[
									130.87978515625014,
									-0.8284179687499602
								],
								[
									130.83242187499997,
									-0.8628906250000483
								],
								[
									130.40244140625003,
									-0.9239257812500483
								],
								[
									130.43906250000003,
									-0.8874023437500682
								],
								[
									130.45732421875005,
									-0.8511718749999773
								],
								[
									130.48427734375002,
									-0.8325195312499005
								],
								[
									130.5269531250002,
									-0.8373046874998948
								],
								[
									130.54814453125016,
									-0.8262695312500483
								],
								[
									130.56953125000007,
									-0.8218749999999488
								],
								[
									130.5937500000001,
									-0.8266601562499574
								],
								[
									130.63544921875018,
									-0.8116210937499062
								],
								[
									130.7232421875002,
									-0.822460937499983
								],
								[
									130.8134765625001,
									-0.8138671875000085
								],
								[
									130.80703125000014,
									-0.7650390625000085
								],
								[
									130.9052734375,
									-0.7774414062500483
								]
							]
						],
						[
							[
								[
									135.38300781250007,
									-0.6513671874999432
								],
								[
									135.59570312499994,
									-0.6904296874999147
								],
								[
									135.67324218750014,
									-0.6882812500000028
								],
								[
									135.7490234375001,
									-0.732519531249963
								],
								[
									135.84121093749997,
									-0.7116210937499687
								],
								[
									135.8935546875,
									-0.7257812499999119
								],
								[
									136.06875000000014,
									-0.8777343749999602
								],
								[
									136.15468749999997,
									-0.978320312499946
								],
								[
									136.28261718750002,
									-1.0646484374999403
								],
								[
									136.37529296875016,
									-1.0940429687499744
								],
								[
									136.30537109375,
									-1.173144531250017
								],
								[
									136.16474609375018,
									-1.214746093749966
								],
								[
									136.1103515625001,
									-1.2167968750000284
								],
								[
									136.0025390625001,
									-1.1697265625000313
								],
								[
									135.9150390625001,
									-1.1784179687500256
								],
								[
									135.83876953125002,
									-1.1194335937499176
								],
								[
									135.82558593749997,
									-1.0283203125
								],
								[
									135.7470703125,
									-0.8230468749999318
								],
								[
									135.645703125,
									-0.8819335937500199
								],
								[
									135.52382812499997,
									-0.7873046874999261
								],
								[
									135.49111328124997,
									-0.785058593749909
								],
								[
									135.4833984375,
									-0.8010742187499744
								],
								[
									135.4316406250001,
									-0.7688476562499034
								],
								[
									135.38769531249994,
									-0.7048828124999176
								],
								[
									135.38300781250007,
									-0.6513671874999432
								]
							]
						],
						[
							[
								[
									127.3003906250002,
									-0.780957031250054
								],
								[
									127.28906250000011,
									-0.8015624999999886
								],
								[
									127.18457031249994,
									-0.7752929687499659
								],
								[
									127.15644531250018,
									-0.7609374999999687
								],
								[
									127.20908203125003,
									-0.6193359374998977
								],
								[
									127.25820312500014,
									-0.6234374999999375
								],
								[
									127.30126953125011,
									-0.7583984374999062
								],
								[
									127.3003906250002,
									-0.780957031250054
								]
							]
						],
						[
							[
								[
									130.62666015625018,
									-0.528710937499909
								],
								[
									130.56914062500016,
									-0.5299804687499119
								],
								[
									130.4654296875001,
									-0.4865234374999403
								],
								[
									130.52587890624994,
									-0.44873046874995737
								],
								[
									130.56416015625,
									-0.44091796875005684
								],
								[
									130.59746093750016,
									-0.4182617187500597
								],
								[
									130.61591796875018,
									-0.417285156249946
								],
								[
									130.65693359375,
									-0.43652343749995737
								],
								[
									130.68427734375018,
									-0.4691406249999517
								],
								[
									130.62666015625018,
									-0.528710937499909
								]
							]
						],
						[
							[
								[
									121.8643554687502,
									-0.40683593749994884
								],
								[
									121.90683593750003,
									-0.4512695312500341
								],
								[
									121.88124999999997,
									-0.5026367187499261
								],
								[
									121.84687500000018,
									-0.4898437499999062
								],
								[
									121.75605468750007,
									-0.4908203124999204
								],
								[
									121.7217773437502,
									-0.4947265625000057
								],
								[
									121.68095703125005,
									-0.524999999999963
								],
								[
									121.65527343749994,
									-0.526171875000017
								],
								[
									121.67236328125,
									-0.4788085937499602
								],
								[
									121.74931640625005,
									-0.40703124999990337
								],
								[
									121.79736328124994,
									-0.4176757812499403
								],
								[
									121.8643554687502,
									-0.40683593749994884
								]
							]
						],
						[
							[
								[
									140.97343750000016,
									-2.6097656249999517
								],
								[
									140.97353515625002,
									-2.8034179687499687
								],
								[
									140.9736328125001,
									-3.006640624999889
								],
								[
									140.97373046875003,
									-3.209960937500014
								],
								[
									140.97382812500007,
									-3.4132812499999545
								],
								[
									140.97392578125,
									-3.616601562499909
								],
								[
									140.97402343750002,
									-3.8198242187499147
								],
								[
									140.97402343750002,
									-4.0231445312499545
								],
								[
									140.97421875000003,
									-4.22646484374998
								],
								[
									140.97421875000003,
									-4.42978515624992
								],
								[
									140.97431640625018,
									-4.633007812500026
								],
								[
									140.9744140625,
									-4.836328124999966
								],
								[
									140.97451171875014,
									-5.03964843749992
								],
								[
									140.97460937499994,
									-5.242968749999946
								],
								[
									140.97460937499994,
									-5.446191406249966
								],
								[
									140.97470703125003,
									-5.6495117187499915
								],
								[
									140.97480468750018,
									-5.852832031249932
								],
								[
									140.97490234375,
									-6.056152343750057
								],
								[
									140.97500000000014,
									-6.259374999999977
								],
								[
									140.97500000000014,
									-6.34609374999998
								],
								[
									140.94404296875,
									-6.452246093749935
								],
								[
									140.8746093750002,
									-6.6115234374999545
								],
								[
									140.8623046875,
									-6.740039062499946
								],
								[
									140.9195312500002,
									-6.840039062499969
								],
								[
									140.9751953125001,
									-6.905371093750048
								],
								[
									140.9751953125001,
									-7.072558593750003
								],
								[
									140.97529296875018,
									-7.275878906249943
								],
								[
									140.97539062500005,
									-7.479199218750068
								],
								[
									140.97548828125014,
									-7.682519531249923
								],
								[
									140.9755859375,
									-7.885742187499943
								],
								[
									140.9755859375,
									-8.089062499999969
								],
								[
									140.9756835937501,
									-8.292382812499909
								],
								[
									140.97578125,
									-8.495703125000034
								],
								[
									140.97587890625005,
									-8.698925781249955
								],
								[
									140.97597656250014,
									-8.902246093749909
								],
								[
									140.97597656250014,
									-9.105566406249935
								],
								[
									140.9761718750002,
									-9.118749999999963
								],
								[
									140.92460937500016,
									-9.08505859375002
								],
								[
									140.78652343750002,
									-8.973730468749906
								],
								[
									140.66152343750014,
									-8.846777343749977
								],
								[
									140.5810546875,
									-8.728320312499903
								],
								[
									140.4897460937501,
									-8.620410156249946
								],
								[
									140.1016601562502,
									-8.300585937499903
								],
								[
									140.00292968749994,
									-8.195507812499983
								],
								[
									139.98330078124997,
									-8.166503906249943
								],
								[
									139.99257812499997,
									-8.139355468749912
								],
								[
									140.03740234375016,
									-8.083984375
								],
								[
									140.11699218750005,
									-7.923730468750037
								],
								[
									140.03378906250003,
									-8.02275390624996
								],
								[
									139.934765625,
									-8.101171874999949
								],
								[
									139.7908203125,
									-8.106347656249937
								],
								[
									139.6494140625,
									-8.125390624999909
								],
								[
									139.51855468749994,
									-8.172753906249966
								],
								[
									139.38564453124997,
									-8.18906249999992
								],
								[
									139.31914062500005,
									-8.165820312499974
								],
								[
									139.27910156250005,
									-8.106933593750057
								],
								[
									139.25830078124994,
									-8.046582031249926
								],
								[
									139.248828125,
									-7.982421874999915
								],
								[
									139.1929687500001,
									-8.086132812499912
								],
								[
									139.08320312500018,
									-8.142871093749918
								],
								[
									138.93349609374997,
									-8.26240234374994
								],
								[
									138.8906250000001,
									-8.2377929687499
								],
								[
									138.86474609375,
									-8.192285156250037
								],
								[
									138.85615234375,
									-8.14511718750002
								],
								[
									138.88505859375016,
									-8.094726562500057
								],
								[
									138.90546875,
									-8.041210937499898
								],
								[
									138.93593750000014,
									-7.9130859375
								],
								[
									139.0030273437502,
									-7.837597656249983
								],
								[
									139.045703125,
									-7.691406249999957
								],
								[
									139.07363281250002,
									-7.6392578124999915
								],
								[
									139.0879882812502,
									-7.5872070312500455
								],
								[
									139.04892578125003,
									-7.528320312499957
								],
								[
									138.9830078125002,
									-7.5082031249999375
								],
								[
									138.93789062499997,
									-7.472460937499946
								],
								[
									138.88554687500016,
									-7.373242187499983
								],
								[
									138.8531250000002,
									-7.33964843750006
								],
								[
									138.79365234375018,
									-7.298925781249935
								],
								[
									138.74794921875002,
									-7.251464843749943
								],
								[
									138.7984375000001,
									-7.215722656250037
								],
								[
									138.8648437500002,
									-7.2013671874999545
								],
								[
									138.91933593750002,
									-7.203613281250057
								],
								[
									139.01796875000014,
									-7.225878906249974
								],
								[
									139.06249999999994,
									-7.227148437499963
								],
								[
									139.1768554687501,
									-7.190429687499943
								],
								[
									139.11259765625005,
									-7.201757812500034
								],
								[
									139.04902343750007,
									-7.20058593749998
								],
								[
									138.8457031250001,
									-7.136328124999935
								],
								[
									138.72001953125,
									-7.069824218749886
								],
								[
									138.60136718750016,
									-6.9365234375
								],
								[
									138.6001953125002,
									-6.910742187499906
								],
								[
									138.68378906250018,
									-6.886523437499946
								],
								[
									138.86455078125016,
									-6.8583984374999005
								],
								[
									138.80849609374997,
									-6.790429687499909
								],
								[
									138.7266601562502,
									-6.731152343749912
								],
								[
									138.69814453124997,
									-6.625683593749912
								],
								[
									138.64218750000003,
									-6.560449218749952
								],
								[
									138.5215820312501,
									-6.453808593750068
								],
								[
									138.43867187500007,
									-6.343359374999949
								],
								[
									138.368359375,
									-6.11855468749998
								],
								[
									138.29628906250002,
									-5.949023437499903
								],
								[
									138.31386718750014,
									-5.887499999999889
								],
								[
									138.37460937500003,
									-5.8436523437499375
								],
								[
									138.2828125000002,
									-5.838574218749969
								],
								[
									138.19960937500014,
									-5.8070312499999375
								],
								[
									138.24355468750002,
									-5.724414062499974
								],
								[
									138.33964843750016,
									-5.675683593749994
								],
								[
									138.25214843750018,
									-5.688183593750054
								],
								[
									138.1665039062501,
									-5.712011718749935
								],
								[
									138.12744140625,
									-5.716503906249969
								],
								[
									138.087109375,
									-5.709179687500068
								],
								[
									138.06591796874994,
									-5.675976562500054
								],
								[
									138.0630859375002,
									-5.628906250000057
								],
								[
									138.07558593749997,
									-5.545800781249909
								],
								[
									138.06083984375,
									-5.4652343749999375
								],
								[
									137.9849609375001,
									-5.427636718749909
								],
								[
									137.92226562500002,
									-5.370117187499915
								],
								[
									137.8868164062501,
									-5.348828124999926
								],
								[
									137.8403320312501,
									-5.350488281249909
								],
								[
									137.79521484375016,
									-5.312011718749886
								],
								[
									137.75908203125016,
									-5.256152343749974
								],
								[
									137.3066406250001,
									-5.014355468749912
								],
								[
									137.27978515624994,
									-4.945410156249906
								],
								[
									137.2378906250002,
									-4.975683593749935
								],
								[
									137.1958984375002,
									-4.990429687500011
								],
								[
									137.14375,
									-4.950781249999935
								],
								[
									137.08925781250014,
									-4.9244140625000625
								],
								[
									137.02968749999997,
									-4.928710937499957
								],
								[
									136.97460937499994,
									-4.907324218749963
								],
								[
									136.9169921875001,
									-4.895117187499963
								],
								[
									136.85683593750014,
									-4.89316406249992
								],
								[
									136.61884765625,
									-4.8187499999999375
								],
								[
									136.39375000000018,
									-4.701269531249906
								],
								[
									136.21064453125018,
									-4.650683593749903
								],
								[
									136.09746093750005,
									-4.584765624999974
								],
								[
									135.9796875,
									-4.530859374999906
								],
								[
									135.71660156250016,
									-4.47841796874998
								],
								[
									135.4501953125,
									-4.443066406250054
								],
								[
									135.35390624999997,
									-4.44179687499998
								],
								[
									135.27314453125007,
									-4.453124999999972
								],
								[
									135.19560546875016,
									-4.450683593749915
								],
								[
									134.75419921875005,
									-4.195410156250048
								],
								[
									134.67968749999994,
									-4.079101562499886
								],
								[
									134.68691406250002,
									-4.011132812499895
								],
								[
									134.7065429687501,
									-3.954785156250054
								],
								[
									134.88652343750016,
									-3.938476562499929
								],
								[
									134.7597656250001,
									-3.922167968749889
								],
								[
									134.70761718750003,
									-3.9298828124999545
								],
								[
									134.60341796875014,
									-3.9760742187499574
								],
								[
									134.546875,
									-3.9792968749999034
								],
								[
									134.46718750000002,
									-3.9486328124999517
								],
								[
									134.39101562500014,
									-3.909960937499889
								],
								[
									134.2662109375002,
									-3.94580078125
								],
								[
									134.20234375000007,
									-3.887011718749932
								],
								[
									134.18046875000005,
									-3.8250976562499233
								],
								[
									134.1470703125001,
									-3.7967773437499233
								],
								[
									134.09999999999997,
									-3.799707031249909
								],
								[
									134.0369140625,
									-3.821972656249997
								],
								[
									133.973828125,
									-3.8179687499999773
								],
								[
									133.9332031250002,
									-3.7755859374999687
								],
								[
									133.90400390625,
									-3.7201171874999375
								],
								[
									133.86074218750002,
									-3.680371093749926
								],
								[
									133.80849609375002,
									-3.649999999999963
								],
								[
									133.72304687500002,
									-3.577929687500017
								],
								[
									133.67832031250003,
									-3.479492187499943
								],
								[
									133.6833984375,
									-3.3091796874999773
								],
								[
									133.69716796874997,
									-3.2481445312499773
								],
								[
									133.78164062500014,
									-3.148925781250014
								],
								[
									133.84150390625018,
									-3.05478515625002
								],
								[
									133.76738281250016,
									-3.0443359375000227
								],
								[
									133.700390625,
									-3.0874999999999346
								],
								[
									133.6719726562501,
									-3.1318359374999147
								],
								[
									133.6607421875002,
									-3.185546875000014
								],
								[
									133.65312500000016,
									-3.3643554687499346
								],
								[
									133.59941406250016,
									-3.4161132812499204
								],
								[
									133.5181640625002,
									-3.411914062499946
								],
								[
									133.54228515625016,
									-3.5164062499999176
								],
								[
									133.50917968750014,
									-3.615527343749946
								],
								[
									133.4151367187501,
									-3.7321289062498977
								],
								[
									133.4072265625,
									-3.7851562499999574
								],
								[
									133.42226562500002,
									-3.842578124999932
								],
								[
									133.4008789062501,
									-3.8990234375000625
								],
								[
									133.24873046875,
									-4.062304687499932
								],
								[
									133.198046875,
									-4.070117187499932
								],
								[
									133.08515625000018,
									-4.069042968749969
								],
								[
									132.96855468750016,
									-4.094921874999912
								],
								[
									132.91445312500014,
									-4.056933593749903
								],
								[
									132.8701171875,
									-4.007421874999949
								],
								[
									132.83710937500018,
									-3.948925781249926
								],
								[
									132.79091796875002,
									-3.8281249999999147
								],
								[
									132.7539062500001,
									-3.7036132812500426
								],
								[
									132.8697265625001,
									-3.5509765624999403
								],
								[
									132.82978515625,
									-3.412988281249895
								],
								[
									132.75136718750014,
									-3.2946289062499403
								],
								[
									132.55351562500016,
									-3.130664062499932
								],
								[
									132.34824218750003,
									-2.9750976562499574
								],
								[
									132.2549804687501,
									-2.943457031249906
								],
								[
									132.10205078125,
									-2.9295898437499233
								],
								[
									132.05390625000007,
									-2.9145507812499574
								],
								[
									132.00634765624994,
									-2.856054687500034
								],
								[
									131.97119140625,
									-2.7885742187499716
								],
								[
									132.0668945312501,
									-2.7595703124999176
								],
								[
									132.23066406250018,
									-2.6803710937499545
								],
								[
									132.32333984375003,
									-2.6841796874999204
								],
								[
									132.57548828125,
									-2.7271484375000625
								],
								[
									132.65292968750003,
									-2.7662109374999346
								],
								[
									132.72499999999997,
									-2.7890624999999716
								],
								[
									132.897265625,
									-2.6582031249999574
								],
								[
									133.0337890625002,
									-2.4874023437499773
								],
								[
									133.11884765625,
									-2.4502929687499773
								],
								[
									133.1910156250001,
									-2.4377929687499176
								],
								[
									133.26494140625005,
									-2.454296874999983
								],
								[
									133.41142578125005,
									-2.5139648437499744
								],
								[
									133.5265625,
									-2.5416992187499403
								],
								[
									133.60869140625016,
									-2.5471679687499886
								],
								[
									133.6515625,
									-2.600585937499943
								],
								[
									133.70009765625014,
									-2.624609374999963
								],
								[
									133.7109375000001,
									-2.5440429687500625
								],
								[
									133.75332031250014,
									-2.4506835937499574
								],
								[
									133.83466796875,
									-2.421679687500003
								],
								[
									133.87763671875007,
									-2.4150390624999005
								],
								[
									133.9048828125002,
									-2.39091796874996
								],
								[
									133.89892578124994,
									-2.304492187499932
								],
								[
									133.7910156250001,
									-2.2936523437499403
								],
								[
									133.84970703125003,
									-2.219628906250051
								],
								[
									133.90244140625003,
									-2.1835937499999005
								],
								[
									133.9205078125002,
									-2.1474609374999147
								],
								[
									133.92158203125007,
									-2.1020507812499005
								],
								[
									133.71035156250002,
									-2.1891601562499687
								],
								[
									133.48779296874994,
									-2.225585937499929
								],
								[
									133.35625000000016,
									-2.215722656249966
								],
								[
									133.22490234375016,
									-2.2144531250000625
								],
								[
									132.96279296875014,
									-2.272558593749906
								],
								[
									132.8632812500001,
									-2.270214843750054
								],
								[
									132.6310546875,
									-2.246679687499963
								],
								[
									132.50263671875018,
									-2.2184570312498977
								],
								[
									132.4033203125001,
									-2.2404296875000256
								],
								[
									132.30761718749994,
									-2.2422851562500483
								],
								[
									132.20742187499997,
									-2.17578125
								],
								[
									132.1221679687502,
									-2.0923828125000625
								],
								[
									132.0798828125,
									-2.0332031249999147
								],
								[
									132.02343749999994,
									-1.990332031249963
								],
								[
									131.99843750000014,
									-1.932519531249909
								],
								[
									131.9361328125002,
									-1.7149414062499062
								],
								[
									131.93037109375,
									-1.5596679687499773
								],
								[
									131.82978515625,
									-1.556542968749966
								],
								[
									131.7314453125,
									-1.5412109375000398
								],
								[
									131.29375,
									-1.393457031249966
								],
								[
									131.24082031250003,
									-1.4296875000000568
								],
								[
									131.1791992187501,
									-1.4483398437499488
								],
								[
									131.1177734375002,
									-1.4552734374999403
								],
								[
									131.0567382812502,
									-1.4476562499998948
								],
								[
									130.99589843750016,
									-1.4247070312499375
								],
								[
									131.0009765625001,
									-1.383984374999983
								],
								[
									131.04619140625,
									-1.284082031249966
								],
								[
									131.09052734375018,
									-1.247265624999926
								],
								[
									131.15185546874994,
									-1.2188476562499204
								],
								[
									131.19082031249997,
									-1.165820312499946
								],
								[
									131.25410156250018,
									-1.0069335937499062
								],
								[
									131.258984375,
									-0.9526367187499432
								],
								[
									131.2520507812502,
									-0.8971679687499261
								],
								[
									131.25722656250002,
									-0.8554687499999574
								],
								[
									131.29638671875,
									-0.8335937499999488
								],
								[
									131.4615234375001,
									-0.781835937499963
								],
								[
									131.8042968750001,
									-0.7038085937499687
								],
								[
									131.89091796875016,
									-0.6571289062500512
								],
								[
									131.96240234374994,
									-0.5824218749999375
								],
								[
									132.0459960937502,
									-0.5370117187499233
								],
								[
									132.08447265624994,
									-0.4911132812499801
								],
								[
									132.12841796874994,
									-0.4541015624999005
								],
								[
									132.39375000000018,
									-0.35546875000005684
								],
								[
									132.50800781250018,
									-0.3474609374999318
								],
								[
									132.62509765625003,
									-0.35888671875004263
								],
								[
									132.8564453125001,
									-0.4173828124999659
								],
								[
									133.07714843749994,
									-0.5118164062499346
								],
								[
									133.26845703125014,
									-0.6357421874999574
								],
								[
									133.47265625,
									-0.7261718749999062
								],
								[
									133.72363281249994,
									-0.7414062499998977
								],
								[
									133.85029296875018,
									-0.7314453124999147
								],
								[
									133.97451171874997,
									-0.744335937500054
								],
								[
									134.02490234374994,
									-0.769726562499983
								],
								[
									134.1115234375,
									-0.846777343749963
								],
								[
									134.08671875000005,
									-0.8973632812499659
								],
								[
									134.07197265625007,
									-1.0018554687499375
								],
								[
									134.1162109375,
									-1.102441406249909
								],
								[
									134.18828125000005,
									-1.2031249999999147
								],
								[
									134.2471679687502,
									-1.3105468749999432
								],
								[
									134.25957031250016,
									-1.3629882812499687
								],
								[
									134.23720703125014,
									-1.4741210937499574
								],
								[
									134.21699218750018,
									-1.5291015625000597
								],
								[
									134.14541015624997,
									-1.620800781249912
								],
								[
									134.10585937500002,
									-1.7209960937499034
								],
								[
									134.13125000000014,
									-1.844531250000017
								],
								[
									134.14541015624997,
									-1.968749999999929
								],
								[
									134.14277343750018,
									-2.082910156249909
								],
								[
									134.15566406250014,
									-2.195214843750051
								],
								[
									134.1948242187501,
									-2.3090820312498863
								],
								[
									134.362109375,
									-2.6209960937499375
								],
								[
									134.45996093749994,
									-2.8323242187499034
								],
								[
									134.4912109375001,
									-2.7142578124999233
								],
								[
									134.48330078125002,
									-2.5830078124999147
								],
								[
									134.51796875000014,
									-2.5356445312499574
								],
								[
									134.56689453125,
									-2.5104492187499687
								],
								[
									134.62744140624994,
									-2.5367187499999915
								],
								[
									134.6447265625,
									-2.5898437499998863
								],
								[
									134.6490234375002,
									-2.7058593749999886
								],
								[
									134.7021484375,
									-2.933593749999929
								],
								[
									134.76982421875,
									-2.944042968749926
								],
								[
									134.8433593750001,
									-2.909179687499929
								],
								[
									134.85537109375014,
									-2.9788085937499034
								],
								[
									134.852734375,
									-3.1076171874999545
								],
								[
									134.88681640625003,
									-3.2098632812499943
								],
								[
									134.9171875,
									-3.24990234374998
								],
								[
									135.03740234375,
									-3.333105468749963
								],
								[
									135.09218750000014,
									-3.348535156249909
								],
								[
									135.2515625000002,
									-3.3685546874999943
								],
								[
									135.37158203124994,
									-3.3749023437499517
								],
								[
									135.48662109375005,
									-3.3451171874999233
								],
								[
									135.5607421875,
									-3.268749999999912
								],
								[
									135.627734375,
									-3.186035156249943
								],
								[
									135.8591796875,
									-2.995312499999983
								],
								[
									135.92617187500014,
									-2.90410156249996
								],
								[
									135.99072265624994,
									-2.764257812499892
								],
								[
									136.01298828125016,
									-2.7342773437499233
								],
								[
									136.2432617187501,
									-2.5831054687499346
								],
								[
									136.2695312500001,
									-2.5294921874999403
								],
								[
									136.30253906250016,
									-2.4256835937499375
								],
								[
									136.35244140625014,
									-2.3251953124999716
								],
								[
									136.38994140625005,
									-2.27333984374998
								],
								[
									136.61230468749994,
									-2.2243164062499403
								],
								[
									136.8432617187501,
									-2.1976562499999233
								],
								[
									137.0720703125,
									-2.105078124999892
								],
								[
									137.17109375000018,
									-2.0254882812499346
								],
								[
									137.17578125,
									-1.973144531249929
								],
								[
									137.12548828124994,
									-1.881250000000037
								],
								[
									137.12343749999997,
									-1.8409179687499915
								],
								[
									137.17646484375,
									-1.802148437499909
								],
								[
									137.38056640625007,
									-1.6856445312499773
								],
								[
									137.61660156250002,
									-1.565820312499909
								],
								[
									137.8062500000002,
									-1.483203124999946
								],
								[
									137.91113281249994,
									-1.4837890625000654
								],
								[
									138.0078125000001,
									-1.556542968749966
								],
								[
									138.1109375000001,
									-1.615917968749983
								],
								[
									138.64980468749997,
									-1.7911132812499773
								],
								[
									138.7361328125,
									-1.845507812499946
								],
								[
									138.81142578124997,
									-1.917773437500017
								],
								[
									138.91914062500007,
									-1.9678710937499204
								],
								[
									139.03945312499997,
									-1.992089843749966
								],
								[
									139.14882812500014,
									-2.0388671874999034
								],
								[
									139.25263671875007,
									-2.099218750000034
								],
								[
									139.48183593750014,
									-2.211816406249966
								],
								[
									139.7895507812501,
									-2.348242187499963
								],
								[
									139.86835937500018,
									-2.356445312499943
								],
								[
									140.15458984375016,
									-2.349999999999966
								],
								[
									140.20400390624997,
									-2.3756835937499545
								],
								[
									140.25097656249994,
									-2.412011718749895
								],
								[
									140.29462890625018,
									-2.420410156249929
								],
								[
									140.62255859375,
									-2.445800781249943
								],
								[
									140.67304687500018,
									-2.472070312499966
								],
								[
									140.72050781250016,
									-2.508105468749932
								],
								[
									140.74746093750014,
									-2.6071289062499545
								],
								[
									140.97343750000016,
									-2.6097656249999517
								]
							]
						],
						[
							[
								[
									104.4742187500002,
									-0.3346679687499119
								],
								[
									104.56777343750002,
									-0.43183593749998295
								],
								[
									104.59013671875005,
									-0.4666015624999602
								],
								[
									104.54394531250011,
									-0.520507812499929
								],
								[
									104.50654296875007,
									-0.5966796874999005
								],
								[
									104.4853515625,
									-0.6128906249999204
								],
								[
									104.41386718749999,
									-0.5836914062500114
								],
								[
									104.36318359374997,
									-0.6585937499999943
								],
								[
									104.32978515625018,
									-0.5390624999998863
								],
								[
									104.25712890625005,
									-0.4632812499999943
								],
								[
									104.3023437500002,
									-0.38574218749991473
								],
								[
									104.31874999999997,
									-0.380175781249946
								],
								[
									104.34072265625002,
									-0.38261718749990337
								],
								[
									104.36357421875016,
									-0.40283203124994316
								],
								[
									104.4742187500002,
									-0.3346679687499119
								]
							]
						],
						[
							[
								[
									127.56699218750003,
									-0.3189453124999062
								],
								[
									127.68242187500005,
									-0.46835937499996305
								],
								[
									127.60498046875,
									-0.6101562499999034
								],
								[
									127.65859374999997,
									-0.6894531249999716
								],
								[
									127.80429687500009,
									-0.6944335937499204
								],
								[
									127.83789062500011,
									-0.724121093749929
								],
								[
									127.86328125000011,
									-0.7598632812500199
								],
								[
									127.88017578124999,
									-0.8086914062500199
								],
								[
									127.84228515625011,
									-0.847753906249892
								],
								[
									127.76113281249997,
									-0.8836914062500227
								],
								[
									127.6675781250002,
									-0.8320312499998863
								],
								[
									127.64287109375016,
									-0.7839843749999602
								],
								[
									127.62382812499999,
									-0.7660156249999375
								],
								[
									127.49785156249999,
									-0.8024414062498977
								],
								[
									127.46269531250005,
									-0.8059570312499034
								],
								[
									127.43828125000005,
									-0.7390625000000455
								],
								[
									127.46865234375002,
									-0.6429687500000085
								],
								[
									127.38056640625018,
									-0.5996093750000568
								],
								[
									127.30000000000001,
									-0.5002929687499034
								],
								[
									127.29707031250007,
									-0.4602539062499176
								],
								[
									127.32949218749997,
									-0.39091796874990337
								],
								[
									127.32509765624997,
									-0.3358398437499659
								],
								[
									127.37119140625003,
									-0.3316406249999062
								],
								[
									127.4551757812502,
									-0.40634765624994884
								],
								[
									127.49169921875,
									-0.3359374999999858
								],
								[
									127.52734374999994,
									-0.30664062500005684
								],
								[
									127.56699218750003,
									-0.3189453124999062
								]
							]
						],
						[
							[
								[
									127.24990234375014,
									-0.4953124999999545
								],
								[
									127.18730468750016,
									-0.5211914062500682
								],
								[
									127.11914062500011,
									-0.520507812499929
								],
								[
									127.10439453125014,
									-0.4138671874999602
								],
								[
									127.12646484375011,
									-0.27861328125003126
								],
								[
									127.18964843750018,
									-0.2557617187499943
								],
								[
									127.29003906250011,
									-0.28437499999996874
								],
								[
									127.25302734375003,
									-0.31865234375001705
								],
								[
									127.28056640625016,
									-0.39101562499992326
								],
								[
									127.24990234375014,
									-0.4953124999999545
								]
							]
						],
						[
							[
								[
									103.73652343750001,
									-0.347949218749946
								],
								[
									103.60634765624997,
									-0.38291015624996305
								],
								[
									103.46132812500002,
									-0.35761718749996874
								],
								[
									103.47900390624994,
									-0.29746093749996305
								],
								[
									103.54892578125009,
									-0.22753906249992895
								],
								[
									103.6109375000002,
									-0.23056640624992042
								],
								[
									103.72392578125005,
									-0.27666015624998863
								],
								[
									103.76425781250009,
									-0.31777343749992326
								],
								[
									103.73652343750001,
									-0.347949218749946
								]
							]
						],
						[
							[
								[
									130.81328125000016,
									-0.004101562499968736
								],
								[
									130.9865234375,
									-0.04658203125001137
								],
								[
									131.02578125000014,
									-0.03994140624990905
								],
								[
									131.2768554687501,
									-0.14980468749990905
								],
								[
									131.3168945312501,
									-0.20429687499989768
								],
								[
									131.30273437499994,
									-0.24111328124993747
								],
								[
									131.33974609375014,
									-0.2903320312499318
								],
								[
									131.25751953125018,
									-0.3657226562500142
								],
								[
									131.2178710937501,
									-0.37412109374994884
								],
								[
									131.177734375,
									-0.34599609374990337
								],
								[
									131.0977539062502,
									-0.33007812499994316
								],
								[
									131.00537109374994,
									-0.36074218750006537
								],
								[
									130.946484375,
									-0.33759765624996874
								],
								[
									130.89667968750018,
									-0.26845703124992326
								],
								[
									130.80839843750016,
									-0.22646484375006537
								],
								[
									130.68349609375002,
									-0.08066406249993463
								],
								[
									130.62216796875003,
									-0.08593749999994316
								],
								[
									130.63828125000003,
									-0.14296874999993747
								],
								[
									130.69130859375002,
									-0.18056640624995168
								],
								[
									130.76132812500003,
									-0.2914062499999801
								],
								[
									130.8015625,
									-0.30214843749993747
								],
								[
									130.84316406250014,
									-0.2983398437499716
								],
								[
									130.89921875,
									-0.3444335937499403
								],
								[
									130.89628906250005,
									-0.41601562499995737
								],
								[
									130.75019531250018,
									-0.44384765624994316
								],
								[
									130.69980468750003,
									-0.39160156249995737
								],
								[
									130.68867187500018,
									-0.29658203124996874
								],
								[
									130.60654296875003,
									-0.32861328124991473
								],
								[
									130.57490234375018,
									-0.36181640624992895
								],
								[
									130.55078125,
									-0.36640624999998295
								],
								[
									130.49628906250007,
									-0.2673828124999602
								],
								[
									130.34052734375,
									-0.2623046874999062
								],
								[
									130.23662109375,
									-0.2096679687499261
								],
								[
									130.2876953125002,
									-0.15468750000000853
								],
								[
									130.294921875,
									-0.10146484374990905
								],
								[
									130.36250000000018,
									-0.0728515625000341
								],
								[
									130.43095703125016,
									-0.09848632812493463
								],
								[
									130.4996093750002,
									-0.06010742187493179
								],
								[
									130.5483398437501,
									-0.06992187499997726
								],
								[
									130.58427734375016,
									-0.04541015624995737
								],
								[
									130.72236328125,
									-0.02983398437497442
								],
								[
									130.81328125000016,
									-0.004101562499968736
								]
							]
						],
						[
							[
								[
									98.45927734375016,
									-0.5304687499999119
								],
								[
									98.39970703125016,
									-0.5768554687500398
								],
								[
									98.3096679687502,
									-0.5318359374999346
								],
								[
									98.33994140625009,
									-0.46787109374994884
								],
								[
									98.35478515625016,
									-0.37929687499993747
								],
								[
									98.40878906250009,
									-0.30898437499990905
								],
								[
									98.42714843749997,
									-0.22646484375006537
								],
								[
									98.32294921875018,
									-0.000781249999917577
								],
								[
									98.37451171875011,
									0.007080078125085265
								],
								[
									98.41542968750002,
									-0.017529296874954525
								],
								[
									98.48437500000011,
									-0.16767578124989768
								],
								[
									98.54414062500001,
									-0.25761718750001705
								],
								[
									98.5201171875002,
									-0.37968750000001705
								],
								[
									98.45927734375016,
									-0.5304687499999119
								]
							]
						],
						[
							[
								[
									104.77861328125016,
									-0.1759765624999119
								],
								[
									104.80751953124997,
									-0.19248046874997726
								],
								[
									104.84316406250014,
									-0.1406249999999858
								],
								[
									104.90898437500016,
									-0.21171874999990337
								],
								[
									104.94970703125011,
									-0.2472656250000398
								],
								[
									105.00537109375,
									-0.2828124999999062
								],
								[
									104.95058593750002,
									-0.28447265624988916
								],
								[
									104.92851562500005,
									-0.3169921875000341
								],
								[
									104.91425781250007,
									-0.3233398437499062
								],
								[
									104.7022460937502,
									-0.20869140624999716
								],
								[
									104.56660156250001,
									-0.24560546875005684
								],
								[
									104.47353515624997,
									-0.21210937499998295
								],
								[
									104.44707031249999,
									-0.1891601562499261
								],
								[
									104.4970703125,
									-0.12636718749992326
								],
								[
									104.54267578125001,
									0.017724609375036948
								],
								[
									104.63564453125014,
									-0.018457031249965894
								],
								[
									104.65839843750018,
									-0.06284179687494884
								],
								[
									104.65273437499997,
									-0.07602539062497726
								],
								[
									104.7134765625002,
									-0.10302734374997158
								],
								[
									104.77861328125016,
									-0.1759765624999119
								]
							]
						],
						[
							[
								[
									129.54892578125003,
									-0.18701171874992895
								],
								[
									129.50566406250005,
									-0.18984375000006537
								],
								[
									129.46923828125,
									-0.13144531249997726
								],
								[
									129.37011718749994,
									-0.06640624999997158
								],
								[
									129.30878906250018,
									0.045410156250071054
								],
								[
									129.5419921875,
									-0.13925781250006253
								],
								[
									129.54892578125003,
									-0.18701171874992895
								]
							]
						],
						[
							[
								[
									127.45341796874999,
									-0.005859374999971578
								],
								[
									127.44863281250002,
									-0.03662109374994316
								],
								[
									127.41787109375014,
									0.006347656250028422
								],
								[
									127.39677734374999,
									0.016601562500071054
								],
								[
									127.4195312500002,
									0.12441406250000853
								],
								[
									127.43134765625007,
									0.14257812500007105
								],
								[
									127.44941406250018,
									0.06899414062507958
								],
								[
									127.45341796874999,
									-0.005859374999971578
								]
							]
						],
						[
							[
								[
									104.68925781250016,
									0.05952148437502558
								],
								[
									104.69814453125002,
									0.03466796875011369
								],
								[
									104.65087890624994,
									0.06269531250003979
								],
								[
									104.62236328124999,
									0.079638671874946
								],
								[
									104.603515625,
									0.09521484375009948
								],
								[
									104.49921875000007,
									0.2320800781250938
								],
								[
									104.54384765625002,
									0.22329101562507958
								],
								[
									104.65986328125001,
									0.10307617187501705
								],
								[
									104.68925781250016,
									0.05952148437502558
								]
							]
						],
						[
							[
								[
									103.28447265625005,
									0.541943359374983
								],
								[
									103.17216796875016,
									0.5361816406250455
								],
								[
									103.13955078125002,
									0.5490722656250142
								],
								[
									103.15332031249994,
									0.6431152343749886
								],
								[
									103.18740234374997,
									0.6997558593750739
								],
								[
									103.23818359375002,
									0.6986328125000227
								],
								[
									103.29511718750018,
									0.6139648437500824
								],
								[
									103.28447265625005,
									0.541943359374983
								]
							]
						],
						[
							[
								[
									127.41972656250016,
									0.6420898437499574
								],
								[
									127.38398437500018,
									0.6310058593750085
								],
								[
									127.3736328125002,
									0.6348632812500767
								],
								[
									127.36289062500003,
									0.6751464843750341
								],
								[
									127.38261718750016,
									0.7435546875000227
								],
								[
									127.42480468749994,
									0.7443847656250142
								],
								[
									127.44257812500001,
									0.7334472656250881
								],
								[
									127.44589843750009,
									0.6833007812500966
								],
								[
									127.41972656250016,
									0.6420898437499574
								]
							]
						],
						[
							[
								[
									127.37265625000009,
									0.7913085937500739
								],
								[
									127.33837890625011,
									0.758447265625037
								],
								[
									127.30605468750002,
									0.7694335937499659
								],
								[
									127.28642578124999,
									0.8119140625000938
								],
								[
									127.29277343750016,
									0.8424804687500966
								],
								[
									127.31982421874994,
									0.8620117187499972
								],
								[
									127.35380859375016,
									0.8474609375000455
								],
								[
									127.37265625000009,
									0.7913085937500739
								]
							]
						],
						[
							[
								[
									103.45019531249994,
									0.6644531250000654
								],
								[
									103.42968749999994,
									0.6508789062499716
								],
								[
									103.34443359375018,
									0.7778808593750881
								],
								[
									103.36572265625,
									0.8511230468750881
								],
								[
									103.38613281250014,
									0.8695800781249403
								],
								[
									103.43310546875011,
									0.8250000000000881
								],
								[
									103.47031250000003,
									0.7781249999999602
								],
								[
									103.49746093749997,
									0.7227050781250313
								],
								[
									103.45019531249994,
									0.6644531250000654
								]
							]
						],
						[
							[
								[
									103.82861328124994,
									0.8010253906250995
								],
								[
									103.833984375,
									0.772216796875
								],
								[
									103.74238281250007,
									0.829980468750037
								],
								[
									103.74003906250005,
									0.8718261718750426
								],
								[
									103.75195312499994,
									0.8913574218750284
								],
								[
									103.80664062500011,
									0.8463378906250938
								],
								[
									103.82861328124994,
									0.8010253906250995
								]
							]
						],
						[
							[
								[
									104.23935546875003,
									0.8339843749999716
								],
								[
									104.17675781250011,
									0.8048828125000824
								],
								[
									104.09814453125,
									0.8962402343750426
								],
								[
									104.10107421874994,
									0.9174804687500995
								],
								[
									104.10830078125002,
									0.9335449218750966
								],
								[
									104.12275390625001,
									0.9439941406250938
								],
								[
									104.17050781250009,
									0.8967285156250568
								],
								[
									104.22705078124994,
									0.8798828125000853
								],
								[
									104.23935546875003,
									0.8339843749999716
								]
							]
						],
						[
							[
								[
									103.02753906250018,
									0.7466308593750313
								],
								[
									103.00878906250011,
									0.7081054687500767
								],
								[
									102.97148437500005,
									0.7365234375000114
								],
								[
									102.77626953124997,
									0.7795898437500739
								],
								[
									102.71054687500009,
									0.7843750000000824
								],
								[
									102.5416015625002,
									0.831591796875017
								],
								[
									102.49042968750018,
									0.8566406249999687
								],
								[
									102.45390625000005,
									0.889501953125091
								],
								[
									102.46640625000009,
									0.9503417968750512
								],
								[
									102.49140625000001,
									0.9868652343750313
								],
								[
									102.50664062500005,
									1.0887695312500085
								],
								[
									102.54921874999997,
									1.13022460937502
								],
								[
									102.63320312500014,
									1.0543945312500256
								],
								[
									102.72617187500009,
									0.9892089843750682
								],
								[
									102.78007812500005,
									0.9593749999999375
								],
								[
									102.94414062500016,
									0.892724609375037
								],
								[
									103.00244140624994,
									0.8592773437500654
								],
								[
									103.02753906250018,
									0.7466308593750313
								]
							]
						],
						[
							[
								[
									103.4239257812502,
									1.0483398437499432
								],
								[
									103.42968749999994,
									0.9933593750000256
								],
								[
									103.36328125000011,
									1.0068359375000142
								],
								[
									103.31542968750011,
									1.0712890625
								],
								[
									103.35498046875011,
									1.117236328124946
								],
								[
									103.37998046875003,
									1.133642578125091
								],
								[
									103.40488281250003,
									1.072558593750074
								],
								[
									103.4239257812502,
									1.0483398437499432
								]
							]
						],
						[
							[
								[
									103.16640625000014,
									0.8701660156250597
								],
								[
									103.13720703124994,
									0.8416503906249346
								],
								[
									103.08671875000016,
									0.8481445312500142
								],
								[
									103.03339843750007,
									0.8820312500000824
								],
								[
									102.9639648437502,
									0.9426757812500881
								],
								[
									102.8863281250002,
									0.9967773437500966
								],
								[
									102.78798828125014,
									1.0309570312499545
								],
								[
									102.72646484375014,
									1.0412597656250995
								],
								[
									102.70185546875018,
									1.0537109374999716
								],
								[
									102.72558593749994,
									1.1588378906250654
								],
								[
									102.79013671875003,
									1.1654785156250966
								],
								[
									102.99941406250014,
									1.0677734374999943
								],
								[
									103.06757812500018,
									1.01474609375002
								],
								[
									103.16640625000014,
									0.8701660156250597
								]
							]
						],
						[
							[
								[
									104.02480468750014,
									1.1805664062500512
								],
								[
									104.08808593750007,
									1.1370117187500597
								],
								[
									104.13984375000001,
									1.165576171875017
								],
								[
									104.13779296875003,
									1.1282226562500455
								],
								[
									104.12734374999997,
									1.092382812500034
								],
								[
									104.06611328125001,
									0.9895507812500455
								],
								[
									103.96357421875018,
									1.013232421875074
								],
								[
									103.93984375000014,
									1.046484375000091
								],
								[
									103.9322265625002,
									1.07138671875002
								],
								[
									103.94697265625018,
									1.0870117187500057
								],
								[
									103.95537109375005,
									1.137451171875071
								],
								[
									103.99980468749999,
									1.1372558593750313
								],
								[
									104.02480468750014,
									1.1805664062500512
								]
							]
						],
						[
							[
								[
									104.58535156250014,
									1.216113281250017
								],
								[
									104.59101562500001,
									1.1410644531250966
								],
								[
									104.64814453125001,
									1.104589843750034
								],
								[
									104.66289062499999,
									1.0495117187500966
								],
								[
									104.65283203125011,
									0.961035156250091
								],
								[
									104.59912109375,
									0.858984375000091
								],
								[
									104.57519531250011,
									0.8319335937500796
								],
								[
									104.50429687500014,
									0.8526367187500341
								],
								[
									104.48066406250018,
									0.8867675781250597
								],
								[
									104.47119140624994,
									0.9134765625000938
								],
								[
									104.4810546875002,
									0.9325195312500654
								],
								[
									104.42861328124997,
									0.956494140625054
								],
								[
									104.46240234375011,
									0.9955566406250256
								],
								[
									104.43925781249999,
									1.050439453125108
								],
								[
									104.2939453125,
									1.0161132812500426
								],
								[
									104.25195312499994,
									1.0148925781250568
								],
								[
									104.24423828125009,
									1.077392578125
								],
								[
									104.25019531250007,
									1.1026367187499915
								],
								[
									104.36181640624994,
									1.1814941406250625
								],
								[
									104.42841796875001,
									1.1960449218750142
								],
								[
									104.50009765625009,
									1.1802246093749886
								],
								[
									104.58535156250014,
									1.216113281250017
								]
							]
						],
						[
							[
								[
									102.42714843749997,
									0.9901367187500796
								],
								[
									102.380859375,
									0.959765625000017
								],
								[
									102.3252929687502,
									1.007031250000054
								],
								[
									102.27958984375005,
									1.0756835937500995
								],
								[
									102.2554687500002,
									1.1471679687500966
								],
								[
									102.23417968750005,
									1.263964843750088
								],
								[
									102.22861328125003,
									1.3478515625000256
								],
								[
									102.25634765625011,
									1.3970703124999346
								],
								[
									102.2764648437502,
									1.3952636718750995
								],
								[
									102.35859375000007,
									1.3456542968749403
								],
								[
									102.41289062499999,
									1.2607910156250597
								],
								[
									102.44287109375,
									1.2342285156249773
								],
								[
									102.44882812500003,
									1.156250000000071
								],
								[
									102.42890625000018,
									1.0672851562500654
								],
								[
									102.42714843749997,
									0.9901367187500796
								]
							]
						],
						[
							[
								[
									97.48154296875009,
									1.4650878906250284
								],
								[
									97.6983398437502,
									1.1837402343749943
								],
								[
									97.78642578124999,
									1.1458984375000938
								],
								[
									97.90322265625002,
									1.0182617187500256
								],
								[
									97.93193359374999,
									0.9739257812500597
								],
								[
									97.90205078125001,
									0.8842285156250824
								],
								[
									97.87646484375,
									0.6283203124999943
								],
								[
									97.8204101562502,
									0.5644531250000426
								],
								[
									97.68398437500002,
									0.5960937500000938
								],
								[
									97.68251953124997,
									0.6410644531250966
								],
								[
									97.60390625000014,
									0.8338867187499517
								],
								[
									97.46123046875005,
									0.9414062500000995
								],
								[
									97.4053710937502,
									0.9469726562500682
								],
								[
									97.36884765625001,
									1.056933593750088
								],
								[
									97.29687500000011,
									1.18735351562502
								],
								[
									97.07919921875009,
									1.4254882812500398
								],
								[
									97.24423828125003,
									1.423632812500017
								],
								[
									97.32441406250001,
									1.4816406250000256
								],
								[
									97.34277343749994,
									1.5279296874999488
								],
								[
									97.35595703125,
									1.5397460937500398
								],
								[
									97.48154296875009,
									1.4650878906250284
								]
							]
						],
						[
							[
								[
									102.49189453125001,
									1.4591796875000682
								],
								[
									102.49941406250014,
									1.3309082031250483
								],
								[
									102.42519531250014,
									1.3644531250000398
								],
								[
									102.36689453125007,
									1.4154785156249545
								],
								[
									102.27421874999999,
									1.4531249999999858
								],
								[
									102.16132812500018,
									1.4654296875000057
								],
								[
									102.07871093750003,
									1.4985839843751023
								],
								[
									102.02089843750002,
									1.5582031250000767
								],
								[
									102.01835937500005,
									1.585644531249983
								],
								[
									102.0240234375002,
									1.607958984375088
								],
								[
									102.04218750000018,
									1.6253906250000796
								],
								[
									102.46953124999999,
									1.5100585937500313
								],
								[
									102.49189453125001,
									1.4591796875000682
								]
							]
						],
						[
							[
								[
									124.88886718750007,
									0.9953125000000682
								],
								[
									124.69814453125002,
									0.825585937500037
								],
								[
									124.63984375000001,
									0.7435546875000227
								],
								[
									124.58906250000018,
									0.655273437500071
								],
								[
									124.51406249999997,
									0.5571289062500568
								],
								[
									124.42753906250005,
									0.470605468750108
								],
								[
									124.38437500000003,
									0.44497070312503695
								],
								[
									124.27802734375007,
									0.39843750000005684
								],
								[
									124.21679687500011,
									0.3803710937500995
								],
								[
									124.10136718750005,
									0.37456054687498863
								],
								[
									123.75380859375002,
									0.3055175781250483
								],
								[
									123.63964843750011,
									0.29746093750009095
								],
								[
									123.52597656250003,
									0.3003417968750597
								],
								[
									123.31044921875002,
									0.31757812500009663
								],
								[
									123.26542968750016,
									0.3266113281250824
								],
								[
									123.17949218750016,
									0.4155273437499858
								],
								[
									123.08251953125011,
									0.4858398437500995
								],
								[
									122.99687500000016,
									0.49350585937506253
								],
								[
									122.90957031250014,
									0.4859863281249517
								],
								[
									122.28076171875011,
									0.48105468750010516
								],
								[
									122.06093750000002,
									0.4680175781251137
								],
								[
									121.84199218750018,
									0.4365722656251023
								],
								[
									121.7227539062502,
									0.4508789062500824
								],
								[
									121.6045898437502,
									0.4861328125000739
								],
								[
									121.51572265625003,
									0.4984375000000938
								],
								[
									121.42578125000011,
									0.4948242187500682
								],
								[
									121.01298828125005,
									0.44169921874998863
								],
								[
									120.90917968750011,
									0.44677734374995737
								],
								[
									120.70039062500001,
									0.5146972656250313
								],
								[
									120.57900390624997,
									0.5283203125000426
								],
								[
									120.4599609375,
									0.5103027343749318
								],
								[
									120.34902343750014,
									0.4492187500000995
								],
								[
									120.30703125000002,
									0.40825195312501705
								],
								[
									120.19228515624997,
									0.268505859375054
								],
								[
									120.12734374999997,
									0.16655273437505969
								],
								[
									120.07832031250001,
									0.03974609375008242
								],
								[
									120.03603515625014,
									-0.08994140624996305
								],
								[
									120.0132812500002,
									-0.19619140624993747
								],
								[
									120.01210937500014,
									-0.3071289062498863
								],
								[
									120.03173828124994,
									-0.43203125000002274
								],
								[
									120.06289062500002,
									-0.5555664062499659
								],
								[
									120.09746093750005,
									-0.64990234375
								],
								[
									120.24062499999997,
									-0.8682617187499062
								],
								[
									120.26982421875016,
									-0.8992187499999886
								],
								[
									120.42539062500003,
									-0.9606445312500682
								],
								[
									120.517578125,
									-1.039453124999966
								],
								[
									120.60507812500003,
									-1.2584960937499972
								],
								[
									120.66738281250014,
									-1.3701171875
								],
								[
									120.7286132812502,
									-1.3714843749999233
								],
								[
									120.79697265625009,
									-1.3636718749999375
								],
								[
									120.91582031250005,
									-1.37783203124998
								],
								[
									121.03369140625,
									-1.4065429687499602
								],
								[
									121.1485351562502,
									-1.3394531249999773
								],
								[
									121.21259765625001,
									-1.2124999999999488
								],
								[
									121.27685546874994,
									-1.1181640624999147
								],
								[
									121.43134765625018,
									-0.9385742187499204
								],
								[
									121.51933593750016,
									-0.8555664062499773
								],
								[
									121.57558593749997,
									-0.8285156249999801
								],
								[
									121.63271484374997,
									-0.8403320312499005
								],
								[
									121.68115234375,
									-0.8878906249998977
								],
								[
									121.73769531250014,
									-0.9256835937500512
								],
								[
									121.8531250000002,
									-0.9459960937499261
								],
								[
									121.96962890625014,
									-0.9333007812499119
								],
								[
									122.09365234375002,
									-0.8750000000000284
								],
								[
									122.13808593750002,
									-0.8392578124999375
								],
								[
									122.17490234375003,
									-0.7937499999999034
								],
								[
									122.27998046875007,
									-0.757031249999983
								],
								[
									122.52968750000014,
									-0.7566406249999034
								],
								[
									122.6587890625002,
									-0.7698242187499176
								],
								[
									122.88876953125009,
									-0.7551757812499602
								],
								[
									122.88554687500016,
									-0.7220703124999659
								],
								[
									122.84111328125016,
									-0.687011718749929
								],
								[
									122.82949218749997,
									-0.658886718750054
								],
								[
									122.87226562500018,
									-0.6407226562499062
								],
								[
									123.02041015624997,
									-0.5998046874999261
								],
								[
									123.1714843750002,
									-0.5707031249999375
								],
								[
									123.28144531250007,
									-0.5915039062499119
								],
								[
									123.37968749999999,
									-0.6485351562499062
								],
								[
									123.41738281250014,
									-0.7074218749999943
								],
								[
									123.43417968750009,
									-0.7782226562499375
								],
								[
									123.39628906249999,
									-0.9616210937499119
								],
								[
									123.3779296875,
									-1.0041015625000398
								],
								[
									123.29960937500005,
									-1.026074218749983
								],
								[
									123.22578125000018,
									-1.0017578124999176
								],
								[
									123.15273437500014,
									-0.9070312499998892
								],
								[
									123.0494140625002,
									-0.8723632812499318
								],
								[
									122.90283203125011,
									-0.9009765624999915
								],
								[
									122.8525390625,
									-0.9281249999999233
								],
								[
									122.80742187500005,
									-0.9660156249999261
								],
								[
									122.72460937500011,
									-1.064257812499946
								],
								[
									122.65566406250002,
									-1.175195312499909
								],
								[
									122.50664062500005,
									-1.347851562499912
								],
								[
									122.33417968750018,
									-1.4978515624999176
								],
								[
									122.25068359375001,
									-1.5552734375000625
								],
								[
									122.15761718749997,
									-1.5939453124999545
								],
								[
									121.85859375000018,
									-1.6932617187499375
								],
								[
									121.7798828125002,
									-1.7669921874999375
								],
								[
									121.71875000000011,
									-1.8627929687499147
								],
								[
									121.65097656250003,
									-1.895410156249909
								],
								[
									121.57265625000002,
									-1.9057617187500568
								],
								[
									121.51386718750001,
									-1.8877929687499488
								],
								[
									121.39472656250018,
									-1.8337890624999602
								],
								[
									121.35546875,
									-1.8782226562499602
								],
								[
									121.34882812500007,
									-1.945996093749912
								],
								[
									121.40751953125005,
									-1.9701171875000227
								],
								[
									121.501953125,
									-2.0450195312500057
								],
								[
									121.57500000000005,
									-2.1508789062499005
								],
								[
									121.62187499999999,
									-2.1736328124999176
								],
								[
									121.72597656249997,
									-2.2080078124999005
								],
								[
									121.76972656250018,
									-2.2409179687499545
								],
								[
									121.8482421875002,
									-2.331542968749943
								],
								[
									121.97187500000018,
									-2.542382812499909
								],
								[
									122.01396484375005,
									-2.6564453124999545
								],
								[
									122.08261718750009,
									-2.74951171875
								],
								[
									122.29169921875001,
									-2.907617187499966
								],
								[
									122.3033203125002,
									-2.9522460937499204
								],
								[
									122.29042968750014,
									-3.004199218750017
								],
								[
									122.30654296875014,
									-3.0515624999999034
								],
								[
									122.38124999999997,
									-3.142382812499932
								],
								[
									122.39902343750003,
									-3.2008789062499403
								],
								[
									122.31728515625002,
									-3.2750976562499687
								],
								[
									122.31279296875016,
									-3.382714843750037
								],
								[
									122.2626953125,
									-3.527441406250034
								],
								[
									122.25136718749997,
									-3.576269531250034
								],
								[
									122.25292968749994,
									-3.6204101562499744
								],
								[
									122.28808593750011,
									-3.661621093750014
								],
								[
									122.32910156250011,
									-3.694238281249909
								],
								[
									122.3853515625002,
									-3.711425781249943
								],
								[
									122.43457031250011,
									-3.739843749999963
								],
								[
									122.52919921875002,
									-3.8526367187499346
								],
								[
									122.57861328124994,
									-3.882324218749943
								],
								[
									122.6099609375002,
									-3.9234375000000625
								],
								[
									122.60673828124999,
									-3.984667968749932
								],
								[
									122.64990234375011,
									-4.020507812499943
								],
								[
									122.68964843750001,
									-4.084472656249915
								],
								[
									122.75039062500014,
									-4.09999999999998
								],
								[
									122.77880859374994,
									-4.081640624999963
								],
								[
									122.79824218750014,
									-4.054199218750057
								],
								[
									122.84794921875005,
									-4.064550781250034
								],
								[
									122.87734374999997,
									-4.1090820312499545
								],
								[
									122.89433593750016,
									-4.166308593749889
								],
								[
									122.89980468750002,
									-4.229394531249952
								],
								[
									122.89736328125014,
									-4.349121093749929
								],
								[
									122.87226562500018,
									-4.391992187499952
								],
								[
									122.81757812500007,
									-4.389941406249974
								],
								[
									122.71972656250011,
									-4.340722656249895
								],
								[
									122.71503906250001,
									-4.376269531249946
								],
								[
									122.72167968749994,
									-4.410742187499949
								],
								[
									122.67187499999994,
									-4.42216796875006
								],
								[
									122.61474609375011,
									-4.41738281249998
								],
								[
									122.47138671875007,
									-4.42207031250004
								],
								[
									122.2071289062502,
									-4.496386718749903
								],
								[
									122.11425781250011,
									-4.5402343749999545
								],
								[
									122.05419921874994,
									-4.620117187499972
								],
								[
									122.05000000000018,
									-4.675292968749943
								],
								[
									122.07324218750011,
									-4.791699218750026
								],
								[
									122.03808593749994,
									-4.83242187499998
								],
								[
									121.9169921875,
									-4.847949218749946
								],
								[
									121.74804687500011,
									-4.816699218749974
								],
								[
									121.64570312500007,
									-4.785644531249943
								],
								[
									121.58867187500016,
									-4.75957031249996
								],
								[
									121.51435546875001,
									-4.681249999999906
								],
								[
									121.48652343750007,
									-4.581054687499929
								],
								[
									121.54121093750018,
									-4.28291015624994
								],
								[
									121.55673828125003,
									-4.244628906249957
								],
								[
									121.58339843749997,
									-4.210546874999935
								],
								[
									121.61152343750001,
									-4.156347656249906
								],
								[
									121.61806640625002,
									-4.092675781249909
								],
								[
									121.53740234374999,
									-4.01484374999994
								],
								[
									121.41582031250005,
									-3.9842773437500227
								],
								[
									121.31269531250018,
									-3.9194335937499574
								],
								[
									120.91425781250018,
									-3.555761718749949
								],
								[
									120.89179687500001,
									-3.5206054687500625
								],
								[
									120.89091796875005,
									-3.4603515624999517
								],
								[
									120.90693359375018,
									-3.4040039062499403
								],
								[
									121.03789062500005,
									-3.2051757812499346
								],
								[
									121.0542968750002,
									-3.167089843749892
								],
								[
									121.0703125,
									-3.010156249999895
								],
								[
									121.06679687499997,
									-2.880957031249963
								],
								[
									121.05214843750002,
									-2.751660156249912
								],
								[
									120.99013671874997,
									-2.6703124999999375
								],
								[
									120.87939453125,
									-2.6456054687499773
								],
								[
									120.76503906250014,
									-2.6416015625000426
								],
								[
									120.65361328124999,
									-2.6675781250000057
								],
								[
									120.54394531249994,
									-2.7326171874999403
								],
								[
									120.34140625000009,
									-2.8696289062499574
								],
								[
									120.26103515625016,
									-2.9493164062499346
								],
								[
									120.25410156250007,
									-3.0528320312499773
								],
								[
									120.30048828125018,
									-3.1542968750000426
								],
								[
									120.36044921875003,
									-3.2468749999999034
								],
								[
									120.39238281250016,
									-3.348144531249929
								],
								[
									120.4366210937502,
									-3.7073242187499176
								],
								[
									120.43515625000009,
									-3.7478515624999034
								],
								[
									120.38300781250001,
									-3.8523437499999744
								],
								[
									120.36250000000001,
									-4.085742187499918
								],
								[
									120.38457031250016,
									-4.415136718750048
								],
								[
									120.42011718750001,
									-4.61738281250004
								],
								[
									120.40498046875007,
									-4.72724609375004
								],
								[
									120.3101562500002,
									-4.963183593749974
								],
								[
									120.28144531250001,
									-5.092675781249966
								],
								[
									120.27929687499994,
									-5.146093749999935
								],
								[
									120.39091796875005,
									-5.392578124999957
								],
								[
									120.4166015625002,
									-5.490039062499918
								],
								[
									120.43037109375018,
									-5.591015624999983
								],
								[
									120.31162109375003,
									-5.541601562500034
								],
								[
									120.25644531250009,
									-5.544140624999926
								],
								[
									120.2007812500002,
									-5.559374999999932
								],
								[
									120.07705078125014,
									-5.575488281249918
								],
								[
									119.95156249999997,
									-5.577636718749915
								],
								[
									119.90761718749997,
									-5.596289062499892
								],
								[
									119.8184570312502,
									-5.661816406250011
								],
								[
									119.76445312500005,
									-5.688281249999903
								],
								[
									119.71728515625011,
									-5.693359375000043
								],
								[
									119.55742187500016,
									-5.611035156249969
								],
								[
									119.46308593750001,
									-5.521679687499969
								],
								[
									119.37617187500018,
									-5.424804687500043
								],
								[
									119.36035156249994,
									-5.314160156249969
								],
								[
									119.39062500000011,
									-5.200585937499923
								],
								[
									119.43359374999994,
									-5.079199218749977
								],
								[
									119.51953124999994,
									-4.877343750000065
								],
								[
									119.51552734375014,
									-4.741894531249912
								],
								[
									119.544921875,
									-4.630859374999943
								],
								[
									119.59404296875016,
									-4.523144531250026
								],
								[
									119.61171875000002,
									-4.423535156249983
								],
								[
									119.62363281250003,
									-4.034374999999926
								],
								[
									119.61142578125003,
									-3.9998046874999886
								],
								[
									119.49365234375011,
									-3.7685546874999574
								],
								[
									119.4800781250002,
									-3.7297851562500455
								],
								[
									119.47929687500005,
									-3.6673828124999517
								],
								[
									119.49199218750016,
									-3.6078125000000654
								],
								[
									119.49453125000014,
									-3.554101562499966
								],
								[
									119.46748046875001,
									-3.512988281249932
								],
								[
									119.41982421875002,
									-3.4753906249999176
								],
								[
									119.36210937500016,
									-3.458984374999943
								],
								[
									119.24003906250016,
									-3.475292968750068
								],
								[
									118.99462890624994,
									-3.5375976562499716
								],
								[
									118.92216796875005,
									-3.482714843749889
								],
								[
									118.86767578124994,
									-3.398046874999963
								],
								[
									118.83281250000016,
									-3.2801757812499375
								],
								[
									118.8125,
									-3.156640624999895
								],
								[
									118.82187500000003,
									-3.0406249999999773
								],
								[
									118.85810546875007,
									-2.92851562499996
								],
								[
									118.82890625000016,
									-2.8500976562499716
								],
								[
									118.78369140625,
									-2.764746093749906
								],
								[
									118.78330078125009,
									-2.7208007812499204
								],
								[
									118.80898437499997,
									-2.6823242187498977
								],
								[
									118.85332031250016,
									-2.650195312500017
								],
								[
									118.90751953125016,
									-2.6314453124999346
								],
								[
									118.95820312500018,
									-2.597460937499932
								],
								[
									119.09218750000014,
									-2.4829101562500426
								],
								[
									119.13535156250003,
									-2.3823242187498863
								],
								[
									119.13818359375,
									-2.258496093749983
								],
								[
									119.17226562500002,
									-2.140039062499909
								],
								[
									119.2408203125002,
									-2.030957031249983
								],
								[
									119.3218750000002,
									-1.9296874999999574
								],
								[
									119.34824218750009,
									-1.8252929687500057
								],
								[
									119.30830078125001,
									-1.6596679687500142
								],
								[
									119.32412109375014,
									-1.5842773437499318
								],
								[
									119.31035156250016,
									-1.4957031250000057
								],
								[
									119.30898437499997,
									-1.4082031249999432
								],
								[
									119.35917968750016,
									-1.2434570312499602
								],
								[
									119.50820312499997,
									-0.906738281249929
								],
								[
									119.65351562500018,
									-0.727929687499909
								],
								[
									119.71132812500014,
									-0.6807617187499773
								],
								[
									119.78671875000003,
									-0.7639648437499744
								],
								[
									119.84433593750003,
									-0.8619140624999346
								],
								[
									119.84521484375,
									-0.7732421874999034
								],
								[
									119.82988281250016,
									-0.6863281249999602
								],
								[
									119.77167968750018,
									-0.4835937499999545
								],
								[
									119.72187500000018,
									-0.0884765625000199
								],
								[
									119.73583984375,
									-0.05102539062502842
								],
								[
									119.78652343750002,
									-0.05698242187490621
								],
								[
									119.83828124999997,
									-0.02211914062490905
								],
								[
									119.86562500000014,
									0.040087890625059686
								],
								[
									119.81171875000018,
									0.18691406249995168
								],
								[
									119.80927734375001,
									0.238671875000108
								],
								[
									119.91328125000018,
									0.44506835937505684
								],
								[
									119.99804687500011,
									0.5202148437499972
								],
								[
									120.03515624999994,
									0.5666015625000256
								],
								[
									120.05644531250005,
									0.6925292968750227
								],
								[
									120.10058593749994,
									0.740136718750037
								],
								[
									120.15654296875016,
									0.7741699218750426
								],
								[
									120.22978515625016,
									0.861230468750108
								],
								[
									120.26953125000011,
									0.9708007812500483
								],
								[
									120.29384765624997,
									0.9791503906250512
								],
								[
									120.32246093750001,
									0.9831542968749858
								],
								[
									120.36650390625005,
									0.8875488281250483
								],
								[
									120.41601562500011,
									0.848681640624946
								],
								[
									120.5166015625,
									0.8175292968749943
								],
								[
									120.6025390625,
									0.854394531250037
								],
								[
									120.62646484375,
									0.9023925781250455
								],
								[
									120.65888671875018,
									0.9436523437499318
								],
								[
									120.71103515625003,
									0.9866699218749915
								],
								[
									120.75488281250011,
									1.0356445312501137
								],
								[
									120.80361328125002,
									1.1492675781250767
								],
								[
									120.86796875000016,
									1.252832031250037
								],
								[
									120.912109375,
									1.2889648437499375
								],
								[
									120.9654296875002,
									1.3118164062499744
								],
								[
									121.02460937500018,
									1.3257812499999773
								],
								[
									121.08173828125018,
									1.32763671875
								],
								[
									121.20839843750014,
									1.2625000000000455
								],
								[
									121.28173828125,
									1.2498046875000455
								],
								[
									121.35673828125016,
									1.2545410156250227
								],
								[
									121.40410156250005,
									1.2436035156250256
								],
								[
									121.44003906250009,
									1.214404296875017
								],
								[
									121.47275390625009,
									1.1555175781250995
								],
								[
									121.51328125000009,
									1.1047363281250568
								],
								[
									121.55068359374997,
									1.0796874999999346
								],
								[
									121.591796875,
									1.067968750000034
								],
								[
									121.86738281250018,
									1.0885253906250512
								],
								[
									122.10820312500005,
									1.0311523437499943
								],
								[
									122.43662109375009,
									1.0180664062500853
								],
								[
									122.54931640625011,
									0.9844726562500767
								],
								[
									122.65742187500001,
									0.940576171875108
								],
								[
									122.78984374999999,
									0.862890625000091
								],
								[
									122.83828125000002,
									0.8457031250000426
								],
								[
									122.89248046875014,
									0.850000000000037
								],
								[
									122.96005859375003,
									0.9229980468750796
								],
								[
									123.0127929687502,
									0.9389648437500426
								],
								[
									123.06650390625003,
									0.9417968750000796
								],
								[
									123.27812499999999,
									0.9280761718750483
								],
								[
									123.84667968750011,
									0.8381835937500313
								],
								[
									123.93076171875009,
									0.8504394531249488
								],
								[
									124.27363281250001,
									1.0222656249999602
								],
								[
									124.41083984375001,
									1.185107421875088
								],
								[
									124.53369140625,
									1.2304687500000995
								],
								[
									124.57539062500007,
									1.3040527343749915
								],
								[
									124.60019531250003,
									1.3924316406250483
								],
								[
									124.64375000000001,
									1.4161621093750938
								],
								[
									124.74667968750003,
									1.4414062500000853
								],
								[
									124.78769531250003,
									1.467578125000088
								],
								[
									124.86064453124999,
									1.5760253906249773
								],
								[
									124.94707031249999,
									1.672167968750017
								],
								[
									124.9892578125,
									1.701025390625034
								],
								[
									125.1109375000002,
									1.6856933593749375
								],
								[
									125.16484375000016,
									1.6436523437500767
								],
								[
									125.23378906249997,
									1.5022949218750483
								],
								[
									125.22167968750011,
									1.4787109375000398
								],
								[
									125.14091796875016,
									1.4083984375000256
								],
								[
									125.11748046874999,
									1.3789062500000568
								],
								[
									125.02802734375018,
									1.1802246093749886
								],
								[
									124.96679687499994,
									1.082617187500091
								],
								[
									124.88886718750007,
									0.9953125000000682
								]
							]
						],
						[
							[
								[
									101.70810546875003,
									2.0784179687501023
								],
								[
									101.76230468750009,
									1.9965332031250256
								],
								[
									101.77353515625003,
									1.9434570312500483
								],
								[
									101.73408203125018,
									1.882568359375071
								],
								[
									101.71943359375007,
									1.7891601562500483
								],
								[
									101.60273437500018,
									1.715722656250108
								],
								[
									101.50078124999999,
									1.733203125000017
								],
								[
									101.46777343750011,
									1.75937500000002
								],
								[
									101.40341796875003,
									1.9013183593750824
								],
								[
									101.40966796875011,
									2.021679687499997
								],
								[
									101.4502929687502,
									2.067822265624983
								],
								[
									101.54472656250016,
									2.060742187500054
								],
								[
									101.6407226562502,
									2.126708984375071
								],
								[
									101.70810546875003,
									2.0784179687501023
								]
							]
						],
						[
							[
								[
									127.73271484375016,
									0.8481445312500142
								],
								[
									127.80537109375001,
									0.8259277343750995
								],
								[
									127.88105468750018,
									0.8321289062499488
								],
								[
									127.91865234375001,
									0.8768066406249915
								],
								[
									127.92910156250002,
									0.9347167968750654
								],
								[
									127.96728515625,
									1.0425781250001052
								],
								[
									128.05527343750003,
									1.1156250000000654
								],
								[
									128.1169921875,
									1.1270507812499915
								],
								[
									128.16074218750003,
									1.157812500000034
								],
								[
									128.153125,
									1.2378906250001052
								],
								[
									128.15742187500018,
									1.316601562500054
								],
								[
									128.2224609375,
									1.4006347656250426
								],
								[
									128.42412109375016,
									1.517529296875054
								],
								[
									128.53925781250018,
									1.5592285156250227
								],
								[
									128.68837890624997,
									1.572558593750074
								],
								[
									128.7051757812502,
									1.5277343750000796
								],
								[
									128.6880859375002,
									1.4637207031251052
								],
								[
									128.7168945312502,
									1.3672851562500767
								],
								[
									128.70263671874994,
									1.1063964843750398
								],
								[
									128.66875000000016,
									1.0694335937499773
								],
								[
									128.51455078125002,
									0.979248046875071
								],
								[
									128.34599609375005,
									0.9071289062499517
								],
								[
									128.2988281250001,
									0.8768066406249915
								],
								[
									128.25722656249997,
									0.804980468750017
								],
								[
									128.26064453124997,
									0.7337890625000796
								],
								[
									128.39794921874994,
									0.6388183593750938
								],
								[
									128.61123046874997,
									0.549951171875108
								],
								[
									128.6552734375,
									0.5082519531250398
								],
								[
									128.6837890625,
									0.43847656250004263
								],
								[
									128.6916015625,
									0.3603515625000284
								],
								[
									128.74326171875003,
									0.3232421875000142
								],
								[
									128.8154296875001,
									0.30537109375009663
								],
								[
									128.8632812500001,
									0.26835937500001705
								],
								[
									128.899609375,
									0.2162597656250682
								],
								[
									128.54042968750014,
									0.33789062500007105
								],
								[
									128.44648437500018,
									0.3915527343750682
								],
								[
									128.33281250000005,
									0.39794921874995737
								],
								[
									128.22060546874997,
									0.4142578125000824
								],
								[
									128.1060546875002,
									0.4608886718750824
								],
								[
									127.98310546875018,
									0.47187500000009663
								],
								[
									127.92441406250003,
									0.43808593749996305
								],
								[
									127.90136718749994,
									0.372265625000054
								],
								[
									127.88740234375007,
									0.29833984375008527
								],
								[
									127.9146484375002,
									0.20629882812508527
								],
								[
									127.91220703125003,
									0.1505371093750938
								],
								[
									127.88896484374999,
									0.04951171875002558
								],
								[
									127.97783203124999,
									-0.24833984374990337
								],
								[
									128.0894531250002,
									-0.48525390624993747
								],
								[
									128.2535156250002,
									-0.7316406249999545
								],
								[
									128.3345703125002,
									-0.8163085937499801
								],
								[
									128.42548828125018,
									-0.8926757812499062
								],
								[
									128.27812500000016,
									-0.870019531249909
								],
								[
									128.2333984375001,
									-0.7876953125000057
								],
								[
									128.0463867187501,
									-0.7060546874999005
								],
								[
									128.01083984375003,
									-0.6573242187499204
								],
								[
									127.88896484374999,
									-0.4235351562500682
								],
								[
									127.85332031250005,
									-0.37988281250005684
								],
								[
									127.7408203125002,
									-0.30039062499993463
								],
								[
									127.69160156250001,
									-0.24189453125001137
								],
								[
									127.6748046875,
									-0.16289062499990337
								],
								[
									127.68740234374997,
									-0.07993164062496305
								],
								[
									127.68134765625018,
									0.034863281250054
								],
								[
									127.68544921875014,
									0.14902343750004832
								],
								[
									127.70869140625007,
									0.28808593749995737
								],
								[
									127.66865234375018,
									0.3367675781250199
								],
								[
									127.61621093749994,
									0.38291015625009095
								],
								[
									127.55537109375018,
									0.4896484375000796
								],
								[
									127.53710937500011,
									0.6108886718750881
								],
								[
									127.54179687500016,
									0.6806640625
								],
								[
									127.56699218750003,
									0.7425292968749915
								],
								[
									127.60068359375009,
									0.7960449218750512
								],
								[
									127.60800781250003,
									0.8482421875000341
								],
								[
									127.52041015624997,
									0.9240234375001108
								],
								[
									127.42851562499999,
									1.139990234374963
								],
								[
									127.42031250000002,
									1.2519531250000284
								],
								[
									127.53710937500011,
									1.4674804687500682
								],
								[
									127.53466796874994,
									1.5720703125000597
								],
								[
									127.55791015625016,
									1.6342285156250256
								],
								[
									127.57070312500002,
									1.7001464843750398
								],
								[
									127.63173828125002,
									1.8437011718750682
								],
								[
									127.7314453125,
									1.9661132812500455
								],
								[
									127.89990234375011,
									2.1373535156249375
								],
								[
									127.96425781249997,
									2.1747070312500796
								],
								[
									128.03642578125005,
									2.1990234375000597
								],
								[
									128.0427734375,
									2.1570800781250483
								],
								[
									128.03124999999994,
									2.1198730468750995
								],
								[
									127.90673828125,
									1.945654296874963
								],
								[
									127.89013671875,
									1.9062988281250313
								],
								[
									127.8868164062502,
									1.8329589843750966
								],
								[
									127.94648437500018,
									1.7896484374999773
								],
								[
									128.01093750000018,
									1.701220703125074
								],
								[
									128.02373046875005,
									1.583496093750071
								],
								[
									128.0258789062501,
									1.4581054687499346
								],
								[
									128.01171875,
									1.3317382812500398
								],
								[
									127.98769531250014,
									1.2895996093750597
								],
								[
									127.88535156250009,
									1.1627929687500824
								],
								[
									127.65283203124994,
									1.0138671875000256
								],
								[
									127.63300781250018,
									0.977197265625108
								],
								[
									127.6343750000002,
									0.936132812500091
								],
								[
									127.67744140625018,
									0.8865722656250199
								],
								[
									127.73271484375016,
									0.8481445312500142
								]
							]
						],
						[
							[
								[
									97.33417968750018,
									2.075634765625068
								],
								[
									97.32832031250001,
									2.0532714843750313
								],
								[
									97.22509765624994,
									2.158496093750074
								],
								[
									97.10830078124997,
									2.2168945312499773
								],
								[
									97.15664062500014,
									2.232226562500074
								],
								[
									97.25283203125014,
									2.216015625000068
								],
								[
									97.29140624999997,
									2.2008300781250796
								],
								[
									97.3287109375002,
									2.1485351562500767
								],
								[
									97.33417968750018,
									2.075634765625068
								]
							]
						],
						[
							[
								[
									128.45390625,
									2.0517578125000853
								],
								[
									128.29589843749994,
									2.0347167968749886
								],
								[
									128.25996093750018,
									2.0825195312499574
								],
								[
									128.21796875000018,
									2.2974609375000483
								],
								[
									128.33037109375016,
									2.4693359375000625
								],
								[
									128.47207031249997,
									2.570507812500068
								],
								[
									128.56865234375,
									2.596093750000051
								],
								[
									128.6021484375002,
									2.5976074218750824
								],
								[
									128.6884765625001,
									2.4736816406250597
								],
								[
									128.6232421875,
									2.224414062500088
								],
								[
									128.54755859375018,
									2.0970703125000796
								],
								[
									128.45390625,
									2.0517578125000853
								]
							]
						],
						[
							[
								[
									125.40742187500018,
									2.651611328125071
								],
								[
									125.39726562500016,
									2.6295410156250227
								],
								[
									125.36005859375001,
									2.7468261718750284
								],
								[
									125.39082031250018,
									2.805371093750054
								],
								[
									125.43525390625018,
									2.7838867187500256
								],
								[
									125.44648437500007,
									2.7629882812500313
								],
								[
									125.4039062500002,
									2.70703125
								],
								[
									125.40742187500018,
									2.651611328125071
								]
							]
						],
						[
							[
								[
									96.46367187499999,
									2.360009765625094
								],
								[
									96.4009765625002,
									2.3506835937500483
								],
								[
									96.34062500000016,
									2.3720703124999716
								],
								[
									96.29042968749997,
									2.429589843749966
								],
								[
									96.02197265625,
									2.5957519531250597
								],
								[
									95.93847656249994,
									2.598437500000074
								],
								[
									95.87978515624997,
									2.6409179687500313
								],
								[
									95.80859374999994,
									2.6556152343750057
								],
								[
									95.7330078125002,
									2.766503906250037
								],
								[
									95.71718749999997,
									2.825976562500074
								],
								[
									95.77216796875018,
									2.854980468749943
								],
								[
									95.8062500000002,
									2.916015624999943
								],
								[
									95.89580078125016,
									2.889062500000051
								],
								[
									95.99785156250016,
									2.781396484375051
								],
								[
									96.10156249999994,
									2.7412109375000284
								],
								[
									96.12978515625014,
									2.720898437499983
								],
								[
									96.17998046875005,
									2.6613281250000966
								],
								[
									96.41728515625016,
									2.515185546875088
								],
								[
									96.44306640625018,
									2.465625000000017
								],
								[
									96.45937500000014,
									2.415820312500003
								],
								[
									96.46367187499999,
									2.360009765625094
								]
							]
						],
						[
							[
								[
									108.88750000000005,
									2.905419921875094
								],
								[
									108.8388671875,
									2.853027343750071
								],
								[
									108.78652343749997,
									2.8856445312500654
								],
								[
									108.86708984375014,
									2.99189453125004
								],
								[
									108.88574218750011,
									2.9989746093749687
								],
								[
									108.88750000000005,
									2.905419921875094
								]
							]
						],
						[
							[
								[
									105.76035156250003,
									2.863037109374986
								],
								[
									105.71855468750016,
									2.859179687500088
								],
								[
									105.7061523437502,
									2.8888671875000966
								],
								[
									105.70791015625002,
									2.940087890625051
								],
								[
									105.70419921875003,
									2.980908203125111
								],
								[
									105.69218749999999,
									3.011328125000091
								],
								[
									105.69218749999999,
									3.062499999999943
								],
								[
									105.73066406250001,
									3.0369628906250625
								],
								[
									105.76035156250003,
									3.0130371093749915
								],
								[
									105.79453125000009,
									2.9959472656250625
								],
								[
									105.82216796875014,
									2.984375000000014
								],
								[
									105.83671875000016,
									2.9765136718750114
								],
								[
									105.80937500000016,
									2.9039550781250654
								],
								[
									105.76035156250003,
									2.863037109374986
								]
							]
						],
						[
							[
								[
									106.28525390625003,
									3.157128906250037
								],
								[
									106.28369140625,
									3.088232421875034
								],
								[
									106.21455078125001,
									3.1285644531250796
								],
								[
									106.20097656249999,
									3.204882812500088
								],
								[
									106.2237304687502,
									3.2295898437500483
								],
								[
									106.27119140625001,
									3.216308593750014
								],
								[
									106.28525390625003,
									3.157128906250037
								]
							]
						],
						[
							[
								[
									117.65839843750007,
									3.2805175781250426
								],
								[
									117.64580078125016,
									3.2477539062500256
								],
								[
									117.56035156250016,
									3.3282226562500767
								],
								[
									117.53750000000014,
									3.3863769531250227
								],
								[
									117.54785156250011,
									3.4319824218750767
								],
								[
									117.63671875,
									3.436083984375017
								],
								[
									117.68085937500001,
									3.4075195312500597
								],
								[
									117.65839843750007,
									3.2805175781250426
								]
							]
						],
						[
							[
								[
									125.65810546875002,
									3.436035156250014
								],
								[
									125.63320312500002,
									3.4054199218749943
								],
								[
									125.51152343750016,
									3.461132812500068
								],
								[
									125.517578125,
									3.5496093750000597
								],
								[
									125.50117187500018,
									3.593212890625054
								],
								[
									125.46855468750005,
									3.639111328124997
								],
								[
									125.45527343750018,
									3.684179687500034
								],
								[
									125.46884765625009,
									3.7332519531249915
								],
								[
									125.54345703125011,
									3.670410156250071
								],
								[
									125.58564453125018,
									3.571093750000088
								],
								[
									125.6435546875,
									3.4765136718750824
								],
								[
									125.65810546875002,
									3.436035156250014
								]
							]
						],
						[
							[
								[
									126.85185546875005,
									3.768457031250051
								],
								[
									126.83554687500009,
									3.75693359375002
								],
								[
									126.79960937500005,
									3.7838867187500966
								],
								[
									126.77753906250018,
									3.813427734374983
								],
								[
									126.77890625000009,
									3.843164062500094
								],
								[
									126.80449218750016,
									3.857910156249986
								],
								[
									126.8570312500002,
									3.8124023437499517
								],
								[
									126.85781249999997,
									3.7872070312500625
								],
								[
									126.85185546875005,
									3.768457031250051
								]
							]
						],
						[
							[
								[
									126.7193359375002,
									3.8746582031250227
								],
								[
									126.72177734375009,
									3.832519531250057
								],
								[
									126.6612304687502,
									3.928417968750054
								],
								[
									126.63750000000016,
									4.041943359374997
								],
								[
									126.685546875,
									4.001416015625082
								],
								[
									126.73964843749997,
									3.9177246093750853
								],
								[
									126.7193359375002,
									3.8746582031250227
								]
							]
						],
						[
							[
								[
									117.884765625,
									4.1861328125000625
								],
								[
									117.91787109374997,
									4.09052734375004
								],
								[
									117.92285156250011,
									4.05429687500002
								],
								[
									117.73681640624994,
									4.004003906250077
								],
								[
									117.6250976562502,
									4.121484375000037
								],
								[
									117.6490234375002,
									4.168994140624946
								],
								[
									117.74541015625005,
									4.166943359375054
								],
								[
									117.884765625,
									4.1861328125000625
								]
							]
						],
						[
							[
								[
									108.31601562500003,
									3.6896484375000824
								],
								[
									108.17958984375014,
									3.653076171875
								],
								[
									108.10039062499999,
									3.7045410156250966
								],
								[
									108.18613281250003,
									3.767968750000051
								],
								[
									108.2164062500002,
									3.7721679687500966
								],
								[
									108.23613281250005,
									3.784570312499966
								],
								[
									108.24326171875003,
									3.8103515625000597
								],
								[
									108.08847656250003,
									3.8520996093750455
								],
								[
									108.04453125000009,
									3.888964843750088
								],
								[
									108.00234375000002,
									3.98286132812504
								],
								[
									108.00351562500009,
									4.042578124999949
								],
								[
									108.20195312500016,
									4.20048828125006
								],
								[
									108.24833984375005,
									4.217138671875077
								],
								[
									108.25556640625018,
									4.15175781250008
								],
								[
									108.39287109375016,
									3.9861816406250057
								],
								[
									108.39882812500014,
									3.8759765625000284
								],
								[
									108.39355468750011,
									3.836181640625
								],
								[
									108.31601562500003,
									3.6896484375000824
								]
							]
						],
						[
							[
								[
									117.57441406250018,
									4.170605468750097
								],
								[
									117.56621093750005,
									4.162304687500097
								],
								[
									117.49746093750014,
									4.133398437499977
								],
								[
									117.46533203125,
									4.076074218750023
								],
								[
									117.55937500000016,
									3.988330078125088
								],
								[
									117.56601562500009,
									3.9299316406250853
								],
								[
									117.63906250000014,
									3.8779785156249886
								],
								[
									117.72822265625018,
									3.7967285156250483
								],
								[
									117.73173828124999,
									3.770263671875071
								],
								[
									117.76201171875005,
									3.733886718749943
								],
								[
									117.77724609375014,
									3.689257812500088
								],
								[
									117.7144531250002,
									3.644824218750088
								],
								[
									117.62988281250011,
									3.636328124999963
								],
								[
									117.5673828125,
									3.678271484375074
								],
								[
									117.50966796875014,
									3.7303710937499375
								],
								[
									117.49492187500016,
									3.6655761718750597
								],
								[
									117.45039062500007,
									3.6285156250000625
								],
								[
									117.28789062500016,
									3.639306640625037
								],
								[
									117.17158203125018,
									3.6389648437500597
								],
								[
									117.05595703125016,
									3.62265625000002
								],
								[
									117.11386718750003,
									3.6126464843749346
								],
								[
									117.16640625000002,
									3.5919921875000824
								],
								[
									117.34628906250009,
									3.4266113281250483
								],
								[
									117.38466796874997,
									3.3653808593750085
								],
								[
									117.32187500000009,
									3.243554687500051
								],
								[
									117.35244140624997,
									3.193750000000037
								],
								[
									117.42207031250007,
									3.1651855468750796
								],
								[
									117.50683593750011,
									3.1045898437499915
								],
								[
									117.56718750000005,
									3.0984863281249915
								],
								[
									117.61064453124999,
									3.064355468749966
								],
								[
									117.6124023437502,
									3.0048828125000995
								],
								[
									117.63789062500007,
									2.9508300781250227
								],
								[
									117.56914062499999,
									2.9292968750000767
								],
								[
									117.63720703125011,
									2.9149414062500796
								],
								[
									117.69765624999997,
									2.8873046875000483
								],
								[
									117.66455078125,
									2.8592773437500227
								],
								[
									117.63886718750018,
									2.8252929687499346
								],
								[
									117.66679687499999,
									2.806933593750017
								],
								[
									117.74970703125018,
									2.7755859375000256
								],
								[
									117.78593750000005,
									2.7467773437500966
								],
								[
									117.80488281250007,
									2.668945312500057
								],
								[
									117.88574218750011,
									2.541748046875071
								],
								[
									118.03417968749994,
									2.37763671875004
								],
								[
									118.06660156250018,
									2.3178222656250256
								],
								[
									118.06630859375014,
									2.262744140625074
								],
								[
									118.04160156250003,
									2.215429687500034
								],
								[
									117.95703124999994,
									2.159960937500017
								],
								[
									117.8892578125002,
									2.0870117187500767
								],
								[
									117.88105468750001,
									2.060644531250034
								],
								[
									117.78925781250018,
									2.026855468749986
								],
								[
									117.83125000000001,
									2.002001953125074
								],
								[
									117.86464843749997,
									1.96840820312498
								],
								[
									117.92841796875018,
									1.8667968750000625
								],
								[
									118.08037109375016,
									1.7018554687500256
								],
								[
									118.15683593750009,
									1.6403320312500256
								],
								[
									118.47167968750011,
									1.4164550781250682
								],
								[
									118.63896484375016,
									1.318994140625108
								],
								[
									118.8525390625,
									1.0958496093750227
								],
								[
									118.9634765625002,
									1.0442871093750057
								],
								[
									118.98496093750003,
									0.9821289062499545
								],
								[
									118.89238281249999,
									0.8868652343750796
								],
								[
									118.75742187500003,
									0.8392089843750625
								],
								[
									118.53476562500009,
									0.8135253906250597
								],
								[
									118.3115234375,
									0.8470703125000654
								],
								[
									118.19609374999999,
									0.8743652343750199
								],
								[
									118.09550781250005,
									0.9291503906249972
								],
								[
									118.01630859375007,
									1.03916015625002
								],
								[
									117.91162109374994,
									1.098681640625074
								],
								[
									117.95195312499999,
									1.0319824218749858
								],
								[
									117.97734375000005,
									0.9638183593749545
								],
								[
									117.96425781250014,
									0.8895507812500938
								],
								[
									117.92304687500007,
									0.8313476562500597
								],
								[
									117.85253906250011,
									0.7886718749999773
								],
								[
									117.77695312500003,
									0.7540039062500199
								],
								[
									117.74511718749994,
									0.7296386718750227
								],
								[
									117.55332031250003,
									0.3410156250000824
								],
								[
									117.52216796875001,
									0.2358886718750739
								],
								[
									117.46376953125014,
									-0.2004882812499318
								],
								[
									117.46289062500011,
									-0.3237304687499858
								],
								[
									117.54892578125003,
									-0.5543945312499119
								],
								[
									117.55683593750007,
									-0.675292968749929
								],
								[
									117.57382812500003,
									-0.7275390624999147
								],
								[
									117.5625,
									-0.7708984374999659
								],
								[
									117.52177734375005,
									-0.7966796875000597
								],
								[
									117.35712890625007,
									-0.8671874999999432
								],
								[
									117.24072265624994,
									-0.9256835937500512
								],
								[
									117.14648437499994,
									-1.0089843749999687
								],
								[
									117.07021484375014,
									-1.112695312499966
								],
								[
									117.00322265625016,
									-1.1876953124999687
								],
								[
									116.91396484375002,
									-1.2236328125
								],
								[
									116.84941406249999,
									-1.2182617187499716
								],
								[
									116.79707031250018,
									-1.183789062500054
								],
								[
									116.76054687500005,
									-1.1171874999999858
								],
								[
									116.73984375000009,
									-1.0442382812500455
								],
								[
									116.7261718750002,
									-1.0981445312500142
								],
								[
									116.72871093750001,
									-1.150781249999909
								],
								[
									116.75927734375011,
									-1.2071289062499204
								],
								[
									116.77099609375011,
									-1.2666015624999574
								],
								[
									116.75341796875,
									-1.3273437499998977
								],
								[
									116.71523437500014,
									-1.3757812499999176
								],
								[
									116.61162109375016,
									-1.4286132812499233
								],
								[
									116.55449218750016,
									-1.4739257812499176
								],
								[
									116.54511718750018,
									-1.55312499999998
								],
								[
									116.517578125,
									-1.59804687499998
								],
								[
									116.47792968750002,
									-1.6328124999999574
								],
								[
									116.33212890625003,
									-1.7124999999999488
								],
								[
									116.29960937499999,
									-1.7443359374999403
								],
								[
									116.27548828125003,
									-1.7848632812499403
								],
								[
									116.35322265625018,
									-1.7786132812499176
								],
								[
									116.42431640625011,
									-1.7848632812499403
								],
								[
									116.42958984375002,
									-1.8641601562499375
								],
								[
									116.45195312500005,
									-1.9231445312500455
								],
								[
									116.42353515625001,
									-2.052539062499946
								],
								[
									116.31396484375,
									-2.1398437499999687
								],
								[
									116.36865234375011,
									-2.1582031249999716
								],
								[
									116.41816406250018,
									-2.186718749999926
								],
								[
									116.52812499999999,
									-2.20791015624998
								],
								[
									116.56542968749994,
									-2.2997070312500227
								],
								[
									116.54921875000014,
									-2.410839843749926
								],
								[
									116.529296875,
									-2.5105468749999886
								],
								[
									116.45039062500018,
									-2.5382812499999545
								],
								[
									116.40126953125002,
									-2.519824218749932
								],
								[
									116.35253906250011,
									-2.5215820312499346
								],
								[
									116.31679687500014,
									-2.551855468749963
								],
								[
									116.30722656250003,
									-2.6033203125000597
								],
								[
									116.37548828125011,
									-2.578027343749966
								],
								[
									116.3716796875002,
									-2.7068359374999176
								],
								[
									116.35322265625018,
									-2.832714843749983
								],
								[
									116.3306640625002,
									-2.9021484374999176
								],
								[
									116.28886718750005,
									-2.958789062500003
								],
								[
									116.22578125000007,
									-2.97695312499998
								],
								[
									116.16630859374999,
									-2.9345703125000426
								],
								[
									116.15410156249999,
									-2.9837890624999517
								],
								[
									116.17226562499997,
									-3.025292968750051
								],
								[
									116.25722656249997,
									-3.126367187500037
								],
								[
									116.20507812500011,
									-3.1485351562499346
								],
								[
									116.16708984375009,
									-3.1830078124999375
								],
								[
									116.15000000000009,
									-3.23320312499996
								],
								[
									116.05751953124997,
									-3.348242187499949
								],
								[
									116.0166992187502,
									-3.4328124999999403
								],
								[
									115.99941406250014,
									-3.523339843749909
								],
								[
									115.9561523437502,
									-3.595019531249946
								],
								[
									115.25820312500002,
									-3.906835937499963
								],
								[
									114.69355468750018,
									-4.169726562499974
								],
								[
									114.65253906250018,
									-4.151855468750057
								],
								[
									114.62529296875005,
									-4.111718750000051
								],
								[
									114.60595703125011,
									-3.703320312499983
								],
								[
									114.5361328125,
									-3.4944335937500597
								],
								[
									114.52558593750018,
									-3.3766601562499545
								],
								[
									114.44599609375001,
									-3.48183593749998
								],
								[
									114.39716796875001,
									-3.471191406249943
								],
								[
									114.3443359375002,
									-3.444433593749906
								],
								[
									114.30458984374997,
									-3.4100585937499233
								],
								[
									114.30166015625002,
									-3.364746093749929
								],
								[
									114.3443359375002,
									-3.2351562499999034
								],
								[
									114.29267578125007,
									-3.3062499999999204
								],
								[
									114.23632812500011,
									-3.3611328124999034
								],
								[
									114.17792968750001,
									-3.3543945312499517
								],
								[
									114.12763671875018,
									-3.3272460937499346
								],
								[
									114.1089843750002,
									-3.285156250000057
								],
								[
									114.08222656250018,
									-3.2789062499999346
								],
								[
									113.95878906250016,
									-3.3943359374999176
								],
								[
									113.79580078124997,
									-3.456249999999926
								],
								[
									113.705078125,
									-3.455273437499983
								],
								[
									113.63359375000016,
									-3.4199218749998863
								],
								[
									113.6373046875002,
									-3.332031250000014
								],
								[
									113.63007812500007,
									-3.2460937499999147
								],
								[
									113.61005859375018,
									-3.1957031249999517
								],
								[
									113.56630859375014,
									-3.177734374999929
								],
								[
									113.52597656250009,
									-3.1840820312499005
								],
								[
									113.40898437500016,
									-3.228906249999966
								],
								[
									113.3671875,
									-3.2236328124999574
								],
								[
									113.34316406250014,
									-3.2464843749999943
								],
								[
									113.03398437500005,
									-2.933496093749909
								],
								[
									112.97148437499999,
									-3.1871093749999773
								],
								[
									112.75800781250001,
									-3.322167968749966
								],
								[
									112.60029296875007,
									-3.4004882812499346
								],
								[
									112.4439453125002,
									-3.3710937499998863
								],
								[
									112.28496093750005,
									-3.320996093749983
								],
								[
									112.12666015625001,
									-3.381445312499963
								],
								[
									111.95488281250005,
									-3.529687499999966
								],
								[
									111.90742187500001,
									-3.5525390624999034
								],
								[
									111.85810546875001,
									-3.551855468750034
								],
								[
									111.82207031250016,
									-3.532519531250003
								],
								[
									111.83437499999997,
									-3.420117187499926
								],
								[
									111.83593750000011,
									-3.307714843750034
								],
								[
									111.82304687500016,
									-3.057226562499892
								],
								[
									111.80937500000005,
									-3.008007812499912
								],
								[
									111.76015625000014,
									-2.939160156249912
								],
								[
									111.69472656250014,
									-2.8894531249999176
								],
								[
									111.65830078125009,
									-2.9257812500000284
								],
								[
									111.62548828124994,
									-2.9754882812499375
								],
								[
									111.49492187499999,
									-2.9733398437499545
								],
								[
									111.36757812500002,
									-2.933691406249949
								],
								[
									111.25917968750014,
									-2.956445312499966
								],
								[
									111.04433593750014,
									-3.055761718749949
								],
								[
									110.93007812500014,
									-3.0710937499999744
								],
								[
									110.86875000000009,
									-3.0487304687499375
								],
								[
									110.8296875000002,
									-2.995117187499943
								],
								[
									110.85205078124994,
									-2.9461914062499233
								],
								[
									110.89931640625002,
									-2.908593749999909
								],
								[
									110.81113281250009,
									-2.9384765624999574
								],
								[
									110.73583984375011,
									-2.988671875000051
								],
								[
									110.70312500000011,
									-3.0208984374999517
								],
								[
									110.66816406250018,
									-3.004785156249966
								],
								[
									110.57402343750016,
									-2.89140624999996
								],
								[
									110.3775390625002,
									-2.9337890624999687
								],
								[
									110.35097656250014,
									-2.9467773437500426
								],
								[
									110.30253906249999,
									-2.9853515624999147
								],
								[
									110.25605468750007,
									-2.9661132812499034
								],
								[
									110.23261718750018,
									-2.9250976562499744
								],
								[
									110.22431640625007,
									-2.68867187500004
								],
								[
									110.12441406250014,
									-2.233886718749943
								],
								[
									110.09658203124997,
									-2.0013671874999943
								],
								[
									110.07500000000005,
									-1.946386718749892
								],
								[
									109.95986328125002,
									-1.8627929687499147
								],
								[
									109.96376953125002,
									-1.742871093749912
								],
								[
									110.0234375,
									-1.6425781249999147
								],
								[
									110.03613281250011,
									-1.5256835937499034
								],
								[
									110.01923828125001,
									-1.3988281249998948
								],
								[
									109.98330078124997,
									-1.2748046874999517
								],
								[
									109.9380859375002,
									-1.1811523437499574
								],
								[
									109.87343749999997,
									-1.1010742187499005
								],
								[
									109.78740234375016,
									-1.0113281249999204
								],
								[
									109.6817382812502,
									-0.9442382812499233
								],
								[
									109.45380859375001,
									-0.8687499999999062
								],
								[
									109.33349609375011,
									-0.8753906249999375
								],
								[
									109.28886718749999,
									-0.8458007812499488
								],
								[
									109.25878906250011,
									-0.807421874999946
								],
								[
									109.27099609375011,
									-0.7320312500000341
								],
								[
									109.31171875000001,
									-0.6801757812499574
								],
								[
									109.36630859375003,
									-0.6673828125000085
								],
								[
									109.37275390625001,
									-0.638183593749929
								],
								[
									109.25703125000018,
									-0.5774414062498892
								],
								[
									109.16054687499997,
									-0.4949218750000455
								],
								[
									109.13027343750014,
									-0.4454101562499062
								],
								[
									109.12109375000011,
									-0.39091796874990337
								],
								[
									109.12177734375018,
									-0.26503906249993747
								],
								[
									109.14960937500007,
									-0.18554687499990052
								],
								[
									109.16474609375001,
									-0.14248046875000853
								],
								[
									109.19462890625016,
									-0.00942382812490905
								],
								[
									109.25751953125018,
									0.031152343750108002
								],
								[
									109.24726562500007,
									0.05576171875004832
								],
								[
									109.22021484374994,
									0.07382812500000568
								],
								[
									109.1807617187502,
									0.11748046875001705
								],
								[
									109.1485351562502,
									0.16767578124994031
								],
								[
									109.0748046875002,
									0.25283203125005116
								],
								[
									108.94453125000001,
									0.3556640625000398
								],
								[
									108.92275390625014,
									0.5328125000000767
								],
								[
									108.90585937500003,
									0.7939453124999858
								],
								[
									108.91679687500016,
									0.9126464843751023
								],
								[
									108.95859375000003,
									1.1346191406249346
								],
								[
									109.0308593750002,
									1.2044921875000512
								],
								[
									109.0884765625002,
									1.2239257812501023
								],
								[
									109.13154296875018,
									1.2538574218750682
								],
								[
									109.09609374999997,
									1.2581542968750483
								],
								[
									109.06542968749994,
									1.2471679687499488
								],
								[
									109.01025390625,
									1.239648437500108
								],
								[
									109.05546875000016,
									1.4384765625001137
								],
								[
									109.07587890625007,
									1.495898437500088
								],
								[
									109.16669921875018,
									1.6070800781250796
								],
								[
									109.27314453125018,
									1.7054687500000512
								],
								[
									109.31816406250005,
									1.8210937499999886
								],
								[
									109.37851562500003,
									1.9227050781250767
								],
								[
									109.62890625000011,
									2.02753906250004
								],
								[
									109.53896484374997,
									1.8961914062500114
								],
								[
									109.54892578125003,
									1.8483398437500256
								],
								[
									109.57080078125,
									1.8062988281249943
								],
								[
									109.63583984375009,
									1.776660156250088
								],
								[
									109.65400390625007,
									1.6148925781250796
								],
								[
									109.73574218750002,
									1.52294921875
								],
								[
									109.81806640625018,
									1.4389648437499432
								],
								[
									109.87851562500003,
									1.3978515625000938
								],
								[
									109.94492187500009,
									1.3380371093750796
								],
								[
									109.99169921875011,
									1.2825683593750483
								],
								[
									110.04082031250016,
									1.2357421875000227
								],
								[
									110.11474609375011,
									1.190136718750054
								],
								[
									110.31523437500005,
									0.9959960937499375
								],
								[
									110.39902343750003,
									0.9390625000000625
								],
								[
									110.46142578124994,
									0.882080078125
								],
								[
									110.50576171875014,
									0.8619628906250796
								],
								[
									110.61474609375011,
									0.8781250000000824
								],
								[
									110.93808593750009,
									1.0173339843751137
								],
								[
									110.99609375000011,
									1.0263671875000853
								],
								[
									111.10136718750005,
									1.0505371093750284
								],
								[
									111.28671875000003,
									1.0432128906250568
								],
								[
									111.48320312500005,
									0.9957519531250654
								],
								[
									111.54667968750016,
									0.9943359374999545
								],
								[
									111.60742187500011,
									1.0226074218750227
								],
								[
									111.69130859375014,
									1.014208984375088
								],
								[
									111.76972656250007,
									0.9994628906250256
								],
								[
									111.80898437500014,
									1.0116699218750256
								],
								[
									111.92314453125005,
									1.1132812500000284
								],
								[
									112.07851562499997,
									1.1433593750000313
								],
								[
									112.12861328125007,
									1.2436035156250256
								],
								[
									112.16738281250014,
									1.338183593750017
								],
								[
									112.18574218750018,
									1.439062499999963
								],
								[
									112.25068359375007,
									1.4796386718750512
								],
								[
									112.34160156250005,
									1.51474609375002
								],
								[
									112.47617187500009,
									1.559082031250071
								],
								[
									112.94296875000003,
									1.566992187500091
								],
								[
									112.98828124999994,
									1.5475585937500398
								],
								[
									112.99804687500011,
									1.4962402343750654
								],
								[
									112.98828124999994,
									1.457128906250091
								],
								[
									113.00654296875007,
									1.4338867187499744
								],
								[
									113.06865234374999,
									1.4317871093750796
								],
								[
									113.12626953124999,
									1.4081054687500512
								],
								[
									113.35898437500009,
									1.327148437500071
								],
								[
									113.45820312500007,
									1.3021484375000512
								],
								[
									113.51318359374994,
									1.3083984374999886
								],
								[
									113.62226562500018,
									1.2359375000000625
								],
								[
									113.68164062500011,
									1.26059570312502
								],
								[
									113.76035156250003,
									1.3113769531250625
								],
								[
									113.83525390625005,
									1.3798828124999858
								],
								[
									113.90234375000011,
									1.434277343750054
								],
								[
									114.00000000000011,
									1.4552734375000682
								],
								[
									114.12597656250011,
									1.4523437500000966
								],
								[
									114.27470703125005,
									1.470898437500054
								],
								[
									114.38710937500002,
									1.5000488281250455
								],
								[
									114.51250000000016,
									1.4520019531249346
								],
								[
									114.54589843750011,
									1.467138671875091
								],
								[
									114.56748046875009,
									1.5141601562499858
								],
								[
									114.63222656250014,
									1.6170410156250767
								],
								[
									114.66093750000005,
									1.6862792968750568
								],
								[
									114.6861328125002,
									1.8190429687500966
								],
								[
									114.70351562499997,
									1.8507812499999972
								],
								[
									114.75107421875009,
									1.8689941406249773
								],
								[
									114.80000000000001,
									1.8939453125000796
								],
								[
									114.81269531250001,
									1.9337890625000256
								],
								[
									114.83056640625011,
									1.9800292968750313
								],
								[
									114.81582031250014,
									2.0189453125000654
								],
								[
									114.78798828124997,
									2.0516113281250483
								],
								[
									114.75869140625014,
									2.1624023437500597
								],
								[
									114.76835937500016,
									2.2129394531250597
								],
								[
									114.78642578124999,
									2.250488281250071
								],
								[
									114.83632812500014,
									2.269384765625105
								],
								[
									114.96914062500002,
									2.3508300781250853
								],
								[
									115.08652343750003,
									2.446142578124963
								],
								[
									115.15078124999997,
									2.492919921875071
								],
								[
									115.17910156249997,
									2.5231933593750284
								],
								[
									115.18085937500018,
									2.5668945312500426
								],
								[
									115.1298828125,
									2.6124023437500767
								],
								[
									115.08076171875001,
									2.6342285156250824
								],
								[
									115.07705078124997,
									2.6870117187500995
								],
								[
									115.07890624999999,
									2.7234375000000597
								],
								[
									115.09365234374997,
									2.7578125000000426
								],
								[
									115.08652343750003,
									2.7912109375000966
								],
								[
									115.08632812500002,
									2.84111328124996
								],
								[
									115.11757812499997,
									2.8948730468750767
								],
								[
									115.18994140624994,
									2.974462890624949
								],
								[
									115.24697265625014,
									3.0259277343750455
								],
								[
									115.3101562500002,
									2.9939453125001023
								],
								[
									115.38417968750002,
									3.0087402343750966
								],
								[
									115.45439453125005,
									3.0343261718750654
								],
								[
									115.49316406250011,
									3.1281250000000824
								],
								[
									115.49912109375009,
									3.173144531250017
								],
								[
									115.48974609375011,
									3.208642578125051
								],
								[
									115.51425781250003,
									3.342382812500034
								],
								[
									115.51992187500014,
									3.361669921874963
								],
								[
									115.56611328125007,
									3.44575195312504
								],
								[
									115.57070312500002,
									3.502294921875105
								],
								[
									115.54453125000009,
									3.633691406250051
								],
								[
									115.56093750000014,
									3.7330566406249517
								],
								[
									115.56845703125009,
									3.9387695312500313
								],
								[
									115.59609375000014,
									3.9755371093749687
								],
								[
									115.6275390625002,
									4.081982421874983
								],
								[
									115.67880859375009,
									4.193017578125037
								],
								[
									115.78242187500007,
									4.253759765625077
								],
								[
									115.83681640625014,
									4.333300781250017
								],
								[
									115.86074218750014,
									4.3480468750000085
								],
								[
									115.89619140625007,
									4.34868164062496
								],
								[
									116.0215820312502,
									4.290673828125037
								],
								[
									116.13447265625001,
									4.35517578125004
								],
								[
									116.23623046875014,
									4.362548828124943
								],
								[
									116.32031249999994,
									4.353710937500097
								],
								[
									116.36767578125011,
									4.327343750000054
								],
								[
									116.41455078124994,
									4.3082031250000625
								],
								[
									116.51474609375003,
									4.370800781250026
								],
								[
									116.55312500000014,
									4.3598632812500995
								],
								[
									116.58906250000018,
									4.338427734375003
								],
								[
									116.63867187499994,
									4.339111328125057
								],
								[
									116.69785156250003,
									4.35498046875
								],
								[
									116.84355468750016,
									4.340136718750088
								],
								[
									117.10058593750011,
									4.33706054687508
								],
								[
									117.27753906250018,
									4.299316406250028
								],
								[
									117.45087890625007,
									4.192871093750014
								],
								[
									117.53730468750018,
									4.171386718750071
								],
								[
									117.57441406250018,
									4.170605468750097
								]
							]
						],
						[
							[
								[
									126.81660156250001,
									4.0334960937500455
								],
								[
									126.77626953124997,
									4.012597656250051
								],
								[
									126.71123046875016,
									4.020263671875114
								],
								[
									126.70449218750014,
									4.070996093750054
								],
								[
									126.77011718750009,
									4.162207031250077
								],
								[
									126.81357421875003,
									4.258496093750054
								],
								[
									126.76728515625001,
									4.2825683593749915
								],
								[
									126.72207031250014,
									4.344189453125026
								],
								[
									126.72050781249999,
									4.41582031249996
								],
								[
									126.75732421874994,
									4.5479003906250455
								],
								[
									126.81250000000011,
									4.537207031250091
								],
								[
									126.86513671874997,
									4.479833984375034
								],
								[
									126.88671875000011,
									4.372509765625111
								],
								[
									126.92109375000018,
									4.291015625000028
								],
								[
									126.84765624999994,
									4.1799804687500455
								],
								[
									126.81660156250001,
									4.0334960937500455
								]
							]
						],
						[
							[
								[
									96.49257812500014,
									5.229345703124963
								],
								[
									96.615234375,
									5.220214843750057
								],
								[
									96.84267578125014,
									5.274462890625088
								],
								[
									96.96777343750011,
									5.269140625000077
								],
								[
									97.08574218749999,
									5.229931640625082
								],
								[
									97.19042968750011,
									5.207324218750088
								],
								[
									97.45117187500011,
									5.236035156250082
								],
								[
									97.50019531250007,
									5.228320312499932
								],
								[
									97.54716796875005,
									5.205859374999974
								],
								[
									97.58750000000009,
									5.170361328125026
								],
								[
									97.70673828125001,
									5.040136718749963
								],
								[
									97.90839843750018,
									4.87998046875002
								],
								[
									97.96660156250005,
									4.777490234375094
								],
								[
									97.99980468750016,
									4.662255859375065
								],
								[
									98.02070312500007,
									4.635205078125068
								],
								[
									98.24843749999997,
									4.414550781250057
								],
								[
									98.27333984375002,
									4.322314453125088
								],
								[
									98.24121093750011,
									4.194531249999997
								],
								[
									98.30732421875018,
									4.0928710937500625
								],
								[
									98.5283203125,
									3.997558593750014
								],
								[
									98.65869140625,
									3.9281250000000796
								],
								[
									98.6865234375,
									3.885546874999932
								],
								[
									98.70576171875018,
									3.8347656250000597
								],
								[
									98.77792968750003,
									3.7594238281249943
								],
								[
									98.86865234374994,
									3.710351562500037
								],
								[
									99.15117187500016,
									3.5812500000000256
								],
								[
									99.52148437500011,
									3.31118164062498
								],
								[
									99.73232421875014,
									3.1830566406250824
								],
								[
									99.90664062500014,
									2.9881835937500796
								],
								[
									99.96943359375007,
									2.8949218750000796
								],
								[
									100.02128906250005,
									2.794238281250003
								],
								[
									100.12724609375005,
									2.6476074218750654
								],
								[
									100.3072265625002,
									2.4666015625000455
								],
								[
									100.35273437500007,
									2.4114746093750057
								],
								[
									100.40117187500016,
									2.3316406250000767
								],
								[
									100.45703125,
									2.2574218750000625
								],
								[
									100.52382812500002,
									2.1891601562500114
								],
								[
									100.6036132812502,
									2.1369628906250284
								],
								[
									100.68525390625001,
									2.1200683593749687
								],
								[
									100.81679687500002,
									1.9892578125000568
								],
								[
									100.88789062500001,
									1.9482421874999574
								],
								[
									100.87666015625001,
									2.050585937500017
								],
								[
									100.81689453125011,
									2.140185546875074
								],
								[
									100.81777343750014,
									2.19423828124998
								],
								[
									100.8282226562502,
									2.242578125000051
								],
								[
									100.8770507812502,
									2.2833007812500057
								],
								[
									100.93593750000014,
									2.294726562500017
								],
								[
									101.04619140625005,
									2.2574707031250654
								],
								[
									101.22519531250009,
									2.102246093750068
								],
								[
									101.30078125000011,
									2.011816406250034
								],
								[
									101.35761718750007,
									1.887011718750088
								],
								[
									101.40507812500016,
									1.7574218750000767
								],
								[
									101.47666015625003,
									1.6930664062501108
								],
								[
									101.57500000000005,
									1.6705566406250512
								],
								[
									101.68427734375018,
									1.66123046875002
								],
								[
									101.7847656250002,
									1.621386718750074
								],
								[
									102.01992187499997,
									1.4421386718750568
								],
								[
									102.09804687500002,
									1.3579101562500426
								],
								[
									102.1572265625,
									1.25888671875002
								],
								[
									102.19794921875018,
									1.1416992187500483
								],
								[
									102.22333984375001,
									1.018701171875037
								],
								[
									102.23906250000005,
									0.9903320312500199
								],
								[
									102.38994140625016,
									0.8419921875000966
								],
								[
									102.46923828124994,
									0.7792968750001137
								],
								[
									102.56640625000011,
									0.7488281250000313
								],
								[
									102.84941406250005,
									0.7154785156250796
								],
								[
									102.94931640625003,
									0.6642089843750227
								],
								[
									103.03183593750009,
									0.5789062500000455
								],
								[
									103.0665039062502,
									0.4919921874999318
								],
								[
									103.00751953125018,
									0.415332031249946
								],
								[
									102.78632812500018,
									0.29775390625006537
								],
								[
									102.55000000000007,
									0.21645507812502274
								],
								[
									102.77958984375005,
									0.24448242187504832
								],
								[
									102.89589843750002,
									0.2786132812500739
								],
								[
									103.00283203125014,
									0.33198242187511084
								],
								[
									103.10869140624999,
									0.3998046874999801
								],
								[
									103.27656250000001,
									0.4945312500000938
								],
								[
									103.3389648437502,
									0.5137207031250881
								],
								[
									103.41230468750007,
									0.5069335937500483
								],
								[
									103.47890625000014,
									0.48017578125001137
								],
								[
									103.5787109375002,
									0.3870605468750483
								],
								[
									103.67265625000016,
									0.28891601562494884
								],
								[
									103.74277343750003,
									0.17441406250006253
								],
								[
									103.7867187500002,
									0.046972656250034106
								],
								[
									103.70644531250014,
									-0.019580078125017053
								],
								[
									103.58945312500009,
									-0.06874999999990905
								],
								[
									103.42851562500016,
									-0.19179687499993747
								],
								[
									103.41162109375011,
									-0.2404296875000682
								],
								[
									103.4444335937502,
									-0.2716796875000398
								],
								[
									103.40517578125014,
									-0.3622070312500085
								],
								[
									103.49541015625005,
									-0.4180664062500199
								],
								[
									103.50917968749997,
									-0.4655273437499261
								],
								[
									103.43115234375,
									-0.5335937499999375
								],
								[
									103.43857421875009,
									-0.5755859374999659
								],
								[
									103.53271484375,
									-0.7546875000000313
								],
								[
									103.57753906250014,
									-0.795703124999946
								],
								[
									103.72109374999997,
									-0.886718749999929
								],
								[
									103.9400390625002,
									-0.9791015624999204
								],
								[
									104.06113281250009,
									-1.0213867187500085
								],
								[
									104.19853515624999,
									-1.054296874999963
								],
								[
									104.25751953125001,
									-1.0534179687499687
								],
								[
									104.36054687500007,
									-1.0383789062499176
								],
								[
									104.38125000000002,
									-1.0742187499999432
								],
								[
									104.42568359375002,
									-1.250683593749912
								],
								[
									104.44687500000003,
									-1.3624023437499346
								],
								[
									104.47832031250016,
									-1.6000976562499574
								],
								[
									104.51855468750011,
									-1.6987304687498863
								],
								[
									104.51591796874999,
									-1.819433593749963
								],
								[
									104.56875000000002,
									-1.9217773437499517
								],
								[
									104.6763671875002,
									-1.9872070312499517
								],
								[
									104.79101562500011,
									-2.040820312499946
								],
								[
									104.84521484375011,
									-2.092968749999912
								],
								[
									104.84453125000016,
									-2.17177734374998
								],
								[
									104.82607421875014,
									-2.2341796874999034
								],
								[
									104.78730468750007,
									-2.282714843749943
								],
								[
									104.66845703125,
									-2.385546874999932
								],
								[
									104.64726562500005,
									-2.429882812499983
								],
								[
									104.63056640625018,
									-2.5433593749999233
								],
								[
									104.65078125000014,
									-2.5952148437499147
								],
								[
									104.69833984375003,
									-2.5981445312499005
								],
								[
									104.73574218750014,
									-2.5708984374999346
								],
								[
									104.87841796874994,
									-2.418847656249966
								],
								[
									104.91699218750011,
									-2.392187500000034
								],
								[
									104.9708007812502,
									-2.37089843749996
								],
								[
									105.02587890625,
									-2.357519531249906
								],
								[
									105.28652343750014,
									-2.3562499999999034
								],
								[
									105.39697265625,
									-2.3801757812499034
								],
								[
									105.49531250000007,
									-2.429687499999943
								],
								[
									105.58203124999994,
									-2.491992187499946
								],
								[
									105.89912109375018,
									-2.8877929687499346
								],
								[
									106.04433593749997,
									-3.106249999999932
								],
								[
									106.0557617187502,
									-3.1606445312499147
								],
								[
									106.05839843749999,
									-3.2171875000000654
								],
								[
									106.03369140624994,
									-3.260937499999926
								],
								[
									105.9014648437502,
									-3.4100585937499233
								],
								[
									105.88505859375016,
									-3.4512695312499773
								],
								[
									105.84375,
									-3.6136718749999233
								],
								[
									105.85156249999994,
									-3.7305664062499346
								],
								[
									105.89550781249994,
									-3.779687499999909
								],
								[
									105.93046875000016,
									-3.833007812499943
								],
								[
									105.92773437500011,
									-3.881347656250014
								],
								[
									105.84062500000016,
									-4.121777343749969
								],
								[
									105.83144531250014,
									-4.162890624999903
								],
								[
									105.88652343750016,
									-4.553906249999983
								],
								[
									105.89052734375002,
									-4.659765624999977
								],
								[
									105.87929687500014,
									-4.793652343750068
								],
								[
									105.88720703124994,
									-5.009570312500003
								],
								[
									105.81611328125001,
									-5.676562499999903
								],
								[
									105.80273437499994,
									-5.716406249999949
								],
								[
									105.74833984375016,
									-5.818261718749909
								],
								[
									105.67656250000005,
									-5.8175781249999545
								],
								[
									105.61855468750002,
									-5.799609375000017
								],
								[
									105.57792968749999,
									-5.76064453124998
								],
								[
									105.55556640624997,
									-5.712304687499994
								],
								[
									105.52265625000001,
									-5.6727539062499375
								],
								[
									105.34941406250016,
									-5.5495117187499545
								],
								[
									105.30400390625016,
									-5.570019531249969
								],
								[
									105.12812500000001,
									-5.722851562500011
								],
								[
									105.08134765624999,
									-5.7455078125000085
								],
								[
									105.02265625000001,
									-5.726855468749946
								],
								[
									104.93027343750003,
									-5.681152343750043
								],
								[
									104.63955078125014,
									-5.52041015624998
								],
								[
									104.62167968750003,
									-5.571777343749972
								],
								[
									104.61816406249994,
									-5.641503906249966
								],
								[
									104.67597656250018,
									-5.816210937499932
								],
								[
									104.68398437500014,
									-5.892675781249977
								],
								[
									104.63105468750018,
									-5.907910156250054
								],
								[
									104.60156249999994,
									-5.904589843749918
								],
								[
									104.48085937500014,
									-5.803125000000023
								],
								[
									104.36953125000014,
									-5.690722656249946
								],
								[
									104.24296874999999,
									-5.538867187499918
								],
								[
									104.15048828125009,
									-5.466601562500031
								],
								[
									104.06679687499997,
									-5.38593749999994
								],
								[
									103.83144531250002,
									-5.079589843750057
								],
								[
									103.77031250000016,
									-5.032812499999949
								],
								[
									103.40566406250014,
									-4.816406249999915
								],
								[
									103.33212890625003,
									-4.765234374999963
								],
								[
									103.23886718750009,
									-4.675683593749923
								],
								[
									103.138671875,
									-4.596191406249986
								],
								[
									102.9189453125,
									-4.470703125
								],
								[
									102.53769531250003,
									-4.152148437499946
								],
								[
									102.37197265625014,
									-3.9692382812498863
								],
								[
									102.18769531250007,
									-3.674511718749983
								],
								[
									102.12753906250003,
									-3.5992187499999204
								],
								[
									101.81787109375011,
									-3.3780273437499773
								],
								[
									101.6490234375002,
									-3.2440429687499375
								],
								[
									101.57861328124994,
									-3.1669921874999716
								],
								[
									101.41425781250007,
									-2.8988281249999517
								],
								[
									101.36621093750011,
									-2.8084960937499375
								],
								[
									101.30566406249994,
									-2.7287109375000256
								],
								[
									101.20625000000001,
									-2.66396484374998
								],
								[
									101.11855468750014,
									-2.5877929687499233
								],
								[
									100.94443359375009,
									-2.345214843750057
								],
								[
									100.88955078125002,
									-2.2485351562499005
								],
								[
									100.84804687499997,
									-2.143945312499909
								],
								[
									100.85527343750005,
									-1.934179687499892
								],
								[
									100.48652343750007,
									-1.2991210937499318
								],
								[
									100.39394531250002,
									-1.1012695312499403
								],
								[
									100.30820312500003,
									-0.8266601562499574
								],
								[
									100.28906249999994,
									-0.7988281249999716
								],
								[
									100.08789062500011,
									-0.5529296874999687
								],
								[
									100.01669921875009,
									-0.4742187499999204
								],
								[
									99.93066406249994,
									-0.4001953124999318
								],
								[
									99.86005859375007,
									-0.3137695312499176
								],
								[
									99.7212890625002,
									-0.032958984374900524
								],
								[
									99.66982421875014,
									0.045068359375008527
								],
								[
									99.59765625,
									0.10244140625006537
								],
								[
									99.3345703125002,
									0.2085937500000199
								],
								[
									99.2364257812502,
									0.2677734375000824
								],
								[
									99.1591796875,
									0.351757812500054
								],
								[
									99.11171875000002,
									0.4589355468750398
								],
								[
									99.05957031249994,
									0.686376953125091
								],
								[
									98.93554687500011,
									1.0319335937500682
								],
								[
									98.79638671875,
									1.4946289062500853
								],
								[
									98.70253906250014,
									1.7019531250000455
								],
								[
									98.59531250000003,
									1.8645996093750625
								],
								[
									98.56425781250005,
									1.902148437500074
								],
								[
									98.08652343750003,
									2.1950683593749716
								],
								[
									98.00507812500007,
									2.238183593750051
								],
								[
									97.9185546875002,
									2.264208984375017
								],
								[
									97.79501953125009,
									2.282861328125094
								],
								[
									97.70078125000009,
									2.358544921875051
								],
								[
									97.66201171874997,
									2.494287109375094
								],
								[
									97.640625,
									2.67641601562498
								],
								[
									97.6167968750002,
									2.7851074218750966
								],
								[
									97.59082031249994,
									2.8465820312500085
								],
								[
									97.39130859375018,
									2.9752929687499403
								],
								[
									97.31318359375007,
									3.0770507812500654
								],
								[
									97.24794921875002,
									3.18901367187496
								],
								[
									97.18837890625014,
									3.275732421875034
								],
								[
									96.96894531250018,
									3.5751464843750256
								],
								[
									96.89394531250002,
									3.6537109374999517
								],
								[
									96.80097656250018,
									3.708544921874932
								],
								[
									96.52539062499994,
									3.7666015625000284
								],
								[
									96.44472656250014,
									3.816308593750037
								],
								[
									96.31083984375016,
									3.9863281250000284
								],
								[
									96.2300781250002,
									4.072753906250057
								],
								[
									95.98798828125018,
									4.2632812500000625
								],
								[
									95.57861328125011,
									4.661962890625105
								],
								[
									95.49472656250003,
									4.761376953125108
								],
								[
									95.43193359375016,
									4.865039062500088
								],
								[
									95.38125000000014,
									4.976171875000077
								],
								[
									95.20664062500009,
									5.284033203125091
								],
								[
									95.22070312500011,
									5.346240234374974
								],
								[
									95.24707031249994,
									5.41079101562498
								],
								[
									95.24296874999999,
									5.46430664062504
								],
								[
									95.22382812500001,
									5.517089843750057
								],
								[
									95.22783203125005,
									5.564794921875091
								],
								[
									95.27958984374999,
									5.592871093749949
								],
								[
									95.3960937500002,
									5.62880859375008
								],
								[
									95.51699218750014,
									5.62460937500002
								],
								[
									95.62890625000011,
									5.609082031250054
								],
								[
									95.73730468750011,
									5.579296875000026
								],
								[
									95.84130859374994,
									5.5145019531250625
								],
								[
									96.02734375000011,
									5.351171875000091
								],
								[
									96.13330078125011,
									5.294287109375048
								],
								[
									96.25087890625002,
									5.266992187499994
								],
								[
									96.49257812500014,
									5.229345703124963
								]
							]
						],
						[
							[
								[
									95.36210937500005,
									5.81240234375008
								],
								[
									95.34257812500016,
									5.784130859375011
								],
								[
									95.28320312500011,
									5.798535156250097
								],
								[
									95.21767578125002,
									5.889501953125077
								],
								[
									95.24199218750016,
									5.907031250000003
								],
								[
									95.28251953125016,
									5.89775390625006
								],
								[
									95.35917968750016,
									5.8767578125000455
								],
								[
									95.36601562500005,
									5.842675781250037
								],
								[
									95.36210937500005,
									5.81240234375008
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "IDN",
					"su_a3": "IDN",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "IDN",
					"gu_a3": "IDN",
					"abbrev": "Indo.",
					"region_un": "Asia",
					"adm0_a3_us": "IDN",
					"scalerank": 1,
					"pop_est": 240271522,
					"adm0_dif": 0,
					"un_a3": "360",
					"pop_year": -99,
					"gdp_md_est": 914600,
					"name": "Indonesia",
					"sovereignt": "Indonesia",
					"economy": "4. Emerging region: MIKT",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Indonesia",
					"postal": "INDO",
					"sov_a3": "IDN",
					"note_brk": "",
					"brk_a3": "IDN",
					"wb_a2": "ID",
					"brk_diff": 0,
					"admin": "Indonesia",
					"name_long": "Indonesia",
					"iso_a3": "IDN",
					"iso_a2": "ID",
					"adm0_a3_is": "IDN",
					"level": 2,
					"formal_en": "Republic of Indonesia",
					"name_len": 9,
					"mapcolor7": 6,
					"long_len": 9,
					"mapcolor8": 6,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "360",
					"homepart": 1,
					"subunit": "Indonesia",
					"name_alt": "",
					"brk_name": "Indonesia",
					"name_sort": "Indonesia",
					"continent": "Asia",
					"mapcolor13": 11,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									93.89003906249997,
									6.831054687499957
								],
								[
									93.82880859375001,
									6.748681640625051
								],
								[
									93.70927734374999,
									7.000683593750054
								],
								[
									93.65800781250016,
									7.016064453125082
								],
								[
									93.65634765625009,
									7.136230468749957
								],
								[
									93.68417968750003,
									7.183593750000014
								],
								[
									93.82246093750018,
									7.236621093750074
								],
								[
									93.85898437500003,
									7.2068359375000455
								],
								[
									93.92958984375014,
									6.97348632812502
								],
								[
									93.89003906249997,
									6.831054687499957
								]
							]
						],
						[
							[
								[
									93.73359375000018,
									7.35649414062506
								],
								[
									93.63847656250016,
									7.261865234375065
								],
								[
									93.5972656250002,
									7.318750000000108
								],
								[
									93.61425781250011,
									7.35810546875004
								],
								[
									93.65468750000002,
									7.3799316406250455
								],
								[
									93.69248046875003,
									7.410595703125068
								],
								[
									93.73359375000018,
									7.35649414062506
								]
							]
						],
						[
							[
								[
									93.44257812500001,
									7.877832031250051
								],
								[
									93.36503906250016,
									7.8765625000000625
								],
								[
									93.34199218750007,
									7.91933593749998
								],
								[
									93.30937500000016,
									7.964013671875023
								],
								[
									93.33447265624994,
									8.006933593750063
								],
								[
									93.37548828124994,
									8.017919921874991
								],
								[
									93.4336914062502,
									7.948388671875037
								],
								[
									93.4473632812502,
									7.89912109375004
								],
								[
									93.44257812500001,
									7.877832031250051
								]
							]
						],
						[
							[
								[
									93.53691406250016,
									8.056640625000057
								],
								[
									93.49003906250005,
									8.019433593750037
								],
								[
									93.47822265625001,
									8.024462890625074
								],
								[
									93.4717773437502,
									8.052685546874969
								],
								[
									93.4697265625,
									8.072656249999952
								],
								[
									93.46123046875005,
									8.108593750000082
								],
								[
									93.45644531250014,
									8.171875000000085
								],
								[
									93.49404296875014,
									8.224658203125102
								],
								[
									93.53164062499997,
									8.213769531250094
								],
								[
									93.51162109374997,
									8.159765624999935
								],
								[
									93.53691406250016,
									8.056640625000057
								]
							]
						],
						[
							[
								[
									73.06738281249994,
									8.269091796875003
								],
								[
									73.05332031250003,
									8.256689453124963
								],
								[
									73.03886718750005,
									8.251953125000057
								],
								[
									73.02851562500007,
									8.25351562500002
								],
								[
									73.0234375,
									8.26591796875006
								],
								[
									73.02607421875018,
									8.275292968750023
								],
								[
									73.03896484375014,
									8.264843750000026
								],
								[
									73.05585937500001,
									8.274560546875051
								],
								[
									73.07519531249994,
									8.306347656249955
								],
								[
									73.07949218750014,
									8.316503906250063
								],
								[
									73.08359375000009,
									8.311035156250114
								],
								[
									73.07978515625018,
									8.293066406250091
								],
								[
									73.06738281249994,
									8.269091796875003
								]
							]
						],
						[
							[
								[
									93.1407226562502,
									8.2495117187501
								],
								[
									93.17060546875007,
									8.212060546875023
								],
								[
									93.11523437499994,
									8.218505859375
								],
								[
									93.06425781250016,
									8.274951171875045
								],
								[
									93.07753906250002,
									8.327880859375071
								],
								[
									93.09697265625016,
									8.349365234375014
								],
								[
									93.1407226562502,
									8.2495117187501
								]
							]
						],
						[
							[
								[
									92.78749999999997,
									9.136669921875097
								],
								[
									92.74355468750002,
									9.130957031250077
								],
								[
									92.71660156250005,
									9.165087890624932
								],
								[
									92.71328125000014,
									9.204882812500045
								],
								[
									92.73857421875016,
									9.230664062499969
								],
								[
									92.76210937500014,
									9.243896484375
								],
								[
									92.78574218750009,
									9.240527343750017
								],
								[
									92.80927734375018,
									9.173388671875017
								],
								[
									92.78749999999997,
									9.136669921875097
								]
							]
						],
						[
							[
								[
									92.50283203124997,
									10.554882812500097
								],
								[
									92.47265624999994,
									10.520751953125071
								],
								[
									92.36953125000002,
									10.547412109375088
								],
								[
									92.37714843750007,
									10.650585937500054
								],
								[
									92.35283203125016,
									10.751123046875023
								],
								[
									92.37070312500009,
									10.793505859375031
								],
								[
									92.44785156250009,
									10.86552734375006
								],
								[
									92.5103515625002,
									10.897460937500071
								],
								[
									92.55400390625005,
									10.799804687500071
								],
								[
									92.57431640625009,
									10.704248046875065
								],
								[
									92.50283203124997,
									10.554882812500097
								]
							]
						],
						[
							[
								[
									72.78037109375003,
									11.202490234375048
								],
								[
									72.77304687500003,
									11.196093749999989
								],
								[
									72.77246093750011,
									11.214257812500051
								],
								[
									72.78183593750003,
									11.243310546875108
								],
								[
									72.79267578125007,
									11.26274414062506
								],
								[
									72.7958984375,
									11.260449218749955
								],
								[
									72.79287109375002,
									11.241552734375105
								],
								[
									72.78789062500016,
									11.215917968750034
								],
								[
									72.78037109375003,
									11.202490234375048
								]
							]
						],
						[
							[
								[
									92.69316406250005,
									11.381152343750031
								],
								[
									92.64453125,
									11.361328125000071
								],
								[
									92.595703125,
									11.38642578125004
								],
								[
									92.63388671875003,
									11.426757812500085
								],
								[
									92.6402343750002,
									11.509130859374991
								],
								[
									92.6900390625002,
									11.463427734375088
								],
								[
									92.68720703125018,
									11.411230468750034
								],
								[
									92.69316406250005,
									11.381152343750031
								]
							]
						],
						[
							[
								[
									93.01738281249999,
									12.036816406250026
								],
								[
									93.06210937500009,
									11.8994140625001
								],
								[
									92.98173828125005,
									11.959472656250071
								],
								[
									92.95537109375016,
									12.002441406250043
								],
								[
									92.99580078125007,
									12.03178710937506
								],
								[
									93.01738281249999,
									12.036816406250026
								]
							]
						],
						[
							[
								[
									92.71757812500005,
									12.864892578125065
								],
								[
									92.68574218750001,
									12.799951171875065
								],
								[
									92.67968749999994,
									12.939257812500017
								],
								[
									92.6944335937502,
									12.956787109375043
								],
								[
									92.71064453125007,
									12.961572265624952
								],
								[
									92.73085937499997,
									12.94853515624996
								],
								[
									92.71757812500005,
									12.864892578125065
								]
							]
						],
						[
							[
								[
									92.7227539062502,
									11.536083984375068
								],
								[
									92.70078125000009,
									11.512548828124977
								],
								[
									92.66835937500014,
									11.53872070312498
								],
								[
									92.57558593749997,
									11.718212890624955
								],
								[
									92.5596679687502,
									11.833447265624983
								],
								[
									92.53388671875018,
									11.873388671874949
								],
								[
									92.56650390625009,
									11.930517578125034
								],
								[
									92.6075195312502,
									11.949511718750003
								],
								[
									92.6318359375,
									12.013867187499969
								],
								[
									92.640625,
									12.112207031250023
								],
								[
									92.67646484375018,
									12.1923828125001
								],
								[
									92.69472656250002,
									12.21469726562502
								],
								[
									92.76923828125018,
									12.215576171875028
								],
								[
									92.78828125000007,
									12.225781250000068
								],
								[
									92.77763671875005,
									12.302539062500074
								],
								[
									92.73408203125001,
									12.335937500000028
								],
								[
									92.71894531250007,
									12.357324218749952
								],
								[
									92.72070312499994,
									12.541259765624943
								],
								[
									92.73203125000003,
									12.615624999999994
								],
								[
									92.75917968749997,
									12.669091796875051
								],
								[
									92.74003906249999,
									12.779638671875105
								],
								[
									92.75312500000018,
									12.820898437500063
								],
								[
									92.80703125000014,
									12.878906249999986
								],
								[
									92.83085937500005,
									13.002636718749969
								],
								[
									92.80898437500002,
									13.039599609375031
								],
								[
									92.86015625000016,
									13.230566406250034
								],
								[
									92.85732421875002,
									13.358105468750082
								],
								[
									92.92460937500005,
									13.48583984375
								],
								[
									93.02939453125003,
									13.543847656250094
								],
								[
									93.06230468749999,
									13.54545898437506
								],
								[
									93.06669921875005,
									13.436474609375068
								],
								[
									93.07666015625011,
									13.40068359375006
								],
								[
									93.01601562500002,
									13.336181640625057
								],
								[
									93.07382812500003,
									13.25209960937508
								],
								[
									93.06611328125018,
									13.22158203125008
								],
								[
									93.04296875,
									13.154882812500077
								],
								[
									93.00468749999999,
									13.089355468750043
								],
								[
									92.95136718750007,
									13.062500000000085
								],
								[
									92.90996093750016,
									12.975195312500063
								],
								[
									92.88623046875011,
									12.942285156250023
								],
								[
									92.96503906250018,
									12.850488281250051
								],
								[
									92.990234375,
									12.538525390625097
								],
								[
									92.9326171875,
									12.453076171875097
								],
								[
									92.86367187500014,
									12.43603515625
								],
								[
									92.87949218750009,
									12.227929687500051
								],
								[
									92.86718749999994,
									12.181445312500003
								],
								[
									92.798828125,
									12.079248046874966
								],
								[
									92.78623046875009,
									12.034667968749943
								],
								[
									92.74765625000003,
									11.992773437499935
								],
								[
									92.76396484375016,
									11.9404296875001
								],
								[
									92.79677734375002,
									11.91752929687506
								],
								[
									92.79755859375018,
									11.874658203125023
								],
								[
									92.76699218749997,
									11.7646484375
								],
								[
									92.76464843749994,
									11.639160156250014
								],
								[
									92.7227539062502,
									11.536083984375068
								]
							]
						],
						[
							[
								[
									78.71972656250006,
									31.88764648437504
								],
								[
									78.71708984375016,
									31.891015625000193
								],
								[
									78.65839843750018,
									31.965332031250057
								],
								[
									78.71972656250006,
									31.88764648437504
								],
								[
									78.68701171875,
									31.80551757812509
								],
								[
									78.69345703125003,
									31.74038085937505
								],
								[
									78.75390625000011,
									31.668359375000023
								],
								[
									78.80292968750007,
									31.61806640625008
								],
								[
									78.75507812500018,
									31.550292968750057
								],
								[
									78.72675781250018,
									31.47182617187505
								],
								[
									78.75859375000016,
									31.43657226562516
								],
								[
									78.74355468750014,
									31.32377929687499
								],
								[
									78.75781250000011,
									31.302490234375
								],
								[
									78.79160156250003,
									31.293652343750068
								],
								[
									78.84453124999999,
									31.30151367187517
								],
								[
									78.8995117187502,
									31.331347656249932
								],
								[
									78.94599609375018,
									31.33720703125016
								],
								[
									78.97392578125016,
									31.328613281250085
								],
								[
									79.01113281250008,
									31.414111328125017
								],
								[
									79.04374999999999,
									31.426220703125182
								],
								[
									79.10712890625001,
									31.402636718750074
								],
								[
									79.23261718750001,
									31.241748046875074
								],
								[
									79.33876953125014,
									31.10571289062497
								],
								[
									79.36123046875008,
									31.08696289062516
								],
								[
									79.36962890624994,
									31.079931640625148
								],
								[
									79.38847656250016,
									31.064208984375142
								],
								[
									79.49316406250006,
									30.993701171875074
								],
								[
									79.56542968750011,
									30.949072265625034
								],
								[
									79.66425781250001,
									30.96523437500005
								],
								[
									79.79462890625001,
									30.968261718750142
								],
								[
									79.87187500000016,
									30.92460937500013
								],
								[
									79.9166015625002,
									30.89418945312505
								],
								[
									79.91855468750003,
									30.889892578125057
								],
								[
									79.92451171875001,
									30.888769531250006
								],
								[
									79.9246093750001,
									30.888769531250006
								],
								[
									80.08144531250008,
									30.781933593750097
								],
								[
									80.14941406250011,
									30.789843749999932
								],
								[
									80.19433593750011,
									30.759228515625182
								],
								[
									80.20712890625003,
									30.68374023437508
								],
								[
									80.18623046875013,
									30.60532226562509
								],
								[
									80.19121093749999,
									30.568408203124932
								],
								[
									80.26093750000018,
									30.561328125000102
								],
								[
									80.40957031250014,
									30.50947265625001
								],
								[
									80.54101562500023,
									30.463525390625165
								],
								[
									80.60888671875011,
									30.448876953125193
								],
								[
									80.68212890625011,
									30.414843750000102
								],
								[
									80.74677734375001,
									30.360400390625017
								],
								[
									80.87353515625011,
									30.290576171875102
								],
								[
									80.98544921875009,
									30.237109375000045
								],
								[
									81.01025390625006,
									30.164501953124983
								],
								[
									80.96611328125005,
									30.180029296875034
								],
								[
									80.90761718750014,
									30.17192382812499
								],
								[
									80.84814453125006,
									30.139746093750006
								],
								[
									80.8199218750002,
									30.11933593750001
								],
								[
									80.68408203125011,
									29.99433593750004
								],
								[
									80.61289062500009,
									29.955859375000017
								],
								[
									80.54902343750013,
									29.899804687499966
								],
								[
									80.40185546875011,
									29.730273437500074
								],
								[
									80.31689453125011,
									29.57207031249999
								],
								[
									80.25488281250011,
									29.423339843750057
								],
								[
									80.25595703125003,
									29.318017578125108
								],
								[
									80.23300781250009,
									29.194628906250017
								],
								[
									80.16953125000009,
									29.124316406250074
								],
								[
									80.13046875000003,
									29.100390625000102
								],
								[
									80.08457031250003,
									28.99418945312513
								],
								[
									80.05166015625008,
									28.870312500000125
								],
								[
									80.07070312500014,
									28.83017578125012
								],
								[
									80.14960937500013,
									28.77607421875001
								],
								[
									80.22656250000011,
									28.723339843750097
								],
								[
									80.32480468750015,
									28.66640625000005
								],
								[
									80.41855468750003,
									28.612011718749983
								],
								[
									80.47910156250009,
									28.60488281250005
								],
								[
									80.49580078125013,
									28.63579101562513
								],
								[
									80.51787109375005,
									28.66518554687508
								],
								[
									80.58701171875009,
									28.649609375000097
								],
								[
									80.67128906250008,
									28.59624023437496
								],
								[
									80.7261718750002,
									28.55390625000004
								],
								[
									80.75078125000016,
									28.539697265624994
								],
								[
									80.89609375000015,
									28.468554687500074
								],
								[
									81.01660156250011,
									28.40957031250005
								],
								[
									81.16894531250017,
									28.33500976562513
								],
								[
									81.20625000000001,
									28.289404296874977
								],
								[
									81.23896484375001,
									28.240869140625136
								],
								[
									81.31083984374999,
									28.176367187500148
								],
								[
									81.48603515625007,
									28.062207031250153
								],
								[
									81.63554687499999,
									27.98046875000003
								],
								[
									81.75722656250008,
									27.91381835937503
								],
								[
									81.85263671875015,
									27.867089843750108
								],
								[
									81.89687500000014,
									27.874462890625097
								],
								[
									81.94521484375014,
									27.899267578125006
								],
								[
									81.98769531250014,
									27.91376953125001
								],
								[
									82.03701171875008,
									27.900585937500097
								],
								[
									82.11191406250003,
									27.86494140625001
								],
								[
									82.28769531250015,
									27.75654296875004
								],
								[
									82.45136718750001,
									27.67182617187501
								],
								[
									82.62988281250006,
									27.687060546875017
								],
								[
									82.67734375000003,
									27.673437500000006
								],
								[
									82.71083984375014,
									27.596679687500085
								],
								[
									82.73339843750011,
									27.518994140625153
								],
								[
									82.93281250000013,
									27.46767578125008
								],
								[
									83.06406250000003,
									27.444531249999983
								],
								[
									83.21386718750011,
									27.402294921875097
								],
								[
									83.28974609375001,
									27.370996093750108
								],
								[
									83.36943359374999,
									27.410253906250034
								],
								[
									83.38398437500001,
									27.444824218750142
								],
								[
									83.44716796875014,
									27.465332031250057
								],
								[
									83.55166015625008,
									27.45634765624999
								],
								[
									83.74697265625008,
									27.39594726562504
								],
								[
									83.82880859375018,
									27.37783203125008
								],
								[
									83.89716796875013,
									27.435107421875017
								],
								[
									84.02480468750014,
									27.46166992187503
								],
								[
									84.09101562500001,
									27.491357421875108
								],
								[
									84.22978515625016,
									27.427832031250063
								],
								[
									84.48085937500014,
									27.348193359375074
								],
								[
									84.61015624999999,
									27.298681640625034
								],
								[
									84.6407226562502,
									27.249853515625034
								],
								[
									84.65478515625011,
									27.203662109375045
								],
								[
									84.65380859375011,
									27.09169921875005
								],
								[
									84.6853515625001,
									27.04101562500003
								],
								[
									84.93720703125013,
									26.92690429687505
								],
								[
									85.02011718750009,
									26.878515625000063
								],
								[
									85.08730468750014,
									26.86293945312508
								],
								[
									85.12539062500008,
									26.860986328125023
								],
								[
									85.15156250000018,
									26.84663085937504
								],
								[
									85.17412109375016,
									26.781542968750017
								],
								[
									85.19179687500008,
									26.766552734375068
								],
								[
									85.24023437500011,
									26.750341796875063
								],
								[
									85.29296875000011,
									26.741015625000017
								],
								[
									85.45644531250008,
									26.797216796875006
								],
								[
									85.5684570312502,
									26.839843750000085
								],
								[
									85.64843750000006,
									26.829003906249994
								],
								[
									85.69990234375007,
									26.781640625000023
								],
								[
									85.70742187500014,
									26.712646484375
								],
								[
									85.73730468750011,
									26.63974609375009
								],
								[
									85.79453125000003,
									26.604150390625023
								],
								[
									85.85566406250018,
									26.600195312500006
								],
								[
									86.00732421875006,
									26.649365234375097
								],
								[
									86.12939453125006,
									26.611718749999966
								],
								[
									86.24160156250008,
									26.597998046875006
								],
								[
									86.36611328125008,
									26.574414062500097
								],
								[
									86.41445312500014,
									26.556298828125136
								],
								[
									86.54365234375007,
									26.495996093750108
								],
								[
									86.70136718750013,
									26.43505859375003
								],
								[
									86.76249999999999,
									26.441943359375017
								],
								[
									87.01640625000005,
									26.555419921875142
								],
								[
									87.03789062500016,
									26.541601562499977
								],
								[
									87.08955078125001,
									26.433203125000006
								],
								[
									87.1667968750001,
									26.394238281250068
								],
								[
									87.28740234374999,
									26.360302734375068
								],
								[
									87.41357421875011,
									26.422949218750148
								],
								[
									87.51308593750014,
									26.40498046875004
								],
								[
									87.63339843750003,
									26.399121093750097
								],
								[
									87.74882812500005,
									26.429296875000006
								],
								[
									87.84921875000003,
									26.43691406250005
								],
								[
									87.99511718750011,
									26.38237304687496
								],
								[
									88.0269531250002,
									26.395019531250142
								],
								[
									88.05488281250001,
									26.430029296874977
								],
								[
									88.11152343750001,
									26.586425781250057
								],
								[
									88.16152343750008,
									26.724804687500097
								],
								[
									88.15722656250011,
									26.807324218750125
								],
								[
									88.11103515625013,
									26.928466796875114
								],
								[
									87.99316406250006,
									27.086083984374966
								],
								[
									87.98437500000006,
									27.13393554687505
								],
								[
									88.02412109375018,
									27.40888671875001
								],
								[
									88.06787109375011,
									27.56738281249997
								],
								[
									88.10556640625003,
									27.642431640624977
								],
								[
									88.14697265625011,
									27.749218750000068
								],
								[
									88.15429687500011,
									27.79868164062512
								],
								[
									88.15029296875008,
									27.843310546875045
								],
								[
									88.10976562500014,
									27.87060546875003
								],
								[
									88.0989257812501,
									27.904541015625085
								],
								[
									88.10898437500003,
									27.933007812500023
								],
								[
									88.14111328125011,
									27.948925781250068
								],
								[
									88.27519531250016,
									27.968847656250148
								],
								[
									88.42597656250013,
									28.011669921875068
								],
								[
									88.48613281250016,
									28.034472656250102
								],
								[
									88.5316406250002,
									28.057373046875057
								],
								[
									88.57792968749999,
									28.093359375000006
								],
								[
									88.62109375000011,
									28.09184570312516
								],
								[
									88.75625000000008,
									28.039697265625193
								],
								[
									88.80371093750011,
									28.00693359375009
								],
								[
									88.82861328125011,
									27.907275390624932
								],
								[
									88.84882812500007,
									27.868652343750057
								],
								[
									88.82988281249999,
									27.76738281250013
								],
								[
									88.74902343749994,
									27.521875000000023
								],
								[
									88.76484375000018,
									27.429882812500125
								],
								[
									88.83251953125011,
									27.362841796875045
								],
								[
									88.89140624999999,
									27.316064453125023
								],
								[
									88.88164062500005,
									27.297460937500148
								],
								[
									88.76035156250003,
									27.218115234375148
								],
								[
									88.73876953125011,
									27.17558593749999
								],
								[
									88.76562500000006,
									27.13422851562501
								],
								[
									88.81357421875003,
									27.099023437500023
								],
								[
									88.83515625000001,
									27.06557617187505
								],
								[
									88.85761718750013,
									26.96147460937499
								],
								[
									88.91914062500018,
									26.932226562500063
								],
								[
									89.04091796875008,
									26.865039062500045
								],
								[
									89.14824218750005,
									26.816162109375142
								],
								[
									89.3321289062502,
									26.848632812500085
								],
								[
									89.38417968750014,
									26.826562500000136
								],
								[
									89.47460937500006,
									26.80341796875004
								],
								[
									89.54511718750007,
									26.796240234374977
								],
								[
									89.58613281250007,
									26.778955078125108
								],
								[
									89.60917968750016,
									26.762207031250057
								],
								[
									89.60615234375007,
									26.741113281250136
								],
								[
									89.60996093750009,
									26.719433593750153
								],
								[
									89.71093750000006,
									26.713916015625102
								],
								[
									89.76386718750001,
									26.701562499999966
								],
								[
									89.94316406250016,
									26.72392578124999
								],
								[
									90.12294921875008,
									26.75458984375004
								],
								[
									90.20605468750006,
									26.847509765625034
								],
								[
									90.24238281250007,
									26.854150390624966
								],
								[
									90.34589843750001,
									26.890332031250153
								],
								[
									90.44765625000008,
									26.850781250000097
								],
								[
									90.55986328124999,
									26.796582031250068
								],
								[
									90.62031250000018,
									26.78022460937501
								],
								[
									90.73964843750014,
									26.77167968750004
								],
								[
									90.8557617187501,
									26.777734375000136
								],
								[
									91.13388671875009,
									26.80341796875004
								],
								[
									91.28652343750008,
									26.789941406250136
								],
								[
									91.42675781250006,
									26.867089843750023
								],
								[
									91.4558593750001,
									26.866894531250068
								],
								[
									91.51757812500006,
									26.807324218750125
								],
								[
									91.67158203125001,
									26.802001953125
								],
								[
									91.75371093750016,
									26.830761718750097
								],
								[
									91.8420898437501,
									26.852978515625097
								],
								[
									91.89863281250007,
									26.86005859375001
								],
								[
									91.94375000000014,
									26.860839843750085
								],
								[
									91.99833984375005,
									26.854980468750057
								],
								[
									92.04970703125014,
									26.874853515625006
								],
								[
									92.07343750000007,
									26.914843750000074
								],
								[
									92.06816406249999,
									26.975195312500034
								],
								[
									92.0308593750002,
									27.04082031249999
								],
								[
									91.99863281250003,
									27.07929687500001
								],
								[
									91.99228515625015,
									27.099902343750045
								],
								[
									92.00253906250009,
									27.147363281250023
								],
								[
									92.03115234375008,
									27.214306640624983
								],
								[
									92.08339843750008,
									27.290624999999977
								],
								[
									92.04492187500006,
									27.364697265625068
								],
								[
									91.99082031250003,
									27.450195312500085
								],
								[
									91.95097656249999,
									27.458300781250045
								],
								[
									91.85126953125001,
									27.438623046875023
								],
								[
									91.74306640625008,
									27.442529296875108
								],
								[
									91.65810546875014,
									27.49360351562504
								],
								[
									91.59472656250006,
									27.557666015625045
								],
								[
									91.57929687500007,
									27.611425781250063
								],
								[
									91.59765625000006,
									27.677001953125
								],
								[
									91.62587890625014,
									27.73730468750003
								],
								[
									91.63193359375009,
									27.75996093750004
								],
								[
									91.71259765625001,
									27.759814453125102
								],
								[
									91.82470703125011,
									27.746435546875034
								],
								[
									91.90937500000013,
									27.729687500000097
								],
								[
									91.9776367187502,
									27.73037109375005
								],
								[
									92.10126953125018,
									27.807617187500057
								],
								[
									92.15761718750008,
									27.812255859374943
								],
								[
									92.2222656250002,
									27.826953125000102
								],
								[
									92.25048828125011,
									27.84150390625004
								],
								[
									92.2701171875002,
									27.83022460937505
								],
								[
									92.34101562500013,
									27.820751953125068
								],
								[
									92.41484374999999,
									27.824609374999966
								],
								[
									92.4806640625003,
									27.845947265625057
								],
								[
									92.5466796875001,
									27.879199218750074
								],
								[
									92.6643554687501,
									27.948925781250068
								],
								[
									92.68779296874999,
									27.988964843750153
								],
								[
									92.68749999999994,
									28.02573242187509
								],
								[
									92.66562500000032,
									28.04985351562513
								],
								[
									92.64345703125014,
									28.0615234375
								],
								[
									92.65253906250001,
									28.093359375000006
								],
								[
									92.70185546875001,
									28.14711914062505
								],
								[
									92.88183593750011,
									28.22812500000012
								],
								[
									93.0349609375001,
									28.327636718750057
								],
								[
									93.11923828125009,
									28.402294921875068
								],
								[
									93.1578125000002,
									28.492724609375017
								],
								[
									93.20654296875011,
									28.590820312500114
								],
								[
									93.25195312500011,
									28.62949218750009
								],
								[
									93.36054687500001,
									28.654052734375114
								],
								[
									93.66494140625014,
									28.690234374999932
								],
								[
									93.76074218750011,
									28.72978515624999
								],
								[
									93.90224609374997,
									28.80322265625003
								],
								[
									93.97363281249994,
									28.86079101562504
								],
								[
									94.01328125000003,
									28.90751953124996
								],
								[
									94.01767578125003,
									28.959521484375074
								],
								[
									94.11152343750018,
									28.97587890625013
								],
								[
									94.19345703125009,
									29.059912109375006
								],
								[
									94.29326171875016,
									29.14462890624995
								],
								[
									94.46806640625016,
									29.216210937499966
								],
								[
									94.62304687500011,
									29.312402343750023
								],
								[
									94.67705078124999,
									29.297021484375193
								],
								[
									94.73339843750023,
									29.25161132812508
								],
								[
									94.76308593750014,
									29.20126953124995
								],
								[
									94.7694335937502,
									29.175878906250006
								],
								[
									94.96748046875001,
									29.144042968750114
								],
								[
									94.99882812499999,
									29.149169921875085
								],
								[
									95.14472656250018,
									29.10405273437513
								],
								[
									95.27910156249999,
									29.049560546874943
								],
								[
									95.35312500000009,
									29.035888671875
								],
								[
									95.38925781250003,
									29.03740234374996
								],
								[
									95.42021484375016,
									29.05429687500012
								],
								[
									95.45654296875011,
									29.10229492187503
								],
								[
									95.4937500000002,
									29.137011718750102
								],
								[
									95.51699218750014,
									29.151171875000045
								],
								[
									95.51582031250018,
									29.206347656250102
								],
								[
									95.71035156250008,
									29.313818359375063
								],
								[
									95.88505859375016,
									29.39091796875013
								],
								[
									96.03535156250013,
									29.44716796875005
								],
								[
									96.07958984375011,
									29.424121093750045
								],
								[
									96.1285156250002,
									29.381396484375045
								],
								[
									96.19472656250008,
									29.272460937500057
								],
								[
									96.23496093750003,
									29.245800781249955
								],
								[
									96.33720703124999,
									29.26098632812503
								],
								[
									96.35585937499997,
									29.249072265625102
								],
								[
									96.33974609375014,
									29.20981445312509
								],
								[
									96.27050781250011,
									29.161230468750063
								],
								[
									96.18085937500001,
									29.11767578124997
								],
								[
									96.12236328125005,
									29.082080078125102
								],
								[
									96.14140625000016,
									28.96347656250009
								],
								[
									96.13710937500008,
									28.922607421875114
								],
								[
									96.16220703125003,
									28.90971679687516
								],
								[
									96.34687500000001,
									29.027441406250063
								],
								[
									96.4357421875003,
									29.050683593749994
								],
								[
									96.46708984374999,
									29.022265625000074
								],
								[
									96.4771484375002,
									28.959326171875034
								],
								[
									96.55000000000013,
									28.82958984375017
								],
								[
									96.58085937500016,
									28.76367187499997
								],
								[
									96.39560546875015,
									28.60654296875012
								],
								[
									96.32734375000001,
									28.525390625
								],
								[
									96.32988281250005,
									28.496826171875057
								],
								[
									96.326171875,
									28.46855468750016
								],
								[
									96.27890625000032,
									28.42817382812501
								],
								[
									96.28144531250013,
									28.41206054687501
								],
								[
									96.31982421875011,
									28.386523437500045
								],
								[
									96.36640625000018,
									28.367285156250034
								],
								[
									96.38906250000002,
									28.367919921875085
								],
								[
									96.42773437500017,
									28.40600585937503
								],
								[
									96.60263671875009,
									28.459912109375182
								],
								[
									96.65283203125011,
									28.44975585937496
								],
								[
									96.77578125000008,
									28.36704101562509
								],
								[
									96.83300781250023,
									28.36240234375012
								],
								[
									96.98085937500014,
									28.337695312500045
								],
								[
									97.07539062500001,
									28.368945312500017
								],
								[
									97.1451171875002,
									28.340332031250057
								],
								[
									97.28945312500014,
									28.236816406250114
								],
								[
									97.32246093750018,
									28.217968750000097
								],
								[
									97.31025390625018,
									28.155224609375097
								],
								[
									97.302734375,
									28.085986328124932
								],
								[
									97.33916015625005,
									28.030859375000063
								],
								[
									97.34355468750005,
									27.98232421875005
								],
								[
									97.33515625000018,
									27.937744140625114
								],
								[
									97.30615234374994,
									27.907080078124977
								],
								[
									97.22607421875006,
									27.89003906250008
								],
								[
									97.15781250000032,
									27.836865234374983
								],
								[
									97.04970703125014,
									27.760009765625057
								],
								[
									96.96279296875002,
									27.69829101562499
								],
								[
									96.89970703125005,
									27.643847656250102
								],
								[
									96.87685546875014,
									27.586718750000102
								],
								[
									96.8835937500001,
									27.51484375000001
								],
								[
									96.9019531250002,
									27.43959960937505
								],
								[
									97.10371093750001,
									27.16333007812517
								],
								[
									97.10205078125011,
									27.115429687500182
								],
								[
									97.03808593750017,
									27.10205078125003
								],
								[
									96.9534179687501,
									27.13330078125
								],
								[
									96.88027343750014,
									27.177832031250006
								],
								[
									96.79785156249994,
									27.29619140624996
								],
								[
									96.73164062500018,
									27.331494140625153
								],
								[
									96.66572265625013,
									27.339257812500136
								],
								[
									96.27421875000016,
									27.27836914062516
								],
								[
									96.19082031250014,
									27.26127929687496
								],
								[
									96.06142578125014,
									27.217089843750017
								],
								[
									95.97089843750018,
									27.128076171874994
								],
								[
									95.90527343750023,
									27.046630859375114
								],
								[
									95.83730468750014,
									27.013818359374994
								],
								[
									95.73837890625003,
									26.950439453125142
								],
								[
									95.46386718750006,
									26.756054687500153
								],
								[
									95.30507812500014,
									26.672265625000136
								],
								[
									95.20146484375016,
									26.641406250000074
								],
								[
									95.12871093749999,
									26.597265625000034
								],
								[
									95.08945312500015,
									26.525488281249977
								],
								[
									95.05976562500018,
									26.473974609375063
								],
								[
									95.05087890625003,
									26.34726562500009
								],
								[
									95.06894531250009,
									26.191113281250068
								],
								[
									95.10839843750011,
									26.091406250000006
								],
								[
									95.12929687500014,
									26.07041015625009
								],
								[
									95.13242187500003,
									26.041259765625
								],
								[
									95.0929687500003,
									25.987304687499943
								],
								[
									95.04072265625001,
									25.94130859375008
								],
								[
									95.01523437500009,
									25.912939453124977
								],
								[
									94.99199218750005,
									25.770458984375097
								],
								[
									94.94570312500014,
									25.70024414062499
								],
								[
									94.86113281250005,
									25.597216796875045
								],
								[
									94.78583984375013,
									25.51933593749999
								],
								[
									94.66777343750016,
									25.458886718749937
								],
								[
									94.62285156250016,
									25.410009765625006
								],
								[
									94.57988281249999,
									25.31982421875003
								],
								[
									94.55439453125007,
									25.243457031250102
								],
								[
									94.55302734375016,
									25.21572265625005
								],
								[
									94.56650390625003,
									25.19150390625009
								],
								[
									94.61562500000008,
									25.164599609375017
								],
								[
									94.67529296875011,
									25.13857421875005
								],
								[
									94.7037109375002,
									25.097851562499926
								],
								[
									94.7076171875002,
									25.048730468750136
								],
								[
									94.66328125000001,
									24.931005859375034
								],
								[
									94.58408203125009,
									24.767236328125165
								],
								[
									94.49316406250011,
									24.637646484374955
								],
								[
									94.39941406250011,
									24.514062500000108
								],
								[
									94.37724609375005,
									24.473730468750063
								],
								[
									94.2930664062502,
									24.32187500000012
								],
								[
									94.21972656250011,
									24.11318359375005
								],
								[
									94.17031250000014,
									23.972656250000114
								],
								[
									94.12763671875018,
									23.876464843750057
								],
								[
									94.07480468750003,
									23.872070312500057
								],
								[
									94.01083984375015,
									23.90292968750012
								],
								[
									93.85546875000011,
									23.943896484375017
								],
								[
									93.75585937500011,
									23.97690429687509
								],
								[
									93.68339843750016,
									24.006542968750097
								],
								[
									93.63330078125006,
									24.00537109375003
								],
								[
									93.5640625000002,
									23.986083984375
								],
								[
									93.49375000000015,
									23.972851562500153
								],
								[
									93.45214843750011,
									23.987402343750006
								],
								[
									93.35556640625009,
									24.07412109375008
								],
								[
									93.32626953125003,
									24.064208984375114
								],
								[
									93.30732421875001,
									24.021875000000193
								],
								[
									93.37255859375006,
									23.774169921875085
								],
								[
									93.41494140625008,
									23.682080078125068
								],
								[
									93.40810546875014,
									23.528027343750125
								],
								[
									93.39130859375018,
									23.339160156250102
								],
								[
									93.36601562500016,
									23.132519531249926
								],
								[
									93.34941406250016,
									23.0849609375
								],
								[
									93.30800781250014,
									23.030371093749977
								],
								[
									93.25351562500009,
									23.015478515625063
								],
								[
									93.20390624999999,
									23.037011718750108
								],
								[
									93.16416015625015,
									23.03203125000016
								],
								[
									93.15097656250003,
									22.997314453125
								],
								[
									93.16250000000008,
									22.907958984375
								],
								[
									93.11425781250023,
									22.80571289062496
								],
								[
									93.07871093750015,
									22.718212890625068
								],
								[
									93.08818359375016,
									22.633251953125097
								],
								[
									93.10507812500032,
									22.54711914062503
								],
								[
									93.16201171874997,
									22.360205078125063
								],
								[
									93.16240234375027,
									22.29189453125008
								],
								[
									93.15117187499999,
									22.230615234375136
								],
								[
									93.1214843750002,
									22.205175781250006
								],
								[
									93.07060546875005,
									22.209423828124983
								],
								[
									93.04296875000006,
									22.18398437500005
								],
								[
									93.02197265625017,
									22.145703125000068
								],
								[
									92.96455078125018,
									22.003759765625006
								],
								[
									92.90947265625016,
									21.988916015624994
								],
								[
									92.85429687499999,
									22.010156250000165
								],
								[
									92.77138671874997,
									22.104785156250074
								],
								[
									92.7209960937501,
									22.132421875000006
								],
								[
									92.68896484375006,
									22.130957031249977
								],
								[
									92.67470703125008,
									22.106005859375045
								],
								[
									92.65263671875016,
									22.049316406250142
								],
								[
									92.63037109375011,
									22.01132812499995
								],
								[
									92.57490234375001,
									21.978076171875102
								],
								[
									92.56123046875018,
									22.048046875000068
								],
								[
									92.5318359375002,
									22.41030273437505
								],
								[
									92.50957031250005,
									22.525683593750017
								],
								[
									92.49140625000007,
									22.685400390625063
								],
								[
									92.46445312500009,
									22.734423828125102
								],
								[
									92.43046875000016,
									22.821826171875045
								],
								[
									92.3931640625002,
									22.89702148437499
								],
								[
									92.36162109374999,
									22.92900390625013
								],
								[
									92.34121093750008,
									23.069824218749943
								],
								[
									92.33378906249999,
									23.242382812499926
								],
								[
									92.3341796875003,
									23.32382812500009
								],
								[
									92.28935546875005,
									23.492480468750074
								],
								[
									92.24609375000011,
									23.683593750000114
								],
								[
									92.18710937500003,
									23.675537109375057
								],
								[
									92.15234375000006,
									23.721875000000182
								],
								[
									92.12705078125009,
									23.72099609374999
								],
								[
									92.04404296875003,
									23.67778320312499
								],
								[
									91.97851562500011,
									23.691992187500034
								],
								[
									91.92958984375008,
									23.685986328125153
								],
								[
									91.92949218750027,
									23.59824218749995
								],
								[
									91.93789062500008,
									23.504687500000074
								],
								[
									91.9191406250003,
									23.471044921875063
								],
								[
									91.79003906250006,
									23.36103515625004
								],
								[
									91.75419921875016,
									23.28730468750001
								],
								[
									91.7579101562502,
									23.209814453125034
								],
								[
									91.77382812499997,
									23.10610351562505
								],
								[
									91.75097656250011,
									23.05351562499999
								],
								[
									91.69492187500009,
									23.004833984375125
								],
								[
									91.61953124999997,
									22.979687500000153
								],
								[
									91.5535156250001,
									22.991552734374977
								],
								[
									91.51123046875011,
									23.033691406250142
								],
								[
									91.47138671875018,
									23.141259765625108
								],
								[
									91.43623046875001,
									23.199902343750068
								],
								[
									91.39941406250006,
									23.21386718749997
								],
								[
									91.37060546875006,
									23.197998046874943
								],
								[
									91.3667968750002,
									23.130468750000034
								],
								[
									91.36865234375023,
									23.07456054687512
								],
								[
									91.35937500000011,
									23.068359375
								],
								[
									91.33886718750011,
									23.077001953124977
								],
								[
									91.31523437500016,
									23.10439453125005
								],
								[
									91.2538085937502,
									23.37363281250012
								],
								[
									91.16552734375011,
									23.5810546875
								],
								[
									91.16044921875027,
									23.660644531250142
								],
								[
									91.1924804687502,
									23.762890625000097
								],
								[
									91.23203125000015,
									23.920458984375045
								],
								[
									91.33642578125011,
									24.018798828125
								],
								[
									91.3501953125002,
									24.060498046875068
								],
								[
									91.36708984375014,
									24.093505859374943
								],
								[
									91.39267578125003,
									24.100097656250142
								],
								[
									91.52636718750011,
									24.090771484374926
								],
								[
									91.57138671875015,
									24.10659179687505
								],
								[
									91.61113281250016,
									24.152832031250057
								],
								[
									91.66875000000016,
									24.19008789062508
								],
								[
									91.72656250000011,
									24.205078124999943
								],
								[
									91.77246093750011,
									24.21064453125001
								],
								[
									91.84619140625,
									24.17529296875
								],
								[
									91.87695312500023,
									24.195312500000085
								],
								[
									91.89902343750015,
									24.260693359375182
								],
								[
									91.93105468750014,
									24.325537109375063
								],
								[
									91.95166015624994,
									24.356738281250017
								],
								[
									92.00107421875015,
									24.370898437500074
								],
								[
									92.06416015625007,
									24.374365234375063
								],
								[
									92.08505859375003,
									24.386181640625068
								],
								[
									92.10195312500014,
									24.40805664062509
								],
								[
									92.11748046874999,
									24.49394531249999
								],
								[
									92.19804687500027,
									24.685742187499983
								],
								[
									92.2266601562502,
									24.770996093749943
								],
								[
									92.23056640625015,
									24.786230468750034
								],
								[
									92.22832031250005,
									24.881347656250142
								],
								[
									92.2512695312501,
									24.895068359375102
								],
								[
									92.38496093750007,
									24.84877929687508
								],
								[
									92.44316406249999,
									24.849414062500017
								],
								[
									92.47500000000008,
									24.868505859375006
								],
								[
									92.4854492187502,
									24.903320312500085
								],
								[
									92.46835937500015,
									24.944140625000045
								],
								[
									92.37343750000008,
									25.015136718749943
								],
								[
									92.2046875000002,
									25.110937500000006
								],
								[
									92.04970703125025,
									25.169482421875045
								],
								[
									91.76347656249999,
									25.160644531250114
								],
								[
									91.4796875000003,
									25.14213867187516
								],
								[
									91.39667968750013,
									25.151611328125142
								],
								[
									91.29316406250001,
									25.177978515625085
								],
								[
									91.03828125000013,
									25.174072265625
								],
								[
									90.73017578125018,
									25.159472656250045
								],
								[
									90.61308593750005,
									25.167724609374943
								],
								[
									90.55527343750003,
									25.166601562499977
								],
								[
									90.43935546875014,
									25.157714843750142
								],
								[
									90.25039062500014,
									25.18496093750008
								],
								[
									90.11962890625011,
									25.21997070312503
								],
								[
									90.00380859374997,
									25.258349609375017
								],
								[
									89.8663085937502,
									25.293164062499926
								],
								[
									89.83330078125016,
									25.292773437500017
								],
								[
									89.81406250000003,
									25.305371093749926
								],
								[
									89.8008789062502,
									25.336132812500068
								],
								[
									89.79628906249997,
									25.375830078124977
								],
								[
									89.82490234375001,
									25.560156250000063
								],
								[
									89.79960937500005,
									25.839599609375142
								],
								[
									89.82294921875018,
									25.94140625
								],
								[
									89.70986328125014,
									26.17124023437512
								],
								[
									89.67089843750011,
									26.213818359375182
								],
								[
									89.61904296875008,
									26.215673828125006
								],
								[
									89.58574218750027,
									26.186035156250114
								],
								[
									89.57275390625011,
									26.13232421875
								],
								[
									89.59140625000009,
									26.07241210937505
								],
								[
									89.54990234375003,
									26.00527343750005
								],
								[
									89.4668945312502,
									25.983544921875165
								],
								[
									89.36972656250032,
									26.006103515625142
								],
								[
									89.28925781250013,
									26.037597656250057
								],
								[
									89.18642578125014,
									26.105957031250057
								],
								[
									89.10830078125014,
									26.202246093750034
								],
								[
									89.10195312500008,
									26.30834960937497
								],
								[
									89.06679687500014,
									26.376904296875182
								],
								[
									89.0186523437502,
									26.41025390624995
								],
								[
									88.98339843750011,
									26.419531249999977
								],
								[
									88.95195312499999,
									26.41210937499997
								],
								[
									88.92412109374999,
									26.375097656249977
								],
								[
									88.94824218750011,
									26.337988281249977
								],
								[
									88.98154296875015,
									26.28613281250017
								],
								[
									88.97041015625001,
									26.250878906249994
								],
								[
									88.94072265625005,
									26.24536132812503
								],
								[
									88.89648437500006,
									26.260498046875
								],
								[
									88.82802734375014,
									26.252197265625085
								],
								[
									88.76191406250013,
									26.279394531250034
								],
								[
									88.72216796875006,
									26.28183593750009
								],
								[
									88.68281250000007,
									26.291699218749955
								],
								[
									88.68066406250006,
									26.35297851562501
								],
								[
									88.62011718750006,
									26.43066406250003
								],
								[
									88.51826171875001,
									26.51777343750001
								],
								[
									88.41816406250013,
									26.571533203124943
								],
								[
									88.36992187499999,
									26.564111328125136
								],
								[
									88.34589843750018,
									26.504785156250023
								],
								[
									88.35146484375014,
									26.482568359374937
								],
								[
									88.38623046875011,
									26.471533203125006
								],
								[
									88.43671875000001,
									26.437109375000006
								],
								[
									88.44785156250009,
									26.401025390625023
								],
								[
									88.4404296875,
									26.36948242187509
								],
								[
									88.37802734375003,
									26.312011718750114
								],
								[
									88.33398437499994,
									26.257519531249926
								],
								[
									88.2351562500001,
									26.17807617187509
								],
								[
									88.15078125000014,
									26.08715820312503
								],
								[
									88.12900390625015,
									26.018212890625023
								],
								[
									88.09736328125018,
									25.95634765625013
								],
								[
									88.08457031250003,
									25.888232421875102
								],
								[
									88.10664062500018,
									25.841113281250102
								],
								[
									88.1474609375,
									25.811425781249994
								],
								[
									88.25292968749994,
									25.78979492187503
								],
								[
									88.3630859375001,
									25.69819335937501
								],
								[
									88.4523437500003,
									25.574414062500125
								],
								[
									88.50244140625006,
									25.537011718750136
								],
								[
									88.59345703125013,
									25.495312500000068
								],
								[
									88.76914062500003,
									25.49047851562497
								],
								[
									88.79541015625006,
									25.456249999999926
								],
								[
									88.82031250000011,
									25.365527343750102
								],
								[
									88.85478515624999,
									25.333544921875074
								],
								[
									88.94414062499999,
									25.29077148437497
								],
								[
									88.95166015625023,
									25.259277343749943
								],
								[
									88.9297851562502,
									25.22299804687512
								],
								[
									88.89013671875011,
									25.194384765625045
								],
								[
									88.81728515625008,
									25.176220703125182
								],
								[
									88.74755859375011,
									25.168945312500114
								],
								[
									88.67753906250016,
									25.18046875000016
								],
								[
									88.57382812500003,
									25.187890624999966
								],
								[
									88.45625000000018,
									25.188427734375182
								],
								[
									88.3729492187502,
									24.961523437500034
								],
								[
									88.31337890625014,
									24.88183593749997
								],
								[
									88.27949218750013,
									24.88193359375009
								],
								[
									88.18886718750014,
									24.920605468750153
								],
								[
									88.14980468750008,
									24.91464843750009
								],
								[
									88.04511718750018,
									24.713037109375136
								],
								[
									88.03027343750006,
									24.664453125000193
								],
								[
									88.02343750000011,
									24.627832031250193
								],
								[
									88.07910156250006,
									24.54990234375012
								],
								[
									88.14550781250011,
									24.485791015624926
								],
								[
									88.22500000000014,
									24.460644531249955
								],
								[
									88.28710937500011,
									24.479736328124943
								],
								[
									88.33750000000003,
									24.453857421875
								],
								[
									88.39697265625011,
									24.389257812499977
								],
								[
									88.49853515625011,
									24.346630859375097
								],
								[
									88.64228515625013,
									24.32597656250016
								],
								[
									88.72353515625008,
									24.274902343750057
								],
								[
									88.73359375000018,
									24.230908203125153
								],
								[
									88.72656250000011,
									24.18623046875001
								],
								[
									88.71376953125014,
									24.06962890625016
								],
								[
									88.69980468750003,
									24.002539062499977
								],
								[
									88.62255859374994,
									23.826367187500153
								],
								[
									88.56738281250006,
									23.674414062500006
								],
								[
									88.59599609375016,
									23.602197265625136
								],
								[
									88.61640625000001,
									23.572753906250085
								],
								[
									88.6357421875,
									23.550000000000068
								],
								[
									88.69765624999997,
									23.493017578125006
								],
								[
									88.74082031250009,
									23.436621093750063
								],
								[
									88.70400390625014,
									23.292822265624977
								],
								[
									88.72441406249999,
									23.254980468750006
								],
								[
									88.80761718750006,
									23.229687500000097
								],
								[
									88.8970703125002,
									23.210400390624983
								],
								[
									88.92812500000014,
									23.18662109375012
								],
								[
									88.85058593750011,
									23.040527343750114
								],
								[
									88.86699218749999,
									22.93886718750008
								],
								[
									88.89970703124999,
									22.843505859375114
								],
								[
									88.92343750000003,
									22.687548828125045
								],
								[
									88.92695312500007,
									22.67114257812517
								],
								[
									88.92070312500005,
									22.632031249999926
								],
								[
									88.97148437500016,
									22.51093750000004
								],
								[
									89.05000000000018,
									22.27460937500004
								],
								[
									89.05585937500001,
									22.186230468750153
								],
								[
									89.05146484375001,
									22.093164062500193
								],
								[
									89.02792968750032,
									21.93720703125004
								],
								[
									88.94931640625015,
									21.937939453125097
								],
								[
									89.0196289062502,
									21.83364257812508
								],
								[
									89.04199218749994,
									21.758691406249994
								],
								[
									89.05166015624997,
									21.654101562500102
								],
								[
									88.96708984375016,
									21.64135742187517
								],
								[
									88.90742187500018,
									21.65307617187497
								],
								[
									88.8575195312502,
									21.744677734375074
								],
								[
									88.83437500000014,
									21.661376953125057
								],
								[
									88.74501953125014,
									21.584375000000108
								],
								[
									88.71298828125015,
									21.621972656250023
								],
								[
									88.69472656250008,
									21.662402343750017
								],
								[
									88.69121093749993,
									21.733496093750006
								],
								[
									88.74023437500011,
									22.00541992187499
								],
								[
									88.73027343750016,
									22.03608398437501
								],
								[
									88.70830078124999,
									22.056152343750114
								],
								[
									88.65957031250014,
									22.066943359374903
								],
								[
									88.64160156250011,
									22.121972656250108
								],
								[
									88.56679687500014,
									21.832128906250034
								],
								[
									88.59980468750001,
									21.71376953125008
								],
								[
									88.58466796875013,
									21.659716796874903
								],
								[
									88.44599609375007,
									21.614257812500057
								],
								[
									88.30546874999999,
									21.723339843750068
								],
								[
									88.28750000000025,
									21.758203125000165
								],
								[
									88.27919921874997,
									21.696875000000006
								],
								[
									88.25371093750005,
									21.622314453124915
								],
								[
									88.12207031249994,
									21.635791015625102
								],
								[
									88.05683593750018,
									21.69414062499999
								],
								[
									88.09941406250016,
									21.79355468750009
								],
								[
									88.18105468750025,
									22.032910156250182
								],
								[
									88.1962890625,
									22.13955078125005
								],
								[
									88.08710937500001,
									22.217724609375068
								],
								[
									87.99443359375016,
									22.265673828125074
								],
								[
									87.94140625000011,
									22.374316406250102
								],
								[
									87.96162109375001,
									22.255029296875136
								],
								[
									88.01074218750011,
									22.21264648437503
								],
								[
									88.08300781250006,
									22.182714843750148
								],
								[
									88.15927734375015,
									22.12172851562505
								],
								[
									88.1041015625002,
									22.04736328125
								],
								[
									88.05078125000006,
									22.00107421875009
								],
								[
									87.94843749999995,
									21.825439453124915
								],
								[
									87.82373046875011,
									21.727343750000102
								],
								[
									87.67822265625011,
									21.653515625000153
								],
								[
									87.20068359375011,
									21.544873046874955
								],
								[
									87.10068359375003,
									21.50078125000013
								],
								[
									86.95410156250023,
									21.365332031250063
								],
								[
									86.85957031250007,
									21.23671875000005
								],
								[
									86.84228515625006,
									21.106347656249966
								],
								[
									86.89580078125016,
									20.965576171875057
								],
								[
									86.93935546875025,
									20.745068359375182
								],
								[
									86.97548828125014,
									20.700146484374983
								],
								[
									86.92451171875013,
									20.61977539062505
								],
								[
									86.83593750000011,
									20.53432617187505
								],
								[
									86.76249999999993,
									20.41914062500004
								],
								[
									86.76923828125001,
									20.355908203125125
								],
								[
									86.75039062500008,
									20.31323242187503
								],
								[
									86.49873046875018,
									20.171630859375057
								],
								[
									86.44580078125023,
									20.08891601562499
								],
								[
									86.37656250000003,
									20.006738281249937
								],
								[
									86.29365234375007,
									20.053759765624932
								],
								[
									86.2452148437502,
									20.05302734374996
								],
								[
									86.31191406250014,
									19.987792968750085
								],
								[
									86.30292968750018,
									19.944677734375006
								],
								[
									86.2794921875003,
									19.919433593749915
								],
								[
									86.21621093749997,
									19.895800781249903
								],
								[
									85.85292968750025,
									19.791748046875114
								],
								[
									85.57499999999999,
									19.69291992187496
								],
								[
									85.49687500000016,
									19.696923828125165
								],
								[
									85.51113281250025,
									19.72690429687495
								],
								[
									85.55976562500018,
									19.75346679687513
								],
								[
									85.55507812500014,
									19.866894531250153
								],
								[
									85.50410156250007,
									19.88769531250003
								],
								[
									85.45996093750011,
									19.895898437500193
								],
								[
									85.24863281250003,
									19.757666015625006
								],
								[
									85.16279296875007,
									19.62089843750013
								],
								[
									85.18076171875015,
									19.59487304687505
								],
								[
									85.22851562500023,
									19.601318359374943
								],
								[
									85.37089843749993,
									19.67890625000004
								],
								[
									85.43691406250014,
									19.65688476562508
								],
								[
									85.4416015624999,
									19.626562500000034
								],
								[
									85.22558593749994,
									19.508349609375017
								],
								[
									84.77099609375006,
									19.12539062500008
								],
								[
									84.7498046875001,
									19.050097656250017
								],
								[
									84.69082031250008,
									18.96469726562492
								],
								[
									84.60937500000011,
									18.884326171875074
								],
								[
									84.46279296875002,
									18.689746093750045
								],
								[
									84.18173828125032,
									18.400585937499926
								],
								[
									84.1041015625002,
									18.292675781250068
								],
								[
									83.65429687499994,
									18.06987304687516
								],
								[
									83.57226562500011,
									18.003613281250153
								],
								[
									83.38798828125016,
									17.786669921875017
								],
								[
									83.19833984375003,
									17.60898437499995
								],
								[
									82.97685546875016,
									17.461816406249994
								],
								[
									82.59316406250014,
									17.273925781250085
								],
								[
									82.35957031250007,
									17.09619140625003
								],
								[
									82.28652343750008,
									16.97807617187513
								],
								[
									82.28193359375007,
									16.936083984375102
								],
								[
									82.30722656250003,
									16.878564453125108
								],
								[
									82.34999999999997,
									16.82519531249997
								],
								[
									82.35976562500008,
									16.782812500000034
								],
								[
									82.33867187500016,
									16.706542968750057
								],
								[
									82.32714843750011,
									16.66435546875016
								],
								[
									82.25878906250023,
									16.559863281250017
								],
								[
									82.14150390625014,
									16.485351562500114
								],
								[
									81.76191406250018,
									16.32949218750005
								],
								[
									81.71171875000016,
									16.33447265625
								],
								[
									81.40185546875006,
									16.365234375000057
								],
								[
									81.28613281249994,
									16.337060546874994
								],
								[
									81.2385742187501,
									16.26396484375013
								],
								[
									81.13212890625005,
									15.96176757812492
								],
								[
									81.03007812499999,
									15.881445312500006
								],
								[
									80.99345703124999,
									15.808740234375108
								],
								[
									80.97871093750001,
									15.758349609375045
								],
								[
									80.91777343750016,
									15.759667968749966
								],
								[
									80.86474609375006,
									15.782226562499943
								],
								[
									80.82597656249999,
									15.765917968749989
								],
								[
									80.78183593750009,
									15.867333984375051
								],
								[
									80.70781249999993,
									15.888085937500108
								],
								[
									80.64658203125003,
									15.89501953125
								],
								[
									80.3848632812502,
									15.79277343749996
								],
								[
									80.29345703125023,
									15.710742187500045
								],
								[
									80.10107421875011,
									15.323632812499952
								],
								[
									80.05341796875018,
									15.074023437499903
								],
								[
									80.09863281249994,
									14.798242187500122
								],
								[
									80.16542968750025,
									14.577832031250068
								],
								[
									80.17871093750011,
									14.478320312500045
								],
								[
									80.17011718750007,
									14.349414062500074
								],
								[
									80.13623046875006,
									14.286572265625153
								],
								[
									80.11171875000014,
									14.212207031250102
								],
								[
									80.14365234375015,
									14.058935546875048
								],
								[
									80.22441406249999,
									13.858203125000102
								],
								[
									80.24414062500011,
									13.773486328125074
								],
								[
									80.24580078124995,
									13.68583984375016
								],
								[
									80.30654296875025,
									13.48505859375011
								],
								[
									80.26562500000023,
									13.521289062500031
								],
								[
									80.23339843750006,
									13.605761718749918
								],
								[
									80.15625000000006,
									13.713769531250165
								],
								[
									80.06210937500009,
									13.606250000000017
								],
								[
									80.11425781249994,
									13.528710937500122
								],
								[
									80.29033203125005,
									13.43671874999994
								],
								[
									80.34238281250009,
									13.361328125000128
								],
								[
									80.22910156250015,
									12.690332031249937
								],
								[
									80.14306640624994,
									12.452001953125148
								],
								[
									80.03750000000014,
									12.295800781250122
								],
								[
									79.98173828125016,
									12.235449218749991
								],
								[
									79.85849609375015,
									11.9887695312501
								],
								[
									79.77138671875008,
									11.690234375000031
								],
								[
									79.75410156250001,
									11.575292968750063
								],
								[
									79.79335937500014,
									11.44667968750015
								],
								[
									79.74892578125014,
									11.370605468750014
								],
								[
									79.69316406250016,
									11.312548828125003
								],
								[
									79.79902343750001,
									11.338671874999903
								],
								[
									79.83525390625016,
									11.26884765625016
								],
								[
									79.84863281250011,
									11.196875000000063
								],
								[
									79.85019531250009,
									10.768847656249989
								],
								[
									79.83818359375005,
									10.322558593750017
								],
								[
									79.75693359375009,
									10.304345703125037
								],
								[
									79.66738281250014,
									10.29970703124998
								],
								[
									79.58857421875007,
									10.312353515624892
								],
								[
									79.53164062500008,
									10.32963867187513
								],
								[
									79.39052734375014,
									10.305957031250102
								],
								[
									79.3145507812502,
									10.25668945312492
								],
								[
									79.25361328125001,
									10.174804687500028
								],
								[
									79.25781250000011,
									10.035205078124918
								],
								[
									78.9962890624999,
									9.683105468750043
								],
								[
									78.93994140625006,
									9.56577148437512
								],
								[
									78.91914062500018,
									9.452880859374943
								],
								[
									78.95312500000011,
									9.393798828124986
								],
								[
									79.01992187500014,
									9.33334960937502
								],
								[
									79.1070312500002,
									9.30893554687502
								],
								[
									79.27548828125003,
									9.28461914062504
								],
								[
									79.35634765625008,
									9.252148437500082
								],
								[
									79.41142578125005,
									9.192382812499986
								],
								[
									79.21289062500006,
									9.25600585937498
								],
								[
									78.97958984375015,
									9.268554687500142
								],
								[
									78.42148437500003,
									9.105029296875045
								],
								[
									78.27451171875003,
									8.990185546875097
								],
								[
									78.19248046874992,
									8.890869140625114
								],
								[
									78.13603515625016,
									8.66337890625013
								],
								[
									78.12636718749997,
									8.511328125000063
								],
								[
									78.06015625000009,
									8.384570312499903
								],
								[
									77.77031249999999,
									8.189843750000023
								],
								[
									77.58720703124999,
									8.129882812500156
								],
								[
									77.51757812500011,
									8.07832031250004
								],
								[
									77.30146484375007,
									8.145312500000102
								],
								[
									77.06591796875011,
									8.315917968750043
								],
								[
									76.9668945312502,
									8.407275390625003
								],
								[
									76.6172851562502,
									8.84707031249998
								],
								[
									76.55341796875018,
									8.902783203125054
								],
								[
									76.48291015625011,
									9.090771484375068
								],
								[
									76.47177734375003,
									9.160839843749955
								],
								[
									76.45234375000018,
									9.18876953124996
								],
								[
									76.41904296875003,
									9.207812499999932
								],
								[
									76.40312499999999,
									9.236816406250071
								],
								[
									76.32460937500025,
									9.452099609375054
								],
								[
									76.29238281250008,
									9.67646484375011
								],
								[
									76.24238281250001,
									9.92709960937492
								],
								[
									76.28466796875011,
									9.909863281250054
								],
								[
									76.34306640625005,
									9.827343750000026
								],
								[
									76.37226562500001,
									9.70737304687492
								],
								[
									76.37558593750009,
									9.539892578124906
								],
								[
									76.41953125000003,
									9.520458984375125
								],
								[
									76.45878906250016,
									9.536230468750048
								],
								[
									76.34648437499999,
									9.922119140624972
								],
								[
									76.24873046875018,
									10.017968750000051
								],
								[
									76.22275390625032,
									10.024267578125091
								],
								[
									76.19560546874999,
									10.086132812500082
								],
								[
									76.1926757812501,
									10.163769531249997
								],
								[
									76.2014648437501,
									10.20063476562514
								],
								[
									76.12333984375005,
									10.327001953125034
								],
								[
									76.09609375000025,
									10.402246093750179
								],
								[
									75.92255859375013,
									10.784082031250165
								],
								[
									75.84462890625002,
									11.057568359375011
								],
								[
									75.72382812500018,
									11.361767578125082
								],
								[
									75.64609375000003,
									11.468408203125136
								],
								[
									75.52451171875003,
									11.70312500000017
								],
								[
									75.42265624999999,
									11.812207031250097
								],
								[
									75.31464843750001,
									11.95844726562514
								],
								[
									75.22978515625016,
									12.023339843750037
								],
								[
									75.19667968749997,
									12.05751953124998
								],
								[
									74.94550781250007,
									12.564550781249892
								],
								[
									74.8682617187502,
									12.84458007812492
								],
								[
									74.80292968750013,
									12.976855468750045
								],
								[
									74.77050781250011,
									13.077343750000182
								],
								[
									74.68232421875018,
									13.506933593750034
								],
								[
									74.68164062500023,
									13.583740234375142
								],
								[
									74.6708984375,
									13.667626953125179
								],
								[
									74.60849609375003,
									13.849658203125045
								],
								[
									74.49853515625023,
									14.046337890624969
								],
								[
									74.46669921875014,
									14.16884765625015
								],
								[
									74.46699218750018,
									14.216503906249997
								],
								[
									74.39716796875018,
									14.407421875000082
								],
								[
									74.38222656250014,
									14.494726562500105
								],
								[
									74.33505859374992,
									14.575439453125028
								],
								[
									74.28037109375009,
									14.64951171875002
								],
								[
									74.22304687500014,
									14.708886718750037
								],
								[
									74.08876953125014,
									14.902197265624892
								],
								[
									74.0406250000002,
									14.949365234375179
								],
								[
									73.94921875000023,
									15.074755859375145
								],
								[
									73.88427734375011,
									15.306445312500003
								],
								[
									73.80078125000006,
									15.396972656249972
								],
								[
									73.93193359375016,
									15.396972656249972
								],
								[
									73.85195312500014,
									15.482470703125074
								],
								[
									73.81386718749997,
									15.538574218750142
								],
								[
									73.7717773437501,
									15.57304687499996
								],
								[
									73.8328125000001,
									15.659374999999955
								],
								[
									73.73281250000002,
									15.656933593750097
								],
								[
									73.67988281250013,
									15.708886718750193
								],
								[
									73.60771484375027,
									15.871093750000028
								],
								[
									73.47607421875011,
									16.054248046874932
								],
								[
									73.45371093750009,
									16.15209960937497
								],
								[
									73.33759765625001,
									16.459863281249966
								],
								[
									73.23916015625014,
									17.198535156250102
								],
								[
									73.14902343750009,
									17.527441406250034
								],
								[
									73.15605468750027,
									17.62192382812492
								],
								[
									73.0471679687501,
									17.906738281250142
								],
								[
									72.99394531250027,
									18.097705078125045
								],
								[
									72.97207031250008,
									18.259277343749915
								],
								[
									72.94316406250016,
									18.365625000000193
								],
								[
									72.9171874999999,
									18.576123046874983
								],
								[
									72.87548828124994,
									18.64282226562517
								],
								[
									72.87089843750027,
									18.683056640624926
								],
								[
									72.89873046875027,
									18.778955078125193
								],
								[
									72.97685546874999,
									18.927197265624926
								],
								[
									73.00556640625018,
									19.021093750000148
								],
								[
									72.97207031250008,
									19.153320312500085
								],
								[
									72.9006835937501,
									19.01450195312495
								],
								[
									72.83466796875018,
									18.975585937500114
								],
								[
									72.8030273437501,
									19.079296875000097
								],
								[
									72.80273437500023,
									19.218750000000085
								],
								[
									72.79453125000009,
									19.252099609375136
								],
								[
									72.81162109375009,
									19.298925781249977
								],
								[
									72.98720703124997,
									19.277441406250148
								],
								[
									72.78789062500016,
									19.362988281250068
								],
								[
									72.76396484375016,
									19.41318359375009
								],
								[
									72.7564453125002,
									19.450537109375063
								],
								[
									72.79941406250009,
									19.519824218750045
								],
								[
									72.72656250000006,
									19.57827148437505
								],
								[
									72.6974609374999,
									19.757128906250074
								],
								[
									72.67597656250018,
									19.797949218750034
								],
								[
									72.66777343750027,
									19.830957031250108
								],
								[
									72.70898437499994,
									20.07802734375008
								],
								[
									72.8811523437501,
									20.563183593750068
								],
								[
									72.89375000000001,
									20.672753906250193
								],
								[
									72.87890625000011,
									20.828515625000023
								],
								[
									72.84052734375001,
									20.952490234375063
								],
								[
									72.8243164062502,
									21.08359374999995
								],
								[
									72.81386718750008,
									21.117187500000142
								],
								[
									72.75156249999992,
									21.129150390625085
								],
								[
									72.69238281249994,
									21.177636718750193
								],
								[
									72.62382812500005,
									21.37197265625008
								],
								[
									72.68652343750011,
									21.435742187499926
								],
								[
									72.73476562500025,
									21.470800781250063
								],
								[
									72.66835937500014,
									21.45590820312495
								],
								[
									72.61328125000011,
									21.46181640625008
								],
								[
									72.7175781250001,
									21.551269531250114
								],
								[
									72.81054687500023,
									21.61992187499996
								],
								[
									73.02246093750023,
									21.699609375000136
								],
								[
									73.1124999999999,
									21.750439453125182
								],
								[
									72.97910156250009,
									21.704687500000006
								],
								[
									72.83974609375014,
									21.687255859375
								],
								[
									72.54306640625009,
									21.696582031250045
								],
								[
									72.59248046875001,
									21.87758789062505
								],
								[
									72.64404296875023,
									21.93798828125003
								],
								[
									72.70019531250011,
									21.971923828124915
								],
								[
									72.61748046875016,
									21.96171874999996
								],
								[
									72.5222656250001,
									21.97622070312508
								],
								[
									72.55302734375016,
									22.15996093750013
								],
								[
									72.62792968749994,
									22.199609374999937
								],
								[
									72.70878906250027,
									22.20717773437505
								],
								[
									72.80917968749992,
									22.23330078125005
								],
								[
									72.7019531250001,
									22.26362304687501
								],
								[
									72.59013671875027,
									22.278125000000045
								],
								[
									72.45595703125008,
									22.248095703125045
								],
								[
									72.3326171875002,
									22.270214843749926
								],
								[
									72.18281250000013,
									22.26972656250001
								],
								[
									72.24257812499997,
									22.245166015625074
								],
								[
									72.30644531250005,
									22.189208984374943
								],
								[
									72.27441406250006,
									22.089746093749937
								],
								[
									72.24433593750018,
									22.027636718750074
								],
								[
									72.1617187500002,
									21.984814453125153
								],
								[
									72.09443359375018,
									21.91997070312499
								],
								[
									72.07558593750025,
									21.862988281249926
								],
								[
									72.03720703125003,
									21.82304687499996
								],
								[
									72.10292968750014,
									21.794580078125023
								],
								[
									72.17089843750011,
									21.77431640625008
								],
								[
									72.21035156249997,
									21.728222656250097
								],
								[
									72.25664062499999,
									21.661230468750034
								],
								[
									72.25400390625009,
									21.53100585937497
								],
								[
									72.07656250000025,
									21.224072265625068
								],
								[
									72.0152343750002,
									21.155712890625068
								],
								[
									71.57109375000016,
									20.970556640625006
								],
								[
									71.39648437500011,
									20.86977539062508
								],
								[
									71.02460937500018,
									20.738867187500063
								],
								[
									70.87968750000016,
									20.714501953125165
								],
								[
									70.71933593750009,
									20.740429687500125
								],
								[
									70.48505859375001,
									20.84018554687492
								],
								[
									70.12734374999997,
									21.094677734375068
								],
								[
									70.03437500000013,
									21.178808593749977
								],
								[
									69.74843750000025,
									21.505712890625063
								],
								[
									69.54199218750011,
									21.678564453125006
								],
								[
									69.38544921875018,
									21.83955078125004
								],
								[
									69.19169921875016,
									21.99150390624999
								],
								[
									69.00878906250011,
									22.19677734375017
								],
								[
									68.9699218750003,
									22.29028320312503
								],
								[
									68.9834960937502,
									22.38540039062505
								],
								[
									69.05166015625025,
									22.437304687500045
								],
								[
									69.13134765625011,
									22.416259765625114
								],
								[
									69.19423828125014,
									22.336083984375023
								],
								[
									69.23886718750009,
									22.300195312499994
								],
								[
									69.27656250000001,
									22.28549804687512
								],
								[
									69.54921874999997,
									22.40839843750001
								],
								[
									69.65517578125025,
									22.403515625000182
								],
								[
									69.72753906250006,
									22.465185546875034
								],
								[
									69.81904296875013,
									22.451757812500063
								],
								[
									70.00585937500011,
									22.547705078124977
								],
								[
									70.08417968750018,
									22.553515625000017
								],
								[
									70.17724609375023,
									22.57275390625003
								],
								[
									70.32773437500003,
									22.815771484375148
								],
								[
									70.44042968750011,
									22.97031249999992
								],
								[
									70.51347656250016,
									23.002490234374903
								],
								[
									70.5093750000002,
									23.040136718750034
								],
								[
									70.48925781250011,
									23.089501953125136
								],
								[
									70.43457031250023,
									23.077099609375097
								],
								[
									70.39628906250027,
									23.03012695312512
								],
								[
									70.36796875000016,
									22.973486328125034
								],
								[
									70.3394531250002,
									22.939746093749903
								],
								[
									70.25117187500018,
									22.97089843750004
								],
								[
									70.19169921875016,
									22.965673828125034
								],
								[
									70.11826171875009,
									22.94702148437497
								],
								[
									69.84980468750001,
									22.856445312500085
								],
								[
									69.73964843750025,
									22.77519531249996
								],
								[
									69.66464843750003,
									22.759082031250045
								],
								[
									69.23593749999992,
									22.84853515625008
								],
								[
									68.81708984375007,
									23.05371093750003
								],
								[
									68.64072265625009,
									23.18994140625017
								],
								[
									68.52919921875008,
									23.364062500000017
								],
								[
									68.41748046875006,
									23.571484375000097
								],
								[
									68.45380859374995,
									23.62949218749992
								],
								[
									68.62714843750018,
									23.754150390624915
								],
								[
									68.77675781250002,
									23.852099609375074
								],
								[
									68.64238281250016,
									23.808496093749966
								],
								[
									68.49687499999999,
									23.747998046875182
								],
								[
									68.42490234375009,
									23.705566406250057
								],
								[
									68.34335937500009,
									23.616845703125108
								],
								[
									68.23496093749992,
									23.596972656250045
								],
								[
									68.19199218750003,
									23.728906250000193
								],
								[
									68.16503906250006,
									23.857324218749966
								],
								[
									68.2341796875001,
									23.90053710937508
								],
								[
									68.2825195312501,
									23.92797851562497
								],
								[
									68.38125000000014,
									23.950878906250125
								],
								[
									68.48867187500008,
									23.967236328124983
								],
								[
									68.58662109375018,
									23.96660156250013
								],
								[
									68.72412109375011,
									23.96469726562509
								],
								[
									68.72812500000015,
									24.265625000000114
								],
								[
									68.73964843750014,
									24.291992187500057
								],
								[
									68.75898437500001,
									24.307226562500063
								],
								[
									68.78115234375008,
									24.313720703125142
								],
								[
									68.80000000000001,
									24.309082031250085
								],
								[
									68.82832031250001,
									24.264013671875034
								],
								[
									68.86347656250018,
									24.266503906250023
								],
								[
									68.90078125000014,
									24.292431640625068
								],
								[
									68.98457031250013,
									24.273095703125023
								],
								[
									69.0515625000001,
									24.286328125000068
								],
								[
									69.11953125000008,
									24.268652343750006
								],
								[
									69.23505859375001,
									24.268261718750125
								],
								[
									69.44345703125003,
									24.275390625000057
								],
								[
									69.55917968750003,
									24.273095703125023
								],
								[
									69.63417968750014,
									24.22519531249995
								],
								[
									69.71621093750014,
									24.172607421875085
								],
								[
									69.80517578125006,
									24.165234375000097
								],
								[
									69.93378906250007,
									24.17138671875
								],
								[
									70.02109375000009,
									24.191552734375023
								],
								[
									70.06513671875001,
									24.240576171874977
								],
								[
									70.09824218750009,
									24.287500000000136
								],
								[
									70.28906250000006,
									24.35629882812512
								],
								[
									70.48925781250011,
									24.41215820312513
								],
								[
									70.54677734375008,
									24.418310546875034
								],
								[
									70.56503906250009,
									24.38579101562499
								],
								[
									70.55585937500018,
									24.33110351562513
								],
								[
									70.57929687500013,
									24.279052734375
								],
								[
									70.6594726562501,
									24.24609375000003
								],
								[
									70.71630859375006,
									24.237988281250068
								],
								[
									70.76728515625018,
									24.24541015624999
								],
								[
									70.80507812500014,
									24.261962890625085
								],
								[
									70.88623046875011,
									24.34375000000003
								],
								[
									70.92812500000014,
									24.362353515625102
								],
								[
									70.98281250000008,
									24.361035156250097
								],
								[
									71.04404296875003,
									24.400097656250153
								],
								[
									71.04531250000014,
									24.429980468750017
								],
								[
									71.00625000000008,
									24.444335937500114
								],
								[
									70.97324218750009,
									24.487402343750006
								],
								[
									70.97929687499999,
									24.52246093750003
								],
								[
									70.96982421875009,
									24.571875000000063
								],
								[
									70.9763671875001,
									24.61875000000012
								],
								[
									71.0023437500002,
									24.653906249999977
								],
								[
									71.04785156250011,
									24.687744140625142
								],
								[
									71.02070312500018,
									24.757666015624977
								],
								[
									70.95087890625018,
									24.8916015625
								],
								[
									70.87773437500016,
									25.06298828125003
								],
								[
									70.80048828125007,
									25.20585937499999
								],
								[
									70.70253906250014,
									25.3310546875
								],
								[
									70.65205078125001,
									25.422900390625074
								],
								[
									70.65722656250011,
									25.625781250000102
								],
								[
									70.64843750000011,
									25.66694335937504
								],
								[
									70.6148437500002,
									25.69189453124997
								],
								[
									70.56953125000013,
									25.705957031249994
								],
								[
									70.50585937500011,
									25.685302734375057
								],
								[
									70.44853515625016,
									25.68134765625004
								],
								[
									70.32519531250006,
									25.685742187500068
								],
								[
									70.26464843750006,
									25.70654296875003
								],
								[
									70.10019531250003,
									25.910058593750108
								],
								[
									70.07861328125011,
									25.99003906249996
								],
								[
									70.0777343750002,
									26.07197265625004
								],
								[
									70.13261718749999,
									26.21479492187501
								],
								[
									70.14921874999999,
									26.347558593749966
								],
								[
									70.15683593750003,
									26.471435546875085
								],
								[
									70.14765625000007,
									26.506445312500006
								],
								[
									70.11464843750014,
									26.54804687500004
								],
								[
									70.05937499999999,
									26.578759765624994
								],
								[
									69.91142578125016,
									26.586132812500068
								],
								[
									69.7359375000002,
									26.627050781249977
								],
								[
									69.60058593750006,
									26.699121093750108
								],
								[
									69.50693359375009,
									26.74267578125
								],
								[
									69.4812500000001,
									26.770996093750085
								],
								[
									69.47001953124999,
									26.80444335937497
								],
								[
									69.49453125000014,
									26.954150390625017
								],
								[
									69.53701171875008,
									27.122949218750023
								],
								[
									69.56796875000009,
									27.174609375000074
								],
								[
									69.62158203125006,
									27.228076171875045
								],
								[
									69.66132812500007,
									27.264501953125006
								],
								[
									69.72480468750013,
									27.31269531250004
								],
								[
									69.8962890625001,
									27.473632812500057
								],
								[
									70.04980468750011,
									27.69472656250008
								],
								[
									70.14453125000011,
									27.849023437499966
								],
								[
									70.19394531250003,
									27.894873046874977
								],
								[
									70.24433593750001,
									27.934130859375074
								],
								[
									70.31845703125009,
									27.981640624999983
								],
								[
									70.40371093750008,
									28.02504882812505
								],
								[
									70.4885742187501,
									28.023144531250097
								],
								[
									70.56923828125014,
									27.98378906250008
								],
								[
									70.62910156250018,
									27.93745117187504
								],
								[
									70.64912109375013,
									27.835351562500023
								],
								[
									70.69160156250013,
									27.76899414062501
								],
								[
									70.73740234375003,
									27.72900390625003
								],
								[
									70.7979492187502,
									27.709619140624994
								],
								[
									70.87490234375014,
									27.714453125000006
								],
								[
									71.18476562500001,
									27.831640624999977
								],
								[
									71.29013671875009,
									27.855273437500102
								],
								[
									71.54296875000011,
									27.869873046875057
								],
								[
									71.71669921875014,
									27.915087890625017
								],
								[
									71.87031250000018,
									27.96250000000009
								],
								[
									71.88886718750001,
									28.047460937499977
								],
								[
									71.94804687499999,
									28.177294921875045
								],
								[
									72.1285156250002,
									28.346337890625136
								],
								[
									72.17919921875011,
									28.42177734375005
								],
								[
									72.23388671875006,
									28.56582031250008
								],
								[
									72.29199218750011,
									28.69726562500003
								],
								[
									72.34189453125003,
									28.751904296875153
								],
								[
									72.62558593750009,
									28.89614257812505
								],
								[
									72.90332031250011,
									29.028759765625068
								],
								[
									72.94873046875006,
									29.08881835937504
								],
								[
									73.12832031250014,
									29.363916015625136
								],
								[
									73.23115234375001,
									29.550634765625063
								],
								[
									73.25781250000011,
									29.610693359375148
								],
								[
									73.31728515625014,
									29.772998046875074
								],
								[
									73.3816406250001,
									29.93437499999999
								],
								[
									73.46748046875001,
									29.971679687500142
								],
								[
									73.6580078125001,
									30.03320312499997
								],
								[
									73.80917968750009,
									30.093359375000063
								],
								[
									73.88652343750016,
									30.162011718750108
								],
								[
									73.93339843749999,
									30.22207031250008
								],
								[
									73.9246093750001,
									30.28164062500005
								],
								[
									73.88271484375008,
									30.352148437500034
								],
								[
									73.89160156250011,
									30.39404296875003
								],
								[
									73.89931640625008,
									30.435351562500102
								],
								[
									74.00898437500001,
									30.51967773437505
								],
								[
									74.2156250000001,
									30.76899414062504
								],
								[
									74.33935546875011,
									30.8935546875
								],
								[
									74.38037109375011,
									30.893408203125063
								],
								[
									74.50976562500011,
									30.959667968750068
								],
								[
									74.63281250000011,
									31.034667968750057
								],
								[
									74.62578125000005,
									31.06875000000008
								],
								[
									74.61035156250006,
									31.112841796875102
								],
								[
									74.53974609375018,
									31.132666015625063
								],
								[
									74.51767578125009,
									31.18559570312499
								],
								[
									74.5349609375001,
									31.26137695312508
								],
								[
									74.59394531250001,
									31.465380859375074
								],
								[
									74.5818359375001,
									31.523925781250085
								],
								[
									74.50996093750013,
									31.712939453125045
								],
								[
									74.52597656250003,
									31.76513671875003
								],
								[
									74.55556640625008,
									31.818554687500068
								],
								[
									74.63574218750011,
									31.889746093750006
								],
								[
									74.73945312500007,
									31.948828125000063
								],
								[
									75.07148437500013,
									32.08935546875
								],
								[
									75.13876953125009,
									32.104785156250045
								],
								[
									75.25410156250001,
									32.14033203125007
								],
								[
									75.32470703125011,
									32.21528320312507
								],
								[
									75.33349609375006,
									32.27919921875005
								],
								[
									75.30263671875014,
									32.318896484375045
								],
								[
									75.23369140625016,
									32.372119140625045
								],
								[
									75.10410156250003,
									32.42036132812501
								],
								[
									74.98730468750006,
									32.46220703125002
								],
								[
									74.7888671875001,
									32.45781250000002
								],
								[
									74.68574218750018,
									32.493798828124966
								],
								[
									74.65781250000003,
									32.51894531250002
								],
								[
									74.64335937500016,
									32.60771484374999
								],
								[
									74.66328125000001,
									32.757666015625006
								],
								[
									74.63242187500003,
									32.77089843750011
								],
								[
									74.58828125000008,
									32.753222656250074
								],
								[
									74.48339843750006,
									32.77099609375006
								],
								[
									74.35458984375009,
									32.76870117187502
								],
								[
									74.30546875000016,
									32.810449218749994
								],
								[
									74.32998046875008,
									32.86083984375006
								],
								[
									74.32275390625011,
									32.92797851562506
								],
								[
									74.30361328125014,
									32.99179687500009
								],
								[
									74.28359375000014,
									33.00512695312514
								],
								[
									74.22207031250008,
									33.020312500000045
								],
								[
									74.1262695312501,
									33.075439453125085
								],
								[
									74.04912109375016,
									33.14340820312498
								],
								[
									74.00380859375014,
									33.18945312500003
								],
								[
									73.98984375000003,
									33.221191406250114
								],
								[
									73.99423828125003,
									33.24218750000003
								],
								[
									74.05039062500015,
									33.301269531250085
								],
								[
									74.11777343750009,
									33.38413085937509
								],
								[
									74.14257812500006,
									33.45537109375002
								],
								[
									74.15000000000009,
									33.506982421874966
								],
								[
									74.13125000000008,
									33.54506835937508
								],
								[
									74.06972656250014,
									33.591699218749994
								],
								[
									74.0040039062502,
									33.632421875000034
								],
								[
									73.97753906250011,
									33.66782226562515
								],
								[
									73.97646484375014,
									33.721289062500034
								],
								[
									74.00097656250011,
									33.78818359375006
								],
								[
									74.07841796875005,
									33.838671875000045
								],
								[
									74.2156250000001,
									33.886572265625034
								],
								[
									74.25087890625014,
									33.946093750000074
								],
								[
									74.24648437500008,
									33.9901855468751
								],
								[
									74.20898437500011,
									34.00341796875003
								],
								[
									74.11259765625016,
									34.00371093750002
								],
								[
									73.94990234375007,
									34.01879882812497
								],
								[
									73.92236328125006,
									34.043066406250034
								],
								[
									73.90410156250016,
									34.075683593750114
								],
								[
									73.90390625000015,
									34.10800781250012
								],
								[
									73.9382812500001,
									34.14477539062506
								],
								[
									73.97949218750006,
									34.19130859375002
								],
								[
									73.97236328125001,
									34.23662109375002
								],
								[
									73.9246093750001,
									34.28784179687506
								],
								[
									73.8099609375002,
									34.32534179687508
								],
								[
									73.79453125000003,
									34.3782226562501
								],
								[
									73.81210937500009,
									34.42236328125003
								],
								[
									73.85009765625011,
									34.48530273437507
								],
								[
									73.88310546875005,
									34.529052734375
								],
								[
									73.9612304687501,
									34.65346679687505
								],
								[
									74.05585937500007,
									34.680664062500085
								],
								[
									74.17197265625003,
									34.72089843750001
								],
								[
									74.30039062500009,
									34.765380859375114
								],
								[
									74.49794921875008,
									34.73203125000006
								],
								[
									74.59414062500014,
									34.715771484375125
								],
								[
									74.78876953125007,
									34.677734375
								],
								[
									74.95185546875013,
									34.64584960937509
								],
								[
									75.1184570312501,
									34.636816406250034
								],
								[
									75.18750000000017,
									34.63901367187512
								],
								[
									75.26406250000014,
									34.60136718749999
								],
								[
									75.45253906250014,
									34.53671875000006
								],
								[
									75.60556640625003,
									34.502734375000074
								],
								[
									75.70917968750001,
									34.503076171875136
								],
								[
									75.86210937499999,
									34.56025390625007
								],
								[
									75.93828125000016,
									34.61254882812506
								],
								[
									76.04101562500011,
									34.66992187500003
								],
								[
									76.17246093750009,
									34.667724609375114
								],
								[
									76.45673828125007,
									34.756103515625085
								],
								[
									76.50996093750007,
									34.740869140624994
								],
								[
									76.59443359375018,
									34.73583984375003
								],
								[
									76.69628906250006,
									34.78691406249996
								],
								[
									76.74902343750011,
									34.84755859375005
								],
								[
									76.75751953125007,
									34.87783203125011
								],
								[
									76.78291015625013,
									34.900195312500045
								],
								[
									76.89169921875003,
									34.93872070312497
								],
								[
									77.00087890625008,
									34.99199218749999
								],
								[
									77.03066406250014,
									35.062353515625034
								],
								[
									77.04863281250005,
									35.109912109375045
								],
								[
									77.16855468750009,
									35.17153320312508
								],
								[
									77.29296875000011,
									35.23554687500015
								],
								[
									77.42343750000003,
									35.302587890625034
								],
								[
									77.57158203124999,
									35.378759765625006
								],
								[
									77.69697265625018,
									35.44326171875008
								],
								[
									77.79941406250009,
									35.495898437500074
								],
								[
									77.81093750000008,
									35.484521484374966
								],
								[
									77.85156250000011,
									35.46079101562512
								],
								[
									77.89492187500014,
									35.44902343750002
								],
								[
									77.94589843750009,
									35.47163085937501
								],
								[
									78.00947265625007,
									35.49023437500017
								],
								[
									78.04267578125018,
									35.479785156250074
								],
								[
									78.04746093750009,
									35.44941406250001
								],
								[
									78.0091796875002,
									35.30693359375013
								],
								[
									78.01220703125006,
									35.2510253906251
								],
								[
									78.07578125000003,
									35.13491210937508
								],
								[
									78.15849609375005,
									34.946484374999955
								],
								[
									78.23613281250016,
									34.76982421875013
								],
								[
									78.28203125000027,
									34.653906250000034
								],
								[
									78.32695312500016,
									34.606396484374955
								],
								[
									78.51572265625015,
									34.557958984375034
								],
								[
									78.67080078125025,
									34.518164062500006
								],
								[
									78.76308593750008,
									34.452929687500045
								],
								[
									78.86484375000003,
									34.39033203124998
								],
								[
									78.93642578124997,
									34.35195312500008
								],
								[
									78.97011718750008,
									34.302636718750165
								],
								[
									78.97695312500014,
									34.258105468750045
								],
								[
									78.97060546875008,
									34.2282226562501
								],
								[
									78.9317382812502,
									34.18896484375
								],
								[
									78.7530273437502,
									34.087695312500074
								],
								[
									78.7317382812501,
									34.055566406249994
								],
								[
									78.72666015625003,
									34.013378906249926
								],
								[
									78.76171875000011,
									33.887597656250165
								],
								[
									78.78378906250003,
									33.8087890625001
								],
								[
									78.78994140624997,
									33.65034179687504
								],
								[
									78.8018554687502,
									33.49970703125018
								],
								[
									78.86503906249999,
									33.43110351562507
								],
								[
									78.91669921875013,
									33.38676757812499
								],
								[
									78.94843750000001,
									33.34653320312506
								],
								[
									79.01259765625025,
									33.29145507812504
								],
								[
									79.0665039062502,
									33.25039062500019
								],
								[
									79.11250000000007,
									33.22626953124998
								],
								[
									79.13515625000014,
									33.17192382812502
								],
								[
									79.12167968750009,
									33.10810546875007
								],
								[
									79.10283203125016,
									33.05253906249993
								],
								[
									79.10859375000013,
									33.02265625000007
								],
								[
									79.14550781250011,
									33.001464843750114
								],
								[
									79.20224609375003,
									32.946044921875085
								],
								[
									79.2095703125002,
									32.86484375000006
								],
								[
									79.20556640625011,
									32.80903320312507
								],
								[
									79.22792968750014,
									32.75878906250006
								],
								[
									79.23388671875011,
									32.70307617187507
								],
								[
									79.21650390625001,
									32.56401367187516
								],
								[
									79.21933593750009,
									32.501074218750034
								],
								[
									79.16992187500011,
									32.49721679687505
								],
								[
									79.12734374999997,
									32.475781250000125
								],
								[
									79.06699218750032,
									32.38818359374994
								],
								[
									78.9976562500002,
									32.36513671875005
								],
								[
									78.9189453125,
									32.35820312500016
								],
								[
									78.83789062500006,
									32.41196289062509
								],
								[
									78.77128906249999,
									32.46806640625016
								],
								[
									78.7535156250002,
									32.499267578125114
								],
								[
									78.73671874999997,
									32.55839843749999
								],
								[
									78.70087890625007,
									32.597021484375034
								],
								[
									78.63154296875007,
									32.57895507812509
								],
								[
									78.52636718750011,
									32.57080078125003
								],
								[
									78.41250000000008,
									32.55771484375012
								],
								[
									78.3916992187502,
									32.544726562500045
								],
								[
									78.38964843749994,
									32.51987304687495
								],
								[
									78.41748046874994,
									32.46669921875005
								],
								[
									78.44130859375008,
									32.397363281250136
								],
								[
									78.45527343750018,
									32.30034179687499
								],
								[
									78.48613281249999,
									32.23623046875008
								],
								[
									78.49589843750005,
									32.2157714843751
								],
								[
									78.67773437500011,
									32.02304687500009
								],
								[
									78.72558593750011,
									31.98378906250008
								],
								[
									78.73544921875015,
									31.957958984375153
								],
								[
									78.71972656250006,
									31.88764648437504
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "IND",
					"su_a3": "IND",
					"brk_group": "",
					"region_wb": "South Asia",
					"wb_a3": "IND",
					"gu_a3": "IND",
					"abbrev": "India",
					"region_un": "Asia",
					"adm0_a3_us": "IND",
					"scalerank": 1,
					"pop_est": 1166079220,
					"adm0_dif": 0,
					"un_a3": "356",
					"pop_year": -99,
					"gdp_md_est": 3297000,
					"name": "India",
					"sovereignt": "India",
					"economy": "3. Emerging region: BRIC",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "India",
					"postal": "IND",
					"sov_a3": "IND",
					"note_brk": "",
					"brk_a3": "IND",
					"wb_a2": "IN",
					"brk_diff": 0,
					"admin": "India",
					"name_long": "India",
					"iso_a3": "IND",
					"iso_a2": "IN",
					"adm0_a3_is": "IND",
					"level": 2,
					"formal_en": "Republic of India",
					"name_len": 5,
					"mapcolor7": 1,
					"long_len": 5,
					"mapcolor8": 3,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "356",
					"homepart": 1,
					"subunit": "India",
					"name_alt": "",
					"brk_name": "India",
					"name_sort": "India",
					"continent": "Asia",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-9.948193359374926,
									53.913134765625045
								],
								[
									-9.952441406249989,
									53.884570312500074
								],
								[
									-10.026513671874994,
									53.92055664062505
								],
								[
									-10.062499999999943,
									53.95971679687494
								],
								[
									-10.265722656249949,
									53.97768554687505
								],
								[
									-10.181054687499937,
									54.01684570312494
								],
								[
									-10.139746093749949,
									54.00522460937498
								],
								[
									-9.996386718749989,
									54.0036132812501
								],
								[
									-9.956152343749949,
									53.98720703125002
								],
								[
									-9.948193359374926,
									53.913134765625045
								]
							]
						],
						[
							[
								[
									-6.218017578125,
									54.08872070312512
								],
								[
									-6.175732421875011,
									54.053515625000045
								],
								[
									-6.156933593749983,
									54.01723632812494
								],
								[
									-6.230664062500011,
									54.0036132812501
								],
								[
									-6.307617187499972,
									54.0110351562501
								],
								[
									-6.345166015624983,
									53.98720703125002
								],
								[
									-6.347607421874926,
									53.94130859375011
								],
								[
									-6.32158203124996,
									53.88217773437495
								],
								[
									-6.270117187499949,
									53.84023437499994
								],
								[
									-6.229003906250028,
									53.74570312499995
								],
								[
									-6.194873046874989,
									53.640869140625
								],
								[
									-6.141845703124943,
									53.57753906250005
								],
								[
									-6.130957031249949,
									53.49892578125002
								],
								[
									-6.138769531249949,
									53.46030273437498
								],
								[
									-6.129101562499926,
									53.39086914062506
								],
								[
									-6.151660156249989,
									53.36640625000004
								],
								[
									-6.134716796875011,
									53.30122070312507
								],
								[
									-6.072265624999972,
									53.166308593750045
								],
								[
									-6.04501953124992,
									53.091162109375006
								],
								[
									-6.027392578124989,
									52.92709960937498
								],
								[
									-6.071484374999983,
									52.86562500000008
								],
								[
									-6.13066406249996,
									52.807275390624994
								],
								[
									-6.1693359374999375,
									52.738134765625034
								],
								[
									-6.19921875,
									52.66347656250011
								],
								[
									-6.217236328124926,
									52.543115234374994
								],
								[
									-6.345410156249926,
									52.40200195312494
								],
								[
									-6.399951171874932,
									52.366943359375085
								],
								[
									-6.46318359374996,
									52.34536132812502
								],
								[
									-6.32499999999996,
									52.246679687500006
								],
								[
									-6.4379394531249545,
									52.20268554687502
								],
								[
									-6.561083984374989,
									52.188818359375034
								],
								[
									-6.69731445312496,
									52.213525390624994
								],
								[
									-6.782226562500028,
									52.2104980468751
								],
								[
									-6.859716796875006,
									52.17856445312498
								],
								[
									-6.890234375000006,
									52.159228515625045
								],
								[
									-6.914648437500006,
									52.16855468750006
								],
								[
									-6.965771484374926,
									52.24951171875006
								],
								[
									-7.00327148437492,
									52.16591796875008
								],
								[
									-7.081787109374943,
									52.13930664062508
								],
								[
									-7.216210937499966,
									52.14497070312507
								],
								[
									-7.440869140625011,
									52.122705078124966
								],
								[
									-7.527294921874926,
									52.098876953125
								],
								[
									-7.5631835937499545,
									52.06162109375006
								],
								[
									-7.589843749999972,
									52.01855468750006
								],
								[
									-7.624902343750023,
									51.99311523437504
								],
								[
									-7.66455078125,
									51.97973632812497
								],
								[
									-7.837988281249977,
									51.947998046875085
								],
								[
									-7.872167968749949,
									51.935302734375085
								],
								[
									-7.952490234374949,
									51.86577148437502
								],
								[
									-8.057812499999926,
									51.82558593750011
								],
								[
									-8.14501953125,
									51.813525390625045
								],
								[
									-8.222460937499989,
									51.85400390624994
								],
								[
									-8.254296874999994,
									51.87832031250011
								],
								[
									-8.290234374999926,
									51.890673828125045
								],
								[
									-8.4091796875,
									51.888769531250006
								],
								[
									-8.371630859374989,
									51.876269531250045
								],
								[
									-8.347363281249926,
									51.84770507812499
								],
								[
									-8.335595703124937,
									51.79296874999994
								],
								[
									-8.349121093749943,
									51.73930664062493
								],
								[
									-8.407812500000006,
									51.71206054687508
								],
								[
									-8.47783203124996,
									51.707031250000114
								],
								[
									-8.588281249999994,
									51.65136718750006
								],
								[
									-8.73447265624992,
									51.63618164062507
								],
								[
									-8.813427734374926,
									51.58491210937501
								],
								[
									-9.296484374999949,
									51.49824218750004
								],
								[
									-9.323876953125023,
									51.497216796874994
								],
								[
									-9.390576171874926,
									51.51928710937506
								],
								[
									-9.462890625,
									51.529052734375
								],
								[
									-9.534863281249926,
									51.522167968749926
								],
								[
									-9.737304687499943,
									51.473730468750006
								],
								[
									-9.835351562499937,
									51.483349609374926
								],
								[
									-9.710351562499966,
									51.603710937499926
								],
								[
									-9.542382812499937,
									51.66445312500005
								],
								[
									-9.524902343750028,
									51.68110351562507
								],
								[
									-9.579833984375028,
									51.689257812500045
								],
								[
									-9.899023437499949,
									51.64707031250006
								],
								[
									-10.009912109374966,
									51.61113281249993
								],
								[
									-10.120751953124994,
									51.60068359375012
								],
								[
									-10.069433593749949,
									51.65556640625002
								],
								[
									-9.926416015624937,
									51.73071289062506
								],
								[
									-9.849707031249949,
									51.76611328124997
								],
								[
									-9.802880859374994,
									51.78012695312509
								],
								[
									-9.749511718749943,
									51.82426757812502
								],
								[
									-9.598828124999983,
									51.87441406250011
								],
								[
									-10.084228515625028,
									51.770996093750085
								],
								[
									-10.21171874999996,
									51.78359375000008
								],
								[
									-10.24174804687496,
									51.8124511718751
								],
								[
									-10.341064453124943,
									51.79892578125009
								],
								[
									-10.37871093749996,
									51.86875000000009
								],
								[
									-10.231591796874937,
									51.97451171875008
								],
								[
									-10.145849609374949,
									52.020019531250114
								],
								[
									-10.04404296874992,
									52.04458007812505
								],
								[
									-9.946044921875028,
									52.07983398437494
								],
								[
									-9.909667968749972,
									52.12294921875002
								],
								[
									-9.955810546874972,
									52.13666992187507
								],
								[
									-10.249511718749943,
									52.12573242187506
								],
								[
									-10.39023437499992,
									52.134912109374966
								],
								[
									-10.38261718749996,
									52.16909179687511
								],
								[
									-10.356689453125028,
									52.20693359375008
								],
								[
									-10.2109375,
									52.27167968750004
								],
								[
									-10.132080078125,
									52.28208007812512
								],
								[
									-10.061767578124972,
									52.27592773437502
								],
								[
									-9.993115234374926,
									52.2593261718751
								],
								[
									-9.937304687499932,
									52.237646484375034
								],
								[
									-9.772119140624937,
									52.25009765625009
								],
								[
									-9.841064453124943,
									52.29145507812507
								],
								[
									-9.853222656249955,
									52.37548828125006
								],
								[
									-9.90605468749996,
									52.40371093750002
								],
								[
									-9.838476562499949,
									52.44267578124996
								],
								[
									-9.761132812500023,
									52.46635742187499
								],
								[
									-9.632226562499937,
									52.546923828125074
								],
								[
									-9.586328125000023,
									52.55917968750006
								],
								[
									-9.331250000000011,
									52.57875976562508
								],
								[
									-9.05615234375,
									52.621142578125074
								],
								[
									-8.783447265624972,
									52.679638671874926
								],
								[
									-8.923291015624926,
									52.71230468750011
								],
								[
									-8.990283203124989,
									52.755419921875074
								],
								[
									-9.097900390624972,
									52.6682617187501
								],
								[
									-9.175390624999949,
									52.63491210937505
								],
								[
									-9.394238281249955,
									52.617089843749966
								],
								[
									-9.463476562499949,
									52.626904296874926
								],
								[
									-9.56103515625,
									52.65395507812502
								],
								[
									-9.59135742187496,
									52.64365234375006
								],
								[
									-9.619531249999937,
									52.62275390625007
								],
								[
									-9.764355468749955,
									52.57998046875005
								],
								[
									-9.916601562499977,
									52.56972656250008
								],
								[
									-9.739599609374977,
									52.648193359375
								],
								[
									-9.514990234374949,
									52.781152343749994
								],
								[
									-9.46489257812496,
									52.82319335937504
								],
								[
									-9.39365234374992,
									52.896240234375
								],
								[
									-9.415722656249983,
									52.92875976562496
								],
								[
									-9.461962890624989,
									52.947265625
								],
								[
									-9.299218749999966,
									53.09755859375008
								],
								[
									-9.241894531249926,
									53.124853515625034
								],
								[
									-9.137597656249994,
									53.12924804687495
								],
								[
									-9.061132812499949,
									53.153076171875085
								],
								[
									-9.02744140624992,
									53.153173828125034
								],
								[
									-8.997167968749977,
									53.16206054687507
								],
								[
									-8.930126953125011,
									53.207080078125074
								],
								[
									-9.03354492187492,
									53.23574218750005
								],
								[
									-9.140332031249926,
									53.25048828125006
								],
								[
									-9.470751953125017,
									53.23486328124997
								],
								[
									-9.514208984374989,
									53.23823242187504
								],
								[
									-9.555175781249972,
									53.252050781250006
								],
								[
									-9.581738281249955,
									53.271972656250085
								],
								[
									-9.601757812499955,
									53.323046875000074
								],
								[
									-9.6259765625,
									53.334472656250114
								],
								[
									-9.700585937499937,
									53.334472656250114
								],
								[
									-9.774072265624994,
									53.31884765624994
								],
								[
									-9.825390624999955,
									53.320361328125074
								],
								[
									-9.875781250000017,
									53.34272460937501
								],
								[
									-9.795410156249972,
									53.3949707031251
								],
								[
									-9.899023437499949,
									53.40727539062502
								],
								[
									-10.00390625,
									53.397021484375045
								],
								[
									-10.091259765624955,
									53.412841796875085
								],
								[
									-10.093994140624972,
									53.4456054687501
								],
								[
									-10.054394531249983,
									53.47832031250002
								],
								[
									-10.106249999999989,
									53.50932617187493
								],
								[
									-10.116992187499932,
									53.548535156249926
								],
								[
									-10.061718749999955,
									53.56782226562504
								],
								[
									-10.001367187500023,
									53.56142578125008
								],
								[
									-9.878271484374977,
									53.59042968750012
								],
								[
									-9.720654296874926,
									53.60449218750006
								],
								[
									-9.855859374999937,
									53.63310546875002
								],
								[
									-9.909716796874989,
									53.65761718750002
								],
								[
									-9.912304687499983,
									53.695117187500045
								],
								[
									-9.901611328124943,
									53.727197265624994
								],
								[
									-9.745068359374926,
									53.78149414062506
								],
								[
									-9.578222656249949,
									53.80541992187494
								],
								[
									-9.590527343749983,
									53.84116210937495
								],
								[
									-9.578857421875,
									53.87983398437501
								],
								[
									-9.747509765624983,
									53.89101562500008
								],
								[
									-9.9140625,
									53.863720703124926
								],
								[
									-9.896240234375,
									53.93759765625006
								],
								[
									-9.856347656249966,
									54.004296874999966
								],
								[
									-9.848486328124949,
									54.048291015624955
								],
								[
									-9.856445312499972,
									54.09536132812505
								],
								[
									-9.934472656249966,
									54.07524414062502
								],
								[
									-9.943603515624972,
									54.14160156250006
								],
								[
									-9.97709960937496,
									54.18710937500009
								],
								[
									-10.092675781249966,
									54.15576171875
								],
								[
									-10.089697265624977,
									54.21582031250006
								],
								[
									-10.056396484374943,
									54.257812500000085
								],
								[
									-9.995947265624977,
									54.27602539062508
								],
								[
									-9.935937499999994,
									54.268115234375074
								],
								[
									-9.824560546874977,
									54.268896484375034
								],
								[
									-9.71713867187492,
									54.30043945312508
								],
								[
									-9.562304687500017,
									54.308544921874955
								],
								[
									-9.315527343750006,
									54.298632812500074
								],
								[
									-9.145898437499994,
									54.20961914062505
								],
								[
									-9.10209960937496,
									54.22553710937501
								],
								[
									-9.034277343749977,
									54.2817871093751
								],
								[
									-9.00244140625,
									54.28798828124994
								],
								[
									-8.746777343749955,
									54.2634765625001
								],
								[
									-8.588037109374937,
									54.23110351562508
								],
								[
									-8.545556640624994,
									54.2412109375
								],
								[
									-8.568457031249949,
									54.30361328125011
								],
								[
									-8.623144531249977,
									54.34687500000004
								],
								[
									-8.554443359375028,
									54.40356445312494
								],
								[
									-8.470996093749989,
									54.441943359375045
								],
								[
									-8.415234374999983,
									54.46108398437494
								],
								[
									-8.286523437499966,
									54.484863281250085
								],
								[
									-8.230371093749994,
									54.50727539062504
								],
								[
									-8.19296874999992,
									54.580126953125045
								],
								[
									-8.133447265624966,
									54.64082031250007
								],
								[
									-8.456542968749972,
									54.60927734374994
								],
								[
									-8.763916015624972,
									54.68120117187493
								],
								[
									-8.715185546875006,
									54.73203125000006
								],
								[
									-8.650292968750023,
									54.76088867187508
								],
								[
									-8.538281249999926,
									54.78295898437497
								],
								[
									-8.527685546874977,
									54.80947265625005
								],
								[
									-8.470996093749989,
									54.831542968750085
								],
								[
									-8.377294921875006,
									54.88945312499999
								],
								[
									-8.411718749999977,
									54.96508789062494
								],
								[
									-8.393261718749955,
									55.02041015624994
								],
								[
									-8.325781249999977,
									55.056445312500074
								],
								[
									-8.304687499999943,
									55.108203125000074
								],
								[
									-8.274609374999955,
									55.1462890625001
								],
								[
									-8.137695312499943,
									55.15991210937503
								],
								[
									-8.006103515624943,
									55.19531250000006
								],
								[
									-7.958593749999949,
									55.19189453124997
								],
								[
									-7.803173828125011,
									55.200048828125034
								],
								[
									-7.750537109374932,
									55.18579101562497
								],
								[
									-7.762548828124977,
									55.24833984375002
								],
								[
									-7.667089843749977,
									55.25649414062508
								],
								[
									-7.6297851562499375,
									55.24399414062509
								],
								[
									-7.613378906249977,
									55.199658203124955
								],
								[
									-7.570019531249926,
									55.17138671875006
								],
								[
									-7.556640624999972,
									55.12221679687508
								],
								[
									-7.585693359375028,
									55.08422851562497
								],
								[
									-7.634277343749972,
									55.05498046874996
								],
								[
									-7.589843749999972,
									55.025048828124994
								],
								[
									-7.658740234374989,
									54.970947265625085
								],
								[
									-7.584375000000023,
									54.99399414062498
								],
								[
									-7.478417968750023,
									55.04697265625012
								],
								[
									-7.483935546874989,
									55.09028320312504
								],
								[
									-7.501953125,
									55.144726562499955
								],
								[
									-7.531445312499983,
									55.193847656250114
								],
								[
									-7.51787109374996,
									55.24794921875002
								],
								[
									-7.458300781249989,
									55.28178710937499
								],
								[
									-7.3017578125,
									55.29877929687498
								],
								[
									-7.365966796875028,
									55.36020507812498
								],
								[
									-7.308789062500011,
									55.36582031250006
								],
								[
									-7.246679687499949,
									55.35302734375003
								],
								[
									-7.155322265624989,
									55.30517578125006
								],
								[
									-7.060253906249983,
									55.267626953125045
								],
								[
									-6.961669921874972,
									55.23789062500009
								],
								[
									-7.056396484375,
									55.178320312500034
								],
								[
									-7.172851562500028,
									55.137011718750074
								],
								[
									-7.2186523437499375,
									55.091992187499955
								],
								[
									-7.376904296874926,
									55.02768554687509
								],
								[
									-7.40141601562496,
									55.00332031250011
								],
								[
									-7.445996093749983,
									54.90512695312509
								],
								[
									-7.451269531249977,
									54.877099609374966
								],
								[
									-7.502197265624972,
									54.825439453125085
								],
								[
									-7.55039062499992,
									54.76796874999994
								],
								[
									-7.606445312499972,
									54.74570312500012
								],
								[
									-7.68999023437496,
									54.72802734374997
								],
								[
									-7.7374999999999545,
									54.71044921874994
								],
								[
									-7.797265624999966,
									54.71928710937496
								],
								[
									-7.872949218749994,
									54.717871093750034
								],
								[
									-7.9105957031249545,
									54.69833984375006
								],
								[
									-7.908740234374932,
									54.683349609375114
								],
								[
									-7.8861328124999375,
									54.66606445312496
								],
								[
									-7.819824218750028,
									54.6396972656251
								],
								[
									-7.7462890624999545,
									54.61582031250012
								],
								[
									-7.75439453125,
									54.59492187500004
								],
								[
									-7.793798828124949,
									54.5712402343751
								],
								[
									-8.044335937500023,
									54.512451171875114
								],
								[
									-8.118945312499932,
									54.47695312500008
								],
								[
									-8.14482421874996,
									54.453515624999994
								],
								[
									-8.118261718749977,
									54.4142578125001
								],
								[
									-7.918457031249943,
									54.2965820312501
								],
								[
									-7.8844726562499545,
									54.28378906250006
								],
								[
									-7.854931640624983,
									54.215283203124955
								],
								[
									-7.67875976562496,
									54.186669921874994
								],
								[
									-7.606542968750006,
									54.143847656250074
								],
								[
									-7.544433593749972,
									54.13359375000002
								],
								[
									-7.409423828125,
									54.13730468750006
								],
								[
									-7.3551757812499545,
									54.12124023437508
								],
								[
									-7.324511718750017,
									54.13344726562508
								],
								[
									-7.306738281249949,
									54.15600585937506
								],
								[
									-7.1930664062499545,
									54.214111328125085
								],
								[
									-7.1554687499999545,
									54.239501953125085
								],
								[
									-7.17807617187492,
									54.27490234375003
								],
								[
									-7.2025878906249545,
									54.3018066406251
								],
								[
									-7.133496093749983,
									54.35537109375008
								],
								[
									-7.049707031249966,
									54.40825195312502
								],
								[
									-7.0077148437499375,
									54.40668945312504
								],
								[
									-6.93613281249992,
									54.37431640625002
								],
								[
									-6.877246093749932,
									54.32910156250006
								],
								[
									-6.869238281249977,
									54.29404296875012
								],
								[
									-6.858349609374983,
									54.26865234375009
								],
								[
									-6.802587890625006,
									54.21435546874994
								],
								[
									-6.766601562499943,
									54.195605468750045
								],
								[
									-6.669531249999977,
									54.18471679687505
								],
								[
									-6.646874999999966,
									54.16342773437506
								],
								[
									-6.664208984374966,
									54.08476562500002
								],
								[
									-6.649804687499966,
									54.05864257812493
								],
								[
									-6.548144531249932,
									54.05727539062511
								],
								[
									-6.440283203124977,
									54.063623046874966
								],
								[
									-6.402587890624943,
									54.06064453125006
								],
								[
									-6.363671875000023,
									54.07709960937504
								],
								[
									-6.3036621093749545,
									54.09487304687494
								],
								[
									-6.218017578125,
									54.08872070312512
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "IRL",
					"su_a3": "IRL",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "IRL",
					"gu_a3": "IRL",
					"abbrev": "Ire.",
					"region_un": "Europe",
					"adm0_a3_us": "IRL",
					"scalerank": 1,
					"pop_est": 4203200,
					"adm0_dif": 0,
					"un_a3": "372",
					"pop_year": -99,
					"gdp_md_est": 188400,
					"name": "Ireland",
					"sovereignt": "Ireland",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Ireland",
					"postal": "IRL",
					"sov_a3": "IRL",
					"note_brk": "",
					"brk_a3": "IRL",
					"wb_a2": "IE",
					"brk_diff": 0,
					"admin": "Ireland",
					"name_long": "Ireland",
					"iso_a3": "IRL",
					"iso_a2": "IE",
					"adm0_a3_is": "IRL",
					"level": 2,
					"formal_en": "Ireland",
					"name_len": 7,
					"mapcolor7": 2,
					"long_len": 7,
					"mapcolor8": 3,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "372",
					"homepart": 1,
					"subunit": "Ireland",
					"name_alt": "",
					"brk_name": "Ireland",
					"name_sort": "Ireland",
					"continent": "Europe",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									56.187988281250114,
									26.921142578124943
								],
								[
									56.09492187500018,
									26.801171875000108
								],
								[
									55.95429687500001,
									26.701123046875068
								],
								[
									55.894140625000034,
									26.732275390625006
								],
								[
									55.84765625,
									26.730810546874977
								],
								[
									55.74726562500001,
									26.692480468750063
								],
								[
									55.67460937500016,
									26.68583984374996
								],
								[
									55.54316406250001,
									26.61752929687509
								],
								[
									55.423730468750136,
									26.58310546875009
								],
								[
									55.340429687500034,
									26.585742187500102
								],
								[
									55.3115234375,
									26.592626953124977
								],
								[
									55.29501953125009,
									26.639208984375045
								],
								[
									55.296484375000034,
									26.657568359374977
								],
								[
									55.346972656250045,
									26.64794921874997
								],
								[
									55.531738281250114,
									26.710009765625102
								],
								[
									55.762597656250136,
									26.811962890625068
								],
								[
									55.78457031250002,
									26.857177734375057
								],
								[
									55.747460937499966,
									26.93095703124999
								],
								[
									55.75761718749999,
									26.947656250000108
								],
								[
									55.90712890625002,
									26.909814453124937
								],
								[
									56.07412109375002,
									26.983349609375097
								],
								[
									56.21396484375009,
									27.003271484374977
								],
								[
									56.27939453125009,
									26.95209960937504
								],
								[
									56.187988281250114,
									26.921142578124943
								]
							]
						],
						[
							[
								[
									46.11445312500018,
									38.87778320312509
								],
								[
									46.17011718750018,
									38.869042968749994
								],
								[
									46.317773437500136,
									38.912646484375074
								],
								[
									46.490624999999966,
									38.90668945312504
								],
								[
									46.55478515625009,
									38.904394531250006
								],
								[
									46.783203125000114,
									39.087402343750085
								],
								[
									46.852539062500114,
									39.148437500000085
								],
								[
									46.98886718750009,
									39.18017578125006
								],
								[
									47.065429687500114,
									39.25288085937504
								],
								[
									47.188378906250136,
									39.34096679687505
								],
								[
									47.338476562500034,
									39.42387695312496
								],
								[
									47.476171875000034,
									39.498339843750045
								],
								[
									47.58183593750016,
									39.543359374999966
								],
								[
									47.77285156250002,
									39.64858398437508
								],
								[
									47.89228515625018,
									39.68505859374997
								],
								[
									47.99589843750016,
									39.683935546875006
								],
								[
									48.15107421875007,
									39.560546875000085
								],
								[
									48.281738281250114,
									39.44833984374998
								],
								[
									48.32216796875002,
									39.39907226562505
								],
								[
									48.25722656250002,
									39.35498046875006
								],
								[
									48.13603515624999,
									39.31235351562498
								],
								[
									48.11289062500009,
									39.281103515625006
								],
								[
									48.104394531250136,
									39.24111328125002
								],
								[
									48.10917968750016,
									39.20283203125004
								],
								[
									48.12548828125,
									39.171630859375
								],
								[
									48.27412109375018,
									39.09912109374997
								],
								[
									48.29101562499994,
									39.05927734375004
								],
								[
									48.29208984375009,
									39.01884765624996
								],
								[
									48.27509765625018,
									38.99360351562507
								],
								[
									48.24199218749999,
									38.97895507812501
								],
								[
									48.138574218749966,
									38.95864257812505
								],
								[
									48.05009765624999,
									38.93500976562501
								],
								[
									48.019335937500045,
									38.91181640625001
								],
								[
									47.992675781250114,
									38.884277343750085
								],
								[
									47.99648437500002,
									38.853759765625085
								],
								[
									48.023242187500045,
									38.81904296875001
								],
								[
									48.204687500000034,
									38.72412109375006
								],
								[
									48.225195312500034,
									38.68920898437503
								],
								[
									48.261328125000034,
									38.64228515624998
								],
								[
									48.30556640625002,
									38.61347656250007
								],
								[
									48.381250000000136,
									38.60561523437505
								],
								[
									48.417382812500136,
									38.58623046874993
								],
								[
									48.592675781250136,
									38.411083984374955
								],
								[
									48.63554687500016,
									38.39873046875002
								],
								[
									48.84033203124994,
									38.43725585937506
								],
								[
									48.86875000000009,
									38.435498046874955
								],
								[
									48.870703125000034,
									38.3925292968751
								],
								[
									48.90136718749994,
									38.143652343750006
								],
								[
									48.92509765624999,
									38.01513671875003
								],
								[
									48.959960937500114,
									37.89013671875006
								],
								[
									49.01533203125018,
									37.7760742187501
								],
								[
									49.080957031250136,
									37.667578125000006
								],
								[
									49.17119140625016,
									37.60058593749994
								],
								[
									49.37246093750002,
									37.519970703124955
								],
								[
									49.47011718750002,
									37.496679687500006
								],
								[
									49.726953125000136,
									37.4805175781251
								],
								[
									49.98066406250001,
									37.44487304687493
								],
								[
									50.13046875000009,
									37.407128906249966
								],
								[
									50.17626953125,
									37.380517578124966
								],
								[
									50.21406250000007,
									37.33959960937506
								],
								[
									50.33789062499994,
									37.149169921875
								],
								[
									50.53320312499994,
									37.013671875000114
								],
								[
									50.92744140625018,
									36.81020507812505
								],
								[
									51.118554687500136,
									36.74257812499994
								],
								[
									51.762011718750045,
									36.61450195312506
								],
								[
									52.19013671875001,
									36.62172851562511
								],
								[
									53.37412109375009,
									36.86874999999998
								],
								[
									53.76767578125009,
									36.930322265624994
								],
								[
									53.915429687500136,
									36.930322265624994
								],
								[
									53.82744140625016,
									36.881201171875034
								],
								[
									53.679492187500045,
									36.85312500000009
								],
								[
									53.76875000000001,
									36.81845703124995
								],
								[
									53.90624999999994,
									36.812695312499926
								],
								[
									53.97011718750002,
									36.81831054687501
								],
								[
									54.01621093750009,
									36.849658203125074
								],
								[
									54.023828125000136,
									36.901318359374955
								],
								[
									54.01718750000009,
									36.95249023437506
								],
								[
									53.951953125000045,
									37.18173828125006
								],
								[
									53.91416015625009,
									37.34355468749999
								],
								[
									54.19160156250018,
									37.33247070312504
								],
								[
									54.299804687500114,
									37.35361328125009
								],
								[
									54.45869140625018,
									37.40756835937506
								],
								[
									54.57890625000016,
									37.44023437499996
								],
								[
									54.6396484375,
									37.444726562499994
								],
								[
									54.69941406250018,
									37.47016601562501
								],
								[
									54.74521484375009,
									37.50190429687501
								],
								[
									54.848632812500114,
									37.72265624999994
								],
								[
									54.90009765625001,
									37.77792968750012
								],
								[
									55.075585937499966,
									37.902490234374994
								],
								[
									55.22470703125009,
									37.98134765625008
								],
								[
									55.380859375000114,
									38.05112304687506
								],
								[
									55.57841796874999,
									38.09975585937502
								],
								[
									55.841308593750114,
									38.094628906249966
								],
								[
									56.05029296874994,
									38.07753906250005
								],
								[
									56.17119140625016,
									38.07836914062494
								],
								[
									56.22880859374999,
									38.073388671874994
								],
								[
									56.272070312500034,
									38.080419921875006
								],
								[
									56.296972656250034,
									38.094824218750006
								],
								[
									56.324121093750136,
									38.1911132812501
								],
								[
									56.36689453125007,
									38.22250976562509
								],
								[
									56.44062500000018,
									38.249414062499966
								],
								[
									56.54404296875009,
									38.249609375000006
								],
								[
									56.669921875,
									38.25664062499993
								],
								[
									56.77460937500018,
									38.25004882812502
								],
								[
									56.906640624999966,
									38.21303710937502
								],
								[
									57.07900390625002,
									38.209960937500114
								],
								[
									57.19355468750018,
									38.21640625000009
								],
								[
									57.260156250000136,
									38.17958984375005
								],
								[
									57.30810546874994,
									38.13037109375006
								],
								[
									57.33144531250002,
									38.08930664062504
								],
								[
									57.336718750000045,
									38.03291015625001
								],
								[
									57.33574218749999,
									37.989941406249955
								],
								[
									57.35371093750001,
									37.97333984375004
								],
								[
									57.423828125000114,
									37.94770507812507
								],
								[
									57.52099609375,
									37.92846679687506
								],
								[
									57.71054687500009,
									37.90527343750003
								],
								[
									57.888183593750114,
									37.86083984374994
								],
								[
									57.98056640625009,
									37.83046875000005
								],
								[
									58.10878906250002,
									37.78305664062509
								],
								[
									58.261621093749966,
									37.6658203125001
								],
								[
									58.318164062500045,
									37.64721679687494
								],
								[
									58.38671875,
									37.63535156250009
								],
								[
									58.43574218750018,
									37.63852539062495
								],
								[
									58.55048828125001,
									37.68818359375004
								],
								[
									58.65019531249999,
									37.65156250000004
								],
								[
									58.70078125000009,
									37.656250000000085
								],
								[
									58.815429687500114,
									37.683496093749966
								],
								[
									58.93720703125001,
									37.649658203125
								],
								[
									59.24082031250009,
									37.52075195312503
								],
								[
									59.27412109375001,
									37.52373046875002
								],
								[
									59.30175781249994,
									37.51064453125011
								],
								[
									59.326953125000045,
									37.481152343749955
								],
								[
									59.344726562500114,
									37.444726562499994
								],
								[
									59.36738281250018,
									37.33374023437494
								],
								[
									59.45498046875002,
									37.25283203125008
								],
								[
									59.56220703125018,
									37.178906249999926
								],
								[
									59.68720703125007,
									37.138476562500045
								],
								[
									59.948632812500136,
									37.04160156250012
								],
								[
									60.062792968750045,
									36.96289062499997
								],
								[
									60.178320312500034,
									36.82944335937506
								],
								[
									60.320703124999966,
									36.653564453125114
								],
								[
									60.341308593750114,
									36.63764648437507
								],
								[
									60.70791015625002,
									36.64296875000008
								],
								[
									61.119628906250114,
									36.642578125
								],
								[
									61.169921875,
									36.57226562499997
								],
								[
									61.16035156250018,
									36.43271484375006
								],
								[
									61.17509765625016,
									36.28969726562505
								],
								[
									61.212011718750034,
									36.190527343750006
								],
								[
									61.212402343750114,
									36.09912109374994
								],
								[
									61.1826171875,
									36.05283203125012
								],
								[
									61.15947265625016,
									35.99990234375008
								],
								[
									61.15292968750009,
									35.97675781250007
								],
								[
									61.20585937499999,
									35.94370117187509
								],
								[
									61.25214843750001,
									35.86762695312504
								],
								[
									61.258691406250136,
									35.76181640624998
								],
								[
									61.23554687500001,
									35.70556640624997
								],
								[
									61.23886718750009,
									35.659277343750034
								],
								[
									61.26201171874999,
									35.619580078124955
								],
								[
									61.281835937500034,
									35.55341796875007
								],
								[
									61.27851562500018,
									35.51376953124998
								],
								[
									61.24550781250002,
									35.47407226562507
								],
								[
									61.225683593750034,
									35.424462890624994
								],
								[
									61.19921875,
									35.361621093750074
								],
								[
									61.18925781249999,
									35.31201171875
								],
								[
									61.139648437500114,
									35.28886718749999
								],
								[
									61.100000000000136,
									35.27231445312509
								],
								[
									61.10664062500007,
									35.20947265625006
								],
								[
									61.126464843750114,
									35.156542968750045
								],
								[
									61.149609375000125,
									35.09375000000003
								],
								[
									61.123144531250034,
									35.05073242187507
								],
								[
									61.10664062500007,
									35.00112304687508
								],
								[
									61.07021484375008,
									34.92172851562498
								],
								[
									61.08007812500006,
									34.85561523437511
								],
								[
									61.04042968750008,
									34.7993652343751
								],
								[
									60.99082031250009,
									34.74975585937503
								],
								[
									60.95781249999999,
									34.71005859375012
								],
								[
									60.951171875,
									34.65385742187502
								],
								[
									60.91474609375001,
									34.63398437500007
								],
								[
									60.84531250000009,
									34.58769531249996
								],
								[
									60.802343750000034,
									34.55463867187507
								],
								[
									60.73945312500001,
									34.5447265625001
								],
								[
									60.72626953125007,
									34.51826171875004
								],
								[
									60.736132812500045,
									34.49179687500006
								],
								[
									60.762597656250136,
									34.475244140624966
								],
								[
									60.803906250000125,
									34.418017578125045
								],
								[
									60.889453125000045,
									34.31943359375012
								],
								[
									60.642675781250034,
									34.30717773437502
								],
								[
									60.57021484375002,
									34.21962890625002
								],
								[
									60.485742187500136,
									34.09477539062499
								],
								[
									60.527050781250125,
									33.84199218750001
								],
								[
									60.48593750000009,
									33.71191406249997
								],
								[
									60.51083984375009,
									33.63891601562503
								],
								[
									60.573828125000034,
									33.58833007812501
								],
								[
									60.654589843750045,
									33.56040039062512
								],
								[
									60.80644531249999,
									33.55869140625012
								],
								[
									60.90693359375007,
									33.53896484375008
								],
								[
									60.91699218750006,
									33.50522460937506
								],
								[
									60.85927734375002,
									33.45625000000004
								],
								[
									60.766894531250045,
									33.36381835937502
								],
								[
									60.718066406250045,
									33.32353515624999
								],
								[
									60.560546875,
									33.137841796874994
								],
								[
									60.56191406250002,
									33.05878906250007
								],
								[
									60.57656250000008,
									32.994873046875
								],
								[
									60.64453125000006,
									32.79438476562501
								],
								[
									60.71044921875,
									32.60000000000002
								],
								[
									60.82929687500001,
									32.24941406250011
								],
								[
									60.827246093750034,
									32.16796875000003
								],
								[
									60.78994140625002,
									31.987109375000045
								],
								[
									60.787500000000136,
									31.87719726562503
								],
								[
									60.80429687500009,
									31.73447265625009
								],
								[
									60.79160156250009,
									31.66059570312504
								],
								[
									60.82070312500008,
									31.495166015625102
								],
								[
									60.854101562500034,
									31.483251953124977
								],
								[
									61.11074218750008,
									31.451123046875097
								],
								[
									61.346484375000045,
									31.42163085937503
								],
								[
									61.660156250000114,
									31.382421875000034
								],
								[
									61.75507812500007,
									31.285302734374966
								],
								[
									61.814257812500045,
									31.072558593750074
								],
								[
									61.810839843750045,
									30.91328125000004
								],
								[
									61.78417968750006,
									30.83193359375008
								],
								[
									61.559472656250136,
									30.59936523437503
								],
								[
									61.331640625000034,
									30.363720703124983
								],
								[
									61.10410156250009,
									30.12841796875
								],
								[
									60.86816406249994,
									29.88437500000012
								],
								[
									60.843359375000034,
									29.858691406250045
								],
								[
									61.034179687500114,
									29.663427734375034
								],
								[
									61.15214843749999,
									29.542724609375057
								],
								[
									61.318359375000114,
									29.372607421875045
								],
								[
									61.339453125000034,
									29.331787109375057
								],
								[
									61.337890625000114,
									29.264990234375063
								],
								[
									61.50859375000016,
									29.006054687500068
								],
								[
									61.568750000000136,
									28.87089843749996
								],
								[
									61.623046875000114,
									28.791601562499977
								],
								[
									61.75800781250007,
									28.66767578125004
								],
								[
									61.88984375000007,
									28.546533203124966
								],
								[
									62.033007812500045,
									28.491015625000017
								],
								[
									62.13056640625001,
									28.478808593750017
								],
								[
									62.35302734375006,
									28.41474609375004
								],
								[
									62.43388671874999,
									28.363867187500063
								],
								[
									62.564550781250034,
									28.235156250000045
								],
								[
									62.717578125000045,
									28.252783203124977
								],
								[
									62.74941406250008,
									28.252880859375097
								],
								[
									62.75800781250001,
									28.243554687499966
								],
								[
									62.762500000000045,
									28.20205078125005
								],
								[
									62.73974609375006,
									28.002050781250063
								],
								[
									62.782324218750034,
									27.80053710937503
								],
								[
									62.812011718750114,
									27.49702148437501
								],
								[
									62.80087890625009,
									27.444531249999983
								],
								[
									62.76425781250009,
									27.356738281250045
								],
								[
									62.762500000000045,
									27.30019531250008
								],
								[
									62.752734375000045,
									27.265625000000057
								],
								[
									62.762988281250045,
									27.25019531250001
								],
								[
									62.811621093750034,
									27.22944335937504
								],
								[
									62.915429687500136,
									27.218408203125023
								],
								[
									63.16679687499999,
									27.252490234375045
								],
								[
									63.196093750000045,
									27.243945312500074
								],
								[
									63.256250000000136,
									27.207910156250108
								],
								[
									63.30156249999999,
									27.151464843750063
								],
								[
									63.30517578125006,
									27.12456054687499
								],
								[
									63.24208984375008,
									27.077685546875045
								],
								[
									63.231445312500114,
									26.99814453125009
								],
								[
									63.25039062500008,
									26.87924804687512
								],
								[
									63.241601562500136,
									26.86474609375
								],
								[
									63.186132812500034,
									26.837597656250068
								],
								[
									63.16806640625009,
									26.665576171875017
								],
								[
									63.157812500000034,
									26.649755859375063
								],
								[
									63.09296875000007,
									26.632324218750085
								],
								[
									62.786621093750114,
									26.643896484375034
								],
								[
									62.751562500000034,
									26.639160156250057
								],
								[
									62.63642578125007,
									26.593652343750108
								],
								[
									62.439257812500045,
									26.56103515625003
								],
								[
									62.38505859374999,
									26.542626953125108
								],
								[
									62.31230468749999,
									26.490869140625023
								],
								[
									62.259667968750136,
									26.427490234375
								],
								[
									62.249609375000034,
									26.369238281250034
								],
								[
									62.23935546875009,
									26.357031250000034
								],
								[
									62.12597656250006,
									26.368994140625063
								],
								[
									62.08906250000007,
									26.31826171875005
								],
								[
									61.869824218750125,
									26.242431640625057
								],
								[
									61.842382812500034,
									26.225927734375063
								],
								[
									61.80996093750008,
									26.165283203125057
								],
								[
									61.78076171875,
									25.995849609375085
								],
								[
									61.754394531250114,
									25.84335937500009
								],
								[
									61.73769531250002,
									25.821093750000102
								],
								[
									61.66865234375007,
									25.76899414062504
								],
								[
									61.66181640625007,
									25.75126953124999
								],
								[
									61.67138671875,
									25.692382812500085
								],
								[
									61.640136718750114,
									25.584619140624966
								],
								[
									61.61542968750007,
									25.2861328125
								],
								[
									61.58789062500006,
									25.202343749999983
								],
								[
									61.533105468749966,
									25.195507812499926
								],
								[
									61.490332031250034,
									25.15366210937509
								],
								[
									61.412207031250034,
									25.10209960937499
								],
								[
									61.242968750000045,
									25.141992187500023
								],
								[
									61.10859375000018,
									25.183886718750045
								],
								[
									60.66386718749999,
									25.2822265625
								],
								[
									60.61513671875002,
									25.32983398437503
								],
								[
									60.58750000000009,
									25.413525390624926
								],
								[
									60.510546875000045,
									25.437060546875017
								],
								[
									60.40019531249999,
									25.31157226562513
								],
								[
									60.02470703125016,
									25.384130859374977
								],
								[
									59.89707031250009,
									25.361816406250057
								],
								[
									59.81835937499994,
									25.400878906250114
								],
								[
									59.616015625000045,
									25.403271484375068
								],
								[
									59.45605468749994,
									25.481494140625102
								],
								[
									59.22724609375007,
									25.427734375000085
								],
								[
									59.04609375000018,
									25.41728515624999
								],
								[
									58.7978515625,
									25.55458984375008
								],
								[
									58.530859375000034,
									25.592431640624966
								],
								[
									58.31425781250016,
									25.580859375000102
								],
								[
									58.20292968749999,
									25.591601562500074
								],
								[
									58.02236328125002,
									25.64082031250004
								],
								[
									57.936621093750034,
									25.691650390625114
								],
								[
									57.79609375000018,
									25.65302734375004
								],
								[
									57.73251953125009,
									25.724902343750045
								],
								[
									57.334570312500034,
									25.79155273437513
								],
								[
									57.26093750000001,
									25.918847656249937
								],
								[
									57.20556640624994,
									26.037207031249977
								],
								[
									57.20136718750018,
									26.15883789062508
								],
								[
									57.10429687499999,
									26.37143554687495
								],
								[
									57.07197265625018,
									26.680078125000023
								],
								[
									57.036035156250136,
									26.80068359375008
								],
								[
									56.98222656249999,
									26.90546875000004
								],
								[
									56.91044921875016,
									26.994580078124983
								],
								[
									56.812890624999966,
									27.089990234374966
								],
								[
									56.728125000000034,
									27.127685546875085
								],
								[
									56.35615234375018,
									27.20024414062496
								],
								[
									56.28437500000001,
									27.190624999999955
								],
								[
									56.11806640625002,
									27.143115234375045
								],
								[
									55.94111328125018,
									27.03759765625003
								],
								[
									55.65029296875002,
									26.97753906249997
								],
								[
									55.591601562500045,
									26.932128906250057
								],
								[
									55.5185546875,
									26.829931640625006
								],
								[
									55.42402343750018,
									26.77055664062499
								],
								[
									55.29414062500018,
									26.785937499999932
								],
								[
									55.15458984374999,
									26.725390625000017
								],
								[
									54.895800781250045,
									26.556689453125045
								],
								[
									54.759277343750114,
									26.505078125000097
								],
								[
									54.644921874999966,
									26.50893554687508
								],
								[
									54.52207031250009,
									26.58916015624999
								],
								[
									54.247070312500114,
									26.696630859375034
								],
								[
									54.06933593749994,
									26.73237304687504
								],
								[
									53.82255859375016,
									26.707714843749983
								],
								[
									53.70576171875007,
									26.725585937500057
								],
								[
									53.50712890624999,
									26.851757812499926
								],
								[
									53.454980468750136,
									26.943261718750108
								],
								[
									53.341699218750136,
									27.004492187500034
								],
								[
									52.98251953125009,
									27.141943359374977
								],
								[
									52.69160156250007,
									27.323388671874994
								],
								[
									52.63818359375,
									27.391992187499937
								],
								[
									52.602636718750034,
									27.493359374999983
								],
								[
									52.47587890625016,
									27.616503906250017
								],
								[
									52.191894531250114,
									27.717285156250057
								],
								[
									52.03076171874994,
									27.824414062499926
								],
								[
									51.84199218750007,
									27.84824218750009
								],
								[
									51.66630859375016,
									27.844970703124943
								],
								[
									51.58906250000007,
									27.864208984374955
								],
								[
									51.5185546875,
									27.910009765625063
								],
								[
									51.27890625000009,
									28.13134765625003
								],
								[
									51.27607421875007,
									28.21884765625009
								],
								[
									51.12841796875,
									28.435156250000006
								],
								[
									51.093847656250034,
									28.512109374999966
								],
								[
									51.06201171874994,
									28.72612304687496
								],
								[
									51.02119140625018,
									28.78208007812509
								],
								[
									50.866992187500045,
									28.87016601562499
								],
								[
									50.84296875000018,
									28.92783203125012
								],
								[
									50.875781250000045,
									29.004394531250085
								],
								[
									50.875781250000045,
									29.062695312499955
								],
								[
									50.795507812500034,
									29.117431640625085
								],
								[
									50.675195312500136,
									29.14658203125009
								],
								[
									50.646093750000034,
									29.212207031250045
								],
								[
									50.66796875,
									29.33984375000003
								],
								[
									50.64960937500007,
									29.420068359374937
								],
								[
									50.543554687500034,
									29.54799804687505
								],
								[
									50.38691406250018,
									29.679052734375034
								],
								[
									50.23017578125007,
									29.87290039062509
								],
								[
									50.168945312500114,
									29.921240234375063
								],
								[
									50.128906250000114,
									30.048095703125085
								],
								[
									50.07158203125016,
									30.19853515624999
								],
								[
									49.98310546875018,
									30.20937500000008
								],
								[
									49.55488281250007,
									30.028955078124994
								],
								[
									49.42998046874999,
									30.130468749999977
								],
								[
									49.054296875000034,
									30.30693359374996
								],
								[
									49.028125000000045,
									30.33344726562504
								],
								[
									49.001953125000114,
									30.373925781250023
								],
								[
									49.04902343750001,
									30.397265625000074
								],
								[
									49.09619140624994,
									30.40678710937496
								],
								[
									49.190332031250136,
									30.37539062500005
								],
								[
									49.24726562500018,
									30.412499999999966
								],
								[
									49.224511718749966,
									30.47231445312508
								],
								[
									49.13037109375,
									30.509423828124994
								],
								[
									49.001953125000114,
									30.50654296875004
								],
								[
									49.037109375,
									30.450488281250074
								],
								[
									48.91679687499999,
									30.397265625000074
								],
								[
									48.891210937500034,
									30.32763671875
								],
								[
									48.908691406250114,
									30.241455078124943
								],
								[
									48.91914062500001,
									30.120898437500074
								],
								[
									48.8701171875,
									30.062402343749966
								],
								[
									48.832421875000136,
									30.03549804687509
								],
								[
									48.6708984375,
									30.02832031250003
								],
								[
									48.59550781249999,
									29.97504882812501
								],
								[
									48.546484375000034,
									29.96235351562501
								],
								[
									48.47851562500006,
									30.003808593750023
								],
								[
									48.4345703125,
									30.03759765624997
								],
								[
									48.39863281250001,
									30.109619140625085
								],
								[
									48.38759765625002,
									30.15986328125001
								],
								[
									48.40136718750006,
									30.188330078125034
								],
								[
									48.382617187500045,
									30.23017578125004
								],
								[
									48.33105468750006,
									30.285449218750017
								],
								[
									48.27890625000009,
									30.315820312499994
								],
								[
									48.22617187500009,
									30.32133789062496
								],
								[
									48.18242187500016,
									30.35502929687499
								],
								[
									48.147558593750034,
									30.416845703125063
								],
								[
									48.06611328125007,
									30.457666015625023
								],
								[
									48.014941406250045,
									30.46562499999996
								],
								[
									48.01347656249999,
									30.65644531250001
								],
								[
									48.01201171875016,
									30.82363281250005
								],
								[
									48.010644531250136,
									30.98979492187499
								],
								[
									47.836328125000136,
									30.996435546875006
								],
								[
									47.6794921875001,
									31.002392578125068
								],
								[
									47.6794921875001,
									31.14150390625008
								],
								[
									47.6794921875001,
									31.40058593750001
								],
								[
									47.75390625000006,
									31.601367187500045
								],
								[
									47.82998046875002,
									31.794433593750057
								],
								[
									47.71455078125001,
									31.936425781250023
								],
								[
									47.59150390625007,
									32.08798828125006
								],
								[
									47.51191406250007,
									32.1508300781251
								],
								[
									47.41816406250007,
									32.340087890625085
								],
								[
									47.37128906250007,
									32.423730468749994
								],
								[
									47.32978515625018,
									32.45551757812498
								],
								[
									47.285156250000114,
									32.47402343750002
								],
								[
									47.121386718750045,
									32.46660156250002
								],
								[
									46.96855468749999,
									32.568408203125074
								],
								[
									46.78906250000006,
									32.687988281250085
								],
								[
									46.56992187500009,
									32.83393554687498
								],
								[
									46.377050781250034,
									32.929248046875045
								],
								[
									46.298242187500136,
									32.950244140625045
								],
								[
									46.112792968750114,
									32.957666015624966
								],
								[
									46.09306640624999,
									32.975878906250045
								],
								[
									46.08046875000002,
									33.02822265625005
								],
								[
									46.08076171875018,
									33.08652343750012
								],
								[
									46.141113281250114,
									33.17441406250006
								],
								[
									46.14589843750002,
									33.22963867187505
								],
								[
									46.019921875000136,
									33.41572265625004
								],
								[
									45.98105468750009,
									33.47011718750011
								],
								[
									45.87324218750018,
									33.49199218750002
								],
								[
									45.89472656250007,
									33.54565429687503
								],
								[
									45.89472656250007,
									33.58154296874997
								],
								[
									45.87939453125,
									33.60976562500005
								],
								[
									45.8544921875,
									33.62333984374996
								],
								[
									45.822851562500034,
									33.62480468749999
								],
								[
									45.738281250000114,
									33.60283203124996
								],
								[
									45.67373046875002,
									33.68666992187508
								],
								[
									45.473242187500034,
									33.92548828125007
								],
								[
									45.4089843750001,
									33.95449218750011
								],
								[
									45.397070312500034,
									33.970849609374966
								],
								[
									45.44609374999999,
									34.04404296875006
								],
								[
									45.528613281250045,
									34.15253906250004
								],
								[
									45.542773437500045,
									34.21552734375007
								],
								[
									45.526855468750114,
									34.28466796875006
								],
								[
									45.437597656250034,
									34.41513671874998
								],
								[
									45.459375000000136,
									34.47036132812505
								],
								[
									45.49775390625007,
									34.53388671875001
								],
								[
									45.500781250000045,
									34.58159179687496
								],
								[
									45.560839843750045,
									34.57451171875002
								],
								[
									45.63749999999999,
									34.57382812499998
								],
								[
									45.66152343750002,
									34.612695312499994
								],
								[
									45.66005859375008,
									34.748779296875
								],
								[
									45.678125000000136,
									34.79843750000009
								],
								[
									45.920898437500114,
									35.02851562500007
								],
								[
									46.041796875000045,
									35.08017578125012
								],
								[
									46.13378906250006,
									35.12763671875001
								],
								[
									46.154687500000136,
									35.19672851562504
								],
								[
									46.1357421875,
									35.232275390625006
								],
								[
									46.117773437500034,
									35.284277343750034
								],
								[
									46.112109375000045,
									35.32167968750011
								],
								[
									46.01064453125008,
									35.42480468749997
								],
								[
									45.97539062499999,
									35.476806640625
								],
								[
									45.971093750000136,
									35.52416992187506
								],
								[
									45.99501953125002,
									35.60810546875001
								],
								[
									46.037402343750045,
									35.67314453125002
								],
								[
									46.18095703125016,
									35.7113769531251
								],
								[
									46.262500000000045,
									35.744140625000114
								],
								[
									46.27343750000006,
									35.77324218749999
								],
								[
									46.16748046875006,
									35.82055664062503
								],
								[
									45.941406250000114,
									35.83540039062504
								],
								[
									45.77636718750006,
									35.821826171875045
								],
								[
									45.72343749999999,
									35.83666992187503
								],
								[
									45.645019531250114,
									35.92836914062508
								],
								[
									45.56162109375009,
									35.97719726562508
								],
								[
									45.483789062500136,
									36.00854492187497
								],
								[
									45.407714843750114,
									36.002783203125034
								],
								[
									45.361621093750045,
									36.01533203125001
								],
								[
									45.35087890625016,
									36.05463867187504
								],
								[
									45.24111328125008,
									36.35595703125006
								],
								[
									45.20654296875006,
									36.39716796875001
								],
								[
									45.1552734375,
									36.40737304687505
								],
								[
									45.112402343750034,
									36.40927734375006
								],
								[
									45.08378906249999,
									36.430029296875034
								],
								[
									45.053125000000136,
									36.47163085937498
								],
								[
									45.03105468749999,
									36.52607421875007
								],
								[
									45.029394531250034,
									36.59755859375005
								],
								[
									45.033984375000045,
									36.65888671875004
								],
								[
									45.01923828125007,
									36.698388671874994
								],
								[
									44.981445312500114,
									36.73769531250011
								],
								[
									44.927832031250034,
									36.76591796874999
								],
								[
									44.88085937500006,
									36.79931640625006
								],
								[
									44.798437500000034,
									37.06386718750002
								],
								[
									44.765429687500045,
									37.13500976562506
								],
								[
									44.765136718750114,
									37.142431640625034
								],
								[
									44.766699218750034,
									37.15634765624995
								],
								[
									44.758300781250114,
									37.217089843750074
								],
								[
									44.796777343750136,
									37.26977539062506
								],
								[
									44.79414062500007,
									37.29038085937509
								],
								[
									44.715136718750045,
									37.3571289062501
								],
								[
									44.604101562500034,
									37.42373046875008
								],
								[
									44.57402343750016,
									37.435400390625034
								],
								[
									44.573144531249966,
									37.506396484375045
								],
								[
									44.5771484375,
									37.56020507812508
								],
								[
									44.56718749999999,
									37.608642578125085
								],
								[
									44.54609375000007,
									37.63632812499995
								],
								[
									44.545312499999966,
									37.658154296874955
								],
								[
									44.589941406250034,
									37.71035156250002
								],
								[
									44.56123046875001,
									37.744628906250085
								],
								[
									44.397753906250045,
									37.829248046874994
								],
								[
									44.336230468750045,
									37.871777343749955
								],
								[
									44.222949218750045,
									37.880175781250074
								],
								[
									44.211328124999966,
									37.90805664062506
								],
								[
									44.22890625000002,
									37.96718749999994
								],
								[
									44.267968749999966,
									38.03881835937506
								],
								[
									44.32939453125016,
									38.10927734375002
								],
								[
									44.348925781250045,
									38.14648437500006
								],
								[
									44.37275390625018,
									38.20971679687506
								],
								[
									44.38085937499994,
									38.254589843749955
								],
								[
									44.449609375000136,
									38.31777343750005
								],
								[
									44.44990234375018,
									38.334228515625114
								],
								[
									44.43085937500001,
									38.35678710937509
								],
								[
									44.37578124999999,
									38.36958007812504
								],
								[
									44.31962890624999,
									38.37470703125001
								],
								[
									44.29853515625018,
									38.38627929687496
								],
								[
									44.29082031249999,
									38.420117187499926
								],
								[
									44.297851562500114,
									38.55781250000001
								],
								[
									44.280175781249966,
									38.64067382812502
								],
								[
									44.25703125000007,
									38.70063476562507
								],
								[
									44.27167968750001,
									38.83603515625012
								],
								[
									44.232421875000114,
									38.86323242187507
								],
								[
									44.170800781249966,
									38.934375000000074
								],
								[
									44.14453124999994,
									38.99438476562503
								],
								[
									44.158789062500034,
									39.01674804687508
								],
								[
									44.171875000000114,
									39.056250000000034
								],
								[
									44.18056640625002,
									39.10805664062502
								],
								[
									44.178027343750045,
									39.14482421874996
								],
								[
									44.12128906250001,
									39.18061523437507
								],
								[
									44.07910156249994,
									39.2183105468751
								],
								[
									44.074316406250034,
									39.25996093750007
								],
								[
									44.05751953125002,
									39.31083984375002
								],
								[
									44.033789062500034,
									39.351025390624955
								],
								[
									44.023242187500045,
									39.377441406250085
								],
								[
									44.0439453125,
									39.39296875000005
								],
								[
									44.12402343749994,
									39.40522460937498
								],
								[
									44.24042968750007,
									39.396777343750045
								],
								[
									44.33544921874994,
									39.396044921875074
								],
								[
									44.38935546875018,
									39.42211914062506
								],
								[
									44.455957031249966,
									39.66674804687497
								],
								[
									44.516699218750034,
									39.731250000000045
								],
								[
									44.58710937500007,
									39.768554687500114
								],
								[
									44.72500000000002,
									39.681738281250006
								],
								[
									44.78212890625002,
									39.65107421875007
								],
								[
									44.817187500000045,
									39.65043945312493
								],
								[
									44.83818359375016,
									39.62910156250004
								],
								[
									45.00019531250001,
									39.42353515624998
								],
								[
									45.07167968750002,
									39.36289062499998
								],
								[
									45.11308593749999,
									39.3115722656251
								],
								[
									45.141210937500034,
									39.254296874999966
								],
								[
									45.19062500000018,
									39.21562499999999
								],
								[
									45.25595703125009,
									39.19467773437509
								],
								[
									45.335546875000034,
									39.13916015625006
								],
								[
									45.389257812500034,
									39.09589843750004
								],
								[
									45.47968750000018,
									39.006249999999966
								],
								[
									45.57500000000016,
									38.972802734374994
								],
								[
									45.921875000000114,
									38.90791015625001
								],
								[
									46.11445312500018,
									38.87778320312509
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "IRN",
					"su_a3": "IRN",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "IRN",
					"gu_a3": "IRN",
					"abbrev": "Iran",
					"region_un": "Asia",
					"adm0_a3_us": "IRN",
					"scalerank": 1,
					"pop_est": 66429284,
					"adm0_dif": 0,
					"un_a3": "364",
					"pop_year": -99,
					"gdp_md_est": 841700,
					"name": "Iran",
					"sovereignt": "Iran",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Iran",
					"postal": "IRN",
					"sov_a3": "IRN",
					"note_brk": "",
					"brk_a3": "IRN",
					"wb_a2": "IR",
					"brk_diff": 0,
					"admin": "Iran",
					"name_long": "Iran",
					"iso_a3": "IRN",
					"iso_a2": "IR",
					"adm0_a3_is": "IRN",
					"level": 2,
					"formal_en": "Islamic Republic of Iran",
					"name_len": 4,
					"mapcolor7": 4,
					"long_len": 4,
					"mapcolor8": 3,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "364",
					"homepart": 1,
					"subunit": "Iran",
					"name_alt": "",
					"brk_name": "Iran",
					"name_sort": "Iran, Islamic Rep.",
					"continent": "Asia",
					"mapcolor13": 13,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								35.78730468750001,
								32.73491210937499
							],
							[
								35.73447265625009,
								32.728906249999994
							],
							[
								35.61123046875002,
								32.68208007812504
							],
							[
								35.59453124999999,
								32.66801757812502
							],
							[
								35.572851562500034,
								32.640869140625
							],
							[
								35.56904296875001,
								32.619873046875
							],
							[
								35.551464843750125,
								32.39550781250003
							],
							[
								35.484375000000114,
								32.40166015625002
							],
							[
								35.402636718750045,
								32.45063476562507
							],
							[
								35.386718750000114,
								32.49301757812509
							],
							[
								35.362109375000045,
								32.50747070312508
							],
							[
								35.30380859375009,
								32.51293945312506
							],
							[
								35.193261718750136,
								32.534423828125085
							],
							[
								35.065039062500034,
								32.460449218750114
							],
							[
								35.010546875000045,
								32.338183593750074
							],
							[
								34.999511718750114,
								32.281054687500074
							],
							[
								34.95595703125002,
								32.16093750000002
							],
							[
								34.97138671875007,
								32.08710937499998
							],
							[
								34.97880859375016,
								31.99160156250008
							],
							[
								34.98974609375006,
								31.91328125000001
							],
							[
								34.978320312500045,
								31.86640625000004
							],
							[
								34.95380859375001,
								31.841259765625068
							],
							[
								34.96113281250007,
								31.823339843749977
							],
							[
								34.983007812500034,
								31.81679687500008
							],
							[
								35.053222656250114,
								31.837939453125017
							],
							[
								35.12714843750018,
								31.816748046875063
							],
							[
								35.198046875000045,
								31.776318359375097
							],
							[
								35.203710937500034,
								31.750000000000057
							],
							[
								35.15341796875009,
								31.73447265625009
							],
							[
								35.03466796875006,
								31.67324218750005
							],
							[
								34.950976562500045,
								31.602294921875057
							],
							[
								34.92919921875,
								31.536572265625097
							],
							[
								34.87275390625001,
								31.396874999999966
							],
							[
								34.88046875000009,
								31.36816406249997
							],
							[
								34.90781250000009,
								31.351318359375085
							],
							[
								35.101171875000034,
								31.36621093750003
							],
							[
								35.276660156250045,
								31.42280273437501
							],
							[
								35.40869140625006,
								31.482910156250085
							],
							[
								35.45058593750008,
								31.47929687499996
							],
							[
								35.4228515625,
								31.325390625000068
							],
							[
								35.42353515625007,
								31.324853515625023
							],
							[
								35.400683593750045,
								31.23051757812499
							],
							[
								35.40966796875,
								31.214453125000006
							],
							[
								35.43925781249999,
								31.132421875000006
							],
							[
								35.38300781250007,
								30.982275390625063
							],
							[
								35.320117187500045,
								30.860205078125063
							],
							[
								35.29785156250006,
								30.80224609374997
							],
							[
								35.23662109374999,
								30.673486328125023
							],
							[
								35.17402343750001,
								30.52392578125003
							],
							[
								35.14062500000006,
								30.4208984375
							],
							[
								35.14814453125001,
								30.384326171875017
							],
							[
								35.132617187500045,
								30.195312500000057
							],
							[
								35.1416015625,
								30.141699218750034
							],
							[
								35.068164062500045,
								29.977880859374977
							],
							[
								35.05341796875007,
								29.89692382812501
							],
							[
								35.02392578125,
								29.78706054687501
							],
							[
								34.973437500000045,
								29.555029296874977
							],
							[
								34.90429687500006,
								29.47734374999996
							],
							[
								34.86982421875007,
								29.56391601562501
							],
							[
								34.79111328125009,
								29.812109375000034
							],
							[
								34.73505859375007,
								29.982031250000034
							],
							[
								34.65859375000002,
								30.19145507812496
							],
							[
								34.52968750000002,
								30.446044921875057
							],
							[
								34.51777343750001,
								30.507373046875017
							],
							[
								34.48994140625001,
								30.596289062500034
							],
							[
								34.400976562500034,
								30.82783203125004
							],
							[
								34.32851562500008,
								30.995019531249994
							],
							[
								34.245312500000125,
								31.208300781250017
							],
							[
								34.34833984375001,
								31.29291992187501
							],
							[
								34.350195312500034,
								31.36274414062504
							],
							[
								34.52558593750007,
								31.525634765625085
							],
							[
								34.52412109375007,
								31.541650390624966
							],
							[
								34.477343750000045,
								31.58486328125008
							],
							[
								34.483984375000034,
								31.59228515624997
							],
							[
								34.67841796875007,
								31.895703124999983
							],
							[
								34.803808593750034,
								32.196337890625045
							],
							[
								34.921875,
								32.61406249999996
							],
							[
								35.00585937500006,
								32.82661132812501
							],
							[
								35.07705078125008,
								32.96718750000005
							],
							[
								35.10859375000001,
								33.08369140625007
							],
							[
								35.22333984375007,
								33.09199218749998
							],
							[
								35.30888671874999,
								33.07954101562501
							],
							[
								35.411230468750034,
								33.07568359375003
							],
							[
								35.49316406250006,
								33.11948242187498
							],
							[
								35.53251953124999,
								33.25048828125003
							],
							[
								35.57929687500001,
								33.27148437500006
							],
							[
								35.60292968750002,
								33.240624999999966
							],
							[
								35.62724609374999,
								33.275048828124966
							],
							[
								35.73447265625009,
								33.33261718749998
							],
							[
								35.78750000000002,
								33.369775390624994
							],
							[
								35.84072265625008,
								33.41567382812502
							],
							[
								35.869140625,
								33.431738281250006
							],
							[
								35.85156250000006,
								33.370458984375034
							],
							[
								35.83710937500001,
								33.33051757812498
							],
							[
								35.83701171875009,
								33.278222656249994
							],
							[
								35.85878906250002,
								33.24956054687502
							],
							[
								35.88847656249999,
								33.192480468750034
							],
							[
								35.90664062500008,
								33.13569335937501
							],
							[
								35.86806640625002,
								33.08857421874998
							],
							[
								35.87177734375007,
								33.03935546875002
							],
							[
								35.88203125000001,
								32.998095703125045
							],
							[
								35.91347656250002,
								32.94960937500002
							],
							[
								35.85683593750002,
								32.86235351562502
							],
							[
								35.80146484375007,
								32.782324218750034
							],
							[
								35.78730468750001,
								32.73491210937499
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "ISR",
					"su_a3": "ISR",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "ISR",
					"gu_a3": "ISR",
					"abbrev": "Isr.",
					"region_un": "Asia",
					"adm0_a3_us": "ISR",
					"scalerank": 1,
					"pop_est": 7233701,
					"adm0_dif": 0,
					"un_a3": "376",
					"pop_year": -99,
					"gdp_md_est": 201400,
					"name": "Israel",
					"sovereignt": "Israel",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Israel",
					"postal": "IS",
					"sov_a3": "ISR",
					"note_brk": "",
					"brk_a3": "ISR",
					"wb_a2": "IL",
					"brk_diff": 0,
					"admin": "Israel",
					"name_long": "Israel",
					"iso_a3": "ISR",
					"iso_a2": "IL",
					"adm0_a3_is": "ISR",
					"level": 2,
					"formal_en": "State of Israel",
					"name_len": 6,
					"mapcolor7": 3,
					"long_len": 6,
					"mapcolor8": 2,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "376",
					"homepart": 1,
					"subunit": "Israel",
					"name_alt": "",
					"brk_name": "Israel",
					"name_sort": "Israel",
					"continent": "Asia",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									12.051269531250028,
									36.757031249999955
								],
								[
									12.003320312500023,
									36.74599609375002
								],
								[
									11.94062500000004,
									36.780371093750006
								],
								[
									11.93642578125008,
									36.82861328124997
								],
								[
									11.948046875000045,
									36.84306640624999
								],
								[
									12.024218750000017,
									36.82094726562511
								],
								[
									12.048046874999983,
									36.776367187500085
								],
								[
									12.051269531250028,
									36.757031249999955
								]
							]
						],
						[
							[
								[
									15.576562500000051,
									38.22031250000009
								],
								[
									15.508886718750034,
									38.106640624999926
								],
								[
									15.475683593750006,
									38.0629394531251
								],
								[
									15.234472656249977,
									37.784814453124994
								],
								[
									15.206835937500045,
									37.72055664062506
								],
								[
									15.189843750000051,
									37.65073242187495
								],
								[
									15.164843750000017,
									37.58955078125001
								],
								[
									15.13105468750004,
									37.53188476562508
								],
								[
									15.099511718750023,
									37.45859374999998
								],
								[
									15.10566406250004,
									37.375488281250085
								],
								[
									15.116992187500017,
									37.33471679687506
								],
								[
									15.14599609375,
									37.30800781249994
								],
								[
									15.193652343750017,
									37.282861328124966
								],
								[
									15.230273437500017,
									37.24433593750001
								],
								[
									15.174121093750045,
									37.20917968750007
								],
								[
									15.23603515625004,
									37.1387207031251
								],
								[
									15.288671875000006,
									37.096923828125114
								],
								[
									15.295703125000017,
									37.05517578124994
								],
								[
									15.294531250000063,
									37.01328125000012
								],
								[
									15.185156250000063,
									36.93481445312503
								],
								[
									15.142382812500045,
									36.891601562500114
								],
								[
									15.115820312500063,
									36.83925781250011
								],
								[
									15.104296875000017,
									36.78525390625012
								],
								[
									15.116308593750063,
									36.73647460937494
								],
								[
									15.112597656250017,
									36.68784179687498
								],
								[
									15.002441406250057,
									36.693896484375074
								],
								[
									14.8896484375,
									36.723535156249966
								],
								[
									14.775976562500006,
									36.710400390624955
								],
								[
									14.614355468750034,
									36.76660156250003
								],
								[
									14.555468750000017,
									36.77675781250008
								],
								[
									14.501855468750023,
									36.798681640625006
								],
								[
									14.367285156250063,
									36.972851562499955
								],
								[
									14.259082031250045,
									37.04643554687502
								],
								[
									14.142968750000023,
									37.103662109374966
								],
								[
									14.024316406249994,
									37.107128906249955
								],
								[
									13.90546875000004,
									37.100634765625045
								],
								[
									13.800585937500074,
									37.13588867187505
								],
								[
									13.587109375000011,
									37.25415039062506
								],
								[
									13.360937500000034,
									37.34873046874998
								],
								[
									13.264941406250017,
									37.41035156250001
								],
								[
									13.221093750000051,
									37.45180664062511
								],
								[
									13.169921875000028,
									37.47929687499993
								],
								[
									13.040332031249989,
									37.50654296875007
								],
								[
									12.924121093750045,
									37.57050781250004
								],
								[
									12.871191406250006,
									37.575195312500114
								],
								[
									12.757324218749972,
									37.56738281250003
								],
								[
									12.699023437500017,
									37.571826171875045
								],
								[
									12.640234375000034,
									37.594335937500006
								],
								[
									12.52675781250008,
									37.66953125000006
								],
								[
									12.454394531249989,
									37.77377929687506
								],
								[
									12.435546874999972,
									37.819775390624926
								],
								[
									12.486816406250028,
									37.938720703125
								],
								[
									12.547656250000074,
									38.0529296875001
								],
								[
									12.601660156250063,
									38.08496093750003
								],
								[
									12.664355468750045,
									38.107910156250085
								],
								[
									12.702343750000068,
									38.14169921875006
								],
								[
									12.734375000000028,
									38.183056640624955
								],
								[
									12.850683593750006,
									38.06372070312497
								],
								[
									12.902734375000023,
									38.034863281249955
								],
								[
									12.955468750000023,
									38.04130859375002
								],
								[
									13.049023437499983,
									38.08408203124995
								],
								[
									13.056835937500068,
									38.13090820312499
								],
								[
									13.159960937500045,
									38.19033203125011
								],
								[
									13.291113281250006,
									38.191455078125074
								],
								[
									13.351660156250006,
									38.18051757812506
								],
								[
									13.383496093750011,
									38.12680664062495
								],
								[
									13.43349609375008,
									38.11025390625005
								],
								[
									13.491308593750034,
									38.103125000000006
								],
								[
									13.68154296875008,
									38.00073242187503
								],
								[
									13.73486328125,
									37.984033203124994
								],
								[
									13.788867187499989,
									37.98120117187503
								],
								[
									13.936621093749977,
									38.024169921875
								],
								[
									14.049999999999983,
									38.04052734375006
								],
								[
									14.287695312500006,
									38.016845703125114
								],
								[
									14.416210937499983,
									38.04257812500012
								],
								[
									14.505957031250063,
									38.04550781250009
								],
								[
									14.636718750000057,
									38.08505859375006
								],
								[
									14.737207031250023,
									38.15078125000005
								],
								[
									14.789648437500034,
									38.16699218750006
								],
								[
									14.84589843750004,
									38.171679687500045
								],
								[
									14.981933593750057,
									38.16757812500009
								],
								[
									15.118750000000034,
									38.152734374999994
								],
								[
									15.176074218750074,
									38.168066406250006
								],
								[
									15.22402343750008,
									38.21103515625006
								],
								[
									15.279589843750017,
									38.230371093749994
								],
								[
									15.340722656250051,
									38.2173339843751
								],
								[
									15.498730468749983,
									38.29086914062498
								],
								[
									15.568359375000057,
									38.29589843750003
								],
								[
									15.63466796875008,
									38.26757812499994
								],
								[
									15.576562500000051,
									38.22031250000009
								]
							]
						],
						[
							[
								[
									8.478906250000023,
									39.06752929687502
								],
								[
									8.421484375000034,
									38.96865234375005
								],
								[
									8.360937500000063,
									39.038671875000006
								],
								[
									8.358593750000011,
									39.098779296874994
								],
								[
									8.366796875000006,
									39.115917968749926
								],
								[
									8.44062500000004,
									39.09062499999993
								],
								[
									8.478906250000023,
									39.06752929687502
								]
							]
						],
						[
							[
								[
									13.938281250000045,
									40.70561523437496
								],
								[
									13.893652343750034,
									40.69697265624998
								],
								[
									13.867675781250057,
									40.70874023437506
								],
								[
									13.853515625000028,
									40.7240722656251
								],
								[
									13.871191406250063,
									40.761816406250034
								],
								[
									13.96210937500004,
									40.73940429687511
								],
								[
									13.960839843750023,
									40.71816406250002
								],
								[
									13.938281250000045,
									40.70561523437496
								]
							]
						],
						[
							[
								[
									8.28603515625008,
									41.03984374999993
								],
								[
									8.252734375000045,
									40.99414062499994
								],
								[
									8.205664062500034,
									40.99746093750008
								],
								[
									8.224023437500051,
									41.031298828125045
								],
								[
									8.267382812499989,
									41.099121093750114
								],
								[
									8.320214843750023,
									41.121875000000045
								],
								[
									8.34375,
									41.10161132812499
								],
								[
									8.318945312500034,
									41.06274414062506
								],
								[
									8.28603515625008,
									41.03984374999993
								]
							]
						],
						[
							[
								[
									9.632031250000011,
									40.88203125000001
								],
								[
									9.68203125000008,
									40.81811523437497
								],
								[
									9.794335937500051,
									40.55620117187499
								],
								[
									9.805273437500034,
									40.499560546875074
								],
								[
									9.782812500000006,
									40.44150390624998
								],
								[
									9.754199218750045,
									40.40029296874994
								],
								[
									9.642968750000023,
									40.26840820312498
								],
								[
									9.659472656250017,
									40.15922851562502
								],
								[
									9.700781249999977,
									40.09179687499997
								],
								[
									9.70673828125004,
									40.017041015624926
								],
								[
									9.68603515625,
									39.92436523437496
								],
								[
									9.616992187500045,
									39.35439453125002
								],
								[
									9.583593750000006,
									39.253564453124994
								],
								[
									9.562500000000057,
									39.166015625000114
								],
								[
									9.486328125,
									39.13955078125005
								],
								[
									9.388085937500051,
									39.16752929687496
								],
								[
									9.264160156250028,
									39.21679687500006
								],
								[
									9.206933593749994,
									39.21381835937498
								],
								[
									9.14931640625008,
									39.196972656249926
								],
								[
									9.101757812500068,
									39.21127929687509
								],
								[
									9.056347656250068,
									39.239160156249994
								],
								[
									9.02265625000004,
									39.04326171874996
								],
								[
									8.966601562500074,
									38.963720703125006
								],
								[
									8.881347656250028,
									38.91289062499996
								],
								[
									8.801171875000023,
									38.909667968750114
								],
								[
									8.718554687500074,
									38.926708984374926
								],
								[
									8.648535156250034,
									38.92656249999999
								],
								[
									8.59541015625004,
									38.964306640624955
								],
								[
									8.553320312499977,
									39.03032226562499
								],
								[
									8.48623046875008,
									39.11049804687508
								],
								[
									8.418164062500068,
									39.20571289062502
								],
								[
									8.410742187499977,
									39.291796875000045
								],
								[
									8.399121093750011,
									39.481591796874994
								],
								[
									8.418652343749983,
									39.523046875000006
								],
								[
									8.447070312500017,
									39.56279296874993
								],
								[
									8.461035156250006,
									39.647705078125
								],
								[
									8.451171875000057,
									39.72167968749997
								],
								[
									8.471093750000023,
									39.74809570312493
								],
								[
									8.510742187500028,
									39.72167968749997
								],
								[
									8.540527343750057,
									39.73159179687505
								],
								[
									8.538671875000034,
									39.76967773437508
								],
								[
									8.547753906249994,
									39.83920898437512
								],
								[
									8.495898437500017,
									39.897460937500085
								],
								[
									8.407812500000006,
									39.91723632812503
								],
								[
									8.399316406250051,
									39.97817382812508
								],
								[
									8.40859375000008,
									40.037646484375045
								],
								[
									8.455078125000057,
									40.07758789062501
								],
								[
									8.470800781250063,
									40.13071289062509
								],
								[
									8.471289062500063,
									40.29267578125004
								],
								[
									8.409179687500028,
									40.35234374999993
								],
								[
									8.385351562500063,
									40.442675781250045
								],
								[
									8.353222656249983,
									40.50053710937493
								],
								[
									8.295507812500034,
									40.558642578125045
								],
								[
									8.230273437500074,
									40.60595703125
								],
								[
									8.189941406250028,
									40.65161132812497
								],
								[
									8.18085937500004,
									40.771044921875074
								],
								[
									8.203808593750011,
									40.87070312500012
								],
								[
									8.224218750000006,
									40.913330078125
								],
								[
									8.245214843750006,
									40.90703124999996
								],
								[
									8.310156250000006,
									40.857519531250006
								],
								[
									8.36328125,
									40.84633789062502
								],
								[
									8.468457031250011,
									40.83432617187506
								],
								[
									8.571875000000034,
									40.85019531250012
								],
								[
									8.698925781250068,
									40.89526367187506
								],
								[
									8.821191406250023,
									40.9499023437501
								],
								[
									8.998144531250006,
									41.1103515625
								],
								[
									9.107226562500045,
									41.14291992187506
								],
								[
									9.163085937500057,
									41.18515625000006
								],
								[
									9.182128906250028,
									41.24218749999994
								],
								[
									9.228417968750023,
									41.25708007812506
								],
								[
									9.283007812500045,
									41.20166015624994
								],
								[
									9.350781250000011,
									41.19589843750012
								],
								[
									9.455175781250034,
									41.15014648437503
								],
								[
									9.500195312500068,
									41.10634765625008
								],
								[
									9.538769531250011,
									41.0536621093751
								],
								[
									9.57568359375,
									41.030517578125085
								],
								[
									9.615332031249977,
									41.017285156249955
								],
								[
									9.621191406250034,
									41.0048828125
								],
								[
									9.589746093750023,
									40.99248046874996
								],
								[
									9.553710937500057,
									40.932128906250114
								],
								[
									9.574023437500017,
									40.91474609375004
								],
								[
									9.632031250000011,
									40.88203125000001
								]
							]
						],
						[
							[
								[
									10.395117187500034,
									42.858154296875
								],
								[
									10.428320312500063,
									42.81918945312506
								],
								[
									10.432226562500063,
									42.79658203124998
								],
								[
									10.409960937500045,
									42.770996093750085
								],
								[
									10.419335937499994,
									42.713183593750045
								],
								[
									10.335644531250011,
									42.76113281250005
								],
								[
									10.208984375000057,
									42.73691406250009
								],
								[
									10.131250000000023,
									42.74204101562506
								],
								[
									10.10976562500008,
									42.78505859374994
								],
								[
									10.127539062500063,
									42.81030273437503
								],
								[
									10.24824218750004,
									42.81577148437498
								],
								[
									10.285742187500063,
									42.8280761718751
								],
								[
									10.358984375000063,
									42.822314453125074
								],
								[
									10.395117187500034,
									42.858154296875
								]
							]
						],
						[
							[
								[
									13.700000000000017,
									46.520263671875
								],
								[
									13.679687500000057,
									46.46289062500003
								],
								[
									13.63710937500008,
									46.448535156250045
								],
								[
									13.563281250000045,
									46.415087890625074
								],
								[
									13.478515625,
									46.369189453125045
								],
								[
									13.399511718749977,
									46.317529296874994
								],
								[
									13.378222656249989,
									46.26162109375008
								],
								[
									13.399609375000011,
									46.22495117187506
								],
								[
									13.420996093750006,
									46.212304687499966
								],
								[
									13.449804687500006,
									46.22353515625002
								],
								[
									13.491796875000034,
									46.216601562500045
								],
								[
									13.544726562500074,
									46.19658203124996
								],
								[
									13.63251953125004,
									46.177050781250074
								],
								[
									13.634960937499983,
									46.15776367187496
								],
								[
									13.61660156250008,
									46.133105468750074
								],
								[
									13.54804687500004,
									46.089111328125
								],
								[
									13.486425781250006,
									46.03955078125003
								],
								[
									13.480273437500017,
									46.00922851562498
								],
								[
									13.487695312500023,
									45.9871093750001
								],
								[
									13.509179687500023,
									45.97377929687505
								],
								[
									13.6005859375,
									45.97978515625002
								],
								[
									13.613964843750068,
									45.96166992187497
								],
								[
									13.569628906250017,
									45.83413085937502
								],
								[
									13.583398437500051,
									45.81235351562512
								],
								[
									13.663476562500023,
									45.79199218750006
								],
								[
									13.721679687499972,
									45.7612792968751
								],
								[
									13.831152343750006,
									45.68041992187506
								],
								[
									13.874707031250068,
									45.61484375000012
								],
								[
									13.8447265625,
									45.59287109374998
								],
								[
									13.775976562500034,
									45.58198242187498
								],
								[
									13.719824218750063,
									45.58759765625007
								],
								[
									13.783300781250006,
									45.627246093750045
								],
								[
									13.628320312500051,
									45.77094726562501
								],
								[
									13.558203124999977,
									45.77070312500007
								],
								[
									13.465136718750045,
									45.70996093749994
								],
								[
									13.206347656250074,
									45.77138671874994
								],
								[
									13.15673828125,
									45.74658203124994
								],
								[
									13.1201171875,
									45.69790039062505
								],
								[
									13.0302734375,
									45.63750000000002
								],
								[
									12.903027343750011,
									45.61079101562507
								],
								[
									12.761230468749972,
									45.544287109375034
								],
								[
									12.61171875000008,
									45.49721679687502
								],
								[
									12.49755859375,
									45.461669921875085
								],
								[
									12.43212890625,
									45.46791992187502
								],
								[
									12.536132812500028,
									45.544921875000085
								],
								[
									12.491796875000063,
									45.546289062499994
								],
								[
									12.353808593750017,
									45.491992187500045
								],
								[
									12.27431640625008,
									45.446044921875
								],
								[
									12.248828125000045,
									45.3688476562501
								],
								[
									12.225683593750034,
									45.24150390624999
								],
								[
									12.28632812500004,
									45.20771484375004
								],
								[
									12.39248046875008,
									45.039794921875114
								],
								[
									12.523437500000028,
									44.96796875000004
								],
								[
									12.49794921875008,
									44.899414062500114
								],
								[
									12.463574218750011,
									44.845214843750085
								],
								[
									12.38447265625004,
									44.79833984374994
								],
								[
									12.31904296875004,
									44.833105468750006
								],
								[
									12.278906250000034,
									44.83222656250001
								],
								[
									12.248339843750017,
									44.72250976562495
								],
								[
									12.304980468750017,
									44.429443359375114
								],
								[
									12.396289062500074,
									44.22387695312497
								],
								[
									12.486816406250028,
									44.1342285156251
								],
								[
									12.691113281249983,
									43.994726562500006
								],
								[
									12.907031250000017,
									43.921191406250045
								],
								[
									13.29531250000008,
									43.6860839843751
								],
								[
									13.508203125000023,
									43.61166992187495
								],
								[
									13.56416015625004,
									43.57128906250006
								],
								[
									13.693261718750051,
									43.38989257812497
								],
								[
									13.804687500000028,
									43.18037109375001
								],
								[
									13.924902343750006,
									42.851562500000085
								],
								[
									14.010449218750011,
									42.68955078125012
								],
								[
									14.182714843750034,
									42.50644531250012
								],
								[
									14.54072265625004,
									42.244287109374994
								],
								[
									14.86611328125008,
									42.05253906250002
								],
								[
									15.168750000000017,
									41.93403320312504
								],
								[
									15.404980468749983,
									41.913232421874966
								],
								[
									15.96406250000004,
									41.93945312499997
								],
								[
									16.0615234375,
									41.92812500000008
								],
								[
									16.164648437500034,
									41.896191406249955
								],
								[
									16.189160156250068,
									41.8140136718751
								],
								[
									16.15126953125005,
									41.75849609375007
								],
								[
									16.03369140625,
									41.70078125000012
								],
								[
									15.913769531249983,
									41.620849609375085
								],
								[
									15.900488281250034,
									41.51206054687495
								],
								[
									16.01259765625005,
									41.43540039062506
								],
								[
									16.551855468750063,
									41.232031250000006
								],
								[
									17.10341796875005,
									41.06215820312505
								],
								[
									17.275195312500074,
									40.975439453125034
								],
								[
									17.474218750000034,
									40.840576171875114
								],
								[
									17.954980468749994,
									40.655175781249994
								],
								[
									18.0361328125,
									40.564941406250085
								],
								[
									18.328222656250006,
									40.37084960937497
								],
								[
									18.460644531249983,
									40.221044921875006
								],
								[
									18.485839843750057,
									40.10483398437506
								],
								[
									18.42255859375004,
									39.986865234375074
								],
								[
									18.39345703125008,
									39.9036132812501
								],
								[
									18.34374999999997,
									39.82138671874995
								],
								[
									18.219335937500034,
									39.852539062500085
								],
								[
									18.07792968749999,
									39.936962890624955
								],
								[
									17.865039062500074,
									40.28017578125008
								],
								[
									17.476171875000063,
									40.31494140625006
								],
								[
									17.395800781250045,
									40.34023437500005
								],
								[
									17.25771484375005,
									40.39907226562505
								],
								[
									17.24941406250005,
									40.43789062500005
								],
								[
									17.21533203125003,
									40.48642578125006
								],
								[
									17.179980468750017,
									40.502783203125034
								],
								[
									17.03125000000003,
									40.51347656249999
								],
								[
									16.92822265625,
									40.458056640625074
								],
								[
									16.80703125000008,
									40.32646484374999
								],
								[
									16.669628906250068,
									40.137207031250085
								],
								[
									16.52998046875004,
									39.85966796874993
								],
								[
									16.52187500000008,
									39.74755859375
								],
								[
									16.597753906249977,
									39.638916015625085
								],
								[
									16.824316406250034,
									39.57832031249998
								],
								[
									16.999218750000068,
									39.481591796874994
								],
								[
									17.114550781250017,
									39.38061523437494
								],
								[
									17.12294921875005,
									39.13657226562506
								],
								[
									17.17460937499999,
									38.998095703125074
								],
								[
									17.09853515625005,
									38.91933593749994
								],
								[
									16.951464843750017,
									38.93979492187512
								],
								[
									16.755468750000063,
									38.88969726562502
								],
								[
									16.61669921875003,
									38.80014648437509
								],
								[
									16.55898437500008,
									38.714794921874926
								],
								[
									16.57421875,
									38.493554687499966
								],
								[
									16.54560546875001,
									38.409082031249994
								],
								[
									16.28242187500004,
									38.2495605468751
								],
								[
									16.144140625000034,
									38.08637695312507
								],
								[
									16.10976562500005,
									38.018652343750034
								],
								[
									16.05683593750001,
									37.941845703124926
								],
								[
									15.72451171875008,
									37.939111328124994
								],
								[
									15.645800781250017,
									38.0342285156251
								],
								[
									15.64306640625,
									38.17539062500009
								],
								[
									15.7001953125,
									38.26230468750012
								],
								[
									15.822363281250034,
									38.30297851562506
								],
								[
									15.904785156250028,
									38.48349609375006
								],
								[
									15.87890625,
									38.61391601562508
								],
								[
									15.926953125000011,
									38.671728515625034
								],
								[
									15.97236328125004,
									38.71259765625001
								],
								[
									16.065527343750006,
									38.73642578124998
								],
								[
									16.19677734375,
									38.75922851562501
								],
								[
									16.20996093750003,
									38.94111328125001
								],
								[
									16.107421875,
									39.023828124999994
								],
								[
									16.071484375000068,
									39.13945312499993
								],
								[
									16.023632812499983,
									39.35361328124995
								],
								[
									15.85439453125008,
									39.626513671875045
								],
								[
									15.763671875000057,
									39.87006835937501
								],
								[
									15.692773437499994,
									39.99018554687504
								],
								[
									15.585156250000011,
									40.05283203125012
								],
								[
									15.390917968750045,
									40.05214843750005
								],
								[
									15.294531250000063,
									40.07001953125007
								],
								[
									14.95087890625004,
									40.23901367187494
								],
								[
									14.92695312500004,
									40.264746093750034
								],
								[
									14.929101562500023,
									40.309570312500114
								],
								[
									14.986132812500017,
									40.377490234375074
								],
								[
									14.94765625000008,
									40.46933593750006
								],
								[
									14.90693359375004,
									40.55605468750005
								],
								[
									14.839550781249983,
									40.629980468750006
								],
								[
									14.765722656250063,
									40.66840820312501
								],
								[
									14.611230468750023,
									40.644775390625
								],
								[
									14.556933593750074,
									40.6264160156251
								],
								[
									14.45937500000008,
									40.63271484375002
								],
								[
									14.382714843749994,
									40.599853515625
								],
								[
									14.339941406250006,
									40.59882812500007
								],
								[
									14.460546875000063,
									40.72871093750004
								],
								[
									14.428125000000023,
									40.759326171875074
								],
								[
									14.308886718750074,
									40.81264648437511
								],
								[
									14.147167968750068,
									40.820703124999966
								],
								[
									14.102343749999989,
									40.82714843749994
								],
								[
									14.075878906250011,
									40.793945312500114
								],
								[
									14.04433593750008,
									40.812255859375114
								],
								[
									14.047656250000045,
									40.87031250000004
								],
								[
									13.859765625000051,
									41.12998046875009
								],
								[
									13.733398437500057,
									41.235644531250045
								],
								[
									13.669726562500045,
									41.25449218750006
								],
								[
									13.554785156250006,
									41.23217773437494
								],
								[
									13.361914062500063,
									41.27851562500007
								],
								[
									13.246875000000074,
									41.288867187500045
								],
								[
									13.183398437500017,
									41.27768554687498
								],
								[
									13.088671875000074,
									41.243847656249926
								],
								[
									13.041015625000057,
									41.26621093749995
								],
								[
									13.024218749999989,
									41.30092773437511
								],
								[
									12.849218750000063,
									41.408740234375045
								],
								[
									12.630859374999972,
									41.469677734374926
								],
								[
									12.205664062500034,
									41.81264648437508
								],
								[
									12.075292968750034,
									41.9408691406251
								],
								[
									11.807031249999994,
									42.08203125000006
								],
								[
									11.637304687500063,
									42.287548828124926
								],
								[
									11.498437500000023,
									42.36293945312511
								],
								[
									11.296289062500051,
									42.423291015624955
								],
								[
									11.249707031250068,
									42.415722656249926
								],
								[
									11.188867187500023,
									42.39311523437502
								],
								[
									11.141210937499977,
									42.389892578125085
								],
								[
									11.103222656250068,
									42.41660156250012
								],
								[
									11.141796875000011,
									42.44409179687503
								],
								[
									11.184765625000068,
									42.45659179687499
								],
								[
									11.167773437500074,
									42.535156250000114
								],
								[
									10.937792968750017,
									42.73872070312501
								],
								[
									10.803125000000023,
									42.80429687499995
								],
								[
									10.765136718750028,
									42.84467773437501
								],
								[
									10.737109374999989,
									42.89995117187499
								],
								[
									10.708398437499994,
									42.93632812500002
								],
								[
									10.644628906249977,
									42.95717773437511
								],
								[
									10.590234374999994,
									42.95361328125
								],
								[
									10.514843750000011,
									42.967529296875085
								],
								[
									10.517285156250068,
									43.06513671874998
								],
								[
									10.532324218750006,
									43.140136718750085
								],
								[
									10.520800781250074,
									43.20380859374998
								],
								[
									10.447558593750074,
									43.37119140624998
								],
								[
									10.32050781250004,
									43.51308593749994
								],
								[
									10.245800781250011,
									43.85209960937499
								],
								[
									10.188085937500063,
									43.94750976562497
								],
								[
									10.047656250000045,
									44.0199707031251
								],
								[
									9.73085937500008,
									44.10117187500012
								],
								[
									9.289355468750017,
									44.31923828125002
								],
								[
									9.195996093750011,
									44.322998046875
								],
								[
									8.930371093750068,
									44.407763671875045
								],
								[
									8.765820312500011,
									44.42231445312498
								],
								[
									8.551953125000068,
									44.34614257812501
								],
								[
									8.292382812500023,
									44.13652343749993
								],
								[
									8.081640625000006,
									43.918945312500114
								],
								[
									8.004980468750006,
									43.876757812500045
								],
								[
									7.73330078125008,
									43.802587890625034
								],
								[
									7.4931640625,
									43.7671386718751
								],
								[
									7.490527343750017,
									43.8229492187501
								],
								[
									7.4820312500000625,
									43.86489257812502
								],
								[
									7.522656250000068,
									43.911083984374926
								],
								[
									7.5896484375000455,
									43.96542968750006
								],
								[
									7.651464843750006,
									44.03364257812504
								],
								[
									7.677148437500023,
									44.08315429687508
								],
								[
									7.665039062500028,
									44.11601562499993
								],
								[
									7.637207031250057,
									44.16484374999993
								],
								[
									7.599414062500074,
									44.16835937499994
								],
								[
									7.3708984375000455,
									44.12739257812504
								],
								[
									7.31855468750004,
									44.137988281250045
								],
								[
									7.149414062500057,
									44.201708984375074
								],
								[
									6.96728515625,
									44.28002929687503
								],
								[
									6.900195312499989,
									44.33574218749993
								],
								[
									6.874804687500074,
									44.39204101562504
								],
								[
									6.8938476562500455,
									44.42817382812501
								],
								[
									6.87861328125004,
									44.46328125000008
								],
								[
									6.842968750000068,
									44.510693359374955
								],
								[
									6.875195312500068,
									44.564550781250006
								],
								[
									6.931933593750074,
									44.631640625000074
								],
								[
									6.96035156250008,
									44.67714843749994
								],
								[
									7.007910156250006,
									44.68896484375003
								],
								[
									7.030664062500023,
									44.71669921875011
								],
								[
									6.99267578125,
									44.82729492187508
								],
								[
									6.972851562500068,
									44.845019531250045
								],
								[
									6.93984375000008,
									44.85874023437509
								],
								[
									6.889355468750011,
									44.860302734374955
								],
								[
									6.8010742187500455,
									44.88315429687509
								],
								[
									6.738183593750023,
									44.92138671875006
								],
								[
									6.724707031250034,
									44.97299804687509
								],
								[
									6.69140625,
									45.02260742187508
								],
								[
									6.634765625,
									45.06816406249993
								],
								[
									6.627734374999989,
									45.117968750000045
								],
								[
									6.692285156249994,
									45.144287109375085
								],
								[
									6.780371093750006,
									45.14531249999993
								],
								[
									6.84228515625,
									45.13564453125008
								],
								[
									6.981250000000074,
									45.21557617187494
								],
								[
									7.032421875000011,
									45.222607421874955
								],
								[
									7.07832031250004,
									45.23994140625001
								],
								[
									7.116796874999977,
									45.34902343750005
								],
								[
									7.146386718750051,
									45.38173828125005
								],
								[
									7.153417968749977,
									45.40092773437496
								],
								[
									7.126074218750006,
									45.42368164062498
								],
								[
									7.013671875000028,
									45.500488281250085
								],
								[
									6.962402343750057,
									45.58056640625006
								],
								[
									6.881445312500006,
									45.670361328124955
								],
								[
									6.806250000000034,
									45.710009765625045
								],
								[
									6.790917968750023,
									45.74086914062494
								],
								[
									6.789160156250034,
									45.78007812499993
								],
								[
									6.8044921875000455,
									45.81455078125012
								],
								[
									6.940820312500023,
									45.86835937500007
								],
								[
									7.021093750000034,
									45.92578124999994
								],
								[
									7.0557617187500625,
									45.90380859375
								],
								[
									7.1290039062500625,
									45.880419921875045
								],
								[
									7.327929687500017,
									45.91235351562506
								],
								[
									7.451562500000051,
									45.94443359375012
								],
								[
									7.538574218750028,
									45.978173828124966
								],
								[
									7.592578125000017,
									45.97221679687499
								],
								[
									7.787890625000017,
									45.92182617187504
								],
								[
									7.852343749999989,
									45.94746093750001
								],
								[
									7.9931640625,
									46.01591796875002
								],
								[
									8.014257812500034,
									46.05190429687505
								],
								[
									8.125195312500068,
									46.160937500000074
								],
								[
									8.127246093750045,
									46.18759765625009
								],
								[
									8.081542968750057,
									46.25600585937508
								],
								[
									8.095703125000028,
									46.271044921875045
								],
								[
									8.231933593750057,
									46.34121093750002
								],
								[
									8.29853515625004,
									46.40341796875009
								],
								[
									8.370703125000006,
									46.445117187500045
								],
								[
									8.422558593749983,
									46.44604492187506
								],
								[
									8.436816406250045,
									46.43188476562503
								],
								[
									8.442968750000063,
									46.40278320312504
								],
								[
									8.438476562500028,
									46.28286132812505
								],
								[
									8.458398437500023,
									46.245898437500074
								],
								[
									8.565429687500057,
									46.15981445312502
								],
								[
									8.641699218750063,
									46.11079101562498
								],
								[
									8.818554687500011,
									46.07714843750006
								],
								[
									8.826757812500006,
									46.06103515624997
								],
								[
									8.778027343750011,
									45.99619140625009
								],
								[
									8.88515625000008,
									45.918701171875114
								],
								[
									8.904296875,
									45.86196289062508
								],
								[
									8.953710937500034,
									45.83002929687498
								],
								[
									9.023730468750074,
									45.84570312499997
								],
								[
									9.046679687500045,
									45.87558593750012
								],
								[
									9.019140625000034,
									45.92812500000008
								],
								[
									8.99892578125008,
									45.98310546875007
								],
								[
									9.003027343750034,
									46.014892578125085
								],
								[
									9.022363281250051,
									46.05146484375007
								],
								[
									9.070996093750011,
									46.102441406249966
								],
								[
									9.203417968749989,
									46.21923828125006
								],
								[
									9.251074218750034,
									46.28676757812505
								],
								[
									9.259765625000028,
									46.39125976562511
								],
								[
									9.260156250000023,
									46.47519531250006
								],
								[
									9.304394531250068,
									46.49555664062504
								],
								[
									9.399316406250023,
									46.48066406250001
								],
								[
									9.427636718750023,
									46.482324218749994
								],
								[
									9.440625000000011,
									46.43081054687508
								],
								[
									9.481054687499977,
									46.348779296874966
								],
								[
									9.528710937500023,
									46.3062011718751
								],
								[
									9.57958984375,
									46.29609374999998
								],
								[
									9.639453125000017,
									46.29589843750003
								],
								[
									9.78779296875004,
									46.346044921875034
								],
								[
									9.884472656250011,
									46.36777343750012
								],
								[
									9.939257812500074,
									46.36181640625006
								],
								[
									9.971679687500028,
									46.32768554687502
								],
								[
									10.041015625000028,
									46.238085937500074
								],
								[
									10.08056640625,
									46.22797851562504
								],
								[
									10.128320312500051,
									46.23823242187501
								],
								[
									10.145214843750011,
									46.25351562500009
								],
								[
									10.1298828125,
									46.28798828125002
								],
								[
									10.109667968750074,
									46.36284179687499
								],
								[
									10.081933593750023,
									46.42075195312498
								],
								[
									10.045605468750068,
									46.44790039062508
								],
								[
									10.038281250000011,
									46.4832031250001
								],
								[
									10.061230468750068,
									46.54677734375008
								],
								[
									10.087011718750063,
									46.599902343750074
								],
								[
									10.137500000000045,
									46.61435546875006
								],
								[
									10.195507812500068,
									46.62109375000003
								],
								[
									10.272265625000074,
									46.56484375000002
								],
								[
									10.363085937499989,
									46.54707031250004
								],
								[
									10.4306640625,
									46.55004882812503
								],
								[
									10.442480468750006,
									46.58286132812506
								],
								[
									10.438281250000045,
									46.61884765625001
								],
								[
									10.39794921875,
									46.665039062500085
								],
								[
									10.406054687500045,
									46.73486328125003
								],
								[
									10.452832031250068,
									46.86494140625007
								],
								[
									10.47939453125008,
									46.85512695312511
								],
								[
									10.579785156250011,
									46.85371093749998
								],
								[
									10.689257812500017,
									46.84638671875001
								],
								[
									10.759765625,
									46.793310546875034
								],
								[
									10.828906250000045,
									46.77524414062509
								],
								[
									10.927343750000034,
									46.76948242187507
								],
								[
									10.993261718750034,
									46.777001953124994
								],
								[
									11.02509765625004,
									46.79697265624998
								],
								[
									11.063476562500057,
									46.85913085937503
								],
								[
									11.133886718750006,
									46.93618164062508
								],
								[
									11.244433593750045,
									46.97568359375006
								],
								[
									11.433203125000063,
									46.98305664062505
								],
								[
									11.527539062500011,
									46.997412109375034
								],
								[
									11.625488281250057,
									46.99658203125006
								],
								[
									11.699414062500011,
									46.98466796875002
								],
								[
									11.775683593750017,
									46.98608398437506
								],
								[
									11.969531250000074,
									47.03969726562505
								],
								[
									12.169433593750028,
									47.08212890624998
								],
								[
									12.19716796875008,
									47.075000000000045
								],
								[
									12.201269531250034,
									47.060888671875006
								],
								[
									12.165527343750028,
									47.028173828125006
								],
								[
									12.130761718750051,
									46.98476562500005
								],
								[
									12.154101562500017,
									46.93525390625007
								],
								[
									12.267968750000023,
									46.8358886718751
								],
								[
									12.330078124999972,
									46.759814453125045
								],
								[
									12.388281250000034,
									46.70263671875003
								],
								[
									12.479199218750068,
									46.67250976562502
								],
								[
									12.598632812499972,
									46.6541015625001
								],
								[
									12.699804687499977,
									46.64746093750006
								],
								[
									12.805566406250051,
									46.62587890625002
								],
								[
									13.168750000000045,
									46.57265625000002
								],
								[
									13.3515625,
									46.557910156250045
								],
								[
									13.490039062500045,
									46.555566406249994
								],
								[
									13.700000000000017,
									46.520263671875
								]
							],
							[
								[
									12.396874999999994,
									43.9345703125
								],
								[
									12.426367187500063,
									43.89409179687502
								],
								[
									12.48525390625008,
									43.9014160156251
								],
								[
									12.514648437500028,
									43.95297851562512
								],
								[
									12.503710937500017,
									43.98974609375006
								],
								[
									12.44111328125004,
									43.982421875000085
								],
								[
									12.396874999999994,
									43.9345703125
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "ITA",
					"su_a3": "ITA",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "ITA",
					"gu_a3": "ITA",
					"abbrev": "Italy",
					"region_un": "Europe",
					"adm0_a3_us": "ITA",
					"scalerank": 1,
					"pop_est": 58126212,
					"adm0_dif": 0,
					"un_a3": "380",
					"pop_year": -99,
					"gdp_md_est": 1823000,
					"name": "Italy",
					"sovereignt": "Italy",
					"economy": "1. Developed region: G7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Italy",
					"postal": "I",
					"sov_a3": "ITA",
					"note_brk": "",
					"brk_a3": "ITA",
					"wb_a2": "IT",
					"brk_diff": 0,
					"admin": "Italy",
					"name_long": "Italy",
					"iso_a3": "ITA",
					"iso_a2": "IT",
					"adm0_a3_is": "ITA",
					"level": 2,
					"formal_en": "Italian Republic",
					"name_len": 5,
					"mapcolor7": 6,
					"long_len": 5,
					"mapcolor8": 7,
					"mapcolor9": 8,
					"note_adm0": "",
					"iso_n3": "380",
					"homepart": 1,
					"subunit": "Italy",
					"name_alt": "",
					"brk_name": "Italy",
					"name_sort": "Italy",
					"continent": "Europe",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2012
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								39.14541015625008,
								32.12451171875006
							],
							[
								38.99707031250006,
								32.00747070312511
							],
							[
								38.96230468750008,
								31.994921875000045
							],
							[
								38.76962890625009,
								31.94648437500001
							],
							[
								38.37548828125006,
								31.847460937500017
							],
							[
								38.11142578125009,
								31.78115234375008
							],
							[
								37.77382812500008,
								31.696337890625045
							],
							[
								37.49335937500001,
								31.62587890625008
							],
							[
								37.215625000000045,
								31.556103515624983
							],
							[
								36.95859375000009,
								31.491503906250045
							],
							[
								37.10527343749999,
								31.355175781250097
							],
							[
								37.329492187500136,
								31.146826171875006
							],
							[
								37.47900390625006,
								31.00776367187501
							],
							[
								37.65546875000001,
								30.82895507812509
							],
							[
								37.81298828125006,
								30.669287109375063
							],
							[
								37.98007812500009,
								30.50000000000003
							],
							[
								37.86289062500009,
								30.442626953125057
							],
							[
								37.6697265625001,
								30.34814453125
							],
							[
								37.64990234375006,
								30.330957031249966
							],
							[
								37.63359374999999,
								30.313281250000102
							],
							[
								37.553613281250136,
								30.144580078125017
							],
							[
								37.490722656250114,
								30.01171875000003
							],
							[
								37.469238281250114,
								29.99506835937501
							],
							[
								37.199414062500125,
								29.94628906250003
							],
							[
								36.927050781250045,
								29.897070312500034
							],
							[
								36.755273437500136,
								29.866015625000017
							],
							[
								36.70390625000016,
								29.831640625000034
							],
							[
								36.591796875000114,
								29.666113281250063
							],
							[
								36.47607421875,
								29.49511718750003
							],
							[
								36.282812500000034,
								29.35537109375008
							],
							[
								36.06845703125009,
								29.200537109374977
							],
							[
								36.015429687500045,
								29.190478515625045
							],
							[
								35.86035156250006,
								29.214257812500023
							],
							[
								35.595312500000034,
								29.25488281250003
							],
							[
								35.33916015624999,
								29.294091796875023
							],
							[
								35.16376953125018,
								29.320947265624994
							],
							[
								34.950781250000034,
								29.353515625000057
							],
							[
								34.982226562500045,
								29.484472656250006
							],
							[
								34.973437500000045,
								29.555029296874977
							],
							[
								35.02392578125,
								29.78706054687501
							],
							[
								35.05341796875007,
								29.89692382812501
							],
							[
								35.068164062500045,
								29.977880859374977
							],
							[
								35.1416015625,
								30.141699218750034
							],
							[
								35.132617187500045,
								30.195312500000057
							],
							[
								35.14814453125001,
								30.384326171875017
							],
							[
								35.14062500000006,
								30.4208984375
							],
							[
								35.17402343750001,
								30.52392578125003
							],
							[
								35.23662109374999,
								30.673486328125023
							],
							[
								35.29785156250006,
								30.80224609374997
							],
							[
								35.320117187500045,
								30.860205078125063
							],
							[
								35.38300781250007,
								30.982275390625063
							],
							[
								35.43925781249999,
								31.132421875000006
							],
							[
								35.40966796875,
								31.214453125000006
							],
							[
								35.400683593750045,
								31.23051757812499
							],
							[
								35.42353515625007,
								31.324853515625023
							],
							[
								35.4228515625,
								31.325390625000068
							],
							[
								35.45058593750008,
								31.47929687499996
							],
							[
								35.46542968750009,
								31.56235351562509
							],
							[
								35.49941406250008,
								31.672363281250057
							],
							[
								35.558984375000136,
								31.765527343750023
							],
							[
								35.53144531250001,
								31.984912109375045
							],
							[
								35.53476562500009,
								32.10302734375003
							],
							[
								35.572070312500045,
								32.23789062500006
							],
							[
								35.551464843750125,
								32.39550781250003
							],
							[
								35.56904296875001,
								32.619873046875
							],
							[
								35.572851562500034,
								32.640869140625
							],
							[
								35.59453124999999,
								32.66801757812502
							],
							[
								35.61123046875002,
								32.68208007812504
							],
							[
								35.73447265625009,
								32.728906249999994
							],
							[
								35.78730468750001,
								32.73491210937499
							],
							[
								35.89472656250007,
								32.71376953125002
							],
							[
								35.95644531250002,
								32.66669921875001
							],
							[
								36.05947265625002,
								32.533789062500034
							],
							[
								36.2197265625,
								32.49511718749997
							],
							[
								36.28427734375009,
								32.45747070312504
							],
							[
								36.37207031250006,
								32.38691406250004
							],
							[
								36.47919921875001,
								32.36132812499997
							],
							[
								36.818359375,
								32.317285156249994
							],
							[
								37.08896484375009,
								32.46552734374998
							],
							[
								37.31757812500001,
								32.59077148437501
							],
							[
								37.577441406250045,
								32.73305664062505
							],
							[
								37.75410156250001,
								32.82983398437503
							],
							[
								38.055761718750034,
								32.994873046875
							],
							[
								38.25429687500008,
								33.099218750000034
							],
							[
								38.515625,
								33.23662109374996
							],
							[
								38.77353515625009,
								33.37221679687505
							],
							[
								38.84501953124999,
								33.15087890625
							],
							[
								38.91484374999999,
								32.934667968750006
							],
							[
								38.987402343750034,
								32.71069335937503
							],
							[
								39.05781250000007,
								32.49316406250003
							],
							[
								38.98164062500001,
								32.472558593749994
							],
							[
								39.04140625000002,
								32.3056640625
							],
							[
								39.14003906250002,
								32.331201171874966
							],
							[
								39.24746093750008,
								32.350976562499994
							],
							[
								39.29277343749999,
								32.24384765625004
							],
							[
								39.14541015625008,
								32.12451171875006
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "JOR",
					"su_a3": "JOR",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "JOR",
					"gu_a3": "JOR",
					"abbrev": "Jord.",
					"region_un": "Asia",
					"adm0_a3_us": "JOR",
					"scalerank": 1,
					"pop_est": 6342948,
					"adm0_dif": 0,
					"un_a3": "400",
					"pop_year": -99,
					"gdp_md_est": 31610,
					"name": "Jordan",
					"sovereignt": "Jordan",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Jordan",
					"postal": "J",
					"sov_a3": "JOR",
					"note_brk": "",
					"brk_a3": "JOR",
					"wb_a2": "JO",
					"brk_diff": 0,
					"admin": "Jordan",
					"name_long": "Jordan",
					"iso_a3": "JOR",
					"iso_a2": "JO",
					"adm0_a3_is": "JOR",
					"level": 2,
					"formal_en": "Hashemite Kingdom of Jordan",
					"name_len": 6,
					"mapcolor7": 5,
					"long_len": 6,
					"mapcolor8": 3,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "400",
					"homepart": 1,
					"subunit": "Jordan",
					"name_alt": "",
					"brk_name": "Jordan",
					"name_sort": "Jordan",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2004
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									123.88867187499994,
									24.28012695312495
								],
								[
									123.82558593749997,
									24.266064453124926
								],
								[
									123.74980468749999,
									24.283300781249977
								],
								[
									123.68066406250011,
									24.288037109375068
								],
								[
									123.6797851562502,
									24.31777343750008
								],
								[
									123.75234374999997,
									24.34848632812512
								],
								[
									123.75371093750016,
									24.391308593749955
								],
								[
									123.77148437499994,
									24.414453124999966
								],
								[
									123.93486328125005,
									24.36201171875004
								],
								[
									123.92812499999997,
									24.323632812499937
								],
								[
									123.88867187499994,
									24.28012695312495
								]
							]
						],
						[
							[
								[
									124.29316406250001,
									24.51591796875013
								],
								[
									124.23427734375002,
									24.358056640625023
								],
								[
									124.18564453125003,
									24.33505859374995
								],
								[
									124.13574218750011,
									24.34760742187501
								],
								[
									124.08476562500005,
									24.435839843750045
								],
								[
									124.12041015624999,
									24.469628906250108
								],
								[
									124.17021484375005,
									24.45185546875004
								],
								[
									124.21054687500009,
									24.458642578124994
								],
								[
									124.30195312500001,
									24.587109375000068
								],
								[
									124.32402343749999,
									24.566357421875097
								],
								[
									124.29316406250001,
									24.51591796875013
								]
							]
						],
						[
							[
								[
									125.44414062500005,
									24.743164062500057
								],
								[
									125.359375,
									24.717089843750074
								],
								[
									125.26894531250014,
									24.73251953125009
								],
								[
									125.28359375000002,
									24.87192382812509
								],
								[
									125.31494140625,
									24.852392578125006
								],
								[
									125.33457031250009,
									24.80468749999997
								],
								[
									125.40185546875011,
									24.776855468750085
								],
								[
									125.44414062500005,
									24.743164062500057
								]
							]
						],
						[
							[
								[
									142.18818359375018,
									26.61650390624996
								],
								[
									142.1699218750001,
									26.615673828125068
								],
								[
									142.10712890625,
									26.72153320312495
								],
								[
									142.12529296875016,
									26.72646484375008
								],
								[
									142.16171875000003,
									26.709960937500085
								],
								[
									142.2021484375001,
									26.648779296875063
								],
								[
									142.18818359375018,
									26.61650390624996
								]
							]
						],
						[
							[
								[
									128.25878906249994,
									26.652783203124983
								],
								[
									128.16250000000014,
									26.606933593750057
								],
								[
									128.1269531250001,
									26.552246093750114
								],
								[
									128.03789062500016,
									26.533593750000023
								],
								[
									127.9512695312502,
									26.456494140624955
								],
								[
									127.86708984375002,
									26.44248046874995
								],
								[
									127.86923828125009,
									26.38056640625004
								],
								[
									127.90478515624994,
									26.328125000000085
								],
								[
									127.84873046875009,
									26.318945312500006
								],
								[
									127.79013671875003,
									26.255078124999955
								],
								[
									127.78554687499997,
									26.208691406249926
								],
								[
									127.80644531250016,
									26.17124023437512
								],
								[
									127.80361328125014,
									26.15253906250004
								],
								[
									127.72939453125002,
									26.097167968749943
								],
								[
									127.65312499999999,
									26.09472656249997
								],
								[
									127.64970703125005,
									26.154492187499983
								],
								[
									127.6548828125002,
									26.19916992187504
								],
								[
									127.72705078125,
									26.307910156250074
								],
								[
									127.72890625000002,
									26.433935546874977
								],
								[
									127.79589843749994,
									26.448535156249932
								],
								[
									127.82041015625009,
									26.466064453125057
								],
								[
									127.92597656250018,
									26.555712890625017
								],
								[
									127.94550781250018,
									26.593945312499983
								],
								[
									127.89082031250001,
									26.631054687500097
								],
								[
									127.89482421875016,
									26.674951171874966
								],
								[
									127.90722656250011,
									26.693603515624943
								],
								[
									127.99433593750018,
									26.679443359375085
								],
								[
									128.02968749999997,
									26.646875000000023
								],
								[
									128.04677734375002,
									26.643310546875
								],
								[
									128.09765625,
									26.667773437500017
								],
								[
									128.12158203125,
									26.71142578125003
								],
								[
									128.21650390625,
									26.79687500000003
								],
								[
									128.25488281249994,
									26.881884765624932
								],
								[
									128.33164062500003,
									26.81210937500012
								],
								[
									128.31093750000002,
									26.720703125000057
								],
								[
									128.25878906249994,
									26.652783203124983
								]
							]
						],
						[
							[
								[
									128.9981445312502,
									27.720800781250063
								],
								[
									128.95625,
									27.702490234375063
								],
								[
									128.9000000000002,
									27.727783203125057
								],
								[
									128.8828125,
									27.84243164062505
								],
								[
									128.90761718749997,
									27.897998046875102
								],
								[
									128.95166015625,
									27.910253906250006
								],
								[
									128.9897460937501,
									27.811132812499977
								],
								[
									129.01640625000005,
									27.770214843750068
								],
								[
									128.9981445312502,
									27.720800781250063
								]
							]
						],
						[
							[
								[
									129.32402343750016,
									28.104931640625068
								],
								[
									129.33056640625,
									28.081591796875017
								],
								[
									129.232421875,
									28.10112304687499
								],
								[
									129.1924804687502,
									28.19248046874995
								],
								[
									129.2574218750002,
									28.176171875000108
								],
								[
									129.27734375,
									28.144726562500097
								],
								[
									129.32402343750016,
									28.104931640625068
								]
							]
						],
						[
							[
								[
									129.45253906250014,
									28.208984374999943
								],
								[
									129.36640625000018,
									28.127734375000074
								],
								[
									129.2749023437501,
									28.200878906250068
								],
								[
									129.1646484375002,
									28.249755859375085
								],
								[
									129.21708984375016,
									28.262939453125085
								],
								[
									129.2478515625,
									28.282519531250102
								],
								[
									129.25087890625002,
									28.31357421875012
								],
								[
									129.3224609375,
									28.359619140625085
								],
								[
									129.46455078125,
									28.395263671875057
								],
								[
									129.50966796874997,
									28.397509765625074
								],
								[
									129.5605468750001,
									28.43105468750005
								],
								[
									129.57714843749994,
									28.461279296875006
								],
								[
									129.59804687500014,
									28.47587890624996
								],
								[
									129.6895507812502,
									28.517480468749994
								],
								[
									129.71464843750016,
									28.469628906250023
								],
								[
									129.7104492187501,
									28.432128906250114
								],
								[
									129.64169921875003,
									28.411279296874937
								],
								[
									129.57460937500014,
									28.36118164062495
								],
								[
									129.51269531249994,
									28.298730468750023
								],
								[
									129.45673828125,
									28.272314453125063
								],
								[
									129.43906250000003,
									28.254785156250023
								],
								[
									129.45253906250014,
									28.208984374999943
								]
							]
						],
						[
							[
								[
									130.62275390625018,
									30.262988281250074
								],
								[
									130.50820312500002,
									30.241406249999926
								],
								[
									130.44560546875005,
									30.264697265625045
								],
								[
									130.38808593750014,
									30.388183593750085
								],
								[
									130.4971679687501,
									30.46552734375004
								],
								[
									130.64355468749994,
									30.388964843750074
								],
								[
									130.67324218750014,
									30.36689453125001
								],
								[
									130.62275390625018,
									30.262988281250074
								]
							]
						],
						[
							[
								[
									130.95976562500016,
									30.396923828125097
								],
								[
									130.8721679687501,
									30.386328125000063
								],
								[
									130.87031250000007,
									30.44423828125005
								],
								[
									130.9399414062501,
									30.575097656249966
								],
								[
									130.9473632812502,
									30.671191406250102
								],
								[
									131.0122070312501,
									30.792285156250074
								],
								[
									131.03984375000016,
									30.81889648437499
								],
								[
									131.06035156250016,
									30.828466796874977
								],
								[
									131.08261718750003,
									30.790869140625063
								],
								[
									131.05742187500016,
									30.642480468750023
								],
								[
									130.99257812500002,
									30.529980468749926
								],
								[
									130.95976562500016,
									30.396923828125097
								]
							]
						],
						[
							[
								[
									129.71796875,
									31.65712890625005
								],
								[
									129.68681640625,
									31.63964843750003
								],
								[
									129.7068359375,
									31.718261718750057
								],
								[
									129.78730468750007,
									31.78710937499997
								],
								[
									129.79365234375018,
									31.742480468750017
								],
								[
									129.71796875,
									31.65712890625005
								]
							]
						],
						[
							[
								[
									130.3810546875,
									32.423730468749994
								],
								[
									130.29257812500003,
									32.41933593750008
								],
								[
									130.25605468750007,
									32.43100585937506
								],
								[
									130.24169921875,
									32.46279296875005
								],
								[
									130.36542968750007,
									32.52719726562512
								],
								[
									130.46142578125,
									32.51572265625009
								],
								[
									130.41855468750003,
									32.45771484375007
								],
								[
									130.3810546875,
									32.423730468749994
								]
							]
						],
						[
							[
								[
									130.08251953124994,
									32.22968749999998
								],
								[
									130.00351562500003,
									32.193994140624994
								],
								[
									129.99335937500018,
									32.22817382812502
								],
								[
									129.96015625000018,
									32.243750000000006
								],
								[
									130.01728515625018,
									32.29184570312495
								],
								[
									130.01533203125007,
									32.313671874999955
								],
								[
									129.97929687500016,
									32.346191406250085
								],
								[
									130.0212890625,
									32.46884765624995
								],
								[
									130.009765625,
									32.52163085937505
								],
								[
									130.1677734375,
									32.54121093750004
								],
								[
									130.19667968750014,
									32.491601562499966
								],
								[
									130.19951171875,
									32.340576171875114
								],
								[
									130.08251953124994,
									32.22968749999998
								]
							]
						],
						[
							[
								[
									128.66533203125,
									32.78388671875001
								],
								[
									128.7041015625,
									32.75688476562502
								],
								[
									128.76103515625005,
									32.772363281249966
								],
								[
									128.80605468749997,
									32.77597656250009
								],
								[
									128.83857421875,
									32.76289062500007
								],
								[
									128.87939453125,
									32.69331054687504
								],
								[
									128.89453124999994,
									32.65214843749999
								],
								[
									128.82128906249994,
									32.64633789062506
								],
								[
									128.79042968749997,
									32.63671875000006
								],
								[
									128.7504882812501,
									32.586132812499955
								],
								[
									128.6929687500002,
									32.604736328125114
								],
								[
									128.65732421875003,
									32.62841796875003
								],
								[
									128.64912109375018,
									32.66201171875005
								],
								[
									128.66533203125,
									32.78388671875001
								]
							]
						],
						[
							[
								[
									139.84111328125016,
									33.05605468749994
								],
								[
									139.8238281250001,
									33.0454589843751
								],
								[
									139.77568359375005,
									33.07822265625012
								],
								[
									139.76894531250002,
									33.10717773437506
								],
								[
									139.77744140625003,
									33.12514648437508
								],
								[
									139.80888671875016,
									33.12924804687512
								],
								[
									139.8736328125002,
									33.09350585937503
								],
								[
									139.84111328125016,
									33.05605468749994
								]
							]
						],
						[
							[
								[
									129.076953125,
									32.84028320312504
								],
								[
									129.05195312500018,
									32.829492187499966
								],
								[
									129.01962890625003,
									32.91962890625004
								],
								[
									128.997265625,
									32.95185546875004
								],
								[
									129.03496093750016,
									32.96909179687509
								],
								[
									129.10976562500014,
									33.132568359375085
								],
								[
									129.1236328125002,
									33.0676757812501
								],
								[
									129.15273437499997,
									33.00332031250002
								],
								[
									129.18193359375,
									32.9931152343751
								],
								[
									129.15351562500007,
									32.94619140624994
								],
								[
									129.11162109375016,
									32.928857421874966
								],
								[
									129.076953125,
									32.84028320312504
								]
							]
						],
						[
							[
								[
									129.49179687500003,
									33.22304687500002
								],
								[
									129.4213867187501,
									33.1758300781251
								],
								[
									129.37041015625005,
									33.17602539062506
								],
								[
									129.4169921875001,
									33.23110351562508
								],
								[
									129.42314453125,
									33.25737304687502
								],
								[
									129.4619140625001,
									33.33125000000004
								],
								[
									129.53798828125014,
									33.35776367187495
								],
								[
									129.5699218750001,
									33.36103515625007
								],
								[
									129.50810546875,
									33.284326171874994
								],
								[
									129.49179687500003,
									33.22304687500002
								]
							]
						],
						[
							[
								[
									129.79570312500016,
									33.748828125000045
								],
								[
									129.7265625000001,
									33.70732421874993
								],
								[
									129.67480468749994,
									33.739697265624955
								],
								[
									129.70000000000005,
									33.8289062500001
								],
								[
									129.71728515625,
									33.85839843749997
								],
								[
									129.77636718749994,
									33.82919921874998
								],
								[
									129.79570312500016,
									33.748828125000045
								]
							]
						],
						[
							[
								[
									131.17460937500016,
									33.602587890625074
								],
								[
									131.3091796875002,
									33.57275390625006
								],
								[
									131.36601562500016,
									33.57089843750012
								],
								[
									131.41875000000016,
									33.58442382812504
								],
								[
									131.49882812500005,
									33.62358398437502
								],
								[
									131.58300781249994,
									33.65239257812493
								],
								[
									131.6430664062501,
									33.63779296874998
								],
								[
									131.6962890625001,
									33.60283203124996
								],
								[
									131.7242187500002,
									33.553808593750006
								],
								[
									131.71064453125,
									33.50234375000008
								],
								[
									131.61552734375,
									33.39184570312506
								],
								[
									131.53740234375016,
									33.27407226562505
								],
								[
									131.71708984375,
									33.25209960937508
								],
								[
									131.89658203125003,
									33.25458984375007
								],
								[
									131.85468750000007,
									33.18164062499994
								],
								[
									131.84785156250018,
									33.118066406249966
								],
								[
									131.90273437499997,
									33.08779296875011
								],
								[
									131.94931640625003,
									33.04707031250007
								],
								[
									131.93720703125018,
									33.01015625000011
								],
								[
									131.91044921875005,
									32.973681640625045
								],
								[
									132.00859375000016,
									32.919042968750006
								],
								[
									132.00214843750018,
									32.882373046875074
								],
								[
									131.9766601562502,
									32.84394531249998
								],
								[
									131.73212890625,
									32.592822265625074
								],
								[
									131.66035156250018,
									32.4656250000001
								],
								[
									131.6103515625001,
									32.32548828124996
								],
								[
									131.5646484375,
									32.223046874999966
								],
								[
									131.53115234375014,
									32.116748046875074
								],
								[
									131.5056640625,
									32.00195312500006
								],
								[
									131.46025390625016,
									31.883496093749983
								],
								[
									131.47529296875,
									31.778417968749977
								],
								[
									131.4599609375001,
									31.670800781249994
								],
								[
									131.33720703125016,
									31.40468750000005
								],
								[
									131.24970703125018,
									31.409619140624983
								],
								[
									131.13974609375003,
									31.441845703125068
								],
								[
									131.07080078124994,
									31.436865234375034
								],
								[
									131.03515625,
									31.377685546875057
								],
								[
									131.0984375,
									31.256152343750074
								],
								[
									130.90224609374997,
									31.11206054687503
								],
								[
									130.6857421875,
									31.01513671875
								],
								[
									130.68417968750003,
									31.059277343749926
								],
								[
									130.70449218750014,
									31.094091796875006
								],
								[
									130.73574218750002,
									31.12207031250003
								],
								[
									130.7583984375001,
									31.155810546875045
								],
								[
									130.78974609375018,
									31.269091796875045
								],
								[
									130.77421875000005,
									31.383203125000023
								],
								[
									130.70898437499994,
									31.526074218750097
								],
								[
									130.70419921875003,
									31.577441406250074
								],
								[
									130.74941406250014,
									31.598193359375045
								],
								[
									130.7797851562501,
									31.60410156250009
								],
								[
									130.79628906249997,
									31.624072265625074
								],
								[
									130.7968750000001,
									31.67128906250008
								],
								[
									130.77626953124997,
									31.706298828124943
								],
								[
									130.71455078125,
									31.71767578125005
								],
								[
									130.655078125,
									31.718408203125108
								],
								[
									130.61347656250007,
									31.665429687499966
								],
								[
									130.55605468749997,
									31.563085937500063
								],
								[
									130.52812500000016,
									31.459667968750068
								],
								[
									130.54042968750002,
									31.403076171875085
								],
								[
									130.56591796874994,
									31.352392578125063
								],
								[
									130.64453125,
									31.26748046875008
								],
								[
									130.62148437499997,
									31.217529296875114
								],
								[
									130.58876953124997,
									31.178515625000074
								],
								[
									130.3106445312501,
									31.266894531250045
								],
								[
									130.2505859375002,
									31.273193359375085
								],
								[
									130.20068359374994,
									31.29189453125008
								],
								[
									130.147265625,
									31.408496093749932
								],
								[
									130.260546875,
									31.436572265625045
								],
								[
									130.29414062500018,
									31.45068359375
								],
								[
									130.306640625,
									31.487792968750114
								],
								[
									130.32197265625018,
									31.60146484375008
								],
								[
									130.26894531250014,
									31.696337890625045
								],
								[
									130.22421875000003,
									31.73007812500009
								],
								[
									130.18789062500014,
									31.768847656250074
								],
								[
									130.2109375000001,
									31.848974609375063
								],
								[
									130.19580078124994,
									31.949853515624994
								],
								[
									130.1944335937502,
									32.090771484374926
								],
								[
									130.2140625,
									32.11503906249999
								],
								[
									130.31914062500005,
									32.143505859374926
								],
								[
									130.39492187500002,
									32.21899414062494
								],
								[
									130.4620117187502,
									32.30493164062503
								],
								[
									130.56035156250016,
									32.456054687500085
								],
								[
									130.64052734375014,
									32.61923828124995
								],
								[
									130.56328125000005,
									32.62636718750008
								],
								[
									130.49785156250005,
									32.65693359374998
								],
								[
									130.56943359375003,
									32.734130859375085
								],
								[
									130.54726562499997,
									32.831591796875045
								],
								[
									130.44042968749994,
									32.951367187499926
								],
								[
									130.38173828125002,
									33.09257812500002
								],
								[
									130.2873046875,
									33.154785156250085
								],
								[
									130.23750000000018,
									33.17763671875002
								],
								[
									130.1768554687502,
									33.14453125000003
								],
								[
									130.12685546875014,
									33.10483398437512
								],
								[
									130.17314453125016,
									33.01298828124996
								],
								[
									130.1677734375,
									32.93178710937494
								],
								[
									130.17500000000018,
									32.85131835937497
								],
								[
									130.22216796875,
									32.84682617187505
								],
								[
									130.28007812500016,
									32.86684570312494
								],
								[
									130.32646484375,
									32.85263671874998
								],
								[
									130.3535156250001,
									32.810351562500074
								],
								[
									130.3608398437501,
									32.75585937500006
								],
								[
									130.3404296875002,
									32.70185546875007
								],
								[
									130.29765625,
									32.67500000000004
								],
								[
									130.24550781250014,
									32.67714843750002
								],
								[
									130.1929687500001,
									32.706298828125085
								],
								[
									130.15205078125018,
									32.747851562500045
								],
								[
									130.05410156250014,
									32.7708007812501
								],
								[
									129.95078125000003,
									32.721728515625045
								],
								[
									129.8525390625001,
									32.62172851562511
								],
								[
									129.76855468749994,
									32.57099609375007
								],
								[
									129.8081054687501,
									32.645263671875085
								],
								[
									129.8267578125001,
									32.72534179687506
								],
								[
									129.78593750000005,
									32.781640624999994
								],
								[
									129.6900390625002,
									32.87524414062506
								],
								[
									129.66777343750005,
									32.92939453124998
								],
								[
									129.66230468750018,
									32.99492187500002
								],
								[
									129.67910156250014,
									33.05996093749994
								],
								[
									129.77773437500014,
									32.98554687500007
								],
								[
									129.82832031250007,
									32.89267578125006
								],
								[
									129.90078124999997,
									32.851904296875006
								],
								[
									129.9916992187501,
									32.85156250000003
								],
								[
									129.9218750000001,
									32.987988281249926
								],
								[
									129.89677734375016,
									33.02236328125011
								],
								[
									129.79873046874997,
									33.083593750000034
								],
								[
									129.6650390625001,
									33.18662109375006
								],
								[
									129.5800781250001,
									33.23627929687507
								],
								[
									129.61015625,
									33.34365234375008
								],
								[
									129.65996093750005,
									33.364990234375
								],
								[
									129.7021484375001,
									33.35981445312501
								],
								[
									129.84414062499997,
									33.321777343750085
								],
								[
									129.85751953125003,
									33.37524414062506
								],
								[
									129.83662109375007,
									33.40380859375
								],
								[
									129.82568359374994,
									33.437011718750114
								],
								[
									129.91914062500018,
									33.48349609374998
								],
								[
									130.07207031250016,
									33.52177734374996
								],
								[
									130.10341796875014,
									33.53969726562505
								],
								[
									130.13056640625018,
									33.578173828125074
								],
								[
									130.16796874999994,
									33.59829101562511
								],
								[
									130.27509765625,
									33.597705078125074
								],
								[
									130.36503906250016,
									33.63447265625001
								],
								[
									130.4394531250001,
									33.73422851562509
								],
								[
									130.45722656250018,
									33.78896484375005
								],
								[
									130.48378906250002,
									33.83461914062502
								],
								[
									130.6695312500002,
									33.91547851562507
								],
								[
									130.71562500000016,
									33.92778320312499
								],
								[
									130.83964843750005,
									33.91777343749999
								],
								[
									130.95312499999994,
									33.8720214843751
								],
								[
									131.00908203125,
									33.77583007812504
								],
								[
									131.05810546874994,
									33.672851562500114
								],
								[
									131.17460937500016,
									33.602587890625074
								]
							]
						],
						[
							[
								[
									132.26601562500002,
									33.94516601562498
								],
								[
									132.3145507812502,
									33.90859375000008
								],
								[
									132.43046875000005,
									33.923535156249926
								],
								[
									132.44492187500003,
									33.91318359374995
								],
								[
									132.41103515624997,
									33.87993164062502
								],
								[
									132.35996093750003,
									33.84702148437506
								],
								[
									132.26728515625018,
									33.87148437500008
								],
								[
									132.20878906250016,
									33.87285156249999
								],
								[
									132.20058593750002,
									33.92778320312499
								],
								[
									132.2080078125001,
									33.947802734375074
								],
								[
									132.26601562500002,
									33.94516601562498
								]
							]
						],
						[
							[
								[
									132.57841796875016,
									34.11518554687507
								],
								[
									132.5494140625002,
									34.07509765625008
								],
								[
									132.4609375000001,
									34.08725585937506
								],
								[
									132.4962890625,
									34.12197265624994
								],
								[
									132.5235351562501,
									34.164062500000085
								],
								[
									132.54345703124994,
									34.17265624999996
								],
								[
									132.5601562500001,
									34.12690429687507
								],
								[
									132.57841796875016,
									34.11518554687507
								]
							]
						],
						[
							[
								[
									129.27949218750007,
									34.12338867187506
								],
								[
									129.21445312500003,
									34.082812500000045
								],
								[
									129.18642578125002,
									34.145019531250114
								],
								[
									129.21484374999994,
									34.320654296875006
								],
								[
									129.33710937500018,
									34.28476562499998
								],
								[
									129.3350585937502,
									34.23081054687509
								],
								[
									129.27949218750007,
									34.12338867187506
								]
							]
						],
						[
							[
								[
									134.3574218750001,
									34.25634765625006
								],
								[
									134.49570312500003,
									34.21474609375011
								],
								[
									134.63750000000016,
									34.22661132812502
								],
								[
									134.63525390624994,
									34.04394531249994
								],
								[
									134.65537109375003,
									33.98261718750007
								],
								[
									134.6953125000001,
									33.92773437500006
								],
								[
									134.6748046875001,
									33.84780273437505
								],
								[
									134.7388671875002,
									33.82050781249998
								],
								[
									134.54873046875002,
									33.72929687499996
								],
								[
									134.3770507812502,
									33.60839843750003
								],
								[
									134.30654296875014,
									33.526806640624926
								],
								[
									134.2426757812501,
									33.43945312500006
								],
								[
									134.2056640625002,
									33.346972656250045
								],
								[
									134.1816406250001,
									33.24721679687508
								],
								[
									134.1241210937502,
									33.28676757812505
								],
								[
									133.95869140625007,
									33.44833984375009
								],
								[
									133.85400390624994,
									33.492675781250085
								],
								[
									133.6856445312502,
									33.51630859375001
								],
								[
									133.63203125,
									33.510986328125085
								],
								[
									133.28593750000016,
									33.35996093749995
								],
								[
									133.23994140625018,
									33.249609375000034
								],
								[
									133.14560546875003,
									33.08315429687505
								],
								[
									133.10087890625,
									33.02822265625005
								],
								[
									133.05117187500002,
									33.01245117187494
								],
								[
									133.01601562500014,
									32.983886718750085
								],
								[
									132.97724609375,
									32.84199218750004
								],
								[
									132.86992187500005,
									32.75458984374998
								],
								[
									132.8042968750001,
									32.75200195312499
								],
								[
									132.69218750000016,
									32.775927734375074
								],
								[
									132.64179687500018,
									32.762451171875085
								],
								[
									132.7089843750001,
									32.90249023437511
								],
								[
									132.60195312500014,
									32.91953125000012
								],
								[
									132.49511718749994,
									32.91660156249995
								],
								[
									132.49257812499997,
									33.007666015625034
								],
								[
									132.4278320312502,
									33.059375000000074
								],
								[
									132.47578125,
									33.126464843750085
								],
								[
									132.4771484375002,
									33.18115234375003
								],
								[
									132.50527343749997,
									33.21127929687495
								],
								[
									132.51503906250014,
									33.25537109375006
								],
								[
									132.51142578125018,
									33.29306640625009
								],
								[
									132.44541015625003,
									33.30458984375005
								],
								[
									132.40517578125014,
									33.33125000000004
								],
								[
									132.41279296875007,
									33.43046875000002
								],
								[
									132.37490234374997,
									33.43408203125003
								],
								[
									132.28105468750016,
									33.416796875000074
								],
								[
									132.08583984374997,
									33.340136718750074
								],
								[
									132.03261718749997,
									33.339990234374966
								],
								[
									132.114453125,
									33.39458007812499
								],
								[
									132.28789062500005,
									33.469531250000074
								],
								[
									132.36591796875,
									33.512451171875114
								],
								[
									132.53603515625014,
									33.632910156250034
								],
								[
									132.64306640625,
									33.68994140624994
								],
								[
									132.69892578125018,
									33.790917968749994
								],
								[
									132.71621093749997,
									33.85224609375007
								],
								[
									132.75234375000014,
									33.90615234374994
								],
								[
									132.7842773437501,
									33.992431640625114
								],
								[
									132.8394531250002,
									34.02124023437503
								],
								[
									132.9351562500001,
									34.09531250000009
								],
								[
									132.99013671875002,
									34.08813476562497
								],
								[
									133.0512695312501,
									33.99711914062499
								],
								[
									133.13369140625014,
									33.927294921875074
								],
								[
									133.19306640625007,
									33.933203125000034
								],
								[
									133.2988281250001,
									33.96899414062494
								],
								[
									133.34980468750018,
									33.977050781250085
								],
								[
									133.47207031250014,
									33.97280273437511
								],
								[
									133.58203124999994,
									34.01713867187499
								],
								[
									133.62675781250005,
									34.069384765625074
								],
								[
									133.64345703125014,
									34.13466796875005
								],
								[
									133.6026367187501,
									34.24384765624998
								],
								[
									133.65556640625005,
									34.23286132812507
								],
								[
									133.70625000000007,
									34.237353515625074
								],
								[
									133.82558593750014,
									34.30683593750004
								],
								[
									133.9483398437501,
									34.34804687500008
								],
								[
									134.07587890625,
									34.35839843750006
								],
								[
									134.2192382812501,
									34.31904296875004
								],
								[
									134.3574218750001,
									34.25634765625006
								]
							]
						],
						[
							[
								[
									134.35185546875005,
									34.483642578125085
								],
								[
									134.33320312500007,
									34.46376953124994
								],
								[
									134.31533203124997,
									34.468945312499926
								],
								[
									134.25185546875002,
									34.42304687500007
								],
								[
									134.23808593750016,
									34.467041015625085
								],
								[
									134.18828125000005,
									34.496337890625
								],
								[
									134.1821289062501,
									34.519238281249955
								],
								[
									134.3259765625,
									34.53437500000001
								],
								[
									134.372265625,
									34.52236328125005
								],
								[
									134.35185546875005,
									34.483642578125085
								]
							]
						],
						[
							[
								[
									134.93281250000018,
									34.288134765625045
								],
								[
									134.8244140625,
									34.2029296875001
								],
								[
									134.7306640625,
									34.208886718749966
								],
								[
									134.68349609375002,
									34.24697265625008
								],
								[
									134.66787109375014,
									34.294140624999926
								],
								[
									134.75722656250014,
									34.3681640625
								],
								[
									134.83427734375,
									34.47265624999997
								],
								[
									134.9041015625,
									34.51909179687493
								],
								[
									134.9607421875,
									34.54492187500003
								],
								[
									135.0046875,
									34.54404296874995
								],
								[
									134.90546875,
									34.398291015625006
								],
								[
									134.93281250000018,
									34.288134765625045
								]
							]
						],
						[
							[
								[
									129.38564453125002,
									34.35366210937508
								],
								[
									129.36533203125003,
									34.305517578125034
								],
								[
									129.2974609375001,
									34.33959960937506
								],
								[
									129.2666992187502,
									34.37045898437512
								],
								[
									129.32939453125,
									34.521874999999966
								],
								[
									129.32207031250005,
									34.57929687500004
								],
								[
									129.32587890625018,
									34.60727539062495
								],
								[
									129.45107421875014,
									34.686572265625045
								],
								[
									129.47246093750005,
									34.67133789062504
								],
								[
									129.48017578125018,
									34.64946289062493
								],
								[
									129.46914062499997,
									34.615527343750045
								],
								[
									129.475390625,
									34.54042968750011
								],
								[
									129.38144531250003,
									34.41645507812498
								],
								[
									129.38564453125002,
									34.35366210937508
								]
							]
						],
						[
							[
								[
									139.45644531250002,
									34.7265136718751
								],
								[
									139.44570312500014,
									34.67954101562512
								],
								[
									139.39238281250005,
									34.6898925781251
								],
								[
									139.36689453125018,
									34.72050781249993
								],
								[
									139.37001953124997,
									34.77543945312493
								],
								[
									139.42617187499997,
									34.775878906250114
								],
								[
									139.45644531250002,
									34.7265136718751
								]
							]
						],
						[
							[
								[
									133.37050781250014,
									36.20385742187497
								],
								[
									133.32470703124994,
									36.16650390625
								],
								[
									133.23925781249994,
									36.1787597656251
								],
								[
									133.1899414062501,
									36.23261718750007
								],
								[
									133.20615234375003,
									36.29340820312501
								],
								[
									133.295703125,
									36.34013671874993
								],
								[
									133.38125000000002,
									36.24638671874993
								],
								[
									133.37050781250014,
									36.20385742187497
								]
							]
						],
						[
							[
								[
									138.34404296875016,
									37.82211914062506
								],
								[
									138.24902343749994,
									37.81958007812497
								],
								[
									138.2251953125001,
									37.82939453124993
								],
								[
									138.2828125000002,
									37.854199218749926
								],
								[
									138.28789062500016,
									37.89580078124996
								],
								[
									138.32226562499994,
									37.969531250000074
								],
								[
									138.32167968750014,
									37.990820312500034
								],
								[
									138.2461914062502,
									37.994580078124926
								],
								[
									138.25,
									38.07846679687506
								],
								[
									138.30634765625018,
									38.161132812500114
								],
								[
									138.46132812500014,
									38.29145507812501
								],
								[
									138.50361328125007,
									38.315917968750114
								],
								[
									138.51005859375005,
									38.25898437500007
								],
								[
									138.46279296875002,
									38.124316406250074
								],
								[
									138.45361328125,
									38.075683593750114
								],
								[
									138.5751953125,
									38.06552734375009
								],
								[
									138.49697265625014,
									37.90390625000009
								],
								[
									138.34404296875016,
									37.82211914062506
								]
							]
						],
						[
							[
								[
									141.22929687500016,
									41.37265625000006
								],
								[
									141.26875,
									41.353808593750045
								],
								[
									141.45546875000014,
									41.404736328124926
								],
								[
									141.419921875,
									41.2511718750001
								],
								[
									141.4000000000002,
									41.09633789062508
								],
								[
									141.41367187500003,
									40.83935546874994
								],
								[
									141.43046875,
									40.72333984375001
								],
								[
									141.46279296875014,
									40.61113281249999
								],
								[
									141.54228515625016,
									40.53071289062504
								],
								[
									141.6462890625,
									40.47363281250006
								],
								[
									141.79707031250018,
									40.291162109374994
								],
								[
									141.87792968749994,
									40.067236328125034
								],
								[
									141.93505859374994,
									39.958496093750085
								],
								[
									141.97783203125016,
									39.84443359375001
								],
								[
									141.99082031250003,
									39.79223632812506
								],
								[
									141.99189453125018,
									39.73989257812505
								],
								[
									141.97910156250003,
									39.66835937500002
								],
								[
									141.9931640625,
									39.61054687499998
								],
								[
									141.97695312500014,
									39.42880859375009
								],
								[
									141.90947265625016,
									39.2187011718751
								],
								[
									141.90078124999997,
									39.11132812499997
								],
								[
									141.84208984375005,
									39.09003906249998
								],
								[
									141.80654296874997,
									39.04042968750011
								],
								[
									141.776171875,
									39.017431640625034
								],
								[
									141.74248046875016,
									38.99960937499995
								],
								[
									141.69355468750007,
									38.99516601562493
								],
								[
									141.65859375000014,
									38.97485351562497
								],
								[
									141.64472656250007,
									38.91791992187501
								],
								[
									141.62226562500018,
									38.865136718749994
								],
								[
									141.5796875000002,
									38.81650390624995
								],
								[
									141.54628906249997,
									38.76284179687494
								],
								[
									141.51875000000007,
									38.63203125000004
								],
								[
									141.5087890625,
									38.49785156249996
								],
								[
									141.46748046875018,
									38.40415039062506
								],
								[
									141.3681640625001,
									38.37973632812506
								],
								[
									141.25429687500002,
									38.381396484375045
								],
								[
									141.1083984375001,
									38.337939453125074
								],
								[
									141.07734375000018,
									38.312548828125045
								],
								[
									140.96210937500018,
									38.14887695312501
								],
								[
									140.92900390625016,
									38.05288085937508
								],
								[
									140.9279296875,
									37.949609374999994
								],
								[
									140.9599609375,
									37.82260742187506
								],
								[
									141.00341796874994,
									37.69843749999998
								],
								[
									141.03632812500018,
									37.467236328124955
								],
								[
									141.00166015625007,
									37.11464843750008
								],
								[
									140.9683593750002,
									37.002050781250034
								],
								[
									140.8951171875002,
									36.925732421874955
								],
								[
									140.8396484375,
									36.89033203125001
								],
								[
									140.791796875,
									36.84687500000004
								],
								[
									140.72988281250002,
									36.73188476562498
								],
								[
									140.62734374999997,
									36.502783203125034
								],
								[
									140.61884765625,
									36.44531250000006
								],
								[
									140.6192382812502,
									36.385595703125034
								],
								[
									140.5916015625,
									36.30781250000001
								],
								[
									140.57353515625016,
									36.23134765625005
								],
								[
									140.5904296875002,
									36.14243164062498
								],
								[
									140.62197265625014,
									36.059228515624994
								],
								[
									140.75957031250005,
									35.845703125000114
								],
								[
									140.8134765625,
									35.78251953124993
								],
								[
									140.8740234375,
									35.72495117187509
								],
								[
									140.6392578125002,
									35.66127929687511
								],
								[
									140.59687500000018,
									35.6320312500001
								],
								[
									140.45742187500002,
									35.51025390624997
								],
								[
									140.412890625,
									35.394775390625085
								],
								[
									140.4165039062501,
									35.26699218750005
								],
								[
									140.39296875000014,
									35.221142578124955
								],
								[
									140.35468750000007,
									35.181445312500045
								],
								[
									140.31474609375,
									35.155029296875085
								],
								[
									140.15888671875,
									35.09648437499996
								],
								[
									140.05917968750003,
									35.03828125000001
								],
								[
									139.95976562500016,
									34.947314453125045
								],
								[
									139.92041015624994,
									34.8996093750001
								],
								[
									139.84394531250018,
									34.914892578125006
								],
								[
									139.79921875000014,
									34.95693359375005
								],
								[
									139.84326171874994,
									35.00986328125009
								],
								[
									139.8296875000002,
									35.07216796875008
								],
								[
									139.85146484375014,
									35.23232421875002
								],
								[
									139.82646484375,
									35.296679687500074
								],
								[
									139.90615234374997,
									35.34526367187493
								],
								[
									139.94414062500016,
									35.42299804687505
								],
								[
									140.02714843750005,
									35.48520507812512
								],
								[
									140.08632812500002,
									35.540429687499994
								],
								[
									140.096875,
									35.585156249999955
								],
								[
									140.04365234375018,
									35.6333496093751
								],
								[
									139.9875,
									35.668212890625
								],
								[
									139.9097656250001,
									35.66835937499994
								],
								[
									139.834765625,
									35.65805664062498
								],
								[
									139.78632812500018,
									35.61210937500002
								],
								[
									139.77011718750003,
									35.549560546875085
								],
								[
									139.77392578124994,
									35.52036132812509
								],
								[
									139.7677734375,
									35.49482421875004
								],
								[
									139.6500000000002,
									35.40913085937507
								],
								[
									139.66552734375,
									35.31948242187511
								],
								[
									139.70000000000016,
									35.273974609375074
								],
								[
									139.74404296874997,
									35.252392578124926
								],
								[
									139.73085937500014,
									35.22153320312495
								],
								[
									139.67500000000007,
									35.14926757812506
								],
								[
									139.63593750000018,
									35.14213867187502
								],
								[
									139.5640625000002,
									35.24326171875012
								],
								[
									139.47441406250005,
									35.29853515625001
								],
								[
									139.36347656250018,
									35.298095703125
								],
								[
									139.24941406250014,
									35.2780273437501
								],
								[
									139.1626953125002,
									35.210742187500074
								],
								[
									139.13408203125016,
									35.15488281250006
								],
								[
									139.1158203125001,
									35.09711914062501
								],
								[
									139.12197265625002,
									34.956494140624955
								],
								[
									139.08603515625003,
									34.839160156250045
								],
								[
									139.0156250000001,
									34.73603515624998
								],
								[
									138.9826171875,
									34.69838867187505
								],
								[
									138.8966796875,
									34.62841796875
								],
								[
									138.83750000000003,
									34.61923828125009
								],
								[
									138.7951171875,
									34.65102539062508
								],
								[
									138.76103515625,
									34.69921874999994
								],
								[
									138.80449218750016,
									34.87573242187503
								],
								[
									138.802734375,
									34.974804687499955
								],
								[
									138.90361328125,
									35.02524414062512
								],
								[
									138.8208984375002,
									35.095703125000085
								],
								[
									138.71962890625002,
									35.12407226562499
								],
								[
									138.5771484375001,
									35.086474609375045
								],
								[
									138.53701171875002,
									35.044140624999955
								],
								[
									138.50957031250005,
									34.98715820312506
								],
								[
									138.43310546875,
									34.91518554687508
								],
								[
									138.3486328125001,
									34.847705078125074
								],
								[
									138.25322265625005,
									34.732666015625085
								],
								[
									138.1890625000002,
									34.59633789062502
								],
								[
									137.9790039062501,
									34.640917968750045
								],
								[
									137.8642578125001,
									34.65087890625006
								],
								[
									137.74853515624994,
									34.647412109374955
								],
								[
									137.54335937500002,
									34.66420898437511
								],
								[
									137.31806640625,
									34.63637695312502
								],
								[
									137.06171875,
									34.582812500000045
								],
								[
									137.07705078125014,
									34.62143554687509
								],
								[
									137.28779296875018,
									34.70351562500002
								],
								[
									137.2954101562501,
									34.727587890625045
								],
								[
									137.2751953125,
									34.772509765625045
								],
								[
									137.22265624999994,
									34.77470703124996
								],
								[
									137.09658203125002,
									34.75903320312506
								],
								[
									137.03222656249994,
									34.765917968750045
								],
								[
									137.0059570312502,
									34.814111328124994
								],
								[
									136.96328125000014,
									34.83491210937507
								],
								[
									136.93476562500018,
									34.81518554687494
								],
								[
									136.94414062500016,
									34.72153320312506
								],
								[
									136.91289062500016,
									34.70903320312499
								],
								[
									136.8712890625,
									34.73310546875001
								],
								[
									136.8845703125,
									34.8058593750001
								],
								[
									136.85615234375007,
									34.912499999999966
								],
								[
									136.85292968750014,
									34.978710937499955
								],
								[
									136.89707031250003,
									35.03554687500008
								],
								[
									136.85185546875016,
									35.05952148437498
								],
								[
									136.80419921874994,
									35.05029296874997
								],
								[
									136.74355468750014,
									35.0229980468751
								],
								[
									136.69003906250003,
									34.984130859375085
								],
								[
									136.57695312500005,
									34.78955078125006
								],
								[
									136.53300781250016,
									34.67836914062505
								],
								[
									136.61582031250003,
									34.58906250000007
								],
								[
									136.84160156250005,
									34.464208984375034
								],
								[
									136.88027343750002,
									34.433593750000085
								],
								[
									136.88115234375,
									34.38046875000012
								],
								[
									136.85371093750018,
									34.32407226562509
								],
								[
									136.79218750000018,
									34.2992675781251
								],
								[
									136.54443359375,
									34.257714843749966
								],
								[
									136.32988281250016,
									34.17685546875012
								],
								[
									136.26787109375005,
									34.09487304687511
								],
								[
									136.07255859375005,
									33.77822265625008
								],
								[
									135.91621093750007,
									33.561718749999926
								],
								[
									135.6953125000001,
									33.48696289062508
								],
								[
									135.45283203125018,
									33.55336914062511
								],
								[
									135.39423828125,
									33.62875976562509
								],
								[
									135.34677734375003,
									33.721972656250074
								],
								[
									135.25664062500016,
									33.806250000000006
								],
								[
									135.17539062500003,
									33.89804687500006
								],
								[
									135.12792968749994,
									34.00698242187505
								],
								[
									135.13535156250003,
									34.18261718749994
								],
								[
									135.10009765625,
									34.2883789062501
								],
								[
									135.1319335937501,
									34.316552734374966
								],
								[
									135.26562499999994,
									34.3808105468751
								],
								[
									135.30927734375007,
									34.41679687499996
								],
								[
									135.384765625,
									34.50043945312504
								],
								[
									135.41181640625018,
									34.54697265625009
								],
								[
									135.41591796875002,
									34.61748046874999
								],
								[
									135.35517578125018,
									34.65429687499994
								],
								[
									135.1982421875,
									34.65292968750012
								],
								[
									135.04169921875018,
									34.631005859374994
								],
								[
									134.9298828125,
									34.66181640625004
								],
								[
									134.7849609375,
									34.747070312500114
								],
								[
									134.74003906250016,
									34.76523437499998
								],
								[
									134.58378906250005,
									34.770605468750006
								],
								[
									134.47226562500003,
									34.75478515625008
								],
								[
									134.36269531250014,
									34.723681640625045
								],
								[
									134.24687500000016,
									34.7138671875
								],
								[
									134.20830078125,
									34.69765625000008
								],
								[
									134.07451171875005,
									34.59311523437509
								],
								[
									133.96826171874994,
									34.5272949218751
								],
								[
									133.87636718749997,
									34.494628906250085
								],
								[
									133.67792968750007,
									34.4858886718751
								],
								[
									133.57861328125,
									34.46469726562495
								],
								[
									133.47441406250016,
									34.430126953124926
								],
								[
									133.4453125000001,
									34.4331542968751
								],
								[
									133.33564453125007,
									34.38535156249995
								],
								[
									133.20976562500016,
									34.34399414062506
								],
								[
									133.14238281250005,
									34.30244140625001
								],
								[
									133.01894531250002,
									34.32958984375006
								],
								[
									132.77460937500007,
									34.25522460937509
								],
								[
									132.65654296875016,
									34.24609375
								],
								[
									132.53447265625016,
									34.2870605468751
								],
								[
									132.42128906250002,
									34.353369140625006
								],
								[
									132.3125976562501,
									34.324951171875085
								],
								[
									132.2380859375,
									34.227001953124926
								],
								[
									132.201953125,
									34.0320312500001
								],
								[
									132.159375,
									33.944238281249966
								],
								[
									132.146484375,
									33.83876953125005
								],
								[
									132.09023437499997,
									33.85546875
								],
								[
									131.76318359374994,
									34.045263671875034
								],
								[
									131.74052734375016,
									34.05205078124999
								],
								[
									131.4761718750002,
									34.01938476562509
								],
								[
									131.40791015625018,
									34.00361328124998
								],
								[
									131.32275390624994,
									33.96518554687506
								],
								[
									131.23261718750007,
									33.94799804687503
								],
								[
									131.1503906250001,
									33.975634765625045
								],
								[
									131.0718750000001,
									34.020654296874994
								],
								[
									130.99638671875016,
									34.007275390624926
								],
								[
									130.91884765625002,
									33.97573242187508
								],
								[
									130.8892578125002,
									34.261816406250006
								],
								[
									130.90429687499994,
									34.29956054687497
								],
								[
									130.95185546875007,
									34.34970703125006
								],
								[
									131.00419921875016,
									34.392578125
								],
								[
									131.13222656250014,
									34.407373046874994
								],
								[
									131.26181640625003,
									34.39345703125008
								],
								[
									131.35439453125002,
									34.41318359375012
								],
								[
									131.43251953125002,
									34.46982421875012
								],
								[
									131.51503906250014,
									34.55014648437495
								],
								[
									131.6080078125001,
									34.61547851562503
								],
								[
									131.73408203125018,
									34.66708984375006
								],
								[
									131.85605468750003,
									34.72631835937506
								],
								[
									131.9630859375,
									34.8093750000001
								],
								[
									132.06474609375005,
									34.90000000000009
								],
								[
									132.158203125,
									34.966503906249955
								],
								[
									132.25957031250005,
									35.02231445312495
								],
								[
									132.41406249999994,
									35.156298828125074
								],
								[
									132.61904296874997,
									35.30683593750001
								],
								[
									132.69765625000002,
									35.41831054687498
								],
								[
									132.7465820312501,
									35.44902343749993
								],
								[
									132.9229492187501,
									35.5112792968751
								],
								[
									133.15693359375007,
									35.558837890625114
								],
								[
									133.26718750000003,
									35.55654296875008
								],
								[
									133.3764648437501,
									35.45883789062498
								],
								[
									133.43535156250005,
									35.472216796875045
								],
								[
									133.49492187500016,
									35.49746093749994
								],
								[
									133.6154296875,
									35.51142578125004
								],
								[
									133.73935546875003,
									35.49526367187494
								],
								[
									133.86025390624997,
									35.49487304687494
								],
								[
									133.98125000000005,
									35.50722656250008
								],
								[
									134.2140625,
									35.539257812499926
								],
								[
									134.3365234375002,
									35.57792968749999
								],
								[
									134.45605468749994,
									35.62792968750006
								],
								[
									134.88222656250002,
									35.663232421874966
								],
								[
									135.1743164062501,
									35.747070312500085
								],
								[
									135.2205078125,
									35.74111328125002
								],
								[
									135.2654296875,
									35.72177734375009
								],
								[
									135.26875000000007,
									35.65966796874994
								],
								[
									135.2320312500002,
									35.59189453125009
								],
								[
									135.2677734375,
									35.55087890625009
								],
								[
									135.326953125,
									35.52553710937508
								],
								[
									135.60185546875016,
									35.51772460937508
								],
								[
									135.68027343750003,
									35.50312500000004
								],
								[
									135.7950195312501,
									35.54951171875007
								],
								[
									135.90312500000016,
									35.60688476562504
								],
								[
									136.0162109375002,
									35.68251953125008
								],
								[
									136.09531250000003,
									35.7676269531251
								],
								[
									136.022265625,
									35.874121093750034
								],
								[
									136.00625000000014,
									35.99057617187495
								],
								[
									136.06748046875003,
									36.11684570312511
								],
								[
									136.1562500000001,
									36.22333984375004
								],
								[
									136.26181640625003,
									36.28769531250009
								],
								[
									136.3589843750002,
									36.36176757812498
								],
								[
									136.55585937500018,
									36.5719726562501
								],
								[
									136.69814453125014,
									36.742041015625006
								],
								[
									136.74931640625016,
									36.95102539062495
								],
								[
									136.71923828124994,
									37.19838867187508
								],
								[
									136.84345703125007,
									37.38212890625002
								],
								[
									136.96230468750002,
									37.41367187500006
								],
								[
									137.19863281250014,
									37.49746093750008
								],
								[
									137.32265624999997,
									37.522070312500034
								],
								[
									137.34121093750014,
									37.485449218750034
								],
								[
									137.3375000000001,
									37.437451171874926
								],
								[
									137.15205078125,
									37.28315429687504
								],
								[
									137.04580078124997,
									37.219726562500085
								],
								[
									136.9822265625,
									37.20004882812506
								],
								[
									136.9240234375,
									37.17197265625012
								],
								[
									136.8999023437501,
									37.11767578124997
								],
								[
									136.99443359375,
									37.02675781250002
								],
								[
									137.0185546875001,
									36.95961914062502
								],
								[
									137.0126953125,
									36.89511718750012
								],
								[
									137.0166992187501,
									36.837207031250045
								],
								[
									137.12373046875007,
									36.774072265624966
								],
								[
									137.24628906250007,
									36.75317382812497
								],
								[
									137.29765625000005,
									36.75375976562509
								],
								[
									137.34257812500005,
									36.770361328125006
								],
								[
									137.48261718750007,
									36.924755859374926
								],
								[
									137.51406249999997,
									36.95156250000005
								],
								[
									137.9131835937502,
									37.064599609374994
								],
								[
									138.10957031250018,
									37.15107421875004
								],
								[
									138.21806640625016,
									37.17338867187496
								],
								[
									138.3199218750002,
									37.21840820312508
								],
								[
									138.5483398437501,
									37.39213867187493
								],
								[
									138.6328125,
									37.472167968750085
								],
								[
									138.70937500000014,
									37.56064453124998
								],
								[
									138.7706054687502,
									37.66342773437506
								],
								[
									138.81884765624994,
									37.774707031250074
								],
								[
									138.88505859375016,
									37.84394531250007
								],
								[
									139.2471679687502,
									38.009082031250045
								],
								[
									139.3638671875001,
									38.09902343750005
								],
								[
									139.4009765625001,
									38.14257812500006
								],
								[
									139.44580078125,
									38.2687500000001
								],
								[
									139.47675781250018,
									38.399804687499966
								],
								[
									139.52080078125016,
									38.50253906250012
								],
								[
									139.5801757812501,
									38.59887695312503
								],
								[
									139.65976562500003,
									38.69702148437494
								],
								[
									139.74912109375003,
									38.788134765625045
								],
								[
									139.80195312500007,
									38.88159179687497
								],
								[
									139.87861328125007,
									39.1049316406251
								],
								[
									139.91230468750018,
									39.22856445312496
								],
								[
									139.9385742187502,
									39.27314453124998
								],
								[
									139.97714843750003,
									39.31064453125009
								],
								[
									140.0108398437501,
									39.358056640624966
								],
								[
									140.03652343749997,
									39.41113281249994
								],
								[
									140.04814453125005,
									39.46372070312509
								],
								[
									140.06474609375005,
									39.624414062499966
								],
								[
									140.05468749999994,
									39.749267578125
								],
								[
									139.9947265625001,
									39.85507812500006
								],
								[
									139.94521484375014,
									39.88510742187506
								],
								[
									139.89121093750003,
									39.886865234374966
								],
								[
									139.8103515625,
									39.877734375000045
								],
								[
									139.74150390625,
									39.920849609374955
								],
								[
									139.7554687500002,
									39.95893554687507
								],
								[
									139.8256835937501,
									39.966015624999926
								],
								[
									139.8736328125002,
									39.98569335937512
								],
								[
									139.9080078125,
									40.021728515625085
								],
								[
									139.97246093750016,
									40.13696289062503
								],
								[
									140.01113281250014,
									40.26035156250012
								],
								[
									140.014453125,
									40.31489257812504
								],
								[
									139.96406250000007,
									40.41430664062494
								],
								[
									139.92392578125003,
									40.53388671875007
								],
								[
									139.9228515625001,
									40.598437500000074
								],
								[
									139.96669921875014,
									40.67275390625002
								],
								[
									140.0292968750001,
									40.73315429687506
								],
								[
									140.08535156249997,
									40.747363281250045
								],
								[
									140.1460937500002,
									40.75156250000009
								],
								[
									140.20126953125003,
									40.77490234375006
								],
								[
									140.25234374999997,
									40.80878906250001
								],
								[
									140.2812500000001,
									40.84609375000008
								],
								[
									140.3262695312502,
									40.94765625000008
								],
								[
									140.3435546875,
									41.00566406249999
								],
								[
									140.315234375,
									41.160888671875085
								],
								[
									140.34443359375018,
									41.203320312499926
								],
								[
									140.3859375,
									41.22978515624999
								],
								[
									140.44130859375002,
									41.20966796874998
								],
								[
									140.4980468750001,
									41.20566406250006
								],
								[
									140.56416015625018,
									41.21181640625005
								],
								[
									140.62763671875007,
									41.195410156250006
								],
								[
									140.6396484375001,
									41.15561523437498
								],
								[
									140.67939453125,
									40.8932617187501
								],
								[
									140.70244140625,
									40.85781250000005
								],
								[
									140.7486328125002,
									40.83032226562497
								],
								[
									140.80078125,
									40.83432617187506
								],
								[
									140.8458007812502,
									40.87514648437505
								],
								[
									140.87617187500007,
									40.92954101562512
								],
								[
									140.9360351562501,
									40.94077148437509
								],
								[
									141.11855468749997,
									40.88227539062498
								],
								[
									141.1832031250001,
									40.92402343750004
								],
								[
									141.22539062500016,
									40.98847656250004
								],
								[
									141.26210937499997,
									41.10268554687502
								],
								[
									141.2442382812501,
									41.205615234375045
								],
								[
									141.200390625,
									41.24360351562507
								],
								[
									141.15507812500005,
									41.23671875000008
								],
								[
									141.11503906250016,
									41.208496093750085
								],
								[
									141.0704101562502,
									41.19306640625007
								],
								[
									140.80058593750005,
									41.13881835937494
								],
								[
									140.8018554687502,
									41.25366210937497
								],
								[
									140.85957031250007,
									41.42543945312505
								],
								[
									140.89150390624997,
									41.479785156250045
								],
								[
									140.93691406250002,
									41.505566406249955
								],
								[
									141.05019531249997,
									41.47573242187511
								],
								[
									141.10585937500014,
									41.455859375000045
								],
								[
									141.22929687500016,
									41.37265625000006
								]
							]
						],
						[
							[
								[
									139.48125,
									42.08100585937504
								],
								[
									139.45839843749997,
									42.07563476562501
								],
								[
									139.4345703125001,
									42.08408203124995
								],
								[
									139.41152343750002,
									42.159667968750085
								],
								[
									139.43134765625007,
									42.199560546875034
								],
								[
									139.49580078125,
									42.22744140624994
								],
								[
									139.5583984375,
									42.235205078125006
								],
								[
									139.50507812500007,
									42.09638671875007
								],
								[
									139.48125,
									42.08100585937504
								]
							]
						],
						[
							[
								[
									141.2954101562501,
									45.11933593750007
								],
								[
									141.22597656250002,
									45.11220703124994
								],
								[
									141.1453125,
									45.15390625000009
								],
								[
									141.1353515625002,
									45.20620117187508
								],
								[
									141.19375000000002,
									45.247851562500045
								],
								[
									141.25185546875014,
									45.23247070312502
								],
								[
									141.31005859375,
									45.17856445312495
								],
								[
									141.3291992187501,
									45.150488281250006
								],
								[
									141.2954101562501,
									45.11933593750007
								]
							]
						],
						[
							[
								[
									141.07275390624994,
									45.33286132812495
								],
								[
									141.03398437500016,
									45.269335937500074
								],
								[
									140.98212890625007,
									45.36376953125003
								],
								[
									140.9716796875,
									45.465478515624966
								],
								[
									141.00166015625007,
									45.464843750000114
								],
								[
									141.0567382812501,
									45.449560546875006
								],
								[
									141.0699218750002,
									45.39999999999995
								],
								[
									141.07275390624994,
									45.33286132812495
								]
							]
						],
						[
							[
								[
									143.8243164062502,
									44.116992187500045
								],
								[
									143.94951171875,
									44.11191406250006
								],
								[
									144.00546875000003,
									44.11665039062507
								],
								[
									144.10136718750016,
									44.101562500000085
								],
								[
									144.48183593750002,
									43.94956054687495
								],
								[
									144.59667968749994,
									43.9302246093751
								],
								[
									144.71523437500014,
									43.927978515625085
								],
								[
									144.79853515625007,
									43.9402343750001
								],
								[
									144.87187500000016,
									43.98193359374997
								],
								[
									145.1015625,
									44.16616210937494
								],
								[
									145.3427734375001,
									44.333886718749994
								],
								[
									145.36953125000014,
									44.327392578125085
								],
								[
									145.36962890624994,
									44.281298828125045
								],
								[
									145.35195312500002,
									44.22978515624993
								],
								[
									145.2452148437502,
									44.076171875000085
								],
								[
									145.12636718750014,
									43.86938476562506
								],
								[
									145.10107421874994,
									43.76455078125011
								],
								[
									145.1396484375001,
									43.662499999999994
								],
								[
									145.21406250000018,
									43.57822265625006
								],
								[
									145.27294921875,
									43.462890625000114
								],
								[
									145.34082031249994,
									43.30253906250002
								],
								[
									145.4361328125002,
									43.28222656249997
								],
								[
									145.4878906250001,
									43.2797363281251
								],
								[
									145.58330078125016,
									43.32778320312502
								],
								[
									145.6736328125,
									43.38886718750004
								],
								[
									145.75126953125,
									43.396289062500045
								],
								[
									145.83300781249994,
									43.38593750000007
								],
								[
									145.7255859375001,
									43.343457031249926
								],
								[
									145.62421875000007,
									43.29130859374996
								],
								[
									145.53740234375005,
									43.19267578125002
								],
								[
									145.505078125,
									43.174218749999994
								],
								[
									145.4047851562501,
									43.18027343750009
								],
								[
									145.34746093750016,
									43.17670898437507
								],
								[
									145.23007812500003,
									43.135498046875114
								],
								[
									145.1271484375,
									43.088867187500114
								],
								[
									145.02880859375,
									43.031640624999994
								],
								[
									144.92138671874994,
									43.000927734374955
								],
								[
									144.8071289062501,
									42.99370117187499
								],
								[
									144.63076171874997,
									42.946923828124966
								],
								[
									144.5162109375002,
									42.943603515625
								],
								[
									144.30156250000016,
									42.984423828125045
								],
								[
									144.19726562499994,
									42.973632812500085
								],
								[
									143.96933593750003,
									42.88139648437502
								],
								[
									143.76210937500014,
									42.74814453125006
								],
								[
									143.58095703124997,
									42.59873046875009
								],
								[
									143.42949218750005,
									42.418896484374955
								],
								[
									143.36865234375,
									42.32514648437504
								],
								[
									143.3321289062502,
									42.22036132812511
								],
								[
									143.32714843749994,
									42.15102539062508
								],
								[
									143.31367187500007,
									42.084326171875006
								],
								[
									143.27871093750014,
									42.03784179687494
								],
								[
									143.23652343750018,
									42.00019531250001
								],
								[
									143.11171875000014,
									42.02221679687506
								],
								[
									142.90634765625003,
									42.11835937500001
								],
								[
									142.50820312500002,
									42.25795898437494
								],
								[
									142.0878906250001,
									42.471728515625045
								],
								[
									141.85136718750016,
									42.57905273437498
								],
								[
									141.40664062500014,
									42.54692382812502
								],
								[
									140.9861328125,
									42.34213867187495
								],
								[
									140.9484375,
									42.35957031250004
								],
								[
									140.78759765624994,
									42.50000000000006
								],
								[
									140.709765625,
									42.55561523437501
								],
								[
									140.6167968750001,
									42.57133789062502
								],
								[
									140.54765625,
									42.5695312500001
								],
								[
									140.4804687500001,
									42.559375000000074
								],
								[
									140.38544921875018,
									42.487158203125006
								],
								[
									140.3505859375001,
									42.435107421875045
								],
								[
									140.32353515625,
									42.37607421875012
								],
								[
									140.315234375,
									42.334277343750045
								],
								[
									140.3266601562501,
									42.29335937500005
								],
								[
									140.41660156250003,
									42.2007324218751
								],
								[
									140.52753906250018,
									42.13178710937507
								],
								[
									140.5777343750002,
									42.11865234375006
								],
								[
									140.68427734375007,
									42.12348632812498
								],
								[
									140.73378906250002,
									42.11635742187505
								],
								[
									140.91230468750007,
									41.97778320312497
								],
								[
									141.10771484375016,
									41.84804687500011
								],
								[
									141.1509765625002,
									41.80507812500005
								],
								[
									141.0787109375002,
									41.759814453125074
								],
								[
									140.99951171874994,
									41.73740234375012
								],
								[
									140.90751953125016,
									41.74326171874998
								],
								[
									140.81640624999994,
									41.76040039062508
								],
								[
									140.65986328125007,
									41.815576171874966
								],
								[
									140.59296875000018,
									41.76855468749997
								],
								[
									140.48916015625002,
									41.672167968750045
								],
								[
									140.4316406250001,
									41.56738281250003
								],
								[
									140.38496093750018,
									41.519287109375
								],
								[
									140.27011718750003,
									41.45600585937498
								],
								[
									140.14863281250018,
									41.423242187499966
								],
								[
									140.08515625,
									41.43408203125006
								],
								[
									140.03662109375,
									41.473779296874966
								],
								[
									140.00917968750002,
									41.52133789062506
								],
								[
									139.9953125,
									41.576416015625
								],
								[
									140.02128906250016,
									41.69575195312507
								],
								[
									140.08417968750018,
									41.80322265625003
								],
								[
									140.10839843749994,
									41.91293945312509
								],
								[
									140.0568359375,
									42.06733398437501
								],
								[
									140.02412109375,
									42.0995605468751
								],
								[
									139.8951171875002,
									42.190039062500034
								],
								[
									139.83544921874994,
									42.27807617187503
								],
								[
									139.8208984375002,
									42.387597656249966
								],
								[
									139.82851562500014,
									42.44814453125005
								],
								[
									139.86015625,
									42.5817382812501
								],
								[
									139.8911132812501,
									42.649218750000074
								],
								[
									139.95058593750014,
									42.671435546875074
								],
								[
									140.01503906250014,
									42.68476562500004
								],
								[
									140.11464843749997,
									42.73295898437499
								],
								[
									140.2241210937501,
									42.795507812500034
								],
								[
									140.32861328125,
									42.866845703124994
								],
								[
									140.4322265625002,
									42.954101562500085
								],
								[
									140.48642578125003,
									43.04990234375006
								],
								[
									140.39746093749994,
									43.16733398437512
								],
								[
									140.37929687500002,
									43.23710937499993
								],
								[
									140.3923828125,
									43.303124999999966
								],
								[
									140.4869140625001,
									43.3381835937501
								],
								[
									140.5845703125001,
									43.31171875000004
								],
								[
									140.78066406250014,
									43.21499023437505
								],
								[
									140.81914062500016,
									43.205468749999966
								],
								[
									140.95380859375018,
									43.200976562500045
								],
								[
									141.13818359374994,
									43.179931640625085
								],
								[
									141.24501953124997,
									43.185058593750085
								],
								[
									141.29628906250014,
									43.19965820312504
								],
								[
									141.3741210937501,
									43.27963867187498
								],
								[
									141.4123046875,
									43.38149414062505
								],
								[
									141.39833984375014,
									43.51249999999999
								],
								[
									141.39765625000018,
									43.642626953125045
								],
								[
									141.44677734374994,
									43.74863281250006
								],
								[
									141.60068359375003,
									43.91899414062502
								],
								[
									141.64472656250007,
									44.01943359375005
								],
								[
									141.66083984375007,
									44.26362304687498
								],
								[
									141.71630859375,
									44.37119140625006
								],
								[
									141.76093750000018,
									44.48251953125009
								],
								[
									141.7822265625,
									44.71635742187493
								],
								[
									141.71904296875,
									44.94106445312505
								],
								[
									141.65576171875,
									45.05122070312504
								],
								[
									141.5830078125001,
									45.15595703125007
								],
								[
									141.59374999999994,
									45.25595703125009
								],
								[
									141.65253906250007,
									45.34863281250006
								],
								[
									141.65400390625018,
									45.37656250000006
								],
								[
									141.66796875,
									45.40126953124994
								],
								[
									141.77812500000016,
									45.41889648437507
								],
								[
									141.82949218750014,
									45.43876953125002
								],
								[
									141.87871093750005,
									45.48330078125005
								],
								[
									141.93769531250007,
									45.50952148437506
								],
								[
									141.98085937500014,
									45.48349609375009
								],
								[
									142.01640625,
									45.43793945312504
								],
								[
									142.17158203125018,
									45.32563476562498
								],
								[
									142.416015625,
									45.12500000000006
								],
								[
									142.70410156249994,
									44.81918945312509
								],
								[
									142.884765625,
									44.670117187499926
								],
								[
									143.07509765625014,
									44.534912109375085
								],
								[
									143.2885742187501,
									44.396630859374994
								],
								[
									143.5119140625,
									44.27753906250007
								],
								[
									143.65458984375016,
									44.22133789062508
								],
								[
									143.75908203125005,
									44.1316406250001
								],
								[
									143.8243164062502,
									44.116992187500045
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "JPN",
					"su_a3": "JPN",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "JPN",
					"gu_a3": "JPN",
					"abbrev": "Japan",
					"region_un": "Asia",
					"adm0_a3_us": "JPN",
					"scalerank": 1,
					"pop_est": 127078679,
					"adm0_dif": 0,
					"un_a3": "392",
					"pop_year": -99,
					"gdp_md_est": 4329000,
					"name": "Japan",
					"sovereignt": "Japan",
					"economy": "1. Developed region: G7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Japan",
					"postal": "J",
					"sov_a3": "JPN",
					"note_brk": "",
					"brk_a3": "JPN",
					"wb_a2": "JP",
					"brk_diff": 0,
					"admin": "Japan",
					"name_long": "Japan",
					"iso_a3": "JPN",
					"iso_a2": "JP",
					"adm0_a3_is": "JPN",
					"level": 2,
					"formal_en": "Japan",
					"name_len": 5,
					"mapcolor7": 5,
					"long_len": 5,
					"mapcolor8": 3,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "392",
					"homepart": 1,
					"subunit": "Japan",
					"name_alt": "",
					"brk_name": "Japan",
					"name_sort": "Japan",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									50.184472656249966,
									44.85463867187505
								],
								[
									50.14873046875016,
									44.82646484374999
								],
								[
									50.095312500000034,
									44.830615234375045
								],
								[
									49.995117187500114,
									44.93696289062504
								],
								[
									50.023046875000034,
									45.044726562500045
								],
								[
									50.05937500000016,
									45.06679687500011
								],
								[
									50.10986328124994,
									45.08193359375008
								],
								[
									50.11660156250002,
									45.05825195312505
								],
								[
									50.045312500000136,
									45.010009765625085
								],
								[
									50.03886718750016,
									44.94912109375002
								],
								[
									50.09814453125,
									44.881542968749926
								],
								[
									50.184472656249966,
									44.85463867187505
								]
							]
						],
						[
							[
								[
									50.31171875000007,
									44.97207031250008
								],
								[
									50.277246093750136,
									44.95859375000009
								],
								[
									50.25615234374999,
									45.02241210937504
								],
								[
									50.294921875000114,
									45.075927734375
								],
								[
									50.34970703125009,
									45.08300781250003
								],
								[
									50.33085937500016,
									44.99843749999994
								],
								[
									50.31171875000007,
									44.97207031250008
								]
							]
						],
						[
							[
								[
									52.682421875000045,
									45.411816406249955
								],
								[
									52.66484374999999,
									45.40131835937504
								],
								[
									52.59833984375007,
									45.4281738281251
								],
								[
									52.554296875000034,
									45.473974609375006
								],
								[
									52.60888671875,
									45.52802734375001
								],
								[
									52.65957031250002,
									45.518066406250114
								],
								[
									52.692968750000034,
									45.460742187500074
								],
								[
									52.682421875000045,
									45.411816406249955
								]
							]
						],
						[
							[
								[
									59.434514017608365,
									45.142967387612714
								],
								[
									59.35957031250001,
									45.178613281249966
								],
								[
									59.221484375000045,
									45.24443359374996
								],
								[
									59.083398437499966,
									45.31020507812505
								],
								[
									58.94511718750016,
									45.37597656250003
								],
								[
									58.807031249999966,
									45.44179687499994
								],
								[
									58.74845301683462,
									45.46969817629909
								],
								[
									58.76015625000002,
									45.48955078124999
								],
								[
									58.82285156250009,
									45.54916992187506
								],
								[
									58.91093749999999,
									45.60502929687496
								],
								[
									58.96054687500009,
									45.66831054687498
								],
								[
									58.97187500000001,
									45.739111328125034
								],
								[
									58.99042968750007,
									45.776953125000006
								],
								[
									59.01650390625002,
									45.78193359375004
								],
								[
									59.02890625000009,
									45.76323242187496
								],
								[
									59.02763671874999,
									45.721093749999994
								],
								[
									59.035742187500034,
									45.69746093750007
								],
								[
									59.05312500000002,
									45.69252929687502
								],
								[
									59.07480468750009,
									45.721093749999994
								],
								[
									59.10097656250002,
									45.78315429687501
								],
								[
									59.129492187500034,
									45.804833984374994
								],
								[
									59.160449218750045,
									45.786230468750034
								],
								[
									59.22070312500006,
									45.70429687500004
								],
								[
									59.25664062499999,
									45.67207031250004
								],
								[
									59.29892578125009,
									45.65590820312502
								],
								[
									59.32314453125008,
									45.62797851562502
								],
								[
									59.32929687500007,
									45.588232421875006
								],
								[
									59.347949218750045,
									45.568994140624994
								],
								[
									59.37890625000006,
									45.57026367187498
								],
								[
									59.392578125,
									45.537988281249994
								],
								[
									59.38886718750001,
									45.47216796875
								],
								[
									59.40498046875001,
									45.39399414062507
								],
								[
									59.44101562500009,
									45.303369140624966
								],
								[
									59.454687500000034,
									45.22700195312504
								],
								[
									59.44599609375001,
									45.16494140625002
								],
								[
									59.434514017608365,
									45.142967387612714
								]
							]
						],
						[
							[
								[
									87.3228515625002,
									49.08579101562498
								],
								[
									87.22998046875011,
									49.10585937500008
								],
								[
									87.04853515625018,
									49.1099121093751
								],
								[
									86.93798828124994,
									49.09755859375005
								],
								[
									86.88593750000018,
									49.09057617187497
								],
								[
									86.80830078125018,
									49.049707031249994
								],
								[
									86.75312500000001,
									49.00883789062493
								],
								[
									86.7286132812502,
									48.93935546875008
								],
								[
									86.75781250000011,
									48.86074218750005
								],
								[
									86.71796875000018,
									48.69716796874994
								],
								[
									86.66376953125007,
									48.635546875000074
								],
								[
									86.5494140625002,
									48.528613281250074
								],
								[
									86.48330078125014,
									48.50537109374994
								],
								[
									86.37255859374994,
									48.48623046875005
								],
								[
									86.26562500000011,
									48.45454101562498
								],
								[
									86.05615234375,
									48.42373046875011
								],
								[
									85.82988281250016,
									48.40805664062509
								],
								[
									85.74941406250002,
									48.385058593750045
								],
								[
									85.69218750000016,
									48.311816406250045
								],
								[
									85.65156250000007,
									48.25053710937499
								],
								[
									85.62636718749997,
									48.20400390625011
								],
								[
									85.56230468749999,
									48.051855468750006
								],
								[
									85.52597656250003,
									47.91562500000006
								],
								[
									85.5616210937502,
									47.746484374999966
								],
								[
									85.58828125000014,
									47.55849609375005
								],
								[
									85.58662109375018,
									47.49365234374997
								],
								[
									85.64179687500001,
									47.3974121093751
								],
								[
									85.66982421875014,
									47.33837890625006
								],
								[
									85.65664062500014,
									47.25463867187506
								],
								[
									85.5772460937502,
									47.18847656249997
								],
								[
									85.52968750000002,
									47.10078125000004
								],
								[
									85.48476562500002,
									47.06352539062502
								],
								[
									85.35537109375014,
									47.04672851562506
								],
								[
									85.23349609375009,
									47.036376953125085
								],
								[
									85.11054687500018,
									46.961230468750045
								],
								[
									85.01220703125011,
									46.90922851562493
								],
								[
									84.85820312499999,
									46.843164062499966
								],
								[
									84.78613281249994,
									46.83071289062511
								],
								[
									84.74599609375014,
									46.86435546875012
								],
								[
									84.71953125000016,
									46.93935546874994
								],
								[
									84.66660156250003,
									46.9723632812501
								],
								[
									84.59228515625011,
									46.97495117187509
								],
								[
									84.53242187500007,
									46.97578124999998
								],
								[
									84.3388671875,
									46.99614257812496
								],
								[
									84.21513671875016,
									46.994726562500034
								],
								[
									84.12207031249994,
									46.978613281250034
								],
								[
									84.01601562500002,
									46.970507812500074
								],
								[
									83.83261718750003,
									46.997851562500045
								],
								[
									83.7139648437502,
									47.021044921875074
								],
								[
									83.63408203124999,
									47.04321289062506
								],
								[
									83.44355468750018,
									47.10864257812506
								],
								[
									83.19306640625007,
									47.186572265625045
								],
								[
									83.09033203125,
									47.209374999999966
								],
								[
									83.02949218750001,
									47.185937499999994
								],
								[
									83.02011718750009,
									47.14145507812509
								],
								[
									83.00410156250018,
									47.03349609374993
								],
								[
									82.97490234374999,
									46.966015624999955
								],
								[
									82.80000000000018,
									46.6244628906251
								],
								[
									82.69218750000016,
									46.38666992187504
								],
								[
									82.55507812500002,
									46.15869140624997
								],
								[
									82.51171874999994,
									46.0058105468751
								],
								[
									82.42968749999994,
									45.81191406250002
								],
								[
									82.34814453124994,
									45.67153320312502
								],
								[
									82.31523437499999,
									45.594921874999955
								],
								[
									82.31220703125018,
									45.563720703125085
								],
								[
									82.32666015625011,
									45.51992187500005
								],
								[
									82.45166015625,
									45.471972656250045
								],
								[
									82.58251953125011,
									45.44257812500001
								],
								[
									82.61162109375016,
									45.42426757812501
								],
								[
									82.62578125000005,
									45.37441406250005
								],
								[
									82.62109374999994,
									45.29311523437502
								],
								[
									82.59697265625005,
									45.21596679687494
								],
								[
									82.55898437500002,
									45.15541992187502
								],
								[
									82.52148437500011,
									45.12548828124997
								],
								[
									82.47871093750018,
									45.123583984375045
								],
								[
									82.39667968750018,
									45.162451171875034
								],
								[
									82.32343750000018,
									45.2058593750001
								],
								[
									82.26660156249994,
									45.21909179687495
								],
								[
									82.12275390625007,
									45.19487304687499
								],
								[
									81.98925781250011,
									45.161865234375114
								],
								[
									81.94492187500003,
									45.16083984374998
								],
								[
									81.86748046874999,
									45.182080078124955
								],
								[
									81.7896484375002,
									45.22602539062504
								],
								[
									81.75888671875009,
									45.31083984374999
								],
								[
									81.6919921875002,
									45.34936523437503
								],
								[
									81.60205078125011,
									45.31083984374999
								],
								[
									81.33476562499999,
									45.24619140625006
								],
								[
									81.04033203125016,
									45.16914062499998
								],
								[
									80.85332031250016,
									45.12929687500005
								],
								[
									80.78007812500016,
									45.135546875000074
								],
								[
									80.63476562500011,
									45.1265136718751
								],
								[
									80.50917968750014,
									45.10498046874997
								],
								[
									80.41494140625002,
									45.07509765625011
								],
								[
									80.22822265625018,
									45.03398437499999
								],
								[
									80.0591796875002,
									45.00644531250006
								],
								[
									79.95019531250011,
									44.94409179687497
								],
								[
									79.87187500000016,
									44.88378906249994
								],
								[
									79.87529296875005,
									44.86083984374997
								],
								[
									79.93212890625,
									44.825195312500085
								],
								[
									79.99716796875009,
									44.79721679687498
								],
								[
									80.12783203125014,
									44.803759765625074
								],
								[
									80.25507812500007,
									44.80810546874997
								],
								[
									80.36083984375011,
									44.7703125000001
								],
								[
									80.45546875000002,
									44.74609375000006
								],
								[
									80.48154296875009,
									44.714648437500045
								],
								[
									80.45546875000002,
									44.68408203125003
								],
								[
									80.40058593750001,
									44.67690429687508
								],
								[
									80.3814453125002,
									44.65541992187505
								],
								[
									80.39101562500014,
									44.62680664062509
								],
								[
									80.35507812500009,
									44.55200195312503
								],
								[
									80.33632812499997,
									44.438378906249966
								],
								[
									80.35488281250014,
									44.326513671875006
								],
								[
									80.3653320312502,
									44.22329101562494
								],
								[
									80.35898437500009,
									44.17128906250008
								],
								[
									80.35527343750005,
									44.09726562500012
								],
								[
									80.39580078125005,
									44.04716796875002
								],
								[
									80.43154296875014,
									43.95175781249995
								],
								[
									80.49599609375002,
									43.89208984375006
								],
								[
									80.59345703125007,
									43.68510742187499
								],
								[
									80.65078125000002,
									43.56416015625004
								],
								[
									80.70380859375018,
									43.42705078124999
								],
								[
									80.66542968749997,
									43.3529785156251
								],
								[
									80.66777343749999,
									43.31005859375006
								],
								[
									80.72978515625005,
									43.27426757812495
								],
								[
									80.75703125000018,
									43.204345703125085
								],
								[
									80.78574218750003,
									43.1615722656251
								],
								[
									80.77773437500014,
									43.11894531249993
								],
								[
									80.75117187500001,
									43.102490234374955
								],
								[
									80.61699218750016,
									43.12827148437506
								],
								[
									80.50703125000001,
									43.08579101562509
								],
								[
									80.39023437500003,
									43.04311523437494
								],
								[
									80.37451171874994,
									43.02041015625002
								],
								[
									80.37128906250018,
									42.99560546875003
								],
								[
									80.38339843750009,
									42.97377929687502
								],
								[
									80.45068359375011,
									42.93554687500006
								],
								[
									80.54375000000016,
									42.91171875000009
								],
								[
									80.53896484375014,
									42.873486328124926
								],
								[
									80.42402343750018,
									42.85576171874996
								],
								[
									80.25029296875016,
									42.79726562499994
								],
								[
									80.2022460937502,
									42.734472656250034
								],
								[
									80.1650390625,
									42.665527343750114
								],
								[
									80.16191406250016,
									42.625537109375045
								],
								[
									80.17929687500003,
									42.51835937499996
								],
								[
									80.20576171875001,
									42.39941406250006
								],
								[
									80.25507812500007,
									42.27416992187506
								],
								[
									80.25908203125016,
									42.23540039062496
								],
								[
									80.23300781250009,
									42.20781249999993
								],
								[
									80.20937500000014,
									42.190039062500034
								],
								[
									80.0712890625,
									42.30297851562506
								],
								[
									79.92109375000001,
									42.41313476562502
								],
								[
									79.80341796875007,
									42.43847656250003
								],
								[
									79.59843750000005,
									42.456640625000006
								],
								[
									79.49013671875008,
									42.45756835937502
								],
								[
									79.42822265625,
									42.48349609375006
								],
								[
									79.36777343750009,
									42.54721679687498
								],
								[
									79.29550781250003,
									42.60483398437509
								],
								[
									79.20302734375014,
									42.66601562500003
								],
								[
									79.16484375000005,
									42.75903320312497
								],
								[
									79.12666015625013,
									42.77573242187509
								],
								[
									79.05986328124999,
									42.763818359374966
								],
								[
									78.94794921875001,
									42.76669921875012
								],
								[
									78.88515625000002,
									42.77490234375
								],
								[
									78.79150390625011,
									42.79082031249996
								],
								[
									78.64228515625013,
									42.828710937500034
								],
								[
									78.52421875000005,
									42.864648437499994
								],
								[
									78.37597656250011,
									42.871484374999966
								],
								[
									78.29003906250011,
									42.86435546875012
								],
								[
									78.02314453125007,
									42.85751953125006
								],
								[
									77.80166015625008,
									42.8952148437501
								],
								[
									77.62246093750008,
									42.90224609375011
								],
								[
									77.51220703125011,
									42.90004882812511
								],
								[
									77.45927734375016,
									42.90473632812498
								],
								[
									77.36855468750014,
									42.90444335937502
								],
								[
									77.23554687500001,
									42.9126464843751
								],
								[
									77.05732421875007,
									42.97065429687501
								],
								[
									76.98808593750005,
									42.97358398437498
								],
								[
									76.94404296875018,
									42.971484375000074
								],
								[
									76.64648437500011,
									42.928808593750006
								],
								[
									76.50917968750014,
									42.91889648437504
								],
								[
									76.21816406250008,
									42.92373046875005
								],
								[
									75.93222656250009,
									42.928515625000045
								],
								[
									75.84033203125011,
									42.9375
								],
								[
									75.78955078125006,
									42.932910156250045
								],
								[
									75.68173828125003,
									42.83046875000005
								],
								[
									75.63564453125014,
									42.81459960937511
								],
								[
									75.36621093750006,
									42.836962890625045
								],
								[
									75.0476562500001,
									42.904394531250006
								],
								[
									74.81757812500013,
									42.97817382812502
								],
								[
									74.62226562500013,
									43.05620117187502
								],
								[
									74.36386718750003,
									43.179443359375
								],
								[
									74.20908203125003,
									43.24038085937508
								],
								[
									74.18681640625005,
									43.20527343750001
								],
								[
									74.14589843750014,
									43.19409179687506
								],
								[
									74.08623046875016,
									43.18862304687508
								],
								[
									73.94921875000011,
									43.19501953125007
								],
								[
									73.88603515625005,
									43.13256835937503
								],
								[
									73.71855468750005,
									43.087890625
								],
								[
									73.61201171875018,
									43.04790039062502
								],
								[
									73.55625000000009,
									43.00278320312498
								],
								[
									73.45019531250006,
									42.70302734375002
								],
								[
									73.42187500000006,
									42.593505859375
								],
								[
									73.49296875000005,
									42.40903320312506
								],
								[
									73.41162109375011,
									42.419775390625034
								],
								[
									73.31601562500009,
									42.46699218749998
								],
								[
									73.28291015625007,
									42.50410156250007
								],
								[
									73.19082031250008,
									42.526855468750085
								],
								[
									72.85507812500003,
									42.56113281249998
								],
								[
									72.79238281250008,
									42.60346679687498
								],
								[
									72.75292968750011,
									42.63789062499998
								],
								[
									72.66611328125003,
									42.66040039062503
								],
								[
									72.54316406250001,
									42.677734375000114
								],
								[
									72.27578125000008,
									42.757666015625034
								],
								[
									72.16181640625007,
									42.76069335937504
								],
								[
									71.81679687500002,
									42.82216796875005
								],
								[
									71.76054687499999,
									42.82148437500007
								],
								[
									71.73476562500008,
									42.818896484375074
								],
								[
									71.60078125000007,
									42.77866210937506
								],
								[
									71.51425781250009,
									42.76694335937498
								],
								[
									71.42207031250007,
									42.7831542968751
								],
								[
									71.25664062500005,
									42.73354492187502
								],
								[
									71.16738281250014,
									42.66743164062504
								],
								[
									71.09355468749999,
									42.58652343750009
								],
								[
									71.02275390625005,
									42.535449218750074
								],
								[
									71.00195312500011,
									42.45908203125006
								],
								[
									70.95234375000001,
									42.41938476562504
								],
								[
									70.89287109375005,
									42.33999023437505
								],
								[
									70.89287109375005,
									42.29370117187503
								],
								[
									70.94677734374994,
									42.24868164062508
								],
								[
									70.86035156250011,
									42.2072265625001
								],
								[
									70.76455078125014,
									42.194189453125006
								],
								[
									70.71523437500014,
									42.168652343749955
								],
								[
									70.66250000000014,
									42.10747070312502
								],
								[
									70.61328124999994,
									42.05473632812502
								],
								[
									70.58427734374999,
									42.03603515624994
								],
								[
									70.54013671875009,
									42.03945312500011
								],
								[
									70.48906250000016,
									42.08027343750007
								],
								[
									70.41601562500011,
									42.07856445312498
								],
								[
									70.32890625000005,
									42.02797851562508
								],
								[
									70.22587890625016,
									41.94599609375007
								],
								[
									70.09560546875002,
									41.82050781250007
								],
								[
									69.9599609375,
									41.75405273437505
								],
								[
									69.7880859375,
									41.69731445312502
								],
								[
									69.66386718750016,
									41.67211914062506
								],
								[
									69.56513671875001,
									41.62905273437508
								],
								[
									69.40097656250009,
									41.54189453125008
								],
								[
									69.36835937500018,
									41.490576171875006
								],
								[
									69.24931640625016,
									41.46025390624996
								],
								[
									69.15361328125005,
									41.42524414062501
								],
								[
									69.06494140625011,
									41.36694335937506
								],
								[
									69.04345703125,
									41.26411132812507
								],
								[
									68.98691406250009,
									41.205029296874926
								],
								[
									68.85117187500003,
									41.12382812499999
								],
								[
									68.73710937499999,
									41.041894531249994
								],
								[
									68.66279296875007,
									40.96152343750006
								],
								[
									68.58408203125009,
									40.8762695312501
								],
								[
									68.55927734375018,
									40.82929687500004
								],
								[
									68.55654296874997,
									40.765136718750114
								],
								[
									68.59365234375002,
									40.71127929687506
								],
								[
									68.60068359375009,
									40.65996093749999
								],
								[
									68.57265624999997,
									40.622656250000034
								],
								[
									68.49570312500003,
									40.608642578125114
								],
								[
									68.41503906250011,
									40.61943359374999
								],
								[
									68.29189453124997,
									40.656103515625006
								],
								[
									68.16025390625009,
									40.72177734375006
								],
								[
									68.1123046875,
									40.75405273437505
								],
								[
									68.04765625000016,
									40.80927734375004
								],
								[
									68.05703125000002,
									40.860595703125085
								],
								[
									68.09033203124994,
									40.960253906250074
								],
								[
									68.11308593750016,
									41.028613281250045
								],
								[
									68.05937500000005,
									41.06127929687494
								],
								[
									68.01972656250007,
									41.09624023437496
								],
								[
									67.99140625000007,
									41.13002929687511
								],
								[
									67.93574218750018,
									41.196582031250074
								],
								[
									67.86572265625011,
									41.180273437500034
								],
								[
									67.80507812500002,
									41.16391601562506
								],
								[
									67.73505859375007,
									41.18725585937494
								],
								[
									67.52802734375007,
									41.17714843750002
								],
								[
									67.37158203125,
									41.16953124999998
								],
								[
									67.22500000000014,
									41.16235351562503
								],
								[
									67.03867187500003,
									41.15332031250006
								],
								[
									66.81425781250005,
									41.142382812500045
								],
								[
									66.74980468750016,
									41.15708007812509
								],
								[
									66.70966796875007,
									41.17915039062498
								],
								[
									66.66865234375007,
									41.270751953125085
								],
								[
									66.64531249999999,
									41.34863281250006
								],
								[
									66.60166015625009,
									41.49433593750007
								],
								[
									66.57255859374999,
									41.60698242187502
								],
								[
									66.53789062500016,
									41.74125976562502
								],
								[
									66.51503906250002,
									41.889404296875085
								],
								[
									66.49863281250003,
									41.994873046875085
								],
								[
									66.32880859375018,
									41.998339843750074
								],
								[
									66.19316406250016,
									42.00112304687502
								],
								[
									66.00957031250016,
									42.004882812500085
								],
								[
									66.01123046874994,
									42.08876953125002
								],
								[
									66.01318359375011,
									42.19448242187505
								],
								[
									66.01552734375014,
									42.31479492187506
								],
								[
									66.04980468750011,
									42.47275390625009
								],
								[
									66.06269531250007,
									42.60517578125007
								],
								[
									66.07851562499997,
									42.76665039062502
								],
								[
									66.08886718749994,
									42.87338867187509
								],
								[
									66.10029296875018,
									42.990820312500034
								],
								[
									66.00566406250016,
									42.954589843750114
								],
								[
									65.90107421875018,
									42.91450195312501
								],
								[
									65.80302734374999,
									42.876953125000114
								],
								[
									65.73564453125005,
									42.97211914062504
								],
								[
									65.67021484375005,
									43.06459960937505
								],
								[
									65.57070312500002,
									43.20517578125009
								],
								[
									65.49619140625009,
									43.31054687499997
								],
								[
									65.36650390625016,
									43.37202148437507
								],
								[
									65.27050781249994,
									43.4175292968751
								],
								[
									65.17089843750011,
									43.49418945312499
								],
								[
									65.08486328125014,
									43.57368164062501
								],
								[
									65.00312500000018,
									43.64907226562502
								],
								[
									64.90546875000018,
									43.71469726562498
								],
								[
									64.81181640625005,
									43.693945312500006
								],
								[
									64.7060546875,
									43.65297851562511
								],
								[
									64.60410156250009,
									43.613476562499955
								],
								[
									64.49609375000011,
									43.57163085937506
								],
								[
									64.44316406250016,
									43.551171874999966
								],
								[
									64.31816406249999,
									43.55893554687495
								],
								[
									64.20878906249999,
									43.5657226562501
								],
								[
									64.01328125000003,
									43.57783203124998
								],
								[
									63.84814453125,
									43.58813476562494
								],
								[
									63.67968749999994,
									43.59863281250006
								],
								[
									63.44482421875,
									43.6132324218751
								],
								[
									63.207031250000114,
									43.627978515625074
								],
								[
									63.04765625000016,
									43.608496093750006
								],
								[
									62.84619140624994,
									43.583886718749966
								],
								[
									62.63447265625018,
									43.55800781249994
								],
								[
									62.459375000000136,
									43.53662109375003
								],
								[
									62.237890625000034,
									43.50957031249993
								],
								[
									62.07197265625018,
									43.48935546875006
								],
								[
									61.990234375000114,
									43.492138671874926
								],
								[
									61.887597656249966,
									43.57724609374995
								],
								[
									61.72324218750009,
									43.713574218749926
								],
								[
									61.623632812500034,
									43.796191406250045
								],
								[
									61.525878906250114,
									43.87719726562503
								],
								[
									61.38505859374999,
									43.99394531249993
								],
								[
									61.27148437499994,
									44.082275390625085
								],
								[
									61.160742187500034,
									44.16860351562508
								],
								[
									61.097070312500136,
									44.248242187499955
								],
								[
									61.065332031249966,
									44.34838867187503
								],
								[
									61.00791015625009,
									44.39379882812494
								],
								[
									60.87919921875016,
									44.455078125
								],
								[
									60.74111328125002,
									44.52084960937506
								],
								[
									60.60292968750002,
									44.58662109375007
								],
								[
									60.46474609375002,
									44.65244140625006
								],
								[
									60.32666015624994,
									44.718212890624955
								],
								[
									60.18847656249994,
									44.783984375000045
								],
								[
									60.05531302875323,
									44.84736645272321
								],
								[
									60.063281250000045,
									45.201904296875
								],
								[
									60.07763671875,
									45.31049804687501
								],
								[
									60.06855468750001,
									45.41689453125002
								],
								[
									60.036230468750034,
									45.52119140625004
								],
								[
									60.00029296874999,
									45.57768554687499
								],
								[
									59.960546875000034,
									45.58642578125
								],
								[
									59.76894531250002,
									45.57939453124999
								],
								[
									59.74492187499999,
									45.59101562500004
								],
								[
									59.73388671875,
									45.61884765625004
								],
								[
									59.73574218750002,
									45.662890625000045
								],
								[
									59.74726562500007,
									45.69614257812506
								],
								[
									59.768652343750034,
									45.71855468750002
								],
								[
									59.78212890625002,
									45.764257812500006
								],
								[
									59.79267578125007,
									45.77788085937502
								],
								[
									59.80595703124999,
									45.784521484375034
								],
								[
									59.81835937500006,
									45.79584960937504
								],
								[
									59.82333984375009,
									45.8349609375
								],
								[
									59.84199218750007,
									45.85791015624997
								],
								[
									59.84160156249999,
									45.86972656249998
								],
								[
									59.832617187500034,
									45.885888671874994
								],
								[
									59.82929687500007,
									45.90229492187504
								],
								[
									59.84726562500009,
									45.914697265624994
								],
								[
									59.88261718749999,
									45.92060546875004
								],
								[
									59.93535156249999,
									45.91997070312502
								],
								[
									60.31601562500009,
									45.86323242187498
								],
								[
									60.41689453125002,
									45.848291015624966
								],
								[
									60.45693359375002,
									45.87192382812498
								],
								[
									60.50253906250009,
									45.92680664062499
								],
								[
									60.57021484375002,
									45.972021484375034
								],
								[
									60.65966796875,
									46.007470703124994
								],
								[
									60.72949218750006,
									46.05083007812502
								],
								[
									60.77949218750001,
									46.102148437500006
								],
								[
									60.835058593750034,
									46.13178710937498
								],
								[
									60.8779296875,
									46.137353515624966
								],
								[
									61.130468750000034,
									46.22983398437498
								],
								[
									61.17744140625001,
									46.23046875000003
								],
								[
									61.22324218750009,
									46.27001953125
								],
								[
									61.26777343750001,
									46.348486328125006
								],
								[
									61.28154296874999,
									46.40727539062499
								],
								[
									61.264453125000045,
									46.44648437499998
								],
								[
									61.22792968750008,
									46.46284179687504
								],
								[
									61.17167968749999,
									46.45654296875
								],
								[
									61.07509765625002,
									46.46552734375004
								],
								[
									60.93808593750009,
									46.489843750000034
								],
								[
									60.84619140625,
									46.52436523437504
								],
								[
									60.79941406250009,
									46.568994140624994
								],
								[
									60.78310546875002,
									46.63266601562498
								],
								[
									60.79726562500008,
									46.715478515624994
								],
								[
									60.743945312500045,
									46.764990234375034
								],
								[
									60.623046875,
									46.78129882812499
								],
								[
									60.57021484375002,
									46.77788085937499
								],
								[
									60.58515625000001,
									46.754785156249994
								],
								[
									60.63779296875009,
									46.720800781250006
								],
								[
									60.72802734375,
									46.67602539062503
								],
								[
									60.72568359375009,
									46.625830078125006
								],
								[
									60.65117187499999,
									46.58906249999998
								],
								[
									60.60449218750006,
									46.57807617187507
								],
								[
									60.55458984375002,
									46.58564453125001
								],
								[
									60.50117187500007,
									46.61176757812498
								],
								[
									60.459570312500034,
									46.592822265625045
								],
								[
									60.4296875,
									46.52890624999998
								],
								[
									60.39628906249999,
									46.543066406250034
								],
								[
									60.35937500000006,
									46.63525390624997
								],
								[
									60.3173828125,
									46.68745117187504
								],
								[
									60.27050781250006,
									46.69970703125006
								],
								[
									60.18906250000009,
									46.67680664062502
								],
								[
									60.07304687499999,
									46.618798828124994
								],
								[
									60.00917968750002,
									46.56064453125006
								],
								[
									59.99765625000009,
									46.50239257812501
								],
								[
									60.02070312500007,
									46.44941406250004
								],
								[
									60.07871093750009,
									46.40175781250002
								],
								[
									60.17285156250006,
									46.38994140625002
								],
								[
									60.30292968750001,
									46.413916015625006
								],
								[
									60.39531249999999,
									46.40556640624999
								],
								[
									60.44980468750009,
									46.364990234375
								],
								[
									60.54775390625008,
									46.32255859374996
								],
								[
									60.58339843750002,
									46.326464843750045
								],
								[
									60.607519531250034,
									46.34902343750002
								],
								[
									60.68339843749999,
									46.381396484375045
								],
								[
									60.69599609375007,
									46.40068359374999
								],
								[
									60.7109375,
									46.407617187499966
								],
								[
									60.72832031249999,
									46.40229492187504
								],
								[
									60.74980468749999,
									46.353662109374994
								],
								[
									60.82255859374999,
									46.24316406250003
								],
								[
									60.82412109375002,
									46.21342773437502
								],
								[
									60.81191406250002,
									46.16865234375004
								],
								[
									60.72832031249999,
									46.10126953124998
								],
								[
									60.68496093750002,
									46.07841796874996
								],
								[
									60.65117187499999,
									46.07104492187506
								],
								[
									60.323535156250045,
									46.10278320312503
								],
								[
									60.23789062500009,
									46.09975585937505
								],
								[
									60.16474609375001,
									46.10834960937501
								],
								[
									60.104296875000045,
									46.12856445312505
								],
								[
									60.02871093750002,
									46.12299804687498
								],
								[
									59.86347656250001,
									46.07451171874996
								],
								[
									59.80488281250007,
									46.07133789062502
								],
								[
									59.787402343750045,
									46.088525390624966
								],
								[
									59.810839843750045,
									46.12607421874998
								],
								[
									59.8154296875,
									46.18139648437497
								],
								[
									59.80078125,
									46.25454101562505
								],
								[
									59.77890625000009,
									46.30146484375001
								],
								[
									59.74941406250002,
									46.322119140625034
								],
								[
									59.698828125000034,
									46.33129882812506
								],
								[
									59.57695312499999,
									46.33349609375006
								],
								[
									59.548828125,
									46.344775390625045
								],
								[
									59.53076171875,
									46.342675781249966
								],
								[
									59.52265625000001,
									46.32719726562502
								],
								[
									59.57167968750008,
									46.25859374999999
								],
								[
									59.677734375,
									46.13691406250007
								],
								[
									59.70576171875001,
									46.02211914062502
								],
								[
									59.65546875000001,
									45.91416015624998
								],
								[
									59.62841796875,
									45.83842773437502
								],
								[
									59.62470703125001,
									45.794970703125045
								],
								[
									59.59804687500002,
									45.77324218749996
								],
								[
									59.548437500000034,
									45.77324218749996
								],
								[
									59.499121093750034,
									45.75244140624997
								],
								[
									59.450000000000045,
									45.71083984375002
								],
								[
									59.42363281249999,
									45.70463867187502
								],
								[
									59.41992187500006,
									45.733789062499994
								],
								[
									59.40351562500001,
									45.749902343749994
								],
								[
									59.37431640624999,
									45.753027343750006
								],
								[
									59.35693359375,
									45.73505859374998
								],
								[
									59.351367187500045,
									45.69594726562502
								],
								[
									59.31855468750001,
									45.69423828125002
								],
								[
									59.2587890625,
									45.729833984375006
								],
								[
									59.23291015625006,
									45.77480468750002
								],
								[
									59.241015625000045,
									45.82915039062499
								],
								[
									59.271484375,
									45.88232421874997
								],
								[
									59.32392578125001,
									45.93437500000002
								],
								[
									59.33457031250009,
									45.974267578124966
								],
								[
									59.30322265625,
									46.002050781250034
								],
								[
									59.25898437500007,
									46.00146484375
								],
								[
									59.201757812500034,
									45.972460937500045
								],
								[
									59.140722656250034,
									45.95722656250004
								],
								[
									59.07587890625007,
									45.955712890624994
								],
								[
									58.98164062500001,
									45.97460937500003
								],
								[
									58.95742187500008,
									45.96821289062507
								],
								[
									58.9501953125,
									45.94233398437504
								],
								[
									58.92626953125,
									45.93227539062502
								],
								[
									58.88544921875007,
									45.93818359374998
								],
								[
									58.83388671875002,
									45.92578125000003
								],
								[
									58.771582031250034,
									45.89501953125
								],
								[
									58.720703125,
									45.84765625000003
								],
								[
									58.681250000000034,
									45.78364257812504
								],
								[
									58.65527343750006,
									45.715722656249966
								],
								[
									58.6279296875,
									45.600244140624966
								],
								[
									58.611328125,
									45.584716796875
								],
								[
									58.59036182976246,
									45.54061527930634
								],
								[
									58.555273437500034,
									45.55537109374998
								],
								[
									58.44941406250007,
									45.542919921874926
								],
								[
									58.291113281250034,
									45.50942382812502
								],
								[
									58.12519531250018,
									45.474365234375
								],
								[
									57.961035156250034,
									45.43969726562503
								],
								[
									57.66669921875018,
									45.37744140624997
								],
								[
									57.47734375000016,
									45.33745117187499
								],
								[
									57.32929687500001,
									45.30366210937504
								],
								[
									57.17167968750016,
									45.267724609374994
								],
								[
									56.96503906250007,
									45.220605468749994
								],
								[
									56.791894531250136,
									45.18105468750002
								],
								[
									56.588769531250136,
									45.134765625
								],
								[
									56.4091796875,
									45.0937988281251
								],
								[
									56.25791015625009,
									45.059326171875
								],
								[
									56.100488281250136,
									45.023388671874955
								],
								[
									55.975683593750034,
									44.99492187499993
								],
								[
									55.97578125000007,
									44.76538085937497
								],
								[
									55.97597656250002,
									44.535839843749926
								],
								[
									55.976074218750114,
									44.30629882812505
								],
								[
									55.976171875000034,
									44.07675781250012
								],
								[
									55.97626953125007,
									43.847216796875074
								],
								[
									55.97636718749999,
									43.61762695312501
								],
								[
									55.97646484375002,
									43.38808593750005
								],
								[
									55.976562500000114,
									43.15859375000011
								],
								[
									55.976660156250034,
									42.92905273437506
								],
								[
									55.97675781250018,
									42.69951171875002
								],
								[
									55.97685546874999,
									42.46997070312506
								],
								[
									55.976953125000136,
									42.24042968750001
								],
								[
									55.97705078124994,
									42.010888671874966
								],
								[
									55.97714843750009,
									41.781347656250006
								],
								[
									55.97734374999999,
									41.55175781250003
								],
								[
									55.977441406250136,
									41.3222167968751
								],
								[
									55.93496093750002,
									41.32412109374994
								],
								[
									55.83906250000018,
									41.31079101562497
								],
								[
									55.67861328125002,
									41.27880859374994
								],
								[
									55.54521484374999,
									41.26274414062496
								],
								[
									55.48701171875007,
									41.272265625000045
								],
								[
									55.43437500000016,
									41.29628906250005
								],
								[
									55.38837890625001,
									41.34692382812506
								],
								[
									55.319726562499966,
									41.40839843750007
								],
								[
									55.24960937500009,
									41.45810546875006
								],
								[
									55.16230468750007,
									41.5602539062501
								],
								[
									55.10185546874999,
									41.63872070312499
								],
								[
									54.95234375000018,
									41.81000976562498
								],
								[
									54.93164062499994,
									41.86401367187497
								],
								[
									54.903710937500136,
									41.91909179687508
								],
								[
									54.85380859374999,
									41.96518554687498
								],
								[
									54.67792968750007,
									42.078222656250006
								],
								[
									54.47285156250001,
									42.180175781250085
								],
								[
									54.271875000000136,
									42.27998046874998
								],
								[
									54.214941406250034,
									42.30419921874994
								],
								[
									54.12099609375002,
									42.33520507812506
								],
								[
									54.00517578125016,
									42.33588867187501
								],
								[
									53.92636718750009,
									42.32978515625001
								],
								[
									53.68535156250016,
									42.29687500000006
								],
								[
									53.50078125000016,
									42.2582519531251
								],
								[
									53.250097656250034,
									42.205859375000074
								],
								[
									53.05585937500018,
									42.14775390624996
								],
								[
									53.01250000000016,
									42.13071289062495
								],
								[
									52.870507812499966,
									42.06059570312496
								],
								[
									52.696875000000034,
									41.9443847656251
								],
								[
									52.49384765625018,
									41.78037109375006
								],
								[
									52.46757812500016,
									41.88588867187508
								],
								[
									52.45859375000009,
									42.04833984375006
								],
								[
									52.46210937500018,
									42.100634765625045
								],
								[
									52.517187500000034,
									42.23715820312506
								],
								[
									52.573242187500114,
									42.33085937499996
								],
								[
									52.61835937500007,
									42.428222656250085
								],
								[
									52.63847656250016,
									42.555664062500114
								],
								[
									52.596582031250136,
									42.76015625000002
								],
								[
									52.55000000000007,
									42.80546875000002
								],
								[
									52.49394531249999,
									42.82026367187501
								],
								[
									52.43427734375001,
									42.82446289062497
								],
								[
									52.32441406250001,
									42.81616210937497
								],
								[
									52.273046875000034,
									42.799804687500114
								],
								[
									52.183691406250034,
									42.868750000000034
								],
								[
									52.075585937500136,
									42.879785156249966
								],
								[
									52.01855468749994,
									42.860546874999955
								],
								[
									51.96074218749999,
									42.85058593749997
								],
								[
									51.89824218750016,
									42.86962890624994
								],
								[
									51.844140625000136,
									42.910449218750074
								],
								[
									51.81103515624994,
									42.95444335937509
								],
								[
									51.785156250000114,
									43.00434570312504
								],
								[
									51.70039062500018,
									43.1040527343751
								],
								[
									51.616015625000045,
									43.158447265625085
								],
								[
									51.514062500000136,
									43.17050781249995
								],
								[
									51.34785156250001,
									43.16738281249994
								],
								[
									51.29541015625,
									43.174121093750074
								],
								[
									51.29238281250002,
									43.23071289062506
								],
								[
									51.31337890625002,
									43.355664062499926
								],
								[
									51.313867187500136,
									43.42084960937507
								],
								[
									51.30175781249994,
									43.48237304687498
								],
								[
									51.27412109375018,
									43.53291015625007
								],
								[
									51.23896484375007,
									43.57670898437493
								],
								[
									51.13964843749994,
									43.648779296875034
								],
								[
									51.06484375000002,
									43.75014648437508
								],
								[
									50.939843750000136,
									43.9585449218751
								],
								[
									50.83076171875018,
									44.19277343749994
								],
								[
									50.782617187499966,
									44.228027343750114
								],
								[
									50.684960937499966,
									44.265087890624926
								],
								[
									50.47177734375009,
									44.29477539062512
								],
								[
									50.331152343750034,
									44.325488281250074
								],
								[
									50.27558593750007,
									44.35512695312505
								],
								[
									50.25253906250009,
									44.40649414062506
								],
								[
									50.2529296875,
									44.46152343749998
								],
								[
									50.264550781250136,
									44.5265625000001
								],
								[
									50.29746093750009,
									44.58154296875
								],
								[
									50.40947265625016,
									44.62402343750006
								],
								[
									50.65244140625009,
									44.63334960937499
								],
								[
									50.860351562500114,
									44.628759765625034
								],
								[
									51.048828125000114,
									44.53046875000007
								],
								[
									51.110742187500136,
									44.507812500000085
								],
								[
									51.177148437499966,
									44.50136718750011
								],
								[
									51.31074218750018,
									44.53242187500004
								],
								[
									51.37666015625001,
									44.541210937499955
								],
								[
									51.54355468750009,
									44.531005859375114
								],
								[
									51.49375000000009,
									44.57753906250008
								],
								[
									51.43105468750002,
									44.60195312500008
								],
								[
									51.366308593750034,
									44.599853515625
								],
								[
									51.31025390625018,
									44.61874999999995
								],
								[
									51.218164062499966,
									44.70898437499994
								],
								[
									51.05791015624999,
									44.811572265625074
								],
								[
									51.02070312500018,
									44.85400390625
								],
								[
									51.00937500000009,
									44.92182617187504
								],
								[
									51.04033203125016,
									44.98032226562498
								],
								[
									51.153710937499966,
									45.040234374999926
								],
								[
									51.249902343750136,
									45.12167968750009
								],
								[
									51.29404296875009,
									45.229785156250074
								],
								[
									51.33339843750002,
									45.27958984374993
								],
								[
									51.41572265625018,
									45.35786132812507
								],
								[
									51.539648437500034,
									45.342871093750034
								],
								[
									51.73261718750018,
									45.39946289062502
								],
								[
									52.048730468749966,
									45.38837890625007
								],
								[
									52.426757812500114,
									45.404638671875006
								],
								[
									52.531054687500045,
									45.39863281250001
								],
								[
									52.77197265625,
									45.343505859375085
								],
								[
									52.91074218750009,
									45.31972656249994
								],
								[
									53.07890625000016,
									45.30751953124994
								],
								[
									53.20039062500007,
									45.33198242187504
								],
								[
									53.08574218750016,
									45.40737304687494
								],
								[
									52.83750000000009,
									45.49672851562494
								],
								[
									52.77382812500002,
									45.57275390624997
								],
								[
									52.88750000000016,
									45.779541015625
								],
								[
									53.041601562500034,
									45.96787109375009
								],
								[
									53.135253906250114,
									46.19165039062503
								],
								[
									53.10898437500009,
									46.41406249999994
								],
								[
									53.06396484374994,
									46.47529296874998
								],
								[
									53.07851562500002,
									46.54746093749995
								],
								[
									53.132421875000034,
									46.60834960937501
								],
								[
									53.170214843750045,
									46.66904296875012
								],
								[
									53.137500000000045,
									46.74204101562498
								],
								[
									53.06943359375009,
									46.85605468750012
								],
								[
									53.03457031250002,
									46.89291992187498
								],
								[
									52.916015625000114,
									46.954394531250074
								],
								[
									52.677636718750136,
									46.957128906250006
								],
								[
									52.483203125000045,
									46.9906738281251
								],
								[
									52.42031250000002,
									46.9636718750001
								],
								[
									52.38486328125009,
									46.92211914062506
								],
								[
									52.34033203125,
									46.894775390625
								],
								[
									52.18876953124999,
									46.83950195312494
								],
								[
									52.138281250000034,
									46.82861328125003
								],
								[
									52.085546875000034,
									46.83959960937506
								],
								[
									52.011132812500136,
									46.901904296875045
								],
								[
									51.945117187500045,
									46.89487304687512
								],
								[
									51.74453125000002,
									46.93374023437505
								],
								[
									51.65009765625007,
									47.018066406250085
								],
								[
									51.61523437499994,
									47.02993164062511
								],
								[
									51.290820312500045,
									47.097314453124966
								],
								[
									51.17802734375016,
									47.1101562500001
								],
								[
									50.92001953125009,
									47.04067382812505
								],
								[
									50.732714843750045,
									46.95166015625006
								],
								[
									50.67988281250018,
									46.938720703125085
								],
								[
									50.582910156250136,
									46.88227539062504
								],
								[
									50.528417968750034,
									46.87329101562506
								],
								[
									50.47226562500009,
									46.88291015625006
								],
								[
									50.419335937500136,
									46.87949218750009
								],
								[
									50.30625000000009,
									46.794921875
								],
								[
									50.10156249999994,
									46.69643554687511
								],
								[
									49.99980468749999,
									46.63427734375006
								],
								[
									49.88632812500009,
									46.5956542968751
								],
								[
									49.760546875000045,
									46.571484374999955
								],
								[
									49.63154296875001,
									46.567578124999955
								],
								[
									49.584375000000136,
									46.54521484374993
								],
								[
									49.43720703125007,
									46.537255859374994
								],
								[
									49.34746093750016,
									46.51914062499995
								],
								[
									49.34423828124994,
									46.48554687500004
								],
								[
									49.362109375000045,
									46.41020507812496
								],
								[
									49.28583984375007,
									46.43681640624996
								],
								[
									49.205664062500034,
									46.38569335937504
								],
								[
									49.23222656250016,
									46.337158203125
								],
								[
									49.18427734375007,
									46.34882812499998
								],
								[
									48.958984375,
									46.442138671875085
								],
								[
									48.77431640625002,
									46.50795898437508
								],
								[
									48.61015625000016,
									46.566455078125074
								],
								[
									48.586035156250034,
									46.57709960937504
								],
								[
									48.54121093750007,
									46.60561523437508
								],
								[
									48.50917968750002,
									46.649951171875045
								],
								[
									48.502343750000136,
									46.69863281250011
								],
								[
									48.51855468749994,
									46.7343261718751
								],
								[
									48.55839843750016,
									46.75712890625002
								],
								[
									48.605273437500045,
									46.765917968750045
								],
								[
									48.647070312500034,
									46.758691406249994
								],
								[
									48.69355468750018,
									46.73681640624997
								],
								[
									48.7763671875,
									46.71035156250008
								],
								[
									48.88359375000016,
									46.70541992187498
								],
								[
									48.95029296875009,
									46.72578125000004
								],
								[
									48.959375000000136,
									46.77460937500004
								],
								[
									48.83183593749999,
									46.954931640625006
								],
								[
									48.71435546874994,
									47.100488281249994
								],
								[
									48.60068359375009,
									47.262304687500006
								],
								[
									48.552539062500045,
									47.32099609375007
								],
								[
									48.41308593749994,
									47.456494140624955
								],
								[
									48.275683593750045,
									47.58994140625006
								],
								[
									48.166992187500114,
									47.70878906249993
								],
								[
									48.109960937500034,
									47.74541015624993
								],
								[
									47.934667968750034,
									47.76069335937501
								],
								[
									47.60019531250009,
									47.789990234374955
								],
								[
									47.48193359375,
									47.80390625000004
								],
								[
									47.387304687500034,
									47.768652343750034
								],
								[
									47.29238281250002,
									47.74091796875007
								],
								[
									47.202050781249966,
									47.792480468750114
								],
								[
									47.130761718750136,
									47.876757812500045
								],
								[
									47.093261718750114,
									47.947705078124926
								],
								[
									47.11152343750018,
									48.020117187500034
								],
								[
									47.119042968750136,
									48.127001953125045
								],
								[
									47.06464843750007,
									48.232470703125045
								],
								[
									47.00429687500002,
									48.284472656250074
								],
								[
									46.853125000000034,
									48.32358398437495
								],
								[
									46.66093750000016,
									48.41225585937508
								],
								[
									46.60917968750016,
									48.57387695312505
								],
								[
									46.702636718750114,
									48.805566406249994
								],
								[
									46.85292968750002,
									48.96962890624994
								],
								[
									46.96220703125016,
									49.038330078125085
								],
								[
									47.01425781250009,
									49.098339843749955
								],
								[
									47.031347656250034,
									49.150292968749966
								],
								[
									47.01816406250009,
									49.199902343749955
								],
								[
									46.953417968750045,
									49.25258789062494
								],
								[
									46.85292968750002,
									49.303857421874994
								],
								[
									46.802050781250045,
									49.367089843749994
								],
								[
									46.823144531250136,
									49.502246093750074
								],
								[
									46.88955078125002,
									49.69697265625007
								],
								[
									46.99199218749999,
									49.85273437500007
								],
								[
									47.12958984375007,
									49.93906250000009
								],
								[
									47.24833984374999,
									50.00087890625005
								],
								[
									47.295214843750045,
									50.05849609375008
								],
								[
									47.29765624999999,
									50.140234375000034
								],
								[
									47.294726562500045,
									50.217480468749955
								],
								[
									47.32646484374999,
									50.273535156250006
								],
								[
									47.376367187500136,
									50.31811523437494
								],
								[
									47.42919921875,
									50.357958984375074
								],
								[
									47.50361328125007,
									50.40273437500005
								],
								[
									47.59960937499994,
									50.41357421874994
								],
								[
									47.70576171875018,
									50.377978515625074
								],
								[
									47.849609375000114,
									50.28232421875012
								],
								[
									48.06074218750001,
									50.09360351562495
								],
								[
									48.18134765625018,
									49.97001953124999
								],
								[
									48.22480468750007,
									49.93193359374996
								],
								[
									48.334960937500114,
									49.85825195312506
								],
								[
									48.43427734375001,
									49.82851562499994
								],
								[
									48.600000000000136,
									49.87470703125004
								],
								[
									48.75898437500018,
									49.92832031250012
								],
								[
									48.81025390625007,
									49.96240234375003
								],
								[
									48.843261718750114,
									50.01313476562498
								],
								[
									48.817968750000034,
									50.09985351562497
								],
								[
									48.78476562500009,
									50.156445312499955
								],
								[
									48.74941406250002,
									50.22846679687507
								],
								[
									48.70048828125016,
									50.353759765625114
								],
								[
									48.666015625,
									50.5503417968751
								],
								[
									48.62509765625009,
									50.61269531250011
								],
								[
									48.655175781249966,
									50.61987304687506
								],
								[
									48.734765625000136,
									50.60688476562507
								],
								[
									48.808398437500045,
									50.601318359375
								],
								[
									48.91376953125018,
									50.64458007812493
								],
								[
									49.058691406250034,
									50.726074218750114
								],
								[
									49.32343750000007,
									50.85170898437494
								],
								[
									49.379492187500034,
									50.93466796875006
								],
								[
									49.42460937500016,
									51.02700195312502
								],
								[
									49.498046875000114,
									51.08359375000012
								],
								[
									49.66630859374999,
									51.102294921875085
								],
								[
									49.822265625,
									51.131884765625074
								],
								[
									49.93232421875001,
									51.19716796875005
								],
								[
									50.10488281250002,
									51.25458984375004
								],
								[
									50.24687500000016,
									51.289501953124955
								],
								[
									50.30927734375018,
									51.3215820312501
								],
								[
									50.35371093750018,
									51.369726562500034
								],
								[
									50.51630859375018,
									51.505615234375114
								],
								[
									50.643945312500136,
									51.58916015624999
								],
								[
									50.75615234374999,
									51.675146484375006
								],
								[
									50.7939453125,
									51.72919921875001
								],
								[
									50.882421875000034,
									51.71918945312501
								],
								[
									51.017871093750045,
									51.681640625
								],
								[
									51.163476562500136,
									51.64746093750006
								],
								[
									51.269921875000136,
									51.594482421875
								],
								[
									51.29072265625001,
									51.54018554687505
								],
								[
									51.30107421874999,
									51.49741210937495
								],
								[
									51.34453125000016,
									51.47534179687506
								],
								[
									51.39599609374994,
									51.47128906249995
								],
								[
									51.473437500000045,
									51.482031250000006
								],
								[
									51.60908203125001,
									51.48398437500006
								],
								[
									51.775390625,
									51.554248046875074
								],
								[
									52.007128906250045,
									51.67270507812495
								],
								[
									52.219140624999966,
									51.709374999999966
								],
								[
									52.33105468749994,
									51.68129882812502
								],
								[
									52.42304687500007,
									51.59423828125006
								],
								[
									52.496191406250034,
									51.512158203124926
								],
								[
									52.571191406250136,
									51.481640624999926
								],
								[
									52.61777343750009,
									51.48076171874993
								],
								[
									52.63515625000002,
									51.479541015625045
								],
								[
									52.728125000000034,
									51.498144531250006
								],
								[
									52.73505859375018,
									51.497900390625034
								],
								[
									52.82050781250018,
									51.49458007812507
								],
								[
									52.90263671875016,
									51.46694335937505
								],
								[
									53.03837890625016,
									51.463720703125006
								],
								[
									53.227343750000045,
									51.48496093750006
								],
								[
									53.24726562500018,
									51.49360351562507
								],
								[
									53.33808593750001,
									51.48237304687507
								],
								[
									53.448632812499966,
									51.44453125000001
								],
								[
									53.534667968750114,
									51.399560546874994
								],
								[
									53.688085937500034,
									51.251806640625006
								],
								[
									53.77646484375009,
									51.21372070312506
								],
								[
									53.95683593750016,
									51.16118164062502
								],
								[
									54.04150390625,
									51.11518554687507
								],
								[
									54.139746093750034,
									51.040771484375
								],
								[
									54.19111328125018,
									50.99570312500006
								],
								[
									54.2978515625,
									50.91406249999994
								],
								[
									54.421484375000034,
									50.78032226562496
								],
								[
									54.44335937499994,
									50.673925781250034
								],
								[
									54.47148437499999,
									50.583789062500074
								],
								[
									54.517382812500045,
									50.541162109374994
								],
								[
									54.555273437500034,
									50.535791015624966
								],
								[
									54.596191406250114,
									50.55068359375008
								],
								[
									54.636132812499966,
									50.591601562500074
								],
								[
									54.650000000000034,
									50.660156250000085
								],
								[
									54.63789062500018,
									50.78105468749993
								],
								[
									54.606250000000045,
									50.879882812500085
								],
								[
									54.56562500000018,
									50.911279296874994
								],
								[
									54.54609375000001,
									50.94604492187497
								],
								[
									54.57294921875018,
									50.990234375
								],
								[
									54.641601562500114,
									51.01157226562509
								],
								[
									54.727148437500034,
									50.9980957031251
								],
								[
									54.86796875000016,
									50.9413574218751
								],
								[
									55.01484375000001,
									50.86977539062508
								],
								[
									55.19521484375002,
									50.74472656250009
								],
								[
									55.36113281250016,
									50.66528320312497
								],
								[
									55.542285156250045,
									50.601806640625085
								],
								[
									55.68623046875001,
									50.58286132812506
								],
								[
									55.79765624999999,
									50.60205078124997
								],
								[
									55.92919921875,
									50.65375976562501
								],
								[
									56.04970703125002,
									50.71352539062494
								],
								[
									56.1044921875,
									50.77626953124994
								],
								[
									56.143945312500136,
									50.84462890625011
								],
								[
									56.32558593750002,
									50.93608398437499
								],
								[
									56.49140625000001,
									51.01953125000003
								],
								[
									56.56689453124994,
									51.00449218749998
								],
								[
									56.62021484375009,
									50.98085937500005
								],
								[
									56.79033203124999,
									51.03159179687509
								],
								[
									56.849609375,
									51.045556640624994
								],
								[
									57.01171875,
									51.065185546875
								],
								[
									57.17900390625016,
									51.03603515625011
								],
								[
									57.3125,
									50.946533203125085
								],
								[
									57.44218749999999,
									50.888867187499955
								],
								[
									57.55781250000001,
									50.89555664062499
								],
								[
									57.65380859374994,
									50.92514648437498
								],
								[
									57.71699218750007,
									50.98095703125006
								],
								[
									57.76484375000001,
									51.046875
								],
								[
									57.828906250000045,
									51.089013671874966
								],
								[
									57.838867187500114,
									51.09165039062506
								],
								[
									58.04511718750018,
									51.06884765624994
								],
								[
									58.174707031250136,
									51.072265625000114
								],
								[
									58.188476562500114,
									51.0817382812501
								],
								[
									58.35917968750016,
									51.06381835937506
								],
								[
									58.547460937500034,
									50.971044921875006
								],
								[
									58.664550781250114,
									50.86831054687502
								],
								[
									58.81406250000009,
									50.737207031249966
								],
								[
									58.883691406250136,
									50.69443359375006
								],
								[
									58.98486328125,
									50.67612304687506
								],
								[
									59.06435546875002,
									50.66821289062494
								],
								[
									59.17089843749994,
									50.64790039062498
								],
								[
									59.45234375000018,
									50.620410156250074
								],
								[
									59.495117187500114,
									50.604296875000074
								],
								[
									59.523925781250114,
									50.58281249999996
								],
								[
									59.497851562500045,
									50.51108398437509
								],
								[
									59.523046875000034,
									50.492871093749926
								],
								[
									59.75117187500001,
									50.54394531249994
								],
								[
									59.812402343749966,
									50.58203124999997
								],
								[
									59.88779296875009,
									50.690185546875085
								],
								[
									59.955175781250034,
									50.7992675781251
								],
								[
									60.005273437500136,
									50.83969726562498
								],
								[
									60.05859374999994,
									50.85029296875001
								],
								[
									60.112109375000045,
									50.83417968750001
								],
								[
									60.18671875000007,
									50.76977539062494
								],
								[
									60.288085937500114,
									50.70415039062499
								],
								[
									60.42480468749994,
									50.679150390624955
								],
								[
									60.50849609375007,
									50.66918945312497
								],
								[
									60.63798828125016,
									50.66372070312511
								],
								[
									60.942285156250136,
									50.6955078125001
								],
								[
									61.226855468750045,
									50.774804687499994
								],
								[
									61.389453125000045,
									50.86103515625007
								],
								[
									61.46503906250007,
									50.990234375
								],
								[
									61.51220703125,
									51.137011718750074
								],
								[
									61.58505859375009,
									51.22968750000004
								],
								[
									61.554687500000114,
									51.32460937500008
								],
								[
									61.41132812500001,
									51.41474609374998
								],
								[
									61.36308593750016,
									51.44189453125
								],
								[
									61.01484375000018,
									51.49238281249998
								],
								[
									60.99335937500007,
									51.52871093750002
								],
								[
									60.973535156250136,
									51.53706054687504
								],
								[
									60.630371093750114,
									51.61694335937506
								],
								[
									60.46474609375002,
									51.6511718750001
								],
								[
									60.418359374999966,
									51.7039062500001
								],
								[
									60.38749999999999,
									51.77299804687496
								],
								[
									60.280371093750034,
									51.83461914062508
								],
								[
									60.06748046875009,
									51.89062499999994
								],
								[
									60.03027343749994,
									51.93325195312511
								],
								[
									60.065527343750034,
									51.97646484375002
								],
								[
									60.233691406250045,
									52.02451171874995
								],
								[
									60.42548828125018,
									52.12558593750012
								],
								[
									60.49931640625016,
									52.14633789062509
								],
								[
									60.670312499999966,
									52.150830078124926
								],
								[
									60.828417968750045,
									52.23339843750006
								],
								[
									60.93759765625009,
									52.280566406250074
								],
								[
									60.994531250000136,
									52.33686523437507
								],
								[
									60.9794921875,
									52.39477539062497
								],
								[
									60.821289062500114,
									52.56982421875003
								],
								[
									60.77441406249994,
									52.67578125000003
								],
								[
									60.802343750000034,
									52.74472656249995
								],
								[
									60.89326171875018,
									52.81943359374998
								],
								[
									60.94472656250002,
									52.86015624999993
								],
								[
									61.00654296875018,
									52.933349609375085
								],
								[
									61.04746093750009,
									52.972460937500074
								],
								[
									61.206933593750136,
									52.98906249999999
								],
								[
									61.400781250000136,
									52.99599609375008
								],
								[
									61.533593749999966,
									52.97851562499997
								],
								[
									61.71933593750009,
									52.96938476562508
								],
								[
									61.88857421875002,
									52.95590820312506
								],
								[
									61.974218750000034,
									52.943749999999994
								],
								[
									62.037109375,
									52.96611328124993
								],
								[
									62.08271484375001,
									53.005419921875045
								],
								[
									62.08105468749994,
									53.057421875000074
								],
								[
									62.014648437500114,
									53.10786132812504
								],
								[
									61.766210937500034,
									53.17392578125009
								],
								[
									61.65986328125007,
									53.2284667968751
								],
								[
									61.57617187499994,
									53.22246093749993
								],
								[
									61.43681640625016,
									53.23940429687511
								],
								[
									61.31093750000002,
									53.27519531249993
								],
								[
									61.19921875,
									53.287158203125045
								],
								[
									61.16279296875001,
									53.33676757812495
								],
								[
									61.185937500000136,
									53.40620117187507
								],
								[
									61.22890625000002,
									53.44589843749998
								],
								[
									61.31162109375009,
									53.46572265625002
								],
								[
									61.400976562500034,
									53.45581054687506
								],
								[
									61.49853515624994,
									53.484667968750074
								],
								[
									61.52656250000018,
									53.50156249999995
								],
								[
									61.53496093749999,
									53.52329101562512
								],
								[
									61.51914062500009,
									53.55449218749999
								],
								[
									61.47412109374994,
									53.5802734375001
								],
								[
									61.409960937500045,
									53.58706054687505
								],
								[
									61.33613281250018,
									53.56518554687494
								],
								[
									61.247949218749966,
									53.55097656249998
								],
								[
									61.09853515625002,
									53.58310546874995
								],
								[
									60.9794921875,
									53.62172851562511
								],
								[
									60.98554687500018,
									53.6574218750001
								],
								[
									61.07353515625016,
									53.71044921875006
								],
								[
									61.113183593750136,
									53.75346679687493
								],
								[
									61.113183593750136,
									53.81298828125006
								],
								[
									61.113183593750136,
									53.88247070312511
								],
								[
									61.14375000000007,
									53.96381835937507
								],
								[
									61.23105468750009,
									54.01948242187504
								],
								[
									61.33369140625001,
									54.04926757812507
								],
								[
									61.59814453125,
									53.9949218750001
								],
								[
									61.928710937500114,
									53.9464843750001
								],
								[
									61.98564453125016,
									53.95439453125002
								],
								[
									62.00234375000002,
									53.97993164062507
								],
								[
									62.04023437500018,
									54.00263671874998
								],
								[
									62.499023437500114,
									54.01318359375
								],
								[
									62.58828125000002,
									54.04443359374997
								],
								[
									62.63271484375002,
									54.06928710937507
								],
								[
									63.07392578125018,
									54.105224609375085
								],
								[
									63.12656250000009,
									54.13925781250009
								],
								[
									63.191308593750136,
									54.17104492187511
								],
								[
									63.29267578125018,
									54.170458984375074
								],
								[
									63.413671875000034,
									54.18320312500009
								],
								[
									63.58203124999994,
									54.22192382812506
								],
								[
									63.70136718750001,
									54.24321289062496
								],
								[
									63.72119140625,
									54.24501953125008
								],
								[
									63.847070312500136,
									54.23647460937511
								],
								[
									64.00390625000011,
									54.26708984374994
								],
								[
									64.03740234374999,
									54.27973632812504
								],
								[
									64.06289062500014,
									54.30292968750004
								],
								[
									64.19941406250007,
									54.34741210937506
								],
								[
									64.46123046874999,
									54.384179687499994
								],
								[
									64.52509765625007,
									54.36215820312495
								],
								[
									64.64990234375,
									54.35224609375007
								],
								[
									64.80927734375007,
									54.36855468750011
								],
								[
									64.92675781250011,
									54.39663085937505
								],
								[
									64.99541015625005,
									54.36875000000006
								],
								[
									65.08837890625,
									54.340185546875006
								],
								[
									65.15781250000009,
									54.364404296874966
								],
								[
									65.19218750000016,
									54.441113281249955
								],
								[
									65.23740234375003,
									54.516064453124955
								],
								[
									65.31591796874994,
									54.55156249999999
								],
								[
									65.37812500000001,
									54.56445312500003
								],
								[
									65.43437500000005,
									54.593310546875045
								],
								[
									65.47695312500002,
									54.62329101562494
								],
								[
									65.70781250000016,
									54.61870117187499
								],
								[
									65.91425781250018,
									54.6933105468751
								],
								[
									65.95468750000009,
									54.659521484375034
								],
								[
									66.22265624999994,
									54.66738281250005
								],
								[
									66.55537109375007,
									54.71542968749998
								],
								[
									66.75449218750003,
									54.73789062500012
								],
								[
									67.09833984375018,
									54.78818359375006
								],
								[
									67.25732421875,
									54.82880859374998
								],
								[
									67.48466796875005,
									54.85449218749997
								],
								[
									67.693359375,
									54.87241210937506
								],
								[
									67.82988281249999,
									54.9435546875001
								],
								[
									67.93994140624994,
									54.953710937500034
								],
								[
									68.07382812500003,
									54.95957031249998
								],
								[
									68.15585937500009,
									54.97670898437511
								],
								[
									68.20937500000014,
									55.00302734374995
								],
								[
									68.24404296875002,
									55.05244140624998
								],
								[
									68.22529296875018,
									55.115234375000085
								],
								[
									68.20625000000001,
									55.160937500000045
								],
								[
									68.30195312500018,
									55.18652343749994
								],
								[
									68.43847656250011,
									55.19443359374995
								],
								[
									68.52480468750002,
									55.20483398437494
								],
								[
									68.71289062499994,
									55.30849609375011
								],
								[
									68.84296875000018,
									55.358349609374955
								],
								[
									68.97724609375018,
									55.389599609374926
								],
								[
									69.24697265625014,
									55.3725097656251
								],
								[
									69.49326171875003,
									55.35688476562501
								],
								[
									69.740234375,
									55.30737304687506
								],
								[
									69.87021484375009,
									55.245654296875074
								],
								[
									69.98173828125016,
									55.199072265625006
								],
								[
									70.08740234375011,
									55.176757812500085
								],
								[
									70.18242187500005,
									55.162451171875006
								],
								[
									70.29335937499997,
									55.18359375000006
								],
								[
									70.37148437499997,
									55.212255859375034
								],
								[
									70.41718750000007,
									55.253173828125114
								],
								[
									70.48632812500011,
									55.28237304687502
								],
								[
									70.73808593750016,
									55.30517578125006
								],
								[
									70.79033203125016,
									55.26113281250005
								],
								[
									70.91015624999994,
									55.1279785156251
								],
								[
									70.99179687500009,
									54.95048828124999
								],
								[
									71.12626953124999,
									54.71503906249998
								],
								[
									71.18554687500011,
									54.59931640625004
								],
								[
									71.15917968749994,
									54.53862304687493
								],
								[
									71.15976562500009,
									54.455419921875034
								],
								[
									71.15214843750016,
									54.364062500000074
								],
								[
									71.05273437499994,
									54.26049804687503
								],
								[
									71.09316406250014,
									54.212207031250045
								],
								[
									71.33642578125011,
									54.158349609374994
								],
								[
									71.67714843749997,
									54.1780273437501
								],
								[
									71.88740234375018,
									54.221484375000074
								],
								[
									72.00449218750003,
									54.20566406249995
								],
								[
									72.06562500000018,
									54.23164062500001
								],
								[
									72.10537109375002,
									54.30844726562512
								],
								[
									72.18603515625011,
									54.32563476562507
								],
								[
									72.26914062500003,
									54.272119140624994
								],
								[
									72.32949218750002,
									54.18144531249999
								],
								[
									72.38730468750003,
									54.123046875
								],
								[
									72.38300781250018,
									54.05366210937498
								],
								[
									72.40429687499994,
									53.96445312500012
								],
								[
									72.44677734375011,
									53.94184570312504
								],
								[
									72.53027343749994,
									53.975781249999926
								],
								[
									72.58593750000011,
									53.99594726562495
								],
								[
									72.59921875000009,
									54.02304687500006
								],
								[
									72.57558593750014,
									54.056494140625034
								],
								[
									72.56425781250016,
									54.09042968750009
								],
								[
									72.58271484375018,
									54.12158203125006
								],
								[
									72.62226562500007,
									54.13432617187499
								],
								[
									72.74101562499999,
									54.12451171874994
								],
								[
									72.9140625,
									54.107324218749994
								],
								[
									73.11933593750018,
									53.98076171874996
								],
								[
									73.22988281250014,
									53.957812500000074
								],
								[
									73.27656250000001,
									53.95561523437499
								],
								[
									73.38066406250005,
									53.962841796874955
								],
								[
									73.50566406249999,
									53.99931640625002
								],
								[
									73.58994140625003,
									54.04497070312499
								],
								[
									73.61796875000016,
									54.06738281250003
								],
								[
									73.66640625000014,
									54.06347656249994
								],
								[
									73.71240234375011,
									54.042382812499994
								],
								[
									73.71552734375001,
									53.99619140625009
								],
								[
									73.67890625000001,
									53.929443359375085
								],
								[
									73.55419921875011,
									53.868310546874966
								],
								[
									73.39941406250011,
									53.81147460937504
								],
								[
									73.30566406250011,
									53.707226562499926
								],
								[
									73.28574218750003,
									53.59838867187506
								],
								[
									73.32685546875018,
									53.54316406249998
								],
								[
									73.36191406250003,
									53.506201171875006
								],
								[
									73.37187499999999,
									53.45439453124993
								],
								[
									73.40693359375007,
									53.44755859374996
								],
								[
									73.46992187500018,
									53.46889648437505
								],
								[
									73.64296874999997,
									53.57626953124998
								],
								[
									73.73115234375018,
									53.60278320312506
								],
								[
									73.85898437500003,
									53.61972656249995
								],
								[
									74.06865234375005,
									53.61142578124995
								],
								[
									74.20996093749994,
									53.57646484374993
								],
								[
									74.27734375000011,
									53.52773437500005
								],
								[
									74.35156250000011,
									53.487646484375034
								],
								[
									74.40273437500014,
									53.5044433593751
								],
								[
									74.42929687500003,
									53.550732421874926
								],
								[
									74.43046875000005,
									53.60371093750007
								],
								[
									74.45195312500016,
									53.647265625000045
								],
								[
									74.68144531250016,
									53.75439453124994
								],
								[
									74.83417968750001,
									53.825683593750085
								],
								[
									74.88681640625009,
									53.8340332031251
								],
								[
									74.98896484375001,
									53.81923828125011
								],
								[
									75.05214843750002,
									53.82670898437493
								],
								[
									75.22021484375,
									53.893798828125114
								],
								[
									75.37705078125003,
									53.97011718750002
								],
								[
									75.39238281250016,
									54.02172851562506
								],
								[
									75.39814453125018,
									54.06850585937508
								],
								[
									75.43720703125001,
									54.089648437500045
								],
								[
									75.65683593750003,
									54.10600585937499
								],
								[
									75.69287109375,
									54.1147949218751
								],
								[
									75.88066406250016,
									54.16796875
								],
								[
									76.14052734374997,
									54.25854492187506
								],
								[
									76.2666015625,
									54.31196289062504
								],
								[
									76.49648437500002,
									54.33569335937497
								],
								[
									76.5391601562502,
									54.35107421875
								],
								[
									76.61552734375005,
									54.387109374999966
								],
								[
									76.7593750000002,
									54.43686523437498
								],
								[
									76.83730468749997,
									54.44238281250003
								],
								[
									76.78896484375002,
									54.321875000000006
								],
								[
									76.70302734374997,
									54.18247070312512
								],
								[
									76.65458984375016,
									54.145263671875085
								],
								[
									76.42167968750016,
									54.15151367187494
								],
								[
									76.42207031250007,
									54.113525390625114
								],
								[
									76.4585937500002,
									54.055273437500034
								],
								[
									76.48476562500014,
									54.02255859374995
								],
								[
									76.51308593750014,
									53.99321289062502
								],
								[
									76.57568359375,
									53.942529296874994
								],
								[
									76.82070312499997,
									53.822656249999994
								],
								[
									77.13242187500009,
									53.67011718750001
								],
								[
									77.46923828124994,
									53.498779296875
								],
								[
									77.70439453125016,
									53.37915039062497
								],
								[
									77.79941406250009,
									53.3174316406251
								],
								[
									77.85996093750003,
									53.26918945312505
								],
								[
									78.03349609375016,
									53.094970703125085
								],
								[
									78.19804687499999,
									52.92968749999997
								],
								[
									78.47548828125014,
									52.63842773437506
								],
								[
									78.72148437500016,
									52.35703125000009
								],
								[
									78.99208984375014,
									52.047412109375074
								],
								[
									79.14873046875016,
									51.86811523437507
								],
								[
									79.4688476562502,
									51.493115234374955
								],
								[
									79.5542968750002,
									51.377978515625045
								],
								[
									79.71640625000009,
									51.16000976562495
								],
								[
									79.85966796875016,
									50.95546874999994
								],
								[
									79.98623046874997,
									50.77456054687494
								],
								[
									80.06591796874994,
									50.75820312500008
								],
								[
									80.07207031250016,
									50.80727539062502
								],
								[
									80.08632812500014,
									50.83999023437505
								],
								[
									80.12724609375005,
									50.858349609374955
								],
								[
									80.22021484374994,
									50.91176757812511
								],
								[
									80.27041015625014,
									50.92460937499996
								],
								[
									80.34521484375011,
									50.91909179687508
								],
								[
									80.42363281249999,
									50.94628906250003
								],
								[
									80.45224609375009,
									50.997607421875074
								],
								[
									80.43359375,
									51.09262695312509
								],
								[
									80.4214843750002,
									51.13637695312494
								],
								[
									80.44804687499999,
									51.183349609375
								],
								[
									80.49101562500016,
									51.20175781250012
								],
								[
									80.55068359375014,
									51.21660156249993
								],
								[
									80.60546875000011,
									51.22421874999998
								],
								[
									80.65048828125003,
									51.27734375000006
								],
								[
									80.73525390624997,
									51.293408203124955
								],
								[
									80.8130859375002,
									51.283496093750074
								],
								[
									80.87734374999997,
									51.2814453125001
								],
								[
									80.93408203125,
									51.242773437500034
								],
								[
									80.96562500000005,
									51.18979492187498
								],
								[
									81.02675781250014,
									51.18569335937502
								],
								[
									81.12724609374999,
									51.19106445312505
								],
								[
									81.14101562500014,
									51.14658203125006
								],
								[
									81.11240234375009,
									51.07236328124995
								],
								[
									81.07753906250002,
									51.014941406250074
								],
								[
									81.07148437500018,
									50.96875000000006
								],
								[
									81.12460937500009,
									50.94628906250003
								],
								[
									81.31914062499999,
									50.96640624999995
								],
								[
									81.38828125000009,
									50.95649414062507
								],
								[
									81.41015625,
									50.90976562499995
								],
								[
									81.43769531250018,
									50.87104492187507
								],
								[
									81.45156249999997,
									50.8236816406251
								],
								[
									81.43144531250016,
									50.77114257812505
								],
								[
									81.46591796875009,
									50.73984374999998
								],
								[
									81.6338867187502,
									50.739111328125006
								],
								[
									81.7520507812502,
									50.764404296875
								],
								[
									81.93369140625009,
									50.76635742187506
								],
								[
									82.09804687499997,
									50.71083984375002
								],
								[
									82.21191406250011,
									50.71943359375007
								],
								[
									82.32636718750007,
									50.74189453125004
								],
								[
									82.49394531250016,
									50.72758789062496
								],
								[
									82.61171875000002,
									50.77148437500003
								],
								[
									82.6929687500002,
									50.82631835937511
								],
								[
									82.71855468749999,
									50.869482421875006
								],
								[
									82.7608398437502,
									50.89335937499999
								],
								[
									82.91904296875009,
									50.89311523437493
								],
								[
									83.01923828125018,
									50.897265625000074
								],
								[
									83.09277343749994,
									50.96059570312511
								],
								[
									83.1602539062502,
									50.98920898437507
								],
								[
									83.27373046875016,
									50.9945800781251
								],
								[
									83.35732421875014,
									50.9945800781251
								],
								[
									83.58144531250014,
									50.93574218750001
								],
								[
									83.71777343750011,
									50.88715820312507
								],
								[
									83.85976562499997,
									50.81801757812508
								],
								[
									83.94511718750016,
									50.77465820312506
								],
								[
									84.00234374999997,
									50.67685546875012
								],
								[
									84.09931640625001,
									50.604736328125085
								],
								[
									84.17597656250018,
									50.520556640625074
								],
								[
									84.19453125000007,
									50.43745117187501
								],
								[
									84.2578125,
									50.28823242187508
								],
								[
									84.3232421875,
									50.23916015624994
								],
								[
									84.4009765625002,
									50.23916015624994
								],
								[
									84.49902343750011,
									50.21875000000003
								],
								[
									84.60732421875014,
									50.202392578125085
								],
								[
									84.83896484375009,
									50.091308593750114
								],
								[
									84.92402343750018,
									50.087988281250034
								],
								[
									84.98945312500018,
									50.061425781249966
								],
								[
									84.99970703125007,
									50.01030273437502
								],
								[
									84.9751953125002,
									49.95107421875005
								],
								[
									85.00078124999999,
									49.89414062500009
								],
								[
									85.07646484375016,
									49.82163085937506
								],
								[
									85.13652343750005,
									49.750732421875085
								],
								[
									85.21015625000001,
									49.66484374999999
								],
								[
									85.23261718750018,
									49.61582031249995
								],
								[
									85.29189453124997,
									49.59946289062509
								],
								[
									85.37158203124994,
									49.62392578125011
								],
								[
									85.49843750000014,
									49.60537109375005
								],
								[
									85.88046875000009,
									49.55654296875005
								],
								[
									85.93359374999994,
									49.55043945312505
								],
								[
									85.97441406250005,
									49.49931640624993
								],
								[
									86.02958984375016,
									49.50341796874997
								],
								[
									86.09296875000001,
									49.505468750000034
								],
								[
									86.18085937500018,
									49.49931640624993
								],
								[
									86.24218749999994,
									49.54633789062501
								],
								[
									86.29238281250014,
									49.587500000000034
								],
								[
									86.41796874999994,
									49.638476562500045
								],
								[
									86.52226562500016,
									49.70776367187494
								],
								[
									86.61015625000016,
									49.76914062500009
								],
								[
									86.67548828125001,
									49.77729492187498
								],
								[
									86.72871093750001,
									49.74868164062502
								],
								[
									86.73066406250018,
									49.69555664062494
								],
								[
									86.66533203124999,
									49.656689453124926
								],
								[
									86.6142578125,
									49.60971679687495
								],
								[
									86.62646484375,
									49.56269531250007
								],
								[
									86.71435546874994,
									49.558593750000114
								],
								[
									86.81210937500009,
									49.487890625000006
								],
								[
									86.95292968750016,
									49.322070312500074
								],
								[
									87.0009765625,
									49.2873046875001
								],
								[
									87.07060546875016,
									49.25458984375007
								],
								[
									87.1480468750002,
									49.239794921875074
								],
								[
									87.23369140625016,
									49.21616210937498
								],
								[
									87.29687499999994,
									49.14765625000007
								],
								[
									87.3228515625002,
									49.08579101562498
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central Asia",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "KAZ",
					"su_a3": "KAZ",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "KAZ",
					"gu_a3": "KAZ",
					"abbrev": "Kaz.",
					"region_un": "Asia",
					"adm0_a3_us": "KAZ",
					"scalerank": 1,
					"pop_est": 15399437,
					"adm0_dif": 0,
					"un_a3": "398",
					"pop_year": -99,
					"gdp_md_est": 175800,
					"name": "Kazakhstan",
					"sovereignt": "Kazakhstan",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Kazakhstan",
					"postal": "KZ",
					"sov_a3": "KAZ",
					"note_brk": "",
					"brk_a3": "KAZ",
					"wb_a2": "KZ",
					"brk_diff": 0,
					"admin": "Kazakhstan",
					"name_long": "Kazakhstan",
					"iso_a3": "KAZ",
					"iso_a2": "KZ",
					"adm0_a3_is": "KAZ",
					"level": 2,
					"formal_en": "Republic of Kazakhstan",
					"name_len": 10,
					"mapcolor7": 6,
					"long_len": 10,
					"mapcolor8": 1,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "398",
					"homepart": 1,
					"subunit": "Kazakhstan",
					"name_alt": "",
					"brk_name": "Kazakhstan",
					"name_sort": "Kazakhstan",
					"continent": "Asia",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									40.99443359374999,
									-2.1583984375000114
								],
								[
									40.95732421875016,
									-2.1672851562500455
								],
								[
									40.976464843749966,
									-2.109765625000051
								],
								[
									41.08603515625009,
									-2.036523437500051
								],
								[
									41.130664062500045,
									-2.053027343749946
								],
								[
									41.139257812500034,
									-2.0698242187499147
								],
								[
									41.136816406250034,
									-2.0850585937499915
								],
								[
									41.1181640625,
									-2.100097656249943
								],
								[
									40.99443359374999,
									-2.1583984375000114
								]
							]
						],
						[
							[
								[
									41.88398437500001,
									3.9777343749999687
								],
								[
									41.760937500000125,
									3.8016113281250625
								],
								[
									41.61347656250007,
									3.590478515625037
								],
								[
									41.34179687500006,
									3.2016601562500426
								],
								[
									41.13496093750001,
									2.9970703125000284
								],
								[
									40.97871093750007,
									2.842431640625051
								],
								[
									40.964453125000034,
									2.814648437500068
								],
								[
									40.96503906250007,
									2.642333984375057
								],
								[
									40.966699218750136,
									2.2209472656250853
								],
								[
									40.97001953124999,
									1.3781738281250853
								],
								[
									40.973242187500034,
									0.535400390625071
								],
								[
									40.976562500000114,
									-0.3073242187499261
								],
								[
									40.97822265625018,
									-0.728710937499983
								],
								[
									40.97871093750007,
									-0.8703124999999687
								],
								[
									41.115820312500034,
									-1.0474609374999915
								],
								[
									41.249804687500045,
									-1.2205078124999034
								],
								[
									41.42695312500007,
									-1.4495117187499176
								],
								[
									41.52187500000008,
									-1.5722656249999716
								],
								[
									41.53759765625,
									-1.613183593749966
								],
								[
									41.53271484375006,
									-1.6953124999999005
								],
								[
									41.38691406250001,
									-1.8669921874999744
								],
								[
									41.267480468750136,
									-1.9450195312499687
								],
								[
									41.106835937499966,
									-1.9823242187500227
								],
								[
									41.058691406250034,
									-1.9751953124999915
								],
								[
									40.995507812500136,
									-1.9505859374999517
								],
								[
									40.97070312499994,
									-1.9917968749999062
								],
								[
									40.952148437500114,
									-2.055957031249932
								],
								[
									40.916601562500034,
									-2.042480468749929
								],
								[
									40.88974609375009,
									-2.0235351562499773
								],
								[
									40.90585937500009,
									-2.137500000000017
								],
								[
									40.92236328124994,
									-2.1937499999999375
								],
								[
									40.898242187500045,
									-2.2699218749999943
								],
								[
									40.82011718749999,
									-2.3363281250000227
								],
								[
									40.81318359375001,
									-2.3923828124999034
								],
								[
									40.644140625000034,
									-2.5394531249999233
								],
								[
									40.40449218750018,
									-2.555664062499943
								],
								[
									40.27851562500018,
									-2.6286132812499687
								],
								[
									40.222460937500045,
									-2.68837890624998
								],
								[
									40.179785156250034,
									-2.8190429687499545
								],
								[
									40.194726562500136,
									-3.0192382812499687
								],
								[
									40.12812500000018,
									-3.173339843750014
								],
								[
									40.11542968750018,
									-3.250585937499949
								],
								[
									39.99169921875,
									-3.350683593749906
								],
								[
									39.93681640624999,
									-3.442480468749963
								],
								[
									39.89628906249999,
									-3.5358398437499687
								],
								[
									39.86093750000009,
									-3.576757812499963
								],
								[
									39.81914062499999,
									-3.786035156249966
								],
								[
									39.76142578125018,
									-3.9130859374999147
								],
								[
									39.74580078125018,
									-3.955175781249963
								],
								[
									39.73164062500001,
									-3.993261718749906
								],
								[
									39.686914062499966,
									-4.06787109375
								],
								[
									39.65800781250016,
									-4.119140624999972
								],
								[
									39.637109375000136,
									-4.1528320312499005
								],
								[
									39.49091796875001,
									-4.47841796874998
								],
								[
									39.376953125,
									-4.625488281249915
								],
								[
									39.287499999999966,
									-4.608593750000026
								],
								[
									39.228125000000034,
									-4.6655273437499005
								],
								[
									39.22177734375009,
									-4.692382812500043
								],
								[
									39.19013671875001,
									-4.677246093749886
								],
								[
									39.11542968750018,
									-4.623535156249957
								],
								[
									38.9619140625,
									-4.512988281249918
								],
								[
									38.80839843750016,
									-4.402441406249949
								],
								[
									38.654882812500034,
									-4.291894531249895
								],
								[
									38.501367187500136,
									-4.1814453125000455
								],
								[
									38.34785156250001,
									-4.070898437499906
								],
								[
									38.194335937500114,
									-3.9603515624999517
								],
								[
									38.04082031249999,
									-3.849804687499983
								],
								[
									37.88730468750009,
									-3.739257812499929
								],
								[
									37.797265625000136,
									-3.674414062499963
								],
								[
									37.75742187500009,
									-3.63613281249998
								],
								[
									37.726171875000034,
									-3.5597656249999545
								],
								[
									37.711035156250034,
									-3.5408203124999176
								],
								[
									37.67011718750018,
									-3.516796874999997
								],
								[
									37.62207031249994,
									-3.5115234374999886
								],
								[
									37.60820312500016,
									-3.4970703124999716
								],
								[
									37.60869140625016,
									-3.460253906249932
								],
								[
									37.62539062500002,
									-3.407226562500057
								],
								[
									37.68183593750007,
									-3.3057617187499915
								],
								[
									37.68798828125,
									-3.2461914062499346
								],
								[
									37.676855468750034,
									-3.178417968749983
								],
								[
									37.6591796875,
									-3.070019531249926
								],
								[
									37.64384765625016,
									-3.0454101562499716
								],
								[
									37.54218750000001,
									-2.9885742187500313
								],
								[
									37.329003906250136,
									-2.8696289062499574
								],
								[
									37.115820312500034,
									-2.750585937499949
								],
								[
									36.902636718750045,
									-2.6316406249999744
								],
								[
									36.689453125000114,
									-2.512597656250051
								],
								[
									36.47636718750016,
									-2.3935546874999574
								],
								[
									36.263085937500136,
									-2.2746093749999687
								],
								[
									36.05000000000007,
									-2.155664062499895
								],
								[
									35.8369140625,
									-2.0366210937499005
								],
								[
									35.62373046875018,
									-1.9175781249999773
								],
								[
									35.410546874999966,
									-1.7986328124999034
								],
								[
									35.19746093750018,
									-1.6795898437498948
								],
								[
									34.98427734375002,
									-1.5605468749999005
								],
								[
									34.77109375000009,
									-1.4416015624999972
								],
								[
									34.55791015624999,
									-1.3225585937499034
								],
								[
									34.344726562500114,
									-1.2036132812499147
								],
								[
									34.131640625000045,
									-1.0845703124999204
								],
								[
									34.055875536310566,
									-1.042252738573282
								],
								[
									34.06318359375001,
									-1.0336914062500284
								],
								[
									34.070117187500045,
									-0.9974609375000227
								],
								[
									34.12128906250007,
									-0.9747070312500057
								],
								[
									34.14404296875,
									-0.9398437500000085
								],
								[
									34.16279296875007,
									-0.8791992187500028
								],
								[
									34.10576171874999,
									-0.7981445312500028
								],
								[
									34.06826171875008,
									-0.724804687499983
								],
								[
									34.06005859375,
									-0.6449218749999659
								],
								[
									34.07929687500001,
									-0.5794921874999517
								],
								[
									34.17480468750006,
									-0.4701171874999659
								],
								[
									34.21718750000008,
									-0.4415039062500057
								],
								[
									34.275390625,
									-0.44501953125001137
								],
								[
									34.32851562500008,
									-0.4593749999999943
								],
								[
									34.37568359375001,
									-0.4587890624999744
								],
								[
									34.4248046875,
									-0.5021484375000114
								],
								[
									34.45634765624999,
									-0.4951171875
								],
								[
									34.47509765625,
									-0.46435546874994316
								],
								[
									34.45830078124999,
									-0.3689453124999602
								],
								[
									34.477832031250045,
									-0.3533203124999744
								],
								[
									34.57656250000008,
									-0.32968749999996305
								],
								[
									34.70332031250007,
									-0.3249023437499545
								],
								[
									34.79814453124999,
									-0.2963867187500142
								],
								[
									34.81328124999999,
									-0.2756835937499744
								],
								[
									34.717578125000045,
									-0.0916992187499659
								],
								[
									34.53808593750006,
									-0.14374999999999716
								],
								[
									34.41953125000009,
									-0.19619140625002274
								],
								[
									34.36992187499999,
									-0.24335937499995453
								],
								[
									34.35332031249999,
									-0.31376953125000284
								],
								[
									34.33398437500006,
									-0.3373046874999943
								],
								[
									34.30996093750002,
									-0.3560546875000057
								],
								[
									34.28466796875006,
									-0.35029296874998295
								],
								[
									34.2255859375,
									-0.2591796874999801
								],
								[
									34.1171875,
									-0.16347656250002274
								],
								[
									34.10751953125009,
									-0.1333984375000199
								],
								[
									34.12519531250007,
									-0.09101562500001137
								],
								[
									34.11523437500006,
									-0.0794921874999659
								],
								[
									34.059179687500034,
									-0.08071289062503695
								],
								[
									34.02871093750002,
									-0.06249999999997158
								],
								[
									34.0029296875,
									-0.02421874999998863
								],
								[
									33.982031250000034,
									0.02465820312502842
								],
								[
									33.9736328125,
									0.0887207031250199
								],
								[
									33.97451171875008,
									0.2133789062500142
								],
								[
									33.9740555198303,
									0.21344418471389304
								],
								[
									34.03720703125009,
									0.2945312500000199
								],
								[
									34.080566406250114,
									0.3824707031250938
								],
								[
									34.11171875000008,
									0.5051269531250284
								],
								[
									34.16093750000016,
									0.6051757812500682
								],
								[
									34.272558593750034,
									0.6864257812500227
								],
								[
									34.292578125000034,
									0.7312500000000028
								],
								[
									34.41083984375018,
									0.8672851562500057
								],
								[
									34.481738281250045,
									1.0421386718750938
								],
								[
									34.535253906250034,
									1.1015625000000426
								],
								[
									34.60195312500002,
									1.1564453125000256
								],
								[
									34.64912109375001,
									1.1853027343750426
								],
								[
									34.72675781250001,
									1.2142578124999943
								],
								[
									34.787597656250114,
									1.2307128906249716
								],
								[
									34.798632812500045,
									1.244531250000037
								],
								[
									34.803808593750034,
									1.2728515625000227
								],
								[
									34.78359375000008,
									1.3811523437500597
								],
								[
									34.809570312500114,
									1.4166992187500256
								],
								[
									34.850976562500136,
									1.4890136718750142
								],
								[
									34.89833984375008,
									1.5564941406250767
								],
								[
									34.941210937500045,
									1.5992675781250938
								],
								[
									34.965234375000136,
									1.643359375000017
								],
								[
									34.97646484375002,
									1.7196289062500938
								],
								[
									34.97822265625001,
									1.7736328125000824
								],
								[
									34.97753906250006,
									1.8619140625000483
								],
								[
									34.96406250000018,
									2.062402343750037
								],
								[
									34.91396484375008,
									2.230175781250111
								],
								[
									34.88300781250018,
									2.417919921875068
								],
								[
									34.905761718750114,
									2.47968750000004
								],
								[
									34.866210937500114,
									2.5896972656250767
								],
								[
									34.84667968750006,
									2.5957519531250597
								],
								[
									34.81445312500006,
									2.619824218749997
								],
								[
									34.77343750000006,
									2.7234375000000597
								],
								[
									34.74248046875016,
									2.818115234375071
								],
								[
									34.723242187500034,
									2.841943359375037
								],
								[
									34.589160156250045,
									2.92475585937504
								],
								[
									34.52255859375009,
									3.11997070312502
								],
								[
									34.447851562500034,
									3.1634765625000796
								],
								[
									34.40722656250006,
									3.3575195312500057
								],
								[
									34.39941406250006,
									3.4126953125000483
								],
								[
									34.44179687500008,
									3.6062500000000455
								],
								[
									34.43769531250001,
									3.6505859375000256
								],
								[
									34.39287109375016,
									3.691503906250105
								],
								[
									34.267089843750114,
									3.7331542968749716
								],
								[
									34.165039062500114,
									3.812988281250071
								],
								[
									34.178222656250114,
									3.8408691406250597
								],
								[
									34.18574218750007,
									3.869775390625094
								],
								[
									34.13203125000001,
									3.8891601562500426
								],
								[
									33.97607421875006,
									4.220214843749986
								],
								[
									34.17685546875009,
									4.419091796875094
								],
								[
									34.380175781250045,
									4.620654296875031
								],
								[
									34.63984375000007,
									4.875488281250085
								],
								[
									34.87832031250002,
									5.109570312500068
								],
								[
									35.08447265625,
									5.311865234375077
								],
								[
									35.268359375000045,
									5.492285156249977
								],
								[
									35.26386718750001,
									5.45791015625008
								],
								[
									35.264648437500114,
									5.412060546875054
								],
								[
									35.28759765625,
									5.3840820312500455
								],
								[
									35.325292968750034,
									5.364892578125037
								],
								[
									35.377929687500114,
									5.38515625000008
								],
								[
									35.42402343750018,
									5.41328125000004
								],
								[
									35.46865234375002,
									5.419091796875065
								],
								[
									35.74501953125002,
									5.343994140625043
								],
								[
									35.791406250000136,
									5.278564453125043
								],
								[
									35.78847656250008,
									5.208105468750077
								],
								[
									35.80029296875,
									5.15693359375004
								],
								[
									35.77929687500006,
									5.1055664062500625
								],
								[
									35.75615234375016,
									4.950488281250088
								],
								[
									35.763085937500136,
									4.808007812500094
								],
								[
									35.84560546875008,
									4.702636718750043
								],
								[
									35.91982421875002,
									4.61982421875004
								],
								[
									35.978710937500125,
									4.503808593750037
								],
								[
									36.021972656250114,
									4.468115234375048
								],
								[
									36.08193359375008,
									4.449707031250028
								],
								[
									36.271875000000136,
									4.44472656250008
								],
								[
									36.553027343750045,
									4.437255859375057
								],
								[
									36.82363281250002,
									4.430126953125026
								],
								[
									36.848242187500034,
									4.427343750000091
								],
								[
									36.90556640624999,
									4.411474609374963
								],
								[
									37.154589843750045,
									4.254541015624966
								],
								[
									37.382519531250125,
									4.11083984375
								],
								[
									37.575488281250045,
									3.9859375000000483
								],
								[
									37.76289062500007,
									3.8646484375000227
								],
								[
									37.94492187500009,
									3.7467285156250654
								],
								[
									38.08613281250007,
									3.6488281250000227
								],
								[
									38.22529296875001,
									3.6189941406250767
								],
								[
									38.451562500000136,
									3.604833984375034
								],
								[
									38.60800781250009,
									3.6000976562500426
								],
								[
									38.75273437499999,
									3.558984375000108
								],
								[
									38.967773437500114,
									3.520605468750105
								],
								[
									39.128320312500136,
									3.5008789062500796
								],
								[
									39.225488281250136,
									3.478759765625014
								],
								[
									39.494433593750045,
									3.456103515625017
								],
								[
									39.538867187500045,
									3.469189453125111
								],
								[
									39.657519531250045,
									3.57783203125004
								],
								[
									39.79033203124999,
									3.7542480468750057
								],
								[
									39.84218750000008,
									3.851464843750094
								],
								[
									40.01416015625006,
									3.9479492187500256
								],
								[
									40.31601562500009,
									4.08271484375004
								],
								[
									40.52871093750008,
									4.177636718750023
								],
								[
									40.765234375000034,
									4.273046875000006
								],
								[
									40.872656250000034,
									4.190332031250023
								],
								[
									41.020800781250045,
									4.057470703124963
								],
								[
									41.087207031250045,
									3.9919433593750284
								],
								[
									41.1404296875001,
									3.9629882812500767
								],
								[
									41.22089843750001,
									3.9435546875000256
								],
								[
									41.318945312500034,
									3.9430664062500966
								],
								[
									41.37246093750002,
									3.9461914062500227
								],
								[
									41.481933593750114,
									3.963281250000051
								],
								[
									41.73769531250008,
									3.9790527343749744
								],
								[
									41.88398437500001,
									3.9777343749999687
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Africa",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "KEN",
					"su_a3": "KEN",
					"brk_group": "",
					"region_wb": "Sub-Saharan Africa",
					"wb_a3": "KEN",
					"gu_a3": "KEN",
					"abbrev": "Ken.",
					"region_un": "Africa",
					"adm0_a3_us": "KEN",
					"scalerank": 1,
					"pop_est": 39002772,
					"adm0_dif": 0,
					"un_a3": "404",
					"pop_year": -99,
					"gdp_md_est": 61510,
					"name": "Kenya",
					"sovereignt": "Kenya",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "5. Low income",
					"geou_dif": 0,
					"geounit": "Kenya",
					"postal": "KE",
					"sov_a3": "KEN",
					"note_brk": "",
					"brk_a3": "KEN",
					"wb_a2": "KE",
					"brk_diff": 0,
					"admin": "Kenya",
					"name_long": "Kenya",
					"iso_a3": "KEN",
					"iso_a2": "KE",
					"adm0_a3_is": "KEN",
					"level": 2,
					"formal_en": "Republic of Kenya",
					"name_len": 5,
					"mapcolor7": 5,
					"long_len": 5,
					"mapcolor8": 2,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "404",
					"homepart": 1,
					"subunit": "Kenya",
					"name_alt": "",
					"brk_name": "Kenya",
					"name_sort": "Kenya",
					"continent": "Africa",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									126.32695312500005,
									33.22363281249997
								],
								[
									126.28203125000005,
									33.20151367187509
								],
								[
									126.24023437500011,
									33.21484375000006
								],
								[
									126.22900390624994,
									33.22524414062505
								],
								[
									126.17871093750011,
									33.28256835937509
								],
								[
									126.1656250000002,
									33.31201171875003
								],
								[
									126.19941406250007,
									33.36806640625008
								],
								[
									126.33769531249999,
									33.46040039062498
								],
								[
									126.69550781250007,
									33.54931640625006
								],
								[
									126.7598632812502,
									33.55322265624997
								],
								[
									126.90117187500005,
									33.51513671874994
								],
								[
									126.9312500000002,
									33.443847656250085
								],
								[
									126.9053710937502,
									33.38237304687499
								],
								[
									126.87285156250005,
									33.341162109375034
								],
								[
									126.70917968750018,
									33.2716796875001
								],
								[
									126.58173828125007,
									33.238330078125045
								],
								[
									126.32695312500005,
									33.22363281249997
								]
							]
						],
						[
							[
								[
									126.75302734375003,
									34.34399414062506
								],
								[
									126.76992187500014,
									34.296435546875045
								],
								[
									126.68906250000009,
									34.305419921875085
								],
								[
									126.6460937500002,
									34.35112304687499
								],
								[
									126.65185546874994,
									34.39033203124998
								],
								[
									126.69999999999999,
									34.395898437499966
								],
								[
									126.75302734375003,
									34.34399414062506
								]
							]
						],
						[
							[
								[
									126.23369140625005,
									34.37050781250002
								],
								[
									126.16972656250016,
									34.355175781249926
								],
								[
									126.13378906250011,
									34.389599609374926
								],
								[
									126.10859375000001,
									34.39873046875002
								],
								[
									126.12285156249999,
									34.44394531250006
								],
								[
									126.22705078125011,
									34.53271484375003
								],
								[
									126.24746093749997,
									34.56333007812506
								],
								[
									126.3438476562502,
									34.54492187500003
								],
								[
									126.37988281249994,
									34.49794921875005
								],
								[
									126.33544921875,
									34.426416015624966
								],
								[
									126.23369140625005,
									34.37050781250002
								]
							]
						],
						[
							[
								[
									127.79902343750018,
									34.61503906249993
								],
								[
									127.78779296875018,
									34.58408203125012
								],
								[
									127.73730468750011,
									34.630908203125074
								],
								[
									127.78710937499994,
									34.682128906250114
								],
								[
									127.79902343750018,
									34.61503906249993
								]
							]
						],
						[
							[
								[
									126.17197265625009,
									34.73115234375007
								],
								[
									126.15878906250003,
									34.706982421874926
								],
								[
									126.11523437499994,
									34.71420898437498
								],
								[
									126.07060546875005,
									34.78305664062506
								],
								[
									126.05205078125016,
									34.837548828124966
								],
								[
									126.00751953125007,
									34.86748046875002
								],
								[
									126.07841796874999,
									34.914843750000074
								],
								[
									126.16855468750009,
									34.82968750000006
								],
								[
									126.17197265625009,
									34.73115234375007
								]
							]
						],
						[
							[
								[
									128.06582031249997,
									34.8058593750001
								],
								[
									128.0546875000001,
									34.708056640625045
								],
								[
									127.9839843750002,
									34.70322265625006
								],
								[
									127.94179687500014,
									34.76625976562511
								],
								[
									127.89687500000014,
									34.735498046874966
								],
								[
									127.87343750000014,
									34.734960937500034
								],
								[
									127.83828124999997,
									34.813330078125006
								],
								[
									127.83222656250018,
									34.87451171875003
								],
								[
									127.91542968749997,
									34.920996093750006
								],
								[
									127.96562499999999,
									34.89301757812507
								],
								[
									128.03798828125002,
									34.87861328124998
								],
								[
									128.06582031249997,
									34.8058593750001
								]
							]
						],
						[
							[
								[
									128.74101562500016,
									34.798535156249926
								],
								[
									128.6466796875,
									34.736865234375074
								],
								[
									128.51953124999994,
									34.81958007812503
								],
								[
									128.4892578125001,
									34.86528320312493
								],
								[
									128.5859375,
									34.932275390624994
								],
								[
									128.6679687500001,
									35.00878906250003
								],
								[
									128.72187500000007,
									35.01357421875005
								],
								[
									128.74101562500016,
									34.798535156249926
								]
							]
						],
						[
							[
								[
									126.4175781250002,
									36.492578124999994
								],
								[
									126.40380859374994,
									36.42788085937505
								],
								[
									126.33750000000003,
									36.47055664062495
								],
								[
									126.31855468750018,
									36.612548828125085
								],
								[
									126.38662109375002,
									36.571142578125006
								],
								[
									126.4175781250002,
									36.492578124999994
								]
							]
						],
						[
							[
								[
									130.91601562499994,
									37.47846679687504
								],
								[
									130.8706054687501,
									37.448730468750085
								],
								[
									130.81679687499997,
									37.47846679687504
								],
								[
									130.81025390625018,
									37.50991210937505
								],
								[
									130.83837890624994,
									37.537207031250006
								],
								[
									130.90371093750014,
									37.553710937500085
								],
								[
									130.93427734375,
									37.52973632812507
								],
								[
									130.91601562499994,
									37.47846679687504
								]
							]
						],
						[
							[
								[
									126.52070312500007,
									37.736816406250085
								],
								[
									126.51601562499997,
									37.60468749999998
								],
								[
									126.46083984375014,
									37.610351562500085
								],
								[
									126.42333984375011,
									37.62363281250012
								],
								[
									126.40722656249994,
									37.64941406249994
								],
								[
									126.36933593750007,
									37.772021484375045
								],
								[
									126.41162109374994,
									37.82265625000008
								],
								[
									126.49355468750014,
									37.78256835937506
								],
								[
									126.52070312500007,
									37.736816406250085
								]
							]
						],
						[
							[
								[
									128.3746093750002,
									38.623437499999966
								],
								[
									128.61884765625,
									38.176074218750045
								],
								[
									128.85244140625002,
									37.887060546875034
								],
								[
									129.05156250000016,
									37.67763671875011
								],
								[
									129.33515625,
									37.274560546874966
								],
								[
									129.41826171875,
									37.059033203124926
								],
								[
									129.42617187500002,
									36.925537109375
								],
								[
									129.47343750000016,
									36.74189453124998
								],
								[
									129.43300781249997,
									36.63662109374994
								],
								[
									129.44501953125,
									36.47070312499997
								],
								[
									129.42714843750014,
									36.38549804687503
								],
								[
									129.3925781250001,
									36.32270507812501
								],
								[
									129.39130859375,
									36.20214843749997
								],
								[
									129.40244140625003,
									36.13764648437498
								],
								[
									129.403515625,
									36.052148437499966
								],
								[
									129.4257812500001,
									36.018798828125114
								],
								[
									129.45830078125016,
									36.00644531250006
								],
								[
									129.509765625,
									36.03759765625003
								],
								[
									129.57285156250003,
									36.050537109375
								],
								[
									129.56171875000018,
									35.947656249999994
								],
								[
									129.4854492187502,
									35.68740234375008
								],
								[
									129.41914062500018,
									35.49785156249993
								],
								[
									129.32900390625014,
									35.33276367187506
								],
								[
									129.21416015625016,
									35.18183593750004
								],
								[
									129.07675781250003,
									35.12270507812508
								],
								[
									128.9800781250001,
									35.101513671874926
								],
								[
									128.795703125,
									35.093896484374966
								],
								[
									128.642578125,
									35.11958007812504
								],
								[
									128.51093750000018,
									35.100976562499994
								],
								[
									128.45810546875003,
									35.06943359375006
								],
								[
									128.41884765625014,
									35.01567382812493
								],
								[
									128.44765624999997,
									34.932080078124955
								],
								[
									128.4439453125002,
									34.870361328125085
								],
								[
									128.3876953125001,
									34.87509765624998
								],
								[
									128.2759765625001,
									34.910986328125006
								],
								[
									128.1523437500001,
									34.915869140625034
								],
								[
									128.09453125000016,
									34.93359375
								],
								[
									128.0362304687501,
									35.02197265624997
								],
								[
									127.97675781250007,
									35.01870117187502
								],
								[
									127.87324218750018,
									34.96630859375
								],
								[
									127.71484375,
									34.954687500000034
								],
								[
									127.65908203124997,
									34.92636718749995
								],
								[
									127.63935546875007,
									34.88969726562493
								],
								[
									127.66249999999997,
									34.84340820312511
								],
								[
									127.74218749999994,
									34.78256835937506
								],
								[
									127.7154296875002,
									34.72104492187495
								],
								[
									127.63242187500003,
									34.690234375000074
								],
								[
									127.56542968750011,
									34.765917968750045
								],
								[
									127.52363281250001,
									34.84008789062506
								],
								[
									127.47695312500002,
									34.84428710937502
								],
								[
									127.40429687499994,
									34.823095703125034
								],
								[
									127.3896484375,
									34.74301757812506
								],
								[
									127.4234375000002,
									34.68847656249997
								],
								[
									127.4791015625002,
									34.62524414062497
								],
								[
									127.40117187500005,
									34.55253906249999
								],
								[
									127.38056640625018,
									34.50063476562508
								],
								[
									127.32460937499997,
									34.46328125000002
								],
								[
									127.17343750000009,
									34.54614257812503
								],
								[
									127.1949218750002,
									34.60502929687502
								],
								[
									127.26054687500016,
									34.66166992187493
								],
								[
									127.2686523437502,
									34.72036132812508
								],
								[
									127.2470703125,
									34.75512695312506
								],
								[
									127.03076171874994,
									34.60688476562504
								],
								[
									126.8974609375,
									34.43886718750002
								],
								[
									126.82626953125003,
									34.45107421875002
								],
								[
									126.7964843750002,
									34.49428710937494
								],
								[
									126.75478515625014,
									34.511865234374966
								],
								[
									126.61083984374994,
									34.40351562500001
								],
								[
									126.58437499999997,
									34.31752929687508
								],
								[
									126.53144531250001,
									34.314257812500045
								],
								[
									126.50830078125011,
									34.350634765625074
								],
								[
									126.50644531250009,
									34.42836914062511
								],
								[
									126.48173828125005,
									34.49394531249996
								],
								[
									126.3326171875002,
									34.5896484375001
								],
								[
									126.26445312499999,
									34.67324218750008
								],
								[
									126.30107421874999,
									34.719970703125
								],
								[
									126.42558593750016,
									34.69458007812497
								],
								[
									126.52451171875003,
									34.69790039062494
								],
								[
									126.50498046875003,
									34.73754882812503
								],
								[
									126.47285156250018,
									34.75634765624994
								],
								[
									126.53857421874994,
									34.77866210937506
								],
								[
									126.5933593750002,
									34.82436523437505
								],
								[
									126.5479492187502,
									34.83676757812509
								],
								[
									126.478515625,
									34.81035156249993
								],
								[
									126.42070312500005,
									34.82338867187502
								],
								[
									126.39785156249997,
									34.932812499999926
								],
								[
									126.32744140625005,
									35.04511718749998
								],
								[
									126.2911132812502,
									35.15415039062509
								],
								[
									126.36054687500001,
									35.21689453124998
								],
								[
									126.39589843750014,
									35.314404296874955
								],
								[
									126.46044921874994,
									35.455615234375045
								],
								[
									126.49277343750003,
									35.5012695312501
								],
								[
									126.58222656250018,
									35.53447265624993
								],
								[
									126.61406250000016,
									35.5709960937501
								],
								[
									126.56494140625011,
									35.58974609375008
								],
								[
									126.48652343750001,
									35.60634765625011
								],
								[
									126.48847656250018,
									35.647070312500034
								],
								[
									126.54189453125014,
									35.669335937499966
								],
								[
									126.60156250000011,
									35.714208984375034
								],
								[
									126.71738281250009,
									35.76884765624999
								],
								[
									126.75302734375003,
									35.87197265625002
								],
								[
									126.71962890625002,
									35.89790039062498
								],
								[
									126.64746093749994,
									35.9224121093751
								],
								[
									126.66367187500003,
									35.974511718749966
								],
								[
									126.69345703125009,
									36.01416015625006
								],
								[
									126.68232421875001,
									36.037939453125006
								],
								[
									126.59707031249997,
									36.105029296875074
								],
								[
									126.54042968749997,
									36.16616210937502
								],
								[
									126.55722656250003,
									36.23583984375
								],
								[
									126.54423828125016,
									36.34121093750005
								],
								[
									126.55195312500001,
									36.42968749999997
								],
								[
									126.54824218749997,
									36.47763671875006
								],
								[
									126.50664062500005,
									36.58564453125004
								],
								[
									126.48769531250002,
									36.693798828124955
								],
								[
									126.43300781250014,
									36.67802734374993
								],
								[
									126.3887695312502,
									36.651171875000074
								],
								[
									126.23066406250001,
									36.6892578125001
								],
								[
									126.18085937500001,
									36.69160156250004
								],
								[
									126.16054687500014,
									36.77192382812507
								],
								[
									126.21718750000014,
									36.87094726562498
								],
								[
									126.3515625,
									36.9582031250001
								],
								[
									126.42871093749994,
									36.969042968750074
								],
								[
									126.48701171875001,
									37.007470703124994
								],
								[
									126.57773437500003,
									37.019580078125074
								],
								[
									126.68671875000007,
									36.96035156250008
								],
								[
									126.78447265625016,
									36.948437499999955
								],
								[
									126.83876953125014,
									36.84609375000008
								],
								[
									126.87207031249994,
									36.824462890625114
								],
								[
									126.87910156250018,
									36.86206054687494
								],
								[
									126.9580078125,
									36.90615234375005
								],
								[
									126.97685546874999,
									36.93940429687498
								],
								[
									126.95976562500016,
									36.95761718750006
								],
								[
									126.86894531250005,
									36.97573242187511
								],
								[
									126.78740234375005,
									37.102734374999955
								],
								[
									126.77607421875001,
									37.15820312499997
								],
								[
									126.74638671875005,
									37.19355468749998
								],
								[
									126.79052734374994,
									37.29492187500003
								],
								[
									126.69619140625002,
									37.41069335937499
								],
								[
									126.65029296874997,
									37.44711914062495
								],
								[
									126.65683593750009,
									37.55117187500011
								],
								[
									126.60761718750018,
									37.617431640625
								],
								[
									126.5801757812502,
									37.65375976562504
								],
								[
									126.56337890625014,
									37.71650390625004
								],
								[
									126.57773437500003,
									37.744726562500006
								],
								[
									126.6207031250002,
									37.75546875000006
								],
								[
									126.6338867187502,
									37.78183593750009
								],
								[
									126.66455078124994,
									37.800732421874955
								],
								[
									126.66650390625011,
									37.82792968749999
								],
								[
									126.66679687500016,
									37.91718750000007
								],
								[
									126.75429687500014,
									37.97895507812504
								],
								[
									126.87890625000011,
									38.10605468750006
								],
								[
									126.94003906250003,
									38.17558593750002
								],
								[
									127.00966796875014,
									38.24052734374993
								],
								[
									127.09033203125011,
									38.28388671875007
								],
								[
									127.16953125000009,
									38.304541015625006
								],
								[
									127.29404296875003,
									38.31328125000002
								],
								[
									127.53271484375011,
									38.30498046875002
								],
								[
									127.57949218750014,
									38.31249999999994
								],
								[
									127.74550781250002,
									38.31923828125008
								],
								[
									127.78466796875,
									38.30771484374995
								],
								[
									127.90527343749994,
									38.30043945312505
								],
								[
									128.03896484375002,
									38.30854492187504
								],
								[
									128.10625000000016,
									38.32734375000004
								],
								[
									128.16865234375007,
									38.35932617187498
								],
								[
									128.22314453124994,
									38.4169921875
								],
								[
									128.27929687499994,
									38.52377929687509
								],
								[
									128.33945312500003,
									38.60786132812498
								],
								[
									128.3746093750002,
									38.623437499999966
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "KOR",
					"su_a3": "KOR",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "KOR",
					"gu_a3": "KOR",
					"abbrev": "S.K.",
					"region_un": "Asia",
					"adm0_a3_us": "KOR",
					"scalerank": 1,
					"pop_est": 48508972,
					"adm0_dif": 0,
					"un_a3": "410",
					"pop_year": -99,
					"gdp_md_est": 1335000,
					"name": "Korea",
					"sovereignt": "South Korea",
					"economy": "4. Emerging region: MIKT",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "South Korea",
					"postal": "KR",
					"sov_a3": "KOR",
					"note_brk": "",
					"brk_a3": "KOR",
					"wb_a2": "KR",
					"brk_diff": 0,
					"admin": "South Korea",
					"name_long": "Republic of Korea",
					"iso_a3": "KOR",
					"iso_a2": "KR",
					"adm0_a3_is": "KOR",
					"level": 2,
					"formal_en": "Republic of Korea",
					"name_len": 5,
					"mapcolor7": 4,
					"long_len": 17,
					"mapcolor8": 1,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "410",
					"homepart": 1,
					"subunit": "South Korea",
					"name_alt": "",
					"brk_name": "Republic of Korea",
					"name_sort": "Korea, Rep.",
					"continent": "Asia",
					"mapcolor13": 5,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									48.275390625,
									29.624316406250074
								],
								[
									48.21826171875,
									29.60195312500005
								],
								[
									48.179687500000114,
									29.61142578125012
								],
								[
									48.142578125000114,
									29.66528320312497
								],
								[
									48.081445312499966,
									29.79892578125012
								],
								[
									48.114746093750114,
									29.848779296874966
								],
								[
									48.11347656250001,
									29.870214843749977
								],
								[
									48.12011718749994,
									29.886328124999977
								],
								[
									48.13886718750007,
									29.89658203125012
								],
								[
									48.158593749999966,
									29.959570312499977
								],
								[
									48.18476562500018,
									29.97885742187509
								],
								[
									48.22773437500001,
									29.936328125000045
								],
								[
									48.34824218750009,
									29.782666015625097
								],
								[
									48.34736328125018,
									29.719970703125114
								],
								[
									48.340234375000136,
									29.694726562499937
								],
								[
									48.275390625,
									29.624316406250074
								]
							]
						],
						[
							[
								[
									48.44248046875009,
									28.54291992187504
								],
								[
									48.26875000000007,
									28.540527343750085
								],
								[
									48.04960937500016,
									28.53750000000008
								],
								[
									47.871972656250136,
									28.535449218750017
								],
								[
									47.67128906250002,
									28.533154296875068
								],
								[
									47.58310546875009,
									28.627978515625045
								],
								[
									47.553222656250114,
									28.73154296875009
								],
								[
									47.52128906249999,
									28.837841796874983
								],
								[
									47.43320312500009,
									28.989550781250074
								],
								[
									47.138769531250034,
									29.026171875000074
								],
								[
									46.98222656250016,
									29.04565429687503
								],
								[
									46.72480468750018,
									29.07460937500008
								],
								[
									46.53144531250007,
									29.096240234375045
								],
								[
									46.69375000000008,
									29.259667968750023
								],
								[
									46.769335937500045,
									29.347460937500074
								],
								[
									46.905859375000034,
									29.537499999999966
								],
								[
									46.97597656250002,
									29.672851562500085
								],
								[
									47.04365234375001,
									29.822998046875057
								],
								[
									47.102050781250114,
									29.93999023437499
								],
								[
									47.114355468750034,
									29.96132812500008
								],
								[
									47.148242187500045,
									30.00097656249997
								],
								[
									47.223242187500034,
									30.04150390624997
								],
								[
									47.331347656250045,
									30.07968750000012
								],
								[
									47.51484375000001,
									30.096484375000074
								],
								[
									47.64375000000007,
									30.09731445312505
								],
								[
									47.672753906250136,
									30.09560546875008
								],
								[
									47.75390625000006,
									30.07661132812501
								],
								[
									47.97871093750001,
									29.982812500000108
								],
								[
									47.97363281249994,
									29.94589843749995
								],
								[
									48.00566406249999,
									29.835791015625063
								],
								[
									48.07734375000007,
									29.715576171875085
								],
								[
									48.136132812500136,
									29.618115234374955
								],
								[
									48.14345703125002,
									29.572460937499983
								],
								[
									48.089453125000034,
									29.5791015625
								],
								[
									48.04833984375,
									29.59750976562512
								],
								[
									47.969628906250136,
									29.61669921875003
								],
								[
									47.817480468750034,
									29.487402343749977
								],
								[
									47.72529296875018,
									29.41694335937501
								],
								[
									47.72265625,
									29.393017578124926
								],
								[
									47.845312500000034,
									29.365722656250057
								],
								[
									47.93535156250016,
									29.366601562499966
								],
								[
									47.99814453125009,
									29.385546875000102
								],
								[
									48.05146484375018,
									29.35537109375008
								],
								[
									48.08632812500002,
									29.275488281250063
								],
								[
									48.100390625000045,
									29.210742187500017
								],
								[
									48.18378906250007,
									28.97939453125005
								],
								[
									48.252929687500114,
									28.901269531249937
								],
								[
									48.339257812500136,
									28.763281249999977
								],
								[
									48.37128906250007,
									28.691845703125068
								],
								[
									48.3896484375,
									28.63159179687497
								],
								[
									48.44248046875009,
									28.54291992187504
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "KWT",
					"su_a3": "KWT",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "KWT",
					"gu_a3": "KWT",
					"abbrev": "Kwt.",
					"region_un": "Asia",
					"adm0_a3_us": "KWT",
					"scalerank": 1,
					"pop_est": 2691158,
					"adm0_dif": 0,
					"un_a3": "414",
					"pop_year": -99,
					"gdp_md_est": 149100,
					"name": "Kuwait",
					"sovereignt": "Kuwait",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Kuwait",
					"postal": "KW",
					"sov_a3": "KWT",
					"note_brk": "",
					"brk_a3": "KWT",
					"wb_a2": "KW",
					"brk_diff": 0,
					"admin": "Kuwait",
					"name_long": "Kuwait",
					"iso_a3": "KWT",
					"iso_a2": "KW",
					"adm0_a3_is": "KWT",
					"level": 2,
					"formal_en": "State of Kuwait",
					"name_len": 6,
					"mapcolor7": 2,
					"long_len": 6,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "414",
					"homepart": 1,
					"subunit": "Kuwait",
					"name_alt": "",
					"brk_name": "Kuwait",
					"name_sort": "Kuwait",
					"continent": "Asia",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									20.957812500000074,
									55.27890625000012
								],
								[
									20.89980468750005,
									55.2866699218751
								],
								[
									21.01406250000008,
									55.40195312499995
								],
								[
									21.057617187500057,
									55.476806640625114
								],
								[
									21.087890625,
									55.58310546875009
								],
								[
									21.114843750000006,
									55.61650390624996
								],
								[
									21.11572265625,
									55.568164062500074
								],
								[
									21.10390625000008,
									55.48774414062501
								],
								[
									21.03173828125003,
									55.35048828125005
								],
								[
									20.957812500000074,
									55.27890625000012
								]
							]
						],
						[
							[
								[
									26.593554687500074,
									55.66752929687496
								],
								[
									26.590820312500057,
									55.62265624999998
								],
								[
									26.56660156250001,
									55.54648437500009
								],
								[
									26.51923828125004,
									55.44814453125005
								],
								[
									26.469531250000017,
									55.37192382812506
								],
								[
									26.457617187500006,
									55.34248046875001
								],
								[
									26.49531250000004,
									55.318017578124994
								],
								[
									26.681250000000006,
									55.306445312500045
								],
								[
									26.76015625000008,
									55.29335937500002
								],
								[
									26.775683593750045,
									55.273095703124994
								],
								[
									26.73437499999997,
									55.24677734375004
								],
								[
									26.675000000000068,
									55.224902343750045
								],
								[
									26.648437500000057,
									55.20419921875009
								],
								[
									26.601171875000034,
									55.1301757812501
								],
								[
									26.291796875000045,
									55.13959960937507
								],
								[
									26.250781250000045,
									55.124511718750085
								],
								[
									26.231250000000074,
									55.09013671875002
								],
								[
									26.21582031250003,
									55.050390625000006
								],
								[
									26.175195312500023,
									55.00327148437509
								],
								[
									26.09296875000004,
									54.96230468750008
								],
								[
									25.964453125000063,
									54.94716796875002
								],
								[
									25.85927734375005,
									54.919287109375034
								],
								[
									25.780859375000063,
									54.833251953125
								],
								[
									25.722460937500074,
									54.717871093750034
								],
								[
									25.723925781250017,
									54.636035156250045
								],
								[
									25.731640625000068,
									54.59038085937499
								],
								[
									25.72480468750001,
									54.5642578125001
								],
								[
									25.685156250000006,
									54.53579101562505
								],
								[
									25.62031250000004,
									54.46040039062498
								],
								[
									25.56757812500004,
									54.37705078125006
								],
								[
									25.54736328125,
									54.33183593749999
								],
								[
									25.557519531250023,
									54.31069335937502
								],
								[
									25.61689453125004,
									54.3101074218751
								],
								[
									25.702539062499994,
									54.29296874999997
								],
								[
									25.748144531250063,
									54.25966796875002
								],
								[
									25.765039062500023,
									54.221191406250085
								],
								[
									25.765234374999977,
									54.179785156250006
								],
								[
									25.74921875000001,
									54.156982421875085
								],
								[
									25.68056640625005,
									54.14047851562509
								],
								[
									25.57304687499999,
									54.13989257812506
								],
								[
									25.510351562500006,
									54.15961914062498
								],
								[
									25.497363281250045,
									54.17524414062507
								],
								[
									25.52734375000003,
									54.21513671875002
								],
								[
									25.505664062500045,
									54.264941406250045
								],
								[
									25.46113281250004,
									54.29277343750002
								],
								[
									25.370605468750057,
									54.251220703125
								],
								[
									25.28369140625003,
									54.2512695312501
								],
								[
									25.179492187500017,
									54.21425781250002
								],
								[
									25.111425781250006,
									54.15493164062511
								],
								[
									25.04609375000004,
									54.133056640625085
								],
								[
									24.869531250000023,
									54.14516601562505
								],
								[
									24.825683593750057,
									54.11899414062506
								],
								[
									24.78925781250001,
									53.99824218750007
								],
								[
									24.768164062500063,
									53.97465820312496
								],
								[
									24.620703125000063,
									53.979833984375034
								],
								[
									24.47851562500003,
									53.93183593750004
								],
								[
									24.317968750000006,
									53.89296875000002
								],
								[
									24.236621093750045,
									53.91997070312502
								],
								[
									24.19130859375005,
									53.950439453125
								],
								[
									24.103906250000023,
									53.94501953125007
								],
								[
									24.00849609375004,
									53.931640625000085
								],
								[
									23.944433593750034,
									53.93896484374997
								],
								[
									23.872558593750057,
									53.93569335937502
								],
								[
									23.73369140624999,
									53.91225585937505
								],
								[
									23.55908203125003,
									53.91982421875008
								],
								[
									23.484667968750074,
									53.93979492187506
								],
								[
									23.477636718750063,
									53.95893554687504
								],
								[
									23.483007812500006,
									54.005957031250034
								],
								[
									23.481347656250023,
									54.079003906249994
								],
								[
									23.453613281250057,
									54.14345703125008
								],
								[
									23.3701171875,
									54.20048828124996
								],
								[
									23.282324218750063,
									54.24033203125009
								],
								[
									23.17031250000005,
									54.28144531250004
								],
								[
									23.087500000000063,
									54.299462890624966
								],
								[
									23.042187500000068,
									54.30419921875006
								],
								[
									23.03193359375004,
									54.327880859375085
								],
								[
									23.01552734375005,
									54.34833984375007
								],
								[
									22.976757812500068,
									54.36635742187511
								],
								[
									22.89394531250008,
									54.39052734375005
								],
								[
									22.823730468750057,
									54.39580078124996
								],
								[
									22.766210937499977,
									54.356787109375006
								],
								[
									22.724316406250068,
									54.405615234375006
								],
								[
									22.679882812500068,
									54.49301757812506
								],
								[
									22.684472656250023,
									54.5629394531251
								],
								[
									22.70966796875001,
									54.632617187500074
								],
								[
									22.83125000000001,
									54.83847656250009
								],
								[
									22.82470703125,
									54.87128906250001
								],
								[
									22.736523437500068,
									54.92885742187494
								],
								[
									22.627441406250057,
									54.97070312500003
								],
								[
									22.56728515625005,
									55.05913085937502
								],
								[
									22.346386718750068,
									55.06425781249999
								],
								[
									22.13789062500004,
									55.059375000000074
								],
								[
									22.072363281250034,
									55.063671874999955
								],
								[
									21.873925781250023,
									55.10073242187505
								],
								[
									21.682714843750034,
									55.16035156250004
								],
								[
									21.5546875,
									55.19531250000006
								],
								[
									21.44707031249999,
									55.23442382812493
								],
								[
									21.389257812500034,
									55.27553710937505
								],
								[
									21.29755859375001,
									55.2644531250001
								],
								[
									21.235742187500023,
									55.26411132812504
								],
								[
									21.236328125000057,
									55.271191406249955
								],
								[
									21.20107421875008,
									55.3437988281251
								],
								[
									21.237890625000006,
									55.455029296874926
								],
								[
									21.17109375000001,
									55.617724609375045
								],
								[
									21.06191406250005,
									55.81342773437504
								],
								[
									21.053808593750006,
									56.022949218750085
								],
								[
									21.04609375000001,
									56.070068359375
								],
								[
									21.31464843750001,
									56.18813476562508
								],
								[
									21.65351562500004,
									56.31455078124998
								],
								[
									21.730566406250034,
									56.325976562500074
								],
								[
									22.04287109375005,
									56.40078125000005
								],
								[
									22.084570312500034,
									56.406738281250114
								],
								[
									22.365917968750068,
									56.392871093750045
								],
								[
									22.586914062500057,
									56.37509765625006
								],
								[
									22.773242187500074,
									56.37729492187506
								],
								[
									22.875585937500063,
									56.39643554687504
								],
								[
									22.96826171875003,
									56.38041992187499
								],
								[
									23.042968750000057,
									56.32407226562506
								],
								[
									23.119824218749983,
									56.33066406249998
								],
								[
									23.195898437500034,
									56.36713867187504
								],
								[
									23.61269531250005,
									56.33383789062509
								],
								[
									23.70673828125001,
									56.33461914062508
								],
								[
									23.81269531250001,
									56.32924804687505
								],
								[
									24.00820312500005,
									56.295263671875034
								],
								[
									24.120703125000063,
									56.264257812500034
								],
								[
									24.367871093750068,
									56.283007812500045
								],
								[
									24.47363281250003,
									56.28408203125008
								],
								[
									24.52900390625001,
									56.29628906250008
								],
								[
									24.699511718750017,
									56.38129882812498
								],
								[
									24.773242187500045,
									56.39589843750002
								],
								[
									24.841015624999983,
									56.411181640625045
								],
								[
									24.90302734375001,
									56.39819335937506
								],
								[
									24.94384765624997,
									56.32558593750011
								],
								[
									25.069921875000006,
									56.20039062500007
								],
								[
									25.206933593750023,
									56.17841796875004
								],
								[
									25.585742187500017,
									56.13017578124999
								],
								[
									25.663183593750063,
									56.10483398437498
								],
								[
									25.87636718750008,
									55.99433593750001
								],
								[
									26.00419921874999,
									55.9401367187501
								],
								[
									26.085546875000063,
									55.89687500000005
								],
								[
									26.209570312500006,
									55.81210937500012
								],
								[
									26.28125000000003,
									55.75043945312498
								],
								[
									26.40107421875004,
									55.70380859374998
								],
								[
									26.54287109375005,
									55.67241210937499
								],
								[
									26.593554687500074,
									55.66752929687496
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "LTU",
					"su_a3": "LTU",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "LTU",
					"gu_a3": "LTU",
					"abbrev": "Lith.",
					"region_un": "Europe",
					"adm0_a3_us": "LTU",
					"scalerank": 1,
					"pop_est": 3555179,
					"adm0_dif": 0,
					"un_a3": "440",
					"pop_year": -99,
					"gdp_md_est": 63330,
					"name": "Lithuania",
					"sovereignt": "Lithuania",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Lithuania",
					"postal": "LT",
					"sov_a3": "LTU",
					"note_brk": "",
					"brk_a3": "LTU",
					"wb_a2": "LT",
					"brk_diff": 0,
					"admin": "Lithuania",
					"name_long": "Lithuania",
					"iso_a3": "LTU",
					"iso_a2": "LT",
					"adm0_a3_is": "LTU",
					"level": 2,
					"formal_en": "Republic of Lithuania",
					"name_len": 9,
					"mapcolor7": 6,
					"long_len": 9,
					"mapcolor8": 3,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "440",
					"homepart": 1,
					"subunit": "Lithuania",
					"name_alt": "",
					"brk_name": "Lithuania",
					"name_sort": "Lithuania",
					"continent": "Europe",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								27.351953125000023,
								57.528125000000045
							],
							[
								27.469726562500057,
								57.52402343750009
							],
							[
								27.51113281250005,
								57.50815429687506
							],
							[
								27.538671875000063,
								57.42978515625006
							],
							[
								27.672753906250023,
								57.36811523437504
							],
							[
								27.796875,
								57.3169433593751
							],
							[
								27.828613281250057,
								57.29331054687498
							],
							[
								27.83828125000008,
								57.24770507812502
							],
							[
								27.83027343750004,
								57.19448242187511
							],
							[
								27.814550781250034,
								57.16689453125008
							],
							[
								27.762792968750063,
								57.13510742187509
							],
							[
								27.717382812500063,
								57.05463867187504
							],
							[
								27.71113281250001,
								56.978076171875074
							],
							[
								27.639453125000074,
								56.8456542968751
							],
							[
								27.655664062499994,
								56.84321289062504
							],
							[
								27.80605468750008,
								56.86708984375011
							],
							[
								27.848632812500057,
								56.85341796875008
							],
							[
								27.88154296875001,
								56.82416992187507
							],
							[
								27.89208984375003,
								56.741064453125006
							],
							[
								27.94140625000003,
								56.703710937500034
							],
							[
								27.99160156250005,
								56.645312500000045
							],
							[
								28.00751953125001,
								56.599853515625114
							],
							[
								28.103125000000034,
								56.545703125000074
							],
							[
								28.11083984375,
								56.51069335937507
							],
							[
								28.169238281250017,
								56.386865234374966
							],
							[
								28.191699218750045,
								56.31557617187511
							],
							[
								28.202050781250023,
								56.26040039062505
							],
							[
								28.17333984375003,
								56.19033203125008
							],
							[
								28.14794921875003,
								56.142919921875006
							],
							[
								28.11787109375001,
								56.14580078124996
							],
							[
								28.032031250000017,
								56.13330078125
							],
							[
								27.89628906249999,
								56.076171875
							],
							[
								27.69423828125005,
								55.94155273437502
							],
							[
								27.64228515625004,
								55.91171874999998
							],
							[
								27.589453125000006,
								55.80917968750006
							],
							[
								27.576757812500006,
								55.79877929687507
							],
							[
								27.45917968750004,
								55.80351562499996
							],
							[
								27.42714843750008,
								55.80595703125002
							],
							[
								27.309179687500034,
								55.80390625000004
							],
							[
								27.052539062500045,
								55.83056640625006
							],
							[
								26.953027343750023,
								55.81293945312501
							],
							[
								26.822460937500068,
								55.70922851562503
							],
							[
								26.77187500000008,
								55.69399414062502
							],
							[
								26.620214843750006,
								55.67963867187504
							],
							[
								26.593554687500074,
								55.66752929687496
							],
							[
								26.54287109375005,
								55.67241210937499
							],
							[
								26.40107421875004,
								55.70380859374998
							],
							[
								26.28125000000003,
								55.75043945312498
							],
							[
								26.209570312500006,
								55.81210937500012
							],
							[
								26.085546875000063,
								55.89687500000005
							],
							[
								26.00419921874999,
								55.9401367187501
							],
							[
								25.87636718750008,
								55.99433593750001
							],
							[
								25.663183593750063,
								56.10483398437498
							],
							[
								25.585742187500017,
								56.13017578124999
							],
							[
								25.206933593750023,
								56.17841796875004
							],
							[
								25.069921875000006,
								56.20039062500007
							],
							[
								24.94384765624997,
								56.32558593750011
							],
							[
								24.90302734375001,
								56.39819335937506
							],
							[
								24.841015624999983,
								56.411181640625045
							],
							[
								24.773242187500045,
								56.39589843750002
							],
							[
								24.699511718750017,
								56.38129882812498
							],
							[
								24.52900390625001,
								56.29628906250008
							],
							[
								24.47363281250003,
								56.28408203125008
							],
							[
								24.367871093750068,
								56.283007812500045
							],
							[
								24.120703125000063,
								56.264257812500034
							],
							[
								24.00820312500005,
								56.295263671875034
							],
							[
								23.81269531250001,
								56.32924804687505
							],
							[
								23.70673828125001,
								56.33461914062508
							],
							[
								23.61269531250005,
								56.33383789062509
							],
							[
								23.195898437500034,
								56.36713867187504
							],
							[
								23.119824218749983,
								56.33066406249998
							],
							[
								23.042968750000057,
								56.32407226562506
							],
							[
								22.96826171875003,
								56.38041992187499
							],
							[
								22.875585937500063,
								56.39643554687504
							],
							[
								22.773242187500074,
								56.37729492187506
							],
							[
								22.586914062500057,
								56.37509765625006
							],
							[
								22.365917968750068,
								56.392871093750045
							],
							[
								22.084570312500034,
								56.406738281250114
							],
							[
								22.04287109375005,
								56.40078125000005
							],
							[
								21.730566406250034,
								56.325976562500074
							],
							[
								21.65351562500004,
								56.31455078124998
							],
							[
								21.31464843750001,
								56.18813476562508
							],
							[
								21.04609375000001,
								56.070068359375
							],
							[
								21.014941406250074,
								56.25893554687502
							],
							[
								21.031445312500068,
								56.636572265625034
							],
							[
								21.0712890625,
								56.82373046874997
							],
							[
								21.257421875000006,
								56.932763671874994
							],
							[
								21.35078125000001,
								57.01767578125006
							],
							[
								21.405078125000074,
								57.13100585937505
							],
							[
								21.421484375000034,
								57.23583984375
							],
							[
								21.459179687500068,
								57.32246093750007
							],
							[
								21.72871093750001,
								57.57099609375007
							],
							[
								21.9423828125,
								57.59785156250004
							],
							[
								22.23144531250003,
								57.666796875000045
							],
							[
								22.554589843750023,
								57.72426757812502
							],
							[
								22.616992187500045,
								57.65117187499996
							],
							[
								22.64863281250001,
								57.595361328124966
							],
							[
								23.037792968750068,
								57.39208984375003
							],
							[
								23.136816406249977,
								57.32382812499998
							],
							[
								23.28730468750001,
								57.089746093749994
							],
							[
								23.647753906250074,
								56.97104492187506
							],
							[
								23.93115234375,
								57.00849609375004
							],
							[
								24.054296875000034,
								57.06611328125007
							],
							[
								24.28125,
								57.17231445312501
							],
							[
								24.382617187500045,
								57.25004882812496
							],
							[
								24.40322265625005,
								57.325000000000045
							],
							[
								24.36298828125004,
								57.64531250000002
							],
							[
								24.301562500000045,
								57.78413085937507
							],
							[
								24.322558593750074,
								57.87060546875
							],
							[
								24.36250000000004,
								57.86616210937498
							],
							[
								24.458886718750023,
								57.90786132812505
							],
							[
								24.775781250000023,
								57.985253906249994
							],
							[
								24.83906250000004,
								57.98872070312507
							],
							[
								24.91132812500001,
								58.00458984375004
							],
							[
								25.11103515625001,
								58.06342773437501
							],
							[
								25.17519531250005,
								58.03212890625005
							],
							[
								25.22871093750001,
								57.996582031250085
							],
							[
								25.25830078125,
								57.99614257812499
							],
							[
								25.27265625000001,
								58.00937500000012
							],
							[
								25.268652343750063,
								58.03222656249997
							],
							[
								25.28261718750008,
								58.048486328124994
							],
							[
								25.34003906250004,
								58.03945312500002
							],
							[
								25.5712890625,
								57.94277343750005
							],
							[
								25.66015624999997,
								57.92016601562497
							],
							[
								25.72089843750001,
								57.913818359375085
							],
							[
								25.793750000000017,
								57.86855468750002
							],
							[
								25.99111328125008,
								57.83818359374996
							],
							[
								26.015234375000034,
								57.81474609374999
							],
							[
								26.030371093750006,
								57.78554687500008
							],
							[
								26.21503906250004,
								57.66274414062502
							],
							[
								26.29804687500001,
								57.60107421874997
							],
							[
								26.46210937500004,
								57.54448242187499
							],
							[
								26.532617187499994,
								57.531005859375
							],
							[
								26.81972656250005,
								57.588720703125034
							],
							[
								26.899804687500023,
								57.60878906250005
							],
							[
								26.96601562500001,
								57.609130859375114
							],
							[
								27.033398437500068,
								57.57875976562505
							],
							[
								27.187109375000034,
								57.538330078125085
							],
							[
								27.326562500000023,
								57.525488281250034
							],
							[
								27.351953125000023,
								57.528125000000045
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "LVA",
					"su_a3": "LVA",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "LVA",
					"gu_a3": "LVA",
					"abbrev": "Lat.",
					"region_un": "Europe",
					"adm0_a3_us": "LVA",
					"scalerank": 1,
					"pop_est": 2231503,
					"adm0_dif": 0,
					"un_a3": "428",
					"pop_year": -99,
					"gdp_md_est": 38860,
					"name": "Latvia",
					"sovereignt": "Latvia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Latvia",
					"postal": "LV",
					"sov_a3": "LVA",
					"note_brk": "",
					"brk_a3": "LVA",
					"wb_a2": "LV",
					"brk_diff": 0,
					"admin": "Latvia",
					"name_long": "Latvia",
					"iso_a3": "LVA",
					"iso_a2": "LV",
					"adm0_a3_is": "LVA",
					"level": 2,
					"formal_en": "Republic of Latvia",
					"name_len": 6,
					"mapcolor7": 4,
					"long_len": 6,
					"mapcolor8": 7,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "428",
					"homepart": 1,
					"subunit": "Latvia",
					"name_alt": "",
					"brk_name": "Latvia",
					"name_sort": "Latvia",
					"continent": "Europe",
					"mapcolor13": 13,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-2.219628906249966,
								35.10419921875004
							],
							[
								-2.190771484374949,
								35.02978515625006
							],
							[
								-2.131787109374926,
								34.97084960937505
							],
							[
								-1.9208984374999432,
								34.835546875000006
							],
							[
								-1.795605468749926,
								34.75190429687501
							],
							[
								-1.792187499999926,
								34.723193359375045
							],
							[
								-1.832421874999966,
								34.654638671875006
							],
							[
								-1.849658203125017,
								34.607324218749966
							],
							[
								-1.816601562499926,
								34.55708007812504
							],
							[
								-1.739453124999926,
								34.49609375000003
							],
							[
								-1.7333007812499375,
								34.467041015625085
							],
							[
								-1.751855468749966,
								34.43325195312502
							],
							[
								-1.7917968749999318,
								34.36791992187503
							],
							[
								-1.706933593749966,
								34.176074218750045
							],
							[
								-1.6926757812499886,
								33.99028320312502
							],
							[
								-1.7146972656249488,
								33.85820312500002
							],
							[
								-1.7141113281250284,
								33.781835937500006
							],
							[
								-1.7029785156249773,
								33.7168457031251
							],
							[
								-1.6312500000000227,
								33.56674804687498
							],
							[
								-1.67919921875,
								33.318652343750074
							],
							[
								-1.6250976562499204,
								33.18334960937503
							],
							[
								-1.5507324218749545,
								33.07358398437506
							],
							[
								-1.510009765625,
								32.87763671875001
							],
							[
								-1.4499999999999318,
								32.78481445312502
							],
							[
								-1.3521484375000057,
								32.70336914062503
							],
							[
								-1.29638671875,
								32.67568359375008
							],
							[
								-1.188232421875,
								32.60849609374998
							],
							[
								-1.111035156249983,
								32.55229492187499
							],
							[
								-1.0655273437499488,
								32.46831054687502
							],
							[
								-1.16259765625,
								32.39916992187506
							],
							[
								-1.2403320312499488,
								32.33759765625004
							],
							[
								-1.2621093749999375,
								32.271142578124994
							],
							[
								-1.2259277343749488,
								32.16455078125003
							],
							[
								-1.2259277343749488,
								32.107226562500074
							],
							[
								-1.275341796874983,
								32.08901367187502
							],
							[
								-1.4770507812499432,
								32.094873046874966
							],
							[
								-1.6351562499999943,
								32.09956054687504
							],
							[
								-1.8169921874999204,
								32.104785156250045
							],
							[
								-2.0728027343749886,
								32.11503906249999
							],
							[
								-2.231249999999932,
								32.12133789062503
							],
							[
								-2.4483886718749375,
								32.12998046875009
							],
							[
								-2.523242187499932,
								32.12568359375004
							],
							[
								-2.7226074218749545,
								32.095751953125045
							],
							[
								-2.8634277343749375,
								32.07470703125003
							],
							[
								-2.88720703125,
								32.068847656250085
							],
							[
								-2.930859374999926,
								32.04252929687496
							],
							[
								-2.9611328124999545,
								31.963964843750034
							],
							[
								-2.988232421874983,
								31.87421875000004
							],
							[
								-3.01738281249996,
								31.83427734374999
							],
							[
								-3.439794921874949,
								31.70454101562504
							],
							[
								-3.604589843749949,
								31.686767578125057
							],
							[
								-3.7002441406249886,
								31.700097656250108
							],
							[
								-3.7681640624999773,
								31.68955078125009
							],
							[
								-3.8267578124999204,
								31.66191406249996
							],
							[
								-3.8466796874999716,
								31.619873046875085
							],
							[
								-3.8495605468749545,
								31.56640625000003
							],
							[
								-3.837109374999983,
								31.51235351562505
							],
							[
								-3.79643554687496,
								31.43710937500009
							],
							[
								-3.7891601562499773,
								31.361816406250114
							],
							[
								-3.8151367187499545,
								31.30883789062497
							],
							[
								-3.8213867187499773,
								31.25546875000012
							],
							[
								-3.8333984374999375,
								31.197802734375074
							],
							[
								-3.8118164062499886,
								31.166601562500034
							],
							[
								-3.7709960937500284,
								31.16181640625004
							],
							[
								-3.7301757812499545,
								31.13540039062508
							],
							[
								-3.6725097656249375,
								31.111376953125074
							],
							[
								-3.6245117187500284,
								31.065771484375006
							],
							[
								-3.626904296874983,
								31.00092773437504
							],
							[
								-3.666796874999932,
								30.96401367187505
							],
							[
								-3.7020019531250057,
								30.944482421874994
							],
							[
								-3.8600585937499545,
								30.92724609375003
							],
							[
								-3.9853515625,
								30.913525390625068
							],
							[
								-4.148779296874977,
								30.80957031250003
							],
							[
								-4.32285156249992,
								30.69887695312505
							],
							[
								-4.52915039062492,
								30.625537109375017
							],
							[
								-4.619628906249972,
								30.604785156250074
							],
							[
								-4.778515624999926,
								30.55239257812505
							],
							[
								-4.968261718749943,
								30.465380859375074
							],
							[
								-5.0619140624999375,
								30.326416015625114
							],
							[
								-5.1801269531249545,
								30.166162109374966
							],
							[
								-5.293652343749983,
								30.058642578125102
							],
							[
								-5.44877929687496,
								29.95693359375005
							],
							[
								-5.593310546874932,
								29.91796875000003
							],
							[
								-5.774999999999977,
								29.869042968750108
							],
							[
								-6.004296874999994,
								29.83125000000004
							],
							[
								-6.16650390625,
								29.81894531250012
							],
							[
								-6.214794921874983,
								29.810693359375023
							],
							[
								-6.357617187499926,
								29.808300781249983
							],
							[
								-6.427636718749994,
								29.816113281250068
							],
							[
								-6.479736328124943,
								29.820361328125045
							],
							[
								-6.500878906249994,
								29.809130859375074
							],
							[
								-6.50791015624992,
								29.783789062500063
							],
							[
								-6.5106933593749545,
								29.72602539062501
							],
							[
								-6.520556640624989,
								29.65986328125004
							],
							[
								-6.565673828124943,
								29.603857421875063
							],
							[
								-6.59775390624992,
								29.578955078124977
							],
							[
								-6.635351562499949,
								29.56879882812504
							],
							[
								-6.755126953125,
								29.58383789062509
							],
							[
								-6.855566406249949,
								29.601611328125074
							],
							[
								-7.0949218749999545,
								29.625195312499983
							],
							[
								-7.142431640624949,
								29.619580078125068
							],
							[
								-7.160205078124932,
								29.61264648437509
							],
							[
								-7.23491210937496,
								29.57490234375004
							],
							[
								-7.349755859374994,
								29.494726562500034
							],
							[
								-7.427685546874983,
								29.42500000000004
							],
							[
								-7.485742187499994,
								29.39223632812505
							],
							[
								-7.624609374999949,
								29.37519531250004
							],
							[
								-7.685156249999949,
								29.34951171875005
							],
							[
								-7.943847656249972,
								29.17475585937504
							],
							[
								-7.998925781249994,
								29.132421875000034
							],
							[
								-8.265185546874989,
								28.980517578125102
							],
							[
								-8.340478515624966,
								28.930175781250057
							],
							[
								-8.399316406249937,
								28.88017578124999
							],
							[
								-8.558349609375028,
								28.767871093750017
							],
							[
								-8.659912109375028,
								28.71860351562512
							],
							[
								-8.678417968749955,
								28.68940429687504
							],
							[
								-8.683349609375,
								28.62075195312508
							],
							[
								-8.683349609375,
								28.46923828125003
							],
							[
								-8.683349609375,
								28.32368164062504
							],
							[
								-8.683349609375,
								28.112011718750068
							],
							[
								-8.683349609375,
								27.900390625000057
							],
							[
								-8.683349609375,
								27.656445312499983
							],
							[
								-8.817822265624955,
								27.656445312500097
							],
							[
								-8.817773437499937,
								27.65590820312505
							],
							[
								-8.813916015624955,
								27.61386718750012
							],
							[
								-8.784570312500023,
								27.53085937500009
							],
							[
								-8.774365234374983,
								27.460546875000063
							],
							[
								-8.788964843749937,
								27.416552734375074
							],
							[
								-8.802685546874983,
								27.360937500000006
							],
							[
								-8.796826171874926,
								27.30820312500009
							],
							[
								-8.774365234374983,
								27.25058593750009
							],
							[
								-8.753857421874983,
								27.191015625000034
							],
							[
								-8.753857421874983,
								27.150976562500034
							],
							[
								-8.794873046874983,
								27.120703125000006
							],
							[
								-8.889062499999994,
								27.10410156250009
							],
							[
								-9.001904296874955,
								27.090429687500063
							],
							[
								-9.084423828124983,
								27.090429687500063
							],
							[
								-9.208447265624955,
								27.100195312500006
							],
							[
								-9.285595703124955,
								27.098242187500063
							],
							[
								-9.352978515624983,
								27.098242187500063
							],
							[
								-9.413037109374983,
								27.08847656250009
							],
							[
								-9.4873046875,
								27.050390624999977
							],
							[
								-9.569824218749943,
								26.99082031250009
							],
							[
								-9.673339843749972,
								26.910742187500034
							],
							[
								-9.7353515625,
								26.86093750000012
							],
							[
								-9.817871093749943,
								26.850195312500063
							],
							[
								-9.900341796874955,
								26.850195312500063
							],
							[
								-9.980908203124926,
								26.890234375000034
							],
							[
								-10.03271484375,
								26.910742187500034
							],
							[
								-10.066845703124955,
								26.90878906250009
							],
							[
								-10.123046874999943,
								26.880468750000006
							],
							[
								-10.189453124999972,
								26.86093750000012
							],
							[
								-10.251464843749972,
								26.86093750000012
							],
							[
								-10.354931640624926,
								26.900976562500006
							],
							[
								-10.478955078124955,
								26.960546874999977
							],
							[
								-10.551269531249943,
								26.99082031250009
							],
							[
								-10.654248046874983,
								27.000585937500063
							],
							[
								-10.757763671874926,
								27.020117187500034
							],
							[
								-10.830078125,
								27.01035156250009
							],
							[
								-10.922802734374983,
								27.01035156250009
							],
							[
								-11.046826171874926,
								26.970312500000006
							],
							[
								-11.150341796874955,
								26.94101562500009
							],
							[
								-11.263623046874955,
								26.910742187500034
							],
							[
								-11.392578124999943,
								26.883398437499977
							],
							[
								-11.361279296874955,
								26.793554687500063
							],
							[
								-11.316845703124955,
								26.744726562500063
							],
							[
								-11.316845703124955,
								26.684179687499977
							],
							[
								-11.337890624999972,
								26.633398437500034
							],
							[
								-11.39990234375,
								26.583593750000006
							],
							[
								-11.470703124999943,
								26.520117187500034
							],
							[
								-11.511669921874955,
								26.47031250000012
							],
							[
								-11.553173828124955,
								26.40097656250012
							],
							[
								-11.583984374999943,
								26.360937500000034
							],
							[
								-11.637207031249943,
								26.29550781250012
							],
							[
								-11.684521484374983,
								26.213476562500006
							],
							[
								-11.699218749999972,
								26.162695312500063
							],
							[
								-11.718212890624926,
								26.10410156250012
							],
							[
								-11.754882812499943,
								26.08652343750009
							],
							[
								-11.880859374999943,
								26.070898437500006
							],
							[
								-11.960888671874983,
								26.050390625000006
							],
							[
								-12.03076171875,
								26.03085937500012
							],
							[
								-12.056787109374994,
								25.996337890625
							],
							[
								-12.060986328124955,
								25.99082031249995
							],
							[
								-12.081054687499943,
								25.920507812500006
							],
							[
								-12.081054687499943,
								25.87070312500009
							],
							[
								-12.101025390624926,
								25.830664062500006
							],
							[
								-12.130859374999972,
								25.731054687500063
							],
							[
								-12.170849609374955,
								25.64023437500012
							],
							[
								-12.201123046874983,
								25.520117187499977
							],
							[
								-12.230957031249943,
								25.42050781250012
							],
							[
								-12.270947265625011,
								25.260302734375074
							],
							[
								-12.310986328124983,
								25.11093750000009
							],
							[
								-12.360839843750028,
								24.970312500000063
							],
							[
								-12.40087890625,
								24.880468750000034
							],
							[
								-12.431152343749943,
								24.83066406250012
							],
							[
								-12.500976562499972,
								24.77011718749995
							],
							[
								-12.561035156249943,
								24.731054687499977
							],
							[
								-12.630810546874955,
								24.680273437500034
							],
							[
								-12.710937499999943,
								24.630468750000006
							],
							[
								-12.820751953124926,
								24.57089843749995
							],
							[
								-12.911132812499943,
								24.52011718750009
							],
							[
								-12.947851562499977,
								24.49726562500004
							],
							[
								-12.991162109375011,
								24.470312499999977
							],
							[
								-13.061035156249943,
								24.400976562500063
							],
							[
								-13.12109375,
								24.30039062500009
							],
							[
								-13.1611328125,
								24.22031250000012
							],
							[
								-13.23095703125,
								24.090429687500034
							],
							[
								-13.280761718749943,
								24.020117187500006
							],
							[
								-13.310986328124955,
								23.98105468749995
							],
							[
								-13.391113281249943,
								23.941015625000063
							],
							[
								-13.480957031249943,
								23.91074218750012
							],
							[
								-13.5810546875,
								23.870703125000034
							],
							[
								-13.661083984374983,
								23.830664062500034
							],
							[
								-13.770947265624983,
								23.790625000000063
							],
							[
								-13.840771484374983,
								23.750585937500063
							],
							[
								-13.891113281249943,
								23.69101562500012
							],
							[
								-13.931103515625011,
								23.62070312500009
							],
							[
								-13.980908203124926,
								23.52011718750012
							],
							[
								-14.020996093750028,
								23.410742187500034
							],
							[
								-14.040966796875011,
								23.340429687500006
							],
							[
								-14.10107421875,
								23.10019531250009
							],
							[
								-14.121093749999972,
								22.960546875000063
							],
							[
								-14.141064453124955,
								22.870703125000063
							],
							[
								-14.1708984375,
								22.76035156249995
							],
							[
								-14.190869140624983,
								22.590429687499977
							],
							[
								-14.190869140624983,
								22.45078124999995
							],
							[
								-14.2109375,
								22.370703124999977
							],
							[
								-14.221191406249943,
								22.310156250000063
							],
							[
								-14.270996093749972,
								22.240820312499977
							],
							[
								-14.311035156249943,
								22.191015625000063
							],
							[
								-14.380810546874955,
								22.12070312500012
							],
							[
								-14.440917968749943,
								22.08066406249995
							],
							[
								-14.460888671874926,
								22.040625000000063
							],
							[
								-14.52099609375,
								21.99086914062505
							],
							[
								-14.581005859374983,
								21.910742187500063
							],
							[
								-14.630859375,
								21.86093749999995
							],
							[
								-14.621093749999972,
								21.820898437500063
							],
							[
								-14.610791015625011,
								21.750585937500034
							],
							[
								-14.641113281249972,
								21.680273437500006
							],
							[
								-14.670849609374983,
								21.600195312500034
							],
							[
								-14.750976562499972,
								21.50058593750009
							],
							[
								-14.840820312499972,
								21.450781250000063
							],
							[
								-14.971142578124955,
								21.44101562500012
							],
							[
								-15.15087890625,
								21.44101562500012
							],
							[
								-15.290966796874926,
								21.450781250000063
							],
							[
								-15.4609375,
								21.450781250000063
							],
							[
								-15.610791015624983,
								21.47031249999995
							],
							[
								-15.750927734374926,
								21.49082031249995
							],
							[
								-15.920849609375011,
								21.50058593750009
							],
							[
								-16.04101562499997,
								21.50058593750009
							],
							[
								-16.190869140624955,
								21.481054687500006
							],
							[
								-16.581005859374926,
								21.481054687500006
							],
							[
								-16.73095703125003,
								21.47031249999995
							],
							[
								-16.951123046874926,
								21.430273437500063
							],
							[
								-17.002978515624932,
								21.420751953124977
							],
							[
								-17.003076171874937,
								21.420703125000045
							],
							[
								-16.930859374999983,
								21.900000000000006
							],
							[
								-16.793261718750017,
								22.159716796875074
							],
							[
								-16.683984374999966,
								22.274365234375068
							],
							[
								-16.514404296874943,
								22.333496093749943
							],
							[
								-16.35874023437495,
								22.594531250000102
							],
							[
								-16.30429687499995,
								22.83481445312512
							],
							[
								-16.201855468749955,
								22.94536132812499
							],
							[
								-16.16972656249999,
								23.03193359375004
							],
							[
								-16.21025390624999,
								23.09790039062497
							],
							[
								-16.113671874999937,
								23.227539062500085
							],
							[
								-15.996728515624994,
								23.425488281249926
							],
							[
								-15.942626953125,
								23.55263671875008
							],
							[
								-15.80595703124996,
								23.749511718749943
							],
							[
								-15.789257812499926,
								23.79287109375008
							],
							[
								-15.801660156249966,
								23.84223632812501
							],
							[
								-15.855175781249955,
								23.800341796875074
							],
							[
								-15.912548828125011,
								23.727587890625102
							],
							[
								-15.980712890624943,
								23.67031250000005
							],
							[
								-15.952832031249955,
								23.74082031249995
							],
							[
								-15.899316406249966,
								23.84443359375001
							],
							[
								-15.777783203124983,
								23.952929687500074
							],
							[
								-15.586328124999966,
								24.072753906250085
							],
							[
								-15.188623046874966,
								24.478808593750017
							],
							[
								-15.038867187499989,
								24.548828125000085
							],
							[
								-14.904296875000028,
								24.71977539062499
							],
							[
								-14.856054687499977,
								24.871582031250114
							],
							[
								-14.842919921874966,
								25.220117187499966
							],
							[
								-14.794921874999943,
								25.404150390624977
							],
							[
								-14.707031249999972,
								25.54770507812509
							],
							[
								-14.602294921874972,
								25.80854492187504
							],
							[
								-14.522753906250017,
								25.925244140625097
							],
							[
								-14.470556640624949,
								26.16303710937504
							],
							[
								-14.413867187499932,
								26.253710937500045
							],
							[
								-14.312451171874983,
								26.296728515625006
							],
							[
								-14.168359375000023,
								26.415429687499937
							],
							[
								-13.952099609374926,
								26.488769531250057
							],
							[
								-13.695898437499949,
								26.64291992187509
							],
							[
								-13.575781250000006,
								26.735107421875057
							],
							[
								-13.495751953124937,
								26.872656250000006
							],
							[
								-13.409814453124937,
								27.14663085937505
							],
							[
								-13.256152343749989,
								27.434619140625017
							],
							[
								-13.177392578125023,
								27.651855468749943
							],
							[
								-13.175976562499983,
								27.65571289062501
							],
							[
								-13.040722656249983,
								27.769824218750102
							],
							[
								-12.948925781249926,
								27.914160156250006
							],
							[
								-12.793652343750011,
								27.97841796875005
							],
							[
								-12.468896484374994,
								28.009423828124966
							],
							[
								-11.986083984374972,
								28.12929687500005
							],
							[
								-11.552685546874955,
								28.310107421874932
							],
							[
								-11.430175781249943,
								28.38203125000001
							],
							[
								-11.299072265624972,
								28.526074218750068
							],
							[
								-11.080957031249966,
								28.713769531250023
							],
							[
								-10.673828124999972,
								28.93920898437503
							],
							[
								-10.486474609374994,
								29.06494140624997
							],
							[
								-10.200585937500023,
								29.380371093750114
							],
							[
								-10.010498046875,
								29.641406250000074
							],
							[
								-9.852636718750006,
								29.809228515624994
							],
							[
								-9.74345703124996,
								29.958203125000068
							],
							[
								-9.667089843749949,
								30.109277343750108
							],
							[
								-9.623828124999932,
								30.352636718750034
							],
							[
								-9.652929687500006,
								30.447558593750102
							],
							[
								-9.773144531249983,
								30.60312500000009
							],
							[
								-9.853906249999994,
								30.644580078125102
							],
							[
								-9.875488281249943,
								30.717919921875023
							],
							[
								-9.832421874999966,
								30.84726562500009
							],
							[
								-9.833349609374977,
								31.069628906250074
							],
							[
								-9.80869140624992,
								31.424609374999932
							],
							[
								-9.674951171874937,
								31.710986328125102
							],
							[
								-9.347460937499932,
								32.086376953124926
							],
							[
								-9.286572265624955,
								32.24057617187506
							],
							[
								-9.249121093749977,
								32.48583984374994
							],
							[
								-9.245849609375028,
								32.57246093750001
							],
							[
								-8.83623046874996,
								32.92045898437502
							],
							[
								-8.59628906249992,
								33.18715820312511
							],
							[
								-8.512841796874994,
								33.252441406250085
							],
							[
								-8.301171874999937,
								33.37436523437495
							],
							[
								-7.562353515624977,
								33.64028320312505
							],
							[
								-7.144677734374966,
								33.83032226562494
							],
							[
								-6.900976562499977,
								33.96904296874996
							],
							[
								-6.755761718749966,
								34.13291015624995
							],
							[
								-6.353125000000006,
								34.77607421875007
							],
							[
								-5.95756835937496,
								35.68115234374997
							],
							[
								-5.924804687499943,
								35.78579101562505
							],
							[
								-5.747949218749994,
								35.81596679687499
							],
							[
								-5.622851562499989,
								35.82890624999996
							],
							[
								-5.522265624999932,
								35.862011718749955
							],
							[
								-5.397363281249966,
								35.929882812499926
							],
							[
								-5.277832031249943,
								35.902734374999994
							],
							[
								-5.337646484374972,
								35.85654296875009
							],
							[
								-5.337646484374972,
								35.74521484375006
							],
							[
								-5.252685546874972,
								35.61474609374994
							],
							[
								-5.105371093749994,
								35.46777343750003
							],
							[
								-4.837207031249989,
								35.28129882812496
							],
							[
								-4.628320312499966,
								35.20639648437498
							],
							[
								-4.3299804687499375,
								35.16147460937506
							],
							[
								-3.982421875,
								35.24340820312506
							],
							[
								-3.7879882812500227,
								35.2449218750001
							],
							[
								-3.6932617187499943,
								35.279980468749955
							],
							[
								-3.59062499999996,
								35.2283203125001
							],
							[
								-3.394726562499926,
								35.21181640625011
							],
							[
								-3.206005859374926,
								35.23911132812498
							],
							[
								-3.063085937499949,
								35.31723632812509
							],
							[
								-2.9722167968749886,
								35.407275390625045
							],
							[
								-2.957958984374926,
								35.36308593750002
							],
							[
								-2.953613281249943,
								35.315136718749926
							],
							[
								-2.925976562499983,
								35.287109375000085
							],
							[
								-2.8695312499999375,
								35.17265625000002
							],
							[
								-2.839941406249949,
								35.12783203125005
							],
							[
								-2.7313964843749545,
								35.13520507812504
							],
							[
								-2.6368164062499773,
								35.11269531250008
							],
							[
								-2.4237304687499943,
								35.123486328124955
							],
							[
								-2.219628906249966,
								35.10419921875004
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Africa",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "MAR",
					"su_a3": "MAR",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "MAR",
					"gu_a3": "MAR",
					"abbrev": "Mor.",
					"region_un": "Africa",
					"adm0_a3_us": "MAR",
					"scalerank": 1,
					"pop_est": 34859364,
					"adm0_dif": 0,
					"un_a3": "504",
					"pop_year": -99,
					"gdp_md_est": 136600,
					"name": "Morocco",
					"sovereignt": "Morocco",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Morocco",
					"postal": "MA",
					"sov_a3": "MAR",
					"note_brk": "",
					"brk_a3": "MAR",
					"wb_a2": "MA",
					"brk_diff": 0,
					"admin": "Morocco",
					"name_long": "Morocco",
					"iso_a3": "MAR",
					"iso_a2": "MA",
					"adm0_a3_is": "MAR",
					"level": 2,
					"formal_en": "Kingdom of Morocco",
					"name_len": 7,
					"mapcolor7": 2,
					"long_len": 7,
					"mapcolor8": 2,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "504",
					"homepart": 1,
					"subunit": "Morocco",
					"name_alt": "",
					"brk_name": "Morocco",
					"name_sort": "Morocco",
					"continent": "Africa",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2004
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-91.68369140624998,
									18.677343750000006
								],
								[
									-91.79614257812497,
									18.654199218749994
								],
								[
									-91.81611328124995,
									18.675878906250063
								],
								[
									-91.58911132812497,
									18.778027343750097
								],
								[
									-91.55029296874997,
									18.773681640625
								],
								[
									-91.53671874999998,
									18.76000976562497
								],
								[
									-91.65424804687493,
									18.71147460937513
								],
								[
									-91.68369140624998,
									18.677343750000006
								]
							]
						],
						[
							[
								[
									-110.91445312499995,
									18.741455078125085
								],
								[
									-110.9748046875,
									18.72036132812505
								],
								[
									-111.06367187499998,
									18.781640624999937
								],
								[
									-111.03994140624994,
									18.830126953125045
								],
								[
									-110.98940429687495,
									18.86313476562512
								],
								[
									-110.94208984375,
									18.80170898437504
								],
								[
									-110.91445312499995,
									18.741455078125085
								]
							]
						],
						[
							[
								[
									-86.93964843750001,
									20.303320312500063
								],
								[
									-86.99140624999998,
									20.272167968749926
								],
								[
									-87.01943359375,
									20.382324218750085
								],
								[
									-86.97797851562501,
									20.48979492187513
								],
								[
									-86.92783203125,
									20.551513671875085
								],
								[
									-86.82856445312493,
									20.558789062500068
								],
								[
									-86.76328124999995,
									20.57905273437501
								],
								[
									-86.75502929687497,
									20.551757812500057
								],
								[
									-86.80878906249998,
									20.46845703125004
								],
								[
									-86.93964843750001,
									20.303320312500063
								]
							]
						],
						[
							[
								[
									-86.71401367187497,
									21.23930664062496
								],
								[
									-86.6962890625,
									21.191015624999977
								],
								[
									-86.71362304687497,
									21.19677734375
								],
								[
									-86.73637695312499,
									21.23330078125008
								],
								[
									-86.75288085937498,
									21.278808593750114
								],
								[
									-86.73906249999999,
									21.279980468749983
								],
								[
									-86.726904296875,
									21.264306640624994
								],
								[
									-86.71401367187497,
									21.23930664062496
								]
							]
						],
						[
							[
								[
									-106.50224609375,
									21.610839843750057
								],
								[
									-106.53134765624998,
									21.528515625000097
								],
								[
									-106.60703124999993,
									21.561474609374955
								],
								[
									-106.63417968749997,
									21.613134765625006
								],
								[
									-106.63935546874995,
									21.697851562500034
								],
								[
									-106.59736328125001,
									21.712158203125114
								],
								[
									-106.53642578125003,
									21.676367187500006
								],
								[
									-106.52382812499995,
									21.65234375
								],
								[
									-106.50224609375,
									21.610839843750057
								]
							]
						],
						[
							[
								[
									-109.805078125,
									24.151074218749955
								],
								[
									-109.82675781249996,
									24.14755859374995
								],
								[
									-109.8779296875,
									24.200634765624926
								],
								[
									-109.90048828124998,
									24.33090820312509
								],
								[
									-109.89033203124995,
									24.34482421875009
								],
								[
									-109.793798828125,
									24.18339843749996
								],
								[
									-109.79560546875001,
									24.163574218750114
								],
								[
									-109.805078125,
									24.151074218749955
								]
							]
						],
						[
							[
								[
									-111.69887695312498,
									24.393603515625074
								],
								[
									-111.71230468749997,
									24.346386718749955
								],
								[
									-112.01328124999999,
									24.53339843750004
								],
								[
									-111.94086914062498,
									24.551123046875006
								],
								[
									-111.85683593750001,
									24.537988281249994
								],
								[
									-111.69887695312498,
									24.393603515625074
								]
							]
						],
						[
							[
								[
									-110.56738281249994,
									25.003466796875045
								],
								[
									-110.5388671875,
									24.891552734375097
								],
								[
									-110.59018554687498,
									24.908056640624977
								],
								[
									-110.657421875,
									24.96884765625012
								],
								[
									-110.70341796874995,
									25.04663085937497
								],
								[
									-110.69926757812499,
									25.08144531250005
								],
								[
									-110.69023437500002,
									25.087841796874926
								],
								[
									-110.59521484375003,
									25.042138671874937
								],
								[
									-110.56738281249994,
									25.003466796875045
								]
							]
						],
						[
							[
								[
									-112.057275390625,
									24.545703125000045
								],
								[
									-112.07734375,
									24.534570312500108
								],
								[
									-112.16289062500002,
									24.65029296875005
								],
								[
									-112.17548828125,
									24.72958984374995
								],
								[
									-112.21049804687503,
									24.76313476562504
								],
								[
									-112.29677734375002,
									24.78964843750012
								],
								[
									-112.22231445312495,
									24.95112304687504
								],
								[
									-112.15942382812501,
									25.285644531250085
								],
								[
									-112.13168945312496,
									25.224365234374943
								],
								[
									-112.19838867187497,
									24.885449218750097
								],
								[
									-112.19501953124998,
									24.841064453125114
								],
								[
									-112.16376953125001,
									24.79965820312509
								],
								[
									-112.13022460937502,
									24.72958984374995
								],
								[
									-112.12626953125002,
									24.65400390625001
								],
								[
									-112.06748046875002,
									24.583642578124966
								],
								[
									-112.057275390625,
									24.545703125000045
								]
							]
						],
						[
							[
								[
									-111.10029296874998,
									26.020605468749977
								],
								[
									-111.087744140625,
									25.984521484374994
								],
								[
									-111.09443359375003,
									25.974072265625097
								],
								[
									-111.13525390625,
									25.99916992187505
								],
								[
									-111.20449218749998,
									25.849707031249977
								],
								[
									-111.224658203125,
									25.835888671875097
								],
								[
									-111.18291015625003,
									26.040625000000063
								],
								[
									-111.13925781250002,
									26.069824218750057
								],
								[
									-111.09086914062502,
									26.07568359375
								],
								[
									-111.10029296874998,
									26.020605468749977
								]
							]
						],
						[
							[
								[
									-115.17060546875001,
									28.069384765625017
								],
								[
									-115.18427734374995,
									28.03725585937505
								],
								[
									-115.35292968750002,
									28.10395507812504
								],
								[
									-115.26040039062501,
									28.22055664062509
								],
								[
									-115.27397460937502,
									28.342773437500114
								],
								[
									-115.23354492187495,
									28.368359375000068
								],
								[
									-115.19697265624997,
									28.327880859375
								],
								[
									-115.14853515624995,
									28.172119140625057
								],
								[
									-115.17060546875001,
									28.069384765625017
								]
							]
						],
						[
							[
								[
									-118.24277343749999,
									28.94194335937496
								],
								[
									-118.28549804687499,
									28.903759765625097
								],
								[
									-118.40009765624998,
									29.112304687499943
								],
								[
									-118.40136718749997,
									29.16274414062508
								],
								[
									-118.36782226562498,
									29.187597656250006
								],
								[
									-118.31230468749995,
									29.182861328125114
								],
								[
									-118.31206054687499,
									29.130517578125108
								],
								[
									-118.26552734375001,
									29.08642578125
								],
								[
									-118.24736328124995,
									29.043359375000023
								],
								[
									-118.24277343749999,
									28.94194335937496
								]
							]
						],
						[
							[
								[
									-112.20307617187503,
									29.005322265625097
								],
								[
									-112.27841796875,
									28.769335937500045
								],
								[
									-112.35527343750003,
									28.77314453125004
								],
								[
									-112.51406249999997,
									28.847607421874926
								],
								[
									-112.53100585937496,
									28.89399414062504
								],
								[
									-112.46982421875002,
									29.16772460937503
								],
								[
									-112.42353515625,
									29.20366210937499
								],
								[
									-112.28505859374994,
									29.240429687499926
								],
								[
									-112.26342773437497,
									29.206787109375
								],
								[
									-112.24873046875,
									29.12597656249997
								],
								[
									-112.20307617187503,
									29.005322265625097
								]
							]
						],
						[
							[
								[
									-113.15561523437502,
									29.052246093750057
								],
								[
									-113.16279296874997,
									29.03476562499995
								],
								[
									-113.26474609374996,
									29.09672851562496
								],
								[
									-113.49633789062497,
									29.307617187499943
								],
								[
									-113.580615234375,
									29.413232421874966
								],
								[
									-113.59438476562497,
									29.462695312500102
								],
								[
									-113.58720703125002,
									29.573046875000017
								],
								[
									-113.50795898437495,
									29.559912109375006
								],
								[
									-113.41591796875002,
									29.485937500000034
								],
								[
									-113.37583007812493,
									29.417480468749943
								],
								[
									-113.37382812499997,
									29.338916015625017
								],
								[
									-113.2021484375,
									29.301855468750006
								],
								[
									-113.17792968749994,
									29.131933593750034
								],
								[
									-113.15561523437502,
									29.052246093750057
								]
							]
						],
						[
							[
								[
									-114.69414062500002,
									31.705615234375074
								],
								[
									-114.72724609375001,
									31.701367187500097
								],
								[
									-114.78920898437502,
									31.747412109375063
								],
								[
									-114.78457031249997,
									31.789794921875085
								],
								[
									-114.77109374999998,
									31.79409179687505
								],
								[
									-114.70908203124995,
									31.756884765625045
								],
								[
									-114.687939453125,
									31.72421874999995
								],
								[
									-114.69414062500002,
									31.705615234375074
								]
							]
						],
						[
							[
								[
									-97.14624023437497,
									25.961474609375102
								],
								[
									-97.16445312500002,
									25.75493164062513
								],
								[
									-97.22490234374999,
									25.585449218750057
								],
								[
									-97.42407226562497,
									25.23310546875004
								],
								[
									-97.50708007812503,
									25.014550781250108
								],
								[
									-97.66767578124995,
									24.38999023437495
								],
								[
									-97.71704101562497,
									23.98061523437505
								],
								[
									-97.72861328125003,
									23.787939453125034
								],
								[
									-97.74267578124997,
									23.760644531249994
								],
								[
									-97.72739257812495,
									23.732226562500074
								],
								[
									-97.76586914062497,
									23.306152343749943
								],
								[
									-97.74521484375003,
									22.9423828125
								],
								[
									-97.75834960937496,
									22.886035156250074
								],
								[
									-97.81669921874996,
									22.77631835937501
								],
								[
									-97.85781249999997,
									22.624511718750085
								],
								[
									-97.84160156249996,
									22.557080078124926
								],
								[
									-97.84248046874995,
									22.51030273437499
								],
								[
									-97.78237304687497,
									22.279296875
								],
								[
									-97.76328124999998,
									22.105859375000023
								],
								[
									-97.58476562499996,
									21.80854492187501
								],
								[
									-97.48452148437497,
									21.704833984374943
								],
								[
									-97.36015625000002,
									21.614941406249926
								],
								[
									-97.31450195312496,
									21.564208984375085
								],
								[
									-97.33686523437498,
									21.437890625000108
								],
								[
									-97.387548828125,
									21.373925781249937
								],
								[
									-97.40917968749997,
									21.272558593750063
								],
								[
									-97.43413085937499,
									21.35649414062513
								],
								[
									-97.42441406249998,
									21.46533203125
								],
								[
									-97.38481445312499,
									21.523828125000023
								],
								[
									-97.38344726562497,
									21.56669921874996
								],
								[
									-97.45659179687496,
									21.612402343750034
								],
								[
									-97.59038085937493,
									21.76201171874996
								],
								[
									-97.75380859375002,
									22.02666015624996
								],
								[
									-97.63754882812495,
									21.603662109374937
								],
								[
									-97.59760742187498,
									21.535888671875085
								],
								[
									-97.56655273437497,
									21.507714843750023
								],
								[
									-97.51455078124994,
									21.477978515625097
								],
								[
									-97.50107421875003,
									21.432031249999966
								],
								[
									-97.50058593750003,
									21.398046875000063
								],
								[
									-97.35712890624993,
									21.104003906250114
								],
								[
									-97.19497070312502,
									20.800097656250102
								],
								[
									-97.18632812499996,
									20.717041015625057
								],
								[
									-97.12143554687498,
									20.614990234375057
								],
								[
									-96.70869140624998,
									20.188281250000074
								],
								[
									-96.45605468749994,
									19.869775390625023
								],
								[
									-96.36835937499993,
									19.56723632812512
								],
								[
									-96.31533203124997,
									19.472851562500068
								],
								[
									-96.28955078124994,
									19.343750000000057
								],
								[
									-96.12397460937498,
									19.199072265624977
								],
								[
									-96.07338867187497,
									19.105664062499955
								],
								[
									-95.98466796875002,
									19.053759765625045
								],
								[
									-95.91303710937498,
									18.89716796875001
								],
								[
									-95.77812499999996,
									18.805517578125006
								],
								[
									-95.81035156249993,
									18.803857421875023
								],
								[
									-95.92822265624997,
									18.85009765625003
								],
								[
									-95.92036132812498,
									18.81958007812503
								],
								[
									-95.82109374999999,
									18.754638671874943
								],
								[
									-95.62680664062503,
									18.690576171875023
								],
								[
									-95.57832031250001,
									18.6904296875
								],
								[
									-95.654931640625,
									18.72368164062513
								],
								[
									-95.71982421874998,
									18.768359375000074
								],
								[
									-95.69711914062498,
									18.774902343750085
								],
								[
									-95.56142578124994,
									18.719140624999994
								],
								[
									-95.18183593749998,
									18.700732421875074
								],
								[
									-95.01469726562493,
									18.570605468750017
								],
								[
									-94.79814453124996,
									18.514599609375068
								],
								[
									-94.68164062500003,
									18.348486328124977
								],
								[
									-94.54619140624996,
									18.174853515625045
								],
								[
									-94.45976562499996,
									18.166650390624966
								],
								[
									-94.39228515624995,
									18.16596679687501
								],
								[
									-94.18901367187493,
									18.19526367187501
								],
								[
									-93.87314453124998,
									18.30444335937497
								],
								[
									-93.76440429687494,
									18.357910156249943
								],
								[
									-93.55234375,
									18.430468750000074
								],
								[
									-93.2279296875,
									18.44379882812504
								],
								[
									-93.12734375000002,
									18.423437500000063
								],
								[
									-92.88476562499997,
									18.468652343749937
								],
								[
									-92.76909179687496,
									18.52412109375004
								],
								[
									-92.72895507812495,
									18.574511718750017
								],
								[
									-92.71010742187502,
									18.61166992187495
								],
								[
									-92.48530273437495,
									18.66479492187503
								],
								[
									-92.44101562499998,
									18.675292968749943
								],
								[
									-92.21318359374993,
									18.684863281250102
								],
								[
									-92.10322265625001,
									18.704394531250102
								],
								[
									-91.97377929687502,
									18.71586914062513
								],
								[
									-91.88037109375,
									18.637792968750034
								],
								[
									-91.88046875,
									18.59965820312499
								],
								[
									-91.94267578124999,
									18.563427734375068
								],
								[
									-91.91357421875,
									18.528515625000068
								],
								[
									-91.80297851562503,
									18.47060546875008
								],
								[
									-91.59970703125,
									18.447167968750108
								],
								[
									-91.53398437499993,
									18.456542968750057
								],
								[
									-91.44047851562499,
									18.54184570312512
								],
								[
									-91.27524414062498,
									18.624462890625068
								],
								[
									-91.27875976562498,
									18.72065429687504
								],
								[
									-91.30830078124998,
									18.773291015625006
								],
								[
									-91.35629882812498,
									18.776562500000068
								],
								[
									-91.3677734375,
									18.80610351562504
								],
								[
									-91.33422851562503,
									18.876806640625063
								],
								[
									-91.34306640624996,
									18.90058593750001
								],
								[
									-91.44555664062497,
									18.832812500000045
								],
								[
									-91.46918945312498,
									18.833007812500085
								],
								[
									-91.45786132812498,
									18.864648437499966
								],
								[
									-91.43666992187502,
									18.889794921874937
								],
								[
									-91.13593749999995,
									19.037500000000108
								],
								[
									-91.05893554687498,
									19.09819335937513
								],
								[
									-90.95502929687495,
									19.151660156250102
								],
								[
									-90.73925781249994,
									19.35224609375001
								],
								[
									-90.69316406249999,
									19.729882812499937
								],
								[
									-90.65009765624998,
									19.79594726562499
								],
								[
									-90.507080078125,
									19.91186523437497
								],
								[
									-90.49169921874997,
									19.946777343750085
								],
								[
									-90.48242187500003,
									20.02573242187509
								],
								[
									-90.48637695312496,
									20.22402343750008
								],
								[
									-90.47832031249999,
									20.37998046874995
								],
								[
									-90.48413085937503,
									20.556347656250097
								],
								[
									-90.45844726562495,
									20.71372070312509
								],
								[
									-90.43515625,
									20.757519531249955
								],
								[
									-90.35312499999998,
									21.009423828124937
								],
								[
									-90.18291015624993,
									21.120898437500074
								],
								[
									-89.88764648437501,
									21.252636718749926
								],
								[
									-89.81977539062495,
									21.274609374999955
								],
								[
									-88.87871093749999,
									21.41411132812496
								],
								[
									-88.7466796875,
									21.448144531249966
								],
								[
									-88.58491210937498,
									21.53867187500012
								],
								[
									-88.46669921874997,
									21.569384765625074
								],
								[
									-88.25102539062502,
									21.56689453125
								],
								[
									-88.18476562500001,
									21.578955078125063
								],
								[
									-88.171728515625,
									21.591455078124937
								],
								[
									-88.17138671875003,
									21.603515625
								],
								[
									-88.13164062500002,
									21.615869140624937
								],
								[
									-88.0068359375,
									21.604052734375017
								],
								[
									-87.77373046875002,
									21.54951171875001
								],
								[
									-87.68881835937495,
									21.535839843750068
								],
								[
									-87.48046874999997,
									21.47246093750013
								],
								[
									-87.25087890625,
									21.446972656250068
								],
								[
									-87.21791992187494,
									21.458007812500114
								],
								[
									-87.18759765624998,
									21.47729492187503
								],
								[
									-87.16430664062503,
									21.514208984375102
								],
								[
									-87.18828124999993,
									21.546435546875102
								],
								[
									-87.21059570312497,
									21.543945312499943
								],
								[
									-87.24946289062498,
									21.526611328125057
								],
								[
									-87.29575195312498,
									21.524951171875074
								],
								[
									-87.38666992187495,
									21.55146484375004
								],
								[
									-87.36850585937498,
									21.57373046874997
								],
								[
									-87.275732421875,
									21.571630859375063
								],
								[
									-87.216455078125,
									21.582421874999966
								],
								[
									-87.12846679687502,
									21.621484375000023
								],
								[
									-87.03476562500003,
									21.59223632812501
								],
								[
									-86.91171875,
									21.46284179687504
								],
								[
									-86.824072265625,
									21.42167968749999
								],
								[
									-86.81708984374998,
									21.23422851562509
								],
								[
									-86.80385742187497,
									21.200048828125034
								],
								[
									-86.77177734374999,
									21.150537109374994
								],
								[
									-86.81552734375003,
									21.005224609375063
								],
								[
									-86.86469726562501,
									20.885058593750102
								],
								[
									-86.92622070312493,
									20.78647460937509
								],
								[
									-87.0595703125,
									20.63125000000008
								],
								[
									-87.22124023437499,
									20.507275390624955
								],
								[
									-87.42138671875,
									20.231396484375068
								],
								[
									-87.46718750000002,
									20.10214843750012
								],
								[
									-87.4658203125,
									19.998535156250057
								],
								[
									-87.43193359375002,
									19.898486328125102
								],
								[
									-87.44174804687498,
									19.86152343750001
								],
								[
									-87.4662109375,
									19.82416992187504
								],
								[
									-87.50688476562502,
									19.82749023437512
								],
								[
									-87.585791015625,
									19.77949218750001
								],
								[
									-87.68769531249998,
									19.63710937500005
								],
								[
									-87.69008789062494,
									19.593701171875097
								],
								[
									-87.64531249999996,
									19.553906250000068
								],
								[
									-87.58730468749997,
									19.57299804687503
								],
								[
									-87.51166992187501,
									19.574707031249943
								],
								[
									-87.46938476562502,
									19.58647460937513
								],
								[
									-87.42475585937498,
									19.58334960937512
								],
								[
									-87.43471679687497,
									19.501708984375085
								],
								[
									-87.48266601562497,
									19.443749999999994
								],
								[
									-87.51289062499998,
									19.42558593750013
								],
								[
									-87.5669921875,
									19.415722656250068
								],
								[
									-87.6275390625,
									19.382714843749994
								],
								[
									-87.65869140625003,
									19.35234375000013
								],
								[
									-87.65576171874997,
									19.25786132812496
								],
								[
									-87.62207031250003,
									19.25048828124997
								],
								[
									-87.55078125,
									19.320947265624937
								],
								[
									-87.50947265625001,
									19.317480468750034
								],
								[
									-87.50107421874998,
									19.28779296875001
								],
								[
									-87.59355468749999,
									19.046386718750057
								],
								[
									-87.65302734374995,
									18.798535156250097
								],
								[
									-87.733544921875,
									18.655029296875085
								],
								[
									-87.76181640625,
									18.446142578124977
								],
								[
									-87.8041015625,
									18.35708007812505
								],
								[
									-87.85322265624995,
									18.26899414062504
								],
								[
									-87.88198242187497,
									18.27387695312504
								],
								[
									-87.95966796874998,
									18.440869140625068
								],
								[
									-88.0390625,
									18.48388671875003
								],
								[
									-88.05644531249999,
									18.52446289062513
								],
								[
									-88.0111328125,
									18.72685546874996
								],
								[
									-88.03173828125,
									18.838916015625045
								],
								[
									-88.07377929687496,
									18.83447265625003
								],
								[
									-88.12675781249999,
									18.773046875000063
								],
								[
									-88.19677734374997,
									18.719677734374926
								],
								[
									-88.19531250000003,
									18.64262695312513
								],
								[
									-88.27573242187498,
									18.514550781249966
								],
								[
									-88.29565429687494,
									18.472412109375
								],
								[
									-88.37241210937495,
									18.48232421875005
								],
								[
									-88.46127929687503,
									18.476757812500097
								],
								[
									-88.52299804687499,
									18.44589843750009
								],
								[
									-88.58618164062497,
									18.290527343750057
								],
								[
									-88.74360351562498,
									18.071630859375063
								],
								[
									-88.80634765624998,
									17.96552734375004
								],
								[
									-88.85737304687498,
									17.928808593750006
								],
								[
									-88.89780273437498,
									17.914550781249943
								],
								[
									-88.94262695312494,
									17.939648437500097
								],
								[
									-89.05043945312497,
									17.999707031250068
								],
								[
									-89.13354492187503,
									17.97080078124995
								],
								[
									-89.16235351562494,
									17.90195312499995
								],
								[
									-89.16147460937503,
									17.814843749999966
								],
								[
									-89.37153320312493,
									17.814990234375102
								],
								[
									-89.72880859374999,
									17.81533203125008
								],
								[
									-90.18359375,
									17.815722656250074
								],
								[
									-90.62202148437495,
									17.81611328125004
								],
								[
									-90.98916015624997,
									17.81640625000003
								],
								[
									-90.99042968749995,
									17.62075195312505
								],
								[
									-90.99160156250002,
									17.447460937500097
								],
								[
									-90.99296874999996,
									17.25244140624997
								],
								[
									-91.19550781250001,
									17.25410156250004
								],
								[
									-91.40961914062501,
									17.255859375000057
								],
								[
									-91.39233398437494,
									17.23642578125009
								],
								[
									-91.31918945312498,
									17.19980468750009
								],
								[
									-91.22416992187499,
									17.11225585937501
								],
								[
									-91.11186523437502,
									16.97617187500009
								],
								[
									-90.975830078125,
									16.86782226562505
								],
								[
									-90.81601562499995,
									16.78710937500003
								],
								[
									-90.710693359375,
									16.708105468750006
								],
								[
									-90.65996093749996,
									16.630908203125102
								],
								[
									-90.63437499999998,
									16.56513671875001
								],
								[
									-90.63408203125002,
									16.51074218750003
								],
								[
									-90.57578124999995,
									16.46782226562499
								],
								[
									-90.47109374999994,
									16.439550781250006
								],
								[
									-90.41699218750003,
									16.39101562500008
								],
								[
									-90.41699218750003,
									16.35131835937497
								],
								[
									-90.45014648437493,
									16.261376953125023
								],
								[
									-90.45986328124997,
									16.16235351562503
								],
								[
									-90.44716796874997,
									16.072705078125068
								],
								[
									-90.52197265625,
									16.071191406250108
								],
								[
									-90.70322265624998,
									16.071044921875085
								],
								[
									-90.97958984374998,
									16.07080078125003
								],
								[
									-91.2337890625,
									16.07065429687509
								],
								[
									-91.433984375,
									16.07045898437505
								],
								[
									-91.736572265625,
									16.070166015624977
								],
								[
									-91.81943359374992,
									15.932373046874972
								],
								[
									-91.95722656250001,
									15.703222656250006
								],
								[
									-92.08212890624998,
									15.495556640624983
								],
								[
									-92.18715820312497,
									15.32089843750002
								],
								[
									-92.204248046875,
									15.274999999999991
								],
								[
									-92.204345703125,
									15.237695312500023
								],
								[
									-92.07480468749998,
									15.074218750000028
								],
								[
									-92.09873046874998,
									15.026757812500037
								],
								[
									-92.14423828125001,
									15.001953125000057
								],
								[
									-92.158544921875,
									14.963574218750054
								],
								[
									-92.15566406249994,
									14.901318359375068
								],
								[
									-92.18637695312498,
									14.818359375000043
								],
								[
									-92.17646484375001,
									14.761328125000063
								],
								[
									-92.159912109375,
									14.691015625000034
								],
								[
									-92.18706054687493,
									14.630078125000054
								],
								[
									-92.20903320312499,
									14.570996093750097
								],
								[
									-92.23515624999996,
									14.545410156250028
								],
								[
									-92.26455078125002,
									14.567773437500065
								],
								[
									-92.53095703125001,
									14.839648437500031
								],
								[
									-92.80893554687498,
									15.13857421875008
								],
								[
									-92.91840820312498,
									15.23613281250006
								],
								[
									-93.0244140625,
									15.310253906250068
								],
								[
									-93.16689453125,
									15.448046875000074
								],
								[
									-93.54116210937494,
									15.750390624999937
								],
								[
									-93.73437499999997,
									15.888476562500102
								],
								[
									-93.91606445312493,
									16.053564453124977
								],
								[
									-94.078955078125,
									16.145263671875
								],
								[
									-94.239892578125,
									16.20507812500003
								],
								[
									-94.31127929687497,
									16.23935546875009
								],
								[
									-94.374169921875,
									16.284765625000006
								],
								[
									-94.409033203125,
									16.287353515625
								],
								[
									-94.426416015625,
									16.226269531249983
								],
								[
									-94.37016601562499,
									16.195410156250006
								],
								[
									-94.30283203125003,
									16.169335937499937
								],
								[
									-94.24951171875,
									16.167529296875102
								],
								[
									-94.19340820312496,
									16.145605468750063
								],
								[
									-94.02832031249997,
									16.062060546875017
								],
								[
									-94.00126953124999,
									16.018945312499937
								],
								[
									-94.47075195312496,
									16.186572265625074
								],
								[
									-94.66152343750002,
									16.201904296875
								],
								[
									-94.682275390625,
									16.22822265625004
								],
								[
									-94.58710937499995,
									16.315820312499937
								],
								[
									-94.61684570312497,
									16.347558593750108
								],
								[
									-94.65078124999997,
									16.351806640625085
								],
								[
									-94.75283203124997,
									16.291210937499983
								],
								[
									-94.79082031249999,
									16.28715820312496
								],
								[
									-94.7974609375,
									16.32705078125008
								],
								[
									-94.79291992187495,
									16.36459960937509
								],
								[
									-94.85869140624996,
									16.41972656249996
								],
								[
									-94.90043945312502,
									16.41748046875003
								],
								[
									-94.934716796875,
									16.37910156250004
								],
								[
									-95.02353515624995,
									16.306250000000034
								],
								[
									-95.02084960937503,
									16.277636718750074
								],
								[
									-94.84604492187503,
									16.24658203125003
								],
								[
									-94.78579101562502,
									16.229101562500034
								],
								[
									-94.79941406249995,
									16.209667968749983
								],
								[
									-94.94931640625003,
									16.21000976562496
								],
								[
									-95.13437499999998,
									16.176953125000068
								],
								[
									-95.46440429687499,
									15.974707031250063
								],
								[
									-95.77177734374999,
									15.887792968749949
								],
								[
									-96.21357421874993,
									15.693066406249983
								],
								[
									-96.40864257812498,
									15.68310546875
								],
								[
									-96.51083984375,
									15.65190429687513
								],
								[
									-96.80795898437498,
									15.726416015625034
								],
								[
									-97.18466796874998,
									15.909277343749977
								],
								[
									-97.75478515624994,
									15.966845703125074
								],
								[
									-98.13896484374996,
									16.206298828125
								],
								[
									-98.52031249999993,
									16.304833984375108
								],
								[
									-98.76220703125003,
									16.53476562499995
								],
								[
									-98.90795898437496,
									16.544580078124994
								],
								[
									-99.00166015624995,
									16.58144531250005
								],
								[
									-99.348046875,
									16.664746093750068
								],
								[
									-99.69067382812499,
									16.71962890625005
								],
								[
									-100.02451171874996,
									16.92050781250012
								],
								[
									-100.24301757812498,
									16.98417968750013
								],
								[
									-100.431884765625,
									17.064062500000063
								],
								[
									-100.84780273437501,
									17.200488281250045
								],
								[
									-101.00195312499997,
									17.276123046875
								],
								[
									-101.14785156250002,
									17.39311523437513
								],
								[
									-101.38549804687503,
									17.514208984375102
								],
								[
									-101.48706054687503,
									17.615332031250006
								],
								[
									-101.60029296875001,
									17.651562499999926
								],
								[
									-101.76240234375,
									17.841992187500097
								],
								[
									-101.84707031250001,
									17.922265625000108
								],
								[
									-101.91870117187494,
									17.959765625000102
								],
								[
									-101.99550781249997,
									17.972705078125074
								],
								[
									-102.21660156249997,
									17.95742187500005
								],
								[
									-102.54697265624996,
									18.041406249999937
								],
								[
									-102.69956054687496,
									18.062841796875034
								],
								[
									-103.01850585937501,
									18.18686523437509
								],
								[
									-103.44160156249997,
									18.325390625000068
								],
								[
									-103.58027343749997,
									18.484374999999943
								],
								[
									-103.69892578124998,
									18.632958984375023
								],
								[
									-103.91245117187496,
									18.828466796875063
								],
								[
									-104.04565429687501,
									18.911816406249983
								],
								[
									-104.27700195312498,
									19.010986328124943
								],
								[
									-104.40517578124998,
									19.091210937499937
								],
								[
									-104.60297851562495,
									19.152880859375074
								],
								[
									-104.9384765625,
									19.309375000000074
								],
								[
									-105.04521484374999,
									19.44326171875008
								],
								[
									-105.10766601562501,
									19.562207031250068
								],
								[
									-105.286376953125,
									19.706494140625068
								],
								[
									-105.482080078125,
									19.97607421875
								],
								[
									-105.53242187499995,
									20.075390624999983
								],
								[
									-105.57041015624996,
									20.227832031250045
								],
								[
									-105.61591796875,
									20.31630859375005
								],
								[
									-105.66943359374997,
									20.385595703125034
								],
								[
									-105.642138671875,
									20.435986328125097
								],
								[
									-105.54257812499998,
									20.497949218750108
								],
								[
									-105.37705078125,
									20.511865234374994
								],
								[
									-105.26015625,
									20.57905273437501
								],
								[
									-105.24467773437503,
									20.63417968750005
								],
								[
									-105.25229492187499,
									20.668505859375102
								],
								[
									-105.32705078124994,
									20.752978515625102
								],
								[
									-105.42011718749998,
									20.77539062500003
								],
								[
									-105.49238281249997,
									20.77661132812503
								],
								[
									-105.51083984374999,
									20.808740234374994
								],
								[
									-105.45634765624999,
									20.84379882812513
								],
								[
									-105.393994140625,
									20.92612304687512
								],
								[
									-105.30195312499998,
									21.02656250000004
								],
								[
									-105.237060546875,
									21.119189453125102
								],
								[
									-105.22500000000002,
									21.24970703125004
								],
								[
									-105.23325195312502,
									21.380419921875017
								],
								[
									-105.20869140624998,
									21.49082031249995
								],
								[
									-105.43144531249999,
									21.618261718749977
								],
								[
									-105.45742187499995,
									21.672460937500006
								],
								[
									-105.52744140625,
									21.81845703125009
								],
								[
									-105.64912109375001,
									21.988085937500102
								],
								[
									-105.64550781249999,
									22.32690429687503
								],
								[
									-105.79179687500003,
									22.627490234375074
								],
								[
									-105.943359375,
									22.777001953124966
								],
								[
									-106.02172851562499,
									22.82905273437501
								],
								[
									-106.2345703125,
									23.060937499999994
								],
								[
									-106.40224609374997,
									23.19560546874999
								],
								[
									-106.56650390624995,
									23.449462890625114
								],
								[
									-106.72875976562496,
									23.61069335937509
								],
								[
									-106.93549804687498,
									23.88125000000005
								],
								[
									-107.08486328124994,
									24.016113281250085
								],
								[
									-107.76494140625003,
									24.471923828124943
								],
								[
									-107.72661132812503,
									24.471923828124943
								],
								[
									-107.52724609375001,
									24.360058593749983
								],
								[
									-107.49370117187502,
									24.369384765625114
								],
								[
									-107.48891601562501,
									24.42397460937505
								],
								[
									-107.5119140625,
									24.489160156249994
								],
								[
									-107.54887695312497,
									24.50478515625008
								],
								[
									-107.60200195312495,
									24.490136718750023
								],
								[
									-107.67368164062499,
									24.503564453124994
								],
								[
									-107.70952148437502,
									24.525048828124937
								],
								[
									-107.81669921875,
									24.53901367187504
								],
								[
									-107.95117187499996,
									24.614892578124937
								],
								[
									-108.00878906249997,
									24.693554687499983
								],
								[
									-108.01508789062501,
									24.783398437499983
								],
								[
									-108.20766601562498,
									24.974804687500068
								],
								[
									-108.28076171874996,
									25.08154296874997
								],
								[
									-108.24331054687497,
									25.073681640625068
								],
								[
									-108.192041015625,
									25.03066406250008
								],
								[
									-108.14008789062498,
									25.01840820312509
								],
								[
									-108.07963867187502,
									25.018066406250114
								],
								[
									-108.03569335937503,
									25.035351562499983
								],
								[
									-108.05146484374995,
									25.06704101562505
								],
								[
									-108.09282226562503,
									25.093505859375114
								],
								[
									-108.37368164062497,
									25.19433593750003
								],
								[
									-108.466259765625,
									25.265136718750085
								],
								[
									-108.69638671874998,
									25.38291015625009
								],
								[
									-108.7509765625,
									25.42421875000008
								],
								[
									-108.78725585937502,
									25.538037109374983
								],
								[
									-108.84360351562495,
									25.54331054687509
								],
								[
									-108.89316406250002,
									25.511572265625006
								],
								[
									-109.02880859375003,
									25.480468750000057
								],
								[
									-109.06347656249999,
									25.51669921875009
								],
								[
									-109.06845703125002,
									25.55156249999999
								],
								[
									-108.97275390624998,
									25.588476562500034
								],
								[
									-108.88486328125,
									25.69604492187503
								],
								[
									-108.886572265625,
									25.733447265625102
								],
								[
									-108.93515624999995,
									25.690283203125006
								],
								[
									-109.00834960937503,
									25.641992187499937
								],
								[
									-109.08408203125,
									25.615039062500045
								],
								[
									-109.196484375,
									25.592529296875085
								],
								[
									-109.25395507812497,
									25.608789062500108
								],
								[
									-109.30429687500002,
									25.63315429687509
								],
								[
									-109.38496093750003,
									25.727148437500063
								],
								[
									-109.42563476562496,
									26.03256835937509
								],
								[
									-109.35415039062497,
									26.138476562500102
								],
								[
									-109.27065429687501,
									26.24311523437501
								],
								[
									-109.19970703125003,
									26.30522460937496
								],
								[
									-109.15878906249995,
									26.258349609375102
								],
								[
									-109.11669921874999,
									26.252734375000017
								],
								[
									-109.14633789062499,
									26.305712890625074
								],
								[
									-109.21601562499997,
									26.355273437500045
								],
								[
									-109.24062500000001,
									26.40468750000005
								],
								[
									-109.24326171875002,
									26.449951171875057
								],
								[
									-109.27626953125,
									26.53388671875001
								],
								[
									-109.48286132812498,
									26.71035156250008
								],
								[
									-109.67607421875,
									26.696826171875074
								],
								[
									-109.75478515624995,
									26.702929687500074
								],
								[
									-109.82836914062503,
									26.77011718750009
								],
								[
									-109.89091796874997,
									26.883398437499977
								],
								[
									-109.92172851562495,
									26.978173828125108
								],
								[
									-109.92563476562495,
									27.02866210937509
								],
								[
									-109.94399414062495,
									27.079345703125114
								],
								[
									-110.27714843749997,
									27.16220703125012
								],
								[
									-110.37729492187495,
									27.233300781249937
								],
								[
									-110.47778320312499,
									27.322656249999937
								],
								[
									-110.51938476562493,
									27.395605468750063
								],
								[
									-110.56064453124999,
									27.450146484375068
								],
								[
									-110.59267578124995,
									27.54433593750008
								],
								[
									-110.61547851562497,
									27.653906250000006
								],
								[
									-110.57827148437495,
									27.79565429687503
								],
								[
									-110.52988281249995,
									27.864208984374955
								],
								[
									-110.759033203125,
									27.91518554687505
								],
								[
									-110.84863281249996,
									27.91757812500009
								],
								[
									-110.92080078125001,
									27.88886718750001
								],
								[
									-110.98608398437499,
									27.925976562499926
								],
								[
									-111.12138671875002,
									27.96699218750001
								],
								[
									-111.28242187499995,
									28.11523437500003
								],
								[
									-111.47167968749997,
									28.383984375000068
								],
								[
									-111.68007812499997,
									28.470556640625034
								],
								[
									-111.74721679687497,
									28.563964843750057
								],
								[
									-111.83242187500001,
									28.648144531250068
								],
								[
									-111.90703125000002,
									28.752490234375102
								],
								[
									-111.91860351562498,
									28.797900390625017
								],
								[
									-111.94082031249998,
									28.823193359374926
								],
								[
									-112.04487304687495,
									28.895898437499994
								],
								[
									-112.16176757812497,
									29.018896484375006
								],
								[
									-112.192041015625,
									29.117968750000017
								],
								[
									-112.223486328125,
									29.269482421874983
								],
								[
									-112.301416015625,
									29.322900390625023
								],
								[
									-112.37822265625,
									29.347705078124932
								],
								[
									-112.39321289062495,
									29.419726562500045
								],
								[
									-112.388671875,
									29.460107421875108
								],
								[
									-112.41455078125003,
									29.536425781250017
								],
								[
									-112.57290039062497,
									29.719531250000017
								],
								[
									-112.65312499999996,
									29.870068359374955
								],
								[
									-112.69716796874997,
									29.916845703124977
								],
								[
									-112.73837890625002,
									29.985449218750006
								],
								[
									-112.759228515625,
									30.125683593749983
								],
								[
									-112.82480468749995,
									30.30014648437509
								],
								[
									-112.95175781249996,
									30.510009765624943
								],
								[
									-113.05766601562496,
									30.65102539062508
								],
								[
									-113.11044921874996,
									30.79331054687509
								],
								[
									-113.08701171874999,
									30.93808593750012
								],
								[
									-113.10498046875,
									31.027197265625063
								],
								[
									-113.11860351562503,
									31.048095703125057
								],
								[
									-113.10795898437499,
									31.07729492187505
								],
								[
									-113.07280273437502,
									31.06088867187509
								],
								[
									-113.04291992187497,
									31.087011718750063
								],
								[
									-113.04672851562495,
									31.179248046875045
								],
								[
									-113.08364257812501,
									31.20717773437505
								],
								[
									-113.18618164062502,
									31.236035156250068
								],
								[
									-113.23144531250001,
									31.255957031250034
								],
								[
									-113.480810546875,
									31.29360351562505
								],
								[
									-113.62348632812494,
									31.345898437500068
								],
								[
									-113.63300781250003,
									31.46762695312509
								],
								[
									-113.69995117187499,
									31.523339843749966
								],
								[
									-113.75942382812502,
									31.557763671874966
								],
								[
									-113.94775390625001,
									31.629345703124983
								],
								[
									-113.97749023437494,
									31.592724609374983
								],
								[
									-114.00268554687501,
									31.525146484375085
								],
								[
									-114.08090820312496,
									31.51035156250009
								],
								[
									-114.14931640624995,
									31.507373046875102
								],
								[
									-114.26406249999998,
									31.554443359375
								],
								[
									-114.54868164062496,
									31.73354492187508
								],
								[
									-114.60878906249995,
									31.762255859375074
								],
								[
									-114.69760742187502,
									31.777441406250034
								],
								[
									-114.74130859374995,
									31.80649414062509
								],
								[
									-114.93359374999996,
									31.900732421875034
								],
								[
									-114.895068359375,
									31.850634765625045
								],
								[
									-114.83950195312497,
									31.798535156250068
								],
								[
									-114.78989257812499,
									31.647119140624966
								],
								[
									-114.84814453124996,
									31.53793945312509
								],
								[
									-114.88188476562499,
									31.156396484374994
								],
								[
									-114.84467773437495,
									31.08046875000008
								],
								[
									-114.76103515624997,
									30.958740234375057
								],
								[
									-114.70336914062503,
									30.765185546875045
								],
								[
									-114.68544921875002,
									30.621191406250034
								],
								[
									-114.63330078124997,
									30.506884765625017
								],
								[
									-114.64975585937495,
									30.238134765624977
								],
								[
									-114.62993164062499,
									30.156298828125102
								],
								[
									-114.55048828124997,
									30.02226562499996
								],
								[
									-114.40341796874995,
									29.896484375
								],
								[
									-114.37260742187497,
									29.830224609375108
								],
								[
									-114.17919921875,
									29.73432617187501
								],
								[
									-114.06191406250001,
									29.60952148437508
								],
								[
									-113.82895507812498,
									29.43945312499997
								],
								[
									-113.75546875,
									29.367480468750045
								],
								[
									-113.54531250000001,
									29.10224609375001
								],
								[
									-113.53847656249995,
									29.02338867187504
								],
								[
									-113.49970703124995,
									28.926708984375068
								],
								[
									-113.38183593750001,
									28.94667968750005
								],
								[
									-113.32890624999997,
									28.873046875000057
								],
								[
									-113.33500976562497,
									28.83906250000004
								],
								[
									-113.320703125,
									28.813134765625108
								],
								[
									-113.25888671875,
									28.818847656250114
								],
								[
									-113.20556640624999,
									28.798779296874926
								],
								[
									-113.09365234375001,
									28.51176757812499
								],
								[
									-113.03359375000002,
									28.472607421875097
								],
								[
									-112.95664062499998,
									28.45585937499996
								],
								[
									-112.870849609375,
									28.42421875000008
								],
								[
									-112.86523437500001,
									28.350634765624932
								],
								[
									-112.86845703124996,
									28.29199218749997
								],
								[
									-112.79570312499997,
									28.207128906250006
								],
								[
									-112.808056640625,
									28.09218750000005
								],
								[
									-112.74931640625002,
									27.994873046875114
								],
								[
									-112.75820312499997,
									27.900634765625
								],
								[
									-112.73403320312502,
									27.825976562500074
								],
								[
									-112.55263671875001,
									27.65747070312503
								],
								[
									-112.32919921874996,
									27.523437500000085
								],
								[
									-112.28261718749998,
									27.347460937499932
								],
								[
									-112.19145507812497,
									27.186669921875023
								],
								[
									-112.09814453124997,
									27.145947265625097
								],
								[
									-112.00395507812496,
									27.07910156249997
								],
								[
									-112.01557617187503,
									27.009716796874955
								],
								[
									-112.00908203125003,
									26.967089843750074
								],
								[
									-111.88315429687495,
									26.840185546875063
								],
								[
									-111.86264648437495,
									26.678515625000074
								],
								[
									-111.75400390625002,
									26.57270507812501
								],
								[
									-111.723388671875,
									26.56440429687501
								],
								[
									-111.6994140625,
									26.58095703125008
								],
								[
									-111.77851562499995,
									26.687255859375085
								],
								[
									-111.81684570312494,
									26.756250000000108
								],
								[
									-111.82177734374997,
									26.865087890624977
								],
								[
									-111.79526367187499,
									26.879687499999932
								],
								[
									-111.56967773437495,
									26.707617187500063
								],
								[
									-111.54589843749999,
									26.57919921875009
								],
								[
									-111.47016601562501,
									26.50664062499996
								],
								[
									-111.46450195312502,
									26.408447265624943
								],
								[
									-111.41850585937497,
									26.34995117187509
								],
								[
									-111.40458984374997,
									26.265039062500023
								],
								[
									-111.33212890624996,
									26.125439453124926
								],
								[
									-111.33037109374996,
									25.931347656250097
								],
								[
									-111.29160156249996,
									25.78979492187503
								],
								[
									-111.14956054687498,
									25.572607421875006
								],
								[
									-111.03442382812497,
									25.52695312499995
								],
								[
									-111.013623046875,
									25.42031250000008
								],
								[
									-110.89394531249995,
									25.144238281249955
								],
								[
									-110.75566406250003,
									24.99458007812501
								],
								[
									-110.68676757812503,
									24.867675781250114
								],
								[
									-110.67724609374994,
									24.788525390625068
								],
								[
									-110.72900390625001,
									24.671533203124937
								],
								[
									-110.73452148437498,
									24.589843750000085
								],
								[
									-110.65932617187502,
									24.341455078125108
								],
								[
									-110.54697265624996,
									24.214160156250017
								],
								[
									-110.42148437499998,
									24.18339843749996
								],
								[
									-110.39965820312497,
									24.165136718749977
								],
								[
									-110.40961914062495,
									24.130957031250034
								],
								[
									-110.36743164062499,
									24.10048828125005
								],
								[
									-110.319970703125,
									24.139453125000074
								],
								[
									-110.29682617187498,
									24.19487304687499
								],
								[
									-110.3208984375,
									24.25917968750005
								],
								[
									-110.32509765624997,
									24.305957031250074
								],
								[
									-110.30375976562497,
									24.339453125000063
								],
								[
									-110.262890625,
									24.344531250000017
								],
								[
									-110.02280273437502,
									24.174609375000045
								],
								[
									-109.98251953124999,
									24.109375000000085
								],
								[
									-109.89316406249999,
									24.033007812500045
								],
								[
									-109.81132812500002,
									23.939013671875102
								],
								[
									-109.7759765625,
									23.86489257812508
								],
								[
									-109.710546875,
									23.80380859375009
								],
								[
									-109.6765625,
									23.661572265625068
								],
								[
									-109.50961914062502,
									23.597900390625057
								],
								[
									-109.42084960937495,
									23.48012695312505
								],
								[
									-109.41499023437501,
									23.405566406250045
								],
								[
									-109.45805664062499,
									23.21474609375008
								],
								[
									-109.49570312500002,
									23.15981445312508
								],
								[
									-109.63046874999995,
									23.07866210937496
								],
								[
									-109.72841796875001,
									22.98183593750005
								],
								[
									-109.823046875,
									22.922167968750045
								],
								[
									-109.92343749999995,
									22.88588867187505
								],
								[
									-110.00625000000002,
									22.894042968750114
								],
								[
									-110.08603515624993,
									23.005468749999977
								],
								[
									-110.18061523437503,
									23.341503906249955
								],
								[
									-110.24409179687498,
									23.41225585937508
								],
								[
									-110.28876953125003,
									23.517675781250063
								],
								[
									-110.3626953125,
									23.604931640625068
								],
								[
									-110.62998046875,
									23.737304687499943
								],
								[
									-110.76489257812496,
									23.877001953125074
								],
								[
									-110.89555664062502,
									23.970263671875074
								],
								[
									-111.03618164062497,
									24.10527343750013
								],
								[
									-111.41933593749997,
									24.329003906249966
								],
								[
									-111.57822265625,
									24.443017578125108
								],
								[
									-111.68291015625002,
									24.55581054687508
								],
								[
									-111.750390625,
									24.554150390625097
								],
								[
									-111.80249023437496,
									24.54252929687513
								],
								[
									-111.82226562499999,
									24.573388671875108
								],
								[
									-111.82519531249996,
									24.63178710937501
								],
								[
									-111.84824218749995,
									24.670068359374994
								],
								[
									-112.07255859374999,
									24.840039062499983
								],
								[
									-112.11904296874997,
									24.93403320312504
								],
								[
									-112.12851562500002,
									25.043115234374966
								],
								[
									-112.07797851562495,
									25.323974609375085
								],
								[
									-112.05576171874995,
									25.48823242187504
								],
								[
									-112.06987304687497,
									25.572851562500063
								],
								[
									-112.09335937499996,
									25.584375000000108
								],
								[
									-112.11459960937495,
									25.630371093750057
								],
								[
									-112.11977539062502,
									25.765527343749966
								],
								[
									-112.17382812500001,
									25.91259765625
								],
								[
									-112.37724609374999,
									26.213916015625017
								],
								[
									-112.52607421875001,
									26.273486328125074
								],
								[
									-112.65839843749997,
									26.31674804687509
								],
								[
									-113.02075195312499,
									26.58325195312503
								],
								[
									-113.11923828124998,
									26.716503906250097
								],
								[
									-113.14321289062498,
									26.792187499999955
								],
								[
									-113.15581054687497,
									26.946240234375068
								],
								[
									-113.20576171875003,
									26.856982421875017
								],
								[
									-113.27226562499997,
									26.790966796875068
								],
								[
									-113.42587890625,
									26.79580078125008
								],
								[
									-113.59853515625001,
									26.72128906250009
								],
								[
									-113.70126953124998,
									26.791357421875063
								],
								[
									-113.75664062499999,
									26.870849609375
								],
								[
									-113.84096679687502,
									26.96650390625004
								],
								[
									-113.93593750000001,
									26.985253906250023
								],
								[
									-113.996484375,
									26.987695312499994
								],
								[
									-114.11005859374995,
									27.10595703125003
								],
								[
									-114.20185546875,
									27.14350585937504
								],
								[
									-114.33339843749998,
									27.158007812500045
								],
								[
									-114.44526367187503,
									27.218164062499966
								],
								[
									-114.47968750000003,
									27.28359375000005
								],
								[
									-114.498291015625,
									27.376220703125114
								],
								[
									-114.53989257812495,
									27.43110351562501
								],
								[
									-114.71562499999996,
									27.539550781250085
								],
								[
									-114.85874023437498,
									27.659179687500114
								],
								[
									-114.99350585937499,
									27.736035156249955
								],
								[
									-115.033203125,
									27.798876953125045
								],
								[
									-115.03647460937495,
									27.841845703124932
								],
								[
									-114.82353515625,
									27.82993164062509
								],
								[
									-114.57001953124995,
									27.783935546874943
								],
								[
									-114.44848632812497,
									27.796875
								],
								[
									-114.372705078125,
									27.84121093750008
								],
								[
									-114.30058593749996,
									27.872998046875068
								],
								[
									-114.2890625,
									27.838574218750068
								],
								[
									-114.30224609375003,
									27.775732421875063
								],
								[
									-114.23266601562497,
									27.71811523437495
								],
								[
									-114.13720703124997,
									27.671435546875017
								],
								[
									-114.0693359375,
									27.675683593750108
								],
								[
									-114.13505859374999,
									27.72661132812499
								],
								[
									-114.17539062499993,
									27.830566406249943
								],
								[
									-114.15732421874999,
									27.867968750000017
								],
								[
									-114.15839843750003,
									27.91967773437497
								],
								[
									-114.25263671874995,
									27.908007812500074
								],
								[
									-114.26586914062499,
									27.934472656249966
								],
								[
									-114.18525390625,
									28.01328124999995
								],
								[
									-114.09272460937497,
									28.221337890624966
								],
								[
									-114.04848632812502,
									28.42617187500005
								],
								[
									-114.14550781249999,
									28.605419921875068
								],
								[
									-114.30922851562502,
									28.72993164062501
								],
								[
									-114.66401367187501,
									29.094580078125063
								],
								[
									-114.87592773437501,
									29.281884765624937
								],
								[
									-114.9373046875,
									29.351611328124932
								],
								[
									-114.99350585937499,
									29.38442382812505
								],
								[
									-115.16635742187495,
									29.42724609374997
								],
								[
									-115.31118164062497,
									29.531933593749983
								],
								[
									-115.56528320312495,
									29.680029296875063
								],
								[
									-115.67382812500003,
									29.756396484375074
								],
								[
									-115.74868164062501,
									29.93574218750001
								],
								[
									-115.80830078124998,
									29.960205078125114
								],
								[
									-115.78955078124999,
									30.08417968750004
								],
								[
									-115.81562499999997,
									30.303613281249994
								],
								[
									-115.85820312500003,
									30.359814453124983
								],
								[
									-115.99580078125,
									30.414453125000108
								],
								[
									-116.028564453125,
									30.56357421875012
								],
								[
									-116.03535156249997,
									30.705468749999966
								],
								[
									-116.06215820312501,
									30.804150390625097
								],
								[
									-116.29628906250001,
									30.97050781249996
								],
								[
									-116.30961914062497,
									31.050976562499926
								],
								[
									-116.30966796874999,
									31.127343749999937
								],
								[
									-116.33344726562494,
									31.202783203125023
								],
								[
									-116.45849609375001,
									31.360986328124937
								],
								[
									-116.60957031249998,
									31.499072265625102
								],
								[
									-116.66215820312495,
									31.564892578125097
								],
								[
									-116.66845703124999,
									31.69863281250008
								],
								[
									-116.72207031249998,
									31.734570312499926
								],
								[
									-116.701708984375,
									31.74365234375
								],
								[
									-116.65209960937503,
									31.74033203124995
								],
								[
									-116.62387695312496,
									31.758007812500097
								],
								[
									-116.62080078124995,
									31.851074218749943
								],
								[
									-116.84799804687496,
									31.997363281250074
								],
								[
									-116.91367187500002,
									32.198535156250045
								],
								[
									-117.034765625,
									32.30502929687506
								],
								[
									-117.06313476562501,
									32.34360351562509
								],
								[
									-117.12827148437496,
									32.53334960937502
								],
								[
									-116.84208984375,
									32.55478515625006
								],
								[
									-116.55595703124997,
									32.576220703125074
								],
								[
									-116.26982421874995,
									32.59760742187498
								],
								[
									-115.98369140625002,
									32.619042968749994
								],
								[
									-115.69750976562497,
									32.640478515625006
								],
								[
									-115.41137695312503,
									32.661865234375114
								],
								[
									-115.1251953125,
									32.68330078125004
								],
								[
									-114.83906249999997,
									32.70473632812505
								],
								[
									-114.72475585937495,
									32.715332031250085
								],
								[
									-114.78798828124995,
									32.564794921875034
								],
								[
									-114.83593749999996,
									32.508300781250085
								],
								[
									-114.36171874999998,
									32.360302734374955
								],
								[
									-113.88745117187499,
									32.212304687499994
								],
								[
									-113.41318359375,
									32.064306640625034
								],
								[
									-112.93896484375003,
									31.916259765625085
								],
								[
									-112.46474609374995,
									31.768261718749955
								],
								[
									-111.99047851562497,
									31.62021484375009
								],
								[
									-111.51621093749998,
									31.472265625000034
								],
								[
									-111.0419921875,
									31.324218750000085
								],
								[
									-110.68852539062503,
									31.324853515625023
								],
								[
									-110.33510742187497,
									31.32553710937509
								],
								[
									-109.98164062499998,
									31.326171874999943
								],
								[
									-109.62822265625002,
									31.32680664062508
								],
								[
									-109.27475585937495,
									31.327441406250017
								],
								[
									-108.92133789062498,
									31.328125000000085
								],
								[
									-108.56787109375,
									31.328808593749955
								],
								[
									-108.21445312499995,
									31.32944335937509
								],
								[
									-108.213818359375,
									31.441894531250085
								],
								[
									-108.21318359374995,
									31.554394531250068
								],
								[
									-108.21249999999999,
									31.666845703125063
								],
								[
									-108.21181640625002,
									31.77934570312499
								],
								[
									-107.99204101562502,
									31.77817382812512
								],
								[
									-107.772216796875,
									31.777050781250068
								],
								[
									-107.55234374999996,
									31.775878906250085
								],
								[
									-107.33251953124994,
									31.774755859375034
								],
								[
									-107.11269531250002,
									31.773632812499983
								],
								[
									-106.89287109375,
									31.772460937500085
								],
								[
									-106.67304687499998,
									31.771337890625034
								],
								[
									-106.45322265624996,
									31.77016601562508
								],
								[
									-106.44541015624996,
									31.768408203124977
								],
								[
									-106.43603515625001,
									31.764453125000074
								],
								[
									-106.34697265624999,
									31.679003906250074
								],
								[
									-106.25571289062495,
									31.544677734375057
								],
								[
									-106.14804687499996,
									31.450927734375057
								],
								[
									-106.02407226562501,
									31.39775390624996
								],
								[
									-105.81269531250003,
									31.241015625000102
								],
								[
									-105.51401367187502,
									30.980761718750017
								],
								[
									-105.27583007812498,
									30.807275390625023
								],
								[
									-105.09814453125003,
									30.72055664062512
								],
								[
									-104.97880859374996,
									30.645947265624926
								],
								[
									-104.91787109374998,
									30.583349609375063
								],
								[
									-104.83588867187498,
									30.447656249999937
								],
								[
									-104.68134765625003,
									30.134374999999977
								],
								[
									-104.68134765625003,
									29.990527343750074
								],
								[
									-104.62221679687497,
									29.854296874999932
								],
								[
									-104.50400390624995,
									29.677685546874926
								],
								[
									-104.40063476562503,
									29.57373046874997
								],
								[
									-104.31220703124995,
									29.542431640625097
								],
								[
									-104.21552734374998,
									29.47988281250005
								],
								[
									-104.11059570312501,
									29.38613281250005
								],
								[
									-103.98974609374999,
									29.323144531249994
								],
								[
									-103.85292968750001,
									29.291064453125045
								],
								[
									-103.66396484374997,
									29.20688476562512
								],
								[
									-103.42294921874998,
									29.070703124999994
								],
								[
									-103.25771484374998,
									29.001123046874937
								],
								[
									-103.16831054687498,
									28.998193359374966
								],
								[
									-103.08999023437501,
									29.04189453125008
								],
								[
									-103.02285156250001,
									29.13222656250008
								],
								[
									-102.95683593749997,
									29.19038085937504
								],
								[
									-102.8919921875,
									29.216406250000006
								],
								[
									-102.86567382812495,
									29.258007812499955
								],
								[
									-102.87783203124995,
									29.31533203125008
								],
								[
									-102.83398437499999,
									29.443945312500006
								],
								[
									-102.73417968749999,
									29.64394531250008
								],
								[
									-102.61494140624995,
									29.75234375000005
								],
								[
									-102.47626953125003,
									29.76909179687499
								],
								[
									-102.38564453124995,
									29.806640625
								],
								[
									-102.34306640624999,
									29.864990234375085
								],
								[
									-102.26894531249998,
									29.871191406250006
								],
								[
									-102.1630859375,
									29.825244140625045
								],
								[
									-101.99091796875001,
									29.79570312499999
								],
								[
									-101.75234374999998,
									29.782470703125057
								],
								[
									-101.61162109375,
									29.786962890625063
								],
								[
									-101.56870117187496,
									29.809228515624994
								],
								[
									-101.54638671874994,
									29.808056640624926
								],
								[
									-101.54462890624994,
									29.78354492187509
								],
								[
									-101.50927734375003,
									29.773144531249926
								],
								[
									-101.44038085937503,
									29.77685546874997
								],
								[
									-101.38037109374997,
									29.74257812500008
								],
								[
									-101.30351562499995,
									29.634082031250017
								],
								[
									-101.03896484374995,
									29.460400390624983
								],
								[
									-101.03862304687497,
									29.460302734375063
								],
								[
									-101.01630859374995,
									29.400683593750074
								],
								[
									-100.92412109375,
									29.314697265625057
								],
								[
									-100.75458984375003,
									29.182519531250023
								],
								[
									-100.65864257812501,
									29.068554687500097
								],
								[
									-100.63632812499999,
									28.972802734374937
								],
								[
									-100.54970703125002,
									28.82133789062499
								],
								[
									-100.39892578124994,
									28.614208984374983
								],
								[
									-100.33173828125003,
									28.502539062500063
								],
								[
									-100.34814453125,
									28.486425781249977
								],
								[
									-100.33627929687498,
									28.428124999999994
								],
								[
									-100.29604492187495,
									28.32768554687496
								],
								[
									-100.22128906249999,
									28.242626953124955
								],
								[
									-100.11196289062502,
									28.172949218750063
								],
								[
									-100.00141601562497,
									28.04785156249997
								],
								[
									-99.88964843750003,
									27.867285156250063
								],
								[
									-99.75424804687498,
									27.729931640624955
								],
								[
									-99.5953125,
									27.63588867187508
								],
								[
									-99.50532226562497,
									27.54833984375
								],
								[
									-99.48427734374995,
									27.46738281250012
								],
								[
									-99.48583984375,
									27.39804687500012
								],
								[
									-99.51005859374996,
									27.340332031250085
								],
								[
									-99.4998046875,
									27.285498046875006
								],
								[
									-99.45512695312496,
									27.233691406249932
								],
								[
									-99.44023437499995,
									27.17011718750004
								],
								[
									-99.45771484374995,
									27.081689453124966
								],
								[
									-99.45654296874999,
									27.056689453124932
								],
								[
									-99.45649414062497,
									27.056640625000114
								],
								[
									-99.4435546875,
									27.036669921875017
								],
								[
									-99.30244140625003,
									26.884716796874983
								],
								[
									-99.229931640625,
									26.76191406250001
								],
								[
									-99.17236328125,
									26.565917968750057
								],
								[
									-99.17207031250003,
									26.564160156249955
								],
								[
									-99.10776367187498,
									26.446923828124966
								],
								[
									-99.01528320312497,
									26.39897460937496
								],
								[
									-98.87319335937498,
									26.381249999999994
								],
								[
									-98.765234375,
									26.340429687500034
								],
								[
									-98.69140624999997,
									26.276464843750063
								],
								[
									-98.59829101562502,
									26.237841796875102
								],
								[
									-98.48588867187493,
									26.224560546874955
								],
								[
									-98.37812500000001,
									26.182373046875057
								],
								[
									-98.27504882812497,
									26.11118164062495
								],
								[
									-98.08281249999999,
									26.06445312500003
								],
								[
									-97.80141601562494,
									26.04204101562499
								],
								[
									-97.587255859375,
									25.984179687500017
								],
								[
									-97.440283203125,
									25.890820312500097
								],
								[
									-97.37563476562497,
									25.87182617187503
								],
								[
									-97.35815429687497,
									25.87050781250005
								],
								[
									-97.34975585937494,
									25.884765625000114
								],
								[
									-97.33867187499999,
									25.911181640625074
								],
								[
									-97.28178710937496,
									25.941601562499955
								],
								[
									-97.14624023437497,
									25.961474609375102
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "MEX",
					"su_a3": "MEX",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "MEX",
					"gu_a3": "MEX",
					"abbrev": "Mex.",
					"region_un": "Americas",
					"adm0_a3_us": "MEX",
					"scalerank": 1,
					"pop_est": 111211789,
					"adm0_dif": 0,
					"un_a3": "484",
					"pop_year": -99,
					"gdp_md_est": 1563000,
					"name": "Mexico",
					"sovereignt": "Mexico",
					"economy": "4. Emerging region: MIKT",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Mexico",
					"postal": "MX",
					"sov_a3": "MEX",
					"note_brk": "",
					"brk_a3": "MEX",
					"wb_a2": "MX",
					"brk_diff": 0,
					"admin": "Mexico",
					"name_long": "Mexico",
					"iso_a3": "MEX",
					"iso_a2": "MX",
					"adm0_a3_is": "MEX",
					"level": 2,
					"formal_en": "United Mexican States",
					"name_len": 6,
					"mapcolor7": 6,
					"long_len": 6,
					"mapcolor8": 1,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "484",
					"homepart": 1,
					"subunit": "Mexico",
					"name_alt": "",
					"brk_name": "Mexico",
					"name_sort": "Mexico",
					"continent": "North America",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								22.344042968750045,
								42.31396484374997
							],
							[
								22.49824218750001,
								42.16508789062502
							],
							[
								22.582714843749983,
								42.104833984375006
							],
							[
								22.68232421875004,
								42.05913085937502
							],
							[
								22.79609375000004,
								42.02568359374996
							],
							[
								22.83681640625008,
								41.99360351562498
							],
							[
								22.909179687500057,
								41.83520507812506
							],
							[
								22.943945312500034,
								41.77509765625007
							],
							[
								22.991992187500074,
								41.75717773437506
							],
							[
								23.00361328125004,
								41.73984374999998
							],
							[
								23.005664062500017,
								41.71694335937502
							],
							[
								22.951464843750074,
								41.605615234374994
							],
							[
								22.92968749999997,
								41.356103515624966
							],
							[
								22.91601562500003,
								41.336279296875006
							],
							[
								22.859277343750023,
								41.33735351562507
							],
							[
								22.78388671875004,
								41.33198242187504
							],
							[
								22.75507812500001,
								41.312744140625114
							],
							[
								22.724804687500068,
								41.17851562500002
							],
							[
								22.603613281249977,
								41.140185546875045
							],
							[
								22.493554687500023,
								41.11850585937506
							],
							[
								22.40078125000005,
								41.12338867187509
							],
							[
								22.23769531250005,
								41.15517578125008
							],
							[
								22.18447265625005,
								41.15864257812507
							],
							[
								22.138867187500068,
								41.14052734375002
							],
							[
								21.99335937500001,
								41.13095703125012
							],
							[
								21.929492187500045,
								41.10742187500003
							],
							[
								21.77949218750004,
								40.950439453125114
							],
							[
								21.627539062500006,
								40.896337890625006
							],
							[
								21.575781250000034,
								40.86894531250002
							],
							[
								21.459667968749983,
								40.903613281250074
							],
							[
								21.404101562500045,
								40.9071777343751
							],
							[
								21.32373046875,
								40.86713867187501
							],
							[
								21.147558593750006,
								40.86313476562509
							],
							[
								21.10000000000008,
								40.85615234375007
							],
							[
								20.96425781250005,
								40.84990234374996
							],
							[
								20.958593750000063,
								40.87153320312501
							],
							[
								20.93349609375008,
								40.90312499999996
							],
							[
								20.870214843749977,
								40.91791992187504
							],
							[
								20.740820312500006,
								40.90527343750006
							],
							[
								20.709277343750074,
								40.92836914062505
							],
							[
								20.656054687500045,
								41.06166992187502
							],
							[
								20.61445312500001,
								41.083056640625045
							],
							[
								20.56787109375003,
								41.127832031249994
							],
							[
								20.48896484375004,
								41.27260742187502
							],
							[
								20.487011718750068,
								41.336083984374966
							],
							[
								20.49238281250001,
								41.39140624999996
							],
							[
								20.44863281250008,
								41.52128906249996
							],
							[
								20.475585937500057,
								41.554101562499994
							],
							[
								20.516210937499977,
								41.57475585937502
							],
							[
								20.516601562500057,
								41.627050781250006
							],
							[
								20.505175781250045,
								41.70649414062504
							],
							[
								20.55312500000005,
								41.86235351562499
							],
							[
								20.566210937500045,
								41.873681640624994
							],
							[
								20.57851562500008,
								41.86621093749997
							],
							[
								20.694921875000063,
								41.85380859375002
							],
							[
								20.72500000000008,
								41.87353515625006
							],
							[
								20.744140625000057,
								41.904296875
							],
							[
								20.75039062500008,
								42.01835937499999
							],
							[
								20.778125000000045,
								42.07104492187506
							],
							[
								21.059765625000068,
								42.17128906250005
							],
							[
								21.142480468750023,
								42.17500000000001
							],
							[
								21.20605468750003,
								42.128955078125045
							],
							[
								21.256347656250057,
								42.099511718749994
							],
							[
								21.28662109375,
								42.10039062499999
							],
							[
								21.29755859375001,
								42.13007812500001
							],
							[
								21.33173828125004,
								42.187158203124994
							],
							[
								21.389550781249994,
								42.21982421874998
							],
							[
								21.56083984374999,
								42.24765625000006
							],
							[
								21.56249999999997,
								42.24750976562504
							],
							[
								21.618261718750063,
								42.2421386718751
							],
							[
								21.73925781250003,
								42.26772460937505
							],
							[
								21.81464843750001,
								42.303124999999994
							],
							[
								21.85302734375003,
								42.3083984375001
							],
							[
								21.904101562500017,
								42.322070312500045
							],
							[
								21.97753906249997,
								42.32006835937506
							],
							[
								22.052050781250074,
								42.30463867187504
							],
							[
								22.146679687500068,
								42.3250000000001
							],
							[
								22.23974609375003,
								42.358154296875114
							],
							[
								22.277050781250068,
								42.349853515625085
							],
							[
								22.31738281250003,
								42.32172851562504
							],
							[
								22.344042968750045,
								42.31396484374997
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "MKD",
					"su_a3": "MKD",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "MKD",
					"gu_a3": "MKD",
					"abbrev": "Mkd.",
					"region_un": "Europe",
					"adm0_a3_us": "MKD",
					"scalerank": 1,
					"pop_est": 2066718,
					"adm0_dif": 0,
					"un_a3": "807",
					"pop_year": -99,
					"gdp_md_est": 18780,
					"name": "Macedonia",
					"sovereignt": "Macedonia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Macedonia",
					"postal": "MK",
					"sov_a3": "MKD",
					"note_brk": "",
					"brk_a3": "MKD",
					"wb_a2": "MK",
					"brk_diff": 0,
					"admin": "Macedonia",
					"name_long": "Macedonia",
					"iso_a3": "MKD",
					"iso_a2": "MK",
					"adm0_a3_is": "MKD",
					"level": 2,
					"formal_en": "Former Yugoslav Republic of Macedonia",
					"name_len": 9,
					"mapcolor7": 5,
					"long_len": 9,
					"mapcolor8": 3,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "807",
					"homepart": 1,
					"subunit": "Macedonia",
					"name_alt": "",
					"brk_name": "Macedonia",
					"name_sort": "Macedonia, FYR",
					"continent": "Europe",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									111.38925781250009,
									2.415332031250074
								],
								[
									111.35869140625016,
									2.4021972656250625
								],
								[
									111.31152343749994,
									2.437597656250091
								],
								[
									111.30039062500009,
									2.7411621093750256
								],
								[
									111.33349609375,
									2.7683105468750426
								],
								[
									111.3550781250002,
									2.7644531249999744
								],
								[
									111.37832031249997,
									2.7093261718749346
								],
								[
									111.37626953124999,
									2.576318359375108
								],
								[
									111.38046875000003,
									2.4589355468750824
								],
								[
									111.38925781250009,
									2.415332031250074
								]
							]
						],
						[
							[
								[
									104.22158203124997,
									2.7317382812500597
								],
								[
									104.17333984375011,
									2.7213378906250654
								],
								[
									104.14687500000014,
									2.728222656250054
								],
								[
									104.12910156250018,
									2.7672363281250085
								],
								[
									104.16982421875002,
									2.856835937499966
								],
								[
									104.18476562500001,
									2.87172851562498
								],
								[
									104.22324218750003,
									2.7742187500001023
								],
								[
									104.22158203124997,
									2.7317382812500597
								]
							]
						],
						[
							[
								[
									101.31855468750018,
									2.988476562500054
								],
								[
									101.26806640625011,
									2.9704101562500114
								],
								[
									101.26542968749999,
									2.9964843749999943
								],
								[
									101.27421875000005,
									3.0328124999999346
								],
								[
									101.31123046875001,
									3.0673828125000426
								],
								[
									101.32841796875016,
									3.0476074218750995
								],
								[
									101.31855468750018,
									2.988476562500054
								]
							]
						],
						[
							[
								[
									117.884765625,
									4.1861328125000625
								],
								[
									117.74541015625005,
									4.166943359375054
								],
								[
									117.6490234375002,
									4.168994140624946
								],
								[
									117.66679687499999,
									4.204003906250065
								],
								[
									117.66210937500011,
									4.250195312499969
								],
								[
									117.70800781249994,
									4.262402343749969
								],
								[
									117.76142578125018,
									4.252343750000051
								],
								[
									117.884765625,
									4.1861328125000625
								]
							]
						],
						[
							[
								[
									100.28896484375014,
									5.29472656249996
								],
								[
									100.26376953125003,
									5.266992187499994
								],
								[
									100.19101562500009,
									5.282861328125023
								],
								[
									100.20390625000005,
									5.446875000000048
								],
								[
									100.24550781249997,
									5.467773437500043
								],
								[
									100.3101562500002,
									5.437939453125097
								],
								[
									100.3388671875,
									5.4100585937500085
								],
								[
									100.28896484375014,
									5.29472656249996
								]
							]
						],
						[
							[
								[
									99.84804687500002,
									6.465722656250051
								],
								[
									99.91865234375018,
									6.358593749999983
								],
								[
									99.8833984375002,
									6.310839843750017
								],
								[
									99.86582031250009,
									6.297070312500054
								],
								[
									99.82324218750011,
									6.312744140625057
								],
								[
									99.78261718750002,
									6.27158203125002
								],
								[
									99.74375000000009,
									6.26328125000002
								],
								[
									99.7046875000002,
									6.337548828125051
								],
								[
									99.65664062500002,
									6.36713867187504
								],
								[
									99.64628906250005,
									6.41835937500008
								],
								[
									99.71054687500003,
									6.427343750000048
								],
								[
									99.74921875000001,
									6.409619140625068
								],
								[
									99.82167968750014,
									6.445019531250097
								],
								[
									99.84804687500002,
									6.465722656250051
								]
							]
						],
						[
							[
								[
									102.10107421875,
									6.242236328125074
								],
								[
									102.27402343750003,
									6.203417968749989
								],
								[
									102.34013671875005,
									6.17202148437508
								],
								[
									102.53437500000018,
									5.862548828125
								],
								[
									102.79023437500007,
									5.644921875000065
								],
								[
									102.8985351562502,
									5.56376953125006
								],
								[
									102.98242187499994,
									5.52495117187506
								],
								[
									103.09707031250014,
									5.408447265625028
								],
								[
									103.19697265625007,
									5.262158203125068
								],
								[
									103.41582031250016,
									4.850292968750011
								],
								[
									103.45390624999999,
									4.669482421874946
								],
								[
									103.46875000000011,
									4.393261718749983
								],
								[
									103.4205078125002,
									3.9768554687500597
								],
								[
									103.36201171875001,
									3.76914062500002
								],
								[
									103.37333984375005,
									3.6710937499999403
								],
								[
									103.45351562500002,
									3.520605468750105
								],
								[
									103.42949218749999,
									3.3785644531250227
								],
								[
									103.44501953125007,
									3.2605957031249773
								],
								[
									103.439453125,
									2.9331054687500426
								],
								[
									103.48515625000016,
									2.836572265625094
								],
								[
									103.53730468750001,
									2.774755859375034
								],
								[
									103.81220703125018,
									2.5804687500000654
								],
								[
									103.83232421874999,
									2.508496093750054
								],
								[
									103.9677734375,
									2.2612304687500426
								],
								[
									104.21855468749999,
									1.7228515625000398
								],
								[
									104.28847656250014,
									1.4806640625000824
								],
								[
									104.28037109375009,
									1.4155761718749744
								],
								[
									104.2500976562502,
									1.38857421874998
								],
								[
									104.1763671875002,
									1.3648925781249517
								],
								[
									104.11494140625001,
									1.4122558593750085
								],
								[
									104.09423828125,
									1.4461914062499943
								],
								[
									104.10058593750011,
									1.4883300781250455
								],
								[
									104.07617187500011,
									1.5297851562499716
								],
								[
									104.01601562500014,
									1.5792968750000256
								],
								[
									103.98144531250011,
									1.6236328125000767
								],
								[
									103.99121093749994,
									1.5500488281250142
								],
								[
									103.99150390624999,
									1.4547851562499687
								],
								[
									103.91513671875009,
									1.4466796875000938
								],
								[
									103.81679687500014,
									1.4765625000000568
								],
								[
									103.69453125000018,
									1.4496582031250824
								],
								[
									103.54980468750011,
									1.3328124999999886
								],
								[
									103.48027343750016,
									1.3294921875000227
								],
								[
									103.4273437500002,
									1.429833984375037
								],
								[
									103.4000000000002,
									1.4978515625000313
								],
								[
									103.35683593750014,
									1.5461425781250995
								],
								[
									102.89687500000014,
									1.7923339843749915
								],
								[
									102.7271484375002,
									1.8555664062500767
								],
								[
									102.54824218750014,
									2.0423828124999517
								],
								[
									102.1456054687502,
									2.248486328125111
								],
								[
									101.88994140625016,
									2.4494140625000966
								],
								[
									101.78125000000011,
									2.5735839843749915
								],
								[
									101.51972656250007,
									2.6836425781250313
								],
								[
									101.40683593750003,
									2.813476562500014
								],
								[
									101.35136718750005,
									2.8389648437500483
								],
								[
									101.2955078125002,
									2.885205078125054
								],
								[
									101.35429687499999,
									3.011132812500051
								],
								[
									101.33017578125003,
									3.1424804687500654
								],
								[
									101.2999023437502,
									3.2532714843750767
								],
								[
									101.11542968750018,
									3.4720214843750625
								],
								[
									101.02480468750014,
									3.6247070312500824
								],
								[
									100.85126953125001,
									3.776708984374963
								],
								[
									100.78183593750009,
									3.864453125000068
								],
								[
									100.71542968750003,
									3.9662109375000227
								],
								[
									100.75703125000018,
									4.0018066406249915
								],
								[
									100.7955078125002,
									4.02338867187504
								],
								[
									100.76025390624994,
									4.09721679687506
								],
								[
									100.66103515624997,
									4.225732421875051
								],
								[
									100.61455078125005,
									4.373437500000023
								],
								[
									100.61455078125005,
									4.65224609375008
								],
								[
									100.47343750000016,
									5.044287109375091
								],
								[
									100.35263671875003,
									5.58769531249996
								],
								[
									100.37402343749994,
									5.777978515625094
								],
								[
									100.34326171875,
									5.984179687500088
								],
								[
									100.26328125000003,
									6.182519531249994
								],
								[
									100.15839843750018,
									6.324218750000085
								],
								[
									100.119140625,
									6.441992187500091
								],
								[
									100.13798828124999,
									6.488671875000108
								],
								[
									100.1612304687502,
									6.641601562500085
								],
								[
									100.17675781250011,
									6.671826171875026
								],
								[
									100.21660156250005,
									6.68662109375002
								],
								[
									100.26142578125001,
									6.682714843749935
								],
								[
									100.34541015625018,
									6.549902343750048
								],
								[
									100.56386718750002,
									6.467529296874972
								],
								[
									100.62949218750003,
									6.447998046875071
								],
								[
									100.71562499999999,
									6.480664062499983
								],
								[
									100.7544921875002,
									6.460058593750048
								],
								[
									100.79375000000005,
									6.426171875000065
								],
								[
									100.81650390625003,
									6.331640625000091
								],
								[
									100.87392578125002,
									6.245410156250017
								],
								[
									100.98876953124994,
									6.25766601562502
								],
								[
									101.02939453125009,
									6.245312499999997
								],
								[
									101.05351562499999,
									6.242578125000065
								],
								[
									101.07597656250016,
									6.166064453125017
								],
								[
									101.08652343750009,
									6.033691406250043
								],
								[
									101.07558593749997,
									5.9564941406249545
								],
								[
									100.99277343750009,
									5.846191406250043
								],
								[
									100.98164062500001,
									5.771044921875102
								],
								[
									101.02519531249999,
									5.724511718750037
								],
								[
									101.08173828125018,
									5.674902343749963
								],
								[
									101.11396484375018,
									5.636767578125102
								],
								[
									101.14765625000018,
									5.643066406250043
								],
								[
									101.19062500000007,
									5.6687500000000455
								],
								[
									101.22978515625005,
									5.733691406250031
								],
								[
									101.25703125000018,
									5.789355468750102
								],
								[
									101.40419921875014,
									5.851660156250091
								],
								[
									101.55605468749997,
									5.907763671874974
								],
								[
									101.5767578125002,
									5.902001953125037
								],
								[
									101.60136718750016,
									5.8771484374999545
								],
								[
									101.6500000000002,
									5.795996093750034
								],
								[
									101.67841796875007,
									5.778808593750085
								],
								[
									101.71953125000016,
									5.770605468750091
								],
								[
									101.79072265625018,
									5.779345703125017
								],
								[
									101.8736328125002,
									5.825292968750048
								],
								[
									101.91718750000018,
									5.911376953125
								],
								[
									101.93613281250003,
									5.9793457031249915
								],
								[
									102.05517578124994,
									6.096679687500085
								],
								[
									102.068359375,
									6.184667968750077
								],
								[
									102.10107421875,
									6.242236328125074
								]
							]
						],
						[
							[
								[
									117.57441406250018,
									4.170605468750097
								],
								[
									117.53730468750018,
									4.171386718750071
								],
								[
									117.45087890625007,
									4.192871093750014
								],
								[
									117.27753906250018,
									4.299316406250028
								],
								[
									117.10058593750011,
									4.33706054687508
								],
								[
									116.84355468750016,
									4.340136718750088
								],
								[
									116.69785156250003,
									4.35498046875
								],
								[
									116.63867187499994,
									4.339111328125057
								],
								[
									116.58906250000018,
									4.338427734375003
								],
								[
									116.55312500000014,
									4.3598632812500995
								],
								[
									116.51474609375003,
									4.370800781250026
								],
								[
									116.41455078124994,
									4.3082031250000625
								],
								[
									116.36767578125011,
									4.327343750000054
								],
								[
									116.32031249999994,
									4.353710937500097
								],
								[
									116.23623046875014,
									4.362548828124943
								],
								[
									116.13447265625001,
									4.35517578125004
								],
								[
									116.0215820312502,
									4.290673828125037
								],
								[
									115.89619140625007,
									4.34868164062496
								],
								[
									115.86074218750014,
									4.3480468750000085
								],
								[
									115.83681640625014,
									4.333300781250017
								],
								[
									115.78242187500007,
									4.253759765625077
								],
								[
									115.67880859375009,
									4.193017578125037
								],
								[
									115.6275390625002,
									4.081982421874983
								],
								[
									115.59609375000014,
									3.9755371093749687
								],
								[
									115.56845703125009,
									3.9387695312500313
								],
								[
									115.56093750000014,
									3.7330566406249517
								],
								[
									115.54453125000009,
									3.633691406250051
								],
								[
									115.57070312500002,
									3.502294921875105
								],
								[
									115.56611328125007,
									3.44575195312504
								],
								[
									115.51992187500014,
									3.361669921874963
								],
								[
									115.51425781250003,
									3.342382812500034
								],
								[
									115.48974609375011,
									3.208642578125051
								],
								[
									115.49912109375009,
									3.173144531250017
								],
								[
									115.49316406250011,
									3.1281250000000824
								],
								[
									115.45439453125005,
									3.0343261718750654
								],
								[
									115.38417968750002,
									3.0087402343750966
								],
								[
									115.3101562500002,
									2.9939453125001023
								],
								[
									115.24697265625014,
									3.0259277343750455
								],
								[
									115.18994140624994,
									2.974462890624949
								],
								[
									115.11757812499997,
									2.8948730468750767
								],
								[
									115.08632812500002,
									2.84111328124996
								],
								[
									115.08652343750003,
									2.7912109375000966
								],
								[
									115.09365234374997,
									2.7578125000000426
								],
								[
									115.07890624999999,
									2.7234375000000597
								],
								[
									115.07705078124997,
									2.6870117187500995
								],
								[
									115.08076171875001,
									2.6342285156250824
								],
								[
									115.1298828125,
									2.6124023437500767
								],
								[
									115.18085937500018,
									2.5668945312500426
								],
								[
									115.17910156249997,
									2.5231933593750284
								],
								[
									115.15078124999997,
									2.492919921875071
								],
								[
									115.08652343750003,
									2.446142578124963
								],
								[
									114.96914062500002,
									2.3508300781250853
								],
								[
									114.83632812500014,
									2.269384765625105
								],
								[
									114.78642578124999,
									2.250488281250071
								],
								[
									114.76835937500016,
									2.2129394531250597
								],
								[
									114.75869140625014,
									2.1624023437500597
								],
								[
									114.78798828124997,
									2.0516113281250483
								],
								[
									114.81582031250014,
									2.0189453125000654
								],
								[
									114.83056640625011,
									1.9800292968750313
								],
								[
									114.81269531250001,
									1.9337890625000256
								],
								[
									114.80000000000001,
									1.8939453125000796
								],
								[
									114.75107421875009,
									1.8689941406249773
								],
								[
									114.70351562499997,
									1.8507812499999972
								],
								[
									114.6861328125002,
									1.8190429687500966
								],
								[
									114.66093750000005,
									1.6862792968750568
								],
								[
									114.63222656250014,
									1.6170410156250767
								],
								[
									114.56748046875009,
									1.5141601562499858
								],
								[
									114.54589843750011,
									1.467138671875091
								],
								[
									114.51250000000016,
									1.4520019531249346
								],
								[
									114.38710937500002,
									1.5000488281250455
								],
								[
									114.27470703125005,
									1.470898437500054
								],
								[
									114.12597656250011,
									1.4523437500000966
								],
								[
									114.00000000000011,
									1.4552734375000682
								],
								[
									113.90234375000011,
									1.434277343750054
								],
								[
									113.83525390625005,
									1.3798828124999858
								],
								[
									113.76035156250003,
									1.3113769531250625
								],
								[
									113.68164062500011,
									1.26059570312502
								],
								[
									113.62226562500018,
									1.2359375000000625
								],
								[
									113.51318359374994,
									1.3083984374999886
								],
								[
									113.45820312500007,
									1.3021484375000512
								],
								[
									113.35898437500009,
									1.327148437500071
								],
								[
									113.12626953124999,
									1.4081054687500512
								],
								[
									113.06865234374999,
									1.4317871093750796
								],
								[
									113.00654296875007,
									1.4338867187499744
								],
								[
									112.98828124999994,
									1.457128906250091
								],
								[
									112.99804687500011,
									1.4962402343750654
								],
								[
									112.98828124999994,
									1.5475585937500398
								],
								[
									112.94296875000003,
									1.566992187500091
								],
								[
									112.47617187500009,
									1.559082031250071
								],
								[
									112.34160156250005,
									1.51474609375002
								],
								[
									112.25068359375007,
									1.4796386718750512
								],
								[
									112.18574218750018,
									1.439062499999963
								],
								[
									112.16738281250014,
									1.338183593750017
								],
								[
									112.12861328125007,
									1.2436035156250256
								],
								[
									112.07851562499997,
									1.1433593750000313
								],
								[
									111.92314453125005,
									1.1132812500000284
								],
								[
									111.80898437500014,
									1.0116699218750256
								],
								[
									111.76972656250007,
									0.9994628906250256
								],
								[
									111.69130859375014,
									1.014208984375088
								],
								[
									111.60742187500011,
									1.0226074218750227
								],
								[
									111.54667968750016,
									0.9943359374999545
								],
								[
									111.48320312500005,
									0.9957519531250654
								],
								[
									111.28671875000003,
									1.0432128906250568
								],
								[
									111.10136718750005,
									1.0505371093750284
								],
								[
									110.99609375000011,
									1.0263671875000853
								],
								[
									110.93808593750009,
									1.0173339843751137
								],
								[
									110.61474609375011,
									0.8781250000000824
								],
								[
									110.50576171875014,
									0.8619628906250796
								],
								[
									110.46142578124994,
									0.882080078125
								],
								[
									110.39902343750003,
									0.9390625000000625
								],
								[
									110.31523437500005,
									0.9959960937499375
								],
								[
									110.11474609375011,
									1.190136718750054
								],
								[
									110.04082031250016,
									1.2357421875000227
								],
								[
									109.99169921875011,
									1.2825683593750483
								],
								[
									109.94492187500009,
									1.3380371093750796
								],
								[
									109.87851562500003,
									1.3978515625000938
								],
								[
									109.81806640625018,
									1.4389648437499432
								],
								[
									109.73574218750002,
									1.52294921875
								],
								[
									109.65400390625007,
									1.6148925781250796
								],
								[
									109.63583984375009,
									1.776660156250088
								],
								[
									109.57080078125,
									1.8062988281249943
								],
								[
									109.54892578125003,
									1.8483398437500256
								],
								[
									109.53896484374997,
									1.8961914062500114
								],
								[
									109.62890625000011,
									2.02753906250004
								],
								[
									109.69433593750011,
									1.888769531250091
								],
								[
									109.71962890625002,
									1.8578125000000085
								],
								[
									109.8648437500002,
									1.764453125000088
								],
								[
									109.98457031250018,
									1.7176269531250483
								],
								[
									110.11406250000016,
									1.6985839843750767
								],
								[
									110.24589843750005,
									1.6947265625000938
								],
								[
									110.29833984374994,
									1.701171875000071
								],
								[
									110.3492187500002,
									1.7197265624999432
								],
								[
									110.39951171875003,
									1.69985351562498
								],
								[
									110.67519531249997,
									1.548046875000054
								],
								[
									110.78203124999999,
									1.52084960937502
								],
								[
									110.89492187499997,
									1.5324707031249858
								],
								[
									110.93994140625011,
									1.5173339843750995
								],
								[
									111.09843750000016,
									1.40087890625
								],
								[
									111.14521484375018,
									1.3869628906250995
								],
								[
									111.2232421875002,
									1.395849609375034
								],
								[
									111.12343750000002,
									1.4490234375000313
								],
								[
									111.05800781250002,
									1.4866699218750625
								],
								[
									111.02871093749997,
									1.5578124999999972
								],
								[
									111.04658203125018,
									1.6336425781249915
								],
								[
									111.11015625000016,
									1.6840820312500568
								],
								[
									111.15419921875014,
									1.7387695312500853
								],
								[
									111.17001953125009,
									1.9022949218750114
								],
								[
									111.19804687500005,
									1.9851074218750995
								],
								[
									111.25087890625014,
									2.0638671875000654
								],
								[
									111.2681640625002,
									2.1397460937500625
								],
								[
									111.20888671875002,
									2.197656249999966
								],
								[
									111.19550781250001,
									2.2971679687499886
								],
								[
									111.2085937500002,
									2.3796386718750853
								],
								[
									111.24218749999994,
									2.435742187500068
								],
								[
									111.29589843749994,
									2.3987792968750767
								],
								[
									111.35136718750016,
									2.364453125000111
								],
								[
									111.40615234375014,
									2.3678710937500966
								],
								[
									111.44384765625011,
									2.38154296875004
								],
								[
									111.45078125000009,
									2.4240722656250853
								],
								[
									111.44042968750011,
									2.4980957031250597
								],
								[
									111.44326171874997,
									2.634326171874932
								],
								[
									111.51250000000016,
									2.7430175781250483
								],
								[
									111.62324218750007,
									2.817968750000034
								],
								[
									111.72773437500001,
									2.8538085937500597
								],
								[
									112.11884765625001,
									2.9146972656250227
								],
								[
									112.7373046875,
									3.070458984374966
								],
								[
									112.9205078125002,
									3.1307128906250767
								],
								[
									112.98789062500003,
									3.161914062499946
								],
								[
									113.04472656249999,
									3.2052246093750654
								],
								[
									113.1402343750002,
									3.3435058593750853
								],
								[
									113.32011718750016,
									3.5614746093750824
								],
								[
									113.44609375000016,
									3.7405761718750625
								],
								[
									113.71210937500018,
									4.001416015625082
								],
								[
									113.92392578125009,
									4.24321289062506
								],
								[
									113.95253906250014,
									4.288720703125094
								],
								[
									113.98779296875011,
									4.42070312500006
								],
								[
									113.99042968750001,
									4.482812500000023
								],
								[
									113.98427734375002,
									4.545800781250065
								],
								[
									114.01250000000016,
									4.575244140624932
								],
								[
									114.05361328125002,
									4.5928710937500625
								],
								[
									114.06386718749997,
									4.592675781250023
								],
								[
									114.09511718750014,
									4.565234375000017
								],
								[
									114.16884765625014,
									4.526953125000034
								],
								[
									114.22412109375011,
									4.4778808593749915
								],
								[
									114.26103515624999,
									4.414257812499997
								],
								[
									114.28759765625,
									4.354736328125043
								],
								[
									114.28964843750003,
									4.304199218749957
								],
								[
									114.32294921875018,
									4.262792968750048
								],
								[
									114.41660156250009,
									4.255859375000057
								],
								[
									114.44707031250016,
									4.203564453125054
								],
								[
									114.51220703125011,
									4.113574218750017
								],
								[
									114.57177734375,
									4.049072265625028
								],
								[
									114.60830078125014,
									4.02397460937506
								],
								[
									114.65410156250016,
									4.037646484375102
								],
								[
									114.72500000000002,
									4.09653320312502
								],
								[
									114.77617187500016,
									4.168798828125077
								],
								[
									114.81044921875002,
									4.266503906250094
								],
								[
									114.78349609375005,
									4.280761718750071
								],
								[
									114.83105468749994,
									4.354492187500071
								],
								[
									114.84023437500014,
									4.393212890625065
								],
								[
									114.81826171875002,
									4.428759765624932
								],
								[
									114.79013671875003,
									4.463916015624989
								],
								[
									114.779296875,
									4.553027343750017
								],
								[
									114.75996093750001,
									4.666503906250043
								],
								[
									114.74667968750009,
									4.718066406250074
								],
								[
									114.7841796875,
									4.754833984375097
								],
								[
									114.86455078125005,
									4.801757812500071
								],
								[
									114.94472656250002,
									4.856250000000074
								],
								[
									115.02675781250014,
									4.8997070312500455
								],
								[
									115.02880859375011,
									4.821142578124935
								],
								[
									115.02675781250014,
									4.691357421875054
								],
								[
									115.05156250000005,
									4.582666015625023
								],
								[
									115.10703125000003,
									4.390429687500031
								],
								[
									115.17060546875001,
									4.364208984375097
								],
								[
									115.24667968750009,
									4.347216796875017
								],
								[
									115.29062500000003,
									4.3525878906250455
								],
								[
									115.31923828125002,
									4.36528320312506
								],
								[
									115.32675781250003,
									4.380761718750094
								],
								[
									115.27929687499994,
									4.4563476562500455
								],
								[
									115.26669921875003,
									4.633984374999997
								],
								[
									115.22792968749997,
									4.750585937499949
								],
								[
									115.16845703125011,
									4.866699218750071
								],
								[
									115.14003906250002,
									4.899755859374963
								],
								[
									115.37490234374997,
									4.9327636718749375
								],
								[
									115.42763671874997,
									4.969189453125068
								],
								[
									115.51982421875005,
									5.048925781249977
								],
								[
									115.55449218750016,
									5.093554687500102
								],
								[
									115.58203125000011,
									5.194140625000074
								],
								[
									115.46689453125009,
									5.254101562500026
								],
								[
									115.42167968749999,
									5.330517578124969
								],
								[
									115.4190429687502,
									5.413183593749935
								],
								[
									115.55644531250005,
									5.566699218749946
								],
								[
									115.60390625000002,
									5.603417968749966
								],
								[
									115.62451171874994,
									5.5488769531250455
								],
								[
									115.68505859375011,
									5.535107421875082
								],
								[
									115.7408203125002,
									5.533007812500102
								],
								[
									115.796875,
									5.536132812500028
								],
								[
									115.87714843750018,
									5.613525390625071
								],
								[
									115.91845703124994,
									5.724951171875034
								],
								[
									116.05976562500018,
									5.8823730468750455
								],
								[
									116.11005859375001,
									6.0032714843750625
								],
								[
									116.13837890625018,
									6.129541015625037
								],
								[
									116.49472656250003,
									6.521679687500082
								],
								[
									116.53828125000001,
									6.582714843750082
								],
								[
									116.74980468750016,
									6.9770996093750455
								],
								[
									116.77617187499999,
									6.990234375000057
								],
								[
									116.83300781249994,
									6.952050781250094
								],
								[
									116.84980468750018,
									6.82670898437496
								],
								[
									116.84199218750018,
									6.77207031250002
								],
								[
									116.80771484375003,
									6.691064453125037
								],
								[
									116.78808593749994,
									6.606103515625051
								],
								[
									116.81240234375002,
									6.607910156249972
								],
								[
									116.91328125000007,
									6.659667968750028
								],
								[
									117.01855468750011,
									6.797363281250114
								],
								[
									117.07792968750005,
									6.91684570312502
								],
								[
									117.1285156250002,
									6.968896484375065
								],
								[
									117.22988281249997,
									6.939990234374946
								],
								[
									117.25244140624994,
									6.919238281250074
								],
								[
									117.24531250000001,
									6.83339843750008
								],
								[
									117.2549804687502,
									6.783447265625028
								],
								[
									117.29404296875009,
									6.676904296874994
								],
								[
									117.38037109375,
									6.612255859374969
								],
								[
									117.49921875000007,
									6.571484375000011
								],
								[
									117.60966796874999,
									6.512646484375097
								],
								[
									117.64570312500007,
									6.473681640625074
								],
								[
									117.66962890625001,
									6.426757812500014
								],
								[
									117.69374999999997,
									6.3500000000000085
								],
								[
									117.69560546874999,
									6.2723144531249915
								],
								[
									117.61591796875001,
									6.1965332031250995
								],
								[
									117.64980468750002,
									6.073583984375006
								],
								[
									117.64453125,
									6.001855468750051
								],
								[
									117.61718750000011,
									5.940722656250031
								],
								[
									117.50117187500018,
									5.884667968750065
								],
								[
									117.81767578124999,
									5.940429687500057
								],
								[
									117.89580078125005,
									5.9722656250000625
								],
								[
									118.00380859375002,
									6.053320312499963
								],
								[
									118.06171875000018,
									5.983447265625031
								],
								[
									118.11582031250009,
									5.862500000000082
								],
								[
									118.07226562500011,
									5.832080078125102
								],
								[
									117.93476562500007,
									5.78750000000008
								],
								[
									117.92802734374999,
									5.76918945312508
								],
								[
									117.9736328125,
									5.7062499999999545
								],
								[
									118.03115234374997,
									5.712109375000082
								],
								[
									118.14462890625009,
									5.7541992187500455
								],
								[
									118.24912109375003,
									5.820556640624972
								],
								[
									118.2998046875,
									5.81972656249998
								],
								[
									118.3531250000002,
									5.806054687500037
								],
								[
									118.45634765624999,
									5.763427734375057
								],
								[
									118.51416015624994,
									5.728906249999952
								],
								[
									118.56308593750009,
									5.684521484374969
								],
								[
									118.59482421875003,
									5.59208984375006
								],
								[
									118.71367187500005,
									5.558544921875054
								],
								[
									118.95732421874999,
									5.42900390624996
								],
								[
									119.00253906250009,
									5.4178222656249915
								],
								[
									119.05000000000007,
									5.415234374999997
								],
								[
									119.17841796875001,
									5.430908203125085
								],
								[
									119.22343750000016,
									5.412646484375003
								],
								[
									119.25556640625001,
									5.365917968750068
								],
								[
									119.26630859375018,
									5.308105468750114
								],
								[
									119.26279296875009,
									5.24589843749996
								],
								[
									119.24970703125018,
									5.198730468749943
								],
								[
									119.21962890624997,
									5.1598144531250085
								],
								[
									119.13222656250014,
									5.100488281250094
								],
								[
									118.91250000000014,
									5.022900390625097
								],
								[
									118.67207031250018,
									4.964062500000097
								],
								[
									118.55136718750009,
									4.968115234375034
								],
								[
									118.38183593750011,
									5.018505859374997
								],
								[
									118.32001953125001,
									5.012011718750088
								],
								[
									118.26054687500016,
									4.988867187500091
								],
								[
									118.18535156250005,
									4.828515625000108
								],
								[
									118.32421875,
									4.668701171875057
								],
								[
									118.56249999999994,
									4.502148437500054
								],
								[
									118.59511718750014,
									4.460644531250026
								],
								[
									118.58632812500002,
									4.409667968750043
								],
								[
									118.54833984375011,
									4.3792480468750625
								],
								[
									118.49804687499994,
									4.362353515625074
								],
								[
									118.36406250000005,
									4.335742187499989
								],
								[
									118.22871093750018,
									4.316015625000048
								],
								[
									118.1172851562502,
									4.287597656250043
								],
								[
									118.00820312500002,
									4.250244140625071
								],
								[
									117.89560546875009,
									4.262939453125071
								],
								[
									117.74101562499999,
									4.337548828125094
								],
								[
									117.69648437500018,
									4.342822265625102
								],
								[
									117.64980468750002,
									4.304492187500017
								],
								[
									117.60380859375005,
									4.2000000000000455
								],
								[
									117.57441406250018,
									4.170605468750097
								]
							]
						],
						[
							[
								[
									117.14160156250011,
									7.168212890625071
								],
								[
									117.08066406250003,
									7.1152832031250455
								],
								[
									117.06015625000003,
									7.1788574218749375
								],
								[
									117.06425781250016,
									7.260693359375082
								],
								[
									117.14687500000014,
									7.337011718750006
								],
								[
									117.26406250000002,
									7.3516601562500625
								],
								[
									117.28076171874994,
									7.2906250000000625
								],
								[
									117.26679687500001,
									7.220800781250048
								],
								[
									117.23935546875003,
									7.184765625000068
								],
								[
									117.14160156250011,
									7.168212890625071
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "MYS",
					"su_a3": "MYS",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "MYS",
					"gu_a3": "MYS",
					"abbrev": "Malay.",
					"region_un": "Asia",
					"adm0_a3_us": "MYS",
					"scalerank": 1,
					"pop_est": 25715819,
					"adm0_dif": 0,
					"un_a3": "458",
					"pop_year": -99,
					"gdp_md_est": 384300,
					"name": "Malaysia",
					"sovereignt": "Malaysia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Malaysia",
					"postal": "MY",
					"sov_a3": "MYS",
					"note_brk": "",
					"brk_a3": "MYS",
					"wb_a2": "MY",
					"brk_diff": 0,
					"admin": "Malaysia",
					"name_long": "Malaysia",
					"iso_a3": "MYS",
					"iso_a2": "MY",
					"adm0_a3_is": "MYS",
					"level": 2,
					"formal_en": "Malaysia",
					"name_len": 8,
					"mapcolor7": 2,
					"long_len": 8,
					"mapcolor8": 4,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "458",
					"homepart": 1,
					"subunit": "Malaysia",
					"name_alt": "",
					"brk_name": "Malaysia",
					"name_sort": "Malaysia",
					"continent": "Asia",
					"mapcolor13": 6,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									7.300781249999972,
									4.418164062500082
								],
								[
									7.2039062500000455,
									4.387646484375082
								],
								[
									7.140429687499989,
									4.395117187500006
								],
								[
									7.2273437500000455,
									4.527343749999943
								],
								[
									7.271386718750023,
									4.498925781250108
								],
								[
									7.327929687500017,
									4.4872070312499375
								],
								[
									7.300781249999972,
									4.418164062500082
								]
							]
						],
						[
							[
								[
									13.606347656250023,
									13.704589843749972
								],
								[
									13.763476562500074,
									13.489550781250045
								],
								[
									13.932324218750011,
									13.25849609375004
								],
								[
									14.06396484375,
									13.078515624999966
								],
								[
									14.160058593750023,
									12.612792968750043
								],
								[
									14.17031250000008,
									12.524072265624994
								],
								[
									14.177636718750051,
									12.48408203125011
								],
								[
									14.184863281250017,
									12.447216796874969
								],
								[
									14.197460937500011,
									12.383789062500014
								],
								[
									14.272851562499994,
									12.35649414062496
								],
								[
									14.415429687500023,
									12.344140625000023
								],
								[
									14.518945312500051,
									12.298242187499994
								],
								[
									14.58095703125008,
									12.222070312500023
								],
								[
									14.587011718750063,
									12.20942382812511
								],
								[
									14.619726562500063,
									12.150976562500105
								],
								[
									14.627148437500068,
									12.108691406250017
								],
								[
									14.6181640625,
									11.986621093750017
								],
								[
									14.59736328125004,
									11.829833984375043
								],
								[
									14.561816406250074,
									11.728710937500054
								],
								[
									14.581640625000034,
									11.591162109375006
								],
								[
									14.575390625000011,
									11.532421875000026
								],
								[
									14.559765625000011,
									11.49228515625002
								],
								[
									14.49609375,
									11.446142578125034
								],
								[
									14.409472656250045,
									11.401171875000017
								],
								[
									14.20234375000004,
									11.26816406250002
								],
								[
									14.143261718750068,
									11.248535156250014
								],
								[
									14.056738281250034,
									11.245019531250009
								],
								[
									13.981445312500057,
									11.211865234375097
								],
								[
									13.892089843750057,
									11.14008789062504
								],
								[
									13.699902343750068,
									10.873144531250091
								],
								[
									13.53535156250004,
									10.60507812500002
								],
								[
									13.478515625,
									10.38325195312504
								],
								[
									13.414550781250028,
									10.17143554687496
								],
								[
									13.269921875000051,
									10.036181640625031
								],
								[
									13.249804687500045,
									9.960058593750063
								],
								[
									13.243750000000063,
									9.915917968750037
								],
								[
									13.23876953125,
									9.814013671874974
								],
								[
									13.221191406249972,
									9.645166015625037
								],
								[
									13.198730468750028,
									9.563769531249974
								],
								[
									13.175488281250011,
									9.539648437500034
								],
								[
									13.019433593749994,
									9.48833007812506
								],
								[
									12.929492187500074,
									9.426269531250028
								],
								[
									12.87568359375004,
									9.30351562500006
								],
								[
									12.85595703125,
									9.17075195312502
								],
								[
									12.824414062500068,
									9.019433593750094
								],
								[
									12.806542968750051,
									8.886621093750037
								],
								[
									12.7822265625,
									8.817871093750071
								],
								[
									12.731152343750068,
									8.745654296875017
								],
								[
									12.651562500000011,
									8.667773437500045
								],
								[
									12.58271484375004,
									8.624121093750034
								],
								[
									12.403515625000011,
									8.595556640625077
								],
								[
									12.311328125000074,
									8.41972656249996
								],
								[
									12.2333984375,
									8.282324218750034
								],
								[
									12.231152343749983,
									8.227392578125034
								],
								[
									12.15595703125004,
									7.942480468750077
								],
								[
									12.025195312500045,
									7.727783203125028
								],
								[
									12.016601562499972,
									7.652001953125051
								],
								[
									12.016015625000051,
									7.58974609374998
								],
								[
									11.852441406250023,
									7.40073242187502
								],
								[
									11.809179687500006,
									7.345068359375048
								],
								[
									11.767382812500017,
									7.27226562499996
								],
								[
									11.808593750000057,
									7.201953125000017
								],
								[
									11.854785156250045,
									7.13798828124996
								],
								[
									11.861425781249977,
									7.116406250000097
								],
								[
									11.787011718750023,
									7.056201171875088
								],
								[
									11.657519531250017,
									6.951562499999994
								],
								[
									11.580078125000057,
									6.888867187500011
								],
								[
									11.562988281250028,
									6.854638671874966
								],
								[
									11.551660156250023,
									6.697265625000057
								],
								[
									11.529101562500045,
									6.655029296875071
								],
								[
									11.477539062500028,
									6.597412109375057
								],
								[
									11.401757812500051,
									6.533935546875
								],
								[
									11.324609375000051,
									6.484667968750088
								],
								[
									11.237304687500028,
									6.4505371093750625
								],
								[
									11.153320312500057,
									6.437939453124983
								],
								[
									11.1064453125,
									6.457714843750097
								],
								[
									11.079687500000063,
									6.505517578125065
								],
								[
									11.032519531250045,
									6.6979003906250085
								],
								[
									11.00869140625008,
									6.739111328125048
								],
								[
									10.954199218749977,
									6.77656250000004
								],
								[
									10.846484375000074,
									6.881787109375082
								],
								[
									10.737597656250017,
									6.988281250000014
								],
								[
									10.606250000000074,
									7.063085937499977
								],
								[
									10.578125000000028,
									7.057714843750034
								],
								[
									10.55634765625004,
									7.037451171875077
								],
								[
									10.519042968750057,
									6.93046874999996
								],
								[
									10.482324218750051,
									6.891259765624966
								],
								[
									10.413183593750006,
									6.8777343750000455
								],
								[
									10.293066406250034,
									6.876757812500031
								],
								[
									10.205468750000051,
									6.891601562500028
								],
								[
									10.185546874999972,
									6.912792968750082
								],
								[
									10.167773437499989,
									6.95917968750004
								],
								[
									10.143554687500028,
									6.996435546875077
								],
								[
									10.038867187500017,
									6.921386718750057
								],
								[
									9.874218750000068,
									6.803271484375074
								],
								[
									9.82070312500008,
									6.783935546875043
								],
								[
									9.779882812500034,
									6.76015625000008
								],
								[
									9.725585937500057,
									6.65000000000002
								],
								[
									9.659960937500017,
									6.531982421875043
								],
								[
									9.574023437500017,
									6.470410156250026
								],
								[
									9.490234375,
									6.418652343750054
								],
								[
									9.442187500000074,
									6.373388671874977
								],
								[
									9.373339843750074,
									6.319628906250031
								],
								[
									9.23876953125,
									6.18613281250002
								],
								[
									9.060156250000034,
									6.009082031250102
								],
								[
									8.997167968750006,
									5.917724609375043
								],
								[
									8.935058593750028,
									5.781005859375085
								],
								[
									8.898828125000023,
									5.629687499999989
								],
								[
									8.859179687500045,
									5.463769531250023
								],
								[
									8.800976562499983,
									5.19746093750004
								],
								[
									8.715625000000017,
									5.046875000000085
								],
								[
									8.64052734375008,
									4.9270019531250995
								],
								[
									8.585156250000068,
									4.832812500000003
								],
								[
									8.555859375000068,
									4.755224609375006
								],
								[
									8.543750000000074,
									4.7578125
								],
								[
									8.51484375000004,
									4.724707031250006
								],
								[
									8.431347656250011,
									4.746240234374952
								],
								[
									8.393652343750063,
									4.813769531250031
								],
								[
									8.342089843750017,
									4.82475585937496
								],
								[
									8.252734375000045,
									4.923974609375094
								],
								[
									8.23378906250008,
									4.907470703125028
								],
								[
									8.328027343749994,
									4.6561035156250625
								],
								[
									8.293066406249977,
									4.557617187500071
								],
								[
									8.028515625000011,
									4.555371093749969
								],
								[
									7.800781250000057,
									4.522265624999974
								],
								[
									7.644238281250068,
									4.525341796875068
								],
								[
									7.56562500000004,
									4.560937500000037
								],
								[
									7.530761718750028,
									4.655175781250051
								],
								[
									7.5173828125000455,
									4.645458984375026
								],
								[
									7.50947265625004,
									4.594921875000026
								],
								[
									7.459863281250051,
									4.555224609375031
								],
								[
									7.284375000000011,
									4.547656250000088
								],
								[
									7.206738281250011,
									4.612060546874972
								],
								[
									7.143847656250074,
									4.684082031250071
								],
								[
									7.076562500000051,
									4.716162109375034
								],
								[
									7.086914062500028,
									4.685839843750074
								],
								[
									7.164160156250034,
									4.615576171874977
								],
								[
									7.154687500000051,
									4.514404296874972
								],
								[
									7.01337890625004,
									4.397314453125091
								],
								[
									6.92324218750008,
									4.390673828124989
								],
								[
									6.867871093750068,
									4.441113281250054
								],
								[
									6.839160156249989,
									4.5234863281250455
								],
								[
									6.824707031249972,
									4.645263671874986
								],
								[
									6.787597656250057,
									4.724707031250006
								],
								[
									6.767675781250006,
									4.724707031250006
								],
								[
									6.786035156250023,
									4.6520019531249375
								],
								[
									6.792187500000011,
									4.592626953125091
								],
								[
									6.793066406250034,
									4.46914062500008
								],
								[
									6.860351562500057,
									4.373339843750102
								],
								[
									6.75703125000004,
									4.343554687500074
								],
								[
									6.7151367187500455,
									4.342431640625023
								],
								[
									6.633007812500011,
									4.340234375000108
								],
								[
									6.617285156250006,
									4.375781249999974
								],
								[
									6.6015625,
									4.455175781250077
								],
								[
									6.579980468750051,
									4.475976562500051
								],
								[
									6.554589843750023,
									4.341406250000077
								],
								[
									6.5,
									4.331933593750094
								],
								[
									6.462109375000011,
									4.333154296874994
								],
								[
									6.299804687499972,
									4.303857421875065
								],
								[
									6.263671875,
									4.309423828125048
								],
								[
									6.255957031250034,
									4.334472656250085
								],
								[
									6.275292968750051,
									4.37167968750002
								],
								[
									6.270996093749972,
									4.432128906250085
								],
								[
									6.2146484375000455,
									4.385498046875
								],
								[
									6.205566406250057,
									4.292285156250017
								],
								[
									6.173339843749972,
									4.277392578125003
								],
								[
									6.07656250000008,
									4.290625000000034
								],
								[
									5.970703125,
									4.338574218750026
								],
								[
									5.90644531250004,
									4.387744140625017
								],
								[
									5.798632812500017,
									4.455957031249966
								],
								[
									5.587792968750051,
									4.647216796875028
								],
								[
									5.553613281250023,
									4.73320312499996
								],
								[
									5.493261718749977,
									4.838769531250065
								],
								[
									5.448144531250023,
									4.945849609375031
								],
								[
									5.383300781250057,
									5.129003906249949
								],
								[
									5.403222656250023,
									5.142285156250082
								],
								[
									5.452148437500057,
									5.126562500000077
								],
								[
									5.475976562500023,
									5.153857421875031
								],
								[
									5.388281250000006,
									5.173779296875011
								],
								[
									5.370019531250023,
									5.195019531250068
								],
								[
									5.364160156250051,
									5.259277343750114
								],
								[
									5.3679687500000455,
									5.33774414062502
								],
								[
									5.439257812499989,
									5.365332031250048
								],
								[
									5.500878906250023,
									5.378613281249997
								],
								[
									5.531835937500034,
									5.426367187500048
								],
								[
									5.549707031250023,
									5.474218749999935
								],
								[
									5.385839843750034,
									5.401757812500094
								],
								[
									5.232421875000057,
									5.483789062500023
								],
								[
									5.199218750000028,
									5.533544921875034
								],
								[
									5.215820312500028,
									5.571679687500065
								],
								[
									5.289062500000028,
									5.577490234375105
								],
								[
									5.393847656250074,
									5.574511718750031
								],
								[
									5.456640624999977,
									5.611718750000051
								],
								[
									5.418066406250034,
									5.62470703125004
								],
								[
									5.350292968749983,
									5.6232910156250995
								],
								[
									5.325292968750034,
									5.647949218750071
								],
								[
									5.327343750000011,
									5.707519531250028
								],
								[
									5.305371093750068,
									5.694335937500014
								],
								[
									5.276269531249994,
									5.641552734375097
								],
								[
									5.1728515625,
									5.602734375000097
								],
								[
									5.112402343750006,
									5.641552734375097
								],
								[
									5.106250000000017,
									5.7281250000000625
								],
								[
									5.093066406250074,
									5.767089843750085
								],
								[
									5.042089843750006,
									5.797509765625065
								],
								[
									4.861035156250068,
									6.026318359374969
								],
								[
									4.633593749999989,
									6.217187499999952
								],
								[
									4.431347656250011,
									6.348583984375068
								],
								[
									4.125878906250023,
									6.411376953125071
								],
								[
									3.486621093750017,
									6.408935546875028
								],
								[
									3.4507812499999773,
									6.427050781250074
								],
								[
									3.489941406250068,
									6.457275390625014
								],
								[
									3.54609375000004,
									6.477441406250037
								],
								[
									3.7516601562500114,
									6.583837890625034
								],
								[
									3.71699218750004,
									6.597949218750074
								],
								[
									3.5033203125000227,
									6.531347656250006
								],
								[
									3.430175781250057,
									6.525000000000048
								],
								[
									3.335546875000034,
									6.396923828125068
								],
								[
									2.7724609375,
									6.3757324218750995
								],
								[
									2.706445312500051,
									6.36923828125002
								],
								[
									2.7080078125,
									6.427685546875026
								],
								[
									2.7356445312500455,
									6.595703124999972
								],
								[
									2.753710937500074,
									6.661767578125023
								],
								[
									2.774609375000068,
									6.711718750000074
								],
								[
									2.7529296875,
									6.771630859375023
								],
								[
									2.7317382812500455,
									6.8528320312500455
								],
								[
									2.721386718750068,
									6.980273437500074
								],
								[
									2.7477539062500114,
									7.0198242187500455
								],
								[
									2.7567382812500796,
									7.067919921875074
								],
								[
									2.7505859375000625,
									7.143212890625051
								],
								[
									2.750488281250057,
									7.395068359375017
								],
								[
									2.765820312500068,
									7.422509765625108
								],
								[
									2.7839843750000455,
									7.443408203125102
								],
								[
									2.78515625,
									7.476855468750074
								],
								[
									2.750976562500057,
									7.541894531250094
								],
								[
									2.7193359375000057,
									7.6162597656250455
								],
								[
									2.72041015625004,
									7.723095703124969
								],
								[
									2.70771484375004,
									7.826611328125097
								],
								[
									2.686035156250057,
									7.873730468750097
								],
								[
									2.7023437500000114,
									8.049804687500085
								],
								[
									2.7115234375000057,
									8.272998046875088
								],
								[
									2.703125,
									8.371826171874972
								],
								[
									2.7236328125,
									8.441894531250028
								],
								[
									2.734667968750017,
									8.6140136718751
								],
								[
									2.7329101562500284,
									8.782519531249974
								],
								[
									2.7748046875000227,
									9.048535156250082
								],
								[
									2.8980468750000057,
									9.061376953125034
								],
								[
									3.044921875,
									9.083837890625077
								],
								[
									3.1104492187500057,
									9.188281250000031
								],
								[
									3.148046875000034,
									9.320605468750088
								],
								[
									3.1361328125000227,
									9.45161132812504
								],
								[
									3.164648437500034,
									9.494677734375017
								],
								[
									3.2234375000000455,
									9.565624999999997
								],
								[
									3.329492187500051,
									9.667041015625045
								],
								[
									3.3251953124999716,
									9.778466796875108
								],
								[
									3.3544921875,
									9.812792968750074
								],
								[
									3.4047851562500284,
									9.838623046875014
								],
								[
									3.47675781250004,
									9.851904296875048
								],
								[
									3.5572265625000057,
									9.907324218749977
								],
								[
									3.6020507812499716,
									10.004541015625065
								],
								[
									3.6458984375000227,
									10.160156249999972
								],
								[
									3.5765625000000227,
									10.268359374999989
								],
								[
									3.5779296875000455,
									10.2924804687501
								],
								[
									3.604101562500034,
									10.350683593750063
								],
								[
									3.6465820312500057,
									10.408984375000031
								],
								[
									3.680273437500034,
									10.42778320312496
								],
								[
									3.758496093750068,
									10.412695312500077
								],
								[
									3.771777343750017,
									10.417626953125023
								],
								[
									3.7837890625000625,
									10.435888671875105
								],
								[
									3.83447265625,
									10.607421875000057
								],
								[
									3.8296875000000057,
									10.653759765625082
								],
								[
									3.7568359375,
									10.768749999999969
								],
								[
									3.7449218750000455,
									10.850439453125091
								],
								[
									3.734179687500074,
									10.971923828124972
								],
								[
									3.7164062500000057,
									11.079589843750057
								],
								[
									3.695312500000057,
									11.120312500000097
								],
								[
									3.65625,
									11.15458984375006
								],
								[
									3.6388671875000114,
									11.176855468749977
								],
								[
									3.487792968750057,
									11.395410156250094
								],
								[
									3.4905273437499886,
									11.499218750000097
								],
								[
									3.55390625000004,
									11.631884765625045
								],
								[
									3.59541015625004,
									11.696289062500014
								],
								[
									3.6531249999999886,
									11.731835937500065
								],
								[
									3.664746093750068,
									11.762451171875085
								],
								[
									3.6473632812500796,
									11.79965820312502
								],
								[
									3.6184570312500455,
									11.827734375000063
								],
								[
									3.6118164062500284,
									11.887304687500034
								],
								[
									3.6201171875000284,
									11.926953125000026
								],
								[
									3.6406250000000284,
									11.97036132812508
								],
								[
									3.632519531250068,
									12.061572265625088
								],
								[
									3.634179687500051,
									12.201611328125026
								],
								[
									3.643847656250074,
									12.405273437500043
								],
								[
									3.6466796875000114,
									12.52998046875004
								],
								[
									3.76923828125004,
									12.622167968750077
								],
								[
									3.9478515625000057,
									12.775048828124966
								],
								[
									4.03876953125004,
									12.934667968749977
								],
								[
									4.08740234375,
									13.055468750000074
								],
								[
									4.147558593750006,
									13.45771484375004
								],
								[
									4.190820312500023,
									13.48212890625004
								],
								[
									4.2421875,
									13.501074218750077
								],
								[
									4.421386718750028,
									13.647509765625074
								],
								[
									4.55947265625008,
									13.701806640625037
								],
								[
									4.6648437500000455,
									13.733203125000031
								],
								[
									4.823339843750006,
									13.759765625000028
								],
								[
									4.921679687500074,
									13.749121093749991
								],
								[
									5.100878906250074,
									13.742724609375102
								],
								[
									5.241894531250011,
									13.757226562500037
								],
								[
									5.361621093750074,
									13.836865234375097
								],
								[
									5.415820312500017,
									13.859179687500031
								],
								[
									5.491992187500074,
									13.872851562499974
								],
								[
									5.838183593749989,
									13.7653808593751
								],
								[
									6.184277343750068,
									13.663671874999991
								],
								[
									6.247167968750006,
									13.672998046875023
								],
								[
									6.299804687499972,
									13.658789062500063
								],
								[
									6.386328125000034,
									13.603613281250105
								],
								[
									6.514062500000023,
									13.485400390625088
								],
								[
									6.589941406250034,
									13.409130859375097
								],
								[
									6.626562500000034,
									13.3642578125001
								],
								[
									6.804296875000006,
									13.107666015625043
								],
								[
									6.87060546875,
									13.043261718750074
								],
								[
									6.937207031250068,
									13.008203125000037
								],
								[
									7.00507812500004,
									12.99555664062504
								],
								[
									7.056738281250006,
									13.000195312500097
								],
								[
									7.106054687500006,
									13.029101562500031
								],
								[
									7.173046875000068,
									13.086328124999966
								],
								[
									7.274707031249989,
									13.112255859375097
								],
								[
									7.357812500000051,
									13.107177734375043
								],
								[
									7.788671875000006,
									13.337890625000057
								],
								[
									7.83046875000008,
									13.340917968749963
								],
								[
									7.955761718750011,
									13.322753906250085
								],
								[
									8.095019531250045,
									13.291162109375037
								],
								[
									8.456054687500057,
									13.059667968750034
								],
								[
									8.750585937500034,
									12.908154296875082
								],
								[
									8.957617187500006,
									12.85747070312506
								],
								[
									9.20156250000008,
									12.821484375000011
								],
								[
									9.615917968750011,
									12.81064453125002
								],
								[
									9.929296875000006,
									13.135253906249986
								],
								[
									10.045117187500068,
									13.206152343750034
								],
								[
									10.184667968750063,
									13.27011718750002
								],
								[
									10.229589843750063,
									13.281005859375014
								],
								[
									10.475878906250074,
									13.330224609375094
								],
								[
									10.958886718750051,
									13.371533203124983
								],
								[
									11.411914062500074,
									13.353613281250063
								],
								[
									11.501074218750034,
									13.340527343750054
								],
								[
									11.693359375000028,
									13.297705078125034
								],
								[
									11.990039062500074,
									13.191796875000051
								],
								[
									12.117968750000017,
									13.090429687500091
								],
								[
									12.31904296875004,
									13.073681640625054
								],
								[
									12.463183593750017,
									13.093750000000057
								],
								[
									12.51015625000008,
									13.194335937500028
								],
								[
									12.654785156250057,
									13.326562500000051
								],
								[
									12.759960937500068,
									13.3803710937501
								],
								[
									12.871679687500006,
									13.449023437500045
								],
								[
									13.048437500000063,
									13.534521484375063
								],
								[
									13.19384765625,
									13.573046875000003
								],
								[
									13.323828125000034,
									13.670849609375026
								],
								[
									13.426953125000068,
									13.70175781250002
								],
								[
									13.606347656250023,
									13.704589843749972
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Africa",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "NGA",
					"su_a3": "NGA",
					"brk_group": "",
					"region_wb": "Sub-Saharan Africa",
					"wb_a3": "NGA",
					"gu_a3": "NGA",
					"abbrev": "Nigeria",
					"region_un": "Africa",
					"adm0_a3_us": "NGA",
					"scalerank": 1,
					"pop_est": 149229090,
					"adm0_dif": 0,
					"un_a3": "566",
					"pop_year": -99,
					"gdp_md_est": 335400,
					"name": "Nigeria",
					"sovereignt": "Nigeria",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 7,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Nigeria",
					"postal": "NG",
					"sov_a3": "NGA",
					"note_brk": "",
					"brk_a3": "NGA",
					"wb_a2": "NG",
					"brk_diff": 0,
					"admin": "Nigeria",
					"name_long": "Nigeria",
					"iso_a3": "NGA",
					"iso_a2": "NG",
					"adm0_a3_is": "NGA",
					"level": 2,
					"formal_en": "Federal Republic of Nigeria",
					"name_len": 7,
					"mapcolor7": 3,
					"long_len": 7,
					"mapcolor8": 2,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "566",
					"homepart": 1,
					"subunit": "Nigeria",
					"name_alt": "",
					"brk_name": "Nigeria",
					"name_sort": "Nigeria",
					"continent": "Africa",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-68.205810546875,
									12.144580078125045
								],
								[
									-68.25434570312495,
									12.032080078124949
								],
								[
									-68.28222656249994,
									12.082275390625043
								],
								[
									-68.287255859375,
									12.171728515624977
								],
								[
									-68.30712890624997,
									12.206738281250097
								],
								[
									-68.34843749999993,
									12.228076171875088
								],
								[
									-68.37109375000003,
									12.25751953125004
								],
								[
									-68.36923828125,
									12.30195312500004
								],
								[
									-68.21948242187494,
									12.231250000000017
								],
								[
									-68.205810546875,
									12.144580078125045
								]
							]
						],
						[
							[
								[
									-62.9375,
									17.49565429687496
								],
								[
									-62.96171874999996,
									17.47504882812501
								],
								[
									-62.983105468749955,
									17.476904296875034
								],
								[
									-62.99716796874998,
									17.496826171875114
								],
								[
									-62.999609375000034,
									17.53037109375009
								],
								[
									-62.97934570312498,
									17.52119140625001
								],
								[
									-62.97177734374995,
									17.51606445312504
								],
								[
									-62.965429687500006,
									17.509277343750057
								],
								[
									-62.9375,
									17.49565429687496
								]
							]
						],
						[
							[
								[
									-63.232666015625,
									17.62314453125009
								],
								[
									-63.24160156249994,
									17.619580078124983
								],
								[
									-63.254492187500006,
									17.628662109375057
								],
								[
									-63.252148437499955,
									17.64526367187497
								],
								[
									-63.241650390624955,
									17.651806640625068
								],
								[
									-63.23349609374998,
									17.647216796875114
								],
								[
									-63.22690429687498,
									17.63413085937509
								],
								[
									-63.232666015625,
									17.62314453125009
								]
							]
						],
						[
							[
								[
									4.226171875000034,
									51.386474609375085
								],
								[
									4.211425781250057,
									51.348730468750034
								],
								[
									4.17255859375004,
									51.30708007812498
								],
								[
									4.040039062500028,
									51.247070312500114
								],
								[
									3.902050781249983,
									51.20766601562508
								],
								[
									3.83076171875004,
									51.21259765625001
								],
								[
									3.78193359375004,
									51.233203125000045
								],
								[
									3.755664062500017,
									51.2548339843751
								],
								[
									3.681835937500068,
									51.275683593750074
								],
								[
									3.580273437499983,
									51.28618164062499
								],
								[
									3.51708984375,
									51.263623046874926
								],
								[
									3.4719726562500455,
									51.2422363281251
								],
								[
									3.4325195312500796,
									51.24575195312511
								],
								[
									3.40283203125,
									51.263623046874926
								],
								[
									3.380078125000068,
									51.29111328125012
								],
								[
									3.35009765625,
									51.37768554687506
								],
								[
									3.425781250000057,
									51.39350585937501
								],
								[
									3.5894531250000057,
									51.39941406250006
								],
								[
									3.71650390625004,
									51.369140625000114
								],
								[
									3.8833984375000057,
									51.35449218750006
								],
								[
									4.011035156249989,
									51.39594726562507
								],
								[
									4.11152343750004,
									51.360644531250074
								],
								[
									4.226171875000034,
									51.386474609375085
								]
							]
						],
						[
							[
								[
									3.9491210937500796,
									51.73945312500004
								],
								[
									4.04677734375008,
									51.68491210937495
								],
								[
									4.067578125000068,
									51.66748046875006
								],
								[
									4.07509765625008,
									51.64877929687506
								],
								[
									3.950976562500017,
									51.62705078124998
								],
								[
									3.81904296875004,
									51.69399414062494
								],
								[
									3.731835937500051,
									51.678222656250114
								],
								[
									3.699023437500017,
									51.70991210937498
								],
								[
									3.698535156250017,
									51.729687499999926
								],
								[
									3.7890624999999716,
									51.74643554687506
								],
								[
									3.9491210937500796,
									51.73945312500004
								]
							]
						],
						[
							[
								[
									5.499121093750034,
									52.30185546875006
								],
								[
									5.424414062499977,
									52.29765624999999
								],
								[
									5.24238281250004,
									52.33374023437497
								],
								[
									5.183886718750017,
									52.35834960937501
								],
								[
									5.168554687500006,
									52.378759765625006
								],
								[
									5.376953125,
									52.490332031250006
								],
								[
									5.53925781250004,
									52.557714843750034
								],
								[
									5.65810546875008,
									52.58759765625001
								],
								[
									5.73554687500004,
									52.58222656250007
								],
								[
									5.7974609375000625,
									52.56459960937502
								],
								[
									5.829492187499994,
									52.535449218750045
								],
								[
									5.834179687500068,
									52.50224609375002
								],
								[
									5.800878906250034,
									52.46577148437504
								],
								[
									5.741015625000017,
									52.42900390625002
								],
								[
									5.62060546875,
									52.37592773437504
								],
								[
									5.54804687500004,
									52.32441406250004
								],
								[
									5.499121093750034,
									52.30185546875006
								]
							]
						],
						[
							[
								[
									4.886132812500023,
									53.07070312500011
								],
								[
									4.787109375,
									52.99980468749996
								],
								[
									4.726757812500068,
									53.01962890625009
								],
								[
									4.70917968750004,
									53.036035156249966
								],
								[
									4.7398437500000625,
									53.09130859374994
								],
								[
									4.886425781249983,
									53.18330078125004
								],
								[
									4.886132812500023,
									53.07070312500011
								]
							]
						],
						[
							[
								[
									5.10859375000004,
									53.30800781250005
								],
								[
									4.923730468750051,
									53.2345703125001
								],
								[
									4.907910156250011,
									53.24624023437508
								],
								[
									5.02705078125004,
									53.31020507812505
								],
								[
									5.10859375000004,
									53.30800781250005
								]
							]
						],
						[
							[
								[
									4.226171875000034,
									51.386474609375085
								],
								[
									4.138867187500011,
									51.40151367187505
								],
								[
									4.006542968750068,
									51.443212890625006
								],
								[
									3.8218750000000057,
									51.409374999999955
								],
								[
									3.693554687500068,
									51.44990234375004
								],
								[
									3.5869140625,
									51.45390624999996
								],
								[
									3.5205078124999716,
									51.48618164062506
								],
								[
									3.44892578125004,
									51.540771484375085
								],
								[
									3.4996093749999773,
									51.576660156250114
								],
								[
									3.548632812500017,
									51.58911132812497
								],
								[
									3.743945312500017,
									51.59604492187506
								],
								[
									3.886035156250017,
									51.57421875000006
								],
								[
									4.141308593750068,
									51.45576171874998
								],
								[
									4.20576171875004,
									51.456689453124994
								],
								[
									4.27412109375004,
									51.47163085937501
								],
								[
									4.2393554687500625,
									51.50390625000003
								],
								[
									4.175488281250011,
									51.51928710937506
								],
								[
									4.080468750000023,
									51.55112304687506
								],
								[
									4.004785156250051,
									51.59584960937502
								],
								[
									4.182617187500057,
									51.61030273437504
								],
								[
									4.158007812500017,
									51.63344726562505
								],
								[
									4.134570312500017,
									51.67290039062499
								],
								[
									3.9468750000000625,
									51.81054687499997
								],
								[
									3.9789062500000227,
									51.84780273437511
								],
								[
									4.02607421875004,
									51.92773437500003
								],
								[
									4.084863281250023,
									51.99409179687507
								],
								[
									4.13173828125008,
									52.011914062499955
								],
								[
									4.2087890625000455,
									52.05898437500005
								],
								[
									4.376269531250074,
									52.196826171875074
								],
								[
									4.482812499999994,
									52.30917968749995
								],
								[
									4.562109375000006,
									52.44257812500004
								],
								[
									4.678320312500034,
									52.80976562500007
								],
								[
									4.7126953125000455,
									52.872119140625045
								],
								[
									4.768749999999983,
									52.94130859374994
								],
								[
									4.839062500000011,
									52.928271484375045
								],
								[
									4.8879882812500455,
									52.90834960937508
								],
								[
									5.061230468750068,
									52.96064453125007
								],
								[
									5.358398437500028,
									53.09648437499993
								],
								[
									5.44599609375004,
									53.2140625000001
								],
								[
									5.532031250000074,
									53.26870117187494
								],
								[
									5.87353515625,
									53.37519531250004
								],
								[
									6.062207031250068,
									53.40708007812498
								],
								[
									6.35322265625004,
									53.41528320312506
								],
								[
									6.563574218749977,
									53.43427734375001
								],
								[
									6.816210937500017,
									53.441162109375085
								],
								[
									6.912402343749989,
									53.37539062500008
								],
								[
									6.96816406250008,
									53.32729492187505
								],
								[
									7.05800781250008,
									53.300585937500045
								],
								[
									7.197265625000028,
									53.282275390625045
								],
								[
									7.188964843750028,
									53.18720703125004
								],
								[
									7.189941406250057,
									52.999511718750085
								],
								[
									7.1794921875000455,
									52.96621093750005
								],
								[
									7.117089843750051,
									52.887011718750074
								],
								[
									7.0508789062500625,
									52.74477539062505
								],
								[
									7.0330078125000455,
									52.65136718750003
								],
								[
									7.01318359375,
									52.63354492187494
								],
								[
									6.74843750000008,
									52.634082031250045
								],
								[
									6.7107421875000455,
									52.617871093749955
								],
								[
									6.705371093750017,
									52.597656250000085
								],
								[
									6.718749999999972,
									52.57358398437509
								],
								[
									6.712402343750028,
									52.54965820312509
								],
								[
									6.69160156250004,
									52.53017578124994
								],
								[
									6.7029296875000455,
									52.49921875000004
								],
								[
									6.748828125000074,
									52.46401367187505
								],
								[
									6.832519531249972,
									52.44228515625005
								],
								[
									6.922070312500011,
									52.440283203125006
								],
								[
									6.96816406250008,
									52.444091796875085
								],
								[
									7.001855468750023,
									52.41899414062493
								],
								[
									7.035156250000057,
									52.380224609375034
								],
								[
									7.032617187500051,
									52.33149414062504
								],
								[
									7.019628906250006,
									52.26601562500002
								],
								[
									6.977246093750068,
									52.20551757812507
								],
								[
									6.855078125000034,
									52.135791015625074
								],
								[
									6.800390625000006,
									52.11123046874994
								],
								[
									6.749023437500028,
									52.09868164062496
								],
								[
									6.724511718749994,
									52.08022460937502
								],
								[
									6.7129882812500625,
									52.05688476562497
								],
								[
									6.7156250000000455,
									52.03618164062493
								],
								[
									6.802441406250068,
									51.98017578125007
								],
								[
									6.800390625000006,
									51.96738281249995
								],
								[
									6.775195312500017,
									51.938281250000045
								],
								[
									6.7417968750000625,
									51.910888671875085
								],
								[
									6.517578125000028,
									51.853955078124926
								],
								[
									6.425000000000011,
									51.85839843749994
								],
								[
									6.372167968749977,
									51.83002929687504
								],
								[
									6.355664062499983,
									51.8246582031251
								],
								[
									6.29707031250004,
									51.85073242187508
								],
								[
									6.16650390625,
									51.88076171875005
								],
								[
									6.1171875,
									51.870410156250074
								],
								[
									6.089843750000028,
									51.853955078124926
								],
								[
									6.0076171875000455,
									51.83398437499994
								],
								[
									5.948730468750057,
									51.80268554687507
								],
								[
									5.948535156250017,
									51.762402343749926
								],
								[
									6.052734375,
									51.65825195312502
								],
								[
									6.08935546875,
									51.63779296874995
								],
								[
									6.091113281250017,
									51.59892578124993
								],
								[
									6.1416015625,
									51.55009765624993
								],
								[
									6.193261718750051,
									51.488916015624994
								],
								[
									6.198828125000006,
									51.450000000000045
								],
								[
									6.192871093750057,
									51.41059570312501
								],
								[
									6.16621093750004,
									51.354833984375034
								],
								[
									6.075878906250011,
									51.22412109375006
								],
								[
									6.0748046875000625,
									51.199023437500074
								],
								[
									6.082421875000023,
									51.17998046874993
								],
								[
									6.113378906250006,
									51.17470703125002
								],
								[
									6.136914062500011,
									51.16484374999996
								],
								[
									6.129980468750034,
									51.14741210937504
								],
								[
									5.9610351562500625,
									51.056689453125045
								],
								[
									5.939257812500074,
									51.0408203125001
								],
								[
									5.868359375000011,
									51.04531250000002
								],
								[
									5.857519531250034,
									51.03012695312506
								],
								[
									5.867187500000057,
									51.005664062500045
								],
								[
									5.894726562500068,
									50.98422851562512
								],
								[
									5.955078125,
									50.972949218750045
								],
								[
									6.006835937499972,
									50.94995117187497
								],
								[
									6.048437500000034,
									50.90488281250012
								],
								[
									5.993945312500017,
									50.7504394531251
								],
								[
									5.89246112249532,
									50.75255685798356
								],
								[
									5.797363281250028,
									50.75454101562505
								],
								[
									5.7470703125,
									50.759570312500074
								],
								[
									5.6936523437500455,
									50.77465820312506
								],
								[
									5.693554687500011,
									50.77475585937498
								],
								[
									5.669140625000011,
									50.805957031250045
								],
								[
									5.639453125000017,
									50.84360351562498
								],
								[
									5.6475585937500625,
									50.86665039062504
								],
								[
									5.736621093749989,
									50.93212890625006
								],
								[
									5.750000000000057,
									50.95024414062502
								],
								[
									5.7408203125000625,
									50.959912109374955
								],
								[
									5.749804687500017,
									50.98876953124997
								],
								[
									5.818261718750023,
									51.08642578124997
								],
								[
									5.827148437500057,
									51.125634765624966
								],
								[
									5.796484375000034,
									51.15307617187506
								],
								[
									5.752343749999994,
									51.16948242187493
								],
								[
									5.60878906250008,
									51.19843750000007
								],
								[
									5.540429687499994,
									51.239306640625045
								],
								[
									5.508789062500028,
									51.27500000000012
								],
								[
									5.476855468750017,
									51.28505859374994
								],
								[
									5.429785156250006,
									51.272998046875045
								],
								[
									5.3108398437500455,
									51.259716796874926
								],
								[
									5.2141601562500455,
									51.27895507812494
								],
								[
									5.0999023437500455,
									51.34648437499993
								],
								[
									5.073437500000068,
									51.40683593750006
								],
								[
									5.05947265625008,
									51.453125000000085
								],
								[
									5.03095703125004,
									51.46909179687495
								],
								[
									4.992578125000023,
									51.4453613281251
								],
								[
									4.943945312499977,
									51.407763671875074
								],
								[
									4.84804687500008,
									51.403271484374955
								],
								[
									4.820703125000023,
									51.41206054687507
								],
								[
									4.816015625000034,
									51.432812499999926
								],
								[
									4.810546874999972,
									51.45273437500009
								],
								[
									4.784179687500028,
									51.47739257812495
								],
								[
									4.755664062499989,
									51.491113281249994
								],
								[
									4.633984375000068,
									51.42172851562498
								],
								[
									4.588769531250023,
									51.42192382812493
								],
								[
									4.531640624999994,
									51.44858398437495
								],
								[
									4.503417968750028,
									51.474707031250034
								],
								[
									4.44091796875,
									51.45981445312509
								],
								[
									4.384765625000028,
									51.42758789062512
								],
								[
									4.40400390625004,
									51.36708984375005
								],
								[
									4.373730468749983,
									51.3560058593751
								],
								[
									4.304492187500017,
									51.36152343750007
								],
								[
									4.226171875000034,
									51.386474609375085
								]
							],
							[
								[
									5.795117187500011,
									52.42768554687501
								],
								[
									5.87001953125008,
									52.48535156250006
								],
								[
									5.867187500000057,
									52.56318359375001
								],
								[
									5.835449218750057,
									52.609277343749966
								],
								[
									5.653417968750006,
									52.62963867187503
								],
								[
									5.619140625000057,
									52.65849609374996
								],
								[
									5.6130859375000455,
									52.68437499999999
								],
								[
									5.617968750000074,
									52.757666015625006
								],
								[
									5.6252929687500455,
									52.78183593750006
								],
								[
									5.666992187500028,
									52.81733398437501
								],
								[
									5.656835937500006,
									52.851416015625006
								],
								[
									5.547265625000051,
									52.84565429687498
								],
								[
									5.45498046875008,
									52.85717773437503
								],
								[
									5.420410156250057,
									52.87446289062501
								],
								[
									5.4130859375,
									52.90263671874996
								],
								[
									5.398242187500074,
									53.04194335937501
								],
								[
									5.377246093750074,
									53.06469726562503
								],
								[
									5.268945312500023,
									53.02724609375005
								],
								[
									5.152343749999972,
									52.966699218749966
								],
								[
									5.06806640625004,
									52.923437500000034
								],
								[
									5.094042968750017,
									52.88618164062498
								],
								[
									5.117578124999994,
									52.83598632812499
								],
								[
									5.1648437500000455,
									52.785742187500034
								],
								[
									5.24746093750008,
									52.73037109375005
								],
								[
									5.241699218749972,
									52.669824218749966
								],
								[
									5.137988281250074,
									52.62661132812505
								],
								[
									5.065917968750057,
									52.62373046874998
								],
								[
									5.05996093750008,
									52.56557617187505
								],
								[
									5.069824218750057,
									52.520410156249994
								],
								[
									5.069042968750068,
									52.45136718750004
								],
								[
									5.062304687500017,
									52.43071289062502
								],
								[
									5.036230468750034,
									52.40458984375002
								],
								[
									5.014062500000051,
									52.36430664062499
								],
								[
									5.03994140625008,
									52.344140624999966
								],
								[
									5.316015625000034,
									52.29150390625
								],
								[
									5.49531250000004,
									52.25190429687501
								],
								[
									5.795117187500011,
									52.42768554687501
								]
							]
						],
						[
							[
								[
									5.3257812500000625,
									53.38574218750006
								],
								[
									5.232617187499983,
									53.377783203125034
								],
								[
									5.190234375000074,
									53.39179687500007
								],
								[
									5.4151367187500625,
									53.43144531249996
								],
								[
									5.557421874999989,
									53.44355468750004
								],
								[
									5.5826171875000625,
									53.43808593750006
								],
								[
									5.3257812500000625,
									53.38574218750006
								]
							]
						],
						[
							[
								[
									5.929296875000006,
									53.45883789062495
								],
								[
									5.732031250000034,
									53.44262695312503
								],
								[
									5.6653320312500455,
									53.454882812500045
								],
								[
									5.654296875000028,
									53.4665039062501
								],
								[
									5.7081054687500625,
									53.473388671875085
								],
								[
									5.876269531250017,
									53.47509765624997
								],
								[
									5.928222656250057,
									53.46499023437505
								],
								[
									5.929296875000006,
									53.45883789062495
								]
							]
						],
						[
							[
								[
									6.33339843750008,
									53.51074218750006
								],
								[
									6.193261718750051,
									53.47680664062497
								],
								[
									6.159277343750034,
									53.4839355468751
								],
								[
									6.167675781250068,
									53.493750000000034
								],
								[
									6.290917968750051,
									53.51499023437512
								],
								[
									6.33339843750008,
									53.51074218750006
								]
							]
						],
						[
							[
								[
									6.734765625000051,
									53.582519531250114
								],
								[
									6.64208984375,
									53.579199218750034
								],
								[
									6.6685546875000625,
									53.605664062499926
								],
								[
									6.754589843750011,
									53.62548828124997
								],
								[
									6.800878906250006,
									53.62548828124997
								],
								[
									6.734765625000051,
									53.582519531250114
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "NLD",
					"su_a3": "NLD",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "NLD",
					"gu_a3": "NLD",
					"abbrev": "Neth.",
					"region_un": "Europe",
					"adm0_a3_us": "NLD",
					"scalerank": 1,
					"pop_est": 16715999,
					"adm0_dif": 1,
					"un_a3": "528",
					"pop_year": -99,
					"gdp_md_est": 672000,
					"name": "Netherlands",
					"sovereignt": "Netherlands",
					"economy": "2. Developed region: nonG7",
					"type": "Country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Netherlands",
					"postal": "NL",
					"sov_a3": "NL1",
					"note_brk": "",
					"brk_a3": "NLD",
					"wb_a2": "NL",
					"brk_diff": 0,
					"admin": "Netherlands",
					"name_long": "Netherlands",
					"iso_a3": "NLD",
					"iso_a2": "NL",
					"adm0_a3_is": "NLD",
					"level": 2,
					"formal_en": "Kingdom of the Netherlands",
					"name_len": 11,
					"mapcolor7": 4,
					"long_len": 11,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "528",
					"homepart": 1,
					"subunit": "Netherlands",
					"name_alt": "",
					"brk_name": "Netherlands",
					"name_sort": "Netherlands",
					"continent": "Europe",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									5.085839843750023,
									60.30756835937498
								],
								[
									5.089062500000068,
									60.18876953125002
								],
								[
									4.996972656250051,
									60.197753906250085
								],
								[
									4.955566406250028,
									60.24331054687494
								],
								[
									4.943554687499983,
									60.272412109374926
								],
								[
									4.950781250000034,
									60.34116210937498
								],
								[
									4.930078124999994,
									60.412060546874955
								],
								[
									4.957226562500011,
									60.447265625000114
								],
								[
									4.99062500000008,
									60.45205078125002
								],
								[
									5.050195312500051,
									60.388964843750045
								],
								[
									5.085839843750023,
									60.30756835937498
								]
							]
						],
						[
							[
								[
									4.958691406250068,
									61.084570312500006
								],
								[
									4.870117187500028,
									61.071923828124994
								],
								[
									4.79902343750004,
									61.08271484374998
								],
								[
									4.824414062500068,
									61.178222656250085
								],
								[
									4.861621093749989,
									61.19384765624997
								],
								[
									4.915429687500023,
									61.19936523437494
								],
								[
									4.973242187500006,
									61.1482421875001
								],
								[
									4.958691406250068,
									61.084570312500006
								]
							]
						],
						[
							[
								[
									8.10273437500004,
									63.33759765625007
								],
								[
									8.004687500000045,
									63.33691406249994
								],
								[
									7.888281250000034,
									63.352343750000074
								],
								[
									7.815332031249994,
									63.385058593750074
								],
								[
									7.804003906250017,
									63.41391601562509
								],
								[
									7.938378906250023,
									63.449804687500034
								],
								[
									8.073535156250017,
									63.47080078124995
								],
								[
									8.13613281250008,
									63.4313476562501
								],
								[
									8.140917968750074,
									63.3664062500001
								],
								[
									8.10273437500004,
									63.33759765625007
								]
							]
						],
						[
							[
								[
									8.470800781250063,
									63.66713867187508
								],
								[
									8.35615234375004,
									63.66479492187494
								],
								[
									8.287109375000028,
									63.68715820312505
								],
								[
									8.451269531250063,
									63.73183593750002
								],
								[
									8.708886718750051,
									63.774316406249966
								],
								[
									8.7333984375,
									63.80131835937496
								],
								[
									8.764648437500057,
									63.804638671874926
								],
								[
									8.809179687500063,
									63.77143554687501
								],
								[
									8.814843750000051,
									63.72597656250008
								],
								[
									8.78652343750008,
									63.703466796875006
								],
								[
									8.470800781250063,
									63.66713867187508
								]
							]
						],
						[
							[
								[
									11.231445312499972,
									64.86586914062502
								],
								[
									11.179003906250045,
									64.83803710937497
								],
								[
									11.062500000000028,
									64.86040039062499
								],
								[
									10.832519531249972,
									64.84311523437512
								],
								[
									10.739843750000006,
									64.87031250000004
								],
								[
									10.8134765625,
									64.9232421875
								],
								[
									11.02099609375,
									64.97871093749993
								],
								[
									11.132617187500017,
									64.97617187499995
								],
								[
									11.246191406250063,
									64.90791015624998
								],
								[
									11.231445312499972,
									64.86586914062502
								]
							]
						],
						[
							[
								[
									11.967968750000011,
									65.62651367187502
								],
								[
									11.901855468750057,
									65.59570312500003
								],
								[
									11.778320312500028,
									65.60454101562507
								],
								[
									11.76513671875,
									65.63095703125003
								],
								[
									11.800390624999977,
									65.68388671875007
								],
								[
									11.87539062500008,
									65.70590820312512
								],
								[
									11.97236328125004,
									65.70156249999994
								],
								[
									12.003222656250017,
									65.67944335937506
								],
								[
									11.967968750000011,
									65.62651367187502
								]
							]
						],
						[
							[
								[
									12.509570312500045,
									65.90195312500009
								],
								[
									12.429492187500074,
									65.89907226562494
								],
								[
									12.430175781250028,
									65.93994140625
								],
								[
									12.476074218750057,
									65.9770996093751
								],
								[
									12.548828125000057,
									66.00190429687493
								],
								[
									12.642382812500017,
									66.00854492187494
								],
								[
									12.747070312500028,
									66.011376953125
								],
								[
									12.77880859375,
									65.99169921875006
								],
								[
									12.718652343750023,
									65.9638671875
								],
								[
									12.509570312500045,
									65.90195312500009
								]
							]
						],
						[
							[
								[
									12.419921875,
									66.0432617187501
								],
								[
									12.32734375000004,
									66.03662109375009
								],
								[
									12.3427734375,
									66.08076171875001
								],
								[
									12.417675781250068,
									66.12265625000009
								],
								[
									12.446386718750063,
									66.15131835937507
								],
								[
									12.46132812500008,
									66.18500976562493
								],
								[
									12.527441406250034,
									66.21054687499998
								],
								[
									12.620800781250068,
									66.1779296875001
								],
								[
									12.622656250000006,
									66.12246093750005
								],
								[
									12.576367187500068,
									66.07192382812508
								],
								[
									12.419921875,
									66.0432617187501
								]
							]
						],
						[
							[
								[
									12.971777343750063,
									67.87412109375006
								],
								[
									12.824023437500074,
									67.82124023437504
								],
								[
									12.877929687500028,
									67.91777343750007
								],
								[
									12.95771484375004,
									68.01547851562506
								],
								[
									13.06806640625004,
									68.07133789062507
								],
								[
									13.122851562500017,
									68.04941406249998
								],
								[
									13.097753906250063,
									68.00268554687506
								],
								[
									13.098242187499977,
									67.95644531250005
								],
								[
									13.074609375000051,
									67.93457031250003
								],
								[
									12.971777343750063,
									67.87412109375006
								]
							]
						],
						[
							[
								[
									13.872851562500045,
									68.2653320312501
								],
								[
									13.932324218750011,
									68.24824218749998
								],
								[
									14.087695312500045,
									68.25322265625002
								],
								[
									14.118847656250068,
									68.24682617187506
								],
								[
									14.096777343750006,
									68.21860351562498
								],
								[
									14.029296875000028,
									68.18754882812496
								],
								[
									13.887695312500057,
									68.16850585937499
								],
								[
									13.824023437500045,
									68.12109375000009
								],
								[
									13.778417968750006,
									68.10498046875011
								],
								[
									13.656152343750051,
									68.10478515625007
								],
								[
									13.583984375,
									68.09384765625006
								],
								[
									13.495214843750034,
									68.05166015625008
								],
								[
									13.424218750000051,
									68.08276367187511
								],
								[
									13.404394531250006,
									68.06069335937497
								],
								[
									13.391503906250051,
									68.021240234375
								],
								[
									13.35205078125,
									68.00966796875005
								],
								[
									13.229394531250051,
									67.99536132812497
								],
								[
									13.199511718750017,
									68.08725585937495
								],
								[
									13.255957031250063,
									68.12060546875
								],
								[
									13.300195312499994,
									68.16044921875013
								],
								[
									13.367968750000045,
									68.16655273437513
								],
								[
									13.428710937499972,
									68.16323242187508
								],
								[
									13.537988281250051,
									68.24902343750006
								],
								[
									13.687695312499983,
									68.27338867187495
								],
								[
									13.78408203125008,
									68.27612304687497
								],
								[
									13.872851562500045,
									68.2653320312501
								]
							]
						],
						[
							[
								[
									15.207128906250006,
									68.94311523437497
								],
								[
									15.337207031250045,
									68.84243164062497
								],
								[
									15.396582031250063,
									68.78359375000005
								],
								[
									15.348437500000017,
									68.67241210937507
								],
								[
									15.222070312500023,
									68.61630859375
								],
								[
									15.027050781250011,
									68.60634765625002
								],
								[
									14.890234375000006,
									68.61098632812508
								],
								[
									14.804003906250045,
									68.63798828125007
								],
								[
									14.793261718750074,
									68.66826171875002
								],
								[
									14.743457031250045,
									68.67719726562507
								],
								[
									14.612109375000017,
									68.63833007812505
								],
								[
									14.520800781250074,
									68.63305664062494
								],
								[
									14.404687500000051,
									68.66323242187497
								],
								[
									14.37343750000008,
									68.71142578125011
								],
								[
									14.496679687500034,
									68.77187500000008
								],
								[
									14.553710937500028,
									68.81884765625006
								],
								[
									14.6904296875,
									68.814697265625
								],
								[
									14.724609375000028,
									68.80009765624996
								],
								[
									14.801855468750034,
									68.79096679687507
								],
								[
									14.848828125000011,
									68.84755859375005
								],
								[
									14.837988281250034,
									68.88666992187493
								],
								[
									14.872363281250017,
									68.91386718749996
								],
								[
									15.037499999999994,
									68.89428710937497
								],
								[
									15.037792968750068,
									69.00053710937513
								],
								[
									15.101855468750045,
									69.00800781249995
								],
								[
									15.128124999999983,
									69.00395507812502
								],
								[
									15.175585937500074,
									68.98154296874998
								],
								[
									15.207128906250006,
									68.94311523437497
								]
							]
						],
						[
							[
								[
									15.760351562500006,
									68.56123046875007
								],
								[
									15.772363281250051,
									68.55419921875006
								],
								[
									15.908593749999994,
									68.65048828124995
								],
								[
									16.05957031250003,
									68.68051757812503
								],
								[
									16.068945312499977,
									68.71401367187511
								],
								[
									16.12744140625,
									68.74643554687495
								],
								[
									16.120800781250068,
									68.79936523437499
								],
								[
									16.15058593750001,
									68.84238281250006
								],
								[
									16.227539062500057,
									68.85375976562497
								],
								[
									16.275585937499983,
									68.86831054687508
								],
								[
									16.328906250000017,
									68.87631835937495
								],
								[
									16.425195312499994,
									68.84155273437497
								],
								[
									16.47968750000001,
									68.80292968750001
								],
								[
									16.54736328125003,
									68.716552734375
								],
								[
									16.519238281250068,
									68.63300781250004
								],
								[
									16.337988281250006,
									68.56787109375009
								],
								[
									16.193945312500063,
									68.53847656250005
								],
								[
									16.048437499999977,
									68.46367187499999
								],
								[
									15.975292968750011,
									68.40249023437497
								],
								[
									15.912499999999994,
									68.38925781250012
								],
								[
									15.872753906249983,
									68.39423828125007
								],
								[
									15.837402343749972,
									68.40903320312506
								],
								[
									15.763671875000057,
									68.40908203124997
								],
								[
									15.682519531250051,
									68.35600585937499
								],
								[
									15.437500000000057,
									68.31284179687509
								],
								[
									15.341406250000006,
									68.32529296874995
								],
								[
									15.337011718750006,
									68.37822265624999
								],
								[
									15.279687500000051,
									68.37382812499999
								],
								[
									15.18789062500008,
									68.31040039062503
								],
								[
									15.09804687500008,
									68.28920898437505
								],
								[
									15.037695312500034,
									68.28271484375009
								],
								[
									14.926855468750006,
									68.30659179687504
								],
								[
									14.628906249999972,
									68.19848632812497
								],
								[
									14.34951171875008,
									68.17827148437502
								],
								[
									14.257519531249983,
									68.19077148437509
								],
								[
									14.257226562500023,
									68.25693359374998
								],
								[
									14.437792968750045,
									68.34155273437506
								],
								[
									14.585839843749994,
									68.40034179687507
								],
								[
									15.095312500000063,
									68.44140625000009
								],
								[
									15.412597656250028,
									68.61582031250009
								],
								[
									15.489257812500028,
									68.80532226562497
								],
								[
									15.564257812500017,
									68.87373046874995
								],
								[
									15.52900390625004,
									68.91240234375002
								],
								[
									15.443652343750045,
									68.91918945312497
								],
								[
									15.438476562499972,
									68.97856445312499
								],
								[
									15.483007812499977,
									69.04345703125006
								],
								[
									15.649511718749977,
									69.13256835937511
								],
								[
									15.741992187499989,
									69.17050781250012
								],
								[
									15.892675781250063,
									69.27788085937496
								],
								[
									15.965332031250028,
									69.30205078124999
								],
								[
									16.048046874999983,
									69.30205078124999
								],
								[
									16.129492187500063,
									69.27392578124994
								],
								[
									16.114843750000006,
									69.21640624999995
								],
								[
									15.99267578125,
									69.11264648437495
								],
								[
									15.811718749999983,
									69.02421875000005
								],
								[
									15.833789062500045,
									68.9607421875001
								],
								[
									15.905859374999977,
									68.90849609375002
								],
								[
									15.92353515625004,
									68.81918945312495
								],
								[
									15.92792968750004,
									68.73320312500002
								],
								[
									15.790722656250068,
									68.61704101562498
								],
								[
									15.760351562500006,
									68.56123046875007
								]
							]
						],
						[
							[
								[
									17.503027343750034,
									69.59624023437507
								],
								[
									17.62324218750001,
									69.53906250000006
								],
								[
									17.677343750000006,
									69.55654296874997
								],
								[
									17.78369140625,
									69.56303710937496
								],
								[
									17.862792968750057,
									69.54296875000006
								],
								[
									17.927441406250068,
									69.50664062500002
								],
								[
									18.004101562500068,
									69.50498046874995
								],
								[
									18.05224609375,
									69.45751953125006
								],
								[
									18.076757812500034,
									69.39575195312509
								],
								[
									18.021093750000063,
									69.349609375
								],
								[
									17.94208984375004,
									69.3287109375
								],
								[
									17.920703125000045,
									69.27431640624994
								],
								[
									17.95068359375,
									69.19814453124997
								],
								[
									17.773535156249977,
									69.17202148437497
								],
								[
									17.568164062500074,
									69.160400390625
								],
								[
									17.487890625000063,
									69.19682617187496
								],
								[
									17.32363281250008,
									69.13002929687494
								],
								[
									17.160937500000045,
									69.02592773437496
								],
								[
									17.08251953124997,
									69.01367187500003
								],
								[
									17.077050781250023,
									69.046630859375
								],
								[
									16.96015625000001,
									69.06938476562502
								],
								[
									16.81044921875005,
									69.07070312499994
								],
								[
									16.8154296875,
									69.09511718749994
								],
								[
									16.842578125000045,
									69.11235351562499
								],
								[
									16.971777343750063,
									69.13789062500004
								],
								[
									16.99755859375,
									69.19062500000004
								],
								[
									16.97412109375,
									69.28471679687502
								],
								[
									16.996875000000017,
									69.33037109374999
								],
								[
									17.001757812500045,
									69.36191406250012
								],
								[
									17.0830078125,
									69.398828125
								],
								[
									17.36083984375003,
									69.38149414062502
								],
								[
									17.39453125000003,
									69.41669921875007
								],
								[
									17.373437499999994,
									69.43886718750008
								],
								[
									17.22988281250008,
									69.47768554687508
								],
								[
									17.25195312500003,
									69.50380859375005
								],
								[
									17.355566406250006,
									69.52714843750002
								],
								[
									17.45361328125,
									69.53017578125002
								],
								[
									17.483105468750068,
									69.56967773437498
								],
								[
									17.488183593750023,
									69.58686523437493
								],
								[
									17.503027343750034,
									69.59624023437507
								]
							]
						],
						[
							[
								[
									29.95615234375009,
									69.79677734375005
								],
								[
									29.76621093750009,
									69.76752929687507
								],
								[
									29.74423828125009,
									69.79160156250006
								],
								[
									29.785937500000045,
									69.82905273437498
								],
								[
									29.835839843749966,
									69.90556640625002
								],
								[
									29.913964843750023,
									69.90244140625
								],
								[
									29.992968750000045,
									69.87324218749993
								],
								[
									30.05517578125,
									69.83837890625011
								],
								[
									29.95615234375009,
									69.79677734375005
								]
							]
						],
						[
							[
								[
									20.779199218749994,
									70.08974609375005
								],
								[
									20.72529296875004,
									70.06650390624995
								],
								[
									20.642578125000057,
									70.05703124999997
								],
								[
									20.59804687500005,
									70.07143554687505
								],
								[
									20.53466796875003,
									70.08090820312495
								],
								[
									20.46425781250005,
									70.07656250000005
								],
								[
									20.40507812499999,
									70.11914062500011
								],
								[
									20.411718750000006,
									70.1548828125
								],
								[
									20.492773437500006,
									70.20332031249993
								],
								[
									20.654882812500006,
									70.23085937500002
								],
								[
									20.78603515625008,
									70.21953125000005
								],
								[
									20.819433593750034,
									70.20546875000002
								],
								[
									20.779199218749994,
									70.08974609375005
								]
							]
						],
						[
							[
								[
									19.25507812500001,
									70.06640625000011
								],
								[
									19.343750000000057,
									70.01196289062494
								],
								[
									19.42226562500005,
									70.01718750000003
								],
								[
									19.445898437499977,
									70.03774414062505
								],
								[
									19.49951171874997,
									70.04790039062507
								],
								[
									19.607812500000023,
									70.01914062499998
								],
								[
									19.592285156250057,
									69.97016601562495
								],
								[
									19.44238281249997,
									69.90839843749998
								],
								[
									19.334765625000074,
									69.82026367187504
								],
								[
									19.197070312500017,
									69.79980468749997
								],
								[
									19.13085937500003,
									69.81044921875011
								],
								[
									19.0078125,
									69.75957031250013
								],
								[
									18.909179687500057,
									69.70668945312511
								],
								[
									18.806933593750017,
									69.63984374999998
								],
								[
									18.80068359375008,
									69.60537109374997
								],
								[
									18.784765625000034,
									69.57900390625002
								],
								[
									18.410253906250034,
									69.55283203125009
								],
								[
									18.27412109375001,
									69.53549804687495
								],
								[
									18.12988281250003,
									69.55786132812497
								],
								[
									18.06152343750003,
									69.60209960937502
								],
								[
									18.08349609374997,
									69.62612304687494
								],
								[
									18.22744140625008,
									69.63574218749994
								],
								[
									18.232031250000034,
									69.67675781249994
								],
								[
									18.268457031249994,
									69.701806640625
								],
								[
									18.315039062499977,
									69.71547851562494
								],
								[
									18.34931640625004,
									69.76787109375005
								],
								[
									18.40625,
									69.78154296875007
								],
								[
									18.51240234375004,
									69.76865234375012
								],
								[
									18.58398437499997,
									69.80659179687493
								],
								[
									18.624316406250017,
									69.8130371093751
								],
								[
									18.67402343750004,
									69.781640625
								],
								[
									18.69794921875001,
									69.82485351562511
								],
								[
									18.67402343750004,
									69.86430664062496
								],
								[
									18.6865234375,
									69.89091796875005
								],
								[
									18.823828125000006,
									69.96010742187494
								],
								[
									18.883203125000023,
									70.0105468750001
								],
								[
									18.968652343750023,
									70.04301757812496
								],
								[
									19.050976562499983,
									70.03784179687497
								],
								[
									19.074902343750068,
									70.08569335937494
								],
								[
									19.050976562499983,
									70.13466796875008
								],
								[
									19.06005859374997,
									70.1666015625
								],
								[
									19.13271484375005,
									70.24414062500009
								],
								[
									19.212695312500074,
									70.24746093750005
								],
								[
									19.249414062500023,
									70.17856445312495
								],
								[
									19.25507812500001,
									70.06640625000011
								]
							]
						],
						[
							[
								[
									19.76748046875005,
									70.21669921875
								],
								[
									19.818359375,
									70.20498046875008
								],
								[
									19.868652343750057,
									70.21225585937498
								],
								[
									19.910449218750045,
									70.201904296875
								],
								[
									19.99414062500003,
									70.14926757812512
								],
								[
									20.084277343750017,
									70.12856445312508
								],
								[
									20.088476562500063,
									70.10205078125
								],
								[
									20.005957031250034,
									70.07622070312507
								],
								[
									19.897265625000017,
									70.06845703125009
								],
								[
									19.780859375000006,
									70.07744140624996
								],
								[
									19.746679687500063,
									70.11049804687494
								],
								[
									19.71083984375005,
									70.1653320312501
								],
								[
									19.61347656250001,
									70.21909179687495
								],
								[
									19.599023437499994,
									70.26616210937513
								],
								[
									19.68378906250004,
									70.27358398437502
								],
								[
									19.76748046875005,
									70.21669921875
								]
							]
						],
						[
							[
								[
									23.615332031250034,
									70.54931640625009
								],
								[
									23.63398437500001,
									70.50253906250006
								],
								[
									23.641015625000023,
									70.46396484375
								],
								[
									23.54775390625005,
									70.40815429687501
								],
								[
									23.332812500000045,
									70.33496093750011
								],
								[
									23.34511718750005,
									70.315283203125
								],
								[
									23.27070312500001,
									70.29648437500009
								],
								[
									23.15917968750003,
									70.28261718750011
								],
								[
									23.10029296875001,
									70.29609375000001
								],
								[
									23.108398437500057,
									70.3588378906251
								],
								[
									23.09062499999999,
									70.37763671875001
								],
								[
									23.005957031250063,
									70.352783203125
								],
								[
									22.91787109375005,
									70.38466796875002
								],
								[
									22.917773437500045,
									70.41674804687506
								],
								[
									22.941015625000063,
									70.44458007812497
								],
								[
									23.022460937500057,
									70.48691406249998
								],
								[
									23.15839843750004,
									70.51606445312504
								],
								[
									23.248046875,
									70.50512695312506
								],
								[
									23.54667968749999,
									70.61708984374994
								],
								[
									23.57890624999999,
									70.59365234374997
								],
								[
									23.615332031250034,
									70.54931640625009
								]
							]
						],
						[
							[
								[
									24.017578125,
									70.56738281249994
								],
								[
									23.82714843750003,
									70.52749023437508
								],
								[
									23.716601562500074,
									70.56186523437506
								],
								[
									23.67011718750001,
									70.59707031250002
								],
								[
									23.66328125000004,
									70.67524414062507
								],
								[
									23.689160156250068,
									70.72280273437508
								],
								[
									23.778417968750063,
									70.74736328125002
								],
								[
									23.836523437499977,
									70.72939453125
								],
								[
									23.85205078125003,
									70.71435546874994
								],
								[
									23.95644531250008,
									70.69960937499997
								],
								[
									24.07832031250004,
									70.65058593749993
								],
								[
									24.017578125,
									70.56738281249994
								]
							]
						],
						[
							[
								[
									23.440527343750034,
									70.815771484375
								],
								[
									23.420898437500057,
									70.78442382812511
								],
								[
									23.387109374999994,
									70.75390625000011
								],
								[
									23.30517578125,
									70.72167968750003
								],
								[
									23.068164062500045,
									70.59409179687506
								],
								[
									22.92890625000001,
									70.57353515625005
								],
								[
									22.88476562499997,
									70.55351562499996
								],
								[
									22.8291015625,
									70.5415527343751
								],
								[
									22.656054687500017,
									70.55903320312493
								],
								[
									22.60537109375008,
									70.53315429687498
								],
								[
									22.557519531250023,
									70.51586914062511
								],
								[
									22.432226562500063,
									70.50917968750008
								],
								[
									22.358691406250017,
									70.51479492187497
								],
								[
									22.168750000000045,
									70.56210937500012
								],
								[
									22.055761718750006,
									70.61333007812507
								],
								[
									21.99453125000008,
									70.65712890625002
								],
								[
									22.170019531250034,
									70.65629882812502
								],
								[
									22.232617187499983,
									70.66689453124997
								],
								[
									22.350292968750068,
									70.65766601562504
								],
								[
									22.420996093750006,
									70.70258789062495
								],
								[
									22.570703125000023,
									70.69716796875
								],
								[
									22.85810546875004,
									70.72841796874997
								],
								[
									22.96357421875004,
									70.71098632812507
								],
								[
									23.204687500000063,
									70.81547851562513
								],
								[
									23.28017578125005,
									70.81274414062509
								],
								[
									23.395605468750034,
									70.84257812499996
								],
								[
									23.440527343750034,
									70.815771484375
								]
							]
						],
						[
							[
								[
									30.869726562500034,
									69.78344726562511
								],
								[
									30.92412109374999,
									69.65175781250011
								],
								[
									30.922460937500034,
									69.60581054687498
								],
								[
									30.896679687500182,
									69.56123046874995
								],
								[
									30.860742187499966,
									69.538427734375
								],
								[
									30.78886718750016,
									69.52851562500004
								],
								[
									30.615429687500182,
									69.53256835937498
								],
								[
									30.379687500000045,
									69.58471679687494
								],
								[
									30.227539062500114,
									69.63378906250009
								],
								[
									30.180175781249943,
									69.63583984375006
								],
								[
									30.15976562500009,
									69.62988281250009
								],
								[
									30.196484375000182,
									69.58056640625006
								],
								[
									30.186718750000068,
									69.5427734375001
								],
								[
									30.163769531250182,
									69.50161132812497
								],
								[
									30.1318359375,
									69.4642578125
								],
								[
									30.087304687500136,
									69.432861328125
								],
								[
									29.994042968749966,
									69.39248046874994
								],
								[
									29.832714843750068,
									69.36044921875009
								],
								[
									29.388281250000034,
									69.29814453125007
								],
								[
									29.353027343750114,
									69.27060546874998
								],
								[
									29.209960937500114,
									69.09702148437506
								],
								[
									29.170898437500057,
									69.07153320312511
								],
								[
									29.11855468750005,
									69.04995117187497
								],
								[
									28.96582031250003,
									69.02197265625006
								],
								[
									28.891894531250045,
									69.0605957031251
								],
								[
									28.832617187500063,
									69.118994140625
								],
								[
									28.846289062500006,
									69.176904296875
								],
								[
									29.02490234374997,
									69.28798828124997
								],
								[
									29.19179687500005,
									69.36669921875003
								],
								[
									29.238867187500034,
									69.39394531250005
								],
								[
									29.333398437500136,
									69.472998046875
								],
								[
									29.14160156250003,
									69.67143554687502
								],
								[
									28.800390625000063,
									69.73149414062507
								],
								[
									28.411718750000034,
									69.82275390624994
								],
								[
									28.269140625000006,
									69.87143554687509
								],
								[
									28.047265625000023,
									69.97167968750009
								],
								[
									27.889941406250045,
									70.06166992187494
								],
								[
									27.747851562500045,
									70.06484374999997
								],
								[
									27.591699218750023,
									70.04223632812497
								],
								[
									27.34804687500005,
									69.96005859375012
								],
								[
									27.205664062499977,
									69.91870117187494
								],
								[
									27.127539062500063,
									69.90649414062494
								],
								[
									27.108691406250045,
									69.90468749999994
								],
								[
									26.93427734375004,
									69.928125
								],
								[
									26.74023437500003,
									69.93305664062504
								],
								[
									26.584277343750045,
									69.92631835937499
								],
								[
									26.52539062500003,
									69.9150390625
								],
								[
									26.308203125000034,
									69.78193359375007
								],
								[
									26.15615234375005,
									69.71469726562495
								],
								[
									26.07246093750004,
									69.69155273437494
								],
								[
									26.011523437500074,
									69.6526367187501
								],
								[
									25.961523437500006,
									69.58862304687503
								],
								[
									25.850195312500063,
									69.36650390625007
								],
								[
									25.767187500000034,
									69.28266601562495
								],
								[
									25.748632812500063,
									69.2314453125
								],
								[
									25.768164062500063,
									69.07612304687507
								],
								[
									25.748339843750017,
									68.99013671875005
								],
								[
									25.646679687499983,
									68.91914062500007
								],
								[
									25.575292968750006,
									68.88715820312501
								],
								[
									25.48085937500005,
									68.88061523437503
								],
								[
									25.357128906250068,
									68.86245117187497
								],
								[
									25.249121093750006,
									68.8213378906251
								],
								[
									25.1728515625,
									68.76528320312505
								],
								[
									25.0869140625,
									68.63959960937495
								],
								[
									24.94140625000003,
									68.59326171875011
								],
								[
									24.80244140625004,
									68.60649414062496
								],
								[
									24.703222656249977,
									68.65283203125006
								],
								[
									24.49052734374999,
									68.6886718750001
								],
								[
									24.33203125000003,
									68.71152343749995
								],
								[
									24.154101562500017,
									68.76088867187497
								],
								[
									23.997363281250074,
									68.79843749999998
								],
								[
									23.85400390625,
									68.80590820312509
								],
								[
									23.772558593750006,
									68.75839843750009
								],
								[
									23.70703124999997,
									68.71386718750006
								],
								[
									23.462500000000006,
									68.67763671874997
								],
								[
									23.324023437500017,
									68.64897460937499
								],
								[
									23.144335937500017,
									68.64257812500003
								],
								[
									23.07167968750005,
									68.67436523437502
								],
								[
									22.811035156250057,
									68.69531250000003
								],
								[
									22.500683593750068,
									68.72021484374994
								],
								[
									22.410937500000074,
									68.71987304687497
								],
								[
									22.382910156250063,
									68.77661132812497
								],
								[
									22.300390625000034,
									68.85585937500005
								],
								[
									22.079687500000006,
									68.99277343750003
								],
								[
									21.98945312500001,
									69.04111328124995
								],
								[
									21.81972656250008,
									69.15449218749995
								],
								[
									21.621777343750068,
									69.27070312500001
								],
								[
									21.59375000000003,
									69.27358398437497
								],
								[
									21.461230468750045,
									69.27749023437497
								],
								[
									21.26679687500004,
									69.27368164062509
								],
								[
									21.14375000000001,
									69.24726562500001
								],
								[
									21.06611328125001,
									69.21411132812503
								],
								[
									21.052636718750023,
									69.1865722656251
								],
								[
									21.12783203125008,
									69.08081054687503
								],
								[
									21.10449218750003,
									69.054443359375
								],
								[
									21.065722656250017,
									69.04174804687509
								],
								[
									20.889257812500034,
									69.071435546875
								],
								[
									20.675878906250006,
									69.06948242187505
								],
								[
									20.622167968749977,
									69.03686523437497
								],
								[
									20.491992187500017,
									69.03330078124995
								],
								[
									20.11669921875003,
									69.02089843750008
								],
								[
									20.282324218750034,
									68.93432617187503
								],
								[
									20.33710937500001,
									68.899658203125
								],
								[
									20.348046875000023,
									68.84873046875
								],
								[
									20.319433593750034,
									68.754052734375
								],
								[
									20.240039062500045,
									68.67314453125013
								],
								[
									20.1474609375,
									68.60732421875002
								],
								[
									19.968847656250034,
									68.54204101562505
								],
								[
									20.240039062500045,
									68.47753906249997
								],
								[
									20.055957031250017,
									68.39038085937506
								],
								[
									19.969824218750063,
									68.35639648437498
								],
								[
									19.87001953125005,
									68.36225585937501
								],
								[
									19.691210937500045,
									68.39243164062495
								],
								[
									19.25898437500001,
									68.46533203124997
								],
								[
									19.05263671875008,
									68.49272460937496
								],
								[
									18.868261718749977,
									68.50112304687508
								],
								[
									18.769824218750017,
									68.50004882812513
								],
								[
									18.378613281250068,
									68.56240234374994
								],
								[
									18.303027343750017,
									68.55541992187494
								],
								[
									18.16259765625003,
									68.52841796874995
								],
								[
									18.147070312500063,
									68.46777343749994
								],
								[
									18.15595703125001,
									68.31684570312493
								],
								[
									18.17666015625005,
									68.20063476562495
								],
								[
									18.125,
									68.13344726562505
								],
								[
									18.07324218750003,
									68.08784179687498
								],
								[
									17.91669921875001,
									67.96489257812499
								],
								[
									17.564746093750074,
									68.04843749999995
								],
								[
									17.324609374999994,
									68.10380859375005
								],
								[
									17.170507812500063,
									68.03012695312495
								],
								[
									16.783593750000023,
									67.89501953125006
								],
								[
									16.585546874999977,
									67.62832031250008
								],
								[
									16.57412109375005,
									67.61958007812498
								],
								[
									16.457128906250034,
									67.55175781250011
								],
								[
									16.30712890625003,
									67.52060546874998
								],
								[
									16.193554687500068,
									67.50517578125013
								],
								[
									16.12744140625,
									67.42583007812513
								],
								[
									16.281542968750045,
									67.31206054687513
								],
								[
									16.36064453124999,
									67.25200195312496
								],
								[
									16.434277343749983,
									67.1550781250001
								],
								[
									16.420703125000074,
									67.09335937499998
								],
								[
									16.40351562500004,
									67.05498046875007
								],
								[
									16.23769531250008,
									66.97641601562495
								],
								[
									15.884179687499994,
									66.76884765625013
								],
								[
									15.557031250000051,
									66.55209960937512
								],
								[
									15.422949218750006,
									66.48984374999995
								],
								[
									15.483789062500051,
									66.30595703124996
								],
								[
									15.37490234375008,
									66.25205078125009
								],
								[
									15.153320312500057,
									66.19106445312511
								],
								[
									15.040039062499972,
									66.1675292968751
								],
								[
									14.917968749999972,
									66.15371093750002
								],
								[
									14.543261718750017,
									66.12934570312495
								],
								[
									14.609960937500034,
									65.93227539062505
								],
								[
									14.635156250000023,
									65.84501953125013
								],
								[
									14.634570312500074,
									65.79326171874996
								],
								[
									14.595800781249977,
									65.74287109375001
								],
								[
									14.549511718750068,
									65.64638671875005
								],
								[
									14.47968750000004,
									65.30146484374995
								],
								[
									14.42626953125,
									65.26435546874995
								],
								[
									14.352441406250051,
									65.1708496093751
								],
								[
									14.115136718750023,
									64.94614257812503
								],
								[
									13.924804687499972,
									64.79677734375
								],
								[
									13.650292968749994,
									64.58154296875003
								],
								[
									13.87353515625,
									64.51357421874994
								],
								[
									14.077636718750028,
									64.46401367187497
								],
								[
									14.119921875000017,
									64.38774414062507
								],
								[
									14.148046874999977,
									64.26030273437513
								],
								[
									14.141210937500006,
									64.17353515625004
								],
								[
									14.063281250000045,
									64.09550781250013
								],
								[
									14.002734375000045,
									64.04072265625007
								],
								[
									13.960546875000063,
									64.01401367187495
								],
								[
									13.670703125000074,
									64.04062499999995
								],
								[
									13.299609375000074,
									64.07480468750009
								],
								[
									13.203515625000023,
									64.07509765624997
								],
								[
									12.987597656249989,
									64.05048828124993
								],
								[
									12.792773437500017,
									63.99999999999994
								],
								[
									12.690039062500034,
									63.957421874999966
								],
								[
									12.662500000000023,
									63.940478515625074
								],
								[
									12.532714843750057,
									63.843554687500045
								],
								[
									12.30195312500004,
									63.6711914062501
								],
								[
									12.175195312500051,
									63.59594726562506
								],
								[
									12.212109375000011,
									63.49223632812496
								],
								[
									11.999902343750051,
									63.29169921875007
								],
								[
									12.138671874999972,
									63.0891601562501
								],
								[
									12.144628906250034,
									63.082519531250085
								],
								[
									12.218164062500023,
									63.000634765624994
								],
								[
									12.141015625000023,
									62.94785156250009
								],
								[
									12.108593750000068,
									62.91948242187499
								],
								[
									12.11962890625,
									62.82592773437503
								],
								[
									12.13984375000004,
									62.72133789062494
								],
								[
									12.121875000000017,
									62.66000976562498
								],
								[
									12.114550781250045,
									62.59189453124995
								],
								[
									12.303515625000074,
									62.28559570312498
								],
								[
									12.301367187500006,
									62.21376953125011
								],
								[
									12.291992187500028,
									62.16743164062498
								],
								[
									12.233691406250074,
									61.976855468750074
								],
								[
									12.155371093750006,
									61.72075195312502
								],
								[
									12.292089843750063,
									61.653466796874994
								],
								[
									12.486816406250028,
									61.57299804687494
								],
								[
									12.596093749999994,
									61.541308593750045
								],
								[
									12.757519531250011,
									61.44570312499994
								],
								[
									12.88076171875008,
									61.352294921875085
								],
								[
									12.86367187500008,
									61.290283203125085
								],
								[
									12.828222656250034,
									61.22182617187508
								],
								[
									12.776367187500057,
									61.17397460937511
								],
								[
									12.727832031250017,
									61.108251953125034
								],
								[
									12.706054687500028,
									61.05986328125013
								],
								[
									12.683007812500023,
									61.046826171874955
								],
								[
									12.467578125000017,
									61.04150390625003
								],
								[
									12.353710937500011,
									61.02319335937503
								],
								[
									12.29414062500004,
									61.002685546875114
								],
								[
									12.31464843750004,
									60.89213867187496
								],
								[
									12.4453125,
									60.689648437499926
								],
								[
									12.553808593750006,
									60.545654296875085
								],
								[
									12.588671874999989,
									60.45073242187502
								],
								[
									12.552832031250063,
									60.35449218749994
								],
								[
									12.515820312499983,
									60.30522460937513
								],
								[
									12.514648437500028,
									60.23886718750009
								],
								[
									12.486132812500074,
									60.10678710937512
								],
								[
									12.402050781249983,
									60.040039062500085
								],
								[
									12.291992187500028,
									59.967236328124926
								],
								[
									12.169238281250074,
									59.912890625000045
								],
								[
									12.071875000000063,
									59.89760742187502
								],
								[
									11.988281249999972,
									59.8913085937501
								],
								[
									11.93212890625,
									59.863671874999966
								],
								[
									11.881250000000023,
									59.78247070312494
								],
								[
									11.834277343750045,
									59.697167968749966
								],
								[
									11.680761718750034,
									59.59228515625
								],
								[
									11.684863281250074,
									59.555761718750034
								],
								[
									11.743359375000011,
									59.43144531250002
								],
								[
									11.798144531250074,
									59.28989257812495
								],
								[
									11.751855468750051,
									59.15756835937509
								],
								[
									11.712207031250045,
									59.018652343750034
								],
								[
									11.64277343750004,
									58.92607421874999
								],
								[
									11.543554687500063,
									58.893017578124926
								],
								[
									11.470703125000057,
									58.90952148437509
								],
								[
									11.388281250000063,
									59.03652343749994
								],
								[
									11.38642578125004,
									59.06572265625002
								],
								[
									11.365917968750011,
									59.1045410156251
								],
								[
									11.132128906249989,
									59.143212890624994
								],
								[
									11.090820312500028,
									59.14179687499998
								],
								[
									10.998925781250051,
									59.16445312500005
								],
								[
									10.945019531250068,
									59.17084960937504
								],
								[
									10.834472656250028,
									59.18393554687495
								],
								[
									10.742578125000051,
									59.29599609374995
								],
								[
									10.644921875000051,
									59.38920898437502
								],
								[
									10.631054687500068,
									59.42817382812507
								],
								[
									10.634375000000034,
									59.602490234374955
								],
								[
									10.604492187499972,
									59.680029296875034
								],
								[
									10.595312500000063,
									59.76455078125002
								],
								[
									10.533886718750068,
									59.69580078125006
								],
								[
									10.56953125000004,
									59.587109374999926
								],
								[
									10.493750000000063,
									59.54150390625006
								],
								[
									10.39814453125004,
									59.519335937500074
								],
								[
									10.407128906249994,
									59.45566406249998
								],
								[
									10.446386718750006,
									59.443603515625
								],
								[
									10.45458984375,
									59.37749023437513
								],
								[
									10.43134765625004,
									59.27963867187509
								],
								[
									10.2431640625,
									59.06206054687499
								],
								[
									10.205175781249977,
									59.03867187500012
								],
								[
									10.179394531250068,
									59.00927734375006
								],
								[
									10.083105468749977,
									59.02880859375006
								],
								[
									9.959570312500034,
									58.96821289062504
								],
								[
									9.842578125000017,
									58.95849609374994
								],
								[
									9.80019531250008,
									59.027050781249955
								],
								[
									9.635156250000023,
									59.11777343750006
								],
								[
									9.557226562500063,
									59.112695312499994
								],
								[
									9.627148437499983,
									59.0679199218751
								],
								[
									9.696093750000017,
									59.00971679687498
								],
								[
									9.656933593750011,
									58.97119140624994
								],
								[
									9.618457031249989,
									58.94604492187497
								],
								[
									9.551074218750045,
									58.93300781250008
								],
								[
									9.309960937500023,
									58.85683593750011
								],
								[
									9.395800781250017,
									58.80566406249997
								],
								[
									9.322949218750011,
									58.74755859375003
								],
								[
									9.23867187500008,
									58.739013671875085
								],
								[
									9.19375000000008,
									58.71186523437504
								],
								[
									9.178124999999994,
									58.67500000000001
								],
								[
									8.928417968750011,
									58.56997070312511
								],
								[
									8.521386718750051,
									58.30058593750002
								],
								[
									8.312207031250068,
									58.22446289062506
								],
								[
									8.166113281250063,
									58.1453125000001
								],
								[
									8.037402343750045,
									58.14726562499996
								],
								[
									7.875585937500034,
									58.07998046875002
								],
								[
									7.4659179687500625,
									58.02094726562498
								],
								[
									7.194140625000017,
									58.0476562500001
								],
								[
									7.0048828125,
									58.02421875000013
								],
								[
									6.903417968750034,
									58.070507812499955
								],
								[
									6.890234375000006,
									58.10229492187494
								],
								[
									6.895312500000074,
									58.12075195312505
								],
								[
									6.912304687500068,
									58.142871093750045
								],
								[
									6.877050781249977,
									58.15073242187495
								],
								[
									6.8028320312500625,
									58.15454101562503
								],
								[
									6.771093749999977,
									58.13222656250008
								],
								[
									6.766796875000011,
									58.081542968750085
								],
								[
									6.7314453125,
									58.068310546874955
								],
								[
									6.590527343750068,
									58.097314453124994
								],
								[
									6.555078125000023,
									58.123437499999994
								],
								[
									6.6057617187500455,
									58.176367187500034
								],
								[
									6.692480468750034,
									58.224023437499966
								],
								[
									6.676757812500028,
									58.233789062499994
								],
								[
									6.659863281250068,
									58.262744140625045
								],
								[
									6.617578125000051,
									58.26640624999999
								],
								[
									6.4915039062500455,
									58.25942382812508
								],
								[
									6.389062500000051,
									58.26796875000002
								],
								[
									6.054687500000057,
									58.37514648437494
								],
								[
									5.976562500000028,
									58.43232421875004
								],
								[
									5.706835937500074,
									58.52363281249998
								],
								[
									5.585937500000028,
									58.62041015624999
								],
								[
									5.517285156249983,
									58.726513671874926
								],
								[
									5.522460937499972,
									58.82265625000005
								],
								[
									5.555566406250051,
									58.97519531250006
								],
								[
									5.612207031250051,
									59.01289062500001
								],
								[
									5.854296874999989,
									58.95947265625006
								],
								[
									6.099023437500023,
									58.870263671874994
								],
								[
									6.137304687500006,
									58.874658203124994
								],
								[
									6.2141601562500455,
									58.94467773437506
								],
								[
									6.363281250000028,
									59.00092773437507
								],
								[
									6.3210937500000455,
									59.01645507812512
								],
								[
									6.099414062500017,
									58.9519531250001
								],
								[
									6.016992187500023,
									58.98769531249994
								],
								[
									5.88916015625,
									59.06049804687501
								],
								[
									5.88916015625,
									59.09794921875002
								],
								[
									5.948730468750057,
									59.135449218749926
								],
								[
									5.968554687499989,
									59.18613281249995
								],
								[
									5.937304687500017,
									59.23398437500012
								],
								[
									5.951855468750068,
									59.29907226562506
								],
								[
									6.050683593750023,
									59.3681640625
								],
								[
									6.19892578125004,
									59.43808593749995
								],
								[
									6.305664062500028,
									59.505566406249926
								],
								[
									6.415332031250074,
									59.54711914062503
								],
								[
									6.4039062500000625,
									59.56098632812501
								],
								[
									6.278515625000011,
									59.53452148437506
								],
								[
									6.15859375000008,
									59.489648437499966
								],
								[
									6.017382812499989,
									59.41445312500002
								],
								[
									5.84521484375,
									59.35346679687501
								],
								[
									5.717968750000011,
									59.329833984375
								],
								[
									5.657324218750006,
									59.310253906249926
								],
								[
									5.564062500000006,
									59.291210937499955
								],
								[
									5.467578125000074,
									59.2038085937501
								],
								[
									5.362304687500028,
									59.166357421875006
								],
								[
									5.17324218750008,
									59.16254882812504
								],
								[
									5.131640625000017,
									59.226464843749994
								],
								[
									5.18505859375,
									59.4536621093751
								],
								[
									5.2421875,
									59.56430664062509
								],
								[
									5.304882812500068,
									59.64257812499994
								],
								[
									5.403515624999983,
									59.65576171874997
								],
								[
									5.472460937500017,
									59.713085937499926
								],
								[
									5.529687500000023,
									59.713085937499926
								],
								[
									5.579492187500051,
									59.68662109374995
								],
								[
									5.77216796875004,
									59.66093749999996
								],
								[
									5.8672851562500625,
									59.733984375000006
								],
								[
									5.9910156250000455,
									59.74467773437496
								],
								[
									6.216601562499989,
									59.81835937499997
								],
								[
									6.211914062500028,
									59.83178710937494
								],
								[
									6.059277343750011,
									59.81557617187494
								],
								[
									5.96669921875008,
									59.81318359374998
								],
								[
									5.833984375000028,
									59.79467773437494
								],
								[
									5.7634765625000455,
									59.807910156250045
								],
								[
									5.73046875,
									59.86308593750002
								],
								[
									5.78359375000008,
									59.912792968749926
								],
								[
									5.996484374999994,
									60.03149414062506
								],
								[
									6.069921875000034,
									60.08349609375006
								],
								[
									6.111816406250057,
									60.13208007812503
								],
								[
									6.10517578125004,
									60.165136718750006
								],
								[
									6.140527343750051,
									60.23349609375006
								],
								[
									6.348730468750006,
									60.35297851562507
								],
								[
									6.518066406250028,
									60.407568359375006
								],
								[
									6.57363281250008,
									60.36059570312494
								],
								[
									6.526367187500057,
									60.21362304687503
								],
								[
									6.526855468750057,
									60.152929687500006
								],
								[
									6.660937500000017,
									60.36723632812496
								],
								[
									6.71992187500004,
									60.418164062499955
								],
								[
									6.787109375000057,
									60.454101562500085
								],
								[
									6.949707031250057,
									60.478222656249926
								],
								[
									6.995703125000006,
									60.51196289062506
								],
								[
									6.806347656250068,
									60.50078124999999
								],
								[
									6.346972656249989,
									60.419091796874966
								],
								[
									6.153320312499972,
									60.346240234375045
								],
								[
									6.10175781250004,
									60.29013671874998
								],
								[
									5.967382812500034,
									60.20556640625006
								],
								[
									5.904394531249977,
									60.15063476562506
								],
								[
									5.876562500000006,
									60.07001953124998
								],
								[
									5.800878906250034,
									60.02622070312495
								],
								[
									5.698828125000034,
									60.01000976562503
								],
								[
									5.557031249999994,
									59.907763671875074
								],
								[
									5.494531250000051,
									59.82558593750002
								],
								[
									5.353417968749994,
									59.760107421875006
								],
								[
									5.263867187500068,
									59.70976562499996
								],
								[
									5.234472656250006,
									59.69179687499994
								],
								[
									5.18603515625,
									59.64228515624998
								],
								[
									5.145800781250074,
									59.63881835937508
								],
								[
									5.110742187500023,
									59.667822265625034
								],
								[
									5.10488281250008,
									59.731689453125085
								],
								[
									5.119238281249977,
									59.83369140624998
								],
								[
									5.1871093750000625,
									59.907080078125006
								],
								[
									5.219531249999989,
									59.97875976562506
								],
								[
									5.174414062500034,
									60.0457031250001
								],
								[
									5.205664062500006,
									60.087939453125074
								],
								[
									5.265429687500017,
									60.08647460937496
								],
								[
									5.37646484375,
									60.06723632812495
								],
								[
									5.494531250000051,
									60.07031250000006
								],
								[
									5.688574218749977,
									60.12319335937508
								],
								[
									5.65761718750008,
									60.154101562500074
								],
								[
									5.5738281250000625,
									60.15849609374999
								],
								[
									5.41738281250008,
									60.154101562500074
								],
								[
									5.285839843750011,
									60.20571289062511
								],
								[
									5.183593750000057,
									60.308398437500045
								],
								[
									5.13710937500008,
									60.44560546875013
								],
								[
									5.168164062500011,
									60.48481445312504
								],
								[
									5.546484374999977,
									60.62456054687499
								],
								[
									5.648339843750051,
									60.68798828124994
								],
								[
									5.589355468750028,
									60.69428710937498
								],
								[
									5.447363281250034,
									60.61733398437494
								],
								[
									5.244042968750023,
									60.56958007812497
								],
								[
									5.115820312500006,
									60.635986328125
								],
								[
									5.049121093750017,
									60.707519531250114
								],
								[
									5.0107421875,
									60.858544921874966
								],
								[
									5.024609375000068,
									60.936132812500034
								],
								[
									5.008593750000017,
									61.03818359375006
								],
								[
									5.095410156250011,
									61.071337890625045
								],
								[
									5.192480468749977,
									61.05371093750003
								],
								[
									5.288183593750034,
									61.04716796875002
								],
								[
									5.505273437500023,
									61.05610351562507
								],
								[
									5.983984375000034,
									61.11733398437502
								],
								[
									6.292578125000034,
									61.08095703125005
								],
								[
									6.41796875,
									61.08427734375013
								],
								[
									6.60986328125,
									61.1370117187501
								],
								[
									6.777832031250028,
									61.14243164062498
								],
								[
									6.903417968750034,
									61.102148437500034
								],
								[
									6.97207031250008,
									61.05595703125013
								],
								[
									6.980566406250034,
									60.99414062500006
								],
								[
									7.0386718750000625,
									60.9529296875001
								],
								[
									7.0779296875000455,
									60.96630859374997
								],
								[
									7.046679687499989,
									61.01528320312511
								],
								[
									7.040136718750006,
									61.091162109375006
								],
								[
									7.545019531250006,
									61.17714843749994
								],
								[
									7.604492187500028,
									61.21054687500009
								],
								[
									7.403906250000034,
									61.22216796874997
								],
								[
									7.34658203125008,
									61.30058593749996
								],
								[
									7.45253906250008,
									61.419238281250045
								],
								[
									7.442578125000011,
									61.43461914062499
								],
								[
									7.331152343750034,
									61.37202148437504
								],
								[
									7.276269531250051,
									61.28393554687494
								],
								[
									7.29804687500004,
									61.213623046875
								],
								[
									7.275976562500006,
									61.1809570312501
								],
								[
									7.173535156249983,
									61.16596679687507
								],
								[
									6.942578125000011,
									61.16054687499994
								],
								[
									6.794335937500023,
									61.19038085937507
								],
								[
									6.657031250000017,
									61.20659179687499
								],
								[
									6.61025390625008,
									61.229101562500034
								],
								[
									6.62587890625008,
									61.27929687499997
								],
								[
									6.599902343750017,
									61.28964843749995
								],
								[
									6.543066406249977,
									61.244531249999994
								],
								[
									6.492578124999994,
									61.15458984374996
								],
								[
									6.383496093750068,
									61.133886718750006
								],
								[
									6.082519531250028,
									61.167285156250074
								],
								[
									5.646777343749989,
									61.147607421874966
								],
								[
									5.451269531250034,
									61.102343750000074
								],
								[
									5.32460937500008,
									61.108251953125034
								],
								[
									5.106738281250017,
									61.18754882812502
								],
								[
									5.021679687500011,
									61.25058593749998
								],
								[
									4.98994140625004,
									61.37768554687494
								],
								[
									5.0027343750000455,
									61.43359375000006
								],
								[
									5.172460937500006,
									61.45712890625006
								],
								[
									5.25830078125,
									61.45546875000008
								],
								[
									5.338671875000017,
									61.485498046874966
								],
								[
									5.267578125,
									61.50502929687505
								],
								[
									5.1675781250000625,
									61.54335937499994
								],
								[
									5.0994140625000455,
									61.62016601562496
								],
								[
									4.9966796875000625,
									61.6452148437501
								],
								[
									4.927832031249977,
									61.710693359375114
								],
								[
									4.910351562500068,
									61.8095703125
								],
								[
									4.930078124999994,
									61.878320312499966
								],
								[
									4.985058593750011,
									61.900439453125045
								],
								[
									5.116992187500074,
									61.885400390624994
								],
								[
									5.465332031249972,
									61.89692382812504
								],
								[
									5.793261718749989,
									61.827099609374926
								],
								[
									6.01582031250004,
									61.78749999999994
								],
								[
									6.466699218750051,
									61.8074218750001
								],
								[
									6.730761718750017,
									61.86977539062511
								],
								[
									6.682324218750011,
									61.88701171874996
								],
								[
									6.395898437500023,
									61.850976562499994
								],
								[
									6.131152343749989,
									61.85244140624994
								],
								[
									5.664453125000051,
									61.92290039062499
								],
								[
									5.473046875000051,
									61.9456054687501
								],
								[
									5.2668945312500455,
									61.9355957031251
								],
								[
									5.159570312500023,
									61.956982421874926
								],
								[
									5.096484375000074,
									62.02666015624999
								],
								[
									5.1431640625000625,
									62.15991210937506
								],
								[
									5.240917968750011,
									62.188671874999955
								],
								[
									5.293847656250023,
									62.15390624999998
								],
								[
									5.357714843750074,
									62.15170898437498
								],
								[
									5.422363281250028,
									62.20737304687495
								],
								[
									5.484277343750023,
									62.23911132812512
								],
								[
									5.5333007812500625,
									62.31088867187509
								],
								[
									5.718164062500051,
									62.378906250000085
								],
								[
									5.79628906250008,
									62.38466796875011
								],
								[
									5.908300781249977,
									62.416015625
								],
								[
									5.979785156250074,
									62.407128906249966
								],
								[
									6.025585937500068,
									62.375683593749955
								],
								[
									6.083496093750057,
									62.34960937499997
								],
								[
									6.208984375000057,
									62.352783203125
								],
								[
									6.580078125000057,
									62.407275390625074
								],
								[
									6.620019531250023,
									62.42329101562507
								],
								[
									6.692382812500028,
									62.468066406250045
								],
								[
									6.4571289062500625,
									62.44809570312506
								],
								[
									6.261718750000028,
									62.416308593750074
								],
								[
									6.136132812500023,
									62.40747070312494
								],
								[
									6.118457031250074,
									62.44716796875005
								],
								[
									6.164746093750011,
									62.48242187499994
								],
								[
									6.237499999999983,
									62.51992187499994
								],
								[
									6.272851562499994,
									62.58383789062509
								],
								[
									6.352929687500051,
									62.61113281249996
								],
								[
									6.439453125,
									62.60966796875002
								],
								[
									6.61835937500004,
									62.62128906249998
								],
								[
									6.74462890625,
									62.6378906250001
								],
								[
									6.961132812500068,
									62.626757812500045
								],
								[
									7.283789062499977,
									62.60229492187494
								],
								[
									7.491796875000006,
									62.54282226562509
								],
								[
									7.5701171875000455,
									62.54819335937512
								],
								[
									7.653124999999989,
									62.56401367187496
								],
								[
									7.690722656250017,
									62.585595703124994
								],
								[
									7.5274414062500625,
									62.61030273437507
								],
								[
									7.518164062500034,
									62.64550781249994
								],
								[
									7.538378906250074,
									62.67207031250004
								],
								[
									7.804687500000057,
									62.72099609374996
								],
								[
									8.095507812500074,
									62.73183593750005
								],
								[
									8.045507812500006,
									62.771240234375085
								],
								[
									7.408398437500068,
									62.71176757812495
								],
								[
									7.242089843750023,
									62.75234375000005
								],
								[
									7.11083984375,
									62.752001953125074
								],
								[
									7.02490234375,
									62.72880859374996
								],
								[
									6.779980468750011,
									62.7007324218751
								],
								[
									6.734960937500006,
									62.720703125000085
								],
								[
									6.781542968750074,
									62.789648437500006
								],
								[
									6.928222656250028,
									62.90273437500005
								],
								[
									6.940429687500028,
									62.9304687500001
								],
								[
									7.00849609375004,
									62.95766601562505
								],
								[
									7.389062500000023,
									63.02329101562509
								],
								[
									7.5718750000000625,
									63.09951171875008
								],
								[
									7.654296875000057,
									63.109179687500074
								],
								[
									7.736035156250011,
									63.10385742187498
								],
								[
									7.860351562500028,
									63.11279296875003
								],
								[
									8.100585937500028,
									63.09096679687502
								],
								[
									8.211132812499983,
									62.99550781249994
								],
								[
									8.310546875,
									62.965527343749955
								],
								[
									8.623144531250006,
									62.84624023437499
								],
								[
									8.609179687499989,
									62.88056640625004
								],
								[
									8.338574218750011,
									63.04218750000004
								],
								[
									8.235156250000017,
									63.08217773437508
								],
								[
									8.158007812500017,
									63.16152343750008
								],
								[
									8.18447265625008,
									63.23652343750001
								],
								[
									8.271484375000028,
									63.28657226562498
								],
								[
									8.580175781250034,
									63.31337890624994
								],
								[
									8.635546875000045,
									63.342333984375074
								],
								[
									8.641015624999994,
									63.392089843750085
								],
								[
									8.593750000000057,
									63.42612304687509
								],
								[
									8.480175781250011,
									63.42416992187495
								],
								[
									8.386523437500017,
									63.44526367187498
								],
								[
									8.360742187500023,
									63.49887695312506
								],
								[
									8.398144531249983,
									63.5351074218751
								],
								[
									8.576171875000028,
									63.60117187499995
								],
								[
									8.673632812500074,
									63.622607421875045
								],
								[
									8.842382812499977,
									63.64589843750011
								],
								[
									9.135839843750006,
									63.59365234374994
								],
								[
									9.158105468749994,
									63.56625976562495
								],
								[
									9.07587890625004,
									63.50039062499994
								],
								[
									9.08417968750004,
									63.46342773437496
								],
								[
									9.156054687500045,
									63.459326171875006
								],
								[
									9.32363281250008,
									63.57036132812499
								],
								[
									9.520703125000068,
									63.585693359375
								],
								[
									9.602246093750068,
									63.60957031249998
								],
								[
									9.696874999999977,
									63.62456054687502
								],
								[
									9.83222656250004,
									63.524169921875085
								],
								[
									9.891503906250023,
									63.49204101562509
								],
								[
									9.936035156250028,
									63.47885742187509
								],
								[
									9.97919921875004,
									63.395263671875114
								],
								[
									10.020996093750028,
									63.3908203125001
								],
								[
									10.08056640625,
									63.432714843750006
								],
								[
									10.188574218750063,
									63.45478515625007
								],
								[
									10.340039062500011,
									63.469335937500006
								],
								[
									10.590917968750063,
									63.44721679687504
								],
								[
									10.704492187500023,
									63.46357421874998
								],
								[
									10.76015625000008,
									63.46127929687506
								],
								[
									10.706738281250011,
									63.53632812499998
								],
								[
									10.673632812500017,
									63.55800781250005
								],
								[
									10.725292968750068,
									63.625000000000114
								],
								[
									10.779199218750051,
									63.65117187500002
								],
								[
									10.952539062499994,
									63.69819335937501
								],
								[
									11.11787109375004,
									63.719189453124926
								],
								[
									11.225781250000068,
									63.763818359374966
								],
								[
									11.370703125000034,
									63.804833984374966
								],
								[
									11.347949218750017,
									63.8376953125001
								],
								[
									11.307617187500057,
									63.87573242187503
								],
								[
									11.213867187500057,
									63.87812499999998
								],
								[
									11.175585937500074,
									63.89887695312504
								],
								[
									11.294628906250068,
									63.948193359374955
								],
								[
									11.457617187500063,
									64.00297851562502
								],
								[
									11.429199218750028,
									64.02451171875003
								],
								[
									11.306640625000028,
									64.04887695312505
								],
								[
									11.213574218750068,
									64.03051757812494
								],
								[
									11.075195312500028,
									63.988134765625006
								],
								[
									10.914257812500011,
									63.92109375000004
								],
								[
									10.966699218750051,
									63.901562499999955
								],
								[
									11.047265625000023,
									63.84521484375003
								],
								[
									10.934863281250045,
									63.770214843749926
								],
								[
									10.339160156250017,
									63.57104492187494
								],
								[
									10.055078125000051,
									63.51269531250006
								],
								[
									9.924023437499983,
									63.52177734375013
								],
								[
									9.892773437500011,
									63.57622070312502
								],
								[
									9.832324218750045,
									63.616503906250045
								],
								[
									9.76748046875008,
									63.6995117187501
								],
								[
									9.6572265625,
									63.6973144531251
								],
								[
									9.594628906250023,
									63.678955078125085
								],
								[
									9.567285156250051,
									63.706152343750034
								],
								[
									9.614746093750057,
									63.794824218749966
								],
								[
									9.708007812500028,
									63.86489257812502
								],
								[
									9.864453125000011,
									63.91782226562498
								],
								[
									9.939453125000028,
									63.981738281250045
								],
								[
									10.009960937500011,
									64.08315429687508
								],
								[
									10.236230468749994,
									64.17963867187504
								],
								[
									10.56562500000004,
									64.41831054687498
								],
								[
									10.833984375,
									64.49448242187503
								],
								[
									10.932324218750068,
									64.57773437499995
								],
								[
									11.090429687500034,
									64.61455078124999
								],
								[
									11.225390624999989,
									64.67949218749999
								],
								[
									11.331347656249989,
									64.68593749999997
								],
								[
									11.523828125000051,
									64.74438476562497
								],
								[
									11.632910156250063,
									64.81391601562493
								],
								[
									11.56171875000004,
									64.81826171875002
								],
								[
									11.392480468750023,
									64.77299804687513
								],
								[
									11.296777343750051,
									64.75478515624997
								],
								[
									11.303515625000017,
									64.82939453125007
								],
								[
									11.349902343750045,
									64.90590820312494
								],
								[
									11.489355468750034,
									64.97583007812497
								],
								[
									12.15966796875,
									65.17895507812506
								],
								[
									12.226562500000028,
									65.14536132812495
								],
								[
									12.30654296875008,
									65.0859863281251
								],
								[
									12.508398437499977,
									65.0994140625001
								],
								[
									12.738378906250034,
									65.21440429687499
								],
								[
									12.915527343750057,
									65.33925781249994
								],
								[
									12.819824218750028,
									65.31748046875003
								],
								[
									12.715332031250057,
									65.266357421875
								],
								[
									12.511718750000028,
									65.1953125
								],
								[
									12.417578125000034,
									65.18408203124994
								],
								[
									12.363867187500034,
									65.19331054687495
								],
								[
									12.333984374999972,
									65.24072265625003
								],
								[
									12.263378906250068,
									65.25610351562506
								],
								[
									12.199609375000051,
									65.245458984375
								],
								[
									12.133886718749977,
									65.27915039062495
								],
								[
									12.122167968750006,
									65.36235351562502
								],
								[
									12.206250000000068,
									65.48623046874994
								],
								[
									12.272851562500051,
									65.5681640625001
								],
								[
									12.344824218750063,
									65.63017578124996
								],
								[
									12.627734375000045,
									65.80615234375011
								],
								[
									12.68886718750008,
									65.90219726562495
								],
								[
									12.816796875000023,
									65.95288085937497
								],
								[
									12.983007812500034,
									65.94160156249998
								],
								[
									13.033105468750023,
									65.95624999999995
								],
								[
									12.976074218750057,
									66.01918945312508
								],
								[
									12.794921875,
									66.06909179687494
								],
								[
									12.783789062500034,
									66.10043945312512
								],
								[
									13.387109375000023,
									66.18276367187508
								],
								[
									13.674414062500034,
									66.17998046875005
								],
								[
									13.75966796875008,
									66.22104492187506
								],
								[
									13.915820312500017,
									66.24736328125002
								],
								[
									14.034179687500057,
									66.29755859375004
								],
								[
									13.973144531250057,
									66.31972656250002
								],
								[
									13.68134765625004,
									66.27358398437494
								],
								[
									13.49892578125008,
									66.25190429687507
								],
								[
									13.416406250000051,
									66.25258789062502
								],
								[
									13.35205078125,
									66.23671875000008
								],
								[
									13.118847656250011,
									66.23066406250007
								],
								[
									13.068164062500074,
									66.430810546875
								],
								[
									13.10468750000004,
									66.539404296875
								],
								[
									13.191601562499983,
									66.53715820312499
								],
								[
									13.211425781250028,
									66.64082031250007
								],
								[
									13.311816406250074,
									66.70185546875007
								],
								[
									13.45039062500004,
									66.71552734375001
								],
								[
									13.520214843750068,
									66.7416503906251
								],
								[
									13.62109375,
									66.79482421875
								],
								[
									13.78798828125008,
									66.78247070312497
								],
								[
									13.959472656250028,
									66.79433593750008
								],
								[
									13.916992187499972,
									66.8193847656251
								],
								[
									13.704101562500057,
									66.85166015625003
								],
								[
									13.651562500000011,
									66.90708007812495
								],
								[
									13.726660156250034,
									66.93803710937505
								],
								[
									13.808398437500074,
									66.96079101562506
								],
								[
									13.880175781250045,
									66.9648925781251
								],
								[
									14.022363281250051,
									67.07309570312512
								],
								[
									14.10878906250008,
									67.11923828125
								],
								[
									14.205566406249972,
									67.11123046875005
								],
								[
									14.34033203125,
									67.15893554687511
								],
								[
									14.472656250000028,
									67.14267578125006
								],
								[
									14.600683593750006,
									67.17387695312505
								],
								[
									14.775585937500011,
									67.19448242187497
								],
								[
									15.41572265625004,
									67.20244140624999
								],
								[
									15.434765625000011,
									67.24667968749995
								],
								[
									15.300097656250017,
									67.25693359375009
								],
								[
									14.824414062500011,
									67.268310546875
								],
								[
									14.58154296875,
									67.267431640625
								],
								[
									14.479296875000045,
									67.25595703124998
								],
								[
									14.441699218750045,
									67.27138671875011
								],
								[
									14.448339843750063,
									67.29785156250006
								],
								[
									14.53662109375,
									67.33974609375
								],
								[
									14.578515625000023,
									67.3860351562501
								],
								[
									14.754980468750006,
									67.49902343750003
								],
								[
									14.961914062500057,
									67.57426757812499
								],
								[
									15.120507812500023,
									67.55502929687498
								],
								[
									15.289160156250034,
									67.48315429687509
								],
								[
									15.409375000000011,
									67.47416992187502
								],
								[
									15.465332031250028,
									67.45092773437509
								],
								[
									15.552929687500011,
									67.35175781249995
								],
								[
									15.59443359375004,
									67.34853515625008
								],
								[
									15.575683593750028,
									67.44384765624997
								],
								[
									15.691503906250006,
									67.52138671875005
								],
								[
									15.661328124999983,
									67.54282226562498
								],
								[
									15.487304687499972,
									67.51479492187502
								],
								[
									15.35400390625,
									67.54394531250003
								],
								[
									15.24873046875004,
									67.60214843749998
								],
								[
									15.218652343750051,
									67.65537109375006
								],
								[
									15.284082031250051,
									67.70795898437495
								],
								[
									15.345800781250006,
									67.73442382812502
								],
								[
									15.303906250000011,
									67.765283203125
								],
								[
									15.040820312500045,
									67.68256835937493
								],
								[
									14.854687500000068,
									67.66333007812509
								],
								[
									14.781347656250034,
									67.67490234375006
								],
								[
									14.821093750000045,
									67.74985351562506
								],
								[
									14.798925781250063,
									67.809326171875
								],
								[
									15.048437500000006,
									67.95576171874998
								],
								[
									15.13427734375,
									67.97270507812507
								],
								[
									15.274414062500028,
									67.96093749999997
								],
								[
									15.400878906250057,
									67.9196289062501
								],
								[
									15.506640625000017,
									67.92622070312493
								],
								[
									15.621386718750017,
									67.94829101562507
								],
								[
									15.605761718750045,
									67.98789062500006
								],
								[
									15.356933593750057,
									68.00361328125007
								],
								[
									15.29287109375008,
									68.036474609375
								],
								[
									15.316015624999977,
									68.06875000000008
								],
								[
									15.486816406250057,
									68.10283203125002
								],
								[
									15.656640625000023,
									68.16435546875013
								],
								[
									15.85126953125004,
									68.18217773437502
								],
								[
									16.007910156249977,
									68.2287109375001
								],
								[
									16.0380859375,
									68.21816406250008
								],
								[
									16.064550781249977,
									68.19990234374998
								],
								[
									16.120800781250068,
									68.02734375
								],
								[
									16.26074218749997,
									67.88657226562509
								],
								[
									16.312304687500017,
									67.88144531249995
								],
								[
									16.258593750000074,
									68.00122070312511
								],
								[
									16.308691406249977,
									68.03564453125009
								],
								[
									16.372167968750034,
									68.06181640625002
								],
								[
									16.39199218750008,
									68.09160156250005
								],
								[
									16.319238281249994,
									68.10175781249998
								],
								[
									16.259765625000057,
									68.14453125000009
								],
								[
									16.174804687500057,
									68.28125000000003
								],
								[
									16.20380859375001,
									68.31674804687509
								],
								[
									16.38789062500004,
									68.38955078125
								],
								[
									16.61884765625001,
									68.4062988281251
								],
								[
									16.864941406250068,
									68.35527343750002
								],
								[
									16.951367187499983,
									68.35468750000007
								],
								[
									17.094042968750017,
									68.36840820312494
								],
								[
									17.33613281250004,
									68.41035156250004
								],
								[
									17.478515625,
									68.42631835937502
								],
								[
									17.552832031250063,
									68.42626953125009
								],
								[
									17.57119140625005,
									68.44746093750007
								],
								[
									17.50234375000008,
									68.461083984375
								],
								[
									17.480175781249983,
									68.47431640625004
								],
								[
									17.426171874999994,
									68.48193359375006
								],
								[
									17.202343750000068,
									68.45927734374999
								],
								[
									16.584863281250023,
									68.46645507812494
								],
								[
									16.52529296875005,
									68.49067382812498
								],
								[
									16.51435546875004,
									68.53256835937509
								],
								[
									16.579882812500074,
									68.59267578125008
								],
								[
									16.65185546875,
									68.62578125000007
								],
								[
									16.88466796875008,
									68.68540039062495
								],
								[
									17.131152343750017,
									68.69345703125009
								],
								[
									17.390820312499983,
									68.79936523437499
								],
								[
									17.490039062500045,
									68.878759765625
								],
								[
									17.54628906250005,
									69.00112304687497
								],
								[
									17.704589843750057,
									69.10004882812504
								],
								[
									18.101464843749994,
									69.15629882812496
								],
								[
									18.117480468750074,
									69.18120117187507
								],
								[
									18.07539062500001,
									69.23261718750007
								],
								[
									18.078710937499977,
									69.32524414062502
								],
								[
									18.18750000000003,
									69.43310546875006
								],
								[
									18.259765625,
									69.47060546874997
								],
								[
									18.293164062500068,
									69.47509765625009
								],
								[
									18.37871093749999,
									69.43984375
								],
								[
									18.48261718750001,
									69.36484375000009
								],
								[
									18.6455078125,
									69.32187499999995
								],
								[
									18.858984375000063,
									69.31445312499994
								],
								[
									18.915917968750023,
									69.335595703125
								],
								[
									18.750000000000057,
									69.37841796875009
								],
								[
									18.62441406250005,
									69.43437500000005
								],
								[
									18.614453125000068,
									69.49057617187495
								],
								[
									18.67402343750004,
									69.52036132812498
								],
								[
									18.766601562500057,
									69.51704101562501
								],
								[
									18.88281250000003,
									69.52333984375005
								],
								[
									18.99111328125005,
									69.56113281250012
								],
								[
									19.006835937500057,
									69.58769531250002
								],
								[
									19.011328125000006,
									69.62373046874998
								],
								[
									19.038378906250017,
									69.66040039062509
								],
								[
									19.197265625000057,
									69.74785156249996
								],
								[
									19.68701171875,
									69.80473632812507
								],
								[
									19.722460937500017,
									69.781640625
								],
								[
									19.69599609375004,
									69.61293945312508
								],
								[
									19.639746093750034,
									69.50380859375005
								],
								[
									19.64150390625005,
									69.42402343750007
								],
								[
									19.73681640625,
									69.50380859375005
								],
								[
									19.864648437500023,
									69.72211914062495
								],
								[
									19.960546875000034,
									69.82460937499997
								],
								[
									20.068945312500006,
									69.88344726562505
								],
								[
									20.14638671875005,
									69.896728515625
								],
								[
									20.223046875000023,
									69.92719726562498
								],
								[
									20.32421875000003,
									69.94531249999994
								],
								[
									20.35517578125004,
									69.92192382812507
								],
								[
									20.38720703125,
									69.86762695312493
								],
								[
									20.332714843749983,
									69.67695312499998
								],
								[
									20.338183593750045,
									69.61665039062495
								],
								[
									20.277148437500045,
									69.53583984374993
								],
								[
									20.043750000000017,
									69.35566406250007
								],
								[
									20.054492187500074,
									69.33266601562502
								],
								[
									20.107226562500074,
									69.34121093750008
								],
								[
									20.197656250000023,
									69.37094726562509
								],
								[
									20.486718750000023,
									69.54208984375003
								],
								[
									20.739453124999983,
									69.5205078125
								],
								[
									20.742578124999994,
									69.53452148437509
								],
								[
									20.661523437500023,
									69.58471679687494
								],
								[
									20.5625,
									69.63281249999997
								],
								[
									20.532714843750057,
									69.69233398437493
								],
								[
									20.545996093750006,
									69.85107421875003
								],
								[
									20.622070312500057,
									69.91391601562495
								],
								[
									20.84033203125003,
									69.90732421875003
								],
								[
									20.971093750000023,
									69.91601562500003
								],
								[
									21.032128906250023,
									69.88745117187497
								],
								[
									21.163085937500057,
									69.88950195312495
								],
								[
									21.253710937500045,
									70.00322265625002
								],
								[
									21.432910156250045,
									70.01318359375009
								],
								[
									21.590234375000023,
									69.93803710937507
								],
								[
									21.779589843750074,
									69.88745117187497
								],
								[
									21.931738281250063,
									69.81469726562509
								],
								[
									21.974707031250034,
									69.83457031249995
								],
								[
									21.892578125,
									70.00424804687506
								],
								[
									21.80273437499997,
									70.06606445312502
								],
								[
									21.60781250000005,
									70.0981933593751
								],
								[
									21.400390625,
									70.17446289062508
								],
								[
									21.346289062499977,
									70.20825195312506
								],
								[
									21.355761718750045,
									70.23339843750003
								],
								[
									21.53876953125004,
									70.25766601562509
								],
								[
									21.78027343750003,
									70.22988281250002
								],
								[
									21.995507812499994,
									70.29335937500008
								],
								[
									22.05439453125001,
									70.27597656250009
								],
								[
									22.219433593750068,
									70.3091796875
								],
								[
									22.321972656250068,
									70.26450195312506
								],
								[
									22.384765625,
									70.277734375
								],
								[
									22.421191406250045,
									70.33759765624993
								],
								[
									22.684570312500057,
									70.37475585937503
								],
								[
									22.851660156249977,
									70.34047851562508
								],
								[
									22.941210937500017,
									70.30498046875005
								],
								[
									22.98281250000005,
									70.2367675781251
								],
								[
									23.046484375000063,
									70.10185546874996
								],
								[
									23.176953124999983,
									70.02905273437506
								],
								[
									23.257910156250063,
									69.99331054687505
								],
								[
									23.35390625000008,
									69.98339843750006
								],
								[
									23.40019531249999,
									70.01977539062503
								],
								[
									23.310253906250068,
									70.06357421874998
								],
								[
									23.286035156250023,
									70.10483398437503
								],
								[
									23.3291015625,
									70.20722656249993
								],
								[
									23.37939453125003,
									70.24746093750005
								],
								[
									23.661230468750063,
									70.39975585937498
								],
								[
									23.897167968749983,
									70.478759765625
								],
								[
									24.038476562499994,
									70.48535156250011
								],
								[
									24.28554687500008,
									70.66240234375002
								],
								[
									24.355566406250034,
									70.694580078125
								],
								[
									24.420019531250034,
									70.702001953125
								],
								[
									24.40351562500004,
									70.74531249999995
								],
								[
									24.268164062500006,
									70.77270507812503
								],
								[
									24.263476562500017,
									70.82631835937494
								],
								[
									24.441796875000023,
									70.89155273437498
								],
								[
									24.658007812500017,
									71.00102539062507
								],
								[
									24.764746093750006,
									71.008447265625
								],
								[
									24.831640625000034,
									70.97802734375003
								],
								[
									25.04218750000004,
									70.92861328125
								],
								[
									25.171191406250017,
									70.87202148437501
								],
								[
									25.264648437500057,
									70.84350585937497
								],
								[
									25.325390624999983,
									70.84941406250002
								],
								[
									25.375585937500006,
									70.89194335937498
								],
								[
									25.43593750000005,
									70.91186523437503
								],
								[
									25.569824218750057,
									70.90068359374999
								],
								[
									25.649707031250074,
									70.8733398437501
								],
								[
									25.711914062500057,
									70.86972656249998
								],
								[
									25.768164062500063,
									70.85317382812508
								],
								[
									25.78144531250001,
									70.81679687500002
								],
								[
									25.665625000000034,
									70.77714843750005
								],
								[
									25.468261718750057,
									70.67197265625012
								],
								[
									25.273535156250006,
									70.552392578125
								],
								[
									25.209277343750045,
									70.48940429687505
								],
								[
									25.146386718750023,
									70.3240234375001
								],
								[
									24.994238281250034,
									70.21821289062504
								],
								[
									24.98271484374999,
									70.14399414062493
								],
								[
									25.043847656250023,
									70.109033203125
								],
								[
									25.21181640625005,
									70.13647460937509
								],
								[
									25.418847656250023,
									70.23549804687508
								],
								[
									25.470507812500074,
									70.340576171875
								],
								[
									25.98808593749999,
									70.62539062499994
								],
								[
									26.23085937500008,
									70.7826171875
								],
								[
									26.506933593750006,
									70.91279296875004
								],
								[
									26.66132812500001,
									70.93974609375005
								],
								[
									26.733984375000006,
									70.85356445312507
								],
								[
									26.675488281250068,
									70.74096679687503
								],
								[
									26.558203125000063,
									70.66914062500007
								],
								[
									26.644628906250006,
									70.63623046875003
								],
								[
									26.62812500000001,
									70.55087890624995
								],
								[
									26.601171875000034,
									70.50346679687507
								],
								[
									26.583984375,
									70.45380859374998
								],
								[
									26.585058593750034,
									70.41000976562503
								],
								[
									26.666113281250034,
									70.4216796875001
								],
								[
									26.989355468750063,
									70.51137695312508
								],
								[
									27.071289062500057,
									70.60844726562496
								],
								[
									27.147265625000074,
									70.68120117187513
								],
								[
									27.183691406250034,
									70.74404296875005
								],
								[
									27.309375000000074,
									70.803564453125
								],
								[
									27.546484375000063,
									70.8040039062501
								],
								[
									27.555664062500057,
									70.82739257812497
								],
								[
									27.26904296875003,
									70.91000976562512
								],
								[
									27.23525390625005,
									70.94721679687495
								],
								[
									27.331640624999977,
									70.99672851562511
								],
								[
									27.59707031250005,
									71.09130859375
								],
								[
									27.733496093750063,
									71.0808593750001
								],
								[
									27.815039062500063,
									71.05937499999999
								],
								[
									28.141699218749977,
									71.0430175781251
								],
								[
									28.392285156250068,
									70.9752929687501
								],
								[
									28.38271484375005,
									70.86943359375002
								],
								[
									28.32685546875004,
									70.82519531249997
								],
								[
									28.27187500000005,
									70.79794921875009
								],
								[
									27.950976562500045,
									70.71757812499999
								],
								[
									27.898046875000006,
									70.67792968749998
								],
								[
									27.998828125000017,
									70.66425781249995
								],
								[
									28.215625000000045,
									70.70434570312503
								],
								[
									28.271777343750017,
									70.66796875
								],
								[
									28.202734374999977,
									70.57690429687511
								],
								[
									28.191015625000006,
									70.44018554687506
								],
								[
									28.166015625000057,
									70.36040039062496
								],
								[
									28.166015625000057,
									70.28764648437505
								],
								[
									28.192968750000034,
									70.2485839843751
								],
								[
									28.280078125000017,
									70.40341796875012
								],
								[
									28.309863281250045,
									70.44306640624993
								],
								[
									28.43730468749999,
									70.5013671875
								],
								[
									28.48476562500008,
									70.61879882812494
								],
								[
									28.609375000000057,
									70.75966796874994
								],
								[
									28.749804687500074,
									70.84150390625001
								],
								[
									28.83154296875003,
									70.86396484375004
								],
								[
									29.102343750000045,
									70.86074218750002
								],
								[
									29.21855468749999,
									70.82993164062503
								],
								[
									29.32109374999999,
									70.76147460937506
								],
								[
									29.397656250000182,
									70.73413085937506
								],
								[
									29.639062500000136,
									70.70502929687501
								],
								[
									29.72197265625016,
									70.66855468749995
								],
								[
									29.73750000000001,
									70.64682617187503
								],
								[
									29.796484375000034,
									70.64252929687507
								],
								[
									29.959375000000023,
									70.69438476562496
								],
								[
									30.065136718750182,
									70.70297851562503
								],
								[
									30.237695312500136,
									70.62216796875009
								],
								[
									30.203027343750023,
									70.56230468750005
								],
								[
									30.213183593750045,
									70.543310546875
								],
								[
									30.422070312500068,
									70.54716796874999
								],
								[
									30.59589843750001,
									70.523681640625
								],
								[
									30.926367187500034,
									70.401123046875
								],
								[
									30.960644531250182,
									70.34384765625006
								],
								[
									30.94414062499999,
									70.27441406249994
								],
								[
									30.468945312500182,
									70.19785156249998
								],
								[
									30.26298828125016,
									70.12470703125007
								],
								[
									29.925878906250034,
									70.09648437500002
								],
								[
									28.78115234375005,
									70.14541015625002
								],
								[
									28.804296875000063,
									70.09252929687509
								],
								[
									29.60136718749999,
									69.97675781249995
								],
								[
									29.646875000000136,
									69.94370117187498
								],
								[
									29.62138671874999,
									69.8740722656251
								],
								[
									29.620996093750023,
									69.81821289062509
								],
								[
									29.63593750000001,
									69.78012695312503
								],
								[
									29.69462890624999,
									69.7445800781251
								],
								[
									29.792089843750034,
									69.72788085937498
								],
								[
									29.990332031250034,
									69.73666992187506
								],
								[
									30.088281249999966,
									69.7175781250001
								],
								[
									30.155175781250136,
									69.745947265625
								],
								[
									30.180078125000136,
									69.84116210937503
								],
								[
									30.237597656250045,
									69.86220703125008
								],
								[
									30.348828125000068,
									69.83457031249995
								],
								[
									30.39726562500016,
									69.7328125
								],
								[
									30.42832031250009,
									69.72226562499998
								],
								[
									30.484374999999943,
									69.79487304687504
								],
								[
									30.59453124999999,
									69.78964843749995
								],
								[
									30.714453125000034,
									69.79570312500002
								],
								[
									30.869726562500034,
									69.78344726562511
								]
							]
						],
						[
							[
								[
									25.58632812500005,
									71.14208984375006
								],
								[
									25.85351562500003,
									71.10385742187506
								],
								[
									25.94501953125001,
									71.10463867187497
								],
								[
									26.07763671875003,
									71.03315429687507
								],
								[
									26.146875000000023,
									71.03950195312493
								],
								[
									26.13378906250003,
									70.9958007812501
								],
								[
									25.999707031250068,
									70.97509765625006
								],
								[
									25.791308593750045,
									70.96250000000006
								],
								[
									25.760156250000023,
									70.95380859375007
								],
								[
									25.582031250000057,
									70.96079101562498
								],
								[
									25.482031250000034,
									71.01958007812496
								],
								[
									25.31494140625,
									71.03413085937507
								],
								[
									25.315234375000045,
									71.05297851562511
								],
								[
									25.423437499999977,
									71.097412109375
								],
								[
									25.58632812500005,
									71.14208984375006
								]
							]
						],
						[
							[
								[
									-8.953564453124983,
									70.83916015625007
								],
								[
									-9.045800781249937,
									70.83266601562508
								],
								[
									-9.098876953125,
									70.85488281250008
								],
								[
									-8.964648437499932,
									70.91591796875008
								],
								[
									-8.520800781250017,
									71.0306640625
								],
								[
									-8.343701171874983,
									71.14013671875
								],
								[
									-8.001367187499966,
									71.17768554687493
								],
								[
									-7.978808593749989,
									71.11689453124998
								],
								[
									-8.002099609374937,
									71.04125976562503
								],
								[
									-8.302343750000006,
									70.98115234375004
								],
								[
									-8.635351562499977,
									70.9404296875
								],
								[
									-8.953564453124983,
									70.83916015625007
								]
							]
						],
						[
							[
								[
									19.219335937500006,
									74.39101562500008
								],
								[
									19.098535156249994,
									74.35214843750006
								],
								[
									18.917578125000006,
									74.41064453125009
								],
								[
									18.797460937500034,
									74.48569335937509
								],
								[
									18.86123046875005,
									74.51416015625003
								],
								[
									19.182910156250045,
									74.51791992187509
								],
								[
									19.261523437500074,
									74.47895507812495
								],
								[
									19.274707031250017,
									74.45673828124995
								],
								[
									19.219335937500006,
									74.39101562500008
								]
							]
						],
						[
							[
								[
									21.60810546875004,
									78.59570312499994
								],
								[
									21.74560546874997,
									78.572021484375
								],
								[
									22.04316406250004,
									78.57695312500013
								],
								[
									22.207324218750074,
									78.40766601562501
								],
								[
									22.29951171875004,
									78.22817382812494
								],
								[
									22.449316406250006,
									78.21523437499997
								],
								[
									22.73457031250001,
									78.23994140625004
								],
								[
									22.988867187500034,
									78.25195312500009
								],
								[
									23.119238281250063,
									78.23862304687503
								],
								[
									23.351660156250063,
									78.18627929687503
								],
								[
									23.451953125000074,
									78.14946289062507
								],
								[
									23.36464843750005,
									78.12050781249994
								],
								[
									23.151953125000063,
									78.0880859375001
								],
								[
									23.11669921874997,
									77.99150390625005
								],
								[
									23.33056640625003,
									77.95786132812503
								],
								[
									23.68398437500008,
									77.87543945312493
								],
								[
									23.88300781250004,
									77.86474609374997
								],
								[
									24.23828125000003,
									77.89853515625012
								],
								[
									24.571484375000068,
									77.83442382812493
								],
								[
									24.90185546875003,
									77.75659179687497
								],
								[
									24.12978515625005,
									77.6582519531251
								],
								[
									24.06191406250008,
									77.63061523437497
								],
								[
									23.95498046875005,
									77.55771484374995
								],
								[
									23.84121093750005,
									77.49775390625007
								],
								[
									23.736132812500045,
									77.46235351562507
								],
								[
									23.505175781250074,
									77.40141601562499
								],
								[
									23.380859375000057,
									77.38032226562495
								],
								[
									23.101367187500045,
									77.38505859375005
								],
								[
									22.996679687500034,
									77.36079101562498
								],
								[
									22.899511718750063,
									77.31137695312495
								],
								[
									22.80175781250003,
									77.27578125000008
								],
								[
									22.55371093750003,
									77.26665039062499
								],
								[
									22.426953125000068,
									77.31591796875009
								],
								[
									22.468847656250063,
									77.33110351562505
								],
								[
									22.486621093750045,
									77.36010742187511
								],
								[
									22.442480468750034,
									77.429345703125
								],
								[
									22.67890625000004,
									77.50014648437502
								],
								[
									22.732617187500068,
									77.53935546875013
								],
								[
									22.685351562500017,
									77.55351562499999
								],
								[
									22.62031250000001,
									77.54960937499999
								],
								[
									22.44824218750003,
									77.57114257812512
								],
								[
									22.397265625000045,
									77.57011718749999
								],
								[
									22.25458984375001,
									77.52885742187502
								],
								[
									22.056835937500068,
									77.50117187499998
								],
								[
									21.85615234375004,
									77.49414062499997
								],
								[
									21.049902343750006,
									77.44096679687505
								],
								[
									20.92812500000005,
									77.45966796874995
								],
								[
									20.873144531250063,
									77.56533203125
								],
								[
									21.20107421875008,
									77.619482421875
								],
								[
									21.25146484375003,
									77.71093750000009
								],
								[
									21.33417968750001,
									77.77177734375005
								],
								[
									21.430859375000068,
									77.81210937500009
								],
								[
									21.6083984375,
									77.91606445312505
								],
								[
									21.653125000000045,
									77.92353515624995
								],
								[
									21.21044921875003,
									78.00576171875002
								],
								[
									21.035449218750074,
									78.05917968749998
								],
								[
									20.844921875000068,
									78.16586914062495
								],
								[
									20.786425781250045,
									78.25214843750004
								],
								[
									20.528320312500057,
									78.32558593750008
								],
								[
									20.560253906249983,
									78.41938476562507
								],
								[
									20.372753906250068,
									78.41201171875
								],
								[
									20.22792968750005,
									78.47783203125007
								],
								[
									20.36269531250005,
									78.51479492187508
								],
								[
									21.046875,
									78.55673828125009
								],
								[
									21.454785156250068,
									78.59755859374997
								],
								[
									21.60810546875004,
									78.59570312499994
								]
							]
						],
						[
							[
								[
									26.875976562500057,
									78.64892578124994
								],
								[
									26.729492187500057,
									78.64648437500009
								],
								[
									26.459570312500034,
									78.7202636718751
								],
								[
									26.407714843750057,
									78.784326171875
								],
								[
									26.455761718750068,
									78.81049804687501
								],
								[
									26.58593750000003,
									78.81147460937501
								],
								[
									26.78876953125004,
									78.72397460937506
								],
								[
									27.007617187500045,
									78.69750976562509
								],
								[
									26.875976562500057,
									78.64892578124994
								]
							]
						],
						[
							[
								[
									11.250292968750017,
									78.61069335937498
								],
								[
									11.261718750000028,
									78.54169921874995
								],
								[
									11.424218749999994,
									78.54858398437503
								],
								[
									11.616308593750063,
									78.47509765624997
								],
								[
									11.82568359375,
									78.43608398437502
								],
								[
									11.884863281250063,
									78.40932617187508
								],
								[
									11.929394531250068,
									78.37490234375
								],
								[
									12.056152343750057,
									78.3056152343751
								],
								[
									12.116406250000068,
									78.23256835937502
								],
								[
									11.96503906250004,
									78.22485351562497
								],
								[
									11.756542968750011,
									78.32900390624997
								],
								[
									11.586523437500034,
									78.38823242187505
								],
								[
									11.372460937500023,
									78.43876953125013
								],
								[
									11.19921875,
									78.441259765625
								],
								[
									11.121289062500011,
									78.46328124999997
								],
								[
									10.840625000000045,
									78.64472656249998
								],
								[
									10.788867187500045,
									78.68652343749997
								],
								[
									10.628417968750057,
									78.75385742187493
								],
								[
									10.557617187500028,
									78.83750000000009
								],
								[
									10.558203125000063,
									78.9029296875
								],
								[
									10.77285156250008,
									78.88750000000005
								],
								[
									10.960839843750023,
									78.84638671875004
								],
								[
									11.123925781250023,
									78.7533691406251
								],
								[
									11.152929687500063,
									78.72446289062498
								],
								[
									11.078222656250034,
									78.68603515625006
								],
								[
									11.15498046875004,
									78.64057617187501
								],
								[
									11.250292968750017,
									78.61069335937498
								]
							]
						],
						[
							[
								[
									29.04707031250004,
									78.9120605468751
								],
								[
									29.345410156250182,
									78.90576171875006
								],
								[
									29.645117187500034,
									78.921630859375
								],
								[
									29.696679687500136,
									78.90473632812493
								],
								[
									29.310546875,
									78.85209960937505
								],
								[
									28.88115234374999,
									78.88007812500007
								],
								[
									28.494531250000023,
									78.88720703125
								],
								[
									28.037890625000074,
									78.82871093749998
								],
								[
									27.889062500000023,
									78.85214843750006
								],
								[
									28.120996093750023,
									78.90844726562497
								],
								[
									28.37402343749997,
									78.92705078125013
								],
								[
									28.41474609375001,
									78.96142578125003
								],
								[
									28.511132812500023,
									78.96733398437507
								],
								[
									28.845214843750057,
									78.97084960937508
								],
								[
									29.04707031250004,
									78.9120605468751
								]
							]
						],
						[
							[
								[
									16.786718750000034,
									79.90673828125006
								],
								[
									16.838476562500006,
									79.90478515625
								],
								[
									16.888964843750074,
									79.91542968750005
								],
								[
									16.925585937500074,
									79.94345703124998
								],
								[
									16.966406250000034,
									79.95893554687501
								],
								[
									17.219433593750068,
									79.94077148437506
								],
								[
									17.578222656249977,
									79.88466796875
								],
								[
									17.68476562500001,
									79.85703125000003
								],
								[
									17.834570312499977,
									79.80004882812509
								],
								[
									17.956152343750063,
									79.70424804687511
								],
								[
									17.85976562500005,
									79.63500976562503
								],
								[
									17.732617187499983,
									79.56953125000001
								],
								[
									17.68750000000003,
									79.53334960937511
								],
								[
									17.733984375000006,
									79.48134765625008
								],
								[
									17.715039062500068,
									79.43076171874998
								],
								[
									17.668750000000045,
									79.3859375000001
								],
								[
									17.86103515625004,
									79.43706054687502
								],
								[
									18.272070312500034,
									79.60058593749994
								],
								[
									18.333300781250074,
									79.61069335937495
								],
								[
									18.39736328125005,
									79.60517578124998
								],
								[
									18.58144531250008,
									79.57158203125007
								],
								[
									18.748437499999994,
									79.48818359375005
								],
								[
									18.785253906250034,
									79.46059570312502
								],
								[
									18.815234375000017,
									79.42666015624994
								],
								[
									18.83242187500005,
									79.38476562500003
								],
								[
									18.822949218749983,
									79.336669921875
								],
								[
									18.807421875000017,
									79.30317382812493
								],
								[
									18.720019531250074,
									79.28149414062494
								],
								[
									18.677832031250006,
									79.26171875
								],
								[
									18.772265625000045,
									79.26025390624997
								],
								[
									18.880078124999983,
									79.23427734375011
								],
								[
									18.97900390625,
									79.17915039062507
								],
								[
									19.089453125000006,
									79.15703124999999
								],
								[
									19.490234375000057,
									79.17568359374997
								],
								[
									19.750878906250023,
									79.14682617187495
								],
								[
									19.893554687500057,
									79.05620117187496
								],
								[
									20.11376953124997,
									79.07670898437505
								],
								[
									20.11445312500004,
									79.12499999999994
								],
								[
									20.162695312500006,
									79.14565429687508
								],
								[
									20.458203125000068,
									79.12924804687509
								],
								[
									20.61103515625004,
									79.10664062500004
								],
								[
									20.767187500000034,
									79.05913085937513
								],
								[
									20.50068359375001,
									78.98139648437501
								],
								[
									20.720312500000006,
									78.90668945312507
								],
								[
									21.089648437500017,
									78.85263671874998
								],
								[
									21.312207031250068,
									78.79584960937495
								],
								[
									21.35253906250003,
									78.77202148437507
								],
								[
									21.388769531250034,
									78.74042968750004
								],
								[
									21.243945312500017,
									78.69941406249993
								],
								[
									21.096289062500034,
									78.67626953125011
								],
								[
									20.72480468750004,
									78.67231445312501
								],
								[
									20.387011718750045,
									78.64326171874995
								],
								[
									19.76875000000004,
									78.62270507812494
								],
								[
									19.67675781250003,
									78.60957031249993
								],
								[
									19.65498046875004,
									78.59785156250001
								],
								[
									19.61855468750008,
									78.56215820312502
								],
								[
									19.380664062500017,
									78.47978515625005
								],
								[
									19.150488281250006,
									78.37939453125011
								],
								[
									19.055664062500057,
									78.31894531250003
								],
								[
									18.98378906250008,
									78.23422851562512
								],
								[
									18.957617187499977,
									78.18247070312495
								],
								[
									19.00869140625008,
									78.13227539062504
								],
								[
									18.99511718749997,
									78.08149414062498
								],
								[
									18.822070312500074,
									78.04169921875004
								],
								[
									18.712304687500023,
									78.04008789062499
								],
								[
									18.574609375000023,
									78.04799804687508
								],
								[
									18.439257812500074,
									78.02504882812502
								],
								[
									18.4306640625,
									77.99057617187503
								],
								[
									18.43867187500004,
									77.942041015625
								],
								[
									18.404003906249983,
									77.79394531249994
								],
								[
									18.361914062500034,
									77.68227539062502
								],
								[
									18.29873046875005,
									77.57856445312501
								],
								[
									18.227929687499994,
									77.522607421875
								],
								[
									18.13740234375004,
									77.50703124999993
								],
								[
									17.84707031250005,
									77.49677734375007
								],
								[
									17.623339843750017,
									77.39936523437493
								],
								[
									17.442480468750034,
									77.22524414062508
								],
								[
									17.34863281250003,
									77.15688476562508
								],
								[
									17.15253906250004,
									77.04892578124995
								],
								[
									17.18789062500005,
									77.01064453124997
								],
								[
									17.249023437500057,
									76.96918945312495
								],
								[
									17.141992187500023,
									76.89492187500002
								],
								[
									16.976660156250006,
									76.81162109375
								],
								[
									16.979882812500023,
									76.77939453125009
								],
								[
									17.035546874999994,
									76.72036132812508
								],
								[
									17.06269531250004,
									76.65898437500007
								],
								[
									16.935156250000063,
									76.60615234374998
								],
								[
									16.700488281250045,
									76.57929687499993
								],
								[
									16.46191406250003,
									76.60932617187501
								],
								[
									16.345800781250006,
									76.64477539062494
								],
								[
									16.238085937500074,
									76.70151367187503
								],
								[
									16.123828125000074,
									76.73852539062494
								],
								[
									16.004492187500006,
									76.76074218749994
								],
								[
									15.546777343750023,
									76.88642578125007
								],
								[
									15.124218749999983,
									77.08510742187502
								],
								[
									14.738476562500011,
									77.16235351562506
								],
								[
									14.486914062500006,
									77.19902343750007
								],
								[
									14.365820312500034,
									77.23447265625
								],
								[
									14.24755859375,
									77.28212890624994
								],
								[
									14.145312500000045,
									77.335595703125
								],
								[
									14.050390624999977,
									77.40322265625011
								],
								[
									14.004199218750074,
									77.44521484375002
								],
								[
									13.995703125000034,
									77.508203125
								],
								[
									14.026074218750011,
									77.54516601562497
								],
								[
									14.071289062499972,
									77.56411132812511
								],
								[
									14.37763671875004,
									77.57963867187507
								],
								[
									14.48779296875,
									77.57084960937496
								],
								[
									14.596289062500006,
									77.537939453125
								],
								[
									14.69501953125004,
									77.52504882812505
								],
								[
									14.920800781250023,
									77.68881835937509
								],
								[
									16.205957031250023,
									77.782470703125
								],
								[
									16.619140625,
									77.79868164062509
								],
								[
									17.033300781249977,
									77.79770507812509
								],
								[
									16.96874999999997,
									77.84194335937502
								],
								[
									16.91406250000003,
									77.89799804687507
								],
								[
									16.852929687500023,
									77.91157226562493
								],
								[
									16.539648437500063,
									77.88022460937512
								],
								[
									16.060058593750057,
									77.84711914062501
								],
								[
									15.82636718750004,
									77.84707031250002
								],
								[
									15.585351562500051,
									77.86914062500006
								],
								[
									15.344824218750006,
									77.85698242187499
								],
								[
									15.096875000000011,
									77.80903320312507
								],
								[
									14.846875000000068,
									77.77866210937512
								],
								[
									14.603906250000051,
									77.76645507812512
								],
								[
									14.089941406250034,
									77.77138671874997
								],
								[
									13.962500000000006,
									77.79624023437506
								],
								[
									13.791113281250006,
									77.85380859374996
								],
								[
									13.749609374999977,
									77.88330078125003
								],
								[
									13.714160156250045,
									77.91943359375011
								],
								[
									13.680566406250051,
									78.02812500000005
								],
								[
									13.717675781250051,
									78.05761718750009
								],
								[
									13.770117187500006,
									78.07460937500011
								],
								[
									13.824023437500045,
									78.08500976562499
								],
								[
									13.936914062500051,
									78.08554687500009
								],
								[
									14.04775390625008,
									78.06684570312501
								],
								[
									14.307226562500006,
									78.00507812500004
								],
								[
									14.248144531250034,
									78.07138671874998
								],
								[
									14.994726562499977,
									78.15122070312498
								],
								[
									15.341406250000006,
									78.22094726562497
								],
								[
									15.519433593750051,
									78.23271484375007
								],
								[
									15.698046875000017,
									78.22758789062507
								],
								[
									15.65869140625,
									78.2646972656251
								],
								[
									15.657128906250023,
									78.29902343749998
								],
								[
									15.783886718750011,
									78.32705078125011
								],
								[
									15.87539062500008,
									78.33911132812506
								],
								[
									16.15029296875005,
									78.35288085937495
								],
								[
									16.776953124999977,
									78.35043945312498
								],
								[
									17.00292968750003,
									78.36938476562503
								],
								[
									17.171972656250006,
									78.41713867187508
								],
								[
									16.991796875000063,
									78.40048828125006
								],
								[
									16.81123046875004,
									78.39726562500002
								],
								[
									16.72656250000003,
									78.40717773437507
								],
								[
									16.535351562500068,
									78.44887695312497
								],
								[
									16.44863281250008,
									78.503564453125
								],
								[
									16.696582031250045,
									78.61289062499998
								],
								[
									16.78261718750008,
									78.66362304687502
								],
								[
									16.53046875000004,
									78.65629882812513
								],
								[
									16.44628906250003,
									78.63852539062506
								],
								[
									16.157519531250017,
									78.5381347656251
								],
								[
									15.94404296875004,
									78.49301757812498
								],
								[
									15.680664062500028,
									78.47133789062511
								],
								[
									15.417382812500023,
									78.47324218749995
								],
								[
									15.359960937500063,
									78.48754882812503
								],
								[
									15.279394531249977,
									78.5541015625
								],
								[
									15.254199218750017,
									78.58906249999993
								],
								[
									15.264941406250074,
									78.60830078124994
								],
								[
									15.348339843750011,
									78.6631347656251
								],
								[
									15.391601562500028,
									78.72119140625011
								],
								[
									15.384179687500023,
									78.77119140624998
								],
								[
									15.322753906250028,
									78.78120117187498
								],
								[
									15.225292968750068,
									78.73232421875005
								],
								[
									15.137304687500006,
									78.66425781250004
								],
								[
									15.01630859375004,
									78.63012695312494
								],
								[
									14.891796875000068,
									78.63945312500007
								],
								[
									14.838671874999989,
									78.66557617187496
								],
								[
									14.79238281250008,
									78.70556640624994
								],
								[
									14.74355468750008,
									78.72094726562497
								],
								[
									14.689257812500017,
									78.72094726562497
								],
								[
									14.577636718750028,
									78.70498046875
								],
								[
									14.46718750000008,
									78.675390625
								],
								[
									14.505273437500023,
									78.63051757812502
								],
								[
									14.515429687500045,
									78.58056640624997
								],
								[
									14.467773437500028,
									78.54091796874997
								],
								[
									14.431835937500068,
									78.49248046874996
								],
								[
									14.545605468750068,
									78.46196289062496
								],
								[
									14.638281250000034,
									78.41459960937499
								],
								[
									14.49951171875,
									78.39238281250007
								],
								[
									14.363281250000057,
									78.35991210937496
								],
								[
									14.238281249999972,
									78.30986328125007
								],
								[
									14.110449218750063,
									78.27089843749994
								],
								[
									13.907617187500023,
									78.26674804687508
								],
								[
									13.654980468750068,
									78.2451660156251
								],
								[
									13.150195312499989,
									78.23750000000007
								],
								[
									12.91279296875004,
									78.30107421874996
								],
								[
									12.869531250000023,
									78.33124999999998
								],
								[
									12.822167968750051,
									78.35146484375011
								],
								[
									12.664648437500034,
									78.38476562500006
								],
								[
									12.434765624999983,
									78.48295898437507
								],
								[
									12.257910156250034,
									78.5946777343751
								],
								[
									12.138281249999977,
									78.60551757812499
								],
								[
									11.961718750000074,
									78.64238281250005
								],
								[
									11.865527343750017,
									78.67421875000005
								],
								[
									11.77382812500008,
									78.71640625000012
								],
								[
									11.746289062500068,
									78.76625976562497
								],
								[
									11.755175781250017,
									78.81166992187505
								],
								[
									11.861035156249983,
									78.831884765625
								],
								[
									11.61103515625004,
									78.88295898437494
								],
								[
									11.365429687500011,
									78.95039062500007
								],
								[
									11.456152343750034,
									78.97299804687498
								],
								[
									11.547558593749983,
									78.98295898437496
								],
								[
									12.274902343750028,
									78.90449218750007
								],
								[
									12.32343750000004,
									78.91425781250001
								],
								[
									12.403320312499972,
									78.95322265624995
								],
								[
									12.375,
									78.96635742187496
								],
								[
									12.25312500000004,
									78.97534179687511
								],
								[
									12.08730468750008,
									78.97509765625006
								],
								[
									12.04580078125008,
									78.983154296875
								],
								[
									11.981835937499994,
									79.02529296875005
								],
								[
									11.925683593750023,
									79.07724609375009
								],
								[
									11.901953124999977,
									79.1118652343751
								],
								[
									11.892773437500068,
									79.15234375000011
								],
								[
									12.016113281250057,
									79.21308593749995
								],
								[
									12.083984375000028,
									79.26752929687504
								],
								[
									11.978320312499989,
									79.29267578125001
								],
								[
									11.679296875000006,
									79.29116210937497
								],
								[
									11.579785156250068,
									79.28349609375007
								],
								[
									11.616406250000068,
									79.20527343749995
								],
								[
									11.52119140625004,
									79.15126953124997
								],
								[
									11.338867187500028,
									79.109130859375
								],
								[
									11.208105468750034,
									79.129638671875
								],
								[
									11.107226562500074,
									79.2329589843751
								],
								[
									10.975390625000045,
									79.30488281250001
								],
								[
									10.925781250000057,
									79.35019531250009
								],
								[
									10.888085937500023,
									79.41542968749997
								],
								[
									10.834374999999994,
									79.46284179687504
								],
								[
									10.737597656250017,
									79.52016601562508
								],
								[
									10.725000000000023,
									79.55551757812509
								],
								[
									10.737011718750068,
									79.58164062500006
								],
								[
									10.810742187500068,
									79.64091796874999
								],
								[
									10.754589843750011,
									79.69033203125002
								],
								[
									10.686230468750011,
									79.73359375000004
								],
								[
									10.682128906249972,
									79.7582519531251
								],
								[
									10.746386718750017,
									79.78867187499998
								],
								[
									10.804003906250045,
									79.79877929687507
								],
								[
									10.86591796875004,
									79.79658203124998
								],
								[
									11.049609375000074,
									79.76030273437505
								],
								[
									11.150390625,
									79.71699218750004
								],
								[
									11.185253906249983,
									79.72045898437503
								],
								[
									11.250585937500063,
									79.7848632812501
								],
								[
									11.343652343750023,
									79.79941406249995
								],
								[
									11.702343749999983,
									79.82060546875007
								],
								[
									12.101757812500011,
									79.73754882812503
								],
								[
									12.205175781250034,
									79.719091796875
								],
								[
									12.287792968750068,
									79.71313476562503
								],
								[
									12.245214843750006,
									79.75
								],
								[
									12.219140625000023,
									79.79790039062499
								],
								[
									12.279980468749983,
									79.81596679687513
								],
								[
									12.602441406250051,
									79.77324218750013
								],
								[
									12.753515625000006,
									79.77578125000002
								],
								[
									13.107519531250006,
									79.83173828124995
								],
								[
									13.692871093749972,
									79.86098632812497
								],
								[
									13.914160156250034,
									79.81694335937496
								],
								[
									13.92568359375008,
									79.79340820312504
								],
								[
									13.921093750000011,
									79.76171875000009
								],
								[
									13.907031249999989,
									79.752197265625
								],
								[
									13.777539062499983,
									79.71528320312504
								],
								[
									13.03925781250004,
									79.68515625000003
								],
								[
									12.55537109375004,
									79.569482421875
								],
								[
									13.215136718749989,
									79.58808593750007
								],
								[
									13.333789062500017,
									79.57480468750009
								],
								[
									13.383593750000017,
									79.48076171875005
								],
								[
									13.431640625000057,
									79.47089843749998
								],
								[
									13.601269531250068,
									79.45722656249995
								],
								[
									13.716210937500023,
									79.42915039062501
								],
								[
									13.833691406250068,
									79.37568359374995
								],
								[
									13.957226562500011,
									79.33964843750007
								],
								[
									14.029589843750017,
									79.34414062500011
								],
								[
									14.05585937500004,
									79.38310546875005
								],
								[
									14.026367187500057,
									79.42929687499995
								],
								[
									14.01113281250008,
									79.48193359375011
								],
								[
									14.019824218750074,
									79.53867187500003
								],
								[
									14.039843750000045,
									79.58564453125001
								],
								[
									14.17841796875004,
									79.61870117187499
								],
								[
									14.379785156250023,
									79.7259765625
								],
								[
									14.59365234375008,
									79.79873046875008
								],
								[
									14.831835937500017,
									79.76640625000005
								],
								[
									15.052343750000006,
									79.67534179687507
								],
								[
									15.251269531250017,
									79.54545898437499
								],
								[
									15.443945312500034,
									79.40678710937507
								],
								[
									15.660156250000028,
									79.23486328124994
								],
								[
									15.764062500000051,
									79.17426757812495
								],
								[
									15.858496093750006,
									79.15991210937506
								],
								[
									16.294531250000034,
									78.98105468750012
								],
								[
									16.34375000000003,
									78.97612304687499
								],
								[
									16.253515625000034,
									79.11210937499999
								],
								[
									16.027539062499983,
									79.3423828125
								],
								[
									15.875097656250034,
									79.51923828125007
								],
								[
									15.840722656250023,
									79.58686523437498
								],
								[
									15.816113281249983,
									79.68183593750007
								],
								[
									15.825781250000006,
									79.7090332031251
								],
								[
									15.845117187500051,
									79.73359375000004
								],
								[
									15.955761718750011,
									79.83510742187494
								],
								[
									16.100195312500063,
									79.88442382812494
								],
								[
									16.056640625000057,
									79.95395507812506
								],
								[
									16.093847656250006,
									80.00732421875003
								],
								[
									16.245703125000034,
									80.049462890625
								],
								[
									16.38662109375005,
									80.052587890625
								],
								[
									16.524023437500063,
									80.02050781250006
								],
								[
									16.786718750000034,
									79.90673828125006
								]
							]
						],
						[
							[
								[
									32.525976562500034,
									80.11914062499997
								],
								[
									31.577636718750114,
									80.08144531249994
								],
								[
									31.481933593749943,
									80.10791015625
								],
								[
									33.019140625000034,
									80.21796874999995
								],
								[
									33.0986328125,
									80.22871093750001
								],
								[
									33.38398437500001,
									80.24233398437494
								],
								[
									33.62929687500002,
									80.21743164062502
								],
								[
									33.55664062499994,
									80.19814453125
								],
								[
									32.525976562500034,
									80.11914062499997
								]
							]
						],
						[
							[
								[
									18.741601562500023,
									80.30092773437505
								],
								[
									18.525000000000034,
									80.24560546875009
								],
								[
									18.162207031250034,
									80.28818359374995
								],
								[
									18.20556640624997,
									80.33178710937506
								],
								[
									18.29169921875004,
									80.35834960937495
								],
								[
									18.519335937500045,
									80.34833984374995
								],
								[
									18.741601562500023,
									80.30092773437505
								]
							]
						],
						[
							[
								[
									20.897851562500023,
									80.24995117187498
								],
								[
									20.99843750000008,
									80.23881835937502
								],
								[
									21.549218750000023,
									80.24291992187497
								],
								[
									21.654882812500063,
									80.21845703124995
								],
								[
									21.69667968750005,
									80.15917968750006
								],
								[
									21.780664062500023,
									80.13876953124998
								],
								[
									21.897753906250074,
									80.13247070312494
								],
								[
									22.190234375000045,
									80.05971679687505
								],
								[
									22.289746093749983,
									80.04921874999994
								],
								[
									22.37636718750005,
									80.0896484375001
								],
								[
									22.442675781250074,
									80.19028320312509
								],
								[
									22.44619140625008,
									80.30834960937497
								],
								[
									22.41787109375008,
									80.36552734374999
								],
								[
									22.450781250000034,
									80.40224609375011
								],
								[
									22.54882812500003,
									80.41645507812507
								],
								[
									22.672070312499983,
									80.41264648437507
								],
								[
									22.792578125000034,
									80.43300781249997
								],
								[
									22.89687500000005,
									80.46899414062503
								],
								[
									23.00800781250004,
									80.47397460937506
								],
								[
									23.25136718750005,
									80.44667968750008
								],
								[
									23.315429687500057,
									80.42524414062498
								],
								[
									23.250097656250063,
									80.380859375
								],
								[
									23.22460937500003,
									80.317626953125
								],
								[
									23.114550781250074,
									80.18696289062504
								],
								[
									23.353320312500045,
									80.17885742187505
								],
								[
									23.68798828125,
									80.20654296875003
								],
								[
									23.77294921875,
									80.244384765625
								],
								[
									23.952929687500074,
									80.30458984375011
								],
								[
									24.14296875000008,
									80.29516601562506
								],
								[
									24.234082031250068,
									80.30312500000008
								],
								[
									24.28017578125005,
									80.32929687499998
								],
								[
									24.29755859375004,
									80.36040039062502
								],
								[
									24.402636718750045,
									80.35517578124993
								],
								[
									24.546679687500074,
									80.29516601562506
								],
								[
									24.61367187500005,
									80.28583984374993
								],
								[
									24.73632812499997,
									80.30131835937496
								],
								[
									24.785937500000045,
									80.30068359375002
								],
								[
									24.907031250000017,
									80.2766601562501
								],
								[
									25.471289062500063,
									80.23310546874993
								],
								[
									25.666894531250023,
									80.20976562499996
								],
								[
									25.75117187500004,
									80.18803710937507
								],
								[
									25.83632812500008,
									80.17514648437512
								],
								[
									26.43671875000001,
									80.1754882812501
								],
								[
									26.86083984375,
									80.16000976562495
								],
								[
									27.017187500000034,
									80.12548828124994
								],
								[
									27.148339843750023,
									80.05922851562494
								],
								[
									27.19863281250005,
									79.90659179687512
								],
								[
									27.079882812500017,
									79.86538085937497
								],
								[
									26.22109375000005,
									79.67744140625004
								],
								[
									26.00585937499997,
									79.617041015625
								],
								[
									25.902050781250068,
									79.56137695312495
								],
								[
									25.726367187500074,
									79.43974609375013
								],
								[
									25.641210937500034,
									79.40302734374993
								],
								[
									25.23906249999999,
									79.34506835937512
								],
								[
									25.145117187500034,
									79.3388671875
								],
								[
									24.842871093750006,
									79.3672363281251
								],
								[
									24.750585937500034,
									79.364599609375
								],
								[
									24.383398437500034,
									79.30161132812503
								],
								[
									24.2568359375,
									79.2634765625001
								],
								[
									24.132910156250063,
									79.215478515625
								],
								[
									23.94775390625,
									79.19428710937504
								],
								[
									23.758789062500057,
									79.20561523437513
								],
								[
									22.903710937500023,
									79.23066406249998
								],
								[
									22.789160156250034,
									79.26435546875001
								],
								[
									22.695703124999994,
									79.32905273437495
								],
								[
									22.865527343750045,
									79.41186523437494
								],
								[
									21.911425781250017,
									79.38105468749998
								],
								[
									20.86113281249999,
									79.39785156249994
								],
								[
									20.80556640625005,
									79.409521484375
								],
								[
									20.760839843750006,
									79.44150390624995
								],
								[
									20.399511718750006,
									79.46337890625006
								],
								[
									20.128222656250074,
									79.48959960937498
								],
								[
									19.900195312500074,
									79.5337890625
								],
								[
									19.674609375000045,
									79.59116210937498
								],
								[
									19.746679687500063,
									79.61796875000002
								],
								[
									19.821093750000045,
									79.633642578125
								],
								[
									20.014843750000068,
									79.64023437500012
								],
								[
									20.187109375000006,
									79.6322753906251
								],
								[
									20.493457031250045,
									79.63276367187493
								],
								[
									20.564843750000023,
									79.69052734375006
								],
								[
									20.686816406250017,
									79.70717773437508
								],
								[
									20.784082031250023,
									79.74858398437507
								],
								[
									20.460742187500045,
									79.77465820312506
								],
								[
									20.12343750000008,
									79.77856445312506
								],
								[
									19.89863281250001,
									79.74418945312507
								],
								[
									19.63808593750005,
									79.72861328125009
								],
								[
									19.400000000000034,
									79.72656250000003
								],
								[
									18.94208984375001,
									79.73632812499997
								],
								[
									18.725000000000023,
									79.76074218749997
								],
								[
									18.428027343750017,
									79.82451171874999
								],
								[
									18.32470703125,
									79.85971679687498
								],
								[
									18.284765625000034,
									79.88735351562511
								],
								[
									18.25537109375,
									79.92919921875
								],
								[
									18.594628906250023,
									79.96669921875011
								],
								[
									18.72646484375005,
									79.99624023437508
								],
								[
									18.855957031250057,
									80.03662109375003
								],
								[
									18.343847656250006,
									80.05957031250009
								],
								[
									18.129492187500034,
									80.09340820312505
								],
								[
									17.91689453125005,
									80.14311523437507
								],
								[
									18.089453125000034,
									80.171142578125
								],
								[
									18.77929687499997,
									80.19350585937494
								],
								[
									18.961914062500057,
									80.17480468749994
								],
								[
									19.14296875000008,
									80.13867187500006
								],
								[
									19.343359375000063,
									80.11640624999995
								],
								[
									19.537109375,
									80.163232421875
								],
								[
									19.35468750000004,
									80.18540039062498
								],
								[
									19.19140625,
									80.26323242187502
								],
								[
									19.15693359375001,
									80.30185546875006
								],
								[
									19.178320312500006,
									80.33154296875
								],
								[
									19.263769531250006,
									80.33598632812502
								],
								[
									19.327441406250017,
									80.32309570312506
								],
								[
									19.568457031250006,
									80.25000000000009
								],
								[
									19.751074218749977,
									80.22719726562497
								],
								[
									19.80224609375003,
									80.29472656249996
								],
								[
									19.810351562500074,
									80.32680664062511
								],
								[
									19.777148437500045,
									80.353369140625
								],
								[
									19.69130859375005,
									80.40234374999994
								],
								[
									19.614355468750006,
									80.46254882812505
								],
								[
									19.733300781249994,
									80.47783203124996
								],
								[
									19.851171875000034,
									80.47119140625003
								],
								[
									20.10429687499999,
									80.42998046875007
								],
								[
									20.359375,
									80.4009277343751
								],
								[
									20.475878906250017,
									80.37163085937499
								],
								[
									20.693457031250034,
									80.29868164062506
								],
								[
									20.897851562500023,
									80.24995117187498
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "NOR",
					"su_a3": "NOR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "NOR",
					"gu_a3": "NOR",
					"abbrev": "Nor.",
					"region_un": "Europe",
					"adm0_a3_us": "NOR",
					"scalerank": 1,
					"pop_est": 4676305,
					"adm0_dif": 0,
					"un_a3": "578",
					"pop_year": -99,
					"gdp_md_est": 276400,
					"name": "Norway",
					"sovereignt": "Norway",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Norway",
					"postal": "N",
					"sov_a3": "NOR",
					"note_brk": "",
					"brk_a3": "NOR",
					"wb_a2": "NO",
					"brk_diff": 0,
					"admin": "Norway",
					"name_long": "Norway",
					"iso_a3": "NOR",
					"iso_a2": "NO",
					"adm0_a3_is": "NOR",
					"level": 2,
					"formal_en": "Kingdom of Norway",
					"name_len": 6,
					"mapcolor7": 5,
					"long_len": 6,
					"mapcolor8": 3,
					"mapcolor9": 8,
					"note_adm0": "",
					"iso_n3": "578",
					"homepart": 1,
					"subunit": "Norway",
					"name_alt": "",
					"brk_name": "Norway",
					"name_sort": "Norway",
					"continent": "Europe",
					"mapcolor13": 12,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									169.17822265625,
									-52.49726562500004
								],
								[
									169.23349609375003,
									-52.54824218750003
								],
								[
									169.12753906250003,
									-52.5703125
								],
								[
									169.07597656250005,
									-52.551855468750055
								],
								[
									169.03984375000005,
									-52.52851562500001
								],
								[
									169.02177734375,
									-52.49541015625002
								],
								[
									169.07910156249994,
									-52.49882812500009
								],
								[
									169.12861328125018,
									-52.48515625000006
								],
								[
									169.17822265625,
									-52.49726562500004
								]
							]
						],
						[
							[
								[
									166.22109374999997,
									-50.7615234375
								],
								[
									166.24287109375018,
									-50.845703125000014
								],
								[
									166.18789062499997,
									-50.84609375
								],
								[
									166.0732421875,
									-50.82265625000002
								],
								[
									166.0376953125002,
									-50.78671875000008
								],
								[
									166.0132812500002,
									-50.77792968750006
								],
								[
									165.97138671875018,
									-50.81953125000001
								],
								[
									165.90410156250016,
									-50.821484375000054
								],
								[
									165.88916015624994,
									-50.80771484375
								],
								[
									165.9156250000002,
									-50.76308593750006
								],
								[
									166.0738281250002,
									-50.67900390625007
								],
								[
									166.1031250000002,
									-50.57304687500007
								],
								[
									166.10136718750005,
									-50.53896484375005
								],
								[
									166.2250976562501,
									-50.53095703125002
								],
								[
									166.25429687500002,
									-50.5439453125
								],
								[
									166.26748046875014,
									-50.55859375000005
								],
								[
									166.25937500000003,
									-50.577246093750034
								],
								[
									166.2095703125002,
									-50.61201171875001
								],
								[
									166.2076171875001,
									-50.65244140625008
								],
								[
									166.22041015625,
									-50.69433593749999
								],
								[
									166.17949218750005,
									-50.714648437500045
								],
								[
									166.2007812500002,
									-50.75087890625006
								],
								[
									166.22109374999997,
									-50.7615234375
								]
							]
						],
						[
							[
								[
									168.14492187500014,
									-46.862207031249994
								],
								[
									168.14531250000016,
									-46.902148437500045
								],
								[
									168.0410156250001,
									-46.88779296875006
								],
								[
									168.0431640625,
									-46.93261718749996
								],
								[
									168.1254882812501,
									-46.956152343750034
								],
								[
									168.15595703125018,
									-46.98828124999993
								],
								[
									168.24140625000018,
									-46.979003906249986
								],
								[
									168.26064453125002,
									-47.02705078125001
								],
								[
									168.24091796875018,
									-47.070019531250054
								],
								[
									168.18388671875,
									-47.101562499999915
								],
								[
									168.01503906249997,
									-47.11748046874996
								],
								[
									167.90556640625016,
									-47.179882812500054
								],
								[
									167.81074218750018,
									-47.170410156249986
								],
								[
									167.7849609375,
									-47.176074218750074
								],
								[
									167.6763671875001,
									-47.242968749999946
								],
								[
									167.5548828125,
									-47.26367187500007
								],
								[
									167.52197265625,
									-47.25869140624995
								],
								[
									167.53876953125,
									-47.199023437500045
								],
								[
									167.6290039062502,
									-47.14228515625004
								],
								[
									167.6309570312501,
									-47.08779296874995
								],
								[
									167.65410156250016,
									-47.04423828124996
								],
								[
									167.74091796875018,
									-47.01357421875001
								],
								[
									167.74199218750005,
									-46.95683593750009
								],
								[
									167.8007812500001,
									-46.906542968749974
								],
								[
									167.7652343750001,
									-46.797656250000074
								],
								[
									167.78398437500016,
									-46.699804687500034
								],
								[
									167.95576171875018,
									-46.694433593750006
								],
								[
									168.14492187500014,
									-46.862207031249994
								]
							]
						],
						[
							[
								[
									166.74628906250007,
									-45.65585937500008
								],
								[
									166.74101562500005,
									-45.704980468749966
								],
								[
									166.72919921875,
									-45.729687500000026
								],
								[
									166.69453125000018,
									-45.729882812500065
								],
								[
									166.64248046875014,
									-45.72441406250002
								],
								[
									166.59169921874997,
									-45.70175781250002
								],
								[
									166.5591796875002,
									-45.70820312500008
								],
								[
									166.53203125,
									-45.69980468749998
								],
								[
									166.56708984375007,
									-45.644433593750065
								],
								[
									166.6856445312502,
									-45.61503906250002
								],
								[
									166.73144531249994,
									-45.63867187499996
								],
								[
									166.74628906250007,
									-45.65585937500008
								]
							]
						],
						[
							[
								[
									166.97949218749994,
									-45.17968750000006
								],
								[
									167.02265625,
									-45.299804687500014
								],
								[
									166.93115234374994,
									-45.27685546875004
								],
								[
									166.8926757812502,
									-45.24052734375002
								],
								[
									166.96269531250016,
									-45.180371093750026
								],
								[
									166.97949218749994,
									-45.17968750000006
								]
							]
						],
						[
							[
								[
									-176.17646484374998,
									-44.32167968750005
								],
								[
									-176.22080078124998,
									-44.330566406249915
								],
								[
									-176.21459960937503,
									-44.27353515625002
								],
								[
									-176.22929687500002,
									-44.23671874999998
								],
								[
									-176.1546875,
									-44.22451171874998
								],
								[
									-176.12255859375003,
									-44.26845703125005
								],
								[
									-176.17646484374998,
									-44.32167968750005
								]
							]
						],
						[
							[
								[
									-176.17763671874997,
									-43.740332031250006
								],
								[
									-176.213525390625,
									-43.76630859375007
								],
								[
									-176.27485351562507,
									-43.764843750000026
								],
								[
									-176.38173828124997,
									-43.866796874999935
								],
								[
									-176.375244140625,
									-43.79062500000005
								],
								[
									-176.40737304687497,
									-43.76093750000004
								],
								[
									-176.49912109375,
									-43.76806640625007
								],
								[
									-176.516552734375,
									-43.78476562499992
								],
								[
									-176.45493164062498,
									-43.80488281250001
								],
								[
									-176.44125976562503,
									-43.81611328125008
								],
								[
									-176.50014648437502,
									-43.86015625
								],
								[
									-176.43911132812502,
									-43.95468750000008
								],
								[
									-176.38544921875,
									-43.95146484375003
								],
								[
									-176.33359375000003,
									-44.025292968750065
								],
								[
									-176.33383789062498,
									-44.04843749999999
								],
								[
									-176.45278320312497,
									-44.07685546875
								],
								[
									-176.51552734374997,
									-44.11660156250002
								],
								[
									-176.571533203125,
									-44.11494140625004
								],
								[
									-176.59799804687498,
									-44.10722656250006
								],
								[
									-176.62934570312498,
									-44.03613281249997
								],
								[
									-176.63154296874998,
									-44.00624999999992
								],
								[
									-176.562744140625,
									-43.95410156249996
								],
								[
									-176.52377929687498,
									-43.90097656250005
								],
								[
									-176.55512695312504,
									-43.85195312500001
								],
								[
									-176.6345703125,
									-43.82021484375004
								],
								[
									-176.80795898437503,
									-43.83457031250002
								],
								[
									-176.84765625000006,
									-43.82392578125008
								],
								[
									-176.76108398437498,
									-43.757910156250034
								],
								[
									-176.66723632812497,
									-43.76513671875
								],
								[
									-176.56611328124995,
									-43.71757812500009
								],
								[
									-176.17763671874997,
									-43.740332031250006
								]
							]
						],
						[
							[
								[
									173.91464843750026,
									-40.863671875000065
								],
								[
									173.7808593750002,
									-40.92177734375001
								],
								[
									173.7862304687502,
									-40.88144531249996
								],
								[
									173.81240234375002,
									-40.79365234375001
								],
								[
									173.87333984375022,
									-40.749316406250045
								],
								[
									173.9033203125001,
									-40.74628906250004
								],
								[
									173.9644531250001,
									-40.712988281250006
								],
								[
									173.95800781250006,
									-40.78681640625004
								],
								[
									173.91464843750026,
									-40.863671875000065
								]
							]
						],
						[
							[
								[
									173.11533203125003,
									-41.279296875000014
								],
								[
									173.23085937500002,
									-41.28417968749994
								],
								[
									173.33779296875014,
									-41.21093749999994
								],
								[
									173.4472656249999,
									-41.15136718750006
								],
								[
									173.5625000000001,
									-41.10205078125004
								],
								[
									173.73789062500015,
									-40.98896484375001
								],
								[
									173.78378906250026,
									-40.97236328125001
								],
								[
									173.89755859375015,
									-40.95078125000005
								],
								[
									173.94716796875014,
									-40.92412109375003
								],
								[
									174.00244140625006,
									-40.917773437500074
								],
								[
									173.95283203125024,
									-40.98486328125007
								],
								[
									173.88984375000018,
									-41.00722656250001
								],
								[
									173.8798828125001,
									-41.03144531249997
								],
								[
									173.9151367187502,
									-41.07011718750003
								],
								[
									173.86035156250006,
									-41.12441406249998
								],
								[
									173.8624023437501,
									-41.19208984375001
								],
								[
									173.7978515625001,
									-41.27197265624994
								],
								[
									173.89707031250026,
									-41.23935546875005
								],
								[
									173.93339843750016,
									-41.1873046875
								],
								[
									173.91464843750026,
									-41.158007812500074
								],
								[
									173.95761718750015,
									-41.09990234375006
								],
								[
									174.02402343749998,
									-41.072265625000014
								],
								[
									173.9975585937501,
									-41.028125
								],
								[
									173.99941406250014,
									-40.993261718750006
								],
								[
									174.0805664062501,
									-41.006152343750045
								],
								[
									174.12119140625026,
									-41.00468750000002
								],
								[
									174.1532226562502,
									-40.990917968750054
								],
								[
									174.21181640625008,
									-40.985449218750006
								],
								[
									174.22382812500018,
									-41.02441406249996
								],
								[
									174.30253906250005,
									-41.01953125000003
								],
								[
									174.2739257812501,
									-41.06875000000001
								],
								[
									174.2136718750001,
									-41.12558593749996
								],
								[
									174.19951171875022,
									-41.16015625000007
								],
								[
									174.1031250000001,
									-41.217382812500006
								],
								[
									174.0385742187501,
									-41.241894531250026
								],
								[
									174.13808593750014,
									-41.24824218750008
								],
								[
									174.28359375000014,
									-41.17158203125
								],
								[
									174.37011718750017,
									-41.103710937500026
								],
								[
									174.3675781250002,
									-41.188378906249966
								],
								[
									174.29726562500008,
									-41.26425781250005
								],
								[
									174.23710937500005,
									-41.31220703124997
								],
								[
									174.16953125000015,
									-41.32705078125005
								],
								[
									174.1020507812499,
									-41.36591796875007
								],
								[
									174.06933593750017,
									-41.42949218750006
								],
								[
									174.07294921875018,
									-41.47167968750003
								],
								[
									174.09238281250026,
									-41.50517578125002
								],
								[
									174.16113281250006,
									-41.56181640625002
								],
								[
									174.08369140625024,
									-41.67080078125001
								],
								[
									174.16992187500006,
									-41.657226562499915
								],
								[
									174.21708984375005,
									-41.677734375
								],
								[
									174.2831054687502,
									-41.74062500000002
								],
								[
									174.24335937500007,
									-41.81308593750005
								],
								[
									174.21542968750026,
									-41.85019531250005
								],
								[
									174.0472656249999,
									-42.00302734375002
								],
								[
									173.9739257812501,
									-42.08056640625
								],
								[
									173.88798828125016,
									-42.13017578124999
								],
								[
									173.88916015625006,
									-42.211621093750054
								],
								[
									173.8398437500001,
									-42.27089843750005
								],
								[
									173.58925781250008,
									-42.47392578125003
								],
								[
									173.54511718750013,
									-42.51796875000002
								],
								[
									173.3475585937502,
									-42.840820312499986
								],
								[
									173.22119140625006,
									-42.976562500000014
								],
								[
									173.14882812500014,
									-43.02275390624993
								],
								[
									173.0723632812502,
									-43.06025390625001
								],
								[
									172.88886718750018,
									-43.12421875
								],
								[
									172.80800781250014,
									-43.19775390625006
								],
								[
									172.71855468750005,
									-43.25878906250006
								],
								[
									172.62402343749994,
									-43.2724609375
								],
								[
									172.6269531250001,
									-43.29951171875
								],
								[
									172.6875000000001,
									-43.31464843750007
								],
								[
									172.73476562500014,
									-43.354785156250074
								],
								[
									172.6997070312501,
									-43.39970703124999
								],
								[
									172.63222656250014,
									-43.427929687500054
								],
								[
									172.56220703125018,
									-43.43603515624993
								],
								[
									172.52666015625005,
									-43.464746093749994
								],
								[
									172.6934570312501,
									-43.444335937500014
								],
								[
									172.74042968750007,
									-43.46787109375002
								],
								[
									172.74921875000018,
									-43.51728515625004
								],
								[
									172.76660156249994,
									-43.561914062499994
								],
								[
									172.80703125000014,
									-43.62099609374995
								],
								[
									172.9472656250001,
									-43.65859375000005
								],
								[
									173.0732421875001,
									-43.676171874999994
								],
								[
									173.09804687499997,
									-43.703515625000065
								],
								[
									173.11689453125018,
									-43.7978515625
								],
								[
									173.09394531250007,
									-43.84414062499994
								],
								[
									173.06562500000007,
									-43.874609375000006
								],
								[
									173.02333984375014,
									-43.88544921875
								],
								[
									172.92060546875018,
									-43.891406249999974
								],
								[
									172.81767578125016,
									-43.87011718750007
								],
								[
									172.74931640625,
									-43.813085937500006
								],
								[
									172.55468749999994,
									-43.831347656250074
								],
								[
									172.50273437500005,
									-43.84365234375001
								],
								[
									172.47597656250002,
									-43.83339843750005
								],
								[
									172.58378906250005,
									-43.77353515625002
								],
								[
									172.52724609375014,
									-43.739453124999926
								],
								[
									172.48037109375002,
									-43.72666015625006
								],
								[
									172.4296875,
									-43.74648437499994
								],
								[
									172.39560546875003,
									-43.77783203124993
								],
								[
									172.38525390625,
									-43.829589843749986
								],
								[
									172.350390625,
									-43.859375000000014
								],
								[
									172.29658203125007,
									-43.867871093750054
								],
								[
									172.22070312499994,
									-43.824999999999946
								],
								[
									172.14580078125016,
									-43.76357421875004
								],
								[
									172.03554687499997,
									-43.70175781250006
								],
								[
									172.0522460937501,
									-43.740039062500045
								],
								[
									172.1372070312501,
									-43.83378906249996
								],
								[
									172.17978515625003,
									-43.895996093750014
								],
								[
									172.08076171875007,
									-43.94560546875
								],
								[
									171.9776367187501,
									-43.984277343750065
								],
								[
									171.8906250000001,
									-44.00693359375006
								],
								[
									171.80839843750016,
									-44.04228515625006
								],
								[
									171.71201171875003,
									-44.09746093750003
								],
								[
									171.658984375,
									-44.11718750000004
								],
								[
									171.51777343750018,
									-44.118359375000026
								],
								[
									171.44257812500007,
									-44.135839843750034
								],
								[
									171.4174804687501,
									-44.208691406249955
								],
								[
									171.36455078125016,
									-44.25498046875005
								],
								[
									171.24072265624994,
									-44.26416015625006
								],
								[
									171.28535156250018,
									-44.27871093750001
								],
								[
									171.31298828124994,
									-44.301855468750006
								],
								[
									171.23105468750003,
									-44.521191406250026
								],
								[
									171.2130859375,
									-44.612207031249994
								],
								[
									171.1978515625002,
									-44.76787109375
								],
								[
									171.1462890625,
									-44.912304687500026
								],
								[
									170.9990234375001,
									-44.911425781249946
								],
								[
									171.02285156249997,
									-44.93701171875
								],
								[
									171.13417968750014,
									-44.977734374999955
								],
								[
									171.1132812500001,
									-45.039257812500054
								],
								[
									170.9907226562501,
									-45.15146484374999
								],
								[
									170.93964843750018,
									-45.21640625000008
								],
								[
									170.88994140625,
									-45.37392578125002
								],
								[
									170.81523437500016,
									-45.51914062500002
								],
								[
									170.70058593749997,
									-45.68427734375001
								],
								[
									170.69970703125,
									-45.71396484375002
								],
								[
									170.7398437500001,
									-45.75605468750007
								],
								[
									170.78847656250014,
									-45.79248046875003
								],
								[
									170.79121093750007,
									-45.843847656250006
								],
								[
									170.77626953125014,
									-45.87089843750002
								],
								[
									170.7217773437502,
									-45.87802734375005
								],
								[
									170.67421875000014,
									-45.895703125
								],
								[
									170.41914062500018,
									-45.94101562499999
								],
								[
									170.3354492187501,
									-45.991796875000034
								],
								[
									170.26679687500007,
									-46.08261718750006
								],
								[
									170.18613281250003,
									-46.16083984375001
								],
								[
									169.91826171875005,
									-46.33437499999994
								],
								[
									169.7607421875,
									-46.479785156250074
								],
								[
									169.7291015625002,
									-46.52138671875002
								],
								[
									169.6866210937501,
									-46.55166015625005
								],
								[
									169.3422851562501,
									-46.620507812499966
								],
								[
									169.0986328125001,
									-46.630664062500074
								],
								[
									168.96582031249994,
									-46.612988281250026
								],
								[
									168.83779296874997,
									-46.57822265625005
								],
								[
									168.76679687500018,
									-46.56630859374994
								],
								[
									168.63144531250003,
									-46.58759765625001
								],
								[
									168.572265625,
									-46.61103515625007
								],
								[
									168.4664062500002,
									-46.58789062500007
								],
								[
									168.38212890625016,
									-46.60537109374998
								],
								[
									168.35722656250016,
									-46.588378906249986
								],
								[
									168.3256835937501,
									-46.545703125
								],
								[
									168.34306640625,
									-46.4890625
								],
								[
									168.31972656250014,
									-46.447167968749994
								],
								[
									168.2662109375001,
									-46.418750000000074
								],
								[
									168.23027343750005,
									-46.3857421875
								],
								[
									168.18916015625018,
									-46.36220703124992
								],
								[
									168.07734375000007,
									-46.35292968749998
								],
								[
									167.900390625,
									-46.36777343749999
								],
								[
									167.84199218750018,
									-46.36621093750003
								],
								[
									167.72207031249997,
									-46.22714843750002
								],
								[
									167.6822265625002,
									-46.19296875000008
								],
								[
									167.53945312499997,
									-46.14853515624999
								],
								[
									167.49062499999997,
									-46.15468749999992
								],
								[
									167.41425781250007,
									-46.22890625000002
								],
								[
									167.36894531250016,
									-46.24150390625002
								],
								[
									167.10029296875007,
									-46.24941406250004
								],
								[
									166.83076171875,
									-46.22548828125004
								],
								[
									166.73154296875003,
									-46.197851562500006
								],
								[
									166.71210937500018,
									-46.13369140624991
								],
								[
									166.91669921875,
									-45.95722656250001
								],
								[
									166.8564453125001,
									-45.98085937500004
								],
								[
									166.73027343750016,
									-46.052734375000014
								],
								[
									166.64990234374994,
									-46.04169921875
								],
								[
									166.72695312500002,
									-45.96328125000001
								],
								[
									166.73378906249997,
									-45.92832031249999
								],
								[
									166.71796875000007,
									-45.88935546875004
								],
								[
									166.61269531250002,
									-45.955371093750074
								],
								[
									166.4931640625,
									-45.96386718750003
								],
								[
									166.4776367187502,
									-45.90273437500001
								],
								[
									166.48828125,
									-45.831835937500045
								],
								[
									166.51289062500018,
									-45.81171875000004
								],
								[
									166.8360351562502,
									-45.77451171874992
								],
								[
									166.95253906250014,
									-45.75019531249994
								],
								[
									167.00332031250002,
									-45.712109375
								],
								[
									166.80996093750014,
									-45.699023437500074
								],
								[
									166.79765625000005,
									-45.64560546874995
								],
								[
									166.82558593750014,
									-45.60283203125002
								],
								[
									166.9908203125002,
									-45.531738281250014
								],
								[
									166.86904296875002,
									-45.54990234374999
								],
								[
									166.7339843750002,
									-45.54355468750002
								],
								[
									166.74306640625002,
									-45.46845703125
								],
								[
									166.7783203125001,
									-45.409667968750014
								],
								[
									166.919921875,
									-45.40791015625001
								],
								[
									166.8755859375002,
									-45.36757812500005
								],
								[
									166.86923828125003,
									-45.31123046875004
								],
								[
									166.90859374999997,
									-45.307421874999974
								],
								[
									167.05214843750002,
									-45.38320312500004
								],
								[
									167.15566406250014,
									-45.4109375
								],
								[
									167.11210937500016,
									-45.35390625000002
								],
								[
									167.11777343750003,
									-45.31796874999999
								],
								[
									167.14531250000016,
									-45.30185546875008
								],
								[
									167.2300781250002,
									-45.290332031250045
								],
								[
									167.20683593750016,
									-45.28027343750003
								],
								[
									167.12734375000014,
									-45.265820312500026
								],
								[
									167.0328125000001,
									-45.222460937500074
								],
								[
									167.02265625,
									-45.17666015624998
								],
								[
									167.02587890625,
									-45.123632812500006
								],
								[
									167.1279296875,
									-45.050781249999915
								],
								[
									167.18818359375018,
									-45.09414062500004
								],
								[
									167.25947265625007,
									-45.082226562499926
								],
								[
									167.205078125,
									-45.04814453125009
								],
								[
									167.171875,
									-44.997070312499986
								],
								[
									167.19453125000007,
									-44.96347656250006
								],
								[
									167.41074218750003,
									-44.82792968749999
								],
								[
									167.46621093749997,
									-44.958300781250074
								],
								[
									167.47919921875007,
									-44.91503906249997
								],
								[
									167.48212890625,
									-44.87392578125002
								],
								[
									167.45625000000018,
									-44.838281249999966
								],
								[
									167.45996093749994,
									-44.802343750000006
								],
								[
									167.4849609375001,
									-44.77138671875001
								],
								[
									167.57763671874994,
									-44.740820312500006
								],
								[
									167.69814453124997,
									-44.64130859374998
								],
								[
									167.78701171874997,
									-44.595019531250045
								],
								[
									167.85937499999994,
									-44.624707031250054
								],
								[
									167.90898437500005,
									-44.66474609375004
								],
								[
									167.9015625,
									-44.62500000000003
								],
								[
									167.86640625000018,
									-44.592089843750074
								],
								[
									167.8565429687502,
									-44.50068359375001
								],
								[
									168.01835937500005,
									-44.35878906249998
								],
								[
									168.19619140625014,
									-44.22363281250006
								],
								[
									168.36660156250002,
									-44.082031249999986
								],
								[
									168.45742187500014,
									-44.030566406250074
								],
								[
									168.6509765625002,
									-43.972167968749986
								],
								[
									168.77480468750014,
									-43.996484375000065
								],
								[
									168.8064453125,
									-43.99199218750003
								],
								[
									168.99042968750018,
									-43.88994140625003
								],
								[
									169.06650390625003,
									-43.86347656249997
								],
								[
									169.13593750000018,
									-43.89990234374993
								],
								[
									169.17890625,
									-43.91308593750003
								],
								[
									169.1357421875001,
									-43.81982421874996
								],
								[
									169.1695312500001,
									-43.777050781250026
								],
								[
									169.32314453125002,
									-43.70156250000002
								],
								[
									169.5152343750001,
									-43.623632812500034
								],
								[
									169.66152343750014,
									-43.59121093749992
								],
								[
									169.76923828125,
									-43.53847656250001
								],
								[
									169.83388671874997,
									-43.537011718750065
								],
								[
									169.8240234375,
									-43.49716796874995
								],
								[
									169.8350585937502,
									-43.458984374999986
								],
								[
									169.8908203125,
									-43.46162109375007
								],
								[
									169.90800781250016,
									-43.446582031249946
								],
								[
									169.8589843750002,
									-43.42597656250001
								],
								[
									170.0175781250001,
									-43.349414062500045
								],
								[
									170.10371093750007,
									-43.26503906249991
								],
								[
									170.14882812500002,
									-43.24755859375007
								],
								[
									170.18964843750018,
									-43.22207031250004
								],
								[
									170.240234375,
									-43.163867187500074
								],
								[
									170.30000000000018,
									-43.14462890625006
								],
								[
									170.35576171875016,
									-43.153613281249946
								],
								[
									170.3960937500002,
									-43.18222656249999
								],
								[
									170.37431640625005,
									-43.134667968749994
								],
								[
									170.3028320312502,
									-43.10761718750007
								],
								[
									170.3794921875002,
									-43.066210937500074
								],
								[
									170.45869140625018,
									-43.037695312500034
								],
								[
									170.53583984375018,
									-43.05849609375001
								],
								[
									170.6118164062501,
									-43.09179687500004
								],
								[
									170.53583984375018,
									-43.04072265625004
								],
								[
									170.52363281250018,
									-43.00898437499997
								],
								[
									170.61552734375016,
									-42.97246093749999
								],
								[
									170.66542968750002,
									-42.96123046875
								],
								[
									170.73525390625014,
									-43.02978515624994
								],
								[
									170.72529296875,
									-42.975488281250065
								],
								[
									170.74160156249997,
									-42.927343750000034
								],
								[
									170.8403320312501,
									-42.848632812499986
								],
								[
									170.96992187500007,
									-42.71835937499999
								],
								[
									171.01142578125007,
									-42.763671874999986
								],
								[
									171.0177734375,
									-42.81874999999994
								],
								[
									171.0117187500001,
									-42.885058593749946
								],
								[
									171.03837890625016,
									-42.86210937500006
								],
								[
									171.04755859375007,
									-42.80185546875005
								],
								[
									171.02773437500002,
									-42.696093750000074
								],
								[
									171.1895507812502,
									-42.500488281250014
								],
								[
									171.2212890625002,
									-42.47861328124992
								],
								[
									171.25703125000018,
									-42.46533203125006
								],
								[
									171.31337890625014,
									-42.46015625000007
								],
								[
									171.29609375000007,
									-42.43056640624998
								],
								[
									171.25224609375,
									-42.401953124999935
								],
								[
									171.29648437500003,
									-42.30253906249993
								],
								[
									171.32265625000014,
									-42.18906250000008
								],
								[
									171.36025390624997,
									-42.079980468750065
								],
								[
									171.42060546875,
									-41.97304687499995
								],
								[
									171.48623046874997,
									-41.79472656250003
								],
								[
									171.53632812500007,
									-41.75751953125
								],
								[
									171.67216796875005,
									-41.74472656249998
								],
								[
									171.73164062500007,
									-41.71962890625001
								],
								[
									171.8306640625001,
									-41.65517578125002
								],
								[
									171.948046875,
									-41.53867187499992
								],
								[
									172.0107421875,
									-41.444726562499966
								],
								[
									172.0933593750002,
									-41.20156249999998
								],
								[
									172.139453125,
									-40.94726562500004
								],
								[
									172.27275390625016,
									-40.758691406249994
								],
								[
									172.46816406250002,
									-40.62216796875008
								],
								[
									172.640625,
									-40.51826171875004
								],
								[
									172.7111328125,
									-40.49667968749999
								],
								[
									172.83017578125003,
									-40.49003906250006
								],
								[
									172.94365234375016,
									-40.51874999999997
								],
								[
									172.73261718750007,
									-40.54375000000009
								],
								[
									172.7111328125,
									-40.60537109375002
								],
								[
									172.70439453125,
									-40.66777343750003
								],
								[
									172.72890625000002,
									-40.72363281250004
								],
								[
									172.76679687500018,
									-40.773437499999986
								],
								[
									172.869140625,
									-40.82031249999994
								],
								[
									172.98867187500002,
									-40.84824218749995
								],
								[
									173.04228515625,
									-40.95361328125
								],
								[
									173.05214843750014,
									-41.078613281249986
								],
								[
									173.06865234375016,
									-41.18583984375006
								],
								[
									173.11533203125003,
									-41.279296875000014
								]
							]
						],
						[
							[
								[
									175.54316406250024,
									-36.27929687499994
								],
								[
									175.55117187500008,
									-36.33388671875005
								],
								[
									175.4746093750001,
									-36.314453125
								],
								[
									175.44462890625022,
									-36.27324218750003
								],
								[
									175.35878906250014,
									-36.23066406249998
								],
								[
									175.34619140625006,
									-36.217773437500014
								],
								[
									175.33662109375024,
									-36.134765624999986
								],
								[
									175.38164062500016,
									-36.09482421875002
								],
								[
									175.3895507812502,
									-36.07773437499999
								],
								[
									175.40937500000013,
									-36.07089843750002
								],
								[
									175.44433593750017,
									-36.11464843750005
								],
								[
									175.5125976562502,
									-36.176953125000054
								],
								[
									175.54316406250024,
									-36.27929687499994
								]
							]
						],
						[
							[
								[
									173.26943359375008,
									-34.93476562499994
								],
								[
									173.28457031250014,
									-34.980566406250034
								],
								[
									173.33994140625026,
									-34.94794921875004
								],
								[
									173.38125000000014,
									-34.89648437499996
								],
								[
									173.4478515625002,
									-34.84433593749999
								],
								[
									173.43867187500013,
									-34.92851562499999
								],
								[
									173.4726562500001,
									-34.94697265624994
								],
								[
									173.6937500000002,
									-35.00566406249999
								],
								[
									173.73925781250006,
									-35.05458984375001
								],
								[
									173.7862304687502,
									-35.06855468750001
								],
								[
									173.81279296874993,
									-35.041210937499955
								],
								[
									173.84394531250024,
									-35.02626953125001
								],
								[
									173.92382812500017,
									-35.05712890625
								],
								[
									174.1040039062501,
									-35.14287109375006
								],
								[
									174.11894531250016,
									-35.17236328125003
								],
								[
									174.10976562500002,
									-35.21640625000002
								],
								[
									174.1187500000001,
									-35.262890625
								],
								[
									174.1431640625001,
									-35.3
								],
								[
									174.20322265625026,
									-35.30859375000007
								],
								[
									174.28291015624995,
									-35.253515625000034
								],
								[
									174.3203125000001,
									-35.24667968750006
								],
								[
									174.3733398437501,
									-35.32451171875002
								],
								[
									174.3931640625002,
									-35.36855468750002
								],
								[
									174.38496093750018,
									-35.36708984375008
								],
								[
									174.41914062500018,
									-35.41074218749992
								],
								[
									174.46474609375008,
									-35.45410156250004
								],
								[
									174.5434570312501,
									-35.58203125
								],
								[
									174.53173828125006,
									-35.626953124999915
								],
								[
									174.50859374999993,
									-35.66738281249998
								],
								[
									174.58066406250026,
									-35.785546875000065
								],
								[
									174.53349609375022,
									-35.793750000000045
								],
								[
									174.39101562500014,
									-35.773730468749974
								],
								[
									174.39580078125005,
									-35.797363281249986
								],
								[
									174.47871093750024,
									-35.884082031250074
								],
								[
									174.54873046875014,
									-36.00664062499999
								],
								[
									174.6048828125002,
									-36.08056640624996
								],
								[
									174.80214843750008,
									-36.30947265625005
								],
								[
									174.77246093750006,
									-36.390917968749946
								],
								[
									174.77705078125013,
									-36.444628906250045
								],
								[
									174.7517578125001,
									-36.49082031250005
								],
								[
									174.8192382812502,
									-36.61210937500006
								],
								[
									174.77714843749993,
									-36.64980468750001
								],
								[
									174.74921875000013,
									-36.774023437500006
								],
								[
									174.7186523437499,
									-36.79580078125001
								],
								[
									174.72246093750016,
									-36.84121093750002
								],
								[
									174.80195312500018,
									-36.85322265624998
								],
								[
									174.84990234375022,
									-36.872558593750014
								],
								[
									174.89140624999993,
									-36.909375000000054
								],
								[
									174.91718750000024,
									-36.865039062500074
								],
								[
									174.95205078125002,
									-36.85292968749992
								],
								[
									175.04707031250024,
									-36.91220703124992
								],
								[
									175.24511718750006,
									-36.97128906250005
								],
								[
									175.29951171875013,
									-36.99326171874999
								],
								[
									175.32646484374993,
									-37.04091796875002
								],
								[
									175.34667968750017,
									-37.15615234375005
								],
								[
									175.3853515625002,
									-37.20693359374992
								],
								[
									175.46093750000017,
									-37.21669921875004
								],
								[
									175.5424804687499,
									-37.201367187500026
								],
								[
									175.56816406250016,
									-37.159375
								],
								[
									175.55195312500024,
									-37.04648437499992
								],
								[
									175.49316406250017,
									-36.86572265625004
								],
								[
									175.49287109375007,
									-36.806933593750045
								],
								[
									175.50126953125022,
									-36.74804687500004
								],
								[
									175.4874023437502,
									-36.689550781250034
								],
								[
									175.4580078125001,
									-36.63427734375004
								],
								[
									175.4263671875002,
									-36.591894531250034
								],
								[
									175.3855468750001,
									-36.55634765625007
								],
								[
									175.39980468750014,
									-36.500781249999946
								],
								[
									175.46083984375014,
									-36.47568359375006
								],
								[
									175.4976562500002,
									-36.52265625000004
								],
								[
									175.52802734374995,
									-36.579296874999955
								],
								[
									175.68144531250016,
									-36.74697265625001
								],
								[
									175.77216796874995,
									-36.73515624999999
								],
								[
									175.7806640624999,
									-36.80458984375002
								],
								[
									175.8421875000002,
									-36.87509765624999
								],
								[
									175.87617187500018,
									-36.957714843749955
								],
								[
									175.92109375000013,
									-37.20458984375006
								],
								[
									175.99013671875014,
									-37.43701171875007
								],
								[
									176.1145507812501,
									-37.538281249999926
								],
								[
									176.1290039062502,
									-37.58671875000002
								],
								[
									176.0533203125002,
									-37.56171875000008
								],
								[
									176.02988281250026,
									-37.57626953125002
								],
								[
									176.0378906250001,
									-37.60068359375002
								],
								[
									176.1083984374999,
									-37.64511718750002
								],
								[
									176.19111328125024,
									-37.66699218750003
								],
								[
									176.24316406250017,
									-37.66386718749993
								],
								[
									176.29169921875013,
									-37.68007812500004
								],
								[
									176.61474609375006,
									-37.83095703125004
								],
								[
									176.77001953125006,
									-37.8896484375
								],
								[
									177.16181640625013,
									-37.98574218750004
								],
								[
									177.2740234375002,
									-37.99345703124993
								],
								[
									177.33593750000006,
									-37.990820312500006
								],
								[
									177.45332031250018,
									-37.95742187500005
								],
								[
									177.55830078125024,
									-37.897460937499915
								],
								[
									177.64892578125006,
									-37.807812500000026
								],
								[
									177.72734375000022,
									-37.70556640625007
								],
								[
									177.81269531250018,
									-37.65595703125
								],
								[
									177.90947265625022,
									-37.616894531249955
								],
								[
									177.9580078125001,
									-37.580664062500034
								],
								[
									178.00917968750008,
									-37.55488281250001
								],
								[
									178.27216796875018,
									-37.56689453125007
								],
								[
									178.36074218750014,
									-37.61845703124992
								],
								[
									178.47597656250014,
									-37.65976562500006
								],
								[
									178.53623046875015,
									-37.69208984375
								],
								[
									178.51601562500014,
									-37.75761718750002
								],
								[
									178.4470703125001,
									-37.85439453125002
								],
								[
									178.39394531250014,
									-37.96025390624992
								],
								[
									178.3472656250002,
									-38.20087890625008
								],
								[
									178.3154296875001,
									-38.44404296875007
								],
								[
									178.26767578125015,
									-38.55117187500004
								],
								[
									178.1806640625,
									-38.63369140624998
								],
								[
									178.08486328125002,
									-38.69394531249999
								],
								[
									177.9761718750001,
									-38.72226562500008
								],
								[
									177.93212890625,
									-38.86025390624995
								],
								[
									177.91035156250018,
									-39.021777343750074
								],
								[
									177.9166015625002,
									-39.06240234374992
								],
								[
									177.95136718750018,
									-39.094531250000074
								],
								[
									177.9656250000001,
									-39.142480468750065
								],
								[
									177.9087890625002,
									-39.23955078125003
								],
								[
									177.87548828125,
									-39.22548828125001
								],
								[
									177.82871093750026,
									-39.1447265625
								],
								[
									177.7861328125001,
									-39.110937500000034
								],
								[
									177.6558593750002,
									-39.08574218750006
								],
								[
									177.5229492187501,
									-39.07382812500002
								],
								[
									177.40751953125005,
									-39.081152343750006
								],
								[
									177.29658203125018,
									-39.11582031250005
								],
								[
									177.1287109375001,
									-39.18613281250008
								],
								[
									177.0767578125002,
									-39.22177734375006
								],
								[
									177.03125000000017,
									-39.26689453125002
								],
								[
									176.95410156250006,
									-39.36757812499992
								],
								[
									176.93574218750024,
									-39.49072265625004
								],
								[
									176.93925781250005,
									-39.55527343750005
								],
								[
									176.96660156249993,
									-39.60517578125001
								],
								[
									177.10986328125017,
									-39.67314453125
								],
								[
									176.96796875000024,
									-39.91074218749999
								],
								[
									176.8421875000002,
									-40.15781249999998
								],
								[
									176.77070312500018,
									-40.22841796875005
								],
								[
									176.68876953125022,
									-40.29345703125007
								],
								[
									176.61152343750007,
									-40.44199218749996
								],
								[
									176.4764648437499,
									-40.57001953125001
								],
								[
									176.38515625000014,
									-40.66767578125001
								],
								[
									176.3138671875002,
									-40.76894531250004
								],
								[
									176.25175781250016,
									-40.876855468749994
								],
								[
									176.11865234375006,
									-41.02910156250002
								],
								[
									176.05996093750014,
									-41.12968750000009
								],
								[
									175.9829101562501,
									-41.213281250000065
								],
								[
									175.83964843750022,
									-41.32011718750006
								],
								[
									175.6873046875001,
									-41.41171874999999
								],
								[
									175.44707031250016,
									-41.53828125000001
								],
								[
									175.38027343750008,
									-41.580078125
								],
								[
									175.30976562500007,
									-41.61064453125002
								],
								[
									175.22216796875,
									-41.5744140625
								],
								[
									175.20449218750014,
									-41.534960937500045
								],
								[
									175.1846679687502,
									-41.44902343750003
								],
								[
									175.1656250000002,
									-41.41738281249998
								],
								[
									175.05390625000018,
									-41.39121093750008
								],
								[
									174.9060546875001,
									-41.432910156250045
								],
								[
									174.88134765625006,
									-41.42402343750001
								],
								[
									174.87519531250018,
									-41.40429687500007
								],
								[
									174.87500000000017,
									-41.27822265625005
								],
								[
									174.90019531250016,
									-41.242675781250014
								],
								[
									174.8656250000002,
									-41.22304687499992
								],
								[
									174.83154296875,
									-41.230761718750074
								],
								[
									174.81972656250008,
									-41.26289062500004
								],
								[
									174.8412109375002,
									-41.290722656250026
								],
								[
									174.75703125000013,
									-41.32529296875005
								],
								[
									174.6695312500002,
									-41.32626953124999
								],
								[
									174.64296875000014,
									-41.31269531250007
								],
								[
									174.6353515625002,
									-41.28945312499995
								],
								[
									174.65654296875005,
									-41.25126953124999
								],
								[
									174.68486328125016,
									-41.217675781250065
								],
								[
									174.8477539062501,
									-41.058789062500026
								],
								[
									175.01679687500007,
									-40.84765625
								],
								[
									175.16250000000014,
									-40.62158203124996
								],
								[
									175.20048828125022,
									-40.505371093749986
								],
								[
									175.25410156250013,
									-40.28935546875003
								],
								[
									175.21015625000024,
									-40.199414062499926
								],
								[
									175.15595703125018,
									-40.114941406250026
								],
								[
									175.00927734375017,
									-39.9521484375
								],
								[
									174.81376953124993,
									-39.86015625000009
								],
								[
									174.6873046875001,
									-39.84716796874993
								],
								[
									174.5674804687502,
									-39.81298828125007
								],
								[
									174.45468750000015,
									-39.73515625000002
								],
								[
									174.35205078125,
									-39.643359374999974
								],
								[
									174.14863281249995,
									-39.56816406249993
								],
								[
									173.93437500000022,
									-39.509082031249974
								],
								[
									173.81210937500015,
									-39.42578125000006
								],
								[
									173.7830078125001,
									-39.37617187500007
								],
								[
									173.76367187500006,
									-39.31874999999992
								],
								[
									173.7664062500001,
									-39.265332031250054
								],
								[
									173.7816406250002,
									-39.211230468750045
								],
								[
									173.8060546875002,
									-39.16953125000008
								],
								[
									173.84433593750015,
									-39.13935546874997
								],
								[
									174.0713867187502,
									-39.03124999999997
								],
								[
									174.31171875000018,
									-38.97109375000005
								],
								[
									174.35605468750015,
									-38.972167968750014
								],
								[
									174.39843750000006,
									-38.96259765625001
								],
								[
									174.45849609375006,
									-38.92578125000006
								],
								[
									174.56621093750016,
									-38.84160156250006
								],
								[
									174.59736328125007,
									-38.78505859374991
								],
								[
									174.61855468750014,
									-38.605273437500045
								],
								[
									174.65302734375024,
									-38.42832031250006
								],
								[
									174.7153320312501,
									-38.22558593749997
								],
								[
									174.80927734375007,
									-38.099804687499926
								],
								[
									174.84003906249995,
									-38.02265625000001
								],
								[
									174.80166015625014,
									-37.89550781250004
								],
								[
									174.8368164062502,
									-37.848925781249974
								],
								[
									174.87958984375018,
									-37.82080078124993
								],
								[
									174.92802734374993,
									-37.80449218750006
								],
								[
									174.8459960937501,
									-37.685156250000006
								],
								[
									174.74941406250014,
									-37.5046875
								],
								[
									174.72919921875013,
									-37.44873046875006
								],
								[
									174.7439453125001,
									-37.39345703125008
								],
								[
									174.76767578125015,
									-37.33906250000001
								],
								[
									174.70742187500014,
									-37.32529296875005
								],
								[
									174.67255859375013,
									-37.27314453125008
								],
								[
									174.58583984375002,
									-37.09775390625006
								],
								[
									174.6096679687501,
									-37.06992187500008
								],
								[
									174.65966796875017,
									-37.08876953125001
								],
								[
									174.73427734375008,
									-37.21523437500001
								],
								[
									174.74638671875005,
									-37.15009765625007
								],
								[
									174.8036132812502,
									-37.11005859375008
								],
								[
									174.8638671875002,
									-37.08925781250001
								],
								[
									174.92890625000013,
									-37.084765625000074
								],
								[
									174.78203125000022,
									-36.94374999999995
								],
								[
									174.73291015625017,
									-36.94941406250004
								],
								[
									174.6679687499999,
									-36.971875
								],
								[
									174.60146484375002,
									-36.98574218749998
								],
								[
									174.53652343750014,
									-36.97333984374994
								],
								[
									174.47558593750017,
									-36.94189453124993
								],
								[
									174.44453125000024,
									-36.88251953125008
								],
								[
									174.40605468750022,
									-36.76826171875008
								],
								[
									174.38193359375026,
									-36.725976562499994
								],
								[
									174.1888671875002,
									-36.49228515624999
								],
								[
									174.2457031250002,
									-36.48496093749992
								],
								[
									174.40156250000018,
									-36.60195312499995
								],
								[
									174.43173828125026,
									-36.56455078125005
								],
								[
									174.45429687500024,
									-36.510742187500014
								],
								[
									174.44687500000015,
									-36.45087890625008
								],
								[
									174.4095703125002,
									-36.40556640624999
								],
								[
									174.35410156250026,
									-36.3759765625
								],
								[
									174.35312500000026,
									-36.322851562499935
								],
								[
									174.39541015625014,
									-36.274121093749955
								],
								[
									174.39277343749995,
									-36.24003906250002
								],
								[
									174.3035156250001,
									-36.17050781250006
								],
								[
									174.2678710937501,
									-36.16308593750007
								],
								[
									174.25205078125026,
									-36.195605468749946
								],
								[
									174.27753906250013,
									-36.24375000000006
								],
								[
									174.25371093750005,
									-36.249121093750006
								],
								[
									174.03642578125022,
									-36.122460937499966
								],
								[
									173.9693359375002,
									-36.02060546874999
								],
								[
									173.91445312500002,
									-35.908691406250014
								],
								[
									173.90888671875018,
									-35.95419921875005
								],
								[
									173.9172851562501,
									-36.018164062500034
								],
								[
									174.00312500000018,
									-36.14628906250002
								],
								[
									174.14238281249993,
									-36.28945312500005
								],
								[
									174.16640625000002,
									-36.327636718750014
								],
								[
									174.1458007812501,
									-36.37695312499994
								],
								[
									174.09746093750022,
									-36.391015624999966
								],
								[
									174.0546875,
									-36.359765624999994
								],
								[
									173.99101562500022,
									-36.237207031250065
								],
								[
									173.9451171875001,
									-36.175878906250006
								],
								[
									173.4122070312502,
									-35.542578125000034
								],
								[
									173.48027343750005,
									-35.45898437500006
								],
								[
									173.58583984375008,
									-35.38857421875002
								],
								[
									173.6103515625001,
									-35.35722656250003
								],
								[
									173.62617187500013,
									-35.31914062499999
								],
								[
									173.5816406250001,
									-35.31259765624999
								],
								[
									173.54169921875013,
									-35.329882812500045
								],
								[
									173.4960937499999,
									-35.3623046875
								],
								[
									173.45429687500007,
									-35.39921875000006
								],
								[
									173.40166015625022,
									-35.481152343750054
								],
								[
									173.3763671875002,
									-35.500097656250006
								],
								[
									173.3139648437501,
									-35.443359374999986
								],
								[
									173.29023437500024,
									-35.408300781250034
								],
								[
									173.29121093750007,
									-35.366308593750006
								],
								[
									173.27451171875026,
									-35.3396484375
								],
								[
									173.2281250000002,
									-35.33125000000007
								],
								[
									173.1601562500001,
									-35.24775390625001
								],
								[
									173.11669921875,
									-35.20527343749998
								],
								[
									173.18876953125,
									-35.12373046875007
								],
								[
									173.190625,
									-35.016210937500006
								],
								[
									173.1172851562502,
									-34.90332031249993
								],
								[
									173.02958984375016,
									-34.79990234374999
								],
								[
									172.86074218750014,
									-34.63232421875004
								],
								[
									172.70595703125014,
									-34.455175781249935
								],
								[
									172.87373046875,
									-34.43291015625002
								],
								[
									173.0439453125,
									-34.42910156249995
								],
								[
									172.96376953124997,
									-34.53515625000006
								],
								[
									172.99980468750016,
									-34.596484374999946
								],
								[
									173.05439453125018,
									-34.6482421875
								],
								[
									173.17109375000007,
									-34.80693359375
								],
								[
									173.1812500000001,
									-34.852734374999926
								],
								[
									173.24052734375005,
									-34.89902343750002
								],
								[
									173.26943359375008,
									-34.93476562499994
								]
							]
						],
						[
							[
								[
									-171.18642578125,
									-9.355468750000043
								],
								[
									-171.188623046875,
									-9.358300781249909
								],
								[
									-171.19301757812502,
									-9.352441406249966
								],
								[
									-171.20004882812503,
									-9.344726562499986
								],
								[
									-171.20444335937503,
									-9.333300781249974
								],
								[
									-171.20166015625,
									-9.332617187500006
								],
								[
									-171.19443359375003,
									-9.338769531249923
								],
								[
									-171.18930664062498,
									-9.346582031250009
								],
								[
									-171.18642578125,
									-9.355468750000043
								]
							]
						],
						[
							[
								[
									-172.47915039062502,
									-8.580761718749955
								],
								[
									-172.48369140624996,
									-8.582910156250037
								],
								[
									-172.488232421875,
									-8.571582031249946
								],
								[
									-172.49404296875002,
									-8.559179687499906
								],
								[
									-172.498681640625,
									-8.54794921875002
								],
								[
									-172.497021484375,
									-8.546484374999906
								],
								[
									-172.48725585937498,
									-8.556152343749915
								],
								[
									-172.48110351562497,
									-8.56748046874992
								],
								[
									-172.47915039062502,
									-8.580761718749955
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Australia and New Zealand",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "NZL",
					"su_a3": "NZL",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "NZL",
					"gu_a3": "NZL",
					"abbrev": "N.Z.",
					"region_un": "Oceania",
					"adm0_a3_us": "NZL",
					"scalerank": 1,
					"pop_est": 4213418,
					"adm0_dif": 1,
					"un_a3": "554",
					"pop_year": -99,
					"gdp_md_est": 116700,
					"name": "New Zealand",
					"sovereignt": "New Zealand",
					"economy": "2. Developed region: nonG7",
					"type": "Country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "New Zealand",
					"postal": "NZ",
					"sov_a3": "NZ1",
					"note_brk": "",
					"brk_a3": "NZL",
					"wb_a2": "NZ",
					"brk_diff": 0,
					"admin": "New Zealand",
					"name_long": "New Zealand",
					"iso_a3": "NZL",
					"iso_a2": "NZ",
					"adm0_a3_is": "NZL",
					"level": 2,
					"formal_en": "New Zealand",
					"name_len": 11,
					"mapcolor7": 3,
					"long_len": 11,
					"mapcolor8": 3,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "554",
					"homepart": 1,
					"subunit": "New Zealand",
					"name_alt": "",
					"brk_name": "New Zealand",
					"name_sort": "New Zealand",
					"continent": "Oceania",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2006
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								76.76689453125005,
								35.661718750000006
							],
							[
								76.81279296874999,
								35.57182617187499
							],
							[
								76.88222656250008,
								35.43574218749998
							],
							[
								76.92773437500006,
								35.34663085937504
							],
							[
								76.97890625000008,
								35.24643554687506
							],
							[
								77.00449218750003,
								35.19633789062496
							],
							[
								77.04863281250005,
								35.109912109375045
							],
							[
								77.03066406250014,
								35.062353515625034
							],
							[
								77.00087890625008,
								34.99199218749999
							],
							[
								76.89169921875003,
								34.93872070312497
							],
							[
								76.78291015625013,
								34.900195312500045
							],
							[
								76.75751953125007,
								34.87783203125011
							],
							[
								76.74902343750011,
								34.84755859375005
							],
							[
								76.69628906250006,
								34.78691406249996
							],
							[
								76.59443359375018,
								34.73583984375003
							],
							[
								76.50996093750007,
								34.740869140624994
							],
							[
								76.45673828125007,
								34.756103515625085
							],
							[
								76.17246093750009,
								34.667724609375114
							],
							[
								76.04101562500011,
								34.66992187500003
							],
							[
								75.93828125000016,
								34.61254882812506
							],
							[
								75.86210937499999,
								34.56025390625007
							],
							[
								75.70917968750001,
								34.503076171875136
							],
							[
								75.60556640625003,
								34.502734375000074
							],
							[
								75.45253906250014,
								34.53671875000006
							],
							[
								75.26406250000014,
								34.60136718749999
							],
							[
								75.18750000000017,
								34.63901367187512
							],
							[
								75.1184570312501,
								34.636816406250034
							],
							[
								74.95185546875013,
								34.64584960937509
							],
							[
								74.78876953125007,
								34.677734375
							],
							[
								74.59414062500014,
								34.715771484375125
							],
							[
								74.49794921875008,
								34.73203125000006
							],
							[
								74.30039062500009,
								34.765380859375114
							],
							[
								74.17197265625003,
								34.72089843750001
							],
							[
								74.05585937500007,
								34.680664062500085
							],
							[
								73.9612304687501,
								34.65346679687505
							],
							[
								73.88310546875005,
								34.529052734375
							],
							[
								73.85009765625011,
								34.48530273437507
							],
							[
								73.81210937500009,
								34.42236328125003
							],
							[
								73.79453125000003,
								34.3782226562501
							],
							[
								73.8099609375002,
								34.32534179687508
							],
							[
								73.9246093750001,
								34.28784179687506
							],
							[
								73.97236328125001,
								34.23662109375002
							],
							[
								73.97949218750006,
								34.19130859375002
							],
							[
								73.9382812500001,
								34.14477539062506
							],
							[
								73.90390625000015,
								34.10800781250012
							],
							[
								73.90410156250016,
								34.075683593750114
							],
							[
								73.92236328125006,
								34.043066406250034
							],
							[
								73.94990234375007,
								34.01879882812497
							],
							[
								74.11259765625016,
								34.00371093750002
							],
							[
								74.20898437500011,
								34.00341796875003
							],
							[
								74.24648437500008,
								33.9901855468751
							],
							[
								74.25087890625014,
								33.946093750000074
							],
							[
								74.2156250000001,
								33.886572265625034
							],
							[
								74.07841796875005,
								33.838671875000045
							],
							[
								74.00097656250011,
								33.78818359375006
							],
							[
								73.97646484375014,
								33.721289062500034
							],
							[
								73.97753906250011,
								33.66782226562515
							],
							[
								74.0040039062502,
								33.632421875000034
							],
							[
								74.06972656250014,
								33.591699218749994
							],
							[
								74.13125000000008,
								33.54506835937508
							],
							[
								74.15000000000009,
								33.506982421874966
							],
							[
								74.14257812500006,
								33.45537109375002
							],
							[
								74.11777343750009,
								33.38413085937509
							],
							[
								74.05039062500015,
								33.301269531250085
							],
							[
								73.99423828125003,
								33.24218750000003
							],
							[
								73.98984375000003,
								33.221191406250114
							],
							[
								74.00380859375014,
								33.18945312500003
							],
							[
								74.04912109375016,
								33.14340820312498
							],
							[
								74.1262695312501,
								33.075439453125085
							],
							[
								74.22207031250008,
								33.020312500000045
							],
							[
								74.28359375000014,
								33.00512695312514
							],
							[
								74.30361328125014,
								32.99179687500009
							],
							[
								74.32275390625011,
								32.92797851562506
							],
							[
								74.32998046875008,
								32.86083984375006
							],
							[
								74.30546875000016,
								32.810449218749994
							],
							[
								74.35458984375009,
								32.76870117187502
							],
							[
								74.48339843750006,
								32.77099609375006
							],
							[
								74.58828125000008,
								32.753222656250074
							],
							[
								74.63242187500003,
								32.77089843750011
							],
							[
								74.66328125000001,
								32.757666015625006
							],
							[
								74.64335937500016,
								32.60771484374999
							],
							[
								74.65781250000003,
								32.51894531250002
							],
							[
								74.68574218750018,
								32.493798828124966
							],
							[
								74.7888671875001,
								32.45781250000002
							],
							[
								74.98730468750006,
								32.46220703125002
							],
							[
								75.10410156250003,
								32.42036132812501
							],
							[
								75.23369140625016,
								32.372119140625045
							],
							[
								75.30263671875014,
								32.318896484375045
							],
							[
								75.33349609375006,
								32.27919921875005
							],
							[
								75.32470703125011,
								32.21528320312507
							],
							[
								75.25410156250001,
								32.14033203125007
							],
							[
								75.13876953125009,
								32.104785156250045
							],
							[
								75.07148437500013,
								32.08935546875
							],
							[
								74.73945312500007,
								31.948828125000063
							],
							[
								74.63574218750011,
								31.889746093750006
							],
							[
								74.55556640625008,
								31.818554687500068
							],
							[
								74.52597656250003,
								31.76513671875003
							],
							[
								74.50996093750013,
								31.712939453125045
							],
							[
								74.5818359375001,
								31.523925781250085
							],
							[
								74.59394531250001,
								31.465380859375074
							],
							[
								74.5349609375001,
								31.26137695312508
							],
							[
								74.51767578125009,
								31.18559570312499
							],
							[
								74.53974609375018,
								31.132666015625063
							],
							[
								74.61035156250006,
								31.112841796875102
							],
							[
								74.62578125000005,
								31.06875000000008
							],
							[
								74.63281250000011,
								31.034667968750057
							],
							[
								74.50976562500011,
								30.959667968750068
							],
							[
								74.38037109375011,
								30.893408203125063
							],
							[
								74.33935546875011,
								30.8935546875
							],
							[
								74.2156250000001,
								30.76899414062504
							],
							[
								74.00898437500001,
								30.51967773437505
							],
							[
								73.89931640625008,
								30.435351562500102
							],
							[
								73.89160156250011,
								30.39404296875003
							],
							[
								73.88271484375008,
								30.352148437500034
							],
							[
								73.9246093750001,
								30.28164062500005
							],
							[
								73.93339843749999,
								30.22207031250008
							],
							[
								73.88652343750016,
								30.162011718750108
							],
							[
								73.80917968750009,
								30.093359375000063
							],
							[
								73.6580078125001,
								30.03320312499997
							],
							[
								73.46748046875001,
								29.971679687500142
							],
							[
								73.3816406250001,
								29.93437499999999
							],
							[
								73.31728515625014,
								29.772998046875074
							],
							[
								73.25781250000011,
								29.610693359375148
							],
							[
								73.23115234375001,
								29.550634765625063
							],
							[
								73.12832031250014,
								29.363916015625136
							],
							[
								72.94873046875006,
								29.08881835937504
							],
							[
								72.90332031250011,
								29.028759765625068
							],
							[
								72.62558593750009,
								28.89614257812505
							],
							[
								72.34189453125003,
								28.751904296875153
							],
							[
								72.29199218750011,
								28.69726562500003
							],
							[
								72.23388671875006,
								28.56582031250008
							],
							[
								72.17919921875011,
								28.42177734375005
							],
							[
								72.1285156250002,
								28.346337890625136
							],
							[
								71.94804687499999,
								28.177294921875045
							],
							[
								71.88886718750001,
								28.047460937499977
							],
							[
								71.87031250000018,
								27.96250000000009
							],
							[
								71.71669921875014,
								27.915087890625017
							],
							[
								71.54296875000011,
								27.869873046875057
							],
							[
								71.29013671875009,
								27.855273437500102
							],
							[
								71.18476562500001,
								27.831640624999977
							],
							[
								70.87490234375014,
								27.714453125000006
							],
							[
								70.7979492187502,
								27.709619140624994
							],
							[
								70.73740234375003,
								27.72900390625003
							],
							[
								70.69160156250013,
								27.76899414062501
							],
							[
								70.64912109375013,
								27.835351562500023
							],
							[
								70.62910156250018,
								27.93745117187504
							],
							[
								70.56923828125014,
								27.98378906250008
							],
							[
								70.4885742187501,
								28.023144531250097
							],
							[
								70.40371093750008,
								28.02504882812505
							],
							[
								70.31845703125009,
								27.981640624999983
							],
							[
								70.24433593750001,
								27.934130859375074
							],
							[
								70.19394531250003,
								27.894873046874977
							],
							[
								70.14453125000011,
								27.849023437499966
							],
							[
								70.04980468750011,
								27.69472656250008
							],
							[
								69.8962890625001,
								27.473632812500057
							],
							[
								69.72480468750013,
								27.31269531250004
							],
							[
								69.66132812500007,
								27.264501953125006
							],
							[
								69.62158203125006,
								27.228076171875045
							],
							[
								69.56796875000009,
								27.174609375000074
							],
							[
								69.53701171875008,
								27.122949218750023
							],
							[
								69.49453125000014,
								26.954150390625017
							],
							[
								69.47001953124999,
								26.80444335937497
							],
							[
								69.4812500000001,
								26.770996093750085
							],
							[
								69.50693359375009,
								26.74267578125
							],
							[
								69.60058593750006,
								26.699121093750108
							],
							[
								69.7359375000002,
								26.627050781249977
							],
							[
								69.91142578125016,
								26.586132812500068
							],
							[
								70.05937499999999,
								26.578759765624994
							],
							[
								70.11464843750014,
								26.54804687500004
							],
							[
								70.14765625000007,
								26.506445312500006
							],
							[
								70.15683593750003,
								26.471435546875085
							],
							[
								70.14921874999999,
								26.347558593749966
							],
							[
								70.13261718749999,
								26.21479492187501
							],
							[
								70.0777343750002,
								26.07197265625004
							],
							[
								70.07861328125011,
								25.99003906249996
							],
							[
								70.10019531250003,
								25.910058593750108
							],
							[
								70.26464843750006,
								25.70654296875003
							],
							[
								70.32519531250006,
								25.685742187500068
							],
							[
								70.44853515625016,
								25.68134765625004
							],
							[
								70.50585937500011,
								25.685302734375057
							],
							[
								70.56953125000013,
								25.705957031249994
							],
							[
								70.6148437500002,
								25.69189453124997
							],
							[
								70.64843750000011,
								25.66694335937504
							],
							[
								70.65722656250011,
								25.625781250000102
							],
							[
								70.65205078125001,
								25.422900390625074
							],
							[
								70.70253906250014,
								25.3310546875
							],
							[
								70.80048828125007,
								25.20585937499999
							],
							[
								70.87773437500016,
								25.06298828125003
							],
							[
								70.95087890625018,
								24.8916015625
							],
							[
								71.02070312500018,
								24.757666015624977
							],
							[
								71.04785156250011,
								24.687744140625142
							],
							[
								71.0023437500002,
								24.653906249999977
							],
							[
								70.9763671875001,
								24.61875000000012
							],
							[
								70.96982421875009,
								24.571875000000063
							],
							[
								70.97929687499999,
								24.52246093750003
							],
							[
								70.97324218750009,
								24.487402343750006
							],
							[
								71.00625000000008,
								24.444335937500114
							],
							[
								71.04531250000014,
								24.429980468750017
							],
							[
								71.04404296875003,
								24.400097656250153
							],
							[
								70.98281250000008,
								24.361035156250097
							],
							[
								70.92812500000014,
								24.362353515625102
							],
							[
								70.88623046875011,
								24.34375000000003
							],
							[
								70.80507812500014,
								24.261962890625085
							],
							[
								70.76728515625018,
								24.24541015624999
							],
							[
								70.71630859375006,
								24.237988281250068
							],
							[
								70.6594726562501,
								24.24609375000003
							],
							[
								70.57929687500013,
								24.279052734375
							],
							[
								70.55585937500018,
								24.33110351562513
							],
							[
								70.56503906250009,
								24.38579101562499
							],
							[
								70.54677734375008,
								24.418310546875034
							],
							[
								70.48925781250011,
								24.41215820312513
							],
							[
								70.28906250000006,
								24.35629882812512
							],
							[
								70.09824218750009,
								24.287500000000136
							],
							[
								70.06513671875001,
								24.240576171874977
							],
							[
								70.02109375000009,
								24.191552734375023
							],
							[
								69.93378906250007,
								24.17138671875
							],
							[
								69.80517578125006,
								24.165234375000097
							],
							[
								69.71621093750014,
								24.172607421875085
							],
							[
								69.63417968750014,
								24.22519531249995
							],
							[
								69.55917968750003,
								24.273095703125023
							],
							[
								69.44345703125003,
								24.275390625000057
							],
							[
								69.23505859375001,
								24.268261718750125
							],
							[
								69.11953125000008,
								24.268652343750006
							],
							[
								69.0515625000001,
								24.286328125000068
							],
							[
								68.98457031250013,
								24.273095703125023
							],
							[
								68.90078125000014,
								24.292431640625068
							],
							[
								68.86347656250018,
								24.266503906250023
							],
							[
								68.82832031250001,
								24.264013671875034
							],
							[
								68.80000000000001,
								24.309082031250085
							],
							[
								68.78115234375008,
								24.313720703125142
							],
							[
								68.75898437500001,
								24.307226562500063
							],
							[
								68.73964843750014,
								24.291992187500057
							],
							[
								68.72812500000015,
								24.265625000000114
							],
							[
								68.72412109375011,
								23.96469726562509
							],
							[
								68.58662109375018,
								23.96660156250013
							],
							[
								68.48867187500008,
								23.967236328124983
							],
							[
								68.38125000000014,
								23.950878906250125
							],
							[
								68.2825195312501,
								23.92797851562497
							],
							[
								68.2341796875001,
								23.90053710937508
							],
							[
								68.16503906250006,
								23.857324218749966
							],
							[
								68.14882812500008,
								23.797216796874977
							],
							[
								68.11552734375005,
								23.75336914062501
							],
							[
								68.06777343750008,
								23.81835937500003
							],
							[
								68.03701171875002,
								23.848242187499977
							],
							[
								68.00146484375006,
								23.826074218749994
							],
							[
								67.95097656249999,
								23.82861328124997
							],
							[
								67.85996093750009,
								23.902685546874977
							],
							[
								67.81904296875001,
								23.82807617187504
							],
							[
								67.66845703125,
								23.81098632812504
							],
							[
								67.64951171875003,
								23.86728515624995
							],
							[
								67.64580078124999,
								23.91987304687501
							],
							[
								67.56308593750009,
								23.8818359375
							],
							[
								67.50361328125007,
								23.94003906249995
							],
							[
								67.47685546875005,
								24.018261718749983
							],
							[
								67.45390624999999,
								24.03989257812495
							],
							[
								67.42763671875002,
								24.064843749999966
							],
							[
								67.365234375,
								24.091601562500017
							],
							[
								67.30937499999999,
								24.1748046875
							],
							[
								67.30429687500003,
								24.262890624999983
							],
							[
								67.28867187500003,
								24.36777343749995
							],
							[
								67.17148437500009,
								24.75610351562503
							],
							[
								67.1005859375,
								24.79194335937504
							],
							[
								66.70302734375002,
								24.860937499999977
							],
							[
								66.68222656250003,
								24.92885742187505
							],
							[
								66.70986328125008,
								25.111328125
							],
							[
								66.69863281250002,
								25.22631835937497
							],
							[
								66.56992187500009,
								25.378515625000006
							],
							[
								66.53388671875001,
								25.48437499999997
							],
							[
								66.42861328125008,
								25.575341796875023
							],
							[
								66.32421875000006,
								25.601806640625
							],
							[
								66.21904296874999,
								25.58989257812499
							],
							[
								66.16230468750001,
								25.55390625000001
							],
							[
								66.13115234375005,
								25.493261718750006
							],
							[
								66.35644531250006,
								25.507373046875045
							],
							[
								66.40712890625008,
								25.48505859375004
							],
							[
								66.46767578125002,
								25.4453125
							],
							[
								66.40292968750009,
								25.44682617187496
							],
							[
								66.32832031250007,
								25.46577148437501
							],
							[
								66.23466796874999,
								25.46435546874997
							],
							[
								65.88359374999999,
								25.41962890625001
							],
							[
								65.6796875,
								25.35527343749996
							],
							[
								65.40625,
								25.374316406250017
							],
							[
								65.06132812499999,
								25.311083984375017
							],
							[
								64.77666015624999,
								25.307324218750068
							],
							[
								64.65898437499999,
								25.18408203125
							],
							[
								64.59404296874999,
								25.206298828125
							],
							[
								64.54375000000005,
								25.23666992187495
							],
							[
								64.15205078125001,
								25.33344726562504
							],
							[
								64.12490234375008,
								25.373925781250023
							],
							[
								64.05937500000005,
								25.402929687500006
							],
							[
								63.9873046875,
								25.351171875000006
							],
							[
								63.93554687500006,
								25.34252929687503
							],
							[
								63.72089843750001,
								25.385888671874994
							],
							[
								63.556640625,
								25.353173828124994
							],
							[
								63.495703125000034,
								25.297509765625023
							],
							[
								63.49140625000007,
								25.210839843750023
							],
							[
								63.28574218750009,
								25.22758789062499
							],
							[
								63.170019531250034,
								25.25488281250003
							],
							[
								63.01503906250008,
								25.22465820312499
							],
							[
								62.66474609375007,
								25.264794921874994
							],
							[
								62.57246093750007,
								25.254736328125006
							],
							[
								62.44472656250008,
								25.19726562500003
							],
							[
								62.39121093750009,
								25.15253906250004
							],
							[
								62.31533203125008,
								25.134912109375023
							],
							[
								62.24873046875001,
								25.19736328124995
							],
							[
								62.19863281250002,
								25.22485351562503
							],
							[
								62.15214843749999,
								25.206640624999977
							],
							[
								62.08945312500009,
								25.15532226562499
							],
							[
								61.90791015625007,
								25.131298828124983
							],
							[
								61.74365234375006,
								25.13818359374997
							],
							[
								61.56689453125,
								25.186328125000017
							],
							[
								61.58789062500006,
								25.202343749999983
							],
							[
								61.61542968750007,
								25.2861328125
							],
							[
								61.640136718750114,
								25.584619140624966
							],
							[
								61.67138671875,
								25.692382812500085
							],
							[
								61.66181640625007,
								25.75126953124999
							],
							[
								61.66865234375007,
								25.76899414062504
							],
							[
								61.73769531250002,
								25.821093750000102
							],
							[
								61.754394531250114,
								25.84335937500009
							],
							[
								61.78076171875,
								25.995849609375085
							],
							[
								61.80996093750008,
								26.165283203125057
							],
							[
								61.842382812500034,
								26.225927734375063
							],
							[
								61.869824218750125,
								26.242431640625057
							],
							[
								62.08906250000007,
								26.31826171875005
							],
							[
								62.12597656250006,
								26.368994140625063
							],
							[
								62.23935546875009,
								26.357031250000034
							],
							[
								62.249609375000034,
								26.369238281250034
							],
							[
								62.259667968750136,
								26.427490234375
							],
							[
								62.31230468749999,
								26.490869140625023
							],
							[
								62.38505859374999,
								26.542626953125108
							],
							[
								62.439257812500045,
								26.56103515625003
							],
							[
								62.63642578125007,
								26.593652343750108
							],
							[
								62.751562500000034,
								26.639160156250057
							],
							[
								62.786621093750114,
								26.643896484375034
							],
							[
								63.09296875000007,
								26.632324218750085
							],
							[
								63.157812500000034,
								26.649755859375063
							],
							[
								63.16806640625009,
								26.665576171875017
							],
							[
								63.186132812500034,
								26.837597656250068
							],
							[
								63.241601562500136,
								26.86474609375
							],
							[
								63.25039062500008,
								26.87924804687512
							],
							[
								63.231445312500114,
								26.99814453125009
							],
							[
								63.24208984375008,
								27.077685546875045
							],
							[
								63.30517578125006,
								27.12456054687499
							],
							[
								63.30156249999999,
								27.151464843750063
							],
							[
								63.256250000000136,
								27.207910156250108
							],
							[
								63.196093750000045,
								27.243945312500074
							],
							[
								63.16679687499999,
								27.252490234375045
							],
							[
								62.915429687500136,
								27.218408203125023
							],
							[
								62.811621093750034,
								27.22944335937504
							],
							[
								62.762988281250045,
								27.25019531250001
							],
							[
								62.752734375000045,
								27.265625000000057
							],
							[
								62.762500000000045,
								27.30019531250008
							],
							[
								62.76425781250009,
								27.356738281250045
							],
							[
								62.80087890625009,
								27.444531249999983
							],
							[
								62.812011718750114,
								27.49702148437501
							],
							[
								62.782324218750034,
								27.80053710937503
							],
							[
								62.73974609375006,
								28.002050781250063
							],
							[
								62.762500000000045,
								28.20205078125005
							],
							[
								62.75800781250001,
								28.243554687499966
							],
							[
								62.74941406250008,
								28.252880859375097
							],
							[
								62.717578125000045,
								28.252783203124977
							],
							[
								62.564550781250034,
								28.235156250000045
							],
							[
								62.43388671874999,
								28.363867187500063
							],
							[
								62.35302734375006,
								28.41474609375004
							],
							[
								62.13056640625001,
								28.478808593750017
							],
							[
								62.033007812500045,
								28.491015625000017
							],
							[
								61.88984375000007,
								28.546533203124966
							],
							[
								61.75800781250007,
								28.66767578125004
							],
							[
								61.623046875000114,
								28.791601562499977
							],
							[
								61.568750000000136,
								28.87089843749996
							],
							[
								61.50859375000016,
								29.006054687500068
							],
							[
								61.337890625000114,
								29.264990234375063
							],
							[
								61.339453125000034,
								29.331787109375057
							],
							[
								61.318359375000114,
								29.372607421875045
							],
							[
								61.15214843749999,
								29.542724609375057
							],
							[
								61.034179687500114,
								29.663427734375034
							],
							[
								60.843359375000034,
								29.858691406250045
							],
							[
								61.22441406249999,
								29.749414062499966
							],
							[
								61.521484375,
								29.665673828124966
							],
							[
								62.0009765625,
								29.530419921875023
							],
							[
								62.37343750000002,
								29.425390625000034
							],
							[
								62.4765625,
								29.408349609375023
							],
							[
								63.56757812500001,
								29.49799804687501
							],
							[
								63.97099609374999,
								29.430078125000023
							],
							[
								64.09873046875003,
								29.391943359374977
							],
							[
								64.11796874999999,
								29.414257812499983
							],
							[
								64.17216796874999,
								29.460351562499966
							],
							[
								64.26611328125006,
								29.506933593750034
							],
							[
								64.39375000000001,
								29.544335937500023
							],
							[
								64.52109375000003,
								29.56450195312496
							],
							[
								64.70351562500008,
								29.567138671875057
							],
							[
								64.82734375000001,
								29.564160156249983
							],
							[
								64.9189453125,
								29.55278320312496
							],
							[
								65.09550781249999,
								29.559472656249994
							],
							[
								65.18046874999999,
								29.57763671874997
							],
							[
								65.47099609375005,
								29.65156250000001
							],
							[
								65.66621093750001,
								29.701318359375023
							],
							[
								65.96162109375007,
								29.778906250000034
							],
							[
								66.17705078124999,
								29.835595703125023
							],
							[
								66.23124999999999,
								29.865722656250057
							],
							[
								66.28691406249999,
								29.920019531250006
							],
							[
								66.31337890625002,
								29.968554687500045
							],
							[
								66.24716796875003,
								30.043505859375017
							],
							[
								66.23847656250007,
								30.109619140625
							],
							[
								66.28183593750003,
								30.193457031250034
							],
							[
								66.30546875000005,
								30.321142578125006
							],
							[
								66.30097656250001,
								30.502978515625017
							],
							[
								66.28691406249999,
								30.60791015625
							],
							[
								66.34687500000001,
								30.80278320312499
							],
							[
								66.39716796875007,
								30.912207031249977
							],
							[
								66.49736328125005,
								30.964550781249983
							],
							[
								66.56679687500008,
								30.99658203125003
							],
							[
								66.59580078125003,
								31.01997070312501
							],
							[
								66.62421875000007,
								31.046044921874994
							],
							[
								66.73134765625002,
								31.19453125000004
							],
							[
								66.82929687500001,
								31.263671875
							],
							[
								66.92431640625,
								31.30561523437501
							],
							[
								67.02773437500002,
								31.300244140624983
							],
							[
								67.11591796875001,
								31.24291992187503
							],
							[
								67.28730468750007,
								31.21782226562499
							],
							[
								67.45283203125001,
								31.23461914062503
							],
							[
								67.59638671875007,
								31.277685546875006
							],
							[
								67.66152343750008,
								31.31298828125003
							],
							[
								67.73789062500009,
								31.34394531250001
							],
							[
								67.73349609375009,
								31.379248046875006
							],
							[
								67.64707031250009,
								31.40996093749996
							],
							[
								67.59755859375002,
								31.45332031250001
							],
							[
								67.57822265625009,
								31.506494140624994
							],
							[
								67.62675781249999,
								31.53876953125001
							],
							[
								67.73984375000003,
								31.548193359375063
							],
							[
								68.01718750000003,
								31.67797851562503
							],
							[
								68.13017578124999,
								31.763281250000006
							],
							[
								68.16103515625008,
								31.802978515625
							],
							[
								68.21396484375009,
								31.80737304687503
							],
							[
								68.31982421875,
								31.767675781250006
							],
							[
								68.44326171875008,
								31.754492187499977
							],
							[
								68.52070312500007,
								31.794140624999983
							],
							[
								68.59765625,
								31.802978515625
							],
							[
								68.67324218750002,
								31.759716796874983
							],
							[
								68.71367187500005,
								31.708056640625045
							],
							[
								68.78232421875009,
								31.64643554687501
							],
							[
								68.86894531250005,
								31.63422851562501
							],
							[
								68.97343749999999,
								31.667382812499994
							],
							[
								69.08310546875003,
								31.73847656250001
							],
							[
								69.18691406250008,
								31.838085937500068
							],
							[
								69.27929687500006,
								31.936816406250017
							],
							[
								69.25654296875007,
								32.24946289062501
							],
							[
								69.24140625000007,
								32.43354492187504
							],
							[
								69.28994140625002,
								32.53056640624999
							],
							[
								69.35947265625003,
								32.59033203125
							],
							[
								69.40537109375009,
								32.682714843750006
							],
							[
								69.40458984374999,
								32.764257812500006
							],
							[
								69.45312500000006,
								32.83281250000002
							],
							[
								69.50156250000003,
								33.02006835937499
							],
							[
								69.56777343750002,
								33.06416015624998
							],
							[
								69.70371093750003,
								33.0947265625
							],
							[
								69.92011718750007,
								33.11249999999998
							],
							[
								70.09023437500008,
								33.198095703125006
							],
							[
								70.26113281250008,
								33.28901367187507
							],
							[
								70.28417968750006,
								33.36904296875002
							],
							[
								70.2197265625,
								33.45468749999998
							],
							[
								70.13417968750002,
								33.620751953124966
							],
							[
								70.05664062500006,
								33.719873046874994
							],
							[
								69.86806640625002,
								33.89765624999998
							],
							[
								69.88964843750006,
								34.00727539062501
							],
							[
								69.99472656250003,
								34.051806640625045
							],
							[
								70.25361328125007,
								33.97597656250005
							],
							[
								70.32568359375,
								33.96113281250004
							],
							[
								70.41572265625001,
								33.950439453125
							],
							[
								70.65400390625001,
								33.95229492187502
							],
							[
								70.84843749999999,
								33.98188476562501
							],
							[
								71.05156249999999,
								34.04970703125005
							],
							[
								71.09130859375,
								34.12026367187502
							],
							[
								71.08906250000007,
								34.20405273437504
							],
							[
								71.09238281250003,
								34.27324218750002
							],
							[
								71.095703125,
								34.36943359374999
							],
							[
								71.02294921875,
								34.43115234375006
							],
							[
								70.97890625000002,
								34.48627929687498
							],
							[
								70.96562499999999,
								34.530371093750006
							],
							[
								71.01630859375001,
								34.55463867187507
							],
							[
								71.06562500000001,
								34.599609375
							],
							[
								71.11328125000006,
								34.68159179687498
							],
							[
								71.22578125000001,
								34.77954101562506
							],
							[
								71.29414062500001,
								34.86772460937499
							],
							[
								71.35810546875001,
								34.90961914062501
							],
							[
								71.45507812500006,
								34.96694335937505
							],
							[
								71.51708984375006,
								35.05112304687506
							],
							[
								71.54550781250009,
								35.101416015625006
							],
							[
								71.60166015625003,
								35.15068359374999
							],
							[
								71.62050781250008,
								35.183007812499994
							],
							[
								71.60527343749999,
								35.211767578125006
							],
							[
								71.57724609375003,
								35.24799804687501
							],
							[
								71.54550781250009,
								35.28886718749999
							],
							[
								71.54550781250009,
								35.328515624999994
							],
							[
								71.57197265625007,
								35.37041015624999
							],
							[
								71.6005859375,
								35.40791015624998
							],
							[
								71.58740234375,
								35.46083984375002
							],
							[
								71.57197265625007,
								35.54682617187504
							],
							[
								71.51904296875,
								35.59750976562498
							],
							[
								71.48359375000007,
								35.71459960937503
							],
							[
								71.42753906250005,
								35.83374023437497
							],
							[
								71.39755859375003,
								35.88017578125002
							],
							[
								71.34287109375009,
								35.93852539062502
							],
							[
								71.22021484375006,
								36.00068359375007
							],
							[
								71.18505859375,
								36.04208984375006
							],
							[
								71.23291015625,
								36.12177734375004
							],
							[
								71.31259765625003,
								36.17119140624999
							],
							[
								71.46328125000002,
								36.29326171874999
							],
							[
								71.54589843750006,
								36.37768554687503
							],
							[
								71.62050781250008,
								36.43647460937501
							],
							[
								71.71640625000009,
								36.426562500000045
							],
							[
								71.77265625000007,
								36.43183593750004
							],
							[
								71.82226562500006,
								36.486083984375
							],
							[
								71.92070312500005,
								36.53417968750003
							],
							[
								72.09560546875008,
								36.63374023437507
							],
							[
								72.15673828125,
								36.70087890625007
							],
							[
								72.24980468750005,
								36.734716796875034
							],
							[
								72.32695312500005,
								36.74238281249998
							],
							[
								72.43115234375,
								36.76582031250007
							],
							[
								72.53134765625009,
								36.80200195312497
							],
							[
								72.62285156249999,
								36.82958984375
							],
							[
								72.76621093750009,
								36.835009765625045
							],
							[
								72.99375000000009,
								36.851611328125045
							],
							[
								73.11679687500009,
								36.86855468750002
							],
							[
								73.4111328125,
								36.881689453125034
							],
							[
								73.73183593750008,
								36.887792968750034
							],
							[
								73.76914062500003,
								36.88847656249999
							],
							[
								73.90781250000003,
								36.85292968750005
							],
							[
								74.00185546875002,
								36.823095703125006
							],
							[
								74.03886718749999,
								36.82573242187502
							],
							[
								74.19472656250002,
								36.89687500000002
							],
							[
								74.43105468750002,
								36.983691406250045
							],
							[
								74.54140624999997,
								37.02216796875007
							],
							[
								74.60058593750006,
								37.03666992187499
							],
							[
								74.69218750000016,
								37.03574218749998
							],
							[
								74.76601562500008,
								37.0127441406251
							],
							[
								74.84121093750014,
								36.97910156250009
							],
							[
								74.88925781250003,
								36.952441406250074
							],
							[
								74.94912109375008,
								36.96835937500012
							],
							[
								75.05390625000001,
								36.987158203125034
							],
							[
								75.14521484375007,
								36.973242187500034
							],
							[
								75.3466796875,
								36.91347656250002
							],
							[
								75.37685546875008,
								36.88369140625008
							],
							[
								75.42421875000014,
								36.73823242187504
							],
							[
								75.46025390625005,
								36.72504882812501
							],
							[
								75.57373046875006,
								36.759326171875074
							],
							[
								75.66718750000007,
								36.7419921875001
							],
							[
								75.77216796875018,
								36.694921875000006
							],
							[
								75.84023437500008,
								36.64970703125002
							],
							[
								75.88496093750007,
								36.600732421874994
							],
							[
								75.93300781250008,
								36.521582031250034
							],
							[
								75.95185546875007,
								36.45810546875006
							],
							[
								75.97441406250005,
								36.38242187500012
							],
							[
								75.96865234375014,
								36.16884765625002
							],
							[
								75.93408203125011,
								36.13393554687502
							],
							[
								75.90488281250003,
								36.08847656250009
							],
							[
								75.91230468750001,
								36.04897460937502
							],
							[
								75.94511718750005,
								36.01757812500003
							],
							[
								76.01044921875001,
								35.99633789062497
							],
							[
								76.07089843750009,
								35.983007812500006
							],
							[
								76.10332031250005,
								35.94921875000006
							],
							[
								76.14785156250014,
								35.82900390625008
							],
							[
								76.17783203125009,
								35.81054687500006
							],
							[
								76.25166015625007,
								35.81093750000002
							],
							[
								76.38574218750011,
								35.83715820312506
							],
							[
								76.50205078125009,
								35.878222656250074
							],
							[
								76.55126953125,
								35.88706054687509
							],
							[
								76.5634765625,
								35.772998046875045
							],
							[
								76.63183593750006,
								35.72939453125002
							],
							[
								76.72753906250011,
								35.6786621093751
							],
							[
								76.76689453125005,
								35.661718750000006
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "PAK",
					"su_a3": "PAK",
					"brk_group": "",
					"region_wb": "South Asia",
					"wb_a3": "PAK",
					"gu_a3": "PAK",
					"abbrev": "Pak.",
					"region_un": "Asia",
					"adm0_a3_us": "PAK",
					"scalerank": 1,
					"pop_est": 176242949,
					"adm0_dif": 0,
					"un_a3": "586",
					"pop_year": -99,
					"gdp_md_est": 427300,
					"name": "Pakistan",
					"sovereignt": "Pakistan",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Pakistan",
					"postal": "PK",
					"sov_a3": "PAK",
					"note_brk": "",
					"brk_a3": "PAK",
					"wb_a2": "PK",
					"brk_diff": 0,
					"admin": "Pakistan",
					"name_long": "Pakistan",
					"iso_a3": "PAK",
					"iso_a2": "PK",
					"adm0_a3_is": "PAK",
					"level": 2,
					"formal_en": "Islamic Republic of Pakistan",
					"name_len": 8,
					"mapcolor7": 2,
					"long_len": 8,
					"mapcolor8": 2,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "586",
					"homepart": 1,
					"subunit": "Pakistan",
					"name_alt": "",
					"brk_name": "Pakistan",
					"name_sort": "Pakistan",
					"continent": "Asia",
					"mapcolor13": 11,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 1998
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-69.96591796875003,
								-4.235937499999963
							],
							[
								-69.97202148437495,
								-4.301171874999923
							],
							[
								-70.00395507812496,
								-4.327246093749906
							],
							[
								-70.05332031249998,
								-4.333105468750034
							],
							[
								-70.12880859375,
								-4.286621093749886
							],
							[
								-70.18398437499997,
								-4.298144531250017
							],
							[
								-70.23916015625002,
								-4.301171874999923
							],
							[
								-70.31689453124994,
								-4.24697265624998
							],
							[
								-70.34365234375,
								-4.19365234374996
							],
							[
								-70.40463867187498,
								-4.150097656249969
							],
							[
								-70.5306640625,
								-4.167578124999977
							],
							[
								-70.63457031250002,
								-4.168652343749926
							],
							[
								-70.72158203124997,
								-4.158886718749983
							],
							[
								-70.79951171874995,
								-4.1733398437499005
							],
							[
								-70.86601562499999,
								-4.229589843749906
							],
							[
								-70.91562499999998,
								-4.29531249999998
							],
							[
								-70.97368164062499,
								-4.350488281250023
							],
							[
								-71.14423828125001,
								-4.387207031249957
							],
							[
								-71.23500976562494,
								-4.388183593749972
							],
							[
								-71.316796875,
								-4.424316406249972
							],
							[
								-71.43828124999996,
								-4.437597656250006
							],
							[
								-71.52133789062492,
								-4.469726562499886
							],
							[
								-71.66835937499994,
								-4.487304687499915
							],
							[
								-71.8447265625,
								-4.504394531249943
							],
							[
								-71.94316406249999,
								-4.553320312499963
							],
							[
								-71.98242187499997,
								-4.5746093749999375
							],
							[
								-72.08251953124994,
								-4.642285156249969
							],
							[
								-72.25678710937501,
								-4.748925781249923
							],
							[
								-72.35283203124996,
								-4.7860351562499375
							],
							[
								-72.468994140625,
								-4.901269531249966
							],
							[
								-72.60834960937495,
								-5.009570312500003
							],
							[
								-72.69873046874997,
								-5.067187500000017
							],
							[
								-72.83193359374994,
								-5.093749999999929
							],
							[
								-72.88706054687498,
								-5.122753906249969
							],
							[
								-72.90747070312497,
								-5.157714843749986
							],
							[
								-72.89580078124999,
								-5.1982421874999005
							],
							[
								-72.91826171874993,
								-5.302539062500003
							],
							[
								-72.95893554687498,
								-5.495214843749906
							],
							[
								-72.97021484374997,
								-5.58964843749996
							],
							[
								-72.97988281249997,
								-5.634863281249935
							],
							[
								-73.06806640625001,
								-5.789550781249929
							],
							[
								-73.16289062499996,
								-5.933398437499918
							],
							[
								-73.20937500000002,
								-6.02871093749998
							],
							[
								-73.23554687500001,
								-6.098437499999974
							],
							[
								-73.20649414062495,
								-6.156445312499969
							],
							[
								-73.16772460937497,
								-6.26064453124998
							],
							[
								-73.13535156249995,
								-6.344335937499977
							],
							[
								-73.12631835937498,
								-6.400878906249943
							],
							[
								-73.137353515625,
								-6.465820312500028
							],
							[
								-73.17744140624998,
								-6.52519531249996
							],
							[
								-73.24033203124992,
								-6.564062499999977
							],
							[
								-73.32548828124996,
								-6.574707031249915
							],
							[
								-73.49990234374997,
								-6.679492187499946
							],
							[
								-73.69453124999998,
								-6.833789062500031
							],
							[
								-73.75810546874999,
								-6.905761718749957
							],
							[
								-73.77626953124994,
								-6.973535156249909
							],
							[
								-73.80463867187495,
								-7.079882812499903
							],
							[
								-73.79301757812499,
								-7.135058593749946
							],
							[
								-73.758203125,
								-7.172753906249895
							],
							[
								-73.72333984375001,
								-7.262792968750034
							],
							[
								-73.72041015624993,
								-7.309277343749912
							],
							[
								-73.74946289062498,
								-7.33535156249998
							],
							[
								-73.80463867187495,
								-7.341210937500023
							],
							[
								-73.85400390624997,
								-7.349902343750017
							],
							[
								-73.89174804687494,
								-7.373144531249963
							],
							[
								-73.92944335937497,
								-7.367285156250006
							],
							[
								-73.96430664062498,
								-7.378906249999972
							],
							[
								-73.96430664062498,
								-7.4166992187499545
							],
							[
								-73.95268554687502,
								-7.460253906249946
							],
							[
								-73.95849609374994,
								-7.506640624999974
							],
							[
								-73.98173828124999,
								-7.535742187499949
							],
							[
								-74.00205078124995,
								-7.556054687499923
							],
							[
								-73.98173828124999,
								-7.585058593749963
							],
							[
								-73.94687499999998,
								-7.611230468749966
							],
							[
								-73.89462890625,
								-7.654785156249957
							],
							[
								-73.82207031249996,
								-7.738964843749969
							],
							[
								-73.76689453124999,
								-7.753515624999906
							],
							[
								-73.72041015624993,
								-7.78251953124996
							],
							[
								-73.714599609375,
								-7.829003906249923
							],
							[
								-73.73203125,
								-7.875390624999966
							],
							[
								-73.77270507812503,
								-7.895703125000011
							],
							[
								-73.77558593749998,
								-7.936425781249966
							],
							[
								-73.72041015624993,
								-7.985742187499966
							],
							[
								-73.68266601562499,
								-8.020605468749963
							],
							[
								-73.64492187500002,
								-8.072851562499949
							],
							[
								-73.61010742187503,
								-8.145410156249909
							],
							[
								-73.61010742187503,
								-8.191894531249957
							],
							[
								-73.57236328124998,
								-8.249902343749966
							],
							[
								-73.54912109374996,
								-8.2993164062499
							],
							[
								-73.54912109374996,
								-8.345800781249963
							],
							[
								-73.48813476562495,
								-8.392187499999906
							],
							[
								-73.43588867187498,
								-8.427050781249903
							],
							[
								-73.39814453125001,
								-8.458984375000014
							],
							[
								-73.36040039062496,
								-8.479296874999974
							],
							[
								-73.35170898437497,
								-8.514160156249972
							],
							[
								-73.35673828125002,
								-8.566992187499991
							],
							[
								-73.30244140624995,
								-8.654003906249955
							],
							[
								-73.20312499999997,
								-8.719335937499949
							],
							[
								-73.12255859375,
								-8.814062499999963
							],
							[
								-73.07050781249995,
								-8.882812500000028
							],
							[
								-72.97402343750002,
								-8.993164062499957
							],
							[
								-72.970361328125,
								-9.120117187499972
							],
							[
								-73.08984375,
								-9.265722656249963
							],
							[
								-73.20942382812493,
								-9.411425781249903
							],
							[
								-73.01376953124995,
								-9.407421874999969
							],
							[
								-72.81425781249999,
								-9.41035156249994
							],
							[
								-72.60546875,
								-9.452050781249909
							],
							[
								-72.46474609375002,
								-9.492187499999915
							],
							[
								-72.37905273437497,
								-9.510156249999937
							],
							[
								-72.31806640624998,
								-9.5566406249999
							],
							[
								-72.28901367187501,
								-9.629199218750031
							],
							[
								-72.26582031249998,
								-9.688476562500028
							],
							[
								-72.25996093749995,
								-9.774316406249937
							],
							[
								-72.17285156249997,
								-9.844042968749932
							],
							[
								-72.1791015625,
								-9.9101562499999
							],
							[
								-72.18159179687495,
								-10.003710937499946
							],
							[
								-72.14296875,
								-10.005175781249974
							],
							[
								-71.887451171875,
								-10.005566406249969
							],
							[
								-71.6080078125,
								-10.006054687499983
							],
							[
								-71.33940429687499,
								-9.988574218749974
							],
							[
								-71.23793945312502,
								-9.966015624999912
							],
							[
								-71.11528320312499,
								-9.852441406250037
							],
							[
								-71.041748046875,
								-9.818749999999923
							],
							[
								-70.97075195312493,
								-9.765722656249963
							],
							[
								-70.88452148437494,
								-9.669042968749977
							],
							[
								-70.81625976562498,
								-9.625292968749946
							],
							[
								-70.75849609374995,
								-9.571679687500037
							],
							[
								-70.6724609375,
								-9.517968749999937
							],
							[
								-70.63691406249995,
								-9.478222656249912
							],
							[
								-70.60791015625,
								-9.463671874999974
							],
							[
								-70.54111328124998,
								-9.437499999999972
							],
							[
								-70.57016601562495,
								-9.489843749999977
							],
							[
								-70.59223632812501,
								-9.543457031249972
							],
							[
								-70.59916992187499,
								-9.620507812500037
							],
							[
								-70.56723632812498,
								-9.704589843749943
							],
							[
								-70.59379882812496,
								-9.767480468749966
							],
							[
								-70.63691406249995,
								-9.823730468749957
							],
							[
								-70.63759765625,
								-9.97177734374992
							],
							[
								-70.63852539062492,
								-10.181542968749937
							],
							[
								-70.63935546875001,
								-10.361328124999972
							],
							[
								-70.64033203124995,
								-10.58603515624992
							],
							[
								-70.64155273437501,
								-10.840820312499957
							],
							[
								-70.642333984375,
								-11.010253906250014
							],
							[
								-70.59653320312498,
								-10.97685546874996
							],
							[
								-70.53325195312499,
								-10.946874999999977
							],
							[
								-70.45087890624998,
								-11.024804687499966
							],
							[
								-70.39228515624995,
								-11.058593749999915
							],
							[
								-70.34199218750001,
								-11.066699218749974
							],
							[
								-70.29038085937498,
								-11.064257812500003
							],
							[
								-70.22006835937495,
								-11.047656249999903
							],
							[
								-70.06630859374997,
								-10.982421875000028
							],
							[
								-69.96035156249997,
								-10.929882812499983
							],
							[
								-69.83979492187501,
								-10.933398437499989
							],
							[
								-69.67402343749998,
								-10.954101562499943
							],
							[
								-69.57861328125,
								-10.951757812500006
							],
							[
								-69.45361328125003,
								-11.168749999999974
							],
							[
								-69.36201171875001,
								-11.327539062499994
							],
							[
								-69.25771484375,
								-11.508593750000017
							],
							[
								-69.17373046874994,
								-11.654296874999957
							],
							[
								-69.04619140624999,
								-11.875683593750026
							],
							[
								-68.93603515625,
								-12.066796874999966
							],
							[
								-68.818701171875,
								-12.270410156249966
							],
							[
								-68.68525390624998,
								-12.501953124999986
							],
							[
								-68.72812499999992,
								-12.560742187499969
							],
							[
								-68.76289062499998,
								-12.607714843750031
							],
							[
								-68.75908203125002,
								-12.687207031249969
							],
							[
								-68.81181640625002,
								-12.729589843749991
							],
							[
								-68.86767578125003,
								-12.75517578124996
							],
							[
								-68.933740234375,
								-12.822070312500003
							],
							[
								-68.97861328124998,
								-12.880078125000011
							],
							[
								-68.98051757812502,
								-12.96259765625004
							],
							[
								-68.97226562499992,
								-13.382324218750014
							],
							[
								-68.98344726562499,
								-13.496386718749974
							],
							[
								-69.01752929687501,
								-13.594433593749969
							],
							[
								-69.05283203125,
								-13.643945312500023
							],
							[
								-69.07412109375,
								-13.68281250000004
							],
							[
								-69.02304687499998,
								-13.7802734375
							],
							[
								-68.974267578125,
								-13.97597656249998
							],
							[
								-68.93745117187504,
								-14.014648437499957
							],
							[
								-68.89169921874995,
								-14.094335937500034
							],
							[
								-68.87089843749996,
								-14.169726562500017
							],
							[
								-68.88032226562504,
								-14.198828125000006
							],
							[
								-68.97177734375,
								-14.234374999999957
							],
							[
								-69.00449218749992,
								-14.265039062499994
							],
							[
								-69.01313476562498,
								-14.377246093750017
							],
							[
								-69.05278320312499,
								-14.417578124999977
							],
							[
								-69.11972656249995,
								-14.470312499999977
							],
							[
								-69.1626953125,
								-14.530957031249983
							],
							[
								-69.19926757812499,
								-14.572558593750017
							],
							[
								-69.23491210937496,
								-14.597070312500037
							],
							[
								-69.25234374999997,
								-14.671093750000026
							],
							[
								-69.276025390625,
								-14.745898437499989
							],
							[
								-69.35947265624995,
								-14.795312500000023
							],
							[
								-69.37373046875001,
								-14.887499999999974
							],
							[
								-69.37470703125004,
								-14.962988281249977
							],
							[
								-69.33071289062494,
								-15.038964843750009
							],
							[
								-69.187109375,
								-15.198730468749957
							],
							[
								-69.17246093749995,
								-15.236621093750045
							],
							[
								-69.25429687500002,
								-15.332910156250023
							],
							[
								-69.30190429687494,
								-15.399414062499986
							],
							[
								-69.36469483081456,
								-15.509271202700901
							],
							[
								-69.40537109374998,
								-15.491015625000003
							],
							[
								-69.44873046875,
								-15.473632812500014
							],
							[
								-69.54135742187495,
								-15.372265624999969
							],
							[
								-69.62509765624998,
								-15.343554687499974
							],
							[
								-69.68686523437495,
								-15.264160156249972
							],
							[
								-69.74179687499995,
								-15.269140625000006
							],
							[
								-69.76093750000001,
								-15.286914062499989
							],
							[
								-69.79873046875,
								-15.298925781250034
							],
							[
								-69.83295898437504,
								-15.309765625000026
							],
							[
								-69.84370117187501,
								-15.324316406249963
							],
							[
								-69.85473632812494,
								-15.343847656250034
							],
							[
								-69.91396484375002,
								-15.374414062500051
							],
							[
								-69.938232421875,
								-15.398730468750031
							],
							[
								-69.92939453124995,
								-15.427343749999991
							],
							[
								-69.86948242187492,
								-15.533007812500031
							],
							[
								-69.81840820312502,
								-15.638476562500017
							],
							[
								-69.79775390624997,
								-15.693457031250034
							],
							[
								-69.81806640625001,
								-15.691601562500011
							],
							[
								-69.86621093749997,
								-15.659863281250026
							],
							[
								-69.92065429687497,
								-15.633886718749977
							],
							[
								-69.95634765624996,
								-15.646191406249997
							],
							[
								-69.97895507812504,
								-15.679980468750031
							],
							[
								-70.00185546875,
								-15.705859374999974
							],
							[
								-70.01694335937495,
								-15.73349609375002
							],
							[
								-70.02060546874998,
								-15.771484375000028
							],
							[
								-70.01601562499994,
								-15.80683593750004
							],
							[
								-70.01098632812497,
								-15.828125000000014
							],
							[
								-69.99418945312493,
								-15.842089843750017
							],
							[
								-69.96113281250004,
								-15.85986328125
							],
							[
								-69.92333984374997,
								-15.87998046875002
							],
							[
								-69.89521484375001,
								-15.899511718749991
							],
							[
								-69.87563476562494,
								-15.913574218750014
							],
							[
								-69.85864257812503,
								-15.920410156249986
							],
							[
								-69.845361328125,
								-15.920019531250006
							],
							[
								-69.83481445312498,
								-15.91640624999998
							],
							[
								-69.83344726562495,
								-15.90458984374996
							],
							[
								-69.84218749999997,
								-15.88437500000002
							],
							[
								-69.85224609374998,
								-15.860742187500009
							],
							[
								-69.85385742187495,
								-15.840722656250009
							],
							[
								-69.8462890625,
								-15.82724609375002
							],
							[
								-69.83408203125,
								-15.8193359375
							],
							[
								-69.81245117187504,
								-15.828222656250034
							],
							[
								-69.78208007812498,
								-15.854980468749986
							],
							[
								-69.74794921874994,
								-15.886523437500017
							],
							[
								-69.71728515625,
								-15.906542968750003
							],
							[
								-69.69125976562495,
								-15.922070312499969
							],
							[
								-69.66826171874996,
								-15.942675781250003
							],
							[
								-69.62734375,
								-15.966699218750009
							],
							[
								-69.55810546875,
								-15.990917968749969
							],
							[
								-69.48867187499997,
								-16.012304687499977
							],
							[
								-69.44721679687495,
								-16.02949218750001
							],
							[
								-69.43881835937495,
								-16.059472656249994
							],
							[
								-69.44931640624995,
								-16.11171874999998
							],
							[
								-69.48701171874998,
								-16.161425781249974
							],
							[
								-69.48310546874998,
								-16.181933593749974
							],
							[
								-69.43618164062494,
								-16.186914062500023
							],
							[
								-69.40043945312493,
								-16.20039062500001
							],
							[
								-69.36630859375,
								-16.22294921874999
							],
							[
								-69.32407226562492,
								-16.243066406249994
							],
							[
								-69.26865234375,
								-16.250878906249994
							],
							[
								-69.22163085937501,
								-16.254101562500026
							],
							[
								-69.17753906250002,
								-16.249804687500045
							],
							[
								-69.13564453125,
								-16.232128906249997
							],
							[
								-69.13280677061198,
								-16.22190557313712
							],
							[
								-69.04624023437498,
								-16.21767578124998
							],
							[
								-68.97995539471842,
								-16.239762601672524
							],
							[
								-69.00512695312497,
								-16.25195312500003
							],
							[
								-69.043701171875,
								-16.281054687500017
							],
							[
								-69.04306640624998,
								-16.318164062500017
							],
							[
								-69.03867187499995,
								-16.36445312500004
							],
							[
								-69.05185546874998,
								-16.41738281249998
							],
							[
								-69.09819335937502,
								-16.48349609375005
							],
							[
								-69.07612304687504,
								-16.520996093749957
							],
							[
								-69.04941406249992,
								-16.525488281249977
							],
							[
								-69.03753779494983,
								-16.532417227357527
							],
							[
								-69.03837890624999,
								-16.542675781250026
							],
							[
								-69.02070312500004,
								-16.64218750000005
							],
							[
								-69.054541015625,
								-16.674316406250014
							],
							[
								-69.13251953124998,
								-16.71308593750001
							],
							[
								-69.19980468749992,
								-16.76845703125001
							],
							[
								-69.267236328125,
								-16.86093750000002
							],
							[
								-69.38154296875001,
								-17.001367187500037
							],
							[
								-69.42109374999998,
								-17.0400390625
							],
							[
								-69.43833007812492,
								-17.08837890625
							],
							[
								-69.50332031249994,
								-17.10478515624996
							],
							[
								-69.624853515625,
								-17.200195312500043
							],
							[
								-69.64570312499998,
								-17.24853515625003
							],
							[
								-69.62587890624994,
								-17.294433593749957
							],
							[
								-69.563818359375,
								-17.33291015624998
							],
							[
								-69.52192382812501,
								-17.38896484375003
							],
							[
								-69.510986328125,
								-17.46035156250001
							],
							[
								-69.51108398437492,
								-17.50488281250003
							],
							[
								-69.51093749999998,
								-17.506054687499997
							],
							[
								-69.58642578125,
								-17.573242187500014
							],
							[
								-69.68476562499995,
								-17.64980468749998
							],
							[
								-69.80610351562498,
								-17.664941406250037
							],
							[
								-69.85209960937493,
								-17.70380859374997
							],
							[
								-69.84150390625001,
								-17.785156250000014
							],
							[
								-69.80244140624995,
								-17.899999999999963
							],
							[
								-69.80258789062498,
								-17.990234374999957
							],
							[
								-69.83969726562498,
								-18.093457031250026
							],
							[
								-69.92636718749998,
								-18.20605468749997
							],
							[
								-70.05908203125,
								-18.283496093750017
							],
							[
								-70.18378906250001,
								-18.325195312499986
							],
							[
								-70.28227539062502,
								-18.325390625000026
							],
							[
								-70.37749023437496,
								-18.33359375000002
							],
							[
								-70.41826171874999,
								-18.34560546874998
							],
							[
								-70.49160156250002,
								-18.27773437500001
							],
							[
								-70.81748046874998,
								-18.05253906249996
							],
							[
								-70.94169921874996,
								-17.93203125000001
							],
							[
								-71.05659179687501,
								-17.875683593749983
							],
							[
								-71.33696289062493,
								-17.68251953124998
							],
							[
								-71.36494140625004,
								-17.62050781250005
							],
							[
								-71.39941406249994,
								-17.421972656250006
							],
							[
								-71.43588867187492,
								-17.366015624999974
							],
							[
								-71.5322265625,
								-17.294335937500037
							],
							[
								-71.77446289062499,
								-17.19882812500002
							],
							[
								-71.86835937500001,
								-17.151074218749983
							],
							[
								-71.96689453124992,
								-17.06406250000002
							],
							[
								-72.11127929687504,
								-17.002539062500006
							],
							[
								-72.26860351562502,
								-16.87617187500001
							],
							[
								-72.36249999999995,
								-16.775000000000006
							],
							[
								-72.46767578125,
								-16.708105468749977
							],
							[
								-72.79394531250003,
								-16.614550781250003
							],
							[
								-72.95771484374998,
								-16.520898437500023
							],
							[
								-73.26376953124998,
								-16.38857421874998
							],
							[
								-73.40004882812497,
								-16.304296875000034
							],
							[
								-73.727685546875,
								-16.20166015625
							],
							[
								-73.824951171875,
								-16.15283203125
							],
							[
								-74.1470703125,
								-15.91249999999998
							],
							[
								-74.372900390625,
								-15.833984374999972
							],
							[
								-74.55488281250004,
								-15.699023437500003
							],
							[
								-75.10424804687494,
								-15.41191406249996
							],
							[
								-75.19052734374995,
								-15.320117187500003
							],
							[
								-75.27456054687502,
								-15.178125000000023
							],
							[
								-75.39658203125,
								-15.093554687500031
							],
							[
								-75.53364257812504,
								-14.89921874999996
							],
							[
								-75.73769531249997,
								-14.784960937500045
							],
							[
								-75.93388671874996,
								-14.633593750000017
							],
							[
								-76.00629882812495,
								-14.495800781250011
							],
							[
								-76.13647460937503,
								-14.320312499999972
							],
							[
								-76.17514648437498,
								-14.226660156249991
							],
							[
								-76.28901367187501,
								-14.133105468750017
							],
							[
								-76.29702148437494,
								-13.948437499999969
							],
							[
								-76.37646484374997,
								-13.863085937499989
							],
							[
								-76.319482421875,
								-13.82148437500004
							],
							[
								-76.25922851562498,
								-13.802832031249977
							],
							[
								-76.183935546875,
								-13.515234375000006
							],
							[
								-76.2236328125,
								-13.371191406249963
							],
							[
								-76.42734374999995,
								-13.109960937500034
							],
							[
								-76.50214843749998,
								-12.984375000000028
							],
							[
								-76.55522460937496,
								-12.823437500000011
							],
							[
								-76.63710937499997,
								-12.728027343750028
							],
							[
								-76.75800781249998,
								-12.52714843749996
							],
							[
								-76.83212890624998,
								-12.348730468750034
							],
							[
								-76.99409179687504,
								-12.219238281250028
							],
							[
								-77.03813476562493,
								-12.172753906249966
							],
							[
								-77.06269531249998,
								-12.106835937499952
							],
							[
								-77.15273437500002,
								-12.060351562499989
							],
							[
								-77.15761718749994,
								-11.923437499999977
							],
							[
								-77.22031249999992,
								-11.663378906250031
							],
							[
								-77.30991210937498,
								-11.532421874999997
							],
							[
								-77.63320312499994,
								-11.287792968749983
							],
							[
								-77.63857421874997,
								-11.193554687499969
							],
							[
								-77.66430664062497,
								-11.02207031250002
							],
							[
								-77.73608398437503,
								-10.836718750000017
							],
							[
								-78.09545898437497,
								-10.26064453124998
							],
							[
								-78.18559570312493,
								-10.089062500000011
							],
							[
								-78.27558593749998,
								-9.810351562499989
							],
							[
								-78.35649414062493,
								-9.652050781249983
							],
							[
								-78.44565429687498,
								-9.370605468750014
							],
							[
								-78.58012695312493,
								-9.156640625000037
							],
							[
								-78.66459960937502,
								-8.97109374999998
							],
							[
								-78.75458984374995,
								-8.740429687499983
							],
							[
								-78.76225585937502,
								-8.61699218749996
							],
							[
								-78.92539062499995,
								-8.404589843749946
							],
							[
								-79.01225585937496,
								-8.21015625000004
							],
							[
								-79.16440429687495,
								-8.04716796874996
							],
							[
								-79.312841796875,
								-7.923242187500023
							],
							[
								-79.37724609374999,
								-7.83554687500002
							],
							[
								-79.5888671875,
								-7.418945312499957
							],
							[
								-79.61772460937493,
								-7.295605468749969
							],
							[
								-79.76196289062503,
								-7.06650390625002
							],
							[
								-79.90468749999997,
								-6.901660156250003
							],
							[
								-79.99497070312498,
								-6.768945312499966
							],
							[
								-80.11025390625,
								-6.649609374999997
							],
							[
								-80.81162109374998,
								-6.282226562500014
							],
							[
								-81.058447265625,
								-6.129394531249972
							],
							[
								-81.14204101562498,
								-6.056738281250006
							],
							[
								-81.180517578125,
								-5.942382812499972
							],
							[
								-81.16430664062497,
								-5.875292968749989
							],
							[
								-81.09184570312496,
								-5.812402343749966
							],
							[
								-80.99165039062498,
								-5.8609374999999915
							],
							[
								-80.9306640625,
								-5.840820312499972
							],
							[
								-80.88271484375,
								-5.758984374999997
							],
							[
								-80.88193359374992,
								-5.635058593749974
							],
							[
								-80.94311523437494,
								-5.47539062499996
							],
							[
								-81.16767578124995,
								-5.167089843750034
							],
							[
								-81.15073242187498,
								-5.101855468749974
							],
							[
								-81.10849609374998,
								-5.02783203125
							],
							[
								-81.19506835937494,
								-4.879492187499977
							],
							[
								-81.28940429687498,
								-4.760742187500028
							],
							[
								-81.33662109375001,
								-4.669531250000006
							],
							[
								-81.28320312499997,
								-4.322265624999957
							],
							[
								-81.23203124999992,
								-4.23427734374998
							],
							[
								-80.891943359375,
								-3.8816406249999886
							],
							[
								-80.798583984375,
								-3.731054687499949
							],
							[
								-80.65273437499994,
								-3.638183593749943
							],
							[
								-80.50366210937494,
								-3.4960937499999574
							],
							[
								-80.32465820312498,
								-3.3878906250000256
							],
							[
								-80.29833984374994,
								-3.406445312499983
							],
							[
								-80.27353515624998,
								-3.42460937499996
							],
							[
								-80.271875,
								-3.4610351562500057
							],
							[
								-80.26523437499995,
								-3.492480468750017
							],
							[
								-80.24541015625002,
								-3.5221679687500256
							],
							[
								-80.24374999999995,
								-3.576757812499963
							],
							[
								-80.22060546875002,
								-3.6131835937499233
							],
							[
								-80.21894531249995,
								-3.654492187499983
							],
							[
								-80.21728515624997,
								-3.7107421874999034
							],
							[
								-80.22885742187492,
								-3.738867187499949
							],
							[
								-80.21757812499993,
								-3.787695312499949
							],
							[
								-80.17924804687493,
								-3.8777343749999886
							],
							[
								-80.19414062499996,
								-3.905859375000034
							],
							[
								-80.23051757812499,
								-3.924023437499912
							],
							[
								-80.26689453124993,
								-3.948828124999906
							],
							[
								-80.30327148437499,
								-4.005078124999997
							],
							[
								-80.35786132812501,
								-4.003417968750014
							],
							[
								-80.43720703125001,
								-3.9786132812499346
							],
							[
								-80.49013671874994,
								-4.010058593749946
							],
							[
								-80.510009765625,
								-4.069531249999983
							],
							[
								-80.49345703125002,
								-4.119140624999972
							],
							[
								-80.48847656249995,
								-4.16552734375
							],
							[
								-80.453759765625,
								-4.205175781249906
							],
							[
								-80.35288085937498,
								-4.208496093749957
							],
							[
								-80.44384765625003,
								-4.335839843749966
							],
							[
								-80.48847656249995,
								-4.393652343749935
							],
							[
								-80.47856445312499,
								-4.43007812499998
							],
							[
								-80.42416992187492,
								-4.461425781249972
							],
							[
								-80.38349609374998,
								-4.463671874999989
							],
							[
								-80.293359375,
								-4.416796875000031
							],
							[
								-80.23217773437497,
								-4.349023437499909
							],
							[
								-80.19746093750001,
								-4.311035156249886
							],
							[
								-80.13955078125002,
								-4.2960937499999545
							],
							[
								-80.06352539062499,
								-4.327539062499966
							],
							[
								-79.962890625,
								-4.390332031249969
							],
							[
								-79.8451171875,
								-4.44589843749992
							],
							[
								-79.79726562500002,
								-4.476367187499918
							],
							[
								-79.71098632812493,
								-4.467578124999903
							],
							[
								-79.638525390625,
								-4.454882812499974
							],
							[
								-79.57768554687496,
								-4.500585937499963
							],
							[
								-79.51616210937493,
								-4.53916015624992
							],
							[
								-79.50190429687498,
								-4.6706054687499545
							],
							[
								-79.45576171874998,
								-4.766210937499892
							],
							[
								-79.39941406249997,
								-4.840039062499926
							],
							[
								-79.33095703124997,
								-4.927832031249963
							],
							[
								-79.26811523437496,
								-4.957617187499906
							],
							[
								-79.18666992187497,
								-4.958203124999926
							],
							[
								-79.07626953124995,
								-4.990624999999966
							],
							[
								-79.03330078124998,
								-4.9691406249999375
							],
							[
								-78.99526367187497,
								-4.908007812499918
							],
							[
								-78.97539062499999,
								-4.87324218749994
							],
							[
								-78.919189453125,
								-4.858398437499943
							],
							[
								-78.91420898437497,
								-4.818652343749918
							],
							[
								-78.92578125000003,
								-4.770703125000011
							],
							[
								-78.90761718749997,
								-4.71445312499992
							],
							[
								-78.86152343749998,
								-4.665039062499886
							],
							[
								-78.74306640625,
								-4.59267578124998
							],
							[
								-78.68603515625003,
								-4.5624023437499375
							],
							[
								-78.67446289062497,
								-4.517675781249977
							],
							[
								-78.65292968749995,
								-4.45820312499994
							],
							[
								-78.66123046874995,
								-4.425097656249946
							],
							[
								-78.68515624999992,
								-4.383984374999926
							],
							[
								-78.67939453125001,
								-4.325878906249983
							],
							[
								-78.64799804687499,
								-4.248144531249963
							],
							[
								-78.60336914062498,
								-4.157324218749935
							],
							[
								-78.56513671874998,
								-4.041601562499977
							],
							[
								-78.55043945312502,
								-3.9869140624999346
							],
							[
								-78.50908203124993,
								-3.9521484374999574
							],
							[
								-78.49345703124996,
								-3.9020507812499687
							],
							[
								-78.47104492187492,
								-3.8430664062500313
							],
							[
								-78.41977539062495,
								-3.7768554687499574
							],
							[
								-78.42143554687493,
								-3.7057617187499545
							],
							[
								-78.39995117187502,
								-3.674316406249943
							],
							[
								-78.39804687499998,
								-3.594824218749906
							],
							[
								-78.34726562499992,
								-3.4312499999999773
							],
							[
								-78.345361328125,
								-3.397363281249909
							],
							[
								-78.32304687499996,
								-3.3882812499999346
							],
							[
								-78.28417968749994,
								-3.399023437499892
							],
							[
								-78.25073242187497,
								-3.436132812499906
							],
							[
								-78.240380859375,
								-3.4725585937499517
							],
							[
								-78.22631835937497,
								-3.489160156249966
							],
							[
								-78.19487304687496,
								-3.4858398437499147
							],
							[
								-78.15849609375002,
								-3.46513671874996
							],
							[
								-78.160986328125,
								-3.4321289062498863
							],
							[
								-78.18745117187495,
								-3.399804687499966
							],
							[
								-78.19462890625002,
								-3.3804687499999346
							],
							[
								-78.18330078125001,
								-3.350195312499892
							],
							[
								-78.12822265624999,
								-3.283886718749983
							],
							[
								-78.06791992187496,
								-3.2068359374999176
							],
							[
								-77.93847656249997,
								-3.0469726562499346
							],
							[
								-77.860595703125,
								-2.98164062500004
							],
							[
								-77.65898437499996,
								-2.9124023437499744
							],
							[
								-77.50649414062497,
								-2.859960937499949
							],
							[
								-77.36005859374998,
								-2.809667968749906
							],
							[
								-77.16147460937495,
								-2.737695312499909
							],
							[
								-76.88076171874994,
								-2.6359374999999545
							],
							[
								-76.6791015625,
								-2.5625976562499346
							],
							[
								-76.49936523437495,
								-2.43232421875004
							],
							[
								-76.36015624999993,
								-2.3313476562499034
							],
							[
								-76.24091796874998,
								-2.2439453125000313
							],
							[
								-76.08979492187501,
								-2.1331054687499176
							],
							[
								-75.88544921874995,
								-1.893457031250037
							],
							[
								-75.74453125000002,
								-1.7281249999999346
							],
							[
								-75.64165039062502,
								-1.6073242187500085
							],
							[
								-75.570556640625,
								-1.5312499999999716
							],
							[
								-75.51386718750001,
								-1.316308593749966
							],
							[
								-75.44916992187498,
								-1.0711914062499375
							],
							[
								-75.42041015624997,
								-0.9622070312500313
							],
							[
								-75.40805664062495,
								-0.9243164062499574
							],
							[
								-75.38012695312503,
								-0.9402343749999034
							],
							[
								-75.34819335937502,
								-0.9667968749999005
							],
							[
								-75.30917968749995,
								-0.9680664062498892
							],
							[
								-75.27241210937493,
								-0.9667968749999005
							],
							[
								-75.249609375,
								-0.9518554687499687
							],
							[
								-75.28359375,
								-0.7071289062499346
							],
							[
								-75.27871093749997,
								-0.6539062499999346
							],
							[
								-75.25937499999995,
								-0.5901367187499034
							],
							[
								-75.26323242187502,
								-0.5553710937499261
							],
							[
								-75.32524414062496,
								-0.5065429687499261
							],
							[
								-75.42470703124997,
								-0.4088867187499261
							],
							[
								-75.46596679687502,
								-0.32177734374994316
							],
							[
								-75.49106445312498,
								-0.24833984374990337
							],
							[
								-75.56059570312493,
								-0.20009765625002274
							],
							[
								-75.63203125000001,
								-0.1576171874999801
							],
							[
								-75.62626953124999,
								-0.12285156249991758
							],
							[
								-75.58374023437503,
								-0.12285156249991758
							],
							[
								-75.47597656250002,
								-0.1571289062499801
							],
							[
								-75.39838867187501,
								-0.1459960937500142
							],
							[
								-75.34047851562494,
								-0.14218749999994884
							],
							[
								-75.28447265624999,
								-0.10654296874997726
							],
							[
								-75.22460937499997,
								-0.041748046874914735
							],
							[
								-75.18408203124997,
								-0.041748046874914735
							],
							[
								-75.13837890624998,
								-0.050488281249926104
							],
							[
								-75.05468749999997,
								-0.11669921874991473
							],
							[
								-75.00498046874998,
								-0.15585937499997726
							],
							[
								-74.9453125,
								-0.1881835937499119
							],
							[
								-74.88881835937494,
								-0.19941406249996874
							],
							[
								-74.83749999999998,
								-0.20332031249996874
							],
							[
								-74.80175781249997,
								-0.20009765625002274
							],
							[
								-74.78046874999998,
								-0.24453124999992326
							],
							[
								-74.75537109375003,
								-0.2986328124999318
							],
							[
								-74.691650390625,
								-0.3352539062499318
							],
							[
								-74.61635742187494,
								-0.37001953124990905
							],
							[
								-74.555078125,
								-0.4298828124999403
							],
							[
								-74.51386718749993,
								-0.4701171874999659
							],
							[
								-74.46518554687498,
								-0.5176757812499773
							],
							[
								-74.41787109375002,
								-0.5806640624999346
							],
							[
								-74.37490234374997,
								-0.691406249999929
							],
							[
								-74.35312499999998,
								-0.7666015624999716
							],
							[
								-74.32861328124994,
								-0.8083984374999602
							],
							[
								-74.33442382812498,
								-0.8508789062499176
							],
							[
								-74.28388671874998,
								-0.927832031249963
							],
							[
								-74.24638671874999,
								-0.9706054687499659
							],
							[
								-74.18076171874992,
								-0.9977539062498977
							],
							[
								-74.05439453124995,
								-1.0286132812499744
							],
							[
								-73.98681640624994,
								-1.0981445312500142
							],
							[
								-73.92695312500001,
								-1.125195312499926
							],
							[
								-73.86318359375,
								-1.1966796874999233
							],
							[
								-73.80717773437493,
								-1.217968749999912
							],
							[
								-73.73574218749997,
								-1.2141601562499318
							],
							[
								-73.66430664062497,
								-1.2488281249998892
							],
							[
								-73.61025390624997,
								-1.3164062499999005
							],
							[
								-73.57548828124999,
								-1.4013671874999716
							],
							[
								-73.52138671875,
								-1.4497070312499574
							],
							[
								-73.49433593749998,
								-1.5366210937499005
							],
							[
								-73.52524414062498,
								-1.6388671875000398
							],
							[
								-73.49628906249993,
								-1.693066406249983
							],
							[
								-73.44028320312498,
								-1.7374023437499488
							],
							[
								-73.34951171874997,
								-1.783886718749926
							],
							[
								-73.266455078125,
								-1.772265624999946
							],
							[
								-73.22397460937498,
								-1.787695312499892
							],
							[
								-73.19697265624998,
								-1.8302734374999545
							],
							[
								-73.18149414062492,
								-1.8803710937499432
							],
							[
								-73.14521484374998,
								-2.003320312500037
							],
							[
								-73.12651367187502,
								-2.0810546874999716
							],
							[
								-73.16020507812493,
								-2.156347656249949
							],
							[
								-73.17265624999999,
								-2.20839843749998
							],
							[
								-73.15449218749993,
								-2.278222656249909
							],
							[
								-73.06816406250002,
								-2.3120117187499574
							],
							[
								-72.98964843750002,
								-2.3397460937500085
							],
							[
								-72.94111328124998,
								-2.3940429687499716
							],
							[
								-72.88715820312501,
								-2.408496093749889
							],
							[
								-72.81123046874998,
								-2.405468749999983
							],
							[
								-72.71416015625002,
								-2.392187500000034
							],
							[
								-72.66015625000003,
								-2.361035156249912
							],
							[
								-72.62534179687495,
								-2.351660156249949
							],
							[
								-72.58671874999999,
								-2.3651367187499375
							],
							[
								-72.50068359374995,
								-2.3950195312499005
							],
							[
								-72.39560546874995,
								-2.4289062499999687
							],
							[
								-72.30073242187498,
								-2.409277343749963
							],
							[
								-72.21845703125001,
								-2.400488281249949
							],
							[
								-72.13681640625,
								-2.3806640624999034
							],
							[
								-72.05380859374995,
								-2.3246093749999517
							],
							[
								-71.98427734375,
								-2.326562499999895
							],
							[
								-71.93247070312492,
								-2.288671874999906
							],
							[
								-71.86728515624998,
								-2.227734374999926
							],
							[
								-71.80273437499997,
								-2.166308593749932
							],
							[
								-71.75253906249995,
								-2.1527343749999233
							],
							[
								-71.67148437499995,
								-2.1821289062499574
							],
							[
								-71.55947265624997,
								-2.2242187499999204
							],
							[
								-71.49609375000003,
								-2.2791992187499375
							],
							[
								-71.44746093749998,
								-2.29374999999996
							],
							[
								-71.39697265625,
								-2.3340820312499204
							],
							[
								-71.30009765624996,
								-2.334863281249909
							],
							[
								-71.19638671874998,
								-2.313085937499906
							],
							[
								-71.11337890624995,
								-2.2454101562499744
							],
							[
								-71.02729492187498,
								-2.2257812499999687
							],
							[
								-70.96855468750002,
								-2.206835937499932
							],
							[
								-70.91455078125003,
								-2.2185546874999176
							],
							[
								-70.70537109374996,
								-2.3419921874999403
							],
							[
								-70.64799804687499,
								-2.4057617187499574
							],
							[
								-70.57587890624995,
								-2.418261718750017
							],
							[
								-70.51679687500001,
								-2.453125000000014
							],
							[
								-70.418212890625,
								-2.490722656249943
							],
							[
								-70.36416015625,
								-2.5292968749999005
							],
							[
								-70.29462890624995,
								-2.552539062500017
							],
							[
								-70.24443359374993,
								-2.6065429687500057
							],
							[
								-70.16474609374995,
								-2.63984375000004
							],
							[
								-70.09584960937494,
								-2.6582031249999574
							],
							[
								-70.06474609375002,
								-2.701660156249929
							],
							[
								-70.06445312499994,
								-2.7307617187499176
							],
							[
								-70.07402343749993,
								-2.7501953124999687
							],
							[
								-70.1470703125,
								-2.8640624999999744
							],
							[
								-70.29013671875,
								-3.08730468749998
							],
							[
								-70.41899414062496,
								-3.288281249999983
							],
							[
								-70.62167968749995,
								-3.604589843749949
							],
							[
								-70.73510742187497,
								-3.781542968749932
							],
							[
								-70.70620117187494,
								-3.7889648437500227
							],
							[
								-70.52968749999997,
								-3.8664062499998977
							],
							[
								-70.48583984375,
								-3.8693359374999687
							],
							[
								-70.42109374999995,
								-3.849609374999943
							],
							[
								-70.37919921874993,
								-3.818749999999966
							],
							[
								-70.33950195312494,
								-3.8143554687499517
							],
							[
								-70.29843749999992,
								-3.8442382812499147
							],
							[
								-70.24028320312499,
								-3.8827148437499375
							],
							[
								-70.19838867187497,
								-3.995117187499929
							],
							[
								-70.16752929687499,
								-4.050195312499952
							],
							[
								-70.09477539062499,
								-4.09218749999998
							],
							[
								-70.0171875,
								-4.162011718749994
							],
							[
								-69.96591796875003,
								-4.235937499999963
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "PER",
					"su_a3": "PER",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "PER",
					"gu_a3": "PER",
					"abbrev": "Peru",
					"region_un": "Americas",
					"adm0_a3_us": "PER",
					"scalerank": 1,
					"pop_est": 29546963,
					"adm0_dif": 0,
					"un_a3": "604",
					"pop_year": -99,
					"gdp_md_est": 247300,
					"name": "Peru",
					"sovereignt": "Peru",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Peru",
					"postal": "PE",
					"sov_a3": "PER",
					"note_brk": "",
					"brk_a3": "PER",
					"wb_a2": "PE",
					"brk_diff": 0,
					"admin": "Peru",
					"name_long": "Peru",
					"iso_a3": "PER",
					"iso_a2": "PE",
					"adm0_a3_is": "PER",
					"level": 2,
					"formal_en": "Republic of Peru",
					"name_len": 4,
					"mapcolor7": 4,
					"long_len": 4,
					"mapcolor8": 4,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "604",
					"homepart": 1,
					"subunit": "Peru",
					"name_alt": "",
					"brk_name": "Peru",
					"name_sort": "Peru",
					"continent": "South America",
					"mapcolor13": 11,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2007
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									120.25039062500002,
									5.2565917968750995
								],
								[
									120.22324218750009,
									5.196240234374969
								],
								[
									120.19160156250001,
									5.168310546874963
								],
								[
									120.15000000000009,
									5.184082031250071
								],
								[
									120.11835937500001,
									5.21538085937496
								],
								[
									120.10058593749994,
									5.168994140625017
								],
								[
									120.0132812500002,
									5.151123046875014
								],
								[
									119.95810546875003,
									5.079541015624997
								],
								[
									119.87753906250009,
									5.060205078124966
								],
								[
									119.82148437500001,
									5.069531250000082
								],
								[
									119.82734375000007,
									5.133154296875077
								],
								[
									119.98271484374999,
									5.228417968749952
								],
								[
									120.07968750000003,
									5.263623046875111
								],
								[
									120.16523437500018,
									5.332421875000094
								],
								[
									120.2080078125,
									5.340087890625057
								],
								[
									120.22939453124997,
									5.284082031250094
								],
								[
									120.25039062500002,
									5.2565917968750995
								]
							]
						],
						[
							[
								[
									121.15937500000018,
									6.075634765625068
								],
								[
									121.21386718750011,
									6.003515625000034
								],
								[
									121.28251953125016,
									6.022265625000031
								],
								[
									121.39150390625014,
									6.0020996093750085
								],
								[
									121.41464843750003,
									5.96450195312508
								],
								[
									121.41103515625014,
									5.9398437499999375
								],
								[
									121.29443359375,
									5.869970703125091
								],
								[
									121.21816406249997,
									5.9427246093749915
								],
								[
									121.0830078125,
									5.893017578125082
								],
								[
									121.01855468750011,
									5.922949218750048
								],
								[
									120.93066406249994,
									5.896191406250097
								],
								[
									120.87636718749997,
									5.952636718750057
								],
								[
									120.89824218749999,
									6.00693359375002
								],
								[
									121.03769531250009,
									6.0959960937500455
								],
								[
									121.15937500000018,
									6.075634765625068
								]
							]
						],
						[
							[
								[
									122.0928710937502,
									6.428320312499977
								],
								[
									121.99140625000007,
									6.414550781250014
								],
								[
									121.95917968750007,
									6.415820312500088
								],
								[
									121.8798828125,
									6.517578125000043
								],
								[
									121.87246093749997,
									6.5627441406250995
								],
								[
									121.80869140625003,
									6.613720703125082
								],
								[
									121.83203125000011,
									6.664062500000043
								],
								[
									121.91494140625002,
									6.676220703125026
								],
								[
									122.05830078125018,
									6.740722656250028
								],
								[
									122.28808593750011,
									6.638916015625071
								],
								[
									122.32353515625005,
									6.602246093750054
								],
								[
									122.25175781250016,
									6.579785156250097
								],
								[
									122.20097656250005,
									6.482910156250085
								],
								[
									122.0928710937502,
									6.428320312499977
								]
							]
						],
						[
							[
								[
									125.78457031250002,
									6.962744140624963
								],
								[
									125.76894531250014,
									6.905761718750071
								],
								[
									125.70751953124994,
									7.039990234375068
								],
								[
									125.68300781250002,
									7.073193359375082
								],
								[
									125.7144531250002,
									7.185546875000057
								],
								[
									125.78339843750007,
									7.13066406250006
								],
								[
									125.78457031250002,
									6.962744140624963
								]
							]
						],
						[
							[
								[
									122.93710937500009,
									7.4091308593749545
								],
								[
									122.94804687500016,
									7.385742187499986
								],
								[
									122.94365234375016,
									7.361035156250097
								],
								[
									122.83955078125018,
									7.314599609375051
								],
								[
									122.80468750000011,
									7.315966796875074
								],
								[
									122.79658203125001,
									7.393359375000031
								],
								[
									122.82216796875002,
									7.428466796874986
								],
								[
									122.87119140625003,
									7.397314453125034
								],
								[
									122.91484375000016,
									7.433398437500017
								],
								[
									122.93710937500009,
									7.4091308593749545
								]
							]
						],
						[
							[
								[
									117.07988281250016,
									7.883398437500034
								],
								[
									117.02832031249994,
									7.8075195312499375
								],
								[
									116.96953125000016,
									7.89492187499998
								],
								[
									116.97578125000018,
									8.016650390625088
								],
								[
									116.99355468749997,
									8.050537109375057
								],
								[
									117.07705078125002,
									8.069140624999946
								],
								[
									117.07988281250016,
									7.883398437500034
								]
							]
						],
						[
							[
								[
									117.35527343750005,
									8.214648437500017
								],
								[
									117.28701171874997,
									8.191015625000077
								],
								[
									117.27226562499999,
									8.25351562500002
								],
								[
									117.28085937500003,
									8.314990234375031
								],
								[
									117.32958984374994,
									8.308496093750037
								],
								[
									117.35371093750018,
									8.289257812500026
								],
								[
									117.35527343750005,
									8.214648437500017
								]
							]
						],
						[
							[
								[
									124.80664062500011,
									9.142626953124974
								],
								[
									124.7779296875002,
									9.08310546875002
								],
								[
									124.66582031249999,
									9.1323242187501
								],
								[
									124.63906249999997,
									9.175097656250017
								],
								[
									124.65332031250011,
									9.225830078125043
								],
								[
									124.7081054687502,
									9.243017578125091
								],
								[
									124.73681640625,
									9.243164062500028
								],
								[
									124.79023437500001,
									9.190087890625051
								],
								[
									124.80664062500011,
									9.142626953124974
								]
							]
						],
						[
							[
								[
									123.69765625000014,
									9.237304687500071
								],
								[
									123.70625000000018,
									9.133544921875071
								],
								[
									123.61445312500001,
									9.10332031249996
								],
								[
									123.54072265625001,
									9.129736328125105
								],
								[
									123.49345703124999,
									9.192089843750097
								],
								[
									123.49355468750002,
									9.215527343750082
								],
								[
									123.53515624999994,
									9.21357421875004
								],
								[
									123.6260742187502,
									9.268261718750082
								],
								[
									123.6548828125002,
									9.278759765624997
								],
								[
									123.69765625000014,
									9.237304687500071
								]
							]
						],
						[
							[
								[
									125.97050781250016,
									9.593554687500003
								],
								[
									125.95244140625005,
									9.567968750000034
								],
								[
									125.92207031250007,
									9.621484375000009
								],
								[
									125.94853515625005,
									9.739208984375011
								],
								[
									125.96777343749994,
									9.759082031249974
								],
								[
									125.99296874999999,
									9.684570312500071
								],
								[
									125.97050781250016,
									9.593554687500003
								]
							]
						],
						[
							[
								[
									126.00595703125009,
									9.320947265625065
								],
								[
									126.08759765625001,
									9.260742187500057
								],
								[
									126.193359375,
									9.276708984374935
								],
								[
									126.19199218750003,
									9.124902343750094
								],
								[
									126.20908203125009,
									9.080566406249943
								],
								[
									126.30458984375002,
									8.952050781250051
								],
								[
									126.31953125000001,
									8.844726562500028
								],
								[
									126.26298828125016,
									8.743945312499932
								],
								[
									126.22021484374994,
									8.696289062500085
								],
								[
									126.14160156250011,
									8.627294921875063
								],
								[
									126.13955078125014,
									8.595654296875097
								],
								[
									126.17304687500001,
									8.560058593750043
								],
								[
									126.28232421875009,
									8.539306640624986
								],
								[
									126.3653320312502,
									8.483886718750057
								],
								[
									126.37978515625014,
									8.32675781250002
								],
								[
									126.45869140625001,
									8.202832031250097
								],
								[
									126.45664062500009,
									8.148779296875006
								],
								[
									126.42529296875,
									7.927441406250026
								],
								[
									126.43535156249999,
									7.832812500000031
								],
								[
									126.49443359375005,
									7.756982421875037
								],
								[
									126.54443359375011,
									7.724804687500054
								],
								[
									126.57011718749999,
									7.677246093750043
								],
								[
									126.5933593750002,
									7.546777343750023
								],
								[
									126.58925781249997,
									7.325146484375068
								],
								[
									126.58154296875011,
									7.24775390624994
								],
								[
									126.54667968750005,
									7.175830078125031
								],
								[
									126.43906250000003,
									7.012353515625037
								],
								[
									126.29404296875009,
									6.8823242187500995
								],
								[
									126.21689453125009,
									6.891015625000094
								],
								[
									126.19208984375018,
									6.852539062500071
								],
								[
									126.24023437500011,
									6.733886718750057
								],
								[
									126.22119140624994,
									6.4833984375000995
								],
								[
									126.18935546874997,
									6.309667968749963
								],
								[
									126.14248046875002,
									6.39755859375002
								],
								[
									126.10976562500002,
									6.489648437500037
								],
								[
									126.08007812500011,
									6.73334960937504
								],
								[
									126.0430664062502,
									6.8431640624999375
								],
								[
									125.98496093750009,
									6.943554687500054
								],
								[
									125.96162109375001,
									7.0332031250000995
								],
								[
									125.90117187500016,
									7.116992187499946
								],
								[
									125.82441406250007,
									7.33330078124996
								],
								[
									125.77363281250018,
									7.322167968750094
								],
								[
									125.68925781250016,
									7.263037109375034
								],
								[
									125.67021484375016,
									7.22231445312508
								],
								[
									125.6602539062502,
									7.16059570312504
								],
								[
									125.6407226562502,
									7.105078125000006
								],
								[
									125.54218750000001,
									7.0166015625000995
								],
								[
									125.46474609375014,
									6.9111328125000995
								],
								[
									125.4009765625002,
									6.795751953125048
								],
								[
									125.38066406250016,
									6.689941406249986
								],
								[
									125.43291015625016,
									6.607128906250082
								],
								[
									125.48662109375016,
									6.573730468750028
								],
								[
									125.56455078125003,
									6.499609374999935
								],
								[
									125.5884765625002,
									6.465771484374969
								],
								[
									125.67070312499999,
									6.225000000000037
								],
								[
									125.66796875,
									5.978662109375023
								],
								[
									125.60781249999997,
									5.8701660156250455
								],
								[
									125.45585937499999,
									5.664257812500097
								],
								[
									125.34648437500005,
									5.598974609374949
								],
								[
									125.28789062499999,
									5.632275390624983
								],
								[
									125.24101562500005,
									5.756933593749977
								],
								[
									125.23320312500005,
									5.808300781250054
								],
								[
									125.26494140625005,
									5.9255859375000455
								],
								[
									125.26845703125014,
									6.03315429687494
								],
								[
									125.23154296875003,
									6.069531250000068
								],
								[
									125.19101562500003,
									6.062500000000057
								],
								[
									125.17402343750007,
									6.046972656250091
								],
								[
									125.07617187500011,
									5.906250000000114
								],
								[
									125.03535156250007,
									5.8706542968750455
								],
								[
									124.97519531250003,
									5.865722656250028
								],
								[
									124.92734375000009,
									5.875341796875034
								],
								[
									124.6363281250002,
									5.998193359375094
								],
								[
									124.39882812500014,
									6.1197265624999915
								],
								[
									124.21279296874997,
									6.23325195312502
								],
								[
									124.07812500000011,
									6.40444335937508
								],
								[
									124.04970703124997,
									6.532568359375077
								],
								[
									124.04814453125005,
									6.666552734375017
								],
								[
									123.9878906250002,
									6.862988281250068
								],
								[
									123.98085937499997,
									6.929687500000071
								],
								[
									123.98525390625002,
									6.9937011718750455
								],
								[
									124.04511718750001,
									7.1141113281250625
								],
								[
									124.11757812500014,
									7.17509765625006
								],
								[
									124.15820312499994,
									7.218798828125074
								],
								[
									124.19072265625005,
									7.267333984375114
								],
								[
									124.21289062500011,
									7.332128906250077
								],
								[
									124.20664062500009,
									7.396435546875026
								],
								[
									124.18242187500005,
									7.436718750000068
								],
								[
									124.06796875000003,
									7.577880859375043
								],
								[
									123.96845703125001,
									7.664648437499963
								],
								[
									123.7647460937502,
									7.74262695312504
								],
								[
									123.71738281250003,
									7.785400390625043
								],
								[
									123.66582031250005,
									7.817773437500065
								],
								[
									123.60888671874994,
									7.831640625000048
								],
								[
									123.55322265625011,
									7.832128906249977
								],
								[
									123.49306640625002,
									7.807910156250017
								],
								[
									123.47744140625002,
									7.756347656250085
								],
								[
									123.48164062500018,
									7.710253906250017
								],
								[
									123.47636718750016,
									7.665380859374935
								],
								[
									123.39091796875016,
									7.407519531250074
								],
								[
									123.28203124999999,
									7.464111328125057
								],
								[
									123.17822265625,
									7.529443359374952
								],
								[
									123.15068359375016,
									7.575195312500028
								],
								[
									123.1387695312502,
									7.629931640625088
								],
								[
									123.1211914062502,
									7.666894531250065
								],
								[
									123.0966796875,
									7.700439453124972
								],
								[
									123.0489257812502,
									7.61435546875002
								],
								[
									122.98955078124999,
									7.5462890625000085
								],
								[
									122.91689453125014,
									7.530517578125085
								],
								[
									122.84296875000018,
									7.5292968750000995
								],
								[
									122.81875000000014,
									7.5584960937500085
								],
								[
									122.79179687500005,
									7.722460937500017
								],
								[
									122.71396484375009,
									7.774121093750054
								],
								[
									122.6162109375,
									7.7631347656249545
								],
								[
									122.49794921875014,
									7.672753906250108
								],
								[
									122.47441406250005,
									7.63896484375006
								],
								[
									122.44863281250014,
									7.561132812500105
								],
								[
									122.31972656249997,
									7.340234374999952
								],
								[
									122.25146484375011,
									7.170019531250091
								],
								[
									122.17617187500014,
									7.00419921875006
								],
								[
									122.14248046875002,
									6.949658203125054
								],
								[
									122.09814453124994,
									6.913720703125094
								],
								[
									122.02763671875016,
									6.9286132812499375
								],
								[
									121.96425781250014,
									6.968212890625011
								],
								[
									121.90419921875014,
									7.075195312499957
								],
								[
									121.92460937500005,
									7.19951171875006
								],
								[
									121.99111328124997,
									7.27875976562504
								],
								[
									122.04716796875005,
									7.363574218750088
								],
								[
									122.11484375000003,
									7.659912109375057
								],
								[
									122.11992187500005,
									7.765380859375057
								],
								[
									122.13183593749994,
									7.810498046875011
								],
								[
									122.24335937500007,
									7.945117187500074
								],
								[
									122.33710937500007,
									8.028417968750091
								],
								[
									122.38671875000011,
									8.0458984375001
								],
								[
									122.5894531250002,
									8.093310546875074
								],
								[
									122.67294921875009,
									8.133105468750102
								],
								[
									122.80439453125001,
									8.133691406249952
								],
								[
									122.91113281250011,
									8.156445312499969
								],
								[
									122.99628906250007,
									8.220507812500045
								],
								[
									123.00273437500005,
									8.286914062500074
								],
								[
									122.99882812500005,
									8.356054687500048
								],
								[
									123.01757812500011,
									8.398339843750037
								],
								[
									123.05058593749999,
									8.433935546875105
								],
								[
									123.09589843750018,
									8.480810546875063
								],
								[
									123.14716796875007,
									8.516015625000037
								],
								[
									123.29287109374997,
									8.541455078125068
								],
								[
									123.34121093749997,
									8.57041015625002
								],
								[
									123.38017578124999,
									8.61562500000008
								],
								[
									123.4345703125,
									8.703320312500097
								],
								[
									123.49892578125014,
									8.681542968750009
								],
								[
									123.56367187500018,
									8.647460937500085
								],
								[
									123.68007812500002,
									8.620605468750028
								],
								[
									123.78339843750018,
									8.547705078125091
								],
								[
									123.84921875000009,
									8.432714843750034
								],
								[
									123.86054687500018,
									8.376074218749949
								],
								[
									123.87744140624994,
									8.188818359374991
								],
								[
									123.85341796875014,
									8.145117187500063
								],
								[
									123.75312500000007,
									8.058251953125037
								],
								[
									123.79941406250003,
									8.049121093750045
								],
								[
									123.93115234375,
									8.128417968749943
								],
								[
									123.99687500000016,
									8.158984375000045
								],
								[
									124.15937500000001,
									8.201464843750074
								],
								[
									124.19765625000002,
									8.229541015625031
								],
								[
									124.22578125000007,
									8.271386718749937
								],
								[
									124.28320312499994,
									8.385986328125014
								],
								[
									124.3251953125,
									8.508447265625094
								],
								[
									124.35791015625,
									8.559423828125091
								],
								[
									124.40488281250003,
									8.599853515625057
								],
								[
									124.45126953125009,
									8.606347656249966
								],
								[
									124.62177734375018,
									8.522656249999969
								],
								[
									124.73115234375018,
									8.562988281250014
								],
								[
									124.76171875000011,
									8.689794921875091
								],
								[
									124.78681640625007,
									8.874121093750077
								],
								[
									124.80615234375,
									8.924023437500026
								],
								[
									124.86894531249999,
									8.972265625000077
								],
								[
									124.94384765625,
									8.956689453125023
								],
								[
									125.04638671875,
									8.890527343749952
								],
								[
									125.14101562500002,
									8.868750000000048
								],
								[
									125.17617187499997,
									8.922070312499983
								],
								[
									125.20966796875007,
									9.027148437500074
								],
								[
									125.24785156249999,
									9.026562499999955
								],
								[
									125.3755859375002,
									8.991796874999977
								],
								[
									125.49873046875007,
									9.014746093750034
								],
								[
									125.53339843750018,
									9.140917968750074
								],
								[
									125.51015624999997,
									9.275878906249943
								],
								[
									125.41396484375002,
									9.669189453124957
								],
								[
									125.47128906250003,
									9.75678710937504
								],
								[
									125.52089843750014,
									9.759130859375077
								],
								[
									125.64248046875014,
									9.654492187499983
								],
								[
									125.87666015625001,
									9.513134765625054
								],
								[
									125.9546875000002,
									9.426660156250023
								],
								[
									126.00595703125009,
									9.320947265625065
								]
							]
						],
						[
							[
								[
									126.05937500000016,
									9.766210937500006
								],
								[
									126.04677734375014,
									9.76079101562506
								],
								[
									125.99121093750011,
									9.838525390624994
								],
								[
									125.9986328125002,
									9.927050781250088
								],
								[
									126.07382812500003,
									10.059228515625108
								],
								[
									126.1294921875002,
									9.943554687500068
								],
								[
									126.12890625000011,
									9.891113281250043
								],
								[
									126.12080078125001,
									9.865185546875097
								],
								[
									126.17255859375018,
									9.799951171874952
								],
								[
									126.13691406250001,
									9.767773437499969
								],
								[
									126.05937500000016,
									9.766210937500006
								]
							]
						],
						[
							[
								[
									125.28076171874994,
									9.982177734375043
								],
								[
									125.28769531250003,
									9.932714843750091
								],
								[
									125.15898437500005,
									10.062939453125054
								],
								[
									125.13300781250007,
									10.155029296875085
								],
								[
									125.17587890625009,
									10.151074218750068
								],
								[
									125.23095703125011,
									10.115673828124969
								],
								[
									125.28076171874994,
									9.982177734375043
								]
							]
						],
						[
							[
								[
									124.59384765625009,
									9.78720703125002
								],
								[
									124.58427734374999,
									9.75048828125
								],
								[
									124.50566406250016,
									9.753515625000077
								],
								[
									124.47753906250011,
									9.747900390625006
								],
								[
									124.4034179687502,
									9.654101562500074
								],
								[
									124.35986328125011,
									9.630224609375105
								],
								[
									124.12246093749997,
									9.599316406250026
								],
								[
									123.9356445312502,
									9.623974609374983
								],
								[
									123.87167968750003,
									9.67573242187504
								],
								[
									123.82998046874997,
									9.761132812500037
								],
								[
									123.81718750000005,
									9.817382812500043
								],
								[
									123.86386718750003,
									9.878808593750023
								],
								[
									123.90888671875018,
									9.919628906249997
								],
								[
									124.05976562500018,
									10.000195312500068
								],
								[
									124.0938476562502,
									10.061328125000088
								],
								[
									124.17285156250011,
									10.13520507812504
								],
								[
									124.33574218749999,
									10.1599121093751
								],
								[
									124.35156250000011,
									10.141357421875043
								],
								[
									124.37324218750018,
									10.129589843750054
								],
								[
									124.40585937500009,
									10.126416015625026
								],
								[
									124.48632812500011,
									10.065478515625045
								],
								[
									124.57714843749994,
									10.026708984374963
								],
								[
									124.55507812500002,
									9.879199218749932
								],
								[
									124.58222656250001,
									9.829589843750043
								],
								[
									124.59384765625009,
									9.78720703125002
								]
							]
						],
						[
							[
								[
									125.69023437500016,
									9.914453125000009
								],
								[
									125.67255859375001,
									9.886474609375085
								],
								[
									125.64863281250001,
									9.9440917968751
								],
								[
									125.59052734375018,
									9.998193359375108
								],
								[
									125.53447265625016,
									10.090087890625085
								],
								[
									125.49482421875007,
									10.118701171875045
								],
								[
									125.52197265625,
									10.191503906249963
								],
								[
									125.52460937500018,
									10.309716796875065
								],
								[
									125.5801757812502,
									10.363671875000037
								],
								[
									125.60585937500014,
									10.379589843750082
								],
								[
									125.64794921875,
									10.436816406250017
								],
								[
									125.66679687499999,
									10.440136718750082
								],
								[
									125.6845703125,
									10.392041015625054
								],
								[
									125.64667968750018,
									10.245410156249932
								],
								[
									125.70332031250018,
									10.071777343750085
								],
								[
									125.68437500000005,
									9.963183593749989
								],
								[
									125.69248046875009,
									9.939013671875031
								],
								[
									125.69023437500016,
									9.914453125000009
								]
							]
						],
						[
							[
								[
									119.91621093750007,
									10.485986328125094
								],
								[
									119.79316406250001,
									10.455273437500054
								],
								[
									119.76445312500005,
									10.551611328124963
								],
								[
									119.85205078124994,
									10.640136718750057
								],
								[
									119.95019531249994,
									10.60478515624996
								],
								[
									120.0083984375002,
									10.570117187500003
								],
								[
									119.98115234375007,
									10.538720703125094
								],
								[
									119.91621093750007,
									10.485986328125094
								]
							]
						],
						[
							[
								[
									124.31621093749999,
									10.606005859375031
								],
								[
									124.28847656250014,
									10.601464843749994
								],
								[
									124.33466796875001,
									10.706689453124937
								],
								[
									124.37109375000011,
									10.691357421875011
								],
								[
									124.38232421875,
									10.679833984375065
								],
								[
									124.38134765624994,
									10.632568359375028
								],
								[
									124.31621093749999,
									10.606005859375031
								]
							]
						],
						[
							[
								[
									122.6495117187502,
									10.472705078125045
								],
								[
									122.62187500000016,
									10.459033203124932
								],
								[
									122.59716796875011,
									10.461035156250077
								],
								[
									122.53837890624999,
									10.424951171875094
								],
								[
									122.51669921875003,
									10.492529296875006
								],
								[
									122.53750000000002,
									10.607568359374994
								],
								[
									122.62578125000016,
									10.69501953125004
								],
								[
									122.64843749999994,
									10.722509765624963
								],
								[
									122.67255859375018,
									10.738818359375088
								],
								[
									122.70126953125009,
									10.740625000000094
								],
								[
									122.72919921875018,
									10.706396484375048
								],
								[
									122.73720703125014,
									10.654589843750074
								],
								[
									122.68125000000009,
									10.498242187500097
								],
								[
									122.6495117187502,
									10.472705078125045
								]
							]
						],
						[
							[
								[
									123.13085937500011,
									9.064111328124966
								],
								[
									123.06464843750001,
									9.05336914062508
								],
								[
									122.99472656250009,
									9.058837890624957
								],
								[
									122.94785156250003,
									9.107958984375017
								],
								[
									122.86660156250002,
									9.319824218750014
								],
								[
									122.77246093750011,
									9.371337890625028
								],
								[
									122.66455078124994,
									9.410351562499983
								],
								[
									122.61035156250011,
									9.44321289062502
								],
								[
									122.56249999999994,
									9.482812500000094
								],
								[
									122.41093750000016,
									9.693896484375017
								],
								[
									122.39951171875003,
									9.823046875000031
								],
								[
									122.42558593750005,
									9.896093750000091
								],
								[
									122.47148437500016,
									9.961523437500006
								],
								[
									122.52324218750005,
									9.979199218750054
								],
								[
									122.64824218749999,
									9.981542968750091
								],
								[
									122.71298828125003,
									9.990136718750065
								],
								[
									122.85556640625009,
									10.086914062499972
								],
								[
									122.8658203125002,
									10.125000000000085
								],
								[
									122.86650390625016,
									10.284033203125077
								],
								[
									122.85234375000005,
									10.395263671875085
								],
								[
									122.8169921875002,
									10.503808593749994
								],
								[
									122.85556640625009,
									10.553417968750068
								],
								[
									122.9058593750002,
									10.602539062500028
								],
								[
									122.95839843750014,
									10.698339843750105
								],
								[
									122.96875000000011,
									10.765722656250063
								],
								[
									122.96972656249994,
									10.836181640625028
								],
								[
									122.98330078124997,
									10.886621093750094
								],
								[
									123.02441406250011,
									10.911816406249983
								],
								[
									123.22177734375009,
									10.988671875000009
								],
								[
									123.25664062500016,
									10.993945312500017
								],
								[
									123.51064453125014,
									10.923046875000054
								],
								[
									123.56250000000011,
									10.816064453125108
								],
								[
									123.56757812500018,
									10.7807617187501
								],
								[
									123.52773437500014,
									10.662011718750065
								],
								[
									123.49287109375007,
									10.582324218750003
								],
								[
									123.40693359375001,
									10.4589843750001
								],
								[
									123.34355468749999,
									10.325390625000054
								],
								[
									123.29609375000001,
									10.124511718750085
								],
								[
									123.26621093750003,
									10.059033203125068
								],
								[
									123.1866210937502,
									9.93330078124994
								],
								[
									123.16201171874997,
									9.864257812500085
								],
								[
									123.1626953125002,
									9.714648437500074
								],
								[
									123.1494140625,
									9.65932617187508
								],
								[
									123.14980468749997,
									9.606152343750082
								],
								[
									123.30839843750005,
									9.356982421874946
								],
								[
									123.3218750000002,
									9.317480468750063
								],
								[
									123.32050781250001,
									9.272949218750057
								],
								[
									123.29335937499997,
									9.217285156250085
								],
								[
									123.22871093750007,
									9.121386718750088
								],
								[
									123.19248046875003,
									9.087890625000014
								],
								[
									123.13085937500011,
									9.064111328124966
								]
							]
						],
						[
							[
								[
									123.37031250000001,
									9.44960937500008
								],
								[
									123.33173828125018,
									9.422949218750063
								],
								[
									123.31601562500009,
									9.488964843750011
								],
								[
									123.32705078125002,
									9.57807617187504
								],
								[
									123.40371093750002,
									9.88925781250002
								],
								[
									123.38623046875,
									9.967089843750074
								],
								[
									123.51435546875018,
									10.14033203125011
								],
								[
									123.59287109375009,
									10.302929687500097
								],
								[
									123.71142578125,
									10.473681640625074
								],
								[
									123.72646484375014,
									10.562207031250082
								],
								[
									123.83154296874994,
									10.731005859375088
								],
								[
									123.92988281250018,
									10.963818359375097
								],
								[
									123.92460937500016,
									11.040917968749994
								],
								[
									123.95009765625014,
									11.07915039062506
								],
								[
									123.96406250000001,
									11.137451171874943
								],
								[
									123.96718750000014,
									11.186914062500065
								],
								[
									124.03886718749999,
									11.273535156250048
								],
								[
									124.05791015625016,
									11.217236328125026
								],
								[
									124.03652343750014,
									11.106689453125071
								],
								[
									124.03984374999999,
									11.053613281250094
								],
								[
									124.05253906250005,
									11.028759765625097
								],
								[
									124.0533203125002,
									10.925781249999986
								],
								[
									124.02753906250018,
									10.76787109375006
								],
								[
									124.05126953124994,
									10.585595703125051
								],
								[
									124.0049804687502,
									10.400097656250097
								],
								[
									123.95214843750011,
									10.31660156250004
								],
								[
									123.87392578125014,
									10.257714843749952
								],
								[
									123.7886718750002,
									10.220800781250063
								],
								[
									123.70048828125016,
									10.128320312500051
								],
								[
									123.64335937500016,
									10.020214843750054
								],
								[
									123.63398437500001,
									9.921728515625063
								],
								[
									123.49355468750002,
									9.589306640625026
								],
								[
									123.37031250000001,
									9.44960937500008
								]
							]
						],
						[
							[
								[
									123.75703125000007,
									11.283300781249991
								],
								[
									123.81562500000018,
									11.150732421875077
								],
								[
									123.73671874999997,
									11.151464843750048
								],
								[
									123.7076171875002,
									11.247998046875082
								],
								[
									123.74140625000007,
									11.279150390625034
								],
								[
									123.75703125000007,
									11.283300781249991
								]
							]
						],
						[
							[
								[
									117.3111328125002,
									8.439599609375094
								],
								[
									117.21855468750016,
									8.367285156249935
								],
								[
									117.22851562499994,
									8.456689453125023
								],
								[
									117.25585937500011,
									8.540966796874969
								],
								[
									117.34990234374999,
									8.713574218750054
								],
								[
									117.41777343750016,
									8.766650390625031
								],
								[
									117.52998046875018,
									8.9025878906251
								],
								[
									117.59326171875011,
									8.968310546874989
								],
								[
									117.74492187499999,
									9.098242187499991
								],
								[
									117.884765625,
									9.240673828125054
								],
								[
									117.93154296875002,
									9.251269531250074
								],
								[
									117.9830078125002,
									9.253417968749986
								],
								[
									118.02382812499997,
									9.269775390624943
								],
								[
									118.11484375000003,
									9.346679687500071
								],
								[
									118.34394531250001,
									9.6027832031251
								],
								[
									118.53339843750007,
									9.793652343750082
								],
								[
									118.72753906250011,
									10.035009765625048
								],
								[
									118.82011718750005,
									10.105322265624991
								],
								[
									118.84511718749997,
									10.131298828124955
								],
								[
									119.02382812499997,
									10.353564453125031
								],
								[
									119.07988281250005,
									10.385839843750034
								],
								[
									119.14306640625011,
									10.409277343750091
								],
								[
									119.18603515625,
									10.439453125000028
								],
								[
									119.22382812500001,
									10.4772949218751
								],
								[
									119.28701171875014,
									10.574023437500088
								],
								[
									119.31269531250001,
									10.687109375000034
								],
								[
									119.29667968750016,
									10.750976562500071
								],
								[
									119.26113281250002,
									10.845166015625082
								],
								[
									119.30566406250011,
									10.973632812500057
								],
								[
									119.34072265625014,
									11.032910156250054
								],
								[
									119.46533203125011,
									11.293798828125091
								],
								[
									119.50126953125016,
									11.346435546875057
								],
								[
									119.5533203125002,
									11.313525390624932
								],
								[
									119.56025390625018,
									11.266796875000097
								],
								[
									119.53457031250002,
									11.156835937500077
								],
								[
									119.53261718749997,
									11.101611328125017
								],
								[
									119.56191406249997,
									11.045507812500034
								],
								[
									119.52666015624999,
									10.95317382812506
								],
								[
									119.61611328125002,
									10.707373046875077
								],
								[
									119.68437500000016,
									10.551708984374983
								],
								[
									119.68691406250014,
									10.500341796875091
								],
								[
									119.59521484375011,
									10.407421875000068
								],
								[
									119.54052734375,
									10.37934570312504
								],
								[
									119.4224609375002,
									10.354394531250023
								],
								[
									119.36933593750001,
									10.327294921875094
								],
								[
									119.2847656250002,
									10.251708984374972
								],
								[
									119.23193359375011,
									10.152148437500031
								],
								[
									119.21855468750005,
									10.100683593749935
								],
								[
									119.1915039062502,
									10.061083984375031
								],
								[
									118.94863281250002,
									9.993457031250031
								],
								[
									118.83466796875018,
									9.949316406250006
								],
								[
									118.78212890625014,
									9.916113281249991
								],
								[
									118.75498046875009,
									9.862109375000003
								],
								[
									118.77382812500002,
									9.76679687500004
								],
								[
									118.56962890625016,
									9.422753906250023
								],
								[
									118.50449218750003,
									9.332666015624966
								],
								[
									118.43496093749997,
									9.25600585937498
								],
								[
									118.34960937500011,
									9.20146484375006
								],
								[
									118.22929687499999,
									9.167968749999986
								],
								[
									118.13408203125016,
									9.101367187500088
								],
								[
									118.06943359375003,
									8.983544921875065
								],
								[
									117.98955078125005,
									8.877099609375051
								],
								[
									117.88857421874997,
									8.79824218749998
								],
								[
									117.77978515625011,
									8.728613281250006
								],
								[
									117.67988281250018,
									8.677832031249963
								],
								[
									117.57216796874997,
									8.641992187500037
								],
								[
									117.5396484375002,
									8.59560546875008
								],
								[
									117.51660156249994,
									8.538330078125057
								],
								[
									117.46914062500014,
									8.51137695312498
								],
								[
									117.41249999999997,
									8.495849609375014
								],
								[
									117.3111328125002,
									8.439599609375094
								]
							]
						],
						[
							[
								[
									119.86142578125009,
									11.525341796875097
								],
								[
									119.8829101562502,
									11.472412109374972
								],
								[
									119.85488281249997,
									11.393066406249972
								],
								[
									119.8306640625002,
									11.375683593749983
								],
								[
									119.79863281250016,
									11.40874023437506
								],
								[
									119.72998046874994,
									11.431933593750074
								],
								[
									119.72558593750011,
									11.474658203125074
								],
								[
									119.76142578125007,
									11.473632812500043
								],
								[
									119.8267578125002,
									11.515429687500031
								],
								[
									119.86142578125009,
									11.525341796875097
								]
							]
						],
						[
							[
								[
									124.57460937499997,
									11.343066406250088
								],
								[
									124.64433593750016,
									11.308105468750071
								],
								[
									124.72431640625001,
									11.322070312500074
								],
								[
									124.82109374999999,
									11.401416015625074
								],
								[
									124.92998046874999,
									11.372851562500031
								],
								[
									124.99394531250016,
									11.255908203125088
								],
								[
									125.02656250000007,
									11.211718749999974
								],
								[
									125.04433593750014,
									11.135253906250028
								],
								[
									125.03974609375007,
									10.951904296875071
								],
								[
									125.01318359375,
									10.785693359375045
								],
								[
									125.0337890625002,
									10.75146484375
								],
								[
									125.08388671875002,
									10.721582031249952
								],
								[
									125.1275390625002,
									10.68471679687508
								],
								[
									125.1641601562502,
									10.637451171875043
								],
								[
									125.18769531250018,
									10.58486328125008
								],
								[
									125.19716796874997,
									10.457226562500097
								],
								[
									125.26005859374999,
									10.349609375000114
								],
								[
									125.26845703125014,
									10.307714843750105
								],
								[
									125.25332031250014,
									10.263818359374952
								],
								[
									125.14843750000011,
									10.272412109375097
								],
								[
									125.14003906249997,
									10.235351562500014
								],
								[
									125.14257812499994,
									10.189453125000071
								],
								[
									125.10537109375014,
									10.218310546875088
								],
								[
									125.04394531250011,
									10.32343750000011
								],
								[
									124.98750000000018,
									10.367578124999952
								],
								[
									125.0048828125,
									10.197070312500031
								],
								[
									125.02353515625003,
									10.11528320312506
								],
								[
									125.02656250000007,
									10.033105468750023
								],
								[
									124.92910156249997,
									10.095898437500026
								],
								[
									124.81279296874999,
									10.134619140625091
								],
								[
									124.78076171874994,
									10.168066406250077
								],
								[
									124.79169921875018,
									10.274560546875009
								],
								[
									124.78955078125,
									10.327539062499966
								],
								[
									124.73769531249997,
									10.439746093750088
								],
								[
									124.79863281250016,
									10.68222656250002
								],
								[
									124.79716796875005,
									10.731787109375077
								],
								[
									124.7867187500002,
									10.781396484375051
								],
								[
									124.73867187500002,
									10.87973632812502
								],
								[
									124.66269531250009,
									10.961962890625074
								],
								[
									124.61611328125002,
									10.962207031249946
								],
								[
									124.50283203125002,
									10.90444335937508
								],
								[
									124.44550781250007,
									10.923583984375071
								],
								[
									124.4117187500002,
									11.150341796875082
								],
								[
									124.36601562500005,
									11.370703125000034
								],
								[
									124.33095703124997,
									11.427099609374977
								],
								[
									124.30820312500009,
									11.486181640624935
								],
								[
									124.3306640625002,
									11.535205078124974
								],
								[
									124.37412109375009,
									11.514990234375034
								],
								[
									124.43593749999997,
									11.457226562500068
								],
								[
									124.51093750000018,
									11.423876953125031
								],
								[
									124.54824218750014,
									11.395019531250014
								],
								[
									124.57460937499997,
									11.343066406250088
								]
							]
						],
						[
							[
								[
									124.60839843750011,
									11.492187500000085
								],
								[
									124.48349609375009,
									11.485839843750043
								],
								[
									124.4288085937502,
									11.531738281250071
								],
								[
									124.36035156250011,
									11.665917968750051
								],
								[
									124.43740234375002,
									11.695019531250026
								],
								[
									124.51093750000018,
									11.687109375000105
								],
								[
									124.56494140624994,
									11.639697265624946
								],
								[
									124.62226562500018,
									11.549560546875057
								],
								[
									124.60839843750011,
									11.492187500000085
								]
							]
						],
						[
							[
								[
									124.85439453125014,
									11.594775390625031
								],
								[
									124.83593750000011,
									11.54331054687502
								],
								[
									124.80664062500011,
									11.557568359375082
								],
								[
									124.78105468750005,
									11.58076171875011
								],
								[
									124.74365234374994,
									11.658544921875048
								],
								[
									124.73085937500002,
									11.715332031250071
								],
								[
									124.78837890624999,
									11.683105468750085
								],
								[
									124.82148437500018,
									11.626611328125037
								],
								[
									124.85439453125014,
									11.594775390625031
								]
							]
						],
						[
							[
								[
									122.49619140625003,
									11.615087890625077
								],
								[
									122.61269531249997,
									11.564160156250011
								],
								[
									122.72626953125001,
									11.607910156250043
								],
								[
									122.83808593750007,
									11.595654296875026
								],
								[
									122.9312500000002,
									11.529296875000014
								],
								[
									122.90078125000014,
									11.487353515625088
								],
								[
									122.89453125000011,
									11.441308593750023
								],
								[
									123.10273437500007,
									11.541455078125097
								],
								[
									123.1583007812502,
									11.535546875000037
								],
								[
									123.15644531250018,
									11.442529296875094
								],
								[
									123.14414062500003,
									11.363574218750003
								],
								[
									123.11953125000002,
									11.286816406249997
								],
								[
									123.07548828124999,
									11.196875000000063
								],
								[
									123.01650390624997,
									11.116503906250031
								],
								[
									122.93876953125016,
									11.058154296875045
								],
								[
									122.84667968750011,
									11.022460937500057
								],
								[
									122.80292968750018,
									10.990039062499932
								],
								[
									122.78945312500002,
									10.941210937499932
								],
								[
									122.79111328125009,
									10.87973632812502
								],
								[
									122.76992187500014,
									10.823828125000091
								],
								[
									122.67314453125005,
									10.800927734374952
								],
								[
									122.52207031250009,
									10.691894531249943
								],
								[
									122.19765624999997,
									10.622900390625091
								],
								[
									122.10859375000001,
									10.575537109375034
								],
								[
									122.05175781250011,
									10.514062499999952
								],
								[
									121.98837890625003,
									10.45830078124996
								],
								[
									121.95400390624997,
									10.44438476562506
								],
								[
									121.93828125000016,
									10.47089843750004
								],
								[
									121.93378906250001,
									10.493652343750057
								],
								[
									121.98007812500003,
									10.638574218750094
								],
								[
									121.97236328125018,
									10.698876953125037
								],
								[
									121.9502929687502,
									10.75737304687496
								],
								[
									121.96435546874994,
									10.871679687499977
								],
								[
									122.02070312500018,
									10.979101562500105
								],
								[
									122.05087890625009,
									11.09736328125004
								],
								[
									122.0596679687502,
									11.3256835937501
								],
								[
									122.103515625,
									11.642919921875063
								],
								[
									122.10136718750016,
									11.680859374999983
								],
								[
									122.06699218750009,
									11.723730468750105
								],
								[
									121.94082031250014,
									11.758300781250043
								],
								[
									121.89121093750009,
									11.790869140625105
								],
								[
									121.91601562499994,
									11.854345703124977
								],
								[
									121.96367187499999,
									11.897363281250037
								],
								[
									122.02919921875014,
									11.895410156249994
								],
								[
									122.08681640625014,
									11.855078124999949
								],
								[
									122.29072265625018,
									11.772021484375074
								],
								[
									122.39921874999999,
									11.70219726562506
								],
								[
									122.49619140625003,
									11.615087890625077
								]
							]
						],
						[
							[
								[
									120.03876953125007,
									11.70332031249994
								],
								[
									119.9638671875,
									11.669384765624955
								],
								[
									119.94492187500003,
									11.690722656250031
								],
								[
									119.9317382812502,
									11.74033203125002
								],
								[
									119.93281250000007,
									11.774462890625045
								],
								[
									119.86093750000009,
									11.95395507812502
								],
								[
									119.91601562500011,
									11.981347656250094
								],
								[
									119.95654296875011,
									11.96025390625006
								],
								[
									119.99785156250016,
									11.932128906250014
								],
								[
									120.03593749999999,
									11.917236328125
								],
								[
									120.07070312499997,
									11.860546874999997
								],
								[
									120.06240234374997,
									11.821337890625003
								],
								[
									120.07314453125014,
									11.783496093749932
								],
								[
									120.03876953125007,
									11.70332031249994
								]
							]
						],
						[
							[
								[
									120.10000000000002,
									12.16767578125004
								],
								[
									120.15468750000014,
									12.152392578124946
								],
								[
									120.19375000000002,
									12.167041015625088
								],
								[
									120.22822265625001,
									12.219824218750006
								],
								[
									120.26054687500005,
									12.14174804687508
								],
								[
									120.34140625000009,
									12.077441406250045
								],
								[
									120.3145507812502,
									12.012402343750026
								],
								[
									120.24345703124999,
									12.004785156250065
								],
								[
									120.17363281249999,
									12.019628906250077
								],
								[
									120.10009765625011,
									11.993750000000048
								],
								[
									120.01054687499999,
									12.008251953125068
								],
								[
									119.95703125000011,
									12.069238281250051
								],
								[
									119.89609375000003,
									12.178759765624989
								],
								[
									119.86591796875001,
									12.199023437500031
								],
								[
									119.86962890625,
									12.243994140625048
								],
								[
									119.89179687500007,
									12.272509765625074
								],
								[
									119.88007812500007,
									12.279882812500077
								],
								[
									119.88574218749994,
									12.29985351562506
								],
								[
									119.89667968750018,
									12.313427734375068
								],
								[
									119.91640625000002,
									12.319091796875071
								],
								[
									119.9638671875,
									12.270410156250009
								],
								[
									120.07753906250014,
									12.197753906250043
								],
								[
									120.10000000000002,
									12.16767578125004
								]
							]
						],
						[
							[
								[
									122.65449218750007,
									12.309033203125054
								],
								[
									122.60332031249999,
									12.285595703125082
								],
								[
									122.49931640625016,
									12.383691406249994
								],
								[
									122.43886718749997,
									12.429492187500088
								],
								[
									122.42294921875003,
									12.455078124999972
								],
								[
									122.47187500000007,
									12.491943359375114
								],
								[
									122.60361328125009,
									12.491601562499952
								],
								[
									122.67363281250005,
									12.424267578125082
								],
								[
									122.68330078125007,
									12.382324218750071
								],
								[
									122.65449218750007,
									12.309033203125054
								]
							]
						],
						[
							[
								[
									125.23955078124999,
									12.52788085937506
								],
								[
									125.31035156250005,
									12.446289062499957
								],
								[
									125.32753906249997,
									12.38720703125
								],
								[
									125.32021484375002,
									12.321826171875003
								],
								[
									125.35224609375007,
									12.292773437499946
								],
								[
									125.4087890625002,
									12.284863281250026
								],
								[
									125.48125000000005,
									12.251953125000071
								],
								[
									125.53564453125011,
									12.191406250000071
								],
								[
									125.50332031250002,
									12.135791015625031
								],
								[
									125.51337890625018,
									12.054589843750094
								],
								[
									125.45654296875,
									11.95253906250008
								],
								[
									125.46425781250014,
									11.771582031249991
								],
								[
									125.49687500000005,
									11.713769531249937
								],
								[
									125.49999999999994,
									11.655419921874952
								],
								[
									125.49179687500003,
									11.594335937500034
								],
								[
									125.50576171874997,
									11.544238281250031
								],
								[
									125.59296875000007,
									11.37822265625006
								],
								[
									125.60898437500003,
									11.323046875000088
								],
								[
									125.58232421875005,
									11.279492187500097
								],
								[
									125.57353515624999,
									11.23823242187504
								],
								[
									125.62734375000014,
									11.233886718750043
								],
								[
									125.70400390625014,
									11.1647949218751
								],
								[
									125.74912109375009,
									11.073583984375077
								],
								[
									125.73564453124999,
									11.049609374999989
								],
								[
									125.67441406250003,
									11.120800781250097
								],
								[
									125.62812500000001,
									11.132031250000082
								],
								[
									125.43183593750018,
									11.112597656250031
								],
								[
									125.31152343750011,
									11.14228515625004
								],
								[
									125.2333984375,
									11.145068359375074
								],
								[
									125.1558593750002,
									11.267041015625054
								],
								[
									125.08789062500011,
									11.2873535156251
								],
								[
									125.0342773437502,
									11.341259765625068
								],
								[
									124.94531250000011,
									11.479150390625094
								],
								[
									124.91699218750011,
									11.558398437500074
								],
								[
									124.97890625000002,
									11.638476562500045
								],
								[
									124.99824218750007,
									11.702343750000097
								],
								[
									124.99501953125002,
									11.76494140625006
								],
								[
									124.93564453125009,
									11.754638671875085
								],
								[
									124.88427734375011,
									11.775488281250077
								],
								[
									124.82109374999999,
									11.852099609375045
								],
								[
									124.79580078125002,
									11.896337890625006
								],
								[
									124.74980468750016,
									11.933349609375085
								],
								[
									124.67675781250011,
									12.02089843749998
								],
								[
									124.57187500000003,
									12.055126953125026
								],
								[
									124.52910156250005,
									12.079199218750048
								],
								[
									124.44570312500002,
									12.152783203125026
								],
								[
									124.38486328125003,
									12.243994140625048
								],
								[
									124.3257812500002,
									12.4038085937501
								],
								[
									124.29472656250016,
									12.569335937500071
								],
								[
									124.56582031249997,
									12.526220703125077
								],
								[
									124.84013671875016,
									12.534570312500094
								],
								[
									125.15019531249999,
									12.572558593750017
								],
								[
									125.23955078124999,
									12.52788085937506
								]
							]
						],
						[
							[
								[
									123.71660156250016,
									12.287353515625085
								],
								[
									123.90830078125003,
									12.169091796875065
								],
								[
									124.04033203125005,
									11.966796874999972
								],
								[
									124.05566406249994,
									11.81157226562506
								],
								[
									124.0455078125002,
									11.75244140625
								],
								[
									123.98271484374999,
									11.818896484375031
								],
								[
									123.84775390625003,
									11.913574218750057
								],
								[
									123.75400390625003,
									11.934472656250051
								],
								[
									123.72519531250003,
									11.951562500000065
								],
								[
									123.73603515625001,
									12.002636718750082
								],
								[
									123.6748046875,
									12.05000000000004
								],
								[
									123.6675781250002,
									12.069335937500071
								],
								[
									123.61201171875018,
									12.090234375000065
								],
								[
									123.53105468749999,
									12.196630859375077
								],
								[
									123.47373046875003,
									12.216650390625063
								],
								[
									123.41884765624997,
									12.194238281250037
								],
								[
									123.29267578125001,
									12.036376953125028
								],
								[
									123.1578125000002,
									11.925634765624935
								],
								[
									123.15585937500003,
									11.967968750000026
								],
								[
									123.21054687500009,
									12.106591796875023
								],
								[
									123.24531250000007,
									12.328027343750023
								],
								[
									123.26718750000009,
									12.395458984375082
								],
								[
									123.2398437500002,
									12.494677734375045
								],
								[
									123.2364257812502,
									12.583496093750114
								],
								[
									123.3370117187502,
									12.542382812499994
								],
								[
									123.4629882812502,
									12.501220703124957
								],
								[
									123.55898437500002,
									12.444824218750014
								],
								[
									123.57480468750003,
									12.406933593750026
								],
								[
									123.71660156250016,
									12.287353515625085
								]
							]
						],
						[
							[
								[
									122.31083984375005,
									12.528808593750071
								],
								[
									122.27978515625011,
									12.498291015625071
								],
								[
									122.26093750000018,
									12.50307617187498
								],
								[
									122.24785156250016,
									12.556933593750031
								],
								[
									122.27802734375018,
									12.59291992187508
								],
								[
									122.28749999999997,
									12.589257812499952
								],
								[
									122.31083984375005,
									12.528808593750071
								]
							]
						],
						[
							[
								[
									122.09404296874999,
									12.35488281250008
								],
								[
									122.01396484375005,
									12.105615234375009
								],
								[
									121.96015625000018,
									12.191406250000071
								],
								[
									121.98193359375,
									12.24531250000004
								],
								[
									121.93564453125003,
									12.290380859374991
								],
								[
									121.92324218750002,
									12.331298828125071
								],
								[
									121.94101562500009,
									12.38540039062508
								],
								[
									121.98945312500018,
									12.435302734375028
								],
								[
									122.00156250000009,
									12.598535156250065
								],
								[
									122.10380859375005,
									12.650634765625114
								],
								[
									122.14501953125,
									12.652636718750074
								],
								[
									122.13027343750002,
									12.612597656250088
								],
								[
									122.13164062500005,
									12.537548828125068
								],
								[
									122.09404296874999,
									12.35488281250008
								]
							]
						],
						[
							[
								[
									123.77539062499994,
									12.453906250000088
								],
								[
									123.77910156249999,
									12.366259765625088
								],
								[
									123.74150390625016,
									12.398535156250091
								],
								[
									123.62060546874994,
									12.57050781250004
								],
								[
									123.58720703124999,
									12.633300781250043
								],
								[
									123.62148437500014,
									12.674902343749991
								],
								[
									123.70869140625007,
									12.610791015625068
								],
								[
									123.77539062499994,
									12.453906250000088
								]
							]
						],
						[
							[
								[
									123.28183593750003,
									12.853417968750037
								],
								[
									123.36718750000011,
									12.700830078125037
								],
								[
									123.27421874999999,
									12.805078125000037
								],
								[
									123.16640624999997,
									12.87587890625008
								],
								[
									123.05419921875011,
									12.993457031250045
								],
								[
									122.97343749999999,
									13.034716796874932
								],
								[
									122.94902343749999,
									13.05869140625002
								],
								[
									122.95751953124994,
									13.107177734375043
								],
								[
									123.01708984375011,
									13.116162109375097
								],
								[
									123.04355468750009,
									13.113378906250063
								],
								[
									123.20625000000018,
									12.905419921875051
								],
								[
									123.28183593750003,
									12.853417968750037
								]
							]
						],
						[
							[
								[
									120.70439453125005,
									13.479492187500043
								],
								[
									120.75537109374994,
									13.470996093750088
								],
								[
									120.91533203125005,
									13.501074218750077
								],
								[
									120.98076171875005,
									13.485986328125023
								],
								[
									121.02470703124999,
									13.428710937500085
								],
								[
									121.07929687500001,
									13.410742187499977
								],
								[
									121.12246093750014,
									13.381250000000009
								],
								[
									121.20273437500003,
									13.432324218750026
								],
								[
									121.28437500000018,
									13.374121093749977
								],
								[
									121.35683593750002,
									13.265478515625048
								],
								[
									121.44218750000016,
									13.188427734374983
								],
								[
									121.52275390625016,
									13.131201171875048
								],
								[
									121.5386718750002,
									13.088867187500043
								],
								[
									121.48974609375,
									13.019580078125045
								],
								[
									121.47480468750007,
									12.931591796875054
								],
								[
									121.47968750000018,
									12.837109374999997
								],
								[
									121.54062500000003,
									12.638183593749972
								],
								[
									121.51923828125007,
									12.584228515625085
								],
								[
									121.45800781250011,
									12.50795898437508
								],
								[
									121.41230468750001,
									12.42304687500011
								],
								[
									121.41816406250007,
									12.388769531249963
								],
								[
									121.40009765625001,
									12.360742187499937
								],
								[
									121.39433593749999,
									12.300585937500031
								],
								[
									121.35683593750002,
									12.313085937500091
								],
								[
									121.32236328125009,
									12.303613281250023
								],
								[
									121.28886718749999,
									12.276708984375048
								],
								[
									121.23671875000014,
									12.218798828124974
								],
								[
									121.15546875000018,
									12.236328125000085
								],
								[
									121.11699218750016,
									12.2534179687501
								],
								[
									121.10761718750001,
									12.303613281250023
								],
								[
									121.08339843749997,
									12.338964843750034
								],
								[
									121.04853515625018,
									12.359960937500048
								],
								[
									120.96250000000003,
									12.4465332031251
								],
								[
									120.92216796874999,
									12.511621093750037
								],
								[
									120.92148437500003,
									12.58110351562506
								],
								[
									120.8994140625,
									12.645849609374935
								],
								[
									120.85478515625005,
									12.703662109374989
								],
								[
									120.79599609375003,
									12.747998046875054
								],
								[
									120.77636718749994,
									12.790576171874932
								],
								[
									120.76875000000018,
									12.840917968750063
								],
								[
									120.76367187499994,
									12.969824218750034
								],
								[
									120.6802734375002,
									13.1306152343751
								],
								[
									120.6513671875,
									13.169140625000054
								],
								[
									120.57314453125014,
									13.208886718750065
								],
								[
									120.50830078124994,
									13.260058593750102
								],
								[
									120.48066406250001,
									13.311035156250085
								],
								[
									120.45546875000014,
									13.39350585937511
								],
								[
									120.43808593750003,
									13.405419921875051
								],
								[
									120.38750000000016,
									13.401660156250074
								],
								[
									120.3384765625002,
									13.412353515625043
								],
								[
									120.35273437500018,
									13.472949218750031
								],
								[
									120.40126953125002,
									13.517041015625054
								],
								[
									120.4683593750002,
									13.522412109375082
								],
								[
									120.65332031250011,
									13.497607421875088
								],
								[
									120.70439453125005,
									13.479492187500043
								]
							]
						],
						[
							[
								[
									121.91484374999999,
									13.540332031250088
								],
								[
									121.97656249999994,
									13.537402343750117
								],
								[
									121.99570312500003,
									13.54677734374998
								],
								[
									122.11455078124999,
									13.463183593750003
								],
								[
									122.10732421875014,
									13.420849609375082
								],
								[
									122.12236328124999,
									13.365136718750094
								],
								[
									122.0546875,
									13.268652343750077
								],
								[
									122.04238281250014,
									13.236181640625034
								],
								[
									122.00488281249994,
									13.20498046874998
								],
								[
									121.87587890625014,
									13.281738281249986
								],
								[
									121.82919921875003,
									13.328613281249943
								],
								[
									121.8150390625002,
									13.424462890625023
								],
								[
									121.86621093749994,
									13.566162109375114
								],
								[
									121.91484374999999,
									13.540332031250088
								]
							]
						],
						[
							[
								[
									120.27128906249999,
									13.750683593749955
								],
								[
									120.27285156250014,
									13.682958984375105
								],
								[
									120.10419921875018,
									13.782373046875108
								],
								[
									120.09941406250016,
									13.816943359375045
								],
								[
									120.10341796875002,
									13.842529296875014
								],
								[
									120.12070312500003,
									13.85805664062498
								],
								[
									120.21142578125,
									13.820654296875091
								],
								[
									120.27128906249999,
									13.750683593749955
								]
							]
						],
						[
							[
								[
									124.35361328125009,
									13.63222656249998
								],
								[
									124.32705078125002,
									13.567382812500085
								],
								[
									124.2945312500002,
									13.590332031249972
								],
								[
									124.24824218750001,
									13.586669921875028
								],
								[
									124.1753906250002,
									13.531542968750074
								],
								[
									124.05703125000014,
									13.605566406250048
								],
								[
									124.03886718749999,
									13.66313476562506
								],
								[
									124.12373046875007,
									13.790478515625068
								],
								[
									124.12285156250016,
									13.979687500000068
								],
								[
									124.15371093750014,
									14.026171874999946
								],
								[
									124.18623046875018,
									14.059521484375082
								],
								[
									124.22490234375016,
									14.07758789062494
								],
								[
									124.30830078125018,
									13.946972656250068
								],
								[
									124.33671874999999,
									13.93110351562494
								],
								[
									124.41718750000007,
									13.871044921875054
								],
								[
									124.39628906250016,
									13.750097656250105
								],
								[
									124.40400390625007,
									13.6794433593751
								],
								[
									124.35361328125009,
									13.63222656249998
								]
							]
						],
						[
							[
								[
									122.17539062500003,
									14.048828124999943
								],
								[
									122.17226562500014,
									14.008007812500068
								],
								[
									121.95625000000018,
									14.156054687500031
								],
								[
									121.9463867187502,
									14.181494140625063
								],
								[
									121.94599609375001,
									14.205126953124989
								],
								[
									121.95917968750007,
									14.2287597656251
								],
								[
									122.17539062500003,
									14.048828124999943
								]
							]
						],
						[
							[
								[
									122.03349609374999,
									15.005029296875051
								],
								[
									122.05156250000016,
									14.969873046875094
								],
								[
									122.03173828125011,
									14.971630859375097
								],
								[
									122.01728515625018,
									14.965283203124955
								],
								[
									121.9703125000002,
									14.892968749999966
								],
								[
									122.02167968750018,
									14.759423828124937
								],
								[
									121.98964843750014,
									14.662158203125017
								],
								[
									121.93300781250014,
									14.656054687500017
								],
								[
									121.91064453125011,
									14.666503906250014
								],
								[
									121.92216796875016,
									14.714550781250026
								],
								[
									121.93457031250011,
									14.736621093750088
								],
								[
									121.92304687500018,
									14.800000000000026
								],
								[
									121.8892578125002,
									14.839843750000071
								],
								[
									121.86230468749994,
									14.917187500000097
								],
								[
									121.82031250000011,
									14.963574218750054
								],
								[
									121.83984375,
									15.038134765625045
								],
								[
									121.97167968750011,
									15.046386718749957
								],
								[
									122.03349609374999,
									15.005029296875051
								]
							]
						],
						[
							[
								[
									121.10156249999994,
									18.615283203125074
								],
								[
									121.2544921875002,
									18.563427734375068
								],
								[
									121.59296875000007,
									18.376464843750085
								],
								[
									121.71679687499994,
									18.330078125000057
								],
								[
									121.84560546875002,
									18.29541015625
								],
								[
									121.94755859374999,
									18.28515625000003
								],
								[
									122.03847656250014,
									18.32792968749996
								],
								[
									122.07695312500016,
									18.37167968750009
								],
								[
									122.14667968750007,
									18.48657226562503
								],
								[
									122.22119140624994,
									18.50063476562505
								],
								[
									122.26552734375014,
									18.458837890625063
								],
								[
									122.2998046875,
									18.40278320312501
								],
								[
									122.31503906250009,
									18.320312500000085
								],
								[
									122.29384765625014,
									18.23427734375008
								],
								[
									122.22285156250001,
									18.15712890625008
								],
								[
									122.17949218749999,
									18.064257812500074
								],
								[
									122.15097656250003,
									17.75649414062508
								],
								[
									122.15234375,
									17.664404296875063
								],
								[
									122.17519531250002,
									17.575683593750085
								],
								[
									122.23681640624994,
									17.434863281250102
								],
								[
									122.26904296874994,
									17.39526367187503
								],
								[
									122.36230468750011,
									17.344873046874966
								],
								[
									122.38749999999999,
									17.306787109374937
								],
								[
									122.39287109375005,
									17.23837890624995
								],
								[
									122.40751953124999,
									17.178125000000023
								],
								[
									122.46787109375003,
									17.15512695312495
								],
								[
									122.5191406250002,
									17.12485351562509
								],
								[
									122.50000000000011,
									17.058007812499966
								],
								[
									122.46796875000007,
									16.990039062500074
								],
								[
									122.42578125,
									16.82265625000008
								],
								[
									122.22587890625005,
									16.435205078125108
								],
								[
									122.21416015625016,
									16.351513671874926
								],
								[
									122.13515625000014,
									16.184814453125057
								],
								[
									121.9747070312502,
									16.15791015625001
								],
								[
									121.78867187500003,
									16.077441406250045
								],
								[
									121.6851562500002,
									16.014746093750063
								],
								[
									121.5953125000002,
									15.93325195312508
								],
								[
									121.56093750000002,
									15.826757812499949
								],
								[
									121.59042968750009,
									15.778027343750068
								],
								[
									121.60917968750016,
									15.72602539062504
								],
								[
									121.60703125000009,
									15.669824218750051
								],
								[
									121.5791992187502,
									15.623193359375051
								],
								[
									121.4898437500002,
									15.509521484375085
								],
								[
									121.45205078125014,
									15.416650390625065
								],
								[
									121.41191406250005,
									15.375048828124946
								],
								[
									121.39228515625001,
									15.324414062500026
								],
								[
									121.39892578124994,
									15.266601562500057
								],
								[
									121.43496093750002,
									15.216308593750028
								],
								[
									121.54394531250011,
									14.999169921875023
								],
								[
									121.66054687499997,
									14.789501953125026
								],
								[
									121.6856445312502,
									14.765429687500088
								],
								[
									121.69541015625003,
									14.737304687500043
								],
								[
									121.62656250000003,
									14.681738281250091
								],
								[
									121.6279296875,
									14.581152343750034
								],
								[
									121.6485351562502,
									14.481494140625074
								],
								[
									121.75185546875002,
									14.234179687500045
								],
								[
									121.7666015625,
									14.168066406250077
								],
								[
									121.80048828125007,
									14.113867187500048
								],
								[
									121.85332031250016,
									14.063085937500006
								],
								[
									121.91171875000009,
									14.020410156250108
								],
								[
									122.07958984375,
									13.947119140625006
								],
								[
									122.14433593750005,
									13.932714843750091
								],
								[
									122.21171874999999,
									13.9301757812501
								],
								[
									122.22841796875002,
									13.979492187500028
								],
								[
									122.28749999999997,
									13.996191406250048
								],
								[
									122.2744140625,
									14.044726562500088
								],
								[
									122.20253906249997,
									14.111669921875048
								],
								[
									122.19970703125011,
									14.148046875000077
								],
								[
									122.23750000000018,
									14.175048828125071
								],
								[
									122.28261718750014,
									14.190820312500094
								],
								[
									122.38369140625014,
									14.263867187500054
								],
								[
									122.4908203125002,
									14.322363281250063
								],
								[
									122.62714843750018,
									14.317529296875065
								],
								[
									122.76103515624999,
									14.284863281250068
								],
								[
									122.85605468750009,
									14.250781250000045
								],
								[
									122.9341796875002,
									14.188085937500063
								],
								[
									123.01455078125014,
									14.079833984375043
								],
								[
									123.07099609375018,
									13.959960937499957
								],
								[
									123.07070312500002,
									13.902734375000023
								],
								[
									123.05693359375016,
									13.845458984375071
								],
								[
									123.05996093750014,
									13.788769531250068
								],
								[
									123.10195312499997,
									13.750244140625043
								],
								[
									123.2314453125,
									13.747363281249989
								],
								[
									123.2969726562502,
									13.836425781250014
								],
								[
									123.30537109375007,
									13.936572265624989
								],
								[
									123.25927734375,
									13.975439453125091
								],
								[
									123.28046875000001,
									14.024804687500023
								],
								[
									123.3203125,
									14.061669921875065
								],
								[
									123.37744140625,
									14.028662109375091
								],
								[
									123.43232421875007,
									13.966259765624997
								],
								[
									123.63281249999994,
									13.898486328125045
								],
								[
									123.68408203125011,
									13.897021484375102
								],
								[
									123.72597656250014,
									13.884326171875003
								],
								[
									123.81572265624999,
									13.837109375000068
								],
								[
									123.85761718750001,
									13.799609374999974
								],
								[
									123.8062500000002,
									13.721728515625088
								],
								[
									123.60712890625007,
									13.704443359374949
								],
								[
									123.54960937500016,
									13.645751953125071
								],
								[
									123.60810546875018,
									13.528076171875071
								],
								[
									123.70361328125,
									13.431591796875054
								],
								[
									123.76484375000001,
									13.353515625000043
								],
								[
									123.81923828125002,
									13.269482421875068
								],
								[
									123.81660156250018,
									13.191601562500097
								],
								[
									123.78515625000011,
									13.110546875000097
								],
								[
									123.87275390625018,
									13.116992187500088
								],
								[
									123.95517578125009,
									13.09970703125002
								],
								[
									124.06914062500005,
									13.031933593750068
								],
								[
									124.10458984375003,
									13.025000000000077
								],
								[
									124.14277343750001,
									13.035791015625065
								],
								[
									124.13730468750009,
									12.791162109375051
								],
								[
									124.05976562500018,
									12.567089843750054
								],
								[
									123.96171874999999,
									12.594970703125043
								],
								[
									123.87783203125014,
									12.689697265624986
								],
								[
									123.89492187499997,
									12.804980468750017
								],
								[
									123.94853515625016,
									12.91640625000008
								],
								[
									123.91796874999994,
									12.939941406249986
								],
								[
									123.86386718750003,
									12.930664062500043
								],
								[
									123.80234375000003,
									12.905566406250088
								],
								[
									123.73603515625001,
									12.896923828125097
								],
								[
									123.62675781250016,
									12.911767578125023
								],
								[
									123.40234375,
									13.033105468750051
								],
								[
									123.31093750000014,
									13.044091796875065
								],
								[
									123.29042968750002,
									13.099023437500065
								],
								[
									123.29550781250009,
									13.2155761718751
								],
								[
									123.20595703125014,
									13.353515625000043
								],
								[
									123.19160156250007,
									13.402880859374974
								],
								[
									123.16328125000007,
									13.441748046875077
								],
								[
									122.89619140625018,
									13.591943359375037
								],
								[
									122.86347656250018,
									13.617236328124946
								],
								[
									122.78134765625003,
									13.737060546875114
								],
								[
									122.59521484374994,
									13.907617187499952
								],
								[
									122.54306640625009,
									13.925048828125043
								],
								[
									122.486328125,
									13.92998046875006
								],
								[
									122.46796875000007,
									13.886718749999957
								],
								[
									122.49375000000009,
									13.82021484375008
								],
								[
									122.50419921875016,
									13.763085937499994
								],
								[
									122.50019531250007,
									13.703173828125045
								],
								[
									122.50800781250007,
									13.65683593750002
								],
								[
									122.59619140625,
									13.562011718750057
								],
								[
									122.60937500000011,
									13.517138671875074
								],
								[
									122.66787109375002,
									13.395361328125034
								],
								[
									122.67509765625016,
									13.253173828125028
								],
								[
									122.59990234375005,
									13.194140625000074
								],
								[
									122.5152343750002,
									13.260009765625
								],
								[
									122.51250000000016,
									13.31362304687508
								],
								[
									122.49794921875014,
									13.363525390625043
								],
								[
									122.40693359375007,
									13.492773437499991
								],
								[
									122.3765625000002,
									13.520605468749977
								],
								[
									122.20527343750018,
									13.648242187500045
								],
								[
									122.07275390625011,
									13.788378906250088
								],
								[
									121.77792968750009,
									13.937646484375023
								],
								[
									121.74287109375007,
									13.945849609375102
								],
								[
									121.69169921874999,
									13.934570312500028
								],
								[
									121.64345703125014,
									13.915966796875054
								],
								[
									121.50107421875009,
									13.842187500000037
								],
								[
									121.45078125000003,
									13.790771484375043
								],
								[
									121.44628906250011,
									13.71186523437504
								],
								[
									121.34414062499997,
									13.64912109375004
								],
								[
									121.20351562500014,
									13.640283203125023
								],
								[
									121.09550781250016,
									13.679492187500017
								],
								[
									121.00615234375016,
									13.758105468750045
								],
								[
									120.93232421875001,
									13.761865234375094
								],
								[
									120.84072265625002,
									13.884716796875082
								],
								[
									120.7291015625002,
									13.900537109375023
								],
								[
									120.63710937500002,
									13.804492187500074
								],
								[
									120.61738281250018,
									13.995312500000054
								],
								[
									120.61679687500003,
									14.18803710937506
								],
								[
									120.64267578125009,
									14.244335937499983
								],
								[
									120.68828125000016,
									14.29121093749994
								],
								[
									120.92207031250018,
									14.49311523437504
								],
								[
									120.95156250000014,
									14.55795898437502
								],
								[
									120.94130859374997,
									14.645068359375088
								],
								[
									120.88808593749997,
									14.715771484375097
								],
								[
									120.80449218749999,
									14.758789062499986
								],
								[
									120.70791015625014,
									14.776611328125057
								],
								[
									120.63828125000009,
									14.816162109375043
								],
								[
									120.58369140625007,
									14.881250000000065
								],
								[
									120.54677734374997,
									14.766113281250057
								],
								[
									120.58271484375001,
									14.594628906249937
								],
								[
									120.58867187499999,
									14.483105468749955
								],
								[
									120.55566406250011,
									14.441357421875068
								],
								[
									120.49570312500009,
									14.440185546875085
								],
								[
									120.43876953124999,
									14.453369140625028
								],
								[
									120.3960937500002,
									14.49331054687508
								],
								[
									120.36523437499994,
									14.608300781250051
								],
								[
									120.28388671875018,
									14.684375000000102
								],
								[
									120.25078124999999,
									14.793310546875091
								],
								[
									120.21386718750011,
									14.80878906250004
								],
								[
									120.13798828125005,
									14.800390624999935
								],
								[
									120.0821289062502,
									14.851074218749957
								],
								[
									120.04453125000009,
									14.978125000000077
								],
								[
									120.03662109375,
									15.114550781249989
								],
								[
									120.0049804687502,
									15.229248046875085
								],
								[
									119.95937500000014,
									15.340234375000051
								],
								[
									119.93281250000007,
									15.430908203124957
								],
								[
									119.89160156250011,
									15.83769531249996
								],
								[
									119.88144531250009,
									15.875000000000114
								],
								[
									119.85966796875016,
									15.905761718749972
								],
								[
									119.80820312500009,
									15.951953125000045
								],
								[
									119.76894531249997,
									16.008447265625023
								],
								[
									119.76181640625003,
									16.054980468750074
								],
								[
									119.7725585937502,
									16.255126953125
								],
								[
									119.79023437500007,
									16.303320312500063
								],
								[
									119.83076171875007,
									16.326562499999994
								],
								[
									119.88613281250014,
									16.287402343750102
								],
								[
									119.93037109375018,
									16.238769531250057
								],
								[
									119.98515625000016,
									16.21542968750009
								],
								[
									120.03339843750001,
									16.184570312500114
								],
								[
									120.12402343750011,
									16.066210937500074
								],
								[
									120.1597656250002,
									16.047656250000017
								],
								[
									120.27128906249999,
									16.05141601562508
								],
								[
									120.33701171875009,
									16.066455078125102
								],
								[
									120.36875000000003,
									16.109570312499926
								],
								[
									120.38876953125003,
									16.160937500000102
								],
								[
									120.38925781250003,
									16.221630859374926
								],
								[
									120.32500000000005,
									16.400341796874926
								],
								[
									120.30527343750009,
									16.529248046874983
								],
								[
									120.30439453125018,
									16.64545898437504
								],
								[
									120.32119140625014,
									16.761865234375023
								],
								[
									120.40888671875007,
									16.955615234375074
								],
								[
									120.42011718750001,
									17.09008789062503
								],
								[
									120.4117187500002,
									17.26992187500008
								],
								[
									120.42714843750014,
									17.376904296874926
								],
								[
									120.42451171875007,
									17.438330078125006
								],
								[
									120.37207031250011,
									17.535107421875097
								],
								[
									120.3583984375,
									17.63818359375003
								],
								[
									120.50507812500001,
									18.162646484375045
								],
								[
									120.55097656250007,
									18.264062500000108
								],
								[
									120.58447265624994,
									18.36875000000012
								],
								[
									120.5997070312502,
									18.507861328125102
								],
								[
									120.70937499999997,
									18.545947265625045
								],
								[
									120.81376953125005,
									18.60341796875005
								],
								[
									120.8677734375002,
									18.598925781250017
								],
								[
									120.92500000000007,
									18.58510742187505
								],
								[
									121.0513671875002,
									18.613671874999994
								],
								[
									121.10156249999994,
									18.615283203125074
								]
							]
						],
						[
							[
								[
									121.92167968750016,
									18.894726562500068
								],
								[
									121.85820312499999,
									18.822900390624994
								],
								[
									121.82519531250011,
									18.84272460937504
								],
								[
									121.86074218749997,
									18.912548828124955
								],
								[
									121.85976562500014,
									18.936767578125085
								],
								[
									121.88886718750001,
									18.991552734374977
								],
								[
									121.94335937500011,
									19.01044921875001
								],
								[
									121.98789062500003,
									18.956640625000063
								],
								[
									121.92167968750016,
									18.894726562500068
								]
							]
						],
						[
							[
								[
									121.25224609374999,
									19.082421875000023
								],
								[
									121.2466796875002,
									19.015185546875074
								],
								[
									121.19609375000005,
									19.050683593750023
								],
								[
									121.18486328125016,
									19.101416015624977
								],
								[
									121.18994140625011,
									19.138916015625057
								],
								[
									121.21318359375016,
									19.18359375000003
								],
								[
									121.24472656250009,
									19.143017578124926
								],
								[
									121.25224609374999,
									19.082421875000023
								]
							]
						],
						[
							[
								[
									121.52089843750014,
									19.361962890625023
								],
								[
									121.53125000000011,
									19.271337890625034
								],
								[
									121.47207031250014,
									19.273339843750108
								],
								[
									121.38291015625009,
									19.328466796875063
								],
								[
									121.37460937500009,
									19.35629882812495
								],
								[
									121.3759765625,
									19.379687500000102
								],
								[
									121.3916015625,
									19.399365234374926
								],
								[
									121.52089843750014,
									19.361962890625023
								]
							]
						],
						[
							[
								[
									121.96005859375003,
									20.365869140625108
								],
								[
									121.94130859374997,
									20.353710937499926
								],
								[
									121.91406250000011,
									20.35942382812513
								],
								[
									121.94121093750005,
									20.453710937500063
								],
								[
									121.99121093750011,
									20.47958984375009
								],
								[
									122.03115234374997,
									20.46938476562505
								],
								[
									121.96005859375003,
									20.365869140625108
								]
							]
						],
						[
							[
								[
									121.87812500000007,
									20.781884765624937
								],
								[
									121.82958984374994,
									20.70029296875012
								],
								[
									121.7906250000002,
									20.701171875000114
								],
								[
									121.79648437500003,
									20.746630859375045
								],
								[
									121.84785156250001,
									20.841259765624955
								],
								[
									121.86699218749999,
									20.839208984375063
								],
								[
									121.87812500000007,
									20.781884765624937
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "PHL",
					"su_a3": "PHL",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "PHL",
					"gu_a3": "PHL",
					"abbrev": "Phil.",
					"region_un": "Asia",
					"adm0_a3_us": "PHL",
					"scalerank": 1,
					"pop_est": 97976603,
					"adm0_dif": 0,
					"un_a3": "608",
					"pop_year": -99,
					"gdp_md_est": 317500,
					"name": "Philippines",
					"sovereignt": "Philippines",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Philippines",
					"postal": "PH",
					"sov_a3": "PHL",
					"note_brk": "",
					"brk_a3": "PHL",
					"wb_a2": "PH",
					"brk_diff": 0,
					"admin": "Philippines",
					"name_long": "Philippines",
					"iso_a3": "PHL",
					"iso_a2": "PH",
					"adm0_a3_is": "PHL",
					"level": 2,
					"formal_en": "Republic of the Philippines",
					"name_len": 11,
					"mapcolor7": 3,
					"long_len": 11,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "608",
					"homepart": 1,
					"subunit": "Philippines",
					"name_alt": "",
					"brk_name": "Philippines",
					"name_sort": "Philippines",
					"continent": "Asia",
					"mapcolor13": 8,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								19.604394531250023,
								54.4591796875001
							],
							[
								19.644238281250068,
								54.44707031250002
							],
							[
								19.92431640625003,
								54.43398437500002
							],
							[
								20.20820312500004,
								54.42075195312506
							],
							[
								20.66474609375004,
								54.40664062500005
							],
							[
								21.14052734375008,
								54.39179687500004
							],
							[
								21.634179687500023,
								54.37646484375003
							],
							[
								22.168457031250057,
								54.359863281250114
							],
							[
								22.73183593750008,
								54.35009765625006
							],
							[
								22.766210937499977,
								54.356787109375006
							],
							[
								22.823730468750057,
								54.39580078124996
							],
							[
								22.89394531250008,
								54.39052734375005
							],
							[
								22.976757812500068,
								54.36635742187511
							],
							[
								23.01552734375005,
								54.34833984375007
							],
							[
								23.03193359375004,
								54.327880859375085
							],
							[
								23.042187500000068,
								54.30419921875006
							],
							[
								23.087500000000063,
								54.299462890624966
							],
							[
								23.17031250000005,
								54.28144531250004
							],
							[
								23.282324218750063,
								54.24033203125009
							],
							[
								23.3701171875,
								54.20048828124996
							],
							[
								23.453613281250057,
								54.14345703125008
							],
							[
								23.481347656250023,
								54.079003906249994
							],
							[
								23.483007812500006,
								54.005957031250034
							],
							[
								23.477636718750063,
								53.95893554687504
							],
							[
								23.484667968750074,
								53.93979492187506
							],
							[
								23.598925781250074,
								53.599218750000034
							],
							[
								23.78925781250004,
								53.27094726562504
							],
							[
								23.859179687500074,
								53.11210937500002
							],
							[
								23.88710937500008,
								53.02753906250001
							],
							[
								23.909374999999983,
								52.90488281249998
							],
							[
								23.916308593750074,
								52.81875000000002
							],
							[
								23.91542968750008,
								52.770263671875
							],
							[
								23.901269531250023,
								52.70361328125
							],
							[
								23.844726562500057,
								52.664208984374966
							],
							[
								23.479589843750006,
								52.551562500000045
							],
							[
								23.410937500000045,
								52.516210937500034
							],
							[
								23.303320312500063,
								52.428369140624994
							],
							[
								23.20410156250003,
								52.33789062500003
							],
							[
								23.181250000000063,
								52.306982421875034
							],
							[
								23.175097656250074,
								52.28662109374997
							],
							[
								23.196972656250068,
								52.25693359375006
							],
							[
								23.32714843750003,
								52.20844726562504
							],
							[
								23.45839843750005,
								52.169531250000006
							],
							[
								23.501171875000068,
								52.14038085937503
							],
							[
								23.597949218750045,
								52.10307617187496
							],
							[
								23.633300781250057,
								52.06958007812497
							],
							[
								23.652441406250063,
								52.04038085937498
							],
							[
								23.65107421875004,
								51.972998046875034
							],
							[
								23.60742187500003,
								51.87978515625005
							],
							[
								23.62568359375001,
								51.809326171875
							],
							[
								23.581347656250045,
								51.76240234375001
							],
							[
								23.54482421875008,
								51.71025390624996
							],
							[
								23.539648437499977,
								51.618896484375
							],
							[
								23.605273437500045,
								51.517919921875034
							],
							[
								23.65888671875004,
								51.44897460937503
							],
							[
								23.6796875,
								51.39492187500002
							],
							[
								23.65761718750005,
								51.3524902343751
							],
							[
								23.664453125000023,
								51.31005859374997
							],
							[
								23.712207031250074,
								51.26513671875006
							],
							[
								23.863476562500068,
								51.126220703125
							],
							[
								23.938085937500063,
								50.992529296875034
							],
							[
								23.985742187500023,
								50.940429687500085
							],
							[
								24.095800781250063,
								50.87275390625004
							],
							[
								24.105761718750045,
								50.844970703125085
							],
							[
								24.061621093750006,
								50.81953125000004
							],
							[
								24.025976562500034,
								50.81616210937506
							],
							[
								23.9970703125,
								50.80937500000002
							],
							[
								23.978417968750023,
								50.78559570312507
							],
							[
								24.007324218750057,
								50.76015625000002
							],
							[
								24.04628906250008,
								50.722802734374966
							],
							[
								24.0947265625,
								50.617041015625006
							],
							[
								24.089941406250006,
								50.53046875000004
							],
							[
								24.05263671875005,
								50.508447265624994
							],
							[
								24.004980468750034,
								50.45703125
							],
							[
								23.97265625,
								50.41005859375002
							],
							[
								23.711718750000045,
								50.37734375000002
							],
							[
								23.649023437500063,
								50.32705078125008
							],
							[
								23.506152343750017,
								50.22983398437509
							],
							[
								23.408593750000023,
								50.17392578125006
							],
							[
								23.264453125000045,
								50.07285156249998
							],
							[
								23.03632812500004,
								49.89907226562502
							],
							[
								22.952246093750034,
								49.82636718750004
							],
							[
								22.890722656250034,
								49.76625976562505
							],
							[
								22.706152343750006,
								49.60620117187503
							],
							[
								22.6494140625,
								49.53901367187504
							],
							[
								22.660644531250057,
								49.483691406250045
							],
							[
								22.719921875000068,
								49.353808593750045
							],
							[
								22.73242187500003,
								49.295166015625
							],
							[
								22.721972656250017,
								49.24096679687497
							],
							[
								22.70234375000004,
								49.19272460937509
							],
							[
								22.705664062500006,
								49.17119140624996
							],
							[
								22.76015625000008,
								49.13623046875003
							],
							[
								22.847070312500023,
								49.08125000000004
							],
							[
								22.852050781250057,
								49.062744140625085
							],
							[
								22.83974609375005,
								49.03891601562512
							],
							[
								22.809765625000068,
								49.02075195312506
							],
							[
								22.701269531249977,
								49.03994140625005
							],
							[
								22.57998046875005,
								49.0771972656251
							],
							[
								22.538671874999977,
								49.07270507812507
							],
							[
								22.473046875000023,
								49.08129882812503
							],
							[
								22.20253906250008,
								49.15322265625002
							],
							[
								22.020117187500034,
								49.20952148437496
							],
							[
								22.00214843750001,
								49.24609375000003
							],
							[
								21.967675781250023,
								49.299072265625
							],
							[
								21.89013671875003,
								49.34345703125007
							],
							[
								21.712109374999983,
								49.381933593750006
							],
							[
								21.639648437500057,
								49.41196289062498
							],
							[
								21.35048828125005,
								49.428759765625045
							],
							[
								21.22500000000005,
								49.429443359375
							],
							[
								21.13613281250008,
								49.41704101562496
							],
							[
								21.079394531250045,
								49.41826171875002
							],
							[
								21.00117187500001,
								49.33984375000003
							],
							[
								20.947265625000057,
								49.31708984375001
							],
							[
								20.868457031250074,
								49.31469726562497
							],
							[
								20.799511718750068,
								49.32866210937499
							],
							[
								20.72900390625,
								49.369921875000045
							],
							[
								20.61611328125008,
								49.391699218750034
							],
							[
								20.53457031250008,
								49.381201171875034
							],
							[
								20.474511718750023,
								49.39018554687499
							],
							[
								20.422656250000017,
								49.392333984375
							],
							[
								20.404687499999994,
								49.38408203124999
							],
							[
								20.36298828125004,
								49.38525390625006
							],
							[
								20.302539062500074,
								49.365527343750045
							],
							[
								20.23652343750004,
								49.33764648437503
							],
							[
								20.163671875000006,
								49.31640624999997
							],
							[
								20.107617187500068,
								49.270751953125
							],
							[
								20.0576171875,
								49.181298828124994
							],
							[
								19.916113281250034,
								49.22138671875007
							],
							[
								19.868945312500017,
								49.204003906249994
							],
							[
								19.80224609375003,
								49.19233398437501
							],
							[
								19.756640625000045,
								49.20439453124999
							],
							[
								19.767382812500017,
								49.235205078125034
							],
							[
								19.78798828125005,
								49.26997070312501
							],
							[
								19.787011718750023,
								49.31855468750007
							],
							[
								19.77392578125003,
								49.37216796875006
							],
							[
								19.730078125000063,
								49.38959960937504
							],
							[
								19.664160156250034,
								49.396044921875045
							],
							[
								19.63027343750005,
								49.406640624999966
							],
							[
								19.62666015625004,
								49.42436523437502
							],
							[
								19.593066406250045,
								49.447119140625034
							],
							[
								19.534765625000063,
								49.504785156249994
							],
							[
								19.47968750000004,
								49.57636718750001
							],
							[
								19.441601562499983,
								49.59770507812499
							],
							[
								19.38623046875,
								49.563623046874966
							],
							[
								19.302343750000034,
								49.52485351562498
							],
							[
								19.250195312499983,
								49.51142578125001
							],
							[
								19.149414062500057,
								49.400000000000034
							],
							[
								18.968359375000034,
								49.39624023437497
							],
							[
								18.957226562499983,
								49.44829101562502
							],
							[
								18.93818359375001,
								49.498291015625
							],
							[
								18.83222656250001,
								49.51079101562496
							],
							[
								18.82929687500004,
								49.54013671874998
							],
							[
								18.806933593750017,
								49.61372070312507
							],
							[
								18.594628906250023,
								49.75781250000003
							],
							[
								18.56884765625,
								49.81791992187502
							],
							[
								18.5771484375,
								49.84111328125002
							],
							[
								18.562402343750023,
								49.87934570312498
							],
							[
								18.516210937500034,
								49.90239257812499
							],
							[
								18.348437500000045,
								49.929833984374966
							],
							[
								18.305273437500034,
								49.91406250000006
							],
							[
								18.26630859375001,
								49.93027343749998
							],
							[
								18.20527343750001,
								49.964746093749994
							],
							[
								18.099218749999977,
								49.992773437500006
							],
							[
								18.087695312500045,
								50.00727539062504
							],
							[
								18.049511718750068,
								50.03193359374998
							],
							[
								18.02832031250003,
								50.03525390625006
							],
							[
								18.0146484375,
								50.02026367187503
							],
							[
								17.983789062499994,
								49.99907226562496
							],
							[
								17.874804687500017,
								49.972265625000006
							],
							[
								17.83125000000001,
								49.98330078125002
							],
							[
								17.79169921875004,
								50.00659179687497
							],
							[
								17.74658203125,
								50.056787109374994
							],
							[
								17.68105468750005,
								50.10078124999998
							],
							[
								17.627050781250063,
								50.11640625000007
							],
							[
								17.596289062500034,
								50.13950195312506
							],
							[
								17.58935546875003,
								50.157470703125
							],
							[
								17.709277343750045,
								50.19355468750007
							],
							[
								17.735449218750034,
								50.23076171874999
							],
							[
								17.720117187500023,
								50.29863281249996
							],
							[
								17.702246093750034,
								50.30717773437502
							],
							[
								17.654687500000023,
								50.28422851562496
							],
							[
								17.55458984375005,
								50.26406250000002
							],
							[
								17.46230468750008,
								50.25478515625002
							],
							[
								17.415234374999983,
								50.25478515625002
							],
							[
								17.151953125000006,
								50.37832031250005
							],
							[
								16.980761718750045,
								50.416113281250006
							],
							[
								16.88007812500004,
								50.42705078125002
							],
							[
								16.86914062500003,
								50.41450195312504
							],
							[
								16.914746093749983,
								50.34521484375006
							],
							[
								16.99335937500001,
								50.25971679687504
							],
							[
								16.98964843750008,
								50.236914062500006
							],
							[
								16.895312500000045,
								50.20195312499999
							],
							[
								16.841796875000057,
								50.18671875000001
							],
							[
								16.778613281250074,
								50.15703124999999
							],
							[
								16.72529296875004,
								50.116064453125006
							],
							[
								16.67910156250005,
								50.09746093750002
							],
							[
								16.63916015624997,
								50.102148437500006
							],
							[
								16.59667968750003,
								50.121923828125034
							],
							[
								16.487597656250017,
								50.248388671875034
							],
							[
								16.35048828125005,
								50.34521484375006
							],
							[
								16.33417968750001,
								50.36689453125001
							],
							[
								16.291308593750074,
								50.37187499999996
							],
							[
								16.230761718750017,
								50.39409179687496
							],
							[
								16.210351562500023,
								50.423730468749966
							],
							[
								16.24072265625,
								50.45468750000006
							],
							[
								16.282519531250074,
								50.48300781250006
							],
							[
								16.356640625000068,
								50.50048828124997
							],
							[
								16.37910156250004,
								50.51689453125002
							],
							[
								16.39228515625004,
								50.54165039062502
							],
							[
								16.419726562500045,
								50.57363281250005
							],
							[
								16.41250000000008,
								50.58515624999998
							],
							[
								16.359960937500034,
								50.62138671874999
							],
							[
								16.2822265625,
								50.655615234375034
							],
							[
								16.06640625,
								50.62993164062496
							],
							[
								16.007226562500023,
								50.61162109374996
							],
							[
								15.973828125000068,
								50.63544921875001
							],
							[
								15.948535156250074,
								50.670263671875006
							],
							[
								15.893945312500051,
								50.67690429687502
							],
							[
								15.819238281250023,
								50.70869140625001
							],
							[
								15.730566406250063,
								50.73969726562504
							],
							[
								15.643945312499994,
								50.748876953125034
							],
							[
								15.463964843750006,
								50.793847656249966
							],
							[
								15.394628906250006,
								50.79628906250002
							],
							[
								15.35439453125008,
								50.81176757812497
							],
							[
								15.312597656250006,
								50.84575195312496
							],
							[
								15.27705078125004,
								50.88300781250001
							],
							[
								15.258593750000017,
								50.958544921875045
							],
							[
								15.1259765625,
								50.99287109375001
							],
							[
								14.993750000000063,
								51.01435546875004
							],
							[
								14.984472656250034,
								51.00341796875003
							],
							[
								14.989941406249983,
								50.92724609375006
							],
							[
								14.982910156249972,
								50.886572265625034
							],
							[
								14.895800781249989,
								50.861376953125045
							],
							[
								14.809375000000074,
								50.858984375000006
							],
							[
								14.814257812500074,
								50.8716308593751
							],
							[
								14.917480468750057,
								51.00874023437504
							],
							[
								14.9638671875,
								51.095117187499966
							],
							[
								15.0166015625,
								51.25273437500002
							],
							[
								14.953125000000028,
								51.37714843750004
							],
							[
								14.935546875,
								51.4353515625001
							],
							[
								14.905957031250011,
								51.46333007812501
							],
							[
								14.724707031250034,
								51.52387695312501
							],
							[
								14.7109375,
								51.54492187500003
							],
							[
								14.738671875000051,
								51.6271484375001
							],
							[
								14.724902343749989,
								51.66171875000012
							],
							[
								14.681347656250011,
								51.6981933593751
							],
							[
								14.623925781250023,
								51.770800781250045
							],
							[
								14.601660156250034,
								51.83237304687498
							],
							[
								14.674902343750034,
								51.90483398437499
							],
							[
								14.692968750000063,
								51.958007812500085
							],
							[
								14.724804687500068,
								52.03085937500009
							],
							[
								14.748144531250034,
								52.07080078125006
							],
							[
								14.752539062500034,
								52.08183593749999
							],
							[
								14.704589843750028,
								52.11020507812509
							],
							[
								14.692382812500028,
								52.15004882812502
							],
							[
								14.705371093750017,
								52.20747070312501
							],
							[
								14.679882812500068,
								52.24999999999997
							],
							[
								14.615625000000023,
								52.2776367187501
							],
							[
								14.573925781250068,
								52.31416015624998
							],
							[
								14.554589843750023,
								52.35966796875002
							],
							[
								14.569726562499994,
								52.43110351562501
							],
							[
								14.619433593750017,
								52.52851562500004
							],
							[
								14.514062500000023,
								52.645605468750006
							],
							[
								14.253710937500017,
								52.78251953125002
							],
							[
								14.128613281250011,
								52.878222656250045
							],
							[
								14.138867187500068,
								52.932861328125
							],
							[
								14.193652343750045,
								52.98232421875005
							],
							[
								14.293164062500068,
								53.02675781250002
							],
							[
								14.368554687500051,
								53.105566406250006
							],
							[
								14.410937500000074,
								53.199023437500045
							],
							[
								14.412304687499983,
								53.21674804687501
							],
							[
								14.41455078125,
								53.28349609375002
							],
							[
								14.298730468750051,
								53.55644531250002
							],
							[
								14.279882812500006,
								53.624755859375
							],
							[
								14.266113281250057,
								53.70712890625009
							],
							[
								14.258886718750006,
								53.729638671874966
							],
							[
								14.487597656250045,
								53.671875
							],
							[
								14.583496093750057,
								53.63935546875004
							],
							[
								14.571582031250017,
								53.675878906250034
							],
							[
								14.552148437500051,
								53.707324218750045
							],
							[
								14.56494140625,
								53.753515625000034
							],
							[
								14.558398437500017,
								53.82319335937501
							],
							[
								14.350878906250017,
								53.85874023437498
							],
							[
								14.213671875000017,
								53.87075195312502
							],
							[
								14.1982421875,
								53.919042968750006
							],
							[
								14.211425781250028,
								53.95034179687508
							],
							[
								14.249316406250017,
								53.93193359374996
							],
							[
								14.384179687500051,
								53.924707031249994
							],
							[
								14.71572265625008,
								54.01831054687497
							],
							[
								15.288378906250045,
								54.13989257812506
							],
							[
								15.900000000000034,
								54.25395507812502
							],
							[
								16.042773437500074,
								54.26635742187497
							],
							[
								16.186328125000017,
								54.29038085937498
							],
							[
								16.239355468750063,
								54.33305664062496
							],
							[
								16.292285156250017,
								54.36162109375002
							],
							[
								16.375585937500034,
								54.43686523437498
							],
							[
								16.559765625000068,
								54.553808593750006
							],
							[
								16.885449218750068,
								54.59638671875007
							],
							[
								17.007031250000068,
								54.65185546875
							],
							[
								17.26191406250001,
								54.72954101562502
							],
							[
								17.84296875000001,
								54.81669921875002
							],
							[
								18.085644531250068,
								54.835839843749994
							],
							[
								18.32343750000001,
								54.83818359375002
							],
							[
								18.53515624999997,
								54.769433593749966
							],
							[
								18.75927734375,
								54.6845703125
							],
							[
								18.799609375000045,
								54.633349609375045
							],
							[
								18.678320312500006,
								54.66528320312497
							],
							[
								18.501562500000063,
								54.74150390624996
							],
							[
								18.436230468750068,
								54.744726562500006
							],
							[
								18.587109374999983,
								54.51289062500001
							],
							[
								18.66962890625001,
								54.430908203125
							],
							[
								18.83642578124997,
								54.36958007812504
							],
							[
								18.97626953125004,
								54.34892578125002
							],
							[
								19.40712890625008,
								54.386083984375034
							],
							[
								19.560156249999977,
								54.43461914062496
							],
							[
								19.604394531250023,
								54.4591796875001
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "POL",
					"su_a3": "POL",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "POL",
					"gu_a3": "POL",
					"abbrev": "Pol.",
					"region_un": "Europe",
					"adm0_a3_us": "POL",
					"scalerank": 1,
					"pop_est": 38482919,
					"adm0_dif": 0,
					"un_a3": "616",
					"pop_year": -99,
					"gdp_md_est": 667900,
					"name": "Poland",
					"sovereignt": "Poland",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Poland",
					"postal": "PL",
					"sov_a3": "POL",
					"note_brk": "",
					"brk_a3": "POL",
					"wb_a2": "PL",
					"brk_diff": 0,
					"admin": "Poland",
					"name_long": "Poland",
					"iso_a3": "POL",
					"iso_a2": "PL",
					"adm0_a3_is": "POL",
					"level": 2,
					"formal_en": "Republic of Poland",
					"name_len": 6,
					"mapcolor7": 3,
					"long_len": 6,
					"mapcolor8": 7,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "616",
					"homepart": 1,
					"subunit": "Poland",
					"name_alt": "",
					"brk_name": "Poland",
					"name_sort": "Poland",
					"continent": "Europe",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-17.190869140624926,
									32.86860351562504
								],
								[
									-17.054492187499932,
									32.81586914062504
								],
								[
									-16.92919921875,
									32.84140625000009
								],
								[
									-16.77397460937499,
									32.773535156250034
								],
								[
									-16.693261718749966,
									32.75800781250007
								],
								[
									-16.765283203124994,
									32.709716796875085
								],
								[
									-16.837402343749943,
									32.648291015625006
								],
								[
									-17.018261718749926,
									32.66279296875004
								],
								[
									-17.17119140624999,
									32.72187499999998
								],
								[
									-17.226025390624983,
									32.766845703125
								],
								[
									-17.241015625000017,
									32.807373046875085
								],
								[
									-17.190869140624926,
									32.86860351562504
								]
							]
						],
						[
							[
								[
									-25.02734375,
									36.9599609375
								],
								[
									-25.03154296874999,
									36.94155273437508
								],
								[
									-25.08837890625,
									36.94887695312505
								],
								[
									-25.15991210937503,
									36.943359375000085
								],
								[
									-25.198388671874966,
									36.99653320312498
								],
								[
									-25.163525390624955,
									37.01855468749994
								],
								[
									-25.082910156249966,
									37.02402343750009
								],
								[
									-25.044335937500023,
									37.00019531250001
								],
								[
									-25.02734375,
									36.9599609375
								]
							]
						],
						[
							[
								[
									-25.64897460937499,
									37.84091796875006
								],
								[
									-25.58549804687496,
									37.83403320312499
								],
								[
									-25.2666015625,
									37.84863281249994
								],
								[
									-25.18193359374999,
									37.83789062499997
								],
								[
									-25.19072265624999,
									37.76435546875001
								],
								[
									-25.251123046874937,
									37.73500976562508
								],
								[
									-25.43901367187496,
									37.71533203125006
								],
								[
									-25.73447265624992,
									37.76289062500007
								],
								[
									-25.833691406249983,
									37.826074218749966
								],
								[
									-25.847851562499926,
									37.87241210937509
								],
								[
									-25.845898437499983,
									37.89404296875006
								],
								[
									-25.783740234375017,
									37.91113281249997
								],
								[
									-25.64897460937499,
									37.84091796875006
								]
							]
						],
						[
							[
								[
									-28.14726562499996,
									38.45268554687499
								],
								[
									-28.064794921875034,
									38.41274414062494
								],
								[
									-28.18974609374999,
									38.40415039062506
								],
								[
									-28.231152343749983,
									38.384667968749994
								],
								[
									-28.332421875000023,
									38.412890625000045
								],
								[
									-28.454492187500023,
									38.40864257812507
								],
								[
									-28.531152343749994,
									38.46254882812505
								],
								[
									-28.54882812499997,
									38.5185546875
								],
								[
									-28.51025390625,
									38.5530273437501
								],
								[
									-28.402148437500017,
									38.55336914062508
								],
								[
									-28.14726562499996,
									38.45268554687499
								]
							]
						],
						[
							[
								[
									-28.641308593749983,
									38.52499999999998
								],
								[
									-28.743847656249983,
									38.52236328125008
								],
								[
									-28.842041015625,
									38.59843749999993
								],
								[
									-28.69775390625003,
									38.6384765625001
								],
								[
									-28.655419921874994,
									38.6140625000001
								],
								[
									-28.624218749999955,
									38.58632812500005
								],
								[
									-28.605810546875034,
									38.55073242187498
								],
								[
									-28.641308593749983,
									38.52499999999998
								]
							]
						],
						[
							[
								[
									-27.778466796874966,
									38.5556152343751
								],
								[
									-27.825878906249926,
									38.543554687500034
								],
								[
									-28.09233398437496,
									38.6205566406251
								],
								[
									-28.18725585937503,
									38.65537109375006
								],
								[
									-28.310644531250034,
									38.743896484375085
								],
								[
									-27.962646484375,
									38.63632812500009
								],
								[
									-27.778466796874966,
									38.5556152343751
								]
							]
						],
						[
							[
								[
									-27.07524414062496,
									38.64345703125005
								],
								[
									-27.09531249999995,
									38.634033203125085
								],
								[
									-27.30283203124995,
									38.66103515625008
								],
								[
									-27.361914062500006,
									38.69785156250012
								],
								[
									-27.38593750000001,
									38.765820312499926
								],
								[
									-27.35102539062501,
									38.78896484374994
								],
								[
									-27.259667968749966,
									38.80268554687507
								],
								[
									-27.127001953125017,
									38.78984374999993
								],
								[
									-27.04194335937501,
									38.74121093749997
								],
								[
									-27.04199218750003,
									38.67890624999998
								],
								[
									-27.07524414062496,
									38.64345703125005
								]
							]
						],
						[
							[
								[
									-31.137109374999966,
									39.40693359375007
								],
								[
									-31.181347656249983,
									39.358935546875045
								],
								[
									-31.25761718749999,
									39.37597656249997
								],
								[
									-31.282958984375,
									39.39409179687493
								],
								[
									-31.260839843750034,
									39.49677734374998
								],
								[
									-31.199853515624937,
									39.520849609375006
								],
								[
									-31.138623046874983,
									39.47944335937501
								],
								[
									-31.137109374999966,
									39.40693359375007
								]
							]
						],
						[
							[
								[
									-7.4061523437499375,
									37.17944335937494
								],
								[
									-7.493603515624983,
									37.16831054687509
								],
								[
									-7.834130859374994,
									37.00571289062509
								],
								[
									-7.939697265625028,
									37.00541992187493
								],
								[
									-8.136767578124932,
									37.07705078125005
								],
								[
									-8.484326171874955,
									37.10004882812504
								],
								[
									-8.597656249999943,
									37.121337890625114
								],
								[
									-8.739111328124977,
									37.074609374999994
								],
								[
									-8.84843749999996,
									37.07568359374994
								],
								[
									-8.935351562499989,
									37.01601562500005
								],
								[
									-8.997802734375028,
									37.03227539062499
								],
								[
									-8.92626953125,
									37.166064453125074
								],
								[
									-8.814160156250011,
									37.430810546874994
								],
								[
									-8.818554687500011,
									37.59243164062505
								],
								[
									-8.791845703124977,
									37.73281250000005
								],
								[
									-8.822656249999966,
									37.871875000000074
								],
								[
									-8.87895507812496,
									37.95869140624998
								],
								[
									-8.802246093749972,
									38.18383789062503
								],
								[
									-8.810937499999966,
									38.299755859374926
								],
								[
									-8.881103515624972,
									38.44667968750011
								],
								[
									-8.668310546874949,
									38.424316406250085
								],
								[
									-8.73398437499992,
									38.482421875000114
								],
								[
									-8.798876953124989,
									38.518164062500006
								],
								[
									-8.861621093749989,
									38.50996093750004
								],
								[
									-8.914794921874972,
									38.51210937500002
								],
								[
									-9.09599609374996,
									38.45522460937508
								],
								[
									-9.186718749999955,
									38.43818359375007
								],
								[
									-9.213281249999966,
									38.44809570312495
								],
								[
									-9.203369140624972,
									38.53896484375008
								],
								[
									-9.250390624999966,
									38.65673828125
								],
								[
									-9.17783203124992,
									38.68779296874993
								],
								[
									-9.093310546874932,
									38.696679687499966
								],
								[
									-9.021484374999972,
									38.746875000000074
								],
								[
									-8.977050781249972,
									38.80292968750004
								],
								[
									-9.000488281249943,
									38.90302734375007
								],
								[
									-8.93808593749992,
									38.998095703125074
								],
								[
									-8.79160156249992,
									39.078173828125045
								],
								[
									-8.867480468749932,
									39.065966796875045
								],
								[
									-8.954296874999955,
									39.016064453124926
								],
								[
									-9.091015625000011,
									38.83466796875001
								],
								[
									-9.135791015624989,
									38.742773437500034
								],
								[
									-9.252294921875006,
									38.71279296875005
								],
								[
									-9.35673828124996,
									38.69790039062502
								],
								[
									-9.410205078124932,
									38.70751953125003
								],
								[
									-9.474121093749972,
									38.730859374999994
								],
								[
									-9.479736328124972,
									38.79877929687498
								],
								[
									-9.474755859374937,
									38.852929687499994
								],
								[
									-9.431445312499989,
									38.96044921875006
								],
								[
									-9.41435546874996,
									39.112109375000045
								],
								[
									-9.35283203124996,
									39.248144531250034
								],
								[
									-9.35722656249996,
									39.28427734374995
								],
								[
									-9.374755859375,
									39.33828124999994
								],
								[
									-9.31962890624996,
									39.39111328125003
								],
								[
									-9.251416015624983,
									39.42602539062506
								],
								[
									-9.148291015624949,
									39.54257812500009
								],
								[
									-9.004052734374966,
									39.82055664062506
								],
								[
									-8.837841796874926,
									40.11567382812504
								],
								[
									-8.851318359375028,
									40.15180664062504
								],
								[
									-8.886621093750023,
									40.17944335937497
								],
								[
									-8.87265624999992,
									40.259082031250045
								],
								[
									-8.772412109374926,
									40.60566406250004
								],
								[
									-8.731591796874966,
									40.65092773437502
								],
								[
									-8.684619140624989,
									40.75253906250012
								],
								[
									-8.673974609374937,
									40.91650390624994
								],
								[
									-8.655566406249932,
									41.029492187499955
								],
								[
									-8.659814453124994,
									41.08627929687498
								],
								[
									-8.674609374999989,
									41.154492187499926
								],
								[
									-8.73837890624992,
									41.284667968750085
								],
								[
									-8.805664062499943,
									41.56000976562504
								],
								[
									-8.810839843749932,
									41.65195312500012
								],
								[
									-8.755419921874932,
									41.69838867187508
								],
								[
									-8.846386718749983,
									41.705175781250034
								],
								[
									-8.887597656249937,
									41.76459960937507
								],
								[
									-8.878222656249989,
									41.832080078125045
								],
								[
									-8.777148437500017,
									41.94106445312505
								],
								[
									-8.68295898437492,
									42.00849609375001
								],
								[
									-8.589648437499989,
									42.05273437500006
								],
								[
									-8.538085937499972,
									42.06933593749997
								],
								[
									-8.322558593749932,
									42.11508789062506
								],
								[
									-8.266064453124983,
									42.13740234374998
								],
								[
									-8.213085937499926,
									42.13369140624994
								],
								[
									-8.204199218749977,
									42.11186523437493
								],
								[
									-8.173583984374972,
									42.069384765625074
								],
								[
									-8.139306640624994,
									42.03994140625002
								],
								[
									-8.129980468749977,
									42.01816406250012
								],
								[
									-8.213330078124983,
									41.92709960937495
								],
								[
									-8.224755859374994,
									41.89584960937498
								],
								[
									-8.18124999999992,
									41.836962890625045
								],
								[
									-8.173535156249955,
									41.819970703124966
								],
								[
									-8.152490234374937,
									41.81196289062504
								],
								[
									-8.094433593749926,
									41.81420898437503
								],
								[
									-7.990966796874972,
									41.85190429687509
								],
								[
									-7.920849609374983,
									41.88364257812498
								],
								[
									-7.896386718749994,
									41.87055664062507
								],
								[
									-7.6930664062499545,
									41.888476562500074
								],
								[
									-7.644677734374966,
									41.873974609374955
								],
								[
									-7.612597656249989,
									41.857958984375074
								],
								[
									-7.512597656249966,
									41.835986328125045
								],
								[
									-7.40361328124996,
									41.833691406249926
								],
								[
									-7.268554687499972,
									41.864404296874966
								],
								[
									-7.209619140624966,
									41.89526367187494
								],
								[
									-7.198339843749977,
									41.92939453125007
								],
								[
									-7.195361328124989,
									41.955224609374994
								],
								[
									-7.177929687499983,
									41.97167968749997
								],
								[
									-7.147119140625023,
									41.98115234375004
								],
								[
									-7.09912109375,
									41.964208984375034
								],
								[
									-7.0304687499999545,
									41.95063476562504
								],
								[
									-6.865527343749932,
									41.94526367187501
								],
								[
									-6.833203124999926,
									41.964160156250045
								],
								[
									-6.777294921874983,
									41.95849609374994
								],
								[
									-6.70361328125,
									41.93457031250006
								],
								[
									-6.61826171874992,
									41.94238281250003
								],
								[
									-6.575341796874966,
									41.91308593750003
								],
								[
									-6.557519531249994,
									41.87412109375009
								],
								[
									-6.552587890624949,
									41.789550781250085
								],
								[
									-6.558984375000023,
									41.70405273437498
								],
								[
									-6.5421874999999545,
									41.67250976562505
								],
								[
									-6.48466796874996,
									41.66440429687506
								],
								[
									-6.391699218749949,
									41.665380859375006
								],
								[
									-6.3080566406249545,
									41.64218750000009
								],
								[
									-6.2431152343749545,
									41.60180664062503
								],
								[
									-6.221679687499943,
									41.56044921875002
								],
								[
									-6.212499999999949,
									41.53203124999993
								],
								[
									-6.2443359374999545,
									41.51591796874993
								],
								[
									-6.28935546874996,
									41.45502929687504
								],
								[
									-6.40312499999996,
									41.375390624999994
								],
								[
									-6.56591796875,
									41.30371093750006
								],
								[
									-6.690136718750011,
									41.21450195312508
								],
								[
									-6.7757812499999375,
									41.10771484374999
								],
								[
									-6.8828125,
									41.062402343749994
								],
								[
									-6.91552734375,
									41.03803710937501
								],
								[
									-6.928466796874972,
									41.00913085937498
								],
								[
									-6.857714843749932,
									40.87832031250008
								],
								[
									-6.835888671874926,
									40.77749023437505
								],
								[
									-6.818359375,
									40.65405273437494
								],
								[
									-6.829833984374943,
									40.619091796874926
								],
								[
									-6.835693359375,
									40.48315429687494
								],
								[
									-6.852050781249943,
									40.44326171875008
								],
								[
									-6.847949218749989,
									40.41098632812498
								],
								[
									-6.82177734375,
									40.37626953125002
								],
								[
									-6.810156249999949,
									40.343115234375006
								],
								[
									-6.85888671875,
									40.30073242187507
								],
								[
									-6.9484374999999545,
									40.25161132812502
								],
								[
									-7.01469726562496,
									40.20834960937509
								],
								[
									-7.032617187499966,
									40.16791992187501
								],
								[
									-7.027832031249972,
									40.14262695312493
								],
								[
									-6.916406249999994,
									40.056835937499955
								],
								[
									-6.896093749999949,
									40.02182617187509
								],
								[
									-6.911181640624989,
									39.93710937500006
								],
								[
									-6.975390624999932,
									39.798388671875045
								],
								[
									-7.036718750000006,
									39.71396484375009
								],
								[
									-7.04741210937496,
									39.70556640624997
								],
								[
									-7.117675781249972,
									39.681689453125074
								],
								[
									-7.454101562499943,
									39.68066406250006
								],
								[
									-7.53569335937496,
									39.66157226562498
								],
								[
									-7.524218749999932,
									39.644726562499926
								],
								[
									-7.445117187499989,
									39.53618164062493
								],
								[
									-7.362695312499966,
									39.478320312500045
								],
								[
									-7.335449218750028,
									39.46513671874993
								],
								[
									-7.30576171874992,
									39.338134765625085
								],
								[
									-7.172412109374932,
									39.135205078124955
								],
								[
									-7.042968749999943,
									39.107080078124994
								],
								[
									-6.997949218749994,
									39.056445312500074
								],
								[
									-7.006249999999994,
									38.98525390625005
								],
								[
									-7.0460449218749375,
									38.9070312500001
								],
								[
									-7.125488281249972,
									38.826953125000045
								],
								[
									-7.219921874999926,
									38.770507812500085
								],
								[
									-7.28154296874996,
									38.71455078125004
								],
								[
									-7.286376953124972,
									38.64936523437501
								],
								[
									-7.30595703124996,
									38.56684570312498
								],
								[
									-7.335791015625006,
									38.501464843750085
								],
								[
									-7.343017578124972,
									38.45742187500008
								],
								[
									-7.106396484374983,
									38.18100585937498
								],
								[
									-6.974804687499983,
									38.19443359375006
								],
								[
									-6.95756835937496,
									38.18789062500005
								],
								[
									-6.9811035156249375,
									38.12197265624994
								],
								[
									-7.022851562500023,
									38.04472656250002
								],
								[
									-7.072509765625,
									38.03002929687503
								],
								[
									-7.185449218750023,
									38.006347656250114
								],
								[
									-7.292236328125,
									37.9064453125001
								],
								[
									-7.37890625,
									37.78637695312506
								],
								[
									-7.44394531249992,
									37.72827148437503
								],
								[
									-7.503515624999977,
									37.585498046875074
								],
								[
									-7.4960449218749545,
									37.52358398437508
								],
								[
									-7.4671874999999375,
									37.42802734374996
								],
								[
									-7.4061523437499375,
									37.17944335937494
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "PRT",
					"su_a3": "PR1",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "PRT",
					"gu_a3": "PRT",
					"abbrev": "Port.",
					"region_un": "Europe",
					"adm0_a3_us": "PRT",
					"scalerank": 1,
					"pop_est": 10707924,
					"adm0_dif": 0,
					"un_a3": "620",
					"pop_year": -99,
					"gdp_md_est": 208627,
					"name": "Portugal",
					"sovereignt": "Portugal",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 1,
					"gdp_year": 0,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Portugal",
					"postal": "P",
					"sov_a3": "PRT",
					"note_brk": "",
					"brk_a3": "PR1",
					"wb_a2": "PT",
					"brk_diff": 0,
					"admin": "Portugal",
					"name_long": "Portugal",
					"iso_a3": "PRT",
					"iso_a2": "PT",
					"adm0_a3_is": "PRT",
					"level": 2,
					"formal_en": "Portuguese Republic",
					"name_len": 8,
					"mapcolor7": 1,
					"long_len": 8,
					"mapcolor8": 7,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "620",
					"homepart": 1,
					"subunit": "Portugal",
					"name_alt": "",
					"brk_name": "Portugal",
					"name_sort": "Portugal",
					"continent": "Europe",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								51.26796875000008,
								24.607226562500074
							],
							[
								51.178027343750045,
								24.586718750000074
							],
							[
								51.093359375000034,
								24.56464843750001
							],
							[
								51.02275390625016,
								24.565234375000045
							],
							[
								50.96601562500001,
								24.57392578125004
							],
							[
								50.92832031250009,
								24.595117187499994
							],
							[
								50.85566406250001,
								24.679638671874983
							],
							[
								50.80439453125007,
								24.78925781250004
							],
							[
								50.8359375,
								24.85039062499996
							],
							[
								50.84677734375009,
								24.888574218750023
							],
							[
								50.77734375000006,
								25.177441406250068
							],
							[
								50.75458984375001,
								25.39926757812495
							],
							[
								50.76289062500007,
								25.444726562499994
							],
							[
								50.80263671875008,
								25.4970703125
							],
							[
								50.86865234375,
								25.612695312499994
							],
							[
								50.90380859375006,
								25.72407226562504
							],
							[
								51.00312500000007,
								25.9814453125
							],
							[
								51.10810546875001,
								26.08056640625003
							],
							[
								51.26230468750009,
								26.15327148437501
							],
							[
								51.38906250000008,
								26.011132812499994
							],
							[
								51.54306640625009,
								25.90239257812496
							],
							[
								51.572265625,
								25.781005859375
							],
							[
								51.52695312500009,
								25.68212890625003
							],
							[
								51.48535156250006,
								25.524707031250017
							],
							[
								51.51025390625006,
								25.45234375000001
							],
							[
								51.51953125,
								25.389746093749977
							],
							[
								51.56142578125002,
								25.284472656250017
							],
							[
								51.60195312500002,
								25.14794921875
							],
							[
								51.60888671875,
								25.052880859374994
							],
							[
								51.58691406250006,
								24.96484375
							],
							[
								51.53339843750007,
								24.89086914062503
							],
							[
								51.42792968750001,
								24.66826171874999
							],
							[
								51.396484375,
								24.645117187499977
							],
							[
								51.26796875000008,
								24.607226562500074
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "QAT",
					"su_a3": "QAT",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "QAT",
					"gu_a3": "QAT",
					"abbrev": "Qatar",
					"region_un": "Asia",
					"adm0_a3_us": "QAT",
					"scalerank": 1,
					"pop_est": 833285,
					"adm0_dif": 0,
					"un_a3": "634",
					"pop_year": -99,
					"gdp_md_est": 91330,
					"name": "Qatar",
					"sovereignt": "Qatar",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Qatar",
					"postal": "QA",
					"sov_a3": "QAT",
					"note_brk": "",
					"brk_a3": "QAT",
					"wb_a2": "QA",
					"brk_diff": 0,
					"admin": "Qatar",
					"name_long": "Qatar",
					"iso_a3": "QAT",
					"iso_a2": "QA",
					"adm0_a3_is": "QAT",
					"level": 2,
					"formal_en": "State of Qatar",
					"name_len": 5,
					"mapcolor7": 3,
					"long_len": 5,
					"mapcolor8": 6,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "634",
					"homepart": 1,
					"subunit": "Qatar",
					"name_alt": "",
					"brk_name": "Qatar",
					"name_sort": "Qatar",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								28.212500000000034,
								45.450439453125
							],
							[
								28.317675781250045,
								45.34711914062501
							],
							[
								28.451269531250006,
								45.29218750000001
							],
							[
								28.76074218749997,
								45.234130859375085
							],
							[
								28.78828125000001,
								45.24096679687506
							],
							[
								28.791406250000023,
								45.25190429687507
							],
							[
								28.769824218750045,
								45.2668945312501
							],
							[
								28.76660156250003,
								45.286230468750034
							],
							[
								28.78173828125,
								45.309863281250045
							],
							[
								28.824316406250063,
								45.311083984375045
							],
							[
								28.894335937500017,
								45.289941406249994
							],
							[
								29.027441406250063,
								45.320556640625114
							],
							[
								29.223535156250136,
								45.402929687500006
							],
							[
								29.403710937500136,
								45.41967773437506
							],
							[
								29.567675781250045,
								45.37080078125004
							],
							[
								29.65195312500009,
								45.3139160156251
							],
							[
								29.705859375000045,
								45.25991210937511
							],
							[
								29.689062500000034,
								45.193212890625006
							],
							[
								29.678613281250023,
								45.15166015624999
							],
							[
								29.63535156250009,
								44.97963867187502
							],
							[
								29.605468750000057,
								44.91547851562501
							],
							[
								29.557519531250023,
								44.843408203124966
							],
							[
								29.048242187500023,
								44.75756835937497
							],
							[
								29.081054687500057,
								44.79882812500003
							],
							[
								29.069140625000017,
								44.87114257812502
							],
							[
								29.047753906250023,
								44.92568359375005
							],
							[
								29.095312500000034,
								44.97504882812507
							],
							[
								28.98066406250001,
								44.99291992187497
							],
							[
								28.930566406250023,
								44.96582031250006
							],
							[
								28.89150390625008,
								44.91865234375004
							],
							[
								28.926171875000023,
								44.81000976562501
							],
							[
								28.870410156250045,
								44.74995117187504
							],
							[
								28.849023437500023,
								44.71630859375003
							],
							[
								28.846484375000045,
								44.636865234374994
							],
							[
								28.813574218750006,
								44.60249023437501
							],
							[
								28.80703125000008,
								44.565039062500006
							],
							[
								28.88818359375,
								44.574755859375045
							],
							[
								28.85175781250004,
								44.506103515625
							],
							[
								28.699218750000057,
								44.37421875000004
							],
							[
								28.645410156250023,
								44.29565429687503
							],
							[
								28.65859375000005,
								43.98383789062501
							],
							[
								28.59072265625008,
								43.797412109375045
							],
							[
								28.58535156250005,
								43.74223632812499
							],
							[
								28.423437500000006,
								43.740478515625
							],
							[
								28.37519531250004,
								43.744775390624966
							],
							[
								28.22197265624999,
								43.77285156250002
							],
							[
								28.05000000000004,
								43.822412109374994
							],
							[
								27.948925781250068,
								43.91860351562505
							],
							[
								27.88427734375003,
								43.98735351562502
							],
							[
								27.738574218750017,
								43.956298828125
							],
							[
								27.710742187500045,
								43.964599609375
							],
							[
								27.6708984375,
								43.997802734375
							],
							[
								27.56103515625,
								44.02006835937502
							],
							[
								27.425390624999977,
								44.02050781250003
							],
							[
								27.120703125000006,
								44.14614257812502
							],
							[
								27.08691406250003,
								44.167382812499994
							],
							[
								26.847753906249977,
								44.14619140625004
							],
							[
								26.489257812500057,
								44.08398437499997
							],
							[
								26.21582031250003,
								44.00727539062498
							],
							[
								25.933398437500045,
								43.87055664062501
							],
							[
								25.81884765624997,
								43.76684570312503
							],
							[
								25.686132812500034,
								43.711767578125006
							],
							[
								25.497070312500057,
								43.670800781249994
							],
							[
								25.15966796874997,
								43.68632812499996
							],
							[
								24.808203125000063,
								43.73842773437502
							],
							[
								24.43056640625005,
								43.79438476562504
							],
							[
								24.226757812499983,
								43.76347656249996
							],
							[
								23.950781250000006,
								43.78666992187499
							],
							[
								23.534570312500023,
								43.85356445312502
							],
							[
								23.22460937500003,
								43.87387695312498
							],
							[
								22.919042968750034,
								43.83447265625003
							],
							[
								22.867675781250057,
								43.864550781250045
							],
							[
								22.85644531249997,
								43.899023437500034
							],
							[
								22.868261718749977,
								43.947900390624966
							],
							[
								22.911328125000068,
								43.987207031249994
							],
							[
								22.98535156250003,
								44.01699218750002
							],
							[
								23.0244140625,
								44.047216796875034
							],
							[
								23.02851562500004,
								44.077978515625006
							],
							[
								22.945410156249977,
								44.127294921875006
							],
							[
								22.775195312500045,
								44.195214843749994
							],
							[
								22.705078125000057,
								44.23779296875006
							],
							[
								22.687890625000023,
								44.24829101562497
							],
							[
								22.683300781250068,
								44.28647460937512
							],
							[
								22.647949218750057,
								44.3164550781251
							],
							[
								22.581835937500074,
								44.33833007812501
							],
							[
								22.53066406250005,
								44.37797851562502
							],
							[
								22.49453125000005,
								44.435449218749994
							],
							[
								22.50234375000005,
								44.48959960937509
							],
							[
								22.554003906250017,
								44.54033203124996
							],
							[
								22.620117187500057,
								44.562353515625006
							],
							[
								22.700781250000063,
								44.555517578125034
							],
							[
								22.73437499999997,
								44.569921875000034
							],
							[
								22.720898437500068,
								44.6055175781251
							],
							[
								22.64208984375,
								44.650976562500034
							],
							[
								22.497656250000063,
								44.70625000000001
							],
							[
								22.350683593750063,
								44.67612304687509
							],
							[
								22.200976562500017,
								44.56069335937502
							],
							[
								22.093066406250074,
								44.54194335937501
							],
							[
								22.026953125000006,
								44.619873046875
							],
							[
								21.909277343750006,
								44.666113281250006
							],
							[
								21.74023437500003,
								44.68066406250003
							],
							[
								21.63613281250005,
								44.71044921874997
							],
							[
								21.597070312499994,
								44.75541992187499
							],
							[
								21.52314453125004,
								44.790087890625045
							],
							[
								21.36005859375004,
								44.82666015625003
							],
							[
								21.357910156250057,
								44.861816406250085
							],
							[
								21.384375000000006,
								44.87006835937498
							],
							[
								21.442187500000074,
								44.873388671875034
							],
							[
								21.519921875000023,
								44.88081054687504
							],
							[
								21.532324218750063,
								44.9006835937501
							],
							[
								21.533203125000057,
								44.91884765625008
							],
							[
								21.471972656250017,
								44.94199218750006
							],
							[
								21.409960937500074,
								44.95771484375007
							],
							[
								21.37773437499999,
								44.973437500000074
							],
							[
								21.357031250000034,
								44.990771484375074
							],
							[
								21.352929687499994,
								45.00898437500004
							],
							[
								21.371093750000057,
								45.021386718749994
							],
							[
								21.39589843750005,
								45.022216796875085
							],
							[
								21.420703125000045,
								45.03295898437506
							],
							[
								21.434472656250023,
								45.07514648437501
							],
							[
								21.467871093750063,
								45.109863281250085
							],
							[
								21.491796875000063,
								45.12226562500004
							],
							[
								21.490234375,
								45.14790039062501
							],
							[
								21.465429687500006,
								45.171875000000114
							],
							[
								21.431445312500017,
								45.19252929687505
							],
							[
								21.381738281250023,
								45.20507812500003
							],
							[
								21.22646484375008,
								45.241308593750034
							],
							[
								21.14785156250005,
								45.291748046875085
							],
							[
								21.099902343750074,
								45.29355468750012
							],
							[
								21.023828125000023,
								45.32153320312503
							],
							[
								20.941796874999994,
								45.36533203125009
							],
							[
								20.87080078125001,
								45.42753906249996
							],
							[
								20.794042968750006,
								45.467871093750006
							],
							[
								20.774218750000045,
								45.4844238281251
							],
							[
								20.772460937500057,
								45.50009765625009
							],
							[
								20.78652343750008,
								45.51748046875008
							],
							[
								20.78603515625008,
								45.536474609375034
							],
							[
								20.76582031250004,
								45.59746093750002
							],
							[
								20.77929687500003,
								45.66201171875002
							],
							[
								20.775781250000023,
								45.72250976562509
							],
							[
								20.775000000000034,
								45.749804687500074
							],
							[
								20.760156250000023,
								45.758105468750074
							],
							[
								20.746875000000074,
								45.74897460937498
							],
							[
								20.727832031250017,
								45.737402343750034
							],
							[
								20.709277343750074,
								45.73525390625002
							],
							[
								20.65273437500008,
								45.77939453125006
							],
							[
								20.581152343750063,
								45.86948242187512
							],
							[
								20.53261718750005,
								45.89951171875009
							],
							[
								20.43798828125003,
								45.94077148437498
							],
							[
								20.35859375000004,
								45.97548828125005
							],
							[
								20.301367187500006,
								46.050683593749994
							],
							[
								20.241796875000034,
								46.10859375000007
							],
							[
								20.28095703125001,
								46.13300781250007
							],
							[
								20.508105468750017,
								46.16694335937504
							],
							[
								20.613671875000023,
								46.13349609374998
							],
							[
								20.661035156249994,
								46.145654296874966
							],
							[
								20.70742187500005,
								46.17280273437501
							],
							[
								20.732714843750045,
								46.19443359375006
							],
							[
								20.737402343750006,
								46.21748046875004
							],
							[
								20.760253906250057,
								46.24624023437505
							],
							[
								20.837011718750063,
								46.25971679687504
							],
							[
								21.039843750000074,
								46.24223632812502
							],
							[
								21.121679687500063,
								46.28242187500004
							],
							[
								21.151953125000006,
								46.304345703124966
							],
							[
								21.17041015625003,
								46.352685546874966
							],
							[
								21.19179687500005,
								46.39155273437498
							],
							[
								21.264550781250023,
								46.41230468750004
							],
							[
								21.263281250000034,
								46.44775390624997
							],
							[
								21.252246093750017,
								46.48637695312502
							],
							[
								21.294531250000006,
								46.57246093750007
							],
							[
								21.320214843749994,
								46.607812499999994
							],
							[
								21.36132812500003,
								46.62075195312505
							],
							[
								21.411035156250023,
								46.647851562499966
							],
							[
								21.497070312500057,
								46.70429687500001
							],
							[
								21.47705078124997,
								46.75336914062507
							],
							[
								21.494433593750045,
								46.78974609375001
							],
							[
								21.58417968750004,
								46.87836914062504
							],
							[
								21.652636718750045,
								46.96376953125002
							],
							[
								21.651464843749977,
								47.00654296875004
							],
							[
								21.661425781250074,
								47.04389648437501
							],
							[
								21.721777343750006,
								47.084814453125006
							],
							[
								21.785449218750017,
								47.13813476562501
							],
							[
								21.86933593750004,
								47.304589843749994
							],
							[
								21.899218750000017,
								47.33256835937502
							],
							[
								21.95429687500004,
								47.3642578125
							],
							[
								21.99531250000004,
								47.39570312500001
							],
							[
								21.999707031250068,
								47.505029296874994
							],
							[
								22.03798828125005,
								47.53662109375003
							],
							[
								22.111914062500006,
								47.57202148437506
							],
							[
								22.18505859374997,
								47.62905273437502
							],
							[
								22.24462890625003,
								47.69638671874998
							],
							[
								22.290625000000006,
								47.72783203124999
							],
							[
								22.35146484375005,
								47.73623046875002
							],
							[
								22.41748046875,
								47.76264648437507
							],
							[
								22.49140625000004,
								47.772558593750034
							],
							[
								22.56289062500005,
								47.75957031249996
							],
							[
								22.60839843749997,
								47.76630859375001
							],
							[
								22.676757812500057,
								47.79902343750001
							],
							[
								22.85175781250001,
								47.92255859375004
							],
							[
								22.87666015625001,
								47.94726562500003
							],
							[
								22.912890625000017,
								47.96425781250002
							],
							[
								23.054785156250063,
								48.00654296875001
							],
							[
								23.09082031250003,
								48.04912109374999
							],
							[
								23.139453125000074,
								48.08740234374997
							],
							[
								23.20263671875,
								48.0845214843751
							],
							[
								23.40820312500003,
								47.989990234375114
							],
							[
								23.628710937500017,
								47.99584960937497
							],
							[
								23.669042968750063,
								47.992333984374966
							],
							[
								23.68203125000005,
								47.99038085937511
							],
							[
								23.70898437500003,
								47.98261718750004
							],
							[
								24.001855468749994,
								47.935791015625085
							],
							[
								24.04736328125003,
								47.94101562500009
							],
							[
								24.059765624999983,
								47.94477539062504
							],
							[
								24.177734375000057,
								47.906054687500074
							],
							[
								24.28193359375004,
								47.911181640625045
							],
							[
								24.380957031250063,
								47.9380371093751
							],
							[
								24.48408203125001,
								47.94711914062509
							],
							[
								24.578906250000074,
								47.93105468750008
							],
							[
								24.650976562500006,
								47.87651367187499
							],
							[
								24.837890625000057,
								47.76083984375006
							],
							[
								24.89335937499999,
								47.717773437500085
							],
							[
								24.979101562500063,
								47.72412109375003
							],
							[
								25.073828125000006,
								47.74570312500009
							],
							[
								25.169628906250068,
								47.823095703125034
							],
							[
								25.46425781250005,
								47.91079101562505
							],
							[
								25.689257812500045,
								47.93247070312512
							],
							[
								25.90869140625,
								47.967578125000074
							],
							[
								26.162695312500034,
								47.992529296875006
							],
							[
								26.236230468750023,
								48.06435546875008
							],
							[
								26.276953125000063,
								48.11323242187507
							],
							[
								26.30566406250003,
								48.20375976562505
							],
							[
								26.4423828125,
								48.22998046874997
							],
							[
								26.57246093750004,
								48.24848632812501
							],
							[
								26.618945312500017,
								48.259863281250034
							],
							[
								26.71376953125005,
								48.26347656249996
							],
							[
								26.78730468750001,
								48.25581054687498
							],
							[
								26.900976562500006,
								48.21113281250004
							],
							[
								26.98076171874999,
								48.15502929687497
							],
							[
								27.01220703125,
								48.110498046874966
							],
							[
								27.080371093750045,
								48.047656250000045
							],
							[
								27.152050781250068,
								47.95927734374999
							],
							[
								27.23085937500005,
								47.84174804687501
							],
							[
								27.248144531250034,
								47.78222656249997
							],
							[
								27.277929687500063,
								47.71796875000001
							],
							[
								27.3369140625,
								47.63974609374998
							],
							[
								27.449218750000057,
								47.55312500000002
							],
							[
								27.46484375000003,
								47.536669921875045
							],
							[
								27.51582031250001,
								47.475634765625045
							],
							[
								27.614062500000045,
								47.34052734375004
							],
							[
								27.69619140625008,
								47.286425781250045
							],
							[
								27.76796875000005,
								47.227587890625045
							],
							[
								27.802343750000034,
								47.168310546875034
							],
							[
								27.853808593750045,
								47.114501953125
							],
							[
								27.974218750000063,
								47.04321289062506
							],
							[
								28.071777343750057,
								46.978417968749994
							],
							[
								28.150000000000006,
								46.792089843750034
							],
							[
								28.204687500000034,
								46.706396484375006
							],
							[
								28.23945312500001,
								46.64082031250004
							],
							[
								28.222656250000057,
								46.508056640625
							],
							[
								28.24433593750004,
								46.45126953124998
							],
							[
								28.19960937500005,
								46.347558593749994
							],
							[
								28.119140625,
								46.13867187499997
							],
							[
								28.099707031250063,
								45.97260742187498
							],
							[
								28.113574218750045,
								45.88305664062503
							],
							[
								28.115527343750074,
								45.825537109375034
							],
							[
								28.13496093750004,
								45.788867187500045
							],
							[
								28.15625000000003,
								45.71308593750004
							],
							[
								28.159765625000034,
								45.64711914062502
							],
							[
								28.130859375,
								45.628271484375006
							],
							[
								28.09033203125,
								45.61274414062504
							],
							[
								28.07470703125003,
								45.59897460937498
							],
							[
								28.111914062500063,
								45.569140625000045
							],
							[
								28.16250000000005,
								45.513769531250034
							],
							[
								28.212500000000034,
								45.450439453125
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "ROU",
					"su_a3": "ROU",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "ROM",
					"gu_a3": "ROU",
					"abbrev": "Rom.",
					"region_un": "Europe",
					"adm0_a3_us": "ROU",
					"scalerank": 1,
					"pop_est": 22215421,
					"adm0_dif": 0,
					"un_a3": "642",
					"pop_year": -99,
					"gdp_md_est": 271400,
					"name": "Romania",
					"sovereignt": "Romania",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Romania",
					"postal": "RO",
					"sov_a3": "ROU",
					"note_brk": "",
					"brk_a3": "ROU",
					"wb_a2": "RO",
					"brk_diff": 0,
					"admin": "Romania",
					"name_long": "Romania",
					"iso_a3": "ROU",
					"iso_a2": "RO",
					"adm0_a3_is": "ROU",
					"level": 2,
					"formal_en": "Romania",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 4,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "642",
					"homepart": 1,
					"subunit": "Romania",
					"name_alt": "",
					"brk_name": "Romania",
					"name_sort": "Romania",
					"continent": "Europe",
					"mapcolor13": 13,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									146.04560546875018,
									43.40932617187494
								],
								[
									146.03232421875003,
									43.40712890625002
								],
								[
									146.02802734375018,
									43.42036132812504
								],
								[
									146.0489257812501,
									43.433593750000085
								],
								[
									146.08857421875007,
									43.44902343750002
								],
								[
									146.10078125000007,
									43.440185546875
								],
								[
									146.08632812500014,
									43.429199218750085
								],
								[
									146.0699218750001,
									43.42148437500009
								],
								[
									146.04560546875018,
									43.40932617187494
								]
							]
						],
						[
							[
								[
									145.88154296875018,
									43.459521484375045
								],
								[
									145.8956054687502,
									43.4545410156251
								],
								[
									145.9138671875,
									43.45537109374999
								],
								[
									145.93115234374994,
									43.45703124999997
								],
								[
									145.94111328125,
									43.44545898437511
								],
								[
									145.94355468750018,
									43.42646484375004
								],
								[
									145.93115234374994,
									43.42563476562506
								],
								[
									145.9072265625,
									43.42231445312501
								],
								[
									145.89394531250014,
									43.41982421874994
								],
								[
									145.88652343750005,
									43.43305664062507
								],
								[
									145.88154296875018,
									43.44379882812504
								],
								[
									145.8691406250001,
									43.45043945312506
								],
								[
									145.8691406250001,
									43.45786132812506
								],
								[
									145.88154296875018,
									43.459521484375045
								]
							]
						],
						[
							[
								[
									146.35878906250014,
									43.62539062500008
								],
								[
									146.33232421875016,
									43.61992187500002
								],
								[
									146.28818359375003,
									43.62539062500008
								],
								[
									146.27382812500014,
									43.62983398437501
								],
								[
									146.2836914062501,
									43.638623046874926
								],
								[
									146.3101562500001,
									43.65185546875006
								],
								[
									146.33330078125,
									43.64746093750006
								],
								[
									146.34980468750018,
									43.64414062500009
								],
								[
									146.35878906250014,
									43.62539062500008
								]
							]
						],
						[
							[
								[
									146.7139648437502,
									43.74379882812505
								],
								[
									146.68300781250002,
									43.71635742187496
								],
								[
									146.60859375000007,
									43.740478515625085
								],
								[
									146.61347656250007,
									43.79702148437505
								],
								[
									146.62197265625002,
									43.812988281250114
								],
								[
									146.82460937500002,
									43.86049804687511
								],
								[
									146.88408203125005,
									43.82915039062493
								],
								[
									146.89902343750003,
									43.80415039062507
								],
								[
									146.7139648437502,
									43.74379882812505
								]
							]
						],
						[
							[
								[
									146.2076171875001,
									44.49765625000006
								],
								[
									146.3559570312501,
									44.4246093750001
								],
								[
									146.56777343749997,
									44.44042968749994
								],
								[
									146.51621093750003,
									44.37465820312505
								],
								[
									146.4365234375,
									44.37568359374998
								],
								[
									146.29619140625,
									44.28095703125004
								],
								[
									146.1729492187502,
									44.268652343750034
								],
								[
									146.1123046875001,
									44.24594726562512
								],
								[
									145.91406249999994,
									44.1037109375001
								],
								[
									145.8873046875002,
									44.047753906249966
								],
								[
									145.76699218750002,
									43.94072265625002
								],
								[
									145.58681640624997,
									43.84511718750008
								],
								[
									145.55585937500018,
									43.664599609375074
								],
								[
									145.43925781250005,
									43.737060546875
								],
								[
									145.42617187500014,
									43.81035156250002
								],
								[
									145.46171875000016,
									43.8708984375001
								],
								[
									145.66630859375,
									43.9990722656251
								],
								[
									145.74833984375005,
									44.071533203125114
								],
								[
									145.77333984375014,
									44.129003906250006
								],
								[
									145.85195312499997,
									44.19301757812508
								],
								[
									145.8902343750001,
									44.24858398437502
								],
								[
									145.9404296875,
									44.272656249999955
								],
								[
									146.11210937500016,
									44.50014648437494
								],
								[
									146.2076171875001,
									44.49765625000006
								]
							]
						],
						[
							[
								[
									148.59951171875002,
									45.31762695312503
								],
								[
									148.4146484375002,
									45.24716796875006
								],
								[
									148.26230468750003,
									45.21684570312493
								],
								[
									148.00527343750002,
									45.07016601562506
								],
								[
									147.91376953125,
									44.99038085937508
								],
								[
									147.78408203124997,
									44.95859375000009
								],
								[
									147.6578125000002,
									44.97714843749995
								],
								[
									147.62187500000016,
									44.94472656250011
								],
								[
									147.60957031250007,
									44.88657226562498
								],
								[
									147.5630859375001,
									44.83554687500006
								],
								[
									147.31015625000003,
									44.67763671875005
								],
								[
									147.20742187500002,
									44.55356445312509
								],
								[
									147.0984375,
									44.53124999999997
								],
								[
									146.8974609375001,
									44.40429687500006
								],
								[
									146.93349609374997,
									44.51308593750008
								],
								[
									146.9742187500002,
									44.565722656250074
								],
								[
									147.14091796875016,
									44.66333007812497
								],
								[
									147.1547851562501,
									44.76621093750006
								],
								[
									147.24658203125,
									44.85605468749998
								],
								[
									147.43046875000016,
									44.94521484375002
								],
								[
									147.55781250000018,
									45.062451171874926
								],
								[
									147.65791015625,
									45.09301757812503
								],
								[
									147.76943359375002,
									45.190722656250045
								],
								[
									147.88554687500016,
									45.225634765625045
								],
								[
									147.8726562500001,
									45.30029296874997
								],
								[
									147.92402343750018,
									45.383300781250085
								],
								[
									147.96455078125007,
									45.37773437500002
								],
								[
									148.05605468750014,
									45.26210937500011
								],
								[
									148.130078125,
									45.25820312500011
								],
								[
									148.32421875,
									45.28242187500007
								],
								[
									148.61230468749994,
									45.48466796874996
								],
								[
									148.7066406250001,
									45.52065429687511
								],
								[
									148.77265625,
									45.52646484374995
								],
								[
									148.81220703125018,
									45.51000976562497
								],
								[
									148.8261718750001,
									45.486083984375085
								],
								[
									148.825390625,
									45.45590820312506
								],
								[
									148.80302734375,
									45.41352539062504
								],
								[
									148.837109375,
									45.36269531250008
								],
								[
									148.79072265625018,
									45.323974609375
								],
								[
									148.59951171875002,
									45.31762695312503
								]
							]
						],
						[
							[
								[
									47.98300781250009,
									45.48823242187498
								],
								[
									47.967675781249966,
									45.469970703125085
								],
								[
									47.920312500000136,
									45.56206054687502
								],
								[
									47.91757812500009,
									45.618164062500085
								],
								[
									47.947167968749966,
									45.647070312500006
								],
								[
									47.98710937500016,
									45.55405273437498
								],
								[
									47.98300781250009,
									45.48823242187498
								]
							]
						],
						[
							[
								[
									149.6876953125,
									45.64204101562504
								],
								[
									149.53886718750016,
									45.59135742187502
								],
								[
									149.44707031250005,
									45.59335937500009
								],
								[
									149.66591796875014,
									45.839794921874926
								],
								[
									149.79628906250014,
									45.87607421874995
								],
								[
									149.96230468750002,
									46.0219238281251
								],
								[
									150.30878906250018,
									46.20034179687502
								],
								[
									150.3486328125001,
									46.21342773437493
								],
								[
									150.55312500000014,
									46.2085449218751
								],
								[
									150.23457031250007,
									46.01230468750009
								],
								[
									150.19501953125018,
									45.93320312499995
								],
								[
									150.05664062499994,
									45.849365234375114
								],
								[
									149.9541015625001,
									45.82246093750004
								],
								[
									149.8833984375002,
									45.78315429687501
								],
								[
									149.6876953125,
									45.64204101562504
								]
							]
						],
						[
							[
								[
									152.0020507812501,
									46.897167968749955
								],
								[
									151.815625,
									46.787109375000085
								],
								[
									151.75410156250018,
									46.788330078125085
								],
								[
									151.72343750000016,
									46.82880859375007
								],
								[
									151.7153320312501,
									46.85268554687505
								],
								[
									151.8643554687501,
									46.86899414062509
								],
								[
									152.03984375000005,
									47.01499023437498
								],
								[
									152.16582031250005,
									47.11044921874998
								],
								[
									152.23466796875005,
									47.143408203125034
								],
								[
									152.28886718750016,
									47.14218750000006
								],
								[
									152.0020507812501,
									46.897167968749955
								]
							]
						],
						[
							[
								[
									153.10107421874994,
									47.76293945312494
								],
								[
									153.0538085937502,
									47.7061035156251
								],
								[
									153.0041015625,
									47.71347656250009
								],
								[
									152.98427734374997,
									47.72792968750011
								],
								[
									153.04912109375016,
									47.797021484374966
								],
								[
									153.07919921875003,
									47.80874023437505
								],
								[
									153.10107421874994,
									47.76293945312494
								]
							]
						],
						[
							[
								[
									154.08125000000018,
									48.790283203125085
								],
								[
									154.0429687500001,
									48.73876953124997
								],
								[
									154.00068359375,
									48.75571289062506
								],
								[
									153.9922851562501,
									48.77250976562502
								],
								[
									154.09169921874997,
									48.83212890625009
								],
								[
									154.12636718750014,
									48.90444335937508
								],
								[
									154.1990234375,
									48.90493164062508
								],
								[
									154.22841796875014,
									48.89208984374994
								],
								[
									154.2046875000002,
									48.85717773437494
								],
								[
									154.08125000000018,
									48.790283203125085
								]
							]
						],
						[
							[
								[
									154.81044921875014,
									49.31201171875006
								],
								[
									154.7148437500001,
									49.26767578125009
								],
								[
									154.6109375000001,
									49.29404296874995
								],
								[
									154.61298828125007,
									49.380615234375
								],
								[
									154.82490234375007,
									49.64692382812498
								],
								[
									154.89960937500018,
									49.630371093750085
								],
								[
									154.88330078124994,
									49.566406250000114
								],
								[
									154.8023437500001,
									49.46826171875
								],
								[
									154.8298828125,
									49.347900390625085
								],
								[
									154.81044921875014,
									49.31201171875006
								]
							]
						],
						[
							[
								[
									155.92109375000018,
									50.30219726562498
								],
								[
									155.79238281249997,
									50.20205078125011
								],
								[
									155.6075195312501,
									50.17724609375003
								],
								[
									155.51640625000016,
									50.14560546875006
								],
								[
									155.44892578125018,
									50.07778320312511
								],
								[
									155.39716796875,
									50.04125976562494
								],
								[
									155.28867187500003,
									50.06118164062508
								],
								[
									155.24306640624997,
									50.09462890625008
								],
								[
									155.24306640624997,
									50.21279296875008
								],
								[
									155.1951171875,
									50.26455078125005
								],
								[
									155.2183593750002,
									50.297851562500085
								],
								[
									155.3267578125001,
									50.293261718750045
								],
								[
									155.43388671875016,
									50.368945312500074
								],
								[
									155.68017578124994,
									50.40073242187509
								],
								[
									155.77275390625016,
									50.48242187500003
								],
								[
									155.884765625,
									50.68413085937499
								],
								[
									156.00166015625018,
									50.75693359375009
								],
								[
									156.096875,
									50.77187500000002
								],
								[
									156.1228515625,
									50.67128906250005
								],
								[
									156.1005859375,
									50.559277343749955
								],
								[
									156.0444335937501,
									50.45175781250009
								],
								[
									155.92109375000018,
									50.30219726562498
								]
							]
						],
						[
							[
								[
									156.40507812500005,
									50.65761718750011
								],
								[
									156.3654296875,
									50.63378906250003
								],
								[
									156.3257812500002,
									50.63906250000005
								],
								[
									156.1962890625001,
									50.70214843750003
								],
								[
									156.16796874999994,
									50.731884765624955
								],
								[
									156.21308593750018,
									50.784716796875045
								],
								[
									156.37646484374994,
									50.86210937500002
								],
								[
									156.45585937500016,
									50.85957031250004
								],
								[
									156.4875,
									50.84296875000001
								],
								[
									156.48310546875,
									50.751220703125085
								],
								[
									156.40507812500005,
									50.65761718750011
								]
							]
						],
						[
							[
								[
									155.64482421875005,
									50.821923828124994
								],
								[
									155.553515625,
									50.8105957031251
								],
								[
									155.51279296875003,
									50.83730468749994
								],
								[
									155.4834960937502,
									50.86962890624994
								],
								[
									155.46738281250003,
									50.913574218750114
								],
								[
									155.56855468750007,
									50.93447265625011
								],
								[
									155.63964843749994,
									50.91049804687509
								],
								[
									155.65361328125016,
									50.84536132812508
								],
								[
									155.64482421875005,
									50.821923828124994
								]
							]
						],
						[
							[
								[
									142.76103515625,
									54.39394531249994
								],
								[
									142.97617187500003,
									54.140966796875006
								],
								[
									142.9859375000001,
									54.08569335937503
								],
								[
									142.96708984375016,
									54.028808593750085
								],
								[
									142.92656250000016,
									53.95561523437499
								],
								[
									142.91142578125,
									53.87836914062507
								],
								[
									142.93642578125014,
									53.81093750000011
								],
								[
									142.9179687500001,
									53.794238281250074
								],
								[
									143.09550781250005,
									53.48867187500008
								],
								[
									143.2236328125001,
									53.29604492187508
								],
								[
									143.25996093750007,
									53.21728515624994
								],
								[
									143.28789062500016,
									53.13437500000012
								],
								[
									143.3247070312501,
									52.96308593750004
								],
								[
									143.3326171875002,
									52.70004882812509
								],
								[
									143.32363281250014,
									52.61357421874996
								],
								[
									143.2951171875,
									52.52915039062509
								],
								[
									143.2642578125002,
									52.47866210937511
								],
								[
									143.20097656250005,
									52.44291992187502
								],
								[
									143.17226562500014,
									52.34936523437506
								],
								[
									143.15556640625,
									52.08374023437503
								],
								[
									143.19062500000007,
									51.94448242187508
								],
								[
									143.2505859375002,
									51.84790039062494
								],
								[
									143.29472656250005,
									51.74433593749998
								],
								[
									143.29951171875,
									51.632373046875074
								],
								[
									143.3205078125,
									51.58325195312503
								],
								[
									143.41777343750016,
									51.52060546875006
								],
								[
									143.45546875000002,
									51.47148437499999
								],
								[
									143.4673828125002,
									51.40190429687502
								],
								[
									143.47294921875,
									51.29921875000008
								],
								[
									143.4887695312501,
									51.2770507812501
								],
								[
									143.53417968749994,
									51.24628906250004
								],
								[
									143.73603515625007,
									50.50673828125008
								],
								[
									143.8160156250001,
									50.282617187499994
								],
								[
									144.0479492187501,
									49.89575195312506
								],
								[
									144.14130859375018,
									49.66147460937512
								],
								[
									144.19960937499997,
									49.5497558593751
								],
								[
									144.23994140625,
									49.432031249999994
								],
								[
									144.2720703125002,
									49.3113281250001
								],
								[
									144.34121093749997,
									49.18051757812509
								],
								[
									144.4317382812502,
									49.0510742187501
								],
								[
									144.60683593749997,
									48.935839843750074
								],
								[
									144.68554687499994,
									48.871240234374966
								],
								[
									144.7066406250001,
									48.8195312500001
								],
								[
									144.71376953125002,
									48.64028320312508
								],
								[
									144.67265625,
									48.67856445312506
								],
								[
									144.62099609375014,
									48.81484375000002
								],
								[
									144.536328125,
									48.89355468750006
								],
								[
									144.41181640625007,
									48.986376953125074
								],
								[
									144.2837890625001,
									49.0697753906251
								],
								[
									144.12548828125,
									49.20854492187493
								],
								[
									144.04873046874997,
									49.24916992187505
								],
								[
									143.9677734375001,
									49.27631835937507
								],
								[
									143.819140625,
									49.30859375000006
								],
								[
									143.73232421875002,
									49.31201171875006
								],
								[
									143.38222656250002,
									49.290673828124966
								],
								[
									143.2363281250001,
									49.26284179687508
								],
								[
									143.1049804687501,
									49.19882812500009
								],
								[
									143.02685546875,
									49.10541992187507
								],
								[
									142.9716796875001,
									48.91777343750002
								],
								[
									142.65097656250003,
									48.246875000000045
								],
								[
									142.57421874999994,
									48.07216796875005
								],
								[
									142.54589843749994,
									47.88491210937502
								],
								[
									142.55693359375,
									47.73789062500009
								],
								[
									142.57900390625014,
									47.68398437499994
								],
								[
									142.67011718750007,
									47.536914062500074
								],
								[
									142.74541015625005,
									47.452392578125085
								],
								[
									142.8007812500001,
									47.416162109374994
								],
								[
									142.86396484375,
									47.39179687500001
								],
								[
									142.90546875,
									47.361865234375045
								],
								[
									142.94033203125014,
									47.32275390624997
								],
								[
									143.00556640625018,
									47.22270507812493
								],
								[
									143.08925781250002,
									47.00078124999993
								],
								[
									143.1779296875,
									46.844042968750074
								],
								[
									143.21767578125014,
									46.79487304687507
								],
								[
									143.31865234375,
									46.80737304687506
								],
								[
									143.3843750000001,
									46.80566406249997
								],
								[
									143.4472656250001,
									46.79199218750003
								],
								[
									143.48564453125,
									46.75205078125006
								],
								[
									143.54033203125016,
									46.57509765625008
								],
								[
									143.57871093750003,
									46.4060546875001
								],
								[
									143.5806640625002,
									46.36069335937509
								],
								[
									143.50859375000016,
									46.23017578125007
								],
								[
									143.49062500000014,
									46.17460937500002
								],
								[
									143.48232421875014,
									46.115820312500034
								],
								[
									143.4634765625002,
									46.06948242187508
								],
								[
									143.4316406250001,
									46.02866210937495
								],
								[
									143.41865234375007,
									46.22202148437509
								],
								[
									143.37031250000007,
									46.35849609375009
								],
								[
									143.3521484375001,
									46.476220703124994
								],
								[
									143.2823242187501,
									46.55898437500008
								],
								[
									143.0478515625001,
									46.59262695312509
								],
								[
									142.82929687500007,
									46.6052734375001
								],
								[
									142.7955078125002,
									46.62021484375012
								],
								[
									142.74736328125016,
									46.670654296875
								],
								[
									142.69189453124994,
									46.71083984375011
								],
								[
									142.6357421875,
									46.71621093750005
								],
								[
									142.57802734375014,
									46.700781250000006
								],
								[
									142.47880859375016,
									46.64423828125004
								],
								[
									142.40644531250018,
									46.5546875
								],
								[
									142.35000000000014,
									46.45869140624998
								],
								[
									142.30400390625016,
									46.35756835937508
								],
								[
									142.2085937500001,
									46.08886718750006
								],
								[
									142.14970703125016,
									45.999267578125
								],
								[
									142.07714843749994,
									45.917041015625045
								],
								[
									142.0156250000001,
									45.96162109375007
								],
								[
									141.96162109375,
									46.01347656249996
								],
								[
									141.92998046875016,
									46.08828125000011
								],
								[
									141.91630859375016,
									46.170751953125034
								],
								[
									141.83037109375005,
									46.45107421874994
								],
								[
									141.86650390625005,
									46.69418945312509
								],
								[
									142.01103515625016,
									47.030322265625074
								],
								[
									142.0386718750002,
									47.14028320312502
								],
								[
									142.01689453125005,
									47.244677734375045
								],
								[
									141.9841796875,
									47.347705078125074
								],
								[
									141.96250000000003,
									47.54379882812498
								],
								[
									141.96406250000018,
									47.58745117187499
								],
								[
									142.0156250000001,
									47.700634765624955
								],
								[
									142.07597656250016,
									47.80834960937506
								],
								[
									142.14921875000016,
									47.902148437500074
								],
								[
									142.1817382812502,
									48.01337890624998
								],
								[
									142.1353515625001,
									48.29008789062496
								],
								[
									142.02871093750014,
									48.47709960937496
								],
								[
									141.89726562500016,
									48.65468750000008
								],
								[
									141.8730468750001,
									48.70195312499993
								],
								[
									141.8663085937501,
									48.75009765624998
								],
								[
									141.97958984375003,
									48.972167968750085
								],
								[
									142.02011718750003,
									49.07846679687509
								],
								[
									142.0665039062502,
									49.312060546875074
								],
								[
									142.10869140625016,
									49.43964843750004
								],
								[
									142.14228515625018,
									49.569140625000045
								],
								[
									142.15312500000016,
									50.21674804687498
								],
								[
									142.14306640624994,
									50.31210937500006
								],
								[
									142.07109375000016,
									50.51499023437509
								],
								[
									142.0660156250001,
									50.63046875000006
								],
								[
									142.10048828125002,
									50.77646484374998
								],
								[
									142.14726562500005,
									50.89018554687496
								],
								[
									142.20791015625014,
									50.9984863281251
								],
								[
									142.20673828125007,
									51.222558593749994
								],
								[
									142.09072265625014,
									51.42939453125004
								],
								[
									142.0059570312502,
									51.52050781249994
								],
								[
									141.87294921875002,
									51.630029296874966
								],
								[
									141.77187500000002,
									51.69018554687506
								],
								[
									141.72236328125007,
									51.73632812499994
								],
								[
									141.77187500000002,
									51.75180664062509
								],
								[
									141.8081054687501,
									51.78920898437505
								],
								[
									141.72099609375016,
									51.84677734374998
								],
								[
									141.6684570312501,
									51.93334960937494
								],
								[
									141.66083984375007,
									52.27294921875003
								],
								[
									141.682421875,
									52.359130859375
								],
								[
									141.74755859374994,
									52.45483398437506
								],
								[
									141.8033203125002,
									52.55561523437507
								],
								[
									141.8555664062502,
									52.79350585937502
								],
								[
									141.87363281250003,
									53.03891601562512
								],
								[
									141.8388671875,
									53.13847656249996
								],
								[
									141.82353515625016,
									53.33950195312505
								],
								[
									141.85244140625002,
									53.38945312499993
								],
								[
									141.9644531250001,
									53.45639648437506
								],
								[
									142.14199218750002,
									53.49560546875006
								],
								[
									142.17988281250018,
									53.48403320312502
								],
								[
									142.3189453125002,
									53.4054687500001
								],
								[
									142.37050781250014,
									53.40253906250004
								],
								[
									142.42402343750018,
									53.410742187500006
								],
								[
									142.52617187500005,
									53.44746093750004
								],
								[
									142.58349609375,
									53.53676757812502
								],
								[
									142.50917968750014,
									53.58759765624998
								],
								[
									142.55253906250016,
									53.652636718750074
								],
								[
									142.67958984375014,
									53.674365234375074
								],
								[
									142.68886718750014,
									53.73017578124998
								],
								[
									142.64287109375,
									53.7367675781251
								],
								[
									142.68300781250002,
									53.81601562499998
								],
								[
									142.70595703124997,
									53.895703124999955
								],
								[
									142.67021484375016,
									53.96840820312494
								],
								[
									142.46660156250016,
									54.14853515624995
								],
								[
									142.3349609375,
									54.28071289062507
								],
								[
									142.55166015624997,
									54.278955078124966
								],
								[
									142.61562500000014,
									54.30361328125011
								],
								[
									142.66621093750007,
									54.358203125000045
								],
								[
									142.69277343750014,
									54.41611328125012
								],
								[
									142.76103515625,
									54.39394531249994
								]
							]
						],
						[
							[
								[
									168.0390625,
									54.564990234375074
								],
								[
									168.08134765625016,
									54.51274414062499
								],
								[
									167.6773437500002,
									54.697656249999994
								],
								[
									167.4880859375,
									54.79497070312493
								],
								[
									167.4415039062502,
									54.85585937500008
								],
								[
									167.5117187500001,
									54.85693359374994
								],
								[
									167.59248046875007,
									54.797753906249966
								],
								[
									167.71064453125007,
									54.77016601562494
								],
								[
									167.8826171875,
									54.69047851562496
								],
								[
									168.0390625,
									54.564990234375074
								]
							]
						],
						[
							[
								[
									137.17861328125014,
									55.10043945312509
								],
								[
									137.05527343750003,
									54.92675781250006
								],
								[
									136.96943359375007,
									54.92397460937511
								],
								[
									136.90273437500014,
									54.960644531249926
								],
								[
									136.76513671875,
									54.94604492187497
								],
								[
									136.7146484375,
									54.95615234375009
								],
								[
									136.79531250000002,
									55.00937500000009
								],
								[
									136.9957031250001,
									55.092724609374926
								],
								[
									137.07753906250014,
									55.0917480468751
								],
								[
									137.15605468750016,
									55.10781250000008
								],
								[
									137.17861328125014,
									55.10043945312509
								]
							]
						],
						[
							[
								[
									137.9405273437502,
									55.09262695312509
								],
								[
									138.0312500000001,
									55.05332031249998
								],
								[
									138.17207031250018,
									55.06005859375003
								],
								[
									138.2061523437502,
									55.03354492187495
								],
								[
									138.09648437500016,
									54.99091796875007
								],
								[
									138.01660156249994,
									54.900878906250114
								],
								[
									137.9912109375001,
									54.82070312500002
								],
								[
									137.95947265624994,
									54.789013671874955
								],
								[
									137.87011718749994,
									54.7495605468751
								],
								[
									137.790234375,
									54.69692382812494
								],
								[
									137.72148437500016,
									54.66323242187508
								],
								[
									137.6611328125001,
									54.653271484374926
								],
								[
									137.5255859375,
									54.825830078124994
								],
								[
									137.4626953125,
									54.873388671875006
								],
								[
									137.27607421875018,
									54.79238281249994
								],
								[
									137.23291015625,
									54.79057617187502
								],
								[
									137.2751953125,
									54.89101562500005
								],
								[
									137.3843750000002,
									55.00068359375001
								],
								[
									137.435546875,
									55.01601562500002
								],
								[
									137.54365234375007,
									55.16308593750006
								],
								[
									137.57734375000018,
									55.19702148437494
								],
								[
									137.91044921875,
									55.1100585937501
								],
								[
									137.9405273437502,
									55.09262695312509
								]
							]
						],
						[
							[
								[
									21.235742187500023,
									55.26411132812504
								],
								[
									21.29755859375001,
									55.2644531250001
								],
								[
									21.389257812500034,
									55.27553710937505
								],
								[
									21.44707031249999,
									55.23442382812493
								],
								[
									21.5546875,
									55.19531250000006
								],
								[
									21.682714843750034,
									55.16035156250004
								],
								[
									21.873925781250023,
									55.10073242187505
								],
								[
									22.072363281250034,
									55.063671874999955
								],
								[
									22.13789062500004,
									55.059375000000074
								],
								[
									22.346386718750068,
									55.06425781249999
								],
								[
									22.56728515625005,
									55.05913085937502
								],
								[
									22.627441406250057,
									54.97070312500003
								],
								[
									22.736523437500068,
									54.92885742187494
								],
								[
									22.82470703125,
									54.87128906250001
								],
								[
									22.83125000000001,
									54.83847656250009
								],
								[
									22.70966796875001,
									54.632617187500074
								],
								[
									22.684472656250023,
									54.5629394531251
								],
								[
									22.679882812500068,
									54.49301757812506
								],
								[
									22.724316406250068,
									54.405615234375006
								],
								[
									22.766210937499977,
									54.356787109375006
								],
								[
									22.73183593750008,
									54.35009765625006
								],
								[
									22.168457031250057,
									54.359863281250114
								],
								[
									21.634179687500023,
									54.37646484375003
								],
								[
									21.14052734375008,
									54.39179687500004
								],
								[
									20.66474609375004,
									54.40664062500005
								],
								[
									20.20820312500004,
									54.42075195312506
								],
								[
									19.92431640625003,
									54.43398437500002
								],
								[
									19.644238281250068,
									54.44707031250002
								],
								[
									19.604394531250023,
									54.4591796875001
								],
								[
									19.758496093750068,
									54.54482421875005
								],
								[
									19.85888671875,
									54.63383789062496
								],
								[
									19.944140625000045,
									54.75
								],
								[
									19.953222656250034,
									54.830468749999966
								],
								[
									19.974511718750023,
									54.921191406250074
								],
								[
									20.107617187500068,
									54.95649414062507
								],
								[
									20.396679687500068,
									54.95126953124998
								],
								[
									20.520312500000017,
									54.99487304687497
								],
								[
									20.67890625000001,
									55.10263671875009
								],
								[
									20.845703125000057,
									55.23203124999998
								],
								[
									20.89980468750005,
									55.2866699218751
								],
								[
									20.957812500000074,
									55.27890625000012
								],
								[
									20.859375,
									55.183642578125074
								],
								[
									20.594824218750006,
									54.98237304687501
								],
								[
									20.67773437500003,
									54.95566406249998
								],
								[
									20.774023437500006,
									54.947021484375
								],
								[
									20.887500000000045,
									54.90947265624999
								],
								[
									20.995898437500017,
									54.90268554687512
								],
								[
									21.18886718750008,
									54.93520507812508
								],
								[
									21.222851562500068,
									55.10776367187506
								],
								[
									21.235742187500023,
									55.26411132812504
								]
							]
						],
						[
							[
								[
									166.65029296875014,
									54.83906250000004
								],
								[
									166.64511718750003,
									54.694091796875085
								],
								[
									166.52128906250005,
									54.767626953125045
								],
								[
									166.46367187500005,
									54.82685546875004
								],
								[
									166.38173828125014,
									54.83808593750001
								],
								[
									166.3248046875001,
									54.864550781250074
								],
								[
									166.22988281250002,
									54.936523437500085
								],
								[
									166.1197265625002,
									55.03037109375009
								],
								[
									166.08232421875016,
									55.07656250000011
								],
								[
									166.06630859374997,
									55.13569335937507
								],
								[
									165.99189453125018,
									55.190478515625045
								],
								[
									165.7510742187501,
									55.294531250000006
								],
								[
									165.83046874999997,
									55.30693359374996
								],
								[
									165.9312500000002,
									55.351464843749966
								],
								[
									166.2119140625,
									55.32397460937506
								],
								[
									166.27578125000014,
									55.31196289062501
								],
								[
									166.2299804687501,
									55.24233398437494
								],
								[
									166.24804687499994,
									55.165429687499994
								],
								[
									166.4042968750001,
									55.00561523437494
								],
								[
									166.47949218749994,
									54.94990234375004
								],
								[
									166.57734375000018,
									54.907714843750085
								],
								[
									166.65029296875014,
									54.83906250000004
								]
							]
						],
						[
							[
								[
									150.5899414062501,
									59.018749999999955
								],
								[
									150.51113281250002,
									59.007421875000034
								],
								[
									150.47177734375003,
									59.03476562500012
								],
								[
									150.4702148437501,
									59.05405273437495
								],
								[
									150.59248046875007,
									59.09721679687496
								],
								[
									150.66621093750007,
									59.160156250000085
								],
								[
									150.71269531250005,
									59.12246093750002
								],
								[
									150.72773437500018,
									59.095214843750085
								],
								[
									150.5899414062501,
									59.018749999999955
								]
							]
						],
						[
							[
								[
									163.63515625000014,
									58.60336914062498
								],
								[
									163.47138671875007,
									58.509375000000006
								],
								[
									163.4472656250001,
									58.524658203125114
								],
								[
									163.43183593750018,
									58.54614257812503
								],
								[
									163.42724609374994,
									58.57895507812498
								],
								[
									163.5767578125002,
									58.64086914062497
								],
								[
									163.7265625000001,
									58.79853515625004
								],
								[
									163.78447265625016,
									58.92973632812513
								],
								[
									163.7666015625,
									58.972363281249926
								],
								[
									163.76093750000018,
									59.015039062499994
								],
								[
									164.2021484375,
									59.096191406250114
								],
								[
									164.5173828125,
									59.22675781250007
								],
								[
									164.57265624999997,
									59.22114257812498
								],
								[
									164.62929687500014,
									59.112207031249994
								],
								[
									164.66162109375,
									58.970751953125045
								],
								[
									164.61572265624994,
									58.885595703125006
								],
								[
									164.27880859375,
									58.838085937499926
								],
								[
									163.96005859375003,
									58.74374999999998
								],
								[
									163.63515625000014,
									58.60336914062498
								]
							]
						],
						[
							[
								[
									35.81611328125018,
									65.18208007812507
								],
								[
									35.848437500000045,
									65.14267578125003
								],
								[
									35.858398437500114,
									65.07792968749999
								],
								[
									35.82734375000018,
									65.03647460937498
								],
								[
									35.842285156250114,
									65.00146484374994
								],
								[
									35.778710937500136,
									64.97666015625003
								],
								[
									35.68007812500002,
									65.05761718750003
								],
								[
									35.62138671875016,
									65.05878906250007
								],
								[
									35.55859374999994,
									65.09360351562498
								],
								[
									35.528906250000034,
									65.15107421875004
								],
								[
									35.58574218750016,
									65.16708984375003
								],
								[
									35.608691406250045,
									65.15712890625005
								],
								[
									35.729101562500034,
									65.19755859375002
								],
								[
									35.81611328125018,
									65.18208007812507
								]
							]
						],
						[
							[
								[
									70.02070312500001,
									66.50219726562497
								],
								[
									69.84472656249994,
									66.48974609375011
								],
								[
									69.65136718750011,
									66.56533203124997
								],
								[
									69.46933593750003,
									66.71596679687511
								],
								[
									69.50273437499999,
									66.75107421875006
								],
								[
									69.61640625000018,
									66.739013671875
								],
								[
									69.80039062500009,
									66.73647460937511
								],
								[
									69.91757812500009,
									66.71166992187503
								],
								[
									70.07666015624994,
									66.6958984375
								],
								[
									70.0576171875,
									66.62719726562503
								],
								[
									70.05722656250009,
									66.59946289062506
								],
								[
									70.11005859375001,
									66.56909179687511
								],
								[
									70.05917968750003,
									66.517578125
								],
								[
									70.02070312500001,
									66.50219726562497
								]
							]
						],
						[
							[
								[
									42.71367187500016,
									66.70170898437513
								],
								[
									42.67558593749999,
									66.6880859375
								],
								[
									42.477343750000045,
									66.73505859374998
								],
								[
									42.46005859375009,
									66.77036132812506
								],
								[
									42.468554687500045,
									66.78554687499997
								],
								[
									42.547460937500034,
									66.79550781250003
								],
								[
									42.63144531250009,
									66.7822265625
								],
								[
									42.69072265625016,
									66.73530273437495
								],
								[
									42.71367187500016,
									66.70170898437513
								]
							]
						],
						[
							[
								[
									-179.79853515625,
									68.94042968750003
								],
								[
									-179.59541015625,
									68.90649414062497
								],
								[
									-179.51450195312503,
									68.91713867187508
								],
								[
									-179.47084960937502,
									68.91240234375002
								],
								[
									-179.35595703125,
									68.85297851562498
								],
								[
									-179.279296875,
									68.82519531250011
								],
								[
									-178.873876953125,
									68.75410156250001
								],
								[
									-178.68930664062498,
									68.67514648437509
								],
								[
									-178.53852539062498,
									68.58564453125007
								],
								[
									-178.61367187500002,
									68.60307617187505
								],
								[
									-178.75146484375003,
									68.66044921875002
								],
								[
									-178.7365234375,
									68.59301757812506
								],
								[
									-178.69262695312503,
									68.54599609374998
								],
								[
									-178.47392578125,
									68.50175781250002
								],
								[
									-178.24448242187503,
									68.46665039062498
								],
								[
									-178.09746093750002,
									68.42480468749997
								],
								[
									-178.04868164062503,
									68.38842773437494
								],
								[
									-178.01870117187497,
									68.32275390624997
								],
								[
									-178.05581054687497,
									68.264892578125
								],
								[
									-177.922412109375,
									68.28652343749997
								],
								[
									-177.79677734374997,
									68.33798828125006
								],
								[
									-177.86181640624997,
									68.37822265624999
								],
								[
									-178.28452148437503,
									68.51855468750006
								],
								[
									-178.37304687500003,
									68.56567382812509
								],
								[
									-178.24985351562498,
									68.54140625000002
								],
								[
									-177.683203125,
									68.36279296875006
								],
								[
									-177.52724609375002,
									68.29438476562504
								],
								[
									-177.59321289062507,
									68.28115234374994
								],
								[
									-177.63935546875004,
									68.24121093749997
								],
								[
									-177.58920898437503,
									68.22421875000006
								],
								[
									-177.52089843749997,
									68.23686523437505
								],
								[
									-177.40751953124996,
									68.24516601562507
								],
								[
									-177.29741210937502,
									68.22250976562498
								],
								[
									-177.171826171875,
									68.17465820312509
								],
								[
									-176.90727539062502,
									68.11914062499997
								],
								[
									-175.34521484375003,
									67.67807617187509
								],
								[
									-175.30986328125002,
									67.60205078125006
								],
								[
									-175.26591796875005,
									67.56650390625
								],
								[
									-175.23955078125,
									67.52109375000006
								],
								[
									-175.23251953124998,
									67.44667968750002
								],
								[
									-175.37470703124998,
									67.35737304687504
								],
								[
									-175.15507812500002,
									67.36538085937497
								],
								[
									-175.122802734375,
									67.37695312500003
								],
								[
									-175.06562499999998,
									67.41342773437509
								],
								[
									-175.00268554687494,
									67.43750000000009
								],
								[
									-174.91806640625003,
									67.40756835937495
								],
								[
									-174.849853515625,
									67.34887695312509
								],
								[
									-174.869921875,
									67.26850585937495
								],
								[
									-174.93041992187497,
									67.20346679687503
								],
								[
									-174.93813476562497,
									67.093017578125
								],
								[
									-174.88505859375,
									67.00024414062511
								],
								[
									-174.82871093750003,
									66.9613769531251
								],
								[
									-174.783642578125,
									66.91679687500007
								],
								[
									-174.77119140625004,
									66.784326171875
								],
								[
									-174.87011718750006,
									66.72490234374996
								],
								[
									-174.92490234375,
									66.62314453125009
								],
								[
									-174.8642578125,
									66.61313476562512
								],
								[
									-174.674658203125,
									66.60341796875
								],
								[
									-174.61245117187497,
									66.58540039062504
								],
								[
									-174.503759765625,
									66.53793945312498
								],
								[
									-174.47773437500004,
									66.49218750000006
								],
								[
									-174.45375976562497,
									66.42988281249998
								],
								[
									-174.418701171875,
									66.37197265625008
								],
								[
									-174.39409179687496,
									66.34423828124994
								],
								[
									-174.36606445312503,
									66.34833984374998
								],
								[
									-174.25698242187502,
									66.42846679687497
								],
								[
									-174.206005859375,
									66.45234375000004
								],
								[
									-174.084765625,
									66.4730957031251
								],
								[
									-174.01772460937502,
									66.38251953124993
								],
								[
									-174.06503906249998,
									66.22958984374995
								],
								[
									-174.025439453125,
									66.22968750000007
								],
								[
									-173.994482421875,
									66.24580078125007
								],
								[
									-173.95546874999997,
									66.28676757812497
								],
								[
									-173.89995117187502,
									66.31049804687501
								],
								[
									-173.83203125000003,
									66.36606445312495
								],
								[
									-173.77397460937502,
									66.43466796875006
								],
								[
									-173.84252929687503,
									66.48828125000009
								],
								[
									-173.92094726562502,
									66.52177734375005
								],
								[
									-174.10185546875002,
									66.54062500000009
								],
								[
									-174.196337890625,
									66.58071289062508
								],
								[
									-174.231591796875,
									66.63188476562502
								],
								[
									-174.13959960937498,
									66.65263671874999
								],
								[
									-174.06059570312496,
									66.689794921875
								],
								[
									-174.00551757812502,
									66.77861328125007
								],
								[
									-174.01884765625,
									66.82739257812497
								],
								[
									-174.04101562499997,
									66.87548828125
								],
								[
									-174.08642578125,
									66.94287109375006
								],
								[
									-174.15434570312496,
									66.98203124999995
								],
								[
									-174.283544921875,
									67.00156250000009
								],
								[
									-174.341845703125,
									67.03974609374998
								],
								[
									-174.430908203125,
									67.03764648437499
								],
								[
									-174.5189453125,
									67.04907226562511
								],
								[
									-174.55449218749996,
									67.06303710937502
								],
								[
									-174.55009765624993,
									67.09062500000005
								],
								[
									-174.44760742187503,
									67.103125
								],
								[
									-173.88403320312497,
									67.10644531249997
								],
								[
									-173.6796875,
									67.14477539062497
								],
								[
									-173.58657226562502,
									67.13276367187493
								],
								[
									-173.493994140625,
									67.10517578124998
								],
								[
									-173.15781249999998,
									67.069091796875
								],
								[
									-173.16762695312502,
									67.05224609374994
								],
								[
									-173.224169921875,
									67.03510742187493
								],
								[
									-173.32353515625,
									66.954833984375
								],
								[
									-173.34306640625,
									66.90922851562513
								],
								[
									-173.34736328124995,
									66.85136718750005
								],
								[
									-173.25893554687497,
									66.84008789062506
								],
								[
									-173.175390625,
									66.864599609375
								],
								[
									-173.21616210937498,
									66.91123046875009
								],
								[
									-173.22827148437506,
									66.96855468750005
								],
								[
									-173.19301757812497,
									66.99360351562507
								],
								[
									-173.14682617187498,
									66.99897460937493
								],
								[
									-173.05849609375,
									66.95585937500013
								],
								[
									-172.96259765625,
									66.94213867187509
								],
								[
									-172.64057617187504,
									66.92499999999995
								],
								[
									-172.54936523437502,
									66.93051757812512
								],
								[
									-172.5201171875,
									66.95249023437506
								],
								[
									-172.582958984375,
									66.97783203125007
								],
								[
									-173.001904296875,
									67.03398437499996
								],
								[
									-173.00751953125,
									67.06489257812495
								],
								[
									-172.62104492187495,
									67.02680664062501
								],
								[
									-172.44731445312502,
									66.99174804687505
								],
								[
									-172.27392578125003,
									66.96557617187497
								],
								[
									-172.03149414062503,
									66.97329101562494
								],
								[
									-171.79555664062502,
									66.93173828125
								],
								[
									-171.569580078125,
									66.81870117187498
								],
								[
									-171.36049804687502,
									66.67675781250011
								],
								[
									-171.14926757812498,
									66.59272460937504
								],
								[
									-170.92666015625002,
									66.52973632812507
								],
								[
									-170.5556640625,
									66.35722656250002
								],
								[
									-170.50952148437503,
									66.34365234375011
								],
								[
									-170.47309570312498,
									66.32026367187495
								],
								[
									-170.54282226562498,
									66.29106445312505
								],
								[
									-170.604443359375,
									66.24892578125008
								],
								[
									-170.48330078125002,
									66.27807617187497
								],
								[
									-170.3611328125,
									66.29790039062502
								],
								[
									-170.30122070312504,
									66.29404296875003
								],
								[
									-170.24697265625002,
									66.27187500000005
								],
								[
									-170.21162109375,
									66.23642578125
								],
								[
									-170.191943359375,
									66.20126953124995
								],
								[
									-170.24394531250002,
									66.169287109375
								],
								[
									-169.88881835937497,
									66.16347656250008
								],
								[
									-169.77788085937502,
									66.1431152343751
								],
								[
									-169.72915039062502,
									66.05810546875009
								],
								[
									-169.83168945312497,
									65.99892578124994
								],
								[
									-169.89169921875,
									66.00610351562509
								],
								[
									-169.94931640625003,
									66.031005859375
								],
								[
									-170.00380859375002,
									66.03349609375005
								],
								[
									-170.15942382812503,
									66.00805664062494
								],
								[
									-170.40102539062497,
									65.92851562499999
								],
								[
									-170.54067382812497,
									65.86542968749993
								],
								[
									-170.563037109375,
									65.82358398437509
								],
								[
									-170.54140624999997,
									65.71025390625002
								],
								[
									-170.56098632812504,
									65.65624999999994
								],
								[
									-170.66630859375,
									65.62153320312507
								],
								[
									-170.89687499999997,
									65.6426269531251
								],
								[
									-171.00146484374997,
									65.66489257812509
								],
								[
									-171.11899414062503,
									65.69501953125001
								],
								[
									-171.23203124999998,
									65.73686523437502
								],
								[
									-171.37685546874997,
									65.80395507812511
								],
								[
									-171.42153320312502,
									65.81035156249999
								],
								[
									-171.45117187500003,
									65.79423828124999
								],
								[
									-171.40170898437498,
									65.75175781250005
								],
								[
									-171.30322265625,
									65.69848632812503
								],
								[
									-171.13442382812497,
									65.62807617187505
								],
								[
									-171.054248046875,
									65.54995117187505
								],
								[
									-171.10585937500002,
									65.51103515625002
								],
								[
									-171.16997070312502,
									65.50209960937508
								],
								[
									-171.21601562499998,
									65.50278320312503
								],
								[
									-171.36376953124997,
									65.52719726562503
								],
								[
									-171.46625976562498,
									65.53310546875
								],
								[
									-171.79038085937503,
									65.51044921875007
								],
								[
									-171.90712890625002,
									65.49594726562506
								],
								[
									-171.94716796875,
									65.50795898437502
								],
								[
									-171.957177734375,
									65.54208984374995
								],
								[
									-172.13149414062497,
									65.56694335937496
								],
								[
									-172.23388671874997,
									65.57045898437497
								],
								[
									-172.28227539062496,
									65.58232421875007
								],
								[
									-172.32226562500003,
									65.61752929687503
								],
								[
									-172.43569335937497,
									65.66962890625001
								],
								[
									-172.60771484375,
									65.69003906250006
								],
								[
									-172.71918945312498,
									65.69243164062513
								],
								[
									-172.78330078124998,
									65.68105468749994
								],
								[
									-172.55654296874997,
									65.61201171874998
								],
								[
									-172.353955078125,
									65.49599609375008
								],
								[
									-172.39199218750002,
									65.47456054687504
								],
								[
									-172.41777343749993,
									65.44956054687512
								],
								[
									-172.30571289062505,
									65.44780273437502
								],
								[
									-172.23281250000002,
									65.45571289062494
								],
								[
									-172.21157226562502,
									65.42519531249994
								],
								[
									-172.269873046875,
									65.30273437500003
								],
								[
									-172.30927734375004,
									65.27563476562494
								],
								[
									-172.66191406249993,
									65.24853515625011
								],
								[
									-172.57314453124997,
									65.22822265624995
								],
								[
									-172.482080078125,
									65.2218750000001
								],
								[
									-172.3787109375,
									65.22670898437511
								],
								[
									-172.28603515625002,
									65.205712890625
								],
								[
									-172.22368164062502,
									65.1287109375001
								],
								[
									-172.21318359375002,
									65.04814453124996
								],
								[
									-172.30434570312502,
									65.0021484375001
								],
								[
									-172.39873046875,
									64.96474609375002
								],
								[
									-172.592822265625,
									64.907958984375
								],
								[
									-172.79248046875,
									64.88291015624995
								],
								[
									-172.89736328124997,
									64.88920898437499
								],
								[
									-172.99912109374998,
									64.87661132812508
								],
								[
									-173.0662109375,
									64.84716796875006
								],
								[
									-173.08579101562498,
									64.81733398437501
								],
								[
									-172.99804687500003,
									64.83710937499995
								],
								[
									-172.89687500000002,
									64.82607421875011
								],
								[
									-172.80107421874996,
									64.79052734375006
								],
								[
									-172.81157226562496,
									64.76118164062501
								],
								[
									-172.90258789062503,
									64.72919921875007
								],
								[
									-172.92402343750007,
									64.70493164062512
								],
								[
									-172.88906250000002,
									64.66401367187504
								],
								[
									-172.90087890624994,
									64.62885742187498
								],
								[
									-172.85415039062502,
									64.6099121093751
								],
								[
									-172.74687500000002,
									64.603271484375
								],
								[
									-172.61611328125002,
									64.57788085937509
								],
								[
									-172.48740234375,
									64.54418945312506
								],
								[
									-172.43662109374998,
									64.51533203125004
								],
								[
									-172.39384765624996,
									64.4746582031251
								],
								[
									-172.37875976562498,
									64.43154296875002
								],
								[
									-172.40146484375,
									64.41391601562498
								],
								[
									-172.69467773437503,
									64.407080078125
								],
								[
									-172.73916015624997,
									64.412255859375
								],
								[
									-172.75595703125,
									64.45996093749994
								],
								[
									-172.79150390624997,
									64.49892578125005
								],
								[
									-172.90317382812498,
									64.5260742187501
								],
								[
									-172.9490234375,
									64.5073730468751
								],
								[
									-172.91586914062498,
									64.36943359375007
								],
								[
									-172.96005859375003,
									64.32768554687499
								],
								[
									-173.00913085937498,
									64.29746093750006
								],
								[
									-173.157421875,
									64.2797363281251
								],
								[
									-173.27548828124998,
									64.28964843749998
								],
								[
									-173.37568359375007,
									64.35488281249994
								],
								[
									-173.37553710937502,
									64.41040039062497
								],
								[
									-173.30922851562502,
									64.44267578125007
								],
								[
									-173.30932617187503,
									64.48745117187502
								],
								[
									-173.327490234375,
									64.53955078125009
								],
								[
									-173.39565429687502,
									64.47900390625
								],
								[
									-173.47495117187503,
									64.42861328125005
								],
								[
									-173.60361328125003,
									64.36547851562497
								],
								[
									-173.66596679687504,
									64.35732421875
								],
								[
									-173.72973632812497,
									64.36450195312494
								],
								[
									-173.89785156250002,
									64.4097167968751
								],
								[
									-174.00136718749997,
									64.44897460937511
								],
								[
									-174.20483398437506,
									64.57778320312497
								],
								[
									-174.31801757812502,
									64.63764648437507
								],
								[
									-174.57055664062503,
									64.71777343749997
								],
								[
									-174.83046874999997,
									64.77597656250012
								],
								[
									-175.03603515625,
									64.81367187500007
								],
								[
									-175.14584960937498,
									64.80927734375004
								],
								[
									-175.25590820312493,
									64.79399414062496
								],
								[
									-175.39511718749998,
									64.80239257812508
								],
								[
									-175.44213867187494,
									64.81669921874996
								],
								[
									-175.483203125,
									64.84858398437498
								],
								[
									-175.52065429687497,
									64.86708984375002
								],
								[
									-175.71586914062493,
									64.94609375000005
								],
								[
									-175.85385742187498,
									65.01083984375009
								],
								[
									-175.85947265624998,
									65.05419921874994
								],
								[
									-175.83022460937497,
									65.1055175781251
								],
								[
									-175.85615234375,
									65.23281250000011
								],
								[
									-175.92294921875003,
									65.35249023437504
								],
								[
									-176.09326171875,
									65.47104492187503
								],
								[
									-176.54746093749998,
									65.54755859375001
								],
								[
									-176.92211914062503,
									65.60136718750005
								],
								[
									-177.05624999999998,
									65.61362304687506
								],
								[
									-177.17524414062498,
									65.60166015625
								],
								[
									-177.48876953125,
									65.50371093750005
								],
								[
									-177.69863281250002,
									65.48969726562504
								],
								[
									-178.31020507812502,
									65.48486328125003
								],
								[
									-178.4125,
									65.49555664062498
								],
								[
									-178.504638671875,
									65.53720703125003
								],
								[
									-178.525927734375,
									65.59301757812494
								],
								[
									-178.49931640625,
									65.69663085937509
								],
								[
									-178.50234375,
									65.74042968749995
								],
								[
									-178.52622070312498,
									65.75522460937495
								],
								[
									-178.55854492187498,
									65.75400390625006
								],
								[
									-178.67915039062504,
									65.79536132812495
								],
								[
									-178.79106445312502,
									65.86474609375006
								],
								[
									-178.87934570312495,
									65.93647460937493
								],
								[
									-178.93906249999998,
									66.03276367187507
								],
								[
									-178.85825195312503,
									66.0375488281251
								],
								[
									-178.74672851562497,
									66.01367187500011
								],
								[
									-178.73056640625003,
									66.03725585937494
								],
								[
									-178.693798828125,
									66.12421874999998
								],
								[
									-178.61625976562502,
									66.16601562499997
								],
								[
									-178.5865234375,
									66.1984375000001
								],
								[
									-178.53413085937498,
									66.316552734375
								],
								[
									-178.52656250000004,
									66.40156250000007
								],
								[
									-178.61577148437502,
									66.35517578124995
								],
								[
									-178.75278320312503,
									66.23725585937501
								],
								[
									-178.82084960937496,
									66.20268554687507
								],
								[
									-178.86811523437498,
									66.18706054687499
								],
								[
									-178.91552734374997,
									66.17993164062506
								],
								[
									-179.02612304687503,
									66.20351562499997
								],
								[
									-179.10507812500003,
									66.23193359375009
								],
								[
									-179.10688476562507,
									66.34609374999997
								],
								[
									-179.14340820312503,
									66.3750488281251
								],
								[
									-179.17836914062497,
									66.35332031250002
								],
								[
									-179.19267578125005,
									66.31254882812507
								],
								[
									-179.29316406249998,
									66.30507812499997
								],
								[
									-179.34013671874996,
									66.28749999999994
								],
								[
									-179.3162109375,
									66.21982421875
								],
								[
									-179.327197265625,
									66.16259765625006
								],
								[
									-179.42265625,
									66.14106445312504
								],
								[
									-179.61616210937498,
									66.12788085937493
								],
								[
									-179.68330078124998,
									66.18413085937502
								],
								[
									-179.74086914062497,
									66.10576171875005
								],
								[
									-179.78364257812498,
									66.01796875000008
								],
								[
									-179.78969726562497,
									65.90087890625003
								],
								[
									-179.7283203125,
									65.80380859374998
								],
								[
									-179.640625,
									65.75756835937497
								],
								[
									-179.44907226562503,
									65.68784179687498
								],
								[
									-179.365966796875,
									65.63862304687507
								],
								[
									-179.34438476562502,
									65.57524414062496
								],
								[
									-179.352099609375,
									65.51674804687494
								],
								[
									-179.45166015625003,
									65.44531250000006
								],
								[
									-179.51933593749996,
									65.3862792968751
								],
								[
									-179.63515625000002,
									65.244140625
								],
								[
									-179.70458984374997,
									65.18720703124995
								],
								[
									-180,
									65.06723632812503
								],
								[
									-180,
									65.31196289062507
								],
								[
									-180,
									65.55678710937502
								],
								[
									-180,
									65.80156250000005
								],
								[
									-180,
									66.0462890625
								],
								[
									-180,
									66.29106445312505
								],
								[
									-180,
									66.53583984375007
								],
								[
									-180,
									66.78056640625002
								],
								[
									-180,
									67.02534179687507
								],
								[
									-180,
									67.27011718750009
								],
								[
									-180,
									67.51484374999995
								],
								[
									-180,
									67.75961914062509
								],
								[
									-180,
									68.00439453124994
								],
								[
									-180,
									68.24912109374998
								],
								[
									-180,
									68.49389648437503
								],
								[
									-180,
									68.73867187499997
								],
								[
									-179.999951171875,
									68.98344726562502
								],
								[
									-179.79853515625,
									68.94042968750003
								]
							]
						],
						[
							[
								[
									50.26523437500009,
									69.18559570312499
								],
								[
									50.28300781250016,
									69.0888671875
								],
								[
									50.220605468750136,
									69.0487792968751
								],
								[
									50.164453124999966,
									69.03754882812493
								],
								[
									50.14091796875016,
									69.09814453125003
								],
								[
									50.09394531250018,
									69.1255371093751
								],
								[
									49.920800781249966,
									69.0532714843751
								],
								[
									49.839843750000114,
									68.973779296875
								],
								[
									49.626269531250045,
									68.85971679687503
								],
								[
									49.18046875000016,
									68.77841796875006
								],
								[
									48.91035156250001,
									68.74306640625008
								],
								[
									48.666992187500114,
									68.733154296875
								],
								[
									48.439062500000034,
									68.80488281249995
								],
								[
									48.31591796875,
									68.9423828125
								],
								[
									48.29443359374994,
									68.98422851562509
								],
								[
									48.27880859374994,
									69.04033203124996
								],
								[
									48.2802734375,
									69.09663085937498
								],
								[
									48.296289062499966,
									69.18388671874999
								],
								[
									48.31992187500009,
									69.26923828125007
								],
								[
									48.413867187500045,
									69.3456542968751
								],
								[
									48.631347656250114,
									69.43603515625003
								],
								[
									48.84492187500018,
									69.49472656250009
								],
								[
									48.95332031250018,
									69.50927734375003
								],
								[
									49.225195312500034,
									69.51123046874997
								],
								[
									49.99628906250018,
									69.30942382812506
								],
								[
									50.167285156250045,
									69.25708007812506
								],
								[
									50.26523437500009,
									69.18559570312499
								]
							]
						],
						[
							[
								[
									67.34492187500007,
									69.52983398437505
								],
								[
									67.26396484374999,
									69.44252929687502
								],
								[
									67.09785156250018,
									69.44716796875008
								],
								[
									67.04726562499997,
									69.46704101562494
								],
								[
									67.02587890625,
									69.48320312500005
								],
								[
									67.21611328125005,
									69.57539062500007
								],
								[
									67.32890624999999,
									69.57211914062495
								],
								[
									67.34492187500007,
									69.52983398437505
								]
							]
						],
						[
							[
								[
									161.46708984375005,
									68.90097656250009
								],
								[
									161.4224609375001,
									68.899658203125
								],
								[
									161.45625,
									68.96601562499993
								],
								[
									161.46113281250007,
									68.99560546875
								],
								[
									161.3640625,
									69.04443359375
								],
								[
									161.18251953125014,
									69.08159179687502
								],
								[
									161.1365234375,
									69.11025390625
								],
								[
									161.12548828125,
									69.197021484375
								],
								[
									161.1645507812501,
									69.33359375000003
								],
								[
									161.08281250000016,
									69.40566406249997
								],
								[
									161.11074218749997,
									69.46982421874998
								],
								[
									161.32333984375003,
									69.54091796875008
								],
								[
									161.4097656250001,
									69.59570312500006
								],
								[
									161.50517578125016,
									69.63945312499999
								],
								[
									161.520703125,
									69.63403320312494
								],
								[
									161.6177734375001,
									69.592431640625
								],
								[
									161.60927734375014,
									69.50092773437493
								],
								[
									161.54033203125005,
									69.43652343749994
								],
								[
									161.37441406249997,
									69.41367187500009
								],
								[
									161.35087890625016,
									69.36933593750001
								],
								[
									161.37265625000003,
									69.29282226562498
								],
								[
									161.3775390625001,
									69.19443359375
								],
								[
									161.39423828125,
									69.10644531250003
								],
								[
									161.49472656250003,
									69.01601562500008
								],
								[
									161.51699218749997,
									68.96958007812503
								],
								[
									161.50673828125014,
									68.927587890625
								],
								[
									161.46708984375005,
									68.90097656250009
								]
							]
						],
						[
							[
								[
									169.20078125000003,
									69.58046874999997
								],
								[
									168.91572265625007,
									69.57143554687508
								],
								[
									168.34804687500014,
									69.66435546875007
								],
								[
									168.14433593750005,
									69.71333007812504
								],
								[
									167.99267578124994,
									69.77583007812507
								],
								[
									167.8212890625001,
									69.81962890625002
								],
								[
									167.7888671875,
									69.83686523437507
								],
								[
									167.81396484374994,
									69.87304687499997
								],
								[
									167.8647460937501,
									69.9010742187501
								],
								[
									168.0595703125,
									69.9749023437501
								],
								[
									168.19628906249994,
									70.0083984375
								],
								[
									168.3579101562501,
									70.01567382812499
								],
								[
									169.37480468750016,
									69.88261718749996
								],
								[
									169.420703125,
									69.85605468749998
								],
								[
									169.43359374999994,
									69.832177734375
								],
								[
									169.41816406250018,
									69.77919921875002
								],
								[
									169.33242187500014,
									69.76958007812513
								],
								[
									169.29912109375,
									69.73476562500005
								],
								[
									169.26337890625018,
									69.62871093750002
								],
								[
									169.24580078125018,
									69.60112304687499
								],
								[
									169.20078125000003,
									69.58046874999997
								]
							]
						],
						[
							[
								[
									60.45048828125016,
									69.93486328125005
								],
								[
									60.48066406250007,
									69.88549804687503
								],
								[
									60.47724609375018,
									69.79370117187497
								],
								[
									60.44023437499999,
									69.72592773437512
								],
								[
									60.32714843749994,
									69.71528320312498
								],
								[
									60.215917968750034,
									69.68769531249995
								],
								[
									60.026171875000045,
									69.71704101562509
								],
								[
									59.919531250000034,
									69.69697265624998
								],
								[
									59.81279296875016,
									69.69565429687498
								],
								[
									59.72460937499994,
									69.706201171875
								],
								[
									59.63701171875016,
									69.721044921875
								],
								[
									59.57822265625009,
									69.73862304687503
								],
								[
									59.58125000000007,
									69.79086914062509
								],
								[
									59.50263671875001,
									69.8662109375
								],
								[
									59.38154296875007,
									69.89042968749996
								],
								[
									59.26835937499999,
									69.89843750000009
								],
								[
									59.14423828125001,
									69.92192382812507
								],
								[
									59.08251953125,
									69.91079101562494
								],
								[
									59.004003906250034,
									69.88330078125011
								],
								[
									58.95273437500009,
									69.89277343750007
								],
								[
									58.680078125000136,
									70.05102539062509
								],
								[
									58.634179687500136,
									70.08803710937508
								],
								[
									58.605566406250034,
									70.12919921875002
								],
								[
									58.56806640625007,
									70.1556640625
								],
								[
									58.473046874999966,
									70.266845703125
								],
								[
									58.519921875000136,
									70.3183105468751
								],
								[
									58.61533203125009,
									70.35083007812506
								],
								[
									58.67802734375016,
									70.35957031250007
								],
								[
									58.794238281250045,
									70.43295898437509
								],
								[
									59.005273437500136,
									70.46518554687509
								],
								[
									59.04804687500007,
									70.46049804687502
								],
								[
									59.088281249999966,
									70.43710937499995
								],
								[
									59.30986328124999,
									70.36166992187495
								],
								[
									59.42597656250007,
									70.31093750000011
								],
								[
									59.52910156249999,
									70.2489746093751
								],
								[
									59.63632812500009,
									70.19702148437506
								],
								[
									59.95585937499999,
									70.10834960937504
								],
								[
									60.172265625000136,
									70.02285156249994
								],
								[
									60.39257812499994,
									69.96240234374997
								],
								[
									60.45048828125016,
									69.93486328125005
								]
							]
						],
						[
							[
								[
									66.56093750000014,
									70.54174804687506
								],
								[
									66.56855468750018,
									70.50146484375009
								],
								[
									66.51582031250018,
									70.51489257812509
								],
								[
									66.44863281249997,
									70.56103515624997
								],
								[
									66.40761718749997,
									70.6157714843751
								],
								[
									66.39482421875005,
									70.72729492187509
								],
								[
									66.41816406250018,
									70.75712890624996
								],
								[
									66.44023437500016,
									70.77265624999993
								],
								[
									66.46289062499994,
									70.76933593749996
								],
								[
									66.45771484375007,
									70.69877929687507
								],
								[
									66.56093750000014,
									70.54174804687506
								]
							]
						],
						[
							[
								[
									160.7189453125,
									70.8227050781251
								],
								[
									160.6513671875001,
									70.80585937500004
								],
								[
									160.50478515625002,
									70.81972656250011
								],
								[
									160.43691406250014,
									70.85102539062507
								],
								[
									160.4404296875001,
									70.92265625000002
								],
								[
									160.44853515625,
									70.93403320312504
								],
								[
									160.56582031250002,
									70.92377929687498
								],
								[
									160.64492187500014,
									70.88354492187506
								],
								[
									160.7189453125,
									70.8227050781251
								]
							]
						],
						[
							[
								[
									52.903320312500114,
									71.36499023437509
								],
								[
									52.99414062499994,
									71.29125976562497
								],
								[
									53.07402343750016,
									71.23793945312502
								],
								[
									53.141406250000045,
									71.24189453124995
								],
								[
									53.19257812500007,
									71.21528320312495
								],
								[
									53.205175781250034,
									71.15971679687507
								],
								[
									53.07148437500018,
									71.06503906249998
								],
								[
									53.048144531250045,
									71.03095703125007
								],
								[
									53.105761718750045,
									70.999267578125
								],
								[
									53.120996093750136,
									70.98203124999995
								],
								[
									53.02265625000018,
									70.96870117187498
								],
								[
									53.004492187500034,
									71.01162109374994
								],
								[
									52.949609375000136,
									71.05361328124997
								],
								[
									52.83535156250002,
									71.08583984375005
								],
								[
									52.788964843749966,
									71.11494140625001
								],
								[
									52.73837890625009,
									71.1806640625
								],
								[
									52.54658203125018,
									71.25043945312501
								],
								[
									52.42548828125018,
									71.23925781249994
								],
								[
									52.28945312500002,
									71.27036132812498
								],
								[
									52.249609375000034,
									71.28491210937511
								],
								[
									52.239843750000034,
									71.32504882812512
								],
								[
									52.29658203125001,
									71.35683593750011
								],
								[
									52.512597656249966,
									71.38505859374999
								],
								[
									52.61738281250001,
									71.38334960937499
								],
								[
									52.72968750000018,
									71.35512695312502
								],
								[
									52.720312500000034,
									71.38979492187505
								],
								[
									52.73222656250016,
									71.40371093749997
								],
								[
									52.776757812499966,
									71.39980468749997
								],
								[
									52.903320312500114,
									71.36499023437509
								]
							]
						],
						[
							[
								[
									178.86152343750018,
									70.82641601562503
								],
								[
									178.79257812500015,
									70.82207031249996
								],
								[
									178.64824218750005,
									71.00058593750009
								],
								[
									178.62832031250008,
									71.04736328125003
								],
								[
									178.68388671875022,
									71.1056640625001
								],
								[
									178.82900390625014,
									71.17788085937497
								],
								[
									178.89111328125017,
									71.23110351562505
								],
								[
									179.23505859375024,
									71.32451171875007
								],
								[
									179.54765625000016,
									71.44765625000005
								],
								[
									179.71591796875015,
									71.4662109375
								],
								[
									179.88642578125024,
									71.52333984375008
								],
								[
									180.0000000000001,
									71.53774414062511
								],
								[
									180.0000000000001,
									70.99301757812506
								],
								[
									179.8813476562501,
									70.97568359375006
								],
								[
									179.64765625000013,
									70.89892578125006
								],
								[
									179.15253906250013,
									70.8802734375
								],
								[
									178.86152343750018,
									70.82641601562503
								]
							]
						],
						[
							[
								[
									137.95986328125014,
									71.507666015625
								],
								[
									137.71181640625014,
									71.42324218750005
								],
								[
									137.61289062500003,
									71.43393554687509
								],
								[
									137.51181640625003,
									71.47460937500003
								],
								[
									137.45781250000016,
									71.48349609375006
								],
								[
									137.40322265625014,
									71.47729492187494
								],
								[
									137.3442382812501,
									71.460546875
								],
								[
									137.26552734374997,
									71.45590820312495
								],
								[
									137.0787109375002,
									71.50219726562506
								],
								[
									137.06406250000003,
									71.5298828125
								],
								[
									137.08183593750005,
									71.54272460937506
								],
								[
									137.12949218750003,
									71.55615234374994
								],
								[
									137.1681640625,
									71.55712890625006
								],
								[
									137.2818359375002,
									71.57993164062506
								],
								[
									137.81679687500002,
									71.58789062500009
								],
								[
									137.85761718750018,
									71.5830566406251
								],
								[
									137.93378906250007,
									71.54277343749996
								],
								[
									137.95986328125014,
									71.507666015625
								]
							]
						],
						[
							[
								[
									-178.87646484375,
									71.57705078124994
								],
								[
									-178.43896484374994,
									71.541162109375
								],
								[
									-178.35356445312496,
									71.52919921875005
								],
								[
									-178.214697265625,
									71.48164062500004
								],
								[
									-178.13388671874998,
									71.46547851562494
								],
								[
									-178.05664062499997,
									71.43759765624995
								],
								[
									-177.97480468749998,
									71.39052734375002
								],
								[
									-177.81699218749998,
									71.33999023437505
								],
								[
									-177.58413085937497,
									71.28168945312498
								],
								[
									-177.53217773437507,
									71.26308593750011
								],
								[
									-177.498486328125,
									71.21914062499994
								],
								[
									-177.523583984375,
									71.16689453125005
								],
								[
									-177.82177734375,
									71.06757812500007
								],
								[
									-178.06269531250004,
									71.04194335937498
								],
								[
									-178.52797851562497,
									71.01479492187497
								],
								[
									-179.15688476562502,
									70.93984374999997
								],
								[
									-179.415673828125,
									70.91899414062499
								],
								[
									-179.50668945312498,
									70.9234375
								],
								[
									-179.73403320312502,
									70.97167968749997
								],
								[
									-179.999951171875,
									70.99301757812506
								],
								[
									-179.999951171875,
									71.18422851562502
								],
								[
									-179.999951171875,
									71.39970703125005
								],
								[
									-179.999951171875,
									71.53774414062511
								],
								[
									-179.84487304687502,
									71.55097656249995
								],
								[
									-179.69101562500003,
									71.57797851562495
								],
								[
									-179.54638671874997,
									71.58242187499997
								],
								[
									-179.40205078125007,
									71.56665039062494
								],
								[
									-179.25649414062497,
									71.5716796875
								],
								[
									-179.11157226562503,
									71.59619140625011
								],
								[
									-178.99404296874997,
									71.59321289062504
								],
								[
									-178.87646484375,
									71.57705078124994
								]
							]
						],
						[
							[
								[
									77.63251953125018,
									72.29125976562503
								],
								[
									77.1456054687502,
									72.281884765625
								],
								[
									76.90595703125001,
									72.29765625000002
								],
								[
									76.87109374999994,
									72.31704101562497
								],
								[
									76.90312500000016,
									72.36557617187509
								],
								[
									77.1495117187502,
									72.43920898437509
								],
								[
									77.26044921875007,
									72.48613281250005
								],
								[
									77.37783203124997,
									72.565283203125
								],
								[
									77.57871093750003,
									72.63085937499994
								],
								[
									77.74853515625011,
									72.63120117187512
								],
								[
									78.27910156249999,
									72.55322265624994
								],
								[
									78.35292968750014,
									72.50429687500011
								],
								[
									78.36513671875014,
									72.482421875
								],
								[
									78.15449218750001,
									72.41699218750009
								],
								[
									78.00722656250014,
									72.39248046874997
								],
								[
									77.7808593750002,
									72.30854492187493
								],
								[
									77.63251953125018,
									72.29125976562503
								]
							]
						],
						[
							[
								[
									79.50146484375,
									72.72192382812494
								],
								[
									79.43066406249994,
									72.71069335937506
								],
								[
									78.88056640625007,
									72.75161132812502
								],
								[
									78.69023437499999,
									72.80341796874993
								],
								[
									78.63320312500014,
									72.85073242187508
								],
								[
									78.65683593750003,
									72.89228515625001
								],
								[
									79.16425781250001,
									73.09433593750003
								],
								[
									79.35654296875003,
									73.03862304687507
								],
								[
									79.41249999999997,
									72.98310546875004
								],
								[
									79.54130859375005,
									72.91865234374995
								],
								[
									79.53789062500005,
									72.7693359375001
								],
								[
									79.50146484375,
									72.72192382812494
								]
							]
						],
						[
							[
								[
									74.66054687500002,
									72.87343750000008
								],
								[
									74.63837890625018,
									72.86376953124997
								],
								[
									74.58808593750018,
									72.88115234374996
								],
								[
									74.43476562500018,
									72.90766601562504
								],
								[
									74.18066406250011,
									72.97534179687506
								],
								[
									74.10019531250003,
									73.02153320312496
								],
								[
									74.14238281250005,
									73.07436523437505
								],
								[
									74.19853515625005,
									73.10908203125004
								],
								[
									74.40878906250003,
									73.13046874999995
								],
								[
									74.59990234375016,
									73.12177734374995
								],
								[
									74.72529296875007,
									73.10815429687503
								],
								[
									74.96152343750003,
									73.06250000000006
								],
								[
									74.74257812500002,
									73.03271484375011
								],
								[
									74.64726562500016,
									72.96904296875002
								],
								[
									74.66015625000011,
									72.92929687500009
								],
								[
									74.69716796875002,
									72.90771484375003
								],
								[
									74.66054687500002,
									72.87343750000008
								]
							]
						],
						[
							[
								[
									120.2613281250002,
									73.08984375000003
								],
								[
									120.00791015625009,
									73.04487304687501
								],
								[
									119.79208984375009,
									73.04541015624994
								],
								[
									119.64042968749999,
									73.1243164062501
								],
								[
									119.76191406250007,
									73.15546874999998
								],
								[
									119.9644531250002,
									73.16767578124998
								],
								[
									120.07851562499997,
									73.15673828124997
								],
								[
									120.23681640625,
									73.10727539062512
								],
								[
									120.2613281250002,
									73.08984375000003
								]
							]
						],
						[
							[
								[
									55.319824218750114,
									73.30830078125004
								],
								[
									55.78730468750001,
									73.26860351562502
								],
								[
									56.137695312500114,
									73.25615234375007
								],
								[
									56.35048828125002,
									73.22553710937495
								],
								[
									56.429589843750136,
									73.20117187500006
								],
								[
									56.3974609375,
									73.13916015624994
								],
								[
									56.33466796875018,
									73.113671875
								],
								[
									56.18896484374994,
									73.03300781249999
								],
								[
									56.166992187500114,
									72.98320312499996
								],
								[
									56.19287109374994,
									72.90498046874993
								],
								[
									56.170507812500034,
									72.84809570312507
								],
								[
									56.121679687500034,
									72.80659179687495
								],
								[
									56.083789062500045,
									72.789404296875
								],
								[
									55.819726562500136,
									72.78950195312504
								],
								[
									55.72343750000016,
									72.76640625000013
								],
								[
									55.71845703125001,
									72.72153320312495
								],
								[
									55.700976562500045,
									72.67172851562509
								],
								[
									55.61640625000001,
									72.59907226562495
								],
								[
									55.441308593750136,
									72.57539062499993
								],
								[
									55.40332031249994,
									72.54907226562509
								],
								[
									55.416894531250136,
									72.50131835937503
								],
								[
									55.35595703125,
									72.46508789062511
								],
								[
									55.35957031250018,
									72.40869140625009
								],
								[
									55.39042968749999,
									72.37783203125008
								],
								[
									55.39912109375018,
									72.31362304687508
								],
								[
									55.51806640625,
									72.22065429687495
								],
								[
									55.49492187500016,
									72.18232421875004
								],
								[
									55.40332031249994,
									72.10688476562495
								],
								[
									55.37499999999994,
									72.01489257812506
								],
								[
									55.29785156249994,
									71.9353515625001
								],
								[
									55.47109375000002,
									71.86923828124995
								],
								[
									55.546679687500045,
									71.78334960937505
								],
								[
									55.61367187500002,
									71.68989257812501
								],
								[
									55.8193359375,
									71.50756835937509
								],
								[
									56.04316406250018,
									71.34560546874994
								],
								[
									56.454394531250045,
									71.10737304687507
								],
								[
									56.89482421875016,
									70.92700195312511
								],
								[
									57.06562500000001,
									70.87602539062502
								],
								[
									57.48359375000018,
									70.79228515625002
								],
								[
									57.556445312500045,
									70.76582031249995
								],
								[
									57.625390625000136,
									70.72880859374996
								],
								[
									57.447167968750136,
									70.66103515625011
								],
								[
									57.263671875,
									70.63603515625007
								],
								[
									57.246972656250136,
									70.605126953125
								],
								[
									57.145898437500136,
									70.58911132812511
								],
								[
									56.648828125000136,
									70.64653320312499
								],
								[
									56.62167968750009,
									70.65537109375
								],
								[
									56.56865234375016,
									70.69746093750007
								],
								[
									56.51005859374999,
									70.72880859374996
								],
								[
									56.3857421875,
									70.73413085937506
								],
								[
									56.26005859375016,
									70.71474609374994
								],
								[
									56.33476562499999,
									70.67670898437501
								],
								[
									56.41718750000018,
									70.66494140625011
								],
								[
									56.56132812500016,
									70.59355468750013
								],
								[
									56.49970703125001,
									70.56640625
								],
								[
									56.4345703125,
									70.56298828125003
								],
								[
									56.14248046875002,
									70.65786132812508
								],
								[
									56.114746093750114,
									70.646142578125
								],
								[
									56.08710937500018,
									70.61835937499993
								],
								[
									55.94160156250001,
									70.649267578125
								],
								[
									55.907226562500114,
									70.62631835937495
								],
								[
									55.796875000000114,
									70.61557617187506
								],
								[
									55.70673828125007,
									70.64189453125002
								],
								[
									55.706445312499966,
									70.67524414062507
								],
								[
									55.68730468750016,
									70.69218749999996
								],
								[
									55.23691406250009,
									70.66601562500006
								],
								[
									55.051660156249966,
									70.66674804687503
								],
								[
									54.867089843750136,
									70.67812499999994
								],
								[
									54.645117187500034,
									70.74184570312505
								],
								[
									54.60820312500016,
									70.71323242187506
								],
								[
									54.601171875000034,
									70.68007812500008
								],
								[
									54.517382812500045,
									70.69331054687493
								],
								[
									54.332617187500034,
									70.74467773437507
								],
								[
									54.19941406250018,
									70.76489257812494
								],
								[
									53.72236328125018,
									70.814453125
								],
								[
									53.38359375000016,
									70.87353515625006
								],
								[
									53.4677734375,
									70.90058593750004
								],
								[
									53.613574218750045,
									70.91464843750006
								],
								[
									53.61562500000002,
									70.95083007812508
								],
								[
									53.59257812499999,
									71.00068359374993
								],
								[
									53.58779296875002,
									71.05229492187496
								],
								[
									53.67050781250009,
									71.0869140625
								],
								[
									53.857031250000034,
									71.07041015625
								],
								[
									53.83427734375016,
									71.12670898437503
								],
								[
									53.922265625000136,
									71.13759765624994
								],
								[
									54.09394531250018,
									71.105224609375
								],
								[
									54.155664062499966,
									71.12548828125003
								],
								[
									53.886132812500136,
									71.19628906250009
								],
								[
									53.590820312500114,
									71.29667968750002
								],
								[
									53.62216796875009,
									71.33276367187509
								],
								[
									53.515234375000034,
									71.34252929687494
								],
								[
									53.409960937500045,
									71.34013671874999
								],
								[
									53.31904296875007,
									71.39916992187503
								],
								[
									53.33251953124994,
									71.47724609375004
								],
								[
									53.411621093750114,
									71.53012695312506
								],
								[
									53.363867187500034,
									71.54165039062508
								],
								[
									52.90898437499999,
									71.49501953125011
								],
								[
									52.6787109375,
									71.50566406249996
								],
								[
									52.418847656249966,
									71.536865234375
								],
								[
									52.17998046874999,
									71.49023437500009
								],
								[
									51.937890625000136,
									71.47470703124995
								],
								[
									51.812597656250034,
									71.49130859375006
								],
								[
									51.69160156250007,
									71.52514648437511
								],
								[
									51.590429687500034,
									71.57114257812498
								],
								[
									51.511328125000034,
									71.64809570312502
								],
								[
									51.43867187500007,
									71.77680664062495
								],
								[
									51.428613281250136,
									71.82553710937512
								],
								[
									51.44355468750018,
									71.93437499999999
								],
								[
									51.482226562500045,
									71.9797851562501
								],
								[
									51.58251953124994,
									72.07119140624997
								],
								[
									51.653125000000045,
									72.09936523437494
								],
								[
									51.80546875000016,
									72.14213867187505
								],
								[
									51.88544921875001,
									72.15322265625008
								],
								[
									52.06865234375016,
									72.13115234375002
								],
								[
									52.252050781250034,
									72.12973632812509
								],
								[
									52.332324218750045,
									72.15395507812505
								],
								[
									52.406738281250114,
									72.19672851562507
								],
								[
									52.46191406249994,
									72.25234375000002
								],
								[
									52.58613281250007,
									72.28403320312509
								],
								[
									52.622070312500114,
									72.30097656249998
								],
								[
									52.661914062500045,
									72.33686523437501
								],
								[
									52.70576171875018,
									72.39096679687509
								],
								[
									52.71386718749994,
									72.43696289062507
								],
								[
									52.74873046875007,
									72.48295898437502
								],
								[
									52.86367187500002,
									72.54985351562496
								],
								[
									52.82324218749994,
									72.59125976562504
								],
								[
									52.83906250000007,
									72.619287109375
								],
								[
									52.916601562500034,
									72.66889648437507
								],
								[
									52.683105468750114,
									72.68232421874995
								],
								[
									52.60498046875,
									72.70405273437504
								],
								[
									52.52851562500001,
									72.73735351562507
								],
								[
									52.55058593749999,
									72.76855468750003
								],
								[
									52.57929687500018,
									72.79135742187506
								],
								[
									52.81220703125018,
									72.875244140625
								],
								[
									52.91318359375009,
									72.89995117187505
								],
								[
									53.024218750000045,
									72.91357421875009
								],
								[
									53.13496093750001,
									72.91323242187511
								],
								[
									53.253515625000034,
									72.90375976562504
								],
								[
									53.36982421875018,
									72.91674804687511
								],
								[
									53.24726562500018,
									72.97314453125006
								],
								[
									53.23710937500016,
									73.01118164062498
								],
								[
									53.188964843750114,
									73.10400390624997
								],
								[
									53.19794921875018,
									73.14755859375006
								],
								[
									53.25117187500018,
									73.18295898437498
								],
								[
									53.35761718750018,
									73.22456054687493
								],
								[
									53.51220703125,
									73.23837890625009
								],
								[
									53.633691406250136,
									73.26025390625009
								],
								[
									53.75322265625016,
									73.29326171874999
								],
								[
									53.865625000000136,
									73.298974609375
								],
								[
									54.09101562500001,
									73.27646484375003
								],
								[
									54.20234375000018,
									73.28134765624995
								],
								[
									54.327636718750114,
									73.29946289062508
								],
								[
									54.676074218750045,
									73.37001953125
								],
								[
									54.80390625000007,
									73.38764648437504
								],
								[
									54.94062500000001,
									73.38325195312493
								],
								[
									55.12138671875016,
									73.35683593749997
								],
								[
									55.319824218750114,
									73.30830078125004
								]
							]
						],
						[
							[
								[
									70.67392578125003,
									73.0950195312501
								],
								[
									70.38037109375011,
									73.04809570312503
								],
								[
									70.29833984375011,
									73.04448242187502
								],
								[
									70.11865234375,
									73.05629882812494
								],
								[
									70.04072265625001,
									73.03715820312513
								],
								[
									69.92011718750007,
									73.0845214843751
								],
								[
									69.93037109375018,
									73.12661132812497
								],
								[
									69.98564453125016,
									73.16923828125013
								],
								[
									70.01875000000018,
									73.22431640625007
								],
								[
									69.99589843750005,
									73.35937500000003
								],
								[
									70.14960937500018,
									73.44472656249994
								],
								[
									70.35000000000014,
									73.47763671874998
								],
								[
									70.94023437500005,
									73.514404296875
								],
								[
									71.02324218750016,
									73.50419921875005
								],
								[
									71.14121093750003,
									73.47797851562495
								],
								[
									71.23164062500018,
									73.44775390625011
								],
								[
									71.35117187500009,
									73.372216796875
								],
								[
									71.44492187500009,
									73.34208984374999
								],
								[
									71.58955078125018,
									73.28315429687507
								],
								[
									71.63046875000003,
									73.22480468749998
								],
								[
									71.62617187500018,
									73.17397460937502
								],
								[
									71.35566406250001,
									73.16245117187498
								],
								[
									70.88671875,
									73.11962890625006
								],
								[
									70.67392578125003,
									73.0950195312501
								]
							]
						],
						[
							[
								[
									76.75605468750007,
									73.44580078124997
								],
								[
									76.65937500000018,
									73.43950195312502
								],
								[
									76.2344726562502,
									73.47622070312505
								],
								[
									76.08310546875009,
									73.52348632812499
								],
								[
									76.13955078125014,
									73.55429687500006
								],
								[
									76.25068359375001,
									73.55527343749998
								],
								[
									76.75605468750007,
									73.44580078124997
								]
							]
						],
						[
							[
								[
									75.50371093749999,
									73.45664062500006
								],
								[
									75.34433593750003,
									73.43227539062497
								],
								[
									75.375,
									73.47739257812509
								],
								[
									75.56972656250014,
									73.54062500000012
								],
								[
									75.93017578125011,
									73.5736328125
								],
								[
									76.03945312499997,
									73.55991210937495
								],
								[
									76.05156250000016,
									73.54926757812501
								],
								[
									75.90097656250003,
									73.48149414062496
								],
								[
									75.8271484375,
									73.45913085937494
								],
								[
									75.50371093749999,
									73.45664062500006
								]
							]
						],
						[
							[
								[
									142.18486328125016,
									73.89589843750011
								],
								[
									142.43505859374994,
									73.85156249999994
								],
								[
									142.63916015624994,
									73.80307617187512
								],
								[
									143.34375,
									73.56875000000005
								],
								[
									143.4107421875002,
									73.52084960937506
								],
								[
									143.46396484375003,
									73.45888671875005
								],
								[
									143.4913085937502,
									73.24643554687495
								],
								[
									143.45146484375016,
									73.23129882812498
								],
								[
									143.19326171875014,
									73.22075195312496
								],
								[
									142.8416015625,
									73.24482421875007
								],
								[
									142.5869140625,
									73.25332031250002
								],
								[
									142.34218750000014,
									73.25288085937493
								],
								[
									142.12636718750014,
									73.28168945312501
								],
								[
									141.5966796875001,
									73.31083984375002
								],
								[
									141.1827148437501,
									73.38920898437499
								],
								[
									140.75400390625003,
									73.44604492187503
								],
								[
									140.66279296875,
									73.45200195312509
								],
								[
									140.39248046875002,
									73.43535156250007
								],
								[
									140.0269531250001,
									73.36142578125009
								],
								[
									139.92509765625,
									73.355224609375
								],
								[
									139.78554687500002,
									73.355224609375
								],
								[
									139.68554687499994,
									73.42573242187507
								],
								[
									139.92011718750007,
									73.448583984375
								],
								[
									140.15517578124997,
									73.45751953125006
								],
								[
									140.3806640625,
									73.4830078125
								],
								[
									140.59355468750005,
									73.56455078125
								],
								[
									140.69746093750018,
									73.62915039062503
								],
								[
									140.8837890625001,
									73.77753906250007
								],
								[
									140.98359375000018,
									73.83154296875006
								],
								[
									141.084765625,
									73.86586914062494
								],
								[
									141.18994140624994,
									73.87646484375006
								],
								[
									141.31191406250002,
									73.8718750000001
								],
								[
									141.68193359375,
									73.90419921875002
								],
								[
									141.93183593750018,
									73.91494140625008
								],
								[
									142.18486328125016,
									73.89589843750011
								]
							]
						],
						[
							[
								[
									124.54296875000011,
									73.85009765625
								],
								[
									124.48173828125016,
									73.847900390625
								],
								[
									124.36640625000001,
									73.87460937500003
								],
								[
									124.33574218749999,
									73.91030273437502
								],
								[
									124.33652343750003,
									73.92836914062497
								],
								[
									124.42968749999994,
									73.94301757812502
								],
								[
									124.54765624999999,
									73.93383789062511
								],
								[
									124.63691406250007,
									73.90039062499994
								],
								[
									124.65292968750003,
									73.888037109375
								],
								[
									124.54296875000011,
									73.85009765625
								]
							]
						],
						[
							[
								[
									83.54902343750018,
									74.07177734375006
								],
								[
									83.49580078125018,
									74.0484375
								],
								[
									83.45000000000016,
									74.05166015625002
								],
								[
									83.41064453124994,
									74.03955078124997
								],
								[
									83.15898437500005,
									74.07534179687505
								],
								[
									82.81777343749997,
									74.0916015625001
								],
								[
									82.9029296875002,
									74.12890625000006
								],
								[
									83.14980468750014,
									74.15161132812497
								],
								[
									83.51347656250005,
									74.12236328124996
								],
								[
									83.61835937500018,
									74.089453125
								],
								[
									83.54902343750018,
									74.07177734375006
								]
							]
						],
						[
							[
								[
									82.70996093750011,
									74.09086914062513
								],
								[
									82.61279296874994,
									74.05644531250013
								],
								[
									82.47812500000003,
									74.07578124999998
								],
								[
									82.38154296875018,
									74.09921874999995
								],
								[
									82.32939453125005,
									74.13110351562497
								],
								[
									82.3824218750002,
									74.14926757812503
								],
								[
									82.52558593750007,
									74.16142578125002
								],
								[
									82.61103515625007,
									74.14853515625006
								],
								[
									82.68896484375011,
									74.11123046875008
								],
								[
									82.70996093750011,
									74.09086914062513
								]
							]
						],
						[
							[
								[
									136.19746093750018,
									73.91362304687507
								],
								[
									136.1216796875002,
									73.88500976562511
								],
								[
									136.05146484375018,
									73.92910156249994
								],
								[
									135.71455078125,
									74.05952148437495
								],
								[
									135.6333984375002,
									74.12143554687495
								],
								[
									135.44863281250002,
									74.1796875
								],
								[
									135.4024414062502,
									74.20170898437496
								],
								[
									135.38701171875016,
									74.25336914062501
								],
								[
									135.62832031250014,
									74.21992187500004
								],
								[
									136.03681640625,
									74.09033203125009
								],
								[
									136.25917968750014,
									73.98496093749995
								],
								[
									136.19746093750018,
									73.91362304687507
								]
							]
						],
						[
							[
								[
									141.0102539062501,
									73.99946289062507
								],
								[
									140.50722656250014,
									73.91865234375004
								],
								[
									140.40947265625,
									73.92167968750002
								],
								[
									140.1832031250002,
									74.00458984374995
								],
								[
									140.1015625,
									74.18427734375004
								],
								[
									140.19355468750018,
									74.23671875
								],
								[
									140.30029296875,
									74.2572265625
								],
								[
									140.40742187500007,
									74.266455078125
								],
								[
									140.8492187500001,
									74.27377929687509
								],
								[
									140.9443359375001,
									74.2646484375
								],
								[
									141.0385742187501,
									74.24272460937505
								],
								[
									141.07949218750002,
									74.209326171875
								],
								[
									141.09746093750005,
									74.16782226562506
								],
								[
									141.0468750000001,
									74.05039062499995
								],
								[
									141.0102539062501,
									73.99946289062507
								]
							]
						],
						[
							[
								[
									84.75898437500001,
									74.45942382812507
								],
								[
									84.71044921875011,
									74.3998046875
								],
								[
									84.42890625000001,
									74.430322265625
								],
								[
									84.38945312500016,
									74.45444335937503
								],
								[
									84.54033203125016,
									74.49042968749998
								],
								[
									84.67988281250018,
									74.51235351562511
								],
								[
									84.87285156250016,
									74.51552734375002
								],
								[
									84.75898437500001,
									74.45942382812507
								]
							]
						],
						[
							[
								[
									113.38720703124994,
									74.40043945312505
								],
								[
									113.35312500000003,
									74.35297851562495
								],
								[
									113.29921874999997,
									74.31713867187494
								],
								[
									113.2588867187502,
									74.27270507812494
								],
								[
									113.19023437500016,
									74.23930664062499
								],
								[
									112.9776367187502,
									74.19682617187513
								],
								[
									112.81132812500016,
									74.1029296875
								],
								[
									112.78242187500001,
									74.09506835937509
								],
								[
									112.19580078125,
									74.14624023437494
								],
								[
									112.10507812500009,
									74.16323242187494
								],
								[
									111.91210937500011,
									74.21923828125006
								],
								[
									111.64296874999997,
									74.27294921875
								],
								[
									111.50341796874994,
									74.35307617187507
								],
								[
									111.57011718750016,
									74.36831054687505
								],
								[
									111.63750000000005,
									74.37431640624996
								],
								[
									111.87978515625002,
									74.36381835937505
								],
								[
									111.94921875000011,
									74.38876953125006
								],
								[
									111.98281250000014,
									74.45629882812506
								],
								[
									111.9893554687502,
									74.49624023437502
								],
								[
									112.00761718749999,
									74.52675781250002
								],
								[
									112.08447265624994,
									74.54897460937511
								],
								[
									112.95175781250009,
									74.47958984375009
								],
								[
									113.2862304687502,
									74.44101562499995
								],
								[
									113.38720703124994,
									74.40043945312505
								]
							]
						],
						[
							[
								[
									86.65312499999999,
									74.98129882812498
								],
								[
									86.73710937500016,
									74.96298828124998
								],
								[
									87.0005859375002,
									74.99194335937511
								],
								[
									87.05214843750014,
									74.98256835937497
								],
								[
									87.12431640625016,
									74.93989257812498
								],
								[
									87.01171874999994,
									74.86191406250009
								],
								[
									86.92714843750014,
									74.83076171874995
								],
								[
									86.6919921875002,
									74.84829101562497
								],
								[
									86.39052734374997,
									74.85087890624996
								],
								[
									86.25859374999999,
									74.89350585937504
								],
								[
									86.3306640625002,
									74.93896484374997
								],
								[
									86.5044921875002,
									74.96596679687497
								],
								[
									86.60546875,
									74.99282226562502
								],
								[
									86.65312499999999,
									74.98129882812498
								]
							]
						],
						[
							[
								[
									82.17236328125011,
									75.41938476562507
								],
								[
									82.20878906250016,
									75.38696289062503
								],
								[
									82.22158203125002,
									75.35053710937507
								],
								[
									82.1792968750002,
									75.33896484375009
								],
								[
									82.05009765625016,
									75.34096679687508
								],
								[
									81.97851562499994,
									75.24711914062496
								],
								[
									81.90507812499999,
									75.26279296874995
								],
								[
									81.86054687500018,
									75.31650390625006
								],
								[
									81.69765625000014,
									75.28051757812509
								],
								[
									81.65478515625011,
									75.28891601562495
								],
								[
									81.57929687500018,
									75.33095703125008
								],
								[
									81.53212890624997,
									75.33955078124995
								],
								[
									81.5005859375002,
									75.36791992187506
								],
								[
									81.71210937500007,
									75.45141601562509
								],
								[
									81.84218749999997,
									75.4070312500001
								],
								[
									81.92656250000005,
									75.4099609375001
								],
								[
									81.90976562500009,
									75.46000976562499
								],
								[
									81.91279296875018,
									75.49770507812494
								],
								[
									82.02187500000002,
									75.51347656250005
								],
								[
									82.16562500000009,
									75.51562499999994
								],
								[
									82.17236328125011,
									75.41938476562507
								]
							]
						],
						[
							[
								[
									146.79521484375016,
									75.37075195312511
								],
								[
									147.06035156250016,
									75.3643066406251
								],
								[
									147.44355468750007,
									75.43798828124994
								],
								[
									147.49697265625002,
									75.44052734375
								],
								[
									148.432421875,
									75.41352539062493
								],
								[
									148.5088867187502,
									75.38745117187494
								],
								[
									148.51884765625,
									75.33647460937505
								],
								[
									148.48916015625002,
									75.3093750000001
								],
								[
									148.47500000000014,
									75.27241210937495
								],
								[
									148.59013671875016,
									75.23637695312499
								],
								[
									148.89218750000003,
									75.22812500000009
								],
								[
									149.08320312500007,
									75.26206054687498
								],
								[
									149.6453125,
									75.24458007812507
								],
								[
									150.10390624999997,
									75.21923828125006
								],
								[
									150.28066406250014,
									75.16401367187498
								],
								[
									150.41718750000007,
									75.13432617187507
								],
								[
									150.53056640625016,
									75.09985351562497
								],
								[
									150.6128906250002,
									75.1201660156251
								],
								[
									150.69033203125002,
									75.15532226562499
								],
								[
									150.7569335937501,
									75.16240234375002
								],
								[
									150.8223632812501,
									75.15654296875007
								],
								[
									150.6462890625,
									74.94458007812506
								],
								[
									150.58027343750007,
									74.91894531249997
								],
								[
									150.33125,
									74.866796875
								],
								[
									149.8380859375,
									74.79531250000002
								],
								[
									149.59687500000018,
									74.77260742187511
								],
								[
									149.05019531249997,
									74.77246093749997
								],
								[
									148.2968750000001,
									74.800439453125
								],
								[
									148.0923828125001,
									74.82568359375009
								],
								[
									147.97187500000007,
									74.85732421875002
								],
								[
									147.74091796875018,
									74.93198242187506
								],
								[
									147.62685546875002,
									74.95893554687495
								],
								[
									147.25703125000018,
									74.98427734374997
								],
								[
									147.14404296874994,
									74.99843750000011
								],
								[
									146.9249023437502,
									75.0625
								],
								[
									146.70332031250018,
									75.11420898437507
								],
								[
									146.1485351562502,
									75.19829101562496
								],
								[
									146.18613281250003,
									75.29555664062497
								],
								[
									146.25761718750005,
									75.39374999999998
								],
								[
									146.34296875,
									75.48090820312498
								],
								[
									146.4384765625001,
									75.558203125
								],
								[
									146.53750000000014,
									75.58178710937511
								],
								[
									146.7509765625001,
									75.51044921874995
								],
								[
									146.74824218750018,
									75.42866210937507
								],
								[
									146.79521484375016,
									75.37075195312511
								]
							]
						],
						[
							[
								[
									135.94863281250002,
									75.40957031250011
								],
								[
									135.7458984375,
									75.38198242187508
								],
								[
									135.45195312500016,
									75.38955078125002
								],
								[
									135.47304687500002,
									75.46323242187512
								],
								[
									135.5234375,
									75.495849609375
								],
								[
									135.59267578125014,
									75.57646484374999
								],
								[
									135.56123046875007,
									75.63647460937506
								],
								[
									135.57841796875,
									75.70996093750011
								],
								[
									135.6138671875002,
									75.76630859375004
								],
								[
									135.69863281249997,
									75.84526367187496
								],
								[
									135.78828125,
									75.79848632812502
								],
								[
									135.8492187500002,
									75.72924804687494
								],
								[
									135.90478515624994,
									75.69438476562505
								],
								[
									136.12734375000002,
									75.62558593750006
								],
								[
									136.16894531249994,
									75.60556640624998
								],
								[
									135.9833984375,
									75.52192382812498
								],
								[
									135.96513671875,
									75.48613281250007
								],
								[
									136.0205078125,
									75.43837890625002
								],
								[
									135.94863281250002,
									75.40957031250011
								]
							]
						],
						[
							[
								[
									152.8859375,
									76.12172851562497
								],
								[
									152.78632812500007,
									76.08579101562512
								],
								[
									152.5585937500001,
									76.14360351562499
								],
								[
									152.6427734375,
									76.17480468749994
								],
								[
									152.7994140625001,
									76.19482421874994
								],
								[
									152.83505859375003,
									76.18515625
								],
								[
									152.8637695312501,
									76.16342773437503
								],
								[
									152.8859375,
									76.12172851562497
								]
							]
						],
						[
							[
								[
									140.04873046874997,
									75.828955078125
								],
								[
									140.1521484375,
									75.80981445312511
								],
								[
									140.27441406249994,
									75.82241210937511
								],
								[
									140.38906250000014,
									75.79584960937493
								],
								[
									140.4962890625,
									75.68979492187509
								],
								[
									140.5466796875,
									75.66318359375006
								],
								[
									140.6021484375002,
									75.64394531250005
								],
								[
									140.6567382812501,
									75.63413085937512
								],
								[
									140.81591796874994,
									75.63071289062495
								],
								[
									140.88925781250003,
									75.65200195312502
								],
								[
									140.94414062500016,
									75.70048828125005
								],
								[
									140.9404296875001,
									75.74951171875009
								],
								[
									140.92656250000005,
									75.79892578125012
								],
								[
									140.92578124999994,
									75.866845703125
								],
								[
									140.95029296875003,
									75.92734374999998
								],
								[
									140.9853515625001,
									75.964501953125
								],
								[
									141.03261718750014,
									75.98896484374993
								],
								[
									141.2993164062501,
									76.06376953125007
								],
								[
									141.4854492187502,
									76.13715820312501
								],
								[
									141.7422851562502,
									76.10805664062494
								],
								[
									142.00146484375,
									76.04355468750003
								],
								[
									142.46035156250014,
									75.90361328125013
								],
								[
									142.6695312500002,
									75.86342773437502
								],
								[
									142.9267578125001,
									75.82690429687494
								],
								[
									143.1851562500001,
									75.813623046875
								],
								[
									143.3111328125001,
									75.82231445312499
								],
								[
									143.55996093749997,
									75.86040039062502
								],
								[
									143.68583984375005,
									75.86367187500005
								],
								[
									145.25527343750014,
									75.585595703125
								],
								[
									145.309765625,
									75.56406249999995
								],
								[
									145.35996093750003,
									75.53046874999995
								],
								[
									145.02343749999994,
									75.48974609375
								],
								[
									144.80312500000002,
									75.4160644531251
								],
								[
									144.72675781250018,
									75.36557617187512
								],
								[
									144.81425781250016,
									75.3245117187501
								],
								[
									144.88349609375007,
									75.26894531249997
								],
								[
									144.40781250000003,
									75.10229492187494
								],
								[
									144.21601562500007,
									75.05917968749995
								],
								[
									144.0197265625,
									75.04467773437511
								],
								[
									143.62587890624997,
									75.08398437499994
								],
								[
									143.3960937500001,
									75.08286132812498
								],
								[
									143.17031249999997,
									75.11689453124998
								],
								[
									142.92207031250007,
									75.21743164062502
								],
								[
									142.82011718750016,
									75.267822265625
								],
								[
									142.7294921875,
									75.33764648437511
								],
								[
									142.69960937500002,
									75.44887695312494
								],
								[
									142.7344726562502,
									75.54458007812508
								],
								[
									142.86757812500014,
									75.57177734375011
								],
								[
									142.98603515625,
									75.63325195312493
								],
								[
									143.00244140625,
									75.65986328124993
								],
								[
									142.94179687499997,
									75.71328125000008
								],
								[
									142.55156250000016,
									75.72089843749993
								],
								[
									142.30791015625016,
									75.69169921875002
								],
								[
									142.08623046875005,
									75.66064453125
								],
								[
									142.15107421875018,
									75.45756835937502
								],
								[
									142.19882812500003,
									75.39267578124995
								],
								[
									142.2647460937501,
									75.34614257812507
								],
								[
									142.6167968750002,
									75.13325195312504
								],
								[
									142.69697265625,
									75.1030761718751
								],
								[
									142.9296875,
									75.06240234375008
								],
								[
									143.12792968749994,
									74.97031250000006
								],
								[
									142.77822265625014,
									74.86777343749995
								],
								[
									142.62607421875003,
									74.83740234374997
								],
								[
									142.4727539062501,
									74.82041015624998
								],
								[
									142.37841796874994,
									74.82856445312495
								],
								[
									142.28740234375016,
									74.84990234375013
								],
								[
									142.1841796875001,
									74.89960937500004
								],
								[
									142.09999999999997,
									74.95097656250002
								],
								[
									141.9873046875001,
									74.99125976562496
								],
								[
									141.74843750000014,
									74.98256835937497
								],
								[
									141.52998046875,
									74.94716796875005
								],
								[
									141.31044921874997,
									74.92319335937495
								],
								[
									140.66074218750003,
									74.88183593749997
								],
								[
									140.4638671875,
									74.85605468749995
								],
								[
									140.26787109375005,
									74.84692382812506
								],
								[
									140.01103515625005,
									74.89477539062494
								],
								[
									139.75820312500014,
									74.96376953124997
								],
								[
									139.6812500000001,
									74.96406249999993
								],
								[
									139.60585937499997,
									74.94560546874999
								],
								[
									139.548046875,
									74.90405273437506
								],
								[
									139.5123046875002,
									74.83779296874997
								],
								[
									139.43007812499997,
									74.74921874999995
								],
								[
									139.32558593750002,
									74.6868164062501
								],
								[
									139.2153320312501,
									74.65966796875
								],
								[
									139.09912109374994,
									74.65654296874999
								],
								[
									138.98173828125005,
									74.67368164062509
								],
								[
									138.86562500000002,
									74.70092773437497
								],
								[
									138.0922851562501,
									74.7974609375
								],
								[
									138.00136718750014,
									74.82700195312506
								],
								[
									137.91503906249994,
									74.87084960937494
								],
								[
									137.68300781250014,
									75.00854492187503
								],
								[
									137.56806640625007,
									75.04057617187507
								],
								[
									137.44697265625018,
									75.05419921875
								],
								[
									137.21796875000007,
									75.12373046874995
								],
								[
									137.00625000000002,
									75.23500976562505
								],
								[
									136.96230468750002,
									75.27036132812498
								],
								[
									136.94765625000014,
									75.32553710937495
								],
								[
									136.9824218750001,
									75.36533203125006
								],
								[
									137.16601562499994,
									75.34658203124997
								],
								[
									137.28974609375,
									75.34863281249994
								],
								[
									137.21523437500014,
									75.55439453125004
								],
								[
									137.26884765625005,
									75.74941406249997
								],
								[
									137.3584960937501,
									75.78164062499997
								],
								[
									137.7065429687501,
									75.75957031249999
								],
								[
									137.5935546875,
									75.82338867187494
								],
								[
									137.501171875,
									75.90966796875003
								],
								[
									137.56054687499994,
									75.95522460937505
								],
								[
									137.62539062500002,
									75.98818359374994
								],
								[
									137.7744140625001,
									76.01567382812513
								],
								[
									137.97705078125,
									76.02778320312493
								],
								[
									138.0386718750002,
									76.04726562500008
								],
								[
									138.09599609375016,
									76.08051757812493
								],
								[
									138.20761718750003,
									76.11494140625001
								],
								[
									138.4306640625001,
									76.13007812499998
								],
								[
									138.81396484374994,
									76.19970703125006
								],
								[
									138.91953125000003,
									76.19672851562507
								],
								[
									139.01757812499994,
									76.16010742187507
								],
								[
									139.10917968750016,
									76.1083496093751
								],
								[
									139.21132812499997,
									76.08071289062497
								],
								[
									139.52851562500007,
									76.01342773437503
								],
								[
									139.743359375,
									75.95307617187498
								],
								[
									140.04873046874997,
									75.828955078125
								]
							]
						],
						[
							[
								[
									96.53242187500018,
									76.27812500000013
								],
								[
									96.61396484375018,
									76.26381835937497
								],
								[
									96.58964843749999,
									76.22124023437499
								],
								[
									96.48671875000002,
									76.23374023437506
								],
								[
									96.35078125000018,
									76.212158203125
								],
								[
									96.35341796875002,
									76.17749023437506
								],
								[
									96.30058593749999,
									76.12172851562497
								],
								[
									96.10878906250002,
									76.15546875000001
								],
								[
									95.84453124999999,
									76.16025390625
								],
								[
									95.67861328125014,
									76.19365234374996
								],
								[
									95.31113281250003,
									76.21474609375
								],
								[
									95.32207031250016,
									76.26162109375005
								],
								[
									95.37988281250011,
									76.28906250000003
								],
								[
									95.59443359375001,
									76.24960937500009
								],
								[
									95.7862304687502,
									76.29389648437495
								],
								[
									96.15097656250009,
									76.27187500000008
								],
								[
									96.27070312500007,
									76.30537109374998
								],
								[
									96.53242187500018,
									76.27812500000013
								]
							]
						],
						[
							[
								[
									96.85390625000002,
									76.19916992187501
								],
								[
									96.79785156249994,
									76.18842773437507
								],
								[
									96.7544921875002,
									76.19575195312495
								],
								[
									96.73935546875003,
									76.20693359375011
								],
								[
									96.74023437499994,
									76.25786132812499
								],
								[
									96.83291015625002,
									76.3241699218751
								],
								[
									96.83525390625005,
									76.34482421874995
								],
								[
									96.87792968750011,
									76.35522460937503
								],
								[
									96.990234375,
									76.34340820312511
								],
								[
									97.04531250000014,
									76.31538085937498
								],
								[
									97.05302734374999,
									76.30258789062495
								],
								[
									96.9742187500002,
									76.2365234375001
								],
								[
									96.85390625000002,
									76.19916992187501
								]
							]
						],
						[
							[
								[
									112.47802734375011,
									76.62089843749996
								],
								[
									112.63251953125007,
									76.55297851562509
								],
								[
									112.66083984375007,
									76.50957031250002
								],
								[
									112.61416015625014,
									76.49926757812497
								],
								[
									112.5865234375002,
									76.48295898437502
								],
								[
									112.5748046875002,
									76.45239257812509
								],
								[
									112.53164062500002,
									76.45004882812498
								],
								[
									112.39482421875005,
									76.48378906250011
								],
								[
									112.29687499999994,
									76.53798828125005
								],
								[
									112.15380859374994,
									76.54931640624994
								],
								[
									112.00273437499999,
									76.60297851562495
								],
								[
									111.96894531250007,
									76.62617187500007
								],
								[
									112.01113281250014,
									76.6328613281251
								],
								[
									112.28144531250001,
									76.61835937499998
								],
								[
									112.39414062500009,
									76.64379882812511
								],
								[
									112.47802734375011,
									76.62089843749996
								]
							]
						],
						[
							[
								[
									97.58837890625,
									76.59936523437503
								],
								[
									97.5352539062502,
									76.5844238281251
								],
								[
									97.43037109375007,
									76.59072265625002
								],
								[
									97.34169921875002,
									76.62885742187498
								],
								[
									97.31035156249999,
									76.68959960937502
								],
								[
									97.38164062500016,
									76.70668945312502
								],
								[
									97.58837890625,
									76.59936523437503
								]
							]
						],
						[
							[
								[
									149.15019531250005,
									76.65991210937509
								],
								[
									148.3986328125,
									76.64824218750013
								],
								[
									148.44814453125002,
									76.67695312499993
								],
								[
									148.71962890624997,
									76.74658203125009
								],
								[
									149.40644531250018,
									76.78208007812503
								],
								[
									149.26835937500005,
									76.74721679687494
								],
								[
									149.20478515625007,
									76.67700195312494
								],
								[
									149.15019531250005,
									76.65991210937509
								]
							]
						],
						[
							[
								[
									67.76533203125018,
									76.23759765625005
								],
								[
									67.36523437500011,
									76.16127929687494
								],
								[
									67.126953125,
									76.10815429687506
								],
								[
									66.89316406250003,
									76.07226562500011
								],
								[
									66.65742187500007,
									76.04702148437494
								],
								[
									66.28242187500007,
									75.9836914062501
								],
								[
									65.61914062500011,
									75.90463867187498
								],
								[
									65.20156250000014,
									75.83945312500009
								],
								[
									64.74453125000002,
									75.78823242187497
								],
								[
									64.26259765625014,
									75.71967773437495
								],
								[
									63.779296875000114,
									75.67260742187503
								],
								[
									63.65947265624999,
									75.66874999999996
								],
								[
									63.31669921875016,
									75.60307617187507
								],
								[
									63.04599609375009,
									75.57573242187502
								],
								[
									62.06611328125001,
									75.42773437500006
								],
								[
									61.616210937500114,
									75.31962890624999
								],
								[
									61.48652343750018,
									75.31083984375005
								],
								[
									61.35595703124994,
									75.31484375000008
								],
								[
									61.24882812500016,
									75.28100585937503
								],
								[
									61.14726562500016,
									75.22255859375002
								],
								[
									60.935644531250034,
									75.163671875
								],
								[
									60.829199218750034,
									75.11083984375009
								],
								[
									60.71923828125,
									75.068603515625
								],
								[
									60.655371093750034,
									75.05502929687509
								],
								[
									60.533789062500034,
									75.05927734375007
								],
								[
									60.475585937500114,
									75.05473632812502
								],
								[
									60.276855468750114,
									75.007568359375
								],
								[
									60.241113281250136,
									74.97075195312496
								],
								[
									60.45488281250016,
									74.946142578125
								],
								[
									60.50136718750002,
									74.90463867187509
								],
								[
									60.43916015625007,
									74.87534179687498
								],
								[
									60.300781250000114,
									74.83701171874998
								],
								[
									60.222460937500045,
									74.79658203125001
								],
								[
									60.080078125,
									74.75585937499997
								],
								[
									59.982324218750136,
									74.74462890625009
								],
								[
									59.74726562500007,
									74.74589843749999
								],
								[
									59.73466796875016,
									74.69545898437511
								],
								[
									59.771484375000114,
									74.664453125
								],
								[
									59.75273437499999,
									74.6370117187501
								],
								[
									59.67402343750007,
									74.61015625000005
								],
								[
									59.59599609375016,
									74.61372070312507
								],
								[
									59.240136718750136,
									74.69296874999995
								],
								[
									59.18203125000002,
									74.665771484375
								],
								[
									59.15703125000016,
									74.61083984375
								],
								[
									59.146093750000034,
									74.55190429687508
								],
								[
									59.10097656250002,
									74.50751953125001
								],
								[
									59.04042968750002,
									74.48554687500007
								],
								[
									58.92822265625,
									74.46269531250002
								],
								[
									58.534667968750114,
									74.49892578124994
								],
								[
									58.50214843750007,
									74.46420898437498
								],
								[
									58.56201171875,
									74.42182617187495
								],
								[
									58.64570312500018,
									74.32802734374994
								],
								[
									58.665039062500114,
									74.28925781250004
								],
								[
									58.61787109375018,
									74.22739257812495
								],
								[
									58.441406250000114,
									74.12885742187495
								],
								[
									57.76738281249999,
									74.01381835937497
								],
								[
									57.778417968750034,
									73.9739257812501
								],
								[
									57.853417968750136,
									73.89785156249997
								],
								[
									57.87226562500007,
									73.85043945312506
								],
								[
									57.84492187500018,
									73.80507812500008
								],
								[
									57.75595703125009,
									73.76918945312505
								],
								[
									57.65742187500018,
									73.7681640625
								],
								[
									57.60371093750007,
									73.77548828125009
								],
								[
									57.44853515625016,
									73.8256347656251
								],
								[
									57.31308593750009,
									73.83803710937502
								],
								[
									57.29091796875002,
									73.81455078125003
								],
								[
									57.464257812499966,
									73.74604492187504
								],
								[
									57.542578125000034,
									73.65820312500009
								],
								[
									57.45976562500016,
									73.61030273437501
								],
								[
									57.13437500000009,
									73.50439453125009
								],
								[
									56.963867187500114,
									73.36655273437509
								],
								[
									56.634179687499966,
									73.304296875
								],
								[
									56.43037109375001,
									73.29721679687509
								],
								[
									56.22832031250016,
									73.31411132812497
								],
								[
									56.034570312500136,
									73.34589843749995
								],
								[
									55.54921875000002,
									73.35683593749997
								],
								[
									55.28017578125002,
									73.39204101562504
								],
								[
									55.006835937500114,
									73.45385742187511
								],
								[
									54.76865234375009,
									73.4494140625001
								],
								[
									54.565820312500136,
									73.4185058593751
								],
								[
									54.299902343750034,
									73.35097656250002
								],
								[
									54.13154296875001,
									73.48100585937505
								],
								[
									54.20458984375,
									73.54204101562505
								],
								[
									53.83867187500016,
									73.69711914062509
								],
								[
									53.76289062500018,
									73.76616210937496
								],
								[
									53.85136718750016,
									73.80053710937494
								],
								[
									53.96347656250009,
									73.82231445312513
								],
								[
									54.17402343750018,
									73.88574218750009
								],
								[
									54.38632812500009,
									73.93564453125003
								],
								[
									54.60566406250018,
									73.95131835937494
								],
								[
									54.64267578125009,
									73.95957031250009
								],
								[
									54.7333984375,
									74.03398437499999
								],
								[
									54.83125000000001,
									74.09575195312496
								],
								[
									54.920312500000136,
									74.12910156250001
								],
								[
									55.022851562499966,
									74.18662109375009
								],
								[
									55.340917968750034,
									74.41962890624995
								],
								[
									55.416406250000136,
									74.43613281250003
								],
								[
									56.07832031250018,
									74.48129882812509
								],
								[
									56.137109375000136,
									74.49609375000009
								],
								[
									55.94746093750007,
									74.54218749999995
								],
								[
									55.75175781250016,
									74.54121093750004
								],
								[
									55.661523437499966,
									74.55610351562495
								],
								[
									55.610351562500114,
									74.59052734374995
								],
								[
									55.58222656250018,
									74.62768554687497
								],
								[
									55.65966796874994,
									74.6562988281251
								],
								[
									55.91367187500009,
									74.7960937500001
								],
								[
									56.21787109375009,
									74.89750976562496
								],
								[
									56.49873046875018,
									74.95708007812502
								],
								[
									56.42851562499999,
									74.97294921874996
								],
								[
									56.34003906250018,
									75.01347656249996
								],
								[
									55.99804687499994,
									75.00336914062504
								],
								[
									55.863183593750136,
									75.05874023437502
								],
								[
									55.82119140625002,
									75.09062499999996
								],
								[
									55.81005859374994,
									75.12490234375002
								],
								[
									55.920703125000045,
									75.16835937500008
								],
								[
									56.035546874999966,
									75.19423828125002
								],
								[
									56.162207031250034,
									75.18657226562496
								],
								[
									56.288671875000034,
									75.16430664062506
								],
								[
									56.389062500000136,
									75.13818359374997
								],
								[
									56.48525390625002,
									75.09609375000011
								],
								[
									56.570312500000114,
									75.09775390625009
								],
								[
									56.87626953124999,
									75.24438476562503
								],
								[
									56.82929687500001,
									75.27773437500005
								],
								[
									56.809472656249966,
									75.32841796875007
								],
								[
									56.84443359375018,
									75.35141601562498
								],
								[
									56.98945312500007,
									75.37509765625
								],
								[
									57.087500000000034,
									75.3838378906251
								],
								[
									57.301757812500114,
									75.37324218749998
								],
								[
									57.606835937499966,
									75.34125976562495
								],
								[
									57.63154296875007,
									75.35644531250003
								],
								[
									57.70820312500001,
									75.45449218750002
								],
								[
									57.78339843750018,
									75.50668945312509
								],
								[
									58.093652343750136,
									75.59252929687506
								],
								[
									58.07255859374999,
									75.61899414062495
								],
								[
									58.05830078125001,
									75.66308593749997
								],
								[
									58.418359375000136,
									75.71977539062505
								],
								[
									58.652734374999966,
									75.77680664062495
								],
								[
									58.88125000000002,
									75.85478515625013
								],
								[
									58.994726562500034,
									75.87172851562502
								],
								[
									59.11044921875009,
									75.87373046874998
								],
								[
									59.346582031250136,
									75.90703125000002
								],
								[
									59.78193359375018,
									75.94584960937502
								],
								[
									60.036132812500114,
									75.98383789062504
								],
								[
									60.118164062500114,
									76.06655273437511
								],
								[
									60.279296875,
									76.09624023437502
								],
								[
									60.60615234375007,
									76.10864257812497
								],
								[
									60.73056640625009,
									76.1040527343751
								],
								[
									60.801171874999966,
									76.06879882812493
								],
								[
									60.942187500000045,
									76.0712890625
								],
								[
									60.99775390625018,
									76.08925781250002
								],
								[
									61.05390625000007,
									76.11987304687494
								],
								[
									61.03691406250016,
									76.16904296875009
								],
								[
									61.03437500000018,
									76.23295898437507
								],
								[
									61.15693359375018,
									76.27353515625006
								],
								[
									61.20166015624994,
									76.28203125000013
								],
								[
									61.56943359375009,
									76.29848632812511
								],
								[
									61.787109375000114,
									76.291015625
								],
								[
									62.237304687500114,
									76.24160156249997
								],
								[
									62.471093750000136,
									76.23046875
								],
								[
									62.78203125000016,
									76.24521484375009
								],
								[
									62.97148437499999,
									76.23666992187503
								],
								[
									63.526171875000045,
									76.30952148437504
								],
								[
									64.46347656250003,
									76.37817382812509
								],
								[
									64.70761718750003,
									76.42602539062497
								],
								[
									64.95000000000005,
									76.48432617187504
								],
								[
									65.07285156250009,
									76.49672851562508
								],
								[
									65.19716796875014,
									76.49965820312505
								],
								[
									65.30976562500007,
									76.51791992187495
								],
								[
									65.52841796875009,
									76.56782226562498
								],
								[
									65.63691406250018,
									76.57866210937507
								],
								[
									65.75517578124999,
									76.57929687499993
								],
								[
									65.86289062500003,
									76.61333007812502
								],
								[
									65.95888671875014,
									76.68793945312504
								],
								[
									66.06298828125011,
									76.74609375000006
								],
								[
									66.34521484374994,
									76.82104492187497
								],
								[
									66.82880859375018,
									76.92382812500003
								],
								[
									67.26367187500011,
									76.96376953125011
								],
								[
									67.53496093750016,
									77.0077636718751
								],
								[
									67.65185546875,
									77.01157226562498
								],
								[
									68.01728515625018,
									76.99062499999997
								],
								[
									68.48574218750014,
									76.93369140625
								],
								[
									68.69912109374997,
									76.87065429687496
								],
								[
									68.87333984375016,
									76.78959960937496
								],
								[
									68.91171875000003,
									76.76054687499999
								],
								[
									68.94169921875005,
									76.70766601562497
								],
								[
									68.89052734374997,
									76.65971679687505
								],
								[
									68.85800781250003,
									76.61049804687508
								],
								[
									68.89980468750002,
									76.57294921875007
								],
								[
									68.55859374999994,
									76.44941406250001
								],
								[
									68.22236328125001,
									76.31347656250003
								],
								[
									68.16542968749997,
									76.28486328124998
								],
								[
									67.76533203125018,
									76.23759765625005
								]
							]
						],
						[
							[
								[
									96.28544921875005,
									77.02666015625013
								],
								[
									96.2535156250002,
									77.00727539062498
								],
								[
									96.20986328124997,
									76.99213867187493
								],
								[
									96.0914062500002,
									77.0025390625
								],
								[
									95.85468750000001,
									76.97495117187498
								],
								[
									95.76582031250001,
									76.99062499999997
								],
								[
									95.68085937500007,
									77.021337890625
								],
								[
									95.36406250000016,
									77.01152343749996
								],
								[
									95.27031250000016,
									77.01884765625005
								],
								[
									95.42070312500016,
									77.05649414062498
								],
								[
									95.85410156250009,
									77.09755859375
								],
								[
									96.52841796875003,
									77.20551757812504
								],
								[
									96.56191406250014,
									77.15405273437506
								],
								[
									96.56132812499999,
									77.12958984374995
								],
								[
									96.42431640625,
									77.07119140625005
								],
								[
									96.28544921875005,
									77.02666015625013
								]
							]
						],
						[
							[
								[
									89.51425781250009,
									77.18881835937503
								],
								[
									89.29951171875001,
									77.18398437500002
								],
								[
									89.17929687500003,
									77.20991210937507
								],
								[
									89.1416992187502,
									77.22680664062494
								],
								[
									89.20048828124999,
									77.27197265625
								],
								[
									89.28154296874999,
									77.30146484375007
								],
								[
									89.61621093749994,
									77.31103515624997
								],
								[
									89.67958984375002,
									77.28032226562502
								],
								[
									89.66582031250005,
									77.25449218750009
								],
								[
									89.51425781250009,
									77.18881835937503
								]
							]
						],
						[
							[
								[
									107.41474609375001,
									77.24267578125009
								],
								[
									107.30224609375011,
									77.24150390625002
								],
								[
									107.26953125000011,
									77.28901367187493
								],
								[
									107.36640625000001,
									77.34663085937501
								],
								[
									107.48642578125003,
									77.34711914062504
								],
								[
									107.59365234375014,
									77.33002929687493
								],
								[
									107.62929687500014,
									77.31967773437495
								],
								[
									107.66455078125011,
									77.29980468750009
								],
								[
									107.67949218750016,
									77.26826171874995
								],
								[
									107.41474609375001,
									77.24267578125009
								]
							]
						],
						[
							[
								[
									130.68730468750016,
									42.30253906249996
								],
								[
									130.65800781250016,
									42.32778320312505
								],
								[
									130.65156250000018,
									42.37250976562501
								],
								[
									130.61796875000016,
									42.41562500000009
								],
								[
									130.55410156250014,
									42.47470703124995
								],
								[
									130.5269531250002,
									42.53540039062497
								],
								[
									130.5844726562501,
									42.5673339843751
								],
								[
									130.57656249999997,
									42.623242187499926
								],
								[
									130.52060546875003,
									42.67431640624994
								],
								[
									130.4392578125,
									42.685546875000085
								],
								[
									130.41992187499994,
									42.699853515624994
								],
								[
									130.4248046875,
									42.72705078125003
								],
								[
									130.4527343750001,
									42.755419921875045
								],
								[
									130.49296875,
									42.779101562500074
								],
								[
									130.57724609375003,
									42.81162109375012
								],
								[
									130.72246093750016,
									42.83583984375008
								],
								[
									130.8033203125001,
									42.856835937499994
								],
								[
									130.86855468750014,
									42.86333007812499
								],
								[
									130.9428710937501,
									42.85175781250004
								],
								[
									131.00556640625018,
									42.88310546874993
								],
								[
									131.0685546875,
									42.90224609375011
								],
								[
									131.08349609374994,
									42.956298828125114
								],
								[
									131.08613281250007,
									43.03808593749997
								],
								[
									131.1089843750002,
									43.06245117187507
								],
								[
									131.135546875,
									43.09760742187501
								],
								[
									131.17558593750016,
									43.142187500000034
								],
								[
									131.2119140625001,
									43.25776367187507
								],
								[
									131.2393554687502,
									43.337646484375085
								],
								[
									131.2573242187501,
									43.378076171874966
								],
								[
									131.26181640625003,
									43.43305664062507
								],
								[
									131.24394531250016,
									43.46904296874993
								],
								[
									131.20917968750018,
									43.49042968750004
								],
								[
									131.18242187500016,
									43.5055664062501
								],
								[
									131.18007812500002,
									43.567089843749926
								],
								[
									131.1835937500001,
									43.65087890624994
								],
								[
									131.17421874999997,
									43.70473632812508
								],
								[
									131.21328125000014,
									44.002929687500085
								],
								[
									131.25527343749997,
									44.07158203125002
								],
								[
									131.12578125000016,
									44.46918945312504
								],
								[
									131.08691406249994,
									44.59565429687504
								],
								[
									131.0606445312502,
									44.65966796875003
								],
								[
									131.0039062500001,
									44.75322265624999
								],
								[
									130.9677734375001,
									44.79995117187508
								],
								[
									130.98164062500018,
									44.84433593750006
								],
								[
									131.03300781250016,
									44.8888671875001
								],
								[
									131.08232421875,
									44.91000976562495
								],
								[
									131.22792968749997,
									44.92016601562506
								],
								[
									131.26826171875,
									44.93613281249995
								],
								[
									131.4468750000002,
									44.98403320312494
								],
								[
									131.4875,
									45.0131347656251
								],
								[
									131.57871093750003,
									45.08364257812508
								],
								[
									131.61396484375,
									45.13657226562509
								],
								[
									131.65400390625,
									45.205371093750074
								],
								[
									131.74208984375014,
									45.24262695312504
								],
								[
									131.79492187499994,
									45.305273437500006
								],
								[
									131.85185546875,
									45.32685546875007
								],
								[
									131.9092773437501,
									45.273730468750074
								],
								[
									131.9775390625001,
									45.24399414062506
								],
								[
									132.02378418738732,
									45.23471998242755
								],
								[
									132.00498046875003,
									45.214013671874994
								],
								[
									132.01718750000003,
									45.12661132812502
								],
								[
									132.01513671875006,
									45.07426757812502
								],
								[
									132.1086914062501,
									44.968652343749994
								],
								[
									132.08437500000002,
									44.85136718749999
								],
								[
									132.06904296875,
									44.742529296875034
								],
								[
									132.16855468750003,
									44.673974609374994
								],
								[
									132.2412109375,
									44.629980468750006
								],
								[
									132.2384765625,
									44.60610351562502
								],
								[
									132.27587890625006,
									44.56899414062502
								],
								[
									132.36552734375005,
									44.52944335937505
								],
								[
									132.45966796875,
									44.61259765625002
								],
								[
									132.61357421875005,
									44.711328124999966
								],
								[
									132.74287109375007,
									44.942675781250045
								],
								[
									132.809765625,
									45.05156250000002
								],
								[
									132.80953302719712,
									45.066034444547995
								],
								[
									132.83867187500016,
									45.061132812500006
								],
								[
									132.88876953125003,
									45.04604492187505
								],
								[
									132.93603515625,
									45.02993164062505
								],
								[
									133.01171874999994,
									45.07456054687509
								],
								[
									133.11347656250018,
									45.13071289062498
								],
								[
									133.09687500000018,
									45.22045898437506
								],
								[
									133.11337890625003,
									45.32143554687502
								],
								[
									133.1860351562501,
									45.49482421875007
								],
								[
									133.26699218750002,
									45.54526367187506
								],
								[
									133.3095703125,
									45.553076171875034
								],
								[
									133.3554687500001,
									45.57221679687504
								],
								[
									133.43642578124997,
									45.60468750000007
								],
								[
									133.46562500000016,
									45.65122070312506
								],
								[
									133.44912109374997,
									45.705078125000114
								],
								[
									133.47578125000018,
									45.75766601562498
								],
								[
									133.48466796875005,
									45.81044921875008
								],
								[
									133.51308593750014,
									45.878808593749966
								],
								[
									133.55117187499997,
									45.89780273437512
								],
								[
									133.6080078125002,
									45.92031250000008
								],
								[
									133.64785156249997,
									45.955224609374994
								],
								[
									133.68574218750007,
									46.00893554687511
								],
								[
									133.71113281250018,
									46.069628906250045
								],
								[
									133.70068359375,
									46.13974609375012
								],
								[
									133.7501953125,
									46.18593750000011
								],
								[
									133.8328125,
									46.22426757812511
								],
								[
									133.8613281250001,
									46.2477539062501
								],
								[
									133.87480468750005,
									46.30908203125006
								],
								[
									133.88027343749997,
									46.33603515624995
								],
								[
									133.90273437500014,
									46.36694335937494
								],
								[
									133.88671874999994,
									46.43056640624994
								],
								[
									133.86660156250014,
									46.499121093750034
								],
								[
									133.95751953125,
									46.61425781250006
								],
								[
									134.02265625,
									46.71318359374996
								],
								[
									134.03857421875,
									46.858154296875
								],
								[
									134.0459960937501,
									46.88198242187505
								],
								[
									134.0713867187502,
									46.950781250000034
								],
								[
									134.08642578124994,
									46.97812500000012
								],
								[
									134.1369140625,
									47.068994140624966
								],
								[
									134.2021484375001,
									47.12807617187502
								],
								[
									134.18925781250016,
									47.194238281249994
								],
								[
									134.16298828125014,
									47.25874023437507
								],
								[
									134.16767578125018,
									47.30219726562504
								],
								[
									134.2251953125001,
									47.35263671875012
								],
								[
									134.26005859375,
									47.37773437499999
								],
								[
									134.29082031250005,
									47.41357421875
								],
								[
									134.3394531250002,
									47.42949218749996
								],
								[
									134.38251953125018,
									47.43823242187506
								],
								[
									134.48349609375003,
									47.44736328125006
								],
								[
									134.54189453125014,
									47.48515624999993
								],
								[
									134.59619140625,
									47.52387695312501
								],
								[
									134.69580078124994,
									47.62485351562506
								],
								[
									134.72812500000003,
									47.68447265625005
								],
								[
									134.75234375000002,
									47.71542968749995
								],
								[
									134.69863281249997,
									47.801416015624966
								],
								[
									134.65029296875002,
									47.87426757812506
								],
								[
									134.59130859375,
									47.97519531250012
								],
								[
									134.56601562500003,
									48.022509765625074
								],
								[
									134.60537109375002,
									48.08291015624994
								],
								[
									134.647265625,
									48.120166015625074
								],
								[
									134.66933593749997,
									48.153320312500085
								],
								[
									134.68085937500018,
									48.210449218750085
								],
								[
									134.665234375,
									48.25390625000006
								],
								[
									134.5635742187502,
									48.321728515624926
								],
								[
									134.45615234375003,
									48.35532226562512
								],
								[
									134.3349609375,
									48.368847656249926
								],
								[
									134.29335937500014,
									48.37343750000008
								],
								[
									134.20585937500016,
									48.359912109375074
								],
								[
									133.84218750000014,
									48.2737304687501
								],
								[
									133.67177734375014,
									48.20771484375007
								],
								[
									133.57324218749994,
									48.13300781250001
								],
								[
									133.4683593750001,
									48.09716796875
								],
								[
									133.30117187500014,
									48.1015136718751
								],
								[
									133.1440429687501,
									48.105664062499955
								],
								[
									133.0201171875001,
									48.06440429687507
								],
								[
									132.87714843750018,
									47.97910156250012
								],
								[
									132.77285156250014,
									47.94008789062508
								],
								[
									132.70722656250018,
									47.947265625000114
								],
								[
									132.63691406250018,
									47.89008789062501
								],
								[
									132.56191406249997,
									47.768505859374926
								],
								[
									132.47626953125,
									47.71499023437505
								],
								[
									132.38017578125,
									47.72949218749997
								],
								[
									132.14980468750014,
									47.71796875000001
								],
								[
									131.7852539062502,
									47.680517578125034
								],
								[
									131.5567382812502,
									47.68203125000008
								],
								[
									131.46425781250002,
									47.72260742187507
								],
								[
									131.31933593749994,
									47.72783203124999
								],
								[
									131.12187500000016,
									47.697656249999966
								],
								[
									131.00273437500005,
									47.691455078125045
								],
								[
									130.9619140625,
									47.70932617187495
								],
								[
									130.93281250000018,
									47.75981445312493
								],
								[
									130.91542968750002,
									47.84291992187508
								],
								[
									130.8486328125,
									47.92944335937494
								],
								[
									130.73261718750018,
									48.01923828125004
								],
								[
									130.71210937500018,
									48.1276367187501
								],
								[
									130.7872070312502,
									48.254589843749926
								],
								[
									130.8042968750002,
									48.341503906249955
								],
								[
									130.76347656250016,
									48.388427734375114
								],
								[
									130.74687500000016,
									48.43037109375004
								],
								[
									130.6591796875001,
									48.4833984375
								],
								[
									130.5972656250002,
									48.57465820312504
								],
								[
									130.55214843749997,
									48.602490234374926
								],
								[
									130.56562500000018,
									48.680126953124926
								],
								[
									130.6171875000001,
									48.77319335937497
								],
								[
									130.55312500000002,
									48.861181640625034
								],
								[
									130.35527343750005,
									48.86635742187502
								],
								[
									130.19599609375018,
									48.891650390625045
								],
								[
									130.03710937499994,
									48.972265625000034
								],
								[
									129.79257812500003,
									49.19887695312511
								],
								[
									129.67109375000018,
									49.27851562499998
								],
								[
									129.5914062500002,
									49.286669921875045
								],
								[
									129.53369140625,
									49.32343749999998
								],
								[
									129.4981445312502,
									49.38881835937508
								],
								[
									129.44072265625016,
									49.38945312499993
								],
								[
									129.38466796874997,
									49.38945312499993
								],
								[
									129.35009765624994,
									49.3623535156251
								],
								[
									129.30986328125005,
									49.35385742187506
								],
								[
									129.24843750000014,
									49.37866210937506
								],
								[
									129.1851562500002,
									49.381396484375074
								],
								[
									129.1201171875001,
									49.36206054687494
								],
								[
									129.06513671875018,
									49.37465820312494
								],
								[
									129.0203125,
									49.41923828124996
								],
								[
									128.93828125,
									49.44892578125007
								],
								[
									128.8193359375001,
									49.46376953125005
								],
								[
									128.77031250000016,
									49.49472656249998
								],
								[
									128.7910156250001,
									49.54184570312498
								],
								[
									128.76904296875,
									49.57695312500002
								],
								[
									128.70400390624997,
									49.60014648437496
								],
								[
									128.52675781250002,
									49.59423828125
								],
								[
									128.23710937500016,
									49.55927734374998
								],
								[
									127.99960937500009,
									49.568603515625114
								],
								[
									127.81425781250016,
									49.62211914062499
								],
								[
									127.71113281250001,
									49.67153320312494
								],
								[
									127.69013671875018,
									49.7167480468751
								],
								[
									127.63671874999994,
									49.76020507812507
								],
								[
									127.55078124999994,
									49.8018066406251
								],
								[
									127.50244140624994,
									49.87343750000002
								],
								[
									127.4917968750002,
									49.975048828124955
								],
								[
									127.5123046875002,
									50.07167968750011
								],
								[
									127.59023437499997,
									50.208984375
								],
								[
									127.39531250000016,
									50.29858398437506
								],
								[
									127.33720703125016,
									50.35014648437499
								],
								[
									127.35117187500003,
									50.39360351562496
								],
								[
									127.3408203125,
									50.42807617187506
								],
								[
									127.30605468750002,
									50.453515624999994
								],
								[
									127.3082031250002,
									50.49418945312493
								],
								[
									127.34716796874994,
									50.550097656250045
								],
								[
									127.34687500000007,
									50.621337890625085
								],
								[
									127.30703125000014,
									50.70795898437504
								],
								[
									127.1982421875,
									50.82944335937512
								],
								[
									127.02041015624997,
									50.9858886718751
								],
								[
									126.92480468749994,
									51.10014648437502
								],
								[
									126.91152343750002,
									51.17231445312507
								],
								[
									126.88769531249994,
									51.23012695312494
								],
								[
									126.85439453125002,
									51.261376953124994
								],
								[
									126.83378906250016,
									51.31489257812507
								],
								[
									126.84775390625009,
									51.37416992187505
								],
								[
									126.82734375000018,
									51.41225585937511
								],
								[
									126.80175781250011,
									51.44804687500002
								],
								[
									126.80546875000016,
									51.50566406250002
								],
								[
									126.77451171875009,
									51.54506835937505
								],
								[
									126.70917968750018,
									51.56630859375005
								],
								[
									126.68867187500018,
									51.609912109375045
								],
								[
									126.70078125000009,
									51.70302734375008
								],
								[
									126.65371093749997,
									51.78129882812496
								],
								[
									126.51054687500005,
									51.9258300781251
								],
								[
									126.46806640624999,
									52.0312988281251
								],
								[
									126.45556640625011,
									52.12646484375003
								],
								[
									126.39482421874999,
									52.17299804687508
								],
								[
									126.39150390625014,
									52.21450195312502
								],
								[
									126.38349609375018,
									52.28652343750005
								],
								[
									126.34628906250003,
									52.30625000000006
								],
								[
									126.32421875000011,
									52.33164062500009
								],
								[
									126.34169921875002,
									52.36201171875004
								],
								[
									126.31289062500002,
									52.39975585937509
								],
								[
									126.23759765625005,
									52.44482421875006
								],
								[
									126.20292968750016,
									52.4838378906251
								],
								[
									126.1944335937502,
									52.51914062500009
								],
								[
									126.15664062500014,
									52.546630859375
								],
								[
									126.04589843749994,
									52.573339843750034
								],
								[
									126.01601562500002,
									52.61020507812509
								],
								[
									126.02324218750016,
									52.643017578124926
								],
								[
									126.04707031250001,
									52.67348632812508
								],
								[
									126.0601562500002,
									52.69199218749995
								],
								[
									126.05605468749997,
									52.71586914062493
								],
								[
									126.04814453125016,
									52.73945312500004
								],
								[
									126.00429687500002,
									52.76787109374996
								],
								[
									125.94160156250001,
									52.80068359375008
								],
								[
									125.87187500000005,
									52.87153320312504
								],
								[
									125.7828125000002,
									52.890722656250034
								],
								[
									125.72812500000003,
									52.890722656250034
								],
								[
									125.6807617187502,
									52.93081054687494
								],
								[
									125.69531249999994,
									52.95629882812497
								],
								[
									125.69169921874999,
									53.003710937500045
								],
								[
									125.6490234375002,
									53.042285156250074
								],
								[
									125.59599609375016,
									53.05747070312498
								],
								[
									125.54599609375009,
									53.047607421875114
								],
								[
									125.42246093750003,
									53.083740234375
								],
								[
									125.22558593750011,
									53.16582031250002
								],
								[
									125.07500000000016,
									53.20366210937502
								],
								[
									124.97089843750018,
									53.19731445312496
								],
								[
									124.90664062500014,
									53.1726562500001
								],
								[
									124.88212890624999,
									53.12973632812506
								],
								[
									124.81230468749999,
									53.133837890625074
								],
								[
									124.63984375000001,
									53.210644531249926
								],
								[
									124.46591796875003,
									53.22963867187505
								],
								[
									124.36914062499994,
									53.270947265624955
								],
								[
									124.29140625000002,
									53.34086914062499
								],
								[
									124.21992187500001,
									53.370117187500085
								],
								[
									124.154296875,
									53.358691406250074
								],
								[
									123.99472656250003,
									53.405615234375034
								],
								[
									123.74091796875007,
									53.510986328125
								],
								[
									123.60781250000002,
									53.546533203124966
								],
								[
									123.55976562500018,
									53.5266601562501
								],
								[
									123.53476562500003,
									53.52646484375006
								],
								[
									123.48945312500007,
									53.52944335937502
								],
								[
									123.42402343750007,
									53.53076171874994
								],
								[
									123.30957031250011,
									53.55561523437504
								],
								[
									123.15410156250016,
									53.54458007812511
								],
								[
									122.95761718750009,
									53.497705078124966
								],
								[
									122.74472656250003,
									53.46850585937506
								],
								[
									122.51582031250001,
									53.456982421874926
								],
								[
									122.38017578125005,
									53.46250000000006
								],
								[
									122.33779296875002,
									53.48500976562505
								],
								[
									122.08886718750011,
									53.45146484374996
								],
								[
									121.74394531249999,
									53.38359374999999
								],
								[
									121.40546875000007,
									53.31704101562502
								],
								[
									120.9854492187502,
									53.28457031250005
								],
								[
									120.7041015625,
									53.17182617187501
								],
								[
									120.42128906250002,
									52.968066406250074
								],
								[
									120.21816406250002,
									52.839892578125074
								],
								[
									120.09453125000016,
									52.78720703125009
								],
								[
									120.04433593750014,
									52.71821289062507
								],
								[
									120.06757812500018,
									52.63291015625009
								],
								[
									120.17275390625002,
									52.602490234374926
								],
								[
									120.36005859375007,
									52.627001953125045
								],
								[
									120.5210937500002,
									52.615039062500074
								],
								[
									120.65615234374997,
									52.566650390625
								],
								[
									120.69921874999994,
									52.49360351562504
								],
								[
									120.65039062499994,
									52.39589843749994
								],
								[
									120.66542968750002,
									52.299902343750006
								],
								[
									120.74453125000014,
									52.20546875000005
								],
								[
									120.74980468750016,
									52.09653320312506
								],
								[
									120.68144531250016,
									51.97304687500002
								],
								[
									120.51054687500016,
									51.84853515625008
								],
								[
									120.23701171875001,
									51.72299804687506
								],
								[
									120.06689453125011,
									51.60068359375012
								],
								[
									119.96699218750018,
									51.42211914062497
								],
								[
									119.81318359375001,
									51.2670410156251
								],
								[
									119.75664062500016,
									51.17949218750002
								],
								[
									119.74599609375002,
									51.10771484374996
								],
								[
									119.68496093750002,
									51.03012695312506
								],
								[
									119.57343750000001,
									50.94677734374994
								],
								[
									119.5123046875002,
									50.863134765625034
								],
								[
									119.50175781249999,
									50.77924804687501
								],
								[
									119.44570312500014,
									50.70283203124998
								],
								[
									119.34404296874999,
									50.63388671875006
								],
								[
									119.28066406249997,
									50.560986328124955
								],
								[
									119.255859375,
									50.48417968749993
								],
								[
									119.21669921875002,
									50.43251953125008
								],
								[
									119.16367187500003,
									50.406005859375
								],
								[
									119.19189453125011,
									50.3798339843751
								],
								[
									119.30156250000016,
									50.35390625000005
								],
								[
									119.3462890625002,
									50.27895507812505
								],
								[
									119.32607421874997,
									50.15493164062511
								],
								[
									119.2598632812502,
									50.06640625
								],
								[
									119.14746093750011,
									50.01337890625004
								],
								[
									118.9794921875,
									49.97885742187512
								],
								[
									118.7559570312502,
									49.962841796874955
								],
								[
									118.45156250000002,
									49.844482421875
								],
								[
									118.1866210937502,
									49.692773437499994
								],
								[
									117.87343749999997,
									49.513476562500074
								],
								[
									117.8125976562502,
									49.51352539062506
								],
								[
									117.69843750000007,
									49.5358398437501
								],
								[
									117.47714843750009,
									49.609423828125074
								],
								[
									117.24560546875,
									49.62485351562512
								],
								[
									117.02167968750001,
									49.69296874999995
								],
								[
									116.88896484375016,
									49.73779296875003
								],
								[
									116.68330078125007,
									49.823779296875045
								],
								[
									116.63154296875001,
									49.87705078125006
								],
								[
									116.55117187500008,
									49.920312499999994
								],
								[
									116.35117187500009,
									49.978076171875045
								],
								[
									116.21679687500011,
									50.00927734375
								],
								[
									116.13457031250005,
									50.010791015625045
								],
								[
									115.92597656250007,
									49.952148437500085
								],
								[
									115.79521484374999,
									49.90590820312508
								],
								[
									115.71777343750011,
									49.880615234375085
								],
								[
									115.58798828125003,
									49.88603515625002
								],
								[
									115.42919921875006,
									49.89648437500003
								],
								[
									115.36503906250005,
									49.91176757812502
								],
								[
									115.27451171875003,
									49.94887695312505
								],
								[
									115.09804687500008,
									50.05942382812509
								],
								[
									115.00332031250014,
									50.13857421875005
								],
								[
									114.87958984375018,
									50.18305664062504
								],
								[
									114.7431640625,
									50.233691406250074
								],
								[
									114.67490234375009,
									50.24570312500012
								],
								[
									114.55400390624999,
									50.24145507812506
								],
								[
									114.38632812500015,
									50.25546875000006
								],
								[
									114.29707031250007,
									50.274414062500114
								],
								[
									114.22177734375009,
									50.25727539062498
								],
								[
									114.07070312500014,
									50.20473632812502
								],
								[
									113.88115234375016,
									50.101123046875045
								],
								[
									113.73242187500006,
									50.061523437500085
								],
								[
									113.57421875000006,
									50.00703124999998
								],
								[
									113.44550781250001,
									49.94160156250007
								],
								[
									113.31904296875001,
									49.874316406250045
								],
								[
									113.1641601562502,
									49.797167968750045
								],
								[
									113.09208984375005,
									49.69252929687505
								],
								[
									113.05556640625008,
									49.616259765625045
								],
								[
									112.91484374999999,
									49.569238281249966
								],
								[
									112.80644531250016,
									49.523583984374994
								],
								[
									112.69736328125009,
									49.50727539062504
								],
								[
									112.49492187499999,
									49.53232421875009
								],
								[
									112.37519531250001,
									49.51459960937504
								],
								[
									112.07968750000003,
									49.424218749999994
								],
								[
									111.93447265625014,
									49.416015625000114
								],
								[
									111.83339843750014,
									49.403613281250074
								],
								[
									111.73554687500013,
									49.39775390625002
								],
								[
									111.57480468750015,
									49.37641601562504
								],
								[
									111.51191406250013,
									49.36093750000006
								],
								[
									111.42929687500003,
									49.34262695312506
								],
								[
									111.33662109375007,
									49.35585937500002
								],
								[
									111.20419921875009,
									49.30429687500009
								],
								[
									110.82792968750005,
									49.16616210937511
								],
								[
									110.70976562500005,
									49.14296875000008
								],
								[
									110.63105468750007,
									49.13759765625005
								],
								[
									110.52958984374999,
									49.1870605468751
								],
								[
									110.42783203125003,
									49.21997070312506
								],
								[
									110.32138671875015,
									49.2158691406251
								],
								[
									110.19990234375007,
									49.170410156250085
								],
								[
									109.99453125000014,
									49.20561523437496
								],
								[
									109.75039062500014,
									49.23930664062499
								],
								[
									109.52871093750002,
									49.26987304687509
								],
								[
									109.4537109375002,
									49.29633789062507
								],
								[
									109.23671875000014,
									49.33491210937501
								],
								[
									108.91992187500006,
									49.33535156250011
								],
								[
									108.7330078125002,
									49.33564453124998
								],
								[
									108.61367187500014,
									49.322802734375045
								],
								[
									108.52246093750011,
									49.34150390625001
								],
								[
									108.40693359375007,
									49.39638671875011
								],
								[
									108.21308593750001,
									49.52480468750005
								],
								[
									108.09804687500014,
									49.56264648437505
								],
								[
									108.03378906250009,
									49.59399414062503
								],
								[
									108.00957031250016,
									49.64687500000005
								],
								[
									107.96542968750015,
									49.6535156250001
								],
								[
									107.93671875000007,
									49.69101562500009
								],
								[
									107.93876953125005,
									49.74072265625
								],
								[
									107.93486328125005,
									49.84902343750002
								],
								[
									107.9478515625002,
									49.924707031249994
								],
								[
									107.91660156250015,
									49.947802734375074
								],
								[
									107.78681640625007,
									49.960009765625074
								],
								[
									107.63095703125009,
									49.9831054687501
								],
								[
									107.34707031250008,
									49.986669921875006
								],
								[
									107.23330078125002,
									49.98940429687502
								],
								[
									107.14306640625011,
									50.033007812500045
								],
								[
									107.04023437500001,
									50.0864746093751
								],
								[
									106.94130859375014,
									50.19667968750008
								],
								[
									106.85371093750001,
									50.248291015625114
								],
								[
									106.71113281250001,
									50.31259765624998
								],
								[
									106.57441406250007,
									50.32880859375007
								],
								[
									106.36845703125005,
									50.31757812500001
								],
								[
									106.21787109375009,
									50.30458984375002
								],
								[
									106.08251953125006,
									50.33256835937496
								],
								[
									105.99648437500002,
									50.36791992187506
								],
								[
									105.87519531250018,
									50.405371093750034
								],
								[
									105.69257812500007,
									50.41416015625006
								],
								[
									105.54160156250003,
									50.44125976562506
								],
								[
									105.38359375000005,
									50.473730468750034
								],
								[
									105.2666992187502,
									50.460498046875074
								],
								[
									105.18593750000008,
									50.42958984375011
								],
								[
									105.09472656250006,
									50.38994140625002
								],
								[
									104.97695312500014,
									50.38291015625009
								],
								[
									104.68535156250005,
									50.341845703125074
								],
								[
									104.59638671875007,
									50.31718750000002
								],
								[
									104.46630859375011,
									50.306152343750085
								],
								[
									104.35390625000014,
									50.27529296875011
								],
								[
									104.25996093750007,
									50.21445312500006
								],
								[
									104.1796875,
									50.16943359375003
								],
								[
									104.07871093750009,
									50.15424804687504
								],
								[
									103.95849609375006,
									50.157275390625045
								],
								[
									103.85615234375007,
									50.17182617187498
								],
								[
									103.80263671875008,
									50.17607421874996
								],
								[
									103.72324218750009,
									50.15385742187496
								],
								[
									103.63291015625003,
									50.13857421875005
								],
								[
									103.49628906250001,
									50.16494140625008
								],
								[
									103.42119140624999,
									50.187060546875074
								],
								[
									103.30439453125007,
									50.200292968750006
								],
								[
									103.23378906250002,
									50.26425781250006
								],
								[
									103.16171875000009,
									50.29072265625004
								],
								[
									103.03945312500014,
									50.30063476562512
								],
								[
									102.85966796874999,
									50.333251953125085
								],
								[
									102.76542968750005,
									50.366552734375034
								],
								[
									102.68330078125001,
									50.38715820312507
								],
								[
									102.54628906250002,
									50.46132812500008
								],
								[
									102.46943359375018,
									50.525683593750045
								],
								[
									102.40683593750009,
									50.53618164062496
								],
								[
									102.33642578125,
									50.5442382812501
								],
								[
									102.28837890625016,
									50.58510742187508
								],
								[
									102.28574218750003,
									50.63466796875005
								],
								[
									102.30332031250009,
									50.66552734375003
								],
								[
									102.31660156250001,
									50.71845703125007
								],
								[
									102.27656250000007,
									50.768701171874994
								],
								[
									102.23505859375001,
									50.79121093750004
								],
								[
									102.21503906250001,
									50.82944335937512
								],
								[
									102.22617187500009,
									50.901464843750034
								],
								[
									102.21025390625005,
									50.97431640625004
								],
								[
									102.19453125000001,
									51.05068359375005
								],
								[
									102.15195312500003,
									51.107519531250006
								],
								[
									102.14238281250005,
									51.216064453125
								],
								[
									102.16005859375014,
									51.26083984374998
								],
								[
									102.15566406250002,
									51.31376953125002
								],
								[
									102.11152343750007,
									51.35346679687501
								],
								[
									101.97919921875001,
									51.38222656250002
								],
								[
									101.82119140625008,
									51.42104492187502
								],
								[
									101.57089843750009,
									51.46718750000011
								],
								[
									101.46435546875006,
									51.47148437499999
								],
								[
									101.38125000000008,
									51.45263671874997
								],
								[
									101.30449218750005,
									51.47475585937505
								],
								[
									101.22324218750015,
									51.51328124999998
								],
								[
									101.08535156250002,
									51.553027343750074
								],
								[
									100.90361328125005,
									51.60424804687503
								],
								[
									100.7107421875001,
									51.6615722656251
								],
								[
									100.53623046875003,
									51.71347656250009
								],
								[
									100.46894531250001,
									51.726074218750085
								],
								[
									100.23037109375008,
									51.729833984375034
								],
								[
									100.03457031250008,
									51.73710937500002
								],
								[
									99.92167968749999,
									51.75551757812505
								],
								[
									99.78789062499999,
									51.827539062499966
								],
								[
									99.71923828125006,
									51.871630859375074
								],
								[
									99.61289062500003,
									51.89252929687507
								],
								[
									99.53232421875009,
									51.89990234375006
								],
								[
									99.40703125000005,
									51.92353515624998
								],
								[
									99.17617187500008,
									51.99887695312506
								],
								[
									99.09140625000003,
									52.03486328125001
								],
								[
									99.03427734375003,
									52.03540039062503
								],
								[
									98.95810546875009,
									52.10170898437505
								],
								[
									98.89316406250009,
									52.11728515625012
								],
								[
									98.84863281250006,
									52.070068359375085
								],
								[
									98.8025390625001,
									51.95747070312507
								],
								[
									98.76015625000008,
									51.905078125000045
								],
								[
									98.64052734375014,
									51.80117187500011
								],
								[
									98.35273437500013,
									51.717626953125034
								],
								[
									98.30312500000014,
									51.67426757812501
								],
								[
									98.27685546875011,
									51.6345703125001
								],
								[
									98.23750000000018,
									51.57841796875002
								],
								[
									98.21992187500007,
									51.505615234375114
								],
								[
									98.18466796875003,
									51.485742187499966
								],
								[
									98.10312500000003,
									51.483544921874966
								],
								[
									98.03759765625011,
									51.44995117187506
								],
								[
									97.98916015625002,
									51.377050781250034
								],
								[
									97.94687500000009,
									51.348437500000074
								],
								[
									97.92324218750008,
									51.28046874999998
								],
								[
									97.92734375000015,
									51.25073242187506
								],
								[
									97.91787109375008,
									51.21787109375012
								],
								[
									97.91083984375007,
									51.16518554687502
								],
								[
									97.83574218750005,
									51.051660156249994
								],
								[
									97.82529296875009,
									50.985253906249966
								],
								[
									97.85615234375013,
									50.94335937500006
								],
								[
									97.91982421875002,
									50.88715820312507
								],
								[
									97.95312500000006,
									50.85517578125001
								],
								[
									97.9641601562501,
									50.81767578125002
								],
								[
									97.96191406250006,
									50.76914062500009
								],
								[
									98.00117187500018,
									50.70205078125008
								],
								[
									98.02978515625011,
									50.644628906250034
								],
								[
									98.07890624999999,
									50.603808593750074
								],
								[
									98.14501953125006,
									50.56855468749998
								],
								[
									98.2205078125001,
									50.557177734375074
								],
								[
									98.27949218750013,
									50.53325195312499
								],
								[
									98.29267578125001,
									50.486962890624966
								],
								[
									98.27734375000011,
									50.422998046874994
								],
								[
									98.25029296874999,
									50.30244140625004
								],
								[
									98.20000000000005,
									50.227685546874994
								],
								[
									98.17011718750001,
									50.18056640625008
								],
								[
									98.12197265625008,
									50.10659179687502
								],
								[
									98.10341796875014,
									50.07783203125001
								],
								[
									98.00390625000011,
									50.014257812500034
								],
								[
									97.93662109375003,
									49.99677734375004
								],
								[
									97.85390625000008,
									49.94677734375006
								],
								[
									97.78554687500002,
									49.94453125000004
								],
								[
									97.72070312500006,
									49.944628906250074
								],
								[
									97.65097656250003,
									49.93359375000003
								],
								[
									97.58935546875011,
									49.91147460937506
								],
								[
									97.54082031250005,
									49.84311523437506
								],
								[
									97.41835937500008,
									49.773046875000006
								],
								[
									97.35976562500014,
									49.74145507812497
								],
								[
									97.20859375000009,
									49.73081054687512
								],
								[
									97.13691406250001,
									49.761718750000114
								],
								[
									97.09765625000011,
									49.805029296875034
								],
								[
									97.04912109374999,
									49.829882812500045
								],
								[
									96.98574218750014,
									49.882812500000085
								],
								[
									96.71171874999999,
									49.91157226562498
								],
								[
									96.6402343750002,
									49.89785156250002
								],
								[
									96.59843750000005,
									49.878417968750085
								],
								[
									96.54326171875005,
									49.89252929687501
								],
								[
									96.50576171875014,
									49.918701171875114
								],
								[
									96.46640625000015,
									49.91152343750008
								],
								[
									96.38115234375005,
									49.89604492187502
								],
								[
									96.31503906250009,
									49.901123046875085
								],
								[
									96.22968750000001,
									49.95410156250003
								],
								[
									96.11171875000008,
									49.982470703125045
								],
								[
									96.06552734375009,
									49.99873046874998
								],
								[
									96.01855468750011,
									49.998779296875085
								],
								[
									95.98955078125016,
									49.97358398437501
								],
								[
									95.93574218750013,
									49.960009765625074
								],
								[
									95.8994140625,
									49.990576171875006
								],
								[
									95.85195312500008,
									50.01293945312503
								],
								[
									95.78935546875005,
									50.012500000000045
								],
								[
									95.70781250000005,
									49.96601562500007
								],
								[
									95.56718750000005,
									49.943847656250085
								],
								[
									95.52265625000007,
									49.911230468750006
								],
								[
									95.44179687500002,
									49.915527343750085
								],
								[
									95.38564453125014,
									49.94121093749999
								],
								[
									95.32949218750014,
									49.94414062499996
								],
								[
									95.16621093750007,
									49.943847656250085
								],
								[
									95.11142578125015,
									49.935449218749966
								],
								[
									95.04433593750014,
									49.96157226562505
								],
								[
									95.01289062500001,
									50.00825195312507
								],
								[
									94.93027343750009,
									50.0437500000001
								],
								[
									94.81123046875018,
									50.04819335937512
								],
								[
									94.71806640624999,
									50.04326171874999
								],
								[
									94.67548828125001,
									50.028076171875085
								],
								[
									94.61474609375011,
									50.02373046875002
								],
								[
									94.56464843750001,
									50.087939453125045
								],
								[
									94.49687500000005,
									50.13281250000003
								],
								[
									94.45849609375006,
									50.16572265624998
								],
								[
									94.40019531249999,
									50.17963867187507
								],
								[
									94.35468750000007,
									50.22182617187505
								],
								[
									94.34687500000007,
									50.30341796875007
								],
								[
									94.31933593750006,
									50.404882812500034
								],
								[
									94.28701171875014,
									50.511376953124966
								],
								[
									94.25107421875009,
									50.556396484375085
								],
								[
									94.07578125000009,
									50.57285156250006
								],
								[
									93.98984375000009,
									50.56884765625006
								],
								[
									93.79541015625006,
									50.57763671874997
								],
								[
									93.66201171875008,
									50.58369140625004
								],
								[
									93.62558593750009,
									50.58554687499998
								],
								[
									93.50107421875003,
									50.59746093750002
								],
								[
									93.38681640625003,
									50.608496093750034
								],
								[
									93.27050781250006,
									50.61557617187506
								],
								[
									93.22255859375008,
									50.60654296875009
								],
								[
									93.10312500000009,
									50.603906249999994
								],
								[
									93.00986328125009,
									50.654541015625
								],
								[
									92.97070312500011,
									50.71250000000009
								],
								[
									92.96357421875007,
									50.744921875000045
								],
								[
									92.94130859375014,
									50.77822265625008
								],
								[
									92.85644531250011,
									50.789111328125074
								],
								[
									92.77929687500011,
									50.77866210937498
								],
								[
									92.73867187500008,
									50.71093750000003
								],
								[
									92.68134765625001,
									50.68320312499998
								],
								[
									92.62666015625007,
									50.688281250000045
								],
								[
									92.57890625000005,
									50.72543945312506
								],
								[
									92.48642578125009,
									50.76508789062507
								],
								[
									92.42636718750003,
									50.80307617187498
								],
								[
									92.35478515625005,
									50.86416015625008
								],
								[
									92.29580078125008,
									50.8498046875001
								],
								[
									92.27900390625007,
									50.81220703125007
								],
								[
									92.26533203125013,
									50.775195312500074
								],
								[
									92.1923828125,
									50.700585937499966
								],
								[
									92.10400390625011,
									50.69199218750009
								],
								[
									91.95654296875,
									50.69760742187506
								],
								[
									91.80429687500003,
									50.69360351562497
								],
								[
									91.70634765624999,
									50.66552734375003
								],
								[
									91.63417968750014,
									50.615136718749966
								],
								[
									91.59687500000018,
									50.57553710937506
								],
								[
									91.52167968750001,
									50.562011718750085
								],
								[
									91.44648437500018,
									50.52216796875004
								],
								[
									91.41503906250006,
									50.468017578125114
								],
								[
									91.34082031250006,
									50.47006835937509
								],
								[
									91.30058593750005,
									50.46337890625006
								],
								[
									91.23378906250008,
									50.45239257812503
								],
								[
									91.06279296875005,
									50.422607421875
								],
								[
									91.02158203125009,
									50.41547851562507
								],
								[
									90.91718750000018,
									50.364160156249994
								],
								[
									90.83808593750001,
									50.32373046875003
								],
								[
									90.7607421875,
									50.305957031250045
								],
								[
									90.71435546875006,
									50.25942382812508
								],
								[
									90.65507812500016,
									50.22236328125007
								],
								[
									90.51689453125016,
									50.2133300781251
								],
								[
									90.36484375000009,
									50.16689453125005
								],
								[
									90.31132812499999,
									50.151171875000045
								],
								[
									90.22451171875008,
									50.11669921875003
								],
								[
									90.10371093750018,
									50.103320312500074
								],
								[
									90.05371093750011,
									50.09374999999997
								],
								[
									90.00498046875015,
									50.06928710937507
								],
								[
									89.97734374999999,
									49.98432617187507
								],
								[
									89.87802734375009,
									49.95351562500011
								],
								[
									89.74423828125009,
									49.94809570312506
								],
								[
									89.64384765624999,
									49.90302734375001
								],
								[
									89.63427734375011,
									49.823291015625045
								],
								[
									89.66953125000009,
									49.75048828125003
								],
								[
									89.65410156250016,
									49.71748046875007
								],
								[
									89.57919921875009,
									49.699707031250085
								],
								[
									89.47500000000008,
									49.66054687500011
								],
								[
									89.39560546875003,
									49.61152343750007
								],
								[
									89.29921875000014,
									49.611132812500074
								],
								[
									89.24394531250005,
									49.62705078125012
								],
								[
									89.20292968750005,
									49.59570312500003
								],
								[
									89.17998046874999,
									49.53222656249997
								],
								[
									89.10947265625009,
									49.501367187499994
								],
								[
									89.00839843750003,
									49.47280273437505
								],
								[
									88.97060546875008,
									49.483740234375034
								],
								[
									88.9454101562502,
									49.507666015625034
								],
								[
									88.90019531250005,
									49.53969726562508
								],
								[
									88.86386718750009,
									49.52763671875002
								],
								[
									88.8603515625,
									49.481542968750034
								],
								[
									88.8316406250002,
									49.44843750000004
								],
								[
									88.7478515625001,
									49.44624023437504
								],
								[
									88.68271484375003,
									49.46455078125004
								],
								[
									88.63320312500008,
									49.4861328125001
								],
								[
									88.54433593750002,
									49.48256835937508
								],
								[
									88.45244140625005,
									49.47270507812502
								],
								[
									88.39335937500005,
									49.48286132812504
								],
								[
									88.33779296875014,
									49.47255859375008
								],
								[
									88.19257812500001,
									49.4517089843751
								],
								[
									88.13554687500005,
									49.381494140624994
								],
								[
									88.13427734375006,
									49.298437500000034
								],
								[
									88.11572265625,
									49.25629882812498
								],
								[
									88.02851562500018,
									49.2197753906251
								],
								[
									87.98808593749999,
									49.186914062499966
								],
								[
									87.93476562500018,
									49.16455078125003
								],
								[
									87.81826171875014,
									49.16210937500006
								],
								[
									87.81425781250005,
									49.162304687499926
								],
								[
									87.76250000000016,
									49.16582031249993
								],
								[
									87.66835937499997,
									49.14721679687506
								],
								[
									87.57656250000002,
									49.13237304687496
								],
								[
									87.51582031250018,
									49.12241210937498
								],
								[
									87.47617187500009,
									49.09145507812505
								],
								[
									87.41669921875007,
									49.07661132812507
								],
								[
									87.3228515625002,
									49.08579101562498
								],
								[
									87.29687499999994,
									49.14765625000007
								],
								[
									87.23369140625016,
									49.21616210937498
								],
								[
									87.1480468750002,
									49.239794921875074
								],
								[
									87.07060546875016,
									49.25458984375007
								],
								[
									87.0009765625,
									49.2873046875001
								],
								[
									86.95292968750016,
									49.322070312500074
								],
								[
									86.81210937500009,
									49.487890625000006
								],
								[
									86.71435546874994,
									49.558593750000114
								],
								[
									86.62646484375,
									49.56269531250007
								],
								[
									86.6142578125,
									49.60971679687495
								],
								[
									86.66533203124999,
									49.656689453124926
								],
								[
									86.73066406250018,
									49.69555664062494
								],
								[
									86.72871093750001,
									49.74868164062502
								],
								[
									86.67548828125001,
									49.77729492187498
								],
								[
									86.61015625000016,
									49.76914062500009
								],
								[
									86.52226562500016,
									49.70776367187494
								],
								[
									86.41796874999994,
									49.638476562500045
								],
								[
									86.29238281250014,
									49.587500000000034
								],
								[
									86.24218749999994,
									49.54633789062501
								],
								[
									86.18085937500018,
									49.49931640624993
								],
								[
									86.09296875000001,
									49.505468750000034
								],
								[
									86.02958984375016,
									49.50341796874997
								],
								[
									85.97441406250005,
									49.49931640624993
								],
								[
									85.93359374999994,
									49.55043945312505
								],
								[
									85.88046875000009,
									49.55654296875005
								],
								[
									85.49843750000014,
									49.60537109375005
								],
								[
									85.37158203124994,
									49.62392578125011
								],
								[
									85.29189453124997,
									49.59946289062509
								],
								[
									85.23261718750018,
									49.61582031249995
								],
								[
									85.21015625000001,
									49.66484374999999
								],
								[
									85.13652343750005,
									49.750732421875085
								],
								[
									85.07646484375016,
									49.82163085937506
								],
								[
									85.00078124999999,
									49.89414062500009
								],
								[
									84.9751953125002,
									49.95107421875005
								],
								[
									84.99970703125007,
									50.01030273437502
								],
								[
									84.98945312500018,
									50.061425781249966
								],
								[
									84.92402343750018,
									50.087988281250034
								],
								[
									84.83896484375009,
									50.091308593750114
								],
								[
									84.60732421875014,
									50.202392578125085
								],
								[
									84.49902343750011,
									50.21875000000003
								],
								[
									84.4009765625002,
									50.23916015624994
								],
								[
									84.3232421875,
									50.23916015624994
								],
								[
									84.2578125,
									50.28823242187508
								],
								[
									84.19453125000007,
									50.43745117187501
								],
								[
									84.17597656250018,
									50.520556640625074
								],
								[
									84.09931640625001,
									50.604736328125085
								],
								[
									84.00234374999997,
									50.67685546875012
								],
								[
									83.94511718750016,
									50.77465820312506
								],
								[
									83.85976562499997,
									50.81801757812508
								],
								[
									83.71777343750011,
									50.88715820312507
								],
								[
									83.58144531250014,
									50.93574218750001
								],
								[
									83.35732421875014,
									50.9945800781251
								],
								[
									83.27373046875016,
									50.9945800781251
								],
								[
									83.1602539062502,
									50.98920898437507
								],
								[
									83.09277343749994,
									50.96059570312511
								],
								[
									83.01923828125018,
									50.897265625000074
								],
								[
									82.91904296875009,
									50.89311523437493
								],
								[
									82.7608398437502,
									50.89335937499999
								],
								[
									82.71855468749999,
									50.869482421875006
								],
								[
									82.6929687500002,
									50.82631835937511
								],
								[
									82.61171875000002,
									50.77148437500003
								],
								[
									82.49394531250016,
									50.72758789062496
								],
								[
									82.32636718750007,
									50.74189453125004
								],
								[
									82.21191406250011,
									50.71943359375007
								],
								[
									82.09804687499997,
									50.71083984375002
								],
								[
									81.93369140625009,
									50.76635742187506
								],
								[
									81.7520507812502,
									50.764404296875
								],
								[
									81.6338867187502,
									50.739111328125006
								],
								[
									81.46591796875009,
									50.73984374999998
								],
								[
									81.43144531250016,
									50.77114257812505
								],
								[
									81.45156249999997,
									50.8236816406251
								],
								[
									81.43769531250018,
									50.87104492187507
								],
								[
									81.41015625,
									50.90976562499995
								],
								[
									81.38828125000009,
									50.95649414062507
								],
								[
									81.31914062499999,
									50.96640624999995
								],
								[
									81.12460937500009,
									50.94628906250003
								],
								[
									81.07148437500018,
									50.96875000000006
								],
								[
									81.07753906250002,
									51.014941406250074
								],
								[
									81.11240234375009,
									51.07236328124995
								],
								[
									81.14101562500014,
									51.14658203125006
								],
								[
									81.12724609374999,
									51.19106445312505
								],
								[
									81.02675781250014,
									51.18569335937502
								],
								[
									80.96562500000005,
									51.18979492187498
								],
								[
									80.93408203125,
									51.242773437500034
								],
								[
									80.87734374999997,
									51.2814453125001
								],
								[
									80.8130859375002,
									51.283496093750074
								],
								[
									80.73525390624997,
									51.293408203124955
								],
								[
									80.65048828125003,
									51.27734375000006
								],
								[
									80.60546875000011,
									51.22421874999998
								],
								[
									80.55068359375014,
									51.21660156249993
								],
								[
									80.49101562500016,
									51.20175781250012
								],
								[
									80.44804687499999,
									51.183349609375
								],
								[
									80.4214843750002,
									51.13637695312494
								],
								[
									80.43359375,
									51.09262695312509
								],
								[
									80.45224609375009,
									50.997607421875074
								],
								[
									80.42363281249999,
									50.94628906250003
								],
								[
									80.34521484375011,
									50.91909179687508
								],
								[
									80.27041015625014,
									50.92460937499996
								],
								[
									80.22021484374994,
									50.91176757812511
								],
								[
									80.12724609375005,
									50.858349609374955
								],
								[
									80.08632812500014,
									50.83999023437505
								],
								[
									80.07207031250016,
									50.80727539062502
								],
								[
									80.06591796874994,
									50.75820312500008
								],
								[
									79.98623046874997,
									50.77456054687494
								],
								[
									79.85966796875016,
									50.95546874999994
								],
								[
									79.71640625000009,
									51.16000976562495
								],
								[
									79.5542968750002,
									51.377978515625045
								],
								[
									79.4688476562502,
									51.493115234374955
								],
								[
									79.14873046875016,
									51.86811523437507
								],
								[
									78.99208984375014,
									52.047412109375074
								],
								[
									78.72148437500016,
									52.35703125000009
								],
								[
									78.47548828125014,
									52.63842773437506
								],
								[
									78.19804687499999,
									52.92968749999997
								],
								[
									78.03349609375016,
									53.094970703125085
								],
								[
									77.85996093750003,
									53.26918945312505
								],
								[
									77.79941406250009,
									53.3174316406251
								],
								[
									77.70439453125016,
									53.37915039062497
								],
								[
									77.46923828124994,
									53.498779296875
								],
								[
									77.13242187500009,
									53.67011718750001
								],
								[
									76.82070312499997,
									53.822656249999994
								],
								[
									76.57568359375,
									53.942529296874994
								],
								[
									76.51308593750014,
									53.99321289062502
								],
								[
									76.48476562500014,
									54.02255859374995
								],
								[
									76.4585937500002,
									54.055273437500034
								],
								[
									76.42207031250007,
									54.113525390625114
								],
								[
									76.42167968750016,
									54.15151367187494
								],
								[
									76.65458984375016,
									54.145263671875085
								],
								[
									76.70302734374997,
									54.18247070312512
								],
								[
									76.78896484375002,
									54.321875000000006
								],
								[
									76.83730468749997,
									54.44238281250003
								],
								[
									76.7593750000002,
									54.43686523437498
								],
								[
									76.61552734375005,
									54.387109374999966
								],
								[
									76.5391601562502,
									54.35107421875
								],
								[
									76.49648437500002,
									54.33569335937497
								],
								[
									76.2666015625,
									54.31196289062504
								],
								[
									76.14052734374997,
									54.25854492187506
								],
								[
									75.88066406250016,
									54.16796875
								],
								[
									75.69287109375,
									54.1147949218751
								],
								[
									75.65683593750003,
									54.10600585937499
								],
								[
									75.43720703125001,
									54.089648437500045
								],
								[
									75.39814453125018,
									54.06850585937508
								],
								[
									75.39238281250016,
									54.02172851562506
								],
								[
									75.37705078125003,
									53.97011718750002
								],
								[
									75.22021484375,
									53.893798828125114
								],
								[
									75.05214843750002,
									53.82670898437493
								],
								[
									74.98896484375001,
									53.81923828125011
								],
								[
									74.88681640625009,
									53.8340332031251
								],
								[
									74.83417968750001,
									53.825683593750085
								],
								[
									74.68144531250016,
									53.75439453124994
								],
								[
									74.45195312500016,
									53.647265625000045
								],
								[
									74.43046875000005,
									53.60371093750007
								],
								[
									74.42929687500003,
									53.550732421874926
								],
								[
									74.40273437500014,
									53.5044433593751
								],
								[
									74.35156250000011,
									53.487646484375034
								],
								[
									74.27734375000011,
									53.52773437500005
								],
								[
									74.20996093749994,
									53.57646484374993
								],
								[
									74.06865234375005,
									53.61142578124995
								],
								[
									73.85898437500003,
									53.61972656249995
								],
								[
									73.73115234375018,
									53.60278320312506
								],
								[
									73.64296874999997,
									53.57626953124998
								],
								[
									73.46992187500018,
									53.46889648437505
								],
								[
									73.40693359375007,
									53.44755859374996
								],
								[
									73.37187499999999,
									53.45439453124993
								],
								[
									73.36191406250003,
									53.506201171875006
								],
								[
									73.32685546875018,
									53.54316406249998
								],
								[
									73.28574218750003,
									53.59838867187506
								],
								[
									73.30566406250011,
									53.707226562499926
								],
								[
									73.39941406250011,
									53.81147460937504
								],
								[
									73.55419921875011,
									53.868310546874966
								],
								[
									73.67890625000001,
									53.929443359375085
								],
								[
									73.71552734375001,
									53.99619140625009
								],
								[
									73.71240234375011,
									54.042382812499994
								],
								[
									73.66640625000014,
									54.06347656249994
								],
								[
									73.61796875000016,
									54.06738281250003
								],
								[
									73.58994140625003,
									54.04497070312499
								],
								[
									73.50566406249999,
									53.99931640625002
								],
								[
									73.38066406250005,
									53.962841796874955
								],
								[
									73.27656250000001,
									53.95561523437499
								],
								[
									73.22988281250014,
									53.957812500000074
								],
								[
									73.11933593750018,
									53.98076171874996
								],
								[
									72.9140625,
									54.107324218749994
								],
								[
									72.74101562499999,
									54.12451171874994
								],
								[
									72.62226562500007,
									54.13432617187499
								],
								[
									72.58271484375018,
									54.12158203125006
								],
								[
									72.56425781250016,
									54.09042968750009
								],
								[
									72.57558593750014,
									54.056494140625034
								],
								[
									72.59921875000009,
									54.02304687500006
								],
								[
									72.58593750000011,
									53.99594726562495
								],
								[
									72.53027343749994,
									53.975781249999926
								],
								[
									72.44677734375011,
									53.94184570312504
								],
								[
									72.40429687499994,
									53.96445312500012
								],
								[
									72.38300781250018,
									54.05366210937498
								],
								[
									72.38730468750003,
									54.123046875
								],
								[
									72.32949218750002,
									54.18144531249999
								],
								[
									72.26914062500003,
									54.272119140624994
								],
								[
									72.18603515625011,
									54.32563476562507
								],
								[
									72.10537109375002,
									54.30844726562512
								],
								[
									72.06562500000018,
									54.23164062500001
								],
								[
									72.00449218750003,
									54.20566406249995
								],
								[
									71.88740234375018,
									54.221484375000074
								],
								[
									71.67714843749997,
									54.1780273437501
								],
								[
									71.33642578125011,
									54.158349609374994
								],
								[
									71.09316406250014,
									54.212207031250045
								],
								[
									71.05273437499994,
									54.26049804687503
								],
								[
									71.15214843750016,
									54.364062500000074
								],
								[
									71.15976562500009,
									54.455419921875034
								],
								[
									71.15917968749994,
									54.53862304687493
								],
								[
									71.18554687500011,
									54.59931640625004
								],
								[
									71.12626953124999,
									54.71503906249998
								],
								[
									70.99179687500009,
									54.95048828124999
								],
								[
									70.91015624999994,
									55.1279785156251
								],
								[
									70.79033203125016,
									55.26113281250005
								],
								[
									70.73808593750016,
									55.30517578125006
								],
								[
									70.48632812500011,
									55.28237304687502
								],
								[
									70.41718750000007,
									55.253173828125114
								],
								[
									70.37148437499997,
									55.212255859375034
								],
								[
									70.29335937499997,
									55.18359375000006
								],
								[
									70.18242187500005,
									55.162451171875006
								],
								[
									70.08740234375011,
									55.176757812500085
								],
								[
									69.98173828125016,
									55.199072265625006
								],
								[
									69.87021484375009,
									55.245654296875074
								],
								[
									69.740234375,
									55.30737304687506
								],
								[
									69.49326171875003,
									55.35688476562501
								],
								[
									69.24697265625014,
									55.3725097656251
								],
								[
									68.97724609375018,
									55.389599609374926
								],
								[
									68.84296875000018,
									55.358349609374955
								],
								[
									68.71289062499994,
									55.30849609375011
								],
								[
									68.52480468750002,
									55.20483398437494
								],
								[
									68.43847656250011,
									55.19443359374995
								],
								[
									68.30195312500018,
									55.18652343749994
								],
								[
									68.20625000000001,
									55.160937500000045
								],
								[
									68.22529296875018,
									55.115234375000085
								],
								[
									68.24404296875002,
									55.05244140624998
								],
								[
									68.20937500000014,
									55.00302734374995
								],
								[
									68.15585937500009,
									54.97670898437511
								],
								[
									68.07382812500003,
									54.95957031249998
								],
								[
									67.93994140624994,
									54.953710937500034
								],
								[
									67.82988281249999,
									54.9435546875001
								],
								[
									67.693359375,
									54.87241210937506
								],
								[
									67.48466796875005,
									54.85449218749997
								],
								[
									67.25732421875,
									54.82880859374998
								],
								[
									67.09833984375018,
									54.78818359375006
								],
								[
									66.75449218750003,
									54.73789062500012
								],
								[
									66.55537109375007,
									54.71542968749998
								],
								[
									66.22265624999994,
									54.66738281250005
								],
								[
									65.95468750000009,
									54.659521484375034
								],
								[
									65.91425781250018,
									54.6933105468751
								],
								[
									65.70781250000016,
									54.61870117187499
								],
								[
									65.47695312500002,
									54.62329101562494
								],
								[
									65.43437500000005,
									54.593310546875045
								],
								[
									65.37812500000001,
									54.56445312500003
								],
								[
									65.31591796874994,
									54.55156249999999
								],
								[
									65.23740234375003,
									54.516064453124955
								],
								[
									65.19218750000016,
									54.441113281249955
								],
								[
									65.15781250000009,
									54.364404296874966
								],
								[
									65.08837890625,
									54.340185546875006
								],
								[
									64.99541015625005,
									54.36875000000006
								],
								[
									64.92675781250011,
									54.39663085937505
								],
								[
									64.80927734375007,
									54.36855468750011
								],
								[
									64.64990234375,
									54.35224609375007
								],
								[
									64.52509765625007,
									54.36215820312495
								],
								[
									64.46123046874999,
									54.384179687499994
								],
								[
									64.19941406250007,
									54.34741210937506
								],
								[
									64.06289062500014,
									54.30292968750004
								],
								[
									64.03740234374999,
									54.27973632812504
								],
								[
									64.00390625000011,
									54.26708984374994
								],
								[
									63.847070312500136,
									54.23647460937511
								],
								[
									63.72119140625,
									54.24501953125008
								],
								[
									63.70136718750001,
									54.24321289062496
								],
								[
									63.58203124999994,
									54.22192382812506
								],
								[
									63.413671875000034,
									54.18320312500009
								],
								[
									63.29267578125018,
									54.170458984375074
								],
								[
									63.191308593750136,
									54.17104492187511
								],
								[
									63.12656250000009,
									54.13925781250009
								],
								[
									63.07392578125018,
									54.105224609375085
								],
								[
									62.63271484375002,
									54.06928710937507
								],
								[
									62.58828125000002,
									54.04443359374997
								],
								[
									62.499023437500114,
									54.01318359375
								],
								[
									62.04023437500018,
									54.00263671874998
								],
								[
									62.00234375000002,
									53.97993164062507
								],
								[
									61.98564453125016,
									53.95439453125002
								],
								[
									61.928710937500114,
									53.9464843750001
								],
								[
									61.59814453125,
									53.9949218750001
								],
								[
									61.33369140625001,
									54.04926757812507
								],
								[
									61.23105468750009,
									54.01948242187504
								],
								[
									61.14375000000007,
									53.96381835937507
								],
								[
									61.113183593750136,
									53.88247070312511
								],
								[
									61.113183593750136,
									53.81298828125006
								],
								[
									61.113183593750136,
									53.75346679687493
								],
								[
									61.07353515625016,
									53.71044921875006
								],
								[
									60.98554687500018,
									53.6574218750001
								],
								[
									60.9794921875,
									53.62172851562511
								],
								[
									61.09853515625002,
									53.58310546874995
								],
								[
									61.247949218749966,
									53.55097656249998
								],
								[
									61.33613281250018,
									53.56518554687494
								],
								[
									61.409960937500045,
									53.58706054687505
								],
								[
									61.47412109374994,
									53.5802734375001
								],
								[
									61.51914062500009,
									53.55449218749999
								],
								[
									61.53496093749999,
									53.52329101562512
								],
								[
									61.52656250000018,
									53.50156249999995
								],
								[
									61.49853515624994,
									53.484667968750074
								],
								[
									61.400976562500034,
									53.45581054687506
								],
								[
									61.31162109375009,
									53.46572265625002
								],
								[
									61.22890625000002,
									53.44589843749998
								],
								[
									61.185937500000136,
									53.40620117187507
								],
								[
									61.16279296875001,
									53.33676757812495
								],
								[
									61.19921875,
									53.287158203125045
								],
								[
									61.31093750000002,
									53.27519531249993
								],
								[
									61.43681640625016,
									53.23940429687511
								],
								[
									61.57617187499994,
									53.22246093749993
								],
								[
									61.65986328125007,
									53.2284667968751
								],
								[
									61.766210937500034,
									53.17392578125009
								],
								[
									62.014648437500114,
									53.10786132812504
								],
								[
									62.08105468749994,
									53.057421875000074
								],
								[
									62.08271484375001,
									53.005419921875045
								],
								[
									62.037109375,
									52.96611328124993
								],
								[
									61.974218750000034,
									52.943749999999994
								],
								[
									61.88857421875002,
									52.95590820312506
								],
								[
									61.71933593750009,
									52.96938476562508
								],
								[
									61.533593749999966,
									52.97851562499997
								],
								[
									61.400781250000136,
									52.99599609375008
								],
								[
									61.206933593750136,
									52.98906249999999
								],
								[
									61.04746093750009,
									52.972460937500074
								],
								[
									61.00654296875018,
									52.933349609375085
								],
								[
									60.94472656250002,
									52.86015624999993
								],
								[
									60.89326171875018,
									52.81943359374998
								],
								[
									60.802343750000034,
									52.74472656249995
								],
								[
									60.77441406249994,
									52.67578125000003
								],
								[
									60.821289062500114,
									52.56982421875003
								],
								[
									60.9794921875,
									52.39477539062497
								],
								[
									60.994531250000136,
									52.33686523437507
								],
								[
									60.93759765625009,
									52.280566406250074
								],
								[
									60.828417968750045,
									52.23339843750006
								],
								[
									60.670312499999966,
									52.150830078124926
								],
								[
									60.49931640625016,
									52.14633789062509
								],
								[
									60.42548828125018,
									52.12558593750012
								],
								[
									60.233691406250045,
									52.02451171874995
								],
								[
									60.065527343750034,
									51.97646484375002
								],
								[
									60.03027343749994,
									51.93325195312511
								],
								[
									60.06748046875009,
									51.89062499999994
								],
								[
									60.280371093750034,
									51.83461914062508
								],
								[
									60.38749999999999,
									51.77299804687496
								],
								[
									60.418359374999966,
									51.7039062500001
								],
								[
									60.46474609375002,
									51.6511718750001
								],
								[
									60.630371093750114,
									51.61694335937506
								],
								[
									60.973535156250136,
									51.53706054687504
								],
								[
									60.99335937500007,
									51.52871093750002
								],
								[
									61.01484375000018,
									51.49238281249998
								],
								[
									61.36308593750016,
									51.44189453125
								],
								[
									61.41132812500001,
									51.41474609374998
								],
								[
									61.554687500000114,
									51.32460937500008
								],
								[
									61.58505859375009,
									51.22968750000004
								],
								[
									61.51220703125,
									51.137011718750074
								],
								[
									61.46503906250007,
									50.990234375
								],
								[
									61.389453125000045,
									50.86103515625007
								],
								[
									61.226855468750045,
									50.774804687499994
								],
								[
									60.942285156250136,
									50.6955078125001
								],
								[
									60.63798828125016,
									50.66372070312511
								],
								[
									60.50849609375007,
									50.66918945312497
								],
								[
									60.42480468749994,
									50.679150390624955
								],
								[
									60.288085937500114,
									50.70415039062499
								],
								[
									60.18671875000007,
									50.76977539062494
								],
								[
									60.112109375000045,
									50.83417968750001
								],
								[
									60.05859374999994,
									50.85029296875001
								],
								[
									60.005273437500136,
									50.83969726562498
								],
								[
									59.955175781250034,
									50.7992675781251
								],
								[
									59.88779296875009,
									50.690185546875085
								],
								[
									59.812402343749966,
									50.58203124999997
								],
								[
									59.75117187500001,
									50.54394531249994
								],
								[
									59.523046875000034,
									50.492871093749926
								],
								[
									59.497851562500045,
									50.51108398437509
								],
								[
									59.523925781250114,
									50.58281249999996
								],
								[
									59.495117187500114,
									50.604296875000074
								],
								[
									59.45234375000018,
									50.620410156250074
								],
								[
									59.17089843749994,
									50.64790039062498
								],
								[
									59.06435546875002,
									50.66821289062494
								],
								[
									58.98486328125,
									50.67612304687506
								],
								[
									58.883691406250136,
									50.69443359375006
								],
								[
									58.81406250000009,
									50.737207031249966
								],
								[
									58.664550781250114,
									50.86831054687502
								],
								[
									58.547460937500034,
									50.971044921875006
								],
								[
									58.35917968750016,
									51.06381835937506
								],
								[
									58.188476562500114,
									51.0817382812501
								],
								[
									58.174707031250136,
									51.072265625000114
								],
								[
									58.04511718750018,
									51.06884765624994
								],
								[
									57.838867187500114,
									51.09165039062506
								],
								[
									57.828906250000045,
									51.089013671874966
								],
								[
									57.76484375000001,
									51.046875
								],
								[
									57.71699218750007,
									50.98095703125006
								],
								[
									57.65380859374994,
									50.92514648437498
								],
								[
									57.55781250000001,
									50.89555664062499
								],
								[
									57.44218749999999,
									50.888867187499955
								],
								[
									57.3125,
									50.946533203125085
								],
								[
									57.17900390625016,
									51.03603515625011
								],
								[
									57.01171875,
									51.065185546875
								],
								[
									56.849609375,
									51.045556640624994
								],
								[
									56.79033203124999,
									51.03159179687509
								],
								[
									56.62021484375009,
									50.98085937500005
								],
								[
									56.56689453124994,
									51.00449218749998
								],
								[
									56.49140625000001,
									51.01953125000003
								],
								[
									56.32558593750002,
									50.93608398437499
								],
								[
									56.143945312500136,
									50.84462890625011
								],
								[
									56.1044921875,
									50.77626953124994
								],
								[
									56.04970703125002,
									50.71352539062494
								],
								[
									55.92919921875,
									50.65375976562501
								],
								[
									55.79765624999999,
									50.60205078124997
								],
								[
									55.68623046875001,
									50.58286132812506
								],
								[
									55.542285156250045,
									50.601806640625085
								],
								[
									55.36113281250016,
									50.66528320312497
								],
								[
									55.19521484375002,
									50.74472656250009
								],
								[
									55.01484375000001,
									50.86977539062508
								],
								[
									54.86796875000016,
									50.9413574218751
								],
								[
									54.727148437500034,
									50.9980957031251
								],
								[
									54.641601562500114,
									51.01157226562509
								],
								[
									54.57294921875018,
									50.990234375
								],
								[
									54.54609375000001,
									50.94604492187497
								],
								[
									54.56562500000018,
									50.911279296874994
								],
								[
									54.606250000000045,
									50.879882812500085
								],
								[
									54.63789062500018,
									50.78105468749993
								],
								[
									54.650000000000034,
									50.660156250000085
								],
								[
									54.636132812499966,
									50.591601562500074
								],
								[
									54.596191406250114,
									50.55068359375008
								],
								[
									54.555273437500034,
									50.535791015624966
								],
								[
									54.517382812500045,
									50.541162109374994
								],
								[
									54.47148437499999,
									50.583789062500074
								],
								[
									54.44335937499994,
									50.673925781250034
								],
								[
									54.421484375000034,
									50.78032226562496
								],
								[
									54.2978515625,
									50.91406249999994
								],
								[
									54.19111328125018,
									50.99570312500006
								],
								[
									54.139746093750034,
									51.040771484375
								],
								[
									54.04150390625,
									51.11518554687507
								],
								[
									53.95683593750016,
									51.16118164062502
								],
								[
									53.77646484375009,
									51.21372070312506
								],
								[
									53.688085937500034,
									51.251806640625006
								],
								[
									53.534667968750114,
									51.399560546874994
								],
								[
									53.448632812499966,
									51.44453125000001
								],
								[
									53.33808593750001,
									51.48237304687507
								],
								[
									53.24726562500018,
									51.49360351562507
								],
								[
									53.227343750000045,
									51.48496093750006
								],
								[
									53.03837890625016,
									51.463720703125006
								],
								[
									52.90263671875016,
									51.46694335937505
								],
								[
									52.82050781250018,
									51.49458007812507
								],
								[
									52.73505859375018,
									51.497900390625034
								],
								[
									52.728125000000034,
									51.498144531250006
								],
								[
									52.63515625000002,
									51.479541015625045
								],
								[
									52.61777343750009,
									51.48076171874993
								],
								[
									52.571191406250136,
									51.481640624999926
								],
								[
									52.496191406250034,
									51.512158203124926
								],
								[
									52.42304687500007,
									51.59423828125006
								],
								[
									52.33105468749994,
									51.68129882812502
								],
								[
									52.219140624999966,
									51.709374999999966
								],
								[
									52.007128906250045,
									51.67270507812495
								],
								[
									51.775390625,
									51.554248046875074
								],
								[
									51.60908203125001,
									51.48398437500006
								],
								[
									51.473437500000045,
									51.482031250000006
								],
								[
									51.39599609374994,
									51.47128906249995
								],
								[
									51.34453125000016,
									51.47534179687506
								],
								[
									51.30107421874999,
									51.49741210937495
								],
								[
									51.29072265625001,
									51.54018554687505
								],
								[
									51.269921875000136,
									51.594482421875
								],
								[
									51.163476562500136,
									51.64746093750006
								],
								[
									51.017871093750045,
									51.681640625
								],
								[
									50.882421875000034,
									51.71918945312501
								],
								[
									50.7939453125,
									51.72919921875001
								],
								[
									50.75615234374999,
									51.675146484375006
								],
								[
									50.643945312500136,
									51.58916015624999
								],
								[
									50.51630859375018,
									51.505615234375114
								],
								[
									50.35371093750018,
									51.369726562500034
								],
								[
									50.30927734375018,
									51.3215820312501
								],
								[
									50.24687500000016,
									51.289501953124955
								],
								[
									50.10488281250002,
									51.25458984375004
								],
								[
									49.93232421875001,
									51.19716796875005
								],
								[
									49.822265625,
									51.131884765625074
								],
								[
									49.66630859374999,
									51.102294921875085
								],
								[
									49.498046875000114,
									51.08359375000012
								],
								[
									49.42460937500016,
									51.02700195312502
								],
								[
									49.379492187500034,
									50.93466796875006
								],
								[
									49.32343750000007,
									50.85170898437494
								],
								[
									49.058691406250034,
									50.726074218750114
								],
								[
									48.91376953125018,
									50.64458007812493
								],
								[
									48.808398437500045,
									50.601318359375
								],
								[
									48.734765625000136,
									50.60688476562507
								],
								[
									48.655175781249966,
									50.61987304687506
								],
								[
									48.62509765625009,
									50.61269531250011
								],
								[
									48.666015625,
									50.5503417968751
								],
								[
									48.70048828125016,
									50.353759765625114
								],
								[
									48.74941406250002,
									50.22846679687507
								],
								[
									48.78476562500009,
									50.156445312499955
								],
								[
									48.817968750000034,
									50.09985351562497
								],
								[
									48.843261718750114,
									50.01313476562498
								],
								[
									48.81025390625007,
									49.96240234375003
								],
								[
									48.75898437500018,
									49.92832031250012
								],
								[
									48.600000000000136,
									49.87470703125004
								],
								[
									48.43427734375001,
									49.82851562499994
								],
								[
									48.334960937500114,
									49.85825195312506
								],
								[
									48.22480468750007,
									49.93193359374996
								],
								[
									48.18134765625018,
									49.97001953124999
								],
								[
									48.06074218750001,
									50.09360351562495
								],
								[
									47.849609375000114,
									50.28232421875012
								],
								[
									47.70576171875018,
									50.377978515625074
								],
								[
									47.59960937499994,
									50.41357421874994
								],
								[
									47.50361328125007,
									50.40273437500005
								],
								[
									47.42919921875,
									50.357958984375074
								],
								[
									47.376367187500136,
									50.31811523437494
								],
								[
									47.32646484374999,
									50.273535156250006
								],
								[
									47.294726562500045,
									50.217480468749955
								],
								[
									47.29765624999999,
									50.140234375000034
								],
								[
									47.295214843750045,
									50.05849609375008
								],
								[
									47.24833984374999,
									50.00087890625005
								],
								[
									47.12958984375007,
									49.93906250000009
								],
								[
									46.99199218749999,
									49.85273437500007
								],
								[
									46.88955078125002,
									49.69697265625007
								],
								[
									46.823144531250136,
									49.502246093750074
								],
								[
									46.802050781250045,
									49.367089843749994
								],
								[
									46.85292968750002,
									49.303857421874994
								],
								[
									46.953417968750045,
									49.25258789062494
								],
								[
									47.01816406250009,
									49.199902343749955
								],
								[
									47.031347656250034,
									49.150292968749966
								],
								[
									47.01425781250009,
									49.098339843749955
								],
								[
									46.96220703125016,
									49.038330078125085
								],
								[
									46.85292968750002,
									48.96962890624994
								],
								[
									46.702636718750114,
									48.805566406249994
								],
								[
									46.60917968750016,
									48.57387695312505
								],
								[
									46.66093750000016,
									48.41225585937508
								],
								[
									46.853125000000034,
									48.32358398437495
								],
								[
									47.00429687500002,
									48.284472656250074
								],
								[
									47.06464843750007,
									48.232470703125045
								],
								[
									47.119042968750136,
									48.127001953125045
								],
								[
									47.11152343750018,
									48.020117187500034
								],
								[
									47.093261718750114,
									47.947705078124926
								],
								[
									47.130761718750136,
									47.876757812500045
								],
								[
									47.202050781249966,
									47.792480468750114
								],
								[
									47.29238281250002,
									47.74091796875007
								],
								[
									47.387304687500034,
									47.768652343750034
								],
								[
									47.48193359375,
									47.80390625000004
								],
								[
									47.60019531250009,
									47.789990234374955
								],
								[
									47.934667968750034,
									47.76069335937501
								],
								[
									48.109960937500034,
									47.74541015624993
								],
								[
									48.166992187500114,
									47.70878906249993
								],
								[
									48.275683593750045,
									47.58994140625006
								],
								[
									48.41308593749994,
									47.456494140624955
								],
								[
									48.552539062500045,
									47.32099609375007
								],
								[
									48.60068359375009,
									47.262304687500006
								],
								[
									48.71435546874994,
									47.100488281249994
								],
								[
									48.83183593749999,
									46.954931640625006
								],
								[
									48.959375000000136,
									46.77460937500004
								],
								[
									48.95029296875009,
									46.72578125000004
								],
								[
									48.88359375000016,
									46.70541992187498
								],
								[
									48.7763671875,
									46.71035156250008
								],
								[
									48.69355468750018,
									46.73681640624997
								],
								[
									48.647070312500034,
									46.758691406249994
								],
								[
									48.605273437500045,
									46.765917968750045
								],
								[
									48.55839843750016,
									46.75712890625002
								],
								[
									48.51855468749994,
									46.7343261718751
								],
								[
									48.502343750000136,
									46.69863281250011
								],
								[
									48.50917968750002,
									46.649951171875045
								],
								[
									48.54121093750007,
									46.60561523437508
								],
								[
									48.586035156250034,
									46.57709960937504
								],
								[
									48.61015625000016,
									46.566455078125074
								],
								[
									48.77431640625002,
									46.50795898437508
								],
								[
									48.958984375,
									46.442138671875085
								],
								[
									49.18427734375007,
									46.34882812499998
								],
								[
									49.23222656250016,
									46.337158203125
								],
								[
									49.24589843750016,
									46.291601562500034
								],
								[
									49.12548828124994,
									46.281738281250085
								],
								[
									49.11064453125016,
									46.22846679687507
								],
								[
									49.079589843750114,
									46.18920898437497
								],
								[
									48.809960937499966,
									46.10048828125011
								],
								[
									48.742578125000136,
									46.10073242187505
								],
								[
									48.683691406250034,
									46.08618164062494
								],
								[
									48.68730468750016,
									46.02875976562507
								],
								[
									48.70341796875016,
									45.97622070312511
								],
								[
									48.749609375000034,
									45.92055664062505
								],
								[
									48.729589843750034,
									45.89682617187509
								],
								[
									48.68964843750018,
									45.88886718750007
								],
								[
									48.63740234375018,
									45.90576171875006
								],
								[
									48.58906250000001,
									45.93486328124993
								],
								[
									48.53730468750007,
									45.942138671875085
								],
								[
									48.48701171875018,
									45.93486328124993
								],
								[
									48.25761718749999,
									45.7777832031251
								],
								[
									48.159179687500114,
									45.73701171875004
								],
								[
									48.052832031250034,
									45.720996093750074
								],
								[
									47.830175781250034,
									45.66303710937507
								],
								[
									47.76396484375016,
									45.665966796874955
								],
								[
									47.701074218750136,
									45.68618164062508
								],
								[
									47.649804687499966,
									45.65673828125003
								],
								[
									47.63330078125,
									45.58403320312496
								],
								[
									47.57402343749999,
									45.63427734375006
								],
								[
									47.508398437500034,
									45.67416992187512
								],
								[
									47.479394531249966,
									45.687597656250006
								],
								[
									47.46328125000002,
									45.679687500000085
								],
								[
									47.52421875000016,
									45.60170898437511
								],
								[
									47.52949218750018,
									45.53022460937501
								],
								[
									47.514550781250136,
									45.4909179687501
								],
								[
									47.48867187500002,
									45.45507812499997
								],
								[
									47.454492187499966,
									45.433056640624926
								],
								[
									47.4130859375,
									45.421044921874966
								],
								[
									47.39111328124994,
									45.294775390625006
								],
								[
									47.35126953125018,
									45.21772460937504
								],
								[
									47.29619140625016,
									45.149462890625074
								],
								[
									47.221484375000045,
									45.02426757812506
								],
								[
									47.161523437499966,
									44.96962890625002
								],
								[
									47.11474609374994,
									44.905957031249926
								],
								[
									47.08378906250016,
									44.816992187500006
								],
								[
									47.03925781250001,
									44.837890625
								],
								[
									47.002929687500114,
									44.87607421875006
								],
								[
									46.98369140625016,
									44.82558593750008
								],
								[
									46.957421875000136,
									44.78256835937509
								],
								[
									46.84121093750002,
									44.71826171874997
								],
								[
									46.75527343750002,
									44.6565429687501
								],
								[
									46.71611328124999,
									44.56069335937502
								],
								[
									46.70722656250018,
									44.503320312499966
								],
								[
									46.72089843750018,
									44.451660156250114
								],
								[
									46.75302734375009,
									44.420654296875
								],
								[
									46.91572265625018,
									44.387158203124926
								],
								[
									47.02363281250007,
									44.34326171875006
								],
								[
									47.122656250000034,
									44.26166992187504
								],
								[
									47.229882812500136,
									44.19238281249994
								],
								[
									47.307031250000136,
									44.10312500000006
								],
								[
									47.36152343750007,
									43.99335937500007
								],
								[
									47.42919921875,
									43.77988281250012
								],
								[
									47.462792968749966,
									43.55502929687495
								],
								[
									47.56259765625009,
									43.83466796875007
								],
								[
									47.646484375000114,
									43.88461914062495
								],
								[
									47.627832031250136,
									43.8059570312501
								],
								[
									47.56796875000009,
									43.68496093750005
								],
								[
									47.50898437500018,
									43.509716796874955
								],
								[
									47.48984375000009,
									43.38168945312509
								],
								[
									47.511621093749966,
									43.27075195312494
								],
								[
									47.51289062500018,
									43.218750000000114
								],
								[
									47.46318359375016,
									43.03505859375008
								],
								[
									47.488867187500034,
									42.999755859375085
								],
								[
									47.52900390625007,
									42.96713867187509
								],
								[
									47.634863281250034,
									42.903466796874994
								],
								[
									47.70908203125009,
									42.81093750000005
								],
								[
									47.72773437500007,
									42.6807128906251
								],
								[
									47.76972656250018,
									42.64477539062506
								],
								[
									47.822363281250034,
									42.61347656249998
								],
								[
									48.08017578125009,
									42.3537109375001
								],
								[
									48.228613281250034,
									42.180957031250074
								],
								[
									48.30302734374999,
									42.080224609374966
								],
								[
									48.383789062500114,
									41.953417968750074
								],
								[
									48.42636718750009,
									41.92397460937502
								],
								[
									48.47675781250007,
									41.90512695312509
								],
								[
									48.57285156250009,
									41.844482421875085
								],
								[
									48.51865234375009,
									41.779345703125045
								],
								[
									48.4306640625,
									41.66333007812494
								],
								[
									48.39140625000016,
									41.60190429687495
								],
								[
									48.29814453124999,
									41.54501953125009
								],
								[
									48.14228515625001,
									41.48476562500008
								],
								[
									48.056054687500136,
									41.4586914062501
								],
								[
									47.96367187500016,
									41.333984375000085
								],
								[
									47.86113281250016,
									41.21274414062506
								],
								[
									47.791015625,
									41.19926757812499
								],
								[
									47.591796875,
									41.21811523437509
								],
								[
									47.520605468750034,
									41.22905273437493
								],
								[
									47.31767578124999,
									41.28242187500007
								],
								[
									47.261132812500136,
									41.315087890624966
								],
								[
									47.20527343750018,
									41.45561523437499
								],
								[
									47.142578125000114,
									41.51606445312504
								],
								[
									47.063964843750114,
									41.554687500000114
								],
								[
									47.010156250000136,
									41.58749999999995
								],
								[
									46.987792968750114,
									41.62138671875002
								],
								[
									46.93085937500007,
									41.67041015625006
								],
								[
									46.825585937500136,
									41.743408203125
								],
								[
									46.749316406250045,
									41.81259765624998
								],
								[
									46.69033203125002,
									41.831347656250074
								],
								[
									46.61601562500016,
									41.806933593750074
								],
								[
									46.5712890625,
									41.8000976562501
								],
								[
									46.55214843750002,
									41.8123046875001
								],
								[
									46.53769531250009,
									41.870410156250045
								],
								[
									46.42988281250007,
									41.890966796875034
								],
								[
									46.411523437500136,
									41.90463867187509
								],
								[
									46.26777343750018,
									41.960351562499966
								],
								[
									46.212695312500045,
									41.98989257812505
								],
								[
									46.15976562500009,
									41.992041015625034
								],
								[
									46.048437500000034,
									42.00874023437507
								],
								[
									45.95400390625002,
									42.035400390625085
								],
								[
									45.91035156250007,
									42.07070312500008
								],
								[
									45.845996093750045,
									42.10996093750006
								],
								[
									45.726562500000114,
									42.15888671875001
								],
								[
									45.638574218750136,
									42.205078125
								],
								[
									45.63427734375006,
									42.23471679687509
								],
								[
									45.68837890625008,
									42.35737304687504
								],
								[
									45.72753906250006,
									42.47504882812501
								],
								[
									45.70527343750007,
									42.49809570312502
								],
								[
									45.65556640625016,
									42.517675781250006
								],
								[
									45.56289062500008,
									42.535742187500034
								],
								[
									45.343750000000114,
									42.529785156250085
								],
								[
									45.20820312500001,
									42.64824218749996
								],
								[
									45.160253906250034,
									42.67500000000007
								],
								[
									45.07158203124999,
									42.694140625000074
								],
								[
									44.943359375,
									42.730273437500074
								],
								[
									44.87099609375008,
									42.75639648437496
								],
								[
									44.85048828125008,
									42.74682617187497
								],
								[
									44.77109375000009,
									42.616796875000034
								],
								[
									44.69179687500008,
									42.70961914062502
								],
								[
									44.64433593749999,
									42.73471679687509
								],
								[
									44.576464843750045,
									42.74848632812504
								],
								[
									44.505859375000114,
									42.74863281249998
								],
								[
									44.32949218750008,
									42.70351562500002
								],
								[
									44.199707031250114,
									42.65361328124999
								],
								[
									44.10273437500007,
									42.61635742187502
								],
								[
									44.004687500000045,
									42.59560546875008
								],
								[
									43.957421875000136,
									42.56655273437511
								],
								[
									43.8259765625001,
									42.57153320312506
								],
								[
									43.759863281250034,
									42.59384765624998
								],
								[
									43.73837890625009,
									42.61699218749999
								],
								[
									43.749902343750136,
									42.657519531250074
								],
								[
									43.79541015625006,
									42.702978515625006
								],
								[
									43.798730468750136,
									42.727783203125
								],
								[
									43.782617187500136,
									42.74702148437501
								],
								[
									43.623046875000114,
									42.807714843750034
								],
								[
									43.55781250000018,
									42.84448242187497
								],
								[
									43.347949218750045,
									42.89667968750004
								],
								[
									43.089160156250045,
									42.98906250000002
								],
								[
									43.00019531250007,
									43.04965820312512
								],
								[
									42.99160156250008,
									43.09150390625001
								],
								[
									42.89003906250002,
									43.13261718749996
								],
								[
									42.760644531250136,
									43.16958007812502
								],
								[
									42.66025390625009,
									43.15908203125002
								],
								[
									42.56601562500009,
									43.15512695312512
								],
								[
									42.419042968750034,
									43.22421875000006
								],
								[
									42.27968750000002,
									43.22807617187496
								],
								[
									42.12226562500007,
									43.20732421874999
								],
								[
									42.08779296875008,
									43.19912109375011
								],
								[
									42.05000000000001,
									43.19013671875004
								],
								[
									41.58056640625006,
									43.21923828125003
								],
								[
									41.46074218750016,
									43.27631835937501
								],
								[
									41.358203125000045,
									43.33339843750011
								],
								[
									41.083105468750034,
									43.37446289062504
								],
								[
									40.941992187500034,
									43.418066406250034
								],
								[
									40.80166015625008,
									43.47993164062501
								],
								[
									40.648046875000034,
									43.5338867187501
								],
								[
									40.518945312500136,
									43.512011718750074
								],
								[
									40.342285156250114,
									43.54272460937503
								],
								[
									40.15019531250016,
									43.56977539062504
								],
								[
									40.08457031250009,
									43.55312500000011
								],
								[
									40.023730468750045,
									43.48486328125006
								],
								[
									39.978320312500045,
									43.41982421875002
								],
								[
									39.87363281250009,
									43.47280273437508
								],
								[
									39.516699218750034,
									43.72788085937509
								],
								[
									39.32939453125016,
									43.897265625000045
								],
								[
									38.71728515625,
									44.288085937500085
								],
								[
									38.63583984375009,
									44.318017578124966
								],
								[
									38.31181640625016,
									44.37446289062501
								],
								[
									38.181250000000034,
									44.41967773437506
								],
								[
									37.851464843749966,
									44.698828125000006
								],
								[
									37.70488281250016,
									44.661376953125114
								],
								[
									37.57246093750018,
									44.67084960937507
								],
								[
									37.495117187500114,
									44.69526367187507
								],
								[
									37.41132812500001,
									44.735351562500085
								],
								[
									37.35234375000016,
									44.788378906250045
								],
								[
									37.284082031250136,
									44.905029296875
								],
								[
									37.20478515625001,
									44.97197265624996
								],
								[
									36.944433593750034,
									45.06958007812506
								],
								[
									36.650781249999966,
									45.12646484375
								],
								[
									36.62763671875007,
									45.1513183593751
								],
								[
									36.619140625000114,
									45.18549804687504
								],
								[
									36.87304687499994,
									45.251757812500045
								],
								[
									36.94121093750016,
									45.28969726562502
								],
								[
									36.811035156250114,
									45.34003906249998
								],
								[
									36.761621093749966,
									45.34833984375007
								],
								[
									36.72041015625001,
									45.37187499999999
								],
								[
									36.79375000000016,
									45.409716796875074
								],
								[
									36.86591796875018,
									45.427050781250045
								],
								[
									36.97783203125016,
									45.383593750000074
								],
								[
									37.103515625000114,
									45.302880859374966
								],
								[
									37.21357421875007,
									45.272314453125034
								],
								[
									37.26425781250009,
									45.31093750000011
								],
								[
									37.64716796875018,
									45.377197265625085
								],
								[
									37.672949218750034,
									45.42973632812496
								],
								[
									37.671875,
									45.488378906250006
								],
								[
									37.63437500000009,
									45.48632812499994
								],
								[
									37.60996093750009,
									45.49951171874997
								],
								[
									37.612402343750034,
									45.564697265625114
								],
								[
									37.66923828125016,
									45.654052734375114
								],
								[
									37.840917968750034,
									45.799560546875085
								],
								[
									37.933105468750114,
									46.00170898437506
								],
								[
									38.014257812500034,
									46.04775390625002
								],
								[
									38.07382812500009,
									46.017089843750085
								],
								[
									38.069726562500136,
									45.96987304687505
								],
								[
									38.079589843750114,
									45.934814453125114
								],
								[
									38.132812500000114,
									46.00283203125011
								],
								[
									38.18359374999994,
									46.09482421875009
								],
								[
									38.31181640625016,
									46.09536132812502
								],
								[
									38.400390625,
									46.080029296874926
								],
								[
									38.492285156250034,
									46.09052734375004
								],
								[
									38.31523437500016,
									46.24194335937506
								],
								[
									38.07773437500009,
									46.39433593750002
								],
								[
									37.9775390625,
									46.38286132812499
								],
								[
									37.91386718750016,
									46.406494140625
								],
								[
									37.80957031249994,
									46.532080078125006
								],
								[
									37.766503906249966,
									46.63613281250008
								],
								[
									37.86738281250001,
									46.63378906249994
								],
								[
									37.96796875000018,
									46.61801757812512
								],
								[
									38.159472656250045,
									46.690673828125085
								],
								[
									38.229980468750114,
									46.70126953125012
								],
								[
									38.34345703125001,
									46.67832031250006
								],
								[
									38.50097656249994,
									46.66367187500009
								],
								[
									38.48798828125018,
									46.732177734375085
								],
								[
									38.43867187500007,
									46.81308593750006
								],
								[
									38.630761718750136,
									46.873046875000114
								],
								[
									38.80107421874999,
									46.90615234375011
								],
								[
									39.12675781249999,
									47.023437500000114
								],
								[
									39.27070312500018,
									47.04414062500007
								],
								[
									39.289062500000114,
									47.070898437500006
								],
								[
									39.293457031250114,
									47.1057617187501
								],
								[
									39.24453125000002,
									47.1995117187501
								],
								[
									39.19570312500002,
									47.2688476562501
								],
								[
									39.02373046875016,
									47.272216796875085
								],
								[
									38.92832031250009,
									47.17568359375002
								],
								[
									38.66816406250018,
									47.143945312499966
								],
								[
									38.55244140625007,
									47.15034179687501
								],
								[
									38.644335937500045,
									47.21220703125002
								],
								[
									38.73603515625018,
									47.23583984374994
								],
								[
									38.76191406250018,
									47.26162109375005
								],
								[
									38.577246093750034,
									47.23911132812509
								],
								[
									38.484765625000136,
									47.175537109375
								],
								[
									38.214355468750114,
									47.09145507812502
								],
								[
									38.20585937500016,
									47.13559570312495
								],
								[
									38.20136718750001,
									47.17524414062504
								],
								[
									38.22119140625,
									47.21274414062495
								],
								[
									38.26533203125018,
									47.236962890624994
								],
								[
									38.28076171874994,
									47.25903320312506
								],
								[
									38.28076171874994,
									47.2766601562501
								],
								[
									38.241015625000045,
									47.287695312500034
								],
								[
									38.20800781249994,
									47.296533203124966
								],
								[
									38.20136718750001,
									47.32080078125003
								],
								[
									38.21240234374994,
									47.34277343749997
								],
								[
									38.243261718750034,
									47.37368164062505
								],
								[
									38.25654296875018,
									47.40893554687494
								],
								[
									38.258789062500114,
									47.479541015625045
								],
								[
									38.28740234375016,
									47.559179687500006
								],
								[
									38.36884765625007,
									47.609960937500034
								],
								[
									38.51093750000001,
									47.622412109375006
								],
								[
									38.640625,
									47.66591796875008
								],
								[
									38.71894531250007,
									47.71411132812494
								],
								[
									38.82226562499994,
									47.837011718750034
								],
								[
									38.900292968750136,
									47.85512695312508
								],
								[
									39.05781250000018,
									47.84848632812506
								],
								[
									39.15849609375016,
									47.837402343750114
								],
								[
									39.39101562500002,
									47.833740234375085
								],
								[
									39.65849609375016,
									47.841210937499994
								],
								[
									39.735937500000034,
									47.84482421875012
								],
								[
									39.778710937500136,
									47.88754882812512
								],
								[
									39.775781249999966,
									47.96445312500006
								],
								[
									39.813964843750114,
									48.03530273437511
								],
								[
									39.885058593750045,
									48.16835937499994
								],
								[
									39.961035156250034,
									48.237939453124994
								],
								[
									39.957910156250136,
									48.26889648437509
								],
								[
									39.91816406250001,
									48.28193359374998
								],
								[
									39.866308593750034,
									48.28842773437498
								],
								[
									39.84746093749999,
									48.302783203125074
								],
								[
									39.84990234375016,
									48.33193359375005
								],
								[
									39.88984375000001,
									48.36044921875009
								],
								[
									39.88261718750016,
									48.41909179687505
								],
								[
									39.857519531250034,
									48.48422851562509
								],
								[
									39.83564453125018,
									48.54277343750002
								],
								[
									39.76542968749999,
									48.57187500000009
								],
								[
									39.64472656250018,
									48.59121093749994
								],
								[
									39.670410156250114,
									48.66245117187506
								],
								[
									39.704589843750114,
									48.739355468750006
								],
								[
									39.755859375000114,
									48.782080078125006
								],
								[
									39.792871093749966,
									48.80771484375009
								],
								[
									39.90410156249999,
									48.79374999999999
								],
								[
									39.984472656250034,
									48.807373046875085
								],
								[
									40.00361328125001,
									48.822070312500074
								],
								[
									39.98916015625002,
									48.851416015625006
								],
								[
									39.86376953124994,
									48.8779785156251
								],
								[
									39.75332031250002,
									48.91445312500005
								],
								[
									39.70566406250009,
									48.95957031250012
								],
								[
									39.6865234375,
									49.007910156250006
								],
								[
									39.75947265625001,
									49.03657226562498
								],
								[
									39.88974609375009,
									49.06406250000009
								],
								[
									39.97636718750016,
									49.12983398437507
								],
								[
									40.07001953125007,
									49.200292968750034
								],
								[
									40.108789062500136,
									49.25156250000009
								],
								[
									40.128320312500136,
									49.30722656250006
								],
								[
									40.12617187500001,
									49.3688476562501
								],
								[
									40.05781250000007,
									49.43154296875008
								],
								[
									40.05781250000007,
									49.497070312500085
								],
								[
									40.09492187500007,
									49.54267578125007
								],
								[
									40.08066406250009,
									49.57685546875001
								],
								[
									40.030664062500136,
									49.596728515625074
								],
								[
									39.95849609375,
									49.5907714843751
								],
								[
									39.876855468750136,
									49.5676757812501
								],
								[
									39.78056640625016,
									49.572021484375
								],
								[
									39.626562500000034,
									49.650683593750045
								],
								[
									39.462792968749966,
									49.728027343750085
								],
								[
									39.368457031250045,
									49.73066406250007
								],
								[
									39.30292968750018,
									49.74204101562509
								],
								[
									39.245996093750136,
									49.781933593749955
								],
								[
									39.21181640625002,
									49.83320312500001
								],
								[
									39.174804687500114,
									49.85595703125003
								],
								[
									39.11494140625018,
									49.84174804687507
								],
								[
									39.027734374999966,
									49.81840820312502
								],
								[
									38.91835937500002,
									49.82470703125006
								],
								[
									38.77666015624999,
									49.884326171875045
								],
								[
									38.647753906250045,
									49.95288085937506
								],
								[
									38.55195312500007,
									49.95458984375006
								],
								[
									38.451171875000114,
									49.96406250000001
								],
								[
									38.25859375000016,
									50.05234374999998
								],
								[
									38.20869140625018,
									50.05146484375007
								],
								[
									38.17753906250016,
									50.025390625000085
								],
								[
									38.162695312500034,
									49.95454101562504
								],
								[
									38.14677734374999,
									49.93940429687507
								],
								[
									38.11250000000007,
									49.92783203125009
								],
								[
									38.046875000000114,
									49.92001953125012
								],
								[
									37.950292968750034,
									49.96420898437506
								],
								[
									37.70419921875009,
									50.10908203125007
								],
								[
									37.605078125000034,
									50.21494140624998
								],
								[
									37.582324218750045,
									50.291845703125006
								],
								[
									37.501367187499966,
									50.34072265625002
								],
								[
									37.42285156249994,
									50.411474609375034
								],
								[
									37.343164062499966,
									50.417626953124966
								],
								[
									37.254882812500114,
									50.39497070312507
								],
								[
									37.17109375000018,
									50.360888671875045
								],
								[
									37.131249999999966,
									50.3515136718751
								],
								[
									36.98847656250001,
									50.339550781249955
								],
								[
									36.75908203124999,
									50.291845703125006
								],
								[
									36.696386718750034,
									50.24624023437505
								],
								[
									36.61943359375016,
									50.20922851562506
								],
								[
									36.559667968750034,
									50.23486328124994
								],
								[
									36.499804687500045,
									50.2804687500001
								],
								[
									36.36884765625018,
									50.296826171874955
								],
								[
									36.30605468750002,
									50.2804687500001
								],
								[
									36.24335937500018,
									50.311767578125085
								],
								[
									36.18945312499994,
									50.36782226562502
								],
								[
									36.11640625000018,
									50.40854492187498
								],
								[
									36.0078125,
									50.41967773437494
								],
								[
									35.890234375000034,
									50.437109375000034
								],
								[
									35.796191406250045,
									50.40576171874994
								],
								[
									35.673730468750136,
									50.34599609375002
								],
								[
									35.59111328124999,
									50.368750000000034
								],
								[
									35.545507812500034,
									50.43999023437499
								],
								[
									35.48847656250007,
									50.45991210937507
								],
								[
									35.411621093750114,
									50.539697265624966
								],
								[
									35.391699218750034,
									50.610937500000006
								],
								[
									35.411621093750114,
									50.64223632812508
								],
								[
									35.44013671875018,
									50.682080078124926
								],
								[
									35.44013671875018,
									50.72768554687508
								],
								[
									35.417382812500136,
									50.76757812499994
								],
								[
									35.38320312500002,
									50.79892578125012
								],
								[
									35.34609375000002,
									50.904296875000085
								],
								[
									35.31474609374999,
									50.949902343749955
								],
								[
									35.309082031250114,
									50.98691406249995
								],
								[
									35.33476562499999,
									51.021142578124994
								],
								[
									35.311914062500136,
									51.043896484374926
								],
								[
									35.269140625000034,
									51.04677734375008
								],
								[
									35.198046875000045,
									51.043896484374926
								],
								[
									35.158105468749966,
									51.06098632812504
								],
								[
									35.11533203125009,
									51.12084960937497
								],
								[
									35.09257812500016,
									51.180664062500085
								],
								[
									35.06406250000009,
									51.2034179687501
								],
								[
									34.990234375,
									51.20175781250012
								],
								[
									34.868554687499966,
									51.18920898437503
								],
								[
									34.760351562500034,
									51.16933593750008
								],
								[
									34.712304687500136,
									51.17221679687495
								],
								[
									34.616796875000034,
									51.20312499999994
								],
								[
									34.49101562500016,
									51.237060546875114
								],
								[
									34.23417968750016,
									51.243798828124966
								],
								[
									34.213867187500114,
									51.255371093750114
								],
								[
									34.228417968750136,
									51.27685546875006
								],
								[
									34.28066406250002,
									51.31166992187494
								],
								[
									34.275000000000034,
									51.34018554687498
								],
								[
									34.229882812499966,
									51.36323242187507
								],
								[
									34.206542968750114,
									51.41992187499997
								],
								[
									34.209277343750045,
									51.48408203124998
								],
								[
									34.20087890625001,
									51.55380859374998
								],
								[
									34.14677734374999,
									51.607958984375074
								],
								[
									34.11542968750001,
									51.64497070312498
								],
								[
									34.121093750000114,
									51.67915039062501
								],
								[
									34.23916015625002,
									51.69223632812512
								],
								[
									34.379296875000136,
									51.7165039062501
								],
								[
									34.40273437500002,
									51.74150390624993
								],
								[
									34.39785156250002,
									51.78041992187505
								],
								[
									34.11308593750016,
									51.97963867187505
								],
								[
									34.01533203125007,
									52.1559570312501
								],
								[
									33.92207031250007,
									52.25146484375
								],
								[
									33.81884765625,
									52.315624999999926
								],
								[
									33.73525390625002,
									52.3447753906251
								],
								[
									33.613378906250034,
									52.33261718750009
								],
								[
									33.45185546875018,
									52.33378906249999
								],
								[
									33.287109375000114,
									52.35356445312493
								],
								[
									33.148437500000114,
									52.340429687500006
								],
								[
									32.89970703125016,
									52.256347656250114
								],
								[
									32.80644531250016,
									52.25263671875007
								],
								[
									32.645410156250136,
									52.279101562500045
								],
								[
									32.50791015625009,
									52.3085449218751
								],
								[
									32.435449218749966,
									52.30722656250009
								],
								[
									32.39130859375007,
									52.29482421875005
								],
								[
									32.36298828125007,
									52.27211914062502
								],
								[
									32.282812500000034,
									52.11401367187497
								],
								[
									32.216796875000114,
									52.082958984374955
								],
								[
									32.12226562500001,
									52.05058593749993
								],
								[
									32.041601562500034,
									52.04501953124995
								],
								[
									31.973828125000182,
									52.046630859375114
								],
								[
									31.875585937500034,
									52.07089843750006
								],
								[
									31.782421875000182,
									52.09941406249993
								],
								[
									31.763378906250125,
									52.10107421875
								],
								[
									31.75859374999999,
									52.12583007812506
								],
								[
									31.69062500000001,
									52.22065429687504
								],
								[
									31.64990234375,
									52.26220703124997
								],
								[
									31.601562500000114,
									52.28481445312505
								],
								[
									31.57734375000001,
									52.31230468749996
								],
								[
									31.576562500000136,
									52.42602539062503
								],
								[
									31.585546875000034,
									52.53247070312506
								],
								[
									31.615917968750068,
									52.5461914062501
								],
								[
									31.52617187499999,
									52.63300781250001
								],
								[
									31.519433593750136,
									52.698730468750085
								],
								[
									31.563476562500057,
									52.7314453125
								],
								[
									31.56484375000008,
									52.75922851562507
								],
								[
									31.535156250000057,
									52.79824218750002
								],
								[
									31.44277343750008,
									52.86181640625
								],
								[
									31.35302734375,
									52.933447265625034
								],
								[
									31.295117187500068,
									52.98979492187496
								],
								[
									31.258789062500057,
									53.01669921875012
								],
								[
									31.302929687500068,
									53.06088867187506
								],
								[
									31.364550781250045,
									53.138964843750074
								],
								[
									31.388378906250068,
									53.184814453125085
								],
								[
									31.417871093750136,
									53.19604492187497
								],
								[
									31.562988281250057,
									53.202490234375034
								],
								[
									31.66826171874999,
									53.200927734375085
								],
								[
									31.747460937500136,
									53.184179687500034
								],
								[
									31.777441406250034,
									53.14687500000008
								],
								[
									31.849707031250034,
									53.10620117187506
								],
								[
									32.05546874999999,
									53.08945312500009
								],
								[
									32.141992187500136,
									53.091162109375006
								],
								[
									32.25068359375007,
									53.12836914062504
								],
								[
									32.42626953125006,
									53.21059570312508
								],
								[
									32.469335937500034,
									53.2703125000001
								],
								[
									32.57802734375008,
									53.31240234375005
								],
								[
									32.64443359375002,
									53.328906250000045
								],
								[
									32.70429687500001,
									53.33632812500005
								],
								[
									32.71025390624999,
									53.37143554687509
								],
								[
									32.706445312500136,
									53.41943359375
								],
								[
									32.68574218750018,
									53.448144531249994
								],
								[
									32.46962890625002,
									53.54697265625006
								],
								[
									32.44238281250006,
									53.579248046874966
								],
								[
									32.42519531250002,
									53.61728515625009
								],
								[
									32.450976562500045,
									53.65332031250006
								],
								[
									32.45019531250006,
									53.692919921875045
								],
								[
									32.20039062500007,
									53.78125
								],
								[
									31.992187500000114,
									53.796875000000085
								],
								[
									31.82080078125,
									53.79194335937504
								],
								[
									31.75419921874999,
									53.810449218749994
								],
								[
									31.78300781249999,
									53.854980468750085
								],
								[
									31.825292968750034,
									53.93500976562507
								],
								[
									31.83779296875008,
									54.00078124999996
								],
								[
									31.825976562500045,
									54.03071289062501
								],
								[
									31.7919921875,
									54.055908203125
								],
								[
									31.628417968750057,
									54.11118164062498
								],
								[
									31.40361328124999,
									54.19594726562502
								],
								[
									31.299121093750045,
									54.29169921874998
								],
								[
									31.245507812500136,
									54.3916503906251
								],
								[
									31.184765625000068,
									54.45297851562498
								],
								[
									31.07480468750009,
									54.49179687499998
								],
								[
									31.081933593750023,
									54.517089843750085
								],
								[
									31.154882812500034,
									54.610937500000006
								],
								[
									31.15214843749999,
									54.625341796875006
								],
								[
									31.12128906250001,
									54.64848632812502
								],
								[
									30.984179687500102,
									54.69589843750009
								],
								[
									30.798828125000057,
									54.78325195312502
								],
								[
									30.791015625,
									54.806005859375034
								],
								[
									30.804492187500045,
									54.860937500000034
								],
								[
									30.82988281249999,
									54.91499023437504
								],
								[
									30.866796875000034,
									54.94072265624996
								],
								[
									30.977734375000068,
									55.05048828125004
								],
								[
									30.977734375000068,
									55.08779296875008
								],
								[
									30.95888671875008,
									55.13759765625011
								],
								[
									30.877441406250114,
									55.2234375000001
								],
								[
									30.814453125000057,
									55.27871093750008
								],
								[
									30.810546875000057,
									55.30698242187506
								],
								[
									30.820996093750068,
									55.33027343750001
								],
								[
									30.861816406250114,
									55.36040039062502
								],
								[
									30.900585937500125,
									55.39741210937501
								],
								[
									30.90878906250009,
									55.52534179687504
								],
								[
									30.906835937500034,
									55.5700195312501
								],
								[
									30.88222656250008,
									55.59638671875004
								],
								[
									30.855957031250057,
									55.60751953125009
								],
								[
									30.800781250000114,
									55.60112304687502
								],
								[
									30.721679687500057,
									55.622119140625045
								],
								[
									30.662304687500068,
									55.6554687500001
								],
								[
									30.625585937500034,
									55.66625976562497
								],
								[
									30.58671874999999,
									55.70029296874998
								],
								[
									30.475390625000045,
									55.768798828125085
								],
								[
									30.456250000000068,
									55.78681640625001
								],
								[
									30.23359375000001,
									55.845214843750114
								],
								[
									30.04267578125001,
									55.83642578125
								],
								[
									29.93701171875,
									55.84526367187502
								],
								[
									29.881640625000102,
									55.832324218750045
								],
								[
									29.823925781250068,
									55.79511718750004
								],
								[
									29.744140625000057,
									55.770410156249966
								],
								[
									29.6845703125,
									55.76972656250001
								],
								[
									29.630078125000182,
									55.75117187500004
								],
								[
									29.482226562500045,
									55.68457031249997
								],
								[
									29.41298828125008,
									55.724853515625114
								],
								[
									29.353417968750136,
									55.78437500000007
								],
								[
									29.373144531250034,
									55.834716796875114
								],
								[
									29.397949218750057,
									55.88105468750004
								],
								[
									29.396093750000034,
									55.91220703125009
								],
								[
									29.375,
									55.93872070312497
								],
								[
									29.283007812500045,
									55.96787109375006
								],
								[
									29.08740234375,
									56.02114257812508
								],
								[
									29.03173828125003,
									56.02177734375002
								],
								[
									28.94746093750001,
									56.00209960937511
								],
								[
									28.794726562500074,
									55.94257812500004
								],
								[
									28.740820312500006,
									55.95537109374999
								],
								[
									28.69082031250005,
									56.00263671875004
								],
								[
									28.636914062500068,
									56.061767578125085
								],
								[
									28.56396484375003,
									56.09199218750001
								],
								[
									28.407031250000045,
									56.08901367187505
								],
								[
									28.39208984375003,
									56.08671875000002
								],
								[
									28.316308593750023,
									56.052539062500074
								],
								[
									28.284277343750006,
									56.05590820312506
								],
								[
									28.14794921875003,
									56.142919921875006
								],
								[
									28.17333984375003,
									56.19033203125008
								],
								[
									28.202050781250023,
									56.26040039062505
								],
								[
									28.191699218750045,
									56.31557617187511
								],
								[
									28.169238281250017,
									56.386865234374966
								],
								[
									28.11083984375,
									56.51069335937507
								],
								[
									28.103125000000034,
									56.545703125000074
								],
								[
									28.00751953125001,
									56.599853515625114
								],
								[
									27.99160156250005,
									56.645312500000045
								],
								[
									27.94140625000003,
									56.703710937500034
								],
								[
									27.89208984375003,
									56.741064453125006
								],
								[
									27.88154296875001,
									56.82416992187507
								],
								[
									27.848632812500057,
									56.85341796875008
								],
								[
									27.80605468750008,
									56.86708984375011
								],
								[
									27.655664062499994,
									56.84321289062504
								],
								[
									27.639453125000074,
									56.8456542968751
								],
								[
									27.71113281250001,
									56.978076171875074
								],
								[
									27.717382812500063,
									57.05463867187504
								],
								[
									27.762792968750063,
									57.13510742187509
								],
								[
									27.814550781250034,
									57.16689453125008
								],
								[
									27.83027343750004,
									57.19448242187511
								],
								[
									27.83828125000008,
									57.24770507812502
								],
								[
									27.828613281250057,
									57.29331054687498
								],
								[
									27.796875,
									57.3169433593751
								],
								[
									27.672753906250023,
									57.36811523437504
								],
								[
									27.538671875000063,
									57.42978515625006
								],
								[
									27.51113281250005,
									57.50815429687506
								],
								[
									27.469726562500057,
									57.52402343750009
								],
								[
									27.351953125000023,
									57.528125000000045
								],
								[
									27.354296875000074,
									57.55029296875003
								],
								[
									27.371777343749983,
									57.612548828125
								],
								[
									27.400000000000063,
									57.666796875000045
								],
								[
									27.491992187500045,
									57.72495117187509
								],
								[
									27.514746093749977,
									57.76420898437499
								],
								[
									27.542089843750034,
									57.79941406250006
								],
								[
									27.75283203125008,
									57.84101562500001
								],
								[
									27.776953125000034,
									57.85673828125002
								],
								[
									27.778515625000068,
									57.87070312500012
								],
								[
									27.76875000000004,
									57.88413085937509
								],
								[
									27.721972656250017,
									57.9054687500001
								],
								[
									27.673437499999977,
									57.934619140625074
								],
								[
									27.644140625000063,
									58.01391601562497
								],
								[
									27.643057672481802,
									58.01575689012634
								],
								[
									27.678320312500006,
									58.01850585937501
								],
								[
									27.80273437500003,
									57.99023437500003
								],
								[
									27.881640625000045,
									57.93701171875003
								],
								[
									27.875390624999994,
									57.92041015625003
								],
								[
									27.910937500000045,
									57.89575195312497
								],
								[
									27.99208984375005,
									57.86811523437501
								],
								[
									28.10175781250001,
									57.85996093750006
								],
								[
									28.169238281250017,
									57.91450195312507
								],
								[
									28.149218750000017,
									57.97465820312496
								],
								[
									28.096972656250017,
									58.04443359374997
								],
								[
									27.973046874999994,
									58.13261718749999
								],
								[
									27.86513671875005,
									58.173486328124966
								],
								[
									27.714355468750057,
									58.16425781250004
								],
								[
									27.591796875000057,
									58.17460937500002
								],
								[
									27.56855468750001,
									58.21479492187504
								],
								[
									27.561328125000045,
									58.257421875000006
								],
								[
									27.582714843750068,
									58.30639648437506
								],
								[
									27.747851562500045,
									58.429931640625
								],
								[
									27.798144531250074,
									58.44682617187496
								],
								[
									27.82050781250001,
									58.48491210937499
								],
								[
									27.81367187500004,
									58.57133789062502
								],
								[
									27.74843750000008,
									58.91206054687498
								],
								[
									27.68300781250008,
									58.979638671874994
								],
								[
									27.668854749312345,
									58.9820640435249
								],
								[
									27.757617187500074,
									59.05200195312506
								],
								[
									27.84951171875005,
									59.192675781250045
								],
								[
									27.89765625000001,
									59.27763671875013
								],
								[
									27.93818359375001,
									59.29702148437508
								],
								[
									28.016406250000045,
									59.301708984374955
								],
								[
									28.04609375000004,
									59.327832031249955
								],
								[
									28.061328125000045,
									59.343261718750085
								],
								[
									28.128320312500023,
									59.357568359374966
								],
								[
									28.15107421875004,
									59.37441406249994
								],
								[
									28.133007812499983,
									59.403076171875
								],
								[
									28.06582031250008,
									59.453173828125074
								],
								[
									28.012500000000045,
									59.48427734374994
								],
								[
									28.063964843750057,
									59.55400390625002
								],
								[
									28.046289062499994,
									59.6471679687501
								],
								[
									28.013964843750074,
									59.724755859374994
								],
								[
									28.05800781250008,
									59.78154296875002
								],
								[
									28.131152343750074,
									59.786523437499966
								],
								[
									28.212500000000034,
									59.724658203125074
								],
								[
									28.334570312500034,
									59.692529296874994
								],
								[
									28.42373046875008,
									59.73408203125004
								],
								[
									28.45390624999999,
									59.81425781250002
								],
								[
									28.518164062500034,
									59.849560546874926
								],
								[
									28.603906249999994,
									59.8180664062501
								],
								[
									28.747656249999977,
									59.80668945312499
								],
								[
									28.86689453125004,
									59.81191406250008
								],
								[
									28.947265625000057,
									59.82875976562505
								],
								[
									28.981542968750034,
									59.85478515625002
								],
								[
									29.01337890625004,
									59.901562499999955
								],
								[
									29.0791015625,
									59.960986328125074
								],
								[
									29.147265625000045,
									59.99975585937497
								],
								[
									29.66972656250016,
									59.95566406250006
								],
								[
									30.122558593749943,
									59.8735839843751
								],
								[
									30.15683593750009,
									59.90429687499997
								],
								[
									30.172656250000045,
									59.95712890625009
								],
								[
									30.059960937499966,
									60.00258789062502
								],
								[
									29.976757812500182,
									60.02636718749997
								],
								[
									29.87226562500001,
									60.12084960937503
								],
								[
									29.72119140625,
									60.19531250000003
								],
								[
									29.569335937499943,
									60.20185546875001
								],
								[
									29.370410156250045,
									60.17592773437508
								],
								[
									29.069140625000017,
									60.191455078125045
								],
								[
									28.81269531250001,
									60.33154296874997
								],
								[
									28.643164062500006,
									60.3752929687501
								],
								[
									28.522265625000074,
									60.4829589843751
								],
								[
									28.49160156250005,
									60.54013671875012
								],
								[
									28.62246093750005,
									60.491601562499994
								],
								[
									28.640332031250068,
									60.54287109375005
								],
								[
									28.65058593750001,
									60.61098632812505
								],
								[
									28.57783203125001,
									60.65253906250001
								],
								[
									28.512792968750006,
									60.67729492187499
								],
								[
									28.179296875000006,
									60.5709960937501
								],
								[
									27.797656250000074,
									60.5361328125
								],
								[
									28.151953125000034,
									60.745849609375
								],
								[
									28.40742187500004,
									60.89692382812504
								],
								[
									28.455078125000057,
									60.91962890625007
								],
								[
									28.568164062500017,
									60.96020507812497
								],
								[
									28.662890625000045,
									61.00283203125005
								],
								[
									28.739062500000017,
									61.05874023437508
								],
								[
									28.992968750000045,
									61.16904296874998
								],
								[
									29.251660156250182,
									61.287792968749926
								],
								[
									29.492382812500182,
									61.444238281249994
								],
								[
									29.57939453125016,
									61.49345703124999
								],
								[
									29.690136718750068,
									61.54609375000007
								],
								[
									29.933203125000034,
									61.71157226562502
								],
								[
									30.00996093750001,
									61.75737304687502
								],
								[
									30.306445312500045,
									61.964843750000114
								],
								[
									30.479687500000068,
									62.06821289062512
								],
								[
									30.565625000000182,
									62.12758789062505
								],
								[
									30.935742187500182,
									62.323779296875045
								],
								[
									31.18671875000001,
									62.4813964843751
								],
								[
									31.285644531250114,
									62.567822265624926
								],
								[
									31.382421875000034,
									62.69165039062503
								],
								[
									31.437304687500045,
									62.776123046875
								],
								[
									31.53398437499999,
									62.885400390624966
								],
								[
									31.536523437499966,
									62.92163085937506
								],
								[
									31.509277343750114,
									62.955322265625
								],
								[
									31.437011718749943,
									63.00771484374994
								],
								[
									31.33671875000016,
									63.06806640625007
								],
								[
									31.247460937499966,
									63.1418945312501
								],
								[
									31.180859375000182,
									63.20830078125013
								],
								[
									30.97480468750001,
									63.300634765625006
								],
								[
									30.655273437499943,
									63.417480468750114
								],
								[
									30.418554687500034,
									63.50405273437505
								],
								[
									30.05537109375001,
									63.689013671875074
								],
								[
									29.99150390625016,
									63.73515624999999
								],
								[
									30.004101562500182,
									63.74731445312497
								],
								[
									30.21025390625016,
									63.80332031250009
								],
								[
									30.41533203124999,
									63.947509765625085
								],
								[
									30.503906250000114,
									64.02060546875006
								],
								[
									30.526074218750182,
									64.07729492187497
								],
								[
									30.527929687500034,
									64.14111328125
								],
								[
									30.51376953125009,
									64.2000000000001
								],
								[
									30.487890625000034,
									64.23652343749998
								],
								[
									30.390625000000114,
									64.28242187499993
								],
								[
									30.10810546875001,
									64.36611328125011
								],
								[
									30.041894531250136,
									64.44335937500003
								],
								[
									29.98662109375016,
									64.52426757812506
								],
								[
									29.98554687500001,
									64.55771484375006
								],
								[
									30.1201171875,
									64.64462890625009
								],
								[
									30.126171875000182,
									64.68808593750006
								],
								[
									30.110253906250136,
									64.73256835937497
								],
								[
									30.072851562500034,
									64.76503906250011
								],
								[
									29.783203125000114,
									64.80429687500009
								],
								[
									29.701660156250114,
									64.84575195312502
								],
								[
									29.63750000000016,
									64.91176757812497
								],
								[
									29.604199218750068,
									64.96840820312497
								],
								[
									29.60087890625016,
									65.00195312500006
								],
								[
									29.622460937500136,
									65.03950195312507
								],
								[
									29.72001953124999,
									65.08032226562494
								],
								[
									29.81083984375016,
									65.10791015625006
								],
								[
									29.826953125000045,
									65.14506835937499
								],
								[
									29.826171874999943,
									65.18530273437509
								],
								[
									29.810546875,
									65.20473632812497
								],
								[
									29.62968749999999,
									65.22387695312506
								],
								[
									29.612402343750034,
									65.23476562499997
								],
								[
									29.608007812500034,
									65.24868164062505
								],
								[
									29.617187500000114,
									65.26533203125007
								],
								[
									29.714843750000114,
									65.33696289062507
								],
								[
									29.728027343749943,
									65.4734375000001
								],
								[
									29.819433593750034,
									65.56874999999997
								],
								[
									29.71591796875009,
									65.62456054687505
								],
								[
									29.72392578124999,
									65.63437500000009
								],
								[
									29.88261718749999,
									65.66362304687502
								],
								[
									30.029003906250182,
									65.67070312499996
								],
								[
									30.09531250000009,
									65.68168945312507
								],
								[
									30.102734375000182,
									65.7262695312501
								],
								[
									30.08750000000009,
									65.78652343750002
								],
								[
									29.93662109375009,
									66.02294921875003
								],
								[
									29.90341796875009,
									66.09106445312497
								],
								[
									29.80351562500016,
									66.17705078124999
								],
								[
									29.720703125,
									66.23486328125006
								],
								[
									29.670898437499943,
									66.27612304687511
								],
								[
									29.590722656250136,
									66.35683593749994
								],
								[
									29.544335937500023,
									66.43969726562494
								],
								[
									29.46435546875,
									66.53217773437495
								],
								[
									29.37119140625009,
									66.61704101562509
								],
								[
									29.293261718750045,
									66.69550781249993
								],
								[
									29.093066406250017,
									66.84921874999998
								],
								[
									29.066210937500045,
									66.89174804687494
								],
								[
									29.06904296875001,
									66.93022460937496
								],
								[
									29.087011718750006,
									66.970947265625
								],
								[
									29.243359375000182,
									67.09658203125011
								],
								[
									29.3876953125,
									67.20141601562506
								],
								[
									29.572265625000114,
									67.32436523437497
								],
								[
									29.750585937500034,
									67.42641601562497
								],
								[
									29.94121093750016,
									67.54746093750003
								],
								[
									29.98808593749999,
									67.66826171875005
								],
								[
									29.979199218750068,
									67.68857421875
								],
								[
									29.82158203124999,
									67.75400390625
								],
								[
									29.52421874999999,
									67.92910156250005
								],
								[
									29.343847656250034,
									68.06186523437512
								],
								[
									29.06298828125,
									68.11796874999999
								],
								[
									28.685156250000034,
									68.18979492187498
								],
								[
									28.560156250000063,
									68.3513671875001
								],
								[
									28.470703125000057,
									68.48837890625006
								],
								[
									28.479296875000017,
									68.53764648437496
								],
								[
									28.752050781249977,
									68.77143554687498
								],
								[
									28.777636718750045,
									68.813818359375
								],
								[
									28.77285156250005,
									68.84003906249993
								],
								[
									28.74482421875004,
									68.85644531250009
								],
								[
									28.705957031250023,
									68.86552734375005
								],
								[
									28.453515625000023,
									68.87226562499993
								],
								[
									28.414062500000057,
									68.90415039062512
								],
								[
									28.566015625000006,
									68.92822265625003
								],
								[
									28.692187500000045,
									68.96103515624998
								],
								[
									28.89892578124997,
									69.00966796874994
								],
								[
									28.96582031250003,
									69.02197265625006
								],
								[
									29.11855468750005,
									69.04995117187497
								],
								[
									29.170898437500057,
									69.07153320312511
								],
								[
									29.209960937500114,
									69.09702148437506
								],
								[
									29.353027343750114,
									69.27060546874998
								],
								[
									29.388281250000034,
									69.29814453125007
								],
								[
									29.832714843750068,
									69.36044921875009
								],
								[
									29.994042968749966,
									69.39248046874994
								],
								[
									30.087304687500136,
									69.432861328125
								],
								[
									30.1318359375,
									69.4642578125
								],
								[
									30.163769531250182,
									69.50161132812497
								],
								[
									30.186718750000068,
									69.5427734375001
								],
								[
									30.196484375000182,
									69.58056640625006
								],
								[
									30.15976562500009,
									69.62988281250009
								],
								[
									30.180175781249943,
									69.63583984375006
								],
								[
									30.227539062500114,
									69.63378906250009
								],
								[
									30.379687500000045,
									69.58471679687494
								],
								[
									30.615429687500182,
									69.53256835937498
								],
								[
									30.78886718750016,
									69.52851562500004
								],
								[
									30.860742187499966,
									69.538427734375
								],
								[
									30.896679687500182,
									69.56123046874995
								],
								[
									30.922460937500034,
									69.60581054687498
								],
								[
									30.92412109374999,
									69.65175781250011
								],
								[
									30.869726562500034,
									69.78344726562511
								],
								[
									31.049511718750068,
									69.76923828124995
								],
								[
									31.452734375000034,
									69.689599609375
								],
								[
									31.54697265625009,
									69.69692382812497
								],
								[
									31.66621093750001,
									69.72099609374999
								],
								[
									31.78857421875,
									69.81577148437503
								],
								[
									31.879394531250114,
									69.83198242187495
								],
								[
									31.997949218750023,
									69.80991210937506
								],
								[
									32.03056640624999,
									69.835302734375
								],
								[
									31.969335937500034,
									69.91391601562495
								],
								[
									31.984570312500068,
									69.95366210937496
								],
								[
									32.391601562500114,
									69.86870117187507
								],
								[
									32.5654296875,
									69.806494140625
								],
								[
									32.94169921874999,
									69.75185546874997
								],
								[
									33.00781249999994,
									69.72211914062495
								],
								[
									33.012597656250136,
									69.6705078125
								],
								[
									32.994628906250114,
									69.62617187500004
								],
								[
									32.9150390625,
									69.60170898437494
								],
								[
									32.75429687500002,
									69.60571289062503
								],
								[
									32.176757812500114,
									69.67402343749993
								],
								[
									32.09150390625018,
									69.632568359375
								],
								[
									32.16132812500018,
									69.59663085937507
								],
								[
									32.330566406250114,
									69.55424804687505
								],
								[
									32.377734375000045,
									69.4791015625
								],
								[
									32.636816406250034,
									69.48945312499998
								],
								[
									32.883789062500114,
									69.46083984375002
								],
								[
									32.999804687500045,
									69.47011718750005
								],
								[
									33.02099609375,
									69.44560546875002
								],
								[
									32.94160156250007,
									69.38334960937505
								],
								[
									32.978906250000136,
									69.36733398437497
								],
								[
									33.25585937499994,
									69.42773437500003
								],
								[
									33.384863281250034,
									69.44428710937493
								],
								[
									33.45429687500007,
									69.42817382812493
								],
								[
									33.463671875000045,
									69.37817382812506
								],
								[
									33.417968750000114,
									69.31528320312503
								],
								[
									33.41298828125002,
									69.26743164062503
								],
								[
									33.327734375000034,
									69.15185546874994
								],
								[
									33.19638671875009,
									69.11684570312511
								],
								[
									33.141210937500034,
									69.06870117187498
								],
								[
									33.333398437500136,
									69.09819335937513
								],
								[
									33.43564453125009,
									69.13037109375011
								],
								[
									33.62705078125009,
									69.28916015624995
								],
								[
									33.684375000000045,
									69.31025390624998
								],
								[
									34.229394531250136,
									69.31313476562494
								],
								[
									34.35273437500007,
									69.3029296875001
								],
								[
									34.86396484375018,
									69.22807617187502
								],
								[
									35.00957031249999,
									69.22124023437496
								],
								[
									35.175878906250034,
									69.23081054687503
								],
								[
									35.23320312499999,
									69.26557617187501
								],
								[
									35.28984374999999,
									69.27543945312499
								],
								[
									35.857910156250114,
									69.19174804687509
								],
								[
									36.61826171875009,
									69.0034667968751
								],
								[
									37.730566406250034,
									68.692138671875
								],
								[
									38.35761718750018,
									68.41513671875006
								],
								[
									38.430175781250114,
									68.35561523437508
								],
								[
									38.65683593750009,
									68.32187500000006
								],
								[
									38.70556640625,
									68.3447265625
								],
								[
									38.83154296875,
									68.32490234375004
								],
								[
									39.568945312500034,
									68.07172851562498
								],
								[
									39.82333984375009,
									68.05859374999997
								],
								[
									39.78974609375007,
									68.11215820312506
								],
								[
									39.74628906250018,
									68.16220703124995
								],
								[
									39.80927734375007,
									68.15083007812504
								],
								[
									39.895605468750034,
									68.114501953125
								],
								[
									40.03574218750009,
									68.01538085937497
								],
								[
									40.20664062500009,
									67.94189453125
								],
								[
									40.38066406249999,
									67.83188476562498
								],
								[
									40.52578125000002,
									67.789697265625
								],
								[
									40.65654296874999,
									67.77407226562511
								],
								[
									40.76630859375007,
									67.74301757812509
								],
								[
									40.966406250000034,
									67.7134765625
								],
								[
									41.060937500000136,
									67.44418945312495
								],
								[
									41.13388671875009,
									67.3860351562501
								],
								[
									41.13388671875009,
									67.26694335937509
								],
								[
									41.261718750000114,
									67.21845703125007
								],
								[
									41.358789062499966,
									67.20966796874995
								],
								[
									41.354296875000045,
									67.121435546875
								],
								[
									41.27558593750018,
									66.914306640625
								],
								[
									41.188964843750114,
									66.82617187500009
								],
								[
									40.521582031250034,
									66.44663085937503
								],
								[
									40.10332031249999,
									66.29995117187508
								],
								[
									39.289062500000114,
									66.13203125000007
								],
								[
									38.653906250000034,
									66.06904296874993
								],
								[
									38.397558593750034,
									66.06445312499997
								],
								[
									37.90068359375016,
									66.09560546875011
								],
								[
									37.62822265625016,
									66.12958984375001
								],
								[
									37.29482421875002,
									66.22504882812501
								],
								[
									36.983691406250045,
									66.27255859375
								],
								[
									36.76992187500002,
									66.29355468750009
								],
								[
									36.373437500000136,
									66.30229492187502
								],
								[
									35.51347656249999,
									66.39580078125007
								],
								[
									35.36396484375018,
									66.42866210937501
								],
								[
									34.824609374999966,
									66.61113281249996
								],
								[
									34.61025390625002,
									66.55961914062505
								],
								[
									34.48261718750001,
									66.55034179687502
								],
								[
									34.39609375000009,
									66.61318359374994
								],
								[
									34.43085937500007,
									66.62978515625002
								],
								[
									34.45156250000002,
									66.65122070312506
								],
								[
									34.146093750000034,
									66.703271484375
								],
								[
									33.893652343750034,
									66.70673828125007
								],
								[
									33.75957031249999,
									66.75097656249994
								],
								[
									33.59541015625001,
									66.78461914062495
								],
								[
									33.522949218750114,
									66.76435546875001
								],
								[
									33.482031250000034,
									66.76455078125005
								],
								[
									33.15019531249999,
									66.84394531250007
								],
								[
									33.001953125000114,
									66.90830078125012
								],
								[
									32.84755859375002,
									67.02153320312507
								],
								[
									32.88525390624994,
									67.06113281249998
								],
								[
									32.93046874999999,
									67.08681640625005
								],
								[
									32.399902343750114,
									67.15268554687498
								],
								[
									31.89531250000016,
									67.16142578124999
								],
								[
									31.98300781250009,
									67.12983398437504
								],
								[
									32.201562500000136,
									67.11323242187504
								],
								[
									32.340625000000045,
									67.06787109375003
								],
								[
									32.500976562500114,
									67.00385742187495
								],
								[
									32.463671875000045,
									66.91630859374996
								],
								[
									32.686425781250136,
									66.82954101562504
								],
								[
									32.857324218750136,
									66.746923828125
								],
								[
									32.86240234375009,
									66.72138671874995
								],
								[
									32.928710937500114,
									66.70410156250009
								],
								[
									33.180566406249966,
									66.67993164062494
								],
								[
									33.224414062500045,
									66.60385742187509
								],
								[
									33.182910156250045,
									66.57387695312502
								],
								[
									33.217382812500034,
									66.53164062499994
								],
								[
									33.405273437500114,
									66.48427734374997
								],
								[
									33.51767578125009,
									66.47138671875001
								],
								[
									33.65595703125001,
									66.44262695312509
								],
								[
									33.59326171874994,
									66.38457031249999
								],
								[
									33.476953124999966,
									66.34687499999995
								],
								[
									33.36054687500007,
									66.32954101562507
								],
								[
									33.415820312500045,
									66.31562499999998
								],
								[
									33.56669921875016,
									66.32099609374993
								],
								[
									34.112695312499966,
									66.22524414062505
								],
								[
									34.399804687500136,
									66.12841796874994
								],
								[
									34.691796875000136,
									65.95185546875004
								],
								[
									34.78632812500018,
									65.86455078125002
								],
								[
									34.79316406250018,
									65.81635742187504
								],
								[
									34.776953125000034,
									65.76826171875001
								],
								[
									34.734765624999966,
									65.71630859375009
								],
								[
									34.71552734375007,
									65.66406250000003
								],
								[
									34.61572265625,
									65.50991210937497
								],
								[
									34.54414062500007,
									65.45668945312497
								],
								[
									34.40644531250007,
									65.39575195312509
								],
								[
									34.53593750000016,
									65.27792968750006
								],
								[
									34.67109375000018,
									65.16811523437497
								],
								[
									34.80351562500016,
									64.985986328125
								],
								[
									34.8271484375,
									64.91269531249998
								],
								[
									34.832617187500034,
									64.80019531250008
								],
								[
									34.952246093750034,
									64.75595703125003
								],
								[
									34.90546875000001,
									64.73867187499997
								],
								[
									34.85830078125002,
									64.70668945312494
								],
								[
									34.869531249999966,
									64.56000976562498
								],
								[
									35.03535156250001,
									64.4402343750001
								],
								[
									35.284082031249966,
									64.36254882812509
								],
								[
									35.43203125000002,
									64.34677734374998
								],
								[
									35.647070312500034,
									64.37832031250011
								],
								[
									35.80205078125016,
									64.33535156250005
								],
								[
									36.146484375,
									64.18901367187499
								],
								[
									36.30195312500007,
									64.03437499999993
								],
								[
									36.36494140625018,
									64.00283203125008
								],
								[
									36.71376953125002,
									63.94506835937494
								],
								[
									36.97519531250009,
									63.90952148437498
								],
								[
									37.37275390625007,
									63.81674804687509
								],
								[
									37.44218749999999,
									63.81337890624994
								],
								[
									37.63535156250009,
									63.89340820312498
								],
								[
									37.96796875000018,
									63.949121093749966
								],
								[
									38.07080078125,
									64.02583007812495
								],
								[
									38.06220703125018,
									64.09101562500001
								],
								[
									37.97714843750009,
									64.20703125000011
								],
								[
									37.953710937500034,
									64.32011718749996
								],
								[
									37.84355468750016,
									64.36630859375003
								],
								[
									37.740625000000136,
									64.39697265625009
								],
								[
									37.42958984375002,
									64.37358398437502
								],
								[
									37.28955078125,
									64.37792968750011
								],
								[
									37.18369140625009,
									64.4084960937501
								],
								[
									37.040429687500136,
									64.48916015624994
								],
								[
									36.76933593750016,
									64.68525390624993
								],
								[
									36.62421875000018,
									64.75053710937499
								],
								[
									36.578710937500034,
									64.79096679687504
								],
								[
									36.528222656250136,
									64.8473632812501
								],
								[
									36.53457031250002,
									64.93862304687494
								],
								[
									36.652929687500034,
									64.93544921875
								],
								[
									36.78593750000016,
									64.98715820312506
								],
								[
									36.8828125,
									65.17236328124994
								],
								[
									37.050195312499966,
									65.19589843749995
								],
								[
									37.14082031250007,
									65.19428710937507
								],
								[
									37.52812499999999,
									65.10825195312495
								],
								[
									38.00937500000009,
									64.87875976562509
								],
								[
									38.11572265625,
									64.85458984375003
								],
								[
									38.22822265625018,
									64.85122070312508
								],
								[
									38.412109375,
									64.85708007812494
								],
								[
									38.441992187500034,
									64.82714843750006
								],
								[
									38.54091796875002,
									64.79125976562503
								],
								[
									38.61308593750016,
									64.78666992187507
								],
								[
									39.05351562499999,
									64.71391601562499
								],
								[
									39.56738281249994,
									64.570556640625
								],
								[
									39.75800781250018,
									64.57705078125
								],
								[
									39.8330078125,
									64.656396484375
								],
								[
									39.8486328125,
									64.69052734375012
								],
								[
									40.05781250000007,
									64.77075195312503
								],
								[
									40.203710937500034,
									64.78403320312498
								],
								[
									40.407812500000034,
									64.75488281250009
								],
								[
									40.444921875000034,
									64.77871093750005
								],
								[
									40.37539062500002,
									64.89628906250002
								],
								[
									40.281250000000114,
									64.99809570312507
								],
								[
									40.142675781250034,
									65.06328125000002
								],
								[
									39.89648437499994,
									65.25478515625005
								],
								[
									39.79804687500018,
									65.34985351562506
								],
								[
									39.749121093750034,
									65.44794921874995
								],
								[
									39.78115234375002,
									65.53471679687496
								],
								[
									39.81650390625009,
									65.59794921874996
								],
								[
									40.32783203125018,
									65.75170898437494
								],
								[
									40.512792968750034,
									65.84379882812496
								],
								[
									40.69160156250001,
									65.96342773437499
								],
								[
									40.774414062500114,
									65.987890625
								],
								[
									41.076074218750136,
									66.02109375000012
								],
								[
									41.47578125000018,
									66.1234375
								],
								[
									41.78085937500009,
									66.25932617187505
								],
								[
									42.083593750000034,
									66.46591796875003
								],
								[
									42.210546875000034,
									66.51967773437508
								],
								[
									42.31367187500018,
									66.51474609375003
								],
								[
									42.450781250000034,
									66.48242187499994
								],
								[
									42.602148437500034,
									66.422509765625
								],
								[
									42.806542968750136,
									66.41132812500004
								],
								[
									43.00595703125009,
									66.42094726562513
								],
								[
									43.23320312499999,
									66.41552734375
								],
								[
									43.55087890625009,
									66.32128906250006
								],
								[
									43.60332031249999,
									66.29121093749998
								],
								[
									43.653125000000045,
									66.25097656250006
								],
								[
									43.55039062500009,
									66.17338867187496
								],
								[
									43.541894531250136,
									66.12338867187506
								],
								[
									43.623925781250136,
									66.14672851562494
								],
								[
									43.73701171875018,
									66.15839843749993
								],
								[
									43.84374999999994,
									66.14238281250005
								],
								[
									43.94414062500016,
									66.09868164062502
								],
								[
									44.016699218750034,
									66.0497558593751
								],
								[
									44.104394531250136,
									66.00859374999996
								],
								[
									44.13242187500009,
									66.06455078125009
								],
								[
									44.145312500000045,
									66.11274414062495
								],
								[
									44.09716796875,
									66.2350585937501
								],
								[
									44.220703125000114,
									66.40708007812506
								],
								[
									44.31640625,
									66.48168945312497
								],
								[
									44.488671874999966,
									66.67177734375005
								],
								[
									44.437109375000034,
									66.79462890624995
								],
								[
									44.42929687500009,
									66.93774414062506
								],
								[
									44.403906250000034,
									67.00419921875002
								],
								[
									44.291796875000045,
									67.09965820312502
								],
								[
									44.07441406250007,
									67.16733398437495
								],
								[
									43.855371093750136,
									67.18862304687494
								],
								[
									43.78242187500018,
									67.25449218750003
								],
								[
									43.795703125000045,
									67.32958984375006
								],
								[
									43.856347656250136,
									67.43930664062512
								],
								[
									44.03642578125016,
									67.67065429687509
								],
								[
									44.22539062499999,
									67.99560546875003
								],
								[
									44.23154296875009,
									68.07124023437498
								],
								[
									44.21386718749994,
									68.11259765624996
								],
								[
									44.226464843750136,
									68.15444335937497
								],
								[
									44.204687500000034,
									68.25375976562495
								],
								[
									44.16914062500018,
									68.32709960937507
								],
								[
									43.40400390625018,
									68.60854492187502
								],
								[
									43.358007812500034,
									68.63579101562507
								],
								[
									43.33320312500007,
									68.67338867187499
								],
								[
									43.41328125000001,
									68.68173828125
								],
								[
									43.47197265625016,
									68.67983398437505
								],
								[
									44.04804687500001,
									68.54882812500003
								],
								[
									44.175292968750114,
									68.541748046875
								],
								[
									45.078125000000114,
									68.57817382812496
								],
								[
									45.519433593750136,
									68.546533203125
								],
								[
									45.891992187499966,
									68.47968750000007
								],
								[
									46.15839843750018,
									68.29135742187506
								],
								[
									46.429687500000114,
									68.1188476562501
								],
								[
									46.68359374999994,
									67.97045898437506
								],
								[
									46.690429687500114,
									67.84882812500004
								],
								[
									46.42890625000001,
									67.82368164062507
								],
								[
									46.17421875000002,
									67.81816406250002
								],
								[
									45.528710937500136,
									67.75756835937503
								],
								[
									45.37412109375009,
									67.68886718749997
								],
								[
									44.939453125,
									67.47744140625005
								],
								[
									44.902148437500045,
									67.41313476562502
								],
								[
									44.939453125,
									67.35078124999993
								],
								[
									45.13886718750001,
									67.28471679687505
								],
								[
									45.56220703125001,
									67.1855957031251
								],
								[
									45.75253906250009,
									66.98916015625005
								],
								[
									45.885351562500034,
									66.89106445312507
								],
								[
									45.98603515625007,
									66.85312499999998
								],
								[
									46.083984375000114,
									66.84350585937497
								],
								[
									46.297753906250136,
									66.8428222656251
								],
								[
									46.448535156250045,
									66.81899414062502
								],
								[
									46.49238281250018,
									66.80019531249994
								],
								[
									46.552343750000034,
									66.81899414062502
								],
								[
									46.69082031250002,
									66.82553710937495
								],
								[
									47.49648437500002,
									66.92983398437497
								],
								[
									47.655859375000034,
									66.97592773437495
								],
								[
									47.70908203125009,
									67.04501953125006
								],
								[
									47.768066406250114,
									67.27563476562509
								],
								[
									47.839257812500136,
									67.35571289062506
								],
								[
									47.90820312499994,
									67.45468750000003
								],
								[
									47.88261718750016,
									67.51533203125007
								],
								[
									47.87470703125007,
									67.58417968749995
								],
								[
									48.278710937500136,
									67.65039062499994
								],
								[
									48.65380859375,
									67.69526367187504
								],
								[
									48.83320312500001,
									67.68149414062498
								],
								[
									48.8779296875,
									67.73134765625011
								],
								[
									48.76269531249994,
									67.82700195312503
								],
								[
									48.695703124999966,
									67.87421874999998
								],
								[
									48.754296875000136,
									67.89594726562507
								],
								[
									48.840625000000045,
									67.86972656250003
								],
								[
									48.95390624999999,
									67.8538085937501
								],
								[
									49.155273437500114,
									67.8704101562501
								],
								[
									49.93125000000009,
									68.06513671874998
								],
								[
									50.23320312500016,
									68.17534179687496
								],
								[
									50.414062500000114,
									68.21835937500012
								],
								[
									50.69941406250018,
									68.317724609375
								],
								[
									50.8388671875,
									68.349951171875
								],
								[
									51.078515625000136,
									68.36333007812507
								],
								[
									51.33613281250001,
									68.40244140624995
								],
								[
									51.61669921875,
									68.47631835937509
								],
								[
									51.99472656250009,
									68.53876953124993
								],
								[
									52.0556640625,
									68.54130859375007
								],
								[
									52.128808593750136,
									68.53203125000007
								],
								[
									52.28535156250007,
									68.45937500000008
								],
								[
									52.227441406249966,
									68.41860351562505
								],
								[
									52.18349609375002,
									68.37426757812509
								],
								[
									52.259179687500136,
									68.35092773437503
								],
								[
									52.322265625000114,
									68.33969726562503
								],
								[
									52.39667968750018,
									68.35170898437511
								],
								[
									52.475000000000136,
									68.38212890624999
								],
								[
									52.669726562500045,
									68.42675781250003
								],
								[
									52.72265625,
									68.48403320312497
								],
								[
									52.64765625000007,
									68.50615234375013
								],
								[
									52.55009765625016,
									68.59243164062494
								],
								[
									52.435058593750114,
									68.610205078125
								],
								[
									52.344042968750045,
									68.60815429687494
								],
								[
									52.683593750000114,
									68.73120117187506
								],
								[
									53.41289062499999,
									68.91254882812495
								],
								[
									53.80195312500001,
									68.99589843750007
								],
								[
									54.18583984375016,
									69.00332031250005
								],
								[
									54.491210937500114,
									68.99233398437505
								],
								[
									54.37626953125016,
									68.96474609374994
								],
								[
									53.874414062500136,
									68.92661132812498
								],
								[
									53.79765625000016,
									68.90747070312509
								],
								[
									53.798242187499966,
									68.88466796874997
								],
								[
									53.91953125000009,
									68.87124023437508
								],
								[
									53.97060546875002,
									68.84428710937499
								],
								[
									53.929296875000034,
									68.81186523437506
								],
								[
									53.89121093750009,
									68.80151367187509
								],
								[
									53.833886718750136,
									68.70893554687495
								],
								[
									53.758886718750034,
									68.63398437499995
								],
								[
									53.91767578125018,
									68.536962890625
								],
								[
									53.93085937500018,
									68.43554687499994
								],
								[
									53.829492187500136,
									68.382666015625
								],
								[
									53.690039062500034,
									68.40253906250007
								],
								[
									53.56669921875016,
									68.36708984374994
								],
								[
									53.34257812500016,
									68.34321289062504
								],
								[
									53.293359374999966,
									68.31166992187494
								],
								[
									53.26054687500016,
									68.26748046875
								],
								[
									53.40312500000016,
									68.25683593750003
								],
								[
									53.51513671874994,
									68.25966796875
								],
								[
									53.913671875000034,
									68.23120117187497
								],
								[
									53.96787109375009,
									68.22734374999999
								],
								[
									54.099218750000034,
									68.25903320312506
								],
								[
									54.23291015625,
									68.26630859374993
								],
								[
									54.393945312500136,
									68.27509765625004
								],
								[
									54.47617187500009,
									68.29414062500001
								],
								[
									54.56123046875018,
									68.27304687500006
								],
								[
									54.71796875000007,
									68.18417968749998
								],
								[
									54.861328125000114,
									68.20185546875004
								],
								[
									54.92304687500018,
									68.37382812499999
								],
								[
									55.15087890624994,
									68.48002929687505
								],
								[
									55.418066406250034,
									68.56782226562498
								],
								[
									55.675292968750114,
									68.57587890625001
								],
								[
									55.924609375000045,
									68.63730468750009
								],
								[
									56.04365234375001,
									68.64887695312507
								],
								[
									56.27568359375016,
									68.62407226562499
								],
								[
									56.62021484375009,
									68.61904296874994
								],
								[
									56.90937500000018,
									68.56669921875002
								],
								[
									57.126855468749966,
									68.5540039062501
								],
								[
									57.444335937500114,
									68.64150390625008
								],
								[
									58.17304687500007,
									68.88974609375012
								],
								[
									58.23701171875001,
									68.83393554687493
								],
								[
									58.353906250000136,
									68.91621093750007
								],
								[
									58.91894531249994,
									69.00380859375008
								],
								[
									59.05732421875018,
									69.0060546875001
								],
								[
									59.05986328125016,
									68.97255859375002
								],
								[
									59.11015624999999,
									68.89628906250002
								],
								[
									59.22041015625018,
									68.84960937500011
								],
								[
									59.370507812500136,
									68.73837890625
								],
								[
									59.29833984375,
									68.70844726562504
								],
								[
									59.222558593749966,
									68.69130859375008
								],
								[
									59.112304687500114,
									68.61630859375
								],
								[
									59.099023437500136,
									68.44433593750006
								],
								[
									59.31074218750001,
									68.40029296875005
								],
								[
									59.60429687500016,
									68.35112304687507
								],
								[
									59.72568359375009,
									68.35161132812499
								],
								[
									59.827539062500136,
									68.38032226562507
								],
								[
									59.858789062500136,
									68.39604492187507
								],
								[
									59.897363281249966,
									68.42192382812502
								],
								[
									59.922851562500114,
									68.47133789062505
								],
								[
									59.94140625,
									68.51049804687494
								],
								[
									59.865136718749966,
									68.60493164062507
								],
								[
									59.89599609374994,
									68.70634765624996
								],
								[
									60.16025390625009,
									68.69951171874999
								],
								[
									60.48916015625002,
									68.72895507812504
								],
								[
									60.6376953125,
									68.78701171874997
								],
								[
									60.81513671875018,
									68.89521484374998
								],
								[
									60.93359374999994,
									68.98676757812498
								],
								[
									60.85859375000007,
									69.14550781250009
								],
								[
									60.66455078124994,
									69.11025390625
								],
								[
									60.337304687499966,
									69.45703124999994
								],
								[
									60.17060546875007,
									69.59091796875003
								],
								[
									60.276464843750034,
									69.6526367187501
								],
								[
									60.558691406250034,
									69.69233398437493
								],
								[
									60.812988281250114,
									69.82114257812506
								],
								[
									60.909082031250136,
									69.84711914062493
								],
								[
									61.015917968750045,
									69.85146484375002
								],
								[
									61.770507812500114,
									69.76303710937503
								],
								[
									62.631250000000136,
									69.74311523437507
								],
								[
									63.361425781250034,
									69.67529296875
								],
								[
									64.19042968750011,
									69.53466796875006
								],
								[
									64.59218750000014,
									69.43564453124995
								],
								[
									64.92851562499999,
									69.32539062499995
								],
								[
									64.89628906249999,
									69.24780273437506
								],
								[
									65.03154296875005,
									69.2698242187501
								],
								[
									65.32675781250003,
									69.2013671875001
								],
								[
									65.52792968750009,
									69.17343750000009
								],
								[
									65.73574218750014,
									69.13232421874997
								],
								[
									65.81269531250018,
									69.07700195312498
								],
								[
									66.08476562499999,
									69.03632812499995
								],
								[
									66.36562500000014,
									68.96132812500002
								],
								[
									66.41611328125003,
									68.94785156249995
								],
								[
									66.75644531250009,
									68.89199218749994
								],
								[
									67.00244140625011,
									68.87358398437502
								],
								[
									67.14921875000016,
									68.75395507812507
								],
								[
									67.6396484375,
									68.57929687499993
								],
								[
									67.73076171875016,
									68.51367187500006
								],
								[
									68.15693359375001,
									68.40366210937512
								],
								[
									68.37119140625003,
									68.31425781250002
								],
								[
									68.50419921875016,
									68.34843749999996
								],
								[
									68.82949218749997,
									68.56743164062499
								],
								[
									69.02431640624997,
									68.81796875000006
								],
								[
									69.14052734375014,
									68.95063476562498
								],
								[
									68.92441406250003,
									68.95620117187497
								],
								[
									68.76289062500018,
									68.91738281249997
								],
								[
									68.65957031250002,
									68.92739257812497
								],
								[
									68.54277343750005,
									68.96708984374996
								],
								[
									68.35507812500009,
									69.06757812499993
								],
								[
									68.11738281250007,
									69.23623046875
								],
								[
									68.07304687500016,
									69.42080078124994
								],
								[
									68.005859375,
									69.48002929687502
								],
								[
									67.77431640625014,
									69.52998046874998
								],
								[
									67.62412109375009,
									69.58442382812507
								],
								[
									67.06445312500011,
									69.69370117187503
								],
								[
									66.96406250000018,
									69.65556640624999
								],
								[
									66.93417968750003,
									69.59667968749997
								],
								[
									66.89667968750007,
									69.55380859374995
								],
								[
									66.84023437500002,
									69.60917968750005
								],
								[
									66.80400390624999,
									69.65922851562502
								],
								[
									66.80292968750007,
									69.74013671875008
								],
								[
									66.83222656250007,
									69.8421875
								],
								[
									66.92636718750003,
									70.01425781250006
								],
								[
									67.06904296875018,
									70.00561523437497
								],
								[
									67.14443359374997,
									70.030615234375
								],
								[
									67.23925781250011,
									70.10805664062505
								],
								[
									67.19746093750001,
									70.17163085937506
								],
								[
									67.14648437499994,
									70.21992187500004
								],
								[
									67.15683593750003,
									70.29511718749998
								],
								[
									67.24687500000016,
									70.50009765625009
								],
								[
									67.28476562500003,
									70.73872070312504
								],
								[
									67.21152343750003,
									70.79843750000003
								],
								[
									67.14335937500005,
									70.837548828125
								],
								[
									66.82246093750001,
									70.79736328125009
								],
								[
									66.70224609375003,
									70.81850585937494
								],
								[
									66.67519531250014,
									70.86469726562501
								],
								[
									66.66611328125003,
									70.90058593750004
								],
								[
									66.75878906250011,
									70.96235351562501
								],
								[
									66.84707031249997,
									71.06372070312506
								],
								[
									66.69257812500001,
									71.04169921875001
								],
								[
									66.6396484375,
									71.08139648437503
								],
								[
									66.76806640624994,
									71.13989257812506
								],
								[
									66.91757812500003,
									71.28237304687494
								],
								[
									67.27421875000016,
									71.34785156249995
								],
								[
									67.54179687500005,
									71.41201171874997
								],
								[
									67.95937500000002,
									71.54838867187496
								],
								[
									68.26923828125018,
									71.68281249999998
								],
								[
									68.46943359375018,
									71.85263671874995
								],
								[
									68.60742187499994,
									72.01274414062496
								],
								[
									68.82968750000003,
									72.39155273437495
								],
								[
									69.03906249999994,
									72.669921875
								],
								[
									69.39140625000016,
									72.95551757812493
								],
								[
									69.61181640625011,
									72.98193359374997
								],
								[
									69.69433593749994,
									72.97753906249997
								],
								[
									69.70898437500011,
									72.956396484375
								],
								[
									69.65878906250009,
									72.93183593749998
								],
								[
									69.64511718750009,
									72.89755859375009
								],
								[
									69.73828124999994,
									72.88496093750001
								],
								[
									69.88750000000016,
									72.88256835937506
								],
								[
									70.17216796875016,
									72.90117187500005
								],
								[
									70.65537109375009,
									72.89038085937497
								],
								[
									71.50019531250018,
									72.913671875
								],
								[
									71.61699218750016,
									72.90209960937506
								],
								[
									71.92958984374997,
									72.81967773437503
								],
								[
									72.10097656249997,
									72.82900390625
								],
								[
									72.44638671875003,
									72.79033203125002
								],
								[
									72.63378906250011,
									72.744482421875
								],
								[
									72.81210937500009,
									72.69140624999994
								],
								[
									72.78740234375005,
									72.48295898437502
								],
								[
									72.75292968750011,
									72.34316406250005
								],
								[
									72.62441406250014,
									72.07944335937506
								],
								[
									72.57412109375002,
									72.01254882812509
								],
								[
									72.37499999999994,
									71.82163085937512
								],
								[
									72.27949218750001,
									71.6955078125001
								],
								[
									72.12968750000016,
									71.60917968749999
								],
								[
									71.91201171875014,
									71.54794921874995
								],
								[
									71.88437500000009,
									71.51137695312497
								],
								[
									71.86728515625009,
									71.45737304687498
								],
								[
									72.07929687500001,
									71.3066894531251
								],
								[
									72.58134765625016,
									71.15112304687503
								],
								[
									72.70449218750014,
									70.96323242187503
								],
								[
									72.73164062500007,
									70.82285156250003
								],
								[
									72.69999999999999,
									70.45732421874999
								],
								[
									72.6533203125,
									70.40341796875012
								],
								[
									72.56191406250002,
									70.34555664062495
								],
								[
									72.46943359375018,
									70.27495117187496
								],
								[
									72.52968750000014,
									70.17250976562497
								],
								[
									72.59941406250005,
									69.79321289062506
								],
								[
									72.61562500000014,
									69.48403320312494
								],
								[
									72.55732421875007,
									69.37841796875009
								],
								[
									72.52705078125001,
									69.15424804687507
								],
								[
									72.52734375,
									69.08051757812498
								],
								[
									72.57675781250003,
									68.96870117187504
								],
								[
									72.67832031250003,
									68.874853515625
								],
								[
									72.81191406250014,
									68.8152343750001
								],
								[
									73.19072265625016,
									68.70678710937506
								],
								[
									73.54804687500018,
									68.57451171875002
								],
								[
									73.57343750000001,
									68.53261718750008
								],
								[
									73.59169921875014,
									68.48188476562507
								],
								[
									73.46523437500002,
									68.43076171874995
								],
								[
									73.26640624999999,
									68.29448242187499
								],
								[
									73.13945312499999,
									68.18134765625004
								],
								[
									73.12939453125,
									68.09091796875009
								],
								[
									73.17304687500018,
									67.97304687500005
								],
								[
									73.15214843749999,
									67.86503906250007
								],
								[
									73.06679687500014,
									67.76694335937498
								],
								[
									72.94873046874994,
									67.69624023437504
								],
								[
									72.59433593750003,
									67.58696289062499
								],
								[
									71.84746093750005,
									67.0076171875001
								],
								[
									71.66816406250018,
									66.93969726562503
								],
								[
									71.36523437500011,
									66.96152343750003
								],
								[
									71.44892578125001,
									66.87895507812499
								],
								[
									71.55117187499997,
									66.76044921874993
								],
								[
									71.53955078125011,
									66.68310546874997
								],
								[
									71.34199218750018,
									66.6867187500001
								],
								[
									71.06562500000018,
									66.60449218749994
								],
								[
									70.93945312499994,
									66.54814453125002
								],
								[
									70.72490234375016,
									66.51943359374994
								],
								[
									70.56142578125014,
									66.54868164062495
								],
								[
									70.3828125,
									66.60249023437498
								],
								[
									70.40888671875007,
									66.64760742187494
								],
								[
									70.44257812500018,
									66.66826171875005
								],
								[
									70.56796875000003,
									66.70087890624995
								],
								[
									70.69072265624999,
									66.74531250000004
								],
								[
									70.63076171875014,
									66.75419921875007
								],
								[
									70.57910156250011,
									66.75375976562498
								],
								[
									70.44394531250009,
									66.6973144531251
								],
								[
									70.28339843750018,
									66.68579101562509
								],
								[
									70.09375,
									66.75434570312493
								],
								[
									69.94863281250002,
									66.82998046874997
								],
								[
									69.87714843750018,
									66.84545898437509
								],
								[
									69.74042968750001,
									66.81459960937494
								],
								[
									69.21777343749994,
									66.82861328125003
								],
								[
									69.07871093750003,
									66.81591796874994
								],
								[
									69.01347656249999,
									66.788330078125
								],
								[
									69.05117187500014,
									66.76635742187497
								],
								[
									69.09111328124999,
									66.72358398437495
								],
								[
									69.14394531250002,
									66.64072265624995
								],
								[
									69.1943359375,
									66.57866210937502
								],
								[
									69.41201171875002,
									66.51074218749994
								],
								[
									69.70097656250016,
									66.48457031250004
								],
								[
									69.98242187499994,
									66.40141601562496
								],
								[
									70.33945312500003,
									66.34238281250009
								],
								[
									71.14550781250011,
									66.36665039062498
								],
								[
									71.35800781250009,
									66.35942382812502
								],
								[
									71.56562500000018,
									66.33374023437494
								],
								[
									71.9169921875,
									66.24672851562508
								],
								[
									72.06757812500001,
									66.2533203125
								],
								[
									72.32158203124999,
									66.33212890625006
								],
								[
									72.38398437500018,
									66.50654296875007
								],
								[
									72.41738281249997,
									66.56079101562511
								],
								[
									73.34160156250016,
									66.80683593749995
								],
								[
									73.51357421875002,
									66.861083984375
								],
								[
									73.79208984375009,
									66.99531249999998
								],
								[
									73.88330078125011,
									67.08496093750003
								],
								[
									73.98623046875014,
									67.32768554687502
								],
								[
									74.07451171875016,
									67.41411132812505
								],
								[
									74.67607421875016,
									67.69462890624999
								],
								[
									74.76953125,
									67.76635742187494
								],
								[
									74.78730468750007,
									67.89750976562502
								],
								[
									74.77822265624997,
									67.9859375
								],
								[
									74.74267578125011,
									68.0735351562501
								],
								[
									74.63242187500003,
									68.2183105468751
								],
								[
									74.51123046874994,
									68.30307617187503
								],
								[
									74.39140625000016,
									68.42060546874993
								],
								[
									74.48095703125011,
									68.65888671875007
								],
								[
									74.57958984375011,
									68.75122070312503
								],
								[
									75.12460937500003,
									68.86171875
								],
								[
									75.58955078125018,
									68.90117187500005
								],
								[
									76.10751953125009,
									68.97573242187505
								],
								[
									76.3160156250002,
									68.99150390624996
								],
								[
									76.45917968750007,
									68.97827148437503
								],
								[
									76.60576171875016,
									68.89760742187494
								],
								[
									76.73505859375001,
									68.77690429687513
								],
								[
									77.11171875000014,
									68.59619140625009
								],
								[
									77.23847656250018,
									68.46958007812495
								],
								[
									77.26103515625016,
									68.31557617187502
								],
								[
									77.24843750000002,
									67.941015625
								],
								[
									77.1744140625002,
									67.77851562500004
								],
								[
									77.32509765624997,
									67.73564453125007
								],
								[
									77.39560546875003,
									67.69868164062493
								],
								[
									77.57919921875003,
									67.64394531249997
								],
								[
									77.67509765625016,
									67.589599609375
								],
								[
									77.77158203125009,
									67.57026367187507
								],
								[
									77.98554687500007,
									67.55917968750012
								],
								[
									78.58955078125018,
									67.57846679687495
								],
								[
									78.92246093750009,
									67.58911132812509
								],
								[
									78.88759765624997,
									67.61313476562509
								],
								[
									78.83906250000007,
									67.63120117187495
								],
								[
									78.55908203125011,
									67.63911132812495
								],
								[
									78.16123046875003,
									67.67836914062497
								],
								[
									77.58828125000014,
									67.75190429687501
								],
								[
									77.5201171875002,
									67.90961914062501
								],
								[
									77.53593750000005,
									68.00766601562509
								],
								[
									77.66484374999999,
									68.19038085937501
								],
								[
									77.75683593750011,
									68.22236328125004
								],
								[
									77.86826171875003,
									68.23471679687498
								],
								[
									77.99511718749994,
									68.25947265624995
								],
								[
									77.95869140625018,
									68.37705078125012
								],
								[
									77.9068359375002,
									68.48227539062506
								],
								[
									77.7852539062502,
									68.63046874999995
								],
								[
									77.65068359375016,
									68.90302734375007
								],
								[
									77.46630859375,
									68.90512695312495
								],
								[
									77.32832031250001,
									68.95864257812494
								],
								[
									76.64492187500014,
									69.11738281250004
								],
								[
									76.00097656249994,
									69.23505859375001
								],
								[
									75.56113281250003,
									69.25180664062498
								],
								[
									75.42001953125009,
									69.23862304687495
								],
								[
									75.05351562500005,
									69.11630859375009
								],
								[
									74.81484374999997,
									69.09057617187509
								],
								[
									74.36259765625016,
									69.14458007812507
								],
								[
									73.97744140625002,
									69.11464843750011
								],
								[
									73.83603515625009,
									69.14321289062497
								],
								[
									73.77568359375005,
									69.19824218750009
								],
								[
									73.89091796875016,
									69.41796875000009
								],
								[
									73.83271484375018,
									69.50390625
								],
								[
									73.66328125000007,
									69.61708984374997
								],
								[
									73.56015625000009,
									69.70722656250004
								],
								[
									73.57812500000011,
									69.802978515625
								],
								[
									73.83017578125003,
									70.17568359375008
								],
								[
									73.93740234375014,
									70.27285156250005
								],
								[
									74.20673828125018,
									70.44545898437497
								],
								[
									74.34335937500003,
									70.57871093750003
								],
								[
									74.31093750000002,
									70.6536132812501
								],
								[
									73.73154296875009,
									71.06870117187512
								],
								[
									73.57656250000014,
									71.21650390624993
								],
								[
									73.50722656250014,
									71.263525390625
								],
								[
									73.365234375,
									71.31977539062493
								],
								[
									73.15048828125003,
									71.38520507812493
								],
								[
									73.08623046875016,
									71.44492187500009
								],
								[
									73.67177734375002,
									71.845068359375
								],
								[
									73.939453125,
									71.91474609374998
								],
								[
									74.31123046875007,
									71.95781249999996
								],
								[
									74.48906250000016,
									71.99702148437495
								],
								[
									74.80410156250014,
									72.07739257812509
								],
								[
									74.99218749999994,
									72.14482421874996
								],
								[
									75.05322265624994,
									72.19921874999994
								],
								[
									75.08994140625009,
									72.2631347656251
								],
								[
									75.09707031250014,
									72.42065429687503
								],
								[
									75.06035156249999,
									72.54877929687493
								],
								[
									75.00800781250018,
									72.61943359375002
								],
								[
									74.89687500000002,
									72.71010742187502
								],
								[
									74.78681640625007,
									72.81186523437506
								],
								[
									74.86494140625018,
									72.83842773437496
								],
								[
									74.94218749999999,
									72.85380859374999
								],
								[
									75.15244140625003,
									72.85273437500004
								],
								[
									75.36933593750018,
									72.79663085937497
								],
								[
									75.47490234375016,
									72.68500976562507
								],
								[
									75.603515625,
									72.58105468750011
								],
								[
									75.60312500000009,
									72.51215820312493
								],
								[
									75.59140625000009,
									72.45722656249993
								],
								[
									75.64433593750016,
									72.38227539062493
								],
								[
									75.69111328125018,
									72.35000000000002
								],
								[
									75.74140625000001,
									72.29624023437509
								],
								[
									75.69443359375003,
									72.25351562500009
								],
								[
									75.64433593750016,
									72.23232421874994
								],
								[
									75.55019531250014,
									72.17080078125002
								],
								[
									75.39453124999994,
									71.98320312499999
								],
								[
									75.27382812499997,
									71.95893554687493
								],
								[
									75.24746093750002,
									71.81337890624994
								],
								[
									75.50322265625016,
									71.65463867187512
								],
								[
									75.46855468750005,
									71.53437500000004
								],
								[
									75.41718750000007,
									71.4946777343751
								],
								[
									75.28027343749994,
									71.43007812500011
								],
								[
									75.29804687500001,
									71.37846679687507
								],
								[
									75.33203125000011,
									71.34174804687495
								],
								[
									75.73359375000001,
									71.26591796874996
								],
								[
									76.11044921875003,
									71.21855468749999
								],
								[
									76.74199218750005,
									71.20205078125011
								],
								[
									76.92900390625005,
									71.1278808593751
								],
								[
									76.9952148437502,
									71.1810546875
								],
								[
									77.58964843750016,
									71.16791992187498
								],
								[
									78.06826171875014,
									70.98632812500003
								],
								[
									78.32060546875005,
									70.930419921875
								],
								[
									78.52578124999997,
									70.91181640625004
								],
								[
									78.94218749999999,
									70.93378906249998
								],
								[
									79.01542968749999,
									70.95019531249994
								],
								[
									79.08388671875002,
									71.00200195312502
								],
								[
									78.88867187500011,
									70.99716796875
								],
								[
									78.80351562499999,
									70.97353515625
								],
								[
									78.72392578125005,
									70.97597656250005
								],
								[
									78.58769531250016,
									70.99389648437497
								],
								[
									78.49140625000018,
									71.02539062500009
								],
								[
									78.38652343750005,
									71.08710937499995
								],
								[
									78.21259765625007,
									71.26630859374995
								],
								[
									77.90839843750018,
									71.32407226562509
								],
								[
									77.70664062500009,
									71.3005859375001
								],
								[
									77.48105468750003,
									71.3115722656251
								],
								[
									77.11367187499997,
									71.40937500000007
								],
								[
									76.87119140625003,
									71.44658203125007
								],
								[
									76.43339843750005,
									71.55249023437509
								],
								[
									76.3121093750002,
									71.59545898437503
								],
								[
									76.21572265625002,
									71.682861328125
								],
								[
									76.1036132812502,
									71.82900390625002
								],
								[
									76.03242187500007,
									71.91040039062509
								],
								[
									76.1240234375,
									71.926611328125
								],
								[
									76.42167968750016,
									72.00600585937502
								],
								[
									76.87138671874999,
									72.0330078125001
								],
								[
									77.06132812500016,
									72.0041992187501
								],
								[
									77.55078124999994,
									71.84208984375002
								],
								[
									77.77753906250007,
									71.83642578125011
								],
								[
									78.18691406250014,
									71.90708007812512
								],
								[
									78.23242187500011,
									71.952294921875
								],
								[
									78.14082031250018,
									72.04467773437509
								],
								[
									78.01640625000016,
									72.09204101562506
								],
								[
									77.78066406249997,
									72.11430664062496
								],
								[
									77.49287109375007,
									72.07172851562507
								],
								[
									77.41083984375007,
									72.10776367187506
								],
								[
									77.43974609375016,
									72.15654296875005
								],
								[
									77.47158203124997,
									72.19213867187509
								],
								[
									77.62529296875005,
									72.20141601562494
								],
								[
									77.73320312500016,
									72.22919921874993
								],
								[
									77.96816406249997,
									72.32871093749995
								],
								[
									78.22539062500016,
									72.37744140625011
								],
								[
									78.48261718750018,
									72.39497070312504
								],
								[
									79.42207031250018,
									72.38076171875008
								],
								[
									79.95390625000016,
									72.223046875
								],
								[
									80.47402343749997,
									72.15312499999996
								],
								[
									80.69921875000011,
									72.09829101562508
								],
								[
									80.76250000000005,
									72.08916015624999
								],
								[
									80.81474609375005,
									72.05429687500009
								],
								[
									80.85605468750009,
									71.97021484375
								],
								[
									81.51123046875,
									71.7461425781251
								],
								[
									81.66162109375,
									71.715966796875
								],
								[
									82.07988281249999,
									71.70683593749999
								],
								[
									82.54726562500002,
									71.75859375000005
								],
								[
									82.75781250000011,
									71.76411132812504
								],
								[
									82.98613281250016,
									71.748681640625
								],
								[
									83.10664062500001,
									71.7205078125001
								],
								[
									83.23359375000007,
									71.66816406249993
								],
								[
									83.16552734375011,
									71.602197265625
								],
								[
									83.10566406250018,
									71.56245117187498
								],
								[
									82.97705078125011,
									71.4513671875001
								],
								[
									82.91796874999994,
									71.41992187500009
								],
								[
									82.49316406250011,
									71.29287109375002
								],
								[
									82.32285156250003,
									71.260009765625
								],
								[
									82.2769531250002,
									71.0934570312501
								],
								[
									82.25429687500002,
									71.05620117187496
								],
								[
									82.23916015625014,
									70.99770507812494
								],
								[
									82.31601562500009,
									70.8794433593751
								],
								[
									82.33593749999994,
									70.80737304687506
								],
								[
									82.27070312500018,
									70.7067382812501
								],
								[
									82.1631835937502,
									70.59814453125009
								],
								[
									82.18242187500005,
									70.511474609375
								],
								[
									82.22119140625011,
									70.39570312499995
								],
								[
									82.23583984375,
									70.43027343749998
								],
								[
									82.2314453125,
									70.48291015625006
								],
								[
									82.25839843750003,
									70.54360351562508
								],
								[
									82.45166015625,
									70.69008789062508
								],
								[
									82.59248046875018,
									70.88994140625002
								],
								[
									82.73779296875011,
									70.94208984374998
								],
								[
									82.86914062499994,
									70.954833984375
								],
								[
									83.01015625000002,
									70.89541015625005
								],
								[
									83.05107421875016,
									70.81523437499999
								],
								[
									83.05839843750016,
									70.69472656250002
								],
								[
									83.03017578124997,
									70.58051757812495
								],
								[
									82.91982421874997,
									70.40742187500004
								],
								[
									82.74248046874999,
									70.28647460937509
								],
								[
									82.68232421875018,
									70.21772460937501
								],
								[
									82.76728515625018,
									70.15405273437503
								],
								[
									82.85654296875003,
									70.10454101562505
								],
								[
									82.9610351562502,
									70.08828124999994
								],
								[
									83.08076171875018,
									70.09301757812503
								],
								[
									83.10957031250018,
									70.10957031249993
								],
								[
									83.13203125000007,
									70.15717773437504
								],
								[
									83.09414062500014,
									70.22109375
								],
								[
									83.0738281250002,
									70.27670898437506
								],
								[
									83.29345703125,
									70.32133789062499
								],
								[
									83.4970703125,
									70.34526367187499
								],
								[
									83.65986328125001,
									70.41835937500005
								],
								[
									83.70048828125005,
									70.46640624999998
								],
								[
									83.73593750000009,
									70.54648437499995
								],
								[
									83.65126953125014,
									70.67221679687498
								],
								[
									83.57890625000016,
									70.76591796875007
								],
								[
									83.33388671875014,
									70.98852539062494
								],
								[
									83.15126953125014,
									71.10361328125003
								],
								[
									83.26601562499997,
									71.27587890624994
								],
								[
									83.4576171875002,
									71.467529296875
								],
								[
									83.53105468750016,
									71.51425781250012
								],
								[
									83.55048828125001,
									71.54365234375007
								],
								[
									83.57128906250011,
									71.594384765625
								],
								[
									83.55351562500005,
									71.64980468750011
								],
								[
									83.53437500000001,
									71.68393554687495
								],
								[
									83.34042968750003,
									71.82753906250008
								],
								[
									83.2002929687502,
									71.8747070312501
								],
								[
									82.75507812500018,
									71.90283203125006
								],
								[
									82.64541015625014,
									71.92524414062507
								],
								[
									82.31914062499999,
									72.07182617187502
								],
								[
									82.28066406249997,
									72.10512695312505
								],
								[
									82.20927734374999,
									72.21118164062506
								],
								[
									82.18359375000011,
									72.23754882812503
								],
								[
									82.09365234374997,
									72.26542968750002
								],
								[
									81.79287109374997,
									72.32661132812495
								],
								[
									81.58623046875016,
									72.35170898437511
								],
								[
									81.28271484374994,
									72.35883789062495
								],
								[
									81.09814453125011,
									72.38974609374995
								],
								[
									80.82705078125014,
									72.48828124999994
								],
								[
									80.79775390625014,
									72.51997070312501
								],
								[
									80.71962890625002,
									72.64790039062495
								],
								[
									80.65624999999994,
									72.71201171875006
								],
								[
									80.67539062500003,
									72.75917968750008
								],
								[
									80.77373046874999,
									72.86079101562498
								],
								[
									80.84160156250016,
									72.94916992187495
								],
								[
									80.75742187500009,
									73.025244140625
								],
								[
									80.63867187500011,
									73.04916992187509
								],
								[
									80.50966796875014,
									73.08608398437497
								],
								[
									80.45546875000002,
									73.15522460937493
								],
								[
									80.42451171875018,
									73.23115234375004
								],
								[
									80.41894531250011,
									73.28964843750003
								],
								[
									80.3980468750002,
									73.35683593749997
								],
								[
									80.45830078125016,
									73.41372070312511
								],
								[
									80.59589843750001,
									73.47402343750005
								],
								[
									80.56191406250014,
									73.51499023437495
								],
								[
									80.58320312500018,
									73.56845703125
								],
								[
									81.46884765625003,
									73.64042968750002
								],
								[
									81.8169921875002,
									73.65883789062494
								],
								[
									83.54472656249999,
									73.66650390625
								],
								[
									83.66699218749994,
									73.68647460937498
								],
								[
									84.41738281249997,
									73.72202148437503
								],
								[
									84.73789062500009,
									73.762841796875
								],
								[
									85.07744140625016,
									73.71953124999996
								],
								[
									85.20058593750014,
									73.72153320312509
								],
								[
									85.44833984375003,
									73.73461914062511
								],
								[
									85.61142578125003,
									73.82158203125005
								],
								[
									85.97929687500005,
									73.85693359374997
								],
								[
									86.59140625000003,
									73.89428710937494
								],
								[
									86.89296875000002,
									73.887109375
								],
								[
									86.96132812500002,
									73.86074218750005
								],
								[
									87.02949218750001,
									73.82416992187504
								],
								[
									86.69765625000002,
									73.71684570312505
								],
								[
									86.36591796875001,
									73.61977539062508
								],
								[
									86.09414062499997,
									73.57832031250007
								],
								[
									85.82705078125014,
									73.49277343749995
								],
								[
									85.80048828125001,
									73.45893554687498
								],
								[
									85.7925781250002,
									73.43833007812506
								],
								[
									85.80244140625018,
									73.37167968749998
								],
								[
									85.81816406250016,
									73.3269531250001
								],
								[
									86.09814453125011,
									73.27260742187505
								],
								[
									86.30791015625005,
									73.19575195312493
								],
								[
									86.51435546875018,
									73.14047851562495
								],
								[
									86.67705078124999,
									73.106787109375
								],
								[
									86.71503906250018,
									73.12583007812498
								],
								[
									86.1216796875002,
									73.30673828124998
								],
								[
									85.97080078125009,
									73.34707031249994
								],
								[
									85.91005859375014,
									73.39042968750007
								],
								[
									85.93896484375,
									73.45649414062493
								],
								[
									85.99892578125014,
									73.48583984375006
								],
								[
									86.09238281250009,
									73.51914062500009
								],
								[
									86.15507812500016,
									73.53466796875006
								],
								[
									86.37626953124999,
									73.56884765625
								],
								[
									87.12011718750011,
									73.61503906249999
								],
								[
									87.29443359375011,
									73.70468750000003
								],
								[
									87.36953125000014,
									73.7559082031251
								],
								[
									87.57119140624997,
									73.81074218749998
								],
								[
									87.50322265624999,
									73.83247070312507
								],
								[
									87.33750000000009,
									73.84604492187498
								],
								[
									87.20966796875007,
									73.87866210937506
								],
								[
									86.69707031250016,
									74.19531250000009
								],
								[
									86.57109375000016,
									74.24375
								],
								[
									86.17783203125009,
									74.27939453124998
								],
								[
									86.00136718750002,
									74.31601562499998
								],
								[
									86.18291015625016,
									74.42304687500001
								],
								[
									86.39580078125016,
									74.45009765624994
								],
								[
									86.53847656250002,
									74.44423828125
								],
								[
									86.66474609375007,
									74.41425781249993
								],
								[
									86.89794921874994,
									74.32534179687502
								],
								[
									87.22968750000007,
									74.36386718750003
								],
								[
									87.10615234375001,
									74.40356445312506
								],
								[
									86.89423828125018,
									74.44970703124994
								],
								[
									86.70009765624997,
									74.52246093749994
								],
								[
									86.42568359375014,
									74.58549804687499
								],
								[
									86.11611328125014,
									74.62856445312497
								],
								[
									85.79101562499994,
									74.64511718750006
								],
								[
									85.88076171875014,
									74.74023437500009
								],
								[
									86.05888671874999,
									74.72822265625001
								],
								[
									86.11953125000002,
									74.75742187500012
								],
								[
									86.20126953125003,
									74.8162109375001
								],
								[
									86.6514648437502,
									74.68242187500002
								],
								[
									86.8628906250002,
									74.71787109375003
								],
								[
									87.04179687500016,
									74.77885742187505
								],
								[
									87.41933593750014,
									74.94091796875011
								],
								[
									87.46757812500005,
									75.0132324218751
								],
								[
									87.28740234374999,
									75.05253906250002
								],
								[
									87.14072265625003,
									75.07226562499994
								],
								[
									86.93906250000009,
									75.06811523437509
								],
								[
									86.92167968749999,
									75.11279296874994
								],
								[
									87.0059570312502,
									75.16982421875002
								],
								[
									87.17080078125014,
									75.19174804687495
								],
								[
									87.67138671875,
									75.12958984375007
								],
								[
									88.50371093750016,
									75.2904785156251
								],
								[
									88.73310546875018,
									75.36918945312496
								],
								[
									89.31025390625018,
									75.4701171875
								],
								[
									89.59511718750014,
									75.45825195312506
								],
								[
									90.18496093750014,
									75.59106445312494
								],
								[
									91.00468750000016,
									75.64956054687497
								],
								[
									91.47949218749994,
									75.64965820312509
								],
								[
									91.84541015625018,
									75.72368164062496
								],
								[
									92.40751953125005,
									75.74965820312502
								],
								[
									92.60253906249994,
									75.77910156250007
								],
								[
									93.54980468750011,
									75.85410156249998
								],
								[
									94.07519531249994,
									75.91289062499996
								],
								[
									94.15634765625003,
									75.95922851562509
								],
								[
									93.68701171875011,
									75.92158203124995
								],
								[
									93.57402343749999,
									75.95629882812511
								],
								[
									93.47548828124997,
									75.93286132812494
								],
								[
									93.40605468750016,
									75.90126953125
								],
								[
									93.17812499999997,
									75.95898437499994
								],
								[
									93.1163085937502,
									75.94462890625005
								],
								[
									93.06865234375016,
									75.91284179687506
								],
								[
									92.98662109375016,
									75.90268554687512
								],
								[
									92.89042968749999,
									75.90996093749999
								],
								[
									92.85859375000018,
									75.97949218749994
								],
								[
									92.97158203125002,
									76.07509765624997
								],
								[
									93.10488281249997,
									76.02583007812507
								],
								[
									93.25927734375011,
									76.098779296875
								],
								[
									93.35957031250018,
									76.10073242187505
								],
								[
									93.64843749999994,
									76.05415039062507
								],
								[
									93.84287109375003,
									76.10131835937509
								],
								[
									94.10234375000016,
									76.12358398437499
								],
								[
									94.38828125000003,
									76.10278320312511
								],
								[
									94.50673828125014,
									76.1079589843751
								],
								[
									94.57558593750014,
									76.15175781250005
								],
								[
									95.03847656250002,
									76.11352539062509
								],
								[
									95.35927734374997,
									76.13959960937507
								],
								[
									95.5787109375002,
									76.13730468749995
								],
								[
									95.919921875,
									76.11313476562509
								],
								[
									96.07548828125016,
									76.08198242187495
								],
								[
									95.98603515625007,
									76.00966796874997
								],
								[
									95.65332031250011,
									75.8921875
								],
								[
									95.74384765625018,
									75.87231445312506
								],
								[
									95.93476562500018,
									75.92602539062497
								],
								[
									96.50859374999999,
									76.00556640624993
								],
								[
									96.60058593750011,
									75.98989257812494
								],
								[
									96.53769531250009,
									75.92163085937497
								],
								[
									96.4970703125,
									75.89121093750009
								],
								[
									96.87919921875005,
									75.93105468749994
								],
								[
									97.20546875000014,
									76.01870117187494
								],
								[
									97.35068359375003,
									76.03339843750001
								],
								[
									97.49921875000001,
									75.980224609375
								],
								[
									97.63769531250011,
									76.029052734375
								],
								[
									97.66982421874997,
									76.07802734375002
								],
								[
									97.91835937499997,
									76.08867187499999
								],
								[
									98.02001953125011,
									76.13369140625011
								],
								[
									98.19462890625016,
									76.16640625000011
								],
								[
									98.34199218750007,
									76.18056640624997
								],
								[
									98.66201171875014,
									76.24267578125
								],
								[
									98.77128906250005,
									76.22402343749994
								],
								[
									98.98466796875016,
									76.20756835937496
								],
								[
									99.18730468750005,
									76.17763671875
								],
								[
									99.56269531250007,
									76.10932617187493
								],
								[
									99.61562499999997,
									76.08232421875002
								],
								[
									99.6631835937502,
									76.07802734375002
								],
								[
									99.77041015625002,
									76.02875976562504
								],
								[
									99.68925781250016,
									75.9563476562501
								],
								[
									99.60234375000005,
									75.85205078125
								],
								[
									99.44218749999999,
									75.8031738281251
								],
								[
									99.54072265625018,
									75.79858398437494
								],
								[
									99.60937499999994,
									75.81127929687506
								],
								[
									99.73750000000007,
									75.88066406250007
								],
								[
									99.85136718750016,
									75.93027343749995
								],
								[
									99.82539062500018,
									76.13593749999993
								],
								[
									99.61679687500003,
									76.24018554687504
								],
								[
									99.46064453125001,
									76.27509765624995
								],
								[
									99.0938476562502,
									76.38432617187507
								],
								[
									98.96953124999999,
									76.43081054687497
								],
								[
									98.80566406250011,
									76.4806640625001
								],
								[
									98.86943359375005,
									76.50957031250002
								],
								[
									99.57626953125003,
									76.47143554687506
								],
								[
									99.93574218750001,
									76.48989257812511
								],
								[
									100.3223632812502,
									76.47915039062505
								],
								[
									100.84375,
									76.5251953125001
								],
								[
									101.06074218750007,
									76.47724609374993
								],
								[
									101.31074218750018,
									76.47890625
								],
								[
									101.59775390625003,
									76.43920898437509
								],
								[
									101.68378906250018,
									76.48549804687508
								],
								[
									101.21298828125009,
									76.53569335937502
								],
								[
									101.00263671875001,
									76.53051757812494
								],
								[
									100.92802734375005,
									76.55673828124995
								],
								[
									101.00624999999997,
									76.61508789062503
								],
								[
									101.09931640625018,
									76.70400390624994
								],
								[
									101.00820312500002,
									76.78134765625006
								],
								[
									100.92041015625,
									76.822509765625
								],
								[
									100.9058593750002,
									76.90068359375013
								],
								[
									100.98994140625001,
									76.99047851562494
								],
								[
									101.18574218750001,
									77.02856445312497
								],
								[
									101.29287109375002,
									77.10156250000011
								],
								[
									101.51767578125009,
									77.19809570312506
								],
								[
									102.61015625000016,
									77.50854492187497
								],
								[
									103.1314453125002,
									77.62646484375011
								],
								[
									103.33125000000007,
									77.64106445312507
								],
								[
									103.56074218750018,
									77.63193359374998
								],
								[
									104.01455078125002,
									77.73041992187504
								],
								[
									104.18486328125016,
									77.73046874999997
								],
								[
									104.81425781250005,
									77.652099609375
								],
								[
									104.96523437500014,
									77.59472656249994
								],
								[
									105.30898437500002,
									77.54921875
								],
								[
									105.71025390625016,
									77.52524414062509
								],
								[
									105.89453125000011,
									77.48886718750003
								],
								[
									105.98339843750011,
									77.44760742187509
								],
								[
									106.0595703125,
									77.39052734375
								],
								[
									105.73417968750005,
									77.35200195312504
								],
								[
									105.38457031250016,
									77.23784179687507
								],
								[
									104.91191406250005,
									77.17470703125
								],
								[
									104.32363281250002,
									77.13266601562495
								],
								[
									104.20244140624999,
									77.10180664062497
								],
								[
									105.32021484374997,
									77.09233398437507
								],
								[
									105.64589843749997,
									77.10068359375
								],
								[
									105.71201171875003,
									77.00146484375006
								],
								[
									105.82216796875014,
									76.99750976562495
								],
								[
									106.14541015624997,
									77.04531250000011
								],
								[
									106.33867187499999,
									77.0478515625
								],
								[
									106.70507812499994,
									77.01376953124998
								],
								[
									106.78369140625,
									77.0317871093751
								],
								[
									106.94160156250018,
									77.03437500000001
								],
								[
									107.27890625000003,
									76.99096679687503
								],
								[
									107.42978515625009,
									76.92656250000007
								],
								[
									107.19023437500005,
									76.822021484375
								],
								[
									106.94091796875011,
									76.73046875
								],
								[
									106.6387695312502,
									76.57338867187497
								],
								[
									106.5455078125002,
									76.58627929687512
								],
								[
									106.38466796875014,
									76.58945312499995
								],
								[
									106.41357421875,
									76.51225585937505
								],
								[
									106.6832031250002,
									76.5146972656251
								],
								[
									106.82539062500001,
									76.48007812500006
								],
								[
									107.15771484374994,
									76.52407226562505
								],
								[
									107.62421875000007,
									76.51010742187495
								],
								[
									107.72216796875011,
									76.52231445312495
								],
								[
									107.90224609375014,
									76.569677734375
								],
								[
									107.94990234375018,
									76.66064453125006
								],
								[
									108.02792968750009,
									76.71845703125004
								],
								[
									108.18164062500011,
									76.73784179687499
								],
								[
									108.35205078125011,
									76.71953124999999
								],
								[
									108.63837890625018,
									76.72011718750002
								],
								[
									109.36933593750007,
									76.7492187500001
								],
								[
									109.98115234375018,
									76.71186523437501
								],
								[
									110.47148437500016,
									76.7583984375
								],
								[
									111.1148437500002,
									76.723046875
								],
								[
									111.39248046875002,
									76.68666992187505
								],
								[
									111.60058593749994,
									76.62231445312509
								],
								[
									111.78613281250011,
									76.60356445312499
								],
								[
									111.93867187500018,
									76.55341796874998
								],
								[
									112.09394531250001,
									76.48032226562509
								],
								[
									112.01679687500001,
									76.42055664062511
								],
								[
									111.94267578125005,
									76.38046875
								],
								[
									112.14277343750001,
									76.423974609375
								],
								[
									112.29707031250018,
									76.43466796874995
								],
								[
									112.41328125000007,
									76.40830078125009
								],
								[
									112.61953124999997,
									76.38354492187511
								],
								[
									112.6841796875002,
									76.21884765624995
								],
								[
									112.74257812500002,
									76.18691406250002
								],
								[
									112.7984375000002,
									76.12963867187506
								],
								[
									112.72187500000007,
									76.07719726562496
								],
								[
									112.65625000000011,
									76.05356445312503
								],
								[
									112.8189453125002,
									76.05859375000009
								],
								[
									113.04667968750016,
									76.11411132812509
								],
								[
									113.09404296874999,
									76.13291015625003
								],
								[
									113.15039062499994,
									76.17451171875007
								],
								[
									113.06601562500009,
									76.21523437500011
								],
								[
									112.98798828125018,
									76.23974609374994
								],
								[
									113.08603515625009,
									76.25810546875005
								],
								[
									113.27265625000018,
									76.25166015625007
								],
								[
									113.36552734375016,
									76.17885742187497
								],
								[
									113.42773437499994,
									76.11210937499996
								],
								[
									113.56386718749997,
									75.89165039062499
								],
								[
									113.85722656250016,
									75.9212890625
								],
								[
									113.87099609375014,
									75.85600585937502
								],
								[
									113.74873046875018,
									75.70478515625001
								],
								[
									113.61992187500005,
									75.59267578125011
								],
								[
									113.56757812500001,
									75.56840820312505
								],
								[
									113.4859375000002,
									75.56396484375003
								],
								[
									113.51718750000009,
									75.6218750000001
								],
								[
									113.46904296875005,
									75.6566894531251
								],
								[
									113.3916015625,
									75.67788085937497
								],
								[
									113.12636718750014,
									75.69868164062501
								],
								[
									112.62919921874999,
									75.83540039062498
								],
								[
									112.49667968750009,
									75.84990234375002
								],
								[
									112.46611328125016,
									75.84365234375008
								],
								[
									112.45302734374997,
									75.83017578125009
								],
								[
									112.7295898437502,
									75.73764648437506
								],
								[
									112.95566406250009,
									75.57192382812505
								],
								[
									113.16152343750002,
									75.6205078125
								],
								[
									113.24296875000016,
									75.61142578125
								],
								[
									113.35625000000016,
									75.53427734375009
								],
								[
									113.55888671875005,
									75.50205078125012
								],
								[
									113.7261718750002,
									75.45063476562504
								],
								[
									113.61357421875016,
									75.29296874999997
								],
								[
									112.9249023437502,
									75.01503906250002
								],
								[
									112.1919921875002,
									74.853173828125
								],
								[
									111.86826171875003,
									74.74003906250013
								],
								[
									111.29902343750018,
									74.65844726562503
								],
								[
									110.89277343750018,
									74.54809570312509
								],
								[
									110.37353515625011,
									74.466064453125
								],
								[
									110.22587890625005,
									74.37866210937503
								],
								[
									109.84033203125,
									74.32197265624995
								],
								[
									109.86640625000018,
									74.29306640625
								],
								[
									109.91132812500018,
									74.26132812500003
								],
								[
									109.86386718750009,
									74.20888671875008
								],
								[
									109.81025390625018,
									74.169189453125
								],
								[
									109.5108398437502,
									74.08881835937507
								],
								[
									109.07500000000005,
									74.03232421875
								],
								[
									108.19951171875005,
									73.69409179687503
								],
								[
									107.76542968750016,
									73.62499999999997
								],
								[
									107.27109375000009,
									73.62104492187507
								],
								[
									107.1669921875,
									73.5894042968751
								],
								[
									106.79423828124999,
									73.37666015624993
								],
								[
									106.67939453125007,
									73.33066406250006
								],
								[
									106.18867187500018,
									73.30800781249997
								],
								[
									105.67714843750014,
									72.95927734375007
								],
								[
									105.39277343750001,
									72.84101562499995
								],
								[
									105.14394531250014,
									72.77705078124998
								],
								[
									105.40273437500002,
									72.78994140624994
								],
								[
									105.70820312500018,
									72.83666992187506
								],
								[
									106.06669921874999,
									72.94985351562511
								],
								[
									106.15957031250002,
									73.00200195312507
								],
								[
									106.20878906249999,
									73.060546875
								],
								[
									106.31503906250009,
									73.10639648437493
								],
								[
									106.47792968750014,
									73.13940429687509
								],
								[
									107.10878906250014,
									73.17729492187499
								],
								[
									107.36875000000009,
									73.16313476562513
								],
								[
									107.75039062500002,
									73.1731445312501
								],
								[
									108.00126953125016,
									73.23559570312506
								],
								[
									108.15097656250009,
									73.25791015624998
								],
								[
									108.28535156250001,
									73.265869140625
								],
								[
									108.35146484374997,
									73.31020507812497
								],
								[
									108.57539062500007,
									73.3190429687501
								],
								[
									109.08994140625009,
									73.37841796875011
								],
								[
									109.1656250000002,
									73.39960937499998
								],
								[
									109.3310546875,
									73.48745117187494
								],
								[
									109.63710937499997,
									73.45400390625005
								],
								[
									109.85527343750005,
									73.47246093749999
								],
								[
									110.42871093749994,
									73.62890624999997
								],
								[
									110.77333984375002,
									73.68916015625007
								],
								[
									110.86816406249994,
									73.73071289062503
								],
								[
									110.79921875000014,
									73.75976562500009
								],
								[
									110.72236328125018,
									73.77993164062511
								],
								[
									110.38828125000009,
									73.72602539062495
								],
								[
									110.09121093750014,
									73.70854492187513
								],
								[
									109.75273437499999,
									73.72255859375005
								],
								[
									109.70673828125007,
									73.74375
								],
								[
									109.6656250000002,
									73.80024414062507
								],
								[
									109.77412109375018,
									73.88125000000005
								],
								[
									109.86914062500011,
									73.93061523437498
								],
								[
									110.08388671875014,
									73.994384765625
								],
								[
									110.26142578125018,
									74.01743164062509
								],
								[
									110.92011718750007,
									73.94790039062502
								],
								[
									111.05625000000009,
									73.93935546875008
								],
								[
									111.13085937500011,
									74.05283203125
								],
								[
									111.3414062500002,
									74.04736328125006
								],
								[
									111.55058593750016,
									74.02851562500004
								],
								[
									111.45996093750011,
									74.0048339843751
								],
								[
									111.2281250000002,
									73.96855468750007
								],
								[
									111.29951171875018,
									73.88486328124998
								],
								[
									111.40039062500011,
									73.82773437499998
								],
								[
									111.80371093749994,
									73.74526367187497
								],
								[
									112.14726562500016,
									73.70893554687501
								],
								[
									112.4000000000002,
									73.71113281250004
								],
								[
									112.79541015625011,
									73.74609375000006
								],
								[
									112.85595703125011,
									73.771142578125
								],
								[
									112.93964843750018,
									73.83564453125007
								],
								[
									112.83593750000011,
									73.962060546875
								],
								[
									112.93496093750014,
									73.94570312499994
								],
								[
									113.03281250000009,
									73.91386718750013
								],
								[
									113.18154296874997,
									73.83740234375
								],
								[
									113.32685546875001,
									73.70742187500008
								],
								[
									113.41621093750018,
									73.64760742187497
								],
								[
									113.36445312500001,
									73.58276367187509
								],
								[
									113.15693359375001,
									73.45957031250003
								],
								[
									113.27695312500009,
									73.39150390625002
								],
								[
									113.49091796875007,
									73.34609375
								],
								[
									113.48759765625016,
									73.1451171875
								],
								[
									113.47460937500011,
									73.04785156250009
								],
								[
									113.36933593750007,
									72.94189453125009
								],
								[
									113.24736328125016,
									72.89721679687494
								],
								[
									113.12783203124997,
									72.83066406249998
								],
								[
									113.15820312500011,
									72.76948242187504
								],
								[
									113.1861328125002,
									72.73017578124993
								],
								[
									113.31220703125007,
									72.65737304687494
								],
								[
									113.66455078125,
									72.63452148437509
								],
								[
									113.71191406249994,
									72.65415039062506
								],
								[
									113.63007812500007,
									72.67709960937495
								],
								[
									113.39140625000005,
									72.71103515625003
								],
								[
									113.29814453125005,
									72.73886718750009
								],
								[
									113.21552734375018,
									72.80585937499998
								],
								[
									113.31152343750011,
									72.87832031250008
								],
								[
									113.41748046875011,
									72.93217773437496
								],
								[
									113.54277343750005,
									73.05434570312508
								],
								[
									113.58144531250002,
									73.14223632812502
								],
								[
									113.55888671875005,
									73.23261718750007
								],
								[
									113.63916015624994,
									73.27358398437497
								],
								[
									113.76523437500009,
									73.31796874999995
								],
								[
									113.82929687500007,
									73.32656250000002
								],
								[
									113.88623046875011,
									73.34580078125003
								],
								[
									113.79511718750001,
									73.367431640625
								],
								[
									113.71132812500002,
									73.37856445312505
								],
								[
									113.53945312499997,
									73.43364257812499
								],
								[
									113.5103515625002,
									73.50498046874995
								],
								[
									113.85693359375011,
									73.53339843750007
								],
								[
									114.06054687500011,
									73.58466796874993
								],
								[
									114.81601562500009,
									73.60717773437509
								],
								[
									115.33769531250016,
									73.70258789062507
								],
								[
									116.49550781250014,
									73.67607421874999
								],
								[
									117.30859375000011,
									73.59916992187496
								],
								[
									118.4501953125,
									73.5897949218751
								],
								[
									118.87089843750016,
									73.53789062499999
								],
								[
									118.9112304687502,
									73.51835937500002
								],
								[
									118.93642578125002,
									73.48120117187509
								],
								[
									118.75449218750009,
									73.46450195312497
								],
								[
									118.45703124999994,
									73.46440429687513
								],
								[
									118.37656250000009,
									73.36723632812496
								],
								[
									118.4302734375002,
									73.24653320312507
								],
								[
									118.96035156250002,
									73.11728515625009
								],
								[
									119.42529296874994,
									73.06396484375009
								],
								[
									119.75039062500002,
									72.97910156250012
								],
								[
									119.92167968749999,
									72.97133789062502
								],
								[
									120.59794921875005,
									72.98110351562508
								],
								[
									120.9971679687502,
									72.9367187500001
								],
								[
									121.35429687499999,
									72.97084960937494
								],
								[
									121.74785156249999,
									72.96967773437504
								],
								[
									121.88603515625016,
									72.96088867187495
								],
								[
									122.02978515624994,
									72.89721679687494
								],
								[
									122.26015625000002,
									72.88056640624993
								],
								[
									122.53750000000002,
									72.87778320312498
								],
								[
									122.69208984375018,
									72.89082031250007
								],
								[
									122.75195312500011,
									72.90649414062497
								],
								[
									122.73085937499997,
									72.93129882812497
								],
								[
									122.50195312499994,
									72.97065429687498
								],
								[
									122.52675781250014,
									73.01669921874995
								],
								[
									122.61523437499994,
									73.02792968750012
								],
								[
									122.99931640625005,
									72.9646484375001
								],
								[
									123.16035156250018,
									72.95488281250005
								],
								[
									123.30117187499997,
									73.00180664062503
								],
								[
									123.40458984374999,
									73.08564453125004
								],
								[
									123.46162109375018,
									73.144189453125
								],
								[
									123.52187500000002,
									73.17290039062507
								],
								[
									123.57246093750018,
									73.17734375000009
								],
								[
									123.62226562500001,
									73.19326171875005
								],
								[
									123.50097656250011,
									73.26162109374994
								],
								[
									123.38388671875003,
									73.34731445312508
								],
								[
									123.35527343749999,
									73.40249023437494
								],
								[
									123.32265625000002,
									73.43081054687494
								],
								[
									123.30507812499997,
									73.53291015624995
								],
								[
									123.41621093750007,
									73.636865234375
								],
								[
									123.49111328125014,
									73.66635742187506
								],
								[
									123.796875,
									73.62675781250007
								],
								[
									123.93388671874999,
									73.68930664062512
								],
								[
									124.01904296874994,
									73.7123046875
								],
								[
									124.38808593750002,
									73.75483398437495
								],
								[
									124.54121093750001,
									73.75126953125013
								],
								[
									124.79628906250014,
									73.71176757812498
								],
								[
									125.61708984375002,
									73.52060546875003
								],
								[
									125.59853515625014,
									73.44741210937502
								],
								[
									125.79443359375,
									73.46845703125007
								],
								[
									125.88789062500001,
									73.49809570312505
								],
								[
									126.107421875,
									73.51748046875011
								],
								[
									126.2544921875002,
									73.54819335937506
								],
								[
									126.2959960937502,
									73.53666992187502
								],
								[
									126.34492187500007,
									73.50629882812495
								],
								[
									126.30888671875016,
									73.46367187500007
								],
								[
									126.25742187500009,
									73.419775390625
								],
								[
									126.29248046875011,
									73.39418945312494
								],
								[
									126.33544921875,
									73.38876953125009
								],
								[
									126.55253906250016,
									73.33491210937504
								],
								[
									126.83847656250003,
									73.4341796875
								],
								[
									126.9551757812502,
									73.52822265625008
								],
								[
									127.03134765625009,
									73.54746093750009
								],
								[
									127.7403320312502,
									73.48154296874998
								],
								[
									127.955078125,
									73.44555664062511
								],
								[
									127.99687500000016,
									73.42563476562495
								],
								[
									128.02568359375016,
									73.39077148437505
								],
								[
									128.1416992187501,
									73.35239257812495
								],
								[
									128.2814453125,
									73.33056640624994
								],
								[
									128.26416015625,
									73.3007324218751
								],
								[
									128.2578125000001,
									73.26748046874997
								],
								[
									128.5870117187502,
									73.26240234375001
								],
								[
									128.7304687500001,
									73.23339843750006
								],
								[
									128.8886718750001,
									73.19023437499996
								],
								[
									128.8716796875002,
									73.13935546874998
								],
								[
									128.91337890625,
									73.11059570312509
								],
								[
									129.0591796875002,
									73.10751953124998
								],
								[
									129.1005859375001,
									73.11235351562499
								],
								[
									129.0537109375,
									73.04541015624994
								],
								[
									128.85351562499994,
									72.97260742187504
								],
								[
									128.73525390625014,
									72.94326171875
								],
								[
									128.59902343749997,
									72.89516601562497
								],
								[
									128.67402343750018,
									72.88588867187502
								],
								[
									129.01728515625,
									72.87246093749997
								],
								[
									129.2291015625002,
									72.77573242187498
								],
								[
									129.25039062499997,
									72.70517578125009
								],
								[
									129.11757812500014,
									72.67695312499993
								],
								[
									128.81533203125002,
									72.58588867187501
								],
								[
									128.63339843750003,
									72.55014648437503
								],
								[
									128.50849609375,
									72.54731445312498
								],
								[
									128.41826171875005,
									72.53515625000009
								],
								[
									128.5494140625002,
									72.49584960937497
								],
								[
									129.11660156250002,
									72.48574218749997
								],
								[
									129.2813476562501,
									72.43769531250004
								],
								[
									129.4117187500001,
									72.3154785156251
								],
								[
									129.41064453124994,
									72.16630859374999
								],
								[
									129.28349609375016,
									72.09204101562506
								],
								[
									128.93496093750014,
									72.07949218750005
								],
								[
									128.4751953125001,
									72.24555664062507
								],
								[
									128.19697265625007,
									72.30961914062496
								],
								[
									127.80341796875018,
									72.4340332031251
								],
								[
									127.72607421874994,
									72.41318359375
								],
								[
									127.8414062500002,
									72.30825195312505
								],
								[
									128.02656250000018,
									72.25000000000009
								],
								[
									128.35878906249997,
									72.0883300781251
								],
								[
									128.91142578125005,
									71.75532226562493
								],
								[
									129.04013671875003,
									71.78242187500004
								],
								[
									129.11660156250002,
									71.82460937500011
								],
								[
									129.15419921875014,
									71.878662109375
								],
								[
									129.12158203124994,
									71.95322265625
								],
								[
									129.21025390625016,
									71.91694335937498
								],
								[
									129.291796875,
									71.85019531249998
								],
								[
									129.46083984374997,
									71.73930664062505
								],
								[
									129.23417968750016,
									71.74482421875001
								],
								[
									128.94902343750016,
									71.70756835937496
								],
								[
									128.8432617187501,
									71.66347656250005
								],
								[
									128.92265625,
									71.60175781250007
								],
								[
									129.13427734374994,
									71.59287109375003
								],
								[
									129.22451171875014,
									71.50883789062507
								],
								[
									129.38984375000018,
									71.40488281250003
								],
								[
									129.7619140625,
									71.11953125000008
								],
								[
									130.0259765625001,
									71.06538085937504
								],
								[
									130.28124999999994,
									70.94731445312507
								],
								[
									130.5371093750001,
									70.89252929687493
								],
								[
									130.66845703124994,
									70.88833007812505
								],
								[
									130.75712890625,
									70.96235351562501
								],
								[
									130.83193359375014,
									70.93588867187506
								],
								[
									130.8980468750002,
									70.803564453125
								],
								[
									131.02158203125003,
									70.74609375000003
								],
								[
									131.157421875,
									70.74218750000003
								],
								[
									131.26826171875,
									70.76552734375008
								],
								[
									131.43232421875018,
									70.82827148437505
								],
								[
									131.5620117187501,
									70.90102539062497
								],
								[
									131.7690429687501,
									71.10141601562512
								],
								[
									131.9064453125,
									71.20263671874994
								],
								[
									132.03535156250018,
									71.24404296875002
								],
								[
									131.9908203125001,
									71.29321289062511
								],
								[
									132.00371093750005,
									71.35019531250009
								],
								[
									132.09882812500007,
									71.48398437499998
								],
								[
									132.2276367187502,
									71.6427734375001
								],
								[
									132.3257812500002,
									71.72622070312502
								],
								[
									132.56230468750016,
									71.89531250000002
								],
								[
									132.6539062500001,
									71.92597656250004
								],
								[
									132.7158203125,
									71.87148437499997
								],
								[
									132.7685546875,
									71.79873046875005
								],
								[
									132.80361328125002,
									71.76757812500003
								],
								[
									132.83925781249997,
									71.75517578124999
								],
								[
									133.130859375,
									71.60668945312503
								],
								[
									133.42617187500002,
									71.49096679687506
								],
								[
									133.68886718749997,
									71.43422851562497
								],
								[
									134.10283203125005,
									71.37895507812499
								],
								[
									134.7027343750002,
									71.38681640625009
								],
								[
									134.81386718750002,
									71.46059570312511
								],
								[
									135.02236328125014,
									71.5150390625
								],
								[
									135.35937499999994,
									71.5435058593751
								],
								[
									135.5591796875001,
									71.61035156249997
								],
								[
									135.88476562499994,
									71.6305664062501
								],
								[
									136.0903320312501,
									71.61958007812498
								],
								[
									136.40615234375014,
									71.57075195312498
								],
								[
									137.1158203125002,
									71.41567382812511
								],
								[
									137.3154296875001,
									71.3594238281251
								],
								[
									137.4174804687501,
									71.29902343749995
								],
								[
									137.65058593750018,
									71.20815429687511
								],
								[
									137.7978515625,
									71.16391601562506
								],
								[
									137.93964843750018,
									71.13339843750006
								],
								[
									137.99169921874994,
									71.142724609375
								],
								[
									137.9737304687502,
									71.16865234374995
								],
								[
									137.90195312500003,
									71.19404296875007
								],
								[
									137.84404296875016,
									71.22680664062509
								],
								[
									138.01269531249994,
									71.26083984375009
								],
								[
									138.03251953125,
									71.28583984375001
								],
								[
									138.09062500000005,
									71.30742187500007
								],
								[
									138.3140625000001,
									71.32553710937503
								],
								[
									138.0971679687501,
									71.35859374999993
								],
								[
									138.02216796875,
									71.36342773437494
								],
								[
									137.91835937500002,
									71.38408203124996
								],
								[
									137.9273437500001,
									71.42978515624995
								],
								[
									137.99570312500003,
									71.46352539062508
								],
								[
									138.0483398437501,
									71.5259765625
								],
								[
									138.11845703125,
									71.56616210937503
								],
								[
									138.23417968750016,
									71.59633789062505
								],
								[
									138.31806640625018,
									71.60283203125013
								],
								[
									138.5251953125,
									71.56274414062494
								],
								[
									138.6700195312502,
									71.63481445312507
								],
								[
									138.78017578125002,
									71.62900390624995
								],
								[
									139.00488281249994,
									71.55605468750011
								],
								[
									139.20937500000014,
									71.44477539062498
								],
								[
									139.32021484374997,
									71.44472656250005
								],
								[
									139.63212890625,
									71.48925781250009
								],
								[
									139.98417968750016,
									71.4915039062501
								],
								[
									139.93876953125016,
									71.55766601562507
								],
								[
									139.69511718750016,
									71.70043945312503
								],
								[
									139.72294921875005,
									71.88496093749995
								],
								[
									139.5523437500002,
									71.92670898437501
								],
								[
									139.35927734375014,
									71.95136718749998
								],
								[
									139.6402343750001,
									71.99833984374996
								],
								[
									139.84707031250002,
									72.14858398437502
								],
								[
									140.01406250000002,
									72.16210937500003
								],
								[
									140.18769531250007,
									72.19130859375002
								],
								[
									140.1343750000002,
									72.20961914062502
								],
								[
									139.61699218750005,
									72.22568359375
								],
								[
									139.50527343750002,
									72.20766601562505
								],
								[
									139.43046875000016,
									72.16347656249994
								],
								[
									139.1763671875001,
									72.16347656249994
								],
								[
									139.14501953125,
									72.26440429687509
								],
								[
									139.1408203125,
									72.32973632812505
								],
								[
									139.47363281249994,
									72.46650390624995
								],
								[
									139.6011718750002,
									72.49609374999994
								],
								[
									140.45058593750014,
									72.49311523437495
								],
								[
									140.7050781250001,
									72.51894531250005
								],
								[
									141.07929687500007,
									72.58691406249997
								],
								[
									140.983203125,
									72.63002929687505
								],
								[
									140.9728515625,
									72.7169921875001
								],
								[
									140.6523437500001,
									72.84282226562496
								],
								[
									140.67597656250007,
									72.87163085937507
								],
								[
									140.7081054687502,
									72.8900390625
								],
								[
									140.8082031250001,
									72.890966796875
								],
								[
									141.309765625,
									72.85771484375007
								],
								[
									141.51835937500016,
									72.78867187499995
								],
								[
									142.06142578125014,
									72.72080078124998
								],
								[
									143.5158203125,
									72.6982421875
								],
								[
									143.68095703125,
									72.67319335937503
								],
								[
									144.30390625000018,
									72.64301757812504
								],
								[
									144.56865234375005,
									72.60991210937513
								],
								[
									145.1993164062501,
									72.57021484374994
								],
								[
									145.48574218749997,
									72.54208984374998
								],
								[
									145.71416015625016,
									72.49736328125002
								],
								[
									146.08330078125016,
									72.47138671875007
								],
								[
									146.25292968749994,
									72.44223632812498
								],
								[
									146.23476562500002,
									72.34970703125003
								],
								[
									145.46708984375,
									72.36206054687509
								],
								[
									145.2128906250001,
									72.39267578125
								],
								[
									144.89746093749994,
									72.39624023437503
								],
								[
									144.7763671875,
									72.38227539062493
								],
								[
									144.58759765625018,
									72.30551757812509
								],
								[
									144.3609375000001,
									72.2653320312501
								],
								[
									144.16923828125,
									72.2587890625
								],
								[
									144.29492187499994,
									72.19262695312503
								],
								[
									144.47070312499994,
									72.17475585937493
								],
								[
									145.03916015625003,
									72.25986328124995
								],
								[
									146.59414062500014,
									72.30244140624993
								],
								[
									146.83183593750016,
									72.29541015625
								],
								[
									146.80703124999997,
									72.236572265625
								],
								[
									146.5992187500001,
									72.12353515624997
								],
								[
									146.40166015625016,
									72.03549804687498
								],
								[
									146.1132812500001,
									71.94497070312502
								],
								[
									146.005859375,
									71.94545898437494
								],
								[
									146.23027343750016,
									72.13750000000007
								],
								[
									146.13730468750003,
									72.14648437499994
								],
								[
									146.05146484375007,
									72.14228515624998
								],
								[
									145.79941406250003,
									72.22187500000004
								],
								[
									145.75859375000016,
									72.22587890624996
								],
								[
									145.70966796875007,
									72.20634765625007
								],
								[
									145.71015625000007,
									72.17758789062498
								],
								[
									145.6640625,
									72.0669921875
								],
								[
									145.75673828125014,
									72.02065429687508
								],
								[
									145.75673828125014,
									71.94130859375008
								],
								[
									145.4072265625,
									71.89013671874994
								],
								[
									145.27119140625018,
									71.89462890624998
								],
								[
									145.12578125000005,
									71.92714843749994
								],
								[
									145.06396484374994,
									71.92607421874999
								],
								[
									145.0468750000001,
									71.90102539062494
								],
								[
									145.0777343750002,
									71.854638671875
								],
								[
									145.07373046875,
									71.83085937500005
								],
								[
									145.01787109375016,
									71.79370117187511
								],
								[
									144.98964843750002,
									71.75336914062507
								],
								[
									145.07558593750002,
									71.70737304687509
								],
								[
									145.1885742187502,
									71.69580078124997
								],
								[
									145.8047851562501,
									71.746484375
								],
								[
									146.07324218749994,
									71.80834960937506
								],
								[
									146.36796875000016,
									71.92207031250007
								],
								[
									146.89472656250018,
									72.19750976562494
								],
								[
									147.12705078125003,
									72.29204101562502
								],
								[
									147.2618164062501,
									72.32788085937503
								],
								[
									147.43398437499997,
									72.34091796874995
								],
								[
									148.40205078125,
									72.3119628906251
								],
								[
									148.9648437500001,
									72.25234375000002
								],
								[
									149.5015625000002,
									72.16430664062503
								],
								[
									149.7662109375002,
									72.09125976562507
								],
								[
									149.96308593750018,
									71.99218750000003
								],
								[
									149.9981445312502,
									71.95048828124999
								],
								[
									150.01689453125005,
									71.89565429687508
								],
								[
									149.88105468750007,
									71.84301757812494
								],
								[
									149.27968750000014,
									71.82553710937512
								],
								[
									149.04873046875014,
									71.79575195312509
								],
								[
									148.9653320312501,
									71.76279296875003
								],
								[
									148.95488281250005,
									71.74414062500006
								],
								[
									148.92333984375,
									71.71464843749999
								],
								[
									148.96816406249997,
									71.69047851562505
								],
								[
									149.23789062500003,
									71.68793945312504
								],
								[
									149.4980468750001,
									71.66401367187507
								],
								[
									149.85712890625018,
									71.60146484374994
								],
								[
									149.9126953125002,
									71.58071289062497
								],
								[
									150.0264648437502,
									71.52133789062495
								],
								[
									150.06083984375,
									71.51083984374995
								],
								[
									150.5998046875,
									71.52011718750006
								],
								[
									150.6348632812501,
									71.49887695312509
								],
								[
									150.66777343750005,
									71.45522460937508
								],
								[
									150.52509765625018,
									71.38583984375006
								],
								[
									150.3847656250001,
									71.33881835937498
								],
								[
									150.09765624999994,
									71.22656249999994
								],
								[
									150.24296875000016,
									71.26718749999995
								],
								[
									150.82167968750014,
									71.362890625
								],
								[
									150.96777343749994,
									71.38046875000003
								],
								[
									151.14531250000016,
									71.37373046874998
								],
								[
									151.58242187500014,
									71.28696289062506
								],
								[
									151.7597656250001,
									71.21782226562502
								],
								[
									152.0927734375,
									71.023291015625
								],
								[
									151.99980468750016,
									71.00249023437513
								],
								[
									151.76201171875,
									70.98247070312505
								],
								[
									152.5087890625001,
									70.83447265625
								],
								[
									152.7983398437501,
									70.83564453125007
								],
								[
									153.46064453125,
									70.87861328124993
								],
								[
									153.794140625,
									70.87998046875003
								],
								[
									154.41396484375002,
									70.974462890625
								],
								[
									155.02949218750018,
									71.03422851562502
								],
								[
									155.5958984375,
									71.03862304687502
								],
								[
									155.89521484375018,
									71.09550781250007
								],
								[
									156.6845703125001,
									71.09374999999997
								],
								[
									157.4473632812502,
									71.07451171874996
								],
								[
									158.03701171875014,
									71.03925781250007
								],
								[
									158.7021484375001,
									70.93500976562495
								],
								[
									159.3506835937501,
									70.79072265625004
								],
								[
									159.72792968750002,
									70.649658203125
								],
								[
									159.8046875000001,
									70.60493164062495
								],
								[
									159.91181640625018,
									70.50610351562497
								],
								[
									159.9585937500002,
									70.42363281249996
								],
								[
									160.0064453125001,
									70.30966796875009
								],
								[
									159.9833984375001,
									70.22138671875007
								],
								[
									159.8896484375001,
									70.1587890625
								],
								[
									159.83144531250014,
									70.08144531249997
								],
								[
									159.83916015625005,
									69.98999023437509
								],
								[
									159.72939453125014,
									69.87021484375009
								],
								[
									159.8325195312501,
									69.78496093749996
								],
								[
									160.11914062499994,
									69.7297851562501
								],
								[
									160.739453125,
									69.65517578125
								],
								[
									160.9107421875002,
									69.60634765625
								],
								[
									160.92890625000018,
									69.45854492187499
								],
								[
									160.98203125000003,
									69.33447265624994
								],
								[
									161.03554687500014,
									69.09819335937513
								],
								[
									161.14082031250018,
									69.03886718750002
								],
								[
									161.30986328125016,
									68.98227539062495
								],
								[
									161.34062500000005,
									68.90517578124997
								],
								[
									161.1290039062501,
									68.65385742187502
								],
								[
									160.9966796875002,
									68.60751953125006
								],
								[
									160.8560546875001,
									68.53833007812511
								],
								[
									161.10449218749994,
									68.56250000000006
								],
								[
									161.23017578125018,
									68.65390625000012
								],
								[
									161.36513671875014,
									68.82299804687509
								],
								[
									161.49531250000018,
									68.84985351562497
								],
								[
									161.565625,
									68.90517578124997
								],
								[
									161.565625,
									69.06396484375009
								],
								[
									161.4800781250002,
									69.20170898437507
								],
								[
									161.4800781250002,
									69.30009765625005
								],
								[
									161.53691406250005,
									69.37954101562497
								],
								[
									161.94511718750016,
									69.54511718749995
								],
								[
									162.16601562499994,
									69.61157226562509
								],
								[
									162.37568359375,
									69.649072265625
								],
								[
									162.94462890625005,
									69.68276367187502
								],
								[
									163.2013671875,
									69.71474609374997
								],
								[
									163.498046875,
									69.69326171874994
								],
								[
									163.70527343750018,
									69.701806640625
								],
								[
									163.94599609375,
									69.73515625000013
								],
								[
									164.15957031250002,
									69.71928710937507
								],
								[
									164.51328125000003,
									69.60913085937494
								],
								[
									165.7607421875,
									69.58442382812507
								],
								[
									165.98046875,
									69.54599609374995
								],
								[
									166.8203125000001,
									69.49956054687507
								],
								[
									166.8843750000002,
									69.49990234375008
								],
								[
									167.07314453125014,
									69.55444335937509
								],
								[
									167.628125,
									69.74033203125012
								],
								[
									167.85683593749997,
									69.72822265624995
								],
								[
									167.95009765624997,
									69.69916992187498
								],
								[
									168.04765625000016,
									69.62563476562502
								],
								[
									168.1500000000002,
									69.57739257812506
								],
								[
									168.22998046875,
									69.44702148437503
								],
								[
									168.30302734375005,
									69.27148437500009
								],
								[
									168.42304687500007,
									69.23950195312503
								],
								[
									168.58759765625018,
									69.22836914062509
								],
								[
									168.94619140625014,
									69.16333007812497
								],
								[
									169.31064453125003,
									69.07954101562495
								],
								[
									169.4146484375002,
									68.91962890624998
								],
								[
									169.60986328125,
									68.78603515624994
								],
								[
									170.065625,
									68.79868164062503
								],
								[
									170.53759765625,
									68.82539062500004
								],
								[
									170.99541015625,
									69.04531250000008
								],
								[
									170.9966796875001,
									69.13471679687493
								],
								[
									170.8837890625,
									69.26362304687498
								],
								[
									170.71416015625016,
									69.38823242187496
								],
								[
									170.5822265625,
									69.58334960937509
								],
								[
									170.16093750000016,
									69.62656250000003
								],
								[
									170.2011718750001,
									69.68320312500012
								],
								[
									170.35957031250007,
									69.75097656249997
								],
								[
									170.50312500000018,
									69.85654296874998
								],
								[
									170.525390625,
									69.93789062500002
								],
								[
									170.4868164062501,
									70.10756835937497
								],
								[
									170.86796875000016,
									70.09604492187509
								],
								[
									171.2466796875002,
									70.07612304687495
								],
								[
									171.97050781250016,
									70.00034179687506
								],
								[
									172.5595703125,
									69.96835937500003
								],
								[
									172.8692382812502,
									69.91977539062506
								],
								[
									173.05634765625,
									69.86494140625001
								],
								[
									173.27744140625015,
									69.82382812499998
								],
								[
									173.35332031249993,
									69.92402343750004
								],
								[
									173.43867187500013,
									69.94682617187499
								],
								[
									173.7333984375001,
									69.89111328125009
								],
								[
									173.94804687500016,
									69.87412109375
								],
								[
									174.31943359375015,
									69.88164062500013
								],
								[
									174.78554687500008,
									69.85566406249998
								],
								[
									175.29560546875024,
									69.86005859374998
								],
								[
									175.75117187500013,
									69.904150390625
								],
								[
									175.9214843750002,
									69.89531250000007
								],
								[
									176.10751953125026,
									69.86030273437495
								],
								[
									176.41044921875016,
									69.76850585937498
								],
								[
									176.92441406250026,
									69.64599609375009
								],
								[
									177.3945312500001,
									69.6116210937501
								],
								[
									177.93369140625015,
									69.49560546875009
								],
								[
									178.44277343750014,
									69.452978515625
								],
								[
									178.84833984374995,
									69.38720703125003
								],
								[
									178.90693359375018,
									69.36210937500007
								],
								[
									178.92500000000013,
									69.32597656249999
								],
								[
									178.95068359375006,
									69.29580078124997
								],
								[
									179.27265625000007,
									69.25966796875005
								],
								[
									179.8682617187501,
									69.01269531250003
								],
								[
									180.0000000000001,
									68.98344726562502
								],
								[
									180.0000000000001,
									65.06723632812503
								],
								[
									179.82734375000013,
									65.03417968750003
								],
								[
									179.65136718750017,
									64.92094726562507
								],
								[
									179.44824218750017,
									64.82202148437509
								],
								[
									179.15000000000015,
									64.781591796875
								],
								[
									178.69843750000018,
									64.63110351562509
								],
								[
									178.5195312500001,
									64.60297851562504
								],
								[
									178.28535156250018,
									64.67226562499994
								],
								[
									177.7486328125001,
									64.717041015625
								],
								[
									177.5816406250002,
									64.77788085937496
								],
								[
									177.33701171875026,
									64.93134765625004
								],
								[
									177.25185546875014,
									64.95361328124997
								],
								[
									177.1791992187501,
									65.01411132812495
								],
								[
									176.88085937500006,
									65.08193359375
								],
								[
									176.62480468749993,
									65.03759765624994
								],
								[
									176.41308593750017,
									65.07124023437495
								],
								[
									176.34101562500024,
									65.04731445312504
								],
								[
									176.4521484375001,
									65.02524414062509
								],
								[
									176.6455078124999,
									65.00717773437503
								],
								[
									176.9400390625002,
									65.01601562500008
								],
								[
									177.03730468749995,
									64.99965820312494
								],
								[
									177.1234374999999,
									64.94702148437506
								],
								[
									177.22285156250013,
									64.86166992187498
								],
								[
									177.14824218750016,
									64.80483398437502
								],
								[
									177.06875000000014,
									64.78666992187507
								],
								[
									176.83105468750006,
									64.84921875000012
								],
								[
									176.5566406250001,
									64.83999023437508
								],
								[
									176.42949218749993,
									64.85517578124998
								],
								[
									176.0611328125002,
									64.96088867187504
								],
								[
									175.7811523437502,
									64.84404296875013
								],
								[
									175.39648437500017,
									64.78369140625009
								],
								[
									175.09775390625026,
									64.77685546875003
								],
								[
									174.54882812500017,
									64.68388671875007
								],
								[
									174.69863281250014,
									64.68144531250013
								],
								[
									175.0970703124999,
									64.74663085937499
								],
								[
									175.33066406250026,
									64.74663085937499
								],
								[
									175.67792968750013,
									64.78247070312509
								],
								[
									175.85859375000018,
									64.82529296875003
								],
								[
									175.9458984375002,
									64.86518554687498
								],
								[
									176.0565429687502,
									64.90473632812495
								],
								[
									176.16923828125022,
									64.88476562499997
								],
								[
									176.24697265625008,
									64.843017578125
								],
								[
									176.3008789062502,
									64.78383789062494
								],
								[
									176.35097656250014,
									64.70512695312507
								],
								[
									176.28320312500017,
									64.663818359375
								],
								[
									176.21943359374995,
									64.64194335937498
								],
								[
									176.14091796875016,
									64.58583984375011
								],
								[
									176.50761718750005,
									64.68242187499996
								],
								[
									176.7309570312499,
									64.62485351562506
								],
								[
									176.84287109375015,
									64.6337890625
								],
								[
									177.0498046875,
									64.71923828125
								],
								[
									177.3875000000001,
									64.77402343749998
								],
								[
									177.42744140625024,
									64.76337890625004
								],
								[
									177.46718750000014,
									64.73681640624994
								],
								[
									177.40986328125018,
									64.57280273437502
								],
								[
									177.4329101562501,
									64.44448242187508
								],
								[
									177.6875000000001,
									64.3047363281251
								],
								[
									177.95332031250024,
									64.222265625
								],
								[
									178.04472656250022,
									64.21958007812509
								],
								[
									178.13056640625013,
									64.23525390625
								],
								[
									178.1639648437502,
									64.30908203125003
								],
								[
									178.2294921875,
									64.36440429687502
								],
								[
									178.31298828125017,
									64.31440429687495
								],
								[
									178.38144531250026,
									64.26088867187505
								],
								[
									178.4771484375002,
									64.12788085937507
								],
								[
									178.47480468750007,
									64.08901367187505
								],
								[
									178.45136718750013,
									64.01137695312502
								],
								[
									178.53603515625014,
									63.975634765625045
								],
								[
									178.65029296875014,
									63.96528320312507
								],
								[
									178.6924804687502,
									63.842333984375045
								],
								[
									178.7314453125001,
									63.66708984374998
								],
								[
									178.68134765625024,
									63.65073242187509
								],
								[
									178.62597656250017,
									63.65073242187509
								],
								[
									178.44042968750017,
									63.60556640625006
								],
								[
									178.4661132812501,
									63.574072265625034
								],
								[
									178.65371093750014,
									63.55664062499994
								],
								[
									178.7064453125002,
									63.52153320312499
								],
								[
									178.6688476562502,
									63.43994140624997
								],
								[
									178.67871093750006,
									63.40229492187504
								],
								[
									178.74404296875002,
									63.394775390625
								],
								[
									178.7867187500002,
									63.44243164062513
								],
								[
									178.77539062500006,
									63.51025390625
								],
								[
									178.79296875000006,
									63.54033203124999
								],
								[
									178.91855468750026,
									63.40024414062506
								],
								[
									178.92148437500015,
									63.34501953124999
								],
								[
									179.02812500000016,
									63.28242187500004
								],
								[
									179.33232421875016,
									63.19018554687506
								],
								[
									179.38857421875008,
									63.14721679687503
								],
								[
									179.40507812500005,
									63.07773437500006
								],
								[
									179.3290039062502,
									63.05791015625013
								],
								[
									179.2595703125001,
									63.00830078125006
								],
								[
									179.30214843750008,
									62.939843749999966
								],
								[
									179.38105468749995,
									62.88369140625008
								],
								[
									179.51093750000013,
									62.862792968750085
								],
								[
									179.57050781250018,
									62.773486328125074
								],
								[
									179.57050781250018,
									62.68749999999997
								],
								[
									179.47724609375018,
									62.6130859375001
								],
								[
									179.28867187500015,
									62.51035156249995
								],
								[
									179.17695312500013,
									62.4691894531251
								],
								[
									179.13388671875026,
									62.396435546874926
								],
								[
									179.1207031250002,
									62.32036132812496
								],
								[
									179.04462890625018,
									62.323681640624926
								],
								[
									178.96386718750006,
									62.355273437500074
								],
								[
									178.01923828125018,
									62.54697265624995
								],
								[
									177.6630859375001,
									62.58281249999996
								],
								[
									177.35126953125018,
									62.58745117187502
								],
								[
									177.2925781250001,
									62.59902343750008
								],
								[
									177.29589843750006,
									62.64448242187501
								],
								[
									177.31582031250002,
									62.68525390625004
								],
								[
									177.3596679687501,
									62.73696289062502
								],
								[
									177.33896484375015,
									62.781347656250006
								],
								[
									177.29833984375006,
									62.78422851562496
								],
								[
									177.25869140625014,
									62.750439453124926
								],
								[
									177.17265625000016,
									62.75034179687509
								],
								[
									177.09121093750014,
									62.789550781250085
								],
								[
									177.0235351562502,
									62.777246093749966
								],
								[
									176.9900390625001,
									62.72221679687513
								],
								[
									176.9634765625002,
									62.693261718749994
								],
								[
									176.9647460937499,
									62.658642578124955
								],
								[
									177.00800781250024,
									62.62656250000009
								],
								[
									177.18964843750007,
									62.591601562500074
								],
								[
									177.15947265625016,
									62.560986328124955
								],
								[
									176.90742187499995,
									62.536083984374955
								],
								[
									176.70253906250014,
									62.505761718749994
								],
								[
									176.4365234375001,
									62.410839843749926
								],
								[
									176.32841796875016,
									62.346044921875034
								],
								[
									175.6138671875002,
									62.184375000000074
								],
								[
									175.4419921875002,
									62.12792968750003
								],
								[
									175.36582031250015,
									62.121337890625085
								],
								[
									175.2678710937501,
									62.10239257812506
								],
								[
									175.19238281250017,
									62.03442382812497
								],
								[
									174.79755859375018,
									61.938867187499966
								],
								[
									174.71503906250007,
									61.94790039062494
								],
								[
									174.61054687500013,
									61.867626953124926
								],
								[
									174.51435546875024,
									61.82363281249994
								],
								[
									174.28496093750022,
									61.81752929687494
								],
								[
									174.13886718750013,
									61.795166015625
								],
								[
									173.8223632812501,
									61.67939453125004
								],
								[
									173.62343750000008,
									61.71606445312506
								],
								[
									173.3907226562501,
									61.556738281250006
								],
								[
									173.13183593749994,
									61.40664062500008
								],
								[
									173.05458984375014,
									61.40620117187498
								],
								[
									172.8565429687501,
									61.469189453124926
								],
								[
									172.80683593750018,
									61.43613281249995
								],
								[
									172.8378906250001,
									61.375585937500034
								],
								[
									172.9080078125,
									61.31162109374998
								],
								[
									172.8677734375001,
									61.29306640625012
								],
								[
									172.7890625000001,
									61.310693359374966
								],
								[
									172.7306640625,
									61.314404296874926
								],
								[
									172.6900390625002,
									61.295166015625
								],
								[
									172.69697265625018,
									61.24931640624999
								],
								[
									172.58476562500016,
									61.190429687500085
								],
								[
									172.49707031249994,
									61.18588867187495
								],
								[
									172.3960937500001,
									61.167382812499994
								],
								[
									172.36240234375003,
									61.11660156250005
								],
								[
									172.3927734375,
									61.06176757812497
								],
								[
									172.21328125000014,
									60.9978515625001
								],
								[
									172.06728515625014,
									60.915673828124966
								],
								[
									171.9976562500001,
									60.90068359375002
								],
								[
									171.9179687500001,
									60.864111328125034
								],
								[
									171.83056640624994,
									60.8373535156251
								],
								[
									171.7294921875,
									60.84311523437509
								],
								[
									171.48974609375,
									60.725732421874994
								],
								[
									170.9493164062502,
									60.52294921875006
								],
								[
									170.7993164062501,
									60.49648437500011
								],
								[
									170.60820312500016,
									60.43491210937506
								],
								[
									170.58974609375014,
									60.39370117187494
								],
								[
									170.58857421875018,
									60.34287109374998
								],
								[
									170.5123046875001,
									60.25952148437506
								],
								[
									170.4234375000002,
									60.04780273437507
								],
								[
									170.3964843750001,
									60.00976562499997
								],
								[
									170.35097656249997,
									59.965527343749926
								],
								[
									170.15410156250005,
									59.98608398437494
								],
								[
									169.98261718750018,
									60.067089843749926
								],
								[
									169.92724609375,
									60.10424804687494
								],
								[
									169.8975585937501,
									60.14785156250002
								],
								[
									169.88701171875016,
									60.21791992187511
								],
								[
									169.85429687500016,
									60.25024414062503
								],
								[
									169.81474609375016,
									60.265380859375
								],
								[
									169.618359375,
									60.4380371093751
								],
								[
									169.27568359375005,
									60.556640625
								],
								[
									169.22675781250018,
									60.59594726562503
								],
								[
									168.78828125,
									60.563818359375034
								],
								[
									168.67031249999997,
									60.56289062500002
								],
								[
									168.46279296874997,
									60.59223632812507
								],
								[
									168.13750000000016,
									60.57392578125007
								],
								[
									167.74599609375014,
									60.50932617187496
								],
								[
									167.62607421875003,
									60.46894531250007
								],
								[
									167.22675781250007,
									60.40629882812502
								],
								[
									166.96406250000018,
									60.30703125000005
								],
								[
									166.45253906249997,
									59.94702148437497
								],
								[
									166.33183593750016,
									59.87241210937506
								],
								[
									166.2730468750002,
									59.85624999999996
								],
								[
									166.18652343749994,
									59.84946289062509
								],
								[
									166.1489257812501,
									59.922070312499955
								],
								[
									166.13603515625016,
									59.97934570312509
								],
								[
									166.16835937499997,
									60.0888183593751
								],
								[
									166.22978515625016,
									60.178320312500034
								],
								[
									166.29248046874994,
									60.34609375000011
								],
								[
									166.30810546874994,
									60.414257812499955
								],
								[
									166.35214843750003,
									60.48481445312504
								],
								[
									166.1801757812501,
									60.48037109375011
								],
								[
									165.94199218750003,
									60.35688476562498
								],
								[
									165.5830078125001,
									60.236474609374966
								],
								[
									165.41582031250016,
									60.20517578125009
								],
								[
									165.2852539062502,
									60.13491210937505
								],
								[
									165.19257812500007,
									60.12475585937494
								],
								[
									165.0845703125001,
									60.09858398437504
								],
								[
									165.07363281249997,
									59.94560546874996
								],
								[
									165.01894531250014,
									59.86074218750008
								],
								[
									164.9537109375001,
									59.843603515625034
								],
								[
									164.85429687500016,
									59.84096679687505
								],
								[
									164.7793945312501,
									59.87421874999998
								],
								[
									164.66972656250005,
									59.99746093750005
								],
								[
									164.52529296875002,
									60.061279296875085
								],
								[
									164.44003906250003,
									60.07270507812501
								],
								[
									164.37685546875014,
									60.058056640624955
								],
								[
									164.2515625000002,
									59.97377929687511
								],
								[
									164.1132812500001,
									59.897558593750034
								],
								[
									164.13505859375,
									59.98437499999994
								],
								[
									164.01757812499994,
									60.017333984375
								],
								[
									163.91289062500005,
									60.03706054687501
								],
								[
									163.78007812500016,
									60.04111328125006
								],
								[
									163.74384765625007,
									60.028027343749955
								],
								[
									163.6900390625002,
									59.97841796875008
								],
								[
									163.5743164062501,
									59.914062500000114
								],
								[
									163.4937500000001,
									59.88676757812496
								],
								[
									163.40996093750016,
									59.83496093749997
								],
								[
									163.3648437500002,
									59.7814453125001
								],
								[
									163.32119140625002,
									59.70541992187506
								],
								[
									163.26904296874994,
									59.52001953124994
								],
								[
									163.27285156250014,
									59.30258789062506
								],
								[
									163.08486328125002,
									59.13139648437499
								],
								[
									163.01015624999997,
									59.14829101562506
								],
								[
									162.97490234375016,
									59.13706054687509
								],
								[
									162.9400390625001,
									59.114306640625074
								],
								[
									163.00429687500014,
									59.02016601562508
								],
								[
									162.9698242187502,
									58.98647460937505
								],
								[
									162.9345703125001,
									58.96396484375006
								],
								[
									162.8472656250002,
									58.93925781250002
								],
								[
									162.64335937500005,
									58.799902343750034
								],
								[
									162.45302734374997,
									58.708593750000006
								],
								[
									162.14160156249994,
									58.447412109374994
								],
								[
									162.04921875000014,
									58.272851562499966
								],
								[
									161.9600585937502,
									58.076904296875114
								],
								[
									162.0019531250001,
									57.980957031250085
								],
								[
									162.03964843750003,
									57.91826171874993
								],
								[
									162.09794921875005,
									57.87465820312494
								],
								[
									162.19746093750007,
									57.82915039062499
								],
								[
									162.41142578125005,
									57.778369140625045
								],
								[
									162.3921875000002,
									57.745019531249994
								],
								[
									162.39140625000005,
									57.717236328124926
								],
								[
									162.46699218750018,
									57.766210937500034
								],
								[
									162.52197265625,
									57.904101562500074
								],
								[
									162.65429687499994,
									57.9482421875
								],
								[
									162.7183593750002,
									57.94609375000002
								],
								[
									163.1450195312501,
									57.837304687499966
								],
								[
									163.22578125,
									57.79038085937509
								],
								[
									163.2138671875001,
									57.686816406250045
								],
								[
									163.18789062500014,
									57.63740234375001
								],
								[
									163.10878906250002,
									57.564843749999966
								],
								[
									162.95703125,
									57.47749023437501
								],
								[
									162.7792968750001,
									57.35761718750004
								],
								[
									162.7623046875002,
									57.284082031249966
								],
								[
									162.76152343750005,
									57.24394531249996
								],
								[
									162.8081054687501,
									57.10278320312506
								],
								[
									162.81484374999997,
									57.02338867187507
								],
								[
									162.7911132812502,
									56.87539062500002
								],
								[
									162.80263671874997,
									56.81147460937504
								],
								[
									162.84990234375,
									56.75683593750003
								],
								[
									162.92207031250007,
									56.722656250000085
								],
								[
									163.04638671875,
									56.74130859375006
								],
								[
									163.16542968749997,
									56.72548828124994
								],
								[
									163.25654296875018,
									56.688037109375045
								],
								[
									163.2432617187502,
									56.56455078125012
								],
								[
									163.2940429687501,
									56.447705078124926
								],
								[
									163.3355468750002,
									56.23251953125006
								],
								[
									163.2613281250001,
									56.17373046875008
								],
								[
									163.18925781250016,
									56.13701171874996
								],
								[
									163.0473632812501,
									56.04467773437497
								],
								[
									162.97167968749994,
									56.03378906249998
								],
								[
									162.8403320312501,
									56.06562499999998
								],
								[
									162.628125,
									56.232275390625006
								],
								[
									162.71318359375016,
									56.33085937500002
								],
								[
									162.89326171875007,
									56.39946289062496
								],
								[
									162.97519531250003,
									56.44902343749993
								],
								[
									163.03837890625005,
									56.52187499999994
								],
								[
									162.94414062500005,
									56.50805664062506
								],
								[
									162.87763671875018,
									56.47636718749999
								],
								[
									162.6714843750001,
									56.49008789062495
								],
								[
									162.58906250000018,
									56.45493164062498
								],
								[
									162.48867187500014,
									56.39912109375007
								],
								[
									162.52822265625014,
									56.260693359374926
								],
								[
									162.4611328125,
									56.23549804687505
								],
								[
									162.3340820312501,
									56.187744140625085
								],
								[
									162.1460937500001,
									56.12827148437495
								],
								[
									162.08496093749994,
									56.08964843749999
								],
								[
									161.9240234375,
									55.84038085937502
								],
								[
									161.77558593750018,
									55.65483398437496
								],
								[
									161.72392578125005,
									55.49614257812496
								],
								[
									161.72939453125002,
									55.35800781250006
								],
								[
									161.78496093750005,
									55.20532226562503
								],
								[
									161.82421874999994,
									55.138916015625114
								],
								[
									161.99609375,
									54.99799804687507
								],
								[
									162.08027343750018,
									54.88613281249994
								],
								[
									162.1055664062501,
									54.7521484375001
								],
								[
									161.9668945312501,
									54.68867187500004
								],
								[
									161.72568359375003,
									54.532958984375114
								],
								[
									161.6248046875,
									54.516259765624994
								],
								[
									161.2940429687502,
									54.520556640625074
								],
								[
									161.1298828125,
									54.59824218750009
								],
								[
									160.9355468750001,
									54.57836914062494
								],
								[
									160.77265625,
									54.54135742187495
								],
								[
									160.51718750000003,
									54.4308593750001
								],
								[
									160.28886718750016,
									54.28823242187508
								],
								[
									160.07441406250018,
									54.18916015625007
								],
								[
									160.01015625000014,
									54.130859375000085
								],
								[
									159.92177734374997,
									54.00839843750009
								],
								[
									159.84375,
									53.783642578124955
								],
								[
									159.8708984375,
									53.67265624999999
								],
								[
									159.91425781250007,
									53.620849609375
								],
								[
									159.95585937500016,
									53.55219726562504
								],
								[
									159.89912109375018,
									53.44770507812507
								],
								[
									159.89765625,
									53.38076171874994
								],
								[
									160.00214843750018,
									53.27490234375006
								],
								[
									160.02509765625007,
									53.129589843749926
								],
								[
									159.94746093750007,
									53.12509765625009
								],
								[
									159.7715820312502,
									53.22968749999998
								],
								[
									159.5859375000001,
									53.23769531250002
								],
								[
									159.13613281250014,
									53.11713867187507
								],
								[
									158.95205078125014,
									53.04755859375001
								],
								[
									158.74541015625005,
									52.908935546875085
								],
								[
									158.6836914062501,
									52.93540039062498
								],
								[
									158.63955078125014,
									53.014794921874994
								],
								[
									158.56464843750018,
									53.05000000000007
								],
								[
									158.47207031250014,
									53.03237304687502
								],
								[
									158.43232421875,
									52.95742187499994
								],
								[
									158.56015625000003,
									52.922167968750045
								],
								[
									158.60878906250002,
									52.873632812500006
								],
								[
									158.53369140625,
									52.68842773437504
								],
								[
									158.48076171875005,
									52.62666015625007
								],
								[
									158.50039062500014,
									52.460302734375006
								],
								[
									158.4931640625,
									52.383154296875006
								],
								[
									158.4634765625001,
									52.304980468750074
								],
								[
									158.3316406250002,
									52.090869140625045
								],
								[
									158.1035156250001,
									51.80961914062496
								],
								[
									157.8232421875001,
									51.60532226562509
								],
								[
									157.62890624999994,
									51.534570312499966
								],
								[
									157.53095703125018,
									51.47988281250002
								],
								[
									157.48984375000003,
									51.40893554687503
								],
								[
									157.2022460937501,
									51.21274414062495
								],
								[
									156.8474609375,
									51.00659179687506
								],
								[
									156.74775390625,
									50.9692871093751
								],
								[
									156.72431640625007,
									51.04707031250004
								],
								[
									156.71347656250003,
									51.12412109375009
								],
								[
									156.67080078124997,
									51.226855468750074
								],
								[
									156.54345703124994,
									51.31162109375012
								],
								[
									156.52119140625007,
									51.38027343750005
								],
								[
									156.50039062499997,
									51.475097656250114
								],
								[
									156.48984375000003,
									51.91303710937507
								],
								[
									156.37734374999997,
									52.36655273437509
								],
								[
									156.36474609375,
									52.50937500000006
								],
								[
									156.22861328125003,
									52.626269531250074
								],
								[
									156.1543945312502,
									52.74726562500001
								],
								[
									156.1103515625001,
									52.8661621093751
								],
								[
									156.09882812500018,
									53.00649414062508
								],
								[
									155.9501953125,
									53.74428710937502
								],
								[
									155.9048828125001,
									53.92812500000008
								],
								[
									155.70644531249997,
									54.521484375000085
								],
								[
									155.6203125,
									54.864550781250074
								],
								[
									155.56386718749997,
									55.19912109375002
								],
								[
									155.55488281250018,
									55.34848632812506
								],
								[
									155.64345703125014,
									55.79355468749998
								],
								[
									155.7166015625,
									56.07221679687507
								],
								[
									155.9825195312502,
									56.695214843749994
								],
								[
									156.0253906250001,
									56.75200195312502
								],
								[
									156.0674804687501,
									56.781591796875006
								],
								[
									156.5292968750001,
									57.02119140625007
								],
								[
									156.72841796874997,
									57.15224609375002
								],
								[
									156.84882812500018,
									57.290185546874966
								],
								[
									156.97675781250007,
									57.46630859375006
								],
								[
									156.96357421875,
									57.560937499999966
								],
								[
									156.9482421875001,
									57.615771484375045
								],
								[
									156.8999023437501,
									57.676904296874966
								],
								[
									156.7916015625001,
									57.747949218749966
								],
								[
									156.82988281250016,
									57.779638671875034
								],
								[
									156.87197265625002,
									57.80366210937504
								],
								[
									156.98574218750002,
									57.83017578125012
								],
								[
									157.2167968750001,
									57.77680664062498
								],
								[
									157.45039062500018,
									57.79926757812504
								],
								[
									157.66640625000014,
									58.019775390625114
								],
								[
									157.9746093750001,
									57.985937500000034
								],
								[
									158.2104492187501,
									58.02529296875008
								],
								[
									158.27519531250016,
									58.00898437500004
								],
								[
									158.32109375,
									58.083447265624926
								],
								[
									158.44941406250007,
									58.16284179687503
								],
								[
									158.68701171874994,
									58.281347656250006
								],
								[
									159.0369140625,
									58.423925781250006
								],
								[
									159.21064453125007,
									58.51943359375002
								],
								[
									159.30839843750016,
									58.610546874999926
								],
								[
									159.45263671874994,
									58.69594726562511
								],
								[
									159.59150390625018,
									58.803662109374926
								],
								[
									159.84736328125018,
									59.127148437499926
								],
								[
									160.35039062500016,
									59.39404296874994
								],
								[
									160.5474609375001,
									59.54736328125
								],
								[
									160.7114257812501,
									59.60166015625006
								],
								[
									160.8552734375,
									59.62685546874994
								],
								[
									161.21894531250018,
									59.84560546875011
								],
								[
									161.44931640625003,
									60.02734375
								],
								[
									161.7535156250002,
									60.15229492187504
								],
								[
									161.84599609375005,
									60.23222656249999
								],
								[
									162.00361328125018,
									60.420166015625
								],
								[
									162.0681640625,
									60.466406250000006
								],
								[
									162.26630859375007,
									60.53671874999995
								],
								[
									162.71318359375016,
									60.65947265624999
								],
								[
									162.97314453125,
									60.78291015625001
								],
								[
									163.35234375000016,
									60.80043945312494
								],
								[
									163.4664062500002,
									60.84975585937502
								],
								[
									163.58515625000007,
									60.877148437499926
								],
								[
									163.7099609375,
									60.91679687500002
								],
								[
									163.553515625,
									61.025634765625085
								],
								[
									163.58925781250002,
									61.084374999999966
								],
								[
									163.61962890625,
									61.11132812499994
								],
								[
									163.89335937500016,
									61.24047851562497
								],
								[
									164.0054687500001,
									61.34379882812496
								],
								[
									163.99208984375002,
									61.38823242187496
								],
								[
									163.97275390625003,
									61.419873046874926
								],
								[
									163.80439453125007,
									61.46137695312504
								],
								[
									163.83710937500007,
									61.55825195312505
								],
								[
									163.88271484375002,
									61.64013671874994
								],
								[
									164.0195312500001,
									61.710693359375114
								],
								[
									164.0679687500002,
									61.87387695312495
								],
								[
									164.07421874999994,
									62.045019531250006
								],
								[
									164.20722656250007,
									62.292236328125085
								],
								[
									164.28750000000014,
									62.34663085937498
								],
								[
									164.59833984375007,
									62.470556640625006
								],
								[
									164.67070312500016,
									62.47377929687505
								],
								[
									164.8876953125001,
									62.43188476562494
								],
								[
									165.12412109375003,
									62.41152343750005
								],
								[
									165.2081054687502,
									62.37397460937504
								],
								[
									165.22568359375003,
									62.40576171875006
								],
								[
									165.21386718749994,
									62.44819335937498
								],
								[
									165.2803710937502,
									62.46298828124998
								],
								[
									165.41738281250014,
									62.44707031250002
								],
								[
									165.39658203125003,
									62.49389648437497
								],
								[
									165.0440429687501,
									62.516992187499966
								],
								[
									164.79238281249997,
									62.571093750000074
								],
								[
									164.5669921875001,
									62.675488281249926
								],
								[
									164.41835937499997,
									62.7046386718751
								],
								[
									164.25566406250016,
									62.69658203124996
								],
								[
									163.33173828125,
									62.55092773437505
								],
								[
									163.2871093750001,
									62.51142578124998
								],
								[
									163.24423828125003,
									62.4553710937501
								],
								[
									163.30214843750014,
									62.37299804687504
								],
								[
									163.2580078125,
									62.33691406250006
								],
								[
									163.21328125000014,
									62.31342773437507
								],
								[
									163.16347656250014,
									62.25957031250002
								],
								[
									163.11845703125,
									62.15292968750006
								],
								[
									163.13105468750018,
									62.04990234375012
								],
								[
									163.0176757812501,
									61.89106445312507
								],
								[
									163.00927734375,
									61.79150390625006
								],
								[
									163.20761718750003,
									61.73657226562506
								],
								[
									163.2578125,
									61.69946289062494
								],
								[
									163.1978515625002,
									61.644775390625
								],
								[
									163.13886718750018,
									61.61142578124995
								],
								[
									163.08525390625,
									61.57055664062497
								],
								[
									163.04726562499997,
									61.55405273437509
								],
								[
									162.99394531250016,
									61.54418945312503
								],
								[
									162.92167968750016,
									61.5977050781251
								],
								[
									162.8559570312501,
									61.705029296874926
								],
								[
									162.75234375000014,
									61.711279296875034
								],
								[
									162.7178710937502,
									61.695117187500045
								],
								[
									162.6990234375,
									61.652587890625085
								],
								[
									162.6076171875,
									61.65004882812511
								],
								[
									162.5064453125002,
									61.670117187499926
								],
								[
									162.3925781250001,
									61.66210937499997
								],
								[
									162.18837890624997,
									61.54067382812502
								],
								[
									161.0371093750001,
									60.962890625000085
								],
								[
									160.9150390625001,
									60.89267578125006
								],
								[
									160.76660156249994,
									60.75332031250002
								],
								[
									160.4820312500001,
									60.739843750000034
								],
								[
									160.36816406249994,
									60.70854492187496
								],
								[
									160.28730468750018,
									60.6670410156251
								],
								[
									160.17363281250005,
									60.63842773437497
								],
								[
									160.1773437500001,
									60.69072265624996
								],
								[
									160.20107421875014,
									60.729638671874994
								],
								[
									160.22578125000018,
									60.83154296874997
								],
								[
									160.3789062500001,
									61.02548828124995
								],
								[
									160.2812500000001,
									61.04477539062498
								],
								[
									160.18427734375018,
									61.04765625000013
								],
								[
									160.0040039062502,
									61.007421875000006
								],
								[
									159.88310546875,
									60.94340820312502
								],
								[
									159.79042968750014,
									60.95664062500006
								],
								[
									159.83457031250003,
									61.0139648437501
								],
								[
									159.94921874999994,
									61.12861328125001
								],
								[
									159.91396484374997,
									61.23447265625006
								],
								[
									159.88310546875,
									61.29179687500013
								],
								[
									159.93085937500007,
									61.32392578125001
								],
								[
									160.1626953125002,
									61.537499999999994
								],
								[
									160.24687500000005,
									61.64760742187505
								],
								[
									160.3173828125001,
									61.79335937500008
								],
								[
									160.32148437500007,
									61.838574218749955
								],
								[
									160.30937500000016,
									61.894384765625034
								],
								[
									160.23779296874994,
									61.90385742187502
								],
								[
									160.18251953124997,
									61.902832031250085
								],
								[
									159.72216796875,
									61.75839843750006
								],
								[
									159.5523437500002,
									61.71948242187494
								],
								[
									159.49628906250018,
									61.781445312499955
								],
								[
									159.42304687500018,
									61.808056640624955
								],
								[
									159.2950195312502,
									61.91416015625009
								],
								[
									159.18925781250016,
									61.92939453124998
								],
								[
									159.0766601562501,
									61.92226562500005
								],
								[
									158.8243164062502,
									61.85024414062494
								],
								[
									158.54716796875016,
									61.810888671875006
								],
								[
									158.33369140625018,
									61.82568359375
								],
								[
									158.1515625,
									61.76484375000004
								],
								[
									158.07011718750005,
									61.75361328125007
								],
								[
									157.7993164062501,
									61.79526367187509
								],
								[
									157.4693359375002,
									61.79892578125006
								],
								[
									157.3707031250002,
									61.74707031249997
								],
								[
									157.08417968750018,
									61.675683593749994
								],
								[
									156.89179687500007,
									61.56518554687494
								],
								[
									156.79062500000003,
									61.52963867187509
								],
								[
									156.68027343750003,
									61.48061523437505
								],
								[
									156.62968750000005,
									61.2724609375
								],
								[
									156.48261718750018,
									61.206005859374955
								],
								[
									156.34414062500014,
									61.155078125000074
								],
								[
									156.05595703125005,
									60.99560546875
								],
								[
									155.85332031250016,
									60.77714843749999
								],
								[
									155.71611328125,
									60.68237304687503
								],
								[
									155.42783203125003,
									60.54985351562496
								],
								[
									154.9708007812502,
									60.376660156249926
								],
								[
									154.5782226562501,
									60.09501953125002
								],
								[
									154.44072265625016,
									59.88378906249997
								],
								[
									154.38984375000018,
									59.87675781249996
								],
								[
									154.2930664062501,
									59.833349609375006
								],
								[
									154.2666015625001,
									59.73037109375008
								],
								[
									154.26884765625005,
									59.65839843750007
								],
								[
									154.2091796875,
									59.60034179687506
								],
								[
									154.14980468750002,
									59.52851562499998
								],
								[
									154.212890625,
									59.48339843749994
								],
								[
									154.27216796875018,
									59.47514648437513
								],
								[
									154.35761718750018,
									59.481445312500085
								],
								[
									154.58251953125,
									59.54008789062513
								],
								[
									154.97128906250003,
									59.44960937500008
								],
								[
									155.16669921875007,
									59.36015624999996
								],
								[
									155.15302734375,
									59.27021484375004
								],
								[
									155.16044921875005,
									59.19013671875007
								],
								[
									155.01669921875003,
									59.19560546875002
								],
								[
									154.8237304687501,
									59.187548828125074
								],
								[
									154.70351562500014,
									59.14130859375007
								],
								[
									154.4580078125001,
									59.21655273437503
								],
								[
									154.3759765625001,
									59.18784179687495
								],
								[
									154.24667968750003,
									59.10859375000004
								],
								[
									154.01093750000007,
									59.07553710937498
								],
								[
									153.8916992187502,
									59.11416015624994
								],
								[
									153.69521484375014,
									59.22475585937508
								],
								[
									153.3611328125,
									59.214794921874926
								],
								[
									153.27294921875,
									59.09130859375
								],
								[
									153.19609375000016,
									59.094433593749926
								],
								[
									153.0777343750002,
									59.081884765625034
								],
								[
									152.88222656249997,
									58.93906249999998
								],
								[
									152.8178710937501,
									58.92626953124994
								],
								[
									152.57558593750014,
									58.95410156250003
								],
								[
									152.40068359375,
									59.0264160156251
								],
								[
									152.31962890625005,
									59.03076171875
								],
								[
									152.16523437500018,
									58.99702148437507
								],
								[
									152.08789062499994,
									58.9104492187501
								],
								[
									151.70458984374994,
									58.86669921874997
								],
								[
									151.3267578125001,
									58.875097656250006
								],
								[
									151.1210937500001,
									59.08251953125006
								],
								[
									151.50498046875003,
									59.16401367187507
								],
								[
									151.7334960937501,
									59.1466796875001
								],
								[
									151.99003906250005,
									59.160058593749966
								],
								[
									152.26064453124997,
									59.22358398437504
								],
								[
									152.1695312500001,
									59.277929687500006
								],
								[
									152.1044921875,
									59.2905761718751
								],
								[
									151.9423828125,
									59.28408203125011
								],
								[
									151.79804687500018,
									59.3232421875
								],
								[
									151.48574218750014,
									59.52412109375007
								],
								[
									151.3482421875002,
									59.56113281250006
								],
								[
									151.17031250000002,
									59.58325195312494
								],
								[
									151.03359375000014,
									59.58564453124998
								],
								[
									150.9825195312502,
									59.5713378906251
								],
								[
									150.91191406250005,
									59.52304687500012
								],
								[
									150.86328125,
									59.475439453125006
								],
								[
									150.8234375,
									59.46074218750013
								],
								[
									150.7294921875,
									59.469140624999966
								],
								[
									150.615234375,
									59.50654296875004
								],
								[
									150.48359375000018,
									59.49438476562506
								],
								[
									150.53984375000016,
									59.52495117187496
								],
								[
									150.66728515625,
									59.55634765625007
								],
								[
									150.4572265625,
									59.59072265625005
								],
								[
									150.32558593750014,
									59.63886718750007
								],
								[
									150.20253906250002,
									59.65126953124994
								],
								[
									149.642578125,
									59.770410156249966
								],
								[
									149.42451171875007,
									59.760986328125
								],
								[
									149.29042968750002,
									59.728466796874955
								],
								[
									149.06523437500005,
									59.63051757812508
								],
								[
									149.12773437500016,
									59.558789062499926
								],
								[
									149.1753906250002,
									59.52675781250008
								],
								[
									149.20498046875002,
									59.48818359374994
								],
								[
									149.13300781250018,
									59.480517578125074
								],
								[
									148.92500000000018,
									59.47500000000008
								],
								[
									148.7970703125,
									59.532324218750034
								],
								[
									148.70888671875002,
									59.44853515625013
								],
								[
									148.744140625,
									59.37353515624994
								],
								[
									148.88964843749994,
									59.400000000000006
								],
								[
									148.96464843750016,
									59.36914062500003
								],
								[
									148.91406249999994,
									59.28271484375
								],
								[
									148.7266601562501,
									59.257910156250006
								],
								[
									148.4912109375,
									59.26230468750009
								],
								[
									148.25742187500003,
									59.414208984374966
								],
								[
									147.87460937500003,
									59.38803710937506
								],
								[
									147.68789062500002,
									59.29067382812494
								],
								[
									147.51445312500005,
									59.26855468750006
								],
								[
									147.0400390625001,
									59.36572265624994
								],
								[
									146.8037109375001,
									59.372949218749994
								],
								[
									146.5372070312501,
									59.45698242187507
								],
								[
									146.4443359375,
									59.43046874999999
								],
								[
									146.2734375,
									59.22148437499996
								],
								[
									146.04951171875018,
									59.17055664062505
								],
								[
									145.931640625,
									59.198388671874966
								],
								[
									145.82910156249994,
									59.330322265625114
								],
								[
									145.7564453125001,
									59.37373046874998
								],
								[
									145.55458984374997,
									59.41352539062501
								],
								[
									144.4833984375,
									59.37626953124996
								],
								[
									144.12343750000002,
									59.408300781250006
								],
								[
									143.8687500000001,
									59.411376953125085
								],
								[
									143.52382812499997,
									59.34365234375008
								],
								[
									143.1921875,
									59.37011718750003
								],
								[
									142.58027343750007,
									59.24013671874994
								],
								[
									142.33037109375005,
									59.15263671874996
								],
								[
									142.025390625,
									58.99965820312505
								],
								[
									141.75468750000016,
									58.74526367187502
								],
								[
									141.60292968749997,
									58.64902343749995
								],
								[
									141.34707031249997,
									58.528076171875
								],
								[
									140.98769531250014,
									58.41684570312509
								],
								[
									140.79023437500007,
									58.303466796875085
								],
								[
									140.68496093750002,
									58.21215820312494
								],
								[
									140.49511718749994,
									57.86542968750001
								],
								[
									140.4468750000001,
									57.81367187500004
								],
								[
									140.00234375000014,
									57.6875
								],
								[
									139.8615234375,
									57.54931640625
								],
								[
									139.8033203125001,
									57.51416015624994
								],
								[
									139.61923828125003,
									57.45571289062494
								],
								[
									139.50664062500005,
									57.35830078125008
								],
								[
									139.4438476562501,
									57.32968750000012
								],
								[
									139.181640625,
									57.26152343749999
								],
								[
									138.96572265625014,
									57.088134765625114
								],
								[
									138.6621093750001,
									56.9655273437501
								],
								[
									138.2177734375,
									56.629003906250006
								],
								[
									138.18007812500014,
									56.58852539062502
								],
								[
									138.1406250000001,
									56.49868164062511
								],
								[
									138.0738281250001,
									56.43310546874997
								],
								[
									137.6915039062501,
									56.13935546875007
								],
								[
									137.57294921875018,
									56.112109375000045
								],
								[
									137.38408203125016,
									55.97475585937494
								],
								[
									137.18984375000002,
									55.892285156249926
								],
								[
									137.01210937500014,
									55.79526367187506
								],
								[
									136.7935546875002,
									55.69418945312498
								],
								[
									136.46025390625016,
									55.57670898437502
								],
								[
									136.35117187500003,
									55.51000976562494
								],
								[
									136.17519531249997,
									55.352246093749955
								],
								[
									135.75078125000005,
									55.16064453125
								],
								[
									135.5406250000002,
									55.11376953125003
								],
								[
									135.26250000000005,
									54.943310546874955
								],
								[
									135.23476562499997,
									54.90322265625005
								],
								[
									135.2115234375002,
									54.84082031249994
								],
								[
									135.25771484375014,
									54.73149414062496
								],
								[
									135.32539062500007,
									54.70742187500002
								],
								[
									135.43779296875005,
									54.692480468750006
								],
								[
									135.85156249999994,
									54.583935546874926
								],
								[
									136.23798828125018,
									54.61406249999993
								],
								[
									136.58027343750018,
									54.61362304687512
								],
								[
									136.71455078125018,
									54.624316406250074
								],
								[
									136.79726562499997,
									54.62099609375011
								],
								[
									136.8237304687501,
									54.56147460937507
								],
								[
									136.8204101562501,
									54.45234375000004
								],
								[
									136.77041015625002,
									54.35332031250002
								],
								[
									136.72939453125002,
									54.06064453125006
								],
								[
									136.68300781250014,
									53.93129882812511
								],
								[
									136.7188476562501,
									53.80410156250002
								],
								[
									136.80263671875002,
									53.78198242187497
								],
								[
									136.88642578125,
									53.83935546875003
								],
								[
									137.01875000000007,
									53.84814453124994
								],
								[
									137.1553710937502,
									53.82167968750005
								],
								[
									137.25800781250007,
									54.02524414062506
								],
								[
									137.1724609375002,
									54.056884765625114
								],
								[
									137.0961914062501,
									54.128564453124966
								],
								[
									137.14160156249994,
									54.18222656249998
								],
								[
									137.377734375,
									54.282324218750034
								],
								[
									137.52509765625018,
									54.29121093750007
								],
								[
									137.6660156250001,
									54.28330078125006
								],
								[
									137.51318359375,
									54.15639648437505
								],
								[
									137.4512695312501,
									54.13046875000009
								],
								[
									137.4034179687502,
									54.123535156250085
								],
								[
									137.33925781249997,
									54.10053710937504
								],
								[
									137.47646484375014,
									54.027587890625
								],
								[
									137.62275390625018,
									53.970458984375
								],
								[
									137.83476562500005,
									53.946728515624955
								],
								[
									137.7861328125,
									53.9033203125
								],
								[
									137.64482421875016,
									53.86582031250009
								],
								[
									137.51699218750014,
									53.70708007812499
								],
								[
									137.313671875,
									53.63159179687497
								],
								[
									137.22148437500016,
									53.579199218750034
								],
								[
									137.25371093750016,
									53.54614257812497
								],
								[
									137.32832031250018,
									53.53896484375002
								],
								[
									137.73818359374997,
									53.560302734375114
								],
								[
									137.95048828125016,
									53.603564453125045
								],
								[
									138.25292968749994,
									53.72641601562512
								],
								[
									138.37890624999994,
									53.90927734375006
								],
								[
									138.49355468750014,
									53.959667968749926
								],
								[
									138.5279296875002,
									53.959863281249966
								],
								[
									138.56816406250016,
									53.94716796875005
								],
								[
									138.569140625,
									53.81879882812501
								],
								[
									138.40703125,
									53.674169921875034
								],
								[
									138.29218750000007,
									53.59243164062508
								],
								[
									138.24970703125,
									53.52402343750009
								],
								[
									138.3203125000001,
									53.52290039062504
								],
								[
									138.4506835937501,
									53.53701171875008
								],
								[
									138.5109375,
									53.570019531249955
								],
								[
									138.6607421875002,
									53.74477539062494
								],
								[
									138.69941406250007,
									53.86972656250009
								],
								[
									138.7216796875,
									54.0437500000001
								],
								[
									138.7046875000001,
									54.14765625000004
								],
								[
									138.71591796875003,
									54.22265625000003
								],
								[
									138.6572265625,
									54.29833984375
								],
								[
									138.69570312500002,
									54.32001953124998
								],
								[
									139.1050781250002,
									54.217822265625045
								],
								[
									139.31972656250014,
									54.192968750000034
								],
								[
									139.70742187499997,
									54.277148437500045
								],
								[
									139.7955078125001,
									54.25644531250009
								],
								[
									139.8583984375001,
									54.20532226562497
								],
								[
									140.1787109375,
									54.0515625000001
								],
								[
									140.2416992187501,
									54.0010253906251
								],
								[
									140.34707031250002,
									53.81259765625009
								],
								[
									140.6875976562502,
									53.596435546875
								],
								[
									141.00566406250016,
									53.49458007812504
								],
								[
									141.01503906250002,
									53.454248046874994
								],
								[
									141.21767578125002,
									53.334472656250114
								],
								[
									141.37373046875018,
									53.29277343749996
								],
								[
									141.40205078125018,
									53.183984374999994
								],
								[
									141.3279296875,
									53.097265625000006
								],
								[
									141.18125000000003,
									53.01528320312508
								],
								[
									140.8873046875002,
									53.09150390624998
								],
								[
									140.8396484375,
									53.08789062500006
								],
								[
									140.87451171875,
									53.039843750000045
								],
								[
									141.08681640624997,
									52.89755859375009
								],
								[
									141.25585937499994,
									52.84013671874993
								],
								[
									141.26591796875016,
									52.652587890625085
								],
								[
									141.24501953124997,
									52.550146484375006
								],
								[
									141.13242187500003,
									52.435693359374966
								],
								[
									141.16982421875014,
									52.36840820312503
								],
								[
									141.3296875000001,
									52.27114257812511
								],
								[
									141.40908203125002,
									52.23432617187507
								],
								[
									141.48525390624997,
									52.178515625000074
								],
								[
									141.385546875,
									52.05722656249995
								],
								[
									141.36689453125,
									51.920654296875114
								],
								[
									141.25839843750003,
									51.86069335937506
								],
								[
									141.12939453124994,
									51.727783203125085
								],
								[
									140.9326171875001,
									51.619921875000045
								],
								[
									140.83857421875,
									51.41416015624995
								],
								[
									140.6876953125,
									51.23227539062512
								],
								[
									140.67070312500005,
									51.05131835937502
								],
								[
									140.6456054687501,
									50.98676757812501
								],
								[
									140.52089843749997,
									50.80019531250011
								],
								[
									140.47636718750016,
									50.545996093750006
								],
								[
									140.53544921875,
									50.130761718749966
								],
								[
									140.5640625000001,
									50.10668945312494
								],
								[
									140.62451171874994,
									50.08242187500008
								],
								[
									140.61328124999994,
									50.053710937500085
								],
								[
									140.5845703125001,
									50.03334960937502
								],
								[
									140.46269531250005,
									49.91147460937506
								],
								[
									140.46455078125007,
									49.825585937499966
								],
								[
									140.5113281250001,
									49.7616699218751
								],
								[
									140.5171875000002,
									49.59614257812504
								],
								[
									140.43105468749997,
									49.33149414062504
								],
								[
									140.39912109375,
									49.28979492187497
								],
								[
									140.36435546875003,
									49.22084960937505
								],
								[
									140.34863281249994,
									49.1591796875
								],
								[
									140.32558593749997,
									49.12001953125002
								],
								[
									140.30898437499997,
									49.05390625000004
								],
								[
									140.33369140625,
									48.99482421875001
								],
								[
									140.37832031249997,
									48.96411132812506
								],
								[
									140.2242187500002,
									48.772851562499994
								],
								[
									140.17060546875,
									48.52368164062494
								],
								[
									140.11328125,
									48.422656250000045
								],
								[
									139.99843750000014,
									48.32377929687499
								],
								[
									139.7607421875001,
									48.18056640624994
								],
								[
									139.67626953124994,
									48.089892578125045
								],
								[
									139.5205078125001,
									47.975292968749955
								],
								[
									139.3726562500001,
									47.88735351562508
								],
								[
									139.1669921875001,
									47.63486328125006
								],
								[
									139.00136718750014,
									47.38330078125006
								],
								[
									138.58681640625014,
									47.05722656250006
								],
								[
									138.52968750000014,
									46.97622070312508
								],
								[
									138.50048828124994,
									46.88984375000007
								],
								[
									138.39179687500018,
									46.74506835937507
								],
								[
									138.3369140625001,
									46.54340820312501
								],
								[
									138.21015625000007,
									46.46293945312496
								],
								[
									138.10634765625014,
									46.25073242187506
								],
								[
									137.7691406250001,
									45.928515625000074
								],
								[
									137.68544921874997,
									45.818359375
								],
								[
									137.42519531250002,
									45.63999023437509
								],
								[
									137.14697265625,
									45.393505859374955
								],
								[
									136.803515625,
									45.17114257812503
								],
								[
									136.73720703124997,
									45.080029296874955
								],
								[
									136.60410156250003,
									44.97817382812508
								],
								[
									136.4604492187501,
									44.82211914062509
								],
								[
									136.25117187500018,
									44.66679687499996
								],
								[
									136.20869140625007,
									44.56201171875003
								],
								[
									136.14228515625,
									44.489111328125006
								],
								[
									135.98701171875018,
									44.43984375000008
								],
								[
									135.8746093750002,
									44.373535156250085
								],
								[
									135.5332031250001,
									43.971484375000074
								],
								[
									135.4890625,
									43.89882812500011
								],
								[
									135.4833984375,
									43.835009765625074
								],
								[
									135.26015624999997,
									43.684619140625074
								],
								[
									135.13105468750018,
									43.52573242187512
								],
								[
									134.9169921875,
									43.426562500000074
								],
								[
									134.69179687500002,
									43.29057617187499
								],
								[
									134.1564453125,
									43.04213867187508
								],
								[
									134.01044921875,
									42.94746093749998
								],
								[
									133.70937499999997,
									42.82993164062512
								],
								[
									133.58671875000005,
									42.828222656250034
								],
								[
									133.32949218750014,
									42.76386718750007
								],
								[
									133.15996093750016,
									42.69697265625004
								],
								[
									133.05937500000016,
									42.72280273437505
								],
								[
									132.99658203125,
									42.808007812499994
								],
								[
									132.9239257812502,
									42.80527343749998
								],
								[
									132.86357421875016,
									42.79374999999993
								],
								[
									132.7089843750001,
									42.87583007812506
								],
								[
									132.57646484375,
									42.871582031250085
								],
								[
									132.48134765625002,
									42.90976562499995
								],
								[
									132.3038085937501,
									42.88330078124997
								],
								[
									132.33437499999997,
									43.23867187500008
								],
								[
									132.3095703125,
									43.31352539062496
								],
								[
									132.23320312500016,
									43.245068359374955
								],
								[
									132.02871093749997,
									43.11894531249993
								],
								[
									131.947265625,
									43.095410156249926
								],
								[
									131.86660156249997,
									43.09516601562507
								],
								[
									131.89833984374997,
									43.170751953125006
								],
								[
									132.01308593749997,
									43.28002929687497
								],
								[
									131.97626953125,
									43.29604492187505
								],
								[
									131.93896484375,
									43.3019531250001
								],
								[
									131.7947265625,
									43.255273437499994
								],
								[
									131.72207031250014,
									43.202636718750114
								],
								[
									131.51640625000016,
									42.99643554687512
								],
								[
									131.39326171875,
									42.822314453125074
								],
								[
									131.2924804687501,
									42.772119140624966
								],
								[
									131.24531250000018,
									42.69741210937494
								],
								[
									131.1583007812502,
									42.62602539062496
								],
								[
									131.02480468750002,
									42.64516601562505
								],
								[
									130.94570312500014,
									42.63393554687505
								],
								[
									130.75615234375016,
									42.6732910156251
								],
								[
									130.70937500000014,
									42.65639648437502
								],
								[
									130.83417968750018,
									42.522949218750114
								],
								[
									130.72988281250014,
									42.32578125000009
								],
								[
									130.68730468750016,
									42.30253906249996
								]
							]
						],
						[
							[
								[
									107.69550781250001,
									78.13090820312502
								],
								[
									107.60625000000016,
									78.08256835937513
								],
								[
									107.48164062500007,
									78.05776367187505
								],
								[
									107.34384765625003,
									78.09858398437501
								],
								[
									107.00166015625007,
									78.09565429687504
								],
								[
									106.41552734375011,
									78.13984375000007
								],
								[
									106.58330078124999,
									78.16757812500003
								],
								[
									107.50830078125,
									78.18940429687504
								],
								[
									107.5732421875,
									78.18554687500006
								],
								[
									107.69550781250001,
									78.13090820312502
								]
							]
						],
						[
							[
								[
									106.27041015625014,
									78.206201171875
								],
								[
									106.15107421875007,
									78.19863281249997
								],
								[
									106.02363281250001,
									78.22011718750008
								],
								[
									106.05839843749999,
									78.2646484375
								],
								[
									106.35058593750011,
									78.27260742187494
								],
								[
									106.45683593749999,
									78.34003906250007
								],
								[
									106.64042968749999,
									78.33623046875002
								],
								[
									106.69121093750016,
									78.31665039062503
								],
								[
									106.71962890624997,
									78.29418945312497
								],
								[
									106.71894531250001,
									78.26499023437498
								],
								[
									106.67910156249997,
									78.26499023437498
								],
								[
									106.50468750000016,
									78.26166992187493
								],
								[
									106.47246093750016,
									78.24501953125
								],
								[
									106.27041015625014,
									78.206201171875
								]
							]
						],
						[
							[
								[
									102.88476562499994,
									79.25395507812502
								],
								[
									102.78730468750018,
									79.17641601562494
								],
								[
									102.74580078125018,
									79.10605468750009
								],
								[
									102.4478515625002,
									78.87666015624998
								],
								[
									102.41230468750018,
									78.83544921875003
								],
								[
									102.58730468750014,
									78.87128906249995
								],
								[
									102.7476562500002,
									78.949560546875
								],
								[
									102.84482421875009,
									79.01435546875007
								],
								[
									102.95039062500018,
									79.05576171875006
								],
								[
									103.07568359374994,
									79.05649414062503
								],
								[
									103.19912109375014,
									79.07128906250003
								],
								[
									103.43339843749999,
									79.126123046875
								],
								[
									103.67285156250011,
									79.14999999999998
								],
								[
									103.80078124999994,
									79.149267578125
								],
								[
									103.92568359375002,
									79.12324218750004
								],
								[
									104.00400390625009,
									79.06254882812502
								],
								[
									104.09111328125016,
									79.01318359375
								],
								[
									104.40419921874997,
									78.97709960937502
								],
								[
									104.44921875000011,
									78.96391601562499
								],
								[
									104.47695312500014,
									78.92333984375009
								],
								[
									104.45205078125014,
									78.88002929687505
								],
								[
									104.63320312500002,
									78.83515625000004
								],
								[
									104.88105468750007,
									78.85488281250008
								],
								[
									105.01464843750011,
									78.8433105468751
								],
								[
									105.14599609375011,
									78.81884765625011
								],
								[
									105.20458984374994,
									78.779931640625
								],
								[
									105.25605468750007,
									78.73300781250003
								],
								[
									105.31015625000009,
									78.666162109375
								],
								[
									105.34267578125014,
									78.59394531250004
								],
								[
									105.3125976562502,
									78.49990234374997
								],
								[
									104.83261718750003,
									78.35273437500001
								],
								[
									104.7417968750002,
									78.33974609374994
								],
								[
									104.51943359375002,
									78.34921875000009
								],
								[
									104.29746093750009,
									78.33505859374995
								],
								[
									103.71933593750009,
									78.25825195312504
								],
								[
									103.00312500000018,
									78.25585937500009
								],
								[
									102.79667968750016,
									78.187890625
								],
								[
									102.73437499999994,
									78.18989257812495
								],
								[
									102.67314453124999,
									78.20170898437496
								],
								[
									102.6171875,
									78.22460937500011
								],
								[
									102.18046874999999,
									78.20532226562509
								],
								[
									101.69238281249994,
									78.19433593749997
								],
								[
									101.20410156249994,
									78.19194335937502
								],
								[
									101.03994140625002,
									78.14296875
								],
								[
									100.54121093750018,
									78.047509765625
								],
								[
									100.08222656250001,
									77.97499999999997
								],
								[
									99.84501953124999,
									77.95683593749999
								],
								[
									99.50029296875005,
									77.97607421875
								],
								[
									99.3916992187502,
									78.00068359374995
								],
								[
									99.28710937500011,
									78.03808593749994
								],
								[
									99.43867187500018,
									78.08393554687495
								],
								[
									99.54560546875001,
									78.17856445312503
								],
								[
									99.67792968750018,
									78.23349609375003
								],
								[
									100.01894531250002,
									78.33891601562513
								],
								[
									100.05751953125014,
									78.38037109374994
								],
								[
									100.12353515625,
									78.470458984375
								],
								[
									100.16298828125014,
									78.50395507812499
								],
								[
									100.21503906250018,
									78.535791015625
								],
								[
									100.25722656250014,
									78.57382812500009
								],
								[
									100.26269531250011,
									78.63149414062505
								],
								[
									100.28398437499999,
									78.67919921875009
								],
								[
									100.41640624999997,
									78.75317382812506
								],
								[
									100.51562500000011,
									78.7877929687501
								],
								[
									100.61962890625,
									78.7974121093751
								],
								[
									100.87558593750009,
									78.78359374999994
								],
								[
									100.95576171875018,
									78.78847656250005
								],
								[
									100.89794921875011,
									78.81245117187495
								],
								[
									100.85625000000016,
									78.89775390625002
								],
								[
									100.86455078125016,
									78.92583007812496
								],
								[
									100.90136718750011,
									78.980078125
								],
								[
									100.9654296875002,
									79.00654296875007
								],
								[
									101.0308593750002,
									79.023291015625
								],
								[
									101.06816406250016,
									79.09624023437505
								],
								[
									101.05224609375011,
									79.12324218750004
								],
								[
									101.14882812499997,
									79.15688476562497
								],
								[
									101.19609374999999,
									79.20444335937506
								],
								[
									101.31044921875014,
									79.23261718750001
								],
								[
									101.5430664062502,
									79.25444335937513
								],
								[
									101.5552734375002,
									79.31264648437508
								],
								[
									101.59062499999999,
									79.35043945312503
								],
								[
									101.64335937499999,
									79.36137695312496
								],
								[
									101.76132812500003,
									79.37197265625
								],
								[
									101.82421875,
									79.37021484375009
								],
								[
									101.91210937499994,
									79.31162109374995
								],
								[
									102.00527343750002,
									79.26367187500006
								],
								[
									102.12851562500009,
									79.25249023437499
								],
								[
									102.25126953125005,
									79.25605468750001
								],
								[
									102.17724609374994,
									79.31259765624998
								],
								[
									102.18066406249994,
									79.37338867187509
								],
								[
									102.22509765624994,
									79.41293945312509
								],
								[
									102.28242187500018,
									79.43007812500002
								],
								[
									102.40488281250009,
									79.43320312499995
								],
								[
									102.78984375000016,
									79.39213867187502
								],
								[
									103.0416015625002,
									79.33154296875011
								],
								[
									103.09794921875016,
									79.29912109374999
								],
								[
									103.05244140625018,
									79.28251953125007
								],
								[
									102.93964843750001,
									79.27119140624998
								],
								[
									102.88476562499994,
									79.25395507812502
								]
							]
						],
						[
							[
								[
									76.24892578125014,
									79.65107421874993
								],
								[
									76.37255859375,
									79.61523437500009
								],
								[
									76.4673828125002,
									79.64316406250009
								],
								[
									77.36015625000005,
									79.5568359375001
								],
								[
									77.54931640625011,
									79.52441406250006
								],
								[
									77.5889648437502,
									79.5019042968751
								],
								[
									76.81015625000003,
									79.48950195312506
								],
								[
									76.6495117187502,
									79.49340820312503
								],
								[
									76.63652343750005,
									79.54443359375006
								],
								[
									76.4576171875002,
									79.54545898437499
								],
								[
									76.15371093749997,
									79.57875976562494
								],
								[
									76.0718750000002,
									79.62563476562508
								],
								[
									76.05156250000016,
									79.64472656249995
								],
								[
									76.1484375,
									79.66445312500008
								],
								[
									76.24892578125014,
									79.65107421874993
								]
							]
						],
						[
							[
								[
									100.13593750000001,
									79.61420898437495
								],
								[
									99.91542968750014,
									79.60161132812505
								],
								[
									99.94228515625002,
									79.67143554687499
								],
								[
									99.95576171875018,
									79.69033203125002
								],
								[
									100.06835937500011,
									79.70102539062498
								],
								[
									100.14150390625002,
									79.68369140625009
								],
								[
									100.30029296875011,
									79.670263671875
								],
								[
									100.13593750000001,
									79.61420898437495
								]
							]
						],
						[
							[
								[
									92.68349609375014,
									79.68520507812502
								],
								[
									92.44062500000001,
									79.67548828124993
								],
								[
									92.15371093750002,
									79.68466796875009
								],
								[
									91.68359375,
									79.7905761718751
								],
								[
									91.37626953125016,
									79.83549804687502
								],
								[
									91.12607421875009,
									79.90493164062502
								],
								[
									91.07031250000011,
									79.9814941406251
								],
								[
									91.22929687500016,
									80.03071289062507
								],
								[
									91.42597656250018,
									80.04921874999994
								],
								[
									91.75195312499994,
									80.05229492187505
								],
								[
									92.1734375000002,
									80.04545898437507
								],
								[
									92.59277343750011,
									79.99653320312495
								],
								[
									93.48154296875009,
									79.94111328125004
								],
								[
									93.80312500000014,
									79.90454101562506
								],
								[
									93.60351562499994,
									79.816748046875
								],
								[
									93.38203125000007,
									79.78388671874998
								],
								[
									93.15507812499999,
									79.73759765624996
								],
								[
									92.92626953125011,
									79.70449218749997
								],
								[
									92.68349609375014,
									79.68520507812502
								]
							]
						],
						[
							[
								[
									51.40927734375009,
									79.94423828124997
								],
								[
									51.435156250000034,
									79.93193359375013
								],
								[
									51.431250000000034,
									79.9205078125
								],
								[
									51.076269531250034,
									79.93198242187495
								],
								[
									50.454101562500114,
									79.9244140625
								],
								[
									50.091406250000034,
									79.98056640625009
								],
								[
									50.47265625,
									80.03544921875007
								],
								[
									50.67578124999994,
									80.04853515624998
								],
								[
									50.936328125000045,
									80.09423828124997
								],
								[
									51.25439453125,
									80.0486328125001
								],
								[
									51.23789062500009,
									80.01035156250012
								],
								[
									51.242773437500034,
									79.99125976562505
								],
								[
									51.326953125000045,
									79.972314453125
								],
								[
									51.40927734375009,
									79.94423828124997
								]
							]
						],
						[
							[
								[
									59.688867187500136,
									79.95581054687509
								],
								[
									59.33066406250009,
									79.9230468750001
								],
								[
									59.202636718750114,
									79.93295898437498
								],
								[
									59.16923828125016,
									79.94829101562499
								],
								[
									59.10039062500016,
									79.96416015625002
								],
								[
									58.91923828124999,
									79.98461914062511
								],
								[
									58.94609375000016,
									80.04233398437506
								],
								[
									59.00146484375,
									80.05390624999993
								],
								[
									59.544531250000034,
									80.11884765625001
								],
								[
									59.801660156250136,
									80.08266601562511
								],
								[
									59.91103515625002,
									79.99428710937494
								],
								[
									59.688867187500136,
									79.95581054687509
								]
							]
						],
						[
							[
								[
									97.67451171875007,
									80.15825195312505
								],
								[
									97.90361328124999,
									80.09501953125005
								],
								[
									98.01777343750018,
									80.0228515625
								],
								[
									97.90673828125011,
									80.003759765625
								],
								[
									97.80791015625005,
									79.95629882812503
								],
								[
									97.75996093750007,
									79.89584960937506
								],
								[
									97.62695312500011,
									79.85043945312495
								],
								[
									97.59130859374994,
									79.77495117187502
								],
								[
									97.65166015624999,
									79.76064453125005
								],
								[
									97.72451171875002,
									79.78139648437508
								],
								[
									97.87070312500003,
									79.85263671874995
								],
								[
									98.0645507812502,
									79.90107421874995
								],
								[
									98.27324218750016,
									79.87412109374998
								],
								[
									98.3531250000002,
									79.88432617187502
								],
								[
									98.4990234375,
									79.953125
								],
								[
									98.47187500000001,
									80.00913085937495
								],
								[
									98.53183593750009,
									80.04360351562505
								],
								[
									98.59648437500005,
									80.05219726562493
								],
								[
									98.86591796875001,
									80.04541015624997
								],
								[
									99.29492187500011,
									80.016357421875
								],
								[
									99.3707031250002,
									79.98637695312502
								],
								[
									99.47304687499997,
									79.97016601562501
								],
								[
									99.53613281249994,
									79.94130859375008
								],
								[
									99.72656250000011,
									79.91992187500006
								],
								[
									99.818359375,
									79.898193359375
								],
								[
									99.94658203124999,
									79.848974609375
								],
								[
									100.06123046875018,
									79.77709960937511
								],
								[
									99.91582031250016,
									79.73833007812502
								],
								[
									99.83925781249997,
									79.66894531250009
								],
								[
									99.80546875000005,
									79.65307617187497
								],
								[
									99.78164062499997,
									79.62827148437498
								],
								[
									99.77109375000003,
									79.56772460937509
								],
								[
									99.74882812500005,
									79.51518554687505
								],
								[
									99.72119140625011,
									79.491845703125
								],
								[
									99.70625000000018,
									79.46347656249998
								],
								[
									99.72158203125002,
									79.385107421875
								],
								[
									99.68066406250011,
									79.32333984374995
								],
								[
									99.53730468750001,
									79.27656250000001
								],
								[
									99.3877929687502,
									79.27475585937509
								],
								[
									99.1670898437502,
									79.30629882812494
								],
								[
									99.10439453125014,
									79.30537109374993
								],
								[
									99.04179687500016,
									79.29301757812499
								],
								[
									99.3173828125,
									79.22719726562508
								],
								[
									99.51728515625001,
									79.1301757812501
								],
								[
									99.75078124999999,
									79.10766601562497
								],
								[
									99.81464843750001,
									79.09584960937497
								],
								[
									99.89960937500001,
									79.00639648437513
								],
								[
									99.9292968750002,
									78.96142578125003
								],
								[
									99.54082031250005,
									78.85273437500007
								],
								[
									99.4395507812502,
									78.83422851562503
								],
								[
									98.81953125000018,
									78.81826171875008
								],
								[
									98.41113281250011,
									78.7877929687501
								],
								[
									98.28251953124999,
									78.79501953125003
								],
								[
									98.05419921875011,
									78.82099609374993
								],
								[
									97.90517578125014,
									78.81020507812494
								],
								[
									97.68857421875009,
									78.82734375000007
								],
								[
									97.55546875000005,
									78.8265625
								],
								[
									97.24814453125003,
									78.86801757812509
								],
								[
									96.93291015625005,
									78.93393554687509
								],
								[
									96.87119140625009,
									78.96381835937507
								],
								[
									96.80781250000007,
									78.98496093750012
								],
								[
									96.42998046875016,
									79.00302734375006
								],
								[
									96.34736328125001,
									79.01586914062509
								],
								[
									95.79648437500009,
									79.0014160156251
								],
								[
									95.70283203125018,
									79.01201171875002
								],
								[
									95.53105468750016,
									79.09809570312507
								],
								[
									95.43691406250002,
									79.09931640624995
								],
								[
									95.13320312500014,
									79.04960937499996
								],
								[
									95.02041015625014,
									79.05268554687495
								],
								[
									94.79101562499994,
									79.08662109375004
								],
								[
									94.65234375000011,
									79.12749023437502
								],
								[
									94.63164062500016,
									79.14086914062509
								],
								[
									94.61972656250003,
									79.1923828125
								],
								[
									94.48212890625018,
									79.218603515625
								],
								[
									94.31376953125016,
									79.30751953125011
								],
								[
									94.21875,
									79.40234375000006
								],
								[
									93.75859375000005,
									79.45141601562511
								],
								[
									93.47871093750001,
									79.462744140625
								],
								[
									93.27226562500016,
									79.45839843750002
								],
								[
									93.07080078124994,
									79.49531249999998
								],
								[
									93.40468750000014,
									79.63159179687494
								],
								[
									93.84726562500003,
									79.70166015625011
								],
								[
									94.03818359375003,
									79.75600585937508
								],
								[
									94.25712890625016,
									79.829736328125
								],
								[
									94.34726562500003,
									79.9419433593751
								],
								[
									94.71943359375001,
									80.01123046875003
								],
								[
									94.81503906250003,
									80.03481445312494
								],
								[
									94.94677734375,
									80.08925781250002
								],
								[
									94.98730468749994,
									80.09682617187497
								],
								[
									95.2813476562502,
									80.03051757812503
								],
								[
									95.3379882812502,
									80.04213867187511
								],
								[
									95.3907226562502,
									80.07280273437505
								],
								[
									95.49755859375011,
									80.10561523437505
								],
								[
									95.85781250000014,
									80.11000976562508
								],
								[
									96.16250000000014,
									80.09682617187497
								],
								[
									96.27734375,
									80.11005859375007
								],
								[
									96.4166015625002,
									80.10434570312498
								],
								[
									97.12050781249997,
									80.15302734374995
								],
								[
									97.58681640625014,
									80.16826171875005
								],
								[
									97.67451171875007,
									80.15825195312505
								]
							]
						],
						[
							[
								[
									50.051757812500114,
									80.07431640625009
								],
								[
									49.97089843750018,
									80.06074218749998
								],
								[
									49.58828125000002,
									80.13613281250005
								],
								[
									49.556054687500136,
									80.158935546875
								],
								[
									49.883691406249966,
									80.23022460937506
								],
								[
									50.250976562500114,
									80.21948242187509
								],
								[
									50.309960937500136,
									80.18564453125003
								],
								[
									50.31914062500016,
									80.17236328125009
								],
								[
									50.072265625000114,
									80.10947265625006
								],
								[
									50.051757812500114,
									80.07431640625009
								]
							]
						],
						[
							[
								[
									55.47968750000007,
									80.27382812499997
								],
								[
									55.19511718749999,
									80.22680664062497
								],
								[
									55.048437500000034,
									80.22836914062503
								],
								[
									54.97968750000018,
									80.25644531249998
								],
								[
									55.09160156250016,
									80.29555664062502
								],
								[
									55.24003906249999,
									80.32539062499998
								],
								[
									55.35322265625007,
									80.31767578125002
								],
								[
									55.43476562500007,
									80.30224609374997
								],
								[
									55.47968750000007,
									80.27382812499997
								]
							]
						],
						[
							[
								[
									57.078710937500034,
									80.35092773437495
								],
								[
									57.122656250000034,
									80.31699218750006
								],
								[
									57.11894531250016,
									80.19394531250003
								],
								[
									57.07275390625,
									80.13940429687503
								],
								[
									57.08017578125009,
									80.09467773437507
								],
								[
									56.98691406250009,
									80.07148437499995
								],
								[
									56.200585937500136,
									80.07646484374999
								],
								[
									55.81162109375009,
									80.08715820312494
								],
								[
									55.72402343750002,
									80.10473632812497
								],
								[
									55.942285156249966,
									80.1632812500001
								],
								[
									56.012207031250114,
									80.20390625000002
								],
								[
									55.98984375000009,
									80.32006835937497
								],
								[
									56.024414062500114,
									80.34130859374994
								],
								[
									56.65507812500016,
									80.33032226562511
								],
								[
									56.70722656250001,
									80.36328124999997
								],
								[
									56.94453125000007,
									80.36616210937504
								],
								[
									57.078710937500034,
									80.35092773437495
								]
							]
						],
						[
							[
								[
									53.521386718749966,
									80.18520507812494
								],
								[
									52.856347656250136,
									80.17324218750008
								],
								[
									52.63593750000018,
									80.17885742187505
								],
								[
									52.607031250000034,
									80.191162109375
								],
								[
									52.55048828125018,
									80.20185546874995
								],
								[
									52.34355468749999,
									80.21323242187506
								],
								[
									52.21337890624994,
									80.26372070312513
								],
								[
									52.27021484375018,
									80.27631835937501
								],
								[
									52.57666015625,
									80.29692382812496
								],
								[
									52.68056640625002,
									80.31850585937508
								],
								[
									52.71601562500007,
									80.34755859374997
								],
								[
									52.853906249999966,
									80.40239257812505
								],
								[
									53.185644531250034,
									80.41264648437507
								],
								[
									53.32919921875009,
									80.40239257812505
								],
								[
									53.34589843750001,
									80.36630859374998
								],
								[
									53.48613281249999,
									80.32338867187494
								],
								[
									53.851660156250034,
									80.2683593750001
								],
								[
									53.777929687500034,
									80.22832031250002
								],
								[
									53.652929687500034,
									80.22255859375
								],
								[
									53.521386718749966,
									80.18520507812494
								]
							]
						],
						[
							[
								[
									57.95625000000001,
									80.12324218749993
								],
								[
									57.80009765624999,
									80.10405273437502
								],
								[
									57.39228515625007,
									80.13916015624997
								],
								[
									57.33232421874999,
									80.15810546875011
								],
								[
									57.28144531250007,
									80.19389648437502
								],
								[
									57.21406250000018,
									80.32827148437505
								],
								[
									57.21171875000016,
									80.36845703124996
								],
								[
									57.18623046875018,
									80.39624023437494
								],
								[
									57.08339843750002,
									80.44521484374997
								],
								[
									57.011132812500136,
									80.46831054687505
								],
								[
									57.07499999999999,
									80.49394531250005
								],
								[
									57.521972656250114,
									80.47539062499999
								],
								[
									58.48046875,
									80.46474609375005
								],
								[
									58.97167968749994,
									80.41586914062495
								],
								[
									59.11591796875001,
									80.38842773437494
								],
								[
									59.255468750000034,
									80.34321289062507
								],
								[
									58.39794921874994,
									80.31874999999997
								],
								[
									58.28388671875018,
									80.29780273437495
								],
								[
									58.28574218750009,
									80.24814453125006
								],
								[
									58.255468750000034,
									80.20180664062494
								],
								[
									58.16318359375009,
									80.19653320312503
								],
								[
									57.95625000000001,
									80.12324218749993
								]
							]
						],
						[
							[
								[
									54.415332031250045,
									80.472802734375
								],
								[
									54.27587890624994,
									80.42133789062507
								],
								[
									53.81191406250002,
									80.47622070312508
								],
								[
									53.850000000000136,
									80.50385742187493
								],
								[
									53.90019531250016,
									80.51542968750007
								],
								[
									53.90156250000018,
									80.54248046875006
								],
								[
									53.85888671875,
									80.56303710937499
								],
								[
									53.87724609374999,
									80.60527343749999
								],
								[
									54.176757812500114,
									80.574365234375
								],
								[
									54.20537109375016,
									80.561767578125
								],
								[
									54.407128906250136,
									80.54013671874995
								],
								[
									54.43730468750016,
									80.49868164062494
								],
								[
									54.415332031250045,
									80.472802734375
								]
							]
						],
						[
							[
								[
									47.44199218750009,
									80.85366210937497
								],
								[
									47.899511718750034,
									80.81269531250004
								],
								[
									48.24326171875009,
									80.82348632812494
								],
								[
									48.34521484375,
									80.81899414062508
								],
								[
									48.445703125000136,
									80.80600585937512
								],
								[
									48.54736328124994,
									80.77905273437494
								],
								[
									48.6865234375,
									80.71777343750009
								],
								[
									48.683593750000114,
									80.6332519531251
								],
								[
									48.62548828125,
									80.629296875
								],
								[
									48.044335937499966,
									80.66816406250001
								],
								[
									47.777343750000114,
									80.75625000000011
								],
								[
									47.70527343750018,
									80.76518554687496
								],
								[
									47.60009765625,
									80.74194335937494
								],
								[
									47.512304687500034,
									80.68793945312495
								],
								[
									47.414160156250034,
									80.67451171875007
								],
								[
									47.30390625000001,
									80.606201171875
								],
								[
									47.198242187500114,
									80.6149414062501
								],
								[
									47.144921874999966,
									80.60903320312505
								],
								[
									47.01103515625016,
									80.56210937499998
								],
								[
									46.67753906250016,
									80.5613281250001
								],
								[
									46.623925781249966,
									80.54067382812497
								],
								[
									46.513671875,
									80.47553710937493
								],
								[
									46.37812500000018,
									80.45678710937503
								],
								[
									46.14140625000016,
									80.44672851562493
								],
								[
									46.05986328125016,
									80.48378906250002
								],
								[
									46.02363281250018,
									80.540869140625
								],
								[
									45.96904296875016,
									80.56948242187505
								],
								[
									45.64082031250007,
									80.536962890625
								],
								[
									45.389257812500034,
									80.56030273437497
								],
								[
									45.14921874999999,
									80.59873046874998
								],
								[
									44.90498046875018,
									80.61127929687504
								],
								[
									45.124511718750114,
									80.65224609374997
								],
								[
									46.32744140625016,
									80.73515625000007
								],
								[
									46.79912109375016,
									80.75522460937498
								],
								[
									47.020605468750034,
									80.81440429687495
								],
								[
									47.35234375000016,
									80.8529296875
								],
								[
									47.44199218750009,
									80.85366210937497
								]
							]
						],
						[
							[
								[
									62.16777343750016,
									80.83476562500002
								],
								[
									62.22773437500018,
									80.79438476562504
								],
								[
									62.191796875000136,
									80.73022460937494
								],
								[
									62.114550781250045,
									80.68369140624998
								],
								[
									62.075781250000034,
									80.61694335937506
								],
								[
									61.769140625000034,
									80.60102539062501
								],
								[
									61.681250000000034,
									80.58632812499994
								],
								[
									61.597460937500045,
									80.53496093749996
								],
								[
									61.285156250000114,
									80.50473632812512
								],
								[
									61.05126953124994,
									80.41860351562497
								],
								[
									60.72226562500009,
									80.43466796874995
								],
								[
									60.27832031249994,
									80.49443359374996
								],
								[
									59.900195312500045,
									80.44609375000007
								],
								[
									59.649804687499966,
									80.43125000000006
								],
								[
									59.34638671875018,
									80.505029296875
								],
								[
									59.30439453125007,
									80.52153320312507
								],
								[
									59.288183593750034,
									80.57265625
								],
								[
									59.30625000000009,
									80.61777343749995
								],
								[
									59.38652343749999,
									80.712548828125
								],
								[
									59.495117187500114,
									80.76650390624997
								],
								[
									59.549414062500034,
									80.78359375000008
								],
								[
									59.592285156250114,
									80.81650390625003
								],
								[
									59.715820312500114,
									80.83637695312507
								],
								[
									60.09453124999999,
									80.84858398437507
								],
								[
									60.23496093750009,
									80.837744140625
								],
								[
									60.27802734375018,
									80.80146484374998
								],
								[
									60.48154296875009,
									80.80424804687502
								],
								[
									60.820214843750136,
									80.82656250000002
								],
								[
									61.31318359375001,
									80.86264648437509
								],
								[
									61.597460937500045,
									80.89291992187506
								],
								[
									61.850585937500114,
									80.88593750000004
								],
								[
									62.102929687499966,
									80.86660156249994
								],
								[
									62.16777343750016,
									80.83476562500002
								]
							]
						],
						[
							[
								[
									50.27812500000016,
									80.92724609374994
								],
								[
									50.431445312500045,
									80.91088867187509
								],
								[
									50.80107421874999,
									80.91416015625003
								],
								[
									50.91767578125007,
									80.89042968749999
								],
								[
									51.45478515625007,
									80.74467773437496
								],
								[
									51.59101562500018,
									80.74077148437496
								],
								[
									51.703613281250114,
									80.68764648437508
								],
								[
									51.14619140625007,
									80.60395507812498
								],
								[
									50.960839843750136,
									80.54047851562493
								],
								[
									50.27968750000002,
									80.52734375
								],
								[
									49.845996093750045,
									80.49765625000009
								],
								[
									49.74980468750016,
									80.47207031249994
								],
								[
									49.79414062500001,
									80.4253417968751
								],
								[
									49.5859375,
									80.37656250000012
								],
								[
									48.896093750000034,
									80.3691894531251
								],
								[
									48.811035156250114,
									80.35371093749998
								],
								[
									48.67705078124999,
									80.30004882812497
								],
								[
									48.688964843750114,
									80.29028320312494
								],
								[
									48.92197265625009,
									80.27680664062504
								],
								[
									48.95957031250009,
									80.26567382812499
								],
								[
									48.99082031250009,
									80.24238281249995
								],
								[
									49.01074218749994,
									80.20742187499994
								],
								[
									48.977539062500114,
									80.16259765624994
								],
								[
									48.89189453125016,
									80.15532226562507
								],
								[
									48.797363281250114,
									80.1611328125
								],
								[
									48.58173828125001,
									80.19536132812496
								],
								[
									48.55458984375002,
									80.18330078125007
								],
								[
									48.532617187499966,
									80.15825195312505
								],
								[
									48.466796875,
									80.110107421875
								],
								[
									48.386230468750114,
									80.09580078125012
								],
								[
									48.16718750000007,
									80.1327636718751
								],
								[
									48.09589843750018,
									80.122314453125
								],
								[
									48.02578125000002,
									80.09946289062506
								],
								[
									47.939941406250114,
									80.08862304687497
								],
								[
									47.73730468749994,
									80.08168945312508
								],
								[
									47.63242187500009,
									80.11196289062494
								],
								[
									47.723144531250114,
									80.15136718749997
								],
								[
									47.97753906249994,
									80.212548828125
								],
								[
									47.892968750000136,
									80.23925781250003
								],
								[
									47.64238281250016,
									80.24531249999993
								],
								[
									47.44433593749994,
									80.23012695312494
								],
								[
									47.343066406250045,
									80.18852539062499
								],
								[
									47.248632812500034,
									80.18022460937499
								],
								[
									46.99101562500016,
									80.18276367187497
								],
								[
									46.84589843750018,
									80.23720703124997
								],
								[
									46.738183593749966,
									80.25766601562495
								],
								[
									46.644433593749966,
									80.30034179687513
								],
								[
									47.402929687500034,
									80.44477539062507
								],
								[
									47.65605468749999,
									80.50053710937496
								],
								[
									47.89580078124999,
									80.529052734375
								],
								[
									48.20820312500007,
									80.54389648437501
								],
								[
									48.306152343750114,
									80.56157226562496
								],
								[
									48.40263671875016,
									80.56879882812493
								],
								[
									48.46474609375002,
									80.55805664062495
								],
								[
									48.62509765625009,
									80.50830078124994
								],
								[
									49.08779296875002,
									80.51577148437505
								],
								[
									49.18525390625018,
									80.55864257812499
								],
								[
									49.19267578125016,
									80.65600585937511
								],
								[
									49.147460937500114,
									80.71210937499998
								],
								[
									49.24433593750001,
									80.82138671875003
								],
								[
									49.50781249999994,
									80.86533203125003
								],
								[
									50.12431640625016,
									80.92387695312496
								],
								[
									50.27812500000016,
									80.92724609374994
								]
							]
						],
						[
							[
								[
									80.02666015625016,
									80.84814453125009
								],
								[
									79.09853515625014,
									80.81206054687502
								],
								[
									79.00683593750011,
									80.83481445312503
								],
								[
									78.9776367187502,
									80.8482421875
								],
								[
									79.10986328124994,
									80.923583984375
								],
								[
									79.2173828125002,
									80.96035156249994
								],
								[
									79.806640625,
									80.97539062500007
								],
								[
									80.27958984375016,
									80.9498046875
								],
								[
									80.42792968750018,
									80.92768554687504
								],
								[
									80.37333984375016,
									80.88261718750007
								],
								[
									80.3448242187502,
									80.86791992187503
								],
								[
									80.02666015625016,
									80.84814453125009
								]
							]
						],
						[
							[
								[
									61.14082031250018,
									80.95034179687494
								],
								[
									60.826757812500034,
									80.9296875
								],
								[
									60.32109375000016,
									80.95551757812493
								],
								[
									60.058203125000034,
									80.984619140625
								],
								[
									60.07832031250018,
									80.99916992187494
								],
								[
									60.147558593750034,
									81.01665039062505
								],
								[
									60.58662109375018,
									81.08769531250013
								],
								[
									61.45742187500002,
									81.10395507812507
								],
								[
									61.567382812500114,
									81.05029296875006
								],
								[
									61.47197265625016,
									81.01103515624996
								],
								[
									61.14082031250018,
									80.95034179687494
								]
							]
						],
						[
							[
								[
									54.71894531250007,
									81.11596679687503
								],
								[
									55.470703125000114,
									81.01987304687498
								],
								[
									56.17011718750001,
									81.029150390625
								],
								[
									56.472265625000034,
									80.99824218749993
								],
								[
									56.90966796875,
									80.91289062500005
								],
								[
									57.567773437500136,
									80.81972656250005
								],
								[
									57.69414062499999,
									80.79228515625007
								],
								[
									57.58037109374999,
									80.75546875000003
								],
								[
									56.81474609374999,
									80.66362304687505
								],
								[
									56.31552734375009,
									80.6328613281251
								],
								[
									55.883398437500034,
									80.62841796875009
								],
								[
									55.712500000000034,
									80.63730468750003
								],
								[
									55.540625000000034,
									80.70332031250007
								],
								[
									55.117187500000114,
									80.75190429687493
								],
								[
									54.66816406250001,
									80.73867187500008
								],
								[
									54.623339843750045,
									80.76523437499998
								],
								[
									54.53281250000009,
									80.78300781249996
								],
								[
									54.376074218750034,
									80.78696289062506
								],
								[
									54.06660156250001,
									80.81362304687505
								],
								[
									54.04541015625,
									80.87197265624997
								],
								[
									54.240527343750045,
									80.90185546875009
								],
								[
									54.36728515625009,
									80.90380859375006
								],
								[
									54.41679687500016,
									80.98652343750004
								],
								[
									54.63398437500018,
									81.11318359375008
								],
								[
									54.71894531250007,
									81.11596679687503
								]
							]
						],
						[
							[
								[
									58.622363281250045,
									81.04165039062508
								],
								[
									58.761523437500045,
									80.99096679687506
								],
								[
									58.815332031249966,
									80.93359375000009
								],
								[
									58.90253906250018,
									80.89765624999995
								],
								[
									58.93056640625002,
									80.83168945312502
								],
								[
									58.859960937500034,
									80.77939453125012
								],
								[
									58.64189453124999,
									80.76796875
								],
								[
									58.28564453125,
									80.764892578125
								],
								[
									57.93789062500002,
									80.79335937499994
								],
								[
									57.74980468750016,
									80.88906250000008
								],
								[
									57.405175781250136,
									80.91513671875006
								],
								[
									57.2109375,
									81.01708984374994
								],
								[
									57.41025390625009,
									81.04677734375005
								],
								[
									57.656250000000114,
									81.03154296874996
								],
								[
									58.04951171875001,
									81.11845703124999
								],
								[
									58.102343750000045,
									81.11425781249994
								],
								[
									58.189941406250114,
									81.09458007812509
								],
								[
									58.50761718749999,
									81.06176757812509
								],
								[
									58.622363281250045,
									81.04165039062508
								]
							]
						],
						[
							[
								[
									50.753710937500045,
									81.04741210937507
								],
								[
									50.61601562500016,
									81.04125976562509
								],
								[
									50.51816406250009,
									81.04555664062505
								],
								[
									50.411914062500045,
									81.08437500000008
								],
								[
									50.377441406250114,
									81.10273437499998
								],
								[
									50.36845703125016,
									81.12250976562493
								],
								[
									50.46494140625009,
									81.12622070312497
								],
								[
									50.50595703125009,
									81.14423828125001
								],
								[
									50.52158203125009,
									81.15820312500009
								],
								[
									50.591796875000114,
									81.16943359375009
								],
								[
									50.71591796875009,
									81.17065429687497
								],
								[
									50.87861328125018,
									81.15087890624994
								],
								[
									50.946191406249966,
									81.10815429687494
								],
								[
									50.78876953125018,
									81.07182617187507
								],
								[
									50.753710937500045,
									81.04741210937507
								]
							]
						],
						[
							[
								[
									63.37382812499999,
									80.70009765624994
								],
								[
									63.18759765625009,
									80.69760742187506
								],
								[
									63.00214843750001,
									80.71284179687495
								],
								[
									62.76044921875018,
									80.76269531250009
								],
								[
									62.52031249999999,
									80.82187500000006
								],
								[
									62.59257812499999,
									80.85302734375009
								],
								[
									62.819335937500114,
									80.89379882812497
								],
								[
									63.11582031250009,
									80.966796875
								],
								[
									63.61474609374994,
									80.98090820312495
								],
								[
									63.85595703125,
									80.9811523437501
								],
								[
									64.095703125,
									80.99833984375005
								],
								[
									64.16591796874997,
									81.03574218750012
								],
								[
									64.21044921875,
									81.10634765625002
								],
								[
									64.25585937500011,
									81.14443359375005
								],
								[
									64.31015625000003,
									81.17519531250011
								],
								[
									64.57539062500018,
									81.19848632812506
								],
								[
									64.80205078124999,
									81.19726562499997
								],
								[
									65.02773437500014,
									81.16948242187507
								],
								[
									65.17197265625003,
									81.14404296874997
								],
								[
									65.30976562500007,
									81.09643554687494
								],
								[
									65.38203125000001,
									81.05673828124995
								],
								[
									65.36005859375018,
									81.00820312500008
								],
								[
									65.37207031249994,
									80.96801757812509
								],
								[
									65.43740234375014,
									80.9307128906251
								],
								[
									64.99746093750002,
									80.81889648437499
								],
								[
									64.54833984375011,
									80.75541992187502
								],
								[
									63.37382812499999,
									80.70009765624994
								]
							]
						],
						[
							[
								[
									91.56718750000016,
									81.1412109375
								],
								[
									91.22285156250018,
									81.06381835937506
								],
								[
									89.97578125000001,
									81.11313476562498
								],
								[
									89.91943359375011,
									81.14873046875013
								],
								[
									89.90117187500005,
									81.17070312500007
								],
								[
									90.0699218750002,
									81.21372070312495
								],
								[
									91.10898437500009,
									81.19912109375
								],
								[
									91.47783203125016,
									81.183935546875
								],
								[
									91.56718750000016,
									81.1412109375
								]
							]
						],
						[
							[
								[
									96.52656250000001,
									81.07558593749997
								],
								[
									96.5630859375002,
									81.03007812500002
								],
								[
									96.69326171874997,
									80.99418945312499
								],
								[
									96.7549804687502,
									80.95786132812506
								],
								[
									97.4136718750002,
									80.84184570312505
								],
								[
									97.70302734374997,
									80.82670898437507
								],
								[
									97.83183593750005,
									80.79829101562495
								],
								[
									97.86992187500016,
									80.76328125000012
								],
								[
									97.8564453125,
									80.69809570312498
								],
								[
									97.7471679687502,
									80.69868164062501
								],
								[
									97.66542968750014,
									80.67807617187498
								],
								[
									97.22138671875018,
									80.65244140625
								],
								[
									97.11308593750016,
									80.61406250000007
								],
								[
									97.02539062499994,
									80.535546875
								],
								[
									97.07255859375016,
									80.51987304687509
								],
								[
									97.11503906249999,
									80.49658203125006
								],
								[
									97.25019531250001,
									80.36298828125001
								],
								[
									97.28681640625001,
									80.34252929687511
								],
								[
									97.4169921875,
									80.32314453124997
								],
								[
									97.29843750000009,
									80.2727539062501
								],
								[
									97.17519531250002,
									80.2410156250001
								],
								[
									95.85576171875016,
									80.17695312500004
								],
								[
									94.96132812500002,
									80.15039062499994
								],
								[
									94.66123046875009,
									80.12280273437511
								],
								[
									94.5650390625002,
									80.12607421875006
								],
								[
									94.32841796875005,
									80.07602539062506
								],
								[
									93.87236328125005,
									80.01010742187506
								],
								[
									93.65468750000002,
									80.00961914062503
								],
								[
									93.00234375000014,
									80.10209960937505
								],
								[
									92.20156249999997,
									80.17929687499998
								],
								[
									92.09218750000002,
									80.22333984374998
								],
								[
									91.8916015625,
									80.24926757812503
								],
								[
									91.63740234375018,
									80.26992187499997
								],
								[
									91.52382812500014,
									80.358544921875
								],
								[
									91.68779296875005,
									80.41850585937505
								],
								[
									91.89667968750007,
									80.47753906250009
								],
								[
									92.2466796875002,
									80.49912109375003
								],
								[
									92.57792968749999,
									80.53325195312496
								],
								[
									92.82675781250009,
									80.61855468749994
								],
								[
									92.98105468750009,
									80.70297851562509
								],
								[
									93.26250000000005,
									80.79125976562494
								],
								[
									92.77294921874994,
									80.76865234375006
								],
								[
									92.59257812500016,
									80.78085937500006
								],
								[
									92.61015624999999,
									80.81000976562495
								],
								[
									92.71035156249997,
									80.87216796875
								],
								[
									92.76464843749994,
									80.89306640625
								],
								[
									92.93867187500007,
									80.9258300781251
								],
								[
									93.06513671875007,
									80.98847656249998
								],
								[
									93.35869140624999,
									81.03168945312507
								],
								[
									93.49736328124999,
									81.03920898437502
								],
								[
									93.63671875,
									81.03813476562507
								],
								[
									93.88886718750018,
									81.05839843750002
								],
								[
									94.14013671874994,
									81.08945312499995
								],
								[
									94.37548828125011,
									81.10737304687495
								],
								[
									94.61162109374999,
									81.11464843750002
								],
								[
									94.837890625,
									81.139404296875
								],
								[
									95.06093750000014,
									81.18808593750006
								],
								[
									95.15957031249997,
									81.27099609375009
								],
								[
									95.80068359375014,
									81.28046874999995
								],
								[
									95.90195312500003,
									81.26059570312509
								],
								[
									95.98398437500009,
									81.21142578125011
								],
								[
									96.07519531250011,
									81.19277343750002
								],
								[
									96.18691406250014,
									81.183935546875
								],
								[
									96.47109375000002,
									81.099267578125
								],
								[
									96.52656250000001,
									81.07558593749997
								]
							]
						],
						[
							[
								[
									59.313085937500034,
									81.30522460937513
								],
								[
									59.09697265625016,
									81.29228515625005
								],
								[
									58.71904296874999,
									81.31352539062513
								],
								[
									58.610156250000045,
									81.33725585937498
								],
								[
									58.63447265625018,
									81.36035156250006
								],
								[
									58.88056640625007,
									81.391845703125
								],
								[
									59.075000000000045,
									81.39770507812503
								],
								[
									59.280859375000034,
									81.36611328125
								],
								[
									59.374609375000034,
									81.32504882812498
								],
								[
									59.313085937500034,
									81.30522460937513
								]
							]
						],
						[
							[
								[
									57.81025390625001,
									81.54604492187505
								],
								[
									57.862695312499966,
									81.50644531250009
								],
								[
									58.0166015625,
									81.4837890625
								],
								[
									58.43603515625,
									81.46416015624999
								],
								[
									58.56386718750002,
									81.4184082031251
								],
								[
									58.37187500000016,
									81.38696289062509
								],
								[
									57.85869140625016,
									81.36806640625005
								],
								[
									57.91191406250016,
									81.30327148437499
								],
								[
									58.01533203125018,
									81.25483398437498
								],
								[
									57.91289062500016,
									81.19750976562503
								],
								[
									57.76972656250007,
									81.16972656249996
								],
								[
									57.450976562500045,
									81.13554687500002
								],
								[
									57.15947265625016,
									81.17846679687506
								],
								[
									56.821875000000034,
									81.237939453125
								],
								[
									56.669238281250045,
									81.1982910156251
								],
								[
									56.51250000000016,
									81.17524414062493
								],
								[
									56.36396484375018,
									81.17861328125
								],
								[
									56.191992187500034,
									81.22397460937509
								],
								[
									55.716699218750136,
									81.18847656250006
								],
								[
									55.572656249999966,
									81.22807617187513
								],
								[
									55.46601562500001,
									81.311181640625
								],
								[
									55.78193359375018,
									81.32944335937509
								],
								[
									56.15683593750009,
									81.30307617187495
								],
								[
									56.404687500000136,
									81.38701171874999
								],
								[
									56.71875,
									81.42338867187513
								],
								[
									56.97304687500002,
									81.5105468750001
								],
								[
									57.09150390625018,
									81.54121093750007
								],
								[
									57.365039062500045,
									81.53525390625009
								],
								[
									57.456445312499966,
									81.54287109375005
								],
								[
									57.71660156250016,
									81.56464843750004
								],
								[
									57.81025390625001,
									81.54604492187505
								]
							]
						],
						[
							[
								[
									63.650976562500034,
									81.60932617187498
								],
								[
									63.52851562500018,
									81.59658203124997
								],
								[
									62.88496093750007,
									81.60888671875009
								],
								[
									62.57304687499999,
									81.63305664062494
								],
								[
									62.531250000000114,
									81.64702148437513
								],
								[
									62.515234375000034,
									81.65913085937493
								],
								[
									62.1064453125,
									81.67934570312505
								],
								[
									62.28398437499999,
									81.70654296875009
								],
								[
									62.794921875000114,
									81.71894531250004
								],
								[
									63.70957031250009,
									81.68730468750007
								],
								[
									63.76738281250016,
									81.66416015625006
								],
								[
									63.78242187500018,
									81.64980468750005
								],
								[
									63.650976562500034,
									81.60932617187498
								]
							]
						],
						[
							[
								[
									58.295410156250114,
									81.71518554687498
								],
								[
									57.964843750000114,
									81.69565429687509
								],
								[
									57.92060546875007,
									81.71049804687499
								],
								[
									57.909277343750034,
									81.72192382812511
								],
								[
									57.94511718750016,
									81.74785156249996
								],
								[
									57.984960937500034,
									81.79702148437502
								],
								[
									58.134570312500045,
									81.82797851562495
								],
								[
									59.26181640625009,
									81.85419921874995
								],
								[
									59.408496093750045,
									81.82543945312506
								],
								[
									59.356835937499966,
									81.78095703124995
								],
								[
									59.356445312500114,
									81.75898437499993
								],
								[
									58.295410156250114,
									81.71518554687498
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "RUS",
					"su_a3": "RUS",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "RUS",
					"gu_a3": "RUS",
					"abbrev": "Rus.",
					"region_un": "Europe",
					"adm0_a3_us": "RUS",
					"scalerank": 1,
					"pop_est": 140041247,
					"adm0_dif": 0,
					"un_a3": "643",
					"pop_year": -99,
					"gdp_md_est": 2266000,
					"name": "Russia",
					"sovereignt": "Russia",
					"economy": "3. Emerging region: BRIC",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Russia",
					"postal": "RUS",
					"sov_a3": "RUS",
					"note_brk": "",
					"brk_a3": "RUS",
					"wb_a2": "RU",
					"brk_diff": 0,
					"admin": "Russia",
					"name_long": "Russian Federation",
					"iso_a3": "RUS",
					"iso_a2": "RU",
					"adm0_a3_is": "RUS",
					"level": 2,
					"formal_en": "Russian Federation",
					"name_len": 6,
					"mapcolor7": 2,
					"long_len": 18,
					"mapcolor8": 5,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "643",
					"homepart": 1,
					"subunit": "Russia",
					"name_alt": "",
					"brk_name": "Russia",
					"name_sort": "Russian Federation",
					"continent": "Europe",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									41.987695312500136,
									16.71562500000013
								],
								[
									42.065039062500034,
									16.710058593750063
								],
								[
									42.03320312499994,
									16.74194335937497
								],
								[
									42.026367187500114,
									16.757666015624977
								],
								[
									42.05996093750002,
									16.80351562499999
								],
								[
									42.170410156250114,
									16.708642578124937
								],
								[
									42.16718750000018,
									16.596386718749983
								],
								[
									42.157812500000034,
									16.570703124999994
								],
								[
									42.12773437500016,
									16.59482421875012
								],
								[
									42.108398437500114,
									16.618457031250045
								],
								[
									42.102343750000045,
									16.643945312499994
								],
								[
									42.071777343750114,
									16.671484375000006
								],
								[
									41.964160156250045,
									16.65346679687508
								],
								[
									41.89726562500016,
									16.68427734375004
								],
								[
									41.801562500000045,
									16.778759765624926
								],
								[
									41.77607421875018,
									16.84687500000004
								],
								[
									41.81611328125007,
									16.86015624999999
								],
								[
									41.858203125000045,
									16.89291992187509
								],
								[
									41.88496093750007,
									16.946826171875045
								],
								[
									41.860449218750034,
									17.00253906249995
								],
								[
									41.91728515625016,
									16.99365234375
								],
								[
									41.94794921875018,
									16.93642578125008
								],
								[
									41.95390625000016,
									16.80625000000012
								],
								[
									41.962500000000034,
									16.77866210937509
								],
								[
									41.94667968750002,
									16.74892578125005
								],
								[
									41.987695312500136,
									16.71562500000013
								]
							]
						],
						[
							[
								[
									36.90166015624999,
									25.383056640624943
								],
								[
									36.87519531250001,
									25.383056640624943
								],
								[
									36.805078125000136,
									25.45073242187496
								],
								[
									36.76386718750018,
									25.50058593750009
								],
								[
									36.72207031250002,
									25.534033203125063
								],
								[
									36.530273437500114,
									25.601562500000057
								],
								[
									36.504296874999966,
									25.64511718749995
								],
								[
									36.533593749999966,
									25.68872070312503
								],
								[
									36.554101562499966,
									25.64536132812509
								],
								[
									36.588769531250136,
									25.61982421875004
								],
								[
									36.74755859374994,
									25.558740234374937
								],
								[
									36.924414062500034,
									25.425537109375057
								],
								[
									36.95478515625018,
									25.414648437499977
								],
								[
									36.90166015624999,
									25.383056640624943
								]
							]
						],
						[
							[
								[
									36.59550781250016,
									25.712792968749966
								],
								[
									36.58613281250001,
									25.699218750000057
								],
								[
									36.54394531249994,
									25.734277343749994
								],
								[
									36.546484375000034,
									25.811621093750034
								],
								[
									36.58271484375007,
									25.855517578125102
								],
								[
									36.57988281249999,
									25.795410156250114
								],
								[
									36.59560546875002,
									25.73486328125003
								],
								[
									36.59550781250016,
									25.712792968749966
								]
							]
						],
						[
							[
								[
									46.53144531250007,
									29.096240234375045
								],
								[
									46.72480468750018,
									29.07460937500008
								],
								[
									46.98222656250016,
									29.04565429687503
								],
								[
									47.138769531250034,
									29.026171875000074
								],
								[
									47.43320312500009,
									28.989550781250074
								],
								[
									47.52128906249999,
									28.837841796874983
								],
								[
									47.553222656250114,
									28.73154296875009
								],
								[
									47.58310546875009,
									28.627978515625045
								],
								[
									47.67128906250002,
									28.533154296875068
								],
								[
									47.871972656250136,
									28.535449218750017
								],
								[
									48.04960937500016,
									28.53750000000008
								],
								[
									48.26875000000007,
									28.540527343750085
								],
								[
									48.44248046875009,
									28.54291992187504
								],
								[
									48.49853515624994,
									28.448876953124966
								],
								[
									48.52304687500009,
									28.355029296875017
								],
								[
									48.626367187499966,
									28.132568359375
								],
								[
									48.77373046875016,
									27.959082031250006
								],
								[
									48.808984374999966,
									27.895898437500023
								],
								[
									48.832812500000045,
									27.80068359375008
								],
								[
									48.807226562500034,
									27.765283203124966
								],
								[
									48.79716796875016,
									27.724316406250068
								],
								[
									48.90644531250001,
									27.629052734375108
								],
								[
									49.086914062500114,
									27.548583984375057
								],
								[
									49.15751953124999,
									27.52822265625008
								],
								[
									49.23750000000007,
									27.492724609375045
								],
								[
									49.175097656250045,
									27.437646484375108
								],
								[
									49.28154296875016,
									27.31049804687504
								],
								[
									49.40527343749994,
									27.180957031249932
								],
								[
									49.537695312500034,
									27.151757812499937
								],
								[
									49.71650390625001,
									26.955859375000074
								],
								[
									49.98613281250016,
									26.828906250000074
								],
								[
									50.14980468750002,
									26.662646484375045
								],
								[
									50.134667968750136,
									26.65952148437512
								],
								[
									50.08662109375001,
									26.676416015624994
								],
								[
									50.026367187500114,
									26.69921875000003
								],
								[
									50.00810546874999,
									26.678515625000074
								],
								[
									50.011328125000034,
									26.60878906250008
								],
								[
									50.027343750000114,
									26.526855468750085
								],
								[
									50.110742187500136,
									26.455957031249937
								],
								[
									50.184960937499966,
									26.404931640624937
								],
								[
									50.213867187500114,
									26.308496093750108
								],
								[
									50.15546875000001,
									26.10053710937501
								],
								[
									50.13525390625,
									26.10068359374995
								],
								[
									50.09599609375016,
									26.118701171875074
								],
								[
									50.05390625000001,
									26.122851562499932
								],
								[
									50.03164062500002,
									26.11098632812508
								],
								[
									50.08105468749994,
									25.961376953124983
								],
								[
									50.130273437500136,
									25.846630859375068
								],
								[
									50.18964843750007,
									25.75581054687504
								],
								[
									50.23896484375007,
									25.62285156250013
								],
								[
									50.28125,
									25.566113281249926
								],
								[
									50.455175781250034,
									25.424804687500085
								],
								[
									50.50849609375018,
									25.306689453125017
								],
								[
									50.557910156250045,
									25.086669921875057
								],
								[
									50.666894531250136,
									24.963818359375068
								],
								[
									50.7255859375,
									24.869384765625085
								],
								[
									50.80439453125007,
									24.78925781250004
								],
								[
									50.85566406250001,
									24.679638671874983
								],
								[
									50.92832031250009,
									24.595117187499994
								],
								[
									50.96601562500001,
									24.57392578125004
								],
								[
									51.02275390625016,
									24.565234375000045
								],
								[
									51.093359375000034,
									24.56464843750001
								],
								[
									51.178027343750045,
									24.586718750000074
								],
								[
									51.26796875000008,
									24.607226562500074
								],
								[
									51.33847656250009,
									24.56435546875005
								],
								[
									51.411230468750034,
									24.570800781250114
								],
								[
									51.41835937500002,
									24.530957031249983
								],
								[
									51.36992187500016,
									24.476904296875063
								],
								[
									51.30986328124999,
									24.340380859375074
								],
								[
									51.39521484375018,
									24.31884765625003
								],
								[
									51.47675781250018,
									24.30820312500009
								],
								[
									51.53476562500009,
									24.286328125000068
								],
								[
									51.568359375000114,
									24.28618164062513
								],
								[
									51.568359375000114,
									24.257910156250034
								],
								[
									51.572167968749966,
									24.128320312499937
								],
								[
									51.59257812500016,
									24.078857421875085
								],
								[
									51.629296874999966,
									24.03500976562512
								],
								[
									51.68437499999999,
									23.969531250000102
								],
								[
									51.739355468750034,
									23.904003906250068
								],
								[
									51.794335937500136,
									23.83847656249995
								],
								[
									51.84941406250016,
									23.772998046875017
								],
								[
									51.90439453125009,
									23.70751953125
								],
								[
									51.959472656250114,
									23.64199218750008
								],
								[
									52.014453125000045,
									23.576464843750045
								],
								[
									52.069433593750034,
									23.51098632812503
								],
								[
									52.12451171875,
									23.445458984374994
								],
								[
									52.17949218750016,
									23.379980468749977
								],
								[
									52.23457031250018,
									23.31445312500003
								],
								[
									52.289550781250114,
									23.24897460937501
								],
								[
									52.344531250000045,
									23.183496093750108
								],
								[
									52.39960937500007,
									23.117968750000074
								],
								[
									52.45458984375,
									23.052441406249955
								],
								[
									52.50957031249999,
									22.986962890624937
								],
								[
									52.555078125000136,
									22.93281250000001
								],
								[
									52.639160156250114,
									22.92250976562505
								],
								[
									52.665917968750136,
									22.919287109375006
								],
								[
									52.74160156250002,
									22.910009765624977
								],
								[
									52.85927734375002,
									22.895605468749977
								],
								[
									53.01191406250001,
									22.877001953125102
								],
								[
									53.192382812500114,
									22.85493164062504
								],
								[
									53.39404296875,
									22.830322265625
								],
								[
									53.60957031250018,
									22.80400390624996
								],
								[
									53.832128906250034,
									22.776806640624926
								],
								[
									54.054589843749966,
									22.749658203124994
								],
								[
									54.270117187500034,
									22.72333984375004
								],
								[
									54.47167968749994,
									22.698730468750114
								],
								[
									54.652246093749966,
									22.67666015625005
								],
								[
									54.80488281250018,
									22.658007812500074
								],
								[
									54.922460937500034,
									22.643652343749977
								],
								[
									54.99824218750001,
									22.634375000000034
								],
								[
									55.02500000000009,
									22.631152343750102
								],
								[
									55.10429687500016,
									22.621484374999994
								],
								[
									55.119433593750045,
									22.62392578125005
								],
								[
									55.18583984375016,
									22.70410156250003
								],
								[
									55.259277343750114,
									22.590917968750063
								],
								[
									55.32011718750016,
									22.49692382812512
								],
								[
									55.40380859374994,
									22.367822265625108
								],
								[
									55.492773437500034,
									22.230664062499955
								],
								[
									55.577734375000034,
									22.099511718749966
								],
								[
									55.641015624999966,
									22.001855468749966
								],
								[
									55.60742187499994,
									21.900390625000085
								],
								[
									55.57080078124994,
									21.78969726562508
								],
								[
									55.53417968749994,
									21.679003906250102
								],
								[
									55.49755859374994,
									21.568310546874926
								],
								[
									55.46093749999994,
									21.457617187500034
								],
								[
									55.42431640624994,
									21.346923828124943
								],
								[
									55.38769531249994,
									21.23623046875005
								],
								[
									55.35107421874994,
									21.12553710937496
								],
								[
									55.31445312499994,
									21.014794921874966
								],
								[
									55.27792968750009,
									20.904101562500074
								],
								[
									55.24121093749994,
									20.793408203124983
								],
								[
									55.20458984374994,
									20.68271484375009
								],
								[
									55.16806640625009,
									20.572021484375
								],
								[
									55.13144531250009,
									20.461328125000108
								],
								[
									55.09472656249994,
									20.350634765625017
								],
								[
									55.05820312500009,
									20.23994140625001
								],
								[
									55.02148437499994,
									20.129248046875034
								],
								[
									54.977343750000045,
									19.995947265625063
								],
								[
									54.87109375,
									19.960498046875102
								],
								[
									54.69902343749999,
									19.903125000000074
								],
								[
									54.52705078125007,
									19.84580078125012
								],
								[
									54.35498046875,
									19.78847656250005
								],
								[
									54.183007812500136,
									19.731152343749926
								],
								[
									54.01093750000007,
									19.67382812499997
								],
								[
									53.838867187500114,
									19.616503906250017
								],
								[
									53.666894531250136,
									19.559130859375045
								],
								[
									53.49482421875018,
									19.50180664062509
								],
								[
									53.322851562500034,
									19.444482421874966
								],
								[
									53.150781249999966,
									19.387158203124926
								],
								[
									52.97871093750018,
									19.32978515625004
								],
								[
									52.806738281250034,
									19.272460937500085
								],
								[
									52.634667968749966,
									19.21513671874996
								],
								[
									52.462695312500045,
									19.157812500000006
								],
								[
									52.29062500000009,
									19.100488281249966
								],
								[
									52.11855468750002,
									19.043164062499926
								],
								[
									51.97763671875009,
									18.996142578125102
								],
								[
									51.74296875000016,
									18.964550781249983
								],
								[
									51.51494140625016,
									18.933886718750045
								],
								[
									51.25839843750009,
									18.89936523437504
								],
								[
									50.95000000000016,
									18.85786132812501
								],
								[
									50.70820312500018,
									18.82529296874995
								],
								[
									50.35527343750016,
									18.77778320312504
								],
								[
									50.03896484375002,
									18.73525390625008
								],
								[
									49.74208984375002,
									18.69531250000003
								],
								[
									49.44511718750016,
									18.65532226562496
								],
								[
									49.192382812500114,
									18.621337890625057
								],
								[
									49.041992187500114,
									18.581787109375085
								],
								[
									48.86484375000009,
									18.49521484375012
								],
								[
									48.59296875000001,
									18.362402343750063
								],
								[
									48.315820312500136,
									18.227050781250114
								],
								[
									48.17216796874999,
									18.15693359375004
								],
								[
									48.02167968750018,
									17.97695312500005
								],
								[
									47.94550781250018,
									17.885839843750034
								],
								[
									47.80781250000001,
									17.721093749999966
								],
								[
									47.703710937500034,
									17.596826171874966
								],
								[
									47.57958984375,
									17.44833984375009
								],
								[
									47.52539062499994,
									17.316113281250068
								],
								[
									47.441796874999966,
									17.111865234375017
								],
								[
									47.369628906250114,
									17.06040039062509
								],
								[
									47.25126953125016,
									16.993945312500074
								],
								[
									47.14355468749994,
									16.946679687499937
								],
								[
									46.975683593750034,
									16.95346679687509
								],
								[
									46.87998046875009,
									17.07900390625008
								],
								[
									46.77851562500001,
									17.212109374999926
								],
								[
									46.727636718750034,
									17.265576171874983
								],
								[
									46.68203125000002,
									17.268554687500057
								],
								[
									46.513476562500045,
									17.251660156249983
								],
								[
									46.310351562500045,
									17.23129882812509
								],
								[
									46.07080078125,
									17.253173828124943
								],
								[
									45.794433593750114,
									17.27841796875012
								],
								[
									45.53535156250018,
									17.302050781250045
								],
								[
									45.406542968750045,
									17.31977539062501
								],
								[
									45.23662109375016,
									17.40620117187504
								],
								[
									45.19277343750002,
									17.423388671875074
								],
								[
									45.148046875000034,
									17.42744140625001
								],
								[
									44.94648437500018,
									17.429589843749994
								],
								[
									44.74677734375018,
									17.431689453125074
								],
								[
									44.546484375000034,
									17.404345703125102
								],
								[
									44.35468750000007,
									17.414355468750102
								],
								[
									44.15595703125018,
									17.398535156249977
								],
								[
									44.085937500000114,
									17.365527343750102
								],
								[
									44.008203124999966,
									17.36748046874996
								],
								[
									43.95966796875007,
									17.338330078125068
								],
								[
									43.91699218749994,
									17.324707031249943
								],
								[
									43.86640625000007,
									17.349609375000057
								],
								[
									43.80429687500009,
									17.344140624999994
								],
								[
									43.712988281250034,
									17.365527343750102
								],
								[
									43.65341796875009,
									17.42187500000003
								],
								[
									43.597265625000034,
									17.471435546875
								],
								[
									43.53925781250001,
									17.49873046875004
								],
								[
									43.47421875000009,
									17.515917968750102
								],
								[
									43.417968750000114,
									17.51625976562508
								],
								[
									43.34609375000002,
									17.486035156249955
								],
								[
									43.302148437500136,
									17.456787109374943
								],
								[
									43.190917968750114,
									17.359375000000085
								],
								[
									43.18632812500016,
									17.324707031249943
								],
								[
									43.236914062500034,
									17.266455078124977
								],
								[
									43.22138671875018,
									17.239257812499943
								],
								[
									43.15595703125018,
									17.205029296875068
								],
								[
									43.13593750000018,
									17.112988281249983
								],
								[
									43.12617187500007,
									17.062451171874983
								],
								[
									43.11650390625016,
									16.941992187500063
								],
								[
									43.145605468750034,
									16.84677734375009
								],
								[
									43.184472656250136,
									16.811816406250074
								],
								[
									43.18632812500016,
									16.770996093749943
								],
								[
									43.1650390625,
									16.689404296874926
								],
								[
									43.10478515625016,
									16.66416015625012
								],
								[
									43.06074218750007,
									16.58662109375004
								],
								[
									43.033593750000136,
									16.550390625000034
								],
								[
									42.986328125,
									16.50908203124996
								],
								[
									42.79931640625,
									16.371777343750068
								],
								[
									42.789843750000045,
									16.451562499999966
								],
								[
									42.73066406250007,
									16.569824218750085
								],
								[
									42.72636718750016,
									16.653320312499943
								],
								[
									42.698828125000034,
									16.736962890624937
								],
								[
									42.64746093749994,
									16.80136718750009
								],
								[
									42.55292968750018,
									16.86845703124999
								],
								[
									42.54414062500007,
									16.95966796875001
								],
								[
									42.47500000000002,
									17.049853515625074
								],
								[
									42.38330078125,
									17.12246093750005
								],
								[
									42.33242187500002,
									17.256640625000102
								],
								[
									42.2939453125,
									17.434960937499937
								],
								[
									42.052246093750114,
									17.669335937499994
								],
								[
									41.750000000000114,
									17.88574218750003
								],
								[
									41.65800781249999,
									18.00766601562509
								],
								[
									41.50761718749999,
									18.256103515625085
								],
								[
									41.43173828125009,
									18.452441406250017
								],
								[
									41.229492187500114,
									18.678417968749955
								],
								[
									41.220800781250034,
									18.765234375000063
								],
								[
									41.190820312500136,
									18.871191406250063
								],
								[
									41.144140625000034,
									18.989062500000102
								],
								[
									41.11601562500016,
									19.082177734374966
								],
								[
									40.91328125000018,
									19.490136718750023
								],
								[
									40.84785156250018,
									19.555273437499977
								],
								[
									40.79160156250009,
									19.64638671875008
								],
								[
									40.77705078125001,
									19.716894531250034
								],
								[
									40.759179687500136,
									19.75546875000009
								],
								[
									40.61591796875018,
									19.82236328124995
								],
								[
									40.48222656249999,
									19.99345703124999
								],
								[
									40.08066406250009,
									20.26591796874999
								],
								[
									39.88408203124999,
									20.292968750000085
								],
								[
									39.72832031250016,
									20.390332031249926
								],
								[
									39.613671874999966,
									20.517675781250034
								],
								[
									39.4912109375,
									20.73701171875004
								],
								[
									39.27607421875007,
									20.97397460937509
								],
								[
									39.09355468750016,
									21.31035156249996
								],
								[
									39.15068359375016,
									21.432763671874937
								],
								[
									39.147070312500034,
									21.51899414062501
								],
								[
									39.09101562500018,
									21.663964843749966
								],
								[
									39.02978515624994,
									21.775976562500063
								],
								[
									38.987890625000034,
									21.881738281250108
								],
								[
									39.02119140625018,
									22.033447265625114
								],
								[
									39.03398437499999,
									22.203369140625085
								],
								[
									39.069921875000034,
									22.293652343750097
								],
								[
									39.09589843750001,
									22.39277343750004
								],
								[
									39.06201171874994,
									22.59218750000008
								],
								[
									39.001367187500136,
									22.69897460937497
								],
								[
									39.007421875000034,
									22.770068359375074
								],
								[
									38.93876953125016,
									22.80478515624995
								],
								[
									38.882910156250034,
									22.88203125000004
								],
								[
									38.94111328125018,
									22.881835937500114
								],
								[
									38.83554687500009,
									22.989062500000102
								],
								[
									38.796875000000114,
									23.048583984375057
								],
								[
									38.75703125000018,
									23.194287109374983
								],
								[
									38.706054687500114,
									23.30551757812509
								],
								[
									38.542285156250045,
									23.55791015624999
								],
								[
									38.46416015624999,
									23.711865234375097
								],
								[
									38.28886718749999,
									23.910986328124977
								],
								[
									38.0986328125,
									24.058007812499994
								],
								[
									37.97783203125016,
									24.124560546875045
								],
								[
									37.919726562500045,
									24.18540039062512
								],
								[
									37.82099609375018,
									24.1875
								],
								[
									37.713378906250114,
									24.274414062499943
								],
								[
									37.63818359374994,
									24.277734374999994
								],
								[
									37.543066406250034,
									24.291650390624994
								],
								[
									37.430957031250045,
									24.45903320312499
								],
								[
									37.33847656250009,
									24.61582031249995
								],
								[
									37.18085937500007,
									24.820019531249983
								],
								[
									37.22041015625001,
									24.873339843750017
								],
								[
									37.26630859375007,
									24.960058593750006
								],
								[
									37.24345703124999,
									25.073437499999926
								],
								[
									37.218359375000034,
									25.15068359375013
								],
								[
									37.14882812500002,
									25.29111328124995
								],
								[
									36.92070312500016,
									25.64116210937513
								],
								[
									36.86015624999999,
									25.692480468750006
								],
								[
									36.762695312500114,
									25.751318359375006
								],
								[
									36.702539062500136,
									25.902880859375074
								],
								[
									36.675195312499966,
									26.03886718749996
								],
								[
									36.51875000000018,
									26.10488281250008
								],
								[
									36.249609375000034,
									26.594775390625074
								],
								[
									36.093750000000114,
									26.76582031250001
								],
								[
									36.032031250000045,
									26.881005859374937
								],
								[
									35.851660156250034,
									27.07045898437508
								],
								[
									35.762988281250045,
									27.258789062500085
								],
								[
									35.58134765625016,
									27.43247070312512
								],
								[
									35.423828125000114,
									27.733789062499937
								],
								[
									35.18046874999999,
									28.034863281250097
								],
								[
									35.07832031250018,
									28.087011718750063
								],
								[
									34.827539062500136,
									28.10859375000001
								],
								[
									34.722070312499966,
									28.130664062500074
								],
								[
									34.625000000000114,
									28.06450195312499
								],
								[
									34.6162109375,
									28.148339843750023
								],
								[
									34.68330078125018,
									28.264111328124983
								],
								[
									34.779882812500034,
									28.50732421874997
								],
								[
									34.799121093750045,
									28.720507812500045
								],
								[
									34.950781250000034,
									29.353515625000057
								],
								[
									35.16376953125018,
									29.320947265624994
								],
								[
									35.33916015624999,
									29.294091796875023
								],
								[
									35.595312500000034,
									29.25488281250003
								],
								[
									35.86035156250006,
									29.214257812500023
								],
								[
									36.015429687500045,
									29.190478515625045
								],
								[
									36.06845703125009,
									29.200537109374977
								],
								[
									36.282812500000034,
									29.35537109375008
								],
								[
									36.47607421875,
									29.49511718750003
								],
								[
									36.591796875000114,
									29.666113281250063
								],
								[
									36.70390625000016,
									29.831640625000034
								],
								[
									36.755273437500136,
									29.866015625000017
								],
								[
									36.927050781250045,
									29.897070312500034
								],
								[
									37.199414062500125,
									29.94628906250003
								],
								[
									37.469238281250114,
									29.99506835937501
								],
								[
									37.490722656250114,
									30.01171875000003
								],
								[
									37.553613281250136,
									30.144580078125017
								],
								[
									37.63359374999999,
									30.313281250000102
								],
								[
									37.64990234375006,
									30.330957031249966
								],
								[
									37.6697265625001,
									30.34814453125
								],
								[
									37.86289062500009,
									30.442626953125057
								],
								[
									37.98007812500009,
									30.50000000000003
								],
								[
									37.81298828125006,
									30.669287109375063
								],
								[
									37.65546875000001,
									30.82895507812509
								],
								[
									37.47900390625006,
									31.00776367187501
								],
								[
									37.329492187500136,
									31.146826171875006
								],
								[
									37.10527343749999,
									31.355175781250097
								],
								[
									36.95859375000009,
									31.491503906250045
								],
								[
									37.215625000000045,
									31.556103515624983
								],
								[
									37.49335937500001,
									31.62587890625008
								],
								[
									37.77382812500008,
									31.696337890625045
								],
								[
									38.11142578125009,
									31.78115234375008
								],
								[
									38.37548828125006,
									31.847460937500017
								],
								[
									38.76962890625009,
									31.94648437500001
								],
								[
									38.96230468750008,
									31.994921875000045
								],
								[
									38.99707031250006,
									32.00747070312511
								],
								[
									39.14541015625008,
									32.12451171875006
								],
								[
									39.36865234375,
									32.09174804687504
								],
								[
									39.704101562500114,
									32.04252929687496
								],
								[
									40.02783203125,
									31.995019531249966
								],
								[
									40.369335937500125,
									31.93896484375
								],
								[
									40.478906250000136,
									31.893359375000045
								],
								[
									40.808398437500045,
									31.72543945312512
								],
								[
									41.022460937500114,
									31.61635742187508
								],
								[
									41.27246093750006,
									31.489013671875085
								],
								[
									41.58505859375009,
									31.329736328124966
								],
								[
									41.79970703125002,
									31.22036132812505
								],
								[
									42.07441406250001,
									31.08037109374996
								],
								[
									42.28857421875006,
									30.92041015624997
								],
								[
									42.55976562500007,
									30.717773437500085
								],
								[
									42.8577148437501,
									30.495214843750034
								],
								[
									43.10312500000009,
									30.32221679687504
								],
								[
									43.440820312500136,
									30.083984375000114
								],
								[
									43.77373046874999,
									29.849218750000063
								],
								[
									44.09960937500006,
									29.61933593750004
								],
								[
									44.360742187500136,
									29.43525390625001
								],
								[
									44.690820312500136,
									29.202343749999983
								],
								[
									44.71650390625007,
									29.193603515625085
								],
								[
									45.050292968750114,
									29.16708984375009
								],
								[
									45.49892578125002,
									29.13154296875004
								],
								[
									45.949707031250114,
									29.095849609374966
								],
								[
									46.356445312500114,
									29.063671874999983
								],
								[
									46.53144531250007,
									29.096240234375045
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "SAU",
					"su_a3": "SAU",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "SAU",
					"gu_a3": "SAU",
					"abbrev": "Saud.",
					"region_un": "Asia",
					"adm0_a3_us": "SAU",
					"scalerank": 1,
					"pop_est": 28686633,
					"adm0_dif": 0,
					"un_a3": "682",
					"pop_year": -99,
					"gdp_md_est": 576500,
					"name": "Saudi Arabia",
					"sovereignt": "Saudi Arabia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Saudi Arabia",
					"postal": "SA",
					"sov_a3": "SAU",
					"note_brk": "",
					"brk_a3": "SAU",
					"wb_a2": "SA",
					"brk_diff": 0,
					"admin": "Saudi Arabia",
					"name_long": "Saudi Arabia",
					"iso_a3": "SAU",
					"iso_a2": "SA",
					"adm0_a3_is": "SAU",
					"level": 2,
					"formal_en": "Kingdom of Saudi Arabia",
					"name_len": 12,
					"mapcolor7": 6,
					"long_len": 12,
					"mapcolor8": 1,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "682",
					"homepart": 1,
					"subunit": "Saudi Arabia",
					"name_alt": "",
					"brk_name": "Saudi Arabia",
					"name_sort": "Saudi Arabia",
					"continent": "Asia",
					"mapcolor13": 7,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								103.9697265625,
								1.33144531249998
							],
							[
								103.81992187500003,
								1.2653808593750142
							],
							[
								103.65019531250005,
								1.32553710937502
							],
							[
								103.70527343750007,
								1.4234374999999773
							],
							[
								103.81796875000009,
								1.4470703124999886
							],
							[
								103.90898437499999,
								1.415966796875054
							],
							[
								103.96083984375008,
								1.3922363281250085
							],
							[
								103.99638671875005,
								1.3652343750000142
							],
							[
								103.9697265625,
								1.33144531249998
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "SGP",
					"su_a3": "SGP",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "SGP",
					"gu_a3": "SGP",
					"abbrev": "Sing.",
					"region_un": "Asia",
					"adm0_a3_us": "SGP",
					"scalerank": 3,
					"pop_est": 4657542,
					"adm0_dif": 0,
					"un_a3": "702",
					"pop_year": -99,
					"gdp_md_est": 237300,
					"name": "Singapore",
					"sovereignt": "Singapore",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Singapore",
					"postal": "SG",
					"sov_a3": "SGP",
					"note_brk": "",
					"brk_a3": "SGP",
					"wb_a2": "SG",
					"brk_diff": 0,
					"admin": "Singapore",
					"name_long": "Singapore",
					"iso_a3": "SGP",
					"iso_a2": "SG",
					"adm0_a3_is": "SGP",
					"level": 2,
					"formal_en": "Republic of Singapore",
					"name_len": 9,
					"mapcolor7": 5,
					"long_len": 9,
					"mapcolor8": 3,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "702",
					"homepart": 1,
					"subunit": "Singapore",
					"name_alt": "",
					"brk_name": "Singapore",
					"name_sort": "Singapore",
					"continent": "Asia",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": 3,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								20.241796875000034,
								46.10859375000007
							],
							[
								20.301367187500006,
								46.050683593749994
							],
							[
								20.35859375000004,
								45.97548828125005
							],
							[
								20.43798828125003,
								45.94077148437498
							],
							[
								20.53261718750005,
								45.89951171875009
							],
							[
								20.581152343750063,
								45.86948242187512
							],
							[
								20.65273437500008,
								45.77939453125006
							],
							[
								20.709277343750074,
								45.73525390625002
							],
							[
								20.727832031250017,
								45.737402343750034
							],
							[
								20.746875000000074,
								45.74897460937498
							],
							[
								20.760156250000023,
								45.758105468750074
							],
							[
								20.775000000000034,
								45.749804687500074
							],
							[
								20.775781250000023,
								45.72250976562509
							],
							[
								20.77929687500003,
								45.66201171875002
							],
							[
								20.76582031250004,
								45.59746093750002
							],
							[
								20.78603515625008,
								45.536474609375034
							],
							[
								20.78652343750008,
								45.51748046875008
							],
							[
								20.772460937500057,
								45.50009765625009
							],
							[
								20.774218750000045,
								45.4844238281251
							],
							[
								20.794042968750006,
								45.467871093750006
							],
							[
								20.87080078125001,
								45.42753906249996
							],
							[
								20.941796874999994,
								45.36533203125009
							],
							[
								21.023828125000023,
								45.32153320312503
							],
							[
								21.099902343750074,
								45.29355468750012
							],
							[
								21.14785156250005,
								45.291748046875085
							],
							[
								21.22646484375008,
								45.241308593750034
							],
							[
								21.381738281250023,
								45.20507812500003
							],
							[
								21.431445312500017,
								45.19252929687505
							],
							[
								21.465429687500006,
								45.171875000000114
							],
							[
								21.490234375,
								45.14790039062501
							],
							[
								21.491796875000063,
								45.12226562500004
							],
							[
								21.467871093750063,
								45.109863281250085
							],
							[
								21.434472656250023,
								45.07514648437501
							],
							[
								21.420703125000045,
								45.03295898437506
							],
							[
								21.39589843750005,
								45.022216796875085
							],
							[
								21.371093750000057,
								45.021386718749994
							],
							[
								21.352929687499994,
								45.00898437500004
							],
							[
								21.357031250000034,
								44.990771484375074
							],
							[
								21.37773437499999,
								44.973437500000074
							],
							[
								21.409960937500074,
								44.95771484375007
							],
							[
								21.471972656250017,
								44.94199218750006
							],
							[
								21.533203125000057,
								44.91884765625008
							],
							[
								21.532324218750063,
								44.9006835937501
							],
							[
								21.519921875000023,
								44.88081054687504
							],
							[
								21.442187500000074,
								44.873388671875034
							],
							[
								21.384375000000006,
								44.87006835937498
							],
							[
								21.357910156250057,
								44.861816406250085
							],
							[
								21.36005859375004,
								44.82666015625003
							],
							[
								21.52314453125004,
								44.790087890625045
							],
							[
								21.597070312499994,
								44.75541992187499
							],
							[
								21.63613281250005,
								44.71044921874997
							],
							[
								21.74023437500003,
								44.68066406250003
							],
							[
								21.909277343750006,
								44.666113281250006
							],
							[
								22.026953125000006,
								44.619873046875
							],
							[
								22.093066406250074,
								44.54194335937501
							],
							[
								22.200976562500017,
								44.56069335937502
							],
							[
								22.350683593750063,
								44.67612304687509
							],
							[
								22.497656250000063,
								44.70625000000001
							],
							[
								22.64208984375,
								44.650976562500034
							],
							[
								22.720898437500068,
								44.6055175781251
							],
							[
								22.73437499999997,
								44.569921875000034
							],
							[
								22.700781250000063,
								44.555517578125034
							],
							[
								22.620117187500057,
								44.562353515625006
							],
							[
								22.554003906250017,
								44.54033203124996
							],
							[
								22.50234375000005,
								44.48959960937509
							],
							[
								22.49453125000005,
								44.435449218749994
							],
							[
								22.53066406250005,
								44.37797851562502
							],
							[
								22.581835937500074,
								44.33833007812501
							],
							[
								22.647949218750057,
								44.3164550781251
							],
							[
								22.683300781250068,
								44.28647460937512
							],
							[
								22.687890625000023,
								44.24829101562497
							],
							[
								22.705078125000057,
								44.23779296875006
							],
							[
								22.66748046875003,
								44.22021484375003
							],
							[
								22.626562500000034,
								44.19409179687503
							],
							[
								22.603417968750023,
								44.148583984374994
							],
							[
								22.597460937500074,
								44.07529296875006
							],
							[
								22.469042968750017,
								44.01801757812504
							],
							[
								22.42080078125005,
								44.00742187500009
							],
							[
								22.399023437500063,
								43.96953125000002
							],
							[
								22.36542968750004,
								43.86210937499999
							],
							[
								22.36962890625,
								43.781298828125045
							],
							[
								22.386914062500068,
								43.74013671875011
							],
							[
								22.394824218750074,
								43.70664062500012
							],
							[
								22.436328125000017,
								43.66547851562498
							],
							[
								22.47412109374997,
								43.60224609374998
							],
							[
								22.499121093750006,
								43.518847656250045
							],
							[
								22.554589843750023,
								43.45449218750008
							],
							[
								22.69697265625001,
								43.39106445312504
							],
							[
								22.767578125,
								43.35415039062505
							],
							[
								22.81972656250005,
								43.30073242187501
							],
							[
								22.859570312499983,
								43.25234375000002
							],
							[
								22.97685546874999,
								43.18798828125006
							],
							[
								22.96796875000004,
								43.14204101562501
							],
							[
								22.94228515625005,
								43.09707031250008
							],
							[
								22.915234375000068,
								43.075976562500045
							],
							[
								22.85683593750005,
								43.01826171875001
							],
							[
								22.799902343750006,
								42.985742187499966
							],
							[
								22.706152343750006,
								42.88393554687511
							],
							[
								22.55810546875003,
								42.87846679687496
							],
							[
								22.522753906250045,
								42.87031250000007
							],
							[
								22.466796875,
								42.84248046875001
							],
							[
								22.439257812500074,
								42.79165039062505
							],
							[
								22.465625000000017,
								42.750781250000074
							],
							[
								22.46328125000008,
								42.70947265625
							],
							[
								22.436230468749983,
								42.62910156250007
							],
							[
								22.472070312500023,
								42.54331054687506
							],
							[
								22.524218750000074,
								42.50390625000003
							],
							[
								22.53242187500004,
								42.48120117187503
							],
							[
								22.523535156250006,
								42.4409667968751
							],
							[
								22.44570312500005,
								42.35913085937503
							],
							[
								22.42207031250004,
								42.328857421875085
							],
							[
								22.344042968750045,
								42.31396484374997
							],
							[
								22.31738281250003,
								42.32172851562504
							],
							[
								22.277050781250068,
								42.349853515625085
							],
							[
								22.23974609375003,
								42.358154296875114
							],
							[
								22.146679687500068,
								42.3250000000001
							],
							[
								22.052050781250074,
								42.30463867187504
							],
							[
								21.97753906249997,
								42.32006835937506
							],
							[
								21.904101562500017,
								42.322070312500045
							],
							[
								21.85302734375003,
								42.3083984375001
							],
							[
								21.81464843750001,
								42.303124999999994
							],
							[
								21.73925781250003,
								42.26772460937505
							],
							[
								21.618261718750063,
								42.2421386718751
							],
							[
								21.56249999999997,
								42.24750976562504
							],
							[
								21.541601562499977,
								42.280810546875074
							],
							[
								21.51894531250008,
								42.32841796874999
							],
							[
								21.52998046875001,
								42.35000000000005
							],
							[
								21.60986328125003,
								42.38745117187503
							],
							[
								21.61904296875005,
								42.42324218750005
							],
							[
								21.73066406250004,
								42.59545898437503
							],
							[
								21.752148437500068,
								42.65151367187508
							],
							[
								21.752929687500057,
								42.66982421875008
							],
							[
								21.723828125000068,
								42.68198242187509
							],
							[
								21.662500000000023,
								42.68149414062498
							],
							[
								21.390625000000057,
								42.75141601562501
							],
							[
								21.40302734375001,
								42.83154296875
							],
							[
								21.32314453125008,
								42.8747070312501
							],
							[
								21.237109375000045,
								42.91323242187502
							],
							[
								21.22265625000003,
								42.956201171874994
							],
							[
								21.127050781250006,
								43.0430175781251
							],
							[
								21.057031250000023,
								43.09169921875005
							],
							[
								20.967675781250023,
								43.116015625000045
							],
							[
								20.890722656249977,
								43.15166015625002
							],
							[
								20.844433593750068,
								43.17343750000012
							],
							[
								20.823828125000034,
								43.21396484375009
							],
							[
								20.823828125000034,
								43.23793945312511
							],
							[
								20.800585937500017,
								43.26108398437512
							],
							[
								20.763378906250068,
								43.25859374999996
							],
							[
								20.70058593750008,
								43.22636718749996
							],
							[
								20.623144531250006,
								43.198632812499994
							],
							[
								20.609667968750017,
								43.17841796875007
							],
							[
								20.637597656250023,
								43.13037109375003
							],
							[
								20.657617187500023,
								43.09985351562503
							],
							[
								20.648535156250034,
								43.07094726562511
							],
							[
								20.6240234375,
								43.03417968750006
							],
							[
								20.475097656250057,
								42.953027343749966
							],
							[
								20.458398437500023,
								42.92456054687503
							],
							[
								20.48681640625003,
								42.879052734374994
							],
							[
								20.468847656250006,
								42.85791015625003
							],
							[
								20.344335937500063,
								42.82792968749996
							],
							[
								20.34765625000003,
								42.85278320312497
							],
							[
								20.339941406250034,
								42.892871093750045
							],
							[
								20.26845703125005,
								42.93544921875002
							],
							[
								20.16787109375008,
								42.968505859375114
							],
							[
								19.94404296875004,
								43.08164062500006
							],
							[
								19.858007812500006,
								43.09653320312498
							],
							[
								19.78115234375008,
								43.10976562500011
							],
							[
								19.670996093750006,
								43.16396484375005
							],
							[
								19.61445312500004,
								43.17343750000012
							],
							[
								19.551562500000017,
								43.21225585937512
							],
							[
								19.414648437500006,
								43.342822265625074
							],
							[
								19.298242187500023,
								43.413964843749994
							],
							[
								19.21874999999997,
								43.44995117187503
							],
							[
								19.196484375000068,
								43.48500976562508
							],
							[
								19.19160156250004,
								43.52104492187496
							],
							[
								19.19433593749997,
								43.53330078125006
							],
							[
								19.254492187500063,
								43.58437500000008
							],
							[
								19.30078125,
								43.591796875000085
							],
							[
								19.360351562500057,
								43.59345703125007
							],
							[
								19.399609375000068,
								43.56757812500001
							],
							[
								19.451269531250006,
								43.56206054687496
							],
							[
								19.47998046875,
								43.595166015624955
							],
							[
								19.495117187500057,
								43.642871093750074
							],
							[
								19.48818359375008,
								43.703564453124926
							],
							[
								19.364062500000017,
								43.8447753906251
							],
							[
								19.257226562499994,
								43.94331054687501
							],
							[
								19.245019531249994,
								43.9650390625001
							],
							[
								19.26806640625,
								43.98344726562502
							],
							[
								19.305273437500034,
								43.99335937500007
							],
							[
								19.34521484375,
								43.985107421875
							],
							[
								19.449414062499983,
								43.97802734374997
							],
							[
								19.54951171875004,
								43.98710937499996
							],
							[
								19.583691406249983,
								44.01108398437506
							],
							[
								19.583789062500017,
								44.043457031250085
							],
							[
								19.547167968750017,
								44.07348632812497
							],
							[
								19.43017578124997,
								44.154492187499955
							],
							[
								19.33886718750003,
								44.225830078125114
							],
							[
								19.231542968750006,
								44.280566406250074
							],
							[
								19.15185546875003,
								44.3025390625001
							],
							[
								19.128320312500023,
								44.33027343750007
							],
							[
								19.118457031250074,
								44.35996093749998
							],
							[
								19.127343750000023,
								44.41455078125
							],
							[
								19.132421875000063,
								44.48378906250008
							],
							[
								19.15136718750003,
								44.52734374999997
							],
							[
								19.22314453125,
								44.60957031250004
							],
							[
								19.29189453125005,
								44.69677734374994
							],
							[
								19.33447265625003,
								44.78066406250008
							],
							[
								19.35683593750005,
								44.85854492187505
							],
							[
								19.348632812500057,
								44.880908203125074
							],
							[
								19.31269531250001,
								44.89746093749997
							],
							[
								19.23681640625003,
								44.914257812499926
							],
							[
								19.131542968750068,
								44.89960937500007
							],
							[
								19.042089843750063,
								44.87133789062506
							],
							[
								19.007128906250045,
								44.86918945312499
							],
							[
								18.99550781250005,
								44.90400390625007
							],
							[
								19.00957031249999,
								44.9193847656251
							],
							[
								19.03759765625003,
								44.917529296875074
							],
							[
								19.060546875,
								44.91098632812498
							],
							[
								19.085253906250045,
								44.926757812500085
							],
							[
								19.100000000000023,
								44.97377929687508
							],
							[
								19.062890625000023,
								45.13720703125006
							],
							[
								19.129687500000045,
								45.15170898437509
							],
							[
								19.13076171875008,
								45.17548828125004
							],
							[
								19.13691406250001,
								45.1962402343751
							],
							[
								19.20595703125005,
								45.167773437500074
							],
							[
								19.303027343750017,
								45.16728515624996
							],
							[
								19.388085937500023,
								45.17299804687505
							],
							[
								19.400976562500063,
								45.18906250000006
							],
							[
								19.400000000000034,
								45.212500000000034
							],
							[
								19.38232421875,
								45.23061523437508
							],
							[
								19.35224609375001,
								45.245410156250074
							],
							[
								19.33027343750004,
								45.26806640625006
							],
							[
								19.27285156250008,
								45.27797851562505
							],
							[
								19.093066406250045,
								45.33691406249997
							],
							[
								19.004687500000074,
								45.39951171875012
							],
							[
								19.007617187500045,
								45.46582031249994
							],
							[
								19.033300781250034,
								45.502197265625085
							],
							[
								19.064257812500045,
								45.51499023437509
							],
							[
								19.055078125000023,
								45.52724609374994
							],
							[
								18.953710937499977,
								45.55800781250008
							],
							[
								18.91787109375005,
								45.600830078125
							],
							[
								18.947265625,
								45.65581054687502
							],
							[
								18.89453125,
								45.76708984374994
							],
							[
								18.839062499999983,
								45.83574218749999
							],
							[
								18.8935546875,
								45.86552734374993
							],
							[
								18.90107421875001,
								45.90761718750008
							],
							[
								18.905371093750006,
								45.931738281250006
							],
							[
								18.927832031250034,
								45.93139648437503
							],
							[
								19.015722656250006,
								45.95971679687503
							],
							[
								19.047656250000017,
								45.982666015625085
							],
							[
								19.066210937500074,
								46.00952148437506
							],
							[
								19.087304687500023,
								46.016162109375074
							],
							[
								19.146289062500045,
								45.98701171874998
							],
							[
								19.208398437499994,
								45.98442382812499
							],
							[
								19.27812499999999,
								46.00288085937501
							],
							[
								19.33027343750004,
								46.02851562500001
							],
							[
								19.392871093750017,
								46.049804687500085
							],
							[
								19.421289062500023,
								46.06445312500006
							],
							[
								19.45751953125003,
								46.0873535156251
							],
							[
								19.53076171875003,
								46.155175781249966
							],
							[
								19.61347656250001,
								46.16918945312497
							],
							[
								19.72451171875008,
								46.1519042968751
							],
							[
								19.844433593749983,
								46.14589843750002
							],
							[
								19.934082031250057,
								46.161474609375006
							],
							[
								20.161425781250017,
								46.14189453125002
							],
							[
								20.210156250000068,
								46.126025390625074
							],
							[
								20.241796875000034,
								46.10859375000007
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 5,
					"adm0_a3_un": -99,
					"adm0_a3": "SRB",
					"su_a3": "SRB",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "SRB",
					"gu_a3": "SRB",
					"abbrev": "Serb.",
					"region_un": "Europe",
					"adm0_a3_us": "SRB",
					"scalerank": 1,
					"pop_est": 7379339,
					"adm0_dif": 0,
					"un_a3": "688",
					"pop_year": -99,
					"gdp_md_est": 80340,
					"name": "Serbia",
					"sovereignt": "Republic of Serbia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Republic of Serbia",
					"postal": "RS",
					"sov_a3": "SRB",
					"note_brk": "",
					"brk_a3": "SRB",
					"wb_a2": "YF",
					"brk_diff": 0,
					"admin": "Republic of Serbia",
					"name_long": "Serbia",
					"iso_a3": "SRB",
					"iso_a2": "RS",
					"adm0_a3_is": "SRB",
					"level": 2,
					"formal_en": "Republic of Serbia",
					"name_len": 6,
					"mapcolor7": 3,
					"long_len": 6,
					"mapcolor8": 3,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "688",
					"homepart": 1,
					"subunit": "Republic of Serbia",
					"name_alt": "",
					"brk_name": "Serbia",
					"name_sort": "Serbia",
					"continent": "Europe",
					"mapcolor13": 10,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								22.538671874999977,
								49.07270507812507
							],
							[
								22.52412109375004,
								49.031396484374994
							],
							[
								22.483203125000045,
								48.983251953125034
							],
							[
								22.432031250000023,
								48.93354492187504
							],
							[
								22.389453125000045,
								48.87348632812507
							],
							[
								22.332617187500034,
								48.74506835937501
							],
							[
								22.295214843750045,
								48.68583984375002
							],
							[
								22.14287109374999,
								48.56850585937502
							],
							[
								22.131835937500057,
								48.40532226562499
							],
							[
								22.111328125000057,
								48.393359375000045
							],
							[
								21.76699218750008,
								48.33808593750007
							],
							[
								21.721484375000045,
								48.34658203125002
							],
							[
								21.674609375000074,
								48.37836914062501
							],
							[
								21.64863281250004,
								48.401464843750006
							],
							[
								21.63251953125004,
								48.41850585937502
							],
							[
								21.602636718749977,
								48.46367187499999
							],
							[
								21.56318359375004,
								48.495703125000006
							],
							[
								21.504687500000017,
								48.52187500000002
							],
							[
								21.451367187500068,
								48.55224609375
							],
							[
								21.382421875000063,
								48.55346679687497
							],
							[
								21.196386718750006,
								48.510595703125034
							],
							[
								21.06728515625008,
								48.50590820312496
							],
							[
								20.98115234375004,
								48.51967773437502
							],
							[
								20.86660156250005,
								48.54565429687497
							],
							[
								20.643164062500006,
								48.549707031249994
							],
							[
								20.490039062500074,
								48.52690429687499
							],
							[
								20.475000000000023,
								48.4951171875
							],
							[
								20.333789062500045,
								48.29555664062502
							],
							[
								20.128613281250068,
								48.222021484375034
							],
							[
								19.95039062500001,
								48.14663085937505
							],
							[
								19.89863281250001,
								48.13134765625003
							],
							[
								19.81005859375,
								48.15502929687497
							],
							[
								19.709179687500068,
								48.199804687500034
							],
							[
								19.62539062500005,
								48.22309570312498
							],
							[
								19.564257812500017,
								48.21284179687504
							],
							[
								19.497460937499994,
								48.162109375
							],
							[
								19.46699218750001,
								48.110693359375006
							],
							[
								19.26513671875003,
								48.07304687499999
							],
							[
								18.914160156250006,
								48.05083007812499
							],
							[
								18.79189453125005,
								48.00029296874999
							],
							[
								18.750097656250063,
								47.93945312500003
							],
							[
								18.748339843750074,
								47.892675781250006
							],
							[
								18.778027343750068,
								47.85288085937498
							],
							[
								18.740624999999994,
								47.806494140625034
							],
							[
								18.724218750000034,
								47.78715820312499
							],
							[
								18.476269531250068,
								47.777001953124966
							],
							[
								18.145605468750034,
								47.76342773437506
							],
							[
								17.947949218750068,
								47.766894531250045
							],
							[
								17.76191406250001,
								47.770166015624994
							],
							[
								17.635253906250057,
								47.809912109375006
							],
							[
								17.48066406250001,
								47.88759765625002
							],
							[
								17.317285156250023,
								47.99091796875004
							],
							[
								17.301562500000017,
								47.99335937499998
							],
							[
								17.27724609375005,
								48.00434570312501
							],
							[
								17.17460937499999,
								48.01206054687498
							],
							[
								17.14736328125005,
								48.00595703124998
							],
							[
								17.085937500000057,
								48.03955078125
							],
							[
								17.06787109375003,
								48.083251953125
							],
							[
								16.97265624999997,
								48.19809570312506
							],
							[
								16.865429687500068,
								48.38691406250007
							],
							[
								16.86269531250005,
								48.44140624999997
							],
							[
								16.90449218750004,
								48.503515625000006
							],
							[
								16.943359375000057,
								48.550927734374994
							],
							[
								16.948828125000006,
								48.58857421875001
							],
							[
								16.953125,
								48.59882812500007
							],
							[
								16.98525390625005,
								48.676904296874994
							],
							[
								17.063281250000045,
								48.78076171875
							],
							[
								17.13564453125005,
								48.84106445312503
							],
							[
								17.18847656249997,
								48.860937500000006
							],
							[
								17.29687500000003,
								48.842822265625045
							],
							[
								17.48261718750004,
								48.827783203124994
							],
							[
								17.62539062500008,
								48.84184570312502
							],
							[
								17.75849609375004,
								48.88813476562504
							],
							[
								17.830859375000017,
								48.92861328125002
							],
							[
								17.892675781250006,
								48.97114257812507
							],
							[
								17.91328125000004,
								48.99873046875001
							],
							[
								17.940722656250017,
								49.01196289062503
							],
							[
								18.050878906250006,
								49.036523437499966
							],
							[
								18.08593750000003,
								49.06513671875004
							],
							[
								18.100390625000045,
								49.11933593750007
							],
							[
								18.109960937500034,
								49.179785156250034
							],
							[
								18.132617187500045,
								49.22456054687501
							],
							[
								18.160937500000045,
								49.25737304687502
							],
							[
								18.364843750000006,
								49.33623046875002
							],
							[
								18.38310546874999,
								49.363916015624966
							],
							[
								18.415820312500017,
								49.39091796874996
							],
							[
								18.47607421875003,
								49.42109374999998
							],
							[
								18.53457031250005,
								49.46469726562498
							],
							[
								18.596484375000045,
								49.49145507812503
							],
							[
								18.676171875000023,
								49.48847656250004
							],
							[
								18.749707031249983,
								49.493994140625006
							],
							[
								18.807031250000023,
								49.50922851562501
							],
							[
								18.83222656250001,
								49.51079101562496
							],
							[
								18.93818359375001,
								49.498291015625
							],
							[
								18.957226562499983,
								49.44829101562502
							],
							[
								18.968359375000034,
								49.39624023437497
							],
							[
								19.149414062500057,
								49.400000000000034
							],
							[
								19.250195312499983,
								49.51142578125001
							],
							[
								19.302343750000034,
								49.52485351562498
							],
							[
								19.38623046875,
								49.563623046874966
							],
							[
								19.441601562499983,
								49.59770507812499
							],
							[
								19.47968750000004,
								49.57636718750001
							],
							[
								19.534765625000063,
								49.504785156249994
							],
							[
								19.593066406250045,
								49.447119140625034
							],
							[
								19.62666015625004,
								49.42436523437502
							],
							[
								19.63027343750005,
								49.406640624999966
							],
							[
								19.664160156250034,
								49.396044921875045
							],
							[
								19.730078125000063,
								49.38959960937504
							],
							[
								19.77392578125003,
								49.37216796875006
							],
							[
								19.787011718750023,
								49.31855468750007
							],
							[
								19.78798828125005,
								49.26997070312501
							],
							[
								19.767382812500017,
								49.235205078125034
							],
							[
								19.756640625000045,
								49.20439453124999
							],
							[
								19.80224609375003,
								49.19233398437501
							],
							[
								19.868945312500017,
								49.204003906249994
							],
							[
								19.916113281250034,
								49.22138671875007
							],
							[
								20.0576171875,
								49.181298828124994
							],
							[
								20.107617187500068,
								49.270751953125
							],
							[
								20.163671875000006,
								49.31640624999997
							],
							[
								20.23652343750004,
								49.33764648437503
							],
							[
								20.302539062500074,
								49.365527343750045
							],
							[
								20.36298828125004,
								49.38525390625006
							],
							[
								20.404687499999994,
								49.38408203124999
							],
							[
								20.422656250000017,
								49.392333984375
							],
							[
								20.474511718750023,
								49.39018554687499
							],
							[
								20.53457031250008,
								49.381201171875034
							],
							[
								20.61611328125008,
								49.391699218750034
							],
							[
								20.72900390625,
								49.369921875000045
							],
							[
								20.799511718750068,
								49.32866210937499
							],
							[
								20.868457031250074,
								49.31469726562497
							],
							[
								20.947265625000057,
								49.31708984375001
							],
							[
								21.00117187500001,
								49.33984375000003
							],
							[
								21.079394531250045,
								49.41826171875002
							],
							[
								21.13613281250008,
								49.41704101562496
							],
							[
								21.22500000000005,
								49.429443359375
							],
							[
								21.35048828125005,
								49.428759765625045
							],
							[
								21.639648437500057,
								49.41196289062498
							],
							[
								21.712109374999983,
								49.381933593750006
							],
							[
								21.89013671875003,
								49.34345703125007
							],
							[
								21.967675781250023,
								49.299072265625
							],
							[
								22.00214843750001,
								49.24609375000003
							],
							[
								22.020117187500034,
								49.20952148437496
							],
							[
								22.20253906250008,
								49.15322265625002
							],
							[
								22.473046875000023,
								49.08129882812503
							],
							[
								22.538671874999977,
								49.07270507812507
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "SVK",
					"su_a3": "SVK",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "SVK",
					"gu_a3": "SVK",
					"abbrev": "Svk.",
					"region_un": "Europe",
					"adm0_a3_us": "SVK",
					"scalerank": 1,
					"pop_est": 5463046,
					"adm0_dif": 0,
					"un_a3": "703",
					"pop_year": -99,
					"gdp_md_est": 119500,
					"name": "Slovakia",
					"sovereignt": "Slovakia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Slovakia",
					"postal": "SK",
					"sov_a3": "SVK",
					"note_brk": "",
					"brk_a3": "SVK",
					"wb_a2": "SK",
					"brk_diff": 0,
					"admin": "Slovakia",
					"name_long": "Slovakia",
					"iso_a3": "SVK",
					"iso_a2": "SK",
					"adm0_a3_is": "SVK",
					"level": 2,
					"formal_en": "Slovak Republic",
					"name_len": 8,
					"mapcolor7": 2,
					"long_len": 8,
					"mapcolor8": 4,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "703",
					"homepart": 1,
					"subunit": "Slovakia",
					"name_alt": "",
					"brk_name": "Slovakia",
					"name_sort": "Slovak Republic",
					"continent": "Europe",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								16.516210937500063,
								46.49990234375002
							],
							[
								16.42763671875005,
								46.52441406250006
							],
							[
								16.32119140625005,
								46.5346191406251
							],
							[
								16.30117187500005,
								46.521386718749966
							],
							[
								16.258398437500034,
								46.50791015625006
							],
							[
								16.23671875000005,
								46.48383789062504
							],
							[
								16.25332031250008,
								46.38911132812501
							],
							[
								16.22744140625005,
								46.37285156249999
							],
							[
								16.1064453125,
								46.38222656250002
							],
							[
								16.066503906250034,
								46.37133789062503
							],
							[
								16.00068359375004,
								46.30537109375001
							],
							[
								15.933300781250068,
								46.277636718750045
							],
							[
								15.847558593749994,
								46.25786132812502
							],
							[
								15.784277343750006,
								46.233984375000034
							],
							[
								15.704199218750034,
								46.21323242187498
							],
							[
								15.635937500000068,
								46.2007324218751
							],
							[
								15.608984374999977,
								46.1719238281251
							],
							[
								15.592578125000017,
								46.13999023437498
							],
							[
								15.596875000000011,
								46.10922851562512
							],
							[
								15.666210937500011,
								46.04848632812508
							],
							[
								15.675585937500045,
								45.98369140625002
							],
							[
								15.668066406250034,
								45.90444335937505
							],
							[
								15.652148437500074,
								45.862158203125034
							],
							[
								15.624804687500017,
								45.834033203125074
							],
							[
								15.454101562500057,
								45.79760742187503
							],
							[
								15.27705078125004,
								45.73261718750004
							],
							[
								15.27294921875,
								45.71772460937501
							],
							[
								15.35371093750004,
								45.65991210937506
							],
							[
								15.356933593750057,
								45.64550781250006
							],
							[
								15.290136718750034,
								45.61264648437509
							],
							[
								15.283593750000051,
								45.57968750000006
							],
							[
								15.291210937499983,
								45.5415527343751
							],
							[
								15.326660156250028,
								45.502294921875006
							],
							[
								15.339453125000063,
								45.467041015625114
							],
							[
								15.242089843750023,
								45.44140625000003
							],
							[
								15.110449218750034,
								45.45078125000009
							],
							[
								14.954589843749972,
								45.49990234375005
							],
							[
								14.900000000000063,
								45.49267578125
							],
							[
								14.847070312500023,
								45.46733398437499
							],
							[
								14.793066406250034,
								45.47822265624998
							],
							[
								14.733593749999983,
								45.50849609375001
							],
							[
								14.649511718750006,
								45.57148437500007
							],
							[
								14.608593750000011,
								45.61010742187503
							],
							[
								14.591796875000057,
								45.65126953125008
							],
							[
								14.56884765625,
								45.65722656250003
							],
							[
								14.533984375000017,
								45.645263671875
							],
							[
								14.505175781249989,
								45.595214843750114
							],
							[
								14.427343750000034,
								45.505761718749994
							],
							[
								14.369921875000074,
								45.481445312500114
							],
							[
								14.283007812500045,
								45.4866210937501
							],
							[
								14.161230468750006,
								45.485156250000074
							],
							[
								14.085546875000034,
								45.47783203124999
							],
							[
								13.992773437500063,
								45.50942382812502
							],
							[
								13.970312500000006,
								45.50336914062504
							],
							[
								13.970117187500051,
								45.48261718750007
							],
							[
								13.935644531250063,
								45.44980468750006
							],
							[
								13.878710937499989,
								45.42836914062505
							],
							[
								13.615234375000057,
								45.47675781250004
							],
							[
								13.577929687500017,
								45.51689453124996
							],
							[
								13.637304687500034,
								45.53593750000002
							],
							[
								13.719824218750063,
								45.58759765625007
							],
							[
								13.775976562500034,
								45.58198242187498
							],
							[
								13.8447265625,
								45.59287109374998
							],
							[
								13.874707031250068,
								45.61484375000012
							],
							[
								13.831152343750006,
								45.68041992187506
							],
							[
								13.721679687499972,
								45.7612792968751
							],
							[
								13.663476562500023,
								45.79199218750006
							],
							[
								13.583398437500051,
								45.81235351562512
							],
							[
								13.569628906250017,
								45.83413085937502
							],
							[
								13.613964843750068,
								45.96166992187497
							],
							[
								13.6005859375,
								45.97978515625002
							],
							[
								13.509179687500023,
								45.97377929687505
							],
							[
								13.487695312500023,
								45.9871093750001
							],
							[
								13.480273437500017,
								46.00922851562498
							],
							[
								13.486425781250006,
								46.03955078125003
							],
							[
								13.54804687500004,
								46.089111328125
							],
							[
								13.61660156250008,
								46.133105468750074
							],
							[
								13.634960937499983,
								46.15776367187496
							],
							[
								13.63251953125004,
								46.177050781250074
							],
							[
								13.544726562500074,
								46.19658203124996
							],
							[
								13.491796875000034,
								46.216601562500045
							],
							[
								13.449804687500006,
								46.22353515625002
							],
							[
								13.420996093750006,
								46.212304687499966
							],
							[
								13.399609375000011,
								46.22495117187506
							],
							[
								13.378222656249989,
								46.26162109375008
							],
							[
								13.399511718749977,
								46.317529296874994
							],
							[
								13.478515625,
								46.369189453125045
							],
							[
								13.563281250000045,
								46.415087890625074
							],
							[
								13.63710937500008,
								46.448535156250045
							],
							[
								13.679687500000057,
								46.46289062500003
							],
							[
								13.700000000000017,
								46.520263671875
							],
							[
								13.743945312500074,
								46.51430664062502
							],
							[
								13.831347656250045,
								46.51123046875003
							],
							[
								13.928808593750006,
								46.49819335937502
							],
							[
								14.019628906250034,
								46.48217773437497
							],
							[
								14.099511718750051,
								46.46191406250003
							],
							[
								14.26728515625004,
								46.44072265624996
							],
							[
								14.419921875000028,
								46.42792968750001
							],
							[
								14.465917968750006,
								46.416113281250006
							],
							[
								14.503515625000006,
								46.41704101562502
							],
							[
								14.549804687500028,
								46.399707031250045
							],
							[
								14.5771484375,
								46.41293945312498
							],
							[
								14.596972656250045,
								46.43608398437499
							],
							[
								14.680175781250028,
								46.46342773437496
							],
							[
								14.75673828125008,
								46.499121093750034
							],
							[
								14.810546875000028,
								46.544580078124994
							],
							[
								14.840625000000045,
								46.58046875000002
							],
							[
								14.893261718750011,
								46.60590820312504
							],
							[
								14.949414062499983,
								46.61323242187501
							],
							[
								15.00068359375004,
								46.62597656250006
							],
							[
								15.216992187500068,
								46.64296875000005
							],
							[
								15.439257812500045,
								46.629638671875
							],
							[
								15.54531250000008,
								46.654638671875034
							],
							[
								15.632617187500017,
								46.69843750000007
							],
							[
								15.760253906249972,
								46.71074218749999
							],
							[
								15.766894531250017,
								46.711279296875006
							],
							[
								15.957617187500034,
								46.677636718749994
							],
							[
								15.972265625000006,
								46.69721679687498
							],
							[
								15.98046875,
								46.70585937499999
							],
							[
								15.976855468750045,
								46.80136718749998
							],
							[
								16.037207031250006,
								46.844824218750034
							],
							[
								16.093066406250017,
								46.86328124999997
							],
							[
								16.283593750000023,
								46.857275390625006
							],
							[
								16.308496093750023,
								46.82797851562498
							],
							[
								16.318457031250006,
								46.78251953124996
							],
							[
								16.33544921875003,
								46.72163085937498
							],
							[
								16.3671875,
								46.70478515625001
							],
							[
								16.384570312500074,
								46.68081054687502
							],
							[
								16.381250000000023,
								46.63867187500006
							],
							[
								16.418457031250057,
								46.607226562500045
							],
							[
								16.505664062500045,
								46.522070312500006
							],
							[
								16.516210937500063,
								46.49990234375002
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Europe",
					"labelrank": 6,
					"adm0_a3_un": -99,
					"adm0_a3": "SVN",
					"su_a3": "SVN",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "SVN",
					"gu_a3": "SVN",
					"abbrev": "Slo.",
					"region_un": "Europe",
					"adm0_a3_us": "SVN",
					"scalerank": 1,
					"pop_est": 2005692,
					"adm0_dif": 0,
					"un_a3": "705",
					"pop_year": -99,
					"gdp_md_est": 59340,
					"name": "Slovenia",
					"sovereignt": "Slovenia",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Slovenia",
					"postal": "SLO",
					"sov_a3": "SVN",
					"note_brk": "",
					"brk_a3": "SVN",
					"wb_a2": "SI",
					"brk_diff": 0,
					"admin": "Slovenia",
					"name_long": "Slovenia",
					"iso_a3": "SVN",
					"iso_a2": "SI",
					"adm0_a3_is": "SVN",
					"level": 2,
					"formal_en": "Republic of Slovenia",
					"name_len": 8,
					"mapcolor7": 2,
					"long_len": 8,
					"mapcolor8": 3,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "705",
					"homepart": 1,
					"subunit": "Slovenia",
					"name_alt": "",
					"brk_name": "Slovenia",
					"name_sort": "Slovenia",
					"continent": "Europe",
					"mapcolor13": 12,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2011
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									16.52851562500001,
									56.29052734374997
								],
								[
									16.477148437500006,
									56.240185546874926
								],
								[
									16.43164062499997,
									56.243750000000034
								],
								[
									16.401269531250023,
									56.310888671875034
								],
								[
									16.394140624999977,
									56.48364257812506
								],
								[
									16.41230468750004,
									56.56899414062502
								],
								[
									16.630371093750057,
									56.87685546875005
								],
								[
									16.72773437500001,
									56.90200195312502
								],
								[
									16.864648437499994,
									57.09067382812509
								],
								[
									16.901562500000068,
									57.17460937499996
								],
								[
									16.9609375,
									57.25019531250007
								],
								[
									16.995996093750023,
									57.317773437499994
								],
								[
									17.02539062499997,
									57.345068359375034
								],
								[
									17.089257812500023,
									57.332275390625114
								],
								[
									17.11767578125003,
									57.31982421875006
								],
								[
									17.050390625000006,
									57.28046875000004
								],
								[
									17.058203125000006,
									57.229248046875085
								],
								[
									17.053515625000017,
									57.208007812500114
								],
								[
									16.88369140625005,
									56.985205078125006
								],
								[
									16.83828125000005,
									56.840527343749926
								],
								[
									16.77802734375004,
									56.80522460937493
								],
								[
									16.52851562500001,
									56.29052734374997
								]
							]
						],
						[
							[
								[
									19.076464843750045,
									57.83593750000003
								],
								[
									18.993750000000063,
									57.81210937499998
								],
								[
									18.945117187500017,
									57.74160156250011
								],
								[
									18.87812500000004,
									57.72968750000007
								],
								[
									18.813867187499994,
									57.70620117187508
								],
								[
									18.79091796875005,
									57.483105468749926
								],
								[
									18.907910156250068,
									57.39833984375005
								],
								[
									18.843652343750023,
									57.38647460937506
								],
								[
									18.78486328125004,
									57.36108398437503
								],
								[
									18.74287109375001,
									57.32353515625002
								],
								[
									18.699902343750068,
									57.242724609375074
								],
								[
									18.538476562500023,
									57.19692382812505
								],
								[
									18.477343750000017,
									57.1630371093751
								],
								[
									18.38720703125003,
									57.087646484375
								],
								[
									18.34023437500005,
									56.97822265625001
								],
								[
									18.248925781250023,
									56.931542968749994
								],
								[
									18.146386718749994,
									56.92050781250006
								],
								[
									18.20654296875,
									57.01015624999994
								],
								[
									18.285351562500068,
									57.08320312499998
								],
								[
									18.209570312500006,
									57.13330078125006
								],
								[
									18.163964843750023,
									57.211718750000045
								],
								[
									18.105078125000034,
									57.271874999999966
								],
								[
									18.151953124999977,
									57.33906250000007
								],
								[
									18.12890625,
									57.44916992187504
								],
								[
									18.136523437500045,
									57.556640625000085
								],
								[
									18.204882812500017,
									57.61088867187493
								],
								[
									18.283203125,
									57.65512695312498
								],
								[
									18.40517578125005,
									57.7568359375
								],
								[
									18.53740234374999,
									57.830566406250114
								],
								[
									18.72187500000001,
									57.863720703124926
								],
								[
									18.80517578125,
									57.83315429687511
								],
								[
									18.841113281250045,
									57.90019531249999
								],
								[
									18.90058593750001,
									57.91547851562507
								],
								[
									18.956445312500023,
									57.89999999999995
								],
								[
									19.076464843750045,
									57.83593750000003
								]
							]
						],
						[
							[
								[
									19.156347656250063,
									57.92260742187503
								],
								[
									19.13837890625004,
									57.86025390625002
								],
								[
									19.086523437500034,
									57.864990234375085
								],
								[
									19.03925781250001,
									57.91103515625005
								],
								[
									19.134863281250034,
									57.981347656249994
								],
								[
									19.28115234375008,
									57.97753906250003
								],
								[
									19.331445312500023,
									57.96289062499997
								],
								[
									19.156347656250063,
									57.92260742187503
								]
							]
						],
						[
							[
								[
									18.416210937499983,
									59.02910156250002
								],
								[
									18.371875000000017,
									59.019580078125045
								],
								[
									18.349902343750074,
									59.02260742187494
								],
								[
									18.377246093750045,
									59.06904296874998
								],
								[
									18.397558593750006,
									59.089111328125085
								],
								[
									18.464941406250063,
									59.10786132812507
								],
								[
									18.48554687500001,
									59.10458984374995
								],
								[
									18.416210937499983,
									59.02910156250002
								]
							]
						],
						[
							[
								[
									18.59541015625001,
									59.47036132812502
								],
								[
									18.57031250000003,
									59.43725585937503
								],
								[
									18.545117187500068,
									59.47783203124996
								],
								[
									18.555175781250057,
									59.48579101562498
								],
								[
									18.572363281250006,
									59.52583007812507
								],
								[
									18.620898437500045,
									59.54780273437501
								],
								[
									18.69843750000004,
									59.53461914062498
								],
								[
									18.69794921875001,
									59.52460937499998
								],
								[
									18.623828125000017,
									59.49218750000003
								],
								[
									18.59541015625001,
									59.47036132812502
								]
							]
						],
						[
							[
								[
									24.15546875000004,
									65.80527343750009
								],
								[
									23.89052734375005,
									65.78222656249994
								],
								[
									23.69140625,
									65.82851562500005
								],
								[
									23.592089843750017,
									65.80532226562494
								],
								[
									23.41835937500005,
									65.80434570312508
								],
								[
									23.221093750000023,
									65.78613281250003
								],
								[
									23.154589843750045,
									65.74990234375002
								],
								[
									23.102343750000074,
									65.73535156250006
								],
								[
									22.919335937499994,
									65.786474609375
								],
								[
									22.74658203124997,
									65.87094726562498
								],
								[
									22.62031250000001,
									65.80654296875011
								],
								[
									22.538574218750057,
									65.79433593750011
								],
								[
									22.465136718750017,
									65.85263671874998
								],
								[
									22.400976562500006,
									65.86210937499996
								],
								[
									22.366308593750034,
									65.84267578125
								],
								[
									22.3359375,
									65.79116210937508
								],
								[
									22.28759765625,
									65.75063476562508
								],
								[
									22.275000000000006,
									65.72500000000008
								],
								[
									22.26660156249997,
									65.62153320312507
								],
								[
									22.254003906250006,
									65.59755859375005
								],
								[
									22.086230468750017,
									65.61093749999995
								],
								[
									22.096289062500006,
									65.58378906250002
								],
								[
									22.1328125,
									65.57011718750007
								],
								[
									22.147558593750063,
									65.55288085937494
								],
								[
									22.086718750000017,
									65.53022460937501
								],
								[
									21.92011718750001,
									65.53237304687502
								],
								[
									21.903125000000017,
									65.5083496093751
								],
								[
									21.950000000000045,
									65.470361328125
								],
								[
									21.91347656250008,
									65.43710937499998
								],
								[
									21.87958984375001,
									65.42402343750007
								],
								[
									21.68066406249997,
									65.4033691406251
								],
								[
									21.565527343750063,
									65.40810546875002
								],
								[
									21.532617187500023,
									65.38657226562498
								],
								[
									21.52343750000003,
									65.35859375000004
								],
								[
									21.545214843750017,
									65.33115234375006
								],
								[
									21.595996093750045,
									65.31655273437502
								],
								[
									21.61269531250008,
									65.29912109375002
								],
								[
									21.609179687500074,
									65.26137695312497
								],
								[
									21.56689453125,
									65.254541015625
								],
								[
									21.446875000000063,
									65.3208496093751
								],
								[
									21.410351562500068,
									65.31743164062502
								],
								[
									21.437792968750074,
									65.28295898437509
								],
								[
									21.50634765625,
									65.24536132812509
								],
								[
									21.545996093750006,
									65.20698242187498
								],
								[
									21.580664062500034,
									65.160791015625
								],
								[
									21.57392578125001,
									65.12578124999996
								],
								[
									21.424902343750006,
									65.01269531250011
								],
								[
									21.293750000000017,
									64.94125976562503
								],
								[
									21.195898437499977,
									64.87690429687507
								],
								[
									21.138183593750057,
									64.80869140625012
								],
								[
									21.20498046875005,
									64.77431640625002
								],
								[
									21.27929687500003,
									64.72470703125006
								],
								[
									21.33154296875,
									64.62934570312498
								],
								[
									21.39384765624999,
									64.5443359375
								],
								[
									21.519628906250034,
									64.46308593749995
								],
								[
									21.49433593750004,
									64.41611328124998
								],
								[
									21.46503906250001,
									64.3795898437501
								],
								[
									21.255761718750023,
									64.29916992187503
								],
								[
									21.01845703125008,
									64.17797851562506
								],
								[
									20.76269531250003,
									63.86782226562511
								],
								[
									20.677636718750023,
									63.82626953124998
								],
								[
									20.453710937500034,
									63.7737304687501
								],
								[
									20.371386718750045,
									63.72290039062497
								],
								[
									20.204687500000034,
									63.662451171875006
								],
								[
									19.913671875000063,
									63.6105468750001
								],
								[
									19.78164062500008,
									63.538183593750006
								],
								[
									19.722070312500023,
									63.46333007812504
								],
								[
									19.65576171875003,
									63.458007812500085
								],
								[
									19.59003906250004,
									63.487255859374926
								],
								[
									19.502343750000023,
									63.509033203125114
								],
								[
									19.49091796875001,
									63.460205078125114
								],
								[
									19.494628906250057,
									63.42436523437499
								],
								[
									19.354296875000074,
									63.47749023437498
								],
								[
									19.28808593749997,
									63.4287597656251
								],
								[
									19.236328125,
									63.34736328125004
								],
								[
									19.034374999999983,
									63.23774414062498
								],
								[
									18.816699218750045,
									63.25747070312511
								],
								[
									18.792285156250045,
									63.23813476562498
								],
								[
									18.850195312500034,
									63.22412109374997
								],
								[
									18.858984375000063,
									63.206591796875045
								],
								[
									18.819433593749977,
									63.197265625
								],
								[
									18.759570312500045,
									63.19824218750003
								],
								[
									18.667187500000068,
									63.17656249999996
								],
								[
									18.60644531250003,
									63.178271484375045
								],
								[
									18.57763671875003,
									63.126416015624955
								],
								[
									18.53066406250005,
									63.06352539062502
								],
								[
									18.40771484375003,
									63.037499999999966
								],
								[
									18.34423828125,
									63.03212890624994
								],
								[
									18.31289062500008,
									62.99638671875002
								],
								[
									18.502050781249977,
									62.988867187500006
								],
								[
									18.486914062500006,
									62.95859375000006
								],
								[
									18.48261718750001,
									62.928320312500006
								],
								[
									18.46308593750004,
									62.89584960937506
								],
								[
									18.24804687500003,
									62.84907226562504
								],
								[
									18.214941406250034,
									62.81220703124998
								],
								[
									18.170019531250034,
									62.78935546875013
								],
								[
									18.074414062499983,
									62.79067382812502
								],
								[
									18.07792968749999,
									62.811962890624926
								],
								[
									18.093554687500074,
									62.83603515624995
								],
								[
									17.951074218749994,
									62.83388671875005
								],
								[
									17.906640625000023,
									62.88676757812499
								],
								[
									17.87958984375001,
									62.873193359374966
								],
								[
									17.895605468749977,
									62.83051757812498
								],
								[
									17.932910156250045,
									62.7861328125
								],
								[
									17.974414062500045,
									62.72104492187498
								],
								[
									17.940722656250017,
									62.67988281250001
								],
								[
									17.903027343750068,
									62.659472656250045
								],
								[
									17.930468750000074,
									62.64062500000003
								],
								[
									18.00654296875001,
									62.6262695312501
								],
								[
									18.037304687500068,
									62.60053710937501
								],
								[
									17.947070312500074,
									62.57846679687506
								],
								[
									17.834472656250057,
									62.50273437499999
								],
								[
									17.7177734375,
									62.500878906249966
								],
								[
									17.646386718750023,
									62.4508789062501
								],
								[
									17.570605468750017,
									62.451025390625034
								],
								[
									17.50898437500001,
									62.48251953125006
								],
								[
									17.410253906250034,
									62.50839843750009
								],
								[
									17.378417968750057,
									62.46279296874994
								],
								[
									17.373339843750074,
									62.426513671875085
								],
								[
									17.429003906250045,
									62.33471679687506
								],
								[
									17.535253906250034,
									62.26367187500006
								],
								[
									17.633691406249994,
									62.23300781250012
								],
								[
									17.56289062500005,
									62.21230468750008
								],
								[
									17.51015625000005,
									62.16630859375002
								],
								[
									17.446582031250074,
									62.02265624999998
								],
								[
									17.41201171875005,
									61.9661132812501
								],
								[
									17.374511718750057,
									61.866308593750006
								],
								[
									17.39824218749999,
									61.78208007812509
								],
								[
									17.417285156250045,
									61.7406738281251
								],
								[
									17.465429687500006,
									61.68447265625008
								],
								[
									17.334570312500006,
									61.69169921874996
								],
								[
									17.196386718750006,
									61.7245605468751
								],
								[
									17.215625000000017,
									61.656347656250034
								],
								[
									17.13076171875005,
									61.57573242187496
								],
								[
									17.146582031250063,
									61.50463867187506
								],
								[
									17.16425781250001,
									61.45830078125002
								],
								[
									17.13798828124999,
									61.381689453125034
								],
								[
									17.177929687500068,
									61.35761718750004
								],
								[
									17.199609375000023,
									61.31196289062504
								],
								[
									17.163867187500045,
									61.27827148437504
								],
								[
									17.179785156249977,
									61.24926757812506
								],
								[
									17.18574218750004,
									61.14653320312502
								],
								[
									17.21289062499997,
									60.98583984375006
								],
								[
									17.20292968749999,
									60.95185546875004
								],
								[
									17.278906250000034,
									60.81215820312502
								],
								[
									17.261230468750057,
									60.763183593750085
								],
								[
									17.25097656250003,
									60.70078124999998
								],
								[
									17.35986328125,
									60.640820312499926
								],
								[
									17.45703124999997,
									60.64179687500004
								],
								[
									17.555468750000045,
									60.64272460937505
								],
								[
									17.593066406250074,
									60.627685546875
								],
								[
									17.630761718750023,
									60.585253906250074
								],
								[
									17.6611328125,
									60.53515625000006
								],
								[
									17.7421875,
									60.53930664062494
								],
								[
									17.871582031250057,
									60.580078125000085
								],
								[
									17.955761718750068,
									60.589794921874926
								],
								[
									18.011328125000034,
									60.51142578125004
								],
								[
									18.162499999999994,
									60.40791015625007
								],
								[
									18.25048828124997,
									60.361523437499955
								],
								[
									18.400000000000063,
									60.337109374999955
								],
								[
									18.557519531249994,
									60.253564453124994
								],
								[
									18.535449218750045,
									60.15288085937499
								],
								[
									18.601171875000006,
									60.11923828124998
								],
								[
									18.78701171875005,
									60.079492187499966
								],
								[
									18.85273437500001,
									60.02587890624997
								],
								[
									18.884277343750057,
									59.98017578124998
								],
								[
									18.933203124999977,
									59.942285156249994
								],
								[
									18.99042968750001,
									59.82778320312494
								],
								[
									18.970507812500045,
									59.75722656250002
								],
								[
									18.895605468750063,
									59.732958984375074
								],
								[
									18.71875,
									59.65737304687494
								],
								[
									18.639941406250017,
									59.60092773437509
								],
								[
									18.57812500000003,
									59.56577148437512
								],
								[
									18.402441406250034,
									59.49038085937494
								],
								[
									18.338085937500068,
									59.4768554687501
								],
								[
									18.276464843750034,
									59.43764648437494
								],
								[
									18.216894531250063,
									59.420507812500006
								],
								[
									18.16357421875003,
									59.43037109375007
								],
								[
									17.964257812500023,
									59.359375000000085
								],
								[
									17.979785156250074,
									59.32905273437501
								],
								[
									18.132617187500045,
									59.31621093749999
								],
								[
									18.210546875000006,
									59.33144531250008
								],
								[
									18.27050781249997,
									59.36713867187507
								],
								[
									18.336035156250006,
									59.37534179687495
								],
								[
									18.395800781250017,
									59.3686035156251
								],
								[
									18.45917968750004,
									59.39672851562506
								],
								[
									18.508886718750034,
									59.40795898437503
								],
								[
									18.56025390625004,
									59.39448242187504
								],
								[
									18.61757812500008,
									59.327050781249966
								],
								[
									18.498632812500006,
									59.291943359374926
								],
								[
									18.41425781250004,
									59.290332031250045
								],
								[
									18.373046875,
									59.179736328125074
								],
								[
									18.321972656250068,
									59.13222656250008
								],
								[
									18.285351562500068,
									59.10937499999994
								],
								[
									18.09814453125003,
									59.062304687500045
								],
								[
									17.974609375,
									59.002636718749955
								],
								[
									17.829003906249994,
									58.95458984374994
								],
								[
									17.765429687500017,
									58.96503906250004
								],
								[
									17.66962890625004,
									58.91621093750004
								],
								[
									17.45673828125001,
									58.85839843749997
								],
								[
									17.34765625,
									58.780517578125
								],
								[
									17.102832031250045,
									58.71083984374994
								],
								[
									16.978125000000034,
									58.65415039062512
								],
								[
									16.63935546875001,
									58.65117187500013
								],
								[
									16.315820312500023,
									58.66362304687499
								],
								[
									16.214257812500023,
									58.636669921874926
								],
								[
									16.31806640625004,
									58.628320312499994
								],
								[
									16.39082031250001,
									58.60185546875002
								],
								[
									16.47802734375003,
									58.61289062500006
								],
								[
									16.683007812500023,
									58.59965820312502
								],
								[
									16.788476562500023,
									58.58525390625002
								],
								[
									16.92382812499997,
									58.492578124999966
								],
								[
									16.824316406250034,
									58.459619140624994
								],
								[
									16.651953125000006,
									58.434326171875
								],
								[
									16.716601562500045,
									58.30288085937505
								],
								[
									16.76992187500008,
									58.21425781250002
								],
								[
									16.70009765625005,
									58.160791015624966
								],
								[
									16.694921875000063,
									57.91752929687496
								],
								[
									16.596972656250017,
									57.912890625000074
								],
								[
									16.555371093750068,
									57.812255859375114
								],
								[
									16.586230468750045,
									57.76093750000004
								],
								[
									16.583789062500074,
									57.64174804687508
								],
								[
									16.604199218750068,
									57.56831054687504
								],
								[
									16.65224609375008,
									57.500683593749955
								],
								[
									16.63085937499997,
									57.43017578124997
								],
								[
									16.47597656250005,
									57.265136718750114
								],
								[
									16.479492187500057,
									57.187695312499955
								],
								[
									16.50732421875003,
									57.141699218750006
								],
								[
									16.527929687500063,
									57.068164062500045
								],
								[
									16.45751953125003,
									56.92680664062502
								],
								[
									16.407812500000006,
									56.80869140625012
								],
								[
									16.348730468750063,
									56.70927734375002
								],
								[
									16.21650390625004,
									56.58999023437505
								],
								[
									16.150683593750045,
									56.500830078125006
								],
								[
									15.996679687500006,
									56.22260742187498
								],
								[
									15.92031250000008,
									56.16738281250002
								],
								[
									15.82666015625,
									56.12495117187498
								],
								[
									15.722265625000063,
									56.164208984374994
								],
								[
									15.626562500000006,
									56.185595703125074
								],
								[
									15.509667968749994,
									56.18300781250008
								],
								[
									15.326562499999994,
									56.150830078124926
								],
								[
									15.051171875000023,
									56.17221679687512
								],
								[
									14.782031249999989,
									56.161914062500045
								],
								[
									14.713964843749977,
									56.13413085937509
								],
								[
									14.754785156250051,
									56.03315429687504
								],
								[
									14.655566406249989,
									56.019921874999994
								],
								[
									14.558593750000057,
									56.048632812500074
								],
								[
									14.473242187500063,
									56.014355468749926
								],
								[
									14.401953125000006,
									55.9767578125001
								],
								[
									14.261914062500011,
									55.887548828125034
								],
								[
									14.21503906250004,
									55.832617187500034
								],
								[
									14.202929687500074,
									55.729150390624994
								],
								[
									14.276464843750034,
									55.63637695312502
								],
								[
									14.341699218749994,
									55.527734374999994
								],
								[
									14.173730468750051,
									55.39663085937494
								],
								[
									14.079980468750051,
									55.392187500000006
								],
								[
									13.806347656250011,
									55.428564453125034
								],
								[
									13.321386718750063,
									55.3463867187501
								],
								[
									12.885839843750063,
									55.411376953125085
								],
								[
									12.940625000000011,
									55.48159179687511
								],
								[
									12.938769531249989,
									55.53320312500006
								],
								[
									12.963378906250028,
									55.612597656250045
								],
								[
									12.97802734375,
									55.69379882812507
								],
								[
									12.973925781250045,
									55.74814453125006
								],
								[
									12.941992187500034,
									55.80605468750002
								],
								[
									12.834570312500006,
									55.881835937500114
								],
								[
									12.592578124999989,
									56.13759765625008
								],
								[
									12.520996093749972,
									56.245556640624955
								],
								[
									12.471191406250057,
									56.29052734374997
								],
								[
									12.507031250000068,
									56.29296875000003
								],
								[
									12.706347656250074,
									56.23500976562494
								],
								[
									12.752832031250051,
									56.24213867187507
								],
								[
									12.801660156250051,
									56.26391601562506
								],
								[
									12.7421875,
									56.34687500000007
								],
								[
									12.691113281249983,
									56.38442382812508
								],
								[
									12.65644531250004,
									56.44057617187508
								],
								[
									12.773144531250011,
									56.45576171875007
								],
								[
									12.857421875000028,
									56.452392578125085
								],
								[
									12.919531249999977,
									56.51557617187498
								],
								[
									12.883691406250051,
									56.61772460937502
								],
								[
									12.793164062500011,
									56.64916992187503
								],
								[
									12.717578125000045,
									56.66284179687497
								],
								[
									12.572656250000023,
									56.823291015625074
								],
								[
									12.421484375000034,
									56.90639648437494
								],
								[
									12.15185546875,
									57.226953124999966
								],
								[
									12.053222656249972,
									57.44697265625001
								],
								[
									11.961523437500034,
									57.42607421875002
								],
								[
									11.916992187500028,
									57.521923828124926
								],
								[
									11.885058593750017,
									57.61269531250002
								],
								[
									11.878710937500045,
									57.67944335937506
								],
								[
									11.734960937500063,
									57.71767578125002
								],
								[
									11.729101562500034,
									57.764453125000045
								],
								[
									11.703222656250006,
									57.97319335937493
								],
								[
									11.549023437500011,
									58.00122070312506
								],
								[
									11.449316406250063,
									58.118359374999926
								],
								[
									11.43154296875008,
									58.339990234374966
								],
								[
									11.32998046875008,
									58.380322265624926
								],
								[
									11.24824218750004,
									58.36914062500003
								],
								[
									11.252050781250006,
									58.42407226562503
								],
								[
									11.271582031249977,
									58.475634765625074
								],
								[
									11.22382812500004,
									58.67993164062494
								],
								[
									11.20791015625008,
									58.86640625000001
								],
								[
									11.169140624999983,
									58.92270507812512
								],
								[
									11.14716796875004,
									58.98862304687495
								],
								[
									11.16689453125008,
									59.045556640624994
								],
								[
									11.19580078125,
									59.07827148437508
								],
								[
									11.295312500000023,
									59.08686523437498
								],
								[
									11.388281250000063,
									59.03652343749994
								],
								[
									11.470703125000057,
									58.90952148437509
								],
								[
									11.543554687500063,
									58.893017578124926
								],
								[
									11.64277343750004,
									58.92607421874999
								],
								[
									11.712207031250045,
									59.018652343750034
								],
								[
									11.751855468750051,
									59.15756835937509
								],
								[
									11.798144531250074,
									59.28989257812495
								],
								[
									11.743359375000011,
									59.43144531250002
								],
								[
									11.684863281250074,
									59.555761718750034
								],
								[
									11.680761718750034,
									59.59228515625
								],
								[
									11.834277343750045,
									59.697167968749966
								],
								[
									11.881250000000023,
									59.78247070312494
								],
								[
									11.93212890625,
									59.863671874999966
								],
								[
									11.988281249999972,
									59.8913085937501
								],
								[
									12.071875000000063,
									59.89760742187502
								],
								[
									12.169238281250074,
									59.912890625000045
								],
								[
									12.291992187500028,
									59.967236328124926
								],
								[
									12.402050781249983,
									60.040039062500085
								],
								[
									12.486132812500074,
									60.10678710937512
								],
								[
									12.514648437500028,
									60.23886718750009
								],
								[
									12.515820312499983,
									60.30522460937513
								],
								[
									12.552832031250063,
									60.35449218749994
								],
								[
									12.588671874999989,
									60.45073242187502
								],
								[
									12.553808593750006,
									60.545654296875085
								],
								[
									12.4453125,
									60.689648437499926
								],
								[
									12.31464843750004,
									60.89213867187496
								],
								[
									12.29414062500004,
									61.002685546875114
								],
								[
									12.353710937500011,
									61.02319335937503
								],
								[
									12.467578125000017,
									61.04150390625003
								],
								[
									12.683007812500023,
									61.046826171874955
								],
								[
									12.706054687500028,
									61.05986328125013
								],
								[
									12.727832031250017,
									61.108251953125034
								],
								[
									12.776367187500057,
									61.17397460937511
								],
								[
									12.828222656250034,
									61.22182617187508
								],
								[
									12.86367187500008,
									61.290283203125085
								],
								[
									12.88076171875008,
									61.352294921875085
								],
								[
									12.757519531250011,
									61.44570312499994
								],
								[
									12.596093749999994,
									61.541308593750045
								],
								[
									12.486816406250028,
									61.57299804687494
								],
								[
									12.292089843750063,
									61.653466796874994
								],
								[
									12.155371093750006,
									61.72075195312502
								],
								[
									12.233691406250074,
									61.976855468750074
								],
								[
									12.291992187500028,
									62.16743164062498
								],
								[
									12.301367187500006,
									62.21376953125011
								],
								[
									12.303515625000074,
									62.28559570312498
								],
								[
									12.114550781250045,
									62.59189453124995
								],
								[
									12.121875000000017,
									62.66000976562498
								],
								[
									12.13984375000004,
									62.72133789062494
								],
								[
									12.11962890625,
									62.82592773437503
								],
								[
									12.108593750000068,
									62.91948242187499
								],
								[
									12.141015625000023,
									62.94785156250009
								],
								[
									12.218164062500023,
									63.000634765624994
								],
								[
									12.144628906250034,
									63.082519531250085
								],
								[
									12.138671874999972,
									63.0891601562501
								],
								[
									11.999902343750051,
									63.29169921875007
								],
								[
									12.212109375000011,
									63.49223632812496
								],
								[
									12.175195312500051,
									63.59594726562506
								],
								[
									12.30195312500004,
									63.6711914062501
								],
								[
									12.532714843750057,
									63.843554687500045
								],
								[
									12.662500000000023,
									63.940478515625074
								],
								[
									12.690039062500034,
									63.957421874999966
								],
								[
									12.792773437500017,
									63.99999999999994
								],
								[
									12.987597656249989,
									64.05048828124993
								],
								[
									13.203515625000023,
									64.07509765624997
								],
								[
									13.299609375000074,
									64.07480468750009
								],
								[
									13.670703125000074,
									64.04062499999995
								],
								[
									13.960546875000063,
									64.01401367187495
								],
								[
									14.002734375000045,
									64.04072265625007
								],
								[
									14.063281250000045,
									64.09550781250013
								],
								[
									14.141210937500006,
									64.17353515625004
								],
								[
									14.148046874999977,
									64.26030273437513
								],
								[
									14.119921875000017,
									64.38774414062507
								],
								[
									14.077636718750028,
									64.46401367187497
								],
								[
									13.87353515625,
									64.51357421874994
								],
								[
									13.650292968749994,
									64.58154296875003
								],
								[
									13.924804687499972,
									64.79677734375
								],
								[
									14.115136718750023,
									64.94614257812503
								],
								[
									14.352441406250051,
									65.1708496093751
								],
								[
									14.42626953125,
									65.26435546874995
								],
								[
									14.47968750000004,
									65.30146484374995
								],
								[
									14.549511718750068,
									65.64638671875005
								],
								[
									14.595800781249977,
									65.74287109375001
								],
								[
									14.634570312500074,
									65.79326171874996
								],
								[
									14.635156250000023,
									65.84501953125013
								],
								[
									14.609960937500034,
									65.93227539062505
								],
								[
									14.543261718750017,
									66.12934570312495
								],
								[
									14.917968749999972,
									66.15371093750002
								],
								[
									15.040039062499972,
									66.1675292968751
								],
								[
									15.153320312500057,
									66.19106445312511
								],
								[
									15.37490234375008,
									66.25205078125009
								],
								[
									15.483789062500051,
									66.30595703124996
								],
								[
									15.422949218750006,
									66.48984374999995
								],
								[
									15.557031250000051,
									66.55209960937512
								],
								[
									15.884179687499994,
									66.76884765625013
								],
								[
									16.23769531250008,
									66.97641601562495
								],
								[
									16.40351562500004,
									67.05498046875007
								],
								[
									16.420703125000074,
									67.09335937499998
								],
								[
									16.434277343749983,
									67.1550781250001
								],
								[
									16.36064453124999,
									67.25200195312496
								],
								[
									16.281542968750045,
									67.31206054687513
								],
								[
									16.12744140625,
									67.42583007812513
								],
								[
									16.193554687500068,
									67.50517578125013
								],
								[
									16.30712890625003,
									67.52060546874998
								],
								[
									16.457128906250034,
									67.55175781250011
								],
								[
									16.57412109375005,
									67.61958007812498
								],
								[
									16.585546874999977,
									67.62832031250008
								],
								[
									16.783593750000023,
									67.89501953125006
								],
								[
									17.170507812500063,
									68.03012695312495
								],
								[
									17.324609374999994,
									68.10380859375005
								],
								[
									17.564746093750074,
									68.04843749999995
								],
								[
									17.91669921875001,
									67.96489257812499
								],
								[
									18.07324218750003,
									68.08784179687498
								],
								[
									18.125,
									68.13344726562505
								],
								[
									18.17666015625005,
									68.20063476562495
								],
								[
									18.15595703125001,
									68.31684570312493
								],
								[
									18.147070312500063,
									68.46777343749994
								],
								[
									18.16259765625003,
									68.52841796874995
								],
								[
									18.303027343750017,
									68.55541992187494
								],
								[
									18.378613281250068,
									68.56240234374994
								],
								[
									18.769824218750017,
									68.50004882812513
								],
								[
									18.868261718749977,
									68.50112304687508
								],
								[
									19.05263671875008,
									68.49272460937496
								],
								[
									19.25898437500001,
									68.46533203124997
								],
								[
									19.691210937500045,
									68.39243164062495
								],
								[
									19.87001953125005,
									68.36225585937501
								],
								[
									19.969824218750063,
									68.35639648437498
								],
								[
									20.055957031250017,
									68.39038085937506
								],
								[
									20.240039062500045,
									68.47753906249997
								],
								[
									19.968847656250034,
									68.54204101562505
								],
								[
									20.1474609375,
									68.60732421875002
								],
								[
									20.240039062500045,
									68.67314453125013
								],
								[
									20.319433593750034,
									68.754052734375
								],
								[
									20.348046875000023,
									68.84873046875
								],
								[
									20.33710937500001,
									68.899658203125
								],
								[
									20.282324218750034,
									68.93432617187503
								],
								[
									20.11669921875003,
									69.02089843750008
								],
								[
									20.491992187500017,
									69.03330078124995
								],
								[
									20.622167968749977,
									69.03686523437497
								],
								[
									20.895117187500006,
									68.97983398437506
								],
								[
									20.907031250000017,
									68.96748046874995
								],
								[
									20.908984375000074,
									68.93774414062494
								],
								[
									20.918554687500063,
									68.90693359375007
								],
								[
									21.183398437500017,
									68.82880859374995
								],
								[
									21.25976562500003,
									68.78745117187506
								],
								[
									21.42236328125003,
									68.72460937499994
								],
								[
									21.465429687500006,
									68.69067382812506
								],
								[
									21.616015625000045,
									68.65097656250003
								],
								[
									21.724023437500023,
									68.60854492187502
								],
								[
									21.850195312500063,
									68.57412109374994
								],
								[
									21.99746093750005,
									68.52060546874995
								],
								[
									22.195117187500074,
									68.47797851562507
								],
								[
									22.362109375000074,
									68.46406249999998
								],
								[
									22.78242187500001,
									68.39101562499994
								],
								[
									22.854101562500034,
									68.367333984375
								],
								[
									22.975390625000045,
									68.31645507812502
								],
								[
									23.09785156250004,
									68.25756835937511
								],
								[
									23.18251953125005,
									68.13662109375005
								],
								[
									23.318554687500068,
									68.13032226562501
								],
								[
									23.35546875000003,
									68.08867187500007
								],
								[
									23.474218749999977,
									68.01733398437509
								],
								[
									23.63886718750004,
									67.95439453125007
								],
								[
									23.632910156249977,
									67.933203125
								],
								[
									23.501855468750023,
									67.87519531250001
								],
								[
									23.48779296875,
									67.79658203124998
								],
								[
									23.50019531250004,
									67.69619140625005
								],
								[
									23.541308593750074,
									67.61430664062505
								],
								[
									23.53701171875008,
									67.59038085937507
								],
								[
									23.504492187500034,
									67.56215820312508
								],
								[
									23.465429687500063,
									67.51787109375005
								],
								[
									23.451464843750045,
									67.47919921874998
								],
								[
									23.454882812500045,
									67.4602539062501
								],
								[
									23.468066406250074,
									67.44995117187497
								],
								[
									23.537109375,
									67.44916992187498
								],
								[
									23.660839843749983,
									67.44003906250009
								],
								[
									23.733593750000068,
									67.42290039062496
								],
								[
									23.774902343750057,
									67.32861328124994
								],
								[
									23.76093750000004,
									67.31049804687498
								],
								[
									23.656640625000023,
									67.26782226562509
								],
								[
									23.626074218750006,
									67.23393554687502
								],
								[
									23.62304687500003,
									67.18413085937499
								],
								[
									23.64150390625005,
									67.12939453124994
								],
								[
									23.677343750000063,
									67.06811523437509
								],
								[
									23.75898437500001,
									67.00258789062505
								],
								[
									23.86933593750001,
									66.93403320312501
								],
								[
									23.941796875000023,
									66.87783203124994
								],
								[
									23.97607421875,
									66.83823242187503
								],
								[
									23.988574218750045,
									66.810546875
								],
								[
									23.93886718750005,
									66.77573242187509
								],
								[
									23.894140625000006,
									66.70688476562512
								],
								[
									23.885839843750006,
									66.62802734374995
								],
								[
									23.865527343750045,
									66.57661132812495
								],
								[
									23.768359375000045,
									66.50585937500011
								],
								[
									23.70117187500003,
									66.48076171874996
								],
								[
									23.68203125000005,
									66.44340820312499
								],
								[
									23.673828125000057,
									66.380712890625
								],
								[
									23.693554687499983,
									66.30429687499998
								],
								[
									23.700292968750034,
									66.25263671875004
								],
								[
									23.720996093750074,
									66.21542968750009
								],
								[
									23.75146484374997,
									66.19116210937494
								],
								[
									23.907324218750034,
									66.14824218749999
								],
								[
									23.994628906250057,
									66.06035156250002
								],
								[
									24.04902343750001,
									65.98984375000003
								],
								[
									24.15546875000004,
									65.80527343750009
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "SWE",
					"su_a3": "SWE",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "SWE",
					"gu_a3": "SWE",
					"abbrev": "Swe.",
					"region_un": "Europe",
					"adm0_a3_us": "SWE",
					"scalerank": 1,
					"pop_est": 9059651,
					"adm0_dif": 0,
					"un_a3": "752",
					"pop_year": -99,
					"gdp_md_est": 344300,
					"name": "Sweden",
					"sovereignt": "Sweden",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "Sweden",
					"postal": "S",
					"sov_a3": "SWE",
					"note_brk": "",
					"brk_a3": "SWE",
					"wb_a2": "SE",
					"brk_diff": 0,
					"admin": "Sweden",
					"name_long": "Sweden",
					"iso_a3": "SWE",
					"iso_a2": "SE",
					"adm0_a3_is": "SWE",
					"level": 2,
					"formal_en": "Kingdom of Sweden",
					"name_len": 6,
					"mapcolor7": 1,
					"long_len": 6,
					"mapcolor8": 4,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "752",
					"homepart": 1,
					"subunit": "Sweden",
					"name_alt": "",
					"brk_name": "Sweden",
					"name_sort": "Sweden",
					"continent": "Europe",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": -99
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									99.6630859375,
									6.52192382812504
								],
								[
									99.64404296875011,
									6.5161132812500995
								],
								[
									99.60664062500001,
									6.596826171875023
								],
								[
									99.65400390625018,
									6.714111328125028
								],
								[
									99.70136718750007,
									6.570556640625
								],
								[
									99.6630859375,
									6.52192382812504
								]
							]
						],
						[
							[
								[
									99.07841796875016,
									7.5918457031250455
								],
								[
									99.10439453125014,
									7.471289062500006
								],
								[
									99.06787109374994,
									7.4958984375000455
								],
								[
									99.0376953125002,
									7.548486328125094
								],
								[
									99.03808593750011,
									7.625732421875028
								],
								[
									99.04511718750001,
									7.636523437500088
								],
								[
									99.07841796875016,
									7.5918457031250455
								]
							]
						],
						[
							[
								[
									98.59199218750018,
									7.933935546874935
								],
								[
									98.57998046875014,
									7.9170410156250455
								],
								[
									98.5293945312502,
									8.10854492187498
								],
								[
									98.60429687499999,
									8.057324218750026
								],
								[
									98.59199218750018,
									7.933935546874935
								]
							]
						],
						[
							[
								[
									98.40908203125014,
									7.902050781250011
								],
								[
									98.39843750000011,
									7.828417968749932
								],
								[
									98.357421875,
									7.829443359374963
								],
								[
									98.31562500000018,
									7.782324218750048
								],
								[
									98.29628906249997,
									7.776074218750097
								],
								[
									98.26230468750009,
									7.926074218749932
								],
								[
									98.3013671875002,
									8.136230468750028
								],
								[
									98.32207031250016,
									8.166308593750017
								],
								[
									98.35097656250002,
									8.110644531250045
								],
								[
									98.43496093749997,
									8.085644531250026
								],
								[
									98.39882812499997,
									7.9645507812499545
								],
								[
									98.40908203125014,
									7.902050781250011
								]
							]
						],
						[
							[
								[
									98.30751953125014,
									9.051464843750054
								],
								[
									98.25078125000005,
									9.040820312500017
								],
								[
									98.25839843750009,
									9.09541015625004
								],
								[
									98.27363281250007,
									9.129882812500043
								],
								[
									98.30117187499997,
									9.139111328124969
								],
								[
									98.3125,
									9.080371093750074
								],
								[
									98.30751953125014,
									9.051464843750054
								]
							]
						],
						[
							[
								[
									100.07070312499997,
									9.586035156250063
								],
								[
									100.0752929687502,
									9.52944335937508
								],
								[
									100.0537109375,
									9.461425781250085
								],
								[
									99.96240234375011,
									9.421630859374972
								],
								[
									99.93125000000009,
									9.476074218750043
								],
								[
									99.93955078125009,
									9.55996093750008
								],
								[
									99.95361328125011,
									9.581005859375026
								],
								[
									100.04296875000011,
									9.576855468750068
								],
								[
									100.07070312499997,
									9.586035156250063
								]
							]
						],
						[
							[
								[
									100.07412109375014,
									9.696679687500051
								],
								[
									100.06445312499994,
									9.679980468750017
								],
								[
									100.02568359375016,
									9.711718750000088
								],
								[
									99.99804687500011,
									9.747607421874946
								],
								[
									99.98339843749994,
									9.793554687500063
								],
								[
									100.04345703125011,
									9.791650390625037
								],
								[
									100.07304687499999,
									9.749121093750077
								],
								[
									100.07412109375014,
									9.696679687500051
								]
							]
						],
						[
							[
								[
									102.60644531250011,
									11.676513671874986
								],
								[
									102.5899414062502,
									11.572167968750037
								],
								[
									102.5328125000002,
									11.614941406250054
								],
								[
									102.54648437500003,
									11.667773437500074
								],
								[
									102.5689453125002,
									11.69169921875006
								],
								[
									102.60644531250011,
									11.676513671874986
								]
							]
						],
						[
							[
								[
									102.42675781250011,
									11.988720703124997
								],
								[
									102.42998046875005,
									11.96474609375008
								],
								[
									102.37812500000001,
									11.98295898437506
								],
								[
									102.35996093750009,
									11.974414062500017
								],
								[
									102.30195312500007,
									11.980810546875077
								],
								[
									102.27333984375002,
									12.119335937500054
								],
								[
									102.27744140625003,
									12.151855468750014
								],
								[
									102.31884765624994,
									12.14165039062506
								],
								[
									102.37812500000001,
									12.072851562500077
								],
								[
									102.40839843750018,
									12.02509765625004
								],
								[
									102.42675781250011,
									11.988720703124997
								]
							]
						],
						[
							[
								[
									100.12246093750014,
									20.316650390625114
								],
								[
									100.11494140625013,
									20.257666015625006
								],
								[
									100.1397460937502,
									20.245410156250074
								],
								[
									100.1741210937501,
									20.27275390624996
								],
								[
									100.21806640625016,
									20.33959960937517
								],
								[
									100.26601562500008,
									20.377294921875034
								],
								[
									100.31796875000009,
									20.385888671875193
								],
								[
									100.37314453125015,
									20.34038085937516
								],
								[
									100.43154296875014,
									20.240722656250085
								],
								[
									100.49160156250008,
									20.184082031250114
								],
								[
									100.51953125000011,
									20.177929687500097
								],
								[
									100.53994140625008,
									20.13237304687496
								],
								[
									100.5430664062502,
									20.088671875000102
								],
								[
									100.51455078125008,
									19.996337890625057
								],
								[
									100.46621093750008,
									19.888916015625
								],
								[
									100.39765625000013,
									19.75610351562503
								],
								[
									100.42011718750013,
									19.64448242187504
								],
								[
									100.51357421875014,
									19.55346679687497
								],
								[
									100.62548828125011,
									19.499853515625063
								],
								[
									100.74394531249999,
									19.514746093749977
								],
								[
									100.80683593750001,
									19.541943359374926
								],
								[
									100.85820312499999,
									19.585058593750006
								],
								[
									100.9060546875001,
									19.60537109375005
								],
								[
									100.96650390625007,
									19.610791015624926
								],
								[
									101.15468750000008,
									19.579199218750063
								],
								[
									101.21191406250006,
									19.548339843750085
								],
								[
									101.22080078125015,
									19.48662109375013
								],
								[
									101.19755859375016,
									19.32792968750013
								],
								[
									101.22656250000011,
									19.211523437500034
								],
								[
									101.2798828125002,
									19.088916015625102
								],
								[
									101.28632812500013,
									18.977148437500063
								],
								[
									101.2205078125001,
									18.792773437500074
								],
								[
									101.16552734375011,
									18.61831054687505
								],
								[
									101.10634765625014,
									18.53354492187512
								],
								[
									101.06044921875008,
									18.47900390625
								],
								[
									101.0469726562502,
									18.44199218750012
								],
								[
									101.0505859375001,
									18.407031250000102
								],
								[
									101.09277343750011,
									18.35454101562496
								],
								[
									101.13750000000016,
									18.28686523437503
								],
								[
									101.14873046875016,
									18.222167968750085
								],
								[
									101.14394531250014,
									18.14262695312496
								],
								[
									101.11328125000011,
									18.033544921875034
								],
								[
									100.99902343750011,
									17.797167968750102
								],
								[
									100.9084960937501,
									17.583886718749994
								],
								[
									100.95585937499999,
									17.541113281250063
								],
								[
									101.04570312499999,
									17.509960937500125
								],
								[
									101.10517578125007,
									17.479541015625045
								],
								[
									101.16748046875006,
									17.49902343750003
								],
								[
									101.29970703125008,
									17.625000000000114
								],
								[
									101.4136718750002,
									17.71875000000003
								],
								[
									101.55507812500014,
									17.81235351562509
								],
								[
									101.56367187500001,
									17.820507812500153
								],
								[
									101.68750000000011,
									17.889404296875057
								],
								[
									101.74414062500011,
									17.952685546875074
								],
								[
									101.77480468750014,
									18.033398437500182
								],
								[
									101.8186523437501,
									18.064648437500153
								],
								[
									101.87548828125006,
									18.04643554687499
								],
								[
									101.94746093750007,
									18.08149414062504
								],
								[
									102.03457031250014,
									18.169824218749994
								],
								[
									102.10146484375008,
									18.21064453125004
								],
								[
									102.1482421875001,
									18.203857421875085
								],
								[
									102.23164062500001,
									18.148974609375102
								],
								[
									102.35185546874999,
									18.045947265625074
								],
								[
									102.4587890625001,
									17.984619140625
								],
								[
									102.55253906250016,
									17.96508789062503
								],
								[
									102.5982421875002,
									17.92675781250003
								],
								[
									102.59609375000014,
									17.86962890625003
								],
								[
									102.61679687500015,
									17.833349609375006
								],
								[
									102.66064453125006,
									17.817968749999977
								],
								[
									102.68007812500008,
									17.82412109375008
								],
								[
									102.67519531250008,
									17.851757812500125
								],
								[
									102.7175781250001,
									17.892236328125108
								],
								[
									102.8074218750001,
									17.945556640625057
								],
								[
									102.89863281250001,
									17.97690429687495
								],
								[
									102.99140625000018,
									17.986230468750165
								],
								[
									103.05136718750003,
									18.028515624999983
								],
								[
									103.09121093750008,
									18.138232421875045
								],
								[
									103.14853515625015,
									18.22172851562499
								],
								[
									103.19970703125006,
									18.25947265625004
								],
								[
									103.26318359375006,
									18.278466796875193
								],
								[
									103.27958984374999,
									18.304980468750074
								],
								[
									103.24892578125008,
									18.33896484375009
								],
								[
									103.25175781250005,
									18.373486328125097
								],
								[
									103.28828125000013,
									18.408398437499926
								],
								[
									103.36699218750016,
									18.42333984375003
								],
								[
									103.48798828125001,
									18.41816406250004
								],
								[
									103.6296875000001,
									18.382568359375085
								],
								[
									103.79228515624999,
									18.31650390625012
								],
								[
									103.89882812500014,
									18.29531250000008
								],
								[
									103.94960937500008,
									18.318994140625108
								],
								[
									104.04873046875014,
									18.21669921875005
								],
								[
									104.19619140625014,
									17.988378906250063
								],
								[
									104.32265625000008,
									17.815820312499994
								],
								[
									104.42812500000014,
									17.698974609375085
								],
								[
									104.53925781250013,
									17.609277343750108
								],
								[
									104.6558593750002,
									17.546728515625063
								],
								[
									104.73964843750008,
									17.461669921875057
								],
								[
									104.81601562500015,
									17.30029296875003
								],
								[
									104.75898437500013,
									17.077148437500057
								],
								[
									104.74355468750008,
									16.88437499999995
								],
								[
									104.7505859375002,
									16.64755859375012
								],
								[
									104.81933593750011,
									16.466064453125085
								],
								[
									104.94990234375013,
									16.339941406250148
								],
								[
									105.02578125000014,
									16.237988281250153
								],
								[
									105.04716796875016,
									16.160253906250034
								],
								[
									105.14873046875016,
									16.093554687500045
								],
								[
									105.33066406250009,
									16.037890625000074
								],
								[
									105.40625000000011,
									15.987451171875108
								],
								[
									105.37558593750015,
									15.942187500000017
								],
								[
									105.37324218750007,
									15.889697265625074
								],
								[
									105.39892578125006,
									15.82988281250016
								],
								[
									105.4620117187502,
									15.780419921875108
								],
								[
									105.56240234375014,
									15.74125976562513
								],
								[
									105.62207031250011,
									15.699951171875142
								],
								[
									105.64101562500008,
									15.656542968750017
								],
								[
									105.63886718750018,
									15.5859375
								],
								[
									105.61562500000014,
									15.48828125
								],
								[
									105.57373046875011,
									15.413232421875179
								],
								[
									105.51318359375006,
									15.360888671874989
								],
								[
									105.50585937500006,
									15.319628906250117
								],
								[
									105.49042968750013,
									15.256591796874972
								],
								[
									105.49042968750013,
									15.127587890625065
								],
								[
									105.53339843750018,
									15.041601562500134
								],
								[
									105.54667968750005,
									14.93247070312502
								],
								[
									105.5230468750002,
									14.843310546874974
								],
								[
									105.50019531250013,
									14.661230468750006
								],
								[
									105.4973632812501,
									14.59067382812502
								],
								[
									105.47558593750011,
									14.530126953125034
								],
								[
									105.4226562500001,
									14.471630859375011
								],
								[
									105.34218750000014,
									14.416699218750011
								],
								[
									105.24365234375011,
									14.367871093750011
								],
								[
									105.18330078125007,
									14.34624023437496
								],
								[
									105.16914062500001,
									14.336083984375023
								],
								[
									105.12597656250011,
									14.280957031249983
								],
								[
									105.07412109375014,
									14.227441406250094
								],
								[
									105.03369140624994,
									14.227392578125077
								],
								[
									105.00341796875011,
									14.254443359375088
								],
								[
									104.98242187500011,
									14.289453124999937
								],
								[
									104.9697265625,
									14.366113281250094
								],
								[
									104.87880859375014,
									14.404003906250097
								],
								[
									104.77900390625007,
									14.427832031250063
								],
								[
									104.5757812500002,
									14.390039062500094
								],
								[
									104.41162109375,
									14.369580078125097
								],
								[
									104.22773437500018,
									14.395507812500043
								],
								[
									104.0542968750002,
									14.36274414062504
								],
								[
									103.98183593750002,
									14.357910156250028
								],
								[
									103.89863281250018,
									14.362792968749957
								],
								[
									103.81835937500011,
									14.362158203125006
								],
								[
									103.74189453125007,
									14.374169921874966
								],
								[
									103.60039062499999,
									14.421093750000026
								],
								[
									103.54638671875011,
									14.417431640625068
								],
								[
									103.43242187500016,
									14.378613281249983
								],
								[
									103.3134765625,
									14.3513183593751
								],
								[
									103.19941406250001,
									14.33261718750002
								],
								[
									103.03105468749999,
									14.252539062500048
								],
								[
									102.90927734375009,
									14.136718750000085
								],
								[
									102.87324218750018,
									14.054882812500026
								],
								[
									102.81279296875005,
									13.972460937500017
								],
								[
									102.72890625000002,
									13.841894531250063
								],
								[
									102.62041015624999,
									13.716943359375009
								],
								[
									102.54472656250016,
									13.659960937499946
								],
								[
									102.5655273437502,
									13.626367187500023
								],
								[
									102.54687499999994,
									13.585693359375085
								],
								[
									102.42851562499999,
									13.567578124999955
								],
								[
									102.33632812500014,
									13.560302734375071
								],
								[
									102.31972656250014,
									13.53999023437511
								],
								[
									102.33076171875018,
									13.288232421875065
								],
								[
									102.36298828125007,
									13.19296875000002
								],
								[
									102.42265625000016,
									13.077978515625034
								],
								[
									102.46171874999999,
									13.015039062500009
								],
								[
									102.49072265625,
									12.828320312499983
								],
								[
									102.4996093750002,
									12.669970703125045
								],
								[
									102.62968750000005,
									12.569921875000091
								],
								[
									102.70332031250001,
									12.493505859375077
								],
								[
									102.75566406250005,
									12.426269531250057
								],
								[
									102.73740234375003,
									12.383398437499935
								],
								[
									102.70625000000018,
									12.255664062500017
								],
								[
									102.73662109375016,
									12.089794921874983
								],
								[
									102.91806640625009,
									11.732080078124937
								],
								[
									102.93388671875005,
									11.706689453125094
								],
								[
									102.91230468750007,
									11.703857421875043
								],
								[
									102.88369140625002,
									11.772753906250045
								],
								[
									102.79160156250009,
									11.888623046875026
								],
								[
									102.76298828125005,
									12.012451171875028
								],
								[
									102.6548828125002,
									12.148828125000023
								],
								[
									102.59414062499997,
									12.203027343750051
								],
								[
									102.57480468750003,
									12.157812500000077
								],
								[
									102.54023437500001,
									12.109228515625034
								],
								[
									102.43408203125,
									12.179248046875088
								],
								[
									102.34316406250014,
									12.252587890625023
								],
								[
									102.25908203125005,
									12.394335937500031
								],
								[
									102.24843750000002,
									12.361425781250077
								],
								[
									102.22958984375009,
									12.331640625000048
								],
								[
									102.13417968749997,
									12.443017578125094
								],
								[
									102.03437500000018,
									12.53188476562508
								],
								[
									101.94453125000018,
									12.563671875000068
								],
								[
									101.88906250000014,
									12.593261718750057
								],
								[
									101.83574218750005,
									12.640380859375057
								],
								[
									101.72363281250011,
									12.689355468750094
								],
								[
									101.44492187500009,
									12.61894531249996
								],
								[
									101.09023437500014,
									12.673632812500088
								],
								[
									100.9537109375002,
									12.621240234375065
								],
								[
									100.89775390625016,
									12.653808593749957
								],
								[
									100.86328125,
									12.714501953125065
								],
								[
									100.89638671874997,
									12.818164062500045
								],
								[
									100.90390625000009,
									13.034912109374972
								],
								[
									100.94609375000016,
									13.1872558593751
								],
								[
									100.92626953125011,
									13.30302734375006
								],
								[
									100.94697265625007,
									13.35756835937498
								],
								[
									100.96269531250016,
									13.431982421875034
								],
								[
									100.90654296874999,
									13.462402343750114
								],
								[
									100.65605468750005,
									13.521289062500031
								],
								[
									100.60292968750014,
									13.568164062500074
								],
								[
									100.53642578124999,
									13.51445312500006
								],
								[
									100.23564453124999,
									13.484472656250077
								],
								[
									100.12236328125005,
									13.439550781250077
								],
								[
									100.01748046874997,
									13.353173828125065
								],
								[
									99.99052734375016,
									13.243457031250003
								],
								[
									100.05107421875016,
									13.171240234375034
								],
								[
									100.08994140625009,
									13.045654296875028
								],
								[
									99.9820312500002,
									12.771484375000043
								],
								[
									99.96396484375009,
									12.690039062500048
								],
								[
									100.00566406250016,
									12.354736328124957
								],
								[
									99.98906250000016,
									12.170800781249966
								],
								[
									99.93027343750003,
									12.047460937500063
								],
								[
									99.83710937500018,
									11.936621093750034
								],
								[
									99.79873046874997,
									11.748779296875057
								],
								[
									99.72548828124997,
									11.661767578125094
								],
								[
									99.62734374999997,
									11.462890624999986
								],
								[
									99.56132812500005,
									11.215185546875063
								],
								[
									99.51435546875007,
									11.100585937500071
								],
								[
									99.48691406250003,
									10.889550781250065
								],
								[
									99.2847656250002,
									10.569140625000074
								],
								[
									99.23730468750011,
									10.388134765625054
								],
								[
									99.16503906250011,
									10.319824218750085
								],
								[
									99.19033203125014,
									10.265869140625014
								],
								[
									99.19462890625005,
									10.175439453125065
								],
								[
									99.16933593750014,
									9.934179687500034
								],
								[
									99.16074218750003,
									9.734033203125023
								],
								[
									99.19130859375014,
									9.627148437500097
								],
								[
									99.28828125000018,
									9.41459960937496
								],
								[
									99.26503906249997,
									9.35297851562511
								],
								[
									99.25390625000011,
									9.265234375000077
								],
								[
									99.33544921875011,
									9.225439453125063
								],
								[
									99.39384765625005,
									9.213720703125063
								],
								[
									99.72382812500018,
									9.314208984375028
								],
								[
									99.8355468750002,
									9.288378906250003
								],
								[
									99.87753906250003,
									9.194628906250088
								],
								[
									99.90468750000002,
									9.112890625000048
								],
								[
									99.96064453125001,
									8.671240234375034
								],
								[
									99.98955078125016,
									8.58920898437502
								],
								[
									100.05625000000003,
									8.511132812500023
								],
								[
									100.12929687500002,
									8.428076171875063
								],
								[
									100.15410156249999,
									8.442968750000077
								],
								[
									100.15888671875018,
									8.473779296875051
								],
								[
									100.16347656250014,
									8.508398437500077
								],
								[
									100.22871093750001,
									8.42470703125008
								],
								[
									100.27939453125003,
									8.268505859375054
								],
								[
									100.45351562499997,
									7.442285156250051
								],
								[
									100.50371093749999,
									7.337304687500065
								],
								[
									100.54521484374999,
									7.226904296875048
								],
								[
									100.43935546875014,
									7.280761718750085
								],
								[
									100.41074218750009,
									7.464306640625097
								],
								[
									100.38037109375011,
									7.5415039062500995
								],
								[
									100.34296875000001,
									7.552880859375023
								],
								[
									100.28378906250003,
									7.5515136718750995
								],
								[
									100.27998046875018,
									7.584326171875034
								],
								[
									100.32431640625003,
									7.644189453125051
								],
								[
									100.31738281249994,
									7.7159667968749375
								],
								[
									100.25664062500005,
									7.774902343750043
								],
								[
									100.15820312499994,
									7.72812500000002
								],
								[
									100.1607421875002,
									7.599267578124966
								],
								[
									100.20488281250016,
									7.500537109375017
								],
								[
									100.37138671875005,
									7.280126953124963
								],
								[
									100.42353515625018,
									7.1878417968749915
								],
								[
									100.48974609375,
									7.1613769531250995
								],
								[
									100.58623046875005,
									7.175976562500054
								],
								[
									100.70166015625011,
									7.081982421875097
								],
								[
									100.79257812500003,
									6.994677734375074
								],
								[
									101.01787109375005,
									6.860937500000006
								],
								[
									101.15439453125003,
									6.875146484375051
								],
								[
									101.30195312500018,
									6.9083007812500625
								],
								[
									101.40087890625,
									6.899560546875051
								],
								[
									101.49794921875014,
									6.865283203125003
								],
								[
									101.61425781250011,
									6.75395507812506
								],
								[
									101.79921875000014,
									6.474609375000085
								],
								[
									102.10107421875,
									6.242236328125074
								],
								[
									102.068359375,
									6.184667968750077
								],
								[
									102.05517578124994,
									6.096679687500085
								],
								[
									101.93613281250003,
									5.9793457031249915
								],
								[
									101.91718750000018,
									5.911376953125
								],
								[
									101.8736328125002,
									5.825292968750048
								],
								[
									101.79072265625018,
									5.779345703125017
								],
								[
									101.71953125000016,
									5.770605468750091
								],
								[
									101.67841796875007,
									5.778808593750085
								],
								[
									101.6500000000002,
									5.795996093750034
								],
								[
									101.60136718750016,
									5.8771484374999545
								],
								[
									101.5767578125002,
									5.902001953125037
								],
								[
									101.55605468749997,
									5.907763671874974
								],
								[
									101.40419921875014,
									5.851660156250091
								],
								[
									101.25703125000018,
									5.789355468750102
								],
								[
									101.22978515625005,
									5.733691406250031
								],
								[
									101.19062500000007,
									5.6687500000000455
								],
								[
									101.14765625000018,
									5.643066406250043
								],
								[
									101.11396484375018,
									5.636767578125102
								],
								[
									101.08173828125018,
									5.674902343749963
								],
								[
									101.02519531249999,
									5.724511718750037
								],
								[
									100.98164062500001,
									5.771044921875102
								],
								[
									100.99277343750009,
									5.846191406250043
								],
								[
									101.07558593749997,
									5.9564941406249545
								],
								[
									101.08652343750009,
									6.033691406250043
								],
								[
									101.07597656250016,
									6.166064453125017
								],
								[
									101.05351562499999,
									6.242578125000065
								],
								[
									101.02939453125009,
									6.245312499999997
								],
								[
									100.98876953124994,
									6.25766601562502
								],
								[
									100.87392578125002,
									6.245410156250017
								],
								[
									100.81650390625003,
									6.331640625000091
								],
								[
									100.79375000000005,
									6.426171875000065
								],
								[
									100.7544921875002,
									6.460058593750048
								],
								[
									100.71562499999999,
									6.480664062499983
								],
								[
									100.62949218750003,
									6.447998046875071
								],
								[
									100.56386718750002,
									6.467529296874972
								],
								[
									100.34541015625018,
									6.549902343750048
								],
								[
									100.26142578125001,
									6.682714843749935
								],
								[
									100.21660156250005,
									6.68662109375002
								],
								[
									100.17675781250011,
									6.671826171875026
								],
								[
									100.1612304687502,
									6.641601562500085
								],
								[
									100.13798828124999,
									6.488671875000108
								],
								[
									100.119140625,
									6.441992187500091
								],
								[
									99.86865234375011,
									6.749902343750037
								],
								[
									99.69599609375001,
									6.876660156250011
								],
								[
									99.7203125000002,
									7.106201171875057
								],
								[
									99.66777343750016,
									7.1508789062500995
								],
								[
									99.60244140624997,
									7.155322265625031
								],
								[
									99.55302734375005,
									7.218798828125074
								],
								[
									99.59697265624999,
									7.355615234375065
								],
								[
									99.52910156250005,
									7.329492187500065
								],
								[
									99.43515625000009,
									7.334375000000094
								],
								[
									99.35859375000001,
									7.372216796875065
								],
								[
									99.30039062500009,
									7.5613281250000455
								],
								[
									99.26367187499994,
									7.61904296875008
								],
								[
									99.18339843750016,
									7.718066406250102
								],
								[
									99.07763671875,
									7.718066406250102
								],
								[
									99.04267578125007,
									7.7656250000000995
								],
								[
									99.05107421874999,
									7.887841796875051
								],
								[
									98.97392578124999,
									7.962792968749952
								],
								[
									98.87246093750014,
									8.023925781249972
								],
								[
									98.7886718750002,
									8.059814453125
								],
								[
									98.70351562499997,
									8.256738281250065
								],
								[
									98.63632812500003,
									8.305029296875034
								],
								[
									98.57919921875003,
									8.344287109375045
								],
								[
									98.49980468750016,
									8.317822265624983
								],
								[
									98.47402343750014,
									8.24692382812502
								],
								[
									98.42099609375009,
									8.178222656250057
								],
								[
									98.36074218750014,
									8.186962890624969
								],
								[
									98.30546875000016,
									8.226220703125065
								],
								[
									98.23818359375014,
									8.423095703125028
								],
								[
									98.22695312500014,
									8.543652343749983
								],
								[
									98.24179687500003,
									8.767871093750102
								],
								[
									98.32597656250016,
									8.96894531249994
								],
								[
									98.37138671874999,
									9.290527343750085
								],
								[
									98.44316406250016,
									9.49282226562508
								],
								[
									98.49296875000016,
									9.561425781250023
								],
								[
									98.56191406250002,
									9.837499999999963
								],
								[
									98.70253906250014,
									10.190380859375082
								],
								[
									98.71845703125018,
									10.266015625000037
								],
								[
									98.74687500000005,
									10.350830078125085
								],
								[
									98.76835937500016,
									10.430859375000054
								],
								[
									98.77539062499994,
									10.557031250000094
								],
								[
									98.75722656250002,
									10.62358398437506
								],
								[
									98.75722656250002,
									10.660937500000031
								],
								[
									98.78691406249999,
									10.70844726562494
								],
								[
									98.88710937499997,
									10.788330078125043
								],
								[
									99.02539062500011,
									10.919970703125045
								],
								[
									99.19013671875018,
									11.10527343749996
								],
								[
									99.35878906249997,
									11.389453124999946
								],
								[
									99.44267578125005,
									11.554394531250068
								],
								[
									99.47792968750002,
									11.612500000000082
								],
								[
									99.51523437500003,
									11.63066406250006
								],
								[
									99.57285156250009,
									11.687158203125023
								],
								[
									99.61250000000018,
									11.749658203124966
								],
								[
									99.61474609375,
									11.781201171874997
								],
								[
									99.52294921875011,
									12.089648437500045
								],
								[
									99.46289062499994,
									12.190234375000017
								],
								[
									99.43242187500016,
									12.309033203125054
								],
								[
									99.41630859375016,
									12.394824218750045
								],
								[
									99.39423828125018,
									12.473632812500114
								],
								[
									99.40507812499999,
									12.547900390625045
								],
								[
									99.37197265625002,
									12.594238281250071
								],
								[
									99.29736328125,
									12.652880859374946
								],
								[
									99.2198242187502,
									12.739746093750057
								],
								[
									99.17353515625018,
									12.881933593750063
								],
								[
									99.17353515625018,
									12.96132812500008
								],
								[
									99.12392578125002,
									13.030761718750014
								],
								[
									99.10742187500011,
									13.103515625000085
								],
								[
									99.13710937500014,
									13.172998046875037
								],
								[
									99.17617187499997,
									13.233056640625108
								],
								[
									99.17167968750016,
									13.496923828124949
								],
								[
									99.15605468750016,
									13.57578125000002
								],
								[
									99.13681640625003,
									13.716699218750051
								],
								[
									99.08623046875016,
									13.822753906250071
								],
								[
									99.01464843749994,
									13.947167968750108
								],
								[
									98.93359374999994,
									14.049853515624974
								],
								[
									98.72119140625011,
									14.235742187500009
								],
								[
									98.57001953125007,
									14.359912109375074
								],
								[
									98.49501953125014,
									14.4729003906251
								],
								[
									98.40019531249999,
									14.60297851562504
								],
								[
									98.33212890625009,
									14.696484375000082
								],
								[
									98.24599609375014,
									14.814746093750017
								],
								[
									98.2021484375,
									14.975927734374991
								],
								[
									98.17792968750001,
									15.147412109375026
								],
								[
									98.1910156250002,
									15.204101562500028
								],
								[
									98.23222656250016,
									15.241357421875065
								],
								[
									98.28613281250011,
									15.271582031250006
								],
								[
									98.32939453125016,
									15.2785644531251
								],
								[
									98.45214843750011,
									15.357373046875068
								],
								[
									98.53730468750007,
									15.350683593750048
								],
								[
									98.55693359375016,
									15.367675781250043
								],
								[
									98.56523437500016,
									15.403564453125071
								],
								[
									98.55449218749999,
									15.559765625000011
								],
								[
									98.55820312500003,
									15.768603515625102
								],
								[
									98.57402343750016,
									15.938623046875108
								],
								[
									98.59238281250009,
									16.050683593750108
								],
								[
									98.8179687500002,
									16.180810546874966
								],
								[
									98.86552734375005,
									16.237060546875057
								],
								[
									98.88847656249999,
									16.298095703125057
								],
								[
									98.88828125000003,
									16.351904296875006
								],
								[
									98.86933593750018,
									16.39418945312508
								],
								[
									98.83544921875011,
									16.417578125000063
								],
								[
									98.68925781249999,
									16.305419921874943
								],
								[
									98.66074218750003,
									16.330419921874977
								],
								[
									98.59365234374997,
									16.514794921874966
								],
								[
									98.56474609375005,
									16.57094726562505
								],
								[
									98.52314453125018,
									16.63818359374997
								],
								[
									98.47812500000009,
									16.73222656250013
								],
								[
									98.47119140625,
									16.895019531250085
								],
								[
									98.43886718749997,
									16.975683593750063
								],
								[
									98.25654296875007,
									17.14765625000004
								],
								[
									98.17460937500016,
									17.23989257812508
								],
								[
									98.06308593750009,
									17.373291015625085
								],
								[
									97.92929687500009,
									17.53330078125009
								],
								[
									97.79296875000011,
									17.68125000000012
								],
								[
									97.72910156250003,
									17.775830078124926
								],
								[
									97.70644531249997,
									17.797119140625
								],
								[
									97.69853515625016,
									17.83354492187496
								],
								[
									97.73994140625007,
									17.935302734375
								],
								[
									97.71972656250011,
									18.037402343750017
								],
								[
									97.65156250000018,
									18.17373046875008
								],
								[
									97.62246093750002,
									18.258007812499926
								],
								[
									97.63222656250014,
									18.29033203125013
								],
								[
									97.59931640625018,
									18.302978515624943
								],
								[
									97.52382812499997,
									18.295898437500085
								],
								[
									97.4507812500002,
									18.35966796875013
								],
								[
									97.38066406250005,
									18.494287109375108
								],
								[
									97.37392578125002,
									18.51796875000005
								],
								[
									97.3970703125002,
									18.517529296874955
								],
								[
									97.48496093750003,
									18.494238281250006
								],
								[
									97.51513671875,
									18.49775390625001
								],
								[
									97.57734375000007,
									18.528710937500108
								],
								[
									97.67158203125018,
									18.561230468750068
								],
								[
									97.72773437500007,
									18.57202148437503
								],
								[
									97.74589843750005,
									18.58818359374996
								],
								[
									97.75400390625009,
									18.62080078125004
								],
								[
									97.7060546875,
									18.931787109374966
								],
								[
									97.71416015625005,
									18.996484375000108
								],
								[
									97.80390625000001,
									19.13046874999995
								],
								[
									97.79355468750003,
									19.265869140625
								],
								[
									97.81679687499997,
									19.459960937500114
								],
								[
									97.91640625000014,
									19.592871093750006
								],
								[
									97.9912109375,
									19.653710937499966
								],
								[
									98.01503906250014,
									19.749511718749943
								],
								[
									98.04902343750007,
									19.769726562500068
								],
								[
									98.11103515625018,
									19.76215820312504
								],
								[
									98.23906250000005,
									19.690673828124943
								],
								[
									98.29365234375007,
									19.687255859375057
								],
								[
									98.37128906250007,
									19.689160156250068
								],
								[
									98.45498046874997,
									19.69443359375009
								],
								[
									98.49384765625018,
									19.70131835937508
								],
								[
									98.76064453124997,
									19.771093750000063
								],
								[
									98.81953125000018,
									19.77846679687508
								],
								[
									98.87578125000016,
									19.76958007812513
								],
								[
									98.91669921875018,
									19.772900390625097
								],
								[
									98.95800781249994,
									19.80493164062503
								],
								[
									98.98740234375009,
									19.86137695312499
								],
								[
									99.02070312500001,
									20.041796875000074
								],
								[
									99.03974609375018,
									20.07363281250008
								],
								[
									99.07421875000011,
									20.099365234375085
								],
								[
									99.13076171874997,
									20.116601562499937
								],
								[
									99.1968750000002,
									20.115136718749994
								],
								[
									99.28369140624994,
									20.080419921875034
								],
								[
									99.337890625,
									20.07890624999999
								],
								[
									99.39921875000016,
									20.09345703125001
								],
								[
									99.45156250000014,
									20.118310546874937
								],
								[
									99.48593750000003,
									20.149853515625068
								],
								[
									99.50166015625007,
									20.187744140625057
								],
								[
									99.48750000000018,
									20.26064453125008
								],
								[
									99.44794921875001,
									20.352050781249943
								],
								[
									99.45888671875014,
									20.363037109375057
								],
								[
									99.53164062500014,
									20.342822265625017
								],
								[
									99.638671875,
									20.320458984374994
								],
								[
									99.72011718750014,
									20.325439453124943
								],
								[
									99.77333984374997,
									20.341308593750057
								],
								[
									99.82519531249994,
									20.384472656249983
								],
								[
									99.89033203125018,
									20.42441406249995
								],
								[
									99.95429687500018,
									20.41542968750008
								],
								[
									100.00361328125018,
									20.37958984375004
								],
								[
									100.12246093750014,
									20.316650390625114
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "THA",
					"su_a3": "THA",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "THA",
					"gu_a3": "THA",
					"abbrev": "Thai.",
					"region_un": "Asia",
					"adm0_a3_us": "THA",
					"scalerank": 1,
					"pop_est": 65905410,
					"adm0_dif": 0,
					"un_a3": "764",
					"pop_year": -99,
					"gdp_md_est": 547400,
					"name": "Thailand",
					"sovereignt": "Thailand",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Thailand",
					"postal": "TH",
					"sov_a3": "THA",
					"note_brk": "",
					"brk_a3": "THA",
					"wb_a2": "TH",
					"brk_diff": 0,
					"admin": "Thailand",
					"name_long": "Thailand",
					"iso_a3": "THA",
					"iso_a2": "TH",
					"adm0_a3_is": "THA",
					"level": 2,
					"formal_en": "Kingdom of Thailand",
					"name_len": 8,
					"mapcolor7": 3,
					"long_len": 8,
					"mapcolor8": 6,
					"mapcolor9": 8,
					"note_adm0": "",
					"iso_n3": "764",
					"homepart": 1,
					"subunit": "Thailand",
					"name_alt": "",
					"brk_name": "Thailand",
					"name_sort": "Thailand",
					"continent": "Asia",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									53.10957031250001,
									38.80307617187506
								],
								[
									53.100195312500034,
									38.7561523437501
								],
								[
									53.045898437500114,
									38.89721679687506
								],
								[
									53.01855468749994,
									39.05273437500003
								],
								[
									53.053320312500034,
									39.09658203125008
								],
								[
									53.092187500000136,
									39.09409179687509
								],
								[
									53.05517578124994,
									39.037939453125034
								],
								[
									53.10957031250001,
									38.80307617187506
								]
							]
						],
						[
							[
								[
									66.52226562500005,
									37.34848632812509
								],
								[
									66.47187500000013,
									37.34472656250006
								],
								[
									66.35029296875001,
									37.36816406250003
								],
								[
									66.10839843750011,
									37.41474609375001
								],
								[
									65.90068359374999,
									37.50810546875002
								],
								[
									65.76503906250008,
									37.56914062500002
								],
								[
									65.74384765625001,
									37.56083984375002
								],
								[
									65.68300781250014,
									37.51914062500006
								],
								[
									65.64121093750009,
									37.46782226562499
								],
								[
									65.60800781250003,
									37.368408203125085
								],
								[
									65.55498046874999,
									37.2511718750001
								],
								[
									65.30361328125014,
									37.24677734374998
								],
								[
									65.08964843750016,
									37.237939453124966
								],
								[
									64.95156250000008,
									37.19355468749998
								],
								[
									64.81630859375014,
									37.13208007812506
								],
								[
									64.78242187500007,
									37.05927734374998
								],
								[
									64.75312500000007,
									36.96479492187501
								],
								[
									64.67431640625,
									36.75019531249998
								],
								[
									64.60253906250011,
									36.554541015625006
								],
								[
									64.56582031250002,
									36.42758789062506
								],
								[
									64.51103515625005,
									36.340673828125034
								],
								[
									64.35800781250003,
									36.22607421875006
								],
								[
									64.18437499999999,
									36.14892578124997
								],
								[
									64.09218750000008,
									36.11269531250005
								],
								[
									64.05136718750009,
									36.067626953125114
								],
								[
									64.04238281250014,
									36.02509765625007
								],
								[
									64.00966796875014,
									36.01210937500008
								],
								[
									63.938085937500034,
									36.01972656250004
								],
								[
									63.86250000000018,
									36.01235351562502
								],
								[
									63.696582031250045,
									35.96782226562502
								],
								[
									63.516992187500136,
									35.913134765625074
								],
								[
									63.301660156250136,
									35.85839843750003
								],
								[
									63.17890625000018,
									35.858447265625045
								],
								[
									63.129980468750034,
									35.84619140625003
								],
								[
									63.10859375000007,
									35.81870117187512
								],
								[
									63.129980468750034,
									35.76674804687508
								],
								[
									63.150781250000136,
									35.72827148437506
								],
								[
									63.169726562500045,
									35.67812500000008
								],
								[
									63.11933593750001,
									35.63754882812506
								],
								[
									63.08417968750007,
									35.56806640625004
								],
								[
									63.056640625000114,
									35.445800781250085
								],
								[
									62.980273437500045,
									35.409179687500085
								],
								[
									62.85800781250009,
									35.34965820312502
								],
								[
									62.722656250000114,
									35.27133789062506
								],
								[
									62.68808593750009,
									35.2553222656251
								],
								[
									62.610546875000125,
									35.233154296875085
								],
								[
									62.533105468750136,
									35.23989257812505
								],
								[
									62.46289062500006,
									35.25136718750008
								],
								[
									62.386621093750136,
									35.231250000000074
								],
								[
									62.30781250000018,
									35.17080078125011
								],
								[
									62.27119140625018,
									35.18911132812511
								],
								[
									62.252832031250136,
									35.25024414062503
								],
								[
									62.21308593750007,
									35.28994140625002
								],
								[
									62.089648437500045,
									35.37968750000002
								],
								[
									61.98388671875006,
									35.443701171875006
								],
								[
									61.938085937500034,
									35.447900390624966
								],
								[
									61.84101562500007,
									35.431494140625006
								],
								[
									61.7197265625,
									35.41943359375003
								],
								[
									61.620996093750136,
									35.4323242187501
								],
								[
									61.54277343749999,
									35.457861328125034
								],
								[
									61.421777343750136,
									35.54580078125002
								],
								[
									61.377734375000045,
									35.59311523437498
								],
								[
									61.34472656250006,
									35.62949218750012
								],
								[
									61.26201171874999,
									35.619580078124955
								],
								[
									61.23886718750009,
									35.659277343750034
								],
								[
									61.23554687500001,
									35.70556640624997
								],
								[
									61.258691406250136,
									35.76181640624998
								],
								[
									61.25214843750001,
									35.86762695312504
								],
								[
									61.20585937499999,
									35.94370117187509
								],
								[
									61.15292968750009,
									35.97675781250007
								],
								[
									61.15947265625016,
									35.99990234375008
								],
								[
									61.1826171875,
									36.05283203125012
								],
								[
									61.212402343750114,
									36.09912109374994
								],
								[
									61.212011718750034,
									36.190527343750006
								],
								[
									61.17509765625016,
									36.28969726562505
								],
								[
									61.16035156250018,
									36.43271484375006
								],
								[
									61.169921875,
									36.57226562499997
								],
								[
									61.119628906250114,
									36.642578125
								],
								[
									60.70791015625002,
									36.64296875000008
								],
								[
									60.341308593750114,
									36.63764648437507
								],
								[
									60.320703124999966,
									36.653564453125114
								],
								[
									60.178320312500034,
									36.82944335937506
								],
								[
									60.062792968750045,
									36.96289062499997
								],
								[
									59.948632812500136,
									37.04160156250012
								],
								[
									59.68720703125007,
									37.138476562500045
								],
								[
									59.56220703125018,
									37.178906249999926
								],
								[
									59.45498046875002,
									37.25283203125008
								],
								[
									59.36738281250018,
									37.33374023437494
								],
								[
									59.344726562500114,
									37.444726562499994
								],
								[
									59.326953125000045,
									37.481152343749955
								],
								[
									59.30175781249994,
									37.51064453125011
								],
								[
									59.27412109375001,
									37.52373046875002
								],
								[
									59.24082031250009,
									37.52075195312503
								],
								[
									58.93720703125001,
									37.649658203125
								],
								[
									58.815429687500114,
									37.683496093749966
								],
								[
									58.70078125000009,
									37.656250000000085
								],
								[
									58.65019531249999,
									37.65156250000004
								],
								[
									58.55048828125001,
									37.68818359375004
								],
								[
									58.43574218750018,
									37.63852539062495
								],
								[
									58.38671875,
									37.63535156250009
								],
								[
									58.318164062500045,
									37.64721679687494
								],
								[
									58.261621093749966,
									37.6658203125001
								],
								[
									58.10878906250002,
									37.78305664062509
								],
								[
									57.98056640625009,
									37.83046875000005
								],
								[
									57.888183593750114,
									37.86083984374994
								],
								[
									57.71054687500009,
									37.90527343750003
								],
								[
									57.52099609375,
									37.92846679687506
								],
								[
									57.423828125000114,
									37.94770507812507
								],
								[
									57.35371093750001,
									37.97333984375004
								],
								[
									57.33574218749999,
									37.989941406249955
								],
								[
									57.336718750000045,
									38.03291015625001
								],
								[
									57.33144531250002,
									38.08930664062504
								],
								[
									57.30810546874994,
									38.13037109375006
								],
								[
									57.260156250000136,
									38.17958984375005
								],
								[
									57.19355468750018,
									38.21640625000009
								],
								[
									57.07900390625002,
									38.209960937500114
								],
								[
									56.906640624999966,
									38.21303710937502
								],
								[
									56.77460937500018,
									38.25004882812502
								],
								[
									56.669921875,
									38.25664062499993
								],
								[
									56.54404296875009,
									38.249609375000006
								],
								[
									56.44062500000018,
									38.249414062499966
								],
								[
									56.36689453125007,
									38.22250976562509
								],
								[
									56.324121093750136,
									38.1911132812501
								],
								[
									56.296972656250034,
									38.094824218750006
								],
								[
									56.272070312500034,
									38.080419921875006
								],
								[
									56.22880859374999,
									38.073388671874994
								],
								[
									56.17119140625016,
									38.07836914062494
								],
								[
									56.05029296874994,
									38.07753906250005
								],
								[
									55.841308593750114,
									38.094628906249966
								],
								[
									55.57841796874999,
									38.09975585937502
								],
								[
									55.380859375000114,
									38.05112304687506
								],
								[
									55.22470703125009,
									37.98134765625008
								],
								[
									55.075585937499966,
									37.902490234374994
								],
								[
									54.90009765625001,
									37.77792968750012
								],
								[
									54.848632812500114,
									37.72265624999994
								],
								[
									54.74521484375009,
									37.50190429687501
								],
								[
									54.69941406250018,
									37.47016601562501
								],
								[
									54.6396484375,
									37.444726562499994
								],
								[
									54.57890625000016,
									37.44023437499996
								],
								[
									54.45869140625018,
									37.40756835937506
								],
								[
									54.299804687500114,
									37.35361328125009
								],
								[
									54.19160156250018,
									37.33247070312504
								],
								[
									53.91416015625009,
									37.34355468749999
								],
								[
									53.897851562500136,
									37.41357421875003
								],
								[
									53.84785156250007,
									37.669580078124966
								],
								[
									53.82353515625016,
									37.92792968750001
								],
								[
									53.82519531249994,
									38.04692382812493
								],
								[
									53.85410156250009,
									38.28564453125006
								],
								[
									53.85185546875016,
									38.405908203124966
								],
								[
									53.84003906250007,
									38.514941406250074
								],
								[
									53.851562500000114,
									38.62177734374998
								],
								[
									53.87373046875018,
									38.74194335937494
								],
								[
									53.885351562500034,
									38.86406249999996
								],
								[
									53.868652343750114,
									38.949267578125074
								],
								[
									53.814941406250114,
									39.01801757812507
								],
								[
									53.72412109375,
									39.103076171875074
								],
								[
									53.70976562500016,
									39.15341796875012
								],
								[
									53.704589843750114,
									39.209570312500006
								],
								[
									53.617578125000136,
									39.21596679687505
								],
								[
									53.539453125000136,
									39.274072265624994
								],
								[
									53.475000000000136,
									39.30571289062496
								],
								[
									53.336328125000136,
									39.340820312500085
								],
								[
									53.26679687500018,
									39.34262695312512
								],
								[
									53.20332031250001,
									39.316796874999994
								],
								[
									53.15664062500002,
									39.26499023437509
								],
								[
									53.124023437500114,
									39.34667968750006
								],
								[
									53.12480468749999,
									39.43208007812504
								],
								[
									53.235644531250045,
									39.60854492187502
								],
								[
									53.304980468750045,
									39.557080078124926
								],
								[
									53.38964843749994,
									39.536425781250074
								],
								[
									53.49736328125016,
									39.53330078125006
								],
								[
									53.603125000000034,
									39.54697265625009
								],
								[
									53.582421874999966,
									39.60742187500006
								],
								[
									53.53330078125009,
									39.64174804687494
								],
								[
									53.47226562500009,
									39.66879882812495
								],
								[
									53.45048828124999,
									39.74853515625003
								],
								[
									53.45830078124999,
									39.831201171874994
								],
								[
									53.48730468749994,
									39.909374999999926
								],
								[
									53.45429687500018,
									39.940869140624955
								],
								[
									53.40419921875002,
									39.96035156250011
								],
								[
									53.28857421875,
									39.95800781250006
								],
								[
									53.138574218749966,
									39.97866210937511
								],
								[
									52.98750000000001,
									39.987597656250045
								],
								[
									52.952148437500114,
									39.89545898437504
								],
								[
									53.035546875000136,
									39.77441406249997
								],
								[
									52.964843750000114,
									39.83388671875011
								],
								[
									52.898242187500045,
									39.91250000000002
								],
								[
									52.8046875,
									40.054003906250074
								],
								[
									52.74443359375016,
									40.21977539062493
								],
								[
									52.73369140624999,
									40.398730468750074
								],
								[
									52.784765625000034,
									40.54672851562509
								],
								[
									52.84990234375016,
									40.68564453124998
								],
								[
									52.88925781250009,
									40.86347656250007
								],
								[
									52.943457031250034,
									41.038085937500114
								],
								[
									52.997656250000034,
									40.95986328125008
								],
								[
									53.05957031249994,
									40.88974609375009
								],
								[
									53.14521484375018,
									40.82495117187494
								],
								[
									53.191992187500034,
									40.80947265625008
								],
								[
									53.332910156250136,
									40.78271484375003
								],
								[
									53.42363281250016,
									40.79277343749996
								],
								[
									53.520312500000045,
									40.83105468749994
								],
								[
									53.615234375000114,
									40.81850585937505
								],
								[
									53.69375000000002,
									40.74643554687512
								],
								[
									53.76376953125009,
									40.665673828124994
								],
								[
									53.870019531250136,
									40.648681640625
								],
								[
									54.08886718749994,
									40.707080078125074
								],
								[
									54.192968750000034,
									40.720410156249955
								],
								[
									54.283300781250034,
									40.69370117187512
								],
								[
									54.329882812500045,
									40.688769531250074
								],
								[
									54.37734375000002,
									40.69326171874994
								],
								[
									54.33623046875016,
									40.764941406250074
								],
								[
									54.319433593750034,
									40.83457031249995
								],
								[
									54.374414062500136,
									40.87138671874999
								],
								[
									54.54707031250007,
									40.832275390625114
								],
								[
									54.65703125000016,
									40.8583496093751
								],
								[
									54.685058593750114,
									40.87304687499997
								],
								[
									54.710058593750034,
									40.891113281250085
								],
								[
									54.723242187500034,
									40.951269531250006
								],
								[
									54.71796875000007,
									41.012988281250045
								],
								[
									54.70371093750009,
									41.071142578125006
								],
								[
									54.67148437500009,
									41.122167968750006
								],
								[
									54.59218750000002,
									41.19355468749998
								],
								[
									54.284570312500136,
									41.363720703124926
								],
								[
									54.181054687499966,
									41.43159179687498
								],
								[
									54.09482421875009,
									41.51938476562512
								],
								[
									54.03984374999999,
									41.64335937499996
								],
								[
									53.995214843750034,
									41.77255859375009
								],
								[
									53.95380859375007,
									41.86845703124999
								],
								[
									53.84648437500016,
									42.09116210937498
								],
								[
									53.80468749999994,
									42.11762695312504
								],
								[
									53.752343750000136,
									42.12939453124994
								],
								[
									53.624902343750136,
									42.13637695312505
								],
								[
									53.495898437500045,
									42.12016601562493
								],
								[
									53.28496093750016,
									42.08183593750002
								],
								[
									53.164160156250034,
									42.093798828125074
								],
								[
									53.108300781250136,
									42.07006835937494
								],
								[
									52.97001953124999,
									41.97622070312511
								],
								[
									52.90527343749994,
									41.89575195312506
								],
								[
									52.81484375000002,
									41.711816406249966
								],
								[
									52.88349609375007,
									41.65253906250007
								],
								[
									52.882226562499966,
									41.61367187500005
								],
								[
									52.830175781250034,
									41.341894531250006
								],
								[
									52.86181640625,
									41.21005859375006
								],
								[
									52.85039062500016,
									41.20029296875012
								],
								[
									52.825585937499966,
									41.23085937500002
								],
								[
									52.74726562500018,
									41.36542968750001
								],
								[
									52.609375,
									41.52944335937494
								],
								[
									52.49384765625018,
									41.78037109375006
								],
								[
									52.696875000000034,
									41.9443847656251
								],
								[
									52.870507812499966,
									42.06059570312496
								],
								[
									53.01250000000016,
									42.13071289062495
								],
								[
									53.05585937500018,
									42.14775390624996
								],
								[
									53.250097656250034,
									42.205859375000074
								],
								[
									53.50078125000016,
									42.2582519531251
								],
								[
									53.68535156250016,
									42.29687500000006
								],
								[
									53.92636718750009,
									42.32978515625001
								],
								[
									54.00517578125016,
									42.33588867187501
								],
								[
									54.12099609375002,
									42.33520507812506
								],
								[
									54.214941406250034,
									42.30419921874994
								],
								[
									54.271875000000136,
									42.27998046874998
								],
								[
									54.47285156250001,
									42.180175781250085
								],
								[
									54.67792968750007,
									42.078222656250006
								],
								[
									54.85380859374999,
									41.96518554687498
								],
								[
									54.903710937500136,
									41.91909179687508
								],
								[
									54.93164062499994,
									41.86401367187497
								],
								[
									54.95234375000018,
									41.81000976562498
								],
								[
									55.10185546874999,
									41.63872070312499
								],
								[
									55.16230468750007,
									41.5602539062501
								],
								[
									55.24960937500009,
									41.45810546875006
								],
								[
									55.319726562499966,
									41.40839843750007
								],
								[
									55.38837890625001,
									41.34692382812506
								],
								[
									55.43437500000016,
									41.29628906250005
								],
								[
									55.48701171875007,
									41.272265625000045
								],
								[
									55.54521484374999,
									41.26274414062496
								],
								[
									55.67861328125002,
									41.27880859374994
								],
								[
									55.83906250000018,
									41.31079101562497
								],
								[
									55.93496093750002,
									41.32412109374994
								],
								[
									55.977441406250136,
									41.3222167968751
								],
								[
									56.241992187500045,
									41.31083984374999
								],
								[
									56.479882812499966,
									41.30063476562495
								],
								[
									56.77363281250007,
									41.28798828125005
								],
								[
									56.86083984375,
									41.276123046875114
								],
								[
									56.96582031249994,
									41.26513671875
								],
								[
									57.01796875000002,
									41.26347656249993
								],
								[
									57.064257812500045,
									41.307275390624966
								],
								[
									57.094824218750034,
									41.33129882812506
								],
								[
									57.11884765625007,
									41.35029296875004
								],
								[
									57.11386718750009,
									41.37177734375007
								],
								[
									57.07666015625,
									41.38999023437495
								],
								[
									57.018164062500034,
									41.45058593750002
								],
								[
									56.984863281250114,
									41.66933593750011
								],
								[
									56.96406250000007,
									41.85654296875006
								],
								[
									57.033691406250114,
									41.91484374999993
								],
								[
									57.08869356964601,
									41.94395858710328
								],
								[
									57.05341796875001,
									41.77338867187498
								],
								[
									57.06181640624999,
									41.72485351562506
								],
								[
									57.11591796875007,
									41.73134765625002
								],
								[
									57.17441406250009,
									41.73457031249998
								],
								[
									57.24716796875009,
									41.65253906250007
								],
								[
									57.34560546875008,
									41.57324218749997
								],
								[
									57.42958984375002,
									41.57856445312498
								],
								[
									57.52675781250002,
									41.59448242187503
								],
								[
									57.68486328124999,
									41.63618164062501
								],
								[
									57.81777343750008,
									41.69985351562502
								],
								[
									57.86503906249999,
									41.77314453125001
								],
								[
									57.84482421875009,
									41.83784179687507
								],
								[
									57.700292968750034,
									41.91264648437502
								],
								[
									57.682421875000045,
									42.01040039062505
								],
								[
									57.63173828125008,
									42.065527343750006
								],
								[
									57.61308593749999,
									42.10502929687496
								],
								[
									57.62724609374999,
									42.14960937499998
								],
								[
									57.61798562461729,
									42.16289283482149
								],
								[
									57.68613281250009,
									42.16479492187506
								],
								[
									57.81425781250016,
									42.18984375000011
								],
								[
									57.855957031250114,
									42.23105468750006
								],
								[
									57.92343750000009,
									42.33520507812506
								],
								[
									57.94570312500002,
									42.420019531250006
								],
								[
									57.98349609375009,
									42.458789062500074
								],
								[
									58.02890625000009,
									42.48764648437509
								],
								[
									58.07548828125016,
									42.48652343750004
								],
								[
									58.165625000000034,
									42.46157226562494
								],
								[
									58.23408203125007,
									42.447705078124955
								],
								[
									58.28291015625007,
									42.42885742187494
								],
								[
									58.327246093750034,
									42.39892578124997
								],
								[
									58.370507812500136,
									42.346777343750006
								],
								[
									58.37714843750018,
									42.31245117187504
								],
								[
									58.397070312500034,
									42.29248046875006
								],
								[
									58.431445312500045,
									42.29208984375006
								],
								[
									58.457031250000114,
									42.29179687499999
								],
								[
									58.47441406250016,
									42.29936523437493
								],
								[
									58.485839843750114,
									42.31684570312504
								],
								[
									58.476953124999966,
									42.340136718750074
								],
								[
									58.41816406250018,
									42.406689453124955
								],
								[
									58.28867187500009,
									42.52729492187501
								],
								[
									58.2041015625,
									42.57636718750007
								],
								[
									58.162011718750136,
									42.60297851562507
								],
								[
									58.15156250000001,
									42.62807617187494
								],
								[
									58.20644531250002,
									42.666308593750074
								],
								[
									58.259667968750136,
									42.68808593750009
								],
								[
									58.353125000000034,
									42.67172851562495
								],
								[
									58.47714843750009,
									42.662841796875
								],
								[
									58.532324218750034,
									42.681933593750074
								],
								[
									58.58906250000018,
									42.77846679687502
								],
								[
									58.729980468750114,
									42.676171874999966
								],
								[
									58.876953125000114,
									42.561474609374955
								],
								[
									58.93085937500018,
									42.540283203125085
								],
								[
									59.03583984375007,
									42.5281250000001
								],
								[
									59.12314453125009,
									42.523779296875006
								],
								[
									59.159570312500136,
									42.51142578125007
								],
								[
									59.19912109375002,
									42.48168945312506
								],
								[
									59.27656250000018,
									42.356152343749955
								],
								[
									59.35429687499999,
									42.32329101562502
								],
								[
									59.45107421875002,
									42.29951171875007
								],
								[
									59.762597656250136,
									42.30156250000002
								],
								[
									59.85830078125002,
									42.29516601562497
								],
								[
									59.93652343749994,
									42.2360351562501
								],
								[
									59.98515624999999,
									42.21171874999993
								],
								[
									60.00605468750018,
									42.19082031249994
								],
								[
									60.00078124999999,
									42.164746093749955
								],
								[
									59.98164062500018,
									42.13173828125008
								],
								[
									59.97919921875007,
									42.06806640625007
								],
								[
									59.97412109375,
									42.01879882812497
								],
								[
									59.94931640625009,
									41.9954101562501
								],
								[
									59.941796874999966,
									41.973535156249994
								],
								[
									59.96259765625001,
									41.9543945312501
								],
								[
									60.10693359374994,
									41.90742187500001
								],
								[
									60.15556640624999,
									41.85703125000006
								],
								[
									60.19208984375018,
									41.83442382812498
								],
								[
									60.20078125000009,
									41.80312500000008
								],
								[
									60.17636718750009,
									41.78227539062493
								],
								[
									60.10859375000001,
									41.79267578125001
								],
								[
									60.075585937500136,
									41.75966796874994
								],
								[
									60.075585937500136,
									41.70053710937498
								],
								[
									60.12402343749994,
									41.64497070312501
								],
								[
									60.13798828125016,
									41.594140624999966
								],
								[
									60.106054687500034,
									41.545214843750045
								],
								[
									60.068749999999966,
									41.47622070312502
								],
								[
									60.0673828125,
									41.427343750000006
								],
								[
									60.08964843750016,
									41.3994140625
								],
								[
									60.19999999999999,
									41.348974609375034
								],
								[
									60.454980468749966,
									41.221630859374926
								],
								[
									60.51357421875002,
									41.21616210937506
								],
								[
									60.7548828125,
									41.24575195312505
								],
								[
									60.867187500000114,
									41.24868164062494
								],
								[
									60.93320312500009,
									41.229003906250114
								],
								[
									61.11992187499999,
									41.21088867187504
								],
								[
									61.179296875000034,
									41.190576171874994
								],
								[
									61.24238281250018,
									41.189208984375085
								],
								[
									61.328906250000045,
									41.195117187500045
								],
								[
									61.38750000000016,
									41.252148437499926
								],
								[
									61.417382812500136,
									41.26513671875
								],
								[
									61.44365234375016,
									41.27460937500007
								],
								[
									61.496972656249966,
									41.27607421875001
								],
								[
									61.644531250000114,
									41.23984375000009
								],
								[
									61.79990234375009,
									41.16342773437498
								],
								[
									61.90283203125,
									41.09370117187498
								],
								[
									61.95351562500002,
									41.030615234375006
								],
								[
									62.017578125000114,
									40.89379882812503
								],
								[
									62.09501953125016,
									40.68330078125004
								],
								[
									62.188476562500114,
									40.541210937499955
								],
								[
									62.29804687500001,
									40.46748046875004
								],
								[
									62.375,
									40.332080078125074
								],
								[
									62.44160156250007,
									40.03623046875012
								],
								[
									62.48320312499999,
									39.97563476562493
								],
								[
									62.52548828125009,
									39.944091796875085
								],
								[
									62.650683593750045,
									39.858496093750034
								],
								[
									62.90683593750009,
									39.71679687500006
								],
								[
									63.05810546875,
									39.63315429687506
								],
								[
									63.29189453125002,
									39.499511718750085
								],
								[
									63.50605468750001,
									39.37709960937494
								],
								[
									63.72080078125009,
									39.18813476562508
								],
								[
									63.763671875000114,
									39.160546874999966
								],
								[
									63.952539062500136,
									39.058349609375114
								],
								[
									64.16279296875007,
									38.953613281250085
								],
								[
									64.30996093750002,
									38.97729492187503
								],
								[
									64.53164062499997,
									38.816210937500074
								],
								[
									64.62187500000016,
									38.75644531250006
								],
								[
									64.65996093749999,
									38.73603515624998
								],
								[
									64.82070312499997,
									38.672460937500006
								],
								[
									65.07666015625,
									38.539453124999994
								],
								[
									65.39960937500007,
									38.34882812500007
								],
								[
									65.61289062500009,
									38.238574218750074
								],
								[
									65.6708984375,
									38.22573242187494
								],
								[
									65.72851562500011,
									38.226367187500074
								],
								[
									65.79023437500007,
									38.25004882812502
								],
								[
									65.85712890625018,
									38.2687500000001
								],
								[
									65.97119140624994,
									38.24423828124998
								],
								[
									66.09482421875003,
									38.20014648437507
								],
								[
									66.17314453125016,
									38.1666992187501
								],
								[
									66.26367187499994,
									38.11806640625002
								],
								[
									66.33535156250002,
									38.07216796875011
								],
								[
									66.38974609375009,
									38.05092773437502
								],
								[
									66.57451171875016,
									38.01079101562502
								],
								[
									66.60625000000005,
									37.98671875000011
								],
								[
									66.62636718750014,
									37.95986328125005
								],
								[
									66.62929687500002,
									37.932031249999966
								],
								[
									66.52558593750001,
									37.785742187500006
								],
								[
									66.51132812500003,
									37.59916992187502
								],
								[
									66.51064453125002,
									37.4586914062501
								],
								[
									66.52226562500005,
									37.34848632812509
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central Asia",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "TKM",
					"su_a3": "TKM",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "TKM",
					"gu_a3": "TKM",
					"abbrev": "Turkm.",
					"region_un": "Asia",
					"adm0_a3_us": "TKM",
					"scalerank": 1,
					"pop_est": 4884887,
					"adm0_dif": 0,
					"un_a3": "795",
					"pop_year": -99,
					"gdp_md_est": 29780,
					"name": "Turkmenistan",
					"sovereignt": "Turkmenistan",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Turkmenistan",
					"postal": "TM",
					"sov_a3": "TKM",
					"note_brk": "",
					"brk_a3": "TKM",
					"wb_a2": "TM",
					"brk_diff": 0,
					"admin": "Turkmenistan",
					"name_long": "Turkmenistan",
					"iso_a3": "TKM",
					"iso_a2": "TM",
					"adm0_a3_is": "TKM",
					"level": 2,
					"formal_en": "Turkmenistan",
					"name_len": 12,
					"mapcolor7": 3,
					"long_len": 12,
					"mapcolor8": 2,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "795",
					"homepart": 1,
					"subunit": "Turkmenistan",
					"name_alt": "",
					"brk_name": "Turkmenistan",
					"name_sort": "Turkmenistan",
					"continent": "Asia",
					"mapcolor13": 9,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 1995
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									10.957617187500063,
									33.72207031250008
								],
								[
									10.93134765625004,
									33.71743164062502
								],
								[
									10.88300781250004,
									33.690185546875085
								],
								[
									10.857421875,
									33.687158203124994
								],
								[
									10.784765625000034,
									33.717675781249994
								],
								[
									10.757031250000068,
									33.717480468749955
								],
								[
									10.722070312500051,
									33.738916015624966
								],
								[
									10.733886718750057,
									33.85561523437494
								],
								[
									10.745214843750034,
									33.888671875000114
								],
								[
									10.921972656250006,
									33.893115234375045
								],
								[
									11.017871093749989,
									33.823339843750034
								],
								[
									11.033593749999994,
									33.805029296875034
								],
								[
									11.037597656250028,
									33.78505859375005
								],
								[
									10.993066406249994,
									33.74594726562498
								],
								[
									10.957617187500063,
									33.72207031250008
								]
							]
						],
						[
							[
								[
									11.278027343750068,
									34.753808593749966
								],
								[
									11.123632812500034,
									34.68168945312502
								],
								[
									11.153027343749983,
									34.74458007812504
								],
								[
									11.254882812500057,
									34.820312500000114
								],
								[
									11.281054687500045,
									34.80219726562504
								],
								[
									11.278027343750068,
									34.753808593749966
								]
							]
						],
						[
							[
								[
									11.50458984375004,
									33.1819335937501
								],
								[
									11.502441406250028,
									33.15556640624996
								],
								[
									11.467187500000051,
									32.96572265625011
								],
								[
									11.459179687500011,
									32.89736328125002
								],
								[
									11.453906250000017,
									32.7816894531251
								],
								[
									11.453906250000017,
									32.642578125000085
								],
								[
									11.533789062500034,
									32.52495117187502
								],
								[
									11.535937500000017,
									32.47333984375007
								],
								[
									11.504980468750034,
									32.41367187500009
								],
								[
									11.358007812500006,
									32.345214843750085
								],
								[
									11.168261718750074,
									32.256738281249994
								],
								[
									11.005175781250074,
									32.17270507812509
								],
								[
									10.826367187500068,
									32.080664062500006
								],
								[
									10.771582031250006,
									32.02119140625007
								],
								[
									10.68300781250008,
									31.97539062499996
								],
								[
									10.608886718749972,
									31.929541015625034
								],
								[
									10.595507812500017,
									31.885742187500085
								],
								[
									10.543652343750011,
									31.802539062500102
								],
								[
									10.47578125000004,
									31.73603515625004
								],
								[
									10.306054687500023,
									31.704833984375
								],
								[
									10.274609375000011,
									31.684960937500023
								],
								[
									10.195996093750068,
									31.585107421875023
								],
								[
									10.159863281250068,
									31.545800781250023
								],
								[
									10.114941406250068,
									31.46376953125008
								],
								[
									10.172656250000017,
									31.250976562500085
								],
								[
									10.24335937500004,
									31.032128906249994
								],
								[
									10.257031250000068,
									30.94082031250005
								],
								[
									10.25605468750004,
									30.86494140625004
								],
								[
									10.216406250000063,
									30.783203125
								],
								[
									10.1259765625,
									30.66596679687501
								],
								[
									10.059765625000011,
									30.580078125
								],
								[
									9.932519531250023,
									30.425341796875017
								],
								[
									9.895019531250028,
									30.38730468750009
								],
								[
									9.807421875000045,
									30.34223632812504
								],
								[
									9.637988281250074,
									30.282324218750006
								],
								[
									9.51875000000004,
									30.229394531249966
								],
								[
									9.4580078125,
									30.465380859375074
								],
								[
									9.406054687500074,
									30.666796875000074
								],
								[
									9.363281250000057,
									30.832910156249994
								],
								[
									9.287890625000074,
									31.125341796874977
								],
								[
									9.224023437500023,
									31.373681640625023
								],
								[
									9.160253906250006,
									31.62133789062503
								],
								[
									9.102343750000017,
									31.84614257812501
								],
								[
									9.044042968750034,
									32.07236328125009
								],
								[
									9.01894531250008,
									32.10537109375005
								],
								[
									8.844042968750074,
									32.21210937500004
								],
								[
									8.682910156250017,
									32.31044921875011
								],
								[
									8.515136718750028,
									32.42231445312507
								],
								[
									8.333398437500023,
									32.543603515624994
								],
								[
									8.304199218750028,
									32.696289062500114
								],
								[
									8.210937500000057,
									32.92670898437507
								],
								[
									8.112500000000068,
									33.055322265624966
								],
								[
									8.075585937499994,
									33.08906250000001
								],
								[
									7.877246093750017,
									33.17211914062506
								],
								[
									7.762695312500028,
									33.23310546875004
								],
								[
									7.731347656250051,
									33.26850585937507
								],
								[
									7.70917968750004,
									33.362304687500085
								],
								[
									7.627539062500034,
									33.54863281250002
								],
								[
									7.534375000000068,
									33.71791992187505
								],
								[
									7.500195312500011,
									33.83247070312501
								],
								[
									7.495605468750057,
									33.97651367187507
								],
								[
									7.51386718750004,
									34.08051757812501
								],
								[
									7.554492187500074,
									34.12500000000003
								],
								[
									7.74853515625,
									34.25449218750012
								],
								[
									7.838281250000051,
									34.410302734374966
								],
								[
									7.949414062500068,
									34.46870117187507
								],
								[
									8.045605468750011,
									34.51269531250006
								],
								[
									8.12343750000008,
									34.5639160156251
								],
								[
									8.19277343750008,
									34.646289062500074
								],
								[
									8.24560546875,
									34.73408203125004
								],
								[
									8.254687500000074,
									34.82895507812509
								],
								[
									8.276855468750057,
									34.97949218750003
								],
								[
									8.312109375000063,
									35.08461914062502
								],
								[
									8.394238281249983,
									35.203857421875085
								],
								[
									8.35986328125,
									35.29960937499996
								],
								[
									8.316406250000028,
									35.403125000000074
								],
								[
									8.329003906250023,
									35.58222656249998
								],
								[
									8.318066406250011,
									35.65493164062505
								],
								[
									8.28291015625004,
									35.71928710937502
								],
								[
									8.247070312500028,
									35.801806640625045
								],
								[
									8.245703125000034,
									35.87055664062501
								],
								[
									8.280273437500057,
									36.0509765625001
								],
								[
									8.306738281250034,
									36.1887695312501
								],
								[
									8.348730468750063,
									36.3679687500001
								],
								[
									8.333984375000057,
									36.41816406250001
								],
								[
									8.302734375,
									36.45561523437502
								],
								[
									8.208789062500045,
									36.49511718749997
								],
								[
									8.207617187499977,
									36.51894531250002
								],
								[
									8.230761718749989,
									36.54526367187498
								],
								[
									8.369628906250057,
									36.63251953125007
								],
								[
									8.444238281250051,
									36.7607421875
								],
								[
									8.50673828125008,
									36.78750000000002
								],
								[
									8.601269531250068,
									36.83393554687507
								],
								[
									8.597656250000057,
									36.883886718750034
								],
								[
									8.576562500000023,
									36.93720703124998
								],
								[
									8.823535156250045,
									36.99760742187502
								],
								[
									9.058886718750045,
									37.155859375000034
								],
								[
									9.141992187500023,
									37.19462890624993
								],
								[
									9.687988281250057,
									37.34038085937496
								],
								[
									9.758886718750006,
									37.33027343750004
								],
								[
									9.838476562500063,
									37.30898437500005
								],
								[
									9.815527343750006,
									37.254638671875085
								],
								[
									9.783984375000074,
									37.21142578125006
								],
								[
									9.830273437499983,
									37.13535156250012
								],
								[
									9.896386718750051,
									37.18164062500003
								],
								[
									9.879394531250057,
									37.2128417968751
								],
								[
									9.875585937499977,
									37.25415039062506
								],
								[
									9.988085937500074,
									37.25776367187501
								],
								[
									10.087402343750057,
									37.25126953125002
								],
								[
									10.196386718750063,
									37.2058593750001
								],
								[
									10.188769531250017,
									37.033886718749955
								],
								[
									10.334082031250034,
									36.86538085937508
								],
								[
									10.293261718750074,
									36.78149414062506
								],
								[
									10.412304687499983,
									36.73183593750005
								],
								[
									10.518164062500063,
									36.79135742187512
								],
								[
									10.571289062500057,
									36.87944335937493
								],
								[
									10.766210937500063,
									36.93027343750009
								],
								[
									10.95136718750004,
									37.05927734374998
								],
								[
									11.05390625000004,
									37.072509765625114
								],
								[
									11.077050781250051,
									36.96669921875005
								],
								[
									11.12666015625004,
									36.874072265625074
								],
								[
									11.056542968750051,
									36.84145507812511
								],
								[
									10.967187500000051,
									36.743017578125034
								],
								[
									10.798144531249989,
									36.493115234374926
								],
								[
									10.642382812500045,
									36.41962890625004
								],
								[
									10.525683593749989,
									36.32333984374998
								],
								[
									10.48798828125004,
									36.25488281249997
								],
								[
									10.476562500000028,
									36.17514648437498
								],
								[
									10.505761718750023,
									36.03242187500004
								],
								[
									10.590820312500028,
									35.887255859375045
								],
								[
									10.688964843750057,
									35.799511718749926
								],
								[
									10.783691406249972,
									35.77207031250012
								],
								[
									11.00429687500008,
									35.63383789062502
								],
								[
									11.00068359375004,
									35.55161132812506
								],
								[
									11.031542968750017,
									35.45385742187494
								],
								[
									11.043261718750017,
									35.335107421874994
								],
								[
									11.120117187500028,
									35.240283203125045
								],
								[
									10.955859375000074,
									35.033642578124955
								],
								[
									10.8662109375,
									34.884326171875074
								],
								[
									10.69091796875,
									34.67846679687506
								],
								[
									10.534863281250011,
									34.5447265625001
								],
								[
									10.200390625000068,
									34.34604492187512
								],
								[
									10.118359375000068,
									34.280078125000074
								],
								[
									10.06484375000008,
									34.2116210937501
								],
								[
									10.0400390625,
									34.14033203125004
								],
								[
									10.049023437500068,
									34.056298828124966
								],
								[
									10.158984375000074,
									33.85004882812504
								],
								[
									10.305273437500034,
									33.72827148437503
								],
								[
									10.454296875000011,
									33.66250000000002
								],
								[
									10.713183593750017,
									33.68901367187493
								],
								[
									10.704296875000068,
									33.60966796874993
								],
								[
									10.722753906250006,
									33.51440429687497
								],
								[
									10.828125000000057,
									33.51889648437509
								],
								[
									10.8984375,
									33.533691406250085
								],
								[
									10.958007812500057,
									33.62631835937495
								],
								[
									11.084570312500006,
									33.562890624999994
								],
								[
									11.150292968750051,
									33.36923828124998
								],
								[
									11.257421875000034,
									33.308837890625114
								],
								[
									11.269921874999994,
									33.286328124999955
								],
								[
									11.23212890625004,
									33.27158203124998
								],
								[
									11.202636718749972,
									33.24921875000004
								],
								[
									11.234277343750023,
									33.23359375000004
								],
								[
									11.33808593750004,
									33.20947265625003
								],
								[
									11.400585937500068,
									33.224902343750045
								],
								[
									11.50458984375004,
									33.1819335937501
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern Africa",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "TUN",
					"su_a3": "TUN",
					"brk_group": "",
					"region_wb": "Middle East & North Africa",
					"wb_a3": "TUN",
					"gu_a3": "TUN",
					"abbrev": "Tun.",
					"region_un": "Africa",
					"adm0_a3_us": "TUN",
					"scalerank": 1,
					"pop_est": 10486339,
					"adm0_dif": 0,
					"un_a3": "788",
					"pop_year": -99,
					"gdp_md_est": 81710,
					"name": "Tunisia",
					"sovereignt": "Tunisia",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Tunisia",
					"postal": "TN",
					"sov_a3": "TUN",
					"note_brk": "",
					"brk_a3": "TUN",
					"wb_a2": "TN",
					"brk_diff": 0,
					"admin": "Tunisia",
					"name_long": "Tunisia",
					"iso_a3": "TUN",
					"iso_a2": "TN",
					"adm0_a3_is": "TUN",
					"level": 2,
					"formal_en": "Republic of Tunisia",
					"name_len": 7,
					"mapcolor7": 4,
					"long_len": 7,
					"mapcolor8": 3,
					"mapcolor9": 3,
					"note_adm0": "",
					"iso_n3": "788",
					"homepart": 1,
					"subunit": "Tunisia",
					"name_alt": "",
					"brk_name": "Tunisia",
					"name_sort": "Tunisia",
					"continent": "Africa",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2004
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									25.970019531250045,
									40.13632812499998
								],
								[
									25.740234375000057,
									40.10546875
								],
								[
									25.6689453125,
									40.13588867187508
								],
								[
									25.74091796875001,
									40.19628906249994
								],
								[
									25.874804687500017,
									40.23369140625002
								],
								[
									25.918359374999994,
									40.2379882812501
								],
								[
									25.977050781250057,
									40.17783203125009
								],
								[
									25.970019531250045,
									40.13632812499998
								]
							]
						],
						[
							[
								[
									41.510058593750045,
									41.51748046875008
								],
								[
									41.576562500000136,
									41.49731445312506
								],
								[
									41.701757812500034,
									41.47158203125005
								],
								[
									41.779394531250034,
									41.440527343750034
								],
								[
									41.823535156250045,
									41.43237304687506
								],
								[
									41.925781250000114,
									41.495654296875074
								],
								[
									42.07773437500009,
									41.49409179687501
								],
								[
									42.21113281250018,
									41.48671875000002
								],
								[
									42.27998046875007,
									41.47500000000002
								],
								[
									42.364355468750034,
									41.45400390625002
								],
								[
									42.466406250000034,
									41.43984375000008
								],
								[
									42.507910156250034,
									41.470068359375006
								],
								[
									42.5673828125,
									41.55927734375007
								],
								[
									42.59042968750009,
									41.570703124999994
								],
								[
									42.606835937500136,
									41.57880859375004
								],
								[
									42.682421875000045,
									41.585742187500045
								],
								[
									42.75410156250001,
									41.578906250000074
								],
								[
									42.787890625000045,
									41.563720703125085
								],
								[
									42.821679687500136,
									41.49238281250001
								],
								[
									42.906738281250114,
									41.466845703125074
								],
								[
									43.057128906250114,
									41.35283203125002
								],
								[
									43.14902343750009,
									41.30712890625003
								],
								[
									43.17128906250002,
									41.287939453125034
								],
								[
									43.14101562500008,
									41.26484375000004
								],
								[
									43.15283203125,
									41.23642578125009
								],
								[
									43.205468750000136,
									41.19916992187507
								],
								[
									43.279296875,
									41.185205078124966
								],
								[
									43.358984375000034,
									41.1901367187501
								],
								[
									43.402343750000114,
									41.17656249999999
								],
								[
									43.433398437500045,
									41.15551757812506
								],
								[
									43.44160156250001,
									41.125976562500085
								],
								[
									43.439453125000114,
									41.10712890625004
								],
								[
									43.45527343750007,
									41.06469726562503
								],
								[
									43.517480468750136,
									41.0048339843751
								],
								[
									43.591699218750136,
									40.9682128906251
								],
								[
									43.63164062499999,
									40.9290039062501
								],
								[
									43.69648437500018,
									40.79414062500007
								],
								[
									43.72265625,
									40.71953124999996
								],
								[
									43.71289062499994,
									40.64775390624999
								],
								[
									43.66787109375002,
									40.57407226562509
								],
								[
									43.569335937500114,
									40.482373046874955
								],
								[
									43.593750000000114,
									40.44404296875007
								],
								[
									43.61582031250009,
									40.39331054687503
								],
								[
									43.6083984375,
									40.35659179687508
								],
								[
									43.678124999999966,
									40.2393066406251
								],
								[
									43.709863281250136,
									40.16650390625
								],
								[
									43.68330078125007,
									40.14965820312494
								],
								[
									43.66621093750001,
									40.126367187499994
								],
								[
									43.79169921875001,
									40.07026367187501
								],
								[
									43.94199218750009,
									40.023144531249926
								],
								[
									44.005371093750114,
									40.014111328124955
								],
								[
									44.178027343750045,
									40.035742187500006
								],
								[
									44.28925781250007,
									40.04038085937498
								],
								[
									44.39960937500007,
									39.99575195312494
								],
								[
									44.560449218750136,
									39.88759765624994
								],
								[
									44.73378906250002,
									39.746484374999966
								],
								[
									44.76826171875001,
									39.70351562500008
								],
								[
									44.78339843750018,
									39.68466796874998
								],
								[
									44.817187500000045,
									39.65043945312493
								],
								[
									44.78212890625002,
									39.65107421875007
								],
								[
									44.72500000000002,
									39.681738281250006
								],
								[
									44.58710937500007,
									39.768554687500114
								],
								[
									44.516699218750034,
									39.731250000000045
								],
								[
									44.455957031249966,
									39.66674804687497
								],
								[
									44.38935546875018,
									39.42211914062506
								],
								[
									44.33544921874994,
									39.396044921875074
								],
								[
									44.24042968750007,
									39.396777343750045
								],
								[
									44.12402343749994,
									39.40522460937498
								],
								[
									44.0439453125,
									39.39296875000005
								],
								[
									44.023242187500045,
									39.377441406250085
								],
								[
									44.033789062500034,
									39.351025390624955
								],
								[
									44.05751953125002,
									39.31083984375002
								],
								[
									44.074316406250034,
									39.25996093750007
								],
								[
									44.07910156249994,
									39.2183105468751
								],
								[
									44.12128906250001,
									39.18061523437507
								],
								[
									44.178027343750045,
									39.14482421874996
								],
								[
									44.18056640625002,
									39.10805664062502
								],
								[
									44.171875000000114,
									39.056250000000034
								],
								[
									44.158789062500034,
									39.01674804687508
								],
								[
									44.14453124999994,
									38.99438476562503
								],
								[
									44.170800781249966,
									38.934375000000074
								],
								[
									44.232421875000114,
									38.86323242187507
								],
								[
									44.27167968750001,
									38.83603515625012
								],
								[
									44.25703125000007,
									38.70063476562507
								],
								[
									44.280175781249966,
									38.64067382812502
								],
								[
									44.297851562500114,
									38.55781250000001
								],
								[
									44.29082031249999,
									38.420117187499926
								],
								[
									44.29853515625018,
									38.38627929687496
								],
								[
									44.31962890624999,
									38.37470703125001
								],
								[
									44.37578124999999,
									38.36958007812504
								],
								[
									44.43085937500001,
									38.35678710937509
								],
								[
									44.44990234375018,
									38.334228515625114
								],
								[
									44.449609375000136,
									38.31777343750005
								],
								[
									44.38085937499994,
									38.254589843749955
								],
								[
									44.37275390625018,
									38.20971679687506
								],
								[
									44.348925781250045,
									38.14648437500006
								],
								[
									44.32939453125016,
									38.10927734375002
								],
								[
									44.267968749999966,
									38.03881835937506
								],
								[
									44.22890625000002,
									37.96718749999994
								],
								[
									44.211328124999966,
									37.90805664062506
								],
								[
									44.222949218750045,
									37.880175781250074
								],
								[
									44.336230468750045,
									37.871777343749955
								],
								[
									44.397753906250045,
									37.829248046874994
								],
								[
									44.56123046875001,
									37.744628906250085
								],
								[
									44.589941406250034,
									37.71035156250002
								],
								[
									44.545312499999966,
									37.658154296874955
								],
								[
									44.54609375000007,
									37.63632812499995
								],
								[
									44.56718749999999,
									37.608642578125085
								],
								[
									44.5771484375,
									37.56020507812508
								],
								[
									44.573144531249966,
									37.506396484375045
								],
								[
									44.57402343750016,
									37.435400390625034
								],
								[
									44.604101562500034,
									37.42373046875008
								],
								[
									44.715136718750045,
									37.3571289062501
								],
								[
									44.79414062500007,
									37.29038085937509
								],
								[
									44.796777343750136,
									37.26977539062506
								],
								[
									44.758300781250114,
									37.217089843750074
								],
								[
									44.766699218750034,
									37.15634765624995
								],
								[
									44.765136718750114,
									37.142431640625034
								],
								[
									44.73095703125006,
									37.165283203125085
								],
								[
									44.669335937500136,
									37.173583984375
								],
								[
									44.60595703125,
									37.17602539062506
								],
								[
									44.566015625000034,
									37.158251953125074
								],
								[
									44.49599609375008,
									37.11054687500004
								],
								[
									44.40195312500009,
									37.058496093749994
								],
								[
									44.32558593750008,
									37.01074218750003
								],
								[
									44.281835937500034,
									36.97802734375003
								],
								[
									44.245703125000034,
									36.98330078125005
								],
								[
									44.21748046875018,
									37.01186523437508
								],
								[
									44.20166015625006,
									37.051806640625045
								],
								[
									44.20839843750002,
									37.20263671875006
								],
								[
									44.19179687500008,
									37.24985351562509
								],
								[
									44.15625000000006,
									37.282958984375085
								],
								[
									44.11445312500007,
									37.30185546875012
								],
								[
									44.06464843750001,
									37.31245117187504
								],
								[
									44.013183593750114,
									37.313525390625074
								],
								[
									43.940039062500034,
									37.26928710937506
								],
								[
									43.83642578125,
									37.22353515625005
								],
								[
									43.675781250000114,
									37.22724609375001
								],
								[
									43.56796875000009,
									37.23583984375006
								],
								[
									43.51582031250001,
									37.24453125000005
								],
								[
									43.30673828125009,
									37.31464843750004
								],
								[
									43.26308593750008,
									37.31650390624998
								],
								[
									43.18515625000009,
									37.34487304687508
								],
								[
									43.09248046875001,
									37.36738281250004
								],
								[
									42.93662109375009,
									37.324755859375074
								],
								[
									42.869140625000114,
									37.3349121093751
								],
								[
									42.77460937500001,
									37.371875000000074
								],
								[
									42.741113281250136,
									37.36191406250009
								],
								[
									42.63544921875007,
									37.24926757812506
								],
								[
									42.45585937499999,
									37.1287109375001
								],
								[
									42.35898437500009,
									37.10859374999998
								],
								[
									42.31289062500002,
									37.229589843750034
								],
								[
									42.26855468750006,
									37.27656250000001
								],
								[
									42.247558593750114,
									37.282226562500114
								],
								[
									42.202734375000034,
									37.297265624999966
								],
								[
									42.167871093750136,
									37.28862304687499
								],
								[
									42.059863281250045,
									37.20605468750003
								],
								[
									41.88681640625009,
									37.15639648437505
								],
								[
									41.743554687500136,
									37.12612304687511
								],
								[
									41.515527343750136,
									37.08916015625002
								],
								[
									41.33955078125007,
									37.070800781250114
								],
								[
									41.2646484375,
									37.069335937500085
								],
								[
									41.10214843750009,
									37.08588867187498
								],
								[
									40.958886718750136,
									37.10917968750002
								],
								[
									40.81562500000018,
									37.108154296875085
								],
								[
									40.705664062500034,
									37.09770507812499
								],
								[
									40.45039062500007,
									37.00888671875012
								],
								[
									40.01640625000016,
									36.82607421875008
								],
								[
									39.6865234375,
									36.73862304687512
								],
								[
									39.50146484375006,
									36.70224609375006
								],
								[
									39.35664062500001,
									36.68159179687504
								],
								[
									39.1083984375,
									36.68056640625011
								],
								[
									38.90644531250007,
									36.694677734375034
								],
								[
									38.7666015625,
									36.693115234375085
								],
								[
									38.688867187500136,
									36.71508789062503
								],
								[
									38.578027343750136,
									36.7891113281251
								],
								[
									38.443750000000136,
									36.86225585937498
								],
								[
									38.38398437500001,
									36.87924804687506
								],
								[
									38.30585937500007,
									36.89335937500002
								],
								[
									38.19169921874999,
									36.9015625000001
								],
								[
									37.906640625000136,
									36.79462890625007
								],
								[
									37.81796875000009,
									36.76557617187501
								],
								[
									37.72031250000009,
									36.74370117187499
								],
								[
									37.523535156250034,
									36.67832031250009
								],
								[
									37.43632812500016,
									36.64331054687497
								],
								[
									37.32705078125008,
									36.64658203125009
								],
								[
									37.187402343750136,
									36.65590820312505
								],
								[
									37.06621093750016,
									36.6526367187501
								],
								[
									36.985351562500114,
									36.702392578125114
								],
								[
									36.94179687500002,
									36.75839843750006
								],
								[
									36.77656250000001,
									36.79267578125001
								],
								[
									36.658593750000136,
									36.80253906249999
								],
								[
									36.628417968750114,
									36.77768554687509
								],
								[
									36.59687500000007,
									36.70136718749998
								],
								[
									36.5466796875001,
									36.50634765625006
								],
								[
									36.53750000000008,
									36.45742187500002
								],
								[
									36.64140624999999,
									36.263525390625034
								],
								[
									36.63671875000006,
									36.23398437499998
								],
								[
									36.56240234375008,
									36.223925781250074
								],
								[
									36.477050781250114,
									36.22070312500003
								],
								[
									36.42148437500009,
									36.20346679687498
								],
								[
									36.37539062500008,
									36.17124023437506
								],
								[
									36.34755859375002,
									36.003515625000006
								],
								[
									36.248828125000045,
									35.972705078125045
								],
								[
									36.20195312499999,
									35.937548828125074
								],
								[
									36.153613281250045,
									35.83388671875008
								],
								[
									36.12734375000002,
									35.83144531250005
								],
								[
									35.96757812500016,
									35.91005859375008
								],
								[
									35.89267578125009,
									35.916552734375045
								],
								[
									35.95693359375002,
									35.99814453124998
								],
								[
									35.88710937500002,
									36.159082031249994
								],
								[
									35.810937500000136,
									36.309863281250074
								],
								[
									35.882812500000114,
									36.406347656250006
								],
								[
									36.03173828125,
									36.522705078125
								],
								[
									36.188476562500114,
									36.65898437499996
								],
								[
									36.18818359375007,
									36.74306640625005
								],
								[
									36.18007812500002,
									36.80722656250006
								],
								[
									36.13515625000002,
									36.851611328125045
								],
								[
									36.048925781250034,
									36.91059570312507
								],
								[
									35.90458984374999,
									36.84760742187501
								],
								[
									35.80156250000016,
									36.77807617187506
								],
								[
									35.734277343750136,
									36.763964843750045
								],
								[
									35.66113281249994,
									36.724316406249955
								],
								[
									35.62558593750009,
									36.65278320312504
								],
								[
									35.53740234375016,
									36.59702148437495
								],
								[
									35.39316406250009,
									36.57519531249994
								],
								[
									35.176171875000136,
									36.63486328125012
								],
								[
									34.94316406250016,
									36.72568359375006
								],
								[
									34.81123046875001,
									36.79926757812504
								],
								[
									34.703613281250114,
									36.816796874999966
								],
								[
									34.60136718750016,
									36.784472656250045
								],
								[
									34.29960937500016,
									36.6041992187501
								],
								[
									34.023437500000114,
									36.34077148437507
								],
								[
									33.95488281249999,
									36.29521484374993
								],
								[
									33.69472656250002,
									36.18198242187495
								],
								[
									33.52275390625016,
									36.14399414062504
								],
								[
									33.44179687500002,
									36.15283203125006
								],
								[
									33.099511718749966,
									36.10297851562501
								],
								[
									32.92949218749999,
									36.09570312500006
								],
								[
									32.79482421875002,
									36.03588867187494
								],
								[
									32.533789062500034,
									36.10073242187511
								],
								[
									32.377734375000045,
									36.18364257812493
								],
								[
									32.28378906250009,
									36.267871093750045
								],
								[
									32.13056640625001,
									36.44912109375002
								],
								[
									32.021972656250114,
									36.535302734374994
								],
								[
									31.777929687500034,
									36.61279296874997
								],
								[
									31.3525390625,
									36.80107421874996
								],
								[
									31.240625000000023,
									36.82172851562507
								],
								[
									30.95029296875009,
									36.848681640625074
								],
								[
									30.644042968749943,
									36.86567382812507
								],
								[
									30.582031249999943,
									36.79716796874996
								],
								[
									30.558496093750136,
									36.525830078124926
								],
								[
									30.506054687500182,
									36.45112304687498
								],
								[
									30.483593750000068,
									36.310400390625006
								],
								[
									30.44609375000016,
									36.269873046875006
								],
								[
									30.38730468750009,
									36.243261718750006
								],
								[
									30.295410156250114,
									36.28769531250009
								],
								[
									30.231640625000068,
									36.3073242187501
								],
								[
									30.08320312500001,
									36.249365234375006
								],
								[
									29.789257812500182,
									36.16806640625006
								],
								[
									29.689062500000034,
									36.156689453124955
								],
								[
									29.348339843750068,
									36.258837890625074
								],
								[
									29.223632812499943,
									36.32446289062503
								],
								[
									29.14326171875001,
									36.397216796875114
								],
								[
									29.11611328125008,
									36.520117187500006
								],
								[
									29.065527343750006,
									36.59008789062506
								],
								[
									29.05810546875,
									36.63813476562498
								],
								[
									29.03828125000004,
									36.69345703125006
								],
								[
									28.96962890625008,
									36.715332031250085
								],
								[
									28.89589843750008,
									36.673583984375085
								],
								[
									28.816894531250057,
									36.67529296875
								],
								[
									28.717675781249994,
									36.70087890625007
								],
								[
									28.48359375000001,
									36.80380859374998
								],
								[
									28.303710937500057,
									36.811962890624955
								],
								[
									28.195605468750045,
									36.68632812500002
								],
								[
									28.111523437500068,
									36.64638671875005
								],
								[
									28.01943359375005,
									36.63447265625004
								],
								[
									28.01416015625003,
									36.670214843750045
								],
								[
									28.083984375000057,
									36.75146484374997
								],
								[
									27.803808593749977,
									36.73647460937494
								],
								[
									27.655859375000034,
									36.674609375000045
								],
								[
									27.54042968750005,
									36.68422851562505
								],
								[
									27.453906250000017,
									36.71215820312506
								],
								[
									27.466894531250006,
									36.746337890625
								],
								[
									27.55468750000003,
									36.75888671874998
								],
								[
									27.630859375,
									36.786669921875045
								],
								[
									27.93447265625005,
									36.80927734375004
								],
								[
									28.00537109375003,
									36.83198242187504
								],
								[
									28.08300781250003,
									36.92026367187509
								],
								[
									28.224414062500045,
									36.99638671874996
								],
								[
									28.242382812500068,
									37.02905273437503
								],
								[
									28.13369140625005,
									37.029492187499955
								],
								[
									27.668359375000023,
									37.00742187500006
								],
								[
									27.348925781250045,
									37.019580078125074
								],
								[
									27.311035156250057,
									36.98188476562501
								],
								[
									27.262988281250017,
									36.9765625
								],
								[
									27.249707031249983,
									37.079150390625045
								],
								[
									27.30019531250005,
									37.12685546875008
								],
								[
									27.368164062500057,
									37.12241210937506
								],
								[
									27.535058593750023,
									37.163867187500074
								],
								[
									27.520117187500006,
									37.24912109375012
								],
								[
									27.400585937499983,
									37.30673828124995
								],
								[
									27.376269531250017,
									37.34072265624994
								],
								[
									27.28955078125003,
									37.34868164062496
								],
								[
									27.21923828125,
									37.38916015625003
								],
								[
									27.203906250000074,
									37.4914062500001
								],
								[
									27.14794921875003,
									37.603613281250034
								],
								[
									27.067968750000006,
									37.65791015625007
								],
								[
									27.077832031250068,
									37.687695312499926
								],
								[
									27.224414062500074,
									37.72543945312498
								],
								[
									27.25478515625005,
									37.88232421874997
								],
								[
									27.23242187500003,
									37.978662109374966
								],
								[
									27.15869140625,
									37.986865234375045
								],
								[
									26.94384765625003,
									38.06289062500008
								],
								[
									26.878613281250068,
									38.05478515625012
								],
								[
									26.807421875000045,
									38.13833007812508
								],
								[
									26.68281250000004,
									38.198339843750034
								],
								[
									26.62109375,
									38.176367187500006
								],
								[
									26.582421875000023,
									38.14926757812509
								],
								[
									26.524707031250074,
									38.16225585937508
								],
								[
									26.427929687499983,
									38.21435546875003
								],
								[
									26.33291015625008,
									38.242480468750074
								],
								[
									26.29072265625001,
									38.27719726562495
								],
								[
									26.34365234375005,
									38.37006835937504
								],
								[
									26.41640625000005,
									38.36787109375004
								],
								[
									26.4296875,
									38.44062500000001
								],
								[
									26.37226562500001,
									38.56191406250005
								],
								[
									26.377832031249994,
									38.62416992187494
								],
								[
									26.44130859375005,
									38.641210937500034
								],
								[
									26.513574218750023,
									38.62949218749995
								],
								[
									26.586523437500063,
									38.55703124999994
								],
								[
									26.61035156250003,
									38.48691406249995
								],
								[
									26.595019531250017,
									38.41860351562508
								],
								[
									26.64130859375004,
									38.352441406249994
								],
								[
									26.67421875000008,
									38.335742187500074
								],
								[
									26.696386718750063,
									38.40537109374995
								],
								[
									26.727343750000074,
									38.41860351562508
								],
								[
									26.769921875000023,
									38.38818359375
								],
								[
									26.861425781250034,
									38.37294921875008
								],
								[
									27.09863281250003,
									38.415722656249926
								],
								[
									27.144238281249983,
									38.45195312499993
								],
								[
									26.97041015625001,
									38.44785156250006
								],
								[
									26.906835937500034,
									38.48173828124996
								],
								[
									26.837792968749994,
									38.557568359374955
								],
								[
									26.79531250000005,
									38.62641601562504
								],
								[
									26.787695312500006,
									38.66020507812499
								],
								[
									26.763671875,
									38.70961914062494
								],
								[
									26.790136718750063,
									38.736083984375
								],
								[
									26.90917968749997,
									38.77578125000008
								],
								[
									27.01367187500003,
									38.88686523437508
								],
								[
									26.97011718750005,
									38.91904296875006
								],
								[
									26.920312500000023,
									38.93422851562505
								],
								[
									26.86621093750003,
									38.92294921875006
								],
								[
									26.814941406250057,
									38.96098632812499
								],
								[
									26.80830078125004,
									39.01391601562503
								],
								[
									26.84931640625004,
									39.05673828124995
								],
								[
									26.853613281250034,
									39.11562500000005
								],
								[
									26.719335937500034,
									39.26064453125002
								],
								[
									26.68183593750004,
									39.29223632812497
								],
								[
									26.710742187500045,
									39.339648437500045
								],
								[
									26.813281250000074,
									39.419042968750034
								],
								[
									26.910937500000074,
									39.517333984375
								],
								[
									26.89921874999999,
									39.549658203125006
								],
								[
									26.827050781250023,
									39.56289062500005
								],
								[
									26.484082031250068,
									39.52070312500007
								],
								[
									26.350781249999983,
									39.48408203125007
								],
								[
									26.113085937500074,
									39.46738281249995
								],
								[
									26.095996093750045,
									39.52080078124999
								],
								[
									26.101367187500074,
									39.568945312500034
								],
								[
									26.154687500000023,
									39.65664062500005
								],
								[
									26.14980468750008,
									39.872851562500045
								],
								[
									26.18134765625004,
									39.990087890625034
								],
								[
									26.313378906250023,
									40.02499999999995
								],
								[
									26.475390625000074,
									40.19726562500006
								],
								[
									26.738085937500017,
									40.40024414062509
								],
								[
									27.01210937500008,
									40.39633789062512
								],
								[
									27.121679687500006,
									40.45234375000007
								],
								[
									27.28457031250008,
									40.45561523437502
								],
								[
									27.314160156250068,
									40.41489257812498
								],
								[
									27.332617187500006,
									40.37592773437504
								],
								[
									27.4755859375,
									40.31992187500009
								],
								[
									27.72802734375,
									40.32880859375004
								],
								[
									27.789355468750074,
									40.35087890624999
								],
								[
									27.84853515625005,
									40.38173828125005
								],
								[
									27.73183593750008,
									40.48149414062496
								],
								[
									27.769140625000034,
									40.509619140625006
								],
								[
									27.87490234375008,
									40.51293945312497
								],
								[
									27.989550781250074,
									40.48945312499998
								],
								[
									27.99482421875001,
									40.466601562500045
								],
								[
									27.96435546875,
									40.43530273437506
								],
								[
									27.928906250000068,
									40.380419921875074
								],
								[
									27.96259765625001,
									40.36987304687506
								],
								[
									28.2890625,
									40.403027343749955
								],
								[
									28.63027343750005,
									40.37646484375006
								],
								[
									28.738867187500063,
									40.39086914062497
								],
								[
									29.00712890624999,
									40.389746093750006
								],
								[
									29.05517578125003,
									40.424169921875006
								],
								[
									28.974023437499994,
									40.46738281250009
								],
								[
									28.894628906250006,
									40.48242187499997
								],
								[
									28.841210937500023,
									40.50346679687499
								],
								[
									28.787890625000017,
									40.534033203125006
								],
								[
									28.95800781250003,
									40.630566406249955
								],
								[
									29.05410156250005,
									40.6491210937501
								],
								[
									29.50761718749999,
									40.708398437499994
								],
								[
									29.844921875000068,
									40.7380859375001
								],
								[
									29.849218750000034,
									40.76010742187506
								],
								[
									29.80058593749999,
									40.76015625000005
								],
								[
									29.364746093750114,
									40.80927734375004
								],
								[
									29.259765624999943,
									40.847314453124966
								],
								[
									29.113867187499977,
									40.93784179687512
								],
								[
									29.08222656250001,
									40.963427734375074
								],
								[
									29.045507812500006,
									41.007568359375114
								],
								[
									29.06738281250003,
									41.101660156250006
								],
								[
									29.094335937500006,
									41.17724609374994
								],
								[
									29.14814453125004,
									41.22104492187509
								],
								[
									29.322265625,
									41.227734374999926
								],
								[
									29.919335937500136,
									41.15083007812498
								],
								[
									30.344921875000068,
									41.19692382812505
								],
								[
									30.810058593749943,
									41.08486328125005
								],
								[
									31.2548828125,
									41.10761718750007
								],
								[
									31.346679687500114,
									41.15791015625001
								],
								[
									31.4580078125,
									41.32001953125007
								],
								[
									32.086425781250114,
									41.589208984375034
								],
								[
									32.30644531250016,
									41.729589843750034
								],
								[
									32.54218750000007,
									41.80639648437506
								],
								[
									32.946679687500136,
									41.89174804687494
								],
								[
									33.28476562500009,
									42.004589843749926
								],
								[
									33.381347656250114,
									42.017578125000085
								],
								[
									34.19296875000009,
									41.96367187499993
								],
								[
									34.75048828125,
									41.95683593749996
								],
								[
									35.00644531250009,
									42.063281250000074
								],
								[
									35.154882812500034,
									42.02753906249998
								],
								[
									35.141015625000136,
									41.98950195312506
								],
								[
									35.11406250000016,
									41.9569824218751
								],
								[
									35.122070312500114,
									41.891113281250085
								],
								[
									35.20917968750018,
									41.7943847656251
								],
								[
									35.29775390625002,
									41.728515625000085
								],
								[
									35.55800781250002,
									41.634033203125114
								],
								[
									35.91982421875002,
									41.71372070312509
								],
								[
									35.97812500000009,
									41.70483398437506
								],
								[
									36.05175781249994,
									41.682568359374955
								],
								[
									36.179199218750114,
									41.42656249999993
								],
								[
									36.278417968750034,
									41.33613281249998
								],
								[
									36.40537109375009,
									41.27460937500007
								],
								[
									36.50966796875002,
									41.262500000000074
								],
								[
									36.58710937500007,
									41.326660156250114
								],
								[
									36.647070312500034,
									41.35253906250006
								],
								[
									36.777734374999966,
									41.36347656250004
								],
								[
									36.991992187500045,
									41.27539062500006
								],
								[
									37.06621093750016,
									41.18442382812509
								],
								[
									37.430957031250045,
									41.11411132812506
								],
								[
									37.765625,
									41.07890624999999
								],
								[
									37.91005859375002,
									41.001904296874926
								],
								[
									38.38105468750007,
									40.92451171875007
								],
								[
									38.55693359374999,
									40.93652343750003
								],
								[
									38.85214843750009,
									41.01767578124995
								],
								[
									39.426367187500034,
									41.1064453125
								],
								[
									39.807910156250045,
									40.98251953124998
								],
								[
									39.911132812500114,
									40.966455078124994
								],
								[
									40.00019531250001,
									40.97714843749995
								],
								[
									40.12841796874994,
									40.94301757812511
								],
								[
									40.265234375000034,
									40.96132812500011
								],
								[
									40.6875,
									41.10742187500003
								],
								[
									40.81953125000018,
									41.19023437499993
								],
								[
									40.95947265625,
									41.21162109375001
								],
								[
									41.083593750000034,
									41.2611816406251
								],
								[
									41.41435546874999,
									41.42363281249996
								],
								[
									41.510058593750045,
									41.51748046875008
								]
							]
						],
						[
							[
								[
									28.01445312499999,
									41.96904296874996
								],
								[
									27.98730468749997,
									41.85488281250008
								],
								[
									28.05029296875003,
									41.72915039062494
								],
								[
									28.197851562500063,
									41.554492187500074
								],
								[
									28.34638671875004,
									41.46635742187496
								],
								[
									28.946777343750057,
									41.24838867187506
								],
								[
									29.057226562499977,
									41.229736328125085
								],
								[
									29.032128906250023,
									41.140478515625006
								],
								[
									28.99599609375005,
									41.061132812500006
								],
								[
									28.95625000000001,
									41.008203124999966
								],
								[
									28.780371093749977,
									40.97416992187496
								],
								[
									28.29492187500003,
									41.07148437499998
								],
								[
									28.172167968750074,
									41.080712890624994
								],
								[
									28.085546875000006,
									41.06132812499996
								],
								[
									27.925195312500023,
									40.99057617187512
								],
								[
									27.747363281250045,
									41.013281250000034
								],
								[
									27.49941406250005,
									40.97314453125003
								],
								[
									27.43017578124997,
									40.83994140624998
								],
								[
									27.258007812499983,
									40.68735351562498
								],
								[
									26.974609375,
									40.564013671875074
								],
								[
									26.772070312500034,
									40.49804687500006
								],
								[
									26.467968750000068,
									40.261474609375085
								],
								[
									26.329980468750023,
									40.123388671875006
								],
								[
									26.271777343750074,
									40.096582031249966
								],
								[
									26.202734375000034,
									40.0753906250001
								],
								[
									26.22597656250005,
									40.141699218750006
								],
								[
									26.260156249999994,
									40.20239257812494
								],
								[
									26.252343750000023,
									40.24814453125012
								],
								[
									26.25380859375005,
									40.314697265625085
								],
								[
									26.355273437500017,
									40.39023437500012
								],
								[
									26.447460937500068,
									40.44501953124998
								],
								[
									26.720312500000063,
									40.544238281250045
								],
								[
									26.792089843750006,
									40.62661132812502
								],
								[
									26.57812500000003,
									40.624658203124994
								],
								[
									26.360937500000034,
									40.606347656249994
								],
								[
									26.224218750000063,
									40.61806640625008
								],
								[
									26.10546875000003,
									40.61132812499994
								],
								[
									26.06777343750008,
									40.683398437500045
								],
								[
									26.03896484375005,
									40.72675781250001
								],
								[
									26.069726562500023,
									40.74028320312502
								],
								[
									26.109179687500074,
									40.749658203124966
								],
								[
									26.178906250000068,
									40.82651367187509
								],
								[
									26.241210937500057,
									40.883203124999994
								],
								[
									26.331054687500057,
									40.95449218750005
								],
								[
									26.354101562500063,
									40.997070312500114
								],
								[
									26.354101562500063,
									41.03676757812502
								],
								[
									26.332617187500034,
									41.064306640625034
								],
								[
									26.328417968750045,
									41.09702148437495
								],
								[
									26.32568359375003,
									41.143261718749955
								],
								[
									26.330664062499977,
									41.23876953125006
								],
								[
									26.536425781250074,
									41.34311523437509
								],
								[
									26.60234374999999,
									41.35415039062502
								],
								[
									26.62490234375005,
									41.40175781250002
								],
								[
									26.609765624999994,
									41.51215820312507
								],
								[
									26.581347656250074,
									41.6012695312501
								],
								[
									26.544531250000034,
									41.607226562500074
								],
								[
									26.49501953125008,
									41.63325195312504
								],
								[
									26.462500000000006,
									41.663378906250045
								],
								[
									26.410546874999994,
									41.6963378906251
								],
								[
									26.320898437500034,
									41.71655273437503
								],
								[
									26.317968750000063,
									41.744677734375074
								],
								[
									26.327246093750006,
									41.772802734375034
								],
								[
									26.3603515625,
									41.801562500000045
								],
								[
									26.51142578125004,
									41.82636718750004
								],
								[
									26.52929687500003,
									41.846679687500085
								],
								[
									26.549707031250023,
									41.89672851562497
								],
								[
									26.579687500000006,
									41.94794921875001
								],
								[
									26.615332031250063,
									41.9648925781251
								],
								[
									26.67919921875003,
									41.96333007812504
								],
								[
									26.800390625000034,
									41.97514648437496
								],
								[
									26.884863281250006,
									41.991845703124994
								],
								[
									26.96875000000003,
									42.026855468750114
								],
								[
									27.01171875,
									42.05864257812502
								],
								[
									27.193359375000057,
									42.07709960937504
								],
								[
									27.24433593750004,
									42.09326171875006
								],
								[
									27.294921875000057,
									42.07954101562501
								],
								[
									27.362890625000034,
									42.02504882812511
								],
								[
									27.47480468750001,
									41.94687499999998
								],
								[
									27.534863281249983,
									41.920800781249994
								],
								[
									27.579882812500017,
									41.932910156250074
								],
								[
									27.661132812500057,
									41.961328124999994
								],
								[
									27.738867187499977,
									41.961523437500034
								],
								[
									27.80166015625008,
									41.956542968750085
								],
								[
									27.831933593750023,
									41.98129882812498
								],
								[
									27.879199218750074,
									41.98662109374999
								],
								[
									28.01445312499999,
									41.96904296874996
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Western Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "TUR",
					"su_a3": "TUR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "TUR",
					"gu_a3": "TUR",
					"abbrev": "Tur.",
					"region_un": "Asia",
					"adm0_a3_us": "TUR",
					"scalerank": 1,
					"pop_est": 76805524,
					"adm0_dif": 0,
					"un_a3": "792",
					"pop_year": -99,
					"gdp_md_est": 902700,
					"name": "Turkey",
					"sovereignt": "Turkey",
					"economy": "4. Emerging region: MIKT",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Turkey",
					"postal": "TR",
					"sov_a3": "TUR",
					"note_brk": "",
					"brk_a3": "TUR",
					"wb_a2": "TR",
					"brk_diff": 0,
					"admin": "Turkey",
					"name_long": "Turkey",
					"iso_a3": "TUR",
					"iso_a2": "TR",
					"adm0_a3_is": "TUR",
					"level": 2,
					"formal_en": "Republic of Turkey",
					"name_len": 6,
					"mapcolor7": 6,
					"long_len": 6,
					"mapcolor8": 3,
					"mapcolor9": 8,
					"note_adm0": "",
					"iso_n3": "792",
					"homepart": 1,
					"subunit": "Turkey",
					"name_alt": "",
					"brk_name": "Turkey",
					"name_sort": "Turkey",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2000
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									118.40742187500018,
									24.52211914062505
								],
								[
									118.45117187500011,
									24.455566406250085
								],
								[
									118.43271484375009,
									24.41435546875013
								],
								[
									118.29511718750001,
									24.436328125000074
								],
								[
									118.28730468750001,
									24.476611328125017
								],
								[
									118.33935546874994,
									24.46914062500008
								],
								[
									118.40742187500018,
									24.52211914062505
								]
							]
						],
						[
							[
								[
									121.00878906249994,
									22.620361328124943
								],
								[
									120.94687500000003,
									22.503076171874937
								],
								[
									120.89736328125002,
									22.379150390625085
								],
								[
									120.87734375000002,
									22.262207031250085
								],
								[
									120.87841796874994,
									22.14155273437501
								],
								[
									120.86425781250011,
									22.03266601562504
								],
								[
									120.83984375000011,
									21.92500000000004
								],
								[
									120.74277343750003,
									21.956005859374955
								],
								[
									120.69013671875018,
									22.033105468749937
								],
								[
									120.67802734374999,
									22.15966796874997
								],
								[
									120.60761718750007,
									22.31254882812513
								],
								[
									120.58125000000018,
									22.356396484375068
								],
								[
									120.47978515625005,
									22.44189453125
								],
								[
									120.38759765624997,
									22.48452148437508
								],
								[
									120.31621093749999,
									22.547607421875057
								],
								[
									120.32558593750014,
									22.542431640625068
								],
								[
									120.27285156250014,
									22.627441406250057
								],
								[
									120.23281249999997,
									22.717919921875108
								],
								[
									120.15009765625018,
									22.97490234374996
								],
								[
									120.12158203124994,
									23.037011718750108
								],
								[
									120.08339843750002,
									23.09370117187501
								],
								[
									120.07246093750018,
									23.149755859375063
								],
								[
									120.08554687500009,
									23.212060546874966
								],
								[
									120.12119140625009,
									23.305175781250114
								],
								[
									120.14296874999997,
									23.39907226562505
								],
								[
									120.12539062500014,
									23.526611328125085
								],
								[
									120.13212890625016,
									23.652929687500063
								],
								[
									120.15898437500005,
									23.70903320312496
								],
								[
									120.62968749999999,
									24.478515625000057
								],
								[
									120.7574218750002,
									24.642285156249926
								],
								[
									120.83593750000011,
									24.722656250000057
								],
								[
									120.90156250000007,
									24.81328125000013
								],
								[
									120.96406250000018,
									24.927978515625057
								],
								[
									121.04062500000003,
									25.03281250000009
								],
								[
									121.09541015625001,
									25.065087890624994
								],
								[
									121.36542968750007,
									25.159179687500085
								],
								[
									121.44960937499997,
									25.249023437500085
								],
								[
									121.51708984374994,
									25.27690429687499
								],
								[
									121.59365234375002,
									25.27534179687501
								],
								[
									121.64306640624994,
									25.232421875000085
								],
								[
									121.68710937500003,
									25.181591796874926
								],
								[
									121.73330078125014,
									25.154101562500017
								],
								[
									121.85283203125016,
									25.10444335937501
								],
								[
									121.90517578124997,
									25.056445312500017
								],
								[
									121.92900390625005,
									24.97373046874995
								],
								[
									121.85625000000016,
									24.89526367187503
								],
								[
									121.82011718750016,
									24.824511718750017
								],
								[
									121.81337890625002,
									24.746337890625085
								],
								[
									121.82636718750018,
									24.640527343750108
								],
								[
									121.82802734374997,
									24.534375000000068
								],
								[
									121.73701171875018,
									24.28525390625012
								],
								[
									121.63935546875018,
									24.13007812500004
								],
								[
									121.61308593750016,
									24.052734375000085
								],
								[
									121.58339843749997,
									23.86088867187499
								],
								[
									121.52607421875001,
									23.668261718750102
								],
								[
									121.47714843750009,
									23.424072265625085
								],
								[
									121.39746093750011,
									23.17250976562508
								],
								[
									121.35224609375007,
									23.06728515625005
								],
								[
									121.29589843750011,
									22.96660156249996
								],
								[
									121.1612304687502,
									22.776367187500114
								],
								[
									121.00878906249994,
									22.620361328124943
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Asia",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "TWN",
					"su_a3": "TWN",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "-99",
					"gu_a3": "TWN",
					"abbrev": "Taiwan",
					"region_un": "Asia",
					"adm0_a3_us": "TWN",
					"scalerank": 1,
					"pop_est": 22974347,
					"adm0_dif": 0,
					"un_a3": "-099",
					"pop_year": -99,
					"gdp_md_est": 712000,
					"name": "Taiwan",
					"sovereignt": "Taiwan",
					"economy": "2. Developed region: nonG7",
					"type": "Sovereign country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "2. High income: nonOECD",
					"geou_dif": 0,
					"geounit": "Taiwan",
					"postal": "TW",
					"sov_a3": "TWN",
					"note_brk": "Self admin.; Claimed by China",
					"brk_a3": "B77",
					"wb_a2": "-99",
					"brk_diff": 1,
					"admin": "Taiwan",
					"name_long": "Taiwan",
					"iso_a3": "TWN",
					"iso_a2": "TW",
					"adm0_a3_is": "TWN",
					"level": 2,
					"formal_en": "",
					"name_len": 6,
					"mapcolor7": 1,
					"long_len": 6,
					"mapcolor8": 5,
					"mapcolor9": 7,
					"note_adm0": "",
					"iso_n3": "158",
					"homepart": 1,
					"subunit": "Taiwan",
					"name_alt": "",
					"brk_name": "Taiwan",
					"name_sort": "Taiwan",
					"continent": "Asia",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": -99
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									32.01220703125,
									46.203906250000045
								],
								[
									32.15009765625001,
									46.15468750000005
								],
								[
									32.009375000000034,
									46.16782226562506
								],
								[
									31.700195312500114,
									46.21406250000007
								],
								[
									31.563867187500136,
									46.25776367187507
								],
								[
									31.528710937499966,
									46.30659179687507
								],
								[
									31.508789062500114,
									46.37314453125006
								],
								[
									31.584863281249966,
									46.30317382812501
								],
								[
									31.63847656250016,
									46.27255859375006
								],
								[
									32.01220703125,
									46.203906250000045
								]
							]
						],
						[
							[
								[
									38.214355468750114,
									47.09145507812502
								],
								[
									38.178320312500034,
									47.08022460937505
								],
								[
									37.828710937500034,
									47.09584960937494
								],
								[
									37.54335937500002,
									47.07456054687495
								],
								[
									37.339843750000114,
									46.91689453125008
								],
								[
									37.21855468749999,
									46.91733398437498
								],
								[
									37.04755859375018,
									46.87622070312506
								],
								[
									36.932031249999966,
									46.82514648437504
								],
								[
									36.79482421875002,
									46.71440429687502
								],
								[
									36.68867187500007,
									46.76411132812504
								],
								[
									36.55878906250007,
									46.762695312500085
								],
								[
									36.432031249999966,
									46.732568359374994
								],
								[
									36.27949218750018,
									46.65859374999994
								],
								[
									36.194628906250045,
									46.64550781250003
								],
								[
									36.024902343750114,
									46.66679687500002
								],
								[
									35.82714843749994,
									46.624316406250074
								],
								[
									35.40019531249999,
									46.381396484375045
								],
								[
									35.25664062500016,
									46.203906250000045
								],
								[
									35.20439453124999,
									46.16918945312497
								],
								[
									35.13232421875,
									46.12587890625002
								],
								[
									35.05527343750009,
									46.104003906250114
								],
								[
									35.014550781250136,
									46.106005859375074
								],
								[
									35.2177734375,
									46.232177734375114
								],
								[
									35.280175781249966,
									46.27949218750007
								],
								[
									35.290917968750136,
									46.31440429687498
								],
								[
									35.2919921875,
									46.37070312500009
								],
								[
									35.230371093750136,
									46.44062500000004
								],
								[
									35.06406250000009,
									46.267236328124966
								],
								[
									34.969531250000045,
									46.242089843749994
								],
								[
									34.849609375000114,
									46.189892578124926
								],
								[
									34.84375,
									46.07358398437495
								],
								[
									34.857324218749966,
									45.987353515625045
								],
								[
									34.90664062500002,
									45.878808593749966
								],
								[
									35.022851562500136,
									45.700976562500074
								],
								[
									35.260156249999966,
									45.44692382812508
								],
								[
									35.373925781249966,
									45.35361328125009
								],
								[
									35.45751953124994,
									45.31630859375005
								],
								[
									35.55800781250002,
									45.31088867187509
								],
								[
									35.7509765625,
									45.3893554687501
								],
								[
									35.833496093750114,
									45.401611328125085
								],
								[
									36.01289062500007,
									45.37167968749995
								],
								[
									36.0771484375,
									45.424121093750074
								],
								[
									36.17050781250009,
									45.453076171874926
								],
								[
									36.29033203125016,
									45.456738281249955
								],
								[
									36.42705078125016,
									45.433251953124966
								],
								[
									36.57500000000016,
									45.39355468750006
								],
								[
									36.514257812500034,
									45.303759765625045
								],
								[
									36.45078125000009,
									45.23232421875008
								],
								[
									36.42841796875007,
									45.153271484374955
								],
								[
									36.393359375000045,
									45.06538085937498
								],
								[
									36.229882812500136,
									45.02597656249995
								],
								[
									36.054785156250034,
									45.03081054687496
								],
								[
									35.870117187500114,
									45.00532226562501
								],
								[
									35.803613281250136,
									45.039599609375074
								],
								[
									35.75947265625001,
									45.070849609375045
								],
								[
									35.677539062500045,
									45.10200195312498
								],
								[
									35.56953125000007,
									45.11933593750007
								],
								[
									35.47255859375002,
									45.09848632812498
								],
								[
									35.357812499999966,
									44.97841796875002
								],
								[
									35.154785156250114,
									44.896337890625006
								],
								[
									35.087695312500045,
									44.80263671875002
								],
								[
									34.88779296875009,
									44.82358398437512
								],
								[
									34.71689453125009,
									44.80712890625006
								],
								[
									34.46992187500001,
									44.72167968750006
								],
								[
									34.28173828124994,
									44.53842773437509
								],
								[
									34.07441406250018,
									44.42382812500003
								],
								[
									33.90996093750016,
									44.38759765625002
								],
								[
									33.75566406249999,
									44.398925781250114
								],
								[
									33.65585937500009,
									44.43320312499998
								],
								[
									33.45068359374994,
									44.55366210937501
								],
								[
									33.46269531249999,
									44.59682617187511
								],
								[
									33.491308593750034,
									44.61860351562501
								],
								[
									33.53007812500016,
									44.680517578125006
								],
								[
									33.612207031249966,
									44.90781249999995
								],
								[
									33.601171875000034,
									44.981494140625045
								],
								[
									33.555175781250114,
									45.097656250000085
								],
								[
									33.392480468749966,
									45.18784179687498
								],
								[
									33.26152343750016,
									45.17075195312506
								],
								[
									33.186914062500136,
									45.19477539062507
								],
								[
									32.91865234375018,
									45.34814453125003
								],
								[
									32.77265625000001,
									45.358984375000034
								],
								[
									32.611328125000114,
									45.32807617187504
								],
								[
									32.55185546875009,
									45.35039062499996
								],
								[
									32.50800781250018,
									45.403808593750114
								],
								[
									32.82802734375002,
									45.593017578125114
								],
								[
									33.14228515625018,
									45.74921875000004
								],
								[
									33.28007812499999,
									45.76523437500009
								],
								[
									33.46621093750002,
									45.83793945312499
								],
								[
									33.66484375000016,
									45.94707031249993
								],
								[
									33.636718750000114,
									46.03286132812508
								],
								[
									33.594140625000136,
									46.096240234375045
								],
								[
									33.49882812500016,
									46.07885742187506
								],
								[
									33.42988281250007,
									46.057617187500085
								],
								[
									33.26347656249999,
									46.1256835937501
								],
								[
									33.202246093750034,
									46.17573242187507
								],
								[
									32.94179687500002,
									46.12377929687506
								],
								[
									32.796875,
									46.13149414062494
								],
								[
									32.47675781250007,
									46.08369140625007
								],
								[
									32.32988281250016,
									46.13037109374997
								],
								[
									32.03574218750009,
									46.26098632812503
								],
								[
									31.925195312500136,
									46.28725585937505
								],
								[
									31.831250000000182,
									46.28168945312498
								],
								[
									31.77998046875001,
									46.32465820312504
								],
								[
									31.842871093750034,
									46.34614257812507
								],
								[
									31.915917968750023,
									46.348681640625045
								],
								[
									31.99169921875,
									46.36440429687505
								],
								[
									32.013085937499966,
									46.38715820312507
								],
								[
									32.00849609375001,
									46.42998046874999
								],
								[
									31.85576171874999,
									46.462451171875045
								],
								[
									31.71367187499999,
									46.47177734374998
								],
								[
									31.623632812500034,
									46.51025390625
								],
								[
									31.554882812500182,
									46.554296875000006
								],
								[
									31.716015625000068,
									46.554980468750045
								],
								[
									31.8779296875,
									46.52167968750001
								],
								[
									32.131445312500034,
									46.509375000000006
								],
								[
									32.361328125,
									46.474951171875006
								],
								[
									32.4189453125,
									46.51777343750004
								],
								[
									32.552539062500045,
									46.591992187499955
								],
								[
									32.578027343749966,
									46.61562500000008
								],
								[
									32.35410156250009,
									46.56484374999994
								],
								[
									32.12724609375016,
									46.59721679687496
								],
								[
									32.044335937500136,
									46.64248046874994
								],
								[
									31.974316406250182,
									46.708789062500045
								],
								[
									31.944921875000034,
									46.78437499999998
								],
								[
									31.964062500000068,
									46.85483398437495
								],
								[
									31.939550781250034,
									46.9819824218751
								],
								[
									31.864746093749943,
									47.095117187499966
								],
								[
									31.83818359375016,
									47.1572265625
								],
								[
									31.759179687500136,
									47.21284179687507
								],
								[
									31.8369140625,
									47.08701171875009
								],
								[
									31.86591796875001,
									47.00327148437509
								],
								[
									31.912695312500034,
									46.92612304687509
								],
								[
									31.901660156250045,
									46.72163085937507
								],
								[
									31.872851562500045,
									46.649755859375006
								],
								[
									31.779589843750045,
									46.631640625000045
								],
								[
									31.657031250000045,
									46.64243164062512
								],
								[
									31.532128906249966,
									46.66474609375004
								],
								[
									31.563378906250136,
									46.77729492187504
								],
								[
									31.49687500000016,
									46.738378906250034
								],
								[
									31.402929687500034,
									46.628808593749994
								],
								[
									31.3203125,
									46.61250000000004
								],
								[
									31.13681640625009,
									46.6244628906251
								],
								[
									30.796289062499966,
									46.552001953125085
								],
								[
									30.772851562500023,
									46.47304687500005
								],
								[
									30.7216796875,
									46.36621093749997
								],
								[
									30.672265625000136,
									46.304003906250074
								],
								[
									30.65673828125,
									46.266503906249994
								],
								[
									30.51152343750016,
									46.10537109374994
								],
								[
									30.49296874999999,
									46.090136718750045
								],
								[
									30.21904296875016,
									45.8667480468751
								],
								[
									30.18417968750009,
									45.84995117187495
								],
								[
									30.00664062500016,
									45.79794921875012
								],
								[
									29.90166015625016,
									45.75239257812507
								],
								[
									29.821191406250136,
									45.73208007812511
								],
								[
									29.685058593750114,
									45.754687500000074
								],
								[
									29.628417968750114,
									45.7224609375001
								],
								[
									29.601660156250034,
									45.68251953125005
								],
								[
									29.601171875000034,
									45.60000000000011
								],
								[
									29.670312500000023,
									45.54067382812511
								],
								[
									29.726953125000023,
									45.343310546875045
								],
								[
									29.705859375000045,
									45.25991210937511
								],
								[
									29.65195312500009,
									45.3139160156251
								],
								[
									29.567675781250045,
									45.37080078125004
								],
								[
									29.403710937500136,
									45.41967773437506
								],
								[
									29.223535156250136,
									45.402929687500006
								],
								[
									29.027441406250063,
									45.320556640625114
								],
								[
									28.894335937500017,
									45.289941406249994
								],
								[
									28.824316406250063,
									45.311083984375045
								],
								[
									28.78173828125,
									45.309863281250045
								],
								[
									28.76660156250003,
									45.286230468750034
								],
								[
									28.769824218750045,
									45.2668945312501
								],
								[
									28.791406250000023,
									45.25190429687507
								],
								[
									28.78828125000001,
									45.24096679687506
								],
								[
									28.76074218749997,
									45.234130859375085
								],
								[
									28.451269531250006,
									45.29218750000001
								],
								[
									28.317675781250045,
									45.34711914062501
								],
								[
									28.212500000000034,
									45.450439453125
								],
								[
									28.26484375000004,
									45.483886718750085
								],
								[
									28.310351562500074,
									45.49858398437496
								],
								[
									28.47138671875001,
									45.50717773437512
								],
								[
									28.499023437500057,
									45.51772460937505
								],
								[
									28.501757812500074,
									45.5415527343751
								],
								[
									28.513769531250034,
									45.57241210937508
								],
								[
									28.50947265625004,
									45.61782226562508
								],
								[
									28.49160156250005,
									45.665771484375
								],
								[
									28.562304687500045,
									45.73579101562507
								],
								[
									28.667578125000006,
									45.79384765625008
								],
								[
									28.729296875000074,
									45.85200195312501
								],
								[
									28.73876953125003,
									45.93715820312505
								],
								[
									28.84951171875005,
									45.97866210937505
								],
								[
									28.94775390624997,
									46.04995117187502
								],
								[
									28.97187500000001,
									46.12763671875004
								],
								[
									29.00625000000008,
									46.17646484375004
								],
								[
									28.94375000000005,
									46.28842773437512
								],
								[
									28.930566406250023,
									46.36225585937504
								],
								[
									28.92744140625001,
									46.424121093750045
								],
								[
									28.958398437500023,
									46.45849609375003
								],
								[
									29.049902343750006,
									46.49702148437507
								],
								[
									29.146289062500017,
									46.52690429687502
								],
								[
									29.186230468750068,
									46.52397460937496
								],
								[
									29.200781250000034,
									46.50498046875009
								],
								[
									29.20458984375,
									46.37934570312498
								],
								[
									29.223828125000068,
									46.37695312500003
								],
								[
									29.254589843750068,
									46.39262695312502
								],
								[
									29.304882812500068,
									46.46660156249999
								],
								[
									29.339550781250068,
									46.44506835937506
								],
								[
									29.392871093750045,
									46.43691406250008
								],
								[
									29.43281250000001,
									46.45595703125005
								],
								[
									29.45878906249999,
									46.45375976562505
								],
								[
									29.491015625000102,
									46.43466796875006
								],
								[
									29.55507812500008,
									46.407763671875074
								],
								[
									29.614941406250125,
									46.39882812500005
								],
								[
									29.66455078125,
									46.41674804687506
								],
								[
									29.70683593749999,
									46.448730468750085
								],
								[
									29.751953125000057,
									46.43779296874999
								],
								[
									29.837890625000057,
									46.35053710937507
								],
								[
									29.878027343750034,
									46.36020507812509
								],
								[
									30.075683593750114,
									46.37783203125002
								],
								[
									30.10751953125009,
									46.40156250000007
								],
								[
									30.131054687500068,
									46.423095703125114
								],
								[
									29.92431640625,
									46.538867187500074
								],
								[
									29.934765625000182,
									46.62500000000003
								],
								[
									29.942480468750034,
									46.72377929687508
								],
								[
									29.918066406250034,
									46.78242187500004
								],
								[
									29.877832031250023,
									46.828906250000074
								],
								[
									29.719726562500057,
									46.88291015625006
								],
								[
									29.59775390625009,
									46.938818359375006
								],
								[
									29.571972656250068,
									46.96401367187508
								],
								[
									29.56865234374999,
									46.996728515624994
								],
								[
									29.563476562500114,
									47.04750976562502
								],
								[
									29.51503906250008,
									47.091113281250045
								],
								[
									29.510937500000068,
									47.128027343750006
								],
								[
									29.541796875000045,
									47.185546875
								],
								[
									29.549316406250057,
									47.24682617187506
								],
								[
									29.539160156250034,
									47.27099609375
								],
								[
									29.51064453125008,
									47.29072265625001
								],
								[
									29.45566406250009,
									47.292626953124966
								],
								[
									29.38339843750009,
									47.32802734375008
								],
								[
									29.333789062500045,
									47.37573242187503
								],
								[
									29.20058593750008,
									47.444482421874994
								],
								[
									29.159765625000006,
									47.45566406250006
								],
								[
									29.134863281250006,
									47.48969726562507
								],
								[
									29.12294921875005,
									47.53037109375009
								],
								[
									29.150878906250057,
									47.580859375000074
								],
								[
									29.18603515625003,
									47.65859375000011
								],
								[
									29.21074218749999,
									47.731542968750034
								],
								[
									29.211132812500068,
									47.775000000000006
								],
								[
									29.194824218750057,
									47.882421875000034
								],
								[
									29.125390625000023,
									47.96455078124998
								],
								[
									29.092968750000068,
									47.97543945312506
								],
								[
									29.036914062500017,
									47.95234374999998
								],
								[
									28.97333984375004,
									47.93300781250005
								],
								[
									28.923144531250017,
									47.95112304687501
								],
								[
									28.865820312499977,
									47.99565429687502
								],
								[
									28.77382812500008,
									48.11958007812504
								],
								[
									28.601660156250006,
									48.144384765625034
								],
								[
									28.530468750000068,
									48.150292968749994
								],
								[
									28.46308593750001,
									48.09052734374998
								],
								[
									28.441992187500063,
									48.108691406250045
								],
								[
									28.42304687500001,
									48.14687500000011
								],
								[
									28.387500000000074,
									48.162109375
								],
								[
									28.340527343749983,
									48.14443359375005
								],
								[
									28.326953125000074,
									48.161425781250045
								],
								[
									28.34716796875003,
									48.21303710937508
								],
								[
									28.29101562500003,
									48.238574218750045
								],
								[
									28.158789062500006,
									48.23798828125001
								],
								[
									28.088476562500063,
									48.25703125000007
								],
								[
									28.080078125000057,
									48.295800781249966
								],
								[
									28.038476562500023,
									48.321289062500114
								],
								[
									27.96337890625,
									48.33354492187502
								],
								[
									27.890625,
									48.365234375000085
								],
								[
									27.82001953125001,
									48.416259765625
								],
								[
									27.714453124999977,
									48.44951171875002
								],
								[
									27.57373046875,
									48.46489257812496
								],
								[
									27.562207031250068,
									48.47041015625001
								],
								[
									27.54921875000008,
									48.4777343750001
								],
								[
									27.45839843750005,
									48.44306640625004
								],
								[
									27.40380859375003,
									48.415625000000034
								],
								[
									27.3369140625,
									48.43271484374998
								],
								[
									27.22851562500003,
									48.37143554687509
								],
								[
									27.00849609375004,
									48.36826171875009
								],
								[
									26.90058593750001,
									48.37192382812512
								],
								[
									26.847070312500023,
									48.38715820312501
								],
								[
									26.640429687500017,
									48.29414062499998
								],
								[
									26.618945312500017,
									48.259863281250034
								],
								[
									26.57246093750004,
									48.24848632812501
								],
								[
									26.4423828125,
									48.22998046874997
								],
								[
									26.30566406250003,
									48.20375976562505
								],
								[
									26.276953125000063,
									48.11323242187507
								],
								[
									26.236230468750023,
									48.06435546875008
								],
								[
									26.162695312500034,
									47.992529296875006
								],
								[
									25.90869140625,
									47.967578125000074
								],
								[
									25.689257812500045,
									47.93247070312512
								],
								[
									25.46425781250005,
									47.91079101562505
								],
								[
									25.169628906250068,
									47.823095703125034
								],
								[
									25.073828125000006,
									47.74570312500009
								],
								[
									24.979101562500063,
									47.72412109375003
								],
								[
									24.89335937499999,
									47.717773437500085
								],
								[
									24.837890625000057,
									47.76083984375006
								],
								[
									24.650976562500006,
									47.87651367187499
								],
								[
									24.578906250000074,
									47.93105468750008
								],
								[
									24.48408203125001,
									47.94711914062509
								],
								[
									24.380957031250063,
									47.9380371093751
								],
								[
									24.28193359375004,
									47.911181640625045
								],
								[
									24.177734375000057,
									47.906054687500074
								],
								[
									24.059765624999983,
									47.94477539062504
								],
								[
									24.04736328125003,
									47.94101562500009
								],
								[
									24.001855468749994,
									47.935791015625085
								],
								[
									23.70898437500003,
									47.98261718750004
								],
								[
									23.68203125000005,
									47.99038085937511
								],
								[
									23.669042968750063,
									47.992333984374966
								],
								[
									23.628710937500017,
									47.99584960937497
								],
								[
									23.40820312500003,
									47.989990234375114
								],
								[
									23.20263671875,
									48.0845214843751
								],
								[
									23.139453125000074,
									48.08740234374997
								],
								[
									23.09082031250003,
									48.04912109374999
								],
								[
									23.054785156250063,
									48.00654296875001
								],
								[
									22.912890625000017,
									47.96425781250002
								],
								[
									22.87666015625001,
									47.94726562500003
								],
								[
									22.856054687499977,
									47.960302734375006
								],
								[
									22.846484375000074,
									47.99707031250003
								],
								[
									22.857226562500045,
									48.029541015625085
								],
								[
									22.836230468750045,
									48.06030273437506
								],
								[
									22.782226562500057,
									48.09521484375006
								],
								[
									22.769140625000034,
									48.10961914062506
								],
								[
									22.70156250000005,
									48.10703125000006
								],
								[
									22.68310546875003,
									48.10361328125006
								],
								[
									22.676367187500063,
									48.104394531249966
								],
								[
									22.582421875000023,
									48.13403320312506
								],
								[
									22.520117187500034,
									48.20537109375002
								],
								[
									22.42382812500003,
									48.24331054687502
								],
								[
									22.350195312500063,
									48.25605468750004
								],
								[
									22.316699218750074,
									48.28662109375006
								],
								[
									22.29511718750001,
									48.327294921874994
								],
								[
									22.27216796875004,
									48.358007812500034
								],
								[
									22.269433593750023,
									48.360888671875074
								],
								[
									22.253710937500017,
									48.407373046874966
								],
								[
									22.23115234375004,
									48.41215820312496
								],
								[
									22.227148437500034,
									48.413427734375034
								],
								[
									22.131835937500057,
									48.40532226562499
								],
								[
									22.14287109374999,
									48.56850585937502
								],
								[
									22.295214843750045,
									48.68583984375002
								],
								[
									22.332617187500034,
									48.74506835937501
								],
								[
									22.389453125000045,
									48.87348632812507
								],
								[
									22.432031250000023,
									48.93354492187504
								],
								[
									22.483203125000045,
									48.983251953125034
								],
								[
									22.52412109375004,
									49.031396484374994
								],
								[
									22.538671874999977,
									49.07270507812507
								],
								[
									22.57998046875005,
									49.0771972656251
								],
								[
									22.701269531249977,
									49.03994140625005
								],
								[
									22.809765625000068,
									49.02075195312506
								],
								[
									22.83974609375005,
									49.03891601562512
								],
								[
									22.852050781250057,
									49.062744140625085
								],
								[
									22.847070312500023,
									49.08125000000004
								],
								[
									22.76015625000008,
									49.13623046875003
								],
								[
									22.705664062500006,
									49.17119140624996
								],
								[
									22.70234375000004,
									49.19272460937509
								],
								[
									22.721972656250017,
									49.24096679687497
								],
								[
									22.73242187500003,
									49.295166015625
								],
								[
									22.719921875000068,
									49.353808593750045
								],
								[
									22.660644531250057,
									49.483691406250045
								],
								[
									22.6494140625,
									49.53901367187504
								],
								[
									22.706152343750006,
									49.60620117187503
								],
								[
									22.890722656250034,
									49.76625976562505
								],
								[
									22.952246093750034,
									49.82636718750004
								],
								[
									23.03632812500004,
									49.89907226562502
								],
								[
									23.264453125000045,
									50.07285156249998
								],
								[
									23.408593750000023,
									50.17392578125006
								],
								[
									23.506152343750017,
									50.22983398437509
								],
								[
									23.649023437500063,
									50.32705078125008
								],
								[
									23.711718750000045,
									50.37734375000002
								],
								[
									23.97265625,
									50.41005859375002
								],
								[
									24.004980468750034,
									50.45703125
								],
								[
									24.05263671875005,
									50.508447265624994
								],
								[
									24.089941406250006,
									50.53046875000004
								],
								[
									24.0947265625,
									50.617041015625006
								],
								[
									24.04628906250008,
									50.722802734374966
								],
								[
									24.007324218750057,
									50.76015625000002
								],
								[
									23.978417968750023,
									50.78559570312507
								],
								[
									23.9970703125,
									50.80937500000002
								],
								[
									24.025976562500034,
									50.81616210937506
								],
								[
									24.061621093750006,
									50.81953125000004
								],
								[
									24.105761718750045,
									50.844970703125085
								],
								[
									24.095800781250063,
									50.87275390625004
								],
								[
									23.985742187500023,
									50.940429687500085
								],
								[
									23.938085937500063,
									50.992529296875034
								],
								[
									23.863476562500068,
									51.126220703125
								],
								[
									23.712207031250074,
									51.26513671875006
								],
								[
									23.664453125000023,
									51.31005859374997
								],
								[
									23.65761718750005,
									51.3524902343751
								],
								[
									23.6796875,
									51.39492187500002
								],
								[
									23.65888671875004,
									51.44897460937503
								],
								[
									23.605273437500045,
									51.517919921875034
								],
								[
									23.61376953125,
									51.52539062500006
								],
								[
									23.60859375000001,
									51.61049804687508
								],
								[
									23.64667968750004,
									51.62885742187507
								],
								[
									23.706835937500045,
									51.64130859375004
								],
								[
									23.79169921875001,
									51.63710937500008
								],
								[
									23.86425781250003,
									51.62397460937507
								],
								[
									23.95117187499997,
									51.585058593750034
								],
								[
									23.978320312500017,
									51.59130859375006
								],
								[
									24.12685546875008,
									51.66464843750009
								],
								[
									24.280078125000017,
									51.774707031250045
								],
								[
									24.32373046875003,
									51.83842773437496
								],
								[
									24.361914062500006,
									51.867529296875034
								],
								[
									24.495214843750063,
									51.883056640625
								],
								[
									24.611328125,
									51.88950195312498
								],
								[
									24.685156250000034,
									51.88828125000009
								],
								[
									24.86640625000001,
									51.89912109374998
								],
								[
									24.97382812500004,
									51.91113281250003
								],
								[
									25.066699218750045,
									51.93051757812506
								],
								[
									25.267187500000034,
									51.93774414062503
								],
								[
									25.58027343750004,
									51.92475585937507
								],
								[
									25.785742187499977,
									51.92382812500006
								],
								[
									25.92529296875,
									51.91352539062498
								],
								[
									26.26708984375,
									51.855029296875074
								],
								[
									26.394335937500074,
									51.84443359375004
								],
								[
									26.453417968750045,
									51.81342773437501
								],
								[
									26.566894531250057,
									51.80190429687508
								],
								[
									26.77343750000003,
									51.77070312500001
								],
								[
									26.952832031249983,
									51.75400390625009
								],
								[
									27.074121093750023,
									51.76083984375006
								],
								[
									27.14199218750008,
									51.752050781250034
								],
								[
									27.270117187500063,
									51.61357421874999
								],
								[
									27.29628906250005,
									51.59741210937506
								],
								[
									27.347656250000057,
									51.59414062500002
								],
								[
									27.452343750000068,
									51.60610351562505
								],
								[
									27.601367187500045,
									51.601611328125045
								],
								[
									27.689746093750017,
									51.57241210937505
								],
								[
									27.67675781250003,
									51.48994140625001
								],
								[
									27.700000000000074,
									51.47797851562498
								],
								[
									27.741308593750034,
									51.48256835937502
								],
								[
									27.788867187500045,
									51.52915039062512
								],
								[
									27.82880859375001,
									51.577441406250074
								],
								[
									27.85859375000004,
									51.59238281250012
								],
								[
									28.010742187500057,
									51.55976562500004
								],
								[
									28.08027343750001,
									51.565039062500034
								],
								[
									28.144433593750023,
									51.601660156250034
								],
								[
									28.18378906250004,
									51.60786132812507
								],
								[
									28.291601562500063,
									51.5818359375001
								],
								[
									28.424609375000074,
									51.56362304687502
								],
								[
									28.532031250000017,
									51.56245117187504
								],
								[
									28.59902343750008,
									51.54262695312511
								],
								[
									28.647753906250045,
									51.45654296874997
								],
								[
									28.690234375000017,
									51.43886718750011
								],
								[
									28.731250000000017,
									51.43339843749996
								],
								[
									28.793261718750045,
									51.510351562500006
								],
								[
									28.84951171875005,
									51.54018554687505
								],
								[
									28.927539062500045,
									51.562158203124994
								],
								[
									28.97773437500004,
									51.57177734375
								],
								[
									29.01308593750005,
									51.59892578125002
								],
								[
									29.060742187499983,
									51.62543945312501
								],
								[
									29.102050781250057,
									51.62753906250009
								],
								[
									29.13564453125008,
									51.617285156250034
								],
								[
									29.174218750000023,
									51.58061523437502
								],
								[
									29.230468750000114,
									51.49702148437504
								],
								[
									29.298828125000114,
									51.41303710937498
								],
								[
									29.346484375000045,
									51.382568359375
								],
								[
									29.46962890625008,
									51.40834960937511
								],
								[
									29.553125000000136,
									51.43457031250003
								],
								[
									29.706054687500114,
									51.43955078125006
								],
								[
									29.908789062500034,
									51.4580078125
								],
								[
									30.063769531250045,
									51.482031250000006
								],
								[
									30.16074218750009,
									51.47788085937506
								],
								[
									30.21953124999999,
									51.451220703125045
								],
								[
									30.308984375000023,
									51.39960937500001
								],
								[
									30.333398437500023,
									51.32553710937509
								],
								[
									30.449511718750045,
									51.274316406249966
								],
								[
									30.544531250000034,
									51.26503906250002
								],
								[
									30.576953125000045,
									51.31835937499997
								],
								[
									30.63251953125001,
									51.35541992187507
								],
								[
									30.611718750000136,
									51.406347656250034
								],
								[
									30.60234374999999,
									51.471240234375045
								],
								[
									30.560742187500068,
									51.53149414062506
								],
								[
									30.53300781249999,
									51.59633789062502
								],
								[
									30.58388671875008,
									51.68896484375006
								],
								[
									30.63945312499999,
									51.770068359375074
								],
								[
									30.66728515624999,
									51.81411132812508
								],
								[
									30.75527343750008,
									51.89516601562508
								],
								[
									30.845703125000114,
									51.95307617187504
								],
								[
									30.980664062500182,
									52.04619140625002
								],
								[
									31.079296875000068,
									52.076953125000074
								],
								[
									31.168457031250057,
									52.06293945312504
								],
								[
									31.217968750000125,
									52.05024414062504
								],
								[
									31.345996093750045,
									52.105371093749994
								],
								[
									31.573730468750114,
									52.10810546875001
								],
								[
									31.763378906250125,
									52.10107421875
								],
								[
									31.782421875000182,
									52.09941406249993
								],
								[
									31.875585937500034,
									52.07089843750006
								],
								[
									31.973828125000182,
									52.046630859375114
								],
								[
									32.041601562500034,
									52.04501953124995
								],
								[
									32.12226562500001,
									52.05058593749993
								],
								[
									32.216796875000114,
									52.082958984374955
								],
								[
									32.282812500000034,
									52.11401367187497
								],
								[
									32.36298828125007,
									52.27211914062502
								],
								[
									32.39130859375007,
									52.29482421875005
								],
								[
									32.435449218749966,
									52.30722656250009
								],
								[
									32.50791015625009,
									52.3085449218751
								],
								[
									32.645410156250136,
									52.279101562500045
								],
								[
									32.80644531250016,
									52.25263671875007
								],
								[
									32.89970703125016,
									52.256347656250114
								],
								[
									33.148437500000114,
									52.340429687500006
								],
								[
									33.287109375000114,
									52.35356445312493
								],
								[
									33.45185546875018,
									52.33378906249999
								],
								[
									33.613378906250034,
									52.33261718750009
								],
								[
									33.73525390625002,
									52.3447753906251
								],
								[
									33.81884765625,
									52.315624999999926
								],
								[
									33.92207031250007,
									52.25146484375
								],
								[
									34.01533203125007,
									52.1559570312501
								],
								[
									34.11308593750016,
									51.97963867187505
								],
								[
									34.39785156250002,
									51.78041992187505
								],
								[
									34.40273437500002,
									51.74150390624993
								],
								[
									34.379296875000136,
									51.7165039062501
								],
								[
									34.23916015625002,
									51.69223632812512
								],
								[
									34.121093750000114,
									51.67915039062501
								],
								[
									34.11542968750001,
									51.64497070312498
								],
								[
									34.14677734374999,
									51.607958984375074
								],
								[
									34.20087890625001,
									51.55380859374998
								],
								[
									34.209277343750045,
									51.48408203124998
								],
								[
									34.206542968750114,
									51.41992187499997
								],
								[
									34.229882812499966,
									51.36323242187507
								],
								[
									34.275000000000034,
									51.34018554687498
								],
								[
									34.28066406250002,
									51.31166992187494
								],
								[
									34.228417968750136,
									51.27685546875006
								],
								[
									34.213867187500114,
									51.255371093750114
								],
								[
									34.23417968750016,
									51.243798828124966
								],
								[
									34.49101562500016,
									51.237060546875114
								],
								[
									34.616796875000034,
									51.20312499999994
								],
								[
									34.712304687500136,
									51.17221679687495
								],
								[
									34.760351562500034,
									51.16933593750008
								],
								[
									34.868554687499966,
									51.18920898437503
								],
								[
									34.990234375,
									51.20175781250012
								],
								[
									35.06406250000009,
									51.2034179687501
								],
								[
									35.09257812500016,
									51.180664062500085
								],
								[
									35.11533203125009,
									51.12084960937497
								],
								[
									35.158105468749966,
									51.06098632812504
								],
								[
									35.198046875000045,
									51.043896484374926
								],
								[
									35.269140625000034,
									51.04677734375008
								],
								[
									35.311914062500136,
									51.043896484374926
								],
								[
									35.33476562499999,
									51.021142578124994
								],
								[
									35.309082031250114,
									50.98691406249995
								],
								[
									35.31474609374999,
									50.949902343749955
								],
								[
									35.34609375000002,
									50.904296875000085
								],
								[
									35.38320312500002,
									50.79892578125012
								],
								[
									35.417382812500136,
									50.76757812499994
								],
								[
									35.44013671875018,
									50.72768554687508
								],
								[
									35.44013671875018,
									50.682080078124926
								],
								[
									35.411621093750114,
									50.64223632812508
								],
								[
									35.391699218750034,
									50.610937500000006
								],
								[
									35.411621093750114,
									50.539697265624966
								],
								[
									35.48847656250007,
									50.45991210937507
								],
								[
									35.545507812500034,
									50.43999023437499
								],
								[
									35.59111328124999,
									50.368750000000034
								],
								[
									35.673730468750136,
									50.34599609375002
								],
								[
									35.796191406250045,
									50.40576171874994
								],
								[
									35.890234375000034,
									50.437109375000034
								],
								[
									36.0078125,
									50.41967773437494
								],
								[
									36.11640625000018,
									50.40854492187498
								],
								[
									36.18945312499994,
									50.36782226562502
								],
								[
									36.24335937500018,
									50.311767578125085
								],
								[
									36.30605468750002,
									50.2804687500001
								],
								[
									36.36884765625018,
									50.296826171874955
								],
								[
									36.499804687500045,
									50.2804687500001
								],
								[
									36.559667968750034,
									50.23486328124994
								],
								[
									36.61943359375016,
									50.20922851562506
								],
								[
									36.696386718750034,
									50.24624023437505
								],
								[
									36.75908203124999,
									50.291845703125006
								],
								[
									36.98847656250001,
									50.339550781249955
								],
								[
									37.131249999999966,
									50.3515136718751
								],
								[
									37.17109375000018,
									50.360888671875045
								],
								[
									37.254882812500114,
									50.39497070312507
								],
								[
									37.343164062499966,
									50.417626953124966
								],
								[
									37.42285156249994,
									50.411474609375034
								],
								[
									37.501367187499966,
									50.34072265625002
								],
								[
									37.582324218750045,
									50.291845703125006
								],
								[
									37.605078125000034,
									50.21494140624998
								],
								[
									37.70419921875009,
									50.10908203125007
								],
								[
									37.950292968750034,
									49.96420898437506
								],
								[
									38.046875000000114,
									49.92001953125012
								],
								[
									38.11250000000007,
									49.92783203125009
								],
								[
									38.14677734374999,
									49.93940429687507
								],
								[
									38.162695312500034,
									49.95454101562504
								],
								[
									38.17753906250016,
									50.025390625000085
								],
								[
									38.20869140625018,
									50.05146484375007
								],
								[
									38.25859375000016,
									50.05234374999998
								],
								[
									38.451171875000114,
									49.96406250000001
								],
								[
									38.55195312500007,
									49.95458984375006
								],
								[
									38.647753906250045,
									49.95288085937506
								],
								[
									38.77666015624999,
									49.884326171875045
								],
								[
									38.91835937500002,
									49.82470703125006
								],
								[
									39.027734374999966,
									49.81840820312502
								],
								[
									39.11494140625018,
									49.84174804687507
								],
								[
									39.174804687500114,
									49.85595703125003
								],
								[
									39.21181640625002,
									49.83320312500001
								],
								[
									39.245996093750136,
									49.781933593749955
								],
								[
									39.30292968750018,
									49.74204101562509
								],
								[
									39.368457031250045,
									49.73066406250007
								],
								[
									39.462792968749966,
									49.728027343750085
								],
								[
									39.626562500000034,
									49.650683593750045
								],
								[
									39.78056640625016,
									49.572021484375
								],
								[
									39.876855468750136,
									49.5676757812501
								],
								[
									39.95849609375,
									49.5907714843751
								],
								[
									40.030664062500136,
									49.596728515625074
								],
								[
									40.08066406250009,
									49.57685546875001
								],
								[
									40.09492187500007,
									49.54267578125007
								],
								[
									40.05781250000007,
									49.497070312500085
								],
								[
									40.05781250000007,
									49.43154296875008
								],
								[
									40.12617187500001,
									49.3688476562501
								],
								[
									40.128320312500136,
									49.30722656250006
								],
								[
									40.108789062500136,
									49.25156250000009
								],
								[
									40.07001953125007,
									49.200292968750034
								],
								[
									39.97636718750016,
									49.12983398437507
								],
								[
									39.88974609375009,
									49.06406250000009
								],
								[
									39.75947265625001,
									49.03657226562498
								],
								[
									39.6865234375,
									49.007910156250006
								],
								[
									39.70566406250009,
									48.95957031250012
								],
								[
									39.75332031250002,
									48.91445312500005
								],
								[
									39.86376953124994,
									48.8779785156251
								],
								[
									39.98916015625002,
									48.851416015625006
								],
								[
									40.00361328125001,
									48.822070312500074
								],
								[
									39.984472656250034,
									48.807373046875085
								],
								[
									39.90410156249999,
									48.79374999999999
								],
								[
									39.792871093749966,
									48.80771484375009
								],
								[
									39.755859375000114,
									48.782080078125006
								],
								[
									39.704589843750114,
									48.739355468750006
								],
								[
									39.670410156250114,
									48.66245117187506
								],
								[
									39.64472656250018,
									48.59121093749994
								],
								[
									39.76542968749999,
									48.57187500000009
								],
								[
									39.83564453125018,
									48.54277343750002
								],
								[
									39.857519531250034,
									48.48422851562509
								],
								[
									39.88261718750016,
									48.41909179687505
								],
								[
									39.88984375000001,
									48.36044921875009
								],
								[
									39.84990234375016,
									48.33193359375005
								],
								[
									39.84746093749999,
									48.302783203125074
								],
								[
									39.866308593750034,
									48.28842773437498
								],
								[
									39.91816406250001,
									48.28193359374998
								],
								[
									39.957910156250136,
									48.26889648437509
								],
								[
									39.961035156250034,
									48.237939453124994
								],
								[
									39.885058593750045,
									48.16835937499994
								],
								[
									39.813964843750114,
									48.03530273437511
								],
								[
									39.775781249999966,
									47.96445312500006
								],
								[
									39.778710937500136,
									47.88754882812512
								],
								[
									39.735937500000034,
									47.84482421875012
								],
								[
									39.65849609375016,
									47.841210937499994
								],
								[
									39.39101562500002,
									47.833740234375085
								],
								[
									39.15849609375016,
									47.837402343750114
								],
								[
									39.05781250000018,
									47.84848632812506
								],
								[
									38.900292968750136,
									47.85512695312508
								],
								[
									38.82226562499994,
									47.837011718750034
								],
								[
									38.71894531250007,
									47.71411132812494
								],
								[
									38.640625,
									47.66591796875008
								],
								[
									38.51093750000001,
									47.622412109375006
								],
								[
									38.36884765625007,
									47.609960937500034
								],
								[
									38.28740234375016,
									47.559179687500006
								],
								[
									38.258789062500114,
									47.479541015625045
								],
								[
									38.25654296875018,
									47.40893554687494
								],
								[
									38.243261718750034,
									47.37368164062505
								],
								[
									38.21240234374994,
									47.34277343749997
								],
								[
									38.20136718750001,
									47.32080078125003
								],
								[
									38.20800781249994,
									47.296533203124966
								],
								[
									38.241015625000045,
									47.287695312500034
								],
								[
									38.28076171874994,
									47.2766601562501
								],
								[
									38.28076171874994,
									47.25903320312506
								],
								[
									38.26533203125018,
									47.236962890624994
								],
								[
									38.22119140625,
									47.21274414062495
								],
								[
									38.20136718750001,
									47.17524414062504
								],
								[
									38.20585937500016,
									47.13559570312495
								],
								[
									38.214355468750114,
									47.09145507812502
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Eastern Europe",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "UKR",
					"su_a3": "UKR",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "UKR",
					"gu_a3": "UKR",
					"abbrev": "Ukr.",
					"region_un": "Europe",
					"adm0_a3_us": "UKR",
					"scalerank": 1,
					"pop_est": 45700395,
					"adm0_dif": 0,
					"un_a3": "804",
					"pop_year": -99,
					"gdp_md_est": 339800,
					"name": "Ukraine",
					"sovereignt": "Ukraine",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Ukraine",
					"postal": "UA",
					"sov_a3": "UKR",
					"note_brk": "",
					"brk_a3": "UKR",
					"wb_a2": "UA",
					"brk_diff": 0,
					"admin": "Ukraine",
					"name_long": "Ukraine",
					"iso_a3": "UKR",
					"iso_a2": "UA",
					"adm0_a3_is": "UKR",
					"level": 2,
					"formal_en": "Ukraine",
					"name_len": 7,
					"mapcolor7": 5,
					"long_len": 7,
					"mapcolor8": 1,
					"mapcolor9": 6,
					"note_adm0": "",
					"iso_n3": "804",
					"homepart": 1,
					"subunit": "Ukraine",
					"name_alt": "",
					"brk_name": "Ukraine",
					"name_sort": "Ukraine",
					"continent": "Europe",
					"mapcolor13": 3,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								-53.16853192343419,
								-32.67175646378118
							],
							[
								-53.17773437500003,
								-32.67880859374996
							],
							[
								-53.21704101562497,
								-32.70722656249998
							],
							[
								-53.26508789062498,
								-32.73310546875001
							],
							[
								-53.30156249999996,
								-32.76074218749996
							],
							[
								-53.31279296875002,
								-32.7931640625
							],
							[
								-53.31308593749998,
								-32.83427734375002
							],
							[
								-53.323144531249994,
								-32.88271484375004
							],
							[
								-53.35449218749997,
								-32.925878906250034
							],
							[
								-53.40615234375002,
								-32.954101562500014
							],
							[
								-53.47280273437502,
								-32.95878906249999
							],
							[
								-53.54609375000004,
								-33.02441406250003
							],
							[
								-53.599511718749994,
								-33.07871093749999
							],
							[
								-53.62421875000004,
								-33.13574218749997
							],
							[
								-53.62016601562502,
								-33.1912109375
							],
							[
								-53.60424804687497,
								-33.242187499999986
							],
							[
								-53.58637695312498,
								-33.298730468749966
							],
							[
								-53.57749023437495,
								-33.36757812500005
							],
							[
								-53.573486328125,
								-33.433300781250026
							],
							[
								-53.567285156249994,
								-33.48251953125002
							],
							[
								-53.55717773437499,
								-33.514648437499986
							],
							[
								-53.543798828125006,
								-33.53945312499998
							],
							[
								-53.533192151790786,
								-33.54781549010977
							],
							[
								-53.53764648437499,
								-33.6228515625
							],
							[
								-53.53134765624995,
								-33.65546874999998
							],
							[
								-53.51884765624999,
								-33.677246093749986
							],
							[
								-53.46357421875001,
								-33.709863281249966
							],
							[
								-53.39755859374998,
								-33.73730468749996
							],
							[
								-53.37060546874997,
								-33.742187499999986
							],
							[
								-53.41958007812502,
								-33.779199218749966
							],
							[
								-53.47246093749996,
								-33.84931640625004
							],
							[
								-53.53452148437498,
								-34.01748046875002
							],
							[
								-53.74291992187497,
								-34.24951171874996
							],
							[
								-53.785302734374994,
								-34.38037109374997
							],
							[
								-54.01025390625,
								-34.516992187499994
							],
							[
								-54.168554687500006,
								-34.67070312499996
							],
							[
								-54.272119140624966,
								-34.66689453124998
							],
							[
								-54.36533203124995,
								-34.73271484374999
							],
							[
								-54.90229492187501,
								-34.93281249999998
							],
							[
								-55.09511718749994,
								-34.895117187500034
							],
							[
								-55.23789062499998,
								-34.89580078124999
							],
							[
								-55.37060546875003,
								-34.80761718749997
							],
							[
								-55.67314453125002,
								-34.77568359375003
							],
							[
								-55.862939453124966,
								-34.81093750000002
							],
							[
								-56.11791992187494,
								-34.90791015624997
							],
							[
								-56.19462890624993,
								-34.906445312500026
							],
							[
								-56.24995117187501,
								-34.90126953125004
							],
							[
								-56.387841796874966,
								-34.86103515625001
							],
							[
								-56.46308593750001,
								-34.77539062499997
							],
							[
								-56.855175781249955,
								-34.67666015625002
							],
							[
								-57.17070312499993,
								-34.45234374999997
							],
							[
								-57.54345703125003,
								-34.44804687499999
							],
							[
								-57.82910156249994,
								-34.47734375
							],
							[
								-57.87324218749998,
								-34.447656249999994
							],
							[
								-57.90214843749999,
								-34.39013671875
							],
							[
								-57.96123046874996,
								-34.30693359375002
							],
							[
								-58.20703125000003,
								-34.109082031250026
							],
							[
								-58.40019531249996,
								-33.91240234375002
							],
							[
								-58.43813476562494,
								-33.719140624999994
							],
							[
								-58.41132812499998,
								-33.50888671874996
							],
							[
								-58.353369140625006,
								-33.26005859374999
							],
							[
								-58.36352539062503,
								-33.18232421874997
							],
							[
								-58.29218749999998,
								-33.13798828124999
							],
							[
								-58.221582031249966,
								-33.12910156250004
							],
							[
								-58.15356445312497,
								-33.06464843749997
							],
							[
								-58.092675781249994,
								-32.96738281249996
							],
							[
								-58.08232421874993,
								-32.893652343750034
							],
							[
								-58.12958984374998,
								-32.75722656250005
							],
							[
								-58.16220703124995,
								-32.566503906250006
							],
							[
								-58.201171875,
								-32.47167968749996
							],
							[
								-58.12304687499997,
								-32.32187499999999
							],
							[
								-58.119726562500006,
								-32.248925781249966
							],
							[
								-58.16479492187494,
								-32.184863281249974
							],
							[
								-58.17700195312494,
								-32.119042968749966
							],
							[
								-58.156347656250006,
								-32.05156249999999
							],
							[
								-58.16040039062494,
								-31.98652343749997
							],
							[
								-58.18901367187499,
								-31.92421874999998
							],
							[
								-58.16748046874997,
								-31.872656249999963
							],
							[
								-58.09584960937494,
								-31.83183593749999
							],
							[
								-58.04233398437495,
								-31.769238281250026
							],
							[
								-58.006982421874966,
								-31.684960937499994
							],
							[
								-57.988867187500006,
								-31.62060546875003
							],
							[
								-57.98798828124998,
								-31.576171874999957
							],
							[
								-58.009667968749966,
								-31.53437499999997
							],
							[
								-58.053857421874994,
								-31.494921875000003
							],
							[
								-58.03339843750001,
								-31.416601562500034
							],
							[
								-57.948339843750006,
								-31.299414062499963
							],
							[
								-57.89335937499999,
								-31.195312499999986
							],
							[
								-57.86840820312497,
								-31.104394531250023
							],
							[
								-57.870068359374955,
								-31.031054687500003
							],
							[
								-57.89829101562492,
								-30.97519531249999
							],
							[
								-57.88632812499998,
								-30.937402343750023
							],
							[
								-57.83408203124998,
								-30.917480468749957
							],
							[
								-57.81059570312499,
								-30.85859375000004
							],
							[
								-57.818554687499926,
								-30.71201171875002
							],
							[
								-57.87250976562501,
								-30.591015624999983
							],
							[
								-57.83120117187502,
								-30.495214843750006
							],
							[
								-57.71269531249996,
								-30.384472656249997
							],
							[
								-57.65087890624997,
								-30.295019531249977
							],
							[
								-57.645751953125,
								-30.226953124999966
							],
							[
								-57.60888671875003,
								-30.187792968750074
							],
							[
								-57.55229492187496,
								-30.261230468749943
							],
							[
								-57.38383789062502,
								-30.280664062499994
							],
							[
								-57.21445312499998,
								-30.28339843750001
							],
							[
								-57.18691406249994,
								-30.26484374999997
							],
							[
								-57.12050781250002,
								-30.14443359374995
							],
							[
								-57.03271484374997,
								-30.109960937500034
							],
							[
								-56.93725585937497,
								-30.10107421875
							],
							[
								-56.83271484375001,
								-30.107226562500003
							],
							[
								-56.72167968750003,
								-30.18691406249998
							],
							[
								-56.4072265625,
								-30.44746093750004
							],
							[
								-56.176171874999994,
								-30.628417968749957
							],
							[
								-56.105859374999994,
								-30.713769531250023
							],
							[
								-56.044824218749994,
								-30.77763671874999
							],
							[
								-55.998974609374955,
								-30.837207031250045
							],
							[
								-56.01845703125002,
								-30.99189453124994
							],
							[
								-56.015527343749966,
								-31.059667968749977
							],
							[
								-56.00468749999999,
								-31.079199218749963
							],
							[
								-55.95200195312498,
								-31.080859374999946
							],
							[
								-55.87368164062502,
								-31.06962890624996
							],
							[
								-55.807763671874994,
								-31.036718750000006
							],
							[
								-55.75634765625,
								-30.98710937500003
							],
							[
								-55.705957031249966,
								-30.946582031249946
							],
							[
								-55.66523437500001,
								-30.924902343749963
							],
							[
								-55.65048828124995,
								-30.89208984375003
							],
							[
								-55.62714843749998,
								-30.85810546875004
							],
							[
								-55.60302734374994,
								-30.85078124999997
							],
							[
								-55.557324218749955,
								-30.87597656250003
							],
							[
								-55.44956054687495,
								-30.964453125000034
							],
							[
								-55.36606445312498,
								-31.04619140624999
							],
							[
								-55.34550781249999,
								-31.092968749999926
							],
							[
								-55.31328124999999,
								-31.14169921874999
							],
							[
								-55.278955078124994,
								-31.184179687500034
							],
							[
								-55.25463867187503,
								-31.225585937499943
							],
							[
								-55.173535156249926,
								-31.279589843749932
							],
							[
								-55.09116210937495,
								-31.31396484375
							],
							[
								-55.036035156249994,
								-31.279003906249983
							],
							[
								-54.89599609374997,
								-31.391210937499935
							],
							[
								-54.58764648437503,
								-31.485156249999974
							],
							[
								-54.53090820312502,
								-31.5419921875
							],
							[
								-54.47768554687502,
								-31.622753906250026
							],
							[
								-54.36992187499999,
								-31.74501953124998
							],
							[
								-54.22055664062495,
								-31.855175781249955
							],
							[
								-54.10043945312498,
								-31.901562499999983
							],
							[
								-53.98515624999996,
								-31.92812499999998
							],
							[
								-53.920605468749955,
								-31.952343750000026
							],
							[
								-53.87651367187502,
								-31.994531249999923
							],
							[
								-53.80610351562498,
								-32.03994140624994
							],
							[
								-53.76171875,
								-32.0568359375
							],
							[
								-53.74658203125003,
								-32.09746093749993
							],
							[
								-53.70112304687498,
								-32.18632812499992
							],
							[
								-53.65361328124999,
								-32.29873046874998
							],
							[
								-53.601708984374994,
								-32.40302734375001
							],
							[
								-53.48940429687502,
								-32.50322265624999
							],
							[
								-53.36274414062498,
								-32.58115234374996
							],
							[
								-53.23125000000002,
								-32.62539062500001
							],
							[
								-53.16853192343419,
								-32.67175646378118
							]
						]
					],
					"type": "Polygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South America",
					"labelrank": 4,
					"adm0_a3_un": -99,
					"adm0_a3": "URY",
					"su_a3": "URY",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "URY",
					"gu_a3": "URY",
					"abbrev": "Ury.",
					"region_un": "Americas",
					"adm0_a3_us": "URY",
					"scalerank": 1,
					"pop_est": 3494382,
					"adm0_dif": 0,
					"un_a3": "858",
					"pop_year": -99,
					"gdp_md_est": 43160,
					"name": "Uruguay",
					"sovereignt": "Uruguay",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Uruguay",
					"postal": "UY",
					"sov_a3": "URY",
					"note_brk": "",
					"brk_a3": "URY",
					"wb_a2": "UY",
					"brk_diff": 0,
					"admin": "Uruguay",
					"name_long": "Uruguay",
					"iso_a3": "URY",
					"iso_a2": "UY",
					"adm0_a3_is": "URY",
					"level": 2,
					"formal_en": "Oriental Republic of Uruguay",
					"name_len": 7,
					"mapcolor7": 1,
					"long_len": 7,
					"mapcolor8": 2,
					"mapcolor9": 2,
					"note_adm0": "",
					"iso_n3": "858",
					"homepart": 1,
					"subunit": "Uruguay",
					"name_alt": "",
					"brk_name": "Uruguay",
					"name_sort": "Uruguay",
					"continent": "South America",
					"mapcolor13": 10,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2004
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-155.58134765625,
									19.012011718750074
								],
								[
									-155.62563476562502,
									18.96391601562513
								],
								[
									-155.68076171874998,
									18.967675781249994
								],
								[
									-155.88129882812495,
									19.070507812499983
								],
								[
									-155.90561523437503,
									19.125830078124977
								],
								[
									-155.89072265625003,
									19.382519531249955
								],
								[
									-155.96582031249994,
									19.590820312499943
								],
								[
									-156.04868164062498,
									19.74995117187504
								],
								[
									-155.98842773437502,
									19.83159179687496
								],
								[
									-155.90888671875,
									19.89472656250004
								],
								[
									-155.8203125,
									20.014160156249943
								],
								[
									-155.8927734375,
									20.16738281250008
								],
								[
									-155.87426757812494,
									20.25981445312499
								],
								[
									-155.83164062499998,
									20.27583007812504
								],
								[
									-155.6220703125,
									20.163427734374977
								],
								[
									-155.19877929687502,
									19.994384765625
								],
								[
									-155.08608398437497,
									19.875634765624966
								],
								[
									-155.06591796875003,
									19.748193359374937
								],
								[
									-154.989013671875,
									19.731982421875102
								],
								[
									-154.95258789062504,
									19.644628906249977
								],
								[
									-154.84135742187505,
									19.56816406250013
								],
								[
									-154.80419921875,
									19.524462890625102
								],
								[
									-154.85029296874998,
									19.45410156249997
								],
								[
									-155.053466796875,
									19.31918945312512
								],
								[
									-155.30961914062493,
									19.26015625000008
								],
								[
									-155.53525390624998,
									19.10908203125004
								],
								[
									-155.58134765625,
									19.012011718750074
								]
							]
						],
						[
							[
								[
									-156.84960937499997,
									20.772656249999926
								],
								[
									-156.90888671874995,
									20.744482421875063
								],
								[
									-156.97338867187497,
									20.757519531249955
								],
								[
									-156.98842773437502,
									20.825683593750085
								],
								[
									-157.0505859375,
									20.912451171875063
								],
								[
									-156.94179687500002,
									20.93002929687509
								],
								[
									-156.88056640624998,
									20.90483398437513
								],
								[
									-156.84829101562497,
									20.877783203125034
								],
								[
									-156.80937499999993,
									20.831152343750034
								],
								[
									-156.84960937499997,
									20.772656249999926
								]
							]
						],
						[
							[
								[
									-156.48681640624994,
									20.932568359375097
								],
								[
									-156.46083984375,
									20.91474609375001
								],
								[
									-156.35439453124997,
									20.94145507812513
								],
								[
									-156.27753906250007,
									20.95126953125009
								],
								[
									-156.14833984375002,
									20.885498046875
								],
								[
									-156.10351562500003,
									20.840332031249943
								],
								[
									-156.01865234374998,
									20.792089843749977
								],
								[
									-155.98984374999998,
									20.75712890624996
								],
								[
									-156.01357421875002,
									20.714794921874955
								],
								[
									-156.10712890624995,
									20.644775390625085
								],
								[
									-156.23476562499997,
									20.628613281249983
								],
								[
									-156.3099609375,
									20.598779296874937
								],
								[
									-156.40878906249998,
									20.605175781250097
								],
								[
									-156.438232421875,
									20.617871093749926
								],
								[
									-156.44887695312497,
									20.706249999999983
								],
								[
									-156.480078125,
									20.801220703125068
								],
								[
									-156.54384765625002,
									20.789990234375097
								],
								[
									-156.61542968750007,
									20.821826171875074
								],
								[
									-156.689697265625,
									20.90141601562496
								],
								[
									-156.69775390625006,
									20.949072265625063
								],
								[
									-156.65688476562497,
									21.02451171875009
								],
								[
									-156.58540039062495,
									21.034326171875023
								],
								[
									-156.53232421874998,
									20.992675781250085
								],
								[
									-156.48681640624994,
									20.932568359375097
								]
							]
						],
						[
							[
								[
									-157.21362304687497,
									21.215380859375074
								],
								[
									-157.00229492187498,
									21.187939453125068
								],
								[
									-156.95234375000004,
									21.19970703124997
								],
								[
									-156.91718749999998,
									21.17729492187513
								],
								[
									-156.74218750000003,
									21.163525390625068
								],
								[
									-156.71215820312506,
									21.15507812500013
								],
								[
									-156.74790039062503,
									21.103564453125017
								],
								[
									-156.85986328125003,
									21.056347656250068
								],
								[
									-157.02089843749997,
									21.097802734374994
								],
								[
									-157.29033203125,
									21.11259765624999
								],
								[
									-157.27949218749998,
									21.152343750000085
								],
								[
									-157.25380859375,
									21.18056640625008
								],
								[
									-157.249951171875,
									21.229785156250074
								],
								[
									-157.21362304687497,
									21.215380859375074
								]
							]
						],
						[
							[
								[
									-157.79936523437502,
									21.456640625000006
								],
								[
									-157.76499023437503,
									21.450927734375
								],
								[
									-157.7208984375,
									21.457714843749955
								],
								[
									-157.705517578125,
									21.37807617187508
								],
								[
									-157.65415039062503,
									21.333935546875068
								],
								[
									-157.63540039062502,
									21.30761718750003
								],
								[
									-157.69086914062504,
									21.27973632812504
								],
								[
									-157.798779296875,
									21.268603515625074
								],
								[
									-157.84931640624998,
									21.290820312500074
								],
								[
									-157.90175781250002,
									21.340576171875085
								],
								[
									-157.958447265625,
									21.326904296875057
								],
								[
									-157.968310546875,
									21.366894531249926
								],
								[
									-157.97841796875,
									21.37851562500009
								],
								[
									-158.01728515625,
									21.367724609375102
								],
								[
									-157.98095703125,
									21.316113281250068
								],
								[
									-158.079150390625,
									21.312255859375085
								],
								[
									-158.11035156249994,
									21.31860351562503
								],
								[
									-158.13784179687497,
									21.377148437500068
								],
								[
									-158.23911132812498,
									21.489355468750006
								],
								[
									-158.238671875,
									21.533056640625034
								],
								[
									-158.27314453125,
									21.585253906250102
								],
								[
									-158.123095703125,
									21.60024414062505
								],
								[
									-158.02036132812503,
									21.69179687500005
								],
								[
									-157.96250000000003,
									21.70136718750004
								],
								[
									-157.85151367187498,
									21.553369140624994
								],
								[
									-157.85434570312503,
									21.511914062499983
								],
								[
									-157.82958984374994,
									21.471435546875
								],
								[
									-157.79936523437502,
									21.456640625000006
								]
							]
						],
						[
							[
								[
									-160.18002929687498,
									21.841064453125085
								],
								[
									-160.20024414062505,
									21.796875000000057
								],
								[
									-160.23471679687503,
									21.80366210937501
								],
								[
									-160.24345703124993,
									21.843066406250045
								],
								[
									-160.22089843749995,
									21.897265625000074
								],
								[
									-160.1638671875,
									21.94404296875001
								],
								[
									-160.100634765625,
									22.015234375000034
								],
								[
									-160.04873046874997,
									22.004638671875
								],
								[
									-160.076708984375,
									21.958105468750034
								],
								[
									-160.08002929687507,
									21.90742187500001
								],
								[
									-160.15341796874998,
									21.878759765625034
								],
								[
									-160.18002929687498,
									21.841064453125085
								]
							]
						],
						[
							[
								[
									-159.37275390625,
									21.93237304687503
								],
								[
									-159.460693359375,
									21.876123046874937
								],
								[
									-159.51186523437502,
									21.900390625000085
								],
								[
									-159.60883789062498,
									21.90952148437509
								],
								[
									-159.64638671875,
									21.951757812499977
								],
								[
									-159.747998046875,
									21.989843750000006
								],
								[
									-159.78916015625003,
									22.041796875000102
								],
								[
									-159.726611328125,
									22.140185546875074
								],
								[
									-159.57919921874998,
									22.22314453125003
								],
								[
									-159.35205078124997,
									22.219580078125006
								],
								[
									-159.30478515625003,
									22.154052734375057
								],
								[
									-159.30068359375,
									22.10527343749999
								],
								[
									-159.33017578124998,
									22.050683593749966
								],
								[
									-159.34374999999997,
									21.973632812500085
								],
								[
									-159.37275390625,
									21.93237304687503
								]
							]
						],
						[
							[
								[
									-81.783837890625,
									24.544580078125108
								],
								[
									-81.80922851562502,
									24.54233398437509
								],
								[
									-81.81142578125002,
									24.55781250000004
								],
								[
									-81.76767578124998,
									24.576708984375074
								],
								[
									-81.73867187500002,
									24.575439453125085
								],
								[
									-81.73974609374997,
									24.554492187500074
								],
								[
									-81.783837890625,
									24.544580078125108
								]
							]
						],
						[
							[
								[
									-81.56669921874999,
									24.599902343750074
								],
								[
									-81.63149414062494,
									24.59003906250004
								],
								[
									-81.57924804687497,
									24.629394531250057
								],
								[
									-81.56230468749999,
									24.689160156250068
								],
								[
									-81.53164062499994,
									24.642480468749966
								],
								[
									-81.53222656249997,
									24.614160156249966
								],
								[
									-81.56669921874999,
									24.599902343750074
								]
							]
						],
						[
							[
								[
									-81.334814453125,
									24.65048828125009
								],
								[
									-81.36479492187496,
									24.62993164062499
								],
								[
									-81.37905273437494,
									24.63627929687513
								],
								[
									-81.37905273437494,
									24.666259765625114
								],
								[
									-81.42167968750002,
									24.73261718750004
								],
								[
									-81.42006835937497,
									24.75000000000003
								],
								[
									-81.32231445312502,
									24.68505859375003
								],
								[
									-81.31982421874997,
									24.667626953124937
								],
								[
									-81.334814453125,
									24.65048828125009
								]
							]
						],
						[
							[
								[
									-81.04418945312503,
									24.716796875000085
								],
								[
									-81.08999023437494,
									24.693115234375057
								],
								[
									-81.137353515625,
									24.710498046875045
								],
								[
									-81.08525390624996,
									24.734179687500074
								],
								[
									-80.93046874999996,
									24.759472656250097
								],
								[
									-80.98891601562497,
									24.727880859375034
								],
								[
									-81.04418945312503,
									24.716796875000085
								]
							]
						],
						[
							[
								[
									-80.82939453124996,
									24.80366210937504
								],
								[
									-80.84833984375001,
									24.80366210937504
								],
								[
									-80.83886718750003,
									24.817871093750085
								],
								[
									-80.79941406249998,
									24.846289062500006
								],
								[
									-80.78520507812502,
									24.835253906250074
								],
								[
									-80.786767578125,
									24.821044921875114
								],
								[
									-80.82939453124996,
									24.80366210937504
								]
							]
						],
						[
							[
								[
									-80.63828125000003,
									24.903173828125063
								],
								[
									-80.66513671874998,
									24.89843749999997
								],
								[
									-80.62568359374995,
									24.941113281250068
								],
								[
									-80.614599609375,
									24.93793945312504
								],
								[
									-80.63828125000003,
									24.903173828125063
								]
							]
						],
						[
							[
								[
									-80.3818359375,
									25.14228515625001
								],
								[
									-80.58056640625,
									24.95424804687508
								],
								[
									-80.55854492187495,
									25.001318359374977
								],
								[
									-80.48105468749998,
									25.10195312500005
								],
								[
									-80.45600585937501,
									25.149316406250023
								],
								[
									-80.403662109375,
									25.179345703125108
								],
								[
									-80.35493164062493,
									25.233642578125057
								],
								[
									-80.35126953124998,
									25.29697265625009
								],
								[
									-80.28046874999995,
									25.341259765624955
								],
								[
									-80.257080078125,
									25.347607421875097
								],
								[
									-80.3818359375,
									25.14228515625001
								]
							]
						],
						[
							[
								[
									-82.03720703125,
									26.453613281250085
								],
								[
									-82.07285156249998,
									26.427539062500017
								],
								[
									-82.14497070312493,
									26.44667968750008
								],
								[
									-82.18437499999996,
									26.48095703124997
								],
								[
									-82.20136718749995,
									26.548046874999955
								],
								[
									-82.13857421874997,
									26.47700195312504
								],
								[
									-82.116064453125,
									26.46093749999997
								],
								[
									-82.03720703125,
									26.453613281250085
								]
							]
						],
						[
							[
								[
									-82.08378906249999,
									26.55234374999995
								],
								[
									-82.085205078125,
									26.493603515625068
								],
								[
									-82.13559570312498,
									26.59199218750004
								],
								[
									-82.16914062499998,
									26.700732421875074
								],
								[
									-82.12114257812496,
									26.66552734375
								],
								[
									-82.08378906249999,
									26.55234374999995
								]
							]
						],
						[
							[
								[
									-97.17070312499996,
									26.159375000000097
								],
								[
									-97.18452148437495,
									26.11293945312505
								],
								[
									-97.26733398437503,
									26.329785156250068
								],
								[
									-97.40209960937494,
									26.820507812499955
								],
								[
									-97.40717773437501,
									27.100195312500006
								],
								[
									-97.38598632812494,
									27.196484375000068
								],
								[
									-97.35122070312497,
									26.801464843749983
								],
								[
									-97.20224609375,
									26.299804687500114
								],
								[
									-97.17070312499996,
									26.159375000000097
								]
							]
						],
						[
							[
								[
									-97.35361328125,
									27.30004882812503
								],
								[
									-97.38481445312499,
									27.242529296875034
								],
								[
									-97.376220703125,
									27.328271484375023
								],
								[
									-97.29501953124998,
									27.523095703125108
								],
								[
									-97.13002929687494,
									27.77915039062495
								],
								[
									-97.060546875,
									27.82202148437497
								],
								[
									-97.25087890624997,
									27.541210937500068
								],
								[
									-97.35361328125,
									27.30004882812503
								]
							]
						],
						[
							[
								[
									-80.18676757812497,
									27.278417968750063
								],
								[
									-80.17050781250003,
									27.204785156250097
								],
								[
									-80.26245117187503,
									27.375585937499977
								],
								[
									-80.37607421874998,
									27.643408203125006
								],
								[
									-80.43691406249994,
									27.850537109374926
								],
								[
									-80.395751953125,
									27.794531250000063
								],
								[
									-80.35551757812496,
									27.67861328125008
								],
								[
									-80.18676757812497,
									27.278417968750063
								]
							]
						],
						[
							[
								[
									-97.01435546875001,
									27.90161132812503
								],
								[
									-97.03603515624997,
									27.89916992187497
								],
								[
									-96.98764648437498,
									27.981054687500034
								],
								[
									-96.97866210937502,
									28.013867187499983
								],
								[
									-96.89931640625002,
									28.117480468750045
								],
								[
									-96.857421875,
									28.132910156250063
								],
								[
									-96.83974609374997,
									28.088818359375068
								],
								[
									-96.92133789062498,
									28.01601562500005
								],
								[
									-97.01435546875001,
									27.90161132812503
								]
							]
						],
						[
							[
								[
									-96.76440429687497,
									28.152587890625
								],
								[
									-96.801123046875,
									28.14843750000003
								],
								[
									-96.75561523437497,
									28.202441406250017
								],
								[
									-96.681640625,
									28.229687499999983
								],
								[
									-96.51933593749996,
									28.333447265624983
								],
								[
									-96.45312499999997,
									28.340576171875114
								],
								[
									-96.41865234374995,
									28.37631835937509
								],
								[
									-96.403564453125,
									28.38159179687503
								],
								[
									-96.41333007812494,
									28.33779296875008
								],
								[
									-96.54389648437498,
									28.27558593750001
								],
								[
									-96.76440429687497,
									28.152587890625
								]
							]
						],
						[
							[
								[
									-95.03969726562497,
									29.145898437500023
								],
								[
									-95.08964843750002,
									29.13632812499995
								],
								[
									-94.87167968750003,
									29.29013671875012
								],
								[
									-94.82597656249996,
									29.341308593750057
								],
								[
									-94.76762695312496,
									29.339062499999955
								],
								[
									-94.86494140624998,
									29.252880859374983
								],
								[
									-95.03969726562497,
									29.145898437500023
								]
							]
						],
						[
							[
								[
									-91.793701171875,
									29.50073242187503
								],
								[
									-91.83085937499993,
									29.486474609374966
								],
								[
									-91.99624023437497,
									29.57309570312512
								],
								[
									-92.00664062499996,
									29.610302734375068
								],
								[
									-91.92504882812503,
									29.64394531250008
								],
								[
									-91.875244140625,
									29.64096679687509
								],
								[
									-91.79648437499995,
									29.596972656250102
								],
								[
									-91.76767578125003,
									29.584716796875085
								],
								[
									-91.75429687499997,
									29.56689453125
								],
								[
									-91.76191406250001,
									29.53901367187501
								],
								[
									-91.793701171875,
									29.50073242187503
								]
							]
						],
						[
							[
								[
									-84.90791015624998,
									29.642626953125074
								],
								[
									-85.00825195312498,
									29.606640624999926
								],
								[
									-85.11674804687499,
									29.63281250000003
								],
								[
									-85.04931640625,
									29.637792968750063
								],
								[
									-85.00053710937502,
									29.627197265624943
								],
								[
									-84.87700195312499,
									29.67866210937504
								],
								[
									-84.81220703124993,
									29.717626953124977
								],
								[
									-84.737158203125,
									29.73242187499997
								],
								[
									-84.90791015624998,
									29.642626953125074
								]
							]
						],
						[
							[
								[
									-88.88930664062502,
									29.71259765625001
								],
								[
									-88.94360351562497,
									29.66025390625012
								],
								[
									-88.94111328124998,
									29.680224609375102
								],
								[
									-88.90117187499993,
									29.732617187499926
								],
								[
									-88.87265625,
									29.75297851562499
								],
								[
									-88.88930664062502,
									29.71259765625001
								]
							]
						],
						[
							[
								[
									-88.82744140625002,
									29.80771484374995
								],
								[
									-88.85566406249998,
									29.775878906249943
								],
								[
									-88.82797851562503,
									29.928369140625023
								],
								[
									-88.86689453124998,
									30.056738281250063
								],
								[
									-88.82587890624995,
									30.000390625000023
								],
								[
									-88.81259765625,
									29.933349609375057
								],
								[
									-88.82744140625002,
									29.80771484374995
								]
							]
						],
						[
							[
								[
									-89.22397460937498,
									30.084082031250034
								],
								[
									-89.22045898437497,
									30.03759765624997
								],
								[
									-89.26943359375,
									30.060742187499983
								],
								[
									-89.34199218749995,
									30.062841796875063
								],
								[
									-89.31005859375003,
									30.078710937500006
								],
								[
									-89.28764648437499,
									30.094189453124955
								],
								[
									-89.27646484375,
									30.11083984374997
								],
								[
									-89.18466796874998,
									30.16865234375004
								],
								[
									-89.21069335937503,
									30.126220703125
								],
								[
									-89.22397460937498,
									30.084082031250034
								]
							]
						],
						[
							[
								[
									-88.55810546874994,
									30.215917968749977
								],
								[
									-88.570654296875,
									30.204785156249926
								],
								[
									-88.65922851562493,
									30.225585937500085
								],
								[
									-88.71308593749998,
									30.244921874999932
								],
								[
									-88.72285156249993,
									30.264257812500063
								],
								[
									-88.57397460937497,
									30.229150390625108
								],
								[
									-88.55810546874994,
									30.215917968749977
								]
							]
						],
						[
							[
								[
									-88.07133789062499,
									30.252343749999937
								],
								[
									-88.15932617187497,
									30.230908203124926
								],
								[
									-88.28974609374998,
									30.23291015624997
								],
								[
									-88.31625976562498,
									30.240429687500097
								],
								[
									-88.26391601562497,
									30.254736328124977
								],
								[
									-88.109375,
									30.273730468750045
								],
								[
									-88.07133789062499,
									30.252343749999937
								]
							]
						],
						[
							[
								[
									-81.41899414062499,
									30.97143554687497
								],
								[
									-81.4634765625,
									30.727783203125085
								],
								[
									-81.48271484375002,
									30.814062499999977
								],
								[
									-81.48461914062497,
									30.897851562499994
								],
								[
									-81.45092773437503,
									30.947412109374966
								],
								[
									-81.41899414062499,
									30.97143554687497
								]
							]
						],
						[
							[
								[
									-118.35039062499997,
									32.82758789062504
								],
								[
									-118.40859375000002,
									32.81850585937505
								],
								[
									-118.47319335937495,
									32.83891601562493
								],
								[
									-118.52890625000002,
									32.9355957031251
								],
								[
									-118.59018554687498,
									33.01118164062504
								],
								[
									-118.55708007812498,
									33.03266601562507
								],
								[
									-118.50747070312501,
									32.95991210937498
								],
								[
									-118.38320312500001,
									32.84946289062495
								],
								[
									-118.35039062499997,
									32.82758789062504
								]
							]
						],
						[
							[
								[
									-119.43803710937496,
									33.217187499999994
								],
								[
									-119.48251953124996,
									33.21533203124997
								],
								[
									-119.54365234374998,
									33.224609375
								],
								[
									-119.57519531250001,
									33.278320312500114
								],
								[
									-119.52514648437503,
									33.282031250000074
								],
								[
									-119.47880859375,
									33.27460937500007
								],
								[
									-119.44204101562498,
									33.232421875000085
								],
								[
									-119.43803710937496,
									33.217187499999994
								]
							]
						],
						[
							[
								[
									-118.34794921875002,
									33.38574218750006
								],
								[
									-118.29746093750003,
									33.31210937500006
								],
								[
									-118.37021484375002,
									33.32124023437507
								],
								[
									-118.44628906249997,
									33.31708984375001
								],
								[
									-118.46933593749996,
									33.3571289062501
								],
								[
									-118.49204101562498,
									33.41279296875007
								],
								[
									-118.50732421874997,
									33.427001953125114
								],
								[
									-118.55942382812502,
									33.43198242187506
								],
								[
									-118.56333007812502,
									33.43706054687493
								],
								[
									-118.56943359375002,
									33.464160156250045
								],
								[
									-118.55483398437498,
									33.47709960937502
								],
								[
									-118.39169921874996,
									33.41508789062499
								],
								[
									-118.34794921875002,
									33.38574218750006
								]
							]
						],
						[
							[
								[
									-120.04355468749995,
									33.91884765625002
								],
								[
									-120.113916015625,
									33.904882812500034
								],
								[
									-120.167138671875,
									33.91806640625006
								],
								[
									-120.25190429687494,
									34.01386718750004
								],
								[
									-120.07182617187495,
									34.02651367187494
								],
								[
									-119.99438476562497,
									33.98491210937499
								],
								[
									-119.98393554687497,
									33.97333984375004
								],
								[
									-120.04355468749995,
									33.91884765625002
								]
							]
						],
						[
							[
								[
									-120.30659179687498,
									34.024853515624955
								],
								[
									-120.35971679687498,
									34.02226562499996
								],
								[
									-120.44155273437495,
									34.0329101562501
								],
								[
									-120.41293945312498,
									34.056298828124966
								],
								[
									-120.367724609375,
									34.073291015625045
								],
								[
									-120.3533203125,
									34.06059570312496
								],
								[
									-120.30659179687498,
									34.024853515624955
								]
							]
						],
						[
							[
								[
									-119.88237304687497,
									34.079687500000034
								],
								[
									-119.678857421875,
									34.02846679687508
								],
								[
									-119.56914062499993,
									34.052978515625
								],
								[
									-119.54926757812497,
									34.02817382812509
								],
								[
									-119.56220703124994,
									34.00659179687497
								],
								[
									-119.80957031249999,
									33.96777343750006
								],
								[
									-119.885498046875,
									33.99492187499999
								],
								[
									-119.89243164062499,
									34.03217773437504
								],
								[
									-119.91806640624996,
									34.06782226562501
								],
								[
									-119.88237304687497,
									34.079687500000034
								]
							]
						],
						[
							[
								[
									-76.546240234375,
									34.65488281250006
								],
								[
									-76.56850585937502,
									34.65253906250004
								],
								[
									-76.60781250000002,
									34.66357421875006
								],
								[
									-76.66196289062495,
									34.68466796875009
								],
								[
									-76.67392578125,
									34.700146484374955
								],
								[
									-76.62226562499995,
									34.69453125000007
								],
								[
									-76.546240234375,
									34.65488281250006
								]
							]
						],
						[
							[
								[
									-76.50366210937494,
									34.64296874999994
								],
								[
									-76.52856445312497,
									34.63149414062508
								],
								[
									-76.43701171874997,
									34.75634765624994
								],
								[
									-76.25620117187498,
									34.914697265624966
								],
								[
									-76.20737304687498,
									34.938916015624926
								],
								[
									-76.35771484374996,
									34.8036621093751
								],
								[
									-76.50366210937494,
									34.64296874999994
								]
							]
						],
						[
							[
								[
									-75.78193359374998,
									35.19018554687506
								],
								[
									-75.96367187499999,
									35.11884765625007
								],
								[
									-75.98417968749999,
									35.123095703125045
								],
								[
									-75.86494140624995,
									35.174121093750074
								],
								[
									-75.78193359374998,
									35.19018554687506
								]
							]
						],
						[
							[
								[
									-75.54414062499995,
									35.24008789062509
								],
								[
									-75.67827148437502,
									35.212841796874955
								],
								[
									-75.69008789062502,
									35.22158203125005
								],
								[
									-75.53637695312497,
									35.278613281250045
								],
								[
									-75.48789062499995,
									35.479492187500114
								],
								[
									-75.48125000000002,
									35.57211914062506
								],
								[
									-75.50429687500002,
									35.73540039062502
								],
								[
									-75.50351562500003,
									35.769140625000034
								],
								[
									-75.478515625,
									35.71650390624998
								],
								[
									-75.45644531249994,
									35.56416015625004
								],
								[
									-75.46474609374994,
									35.44863281249994
								],
								[
									-75.50932617187496,
									35.28032226562493
								],
								[
									-75.54414062499995,
									35.24008789062509
								]
							]
						],
						[
							[
								[
									-75.63569335937495,
									35.855908203124955
								],
								[
									-75.65078125000002,
									35.835595703124994
								],
								[
									-75.71718749999994,
									35.946142578125034
								],
								[
									-75.64887695312498,
									35.91040039062506
								],
								[
									-75.63666992187498,
									35.88066406250002
								],
								[
									-75.63569335937495,
									35.855908203124955
								]
							]
						],
						[
							[
								[
									-75.33305664062493,
									37.888281250000034
								],
								[
									-75.37851562499998,
									37.872070312500114
								],
								[
									-75.22597656249997,
									38.072314453125045
								],
								[
									-75.13740234374995,
									38.24008789062512
								],
								[
									-75.097900390625,
									38.29809570312494
								],
								[
									-75.13623046875,
									38.18051757812506
								],
								[
									-75.20322265624995,
									38.072412109374966
								],
								[
									-75.33305664062493,
									37.888281250000034
								]
							]
						],
						[
							[
								[
									-74.13320312500002,
									39.68076171875006
								],
								[
									-74.25048828125003,
									39.52939453125006
								],
								[
									-74.25317382812503,
									39.55849609375002
								],
								[
									-74.10673828124996,
									39.74643554687495
								],
								[
									-74.13320312500002,
									39.68076171875006
								]
							]
						],
						[
							[
								[
									-74.18813476562502,
									40.52285156250002
								],
								[
									-74.23588867187496,
									40.51870117187508
								],
								[
									-74.18818359374993,
									40.61459960937506
								],
								[
									-74.10048828125002,
									40.65844726562494
								],
								[
									-74.06875000000002,
									40.64931640625005
								],
								[
									-74.06738281250003,
									40.61542968750007
								],
								[
									-74.07968750000003,
									40.58647460937502
								],
								[
									-74.13852539062503,
									40.54184570312509
								],
								[
									-74.18813476562502,
									40.52285156250002
								]
							]
						],
						[
							[
								[
									-72.50976562500003,
									40.98603515624998
								],
								[
									-72.58085937499996,
									40.92133789062504
								],
								[
									-72.5166015625,
									40.91479492187494
								],
								[
									-72.46132812500002,
									40.9337890625001
								],
								[
									-72.40898437500002,
									40.97216796875
								],
								[
									-72.28745117187503,
									41.02407226562511
								],
								[
									-72.18388671874999,
									41.04677734375011
								],
								[
									-72.15126953125,
									41.05146484375007
								],
								[
									-72.10190429687498,
									41.01503906249994
								],
								[
									-72.00395507812502,
									41.04428710937495
								],
								[
									-71.90322265625002,
									41.06069335937511
								],
								[
									-72.33896484374998,
									40.894140625000006
								],
								[
									-72.428076171875,
									40.87539062500008
								],
								[
									-72.55556640624994,
									40.82578125000012
								],
								[
									-72.67607421874999,
									40.79062500000006
								],
								[
									-72.762841796875,
									40.77783203125003
								],
								[
									-73.19428710937495,
									40.654199218749966
								],
								[
									-73.228515625,
									40.65151367187505
								],
								[
									-73.26552734375,
									40.663574218750114
								],
								[
									-73.62089843750002,
									40.59990234375002
								],
								[
									-73.76674804687497,
									40.59272460937507
								],
								[
									-73.89956054687502,
									40.57050781250007
								],
								[
									-73.80131835937499,
									40.62177734375004
								],
								[
									-73.799169921875,
									40.640966796875034
								],
								[
									-73.82265625,
									40.65595703125007
								],
								[
									-73.87519531249995,
									40.65161132812497
								],
								[
									-73.92900390624999,
									40.59882812500007
								],
								[
									-74.01489257812497,
									40.58120117187502
								],
								[
									-74.03203125000002,
									40.638671875
								],
								[
									-74.00336914062495,
									40.6831542968751
								],
								[
									-73.96455078124993,
									40.725341796875085
								],
								[
									-73.87924804687498,
									40.791650390624994
								],
								[
									-73.75722656249997,
									40.83369140625004
								],
								[
									-73.69521484374997,
									40.87001953125005
								],
								[
									-73.65224609375,
									40.83803710937494
								],
								[
									-73.64282226562503,
									40.88125000000005
								],
								[
									-73.60976562499997,
									40.90620117187507
								],
								[
									-73.573828125,
									40.919628906249955
								],
								[
									-73.48740234374998,
									40.91997070312493
								],
								[
									-73.44086914062501,
									40.926757812500085
								],
								[
									-73.4072265625,
									40.94111328124998
								],
								[
									-73.37270507812497,
									40.9437988281251
								],
								[
									-73.278173828125,
									40.92421875000008
								],
								[
									-73.18583984375002,
									40.929833984374994
								],
								[
									-73.11127929687501,
									40.95688476562509
								],
								[
									-73.03378906250003,
									40.96596679687508
								],
								[
									-72.82880859375001,
									40.97207031250008
								],
								[
									-72.62509765625,
									40.99184570312511
								],
								[
									-72.54365234375001,
									41.02700195312508
								],
								[
									-72.37255859374997,
									41.125537109375074
								],
								[
									-72.27412109374998,
									41.15302734374998
								],
								[
									-72.42739257812494,
									41.038525390624926
								],
								[
									-72.50976562500003,
									40.98603515624998
								]
							]
						],
						[
							[
								[
									-69.9779296875,
									41.2655761718751
								],
								[
									-70.055078125,
									41.24946289062501
								],
								[
									-70.23305664062502,
									41.28632812500007
								],
								[
									-70.08662109374993,
									41.31757812500004
								],
								[
									-70.06269531249995,
									41.32846679687512
								],
								[
									-70.04360351562497,
									41.374414062499966
								],
								[
									-70.04121093750001,
									41.39746093750006
								],
								[
									-69.98559570312497,
									41.29863281249999
								],
								[
									-69.9779296875,
									41.2655761718751
								]
							]
						],
						[
							[
								[
									-70.50991210937502,
									41.376318359375006
								],
								[
									-70.785302734375,
									41.32744140624999
								],
								[
									-70.82919921874995,
									41.35898437500012
								],
								[
									-70.760498046875,
									41.373583984375074
								],
								[
									-70.67373046875,
									41.448535156250074
								],
								[
									-70.61601562499996,
									41.45722656250007
								],
								[
									-70.52534179687495,
									41.41479492187503
								],
								[
									-70.50991210937502,
									41.376318359375006
								]
							]
						],
						[
							[
								[
									-71.36533203125003,
									41.485253906249994
								],
								[
									-71.39306640625,
									41.466748046874955
								],
								[
									-71.40341796874998,
									41.51503906250002
								],
								[
									-71.38398437500001,
									41.57055664062506
								],
								[
									-71.36430664062499,
									41.571826171875045
								],
								[
									-71.35449218749994,
									41.542285156250074
								],
								[
									-71.36533203125003,
									41.485253906249994
								]
							]
						],
						[
							[
								[
									-71.24140625000001,
									41.49194335937503
								],
								[
									-71.29091796874997,
									41.46459960937506
								],
								[
									-71.34624023437496,
									41.46938476562505
								],
								[
									-71.31816406250002,
									41.506298828124926
								],
								[
									-71.30747070312498,
									41.560498046874955
								],
								[
									-71.28017578125,
									41.62001953125008
								],
								[
									-71.26445312499999,
									41.638232421875074
								],
								[
									-71.23203124999995,
									41.65429687499997
								],
								[
									-71.24140625000001,
									41.49194335937503
								]
							]
						],
						[
							[
								[
									-78.92993164062497,
									43.0224609375
								],
								[
									-78.960546875,
									42.98823242187504
								],
								[
									-78.99028320312502,
									42.991552734375006
								],
								[
									-79.01201171874999,
									43.00268554687506
								],
								[
									-79.01943359375,
									43.02421874999999
								],
								[
									-79.01416015625,
									43.05151367187506
								],
								[
									-78.98798828124998,
									43.06352539062502
								],
								[
									-78.91621093750001,
									43.05317382812504
								],
								[
									-78.91386718749999,
									43.042333984375034
								],
								[
									-78.92993164062497,
									43.0224609375
								]
							]
						],
						[
							[
								[
									-76.26201171875002,
									43.99013671875005
								],
								[
									-76.27666015624999,
									43.98706054687503
								],
								[
									-76.27514648437503,
									44.00859374999999
								],
								[
									-76.25981445312502,
									44.02241210937504
								],
								[
									-76.23056640625,
									44.02851562500004
								],
								[
									-76.23129882812498,
									44.01777343749998
								],
								[
									-76.26201171875002,
									43.99013671875005
								]
							]
						],
						[
							[
								[
									-68.62319335937497,
									44.196044921875085
								],
								[
									-68.66118164062496,
									44.17626953125003
								],
								[
									-68.70170898437496,
									44.18266601562502
								],
								[
									-68.70302734374997,
									44.23198242187493
								],
								[
									-68.69077148437495,
									44.24873046875007
								],
								[
									-68.67675781250003,
									44.25620117187498
								],
								[
									-68.65595703124998,
									44.242333984374994
								],
								[
									-68.62319335937497,
									44.196044921875085
								]
							]
						],
						[
							[
								[
									-76.11123046875002,
									44.27729492187501
								],
								[
									-76.14272460937497,
									44.26923828125007
								],
								[
									-76.15029296875,
									44.28105468749999
								],
								[
									-76.14521484375001,
									44.292089843750006
								],
								[
									-76.11914062499994,
									44.30585937500007
								],
								[
									-76.07543945312503,
									44.305761718750034
								],
								[
									-76.08056640625,
									44.29472656250002
								],
								[
									-76.11123046875002,
									44.27729492187501
								]
							]
						],
						[
							[
								[
									-68.18725585937497,
									44.33247070312507
								],
								[
									-68.245458984375,
									44.31298828125
								],
								[
									-68.30927734374995,
									44.321484374999955
								],
								[
									-68.30795898437503,
									44.26870117187505
								],
								[
									-68.315087890625,
									44.24970703125007
								],
								[
									-68.38579101562499,
									44.276855468750114
								],
								[
									-68.41171875000003,
									44.29433593749994
								],
								[
									-68.40947265624993,
									44.36425781249997
								],
								[
									-68.347021484375,
									44.43037109375004
								],
								[
									-68.29941406249998,
									44.456494140624926
								],
								[
									-68.238037109375,
									44.438378906249966
								],
								[
									-68.19091796875,
									44.36435546875009
								],
								[
									-68.18725585937497,
									44.33247070312507
								]
							]
						],
						[
							[
								[
									-85.97622070312502,
									45.102148437500006
								],
								[
									-85.98818359374997,
									45.08798828124998
								],
								[
									-86.015771484375,
									45.089160156250045
								],
								[
									-86.03793945312498,
									45.10283203124999
								],
								[
									-86.05957031249994,
									45.14682617187506
								],
								[
									-86.05244140625001,
									45.156396484374966
								],
								[
									-85.99848632812501,
									45.15014648437503
								],
								[
									-85.97983398437495,
									45.13164062499999
								],
								[
									-85.97622070312502,
									45.102148437500006
								]
							]
						],
						[
							[
								[
									-86.99189453124998,
									45.24101562499999
								],
								[
									-87.01035156249992,
									45.22817382812502
								],
								[
									-87.04150390624997,
									45.23666992187498
								],
								[
									-87.05356445312495,
									45.217919921874966
								],
								[
									-87.04663085937494,
									45.171875
								],
								[
									-87.056884765625,
									45.15053710937502
								],
								[
									-87.08417968749995,
									45.153955078124994
								],
								[
									-87.085693359375,
									45.14541015625005
								],
								[
									-87.06152343749997,
									45.12490234375002
								],
								[
									-87.05893554687498,
									45.102441406249994
								],
								[
									-87.07802734374997,
									45.078125
								],
								[
									-87.09633789062497,
									45.066748046875006
								],
								[
									-87.113916015625,
									45.068457031250006
								],
								[
									-87.14135742187497,
									45.04067382812502
								],
								[
									-87.178564453125,
									44.98339843749997
								],
								[
									-87.19130859374994,
									44.95024414062499
								],
								[
									-87.17949218750002,
									44.941064453124966
								],
								[
									-87.1880859375,
									44.921972656250006
								],
								[
									-87.28027343749994,
									44.83486328125002
								],
								[
									-87.3158203125,
									44.826562499999994
								],
								[
									-87.35458984374998,
									44.83881835937501
								],
								[
									-87.38203124999998,
									44.86425781250006
								],
								[
									-87.39824218749999,
									44.902929687500034
								],
								[
									-87.40302734374998,
									44.932861328125
								],
								[
									-87.396484375,
									44.95415039062499
								],
								[
									-87.31552734374992,
									45.031103515625034
								],
								[
									-87.27934570312493,
									45.08149414062498
								],
								[
									-87.2587890625,
									45.137988281250045
								],
								[
									-87.22114257812498,
									45.173974609374994
								],
								[
									-87.16640625000002,
									45.18950195312496
								],
								[
									-87.12202148437504,
									45.224511718749994
								],
								[
									-87.08813476562497,
									45.279150390625006
								],
								[
									-87.04912109375002,
									45.302880859374966
								],
								[
									-87.005029296875,
									45.29580078125002
								],
								[
									-86.98593749999992,
									45.27519531250002
								],
								[
									-86.99189453124998,
									45.24101562499999
								]
							]
						],
						[
							[
								[
									-86.86186523437496,
									45.35224609374998
								],
								[
									-86.89194335937498,
									45.34228515625
								],
								[
									-86.94687499999998,
									45.345703125
								],
								[
									-86.96669921875002,
									45.368310546874966
								],
								[
									-86.93798828125003,
									45.42558593750002
								],
								[
									-86.92631835937496,
									45.414941406249966
								],
								[
									-86.87846679687499,
									45.41416015624998
								],
								[
									-86.86186523437496,
									45.40859375000002
								],
								[
									-86.85659179687497,
									45.394384765625034
								],
								[
									-86.86186523437496,
									45.35224609374998
								]
							]
						],
						[
							[
								[
									-85.55166015624994,
									45.60258789062502
								],
								[
									-85.5859375,
									45.597509765625034
								],
								[
									-85.612060546875,
									45.60927734375005
								],
								[
									-85.60771484374999,
									45.65605468749999
								],
								[
									-85.5728515625,
									45.737890625000034
								],
								[
									-85.53852539062501,
									45.77539062500003
								],
								[
									-85.49233398437502,
									45.76020507812507
								],
								[
									-85.50146484375003,
									45.75024414062497
								],
								[
									-85.49233398437502,
									45.662890625000045
								],
								[
									-85.50908203124996,
									45.62446289062501
								],
								[
									-85.55166015624994,
									45.60258789062502
								]
							]
						],
						[
							[
								[
									-84.55717773437493,
									45.820458984374994
								],
								[
									-84.42900390624993,
									45.806542968749994
								],
								[
									-84.416748046875,
									45.81430664062498
								],
								[
									-84.38027343749997,
									45.78769531250006
								],
								[
									-84.37475585937497,
									45.76538085937506
								],
								[
									-84.39013671875,
									45.74658203125003
								],
								[
									-84.41230468749998,
									45.73627929687507
								],
								[
									-84.44121093749993,
									45.73447265625006
								],
								[
									-84.48750000000004,
									45.753515625000034
								],
								[
									-84.56308593749998,
									45.803857421874966
								],
								[
									-84.55717773437493,
									45.820458984374994
								]
							]
						],
						[
							[
								[
									-83.50346679687493,
									46.01313476562498
								],
								[
									-83.49375,
									45.99082031250006
								],
								[
									-83.51801757812498,
									45.957861328125006
								],
								[
									-83.58828125,
									45.94111328125004
								],
								[
									-83.73076171874996,
									45.94296874999998
								],
								[
									-83.82324218749997,
									45.955664062500006
								],
								[
									-83.86572265625003,
									45.97910156249998
								],
								[
									-83.875146484375,
									45.99125976562496
								],
								[
									-83.87109374999997,
									46.01738281249996
								],
								[
									-83.85058593749994,
									46.01914062500006
								],
								[
									-83.82026367187498,
									46.004980468750006
								],
								[
									-83.77499999999992,
									46.011083984375006
								],
								[
									-83.71479492187501,
									46.037499999999966
								],
								[
									-83.68325195312497,
									46.057226562500006
								],
								[
									-83.68022460937499,
									46.070410156250006
								],
								[
									-83.69941406249998,
									46.095605468749994
								],
								[
									-83.68388671875002,
									46.106250000000045
								],
								[
									-83.60820312499996,
									46.09658203125002
								],
								[
									-83.580078125,
									46.08007812500003
								],
								[
									-83.52900390624998,
									46.023583984374966
								],
								[
									-83.50346679687493,
									46.01313476562498
								]
							]
						],
						[
							[
								[
									-84.12065429687499,
									46.24589843749996
								],
								[
									-84.13486328124995,
									46.24042968750001
								],
								[
									-84.18491210937495,
									46.279443359374966
								],
								[
									-84.19550781249998,
									46.30341796875007
								],
								[
									-84.18813476562497,
									46.32348632812497
								],
								[
									-84.16874999999993,
									46.324462890625
								],
								[
									-84.13730468749992,
									46.306250000000006
								],
								[
									-84.11958007812495,
									46.285009765625034
								],
								[
									-84.11557617187495,
									46.26079101562499
								],
								[
									-84.12065429687499,
									46.24589843749996
								]
							]
						],
						[
							[
								[
									-84.1328125,
									46.36220703125005
								],
								[
									-84.13271484374997,
									46.340673828125006
								],
								[
									-84.163427734375,
									46.345556640625034
								],
								[
									-84.18896484374997,
									46.36005859375004
								],
								[
									-84.20947265624997,
									46.38427734375
								],
								[
									-84.23505859375004,
									46.44453125000004
								],
								[
									-84.274169921875,
									46.48749999999998
								],
								[
									-84.21552734374995,
									46.53608398437504
								],
								[
									-84.18027343749998,
									46.541796875000045
								],
								[
									-84.142431640625,
									46.53090820312505
								],
								[
									-84.13735351562502,
									46.50258789062505
								],
								[
									-84.16508789062499,
									46.45678710937503
								],
								[
									-84.16357421874994,
									46.410009765625006
								],
								[
									-84.1328125,
									46.36220703125005
								]
							]
						],
						[
							[
								[
									-90.71054687499998,
									46.78334960937505
								],
								[
									-90.76772460937497,
									46.76977539062503
								],
								[
									-90.79160156249995,
									46.772314453125006
								],
								[
									-90.78208007812498,
									46.79106445312502
								],
								[
									-90.75229492187495,
									46.813623046874994
								],
								[
									-90.619140625,
									46.869970703125006
								],
								[
									-90.59609375,
									46.86884765625004
								],
								[
									-90.58886718749994,
									46.85541992187498
								],
								[
									-90.65336914062496,
									46.82768554687502
								],
								[
									-90.67753906249999,
									46.81303710937496
								],
								[
									-90.68046874999996,
									46.79780273437507
								],
								[
									-90.71054687499998,
									46.78334960937505
								]
							]
						],
						[
							[
								[
									-90.54667968749999,
									46.919287109375034
								],
								[
									-90.57998046875002,
									46.91352539062501
								],
								[
									-90.65180664062498,
									46.92226562500002
								],
								[
									-90.65043945312499,
									46.93676757812503
								],
								[
									-90.57587890624998,
									46.95698242187507
								],
								[
									-90.54262695312494,
									46.962744140625006
								],
								[
									-90.53481445312497,
									46.95429687500004
								],
								[
									-90.54667968749999,
									46.919287109375034
								]
							]
						],
						[
							[
								[
									-90.70795898437498,
									46.92734374999998
								],
								[
									-90.72275390624998,
									46.92011718750001
								],
								[
									-90.76083984375,
									46.93701171875
								],
								[
									-90.76596679687498,
									46.950830078124966
								],
								[
									-90.75571289062492,
									46.96479492187507
								],
								[
									-90.73808593749999,
									46.96157226562502
								],
								[
									-90.71308593750004,
									46.94116210937503
								],
								[
									-90.70795898437498,
									46.92734374999998
								]
							]
						],
						[
							[
								[
									-90.42666015624994,
									47.02587890624997
								],
								[
									-90.45932617187495,
									47.01010742187506
								],
								[
									-90.47172851562499,
									47.01752929687507
								],
								[
									-90.46386718749997,
									47.04829101562501
								],
								[
									-90.44736328125,
									47.06616210937503
								],
								[
									-90.422119140625,
									47.07114257812506
								],
								[
									-90.40971679687496,
									47.06367187500004
								],
								[
									-90.41015624999997,
									47.04374999999999
								],
								[
									-90.42666015624994,
									47.02587890624997
								]
							]
						],
						[
							[
								[
									-122.85307617187499,
									47.20473632812508
								],
								[
									-122.86259765624997,
									47.185058593750085
								],
								[
									-122.87675781250002,
									47.186132812500034
								],
								[
									-122.90795898437497,
									47.2261230468751
								],
								[
									-122.91191406249999,
									47.25434570312498
								],
								[
									-122.88510742187503,
									47.27470703124996
								],
								[
									-122.84916992187499,
									47.21630859375006
								],
								[
									-122.85307617187499,
									47.20473632812508
								]
							]
						],
						[
							[
								[
									-88.22187500000001,
									47.21059570312505
								],
								[
									-88.24038085937497,
									47.178320312500034
								],
								[
									-88.23676757812504,
									47.158935546875
								],
								[
									-88.35820312499999,
									47.073388671874966
								],
								[
									-88.40224609375,
									47.01928710937497
								],
								[
									-88.43906249999995,
									47.0107421875
								],
								[
									-88.46865234375002,
									47.04760742187506
								],
								[
									-88.46845703124998,
									47.07724609375006
								],
								[
									-88.43842773437498,
									47.09956054687498
								],
								[
									-88.40908203124997,
									47.131445312500006
								],
								[
									-88.40541992187502,
									47.17548828124998
								],
								[
									-88.41674804687503,
									47.19145507812496
								],
								[
									-88.45380859375001,
									47.15185546874997
								],
								[
									-88.43315429687499,
									47.14335937500002
								],
								[
									-88.42705078124999,
									47.13657226562506
								],
								[
									-88.43408203125,
									47.122314453125
								],
								[
									-88.57373046875003,
									47.143310546875
								],
								[
									-88.61572265624997,
									47.174169921875006
								],
								[
									-88.60888671875,
									47.217187499999966
								],
								[
									-88.56196289062501,
									47.27216796875007
								],
								[
									-88.39433593749999,
									47.38872070312502
								],
								[
									-88.3203125,
									47.42109375000004
								],
								[
									-88.110205078125,
									47.472509765625034
								],
								[
									-87.99428710937502,
									47.484228515625006
								],
								[
									-87.87792968750003,
									47.48417968749999
								],
								[
									-87.79345703124994,
									47.46728515625003
								],
								[
									-87.74101562500002,
									47.43364257812502
								],
								[
									-87.79047851562498,
									47.41142578125002
								],
								[
									-88.02065429687497,
									47.392382812500045
								],
								[
									-88.026953125,
									47.38632812500006
								],
								[
									-87.98305664062494,
									47.36791992187503
								],
								[
									-87.97490234374996,
									47.35493164062504
								],
								[
									-88.01552734375,
									47.320849609375045
								],
								[
									-88.22187500000001,
									47.21059570312505
								]
							]
						],
						[
							[
								[
									-122.39414062500002,
									47.395263671875
								],
								[
									-122.39873046874997,
									47.37250976562498
								],
								[
									-122.43710937499998,
									47.35478515624993
								],
								[
									-122.45698242187503,
									47.35932617187507
								],
								[
									-122.45820312500001,
									47.38613281250011
								],
								[
									-122.46855468749999,
									47.390234375000034
								],
								[
									-122.50991210937498,
									47.35800781250006
								],
								[
									-122.50683593749997,
									47.421679687500045
								],
								[
									-122.486474609375,
									47.48876953125006
								],
								[
									-122.46860351562499,
									47.48999023437494
								],
								[
									-122.44208984375001,
									47.44614257812498
								],
								[
									-122.39414062500002,
									47.395263671875
								]
							]
						],
						[
							[
								[
									-122.49726562499997,
									47.59458007812512
								],
								[
									-122.50263671875,
									47.57543945312494
								],
								[
									-122.55781249999997,
									47.59829101562508
								],
								[
									-122.57592773437501,
									47.619482421875034
								],
								[
									-122.57373046875001,
									47.66684570312509
								],
								[
									-122.56010742187499,
									47.697753906250085
								],
								[
									-122.54975585937501,
									47.703955078125006
								],
								[
									-122.51723632812495,
									47.69057617187505
								],
								[
									-122.507861328125,
									47.68266601562493
								],
								[
									-122.49726562499997,
									47.59458007812512
								]
							]
						],
						[
							[
								[
									-88.95517578124992,
									47.92602539062506
								],
								[
									-88.96010742187497,
									47.90947265624996
								],
								[
									-88.92373046875,
									47.90454101562503
								],
								[
									-88.93037109375004,
									47.89624023437503
								],
								[
									-88.969873046875,
									47.881249999999994
								],
								[
									-89.08164062499995,
									47.85058593750003
								],
								[
									-89.15678710937496,
									47.84077148437498
								],
								[
									-89.19521484375,
									47.85180664062503
								],
								[
									-89.19916992187498,
									47.87226562500001
								],
								[
									-89.16879882812492,
									47.90214843749999
								],
								[
									-89.169091796875,
									47.917089843750006
								],
								[
									-89.20009765625,
									47.917089843750006
								],
								[
									-89.192626953125,
									47.92895507812503
								],
								[
									-89.14663085937494,
									47.95263671875006
								],
								[
									-88.75551757812502,
									48.10351562500006
								],
								[
									-88.58828124999997,
									48.15849609374999
								],
								[
									-88.49921875000004,
									48.175927734374966
								],
								[
									-88.48486328124994,
									48.16743164062501
								],
								[
									-88.58129882812497,
									48.11074218750002
								],
								[
									-88.59682617187502,
									48.08745117187499
								],
								[
									-88.59306640624996,
									48.07197265625001
								],
								[
									-88.62475585937503,
									48.04204101562496
								],
								[
									-88.91103515625,
									47.93623046874998
								],
								[
									-88.95517578124992,
									47.92602539062506
								]
							]
						],
						[
							[
								[
									-122.57275390624999,
									48.15664062500005
								],
								[
									-122.52382812499997,
									48.02543945312496
								],
								[
									-122.50283203124995,
									48.080078125000085
								],
								[
									-122.36674804687495,
									47.98544921874998
								],
								[
									-122.3666015625,
									47.93881835937506
								],
								[
									-122.38315429687499,
									47.92319335937509
								],
								[
									-122.41142578124999,
									47.91772460937503
								],
								[
									-122.43759765624999,
									47.93134765625007
								],
								[
									-122.46162109375,
									47.964013671874966
								],
								[
									-122.49228515625002,
									47.98129882812512
								],
								[
									-122.55751953125,
									47.99248046874999
								],
								[
									-122.59135742187496,
									48.02963867187509
								],
								[
									-122.60317382812497,
									48.05502929687495
								],
								[
									-122.60629882812498,
									48.12856445312511
								],
								[
									-122.62265625000003,
									48.151416015625045
								],
								[
									-122.65727539062497,
									48.156494140625114
								],
								[
									-122.69038085937497,
									48.1738769531251
								],
								[
									-122.74150390624999,
									48.2252929687501
								],
								[
									-122.74873046874995,
									48.23901367187494
								],
								[
									-122.72451171875,
									48.28090820312505
								],
								[
									-122.66899414062496,
									48.35102539062504
								],
								[
									-122.62861328125,
									48.384228515624955
								],
								[
									-122.60351562499994,
									48.380615234375114
								],
								[
									-122.57246093750001,
									48.3595703125001
								],
								[
									-122.53554687499995,
									48.321191406249994
								],
								[
									-122.54243164062503,
									48.29399414062496
								],
								[
									-122.69213867187497,
									48.241064453125006
								],
								[
									-122.69702148437499,
									48.228662109374966
								],
								[
									-122.62441406249994,
									48.21376953125005
								],
								[
									-122.59760742187498,
									48.200439453125085
								],
								[
									-122.57275390624999,
									48.15664062500005
								]
							]
						],
						[
							[
								[
									-122.8208984375,
									48.43134765625004
								],
								[
									-122.836572265625,
									48.42153320312511
								],
								[
									-122.89003906249997,
									48.43466796875012
								],
								[
									-122.92163085937501,
									48.45693359374994
								],
								[
									-122.93227539062495,
									48.48476562500011
								],
								[
									-122.91220703124995,
									48.53798828125002
								],
								[
									-122.88549804687501,
									48.55161132812495
								],
								[
									-122.86889648437501,
									48.54863281249996
								],
								[
									-122.8619140625,
									48.50185546874994
								],
								[
									-122.81459960937497,
									48.45234375000007
								],
								[
									-122.8208984375,
									48.43134765625004
								]
							]
						],
						[
							[
								[
									-123.013134765625,
									48.50087890625011
								],
								[
									-122.98676757812495,
									48.46801757812497
								],
								[
									-123.09443359374995,
									48.489062500000074
								],
								[
									-123.13994140624999,
									48.50795898437494
								],
								[
									-123.15341796874998,
									48.52631835937504
								],
								[
									-123.16958007812498,
									48.586718750000074
								],
								[
									-123.16215820312499,
									48.60639648437501
								],
								[
									-123.11416015624998,
									48.613281250000085
								],
								[
									-123.02416992187503,
									48.53847656249994
								],
								[
									-123.013134765625,
									48.50087890625011
								]
							]
						],
						[
							[
								[
									-122.78212890625001,
									48.67270507812512
								],
								[
									-122.76884765624997,
									48.650976562500034
								],
								[
									-122.80898437499998,
									48.62983398437498
								],
								[
									-122.83759765625003,
									48.626562500000034
								],
								[
									-122.88310546874997,
									48.66064453125006
								],
								[
									-122.90302734374995,
									48.66469726562508
								],
								[
									-122.88701171874997,
									48.61230468749997
								],
								[
									-122.89252929687503,
									48.59448242187506
								],
								[
									-122.98564453124999,
									48.62670898437497
								],
								[
									-123.00283203124994,
									48.65219726562509
								],
								[
									-122.97666015625003,
									48.6791503906251
								],
								[
									-122.91801757812499,
									48.70698242187498
								],
								[
									-122.89770507812501,
									48.71035156250005
								],
								[
									-122.78212890625001,
									48.67270507812512
								]
							]
						],
						[
							[
								[
									-89.57755546283573,
									48.00175342324741
								],
								[
									-89.604736328125,
									47.99165039062501
								],
								[
									-89.63383789062499,
									47.99370117187499
								],
								[
									-89.67207031249995,
									47.97871093750004
								],
								[
									-89.71953124999996,
									47.94672851562501
								],
								[
									-89.828759765625,
									47.90087890624997
								],
								[
									-89.99985351562495,
									47.84116210937498
								],
								[
									-90.19726562500003,
									47.78642578125002
								],
								[
									-90.59746093750002,
									47.687744140625
								],
								[
									-90.84672851562499,
									47.58525390624999
								],
								[
									-90.95712890624992,
									47.52373046874999
								],
								[
									-91.38627929687496,
									47.214746093749994
								],
								[
									-91.64516601562494,
									47.05004882812503
								],
								[
									-92.06455078124995,
									46.81884765625
								],
								[
									-92.10424804687494,
									46.789404296875034
								],
								[
									-92.10703124999998,
									46.76186523437502
								],
								[
									-92.07280273437493,
									46.736181640625034
								],
								[
									-91.98730468750003,
									46.698974609375
								],
								[
									-91.92080078124997,
									46.694433593750034
								],
								[
									-91.83564453125004,
									46.70209960937501
								],
								[
									-91.49907226562493,
									46.76611328125
								],
								[
									-91.35698242187493,
									46.81074218750004
								],
								[
									-91.21762695312498,
									46.88564453125002
								],
								[
									-91.203369140625,
									46.88803710937506
								],
								[
									-91.14541015625,
									46.87431640625002
								],
								[
									-91.12724609374996,
									46.86767578125
								],
								[
									-90.94604492187497,
									46.95375976562502
								],
								[
									-90.88666992187495,
									46.96479492187507
								],
								[
									-90.83994140624995,
									46.96245117187502
								],
								[
									-90.78193359375004,
									46.9287109375
								],
								[
									-90.76835937500002,
									46.908007812500045
								],
								[
									-90.78769531249995,
									46.86840820312506
								],
								[
									-90.83989257812493,
									46.80996093750005
								],
								[
									-90.86533203124998,
									46.76069335937504
								],
								[
									-90.86391601562494,
									46.720800781250006
								],
								[
									-90.88642578125001,
									46.67749023437497
								],
								[
									-90.943505859375,
									46.618994140625034
								],
								[
									-90.922998046875,
									46.60307617187499
								],
								[
									-90.76997070312498,
									46.645410156249994
								],
								[
									-90.74755859374994,
									46.66186523437497
								],
								[
									-90.74501953124997,
									46.67167968750002
								],
								[
									-90.75434570312501,
									46.68354492187504
								],
								[
									-90.73681640625,
									46.688867187499966
								],
								[
									-90.61650390624999,
									46.63134765624997
								],
								[
									-90.53613281249997,
									46.59936523437503
								],
								[
									-90.46884765624992,
									46.58413085937505
								],
								[
									-90.34135742187499,
									46.60249023437507
								],
								[
									-90.153564453125,
									46.65449218749998
								],
								[
									-89.99326171874995,
									46.71791992187502
								],
								[
									-89.860595703125,
									46.79277343750002
								],
								[
									-89.69511718749996,
									46.83857421875001
								],
								[
									-89.49682617187497,
									46.85541992187498
								],
								[
									-89.35498046875003,
									46.88193359375006
								],
								[
									-89.26943359375,
									46.91816406250007
								],
								[
									-89.15478515625,
									46.988623046875034
								],
								[
									-89.090234375,
									47.00927734374997
								],
								[
									-89.009130859375,
									47.015722656250034
								],
								[
									-88.948095703125,
									47.04296875
								],
								[
									-88.90712890625,
									47.091113281250045
								],
								[
									-88.82963867187493,
									47.145849609375006
								],
								[
									-88.71562499999999,
									47.207177734374966
								],
								[
									-88.65048828124995,
									47.23198242187496
								],
								[
									-88.63413085937498,
									47.22031249999998
								],
								[
									-88.62822265624993,
									47.198632812499994
								],
								[
									-88.63271484374997,
									47.16689453125002
								],
								[
									-88.60439453124997,
									47.14125976562505
								],
								[
									-88.54326171874993,
									47.12158203125003
								],
								[
									-88.51542968749996,
									47.095507812500045
								],
								[
									-88.520849609375,
									47.063085937500006
								],
								[
									-88.50439453125003,
									47.03544921874999
								],
								[
									-88.46601562500001,
									47.012548828125006
								],
								[
									-88.45585937499999,
									46.96284179687501
								],
								[
									-88.47373046874998,
									46.88627929687496
								],
								[
									-88.47607421875003,
									46.83671874999999
								],
								[
									-88.46274414062498,
									46.81416015625001
								],
								[
									-88.44912109374994,
									46.801513671875
								],
								[
									-88.42729492187493,
									46.81391601562504
								],
								[
									-88.39999999999998,
									46.840917968750034
								],
								[
									-88.38994140624996,
									46.85742187500003
								],
								[
									-88.38300781249998,
									46.87431640625002
								],
								[
									-88.21625976562504,
									46.95156250000002
								],
								[
									-88.18374023437497,
									46.955322265625
								],
								[
									-88.12915039062494,
									46.93549804687504
								],
								[
									-87.87709960937494,
									46.90771484374997
								],
								[
									-87.777587890625,
									46.88789062500001
								],
								[
									-87.67290039062499,
									46.84355468749996
								],
								[
									-87.63749999999999,
									46.826513671875034
								],
								[
									-87.50947265625001,
									46.683447265625034
								],
								[
									-87.45122070312496,
									46.62744140625
								],
								[
									-87.41489257812492,
									46.61206054687506
								],
								[
									-87.39448242187504,
									46.59008789062503
								],
								[
									-87.37783203125002,
									46.53955078125003
								],
								[
									-87.35810546874998,
									46.52441406250006
								],
								[
									-87.170654296875,
									46.51352539062506
								],
								[
									-87.085693359375,
									46.52270507812506
								],
								[
									-87.03413085937498,
									46.54321289062497
								],
								[
									-86.97675781250001,
									46.53007812499996
								],
								[
									-86.91362304687493,
									46.48330078125002
								],
								[
									-86.85146484375,
									46.47021484375003
								],
								[
									-86.79038085937498,
									46.490820312500034
								],
								[
									-86.73291015625,
									46.490136718749994
								],
								[
									-86.67905273437495,
									46.46821289062507
								],
								[
									-86.65390624999998,
									46.452246093750006
								],
								[
									-86.63749999999999,
									46.45297851562506
								],
								[
									-86.53100585937497,
									46.52441406250006
								],
								[
									-86.40268554687495,
									46.58774414062498
								],
								[
									-86.23134765624994,
									46.65625
								],
								[
									-86.13203124999995,
									46.68681640625002
								],
								[
									-86.10463867187497,
									46.67924804687496
								],
								[
									-85.94677734374997,
									46.70214843750003
								],
								[
									-85.80449218749993,
									46.704248046874994
								],
								[
									-85.61611328125002,
									46.690576171874966
								],
								[
									-85.44150390624998,
									46.706640625000034
								],
								[
									-85.28071289062498,
									46.75244140625006
								],
								[
									-85.13842773437494,
									46.77802734375001
								],
								[
									-85.01464843749997,
									46.78349609374999
								],
								[
									-84.96791992187494,
									46.77070312500004
								],
								[
									-84.998193359375,
									46.73969726562504
								],
								[
									-85.01450195312492,
									46.68647460937501
								],
								[
									-85.01674804687494,
									46.610937500000006
								],
								[
									-85.02739257812499,
									46.56313476562502
								],
								[
									-85.04628906250002,
									46.54301757812502
								],
								[
									-85.04863281249996,
									46.52387695312504
								],
								[
									-85.03432617187497,
									46.505761718749966
								],
								[
									-84.91430664062494,
									46.49399414062498
								],
								[
									-84.85117187499998,
									46.46948242187506
								],
								[
									-84.77880859374997,
									46.468359375000006
								],
								[
									-84.69731445312496,
									46.49072265625003
								],
								[
									-84.63486328124995,
									46.48227539062498
								],
								[
									-84.59150390625001,
									46.443115234375
								],
								[
									-84.52836914062502,
									46.43608398437499
								],
								[
									-84.4671875,
									46.464208984375034
								],
								[
									-84.42416992187492,
									46.49067382812501
								],
								[
									-84.38696289062497,
									46.50224609374996
								],
								[
									-84.35800781249995,
									46.50468750000002
								],
								[
									-84.32744140624993,
									46.491455078125
								],
								[
									-84.30673828124998,
									46.469140624999966
								],
								[
									-84.25478515624997,
									46.407568359375034
								],
								[
									-84.22905273437496,
									46.36582031249998
								],
								[
									-84.21333007812495,
									46.303808593750034
								],
								[
									-84.20224609374992,
									46.28315429687501
								],
								[
									-84.20366210937493,
									46.24697265625002
								],
								[
									-84.23847656250001,
									46.22246093749999
								],
								[
									-84.24794921875,
									46.20302734375002
								],
								[
									-84.22705078125,
									46.18364257812499
								],
								[
									-84.10883789062498,
									46.17817382812504
								],
								[
									-84.05488281250001,
									46.15893554687503
								],
								[
									-84.03471679687499,
									46.13740234374998
								],
								[
									-84.04838867187502,
									46.113525390625
								],
								[
									-84.04077148437497,
									46.08818359374999
								],
								[
									-84.01196289062497,
									46.06142578125005
								],
								[
									-83.91743164062498,
									46.02070312500001
								],
								[
									-83.89414062499995,
									46.00131835937506
								],
								[
									-83.9009765625,
									45.980859374999966
								],
								[
									-83.92919921874997,
									45.96757812500002
								],
								[
									-83.97880859374996,
									45.961523437500034
								],
								[
									-84.34091796874992,
									45.99980468750002
								],
								[
									-84.44731445312493,
									46.00615234374999
								],
								[
									-84.46293945312502,
									45.99208984375005
								],
								[
									-84.47309570312504,
									45.98999023437497
								],
								[
									-84.49033203125,
									45.993750000000034
								],
								[
									-84.52128906249999,
									45.99458007812501
								],
								[
									-84.53686523437497,
									46.00371093750002
								],
								[
									-84.54990234374995,
									46.02924804687507
								],
								[
									-84.58149414062501,
									46.04555664062502
								],
								[
									-84.63154296874998,
									46.05263671875002
								],
								[
									-84.67465820312498,
									46.033300781250006
								],
								[
									-84.72490234374999,
									45.95751953125003
								],
								[
									-84.71708984375002,
									45.943505859374994
								],
								[
									-84.72539062500002,
									45.894873046875034
								],
								[
									-84.71269531249999,
									45.88164062500002
								],
								[
									-84.71333007812504,
									45.870507812499966
								],
								[
									-84.72739257812498,
									45.861474609374994
								],
								[
									-84.75693359374995,
									45.86279296875
								],
								[
									-84.80185546874995,
									45.874365234375034
								],
								[
									-84.97182617187494,
									45.98896484375004
								],
								[
									-85.10063476562499,
									46.04619140624996
								],
								[
									-85.25986328125,
									46.08818359374999
								],
								[
									-85.38593750000001,
									46.108642578125
								],
								[
									-85.47880859374993,
									46.10756835937502
								],
								[
									-85.55507812500002,
									46.07817382812499
								],
								[
									-85.61479492187502,
									46.02045898437504
								],
								[
									-85.70781249999996,
									45.98759765625002
								],
								[
									-85.83422851562494,
									45.97968750000001
								],
								[
									-85.90288085937499,
									45.96420898437506
								],
								[
									-85.913720703125,
									45.94116210937497
								],
								[
									-85.95932617187495,
									45.94067382812506
								],
								[
									-86.03974609374998,
									45.96269531250002
								],
								[
									-86.12294921874997,
									45.96894531250004
								],
								[
									-86.20893554687501,
									45.959326171875034
								],
								[
									-86.27177734375002,
									45.93666992187502
								],
								[
									-86.33808593750001,
									45.86572265624997
								],
								[
									-86.35131835937497,
									45.830957031249994
								],
								[
									-86.39956054687502,
									45.80068359375005
								],
								[
									-86.52749023437497,
									45.75317382812506
								],
								[
									-86.53388671875004,
									45.73564453125002
								],
								[
									-86.60117187499998,
									45.68164062500003
								],
								[
									-86.62236328124993,
									45.65200195312505
								],
								[
									-86.62197265624994,
									45.62275390625004
								],
								[
									-86.64443359375,
									45.62451171875003
								],
								[
									-86.68969726562497,
									45.65732421875006
								],
								[
									-86.69140624999997,
									45.70141601562497
								],
								[
									-86.64951171874995,
									45.7568359375
								],
								[
									-86.61225585937501,
									45.78364257812504
								],
								[
									-86.57954101562501,
									45.781835937500034
								],
								[
									-86.55927734374995,
									45.80629882812502
								],
								[
									-86.55151367187497,
									45.857080078124994
								],
								[
									-86.56333007812498,
									45.88251953125001
								],
								[
									-86.62719726562494,
									45.87250976562501
								],
								[
									-86.66064453125,
									45.852294921875
								],
								[
									-86.70278320312497,
									45.84794921874999
								],
								[
									-86.75361328125004,
									45.859472656250034
								],
								[
									-86.79853515625004,
									45.83178710937497
								],
								[
									-86.83745117187496,
									45.76479492187502
								],
								[
									-86.88388671874992,
									45.72094726562506
								],
								[
									-86.937890625,
									45.70024414062502
								],
								[
									-86.97421874999995,
									45.72314453125006
								],
								[
									-86.9927734375,
									45.789648437500006
								],
								[
									-86.99291992187503,
									45.841894531250006
								],
								[
									-86.97109375000002,
									45.90498046875007
								],
								[
									-86.98232421875,
									45.91728515624999
								],
								[
									-87.005029296875,
									45.89716796874998
								],
								[
									-87.03925781249995,
									45.844580078125006
								],
								[
									-87.08486328125002,
									45.72978515624999
								],
								[
									-87.11416015624994,
									45.692480468750034
								],
								[
									-87.15375976562501,
									45.67675781250003
								],
								[
									-87.21640624999998,
									45.607324218749994
								],
								[
									-87.30205078124993,
									45.48413085937503
								],
								[
									-87.39877929687492,
									45.36464843750002
								],
								[
									-87.50649414062502,
									45.24887695312498
								],
								[
									-87.57119140624997,
									45.186621093750006
								],
								[
									-87.59282226562493,
									45.17783203124998
								],
								[
									-87.60224609374998,
									45.15703125000002
								],
								[
									-87.60776367187495,
									45.08266601562505
								],
								[
									-87.62700195312496,
									45.03227539062499
								],
								[
									-87.68320312499998,
									44.99262695312501
								],
								[
									-87.83027343749998,
									44.942480468750006
								],
								[
									-87.85356445312493,
									44.90830078125006
								],
								[
									-87.85678710937498,
									44.88037109375006
								],
								[
									-87.95156250000002,
									44.76372070312499
								],
								[
									-87.99780273437503,
									44.69233398437501
								],
								[
									-88.02827148437501,
									44.61791992187506
								],
								[
									-88.01875000000001,
									44.571142578125006
								],
								[
									-87.96923828124997,
									44.55200195312503
								],
								[
									-87.92900390624996,
									44.55947265625005
								],
								[
									-87.89824218749999,
									44.593359375000006
								],
								[
									-87.85107421874997,
									44.62402343750006
								],
								[
									-87.78754882812498,
									44.65156250000007
								],
								[
									-87.74091796875001,
									44.69204101562505
								],
								[
									-87.67661132812495,
									44.790283203125
								],
								[
									-87.60439453125,
									44.84687500000007
								],
								[
									-87.56601562499998,
									44.85029296875004
								],
								[
									-87.55537109375004,
									44.84858398437504
								],
								[
									-87.48017578124998,
									44.874121093750006
								],
								[
									-87.419580078125,
									44.865624999999966
								],
								[
									-87.38310546874993,
									44.82709960937504
								],
								[
									-87.34560546875002,
									44.80063476562506
								],
								[
									-87.33730468750002,
									44.77583007812507
								],
								[
									-87.35605468749992,
									44.72036132812505
								],
								[
									-87.39052734375002,
									44.661962890625034
								],
								[
									-87.44086914062498,
									44.600683593750006
								],
								[
									-87.48652343750004,
									44.50859374999999
								],
								[
									-87.52744140624995,
									44.38569335937498
								],
								[
									-87.53613281250003,
									44.29296875
								],
								[
									-87.51250000000002,
									44.23027343750002
								],
								[
									-87.53491210937494,
									44.17426757812498
								],
								[
									-87.60341796874997,
									44.12495117187507
								],
								[
									-87.65849609374999,
									44.05903320312504
								],
								[
									-87.70014648437504,
									43.976611328125045
								],
								[
									-87.72382812499998,
									43.907275390625045
								],
								[
									-87.72939453124997,
									43.85117187499998
								],
								[
									-87.72338867187497,
									43.80908203125003
								],
								[
									-87.69794921875004,
									43.75244140625003
								],
								[
									-87.69970703124994,
									43.723730468750034
								],
								[
									-87.7740234375,
									43.598876953125
								],
								[
									-87.80087890624995,
									43.53808593750006
								],
								[
									-87.80556640625002,
									43.490087890625034
								],
								[
									-87.82392578125004,
									43.44301757812505
								],
								[
									-87.88071289062498,
									43.347021484375034
								],
								[
									-87.89838867187501,
									43.293798828125034
								],
								[
									-87.90166015624996,
									43.24492187500002
								],
								[
									-87.88881835937502,
									43.16455078124997
								],
								[
									-87.89609375,
									43.13740234375004
								],
								[
									-87.89277343750004,
									43.11689453125004
								],
								[
									-87.87885742187504,
									43.103125000000006
								],
								[
									-87.87900390624998,
									43.07783203124998
								],
								[
									-87.89340820312498,
									43.04111328125006
								],
								[
									-87.88774414062499,
									43.012451171875
								],
								[
									-87.862060546875,
									42.99199218749999
								],
								[
									-87.845556640625,
									42.95307617187507
								],
								[
									-87.83818359375002,
									42.895654296874994
								],
								[
									-87.81870117187495,
									42.84770507812502
								],
								[
									-87.78706054687498,
									42.80917968750006
								],
								[
									-87.781396484375,
									42.75341796874997
								],
								[
									-87.80166015624994,
									42.68037109375001
								],
								[
									-87.81196289062498,
									42.54296875
								],
								[
									-87.81250000000003,
									42.341064453125
								],
								[
									-87.79746093749998,
									42.21142578125006
								],
								[
									-87.76679687500004,
									42.15390625000006
								],
								[
									-87.73251953124998,
									42.11152343750004
								],
								[
									-87.69462890624999,
									42.08437500000002
								],
								[
									-87.651123046875,
									42.00024414062503
								],
								[
									-87.60205078124994,
									41.85913085937506
								],
								[
									-87.55659179687501,
									41.76596679687498
								],
								[
									-87.5146484375,
									41.72065429687498
								],
								[
									-87.47695312499997,
									41.695458984374994
								],
								[
									-87.447021484375,
									41.680761718750034
								],
								[
									-87.42500000000004,
									41.678564453125034
								],
								[
									-87.41249999999997,
									41.65649414062497
								],
								[
									-87.35624999999996,
									41.64326171875004
								],
								[
									-87.25322265624993,
									41.63764648437504
								],
								[
									-87.15869140624994,
									41.64638671875005
								],
								[
									-87.072607421875,
									41.669482421875045
								],
								[
									-86.79819335937498,
									41.78852539062504
								],
								[
									-86.691552734375,
									41.853369140625034
								],
								[
									-86.63247070312497,
									41.91132812500001
								],
								[
									-86.57534179687494,
									41.98769531250002
								],
								[
									-86.520166015625,
									42.08227539062503
								],
								[
									-86.40737304687502,
									42.22373046874998
								],
								[
									-86.35249023437501,
									42.309326171875
								],
								[
									-86.299560546875,
									42.41762695312505
								],
								[
									-86.25961914062492,
									42.53120117187501
								],
								[
									-86.23271484374996,
									42.65000000000006
								],
								[
									-86.22001953124996,
									42.773095703124994
								],
								[
									-86.22153320312498,
									42.90043945312499
								],
								[
									-86.24848632812498,
									43.02880859375003
								],
								[
									-86.30087890624998,
									43.158056640625006
								],
								[
									-86.32915039062499,
									43.22412109375003
								],
								[
									-86.340185546875,
									43.24174804687499
								],
								[
									-86.43500976562495,
									43.40712890625002
								],
								[
									-86.54213867187502,
									43.637304687500006
								],
								[
									-86.54052734374997,
									43.65693359375001
								],
								[
									-86.44057617187494,
									43.794287109375034
								],
								[
									-86.43803710937496,
									43.81274414062506
								],
								[
									-86.4486328125,
									43.923974609374966
								],
								[
									-86.46992187499995,
									43.97978515624999
								],
								[
									-86.52094726562498,
									44.05473632812496
								],
								[
									-86.51918945312497,
									44.07373046875003
								],
								[
									-86.41542968749997,
									44.16948242187499
								],
								[
									-86.35273437499998,
									44.24238281250001
								],
								[
									-86.29589843749994,
									44.330615234375045
								],
								[
									-86.25908203124999,
									44.43359374999997
								],
								[
									-86.24218750000003,
									44.55131835937499
								],
								[
									-86.24272460937496,
									44.62973632812506
								],
								[
									-86.26069335937498,
									44.66884765625002
								],
								[
									-86.25874023437501,
									44.69902343749996
								],
								[
									-86.23701171875004,
									44.72021484375
								],
								[
									-86.12583007812495,
									44.74775390625004
								],
								[
									-86.08842773437496,
									44.79423828124999
								],
								[
									-86.08046874999994,
									44.87587890625002
								],
								[
									-86.05766601562499,
									44.916357421875006
								],
								[
									-86.01992187499994,
									44.91572265625004
								],
								[
									-85.98500976562494,
									44.93251953125002
								],
								[
									-85.95292968749999,
									44.966650390625034
								],
								[
									-85.91049804687495,
									44.97631835937506
								],
								[
									-85.85781249999997,
									44.96152343750006
								],
								[
									-85.78413085937495,
									45.01215820312498
								],
								[
									-85.68935546875002,
									45.128076171874966
								],
								[
									-85.61660156249994,
									45.192919921875045
								],
								[
									-85.56586914062498,
									45.20654296874997
								],
								[
									-85.55620117187499,
									45.19599609375004
								],
								[
									-85.58774414062492,
									45.16132812499998
								],
								[
									-85.59741210937503,
									45.12333984374999
								],
								[
									-85.58525390624996,
									45.08198242187498
								],
								[
									-85.59570312499994,
									45.04194335937501
								],
								[
									-85.61923828124995,
									44.98706054687503
								],
								[
									-85.60468750000001,
									44.96992187499998
								],
								[
									-85.64531250000002,
									44.881640625000045
								],
								[
									-85.64721679687497,
									44.837500000000006
								],
								[
									-85.62250976562498,
									44.80395507812503
								],
								[
									-85.59326171874997,
									44.815673828125
								],
								[
									-85.559326171875,
									44.87265624999998
								],
								[
									-85.54921874999997,
									44.90297851562502
								],
								[
									-85.562841796875,
									44.90673828125
								],
								[
									-85.55776367187494,
									44.93095703124996
								],
								[
									-85.53388671874995,
									44.9755859375
								],
								[
									-85.51264648437498,
									44.99677734375004
								],
								[
									-85.49409179687504,
									44.99443359375002
								],
								[
									-85.48891601562494,
									44.97011718750002
								],
								[
									-85.49711914062493,
									44.92382812500003
								],
								[
									-85.55092773437497,
									44.81464843750007
								],
								[
									-85.56147460937498,
									44.78125
								],
								[
									-85.54936523437502,
									44.771874999999966
								],
								[
									-85.48471679687498,
									44.84033203124997
								],
								[
									-85.43037109375001,
									44.94931640625006
								],
								[
									-85.38901367187495,
									45.03276367187502
								],
								[
									-85.38159179687503,
									45.07827148437505
								],
								[
									-85.39399414062498,
									45.19565429687506
								],
								[
									-85.39145507812498,
									45.24379882812502
								],
								[
									-85.37568359374998,
									45.276953125000006
								],
								[
									-85.319482421875,
									45.31445312500003
								],
								[
									-85.22285156250001,
									45.35615234374998
								],
								[
									-85.12734375,
									45.37846679687499
								],
								[
									-85.03295898437497,
									45.38125000000002
								],
								[
									-84.96713867187498,
									45.39267578125006
								],
								[
									-84.929833984375,
									45.41259765625003
								],
								[
									-84.94287109375,
									45.428564453125006
								],
								[
									-85.00639648437496,
									45.44047851562502
								],
								[
									-85.05468749999994,
									45.466650390625034
								],
								[
									-85.08769531250002,
									45.50688476562496
								],
								[
									-85.09873046874995,
									45.553124999999966
								],
								[
									-85.08779296874994,
									45.60527343750002
								],
								[
									-85.04736328124997,
									45.65639648437505
								],
								[
									-84.97749023437504,
									45.70654296875006
								],
								[
									-84.95546875,
									45.743408203125
								],
								[
									-84.98139648437504,
									45.76704101562504
								],
								[
									-84.95151367187498,
									45.77539062500003
								],
								[
									-84.86586914062494,
									45.76855468749997
								],
								[
									-84.80595703124999,
									45.775048828124966
								],
								[
									-84.77197265625,
									45.794775390625006
								],
								[
									-84.69091796875,
									45.77377929687498
								],
								[
									-84.56293945312504,
									45.71215820312503
								],
								[
									-84.44140624999997,
									45.67626953125
								],
								[
									-84.32631835937497,
									45.666162109374994
								],
								[
									-84.24228515625,
									45.644433593749994
								],
								[
									-84.18925781249993,
									45.61113281249996
								],
								[
									-84.151123046875,
									45.573828125000006
								],
								[
									-84.12773437500002,
									45.53247070312503
								],
								[
									-84.07280273437502,
									45.50913085937498
								],
								[
									-83.986328125,
									45.50380859375005
								],
								[
									-83.91826171874999,
									45.48627929687504
								],
								[
									-83.86874999999992,
									45.45649414062501
								],
								[
									-83.59365234375002,
									45.37944335937502
								],
								[
									-83.478515625,
									45.33881835937501
								],
								[
									-83.415283203125,
									45.29902343749998
								],
								[
									-83.39726562499996,
									45.27358398437505
								],
								[
									-83.402587890625,
									45.24833984374996
								],
								[
									-83.39619140625001,
									45.22138671875007
								],
								[
									-83.348974609375,
									45.16899414062496
								],
								[
									-83.33110351562499,
									45.16420898437505
								],
								[
									-83.32016601562498,
									45.13896484374996
								],
								[
									-83.31611328124995,
									45.093164062499966
								],
								[
									-83.30229492187499,
									45.062402343749994
								],
								[
									-83.27871093749997,
									45.04677734375002
								],
								[
									-83.29306640624998,
									45.040380859375034
								],
								[
									-83.37783203125002,
									45.06689453125003
								],
								[
									-83.42592773437494,
									45.058935546875006
								],
								[
									-83.44814453124994,
									45.02456054687502
								],
								[
									-83.45156250000002,
									44.99199218749996
								],
								[
									-83.436181640625,
									44.96142578125003
								],
								[
									-83.32778320312494,
									44.869238281250006
								],
								[
									-83.29956054687497,
									44.78520507812502
								],
								[
									-83.29423828124993,
									44.68334960937506
								],
								[
									-83.30791015624999,
									44.643798828125
								],
								[
									-83.31928710937498,
									44.55649414062506
								],
								[
									-83.32836914062497,
									44.42143554687499
								],
								[
									-83.33056640624997,
									44.375097656250034
								],
								[
									-83.36621093749994,
									44.33002929687501
								],
								[
									-83.46279296875,
									44.26494140624999
								],
								[
									-83.46420898437492,
									44.277246093749994
								],
								[
									-83.48740234374995,
									44.28056640624996
								],
								[
									-83.51249999999999,
									44.27075195312503
								],
								[
									-83.54750976562494,
									44.21503906250004
								],
								[
									-83.577490234375,
									44.11342773437502
								],
								[
									-83.61396484374998,
									44.058251953124966
								],
								[
									-83.65698242187494,
									44.04956054687497
								],
								[
									-83.68281249999998,
									44.035009765625034
								],
								[
									-83.69150390624998,
									44.01445312500002
								],
								[
									-83.73769531249997,
									44.000634765624966
								],
								[
									-83.82143554687497,
									43.99345703125002
								],
								[
									-83.87880859375002,
									43.96254882812502
								],
								[
									-83.92158203125004,
									43.87548828125006
								],
								[
									-83.91977539062492,
									43.83388671875002
								],
								[
									-83.93959960937497,
									43.78193359374998
								],
								[
									-83.93828124999996,
									43.737548828125
								],
								[
									-83.915673828125,
									43.70058593750002
								],
								[
									-83.84799804687495,
									43.66362304687496
								],
								[
									-83.73520507812498,
									43.62666015624998
								],
								[
									-83.66787109374994,
									43.620996093749994
								],
								[
									-83.62158203125003,
									43.63647460937503
								],
								[
									-83.573095703125,
									43.697119140625034
								],
								[
									-83.526025390625,
									43.72089843749998
								],
								[
									-83.468896484375,
									43.73090820312498
								],
								[
									-83.44736328124998,
									43.758447265624994
								],
								[
									-83.35297851562501,
									43.87934570312504
								],
								[
									-83.35307617187493,
									43.906347656250034
								],
								[
									-83.38749999999993,
									43.91660156249998
								],
								[
									-83.382568359375,
									43.924072265625
								],
								[
									-83.338134765625,
									43.92890625000001
								],
								[
									-83.29946289062494,
									43.94511718750002
								],
								[
									-83.2666015625,
									43.97285156249998
								],
								[
									-83.20927734374996,
									43.99360351562504
								],
								[
									-83.069482421875,
									44.025048828124966
								],
								[
									-82.99462890625,
									44.06108398437502
								],
								[
									-82.94721679687504,
									44.06699218749998
								],
								[
									-82.87822265625002,
									44.047753906249966
								],
								[
									-82.78774414062497,
									44.003515625000006
								],
								[
									-82.71611328124993,
									43.93901367187502
								],
								[
									-82.66333007812503,
									43.85419921875007
								],
								[
									-82.59672851562496,
									43.634423828124966
								],
								[
									-82.51621093749998,
									43.27963867187498
								],
								[
									-82.46127929687498,
									43.08100585937501
								],
								[
									-82.43193359374996,
									43.03857421875
								],
								[
									-82.41723632812497,
									43.01738281250002
								],
								[
									-82.4883300781249,
									42.73950195312517
								],
								[
									-82.54531249999997,
									42.624707031249955
								],
								[
									-82.64511718749995,
									42.55805664062515
								],
								[
									-82.63911132812498,
									42.574365234374994
								],
								[
									-82.62998046874998,
									42.59453125000002
								],
								[
									-82.63281250000003,
									42.661035156249994
								],
								[
									-82.64990234374994,
									42.686572265625045
								],
								[
									-82.686767578125,
									42.69692382812502
								],
								[
									-82.73261718750001,
									42.689550781250034
								],
								[
									-82.78735351562497,
									42.66455078125
								],
								[
									-82.804443359375,
									42.638916015625
								],
								[
									-82.78378906249995,
									42.61274414062501
								],
								[
									-82.79599609374995,
									42.589111328125
								],
								[
									-82.84096679687497,
									42.56811523437497
								],
								[
									-82.87011718749997,
									42.51899414062501
								],
								[
									-82.8833984375,
									42.44184570312501
								],
								[
									-82.90200195312497,
									42.39399414062504
								],
								[
									-82.92597656249998,
									42.37548828125
								],
								[
									-83.01650390624994,
									42.34711914062498
								],
								[
									-83.06337890625,
									42.322656249999966
								],
								[
									-83.104833984375,
									42.28642578124996
								],
								[
									-83.14213867187496,
									42.22763671874998
								],
								[
									-83.17524414062504,
									42.14628906250002
								],
								[
									-83.18842773437498,
									42.083398437499994
								],
								[
									-83.17656249999996,
									42.04892578124998
								],
								[
									-83.20478515625001,
									42.02705078125007
								],
								[
									-83.25556640624998,
									41.98559570312506
								],
								[
									-83.26523437499998,
									41.970556640625006
								],
								[
									-83.26181640625,
									41.94638671875006
								],
								[
									-83.27250976562496,
									41.93457031250006
								],
								[
									-83.29721679687492,
									41.93505859374997
								],
								[
									-83.31616210937497,
									41.92329101562507
								],
								[
									-83.362060546875,
									41.8798828125
								],
								[
									-83.44116210937494,
									41.766210937500034
								],
								[
									-83.456201171875,
									41.74248046874999
								],
								[
									-83.44296874999995,
									41.72485351562506
								],
								[
									-83.35224609375004,
									41.714013671874966
								],
								[
									-83.29072265625004,
									41.693261718749994
								],
								[
									-83.242578125,
									41.66191406250002
								],
								[
									-83.069091796875,
									41.60063476562496
								],
								[
									-83.01601562500002,
									41.56279296874999
								],
								[
									-82.96328125000002,
									41.54194335937498
								],
								[
									-82.910791015625,
									41.53823242187505
								],
								[
									-82.87490234374997,
									41.55014648437498
								],
								[
									-82.85551757812502,
									41.57783203125001
								],
								[
									-82.83076171875001,
									41.579687500000034
								],
								[
									-82.80078124999994,
									41.55571289062496
								],
								[
									-82.70312499999994,
									41.52949218750004
								],
								[
									-82.69999999999993,
									41.52128906249996
								],
								[
									-82.97070312500003,
									41.475732421874994
								],
								[
									-83.02749023437497,
									41.45454101562504
								],
								[
									-82.95957031249998,
									41.43974609374996
								],
								[
									-82.89111328124997,
									41.44331054687507
								],
								[
									-82.82226562499997,
									41.465234374999994
								],
								[
									-82.74306640625002,
									41.46406250000004
								],
								[
									-82.67348632812497,
									41.453662109375045
								],
								[
									-82.65146484375,
									41.46245117187496
								],
								[
									-82.64262695312499,
									41.46689453124998
								],
								[
									-82.52441406249997,
									41.40698242187503
								],
								[
									-82.48027343749993,
									41.398095703124994
								],
								[
									-82.43442382812492,
									41.404931640624966
								],
								[
									-82.386865234375,
									41.42749023437503
								],
								[
									-82.28247070312497,
									41.45683593749999
								],
								[
									-82.121337890625,
									41.49296874999996
								],
								[
									-81.96630859374994,
									41.507666015625034
								],
								[
									-81.81748046875,
									41.500878906249966
								],
								[
									-81.72319335937499,
									41.51093749999998
								],
								[
									-81.63720703124997,
									41.54843749999998
								],
								[
									-81.44707031249996,
									41.671484375000006
								],
								[
									-81.22861328124995,
									41.770410156249994
								],
								[
									-80.86923828125,
									41.893310546875
								],
								[
									-80.33447265624994,
									42.04082031250002
								],
								[
									-80.251953125,
									42.075292968750034
								],
								[
									-80.16816406249998,
									42.10898437500006
								],
								[
									-80.12470703125001,
									42.128320312499994
								],
								[
									-80.076171875,
									42.14599609375006
								],
								[
									-79.70405273437504,
									42.30009765624999
								],
								[
									-79.51225585937496,
									42.39101562500005
								],
								[
									-79.41635742187495,
									42.45688476562506
								],
								[
									-79.31538085937498,
									42.511572265625006
								],
								[
									-79.20922851562503,
									42.55517578125
								],
								[
									-79.12495117187501,
									42.611230468749966
								],
								[
									-79.06254882812499,
									42.67978515624998
								],
								[
									-78.99360351562498,
									42.73071289062497
								],
								[
									-78.91826171874999,
									42.76406250000002
								],
								[
									-78.87783203125002,
									42.79912109374996
								],
								[
									-78.87226562500004,
									42.8359375
								],
								[
									-78.88623046874994,
									42.885644531249994
								],
								[
									-78.91972656249993,
									42.94819335937504
								],
								[
									-78.92431640624997,
									42.99750976562507
								],
								[
									-78.90009765625001,
									43.03349609375002
								],
								[
									-78.89472656249998,
									43.057763671874994
								],
								[
									-78.90815429687498,
									43.07031249999997
								],
								[
									-79.066064453125,
									43.10610351562508
								],
								[
									-79.05922851562494,
									43.278076171875114
								],
								[
									-79.0613893338681,
									43.2829114454847
								],
								[
									-79.05317382812504,
									43.28510742187504
								],
								[
									-78.689453125,
									43.36147460937505
								],
								[
									-78.45747070312501,
									43.387548828125034
								],
								[
									-78.174951171875,
									43.394677734374966
								],
								[
									-77.83823242187498,
									43.35708007812505
								],
								[
									-77.70737304687495,
									43.322851562500006
								],
								[
									-77.62460937499998,
									43.27910156249996
								],
								[
									-77.52905273437494,
									43.26738281249996
								],
								[
									-77.42080078125002,
									43.28774414062502
								],
								[
									-77.27080078125002,
									43.294531250000006
								],
								[
									-77.07900390625002,
									43.287695312500034
								],
								[
									-76.97641601562498,
									43.27739257812496
								],
								[
									-76.96308593750001,
									43.263769531250034
								],
								[
									-76.94980468749998,
									43.267919921875006
								],
								[
									-76.93666992187497,
									43.28974609375001
								],
								[
									-76.88530273437499,
									43.31401367187496
								],
								[
									-76.74140624999998,
									43.35004882812504
								],
								[
									-76.722314453125,
									43.342626953125034
								],
								[
									-76.69287109374994,
									43.360937500000034
								],
								[
									-76.653076171875,
									43.40502929687503
								],
								[
									-76.57968749999998,
									43.45380859375004
								],
								[
									-76.47270507812496,
									43.50727539062498
								],
								[
									-76.37602539062496,
									43.535058593749966
								],
								[
									-76.28959960937496,
									43.53730468749998
								],
								[
									-76.23178710937498,
									43.550439453124994
								],
								[
									-76.20258789062498,
									43.57451171875002
								],
								[
									-76.19360351562503,
									43.595800781250006
								],
								[
									-76.204833984375,
									43.61425781250003
								],
								[
									-76.19985351562497,
									43.63471679687501
								],
								[
									-76.19501953125004,
									43.644824218750045
								],
								[
									-76.19931640624995,
									43.65307617187503
								],
								[
									-76.20971679687503,
									43.670312499999994
								],
								[
									-76.21811523437495,
									43.75781250000006
								],
								[
									-76.23486328125,
									43.79877929687504
								],
								[
									-76.25820312499994,
									43.8291015625
								],
								[
									-76.28818359374992,
									43.848730468750006
								],
								[
									-76.28461914062501,
									43.869238281250006
								],
								[
									-76.23251953124995,
									43.89453125000003
								],
								[
									-76.23642578124995,
									43.870947265625006
								],
								[
									-76.22275390625,
									43.86381835937499
								],
								[
									-76.19833984375,
									43.87446289062501
								],
								[
									-76.14267578124995,
									43.926855468750034
								],
								[
									-76.13647460937503,
									43.94663085937498
								],
								[
									-76.09868164062496,
									43.96699218750004
								],
								[
									-76.07065429687492,
									43.99848632812507
								],
								[
									-76.10190429687498,
									44.00317382812503
								],
								[
									-76.17543945312497,
									43.993798828124994
								],
								[
									-76.19228515625002,
									44.00336914062498
								],
								[
									-76.15415039062498,
									44.04541015625003
								],
								[
									-76.16123046875,
									44.06933593750003
								],
								[
									-76.17329101562495,
									44.079443359375034
								],
								[
									-76.19760742187495,
									44.08349609374997
								],
								[
									-76.28061523437498,
									44.04648437499998
								],
								[
									-76.30605468750002,
									44.04321289062503
								],
								[
									-76.30966796874995,
									44.062744140625
								],
								[
									-76.35244140624997,
									44.106054687500034
								],
								[
									-76.23779296874997,
									44.183203125000034
								],
								[
									-75.83217773437502,
									44.397265625000045
								],
								[
									-75.79091796874997,
									44.42988281250001
								],
								[
									-75.77568359374996,
									44.458886718749966
								],
								[
									-75.78657226562495,
									44.48432617187501
								],
								[
									-75.79796599199037,
									44.49068267184725
								],
								[
									-75.79194335937498,
									44.49707031250003
								],
								[
									-75.40126953125,
									44.77226562499996
								],
								[
									-75.17939453124998,
									44.8993652343751
								],
								[
									-74.99614257812496,
									44.97011718749994
								],
								[
									-74.85664062499995,
									45.00390625000017
								],
								[
									-74.76245117187494,
									44.999072265625074
								],
								[
									-74.70888671874997,
									45.00385742187507
								],
								[
									-74.663232421875,
									45.003906250000085
								],
								[
									-74.43037109374998,
									45.00419921874996
								],
								[
									-74.01425781250003,
									45.004687500000045
								],
								[
									-73.59814453125,
									45.005175781250074
								],
								[
									-73.18203124999994,
									45.00561523437506
								],
								[
									-72.76591796874999,
									45.006103515625085
								],
								[
									-72.34975585937494,
									45.006591796875
								],
								[
									-71.93364257812499,
									45.007080078125114
								],
								[
									-71.51752929687495,
									45.00756835937503
								],
								[
									-71.41904296874995,
									45.20034179687505
								],
								[
									-71.327294921875,
									45.29008789062493
								],
								[
									-71.20161132812498,
									45.260351562500006
								],
								[
									-71.13466796875002,
									45.26284179687508
								],
								[
									-71.06025390624995,
									45.309130859375074
								],
								[
									-70.99990234375002,
									45.33725585937495
								],
								[
									-70.96015624999998,
									45.33310546875009
								],
								[
									-70.92622070312501,
									45.29072265625007
								],
								[
									-70.89799804687493,
									45.262451171875085
								],
								[
									-70.86503906249999,
									45.27070312499998
								],
								[
									-70.83681640625,
									45.31069335937505
								],
								[
									-70.83779296875002,
									45.36616210937498
								],
								[
									-70.79916992187498,
									45.40478515624994
								],
								[
									-70.75332031249997,
									45.41069335937499
								],
								[
									-70.71093750000003,
									45.40947265625002
								],
								[
									-70.68979492187498,
									45.428320312500034
								],
								[
									-70.69213867187503,
									45.455371093750045
								],
								[
									-70.70742187500002,
									45.49892578124994
								],
								[
									-70.70224609375003,
									45.55136718750006
								],
								[
									-70.59638671874995,
									45.64399414062501
								],
								[
									-70.46660156249999,
									45.70683593749993
								],
								[
									-70.42109374999995,
									45.738232421874926
								],
								[
									-70.40786132812502,
									45.80190429687494
								],
								[
									-70.33344726562495,
									45.86806640625008
								],
								[
									-70.296240234375,
									45.90610351562512
								],
								[
									-70.28715820312502,
									45.93916015625001
								],
								[
									-70.30644531249996,
									45.97983398437495
								],
								[
									-70.30449218749999,
									46.05737304687503
								],
								[
									-70.27890625000003,
									46.14999999999998
								],
								[
									-70.248291015625,
									46.25087890625011
								],
								[
									-70.17968749999997,
									46.341845703125074
								],
								[
									-70.06718749999996,
									46.44106445312494
								],
								[
									-70.03823242187502,
									46.57143554687502
								],
								[
									-70.00771484375002,
									46.70893554687498
								],
								[
									-69.87172851562494,
									46.84291992187511
								],
								[
									-69.71752929687497,
									46.99487304687497
								],
								[
									-69.62978515624994,
									47.0813476562501
								],
								[
									-69.47148437499993,
									47.23867187500008
								],
								[
									-69.35888671875,
									47.350634765625074
								],
								[
									-69.3021484375,
									47.40200195312505
								],
								[
									-69.24287109374998,
									47.46298828124995
								],
								[
									-69.14628906249993,
									47.44477539062507
								],
								[
									-69.0501953125,
									47.42661132812509
								],
								[
									-69.06425781250002,
									47.338134765625
								],
								[
									-69.04858398437503,
									47.27363281250001
								],
								[
									-69.00312500000001,
									47.23642578124998
								],
								[
									-68.93720703124998,
									47.21123046874999
								],
								[
									-68.88740234374995,
									47.20283203125007
								],
								[
									-68.8287109375,
									47.20332031249998
								],
								[
									-68.66855468749995,
									47.253466796875074
								],
								[
									-68.48037109375,
									47.285791015624994
								],
								[
									-68.37690429687495,
									47.31616210937506
								],
								[
									-68.35800781250003,
									47.344531250000074
								],
								[
									-68.310888671875,
									47.35449218750006
								],
								[
									-68.23549804687502,
									47.345947265625085
								],
								[
									-68.09677734375,
									47.27485351562498
								],
								[
									-67.93486328124996,
									47.167626953124994
								],
								[
									-67.806787109375,
									47.082812500000045
								],
								[
									-67.80283203124998,
									46.9357421875001
								],
								[
									-67.80034179687502,
									46.779882812500034
								],
								[
									-67.797705078125,
									46.61562500000008
								],
								[
									-67.79580078124997,
									46.49838867187506
								],
								[
									-67.79252929687502,
									46.33740234375006
								],
								[
									-67.78994140625002,
									46.20932617187498
								],
								[
									-67.78647460937503,
									46.04213867187494
								],
								[
									-67.78466796875,
									45.95278320312494
								],
								[
									-67.76704101562498,
									45.927001953125114
								],
								[
									-67.77763671874999,
									45.891796874999955
								],
								[
									-67.78227539062496,
									45.87416992187508
								],
								[
									-67.78115234375,
									45.86015624999999
								],
								[
									-67.77412109374998,
									45.84252929687503
								],
								[
									-67.77529296874997,
									45.817871093750085
								],
								[
									-67.79169921874993,
									45.79555664062505
								],
								[
									-67.79990234375,
									45.76977539062506
								],
								[
									-67.800694304263,
									45.75550360221345
								],
								[
									-67.86298828124998,
									45.739599609375034
								],
								[
									-67.778955078125,
									45.67011718750001
								],
								[
									-67.62548828125,
									45.60224609375004
								],
								[
									-67.51240234374995,
									45.58935546874997
								],
								[
									-67.44941406250001,
									45.60708007812502
								],
								[
									-67.44970446134872,
									45.60795127467105
								],
								[
									-67.43266601562499,
									45.603125000000034
								],
								[
									-67.41386718749996,
									45.56557617187502
								],
								[
									-67.42441406249998,
									45.53041992187505
								],
								[
									-67.45493164062498,
									45.513964843750074
								],
								[
									-67.48779296875003,
									45.50102539062502
								],
								[
									-67.49365234374997,
									45.47407226562504
								],
								[
									-67.47724609375001,
									45.44589843750006
								],
								[
									-67.45375976562502,
									45.421240234375006
								],
								[
									-67.42792968749998,
									45.37792968750006
								],
								[
									-67.43852539062502,
									45.340380859375045
								],
								[
									-67.46196289062499,
									45.30869140625009
								],
								[
									-67.47255859375002,
									45.27587890624997
								],
								[
									-67.45258789062495,
									45.24765625000009
								],
								[
									-67.39980468749994,
									45.2101562500001
								],
								[
									-67.366943359375,
									45.173779296874955
								],
								[
									-67.31528320312495,
									45.15380859374997
								],
								[
									-67.290673828125,
									45.16791992187501
								],
								[
									-67.27070312499993,
									45.186718749999926
								],
								[
									-67.24960937499998,
									45.20078124999995
								],
								[
									-67.21323242187503,
									45.19252929687505
								],
								[
									-67.17099609374995,
									45.181982421875034
								],
								[
									-67.12485351562498,
									45.16943359375006
								],
								[
									-67.13037109375003,
									45.13901367187498
								],
								[
									-67.10224609374998,
									45.08774414062509
								],
								[
									-67.08046875,
									44.98916015625008
								],
								[
									-67.11391601562497,
									44.94438476562502
								],
								[
									-67.10673828125002,
									44.88505859374993
								],
								[
									-67.01401367187503,
									44.86777343750006
								],
								[
									-66.99145507812497,
									44.849609375000085
								],
								[
									-66.98701171874995,
									44.827685546875045
								],
								[
									-67.191259765625,
									44.675585937500074
								],
								[
									-67.36406249999993,
									44.69687500000006
								],
								[
									-67.45781249999996,
									44.6565429687501
								],
								[
									-67.55600585937498,
									44.644775390625085
								],
								[
									-67.59907226562495,
									44.57680664062502
								],
								[
									-67.652978515625,
									44.56240234375011
								],
								[
									-67.72680664062494,
									44.56650390625006
								],
								[
									-67.79047851562495,
									44.58569335937506
								],
								[
									-67.83906249999998,
									44.57626953125009
								],
								[
									-67.90703124999999,
									44.45361328125006
								],
								[
									-67.96269531249996,
									44.464306640624926
								],
								[
									-67.98486328125003,
									44.420166015625085
								],
								[
									-68.01396484375002,
									44.40087890624997
								],
								[
									-68.056640625,
									44.384326171875074
								],
								[
									-68.09370117187501,
									44.43881835937506
								],
								[
									-68.11728515625,
									44.49062500000005
								],
								[
									-68.15205078124998,
									44.50200195312496
								],
								[
									-68.19824218749997,
									44.51523437500009
								],
								[
									-68.24575195312497,
									44.514794921874994
								],
								[
									-68.27744140625003,
									44.50737304687499
								],
								[
									-68.31674804687498,
									44.473876953125085
								],
								[
									-68.37373046874993,
									44.44511718750002
								],
								[
									-68.416845703125,
									44.469091796875006
								],
								[
									-68.45058593749997,
									44.507617187500045
								],
								[
									-68.47944335937498,
									44.445654296875034
								],
								[
									-68.52143554687501,
									44.38022460937512
								],
								[
									-68.51445312500002,
									44.303906249999926
								],
								[
									-68.53251953124996,
									44.25864257812495
								],
								[
									-68.57236328125,
									44.27084960937495
								],
								[
									-68.61201171874998,
									44.31054687500003
								],
								[
									-68.72329101562502,
									44.34228515625003
								],
								[
									-68.81191406249994,
									44.33935546875006
								],
								[
									-68.79389648437501,
									44.38173828125008
								],
								[
									-68.710107421875,
									44.44257812500004
								],
								[
									-68.73588867187499,
									44.454492187499966
								],
								[
									-68.77700195312502,
									44.44604492187503
								],
								[
									-68.79492187499994,
									44.454492187499966
								],
								[
									-68.76552734375,
									44.50976562499994
								],
								[
									-68.76269531249994,
									44.57075195312504
								],
								[
									-68.80019531249997,
									44.549414062500034
								],
								[
									-68.84736328124998,
									44.48505859375007
								],
								[
									-68.96147460937496,
									44.43383789062503
								],
								[
									-68.95615234375003,
									44.34809570312504
								],
								[
									-69.06357421874998,
									44.17236328125006
								],
								[
									-69.06835937499997,
									44.097558593749994
								],
								[
									-69.13725585937496,
									44.037841796875085
								],
								[
									-69.22607421875003,
									43.98647460937511
								],
								[
									-69.34453125000002,
									44.00092773437501
								],
								[
									-69.43496093749997,
									43.956298828125085
								],
								[
									-69.480859375,
									43.905078125000045
								],
								[
									-69.52075195312503,
									43.89736328125005
								],
								[
									-69.54155273437499,
									43.96259765625004
								],
								[
									-69.55668945312499,
									43.98276367187506
								],
								[
									-69.58999023437502,
									43.88657226562509
								],
								[
									-69.62392578125,
									43.88061523437503
								],
								[
									-69.63676757812496,
									43.94882812499998
								],
								[
									-69.65288085937493,
									43.993896484375114
								],
								[
									-69.69912109374994,
									43.9550292968751
								],
								[
									-69.72983398437498,
									43.85200195312507
								],
								[
									-69.76201171874996,
									43.86069335937506
								],
								[
									-69.77226562500002,
									43.899023437500034
								],
								[
									-69.7953125,
									43.910644531250114
								],
								[
									-69.80322265625003,
									43.86684570312505
								],
								[
									-69.79160156249995,
									43.805224609375045
								],
								[
									-69.808349609375,
									43.77231445312509
								],
								[
									-69.84033203125003,
									43.78989257812512
								],
								[
									-69.87250976562501,
									43.819531249999926
								],
								[
									-69.92558593749999,
									43.79702148437505
								],
								[
									-69.97431640624998,
									43.78789062499996
								],
								[
									-69.97451171875002,
									43.81806640624998
								],
								[
									-69.965234375,
									43.85507812499998
								],
								[
									-70.06235351562498,
									43.83461914062508
								],
								[
									-70.17880859374998,
									43.766357421875114
								],
								[
									-70.26923828125001,
									43.67192382812496
								],
								[
									-70.23789062500003,
									43.656201171874955
								],
								[
									-70.20258789062493,
									43.62612304687505
								],
								[
									-70.35966796874996,
									43.480224609375085
								],
								[
									-70.52070312499998,
									43.348828124999955
								],
								[
									-70.642333984375,
									43.13442382812505
								],
								[
									-70.691162109375,
									43.109326171874926
								],
								[
									-70.73310546875001,
									43.0700195312501
								],
								[
									-70.77763671874993,
									42.94057617187511
								],
								[
									-70.82905273437493,
									42.82534179687508
								],
								[
									-70.80029296875003,
									42.774023437500006
								],
								[
									-70.78134765624998,
									42.721240234375074
								],
								[
									-70.735693359375,
									42.66928710937498
								],
								[
									-70.696875,
									42.6645996093751
								],
								[
									-70.65483398437496,
									42.67397460937505
								],
								[
									-70.62397460937498,
									42.67177734375005
								],
								[
									-70.60415039062494,
									42.64970703124999
								],
								[
									-70.61293945312497,
									42.623242187499926
								],
								[
									-70.66142578124999,
									42.61665039062501
								],
								[
									-70.75185546875002,
									42.57036132812499
								],
								[
									-70.83115234375,
									42.552587890625006
								],
								[
									-70.87089843750002,
									42.496630859375074
								],
								[
									-70.93046874999999,
									42.43198242187495
								],
								[
									-71.04619140624993,
									42.3311035156251
								],
								[
									-70.996728515625,
									42.30000000000007
								],
								[
									-70.81796874999998,
									42.26494140625002
								],
								[
									-70.73828125,
									42.22885742187506
								],
								[
									-70.61767578125003,
									42.04042968749994
								],
								[
									-70.64521484374995,
									42.021582031250006
								],
								[
									-70.65615234374997,
									41.987060546875085
								],
								[
									-70.54892578124998,
									41.93862304687508
								],
								[
									-70.51469726562502,
									41.80332031249995
								],
								[
									-70.42666015625002,
									41.75727539062498
								],
								[
									-70.29545898437493,
									41.72895507812507
								],
								[
									-70.13500976562503,
									41.76987304687498
								],
								[
									-70.00141601562498,
									41.826171875000085
								],
								[
									-70.00610351562497,
									41.87231445312497
								],
								[
									-70.09003906250001,
									41.9796875000001
								],
								[
									-70.11025390624997,
									42.03012695312498
								],
								[
									-70.17255859374995,
									42.062792968750045
								],
								[
									-70.19624023437498,
									42.035107421874926
								],
								[
									-70.23652343750001,
									42.07104492187506
								],
								[
									-70.24106445312495,
									42.09121093750008
								],
								[
									-70.20351562499994,
									42.10102539062504
								],
								[
									-70.15986328124993,
									42.09711914062504
								],
								[
									-70.10893554687496,
									42.07832031250001
								],
								[
									-69.97788085937498,
									41.96127929687498
								],
								[
									-69.94160156249995,
									41.807861328125085
								],
								[
									-69.93383789062497,
									41.71044921875003
								],
								[
									-69.94863281249997,
									41.67714843750011
								],
								[
									-69.98676757812493,
									41.68398437500008
								],
								[
									-70.05952148437501,
									41.677343750000034
								],
								[
									-70.4046875,
									41.62690429687498
								],
								[
									-70.48134765624997,
									41.58247070312507
								],
								[
									-70.65712890625,
									41.53422851562493
								],
								[
									-70.66806640625,
									41.558300781249955
								],
								[
									-70.65537109374998,
									41.60810546875007
								],
								[
									-70.66645507812493,
									41.710107421874966
								],
								[
									-70.70112304687498,
									41.71484375000006
								],
								[
									-70.97421875,
									41.54853515625001
								],
								[
									-71.07978515624995,
									41.538085937500085
								],
								[
									-71.1685546875,
									41.48940429687505
								],
								[
									-71.18842773437495,
									41.516406250000045
								],
								[
									-71.20429687499998,
									41.64111328124994
								],
								[
									-71.14873046874996,
									41.745703125000034
								],
								[
									-71.17832031250003,
									41.74404296875005
								],
								[
									-71.27109375,
									41.68124999999995
								],
								[
									-71.31074218750001,
									41.71987304687511
								],
								[
									-71.33061523437496,
									41.76225585937493
								],
								[
									-71.35917968750002,
									41.78623046875012
								],
								[
									-71.39013671875003,
									41.79531250000011
								],
								[
									-71.36367187499997,
									41.70273437499998
								],
								[
									-71.42656249999999,
									41.63330078125006
								],
								[
									-71.44379882812493,
									41.45371093750006
								],
								[
									-71.52285156249997,
									41.3789550781251
								],
								[
									-71.769287109375,
									41.33090820312509
								],
								[
									-71.92993164062503,
									41.341064453125114
								],
								[
									-72.07387695312497,
									41.32612304687507
								],
								[
									-72.26528320312497,
									41.29165039062508
								],
								[
									-72.37104492187501,
									41.31215820312508
								],
								[
									-72.47939453124997,
									41.27578125000005
								],
								[
									-72.84716796875003,
									41.26586914062497
								],
								[
									-72.92470703125002,
									41.285156250000085
								],
								[
									-73.02373046874993,
									41.21645507812494
								],
								[
									-73.182275390625,
									41.17583007812502
								],
								[
									-73.5830078125,
									41.02187500000008
								],
								[
									-73.67138671875,
									40.96586914062496
								],
								[
									-73.77900390624998,
									40.87841796875
								],
								[
									-73.85126953124995,
									40.831396484375006
								],
								[
									-73.91069335937499,
									40.81611328125001
								],
								[
									-73.94721679687495,
									40.77695312500012
								],
								[
									-73.98710937500002,
									40.75136718750005
								],
								[
									-73.94858398437498,
									40.83876953125008
								],
								[
									-73.90673828124997,
									40.912451171875006
								],
								[
									-73.87197265625,
									41.05517578124994
								],
								[
									-73.88222656249997,
									41.170605468749926
								],
								[
									-73.92534179687493,
									41.2180664062501
								],
								[
									-73.96992187499995,
									41.24970703125007
								],
								[
									-73.91767578124998,
									41.13579101562502
								],
								[
									-73.90922851562496,
									40.996093750000085
								],
								[
									-73.92719726562495,
									40.914257812499926
								],
								[
									-74.02548828125,
									40.7563964843751
								],
								[
									-74.06733398437501,
									40.71962890625008
								],
								[
									-74.11625976562493,
									40.68730468749996
								],
								[
									-74.15312499999999,
									40.67324218749994
								],
								[
									-74.187158203125,
									40.647998046875045
								],
								[
									-74.22670898437497,
									40.60800781249998
								],
								[
									-74.26420898437496,
									40.52861328124996
								],
								[
									-74.24150390624996,
									40.45625000000007
								],
								[
									-74.04985351562499,
									40.42983398437508
								],
								[
									-73.9984375,
									40.452148437500114
								],
								[
									-73.972265625,
									40.40034179687504
								],
								[
									-73.95761718750003,
									40.32836914062503
								],
								[
									-73.97197265624993,
									40.250537109375074
								],
								[
									-74.00400390624998,
									40.17133789062501
								],
								[
									-74.02832031249997,
									40.07299804687506
								],
								[
									-74.04892578124998,
									39.92304687500004
								],
								[
									-74.079931640625,
									39.78813476562502
								],
								[
									-74.08398437500003,
									39.829101562500085
								],
								[
									-74.064599609375,
									39.99311523437504
								],
								[
									-74.09599609374999,
									39.975976562499994
								],
								[
									-74.11762695312495,
									39.93813476562502
								],
								[
									-74.17612304687498,
									39.7266113281251
								],
								[
									-74.25654296875001,
									39.61386718749995
								],
								[
									-74.33061523437499,
									39.53588867187506
								],
								[
									-74.40703125000002,
									39.54877929687501
								],
								[
									-74.38984374999998,
									39.48681640625
								],
								[
									-74.41083984375001,
									39.4545410156251
								],
								[
									-74.42880859375,
									39.38720703125006
								],
								[
									-74.47436523437497,
									39.34257812500002
								],
								[
									-74.5171875,
									39.3468750000001
								],
								[
									-74.5787109375,
									39.31611328125004
								],
								[
									-74.60297851562498,
									39.29257812499995
								],
								[
									-74.60478515624999,
									39.24750976562501
								],
								[
									-74.64594726562493,
									39.207861328125006
								],
								[
									-74.79448242187499,
									39.00190429687507
								],
								[
									-74.92343749999998,
									38.94111328125001
								],
								[
									-74.95429687499995,
									38.94995117187506
								],
								[
									-74.92031249999997,
									39.04716796874996
								],
								[
									-74.89702148437502,
									39.1454589843751
								],
								[
									-74.97529296874998,
									39.188232421875085
								],
								[
									-75.05019531249997,
									39.210839843749994
								],
								[
									-75.13613281249997,
									39.207861328125006
								],
								[
									-75.23105468750003,
									39.28427734374995
								],
								[
									-75.35341796875,
									39.339843750000085
								],
								[
									-75.52421874999999,
									39.49018554687507
								],
								[
									-75.51923828124995,
									39.53188476562494
								],
								[
									-75.52353515625003,
									39.60185546874999
								],
								[
									-75.47163085937501,
									39.71240234374994
								],
								[
									-75.421875,
									39.78969726562505
								],
								[
									-75.35317382812497,
									39.82973632812505
								],
								[
									-75.15380859375003,
									39.87050781250011
								],
								[
									-75.10380859374996,
									39.93183593750007
								],
								[
									-75.07416992187495,
									39.98349609375012
								],
								[
									-75.17294921875,
									39.89477539062497
								],
								[
									-75.32089843750003,
									39.86469726562507
								],
								[
									-75.40063476562503,
									39.831591796875074
								],
								[
									-75.46440429687496,
									39.78095703125007
								],
								[
									-75.50214843750001,
									39.71738281250006
								],
								[
									-75.58759765625001,
									39.64077148437511
								],
								[
									-75.58159179687496,
									39.58945312499995
								],
								[
									-75.56728515624997,
									39.55297851562497
								],
								[
									-75.57387695312497,
									39.47695312499994
								],
								[
									-75.51982421874999,
									39.40283203124994
								],
								[
									-75.41264648437499,
									39.28139648437508
								],
								[
									-75.3921875,
									39.092773437500114
								],
								[
									-75.31040039062503,
									38.96655273437506
								],
								[
									-75.18505859375,
									38.8193847656251
								],
								[
									-75.08867187499999,
									38.77753906250001
								],
								[
									-75.083984375,
									38.72280273437505
								],
								[
									-75.12846679687502,
									38.63242187500012
								],
								[
									-75.18710937499995,
									38.591113281250045
								],
								[
									-75.11083984374997,
									38.59936523437494
								],
								[
									-75.07285156249995,
									38.57871093750009
								],
								[
									-75.03588867187497,
									38.50332031250011
								],
								[
									-75.03876953124993,
									38.42636718750006
								],
								[
									-75.05126953125,
									38.38300781250001
								],
								[
									-75.074365234375,
									38.36572265625003
								],
								[
									-75.07338867187497,
									38.410009765625006
								],
								[
									-75.08974609375002,
									38.425390625000034
								],
								[
									-75.11674804687502,
									38.40620117187504
								],
								[
									-75.13422851562493,
									38.38432617187502
								],
								[
									-75.14150390625,
									38.298144531250045
								],
								[
									-75.16000976562503,
									38.25507812500007
								],
								[
									-75.22543945312495,
									38.242285156250034
								],
								[
									-75.29179687499996,
									38.12919921874999
								],
								[
									-75.35351562500003,
									38.06503906249998
								],
								[
									-75.59638671874995,
									37.63120117187506
								],
								[
									-75.58710937500001,
									37.558691406250034
								],
								[
									-75.63154296875001,
									37.53535156249998
								],
								[
									-75.69882812500003,
									37.516357421875114
								],
								[
									-75.76689453124996,
									37.47299804687498
								],
								[
									-75.81206054687502,
									37.42519531250011
								],
								[
									-75.85400390625003,
									37.296630859375114
								],
								[
									-75.93437499999996,
									37.15190429687493
								],
								[
									-75.98452148437497,
									37.21220703124996
								],
								[
									-75.99736328125002,
									37.263818359374994
								],
								[
									-75.97504882812498,
									37.39843749999997
								],
								[
									-75.88813476562495,
									37.619140625
								],
								[
									-75.7923828125,
									37.75634765624997
								],
								[
									-75.71933593750003,
									37.82138671875009
								],
								[
									-75.65927734374998,
									37.95395507812509
								],
								[
									-75.73515624999996,
									37.973730468750034
								],
								[
									-75.850830078125,
									37.97158203125002
								],
								[
									-75.82905273437501,
									38.032763671875074
								],
								[
									-75.79531249999997,
									38.08666992187494
								],
								[
									-75.855615234375,
									38.14038085937506
								],
								[
									-75.89130859374998,
									38.14721679687503
								],
								[
									-75.928076171875,
									38.169238281250074
								],
								[
									-75.88496093749993,
									38.213964843750034
								],
								[
									-75.863916015625,
									38.26123046875006
								],
								[
									-75.87675781249996,
									38.31875000000005
								],
								[
									-75.85869140624999,
									38.362060546875
								],
								[
									-75.88881835937502,
									38.3555175781251
								],
								[
									-75.93725585937503,
									38.30966796875009
								],
								[
									-75.96738281250003,
									38.29135742187509
								],
								[
									-75.98574218749994,
									38.331933593749994
								],
								[
									-76.00668945312495,
									38.322753906250085
								],
								[
									-76.02031249999999,
									38.2948730468751
								],
								[
									-76.05122070312495,
									38.27954101562506
								],
								[
									-76.11650390624993,
									38.31767578124993
								],
								[
									-76.21166992187497,
									38.36132812499994
								],
								[
									-76.26464843750003,
									38.436425781249966
								],
								[
									-76.29487304687495,
									38.494628906250114
								],
								[
									-76.26416015625,
									38.59995117187498
								],
								[
									-76.19838867187502,
									38.61865234375006
								],
								[
									-76.11293945312502,
									38.60156249999994
								],
								[
									-76.00092773437493,
									38.60170898437508
								],
								[
									-76.016943359375,
									38.62509765624995
								],
								[
									-76.05693359374999,
									38.62124023437505
								],
								[
									-76.17499999999995,
									38.70668945312505
								],
								[
									-76.21298828124998,
									38.758300781250085
								],
								[
									-76.27832031249997,
									38.77246093749994
								],
								[
									-76.30810546875,
									38.72285156250007
								],
								[
									-76.34116210937498,
									38.70966796875004
								],
								[
									-76.30034179687502,
									38.818212890625034
								],
								[
									-76.24697265624997,
									38.82265625000005
								],
								[
									-76.16816406249998,
									38.852734374999955
								],
								[
									-76.19106445312494,
									38.915576171875074
								],
								[
									-76.24082031249995,
									38.94306640625007
								],
								[
									-76.33066406249998,
									38.908593749999966
								],
								[
									-76.32958984375,
									38.95278320312508
								],
								[
									-76.31274414062494,
									39.00937500000006
								],
								[
									-76.24501953125002,
									39.00917968750002
								],
								[
									-76.185693359375,
									38.99072265625
								],
								[
									-76.13520507812493,
									39.08212890624998
								],
								[
									-76.13295898437502,
									39.12294921874994
								],
								[
									-76.21684570312496,
									39.06362304687494
								],
								[
									-76.23569335937498,
									39.19160156249998
								],
								[
									-76.15312499999993,
									39.31503906250009
								],
								[
									-76.07436523437497,
									39.36884765625004
								],
								[
									-75.9759765625,
									39.36728515624998
								],
								[
									-75.87597656249997,
									39.37597656249997
								],
								[
									-75.93872070312497,
									39.398583984374966
								],
								[
									-76.00312499999993,
									39.41083984375007
								],
								[
									-75.95473632812502,
									39.459619140624966
								],
								[
									-75.91347656249997,
									39.46835937500006
								],
								[
									-75.87294921874997,
									39.51088867187502
								],
								[
									-75.97041015624993,
									39.50458984375007
								],
								[
									-75.95893554687498,
									39.585058593750034
								],
								[
									-76.00629882812495,
									39.56870117187498
								],
								[
									-76.06298828124997,
									39.56113281249995
								],
								[
									-76.08505859375003,
									39.52700195312511
								],
								[
									-76.08071289062502,
									39.470312500000006
								],
								[
									-76.09726562500003,
									39.43310546875006
								],
								[
									-76.14135742187503,
									39.40322265625002
								],
								[
									-76.21582031250003,
									39.379931640625074
								],
								[
									-76.22304687499997,
									39.42031250000005
								],
								[
									-76.24765625,
									39.43862304687505
								],
								[
									-76.25683593750003,
									39.352148437500006
								],
								[
									-76.2763671875,
									39.32275390624997
								],
								[
									-76.330810546875,
									39.40390624999998
								],
								[
									-76.34716796874994,
									39.38754882812512
								],
								[
									-76.34506835937498,
									39.36450195312494
								],
								[
									-76.35898437499995,
									39.3246582031251
								],
								[
									-76.40566406249997,
									39.30390625000004
								],
								[
									-76.40278320312501,
									39.25283203124994
								],
								[
									-76.42089843749997,
									39.22500000000005
								],
								[
									-76.57041015624995,
									39.26933593750002
								],
								[
									-76.57392578124995,
									39.254296874999966
								],
								[
									-76.48935546874998,
									39.15869140624994
								],
								[
									-76.427587890625,
									39.126025390625045
								],
								[
									-76.42006835937497,
									39.07387695312508
								],
								[
									-76.47309570312493,
									39.03061523437506
								],
								[
									-76.546240234375,
									39.06796875000012
								],
								[
									-76.55854492187493,
									39.065234375000074
								],
								[
									-76.518798828125,
									39.0011718750001
								],
								[
									-76.49374999999998,
									38.945214843749966
								],
								[
									-76.51953124999997,
									38.89833984375011
								],
								[
									-76.51552734374997,
									38.840625000000074
								],
								[
									-76.52109375000003,
									38.78828125000007
								],
								[
									-76.53686523437497,
									38.7426269531251
								],
								[
									-76.501318359375,
									38.53217773437501
								],
								[
									-76.45849609374997,
									38.47495117187509
								],
								[
									-76.41640625000002,
									38.420214843750045
								],
								[
									-76.39409179687502,
									38.36899414062509
								],
								[
									-76.43876953124996,
									38.36152343749998
								],
								[
									-76.50991210937497,
									38.40366210937495
								],
								[
									-76.57241210937502,
									38.435791015625114
								],
								[
									-76.646875,
									38.53852539062498
								],
								[
									-76.6591796875,
									38.57954101562507
								],
								[
									-76.67734374999998,
									38.61196289062494
								],
								[
									-76.66855468749998,
									38.53750000000005
								],
								[
									-76.64199218749997,
									38.45434570312497
								],
								[
									-76.40878906249998,
									38.26826171875007
								],
								[
									-76.36572265625,
									38.19687500000009
								],
								[
									-76.33291015624997,
									38.14077148437505
								],
								[
									-76.34116210937498,
									38.08701171875009
								],
								[
									-76.401953125,
									38.125048828125045
								],
								[
									-76.45439453124996,
									38.17353515625007
								],
								[
									-76.59360351562498,
									38.22832031249993
								],
								[
									-76.76914062500003,
									38.26293945312497
								],
								[
									-76.86811523437495,
									38.39028320312508
								],
								[
									-76.86777343749998,
									38.337158203125085
								],
								[
									-76.88974609375,
									38.29208984375006
								],
								[
									-76.95024414062499,
									38.34702148437506
								],
								[
									-76.98837890625003,
									38.393896484375006
								],
								[
									-77.00117187499995,
									38.44526367187507
								],
								[
									-77.07670898437499,
									38.44174804687506
								],
								[
									-77.15590820312497,
									38.39711914062505
								],
								[
									-77.23251953125003,
									38.40771484375006
								],
								[
									-77.2416015625,
									38.49482421875004
								],
								[
									-77.22089843749995,
									38.54096679687504
								],
								[
									-77.13491210937494,
									38.65009765625007
								],
								[
									-77.05390624999995,
									38.70581054687506
								],
								[
									-77.01816406249995,
									38.77773437500005
								],
								[
									-77.03037109374995,
									38.889257812500034
								],
								[
									-77.04560546874995,
									38.77578125000008
								],
								[
									-77.09189453124998,
									38.7195312500001
								],
								[
									-77.16464843749995,
									38.676562500000045
								],
								[
									-77.26040039062502,
									38.60000000000008
								],
								[
									-77.28378906249998,
									38.52919921875005
								],
								[
									-77.31367187499995,
									38.39663085937494
								],
								[
									-77.27324218749996,
									38.35175781250004
								],
								[
									-77.23193359375,
									38.340039062499955
								],
								[
									-77.10991210937499,
									38.37011718750006
								],
								[
									-77.04677734375002,
									38.35668945312497
								],
								[
									-76.90634765625,
									38.19707031249996
								],
								[
									-76.64487304687503,
									38.13393554687508
								],
								[
									-76.54951171874995,
									38.09448242187503
								],
								[
									-76.47177734375003,
									38.011181640624926
								],
								[
									-76.35493164062493,
									37.96323242187512
								],
								[
									-76.26425781250003,
									37.89355468749994
								],
								[
									-76.26181640624998,
									37.848095703124926
								],
								[
									-76.29321289062497,
									37.79433593750008
								],
								[
									-76.30561523437501,
									37.721582031249994
								],
								[
									-76.34414062499997,
									37.675683593749966
								],
								[
									-76.43662109374998,
									37.67041015625006
								],
								[
									-76.49248046874999,
									37.68222656250006
								],
								[
									-76.79277343749996,
									37.93798828124994
								],
								[
									-76.82861328124997,
									37.961523437500034
								],
								[
									-76.93999023437502,
									38.09545898437506
								],
								[
									-77.070654296875,
									38.16718750000001
								],
								[
									-77.11108398437497,
									38.165673828124966
								],
								[
									-76.92509765625002,
									38.03300781249993
								],
								[
									-76.84916992187499,
									37.940234375000045
								],
								[
									-76.7154296875,
									37.810156250000006
								],
								[
									-76.61982421874998,
									37.75507812499998
								],
								[
									-76.54946289062497,
									37.66914062500007
								],
								[
									-76.48408203124995,
									37.62885742187501
								],
								[
									-76.30556640625,
									37.57148437500007
								],
								[
									-76.36762695312495,
									37.530273437500114
								],
								[
									-76.2685546875,
									37.49516601562496
								],
								[
									-76.25439453124997,
									37.430615234374955
								],
								[
									-76.26347656249996,
									37.35703124999998
								],
								[
									-76.40097656249998,
									37.38613281250005
								],
								[
									-76.40546875000001,
									37.33193359375002
								],
								[
									-76.3931640625,
									37.29995117187508
								],
								[
									-76.45390624999993,
									37.27353515625012
								],
								[
									-76.53837890625002,
									37.309375000000045
								],
								[
									-76.75771484375002,
									37.50541992187502
								],
								[
									-76.755859375,
									37.4791992187501
								],
								[
									-76.73808593750002,
									37.44877929687493
								],
								[
									-76.61088867187493,
									37.322558593750074
								],
								[
									-76.49736328124999,
									37.2468750000001
								],
								[
									-76.40112304687503,
									37.212695312500074
								],
								[
									-76.32695312500002,
									37.14926757812512
								],
								[
									-76.30078125,
									37.11088867187502
								],
								[
									-76.28330078125,
									37.05268554687507
								],
								[
									-76.33828125,
									37.0131347656251
								],
								[
									-76.40087890624997,
									36.99130859375009
								],
								[
									-76.46201171874998,
									37.03076171874994
								],
								[
									-76.50683593749997,
									37.072314453125074
								],
								[
									-76.60229492187497,
									37.14287109374996
								],
								[
									-76.63090820312493,
									37.221728515625045
								],
								[
									-76.703515625,
									37.21767578125011
								],
								[
									-77.006982421875,
									37.317675781250045
								],
								[
									-77.25087890624994,
									37.32919921875009
								],
								[
									-77.22705078124997,
									37.30908203125006
								],
								[
									-77.19619140625,
									37.2957031250001
								],
								[
									-77.00195312500003,
									37.27104492187496
								],
								[
									-76.92519531250002,
									37.224999999999994
								],
								[
									-76.76542968749999,
									37.18413085937502
								],
								[
									-76.67187500000003,
									37.172949218750034
								],
								[
									-76.63393554687502,
									37.04741210937496
								],
								[
									-76.50463867187497,
									36.96103515624995
								],
								[
									-76.48784179687502,
									36.89702148437496
								],
								[
									-76.39956054687497,
									36.889843749999926
								],
								[
									-76.24423828125003,
									36.952636718750114
								],
								[
									-76.14399414062495,
									36.93061523437507
								],
								[
									-75.9994140625,
									36.912646484375045
								],
								[
									-75.96635742187499,
									36.86196289062502
								],
								[
									-75.941552734375,
									36.765527343749994
								],
								[
									-75.89042968749999,
									36.65703125000002
								],
								[
									-75.75786132812499,
									36.229248046875085
								],
								[
									-75.55869140624998,
									35.87934570312504
								],
								[
									-75.53417968749997,
									35.819091796875085
								],
								[
									-75.58046875,
									35.87197265625002
								],
								[
									-75.72822265624998,
									36.1037109375001
								],
								[
									-75.80976562499998,
									36.271044921875074
								],
								[
									-75.8935546875,
									36.56650390624995
								],
								[
									-75.91787109374997,
									36.63266601562512
								],
								[
									-75.94648437499995,
									36.65908203125008
								],
								[
									-75.96533203124997,
									36.63759765625005
								],
								[
									-75.97343750000002,
									36.59995117187512
								],
								[
									-75.95976562499999,
									36.571044921875085
								],
								[
									-75.99277343749995,
									36.47377929687508
								],
								[
									-75.97846679687498,
									36.42915039062504
								],
								[
									-75.92485351562499,
									36.38300781250004
								],
								[
									-75.86660156250002,
									36.267871093750045
								],
								[
									-75.82006835937494,
									36.11284179687499
								],
								[
									-75.88300781249998,
									36.17568359375008
								],
								[
									-75.9501953125,
									36.20898437499994
								],
								[
									-76.05473632812496,
									36.234521484374994
								],
								[
									-76.14785156250002,
									36.27929687499997
								],
								[
									-76.14106445312498,
									36.21508789062494
								],
								[
									-76.15,
									36.14575195312494
								],
								[
									-76.22177734374998,
									36.16689453125008
								],
								[
									-76.27060546874998,
									36.18989257812507
								],
								[
									-76.22739257812498,
									36.11601562500002
								],
								[
									-76.32119140625,
									36.13818359375
								],
								[
									-76.38369140625002,
									36.13354492187494
								],
								[
									-76.42431640624994,
									36.06796875000009
								],
								[
									-76.47880859374996,
									36.02817382812506
								],
								[
									-76.55937500000002,
									36.015332031249926
								],
								[
									-76.67890624999995,
									36.07529296874998
								],
								[
									-76.717626953125,
									36.14809570312508
								],
								[
									-76.733642578125,
									36.229150390624966
								],
								[
									-76.74003906249996,
									36.133300781250085
								],
								[
									-76.71874999999997,
									36.03349609374999
								],
								[
									-76.726220703125,
									35.95761718750006
								],
								[
									-76.61113281249999,
									35.943652343750074
								],
								[
									-76.503515625,
									35.95605468750003
								],
								[
									-76.35830078125,
									35.952880859375
								],
								[
									-76.26357421874997,
									35.96708984374996
								],
								[
									-76.20654296875,
									35.991210937500085
								],
								[
									-76.06977539062501,
									35.97031250000009
								],
								[
									-76.06005859375,
									35.87866210937497
								],
								[
									-76.07568359374997,
									35.78754882812507
								],
								[
									-76.08359374999998,
									35.69052734375012
								],
								[
									-76.04570312499999,
									35.69116210937497
								],
								[
									-76.00117187499998,
									35.72216796875006
								],
								[
									-75.97890624999997,
									35.89594726562504
								],
								[
									-75.85390625,
									35.96015625000007
								],
								[
									-75.81201171875,
									35.95576171875004
								],
								[
									-75.77221679687497,
									35.89990234375003
								],
								[
									-75.75883789062499,
									35.84326171875006
								],
								[
									-75.74472656249998,
									35.765478515625006
								],
								[
									-75.77392578124997,
									35.64697265625003
								],
								[
									-75.965966796875,
									35.50839843749995
								],
								[
									-76.10351562499997,
									35.38027343750005
								],
								[
									-76.173828125,
									35.354150390624966
								],
								[
									-76.27524414062495,
									35.36904296875008
								],
								[
									-76.39023437500003,
									35.40126953125005
								],
								[
									-76.44663085937498,
									35.40776367187496
								],
								[
									-76.489501953125,
									35.397021484375074
								],
								[
									-76.515625,
									35.436474609374955
								],
								[
									-76.53247070312494,
									35.50844726562505
								],
								[
									-76.57719726562502,
									35.532324218750034
								],
								[
									-76.61103515624998,
									35.52968749999994
								],
								[
									-76.63413085937498,
									35.45322265625009
								],
								[
									-76.74140624999998,
									35.431494140625006
								],
								[
									-76.88725585937493,
									35.463085937499955
								],
								[
									-77.03999023437495,
									35.5273925781251
								],
								[
									-76.97446289062503,
									35.45839843750008
								],
								[
									-76.595458984375,
									35.329687500000034
								],
								[
									-76.55278320312502,
									35.30561523437504
								],
								[
									-76.51293945312497,
									35.27041015625005
								],
								[
									-76.56596679687493,
									35.21518554687509
								],
								[
									-76.60751953124998,
									35.15297851562502
								],
								[
									-76.61337890625,
									35.10415039062502
								],
								[
									-76.62802734374998,
									35.073339843750034
								],
								[
									-76.77915039062503,
									34.990332031250006
								],
								[
									-76.86103515625001,
									35.00498046874998
								],
								[
									-77.07026367187501,
									35.15463867187509
								],
								[
									-76.97495117187503,
									35.0251953125001
								],
								[
									-76.89863281249995,
									34.9702636718751
								],
								[
									-76.744970703125,
									34.94096679687499
								],
								[
									-76.45673828124998,
									34.98935546875009
								],
								[
									-76.36220703125,
									34.93652343749997
								],
								[
									-76.439794921875,
									34.842919921874994
								],
								[
									-76.51689453124999,
									34.77724609374994
								],
								[
									-76.61801757812498,
									34.76992187500005
								],
								[
									-76.70708007812499,
									34.75214843749998
								],
								[
									-76.73320312499999,
									34.706982421874926
								],
								[
									-76.79667968749996,
									34.704150390625074
								],
								[
									-76.89589843750002,
									34.70146484374996
								],
								[
									-77.04951171874995,
									34.697363281250006
								],
								[
									-77.13388671875,
									34.70791015624994
								],
								[
									-77.25175781249993,
									34.615624999999966
								],
								[
									-77.29624023437503,
									34.60292968750005
								],
								[
									-77.3583984375,
									34.62026367187494
								],
								[
									-77.38447265624998,
									34.69438476562493
								],
								[
									-77.41225585937497,
									34.73081054687506
								],
								[
									-77.412939453125,
									34.59213867187498
								],
								[
									-77.40205078125001,
									34.554785156250006
								],
								[
									-77.37978515625,
									34.52661132812503
								],
								[
									-77.51767578125003,
									34.45136718749998
								],
								[
									-77.649658203125,
									34.35751953125006
								],
								[
									-77.69697265624995,
									34.3319824218751
								],
								[
									-77.750732421875,
									34.28496093750002
								],
								[
									-77.86083984374994,
									34.14916992187497
								],
								[
									-77.88803710937498,
									34.05014648437506
								],
								[
									-77.92783203125,
									33.93974609375002
								],
								[
									-77.93286132812497,
									33.98945312500004
								],
								[
									-77.926025390625,
									34.07314453124994
								],
								[
									-77.95327148437497,
									34.16899414062502
								],
								[
									-77.970556640625,
									33.99340820312494
								],
								[
									-78.01333007812502,
									33.91181640625001
								],
								[
									-78.40585937499998,
									33.91757812499995
								],
								[
									-78.57768554687499,
									33.87324218749998
								],
								[
									-78.84145507812497,
									33.72407226562507
								],
								[
									-78.92031249999997,
									33.65869140624997
								],
								[
									-79.13818359375003,
									33.40590820312508
								],
								[
									-79.19379882812498,
									33.24414062500006
								],
								[
									-79.23837890625,
									33.31215820312508
								],
								[
									-79.22734374999999,
									33.36318359375008
								],
								[
									-79.22646484375,
									33.40488281249995
								],
								[
									-79.28134765624998,
									33.31542968750003
								],
								[
									-79.22924804687503,
									33.18515624999995
								],
								[
									-79.27602539062497,
									33.13540039062494
								],
								[
									-79.41992187499997,
									33.04252929687502
								],
								[
									-79.49868164062502,
									33.02729492187504
								],
								[
									-79.58710937500001,
									33.00087890625008
								],
								[
									-79.61494140624998,
									32.90927734375006
								],
								[
									-79.73500976562494,
									32.82480468750009
								],
								[
									-79.80498046874999,
									32.78740234375002
								],
								[
									-79.93310546874997,
									32.810058593750085
								],
								[
									-79.89365234375003,
									32.728710937499955
								],
								[
									-79.94072265625002,
									32.66713867187494
								],
								[
									-80.02177734375002,
									32.619921875000074
								],
								[
									-80.12255859375003,
									32.58911132812503
								],
								[
									-80.180322265625,
									32.59287109375009
								],
								[
									-80.22968750000001,
									32.57651367187495
								],
								[
									-80.26835937499999,
									32.53735351562506
								],
								[
									-80.36284179687496,
									32.50073242187506
								],
								[
									-80.46098632812496,
									32.52133789062506
								],
								[
									-80.57221679687498,
									32.533691406250114
								],
								[
									-80.6341796875,
									32.51171875000006
								],
								[
									-80.530029296875,
									32.475390625000045
								],
								[
									-80.474267578125,
									32.42275390625005
								],
								[
									-80.48574218749994,
									32.351806640625
								],
								[
									-80.51362304687493,
									32.324414062499926
								],
								[
									-80.579345703125,
									32.2873046875001
								],
								[
									-80.60820312500002,
									32.29282226562506
								],
								[
									-80.62583007812498,
									32.32626953124995
								],
								[
									-80.64721679687497,
									32.395947265624926
								],
								[
									-80.67778320312499,
									32.381103515625114
								],
								[
									-80.68305664062498,
									32.34863281249997
								],
								[
									-80.709326171875,
									32.33706054687511
								],
								[
									-80.80253906249999,
									32.448046875000074
								],
								[
									-80.79790039062493,
									32.363378906250034
								],
								[
									-80.76533203124998,
									32.29833984374994
								],
								[
									-80.73383789062495,
									32.26533203125007
								],
								[
									-80.70205078124997,
									32.2458984375001
								],
								[
									-80.69423828124997,
									32.21572265625008
								],
								[
									-80.75800781249998,
									32.14218750000009
								],
								[
									-80.79082031250002,
									32.12583007812506
								],
								[
									-80.84921875,
									32.11391601562494
								],
								[
									-80.88208007812494,
									32.06860351562494
								],
								[
									-80.87236328125002,
									32.02958984374999
								],
								[
									-80.92343750000003,
									31.944921875000063
								],
								[
									-81.04555664062494,
									31.89204101562504
								],
								[
									-81.082861328125,
									31.894091796875102
								],
								[
									-81.11328124999997,
									31.87861328125004
								],
								[
									-81.09550781249999,
									31.840917968750006
								],
								[
									-81.0650390625,
									31.813476562500114
								],
								[
									-81.06611328124995,
									31.78798828125005
								],
								[
									-81.09838867187497,
									31.75336914062504
								],
								[
									-81.16210937499997,
									31.743701171875017
								],
								[
									-81.197900390625,
									31.704199218750034
								],
								[
									-81.18657226562499,
									31.66694335937501
								],
								[
									-81.16552734374997,
									31.646142578124937
								],
								[
									-81.16992187499997,
									31.610302734374926
								],
								[
									-81.24238281249998,
									31.574316406250063
								],
								[
									-81.25937499999998,
									31.53891601562495
								],
								[
									-81.22338867187503,
									31.52846679687505
								],
								[
									-81.195703125,
									31.53891601562495
								],
								[
									-81.17543945312494,
									31.53129882812499
								],
								[
									-81.218896484375,
									31.472119140624926
								],
								[
									-81.25791015624995,
									31.436035156249943
								],
								[
									-81.29497070312496,
									31.371191406250063
								],
								[
									-81.38095703124998,
									31.353271484375057
								],
								[
									-81.37773437499993,
									31.33232421874996
								],
								[
									-81.32915039062499,
									31.313769531250074
								],
								[
									-81.28847656249997,
									31.263916015625057
								],
								[
									-81.364892578125,
									31.171875000000057
								],
								[
									-81.41259765625003,
									31.179443359375085
								],
								[
									-81.441748046875,
									31.199707031249943
								],
								[
									-81.4603515625,
									31.127050781250063
								],
								[
									-81.45322265624995,
									31.08828125000008
								],
								[
									-81.47138671875001,
									31.009033203125
								],
								[
									-81.5005859375,
									30.913769531249955
								],
								[
									-81.52041015624997,
									30.87465820312508
								],
								[
									-81.5162109375,
									30.801806640625045
								],
								[
									-81.50395507812499,
									30.73144531250003
								],
								[
									-81.45717773437497,
									30.640771484374937
								],
								[
									-81.38574218749997,
									30.269970703125068
								],
								[
									-81.33710937500001,
									30.14121093749995
								],
								[
									-81.24951171875003,
									29.793798828125034
								],
								[
									-81.10454101562499,
									29.456982421875097
								],
								[
									-80.89999999999995,
									29.049853515625102
								],
								[
									-80.56430664062495,
									28.556396484375114
								],
								[
									-80.52412109374995,
									28.486083984375085
								],
								[
									-80.56782226562495,
									28.426464843749926
								],
								[
									-80.58115234375,
									28.364697265624955
								],
								[
									-80.5849609375,
									28.27158203125009
								],
								[
									-80.5728515625,
									28.180859374999983
								],
								[
									-80.53315429687501,
									28.07006835937497
								],
								[
									-80.456884765625,
									27.900683593750017
								],
								[
									-80.49956054687502,
									27.934472656249966
								],
								[
									-80.61000976562494,
									28.177587890625034
								],
								[
									-80.62285156249999,
									28.320361328125074
								],
								[
									-80.60693359375003,
									28.52290039062504
								],
								[
									-80.63286132812499,
									28.518017578124926
								],
								[
									-80.65390625,
									28.452197265624932
								],
								[
									-80.66547851562495,
									28.374902343749994
								],
								[
									-80.693505859375,
									28.34497070312503
								],
								[
									-80.73173828124996,
									28.46289062499997
								],
								[
									-80.72905273437496,
									28.516210937500006
								],
								[
									-80.68847656250003,
									28.578515624999994
								],
								[
									-80.70024414062493,
									28.600927734375034
								],
								[
									-80.76591796874999,
									28.632812500000057
								],
								[
									-80.7798828125,
									28.682958984375034
								],
								[
									-80.77099609374997,
									28.732470703125102
								],
								[
									-80.80869140625,
									28.75893554687508
								],
								[
									-80.83818359374999,
									28.75766601562509
								],
								[
									-80.81840820312496,
									28.63559570312509
								],
								[
									-80.78720703124998,
									28.56064453125009
								],
								[
									-80.74863281250003,
									28.381005859374994
								],
								[
									-80.68637695312495,
									28.27216796875001
								],
								[
									-80.65009765624995,
									28.180908203125085
								],
								[
									-80.22612304687499,
									27.207031250000085
								],
								[
									-80.12578124999996,
									27.083007812500057
								],
								[
									-80.08867187499996,
									26.993945312500017
								],
								[
									-80.050048828125,
									26.80771484375009
								],
								[
									-80.04130859374999,
									26.56860351562497
								],
								[
									-80.110595703125,
									26.13159179687503
								],
								[
									-80.1263671875,
									25.833496093750057
								],
								[
									-80.13627929687499,
									25.84262695312495
								],
								[
									-80.142919921875,
									25.874023437500057
								],
								[
									-80.15893554687497,
									25.878320312499937
								],
								[
									-80.21909179687498,
									25.741748046875102
								],
								[
									-80.30083007812502,
									25.61855468750005
								],
								[
									-80.327734375,
									25.427099609375034
								],
								[
									-80.366943359375,
									25.331249999999955
								],
								[
									-80.48466796874999,
									25.22983398437509
								],
								[
									-80.55761718750003,
									25.232421875000085
								],
								[
									-80.73652343749995,
									25.156347656250034
								],
								[
									-80.86220703125,
									25.17617187500008
								],
								[
									-81.01196289062503,
									25.13325195312504
								],
								[
									-81.11049804687494,
									25.138037109375034
								],
								[
									-81.1673828125,
									25.228515625000085
								],
								[
									-81.15869140625,
									25.268994140625068
								],
								[
									-81.13603515624999,
									25.30966796875009
								],
								[
									-81.09765625,
									25.319140625000074
								],
								[
									-80.96538085937496,
									25.224316406249926
								],
								[
									-80.94042968750003,
									25.264208984375074
								],
								[
									-80.98037109375,
									25.311669921874966
								],
								[
									-81.05683593749993,
									25.33813476562503
								],
								[
									-81.11333007812499,
									25.367236328125102
								],
								[
									-81.2271484375,
									25.58339843750008
								],
								[
									-81.34506835937503,
									25.731835937499937
								],
								[
									-81.36494140625001,
									25.831054687500085
								],
								[
									-81.56826171874994,
									25.891552734375068
								],
								[
									-81.715478515625,
									25.983154296875085
								],
								[
									-81.81147460937493,
									26.146093750000063
								],
								[
									-81.86655273437498,
									26.43500976562501
								],
								[
									-81.93149414062495,
									26.467480468750068
								],
								[
									-81.95893554687495,
									26.48994140625001
								],
								[
									-81.8955078125,
									26.597167968750114
								],
								[
									-81.82866210937496,
									26.687060546875045
								],
								[
									-81.88154296875001,
									26.664697265625108
								],
								[
									-81.92055664062497,
									26.631445312500063
								],
								[
									-81.97016601562493,
									26.552050781250074
								],
								[
									-82.00639648437493,
									26.539843750000074
								],
								[
									-82.03959960937496,
									26.552050781250074
								],
								[
									-82.07788085937503,
									26.704345703125
								],
								[
									-82.06694335937502,
									26.891552734374955
								],
								[
									-82.01328125,
									26.961572265625108
								],
								[
									-82.09570312500003,
									26.963427734375017
								],
								[
									-82.18110351562501,
									26.936767578125114
								],
								[
									-82.16860351562494,
									26.874365234375006
								],
								[
									-82.1806640625,
									26.840087890624943
								],
								[
									-82.24287109374998,
									26.848876953125057
								],
								[
									-82.2900390625,
									26.870800781249983
								],
								[
									-82.35405273437499,
									26.935742187499983
								],
								[
									-82.44135742187501,
									27.059667968750006
								],
								[
									-82.62045898437498,
									27.401074218749926
								],
								[
									-82.65537109375,
									27.449218750000057
								],
								[
									-82.71459960937497,
									27.49960937500012
								],
								[
									-82.68671874999998,
									27.515283203125108
								],
								[
									-82.63583984375,
									27.52456054687505
								],
								[
									-82.52084960937503,
									27.678271484375102
								],
								[
									-82.430517578125,
									27.77114257812508
								],
								[
									-82.40053710937494,
									27.83540039062504
								],
								[
									-82.40576171874994,
									27.86289062499995
								],
								[
									-82.445703125,
									27.902832031250085
								],
								[
									-82.49814453125003,
									27.867919921875
								],
								[
									-82.52060546874998,
									27.877880859374983
								],
								[
									-82.57958984375,
									27.958447265625068
								],
								[
									-82.63593749999995,
									27.981201171875085
								],
								[
									-82.67519531249994,
									27.96376953125008
								],
								[
									-82.63378906249994,
									27.897753906250045
								],
								[
									-82.59658203125002,
									27.873242187499926
								],
								[
									-82.61098632812502,
									27.77724609375008
								],
								[
									-82.62602539062496,
									27.745996093749937
								],
								[
									-82.66088867187497,
									27.718408203125108
								],
								[
									-82.71533203124994,
									27.733105468749983
								],
								[
									-82.74287109374998,
									27.709374999999937
								],
								[
									-82.77529296875,
									27.73437499999997
								],
								[
									-82.80756835937501,
									27.776562499999955
								],
								[
									-82.84350585937494,
									27.845996093750074
								],
								[
									-82.74853515624997,
									28.236816406250114
								],
								[
									-82.66064453125,
									28.485839843749943
								],
								[
									-82.65058593750001,
									28.769921874999994
								],
								[
									-82.64404296875,
									28.812011718750057
								],
								[
									-82.65146484375,
									28.887500000000074
								],
								[
									-82.76933593749993,
									29.051562500000102
								],
								[
									-83.29047851562498,
									29.45190429687503
								],
								[
									-83.69438476562502,
									29.925976562500068
								],
								[
									-84.04423828124996,
									30.10380859374996
								],
								[
									-84.30966796874995,
									30.064746093750102
								],
								[
									-84.355615234375,
									30.029003906250097
								],
								[
									-84.375341796875,
									29.982275390625063
								],
								[
									-84.35869140624999,
									29.929394531249955
								],
								[
									-84.38281250000003,
									29.90737304687508
								],
								[
									-84.45405273437498,
									29.910156249999943
								],
								[
									-84.54999999999998,
									29.897851562500023
								],
								[
									-84.80053710937494,
									29.77304687500009
								],
								[
									-84.88891601562503,
									29.777636718750045
								],
								[
									-84.96918945312493,
									29.74531250000004
								],
								[
									-85.02929687500003,
									29.72109375000008
								],
								[
									-85.18603515624997,
									29.70791015625005
								],
								[
									-85.31894531249995,
									29.680224609375102
								],
								[
									-85.37636718750002,
									29.695214843750023
								],
								[
									-85.41381835937503,
									29.767578124999943
								],
								[
									-85.41381835937503,
									29.842480468749926
								],
								[
									-85.38344726562497,
									29.78505859375005
								],
								[
									-85.33642578124997,
									29.74013671875005
								],
								[
									-85.31489257812493,
									29.758105468750045
								],
								[
									-85.30683593749998,
									29.797851562500085
								],
								[
									-85.35361328125,
									29.87573242187503
								],
								[
									-85.50429687499997,
									29.975781250000097
								],
								[
									-85.67578125,
									30.12192382812509
								],
								[
									-85.62348632812501,
									30.117089843750108
								],
								[
									-85.61025390624997,
									30.148388671874983
								],
								[
									-85.66342773437498,
									30.189453125
								],
								[
									-85.640966796875,
									30.23691406250009
								],
								[
									-85.60351562500003,
									30.286767578124937
								],
								[
									-85.67587890625003,
									30.279296875000114
								],
								[
									-85.74082031250003,
									30.244384765625
								],
								[
									-85.74296875000002,
									30.20126953125009
								],
								[
									-85.75581054687495,
									30.166992187500057
								],
								[
									-85.79077148437497,
									30.17197265625009
								],
								[
									-85.85566406249998,
									30.214404296874932
								],
								[
									-86.17514648437495,
									30.332519531250114
								],
								[
									-86.454443359375,
									30.399121093750097
								],
								[
									-86.24008789062503,
									30.42910156250008
								],
								[
									-86.12382812499999,
									30.405810546875017
								],
								[
									-86.13769531249997,
									30.441552734374937
								],
								[
									-86.16567382812497,
									30.464257812500023
								],
								[
									-86.25737304687502,
									30.493017578125034
								],
								[
									-86.374169921875,
									30.482080078124937
								],
								[
									-86.44794921874993,
									30.49560546875003
								],
								[
									-86.52338867187493,
									30.46708984374999
								],
								[
									-86.60605468749998,
									30.424707031249966
								],
								[
									-86.67963867187498,
									30.40288085937496
								],
								[
									-86.96762695312503,
									30.37236328124996
								],
								[
									-87.201171875,
									30.339257812499966
								],
								[
									-87.163720703125,
									30.374218749999983
								],
								[
									-87.12377929687494,
									30.39667968750004
								],
								[
									-86.98579101562498,
									30.430859374999983
								],
								[
									-86.96513671874996,
									30.501904296875068
								],
								[
									-86.99755859375,
									30.57031249999997
								],
								[
									-87.03388671874993,
									30.553906250000097
								],
								[
									-87.07202148437497,
									30.50043945312504
								],
								[
									-87.118798828125,
									30.53896484375008
								],
								[
									-87.17060546874998,
									30.53876953125004
								],
								[
									-87.18466796875,
									30.45371093750012
								],
								[
									-87.25107421875003,
									30.39667968750004
								],
								[
									-87.28105468750002,
									30.339257812499966
								],
								[
									-87.47578124999998,
									30.294287109375034
								],
								[
									-87.500732421875,
									30.309277343750068
								],
								[
									-87.44374999999994,
									30.363818359375102
								],
								[
									-87.44829101562499,
									30.394140625000063
								],
								[
									-87.51328124999998,
									30.368115234374983
								],
								[
									-87.62226562499998,
									30.264746093749977
								],
								[
									-88.00595703125,
									30.230908203124926
								],
								[
									-87.985009765625,
									30.25439453125
								],
								[
									-87.90400390625001,
									30.259082031250074
								],
								[
									-87.79028320312503,
									30.291796875000074
								],
								[
									-87.81328124999999,
									30.346874999999926
								],
								[
									-87.85712890624995,
									30.407421875000097
								],
								[
									-87.89760742187494,
									30.41416015624995
								],
								[
									-87.92431640624997,
									30.449658203125068
								],
								[
									-87.92299804687497,
									30.561523437500057
								],
								[
									-87.948876953125,
									30.626904296874955
								],
								[
									-88.01132812500003,
									30.694189453124977
								],
								[
									-88.03242187499995,
									30.681250000000006
								],
								[
									-88.078369140625,
									30.566210937499932
								],
								[
									-88.11655273437498,
									30.415332031250017
								],
								[
									-88.13544921874998,
									30.366601562500023
								],
								[
									-88.24921874999998,
									30.36318359375005
								],
								[
									-88.34990234374999,
									30.373486328124926
								],
								[
									-88.69208984374998,
									30.355371093749966
								],
								[
									-88.819921875,
									30.406494140625085
								],
								[
									-88.87294921874997,
									30.416308593750045
								],
								[
									-88.90522460937495,
									30.415136718749977
								],
								[
									-89.054052734375,
									30.36826171875012
								],
								[
									-89.2236328125,
									30.33237304687509
								],
								[
									-89.26357421874997,
									30.34365234375008
								],
								[
									-89.32055664062503,
									30.345312500000063
								],
								[
									-89.44350585937502,
									30.223144531249943
								],
								[
									-89.58847656249998,
									30.165966796874926
								],
								[
									-89.954248046875,
									30.268750000000097
								],
								[
									-90.04521484374996,
									30.351416015625063
								],
								[
									-90.12597656249997,
									30.36909179687501
								],
								[
									-90.22529296874995,
									30.37929687500005
								],
								[
									-90.33198242187493,
									30.277587890625114
								],
								[
									-90.41303710937501,
									30.14033203125004
								],
								[
									-90.28496093749996,
									30.06508789062508
								],
								[
									-90.17534179687499,
									30.029101562499932
								],
								[
									-89.99418945312496,
									30.059277343749955
								],
								[
									-89.89404296874997,
									30.125878906250023
								],
								[
									-89.812255859375,
									30.123681640625023
								],
								[
									-89.77314453124995,
									30.137207031250114
								],
								[
									-89.73745117187497,
									30.17197265625009
								],
								[
									-89.66752929687502,
									30.14453125
								],
								[
									-89.66503906249994,
									30.11704101562509
								],
								[
									-89.71469726562503,
									30.078320312499926
								],
								[
									-89.77724609375,
									30.045703125000017
								],
								[
									-89.815185546875,
									30.007275390624926
								],
								[
									-89.74379882812502,
									29.92983398437505
								],
								[
									-89.631689453125,
									29.903808593750085
								],
								[
									-89.58950195312502,
									29.915039062500057
								],
								[
									-89.56337890625002,
									30.002099609374937
								],
								[
									-89.49443359375002,
									30.05815429687499
								],
								[
									-89.400732421875,
									30.046044921875108
								],
								[
									-89.41406249999997,
									30.01088867187505
								],
								[
									-89.40092773437496,
									29.977685546874937
								],
								[
									-89.35786132812498,
									29.92099609375012
								],
								[
									-89.36279296875003,
									29.839794921875097
								],
								[
									-89.35444335937501,
									29.820214843750108
								],
								[
									-89.45541992187498,
									29.784375000000068
								],
								[
									-89.53066406250002,
									29.772216796875
								],
								[
									-89.59086914062493,
									29.72529296875004
								],
								[
									-89.559326171875,
									29.69804687499999
								],
								[
									-89.62065429687496,
									29.674121093750102
								],
								[
									-89.66210937499997,
									29.68369140625009
								],
								[
									-89.68295898437495,
									29.674853515625074
								],
								[
									-89.689208984375,
									29.64604492187496
								],
								[
									-89.72089843749995,
									29.619287109375023
								],
								[
									-89.6748046875,
									29.538671875000034
								],
								[
									-89.580322265625,
									29.48603515625004
								],
								[
									-89.51367187500003,
									29.420068359374937
								],
								[
									-89.24570312499998,
									29.333203125000097
								],
								[
									-89.18076171874998,
									29.33569335937497
								],
								[
									-89.116845703125,
									29.248242187499926
								],
								[
									-89.06533203125,
									29.218164062500108
								],
								[
									-89.01572265625,
									29.202880859375085
								],
								[
									-89.02138671875,
									29.142724609375108
								],
								[
									-89.10952148437502,
									29.098681640625102
								],
								[
									-89.13334960937499,
									29.046142578125057
								],
								[
									-89.15551757812497,
									29.016601562500085
								],
								[
									-89.19526367187498,
									29.05400390624996
								],
								[
									-89.23608398437497,
									29.081103515625074
								],
								[
									-89.33056640625003,
									28.99868164062505
								],
								[
									-89.37612304687497,
									28.981347656249994
								],
								[
									-89.353515625,
									29.07021484375008
								],
								[
									-89.38920898437499,
									29.105029296875045
								],
								[
									-89.44316406249996,
									29.194140625000102
								],
								[
									-89.52177734374999,
									29.249267578125057
								],
								[
									-89.5771484375,
									29.26752929687504
								],
								[
									-89.62026367187497,
									29.302392578124937
								],
								[
									-89.67246093749995,
									29.316503906249977
								],
								[
									-89.71699218749995,
									29.31289062500005
								],
								[
									-89.79238281249997,
									29.333203125000097
								],
								[
									-89.79736328125,
									29.380615234375057
								],
								[
									-89.81826171875,
									29.41611328125012
								],
								[
									-89.87724609375002,
									29.45800781250003
								],
								[
									-90.15908203124997,
									29.53715820312499
								],
								[
									-90.16079101562497,
									29.50439453124997
								],
								[
									-90.141259765625,
									29.479736328125114
								],
								[
									-90.10078124999998,
									29.463330078124955
								],
								[
									-90.05234374999998,
									29.43139648437503
								],
								[
									-90.05278320312499,
									29.336816406249937
								],
								[
									-90.07373046875,
									29.29677734375005
								],
								[
									-90.08271484374995,
									29.23974609374997
								],
								[
									-90.10136718749993,
									29.18178710937505
								],
								[
									-90.13583984375003,
									29.13608398437509
								],
								[
									-90.21279296875,
									29.10493164062504
								],
								[
									-90.24672851562497,
									29.131005859375023
								],
								[
									-90.30161132812498,
									29.255810546874955
								],
								[
									-90.37919921874996,
									29.295117187500068
								],
								[
									-90.50249023437493,
									29.29975585937504
								],
								[
									-90.58623046874996,
									29.27153320312496
								],
								[
									-90.67749023437497,
									29.15063476562503
								],
								[
									-90.75102539062496,
									29.130859375000085
								],
								[
									-91.00273437499999,
									29.193505859374966
								],
								[
									-91.29013671875,
									29.28896484375005
								],
								[
									-91.28271484375,
									29.320751953124955
								],
								[
									-91.23749999999993,
									29.33095703125008
								],
								[
									-91.15078124999994,
									29.317919921875074
								],
								[
									-91.15537109375,
									29.350683593750006
								],
								[
									-91.243994140625,
									29.457324218750074
								],
								[
									-91.26025390624994,
									29.50546875000009
								],
								[
									-91.24882812499993,
									29.564208984375085
								],
								[
									-91.27773437499997,
									29.56289062500008
								],
								[
									-91.33095703124997,
									29.51357421875008
								],
								[
									-91.51420898437499,
									29.555371093750068
								],
								[
									-91.564794921875,
									29.60532226562512
								],
								[
									-91.6724609375,
									29.746093750000085
								],
								[
									-91.82441406249995,
									29.750683593750068
								],
								[
									-91.89316406250003,
									29.83603515624995
								],
								[
									-92.017333984375,
									29.800292968749943
								],
								[
									-92.08022460937502,
									29.76074218749997
								],
								[
									-92.135498046875,
									29.699462890625114
								],
								[
									-92.11396484374998,
									29.667675781249926
								],
								[
									-92.05888671874993,
									29.617187499999943
								],
								[
									-92.08403320312502,
									29.59282226562496
								],
								[
									-92.26083984374998,
									29.556835937500097
								],
								[
									-92.6712890625,
									29.597070312499937
								],
								[
									-92.79130859374993,
									29.63466796875005
								],
								[
									-92.952392578125,
									29.71416015624999
								],
								[
									-93.17568359375,
									29.77895507812505
								],
								[
									-93.28320312499997,
									29.78940429687495
								],
								[
									-93.38847656250002,
									29.776562500000097
								],
								[
									-93.69482421874997,
									29.76992187500008
								],
								[
									-93.76591796874999,
									29.752685546875114
								],
								[
									-93.82646484374999,
									29.725146484375102
								],
								[
									-93.86572265624997,
									29.755615234375085
								],
								[
									-93.88388671874995,
									29.810009765625068
								],
								[
									-93.84833984374998,
									29.81884765625
								],
								[
									-93.80878906249993,
									29.850830078124943
								],
								[
									-93.77309570312494,
									29.914062499999943
								],
								[
									-93.76904296875,
									29.952294921875108
								],
								[
									-93.79399414062493,
									29.97724609375004
								],
								[
									-93.84145507812502,
									29.979736328125
								],
								[
									-93.94628906249997,
									29.814990234375017
								],
								[
									-93.88637695312502,
									29.722656249999943
								],
								[
									-93.89047851562498,
									29.689355468749994
								],
								[
									-94.09965820312496,
									29.670410156250057
								],
								[
									-94.57446289062494,
									29.484521484375108
								],
								[
									-94.759619140625,
									29.384277343750114
								],
								[
									-94.75014648437497,
									29.41801757812496
								],
								[
									-94.52626953125,
									29.547949218750063
								],
								[
									-94.60532226562503,
									29.567822265624926
								],
								[
									-94.73261718749993,
									29.535351562500068
								],
								[
									-94.77827148437501,
									29.547851562499943
								],
								[
									-94.72436523437503,
									29.655273437500057
								],
								[
									-94.74194335937497,
									29.75
								],
								[
									-94.83232421874999,
									29.752587890624994
								],
								[
									-94.889892578125,
									29.676953124999955
								],
								[
									-94.92988281249998,
									29.680175781250085
								],
								[
									-94.982275390625,
									29.71259765625001
								],
								[
									-95.0228515625,
									29.702343750000068
								],
								[
									-94.99282226562502,
									29.530957031250068
								],
								[
									-94.93588867187495,
									29.460449218750085
								],
								[
									-94.88828125000003,
									29.370556640625068
								],
								[
									-95.01831054687497,
									29.259472656250068
								],
								[
									-95.13906249999997,
									29.167822265625063
								],
								[
									-95.15214843749996,
									29.07924804687505
								],
								[
									-95.27348632812499,
									28.963867187500085
								],
								[
									-95.38764648437498,
									28.898437500000057
								],
								[
									-95.655859375,
									28.74462890625
								],
								[
									-95.73237304687495,
									28.711718750000045
								],
								[
									-95.85341796875002,
									28.640332031250068
								],
								[
									-96.02041015625002,
									28.586816406249994
								],
								[
									-96.18051757812503,
									28.501855468750108
								],
								[
									-96.23452148437502,
									28.488964843749955
								],
								[
									-96.13227539062498,
									28.560888671875034
								],
								[
									-96.01103515624996,
									28.63193359374995
								],
								[
									-96.11503906250002,
									28.622216796875023
								],
								[
									-96.27534179687498,
									28.655126953125063
								],
								[
									-96.3734375,
									28.657031250000102
								],
								[
									-96.37412109374995,
									28.631103515625057
								],
								[
									-96.44873046874997,
									28.594482421875057
								],
								[
									-96.526025390625,
									28.64829101562509
								],
								[
									-96.55971679687502,
									28.684472656249994
								],
								[
									-96.57568359374997,
									28.715722656249966
								],
								[
									-96.60849609375,
									28.72329101562508
								],
								[
									-96.64003906249994,
									28.708789062500074
								],
								[
									-96.52465820312497,
									28.488720703125097
								],
								[
									-96.47548828125,
									28.479199218749926
								],
								[
									-96.42109374999993,
									28.457324218750074
								],
								[
									-96.48881835937496,
									28.406054687500045
								],
								[
									-96.56171874999998,
									28.36713867187501
								],
								[
									-96.67636718749998,
									28.341308593750085
								],
								[
									-96.77353515624998,
									28.421630859375085
								],
								[
									-96.794580078125,
									28.32084960937499
								],
								[
									-96.806884765625,
									28.220214843750085
								],
								[
									-96.839501953125,
									28.19438476562499
								],
								[
									-96.89160156249994,
									28.15756835937495
								],
								[
									-96.91987304687493,
									28.185351562500017
								],
								[
									-96.93330078125001,
									28.224267578125023
								],
								[
									-96.96665039062498,
									28.189550781249977
								],
								[
									-97.01547851562498,
									28.163476562499994
								],
								[
									-97.09604492187503,
									28.158251953125074
								],
								[
									-97.156494140625,
									28.144335937500102
								],
								[
									-97.15507812499999,
									28.10263671874995
								],
								[
									-97.14125976562502,
									28.06074218750004
								],
								[
									-97.034326171875,
									28.09384765625012
								],
								[
									-97.07309570312498,
									27.986083984375
								],
								[
									-97.17143554687493,
									27.879589843749983
								],
								[
									-97.2515625,
									27.85444335937501
								],
								[
									-97.37412109375003,
									27.87001953125008
								],
								[
									-97.40439453124998,
									27.85932617187504
								],
								[
									-97.43149414062498,
									27.83720703124996
								],
								[
									-97.28872070312494,
									27.67060546875004
								],
								[
									-97.38046874999998,
									27.419335937500108
								],
								[
									-97.43911132812502,
									27.328271484375023
								],
								[
									-97.47978515624996,
									27.31660156250004
								],
								[
									-97.52387695312498,
									27.313964843749943
								],
								[
									-97.68212890624997,
									27.394921875000108
								],
								[
									-97.76845703124997,
									27.45751953124997
								],
								[
									-97.69238281250003,
									27.28715820312499
								],
								[
									-97.48510742187497,
									27.237402343749977
								],
								[
									-97.47451171874997,
									27.17294921875009
								],
								[
									-97.47568359375,
									27.11787109375004
								],
								[
									-97.51650390625,
									27.05322265625003
								],
								[
									-97.55468749999994,
									26.967333984374932
								],
								[
									-97.526513671875,
									26.907519531250102
								],
								[
									-97.49379882812497,
									26.759619140625063
								],
								[
									-97.46582031249997,
									26.69174804687509
								],
								[
									-97.43505859375,
									26.485839843750085
								],
								[
									-97.40234375,
									26.396533203125102
								],
								[
									-97.21391601562499,
									26.067871093750114
								],
								[
									-97.150390625,
									26.065332031249937
								],
								[
									-97.14018554687496,
									26.029736328125068
								],
								[
									-97.14624023437497,
									25.961474609375102
								],
								[
									-97.28178710937496,
									25.941601562499955
								],
								[
									-97.33867187499999,
									25.911181640625074
								],
								[
									-97.34975585937494,
									25.884765625000114
								],
								[
									-97.35815429687497,
									25.87050781250005
								],
								[
									-97.37563476562497,
									25.87182617187503
								],
								[
									-97.440283203125,
									25.890820312500097
								],
								[
									-97.587255859375,
									25.984179687500017
								],
								[
									-97.80141601562494,
									26.04204101562499
								],
								[
									-98.08281249999999,
									26.06445312500003
								],
								[
									-98.27504882812497,
									26.11118164062495
								],
								[
									-98.37812500000001,
									26.182373046875057
								],
								[
									-98.48588867187493,
									26.224560546874955
								],
								[
									-98.59829101562502,
									26.237841796875102
								],
								[
									-98.69140624999997,
									26.276464843750063
								],
								[
									-98.765234375,
									26.340429687500034
								],
								[
									-98.87319335937498,
									26.381249999999994
								],
								[
									-99.01528320312497,
									26.39897460937496
								],
								[
									-99.10776367187498,
									26.446923828124966
								],
								[
									-99.17207031250003,
									26.564160156249955
								],
								[
									-99.17236328125,
									26.565917968750057
								],
								[
									-99.229931640625,
									26.76191406250001
								],
								[
									-99.30244140625003,
									26.884716796874983
								],
								[
									-99.4435546875,
									27.036669921875017
								],
								[
									-99.45649414062497,
									27.056640625000114
								],
								[
									-99.45654296874999,
									27.056689453124932
								],
								[
									-99.45771484374995,
									27.081689453124966
								],
								[
									-99.44023437499995,
									27.17011718750004
								],
								[
									-99.45512695312496,
									27.233691406249932
								],
								[
									-99.4998046875,
									27.285498046875006
								],
								[
									-99.51005859374996,
									27.340332031250085
								],
								[
									-99.48583984375,
									27.39804687500012
								],
								[
									-99.48427734374995,
									27.46738281250012
								],
								[
									-99.50532226562497,
									27.54833984375
								],
								[
									-99.5953125,
									27.63588867187508
								],
								[
									-99.75424804687498,
									27.729931640624955
								],
								[
									-99.88964843750003,
									27.867285156250063
								],
								[
									-100.00141601562497,
									28.04785156249997
								],
								[
									-100.11196289062502,
									28.172949218750063
								],
								[
									-100.22128906249999,
									28.242626953124955
								],
								[
									-100.29604492187495,
									28.32768554687496
								],
								[
									-100.33627929687498,
									28.428124999999994
								],
								[
									-100.34814453125,
									28.486425781249977
								],
								[
									-100.33173828125003,
									28.502539062500063
								],
								[
									-100.39892578124994,
									28.614208984374983
								],
								[
									-100.54970703125002,
									28.82133789062499
								],
								[
									-100.63632812499999,
									28.972802734374937
								],
								[
									-100.65864257812501,
									29.068554687500097
								],
								[
									-100.75458984375003,
									29.182519531250023
								],
								[
									-100.92412109375,
									29.314697265625057
								],
								[
									-101.01630859374995,
									29.400683593750074
								],
								[
									-101.03862304687497,
									29.460302734375063
								],
								[
									-101.03896484374995,
									29.460400390624983
								],
								[
									-101.30351562499995,
									29.634082031250017
								],
								[
									-101.38037109374997,
									29.74257812500008
								],
								[
									-101.44038085937503,
									29.77685546874997
								],
								[
									-101.50927734375003,
									29.773144531249926
								],
								[
									-101.54462890624994,
									29.78354492187509
								],
								[
									-101.54638671874994,
									29.808056640624926
								],
								[
									-101.56870117187496,
									29.809228515624994
								],
								[
									-101.61162109375,
									29.786962890625063
								],
								[
									-101.75234374999998,
									29.782470703125057
								],
								[
									-101.99091796875001,
									29.79570312499999
								],
								[
									-102.1630859375,
									29.825244140625045
								],
								[
									-102.26894531249998,
									29.871191406250006
								],
								[
									-102.34306640624999,
									29.864990234375085
								],
								[
									-102.38564453124995,
									29.806640625
								],
								[
									-102.47626953125003,
									29.76909179687499
								],
								[
									-102.61494140624995,
									29.75234375000005
								],
								[
									-102.73417968749999,
									29.64394531250008
								],
								[
									-102.83398437499999,
									29.443945312500006
								],
								[
									-102.87783203124995,
									29.31533203125008
								],
								[
									-102.86567382812495,
									29.258007812499955
								],
								[
									-102.8919921875,
									29.216406250000006
								],
								[
									-102.95683593749997,
									29.19038085937504
								],
								[
									-103.02285156250001,
									29.13222656250008
								],
								[
									-103.08999023437501,
									29.04189453125008
								],
								[
									-103.16831054687498,
									28.998193359374966
								],
								[
									-103.25771484374998,
									29.001123046874937
								],
								[
									-103.42294921874998,
									29.070703124999994
								],
								[
									-103.66396484374997,
									29.20688476562512
								],
								[
									-103.85292968750001,
									29.291064453125045
								],
								[
									-103.98974609374999,
									29.323144531249994
								],
								[
									-104.11059570312501,
									29.38613281250005
								],
								[
									-104.21552734374998,
									29.47988281250005
								],
								[
									-104.31220703124995,
									29.542431640625097
								],
								[
									-104.40063476562503,
									29.57373046874997
								],
								[
									-104.50400390624995,
									29.677685546874926
								],
								[
									-104.62221679687497,
									29.854296874999932
								],
								[
									-104.68134765625003,
									29.990527343750074
								],
								[
									-104.68134765625003,
									30.134374999999977
								],
								[
									-104.83588867187498,
									30.447656249999937
								],
								[
									-104.91787109374998,
									30.583349609375063
								],
								[
									-104.97880859374996,
									30.645947265624926
								],
								[
									-105.09814453125003,
									30.72055664062512
								],
								[
									-105.27583007812498,
									30.807275390625023
								],
								[
									-105.51401367187502,
									30.980761718750017
								],
								[
									-105.81269531250003,
									31.241015625000102
								],
								[
									-106.02407226562501,
									31.39775390624996
								],
								[
									-106.14804687499996,
									31.450927734375057
								],
								[
									-106.25571289062495,
									31.544677734375057
								],
								[
									-106.34697265624999,
									31.679003906250074
								],
								[
									-106.43603515625001,
									31.764453125000074
								],
								[
									-106.44541015624996,
									31.768408203124977
								],
								[
									-106.45322265624996,
									31.77016601562508
								],
								[
									-106.67304687499998,
									31.771337890625034
								],
								[
									-106.89287109375,
									31.772460937500085
								],
								[
									-107.11269531250002,
									31.773632812499983
								],
								[
									-107.33251953124994,
									31.774755859375034
								],
								[
									-107.55234374999996,
									31.775878906250085
								],
								[
									-107.772216796875,
									31.777050781250068
								],
								[
									-107.99204101562502,
									31.77817382812512
								],
								[
									-108.21181640625002,
									31.77934570312499
								],
								[
									-108.21249999999999,
									31.666845703125063
								],
								[
									-108.21318359374995,
									31.554394531250068
								],
								[
									-108.213818359375,
									31.441894531250085
								],
								[
									-108.21445312499995,
									31.32944335937509
								],
								[
									-108.56787109375,
									31.328808593749955
								],
								[
									-108.92133789062498,
									31.328125000000085
								],
								[
									-109.27475585937495,
									31.327441406250017
								],
								[
									-109.62822265625002,
									31.32680664062508
								],
								[
									-109.98164062499998,
									31.326171874999943
								],
								[
									-110.33510742187497,
									31.32553710937509
								],
								[
									-110.68852539062503,
									31.324853515625023
								],
								[
									-111.0419921875,
									31.324218750000085
								],
								[
									-111.51621093749998,
									31.472265625000034
								],
								[
									-111.99047851562497,
									31.62021484375009
								],
								[
									-112.46474609374995,
									31.768261718749955
								],
								[
									-112.93896484375003,
									31.916259765625085
								],
								[
									-113.41318359375,
									32.064306640625034
								],
								[
									-113.88745117187499,
									32.212304687499994
								],
								[
									-114.36171874999998,
									32.360302734374955
								],
								[
									-114.83593749999996,
									32.508300781250085
								],
								[
									-114.78798828124995,
									32.564794921875034
								],
								[
									-114.72475585937495,
									32.715332031250085
								],
								[
									-114.83906249999997,
									32.70473632812505
								],
								[
									-115.1251953125,
									32.68330078125004
								],
								[
									-115.41137695312503,
									32.661865234375114
								],
								[
									-115.69750976562497,
									32.640478515625006
								],
								[
									-115.98369140625002,
									32.619042968749994
								],
								[
									-116.26982421874995,
									32.59760742187498
								],
								[
									-116.55595703124997,
									32.576220703125074
								],
								[
									-116.84208984375,
									32.55478515625006
								],
								[
									-117.12827148437496,
									32.53334960937502
								],
								[
									-117.13046874999996,
									32.53974609375001
								],
								[
									-117.13740234374995,
									32.649169921875
								],
								[
									-117.18374023437498,
									32.68789062500008
								],
								[
									-117.24345703124997,
									32.66401367187501
								],
								[
									-117.27070312500003,
									32.806250000000034
								],
								[
									-117.25576171875,
									32.873388671875034
								],
								[
									-117.26298828124996,
									32.93886718750005
								],
								[
									-117.31884765624997,
									33.10004882812501
								],
								[
									-117.46743164062495,
									33.29550781250006
								],
								[
									-117.788525390625,
									33.538476562499994
								],
								[
									-117.95209960937501,
									33.61962890625
								],
								[
									-118.08051757812498,
									33.72216796875003
								],
								[
									-118.16191406249995,
									33.75068359375007
								],
								[
									-118.26440429687496,
									33.758593750000074
								],
								[
									-118.29418945312499,
									33.712304687499966
								],
								[
									-118.41044921874996,
									33.74394531249993
								],
								[
									-118.39296874999995,
									33.85830078125005
								],
								[
									-118.50620117187502,
									34.017382812500045
								],
								[
									-118.59882812499997,
									34.03500976562506
								],
								[
									-118.83203124999996,
									34.024462890625045
								],
								[
									-119.14374999999995,
									34.112011718749955
								],
								[
									-119.23583984374999,
									34.164111328125074
								],
								[
									-119.26767578124998,
									34.25742187500009
								],
								[
									-119.41367187499998,
									34.338574218749926
								],
								[
									-119.60605468749999,
									34.418017578125045
								],
								[
									-119.71318359374997,
									34.39965820312503
								],
								[
									-119.85332031250002,
									34.41196289062495
								],
								[
									-120.05297851562501,
									34.469287109375074
								],
								[
									-120.16953125000003,
									34.47646484375005
								],
								[
									-120.396484375,
									34.45957031250006
								],
								[
									-120.48120117187503,
									34.47163085937504
								],
								[
									-120.55981445312497,
									34.54389648437501
								],
								[
									-120.64467773437502,
									34.57998046875008
								],
								[
									-120.62670898437501,
									34.668945312500085
								],
								[
									-120.63759765625001,
									34.74936523437495
								],
								[
									-120.62490234375,
									34.8119628906251
								],
								[
									-120.66303710937495,
									34.94926757812499
								],
								[
									-120.63359374999999,
									35.076464843750074
								],
								[
									-120.65908203124994,
									35.122412109375006
								],
								[
									-120.70703125000003,
									35.1576660156251
								],
								[
									-120.85737304687501,
									35.209667968749926
								],
								[
									-120.88486328125002,
									35.274951171875074
								],
								[
									-120.860302734375,
									35.365429687499955
								],
								[
									-120.89960937500001,
									35.425097656250045
								],
								[
									-121.02285156249998,
									35.4807617187501
								],
								[
									-121.13793945312497,
									35.60712890625007
								],
								[
									-121.28383789062495,
									35.67631835937496
								],
								[
									-121.34384765625,
									35.79223632812506
								],
								[
									-121.43374023437502,
									35.86386718749998
								],
								[
									-121.464990234375,
									35.92739257812505
								],
								[
									-121.66435546875002,
									36.15405273437494
								],
								[
									-121.87739257812498,
									36.33105468749994
								],
								[
									-121.91015625,
									36.4329101562501
								],
								[
									-121.91865234374995,
									36.57236328125009
								],
								[
									-121.83515625,
									36.657470703125114
								],
								[
									-121.78999023437494,
									36.73227539062498
								],
								[
									-121.79453124999998,
									36.80097656250004
								],
								[
									-121.80742187499995,
									36.85122070312505
								],
								[
									-121.88066406249995,
									36.93891601562507
								],
								[
									-122.16420898437498,
									36.990966796875085
								],
								[
									-122.394921875,
									37.207519531250085
								],
								[
									-122.408447265625,
									37.37314453124998
								],
								[
									-122.49921875000001,
									37.54262695312505
								],
								[
									-122.500439453125,
									37.652783203124926
								],
								[
									-122.51420898437496,
									37.77197265625006
								],
								[
									-122.44560546875002,
									37.79799804687502
								],
								[
									-122.38408203125,
									37.788525390624955
								],
								[
									-122.39028320312502,
									37.74106445312506
								],
								[
									-122.36972656250002,
									37.65585937500012
								],
								[
									-122.29760742187497,
									37.591845703125045
								],
								[
									-122.22866210937497,
									37.56391601562504
								],
								[
									-122.16601562499999,
									37.501660156249955
								],
								[
									-122.11904296875001,
									37.48281249999994
								],
								[
									-122.07050781249998,
									37.478271484375085
								],
								[
									-122.09653320312496,
									37.51821289062505
								],
								[
									-122.12412109374998,
									37.54379882812509
								],
								[
									-122.15805664062496,
									37.62646484375006
								],
								[
									-122.22221679687499,
									37.73203125000009
								],
								[
									-122.29599609375,
									37.790332031250045
								],
								[
									-122.333447265625,
									37.896582031250034
								],
								[
									-122.36547851562494,
									37.921191406250074
								],
								[
									-122.38544921875003,
									37.96059570312502
								],
								[
									-122.31425781249999,
									38.00732421874994
								],
								[
									-122.217041015625,
									38.04062499999998
								],
								[
									-122.08671875,
									38.049609375000045
								],
								[
									-121.71684570312496,
									38.03408203125008
								],
								[
									-121.6380859375,
									38.061279296875114
								],
								[
									-121.57299804687497,
									38.05239257812508
								],
								[
									-121.52534179687503,
									38.055908203125085
								],
								[
									-121.62573242187497,
									38.08393554687501
								],
								[
									-121.68222656250002,
									38.07480468750009
								],
								[
									-121.74863281249996,
									38.08046875000011
								],
								[
									-121.88076171874997,
									38.07499999999996
								],
								[
									-121.9341796875,
									38.08681640625005
								],
								[
									-121.99311523437503,
									38.120117187500085
								],
								[
									-122.03149414062503,
									38.123535156250085
								],
								[
									-122.15375976562498,
									38.06552734375009
								],
								[
									-122.20830078124999,
									38.0725585937501
								],
								[
									-122.33710937500003,
									38.13588867187494
								],
								[
									-122.39335937499995,
									38.144824218750074
								],
								[
									-122.48388671875,
									38.108837890624926
								],
								[
									-122.49492187499995,
									37.95356445312501
								],
								[
									-122.46689453125,
									37.838183593750045
								],
								[
									-122.52133789062499,
									37.82641601562494
								],
								[
									-122.58417968750001,
									37.874072265625074
								],
								[
									-122.68071289062496,
									37.90234375000006
								],
								[
									-122.76040039062502,
									37.94565429687509
								],
								[
									-122.87294921874995,
									38.02607421875004
								],
								[
									-122.93198242187499,
									38.055468750000074
								],
								[
									-122.998779296875,
									37.98862304687495
								],
								[
									-123.00146484375001,
									38.019287109375085
								],
								[
									-122.96816406249998,
									38.097021484375006
								],
								[
									-122.97758789062495,
									38.2273437500001
								],
								[
									-122.87680664062502,
									38.123339843750045
								],
								[
									-122.90815429687501,
									38.196582031250045
								],
								[
									-122.9865234375,
									38.277099609375114
								],
								[
									-123.04619140624999,
									38.30507812499994
								],
								[
									-123.12114257812497,
									38.4492675781251
								],
								[
									-123.28974609374995,
									38.53583984375007
								],
								[
									-123.42480468750003,
									38.675634765625034
								],
								[
									-123.70112304687501,
									38.907275390625045
								],
								[
									-123.71953124999993,
									39.110986328124994
								],
								[
									-123.82031249999996,
									39.36840820312494
								],
								[
									-123.777783203125,
									39.514941406250045
								],
								[
									-123.78349609375,
									39.618701171875045
								],
								[
									-123.83291015624994,
									39.775488281250006
								],
								[
									-123.88447265624997,
									39.86079101562498
								],
								[
									-124.10849609374995,
									40.09453124999999
								],
								[
									-124.32402343749999,
									40.251953125
								],
								[
									-124.35654296875003,
									40.37109375000003
								],
								[
									-124.37167968750002,
									40.491210937500085
								],
								[
									-124.32451171875,
									40.5980957031251
								],
								[
									-124.28369140625003,
									40.71054687500009
								],
								[
									-124.25390625,
									40.74028320312502
								],
								[
									-124.24233398437495,
									40.72788085937506
								],
								[
									-124.25058593750003,
									40.703906250000074
								],
								[
									-124.22001953124993,
									40.69648437500007
								],
								[
									-124.20844726562498,
									40.74609375000003
								],
								[
									-124.190234375,
									40.77172851562503
								],
								[
									-124.222509765625,
									40.77504882812508
								],
								[
									-124.21918945312494,
									40.79072265624998
								],
								[
									-124.19990234375001,
									40.822070312500074
								],
								[
									-124.13310546874999,
									40.96977539062496
								],
								[
									-124.14003906249998,
									41.15590820312505
								],
								[
									-124.06850585937498,
									41.38417968750011
								],
								[
									-124.07192382812497,
									41.45952148437499
								],
								[
									-124.11767578124996,
									41.621728515624994
								],
								[
									-124.16323242187501,
									41.718994140625
								],
								[
									-124.24462890624997,
									41.78793945312512
								],
								[
									-124.20874023437494,
									41.88857421875008
								],
								[
									-124.21166992187501,
									41.98461914062494
								],
								[
									-124.35527343749996,
									42.122900390625034
								],
								[
									-124.410009765625,
									42.30434570312505
								],
								[
									-124.42050781250002,
									42.38100585937505
								],
								[
									-124.40615234375002,
									42.583691406249955
								],
								[
									-124.44379882812497,
									42.67021484374999
								],
								[
									-124.53964843750003,
									42.81289062500002
								],
								[
									-124.49858398437502,
									42.93686523437506
								],
								[
									-124.454443359375,
									43.01235351562505
								],
								[
									-124.34658203124997,
									43.341650390625006
								],
								[
									-124.32060546875,
									43.368212890625074
								],
								[
									-124.27548828124996,
									43.36738281250001
								],
								[
									-124.19692382812502,
									43.42333984374994
								],
								[
									-124.23315429687494,
									43.436376953125034
								],
								[
									-124.28798828125002,
									43.40971679687502
								],
								[
									-124.23920898437503,
									43.540039062500085
								],
								[
									-124.18437499999996,
									43.65156250000007
								],
								[
									-124.14873046874997,
									43.691748046875006
								],
								[
									-124.13066406249995,
									44.055664062500085
								],
								[
									-124.099169921875,
									44.333789062500074
								],
								[
									-124.04746093749995,
									44.42548828125001
								],
								[
									-124.06542968749997,
									44.5200683593751
								],
								[
									-124.04453124999998,
									44.6482421875001
								],
								[
									-124.05917968750003,
									44.77773437500011
								],
								[
									-123.94858398437498,
									45.40083007812504
								],
								[
									-123.9630859375,
									45.476074218750085
								],
								[
									-123.92934570312497,
									45.57695312499993
								],
								[
									-123.96123046874997,
									45.842968749999955
								],
								[
									-123.94711914062503,
									46.14057617187501
								],
								[
									-123.97524414062498,
									46.17832031250006
								],
								[
									-123.989306640625,
									46.21938476562508
								],
								[
									-123.96293945312496,
									46.22543945312498
								],
								[
									-123.911669921875,
									46.18217773437496
								],
								[
									-123.6736328125,
									46.18261718750006
								],
								[
									-123.52163085937494,
									46.22265624999994
								],
								[
									-123.46635742187496,
									46.2094238281251
								],
								[
									-123.40229492187497,
									46.154980468749926
								],
								[
									-123.32158203124996,
									46.1439941406251
								],
								[
									-123.22060546875,
									46.1536132812501
								],
								[
									-123.25131835937503,
									46.167285156250045
								],
								[
									-123.29868164062499,
									46.170849609374955
								],
								[
									-123.40473632812503,
									46.22099609374996
								],
								[
									-123.46484375000001,
									46.27109374999995
								],
								[
									-123.65034179687497,
									46.26772460937508
								],
								[
									-123.68837890624998,
									46.299853515625045
								],
								[
									-123.89570312499994,
									46.26777343749998
								],
								[
									-123.95976562499995,
									46.300732421874955
								],
								[
									-124.07275390624996,
									46.279443359374966
								],
								[
									-124.04511718750001,
									46.37290039062509
								],
								[
									-124.05019531249998,
									46.490527343750074
								],
								[
									-124.04433593750002,
									46.60507812500006
								],
								[
									-124.01640625000002,
									46.521386718749966
								],
								[
									-123.946142578125,
									46.43256835937498
								],
								[
									-123.91240234374997,
									46.53334960937508
								],
								[
									-123.88916015625003,
									46.66000976562506
								],
								[
									-123.95771484374997,
									46.708691406249926
								],
								[
									-124.07167968750001,
									46.744775390624994
								],
								[
									-124.11254882812499,
									46.86269531250005
								],
								[
									-123.84287109375002,
									46.963183593750074
								],
								[
									-123.98603515624997,
									46.98447265624998
								],
								[
									-124.04223632812496,
									47.02968750000005
								],
								[
									-124.11171875,
									47.03520507812502
								],
								[
									-124.11679687499996,
									47.00034179687512
								],
								[
									-124.1392578125,
									46.95468749999995
								],
								[
									-124.16357421874999,
									47.01533203125004
								],
								[
									-124.17050781249998,
									47.086669921875114
								],
								[
									-124.19882812499998,
									47.208544921875074
								],
								[
									-124.30927734375,
									47.404589843750045
								],
								[
									-124.37602539062502,
									47.658642578124926
								],
								[
									-124.46005859374999,
									47.78422851562493
								],
								[
									-124.62109375000003,
									47.904150390625034
								],
								[
									-124.66308593749996,
									47.974121093750085
								],
								[
									-124.70166015625,
									48.1516601562501
								],
								[
									-124.67998046874995,
									48.285888671875085
								],
								[
									-124.70996093750001,
									48.38037109374997
								],
								[
									-124.63261718749997,
									48.375048828125045
								],
								[
									-124.42905273437498,
									48.300781250000085
								],
								[
									-124.17548828125001,
									48.24243164062503
								],
								[
									-124.09877929687502,
									48.19999999999999
								],
								[
									-123.97578125000001,
									48.16845703125006
								],
								[
									-123.29443359375001,
									48.11953124999994
								],
								[
									-123.24990234375001,
									48.12421875000001
								],
								[
									-123.16186523437501,
									48.15454101562497
								],
								[
									-123.12441406250002,
									48.150927734375045
								],
								[
									-123.02421874999995,
									48.08159179687502
								],
								[
									-122.973876953125,
									48.07329101562493
								],
								[
									-122.90888671874998,
									48.07690429687506
								],
								[
									-122.86088867187497,
									48.09003906250007
								],
								[
									-122.77861328125,
									48.13759765625008
								],
								[
									-122.76752929687497,
									48.12001953125005
								],
								[
									-122.76909179687502,
									48.075976562500045
								],
								[
									-122.73974609374999,
									48.01323242187496
								],
								[
									-122.67949218749997,
									47.93178710937505
								],
								[
									-122.65664062500002,
									47.88115234374996
								],
								[
									-122.77841796874996,
									47.73842773437502
								],
								[
									-122.80175781250001,
									47.735351562500114
								],
								[
									-122.80537109374995,
									47.78364257812507
								],
								[
									-122.82138671875002,
									47.79316406250007
								],
								[
									-123.050634765625,
									47.551953124999955
								],
								[
									-123.13105468749995,
									47.43774414062506
								],
								[
									-123.13906249999998,
									47.38608398437509
								],
								[
									-123.13632812499996,
									47.35581054687506
								],
								[
									-123.10419921874998,
									47.34838867187506
								],
								[
									-123.03090820312498,
									47.36020507812506
								],
								[
									-122.92216796874995,
									47.407666015624955
								],
								[
									-122.91689453125002,
									47.417968750000114
								],
								[
									-123.01821289062497,
									47.40107421875004
								],
								[
									-123.06679687500001,
									47.399658203125114
								],
								[
									-123.06015624999999,
									47.4536621093751
								],
								[
									-123.04863281249995,
									47.47934570312509
								],
								[
									-122.98247070312497,
									47.559375000000045
								],
								[
									-122.912890625,
									47.60737304687504
								],
								[
									-122.81406250000003,
									47.65854492187509
								],
								[
									-122.75712890624997,
									47.70053710937512
								],
								[
									-122.71787109374998,
									47.76210937500005
								],
								[
									-122.608154296875,
									47.83549804687499
								],
								[
									-122.58789062499996,
									47.85595703125006
								],
								[
									-122.59267578124997,
									47.91640625000005
								],
								[
									-122.58574218749997,
									47.92788085937508
								],
								[
									-122.53281250000002,
									47.9197265625001
								],
								[
									-122.51079101562497,
									47.815722656250045
								],
								[
									-122.52392578124999,
									47.7693359375001
								],
								[
									-122.61840820312496,
									47.71279296875002
								],
								[
									-122.63017578124996,
									47.69282226562504
								],
								[
									-122.61362304687496,
									47.61562500000005
								],
								[
									-122.62827148437502,
									47.60815429687494
								],
								[
									-122.66430664062499,
									47.61723632812493
								],
								[
									-122.67548828124995,
									47.6123535156251
								],
								[
									-122.58583984375,
									47.52841796874995
								],
								[
									-122.55742187499997,
									47.46318359374999
								],
								[
									-122.55356445312499,
									47.40493164062502
								],
								[
									-122.57788085937497,
									47.29316406249998
								],
								[
									-122.60390625000002,
									47.27460937500004
								],
								[
									-122.6486328125,
									47.2814453125001
								],
								[
									-122.70771484374995,
									47.316406250000114
								],
								[
									-122.72089843749997,
									47.30512695312504
								],
								[
									-122.76777343750001,
									47.21835937500012
								],
								[
									-122.78330078124998,
									47.22597656250008
								],
								[
									-122.81254882812499,
									47.32895507812509
								],
								[
									-122.82846679687503,
									47.33657226562505
								],
								[
									-122.91953125000002,
									47.28964843749998
								],
								[
									-122.95620117187495,
									47.24458007812504
								],
								[
									-122.98764648437496,
									47.172558593749926
								],
								[
									-123.02758789062501,
									47.138916015625
								],
								[
									-122.91416015624999,
									47.13149414062508
								],
								[
									-122.81196289062495,
									47.14599609375003
								],
								[
									-122.72988281250002,
									47.111816406250085
								],
								[
									-122.70195312500002,
									47.110888671875074
								],
								[
									-122.62705078125003,
									47.14423828125001
								],
								[
									-122.604150390625,
									47.16699218750003
								],
								[
									-122.54218749999998,
									47.275585937499955
								],
								[
									-122.51108398437503,
									47.295019531250006
								],
								[
									-122.46484375000003,
									47.295800781249994
								],
								[
									-122.42011718749998,
									47.312109375000034
								],
								[
									-122.35380859374997,
									47.37158203124997
								],
								[
									-122.35112304687496,
									47.3952148437501
								],
								[
									-122.37524414062499,
									47.528369140625045
								],
								[
									-122.368359375,
									47.603906249999966
								],
								[
									-122.38076171874995,
									47.62783203125005
								],
								[
									-122.41049804687498,
									47.652636718750045
								],
								[
									-122.40678710937502,
									47.67675781249997
								],
								[
									-122.383642578125,
									47.71645507812508
								],
								[
									-122.38198242187502,
									47.75234375000011
								],
								[
									-122.40180664062498,
									47.784277343750034
								],
								[
									-122.39287109375002,
									47.82055664062506
								],
								[
									-122.33032226562499,
									47.89863281250007
								],
								[
									-122.31845703124996,
									47.93305664062507
								],
								[
									-122.24199218750002,
									48.010742187500085
								],
								[
									-122.26127929687495,
									48.04204101562496
								],
								[
									-122.31748046875003,
									48.080175781250006
								],
								[
									-122.35297851562498,
									48.11381835937493
								],
								[
									-122.38867187499997,
									48.16635742187498
								],
								[
									-122.41582031249999,
									48.183935546875006
								],
								[
									-122.42470703125002,
									48.17592773437505
								],
								[
									-122.38662109375,
									48.08994140624995
								],
								[
									-122.39477539062497,
									48.08413085937511
								],
								[
									-122.49404296875002,
									48.13046874999995
								],
								[
									-122.5169921875,
									48.15966796874994
								],
								[
									-122.52915039062499,
									48.199316406250034
								],
								[
									-122.52031249999996,
									48.22910156250006
								],
								[
									-122.46704101562503,
									48.25849609375001
								],
								[
									-122.40336914062495,
									48.269189453124966
								],
								[
									-122.40854492187502,
									48.29389648437504
								],
								[
									-122.48842773437495,
									48.374316406250074
								],
								[
									-122.54165039062495,
									48.410937500000074
								],
								[
									-122.58256835937495,
									48.42866210937504
								],
								[
									-122.63779296875,
									48.43330078125001
								],
								[
									-122.66249999999998,
									48.446386718750006
								],
								[
									-122.66899414062496,
									48.46523437499994
								],
								[
									-122.65727539062497,
									48.489990234375085
								],
								[
									-122.62797851562496,
									48.49790039062512
								],
								[
									-122.54267578124998,
									48.487988281249955
								],
								[
									-122.49677734374997,
									48.50556640624998
								],
								[
									-122.50107421875003,
									48.53750000000011
								],
								[
									-122.514794921875,
									48.55517578125006
								],
								[
									-122.51274414062502,
									48.66943359374997
								],
								[
									-122.54511718749995,
									48.76230468749998
								],
								[
									-122.56201171875001,
									48.777978515624966
								],
								[
									-122.58017578124999,
									48.779589843750045
								],
								[
									-122.5994140625,
									48.76708984374997
								],
								[
									-122.65302734375,
									48.76386718750004
								],
								[
									-122.68593749999995,
									48.794287109375006
								],
								[
									-122.72246093750002,
									48.853027343750085
								],
								[
									-122.78876953124994,
									48.99301757812509
								],
								[
									-122.68637695312495,
									48.99301757812509
								],
								[
									-122.26000976562496,
									48.99301757812509
								],
								[
									-121.83359374999995,
									48.99301757812509
								],
								[
									-121.40722656249994,
									48.99301757812509
								],
								[
									-120.98085937499995,
									48.99301757812509
								],
								[
									-120.55449218749995,
									48.99301757812509
								],
								[
									-120.12807617187494,
									48.99301757812509
								],
								[
									-119.70170898437495,
									48.99301757812509
								],
								[
									-119.27534179687494,
									48.99306640625019
								],
								[
									-118.84892578124993,
									48.99306640625019
								],
								[
									-118.42255859374994,
									48.99306640625019
								],
								[
									-117.99619140624993,
									48.99306640625019
								],
								[
									-117.56977539062493,
									48.99306640625019
								],
								[
									-117.14340820312493,
									48.99306640625019
								],
								[
									-116.71704101562493,
									48.99306640625019
								],
								[
									-116.29062499999992,
									48.99306640625019
								],
								[
									-115.86425781249993,
									48.99306640625019
								],
								[
									-115.43789062499992,
									48.99306640625019
								],
								[
									-115.01152343750002,
									48.99306640625019
								],
								[
									-114.58510742187492,
									48.99306640625019
								],
								[
									-114.15874023437492,
									48.99306640625019
								],
								[
									-113.73237304687493,
									48.99306640625019
								],
								[
									-113.30595703124992,
									48.99306640625019
								],
								[
									-112.87958984374991,
									48.99306640625019
								],
								[
									-112.45322265625,
									48.99306640625019
								],
								[
									-112.02680664062491,
									48.99306640625019
								],
								[
									-111.6004394531249,
									48.99306640625019
								],
								[
									-111.17407226562491,
									48.99306640625019
								],
								[
									-110.7476562499999,
									48.99306640625019
								],
								[
									-110.3212890624999,
									48.99306640625019
								],
								[
									-109.894921875,
									48.99306640625019
								],
								[
									-109.4685546874999,
									48.99306640625019
								],
								[
									-109.042138671875,
									48.99311523437501
								],
								[
									-108.6157714843749,
									48.99311523437501
								],
								[
									-108.189404296875,
									48.99311523437501
								],
								[
									-107.76298828124989,
									48.99311523437501
								],
								[
									-107.33662109374998,
									48.99311523437501
								],
								[
									-106.91025390624989,
									48.99311523437501
								],
								[
									-106.48383789062498,
									48.99311523437501
								],
								[
									-106.05747070312489,
									48.99311523437501
								],
								[
									-105.63110351562499,
									48.99311523437501
								],
								[
									-105.20468749999988,
									48.99311523437501
								],
								[
									-104.77832031249997,
									48.99311523437501
								],
								[
									-104.35195312499998,
									48.99311523437501
								],
								[
									-103.92558593749989,
									48.99311523437501
								],
								[
									-103.49916992187497,
									48.99311523437501
								],
								[
									-103.07280273437497,
									48.99311523437501
								],
								[
									-102.64643554687497,
									48.99311523437501
								],
								[
									-102.22001953124996,
									48.99311523437501
								],
								[
									-101.79365234374997,
									48.99311523437501
								],
								[
									-101.36728515624988,
									48.99311523437501
								],
								[
									-100.94086914062495,
									48.99311523437501
								],
								[
									-100.51450195312496,
									48.99311523437501
								],
								[
									-100.08813476562496,
									48.99311523437501
								],
								[
									-99.66171874999995,
									48.99311523437501
								],
								[
									-99.23535156249996,
									48.99311523437501
								],
								[
									-98.80898437499995,
									48.99316406250003
								],
								[
									-98.38261718749996,
									48.99316406250003
								],
								[
									-97.95620117187494,
									48.99316406250003
								],
								[
									-97.52983398437496,
									48.99316406250003
								],
								[
									-97.10346679687495,
									48.99316406250003
								],
								[
									-96.67705078124993,
									48.99316406250003
								],
								[
									-96.25068359374995,
									48.99316406250003
								],
								[
									-95.82431640624995,
									48.99316406250003
								],
								[
									-95.39790039062493,
									48.99316406250003
								],
								[
									-95.16206054687493,
									48.9917480468751
								],
								[
									-95.15825195312496,
									49.20307617187507
								],
								[
									-95.15527343749997,
									49.369677734375074
								],
								[
									-94.93935546874997,
									49.34941406250013
								],
								[
									-94.87480468749996,
									49.31904296875007
								],
								[
									-94.85434570312495,
									49.304589843749966
								],
								[
									-94.86040039062493,
									49.2585937500001
								],
								[
									-94.84257812499996,
									49.11918945312513
								],
								[
									-94.80346679687497,
									49.00292968749997
								],
								[
									-94.71279296875,
									48.863427734374966
								],
								[
									-94.71254882812494,
									48.86298828125015
								],
								[
									-94.70507812499991,
									48.808496093749966
								],
								[
									-94.6753417968749,
									48.77441406250006
								],
								[
									-94.6208984374999,
									48.74262695312515
								],
								[
									-94.41416015624989,
									48.704101562500114
								],
								[
									-94.05517578125003,
									48.65903320312498
								],
								[
									-93.85161132812496,
									48.607275390625006
								],
								[
									-93.80356445312492,
									48.54892578125012
								],
								[
									-93.70771484374995,
									48.52543945312513
								],
								[
									-93.56425781249993,
									48.53691406250016
								],
								[
									-93.46362304687494,
									48.56127929687506
								],
								[
									-93.37788085937498,
									48.61655273437495
								],
								[
									-93.25795898437497,
									48.62885742187507
								],
								[
									-93.15522460937493,
									48.62534179687506
								],
								[
									-93.05170898437498,
									48.619873046875085
								],
								[
									-92.99624023437494,
									48.61181640625014
								],
								[
									-92.83671874999996,
									48.56777343750005
								],
								[
									-92.73266601562489,
									48.531835937500006
								],
								[
									-92.58325195312491,
									48.465087890625
								],
								[
									-92.50058593749995,
									48.435351562500074
								],
								[
									-92.46088867187495,
									48.365869140625136
								],
								[
									-92.41459960937493,
									48.27661132812497
								],
								[
									-92.34843749999996,
									48.27661132812497
								],
								[
									-92.29868164062495,
									48.32890624999996
								],
								[
									-92.17177734374994,
									48.33837890624994
								],
								[
									-92.00517578125002,
									48.30185546875006
								],
								[
									-91.85839843749994,
									48.19755859375013
								],
								[
									-91.64731445312495,
									48.104589843750006
								],
								[
									-91.51831054687494,
									48.05830078125018
								],
								[
									-91.38720703124997,
									48.058544921874955
								],
								[
									-91.22065429687498,
									48.104589843750006
								],
								[
									-91.04345703124994,
									48.19370117187495
								],
								[
									-90.9160644531249,
									48.20913085937508
								],
								[
									-90.84033203125003,
									48.200537109375006
								],
								[
									-90.79731445312495,
									48.13105468749998
								],
								[
									-90.74438476562494,
									48.104589843750006
								],
								[
									-90.60708007812494,
									48.112597656250045
								],
								[
									-90.3201171874999,
									48.09916992187516
								],
								[
									-90.09179687500003,
									48.11811523437501
								],
								[
									-90.03994140624994,
									48.078173828125045
								],
								[
									-89.99365234374994,
									48.015332031250125
								],
								[
									-89.90102539062497,
									47.99545898437506
								],
								[
									-89.77539062499997,
									48.015332031250125
								],
								[
									-89.57755546283573,
									48.00175342324741
								]
							]
						],
						[
							[
								[
									179.45156250000014,
									51.37260742187502
								],
								[
									179.27812500000016,
									51.37221679687502
								],
								[
									178.92587890625015,
									51.53505859375008
								],
								[
									178.7470703125001,
									51.58671874999993
								],
								[
									178.64794921875017,
									51.64389648437495
								],
								[
									178.69218750000016,
									51.65595703125001
								],
								[
									178.90800781250022,
									51.61557617187495
								],
								[
									179.0842773437501,
									51.52768554687506
								],
								[
									179.1817382812502,
									51.46992187500004
								],
								[
									179.29433593750008,
									51.42084960937498
								],
								[
									179.41552734375006,
									51.40087890625
								],
								[
									179.45156250000014,
									51.37260742187502
								]
							]
						],
						[
							[
								[
									-176.28671874999998,
									51.791992187500085
								],
								[
									-176.34965820312502,
									51.73330078125005
								],
								[
									-176.39609374999998,
									51.75986328124995
								],
								[
									-176.41372070312502,
									51.84057617187506
								],
								[
									-176.37856445312497,
									51.861132812500074
								],
								[
									-176.28022460937498,
									51.80283203125009
								],
								[
									-176.28671874999998,
									51.791992187500085
								]
							]
						],
						[
							[
								[
									-176.00898437499998,
									51.81235351562498
								],
								[
									-176.09335937500003,
									51.79047851562507
								],
								[
									-176.204443359375,
									51.834814453125034
								],
								[
									-176.19365234375005,
									51.886279296875045
								],
								[
									-176.07163085937503,
									51.843310546875074
								],
								[
									-176.00898437499998,
									51.81235351562498
								]
							]
						],
						[
							[
								[
									-177.87905273437502,
									51.649707031250074
								],
								[
									-177.90126953125002,
									51.61640625000004
								],
								[
									-177.92534179687493,
									51.61738281250004
								],
								[
									-178.05888671875,
									51.67260742187503
								],
								[
									-178.07846679687498,
									51.691259765625006
								],
								[
									-178.000048828125,
									51.717480468749926
								],
								[
									-177.97724609375004,
									51.73779296875006
								],
								[
									-177.98637695312493,
									51.76425781249995
								],
								[
									-178.0451171875,
									51.80107421874999
								],
								[
									-178.15346679687497,
									51.848242187500006
								],
								[
									-178.19453124999998,
									51.88222656250011
								],
								[
									-178.16826171874996,
									51.90302734374998
								],
								[
									-178.11660156250002,
									51.91586914062512
								],
								[
									-177.95380859374998,
									51.918457031250114
								],
								[
									-177.865869140625,
									51.8604003906251
								],
								[
									-177.799609375,
									51.84003906250004
								],
								[
									-177.644482421875,
									51.82626953124998
								],
								[
									-177.72495117187498,
									51.80166015624994
								],
								[
									-177.77065429687497,
									51.777880859375074
								],
								[
									-177.826953125,
									51.68588867187498
								],
								[
									-177.87905273437502,
									51.649707031250074
								]
							]
						],
						[
							[
								[
									-177.148193359375,
									51.716748046874955
								],
								[
									-177.177001953125,
									51.70371093750006
								],
								[
									-177.22988281250002,
									51.69355468750004
								],
								[
									-177.382373046875,
									51.704833984375114
								],
								[
									-177.47465820312496,
									51.70126953125009
								],
								[
									-177.57758789062498,
									51.69418945312498
								],
								[
									-177.6548828125,
									51.67656250000002
								],
								[
									-177.67021484375002,
									51.70107421875005
								],
								[
									-177.66762695312502,
									51.72119140624997
								],
								[
									-177.33471679687497,
									51.77622070312509
								],
								[
									-177.257275390625,
									51.80493164062506
								],
								[
									-177.209765625,
									51.84125976562501
								],
								[
									-177.16640624999997,
									51.90942382812503
								],
								[
									-177.13149414062497,
									51.92978515625009
								],
								[
									-177.11005859375004,
									51.928759765625074
								],
								[
									-177.06303710937496,
									51.90190429687493
								],
								[
									-177.07954101562504,
									51.866552734375006
								],
								[
									-177.12138671875005,
									51.83579101562506
								],
								[
									-177.13510742187498,
									51.806933593750045
								],
								[
									-177.148193359375,
									51.716748046874955
								]
							]
						],
						[
							[
								[
									-176.593310546875,
									51.86669921875003
								],
								[
									-176.587939453125,
									51.83320312500007
								],
								[
									-176.473388671875,
									51.83740234375003
								],
								[
									-176.43745117187504,
									51.82011718749996
								],
								[
									-176.43735351562503,
									51.754296874999966
								],
								[
									-176.45234374999998,
									51.73569335937509
								],
								[
									-176.469775390625,
									51.731152343749955
								],
								[
									-176.51098632812503,
									51.74560546874997
								],
								[
									-176.55751953125,
									51.71206054687508
								],
								[
									-176.77094726562504,
									51.629931640625045
								],
								[
									-176.837109375,
									51.67587890624998
								],
								[
									-176.96162109374998,
									51.60366210937511
								],
								[
									-176.8744140625,
									51.79047851562507
								],
								[
									-176.77363281249995,
									51.81875000000005
								],
								[
									-176.73642578125003,
									51.839941406250006
								],
								[
									-176.74511718750003,
									51.894677734374966
								],
								[
									-176.69833984375,
									51.986035156249926
								],
								[
									-176.59682617187502,
									51.98178710937495
								],
								[
									-176.54990234375003,
									51.94404296874998
								],
								[
									-176.55161132812503,
									51.91958007812508
								],
								[
									-176.593310546875,
									51.86669921875003
								]
							]
						],
						[
							[
								[
									178.57548828125016,
									51.916259765625114
								],
								[
									178.51181640625015,
									51.89912109374998
								],
								[
									178.47773437499995,
									51.94252929687502
								],
								[
									178.47500000000014,
									51.967724609374926
								],
								[
									178.5093750000002,
									51.9946777343751
								],
								[
									178.57060546875005,
									51.97753906249997
								],
								[
									178.60732421875008,
									51.95302734375005
								],
								[
									178.57548828125016,
									51.916259765625114
								]
							]
						],
						[
							[
								[
									179.72773437500024,
									51.90541992187494
								],
								[
									179.64521484375013,
									51.88022460937495
								],
								[
									179.54960937500022,
									51.894042968750114
								],
								[
									179.49765625000026,
									51.93281250000001
								],
								[
									179.5039062500001,
									51.97958984374995
								],
								[
									179.62714843750018,
									52.030419921874994
								],
								[
									179.77998046875024,
									51.96684570312502
								],
								[
									179.72773437500024,
									51.90541992187494
								]
							]
						],
						[
							[
								[
									-176.02153320312496,
									52.002441406250085
								],
								[
									-176.04506835937497,
									51.97299804687512
								],
								[
									-176.14287109375,
									52.00429687500011
								],
								[
									-176.17753906249993,
									52.029833984375045
								],
								[
									-176.18452148437504,
									52.05605468750008
								],
								[
									-176.15566406250002,
									52.09941406249993
								],
								[
									-176.07739257812497,
									52.09995117187495
								],
								[
									-176.03120117187498,
									52.0823242187501
								],
								[
									-175.9880859375,
									52.049462890624966
								],
								[
									-175.97529296875004,
									52.028955078124966
								],
								[
									-176.02153320312496,
									52.002441406250085
								]
							]
						],
						[
							[
								[
									177.41542968750008,
									51.88281249999994
								],
								[
									177.32851562500014,
									51.84106445312497
								],
								[
									177.2606445312502,
									51.88369140625005
								],
								[
									177.25029296875022,
									51.90292968750006
								],
								[
									177.3806640625001,
									51.97578125000007
								],
								[
									177.47841796875014,
									51.991601562499994
								],
								[
									177.52050781250017,
									52.018212890624994
								],
								[
									177.5637695312501,
									52.110498046874966
								],
								[
									177.63652343750016,
									52.11381835937493
								],
								[
									177.66962890625018,
									52.10302734375006
								],
								[
									177.65302734375018,
									52.05976562500004
								],
								[
									177.5959960937501,
									51.99384765625001
								],
								[
									177.59414062500008,
									51.94755859374999
								],
								[
									177.41542968750008,
									51.88281249999994
								]
							]
						],
						[
							[
								[
									-173.5533203125,
									52.136279296875074
								],
								[
									-173.35722656250002,
									52.09565429687507
								],
								[
									-173.11328124999997,
									52.100390625000045
								],
								[
									-173.02431640624997,
									52.09052734374998
								],
								[
									-173.02290039062504,
									52.079150390625074
								],
								[
									-173.17885742187502,
									52.06250000000006
								],
								[
									-173.23222656249996,
									52.067968750000006
								],
								[
									-173.368408203125,
									52.04560546874998
								],
								[
									-173.46098632812502,
									52.04155273437496
								],
								[
									-173.67255859375004,
									52.062646484374994
								],
								[
									-173.835791015625,
									52.04819335937498
								],
								[
									-173.878955078125,
									52.05366210937504
								],
								[
									-173.93022460937496,
									52.07216796875008
								],
								[
									-173.98959960937498,
									52.10361328125009
								],
								[
									-173.99248046874993,
									52.12333984375002
								],
								[
									-173.93891601562504,
									52.13129882812504
								],
								[
									-173.79409179687502,
									52.104296875000045
								],
								[
									-173.77900390624998,
									52.11835937500007
								],
								[
									-173.65683593750003,
									52.1437500000001
								],
								[
									-173.5533203125,
									52.136279296875074
								]
							]
						],
						[
							[
								[
									-172.464794921875,
									52.272265625000074
								],
								[
									-172.539111328125,
									52.25747070312508
								],
								[
									-172.61982421874998,
									52.27285156250011
								],
								[
									-172.58217773437497,
									52.325634765624926
								],
								[
									-172.54365234375,
									52.353808593750074
								],
								[
									-172.47041015625,
									52.38803710937512
								],
								[
									-172.38310546875,
									52.372949218749966
								],
								[
									-172.31362304687497,
									52.329589843750114
								],
								[
									-172.464794921875,
									52.272265625000074
								]
							]
						],
						[
							[
								[
									-174.67739257812502,
									52.035009765625034
								],
								[
									-175.2138671875,
									51.993896484375114
								],
								[
									-175.29555664062502,
									52.02216796875001
								],
								[
									-175.21416015624996,
									52.038232421874994
								],
								[
									-175.11767578125003,
									52.04711914062503
								],
								[
									-174.91591796874997,
									52.09418945312501
								],
								[
									-174.66777343750005,
									52.13496093749998
								],
								[
									-174.47426757812497,
									52.18403320312504
								],
								[
									-174.30615234375,
									52.216162109375006
								],
								[
									-174.25883789062505,
									52.26904296874994
								],
								[
									-174.406494140625,
									52.29599609375009
								],
								[
									-174.43554687499997,
									52.31723632812509
								],
								[
									-174.36542968749998,
									52.34194335937505
								],
								[
									-174.30688476562494,
									52.377929687500085
								],
								[
									-174.168896484375,
									52.420166015625
								],
								[
									-174.04560546875,
									52.36723632812496
								],
								[
									-174.018359375,
									52.33178710937503
								],
								[
									-174.03007812499996,
									52.289794921875085
								],
								[
									-174.05488281250004,
									52.24599609375005
								],
								[
									-174.163232421875,
									52.22338867187506
								],
								[
									-174.17939453125,
									52.20034179687508
								],
								[
									-174.12065429687493,
									52.13520507812504
								],
								[
									-174.34355468749996,
									52.077783203124966
								],
								[
									-174.67739257812502,
									52.035009765625034
								]
							]
						],
						[
							[
								[
									173.72275390625026,
									52.3595703125001
								],
								[
									173.65781249999998,
									52.35664062500001
								],
								[
									173.61621093750006,
									52.391259765624966
								],
								[
									173.40234375000017,
									52.40478515624997
								],
								[
									173.42451171875024,
									52.43764648437511
								],
								[
									173.51650390625014,
									52.45141601562497
								],
								[
									173.65761718750014,
									52.504101562499955
								],
								[
									173.77607421875013,
									52.495117187500085
								],
								[
									173.7447265625001,
									52.44663085937506
								],
								[
									173.72275390625026,
									52.3595703125001
								]
							]
						],
						[
							[
								[
									-170.7333984375,
									52.5814941406251
								],
								[
									-170.79736328124994,
									52.549755859374926
								],
								[
									-170.81606445312497,
									52.561523437500114
								],
								[
									-170.82705078124997,
									52.60073242187511
								],
								[
									-170.79116210937502,
									52.63125000000011
								],
								[
									-170.682080078125,
									52.69755859374993
								],
								[
									-170.60805664062502,
									52.68505859375006
								],
								[
									-170.58461914062497,
									52.66757812499995
								],
								[
									-170.58662109375,
									52.64243164062498
								],
								[
									-170.614013671875,
									52.60961914062506
								],
								[
									-170.64926757812498,
									52.59311523437506
								],
								[
									-170.69228515624997,
									52.59296875000004
								],
								[
									-170.7333984375,
									52.5814941406251
								]
							]
						],
						[
							[
								[
									-169.691943359375,
									52.84736328124998
								],
								[
									-169.70810546875,
									52.80712890625006
								],
								[
									-169.72275390624998,
									52.79233398437506
								],
								[
									-169.87734375000002,
									52.813769531250074
								],
								[
									-169.98056640625,
									52.80600585937509
								],
								[
									-169.991845703125,
									52.82983398437497
								],
								[
									-169.98256835937497,
									52.85102539062501
								],
								[
									-169.82065429687503,
									52.883398437500034
								],
								[
									-169.75488281250003,
									52.883642578125006
								],
								[
									-169.71098632812496,
									52.86674804687502
								],
								[
									-169.691943359375,
									52.84736328124998
								]
							]
						],
						[
							[
								[
									172.81181640625005,
									53.012988281250074
								],
								[
									172.9839843750002,
									52.980273437500074
								],
								[
									173.1021484375002,
									52.995605468750085
								],
								[
									173.25166015625018,
									52.942675781250045
								],
								[
									173.4360351562501,
									52.85205078125006
								],
								[
									173.39472656250024,
									52.834765625000074
								],
								[
									173.34824218750015,
									52.82485351562502
								],
								[
									173.3025390625001,
									52.82592773437497
								],
								[
									173.1586914062501,
									52.810791015625
								],
								[
									173.08027343750018,
									52.81445312499994
								],
								[
									172.9351562500002,
									52.75209960937494
								],
								[
									172.7755859375,
									52.79692382812502
								],
								[
									172.7217773437501,
									52.885546875000045
								],
								[
									172.59511718750014,
									52.90742187500007
								],
								[
									172.49482421875,
									52.93789062500005
								],
								[
									172.6779296875,
									53.00756835937494
								],
								[
									172.81181640625005,
									53.012988281250074
								]
							]
						],
						[
							[
								[
									-167.96435546875003,
									53.345117187499966
								],
								[
									-168.270703125,
									53.238037109375
								],
								[
									-168.3701171875,
									53.15976562499995
								],
								[
									-168.44599609375,
									53.08442382812507
								],
								[
									-168.505615234375,
									53.0431640625001
								],
								[
									-168.54902343750004,
									53.03608398437507
								],
								[
									-168.59741210937503,
									53.016113281250085
								],
								[
									-168.69853515625005,
									52.9634277343751
								],
								[
									-168.741015625,
									52.956884765625006
								],
								[
									-169.06591796875,
									52.83393554687501
								],
								[
									-169.088916015625,
									52.83203124999997
								],
								[
									-169.07309570312503,
									52.86416015625002
								],
								[
									-168.973876953125,
									52.90966796875006
								],
								[
									-168.90917968749994,
									52.951171875
								],
								[
									-168.836083984375,
									53.019726562499926
								],
								[
									-168.79584960937504,
									53.044921875
								],
								[
									-168.78300781250002,
									53.079345703125
								],
								[
									-168.777783203125,
									53.14877929687512
								],
								[
									-168.75961914062503,
									53.17504882812506
								],
								[
									-168.68984375000002,
									53.227246093749926
								],
								[
									-168.63901367187498,
									53.255761718749966
								],
								[
									-168.57216796874997,
									53.26562500000003
								],
								[
									-168.43662109374998,
									53.25688476562493
								],
								[
									-168.38041992187496,
									53.283447265625114
								],
								[
									-168.36298828124995,
									53.30356445312512
								],
								[
									-168.39726562500002,
									53.32192382812502
								],
								[
									-168.405322265625,
									53.35380859374996
								],
								[
									-168.39643554687504,
									53.40878906250006
								],
								[
									-168.35722656249996,
									53.45756835937496
								],
								[
									-168.2876953125,
									53.50014648437502
								],
								[
									-168.19306640624998,
									53.53330078125012
								],
								[
									-168.07329101562502,
									53.55698242187506
								],
								[
									-167.98569335937503,
									53.558203125000034
								],
								[
									-167.82807617187498,
									53.50795898437511
								],
								[
									-167.8046875,
									53.484960937500034
								],
								[
									-167.84311523437503,
									53.43457031250006
								],
								[
									-167.86513671874997,
									53.387304687500034
								],
								[
									-167.96435546875003,
									53.345117187499966
								]
							]
						],
						[
							[
								[
									-166.209765625,
									53.72329101562508
								],
								[
									-166.223828125,
									53.72041015625004
								],
								[
									-166.24941406249997,
									53.74516601562493
								],
								[
									-166.25073242187497,
									53.76777343750001
								],
								[
									-166.234375,
									53.78417968749997
								],
								[
									-166.187744140625,
									53.822460937499955
								],
								[
									-166.154541015625,
									53.83613281249998
								],
								[
									-166.11372070312504,
									53.843066406250074
								],
								[
									-166.10268554687502,
									53.83281249999993
								],
								[
									-166.13862304687504,
									53.7874023437501
								],
								[
									-166.183740234375,
									53.7568847656251
								],
								[
									-166.209765625,
									53.72329101562508
								]
							]
						],
						[
							[
								[
									-166.61533203125,
									53.900927734375045
								],
								[
									-166.57216796875,
									53.85346679687507
								],
								[
									-166.49746093749997,
									53.88354492187506
								],
								[
									-166.44277343750002,
									53.92480468750003
								],
								[
									-166.40004882812502,
									53.97812500000006
								],
								[
									-166.37231445312494,
									53.99897460937504
								],
								[
									-166.33564453125004,
									53.9708984375001
								],
								[
									-166.23085937500002,
									53.932617187500114
								],
								[
									-166.31899414062502,
									53.873779296875114
								],
								[
									-166.48876953124997,
									53.78549804687498
								],
								[
									-166.54560546875,
									53.72646484374994
								],
								[
									-166.54921875000002,
									53.70097656249999
								],
								[
									-166.384716796875,
									53.720507812500045
								],
								[
									-166.33876953124997,
									53.71767578125011
								],
								[
									-166.30947265625002,
									53.697509765625085
								],
								[
									-166.354541015625,
									53.67353515625007
								],
								[
									-166.44418945312503,
									53.65180664062501
								],
								[
									-166.522021484375,
									53.609667968750045
								],
								[
									-166.70219726562502,
									53.536669921875074
								],
								[
									-166.77041015624997,
									53.47602539062498
								],
								[
									-166.85097656249997,
									53.45288085937506
								],
								[
									-166.96074218750002,
									53.447363281250006
								],
								[
									-167.15366210937498,
									53.40786132812505
								],
								[
									-167.27080078124996,
									53.37060546875
								],
								[
									-167.30043945312497,
									53.350488281249994
								],
								[
									-167.33725585937498,
									53.34096679687511
								],
								[
									-167.38129882812498,
									53.34199218750004
								],
								[
									-167.42880859374998,
									53.32568359375
								],
								[
									-167.47983398437498,
									53.29199218749997
								],
								[
									-167.52246093749997,
									53.27622070312506
								],
								[
									-167.59218749999997,
									53.27270507812506
								],
								[
									-167.62861328125,
									53.25942382812508
								],
								[
									-167.66943359375,
									53.25996093750001
								],
								[
									-167.78085937500003,
									53.30024414062507
								],
								[
									-167.80878906250004,
									53.323779296875045
								],
								[
									-167.71010742187502,
									53.370898437500074
								],
								[
									-167.63872070312493,
									53.38657226562506
								],
								[
									-167.53017578125002,
									53.39370117187508
								],
								[
									-167.42353515624998,
									53.437255859375085
								],
								[
									-167.20410156250006,
									53.494970703125034
								],
								[
									-167.13608398437503,
									53.52646484375006
								],
								[
									-167.09233398437502,
									53.63593750000007
								],
								[
									-167.04243164062495,
									53.654589843750045
								],
								[
									-167.01572265625003,
									53.698388671874994
								],
								[
									-166.89414062500003,
									53.69711914062509
								],
								[
									-166.83833007812504,
									53.64804687499995
								],
								[
									-166.81874999999997,
									53.641357421875085
								],
								[
									-166.80898437500002,
									53.64614257812511
								],
								[
									-166.803662109375,
									53.685400390625006
								],
								[
									-166.741259765625,
									53.71293945312493
								],
								[
									-166.77724609375002,
									53.73315429687497
								],
								[
									-166.889599609375,
									53.7585937500001
								],
								[
									-166.97294921875002,
									53.770556640625045
								],
								[
									-167.02724609374997,
									53.76914062500012
								],
								[
									-167.071484375,
									53.78339843750007
								],
								[
									-167.10561523437497,
									53.813378906249966
								],
								[
									-167.12114257812502,
									53.84311523437509
								],
								[
									-167.11816406250003,
									53.87260742187496
								],
								[
									-167.090478515625,
									53.90566406249994
								],
								[
									-167.03808593749997,
									53.94218750000002
								],
								[
									-166.978076171875,
									53.962939453125074
								],
								[
									-166.84868164062502,
									53.97788085937509
								],
								[
									-166.73403320312502,
									54.00219726562506
								],
								[
									-166.67329101562498,
									54.00595703124995
								],
								[
									-166.62739257812495,
									53.995654296875074
								],
								[
									-166.61533203125,
									53.900927734375045
								]
							]
						],
						[
							[
								[
									-165.841552734375,
									54.07065429687498
								],
								[
									-165.87939453125,
									54.053027343750045
								],
								[
									-165.90986328124998,
									54.049169921875034
								],
								[
									-165.93291015624996,
									54.05917968749995
								],
								[
									-166.03642578125002,
									54.04716796874999
								],
								[
									-166.05664062500006,
									54.05434570312502
								],
								[
									-166.10283203124993,
									54.113964843749926
								],
								[
									-166.10581054687503,
									54.14482421874999
								],
								[
									-166.08774414062498,
									54.16914062500007
								],
								[
									-166.041259765625,
									54.19125976562495
								],
								[
									-165.96640625000003,
									54.21103515624998
								],
								[
									-165.89287109375,
									54.206982421874955
								],
								[
									-165.76445312500002,
									54.15209960937506
								],
								[
									-165.70424804687502,
									54.119921875000074
								],
								[
									-165.69287109375,
									54.09990234374999
								],
								[
									-165.73789062500003,
									54.081103515625074
								],
								[
									-165.841552734375,
									54.07065429687498
								]
							]
						],
						[
							[
								[
									-165.56113281249998,
									54.13671874999994
								],
								[
									-165.604833984375,
									54.129150390625
								],
								[
									-165.61538085937502,
									54.13955078125008
								],
								[
									-165.62050781250002,
									54.18354492187507
								],
								[
									-165.65415039062503,
									54.25332031250008
								],
								[
									-165.59033203125,
									54.27866210937509
								],
								[
									-165.55063476562498,
									54.284521484375034
								],
								[
									-165.5337890625,
									54.2738769531251
								],
								[
									-165.48769531249997,
									54.22187500000007
								],
								[
									-165.441748046875,
									54.208007812500085
								],
								[
									-165.40786132812502,
									54.19682617187493
								],
								[
									-165.46757812500002,
									54.18090820312497
								],
								[
									-165.56113281249998,
									54.13671874999994
								]
							]
						],
						[
							[
								[
									-162.55439453125,
									54.40136718749994
								],
								[
									-162.64111328125,
									54.37954101562494
								],
								[
									-162.73310546875,
									54.402294921874955
								],
								[
									-162.81171875000004,
									54.4443847656251
								],
								[
									-162.82055664062497,
									54.49453125000011
								],
								[
									-162.64541015625,
									54.462060546874966
								],
								[
									-162.607958984375,
									54.44663085937512
								],
								[
									-162.55439453125,
									54.40136718749994
								]
							]
						],
						[
							[
								[
									-162.29814453124993,
									54.84702148437506
								],
								[
									-162.321923828125,
									54.84238281250009
								],
								[
									-162.39077148437497,
									54.872998046874926
								],
								[
									-162.415771484375,
									54.89589843750005
								],
								[
									-162.43388671875,
									54.93154296875005
								],
								[
									-162.29365234375,
									54.982861328124926
								],
								[
									-162.26459960937504,
									54.98349609375006
								],
								[
									-162.23837890625003,
									54.954736328124966
								],
								[
									-162.23374023437498,
									54.932031249999966
								],
								[
									-162.27255859374998,
									54.867187500000085
								],
								[
									-162.29814453124993,
									54.84702148437506
								]
							]
						],
						[
							[
								[
									-163.476025390625,
									54.98071289062503
								],
								[
									-163.37895507812496,
									54.815527343750034
								],
								[
									-163.3369140625,
									54.783203125000114
								],
								[
									-163.27451171874998,
									54.76557617187498
								],
								[
									-163.18710937500003,
									54.74775390625007
								],
								[
									-163.13505859375,
									54.72329101562508
								],
								[
									-163.0892578125,
									54.686083984375045
								],
								[
									-163.08325195312503,
									54.66899414062493
								],
								[
									-163.35810546874995,
									54.73569335937512
								],
								[
									-163.53085937499998,
									54.638330078124994
								],
								[
									-163.58300781249994,
									54.62568359375007
								],
								[
									-164.07329101562502,
									54.62099609375011
								],
								[
									-164.1712890625,
									54.603027343750085
								],
								[
									-164.234619140625,
									54.57133789062493
								],
								[
									-164.34667968750003,
									54.48242187500003
								],
								[
									-164.40351562500007,
									54.44785156250009
								],
								[
									-164.4634765625,
									54.42734375000009
								],
								[
									-164.59082031250003,
									54.40434570312493
								],
								[
									-164.74379882812502,
									54.40747070312494
								],
								[
									-164.82343749999998,
									54.41909179687508
								],
								[
									-164.86616210937498,
									54.4613769531251
								],
								[
									-164.90395507812497,
									54.544775390625034
								],
								[
									-164.9037109375,
									54.567968750000034
								],
								[
									-164.887646484375,
									54.607812499999994
								],
								[
									-164.75146484374997,
									54.662939453125034
								],
								[
									-164.706201171875,
									54.69199218750009
								],
								[
									-164.52978515625003,
									54.880859375000114
								],
								[
									-164.47861328124998,
									54.90683593749998
								],
								[
									-164.42431640625003,
									54.913183593750034
								],
								[
									-164.27368164062497,
									54.90004882812502
								],
								[
									-164.145068359375,
									54.95512695312496
								],
								[
									-163.86796875000002,
									55.03911132812493
								],
								[
									-163.80712890624997,
									55.049072265625
								],
								[
									-163.60747070312496,
									55.0508300781251
								],
								[
									-163.55302734375,
									55.03784179687503
								],
								[
									-163.51088867187502,
									55.01430664062494
								],
								[
									-163.476025390625,
									54.98071289062503
								]
							]
						],
						[
							[
								[
									-159.36201171875007,
									54.972412109375114
								],
								[
									-159.394482421875,
									54.96733398437496
								],
								[
									-159.42133789062495,
									54.978125000000034
								],
								[
									-159.45849609375,
									55.034960937500074
								],
								[
									-159.46191406249997,
									55.05878906250004
								],
								[
									-159.3904296875,
									55.04086914062512
								],
								[
									-159.36318359375002,
									54.99951171874994
								],
								[
									-159.36201171875007,
									54.972412109375114
								]
							]
						],
						[
							[
								[
									-159.51513671875,
									55.151855468750085
								],
								[
									-159.52041015625,
									55.07216796875008
								],
								[
									-159.53496093750005,
									55.05961914062493
								],
								[
									-159.561474609375,
									55.080908203125006
								],
								[
									-159.61772460937502,
									55.0573242187501
								],
								[
									-159.648486328125,
									55.074560546875034
								],
								[
									-159.63540039062497,
									55.10234374999993
								],
								[
									-159.63964843750006,
									55.12397460937498
								],
								[
									-159.59794921875,
									55.12568359374998
								],
								[
									-159.58803710937502,
									55.165332031250074
								],
								[
									-159.59526367187496,
									55.18203125000008
								],
								[
									-159.57475585937496,
									55.21772460937507
								],
								[
									-159.54506835937497,
									55.22597656250008
								],
								[
									-159.51513671875,
									55.151855468750085
								]
							]
						],
						[
							[
								[
									-131.33974609375002,
									55.07983398437506
								],
								[
									-131.23745117187497,
									54.949511718750074
								],
								[
									-131.23203125000003,
									54.90375976562507
								],
								[
									-131.32954101562498,
									54.8877441406251
								],
								[
									-131.40620117187495,
									54.894287109375
								],
								[
									-131.44570312500002,
									54.90932617187505
								],
								[
									-131.45610351562502,
									54.93056640625002
								],
								[
									-131.43134765625,
									54.99648437500005
								],
								[
									-131.48173828125,
									55.035253906250034
								],
								[
									-131.54003906249997,
									55.04848632812505
								],
								[
									-131.59223632812504,
									55.025683593750045
								],
								[
									-131.5951171875,
									55.090722656249966
								],
								[
									-131.55600585937503,
									55.13740234375007
								],
								[
									-131.57783203125,
									55.20083007812511
								],
								[
									-131.57846679687498,
									55.248779296875114
								],
								[
									-131.5654296875,
									55.26411132812504
								],
								[
									-131.51264648437498,
									55.26274414062502
								],
								[
									-131.404638671875,
									55.21333007812498
								],
								[
									-131.33974609375002,
									55.07983398437506
								]
							]
						],
						[
							[
								[
									-159.87299804687495,
									55.12875976562506
								],
								[
									-159.93393554687503,
									55.10683593750005
								],
								[
									-159.953076171875,
									55.07895507812506
								],
								[
									-159.99941406249997,
									55.06718749999996
								],
								[
									-160.038427734375,
									55.04448242187496
								],
								[
									-160.169580078125,
									54.941699218750074
								],
								[
									-160.22705078125,
									54.92270507812512
								],
								[
									-160.16357421875,
									55.010449218749955
								],
								[
									-160.15361328125005,
									55.03833007812494
								],
								[
									-160.15239257812496,
									55.056884765625
								],
								[
									-160.17207031249995,
									55.12304687499997
								],
								[
									-160.13374023437498,
									55.12016601562502
								],
								[
									-160.10219726562502,
									55.13388671875006
								],
								[
									-160.03876953125,
									55.19252929687511
								],
								[
									-159.98164062499998,
									55.197753906250085
								],
								[
									-159.92045898437496,
									55.267529296874926
								],
								[
									-159.88735351562497,
									55.272998046875074
								],
								[
									-159.871044921875,
									55.26357421875011
								],
								[
									-159.89824218749996,
									55.221289062500006
								],
								[
									-159.83940429687496,
									55.182373046875085
								],
								[
									-159.85410156250003,
									55.14467773437494
								],
								[
									-159.87299804687495,
									55.12875976562506
								]
							]
						],
						[
							[
								[
									-132.86225585937504,
									54.89443359374994
								],
								[
									-132.83774414062503,
									54.88095703124995
								],
								[
									-132.81289062500002,
									54.89042968750002
								],
								[
									-132.77231445312503,
									54.92607421874999
								],
								[
									-132.70063476562498,
									54.91904296874998
								],
								[
									-132.648876953125,
									54.907080078125034
								],
								[
									-132.61723632812496,
									54.89243164062498
								],
								[
									-132.634033203125,
									54.840478515624966
								],
								[
									-132.64697265624997,
									54.75615234375002
								],
								[
									-132.67666015624997,
									54.72622070312505
								],
								[
									-132.70581054687497,
									54.684179687500006
								],
								[
									-132.80727539062502,
									54.70913085937494
								],
								[
									-132.889599609375,
									54.76264648437501
								],
								[
									-133.008935546875,
									54.854833984375034
								],
								[
									-133.07539062500004,
									54.92133789062501
								],
								[
									-133.08056640625003,
									54.949414062499955
								],
								[
									-133.122705078125,
									54.96982421875012
								],
								[
									-133.204638671875,
									55.08447265625003
								],
								[
									-133.25117187500007,
									55.17514648437512
								],
								[
									-133.32485351562497,
									55.1854980468751
								],
								[
									-133.41796875,
									55.21069335937506
								],
								[
									-133.45380859375004,
									55.26035156250006
								],
								[
									-133.42905273437498,
									55.303808593750034
								],
								[
									-133.29658203124998,
									55.325732421875045
								],
								[
									-133.097412109375,
									55.21372070312498
								],
								[
									-133.06708984375,
									55.16621093750007
								],
								[
									-132.99575195312497,
									55.110595703125114
								],
								[
									-132.98217773437494,
									55.03300781249993
								],
								[
									-132.94599609375007,
									55.00258789062505
								],
								[
									-132.86225585937504,
									54.89443359374994
								]
							]
						],
						[
							[
								[
									-160.329296875,
									55.3376953125001
								],
								[
									-160.34331054687493,
									55.258789062500085
								],
								[
									-160.48076171875,
									55.30898437500002
								],
								[
									-160.51748046875,
									55.33383789062512
								],
								[
									-160.49291992187497,
									55.352343750000074
								],
								[
									-160.3623046875,
									55.35698242187502
								],
								[
									-160.329296875,
									55.3376953125001
								]
							]
						],
						[
							[
								[
									-160.684912109375,
									55.31479492187506
								],
								[
									-160.66972656250002,
									55.31425781250002
								],
								[
									-160.63881835937502,
									55.321923828124994
								],
								[
									-160.57397460937494,
									55.37827148437509
								],
								[
									-160.552783203125,
									55.38076171875008
								],
								[
									-160.55249023437503,
									55.36337890625009
								],
								[
									-160.58315429687497,
									55.307617187500085
								],
								[
									-160.53120117187504,
									55.233203125000045
								],
								[
									-160.482666015625,
									55.19741210937494
								],
								[
									-160.48754882812503,
									55.18486328124996
								],
								[
									-160.60908203125,
									55.15903320312512
								],
								[
									-160.70180664062497,
									55.177636718749994
								],
								[
									-160.75063476562497,
									55.17119140625002
								],
								[
									-160.79506835937497,
									55.14521484375004
								],
								[
									-160.82548828124993,
									55.17397460937505
								],
								[
									-160.84653320312498,
									55.31132812499996
								],
								[
									-160.8396484375,
									55.33540039062498
								],
								[
									-160.78920898437502,
									55.38310546874993
								],
								[
									-160.72392578124996,
									55.40463867187506
								],
								[
									-160.69565429687498,
									55.39833984375002
								],
								[
									-160.67216796875,
									55.37939453124997
								],
								[
									-160.66635742187503,
									55.35942382812499
								],
								[
									-160.684912109375,
									55.31479492187506
								]
							]
						],
						[
							[
								[
									-133.30507812500002,
									55.543750000000074
								],
								[
									-133.283203125,
									55.515625000000114
								],
								[
									-133.28168945312507,
									55.497851562500045
								],
								[
									-133.42646484374995,
									55.43144531250002
								],
								[
									-133.42910156249997,
									55.41772460937497
								],
								[
									-133.46308593749995,
									55.376660156249955
								],
								[
									-133.49345703125005,
									55.361669921875006
								],
								[
									-133.54736328125,
									55.31723632812509
								],
								[
									-133.6501953125,
									55.269287109375114
								],
								[
									-133.635009765625,
									55.41333007812506
								],
								[
									-133.73710937500002,
									55.496923828125034
								],
								[
									-133.634228515625,
									55.53925781250004
								],
								[
									-133.56669921875005,
									55.52719726562498
								],
								[
									-133.45478515624995,
									55.52231445312506
								],
								[
									-133.345556640625,
									55.559082031250085
								],
								[
									-133.30507812500002,
									55.543750000000074
								]
							]
						],
						[
							[
								[
									-155.56601562500003,
									55.82119140625011
								],
								[
									-155.60488281249997,
									55.78955078125006
								],
								[
									-155.680615234375,
									55.79184570312498
								],
								[
									-155.723193359375,
									55.802197265624955
								],
								[
									-155.73735351562496,
									55.82978515624998
								],
								[
									-155.62060546874997,
									55.913085937500085
								],
								[
									-155.59394531250007,
									55.92431640624997
								],
								[
									-155.5732421875,
									55.92109375000001
								],
								[
									-155.56391601562495,
									55.88666992187504
								],
								[
									-155.56601562500003,
									55.82119140625011
								]
							]
						],
						[
							[
								[
									-130.97915039062502,
									55.48916015625005
								],
								[
									-131.013916015625,
									55.37929687500005
								],
								[
									-131.082763671875,
									55.266796874999955
								],
								[
									-131.187890625,
									55.20629882812497
								],
								[
									-131.26186523437497,
									55.21977539062496
								],
								[
									-131.31630859374997,
									55.26850585937504
								],
								[
									-131.36684570312502,
									55.265820312499926
								],
								[
									-131.420703125,
									55.27587890625003
								],
								[
									-131.45092773437503,
									55.31630859375008
								],
								[
									-131.42236328124997,
									55.36840820312506
								],
								[
									-131.44755859374996,
									55.40878906250009
								],
								[
									-131.47451171875002,
									55.373486328124926
								],
								[
									-131.52182617187498,
									55.341064453125085
								],
								[
									-131.64130859375,
									55.29892578125009
								],
								[
									-131.723681640625,
									55.218359375000034
								],
								[
									-131.7625,
									55.16582031249999
								],
								[
									-131.810986328125,
									55.223095703124926
								],
								[
									-131.8419921875,
									55.35869140624993
								],
								[
									-131.84609374999997,
									55.41625976562503
								],
								[
									-131.75947265625,
									55.50307617187505
								],
								[
									-131.64755859375003,
									55.58554687500006
								],
								[
									-131.62495117187504,
									55.83168945312502
								],
								[
									-131.26923828125004,
									55.95537109374999
								],
								[
									-131.23618164062498,
									55.948974609375114
								],
								[
									-131.120654296875,
									55.85664062500004
								],
								[
									-130.997802734375,
									55.727636718750034
								],
								[
									-130.965966796875,
									55.66953125000012
								],
								[
									-130.96503906249998,
									55.56801757812502
								],
								[
									-130.97915039062502,
									55.48916015625005
								]
							]
						],
						[
							[
								[
									-133.56611328125,
									56.339208984375034
								],
								[
									-133.37661132812502,
									56.31777343750011
								],
								[
									-133.202978515625,
									56.319824218750085
								],
								[
									-133.14370117187502,
									56.278564453125114
								],
								[
									-133.1044921875,
									56.23510742187506
								],
								[
									-133.08173828125,
									56.19418945312506
								],
								[
									-133.07543945312494,
									56.15585937499998
								],
								[
									-133.08012695312502,
									56.128710937500045
								],
								[
									-133.10122070312497,
									56.099804687499926
								],
								[
									-133.096630859375,
									56.09003906249998
								],
								[
									-132.75756835937503,
									55.99501953125008
								],
								[
									-132.59760742187504,
									55.89501953125003
								],
								[
									-132.5337890625,
									55.8424804687501
								],
								[
									-132.49697265624997,
									55.798095703125114
								],
								[
									-132.43017578125006,
									55.68701171874994
								],
								[
									-132.28886718750005,
									55.55810546874997
								],
								[
									-132.21474609375002,
									55.51884765624996
								],
								[
									-132.17270507812498,
									55.480615234374994
								],
								[
									-132.196337890625,
									55.47915039062505
								],
								[
									-132.29589843750006,
									55.50747070312505
								],
								[
									-132.51127929687493,
									55.59394531249998
								],
								[
									-132.528857421875,
									55.590478515624994
								],
								[
									-132.54833984375006,
									55.54370117187506
								],
								[
									-132.58173828125,
									55.50263671875004
								],
								[
									-132.63129882812498,
									55.47319335937499
								],
								[
									-132.5916015625,
									55.46435546875006
								],
								[
									-132.41787109375002,
									55.482910156250114
								],
								[
									-132.272021484375,
									55.39863281249998
								],
								[
									-132.21528320312504,
									55.38354492187503
								],
								[
									-132.16025390625003,
									55.32299804687494
								],
								[
									-132.1583984375,
									55.299804687500114
								],
								[
									-132.19042968749994,
									55.254980468750034
								],
								[
									-132.21489257812496,
									55.23676757812504
								],
								[
									-132.20668945312497,
									55.22441406249993
								],
								[
									-132.16596679687504,
									55.21801757812506
								],
								[
									-132.005078125,
									55.23061523437505
								],
								[
									-131.97641601562498,
									55.20859375000009
								],
								[
									-132.00039062499997,
									55.03383789062511
								],
								[
									-131.97758789062505,
									54.96948242187506
								],
								[
									-131.97792968750002,
									54.940234375000045
								],
								[
									-131.99658203125,
									54.901416015625045
								],
								[
									-131.99721679687502,
									54.86860351562501
								],
								[
									-131.98271484375,
									54.83491210937498
								],
								[
									-131.98085937499997,
									54.80483398437508
								],
								[
									-132.02167968750004,
									54.72631835937497
								],
								[
									-132.06474609375002,
									54.71313476562506
								],
								[
									-132.134326171875,
									54.71254882812511
								],
								[
									-132.1892578125,
									54.73486328124994
								],
								[
									-132.26630859375007,
									54.802343750000006
								],
								[
									-132.34130859374994,
									54.90722656249997
								],
								[
									-132.37021484374998,
									54.922216796875006
								],
								[
									-132.46865234374997,
									54.937939453124926
								],
								[
									-132.48647460937497,
									54.95039062500007
								],
								[
									-132.549365234375,
									54.95258789062507
								],
								[
									-132.59384765624998,
									54.99575195312508
								],
								[
									-132.58847656250003,
									55.05234375000006
								],
								[
									-132.626953125,
									55.1100585937501
								],
								[
									-132.62216796874998,
									55.13593750000004
								],
								[
									-132.66533203125,
									55.14677734375002
								],
								[
									-132.70175781250003,
									55.13051757812508
								],
								[
									-132.682861328125,
									55.07392578125001
								],
								[
									-132.704150390625,
									55.030078125000045
								],
								[
									-132.78232421875003,
									55.04848632812505
								],
								[
									-132.91259765625,
									55.188476562500085
								],
								[
									-133.06059570312493,
									55.30092773437508
								],
								[
									-133.11855468750002,
									55.32763671875
								],
								[
									-133.10302734375,
									55.36025390625008
								],
								[
									-133.03002929687503,
									55.37753906249995
								],
								[
									-132.97080078125003,
									55.37617187500004
								],
								[
									-132.95888671875002,
									55.395556640625074
								],
								[
									-133.08247070312495,
									55.50410156249998
								],
								[
									-133.07841796875005,
									55.53491210937503
								],
								[
									-133.0333984375,
									55.589697265625006
								],
								[
									-133.0896484375,
									55.612597656250045
								],
								[
									-133.24374999999998,
									55.595410156249926
								],
								[
									-133.29824218749997,
									55.606884765624955
								],
								[
									-133.342822265625,
									55.65083007812504
								],
								[
									-133.36899414062498,
									55.688964843750085
								],
								[
									-133.50273437499996,
									55.69589843749998
								],
								[
									-133.55327148437496,
									55.691162109375085
								],
								[
									-133.64047851562498,
									55.748779296875
								],
								[
									-133.68017578124997,
									55.78515625000003
								],
								[
									-133.66440429687503,
									55.80380859375012
								],
								[
									-133.58408203125003,
									55.83652343750012
								],
								[
									-133.53715820312496,
									55.83193359375008
								],
								[
									-133.44697265624995,
									55.797021484374966
								],
								[
									-133.41171874999998,
									55.79833984374997
								],
								[
									-133.32211914062503,
									55.84462890625008
								],
								[
									-133.30849609375002,
									55.886474609375085
								],
								[
									-133.24150390624993,
									55.920800781249966
								],
								[
									-133.25214843749998,
									55.957080078125074
								],
								[
									-133.28920898437497,
									56.01870117187511
								],
								[
									-133.371240234375,
									56.03588867187506
								],
								[
									-133.538623046875,
									55.99926757812506
								],
								[
									-133.684228515625,
									55.942773437499994
								],
								[
									-133.74252929687498,
									55.96484375000006
								],
								[
									-133.75517578125,
									55.9994628906251
								],
								[
									-133.59921874999998,
									56.09365234375011
								],
								[
									-133.530859375,
									56.14565429687494
								],
								[
									-133.54409179687497,
									56.176513671875114
								],
								[
									-133.59443359375,
									56.21635742187496
								],
								[
									-133.59863281249994,
									56.31625976562506
								],
								[
									-133.56611328125,
									56.339208984375034
								]
							]
						],
						[
							[
								[
									-132.77988281249998,
									56.24726562500004
								],
								[
									-132.83095703124997,
									56.24414062500003
								],
								[
									-132.89145507812503,
									56.25942382812494
								],
								[
									-133.03500976562498,
									56.34091796875012
								],
								[
									-133.037646484375,
									56.364843750000006
								],
								[
									-133.01708984374997,
									56.39199218750002
								],
								[
									-132.93549804687504,
									56.441796874999966
								],
								[
									-132.90205078124998,
									56.45375976562511
								],
								[
									-132.7060546875,
									56.448486328125
								],
								[
									-132.64335937499993,
									56.43515624999995
								],
								[
									-132.62910156249995,
									56.4119140625001
								],
								[
									-132.632275390625,
									56.38828125000009
								],
								[
									-132.65283203125,
									56.36435546875009
								],
								[
									-132.657568359375,
									56.339306640624955
								],
								[
									-132.64658203124998,
									56.31318359375007
								],
								[
									-132.669384765625,
									56.28730468750001
								],
								[
									-132.77988281249998,
									56.24726562500004
								]
							]
						],
						[
							[
								[
									-132.11235351562493,
									56.109375000000114
								],
								[
									-132.13295898437497,
									55.94326171875011
								],
								[
									-132.17260742187497,
									55.95263671875006
								],
								[
									-132.210302734375,
									55.95297851562495
								],
								[
									-132.28730468749995,
									55.92939453125004
								],
								[
									-132.368603515625,
									55.9397460937501
								],
								[
									-132.40659179687503,
									55.95820312500004
								],
								[
									-132.42060546875004,
									55.97954101562502
								],
								[
									-132.4060546875,
									56.028857421875045
								],
								[
									-132.45117187499994,
									56.056347656249955
								],
								[
									-132.60297851562498,
									56.06640625000006
								],
								[
									-132.65991210937503,
									56.07817382812496
								],
								[
									-132.69135742187504,
									56.13007812500007
								],
								[
									-132.6990234375,
									56.19819335937498
								],
								[
									-132.67519531249997,
									56.223632812500114
								],
								[
									-132.59873046875,
									56.241650390624955
								],
								[
									-132.539013671875,
									56.32416992187498
								],
								[
									-132.50595703125003,
									56.33525390624993
								],
								[
									-132.379833984375,
									56.49877929687494
								],
								[
									-132.31650390624998,
									56.487499999999955
								],
								[
									-132.20561523437505,
									56.387939453125085
								],
								[
									-132.06689453125,
									56.24423828124995
								],
								[
									-132.11235351562493,
									56.109375000000114
								]
							]
						],
						[
							[
								[
									-154.68281249999995,
									56.435791015625085
								],
								[
									-154.75122070312494,
									56.412158203125045
								],
								[
									-154.77392578124997,
									56.42026367187512
								],
								[
									-154.7771484375,
									56.43989257812501
								],
								[
									-154.76093749999998,
									56.4711425781251
								],
								[
									-154.72934570312503,
									56.50214843750001
								],
								[
									-154.62373046875,
									56.561328125000074
								],
								[
									-154.51752929687504,
									56.60053710937507
								],
								[
									-154.46337890625003,
									56.598193359375045
								],
								[
									-154.444873046875,
									56.5731933593751
								],
								[
									-154.511181640625,
									56.52143554687504
								],
								[
									-154.68281249999995,
									56.435791015625085
								]
							]
						],
						[
							[
								[
									-154.208642578125,
									56.51489257812503
								],
								[
									-154.2578125,
									56.51269531250003
								],
								[
									-154.33212890625003,
									56.53901367187507
								],
								[
									-154.32221679687504,
									56.5706054687501
								],
								[
									-154.21674804687507,
									56.60874023437506
								],
								[
									-154.110400390625,
									56.60292968750002
								],
								[
									-154.10224609375,
									56.58164062499995
								],
								[
									-154.10717773437503,
									56.55781250000007
								],
								[
									-154.11596679687506,
									56.54389648437498
								],
								[
									-154.14980468750002,
									56.5295898437501
								],
								[
									-154.208642578125,
									56.51489257812503
								]
							]
						],
						[
							[
								[
									-169.755224609375,
									56.63505859374999
								],
								[
									-169.62392578125,
									56.61513671875002
								],
								[
									-169.55048828125004,
									56.6281250000001
								],
								[
									-169.48569335937498,
									56.61772460937502
								],
								[
									-169.47431640624998,
									56.59404296874999
								],
								[
									-169.586865234375,
									56.542431640624955
								],
								[
									-169.6326171875,
									56.545703125000074
								],
								[
									-169.76616210937502,
									56.607958984375074
								],
								[
									-169.755224609375,
									56.63505859374999
								]
							]
						],
						[
							[
								[
									-132.746875,
									56.5256835937501
								],
								[
									-132.75761718749996,
									56.511035156250045
								],
								[
									-132.884716796875,
									56.51245117187497
								],
								[
									-132.93081054687497,
									56.52446289062493
								],
								[
									-132.94804687500005,
									56.567236328125034
								],
								[
									-132.93623046875,
									56.60683593750002
								],
								[
									-132.90654296875,
									56.63740234375004
								],
								[
									-132.870654296875,
									56.69638671875006
								],
								[
									-132.84252929687503,
									56.79477539062512
								],
								[
									-132.655859375,
									56.68471679687508
								],
								[
									-132.598681640625,
									56.63574218750006
								],
								[
									-132.56796875000003,
									56.57583007812511
								],
								[
									-132.63422851562504,
									56.55346679687506
								],
								[
									-132.71445312500003,
									56.542529296875074
								],
								[
									-132.746875,
									56.5256835937501
								]
							]
						],
						[
							[
								[
									-133.98959960937503,
									56.84497070312494
								],
								[
									-133.92480468749997,
									56.775683593750045
								],
								[
									-133.83085937500002,
									56.781298828125045
								],
								[
									-133.77812500000005,
									56.72890625000002
								],
								[
									-133.73837890625,
									56.65043945312493
								],
								[
									-133.76728515625004,
									56.60009765624997
								],
								[
									-133.809033203125,
									56.61132812500006
								],
								[
									-133.85527343750002,
									56.582177734374966
								],
								[
									-133.88359375000002,
									56.48549804687508
								],
								[
									-133.870458984375,
									56.38867187500006
								],
								[
									-133.88461914062498,
									56.29213867187494
								],
								[
									-133.93852539062502,
									56.193652343750045
								],
								[
									-133.94970703125,
									56.12773437499993
								],
								[
									-133.97080078125003,
									56.10791015625006
								],
								[
									-133.99399414062503,
									56.10112304687493
								],
								[
									-134.02402343750003,
									56.11899414062512
								],
								[
									-134.06748046875,
									56.13300781250004
								],
								[
									-134.122412109375,
									56.07739257812506
								],
								[
									-134.18959960937502,
									56.076953125000074
								],
								[
									-134.245068359375,
									56.20327148437505
								],
								[
									-134.19545898437497,
									56.41352539062498
								],
								[
									-134.08437499999997,
									56.4563476562501
								],
								[
									-134.15048828125003,
									56.5134765625001
								],
								[
									-134.290234375,
									56.58002929687507
								],
								[
									-134.278369140625,
									56.61708984375005
								],
								[
									-134.384423828125,
									56.724023437499994
								],
								[
									-134.390625,
									56.74946289062504
								],
								[
									-134.37368164062502,
									56.838671875000074
								],
								[
									-134.27441406249997,
									56.91816406250004
								],
								[
									-134.14326171874998,
									56.93232421874998
								],
								[
									-134.051806640625,
									56.89829101562498
								],
								[
									-134.00058593749998,
									56.869189453125074
								],
								[
									-133.98959960937503,
									56.84497070312494
								]
							]
						],
						[
							[
								[
									-133.36621093750006,
									57.003515625000006
								],
								[
									-133.29970703125,
									56.972167968750114
								],
								[
									-133.26352539062498,
									57.00498046874995
								],
								[
									-133.19599609375,
									57.003466796875074
								],
								[
									-133.07080078125,
									56.974267578124994
								],
								[
									-132.99624023437497,
									56.93041992187494
								],
								[
									-132.95415039062505,
									56.88027343750002
								],
								[
									-132.95058593750002,
									56.85043945312509
								],
								[
									-132.963330078125,
									56.78256835937512
								],
								[
									-132.95400390625,
									56.71308593750007
								],
								[
									-132.95917968749998,
									56.67705078124993
								],
								[
									-132.97587890625002,
									56.64726562499999
								],
								[
									-133.00410156249998,
									56.6237304687501
								],
								[
									-133.03491210937494,
									56.62075195312511
								],
								[
									-133.132373046875,
									56.68325195312505
								],
								[
									-133.243994140625,
									56.79584960937507
								],
								[
									-133.328955078125,
									56.83007812500003
								],
								[
									-133.332421875,
									56.81850585937505
								],
								[
									-133.30908203125006,
									56.78623046875006
								],
								[
									-133.239697265625,
									56.72568359374998
								],
								[
									-133.22724609374995,
									56.68925781249993
								],
								[
									-133.178466796875,
									56.64482421875002
								],
								[
									-133.15664062499997,
									56.6111328125001
								],
								[
									-133.14423828125,
									56.56689453125006
								],
								[
									-133.14472656250004,
									56.52822265625008
								],
								[
									-133.158154296875,
									56.4951660156251
								],
								[
									-133.18081054687502,
									56.47397460937495
								],
								[
									-133.212646484375,
									56.464599609375085
								],
								[
									-133.38276367187504,
									56.473876953125114
								],
								[
									-133.4841796875,
									56.45175781249995
								],
								[
									-133.602783203125,
									56.464111328125085
								],
								[
									-133.63134765624997,
									56.48403320312505
								],
								[
									-133.64926757812498,
									56.51679687500007
								],
								[
									-133.65830078125003,
									56.59628906250009
								],
								[
									-133.68818359375,
									56.71000976562499
								],
								[
									-133.68095703124993,
									56.79750976562505
								],
								[
									-133.75751953125,
									56.87666015625001
								],
								[
									-133.82304687500005,
									56.92436523437496
								],
								[
									-133.91728515624996,
									56.96708984374996
								],
								[
									-133.979443359375,
									57.009570312500074
								],
								[
									-133.96235351562498,
									57.04345703124997
								],
								[
									-133.865966796875,
									57.06870117187506
								],
								[
									-133.70771484374998,
									57.06284179687509
								],
								[
									-133.36621093750006,
									57.003515625000006
								]
							]
						],
						[
							[
								[
									-153.007080078125,
									57.12485351562495
								],
								[
									-153.13422851562507,
									57.092578125000045
								],
								[
									-153.15683593750003,
									57.093945312499955
								],
								[
									-153.23540039062496,
									57.028613281250045
								],
								[
									-153.29541015625003,
									57.0004394531251
								],
								[
									-153.37460937499998,
									57.05190429687511
								],
								[
									-153.35434570312503,
									57.13193359375006
								],
								[
									-153.285205078125,
									57.18505859375006
								],
								[
									-152.93544921874997,
									57.16733398437506
								],
								[
									-152.90839843750007,
									57.15244140625006
								],
								[
									-152.907763671875,
									57.13974609375006
								],
								[
									-152.933447265625,
									57.12924804687495
								],
								[
									-153.007080078125,
									57.12485351562495
								]
							]
						],
						[
							[
								[
									-170.160546875,
									57.18393554687509
								],
								[
									-170.264013671875,
									57.136767578125074
								],
								[
									-170.35800781249998,
									57.15419921875005
								],
								[
									-170.38588867187497,
									57.18857421875006
								],
								[
									-170.38662109375002,
									57.20302734375005
								],
								[
									-170.116162109375,
									57.24179687500006
								],
								[
									-170.160546875,
									57.18393554687509
								]
							]
						],
						[
							[
								[
									-134.969775390625,
									57.351416015625006
								],
								[
									-134.88486328124998,
									57.24169921874994
								],
								[
									-134.82319335937504,
									57.1565429687501
								],
								[
									-134.768505859375,
									57.05419921874994
								],
								[
									-134.67685546874998,
									56.84228515625003
								],
								[
									-134.63408203125,
									56.76210937499994
								],
								[
									-134.62070312499998,
									56.71831054687499
								],
								[
									-134.61054687499995,
									56.60341796874994
								],
								[
									-134.62431640625002,
									56.57871093750006
								],
								[
									-134.651708984375,
									56.55605468750005
								],
								[
									-134.65708007812503,
									56.523242187500045
								],
								[
									-134.63168945312503,
									56.435644531250034
								],
								[
									-134.63002929687502,
									56.3024414062501
								],
								[
									-134.65400390625,
									56.22749023437501
								],
								[
									-134.68188476562503,
									56.216162109375006
								],
								[
									-134.75029296875002,
									56.24077148437496
								],
								[
									-134.8064453125,
									56.28124999999994
								],
								[
									-134.84799804687503,
									56.32348632812503
								],
								[
									-134.95014648437495,
									56.45683593750002
								],
								[
									-134.98056640625003,
									56.518945312499966
								],
								[
									-134.98242187499997,
									56.56362304687511
								],
								[
									-134.96665039062503,
									56.59614257812507
								],
								[
									-134.93320312499998,
									56.61635742187508
								],
								[
									-134.87509765625003,
									56.67045898437502
								],
								[
									-134.88344726562497,
									56.67905273437506
								],
								[
									-134.92758789062498,
									56.666992187500114
								],
								[
									-135.017822265625,
									56.66015625000006
								],
								[
									-135.09716796875,
									56.70283203125004
								],
								[
									-135.15903320312498,
									56.72539062500002
								],
								[
									-135.14658203125003,
									56.80234375000006
								],
								[
									-135.16313476562502,
									56.824121093749966
								],
								[
									-135.28481445312502,
									56.8003417968751
								],
								[
									-135.33061523437505,
									56.82187499999995
								],
								[
									-135.34062500000005,
									56.85078125000007
								],
								[
									-135.33837890625,
									56.89399414062498
								],
								[
									-135.31513671874998,
									56.93183593750007
								],
								[
									-135.19960937499997,
									57.02734374999997
								],
								[
									-135.21123046874996,
									57.044921875
								],
								[
									-135.26738281250005,
									57.04887695312502
								],
								[
									-135.341357421875,
									57.08159179687502
								],
								[
									-135.37529296875,
									57.188427734374926
								],
								[
									-135.45493164062503,
									57.24941406250011
								],
								[
									-135.50195312500003,
									57.24384765625004
								],
								[
									-135.608935546875,
									57.07143554687508
								],
								[
									-135.661865234375,
									57.033740234375045
								],
								[
									-135.81230468750002,
									57.009521484375085
								],
								[
									-135.781640625,
									57.057519531249994
								],
								[
									-135.767724609375,
									57.10039062499993
								],
								[
									-135.82114257812503,
									57.230419921874955
								],
								[
									-135.82275390625,
									57.28041992187502
								],
								[
									-135.78710937500006,
									57.31728515625008
								],
								[
									-135.680908203125,
									57.33256835937499
								],
								[
									-135.62451171875006,
									57.354394531249994
								],
								[
									-135.58056640624997,
									57.38999023437506
								],
								[
									-135.56962890624996,
									57.42470703125002
								],
								[
									-135.48730468749997,
									57.51650390625008
								],
								[
									-135.448681640625,
									57.53437500000007
								],
								[
									-135.34628906250003,
									57.53310546875008
								],
								[
									-135.1306640625,
									57.431640625000085
								],
								[
									-135.06523437499996,
									57.41669921874998
								],
								[
									-134.969775390625,
									57.351416015625006
								]
							]
						],
						[
							[
								[
									-153.24062499999997,
									57.850097656250085
								],
								[
									-153.26855468749997,
									57.822363281250034
								],
								[
									-153.29497070312502,
									57.829492187499966
								],
								[
									-153.35083007812503,
									57.86196289062511
								],
								[
									-153.4650390625,
									57.90937500000007
								],
								[
									-153.51708984374997,
									57.94189453125006
								],
								[
									-153.52006835937496,
									57.95576171875004
								],
								[
									-153.4810546875,
									57.971044921875034
								],
								[
									-153.34697265624996,
									57.93281250000007
								],
								[
									-153.2900390625,
									57.89790039062504
								],
								[
									-153.24062499999997,
									57.850097656250085
								]
							]
						],
						[
							[
								[
									-152.89804687499998,
									57.82392578125007
								],
								[
									-152.8908203125,
									57.76899414062507
								],
								[
									-152.850146484375,
									57.77568359374993
								],
								[
									-152.696240234375,
									57.832275390625
								],
								[
									-152.616015625,
									57.848876953125114
								],
								[
									-152.51157226562503,
									57.85146484375011
								],
								[
									-152.42875976562493,
									57.825683593750085
								],
								[
									-152.4119140625,
									57.80590820312506
								],
								[
									-152.419140625,
									57.78232421874995
								],
								[
									-152.48540039062505,
									57.73442382812496
								],
								[
									-152.4826171875,
									57.70332031250001
								],
								[
									-152.41147460937498,
									57.64609375000009
								],
								[
									-152.23652343750004,
									57.61489257812505
								],
								[
									-152.21528320312495,
									57.5977050781251
								],
								[
									-152.21621093749997,
									57.577001953125034
								],
								[
									-152.336669921875,
									57.48222656250002
								],
								[
									-152.38085937499994,
									57.46010742187502
								],
								[
									-152.41220703125003,
									57.454785156249926
								],
								[
									-152.63095703125003,
									57.47182617187494
								],
								[
									-152.83115234375003,
									57.502880859374955
								],
								[
									-152.91215820312502,
									57.50815429687506
								],
								[
									-152.94077148437498,
									57.49809570312496
								],
								[
									-152.99746093749997,
									57.46894531250007
								],
								[
									-152.9568359375,
									57.460351562499994
								],
								[
									-152.78134765625,
									57.4534179687501
								],
								[
									-152.71953125000005,
									57.41083984375004
								],
								[
									-152.69252929687502,
									57.37958984375007
								],
								[
									-152.67905273437503,
									57.345117187499966
								],
								[
									-152.71406249999998,
									57.33095703125011
								],
								[
									-152.789111328125,
									57.320654296875034
								],
								[
									-152.87905273437502,
									57.320800781250085
								],
								[
									-152.99028320312493,
									57.281982421875085
								],
								[
									-153.051611328125,
									57.237646484375006
								],
								[
									-153.274365234375,
									57.22636718749993
								],
								[
									-153.44370117187503,
									57.167187499999955
								],
								[
									-153.50356445312497,
									57.13798828124996
								],
								[
									-153.52441406249994,
									57.103076171875045
								],
								[
									-153.58828125000002,
									57.07768554687493
								],
								[
									-153.732568359375,
									57.052343750000006
								],
								[
									-153.646533203125,
									57.02958984374999
								],
								[
									-153.63305664062497,
									57.01035156249998
								],
								[
									-153.6314453125,
									56.98369140624996
								],
								[
									-153.64331054687503,
									56.960742187500074
								],
								[
									-153.75722656249997,
									56.85834960937501
								],
								[
									-153.972705078125,
									56.77421875000002
								],
								[
									-154.02734375,
									56.77797851562508
								],
								[
									-154.05078125,
									56.78847656250008
								],
								[
									-154.07001953125,
									56.80454101562506
								],
								[
									-154.070849609375,
									56.82065429687506
								],
								[
									-153.793212890625,
									56.989501953125085
								],
								[
									-153.80419921875003,
									56.997802734375
								],
								[
									-153.87973632812498,
									57.003515625000006
								],
								[
									-153.99936523437498,
									57.049951171874966
								],
								[
									-154.08378906249996,
									57.0200683593751
								],
								[
									-154.10297851562495,
									57.02124023437497
								],
								[
									-154.08046875,
									57.06103515625
								],
								[
									-154.025439453125,
									57.10849609375009
								],
								[
									-154.03505859374997,
									57.12182617187503
								],
								[
									-154.06533203125002,
									57.133691406249966
								],
								[
									-154.13486328124998,
									57.140771484374994
								],
								[
									-154.24375000000003,
									57.14301757812501
								],
								[
									-154.32441406250007,
									57.13178710937504
								],
								[
									-154.37680664062498,
									57.107031250000034
								],
								[
									-154.38110351562494,
									57.09653320312495
								],
								[
									-154.26953124999997,
									57.09946289062509
								],
								[
									-154.239208984375,
									57.08686523437501
								],
								[
									-154.20913085937502,
									57.06333007812512
								],
								[
									-154.19082031250002,
									57.036132812500085
								],
								[
									-154.184326171875,
									57.005322265624926
								],
								[
									-154.20771484374998,
									56.9638183593751
								],
								[
									-154.2609375,
									56.911767578124966
								],
								[
									-154.33896484374998,
									56.92089843750006
								],
								[
									-154.49877929687494,
									57.03657226562507
								],
								[
									-154.56933593750003,
									57.205908203125034
								],
								[
									-154.70595703124997,
									57.33535156250002
								],
								[
									-154.71220703125,
									57.36625976562502
								],
								[
									-154.67319335937498,
									57.44609374999993
								],
								[
									-154.53530273437502,
									57.55942382812512
								],
								[
									-154.38706054687503,
									57.59047851562505
								],
								[
									-154.2814453125,
									57.638085937499966
								],
								[
									-154.17934570312497,
									57.65244140625006
								],
								[
									-154.11616210937498,
									57.65122070312498
								],
								[
									-154.029833984375,
									57.63071289062498
								],
								[
									-153.99501953125,
									57.58730468750011
								],
								[
									-154.015869140625,
									57.56689453124994
								],
								[
									-154.00791015624998,
									57.55615234374997
								],
								[
									-153.94736328124998,
									57.53007812499999
								],
								[
									-153.88188476562496,
									57.4390136718751
								],
								[
									-153.805419921875,
									57.358203125000045
								],
								[
									-153.75458984375004,
									57.32534179687494
								],
								[
									-153.6876953125,
									57.30512695312507
								],
								[
									-153.75693359374998,
									57.36684570312505
								],
								[
									-153.79780273437495,
									57.44326171875008
								],
								[
									-153.818359375,
									57.59560546875002
								],
								[
									-153.838134765625,
									57.63583984374995
								],
								[
									-153.79946289062497,
									57.64667968750004
								],
								[
									-153.69013671874995,
									57.64072265625006
								],
								[
									-153.69316406249996,
									57.66342773437498
								],
								[
									-153.80849609375002,
									57.71474609375005
								],
								[
									-153.879443359375,
									57.75717773437498
								],
								[
									-153.906103515625,
									57.790771484375085
								],
								[
									-153.90444335937502,
									57.81987304687496
								],
								[
									-153.841552734375,
									57.86284179687502
								],
								[
									-153.805810546875,
									57.87509765625012
								],
								[
									-153.76899414062507,
									57.88037109374994
								],
								[
									-153.69560546875002,
									57.87124023437505
								],
								[
									-153.66264648437496,
									57.857812499999966
								],
								[
									-153.56855468749998,
									57.76108398437498
								],
								[
									-153.524462890625,
									57.731005859375074
								],
								[
									-153.487939453125,
									57.73095703124997
								],
								[
									-153.454052734375,
									57.747021484374955
								],
								[
									-153.42270507812503,
									57.77915039062512
								],
								[
									-153.39042968750002,
									57.79838867187502
								],
								[
									-153.35712890624998,
									57.80468750000006
								],
								[
									-153.25239257812507,
									57.790478515624926
								],
								[
									-153.21748046875004,
									57.79575195312512
								],
								[
									-153.20029296875,
									57.8200195312501
								],
								[
									-153.20102539062498,
									57.863281250000114
								],
								[
									-153.17519531249997,
									57.87885742187507
								],
								[
									-153.16884765625,
									57.910644531250085
								],
								[
									-153.22592773437498,
									57.95761718750006
								],
								[
									-153.16044921875,
									57.971972656250045
								],
								[
									-152.94326171874997,
									57.93603515625
								],
								[
									-152.85039062499996,
									57.8967773437501
								],
								[
									-152.89804687499998,
									57.82392578125007
								]
							]
						],
						[
							[
								[
									-135.73037109375002,
									58.24423828125009
								],
								[
									-135.58749999999998,
									58.146777343750045
								],
								[
									-135.58627929687498,
									58.12441406250011
								],
								[
									-135.61538085937497,
									58.05747070312506
								],
								[
									-135.693115234375,
									58.038525390624926
								],
								[
									-135.67114257812506,
									58.01191406250001
								],
								[
									-135.61323242187507,
									57.99184570312511
								],
								[
									-135.572021484375,
									58.00854492187494
								],
								[
									-135.42119140625,
									58.10239257812506
								],
								[
									-135.37470703125004,
									58.12211914062499
								],
								[
									-135.346630859375,
									58.12412109374995
								],
								[
									-135.16284179687494,
									58.095849609374966
								],
								[
									-135.00209960937497,
									58.05107421874999
								],
								[
									-134.9546875,
									58.0153320312501
								],
								[
									-134.927978515625,
									57.95278320312505
								],
								[
									-134.97065429687495,
									57.81723632812506
								],
								[
									-135.10258789062505,
									57.793652343749955
								],
								[
									-135.16474609374998,
									57.79609375000001
								],
								[
									-135.23120117187503,
									57.81582031249994
								],
								[
									-135.33847656250003,
									57.768652343750006
								],
								[
									-135.24956054687493,
									57.73256835937494
								],
								[
									-134.97885742187503,
									57.72436523437506
								],
								[
									-134.896630859375,
									57.647998046875045
								],
								[
									-134.873095703125,
									57.589208984375034
								],
								[
									-134.93149414062498,
									57.48115234375007
								],
								[
									-135.08486328124997,
									57.51103515624993
								],
								[
									-135.22021484375,
									57.57363281250008
								],
								[
									-135.4978515625,
									57.66225585937511
								],
								[
									-135.564208984375,
									57.666406249999966
								],
								[
									-135.60854492187497,
									57.65073242187506
								],
								[
									-135.62065429687496,
									57.59697265625002
								],
								[
									-135.61782226562502,
									57.48037109375008
								],
								[
									-135.69194335937502,
									57.419921875000114
								],
								[
									-135.91079101562502,
									57.446582031250045
								],
								[
									-135.9966796875,
									57.53486328124998
								],
								[
									-136.07661132812504,
									57.67456054687503
								],
								[
									-136.37822265625005,
									57.83999023437508
								],
								[
									-136.45991210937495,
									57.873095703125074
								],
								[
									-136.568603515625,
									57.972167968750085
								],
								[
									-136.52509765625,
									58.050585937500074
								],
								[
									-136.51230468749998,
									58.095996093750074
								],
								[
									-136.45439453125,
									58.10800781249995
								],
								[
									-136.36953125000002,
									58.143066406250085
								],
								[
									-136.32197265625,
									58.21889648437508
								],
								[
									-136.24570312500003,
									58.157470703125
								],
								[
									-136.14375000000004,
									58.09848632812506
								],
								[
									-136.142333984375,
									58.15390624999998
								],
								[
									-136.09438476562502,
									58.19814453124994
								],
								[
									-135.994384765625,
									58.19653320312506
								],
								[
									-135.94741210937502,
									58.205810546875085
								],
								[
									-135.88173828124997,
									58.24716796874998
								],
								[
									-135.787060546875,
									58.26850585937507
								],
								[
									-135.73037109375002,
									58.24423828125009
								]
							]
						],
						[
							[
								[
									-134.31274414062494,
									58.22890625000008
								],
								[
									-134.319873046875,
									58.204101562500085
								],
								[
									-134.45624999999998,
									58.20654296875006
								],
								[
									-134.59399414062497,
									58.24311523437504
								],
								[
									-134.66157226562495,
									58.29091796875008
								],
								[
									-134.64799804687496,
									58.31240234374994
								],
								[
									-134.519970703125,
									58.33251953125003
								],
								[
									-134.398876953125,
									58.287207031250034
								],
								[
									-134.31274414062494,
									58.22890625000008
								]
							]
						],
						[
							[
								[
									-134.68027343749998,
									58.16166992187496
								],
								[
									-134.42612304687498,
									58.13881835937502
								],
								[
									-134.24008789062498,
									58.14399414062501
								],
								[
									-134.07016601562503,
									57.99453125000002
								],
								[
									-133.96552734375,
									57.87377929687503
								],
								[
									-133.90410156250002,
									57.78920898437494
								],
								[
									-133.86928710937502,
									57.707519531250085
								],
								[
									-133.82275390624997,
									57.628662109375
								],
								[
									-133.826904296875,
									57.617578124999966
								],
								[
									-133.925,
									57.670800781249966
								],
								[
									-133.995556640625,
									57.778466796874966
								],
								[
									-134.03164062499997,
									57.82060546874993
								],
								[
									-134.06723632812503,
									57.839599609375085
								],
								[
									-134.10473632812506,
									57.8793457031251
								],
								[
									-134.17753906249993,
									57.982177734375085
								],
								[
									-134.18027343749998,
									58.01113281249994
								],
								[
									-134.21259765624998,
									58.03793945312498
								],
								[
									-134.24995117187507,
									58.04916992187506
								],
								[
									-134.29233398437498,
									58.04472656250013
								],
								[
									-134.306884765625,
									58.03437500000007
								],
								[
									-134.30039062500003,
									57.96342773437499
								],
								[
									-134.26708984375,
									57.884521484375085
								],
								[
									-134.08369140625,
									57.71225585937498
								],
								[
									-133.9611328125,
									57.61416015625008
								],
								[
									-133.93701171874997,
									57.5815917968751
								],
								[
									-133.92084960937495,
									57.49199218749996
								],
								[
									-133.97373046874998,
									57.45136718750004
								],
								[
									-133.90883789062502,
									57.368701171875074
								],
								[
									-133.91113281250003,
									57.35253906249997
								],
								[
									-133.92529296875,
									57.33676757812495
								],
								[
									-134.10004882812495,
									57.300097656250045
								],
								[
									-134.26015625,
									57.146777343750074
								],
								[
									-134.43530273437497,
									57.05698242187498
								],
								[
									-134.51601562499997,
									57.04257812500006
								],
								[
									-134.55478515624998,
									57.05756835937501
								],
								[
									-134.59150390625,
									57.0919921875001
								],
								[
									-134.61308593749996,
									57.13793945312494
								],
								[
									-134.61953125000002,
									57.195507812499955
								],
								[
									-134.57587890625,
									57.23173828124996
								],
								[
									-134.489208984375,
									57.42016601562506
								],
								[
									-134.48676757812498,
									57.48203125000006
								],
								[
									-134.59482421874998,
									57.567822265624955
								],
								[
									-134.65986328124998,
									57.638085937499966
								],
								[
									-134.6951171875,
									57.73603515625004
								],
								[
									-134.7541015625,
									57.99501953124994
								],
								[
									-134.781494140625,
									58.07783203125004
								],
								[
									-134.82011718749993,
									58.146874999999966
								],
								[
									-134.86997070312498,
									58.20209960937504
								],
								[
									-134.907666015625,
									58.262792968750034
								],
								[
									-134.93310546874994,
									58.328955078125034
								],
								[
									-134.92348632812497,
									58.35463867187502
								],
								[
									-134.836962890625,
									58.320166015625006
								],
								[
									-134.733203125,
									58.22500000000008
								],
								[
									-134.68027343749998,
									58.16166992187496
								]
							]
						],
						[
							[
								[
									-152.416943359375,
									58.36020507812509
								],
								[
									-152.38076171875002,
									58.35209960937513
								],
								[
									-152.34301757812497,
									58.411621093750085
								],
								[
									-152.31625976562503,
									58.41347656250002
								],
								[
									-152.19794921875,
									58.36308593749996
								],
								[
									-152.125244140625,
									58.37426757812503
								],
								[
									-152.078515625,
									58.31235351562512
								],
								[
									-152.03662109375,
									58.30668945312502
								],
								[
									-151.99775390624998,
									58.31420898437503
								],
								[
									-151.974365234375,
									58.30986328124996
								],
								[
									-151.98251953124998,
									58.244335937499926
								],
								[
									-152.068896484375,
									58.17792968749998
								],
								[
									-152.10908203125,
									58.16113281249994
								],
								[
									-152.16547851562504,
									58.178271484375045
								],
								[
									-152.18652343749997,
									58.184667968750034
								],
								[
									-152.22358398437498,
									58.214013671874966
								],
								[
									-152.25166015625,
									58.25112304687508
								],
								[
									-152.26835937499993,
									58.251708984375085
								],
								[
									-152.334375,
									58.208056640625074
								],
								[
									-152.332666015625,
									58.18652343750006
								],
								[
									-152.305224609375,
									58.154052734375085
								],
								[
									-152.30922851562502,
									58.13388671875006
								],
								[
									-152.38115234375002,
									58.12426757812506
								],
								[
									-152.45161132812498,
									58.12924804687512
								],
								[
									-152.53764648437502,
									58.10097656249994
								],
								[
									-152.55820312500003,
									58.11860351562498
								],
								[
									-152.57133789062493,
									58.16821289062506
								],
								[
									-152.5982421875,
									58.16259765624997
								],
								[
									-152.63876953125,
									58.10180664062503
								],
								[
									-152.68305664062495,
									58.063330078125006
								],
								[
									-152.7638671875,
									58.03139648437508
								],
								[
									-152.78154296874996,
									58.0159179687501
								],
								[
									-152.84072265625002,
									58.01381835937505
								],
								[
									-152.92841796875004,
									57.99370117187502
								],
								[
									-152.98256835937497,
									57.9970703125
								],
								[
									-153.30546875000005,
									58.06308593749995
								],
								[
									-153.38134765625003,
									58.087207031250074
								],
								[
									-153.11582031250003,
									58.238525390625085
								],
								[
									-152.976123046875,
									58.29702148437508
								],
								[
									-152.89536132812498,
									58.29384765625008
								],
								[
									-152.81455078125003,
									58.275634765625
								],
								[
									-152.77187500000002,
									58.27856445312497
								],
								[
									-152.76870117187502,
									58.34560546875005
								],
								[
									-152.84394531249995,
									58.39560546875009
								],
								[
									-152.84111328125002,
									58.416406249999994
								],
								[
									-152.67465820312503,
									58.45058593749994
								],
								[
									-152.61230468750003,
									58.44570312500011
								],
								[
									-152.54355468749998,
									58.42817382812498
								],
								[
									-152.47846679687504,
									58.39970703124996
								],
								[
									-152.416943359375,
									58.36020507812509
								]
							]
						],
						[
							[
								[
									-152.486083984375,
									58.48500976562494
								],
								[
									-152.51552734375002,
									58.47861328125006
								],
								[
									-152.588623046875,
									58.50922851562498
								],
								[
									-152.63662109375002,
									58.54169921875001
								],
								[
									-152.60488281250002,
									58.56640625
								],
								[
									-152.46318359375005,
									58.61850585937495
								],
								[
									-152.3955078125,
									58.61938476562503
								],
								[
									-152.367919921875,
									58.61108398437494
								],
								[
									-152.35683593750002,
									58.59497070312503
								],
								[
									-152.36225585937498,
									58.57084960937502
								],
								[
									-152.392822265625,
									58.54086914062495
								],
								[
									-152.486083984375,
									58.48500976562494
								]
							]
						],
						[
							[
								[
									-160.918994140625,
									58.577099609374955
								],
								[
									-160.9923828125,
									58.56103515624997
								],
								[
									-161.070263671875,
									58.56914062500002
								],
								[
									-161.13149414062502,
									58.66821289062503
								],
								[
									-161.08457031249998,
									58.67128906250005
								],
								[
									-160.98623046875002,
									58.73642578125009
								],
								[
									-160.768603515625,
									58.789208984374994
								],
								[
									-160.71513671875005,
									58.795214843750074
								],
								[
									-160.918994140625,
									58.577099609374955
								]
							]
						],
						[
							[
								[
									-144.565625,
									59.818408203125074
								],
								[
									-144.61357421875002,
									59.81264648437505
								],
								[
									-144.541552734375,
									59.87822265624999
								],
								[
									-144.44492187500003,
									59.950683593750114
								],
								[
									-144.35395507812495,
									59.996191406250034
								],
								[
									-144.23574218749997,
									60.0151855468751
								],
								[
									-144.248974609375,
									59.98212890625001
								],
								[
									-144.40322265624997,
									59.92109375000001
								],
								[
									-144.565625,
									59.818408203125074
								]
							]
						],
						[
							[
								[
									-148.02177734375,
									60.06533203125011
								],
								[
									-148.074169921875,
									60.03471679687499
								],
								[
									-148.27187499999997,
									60.053271484375045
								],
								[
									-148.2306640625,
									60.11352539062497
								],
								[
									-148.07958984375006,
									60.15166015625002
								],
								[
									-147.91420898437502,
									60.0923339843751
								],
								[
									-148.02177734375,
									60.06533203125011
								]
							]
						],
						[
							[
								[
									-147.735888671875,
									59.813232421875085
								],
								[
									-147.84633789062502,
									59.798828125000085
								],
								[
									-147.87246093750002,
									59.82836914062506
								],
								[
									-147.81435546875002,
									59.90195312499995
								],
								[
									-147.76806640625,
									59.94374999999994
								],
								[
									-147.733642578125,
									59.953613281250085
								],
								[
									-147.60668945312497,
									60.03662109375003
								],
								[
									-147.46582031249994,
									60.09702148437498
								],
								[
									-147.3365234375,
									60.185351562500045
								],
								[
									-147.20522460937497,
									60.31132812500013
								],
								[
									-147.180859375,
									60.358251953125006
								],
								[
									-147.12001953125002,
									60.3630859375001
								],
								[
									-147.01987304687498,
									60.33222656250004
								],
								[
									-146.95786132812503,
									60.28886718749999
								],
								[
									-146.98671874999997,
									60.25434570312507
								],
								[
									-147.31845703124998,
									60.07529296875009
								],
								[
									-147.34633789062497,
									60.051953124999955
								],
								[
									-147.376513671875,
									59.9911621093751
								],
								[
									-147.40380859375003,
									59.96997070312494
								],
								[
									-147.44755859375,
									59.9602539062501
								],
								[
									-147.47939453124997,
									59.93369140625009
								],
								[
									-147.49931640624993,
									59.89018554687513
								],
								[
									-147.540234375,
									59.86752929687495
								],
								[
									-147.60205078125,
									59.86557617187509
								],
								[
									-147.64492187500002,
									59.85361328124995
								],
								[
									-147.66875,
									59.831542968750085
								],
								[
									-147.735888671875,
									59.813232421875085
								]
							]
						],
						[
							[
								[
									-166.13544921875,
									60.383544921875
								],
								[
									-166.04365234374995,
									60.333935546874926
								],
								[
									-165.994921875,
									60.33115234375006
								],
								[
									-165.84091796874998,
									60.346240234375045
								],
								[
									-165.78447265625002,
									60.33559570312508
								],
								[
									-165.72968750000004,
									60.314208984375
								],
								[
									-165.69580078124997,
									60.2815429687501
								],
								[
									-165.68935546875,
									60.22412109374994
								],
								[
									-165.71440429687496,
									60.17285156249997
								],
								[
									-165.70693359375002,
									60.1005859375
								],
								[
									-165.71235351562498,
									60.06933593749994
								],
								[
									-165.63056640625,
									60.02836914062513
								],
								[
									-165.60502929687496,
									59.972802734374994
								],
								[
									-165.59179687500003,
									59.9131347656251
								],
								[
									-165.76928710937503,
									59.89321289062494
								],
								[
									-165.94672851562504,
									59.89003906250008
								],
								[
									-166.09985351562497,
									59.84960937499994
								],
								[
									-166.13120117187503,
									59.81977539062498
								],
								[
									-166.10668945312503,
									59.77543945312502
								],
								[
									-166.14873046875,
									59.764111328124926
								],
								[
									-166.187548828125,
									59.77382812500005
								],
								[
									-166.26162109374997,
									59.81489257812507
								],
								[
									-166.34296875,
									59.834423828124955
								],
								[
									-166.62763671875,
									59.86464843750008
								],
								[
									-166.98505859375,
									59.98388671874994
								],
								[
									-167.13886718749998,
									60.008544921875085
								],
								[
									-167.2951171875,
									60.09570312500006
								],
								[
									-167.43642578125002,
									60.20664062500012
								],
								[
									-167.3443359375,
									60.224462890625006
								],
								[
									-167.25170898437497,
									60.233544921874994
								],
								[
									-166.836328125,
									60.2169921875001
								],
								[
									-166.78437499999998,
									60.29643554687502
								],
								[
									-166.73095703125,
									60.31625976562498
								],
								[
									-166.59897460937503,
									60.33876953124994
								],
								[
									-166.47568359374998,
									60.382763671874926
								],
								[
									-166.42036132812498,
									60.38168945312498
								],
								[
									-166.3638671875,
									60.364746093750085
								],
								[
									-166.24697265625,
									60.39116210937496
								],
								[
									-166.18496093749997,
									60.39677734375013
								],
								[
									-166.13544921875,
									60.383544921875
								]
							]
						],
						[
							[
								[
									-145.11850585937503,
									60.337109374999955
								],
								[
									-145.15048828124998,
									60.31264648437502
								],
								[
									-145.23764648437498,
									60.32133789062513
								],
								[
									-145.28427734374998,
									60.33681640625008
								],
								[
									-145.12812500000004,
									60.40112304687494
								],
								[
									-145.10244140624997,
									60.388232421875074
								],
								[
									-145.11850585937503,
									60.337109374999955
								]
							]
						],
						[
							[
								[
									-146.3939453125,
									60.44965820312507
								],
								[
									-146.37167968749998,
									60.42216796874996
								],
								[
									-146.17954101562503,
									60.428759765625074
								],
								[
									-146.12426757812503,
									60.42392578125006
								],
								[
									-146.10224609374998,
									60.411181640625045
								],
								[
									-146.12827148437498,
									60.39252929687507
								],
								[
									-146.20239257812494,
									60.36801757812495
								],
								[
									-146.419189453125,
									60.32504882812506
								],
								[
									-146.59531249999998,
									60.26845703125008
								],
								[
									-146.61831054687497,
									60.273681640625
								],
								[
									-146.65043945312505,
									60.335644531249926
								],
								[
									-146.6830078125,
									60.36069335937506
								],
								[
									-146.70288085937494,
									60.39560546874998
								],
								[
									-146.70253906249997,
									60.40854492187495
								],
								[
									-146.67026367187498,
									60.43261718750006
								],
								[
									-146.605908203125,
									60.46782226562513
								],
								[
									-146.56030273437494,
									60.48056640625006
								],
								[
									-146.3939453125,
									60.44965820312507
								]
							]
						],
						[
							[
								[
									-147.658251953125,
									60.45048828124996
								],
								[
									-147.65869140625,
									60.4241210937501
								],
								[
									-147.69003906249998,
									60.398876953124926
								],
								[
									-147.6599609375,
									60.35249023437498
								],
								[
									-147.71201171875003,
									60.27275390624999
								],
								[
									-147.73212890625004,
									60.222070312499966
								],
								[
									-147.75991210937502,
									60.19023437499996
								],
								[
									-147.787841796875,
									60.17792968750004
								],
								[
									-147.81582031250002,
									60.18515625000009
								],
								[
									-147.82167968749997,
									60.202734375000034
								],
								[
									-147.80527343750003,
									60.23066406250004
								],
								[
									-147.87133789062497,
									60.22978515625013
								],
								[
									-147.89145507812498,
									60.299414062500006
								],
								[
									-147.8548828125,
									60.321435546874966
								],
								[
									-147.84169921874997,
									60.3512695312501
								],
								[
									-147.83759765625,
									60.37128906250007
								],
								[
									-147.79453124999998,
									60.45986328125011
								],
								[
									-147.77915039062503,
									60.46606445312494
								],
								[
									-147.774169921875,
									60.444970703124994
								],
								[
									-147.76020507812498,
									60.438769531250074
								],
								[
									-147.73730468750003,
									60.44741210937505
								],
								[
									-147.70297851562498,
									60.486816406250085
								],
								[
									-147.68857421875003,
									60.491406249999955
								],
								[
									-147.658251953125,
									60.45048828124996
								]
							]
						],
						[
							[
								[
									-152.02075195312494,
									60.361718749999994
								],
								[
									-152.06904296875,
									60.358056640624966
								],
								[
									-152.00449218750003,
									60.40742187499998
								],
								[
									-151.95971679687494,
									60.50375976562498
								],
								[
									-151.8994140625,
									60.49038085937511
								],
								[
									-151.88730468750003,
									60.47270507812496
								],
								[
									-151.98691406249998,
									60.37397460937501
								],
								[
									-152.02075195312494,
									60.361718749999994
								]
							]
						],
						[
							[
								[
									-172.74223632812496,
									60.45737304687495
								],
								[
									-172.52607421874998,
									60.39174804687508
								],
								[
									-172.3875,
									60.3984863281251
								],
								[
									-172.27753906249998,
									60.34365234375005
								],
								[
									-172.23208007812497,
									60.29912109375013
								],
								[
									-172.39716796875,
									60.331103515625074
								],
								[
									-172.63574218750003,
									60.32885742187506
								],
								[
									-172.95839843749997,
									60.46279296875008
								],
								[
									-173.07402343749996,
									60.49321289062496
								],
								[
									-173.04765625000002,
									60.56831054687498
								],
								[
									-172.92387695312502,
									60.60683593750002
								],
								[
									-172.86020507812503,
									60.50566406250002
								],
								[
									-172.74223632812496,
									60.45737304687495
								]
							]
						],
						[
							[
								[
									-147.930712890625,
									60.82617187499994
								],
								[
									-148.05742187499996,
									60.81791992187513
								],
								[
									-148.11542968749995,
									60.83061523437496
								],
								[
									-148.123779296875,
									60.84433593750009
								],
								[
									-148.09970703124998,
									60.894824218750074
								],
								[
									-148.10166015625,
									60.91611328125006
								],
								[
									-148.03774414062497,
									60.924121093750074
								],
								[
									-147.96440429687502,
									60.900146484375
								],
								[
									-147.94311523437503,
									60.87539062500002
								],
								[
									-147.930712890625,
									60.82617187499994
								]
							]
						],
						[
							[
								[
									-171.46303710937497,
									63.640039062499966
								],
								[
									-171.44785156249998,
									63.61567382812498
								],
								[
									-171.34335937499998,
									63.619628906250085
								],
								[
									-171.196923828125,
									63.60913085937497
								],
								[
									-171.03486328125,
									63.58549804687496
								],
								[
									-170.87460937499998,
									63.593994140625
								],
								[
									-170.67250976562502,
									63.66884765625005
								],
								[
									-170.55185546875003,
									63.68847656249997
								],
								[
									-170.430419921875,
									63.69882812499995
								],
								[
									-170.29936523437502,
									63.68061523437507
								],
								[
									-170.17128906249997,
									63.640917968750045
								],
								[
									-170.121826171875,
									63.617529296875006
								],
								[
									-170.08242187499997,
									63.57666015625003
								],
								[
									-170.05629882812497,
									63.52719726562498
								],
								[
									-170.01738281249996,
									63.49174804687496
								],
								[
									-169.77744140625,
									63.447998046875114
								],
								[
									-169.62412109375003,
									63.43056640625002
								],
								[
									-169.58720703125,
									63.40659179687509
								],
								[
									-169.55454101562498,
									63.373486328124926
								],
								[
									-169.42758789062498,
									63.348339843749955
								],
								[
									-169.29506835937497,
									63.35751953125006
								],
								[
									-169.22109375,
									63.348583984374926
								],
								[
									-168.99604492187498,
									63.34731445312502
								],
								[
									-168.71601562500004,
									63.310595703125074
								],
								[
									-168.76132812500003,
									63.213769531249994
								],
								[
									-168.85239257812503,
									63.171240234375034
								],
								[
									-169.109033203125,
									63.18491210937498
								],
								[
									-169.36469726562504,
									63.171142578125085
								],
								[
									-169.470849609375,
									63.12128906249998
								],
								[
									-169.55927734374995,
									63.058203125000006
								],
								[
									-169.57128906250003,
									62.996777343749926
								],
								[
									-169.62285156249996,
									62.968554687500045
								],
								[
									-169.67636718750003,
									62.95610351562499
								],
								[
									-169.71982421874998,
									62.99008789062498
								],
								[
									-169.77778320312498,
									63.09375000000006
								],
								[
									-169.81860351562494,
									63.12236328125002
								],
								[
									-169.86342773437502,
									63.14038085937506
								],
								[
									-169.9884765625,
									63.173144531250074
								],
								[
									-170.11538085937502,
									63.193847656250114
								],
								[
									-170.18959960937497,
									63.19633789062499
								],
								[
									-170.243115234375,
									63.232275390625034
								],
								[
									-170.272705078125,
									63.28427734375006
								],
								[
									-170.32353515625,
									63.31113281250012
								],
								[
									-170.42416992187503,
									63.349267578124966
								],
								[
									-170.52709960937497,
									63.379296874999966
								],
								[
									-170.84838867187497,
									63.44438476562499
								],
								[
									-170.954052734375,
									63.452929687500045
								],
								[
									-171.06123046874998,
									63.445898437500034
								],
								[
									-171.176025390625,
									63.416210937499926
								],
								[
									-171.28730468750004,
									63.37216796875012
								],
								[
									-171.40117187499996,
									63.33925781250005
								],
								[
									-171.519140625,
									63.33198242187501
								],
								[
									-171.63183593749997,
									63.35122070312502
								],
								[
									-171.737841796875,
									63.39423828124998
								],
								[
									-171.79096679687495,
									63.42470703125005
								],
								[
									-171.819384765625,
									63.477246093749926
								],
								[
									-171.81791992187496,
									63.52983398437499
								],
								[
									-171.80351562499993,
									63.580517578124926
								],
								[
									-171.74638671874993,
									63.703076171874926
								],
								[
									-171.64648437500003,
									63.727001953124926
								],
								[
									-171.46303710937497,
									63.640039062499966
								]
							]
						],
						[
							[
								[
									-166.10986328124994,
									66.22744140625005
								],
								[
									-166.14863281250004,
									66.22182617187497
								],
								[
									-166.14648437499994,
									66.23715820312498
								],
								[
									-166.03251953125002,
									66.277734375
								],
								[
									-165.82221679687498,
									66.32807617187504
								],
								[
									-165.82988281250005,
									66.31713867187503
								],
								[
									-165.94228515625002,
									66.27817382812509
								],
								[
									-166.10986328124994,
									66.22744140625005
								]
							]
						],
						[
							[
								[
									-141.00214843750004,
									69.65078125000008
								],
								[
									-141.00214843750004,
									69.35859375000015
								],
								[
									-141.00214843750004,
									69.06635742187513
								],
								[
									-141.00214843750004,
									68.77416992187509
								],
								[
									-141.00214843750004,
									68.48198242187499
								],
								[
									-141.00214843750004,
									68.18974609374996
								],
								[
									-141.00214843750004,
									67.89755859374995
								],
								[
									-141.00214843750004,
									67.60537109375011
								],
								[
									-141.00214843750004,
									67.31313476562508
								],
								[
									-141.00214843750004,
									67.02094726562515
								],
								[
									-141.00214843750004,
									66.72875976562503
								],
								[
									-141.00214843750004,
									66.43652343750009
								],
								[
									-141.00214843750004,
									66.14433593749999
								],
								[
									-141.00214843750004,
									65.85214843749998
								],
								[
									-141.00214843750004,
									65.55991210937495
								],
								[
									-141.00214843750004,
									65.26772460937511
								],
								[
									-141.00214843750004,
									64.97553710937518
								],
								[
									-141.00214843750004,
									64.68330078125015
								],
								[
									-141.00214843750004,
									64.39111328125003
								],
								[
									-141.00214843750004,
									64.09887695312509
								],
								[
									-141.00214843750004,
									63.80668945312499
								],
								[
									-141.00214843750004,
									63.51445312499996
								],
								[
									-141.00214843750004,
									63.22226562499995
								],
								[
									-141.00214843750004,
									62.93007812500011
								],
								[
									-141.00214843750004,
									62.63789062500018
								],
								[
									-141.00214843750004,
									62.34570312500006
								],
								[
									-141.00214843750004,
									62.05346679687503
								],
								[
									-141.00214843750004,
									61.76127929687502
								],
								[
									-141.00214843750004,
									61.46904296874999
								],
								[
									-141.00214843750004,
									61.17685546874998
								],
								[
									-141.00214843750004,
									60.88466796875005
								],
								[
									-141.00214843750004,
									60.59243164062511
								],
								[
									-141.00214843750004,
									60.30024414062518
								],
								[
									-140.76274414062505,
									60.25913085937506
								],
								[
									-140.52543945312493,
									60.218359375000006
								],
								[
									-140.45283203125004,
									60.29970703125005
								],
								[
									-140.19692382812497,
									60.2375000000001
								],
								[
									-139.97329101562497,
									60.18315429687513
								],
								[
									-139.83066406249995,
									60.252880859375125
								],
								[
									-139.67631835937505,
									60.32832031250004
								],
								[
									-139.46796875000004,
									60.33369140625007
								],
								[
									-139.23476562499997,
									60.339746093749966
								],
								[
									-139.07924804687497,
									60.34370117187515
								],
								[
									-139.07924804687497,
									60.27944335937502
								],
								[
									-139.13696289062494,
									60.172705078125034
								],
								[
									-139.1851562499999,
									60.083593750000006
								],
								[
									-139.04345703124997,
									59.99326171874998
								],
								[
									-138.86874999999992,
									59.94575195312498
								],
								[
									-138.70546874999997,
									59.90131835937507
								],
								[
									-138.63227539062507,
									59.77827148437507
								],
								[
									-138.45361328124997,
									59.6833984375001
								],
								[
									-138.317626953125,
									59.6111328125001
								],
								[
									-138.18745117187493,
									59.54194335937504
								],
								[
									-138.00112304687497,
									59.442919921875045
								],
								[
									-137.87055664062495,
									59.373583984375045
								],
								[
									-137.69663085937495,
									59.28115234375002
								],
								[
									-137.59331054687493,
									59.226269531249955
								],
								[
									-137.54370117187497,
									59.119433593750045
								],
								[
									-137.48417968749993,
									58.99121093750003
								],
								[
									-137.52089843749994,
									58.915380859375034
								],
								[
									-137.43857421874995,
									58.9031250000001
								],
								[
									-137.27753906249993,
									58.98818359375002
								],
								[
									-137.12622070312491,
									59.04096679687504
								],
								[
									-136.93930664062492,
									59.106103515624994
								],
								[
									-136.81328125000002,
									59.15004882812505
								],
								[
									-136.57875976562494,
									59.15224609375005
								],
								[
									-136.46674804687495,
									59.27993164062505
								],
								[
									-136.46635742187493,
									59.459082031250034
								],
								[
									-136.34785156249995,
									59.45605468750006
								],
								[
									-136.27797851562494,
									59.48032226562512
								],
								[
									-136.24711914062496,
									59.53291015625007
								],
								[
									-136.3218261718749,
									59.60483398437506
								],
								[
									-136.09716796874997,
									59.63837890625007
								],
								[
									-135.93466796874992,
									59.662646484375045
								],
								[
									-135.70258789062507,
									59.728759765625085
								],
								[
									-135.47592773437486,
									59.7932617187501
								],
								[
									-135.36787109374998,
									59.74331054687505
								],
								[
									-135.26079101562502,
									59.69501953125007
								],
								[
									-135.05102539062491,
									59.57866210937499
								],
								[
									-135.03666992187493,
									59.550683593749966
								],
								[
									-135.05083007812496,
									59.496044921875125
								],
								[
									-135.07128906249994,
									59.4414550781251
								],
								[
									-134.94375,
									59.28828124999998
								],
								[
									-134.90722656249994,
									59.27119140625004
								],
								[
									-134.80239257812497,
									59.25
								],
								[
									-134.67724609374997,
									59.19926757812496
								],
								[
									-134.62197265625,
									59.155322265625074
								],
								[
									-134.44077148437492,
									59.08535156250002
								],
								[
									-134.41020507812493,
									59.056250000000034
								],
								[
									-134.39306640625,
									59.009179687499966
								],
								[
									-134.36352539062491,
									58.96875000000017
								],
								[
									-134.32963867187505,
									58.939697265625114
								],
								[
									-134.29697265624995,
									58.898486328125045
								],
								[
									-134.21850585937506,
									58.84990234375002
								],
								[
									-134.06918945312492,
									58.79550781249995
								],
								[
									-133.96572265624997,
									58.7578613281251
								],
								[
									-133.8207519531249,
									58.70502929687507
								],
								[
									-133.67392578124992,
									58.59716796875014
								],
								[
									-133.54638671874997,
									58.50346679687496
								],
								[
									-133.40112304687494,
									58.41088867187503
								],
								[
									-133.42255859374995,
									58.337060546874994
								],
								[
									-133.27529296875,
									58.22285156250007
								],
								[
									-133.12041015625,
									58.077734375000006
								],
								[
									-133.00141601562495,
									57.94897460937497
								],
								[
									-132.9168457031249,
									57.87700195312516
								],
								[
									-132.81552734374992,
									57.77270507812494
								],
								[
									-132.6915039062499,
									57.64511718750006
								],
								[
									-132.55048828124995,
									57.499902343749966
								],
								[
									-132.44248046874986,
									57.40673828125
								],
								[
									-132.30166015624997,
									57.27631835937507
								],
								[
									-132.23217773437494,
									57.19853515625013
								],
								[
									-132.27939453124998,
									57.145361328125034
								],
								[
									-132.33798828124992,
									57.07944335937512
								],
								[
									-132.1570312499999,
									57.04819335937506
								],
								[
									-132.03154296874993,
									57.0265625000001
								],
								[
									-132.062890625,
									56.953369140625
								],
								[
									-132.1042968749999,
									56.85678710937515
								],
								[
									-131.96249999999986,
									56.818701171875006
								],
								[
									-131.86616210937495,
									56.79282226562498
								],
								[
									-131.88598632812494,
									56.742138671874955
								],
								[
									-131.83310546874992,
									56.684814453125
								],
								[
									-131.82426757812496,
									56.58999023437505
								],
								[
									-131.65151367187494,
									56.59609375000005
								],
								[
									-131.57509765625002,
									56.59882812500007
								],
								[
									-131.47187499999995,
									56.55673828125012
								],
								[
									-131.33579101562503,
									56.501220703125085
								],
								[
									-131.19941406249995,
									56.44921874999997
								],
								[
									-131.0829101562499,
									56.40483398437499
								],
								[
									-130.9302246093749,
									56.37861328125007
								],
								[
									-130.74169921875006,
									56.340820312500085
								],
								[
									-130.649072265625,
									56.263671875
								],
								[
									-130.47709960937496,
									56.230566406250006
								],
								[
									-130.41313476562487,
									56.122509765625125
								],
								[
									-130.21469726562486,
									56.08281249999993
								],
								[
									-130.09785156249995,
									56.109277343749994
								],
								[
									-130.05595703124996,
									56.065234375000074
								],
								[
									-130.02290039062495,
									56.01450195312515
								],
								[
									-130.01406249999997,
									55.95053710937498
								],
								[
									-130.02509765624998,
									55.888232421875074
								],
								[
									-130.07465820312504,
									55.83603515625009
								],
								[
									-130.111962890625,
									55.779785156250114
								],
								[
									-130.13706054687498,
									55.719384765624966
								],
								[
									-130.14653320312505,
									55.65449218750007
								],
								[
									-130.14042968750005,
									55.585009765625045
								],
								[
									-130.12041015624993,
									55.52441406249994
								],
								[
									-130.05947265624997,
									55.412304687499926
								],
								[
									-130.0392578125,
									55.34360351562506
								],
								[
									-130.036572265625,
									55.297900390625074
								],
								[
									-130.171826171875,
									55.137011718750074
								],
								[
									-130.21850585937503,
									55.06025390625007
								],
								[
									-130.2140625,
									55.025878906250085
								],
								[
									-130.312548828125,
									54.94594726562505
								],
								[
									-130.49326171874998,
									54.834179687499926
								],
								[
									-130.575341796875,
									54.76967773437502
								],
								[
									-130.61582031249998,
									54.790917968749994
								],
								[
									-130.849609375,
									54.807617187500114
								],
								[
									-130.934619140625,
									54.95039062500007
								],
								[
									-130.9796875,
									55.06118164062508
								],
								[
									-131.04785156249997,
									55.157666015624926
								],
								[
									-131.0458984375,
									55.17958984375005
								],
								[
									-130.983935546875,
									55.2439453125001
								],
								[
									-130.75039062500002,
									55.29697265625006
								],
								[
									-130.74819335937502,
									55.318017578124994
								],
								[
									-130.83505859374998,
									55.33208007812493
								],
								[
									-130.85595703124994,
									55.35512695312511
								],
								[
									-130.87978515625002,
									55.45952148437496
								],
								[
									-130.87338867187503,
									55.55112304687506
								],
								[
									-130.879638671875,
									55.611816406250085
								],
								[
									-130.9185546875,
									55.735986328124966
								],
								[
									-130.977001953125,
									55.8119628906251
								],
								[
									-131.127685546875,
									55.96015624999998
								],
								[
									-131.140380859375,
									55.997509765624955
								],
								[
									-131.0740234375,
									56.04438476562501
								],
								[
									-131.032763671875,
									56.08808593750004
								],
								[
									-131.28759765624997,
									56.01210937500008
								],
								[
									-131.63525390625,
									55.93222656249998
								],
								[
									-131.78417968749997,
									55.876562500000006
								],
								[
									-131.81547851562493,
									55.85419921874998
								],
								[
									-131.826171875,
									55.835351562499966
								],
								[
									-131.799072265625,
									55.782812500000006
								],
								[
									-131.80327148437493,
									55.76596679687495
								],
								[
									-131.83359375,
									55.73491210937493
								],
								[
									-131.86943359375002,
									55.6471679687501
								],
								[
									-131.94501953125007,
									55.55415039062504
								],
								[
									-131.98339843749997,
									55.53500976562506
								],
								[
									-132.11899414062498,
									55.56977539062504
								],
								[
									-132.15541992187502,
									55.59956054687507
								],
								[
									-132.22343750000002,
									55.72104492187495
								],
								[
									-132.20751953124997,
									55.75341796874997
								],
								[
									-132.157958984375,
									55.78066406250011
								],
								[
									-132.09067382812498,
									55.839550781249926
								],
								[
									-132.00571289062498,
									55.93007812500008
								],
								[
									-131.84384765625003,
									56.160107421874955
								],
								[
									-131.738037109375,
									56.161230468750006
								],
								[
									-131.55136718749998,
									56.20678710937506
								],
								[
									-131.84423828125006,
									56.229638671874994
								],
								[
									-131.88789062500007,
									56.241650390624955
								],
								[
									-131.927294921875,
									56.272998046875045
								],
								[
									-131.96230468750002,
									56.32368164062507
								],
								[
									-132.021923828125,
									56.38007812500001
								],
								[
									-132.133251953125,
									56.39985351562504
								],
								[
									-132.18203125000002,
									56.420654296875114
								],
								[
									-132.25556640625,
									56.48911132812509
								],
								[
									-132.30498046875002,
									56.51987304687498
								],
								[
									-132.33203125000003,
									56.557910156250074
								],
								[
									-132.336669921875,
									56.60312500000006
								],
								[
									-132.357666015625,
									56.62587890625008
								],
								[
									-132.43442382812503,
									56.63413085937498
								],
								[
									-132.47592773437503,
									56.64965820312494
								],
								[
									-132.487109375,
									56.76640624999993
								],
								[
									-132.63950195312498,
									56.7964355468751
								],
								[
									-132.701953125,
									56.82226562499994
								],
								[
									-132.80219726562498,
									56.89516601562505
								],
								[
									-132.82988281250002,
									56.93061523437498
								],
								[
									-132.83881835937498,
									56.96020507812497
								],
								[
									-132.81425781249993,
									57.04072265625004
								],
								[
									-132.82460937500002,
									57.05581054687508
								],
								[
									-132.91342773437498,
									57.04746093750009
								],
								[
									-133.465869140625,
									57.17216796874999
								],
								[
									-133.43666992187502,
									57.33686523437507
								],
								[
									-133.53896484374997,
									57.55415039062501
								],
								[
									-133.64873046874996,
									57.64228515625001
								],
								[
									-133.62695312499994,
									57.67651367187506
								],
								[
									-133.60336914062503,
									57.69467773437495
								],
								[
									-133.55419921874997,
									57.69506835937494
								],
								[
									-133.342333984375,
									57.63110351562506
								],
								[
									-133.142822265625,
									57.55512695312504
								],
								[
									-133.11704101562498,
									57.566210937500074
								],
								[
									-133.4357421875,
									57.72705078124997
								],
								[
									-133.51547851562498,
									57.775146484375
								],
								[
									-133.535205078125,
									57.83295898437507
								],
								[
									-133.53642578125,
									57.863867187500034
								],
								[
									-133.5111328125,
									57.880126953125085
								],
								[
									-133.212060546875,
									57.86567382812507
								],
								[
									-133.1943359375,
									57.877685546875114
								],
								[
									-133.49741210937503,
									57.92465820312509
								],
								[
									-133.55937499999996,
									57.92446289062505
								],
								[
									-133.62573242187497,
									57.856982421875074
								],
								[
									-133.657275390625,
									57.84101562500001
								],
								[
									-133.72231445312502,
									57.84423828125006
								],
								[
									-133.74414062500003,
									57.85458984375012
								],
								[
									-133.82138671875003,
									57.93637695312506
								],
								[
									-133.894482421875,
									57.993261718750034
								],
								[
									-134.03110351562498,
									58.07216796874994
								],
								[
									-134.05673828125003,
									58.128369140624926
								],
								[
									-134.06333007812503,
									58.211083984374994
								],
								[
									-134.045263671875,
									58.289257812499926
								],
								[
									-133.933642578125,
									58.46787109375009
								],
								[
									-133.88852539062503,
									58.49873046875007
								],
								[
									-133.87675781249996,
									58.518164062500034
								],
								[
									-133.91113281250003,
									58.51523437500006
								],
								[
									-133.94384765625006,
									58.49829101562497
								],
								[
									-134.0361328125,
									58.415332031250045
								],
								[
									-134.13120117187503,
									58.27934570312496
								],
								[
									-134.20883789062503,
									58.2329589843751
								],
								[
									-134.25761718750002,
									58.24418945312499
								],
								[
									-134.33144531249997,
									58.299609375000074
								],
								[
									-134.48544921874998,
									58.3671875
								],
								[
									-134.66362304687493,
									58.384716796874926
								],
								[
									-134.77612304687506,
									58.45385742187506
								],
								[
									-134.94252929687502,
									58.64628906250002
								],
								[
									-134.964794921875,
									58.742187500000114
								],
								[
									-134.98613281250002,
									58.765625000000085
								],
								[
									-135.07646484374993,
									58.79677734374994
								],
								[
									-135.13183593750003,
									58.842871093750006
								],
								[
									-135.21738281249998,
									59.076611328124926
								],
								[
									-135.33032226562497,
									59.23906249999999
								],
								[
									-135.35844726562502,
									59.32490234374998
								],
								[
									-135.34892578125005,
									59.41005859375011
								],
								[
									-135.36367187500002,
									59.41943359375006
								],
								[
									-135.4025390625,
									59.35307617187513
								],
								[
									-135.41274414062497,
									59.31845703125009
								],
								[
									-135.48408203125,
									59.30869140625006
								],
								[
									-135.416943359375,
									59.241503906250045
								],
								[
									-135.400146484375,
									59.20791015625002
								],
								[
									-135.433740234375,
									59.21069335937506
								],
								[
									-135.50234375000002,
									59.20229492187505
								],
								[
									-135.38613281249997,
									59.08754882812494
								],
								[
									-135.33408203125003,
									58.909619140624926
								],
								[
									-135.25703125000007,
									58.777734374999966
								],
								[
									-135.207080078125,
									58.67089843749997
								],
								[
									-135.18457031250003,
									58.58974609375005
								],
								[
									-135.15190429687493,
									58.51220703124997
								],
								[
									-135.06201171875,
									58.34086914062496
								],
								[
									-135.04970703125,
									58.30678710937505
								],
								[
									-135.06049804687498,
									58.27890624999995
								],
								[
									-135.090234375,
									58.24584960937497
								],
								[
									-135.14155273437495,
									58.233398437500085
								],
								[
									-135.3025390625,
									58.255908203125074
								],
								[
									-135.36313476562498,
									58.2982910156251
								],
								[
									-135.449951171875,
									58.37612304687505
								],
								[
									-135.57177734374994,
									58.41206054687507
								],
								[
									-135.87343749999997,
									58.39423828125001
								],
								[
									-135.89755859374998,
									58.400195312500074
								],
								[
									-135.89633789062498,
									58.46381835937507
								],
								[
									-135.86171874999997,
									58.57705078124994
								],
								[
									-135.88955078125002,
									58.62270507812511
								],
								[
									-136.0455078125,
									58.789111328125074
								],
								[
									-136.04311523437497,
									58.82163085937495
								],
								[
									-135.82636718750004,
									58.89794921874994
								],
								[
									-135.931689453125,
									58.90375976562498
								],
								[
									-136.0166015625,
									58.873974609374955
								],
								[
									-136.049365234375,
									58.893212890624966
								],
								[
									-136.10063476562496,
									58.99985351562509
								],
								[
									-136.13369140625002,
									59.03955078125003
								],
								[
									-136.150048828125,
									59.048095703125085
								],
								[
									-136.15947265624996,
									58.94677734374994
								],
								[
									-136.12353515625,
									58.89345703125011
								],
								[
									-136.11840820312503,
									58.86259765625013
								],
								[
									-136.12416992187497,
									58.819628906250074
								],
								[
									-136.14682617187503,
									58.788818359375085
								],
								[
									-136.18632812500002,
									58.77016601562494
								],
								[
									-136.22583007812497,
									58.76547851562506
								],
								[
									-136.29902343749995,
									58.786914062500074
								],
								[
									-136.3802734375,
									58.82729492187494
								],
								[
									-136.45117187499997,
									58.84633789062508
								],
								[
									-136.47758789062502,
									58.862499999999926
								],
								[
									-136.511181640625,
									58.90708007812495
								],
								[
									-136.56621093749996,
									58.94091796875
								],
								[
									-136.83095703124997,
									58.983837890624955
								],
								[
									-136.98901367187503,
									59.03447265624996
								],
								[
									-137.00214843750004,
									59.021142578124994
								],
								[
									-136.95283203125,
									58.966943359374966
								],
								[
									-136.94804687500005,
									58.93491210937512
								],
								[
									-136.98789062499998,
									58.92514648437498
								],
								[
									-137.059033203125,
									58.87373046874998
								],
								[
									-137.03837890624996,
									58.86665039062507
								],
								[
									-136.96303710937497,
									58.88354492187494
								],
								[
									-136.8791015625,
									58.88154296874998
								],
								[
									-136.74013671874997,
									58.85019531250009
								],
								[
									-136.613916015625,
									58.80927734375001
								],
								[
									-136.568212890625,
									58.78632812500004
								],
								[
									-136.54931640624997,
									58.752392578124955
								],
								[
									-136.53349609374993,
									58.74023437499997
								],
								[
									-136.41010742187504,
									58.70063476562498
								],
								[
									-136.40419921875,
									58.679785156250006
								],
								[
									-136.48374023437503,
									58.61767578125006
								],
								[
									-136.31987304687493,
									58.624462890624926
								],
								[
									-136.224609375,
									58.602246093749926
								],
								[
									-136.10288085937498,
									58.50629882812501
								],
								[
									-136.06147460937498,
									58.45273437500012
								],
								[
									-136.05595703125,
									58.384179687499994
								],
								[
									-136.08125,
									58.364208984374926
								],
								[
									-136.129638671875,
									58.350390625000045
								],
								[
									-136.46240234375003,
									58.327978515625006
								],
								[
									-136.5826171875,
									58.24521484375012
								],
								[
									-136.607421875,
									58.24399414062495
								],
								[
									-136.69892578125,
									58.26645507812509
								],
								[
									-136.864990234375,
									58.33242187499994
								],
								[
									-137.07192382812497,
									58.39521484375001
								],
								[
									-137.54399414062505,
									58.581201171874994
								],
								[
									-137.55693359375,
									58.58994140625009
								],
								[
									-137.56459960937497,
									58.62587890624994
								],
								[
									-137.59707031250002,
									58.644238281249955
								],
								[
									-137.66108398437498,
									58.65991210937494
								],
								[
									-137.75,
									58.70708007812496
								],
								[
									-137.86372070312495,
									58.785546874999966
								],
								[
									-137.93398437499997,
									58.84687500000001
								],
								[
									-137.96088867187507,
									58.89101562500005
								],
								[
									-138.026904296875,
									58.94145507812502
								],
								[
									-138.24072265625006,
									59.04682617187507
								],
								[
									-138.35249023437498,
									59.08730468750008
								],
								[
									-138.45131835937497,
									59.110107421875
								],
								[
									-138.53715820312493,
									59.11508789062495
								],
								[
									-138.56030273437506,
									59.12915039062497
								],
								[
									-138.52070312499995,
									59.15224609375005
								],
								[
									-138.51489257812503,
									59.16591796875011
								],
								[
									-138.70419921875003,
									59.187548828125074
								],
								[
									-138.884326171875,
									59.23691406250009
								],
								[
									-139.34096679687502,
									59.37563476562511
								],
								[
									-139.57680664062502,
									59.46245117187502
								],
								[
									-139.71445312499998,
									59.503955078125045
								],
								[
									-139.77329101562498,
									59.5272949218751
								],
								[
									-139.79912109375,
									59.54624023437495
								],
								[
									-139.766064453125,
									59.566064453124994
								],
								[
									-139.67412109375005,
									59.58681640625005
								],
								[
									-139.61162109375,
									59.61030273437504
								],
								[
									-139.51303710937498,
									59.69809570312498
								],
								[
									-139.50556640624995,
									59.72631835937506
								],
								[
									-139.55849609375002,
									59.790185546874994
								],
								[
									-139.58217773437502,
									59.84829101562494
								],
								[
									-139.58115234375,
									59.88051757812502
								],
								[
									-139.56914062499996,
									59.91235351562503
								],
								[
									-139.5541015625,
									59.93330078125001
								],
								[
									-139.5123046875,
									59.95356445312498
								],
								[
									-139.48300781249998,
									59.96376953125002
								],
								[
									-139.446875,
									59.95683593750002
								],
								[
									-139.33095703125002,
									59.87700195312502
								],
								[
									-139.31464843749998,
									59.84794921874996
								],
								[
									-139.32001953125,
									59.7387207031251
								],
								[
									-139.28671874999998,
									59.61093750000006
								],
								[
									-139.27626953124997,
									59.62036132812503
								],
								[
									-139.26562500000003,
									59.66259765624994
								],
								[
									-139.25874023437504,
									59.74331054687505
								],
								[
									-139.24570312499998,
									59.78208007812495
								],
								[
									-139.22080078125003,
									59.8198730468751
								],
								[
									-139.17885742187502,
									59.839843750000085
								],
								[
									-139.04829101562498,
									59.82822265625012
								],
								[
									-138.9880859375,
									59.83500976562499
								],
								[
									-139.24248046875002,
									59.89277343750004
								],
								[
									-139.40249023437502,
									60.00097656250006
								],
								[
									-139.4314453125,
									60.01225585937513
								],
								[
									-139.51894531250002,
									60.01708984375003
								],
								[
									-139.611669921875,
									59.97343750000013
								],
								[
									-139.85019531250003,
									59.830712890624994
								],
								[
									-139.91689453125002,
									59.80566406250006
								],
								[
									-140.216748046875,
									59.726660156250034
								],
								[
									-140.41982421874997,
									59.710742187500074
								],
								[
									-140.648388671875,
									59.72319335937513
								],
								[
									-140.84316406249997,
									59.74887695312512
								],
								[
									-141.33193359375,
									59.87377929687497
								],
								[
									-141.40830078125,
									59.90278320312501
								],
								[
									-141.29462890625,
									59.980029296875045
								],
								[
									-141.28994140624997,
									60.00415039062506
								],
								[
									-141.32954101562504,
									60.08281250000002
								],
								[
									-141.36215820312503,
									60.105273437500074
								],
								[
									-141.408740234375,
									60.117675781250114
								],
								[
									-141.4216796875,
									60.10883789062507
								],
								[
									-141.42216796875,
									60.08549804687513
								],
								[
									-141.40971679687505,
									60.04228515625002
								],
								[
									-141.4470703125,
									60.01943359375008
								],
								[
									-141.53017578124997,
									59.99477539062494
								],
								[
									-141.67016601562497,
									59.96987304687502
								],
								[
									-142.1041015625,
									60.033447265625
								],
								[
									-142.54858398437497,
									60.08603515625006
								],
								[
									-142.94565429687503,
									60.096972656250074
								],
								[
									-143.506103515625,
									60.05502929687495
								],
								[
									-143.80507812499997,
									60.01289062499998
								],
								[
									-143.9794921875,
									60.00878906249994
								],
								[
									-144.14721679687494,
									60.01640624999999
								],
								[
									-144.1609375,
									60.04580078124994
								],
								[
									-144.08427734375002,
									60.06303710937499
								],
								[
									-144.088525390625,
									60.08432617187498
								],
								[
									-144.185498046875,
									60.150732421875006
								],
								[
									-144.33261718749998,
									60.19101562499995
								],
								[
									-144.52998046875004,
									60.205224609374994
								],
								[
									-144.64296874999997,
									60.22465820312496
								],
								[
									-144.67158203125,
									60.24921875000007
								],
								[
									-144.74140625000004,
									60.27270507812506
								],
								[
									-144.85244140625002,
									60.29506835937511
								],
								[
									-144.901318359375,
									60.33515625000001
								],
								[
									-144.86245117187502,
									60.459179687499955
								],
								[
									-144.82441406249998,
									60.53359375000002
								],
								[
									-144.786572265625,
									60.58461914062494
								],
								[
									-144.69111328125,
									60.669091796874994
								],
								[
									-144.72441406249993,
									60.66284179687497
								],
								[
									-144.86308593749996,
									60.60087890624996
								],
								[
									-144.984033203125,
									60.53691406249999
								],
								[
									-145.09599609375,
									60.45366210937499
								],
								[
									-145.16269531249998,
									60.415380859375006
								],
								[
									-145.248291015625,
									60.380126953125114
								],
								[
									-145.381787109375,
									60.388574218749966
								],
								[
									-145.56313476562502,
									60.44072265625002
								],
								[
									-145.71845703125007,
									60.467578125000074
								],
								[
									-145.84775390625,
									60.46923828125006
								],
								[
									-145.89887695312504,
									60.47817382812511
								],
								[
									-145.81064453125,
									60.52465820312497
								],
								[
									-145.75981445312493,
									60.56201171874994
								],
								[
									-145.690234375,
									60.621972656249994
								],
								[
									-145.67490234374998,
									60.65112304687506
								],
								[
									-146.14902343750003,
									60.660693359375074
								],
								[
									-146.16640625000002,
									60.69228515625002
								],
								[
									-146.16708984374998,
									60.715527343749955
								],
								[
									-146.18232421875007,
									60.734765624999966
								],
								[
									-146.25102539062502,
									60.749072265625045
								],
								[
									-146.34716796874997,
									60.73813476562495
								],
								[
									-146.502978515625,
									60.70078124999998
								],
								[
									-146.57045898437497,
									60.72915039062508
								],
								[
									-146.54638671874997,
									60.74511718749994
								],
								[
									-146.4955078125,
									60.756787109374926
								],
								[
									-146.39199218749997,
									60.81083984375002
								],
								[
									-146.53193359375004,
									60.83886718749994
								],
								[
									-146.603564453125,
									60.870947265625006
								],
								[
									-146.63842773437497,
									60.89731445312495
								],
								[
									-146.63603515625002,
									60.99252929687509
								],
								[
									-146.59912109374994,
									61.053515625000074
								],
								[
									-146.284912109375,
									61.11264648437495
								],
								[
									-146.384375,
									61.13583984375006
								],
								[
									-146.58271484375,
									61.12783203124994
								],
								[
									-146.71591796875003,
									61.077539062499994
								],
								[
									-146.8740234375,
									61.00488281250003
								],
								[
									-146.98017578124995,
									60.977783203125
								],
								[
									-147.03432617187497,
									60.996191406250034
								],
								[
									-147.10595703125,
									61.00253906250006
								],
								[
									-147.19501953125004,
									60.99682617187497
								],
								[
									-147.25488281249997,
									60.978271484375114
								],
								[
									-147.285595703125,
									60.94677734375
								],
								[
									-147.32109374999996,
									60.925488281249926
								],
								[
									-147.361376953125,
									60.91450195312507
								],
								[
									-147.390576171875,
									60.918017578125074
								],
								[
									-147.43339843750002,
									60.950292968750006
								],
								[
									-147.52329101562503,
									60.97031250000009
								],
								[
									-147.56728515625002,
									60.99492187500013
								],
								[
									-147.59257812500005,
									60.97944335937498
								],
								[
									-147.623291015625,
									60.93300781249994
								],
								[
									-147.65566406250002,
									60.90952148437495
								],
								[
									-147.80761718749994,
									60.88540039062502
								],
								[
									-147.89111328125,
									60.88989257812503
								],
								[
									-147.990771484375,
									60.948291015625045
								],
								[
									-148.00512695312497,
									60.96855468749999
								],
								[
									-147.97119140625,
									61.01904296874997
								],
								[
									-147.75185546874997,
									61.218945312499926
								],
								[
									-147.77377929687498,
									61.217822265625045
								],
								[
									-147.84482421874998,
									61.186376953125034
								],
								[
									-147.98637695312496,
									61.1064941406251
								],
								[
									-148.04941406250003,
									61.082666015624966
								],
								[
									-148.15791015625,
									61.07968749999998
								],
								[
									-148.20869140625007,
									61.08828125000005
								],
								[
									-148.27001953125,
									61.08178710937497
								],
								[
									-148.34189453125,
									61.06040039062506
								],
								[
									-148.38876953124998,
									61.03696289062498
								],
								[
									-148.4107421875,
									61.01147460937494
								],
								[
									-148.39584960937498,
									61.00712890625013
								],
								[
									-148.28740234375,
									61.036230468750006
								],
								[
									-148.22587890625,
									61.044042968750006
								],
								[
									-148.20869140625007,
									61.029931640624966
								],
								[
									-148.2931640625,
									60.93969726562497
								],
								[
									-148.34443359375,
									60.85356445312502
								],
								[
									-148.393310546875,
									60.83188476562495
								],
								[
									-148.47104492187503,
									60.835498046875074
								],
								[
									-148.55615234374994,
									60.82700195312512
								],
								[
									-148.55737304687503,
									60.8029296875001
								],
								[
									-148.39868164062503,
									60.734033203124994
								],
								[
									-148.34125976562495,
									60.72431640625007
								],
								[
									-148.26787109375005,
									60.69970703125003
								],
								[
									-148.25673828124997,
									60.67529296875003
								],
								[
									-148.284228515625,
									60.60932617187507
								],
								[
									-148.30498046874993,
									60.583349609375034
								],
								[
									-148.33842773437502,
									60.56982421874994
								],
								[
									-148.4677734375,
									60.572070312500045
								],
								[
									-148.5095703125,
									60.565234375000074
								],
								[
									-148.59663085937504,
									60.52377929687498
								],
								[
									-148.64013671875,
									60.4894531250001
								],
								[
									-148.624267578125,
									60.486425781250006
								],
								[
									-148.54912109374993,
									60.51479492187511
								],
								[
									-148.43984374999997,
									60.52998046875007
								],
								[
									-148.29638671874997,
									60.53208007812498
								],
								[
									-148.18945312500006,
									60.54711914062503
								],
								[
									-148.11918945312502,
									60.575146484374955
								],
								[
									-148.05068359375002,
									60.56718750000002
								],
								[
									-147.98403320312502,
									60.523339843749966
								],
								[
									-147.96411132812494,
									60.48486328124994
								],
								[
									-147.990966796875,
									60.45185546875007
								],
								[
									-148.04599609375003,
									60.42832031249998
								],
								[
									-148.12919921875002,
									60.41420898437494
								],
								[
									-148.18168945312496,
									60.393066406250085
								],
								[
									-148.20356445312498,
									60.36494140625004
								],
								[
									-148.215869140625,
									60.32314453125005
								],
								[
									-148.21865234375002,
									60.26767578125012
								],
								[
									-148.197607421875,
									60.1677734375001
								],
								[
									-148.21376953125002,
									60.15424804687501
								],
								[
									-148.24501953125,
									60.146826171875006
								],
								[
									-148.29135742187503,
									60.14545898437507
								],
								[
									-148.33310546874998,
									60.122021484374926
								],
								[
									-148.430712890625,
									59.989111328125034
								],
								[
									-148.46508789062497,
									59.97470703125012
								],
								[
									-148.50605468749995,
									59.9889648437501
								],
								[
									-148.5423828125,
									59.98740234374995
								],
								[
									-148.57407226562498,
									59.97006835937506
								],
								[
									-148.64360351562502,
									59.95683593750002
								],
								[
									-148.75087890625002,
									59.94775390624994
								],
								[
									-148.84272460937498,
									59.95122070312513
								],
								[
									-149.00424804687503,
									59.97998046874994
								],
								[
									-149.07011718749993,
									60.000244140625085
								],
								[
									-149.12158203124994,
									60.0334960937501
								],
								[
									-149.2666015625,
									59.99829101562494
								],
								[
									-149.304931640625,
									60.01367187499997
								],
								[
									-149.39526367187503,
									60.10576171874999
								],
								[
									-149.41484375000002,
									60.10024414062502
								],
								[
									-149.4322265625,
									60.00102539062496
								],
								[
									-149.459716796875,
									59.96625976562498
								],
								[
									-149.54916992187503,
									59.89433593749999
								],
								[
									-149.59804687500002,
									59.77045898437498
								],
								[
									-149.61289062500003,
									59.76684570312503
								],
								[
									-149.629638671875,
									59.78466796874994
								],
								[
									-149.68466796875,
									59.89531250000002
								],
								[
									-149.7138671875,
									59.91958007812508
								],
								[
									-149.79477539062498,
									59.855810546875034
								],
								[
									-149.803662109375,
									59.832714843749955
								],
								[
									-149.78247070312506,
									59.75034179687506
								],
								[
									-149.80126953124994,
									59.73793945312502
								],
								[
									-149.96499023437502,
									59.78227539062499
								],
								[
									-150.00532226562507,
									59.78442382812506
								],
								[
									-150.015966796875,
									59.77695312500006
								],
								[
									-149.96015625,
									59.71303710937508
								],
								[
									-149.96650390625007,
									59.690039062500034
								],
								[
									-150.198046875,
									59.56655273437508
								],
								[
									-150.25849609375,
									59.57094726562511
								],
								[
									-150.29648437500003,
									59.58325195312494
								],
								[
									-150.338134765625,
									59.581347656250074
								],
								[
									-150.48535156249997,
									59.53530273437494
								],
								[
									-150.52597656249998,
									59.5373046875001
								],
								[
									-150.58154296875003,
									59.564599609374966
								],
								[
									-150.60737304687507,
									59.56337890625008
								],
								[
									-150.62114257812502,
									59.53505859375008
								],
								[
									-150.62290039062503,
									59.479638671874966
								],
								[
									-150.67744140625,
									59.42695312499998
								],
								[
									-150.85278320312506,
									59.34184570312496
								],
								[
									-150.89931640625002,
									59.30268554687498
								],
								[
									-150.934521484375,
									59.24912109375009
								],
								[
									-150.9607421875,
									59.24399414062509
								],
								[
									-151.06357421874998,
									59.278417968750006
								],
								[
									-151.18276367187502,
									59.30078124999994
								],
								[
									-151.19921875,
									59.28964843750009
								],
								[
									-151.163037109375,
									59.25693359375006
								],
								[
									-151.170703125,
									59.23691406250009
								],
								[
									-151.22226562499998,
									59.229394531249966
								],
								[
									-151.28749999999997,
									59.23232421875002
								],
								[
									-151.36635742187497,
									59.245605468750085
								],
								[
									-151.477001953125,
									59.23056640624995
								],
								[
									-151.619384765625,
									59.18730468750002
								],
								[
									-151.73818359375002,
									59.18852539062499
								],
								[
									-151.90385742187493,
									59.25976562499994
								],
								[
									-151.94951171875,
									59.265087890624955
								],
								[
									-151.96406250000004,
									59.285107421874955
								],
								[
									-151.93168945312502,
									59.34272460937507
								],
								[
									-151.88461914062503,
									59.38632812500006
								],
								[
									-151.84995117187498,
									59.40634765625006
								],
								[
									-151.69257812499998,
									59.462207031250074
								],
								[
									-151.5126953125,
									59.482714843750074
								],
								[
									-151.39960937499998,
									59.51630859374998
								],
								[
									-151.26210937500002,
									59.58559570312505
								],
								[
									-151.18940429687507,
									59.63769531250003
								],
								[
									-151.04648437499998,
									59.77182617187509
								],
								[
									-151.05732421874995,
									59.78217773437507
								],
								[
									-151.08945312500003,
									59.78940429687512
								],
								[
									-151.403662109375,
									59.662255859374966
								],
								[
									-151.45009765624997,
									59.65039062499994
								],
								[
									-151.51259765625,
									59.65126953124994
								],
								[
									-151.76381835937502,
									59.70000000000002
								],
								[
									-151.816943359375,
									59.72089843750001
								],
								[
									-151.85322265625,
									59.78208007812495
								],
								[
									-151.783447265625,
									59.92114257812494
								],
								[
									-151.734521484375,
									59.98833007812496
								],
								[
									-151.61186523437496,
									60.09204101562494
								],
								[
									-151.45146484375,
									60.20263671875
								],
								[
									-151.39599609375006,
									60.27446289062499
								],
								[
									-151.31269531250004,
									60.46645507812502
								],
								[
									-151.31752929687497,
									60.553564453125006
								],
								[
									-151.35502929687496,
									60.65986328124998
								],
								[
									-151.35644531249997,
									60.72294921874996
								],
								[
									-151.32177734375,
									60.74291992187494
								],
								[
									-150.95375976562502,
									60.84121093750008
								],
								[
									-150.7794921875,
									60.91479492187506
								],
								[
									-150.44125976562503,
									61.02358398437511
								],
								[
									-150.34912109375,
									61.0226562500001
								],
								[
									-150.281494140625,
									60.985205078125006
								],
								[
									-150.20278320312497,
									60.95522460937494
								],
								[
									-150.11303710937497,
									60.93281250000007
								],
								[
									-149.99755859375,
									60.935156250000034
								],
								[
									-149.85625,
									60.96225585937495
								],
								[
									-149.63247070312502,
									60.95200195312509
								],
								[
									-149.1728515625,
									60.880419921875074
								],
								[
									-149.07509765625,
									60.876416015624955
								],
								[
									-149.0712890625,
									60.88554687499996
								],
								[
									-149.142236328125,
									60.93569335937505
								],
								[
									-149.45913085937497,
									60.96474609375002
								],
								[
									-149.59248046874995,
									60.99384765625007
								],
								[
									-149.967724609375,
									61.12172851562494
								],
								[
									-150.05327148437496,
									61.171093749999955
								],
								[
									-150.0185546875,
									61.194238281249966
								],
								[
									-149.92675781250003,
									61.21328124999994
								],
								[
									-149.89531250000002,
									61.23173828124996
								],
								[
									-149.88203124999998,
									61.26372070312499
								],
								[
									-149.82919921874998,
									61.30751953125002
								],
								[
									-149.73691406249998,
									61.363330078125045
								],
								[
									-149.59599609375,
									61.41728515625002
								],
								[
									-149.32905273437504,
									61.49736328124999
								],
								[
									-149.433544921875,
									61.500781250000074
								],
								[
									-149.625439453125,
									61.48603515624998
								],
								[
									-149.69526367187504,
									61.47070312499997
								],
								[
									-149.82373046875,
									61.41337890625002
								],
								[
									-149.87368164062497,
									61.37299804687504
								],
								[
									-149.94521484374997,
									61.29423828124999
								],
								[
									-149.97568359374998,
									61.279345703125074
								],
								[
									-150.10893554687502,
									61.26791992187506
								],
								[
									-150.47177734375003,
									61.25996093750004
								],
								[
									-150.53320312500006,
									61.30024414062507
								],
								[
									-150.56723632812503,
									61.30678710937505
								],
								[
									-150.61225585937498,
									61.30112304687498
								],
								[
									-150.9455078125,
									61.19824218749997
								],
								[
									-151.06499023437502,
									61.145703124999926
								],
								[
									-151.15014648437494,
									61.085839843749994
								],
								[
									-151.28188476562497,
									61.041943359374926
								],
								[
									-151.46010742187497,
									61.01411132812504
								],
								[
									-151.59350585937494,
									60.97963867187494
								],
								[
									-151.73398437499998,
									60.910742187500034
								],
								[
									-151.78164062500002,
									60.85795898437502
								],
								[
									-151.78442382812506,
									60.83315429687494
								],
								[
									-151.75048828124994,
									60.75488281250006
								],
								[
									-151.785107421875,
									60.740234375000114
								],
								[
									-151.866162109375,
									60.73408203125001
								],
								[
									-151.99624023437502,
									60.682226562500006
								],
								[
									-152.27070312499998,
									60.528125000000045
								],
								[
									-152.306591796875,
									60.472216796875045
								],
								[
									-152.30507812499997,
									60.45302734375002
								],
								[
									-152.260302734375,
									60.40942382812494
								],
								[
									-152.29150390624994,
									60.38110351562494
								],
								[
									-152.36884765625,
									60.33632812500005
								],
								[
									-152.54091796874997,
									60.2654296875001
								],
								[
									-152.653955078125,
									60.23842773437502
								],
								[
									-152.727294921875,
									60.237060546875
								],
								[
									-152.797900390625,
									60.24716796875012
								],
								[
									-152.923388671875,
									60.29287109375008
								],
								[
									-153.025,
									60.29565429687494
								],
								[
									-153.03125000000003,
									60.28925781249998
								],
								[
									-152.892919921875,
									60.240380859374966
								],
								[
									-152.75239257812495,
									60.17749023437494
								],
								[
									-152.66474609374995,
									60.125292968750045
								],
								[
									-152.63012695312503,
									60.083789062500045
								],
								[
									-152.62856445312497,
									60.04111328125006
								],
								[
									-152.660107421875,
									59.997216796874994
								],
								[
									-152.75947265625,
									59.920898437500085
								],
								[
									-152.85693359374994,
									59.89809570312505
								],
								[
									-153.10605468749998,
									59.875048828125045
								],
								[
									-153.18637695312503,
									59.8568847656251
								],
								[
									-153.21123046875002,
									59.842724609374955
								],
								[
									-153.04008789062496,
									59.81049804687504
								],
								[
									-153.024609375,
									59.793994140625074
								],
								[
									-153.04814453125,
									59.7300292968751
								],
								[
									-153.09360351562503,
									59.70913085937511
								],
								[
									-153.23618164062503,
									59.67094726562496
								],
								[
									-153.36401367187497,
									59.65986328125001
								],
								[
									-153.38349609375,
									59.66718749999998
								],
								[
									-153.35961914062494,
									59.717480468749926
								],
								[
									-153.366455078125,
									59.72983398437506
								],
								[
									-153.41440429687503,
									59.74013671875002
								],
								[
									-153.48261718749995,
									59.720947265625114
								],
								[
									-153.65253906250004,
									59.64702148437496
								],
								[
									-153.670703125,
									59.63481445312496
								],
								[
									-153.60937500000006,
									59.61503906250002
								],
								[
									-153.622265625,
									59.598486328125034
								],
								[
									-153.71435546875,
									59.54526367187512
								],
								[
									-153.752587890625,
									59.509863281250006
								],
								[
									-153.81416015625,
									59.473730468750006
								],
								[
									-154.088330078125,
									59.36328125000006
								],
								[
									-154.06748046875003,
									59.33637695312501
								],
								[
									-154.13881835937497,
									59.24013671874994
								],
								[
									-154.17832031250003,
									59.15556640625013
								],
								[
									-154.129833984375,
									59.11987304687503
								],
								[
									-153.89956054687502,
									59.07802734375005
								],
								[
									-153.787939453125,
									59.0679199218751
								],
								[
									-153.65639648437502,
									59.03867187500012
								],
								[
									-153.41826171875,
									58.95996093749997
								],
								[
									-153.33896484375003,
									58.90854492187498
								],
								[
									-153.32705078124997,
									58.88432617187502
								],
								[
									-153.33442382812498,
									58.857861328124955
								],
								[
									-153.36293945312502,
									58.82221679687507
								],
								[
									-153.43759765625003,
									58.754833984374926
								],
								[
									-153.61733398437497,
									58.654736328124955
								],
								[
									-153.698583984375,
									58.62636718750005
								],
								[
									-153.821484375,
									58.60410156249995
								],
								[
									-153.86196289062497,
									58.587841796874926
								],
								[
									-154.019873046875,
									58.49296874999996
								],
								[
									-154.06245117187495,
									58.441748046875006
								],
								[
									-154.05571289062502,
									58.39716796874998
								],
								[
									-154.08588867187504,
									58.36582031250006
								],
								[
									-154.289013671875,
									58.30434570312508
								],
								[
									-154.281787109375,
									58.293457031250085
								],
								[
									-154.208056640625,
									58.288769531249926
								],
								[
									-154.23510742187497,
									58.234619140625085
								],
								[
									-154.247021484375,
									58.15942382812494
								],
								[
									-154.282275390625,
									58.146777343750045
								],
								[
									-154.409228515625,
									58.14731445312506
								],
								[
									-154.57060546875002,
									58.118066406249966
								],
								[
									-154.58193359375002,
									58.10976562500005
								],
								[
									-154.584912109375,
									58.05566406250003
								],
								[
									-155.006884765625,
									58.01606445312507
								],
								[
									-155.099267578125,
									57.913330078125
								],
								[
									-155.14736328125002,
									57.88183593749997
								],
								[
									-155.31274414062494,
									57.80712890624994
								],
								[
									-155.41396484374997,
									57.77705078125004
								],
								[
									-155.529638671875,
									57.75888671874998
								],
								[
									-155.59023437500002,
									57.73359375000007
								],
								[
									-155.595849609375,
									57.70107421875011
								],
								[
									-155.62871093750005,
									57.67304687499998
								],
								[
									-155.728955078125,
									57.62661132812494
								],
								[
									-155.77797851562497,
									57.568212890625034
								],
								[
									-155.81367187500007,
									57.55903320312504
								],
								[
									-156.00019531250004,
									57.5449707031251
								],
								[
									-156.03735351562497,
									57.52651367187505
								],
								[
									-156.05537109375,
									57.44755859374996
								],
								[
									-156.08989257812502,
									57.445068359375085
								],
								[
									-156.156005859375,
									57.4634277343751
								],
								[
									-156.24218750000006,
									57.44921874999994
								],
								[
									-156.43588867187498,
									57.35996093750006
								],
								[
									-156.47841796875002,
									57.327880859375085
								],
								[
									-156.47368164062493,
									57.310693359374966
								],
								[
									-156.4435546875,
									57.29365234375004
								],
								[
									-156.39765625,
									57.24057617187506
								],
								[
									-156.40048828124998,
									57.204833984375085
								],
								[
									-156.475146484375,
									57.10517578125001
								],
								[
									-156.50131835937498,
									57.0897949218751
								],
								[
									-156.592041015625,
									57.06508789062494
								],
								[
									-156.62900390624998,
									57.00996093749998
								],
								[
									-156.71264648437494,
									57.01606445312498
								],
								[
									-156.77988281249998,
									57.005615234375085
								],
								[
									-156.82387695312497,
									56.96884765625006
								],
								[
									-156.87172851562497,
									56.947656249999994
								],
								[
									-156.9234375,
									56.942089843749926
								],
								[
									-156.98842773437502,
									56.912939453125034
								],
								[
									-157.06669921875,
									56.860205078125034
								],
								[
									-157.13916015625,
									56.82656250000002
								],
								[
									-157.20576171874995,
									56.81206054687499
								],
								[
									-157.27055664062505,
									56.80849609375008
								],
								[
									-157.33359374999998,
									56.81586914062507
								],
								[
									-157.39023437499998,
									56.80981445312506
								],
								[
									-157.44057617187502,
									56.7903320312501
								],
								[
									-157.48964843749997,
									56.759765625
								],
								[
									-157.52871093749997,
									56.67319335937495
								],
								[
									-157.57836914062503,
									56.63447265625004
								],
								[
									-157.60976562500002,
									56.627685546875
								],
								[
									-157.67387695312493,
									56.63344726562502
								],
								[
									-157.77070312500004,
									56.6516601562501
								],
								[
									-157.869091796875,
									56.645214843749926
								],
								[
									-158.02788085937493,
									56.59213867187495
								],
								[
									-158.0783203125,
									56.55205078124996
								],
								[
									-157.97827148437497,
									56.543164062499926
								],
								[
									-157.9287109375,
									56.53168945312498
								],
								[
									-157.92998046875,
									56.52045898437501
								],
								[
									-157.98217773437494,
									56.5095703125001
								],
								[
									-158.07094726562502,
									56.51035156250009
								],
								[
									-158.12436523437498,
									56.501025390625045
								],
								[
									-158.189404296875,
									56.47817382812511
								],
								[
									-158.352490234375,
									56.45351562500005
								],
								[
									-158.414404296875,
									56.435839843750074
								],
								[
									-158.53740234375002,
									56.33544921874997
								],
								[
									-158.5521484375,
									56.312695312499955
								],
								[
									-158.536376953125,
									56.307666015625074
								],
								[
									-158.46733398437493,
									56.31826171874994
								],
								[
									-158.38613281250002,
									56.301562500000074
								],
								[
									-158.34399414062494,
									56.28032226562493
								],
								[
									-158.31699218749998,
									56.254150390625114
								],
								[
									-158.29140625,
									56.203662109375045
								],
								[
									-158.27563476562497,
									56.19624023437504
								],
								[
									-158.4318359375,
									56.111474609374994
								],
								[
									-158.47612304687496,
									56.075488281250045
								],
								[
									-158.5046875,
									56.06210937499998
								],
								[
									-158.52333984375,
									56.072460937499955
								],
								[
									-158.54267578125,
									56.16684570312509
								],
								[
									-158.554443359375,
									56.18286132812497
								],
								[
									-158.59116210937503,
									56.184521484374955
								],
								[
									-158.6267578125,
									56.15468750000011
								],
								[
									-158.70488281250005,
									56.04311523437511
								],
								[
									-158.78984375000002,
									55.98691406250012
								],
								[
									-159.42944335937503,
									55.842724609374955
								],
								[
									-159.52324218749993,
									55.810009765624955
								],
								[
									-159.54130859375,
									55.74848632812504
								],
								[
									-159.567626953125,
									55.69521484375011
								],
								[
									-159.61005859375007,
									55.65278320312498
								],
								[
									-159.65966796875003,
									55.625927734374926
								],
								[
									-159.67026367187498,
									55.64501953125
								],
								[
									-159.66533203125005,
									55.79487304687507
								],
								[
									-159.67851562499996,
									55.82465820312501
								],
								[
									-159.74301757812503,
									55.843750000000085
								],
								[
									-159.77138671874997,
									55.841113281250074
								],
								[
									-159.810400390625,
									55.832714843749955
								],
								[
									-159.87436523437498,
									55.800292968750114
								],
								[
									-159.91352539062495,
									55.79218750000004
								],
								[
									-159.96230468749997,
									55.79487304687507
								],
								[
									-160.04565429687497,
									55.76293945312506
								],
								[
									-160.24379882812502,
									55.660546874999966
								],
								[
									-160.373193359375,
									55.63510742187512
								],
								[
									-160.40742187500004,
									55.613818359375045
								],
								[
									-160.46269531250005,
									55.5578125000001
								],
								[
									-160.49931640625005,
									55.5373046875001
								],
								[
									-160.55351562499996,
									55.53549804687498
								],
								[
									-160.625244140625,
									55.55239257812505
								],
								[
									-160.68291015624993,
									55.54042968750011
								],
								[
									-160.72651367187504,
									55.499658203124966
								],
								[
									-160.770849609375,
									55.483544921874966
								],
								[
									-160.896728515625,
									55.51362304687507
								],
								[
									-160.952197265625,
									55.49306640625005
								],
								[
									-161.02421875000005,
									55.44042968749997
								],
								[
									-161.09951171875,
									55.40571289062501
								],
								[
									-161.17802734375,
									55.388867187499955
								],
								[
									-161.38193359374998,
									55.371289062499926
								],
								[
									-161.46386718749997,
									55.38251953125007
								],
								[
									-161.480517578125,
									55.39780273437509
								],
								[
									-161.47670898437502,
									55.46489257812499
								],
								[
									-161.44379882812495,
									55.51328125000006
								],
								[
									-161.413330078125,
									55.53613281250003
								],
								[
									-161.37270507812497,
									55.55629882812505
								],
								[
									-161.31328125000005,
									55.55864257812499
								],
								[
									-161.202099609375,
									55.54355468750012
								],
								[
									-161.21469726562503,
									55.559765624999955
								],
								[
									-161.255126953125,
									55.579003906249966
								],
								[
									-161.357470703125,
									55.61220703125008
								],
								[
									-161.4587890625,
									55.62915039062506
								],
								[
									-161.51694335937503,
									55.618408203125
								],
								[
									-161.59877929687502,
									55.59282226562493
								],
								[
									-161.65429687499994,
									55.56337890625008
								],
								[
									-161.68354492187495,
									55.52993164062508
								],
								[
									-161.72036132812502,
									55.420703125000045
								],
								[
									-161.74155273437498,
									55.391162109375074
								],
								[
									-161.98032226562503,
									55.19863281250011
								],
								[
									-162.073974609375,
									55.13930664062508
								],
								[
									-162.16660156249998,
									55.143749999999926
								],
								[
									-162.21147460937496,
									55.121337890625085
								],
								[
									-162.27465820312494,
									55.07324218750006
								],
								[
									-162.33291015625002,
									55.05024414062507
								],
								[
									-162.38637695312497,
									55.05234375000006
								],
								[
									-162.4279296875,
									55.061474609374955
								],
								[
									-162.45747070312498,
									55.077685546875074
								],
								[
									-162.452392578125,
									55.092822265625045
								],
								[
									-162.41254882812498,
									55.10688476562507
								],
								[
									-162.42680664062496,
									55.14541015625008
								],
								[
									-162.49526367187497,
									55.20844726562507
								],
								[
									-162.54189453124997,
									55.24272460937493
								],
								[
									-162.63037109375006,
									55.246679687500034
								],
								[
									-162.644140625,
									55.21801757812506
								],
								[
									-162.61430664062496,
									55.071484374999955
								],
								[
									-162.618896484375,
									55.03842773437506
								],
								[
									-162.67436523437505,
									54.99658203124997
								],
								[
									-162.81958007812503,
									54.950000000000074
								],
								[
									-162.8650390625,
									54.954541015624926
								],
								[
									-162.9958984375,
									55.046484375000006
								],
								[
									-163.11962890624997,
									55.064697265625085
								],
								[
									-163.12783203124997,
									55.03476562500012
								],
								[
									-163.1001953125,
									54.9736328125
								],
								[
									-163.131103515625,
									54.9165527343751
								],
								[
									-163.220556640625,
									54.863378906250006
								],
								[
									-163.28862304687502,
									54.8375976562501
								],
								[
									-163.33530273437503,
									54.83916015624996
								],
								[
									-163.33789062500003,
									54.876367187499994
								],
								[
									-163.296337890625,
									54.94926757812502
								],
								[
									-163.28569335937496,
									55.00996093750004
								],
								[
									-163.30595703125,
									55.05854492187498
								],
								[
									-163.30366210937498,
									55.09584960937494
								],
								[
									-163.27880859374997,
									55.121826171875085
								],
								[
									-163.114501953125,
									55.193945312500034
								],
								[
									-163.045361328125,
									55.20473632812511
								],
								[
									-163.008251953125,
									55.186865234375006
								],
								[
									-162.961962890625,
									55.183837890625114
								],
								[
									-162.906591796875,
									55.195556640625
								],
								[
									-162.87158203124997,
									55.21860351562509
								],
								[
									-162.85712890625004,
									55.25302734375009
								],
								[
									-162.78623046874998,
									55.29707031250007
								],
								[
									-162.658984375,
									55.35078125000001
								],
								[
									-162.51337890625,
									55.450000000000074
								],
								[
									-162.349365234375,
									55.59472656249997
								],
								[
									-162.15712890625,
									55.71943359375007
								],
								[
									-161.93662109375,
									55.8241699218751
								],
								[
									-161.69731445312502,
									55.90722656250003
								],
								[
									-161.21562500000005,
									56.02143554687504
								],
								[
									-161.17861328124997,
									56.014453125000045
								],
								[
									-161.22255859375002,
									55.97744140625005
								],
								[
									-161.19252929687502,
									55.95429687500004
								],
								[
									-161.14516601562497,
									55.951318359374966
								],
								[
									-160.96865234374997,
									55.969628906249966
								],
								[
									-160.8986328125,
									55.99365234374997
								],
								[
									-160.87783203124997,
									55.97050781249996
								],
								[
									-160.902392578125,
									55.941308593749966
								],
								[
									-161.0083984375,
									55.91171874999998
								],
								[
									-161.00537109375,
									55.88715820312504
								],
								[
									-160.85131835937497,
									55.771874999999994
								],
								[
									-160.80283203125003,
									55.7544433593751
								],
								[
									-160.76259765625002,
									55.756591796875085
								],
								[
									-160.7455078125,
									55.771484375000085
								],
								[
									-160.75839843749998,
									55.85463867187508
								],
								[
									-160.70634765625002,
									55.870458984375006
								],
								[
									-160.59970703124998,
									55.874316406250074
								],
								[
									-160.530224609375,
									55.86347656250001
								],
								[
									-160.497900390625,
									55.83789062499994
								],
								[
									-160.43691406250002,
									55.816699218750074
								],
								[
									-160.34731445312497,
									55.79990234375012
								],
								[
									-160.29169921875,
									55.80507812500011
								],
								[
									-160.27011718749998,
									55.83217773437494
								],
								[
									-160.30849609374997,
									55.86445312500004
								],
								[
									-160.47988281249997,
									55.93544921875002
								],
								[
									-160.52744140624998,
									55.96503906250001
								],
								[
									-160.53906250000006,
									56.00629882812507
								],
								[
									-160.51469726562496,
									56.05913085937499
								],
								[
									-160.46083984375002,
									56.137500000000045
								],
								[
									-160.377490234375,
									56.241455078125085
								],
								[
									-160.30205078125,
									56.31411132812508
								],
								[
									-160.14926757812503,
									56.396337890625034
								],
								[
									-160.046240234375,
									56.43701171874997
								],
								[
									-159.78505859375,
									56.56162109374995
								],
								[
									-159.28310546874997,
									56.68857421875006
								],
								[
									-159.159033203125,
									56.77006835937496
								],
								[
									-158.99038085937502,
									56.8600585937501
								],
								[
									-158.91801757812502,
									56.88217773437498
								],
								[
									-158.91801757812502,
									56.847412109375
								],
								[
									-158.894873046875,
									56.816406250000085
								],
								[
									-158.78208007812503,
									56.795751953125034
								],
								[
									-158.70883789062503,
									56.78857421875
								],
								[
									-158.675146484375,
									56.794873046874955
								],
								[
									-158.66591796875,
									56.82792968750002
								],
								[
									-158.68105468749997,
									56.88774414062496
								],
								[
									-158.68481445312503,
									56.94423828125011
								],
								[
									-158.67724609375,
									56.997363281250074
								],
								[
									-158.66079101562502,
									57.03940429687495
								],
								[
									-158.58559570312497,
									57.114062500000045
								],
								[
									-158.47373046875,
									57.19907226562506
								],
								[
									-158.32094726562497,
									57.29790039062502
								],
								[
									-158.22451171874997,
									57.34267578125008
								],
								[
									-158.133544921875,
									57.366406249999955
								],
								[
									-158.04570312500005,
									57.40947265624993
								],
								[
									-157.8943359375,
									57.511376953124994
								],
								[
									-157.845751953125,
									57.52807617187503
								],
								[
									-157.73720703124997,
									57.54814453125002
								],
								[
									-157.69741210937502,
									57.5392578125001
								],
								[
									-157.67402343749998,
									57.513720703125045
								],
								[
									-157.64555664062493,
									57.497802734375085
								],
								[
									-157.53530273437497,
									57.48344726562499
								],
								[
									-157.4619140625,
									57.506201171875006
								],
								[
									-157.47387695312497,
									57.518212890624966
								],
								[
									-157.53349609374993,
									57.52587890625003
								],
								[
									-157.57163085937498,
									57.54067382812502
								],
								[
									-157.60756835937502,
									57.601464843749966
								],
								[
									-157.6806640625,
									57.638085937499966
								],
								[
									-157.697216796875,
									57.67944335937506
								],
								[
									-157.68398437499997,
									57.74389648437494
								],
								[
									-157.62119140624998,
									57.89521484375004
								],
								[
									-157.610888671875,
									58.05083007812513
								],
								[
									-157.55502929687498,
									58.139941406250074
								],
								[
									-157.44267578125,
									58.172167968750045
								],
								[
									-157.193701171875,
									58.19418945312509
								],
								[
									-157.33940429687502,
									58.234521484374966
								],
								[
									-157.39360351562496,
									58.23481445312504
								],
								[
									-157.48837890624998,
									58.253710937500074
								],
								[
									-157.52441406249994,
									58.35073242187494
								],
								[
									-157.52363281249998,
									58.421337890624926
								],
								[
									-157.46088867187498,
									58.50302734375006
								],
								[
									-157.22885742187498,
									58.64091796874999
								],
								[
									-156.97465820312496,
									58.73632812499997
								],
								[
									-157.00903320312506,
									58.744189453125074
								],
								[
									-157.04047851562507,
									58.77255859374998
								],
								[
									-156.92324218749997,
									58.96367187500002
								],
								[
									-156.80888671875005,
									59.13427734375006
								],
								[
									-156.96337890624997,
									58.98886718750009
								],
								[
									-157.14204101562504,
									58.87763671874998
								],
								[
									-157.66572265624995,
									58.74848632812504
								],
								[
									-158.02192382812498,
									58.64018554687502
								],
								[
									-158.19091796875003,
									58.61425781249997
								],
								[
									-158.30258789062503,
									58.64179687499998
								],
								[
									-158.3896484375,
									58.7456542968751
								],
								[
									-158.439306640625,
									58.782617187499994
								],
								[
									-158.50317382812497,
									58.85034179687503
								],
								[
									-158.47626953125,
									58.93837890625002
								],
								[
									-158.42563476562498,
									58.99931640624999
								],
								[
									-158.314501953125,
									59.00932617187499
								],
								[
									-158.18920898437506,
									58.979931640624955
								],
								[
									-158.080517578125,
									58.97744140625008
								],
								[
									-158.22060546874997,
									59.03750000000005
								],
								[
									-158.422802734375,
									59.08984375000006
								],
								[
									-158.51440429687503,
									59.07285156250006
								],
								[
									-158.58447265625,
									58.98779296875006
								],
								[
									-158.67827148437502,
									58.929394531249955
								],
								[
									-158.760595703125,
									58.95009765625008
								],
								[
									-158.80947265625002,
									58.97387695312506
								],
								[
									-158.77553710937502,
									58.9025390625001
								],
								[
									-158.837744140625,
									58.793945312500085
								],
								[
									-158.86137695312502,
									58.71874999999994
								],
								[
									-158.77211914062497,
									58.52031250000002
								],
								[
									-158.78862304687493,
									58.44096679687502
								],
								[
									-158.95068359375,
									58.40454101562497
								],
								[
									-159.08266601562497,
									58.4697753906251
								],
								[
									-159.358203125,
									58.72128906250012
								],
								[
									-159.45419921875,
									58.792919921874955
								],
								[
									-159.67026367187498,
									58.91113281249997
								],
								[
									-159.741455078125,
									58.894287109375
								],
								[
									-159.8322265625,
									58.8359863281251
								],
								[
									-159.92021484375,
									58.81987304687513
								],
								[
									-160.152587890625,
									58.905908203124966
								],
								[
									-160.26079101562502,
									58.97153320312512
								],
								[
									-160.36313476562498,
									59.051171874999994
								],
								[
									-160.51992187499997,
									59.00732421874994
								],
								[
									-160.65664062500002,
									58.95507812500003
								],
								[
									-160.81708984375,
									58.87167968750009
								],
								[
									-160.924267578125,
									58.87241210937506
								],
								[
									-161.21591796875,
									58.8009765625001
								],
								[
									-161.246826171875,
									58.79946289062505
								],
								[
									-161.287890625,
									58.760937499999926
								],
								[
									-161.32812500000003,
									58.74370117187496
								],
								[
									-161.36132812499994,
									58.66953124999995
								],
								[
									-161.75546874999998,
									58.612011718749955
								],
								[
									-162.144921875,
									58.644238281249955
								],
								[
									-162.00869140624997,
									58.6850097656251
								],
								[
									-161.85649414062505,
									58.71708984374996
								],
								[
									-161.72436523437503,
									58.79428710937506
								],
								[
									-161.780517578125,
									58.897412109374926
								],
								[
									-161.79028320312506,
									58.94995117187497
								],
								[
									-161.78867187499998,
									59.01640625000002
								],
								[
									-161.64438476562498,
									59.1096679687501
								],
								[
									-161.794482421875,
									59.10947265625006
								],
								[
									-161.890771484375,
									59.076074218749994
								],
								[
									-161.9810546875,
									59.14614257812505
								],
								[
									-162.02329101562498,
									59.28398437499999
								],
								[
									-161.9201171875,
									59.365478515625085
								],
								[
									-161.87221679687502,
									59.42827148437499
								],
								[
									-161.83168945312497,
									59.51450195312506
								],
								[
									-161.82871093749998,
									59.58862304687497
								],
								[
									-161.908642578125,
									59.71411132812506
								],
								[
									-162.138134765625,
									59.980029296875045
								],
								[
									-162.24248046875,
									60.178320312500034
								],
								[
									-162.421337890625,
									60.283984375000045
								],
								[
									-162.28779296874995,
									60.45688476562512
								],
								[
									-162.1388671875,
									60.61435546874995
								],
								[
									-161.94658203125,
									60.684814453125
								],
								[
									-161.96201171875003,
									60.69536132812502
								],
								[
									-162.06826171875002,
									60.69487304687502
								],
								[
									-162.138037109375,
									60.68554687499997
								],
								[
									-162.19990234375,
									60.63432617187502
								],
								[
									-162.26503906249997,
									60.59521484375006
								],
								[
									-162.46870117187507,
									60.394677734374966
								],
								[
									-162.59970703125,
									60.29697265624995
								],
								[
									-162.68496093749997,
									60.26894531250002
								],
								[
									-162.54770507812498,
									60.23105468750012
								],
								[
									-162.52695312500003,
									60.199121093749994
								],
								[
									-162.50048828124994,
									60.12656250000006
								],
								[
									-162.53564453125,
									60.0383789062501
								],
								[
									-162.57075195312495,
									59.98974609374997
								],
								[
									-162.7326171875,
									59.99365234374997
								],
								[
									-162.87783203125,
									59.92275390625011
								],
								[
									-163.21938476562497,
									59.84560546875011
								],
								[
									-163.68037109374998,
									59.801513671875
								],
								[
									-163.90688476562497,
									59.80678710937511
								],
								[
									-164.14282226562497,
									59.89677734374996
								],
								[
									-164.14111328124997,
									59.948876953124994
								],
								[
									-164.13154296874998,
									59.994238281250006
								],
								[
									-164.47050781250002,
									60.14931640625008
								],
								[
									-164.66225585937502,
									60.303808593750006
								],
								[
									-164.799951171875,
									60.30722656250009
								],
								[
									-164.91972656249996,
									60.34843749999996
								],
								[
									-165.0611328125,
									60.412548828124955
								],
								[
									-165.04873046874997,
									60.46425781250002
								],
								[
									-165.02651367187497,
									60.500634765624966
								],
								[
									-165.11328124999997,
									60.5260742187501
								],
								[
									-165.22451171874997,
									60.52358398437494
								],
								[
									-165.35380859375005,
									60.54121093750007
								],
								[
									-165.01601562499997,
									60.740039062500074
								],
								[
									-164.8998046875,
									60.873144531250006
								],
								[
									-164.80517578125,
									60.89204101562504
								],
								[
									-164.68237304687503,
									60.87153320312504
								],
								[
									-164.51293945312497,
									60.8190429687501
								],
								[
									-164.37006835937498,
									60.795898437500085
								],
								[
									-164.31850585937497,
									60.771289062500045
								],
								[
									-164.26567382812493,
									60.724658203125045
								],
								[
									-164.32138671875003,
									60.64663085937505
								],
								[
									-164.37236328125002,
									60.59184570312499
								],
								[
									-164.30966796875003,
									60.606738281250074
								],
								[
									-164.13183593750003,
									60.69150390624995
								],
								[
									-163.999560546875,
									60.766064453124955
								],
								[
									-163.93613281250003,
									60.75830078124997
								],
								[
									-163.894921875,
									60.74516601562496
								],
								[
									-163.82138671875003,
									60.6682617187501
								],
								[
									-163.72998046874997,
									60.589990234374966
								],
								[
									-163.5287109375,
									60.66455078125006
								],
								[
									-163.420947265625,
									60.75742187500006
								],
								[
									-163.51186523437502,
									60.7981445312501
								],
								[
									-163.62304687500003,
									60.822216796874926
								],
								[
									-163.90654296874996,
									60.853808593750074
								],
								[
									-163.8373046875,
									60.880419921875074
								],
								[
									-163.65541992187497,
									60.8774902343751
								],
								[
									-163.58691406249994,
									60.90297851562505
								],
								[
									-163.65893554687497,
									60.93823242187494
								],
								[
									-163.74902343750003,
									60.96972656250006
								],
								[
									-163.99462890624997,
									60.86469726562507
								],
								[
									-164.441552734375,
									60.86997070312498
								],
								[
									-164.75395507812493,
									60.93129882812505
								],
								[
									-165.065625,
									60.920654296875
								],
								[
									-165.11484375000003,
									60.93281250000007
								],
								[
									-165.17548828125,
									60.965673828125034
								],
								[
									-164.99990234374997,
									61.043652343749926
								],
								[
									-164.87558593750003,
									61.086767578125006
								],
								[
									-164.86899414062503,
									61.11176757812504
								],
								[
									-164.9412109375,
									61.114892578124966
								],
								[
									-165.07709960937495,
									61.09418945312501
								],
								[
									-165.13769531249997,
									61.13012695312506
								],
								[
									-165.12778320312498,
									61.192431640625045
								],
								[
									-165.150048828125,
									61.18686523437506
								],
								[
									-165.20375976562502,
									61.15283203125006
								],
								[
									-165.27978515624994,
									61.169628906249926
								],
								[
									-165.344873046875,
									61.197705078124955
								],
								[
									-165.31079101562497,
									61.22763671875009
								],
								[
									-165.24394531250005,
									61.268749999999955
								],
								[
									-165.27363281250004,
									61.274853515624955
								],
								[
									-165.33369140625,
									61.26611328124994
								],
								[
									-165.392041015625,
									61.212304687499994
								],
								[
									-165.37929687499997,
									61.1687500000001
								],
								[
									-165.38076171875002,
									61.10629882812506
								],
								[
									-165.48046875,
									61.094873046874966
								],
								[
									-165.56586914062498,
									61.102343750000074
								],
								[
									-165.62758789062502,
									61.165185546874994
								],
								[
									-165.69135742187507,
									61.29990234375009
								],
								[
									-165.86396484375004,
									61.335693359375
								],
								[
									-165.90629882812496,
									61.40380859375003
								],
								[
									-165.797119140625,
									61.49116210937507
								],
								[
									-165.84531249999998,
									61.536230468750006
								],
								[
									-165.961328125,
									61.55087890625006
								],
								[
									-166.093994140625,
									61.50673828124994
								],
								[
									-166.152734375,
									61.5459472656251
								],
								[
									-166.16352539062495,
									61.58901367187511
								],
								[
									-166.16811523437502,
									61.65083007812498
								],
								[
									-166.13115234374993,
									61.65732421874998
								],
								[
									-166.10048828125,
									61.645068359375045
								],
								[
									-165.8345703125,
									61.67939453125004
								],
								[
									-165.80893554687503,
									61.696093750000074
								],
								[
									-166.01992187500002,
									61.74829101562494
								],
								[
									-166.07880859375,
									61.80312500000002
								],
								[
									-165.99140624999998,
									61.834179687499955
								],
								[
									-165.83383789062503,
									61.83681640625005
								],
								[
									-165.61279296875003,
									61.869287109374994
								],
								[
									-165.70581054687497,
									61.92744140625004
								],
								[
									-165.72524414062502,
									61.959374999999966
								],
								[
									-165.74394531250002,
									62.01171874999997
								],
								[
									-165.707275390625,
									62.10043945312509
								],
								[
									-165.44765624999997,
									62.30390624999998
								],
								[
									-165.19453125,
									62.473535156249994
								],
								[
									-165.115625,
									62.51269531250006
								],
								[
									-164.99970703125,
									62.53378906250009
								],
								[
									-164.89184570312497,
									62.517578125
								],
								[
									-164.77919921875002,
									62.481152343749955
								],
								[
									-164.75786132812493,
									62.49672851562502
								],
								[
									-164.79609375,
									62.51162109374994
								],
								[
									-164.844384765625,
									62.58105468750006
								],
								[
									-164.68798828125,
									62.60825195312509
								],
								[
									-164.59628906249998,
									62.68666992187508
								],
								[
									-164.589453125,
									62.709374999999994
								],
								[
									-164.68896484375003,
									62.676757812500085
								],
								[
									-164.79267578125,
									62.62319335937494
								],
								[
									-164.81865234375,
									62.677050781250074
								],
								[
									-164.84541015625,
									62.80097656250001
								],
								[
									-164.79965820312503,
									62.91806640625006
								],
								[
									-164.76406249999997,
									62.97060546875011
								],
								[
									-164.67744140624998,
									63.020458984374955
								],
								[
									-164.428125,
									63.04042968749994
								],
								[
									-164.38422851562504,
									63.030468749999955
								],
								[
									-164.37509765625003,
									63.054003906250045
								],
								[
									-164.5251953125,
									63.12763671875004
								],
								[
									-164.46328124999997,
									63.18520507812494
								],
								[
									-164.40903320312503,
									63.21503906249998
								],
								[
									-164.10761718749998,
									63.261718750000085
								],
								[
									-163.94287109375,
									63.247216796874966
								],
								[
									-163.73623046875,
									63.19282226562498
								],
								[
									-163.61630859374998,
									63.125146484374966
								],
								[
									-163.63374023437498,
									63.09042968750009
								],
								[
									-163.66357421875003,
									63.070312500000085
								],
								[
									-163.725732421875,
									63.047802734374926
								],
								[
									-163.748974609375,
									63.0303222656251
								],
								[
									-163.737841796875,
									63.01640625000002
								],
								[
									-163.64936523437498,
									63.05678710937508
								],
								[
									-163.504345703125,
									63.10585937499994
								],
								[
									-163.423193359375,
									63.084521484375045
								],
								[
									-163.35883789062504,
									63.04575195312495
								],
								[
									-163.28784179687494,
									63.0464355468751
								],
								[
									-163.062255859375,
									63.07973632812505
								],
								[
									-162.947705078125,
									63.11499023437494
								],
								[
									-162.80776367187502,
									63.206591796875045
								],
								[
									-162.62148437500002,
									63.26582031250001
								],
								[
									-162.35981445312498,
									63.45258789062507
								],
								[
									-162.28281250000003,
									63.52919921875002
								],
								[
									-162.193310546875,
									63.54096679687504
								],
								[
									-162.11250000000007,
									63.534179687500085
								],
								[
									-162.05625000000003,
									63.471337890624966
								],
								[
									-161.97397460937498,
									63.452929687500045
								],
								[
									-161.505419921875,
									63.46816406250002
								],
								[
									-161.266015625,
									63.49697265625005
								],
								[
									-161.09970703125003,
									63.55791015625002
								],
								[
									-160.92670898437495,
									63.660546874999966
								],
								[
									-160.82651367187498,
									63.72934570312495
								],
								[
									-160.778564453125,
									63.818945312500006
								],
								[
									-160.84047851562497,
									63.934912109375006
								],
								[
									-160.90395507812497,
									64.03120117187498
								],
								[
									-160.987548828125,
									64.25126953125005
								],
								[
									-161.22011718749997,
									64.39658203125009
								],
								[
									-161.38569335937504,
									64.43994140624994
								],
								[
									-161.49072265625003,
									64.43378906250004
								],
								[
									-161.414599609375,
									64.52636718749997
								],
								[
									-161.19306640625007,
									64.51640624999999
								],
								[
									-161.04877929687495,
									64.53447265625002
								],
								[
									-160.93193359374996,
									64.57910156249997
								],
								[
									-160.893701171875,
									64.612890625
								],
								[
									-160.83603515624998,
									64.68193359374996
								],
								[
									-160.855908203125,
									64.75561523437506
								],
								[
									-160.88696289062506,
									64.79555664062511
								],
								[
									-160.96748046875,
									64.83955078125001
								],
								[
									-161.063232421875,
									64.90400390624998
								],
								[
									-161.13017578125005,
									64.92543945312508
								],
								[
									-161.18691406249997,
									64.92402343749998
								],
								[
									-161.46635742187493,
									64.79487304687495
								],
								[
									-161.633984375,
									64.79248046875
								],
								[
									-161.75937499999998,
									64.81625976562506
								],
								[
									-161.86831054687497,
									64.74267578125009
								],
								[
									-162.17226562499997,
									64.67807617187506
								],
								[
									-162.33461914062502,
									64.6128417968751
								],
								[
									-162.63574218749997,
									64.45083007812502
								],
								[
									-162.71108398437497,
									64.37753906250003
								],
								[
									-162.80703124999997,
									64.37421875000007
								],
								[
									-162.87641601562498,
									64.51640624999999
								],
								[
									-163.20390625,
									64.65200195312508
								],
								[
									-163.30283203124998,
									64.60590820312493
								],
								[
									-163.24829101562497,
									64.56328125000013
								],
								[
									-163.17407226562494,
									64.53295898437506
								],
								[
									-163.0517578125,
									64.51972656249995
								],
								[
									-163.1044921875,
									64.47861328125
								],
								[
									-163.14433593750005,
									64.42382812500003
								],
								[
									-163.26704101562498,
									64.47519531250003
								],
								[
									-163.48618164062503,
									64.54980468749994
								],
								[
									-163.71308593749998,
									64.58823242187506
								],
								[
									-164.30395507812503,
									64.58393554687507
								],
								[
									-164.691845703125,
									64.50742187500012
								],
								[
									-164.72749023437498,
									64.52329101562506
								],
								[
									-164.76494140624996,
									64.52963867187509
								],
								[
									-164.82954101562498,
									64.51137695312494
								],
								[
									-164.85727539062503,
									64.480322265625
								],
								[
									-164.89951171875003,
									64.46064453125007
								],
								[
									-164.978759765625,
									64.45366210937499
								],
								[
									-165.13813476562495,
									64.46523437500005
								],
								[
									-165.44619140625002,
									64.51284179687497
								],
								[
									-166.1427734375,
									64.582763671875
								],
								[
									-166.32509765625002,
									64.62573242187506
								],
								[
									-166.48139648437498,
									64.72807617187513
								],
								[
									-166.47812500000003,
									64.79755859375007
								],
								[
									-166.40869140625,
									64.82695312500002
								],
								[
									-166.415234375,
									64.92651367187506
								],
								[
									-166.55087890625,
									64.95297851562512
								],
								[
									-166.82695312499993,
									65.09609375000005
								],
								[
									-166.92841796875,
									65.15708007812495
								],
								[
									-166.90639648437497,
									65.16381835937509
								],
								[
									-166.85678710937498,
									65.14726562499999
								],
								[
									-166.76254882812498,
									65.13491210937505
								],
								[
									-166.53100585937494,
									65.1547363281251
								],
								[
									-166.45166015624994,
									65.24731445312494
								],
								[
									-166.27968750000002,
									65.273779296875
								],
								[
									-166.12148437500002,
									65.26074218750011
								],
								[
									-166.15703125,
									65.28583984375007
								],
								[
									-166.19741210937502,
									65.30556640625
								],
								[
									-166.60937500000003,
									65.35273437499993
								],
								[
									-166.66538085937498,
									65.33828125
								],
								[
									-167.40400390625,
									65.42211914062494
								],
								[
									-167.98725585937498,
									65.56777343750002
								],
								[
									-168.03500976562503,
									65.59560546874994
								],
								[
									-168.08837890624997,
									65.65776367187499
								],
								[
									-168.00966796875002,
									65.71914062499997
								],
								[
									-167.93056640624997,
									65.74814453125
								],
								[
									-167.92700195312497,
									65.71435546874997
								],
								[
									-167.91435546874996,
									65.68120117187496
								],
								[
									-167.58002929687498,
									65.75830078124994
								],
								[
									-167.405322265625,
									65.85932617187493
								],
								[
									-167.07421874999994,
									65.87705078124998
								],
								[
									-166.997216796875,
									65.90493164062508
								],
								[
									-166.89443359375002,
									65.95917968749993
								],
								[
									-166.74765625000003,
									66.05185546874998
								],
								[
									-166.54013671875003,
									66.10063476562505
								],
								[
									-166.39873046875002,
									66.14443359375011
								],
								[
									-166.21459960937497,
									66.17026367187495
								],
								[
									-166.05742187500002,
									66.12724609375007
								],
								[
									-166.008935546875,
									66.12133789062511
								],
								[
									-165.723681640625,
									66.112548828125
								],
								[
									-165.629931640625,
									66.13120117187498
								],
								[
									-165.58999023437502,
									66.14511718749998
								],
								[
									-165.56020507812497,
									66.16708984375
								],
								[
									-165.84023437500002,
									66.2450683593751
								],
								[
									-165.811865234375,
									66.28847656250005
								],
								[
									-165.77617187500002,
									66.31904296875007
								],
								[
									-165.44941406249995,
									66.409912109375
								],
								[
									-165.19829101562496,
									66.43994140625
								],
								[
									-165.06396484374994,
									66.437841796875
								],
								[
									-164.67412109375002,
									66.55502929687509
								],
								[
									-164.46049804687502,
									66.58842773437496
								],
								[
									-164.05825195312497,
									66.61074218750005
								],
								[
									-163.72768554687502,
									66.61645507812509
								],
								[
									-163.63823242187502,
									66.5746582031251
								],
								[
									-163.81572265625005,
									66.58349609375003
								],
								[
									-163.89394531249997,
									66.57587890624998
								],
								[
									-163.838232421875,
									66.56157226562499
								],
								[
									-163.77548828125,
									66.531103515625
								],
								[
									-163.793701171875,
									66.49262695312498
								],
								[
									-163.90288085937502,
									66.37836914062507
								],
								[
									-163.89394531249997,
									66.28691406249999
								],
								[
									-163.96499023437497,
									66.25732421875
								],
								[
									-164.03374023437493,
									66.21552734374993
								],
								[
									-163.69536132812502,
									66.083837890625
								],
								[
									-163.17143554687496,
									66.07543945312509
								],
								[
									-162.886474609375,
									66.09921874999995
								],
								[
									-162.72177734375,
									66.059814453125
								],
								[
									-162.58686523437495,
									66.05083007812505
								],
								[
									-162.2142578125,
									66.07104492187506
								],
								[
									-161.93369140625003,
									66.04287109375002
								],
								[
									-161.81630859375002,
									66.05366210937507
								],
								[
									-161.5568359375,
									66.25053710937496
								],
								[
									-161.45541992187503,
									66.28139648437494
								],
								[
									-161.34506835937503,
									66.24716796874998
								],
								[
									-161.20107421875,
									66.21938476562508
								],
								[
									-161.10922851562503,
									66.23950195312511
								],
								[
									-161.03427734375003,
									66.18881835937509
								],
								[
									-161.06953125,
									66.29462890625007
								],
								[
									-161.12031249999995,
									66.33432617187498
								],
								[
									-161.54443359374994,
									66.40703125000005
								],
								[
									-161.82817382812493,
									66.37084960937503
								],
								[
									-161.91689453125,
									66.41181640624995
								],
								[
									-161.88759765624997,
									66.49306640625008
								],
								[
									-162.191162109375,
									66.69311523437497
								],
								[
									-162.31772460937503,
									66.73369140625007
								],
								[
									-162.46743164062497,
									66.73564453125002
								],
								[
									-162.54365234375004,
									66.80512695312504
								],
								[
									-162.607421875,
									66.89438476562503
								],
								[
									-162.4783203125,
									66.930810546875
								],
								[
									-162.36162109375,
									66.94731445312507
								],
								[
									-162.25356445312502,
									66.9186523437501
								],
								[
									-162.131396484375,
									66.80136718750009
								],
								[
									-162.017626953125,
									66.78413085937495
								],
								[
									-162.05073242187498,
									66.66728515625005
								],
								[
									-161.90957031250002,
									66.55961914062505
								],
								[
									-161.59101562500004,
									66.45952148437499
								],
								[
									-161.33593750000003,
									66.49633789062494
								],
								[
									-161.15581054687502,
									66.4953125000001
								],
								[
									-161.04814453125002,
									66.47421875000006
								],
								[
									-160.78447265624993,
									66.38437499999995
								],
								[
									-160.65053710937502,
									66.37309570312496
								],
								[
									-160.23168945312506,
									66.42026367187498
								],
								[
									-160.22734374999993,
									66.50854492187494
								],
								[
									-160.26254882812503,
									66.57246093750007
								],
								[
									-160.360888671875,
									66.61249999999998
								],
								[
									-160.64379882812497,
									66.60498046875006
								],
								[
									-160.864013671875,
									66.67084960937504
								],
								[
									-161.05146484374998,
									66.65278320312493
								],
								[
									-161.39804687499998,
									66.55185546875006
								],
								[
									-161.571728515625,
									66.59160156249999
								],
								[
									-161.68090820312494,
									66.64550781250003
								],
								[
									-161.856689453125,
									66.70034179687494
								],
								[
									-161.87875976562503,
									66.80395507812509
								],
								[
									-161.73129882812503,
									66.92280273437495
								],
								[
									-161.622216796875,
									66.97934570312512
								],
								[
									-161.719921875,
									67.02055664062507
								],
								[
									-161.96542968750003,
									67.04956054687503
								],
								[
									-162.39155273437495,
									67.01987304687509
								],
								[
									-162.41157226562507,
									67.06030273437509
								],
								[
									-162.40942382812497,
									67.10395507812501
								],
								[
									-162.58310546875,
									67.01850585937501
								],
								[
									-162.76142578125,
									67.03642578125002
								],
								[
									-163.001708984375,
									67.02729492187493
								],
								[
									-163.5318359375,
									67.10258789062499
								],
								[
									-163.720556640625,
									67.19555664062511
								],
								[
									-163.7998046875,
									67.27099609375011
								],
								[
									-163.94267578124996,
									67.4775878906251
								],
								[
									-164.1251953125,
									67.6067382812501
								],
								[
									-165.38603515625002,
									68.0456054687501
								],
								[
									-165.95957031249998,
									68.155908203125
								],
								[
									-166.23593749999998,
									68.27792968750006
								],
								[
									-166.409130859375,
									68.30795898437498
								],
								[
									-166.57446289062503,
									68.3202636718751
								],
								[
									-166.78627929687502,
									68.35961914062503
								],
								[
									-166.64389648437503,
									68.40800781250002
								],
								[
									-166.54589843749997,
									68.42436523437507
								],
								[
									-166.64785156249997,
									68.37382812499999
								],
								[
									-166.57041015624998,
									68.36108398437506
								],
								[
									-166.447021484375,
									68.39023437499995
								],
								[
									-166.38051757812502,
									68.42514648437503
								],
								[
									-166.28295898437497,
									68.57324218750003
								],
								[
									-166.18203125000002,
									68.79721679687509
								],
								[
									-166.20908203125,
									68.8853515625
								],
								[
									-165.50947265625004,
									68.86757812499994
								],
								[
									-165.04394531249997,
									68.88247070312505
								],
								[
									-164.889697265625,
									68.90244140625003
								],
								[
									-164.30234375000003,
									68.93647460937504
								],
								[
									-164.15019531249996,
									68.961181640625
								],
								[
									-163.867919921875,
									69.03666992187502
								],
								[
									-163.535693359375,
									69.17011718750004
								],
								[
									-163.250537109375,
									69.34536132812494
								],
								[
									-163.20517578124998,
									69.39252929687495
								],
								[
									-163.18710937500003,
									69.38046874999998
								],
								[
									-163.16147460937498,
									69.387939453125
								],
								[
									-163.13100585937497,
									69.45434570312503
								],
								[
									-163.0935546875,
									69.61069335937509
								],
								[
									-162.95209960937504,
									69.7581054687501
								],
								[
									-162.35039062500002,
									70.09414062500008
								],
								[
									-162.07114257812498,
									70.227197265625
								],
								[
									-161.977978515625,
									70.28764648437505
								],
								[
									-161.88095703125003,
									70.33173828124998
								],
								[
									-161.81259765624998,
									70.28984375000007
								],
								[
									-161.77993164062497,
									70.27734375
								],
								[
									-161.76108398437503,
									70.25766601562509
								],
								[
									-161.818408203125,
									70.24843750000005
								],
								[
									-161.91196289062498,
									70.20546875000002
								],
								[
									-162.04238281249997,
									70.17666015625011
								],
								[
									-162.073876953125,
									70.16196289062495
								],
								[
									-161.99741210937498,
									70.16523437499998
								],
								[
									-161.76816406249998,
									70.19653320312497
								],
								[
									-161.63901367187503,
									70.23452148437508
								],
								[
									-160.9962890625,
									70.30458984375005
								],
								[
									-160.64765625000007,
									70.42055664062505
								],
								[
									-160.63413085937503,
									70.44638671874998
								],
								[
									-160.11713867187495,
									70.5912109375
								],
								[
									-160.04560546875007,
									70.58559570312511
								],
								[
									-159.96313476562506,
									70.5681640625001
								],
								[
									-160.106396484375,
									70.47255859375008
								],
								[
									-160.00556640624998,
									70.44755859375005
								],
								[
									-160.095068359375,
									70.33330078125013
								],
								[
									-159.90756835937498,
									70.33144531250011
								],
								[
									-159.86567382812498,
									70.27885742187496
								],
								[
									-159.855224609375,
									70.32416992187495
								],
								[
									-159.85751953125003,
									70.38925781249998
								],
								[
									-159.842626953125,
									70.45302734375
								],
								[
									-159.81499023437496,
									70.4970703125
								],
								[
									-159.68330078125007,
									70.47714843750003
								],
								[
									-159.38676757812493,
									70.52451171875009
								],
								[
									-159.74619140624998,
									70.53046875000007
								],
								[
									-159.96181640625002,
									70.6340820312501
								],
								[
									-160.08159179687502,
									70.63486328125
								],
								[
									-159.680908203125,
									70.78676757812505
								],
								[
									-159.31450195312496,
									70.87851562500009
								],
								[
									-159.23173828125,
									70.87675781249999
								],
								[
									-159.191748046875,
									70.85966796875007
								],
								[
									-159.18315429687505,
									70.83193359375011
								],
								[
									-159.26220703124997,
									70.81386718749997
								],
								[
									-159.33984374999997,
									70.78125000000009
								],
								[
									-159.30415039062498,
									70.7525390625
								],
								[
									-159.251171875,
									70.74843749999997
								],
								[
									-159.07504882812503,
									70.77207031249998
								],
								[
									-158.99628906249995,
									70.80161132812506
								],
								[
									-158.62094726562498,
									70.79902343750007
								],
								[
									-158.51083984375003,
									70.8201171875001
								],
								[
									-158.48437499999994,
									70.841064453125
								],
								[
									-157.998486328125,
									70.84531249999998
								],
								[
									-157.90937500000007,
									70.86010742187497
								],
								[
									-157.60561523437497,
									70.94125976562509
								],
								[
									-157.32475585937496,
									71.03959960937505
								],
								[
									-157.19531249999997,
									71.09326171875006
								],
								[
									-156.97333984375007,
									71.23002929687502
								],
								[
									-156.78330078124998,
									71.31894531250012
								],
								[
									-156.47021484374994,
									71.40766601562507
								],
								[
									-156.39526367187494,
									71.39667968749995
								],
								[
									-156.49667968750003,
									71.37910156249993
								],
								[
									-156.567236328125,
									71.341552734375
								],
								[
									-156.469970703125,
									71.29155273437513
								],
								[
									-155.81113281249998,
									71.18842773437498
								],
								[
									-155.64560546875,
									71.18276367187508
								],
								[
									-155.57944335937503,
									71.12109374999994
								],
								[
									-155.6345703125,
									71.06157226562499
								],
								[
									-155.80434570312502,
									70.9954101562501
								],
								[
									-156.14658203125003,
									70.92783203125
								],
								[
									-156.041943359375,
									70.90224609375002
								],
								[
									-155.97353515625002,
									70.84199218749993
								],
								[
									-155.87221679687497,
									70.83466796875004
								],
								[
									-155.70805664062505,
									70.85727539062512
								],
								[
									-155.57939453125002,
									70.89433593750002
								],
								[
									-155.31337890625,
									71.014990234375
								],
								[
									-155.229736328125,
									71.08222656249993
								],
								[
									-155.16684570312498,
									71.09921875000012
								],
								[
									-154.943798828125,
									71.08305664062502
								],
								[
									-154.81752929687497,
									71.04848632812508
								],
								[
									-154.67368164062498,
									70.9871093750001
								],
								[
									-154.72631835937506,
									70.92778320312507
								],
								[
									-154.78520507812496,
									70.89428710937511
								],
								[
									-154.59863281249994,
									70.84799804687509
								],
								[
									-154.3921875,
									70.83833007812498
								],
								[
									-154.19521484375002,
									70.80112304687495
								],
								[
									-153.918212890625,
									70.87734374999994
								],
								[
									-153.70136718750004,
									70.89360351562496
								],
								[
									-153.49770507812502,
									70.89106445312498
								],
								[
									-153.23291015625,
									70.9325683593751
								],
								[
									-152.78491210937503,
									70.87602539062502
								],
								[
									-152.67084960937495,
									70.89072265625009
								],
								[
									-152.49121093749997,
									70.88095703125006
								],
								[
									-152.30039062499998,
									70.84677734375009
								],
								[
									-152.23291015625,
									70.81035156249996
								],
								[
									-152.437255859375,
									70.73325195312498
								],
								[
									-152.47060546875002,
									70.6536132812501
								],
								[
									-152.39921874999996,
									70.620458984375
								],
								[
									-152.26967773437497,
									70.61474609375
								],
								[
									-152.253369140625,
									70.56826171874994
								],
								[
									-152.17294921874998,
									70.55664062499997
								],
								[
									-151.76904296875,
									70.56015624999998
								],
								[
									-151.79990234374998,
									70.5380371093751
								],
								[
									-151.81962890625002,
									70.51132812499998
								],
								[
									-151.944677734375,
									70.45209960937498
								],
								[
									-151.22480468749998,
									70.41875000000013
								],
								[
									-151.12802734374998,
									70.45161132812498
								],
								[
									-150.979052734375,
									70.46469726562498
								],
								[
									-150.66264648437505,
									70.50991210937505
								],
								[
									-150.543505859375,
									70.49013671875011
								],
								[
									-150.40322265625002,
									70.4438964843751
								],
								[
									-150.2736328125,
									70.43432617187509
								],
								[
									-150.15249023437502,
									70.44370117187506
								],
								[
									-149.87011718750006,
									70.50966796875
								],
								[
									-149.54404296875003,
									70.51289062500004
								],
								[
									-149.41059570312504,
									70.49140625000001
								],
								[
									-149.26943359374997,
									70.50078124999996
								],
								[
									-148.84477539062496,
									70.42519531250002
								],
								[
									-148.68837890624997,
									70.41630859375007
								],
								[
									-148.47919921875,
									70.3179199218751
								],
								[
									-148.37114257812502,
									70.31499023437513
								],
								[
									-148.24877929687494,
									70.35673828125002
								],
								[
									-148.14272460937502,
									70.35546875000003
								],
								[
									-148.03906250000006,
									70.31547851562496
								],
								[
									-147.86953124999997,
									70.30327148437496
								],
								[
									-147.79057617187496,
									70.24013671874997
								],
								[
									-147.70537109375,
									70.21723632812493
								],
								[
									-147.06293945312504,
									70.17041015624997
								],
								[
									-146.744873046875,
									70.19174804687498
								],
								[
									-146.28125000000006,
									70.18613281249998
								],
								[
									-146.05766601562496,
									70.15625000000003
								],
								[
									-145.82314453124997,
									70.16005859375
								],
								[
									-145.44008789062502,
									70.05092773437497
								],
								[
									-145.23681640625,
									70.03393554687497
								],
								[
									-145.19736328125003,
									70.00869140625008
								],
								[
									-144.619189453125,
									69.98212890624998
								],
								[
									-144.41689453125002,
									70.03901367187504
								],
								[
									-144.064111328125,
									70.0541015625
								],
								[
									-143.74643554687503,
									70.10195312500005
								],
								[
									-143.56640625000003,
									70.10146484374997
								],
								[
									-143.35703125,
									70.08955078125001
								],
								[
									-143.27646484375003,
									70.09531249999995
								],
								[
									-143.218310546875,
									70.11625976562496
								],
								[
									-142.70786132812498,
									70.03378906249995
								],
								[
									-142.42211914062494,
									69.9395019531251
								],
								[
									-142.29697265625003,
									69.86987304687494
								],
								[
									-141.69921875000003,
									69.770361328125
								],
								[
									-141.5263671875,
									69.71469726562495
								],
								[
									-141.40791015625,
									69.65336914062507
								],
								[
									-141.33862304687503,
									69.64677734375005
								],
								[
									-141.28964843749998,
									69.66469726562508
								],
								[
									-141.080810546875,
									69.65942382812497
								],
								[
									-141.00214843750004,
									69.65078125000008
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Northern America",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "USA",
					"su_a3": "USA",
					"brk_group": "",
					"region_wb": "North America",
					"wb_a3": "USA",
					"gu_a3": "USA",
					"abbrev": "U.S.A.",
					"region_un": "Americas",
					"adm0_a3_us": "USA",
					"scalerank": 1,
					"pop_est": 313973000,
					"adm0_dif": 1,
					"un_a3": "840",
					"pop_year": 0,
					"gdp_md_est": 15094000,
					"name": "United States",
					"sovereignt": "United States of America",
					"economy": "1. Developed region: G7",
					"type": "Country",
					"abbrev_len": 6,
					"su_dif": 0,
					"gdp_year": 0,
					"woe_id": -99,
					"income_grp": "1. High income: OECD",
					"geou_dif": 0,
					"geounit": "United States of America",
					"postal": "US",
					"sov_a3": "US1",
					"note_brk": "",
					"brk_a3": "USA",
					"wb_a2": "US",
					"brk_diff": 0,
					"admin": "United States of America",
					"name_long": "United States",
					"iso_a3": "USA",
					"iso_a2": "US",
					"adm0_a3_is": "USA",
					"level": 2,
					"formal_en": "United States of America",
					"name_len": 13,
					"mapcolor7": 4,
					"long_len": 13,
					"mapcolor8": 5,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "840",
					"homepart": 1,
					"subunit": "United States of America",
					"name_alt": "",
					"brk_name": "United States",
					"name_sort": "United States of America",
					"continent": "North America",
					"mapcolor13": 1,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": 0,
					"lastcensus": 2010
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									71.77968750000008,
									39.950244140625074
								],
								[
									71.75292968750006,
									39.90712890625011
								],
								[
									71.70585937500016,
									39.91743164062507
								],
								[
									71.6689453125,
									39.946093750000045
								],
								[
									71.68125000000003,
									39.96865234375002
								],
								[
									71.73652343750007,
									39.98095703125003
								],
								[
									71.76533203125007,
									39.99326171875006
								],
								[
									71.78994140625014,
									39.99531250000004
								],
								[
									71.77968750000008,
									39.950244140625074
								]
							]
						],
						[
							[
								[
									71.20615234375003,
									39.89257812499997
								],
								[
									71.15625,
									39.88344726562508
								],
								[
									71.06425781249999,
									39.88491210937511
								],
								[
									71.01171875000006,
									39.895117187500034
								],
								[
									71.04365234375007,
									39.97631835937506
								],
								[
									71.04482421875014,
									39.99252929687509
								],
								[
									71.04101562500006,
									39.994921875000045
								],
								[
									71.01445312500005,
									40.00576171875002
								],
								[
									70.9744140625001,
									40.03886718750002
								],
								[
									70.96064453125001,
									40.08798828125009
								],
								[
									70.97626953125013,
									40.13325195312507
								],
								[
									71.00546875000009,
									40.15229492187504
								],
								[
									71.02412109375018,
									40.14916992187503
								],
								[
									71.0803710937501,
									40.07988281250002
								],
								[
									71.13027343750014,
									40.05966796875009
								],
								[
									71.22871093750013,
									40.04814453124996
								],
								[
									71.17929687500009,
									39.97983398437506
								],
								[
									71.21562499999999,
									39.90678710937502
								],
								[
									71.20615234375003,
									39.89257812499997
								]
							]
						],
						[
							[
								[
									58.74845301683462,
									45.46969817629909
								],
								[
									58.807031249999966,
									45.44179687499994
								],
								[
									58.94511718750016,
									45.37597656250003
								],
								[
									59.083398437499966,
									45.31020507812505
								],
								[
									59.221484375000045,
									45.24443359374996
								],
								[
									59.35957031250001,
									45.178613281249966
								],
								[
									59.434514017608365,
									45.142967387612714
								],
								[
									59.381445312500034,
									45.041406249999994
								],
								[
									59.26103515624999,
									44.85644531250006
								],
								[
									59.2021484375,
									44.74536132812497
								],
								[
									59.20458984375006,
									44.708105468750034
								],
								[
									59.24052734374999,
									44.654687499999994
								],
								[
									59.31015625000009,
									44.58520507812503
								],
								[
									59.64863281250001,
									44.34033203124997
								],
								[
									59.64804687500009,
									44.31987304687499
								],
								[
									59.56699218750009,
									44.24257812500005
								],
								[
									59.53974609375007,
									44.197900390624994
								],
								[
									59.52988281250009,
									44.16875000000002
								],
								[
									59.54101562500006,
									44.14824218750002
								],
								[
									59.71787109375009,
									44.16313476562502
								],
								[
									59.81093750000002,
									44.18237304687503
								],
								[
									59.92080078125002,
									44.234521484374994
								],
								[
									59.93574218750007,
									44.253173828125
								],
								[
									59.92832031250009,
									44.268652343750034
								],
								[
									59.8984375,
									44.28105468749999
								],
								[
									59.8857421875,
									44.29692382812502
								],
								[
									59.89013671875,
									44.31616210937503
								],
								[
									59.91992187500006,
									44.329199218750034
								],
								[
									59.975195312500034,
									44.33598632812499
								],
								[
									60.013281250000034,
									44.36206054687506
								],
								[
									60.03437500000001,
									44.40737304687505
								],
								[
									60.02851562500007,
									44.48437500000003
								],
								[
									59.995703125000034,
									44.59296875000001
								],
								[
									59.99814453125009,
									44.67026367187506
								],
								[
									60.035937500000045,
									44.716210937499994
								],
								[
									60.05517578125006,
									44.84125976562498
								],
								[
									60.05531302875323,
									44.84736645272321
								],
								[
									60.18847656249994,
									44.783984375000045
								],
								[
									60.32666015624994,
									44.718212890624955
								],
								[
									60.46474609375002,
									44.65244140625006
								],
								[
									60.60292968750002,
									44.58662109375007
								],
								[
									60.74111328125002,
									44.52084960937506
								],
								[
									60.87919921875016,
									44.455078125
								],
								[
									61.00791015625009,
									44.39379882812494
								],
								[
									61.065332031249966,
									44.34838867187503
								],
								[
									61.097070312500136,
									44.248242187499955
								],
								[
									61.160742187500034,
									44.16860351562508
								],
								[
									61.27148437499994,
									44.082275390625085
								],
								[
									61.38505859374999,
									43.99394531249993
								],
								[
									61.525878906250114,
									43.87719726562503
								],
								[
									61.623632812500034,
									43.796191406250045
								],
								[
									61.72324218750009,
									43.713574218749926
								],
								[
									61.887597656249966,
									43.57724609374995
								],
								[
									61.990234375000114,
									43.492138671874926
								],
								[
									62.07197265625018,
									43.48935546875006
								],
								[
									62.237890625000034,
									43.50957031249993
								],
								[
									62.459375000000136,
									43.53662109375003
								],
								[
									62.63447265625018,
									43.55800781249994
								],
								[
									62.84619140624994,
									43.583886718749966
								],
								[
									63.04765625000016,
									43.608496093750006
								],
								[
									63.207031250000114,
									43.627978515625074
								],
								[
									63.44482421875,
									43.6132324218751
								],
								[
									63.67968749999994,
									43.59863281250006
								],
								[
									63.84814453125,
									43.58813476562494
								],
								[
									64.01328125000003,
									43.57783203124998
								],
								[
									64.20878906249999,
									43.5657226562501
								],
								[
									64.31816406249999,
									43.55893554687495
								],
								[
									64.44316406250016,
									43.551171874999966
								],
								[
									64.49609375000011,
									43.57163085937506
								],
								[
									64.60410156250009,
									43.613476562499955
								],
								[
									64.7060546875,
									43.65297851562511
								],
								[
									64.81181640625005,
									43.693945312500006
								],
								[
									64.90546875000018,
									43.71469726562498
								],
								[
									65.00312500000018,
									43.64907226562502
								],
								[
									65.08486328125014,
									43.57368164062501
								],
								[
									65.17089843750011,
									43.49418945312499
								],
								[
									65.27050781249994,
									43.4175292968751
								],
								[
									65.36650390625016,
									43.37202148437507
								],
								[
									65.49619140625009,
									43.31054687499997
								],
								[
									65.57070312500002,
									43.20517578125009
								],
								[
									65.67021484375005,
									43.06459960937505
								],
								[
									65.73564453125005,
									42.97211914062504
								],
								[
									65.80302734374999,
									42.876953125000114
								],
								[
									65.90107421875018,
									42.91450195312501
								],
								[
									66.00566406250016,
									42.954589843750114
								],
								[
									66.10029296875018,
									42.990820312500034
								],
								[
									66.08886718749994,
									42.87338867187509
								],
								[
									66.07851562499997,
									42.76665039062502
								],
								[
									66.06269531250007,
									42.60517578125007
								],
								[
									66.04980468750011,
									42.47275390625009
								],
								[
									66.01552734375014,
									42.31479492187506
								],
								[
									66.01318359375011,
									42.19448242187505
								],
								[
									66.01123046874994,
									42.08876953125002
								],
								[
									66.00957031250016,
									42.004882812500085
								],
								[
									66.19316406250016,
									42.00112304687502
								],
								[
									66.32880859375018,
									41.998339843750074
								],
								[
									66.49863281250003,
									41.994873046875085
								],
								[
									66.51503906250002,
									41.889404296875085
								],
								[
									66.53789062500016,
									41.74125976562502
								],
								[
									66.57255859374999,
									41.60698242187502
								],
								[
									66.60166015625009,
									41.49433593750007
								],
								[
									66.64531249999999,
									41.34863281250006
								],
								[
									66.66865234375007,
									41.270751953125085
								],
								[
									66.70966796875007,
									41.17915039062498
								],
								[
									66.74980468750016,
									41.15708007812509
								],
								[
									66.81425781250005,
									41.142382812500045
								],
								[
									67.03867187500003,
									41.15332031250006
								],
								[
									67.22500000000014,
									41.16235351562503
								],
								[
									67.37158203125,
									41.16953124999998
								],
								[
									67.52802734375007,
									41.17714843750002
								],
								[
									67.73505859375007,
									41.18725585937494
								],
								[
									67.80507812500002,
									41.16391601562506
								],
								[
									67.86572265625011,
									41.180273437500034
								],
								[
									67.93574218750018,
									41.196582031250074
								],
								[
									67.99140625000007,
									41.13002929687511
								],
								[
									68.01972656250007,
									41.09624023437496
								],
								[
									68.05937500000005,
									41.06127929687494
								],
								[
									68.11308593750016,
									41.028613281250045
								],
								[
									68.09033203124994,
									40.960253906250074
								],
								[
									68.05703125000002,
									40.860595703125085
								],
								[
									68.04765625000016,
									40.80927734375004
								],
								[
									68.1123046875,
									40.75405273437505
								],
								[
									68.16025390625009,
									40.72177734375006
								],
								[
									68.29189453124997,
									40.656103515625006
								],
								[
									68.41503906250011,
									40.61943359374999
								],
								[
									68.49570312500003,
									40.608642578125114
								],
								[
									68.57265624999997,
									40.622656250000034
								],
								[
									68.60068359375009,
									40.65996093749999
								],
								[
									68.59365234375002,
									40.71127929687506
								],
								[
									68.55654296874997,
									40.765136718750114
								],
								[
									68.55927734375018,
									40.82929687500004
								],
								[
									68.58408203125009,
									40.8762695312501
								],
								[
									68.66279296875007,
									40.96152343750006
								],
								[
									68.73710937499999,
									41.041894531249994
								],
								[
									68.85117187500003,
									41.12382812499999
								],
								[
									68.98691406250009,
									41.205029296874926
								],
								[
									69.04345703125,
									41.26411132812507
								],
								[
									69.06494140625011,
									41.36694335937506
								],
								[
									69.15361328125005,
									41.42524414062501
								],
								[
									69.24931640625016,
									41.46025390624996
								],
								[
									69.36835937500018,
									41.490576171875006
								],
								[
									69.40097656250009,
									41.54189453125008
								],
								[
									69.56513671875001,
									41.62905273437508
								],
								[
									69.66386718750016,
									41.67211914062506
								],
								[
									69.7880859375,
									41.69731445312502
								],
								[
									69.9599609375,
									41.75405273437505
								],
								[
									70.09560546875002,
									41.82050781250007
								],
								[
									70.22587890625016,
									41.94599609375007
								],
								[
									70.32890625000005,
									42.02797851562508
								],
								[
									70.41601562500011,
									42.07856445312498
								],
								[
									70.48906250000016,
									42.08027343750007
								],
								[
									70.54013671875009,
									42.03945312500011
								],
								[
									70.58427734374999,
									42.03603515624994
								],
								[
									70.61328124999994,
									42.05473632812502
								],
								[
									70.66250000000014,
									42.10747070312502
								],
								[
									70.71523437500014,
									42.168652343749955
								],
								[
									70.76455078125014,
									42.194189453125006
								],
								[
									70.86035156250011,
									42.2072265625001
								],
								[
									70.94677734374994,
									42.24868164062508
								],
								[
									70.97900390625011,
									42.2665527343751
								],
								[
									71.03603515625002,
									42.28466796875006
								],
								[
									71.12998046875003,
									42.25
								],
								[
									71.21269531250005,
									42.20644531250011
								],
								[
									71.23232421875014,
									42.186279296875085
								],
								[
									71.22851562500006,
									42.16289062500002
								],
								[
									71.03222656250006,
									42.07778320312508
								],
								[
									70.91035156250007,
									42.03798828125008
								],
								[
									70.85664062500007,
									42.03081054687502
								],
								[
									70.84189453125009,
									42.01962890625006
								],
								[
									70.80332031250003,
									41.92265625000002
								],
								[
									70.72773437500007,
									41.90522460937501
								],
								[
									70.630859375,
									41.87548828125
								],
								[
									70.56289062500008,
									41.83081054687506
								],
								[
									70.45498046875014,
									41.7250488281251
								],
								[
									70.1809570312501,
									41.571435546874966
								],
								[
									70.17695312500007,
									41.53999023437504
								],
								[
									70.20087890625007,
									41.51445312499999
								],
								[
									70.29003906250011,
									41.49682617187503
								],
								[
									70.40781250000003,
									41.449560546875006
								],
								[
									70.47138671875007,
									41.412646484375045
								],
								[
									70.64589843750014,
									41.46035156250008
								],
								[
									70.68886718750008,
									41.44980468750006
								],
								[
									70.73437500000011,
									41.400537109374966
								],
								[
									70.78242187500007,
									41.262500000000074
								],
								[
									70.86044921875003,
									41.224902343750074
								],
								[
									70.96259765625018,
									41.19599609375004
								],
								[
									71.02597656250009,
									41.186572265625074
								],
								[
									71.11074218750014,
									41.152636718750074
								],
								[
									71.22343749999999,
									41.13994140624999
								],
								[
									71.29882812500011,
									41.152490234374966
								],
								[
									71.39306640625011,
									41.12338867187509
								],
								[
									71.40839843750001,
									41.13603515624999
								],
								[
									71.42089843750011,
									41.341894531250006
								],
								[
									71.50000000000006,
									41.307470703125006
								],
								[
									71.54560546875007,
									41.30805664062504
								],
								[
									71.58554687500003,
									41.33325195312503
								],
								[
									71.60624999999999,
									41.36743164062497
								],
								[
									71.61962890625,
									41.435449218749966
								],
								[
									71.60224609375007,
									41.50327148437512
								],
								[
									71.63750000000005,
									41.534179687500114
								],
								[
									71.66494140625008,
									41.54121093750001
								],
								[
									71.68515625000009,
									41.533007812500045
								],
								[
									71.697265625,
									41.51557617187504
								],
								[
									71.70068359375006,
									41.45400390625002
								],
								[
									71.75771484375014,
									41.428027343750045
								],
								[
									71.79248046875011,
									41.413134765625045
								],
								[
									71.82578125000003,
									41.3610351562501
								],
								[
									71.85800781250003,
									41.311376953125006
								],
								[
									71.87861328125018,
									41.19501953125001
								],
								[
									71.95849609375011,
									41.18706054687499
								],
								[
									72.05244140625007,
									41.16474609375007
								],
								[
									72.11542968750007,
									41.186572265625074
								],
								[
									72.16425781250007,
									41.17373046875002
								],
								[
									72.18095703125005,
									41.11845703124996
								],
								[
									72.18066406250006,
									41.06684570312501
								],
								[
									72.18730468749999,
									41.02592773437502
								],
								[
									72.21308593750007,
									41.01425781250006
								],
								[
									72.294921875,
									41.03994140625005
								],
								[
									72.36406250000005,
									41.04345703125006
								],
								[
									72.42734375000003,
									41.01894531250002
								],
								[
									72.50595703125009,
									40.981689453125085
								],
								[
									72.62041015625005,
									40.88378906250003
								],
								[
									72.65830078125003,
									40.869921875000045
								],
								[
									72.83095703125014,
									40.86215820312506
								],
								[
									72.86660156250002,
									40.84233398437502
								],
								[
									72.92597656250001,
									40.84243164062505
								],
								[
									72.99003906250005,
									40.860107421875
								],
								[
									73.13212890624999,
									40.82851562500005
								],
								[
									73.13691406250013,
									40.810644531250034
								],
								[
									73.11289062500009,
									40.78603515625011
								],
								[
									72.77382812500014,
									40.650390625000085
								],
								[
									72.74882812499999,
									40.60869140625002
								],
								[
									72.67958984375002,
									40.55561523437504
								],
								[
									72.60410156250009,
									40.52543945312502
								],
								[
									72.56748046875009,
									40.52436523437498
								],
								[
									72.40205078125007,
									40.57807617187501
								],
								[
									72.38261718749999,
									40.56513671875004
								],
								[
									72.36904296875008,
									40.54345703124997
								],
								[
									72.36972656250003,
									40.51972656250001
								],
								[
									72.40595703125007,
									40.46308593750004
								],
								[
									72.38925781250003,
									40.42739257812505
								],
								[
									72.35771484375005,
									40.401660156250045
								],
								[
									72.25400390625009,
									40.42421875000011
								],
								[
									72.23466796875016,
									40.43862304687502
								],
								[
									72.23281250000014,
									40.454394531250045
								],
								[
									72.19287109375006,
									40.454443359375034
								],
								[
									72.13125000000014,
									40.43862304687502
								],
								[
									72.01259765625002,
									40.340722656249966
								],
								[
									71.97109375000008,
									40.28950195312501
								],
								[
									71.95566406250003,
									40.25859375000002
								],
								[
									71.90273437500002,
									40.240966796875085
								],
								[
									71.84541015625007,
									40.23432617187504
								],
								[
									71.77265625000018,
									40.188037109375045
								],
								[
									71.69248046875009,
									40.15234375000006
								],
								[
									71.66679687499999,
									40.17861328125008
								],
								[
									71.65087890625006,
									40.208007812500114
								],
								[
									71.62988281250011,
									40.21713867187509
								],
								[
									71.58046875000008,
									40.210253906250045
								],
								[
									71.52041015625014,
									40.20898437500003
								],
								[
									71.45742187500008,
									40.24199218750002
								],
								[
									71.37617187500001,
									40.27519531250002
								],
								[
									71.30468750000006,
									40.28691406250002
								],
								[
									71.09453125000005,
									40.27124023437503
								],
								[
									70.99062500000002,
									40.25488281249997
								],
								[
									70.95800781250011,
									40.23886718750009
								],
								[
									70.8994140625,
									40.234570312499926
								],
								[
									70.65312500000016,
									40.20117187500006
								],
								[
									70.60273437500001,
									40.21416015625002
								],
								[
									70.56582031250014,
									40.26713867187499
								],
								[
									70.53359374999997,
									40.324511718750045
								],
								[
									70.46992187500007,
									40.34536132812494
								],
								[
									70.39824218750005,
									40.3613769531251
								],
								[
									70.37158203125011,
									40.38413085937512
								],
								[
									70.36972656250009,
									40.41201171875011
								],
								[
									70.37714843750018,
									40.439257812500045
								],
								[
									70.38261718750005,
									40.45351562499994
								],
								[
									70.54882812499994,
									40.5627929687501
								],
								[
									70.69833984375003,
									40.661181640625074
								],
								[
									70.71201171875009,
									40.66909179687508
								],
								[
									70.72558593750011,
									40.687792968750074
								],
								[
									70.75107421875003,
									40.72177734375006
								],
								[
									70.75097656250011,
									40.73959960937506
								],
								[
									70.63916015625,
									40.778564453125085
								],
								[
									70.634765625,
									40.79658203125001
								],
								[
									70.65732421875003,
									40.81508789062505
								],
								[
									70.65732421875003,
									40.8396484375001
								],
								[
									70.57822265625009,
									40.91147460937498
								],
								[
									70.44150390625003,
									41.02343750000006
								],
								[
									70.40195312500009,
									41.03510742187504
								],
								[
									70.37265625000003,
									41.02763671874993
								],
								[
									70.31894531250003,
									40.91923828124996
								],
								[
									70.29208984375009,
									40.89169921874995
								],
								[
									70.13632812500003,
									40.82041015625009
								],
								[
									70.00566406250016,
									40.77143554687504
								],
								[
									69.77324218750016,
									40.68427734375007
								],
								[
									69.71289062500011,
									40.656982421875
								],
								[
									69.67080078124997,
									40.66196289062495
								],
								[
									69.62841796874994,
									40.67905273437506
								],
								[
									69.49824218750018,
									40.76708984375006
								],
								[
									69.41386718750005,
									40.79716796874996
								],
								[
									69.35722656250005,
									40.76738281249993
								],
								[
									69.30937500000016,
									40.72392578124996
								],
								[
									69.31396484375011,
									40.634765625000085
								],
								[
									69.25996093750001,
									40.587646484375
								],
								[
									69.20625000000018,
									40.566552734374966
								],
								[
									69.30419921875,
									40.327392578125
								],
								[
									69.29443359375011,
									40.29658203125004
								],
								[
									69.21953125000016,
									40.2881347656251
								],
								[
									69.27490234374994,
									40.19809570312495
								],
								[
									69.22832031250016,
									40.18759765624995
								],
								[
									69.11035156250011,
									40.208740234375085
								],
								[
									68.95175781250003,
									40.22260742187507
								],
								[
									68.65253906250018,
									40.1826660156251
								],
								[
									68.63066406250016,
									40.167089843750034
								],
								[
									68.62246093750002,
									40.14726562499999
								],
								[
									68.63974609375003,
									40.129199218750045
								],
								[
									68.78457031249997,
									40.127099609374966
								],
								[
									68.92685546875003,
									40.13632812499998
								],
								[
									68.96601562500018,
									40.11958007812504
								],
								[
									68.97207031250002,
									40.08994140624995
								],
								[
									68.95566406250003,
									40.071337890625074
								],
								[
									68.90849609374999,
									40.06821289062506
								],
								[
									68.80468750000011,
									40.05034179687496
								],
								[
									68.79277343750016,
									40.03149414062494
								],
								[
									68.78945312500002,
									40.013330078124966
								],
								[
									68.82441406250001,
									39.96079101562509
								],
								[
									68.86386718750009,
									39.92734374999995
								],
								[
									68.86875000000009,
									39.907470703125085
								],
								[
									68.85224609375018,
									39.89096679687509
								],
								[
									68.83242187500014,
									39.884326171875074
								],
								[
									68.79765625000016,
									39.90913085937507
								],
								[
									68.77783203124994,
									39.90419921874994
								],
								[
									68.76796874999997,
									39.8818359375
								],
								[
									68.75820312500014,
									39.85556640624998
								],
								[
									68.73525390624997,
									39.836230468750045
								],
								[
									68.68691406249997,
									39.846289062500034
								],
								[
									68.63896484375016,
									39.83886718750006
								],
								[
									68.61035156250011,
									39.74326171875012
								],
								[
									68.58613281250007,
									39.63496093749998
								],
								[
									68.50693359375009,
									39.56279296874993
								],
								[
									68.46328124999997,
									39.53671874999995
								],
								[
									68.39902343750003,
									39.528857421875045
								],
								[
									68.30302734375005,
									39.53769531250006
								],
								[
									68.24492187499999,
									39.5482910156251
								],
								[
									68.07714843750011,
									39.56416015625004
								],
								[
									67.90859375000014,
									39.593798828125045
								],
								[
									67.71904296875016,
									39.621386718750045
								],
								[
									67.54248046875,
									39.55761718749994
								],
								[
									67.49169921875011,
									39.518749999999926
								],
								[
									67.45957031250003,
									39.482421875000085
								],
								[
									67.42617187500002,
									39.46557617187503
								],
								[
									67.34960937499994,
									39.242089843749966
								],
								[
									67.35761718750018,
									39.21669921875002
								],
								[
									67.400390625,
									39.19667968750005
								],
								[
									67.61650390625016,
									39.15029296875011
								],
								[
									67.64833984375014,
									39.1310546875001
								],
								[
									67.66728515624999,
									39.109179687500074
								],
								[
									67.67656250000005,
									39.00849609374998
								],
								[
									67.69443359375003,
									38.99462890625
								],
								[
									67.76855468750011,
									38.98222656249996
								],
								[
									67.87568359375018,
									38.983007812500034
								],
								[
									67.95957031250003,
									38.992919921875085
								],
								[
									68.04433593750002,
									38.98359375000007
								],
								[
									68.103515625,
									38.96201171875012
								],
								[
									68.13251953125001,
									38.92763671874994
								],
								[
									68.14853515625009,
									38.89062500000003
								],
								[
									68.04785156250011,
									38.66928710937498
								],
								[
									68.05595703125016,
									38.588916015625045
								],
								[
									68.08720703125005,
									38.47353515625008
								],
								[
									68.14414062500009,
									38.38310546875002
								],
								[
									68.25136718749997,
									38.29453125000009
								],
								[
									68.33310546875003,
									38.23779296875
								],
								[
									68.35029296875018,
									38.21103515625006
								],
								[
									68.35449218750011,
									38.16953124999995
								],
								[
									68.34121093749997,
									38.11679687499995
								],
								[
									68.29404296875009,
									38.03291015625001
								],
								[
									68.23652343750018,
									37.95966796875001
								],
								[
									68.17402343750001,
									37.92841796875004
								],
								[
									68.08759765625001,
									37.835449218750114
								],
								[
									68.01093750000001,
									37.72094726562506
								],
								[
									67.86357421875005,
									37.57070312500008
								],
								[
									67.81435546875014,
									37.48701171875007
								],
								[
									67.79804687500018,
									37.24497070312498
								],
								[
									67.75898437500001,
									37.17221679687506
								],
								[
									67.75292968750006,
									37.199804687500006
								],
								[
									67.69999999999999,
									37.22724609375001
								],
								[
									67.607421875,
									37.22250976562512
								],
								[
									67.54648437500009,
									37.23564453125002
								],
								[
									67.51728515625007,
									37.266650390625045
								],
								[
									67.44169921875005,
									37.25800781250007
								],
								[
									67.31972656250008,
									37.209570312500034
								],
								[
									67.19550781250007,
									37.235205078125034
								],
								[
									67.06884765625006,
									37.33481445312498
								],
								[
									66.82773437500003,
									37.37128906250004
								],
								[
									66.52226562500005,
									37.34848632812509
								],
								[
									66.51064453125002,
									37.4586914062501
								],
								[
									66.51132812500003,
									37.59916992187502
								],
								[
									66.52558593750001,
									37.785742187500006
								],
								[
									66.62929687500002,
									37.932031249999966
								],
								[
									66.62636718750014,
									37.95986328125005
								],
								[
									66.60625000000005,
									37.98671875000011
								],
								[
									66.57451171875016,
									38.01079101562502
								],
								[
									66.38974609375009,
									38.05092773437502
								],
								[
									66.33535156250002,
									38.07216796875011
								],
								[
									66.26367187499994,
									38.11806640625002
								],
								[
									66.17314453125016,
									38.1666992187501
								],
								[
									66.09482421875003,
									38.20014648437507
								],
								[
									65.97119140624994,
									38.24423828124998
								],
								[
									65.85712890625018,
									38.2687500000001
								],
								[
									65.79023437500007,
									38.25004882812502
								],
								[
									65.72851562500011,
									38.226367187500074
								],
								[
									65.6708984375,
									38.22573242187494
								],
								[
									65.61289062500009,
									38.238574218750074
								],
								[
									65.39960937500007,
									38.34882812500007
								],
								[
									65.07666015625,
									38.539453124999994
								],
								[
									64.82070312499997,
									38.672460937500006
								],
								[
									64.65996093749999,
									38.73603515624998
								],
								[
									64.62187500000016,
									38.75644531250006
								],
								[
									64.53164062499997,
									38.816210937500074
								],
								[
									64.30996093750002,
									38.97729492187503
								],
								[
									64.16279296875007,
									38.953613281250085
								],
								[
									63.952539062500136,
									39.058349609375114
								],
								[
									63.763671875000114,
									39.160546874999966
								],
								[
									63.72080078125009,
									39.18813476562508
								],
								[
									63.50605468750001,
									39.37709960937494
								],
								[
									63.29189453125002,
									39.499511718750085
								],
								[
									63.05810546875,
									39.63315429687506
								],
								[
									62.90683593750009,
									39.71679687500006
								],
								[
									62.650683593750045,
									39.858496093750034
								],
								[
									62.52548828125009,
									39.944091796875085
								],
								[
									62.48320312499999,
									39.97563476562493
								],
								[
									62.44160156250007,
									40.03623046875012
								],
								[
									62.375,
									40.332080078125074
								],
								[
									62.29804687500001,
									40.46748046875004
								],
								[
									62.188476562500114,
									40.541210937499955
								],
								[
									62.09501953125016,
									40.68330078125004
								],
								[
									62.017578125000114,
									40.89379882812503
								],
								[
									61.95351562500002,
									41.030615234375006
								],
								[
									61.90283203125,
									41.09370117187498
								],
								[
									61.79990234375009,
									41.16342773437498
								],
								[
									61.644531250000114,
									41.23984375000009
								],
								[
									61.496972656249966,
									41.27607421875001
								],
								[
									61.44365234375016,
									41.27460937500007
								],
								[
									61.417382812500136,
									41.26513671875
								],
								[
									61.38750000000016,
									41.252148437499926
								],
								[
									61.328906250000045,
									41.195117187500045
								],
								[
									61.24238281250018,
									41.189208984375085
								],
								[
									61.179296875000034,
									41.190576171874994
								],
								[
									61.11992187499999,
									41.21088867187504
								],
								[
									60.93320312500009,
									41.229003906250114
								],
								[
									60.867187500000114,
									41.24868164062494
								],
								[
									60.7548828125,
									41.24575195312505
								],
								[
									60.51357421875002,
									41.21616210937506
								],
								[
									60.454980468749966,
									41.221630859374926
								],
								[
									60.19999999999999,
									41.348974609375034
								],
								[
									60.08964843750016,
									41.3994140625
								],
								[
									60.0673828125,
									41.427343750000006
								],
								[
									60.068749999999966,
									41.47622070312502
								],
								[
									60.106054687500034,
									41.545214843750045
								],
								[
									60.13798828125016,
									41.594140624999966
								],
								[
									60.12402343749994,
									41.64497070312501
								],
								[
									60.075585937500136,
									41.70053710937498
								],
								[
									60.075585937500136,
									41.75966796874994
								],
								[
									60.10859375000001,
									41.79267578125001
								],
								[
									60.17636718750009,
									41.78227539062493
								],
								[
									60.20078125000009,
									41.80312500000008
								],
								[
									60.19208984375018,
									41.83442382812498
								],
								[
									60.15556640624999,
									41.85703125000006
								],
								[
									60.10693359374994,
									41.90742187500001
								],
								[
									59.96259765625001,
									41.9543945312501
								],
								[
									59.941796874999966,
									41.973535156249994
								],
								[
									59.94931640625009,
									41.9954101562501
								],
								[
									59.97412109375,
									42.01879882812497
								],
								[
									59.97919921875007,
									42.06806640625007
								],
								[
									59.98164062500018,
									42.13173828125008
								],
								[
									60.00078124999999,
									42.164746093749955
								],
								[
									60.00605468750018,
									42.19082031249994
								],
								[
									59.98515624999999,
									42.21171874999993
								],
								[
									59.93652343749994,
									42.2360351562501
								],
								[
									59.85830078125002,
									42.29516601562497
								],
								[
									59.762597656250136,
									42.30156250000002
								],
								[
									59.45107421875002,
									42.29951171875007
								],
								[
									59.35429687499999,
									42.32329101562502
								],
								[
									59.27656250000018,
									42.356152343749955
								],
								[
									59.19912109375002,
									42.48168945312506
								],
								[
									59.159570312500136,
									42.51142578125007
								],
								[
									59.12314453125009,
									42.523779296875006
								],
								[
									59.03583984375007,
									42.5281250000001
								],
								[
									58.93085937500018,
									42.540283203125085
								],
								[
									58.876953125000114,
									42.561474609374955
								],
								[
									58.729980468750114,
									42.676171874999966
								],
								[
									58.58906250000018,
									42.77846679687502
								],
								[
									58.532324218750034,
									42.681933593750074
								],
								[
									58.47714843750009,
									42.662841796875
								],
								[
									58.353125000000034,
									42.67172851562495
								],
								[
									58.259667968750136,
									42.68808593750009
								],
								[
									58.20644531250002,
									42.666308593750074
								],
								[
									58.15156250000001,
									42.62807617187494
								],
								[
									58.162011718750136,
									42.60297851562507
								],
								[
									58.2041015625,
									42.57636718750007
								],
								[
									58.28867187500009,
									42.52729492187501
								],
								[
									58.41816406250018,
									42.406689453124955
								],
								[
									58.476953124999966,
									42.340136718750074
								],
								[
									58.485839843750114,
									42.31684570312504
								],
								[
									58.47441406250016,
									42.29936523437493
								],
								[
									58.457031250000114,
									42.29179687499999
								],
								[
									58.431445312500045,
									42.29208984375006
								],
								[
									58.397070312500034,
									42.29248046875006
								],
								[
									58.37714843750018,
									42.31245117187504
								],
								[
									58.370507812500136,
									42.346777343750006
								],
								[
									58.327246093750034,
									42.39892578124997
								],
								[
									58.28291015625007,
									42.42885742187494
								],
								[
									58.23408203125007,
									42.447705078124955
								],
								[
									58.165625000000034,
									42.46157226562494
								],
								[
									58.07548828125016,
									42.48652343750004
								],
								[
									58.02890625000009,
									42.48764648437509
								],
								[
									57.98349609375009,
									42.458789062500074
								],
								[
									57.94570312500002,
									42.420019531250006
								],
								[
									57.92343750000009,
									42.33520507812506
								],
								[
									57.855957031250114,
									42.23105468750006
								],
								[
									57.81425781250016,
									42.18984375000011
								],
								[
									57.68613281250009,
									42.16479492187506
								],
								[
									57.61798562461729,
									42.16289283482149
								],
								[
									57.5498046875,
									42.26069335937504
								],
								[
									57.39228515625007,
									42.33491210937498
								],
								[
									57.27265625000001,
									42.303320312500034
								],
								[
									57.18271484375009,
									42.18535156249999
								],
								[
									57.09375,
									41.96840820312502
								],
								[
									57.08869356964601,
									41.94395858710328
								],
								[
									57.033691406250114,
									41.91484374999993
								],
								[
									56.96406250000007,
									41.85654296875006
								],
								[
									56.984863281250114,
									41.66933593750011
								],
								[
									57.018164062500034,
									41.45058593750002
								],
								[
									57.07666015625,
									41.38999023437495
								],
								[
									57.11386718750009,
									41.37177734375007
								],
								[
									57.11884765625007,
									41.35029296875004
								],
								[
									57.094824218750034,
									41.33129882812506
								],
								[
									57.064257812500045,
									41.307275390624966
								],
								[
									57.01796875000002,
									41.26347656249993
								],
								[
									56.96582031249994,
									41.26513671875
								],
								[
									56.86083984375,
									41.276123046875114
								],
								[
									56.77363281250007,
									41.28798828125005
								],
								[
									56.479882812499966,
									41.30063476562495
								],
								[
									56.241992187500045,
									41.31083984374999
								],
								[
									55.977441406250136,
									41.3222167968751
								],
								[
									55.97734374999999,
									41.55175781250003
								],
								[
									55.97714843750009,
									41.781347656250006
								],
								[
									55.97705078124994,
									42.010888671874966
								],
								[
									55.976953125000136,
									42.24042968750001
								],
								[
									55.97685546874999,
									42.46997070312506
								],
								[
									55.97675781250018,
									42.69951171875002
								],
								[
									55.976660156250034,
									42.92905273437506
								],
								[
									55.976562500000114,
									43.15859375000011
								],
								[
									55.97646484375002,
									43.38808593750005
								],
								[
									55.97636718749999,
									43.61762695312501
								],
								[
									55.97626953125007,
									43.847216796875074
								],
								[
									55.976171875000034,
									44.07675781250012
								],
								[
									55.976074218750114,
									44.30629882812505
								],
								[
									55.97597656250002,
									44.535839843749926
								],
								[
									55.97578125000007,
									44.76538085937497
								],
								[
									55.975683593750034,
									44.99492187499993
								],
								[
									56.100488281250136,
									45.023388671874955
								],
								[
									56.25791015625009,
									45.059326171875
								],
								[
									56.4091796875,
									45.0937988281251
								],
								[
									56.588769531250136,
									45.134765625
								],
								[
									56.791894531250136,
									45.18105468750002
								],
								[
									56.96503906250007,
									45.220605468749994
								],
								[
									57.17167968750016,
									45.267724609374994
								],
								[
									57.32929687500001,
									45.30366210937504
								],
								[
									57.47734375000016,
									45.33745117187499
								],
								[
									57.66669921875018,
									45.37744140624997
								],
								[
									57.961035156250034,
									45.43969726562503
								],
								[
									58.12519531250018,
									45.474365234375
								],
								[
									58.291113281250034,
									45.50942382812502
								],
								[
									58.44941406250007,
									45.542919921874926
								],
								[
									58.555273437500034,
									45.55537109374998
								],
								[
									58.59036182976246,
									45.54061527930634
								],
								[
									58.58867187499999,
									45.53706054687498
								],
								[
									58.56005859375,
									45.45722656250007
								],
								[
									58.51357421875008,
									45.38569335937504
								],
								[
									58.44921875,
									45.32241210937505
								],
								[
									58.404101562500045,
									45.253027343750034
								],
								[
									58.37832031250002,
									45.17753906250002
								],
								[
									58.27216796875001,
									44.981689453125
								],
								[
									58.23808593749999,
									44.90312499999996
								],
								[
									58.23212890625001,
									44.851318359375
								],
								[
									58.25097656250006,
									44.78642578124999
								],
								[
									58.29462890625007,
									44.708349609375006
								],
								[
									58.29667968749999,
									44.63842773437506
								],
								[
									58.257128906250045,
									44.576562499999966
								],
								[
									58.24287109375007,
									44.52421874999996
								],
								[
									58.253710937500045,
									44.481298828125006
								],
								[
									58.27802734375001,
									44.44921875000006
								],
								[
									58.31572265624999,
									44.42631835937499
								],
								[
									58.36855468750002,
									44.42924804687499
								],
								[
									58.46533203125,
									44.46103515625006
								],
								[
									58.51376953125009,
									44.490869140624994
								],
								[
									58.57763671875006,
									44.546728515625006
								],
								[
									58.6943359375,
									44.677392578124994
								],
								[
									58.68935546875008,
									44.69291992187496
								],
								[
									58.62539062500002,
									44.70346679687498
								],
								[
									58.612402343750034,
									44.72114257812501
								],
								[
									58.62734375000008,
									44.75468750000002
								],
								[
									58.6484375,
									44.77265625000004
								],
								[
									58.67578125000006,
									44.775146484375
								],
								[
									58.695605468750045,
									44.765869140625
								],
								[
									58.70800781250006,
									44.744726562500034
								],
								[
									58.731542968750034,
									44.738525390625
								],
								[
									58.766406250000045,
									44.74726562500001
								],
								[
									58.77382812500008,
									44.763964843750045
								],
								[
									58.75390625,
									44.78876953125004
								],
								[
									58.7421875,
									44.83598632812496
								],
								[
									58.73847656250007,
									44.90546875000001
								],
								[
									58.74843750000002,
									44.94208984375001
								],
								[
									58.77197265625006,
									44.94584960937496
								],
								[
									58.79238281250002,
									44.97124023437499
								],
								[
									58.81289062500002,
									45.044531250000006
								],
								[
									58.80175781250006,
									45.04951171875004
								],
								[
									58.66210937500006,
									44.986181640625006
								],
								[
									58.64716796875001,
									44.99365234375003
								],
								[
									58.65029296875002,
									45.02216796875007
								],
								[
									58.67138671875006,
									45.07182617187496
								],
								[
									58.71357421875001,
									45.11962890625003
								],
								[
									58.77695312500009,
									45.16557617187496
								],
								[
									58.79052734375,
									45.20034179687505
								],
								[
									58.75458984375007,
									45.22392578124996
								],
								[
									58.72851562500006,
									45.27543945312496
								],
								[
									58.71230468750002,
									45.35483398437498
								],
								[
									58.72285156250007,
									45.42626953124997
								],
								[
									58.74845301683462,
									45.46969817629909
								]
							],
							[
								[
									70.65253906250007,
									40.93662109374995
								],
								[
									70.64921874999999,
									40.96083984375008
								],
								[
									70.61835937500018,
									41.00166015625007
								],
								[
									70.57207031249999,
									41.02480468750008
								],
								[
									70.55000000000001,
									41.014892578125
								],
								[
									70.56875000000014,
									40.98183593750002
								],
								[
									70.62275390625001,
									40.93442382812495
								],
								[
									70.65253906250007,
									40.93662109374995
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Central Asia",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "UZB",
					"su_a3": "UZB",
					"brk_group": "",
					"region_wb": "Europe & Central Asia",
					"wb_a3": "UZB",
					"gu_a3": "UZB",
					"abbrev": "Uzb.",
					"region_un": "Asia",
					"adm0_a3_us": "UZB",
					"scalerank": 1,
					"pop_est": 27606007,
					"adm0_dif": 0,
					"un_a3": "860",
					"pop_year": -99,
					"gdp_md_est": 71670,
					"name": "Uzbekistan",
					"sovereignt": "Uzbekistan",
					"economy": "6. Developing region",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Uzbekistan",
					"postal": "UZ",
					"sov_a3": "UZB",
					"note_brk": "",
					"brk_a3": "UZB",
					"wb_a2": "UZ",
					"brk_diff": 0,
					"admin": "Uzbekistan",
					"name_long": "Uzbekistan",
					"iso_a3": "UZB",
					"iso_a2": "UZ",
					"adm0_a3_is": "UZB",
					"level": 2,
					"formal_en": "Republic of Uzbekistan",
					"name_len": 10,
					"mapcolor7": 2,
					"long_len": 10,
					"mapcolor8": 3,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "860",
					"homepart": 1,
					"subunit": "Uzbekistan",
					"name_alt": "",
					"brk_name": "Uzbekistan",
					"name_sort": "Uzbekistan",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": 5,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 1989
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									-60.997900390625006,
									8.867333984375023
								],
								[
									-61.05996093750002,
									8.847021484375063
								],
								[
									-61.069189453125034,
									8.947314453124974
								],
								[
									-61.050488281249955,
									8.974365234375071
								],
								[
									-60.94477539062501,
									9.055029296875063
								],
								[
									-60.91582031249996,
									9.070312499999986
								],
								[
									-60.89458007812499,
									9.05336914062508
								],
								[
									-60.89990234375,
									9.031884765625065
								],
								[
									-60.84916992187499,
									8.995703125000063
								],
								[
									-60.86142578124998,
									8.94960937500008
								],
								[
									-60.916406249999994,
									8.899267578125048
								],
								[
									-60.997900390625006,
									8.867333984375023
								]
							]
						],
						[
							[
								[
									-60.821191406249966,
									9.138378906249997
								],
								[
									-60.94140625000003,
									9.105566406250063
								],
								[
									-60.939453125,
									9.1323242187501
								],
								[
									-60.90727539062502,
									9.178710937500043
								],
								[
									-60.844873046874994,
									9.191796875000037
								],
								[
									-60.821386718750006,
									9.20766601562508
								],
								[
									-60.78159179687498,
									9.218359374999949
								],
								[
									-60.75888671874998,
									9.216455078125094
								],
								[
									-60.73583984374997,
									9.203320312500082
								],
								[
									-60.790380859375006,
									9.177197265625082
								],
								[
									-60.821191406249966,
									9.138378906249997
								]
							]
						],
						[
							[
								[
									-65.2125,
									10.906445312499955
								],
								[
									-65.26640624999999,
									10.883984374999997
								],
								[
									-65.36523437499997,
									10.906445312499955
								],
								[
									-65.41464843749998,
									10.937890624999966
								],
								[
									-65.38320312499997,
									10.973828125000097
								],
								[
									-65.30234375000003,
									10.973828125000097
								],
								[
									-65.22656249999994,
									10.930224609375003
								],
								[
									-65.2125,
									10.906445312499955
								]
							]
						],
						[
							[
								[
									-63.84936523437494,
									11.131005859375051
								],
								[
									-63.817285156249994,
									11.000341796875077
								],
								[
									-63.827099609374955,
									10.975830078125057
								],
								[
									-63.917626953124994,
									10.887548828125105
								],
								[
									-63.99355468750002,
									10.881201171874963
								],
								[
									-64.05468749999994,
									10.88432617187506
								],
								[
									-64.101171875,
									10.901416015625088
								],
								[
									-64.160888671875,
									10.95878906249996
								],
								[
									-64.21894531249993,
									10.941601562500011
								],
								[
									-64.36249999999995,
									10.961523437500077
								],
								[
									-64.40234375,
									10.98159179687508
								],
								[
									-64.34863281249997,
									11.051904296875094
								],
								[
									-64.249755859375,
									11.080322265625028
								],
								[
									-64.21367187500002,
									11.086132812499969
								],
								[
									-64.184814453125,
									11.042968750000057
								],
								[
									-64.11279296874997,
									11.005664062500088
								],
								[
									-64.0283203125,
									11.001855468750023
								],
								[
									-64.00732421874997,
									11.068457031250091
								],
								[
									-63.89311523437499,
									11.167236328124972
								],
								[
									-63.84936523437494,
									11.131005859375051
								]
							]
						],
						[
							[
								[
									-60.01752929687501,
									8.549316406250071
								],
								[
									-59.83164062499998,
									8.305957031250045
								],
								[
									-59.82890624999996,
									8.279150390625091
								],
								[
									-59.84907226562498,
									8.248681640625023
								],
								[
									-59.96484375000003,
									8.191601562500026
								],
								[
									-59.99072265624997,
									8.162011718750037
								],
								[
									-60.032421874999955,
									8.053564453125063
								],
								[
									-60.17817382812498,
									7.994042968750094
								],
								[
									-60.27890624999998,
									7.91943359375
								],
								[
									-60.34677734374995,
									7.854003906250085
								],
								[
									-60.380615234375,
									7.827636718750043
								],
								[
									-60.51362304687501,
									7.813183593750026
								],
								[
									-60.55634765625001,
									7.772021484374989
								],
								[
									-60.61010742187494,
									7.648339843750108
								],
								[
									-60.64946289062496,
									7.596630859375054
								],
								[
									-60.71865234374994,
									7.535937500000031
								],
								[
									-60.71923828124997,
									7.49868164062508
								],
								[
									-60.62373046874998,
									7.363330078125031
								],
								[
									-60.60654296874992,
									7.320849609375088
								],
								[
									-60.636181640624926,
									7.256591796875057
								],
								[
									-60.63330078124997,
									7.211083984375023
								],
								[
									-60.58320312499998,
									7.156201171875026
								],
								[
									-60.523193359375,
									7.143701171875051
								],
								[
									-60.46494140624995,
									7.166552734375088
								],
								[
									-60.39238281249999,
									7.164550781250043
								],
								[
									-60.34506835937495,
									7.150000000000091
								],
								[
									-60.32548828124996,
									7.133984375000026
								],
								[
									-60.32207031249999,
									7.092041015625014
								],
								[
									-60.35209960937496,
									7.002880859374969
								],
								[
									-60.39501953125,
									6.945361328124974
								],
								[
									-60.58608398437494,
									6.857080078125023
								],
								[
									-60.67104492187502,
									6.805957031250088
								],
								[
									-60.717919921874966,
									6.768310546875057
								],
								[
									-60.82084960937499,
									6.78847656250008
								],
								[
									-60.87333984375002,
									6.786914062500017
								],
								[
									-60.91357421874994,
									6.757812500000043
								],
								[
									-60.93798828124994,
									6.732763671875006
								],
								[
									-61.007080078125,
									6.726611328125088
								],
								[
									-61.10478515625002,
									6.711376953125082
								],
								[
									-61.14560546874998,
									6.694531250000026
								],
								[
									-61.17724609375003,
									6.650927734375031
								],
								[
									-61.20361328124997,
									6.588378906250071
								],
								[
									-61.181591796874926,
									6.513378906250068
								],
								[
									-61.15102539062502,
									6.446533203125043
								],
								[
									-61.15229492187501,
									6.385107421875048
								],
								[
									-61.12871093749999,
									6.214306640625068
								],
								[
									-61.15947265624996,
									6.174414062500034
								],
								[
									-61.22495117187498,
									6.12919921875006
								],
								[
									-61.303124999999994,
									6.049511718750068
								],
								[
									-61.39082031250001,
									5.938769531250074
								],
								[
									-61.376806640625006,
									5.906982421875085
								],
								[
									-61.167187499999926,
									5.674218750000094
								],
								[
									-60.95400390625002,
									5.437402343750065
								],
								[
									-60.742138671874926,
									5.20205078125008
								],
								[
									-60.71196289062502,
									5.19155273437508
								],
								[
									-60.671972656250034,
									5.1643554687500455
								],
								[
									-60.63500976562497,
									5.081982421875054
								],
								[
									-60.60449218749997,
									4.994580078125097
								],
								[
									-60.603857421875006,
									4.949365234375037
								],
								[
									-60.627587890624966,
									4.892529296875082
								],
								[
									-60.67915039062498,
									4.827099609375082
								],
								[
									-60.74174804687493,
									4.77412109375004
								],
								[
									-60.833398437499966,
									4.729199218750026
								],
								[
									-60.90624999999997,
									4.686816406250017
								],
								[
									-60.96640624999998,
									4.57470703125
								],
								[
									-61.00283203125002,
									4.535253906250048
								],
								[
									-61.036279296874994,
									4.519335937500088
								],
								[
									-61.102441406249966,
									4.504687499999946
								],
								[
									-61.20942382812501,
									4.5080566406250995
								],
								[
									-61.28007812500002,
									4.516894531249946
								],
								[
									-61.36752929687498,
									4.43300781250008
								],
								[
									-61.47939453124994,
									4.402246093750037
								],
								[
									-61.55424804687502,
									4.287792968750082
								],
								[
									-61.82084960937496,
									4.197021484374972
								],
								[
									-62.08159179687496,
									4.126318359375048
								],
								[
									-62.15312499999999,
									4.098388671875043
								],
								[
									-62.41064453124994,
									4.156738281250028
								],
								[
									-62.47255859374994,
									4.138525390625048
								],
								[
									-62.54394531250003,
									4.08432617187502
								],
								[
									-62.60976562500002,
									4.04228515625006
								],
								[
									-62.66533203124996,
									4.0396484375000625
								],
								[
									-62.71210937499998,
									4.017919921875077
								],
								[
									-62.73994140624998,
									3.9403320312500796
								],
								[
									-62.764599609374926,
									3.672949218749963
								],
								[
									-62.85698242187502,
									3.5934570312500256
								],
								[
									-62.96865234374994,
									3.5939453125000256
								],
								[
									-63.04531250000002,
									3.686474609375054
								],
								[
									-63.13623046874997,
									3.756445312500091
								],
								[
									-63.29472656249993,
									3.9222656249999517
								],
								[
									-63.33867187500002,
									3.943896484375088
								],
								[
									-63.37978515624994,
									3.942871093750057
								],
								[
									-63.526806640624955,
									3.8937011718749943
								],
								[
									-63.59663085937498,
									3.915039062500071
								],
								[
									-63.652929687500006,
									3.940820312500094
								],
								[
									-63.746972656249966,
									3.9325683593750966
								],
								[
									-63.914648437500034,
									3.930664062500057
								],
								[
									-64.02148437500003,
									3.929101562500094
								],
								[
									-64.07338867187494,
									3.974414062500088
								],
								[
									-64.12172851562502,
									4.066992187499949
								],
								[
									-64.154296875,
									4.1001464843750455
								],
								[
									-64.19248046874995,
									4.126855468750065
								],
								[
									-64.25566406249996,
									4.140332031249969
								],
								[
									-64.52553710937497,
									4.139990234375077
								],
								[
									-64.57636718750001,
									4.139892578125057
								],
								[
									-64.61367187499997,
									4.157714843749957
								],
								[
									-64.66552734374997,
									4.23710937500006
								],
								[
									-64.72226562499998,
									4.2744140625000995
								],
								[
									-64.788671875,
									4.27602539062508
								],
								[
									-64.81787109375,
									4.232275390625048
								],
								[
									-64.70258789062495,
									4.089306640625054
								],
								[
									-64.66899414062496,
									4.011816406250077
								],
								[
									-64.56791992187496,
									3.8998046874999943
								],
								[
									-64.27529296874997,
									3.6626953125000057
								],
								[
									-64.22109375000002,
									3.587402343749943
								],
								[
									-64.22705078124997,
									3.491210937500057
								],
								[
									-64.22875976562497,
									3.3439941406250853
								],
								[
									-64.21884765625,
									3.2046875000000483
								],
								[
									-64.14355468750003,
									3.0048828125000995
								],
								[
									-64.03779296874998,
									2.801513671875057
								],
								[
									-64.00903320312497,
									2.671874999999943
								],
								[
									-64.0287109375,
									2.576074218749966
								],
								[
									-64.048828125,
									2.525097656250054
								],
								[
									-64.04658203124998,
									2.502392578125054
								],
								[
									-64.02490234375,
									2.481884765625054
								],
								[
									-63.924169921875006,
									2.452441406250003
								],
								[
									-63.712548828124966,
									2.434033203124983
								],
								[
									-63.58461914062502,
									2.433935546874963
								],
								[
									-63.389257812500006,
									2.411914062500088
								],
								[
									-63.374853515625006,
									2.340429687500091
								],
								[
									-63.393945312499994,
									2.2225097656250483
								],
								[
									-63.43251953124994,
									2.155566406250088
								],
								[
									-63.46391601562493,
									2.136035156250017
								],
								[
									-63.570263671874926,
									2.120507812500051
								],
								[
									-63.68212890625,
									2.0481445312500597
								],
								[
									-63.84448242187503,
									1.9767089843750654
								],
								[
									-63.937158203124994,
									1.9669921875000398
								],
								[
									-63.975781249999955,
									1.953027343750037
								],
								[
									-64.00849609374995,
									1.9315917968749403
								],
								[
									-64.03544921874993,
									1.9044433593750938
								],
								[
									-64.067041015625,
									1.7705078124999858
								],
								[
									-64.11484375000003,
									1.6192871093750796
								],
								[
									-64.20502929687493,
									1.5294921875000824
								],
								[
									-64.30419921874997,
									1.4552734375000682
								],
								[
									-64.40512695312503,
									1.4468750000000483
								],
								[
									-64.48603515624998,
									1.4527832031250938
								],
								[
									-64.52626953125002,
									1.431005859375091
								],
								[
									-64.58437499999994,
									1.369873046875071
								],
								[
									-64.66743164062498,
									1.293847656250037
								],
								[
									-64.73154296875,
									1.2533203125000512
								],
								[
									-64.81796875000003,
									1.257128906250017
								],
								[
									-64.91010742187495,
									1.2197265625000426
								],
								[
									-65.02656249999998,
									1.1584472656250853
								],
								[
									-65.10375976562497,
									1.1081054687500398
								],
								[
									-65.16962890624998,
									1.0222167968750426
								],
								[
									-65.26396484375002,
									0.9318847656251137
								],
								[
									-65.36083984374994,
									0.8686523437500995
								],
								[
									-65.4072265625,
									0.7904785156250824
								],
								[
									-65.47338867187497,
									0.6912597656250199
								],
								[
									-65.55605468750002,
									0.687988281250071
								],
								[
									-65.56269531249995,
									0.7475097656249403
								],
								[
									-65.52299804687496,
									0.8434082031249375
								],
								[
									-65.566015625,
									0.9260742187500739
								],
								[
									-65.64467773437497,
									0.970361328125037
								],
								[
									-65.68144531249999,
									0.9834472656250455
								],
								[
									-65.718115234375,
									0.9780273437500995
								],
								[
									-65.81132812499999,
									0.9372558593750426
								],
								[
									-65.92587890624995,
									0.8631347656250483
								],
								[
									-65.996337890625,
									0.8097656250000114
								],
								[
									-66.06005859375003,
									0.7853515625000114
								],
								[
									-66.19121093750002,
									0.7632812500000483
								],
								[
									-66.30166015624997,
									0.7519531249999574
								],
								[
									-66.34711914062498,
									0.7671875000000341
								],
								[
									-66.42924804687502,
									0.8216796874999517
								],
								[
									-66.61904296874997,
									0.9921386718750398
								],
								[
									-66.87602539062499,
									1.2230468750000085
								],
								[
									-66.89550781249997,
									1.2898925781249488
								],
								[
									-66.88447265624993,
									1.35825195312502
								],
								[
									-66.93110351562493,
									1.4580078125000853
								],
								[
									-66.95834960937498,
									1.5642089843750568
								],
								[
									-66.98154296875,
									1.6007812500000398
								],
								[
									-66.988134765625,
									1.6801757812500568
								],
								[
									-67.04389648437501,
									1.823193359375054
								],
								[
									-67.08955078124998,
									1.940332031250037
								],
								[
									-67.13144531249998,
									1.9998535156249915
								],
								[
									-67.11381835937493,
									2.050585937500017
								],
								[
									-67.13144531249998,
									2.10126953125004
								],
								[
									-67.16547851562498,
									2.1425781250000284
								],
								[
									-67.215234375,
									2.275488281250105
								],
								[
									-67.19760742187495,
									2.3327636718749574
								],
								[
									-67.21083984375,
									2.3901367187500995
								],
								[
									-67.25273437499999,
									2.4294433593750284
								],
								[
									-67.31225585937497,
									2.471679687500014
								],
								[
									-67.39160156249997,
									2.5599121093750483
								],
								[
									-67.48642578125,
									2.6436523437500483
								],
								[
									-67.53496093749993,
									2.6767578125000426
								],
								[
									-67.56801757812502,
									2.689941406250071
								],
								[
									-67.5966796875,
									2.769335937500074
								],
								[
									-67.61870117187496,
									2.793603515625051
								],
								[
									-67.66723632812497,
									2.8001953125000654
								],
								[
									-67.76645507812503,
									2.8333007812500597
								],
								[
									-67.85908203124998,
									2.793603515625051
								],
								[
									-67.86123046874997,
									2.855322265625105
								],
								[
									-67.83476562500002,
									2.892822265625014
								],
								[
									-67.51484374999993,
									3.1872558593749574
								],
								[
									-67.35361328125003,
									3.3226562500000085
								],
								[
									-67.33627929687498,
									3.3426269531249915
								],
								[
									-67.32216796875002,
									3.373974609374983
								],
								[
									-67.3111328125,
									3.4158691406249915
								],
								[
									-67.34770507812499,
									3.46376953124998
								],
								[
									-67.49868164062502,
									3.6911132812500256
								],
								[
									-67.55112304687503,
									3.7338378906250256
								],
								[
									-67.60253906250003,
									3.7687988281250426
								],
								[
									-67.66162109375,
									3.8642578125000284
								],
								[
									-67.73232421875,
									4.08652343750002
								],
								[
									-67.78320312499997,
									4.198242187500043
								],
								[
									-67.79863281250002,
									4.283886718750082
								],
								[
									-67.79541015624997,
									4.380712890625091
								],
								[
									-67.814306640625,
									4.455078125000057
								],
								[
									-67.85527343750002,
									4.506884765625031
								],
								[
									-67.85527343750002,
									4.665478515625111
								],
								[
									-67.814306640625,
									4.930810546875065
								],
								[
									-67.80419921875,
									5.1325195312499545
								],
								[
									-67.82490234374995,
									5.270458984375082
								],
								[
									-67.78842773437498,
									5.375488281250071
								],
								[
									-67.69462890624996,
									5.447509765625
								],
								[
									-67.64228515624995,
									5.558789062500026
								],
								[
									-67.63134765624994,
									5.709375000000051
								],
								[
									-67.57519531249997,
									5.833105468750034
								],
								[
									-67.47387695312503,
									5.92998046875006
								],
								[
									-67.43935546875,
									6.02553710937508
								],
								[
									-67.47158203125,
									6.119775390625094
								],
								[
									-67.48198242187499,
									6.1802734375000625
								],
								[
									-67.56806640624993,
									6.2417968749999915
								],
								[
									-67.7271484375,
									6.284960937500074
								],
								[
									-67.85917968750002,
									6.28989257812502
								],
								[
									-67.9388671875,
									6.241943359375114
								],
								[
									-68.14306640625003,
									6.197509765625028
								],
								[
									-68.47177734375,
									6.156542968750031
								],
								[
									-68.73647460937494,
									6.156787109375074
								],
								[
									-68.93720703124998,
									6.198193359375082
								],
								[
									-69.08994140625,
									6.184375000000017
								],
								[
									-69.19453125000001,
									6.115332031250077
								],
								[
									-69.2681640625,
									6.099707031250091
								],
								[
									-69.31083984374999,
									6.13759765625008
								],
								[
									-69.357080078125,
									6.14799804687506
								],
								[
									-69.42714843749997,
									6.123974609374969
								],
								[
									-69.43925781249993,
									6.134912109375065
								],
								[
									-69.59482421875,
									6.321484375000054
								],
								[
									-69.73896484374998,
									6.494384765625028
								],
								[
									-69.90419921875,
									6.7002441406250455
								],
								[
									-70.09501953124996,
									6.937939453125054
								],
								[
									-70.12919921874999,
									6.953613281250057
								],
								[
									-70.18813476562502,
									6.952050781250094
								],
								[
									-70.26611328125,
									6.947949218749969
								],
								[
									-70.38749999999996,
									6.972607421875111
								],
								[
									-70.47065429687501,
									7.007128906249946
								],
								[
									-70.535546875,
									7.04052734375
								],
								[
									-70.65507812500002,
									7.082763671875071
								],
								[
									-70.73715820312503,
									7.090039062500054
								],
								[
									-70.81069335937502,
									7.077587890625082
								],
								[
									-71.01328124999998,
									6.994433593750017
								],
								[
									-71.12861328124995,
									6.986718750000051
								],
								[
									-71.21782226562499,
									6.985205078125091
								],
								[
									-71.45712890624998,
									7.026367187499957
								],
								[
									-71.62089843749996,
									7.03291015625004
								],
								[
									-71.81127929687503,
									7.005810546875026
								],
								[
									-71.89267578125,
									6.990332031250077
								],
								[
									-72.00664062499993,
									7.03261718750008
								],
								[
									-72.08427734374996,
									7.096875000000026
								],
								[
									-72.15668945312495,
									7.249707031249983
								],
								[
									-72.20771484374995,
									7.370263671875023
								],
								[
									-72.29633789062498,
									7.39453125
								],
								[
									-72.39462890625003,
									7.415087890625017
								],
								[
									-72.44296875,
									7.454882812500031
								],
								[
									-72.47197265624996,
									7.524267578124963
								],
								[
									-72.47895507812498,
									7.613232421874969
								],
								[
									-72.46889648437497,
									7.757958984374966
								],
								[
									-72.45957031250003,
									7.80986328125006
								],
								[
									-72.44604492187503,
									7.966113281250088
								],
								[
									-72.39169921874995,
									8.04770507812502
								],
								[
									-72.35761718749995,
									8.087304687500094
								],
								[
									-72.36416015624994,
									8.152783203125026
								],
								[
									-72.39033203124995,
									8.287060546875026
								],
								[
									-72.41655273437496,
									8.38198242187508
								],
								[
									-72.525732421875,
									8.489697265625097
								],
								[
									-72.66542968749994,
									8.627587890625023
								],
								[
									-72.72553710937493,
									8.848291015625051
								],
								[
									-72.79638671874997,
									9.108984375000048
								],
								[
									-72.85209960937496,
									9.135156250000051
								],
								[
									-72.90444335937497,
									9.122070312500043
								],
								[
									-72.96015624999995,
									9.135156250000051
								],
								[
									-73.00927734375,
									9.239941406250082
								],
								[
									-73.05839843749999,
									9.259570312500088
								],
								[
									-73.13671874999994,
									9.222802734374966
								],
								[
									-73.19316406249999,
									9.194140624999989
								],
								[
									-73.33671875000002,
									9.167919921875068
								],
								[
									-73.3662109375,
									9.194140624999989
								],
								[
									-73.35634765625002,
									9.226855468750074
								],
								[
									-73.295654296875,
									9.3220214843751
								],
								[
									-73.22426757812502,
									9.4436035156251
								],
								[
									-73.141259765625,
									9.554638671875068
								],
								[
									-73.06406249999998,
									9.668212890625028
								],
								[
									-73.00654296874998,
									9.789160156250063
								],
								[
									-72.9673828125,
									10.02973632812504
								],
								[
									-72.94038085937501,
									10.19575195312494
								],
								[
									-72.86933593750001,
									10.491259765625017
								],
								[
									-72.73916015624997,
									10.727197265625023
								],
								[
									-72.690087890625,
									10.835839843750051
								],
								[
									-72.57226562499997,
									10.977148437500063
								],
								[
									-72.51801757812493,
									11.053906250000068
								],
								[
									-72.44609374999993,
									11.114257812500014
								],
								[
									-72.24848632812501,
									11.196435546875051
								],
								[
									-72.01230468750003,
									11.601953125000065
								],
								[
									-71.95810546875,
									11.666406250000051
								],
								[
									-71.71948242187497,
									11.726855468750031
								],
								[
									-71.53608398437501,
									11.774072265624966
								],
								[
									-71.40019531249993,
									11.823535156250088
								],
								[
									-71.35556640625,
									11.849755859375023
								],
								[
									-71.31972656249997,
									11.861914062500091
								],
								[
									-71.34941406249999,
									11.814941406249943
								],
								[
									-71.41455078125003,
									11.755175781250017
								],
								[
									-71.48837890624995,
									11.718750000000057
								],
								[
									-71.86865234374997,
									11.627343750000094
								],
								[
									-71.90751953124999,
									11.607958984375045
								],
								[
									-71.95693359375002,
									11.569921875000034
								],
								[
									-71.95722656250001,
									11.482812500000051
								],
								[
									-71.94697265624995,
									11.414453125000065
								],
								[
									-71.835107421875,
									11.190332031250051
								],
								[
									-71.79145507812498,
									11.135058593749989
								],
								[
									-71.6416015625,
									11.013525390625091
								],
								[
									-71.67568359375002,
									10.996728515625051
								],
								[
									-71.73090820312498,
									10.994677734374989
								],
								[
									-71.6904296875,
									10.83549804687506
								],
								[
									-71.59843749999999,
									10.726220703125009
								],
								[
									-71.59433593749998,
									10.657373046875108
								],
								[
									-71.66484374999993,
									10.443750000000108
								],
								[
									-71.79350585937496,
									10.315966796875088
								],
								[
									-71.88476562499997,
									10.167236328125085
								],
								[
									-71.95571289062497,
									10.108056640625108
								],
								[
									-72.11284179687499,
									9.815576171874937
								],
								[
									-71.99326171874998,
									9.641503906250094
								],
								[
									-71.97626953124998,
									9.553222656249957
								],
								[
									-71.873046875,
									9.427636718749952
								],
								[
									-71.80566406250003,
									9.386425781250082
								],
								[
									-71.76074218750003,
									9.33574218750006
								],
								[
									-71.78134765624995,
									9.25
								],
								[
									-71.74013671875,
									9.133886718750063
								],
								[
									-71.68671874999995,
									9.072509765625071
								],
								[
									-71.61953124999994,
									9.047949218750048
								],
								[
									-71.53662109375003,
									9.04829101562494
								],
								[
									-71.29794921874998,
									9.125634765625065
								],
								[
									-71.24140625000001,
									9.160449218750045
								],
								[
									-71.20537109374996,
									9.222460937500074
								],
								[
									-71.08583984375002,
									9.348242187500034
								],
								[
									-71.07841796875002,
									9.510791015625017
								],
								[
									-71.05268554687501,
									9.705810546874957
								],
								[
									-71.08173828124998,
									9.833203125000068
								],
								[
									-71.20722656249998,
									10.014599609374983
								],
								[
									-71.26220703124997,
									10.143603515624974
								],
								[
									-71.38662109375002,
									10.263769531250034
								],
								[
									-71.46279296875,
									10.469238281250057
								],
								[
									-71.49423828125,
									10.533203124999943
								],
								[
									-71.51787109375002,
									10.621826171875057
								],
								[
									-71.54462890624995,
									10.778710937500037
								],
								[
									-71.46113281250001,
									10.835644531250097
								],
								[
									-71.46953124999993,
									10.964160156249989
								],
								[
									-71.26435546874998,
									10.999511718750085
								],
								[
									-70.82050781249995,
									11.20844726562511
								],
								[
									-70.54560546875001,
									11.261376953124966
								],
								[
									-70.23251953125,
									11.372998046874969
								],
								[
									-70.15996093749996,
									11.428076171875091
								],
								[
									-70.09711914062495,
									11.519775390625028
								],
								[
									-70.04853515624998,
									11.530322265625045
								],
								[
									-69.88535156249998,
									11.444335937500028
								],
								[
									-69.80478515624998,
									11.474218750000077
								],
								[
									-69.77290039062498,
									11.541308593749974
								],
								[
									-69.81733398437495,
									11.672070312499969
								],
								[
									-69.91093749999993,
									11.672119140625071
								],
								[
									-70.19257812499993,
									11.624609375000063
								],
								[
									-70.22011718749997,
									11.680859374999983
								],
								[
									-70.22001953125002,
									11.730078125000063
								],
								[
									-70.2865234375,
									11.886035156250031
								],
								[
									-70.24511718749997,
									12.003515624999991
								],
								[
									-70.20278320312497,
									12.098388671874957
								],
								[
									-70.12202148437495,
									12.136621093750023
								],
								[
									-70.00395507812496,
									12.17788085937508
								],
								[
									-69.91435546875002,
									12.114599609375063
								],
								[
									-69.86010742187497,
									12.054199218750014
								],
								[
									-69.83061523437502,
									11.995605468750071
								],
								[
									-69.810546875,
									11.836865234374969
								],
								[
									-69.76240234374995,
									11.676025390625057
								],
								[
									-69.71191406249997,
									11.564208984375114
								],
								[
									-69.63159179687497,
									11.479931640625082
								],
								[
									-69.56982421875,
									11.485449218749963
								],
								[
									-69.52573242187498,
									11.499511718749986
								],
								[
									-69.23256835937502,
									11.518457031249937
								],
								[
									-69.05458984375,
									11.461035156249963
								],
								[
									-68.82797851562503,
									11.431738281250034
								],
								[
									-68.61621093749994,
									11.309374999999974
								],
								[
									-68.39863281249995,
									11.160986328125034
								],
								[
									-68.34316406250002,
									11.052832031249935
								],
								[
									-68.3248046875,
									10.949316406250077
								],
								[
									-68.2720703125,
									10.88002929687508
								],
								[
									-68.32470703125,
									10.808740234375037
								],
								[
									-68.29628906249997,
									10.689355468750051
								],
								[
									-68.23408203125001,
									10.569140625000074
								],
								[
									-68.13994140625002,
									10.492724609375045
								],
								[
									-67.87163085937496,
									10.472070312500094
								],
								[
									-67.58134765624999,
									10.52373046875006
								],
								[
									-67.13330078125,
									10.570410156250063
								],
								[
									-66.98906250000002,
									10.610644531250088
								],
								[
									-66.24721679687497,
									10.632226562500037
								],
								[
									-66.10585937499994,
									10.574609375000023
								],
								[
									-66.09213867187498,
									10.517089843750028
								],
								[
									-66.090478515625,
									10.472949218750017
								],
								[
									-65.85175781249995,
									10.257763671875054
								],
								[
									-65.655859375,
									10.228466796875026
								],
								[
									-65.48935546875003,
									10.159423828125
								],
								[
									-65.31738281249997,
									10.122363281250088
								],
								[
									-65.12910156249998,
									10.070068359375085
								],
								[
									-65.023291015625,
									10.076660156250014
								],
								[
									-64.94404296874995,
									10.095019531250017
								],
								[
									-64.85048828125,
									10.09809570312494
								],
								[
									-64.188330078125,
									10.457812500000031
								],
								[
									-63.833691406249955,
									10.448535156250017
								],
								[
									-63.77905273437503,
									10.471923828125071
								],
								[
									-63.73188476562501,
									10.503417968750085
								],
								[
									-63.862695312499994,
									10.558154296875045
								],
								[
									-64.15791015624993,
									10.57924804687508
								],
								[
									-64.24750976562498,
									10.542578125000077
								],
								[
									-64.298193359375,
									10.635156250000023
								],
								[
									-64.20195312500002,
									10.632666015625048
								],
								[
									-63.873437499999966,
									10.663769531250068
								],
								[
									-63.49677734374998,
									10.643261718749983
								],
								[
									-63.18989257812498,
									10.709179687500082
								],
								[
									-63.03549804687498,
									10.720117187500009
								],
								[
									-62.94672851562501,
									10.707080078125017
								],
								[
									-62.702343749999955,
									10.749804687500017
								],
								[
									-62.242285156250034,
									10.699560546875077
								],
								[
									-61.879492187500006,
									10.741015625000003
								],
								[
									-61.92138671875003,
									10.681445312499946
								],
								[
									-62.04042968750002,
									10.645361328125048
								],
								[
									-62.23291015624997,
									10.63398437500004
								],
								[
									-62.379980468750006,
									10.546875000000057
								],
								[
									-62.693554687499955,
									10.562988281249972
								],
								[
									-62.91357421875,
									10.531494140625043
								],
								[
									-62.84296875000001,
									10.50722656249998
								],
								[
									-62.84301757812503,
									10.417919921875082
								],
								[
									-62.81293945312501,
									10.399902343750057
								],
								[
									-62.78124999999994,
									10.399218750000003
								],
								[
									-62.70629882812497,
									10.333056640625017
								],
								[
									-62.68583984374996,
									10.289794921875085
								],
								[
									-62.66162109375,
									10.198583984375077
								],
								[
									-62.694677734375006,
									10.100097656250085
								],
								[
									-62.740576171875006,
									10.0561523437501
								],
								[
									-62.65117187500002,
									10.070654296875034
								],
								[
									-62.600488281249994,
									10.116943359375043
								],
								[
									-62.60791015625,
									10.16342773437502
								],
								[
									-62.600488281249994,
									10.217285156250057
								],
								[
									-62.55034179687499,
									10.2004394531251
								],
								[
									-62.51513671875,
									10.17612304687502
								],
								[
									-62.40092773437502,
									9.918408203125097
								],
								[
									-62.320410156250034,
									9.783056640625063
								],
								[
									-62.29980468750003,
									9.788183593750034
								],
								[
									-62.28066406250002,
									9.792968750000043
								],
								[
									-62.25673828124994,
									9.818896484375074
								],
								[
									-62.22114257812498,
									9.882568359375085
								],
								[
									-62.19042968750003,
									9.842187500000023
								],
								[
									-62.171972656250006,
									9.826708984375074
								],
								[
									-62.15336914062493,
									9.821777343749957
								],
								[
									-62.17031250000002,
									9.879492187499991
								],
								[
									-62.14746093749997,
									9.953417968750045
								],
								[
									-62.15532226562499,
									9.979248046875057
								],
								[
									-62.11962890625,
									9.984863281250057
								],
								[
									-62.077099609374955,
									9.975048828125097
								],
								[
									-62.01650390624994,
									9.954687500000034
								],
								[
									-61.908593749999994,
									9.869921875000088
								],
								[
									-61.837255859375006,
									9.782080078125034
								],
								[
									-61.831152343750006,
									9.733056640625094
								],
								[
									-61.80537109375001,
									9.705517578125068
								],
								[
									-61.75874023437501,
									9.676513671875028
								],
								[
									-61.73593749999998,
									9.631201171875034
								],
								[
									-61.73173828125002,
									9.702490234374991
								],
								[
									-61.75917968750002,
									9.754443359375088
								],
								[
									-61.76591796874996,
									9.813818359374935
								],
								[
									-61.62539062500002,
									9.816455078125031
								],
								[
									-61.58886718749994,
									9.894531250000028
								],
								[
									-61.51230468749998,
									9.847509765625048
								],
								[
									-61.30937499999993,
									9.633056640625057
								],
								[
									-61.23442382812496,
									9.59760742187494
								],
								[
									-61.013378906249955,
									9.556445312500074
								],
								[
									-60.87407226562499,
									9.453320312500026
								],
								[
									-60.79248046874997,
									9.360742187500094
								],
								[
									-60.840966796874994,
									9.263671874999943
								],
								[
									-60.971044921875034,
									9.215185546875105
								],
								[
									-61.02314453124998,
									9.154589843750017
								],
								[
									-61.05307617187495,
									9.095117187500065
								],
								[
									-61.05356445312498,
									9.035253906249949
								],
								[
									-61.09296875000001,
									8.965771484375097
								],
								[
									-61.098828124999955,
									8.941308593749994
								],
								[
									-61.12236328124996,
									8.843359374999935
								],
								[
									-61.175878906250006,
									8.72539062500006
								],
								[
									-61.24726562499998,
									8.600341796874986
								],
								[
									-61.61870117187499,
									8.597460937499932
								],
								[
									-61.52690429687493,
									8.546142578124957
								],
								[
									-61.44257812499998,
									8.508691406249966
								],
								[
									-61.30400390625002,
									8.410400390625014
								],
								[
									-61.19375000000002,
									8.487597656249932
								],
								[
									-61.035986328125034,
									8.493115234375082
								],
								[
									-60.86523437499997,
									8.57880859375004
								],
								[
									-60.800976562499926,
									8.592138671875091
								],
								[
									-60.48149414062496,
									8.547265625000009
								],
								[
									-60.40449218749998,
									8.610253906250051
								],
								[
									-60.34023437499994,
									8.628759765625091
								],
								[
									-60.16748046875,
									8.616992187500003
								],
								[
									-60.01752929687501,
									8.549316406250071
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "RepÃºblica Bolivariana de Venezuela",
					"subregion": "South America",
					"labelrank": 3,
					"adm0_a3_un": -99,
					"adm0_a3": "VEN",
					"su_a3": "VEN",
					"brk_group": "",
					"region_wb": "Latin America & Caribbean",
					"wb_a3": "VEN",
					"gu_a3": "VEN",
					"abbrev": "Ven.",
					"region_un": "Americas",
					"adm0_a3_us": "VEN",
					"scalerank": 1,
					"pop_est": 26814843,
					"adm0_dif": 0,
					"un_a3": "862",
					"pop_year": -99,
					"gdp_md_est": 357400,
					"name": "Venezuela",
					"sovereignt": "Venezuela",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 4,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "Venezuela",
					"postal": "VE",
					"sov_a3": "VEN",
					"note_brk": "",
					"brk_a3": "VEN",
					"wb_a2": "VE",
					"brk_diff": 0,
					"admin": "Venezuela",
					"name_long": "Venezuela",
					"iso_a3": "VEN",
					"iso_a2": "VE",
					"adm0_a3_is": "VEN",
					"level": 2,
					"formal_en": "Bolivarian Republic of Venezuela",
					"name_len": 9,
					"mapcolor7": 1,
					"long_len": 9,
					"mapcolor8": 3,
					"mapcolor9": 1,
					"note_adm0": "",
					"iso_n3": "862",
					"homepart": 1,
					"subunit": "Venezuela",
					"name_alt": "",
					"brk_name": "Venezuela",
					"name_sort": "Venezuela, RB",
					"continent": "South America",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									106.61748046875016,
									8.682812500000082
								],
								[
									106.58925781249997,
									8.680517578124977
								],
								[
									106.56796875000009,
									8.700927734375043
								],
								[
									106.65859374999997,
									8.766357421875057
								],
								[
									106.64951171875009,
									8.72299804687502
								],
								[
									106.65253906250018,
									8.701123046875082
								],
								[
									106.61748046875016,
									8.682812500000082
								]
							]
						],
						[
							[
								[
									104.06396484375011,
									10.390820312500068
								],
								[
									104.08300781250011,
									10.34111328125006
								],
								[
									104.07578125000003,
									10.2248535156251
								],
								[
									104.03681640625018,
									10.110742187500023
								],
								[
									104.04833984374994,
									10.061035156250028
								],
								[
									104.01845703125002,
									10.029199218749937
								],
								[
									103.9521484375,
									10.242919921874957
								],
								[
									103.86796875000016,
									10.335400390624969
								],
								[
									103.84951171875014,
									10.371093749999957
								],
								[
									103.89843749999994,
									10.368505859374963
								],
								[
									103.98583984375011,
									10.426953124999969
								],
								[
									104.02773437500014,
									10.42836914062508
								],
								[
									104.06396484375011,
									10.390820312500068
								]
							]
						],
						[
							[
								[
									107.16767578125007,
									10.39716796874994
								],
								[
									107.08378906249999,
									10.336572265625023
								],
								[
									107.07792968750016,
									10.387500000000017
								],
								[
									107.15087890625011,
									10.420312500000037
								],
								[
									107.17656250000016,
									10.44619140624998
								],
								[
									107.1949218750002,
									10.445703125000051
								],
								[
									107.16767578125007,
									10.39716796874994
								]
							]
						],
						[
							[
								[
									107.03134765625009,
									20.74702148437504
								],
								[
									106.99003906249999,
									20.743066406249937
								],
								[
									106.91064453125,
									20.82421875000003
								],
								[
									106.95341796874999,
									20.867041015625063
								],
								[
									107.04375000000005,
									20.836816406249937
								],
								[
									107.064453125,
									20.81728515625005
								],
								[
									107.06396484374994,
									20.79975585937504
								],
								[
									107.04228515625016,
									20.76103515624996
								],
								[
									107.03134765625009,
									20.74702148437504
								]
							]
						],
						[
							[
								[
									106.86562499999997,
									20.815722656250074
								],
								[
									106.8541015625002,
									20.796386718750057
								],
								[
									106.80312500000014,
									20.84375000000003
								],
								[
									106.76943359375002,
									20.864208984374926
								],
								[
									106.79531250000014,
									20.92792968750004
								],
								[
									106.85507812500003,
									20.858251953125034
								],
								[
									106.86562499999997,
									20.815722656250074
								]
							]
						],
						[
							[
								[
									107.52128906250016,
									20.926611328125034
								],
								[
									107.46552734375007,
									20.90053710937505
								],
								[
									107.39921875000016,
									20.903466796875023
								],
								[
									107.47861328125009,
									20.95234375000004
								],
								[
									107.51894531250014,
									21.012841796875108
								],
								[
									107.55126953125011,
									21.034033203124977
								],
								[
									107.55107421874999,
									20.981201171875057
								],
								[
									107.52128906250016,
									20.926611328125034
								]
							]
						],
						[
							[
								[
									107.60273437500001,
									21.216796875000085
								],
								[
									107.45869140625018,
									21.09165039062509
								],
								[
									107.40351562500007,
									21.09365234375005
								],
								[
									107.45253906249997,
									21.23530273437504
								],
								[
									107.47626953125001,
									21.26894531250005
								],
								[
									107.56269531250007,
									21.220410156249926
								],
								[
									107.60273437500001,
									21.216796875000085
								]
							]
						],
						[
							[
								[
									107.97265625,
									21.50795898437508
								],
								[
									107.92578124999994,
									21.498925781250108
								],
								[
									107.80908203125,
									21.49711914062499
								],
								[
									107.70722656250018,
									21.405859375000063
								],
								[
									107.63671875000011,
									21.368066406249994
								],
								[
									107.52695312500003,
									21.33623046874999
								],
								[
									107.40996093750005,
									21.284814453124994
								],
								[
									107.37617187500018,
									21.194140625000074
								],
								[
									107.37333984375005,
									21.12846679687513
								],
								[
									107.35429687500016,
									21.055175781250114
								],
								[
									107.16474609375018,
									20.94873046875
								],
								[
									107.11171875000002,
									20.95957031250009
								],
								[
									107.07519531250011,
									20.999267578125
								],
								[
									107.01923828125018,
									20.991210937500057
								],
								[
									106.98144531250011,
									20.971386718750097
								],
								[
									106.93642578125002,
									20.974072265624926
								],
								[
									106.88623046875,
									20.950000000000074
								],
								[
									106.82060546875005,
									20.957519531250114
								],
								[
									106.76025390625011,
									20.991113281249937
								],
								[
									106.72519531250003,
									20.99990234375005
								],
								[
									106.68339843750016,
									21.00029296875013
								],
								[
									106.67548828125007,
									20.960498046875102
								],
								[
									106.73730468750011,
									20.80615234375
								],
								[
									106.75341796875011,
									20.735058593750097
								],
								[
									106.55078124999994,
									20.526562500000068
								],
								[
									106.5728515625002,
									20.39218749999995
								],
								[
									106.51796875000014,
									20.288867187500045
								],
								[
									106.39550781250011,
									20.20590820312512
								],
								[
									106.16572265625001,
									19.992041015625063
								],
								[
									106.06220703125018,
									19.98735351562499
								],
								[
									105.98408203125007,
									19.939062500000006
								],
								[
									105.81396484374994,
									19.58745117187496
								],
								[
									105.8121093750002,
									19.46699218750004
								],
								[
									105.78535156250018,
									19.378857421874926
								],
								[
									105.7911132812502,
									19.294189453125085
								],
								[
									105.71640625000003,
									19.12778320312512
								],
								[
									105.63906250000014,
									19.057177734375102
								],
								[
									105.62177734375007,
									18.966308593750085
								],
								[
									105.73203125000003,
									18.779296875000085
								],
								[
									105.74423828125003,
									18.746289062499926
								],
								[
									105.8082031250002,
									18.645849609374977
								],
								[
									105.83925781250014,
									18.57416992187504
								],
								[
									105.88828125000009,
									18.502490234375074
								],
								[
									106.06562500000007,
									18.316357421875097
								],
								[
									106.14453124999994,
									18.25942382812505
								],
								[
									106.23955078125016,
									18.220703125000057
								],
								[
									106.41191406249999,
									18.05317382812504
								],
								[
									106.4990234375,
									17.94643554687505
								],
								[
									106.45937499999997,
									17.873681640624966
								],
								[
									106.47890625000014,
									17.71958007812509
								],
								[
									106.35585937500014,
									17.76503906250005
								],
								[
									106.37050781250002,
									17.746875000000074
								],
								[
									106.51679687500007,
									17.662792968750068
								],
								[
									106.73574218749997,
									17.367187500000085
								],
								[
									106.92617187500014,
									17.22138671875004
								],
								[
									107.11992187499999,
									17.05551757812509
								],
								[
									107.18037109375007,
									16.897949218750057
								],
								[
									107.3550781250002,
									16.79374999999996
								],
								[
									107.54931640625,
									16.642578125000057
								],
								[
									107.54082031250005,
									16.608642578125085
								],
								[
									107.59345703125018,
									16.568066406249983
								],
								[
									107.72412109375,
									16.48784179687499
								],
								[
									107.80312500000002,
									16.403076171874943
								],
								[
									107.83378906250005,
									16.322460937499955
								],
								[
									107.88203125000018,
									16.309619140625102
								],
								[
									107.93632812500016,
									16.32939453125013
								],
								[
									107.99072265625011,
									16.33710937500001
								],
								[
									108.0293945312502,
									16.33110351562513
								],
								[
									108.08798828125003,
									16.24272460937496
								],
								[
									108.16972656249999,
									16.16367187500012
								],
								[
									108.20898437500011,
									16.09106445312497
								],
								[
									108.2408203125002,
									16.100781250000097
								],
								[
									108.26738281249999,
									16.089794921874983
								],
								[
									108.2740234375002,
									16.029052734375057
								],
								[
									108.28603515624997,
									15.989062500000074
								],
								[
									108.39531250000005,
									15.872460937499937
								],
								[
									108.44746093750018,
									15.762695312500057
								],
								[
									108.57783203125018,
									15.584716796875028
								],
								[
									108.67421875000002,
									15.48359375000004
								],
								[
									108.7427734375002,
									15.426611328125063
								],
								[
									108.82128906249994,
									15.3779296875
								],
								[
									108.89824218749999,
									15.18051757812502
								],
								[
									108.93994140624994,
									15.001464843750043
								],
								[
									109.0224609375,
									14.802832031250077
								],
								[
									109.08486328125002,
									14.716162109375006
								],
								[
									109.0870117187502,
									14.552587890625077
								],
								[
									109.1373046875002,
									14.384130859375034
								],
								[
									109.19140624999994,
									14.270458984375068
								],
								[
									109.20732421874999,
									14.154296875000028
								],
								[
									109.22392578124999,
									14.0966796875001
								],
								[
									109.24462890624994,
									14.053417968750082
								],
								[
									109.3033203125002,
									13.8564453125001
								],
								[
									109.28808593750011,
									13.765039062500037
								],
								[
									109.24707031250011,
									13.854736328125014
								],
								[
									109.25205078125003,
									13.590527343750011
								],
								[
									109.28808593750011,
									13.450781249999963
								],
								[
									109.27187500000002,
									13.279345703125031
								],
								[
									109.30957031249994,
									13.219189453125026
								],
								[
									109.37675781250016,
									13.025488281250006
								],
								[
									109.42392578125009,
									12.955957031250051
								],
								[
									109.42001953125009,
									12.719042968750017
								],
								[
									109.44492187500009,
									12.5996093750001
								],
								[
									109.3814453125002,
									12.670751953125034
								],
								[
									109.3355468750002,
									12.75190429687504
								],
								[
									109.27402343750009,
									12.709033203125017
								],
								[
									109.21894531250007,
									12.645800781250017
								],
								[
									109.30468750000011,
									12.391162109375088
								],
								[
									109.20683593750016,
									12.415380859375048
								],
								[
									109.21572265625014,
									12.072900390625094
								],
								[
									109.25625000000002,
									11.992871093749955
								],
								[
									109.25917968749997,
									11.954541015625054
								],
								[
									109.24726562500007,
									11.908691406250028
								],
								[
									109.22021484374994,
									11.958837890624949
								],
								[
									109.21455078125007,
									12.010449218749983
								],
								[
									109.19912109375002,
									11.999023437500057
								],
								[
									109.19990234375018,
									11.97246093750006
								],
								[
									109.16728515624999,
									11.912011718750094
								],
								[
									109.15751953125016,
									11.83710937500011
								],
								[
									109.19267578125005,
									11.773437500000014
								],
								[
									109.19863281250002,
									11.724853515625057
								],
								[
									109.17324218749997,
									11.664746093750068
								],
								[
									109.13251953125001,
									11.601074218750071
								],
								[
									109.0396484375002,
									11.592675781250051
								],
								[
									109.01845703124997,
									11.468359375000034
								],
								[
									108.98671875000002,
									11.336376953124969
								],
								[
									108.82080078125011,
									11.315429687500057
								],
								[
									108.70029296875009,
									11.199267578125017
								],
								[
									108.55126953125011,
									11.155957031249983
								],
								[
									108.41855468750009,
									11.040722656249955
								],
								[
									108.27167968750018,
									10.93427734374994
								],
								[
									108.17617187499997,
									10.920166015625085
								],
								[
									108.09492187500001,
									10.897265625000031
								],
								[
									108.00136718749997,
									10.720361328125051
								],
								[
									107.84511718750014,
									10.700097656250108
								],
								[
									107.56445312499994,
									10.555468750000031
								],
								[
									107.47031250000003,
									10.485839843750057
								],
								[
									107.38447265625018,
									10.458642578125023
								],
								[
									107.26152343750016,
									10.398388671875011
								],
								[
									107.23505859375018,
									10.41987304687504
								],
								[
									107.19414062500005,
									10.471582031250094
								],
								[
									107.08779296875014,
									10.498339843749946
								],
								[
									107.03574218750009,
									10.556298828125023
								],
								[
									107.02070312500001,
									10.630957031249963
								],
								[
									107.00664062499999,
									10.660546874999952
								],
								[
									106.98369140625016,
									10.618310546875051
								],
								[
									106.96611328124999,
									10.440722656249932
								],
								[
									106.94746093750001,
									10.400341796875054
								],
								[
									106.90205078125001,
									10.382812500000028
								],
								[
									106.81269531250001,
									10.43330078125011
								],
								[
									106.72734375000016,
									10.535644531250085
								],
								[
									106.60585937499997,
									10.464941406250063
								],
								[
									106.64306640625011,
									10.456250000000068
								],
								[
									106.69843750000001,
									10.462060546875108
								],
								[
									106.74121093750011,
									10.44438476562506
								],
								[
									106.77753906250007,
									10.376123046875094
								],
								[
									106.77626953124997,
									10.338964843750077
								],
								[
									106.75742187500003,
									10.295800781250065
								],
								[
									106.64355468750011,
									10.288916015625091
								],
								[
									106.49169921875011,
									10.30410156250008
								],
								[
									106.46406250000007,
									10.29829101562504
								],
								[
									106.60244140625002,
									10.231738281249989
								],
								[
									106.72900390625011,
									10.193310546875068
								],
								[
									106.7852539062502,
									10.151171875000088
								],
								[
									106.7852539062502,
									10.116455078125043
								],
								[
									106.71416015625005,
									10.060205078125037
								],
								[
									106.65917968750011,
									9.991406250000054
								],
								[
									106.65810546874997,
									9.948730468750057
								],
								[
									106.65683593750009,
									9.90107421875004
								],
								[
									106.59560546875014,
									9.859863281250071
								],
								[
									106.55732421875007,
									9.868066406250065
								],
								[
									106.44912109375014,
									9.939648437500082
								],
								[
									106.13642578125018,
									10.221679687500071
								],
								[
									106.18359375000011,
									10.142089843750114
								],
								[
									106.5074218750002,
									9.821240234375026
								],
								[
									106.56435546875014,
									9.715625000000003
								],
								[
									106.57246093750001,
									9.6411132812501
								],
								[
									106.53916015625009,
									9.603564453125088
								],
								[
									106.48408203125007,
									9.559423828124977
								],
								[
									106.3780273437502,
									9.556103515625011
								],
								[
									106.20400390625002,
									9.67543945312508
								],
								[
									105.92568359374997,
									9.961718750000045
								],
								[
									105.83095703125014,
									10.000732421875
								],
								[
									106.11250000000001,
									9.673583984375057
								],
								[
									106.15859374999997,
									9.594140625000037
								],
								[
									106.2061523437502,
									9.502343750000065
								],
								[
									106.19257812500018,
									9.447802734374974
								],
								[
									106.16835937500014,
									9.396728515625043
								],
								[
									105.50097656249994,
									9.093212890625026
								],
								[
									105.40136718750011,
									8.962402343750028
								],
								[
									105.32226562499994,
									8.801123046875034
								],
								[
									105.19121093749999,
									8.711328125000037
								],
								[
									105.11435546875003,
									8.629199218750003
								],
								[
									104.89189453125005,
									8.583251953125057
								],
								[
									104.77041015624997,
									8.597656249999972
								],
								[
									104.89628906250016,
									8.746630859374946
								],
								[
									104.81855468750001,
									8.801855468750006
								],
								[
									104.81464843750001,
									9.185498046875097
								],
								[
									104.84521484375011,
									9.606152343750082
								],
								[
									104.90322265625014,
									9.816259765625077
								],
								[
									104.98710937500016,
									9.868652343750085
								],
								[
									105.09257812500016,
									9.90097656250002
								],
								[
									105.09492187500018,
									9.945263671875068
								],
								[
									105.08447265625011,
									9.995703125000034
								],
								[
									105.02783203125011,
									10.067431640625088
								],
								[
									104.96582031250011,
									10.100585937500085
								],
								[
									104.87324218750007,
									10.11479492187506
								],
								[
									104.80195312500018,
									10.202734375000034
								],
								[
									104.74765625000003,
									10.199121093750094
								],
								[
									104.66347656250014,
									10.1699218750001
								],
								[
									104.61269531250002,
									10.207666015625051
								],
								[
									104.59404296875005,
									10.266894531250045
								],
								[
									104.51611328124994,
									10.339990234375108
								],
								[
									104.42636718750003,
									10.411230468749963
								],
								[
									104.46699218750018,
									10.4223632812501
								],
								[
									104.51406249999997,
									10.463330078125097
								],
								[
									104.56425781250016,
									10.515966796875077
								],
								[
									104.68964843750007,
									10.523242187500045
								],
								[
									104.81542968750011,
									10.520800781250074
								],
								[
									104.85058593749994,
									10.534472656250017
								],
								[
									104.90126953124997,
									10.590234375000108
								],
								[
									104.98388671874994,
									10.661914062500045
								],
								[
									105.04638671875,
									10.701660156250071
								],
								[
									105.06113281250003,
									10.733789062499952
								],
								[
									105.03613281250011,
									10.809375000000074
								],
								[
									105.02226562500005,
									10.886865234375051
								],
								[
									105.04570312500005,
									10.911376953125071
								],
								[
									105.15947265624999,
									10.897558593750091
								],
								[
									105.28427734375003,
									10.861474609375023
								],
								[
									105.31464843750018,
									10.845166015625082
								],
								[
									105.38652343749999,
									10.940087890625051
								],
								[
									105.40576171875011,
									10.951611328125097
								],
								[
									105.45273437500009,
									10.951416015625057
								],
								[
									105.57656249999997,
									10.968896484375065
								],
								[
									105.69775390625,
									10.994042968750037
								],
								[
									105.75507812500001,
									10.9899902343751
								],
								[
									105.81074218750018,
									10.926074218750045
								],
								[
									105.85332031250016,
									10.863574218750017
								],
								[
									105.87519531250018,
									10.858496093750048
								],
								[
									105.93818359375001,
									10.885156250000051
								],
								[
									105.99013671875014,
									10.851806640625014
								],
								[
									106.09882812500018,
									10.797265625000094
								],
								[
									106.16396484375014,
									10.794921874999972
								],
								[
									106.13154296875018,
									10.921972656250091
								],
								[
									106.16796874999994,
									11.01230468750002
								],
								[
									106.16093750000005,
									11.0371093750001
								],
								[
									106.09951171875014,
									11.078662109375045
								],
								[
									105.89160156249994,
									11.244824218749969
								],
								[
									105.85605468750009,
									11.294287109375091
								],
								[
									105.8609375000002,
									11.37241210937502
								],
								[
									105.85400390625011,
									11.487060546875028
								],
								[
									105.83535156250014,
									11.559130859375045
								],
								[
									105.83847656250003,
									11.601318359374943
								],
								[
									105.85146484375014,
									11.635009765625057
								],
								[
									105.88984375000007,
									11.64838867187494
								],
								[
									105.92656250000016,
									11.652929687499977
								],
								[
									105.95625000000018,
									11.682470703125048
								],
								[
									106.00605468750018,
									11.758007812500068
								],
								[
									106.10292968750014,
									11.751269531250031
								],
								[
									106.23916015624997,
									11.708349609375077
								],
								[
									106.33984374999994,
									11.681835937500097
								],
								[
									106.39921875000016,
									11.687011718750085
								],
								[
									106.41250000000014,
									11.69780273437506
								],
								[
									106.4107421875002,
									11.738378906249977
								],
								[
									106.41777343750005,
									11.911718750000034
								],
								[
									106.41386718750005,
									11.948437500000054
								],
								[
									106.4996093750002,
									11.965527343750068
								],
								[
									106.6309570312502,
									11.969189453125097
								],
								[
									106.70009765625002,
									11.979296875000031
								],
								[
									106.76464843750011,
									12.052343749999991
								],
								[
									106.9306640625,
									12.077490234374963
								],
								[
									107.05068359375002,
									12.175878906249935
								],
								[
									107.15898437500016,
									12.27705078124994
								],
								[
									107.21210937500001,
									12.304003906250017
								],
								[
									107.27968750000014,
									12.321582031250045
								],
								[
									107.33007812500011,
									12.319042968749969
								],
								[
									107.39335937499999,
									12.260498046874943
								],
								[
									107.44599609375018,
									12.295703125000102
								],
								[
									107.50644531250003,
									12.364550781250003
								],
								[
									107.53808593750011,
									12.431787109375023
								],
								[
									107.55546874999999,
									12.53999023437504
								],
								[
									107.54355468750003,
									12.705908203125091
								],
								[
									107.51152343750005,
									12.835742187500074
								],
								[
									107.48154296875003,
									12.933105468750014
								],
								[
									107.47539062500005,
									13.030371093749935
								],
								[
									107.5455078125002,
									13.225439453125063
								],
								[
									107.60546875,
									13.437792968750074
								],
								[
									107.59394531250001,
									13.52167968750011
								],
								[
									107.52861328125005,
									13.654199218750108
								],
								[
									107.46230468750014,
									13.81562500000004
								],
								[
									107.38945312500005,
									13.993017578125034
								],
								[
									107.36210937500016,
									14.019482421875097
								],
								[
									107.34257812500016,
									14.068896484374946
								],
								[
									107.33144531250002,
									14.12661132812498
								],
								[
									107.36035156249994,
									14.307861328124957
								],
								[
									107.36445312500018,
									14.368701171875088
								],
								[
									107.44843750000007,
									14.451220703125031
								],
								[
									107.49316406250011,
									14.54575195312502
								],
								[
									107.53525390625003,
									14.649951171875017
								],
								[
									107.51943359375014,
									14.705078125000057
								],
								[
									107.51376953125015,
									14.817382812500114
								],
								[
									107.5245117187502,
									14.871826171875014
								],
								[
									107.50468750000016,
									14.915917968750108
								],
								[
									107.48037109375008,
									14.979882812500179
								],
								[
									107.49628906250001,
									15.02143554687511
								],
								[
									107.55527343750015,
									15.057031249999994
								],
								[
									107.58964843750005,
									15.118457031250074
								],
								[
									107.63369140625014,
									15.189843750000051
								],
								[
									107.65312499999999,
									15.255224609375134
								],
								[
									107.62167968750015,
									15.309863281250074
								],
								[
									107.56425781249999,
									15.391601562500028
								],
								[
									107.4595703125002,
									15.465820312500057
								],
								[
									107.33876953125008,
									15.560498046875153
								],
								[
									107.27939453125009,
									15.618701171875017
								],
								[
									107.23261718750013,
									15.678076171875034
								],
								[
									107.18955078125003,
									15.747265624999926
								],
								[
									107.16591796875014,
									15.802490234375085
								],
								[
									107.18886718750008,
									15.838623046875057
								],
								[
									107.3606445312501,
									15.921728515625034
								],
								[
									107.39199218750008,
									15.951660156250085
								],
								[
									107.41015625000006,
									15.997851562500074
								],
								[
									107.39638671875008,
									16.04301757812496
								],
								[
									107.35009765625006,
									16.06738281250003
								],
								[
									107.29648437500015,
									16.08403320312496
								],
								[
									107.21738281250003,
									16.136328125000063
								],
								[
									107.06972656250008,
									16.27983398437516
								],
								[
									107.00195312500011,
									16.311816406250102
								],
								[
									106.93066406250006,
									16.353124999999977
								],
								[
									106.89277343750018,
									16.39653320312513
								],
								[
									106.85107421875011,
									16.515625000000057
								],
								[
									106.83242187500014,
									16.526269531249994
								],
								[
									106.79160156250015,
									16.490332031250063
								],
								[
									106.73955078125016,
									16.452539062500165
								],
								[
									106.69609375000016,
									16.45898437499997
								],
								[
									106.65644531250018,
									16.492626953125068
								],
								[
									106.63750000000005,
									16.537939453124977
								],
								[
									106.59365234375008,
									16.60009765625003
								],
								[
									106.5461914062501,
									16.65073242187495
								],
								[
									106.53369140625011,
									16.821044921875114
								],
								[
									106.52597656250003,
									16.87661132812505
								],
								[
									106.50224609374999,
									16.95410156250003
								],
								[
									106.46533203125006,
									16.98183593750008
								],
								[
									106.42597656250013,
									17.002539062500034
								],
								[
									106.33339843750008,
									17.143701171875108
								],
								[
									106.26953125000011,
									17.216796875000085
								],
								[
									106.00625000000014,
									17.41528320312503
								],
								[
									105.97353515625014,
									17.446972656249983
								],
								[
									105.90273437500008,
									17.52866210937512
								],
								[
									105.77949218750001,
									17.644433593750165
								],
								[
									105.69140625000011,
									17.737841796875017
								],
								[
									105.6272460937501,
									17.83442382812504
								],
								[
									105.59765625000011,
									17.91826171874999
								],
								[
									105.5884765625002,
									17.98369140624999
								],
								[
									105.51855468750006,
									18.077441406250102
								],
								[
									105.45820312500013,
									18.15429687500003
								],
								[
									105.40000000000015,
									18.17924804687496
								],
								[
									105.33349609375011,
									18.18964843750004
								],
								[
									105.2732421875001,
									18.235351562500114
								],
								[
									105.16328125000018,
									18.338720703125034
								],
								[
									105.1145507812501,
									18.405273437500085
								],
								[
									105.08583984375014,
									18.450097656250165
								],
								[
									105.08701171875015,
									18.49624023437505
								],
								[
									105.11347656250007,
									18.573046875000074
								],
								[
									105.14541015625008,
									18.61679687500009
								],
								[
									105.14648437500011,
									18.650976562500063
								],
								[
									105.11513671875014,
									18.67885742187505
								],
								[
									104.99316406250006,
									18.72832031249999
								],
								[
									104.71650390625013,
									18.803417968749926
								],
								[
									104.61328125000011,
									18.86064453125013
								],
								[
									104.51796875000008,
									18.934082031250085
								],
								[
									104.44580078125011,
									18.983837890625097
								],
								[
									104.10859375000013,
									19.195556640625057
								],
								[
									104.00634765625011,
									19.230908203124983
								],
								[
									103.91835937500014,
									19.268505859375097
								],
								[
									103.89160156250011,
									19.304980468750074
								],
								[
									103.89638671875008,
									19.339990234374994
								],
								[
									103.93203125000008,
									19.366064453125063
								],
								[
									104.02753906250018,
									19.420458984375045
								],
								[
									104.06289062500008,
									19.482568359375193
								],
								[
									104.05156250000016,
									19.56416015625001
								],
								[
									104.01347656250016,
									19.646484375
								],
								[
									104.03203124999999,
									19.675146484374977
								],
								[
									104.06279296875016,
									19.678417968750125
								],
								[
									104.12714843750001,
									19.680859374999983
								],
								[
									104.25986328125003,
									19.68549804687504
								],
								[
									104.54628906250008,
									19.61054687500004
								],
								[
									104.58789062500011,
									19.61874999999995
								],
								[
									104.74316406250011,
									19.754736328125034
								],
								[
									104.80175781250006,
									19.836132812500097
								],
								[
									104.81513671875001,
									19.904003906250068
								],
								[
									104.84580078125003,
									19.94716796875005
								],
								[
									104.92792968750018,
									20.018115234375045
								],
								[
									104.92919921875011,
									20.082812500000074
								],
								[
									104.88867187500011,
									20.16909179687508
								],
								[
									104.84785156250013,
									20.202441406250017
								],
								[
									104.81269531250018,
									20.216845703125102
								],
								[
									104.69873046875011,
									20.20532226562517
								],
								[
									104.67695312500013,
									20.224707031250034
								],
								[
									104.66191406250016,
									20.289013671875068
								],
								[
									104.65644531250001,
									20.32851562500005
								],
								[
									104.61884765625013,
									20.374511718750085
								],
								[
									104.49619140625009,
									20.413671874999977
								],
								[
									104.3921875000002,
									20.42475585937501
								],
								[
									104.3677734375002,
									20.44140625000003
								],
								[
									104.4078125000002,
									20.485742187500108
								],
								[
									104.47861328125003,
									20.52958984375016
								],
								[
									104.53271484375006,
									20.554882812500153
								],
								[
									104.57519531250011,
									20.60024414062505
								],
								[
									104.58320312500001,
									20.646679687499926
								],
								[
									104.5303710937502,
									20.687988281250085
								],
								[
									104.46142578125011,
									20.733740234375006
								],
								[
									104.34960937500006,
									20.821093750000102
								],
								[
									104.19531250000006,
									20.913964843750023
								],
								[
									104.1013671875001,
									20.945507812500153
								],
								[
									104.05205078124999,
									20.941210937500074
								],
								[
									103.88203125000018,
									20.861425781250063
								],
								[
									103.79052734375011,
									20.809521484375153
								],
								[
									103.71445312500015,
									20.716943359375136
								],
								[
									103.63505859375016,
									20.697070312500074
								],
								[
									103.55468750000011,
									20.73784179687513
								],
								[
									103.46357421875001,
									20.77983398437516
								],
								[
									103.21074218750005,
									20.840625000000102
								],
								[
									103.10449218750006,
									20.891650390625102
								],
								[
									102.88378906250011,
									21.202587890625125
								],
								[
									102.85117187500015,
									21.26591796874996
								],
								[
									102.87226562500018,
									21.337500000000063
								],
								[
									102.88750000000016,
									21.43994140625017
								],
								[
									102.90957031250014,
									21.50634765625
								],
								[
									102.94863281250008,
									21.56977539062504
								],
								[
									102.95917968750013,
									21.626220703125085
								],
								[
									102.94960937500014,
									21.68134765625004
								],
								[
									102.91767578125018,
									21.71293945312499
								],
								[
									102.87617187500018,
									21.72226562500012
								],
								[
									102.84521484375006,
									21.734765625000193
								],
								[
									102.81591796875006,
									21.807373046875057
								],
								[
									102.79824218750008,
									21.79794921875009
								],
								[
									102.77109375000015,
									21.70966796875004
								],
								[
									102.7385742187501,
									21.677929687500153
								],
								[
									102.69531250000011,
									21.66210937500003
								],
								[
									102.66201171875014,
									21.67602539062503
								],
								[
									102.64082031250018,
									21.711425781250057
								],
								[
									102.63125000000008,
									21.771337890625006
								],
								[
									102.60966796875016,
									21.85175781250004
								],
								[
									102.58251953125011,
									21.904296875000085
								],
								[
									102.48750000000013,
									21.957763671875142
								],
								[
									102.44267578125016,
									22.027148437500074
								],
								[
									102.30136718750015,
									22.178173828125097
								],
								[
									102.18300781250008,
									22.284033203125006
								],
								[
									102.12744140625006,
									22.379199218750017
								],
								[
									102.17597656250018,
									22.414648437500034
								],
								[
									102.23701171875018,
									22.46601562500004
								],
								[
									102.30224609375011,
									22.545996093749977
								],
								[
									102.37578124999999,
									22.646630859374966
								],
								[
									102.40644531250001,
									22.708007812499943
								],
								[
									102.42792968750007,
									22.732812499999937
								],
								[
									102.47089843750001,
									22.750927734374983
								],
								[
									102.5171875000002,
									22.741015625000102
								],
								[
									102.59853515625002,
									22.700390625000097
								],
								[
									102.72099609375016,
									22.64848632812499
								],
								[
									102.83007812500011,
									22.587158203125114
								],
								[
									102.87421875000001,
									22.525390625000057
								],
								[
									102.9351562500002,
									22.466162109375063
								],
								[
									102.98193359374994,
									22.448242187500057
								],
								[
									103.00537109375011,
									22.45297851562495
								],
								[
									103.07587890625018,
									22.49750976562504
								],
								[
									103.13632812500003,
									22.542236328125114
								],
								[
									103.13759765625014,
									22.592968749999955
								],
								[
									103.19335937500011,
									22.638525390625006
								],
								[
									103.26630859375007,
									22.713525390625108
								],
								[
									103.30058593750005,
									22.764404296875057
								],
								[
									103.32666015625011,
									22.769775390625085
								],
								[
									103.35605468750003,
									22.754687500000045
								],
								[
									103.47099609375005,
									22.59741210937497
								],
								[
									103.49296875000016,
									22.587988281250006
								],
								[
									103.52539062500011,
									22.611572265625114
								],
								[
									103.57070312499997,
									22.734423828125102
								],
								[
									103.62021484375003,
									22.782031250000017
								],
								[
									103.63730468750003,
									22.77001953124997
								],
								[
									103.9150390625,
									22.538232421874994
								],
								[
									103.94150390625003,
									22.540087890625017
								],
								[
									103.97138671875018,
									22.55048828125001
								],
								[
									103.99082031250003,
									22.586132812499983
								],
								[
									104.0126953125,
									22.66635742187509
								],
								[
									104.05390625000001,
									22.75229492187509
								],
								[
									104.14306640625,
									22.800146484374977
								],
								[
									104.2125000000002,
									22.809423828125006
								],
								[
									104.23828125000011,
									22.768505859374926
								],
								[
									104.29833984375,
									22.712011718750063
								],
								[
									104.37177734375001,
									22.70405273437504
								],
								[
									104.52685546875011,
									22.80410156250008
								],
								[
									104.57753906250014,
									22.82001953125004
								],
								[
									104.63173828124997,
									22.81821289062512
								],
								[
									104.68730468749999,
									22.82221679687504
								],
								[
									104.74003906249999,
									22.860498046875023
								],
								[
									104.79570312500016,
									22.911132812499943
								],
								[
									104.81474609375005,
									23.01079101562499
								],
								[
									104.82656250000014,
									23.10019531250009
								],
								[
									104.86474609375011,
									23.136376953124994
								],
								[
									104.91015625000011,
									23.16054687500005
								],
								[
									104.99570312500003,
									23.194335937500085
								],
								[
									105.1890625000002,
									23.28105468749999
								],
								[
									105.23876953125011,
									23.322119140625006
								],
								[
									105.27539062500011,
									23.34521484375
								],
								[
									105.35048828125014,
									23.30766601562499
								],
								[
									105.44013671875018,
									23.2353515625
								],
								[
									105.49453124999997,
									23.180859375000097
								],
								[
									105.5308593750002,
									23.121972656249994
								],
								[
									105.54814453125016,
									23.07265625000008
								],
								[
									105.69121093750016,
									23.02993164062508
								],
								[
									105.78232421875009,
									22.969335937500063
								],
								[
									105.84296875000018,
									22.92280273437501
								],
								[
									105.90263671875016,
									22.92495117187508
								],
								[
									105.96230468749997,
									22.937451171875068
								],
								[
									106.00097656250011,
									22.974755859374937
								],
								[
									106.0684570312502,
									22.97553710937501
								],
								[
									106.14843749999994,
									22.970068359375034
								],
								[
									106.18398437500002,
									22.955126953125017
								],
								[
									106.24941406250014,
									22.869433593750074
								],
								[
									106.27900390625018,
									22.857470703125017
								],
								[
									106.33808593750007,
									22.863476562500097
								],
								[
									106.45087890625001,
									22.893896484374977
								],
								[
									106.54179687500016,
									22.908349609374994
								],
								[
									106.62402343749994,
									22.874267578125057
								],
								[
									106.7802734375,
									22.778906250000006
								],
								[
									106.73632812500011,
									22.710937500000114
								],
								[
									106.70156250000014,
									22.637744140625017
								],
								[
									106.63310546875005,
									22.586035156250063
								],
								[
									106.58242187500002,
									22.57324218750003
								],
								[
									106.55039062500003,
									22.50136718750005
								],
								[
									106.53632812500001,
									22.395410156250023
								],
								[
									106.55361328125002,
									22.341699218750023
								],
								[
									106.59316406249997,
									22.324511718750074
								],
								[
									106.63652343749999,
									22.288623046875045
								],
								[
									106.65419921874997,
									22.24145507812503
								],
								[
									106.66005859375002,
									22.13647460937503
								],
								[
									106.65771484375,
									22.018212890625023
								],
								[
									106.66357421875011,
									21.97890625000008
								],
								[
									106.69765625000014,
									21.986181640624977
								],
								[
									106.72949218749994,
									22.00034179687512
								],
								[
									106.79414062500007,
									21.981982421875102
								],
								[
									106.87451171875011,
									21.951269531250063
								],
								[
									106.92519531250014,
									21.920117187499926
								],
								[
									106.97099609375005,
									21.92392578125009
								],
								[
									107.00644531250003,
									21.89340820312509
								],
								[
									107.01982421875005,
									21.834863281249966
								],
								[
									107.0616210937502,
									21.794189453124943
								],
								[
									107.17851562500005,
									21.717089843750045
								],
								[
									107.27207031250009,
									21.710644531250068
								],
								[
									107.3511718750002,
									21.60888671875003
								],
								[
									107.43349609375014,
									21.642285156250068
								],
								[
									107.47138671875018,
									21.59833984375001
								],
								[
									107.64101562500014,
									21.61391601562508
								],
								[
									107.75927734374994,
									21.655029296875114
								],
								[
									107.80205078125016,
									21.64516601562505
								],
								[
									107.90839843750007,
									21.560400390625006
								],
								[
									107.97265625,
									21.50795898437508
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "South-Eastern Asia",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "VNM",
					"su_a3": "VNM",
					"brk_group": "",
					"region_wb": "East Asia & Pacific",
					"wb_a3": "VNM",
					"gu_a3": "VNM",
					"abbrev": "Viet.",
					"region_un": "Asia",
					"adm0_a3_us": "VNM",
					"scalerank": 1,
					"pop_est": 86967524,
					"adm0_dif": 0,
					"un_a3": "704",
					"pop_year": -99,
					"gdp_md_est": 241700,
					"name": "Vietnam",
					"sovereignt": "Vietnam",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "4. Lower middle income",
					"geou_dif": 0,
					"geounit": "Vietnam",
					"postal": "VN",
					"sov_a3": "VNM",
					"note_brk": "",
					"brk_a3": "VNM",
					"wb_a2": "VN",
					"brk_diff": 0,
					"admin": "Vietnam",
					"name_long": "Vietnam",
					"iso_a3": "VNM",
					"iso_a2": "VN",
					"adm0_a3_is": "VNM",
					"level": 2,
					"formal_en": "Socialist Republic of Vietnam",
					"name_len": 7,
					"mapcolor7": 5,
					"long_len": 7,
					"mapcolor8": 6,
					"mapcolor9": 5,
					"note_adm0": "",
					"iso_n3": "704",
					"homepart": 1,
					"subunit": "Vietnam",
					"name_alt": "",
					"brk_name": "Vietnam",
					"name_sort": "Vietnam",
					"continent": "Asia",
					"mapcolor13": 4,
					"fips_10": "",
					"tiny": 2,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2009
				}
			},
			{
				"geometry": {
					"coordinates": [
						[
							[
								[
									37.856933593750114,
									-46.94423828125001
								],
								[
									37.81396484375,
									-46.962890624999986
								],
								[
									37.611816406250114,
									-46.94648437499994
								],
								[
									37.59003906250018,
									-46.90800781250009
								],
								[
									37.64970703124999,
									-46.84892578124996
								],
								[
									37.68486328125016,
									-46.82402343750003
								],
								[
									37.78955078125,
									-46.83750000000002
								],
								[
									37.87285156250016,
									-46.88544921874994
								],
								[
									37.8876953125,
									-46.901660156250045
								],
								[
									37.856933593750114,
									-46.94423828125001
								]
							]
						],
						[
							[
								[
									31.287890625000045,
									-22.402050781250026
								],
								[
									31.293164062500068,
									-22.45468749999999
								],
								[
									31.30019531250008,
									-22.47861328124999
								],
								[
									31.348046875000136,
									-22.617578124999966
								],
								[
									31.41933593750008,
									-22.825097656249966
								],
								[
									31.466699218750136,
									-23.016699218750006
								],
								[
									31.53173828125,
									-23.279492187499983
								],
								[
									31.529687500000023,
									-23.425781250000043
								],
								[
									31.545605468750068,
									-23.48232421875001
								],
								[
									31.60410156250009,
									-23.55292968750001
								],
								[
									31.675585937500045,
									-23.674218750000023
								],
								[
									31.700000000000045,
									-23.743066406250023
								],
								[
									31.72402343750008,
									-23.79453125000002
								],
								[
									31.799609375000045,
									-23.89218750000002
								],
								[
									31.85830078125008,
									-24.040234374999983
								],
								[
									31.908007812500102,
									-24.23623046874995
								],
								[
									31.950585937500136,
									-24.330273437499926
								],
								[
									31.966601562500045,
									-24.37646484375
								],
								[
									31.985839843750057,
									-24.46064453125001
								],
								[
									31.983203125000045,
									-24.638281249999963
								],
								[
									31.984375000000114,
									-24.84404296874996
								],
								[
									31.985742187500023,
									-25.073828124999963
								],
								[
									31.987011718750125,
									-25.263476562499974
								],
								[
									31.979394531250136,
									-25.35947265624999
								],
								[
									31.984570312500068,
									-25.631933593749977
								],
								[
									31.920312500000023,
									-25.773925781249957
								],
								[
									31.928320312500034,
									-25.885351562500006
								],
								[
									31.9482421875,
									-25.95761718749999
								],
								[
									31.921679687500045,
									-25.96875000000003
								],
								[
									31.871484375000023,
									-25.981640624999997
								],
								[
									31.64042968749999,
									-25.867285156249963
								],
								[
									31.415136718750034,
									-25.746582031249986
								],
								[
									31.382617187500045,
									-25.74296874999996
								],
								[
									31.335156250000068,
									-25.75556640625004
								],
								[
									31.207324218750045,
									-25.843359374999977
								],
								[
									31.08808593750001,
									-25.98066406249997
								],
								[
									31.033300781250034,
									-26.09775390625002
								],
								[
									30.945214843750136,
									-26.218749999999986
								],
								[
									30.80332031250009,
									-26.413476562500037
								],
								[
									30.789062500000114,
									-26.45546874999998
								],
								[
									30.78750000000008,
									-26.613671874999966
								],
								[
									30.794335937500136,
									-26.764257812500006
								],
								[
									30.80673828125009,
									-26.78525390625002
								],
								[
									30.883300781250057,
									-26.792382812499966
								],
								[
									30.93808593750009,
									-26.915820312499974
								],
								[
									31.063378906250136,
									-27.112304687500043
								],
								[
									31.274023437500034,
									-27.238378906249963
								],
								[
									31.46953124999999,
									-27.295507812499963
								],
								[
									31.742578125000136,
									-27.30996093749998
								],
								[
									31.958398437500136,
									-27.30585937500004
								],
								[
									31.946093750000045,
									-27.173632812500003
								],
								[
									31.967187500000136,
									-26.960644531250054
								],
								[
									31.99472656250009,
									-26.81748046875002
								],
								[
									32.02480468750008,
									-26.811132812499963
								],
								[
									32.081640625000034,
									-26.82480468749999
								],
								[
									32.11289062500009,
									-26.839453124999963
								],
								[
									32.19960937500008,
									-26.833496093749986
								],
								[
									32.353515625,
									-26.86162109375003
								],
								[
									32.47773437500007,
									-26.85849609375002
								],
								[
									32.588769531250136,
									-26.855761718750003
								],
								[
									32.776562500000125,
									-26.850976562499994
								],
								[
									32.886132812500136,
									-26.84931640625001
								],
								[
									32.84912109374994,
									-27.080175781250063
								],
								[
									32.70585937499999,
									-27.441601562499983
								],
								[
									32.65703124999999,
									-27.607324218749994
								],
								[
									32.534765625000034,
									-28.199707031250057
								],
								[
									32.37519531250007,
									-28.498242187499955
								],
								[
									32.285742187500034,
									-28.62148437500001
								],
								[
									32.027246093750136,
									-28.839550781250026
								],
								[
									31.95537109375016,
									-28.883789062499986
								],
								[
									31.891503906250023,
									-28.91210937500007
								],
								[
									31.778222656250023,
									-28.937109375000006
								],
								[
									31.335156250000182,
									-29.378125000000054
								],
								[
									31.169921875,
									-29.590820312500043
								],
								[
									31.023339843749966,
									-29.90087890625007
								],
								[
									30.877636718750068,
									-30.071093749999932
								],
								[
									30.663574218749943,
									-30.434179687500006
								],
								[
									30.472265625000034,
									-30.714550781249926
								],
								[
									30.288671875000034,
									-30.970117187500023
								],
								[
									29.971191406250114,
									-31.32207031250006
								],
								[
									29.830273437500182,
									-31.423828125
								],
								[
									29.73515625000016,
									-31.470410156250082
								],
								[
									29.482910156250114,
									-31.674707031250037
								],
								[
									29.12783203125008,
									-32.00312500000007
								],
								[
									28.85595703125003,
									-32.294238281250045
								],
								[
									28.449414062500068,
									-32.624609375000034
								],
								[
									28.214062499999983,
									-32.76923828125001
								],
								[
									27.860644531250017,
									-33.05390625
								],
								[
									27.762109375000023,
									-33.095996093750045
								],
								[
									27.363769531250057,
									-33.36054687500004
								],
								[
									27.077441406250074,
									-33.52119140625008
								],
								[
									26.61367187500008,
									-33.70742187500001
								],
								[
									26.429492187500045,
									-33.759570312499974
								],
								[
									25.989550781250045,
									-33.711328124999994
								],
								[
									25.80585937500001,
									-33.73710937500002
								],
								[
									25.652441406250006,
									-33.849609375000014
								],
								[
									25.63818359375003,
									-34.011132812500065
								],
								[
									25.574218750000057,
									-34.035351562500026
								],
								[
									25.47724609375001,
									-34.028124999999974
								],
								[
									25.169726562500074,
									-33.9607421875
								],
								[
									25.00292968750003,
									-33.97363281250006
								],
								[
									24.90556640624999,
									-34.059765625000026
								],
								[
									24.8271484375,
									-34.16894531250006
								],
								[
									24.595507812500074,
									-34.174511718749955
								],
								[
									24.18300781250005,
									-34.06152343750003
								],
								[
									23.697851562500063,
									-33.99277343750005
								],
								[
									23.585546875000006,
									-33.98515625
								],
								[
									23.350390625000074,
									-34.06894531250002
								],
								[
									23.268164062500006,
									-34.08115234375002
								],
								[
									22.925585937500045,
									-34.06318359375001
								],
								[
									22.73554687500004,
									-34.01025390625006
								],
								[
									22.553808593750063,
									-34.01005859375002
								],
								[
									22.41445312500008,
									-34.05380859375005
								],
								[
									22.24550781250005,
									-34.06914062500006
								],
								[
									21.788964843750023,
									-34.37265624999999
								],
								[
									21.553222656250057,
									-34.37304687500007
								],
								[
									21.349804687499983,
									-34.40820312499996
								],
								[
									21.24892578125005,
									-34.407031250000074
								],
								[
									21.060156250000034,
									-34.364648437499966
								],
								[
									20.989843750000034,
									-34.36748046875
								],
								[
									20.882421874999977,
									-34.38652343750006
								],
								[
									20.774804687499994,
									-34.43994140625003
								],
								[
									20.529882812500006,
									-34.463085937500026
								],
								[
									20.434667968749977,
									-34.50859375000006
								],
								[
									20.020605468750006,
									-34.785742187500034
								],
								[
									19.926269531250057,
									-34.77470703125002
								],
								[
									19.85000000000005,
									-34.75664062500006
								],
								[
									19.63496093750004,
									-34.75332031249992
								],
								[
									19.391503906249994,
									-34.60566406250004
								],
								[
									19.298242187500023,
									-34.61503906249999
								],
								[
									19.32324218750003,
									-34.57080078125004
								],
								[
									19.330761718750068,
									-34.492382812500054
								],
								[
									19.279394531249977,
									-34.43701171875004
								],
								[
									19.24462890625,
									-34.41230468750008
								],
								[
									19.14912109375001,
									-34.41689453124995
								],
								[
									19.09833984375004,
									-34.350097656250014
								],
								[
									18.95214843750003,
									-34.34374999999997
								],
								[
									18.90156250000001,
									-34.36064453125003
								],
								[
									18.831347656250017,
									-34.36406250000002
								],
								[
									18.82509765625008,
									-34.296484374999935
								],
								[
									18.830664062500063,
									-34.25390625000004
								],
								[
									18.826367187500068,
									-34.18847656249996
								],
								[
									18.80878906250004,
									-34.108203124999946
								],
								[
									18.75214843750004,
									-34.08261718750006
								],
								[
									18.708691406250068,
									-34.071875000000006
								],
								[
									18.60517578125004,
									-34.077343750000054
								],
								[
									18.533886718749983,
									-34.08593750000003
								],
								[
									18.500390624999994,
									-34.109277343750065
								],
								[
									18.46210937500001,
									-34.16806640625006
								],
								[
									18.46162109375001,
									-34.34687500000007
								],
								[
									18.41035156250004,
									-34.29560546875001
								],
								[
									18.35205078124997,
									-34.18847656249996
								],
								[
									18.333398437499994,
									-34.07421875000003
								],
								[
									18.354394531250023,
									-33.93906249999995
								],
								[
									18.465039062499983,
									-33.88779296875006
								],
								[
									18.456445312500023,
									-33.796484375000034
								],
								[
									18.43300781250005,
									-33.71728515625006
								],
								[
									18.309472656250023,
									-33.51445312500003
								],
								[
									18.26123046875003,
									-33.42167968750006
								],
								[
									18.156347656249977,
									-33.35878906250004
								],
								[
									18.074804687499977,
									-33.20732421874999
								],
								[
									17.992578125000023,
									-33.15234375000007
								],
								[
									17.95839843750008,
									-33.046386718749986
								],
								[
									17.87822265624999,
									-32.961523437500006
								],
								[
									17.851074218750057,
									-32.827441406250045
								],
								[
									17.895312500000017,
									-32.75048828125
								],
								[
									17.96523437500005,
									-32.70859374999999
								],
								[
									18.036523437499994,
									-32.77509765625004
								],
								[
									18.125,
									-32.74912109374999
								],
								[
									18.25087890625005,
									-32.65214843749996
								],
								[
									18.325292968750034,
									-32.50498046874999
								],
								[
									18.32988281249999,
									-32.269531249999986
								],
								[
									18.31074218750001,
									-32.12246093750005
								],
								[
									18.21083984375008,
									-31.74248046874999
								],
								[
									18.163671875000063,
									-31.655175781250065
								],
								[
									17.938574218750034,
									-31.38320312500008
								],
								[
									17.67744140625004,
									-31.019042968750043
								],
								[
									17.34707031250005,
									-30.444824218750043
								],
								[
									17.189062500000006,
									-30.099804687499997
								],
								[
									16.950000000000074,
									-29.403417968749977
								],
								[
									16.739453124999983,
									-29.00937499999999
								],
								[
									16.480761718750045,
									-28.64150390625001
								],
								[
									16.447558593750017,
									-28.61757812500001
								],
								[
									16.487109375000017,
									-28.572851562499963
								],
								[
									16.62617187500001,
									-28.487890624999977
								],
								[
									16.68945312500003,
									-28.46494140624992
								],
								[
									16.723046875000023,
									-28.475488281249937
								],
								[
									16.755761718750023,
									-28.45214843749997
								],
								[
									16.787499999999994,
									-28.394726562499997
								],
								[
									16.794531250000006,
									-28.34082031250003
								],
								[
									16.810156250000006,
									-28.26455078124995
								],
								[
									16.841210937500023,
									-28.218945312499983
								],
								[
									16.875292968750045,
									-28.1279296875
								],
								[
									16.93330078125004,
									-28.06962890625003
								],
								[
									17.056250000000034,
									-28.03105468749999
								],
								[
									17.14941406250003,
									-28.08222656250001
								],
								[
									17.18847656249997,
									-28.132519531250054
								],
								[
									17.20458984374997,
									-28.198828124999963
								],
								[
									17.24580078125004,
									-28.23085937500001
								],
								[
									17.31201171875003,
									-28.22861328124999
								],
								[
									17.358691406250017,
									-28.269433593749966
								],
								[
									17.38574218750003,
									-28.353222656249983
								],
								[
									17.38027343750008,
									-28.41396484375001
								],
								[
									17.342578125000017,
									-28.451660156249957
								],
								[
									17.34785156250004,
									-28.50117187500001
								],
								[
									17.39589843750005,
									-28.56269531249994
								],
								[
									17.41572265625001,
									-28.621093750000014
								],
								[
									17.44794921875001,
									-28.698144531249994
								],
								[
									17.616796875000034,
									-28.743066406249994
								],
								[
									17.699316406250063,
									-28.768359374999918
								],
								[
									17.841601562500074,
									-28.776953124999977
								],
								[
									17.97607421875003,
									-28.81132812499996
								],
								[
									18.102734374999983,
									-28.871679687500006
								],
								[
									18.310839843750017,
									-28.88623046875003
								],
								[
									18.600390625000045,
									-28.85527343750003
								],
								[
									18.838769531250023,
									-28.869140625000014
								],
								[
									19.026074218750068,
									-28.927929687499997
								],
								[
									19.161718750000006,
									-28.93876953124999
								],
								[
									19.245800781250068,
									-28.901660156249974
								],
								[
									19.28222656250003,
									-28.84794921874996
								],
								[
									19.270996093750057,
									-28.77773437500005
								],
								[
									19.31269531250001,
									-28.733300781249966
								],
								[
									19.4072265625,
									-28.71445312499995
								],
								[
									19.482910156250057,
									-28.661621093750014
								],
								[
									19.539843750000017,
									-28.574609374999966
								],
								[
									19.671484375000034,
									-28.503906250000043
								],
								[
									19.87783203125005,
									-28.449414062499955
								],
								[
									19.98046875,
									-28.451269531249977
								],
								[
									19.98046875,
									-28.310351562500045
								],
								[
									19.98046875,
									-27.865527343750017
								],
								[
									19.98046875,
									-27.42070312499999
								],
								[
									19.98046875,
									-26.97597656249998
								],
								[
									19.98046875,
									-26.53115234374995
								],
								[
									19.98046875,
									-26.086328124999923
								],
								[
									19.98046875,
									-25.641601562499915
								],
								[
									19.98046875,
									-25.19677734374997
								],
								[
									19.98046875,
									-24.776757812500023
								],
								[
									20.028613281250045,
									-24.807031249999966
								],
								[
									20.345214843750057,
									-25.02988281249999
								],
								[
									20.430664062500057,
									-25.147070312499963
								],
								[
									20.47314453125,
									-25.22128906249999
								],
								[
									20.609277343750023,
									-25.4912109375
								],
								[
									20.710742187500017,
									-25.733203125000003
								],
								[
									20.79316406250001,
									-25.915624999999963
								],
								[
									20.799414062500034,
									-25.999023437499986
								],
								[
									20.81103515625,
									-26.080566406249986
								],
								[
									20.82265625000008,
									-26.12060546874997
								],
								[
									20.815039062500034,
									-26.16494140624995
								],
								[
									20.75703125000001,
									-26.264160156249915
								],
								[
									20.697851562500034,
									-26.340136718750017
								],
								[
									20.626757812500045,
									-26.44384765624993
								],
								[
									20.619921875000074,
									-26.58085937500003
								],
								[
									20.64140624999999,
									-26.742187499999957
								],
								[
									20.68505859375,
									-26.82246093749997
								],
								[
									20.739843750000063,
									-26.84882812500001
								],
								[
									20.870898437500045,
									-26.808789062500026
								],
								[
									20.953906250000074,
									-26.821093750000045
								],
								[
									21.07099609375004,
									-26.851757812499983
								],
								[
									21.454980468750023,
									-26.832812499999946
								],
								[
									21.50136718750005,
									-26.842675781249994
								],
								[
									21.64628906249999,
									-26.85419921875004
								],
								[
									21.694726562499994,
									-26.84091796874999
								],
								[
									21.738085937500045,
									-26.806835937499983
								],
								[
									21.788281250000068,
									-26.710058593749977
								],
								[
									21.833203125000068,
									-26.67832031249999
								],
								[
									21.91455078125003,
									-26.661914062499946
								],
								[
									22.01093750000004,
									-26.635839843749963
								],
								[
									22.090917968749977,
									-26.58017578124999
								],
								[
									22.217578125000045,
									-26.388867187499997
								],
								[
									22.47089843750004,
									-26.21904296874996
								],
								[
									22.548632812500074,
									-26.178417968750026
								],
								[
									22.59765625000003,
									-26.132714843750037
								],
								[
									22.640234374999977,
									-26.071191406250037
								],
								[
									22.72900390625003,
									-25.85732421874998
								],
								[
									22.79609375000004,
									-25.679101562499994
								],
								[
									22.818945312500063,
									-25.595117187500037
								],
								[
									22.878808593749994,
									-25.457910156249966
								],
								[
									22.951269531250034,
									-25.37031249999997
								],
								[
									23.022070312500063,
									-25.32412109374998
								],
								[
									23.05751953125008,
									-25.312304687499974
								],
								[
									23.148730468750017,
									-25.288671875000034
								],
								[
									23.266015625000023,
									-25.266601562499986
								],
								[
									23.389257812500006,
									-25.29140624999998
								],
								[
									23.52148437500003,
									-25.344433593750026
								],
								[
									23.670703125000045,
									-25.43398437499998
								],
								[
									23.823437500000068,
									-25.544628906250054
								],
								[
									23.89375000000001,
									-25.60087890624996
								],
								[
									23.969531250000074,
									-25.62607421874995
								],
								[
									24.104492187500057,
									-25.634863281249963
								],
								[
									24.192968750000034,
									-25.63291015624992
								],
								[
									24.33056640625,
									-25.74287109374994
								],
								[
									24.400195312500074,
									-25.749804687499932
								],
								[
									24.555859375000068,
									-25.783105468749966
								],
								[
									24.748144531249977,
									-25.817382812500014
								],
								[
									24.869238281250063,
									-25.813476562500014
								],
								[
									24.998925781250023,
									-25.754003906249977
								],
								[
									25.092480468750068,
									-25.751464843749915
								],
								[
									25.21337890625,
									-25.756249999999994
								],
								[
									25.346191406250057,
									-25.739941406250054
								],
								[
									25.443652343750017,
									-25.714453125000006
								],
								[
									25.518164062500006,
									-25.66279296874997
								],
								[
									25.583789062500045,
									-25.60624999999999
								],
								[
									25.659179687500057,
									-25.43789062499998
								],
								[
									25.70263671875003,
									-25.302343749999977
								],
								[
									25.76992187500005,
									-25.146484374999943
								],
								[
									25.85244140625008,
									-24.935253906249983
								],
								[
									25.88183593750003,
									-24.787988281249994
								],
								[
									25.912109375000057,
									-24.74746093750001
								],
								[
									26.031835937500034,
									-24.702441406249974
								],
								[
									26.130859375000057,
									-24.671484374999977
								],
								[
									26.39716796875004,
									-24.61357421874999
								],
								[
									26.451757812500063,
									-24.58271484375001
								],
								[
									26.501562500000063,
									-24.51328124999999
								],
								[
									26.617773437500034,
									-24.39550781249997
								],
								[
									26.761132812500023,
									-24.297167968749932
								],
								[
									26.835058593750063,
									-24.24082031249999
								],
								[
									26.97060546875005,
									-23.763476562499918
								],
								[
									26.98701171875004,
									-23.70458984375
								],
								[
									27.085546875000034,
									-23.57792968750003
								],
								[
									27.14638671875008,
									-23.52441406249997
								],
								[
									27.185546875000057,
									-23.523437500000043
								],
								[
									27.24121093750003,
									-23.49003906249999
								],
								[
									27.31337890625008,
									-23.42421874999998
								],
								[
									27.399218750000074,
									-23.383593749999974
								],
								[
									27.49873046875001,
									-23.36835937499997
								],
								[
									27.563183593749983,
									-23.324609375000037
								],
								[
									27.59267578125005,
									-23.25263671874994
								],
								[
									27.643847656250074,
									-23.217675781249923
								],
								[
									27.71679687500003,
									-23.219628906249966
								],
								[
									27.75830078125003,
									-23.19677734374993
								],
								[
									27.7685546875,
									-23.14892578125003
								],
								[
									27.812597656250006,
									-23.108007812499963
								],
								[
									27.89052734375008,
									-23.073925781250026
								],
								[
									27.93134765625004,
									-23.03359374999998
								],
								[
									27.93505859375,
									-22.987011718749997
								],
								[
									28.027929687500006,
									-22.87373046875001
								],
								[
									28.210156249999983,
									-22.693652343750003
								],
								[
									28.38173828125005,
									-22.59335937499992
								],
								[
									28.542871093749994,
									-22.572949218750026
								],
								[
									28.69550781250001,
									-22.535449218750017
								],
								[
									28.83984375000003,
									-22.480859374999994
								],
								[
									28.94580078125003,
									-22.395117187500034
								],
								[
									29.013476562500045,
									-22.278417968749963
								],
								[
									29.129882812500057,
									-22.213281249999937
								],
								[
									29.364843750000034,
									-22.19394531249999
								],
								[
									29.377441406250114,
									-22.192773437500023
								],
								[
									29.663085937500057,
									-22.14628906249996
								],
								[
									29.902343750000114,
									-22.18417968750005
								],
								[
									30.190429687500114,
									-22.291113281249977
								],
								[
									30.460156250000182,
									-22.329003906249966
								],
								[
									30.711621093750068,
									-22.297851562500014
								],
								[
									30.91611328125009,
									-22.290722656249983
								],
								[
									31.073437500000068,
									-22.30781250000001
								],
								[
									31.197265625000057,
									-22.34492187500001
								],
								[
									31.287890625000045,
									-22.402050781250026
								]
							],
							[
								[
									28.736914062500006,
									-30.101953124999994
								],
								[
									28.901074218750068,
									-30.038476562500037
								],
								[
									28.975292968749983,
									-29.99941406249998
								],
								[
									29.02900390625001,
									-29.967578124999974
								],
								[
									29.09804687500005,
									-29.919042968750034
								],
								[
									29.121972656250023,
									-29.80117187500001
								],
								[
									29.142187500000063,
									-29.700976562500017
								],
								[
									29.195117187500017,
									-29.651660156250003
								],
								[
									29.24921875000001,
									-29.618847656249983
								],
								[
									29.29355468750009,
									-29.56689453124997
								],
								[
									29.348828125000182,
									-29.44199218750002
								],
								[
									29.386718750000057,
									-29.31972656249998
								],
								[
									29.39072265625009,
									-29.269726562499997
								],
								[
									29.370898437500045,
									-29.218457031249955
								],
								[
									29.335937500000114,
									-29.163671874999977
								],
								[
									29.30136718750009,
									-29.089843750000043
								],
								[
									29.259765625000057,
									-29.078320312499997
								],
								[
									29.17802734374999,
									-29.036914062499918
								],
								[
									29.05800781250005,
									-28.95371093750002
								],
								[
									28.953710937500034,
									-28.881445312500034
								],
								[
									28.856250000000074,
									-28.77607421874997
								],
								[
									28.816210937500017,
									-28.75888671875002
								],
								[
									28.721777343750034,
									-28.687695312499997
								],
								[
									28.68115234375003,
									-28.646777343750017
								],
								[
									28.652636718750074,
									-28.597851562499997
								],
								[
									28.625781250000017,
									-28.581738281249997
								],
								[
									28.583398437499994,
									-28.59414062499995
								],
								[
									28.47187500000001,
									-28.615820312500006
								],
								[
									28.23261718750004,
									-28.701269531250006
								],
								[
									28.084375000000023,
									-28.77998046874997
								],
								[
									27.95986328125008,
									-28.87333984374999
								],
								[
									27.830371093750074,
									-28.90908203124998
								],
								[
									27.73554687500001,
									-28.940039062499977
								],
								[
									27.66044921874999,
									-29.046972656250006
								],
								[
									27.59023437500008,
									-29.14648437500003
								],
								[
									27.527148437500017,
									-29.236132812500003
								],
								[
									27.491015625000045,
									-29.27656249999997
								],
								[
									27.458007812500057,
									-29.30273437499997
								],
								[
									27.424902343750063,
									-29.360058593750026
								],
								[
									27.35683593750005,
									-29.45527343749997
								],
								[
									27.294531250000063,
									-29.51933593749996
								],
								[
									27.20742187500008,
									-29.554199218749957
								],
								[
									27.095214843750057,
									-29.599316406249997
								],
								[
									27.056933593750074,
									-29.62558593750002
								],
								[
									27.05175781249997,
									-29.664062499999957
								],
								[
									27.091796875000057,
									-29.753710937499932
								],
								[
									27.130468750000034,
									-29.840234374999966
								],
								[
									27.19355468750001,
									-29.941308593750037
								],
								[
									27.23974609375,
									-30.01533203124994
								],
								[
									27.31269531250004,
									-30.10566406250004
								],
								[
									27.355371093750023,
									-30.158593749999994
								],
								[
									27.349707031250034,
									-30.24736328124996
								],
								[
									27.364062500000017,
									-30.27919921875005
								],
								[
									27.388476562500017,
									-30.31591796874997
								],
								[
									27.408593750000023,
									-30.32529296875002
								],
								[
									27.431445312500074,
									-30.33847656250005
								],
								[
									27.491992187500045,
									-30.363964843749997
								],
								[
									27.50654296875001,
									-30.38095703124999
								],
								[
									27.54902343750004,
									-30.41123046874995
								],
								[
									27.589648437500045,
									-30.46640624999999
								],
								[
									27.666601562500006,
									-30.542285156250003
								],
								[
									27.75312500000004,
									-30.600000000000037
								],
								[
									27.901855468750057,
									-30.623828124999918
								],
								[
									28.018164062500034,
									-30.642285156250026
								],
								[
									28.05683593750001,
									-30.63105468749997
								],
								[
									28.096386718749983,
									-30.58457031249999
								],
								[
									28.128710937500017,
									-30.525097656250054
								],
								[
									28.13906250000008,
									-30.44990234375001
								],
								[
									28.17617187500008,
									-30.409863281250026
								],
								[
									28.31542968750003,
									-30.21845703125001
								],
								[
									28.39208984375003,
									-30.147558593749963
								],
								[
									28.439062500000006,
									-30.142480468749994
								],
								[
									28.499609374999977,
									-30.128906249999986
								],
								[
									28.576660156250057,
									-30.12304687500003
								],
								[
									28.634375000000006,
									-30.128710937499946
								],
								[
									28.64687500000005,
									-30.126562500000034
								],
								[
									28.736914062500006,
									-30.101953124999994
								]
							]
						]
					],
					"type": "MultiPolygon"
				},
				"type": "Feature",
				"properties": {
					"formal_fr": "",
					"subregion": "Southern Africa",
					"labelrank": 2,
					"adm0_a3_un": -99,
					"adm0_a3": "ZAF",
					"su_a3": "ZAF",
					"brk_group": "",
					"region_wb": "Sub-Saharan Africa",
					"wb_a3": "ZAF",
					"gu_a3": "ZAF",
					"abbrev": "S.Af.",
					"region_un": "Africa",
					"adm0_a3_us": "ZAF",
					"scalerank": 1,
					"pop_est": 49052489,
					"adm0_dif": 0,
					"un_a3": "710",
					"pop_year": -99,
					"gdp_md_est": 491000,
					"name": "South Africa",
					"sovereignt": "South Africa",
					"economy": "5. Emerging region: G20",
					"type": "Sovereign country",
					"abbrev_len": 5,
					"su_dif": 0,
					"gdp_year": -99,
					"woe_id": -99,
					"income_grp": "3. Upper middle income",
					"geou_dif": 0,
					"geounit": "South Africa",
					"postal": "ZA",
					"sov_a3": "ZAF",
					"note_brk": "",
					"brk_a3": "ZAF",
					"wb_a2": "ZA",
					"brk_diff": 0,
					"admin": "South Africa",
					"name_long": "South Africa",
					"iso_a3": "ZAF",
					"iso_a2": "ZA",
					"adm0_a3_is": "ZAF",
					"level": 2,
					"formal_en": "Republic of South Africa",
					"name_len": 12,
					"mapcolor7": 2,
					"long_len": 12,
					"mapcolor8": 3,
					"mapcolor9": 4,
					"note_adm0": "",
					"iso_n3": "710",
					"homepart": 1,
					"subunit": "South Africa",
					"name_alt": "",
					"brk_name": "South Africa",
					"name_sort": "South Africa",
					"continent": "Africa",
					"mapcolor13": 2,
					"fips_10": "",
					"tiny": -99,
					"featurecla": "Admin-0 country",
					"adm0_a3_wb": -99,
					"wikipedia": -99,
					"lastcensus": 2001
				}
			}
		],
		"type": "FeatureCollection"
	};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _underscore = __webpack_require__(109);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Created by Julio Perez on 12/19/2016.
	                                                                                                                                                           */
	
	
	var IncomeWealthService = function IncomeWealthService() {
	    _classCallCheck(this, IncomeWealthService);
	
	    var vm = this;
	
	    vm.currentMax = 0;
	    vm.forecastMax = 0;
	    // vm.countrySegment = null;
	    vm.toggleSelected = null;
	    vm.latlngData = __webpack_require__(110);
	    vm.segmentedCountries = __webpack_require__(111);
	    // vm.segmentedCountries = require('./data/map-per-cap-coffee.json');
	
	    vm.getCountryLatLng = function () {
	        var countryLatLng = vm.latlngData.map(function (item) {
	            return {
	                country: item.country,
	                latlng: item.latlng
	            };
	        });
	
	        return countryLatLng;
	    };
	
	    vm.getCountrySegment = function (seg) {
	
	        var countrySegment = vm.segmentedCountries.filter(function (item) {
	            return item.segment === seg;
	        }).map(function (item) {
	            console.log("getCountrySegemetn:: ", item);
	            return item.metrics;
	        }).shift();
	
	        return countrySegment;
	    };
	
	    vm.getCurrentMax = function (seg) {
	
	        vm.currentMax = vm.segmentedCountries.filter(function (item) {
	            return item.segment === seg;
	        }).map(function (item) {
	            return item.current_max;
	        }).shift();
	
	        return vm.currentMax;
	    };
	
	    vm.getForecastMax = function (seg) {
	
	        vm.forecastMax = vm.segmentedCountries.filter(function (item) {
	            return item.segment === seg;
	        }).map(function (item) {
	            return item.forecast_max;
	        }).shift();
	
	        return vm.forecastMax;
	    };
	};
	
	exports.default = angular.module('income-wealth.service', []).service('incomeWealthService', IncomeWealthService).name;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function() {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var
	    push             = ArrayProto.push,
	    slice            = ArrayProto.slice,
	    toString         = ObjProto.toString,
	    hasOwnProperty   = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var
	    nativeIsArray      = Array.isArray,
	    nativeKeys         = Object.keys,
	    nativeBind         = FuncProto.bind,
	    nativeCreate       = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function(){};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1: return function(value) {
	        return func.call(context, value);
	      };
	      case 2: return function(value, other) {
	        return func.call(context, value, other);
	      };
	      case 3: return function(value, index, collection) {
	        return func.call(context, value, index, collection);
	      };
	      case 4: return function(accumulator, value, index, collection) {
	        return func.call(context, accumulator, value, index, collection);
	      };
	    }
	    return function() {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function(value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function(keysFunc, undefinedOnly) {
	    return function(obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor;
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function(key) {
	    return function(obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function(obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function(obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function(obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function(obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function(value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function(obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function(obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function(value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function(obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function(obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function(obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function(obj, iteratee, context) {
	    var result = -Infinity, lastComputed = -Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function(obj, iteratee, context) {
	    var result = Infinity, lastComputed = Infinity,
	        value, computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function(obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function(obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function(value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function(left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function(behavior) {
	    return function(obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function(value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function(result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function(result, value, key) {
	    if (_.has(result, key)) result[key]++; else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function(obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function(obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [], fail = [];
	    _.each(obj, function(value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function(array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function(array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function(array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function(array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function(input, shallow, strict, startIndex) {
	    var output = [], idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0, len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function(array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function(array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function() {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function(array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function(array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function(value){
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function() {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function(array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function(list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function(array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function(array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0, high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function(array, item, idx) {
	      var i = 0, length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	            i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function(start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function(func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function(func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function() {
	      var position = 0, length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) args.push(arguments[position++]);
	      return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function(obj) {
	    var i, length = arguments.length, key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function(func, hasher) {
	    var memoize = function(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function(func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function(){
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function(func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function() {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function(func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function() {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function(func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function() {
	    var args = arguments;
	    var start = args.length - 1;
	    return function() {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) result = args[i].call(this, result);
	      return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function(times, func) {
	    return function() {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function(times, func) {
	    var memo;
	    return function() {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
	                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) if (_.has(obj, key)) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function(obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) keys.push(key);
	    // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function(obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys =  _.keys(obj),
	          length = keys.length,
	          results = {},
	          currentKey;
	      for (var index = 0; index < length; index++) {
	        currentKey = keys[index];
	        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	      }
	      return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function(obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function(obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function(obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function(obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj), key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function(object, oiteratee, context) {
	    var result = {}, obj = object, iteratee, keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function(value, key, obj) { return key in obj; };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	   // Return a copy of the object without the blacklisted properties.
	  _.omit = function(obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function(prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function(obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function(obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function(object, attrs) {
	    var keys = _.keys(attrs), length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if (typeof a != 'object' || typeof b != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor, bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
	                               _.isFunction(bCtor) && bCtor instanceof bCtor)
	                          && ('constructor' in a && 'constructor' in b)) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a), key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function(a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function(obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function(obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function(obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function(obj) {
	    var type = typeof obj;
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
	    _['is' + name] = function(obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function(obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
	    _.isFunction = function(obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function(obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function(obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function(obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function(obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function(obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function(obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function() {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function(value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function(value) {
	    return function() {
	      return value;
	    };
	  };
	
	  _.noop = function(){};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function(obj) {
	    return obj == null ? function(){} : function(key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function(attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function(obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function(n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
	    return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function(min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function() {
	    return new Date().getTime();
	  };
	
	   // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function(map) {
	    var escaper = function(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function(string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function(object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function(prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate    : /<%([\s\S]+?)%>/g,
	    interpolate : /<%=([\s\S]+?)%>/g,
	    escape      : /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'":      "'",
	    '\\':     '\\',
	    '\r':     'r',
	    '\n':     'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function(text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([
	      (settings.escape || noMatch).source,
	      (settings.interpolate || noMatch).source,
	      (settings.evaluate || noMatch).source
	    ].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," +
	      "print=function(){__p+=__j.call(arguments,'');};\n" +
	      source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function(obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function(obj) {
	    _.each(_.functions(obj), function(name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function() {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function(name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function() {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function() {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function() {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}.call(this));


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = [
		{
			"latlng": [
				40.143105,
				47.576927
			],
			"country": "Azerbaijan"
		},
		{
			"latlng": [
				28.033886,
				1.659626
			],
			"country": "Algeria"
		},
		{
			"latlng": [
				-38.416097,
				-63.61667199999999
			],
			"country": "Argentina"
		},
		{
			"latlng": [
				47.516231,
				14.550072
			],
			"country": "Austria"
		},
		{
			"latlng": [
				-25.274398,
				133.775136
			],
			"country": "Australia"
		},
		{
			"latlng": [
				50.503887,
				4.469936
			],
			"country": "Belgium"
		},
		{
			"latlng": [
				26.0667,
				50.5577
			],
			"country": "Bahrain"
		},
		{
			"latlng": [
				53.709807,
				27.953389
			],
			"country": "Belarus"
		},
		{
			"latlng": [
				-14.235004,
				-51.92528
			],
			"country": "Brazil"
		},
		{
			"latlng": [
				43.915886,
				17.679076
			],
			"country": "Bosnia"
		},
		{
			"latlng": [
				42.733883,
				25.48583
			],
			"country": "Bulgaria"
		},
		{
			"latlng": [
				-16.290154,
				-63.58865299999999
			],
			"country": "Bolivia"
		},
		{
			"latlng": [
				56.130366,
				-106.346771
			],
			"country": "Canada"
		},
		{
			"latlng": [
				46.818188,
				8.227511999999999
			],
			"country": "Switzerland"
		},
		{
			"latlng": [
				-35.675147,
				-71.542969
			],
			"country": "Chile"
		},
		{
			"latlng": [
				35.86166,
				104.195397
			],
			"country": "China"
		},
		{
			"latlng": [
				4.570868,
				-74.297333
			],
			"country": "Colombia"
		},
		{
			"latlng": [
				45.1,
				15.2
			],
			"country": "Croatia"
		},
		{
			"latlng": [
				49.81749199999999,
				15.472962
			],
			"country": "Czech Rep"
		},
		{
			"latlng": [
				51.165691,
				10.451526
			],
			"country": "Germany"
		},
		{
			"latlng": [
				56.26392,
				9.501785
			],
			"country": "Denmark"
		},
		{
			"latlng": [
				18.735693,
				-70.162651
			],
			"country": "Dominican Rep"
		},
		{
			"latlng": [
				-1.831239,
				-78.18340599999999
			],
			"country": "Ecuador"
		},
		{
			"latlng": [
				26.820553,
				30.802498
			],
			"country": "Egypt"
		},
		{
			"latlng": [
				40.46366700000001,
				-3.74922
			],
			"country": "Spain"
		},
		{
			"latlng": [
				58.595272,
				25.013607
			],
			"country": "Estonia"
		},
		{
			"latlng": [
				61.92410999999999,
				25.748151
			],
			"country": "Finland"
		},
		{
			"latlng": [
				46.227638,
				2.213749
			],
			"country": "France"
		},
		{
			"latlng": [
				55.378051,
				-3.435973
			],
			"country": "United Kingdom"
		},
		{
			"latlng": [
				42.315407,
				43.35689199999999
			],
			"country": "Georgia"
		},
		{
			"latlng": [
				39.074208,
				21.824312
			],
			"country": "Greece"
		},
		{
			"latlng": [
				15.783471,
				-90.23075899999999
			],
			"country": "Guatemala"
		},
		{
			"latlng": [
				22.396428,
				114.109497
			],
			"country": "Hong Kong"
		},
		{
			"latlng": [
				47.162494,
				19.503304
			],
			"country": "Hungary"
		},
		{
			"latlng": [
				-0.789275,
				113.921327
			],
			"country": "Indonesia"
		},
		{
			"latlng": [
				53.41291,
				-8.24389
			],
			"country": "Ireland"
		},
		{
			"latlng": [
				20.593684,
				78.96288
			],
			"country": "India"
		},
		{
			"latlng": [
				32.427908,
				53.688046
			],
			"country": "Iran"
		},
		{
			"latlng": [
				31.046051,
				34.851612
			],
			"country": "Israel"
		},
		{
			"latlng": [
				41.87194,
				12.56738
			],
			"country": "Italy"
		},
		{
			"latlng": [
				30.585164,
				36.238414
			],
			"country": "Jordan"
		},
		{
			"latlng": [
				36.204824,
				138.252924
			],
			"country": "Japan"
		},
		{
			"latlng": [
				48.019573,
				66.923684
			],
			"country": "Kazakhstan"
		},
		{
			"latlng": [
				35.907757,
				127.766922
			],
			"country": "South Korea"
		},
		{
			"latlng": [
				29.31166,
				47.481766
			],
			"country": "Kuwait"
		},
		{
			"latlng": [
				-0.023559,
				37.906193
			],
			"country": "Kenya"
		},
		{
			"latlng": [
				56.879635,
				24.603189
			],
			"country": "Latvia"
		},
		{
			"latlng": [
				55.169438,
				23.881275
			],
			"country": "Lithuania"
		},
		{
			"latlng": [
				41.608635,
				21.745275
			],
			"country": "Macedonia"
		},
		{
			"latlng": [
				31.791702,
				-7.092619999999999
			],
			"country": "Morocco"
		},
		{
			"latlng": [
				23.634501,
				-102.552784
			],
			"country": "Mexico"
		},
		{
			"latlng": [
				4.210484,
				101.975766
			],
			"country": "Malaysia"
		},
		{
			"latlng": [
				9.081999,
				8.675277
			],
			"country": "Nigeria"
		},
		{
			"latlng": [
				52.132633,
				5.291265999999999
			],
			"country": "Netherlands"
		},
		{
			"latlng": [
				60.47202399999999,
				8.468945999999999
			],
			"country": "Norway"
		},
		{
			"latlng": [
				-40.900557,
				174.885971
			],
			"country": "New Zealand"
		},
		{
			"latlng": [
				7.369721999999999,
				12.354722
			],
			"country": "Cameroon"
		},
		{
			"latlng": [
				12.879721,
				121.774017
			],
			"country": "Philippines"
		},
		{
			"latlng": [
				30.375321,
				69.34511599999999
			],
			"country": "Pakistan"
		},
		{
			"latlng": [
				51.919438,
				19.145136
			],
			"country": "Poland"
		},
		{
			"latlng": [
				39.39987199999999,
				-8.224454
			],
			"country": "Portugal"
		},
		{
			"latlng": [
				-9.189967,
				-75.015152
			],
			"country": "Peru"
		},
		{
			"latlng": [
				25.354826,
				51.183884
			],
			"country": "Qatar"
		},
		{
			"latlng": [
				9.748916999999999,
				-83.753428
			],
			"country": "Costa Rica"
		},
		{
			"latlng": [
				45.943161,
				24.96676
			],
			"country": "Romania"
		},
		{
			"latlng": [
				61.52401,
				105.318756
			],
			"country": "Russia"
		},
		{
			"latlng": [
				23.885942,
				45.079162
			],
			"country": "Saudi Arabia"
		},
		{
			"latlng": [
				60.12816100000001,
				18.643501
			],
			"country": "Sweden"
		},
		{
			"latlng": [
				1.352083,
				103.819836
			],
			"country": "Singapore"
		},
		{
			"latlng": [
				48.669026,
				19.699024
			],
			"country": "Slovakia"
		},
		{
			"latlng": [
				46.151241,
				14.995463
			],
			"country": "Slovenia"
		},
		{
			"latlng": [
				15.870032,
				100.992541
			],
			"country": "Thailand"
		},
		{
			"latlng": [
				38.969719,
				59.556278
			],
			"country": "Turkmenistan"
		},
		{
			"latlng": [
				38.963745,
				35.243322
			],
			"country": "Turkey"
		},
		{
			"latlng": [
				33.886917,
				9.537499
			],
			"country": "Tunisia"
		},
		{
			"latlng": [
				23.69781,
				120.960515
			],
			"country": "Taiwan"
		},
		{
			"latlng": [
				23.424076,
				53.847818
			],
			"country": "United Arab Emirates"
		},
		{
			"latlng": [
				48.379433,
				31.16558
			],
			"country": "Ukraine"
		},
		{
			"latlng": [
				37.09024,
				-95.712891
			],
			"country": "USA"
		},
		{
			"latlng": [
				-32.522779,
				-55.765835
			],
			"country": "Uruguay"
		},
		{
			"latlng": [
				41.377491,
				64.585262
			],
			"country": "Uzbekistan"
		},
		{
			"latlng": [
				14.058324,
				108.277199
			],
			"country": "Vietnam"
		},
		{
			"latlng": [
				-30.559482,
				22.937506
			],
			"country": "South Africa"
		},
		{
			"latlng": [
				44.016521,
				21.005859
			],
			"country": "Serbia"
		}
	];

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = [
		{
			"segment": "Bottom",
			"forecast_year": "2030",
			"forecast_max": 950144.4,
			"unit": "Number of Adults, '000s",
			"current_max": 818072.8,
			"metrics": [
				{
					"metricValueCurrent": 5786.6,
					"metricValueForecast": 4802.2,
					"latlng": [
						40.143105,
						47.576927
					],
					"country": "Azerbaijan"
				},
				{
					"metricValueCurrent": 23358.2,
					"metricValueForecast": 26462.4,
					"latlng": [
						28.033886,
						1.659626
					],
					"country": "Algeria"
				},
				{
					"metricValueCurrent": 20740.9,
					"metricValueForecast": 22549.7,
					"latlng": [
						-38.416097,
						-63.61667199999999
					],
					"country": "Argentina"
				},
				{
					"metricValueCurrent": 2008.6,
					"metricValueForecast": 1662.8,
					"latlng": [
						47.516231,
						14.550072
					],
					"country": "Austria"
				},
				{
					"metricValueCurrent": 1397.4,
					"metricValueForecast": 1579.9,
					"latlng": [
						-25.274398,
						133.775136
					],
					"country": "Australia"
				},
				{
					"metricValueCurrent": 1181.1,
					"metricValueForecast": 1257.7,
					"latlng": [
						50.503887,
						4.469936
					],
					"country": "Belgium"
				},
				{
					"metricValueCurrent": 244.7,
					"metricValueForecast": 194,
					"latlng": [
						26.0667,
						50.5577
					],
					"country": "Bahrain"
				},
				{
					"metricValueCurrent": 6663.4,
					"metricValueForecast": 4434,
					"latlng": [
						53.709807,
						27.953389
					],
					"country": "Belarus"
				},
				{
					"metricValueCurrent": 121152.2,
					"metricValueForecast": 121032.7,
					"latlng": [
						-14.235004,
						-51.92528
					],
					"country": "Brazil"
				},
				{
					"metricValueCurrent": 2405.1,
					"metricValueForecast": 1195.5,
					"latlng": [
						43.915886,
						17.679076
					],
					"country": "Bosnia"
				},
				{
					"metricValueCurrent": 3342.3,
					"metricValueForecast": 1180.8,
					"latlng": [
						42.733883,
						25.48583
					],
					"country": "Bulgaria"
				},
				{
					"metricValueCurrent": 5889.4,
					"metricValueForecast": 6450,
					"latlng": [
						-16.290154,
						-63.58865299999999
					],
					"country": "Bolivia"
				},
				{
					"metricValueCurrent": 4724.7,
					"metricValueForecast": 4422.2,
					"latlng": [
						56.130366,
						-106.346771
					],
					"country": "Canada"
				},
				{
					"metricValueCurrent": 953.2,
					"metricValueForecast": 977.4,
					"latlng": [
						46.818188,
						8.227511999999999
					],
					"country": "Switzerland"
				},
				{
					"metricValueCurrent": 6608.8,
					"metricValueForecast": 5067.9,
					"latlng": [
						-35.675147,
						-71.542969
					],
					"country": "Chile"
				},
				{
					"metricValueCurrent": 686506.2,
					"metricValueForecast": 368978.8,
					"latlng": [
						35.86166,
						104.195397
					],
					"country": "China"
				},
				{
					"metricValueCurrent": 23682.9,
					"metricValueForecast": 15434.7,
					"latlng": [
						4.570868,
						-74.297333
					],
					"country": "Colombia"
				},
				{
					"metricValueCurrent": 1639.8,
					"metricValueForecast": 740.7,
					"latlng": [
						45.1,
						15.2
					],
					"country": "Croatia"
				},
				{
					"metricValueCurrent": 3021.8,
					"metricValueForecast": 2615.3,
					"latlng": [
						49.81749199999999,
						15.472962
					],
					"country": "Czech Rep"
				},
				{
					"metricValueCurrent": 13841.3,
					"metricValueForecast": 11340.8,
					"latlng": [
						51.165691,
						10.451526
					],
					"country": "Germany"
				},
				{
					"metricValueCurrent": 1296.4,
					"metricValueForecast": 1234,
					"latlng": [
						56.26392,
						9.501785
					],
					"country": "Denmark"
				},
				{
					"metricValueCurrent": 3269.1,
					"metricValueForecast": 2257.4,
					"latlng": [
						18.735693,
						-70.162651
					],
					"country": "Dominican Rep"
				},
				{
					"metricValueCurrent": 7644.5,
					"metricValueForecast": 9324.7,
					"latlng": [
						-1.831239,
						-78.18340599999999
					],
					"country": "Ecuador"
				},
				{
					"metricValueCurrent": 49504.8,
					"metricValueForecast": 62988.8,
					"latlng": [
						26.820553,
						30.802498
					],
					"country": "Egypt"
				},
				{
					"metricValueCurrent": 5953.5,
					"metricValueForecast": 4538,
					"latlng": [
						40.46366700000001,
						-3.74922
					],
					"country": "Spain"
				},
				{
					"metricValueCurrent": 353.1,
					"metricValueForecast": 168,
					"latlng": [
						58.595272,
						25.013607
					],
					"country": "Estonia"
				},
				{
					"metricValueCurrent": 922.1,
					"metricValueForecast": 929.1,
					"latlng": [
						61.92410999999999,
						25.748151
					],
					"country": "Finland"
				},
				{
					"metricValueCurrent": 7434.8,
					"metricValueForecast": 6901.8,
					"latlng": [
						46.227638,
						2.213749
					],
					"country": "France"
				},
				{
					"metricValueCurrent": 7147.6,
					"metricValueForecast": 7155.2,
					"latlng": [
						55.378051,
						-3.435973
					],
					"country": "United Kingdom"
				},
				{
					"metricValueCurrent": 2265.6,
					"metricValueForecast": 1001.7,
					"latlng": [
						42.315407,
						43.35689199999999
					],
					"country": "Georgia"
				},
				{
					"metricValueCurrent": 1961.2,
					"metricValueForecast": 1433.9,
					"latlng": [
						39.074208,
						21.824312
					],
					"country": "Greece"
				},
				{
					"metricValueCurrent": 6916.8,
					"metricValueForecast": 6838.3,
					"latlng": [
						15.783471,
						-90.23075899999999
					],
					"country": "Guatemala"
				},
				{
					"metricValueCurrent": 1293.5,
					"metricValueForecast": 1110,
					"latlng": [
						22.396428,
						114.109497
					],
					"country": "Hong Kong"
				},
				{
					"metricValueCurrent": 3347.9,
					"metricValueForecast": 2256.3,
					"latlng": [
						47.162494,
						19.503304
					],
					"country": "Hungary"
				},
				{
					"metricValueCurrent": 154238,
					"metricValueForecast": 155798.8,
					"latlng": [
						-0.789275,
						113.921327
					],
					"country": "Indonesia"
				},
				{
					"metricValueCurrent": 568.5,
					"metricValueForecast": 535.4,
					"latlng": [
						53.41291,
						-8.24389
					],
					"country": "Ireland"
				},
				{
					"metricValueCurrent": 818072.8,
					"metricValueForecast": 950144.4,
					"latlng": [
						20.593684,
						78.96288
					],
					"country": "India"
				},
				{
					"metricValueCurrent": 51763.8,
					"metricValueForecast": 60590.1,
					"latlng": [
						32.427908,
						53.688046
					],
					"country": "Iran"
				},
				{
					"metricValueCurrent": 1115.3,
					"metricValueForecast": 1194.1,
					"latlng": [
						31.046051,
						34.851612
					],
					"country": "Israel"
				},
				{
					"metricValueCurrent": 6157.5,
					"metricValueForecast": 5536.6,
					"latlng": [
						41.87194,
						12.56738
					],
					"country": "Italy"
				},
				{
					"metricValueCurrent": 2477,
					"metricValueForecast": 2197.1,
					"latlng": [
						30.585164,
						36.238414
					],
					"country": "Jordan"
				},
				{
					"metricValueCurrent": 8359.6,
					"metricValueForecast": 8340.4,
					"latlng": [
						36.204824,
						138.252924
					],
					"country": "Japan"
				},
				{
					"metricValueCurrent": 10692.1,
					"metricValueForecast": 8305.3,
					"latlng": [
						48.019573,
						66.923684
					],
					"country": "Kazakhstan"
				},
				{
					"metricValueCurrent": 5115.7,
					"metricValueForecast": 4405.5,
					"latlng": [
						35.907757,
						127.766922
					],
					"country": "South Korea"
				},
				{
					"metricValueCurrent": 607.8,
					"metricValueForecast": 507.6,
					"latlng": [
						29.31166,
						47.481766
					],
					"country": "Kuwait"
				},
				{
					"metricValueCurrent": 23512.6,
					"metricValueForecast": 33632.4,
					"latlng": [
						-0.023559,
						37.906193
					],
					"country": "Kenya"
				},
				{
					"metricValueCurrent": 669.6,
					"metricValueForecast": 222.1,
					"latlng": [
						56.879635,
						24.603189
					],
					"country": "Latvia"
				},
				{
					"metricValueCurrent": 1182.6,
					"metricValueForecast": 379.4,
					"latlng": [
						55.169438,
						23.881275
					],
					"country": "Lithuania"
				},
				{
					"metricValueCurrent": 1271.6,
					"metricValueForecast": 897.8,
					"latlng": [
						41.608635,
						21.745275
					],
					"country": "Macedonia"
				},
				{
					"metricValueCurrent": 19466.3,
					"metricValueForecast": 17527.1,
					"latlng": [
						31.791702,
						-7.092619999999999
					],
					"country": "Morocco"
				},
				{
					"metricValueCurrent": 60744.8,
					"metricValueForecast": 58796.5,
					"latlng": [
						23.634501,
						-102.552784
					],
					"country": "Mexico"
				},
				{
					"metricValueCurrent": 15281.1,
					"metricValueForecast": 7375.9,
					"latlng": [
						4.210484,
						101.975766
					],
					"country": "Malaysia"
				},
				{
					"metricValueCurrent": 90906.9,
					"metricValueForecast": 135961.1,
					"latlng": [
						9.081999,
						8.675277
					],
					"country": "Nigeria"
				},
				{
					"metricValueCurrent": 2322.6,
					"metricValueForecast": 2404.4,
					"latlng": [
						52.132633,
						5.291265999999999
					],
					"country": "Netherlands"
				},
				{
					"metricValueCurrent": 902.8,
					"metricValueForecast": 974.1,
					"latlng": [
						60.47202399999999,
						8.468945999999999
					],
					"country": "Norway"
				},
				{
					"metricValueCurrent": 410,
					"metricValueForecast": 388.6,
					"latlng": [
						-40.900557,
						174.885971
					],
					"country": "New Zealand"
				},
				{
					"metricValueCurrent": 11691.6,
					"metricValueForecast": 16484.4,
					"latlng": [
						7.369721999999999,
						12.354722
					],
					"country": "Cameroon"
				},
				{
					"metricValueCurrent": 53713.7,
					"metricValueForecast": 48388.9,
					"latlng": [
						12.879721,
						121.774017
					],
					"country": "Philippines"
				},
				{
					"metricValueCurrent": 105840.5,
					"metricValueForecast": 114191.1,
					"latlng": [
						30.375321,
						69.34511599999999
					],
					"country": "Pakistan"
				},
				{
					"metricValueCurrent": 20253.7,
					"metricValueForecast": 11146.7,
					"latlng": [
						51.919438,
						19.145136
					],
					"country": "Poland"
				},
				{
					"metricValueCurrent": 2694.4,
					"metricValueForecast": 1863.9,
					"latlng": [
						39.39987199999999,
						-8.224454
					],
					"country": "Portugal"
				},
				{
					"metricValueCurrent": 14638.8,
					"metricValueForecast": 12718.5,
					"latlng": [
						-9.189967,
						-75.015152
					],
					"country": "Peru"
				},
				{
					"metricValueCurrent": 205.7,
					"metricValueForecast": 285.2,
					"latlng": [
						25.354826,
						51.183884
					],
					"country": "Qatar"
				},
				{
					"metricValueCurrent": 1693.9,
					"metricValueForecast": 1099.9,
					"latlng": [
						9.748916999999999,
						-83.753428
					],
					"country": "Costa Rica"
				},
				{
					"metricValueCurrent": 11504.8,
					"metricValueForecast": 5335.1,
					"latlng": [
						45.943161,
						24.96676
					],
					"country": "Romania"
				},
				{
					"metricValueCurrent": 107414.6,
					"metricValueForecast": 90866,
					"latlng": [
						61.52401,
						105.318756
					],
					"country": "Russia"
				},
				{
					"metricValueCurrent": 8051.3,
					"metricValueForecast": 7870.2,
					"latlng": [
						23.885942,
						45.079162
					],
					"country": "Saudi Arabia"
				},
				{
					"metricValueCurrent": 2216.6,
					"metricValueForecast": 2059.5,
					"latlng": [
						60.12816100000001,
						18.643501
					],
					"country": "Sweden"
				},
				{
					"metricValueCurrent": 486.2,
					"metricValueForecast": 390.1,
					"latlng": [
						1.352083,
						103.819836
					],
					"country": "Singapore"
				},
				{
					"metricValueCurrent": 1534.3,
					"metricValueForecast": 707.9,
					"latlng": [
						48.669026,
						19.699024
					],
					"country": "Slovakia"
				},
				{
					"metricValueCurrent": 456.8,
					"metricValueForecast": 297.5,
					"latlng": [
						46.151241,
						14.995463
					],
					"country": "Slovenia"
				},
				{
					"metricValueCurrent": 43429.2,
					"metricValueForecast": 35901.9,
					"latlng": [
						15.870032,
						100.992541
					],
					"country": "Thailand"
				},
				{
					"metricValueCurrent": 3153.3,
					"metricValueForecast": 1951.6,
					"latlng": [
						38.969719,
						59.556278
					],
					"country": "Turkmenistan"
				},
				{
					"metricValueCurrent": 36193.2,
					"metricValueForecast": 27399.9,
					"latlng": [
						38.963745,
						35.243322
					],
					"country": "Turkey"
				},
				{
					"metricValueCurrent": 5401.5,
					"metricValueForecast": 4425.8,
					"latlng": [
						33.886917,
						9.537499
					],
					"country": "Tunisia"
				},
				{
					"metricValueCurrent": 2454.9,
					"metricValueForecast": 1805.6,
					"latlng": [
						23.69781,
						120.960515
					],
					"country": "Taiwan"
				},
				{
					"metricValueCurrent": 1536.6,
					"metricValueForecast": 1144.2,
					"latlng": [
						23.424076,
						53.847818
					],
					"country": "United Arab Emirates"
				},
				{
					"metricValueCurrent": 36286.5,
					"metricValueForecast": 32617.3,
					"latlng": [
						48.379433,
						31.16558
					],
					"country": "Ukraine"
				},
				{
					"metricValueCurrent": 63459.3,
					"metricValueForecast": 54839.8,
					"latlng": [
						37.09024,
						-95.712891
					],
					"country": "USA"
				},
				{
					"metricValueCurrent": 869.2,
					"metricValueForecast": 475.7,
					"latlng": [
						-32.522779,
						-55.765835
					],
					"country": "Uruguay"
				},
				{
					"metricValueCurrent": 19431.7,
					"metricValueForecast": 22607.7,
					"latlng": [
						41.377491,
						64.585262
					],
					"country": "Uzbekistan"
				},
				{
					"metricValueCurrent": 62076.5,
					"metricValueForecast": 57401.4,
					"latlng": [
						14.058324,
						108.277199
					],
					"country": "Vietnam"
				},
				{
					"metricValueCurrent": 25816.9,
					"metricValueForecast": 21369.3,
					"latlng": [
						-30.559482,
						22.937506
					],
					"country": "South Africa"
				},
				{
					"metricValueCurrent": 4581.5,
					"metricValueForecast": 2257.1,
					"latlng": [
						44.016521,
						21.005859
					],
					"country": "Serbia"
				}
			],
			"current_year": "2016"
		},
		{
			"segment": "Middle",
			"forecast_year": "2030",
			"forecast_max": 666688.8,
			"unit": "Number of Adults, '000s",
			"current_max": 369457.5,
			"metrics": [
				{
					"metricValueCurrent": 1271.3,
					"metricValueForecast": 3124.7,
					"latlng": [
						40.143105,
						47.576927
					],
					"country": "Azerbaijan"
				},
				{
					"metricValueCurrent": 3496.7,
					"metricValueForecast": 6858.5,
					"latlng": [
						28.033886,
						1.659626
					],
					"country": "Algeria"
				},
				{
					"metricValueCurrent": 9209.1,
					"metricValueForecast": 12364.2,
					"latlng": [
						-38.416097,
						-63.61667199999999
					],
					"country": "Argentina"
				},
				{
					"metricValueCurrent": 3333,
					"metricValueForecast": 3314.5,
					"latlng": [
						47.516231,
						14.550072
					],
					"country": "Austria"
				},
				{
					"metricValueCurrent": 4959,
					"metricValueForecast": 3188.9,
					"latlng": [
						-25.274398,
						133.775136
					],
					"country": "Australia"
				},
				{
					"metricValueCurrent": 3089,
					"metricValueForecast": 2083.3,
					"latlng": [
						50.503887,
						4.469936
					],
					"country": "Belgium"
				},
				{
					"metricValueCurrent": 626.4,
					"metricValueForecast": 783.3,
					"latlng": [
						26.0667,
						50.5577
					],
					"country": "Bahrain"
				},
				{
					"metricValueCurrent": 968.6,
					"metricValueForecast": 2871.9,
					"latlng": [
						53.709807,
						27.953389
					],
					"country": "Belarus"
				},
				{
					"metricValueCurrent": 28275.3,
					"metricValueForecast": 51862.2,
					"latlng": [
						-14.235004,
						-51.92528
					],
					"country": "Brazil"
				},
				{
					"metricValueCurrent": 755.6,
					"metricValueForecast": 1786.7,
					"latlng": [
						43.915886,
						17.679076
					],
					"country": "Bosnia"
				},
				{
					"metricValueCurrent": 2487,
					"metricValueForecast": 3566.6,
					"latlng": [
						42.733883,
						25.48583
					],
					"country": "Bulgaria"
				},
				{
					"metricValueCurrent": 808,
					"metricValueForecast": 2230.9,
					"latlng": [
						-16.290154,
						-63.58865299999999
					],
					"country": "Bolivia"
				},
				{
					"metricValueCurrent": 11345.1,
					"metricValueForecast": 8886.4,
					"latlng": [
						56.130366,
						-106.346771
					],
					"country": "Canada"
				},
				{
					"metricValueCurrent": 1945,
					"metricValueForecast": 1662.6,
					"latlng": [
						46.818188,
						8.227511999999999
					],
					"country": "Switzerland"
				},
				{
					"metricValueCurrent": 6200.7,
					"metricValueForecast": 8719.9,
					"latlng": [
						-35.675147,
						-71.542969
					],
					"country": "Chile"
				},
				{
					"metricValueCurrent": 369457.5,
					"metricValueForecast": 666688.8,
					"latlng": [
						35.86166,
						104.195397
					],
					"country": "China"
				},
				{
					"metricValueCurrent": 10096.2,
					"metricValueForecast": 21882.5,
					"latlng": [
						4.570868,
						-74.297333
					],
					"country": "Colombia"
				},
				{
					"metricValueCurrent": 1684.9,
					"metricValueForecast": 2124.7,
					"latlng": [
						45.1,
						15.2
					],
					"country": "Croatia"
				},
				{
					"metricValueCurrent": 5054.1,
					"metricValueForecast": 5310.9,
					"latlng": [
						49.81749199999999,
						15.472962
					],
					"country": "Czech Rep"
				},
				{
					"metricValueCurrent": 31085.1,
					"metricValueForecast": 24576.5,
					"latlng": [
						51.165691,
						10.451526
					],
					"country": "Germany"
				},
				{
					"metricValueCurrent": 1466.1,
					"metricValueForecast": 1011.1,
					"latlng": [
						56.26392,
						9.501785
					],
					"country": "Denmark"
				},
				{
					"metricValueCurrent": 3050.3,
					"metricValueForecast": 4751.5,
					"latlng": [
						18.735693,
						-70.162651
					],
					"country": "Dominican Rep"
				},
				{
					"metricValueCurrent": 2940,
					"metricValueForecast": 4219.3,
					"latlng": [
						-1.831239,
						-78.18340599999999
					],
					"country": "Ecuador"
				},
				{
					"metricValueCurrent": 3847.4,
					"metricValueForecast": 7354.8,
					"latlng": [
						26.820553,
						30.802498
					],
					"country": "Egypt"
				},
				{
					"metricValueCurrent": 22545.1,
					"metricValueForecast": 16319.4,
					"latlng": [
						40.46366700000001,
						-3.74922
					],
					"country": "Spain"
				},
				{
					"metricValueCurrent": 602.6,
					"metricValueForecast": 570.5,
					"latlng": [
						58.595272,
						25.013607
					],
					"country": "Estonia"
				},
				{
					"metricValueCurrent": 1981.3,
					"metricValueForecast": 1459.5,
					"latlng": [
						61.92410999999999,
						25.748151
					],
					"country": "Finland"
				},
				{
					"metricValueCurrent": 16257.3,
					"metricValueForecast": 8879.5,
					"latlng": [
						46.227638,
						2.213749
					],
					"country": "France"
				},
				{
					"metricValueCurrent": 16723.5,
					"metricValueForecast": 10901.5,
					"latlng": [
						55.378051,
						-3.435973
					],
					"country": "United Kingdom"
				},
				{
					"metricValueCurrent": 662,
					"metricValueForecast": 1603.6,
					"latlng": [
						42.315407,
						43.35689199999999
					],
					"country": "Georgia"
				},
				{
					"metricValueCurrent": 5454,
					"metricValueForecast": 4436.6,
					"latlng": [
						39.074208,
						21.824312
					],
					"country": "Greece"
				},
				{
					"metricValueCurrent": 2450,
					"metricValueForecast": 6099,
					"latlng": [
						15.783471,
						-90.23075899999999
					],
					"country": "Guatemala"
				},
				{
					"metricValueCurrent": 2810.6,
					"metricValueForecast": 2555.8,
					"latlng": [
						22.396428,
						114.109497
					],
					"country": "Hong Kong"
				},
				{
					"metricValueCurrent": 4413.8,
					"metricValueForecast": 4893.8,
					"latlng": [
						47.162494,
						19.503304
					],
					"country": "Hungary"
				},
				{
					"metricValueCurrent": 19459.8,
					"metricValueForecast": 51102,
					"latlng": [
						-0.789275,
						113.921327
					],
					"country": "Indonesia"
				},
				{
					"metricValueCurrent": 1507.1,
					"metricValueForecast": 956.8,
					"latlng": [
						53.41291,
						-8.24389
					],
					"country": "Ireland"
				},
				{
					"metricValueCurrent": 36314.6,
					"metricValueForecast": 117117.9,
					"latlng": [
						20.593684,
						78.96288
					],
					"country": "India"
				},
				{
					"metricValueCurrent": 5964.4,
					"metricValueForecast": 7682.2,
					"latlng": [
						32.427908,
						53.688046
					],
					"country": "Iran"
				},
				{
					"metricValueCurrent": 3079.3,
					"metricValueForecast": 3368.1,
					"latlng": [
						31.046051,
						34.851612
					],
					"country": "Israel"
				},
				{
					"metricValueCurrent": 20984.8,
					"metricValueForecast": 13505.2,
					"latlng": [
						41.87194,
						12.56738
					],
					"country": "Italy"
				},
				{
					"metricValueCurrent": 1621.2,
					"metricValueForecast": 3246.6,
					"latlng": [
						30.585164,
						36.238414
					],
					"country": "Jordan"
				},
				{
					"metricValueCurrent": 39430.3,
					"metricValueForecast": 27362.6,
					"latlng": [
						36.204824,
						138.252924
					],
					"country": "Japan"
				},
				{
					"metricValueCurrent": 1372,
					"metricValueForecast": 4857,
					"latlng": [
						48.019573,
						66.923684
					],
					"country": "Kazakhstan"
				},
				{
					"metricValueCurrent": 23458.1,
					"metricValueForecast": 16691.2,
					"latlng": [
						35.907757,
						127.766922
					],
					"country": "South Korea"
				},
				{
					"metricValueCurrent": 1779.8,
					"metricValueForecast": 1830.4,
					"latlng": [
						29.31166,
						47.481766
					],
					"country": "Kuwait"
				},
				{
					"metricValueCurrent": 954.8,
					"metricValueForecast": 3484.3,
					"latlng": [
						-0.023559,
						37.906193
					],
					"country": "Kenya"
				},
				{
					"metricValueCurrent": 882.3,
					"metricValueForecast": 968,
					"latlng": [
						56.879635,
						24.603189
					],
					"country": "Latvia"
				},
				{
					"metricValueCurrent": 1109,
					"metricValueForecast": 1280.9,
					"latlng": [
						55.169438,
						23.881275
					],
					"country": "Lithuania"
				},
				{
					"metricValueCurrent": 361,
					"metricValueForecast": 703.8,
					"latlng": [
						41.608635,
						21.745275
					],
					"country": "Macedonia"
				},
				{
					"metricValueCurrent": 3884.9,
					"metricValueForecast": 10045.7,
					"latlng": [
						31.791702,
						-7.092619999999999
					],
					"country": "Morocco"
				},
				{
					"metricValueCurrent": 23398,
					"metricValueForecast": 43186.8,
					"latlng": [
						23.634501,
						-102.552784
					],
					"country": "Mexico"
				},
				{
					"metricValueCurrent": 6236.2,
					"metricValueForecast": 17756.1,
					"latlng": [
						4.210484,
						101.975766
					],
					"country": "Malaysia"
				},
				{
					"metricValueCurrent": 1781.6,
					"metricValueForecast": 2267.9,
					"latlng": [
						9.081999,
						8.675277
					],
					"country": "Nigeria"
				},
				{
					"metricValueCurrent": 4083.6,
					"metricValueForecast": 2887.3,
					"latlng": [
						52.132633,
						5.291265999999999
					],
					"country": "Netherlands"
				},
				{
					"metricValueCurrent": 1655.4,
					"metricValueForecast": 1677.5,
					"latlng": [
						60.47202399999999,
						8.468945999999999
					],
					"country": "Norway"
				},
				{
					"metricValueCurrent": 1375.1,
					"metricValueForecast": 934.2,
					"latlng": [
						-40.900557,
						174.885971
					],
					"country": "New Zealand"
				},
				{
					"metricValueCurrent": 501,
					"metricValueForecast": 1735.2,
					"latlng": [
						7.369721999999999,
						12.354722
					],
					"country": "Cameroon"
				},
				{
					"metricValueCurrent": 9280,
					"metricValueForecast": 29071.4,
					"latlng": [
						12.879721,
						121.774017
					],
					"country": "Philippines"
				},
				{
					"metricValueCurrent": 7788.9,
					"metricValueForecast": 38654.6,
					"latlng": [
						30.375321,
						69.34511599999999
					],
					"country": "Pakistan"
				},
				{
					"metricValueCurrent": 10615.9,
					"metricValueForecast": 18129.6,
					"latlng": [
						51.919438,
						19.145136
					],
					"country": "Poland"
				},
				{
					"metricValueCurrent": 4481.5,
					"metricValueForecast": 4064.7,
					"latlng": [
						39.39987199999999,
						-8.224454
					],
					"country": "Portugal"
				},
				{
					"metricValueCurrent": 6005.1,
					"metricValueForecast": 11538.1,
					"latlng": [
						-9.189967,
						-75.015152
					],
					"country": "Peru"
				},
				{
					"metricValueCurrent": 1285.3,
					"metricValueForecast": 1551.6,
					"latlng": [
						25.354826,
						51.183884
					],
					"country": "Qatar"
				},
				{
					"metricValueCurrent": 1676.4,
					"metricValueForecast": 2558.5,
					"latlng": [
						9.748916999999999,
						-83.753428
					],
					"country": "Costa Rica"
				},
				{
					"metricValueCurrent": 4149.1,
					"metricValueForecast": 8411.5,
					"latlng": [
						45.943161,
						24.96676
					],
					"country": "Romania"
				},
				{
					"metricValueCurrent": 7582.4,
					"metricValueForecast": 19618.7,
					"latlng": [
						61.52401,
						105.318756
					],
					"country": "Russia"
				},
				{
					"metricValueCurrent": 11589,
					"metricValueForecast": 16150.3,
					"latlng": [
						23.885942,
						45.079162
					],
					"country": "Saudi Arabia"
				},
				{
					"metricValueCurrent": 3143.3,
					"metricValueForecast": 3176.5,
					"latlng": [
						60.12816100000001,
						18.643501
					],
					"country": "Sweden"
				},
				{
					"metricValueCurrent": 1995.2,
					"metricValueForecast": 1536.6,
					"latlng": [
						1.352083,
						103.819836
					],
					"country": "Singapore"
				},
				{
					"metricValueCurrent": 2670.4,
					"metricValueForecast": 3101.9,
					"latlng": [
						48.669026,
						19.699024
					],
					"country": "Slovakia"
				},
				{
					"metricValueCurrent": 1085.4,
					"metricValueForecast": 1048.6,
					"latlng": [
						46.151241,
						14.995463
					],
					"country": "Slovenia"
				},
				{
					"metricValueCurrent": 9324.9,
					"metricValueForecast": 17715.8,
					"latlng": [
						15.870032,
						100.992541
					],
					"country": "Thailand"
				},
				{
					"metricValueCurrent": 442.8,
					"metricValueForecast": 2133.3,
					"latlng": [
						38.969719,
						59.556278
					],
					"country": "Turkmenistan"
				},
				{
					"metricValueCurrent": 17739.6,
					"metricValueForecast": 33357.3,
					"latlng": [
						38.963745,
						35.243322
					],
					"country": "Turkey"
				},
				{
					"metricValueCurrent": 2659.1,
					"metricValueForecast": 4603.4,
					"latlng": [
						33.886917,
						9.537499
					],
					"country": "Tunisia"
				},
				{
					"metricValueCurrent": 10949.4,
					"metricValueForecast": 8030.1,
					"latlng": [
						23.69781,
						120.960515
					],
					"country": "Taiwan"
				},
				{
					"metricValueCurrent": 4905.2,
					"metricValueForecast": 5314,
					"latlng": [
						23.424076,
						53.847818
					],
					"country": "United Arab Emirates"
				},
				{
					"metricValueCurrent": 477.9,
					"metricValueForecast": 1465.5,
					"latlng": [
						48.379433,
						31.16558
					],
					"country": "Ukraine"
				},
				{
					"metricValueCurrent": 88930.9,
					"metricValueForecast": 81248.1,
					"latlng": [
						37.09024,
						-95.712891
					],
					"country": "USA"
				},
				{
					"metricValueCurrent": 1496.4,
					"metricValueForecast": 1732.6,
					"latlng": [
						-32.522779,
						-55.765835
					],
					"country": "Uruguay"
				},
				{
					"metricValueCurrent": 657.1,
					"metricValueForecast": 1497.6,
					"latlng": [
						41.377491,
						64.585262
					],
					"country": "Uzbekistan"
				},
				{
					"metricValueCurrent": 6283.2,
					"metricValueForecast": 20596.1,
					"latlng": [
						14.058324,
						108.277199
					],
					"country": "Vietnam"
				},
				{
					"metricValueCurrent": 9193.8,
					"metricValueForecast": 17221.5,
					"latlng": [
						-30.559482,
						22.937506
					],
					"country": "South Africa"
				},
				{
					"metricValueCurrent": 1244.4,
					"metricValueForecast": 2999,
					"latlng": [
						44.016521,
						21.005859
					],
					"country": "Serbia"
				}
			],
			"current_year": "2016"
		},
		{
			"segment": "Affluent",
			"forecast_year": "2030",
			"forecast_max": 110322.8,
			"unit": "Number of Adults, '000s",
			"current_max": 81279.2,
			"metrics": [
				{
					"metricValueCurrent": 56.8,
					"metricValueForecast": 192.7,
					"latlng": [
						40.143105,
						47.576927
					],
					"country": "Azerbaijan"
				},
				{
					"metricValueCurrent": 154,
					"metricValueForecast": 330.3,
					"latlng": [
						28.033886,
						1.659626
					],
					"country": "Algeria"
				},
				{
					"metricValueCurrent": 797.5,
					"metricValueForecast": 1170.6,
					"latlng": [
						-38.416097,
						-63.61667199999999
					],
					"country": "Argentina"
				},
				{
					"metricValueCurrent": 1702,
					"metricValueForecast": 2601.1,
					"latlng": [
						47.516231,
						14.550072
					],
					"country": "Austria"
				},
				{
					"metricValueCurrent": 11487,
					"metricValueForecast": 15566.8,
					"latlng": [
						-25.274398,
						133.775136
					],
					"country": "Australia"
				},
				{
					"metricValueCurrent": 4430.9,
					"metricValueForecast": 5560.9,
					"latlng": [
						50.503887,
						4.469936
					],
					"country": "Belgium"
				},
				{
					"metricValueCurrent": 78.8,
					"metricValueForecast": 178.1,
					"latlng": [
						26.0667,
						50.5577
					],
					"country": "Bahrain"
				},
				{
					"metricValueCurrent": 29.1,
					"metricValueForecast": 131.5,
					"latlng": [
						53.709807,
						27.953389
					],
					"country": "Belarus"
				},
				{
					"metricValueCurrent": 2132,
					"metricValueForecast": 4650.8,
					"latlng": [
						-14.235004,
						-51.92528
					],
					"country": "Brazil"
				},
				{
					"metricValueCurrent": 26.6,
					"metricValueForecast": 138.8,
					"latlng": [
						43.915886,
						17.679076
					],
					"country": "Bosnia"
				},
				{
					"metricValueCurrent": 133.8,
					"metricValueForecast": 581.8,
					"latlng": [
						42.733883,
						25.48583
					],
					"country": "Bulgaria"
				},
				{
					"metricValueCurrent": 39,
					"metricValueForecast": 153.2,
					"latlng": [
						-16.290154,
						-63.58865299999999
					],
					"country": "Bolivia"
				},
				{
					"metricValueCurrent": 11974.3,
					"metricValueForecast": 16881.1,
					"latlng": [
						56.130366,
						-106.346771
					],
					"country": "Canada"
				},
				{
					"metricValueCurrent": 3295.9,
					"metricValueForecast": 3886.8,
					"latlng": [
						46.818188,
						8.227511999999999
					],
					"country": "Switzerland"
				},
				{
					"metricValueCurrent": 898.8,
					"metricValueForecast": 2185.6,
					"latlng": [
						-35.675147,
						-71.542969
					],
					"country": "Chile"
				},
				{
					"metricValueCurrent": 26716,
					"metricValueForecast": 106601.5,
					"latlng": [
						35.86166,
						104.195397
					],
					"country": "China"
				},
				{
					"metricValueCurrent": 791,
					"metricValueForecast": 3330.5,
					"latlng": [
						4.570868,
						-74.297333
					],
					"country": "Colombia"
				},
				{
					"metricValueCurrent": 114.3,
					"metricValueForecast": 354.7,
					"latlng": [
						45.1,
						15.2
					],
					"country": "Croatia"
				},
				{
					"metricValueCurrent": 556.7,
					"metricValueForecast": 697.8,
					"latlng": [
						49.81749199999999,
						15.472962
					],
					"country": "Czech Rep"
				},
				{
					"metricValueCurrent": 22388.5,
					"metricValueForecast": 29645.2,
					"latlng": [
						51.165691,
						10.451526
					],
					"country": "Germany"
				},
				{
					"metricValueCurrent": 1577.9,
					"metricValueForecast": 2100.5,
					"latlng": [
						56.26392,
						9.501785
					],
					"country": "Denmark"
				},
				{
					"metricValueCurrent": 257,
					"metricValueForecast": 898.8,
					"latlng": [
						18.735693,
						-70.162651
					],
					"country": "Dominican Rep"
				},
				{
					"metricValueCurrent": 186,
					"metricValueForecast": 254.3,
					"latlng": [
						-1.831239,
						-78.18340599999999
					],
					"country": "Ecuador"
				},
				{
					"metricValueCurrent": 243.9,
					"metricValueForecast": 491.6,
					"latlng": [
						26.820553,
						30.802498
					],
					"country": "Egypt"
				},
				{
					"metricValueCurrent": 9139.7,
					"metricValueForecast": 17041.1,
					"latlng": [
						40.46366700000001,
						-3.74922
					],
					"country": "Spain"
				},
				{
					"metricValueCurrent": 68.9,
					"metricValueForecast": 213.4,
					"latlng": [
						58.595272,
						25.013607
					],
					"country": "Estonia"
				},
				{
					"metricValueCurrent": 1437.9,
					"metricValueForecast": 2118.6,
					"latlng": [
						61.92410999999999,
						25.748151
					],
					"country": "Finland"
				},
				{
					"metricValueCurrent": 24764.9,
					"metricValueForecast": 31559.6,
					"latlng": [
						46.227638,
						2.213749
					],
					"country": "France"
				},
				{
					"metricValueCurrent": 25645.7,
					"metricValueForecast": 32017.3,
					"latlng": [
						55.378051,
						-3.435973
					],
					"country": "United Kingdom"
				},
				{
					"metricValueCurrent": 29.6,
					"metricValueForecast": 164.9,
					"latlng": [
						42.315407,
						43.35689199999999
					],
					"country": "Georgia"
				},
				{
					"metricValueCurrent": 1440.8,
					"metricValueForecast": 2607.3,
					"latlng": [
						39.074208,
						21.824312
					],
					"country": "Greece"
				},
				{
					"metricValueCurrent": 158.9,
					"metricValueForecast": 634.9,
					"latlng": [
						15.783471,
						-90.23075899999999
					],
					"country": "Guatemala"
				},
				{
					"metricValueCurrent": 1956.4,
					"metricValueForecast": 2666.5,
					"latlng": [
						22.396428,
						114.109497
					],
					"country": "Hong Kong"
				},
				{
					"metricValueCurrent": 340.9,
					"metricValueForecast": 656.9,
					"latlng": [
						47.162494,
						19.503304
					],
					"country": "Hungary"
				},
				{
					"metricValueCurrent": 1335.9,
					"metricValueForecast": 4054.2,
					"latlng": [
						-0.789275,
						113.921327
					],
					"country": "Indonesia"
				},
				{
					"metricValueCurrent": 1281.1,
					"metricValueForecast": 2011,
					"latlng": [
						53.41291,
						-8.24389
					],
					"country": "Ireland"
				},
				{
					"metricValueCurrent": 2356.5,
					"metricValueForecast": 8830.3,
					"latlng": [
						20.593684,
						78.96288
					],
					"country": "India"
				},
				{
					"metricValueCurrent": 229,
					"metricValueForecast": 321.7,
					"latlng": [
						32.427908,
						53.688046
					],
					"country": "Iran"
				},
				{
					"metricValueCurrent": 1428.4,
					"metricValueForecast": 2510,
					"latlng": [
						31.046051,
						34.851612
					],
					"country": "Israel"
				},
				{
					"metricValueCurrent": 22604.7,
					"metricValueForecast": 31253.2,
					"latlng": [
						41.87194,
						12.56738
					],
					"country": "Italy"
				},
				{
					"metricValueCurrent": 95.4,
					"metricValueForecast": 314.8,
					"latlng": [
						30.585164,
						36.238414
					],
					"country": "Jordan"
				},
				{
					"metricValueCurrent": 56090.9,
					"metricValueForecast": 59960.6,
					"latlng": [
						36.204824,
						138.252924
					],
					"country": "Japan"
				},
				{
					"metricValueCurrent": 103.3,
					"metricValueForecast": 591.9,
					"latlng": [
						48.019573,
						66.923684
					],
					"country": "Kazakhstan"
				},
				{
					"metricValueCurrent": 12836.1,
					"metricValueForecast": 21423.4,
					"latlng": [
						35.907757,
						127.766922
					],
					"country": "South Korea"
				},
				{
					"metricValueCurrent": 682.3,
					"metricValueForecast": 1491,
					"latlng": [
						29.31166,
						47.481766
					],
					"country": "Kuwait"
				},
				{
					"metricValueCurrent": 62.6,
					"metricValueForecast": 244,
					"latlng": [
						-0.023559,
						37.906193
					],
					"country": "Kenya"
				},
				{
					"metricValueCurrent": 62.5,
					"metricValueForecast": 192.1,
					"latlng": [
						56.879635,
						24.603189
					],
					"country": "Latvia"
				},
				{
					"metricValueCurrent": 75.9,
					"metricValueForecast": 244.6,
					"latlng": [
						55.169438,
						23.881275
					],
					"country": "Lithuania"
				},
				{
					"metricValueCurrent": 14,
					"metricValueForecast": 44.2,
					"latlng": [
						41.608635,
						21.745275
					],
					"country": "Macedonia"
				},
				{
					"metricValueCurrent": 269.5,
					"metricValueForecast": 827.9,
					"latlng": [
						31.791702,
						-7.092619999999999
					],
					"country": "Morocco"
				},
				{
					"metricValueCurrent": 2257.4,
					"metricValueForecast": 6205.2,
					"latlng": [
						23.634501,
						-102.552784
					],
					"country": "Mexico"
				},
				{
					"metricValueCurrent": 435.2,
					"metricValueForecast": 1851.3,
					"latlng": [
						4.210484,
						101.975766
					],
					"country": "Malaysia"
				},
				{
					"metricValueCurrent": 102,
					"metricValueForecast": 129.7,
					"latlng": [
						9.081999,
						8.675277
					],
					"country": "Nigeria"
				},
				{
					"metricValueCurrent": 6661.2,
					"metricValueForecast": 8062.9,
					"latlng": [
						52.132633,
						5.291265999999999
					],
					"country": "Netherlands"
				},
				{
					"metricValueCurrent": 1362.7,
					"metricValueForecast": 1763.3,
					"latlng": [
						60.47202399999999,
						8.468945999999999
					],
					"country": "Norway"
				},
				{
					"metricValueCurrent": 1597.1,
					"metricValueForecast": 2381.2,
					"latlng": [
						-40.900557,
						174.885971
					],
					"country": "New Zealand"
				},
				{
					"metricValueCurrent": 25.2,
					"metricValueForecast": 94.1,
					"latlng": [
						7.369721999999999,
						12.354722
					],
					"country": "Cameroon"
				},
				{
					"metricValueCurrent": 700.8,
					"metricValueForecast": 4172.1,
					"latlng": [
						12.879721,
						121.774017
					],
					"country": "Philippines"
				},
				{
					"metricValueCurrent": 353.3,
					"metricValueForecast": 2263.9,
					"latlng": [
						30.375321,
						69.34511599999999
					],
					"country": "Pakistan"
				},
				{
					"metricValueCurrent": 629.5,
					"metricValueForecast": 1770,
					"latlng": [
						51.919438,
						19.145136
					],
					"country": "Poland"
				},
				{
					"metricValueCurrent": 1299.4,
					"metricValueForecast": 2344.7,
					"latlng": [
						39.39987199999999,
						-8.224454
					],
					"country": "Portugal"
				},
				{
					"metricValueCurrent": 650.9,
					"metricValueForecast": 2100.6,
					"latlng": [
						-9.189967,
						-75.015152
					],
					"country": "Peru"
				},
				{
					"metricValueCurrent": 675.6,
					"metricValueForecast": 1280.2,
					"latlng": [
						25.354826,
						51.183884
					],
					"country": "Qatar"
				},
				{
					"metricValueCurrent": 161.6,
					"metricValueForecast": 584.9,
					"latlng": [
						9.748916999999999,
						-83.753428
					],
					"country": "Costa Rica"
				},
				{
					"metricValueCurrent": 249.4,
					"metricValueForecast": 1165.4,
					"latlng": [
						45.943161,
						24.96676
					],
					"country": "Romania"
				},
				{
					"metricValueCurrent": 646.1,
					"metricValueForecast": 1984.9,
					"latlng": [
						61.52401,
						105.318756
					],
					"country": "Russia"
				},
				{
					"metricValueCurrent": 1777.6,
					"metricValueForecast": 4167.6,
					"latlng": [
						23.885942,
						45.079162
					],
					"country": "Saudi Arabia"
				},
				{
					"metricValueCurrent": 2183.9,
					"metricValueForecast": 3090.3,
					"latlng": [
						60.12816100000001,
						18.643501
					],
					"country": "Sweden"
				},
				{
					"metricValueCurrent": 2009.2,
					"metricValueForecast": 2813.7,
					"latlng": [
						1.352083,
						103.819836
					],
					"country": "Singapore"
				},
				{
					"metricValueCurrent": 217.6,
					"metricValueForecast": 609.1,
					"latlng": [
						48.669026,
						19.699024
					],
					"country": "Slovakia"
				},
				{
					"metricValueCurrent": 154.4,
					"metricValueForecast": 323.3,
					"latlng": [
						46.151241,
						14.995463
					],
					"country": "Slovenia"
				},
				{
					"metricValueCurrent": 882.3,
					"metricValueForecast": 2752.2,
					"latlng": [
						15.870032,
						100.992541
					],
					"country": "Thailand"
				},
				{
					"metricValueCurrent": 36.4,
					"metricValueForecast": 271.9,
					"latlng": [
						38.969719,
						59.556278
					],
					"country": "Turkmenistan"
				},
				{
					"metricValueCurrent": 1693.3,
					"metricValueForecast": 5139.7,
					"latlng": [
						38.963745,
						35.243322
					],
					"country": "Turkey"
				},
				{
					"metricValueCurrent": 182.9,
					"metricValueForecast": 485.9,
					"latlng": [
						33.886917,
						9.537499
					],
					"country": "Tunisia"
				},
				{
					"metricValueCurrent": 5701.3,
					"metricValueForecast": 9379,
					"latlng": [
						23.69781,
						120.960515
					],
					"country": "Taiwan"
				},
				{
					"metricValueCurrent": 927.8,
					"metricValueForecast": 2421.8,
					"latlng": [
						23.424076,
						53.847818
					],
					"country": "United Arab Emirates"
				},
				{
					"metricValueCurrent": 38.5,
					"metricValueForecast": 121,
					"latlng": [
						48.379433,
						31.16558
					],
					"country": "Ukraine"
				},
				{
					"metricValueCurrent": 81279.2,
					"metricValueForecast": 110322.8,
					"latlng": [
						37.09024,
						-95.712891
					],
					"country": "USA"
				},
				{
					"metricValueCurrent": 187.7,
					"metricValueForecast": 529.9,
					"latlng": [
						-32.522779,
						-55.765835
					],
					"country": "Uruguay"
				},
				{
					"metricValueCurrent": 43.9,
					"metricValueForecast": 105.9,
					"latlng": [
						41.377491,
						64.585262
					],
					"country": "Uzbekistan"
				},
				{
					"metricValueCurrent": 322.8,
					"metricValueForecast": 1318,
					"latlng": [
						14.058324,
						108.277199
					],
					"country": "Vietnam"
				},
				{
					"metricValueCurrent": 873.9,
					"metricValueForecast": 2884.8,
					"latlng": [
						-30.559482,
						22.937506
					],
					"country": "South Africa"
				},
				{
					"metricValueCurrent": 42.6,
					"metricValueForecast": 214.1,
					"latlng": [
						44.016521,
						21.005859
					],
					"country": "Serbia"
				}
			],
			"current_year": "2016"
		},
		{
			"segment": "HNWIs",
			"forecast_year": "2030",
			"forecast_max": 38209.3,
			"unit": "Number of Adults, '000s",
			"current_max": 16875.4,
			"metrics": [
				{
					"metricValueCurrent": 2.2,
					"metricValueForecast": 7.7,
					"latlng": [
						40.143105,
						47.576927
					],
					"country": "Azerbaijan"
				},
				{
					"metricValueCurrent": 6,
					"metricValueForecast": 13,
					"latlng": [
						28.033886,
						1.659626
					],
					"country": "Algeria"
				},
				{
					"metricValueCurrent": 36.5,
					"metricValueForecast": 53.8,
					"latlng": [
						-38.416097,
						-63.61667199999999
					],
					"country": "Argentina"
				},
				{
					"metricValueCurrent": 144.1,
					"metricValueForecast": 293.7,
					"latlng": [
						47.516231,
						14.550072
					],
					"country": "Austria"
				},
				{
					"metricValueCurrent": 1046.7,
					"metricValueForecast": 3298.3,
					"latlng": [
						-25.274398,
						133.775136
					],
					"country": "Australia"
				},
				{
					"metricValueCurrent": 280.9,
					"metricValueForecast": 749.3,
					"latlng": [
						50.503887,
						4.469936
					],
					"country": "Belgium"
				},
				{
					"metricValueCurrent": 3.4,
					"metricValueForecast": 8.4,
					"latlng": [
						26.0667,
						50.5577
					],
					"country": "Bahrain"
				},
				{
					"metricValueCurrent": 0.7,
					"metricValueForecast": 3.5,
					"latlng": [
						53.709807,
						27.953389
					],
					"country": "Belarus"
				},
				{
					"metricValueCurrent": 138.4,
					"metricValueForecast": 306.2,
					"latlng": [
						-14.235004,
						-51.92528
					],
					"country": "Brazil"
				},
				{
					"metricValueCurrent": 0.7,
					"metricValueForecast": 3.9,
					"latlng": [
						43.915886,
						17.679076
					],
					"country": "Bosnia"
				},
				{
					"metricValueCurrent": 3.9,
					"metricValueForecast": 19.9,
					"latlng": [
						42.733883,
						25.48583
					],
					"country": "Bulgaria"
				},
				{
					"metricValueCurrent": 1.5,
					"metricValueForecast": 6.1,
					"latlng": [
						-16.290154,
						-63.58865299999999
					],
					"country": "Bolivia"
				},
				{
					"metricValueCurrent": 1214.2,
					"metricValueForecast": 3150.7,
					"latlng": [
						56.130366,
						-106.346771
					],
					"country": "Canada"
				},
				{
					"metricValueCurrent": 637.8,
					"metricValueForecast": 1116.5,
					"latlng": [
						46.818188,
						8.227511999999999
					],
					"country": "Switzerland"
				},
				{
					"metricValueCurrent": 47.1,
					"metricValueForecast": 131.5,
					"latlng": [
						-35.675147,
						-71.542969
					],
					"country": "Chile"
				},
				{
					"metricValueCurrent": 1115.5,
					"metricValueForecast": 4910.7,
					"latlng": [
						35.86166,
						104.195397
					],
					"country": "China"
				},
				{
					"metricValueCurrent": 35.7,
					"metricValueForecast": 159.9,
					"latlng": [
						4.570868,
						-74.297333
					],
					"country": "Colombia"
				},
				{
					"metricValueCurrent": 4.1,
					"metricValueForecast": 13.9,
					"latlng": [
						45.1,
						15.2
					],
					"country": "Croatia"
				},
				{
					"metricValueCurrent": 26.2,
					"metricValueForecast": 33.5,
					"latlng": [
						49.81749199999999,
						15.472962
					],
					"country": "Czech Rep"
				},
				{
					"metricValueCurrent": 1748.7,
					"metricValueForecast": 3529.9,
					"latlng": [
						51.165691,
						10.451526
					],
					"country": "Germany"
				},
				{
					"metricValueCurrent": 184.6,
					"metricValueForecast": 485.9,
					"latlng": [
						56.26392,
						9.501785
					],
					"country": "Denmark"
				},
				{
					"metricValueCurrent": 9.7,
					"metricValueForecast": 39.1,
					"latlng": [
						18.735693,
						-70.162651
					],
					"country": "Dominican Rep"
				},
				{
					"metricValueCurrent": 7.4,
					"metricValueForecast": 9.6,
					"latlng": [
						-1.831239,
						-78.18340599999999
					],
					"country": "Ecuador"
				},
				{
					"metricValueCurrent": 15.5,
					"metricValueForecast": 31.6,
					"latlng": [
						26.820553,
						30.802498
					],
					"country": "Egypt"
				},
				{
					"metricValueCurrent": 403.2,
					"metricValueForecast": 1108.4,
					"latlng": [
						40.46366700000001,
						-3.74922
					],
					"country": "Spain"
				},
				{
					"metricValueCurrent": 2.8,
					"metricValueForecast": 10.9,
					"latlng": [
						58.595272,
						25.013607
					],
					"country": "Estonia"
				},
				{
					"metricValueCurrent": 73,
					"metricValueForecast": 177.6,
					"latlng": [
						61.92410999999999,
						25.748151
					],
					"country": "Finland"
				},
				{
					"metricValueCurrent": 1851.9,
					"metricValueForecast": 6394.1,
					"latlng": [
						46.227638,
						2.213749
					],
					"country": "France"
				},
				{
					"metricValueCurrent": 2074.7,
					"metricValueForecast": 5167.7,
					"latlng": [
						55.378051,
						-3.435973
					],
					"country": "United Kingdom"
				},
				{
					"metricValueCurrent": 1,
					"metricValueForecast": 5.6,
					"latlng": [
						42.315407,
						43.35689199999999
					],
					"country": "Georgia"
				},
				{
					"metricValueCurrent": 57,
					"metricValueForecast": 133,
					"latlng": [
						39.074208,
						21.824312
					],
					"country": "Greece"
				},
				{
					"metricValueCurrent": 6.5,
					"metricValueForecast": 27.1,
					"latlng": [
						15.783471,
						-90.23075899999999
					],
					"country": "Guatemala"
				},
				{
					"metricValueCurrent": 278.4,
					"metricValueForecast": 591.6,
					"latlng": [
						22.396428,
						114.109497
					],
					"country": "Hong Kong"
				},
				{
					"metricValueCurrent": 11.9,
					"metricValueForecast": 24.6,
					"latlng": [
						47.162494,
						19.503304
					],
					"country": "Hungary"
				},
				{
					"metricValueCurrent": 82.2,
					"metricValueForecast": 248,
					"latlng": [
						-0.789275,
						113.921327
					],
					"country": "Indonesia"
				},
				{
					"metricValueCurrent": 83.6,
					"metricValueForecast": 237.8,
					"latlng": [
						53.41291,
						-8.24389
					],
					"country": "Ireland"
				},
				{
					"metricValueCurrent": 154.9,
					"metricValueForecast": 597.6,
					"latlng": [
						20.593684,
						78.96288
					],
					"country": "India"
				},
				{
					"metricValueCurrent": 7.6,
					"metricValueForecast": 11.2,
					"latlng": [
						32.427908,
						53.688046
					],
					"country": "Iran"
				},
				{
					"metricValueCurrent": 98,
					"metricValueForecast": 210.3,
					"latlng": [
						31.046051,
						34.851612
					],
					"country": "Israel"
				},
				{
					"metricValueCurrent": 1151.2,
					"metricValueForecast": 2927.9,
					"latlng": [
						41.87194,
						12.56738
					],
					"country": "Italy"
				},
				{
					"metricValueCurrent": 3.2,
					"metricValueForecast": 11,
					"latlng": [
						30.585164,
						36.238414
					],
					"country": "Jordan"
				},
				{
					"metricValueCurrent": 3248.4,
					"metricValueForecast": 5978.2,
					"latlng": [
						36.204824,
						138.252924
					],
					"country": "Japan"
				},
				{
					"metricValueCurrent": 7.2,
					"metricValueForecast": 43.8,
					"latlng": [
						48.019573,
						66.923684
					],
					"country": "Kazakhstan"
				},
				{
					"metricValueCurrent": 696.6,
					"metricValueForecast": 1740.9,
					"latlng": [
						35.907757,
						127.766922
					],
					"country": "South Korea"
				},
				{
					"metricValueCurrent": 39.9,
					"metricValueForecast": 135,
					"latlng": [
						29.31166,
						47.481766
					],
					"country": "Kuwait"
				},
				{
					"metricValueCurrent": 4.3,
					"metricValueForecast": 16.7,
					"latlng": [
						-0.023559,
						37.906193
					],
					"country": "Kenya"
				},
				{
					"metricValueCurrent": 2.2,
					"metricValueForecast": 7.5,
					"latlng": [
						56.879635,
						24.603189
					],
					"country": "Latvia"
				},
				{
					"metricValueCurrent": 2.9,
					"metricValueForecast": 10.7,
					"latlng": [
						55.169438,
						23.881275
					],
					"country": "Lithuania"
				},
				{
					"metricValueCurrent": 0.4,
					"metricValueForecast": 1.4,
					"latlng": [
						41.608635,
						21.745275
					],
					"country": "Macedonia"
				},
				{
					"metricValueCurrent": 17.6,
					"metricValueForecast": 55.1,
					"latlng": [
						31.791702,
						-7.092619999999999
					],
					"country": "Morocco"
				},
				{
					"metricValueCurrent": 115.7,
					"metricValueForecast": 347.5,
					"latlng": [
						23.634501,
						-102.552784
					],
					"country": "Mexico"
				},
				{
					"metricValueCurrent": 27.5,
					"metricValueForecast": 117.6,
					"latlng": [
						4.210484,
						101.975766
					],
					"country": "Malaysia"
				},
				{
					"metricValueCurrent": 6.1,
					"metricValueForecast": 7.8,
					"latlng": [
						9.081999,
						8.675277
					],
					"country": "Nigeria"
				},
				{
					"metricValueCurrent": 491.7,
					"metricValueForecast": 1049.2,
					"latlng": [
						52.132633,
						5.291265999999999
					],
					"country": "Netherlands"
				},
				{
					"metricValueCurrent": 165.7,
					"metricValueForecast": 300.1,
					"latlng": [
						60.47202399999999,
						8.468945999999999
					],
					"country": "Norway"
				},
				{
					"metricValueCurrent": 161.3,
					"metricValueForecast": 547.5,
					"latlng": [
						-40.900557,
						174.885971
					],
					"country": "New Zealand"
				},
				{
					"metricValueCurrent": 1.2,
					"metricValueForecast": 4.7,
					"latlng": [
						7.369721999999999,
						12.354722
					],
					"country": "Cameroon"
				},
				{
					"metricValueCurrent": 32.9,
					"metricValueForecast": 229.7,
					"latlng": [
						12.879721,
						121.774017
					],
					"country": "Philippines"
				},
				{
					"metricValueCurrent": 15.8,
					"metricValueForecast": 104.5,
					"latlng": [
						30.375321,
						69.34511599999999
					],
					"country": "Pakistan"
				},
				{
					"metricValueCurrent": 28.3,
					"metricValueForecast": 81.5,
					"latlng": [
						51.919438,
						19.145136
					],
					"country": "Poland"
				},
				{
					"metricValueCurrent": 63.8,
					"metricValueForecast": 173.9,
					"latlng": [
						39.39987199999999,
						-8.224454
					],
					"country": "Portugal"
				},
				{
					"metricValueCurrent": 34.8,
					"metricValueForecast": 128.2,
					"latlng": [
						-9.189967,
						-75.015152
					],
					"country": "Peru"
				},
				{
					"metricValueCurrent": 38,
					"metricValueForecast": 84.3,
					"latlng": [
						25.354826,
						51.183884
					],
					"country": "Qatar"
				},
				{
					"metricValueCurrent": 6.4,
					"metricValueForecast": 27.6,
					"latlng": [
						9.748916999999999,
						-83.753428
					],
					"country": "Costa Rica"
				},
				{
					"metricValueCurrent": 11.6,
					"metricValueForecast": 58.6,
					"latlng": [
						45.943161,
						24.96676
					],
					"country": "Romania"
				},
				{
					"metricValueCurrent": 56.6,
					"metricValueForecast": 176.9,
					"latlng": [
						61.52401,
						105.318756
					],
					"country": "Russia"
				},
				{
					"metricValueCurrent": 79.3,
					"metricValueForecast": 222.9,
					"latlng": [
						23.885942,
						45.079162
					],
					"country": "Saudi Arabia"
				},
				{
					"metricValueCurrent": 282.1,
					"metricValueForecast": 618.3,
					"latlng": [
						60.12816100000001,
						18.643501
					],
					"country": "Sweden"
				},
				{
					"metricValueCurrent": 175.7,
					"metricValueForecast": 398.7,
					"latlng": [
						1.352083,
						103.819836
					],
					"country": "Singapore"
				},
				{
					"metricValueCurrent": 7.2,
					"metricValueForecast": 22,
					"latlng": [
						48.669026,
						19.699024
					],
					"country": "Slovakia"
				},
				{
					"metricValueCurrent": 5.2,
					"metricValueForecast": 12.7,
					"latlng": [
						46.151241,
						14.995463
					],
					"country": "Slovenia"
				},
				{
					"metricValueCurrent": 44.9,
					"metricValueForecast": 166.5,
					"latlng": [
						15.870032,
						100.992541
					],
					"country": "Thailand"
				},
				{
					"metricValueCurrent": 3,
					"metricValueForecast": 23.4,
					"latlng": [
						38.969719,
						59.556278
					],
					"country": "Turkmenistan"
				},
				{
					"metricValueCurrent": 111.7,
					"metricValueForecast": 355.8,
					"latlng": [
						38.963745,
						35.243322
					],
					"country": "Turkey"
				},
				{
					"metricValueCurrent": 7.9,
					"metricValueForecast": 21.9,
					"latlng": [
						33.886917,
						9.537499
					],
					"country": "Tunisia"
				},
				{
					"metricValueCurrent": 343.1,
					"metricValueForecast": 827,
					"latlng": [
						23.69781,
						120.960515
					],
					"country": "Taiwan"
				},
				{
					"metricValueCurrent": 45.8,
					"metricValueForecast": 142.8,
					"latlng": [
						23.424076,
						53.847818
					],
					"country": "United Arab Emirates"
				},
				{
					"metricValueCurrent": 3.4,
					"metricValueForecast": 10.6,
					"latlng": [
						48.379433,
						31.16558
					],
					"country": "Ukraine"
				},
				{
					"metricValueCurrent": 16875.4,
					"metricValueForecast": 38209.3,
					"latlng": [
						37.09024,
						-95.712891
					],
					"country": "USA"
				},
				{
					"metricValueCurrent": 7.2,
					"metricValueForecast": 24,
					"latlng": [
						-32.522779,
						-55.765835
					],
					"country": "Uruguay"
				},
				{
					"metricValueCurrent": 3,
					"metricValueForecast": 7.4,
					"latlng": [
						41.377491,
						64.585262
					],
					"country": "Uzbekistan"
				},
				{
					"metricValueCurrent": 16.2,
					"metricValueForecast": 67.8,
					"latlng": [
						14.058324,
						108.277199
					],
					"country": "Vietnam"
				},
				{
					"metricValueCurrent": 43.3,
					"metricValueForecast": 167.1,
					"latlng": [
						-30.559482,
						22.937506
					],
					"country": "South Africa"
				},
				{
					"metricValueCurrent": 1.1,
					"metricValueForecast": 6,
					"latlng": [
						44.016521,
						21.005859
					],
					"country": "Serbia"
				}
			],
			"current_year": "2016"
		},
		{
			"segment": "Ultra-HNWIs",
			"forecast_year": "2030",
			"forecast_max": 201.8,
			"unit": "Number of Adults, '000s",
			"current_max": 54.9,
			"metrics": [
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						40.143105,
						47.576927
					],
					"country": "Azerbaijan"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						28.033886,
						1.659626
					],
					"country": "Algeria"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.2,
					"latlng": [
						-38.416097,
						-63.61667199999999
					],
					"country": "Argentina"
				},
				{
					"metricValueCurrent": 0.4,
					"metricValueForecast": 1,
					"latlng": [
						47.516231,
						14.550072
					],
					"country": "Austria"
				},
				{
					"metricValueCurrent": 1.7,
					"metricValueForecast": 6.3,
					"latlng": [
						-25.274398,
						133.775136
					],
					"country": "Australia"
				},
				{
					"metricValueCurrent": 0.3,
					"metricValueForecast": 0.9,
					"latlng": [
						50.503887,
						4.469936
					],
					"country": "Belgium"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						26.0667,
						50.5577
					],
					"country": "Bahrain"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						53.709807,
						27.953389
					],
					"country": "Belarus"
				},
				{
					"metricValueCurrent": 1.2,
					"metricValueForecast": 2.6,
					"latlng": [
						-14.235004,
						-51.92528
					],
					"country": "Brazil"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						43.915886,
						17.679076
					],
					"country": "Bosnia"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						42.733883,
						25.48583
					],
					"country": "Bulgaria"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						-16.290154,
						-63.58865299999999
					],
					"country": "Bolivia"
				},
				{
					"metricValueCurrent": 2.7,
					"metricValueForecast": 8.5,
					"latlng": [
						56.130366,
						-106.346771
					],
					"country": "Canada"
				},
				{
					"metricValueCurrent": 2.3,
					"metricValueForecast": 4.8,
					"latlng": [
						46.818188,
						8.227511999999999
					],
					"country": "Switzerland"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.6,
					"latlng": [
						-35.675147,
						-71.542969
					],
					"country": "Chile"
				},
				{
					"metricValueCurrent": 4.4,
					"metricValueForecast": 19,
					"latlng": [
						35.86166,
						104.195397
					],
					"country": "China"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.7,
					"latlng": [
						4.570868,
						-74.297333
					],
					"country": "Colombia"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						45.1,
						15.2
					],
					"country": "Croatia"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.2,
					"latlng": [
						49.81749199999999,
						15.472962
					],
					"country": "Czech Rep"
				},
				{
					"metricValueCurrent": 4.4,
					"metricValueForecast": 9.8,
					"latlng": [
						51.165691,
						10.451526
					],
					"country": "Germany"
				},
				{
					"metricValueCurrent": 0.5,
					"metricValueForecast": 1.7,
					"latlng": [
						56.26392,
						9.501785
					],
					"country": "Denmark"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						18.735693,
						-70.162651
					],
					"country": "Dominican Rep"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						-1.831239,
						-78.18340599999999
					],
					"country": "Ecuador"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.3,
					"latlng": [
						26.820553,
						30.802498
					],
					"country": "Egypt"
				},
				{
					"metricValueCurrent": 0.9,
					"metricValueForecast": 2.6,
					"latlng": [
						40.46366700000001,
						-3.74922
					],
					"country": "Spain"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						58.595272,
						25.013607
					],
					"country": "Estonia"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						61.92410999999999,
						25.748151
					],
					"country": "Finland"
				},
				{
					"metricValueCurrent": 1.9,
					"metricValueForecast": 8.1,
					"latlng": [
						46.227638,
						2.213749
					],
					"country": "France"
				},
				{
					"metricValueCurrent": 3.6,
					"metricValueForecast": 10.3,
					"latlng": [
						55.378051,
						-3.435973
					],
					"country": "United Kingdom"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						42.315407,
						43.35689199999999
					],
					"country": "Georgia"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						39.074208,
						21.824312
					],
					"country": "Greece"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						15.783471,
						-90.23075899999999
					],
					"country": "Guatemala"
				},
				{
					"metricValueCurrent": 1.8,
					"metricValueForecast": 5,
					"latlng": [
						22.396428,
						114.109497
					],
					"country": "Hong Kong"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						47.162494,
						19.503304
					],
					"country": "Hungary"
				},
				{
					"metricValueCurrent": 0.6,
					"metricValueForecast": 1.9,
					"latlng": [
						-0.789275,
						113.921327
					],
					"country": "Indonesia"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.8,
					"latlng": [
						53.41291,
						-8.24389
					],
					"country": "Ireland"
				},
				{
					"metricValueCurrent": 1.4,
					"metricValueForecast": 5.4,
					"latlng": [
						20.593684,
						78.96288
					],
					"country": "India"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						32.427908,
						53.688046
					],
					"country": "Iran"
				},
				{
					"metricValueCurrent": 0.5,
					"metricValueForecast": 1.2,
					"latlng": [
						31.046051,
						34.851612
					],
					"country": "Israel"
				},
				{
					"metricValueCurrent": 1.6,
					"metricValueForecast": 4.4,
					"latlng": [
						41.87194,
						12.56738
					],
					"country": "Italy"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						30.585164,
						36.238414
					],
					"country": "Jordan"
				},
				{
					"metricValueCurrent": 3.3,
					"metricValueForecast": 7.3,
					"latlng": [
						36.204824,
						138.252924
					],
					"country": "Japan"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						48.019573,
						66.923684
					],
					"country": "Kazakhstan"
				},
				{
					"metricValueCurrent": 2.5,
					"metricValueForecast": 6.6,
					"latlng": [
						35.907757,
						127.766922
					],
					"country": "South Korea"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.5,
					"latlng": [
						29.31166,
						47.481766
					],
					"country": "Kuwait"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.2,
					"latlng": [
						-0.023559,
						37.906193
					],
					"country": "Kenya"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						56.879635,
						24.603189
					],
					"country": "Latvia"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						55.169438,
						23.881275
					],
					"country": "Lithuania"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						41.608635,
						21.745275
					],
					"country": "Macedonia"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.5,
					"latlng": [
						31.791702,
						-7.092619999999999
					],
					"country": "Morocco"
				},
				{
					"metricValueCurrent": 0.6,
					"metricValueForecast": 1.7,
					"latlng": [
						23.634501,
						-102.552784
					],
					"country": "Mexico"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.9,
					"latlng": [
						4.210484,
						101.975766
					],
					"country": "Malaysia"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						9.081999,
						8.675277
					],
					"country": "Nigeria"
				},
				{
					"metricValueCurrent": 0.6,
					"metricValueForecast": 1.5,
					"latlng": [
						52.132633,
						5.291265999999999
					],
					"country": "Netherlands"
				},
				{
					"metricValueCurrent": 0.3,
					"metricValueForecast": 0.8,
					"latlng": [
						60.47202399999999,
						8.468945999999999
					],
					"country": "Norway"
				},
				{
					"metricValueCurrent": 0.5,
					"metricValueForecast": 2,
					"latlng": [
						-40.900557,
						174.885971
					],
					"country": "New Zealand"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						7.369721999999999,
						12.354722
					],
					"country": "Cameroon"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 1,
					"latlng": [
						12.879721,
						121.774017
					],
					"country": "Philippines"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.5,
					"latlng": [
						30.375321,
						69.34511599999999
					],
					"country": "Pakistan"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						51.919438,
						19.145136
					],
					"country": "Poland"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						39.39987199999999,
						-8.224454
					],
					"country": "Portugal"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.6,
					"latlng": [
						-9.189967,
						-75.015152
					],
					"country": "Peru"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.3,
					"latlng": [
						25.354826,
						51.183884
					],
					"country": "Qatar"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						9.748916999999999,
						-83.753428
					],
					"country": "Costa Rica"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.3,
					"latlng": [
						45.943161,
						24.96676
					],
					"country": "Romania"
				},
				{
					"metricValueCurrent": 0.8,
					"metricValueForecast": 2.4,
					"latlng": [
						61.52401,
						105.318756
					],
					"country": "Russia"
				},
				{
					"metricValueCurrent": 0.3,
					"metricValueForecast": 0.8,
					"latlng": [
						23.885942,
						45.079162
					],
					"country": "Saudi Arabia"
				},
				{
					"metricValueCurrent": 0.4,
					"metricValueForecast": 1.4,
					"latlng": [
						60.12816100000001,
						18.643501
					],
					"country": "Sweden"
				},
				{
					"metricValueCurrent": 0.5,
					"metricValueForecast": 1.3,
					"latlng": [
						1.352083,
						103.819836
					],
					"country": "Singapore"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						48.669026,
						19.699024
					],
					"country": "Slovakia"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						46.151241,
						14.995463
					],
					"country": "Slovenia"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.7,
					"latlng": [
						15.870032,
						100.992541
					],
					"country": "Thailand"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.3,
					"latlng": [
						38.969719,
						59.556278
					],
					"country": "Turkmenistan"
				},
				{
					"metricValueCurrent": 0.9,
					"metricValueForecast": 3,
					"latlng": [
						38.963745,
						35.243322
					],
					"country": "Turkey"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						33.886917,
						9.537499
					],
					"country": "Tunisia"
				},
				{
					"metricValueCurrent": 1.5,
					"metricValueForecast": 3.7,
					"latlng": [
						23.69781,
						120.960515
					],
					"country": "Taiwan"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.7,
					"latlng": [
						23.424076,
						53.847818
					],
					"country": "United Arab Emirates"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						48.379433,
						31.16558
					],
					"country": "Ukraine"
				},
				{
					"metricValueCurrent": 54.9,
					"metricValueForecast": 201.8,
					"latlng": [
						37.09024,
						-95.712891
					],
					"country": "USA"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						-32.522779,
						-55.765835
					],
					"country": "Uruguay"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0.1,
					"latlng": [
						41.377491,
						64.585262
					],
					"country": "Uzbekistan"
				},
				{
					"metricValueCurrent": 0.1,
					"metricValueForecast": 0.4,
					"latlng": [
						14.058324,
						108.277199
					],
					"country": "Vietnam"
				},
				{
					"metricValueCurrent": 0.2,
					"metricValueForecast": 0.8,
					"latlng": [
						-30.559482,
						22.937506
					],
					"country": "South Africa"
				},
				{
					"metricValueCurrent": 0,
					"metricValueForecast": 0,
					"latlng": [
						44.016521,
						21.005859
					],
					"country": "Serbia"
				}
			],
			"current_year": "2016"
		}
	];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 Leaflet 1.0.3, a JS library for interactive maps. http://leafletjs.com
	 (c) 2010-2016 Vladimir Agafonkin, (c) 2010-2011 CloudMade
	*/
	(function (window, document, undefined) {
	var L = {
		version: "1.0.3"
	};
	
	function expose() {
		var oldL = window.L;
	
		L.noConflict = function () {
			window.L = oldL;
			return this;
		};
	
		window.L = L;
	}
	
	// define Leaflet for Node module pattern loaders, including Browserify
	if (typeof module === 'object' && typeof module.exports === 'object') {
		module.exports = L;
	
	// define Leaflet as an AMD module
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (L), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	// define Leaflet as a global L variable, saving the original L to restore later if needed
	if (typeof window !== 'undefined') {
		expose();
	}
	
	
	
	/*
	 * @namespace Util
	 *
	 * Various utility functions, used by Leaflet internally.
	 */
	
	L.Util = {
	
		// @function extend(dest: Object, src?: Object): Object
		// Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
		extend: function (dest) {
			var i, j, len, src;
	
			for (j = 1, len = arguments.length; j < len; j++) {
				src = arguments[j];
				for (i in src) {
					dest[i] = src[i];
				}
			}
			return dest;
		},
	
		// @function create(proto: Object, properties?: Object): Object
		// Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
		create: Object.create || (function () {
			function F() {}
			return function (proto) {
				F.prototype = proto;
				return new F();
			};
		})(),
	
		// @function bind(fn: Function, …): Function
		// Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
		// Has a `L.bind()` shortcut.
		bind: function (fn, obj) {
			var slice = Array.prototype.slice;
	
			if (fn.bind) {
				return fn.bind.apply(fn, slice.call(arguments, 1));
			}
	
			var args = slice.call(arguments, 2);
	
			return function () {
				return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
			};
		},
	
		// @function stamp(obj: Object): Number
		// Returns the unique ID of an object, assiging it one if it doesn't have it.
		stamp: function (obj) {
			/*eslint-disable */
			obj._leaflet_id = obj._leaflet_id || ++L.Util.lastId;
			return obj._leaflet_id;
			/*eslint-enable */
		},
	
		// @property lastId: Number
		// Last unique ID used by [`stamp()`](#util-stamp)
		lastId: 0,
	
		// @function throttle(fn: Function, time: Number, context: Object): Function
		// Returns a function which executes function `fn` with the given scope `context`
		// (so that the `this` keyword refers to `context` inside `fn`'s code). The function
		// `fn` will be called no more than one time per given amount of `time`. The arguments
		// received by the bound function will be any arguments passed when binding the
		// function, followed by any arguments passed when invoking the bound function.
		// Has an `L.bind` shortcut.
		throttle: function (fn, time, context) {
			var lock, args, wrapperFn, later;
	
			later = function () {
				// reset lock and call if queued
				lock = false;
				if (args) {
					wrapperFn.apply(context, args);
					args = false;
				}
			};
	
			wrapperFn = function () {
				if (lock) {
					// called too soon, queue to call later
					args = arguments;
	
				} else {
					// call and lock until later
					fn.apply(context, arguments);
					setTimeout(later, time);
					lock = true;
				}
			};
	
			return wrapperFn;
		},
	
		// @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
		// Returns the number `num` modulo `range` in such a way so it lies within
		// `range[0]` and `range[1]`. The returned value will be always smaller than
		// `range[1]` unless `includeMax` is set to `true`.
		wrapNum: function (x, range, includeMax) {
			var max = range[1],
			    min = range[0],
			    d = max - min;
			return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
		},
	
		// @function falseFn(): Function
		// Returns a function which always returns `false`.
		falseFn: function () { return false; },
	
		// @function formatNum(num: Number, digits?: Number): Number
		// Returns the number `num` rounded to `digits` decimals, or to 5 decimals by default.
		formatNum: function (num, digits) {
			var pow = Math.pow(10, digits || 5);
			return Math.round(num * pow) / pow;
		},
	
		// @function trim(str: String): String
		// Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
		trim: function (str) {
			return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
		},
	
		// @function splitWords(str: String): String[]
		// Trims and splits the string on whitespace and returns the array of parts.
		splitWords: function (str) {
			return L.Util.trim(str).split(/\s+/);
		},
	
		// @function setOptions(obj: Object, options: Object): Object
		// Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
		setOptions: function (obj, options) {
			if (!obj.hasOwnProperty('options')) {
				obj.options = obj.options ? L.Util.create(obj.options) : {};
			}
			for (var i in options) {
				obj.options[i] = options[i];
			}
			return obj.options;
		},
	
		// @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
		// Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
		// translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
		// be appended at the end. If `uppercase` is `true`, the parameter names will
		// be uppercased (e.g. `'?A=foo&B=bar'`)
		getParamString: function (obj, existingUrl, uppercase) {
			var params = [];
			for (var i in obj) {
				params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
			}
			return ((!existingUrl || existingUrl.indexOf('?') === -1) ? '?' : '&') + params.join('&');
		},
	
		// @function template(str: String, data: Object): String
		// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
		// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
		// `('Hello foo, bar')`. You can also specify functions instead of strings for
		// data values — they will be evaluated passing `data` as an argument.
		template: function (str, data) {
			return str.replace(L.Util.templateRe, function (str, key) {
				var value = data[key];
	
				if (value === undefined) {
					throw new Error('No value provided for variable ' + str);
	
				} else if (typeof value === 'function') {
					value = value(data);
				}
				return value;
			});
		},
	
		templateRe: /\{ *([\w_\-]+) *\}/g,
	
		// @function isArray(obj): Boolean
		// Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
		isArray: Array.isArray || function (obj) {
			return (Object.prototype.toString.call(obj) === '[object Array]');
		},
	
		// @function indexOf(array: Array, el: Object): Number
		// Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
		indexOf: function (array, el) {
			for (var i = 0; i < array.length; i++) {
				if (array[i] === el) { return i; }
			}
			return -1;
		},
	
		// @property emptyImageUrl: String
		// Data URI string containing a base64-encoded empty GIF image.
		// Used as a hack to free memory from unused images on WebKit-powered
		// mobile devices (by setting image `src` to this string).
		emptyImageUrl: 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
	};
	
	(function () {
		// inspired by http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	
		function getPrefixed(name) {
			return window['webkit' + name] || window['moz' + name] || window['ms' + name];
		}
	
		var lastTime = 0;
	
		// fallback for IE 7-8
		function timeoutDefer(fn) {
			var time = +new Date(),
			    timeToCall = Math.max(0, 16 - (time - lastTime));
	
			lastTime = time + timeToCall;
			return window.setTimeout(fn, timeToCall);
		}
	
		var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer,
		    cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') ||
		               getPrefixed('CancelRequestAnimationFrame') || function (id) { window.clearTimeout(id); };
	
	
		// @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
		// Schedules `fn` to be executed when the browser repaints. `fn` is bound to
		// `context` if given. When `immediate` is set, `fn` is called immediately if
		// the browser doesn't have native support for
		// [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
		// otherwise it's delayed. Returns a request ID that can be used to cancel the request.
		L.Util.requestAnimFrame = function (fn, context, immediate) {
			if (immediate && requestFn === timeoutDefer) {
				fn.call(context);
			} else {
				return requestFn.call(window, L.bind(fn, context));
			}
		};
	
		// @function cancelAnimFrame(id: Number): undefined
		// Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
		L.Util.cancelAnimFrame = function (id) {
			if (id) {
				cancelFn.call(window, id);
			}
		};
	})();
	
	// shortcuts for most used utility functions
	L.extend = L.Util.extend;
	L.bind = L.Util.bind;
	L.stamp = L.Util.stamp;
	L.setOptions = L.Util.setOptions;
	
	
	
	
	// @class Class
	// @aka L.Class
	
	// @section
	// @uninheritable
	
	// Thanks to John Resig and Dean Edwards for inspiration!
	
	L.Class = function () {};
	
	L.Class.extend = function (props) {
	
		// @function extend(props: Object): Function
		// [Extends the current class](#class-inheritance) given the properties to be included.
		// Returns a Javascript function that is a class constructor (to be called with `new`).
		var NewClass = function () {
	
			// call the constructor
			if (this.initialize) {
				this.initialize.apply(this, arguments);
			}
	
			// call all constructor hooks
			this.callInitHooks();
		};
	
		var parentProto = NewClass.__super__ = this.prototype;
	
		var proto = L.Util.create(parentProto);
		proto.constructor = NewClass;
	
		NewClass.prototype = proto;
	
		// inherit parent's statics
		for (var i in this) {
			if (this.hasOwnProperty(i) && i !== 'prototype') {
				NewClass[i] = this[i];
			}
		}
	
		// mix static properties into the class
		if (props.statics) {
			L.extend(NewClass, props.statics);
			delete props.statics;
		}
	
		// mix includes into the prototype
		if (props.includes) {
			L.Util.extend.apply(null, [proto].concat(props.includes));
			delete props.includes;
		}
	
		// merge options
		if (proto.options) {
			props.options = L.Util.extend(L.Util.create(proto.options), props.options);
		}
	
		// mix given properties into the prototype
		L.extend(proto, props);
	
		proto._initHooks = [];
	
		// add method for calling all hooks
		proto.callInitHooks = function () {
	
			if (this._initHooksCalled) { return; }
	
			if (parentProto.callInitHooks) {
				parentProto.callInitHooks.call(this);
			}
	
			this._initHooksCalled = true;
	
			for (var i = 0, len = proto._initHooks.length; i < len; i++) {
				proto._initHooks[i].call(this);
			}
		};
	
		return NewClass;
	};
	
	
	// @function include(properties: Object): this
	// [Includes a mixin](#class-includes) into the current class.
	L.Class.include = function (props) {
		L.extend(this.prototype, props);
		return this;
	};
	
	// @function mergeOptions(options: Object): this
	// [Merges `options`](#class-options) into the defaults of the class.
	L.Class.mergeOptions = function (options) {
		L.extend(this.prototype.options, options);
		return this;
	};
	
	// @function addInitHook(fn: Function): this
	// Adds a [constructor hook](#class-constructor-hooks) to the class.
	L.Class.addInitHook = function (fn) { // (Function) || (String, args...)
		var args = Array.prototype.slice.call(arguments, 1);
	
		var init = typeof fn === 'function' ? fn : function () {
			this[fn].apply(this, args);
		};
	
		this.prototype._initHooks = this.prototype._initHooks || [];
		this.prototype._initHooks.push(init);
		return this;
	};
	
	
	
	/*
	 * @class Evented
	 * @aka L.Evented
	 * @inherits Class
	 *
	 * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
	 *
	 * @example
	 *
	 * ```js
	 * map.on('click', function(e) {
	 * 	alert(e.latlng);
	 * } );
	 * ```
	 *
	 * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
	 *
	 * ```js
	 * function onClick(e) { ... }
	 *
	 * map.on('click', onClick);
	 * map.off('click', onClick);
	 * ```
	 */
	
	
	L.Evented = L.Class.extend({
	
		/* @method on(type: String, fn: Function, context?: Object): this
		 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
		 *
		 * @alternative
		 * @method on(eventMap: Object): this
		 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		 */
		on: function (types, fn, context) {
	
			// types can be a map of types/handlers
			if (typeof types === 'object') {
				for (var type in types) {
					// we don't process space-separated events here for performance;
					// it's a hot path since Layer uses the on(obj) syntax
					this._on(type, types[type], fn);
				}
	
			} else {
				// types can be a string of space-separated words
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		/* @method off(type: String, fn?: Function, context?: Object): this
		 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
		 *
		 * @alternative
		 * @method off(eventMap: Object): this
		 * Removes a set of type/listener pairs.
		 *
		 * @alternative
		 * @method off: this
		 * Removes all listeners to all events on the object.
		 */
		off: function (types, fn, context) {
	
			if (!types) {
				// clear all listeners if called without arguments
				delete this._events;
	
			} else if (typeof types === 'object') {
				for (var type in types) {
					this._off(type, types[type], fn);
				}
	
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// attach listener (without syntactic sugar now)
		_on: function (type, fn, context) {
			this._events = this._events || {};
	
			/* get/init listeners for type */
			var typeListeners = this._events[type];
			if (!typeListeners) {
				typeListeners = [];
				this._events[type] = typeListeners;
			}
	
			if (context === this) {
				// Less memory footprint.
				context = undefined;
			}
			var newListener = {fn: fn, ctx: context},
			    listeners = typeListeners;
	
			// check if fn already there
			for (var i = 0, len = listeners.length; i < len; i++) {
				if (listeners[i].fn === fn && listeners[i].ctx === context) {
					return;
				}
			}
	
			listeners.push(newListener);
		},
	
		_off: function (type, fn, context) {
			var listeners,
			    i,
			    len;
	
			if (!this._events) { return; }
	
			listeners = this._events[type];
	
			if (!listeners) {
				return;
			}
	
			if (!fn) {
				// Set all removed listeners to noop so they are not called if remove happens in fire
				for (i = 0, len = listeners.length; i < len; i++) {
					listeners[i].fn = L.Util.falseFn;
				}
				// clear all listeners for a type if function isn't specified
				delete this._events[type];
				return;
			}
	
			if (context === this) {
				context = undefined;
			}
	
			if (listeners) {
	
				// find fn and remove it
				for (i = 0, len = listeners.length; i < len; i++) {
					var l = listeners[i];
					if (l.ctx !== context) { continue; }
					if (l.fn === fn) {
	
						// set the removed listener to noop so that's not called if remove happens in fire
						l.fn = L.Util.falseFn;
	
						if (this._firingCount) {
							/* copy array in case events are being fired */
							this._events[type] = listeners = listeners.slice();
						}
						listeners.splice(i, 1);
	
						return;
					}
				}
			}
		},
	
		// @method fire(type: String, data?: Object, propagate?: Boolean): this
		// Fires an event of the specified type. You can optionally provide an data
		// object — the first argument of the listener function will contain its
		// properties. The event can optionally be propagated to event parents.
		fire: function (type, data, propagate) {
			if (!this.listens(type, propagate)) { return this; }
	
			var event = L.Util.extend({}, data, {type: type, target: this});
	
			if (this._events) {
				var listeners = this._events[type];
	
				if (listeners) {
					this._firingCount = (this._firingCount + 1) || 1;
					for (var i = 0, len = listeners.length; i < len; i++) {
						var l = listeners[i];
						l.fn.call(l.ctx || this, event);
					}
	
					this._firingCount--;
				}
			}
	
			if (propagate) {
				// propagate the event to parents (set with addEventParent)
				this._propagateEvent(event);
			}
	
			return this;
		},
	
		// @method listens(type: String): Boolean
		// Returns `true` if a particular event type has any listeners attached to it.
		listens: function (type, propagate) {
			var listeners = this._events && this._events[type];
			if (listeners && listeners.length) { return true; }
	
			if (propagate) {
				// also check parents for listeners if event propagates
				for (var id in this._eventParents) {
					if (this._eventParents[id].listens(type, propagate)) { return true; }
				}
			}
			return false;
		},
	
		// @method once(…): this
		// Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
		once: function (types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this.once(type, types[type], fn);
				}
				return this;
			}
	
			var handler = L.bind(function () {
				this
				    .off(types, fn, context)
				    .off(types, handler, context);
			}, this);
	
			// add a listener that's executed once and removed after that
			return this
			    .on(types, fn, context)
			    .on(types, handler, context);
		},
	
		// @method addEventParent(obj: Evented): this
		// Adds an event parent - an `Evented` that will receive propagated events
		addEventParent: function (obj) {
			this._eventParents = this._eventParents || {};
			this._eventParents[L.stamp(obj)] = obj;
			return this;
		},
	
		// @method removeEventParent(obj: Evented): this
		// Removes an event parent, so it will stop receiving propagated events
		removeEventParent: function (obj) {
			if (this._eventParents) {
				delete this._eventParents[L.stamp(obj)];
			}
			return this;
		},
	
		_propagateEvent: function (e) {
			for (var id in this._eventParents) {
				this._eventParents[id].fire(e.type, L.extend({layer: e.target}, e), true);
			}
		}
	});
	
	var proto = L.Evented.prototype;
	
	// aliases; we should ditch those eventually
	
	// @method addEventListener(…): this
	// Alias to [`on(…)`](#evented-on)
	proto.addEventListener = proto.on;
	
	// @method removeEventListener(…): this
	// Alias to [`off(…)`](#evented-off)
	
	// @method clearAllEventListeners(…): this
	// Alias to [`off()`](#evented-off)
	proto.removeEventListener = proto.clearAllEventListeners = proto.off;
	
	// @method addOneTimeEventListener(…): this
	// Alias to [`once(…)`](#evented-once)
	proto.addOneTimeEventListener = proto.once;
	
	// @method fireEvent(…): this
	// Alias to [`fire(…)`](#evented-fire)
	proto.fireEvent = proto.fire;
	
	// @method hasEventListeners(…): Boolean
	// Alias to [`listens(…)`](#evented-listens)
	proto.hasEventListeners = proto.listens;
	
	L.Mixin = {Events: proto};
	
	
	
	/*
	 * @namespace Browser
	 * @aka L.Browser
	 *
	 * A namespace with static properties for browser/feature detection used by Leaflet internally.
	 *
	 * @example
	 *
	 * ```js
	 * if (L.Browser.ielt9) {
	 *   alert('Upgrade your browser, dude!');
	 * }
	 * ```
	 */
	
	(function () {
	
		var ua = navigator.userAgent.toLowerCase(),
		    doc = document.documentElement,
	
		    ie = 'ActiveXObject' in window,
	
		    webkit    = ua.indexOf('webkit') !== -1,
		    phantomjs = ua.indexOf('phantom') !== -1,
		    android23 = ua.search('android [23]') !== -1,
		    chrome    = ua.indexOf('chrome') !== -1,
		    gecko     = ua.indexOf('gecko') !== -1  && !webkit && !window.opera && !ie,
	
		    win = navigator.platform.indexOf('Win') === 0,
	
		    mobile = typeof orientation !== 'undefined' || ua.indexOf('mobile') !== -1,
		    msPointer = !window.PointerEvent && window.MSPointerEvent,
		    pointer = window.PointerEvent || msPointer,
	
		    ie3d = ie && ('transition' in doc.style),
		    webkit3d = ('WebKitCSSMatrix' in window) && ('m11' in new window.WebKitCSSMatrix()) && !android23,
		    gecko3d = 'MozPerspective' in doc.style,
		    opera12 = 'OTransition' in doc.style;
	
	
		var touch = !window.L_NO_TOUCH && (pointer || 'ontouchstart' in window ||
				(window.DocumentTouch && document instanceof window.DocumentTouch));
	
		L.Browser = {
	
			// @property ie: Boolean
			// `true` for all Internet Explorer versions (not Edge).
			ie: ie,
	
			// @property ielt9: Boolean
			// `true` for Internet Explorer versions less than 9.
			ielt9: ie && !document.addEventListener,
	
			// @property edge: Boolean
			// `true` for the Edge web browser.
			edge: 'msLaunchUri' in navigator && !('documentMode' in document),
	
			// @property webkit: Boolean
			// `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
			webkit: webkit,
	
			// @property gecko: Boolean
			// `true` for gecko-based browsers like Firefox.
			gecko: gecko,
	
			// @property android: Boolean
			// `true` for any browser running on an Android platform.
			android: ua.indexOf('android') !== -1,
	
			// @property android23: Boolean
			// `true` for browsers running on Android 2 or Android 3.
			android23: android23,
	
			// @property chrome: Boolean
			// `true` for the Chrome browser.
			chrome: chrome,
	
			// @property safari: Boolean
			// `true` for the Safari browser.
			safari: !chrome && ua.indexOf('safari') !== -1,
	
	
			// @property win: Boolean
			// `true` when the browser is running in a Windows platform
			win: win,
	
	
			// @property ie3d: Boolean
			// `true` for all Internet Explorer versions supporting CSS transforms.
			ie3d: ie3d,
	
			// @property webkit3d: Boolean
			// `true` for webkit-based browsers supporting CSS transforms.
			webkit3d: webkit3d,
	
			// @property gecko3d: Boolean
			// `true` for gecko-based browsers supporting CSS transforms.
			gecko3d: gecko3d,
	
			// @property opera12: Boolean
			// `true` for the Opera browser supporting CSS transforms (version 12 or later).
			opera12: opera12,
	
			// @property any3d: Boolean
			// `true` for all browsers supporting CSS transforms.
			any3d: !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantomjs,
	
	
			// @property mobile: Boolean
			// `true` for all browsers running in a mobile device.
			mobile: mobile,
	
			// @property mobileWebkit: Boolean
			// `true` for all webkit-based browsers in a mobile device.
			mobileWebkit: mobile && webkit,
	
			// @property mobileWebkit3d: Boolean
			// `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
			mobileWebkit3d: mobile && webkit3d,
	
			// @property mobileOpera: Boolean
			// `true` for the Opera browser in a mobile device.
			mobileOpera: mobile && window.opera,
	
			// @property mobileGecko: Boolean
			// `true` for gecko-based browsers running in a mobile device.
			mobileGecko: mobile && gecko,
	
	
			// @property touch: Boolean
			// `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
			// This does not necessarily mean that the browser is running in a computer with
			// a touchscreen, it only means that the browser is capable of understanding
			// touch events.
			touch: !!touch,
	
			// @property msPointer: Boolean
			// `true` for browsers implementing the Microsoft touch events model (notably IE10).
			msPointer: !!msPointer,
	
			// @property pointer: Boolean
			// `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
			pointer: !!pointer,
	
	
			// @property retina: Boolean
			// `true` for browsers on a high-resolution "retina" screen.
			retina: (window.devicePixelRatio || (window.screen.deviceXDPI / window.screen.logicalXDPI)) > 1
		};
	
	}());
	
	
	
	/*
	 * @class Point
	 * @aka L.Point
	 *
	 * Represents a point with `x` and `y` coordinates in pixels.
	 *
	 * @example
	 *
	 * ```js
	 * var point = L.point(200, 300);
	 * ```
	 *
	 * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```js
	 * map.panBy([200, 300]);
	 * map.panBy(L.point(200, 300));
	 * ```
	 */
	
	L.Point = function (x, y, round) {
		// @property x: Number; The `x` coordinate of the point
		this.x = (round ? Math.round(x) : x);
		// @property y: Number; The `y` coordinate of the point
		this.y = (round ? Math.round(y) : y);
	};
	
	L.Point.prototype = {
	
		// @method clone(): Point
		// Returns a copy of the current point.
		clone: function () {
			return new L.Point(this.x, this.y);
		},
	
		// @method add(otherPoint: Point): Point
		// Returns the result of addition of the current and the given points.
		add: function (point) {
			// non-destructive, returns a new point
			return this.clone()._add(L.point(point));
		},
	
		_add: function (point) {
			// destructive, used directly for performance in situations where it's safe to modify existing point
			this.x += point.x;
			this.y += point.y;
			return this;
		},
	
		// @method subtract(otherPoint: Point): Point
		// Returns the result of subtraction of the given point from the current.
		subtract: function (point) {
			return this.clone()._subtract(L.point(point));
		},
	
		_subtract: function (point) {
			this.x -= point.x;
			this.y -= point.y;
			return this;
		},
	
		// @method divideBy(num: Number): Point
		// Returns the result of division of the current point by the given number.
		divideBy: function (num) {
			return this.clone()._divideBy(num);
		},
	
		_divideBy: function (num) {
			this.x /= num;
			this.y /= num;
			return this;
		},
	
		// @method multiplyBy(num: Number): Point
		// Returns the result of multiplication of the current point by the given number.
		multiplyBy: function (num) {
			return this.clone()._multiplyBy(num);
		},
	
		_multiplyBy: function (num) {
			this.x *= num;
			this.y *= num;
			return this;
		},
	
		// @method scaleBy(scale: Point): Point
		// Multiply each coordinate of the current point by each coordinate of
		// `scale`. In linear algebra terms, multiply the point by the
		// [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
		// defined by `scale`.
		scaleBy: function (point) {
			return new L.Point(this.x * point.x, this.y * point.y);
		},
	
		// @method unscaleBy(scale: Point): Point
		// Inverse of `scaleBy`. Divide each coordinate of the current point by
		// each coordinate of `scale`.
		unscaleBy: function (point) {
			return new L.Point(this.x / point.x, this.y / point.y);
		},
	
		// @method round(): Point
		// Returns a copy of the current point with rounded coordinates.
		round: function () {
			return this.clone()._round();
		},
	
		_round: function () {
			this.x = Math.round(this.x);
			this.y = Math.round(this.y);
			return this;
		},
	
		// @method floor(): Point
		// Returns a copy of the current point with floored coordinates (rounded down).
		floor: function () {
			return this.clone()._floor();
		},
	
		_floor: function () {
			this.x = Math.floor(this.x);
			this.y = Math.floor(this.y);
			return this;
		},
	
		// @method ceil(): Point
		// Returns a copy of the current point with ceiled coordinates (rounded up).
		ceil: function () {
			return this.clone()._ceil();
		},
	
		_ceil: function () {
			this.x = Math.ceil(this.x);
			this.y = Math.ceil(this.y);
			return this;
		},
	
		// @method distanceTo(otherPoint: Point): Number
		// Returns the cartesian distance between the current and the given points.
		distanceTo: function (point) {
			point = L.point(point);
	
			var x = point.x - this.x,
			    y = point.y - this.y;
	
			return Math.sqrt(x * x + y * y);
		},
	
		// @method equals(otherPoint: Point): Boolean
		// Returns `true` if the given point has the same coordinates.
		equals: function (point) {
			point = L.point(point);
	
			return point.x === this.x &&
			       point.y === this.y;
		},
	
		// @method contains(otherPoint: Point): Boolean
		// Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
		contains: function (point) {
			point = L.point(point);
	
			return Math.abs(point.x) <= Math.abs(this.x) &&
			       Math.abs(point.y) <= Math.abs(this.y);
		},
	
		// @method toString(): String
		// Returns a string representation of the point for debugging purposes.
		toString: function () {
			return 'Point(' +
			        L.Util.formatNum(this.x) + ', ' +
			        L.Util.formatNum(this.y) + ')';
		}
	};
	
	// @factory L.point(x: Number, y: Number, round?: Boolean)
	// Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
	
	// @alternative
	// @factory L.point(coords: Number[])
	// Expects an array of the form `[x, y]` instead.
	
	// @alternative
	// @factory L.point(coords: Object)
	// Expects a plain object of the form `{x: Number, y: Number}` instead.
	L.point = function (x, y, round) {
		if (x instanceof L.Point) {
			return x;
		}
		if (L.Util.isArray(x)) {
			return new L.Point(x[0], x[1]);
		}
		if (x === undefined || x === null) {
			return x;
		}
		if (typeof x === 'object' && 'x' in x && 'y' in x) {
			return new L.Point(x.x, x.y);
		}
		return new L.Point(x, y, round);
	};
	
	
	
	/*
	 * @class Bounds
	 * @aka L.Bounds
	 *
	 * Represents a rectangular area in pixel coordinates.
	 *
	 * @example
	 *
	 * ```js
	 * var p1 = L.point(10, 10),
	 * p2 = L.point(40, 60),
	 * bounds = L.bounds(p1, p2);
	 * ```
	 *
	 * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * otherBounds.intersects([[10, 10], [40, 60]]);
	 * ```
	 */
	
	L.Bounds = function (a, b) {
		if (!a) { return; }
	
		var points = b ? [a, b] : a;
	
		for (var i = 0, len = points.length; i < len; i++) {
			this.extend(points[i]);
		}
	};
	
	L.Bounds.prototype = {
		// @method extend(point: Point): this
		// Extends the bounds to contain the given point.
		extend: function (point) { // (Point)
			point = L.point(point);
	
			// @property min: Point
			// The top left corner of the rectangle.
			// @property max: Point
			// The bottom right corner of the rectangle.
			if (!this.min && !this.max) {
				this.min = point.clone();
				this.max = point.clone();
			} else {
				this.min.x = Math.min(point.x, this.min.x);
				this.max.x = Math.max(point.x, this.max.x);
				this.min.y = Math.min(point.y, this.min.y);
				this.max.y = Math.max(point.y, this.max.y);
			}
			return this;
		},
	
		// @method getCenter(round?: Boolean): Point
		// Returns the center point of the bounds.
		getCenter: function (round) {
			return new L.Point(
			        (this.min.x + this.max.x) / 2,
			        (this.min.y + this.max.y) / 2, round);
		},
	
		// @method getBottomLeft(): Point
		// Returns the bottom-left point of the bounds.
		getBottomLeft: function () {
			return new L.Point(this.min.x, this.max.y);
		},
	
		// @method getTopRight(): Point
		// Returns the top-right point of the bounds.
		getTopRight: function () { // -> Point
			return new L.Point(this.max.x, this.min.y);
		},
	
		// @method getSize(): Point
		// Returns the size of the given bounds
		getSize: function () {
			return this.max.subtract(this.min);
		},
	
		// @method contains(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle contains the given one.
		// @alternative
		// @method contains(point: Point): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) {
			var min, max;
	
			if (typeof obj[0] === 'number' || obj instanceof L.Point) {
				obj = L.point(obj);
			} else {
				obj = L.bounds(obj);
			}
	
			if (obj instanceof L.Bounds) {
				min = obj.min;
				max = obj.max;
			} else {
				min = max = obj;
			}
	
			return (min.x >= this.min.x) &&
			       (max.x <= this.max.x) &&
			       (min.y >= this.min.y) &&
			       (max.y <= this.max.y);
		},
	
		// @method intersects(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds
		// intersect if they have at least one point in common.
		intersects: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xIntersects = (max2.x >= min.x) && (min2.x <= max.x),
			    yIntersects = (max2.y >= min.y) && (min2.y <= max.y);
	
			return xIntersects && yIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds
		// overlap if their intersection is an area.
		overlaps: function (bounds) { // (Bounds) -> Boolean
			bounds = L.bounds(bounds);
	
			var min = this.min,
			    max = this.max,
			    min2 = bounds.min,
			    max2 = bounds.max,
			    xOverlaps = (max2.x > min.x) && (min2.x < max.x),
			    yOverlaps = (max2.y > min.y) && (min2.y < max.y);
	
			return xOverlaps && yOverlaps;
		},
	
		isValid: function () {
			return !!(this.min && this.max);
		}
	};
	
	
	// @factory L.bounds(topLeft: Point, bottomRight: Point)
	// Creates a Bounds object from two coordinates (usually top-left and bottom-right corners).
	// @alternative
	// @factory L.bounds(points: Point[])
	// Creates a Bounds object from the points it contains
	L.bounds = function (a, b) {
		if (!a || a instanceof L.Bounds) {
			return a;
		}
		return new L.Bounds(a, b);
	};
	
	
	
	/*
	 * @class Transformation
	 * @aka L.Transformation
	 *
	 * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
	 * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
	 * the reverse. Used by Leaflet in its projections code.
	 *
	 * @example
	 *
	 * ```js
	 * var transformation = new L.Transformation(2, 5, -1, 10),
	 * 	p = L.point(1, 2),
	 * 	p2 = transformation.transform(p), //  L.point(7, 8)
	 * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
	 * ```
	 */
	
	
	// factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
	// Creates a `Transformation` object with the given coefficients.
	L.Transformation = function (a, b, c, d) {
		this._a = a;
		this._b = b;
		this._c = c;
		this._d = d;
	};
	
	L.Transformation.prototype = {
		// @method transform(point: Point, scale?: Number): Point
		// Returns a transformed point, optionally multiplied by the given scale.
		// Only accepts actual `L.Point` instances, not arrays.
		transform: function (point, scale) { // (Point, Number) -> Point
			return this._transform(point.clone(), scale);
		},
	
		// destructive transform (faster)
		_transform: function (point, scale) {
			scale = scale || 1;
			point.x = scale * (this._a * point.x + this._b);
			point.y = scale * (this._c * point.y + this._d);
			return point;
		},
	
		// @method untransform(point: Point, scale?: Number): Point
		// Returns the reverse transformation of the given point, optionally divided
		// by the given scale. Only accepts actual `L.Point` instances, not arrays.
		untransform: function (point, scale) {
			scale = scale || 1;
			return new L.Point(
			        (point.x / scale - this._b) / this._a,
			        (point.y / scale - this._d) / this._c);
		}
	};
	
	
	
	/*
	 * @namespace DomUtil
	 *
	 * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
	 * tree, used by Leaflet internally.
	 *
	 * Most functions expecting or returning a `HTMLElement` also work for
	 * SVG elements. The only difference is that classes refer to CSS classes
	 * in HTML and SVG classes in SVG.
	 */
	
	L.DomUtil = {
	
		// @function get(id: String|HTMLElement): HTMLElement
		// Returns an element given its DOM id, or returns the element itself
		// if it was passed directly.
		get: function (id) {
			return typeof id === 'string' ? document.getElementById(id) : id;
		},
	
		// @function getStyle(el: HTMLElement, styleAttrib: String): String
		// Returns the value for a certain style attribute on an element,
		// including computed values or values set through CSS.
		getStyle: function (el, style) {
	
			var value = el.style[style] || (el.currentStyle && el.currentStyle[style]);
	
			if ((!value || value === 'auto') && document.defaultView) {
				var css = document.defaultView.getComputedStyle(el, null);
				value = css ? css[style] : null;
			}
	
			return value === 'auto' ? null : value;
		},
	
		// @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
		// Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
		create: function (tagName, className, container) {
	
			var el = document.createElement(tagName);
			el.className = className || '';
	
			if (container) {
				container.appendChild(el);
			}
	
			return el;
		},
	
		// @function remove(el: HTMLElement)
		// Removes `el` from its parent element
		remove: function (el) {
			var parent = el.parentNode;
			if (parent) {
				parent.removeChild(el);
			}
		},
	
		// @function empty(el: HTMLElement)
		// Removes all of `el`'s children elements from `el`
		empty: function (el) {
			while (el.firstChild) {
				el.removeChild(el.firstChild);
			}
		},
	
		// @function toFront(el: HTMLElement)
		// Makes `el` the last children of its parent, so it renders in front of the other children.
		toFront: function (el) {
			el.parentNode.appendChild(el);
		},
	
		// @function toBack(el: HTMLElement)
		// Makes `el` the first children of its parent, so it renders back from the other children.
		toBack: function (el) {
			var parent = el.parentNode;
			parent.insertBefore(el, parent.firstChild);
		},
	
		// @function hasClass(el: HTMLElement, name: String): Boolean
		// Returns `true` if the element's class attribute contains `name`.
		hasClass: function (el, name) {
			if (el.classList !== undefined) {
				return el.classList.contains(name);
			}
			var className = L.DomUtil.getClass(el);
			return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
		},
	
		// @function addClass(el: HTMLElement, name: String)
		// Adds `name` to the element's class attribute.
		addClass: function (el, name) {
			if (el.classList !== undefined) {
				var classes = L.Util.splitWords(name);
				for (var i = 0, len = classes.length; i < len; i++) {
					el.classList.add(classes[i]);
				}
			} else if (!L.DomUtil.hasClass(el, name)) {
				var className = L.DomUtil.getClass(el);
				L.DomUtil.setClass(el, (className ? className + ' ' : '') + name);
			}
		},
	
		// @function removeClass(el: HTMLElement, name: String)
		// Removes `name` from the element's class attribute.
		removeClass: function (el, name) {
			if (el.classList !== undefined) {
				el.classList.remove(name);
			} else {
				L.DomUtil.setClass(el, L.Util.trim((' ' + L.DomUtil.getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
			}
		},
	
		// @function setClass(el: HTMLElement, name: String)
		// Sets the element's class.
		setClass: function (el, name) {
			if (el.className.baseVal === undefined) {
				el.className = name;
			} else {
				// in case of SVG element
				el.className.baseVal = name;
			}
		},
	
		// @function getClass(el: HTMLElement): String
		// Returns the element's class.
		getClass: function (el) {
			return el.className.baseVal === undefined ? el.className : el.className.baseVal;
		},
	
		// @function setOpacity(el: HTMLElement, opacity: Number)
		// Set the opacity of an element (including old IE support).
		// `opacity` must be a number from `0` to `1`.
		setOpacity: function (el, value) {
	
			if ('opacity' in el.style) {
				el.style.opacity = value;
	
			} else if ('filter' in el.style) {
				L.DomUtil._setOpacityIE(el, value);
			}
		},
	
		_setOpacityIE: function (el, value) {
			var filter = false,
			    filterName = 'DXImageTransform.Microsoft.Alpha';
	
			// filters collection throws an error if we try to retrieve a filter that doesn't exist
			try {
				filter = el.filters.item(filterName);
			} catch (e) {
				// don't set opacity to 1 if we haven't already set an opacity,
				// it isn't needed and breaks transparent pngs.
				if (value === 1) { return; }
			}
	
			value = Math.round(value * 100);
	
			if (filter) {
				filter.Enabled = (value !== 100);
				filter.Opacity = value;
			} else {
				el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
			}
		},
	
		// @function testProp(props: String[]): String|false
		// Goes through the array of style names and returns the first name
		// that is a valid style name for an element. If no such name is found,
		// it returns false. Useful for vendor-prefixed styles like `transform`.
		testProp: function (props) {
	
			var style = document.documentElement.style;
	
			for (var i = 0; i < props.length; i++) {
				if (props[i] in style) {
					return props[i];
				}
			}
			return false;
		},
	
		// @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
		// Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
		// and optionally scaled by `scale`. Does not have an effect if the
		// browser doesn't support 3D CSS transforms.
		setTransform: function (el, offset, scale) {
			var pos = offset || new L.Point(0, 0);
	
			el.style[L.DomUtil.TRANSFORM] =
				(L.Browser.ie3d ?
					'translate(' + pos.x + 'px,' + pos.y + 'px)' :
					'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') +
				(scale ? ' scale(' + scale + ')' : '');
		},
	
		// @function setPosition(el: HTMLElement, position: Point)
		// Sets the position of `el` to coordinates specified by `position`,
		// using CSS translate or top/left positioning depending on the browser
		// (used by Leaflet internally to position its layers).
		setPosition: function (el, point) { // (HTMLElement, Point[, Boolean])
	
			/*eslint-disable */
			el._leaflet_pos = point;
			/*eslint-enable */
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(el, point);
			} else {
				el.style.left = point.x + 'px';
				el.style.top = point.y + 'px';
			}
		},
	
		// @function getPosition(el: HTMLElement): Point
		// Returns the coordinates of an element previously positioned with setPosition.
		getPosition: function (el) {
			// this method is only used for elements previously positioned using setPosition,
			// so it's safe to cache the position for performance
	
			return el._leaflet_pos || new L.Point(0, 0);
		}
	};
	
	
	(function () {
		// prefix style property names
	
		// @property TRANSFORM: String
		// Vendor-prefixed fransform style name (e.g. `'webkitTransform'` for WebKit).
		L.DomUtil.TRANSFORM = L.DomUtil.testProp(
				['transform', 'WebkitTransform', 'OTransform', 'MozTransform', 'msTransform']);
	
	
		// webkitTransition comes first because some browser versions that drop vendor prefix don't do
		// the same for the transitionend event, in particular the Android 4.1 stock browser
	
		// @property TRANSITION: String
		// Vendor-prefixed transform style name.
		var transition = L.DomUtil.TRANSITION = L.DomUtil.testProp(
				['webkitTransition', 'transition', 'OTransition', 'MozTransition', 'msTransition']);
	
		L.DomUtil.TRANSITION_END =
				transition === 'webkitTransition' || transition === 'OTransition' ? transition + 'End' : 'transitionend';
	
		// @function disableTextSelection()
		// Prevents the user from generating `selectstart` DOM events, usually generated
		// when the user drags the mouse through a page with text. Used internally
		// by Leaflet to override the behaviour of any click-and-drag interaction on
		// the map. Affects drag interactions on the whole document.
	
		// @function enableTextSelection()
		// Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
		if ('onselectstart' in document) {
			L.DomUtil.disableTextSelection = function () {
				L.DomEvent.on(window, 'selectstart', L.DomEvent.preventDefault);
			};
			L.DomUtil.enableTextSelection = function () {
				L.DomEvent.off(window, 'selectstart', L.DomEvent.preventDefault);
			};
	
		} else {
			var userSelectProperty = L.DomUtil.testProp(
				['userSelect', 'WebkitUserSelect', 'OUserSelect', 'MozUserSelect', 'msUserSelect']);
	
			L.DomUtil.disableTextSelection = function () {
				if (userSelectProperty) {
					var style = document.documentElement.style;
					this._userSelect = style[userSelectProperty];
					style[userSelectProperty] = 'none';
				}
			};
			L.DomUtil.enableTextSelection = function () {
				if (userSelectProperty) {
					document.documentElement.style[userSelectProperty] = this._userSelect;
					delete this._userSelect;
				}
			};
		}
	
		// @function disableImageDrag()
		// As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
		// for `dragstart` DOM events, usually generated when the user drags an image.
		L.DomUtil.disableImageDrag = function () {
			L.DomEvent.on(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function enableImageDrag()
		// Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
		L.DomUtil.enableImageDrag = function () {
			L.DomEvent.off(window, 'dragstart', L.DomEvent.preventDefault);
		};
	
		// @function preventOutline(el: HTMLElement)
		// Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
		// of the element `el` invisible. Used internally by Leaflet to prevent
		// focusable elements from displaying an outline when the user performs a
		// drag interaction on them.
		L.DomUtil.preventOutline = function (element) {
			while (element.tabIndex === -1) {
				element = element.parentNode;
			}
			if (!element || !element.style) { return; }
			L.DomUtil.restoreOutline();
			this._outlineElement = element;
			this._outlineStyle = element.style.outline;
			element.style.outline = 'none';
			L.DomEvent.on(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	
		// @function restoreOutline()
		// Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
		L.DomUtil.restoreOutline = function () {
			if (!this._outlineElement) { return; }
			this._outlineElement.style.outline = this._outlineStyle;
			delete this._outlineElement;
			delete this._outlineStyle;
			L.DomEvent.off(window, 'keydown', L.DomUtil.restoreOutline, this);
		};
	})();
	
	
	
	/* @class LatLng
	 * @aka L.LatLng
	 *
	 * Represents a geographical point with a certain latitude and longitude.
	 *
	 * @example
	 *
	 * ```
	 * var latlng = L.latLng(50.5, 30.5);
	 * ```
	 *
	 * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
	 *
	 * ```
	 * map.panTo([50, 30]);
	 * map.panTo({lon: 30, lat: 50});
	 * map.panTo({lat: 50, lng: 30});
	 * map.panTo(L.latLng(50, 30));
	 * ```
	 */
	
	L.LatLng = function (lat, lng, alt) {
		if (isNaN(lat) || isNaN(lng)) {
			throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
		}
	
		// @property lat: Number
		// Latitude in degrees
		this.lat = +lat;
	
		// @property lng: Number
		// Longitude in degrees
		this.lng = +lng;
	
		// @property alt: Number
		// Altitude in meters (optional)
		if (alt !== undefined) {
			this.alt = +alt;
		}
	};
	
	L.LatLng.prototype = {
		// @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
		// Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overriden by setting `maxMargin` to a small number.
		equals: function (obj, maxMargin) {
			if (!obj) { return false; }
	
			obj = L.latLng(obj);
	
			var margin = Math.max(
			        Math.abs(this.lat - obj.lat),
			        Math.abs(this.lng - obj.lng));
	
			return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
		},
	
		// @method toString(): String
		// Returns a string representation of the point (for debugging purposes).
		toString: function (precision) {
			return 'LatLng(' +
			        L.Util.formatNum(this.lat, precision) + ', ' +
			        L.Util.formatNum(this.lng, precision) + ')';
		},
	
		// @method distanceTo(otherLatLng: LatLng): Number
		// Returns the distance (in meters) to the given `LatLng` calculated using the [Haversine formula](http://en.wikipedia.org/wiki/Haversine_formula).
		distanceTo: function (other) {
			return L.CRS.Earth.distance(this, L.latLng(other));
		},
	
		// @method wrap(): LatLng
		// Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
		wrap: function () {
			return L.CRS.Earth.wrapLatLng(this);
		},
	
		// @method toBounds(sizeInMeters: Number): LatLngBounds
		// Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
		toBounds: function (sizeInMeters) {
			var latAccuracy = 180 * sizeInMeters / 40075017,
			    lngAccuracy = latAccuracy / Math.cos((Math.PI / 180) * this.lat);
	
			return L.latLngBounds(
			        [this.lat - latAccuracy, this.lng - lngAccuracy],
			        [this.lat + latAccuracy, this.lng + lngAccuracy]);
		},
	
		clone: function () {
			return new L.LatLng(this.lat, this.lng, this.alt);
		}
	};
	
	
	
	// @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
	// Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
	
	// @alternative
	// @factory L.latLng(coords: Array): LatLng
	// Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
	
	// @alternative
	// @factory L.latLng(coords: Object): LatLng
	// Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
	
	L.latLng = function (a, b, c) {
		if (a instanceof L.LatLng) {
			return a;
		}
		if (L.Util.isArray(a) && typeof a[0] !== 'object') {
			if (a.length === 3) {
				return new L.LatLng(a[0], a[1], a[2]);
			}
			if (a.length === 2) {
				return new L.LatLng(a[0], a[1]);
			}
			return null;
		}
		if (a === undefined || a === null) {
			return a;
		}
		if (typeof a === 'object' && 'lat' in a) {
			return new L.LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
		}
		if (b === undefined) {
			return null;
		}
		return new L.LatLng(a, b, c);
	};
	
	
	
	/*
	 * @class LatLngBounds
	 * @aka L.LatLngBounds
	 *
	 * Represents a rectangular geographical area on a map.
	 *
	 * @example
	 *
	 * ```js
	 * var corner1 = L.latLng(40.712, -74.227),
	 * corner2 = L.latLng(40.774, -74.125),
	 * bounds = L.latLngBounds(corner1, corner2);
	 * ```
	 *
	 * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
	 *
	 * ```js
	 * map.fitBounds([
	 * 	[40.712, -74.227],
	 * 	[40.774, -74.125]
	 * ]);
	 * ```
	 *
	 * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
	 */
	
	L.LatLngBounds = function (corner1, corner2) { // (LatLng, LatLng) or (LatLng[])
		if (!corner1) { return; }
	
		var latlngs = corner2 ? [corner1, corner2] : corner1;
	
		for (var i = 0, len = latlngs.length; i < len; i++) {
			this.extend(latlngs[i]);
		}
	};
	
	L.LatLngBounds.prototype = {
	
		// @method extend(latlng: LatLng): this
		// Extend the bounds to contain the given point
	
		// @alternative
		// @method extend(otherBounds: LatLngBounds): this
		// Extend the bounds to contain the given bounds
		extend: function (obj) {
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLng) {
				sw2 = obj;
				ne2 = obj;
	
			} else if (obj instanceof L.LatLngBounds) {
				sw2 = obj._southWest;
				ne2 = obj._northEast;
	
				if (!sw2 || !ne2) { return this; }
	
			} else {
				return obj ? this.extend(L.latLng(obj) || L.latLngBounds(obj)) : this;
			}
	
			if (!sw && !ne) {
				this._southWest = new L.LatLng(sw2.lat, sw2.lng);
				this._northEast = new L.LatLng(ne2.lat, ne2.lng);
			} else {
				sw.lat = Math.min(sw2.lat, sw.lat);
				sw.lng = Math.min(sw2.lng, sw.lng);
				ne.lat = Math.max(ne2.lat, ne.lat);
				ne.lng = Math.max(ne2.lng, ne.lng);
			}
	
			return this;
		},
	
		// @method pad(bufferRatio: Number): LatLngBounds
		// Returns bigger bounds created by extending the current bounds by a given percentage in each direction.
		pad: function (bufferRatio) {
			var sw = this._southWest,
			    ne = this._northEast,
			    heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio,
			    widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
	
			return new L.LatLngBounds(
			        new L.LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
			        new L.LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
		},
	
		// @method getCenter(): LatLng
		// Returns the center point of the bounds.
		getCenter: function () {
			return new L.LatLng(
			        (this._southWest.lat + this._northEast.lat) / 2,
			        (this._southWest.lng + this._northEast.lng) / 2);
		},
	
		// @method getSouthWest(): LatLng
		// Returns the south-west point of the bounds.
		getSouthWest: function () {
			return this._southWest;
		},
	
		// @method getNorthEast(): LatLng
		// Returns the north-east point of the bounds.
		getNorthEast: function () {
			return this._northEast;
		},
	
		// @method getNorthWest(): LatLng
		// Returns the north-west point of the bounds.
		getNorthWest: function () {
			return new L.LatLng(this.getNorth(), this.getWest());
		},
	
		// @method getSouthEast(): LatLng
		// Returns the south-east point of the bounds.
		getSouthEast: function () {
			return new L.LatLng(this.getSouth(), this.getEast());
		},
	
		// @method getWest(): Number
		// Returns the west longitude of the bounds
		getWest: function () {
			return this._southWest.lng;
		},
	
		// @method getSouth(): Number
		// Returns the south latitude of the bounds
		getSouth: function () {
			return this._southWest.lat;
		},
	
		// @method getEast(): Number
		// Returns the east longitude of the bounds
		getEast: function () {
			return this._northEast.lng;
		},
	
		// @method getNorth(): Number
		// Returns the north latitude of the bounds
		getNorth: function () {
			return this._northEast.lat;
		},
	
		// @method contains(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle contains the given one.
	
		// @alternative
		// @method contains (latlng: LatLng): Boolean
		// Returns `true` if the rectangle contains the given point.
		contains: function (obj) { // (LatLngBounds) or (LatLng) -> Boolean
			if (typeof obj[0] === 'number' || obj instanceof L.LatLng || 'lat' in obj) {
				obj = L.latLng(obj);
			} else {
				obj = L.latLngBounds(obj);
			}
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2, ne2;
	
			if (obj instanceof L.LatLngBounds) {
				sw2 = obj.getSouthWest();
				ne2 = obj.getNorthEast();
			} else {
				sw2 = ne2 = obj;
			}
	
			return (sw2.lat >= sw.lat) && (ne2.lat <= ne.lat) &&
			       (sw2.lng >= sw.lng) && (ne2.lng <= ne.lng);
		},
	
		// @method intersects(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
		intersects: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latIntersects = (ne2.lat >= sw.lat) && (sw2.lat <= ne.lat),
			    lngIntersects = (ne2.lng >= sw.lng) && (sw2.lng <= ne.lng);
	
			return latIntersects && lngIntersects;
		},
	
		// @method overlaps(otherBounds: Bounds): Boolean
		// Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
		overlaps: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			var sw = this._southWest,
			    ne = this._northEast,
			    sw2 = bounds.getSouthWest(),
			    ne2 = bounds.getNorthEast(),
	
			    latOverlaps = (ne2.lat > sw.lat) && (sw2.lat < ne.lat),
			    lngOverlaps = (ne2.lng > sw.lng) && (sw2.lng < ne.lng);
	
			return latOverlaps && lngOverlaps;
		},
	
		// @method toBBoxString(): String
		// Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
		toBBoxString: function () {
			return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(',');
		},
	
		// @method equals(otherBounds: LatLngBounds): Boolean
		// Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds.
		equals: function (bounds) {
			if (!bounds) { return false; }
	
			bounds = L.latLngBounds(bounds);
	
			return this._southWest.equals(bounds.getSouthWest()) &&
			       this._northEast.equals(bounds.getNorthEast());
		},
	
		// @method isValid(): Boolean
		// Returns `true` if the bounds are properly initialized.
		isValid: function () {
			return !!(this._southWest && this._northEast);
		}
	};
	
	// TODO International date line?
	
	// @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
	// Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
	
	// @alternative
	// @factory L.latLngBounds(latlngs: LatLng[])
	// Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
	L.latLngBounds = function (a, b) {
		if (a instanceof L.LatLngBounds) {
			return a;
		}
		return new L.LatLngBounds(a, b);
	};
	
	
	
	/*
	 * @namespace Projection
	 * @section
	 * Leaflet comes with a set of already defined Projections out of the box:
	 *
	 * @projection L.Projection.LonLat
	 *
	 * Equirectangular, or Plate Carree projection — the most simple projection,
	 * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
	 * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
	 * `EPSG:3395` and `Simple` CRS.
	 */
	
	L.Projection = {};
	
	L.Projection.LonLat = {
		project: function (latlng) {
			return new L.Point(latlng.lng, latlng.lat);
		},
	
		unproject: function (point) {
			return new L.LatLng(point.y, point.x);
		},
	
		bounds: L.bounds([-180, -90], [180, 90])
	};
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.SphericalMercator
	 *
	 * Spherical Mercator projection — the most common projection for online maps,
	 * used by almost all free and commercial tile providers. Assumes that Earth is
	 * a sphere. Used by the `EPSG:3857` CRS.
	 */
	
	L.Projection.SphericalMercator = {
	
		R: 6378137,
		MAX_LATITUDE: 85.0511287798,
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    max = this.MAX_LATITUDE,
			    lat = Math.max(Math.min(max, latlng.lat), -max),
			    sin = Math.sin(lat * d);
	
			return new L.Point(
					this.R * latlng.lng * d,
					this.R * Math.log((1 + sin) / (1 - sin)) / 2);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI;
	
			return new L.LatLng(
				(2 * Math.atan(Math.exp(point.y / this.R)) - (Math.PI / 2)) * d,
				point.x * d / this.R);
		},
	
		bounds: (function () {
			var d = 6378137 * Math.PI;
			return L.bounds([-d, -d], [d, d]);
		})()
	};
	
	
	
	/*
	 * @class CRS
	 * @aka L.CRS
	 * Abstract class that defines coordinate reference systems for projecting
	 * geographical points into pixel (screen) coordinates and back (and to
	 * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
	 * [spatial reference system](http://en.wikipedia.org/wiki/Coordinate_reference_system).
	 *
	 * Leaflet defines the most usual CRSs by default. If you want to use a
	 * CRS not defined by default, take a look at the
	 * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
	 */
	
	L.CRS = {
		// @method latLngToPoint(latlng: LatLng, zoom: Number): Point
		// Projects geographical coordinates into pixel coordinates for a given zoom.
		latLngToPoint: function (latlng, zoom) {
			var projectedPoint = this.projection.project(latlng),
			    scale = this.scale(zoom);
	
			return this.transformation._transform(projectedPoint, scale);
		},
	
		// @method pointToLatLng(point: Point, zoom: Number): LatLng
		// The inverse of `latLngToPoint`. Projects pixel coordinates on a given
		// zoom into geographical coordinates.
		pointToLatLng: function (point, zoom) {
			var scale = this.scale(zoom),
			    untransformedPoint = this.transformation.untransform(point, scale);
	
			return this.projection.unproject(untransformedPoint);
		},
	
		// @method project(latlng: LatLng): Point
		// Projects geographical coordinates into coordinates in units accepted for
		// this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
		project: function (latlng) {
			return this.projection.project(latlng);
		},
	
		// @method unproject(point: Point): LatLng
		// Given a projected coordinate returns the corresponding LatLng.
		// The inverse of `project`.
		unproject: function (point) {
			return this.projection.unproject(point);
		},
	
		// @method scale(zoom: Number): Number
		// Returns the scale used when transforming projected coordinates into
		// pixel coordinates for a particular zoom. For example, it returns
		// `256 * 2^zoom` for Mercator-based CRS.
		scale: function (zoom) {
			return 256 * Math.pow(2, zoom);
		},
	
		// @method zoom(scale: Number): Number
		// Inverse of `scale()`, returns the zoom level corresponding to a scale
		// factor of `scale`.
		zoom: function (scale) {
			return Math.log(scale / 256) / Math.LN2;
		},
	
		// @method getProjectedBounds(zoom: Number): Bounds
		// Returns the projection's bounds scaled and transformed for the provided `zoom`.
		getProjectedBounds: function (zoom) {
			if (this.infinite) { return null; }
	
			var b = this.projection.bounds,
			    s = this.scale(zoom),
			    min = this.transformation.transform(b.min, s),
			    max = this.transformation.transform(b.max, s);
	
			return L.bounds(min, max);
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates.
	
		// @property code: String
		// Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
		//
		// @property wrapLng: Number[]
		// An array of two numbers defining whether the longitude (horizontal) coordinate
		// axis wraps around a given range and how. Defaults to `[-180, 180]` in most
		// geographical CRSs. If `undefined`, the longitude axis does not wrap around.
		//
		// @property wrapLat: Number[]
		// Like `wrapLng`, but for the latitude (vertical) axis.
	
		// wrapLng: [min, max],
		// wrapLat: [min, max],
	
		// @property infinite: Boolean
		// If true, the coordinate space will be unbounded (infinite in both axes)
		infinite: false,
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where lat and lng has been wrapped according to the
		// CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
		// Only accepts actual `L.LatLng` instances, not arrays.
		wrapLatLng: function (latlng) {
			var lng = this.wrapLng ? L.Util.wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng,
			    lat = this.wrapLat ? L.Util.wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat,
			    alt = latlng.alt;
	
			return L.latLng(lat, lng, alt);
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring
		// that its center is within the CRS's bounds.
		// Only accepts actual `L.LatLngBounds` instances, not arrays.
		wrapLatLngBounds: function (bounds) {
			var center = bounds.getCenter(),
			    newCenter = this.wrapLatLng(center),
			    latShift = center.lat - newCenter.lat,
			    lngShift = center.lng - newCenter.lng;
	
			if (latShift === 0 && lngShift === 0) {
				return bounds;
			}
	
			var sw = bounds.getSouthWest(),
			    ne = bounds.getNorthEast(),
			    newSw = L.latLng({lat: sw.lat - latShift, lng: sw.lng - lngShift}),
			    newNe = L.latLng({lat: ne.lat - latShift, lng: ne.lng - lngShift});
	
			return new L.LatLngBounds(newSw, newNe);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Simple
	 *
	 * A simple CRS that maps longitude and latitude into `x` and `y` directly.
	 * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
	 * axis should still be inverted (going from bottom to top). `distance()` returns
	 * simple euclidean distance.
	 */
	
	L.CRS.Simple = L.extend({}, L.CRS, {
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1, 0, -1, 0),
	
		scale: function (zoom) {
			return Math.pow(2, zoom);
		},
	
		zoom: function (scale) {
			return Math.log(scale) / Math.LN2;
		},
	
		distance: function (latlng1, latlng2) {
			var dx = latlng2.lng - latlng1.lng,
			    dy = latlng2.lat - latlng1.lat;
	
			return Math.sqrt(dx * dx + dy * dy);
		},
	
		infinite: true
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.Earth
	 *
	 * Serves as the base for CRS that are global such that they cover the earth.
	 * Can only be used as the base for other CRS and cannot be used directly,
	 * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
	 * meters.
	 */
	
	L.CRS.Earth = L.extend({}, L.CRS, {
		wrapLng: [-180, 180],
	
		// Mean Earth Radius, as recommended for use by
		// the International Union of Geodesy and Geophysics,
		// see http://rosettacode.org/wiki/Haversine_formula
		R: 6371000,
	
		// distance between two geographical points using spherical law of cosines approximation
		distance: function (latlng1, latlng2) {
			var rad = Math.PI / 180,
			    lat1 = latlng1.lat * rad,
			    lat2 = latlng2.lat * rad,
			    a = Math.sin(lat1) * Math.sin(lat2) +
			        Math.cos(lat1) * Math.cos(lat2) * Math.cos((latlng2.lng - latlng1.lng) * rad);
	
			return this.R * Math.acos(Math.min(a, 1));
		}
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3857
	 *
	 * The most common CRS for online maps, used by almost all free and commercial
	 * tile providers. Uses Spherical Mercator projection. Set in by default in
	 * Map's `crs` option.
	 */
	
	L.CRS.EPSG3857 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3857',
		projection: L.Projection.SphericalMercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.SphericalMercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	L.CRS.EPSG900913 = L.extend({}, L.CRS.EPSG3857, {
		code: 'EPSG:900913'
	});
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG4326
	 *
	 * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
	 *
	 * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
	 * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
	 * with this CRS, ensure that there are two 256x256 pixel tiles covering the
	 * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
	 * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
	 */
	
	L.CRS.EPSG4326 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:4326',
		projection: L.Projection.LonLat,
		transformation: new L.Transformation(1 / 180, 1, -1 / 180, 0.5)
	});
	
	
	
	/*
	 * @class Map
	 * @aka L.Map
	 * @inherits Evented
	 *
	 * The central class of the API — it is used to create a map on a page and manipulate it.
	 *
	 * @example
	 *
	 * ```js
	 * // initialize the map on the "map" div with a given center and zoom
	 * var map = L.map('map', {
	 * 	center: [51.505, -0.09],
	 * 	zoom: 13
	 * });
	 * ```
	 *
	 */
	
	L.Map = L.Evented.extend({
	
		options: {
			// @section Map State Options
			// @option crs: CRS = L.CRS.EPSG3857
			// The [Coordinate Reference System](#crs) to use. Don't change this if you're not
			// sure what it means.
			crs: L.CRS.EPSG3857,
	
			// @option center: LatLng = undefined
			// Initial geographic center of the map
			center: undefined,
	
			// @option zoom: Number = undefined
			// Initial map zoom level
			zoom: undefined,
	
			// @option minZoom: Number = undefined
			// Minimum zoom level of the map. Overrides any `minZoom` option set on map layers.
			minZoom: undefined,
	
			// @option maxZoom: Number = undefined
			// Maximum zoom level of the map. Overrides any `maxZoom` option set on map layers.
			maxZoom: undefined,
	
			// @option layers: Layer[] = []
			// Array of layers that will be added to the map initially
			layers: [],
	
			// @option maxBounds: LatLngBounds = null
			// When this option is set, the map restricts the view to the given
			// geographical bounds, bouncing the user back if the user tries to pan
			// outside the view. To set the restriction dynamically, use
			// [`setMaxBounds`](#map-setmaxbounds) method.
			maxBounds: undefined,
	
			// @option renderer: Renderer = *
			// The default method for drawing vector layers on the map. `L.SVG`
			// or `L.Canvas` by default depending on browser support.
			renderer: undefined,
	
	
			// @section Animation Options
			// @option zoomAnimation: Boolean = true
			// Whether the map zoom animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			zoomAnimation: true,
	
			// @option zoomAnimationThreshold: Number = 4
			// Won't animate zoom if the zoom difference exceeds this value.
			zoomAnimationThreshold: 4,
	
			// @option fadeAnimation: Boolean = true
			// Whether the tile fade animation is enabled. By default it's enabled
			// in all browsers that support CSS3 Transitions except Android.
			fadeAnimation: true,
	
			// @option markerZoomAnimation: Boolean = true
			// Whether markers animate their zoom with the zoom animation, if disabled
			// they will disappear for the length of the animation. By default it's
			// enabled in all browsers that support CSS3 Transitions except Android.
			markerZoomAnimation: true,
	
			// @option transform3DLimit: Number = 2^23
			// Defines the maximum size of a CSS translation transform. The default
			// value should not be changed unless a web browser positions layers in
			// the wrong place after doing a large `panBy`.
			transform3DLimit: 8388608, // Precision limit of a 32-bit float
	
			// @section Interaction Options
			// @option zoomSnap: Number = 1
			// Forces the map's zoom level to always be a multiple of this, particularly
			// right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
			// By default, the zoom level snaps to the nearest integer; lower values
			// (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
			// means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
			zoomSnap: 1,
	
			// @option zoomDelta: Number = 1
			// Controls how much the map's zoom level will change after a
			// [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
			// or `-` on the keyboard, or using the [zoom controls](#control-zoom).
			// Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
			zoomDelta: 1,
	
			// @option trackResize: Boolean = true
			// Whether the map automatically handles browser window resize to update itself.
			trackResize: true
		},
	
		initialize: function (id, options) { // (HTMLElement or String, Object)
			options = L.setOptions(this, options);
	
			this._initContainer(id);
			this._initLayout();
	
			// hack for https://github.com/Leaflet/Leaflet/issues/1980
			this._onResize = L.bind(this._onResize, this);
	
			this._initEvents();
	
			if (options.maxBounds) {
				this.setMaxBounds(options.maxBounds);
			}
	
			if (options.zoom !== undefined) {
				this._zoom = this._limitZoom(options.zoom);
			}
	
			if (options.center && options.zoom !== undefined) {
				this.setView(L.latLng(options.center), options.zoom, {reset: true});
			}
	
			this._handlers = [];
			this._layers = {};
			this._zoomBoundLayers = {};
			this._sizeChanged = true;
	
			this.callInitHooks();
	
			// don't animate on browsers without hardware-accelerated transitions or old Android/Opera
			this._zoomAnimated = L.DomUtil.TRANSITION && L.Browser.any3d && !L.Browser.mobileOpera &&
					this.options.zoomAnimation;
	
			// zoom transitions run with the same duration for all layers, so if one of transitionend events
			// happens after starting zoom animation (propagating to the map pane), we know that it ended globally
			if (this._zoomAnimated) {
				this._createAnimProxy();
				L.DomEvent.on(this._proxy, L.DomUtil.TRANSITION_END, this._catchTransitionEnd, this);
			}
	
			this._addLayers(this.options.layers);
		},
	
	
		// @section Methods for modifying map state
	
		// @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) with the given
		// animation options.
		setView: function (center, zoom, options) {
	
			zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
			center = this._limitCenter(L.latLng(center), zoom, this.options.maxBounds);
			options = options || {};
	
			this._stop();
	
			if (this._loaded && !options.reset && options !== true) {
	
				if (options.animate !== undefined) {
					options.zoom = L.extend({animate: options.animate}, options.zoom);
					options.pan = L.extend({animate: options.animate, duration: options.duration}, options.pan);
				}
	
				// try animating pan or zoom
				var moved = (this._zoom !== zoom) ?
					this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) :
					this._tryAnimatedPan(center, options.pan);
	
				if (moved) {
					// prevent resize handler call, the view will refresh after animation anyway
					clearTimeout(this._sizeTimer);
					return this;
				}
			}
	
			// animation didn't start, just reset the map view
			this._resetView(center, zoom);
	
			return this;
		},
	
		// @method setZoom(zoom: Number, options: Zoom/pan options): this
		// Sets the zoom of the map.
		setZoom: function (zoom, options) {
			if (!this._loaded) {
				this._zoom = zoom;
				return this;
			}
			return this.setView(this.getCenter(), zoom, {zoom: options});
		},
	
		// @method zoomIn(delta?: Number, options?: Zoom options): this
		// Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomIn: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom + delta, options);
		},
	
		// @method zoomOut(delta?: Number, options?: Zoom options): this
		// Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
		zoomOut: function (delta, options) {
			delta = delta || (L.Browser.any3d ? this.options.zoomDelta : 1);
			return this.setZoom(this._zoom - delta, options);
		},
	
		// @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified geographical point on the map
		// stationary (e.g. used internally for scroll zoom and double-click zoom).
		// @alternative
		// @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
		// Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
		setZoomAround: function (latlng, zoom, options) {
			var scale = this.getZoomScale(zoom),
			    viewHalf = this.getSize().divideBy(2),
			    containerPoint = latlng instanceof L.Point ? latlng : this.latLngToContainerPoint(latlng),
	
			    centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale),
			    newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
	
			return this.setView(newCenter, zoom, {zoom: options});
		},
	
		_getBoundsCenterZoom: function (bounds, options) {
	
			options = options || {};
			bounds = bounds.getBounds ? bounds.getBounds() : L.latLngBounds(bounds);
	
			var paddingTL = L.point(options.paddingTopLeft || options.padding || [0, 0]),
			    paddingBR = L.point(options.paddingBottomRight || options.padding || [0, 0]),
	
			    zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
	
			zoom = (typeof options.maxZoom === 'number') ? Math.min(options.maxZoom, zoom) : zoom;
	
			var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2),
	
			    swPoint = this.project(bounds.getSouthWest(), zoom),
			    nePoint = this.project(bounds.getNorthEast(), zoom),
			    center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
	
			return {
				center: center,
				zoom: zoom
			};
		},
	
		// @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets a map view that contains the given geographical bounds with the
		// maximum zoom level possible.
		fitBounds: function (bounds, options) {
	
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				throw new Error('Bounds are not valid.');
			}
	
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.setView(target.center, target.zoom, options);
		},
	
		// @method fitWorld(options?: fitBounds options): this
		// Sets a map view that mostly contains the whole world with the maximum
		// zoom level possible.
		fitWorld: function (options) {
			return this.fitBounds([[-90, -180], [90, 180]], options);
		},
	
		// @method panTo(latlng: LatLng, options?: Pan options): this
		// Pans the map to a given center.
		panTo: function (center, options) { // (LatLng)
			return this.setView(center, this._zoom, {pan: options});
		},
	
		// @method panBy(offset: Point): this
		// Pans the map by a given number of pixels (animated).
		panBy: function (offset, options) {
			offset = L.point(offset).round();
			options = options || {};
	
			if (!offset.x && !offset.y) {
				return this.fire('moveend');
			}
			// If we pan too far, Chrome gets issues with tiles
			// and makes them disappear or appear in the wrong place (slightly offset) #2602
			if (options.animate !== true && !this.getSize().contains(offset)) {
				this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
				return this;
			}
	
			if (!this._panAnim) {
				this._panAnim = new L.PosAnimation();
	
				this._panAnim.on({
					'step': this._onPanTransitionStep,
					'end': this._onPanTransitionEnd
				}, this);
			}
	
			// don't fire movestart if animating inertia
			if (!options.noMoveStart) {
				this.fire('movestart');
			}
	
			// animate pan unless animate: false specified
			if (options.animate !== false) {
				L.DomUtil.addClass(this._mapPane, 'leaflet-pan-anim');
	
				var newPos = this._getMapPanePos().subtract(offset).round();
				this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
			} else {
				this._rawPanBy(offset);
				this.fire('move').fire('moveend');
			}
	
			return this;
		},
	
		// @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
		// Sets the view of the map (geographical center and zoom) performing a smooth
		// pan-zoom animation.
		flyTo: function (targetCenter, targetZoom, options) {
	
			options = options || {};
			if (options.animate === false || !L.Browser.any3d) {
				return this.setView(targetCenter, targetZoom, options);
			}
	
			this._stop();
	
			var from = this.project(this.getCenter()),
			    to = this.project(targetCenter),
			    size = this.getSize(),
			    startZoom = this._zoom;
	
			targetCenter = L.latLng(targetCenter);
			targetZoom = targetZoom === undefined ? startZoom : targetZoom;
	
			var w0 = Math.max(size.x, size.y),
			    w1 = w0 * this.getZoomScale(startZoom, targetZoom),
			    u1 = (to.distanceTo(from)) || 1,
			    rho = 1.42,
			    rho2 = rho * rho;
	
			function r(i) {
				var s1 = i ? -1 : 1,
				    s2 = i ? w1 : w0,
				    t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1,
				    b1 = 2 * s2 * rho2 * u1,
				    b = t1 / b1,
				    sq = Math.sqrt(b * b + 1) - b;
	
				    // workaround for floating point precision bug when sq = 0, log = -Infinite,
				    // thus triggering an infinite loop in flyTo
				    var log = sq < 0.000000001 ? -18 : Math.log(sq);
	
				return log;
			}
	
			function sinh(n) { return (Math.exp(n) - Math.exp(-n)) / 2; }
			function cosh(n) { return (Math.exp(n) + Math.exp(-n)) / 2; }
			function tanh(n) { return sinh(n) / cosh(n); }
	
			var r0 = r(0);
	
			function w(s) { return w0 * (cosh(r0) / cosh(r0 + rho * s)); }
			function u(s) { return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2; }
	
			function easeOut(t) { return 1 - Math.pow(1 - t, 1.5); }
	
			var start = Date.now(),
			    S = (r(1) - r0) / rho,
			    duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
	
			function frame() {
				var t = (Date.now() - start) / duration,
				    s = easeOut(t) * S;
	
				if (t <= 1) {
					this._flyToFrame = L.Util.requestAnimFrame(frame, this);
	
					this._move(
						this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
						this.getScaleZoom(w0 / w(s), startZoom),
						{flyTo: true});
	
				} else {
					this
						._move(targetCenter, targetZoom)
						._moveEnd(true);
				}
			}
	
			this._moveStart(true);
	
			frame.call(this);
			return this;
		},
	
		// @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
		// Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
		// but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
		flyToBounds: function (bounds, options) {
			var target = this._getBoundsCenterZoom(bounds, options);
			return this.flyTo(target.center, target.zoom, options);
		},
	
		// @method setMaxBounds(bounds: Bounds): this
		// Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
		setMaxBounds: function (bounds) {
			bounds = L.latLngBounds(bounds);
	
			if (!bounds.isValid()) {
				this.options.maxBounds = null;
				return this.off('moveend', this._panInsideMaxBounds);
			} else if (this.options.maxBounds) {
				this.off('moveend', this._panInsideMaxBounds);
			}
	
			this.options.maxBounds = bounds;
	
			if (this._loaded) {
				this._panInsideMaxBounds();
			}
	
			return this.on('moveend', this._panInsideMaxBounds);
		},
	
		// @method setMinZoom(zoom: Number): this
		// Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
		setMinZoom: function (zoom) {
			this.options.minZoom = zoom;
	
			if (this._loaded && this.getZoom() < this.options.minZoom) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method setMaxZoom(zoom: Number): this
		// Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
		setMaxZoom: function (zoom) {
			this.options.maxZoom = zoom;
	
			if (this._loaded && (this.getZoom() > this.options.maxZoom)) {
				return this.setZoom(zoom);
			}
	
			return this;
		},
	
		// @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
		// Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
		panInsideBounds: function (bounds, options) {
			this._enforcingBounds = true;
			var center = this.getCenter(),
			    newCenter = this._limitCenter(center, this._zoom, L.latLngBounds(bounds));
	
			if (!center.equals(newCenter)) {
				this.panTo(newCenter, options);
			}
	
			this._enforcingBounds = false;
			return this;
		},
	
		// @method invalidateSize(options: Zoom/Pan options): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default. If `options.pan` is `false`, panning will not occur.
		// If `options.debounceMoveend` is `true`, it will delay `moveend` event so
		// that it doesn't happen often even if the method is called many
		// times in a row.
	
		// @alternative
		// @method invalidateSize(animate: Boolean): this
		// Checks if the map container size changed and updates the map if so —
		// call it after you've changed the map size dynamically, also animating
		// pan by default.
		invalidateSize: function (options) {
			if (!this._loaded) { return this; }
	
			options = L.extend({
				animate: false,
				pan: true
			}, options === true ? {animate: true} : options);
	
			var oldSize = this.getSize();
			this._sizeChanged = true;
			this._lastCenter = null;
	
			var newSize = this.getSize(),
			    oldCenter = oldSize.divideBy(2).round(),
			    newCenter = newSize.divideBy(2).round(),
			    offset = oldCenter.subtract(newCenter);
	
			if (!offset.x && !offset.y) { return this; }
	
			if (options.animate && options.pan) {
				this.panBy(offset);
	
			} else {
				if (options.pan) {
					this._rawPanBy(offset);
				}
	
				this.fire('move');
	
				if (options.debounceMoveend) {
					clearTimeout(this._sizeTimer);
					this._sizeTimer = setTimeout(L.bind(this.fire, this, 'moveend'), 200);
				} else {
					this.fire('moveend');
				}
			}
	
			// @section Map state change events
			// @event resize: ResizeEvent
			// Fired when the map is resized.
			return this.fire('resize', {
				oldSize: oldSize,
				newSize: newSize
			});
		},
	
		// @section Methods for modifying map state
		// @method stop(): this
		// Stops the currently running `panTo` or `flyTo` animation, if any.
		stop: function () {
			this.setZoom(this._limitZoom(this._zoom));
			if (!this.options.zoomSnap) {
				this.fire('viewreset');
			}
			return this._stop();
		},
	
		// @section Geolocation methods
		// @method locate(options?: Locate options): this
		// Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
		// event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
		// and optionally sets the map view to the user's location with respect to
		// detection accuracy (or to the world view if geolocation failed).
		// Note that, if your page doesn't use HTTPS, this method will fail in
		// modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
		// See `Locate options` for more details.
		locate: function (options) {
	
			options = this._locateOptions = L.extend({
				timeout: 10000,
				watch: false
				// setView: false
				// maxZoom: <Number>
				// maximumAge: 0
				// enableHighAccuracy: false
			}, options);
	
			if (!('geolocation' in navigator)) {
				this._handleGeolocationError({
					code: 0,
					message: 'Geolocation not supported.'
				});
				return this;
			}
	
			var onResponse = L.bind(this._handleGeolocationResponse, this),
			    onError = L.bind(this._handleGeolocationError, this);
	
			if (options.watch) {
				this._locationWatchId =
				        navigator.geolocation.watchPosition(onResponse, onError, options);
			} else {
				navigator.geolocation.getCurrentPosition(onResponse, onError, options);
			}
			return this;
		},
	
		// @method stopLocate(): this
		// Stops watching location previously initiated by `map.locate({watch: true})`
		// and aborts resetting the map view if map.locate was called with
		// `{setView: true}`.
		stopLocate: function () {
			if (navigator.geolocation && navigator.geolocation.clearWatch) {
				navigator.geolocation.clearWatch(this._locationWatchId);
			}
			if (this._locateOptions) {
				this._locateOptions.setView = false;
			}
			return this;
		},
	
		_handleGeolocationError: function (error) {
			var c = error.code,
			    message = error.message ||
			            (c === 1 ? 'permission denied' :
			            (c === 2 ? 'position unavailable' : 'timeout'));
	
			if (this._locateOptions.setView && !this._loaded) {
				this.fitWorld();
			}
	
			// @section Location events
			// @event locationerror: ErrorEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method) failed.
			this.fire('locationerror', {
				code: c,
				message: 'Geolocation error: ' + message + '.'
			});
		},
	
		_handleGeolocationResponse: function (pos) {
			var lat = pos.coords.latitude,
			    lng = pos.coords.longitude,
			    latlng = new L.LatLng(lat, lng),
			    bounds = latlng.toBounds(pos.coords.accuracy),
			    options = this._locateOptions;
	
			if (options.setView) {
				var zoom = this.getBoundsZoom(bounds);
				this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
			}
	
			var data = {
				latlng: latlng,
				bounds: bounds,
				timestamp: pos.timestamp
			};
	
			for (var i in pos.coords) {
				if (typeof pos.coords[i] === 'number') {
					data[i] = pos.coords[i];
				}
			}
	
			// @event locationfound: LocationEvent
			// Fired when geolocation (using the [`locate`](#map-locate) method)
			// went successfully.
			this.fire('locationfound', data);
		},
	
		// TODO handler.addTo
		// TODO Appropiate docs section?
		// @section Other Methods
		// @method addHandler(name: String, HandlerClass: Function): this
		// Adds a new `Handler` to the map, given its name and constructor function.
		addHandler: function (name, HandlerClass) {
			if (!HandlerClass) { return this; }
	
			var handler = this[name] = new HandlerClass(this);
	
			this._handlers.push(handler);
	
			if (this.options[name]) {
				handler.enable();
			}
	
			return this;
		},
	
		// @method remove(): this
		// Destroys the map and clears all related event listeners.
		remove: function () {
	
			this._initEvents(true);
	
			if (this._containerId !== this._container._leaflet_id) {
				throw new Error('Map container is being reused by another instance');
			}
	
			try {
				// throws error in IE6-8
				delete this._container._leaflet_id;
				delete this._containerId;
			} catch (e) {
				/*eslint-disable */
				this._container._leaflet_id = undefined;
				/*eslint-enable */
				this._containerId = undefined;
			}
	
			L.DomUtil.remove(this._mapPane);
	
			if (this._clearControlPos) {
				this._clearControlPos();
			}
	
			this._clearHandlers();
	
			if (this._loaded) {
				// @section Map state change events
				// @event unload: Event
				// Fired when the map is destroyed with [remove](#map-remove) method.
				this.fire('unload');
			}
	
			for (var i in this._layers) {
				this._layers[i].remove();
			}
	
			return this;
		},
	
		// @section Other Methods
		// @method createPane(name: String, container?: HTMLElement): HTMLElement
		// Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
		// then returns it. The pane is created as a children of `container`, or
		// as a children of the main map pane if not set.
		createPane: function (name, container) {
			var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''),
			    pane = L.DomUtil.create('div', className, container || this._mapPane);
	
			if (name) {
				this._panes[name] = pane;
			}
			return pane;
		},
	
		// @section Methods for Getting Map State
	
		// @method getCenter(): LatLng
		// Returns the geographical center of the map view
		getCenter: function () {
			this._checkIfLoaded();
	
			if (this._lastCenter && !this._moved()) {
				return this._lastCenter;
			}
			return this.layerPointToLatLng(this._getCenterLayerPoint());
		},
	
		// @method getZoom(): Number
		// Returns the current zoom level of the map view
		getZoom: function () {
			return this._zoom;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the geographical bounds visible in the current map view
		getBounds: function () {
			var bounds = this.getPixelBounds(),
			    sw = this.unproject(bounds.getBottomLeft()),
			    ne = this.unproject(bounds.getTopRight());
	
			return new L.LatLngBounds(sw, ne);
		},
	
		// @method getMinZoom(): Number
		// Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
		getMinZoom: function () {
			return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
		},
	
		// @method getMaxZoom(): Number
		// Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
		getMaxZoom: function () {
			return this.options.maxZoom === undefined ?
				(this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom) :
				this.options.maxZoom;
		},
	
		// @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean): Number
		// Returns the maximum zoom level on which the given bounds fit to the map
		// view in its entirety. If `inside` (optional) is set to `true`, the method
		// instead returns the minimum zoom level on which the map view fits into
		// the given bounds in its entirety.
		getBoundsZoom: function (bounds, inside, padding) { // (LatLngBounds[, Boolean, Point]) -> Number
			bounds = L.latLngBounds(bounds);
			padding = L.point(padding || [0, 0]);
	
			var zoom = this.getZoom() || 0,
			    min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    nw = bounds.getNorthWest(),
			    se = bounds.getSouthEast(),
			    size = this.getSize().subtract(padding),
			    boundsSize = L.bounds(this.project(se, zoom), this.project(nw, zoom)).getSize(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
	
			var scale = Math.min(size.x / boundsSize.x, size.y / boundsSize.y);
			zoom = this.getScaleZoom(scale, zoom);
	
			if (snap) {
				zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
				zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
			}
	
			return Math.max(min, Math.min(max, zoom));
		},
	
		// @method getSize(): Point
		// Returns the current size of the map container (in pixels).
		getSize: function () {
			if (!this._size || this._sizeChanged) {
				this._size = new L.Point(
					this._container.clientWidth || 0,
					this._container.clientHeight || 0);
	
				this._sizeChanged = false;
			}
			return this._size.clone();
		},
	
		// @method getPixelBounds(): Bounds
		// Returns the bounds of the current map view in projected pixel
		// coordinates (sometimes useful in layer and overlay implementations).
		getPixelBounds: function (center, zoom) {
			var topLeftPoint = this._getTopLeftPoint(center, zoom);
			return new L.Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
		},
	
		// TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
		// the map pane? "left point of the map layer" can be confusing, specially
		// since there can be negative offsets.
		// @method getPixelOrigin(): Point
		// Returns the projected pixel coordinates of the top left point of
		// the map layer (useful in custom layer and overlay implementations).
		getPixelOrigin: function () {
			this._checkIfLoaded();
			return this._pixelOrigin;
		},
	
		// @method getPixelWorldBounds(zoom?: Number): Bounds
		// Returns the world's bounds in pixel coordinates for zoom level `zoom`.
		// If `zoom` is omitted, the map's current zoom level is used.
		getPixelWorldBounds: function (zoom) {
			return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
		},
	
		// @section Other Methods
	
		// @method getPane(pane: String|HTMLElement): HTMLElement
		// Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
		getPane: function (pane) {
			return typeof pane === 'string' ? this._panes[pane] : pane;
		},
	
		// @method getPanes(): Object
		// Returns a plain object containing the names of all [panes](#map-pane) as keys and
		// the panes as values.
		getPanes: function () {
			return this._panes;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the map.
		getContainer: function () {
			return this._container;
		},
	
	
		// @section Conversion Methods
	
		// @method getZoomScale(toZoom: Number, fromZoom: Number): Number
		// Returns the scale factor to be applied to a map transition from zoom level
		// `fromZoom` to `toZoom`. Used internally to help with zoom animations.
		getZoomScale: function (toZoom, fromZoom) {
			// TODO replace with universal implementation after refactoring projections
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			return crs.scale(toZoom) / crs.scale(fromZoom);
		},
	
		// @method getScaleZoom(scale: Number, fromZoom: Number): Number
		// Returns the zoom level that the map would end up at, if it is at `fromZoom`
		// level and everything is scaled by a factor of `scale`. Inverse of
		// [`getZoomScale`](#map-getZoomScale).
		getScaleZoom: function (scale, fromZoom) {
			var crs = this.options.crs;
			fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
			var zoom = crs.zoom(scale * crs.scale(fromZoom));
			return isNaN(zoom) ? Infinity : zoom;
		},
	
		// @method project(latlng: LatLng, zoom: Number): Point
		// Projects a geographical coordinate `LatLng` according to the projection
		// of the map's CRS, then scales it according to `zoom` and the CRS's
		// `Transformation`. The result is pixel coordinate relative to
		// the CRS origin.
		project: function (latlng, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.latLngToPoint(L.latLng(latlng), zoom);
		},
	
		// @method unproject(point: Point, zoom: Number): LatLng
		// Inverse of [`project`](#map-project).
		unproject: function (point, zoom) {
			zoom = zoom === undefined ? this._zoom : zoom;
			return this.options.crs.pointToLatLng(L.point(point), zoom);
		},
	
		// @method layerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding geographical coordinate (for the current zoom level).
		layerPointToLatLng: function (point) {
			var projectedPoint = L.point(point).add(this.getPixelOrigin());
			return this.unproject(projectedPoint);
		},
	
		// @method latLngToLayerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the [origin pixel](#map-getpixelorigin).
		latLngToLayerPoint: function (latlng) {
			var projectedPoint = this.project(L.latLng(latlng))._round();
			return projectedPoint._subtract(this.getPixelOrigin());
		},
	
		// @method wrapLatLng(latlng: LatLng): LatLng
		// Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
		// map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
		// CRS's bounds.
		// By default this means longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees.
		wrapLatLng: function (latlng) {
			return this.options.crs.wrapLatLng(L.latLng(latlng));
		},
	
		// @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
		// Returns a `LatLngBounds` with the same size as the given one, ensuring that
		// its center is within the CRS's bounds.
		// By default this means the center longitude is wrapped around the dateline so its
		// value is between -180 and +180 degrees, and the majority of the bounds
		// overlaps the CRS's bounds.
		wrapLatLngBounds: function (latlng) {
			return this.options.crs.wrapLatLngBounds(L.latLngBounds(latlng));
		},
	
		// @method distance(latlng1: LatLng, latlng2: LatLng): Number
		// Returns the distance between two geographical coordinates according to
		// the map's CRS. By default this measures distance in meters.
		distance: function (latlng1, latlng2) {
			return this.options.crs.distance(L.latLng(latlng1), L.latLng(latlng2));
		},
	
		// @method containerPointToLayerPoint(point: Point): Point
		// Given a pixel coordinate relative to the map container, returns the corresponding
		// pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
		containerPointToLayerPoint: function (point) { // (Point)
			return L.point(point).subtract(this._getMapPanePos());
		},
	
		// @method layerPointToContainerPoint(point: Point): Point
		// Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
		// returns the corresponding pixel coordinate relative to the map container.
		layerPointToContainerPoint: function (point) { // (Point)
			return L.point(point).add(this._getMapPanePos());
		},
	
		// @method containerPointToLatLng(point: Point): LatLng
		// Given a pixel coordinate relative to the map container, returns
		// the corresponding geographical coordinate (for the current zoom level).
		containerPointToLatLng: function (point) {
			var layerPoint = this.containerPointToLayerPoint(L.point(point));
			return this.layerPointToLatLng(layerPoint);
		},
	
		// @method latLngToContainerPoint(latlng: LatLng): Point
		// Given a geographical coordinate, returns the corresponding pixel coordinate
		// relative to the map container.
		latLngToContainerPoint: function (latlng) {
			return this.layerPointToContainerPoint(this.latLngToLayerPoint(L.latLng(latlng)));
		},
	
		// @method mouseEventToContainerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to the
		// map container where the event took place.
		mouseEventToContainerPoint: function (e) {
			return L.DomEvent.getMousePosition(e, this._container);
		},
	
		// @method mouseEventToLayerPoint(ev: MouseEvent): Point
		// Given a MouseEvent object, returns the pixel coordinate relative to
		// the [origin pixel](#map-getpixelorigin) where the event took place.
		mouseEventToLayerPoint: function (e) {
			return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
		},
	
		// @method mouseEventToLatLng(ev: MouseEvent): LatLng
		// Given a MouseEvent object, returns geographical coordinate where the
		// event took place.
		mouseEventToLatLng: function (e) { // (MouseEvent)
			return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
		},
	
	
		// map initialization methods
	
		_initContainer: function (id) {
			var container = this._container = L.DomUtil.get(id);
	
			if (!container) {
				throw new Error('Map container not found.');
			} else if (container._leaflet_id) {
				throw new Error('Map container is already initialized.');
			}
	
			L.DomEvent.addListener(container, 'scroll', this._onScroll, this);
			this._containerId = L.Util.stamp(container);
		},
	
		_initLayout: function () {
			var container = this._container;
	
			this._fadeAnimated = this.options.fadeAnimation && L.Browser.any3d;
	
			L.DomUtil.addClass(container, 'leaflet-container' +
				(L.Browser.touch ? ' leaflet-touch' : '') +
				(L.Browser.retina ? ' leaflet-retina' : '') +
				(L.Browser.ielt9 ? ' leaflet-oldie' : '') +
				(L.Browser.safari ? ' leaflet-safari' : '') +
				(this._fadeAnimated ? ' leaflet-fade-anim' : ''));
	
			var position = L.DomUtil.getStyle(container, 'position');
	
			if (position !== 'absolute' && position !== 'relative' && position !== 'fixed') {
				container.style.position = 'relative';
			}
	
			this._initPanes();
	
			if (this._initControlPos) {
				this._initControlPos();
			}
		},
	
		_initPanes: function () {
			var panes = this._panes = {};
			this._paneRenderers = {};
	
			// @section
			//
			// Panes are DOM elements used to control the ordering of layers on the map. You
			// can access panes with [`map.getPane`](#map-getpane) or
			// [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
			// [`map.createPane`](#map-createpane) method.
			//
			// Every map has the following default panes that differ only in zIndex.
			//
			// @pane mapPane: HTMLElement = 'auto'
			// Pane that contains all other map panes
	
			this._mapPane = this.createPane('mapPane', this._container);
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			// @pane tilePane: HTMLElement = 200
			// Pane for `GridLayer`s and `TileLayer`s
			this.createPane('tilePane');
			// @pane overlayPane: HTMLElement = 400
			// Pane for vector overlays (`Path`s), like `Polyline`s and `Polygon`s
			this.createPane('shadowPane');
			// @pane shadowPane: HTMLElement = 500
			// Pane for overlay shadows (e.g. `Marker` shadows)
			this.createPane('overlayPane');
			// @pane markerPane: HTMLElement = 600
			// Pane for `Icon`s of `Marker`s
			this.createPane('markerPane');
			// @pane tooltipPane: HTMLElement = 650
			// Pane for tooltip.
			this.createPane('tooltipPane');
			// @pane popupPane: HTMLElement = 700
			// Pane for `Popup`s.
			this.createPane('popupPane');
	
			if (!this.options.markerZoomAnimation) {
				L.DomUtil.addClass(panes.markerPane, 'leaflet-zoom-hide');
				L.DomUtil.addClass(panes.shadowPane, 'leaflet-zoom-hide');
			}
		},
	
	
		// private methods that modify map state
	
		// @section Map state change events
		_resetView: function (center, zoom) {
			L.DomUtil.setPosition(this._mapPane, new L.Point(0, 0));
	
			var loading = !this._loaded;
			this._loaded = true;
			zoom = this._limitZoom(zoom);
	
			this.fire('viewprereset');
	
			var zoomChanged = this._zoom !== zoom;
			this
				._moveStart(zoomChanged)
				._move(center, zoom)
				._moveEnd(zoomChanged);
	
			// @event viewreset: Event
			// Fired when the map needs to redraw its content (this usually happens
			// on map zoom or load). Very useful for creating custom overlays.
			this.fire('viewreset');
	
			// @event load: Event
			// Fired when the map is initialized (when its center and zoom are set
			// for the first time).
			if (loading) {
				this.fire('load');
			}
		},
	
		_moveStart: function (zoomChanged) {
			// @event zoomstart: Event
			// Fired when the map zoom is about to change (e.g. before zoom animation).
			// @event movestart: Event
			// Fired when the view of the map starts changing (e.g. user starts dragging the map).
			if (zoomChanged) {
				this.fire('zoomstart');
			}
			return this.fire('movestart');
		},
	
		_move: function (center, zoom, data) {
			if (zoom === undefined) {
				zoom = this._zoom;
			}
			var zoomChanged = this._zoom !== zoom;
	
			this._zoom = zoom;
			this._lastCenter = center;
			this._pixelOrigin = this._getNewPixelOrigin(center);
	
			// @event zoom: Event
			// Fired repeatedly during any change in zoom level, including zoom
			// and fly animations.
			if (zoomChanged || (data && data.pinch)) {	// Always fire 'zoom' if pinching because #3530
				this.fire('zoom', data);
			}
	
			// @event move: Event
			// Fired repeatedly during any movement of the map, including pan and
			// fly animations.
			return this.fire('move', data);
		},
	
		_moveEnd: function (zoomChanged) {
			// @event zoomend: Event
			// Fired when the map has changed, after any animations.
			if (zoomChanged) {
				this.fire('zoomend');
			}
	
			// @event moveend: Event
			// Fired when the center of the map stops changing (e.g. user stopped
			// dragging the map).
			return this.fire('moveend');
		},
	
		_stop: function () {
			L.Util.cancelAnimFrame(this._flyToFrame);
			if (this._panAnim) {
				this._panAnim.stop();
			}
			return this;
		},
	
		_rawPanBy: function (offset) {
			L.DomUtil.setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
		},
	
		_getZoomSpan: function () {
			return this.getMaxZoom() - this.getMinZoom();
		},
	
		_panInsideMaxBounds: function () {
			if (!this._enforcingBounds) {
				this.panInsideBounds(this.options.maxBounds);
			}
		},
	
		_checkIfLoaded: function () {
			if (!this._loaded) {
				throw new Error('Set map center and zoom first.');
			}
		},
	
		// DOM event handling
	
		// @section Interaction events
		_initEvents: function (remove) {
			if (!L.DomEvent) { return; }
	
			this._targets = {};
			this._targets[L.stamp(this._container)] = this;
	
			var onOff = remove ? 'off' : 'on';
	
			// @event click: MouseEvent
			// Fired when the user clicks (or taps) the map.
			// @event dblclick: MouseEvent
			// Fired when the user double-clicks (or double-taps) the map.
			// @event mousedown: MouseEvent
			// Fired when the user pushes the mouse button on the map.
			// @event mouseup: MouseEvent
			// Fired when the user releases the mouse button on the map.
			// @event mouseover: MouseEvent
			// Fired when the mouse enters the map.
			// @event mouseout: MouseEvent
			// Fired when the mouse leaves the map.
			// @event mousemove: MouseEvent
			// Fired while the mouse moves over the map.
			// @event contextmenu: MouseEvent
			// Fired when the user pushes the right mouse button on the map, prevents
			// default browser context menu from showing if there are listeners on
			// this event. Also fired on mobile when the user holds a single touch
			// for a second (also called long press).
			// @event keypress: KeyboardEvent
			// Fired when the user presses a key from the keyboard while the map is focused.
			L.DomEvent[onOff](this._container, 'click dblclick mousedown mouseup ' +
				'mouseover mouseout mousemove contextmenu keypress', this._handleDOMEvent, this);
	
			if (this.options.trackResize) {
				L.DomEvent[onOff](window, 'resize', this._onResize, this);
			}
	
			if (L.Browser.any3d && this.options.transform3DLimit) {
				this[onOff]('moveend', this._onMoveEnd);
			}
		},
	
		_onResize: function () {
			L.Util.cancelAnimFrame(this._resizeRequest);
			this._resizeRequest = L.Util.requestAnimFrame(
			        function () { this.invalidateSize({debounceMoveend: true}); }, this);
		},
	
		_onScroll: function () {
			this._container.scrollTop  = 0;
			this._container.scrollLeft = 0;
		},
	
		_onMoveEnd: function () {
			var pos = this._getMapPanePos();
			if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
				// https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
				// a pixel offset on very high values, see: http://jsfiddle.net/dg6r5hhb/
				this._resetView(this.getCenter(), this.getZoom());
			}
		},
	
		_findEventTargets: function (e, type) {
			var targets = [],
			    target,
			    isHover = type === 'mouseout' || type === 'mouseover',
			    src = e.target || e.srcElement,
			    dragging = false;
	
			while (src) {
				target = this._targets[L.stamp(src)];
				if (target && (type === 'click' || type === 'preclick') && !e._simulated && this._draggableMoved(target)) {
					// Prevent firing click after you just dragged an object.
					dragging = true;
					break;
				}
				if (target && target.listens(type, true)) {
					if (isHover && !L.DomEvent._isExternalTarget(src, e)) { break; }
					targets.push(target);
					if (isHover) { break; }
				}
				if (src === this._container) { break; }
				src = src.parentNode;
			}
			if (!targets.length && !dragging && !isHover && L.DomEvent._isExternalTarget(src, e)) {
				targets = [this];
			}
			return targets;
		},
	
		_handleDOMEvent: function (e) {
			if (!this._loaded || L.DomEvent._skipped(e)) { return; }
	
			var type = e.type === 'keypress' && e.keyCode === 13 ? 'click' : e.type;
	
			if (type === 'mousedown') {
				// prevents outline when clicking on keyboard-focusable element
				L.DomUtil.preventOutline(e.target || e.srcElement);
			}
	
			this._fireDOMEvent(e, type);
		},
	
		_fireDOMEvent: function (e, type, targets) {
	
			if (e.type === 'click') {
				// Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
				// @event preclick: MouseEvent
				// Fired before mouse click on the map (sometimes useful when you
				// want something to happen on click before any existing click
				// handlers start running).
				var synth = L.Util.extend({}, e);
				synth.type = 'preclick';
				this._fireDOMEvent(synth, synth.type, targets);
			}
	
			if (e._stopped) { return; }
	
			// Find the layer the event is propagating from and its parents.
			targets = (targets || []).concat(this._findEventTargets(e, type));
	
			if (!targets.length) { return; }
	
			var target = targets[0];
			if (type === 'contextmenu' && target.listens(type, true)) {
				L.DomEvent.preventDefault(e);
			}
	
			var data = {
				originalEvent: e
			};
	
			if (e.type !== 'keypress') {
				var isMarker = target instanceof L.Marker;
				data.containerPoint = isMarker ?
						this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
				data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
				data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
			}
	
			for (var i = 0; i < targets.length; i++) {
				targets[i].fire(type, data, true);
				if (data.originalEvent._stopped ||
					(targets[i].options.nonBubblingEvents && L.Util.indexOf(targets[i].options.nonBubblingEvents, type) !== -1)) { return; }
			}
		},
	
		_draggableMoved: function (obj) {
			obj = obj.dragging && obj.dragging.enabled() ? obj : this;
			return (obj.dragging && obj.dragging.moved()) || (this.boxZoom && this.boxZoom.moved());
		},
	
		_clearHandlers: function () {
			for (var i = 0, len = this._handlers.length; i < len; i++) {
				this._handlers[i].disable();
			}
		},
	
		// @section Other Methods
	
		// @method whenReady(fn: Function, context?: Object): this
		// Runs the given function `fn` when the map gets initialized with
		// a view (center and zoom) and at least one layer, or immediately
		// if it's already initialized, optionally passing a function context.
		whenReady: function (callback, context) {
			if (this._loaded) {
				callback.call(context || this, {target: this});
			} else {
				this.on('load', callback, context);
			}
			return this;
		},
	
	
		// private methods for getting map state
	
		_getMapPanePos: function () {
			return L.DomUtil.getPosition(this._mapPane) || new L.Point(0, 0);
		},
	
		_moved: function () {
			var pos = this._getMapPanePos();
			return pos && !pos.equals([0, 0]);
		},
	
		_getTopLeftPoint: function (center, zoom) {
			var pixelOrigin = center && zoom !== undefined ?
				this._getNewPixelOrigin(center, zoom) :
				this.getPixelOrigin();
			return pixelOrigin.subtract(this._getMapPanePos());
		},
	
		_getNewPixelOrigin: function (center, zoom) {
			var viewHalf = this.getSize()._divideBy(2);
			return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
		},
	
		_latLngToNewLayerPoint: function (latlng, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return this.project(latlng, zoom)._subtract(topLeft);
		},
	
		_latLngBoundsToNewLayerBounds: function (latLngBounds, zoom, center) {
			var topLeft = this._getNewPixelOrigin(center, zoom);
			return L.bounds([
				this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
				this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
			]);
		},
	
		// layer point of the current center
		_getCenterLayerPoint: function () {
			return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
		},
	
		// offset of the specified place to the current center in pixels
		_getCenterOffset: function (latlng) {
			return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
		},
	
		// adjust center for view to get inside bounds
		_limitCenter: function (center, zoom, bounds) {
	
			if (!bounds) { return center; }
	
			var centerPoint = this.project(center, zoom),
			    viewHalf = this.getSize().divideBy(2),
			    viewBounds = new L.Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)),
			    offset = this._getBoundsOffset(viewBounds, bounds, zoom);
	
			// If offset is less than a pixel, ignore.
			// This prevents unstable projections from getting into
			// an infinite loop of tiny offsets.
			if (offset.round().equals([0, 0])) {
				return center;
			}
	
			return this.unproject(centerPoint.add(offset), zoom);
		},
	
		// adjust offset for view to get inside bounds
		_limitOffset: function (offset, bounds) {
			if (!bounds) { return offset; }
	
			var viewBounds = this.getPixelBounds(),
			    newBounds = new L.Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
	
			return offset.add(this._getBoundsOffset(newBounds, bounds));
		},
	
		// returns offset needed for pxBounds to get inside maxBounds at a specified zoom
		_getBoundsOffset: function (pxBounds, maxBounds, zoom) {
			var projectedMaxBounds = L.bounds(
			        this.project(maxBounds.getNorthEast(), zoom),
			        this.project(maxBounds.getSouthWest(), zoom)
			    ),
			    minOffset = projectedMaxBounds.min.subtract(pxBounds.min),
			    maxOffset = projectedMaxBounds.max.subtract(pxBounds.max),
	
			    dx = this._rebound(minOffset.x, -maxOffset.x),
			    dy = this._rebound(minOffset.y, -maxOffset.y);
	
			return new L.Point(dx, dy);
		},
	
		_rebound: function (left, right) {
			return left + right > 0 ?
				Math.round(left - right) / 2 :
				Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
		},
	
		_limitZoom: function (zoom) {
			var min = this.getMinZoom(),
			    max = this.getMaxZoom(),
			    snap = L.Browser.any3d ? this.options.zoomSnap : 1;
			if (snap) {
				zoom = Math.round(zoom / snap) * snap;
			}
			return Math.max(min, Math.min(max, zoom));
		},
	
		_onPanTransitionStep: function () {
			this.fire('move');
		},
	
		_onPanTransitionEnd: function () {
			L.DomUtil.removeClass(this._mapPane, 'leaflet-pan-anim');
			this.fire('moveend');
		},
	
		_tryAnimatedPan: function (center, options) {
			// difference between the new and current centers in pixels
			var offset = this._getCenterOffset(center)._floor();
	
			// don't animate too far unless animate: true specified in options
			if ((options && options.animate) !== true && !this.getSize().contains(offset)) { return false; }
	
			this.panBy(offset, options);
	
			return true;
		},
	
		_createAnimProxy: function () {
	
			var proxy = this._proxy = L.DomUtil.create('div', 'leaflet-proxy leaflet-zoom-animated');
			this._panes.mapPane.appendChild(proxy);
	
			this.on('zoomanim', function (e) {
				var prop = L.DomUtil.TRANSFORM,
				    transform = proxy.style[prop];
	
				L.DomUtil.setTransform(proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
	
				// workaround for case when transform is the same and so transitionend event is not fired
				if (transform === proxy.style[prop] && this._animatingZoom) {
					this._onZoomTransitionEnd();
				}
			}, this);
	
			this.on('load moveend', function () {
				var c = this.getCenter(),
				    z = this.getZoom();
				L.DomUtil.setTransform(proxy, this.project(c, z), this.getZoomScale(z, 1));
			}, this);
		},
	
		_catchTransitionEnd: function (e) {
			if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) {
				this._onZoomTransitionEnd();
			}
		},
	
		_nothingToAnimate: function () {
			return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
		},
	
		_tryAnimatedZoom: function (center, zoom, options) {
	
			if (this._animatingZoom) { return true; }
	
			options = options || {};
	
			// don't animate if disabled, not supported or zoom difference is too large
			if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() ||
			        Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) { return false; }
	
			// offset is the pixel coords of the zoom origin relative to the current center
			var scale = this.getZoomScale(zoom),
			    offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
	
			// don't animate if the zoom origin isn't within one screen from the current center, unless forced
			if (options.animate !== true && !this.getSize().contains(offset)) { return false; }
	
			L.Util.requestAnimFrame(function () {
				this
				    ._moveStart(true)
				    ._animateZoom(center, zoom, true);
			}, this);
	
			return true;
		},
	
		_animateZoom: function (center, zoom, startAnim, noUpdate) {
			if (startAnim) {
				this._animatingZoom = true;
	
				// remember what center/zoom to set after animation
				this._animateToCenter = center;
				this._animateToZoom = zoom;
	
				L.DomUtil.addClass(this._mapPane, 'leaflet-zoom-anim');
			}
	
			// @event zoomanim: ZoomAnimEvent
			// Fired on every frame of a zoom animation
			this.fire('zoomanim', {
				center: center,
				zoom: zoom,
				noUpdate: noUpdate
			});
	
			// Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
			setTimeout(L.bind(this._onZoomTransitionEnd, this), 250);
		},
	
		_onZoomTransitionEnd: function () {
			if (!this._animatingZoom) { return; }
	
			L.DomUtil.removeClass(this._mapPane, 'leaflet-zoom-anim');
	
			this._animatingZoom = false;
	
			this._move(this._animateToCenter, this._animateToZoom);
	
			// This anim frame should prevent an obscure iOS webkit tile loading race condition.
			L.Util.requestAnimFrame(function () {
				this._moveEnd(true);
			}, this);
		}
	});
	
	// @section
	
	// @factory L.map(id: String, options?: Map options)
	// Instantiates a map object given the DOM ID of a `<div>` element
	// and optionally an object literal with `Map options`.
	//
	// @alternative
	// @factory L.map(el: HTMLElement, options?: Map options)
	// Instantiates a map object given an instance of a `<div>` HTML element
	// and optionally an object literal with `Map options`.
	L.map = function (id, options) {
		return new L.Map(id, options);
	};
	
	
	
	
	/*
	 * @class Layer
	 * @inherits Evented
	 * @aka L.Layer
	 * @aka ILayer
	 *
	 * A set of methods from the Layer base class that all Leaflet layers use.
	 * Inherits all methods, options and events from `L.Evented`.
	 *
	 * @example
	 *
	 * ```js
	 * var layer = L.Marker(latlng).addTo(map);
	 * layer.addTo(map);
	 * layer.remove();
	 * ```
	 *
	 * @event add: Event
	 * Fired after the layer is added to a map
	 *
	 * @event remove: Event
	 * Fired after the layer is removed from a map
	 */
	
	
	L.Layer = L.Evented.extend({
	
		// Classes extending `L.Layer` will inherit the following options:
		options: {
			// @option pane: String = 'overlayPane'
			// By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
			pane: 'overlayPane',
			nonBubblingEvents: [],  // Array of events that should not be bubbled to DOM parents (like the map),
	
			// @option attribution: String = null
			// String to be shown in the attribution control, describes the layer data, e.g. "© Mapbox".
			attribution: null
		},
	
		/* @section
		 * Classes extending `L.Layer` will inherit the following methods:
		 *
		 * @method addTo(map: Map): this
		 * Adds the layer to the given map
		 */
		addTo: function (map) {
			map.addLayer(this);
			return this;
		},
	
		// @method remove: this
		// Removes the layer from the map it is currently active on.
		remove: function () {
			return this.removeFrom(this._map || this._mapToAdd);
		},
	
		// @method removeFrom(map: Map): this
		// Removes the layer from the given map
		removeFrom: function (obj) {
			if (obj) {
				obj.removeLayer(this);
			}
			return this;
		},
	
		// @method getPane(name? : String): HTMLElement
		// Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
		getPane: function (name) {
			return this._map.getPane(name ? (this.options[name] || name) : this.options.pane);
		},
	
		addInteractiveTarget: function (targetEl) {
			this._map._targets[L.stamp(targetEl)] = this;
			return this;
		},
	
		removeInteractiveTarget: function (targetEl) {
			delete this._map._targets[L.stamp(targetEl)];
			return this;
		},
	
		// @method getAttribution: String
		// Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
		getAttribution: function () {
			return this.options.attribution;
		},
	
		_layerAdd: function (e) {
			var map = e.target;
	
			// check in case layer gets added and then removed before the map is ready
			if (!map.hasLayer(this)) { return; }
	
			this._map = map;
			this._zoomAnimated = map._zoomAnimated;
	
			if (this.getEvents) {
				var events = this.getEvents();
				map.on(events, this);
				this.once('remove', function () {
					map.off(events, this);
				}, this);
			}
	
			this.onAdd(map);
	
			if (this.getAttribution && map.attributionControl) {
				map.attributionControl.addAttribution(this.getAttribution());
			}
	
			this.fire('add');
			map.fire('layeradd', {layer: this});
		}
	});
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every layer should extend from `L.Layer` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): this
	 * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
	 *
	 * @method onRemove(map: Map): this
	 * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
	 *
	 * @method getEvents(): Object
	 * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
	 *
	 * @method getAttribution(): String
	 * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
	 *
	 * @method beforeAdd(map: Map): this
	 * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
	 */
	
	
	/* @namespace Map
	 * @section Layer events
	 *
	 * @event layeradd: LayerEvent
	 * Fired when a new layer is added to the map.
	 *
	 * @event layerremove: LayerEvent
	 * Fired when some layer is removed from the map
	 *
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the map
		addLayer: function (layer) {
			var id = L.stamp(layer);
			if (this._layers[id]) { return this; }
			this._layers[id] = layer;
	
			layer._mapToAdd = this;
	
			if (layer.beforeAdd) {
				layer.beforeAdd(this);
			}
	
			this.whenReady(layer._layerAdd, layer);
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the map.
		removeLayer: function (layer) {
			var id = L.stamp(layer);
	
			if (!this._layers[id]) { return this; }
	
			if (this._loaded) {
				layer.onRemove(this);
			}
	
			if (layer.getAttribution && this.attributionControl) {
				this.attributionControl.removeAttribution(layer.getAttribution());
			}
	
			delete this._layers[id];
	
			if (this._loaded) {
				this.fire('layerremove', {layer: layer});
				layer.fire('remove');
			}
	
			layer._map = layer._mapToAdd = null;
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the map
		hasLayer: function (layer) {
			return !!layer && (L.stamp(layer) in this._layers);
		},
	
		/* @method eachLayer(fn: Function, context?: Object): this
		 * Iterates over the layers of the map, optionally specifying context of the iterator function.
		 * ```
		 * map.eachLayer(function(layer){
		 *     layer.bindPopup('Hello');
		 * });
		 * ```
		 */
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		_addLayers: function (layers) {
			layers = layers ? (L.Util.isArray(layers) ? layers : [layers]) : [];
	
			for (var i = 0, len = layers.length; i < len; i++) {
				this.addLayer(layers[i]);
			}
		},
	
		_addZoomLimit: function (layer) {
			if (isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
				this._zoomBoundLayers[L.stamp(layer)] = layer;
				this._updateZoomLevels();
			}
		},
	
		_removeZoomLimit: function (layer) {
			var id = L.stamp(layer);
	
			if (this._zoomBoundLayers[id]) {
				delete this._zoomBoundLayers[id];
				this._updateZoomLevels();
			}
		},
	
		_updateZoomLevels: function () {
			var minZoom = Infinity,
			    maxZoom = -Infinity,
			    oldZoomSpan = this._getZoomSpan();
	
			for (var i in this._zoomBoundLayers) {
				var options = this._zoomBoundLayers[i].options;
	
				minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
				maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
			}
	
			this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
			this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
	
			// @section Map state change events
			// @event zoomlevelschange: Event
			// Fired when the number of zoomlevels on the map is changed due
			// to adding or removing a layer.
			if (oldZoomSpan !== this._getZoomSpan()) {
				this.fire('zoomlevelschange');
			}
	
			if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
				this.setZoom(this._layersMaxZoom);
			}
			if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
				this.setZoom(this._layersMinZoom);
			}
		}
	});
	
	
	
	/*
	 * @namespace DomEvent
	 * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
	 */
	
	// Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
	
	
	
	var eventsKey = '_leaflet_events';
	
	L.DomEvent = {
	
		// @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Adds a listener function (`fn`) to a particular DOM event type of the
		// element `el`. You can optionally specify the context of the listener
		// (object the `this` keyword will point to). You can also pass several
		// space-separated types (e.g. `'click dblclick'`).
	
		// @alternative
		// @function on(el: HTMLElement, eventMap: Object, context?: Object): this
		// Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		on: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._on(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._on(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		// @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
		// Removes a previously added listener function. If no function is specified,
		// it will remove all the listeners of that particular DOM event from the element.
		// Note that if you passed a custom context to on, you must pass the same
		// context to `off` in order to remove the listener.
	
		// @alternative
		// @function off(el: HTMLElement, eventMap: Object, context?: Object): this
		// Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
		off: function (obj, types, fn, context) {
	
			if (typeof types === 'object') {
				for (var type in types) {
					this._off(obj, type, types[type], fn);
				}
			} else {
				types = L.Util.splitWords(types);
	
				for (var i = 0, len = types.length; i < len; i++) {
					this._off(obj, types[i], fn, context);
				}
			}
	
			return this;
		},
	
		_on: function (obj, type, fn, context) {
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : '');
	
			if (obj[eventsKey] && obj[eventsKey][id]) { return this; }
	
			var handler = function (e) {
				return fn.call(context || obj, e || window.event);
			};
	
			var originalHandler = handler;
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.addPointerListener(obj, type, handler, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.addDoubleTapListener &&
			           !(L.Browser.pointer && L.Browser.chrome)) {
				// Chrome >55 does not need the synthetic dblclicks from addDoubleTapListener
				// See #5180
				this.addDoubleTapListener(obj, handler, id);
	
			} else if ('addEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.addEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else if ((type === 'mouseenter') || (type === 'mouseleave')) {
					handler = function (e) {
						e = e || window.event;
						if (L.DomEvent._isExternalTarget(obj, e)) {
							originalHandler(e);
						}
					};
					obj.addEventListener(type === 'mouseenter' ? 'mouseover' : 'mouseout', handler, false);
	
				} else {
					if (type === 'click' && L.Browser.android) {
						handler = function (e) {
							return L.DomEvent._filterClick(e, originalHandler);
						};
					}
					obj.addEventListener(type, handler, false);
				}
	
			} else if ('attachEvent' in obj) {
				obj.attachEvent('on' + type, handler);
			}
	
			obj[eventsKey] = obj[eventsKey] || {};
			obj[eventsKey][id] = handler;
	
			return this;
		},
	
		_off: function (obj, type, fn, context) {
	
			var id = type + L.stamp(fn) + (context ? '_' + L.stamp(context) : ''),
			    handler = obj[eventsKey] && obj[eventsKey][id];
	
			if (!handler) { return this; }
	
			if (L.Browser.pointer && type.indexOf('touch') === 0) {
				this.removePointerListener(obj, type, id);
	
			} else if (L.Browser.touch && (type === 'dblclick') && this.removeDoubleTapListener) {
				this.removeDoubleTapListener(obj, id);
	
			} else if ('removeEventListener' in obj) {
	
				if (type === 'mousewheel') {
					obj.removeEventListener('onwheel' in obj ? 'wheel' : 'mousewheel', handler, false);
	
				} else {
					obj.removeEventListener(
						type === 'mouseenter' ? 'mouseover' :
						type === 'mouseleave' ? 'mouseout' : type, handler, false);
				}
	
			} else if ('detachEvent' in obj) {
				obj.detachEvent('on' + type, handler);
			}
	
			obj[eventsKey][id] = null;
	
			return this;
		},
	
		// @function stopPropagation(ev: DOMEvent): this
		// Stop the given event from propagation to parent elements. Used inside the listener functions:
		// ```js
		// L.DomEvent.on(div, 'click', function (ev) {
		// 	L.DomEvent.stopPropagation(ev);
		// });
		// ```
		stopPropagation: function (e) {
	
			if (e.stopPropagation) {
				e.stopPropagation();
			} else if (e.originalEvent) {  // In case of Leaflet event.
				e.originalEvent._stopped = true;
			} else {
				e.cancelBubble = true;
			}
			L.DomEvent._skipped(e);
	
			return this;
		},
	
		// @function disableScrollPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'mousewheel'` events (plus browser variants).
		disableScrollPropagation: function (el) {
			return L.DomEvent.on(el, 'mousewheel', L.DomEvent.stopPropagation);
		},
	
		// @function disableClickPropagation(el: HTMLElement): this
		// Adds `stopPropagation` to the element's `'click'`, `'doubleclick'`,
		// `'mousedown'` and `'touchstart'` events (plus browser variants).
		disableClickPropagation: function (el) {
			var stop = L.DomEvent.stopPropagation;
	
			L.DomEvent.on(el, L.Draggable.START.join(' '), stop);
	
			return L.DomEvent.on(el, {
				click: L.DomEvent._fakeStop,
				dblclick: stop
			});
		},
	
		// @function preventDefault(ev: DOMEvent): this
		// Prevents the default action of the DOM Event `ev` from happening (such as
		// following a link in the href of the a element, or doing a POST request
		// with page reload when a `<form>` is submitted).
		// Use it inside listener functions.
		preventDefault: function (e) {
	
			if (e.preventDefault) {
				e.preventDefault();
			} else {
				e.returnValue = false;
			}
			return this;
		},
	
		// @function stop(ev): this
		// Does `stopPropagation` and `preventDefault` at the same time.
		stop: function (e) {
			return L.DomEvent
				.preventDefault(e)
				.stopPropagation(e);
		},
	
		// @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
		// Gets normalized mouse position from a DOM event relative to the
		// `container` or to the whole page if not specified.
		getMousePosition: function (e, container) {
			if (!container) {
				return new L.Point(e.clientX, e.clientY);
			}
	
			var rect = container.getBoundingClientRect();
	
			return new L.Point(
				e.clientX - rect.left - container.clientLeft,
				e.clientY - rect.top - container.clientTop);
		},
	
		// Chrome on Win scrolls double the pixels as in other platforms (see #4538),
		// and Firefox scrolls device pixels, not CSS pixels
		_wheelPxFactor: (L.Browser.win && L.Browser.chrome) ? 2 :
		                L.Browser.gecko ? window.devicePixelRatio :
		                1,
	
		// @function getWheelDelta(ev: DOMEvent): Number
		// Gets normalized wheel delta from a mousewheel DOM event, in vertical
		// pixels scrolled (negative if scrolling down).
		// Events from pointing devices without precise scrolling are mapped to
		// a best guess of 60 pixels.
		getWheelDelta: function (e) {
			return (L.Browser.edge) ? e.wheelDeltaY / 2 : // Don't trust window-geometry-based delta
			       (e.deltaY && e.deltaMode === 0) ? -e.deltaY / L.DomEvent._wheelPxFactor : // Pixels
			       (e.deltaY && e.deltaMode === 1) ? -e.deltaY * 20 : // Lines
			       (e.deltaY && e.deltaMode === 2) ? -e.deltaY * 60 : // Pages
			       (e.deltaX || e.deltaZ) ? 0 :	// Skip horizontal/depth wheel events
			       e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : // Legacy IE pixels
			       (e.detail && Math.abs(e.detail) < 32765) ? -e.detail * 20 : // Legacy Moz lines
			       e.detail ? e.detail / -32765 * 60 : // Legacy Moz pages
			       0;
		},
	
		_skipEvents: {},
	
		_fakeStop: function (e) {
			// fakes stopPropagation by setting a special event flag, checked/reset with L.DomEvent._skipped(e)
			L.DomEvent._skipEvents[e.type] = true;
		},
	
		_skipped: function (e) {
			var skipped = this._skipEvents[e.type];
			// reset when checking, as it's only used in map container and propagates outside of the map
			this._skipEvents[e.type] = false;
			return skipped;
		},
	
		// check if element really left/entered the event target (for mouseenter/mouseleave)
		_isExternalTarget: function (el, e) {
	
			var related = e.relatedTarget;
	
			if (!related) { return true; }
	
			try {
				while (related && (related !== el)) {
					related = related.parentNode;
				}
			} catch (err) {
				return false;
			}
			return (related !== el);
		},
	
		// this is a horrible workaround for a bug in Android where a single touch triggers two click events
		_filterClick: function (e, handler) {
			var timeStamp = (e.timeStamp || (e.originalEvent && e.originalEvent.timeStamp)),
			    elapsed = L.DomEvent._lastClick && (timeStamp - L.DomEvent._lastClick);
	
			// are they closer together than 500ms yet more than 100ms?
			// Android typically triggers them ~300ms apart while multiple listeners
			// on the same event should be triggered far faster;
			// or check if click is simulated on the element, and if it is, reject any non-simulated events
	
			if ((elapsed && elapsed > 100 && elapsed < 500) || (e.target._simulatedClick && !e._simulated)) {
				L.DomEvent.stop(e);
				return;
			}
			L.DomEvent._lastClick = timeStamp;
	
			handler(e);
		}
	};
	
	// @function addListener(…): this
	// Alias to [`L.DomEvent.on`](#domevent-on)
	L.DomEvent.addListener = L.DomEvent.on;
	
	// @function removeListener(…): this
	// Alias to [`L.DomEvent.off`](#domevent-off)
	L.DomEvent.removeListener = L.DomEvent.off;
	
	
	
	/*
	 * @class PosAnimation
	 * @aka L.PosAnimation
	 * @inherits Evented
	 * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
	 *
	 * @example
	 * ```js
	 * var fx = new L.PosAnimation();
	 * fx.run(el, [300, 500], 0.5);
	 * ```
	 *
	 * @constructor L.PosAnimation()
	 * Creates a `PosAnimation` object.
	 *
	 */
	
	L.PosAnimation = L.Evented.extend({
	
		// @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
		// Run an animation of a given element to a new position, optionally setting
		// duration in seconds (`0.25` by default) and easing linearity factor (3rd
		// argument of the [cubic bezier curve](http://cubic-bezier.com/#0,0,.5,1),
		// `0.5` by default).
		run: function (el, newPos, duration, easeLinearity) {
			this.stop();
	
			this._el = el;
			this._inProgress = true;
			this._duration = duration || 0.25;
			this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
	
			this._startPos = L.DomUtil.getPosition(el);
			this._offset = newPos.subtract(this._startPos);
			this._startTime = +new Date();
	
			// @event start: Event
			// Fired when the animation starts
			this.fire('start');
	
			this._animate();
		},
	
		// @method stop()
		// Stops the animation (if currently running).
		stop: function () {
			if (!this._inProgress) { return; }
	
			this._step(true);
			this._complete();
		},
	
		_animate: function () {
			// animation loop
			this._animId = L.Util.requestAnimFrame(this._animate, this);
			this._step();
		},
	
		_step: function (round) {
			var elapsed = (+new Date()) - this._startTime,
			    duration = this._duration * 1000;
	
			if (elapsed < duration) {
				this._runFrame(this._easeOut(elapsed / duration), round);
			} else {
				this._runFrame(1);
				this._complete();
			}
		},
	
		_runFrame: function (progress, round) {
			var pos = this._startPos.add(this._offset.multiplyBy(progress));
			if (round) {
				pos._round();
			}
			L.DomUtil.setPosition(this._el, pos);
	
			// @event step: Event
			// Fired continuously during the animation.
			this.fire('step');
		},
	
		_complete: function () {
			L.Util.cancelAnimFrame(this._animId);
	
			this._inProgress = false;
			// @event end: Event
			// Fired when the animation ends.
			this.fire('end');
		},
	
		_easeOut: function (t) {
			return 1 - Math.pow(1 - t, this._easeOutPower);
		}
	});
	
	
	
	/*
	 * @namespace Projection
	 * @projection L.Projection.Mercator
	 *
	 * Elliptical Mercator projection — more complex than Spherical Mercator. Takes into account that Earth is a geoid, not a perfect sphere. Used by the EPSG:3395 CRS.
	 */
	
	L.Projection.Mercator = {
		R: 6378137,
		R_MINOR: 6356752.314245179,
	
		bounds: L.bounds([-20037508.34279, -15496570.73972], [20037508.34279, 18764656.23138]),
	
		project: function (latlng) {
			var d = Math.PI / 180,
			    r = this.R,
			    y = latlng.lat * d,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    con = e * Math.sin(y);
	
			var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
			y = -r * Math.log(Math.max(ts, 1E-10));
	
			return new L.Point(latlng.lng * d * r, y);
		},
	
		unproject: function (point) {
			var d = 180 / Math.PI,
			    r = this.R,
			    tmp = this.R_MINOR / r,
			    e = Math.sqrt(1 - tmp * tmp),
			    ts = Math.exp(-point.y / r),
			    phi = Math.PI / 2 - 2 * Math.atan(ts);
	
			for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
				con = e * Math.sin(phi);
				con = Math.pow((1 - con) / (1 + con), e / 2);
				dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
				phi += dphi;
			}
	
			return new L.LatLng(phi * d, point.x * d / r);
		}
	};
	
	
	
	/*
	 * @namespace CRS
	 * @crs L.CRS.EPSG3395
	 *
	 * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
	 */
	
	L.CRS.EPSG3395 = L.extend({}, L.CRS.Earth, {
		code: 'EPSG:3395',
		projection: L.Projection.Mercator,
	
		transformation: (function () {
			var scale = 0.5 / (Math.PI * L.Projection.Mercator.R);
			return new L.Transformation(scale, 0.5, -scale, 0.5);
		}())
	});
	
	
	
	/*
	 * @class GridLayer
	 * @inherits Layer
	 * @aka L.GridLayer
	 *
	 * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
	 * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
	 *
	 *
	 * @section Synchronous usage
	 * @example
	 *
	 * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords){
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
	 *         var ctx = tile.getContext('2d');
	 *
	 *         // return the tile so it can be rendered on screen
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section Asynchronous usage
	 * @example
	 *
	 * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
	 *
	 * ```js
	 * var CanvasLayer = L.GridLayer.extend({
	 *     createTile: function(coords, done){
	 *         var error;
	 *
	 *         // create a <canvas> element for drawing
	 *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
	 *
	 *         // setup tile width and height according to the options
	 *         var size = this.getTileSize();
	 *         tile.width = size.x;
	 *         tile.height = size.y;
	 *
	 *         // draw something asynchronously and pass the tile to the done() callback
	 *         setTimeout(function() {
	 *             done(error, tile);
	 *         }, 1000);
	 *
	 *         return tile;
	 *     }
	 * });
	 * ```
	 *
	 * @section
	 */
	
	
	L.GridLayer = L.Layer.extend({
	
		// @section
		// @aka GridLayer options
		options: {
			// @option tileSize: Number|Point = 256
			// Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
			tileSize: 256,
	
			// @option opacity: Number = 1.0
			// Opacity of the tiles. Can be used in the `createTile()` function.
			opacity: 1,
	
			// @option updateWhenIdle: Boolean = depends
			// If `false`, new tiles are loaded during panning, otherwise only after it (for better performance). `true` by default on mobile browsers, otherwise `false`.
			updateWhenIdle: L.Browser.mobile,
	
			// @option updateWhenZooming: Boolean = true
			// By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
			updateWhenZooming: true,
	
			// @option updateInterval: Number = 200
			// Tiles will not update more than once every `updateInterval` milliseconds when panning.
			updateInterval: 200,
	
			// @option zIndex: Number = 1
			// The explicit zIndex of the tile layer.
			zIndex: 1,
	
			// @option bounds: LatLngBounds = undefined
			// If set, tiles will only be loaded inside the set `LatLngBounds`.
			bounds: null,
	
			// @option minZoom: Number = 0
			// The minimum zoom level that tiles will be loaded at. By default the entire map.
			minZoom: 0,
	
			// @option maxZoom: Number = undefined
			// The maximum zoom level that tiles will be loaded at.
			maxZoom: undefined,
	
			// @option noWrap: Boolean = false
			// Whether the layer is wrapped around the antimeridian. If `true`, the
			// GridLayer will only be displayed once at low zoom levels. Has no
			// effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
			// in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
			// tiles outside the CRS limits.
			noWrap: false,
	
			// @option pane: String = 'tilePane'
			// `Map pane` where the grid layer will be added.
			pane: 'tilePane',
	
			// @option className: String = ''
			// A custom class name to assign to the tile layer. Empty by default.
			className: '',
	
			// @option keepBuffer: Number = 2
			// When panning the map, keep this many rows and columns of tiles before unloading them.
			keepBuffer: 2
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			this._initContainer();
	
			this._levels = {};
			this._tiles = {};
	
			this._resetView();
			this._update();
		},
	
		beforeAdd: function (map) {
			map._addZoomLimit(this);
		},
	
		onRemove: function (map) {
			this._removeAllTiles();
			L.DomUtil.remove(this._container);
			map._removeZoomLimit(this);
			this._container = null;
			this._tileZoom = null;
		},
	
		// @method bringToFront: this
		// Brings the tile layer to the top of all tile layers.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
				this._setAutoZIndex(Math.max);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings the tile layer to the bottom of all tile layers.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
				this._setAutoZIndex(Math.min);
			}
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTML element that contains the tiles for this layer.
		getContainer: function () {
			return this._container;
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the [opacity](#gridlayer-opacity) of the grid layer.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			this._updateOpacity();
			return this;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Changes the [zIndex](#gridlayer-zindex) of the grid layer.
		setZIndex: function (zIndex) {
			this.options.zIndex = zIndex;
			this._updateZIndex();
	
			return this;
		},
	
		// @method isLoading: Boolean
		// Returns `true` if any tile in the grid layer has not finished loading.
		isLoading: function () {
			return this._loading;
		},
	
		// @method redraw: this
		// Causes the layer to clear all the tiles and request them again.
		redraw: function () {
			if (this._map) {
				this._removeAllTiles();
				this._update();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				viewprereset: this._invalidateAll,
				viewreset: this._resetView,
				zoom: this._resetView,
				moveend: this._onMoveEnd
			};
	
			if (!this.options.updateWhenIdle) {
				// update tiles on move, but not more often than once per given interval
				if (!this._onMove) {
					this._onMove = L.Util.throttle(this._onMoveEnd, this.options.updateInterval, this);
				}
	
				events.move = this._onMove;
			}
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @section Extension methods
		// Layers extending `GridLayer` shall reimplement the following method.
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, must be overriden by classes extending `GridLayer`.
		// Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
		// is specified, it must be called when the tile has finished loading and drawing.
		createTile: function () {
			return document.createElement('div');
		},
	
		// @section
		// @method getTileSize: Point
		// Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
		getTileSize: function () {
			var s = this.options.tileSize;
			return s instanceof L.Point ? s : new L.Point(s, s);
		},
	
		_updateZIndex: function () {
			if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) {
				this._container.style.zIndex = this.options.zIndex;
			}
		},
	
		_setAutoZIndex: function (compare) {
			// go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
	
			var layers = this.getPane().children,
			    edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
	
			for (var i = 0, len = layers.length, zIndex; i < len; i++) {
	
				zIndex = layers[i].style.zIndex;
	
				if (layers[i] !== this._container && zIndex) {
					edgeZIndex = compare(edgeZIndex, +zIndex);
				}
			}
	
			if (isFinite(edgeZIndex)) {
				this.options.zIndex = edgeZIndex + compare(-1, 1);
				this._updateZIndex();
			}
		},
	
		_updateOpacity: function () {
			if (!this._map) { return; }
	
			// IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
			if (L.Browser.ielt9) { return; }
	
			L.DomUtil.setOpacity(this._container, this.options.opacity);
	
			var now = +new Date(),
			    nextFrame = false,
			    willPrune = false;
	
			for (var key in this._tiles) {
				var tile = this._tiles[key];
				if (!tile.current || !tile.loaded) { continue; }
	
				var fade = Math.min(1, (now - tile.loaded) / 200);
	
				L.DomUtil.setOpacity(tile.el, fade);
				if (fade < 1) {
					nextFrame = true;
				} else {
					if (tile.active) { willPrune = true; }
					tile.active = true;
				}
			}
	
			if (willPrune && !this._noPrune) { this._pruneTiles(); }
	
			if (nextFrame) {
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			}
		},
	
		_initContainer: function () {
			if (this._container) { return; }
	
			this._container = L.DomUtil.create('div', 'leaflet-layer ' + (this.options.className || ''));
			this._updateZIndex();
	
			if (this.options.opacity < 1) {
				this._updateOpacity();
			}
	
			this.getPane().appendChild(this._container);
		},
	
		_updateLevels: function () {
	
			var zoom = this._tileZoom,
			    maxZoom = this.options.maxZoom;
	
			if (zoom === undefined) { return undefined; }
	
			for (var z in this._levels) {
				if (this._levels[z].el.children.length || z === zoom) {
					this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
				} else {
					L.DomUtil.remove(this._levels[z].el);
					this._removeTilesAtZoom(z);
					delete this._levels[z];
				}
			}
	
			var level = this._levels[zoom],
			    map = this._map;
	
			if (!level) {
				level = this._levels[zoom] = {};
	
				level.el = L.DomUtil.create('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
				level.el.style.zIndex = maxZoom;
	
				level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
				level.zoom = zoom;
	
				this._setZoomTransform(level, map.getCenter(), map.getZoom());
	
				// force the browser to consider the newly added element for transition
				L.Util.falseFn(level.el.offsetWidth);
			}
	
			this._level = level;
	
			return level;
		},
	
		_pruneTiles: function () {
			if (!this._map) {
				return;
			}
	
			var key, tile;
	
			var zoom = this._map.getZoom();
			if (zoom > this.options.maxZoom ||
				zoom < this.options.minZoom) {
				this._removeAllTiles();
				return;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				tile.retain = tile.current;
			}
	
			for (key in this._tiles) {
				tile = this._tiles[key];
				if (tile.current && !tile.active) {
					var coords = tile.coords;
					if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
						this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
					}
				}
			}
	
			for (key in this._tiles) {
				if (!this._tiles[key].retain) {
					this._removeTile(key);
				}
			}
		},
	
		_removeTilesAtZoom: function (zoom) {
			for (var key in this._tiles) {
				if (this._tiles[key].coords.z !== zoom) {
					continue;
				}
				this._removeTile(key);
			}
		},
	
		_removeAllTiles: function () {
			for (var key in this._tiles) {
				this._removeTile(key);
			}
		},
	
		_invalidateAll: function () {
			for (var z in this._levels) {
				L.DomUtil.remove(this._levels[z].el);
				delete this._levels[z];
			}
			this._removeAllTiles();
	
			this._tileZoom = null;
		},
	
		_retainParent: function (x, y, z, minZoom) {
			var x2 = Math.floor(x / 2),
			    y2 = Math.floor(y / 2),
			    z2 = z - 1,
			    coords2 = new L.Point(+x2, +y2);
			coords2.z = +z2;
	
			var key = this._tileCoordsToKey(coords2),
			    tile = this._tiles[key];
	
			if (tile && tile.active) {
				tile.retain = true;
				return true;
	
			} else if (tile && tile.loaded) {
				tile.retain = true;
			}
	
			if (z2 > minZoom) {
				return this._retainParent(x2, y2, z2, minZoom);
			}
	
			return false;
		},
	
		_retainChildren: function (x, y, z, maxZoom) {
	
			for (var i = 2 * x; i < 2 * x + 2; i++) {
				for (var j = 2 * y; j < 2 * y + 2; j++) {
	
					var coords = new L.Point(i, j);
					coords.z = z + 1;
	
					var key = this._tileCoordsToKey(coords),
					    tile = this._tiles[key];
	
					if (tile && tile.active) {
						tile.retain = true;
						continue;
	
					} else if (tile && tile.loaded) {
						tile.retain = true;
					}
	
					if (z + 1 < maxZoom) {
						this._retainChildren(i, j, z + 1, maxZoom);
					}
				}
			}
		},
	
		_resetView: function (e) {
			var animating = e && (e.pinch || e.flyTo);
			this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
		},
	
		_animateZoom: function (e) {
			this._setView(e.center, e.zoom, true, e.noUpdate);
		},
	
		_setView: function (center, zoom, noPrune, noUpdate) {
			var tileZoom = Math.round(zoom);
			if ((this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom) ||
			    (this.options.minZoom !== undefined && tileZoom < this.options.minZoom)) {
				tileZoom = undefined;
			}
	
			var tileZoomChanged = this.options.updateWhenZooming && (tileZoom !== this._tileZoom);
	
			if (!noUpdate || tileZoomChanged) {
	
				this._tileZoom = tileZoom;
	
				if (this._abortLoading) {
					this._abortLoading();
				}
	
				this._updateLevels();
				this._resetGrid();
	
				if (tileZoom !== undefined) {
					this._update(center);
				}
	
				if (!noPrune) {
					this._pruneTiles();
				}
	
				// Flag to prevent _updateOpacity from pruning tiles during
				// a zoom anim or a pinch gesture
				this._noPrune = !!noPrune;
			}
	
			this._setZoomTransforms(center, zoom);
		},
	
		_setZoomTransforms: function (center, zoom) {
			for (var i in this._levels) {
				this._setZoomTransform(this._levels[i], center, zoom);
			}
		},
	
		_setZoomTransform: function (level, center, zoom) {
			var scale = this._map.getZoomScale(zoom, level.zoom),
			    translate = level.origin.multiplyBy(scale)
			        .subtract(this._map._getNewPixelOrigin(center, zoom)).round();
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(level.el, translate, scale);
			} else {
				L.DomUtil.setPosition(level.el, translate);
			}
		},
	
		_resetGrid: function () {
			var map = this._map,
			    crs = map.options.crs,
			    tileSize = this._tileSize = this.getTileSize(),
			    tileZoom = this._tileZoom;
	
			var bounds = this._map.getPixelWorldBounds(this._tileZoom);
			if (bounds) {
				this._globalTileRange = this._pxBoundsToTileRange(bounds);
			}
	
			this._wrapX = crs.wrapLng && !this.options.noWrap && [
				Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
				Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
			];
			this._wrapY = crs.wrapLat && !this.options.noWrap && [
				Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
				Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
			];
		},
	
		_onMoveEnd: function () {
			if (!this._map || this._map._animatingZoom) { return; }
	
			this._update();
		},
	
		_getTiledPixelBounds: function (center) {
			var map = this._map,
			    mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(),
			    scale = map.getZoomScale(mapZoom, this._tileZoom),
			    pixelCenter = map.project(center, this._tileZoom).floor(),
			    halfSize = map.getSize().divideBy(scale * 2);
	
			return new L.Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
		},
	
		// Private method to load tiles in the grid's active zoom level according to map bounds
		_update: function (center) {
			var map = this._map;
			if (!map) { return; }
			var zoom = map.getZoom();
	
			if (center === undefined) { center = map.getCenter(); }
			if (this._tileZoom === undefined) { return; }	// if out of minzoom/maxzoom
	
			var pixelBounds = this._getTiledPixelBounds(center),
			    tileRange = this._pxBoundsToTileRange(pixelBounds),
			    tileCenter = tileRange.getCenter(),
			    queue = [],
			    margin = this.options.keepBuffer,
			    noPruneRange = new L.Bounds(tileRange.getBottomLeft().subtract([margin, -margin]),
			                              tileRange.getTopRight().add([margin, -margin]));
	
			for (var key in this._tiles) {
				var c = this._tiles[key].coords;
				if (c.z !== this._tileZoom || !noPruneRange.contains(L.point(c.x, c.y))) {
					this._tiles[key].current = false;
				}
			}
	
			// _update just loads more tiles. If the tile zoom level differs too much
			// from the map's, let _setView reset levels and prune old tiles.
			if (Math.abs(zoom - this._tileZoom) > 1) { this._setView(center, zoom); return; }
	
			// create a queue of coordinates to load tiles from
			for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
				for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
					var coords = new L.Point(i, j);
					coords.z = this._tileZoom;
	
					if (!this._isValidTile(coords)) { continue; }
	
					var tile = this._tiles[this._tileCoordsToKey(coords)];
					if (tile) {
						tile.current = true;
					} else {
						queue.push(coords);
					}
				}
			}
	
			// sort tile queue to load tiles in order of their distance to center
			queue.sort(function (a, b) {
				return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
			});
	
			if (queue.length !== 0) {
				// if it's the first batch of tiles to load
				if (!this._loading) {
					this._loading = true;
					// @event loading: Event
					// Fired when the grid layer starts loading tiles.
					this.fire('loading');
				}
	
				// create DOM fragment to append tiles in one batch
				var fragment = document.createDocumentFragment();
	
				for (i = 0; i < queue.length; i++) {
					this._addTile(queue[i], fragment);
				}
	
				this._level.el.appendChild(fragment);
			}
		},
	
		_isValidTile: function (coords) {
			var crs = this._map.options.crs;
	
			if (!crs.infinite) {
				// don't load tile if it's out of bounds and not wrapped
				var bounds = this._globalTileRange;
				if ((!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x)) ||
				    (!crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y))) { return false; }
			}
	
			if (!this.options.bounds) { return true; }
	
			// don't load tile if it doesn't intersect the bounds in options
			var tileBounds = this._tileCoordsToBounds(coords);
			return L.latLngBounds(this.options.bounds).overlaps(tileBounds);
		},
	
		_keyToBounds: function (key) {
			return this._tileCoordsToBounds(this._keyToTileCoords(key));
		},
	
		// converts tile coordinates to its geographical bounds
		_tileCoordsToBounds: function (coords) {
	
			var map = this._map,
			    tileSize = this.getTileSize(),
	
			    nwPoint = coords.scaleBy(tileSize),
			    sePoint = nwPoint.add(tileSize),
	
			    nw = map.unproject(nwPoint, coords.z),
			    se = map.unproject(sePoint, coords.z),
			    bounds = new L.LatLngBounds(nw, se);
	
			if (!this.options.noWrap) {
				map.wrapLatLngBounds(bounds);
			}
	
			return bounds;
		},
	
		// converts tile coordinates to key for the tile cache
		_tileCoordsToKey: function (coords) {
			return coords.x + ':' + coords.y + ':' + coords.z;
		},
	
		// converts tile cache key to coordinates
		_keyToTileCoords: function (key) {
			var k = key.split(':'),
			    coords = new L.Point(+k[0], +k[1]);
			coords.z = +k[2];
			return coords;
		},
	
		_removeTile: function (key) {
			var tile = this._tiles[key];
			if (!tile) { return; }
	
			L.DomUtil.remove(tile.el);
	
			delete this._tiles[key];
	
			// @event tileunload: TileEvent
			// Fired when a tile is removed (e.g. when a tile goes off the screen).
			this.fire('tileunload', {
				tile: tile.el,
				coords: this._keyToTileCoords(key)
			});
		},
	
		_initTile: function (tile) {
			L.DomUtil.addClass(tile, 'leaflet-tile');
	
			var tileSize = this.getTileSize();
			tile.style.width = tileSize.x + 'px';
			tile.style.height = tileSize.y + 'px';
	
			tile.onselectstart = L.Util.falseFn;
			tile.onmousemove = L.Util.falseFn;
	
			// update opacity on tiles in IE7-8 because of filter inheritance problems
			if (L.Browser.ielt9 && this.options.opacity < 1) {
				L.DomUtil.setOpacity(tile, this.options.opacity);
			}
	
			// without this hack, tiles disappear after zoom on Chrome for Android
			// https://github.com/Leaflet/Leaflet/issues/2078
			if (L.Browser.android && !L.Browser.android23) {
				tile.style.WebkitBackfaceVisibility = 'hidden';
			}
		},
	
		_addTile: function (coords, container) {
			var tilePos = this._getTilePos(coords),
			    key = this._tileCoordsToKey(coords);
	
			var tile = this.createTile(this._wrapCoords(coords), L.bind(this._tileReady, this, coords));
	
			this._initTile(tile);
	
			// if createTile is defined with a second argument ("done" callback),
			// we know that tile is async and will be ready later; otherwise
			if (this.createTile.length < 2) {
				// mark tile as ready, but delay one frame for opacity animation to happen
				L.Util.requestAnimFrame(L.bind(this._tileReady, this, coords, null, tile));
			}
	
			L.DomUtil.setPosition(tile, tilePos);
	
			// save tile in cache
			this._tiles[key] = {
				el: tile,
				coords: coords,
				current: true
			};
	
			container.appendChild(tile);
			// @event tileloadstart: TileEvent
			// Fired when a tile is requested and starts loading.
			this.fire('tileloadstart', {
				tile: tile,
				coords: coords
			});
		},
	
		_tileReady: function (coords, err, tile) {
			if (!this._map) { return; }
	
			if (err) {
				// @event tileerror: TileErrorEvent
				// Fired when there is an error loading a tile.
				this.fire('tileerror', {
					error: err,
					tile: tile,
					coords: coords
				});
			}
	
			var key = this._tileCoordsToKey(coords);
	
			tile = this._tiles[key];
			if (!tile) { return; }
	
			tile.loaded = +new Date();
			if (this._map._fadeAnimated) {
				L.DomUtil.setOpacity(tile.el, 0);
				L.Util.cancelAnimFrame(this._fadeFrame);
				this._fadeFrame = L.Util.requestAnimFrame(this._updateOpacity, this);
			} else {
				tile.active = true;
				this._pruneTiles();
			}
	
			if (!err) {
				L.DomUtil.addClass(tile.el, 'leaflet-tile-loaded');
	
				// @event tileload: TileEvent
				// Fired when a tile loads.
				this.fire('tileload', {
					tile: tile.el,
					coords: coords
				});
			}
	
			if (this._noTilesToLoad()) {
				this._loading = false;
				// @event load: Event
				// Fired when the grid layer loaded all visible tiles.
				this.fire('load');
	
				if (L.Browser.ielt9 || !this._map._fadeAnimated) {
					L.Util.requestAnimFrame(this._pruneTiles, this);
				} else {
					// Wait a bit more than 0.2 secs (the duration of the tile fade-in)
					// to trigger a pruning.
					setTimeout(L.bind(this._pruneTiles, this), 250);
				}
			}
		},
	
		_getTilePos: function (coords) {
			return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
		},
	
		_wrapCoords: function (coords) {
			var newCoords = new L.Point(
				this._wrapX ? L.Util.wrapNum(coords.x, this._wrapX) : coords.x,
				this._wrapY ? L.Util.wrapNum(coords.y, this._wrapY) : coords.y);
			newCoords.z = coords.z;
			return newCoords;
		},
	
		_pxBoundsToTileRange: function (bounds) {
			var tileSize = this.getTileSize();
			return new L.Bounds(
				bounds.min.unscaleBy(tileSize).floor(),
				bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1]));
		},
	
		_noTilesToLoad: function () {
			for (var key in this._tiles) {
				if (!this._tiles[key].loaded) { return false; }
			}
			return true;
		}
	});
	
	// @factory L.gridLayer(options?: GridLayer options)
	// Creates a new instance of GridLayer with the supplied options.
	L.gridLayer = function (options) {
		return new L.GridLayer(options);
	};
	
	
	
	/*
	 * @class TileLayer
	 * @inherits GridLayer
	 * @aka L.TileLayer
	 * Used to load and display tile layers on the map. Extends `GridLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar'}).addTo(map);
	 * ```
	 *
	 * @section URL template
	 * @example
	 *
	 * A string of the following form:
	 *
	 * ```
	 * 'http://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
	 * ```
	 *
	 * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add @2x to the URL to load retina tiles.
	 *
	 * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
	 *
	 * ```
	 * L.tileLayer('http://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
	 * ```
	 */
	
	
	L.TileLayer = L.GridLayer.extend({
	
		// @section
		// @aka TileLayer options
		options: {
			// @option minZoom: Number = 0
			// Minimum zoom number.
			minZoom: 0,
	
			// @option maxZoom: Number = 18
			// Maximum zoom number.
			maxZoom: 18,
	
			// @option maxNativeZoom: Number = null
			// Maximum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
			// from `maxNativeZoom` level and auto-scaled.
			maxNativeZoom: null,
	
			// @option minNativeZoom: Number = null
			// Minimum zoom number the tile source has available. If it is specified,
			// the tiles on all zoom levels lower than `minNativeZoom` will be loaded
			// from `minNativeZoom` level and auto-scaled.
			minNativeZoom: null,
	
			// @option subdomains: String|String[] = 'abc'
			// Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
			subdomains: 'abc',
	
			// @option errorTileUrl: String = ''
			// URL to the tile image to show in place of the tile that failed to load.
			errorTileUrl: '',
	
			// @option zoomOffset: Number = 0
			// The zoom number used in tile URLs will be offset with this value.
			zoomOffset: 0,
	
			// @option tms: Boolean = false
			// If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
			tms: false,
	
			// @option zoomReverse: Boolean = false
			// If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
			zoomReverse: false,
	
			// @option detectRetina: Boolean = false
			// If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
			detectRetina: false,
	
			// @option crossOrigin: Boolean = false
			// If true, all tiles will have their crossOrigin attribute set to ''. This is needed if you want to access tile pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			options = L.setOptions(this, options);
	
			// detecting retina displays, adjusting tileSize and zoom levels
			if (options.detectRetina && L.Browser.retina && options.maxZoom > 0) {
	
				options.tileSize = Math.floor(options.tileSize / 2);
	
				if (!options.zoomReverse) {
					options.zoomOffset++;
					options.maxZoom--;
				} else {
					options.zoomOffset--;
					options.minZoom++;
				}
	
				options.minZoom = Math.max(0, options.minZoom);
			}
	
			if (typeof options.subdomains === 'string') {
				options.subdomains = options.subdomains.split('');
			}
	
			// for https://github.com/Leaflet/Leaflet/issues/137
			if (!L.Browser.android) {
				this.on('tileunload', this._onTileRemove);
			}
		},
	
		// @method setUrl(url: String, noRedraw?: Boolean): this
		// Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
		setUrl: function (url, noRedraw) {
			this._url = url;
	
			if (!noRedraw) {
				this.redraw();
			}
			return this;
		},
	
		// @method createTile(coords: Object, done?: Function): HTMLElement
		// Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
		// to return an `<img>` HTML element with the appropiate image URL given `coords`. The `done`
		// callback is called when the tile has been loaded.
		createTile: function (coords, done) {
			var tile = document.createElement('img');
	
			L.DomEvent.on(tile, 'load', L.bind(this._tileOnLoad, this, done, tile));
			L.DomEvent.on(tile, 'error', L.bind(this._tileOnError, this, done, tile));
	
			if (this.options.crossOrigin) {
				tile.crossOrigin = '';
			}
	
			/*
			 Alt tag is set to empty string to keep screen readers from reading URL and for compliance reasons
			 http://www.w3.org/TR/WCAG20-TECHS/H67
			*/
			tile.alt = '';
	
			/*
			 Set role="presentation" to force screen readers to ignore this
			 https://www.w3.org/TR/wai-aria/roles#textalternativecomputation
			*/
			tile.setAttribute('role', 'presentation');
	
			tile.src = this.getTileUrl(coords);
	
			return tile;
		},
	
		// @section Extension methods
		// @uninheritable
		// Layers extending `TileLayer` might reimplement the following method.
		// @method getTileUrl(coords: Object): String
		// Called only internally, returns the URL for a tile given its coordinates.
		// Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
		getTileUrl: function (coords) {
			var data = {
				r: L.Browser.retina ? '@2x' : '',
				s: this._getSubdomain(coords),
				x: coords.x,
				y: coords.y,
				z: this._getZoomForUrl()
			};
			if (this._map && !this._map.options.crs.infinite) {
				var invertedY = this._globalTileRange.max.y - coords.y;
				if (this.options.tms) {
					data['y'] = invertedY;
				}
				data['-y'] = invertedY;
			}
	
			return L.Util.template(this._url, L.extend(data, this.options));
		},
	
		_tileOnLoad: function (done, tile) {
			// For https://github.com/Leaflet/Leaflet/issues/3332
			if (L.Browser.ielt9) {
				setTimeout(L.bind(done, this, null, tile), 0);
			} else {
				done(null, tile);
			}
		},
	
		_tileOnError: function (done, tile, e) {
			var errorUrl = this.options.errorTileUrl;
			if (errorUrl && tile.src !== errorUrl) {
				tile.src = errorUrl;
			}
			done(e, tile);
		},
	
		getTileSize: function () {
			var map = this._map,
			tileSize = L.GridLayer.prototype.getTileSize.call(this),
			zoom = this._tileZoom + this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			// decrease tile size when scaling below minNativeZoom
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(minNativeZoom, zoom)).round();
			}
	
			// increase tile size when scaling above maxNativeZoom
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return tileSize.divideBy(map.getZoomScale(maxNativeZoom, zoom)).round();
			}
	
			return tileSize;
		},
	
		_onTileRemove: function (e) {
			e.tile.onload = null;
		},
	
		_getZoomForUrl: function () {
			var zoom = this._tileZoom,
			maxZoom = this.options.maxZoom,
			zoomReverse = this.options.zoomReverse,
			zoomOffset = this.options.zoomOffset,
			minNativeZoom = this.options.minNativeZoom,
			maxNativeZoom = this.options.maxNativeZoom;
	
			if (zoomReverse) {
				zoom = maxZoom - zoom;
			}
	
			zoom += zoomOffset;
	
			if (minNativeZoom !== null && zoom < minNativeZoom) {
				return minNativeZoom;
			}
	
			if (maxNativeZoom !== null && zoom > maxNativeZoom) {
				return maxNativeZoom;
			}
	
			return zoom;
		},
	
		_getSubdomain: function (tilePoint) {
			var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
			return this.options.subdomains[index];
		},
	
		// stops loading all tiles in the background layer
		_abortLoading: function () {
			var i, tile;
			for (i in this._tiles) {
				if (this._tiles[i].coords.z !== this._tileZoom) {
					tile = this._tiles[i].el;
	
					tile.onload = L.Util.falseFn;
					tile.onerror = L.Util.falseFn;
	
					if (!tile.complete) {
						tile.src = L.Util.emptyImageUrl;
						L.DomUtil.remove(tile);
					}
				}
			}
		}
	});
	
	
	// @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
	// Instantiates a tile layer object given a `URL template` and optionally an options object.
	
	L.tileLayer = function (url, options) {
		return new L.TileLayer(url, options);
	};
	
	
	
	/*
	 * @class TileLayer.WMS
	 * @inherits TileLayer
	 * @aka L.TileLayer.WMS
	 * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
	 *
	 * @example
	 *
	 * ```js
	 * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
	 * 	layers: 'nexrad-n0r-900913',
	 * 	format: 'image/png',
	 * 	transparent: true,
	 * 	attribution: "Weather data © 2012 IEM Nexrad"
	 * });
	 * ```
	 */
	
	L.TileLayer.WMS = L.TileLayer.extend({
	
		// @section
		// @aka TileLayer.WMS options
		// If any custom options not documented here are used, they will be sent to the
		// WMS server as extra parameters in each request URL. This can be useful for
		// [non-standard vendor WMS parameters](http://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
		defaultWmsParams: {
			service: 'WMS',
			request: 'GetMap',
	
			// @option layers: String = ''
			// **(required)** Comma-separated list of WMS layers to show.
			layers: '',
	
			// @option styles: String = ''
			// Comma-separated list of WMS styles.
			styles: '',
	
			// @option format: String = 'image/jpeg'
			// WMS image format (use `'image/png'` for layers with transparency).
			format: 'image/jpeg',
	
			// @option transparent: Boolean = false
			// If `true`, the WMS service will return images with transparency.
			transparent: false,
	
			// @option version: String = '1.1.1'
			// Version of the WMS service to use
			version: '1.1.1'
		},
	
		options: {
			// @option crs: CRS = null
			// Coordinate Reference System to use for the WMS requests, defaults to
			// map CRS. Don't change this if you're not sure what it means.
			crs: null,
	
			// @option uppercase: Boolean = false
			// If `true`, WMS request parameter keys will be uppercase.
			uppercase: false
		},
	
		initialize: function (url, options) {
	
			this._url = url;
	
			var wmsParams = L.extend({}, this.defaultWmsParams);
	
			// all keys that are not TileLayer options go to WMS params
			for (var i in options) {
				if (!(i in this.options)) {
					wmsParams[i] = options[i];
				}
			}
	
			options = L.setOptions(this, options);
	
			wmsParams.width = wmsParams.height = options.tileSize * (options.detectRetina && L.Browser.retina ? 2 : 1);
	
			this.wmsParams = wmsParams;
		},
	
		onAdd: function (map) {
	
			this._crs = this.options.crs || map.options.crs;
			this._wmsVersion = parseFloat(this.wmsParams.version);
	
			var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
			this.wmsParams[projectionKey] = this._crs.code;
	
			L.TileLayer.prototype.onAdd.call(this, map);
		},
	
		getTileUrl: function (coords) {
	
			var tileBounds = this._tileCoordsToBounds(coords),
			    nw = this._crs.project(tileBounds.getNorthWest()),
			    se = this._crs.project(tileBounds.getSouthEast()),
	
			    bbox = (this._wmsVersion >= 1.3 && this._crs === L.CRS.EPSG4326 ?
				    [se.y, nw.x, nw.y, se.x] :
				    [nw.x, se.y, se.x, nw.y]).join(','),
	
			    url = L.TileLayer.prototype.getTileUrl.call(this, coords);
	
			return url +
				L.Util.getParamString(this.wmsParams, url, this.options.uppercase) +
				(this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
		},
	
		// @method setParams(params: Object, noRedraw?: Boolean): this
		// Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
		setParams: function (params, noRedraw) {
	
			L.extend(this.wmsParams, params);
	
			if (!noRedraw) {
				this.redraw();
			}
	
			return this;
		}
	});
	
	
	// @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
	// Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
	L.tileLayer.wms = function (url, options) {
		return new L.TileLayer.WMS(url, options);
	};
	
	
	
	/*
	 * @class ImageOverlay
	 * @aka L.ImageOverlay
	 * @inherits Interactive layer
	 *
	 * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * var imageUrl = 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
	 * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
	 * L.imageOverlay(imageUrl, imageBounds).addTo(map);
	 * ```
	 */
	
	L.ImageOverlay = L.Layer.extend({
	
		// @section
		// @aka ImageOverlay options
		options: {
			// @option opacity: Number = 1.0
			// The opacity of the image overlay.
			opacity: 1,
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the image (useful for accessibility).
			alt: '',
	
			// @option interactive: Boolean = false
			// If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
			interactive: false,
	
			// @option crossOrigin: Boolean = false
			// If true, the image will have its crossOrigin attribute set to ''. This is needed if you want to access image pixel data.
			crossOrigin: false
		},
	
		initialize: function (url, bounds, options) { // (String, LatLngBounds, Object)
			this._url = url;
			this._bounds = L.latLngBounds(bounds);
	
			L.setOptions(this, options);
		},
	
		onAdd: function () {
			if (!this._image) {
				this._initImage();
	
				if (this.options.opacity < 1) {
					this._updateOpacity();
				}
			}
	
			if (this.options.interactive) {
				L.DomUtil.addClass(this._image, 'leaflet-interactive');
				this.addInteractiveTarget(this._image);
			}
	
			this.getPane().appendChild(this._image);
			this._reset();
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._image);
			if (this.options.interactive) {
				this.removeInteractiveTarget(this._image);
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Sets the opacity of the overlay.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._image) {
				this._updateOpacity();
			}
			return this;
		},
	
		setStyle: function (styleOpts) {
			if (styleOpts.opacity) {
				this.setOpacity(styleOpts.opacity);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all overlays.
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._image);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all overlays.
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._image);
			}
			return this;
		},
	
		// @method setUrl(url: String): this
		// Changes the URL of the image.
		setUrl: function (url) {
			this._url = url;
	
			if (this._image) {
				this._image.src = url;
			}
			return this;
		},
	
		// @method setBounds(bounds: LatLngBounds): this
		// Update the bounds that this ImageOverlay covers
		setBounds: function (bounds) {
			this._bounds = bounds;
	
			if (this._map) {
				this._reset();
			}
			return this;
		},
	
		getEvents: function () {
			var events = {
				zoom: this._reset,
				viewreset: this._reset
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
	
			return events;
		},
	
		// @method getBounds(): LatLngBounds
		// Get the bounds that this ImageOverlay covers
		getBounds: function () {
			return this._bounds;
		},
	
		// @method getElement(): HTMLElement
		// Get the img element that represents the ImageOverlay on the map
		getElement: function () {
			return this._image;
		},
	
		_initImage: function () {
			var img = this._image = L.DomUtil.create('img',
					'leaflet-image-layer ' + (this._zoomAnimated ? 'leaflet-zoom-animated' : ''));
	
			img.onselectstart = L.Util.falseFn;
			img.onmousemove = L.Util.falseFn;
	
			img.onload = L.bind(this.fire, this, 'load');
	
			if (this.options.crossOrigin) {
				img.crossOrigin = '';
			}
	
			img.src = this._url;
			img.alt = this.options.alt;
		},
	
		_animateZoom: function (e) {
			var scale = this._map.getZoomScale(e.zoom),
			    offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
	
			L.DomUtil.setTransform(this._image, offset, scale);
		},
	
		_reset: function () {
			var image = this._image,
			    bounds = new L.Bounds(
			        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
			        this._map.latLngToLayerPoint(this._bounds.getSouthEast())),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(image, bounds.min);
	
			image.style.width  = size.x + 'px';
			image.style.height = size.y + 'px';
		},
	
		_updateOpacity: function () {
			L.DomUtil.setOpacity(this._image, this.options.opacity);
		}
	});
	
	// @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
	// Instantiates an image overlay object given the URL of the image and the
	// geographical bounds it is tied to.
	L.imageOverlay = function (url, bounds, options) {
		return new L.ImageOverlay(url, bounds, options);
	};
	
	
	
	/*
	 * @class Icon
	 * @aka L.Icon
	 * @inherits Layer
	 *
	 * Represents an icon to provide when creating a marker.
	 *
	 * @example
	 *
	 * ```js
	 * var myIcon = L.icon({
	 *     iconUrl: 'my-icon.png',
	 *     iconRetinaUrl: 'my-icon@2x.png',
	 *     iconSize: [38, 95],
	 *     iconAnchor: [22, 94],
	 *     popupAnchor: [-3, -76],
	 *     shadowUrl: 'my-icon-shadow.png',
	 *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
	 *     shadowSize: [68, 95],
	 *     shadowAnchor: [22, 94]
	 * });
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
	 *
	 */
	
	L.Icon = L.Class.extend({
	
		/* @section
		 * @aka Icon options
		 *
		 * @option iconUrl: String = null
		 * **(required)** The URL to the icon image (absolute or relative to your script path).
		 *
		 * @option iconRetinaUrl: String = null
		 * The URL to a retina sized version of the icon image (absolute or relative to your
		 * script path). Used for Retina screen devices.
		 *
		 * @option iconSize: Point = null
		 * Size of the icon image in pixels.
		 *
		 * @option iconAnchor: Point = null
		 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
		 * will be aligned so that this point is at the marker's geographical location. Centered
		 * by default if size is specified, also can be set in CSS with negative margins.
		 *
		 * @option popupAnchor: Point = null
		 * The coordinates of the point from which popups will "open", relative to the icon anchor.
		 *
		 * @option shadowUrl: String = null
		 * The URL to the icon shadow image. If not specified, no shadow image will be created.
		 *
		 * @option shadowRetinaUrl: String = null
		 *
		 * @option shadowSize: Point = null
		 * Size of the shadow image in pixels.
		 *
		 * @option shadowAnchor: Point = null
		 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
		 * as iconAnchor if not specified).
		 *
		 * @option className: String = ''
		 * A custom class name to assign to both icon and shadow images. Empty by default.
		 */
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		// @method createIcon(oldIcon?: HTMLElement): HTMLElement
		// Called internally when the icon has to be shown, returns a `<img>` HTML element
		// styled according to the options.
		createIcon: function (oldIcon) {
			return this._createIcon('icon', oldIcon);
		},
	
		// @method createShadow(oldIcon?: HTMLElement): HTMLElement
		// As `createIcon`, but for the shadow beneath it.
		createShadow: function (oldIcon) {
			return this._createIcon('shadow', oldIcon);
		},
	
		_createIcon: function (name, oldIcon) {
			var src = this._getIconUrl(name);
	
			if (!src) {
				if (name === 'icon') {
					throw new Error('iconUrl not set in Icon options (see the docs).');
				}
				return null;
			}
	
			var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
			this._setIconStyles(img, name);
	
			return img;
		},
	
		_setIconStyles: function (img, name) {
			var options = this.options;
			var sizeOption = options[name + 'Size'];
	
			if (typeof sizeOption === 'number') {
				sizeOption = [sizeOption, sizeOption];
			}
	
			var size = L.point(sizeOption),
			    anchor = L.point(name === 'shadow' && options.shadowAnchor || options.iconAnchor ||
			            size && size.divideBy(2, true));
	
			img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
	
			if (anchor) {
				img.style.marginLeft = (-anchor.x) + 'px';
				img.style.marginTop  = (-anchor.y) + 'px';
			}
	
			if (size) {
				img.style.width  = size.x + 'px';
				img.style.height = size.y + 'px';
			}
		},
	
		_createImg: function (src, el) {
			el = el || document.createElement('img');
			el.src = src;
			return el;
		},
	
		_getIconUrl: function (name) {
			return L.Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
		}
	});
	
	
	// @factory L.icon(options: Icon options)
	// Creates an icon instance with the given options.
	L.icon = function (options) {
		return new L.Icon(options);
	};
	
	
	
	/*
	 * @miniclass Icon.Default (Icon)
	 * @aka L.Icon.Default
	 * @section
	 *
	 * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
	 * no icon is specified. Points to the blue marker image distributed with Leaflet
	 * releases.
	 *
	 * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
	 * (which is a set of `Icon options`).
	 *
	 * If you want to _completely_ replace the default icon, override the
	 * `L.Marker.prototype.options.icon` with your own icon instead.
	 */
	
	L.Icon.Default = L.Icon.extend({
	
		options: {
			iconUrl:       'marker-icon.png',
			iconRetinaUrl: 'marker-icon-2x.png',
			shadowUrl:     'marker-shadow.png',
			iconSize:    [25, 41],
			iconAnchor:  [12, 41],
			popupAnchor: [1, -34],
			tooltipAnchor: [16, -28],
			shadowSize:  [41, 41]
		},
	
		_getIconUrl: function (name) {
			if (!L.Icon.Default.imagePath) {	// Deprecated, backwards-compatibility only
				L.Icon.Default.imagePath = this._detectIconPath();
			}
	
			// @option imagePath: String
			// `L.Icon.Default` will try to auto-detect the absolute location of the
			// blue icon images. If you are placing these images in a non-standard
			// way, set this option to point to the right absolute path.
			return (this.options.imagePath || L.Icon.Default.imagePath) + L.Icon.prototype._getIconUrl.call(this, name);
		},
	
		_detectIconPath: function () {
			var el = L.DomUtil.create('div',  'leaflet-default-icon-path', document.body);
			var path = L.DomUtil.getStyle(el, 'background-image') ||
			           L.DomUtil.getStyle(el, 'backgroundImage');	// IE8
	
			document.body.removeChild(el);
	
			return path.indexOf('url') === 0 ?
				path.replace(/^url\([\"\']?/, '').replace(/marker-icon\.png[\"\']?\)$/, '') : '';
		}
	});
	
	
	
	/*
	 * @class Marker
	 * @inherits Interactive layer
	 * @aka L.Marker
	 * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.marker([50.5, 30.5]).addTo(map);
	 * ```
	 */
	
	L.Marker = L.Layer.extend({
	
		// @section
		// @aka Marker options
		options: {
			// @option icon: Icon = *
			// Icon class to use for rendering the marker. See [Icon documentation](#L.Icon) for details on how to customize the marker icon. If not specified, a new `L.Icon.Default` is used.
			icon: new L.Icon.Default(),
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true,
	
			// @option draggable: Boolean = false
			// Whether the marker is draggable with mouse/touch or not.
			draggable: false,
	
			// @option keyboard: Boolean = true
			// Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
			keyboard: true,
	
			// @option title: String = ''
			// Text for the browser tooltip that appear on marker hover (no tooltip by default).
			title: '',
	
			// @option alt: String = ''
			// Text for the `alt` attribute of the icon image (useful for accessibility).
			alt: '',
	
			// @option zIndexOffset: Number = 0
			// By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
			zIndexOffset: 0,
	
			// @option opacity: Number = 1.0
			// The opacity of the marker.
			opacity: 1,
	
			// @option riseOnHover: Boolean = false
			// If `true`, the marker will get on top of others when you hover the mouse over it.
			riseOnHover: false,
	
			// @option riseOffset: Number = 250
			// The z-index offset used for the `riseOnHover` feature.
			riseOffset: 250,
	
			// @option pane: String = 'markerPane'
			// `Map pane` where the markers icon will be added.
			pane: 'markerPane',
	
			// FIXME: shadowPane is no longer a valid option
			nonBubblingEvents: ['click', 'dblclick', 'mouseover', 'mouseout', 'contextmenu']
		},
	
		/* @section
		 *
		 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
		 */
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
		},
	
		onAdd: function (map) {
			this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
	
			if (this._zoomAnimated) {
				map.on('zoomanim', this._animateZoom, this);
			}
	
			this._initIcon();
			this.update();
		},
	
		onRemove: function (map) {
			if (this.dragging && this.dragging.enabled()) {
				this.options.draggable = true;
				this.dragging.removeHooks();
			}
	
			if (this._zoomAnimated) {
				map.off('zoomanim', this._animateZoom, this);
			}
	
			this._removeIcon();
			this._removeShadow();
		},
	
		getEvents: function () {
			return {
				zoom: this.update,
				viewreset: this.update
			};
		},
	
		// @method getLatLng: LatLng
		// Returns the current geographical position of the marker.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Changes the marker position to the given point.
		setLatLng: function (latlng) {
			var oldLatLng = this._latlng;
			this._latlng = L.latLng(latlng);
			this.update();
	
			// @event move: Event
			// Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
			return this.fire('move', {oldLatLng: oldLatLng, latlng: this._latlng});
		},
	
		// @method setZIndexOffset(offset: Number): this
		// Changes the [zIndex offset](#marker-zindexoffset) of the marker.
		setZIndexOffset: function (offset) {
			this.options.zIndexOffset = offset;
			return this.update();
		},
	
		// @method setIcon(icon: Icon): this
		// Changes the marker icon.
		setIcon: function (icon) {
	
			this.options.icon = icon;
	
			if (this._map) {
				this._initIcon();
				this.update();
			}
	
			if (this._popup) {
				this.bindPopup(this._popup, this._popup.options);
			}
	
			return this;
		},
	
		getElement: function () {
			return this._icon;
		},
	
		update: function () {
	
			if (this._icon) {
				var pos = this._map.latLngToLayerPoint(this._latlng).round();
				this._setPos(pos);
			}
	
			return this;
		},
	
		_initIcon: function () {
			var options = this.options,
			    classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			var icon = options.icon.createIcon(this._icon),
			    addIcon = false;
	
			// if we're not reusing the icon, remove the old one and init new one
			if (icon !== this._icon) {
				if (this._icon) {
					this._removeIcon();
				}
				addIcon = true;
	
				if (options.title) {
					icon.title = options.title;
				}
				if (options.alt) {
					icon.alt = options.alt;
				}
			}
	
			L.DomUtil.addClass(icon, classToAdd);
	
			if (options.keyboard) {
				icon.tabIndex = '0';
			}
	
			this._icon = icon;
	
			if (options.riseOnHover) {
				this.on({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			var newShadow = options.icon.createShadow(this._shadow),
			    addShadow = false;
	
			if (newShadow !== this._shadow) {
				this._removeShadow();
				addShadow = true;
			}
	
			if (newShadow) {
				L.DomUtil.addClass(newShadow, classToAdd);
				newShadow.alt = '';
			}
			this._shadow = newShadow;
	
	
			if (options.opacity < 1) {
				this._updateOpacity();
			}
	
	
			if (addIcon) {
				this.getPane().appendChild(this._icon);
			}
			this._initInteraction();
			if (newShadow && addShadow) {
				this.getPane('shadowPane').appendChild(this._shadow);
			}
		},
	
		_removeIcon: function () {
			if (this.options.riseOnHover) {
				this.off({
					mouseover: this._bringToFront,
					mouseout: this._resetZIndex
				});
			}
	
			L.DomUtil.remove(this._icon);
			this.removeInteractiveTarget(this._icon);
	
			this._icon = null;
		},
	
		_removeShadow: function () {
			if (this._shadow) {
				L.DomUtil.remove(this._shadow);
			}
			this._shadow = null;
		},
	
		_setPos: function (pos) {
			L.DomUtil.setPosition(this._icon, pos);
	
			if (this._shadow) {
				L.DomUtil.setPosition(this._shadow, pos);
			}
	
			this._zIndex = pos.y + this.options.zIndexOffset;
	
			this._resetZIndex();
		},
	
		_updateZIndex: function (offset) {
			this._icon.style.zIndex = this._zIndex + offset;
		},
	
		_animateZoom: function (opt) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
	
			this._setPos(pos);
		},
	
		_initInteraction: function () {
	
			if (!this.options.interactive) { return; }
	
			L.DomUtil.addClass(this._icon, 'leaflet-interactive');
	
			this.addInteractiveTarget(this._icon);
	
			if (L.Handler.MarkerDrag) {
				var draggable = this.options.draggable;
				if (this.dragging) {
					draggable = this.dragging.enabled();
					this.dragging.disable();
				}
	
				this.dragging = new L.Handler.MarkerDrag(this);
	
				if (draggable) {
					this.dragging.enable();
				}
			}
		},
	
		// @method setOpacity(opacity: Number): this
		// Changes the opacity of the marker.
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
			if (this._map) {
				this._updateOpacity();
			}
	
			return this;
		},
	
		_updateOpacity: function () {
			var opacity = this.options.opacity;
	
			L.DomUtil.setOpacity(this._icon, opacity);
	
			if (this._shadow) {
				L.DomUtil.setOpacity(this._shadow, opacity);
			}
		},
	
		_bringToFront: function () {
			this._updateZIndex(this.options.riseOffset);
		},
	
		_resetZIndex: function () {
			this._updateZIndex(0);
		},
	
		_getPopupAnchor: function () {
			return this.options.icon.options.popupAnchor || [0, 0];
		},
	
		_getTooltipAnchor: function () {
			return this.options.icon.options.tooltipAnchor || [0, 0];
		}
	});
	
	
	// factory L.marker(latlng: LatLng, options? : Marker options)
	
	// @factory L.marker(latlng: LatLng, options? : Marker options)
	// Instantiates a Marker object given a geographical point and optionally an options object.
	L.marker = function (latlng, options) {
		return new L.Marker(latlng, options);
	};
	
	
	
	/*
	 * @class DivIcon
	 * @aka L.DivIcon
	 * @inherits Icon
	 *
	 * Represents a lightweight icon for markers that uses a simple `<div>`
	 * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
	 *
	 * @example
	 * ```js
	 * var myIcon = L.divIcon({className: 'my-div-icon'});
	 * // you can set .my-div-icon styles in CSS
	 *
	 * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
	 * ```
	 *
	 * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
	 */
	
	L.DivIcon = L.Icon.extend({
		options: {
			// @section
			// @aka DivIcon options
			iconSize: [12, 12], // also can be set through CSS
	
			// iconAnchor: (Point),
			// popupAnchor: (Point),
	
			// @option html: String = ''
			// Custom HTML code to put inside the div element, empty by default.
			html: false,
	
			// @option bgPos: Point = [0, 0]
			// Optional relative position of the background, in pixels
			bgPos: null,
	
			className: 'leaflet-div-icon'
		},
	
		createIcon: function (oldIcon) {
			var div = (oldIcon && oldIcon.tagName === 'DIV') ? oldIcon : document.createElement('div'),
			    options = this.options;
	
			div.innerHTML = options.html !== false ? options.html : '';
	
			if (options.bgPos) {
				var bgPos = L.point(options.bgPos);
				div.style.backgroundPosition = (-bgPos.x) + 'px ' + (-bgPos.y) + 'px';
			}
			this._setIconStyles(div, 'icon');
	
			return div;
		},
	
		createShadow: function () {
			return null;
		}
	});
	
	// @factory L.divIcon(options: DivIcon options)
	// Creates a `DivIcon` instance with the given options.
	L.divIcon = function (options) {
		return new L.DivIcon(options);
	};
	
	
	
	/*
	 * @class DivOverlay
	 * @inherits Layer
	 * @aka L.DivOverlay
	 * Base model for L.Popup and L.Tooltip. Inherit from it for custom popup like plugins.
	 */
	
	// @namespace DivOverlay
	L.DivOverlay = L.Layer.extend({
	
		// @section
		// @aka DivOverlay options
		options: {
			// @option offset: Point = Point(0, 7)
			// The offset of the popup position. Useful to control the anchor
			// of the popup when opening it on some overlays.
			offset: [0, 7],
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: '',
	
			// @option pane: String = 'popupPane'
			// `Map pane` where the popup will be added.
			pane: 'popupPane'
		},
	
		initialize: function (options, source) {
			L.setOptions(this, options);
	
			this._source = source;
		},
	
		onAdd: function (map) {
			this._zoomAnimated = map._zoomAnimated;
	
			if (!this._container) {
				this._initLayout();
			}
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
			}
	
			clearTimeout(this._removeTimeout);
			this.getPane().appendChild(this._container);
			this.update();
	
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 1);
			}
	
			this.bringToFront();
		},
	
		onRemove: function (map) {
			if (map._fadeAnimated) {
				L.DomUtil.setOpacity(this._container, 0);
				this._removeTimeout = setTimeout(L.bind(L.DomUtil.remove, L.DomUtil, this._container), 200);
			} else {
				L.DomUtil.remove(this._container);
			}
		},
	
		// @namespace Popup
		// @method getLatLng: LatLng
		// Returns the geographical point of popup.
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setLatLng(latlng: LatLng): this
		// Sets the geographical point where the popup will open.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			if (this._map) {
				this._updatePosition();
				this._adjustPan();
			}
			return this;
		},
	
		// @method getContent: String|HTMLElement
		// Returns the content of the popup.
		getContent: function () {
			return this._content;
		},
	
		// @method setContent(htmlContent: String|HTMLElement|Function): this
		// Sets the HTML content of the popup. If a function is passed the source layer will be passed to the function. The function should return a `String` or `HTMLElement` to be used in the popup.
		setContent: function (content) {
			this._content = content;
			this.update();
			return this;
		},
	
		// @method getElement: String|HTMLElement
		// Alias for [getContent()](#popup-getcontent)
		getElement: function () {
			return this._container;
		},
	
		// @method update: null
		// Updates the popup content, layout and position. Useful for updating the popup after something inside changed, e.g. image loaded.
		update: function () {
			if (!this._map) { return; }
	
			this._container.style.visibility = 'hidden';
	
			this._updateContent();
			this._updateLayout();
			this._updatePosition();
	
			this._container.style.visibility = '';
	
			this._adjustPan();
		},
	
		getEvents: function () {
			var events = {
				zoom: this._updatePosition,
				viewreset: this._updatePosition
			};
	
			if (this._zoomAnimated) {
				events.zoomanim = this._animateZoom;
			}
			return events;
		},
	
		// @method isOpen: Boolean
		// Returns `true` when the popup is visible on the map.
		isOpen: function () {
			return !!this._map && this._map.hasLayer(this);
		},
	
		// @method bringToFront: this
		// Brings this popup in front of other popups (in the same map pane).
		bringToFront: function () {
			if (this._map) {
				L.DomUtil.toFront(this._container);
			}
			return this;
		},
	
		// @method bringToBack: this
		// Brings this popup to the back of other popups (in the same map pane).
		bringToBack: function () {
			if (this._map) {
				L.DomUtil.toBack(this._container);
			}
			return this;
		},
	
		_updateContent: function () {
			if (!this._content) { return; }
	
			var node = this._contentNode;
			var content = (typeof this._content === 'function') ? this._content(this._source || this) : this._content;
	
			if (typeof content === 'string') {
				node.innerHTML = content;
			} else {
				while (node.hasChildNodes()) {
					node.removeChild(node.firstChild);
				}
				node.appendChild(content);
			}
			this.fire('contentupdate');
		},
	
		_updatePosition: function () {
			if (!this._map) { return; }
	
			var pos = this._map.latLngToLayerPoint(this._latlng),
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (this._zoomAnimated) {
				L.DomUtil.setPosition(this._container, pos.add(anchor));
			} else {
				offset = offset.add(pos).add(anchor);
			}
	
			var bottom = this._containerBottom = -offset.y,
			    left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
	
			// bottom position the popup in case the height of the popup changes (images loading etc)
			this._container.style.bottom = bottom + 'px';
			this._container.style.left = left + 'px';
		},
	
		_getAnchor: function () {
			return [0, 0];
		}
	
	});
	
	
	
	/*
	 * @class Popup
	 * @inherits DivOverlay
	 * @aka L.Popup
	 * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
	 * open popups while making sure that only one popup is open at one time
	 * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
	 *
	 * @example
	 *
	 * If you want to just bind a popup to marker click and then open it, it's really easy:
	 *
	 * ```js
	 * marker.bindPopup(popupContent).openPopup();
	 * ```
	 * Path overlays like polylines also have a `bindPopup` method.
	 * Here's a more complicated way to open a popup on a map:
	 *
	 * ```js
	 * var popup = L.popup()
	 * 	.setLatLng(latlng)
	 * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
	 * 	.openOn(map);
	 * ```
	 */
	
	
	// @namespace Popup
	L.Popup = L.DivOverlay.extend({
	
		// @section
		// @aka Popup options
		options: {
			// @option maxWidth: Number = 300
			// Max width of the popup, in pixels.
			maxWidth: 300,
	
			// @option minWidth: Number = 50
			// Min width of the popup, in pixels.
			minWidth: 50,
	
			// @option maxHeight: Number = null
			// If set, creates a scrollable container of the given height
			// inside a popup if its content exceeds it.
			maxHeight: null,
	
			// @option autoPan: Boolean = true
			// Set it to `false` if you don't want the map to do panning animation
			// to fit the opened popup.
			autoPan: true,
	
			// @option autoPanPaddingTopLeft: Point = null
			// The margin between the popup and the top left corner of the map
			// view after autopanning was performed.
			autoPanPaddingTopLeft: null,
	
			// @option autoPanPaddingBottomRight: Point = null
			// The margin between the popup and the bottom right corner of the map
			// view after autopanning was performed.
			autoPanPaddingBottomRight: null,
	
			// @option autoPanPadding: Point = Point(5, 5)
			// Equivalent of setting both top left and bottom right autopan padding to the same value.
			autoPanPadding: [5, 5],
	
			// @option keepInView: Boolean = false
			// Set it to `true` if you want to prevent users from panning the popup
			// off of the screen while it is open.
			keepInView: false,
	
			// @option closeButton: Boolean = true
			// Controls the presence of a close button in the popup.
			closeButton: true,
	
			// @option autoClose: Boolean = true
			// Set it to `false` if you want to override the default behavior of
			// the popup closing when user clicks the map (set globally by
			// the Map's [closePopupOnClick](#map-closepopuponclick) option).
			autoClose: true,
	
			// @option className: String = ''
			// A custom CSS class name to assign to the popup.
			className: ''
		},
	
		// @namespace Popup
		// @method openOn(map: Map): this
		// Adds the popup to the map and closes the previous one. The same as `map.openPopup(popup)`.
		openOn: function (map) {
			map.openPopup(this);
			return this;
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupopen: PopupEvent
			// Fired when a popup is opened in the map
			map.fire('popupopen', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupopen: PopupEvent
				// Fired when a popup bound to this layer is opened
				this._source.fire('popupopen', {popup: this}, true);
				// For non-path layers, we toggle the popup when clicking
				// again the layer, so prevent the map to reopen it.
				if (!(this._source instanceof L.Path)) {
					this._source.on('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Popup events
			// @event popupclose: PopupEvent
			// Fired when a popup in the map is closed
			map.fire('popupclose', {popup: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Popup events
				// @event popupclose: PopupEvent
				// Fired when a popup bound to this layer is closed
				this._source.fire('popupclose', {popup: this}, true);
				if (!(this._source instanceof L.Path)) {
					this._source.off('preclick', L.DomEvent.stopPropagation);
				}
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if ('closeOnClick' in this.options ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
				events.preclick = this._close;
			}
	
			if (this.options.keepInView) {
				events.moveend = this._adjustPan;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closePopup(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-popup',
			    container = this._container = L.DomUtil.create('div',
				prefix + ' ' + (this.options.className || '') +
				' leaflet-zoom-animated');
	
			if (this.options.closeButton) {
				var closeButton = this._closeButton = L.DomUtil.create('a', prefix + '-close-button', container);
				closeButton.href = '#close';
				closeButton.innerHTML = '&#215;';
	
				L.DomEvent.on(closeButton, 'click', this._onCloseButtonClick, this);
			}
	
			var wrapper = this._wrapper = L.DomUtil.create('div', prefix + '-content-wrapper', container);
			this._contentNode = L.DomUtil.create('div', prefix + '-content', wrapper);
	
			L.DomEvent
				.disableClickPropagation(wrapper)
				.disableScrollPropagation(this._contentNode)
				.on(wrapper, 'contextmenu', L.DomEvent.stopPropagation);
	
			this._tipContainer = L.DomUtil.create('div', prefix + '-tip-container', container);
			this._tip = L.DomUtil.create('div', prefix + '-tip', this._tipContainer);
		},
	
		_updateLayout: function () {
			var container = this._contentNode,
			    style = container.style;
	
			style.width = '';
			style.whiteSpace = 'nowrap';
	
			var width = container.offsetWidth;
			width = Math.min(width, this.options.maxWidth);
			width = Math.max(width, this.options.minWidth);
	
			style.width = (width + 1) + 'px';
			style.whiteSpace = '';
	
			style.height = '';
	
			var height = container.offsetHeight,
			    maxHeight = this.options.maxHeight,
			    scrolledClass = 'leaflet-popup-scrolled';
	
			if (maxHeight && height > maxHeight) {
				style.height = maxHeight + 'px';
				L.DomUtil.addClass(container, scrolledClass);
			} else {
				L.DomUtil.removeClass(container, scrolledClass);
			}
	
			this._containerWidth = this._container.offsetWidth;
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
			    anchor = this._getAnchor();
			L.DomUtil.setPosition(this._container, pos.add(anchor));
		},
	
		_adjustPan: function () {
			if (!this.options.autoPan || (this._map._panAnim && this._map._panAnim._inProgress)) { return; }
	
			var map = this._map,
			    marginBottom = parseInt(L.DomUtil.getStyle(this._container, 'marginBottom'), 10) || 0,
			    containerHeight = this._container.offsetHeight + marginBottom,
			    containerWidth = this._containerWidth,
			    layerPos = new L.Point(this._containerLeft, -containerHeight - this._containerBottom);
	
			layerPos._add(L.DomUtil.getPosition(this._container));
	
			var containerPos = map.layerPointToContainerPoint(layerPos),
			    padding = L.point(this.options.autoPanPadding),
			    paddingTL = L.point(this.options.autoPanPaddingTopLeft || padding),
			    paddingBR = L.point(this.options.autoPanPaddingBottomRight || padding),
			    size = map.getSize(),
			    dx = 0,
			    dy = 0;
	
			if (containerPos.x + containerWidth + paddingBR.x > size.x) { // right
				dx = containerPos.x + containerWidth - size.x + paddingBR.x;
			}
			if (containerPos.x - dx - paddingTL.x < 0) { // left
				dx = containerPos.x - paddingTL.x;
			}
			if (containerPos.y + containerHeight + paddingBR.y > size.y) { // bottom
				dy = containerPos.y + containerHeight - size.y + paddingBR.y;
			}
			if (containerPos.y - dy - paddingTL.y < 0) { // top
				dy = containerPos.y - paddingTL.y;
			}
	
			// @namespace Map
			// @section Popup events
			// @event autopanstart: Event
			// Fired when the map starts autopanning when opening a popup.
			if (dx || dy) {
				map
				    .fire('autopanstart')
				    .panBy([dx, dy]);
			}
		},
	
		_onCloseButtonClick: function (e) {
			this._close();
			L.DomEvent.stop(e);
		},
	
		_getAnchor: function () {
			// Where should we anchor the popup on the source layer?
			return L.point(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Popup
	// @factory L.popup(options?: Popup options, source?: Layer)
	// Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
	L.popup = function (options, source) {
		return new L.Popup(options, source);
	};
	
	
	/* @namespace Map
	 * @section Interaction Options
	 * @option closePopupOnClick: Boolean = true
	 * Set it to `false` if you don't want popups to close when user clicks the map.
	 */
	L.Map.mergeOptions({
		closePopupOnClick: true
	});
	
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
		// @method openPopup(popup: Popup): this
		// Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
		// @alternative
		// @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
		// Creates a popup with the specified content and options and opens it in the given point on a map.
		openPopup: function (popup, latlng, options) {
			if (!(popup instanceof L.Popup)) {
				popup = new L.Popup(options).setContent(popup);
			}
	
			if (latlng) {
				popup.setLatLng(latlng);
			}
	
			if (this.hasLayer(popup)) {
				return this;
			}
	
			if (this._popup && this._popup.options.autoClose) {
				this.closePopup();
			}
	
			this._popup = popup;
			return this.addLayer(popup);
		},
	
		// @method closePopup(popup?: Popup): this
		// Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
		closePopup: function (popup) {
			if (!popup || popup === this._popup) {
				popup = this._popup;
				this._popup = null;
			}
			if (popup) {
				this.removeLayer(popup);
			}
			return this;
		}
	});
	
	/*
	 * @namespace Layer
	 * @section Popup methods example
	 *
	 * All layers share a set of methods convenient for binding popups to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
	 * layer.openPopup();
	 * layer.closePopup();
	 * ```
	 *
	 * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
	 */
	
	// @section Popup methods
	L.Layer.include({
	
		// @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
		// Binds a popup to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindPopup: function (content, options) {
	
			if (content instanceof L.Popup) {
				L.setOptions(content, options);
				this._popup = content;
				content._source = this;
			} else {
				if (!this._popup || options) {
					this._popup = new L.Popup(options, this);
				}
				this._popup.setContent(content);
			}
	
			if (!this._popupHandlersAdded) {
				this.on({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = true;
			}
	
			return this;
		},
	
		// @method unbindPopup(): this
		// Removes the popup previously bound with `bindPopup`.
		unbindPopup: function () {
			if (this._popup) {
				this.off({
					click: this._openPopup,
					remove: this.closePopup,
					move: this._movePopup
				});
				this._popupHandlersAdded = false;
				this._popup = null;
			}
			return this;
		},
	
		// @method openPopup(latlng?: LatLng): this
		// Opens the bound popup at the specificed `latlng` or at the default popup anchor if no `latlng` is passed.
		openPopup: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._popup && this._map) {
				// set popup source to this layer
				this._popup._source = layer;
	
				// update the popup (content, layout, ect...)
				this._popup.update();
	
				// open the popup on the map
				this._map.openPopup(this._popup, latlng);
			}
	
			return this;
		},
	
		// @method closePopup(): this
		// Closes the popup bound to this layer if it is open.
		closePopup: function () {
			if (this._popup) {
				this._popup._close();
			}
			return this;
		},
	
		// @method togglePopup(): this
		// Opens or closes the popup bound to this layer depending on its current state.
		togglePopup: function (target) {
			if (this._popup) {
				if (this._popup._map) {
					this.closePopup();
				} else {
					this.openPopup(target);
				}
			}
			return this;
		},
	
		// @method isPopupOpen(): boolean
		// Returns `true` if the popup bound to this layer is currently open.
		isPopupOpen: function () {
			return (this._popup ? this._popup.isOpen() : false);
		},
	
		// @method setPopupContent(content: String|HTMLElement|Popup): this
		// Sets the content of the popup bound to this layer.
		setPopupContent: function (content) {
			if (this._popup) {
				this._popup.setContent(content);
			}
			return this;
		},
	
		// @method getPopup(): Popup
		// Returns the popup bound to this layer.
		getPopup: function () {
			return this._popup;
		},
	
		_openPopup: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._popup) {
				return;
			}
	
			if (!this._map) {
				return;
			}
	
			// prevent map click
			L.DomEvent.stop(e);
	
			// if this inherits from Path its a vector and we can just
			// open the popup at the new location
			if (layer instanceof L.Path) {
				this.openPopup(e.layer || e.target, e.latlng);
				return;
			}
	
			// otherwise treat it like a marker and figure out
			// if we should toggle it open/closed
			if (this._map.hasLayer(this._popup) && this._popup._source === layer) {
				this.closePopup();
			} else {
				this.openPopup(layer, e.latlng);
			}
		},
	
		_movePopup: function (e) {
			this._popup.setLatLng(e.latlng);
		}
	});
	
	
	
	/*
	 * @class Tooltip
	 * @inherits DivOverlay
	 * @aka L.Tooltip
	 * Used to display small texts on top of map layers.
	 *
	 * @example
	 *
	 * ```js
	 * marker.bindTooltip("my tooltip text").openTooltip();
	 * ```
	 * Note about tooltip offset. Leaflet takes two options in consideration
	 * for computing tooltip offseting:
	 * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
	 *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
	 *   move it to the bottom. Negatives will move to the left and top.
	 * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
	 *   should adapt this value if you use a custom icon.
	 */
	
	
	// @namespace Tooltip
	L.Tooltip = L.DivOverlay.extend({
	
		// @section
		// @aka Tooltip options
		options: {
			// @option pane: String = 'tooltipPane'
			// `Map pane` where the tooltip will be added.
			pane: 'tooltipPane',
	
			// @option offset: Point = Point(0, 0)
			// Optional offset of the tooltip position.
			offset: [0, 0],
	
			// @option direction: String = 'auto'
			// Direction where to open the tooltip. Possible values are: `right`, `left`,
			// `top`, `bottom`, `center`, `auto`.
			// `auto` will dynamicaly switch between `right` and `left` according to the tooltip
			// position on the map.
			direction: 'auto',
	
			// @option permanent: Boolean = false
			// Whether to open the tooltip permanently or only on mouseover.
			permanent: false,
	
			// @option sticky: Boolean = false
			// If true, the tooltip will follow the mouse instead of being fixed at the feature center.
			sticky: false,
	
			// @option interactive: Boolean = false
			// If true, the tooltip will listen to the feature events.
			interactive: false,
	
			// @option opacity: Number = 0.9
			// Tooltip container opacity.
			opacity: 0.9
		},
	
		onAdd: function (map) {
			L.DivOverlay.prototype.onAdd.call(this, map);
			this.setOpacity(this.options.opacity);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipopen: TooltipEvent
			// Fired when a tooltip is opened in the map.
			map.fire('tooltipopen', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipopen: TooltipEvent
				// Fired when a tooltip bound to this layer is opened.
				this._source.fire('tooltipopen', {tooltip: this}, true);
			}
		},
	
		onRemove: function (map) {
			L.DivOverlay.prototype.onRemove.call(this, map);
	
			// @namespace Map
			// @section Tooltip events
			// @event tooltipclose: TooltipEvent
			// Fired when a tooltip in the map is closed.
			map.fire('tooltipclose', {tooltip: this});
	
			if (this._source) {
				// @namespace Layer
				// @section Tooltip events
				// @event tooltipclose: TooltipEvent
				// Fired when a tooltip bound to this layer is closed.
				this._source.fire('tooltipclose', {tooltip: this}, true);
			}
		},
	
		getEvents: function () {
			var events = L.DivOverlay.prototype.getEvents.call(this);
	
			if (L.Browser.touch && !this.options.permanent) {
				events.preclick = this._close;
			}
	
			return events;
		},
	
		_close: function () {
			if (this._map) {
				this._map.closeTooltip(this);
			}
		},
	
		_initLayout: function () {
			var prefix = 'leaflet-tooltip',
			    className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
	
			this._contentNode = this._container = L.DomUtil.create('div', className);
		},
	
		_updateLayout: function () {},
	
		_adjustPan: function () {},
	
		_setPosition: function (pos) {
			var map = this._map,
			    container = this._container,
			    centerPoint = map.latLngToContainerPoint(map.getCenter()),
			    tooltipPoint = map.layerPointToContainerPoint(pos),
			    direction = this.options.direction,
			    tooltipWidth = container.offsetWidth,
			    tooltipHeight = container.offsetHeight,
			    offset = L.point(this.options.offset),
			    anchor = this._getAnchor();
	
			if (direction === 'top') {
				pos = pos.add(L.point(-tooltipWidth / 2 + offset.x, -tooltipHeight + offset.y + anchor.y, true));
			} else if (direction === 'bottom') {
				pos = pos.subtract(L.point(tooltipWidth / 2 - offset.x, -offset.y, true));
			} else if (direction === 'center') {
				pos = pos.subtract(L.point(tooltipWidth / 2 + offset.x, tooltipHeight / 2 - anchor.y + offset.y, true));
			} else if (direction === 'right' || direction === 'auto' && tooltipPoint.x < centerPoint.x) {
				direction = 'right';
				pos = pos.add(L.point(offset.x + anchor.x, anchor.y - tooltipHeight / 2 + offset.y, true));
			} else {
				direction = 'left';
				pos = pos.subtract(L.point(tooltipWidth + anchor.x - offset.x, tooltipHeight / 2 - anchor.y - offset.y, true));
			}
	
			L.DomUtil.removeClass(container, 'leaflet-tooltip-right');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-left');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-top');
			L.DomUtil.removeClass(container, 'leaflet-tooltip-bottom');
			L.DomUtil.addClass(container, 'leaflet-tooltip-' + direction);
			L.DomUtil.setPosition(container, pos);
		},
	
		_updatePosition: function () {
			var pos = this._map.latLngToLayerPoint(this._latlng);
			this._setPosition(pos);
		},
	
		setOpacity: function (opacity) {
			this.options.opacity = opacity;
	
			if (this._container) {
				L.DomUtil.setOpacity(this._container, opacity);
			}
		},
	
		_animateZoom: function (e) {
			var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
			this._setPosition(pos);
		},
	
		_getAnchor: function () {
			// Where should we anchor the tooltip on the source layer?
			return L.point(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
		}
	
	});
	
	// @namespace Tooltip
	// @factory L.tooltip(options?: Tooltip options, source?: Layer)
	// Instantiates a Tooltip object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
	L.tooltip = function (options, source) {
		return new L.Tooltip(options, source);
	};
	
	// @namespace Map
	// @section Methods for Layers and Controls
	L.Map.include({
	
		// @method openTooltip(tooltip: Tooltip): this
		// Opens the specified tooltip.
		// @alternative
		// @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
		// Creates a tooltip with the specified content and options and open it.
		openTooltip: function (tooltip, latlng, options) {
			if (!(tooltip instanceof L.Tooltip)) {
				tooltip = new L.Tooltip(options).setContent(tooltip);
			}
	
			if (latlng) {
				tooltip.setLatLng(latlng);
			}
	
			if (this.hasLayer(tooltip)) {
				return this;
			}
	
			return this.addLayer(tooltip);
		},
	
		// @method closeTooltip(tooltip?: Tooltip): this
		// Closes the tooltip given as parameter.
		closeTooltip: function (tooltip) {
			if (tooltip) {
				this.removeLayer(tooltip);
			}
			return this;
		}
	
	});
	
	/*
	 * @namespace Layer
	 * @section Tooltip methods example
	 *
	 * All layers share a set of methods convenient for binding tooltips to it.
	 *
	 * ```js
	 * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
	 * layer.openTooltip();
	 * layer.closeTooltip();
	 * ```
	 */
	
	// @section Tooltip methods
	L.Layer.include({
	
		// @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
		// Binds a tooltip to the layer with the passed `content` and sets up the
		// neccessary event listeners. If a `Function` is passed it will receive
		// the layer as the first argument and should return a `String` or `HTMLElement`.
		bindTooltip: function (content, options) {
	
			if (content instanceof L.Tooltip) {
				L.setOptions(content, options);
				this._tooltip = content;
				content._source = this;
			} else {
				if (!this._tooltip || options) {
					this._tooltip = L.tooltip(options, this);
				}
				this._tooltip.setContent(content);
	
			}
	
			this._initTooltipInteractions();
	
			if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
				this.openTooltip();
			}
	
			return this;
		},
	
		// @method unbindTooltip(): this
		// Removes the tooltip previously bound with `bindTooltip`.
		unbindTooltip: function () {
			if (this._tooltip) {
				this._initTooltipInteractions(true);
				this.closeTooltip();
				this._tooltip = null;
			}
			return this;
		},
	
		_initTooltipInteractions: function (remove) {
			if (!remove && this._tooltipHandlersAdded) { return; }
			var onOff = remove ? 'off' : 'on',
			    events = {
				remove: this.closeTooltip,
				move: this._moveTooltip
			    };
			if (!this._tooltip.options.permanent) {
				events.mouseover = this._openTooltip;
				events.mouseout = this.closeTooltip;
				if (this._tooltip.options.sticky) {
					events.mousemove = this._moveTooltip;
				}
				if (L.Browser.touch) {
					events.click = this._openTooltip;
				}
			} else {
				events.add = this._openTooltip;
			}
			this[onOff](events);
			this._tooltipHandlersAdded = !remove;
		},
	
		// @method openTooltip(latlng?: LatLng): this
		// Opens the bound tooltip at the specificed `latlng` or at the default tooltip anchor if no `latlng` is passed.
		openTooltip: function (layer, latlng) {
			if (!(layer instanceof L.Layer)) {
				latlng = layer;
				layer = this;
			}
	
			if (layer instanceof L.FeatureGroup) {
				for (var id in this._layers) {
					layer = this._layers[id];
					break;
				}
			}
	
			if (!latlng) {
				latlng = layer.getCenter ? layer.getCenter() : layer.getLatLng();
			}
	
			if (this._tooltip && this._map) {
	
				// set tooltip source to this layer
				this._tooltip._source = layer;
	
				// update the tooltip (content, layout, ect...)
				this._tooltip.update();
	
				// open the tooltip on the map
				this._map.openTooltip(this._tooltip, latlng);
	
				// Tooltip container may not be defined if not permanent and never
				// opened.
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.addClass(this._tooltip._container, 'leaflet-clickable');
					this.addInteractiveTarget(this._tooltip._container);
				}
			}
	
			return this;
		},
	
		// @method closeTooltip(): this
		// Closes the tooltip bound to this layer if it is open.
		closeTooltip: function () {
			if (this._tooltip) {
				this._tooltip._close();
				if (this._tooltip.options.interactive && this._tooltip._container) {
					L.DomUtil.removeClass(this._tooltip._container, 'leaflet-clickable');
					this.removeInteractiveTarget(this._tooltip._container);
				}
			}
			return this;
		},
	
		// @method toggleTooltip(): this
		// Opens or closes the tooltip bound to this layer depending on its current state.
		toggleTooltip: function (target) {
			if (this._tooltip) {
				if (this._tooltip._map) {
					this.closeTooltip();
				} else {
					this.openTooltip(target);
				}
			}
			return this;
		},
	
		// @method isTooltipOpen(): boolean
		// Returns `true` if the tooltip bound to this layer is currently open.
		isTooltipOpen: function () {
			return this._tooltip.isOpen();
		},
	
		// @method setTooltipContent(content: String|HTMLElement|Tooltip): this
		// Sets the content of the tooltip bound to this layer.
		setTooltipContent: function (content) {
			if (this._tooltip) {
				this._tooltip.setContent(content);
			}
			return this;
		},
	
		// @method getTooltip(): Tooltip
		// Returns the tooltip bound to this layer.
		getTooltip: function () {
			return this._tooltip;
		},
	
		_openTooltip: function (e) {
			var layer = e.layer || e.target;
	
			if (!this._tooltip || !this._map) {
				return;
			}
			this.openTooltip(layer, this._tooltip.options.sticky ? e.latlng : undefined);
		},
	
		_moveTooltip: function (e) {
			var latlng = e.latlng, containerPoint, layerPoint;
			if (this._tooltip.options.sticky && e.originalEvent) {
				containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
				layerPoint = this._map.containerPointToLayerPoint(containerPoint);
				latlng = this._map.layerPointToLatLng(layerPoint);
			}
			this._tooltip.setLatLng(latlng);
		}
	});
	
	
	
	/*
	 * @class LayerGroup
	 * @aka L.LayerGroup
	 * @inherits Layer
	 *
	 * Used to group several layers and handle them as one. If you add it to the map,
	 * any layers added or removed from the group will be added/removed on the map as
	 * well. Extends `Layer`.
	 *
	 * @example
	 *
	 * ```js
	 * L.layerGroup([marker1, marker2])
	 * 	.addLayer(polyline)
	 * 	.addTo(map);
	 * ```
	 */
	
	L.LayerGroup = L.Layer.extend({
	
		initialize: function (layers) {
			this._layers = {};
	
			var i, len;
	
			if (layers) {
				for (i = 0, len = layers.length; i < len; i++) {
					this.addLayer(layers[i]);
				}
			}
		},
	
		// @method addLayer(layer: Layer): this
		// Adds the given layer to the group.
		addLayer: function (layer) {
			var id = this.getLayerId(layer);
	
			this._layers[id] = layer;
	
			if (this._map) {
				this._map.addLayer(layer);
			}
	
			return this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Removes the given layer from the group.
		// @alternative
		// @method removeLayer(id: Number): this
		// Removes the layer with the given internal ID from the group.
		removeLayer: function (layer) {
			var id = layer in this._layers ? layer : this.getLayerId(layer);
	
			if (this._map && this._layers[id]) {
				this._map.removeLayer(this._layers[id]);
			}
	
			delete this._layers[id];
	
			return this;
		},
	
		// @method hasLayer(layer: Layer): Boolean
		// Returns `true` if the given layer is currently added to the group.
		hasLayer: function (layer) {
			return !!layer && (layer in this._layers || this.getLayerId(layer) in this._layers);
		},
	
		// @method clearLayers(): this
		// Removes all the layers from the group.
		clearLayers: function () {
			for (var i in this._layers) {
				this.removeLayer(this._layers[i]);
			}
			return this;
		},
	
		// @method invoke(methodName: String, …): this
		// Calls `methodName` on every layer contained in this group, passing any
		// additional parameters. Has no effect if the layers contained do not
		// implement `methodName`.
		invoke: function (methodName) {
			var args = Array.prototype.slice.call(arguments, 1),
			    i, layer;
	
			for (i in this._layers) {
				layer = this._layers[i];
	
				if (layer[methodName]) {
					layer[methodName].apply(layer, args);
				}
			}
	
			return this;
		},
	
		onAdd: function (map) {
			for (var i in this._layers) {
				map.addLayer(this._layers[i]);
			}
		},
	
		onRemove: function (map) {
			for (var i in this._layers) {
				map.removeLayer(this._layers[i]);
			}
		},
	
		// @method eachLayer(fn: Function, context?: Object): this
		// Iterates over the layers of the group, optionally specifying context of the iterator function.
		// ```js
		// group.eachLayer(function (layer) {
		// 	layer.bindPopup('Hello');
		// });
		// ```
		eachLayer: function (method, context) {
			for (var i in this._layers) {
				method.call(context, this._layers[i]);
			}
			return this;
		},
	
		// @method getLayer(id: Number): Layer
		// Returns the layer with the given internal ID.
		getLayer: function (id) {
			return this._layers[id];
		},
	
		// @method getLayers(): Layer[]
		// Returns an array of all the layers added to the group.
		getLayers: function () {
			var layers = [];
	
			for (var i in this._layers) {
				layers.push(this._layers[i]);
			}
			return layers;
		},
	
		// @method setZIndex(zIndex: Number): this
		// Calls `setZIndex` on every layer contained in this group, passing the z-index.
		setZIndex: function (zIndex) {
			return this.invoke('setZIndex', zIndex);
		},
	
		// @method getLayerId(layer: Layer): Number
		// Returns the internal ID for a layer
		getLayerId: function (layer) {
			return L.stamp(layer);
		}
	});
	
	
	// @factory L.layerGroup(layers: Layer[])
	// Create a layer group, optionally given an initial set of layers.
	L.layerGroup = function (layers) {
		return new L.LayerGroup(layers);
	};
	
	
	
	/*
	 * @class FeatureGroup
	 * @aka L.FeatureGroup
	 * @inherits LayerGroup
	 *
	 * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
	 *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
	 *  * Events are propagated to the `FeatureGroup`, so if the group has an event
	 * handler, it will handle events from any of the layers. This includes mouse events
	 * and custom events.
	 *  * Has `layeradd` and `layerremove` events
	 *
	 * @example
	 *
	 * ```js
	 * L.featureGroup([marker1, marker2, polyline])
	 * 	.bindPopup('Hello world!')
	 * 	.on('click', function() { alert('Clicked on a member of the group!'); })
	 * 	.addTo(map);
	 * ```
	 */
	
	L.FeatureGroup = L.LayerGroup.extend({
	
		addLayer: function (layer) {
			if (this.hasLayer(layer)) {
				return this;
			}
	
			layer.addEventParent(this);
	
			L.LayerGroup.prototype.addLayer.call(this, layer);
	
			// @event layeradd: LayerEvent
			// Fired when a layer is added to this `FeatureGroup`
			return this.fire('layeradd', {layer: layer});
		},
	
		removeLayer: function (layer) {
			if (!this.hasLayer(layer)) {
				return this;
			}
			if (layer in this._layers) {
				layer = this._layers[layer];
			}
	
			layer.removeEventParent(this);
	
			L.LayerGroup.prototype.removeLayer.call(this, layer);
	
			// @event layerremove: LayerEvent
			// Fired when a layer is removed from this `FeatureGroup`
			return this.fire('layerremove', {layer: layer});
		},
	
		// @method setStyle(style: Path options): this
		// Sets the given path options to each layer of the group that has a `setStyle` method.
		setStyle: function (style) {
			return this.invoke('setStyle', style);
		},
	
		// @method bringToFront(): this
		// Brings the layer group to the top of all other layers
		bringToFront: function () {
			return this.invoke('bringToFront');
		},
	
		// @method bringToBack(): this
		// Brings the layer group to the top of all other layers
		bringToBack: function () {
			return this.invoke('bringToBack');
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
		getBounds: function () {
			var bounds = new L.LatLngBounds();
	
			for (var id in this._layers) {
				var layer = this._layers[id];
				bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
			}
			return bounds;
		}
	});
	
	// @factory L.featureGroup(layers: Layer[])
	// Create a feature group, optionally given an initial set of layers.
	L.featureGroup = function (layers) {
		return new L.FeatureGroup(layers);
	};
	
	
	
	/*
	 * @class Renderer
	 * @inherits Layer
	 * @aka L.Renderer
	 *
	 * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
	 * DOM container of the renderer, its bounds, and its zoom animation.
	 *
	 * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
	 * itself can be added or removed to the map. All paths use a renderer, which can
	 * be implicit (the map will decide the type of renderer and use it automatically)
	 * or explicit (using the [`renderer`](#path-renderer) option of the path).
	 *
	 * Do not use this class directly, use `SVG` and `Canvas` instead.
	 *
	 * @event update: Event
	 * Fired when the renderer updates its bounds, center and zoom, for example when
	 * its map has moved
	 */
	
	L.Renderer = L.Layer.extend({
	
		// @section
		// @aka Renderer options
		options: {
			// @option padding: Number = 0.1
			// How much to extend the clip area around the map view (relative to its size)
			// e.g. 0.1 would be 10% of map view in each direction
			padding: 0.1
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
			L.stamp(this);
			this._layers = this._layers || {};
		},
	
		onAdd: function () {
			if (!this._container) {
				this._initContainer(); // defined by renderer implementations
	
				if (this._zoomAnimated) {
					L.DomUtil.addClass(this._container, 'leaflet-zoom-animated');
				}
			}
	
			this.getPane().appendChild(this._container);
			this._update();
			this.on('update', this._updatePaths, this);
		},
	
		onRemove: function () {
			L.DomUtil.remove(this._container);
			this.off('update', this._updatePaths, this);
		},
	
		getEvents: function () {
			var events = {
				viewreset: this._reset,
				zoom: this._onZoom,
				moveend: this._update,
				zoomend: this._onZoomEnd
			};
			if (this._zoomAnimated) {
				events.zoomanim = this._onAnimZoom;
			}
			return events;
		},
	
		_onAnimZoom: function (ev) {
			this._updateTransform(ev.center, ev.zoom);
		},
	
		_onZoom: function () {
			this._updateTransform(this._map.getCenter(), this._map.getZoom());
		},
	
		_updateTransform: function (center, zoom) {
			var scale = this._map.getZoomScale(zoom, this._zoom),
			    position = L.DomUtil.getPosition(this._container),
			    viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding),
			    currentCenterPoint = this._map.project(this._center, zoom),
			    destCenterPoint = this._map.project(center, zoom),
			    centerOffset = destCenterPoint.subtract(currentCenterPoint),
	
			    topLeftOffset = viewHalf.multiplyBy(-scale).add(position).add(viewHalf).subtract(centerOffset);
	
			if (L.Browser.any3d) {
				L.DomUtil.setTransform(this._container, topLeftOffset, scale);
			} else {
				L.DomUtil.setPosition(this._container, topLeftOffset);
			}
		},
	
		_reset: function () {
			this._update();
			this._updateTransform(this._center, this._zoom);
	
			for (var id in this._layers) {
				this._layers[id]._reset();
			}
		},
	
		_onZoomEnd: function () {
			for (var id in this._layers) {
				this._layers[id]._project();
			}
		},
	
		_updatePaths: function () {
			for (var id in this._layers) {
				this._layers[id]._update();
			}
		},
	
		_update: function () {
			// Update pixel bounds of renderer container (for positioning/sizing/clipping later)
			// Subclasses are responsible of firing the 'update' event.
			var p = this.options.padding,
			    size = this._map.getSize(),
			    min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
	
			this._bounds = new L.Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
	
			this._center = this._map.getCenter();
			this._zoom = this._map.getZoom();
		}
	});
	
	
	L.Map.include({
		// @namespace Map; @method getRenderer(layer: Path): Renderer
		// Returns the instance of `Renderer` that should be used to render the given
		// `Path`. It will ensure that the `renderer` options of the map and paths
		// are respected, and that the renderers do exist on the map.
		getRenderer: function (layer) {
			// @namespace Path; @option renderer: Renderer
			// Use this specific instance of `Renderer` for this path. Takes
			// precedence over the map's [default renderer](#map-renderer).
			var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
	
			if (!renderer) {
				// @namespace Map; @option preferCanvas: Boolean = false
				// Whether `Path`s should be rendered on a `Canvas` renderer.
				// By default, all `Path`s are rendered in a `SVG` renderer.
				renderer = this._renderer = (this.options.preferCanvas && L.canvas()) || L.svg();
			}
	
			if (!this.hasLayer(renderer)) {
				this.addLayer(renderer);
			}
			return renderer;
		},
	
		_getPaneRenderer: function (name) {
			if (name === 'overlayPane' || name === undefined) {
				return false;
			}
	
			var renderer = this._paneRenderers[name];
			if (renderer === undefined) {
				renderer = (L.SVG && L.svg({pane: name})) || (L.Canvas && L.canvas({pane: name}));
				this._paneRenderers[name] = renderer;
			}
			return renderer;
		}
	});
	
	
	
	/*
	 * @class Path
	 * @aka L.Path
	 * @inherits Interactive layer
	 *
	 * An abstract class that contains options and constants shared between vector
	 * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
	 */
	
	L.Path = L.Layer.extend({
	
		// @section
		// @aka Path options
		options: {
			// @option stroke: Boolean = true
			// Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
			stroke: true,
	
			// @option color: String = '#3388ff'
			// Stroke color
			color: '#3388ff',
	
			// @option weight: Number = 3
			// Stroke width in pixels
			weight: 3,
	
			// @option opacity: Number = 1.0
			// Stroke opacity
			opacity: 1,
	
			// @option lineCap: String= 'round'
			// A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
			lineCap: 'round',
	
			// @option lineJoin: String = 'round'
			// A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
			lineJoin: 'round',
	
			// @option dashArray: String = null
			// A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashArray: null,
	
			// @option dashOffset: String = null
			// A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
			dashOffset: null,
	
			// @option fill: Boolean = depends
			// Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
			fill: false,
	
			// @option fillColor: String = *
			// Fill color. Defaults to the value of the [`color`](#path-color) option
			fillColor: null,
	
			// @option fillOpacity: Number = 0.2
			// Fill opacity.
			fillOpacity: 0.2,
	
			// @option fillRule: String = 'evenodd'
			// A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
			fillRule: 'evenodd',
	
			// className: '',
	
			// Option inherited from "Interactive layer" abstract class
			interactive: true
		},
	
		beforeAdd: function (map) {
			// Renderer is set here because we need to call renderer.getEvents
			// before this.getEvents.
			this._renderer = map.getRenderer(this);
		},
	
		onAdd: function () {
			this._renderer._initPath(this);
			this._reset();
			this._renderer._addPath(this);
		},
	
		onRemove: function () {
			this._renderer._removePath(this);
		},
	
		// @method redraw(): this
		// Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
		redraw: function () {
			if (this._map) {
				this._renderer._updatePath(this);
			}
			return this;
		},
	
		// @method setStyle(style: Path options): this
		// Changes the appearance of a Path based on the options in the `Path options` object.
		setStyle: function (style) {
			L.setOptions(this, style);
			if (this._renderer) {
				this._renderer._updateStyle(this);
			}
			return this;
		},
	
		// @method bringToFront(): this
		// Brings the layer to the top of all path layers.
		bringToFront: function () {
			if (this._renderer) {
				this._renderer._bringToFront(this);
			}
			return this;
		},
	
		// @method bringToBack(): this
		// Brings the layer to the bottom of all path layers.
		bringToBack: function () {
			if (this._renderer) {
				this._renderer._bringToBack(this);
			}
			return this;
		},
	
		getElement: function () {
			return this._path;
		},
	
		_reset: function () {
			// defined in children classes
			this._project();
			this._update();
		},
	
		_clickTolerance: function () {
			// used when doing hit detection for Canvas layers
			return (this.options.stroke ? this.options.weight / 2 : 0) + (L.Browser.touch ? 10 : 0);
		}
	});
	
	
	
	/*
	 * @namespace LineUtil
	 *
	 * Various utility functions for polyine points processing, used by Leaflet internally to make polylines lightning-fast.
	 */
	
	L.LineUtil = {
	
		// Simplify polyline with vertex reduction and Douglas-Peucker simplification.
		// Improves rendering performance dramatically by lessening the number of points to draw.
	
		// @function simplify(points: Point[], tolerance: Number): Point[]
		// Dramatically reduces the number of points in a polyline while retaining
		// its shape and returns a new array of simplified points, using the
		// [Douglas-Peucker algorithm](http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm).
		// Used for a huge performance boost when processing/displaying Leaflet polylines for
		// each zoom level and also reducing visual noise. tolerance affects the amount of
		// simplification (lesser value means higher quality but slower and with more points).
		// Also released as a separated micro-library [Simplify.js](http://mourner.github.com/simplify-js/).
		simplify: function (points, tolerance) {
			if (!tolerance || !points.length) {
				return points.slice();
			}
	
			var sqTolerance = tolerance * tolerance;
	
			// stage 1: vertex reduction
			points = this._reducePoints(points, sqTolerance);
	
			// stage 2: Douglas-Peucker simplification
			points = this._simplifyDP(points, sqTolerance);
	
			return points;
		},
	
		// @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
		// Returns the distance between point `p` and segment `p1` to `p2`.
		pointToSegmentDistance:  function (p, p1, p2) {
			return Math.sqrt(this._sqClosestPointOnSegment(p, p1, p2, true));
		},
	
		// @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
		// Returns the closest point from a point `p` on a segment `p1` to `p2`.
		closestPointOnSegment: function (p, p1, p2) {
			return this._sqClosestPointOnSegment(p, p1, p2);
		},
	
		// Douglas-Peucker simplification, see http://en.wikipedia.org/wiki/Douglas-Peucker_algorithm
		_simplifyDP: function (points, sqTolerance) {
	
			var len = points.length,
			    ArrayConstructor = typeof Uint8Array !== undefined + '' ? Uint8Array : Array,
			    markers = new ArrayConstructor(len);
	
			markers[0] = markers[len - 1] = 1;
	
			this._simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
	
			var i,
			    newPoints = [];
	
			for (i = 0; i < len; i++) {
				if (markers[i]) {
					newPoints.push(points[i]);
				}
			}
	
			return newPoints;
		},
	
		_simplifyDPStep: function (points, markers, sqTolerance, first, last) {
	
			var maxSqDist = 0,
			    index, i, sqDist;
	
			for (i = first + 1; i <= last - 1; i++) {
				sqDist = this._sqClosestPointOnSegment(points[i], points[first], points[last], true);
	
				if (sqDist > maxSqDist) {
					index = i;
					maxSqDist = sqDist;
				}
			}
	
			if (maxSqDist > sqTolerance) {
				markers[index] = 1;
	
				this._simplifyDPStep(points, markers, sqTolerance, first, index);
				this._simplifyDPStep(points, markers, sqTolerance, index, last);
			}
		},
	
		// reduce points that are too close to each other to a single point
		_reducePoints: function (points, sqTolerance) {
			var reducedPoints = [points[0]];
	
			for (var i = 1, prev = 0, len = points.length; i < len; i++) {
				if (this._sqDist(points[i], points[prev]) > sqTolerance) {
					reducedPoints.push(points[i]);
					prev = i;
				}
			}
			if (prev < len - 1) {
				reducedPoints.push(points[len - 1]);
			}
			return reducedPoints;
		},
	
	
		// @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
		// Clips the segment a to b by rectangular bounds with the
		// [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
		// (modifying the segment points directly!). Used by Leaflet to only show polyline
		// points that are on the screen or near, increasing performance.
		clipSegment: function (a, b, bounds, useLastCode, round) {
			var codeA = useLastCode ? this._lastCode : this._getBitCode(a, bounds),
			    codeB = this._getBitCode(b, bounds),
	
			    codeOut, p, newCode;
	
			// save 2nd code to avoid calculating it on the next segment
			this._lastCode = codeB;
	
			while (true) {
				// if a,b is inside the clip window (trivial accept)
				if (!(codeA | codeB)) {
					return [a, b];
				}
	
				// if a,b is outside the clip window (trivial reject)
				if (codeA & codeB) {
					return false;
				}
	
				// other cases
				codeOut = codeA || codeB;
				p = this._getEdgeIntersection(a, b, codeOut, bounds, round);
				newCode = this._getBitCode(p, bounds);
	
				if (codeOut === codeA) {
					a = p;
					codeA = newCode;
				} else {
					b = p;
					codeB = newCode;
				}
			}
		},
	
		_getEdgeIntersection: function (a, b, code, bounds, round) {
			var dx = b.x - a.x,
			    dy = b.y - a.y,
			    min = bounds.min,
			    max = bounds.max,
			    x, y;
	
			if (code & 8) { // top
				x = a.x + dx * (max.y - a.y) / dy;
				y = max.y;
	
			} else if (code & 4) { // bottom
				x = a.x + dx * (min.y - a.y) / dy;
				y = min.y;
	
			} else if (code & 2) { // right
				x = max.x;
				y = a.y + dy * (max.x - a.x) / dx;
	
			} else if (code & 1) { // left
				x = min.x;
				y = a.y + dy * (min.x - a.x) / dx;
			}
	
			return new L.Point(x, y, round);
		},
	
		_getBitCode: function (p, bounds) {
			var code = 0;
	
			if (p.x < bounds.min.x) { // left
				code |= 1;
			} else if (p.x > bounds.max.x) { // right
				code |= 2;
			}
	
			if (p.y < bounds.min.y) { // bottom
				code |= 4;
			} else if (p.y > bounds.max.y) { // top
				code |= 8;
			}
	
			return code;
		},
	
		// square distance (to avoid unnecessary Math.sqrt calls)
		_sqDist: function (p1, p2) {
			var dx = p2.x - p1.x,
			    dy = p2.y - p1.y;
			return dx * dx + dy * dy;
		},
	
		// return closest point on segment or distance to that point
		_sqClosestPointOnSegment: function (p, p1, p2, sqDist) {
			var x = p1.x,
			    y = p1.y,
			    dx = p2.x - x,
			    dy = p2.y - y,
			    dot = dx * dx + dy * dy,
			    t;
	
			if (dot > 0) {
				t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
	
				if (t > 1) {
					x = p2.x;
					y = p2.y;
				} else if (t > 0) {
					x += dx * t;
					y += dy * t;
				}
			}
	
			dx = p.x - x;
			dy = p.y - y;
	
			return sqDist ? dx * dx + dy * dy : new L.Point(x, y);
		}
	};
	
	
	
	/*
	 * @class Polyline
	 * @aka L.Polyline
	 * @inherits Path
	 *
	 * A class for drawing polyline overlays on a map. Extends `Path`.
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polyline from an array of LatLng points
	 * var latlngs = [
	 * 	[45.51, -122.68],
	 * 	[37.77, -122.43],
	 * 	[34.04, -118.2]
	 * ];
	 *
	 * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polyline
	 * map.fitBounds(polyline.getBounds());
	 * ```
	 *
	 * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
	 *
	 * ```js
	 * // create a red polyline from an array of arrays of LatLng points
	 * var latlngs = [
	 * 	[[45.51, -122.68],
	 * 	 [37.77, -122.43],
	 * 	 [34.04, -118.2]],
	 * 	[[40.78, -73.91],
	 * 	 [41.83, -87.62],
	 * 	 [32.76, -96.72]]
	 * ];
	 * ```
	 */
	
	L.Polyline = L.Path.extend({
	
		// @section
		// @aka Polyline options
		options: {
			// @option smoothFactor: Number = 1.0
			// How much to simplify the polyline on each zoom level. More means
			// better performance and smoother look, and less means more accurate representation.
			smoothFactor: 1.0,
	
			// @option noClip: Boolean = false
			// Disable polyline clipping.
			noClip: false
		},
	
		initialize: function (latlngs, options) {
			L.setOptions(this, options);
			this._setLatLngs(latlngs);
		},
	
		// @method getLatLngs(): LatLng[]
		// Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
		getLatLngs: function () {
			return this._latlngs;
		},
	
		// @method setLatLngs(latlngs: LatLng[]): this
		// Replaces all the points in the polyline with the given array of geographical points.
		setLatLngs: function (latlngs) {
			this._setLatLngs(latlngs);
			return this.redraw();
		},
	
		// @method isEmpty(): Boolean
		// Returns `true` if the Polyline has no LatLngs.
		isEmpty: function () {
			return !this._latlngs.length;
		},
	
		closestLayerPoint: function (p) {
			var minDistance = Infinity,
			    minPoint = null,
			    closest = L.LineUtil._sqClosestPointOnSegment,
			    p1, p2;
	
			for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
				var points = this._parts[j];
	
				for (var i = 1, len = points.length; i < len; i++) {
					p1 = points[i - 1];
					p2 = points[i];
	
					var sqDist = closest(p, p1, p2, true);
	
					if (sqDist < minDistance) {
						minDistance = sqDist;
						minPoint = closest(p, p1, p2);
					}
				}
			}
			if (minPoint) {
				minPoint.distance = Math.sqrt(minDistance);
			}
			return minPoint;
		},
	
		// @method getCenter(): LatLng
		// Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the polyline.
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, halfDist, segDist, dist, p1, p2, ratio,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polyline centroid algorithm; only uses the first ring if there are multiple
	
			for (i = 0, halfDist = 0; i < len - 1; i++) {
				halfDist += points[i].distanceTo(points[i + 1]) / 2;
			}
	
			// The line is so small in the current view that all points are on the same pixel.
			if (halfDist === 0) {
				return this._map.layerPointToLatLng(points[0]);
			}
	
			for (i = 0, dist = 0; i < len - 1; i++) {
				p1 = points[i];
				p2 = points[i + 1];
				segDist = p1.distanceTo(p2);
				dist += segDist;
	
				if (dist > halfDist) {
					ratio = (dist - halfDist) / segDist;
					return this._map.layerPointToLatLng([
						p2.x - ratio * (p2.x - p1.x),
						p2.y - ratio * (p2.y - p1.y)
					]);
				}
			}
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			return this._bounds;
		},
	
		// @method addLatLng(latlng: LatLng, latlngs? LatLng[]): this
		// Adds a given point to the polyline. By default, adds to the first ring of
		// the polyline in case of a multi-polyline, but can be overridden by passing
		// a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
		addLatLng: function (latlng, latlngs) {
			latlngs = latlngs || this._defaultShape();
			latlng = L.latLng(latlng);
			latlngs.push(latlng);
			this._bounds.extend(latlng);
			return this.redraw();
		},
	
		_setLatLngs: function (latlngs) {
			this._bounds = new L.LatLngBounds();
			this._latlngs = this._convertLatLngs(latlngs);
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs) ? this._latlngs : this._latlngs[0];
		},
	
		// recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
		_convertLatLngs: function (latlngs) {
			var result = [],
			    flat = L.Polyline._flat(latlngs);
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				if (flat) {
					result[i] = L.latLng(latlngs[i]);
					this._bounds.extend(result[i]);
				} else {
					result[i] = this._convertLatLngs(latlngs[i]);
				}
			}
	
			return result;
		},
	
		_project: function () {
			var pxBounds = new L.Bounds();
			this._rings = [];
			this._projectLatlngs(this._latlngs, this._rings, pxBounds);
	
			var w = this._clickTolerance(),
			    p = new L.Point(w, w);
	
			if (this._bounds.isValid() && pxBounds.isValid()) {
				pxBounds.min._subtract(p);
				pxBounds.max._add(p);
				this._pxBounds = pxBounds;
			}
		},
	
		// recursively turns latlngs into a set of rings with projected coordinates
		_projectLatlngs: function (latlngs, result, projectedBounds) {
			var flat = latlngs[0] instanceof L.LatLng,
			    len = latlngs.length,
			    i, ring;
	
			if (flat) {
				ring = [];
				for (i = 0; i < len; i++) {
					ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
					projectedBounds.extend(ring[i]);
				}
				result.push(ring);
			} else {
				for (i = 0; i < len; i++) {
					this._projectLatlngs(latlngs[i], result, projectedBounds);
				}
			}
		},
	
		// clip polyline by renderer bounds so that we have less to render for performance
		_clipPoints: function () {
			var bounds = this._renderer._bounds;
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			var parts = this._parts,
			    i, j, k, len, len2, segment, points;
	
			for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
				points = this._rings[i];
	
				for (j = 0, len2 = points.length; j < len2 - 1; j++) {
					segment = L.LineUtil.clipSegment(points[j], points[j + 1], bounds, j, true);
	
					if (!segment) { continue; }
	
					parts[k] = parts[k] || [];
					parts[k].push(segment[0]);
	
					// if segment goes out of screen, or it's the last one, it's the end of the line part
					if ((segment[1] !== points[j + 1]) || (j === len2 - 2)) {
						parts[k].push(segment[1]);
						k++;
					}
				}
			}
		},
	
		// simplify each clipped part of the polyline for performance
		_simplifyPoints: function () {
			var parts = this._parts,
			    tolerance = this.options.smoothFactor;
	
			for (var i = 0, len = parts.length; i < len; i++) {
				parts[i] = L.LineUtil.simplify(parts[i], tolerance);
			}
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			this._clipPoints();
			this._simplifyPoints();
			this._updatePath();
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this);
		}
	});
	
	// @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
	// Instantiates a polyline object given an array of geographical points and
	// optionally an options object. You can create a `Polyline` object with
	// multiple separate lines (`MultiPolyline`) by passing an array of arrays
	// of geographic points.
	L.polyline = function (latlngs, options) {
		return new L.Polyline(latlngs, options);
	};
	
	L.Polyline._flat = function (latlngs) {
		// true if it's a flat array of latlngs; false if nested
		return !L.Util.isArray(latlngs[0]) || (typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined');
	};
	
	
	
	/*
	 * @namespace PolyUtil
	 * Various utility functions for polygon geometries.
	 */
	
	L.PolyUtil = {};
	
	/* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
	 * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgeman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
	 * Used by Leaflet to only show polygon points that are on the screen or near, increasing
	 * performance. Note that polygon points needs different algorithm for clipping
	 * than polyline, so there's a seperate method for it.
	 */
	L.PolyUtil.clipPolygon = function (points, bounds, round) {
		var clippedPoints,
		    edges = [1, 4, 2, 8],
		    i, j, k,
		    a, b,
		    len, edge, p,
		    lu = L.LineUtil;
	
		for (i = 0, len = points.length; i < len; i++) {
			points[i]._code = lu._getBitCode(points[i], bounds);
		}
	
		// for each edge (left, bottom, right, top)
		for (k = 0; k < 4; k++) {
			edge = edges[k];
			clippedPoints = [];
	
			for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
				a = points[i];
				b = points[j];
	
				// if a is inside the clip window
				if (!(a._code & edge)) {
					// if b is outside the clip window (a->b goes out of screen)
					if (b._code & edge) {
						p = lu._getEdgeIntersection(b, a, edge, bounds, round);
						p._code = lu._getBitCode(p, bounds);
						clippedPoints.push(p);
					}
					clippedPoints.push(a);
	
				// else if b is inside the clip window (a->b enters the screen)
				} else if (!(b._code & edge)) {
					p = lu._getEdgeIntersection(b, a, edge, bounds, round);
					p._code = lu._getBitCode(p, bounds);
					clippedPoints.push(p);
				}
			}
			points = clippedPoints;
		}
	
		return points;
	};
	
	
	
	/*
	 * @class Polygon
	 * @aka L.Polygon
	 * @inherits Polyline
	 *
	 * A class for drawing polygon overlays on a map. Extends `Polyline`.
	 *
	 * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
	 *
	 *
	 * @example
	 *
	 * ```js
	 * // create a red polygon from an array of LatLng points
	 * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
	 *
	 * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
	 *
	 * // zoom the map to the polygon
	 * map.fitBounds(polygon.getBounds());
	 * ```
	 *
	 * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
	 *
	 * ```js
	 * var latlngs = [
	 *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 * ];
	 * ```
	 *
	 * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
	 *
	 * ```js
	 * var latlngs = [
	 *   [ // first polygon
	 *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
	 *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
	 *   ],
	 *   [ // second polygon
	 *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
	 *   ]
	 * ];
	 * ```
	 */
	
	L.Polygon = L.Polyline.extend({
	
		options: {
			fill: true
		},
	
		isEmpty: function () {
			return !this._latlngs.length || !this._latlngs[0].length;
		},
	
		getCenter: function () {
			// throws error when not yet added to map as this center calculation requires projected coordinates
			if (!this._map) {
				throw new Error('Must add layer to map before using getCenter()');
			}
	
			var i, j, p1, p2, f, area, x, y, center,
			    points = this._rings[0],
			    len = points.length;
	
			if (!len) { return null; }
	
			// polygon centroid algorithm; only uses the first ring if there are multiple
	
			area = x = y = 0;
	
			for (i = 0, j = len - 1; i < len; j = i++) {
				p1 = points[i];
				p2 = points[j];
	
				f = p1.y * p2.x - p2.y * p1.x;
				x += (p1.x + p2.x) * f;
				y += (p1.y + p2.y) * f;
				area += f * 3;
			}
	
			if (area === 0) {
				// Polygon is so small that all points are on same pixel.
				center = points[0];
			} else {
				center = [x / area, y / area];
			}
			return this._map.layerPointToLatLng(center);
		},
	
		_convertLatLngs: function (latlngs) {
			var result = L.Polyline.prototype._convertLatLngs.call(this, latlngs),
			    len = result.length;
	
			// remove last point if it equals first one
			if (len >= 2 && result[0] instanceof L.LatLng && result[0].equals(result[len - 1])) {
				result.pop();
			}
			return result;
		},
	
		_setLatLngs: function (latlngs) {
			L.Polyline.prototype._setLatLngs.call(this, latlngs);
			if (L.Polyline._flat(this._latlngs)) {
				this._latlngs = [this._latlngs];
			}
		},
	
		_defaultShape: function () {
			return L.Polyline._flat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
		},
	
		_clipPoints: function () {
			// polygons need a different clipping algorithm so we redefine that
	
			var bounds = this._renderer._bounds,
			    w = this.options.weight,
			    p = new L.Point(w, w);
	
			// increase clip padding by stroke width to avoid stroke on clip edges
			bounds = new L.Bounds(bounds.min.subtract(p), bounds.max.add(p));
	
			this._parts = [];
			if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
				return;
			}
	
			if (this.options.noClip) {
				this._parts = this._rings;
				return;
			}
	
			for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
				clipped = L.PolyUtil.clipPolygon(this._rings[i], bounds, true);
				if (clipped.length) {
					this._parts.push(clipped);
				}
			}
		},
	
		_updatePath: function () {
			this._renderer._updatePoly(this, true);
		}
	});
	
	
	// @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
	L.polygon = function (latlngs, options) {
		return new L.Polygon(latlngs, options);
	};
	
	
	
	/*
	 * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
	 */
	
	/*
	 * @class Rectangle
	 * @aka L.Retangle
	 * @inherits Polygon
	 *
	 * A class for drawing rectangle overlays on a map. Extends `Polygon`.
	 *
	 * @example
	 *
	 * ```js
	 * // define rectangle geographical bounds
	 * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
	 *
	 * // create an orange rectangle
	 * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
	 *
	 * // zoom the map to the rectangle bounds
	 * map.fitBounds(bounds);
	 * ```
	 *
	 */
	
	
	L.Rectangle = L.Polygon.extend({
		initialize: function (latLngBounds, options) {
			L.Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
		},
	
		// @method setBounds(latLngBounds: LatLngBounds): this
		// Redraws the rectangle with the passed bounds.
		setBounds: function (latLngBounds) {
			return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
		},
	
		_boundsToLatLngs: function (latLngBounds) {
			latLngBounds = L.latLngBounds(latLngBounds);
			return [
				latLngBounds.getSouthWest(),
				latLngBounds.getNorthWest(),
				latLngBounds.getNorthEast(),
				latLngBounds.getSouthEast()
			];
		}
	});
	
	
	// @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
	L.rectangle = function (latLngBounds, options) {
		return new L.Rectangle(latLngBounds, options);
	};
	
	
	
	/*
	 * @class CircleMarker
	 * @aka L.CircleMarker
	 * @inherits Path
	 *
	 * A circle of a fixed size with radius specified in pixels. Extends `Path`.
	 */
	
	L.CircleMarker = L.Path.extend({
	
		// @section
		// @aka CircleMarker options
		options: {
			fill: true,
	
			// @option radius: Number = 10
			// Radius of the circle marker, in pixels
			radius: 10
		},
	
		initialize: function (latlng, options) {
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
			this._radius = this.options.radius;
		},
	
		// @method setLatLng(latLng: LatLng): this
		// Sets the position of a circle marker to a new location.
		setLatLng: function (latlng) {
			this._latlng = L.latLng(latlng);
			this.redraw();
			return this.fire('move', {latlng: this._latlng});
		},
	
		// @method getLatLng(): LatLng
		// Returns the current geographical position of the circle marker
		getLatLng: function () {
			return this._latlng;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle marker. Units are in pixels.
		setRadius: function (radius) {
			this.options.radius = this._radius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of the circle
		getRadius: function () {
			return this._radius;
		},
	
		setStyle : function (options) {
			var radius = options && options.radius || this._radius;
			L.Path.prototype.setStyle.call(this, options);
			this.setRadius(radius);
			return this;
		},
	
		_project: function () {
			this._point = this._map.latLngToLayerPoint(this._latlng);
			this._updateBounds();
		},
	
		_updateBounds: function () {
			var r = this._radius,
			    r2 = this._radiusY || r,
			    w = this._clickTolerance(),
			    p = [r + w, r2 + w];
			this._pxBounds = new L.Bounds(this._point.subtract(p), this._point.add(p));
		},
	
		_update: function () {
			if (this._map) {
				this._updatePath();
			}
		},
	
		_updatePath: function () {
			this._renderer._updateCircle(this);
		},
	
		_empty: function () {
			return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
		}
	});
	
	
	// @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
	// Instantiates a circle marker object given a geographical point, and an optional options object.
	L.circleMarker = function (latlng, options) {
		return new L.CircleMarker(latlng, options);
	};
	
	
	
	/*
	 * @class Circle
	 * @aka L.Circle
	 * @inherits CircleMarker
	 *
	 * A class for drawing circle overlays on a map. Extends `CircleMarker`.
	 *
	 * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
	 *
	 * @example
	 *
	 * ```js
	 * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
	 * ```
	 */
	
	L.Circle = L.CircleMarker.extend({
	
		initialize: function (latlng, options, legacyOptions) {
			if (typeof options === 'number') {
				// Backwards compatibility with 0.7.x factory (latlng, radius, options?)
				options = L.extend({}, legacyOptions, {radius: options});
			}
			L.setOptions(this, options);
			this._latlng = L.latLng(latlng);
	
			if (isNaN(this.options.radius)) { throw new Error('Circle radius cannot be NaN'); }
	
			// @section
			// @aka Circle options
			// @option radius: Number; Radius of the circle, in meters.
			this._mRadius = this.options.radius;
		},
	
		// @method setRadius(radius: Number): this
		// Sets the radius of a circle. Units are in meters.
		setRadius: function (radius) {
			this._mRadius = radius;
			return this.redraw();
		},
	
		// @method getRadius(): Number
		// Returns the current radius of a circle. Units are in meters.
		getRadius: function () {
			return this._mRadius;
		},
	
		// @method getBounds(): LatLngBounds
		// Returns the `LatLngBounds` of the path.
		getBounds: function () {
			var half = [this._radius, this._radiusY || this._radius];
	
			return new L.LatLngBounds(
				this._map.layerPointToLatLng(this._point.subtract(half)),
				this._map.layerPointToLatLng(this._point.add(half)));
		},
	
		setStyle: L.Path.prototype.setStyle,
	
		_project: function () {
	
			var lng = this._latlng.lng,
			    lat = this._latlng.lat,
			    map = this._map,
			    crs = map.options.crs;
	
			if (crs.distance === L.CRS.Earth.distance) {
				var d = Math.PI / 180,
				    latR = (this._mRadius / L.CRS.Earth.R) / d,
				    top = map.project([lat + latR, lng]),
				    bottom = map.project([lat - latR, lng]),
				    p = top.add(bottom).divideBy(2),
				    lat2 = map.unproject(p).lat,
				    lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) /
				            (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
	
				if (isNaN(lngR) || lngR === 0) {
					lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
				}
	
				this._point = p.subtract(map.getPixelOrigin());
				this._radius = isNaN(lngR) ? 0 : Math.max(Math.round(p.x - map.project([lat2, lng - lngR]).x), 1);
				this._radiusY = Math.max(Math.round(p.y - top.y), 1);
	
			} else {
				var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
	
				this._point = map.latLngToLayerPoint(this._latlng);
				this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
			}
	
			this._updateBounds();
		}
	});
	
	// @factory L.circle(latlng: LatLng, options?: Circle options)
	// Instantiates a circle object given a geographical point, and an options object
	// which contains the circle radius.
	// @alternative
	// @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
	// Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
	// Do not use in new applications or plugins.
	L.circle = function (latlng, options, legacyOptions) {
		return new L.Circle(latlng, options, legacyOptions);
	};
	
	
	
	/*
	 * @class SVG
	 * @inherits Renderer
	 * @aka L.SVG
	 *
	 * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=svg), SVG is not
	 * available in all web browsers, notably Android 2.x and 3.x.
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support
	 * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
	 * (a now deprecated technology), and the SVG renderer will fall back to VML in
	 * this case.
	 *
	 * @example
	 *
	 * Use SVG by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.svg()
	 * });
	 * ```
	 *
	 * Use a SVG renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.svg({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.SVG = L.Renderer.extend({
	
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.zoomstart = this._onZoomStart;
			return events;
		},
	
		_initContainer: function () {
			this._container = L.SVG.create('svg');
	
			// makes it possible to click through svg root; we'll reset it back in individual paths
			this._container.setAttribute('pointer-events', 'none');
	
			this._rootGroup = L.SVG.create('g');
			this._container.appendChild(this._rootGroup);
		},
	
		_onZoomStart: function () {
			// Drag-then-pinch interactions might mess up the center and zoom.
			// In this case, the easiest way to prevent this is re-do the renderer
			//   bounds and padding when the zooming starts.
			this._update();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    size = b.getSize(),
			    container = this._container;
	
			// set size of svg-container if changed
			if (!this._svgSize || !this._svgSize.equals(size)) {
				this._svgSize = size;
				container.setAttribute('width', size.x);
				container.setAttribute('height', size.y);
			}
	
			// movement: update container viewBox so that we don't have to change coordinates of individual layers
			L.DomUtil.setPosition(container, b.min);
			container.setAttribute('viewBox', [b.min.x, b.min.y, size.x, size.y].join(' '));
	
			this.fire('update');
		},
	
		// methods below are called by vector layers implementations
	
		_initPath: function (layer) {
			var path = layer._path = L.SVG.create('path');
	
			// @namespace Path
			// @option className: String = null
			// Custom class name set on an element. Only for SVG renderer.
			if (layer.options.className) {
				L.DomUtil.addClass(path, layer.options.className);
			}
	
			if (layer.options.interactive) {
				L.DomUtil.addClass(path, 'leaflet-interactive');
			}
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			this._rootGroup.appendChild(layer._path);
			layer.addInteractiveTarget(layer._path);
		},
	
		_removePath: function (layer) {
			L.DomUtil.remove(layer._path);
			layer.removeInteractiveTarget(layer._path);
			delete this._layers[L.stamp(layer)];
		},
	
		_updatePath: function (layer) {
			layer._project();
			layer._update();
		},
	
		_updateStyle: function (layer) {
			var path = layer._path,
			    options = layer.options;
	
			if (!path) { return; }
	
			if (options.stroke) {
				path.setAttribute('stroke', options.color);
				path.setAttribute('stroke-opacity', options.opacity);
				path.setAttribute('stroke-width', options.weight);
				path.setAttribute('stroke-linecap', options.lineCap);
				path.setAttribute('stroke-linejoin', options.lineJoin);
	
				if (options.dashArray) {
					path.setAttribute('stroke-dasharray', options.dashArray);
				} else {
					path.removeAttribute('stroke-dasharray');
				}
	
				if (options.dashOffset) {
					path.setAttribute('stroke-dashoffset', options.dashOffset);
				} else {
					path.removeAttribute('stroke-dashoffset');
				}
			} else {
				path.setAttribute('stroke', 'none');
			}
	
			if (options.fill) {
				path.setAttribute('fill', options.fillColor || options.color);
				path.setAttribute('fill-opacity', options.fillOpacity);
				path.setAttribute('fill-rule', options.fillRule || 'evenodd');
			} else {
				path.setAttribute('fill', 'none');
			}
		},
	
		_updatePoly: function (layer, closed) {
			this._setPath(layer, L.SVG.pointsToPath(layer._parts, closed));
		},
	
		_updateCircle: function (layer) {
			var p = layer._point,
			    r = layer._radius,
			    r2 = layer._radiusY || r,
			    arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
	
			// drawing a circle with two half-arcs
			var d = layer._empty() ? 'M0 0' :
					'M' + (p.x - r) + ',' + p.y +
					arc + (r * 2) + ',0 ' +
					arc + (-r * 2) + ',0 ';
	
			this._setPath(layer, d);
		},
	
		_setPath: function (layer, path) {
			layer._path.setAttribute('d', path);
		},
	
		// SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._path);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._path);
		}
	});
	
	
	// @namespace SVG; @section
	// There are several static functions which can be called without instantiating L.SVG:
	L.extend(L.SVG, {
		// @function create(name: String): SVGElement
		// Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
		// corresponding to the class name passed. For example, using 'line' will return
		// an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
		create: function (name) {
			return document.createElementNS('http://www.w3.org/2000/svg', name);
		},
	
		// @function pointsToPath(rings: Point[], closed: Boolean): String
		// Generates a SVG path string for multiple rings, with each ring turning
		// into "M..L..L.." instructions
		pointsToPath: function (rings, closed) {
			var str = '',
			    i, j, len, len2, points, p;
	
			for (i = 0, len = rings.length; i < len; i++) {
				points = rings[i];
	
				for (j = 0, len2 = points.length; j < len2; j++) {
					p = points[j];
					str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
				}
	
				// closes the ring for polygons; "x" is VML syntax
				str += closed ? (L.Browser.svg ? 'z' : 'x') : '';
			}
	
			// SVG complains about empty path strings
			return str || 'M0 0';
		}
	});
	
	// @namespace Browser; @property svg: Boolean
	// `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
	L.Browser.svg = !!(document.createElementNS && L.SVG.create('svg').createSVGRect);
	
	
	// @namespace SVG
	// @factory L.svg(options?: Renderer options)
	// Creates a SVG renderer with the given options.
	L.svg = function (options) {
		return L.Browser.svg || L.Browser.vml ? new L.SVG(options) : null;
	};
	
	
	
	/*
	 * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
	 */
	
	/*
	 * @class SVG
	 *
	 * Although SVG is not available on IE7 and IE8, these browsers support [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language), and the SVG renderer will fall back to VML in this case.
	 *
	 * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
	 * with old versions of Internet Explorer.
	 */
	
	// @namespace Browser; @property vml: Boolean
	// `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
	L.Browser.vml = !L.Browser.svg && (function () {
		try {
			var div = document.createElement('div');
			div.innerHTML = '<v:shape adj="1"/>';
	
			var shape = div.firstChild;
			shape.style.behavior = 'url(#default#VML)';
	
			return shape && (typeof shape.adj === 'object');
	
		} catch (e) {
			return false;
		}
	}());
	
	// redefine some SVG methods to handle VML syntax which is similar but with some differences
	L.SVG.include(!L.Browser.vml ? {} : {
	
		_initContainer: function () {
			this._container = L.DomUtil.create('div', 'leaflet-vml-container');
		},
	
		_update: function () {
			if (this._map._animatingZoom) { return; }
			L.Renderer.prototype._update.call(this);
			this.fire('update');
		},
	
		_initPath: function (layer) {
			var container = layer._container = L.SVG.create('shape');
	
			L.DomUtil.addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
	
			container.coordsize = '1 1';
	
			layer._path = L.SVG.create('path');
			container.appendChild(layer._path);
	
			this._updateStyle(layer);
			this._layers[L.stamp(layer)] = layer;
		},
	
		_addPath: function (layer) {
			var container = layer._container;
			this._container.appendChild(container);
	
			if (layer.options.interactive) {
				layer.addInteractiveTarget(container);
			}
		},
	
		_removePath: function (layer) {
			var container = layer._container;
			L.DomUtil.remove(container);
			layer.removeInteractiveTarget(container);
			delete this._layers[L.stamp(layer)];
		},
	
		_updateStyle: function (layer) {
			var stroke = layer._stroke,
			    fill = layer._fill,
			    options = layer.options,
			    container = layer._container;
	
			container.stroked = !!options.stroke;
			container.filled = !!options.fill;
	
			if (options.stroke) {
				if (!stroke) {
					stroke = layer._stroke = L.SVG.create('stroke');
				}
				container.appendChild(stroke);
				stroke.weight = options.weight + 'px';
				stroke.color = options.color;
				stroke.opacity = options.opacity;
	
				if (options.dashArray) {
					stroke.dashStyle = L.Util.isArray(options.dashArray) ?
					    options.dashArray.join(' ') :
					    options.dashArray.replace(/( *, *)/g, ' ');
				} else {
					stroke.dashStyle = '';
				}
				stroke.endcap = options.lineCap.replace('butt', 'flat');
				stroke.joinstyle = options.lineJoin;
	
			} else if (stroke) {
				container.removeChild(stroke);
				layer._stroke = null;
			}
	
			if (options.fill) {
				if (!fill) {
					fill = layer._fill = L.SVG.create('fill');
				}
				container.appendChild(fill);
				fill.color = options.fillColor || options.color;
				fill.opacity = options.fillOpacity;
	
			} else if (fill) {
				container.removeChild(fill);
				layer._fill = null;
			}
		},
	
		_updateCircle: function (layer) {
			var p = layer._point.round(),
			    r = Math.round(layer._radius),
			    r2 = Math.round(layer._radiusY || r);
	
			this._setPath(layer, layer._empty() ? 'M0 0' :
					'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + (65535 * 360));
		},
	
		_setPath: function (layer, path) {
			layer._path.v = path;
		},
	
		_bringToFront: function (layer) {
			L.DomUtil.toFront(layer._container);
		},
	
		_bringToBack: function (layer) {
			L.DomUtil.toBack(layer._container);
		}
	});
	
	if (L.Browser.vml) {
		L.SVG.create = (function () {
			try {
				document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
				return function (name) {
					return document.createElement('<lvml:' + name + ' class="lvml">');
				};
			} catch (e) {
				return function (name) {
					return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
				};
			}
		})();
	}
	
	
	
	/*
	 * @class Canvas
	 * @inherits Renderer
	 * @aka L.Canvas
	 *
	 * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	 * Inherits `Renderer`.
	 *
	 * Due to [technical limitations](http://caniuse.com/#search=canvas), Canvas is not
	 * available in all web browsers, notably IE8, and overlapping geometries might
	 * not display properly in some edge cases.
	 *
	 * @example
	 *
	 * Use Canvas by default for all paths in the map:
	 *
	 * ```js
	 * var map = L.map('map', {
	 * 	renderer: L.canvas()
	 * });
	 * ```
	 *
	 * Use a Canvas renderer with extra padding for specific vector geometries:
	 *
	 * ```js
	 * var map = L.map('map');
	 * var myRenderer = L.canvas({ padding: 0.5 });
	 * var line = L.polyline( coordinates, { renderer: myRenderer } );
	 * var circle = L.circle( center, { renderer: myRenderer } );
	 * ```
	 */
	
	L.Canvas = L.Renderer.extend({
		getEvents: function () {
			var events = L.Renderer.prototype.getEvents.call(this);
			events.viewprereset = this._onViewPreReset;
			return events;
		},
	
		_onViewPreReset: function () {
			// Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
			this._postponeUpdatePaths = true;
		},
	
		onAdd: function () {
			L.Renderer.prototype.onAdd.call(this);
	
			// Redraw vectors since canvas is cleared upon removal,
			// in case of removing the renderer itself from the map.
			this._draw();
		},
	
		_initContainer: function () {
			var container = this._container = document.createElement('canvas');
	
			L.DomEvent
				.on(container, 'mousemove', L.Util.throttle(this._onMouseMove, 32, this), this)
				.on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this)
				.on(container, 'mouseout', this._handleMouseOut, this);
	
			this._ctx = container.getContext('2d');
		},
	
		_updatePaths: function () {
			if (this._postponeUpdatePaths) { return; }
	
			var layer;
			this._redrawBounds = null;
			for (var id in this._layers) {
				layer = this._layers[id];
				layer._update();
			}
			this._redraw();
		},
	
		_update: function () {
			if (this._map._animatingZoom && this._bounds) { return; }
	
			this._drawnLayers = {};
	
			L.Renderer.prototype._update.call(this);
	
			var b = this._bounds,
			    container = this._container,
			    size = b.getSize(),
			    m = L.Browser.retina ? 2 : 1;
	
			L.DomUtil.setPosition(container, b.min);
	
			// set canvas size (also clearing it); use double size on retina
			container.width = m * size.x;
			container.height = m * size.y;
			container.style.width = size.x + 'px';
			container.style.height = size.y + 'px';
	
			if (L.Browser.retina) {
				this._ctx.scale(2, 2);
			}
	
			// translate so we use the same path coordinates after canvas element moves
			this._ctx.translate(-b.min.x, -b.min.y);
	
			// Tell paths to redraw themselves
			this.fire('update');
		},
	
		_reset: function () {
			L.Renderer.prototype._reset.call(this);
	
			if (this._postponeUpdatePaths) {
				this._postponeUpdatePaths = false;
				this._updatePaths();
			}
		},
	
		_initPath: function (layer) {
			this._updateDashArray(layer);
			this._layers[L.stamp(layer)] = layer;
	
			var order = layer._order = {
				layer: layer,
				prev: this._drawLast,
				next: null
			};
			if (this._drawLast) { this._drawLast.next = order; }
			this._drawLast = order;
			this._drawFirst = this._drawFirst || this._drawLast;
		},
	
		_addPath: function (layer) {
			this._requestRedraw(layer);
		},
	
		_removePath: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				this._drawLast = prev;
			}
			if (prev) {
				prev.next = next;
			} else {
				this._drawFirst = next;
			}
	
			delete layer._order;
	
			delete this._layers[L.stamp(layer)];
	
			this._requestRedraw(layer);
		},
	
		_updatePath: function (layer) {
			// Redraw the union of the layer's old pixel
			// bounds and the new pixel bounds.
			this._extendRedrawBounds(layer);
			layer._project();
			layer._update();
			// The redraw will extend the redraw bounds
			// with the new pixel bounds.
			this._requestRedraw(layer);
		},
	
		_updateStyle: function (layer) {
			this._updateDashArray(layer);
			this._requestRedraw(layer);
		},
	
		_updateDashArray: function (layer) {
			if (layer.options.dashArray) {
				var parts = layer.options.dashArray.split(','),
				    dashArray = [],
				    i;
				for (i = 0; i < parts.length; i++) {
					dashArray.push(Number(parts[i]));
				}
				layer.options._dashArray = dashArray;
			}
		},
	
		_requestRedraw: function (layer) {
			if (!this._map) { return; }
	
			this._extendRedrawBounds(layer);
			this._redrawRequest = this._redrawRequest || L.Util.requestAnimFrame(this._redraw, this);
		},
	
		_extendRedrawBounds: function (layer) {
			var padding = (layer.options.weight || 0) + 1;
			this._redrawBounds = this._redrawBounds || new L.Bounds();
			this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
			this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
		},
	
		_redraw: function () {
			this._redrawRequest = null;
	
			if (this._redrawBounds) {
				this._redrawBounds.min._floor();
				this._redrawBounds.max._ceil();
			}
	
			this._clear(); // clear layers in redraw bounds
			this._draw(); // draw layers
	
			this._redrawBounds = null;
		},
	
		_clear: function () {
			var bounds = this._redrawBounds;
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
			} else {
				this._ctx.clearRect(0, 0, this._container.width, this._container.height);
			}
		},
	
		_draw: function () {
			var layer, bounds = this._redrawBounds;
			this._ctx.save();
			if (bounds) {
				var size = bounds.getSize();
				this._ctx.beginPath();
				this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
				this._ctx.clip();
			}
	
			this._drawing = true;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (!bounds || (layer._pxBounds && layer._pxBounds.intersects(bounds))) {
					layer._updatePath();
				}
			}
	
			this._drawing = false;
	
			this._ctx.restore();  // Restore state before clipping.
		},
	
		_updatePoly: function (layer, closed) {
			if (!this._drawing) { return; }
	
			var i, j, len2, p,
			    parts = layer._parts,
			    len = parts.length,
			    ctx = this._ctx;
	
			if (!len) { return; }
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			ctx.beginPath();
	
			if (ctx.setLineDash) {
				ctx.setLineDash(layer.options && layer.options._dashArray || []);
			}
	
			for (i = 0; i < len; i++) {
				for (j = 0, len2 = parts[i].length; j < len2; j++) {
					p = parts[i][j];
					ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
				}
				if (closed) {
					ctx.closePath();
				}
			}
	
			this._fillStroke(ctx, layer);
	
			// TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
		},
	
		_updateCircle: function (layer) {
	
			if (!this._drawing || layer._empty()) { return; }
	
			var p = layer._point,
			    ctx = this._ctx,
			    r = layer._radius,
			    s = (layer._radiusY || r) / r;
	
			this._drawnLayers[layer._leaflet_id] = layer;
	
			if (s !== 1) {
				ctx.save();
				ctx.scale(1, s);
			}
	
			ctx.beginPath();
			ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
	
			if (s !== 1) {
				ctx.restore();
			}
	
			this._fillStroke(ctx, layer);
		},
	
		_fillStroke: function (ctx, layer) {
			var options = layer.options;
	
			if (options.fill) {
				ctx.globalAlpha = options.fillOpacity;
				ctx.fillStyle = options.fillColor || options.color;
				ctx.fill(options.fillRule || 'evenodd');
			}
	
			if (options.stroke && options.weight !== 0) {
				ctx.globalAlpha = options.opacity;
				ctx.lineWidth = options.weight;
				ctx.strokeStyle = options.color;
				ctx.lineCap = options.lineCap;
				ctx.lineJoin = options.lineJoin;
				ctx.stroke();
			}
		},
	
		// Canvas obviously doesn't have mouse events for individual drawn objects,
		// so we emulate that by calculating what's under the mouse on mousemove/click manually
	
		_onClick: function (e) {
			var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point) && !this._map._draggableMoved(layer)) {
					clickedLayer = layer;
				}
			}
			if (clickedLayer)  {
				L.DomEvent._fakeStop(e);
				this._fireEvent([clickedLayer], e);
			}
		},
	
		_onMouseMove: function (e) {
			if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) { return; }
	
			var point = this._map.mouseEventToLayerPoint(e);
			this._handleMouseHover(e, point);
		},
	
	
		_handleMouseOut: function (e) {
			var layer = this._hoveredLayer;
			if (layer) {
				// if we're leaving the layer, fire mouseout
				L.DomUtil.removeClass(this._container, 'leaflet-interactive');
				this._fireEvent([layer], e, 'mouseout');
				this._hoveredLayer = null;
			}
		},
	
		_handleMouseHover: function (e, point) {
			var layer, candidateHoveredLayer;
	
			for (var order = this._drawFirst; order; order = order.next) {
				layer = order.layer;
				if (layer.options.interactive && layer._containsPoint(point)) {
					candidateHoveredLayer = layer;
				}
			}
	
			if (candidateHoveredLayer !== this._hoveredLayer) {
				this._handleMouseOut(e);
	
				if (candidateHoveredLayer) {
					L.DomUtil.addClass(this._container, 'leaflet-interactive'); // change cursor
					this._fireEvent([candidateHoveredLayer], e, 'mouseover');
					this._hoveredLayer = candidateHoveredLayer;
				}
			}
	
			if (this._hoveredLayer) {
				this._fireEvent([this._hoveredLayer], e);
			}
		},
	
		_fireEvent: function (layers, e, type) {
			this._map._fireDOMEvent(e, type || e.type, layers);
		},
	
		_bringToFront: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (next) {
				next.prev = prev;
			} else {
				// Already last
				return;
			}
			if (prev) {
				prev.next = next;
			} else if (next) {
				// Update first entry unless this is the
				// signle entry
				this._drawFirst = next;
			}
	
			order.prev = this._drawLast;
			this._drawLast.next = order;
	
			order.next = null;
			this._drawLast = order;
	
			this._requestRedraw(layer);
		},
	
		_bringToBack: function (layer) {
			var order = layer._order;
			var next = order.next;
			var prev = order.prev;
	
			if (prev) {
				prev.next = next;
			} else {
				// Already first
				return;
			}
			if (next) {
				next.prev = prev;
			} else if (prev) {
				// Update last entry unless this is the
				// signle entry
				this._drawLast = prev;
			}
	
			order.prev = null;
	
			order.next = this._drawFirst;
			this._drawFirst.prev = order;
			this._drawFirst = order;
	
			this._requestRedraw(layer);
		}
	});
	
	// @namespace Browser; @property canvas: Boolean
	// `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
	L.Browser.canvas = (function () {
		return !!document.createElement('canvas').getContext;
	}());
	
	// @namespace Canvas
	// @factory L.canvas(options?: Renderer options)
	// Creates a Canvas renderer with the given options.
	L.canvas = function (options) {
		return L.Browser.canvas ? new L.Canvas(options) : null;
	};
	
	L.Polyline.prototype._containsPoint = function (p, closed) {
		var i, j, k, len, len2, part,
		    w = this._clickTolerance();
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// hit detection for polylines
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				if (!closed && (j === 0)) { continue; }
	
				if (L.LineUtil.pointToSegmentDistance(p, part[k], part[j]) <= w) {
					return true;
				}
			}
		}
		return false;
	};
	
	L.Polygon.prototype._containsPoint = function (p) {
		var inside = false,
		    part, p1, p2, i, j, k, len, len2;
	
		if (!this._pxBounds.contains(p)) { return false; }
	
		// ray casting algorithm for detecting if point is in polygon
		for (i = 0, len = this._parts.length; i < len; i++) {
			part = this._parts[i];
	
			for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
				p1 = part[j];
				p2 = part[k];
	
				if (((p1.y > p.y) !== (p2.y > p.y)) && (p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x)) {
					inside = !inside;
				}
			}
		}
	
		// also check if it's on polygon stroke
		return inside || L.Polyline.prototype._containsPoint.call(this, p, true);
	};
	
	L.CircleMarker.prototype._containsPoint = function (p) {
		return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
	};
	
	
	
	/*
	 * @class GeoJSON
	 * @aka L.GeoJSON
	 * @inherits FeatureGroup
	 *
	 * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
	 * GeoJSON data and display it on the map. Extends `FeatureGroup`.
	 *
	 * @example
	 *
	 * ```js
	 * L.geoJSON(data, {
	 * 	style: function (feature) {
	 * 		return {color: feature.properties.color};
	 * 	}
	 * }).bindPopup(function (layer) {
	 * 	return layer.feature.properties.description;
	 * }).addTo(map);
	 * ```
	 */
	
	L.GeoJSON = L.FeatureGroup.extend({
	
		/* @section
		 * @aka GeoJSON options
		 *
		 * @option pointToLayer: Function = *
		 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
		 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
		 * The default is to spawn a default `Marker`:
		 * ```js
		 * function(geoJsonPoint, latlng) {
		 * 	return L.marker(latlng);
		 * }
		 * ```
		 *
		 * @option style: Function = *
		 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
		 * called internally when data is added.
		 * The default value is to not override any defaults:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return {}
		 * }
		 * ```
		 *
		 * @option onEachFeature: Function = *
		 * A `Function` that will be called once for each created `Feature`, after it has
		 * been created and styled. Useful for attaching events and popups to features.
		 * The default is to do nothing with the newly created layers:
		 * ```js
		 * function (feature, layer) {}
		 * ```
		 *
		 * @option filter: Function = *
		 * A `Function` that will be used to decide whether to include a feature or not.
		 * The default is to include all features:
		 * ```js
		 * function (geoJsonFeature) {
		 * 	return true;
		 * }
		 * ```
		 * Note: dynamically changing the `filter` option will have effect only on newly
		 * added data. It will _not_ re-evaluate already included features.
		 *
		 * @option coordsToLatLng: Function = *
		 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
		 * The default is the `coordsToLatLng` static method.
		 */
	
		initialize: function (geojson, options) {
			L.setOptions(this, options);
	
			this._layers = {};
	
			if (geojson) {
				this.addData(geojson);
			}
		},
	
		// @method addData( <GeoJSON> data ): this
		// Adds a GeoJSON object to the layer.
		addData: function (geojson) {
			var features = L.Util.isArray(geojson) ? geojson : geojson.features,
			    i, len, feature;
	
			if (features) {
				for (i = 0, len = features.length; i < len; i++) {
					// only add this if geometry or geometries are set and not null
					feature = features[i];
					if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
						this.addData(feature);
					}
				}
				return this;
			}
	
			var options = this.options;
	
			if (options.filter && !options.filter(geojson)) { return this; }
	
			var layer = L.GeoJSON.geometryToLayer(geojson, options);
			if (!layer) {
				return this;
			}
			layer.feature = L.GeoJSON.asFeature(geojson);
	
			layer.defaultOptions = layer.options;
			this.resetStyle(layer);
	
			if (options.onEachFeature) {
				options.onEachFeature(geojson, layer);
			}
	
			return this.addLayer(layer);
		},
	
		// @method resetStyle( <Path> layer ): this
		// Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
		resetStyle: function (layer) {
			// reset any custom styles
			layer.options = L.Util.extend({}, layer.defaultOptions);
			this._setLayerStyle(layer, this.options.style);
			return this;
		},
	
		// @method setStyle( <Function> style ): this
		// Changes styles of GeoJSON vector layers with the given style function.
		setStyle: function (style) {
			return this.eachLayer(function (layer) {
				this._setLayerStyle(layer, style);
			}, this);
		},
	
		_setLayerStyle: function (layer, style) {
			if (typeof style === 'function') {
				style = style(layer.feature);
			}
			if (layer.setStyle) {
				layer.setStyle(style);
			}
		}
	});
	
	// @section
	// There are several static functions which can be called without instantiating L.GeoJSON:
	L.extend(L.GeoJSON, {
		// @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
		// Creates a `Layer` from a given GeoJSON feature. Can use a custom
		// [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
		// functions if provided as options.
		geometryToLayer: function (geojson, options) {
	
			var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson,
			    coords = geometry ? geometry.coordinates : null,
			    layers = [],
			    pointToLayer = options && options.pointToLayer,
			    coordsToLatLng = options && options.coordsToLatLng || this.coordsToLatLng,
			    latlng, latlngs, i, len;
	
			if (!coords && !geometry) {
				return null;
			}
	
			switch (geometry.type) {
			case 'Point':
				latlng = coordsToLatLng(coords);
				return pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng);
	
			case 'MultiPoint':
				for (i = 0, len = coords.length; i < len; i++) {
					latlng = coordsToLatLng(coords[i]);
					layers.push(pointToLayer ? pointToLayer(geojson, latlng) : new L.Marker(latlng));
				}
				return new L.FeatureGroup(layers);
	
			case 'LineString':
			case 'MultiLineString':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, coordsToLatLng);
				return new L.Polyline(latlngs, options);
	
			case 'Polygon':
			case 'MultiPolygon':
				latlngs = this.coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, coordsToLatLng);
				return new L.Polygon(latlngs, options);
	
			case 'GeometryCollection':
				for (i = 0, len = geometry.geometries.length; i < len; i++) {
					var layer = this.geometryToLayer({
						geometry: geometry.geometries[i],
						type: 'Feature',
						properties: geojson.properties
					}, options);
	
					if (layer) {
						layers.push(layer);
					}
				}
				return new L.FeatureGroup(layers);
	
			default:
				throw new Error('Invalid GeoJSON object.');
			}
		},
	
		// @function coordsToLatLng(coords: Array): LatLng
		// Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
		// or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
		coordsToLatLng: function (coords) {
			return new L.LatLng(coords[1], coords[0], coords[2]);
		},
	
		// @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
		// Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
		// `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
		// Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
		coordsToLatLngs: function (coords, levelsDeep, coordsToLatLng) {
			var latlngs = [];
	
			for (var i = 0, len = coords.length, latlng; i < len; i++) {
				latlng = levelsDeep ?
				        this.coordsToLatLngs(coords[i], levelsDeep - 1, coordsToLatLng) :
				        (coordsToLatLng || this.coordsToLatLng)(coords[i]);
	
				latlngs.push(latlng);
			}
	
			return latlngs;
		},
	
		// @function latLngToCoords(latlng: LatLng): Array
		// Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
		latLngToCoords: function (latlng) {
			return latlng.alt !== undefined ?
					[latlng.lng, latlng.lat, latlng.alt] :
					[latlng.lng, latlng.lat];
		},
	
		// @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean): Array
		// Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
		// `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
		latLngsToCoords: function (latlngs, levelsDeep, closed) {
			var coords = [];
	
			for (var i = 0, len = latlngs.length; i < len; i++) {
				coords.push(levelsDeep ?
					L.GeoJSON.latLngsToCoords(latlngs[i], levelsDeep - 1, closed) :
					L.GeoJSON.latLngToCoords(latlngs[i]));
			}
	
			if (!levelsDeep && closed) {
				coords.push(coords[0]);
			}
	
			return coords;
		},
	
		getFeature: function (layer, newGeometry) {
			return layer.feature ?
					L.extend({}, layer.feature, {geometry: newGeometry}) :
					L.GeoJSON.asFeature(newGeometry);
		},
	
		// @function asFeature(geojson: Object): Object
		// Normalize GeoJSON geometries/features into GeoJSON features.
		asFeature: function (geojson) {
			if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') {
				return geojson;
			}
	
			return {
				type: 'Feature',
				properties: {},
				geometry: geojson
			};
		}
	});
	
	var PointToGeoJSON = {
		toGeoJSON: function () {
			return L.GeoJSON.getFeature(this, {
				type: 'Point',
				coordinates: L.GeoJSON.latLngToCoords(this.getLatLng())
			});
		}
	};
	
	// @namespace Marker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
	L.Marker.include(PointToGeoJSON);
	
	// @namespace CircleMarker
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
	L.Circle.include(PointToGeoJSON);
	L.CircleMarker.include(PointToGeoJSON);
	
	
	// @namespace Polyline
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
	L.Polyline.prototype.toGeoJSON = function () {
		var multi = !L.Polyline._flat(this._latlngs);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 1 : 0);
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'LineString',
			coordinates: coords
		});
	};
	
	// @namespace Polygon
	// @method toGeoJSON(): Object
	// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
	L.Polygon.prototype.toGeoJSON = function () {
		var holes = !L.Polyline._flat(this._latlngs),
		    multi = holes && !L.Polyline._flat(this._latlngs[0]);
	
		var coords = L.GeoJSON.latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true);
	
		if (!holes) {
			coords = [coords];
		}
	
		return L.GeoJSON.getFeature(this, {
			type: (multi ? 'Multi' : '') + 'Polygon',
			coordinates: coords
		});
	};
	
	
	// @namespace LayerGroup
	L.LayerGroup.include({
		toMultiPoint: function () {
			var coords = [];
	
			this.eachLayer(function (layer) {
				coords.push(layer.toGeoJSON().geometry.coordinates);
			});
	
			return L.GeoJSON.getFeature(this, {
				type: 'MultiPoint',
				coordinates: coords
			});
		},
	
		// @method toGeoJSON(): Object
		// Returns a [`GeoJSON`](http://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `GeometryCollection`).
		toGeoJSON: function () {
	
			var type = this.feature && this.feature.geometry && this.feature.geometry.type;
	
			if (type === 'MultiPoint') {
				return this.toMultiPoint();
			}
	
			var isGeometryCollection = type === 'GeometryCollection',
			    jsons = [];
	
			this.eachLayer(function (layer) {
				if (layer.toGeoJSON) {
					var json = layer.toGeoJSON();
					jsons.push(isGeometryCollection ? json.geometry : L.GeoJSON.asFeature(json));
				}
			});
	
			if (isGeometryCollection) {
				return L.GeoJSON.getFeature(this, {
					geometries: jsons,
					type: 'GeometryCollection'
				});
			}
	
			return {
				type: 'FeatureCollection',
				features: jsons
			};
		}
	});
	
	// @namespace GeoJSON
	// @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
	// Creates a GeoJSON layer. Optionally accepts an object in
	// [GeoJSON format](http://geojson.org/geojson-spec.html) to display on the map
	// (you can alternatively add it later with `addData` method) and an `options` object.
	L.geoJSON = function (geojson, options) {
		return new L.GeoJSON(geojson, options);
	};
	// Backward compatibility.
	L.geoJson = L.geoJSON;
	
	
	
	/*
	 * @class Draggable
	 * @aka L.Draggable
	 * @inherits Evented
	 *
	 * A class for making DOM elements draggable (including touch support).
	 * Used internally for map and marker dragging. Only works for elements
	 * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
	 *
	 * @example
	 * ```js
	 * var draggable = new L.Draggable(elementToDrag);
	 * draggable.enable();
	 * ```
	 */
	
	L.Draggable = L.Evented.extend({
	
		options: {
			// @option clickTolerance: Number = 3
			// The max number of pixels a user can shift the mouse pointer during a click
			// for it to be considered a valid click (as opposed to a mouse drag).
			clickTolerance: 3
		},
	
		statics: {
			START: L.Browser.touch ? ['touchstart', 'mousedown'] : ['mousedown'],
			END: {
				mousedown: 'mouseup',
				touchstart: 'touchend',
				pointerdown: 'touchend',
				MSPointerDown: 'touchend'
			},
			MOVE: {
				mousedown: 'mousemove',
				touchstart: 'touchmove',
				pointerdown: 'touchmove',
				MSPointerDown: 'touchmove'
			}
		},
	
		// @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline: Boolean)
		// Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
		initialize: function (element, dragStartTarget, preventOutline) {
			this._element = element;
			this._dragStartTarget = dragStartTarget || element;
			this._preventOutline = preventOutline;
		},
	
		// @method enable()
		// Enables the dragging ability
		enable: function () {
			if (this._enabled) { return; }
	
			L.DomEvent.on(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = true;
		},
	
		// @method disable()
		// Disables the dragging ability
		disable: function () {
			if (!this._enabled) { return; }
	
			// If we're currently dragging this draggable,
			// disabling it counts as first ending the drag.
			if (L.Draggable._dragging === this) {
				this.finishDrag();
			}
	
			L.DomEvent.off(this._dragStartTarget, L.Draggable.START.join(' '), this._onDown, this);
	
			this._enabled = false;
			this._moved = false;
		},
	
		_onDown: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			this._moved = false;
	
			if (L.DomUtil.hasClass(this._element, 'leaflet-zoom-anim')) { return; }
	
			if (L.Draggable._dragging || e.shiftKey || ((e.which !== 1) && (e.button !== 1) && !e.touches)) { return; }
			L.Draggable._dragging = this;  // Prevent dragging multiple objects at once.
	
			if (this._preventOutline) {
				L.DomUtil.preventOutline(this._element);
			}
	
			L.DomUtil.disableImageDrag();
			L.DomUtil.disableTextSelection();
	
			if (this._moving) { return; }
	
			// @event down: Event
			// Fired when a drag is about to start.
			this.fire('down');
	
			var first = e.touches ? e.touches[0] : e;
	
			this._startPoint = new L.Point(first.clientX, first.clientY);
	
			L.DomEvent
				.on(document, L.Draggable.MOVE[e.type], this._onMove, this)
				.on(document, L.Draggable.END[e.type], this._onUp, this);
		},
	
		_onMove: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
	
			if (e.touches && e.touches.length > 1) {
				this._moved = true;
				return;
			}
	
			var first = (e.touches && e.touches.length === 1 ? e.touches[0] : e),
			    newPoint = new L.Point(first.clientX, first.clientY),
			    offset = newPoint.subtract(this._startPoint);
	
			if (!offset.x && !offset.y) { return; }
			if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) { return; }
	
			L.DomEvent.preventDefault(e);
	
			if (!this._moved) {
				// @event dragstart: Event
				// Fired when a drag starts
				this.fire('dragstart');
	
				this._moved = true;
				this._startPos = L.DomUtil.getPosition(this._element).subtract(offset);
	
				L.DomUtil.addClass(document.body, 'leaflet-dragging');
	
				this._lastTarget = e.target || e.srcElement;
				// IE and Edge do not give the <use> element, so fetch it
				// if necessary
				if ((window.SVGElementInstance) && (this._lastTarget instanceof SVGElementInstance)) {
					this._lastTarget = this._lastTarget.correspondingUseElement;
				}
				L.DomUtil.addClass(this._lastTarget, 'leaflet-drag-target');
			}
	
			this._newPos = this._startPos.add(offset);
			this._moving = true;
	
			L.Util.cancelAnimFrame(this._animRequest);
			this._lastEvent = e;
			this._animRequest = L.Util.requestAnimFrame(this._updatePosition, this, true);
		},
	
		_updatePosition: function () {
			var e = {originalEvent: this._lastEvent};
	
			// @event predrag: Event
			// Fired continuously during dragging *before* each corresponding
			// update of the element's position.
			this.fire('predrag', e);
			L.DomUtil.setPosition(this._element, this._newPos);
	
			// @event drag: Event
			// Fired continuously during dragging.
			this.fire('drag', e);
		},
	
		_onUp: function (e) {
			// Ignore simulated events, since we handle both touch and
			// mouse explicitly; otherwise we risk getting duplicates of
			// touch events, see #4315.
			// Also ignore the event if disabled; this happens in IE11
			// under some circumstances, see #3666.
			if (e._simulated || !this._enabled) { return; }
			this.finishDrag();
		},
	
		finishDrag: function () {
			L.DomUtil.removeClass(document.body, 'leaflet-dragging');
	
			if (this._lastTarget) {
				L.DomUtil.removeClass(this._lastTarget, 'leaflet-drag-target');
				this._lastTarget = null;
			}
	
			for (var i in L.Draggable.MOVE) {
				L.DomEvent
					.off(document, L.Draggable.MOVE[i], this._onMove, this)
					.off(document, L.Draggable.END[i], this._onUp, this);
			}
	
			L.DomUtil.enableImageDrag();
			L.DomUtil.enableTextSelection();
	
			if (this._moved && this._moving) {
				// ensure drag is not fired after dragend
				L.Util.cancelAnimFrame(this._animRequest);
	
				// @event dragend: DragEndEvent
				// Fired when the drag ends.
				this.fire('dragend', {
					distance: this._newPos.distanceTo(this._startPos)
				});
			}
	
			this._moving = false;
			L.Draggable._dragging = false;
		}
	
	});
	
	
	
	/*
		L.Handler is a base class for handler classes that are used internally to inject
		interaction features like dragging to classes like Map and Marker.
	*/
	
	// @class Handler
	// @aka L.Handler
	// Abstract class for map interaction handlers
	
	L.Handler = L.Class.extend({
		initialize: function (map) {
			this._map = map;
		},
	
		// @method enable(): this
		// Enables the handler
		enable: function () {
			if (this._enabled) { return this; }
	
			this._enabled = true;
			this.addHooks();
			return this;
		},
	
		// @method disable(): this
		// Disables the handler
		disable: function () {
			if (!this._enabled) { return this; }
	
			this._enabled = false;
			this.removeHooks();
			return this;
		},
	
		// @method enabled(): Boolean
		// Returns `true` if the handler is enabled
		enabled: function () {
			return !!this._enabled;
		}
	
		// @section Extension methods
		// Classes inheriting from `Handler` must implement the two following methods:
		// @method addHooks()
		// Called when the handler is enabled, should add event hooks.
		// @method removeHooks()
		// Called when the handler is disabled, should remove the event hooks added previously.
	});
	
	
	
	/*
	 * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option dragging: Boolean = true
		// Whether the map be draggable with mouse/touch or not.
		dragging: true,
	
		// @section Panning Inertia Options
		// @option inertia: Boolean = *
		// If enabled, panning of the map will have an inertia effect where
		// the map builds momentum while dragging and continues moving in
		// the same direction for some time. Feels especially nice on touch
		// devices. Enabled by default unless running on old Android devices.
		inertia: !L.Browser.android23,
	
		// @option inertiaDeceleration: Number = 3000
		// The rate with which the inertial movement slows down, in pixels/second².
		inertiaDeceleration: 3400, // px/s^2
	
		// @option inertiaMaxSpeed: Number = Infinity
		// Max speed of the inertial movement, in pixels/second.
		inertiaMaxSpeed: Infinity, // px/s
	
		// @option easeLinearity: Number = 0.2
		easeLinearity: 0.2,
	
		// TODO refactor, move to CRS
		// @option worldCopyJump: Boolean = false
		// With this option enabled, the map tracks when you pan to another "copy"
		// of the world and seamlessly jumps to the original one so that all overlays
		// like markers and vector layers are still visible.
		worldCopyJump: false,
	
		// @option maxBoundsViscosity: Number = 0.0
		// If `maxBounds` is set, this option will control how solid the bounds
		// are when dragging the map around. The default value of `0.0` allows the
		// user to drag outside the bounds at normal speed, higher values will
		// slow down map dragging outside bounds, and `1.0` makes the bounds fully
		// solid, preventing the user from dragging outside the bounds.
		maxBoundsViscosity: 0.0
	});
	
	L.Map.Drag = L.Handler.extend({
		addHooks: function () {
			if (!this._draggable) {
				var map = this._map;
	
				this._draggable = new L.Draggable(map._mapPane, map._container);
	
				this._draggable.on({
					down: this._onDown,
					dragstart: this._onDragStart,
					drag: this._onDrag,
					dragend: this._onDragEnd
				}, this);
	
				this._draggable.on('predrag', this._onPreDragLimit, this);
				if (map.options.worldCopyJump) {
					this._draggable.on('predrag', this._onPreDragWrap, this);
					map.on('zoomend', this._onZoomEnd, this);
	
					map.whenReady(this._onZoomEnd, this);
				}
			}
			L.DomUtil.addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
			this._draggable.enable();
			this._positions = [];
			this._times = [];
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-grab');
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-drag');
			this._draggable.disable();
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		moving: function () {
			return this._draggable && this._draggable._moving;
		},
	
		_onDown: function () {
			this._map._stop();
		},
	
		_onDragStart: function () {
			var map = this._map;
	
			if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
				var bounds = L.latLngBounds(this._map.options.maxBounds);
	
				this._offsetLimit = L.bounds(
					this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
					this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1)
						.add(this._map.getSize()));
	
				this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
			} else {
				this._offsetLimit = null;
			}
	
			map
			    .fire('movestart')
			    .fire('dragstart');
	
			if (map.options.inertia) {
				this._positions = [];
				this._times = [];
			}
		},
	
		_onDrag: function (e) {
			if (this._map.options.inertia) {
				var time = this._lastTime = +new Date(),
				    pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
	
				this._positions.push(pos);
				this._times.push(time);
	
				if (time - this._times[0] > 50) {
					this._positions.shift();
					this._times.shift();
				}
			}
	
			this._map
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onZoomEnd: function () {
			var pxCenter = this._map.getSize().divideBy(2),
			    pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
	
			this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
			this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
		},
	
		_viscousLimit: function (value, threshold) {
			return value - (value - threshold) * this._viscosity;
		},
	
		_onPreDragLimit: function () {
			if (!this._viscosity || !this._offsetLimit) { return; }
	
			var offset = this._draggable._newPos.subtract(this._draggable._startPos);
	
			var limit = this._offsetLimit;
			if (offset.x < limit.min.x) { offset.x = this._viscousLimit(offset.x, limit.min.x); }
			if (offset.y < limit.min.y) { offset.y = this._viscousLimit(offset.y, limit.min.y); }
			if (offset.x > limit.max.x) { offset.x = this._viscousLimit(offset.x, limit.max.x); }
			if (offset.y > limit.max.y) { offset.y = this._viscousLimit(offset.y, limit.max.y); }
	
			this._draggable._newPos = this._draggable._startPos.add(offset);
		},
	
		_onPreDragWrap: function () {
			// TODO refactor to be able to adjust map pane position after zoom
			var worldWidth = this._worldWidth,
			    halfWidth = Math.round(worldWidth / 2),
			    dx = this._initialWorldOffset,
			    x = this._draggable._newPos.x,
			    newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx,
			    newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx,
			    newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
	
			this._draggable._absPos = this._draggable._newPos.clone();
			this._draggable._newPos.x = newX;
		},
	
		_onDragEnd: function (e) {
			var map = this._map,
			    options = map.options,
	
			    noInertia = !options.inertia || this._times.length < 2;
	
			map.fire('dragend', e);
	
			if (noInertia) {
				map.fire('moveend');
	
			} else {
	
				var direction = this._lastPos.subtract(this._positions[0]),
				    duration = (this._lastTime - this._times[0]) / 1000,
				    ease = options.easeLinearity,
	
				    speedVector = direction.multiplyBy(ease / duration),
				    speed = speedVector.distanceTo([0, 0]),
	
				    limitedSpeed = Math.min(options.inertiaMaxSpeed, speed),
				    limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed),
	
				    decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease),
				    offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
	
				if (!offset.x && !offset.y) {
					map.fire('moveend');
	
				} else {
					offset = map._limitOffset(offset, map.options.maxBounds);
	
					L.Util.requestAnimFrame(function () {
						map.panBy(offset, {
							duration: decelerationDuration,
							easeLinearity: ease,
							noMoveStart: true,
							animate: true
						});
					});
				}
			}
		}
	});
	
	// @section Handlers
	// @property dragging: Handler
	// Map dragging handler (by both mouse and touch).
	L.Map.addInitHook('addHandler', 'dragging', L.Map.Drag);
	
	
	
	/*
	 * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	
	L.Map.mergeOptions({
		// @option doubleClickZoom: Boolean|String = true
		// Whether the map can be zoomed in by double clicking on it and
		// zoomed out by double clicking while holding shift. If passed
		// `'center'`, double-click zoom will zoom to the center of the
		//  view regardless of where the mouse was.
		doubleClickZoom: true
	});
	
	L.Map.DoubleClickZoom = L.Handler.extend({
		addHooks: function () {
			this._map.on('dblclick', this._onDoubleClick, this);
		},
	
		removeHooks: function () {
			this._map.off('dblclick', this._onDoubleClick, this);
		},
	
		_onDoubleClick: function (e) {
			var map = this._map,
			    oldZoom = map.getZoom(),
			    delta = map.options.zoomDelta,
			    zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
	
			if (map.options.doubleClickZoom === 'center') {
				map.setZoom(zoom);
			} else {
				map.setZoomAround(e.containerPoint, zoom);
			}
		}
	});
	
	// @section Handlers
	//
	// Map properties include interaction handlers that allow you to control
	// interaction behavior in runtime, enabling or disabling certain features such
	// as dragging or touch zoom (see `Handler` methods). For example:
	//
	// ```js
	// map.doubleClickZoom.disable();
	// ```
	//
	// @property doubleClickZoom: Handler
	// Double click zoom handler.
	L.Map.addInitHook('addHandler', 'doubleClickZoom', L.Map.DoubleClickZoom);
	
	
	
	/*
	 * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Mousewheel options
		// @option scrollWheelZoom: Boolean|String = true
		// Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
		// it will zoom to the center of the view regardless of where the mouse was.
		scrollWheelZoom: true,
	
		// @option wheelDebounceTime: Number = 40
		// Limits the rate at which a wheel can fire (in milliseconds). By default
		// user can't zoom via wheel more often than once per 40 ms.
		wheelDebounceTime: 40,
	
		// @option wheelPxPerZoomLevel: Number = 60
		// How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
		// mean a change of one full zoom level. Smaller values will make wheel-zooming
		// faster (and vice versa).
		wheelPxPerZoomLevel: 60
	});
	
	L.Map.ScrollWheelZoom = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'mousewheel', this._onWheelScroll, this);
	
			this._delta = 0;
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'mousewheel', this._onWheelScroll, this);
		},
	
		_onWheelScroll: function (e) {
			var delta = L.DomEvent.getWheelDelta(e);
	
			var debounce = this._map.options.wheelDebounceTime;
	
			this._delta += delta;
			this._lastMousePos = this._map.mouseEventToContainerPoint(e);
	
			if (!this._startTime) {
				this._startTime = +new Date();
			}
	
			var left = Math.max(debounce - (+new Date() - this._startTime), 0);
	
			clearTimeout(this._timer);
			this._timer = setTimeout(L.bind(this._performZoom, this), left);
	
			L.DomEvent.stop(e);
		},
	
		_performZoom: function () {
			var map = this._map,
			    zoom = map.getZoom(),
			    snap = this._map.options.zoomSnap || 0;
	
			map._stop(); // stop panning and fly animations if any
	
			// map the delta with a sigmoid function to -4..4 range leaning on -1..1
			var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4),
			    d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2,
			    d4 = snap ? Math.ceil(d3 / snap) * snap : d3,
			    delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
	
			this._delta = 0;
			this._startTime = null;
	
			if (!delta) { return; }
	
			if (map.options.scrollWheelZoom === 'center') {
				map.setZoom(zoom + delta);
			} else {
				map.setZoomAround(this._lastMousePos, zoom + delta);
			}
		}
	});
	
	// @section Handlers
	// @property scrollWheelZoom: Handler
	// Scroll wheel zoom handler.
	L.Map.addInitHook('addHandler', 'scrollWheelZoom', L.Map.ScrollWheelZoom);
	
	
	
	/*
	 * Extends the event handling code with double tap support for mobile browsers.
	 */
	
	L.extend(L.DomEvent, {
	
		_touchstart: L.Browser.msPointer ? 'MSPointerDown' : L.Browser.pointer ? 'pointerdown' : 'touchstart',
		_touchend: L.Browser.msPointer ? 'MSPointerUp' : L.Browser.pointer ? 'pointerup' : 'touchend',
	
		// inspired by Zepto touch code by Thomas Fuchs
		addDoubleTapListener: function (obj, handler, id) {
			var last, touch,
			    doubleTap = false,
			    delay = 250;
	
			function onTouchStart(e) {
				var count;
	
				if (L.Browser.pointer) {
					if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
					count = L.DomEvent._pointersCount;
				} else {
					count = e.touches.length;
				}
	
				if (count > 1) { return; }
	
				var now = Date.now(),
				    delta = now - (last || now);
	
				touch = e.touches ? e.touches[0] : e;
				doubleTap = (delta > 0 && delta <= delay);
				last = now;
			}
	
			function onTouchEnd(e) {
				if (doubleTap && !touch.cancelBubble) {
					if (L.Browser.pointer) {
						if ((!L.Browser.edge) || e.pointerType === 'mouse') { return; }
	
						// work around .type being readonly with MSPointer* events
						var newTouch = {},
						    prop, i;
	
						for (i in touch) {
							prop = touch[i];
							newTouch[i] = prop && prop.bind ? prop.bind(touch) : prop;
						}
						touch = newTouch;
					}
					touch.type = 'dblclick';
					handler(touch);
					last = null;
				}
			}
	
			var pre = '_leaflet_',
			    touchstart = this._touchstart,
			    touchend = this._touchend;
	
			obj[pre + touchstart + id] = onTouchStart;
			obj[pre + touchend + id] = onTouchEnd;
			obj[pre + 'dblclick' + id] = handler;
	
			obj.addEventListener(touchstart, onTouchStart, false);
			obj.addEventListener(touchend, onTouchEnd, false);
	
			// On some platforms (notably, chrome<55 on win10 + touchscreen + mouse),
			// the browser doesn't fire touchend/pointerup events but does fire
			// native dblclicks. See #4127.
			// Edge 14 also fires native dblclicks, but only for pointerType mouse, see #5180.
			obj.addEventListener('dblclick', handler, false);
	
			return this;
		},
	
		removeDoubleTapListener: function (obj, id) {
			var pre = '_leaflet_',
			    touchstart = obj[pre + this._touchstart + id],
			    touchend = obj[pre + this._touchend + id],
			    dblclick = obj[pre + 'dblclick' + id];
	
			obj.removeEventListener(this._touchstart, touchstart, false);
			obj.removeEventListener(this._touchend, touchend, false);
			if (!L.Browser.edge) {
				obj.removeEventListener('dblclick', dblclick, false);
			}
	
			return this;
		}
	});
	
	
	
	/*
	 * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
	 */
	
	L.extend(L.DomEvent, {
	
		POINTER_DOWN:   L.Browser.msPointer ? 'MSPointerDown'   : 'pointerdown',
		POINTER_MOVE:   L.Browser.msPointer ? 'MSPointerMove'   : 'pointermove',
		POINTER_UP:     L.Browser.msPointer ? 'MSPointerUp'     : 'pointerup',
		POINTER_CANCEL: L.Browser.msPointer ? 'MSPointerCancel' : 'pointercancel',
		TAG_WHITE_LIST: ['INPUT', 'SELECT', 'OPTION'],
	
		_pointers: {},
		_pointersCount: 0,
	
		// Provides a touch events wrapper for (ms)pointer events.
		// ref http://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
	
		addPointerListener: function (obj, type, handler, id) {
	
			if (type === 'touchstart') {
				this._addPointerStart(obj, handler, id);
	
			} else if (type === 'touchmove') {
				this._addPointerMove(obj, handler, id);
	
			} else if (type === 'touchend') {
				this._addPointerEnd(obj, handler, id);
			}
	
			return this;
		},
	
		removePointerListener: function (obj, type, id) {
			var handler = obj['_leaflet_' + type + id];
	
			if (type === 'touchstart') {
				obj.removeEventListener(this.POINTER_DOWN, handler, false);
	
			} else if (type === 'touchmove') {
				obj.removeEventListener(this.POINTER_MOVE, handler, false);
	
			} else if (type === 'touchend') {
				obj.removeEventListener(this.POINTER_UP, handler, false);
				obj.removeEventListener(this.POINTER_CANCEL, handler, false);
			}
	
			return this;
		},
	
		_addPointerStart: function (obj, handler, id) {
			var onDown = L.bind(function (e) {
				if (e.pointerType !== 'mouse' && e.MSPOINTER_TYPE_MOUSE && e.pointerType !== e.MSPOINTER_TYPE_MOUSE) {
					// In IE11, some touch events needs to fire for form controls, or
					// the controls will stop working. We keep a whitelist of tag names that
					// need these events. For other target tags, we prevent default on the event.
					if (this.TAG_WHITE_LIST.indexOf(e.target.tagName) < 0) {
						L.DomEvent.preventDefault(e);
					} else {
						return;
					}
				}
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchstart' + id] = onDown;
			obj.addEventListener(this.POINTER_DOWN, onDown, false);
	
			// need to keep track of what pointers and how many are active to provide e.touches emulation
			if (!this._pointerDocListener) {
				var pointerUp = L.bind(this._globalPointerUp, this);
	
				// we listen documentElement as any drags that end by moving the touch off the screen get fired there
				document.documentElement.addEventListener(this.POINTER_DOWN, L.bind(this._globalPointerDown, this), true);
				document.documentElement.addEventListener(this.POINTER_MOVE, L.bind(this._globalPointerMove, this), true);
				document.documentElement.addEventListener(this.POINTER_UP, pointerUp, true);
				document.documentElement.addEventListener(this.POINTER_CANCEL, pointerUp, true);
	
				this._pointerDocListener = true;
			}
		},
	
		_globalPointerDown: function (e) {
			this._pointers[e.pointerId] = e;
			this._pointersCount++;
		},
	
		_globalPointerMove: function (e) {
			if (this._pointers[e.pointerId]) {
				this._pointers[e.pointerId] = e;
			}
		},
	
		_globalPointerUp: function (e) {
			delete this._pointers[e.pointerId];
			this._pointersCount--;
		},
	
		_handlePointer: function (e, handler) {
			e.touches = [];
			for (var i in this._pointers) {
				e.touches.push(this._pointers[i]);
			}
			e.changedTouches = [e];
	
			handler(e);
		},
	
		_addPointerMove: function (obj, handler, id) {
			var onMove = L.bind(function (e) {
				// don't fire touch moves when mouse isn't down
				if ((e.pointerType === e.MSPOINTER_TYPE_MOUSE || e.pointerType === 'mouse') && e.buttons === 0) { return; }
	
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchmove' + id] = onMove;
			obj.addEventListener(this.POINTER_MOVE, onMove, false);
		},
	
		_addPointerEnd: function (obj, handler, id) {
			var onUp = L.bind(function (e) {
				this._handlePointer(e, handler);
			}, this);
	
			obj['_leaflet_touchend' + id] = onUp;
			obj.addEventListener(this.POINTER_UP, onUp, false);
			obj.addEventListener(this.POINTER_CANCEL, onUp, false);
		}
	});
	
	
	
	/*
	 * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option touchZoom: Boolean|String = *
		// Whether the map can be zoomed by touch-dragging with two fingers. If
		// passed `'center'`, it will zoom to the center of the view regardless of
		// where the touch events (fingers) were. Enabled for touch-capable web
		// browsers except for old Androids.
		touchZoom: L.Browser.touch && !L.Browser.android23,
	
		// @option bounceAtZoomLimits: Boolean = true
		// Set it to false if you don't want the map to zoom beyond min/max zoom
		// and then bounce back when pinch-zooming.
		bounceAtZoomLimits: true
	});
	
	L.Map.TouchZoom = L.Handler.extend({
		addHooks: function () {
			L.DomUtil.addClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.on(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		removeHooks: function () {
			L.DomUtil.removeClass(this._map._container, 'leaflet-touch-zoom');
			L.DomEvent.off(this._map._container, 'touchstart', this._onTouchStart, this);
		},
	
		_onTouchStart: function (e) {
			var map = this._map;
			if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) { return; }
	
			var p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]);
	
			this._centerPoint = map.getSize()._divideBy(2);
			this._startLatLng = map.containerPointToLatLng(this._centerPoint);
			if (map.options.touchZoom !== 'center') {
				this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
			}
	
			this._startDist = p1.distanceTo(p2);
			this._startZoom = map.getZoom();
	
			this._moved = false;
			this._zooming = true;
	
			map._stop();
	
			L.DomEvent
			    .on(document, 'touchmove', this._onTouchMove, this)
			    .on(document, 'touchend', this._onTouchEnd, this);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchMove: function (e) {
			if (!e.touches || e.touches.length !== 2 || !this._zooming) { return; }
	
			var map = this._map,
			    p1 = map.mouseEventToContainerPoint(e.touches[0]),
			    p2 = map.mouseEventToContainerPoint(e.touches[1]),
			    scale = p1.distanceTo(p2) / this._startDist;
	
	
			this._zoom = map.getScaleZoom(scale, this._startZoom);
	
			if (!map.options.bounceAtZoomLimits && (
				(this._zoom < map.getMinZoom() && scale < 1) ||
				(this._zoom > map.getMaxZoom() && scale > 1))) {
				this._zoom = map._limitZoom(this._zoom);
			}
	
			if (map.options.touchZoom === 'center') {
				this._center = this._startLatLng;
				if (scale === 1) { return; }
			} else {
				// Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
				var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
				if (scale === 1 && delta.x === 0 && delta.y === 0) { return; }
				this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
			}
	
			if (!this._moved) {
				map._moveStart(true);
				this._moved = true;
			}
	
			L.Util.cancelAnimFrame(this._animRequest);
	
			var moveFn = L.bind(map._move, map, this._center, this._zoom, {pinch: true, round: false});
			this._animRequest = L.Util.requestAnimFrame(moveFn, this, true);
	
			L.DomEvent.preventDefault(e);
		},
	
		_onTouchEnd: function () {
			if (!this._moved || !this._zooming) {
				this._zooming = false;
				return;
			}
	
			this._zooming = false;
			L.Util.cancelAnimFrame(this._animRequest);
	
			L.DomEvent
			    .off(document, 'touchmove', this._onTouchMove)
			    .off(document, 'touchend', this._onTouchEnd);
	
			// Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
			if (this._map.options.zoomAnimation) {
				this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
			} else {
				this._map._resetView(this._center, this._map._limitZoom(this._zoom));
			}
		}
	});
	
	// @section Handlers
	// @property touchZoom: Handler
	// Touch zoom handler.
	L.Map.addInitHook('addHandler', 'touchZoom', L.Map.TouchZoom);
	
	
	
	/*
	 * L.Map.Tap is used to enable mobile hacks like quick taps and long hold.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @section Touch interaction options
		// @option tap: Boolean = true
		// Enables mobile hacks for supporting instant taps (fixing 200ms click
		// delay on iOS/Android) and touch holds (fired as `contextmenu` events).
		tap: true,
	
		// @option tapTolerance: Number = 15
		// The max number of pixels a user can shift his finger during touch
		// for it to be considered a valid tap.
		tapTolerance: 15
	});
	
	L.Map.Tap = L.Handler.extend({
		addHooks: function () {
			L.DomEvent.on(this._map._container, 'touchstart', this._onDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._map._container, 'touchstart', this._onDown, this);
		},
	
		_onDown: function (e) {
			if (!e.touches) { return; }
	
			L.DomEvent.preventDefault(e);
	
			this._fireClick = true;
	
			// don't simulate click or track longpress if more than 1 touch
			if (e.touches.length > 1) {
				this._fireClick = false;
				clearTimeout(this._holdTimeout);
				return;
			}
	
			var first = e.touches[0],
			    el = first.target;
	
			this._startPos = this._newPos = new L.Point(first.clientX, first.clientY);
	
			// if touching a link, highlight it
			if (el.tagName && el.tagName.toLowerCase() === 'a') {
				L.DomUtil.addClass(el, 'leaflet-active');
			}
	
			// simulate long hold but setting a timeout
			this._holdTimeout = setTimeout(L.bind(function () {
				if (this._isTapValid()) {
					this._fireClick = false;
					this._onUp();
					this._simulateEvent('contextmenu', first);
				}
			}, this), 1000);
	
			this._simulateEvent('mousedown', first);
	
			L.DomEvent.on(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
		},
	
		_onUp: function (e) {
			clearTimeout(this._holdTimeout);
	
			L.DomEvent.off(document, {
				touchmove: this._onMove,
				touchend: this._onUp
			}, this);
	
			if (this._fireClick && e && e.changedTouches) {
	
				var first = e.changedTouches[0],
				    el = first.target;
	
				if (el && el.tagName && el.tagName.toLowerCase() === 'a') {
					L.DomUtil.removeClass(el, 'leaflet-active');
				}
	
				this._simulateEvent('mouseup', first);
	
				// simulate click if the touch didn't move too much
				if (this._isTapValid()) {
					this._simulateEvent('click', first);
				}
			}
		},
	
		_isTapValid: function () {
			return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
		},
	
		_onMove: function (e) {
			var first = e.touches[0];
			this._newPos = new L.Point(first.clientX, first.clientY);
			this._simulateEvent('mousemove', first);
		},
	
		_simulateEvent: function (type, e) {
			var simulatedEvent = document.createEvent('MouseEvents');
	
			simulatedEvent._simulated = true;
			e.target._simulatedClick = true;
	
			simulatedEvent.initMouseEvent(
			        type, true, true, window, 1,
			        e.screenX, e.screenY,
			        e.clientX, e.clientY,
			        false, false, false, false, 0, null);
	
			e.target.dispatchEvent(simulatedEvent);
		}
	});
	
	// @section Handlers
	// @property tap: Handler
	// Mobile touch hacks (quick tap and touch hold) handler.
	if (L.Browser.touch && !L.Browser.pointer) {
		L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
	}
	
	
	
	/*
	 * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
	 * (zoom to a selected bounding box), enabled by default.
	 */
	
	// @namespace Map
	// @section Interaction Options
	L.Map.mergeOptions({
		// @option boxZoom: Boolean = true
		// Whether the map can be zoomed to a rectangular area specified by
		// dragging the mouse while pressing the shift key.
		boxZoom: true
	});
	
	L.Map.BoxZoom = L.Handler.extend({
		initialize: function (map) {
			this._map = map;
			this._container = map._container;
			this._pane = map._panes.overlayPane;
		},
	
		addHooks: function () {
			L.DomEvent.on(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		removeHooks: function () {
			L.DomEvent.off(this._container, 'mousedown', this._onMouseDown, this);
		},
	
		moved: function () {
			return this._moved;
		},
	
		_resetState: function () {
			this._moved = false;
		},
	
		_onMouseDown: function (e) {
			if (!e.shiftKey || ((e.which !== 1) && (e.button !== 1))) { return false; }
	
			this._resetState();
	
			L.DomUtil.disableTextSelection();
			L.DomUtil.disableImageDrag();
	
			this._startPoint = this._map.mouseEventToContainerPoint(e);
	
			L.DomEvent.on(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseMove: function (e) {
			if (!this._moved) {
				this._moved = true;
	
				this._box = L.DomUtil.create('div', 'leaflet-zoom-box', this._container);
				L.DomUtil.addClass(this._container, 'leaflet-crosshair');
	
				this._map.fire('boxzoomstart');
			}
	
			this._point = this._map.mouseEventToContainerPoint(e);
	
			var bounds = new L.Bounds(this._point, this._startPoint),
			    size = bounds.getSize();
	
			L.DomUtil.setPosition(this._box, bounds.min);
	
			this._box.style.width  = size.x + 'px';
			this._box.style.height = size.y + 'px';
		},
	
		_finish: function () {
			if (this._moved) {
				L.DomUtil.remove(this._box);
				L.DomUtil.removeClass(this._container, 'leaflet-crosshair');
			}
	
			L.DomUtil.enableTextSelection();
			L.DomUtil.enableImageDrag();
	
			L.DomEvent.off(document, {
				contextmenu: L.DomEvent.stop,
				mousemove: this._onMouseMove,
				mouseup: this._onMouseUp,
				keydown: this._onKeyDown
			}, this);
		},
	
		_onMouseUp: function (e) {
			if ((e.which !== 1) && (e.button !== 1)) { return; }
	
			this._finish();
	
			if (!this._moved) { return; }
			// Postpone to next JS tick so internal click event handling
			// still see it as "moved".
			setTimeout(L.bind(this._resetState, this), 0);
	
			var bounds = new L.LatLngBounds(
			        this._map.containerPointToLatLng(this._startPoint),
			        this._map.containerPointToLatLng(this._point));
	
			this._map
				.fitBounds(bounds)
				.fire('boxzoomend', {boxZoomBounds: bounds});
		},
	
		_onKeyDown: function (e) {
			if (e.keyCode === 27) {
				this._finish();
			}
		}
	});
	
	// @section Handlers
	// @property boxZoom: Handler
	// Box (shift-drag with mouse) zoom handler.
	L.Map.addInitHook('addHandler', 'boxZoom', L.Map.BoxZoom);
	
	
	
	/*
	 * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
	 */
	
	// @namespace Map
	// @section Keyboard Navigation Options
	L.Map.mergeOptions({
		// @option keyboard: Boolean = true
		// Makes the map focusable and allows users to navigate the map with keyboard
		// arrows and `+`/`-` keys.
		keyboard: true,
	
		// @option keyboardPanDelta: Number = 80
		// Amount of pixels to pan when pressing an arrow key.
		keyboardPanDelta: 80
	});
	
	L.Map.Keyboard = L.Handler.extend({
	
		keyCodes: {
			left:    [37],
			right:   [39],
			down:    [40],
			up:      [38],
			zoomIn:  [187, 107, 61, 171],
			zoomOut: [189, 109, 54, 173]
		},
	
		initialize: function (map) {
			this._map = map;
	
			this._setPanDelta(map.options.keyboardPanDelta);
			this._setZoomDelta(map.options.zoomDelta);
		},
	
		addHooks: function () {
			var container = this._map._container;
	
			// make the container focusable by tabbing
			if (container.tabIndex <= 0) {
				container.tabIndex = '0';
			}
	
			L.DomEvent.on(container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.on({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		removeHooks: function () {
			this._removeHooks();
	
			L.DomEvent.off(this._map._container, {
				focus: this._onFocus,
				blur: this._onBlur,
				mousedown: this._onMouseDown
			}, this);
	
			this._map.off({
				focus: this._addHooks,
				blur: this._removeHooks
			}, this);
		},
	
		_onMouseDown: function () {
			if (this._focused) { return; }
	
			var body = document.body,
			    docEl = document.documentElement,
			    top = body.scrollTop || docEl.scrollTop,
			    left = body.scrollLeft || docEl.scrollLeft;
	
			this._map._container.focus();
	
			window.scrollTo(left, top);
		},
	
		_onFocus: function () {
			this._focused = true;
			this._map.fire('focus');
		},
	
		_onBlur: function () {
			this._focused = false;
			this._map.fire('blur');
		},
	
		_setPanDelta: function (panDelta) {
			var keys = this._panKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.left.length; i < len; i++) {
				keys[codes.left[i]] = [-1 * panDelta, 0];
			}
			for (i = 0, len = codes.right.length; i < len; i++) {
				keys[codes.right[i]] = [panDelta, 0];
			}
			for (i = 0, len = codes.down.length; i < len; i++) {
				keys[codes.down[i]] = [0, panDelta];
			}
			for (i = 0, len = codes.up.length; i < len; i++) {
				keys[codes.up[i]] = [0, -1 * panDelta];
			}
		},
	
		_setZoomDelta: function (zoomDelta) {
			var keys = this._zoomKeys = {},
			    codes = this.keyCodes,
			    i, len;
	
			for (i = 0, len = codes.zoomIn.length; i < len; i++) {
				keys[codes.zoomIn[i]] = zoomDelta;
			}
			for (i = 0, len = codes.zoomOut.length; i < len; i++) {
				keys[codes.zoomOut[i]] = -zoomDelta;
			}
		},
	
		_addHooks: function () {
			L.DomEvent.on(document, 'keydown', this._onKeyDown, this);
		},
	
		_removeHooks: function () {
			L.DomEvent.off(document, 'keydown', this._onKeyDown, this);
		},
	
		_onKeyDown: function (e) {
			if (e.altKey || e.ctrlKey || e.metaKey) { return; }
	
			var key = e.keyCode,
			    map = this._map,
			    offset;
	
			if (key in this._panKeys) {
	
				if (map._panAnim && map._panAnim._inProgress) { return; }
	
				offset = this._panKeys[key];
				if (e.shiftKey) {
					offset = L.point(offset).multiplyBy(3);
				}
	
				map.panBy(offset);
	
				if (map.options.maxBounds) {
					map.panInsideBounds(map.options.maxBounds);
				}
	
			} else if (key in this._zoomKeys) {
				map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
	
			} else if (key === 27) {
				map.closePopup();
	
			} else {
				return;
			}
	
			L.DomEvent.stop(e);
		}
	});
	
	// @section Handlers
	// @section Handlers
	// @property keyboard: Handler
	// Keyboard navigation handler.
	L.Map.addInitHook('addHandler', 'keyboard', L.Map.Keyboard);
	
	
	
	/*
	 * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
	 */
	
	
	/* @namespace Marker
	 * @section Interaction handlers
	 *
	 * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
	 *
	 * ```js
	 * marker.dragging.disable();
	 * ```
	 *
	 * @property dragging: Handler
	 * Marker dragging handler (by both mouse and touch).
	 */
	
	L.Handler.MarkerDrag = L.Handler.extend({
		initialize: function (marker) {
			this._marker = marker;
		},
	
		addHooks: function () {
			var icon = this._marker._icon;
	
			if (!this._draggable) {
				this._draggable = new L.Draggable(icon, icon, true);
			}
	
			this._draggable.on({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).enable();
	
			L.DomUtil.addClass(icon, 'leaflet-marker-draggable');
		},
	
		removeHooks: function () {
			this._draggable.off({
				dragstart: this._onDragStart,
				drag: this._onDrag,
				dragend: this._onDragEnd
			}, this).disable();
	
			if (this._marker._icon) {
				L.DomUtil.removeClass(this._marker._icon, 'leaflet-marker-draggable');
			}
		},
	
		moved: function () {
			return this._draggable && this._draggable._moved;
		},
	
		_onDragStart: function () {
			// @section Dragging events
			// @event dragstart: Event
			// Fired when the user starts dragging the marker.
	
			// @event movestart: Event
			// Fired when the marker starts moving (because of dragging).
	
			this._oldLatLng = this._marker.getLatLng();
			this._marker
			    .closePopup()
			    .fire('movestart')
			    .fire('dragstart');
		},
	
		_onDrag: function (e) {
			var marker = this._marker,
			    shadow = marker._shadow,
			    iconPos = L.DomUtil.getPosition(marker._icon),
			    latlng = marker._map.layerPointToLatLng(iconPos);
	
			// update shadow position
			if (shadow) {
				L.DomUtil.setPosition(shadow, iconPos);
			}
	
			marker._latlng = latlng;
			e.latlng = latlng;
			e.oldLatLng = this._oldLatLng;
	
			// @event drag: Event
			// Fired repeatedly while the user drags the marker.
			marker
			    .fire('move', e)
			    .fire('drag', e);
		},
	
		_onDragEnd: function (e) {
			// @event dragend: DragEndEvent
			// Fired when the user stops dragging the marker.
	
			// @event moveend: Event
			// Fired when the marker stops moving (because of dragging).
			delete this._oldLatLng;
			this._marker
			    .fire('moveend')
			    .fire('dragend', e);
		}
	});
	
	
	
	/*
	 * @class Control
	 * @aka L.Control
	 * @inherits Class
	 *
	 * L.Control is a base class for implementing map controls. Handles positioning.
	 * All other controls extend from this class.
	 */
	
	L.Control = L.Class.extend({
		// @section
		// @aka Control options
		options: {
			// @option position: String = 'topright'
			// The position of the control (one of the map corners). Possible values are `'topleft'`,
			// `'topright'`, `'bottomleft'` or `'bottomright'`
			position: 'topright'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
		},
	
		/* @section
		 * Classes extending L.Control will inherit the following methods:
		 *
		 * @method getPosition: string
		 * Returns the position of the control.
		 */
		getPosition: function () {
			return this.options.position;
		},
	
		// @method setPosition(position: string): this
		// Sets the position of the control.
		setPosition: function (position) {
			var map = this._map;
	
			if (map) {
				map.removeControl(this);
			}
	
			this.options.position = position;
	
			if (map) {
				map.addControl(this);
			}
	
			return this;
		},
	
		// @method getContainer: HTMLElement
		// Returns the HTMLElement that contains the control.
		getContainer: function () {
			return this._container;
		},
	
		// @method addTo(map: Map): this
		// Adds the control to the given map.
		addTo: function (map) {
			this.remove();
			this._map = map;
	
			var container = this._container = this.onAdd(map),
			    pos = this.getPosition(),
			    corner = map._controlCorners[pos];
	
			L.DomUtil.addClass(container, 'leaflet-control');
	
			if (pos.indexOf('bottom') !== -1) {
				corner.insertBefore(container, corner.firstChild);
			} else {
				corner.appendChild(container);
			}
	
			return this;
		},
	
		// @method remove: this
		// Removes the control from the map it is currently active on.
		remove: function () {
			if (!this._map) {
				return this;
			}
	
			L.DomUtil.remove(this._container);
	
			if (this.onRemove) {
				this.onRemove(this._map);
			}
	
			this._map = null;
	
			return this;
		},
	
		_refocusOnMap: function (e) {
			// if map exists and event is not a keyboard event
			if (this._map && e && e.screenX > 0 && e.screenY > 0) {
				this._map.getContainer().focus();
			}
		}
	});
	
	L.control = function (options) {
		return new L.Control(options);
	};
	
	/* @section Extension methods
	 * @uninheritable
	 *
	 * Every control should extend from `L.Control` and (re-)implement the following methods.
	 *
	 * @method onAdd(map: Map): HTMLElement
	 * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
	 *
	 * @method onRemove(map: Map)
	 * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
	 */
	
	/* @namespace Map
	 * @section Methods for Layers and Controls
	 */
	L.Map.include({
		// @method addControl(control: Control): this
		// Adds the given control to the map
		addControl: function (control) {
			control.addTo(this);
			return this;
		},
	
		// @method removeControl(control: Control): this
		// Removes the given control from the map
		removeControl: function (control) {
			control.remove();
			return this;
		},
	
		_initControlPos: function () {
			var corners = this._controlCorners = {},
			    l = 'leaflet-',
			    container = this._controlContainer =
			            L.DomUtil.create('div', l + 'control-container', this._container);
	
			function createCorner(vSide, hSide) {
				var className = l + vSide + ' ' + l + hSide;
	
				corners[vSide + hSide] = L.DomUtil.create('div', className, container);
			}
	
			createCorner('top', 'left');
			createCorner('top', 'right');
			createCorner('bottom', 'left');
			createCorner('bottom', 'right');
		},
	
		_clearControlPos: function () {
			L.DomUtil.remove(this._controlContainer);
		}
	});
	
	
	
	/*
	 * @class Control.Zoom
	 * @aka L.Control.Zoom
	 * @inherits Control
	 *
	 * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
	 */
	
	L.Control.Zoom = L.Control.extend({
		// @section
		// @aka Control.Zoom options
		options: {
			position: 'topleft',
	
			// @option zoomInText: String = '+'
			// The text set on the 'zoom in' button.
			zoomInText: '+',
	
			// @option zoomInTitle: String = 'Zoom in'
			// The title set on the 'zoom in' button.
			zoomInTitle: 'Zoom in',
	
			// @option zoomOutText: String = '-'
			// The text set on the 'zoom out' button.
			zoomOutText: '-',
	
			// @option zoomOutTitle: String = 'Zoom out'
			// The title set on the 'zoom out' button.
			zoomOutTitle: 'Zoom out'
		},
	
		onAdd: function (map) {
			var zoomName = 'leaflet-control-zoom',
			    container = L.DomUtil.create('div', zoomName + ' leaflet-bar'),
			    options = this.options;
	
			this._zoomInButton  = this._createButton(options.zoomInText, options.zoomInTitle,
			        zoomName + '-in',  container, this._zoomIn);
			this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle,
			        zoomName + '-out', container, this._zoomOut);
	
			this._updateDisabled();
			map.on('zoomend zoomlevelschange', this._updateDisabled, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off('zoomend zoomlevelschange', this._updateDisabled, this);
		},
	
		disable: function () {
			this._disabled = true;
			this._updateDisabled();
			return this;
		},
	
		enable: function () {
			this._disabled = false;
			this._updateDisabled();
			return this;
		},
	
		_zoomIn: function (e) {
			if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
				this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_zoomOut: function (e) {
			if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
				this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
			}
		},
	
		_createButton: function (html, title, className, container, fn) {
			var link = L.DomUtil.create('a', className, container);
			link.innerHTML = html;
			link.href = '#';
			link.title = title;
	
			/*
			 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
			 */
			link.setAttribute('role', 'button');
			link.setAttribute('aria-label', title);
	
			L.DomEvent
			    .on(link, 'mousedown dblclick', L.DomEvent.stopPropagation)
			    .on(link, 'click', L.DomEvent.stop)
			    .on(link, 'click', fn, this)
			    .on(link, 'click', this._refocusOnMap, this);
	
			return link;
		},
	
		_updateDisabled: function () {
			var map = this._map,
			    className = 'leaflet-disabled';
	
			L.DomUtil.removeClass(this._zoomInButton, className);
			L.DomUtil.removeClass(this._zoomOutButton, className);
	
			if (this._disabled || map._zoom === map.getMinZoom()) {
				L.DomUtil.addClass(this._zoomOutButton, className);
			}
			if (this._disabled || map._zoom === map.getMaxZoom()) {
				L.DomUtil.addClass(this._zoomInButton, className);
			}
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option zoomControl: Boolean = true
	// Whether a [zoom control](#control-zoom) is added to the map by default.
	L.Map.mergeOptions({
		zoomControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.zoomControl) {
			this.zoomControl = new L.Control.Zoom();
			this.addControl(this.zoomControl);
		}
	});
	
	// @namespace Control.Zoom
	// @factory L.control.zoom(options: Control.Zoom options)
	// Creates a zoom control
	L.control.zoom = function (options) {
		return new L.Control.Zoom(options);
	};
	
	
	
	/*
	 * @class Control.Attribution
	 * @aka L.Control.Attribution
	 * @inherits Control
	 *
	 * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
	 */
	
	L.Control.Attribution = L.Control.extend({
		// @section
		// @aka Control.Attribution options
		options: {
			position: 'bottomright',
	
			// @option prefix: String = 'Leaflet'
			// The HTML text shown before the attributions. Pass `false` to disable.
			prefix: '<a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>'
		},
	
		initialize: function (options) {
			L.setOptions(this, options);
	
			this._attributions = {};
		},
	
		onAdd: function (map) {
			map.attributionControl = this;
			this._container = L.DomUtil.create('div', 'leaflet-control-attribution');
			if (L.DomEvent) {
				L.DomEvent.disableClickPropagation(this._container);
			}
	
			// TODO ugly, refactor
			for (var i in map._layers) {
				if (map._layers[i].getAttribution) {
					this.addAttribution(map._layers[i].getAttribution());
				}
			}
	
			this._update();
	
			return this._container;
		},
	
		// @method setPrefix(prefix: String): this
		// Sets the text before the attributions.
		setPrefix: function (prefix) {
			this.options.prefix = prefix;
			this._update();
			return this;
		},
	
		// @method addAttribution(text: String): this
		// Adds an attribution text (e.g. `'Vector data &copy; Mapbox'`).
		addAttribution: function (text) {
			if (!text) { return this; }
	
			if (!this._attributions[text]) {
				this._attributions[text] = 0;
			}
			this._attributions[text]++;
	
			this._update();
	
			return this;
		},
	
		// @method removeAttribution(text: String): this
		// Removes an attribution text.
		removeAttribution: function (text) {
			if (!text) { return this; }
	
			if (this._attributions[text]) {
				this._attributions[text]--;
				this._update();
			}
	
			return this;
		},
	
		_update: function () {
			if (!this._map) { return; }
	
			var attribs = [];
	
			for (var i in this._attributions) {
				if (this._attributions[i]) {
					attribs.push(i);
				}
			}
	
			var prefixAndAttribs = [];
	
			if (this.options.prefix) {
				prefixAndAttribs.push(this.options.prefix);
			}
			if (attribs.length) {
				prefixAndAttribs.push(attribs.join(', '));
			}
	
			this._container.innerHTML = prefixAndAttribs.join(' | ');
		}
	});
	
	// @namespace Map
	// @section Control options
	// @option attributionControl: Boolean = true
	// Whether a [attribution control](#control-attribution) is added to the map by default.
	L.Map.mergeOptions({
		attributionControl: true
	});
	
	L.Map.addInitHook(function () {
		if (this.options.attributionControl) {
			new L.Control.Attribution().addTo(this);
		}
	});
	
	// @namespace Control.Attribution
	// @factory L.control.attribution(options: Control.Attribution options)
	// Creates an attribution control.
	L.control.attribution = function (options) {
		return new L.Control.Attribution(options);
	};
	
	
	
	/*
	 * @class Control.Scale
	 * @aka L.Control.Scale
	 * @inherits Control
	 *
	 * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * L.control.scale().addTo(map);
	 * ```
	 */
	
	L.Control.Scale = L.Control.extend({
		// @section
		// @aka Control.Scale options
		options: {
			position: 'bottomleft',
	
			// @option maxWidth: Number = 100
			// Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
			maxWidth: 100,
	
			// @option metric: Boolean = True
			// Whether to show the metric scale line (m/km).
			metric: true,
	
			// @option imperial: Boolean = True
			// Whether to show the imperial scale line (mi/ft).
			imperial: true
	
			// @option updateWhenIdle: Boolean = false
			// If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
		},
	
		onAdd: function (map) {
			var className = 'leaflet-control-scale',
			    container = L.DomUtil.create('div', className),
			    options = this.options;
	
			this._addScales(options, className + '-line', container);
	
			map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
			map.whenReady(this._update, this);
	
			return container;
		},
	
		onRemove: function (map) {
			map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
		},
	
		_addScales: function (options, className, container) {
			if (options.metric) {
				this._mScale = L.DomUtil.create('div', className, container);
			}
			if (options.imperial) {
				this._iScale = L.DomUtil.create('div', className, container);
			}
		},
	
		_update: function () {
			var map = this._map,
			    y = map.getSize().y / 2;
	
			var maxMeters = map.distance(
					map.containerPointToLatLng([0, y]),
					map.containerPointToLatLng([this.options.maxWidth, y]));
	
			this._updateScales(maxMeters);
		},
	
		_updateScales: function (maxMeters) {
			if (this.options.metric && maxMeters) {
				this._updateMetric(maxMeters);
			}
			if (this.options.imperial && maxMeters) {
				this._updateImperial(maxMeters);
			}
		},
	
		_updateMetric: function (maxMeters) {
			var meters = this._getRoundNum(maxMeters),
			    label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';
	
			this._updateScale(this._mScale, label, meters / maxMeters);
		},
	
		_updateImperial: function (maxMeters) {
			var maxFeet = maxMeters * 3.2808399,
			    maxMiles, miles, feet;
	
			if (maxFeet > 5280) {
				maxMiles = maxFeet / 5280;
				miles = this._getRoundNum(maxMiles);
				this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
	
			} else {
				feet = this._getRoundNum(maxFeet);
				this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
			}
		},
	
		_updateScale: function (scale, text, ratio) {
			scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
			scale.innerHTML = text;
		},
	
		_getRoundNum: function (num) {
			var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
			    d = num / pow10;
	
			d = d >= 10 ? 10 :
			    d >= 5 ? 5 :
			    d >= 3 ? 3 :
			    d >= 2 ? 2 : 1;
	
			return pow10 * d;
		}
	});
	
	
	// @factory L.control.scale(options?: Control.Scale options)
	// Creates an scale control with the given options.
	L.control.scale = function (options) {
		return new L.Control.Scale(options);
	};
	
	
	
	/*
	 * @class Control.Layers
	 * @aka L.Control.Layers
	 * @inherits Control
	 *
	 * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](http://leafletjs.com/examples/layers-control.html)). Extends `Control`.
	 *
	 * @example
	 *
	 * ```js
	 * var baseLayers = {
	 * 	"Mapbox": mapbox,
	 * 	"OpenStreetMap": osm
	 * };
	 *
	 * var overlays = {
	 * 	"Marker": marker,
	 * 	"Roads": roadsLayer
	 * };
	 *
	 * L.control.layers(baseLayers, overlays).addTo(map);
	 * ```
	 *
	 * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
	 *
	 * ```js
	 * {
	 *     "<someName1>": layer1,
	 *     "<someName2>": layer2
	 * }
	 * ```
	 *
	 * The layer names can contain HTML, which allows you to add additional styling to the items:
	 *
	 * ```js
	 * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
	 * ```
	 */
	
	
	L.Control.Layers = L.Control.extend({
		// @section
		// @aka Control.Layers options
		options: {
			// @option collapsed: Boolean = true
			// If `true`, the control will be collapsed into an icon and expanded on mouse hover or touch.
			collapsed: true,
			position: 'topright',
	
			// @option autoZIndex: Boolean = true
			// If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
			autoZIndex: true,
	
			// @option hideSingleBase: Boolean = false
			// If `true`, the base layers in the control will be hidden when there is only one.
			hideSingleBase: false,
	
			// @option sortLayers: Boolean = false
			// Whether to sort the layers. When `false`, layers will keep the order
			// in which they were added to the control.
			sortLayers: false,
	
			// @option sortFunction: Function = *
			// A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
			// that will be used for sorting the layers, when `sortLayers` is `true`.
			// The function receives both the `L.Layer` instances and their names, as in
			// `sortFunction(layerA, layerB, nameA, nameB)`.
			// By default, it sorts layers alphabetically by their name.
			sortFunction: function (layerA, layerB, nameA, nameB) {
				return nameA < nameB ? -1 : (nameB < nameA ? 1 : 0);
			}
		},
	
		initialize: function (baseLayers, overlays, options) {
			L.setOptions(this, options);
	
			this._layers = [];
			this._lastZIndex = 0;
			this._handlingClick = false;
	
			for (var i in baseLayers) {
				this._addLayer(baseLayers[i], i);
			}
	
			for (i in overlays) {
				this._addLayer(overlays[i], i, true);
			}
		},
	
		onAdd: function (map) {
			this._initLayout();
			this._update();
	
			this._map = map;
			map.on('zoomend', this._checkDisabledLayers, this);
	
			return this._container;
		},
	
		onRemove: function () {
			this._map.off('zoomend', this._checkDisabledLayers, this);
	
			for (var i = 0; i < this._layers.length; i++) {
				this._layers[i].layer.off('add remove', this._onLayerChange, this);
			}
		},
	
		// @method addBaseLayer(layer: Layer, name: String): this
		// Adds a base layer (radio button entry) with the given name to the control.
		addBaseLayer: function (layer, name) {
			this._addLayer(layer, name);
			return (this._map) ? this._update() : this;
		},
	
		// @method addOverlay(layer: Layer, name: String): this
		// Adds an overlay (checkbox entry) with the given name to the control.
		addOverlay: function (layer, name) {
			this._addLayer(layer, name, true);
			return (this._map) ? this._update() : this;
		},
	
		// @method removeLayer(layer: Layer): this
		// Remove the given layer from the control.
		removeLayer: function (layer) {
			layer.off('add remove', this._onLayerChange, this);
	
			var obj = this._getLayer(L.stamp(layer));
			if (obj) {
				this._layers.splice(this._layers.indexOf(obj), 1);
			}
			return (this._map) ? this._update() : this;
		},
	
		// @method expand(): this
		// Expand the control container if collapsed.
		expand: function () {
			L.DomUtil.addClass(this._container, 'leaflet-control-layers-expanded');
			this._form.style.height = null;
			var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
			if (acceptableHeight < this._form.clientHeight) {
				L.DomUtil.addClass(this._form, 'leaflet-control-layers-scrollbar');
				this._form.style.height = acceptableHeight + 'px';
			} else {
				L.DomUtil.removeClass(this._form, 'leaflet-control-layers-scrollbar');
			}
			this._checkDisabledLayers();
			return this;
		},
	
		// @method collapse(): this
		// Collapse the control container if expanded.
		collapse: function () {
			L.DomUtil.removeClass(this._container, 'leaflet-control-layers-expanded');
			return this;
		},
	
		_initLayout: function () {
			var className = 'leaflet-control-layers',
			    container = this._container = L.DomUtil.create('div', className),
			    collapsed = this.options.collapsed;
	
			// makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
			container.setAttribute('aria-haspopup', true);
	
			L.DomEvent.disableClickPropagation(container);
			if (!L.Browser.touch) {
				L.DomEvent.disableScrollPropagation(container);
			}
	
			var form = this._form = L.DomUtil.create('form', className + '-list');
	
			if (collapsed) {
				this._map.on('click', this.collapse, this);
	
				if (!L.Browser.android) {
					L.DomEvent.on(container, {
						mouseenter: this.expand,
						mouseleave: this.collapse
					}, this);
				}
			}
	
			var link = this._layersLink = L.DomUtil.create('a', className + '-toggle', container);
			link.href = '#';
			link.title = 'Layers';
	
			if (L.Browser.touch) {
				L.DomEvent
				    .on(link, 'click', L.DomEvent.stop)
				    .on(link, 'click', this.expand, this);
			} else {
				L.DomEvent.on(link, 'focus', this.expand, this);
			}
	
			// work around for Firefox Android issue https://github.com/Leaflet/Leaflet/issues/2033
			L.DomEvent.on(form, 'click', function () {
				setTimeout(L.bind(this._onInputClick, this), 0);
			}, this);
	
			// TODO keyboard accessibility
	
			if (!collapsed) {
				this.expand();
			}
	
			this._baseLayersList = L.DomUtil.create('div', className + '-base', form);
			this._separator = L.DomUtil.create('div', className + '-separator', form);
			this._overlaysList = L.DomUtil.create('div', className + '-overlays', form);
	
			container.appendChild(form);
		},
	
		_getLayer: function (id) {
			for (var i = 0; i < this._layers.length; i++) {
	
				if (this._layers[i] && L.stamp(this._layers[i].layer) === id) {
					return this._layers[i];
				}
			}
		},
	
		_addLayer: function (layer, name, overlay) {
			layer.on('add remove', this._onLayerChange, this);
	
			this._layers.push({
				layer: layer,
				name: name,
				overlay: overlay
			});
	
			if (this.options.sortLayers) {
				this._layers.sort(L.bind(function (a, b) {
					return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
				}, this));
			}
	
			if (this.options.autoZIndex && layer.setZIndex) {
				this._lastZIndex++;
				layer.setZIndex(this._lastZIndex);
			}
		},
	
		_update: function () {
			if (!this._container) { return this; }
	
			L.DomUtil.empty(this._baseLayersList);
			L.DomUtil.empty(this._overlaysList);
	
			var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
	
			for (i = 0; i < this._layers.length; i++) {
				obj = this._layers[i];
				this._addItem(obj);
				overlaysPresent = overlaysPresent || obj.overlay;
				baseLayersPresent = baseLayersPresent || !obj.overlay;
				baseLayersCount += !obj.overlay ? 1 : 0;
			}
	
			// Hide base layers section if there's only one layer.
			if (this.options.hideSingleBase) {
				baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
				this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
			}
	
			this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
	
			return this;
		},
	
		_onLayerChange: function (e) {
			if (!this._handlingClick) {
				this._update();
			}
	
			var obj = this._getLayer(L.stamp(e.target));
	
			// @namespace Map
			// @section Layer events
			// @event baselayerchange: LayersControlEvent
			// Fired when the base layer is changed through the [layer control](#control-layers).
			// @event overlayadd: LayersControlEvent
			// Fired when an overlay is selected through the [layer control](#control-layers).
			// @event overlayremove: LayersControlEvent
			// Fired when an overlay is deselected through the [layer control](#control-layers).
			// @namespace Control.Layers
			var type = obj.overlay ?
				(e.type === 'add' ? 'overlayadd' : 'overlayremove') :
				(e.type === 'add' ? 'baselayerchange' : null);
	
			if (type) {
				this._map.fire(type, obj);
			}
		},
	
		// IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see http://bit.ly/PqYLBe)
		_createRadioElement: function (name, checked) {
	
			var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' +
					name + '"' + (checked ? ' checked="checked"' : '') + '/>';
	
			var radioFragment = document.createElement('div');
			radioFragment.innerHTML = radioHtml;
	
			return radioFragment.firstChild;
		},
	
		_addItem: function (obj) {
			var label = document.createElement('label'),
			    checked = this._map.hasLayer(obj.layer),
			    input;
	
			if (obj.overlay) {
				input = document.createElement('input');
				input.type = 'checkbox';
				input.className = 'leaflet-control-layers-selector';
				input.defaultChecked = checked;
			} else {
				input = this._createRadioElement('leaflet-base-layers', checked);
			}
	
			input.layerId = L.stamp(obj.layer);
	
			L.DomEvent.on(input, 'click', this._onInputClick, this);
	
			var name = document.createElement('span');
			name.innerHTML = ' ' + obj.name;
	
			// Helps from preventing layer control flicker when checkboxes are disabled
			// https://github.com/Leaflet/Leaflet/issues/2771
			var holder = document.createElement('div');
	
			label.appendChild(holder);
			holder.appendChild(input);
			holder.appendChild(name);
	
			var container = obj.overlay ? this._overlaysList : this._baseLayersList;
			container.appendChild(label);
	
			this._checkDisabledLayers();
			return label;
		},
	
		_onInputClick: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input, layer, hasLayer;
			var addedLayers = [],
			    removedLayers = [];
	
			this._handlingClick = true;
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				hasLayer = this._map.hasLayer(layer);
	
				if (input.checked && !hasLayer) {
					addedLayers.push(layer);
	
				} else if (!input.checked && hasLayer) {
					removedLayers.push(layer);
				}
			}
	
			// Bugfix issue 2318: Should remove all old layers before readding new ones
			for (i = 0; i < removedLayers.length; i++) {
				this._map.removeLayer(removedLayers[i]);
			}
			for (i = 0; i < addedLayers.length; i++) {
				this._map.addLayer(addedLayers[i]);
			}
	
			this._handlingClick = false;
	
			this._refocusOnMap();
		},
	
		_checkDisabledLayers: function () {
			var inputs = this._form.getElementsByTagName('input'),
			    input,
			    layer,
			    zoom = this._map.getZoom();
	
			for (var i = inputs.length - 1; i >= 0; i--) {
				input = inputs[i];
				layer = this._getLayer(input.layerId).layer;
				input.disabled = (layer.options.minZoom !== undefined && zoom < layer.options.minZoom) ||
				                 (layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom);
	
			}
		},
	
		_expand: function () {
			// Backward compatibility, remove me in 1.1.
			return this.expand();
		},
	
		_collapse: function () {
			// Backward compatibility, remove me in 1.1.
			return this.collapse();
		}
	
	});
	
	
	// @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
	// Creates an attribution control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
	L.control.layers = function (baseLayers, overlays, options) {
		return new L.Control.Layers(baseLayers, overlays, options);
	};
	
	
	
	}(window, document));
	//# sourceMappingURL=leaflet-src.map

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(71);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(73);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _navLinksStrip = __webpack_require__(114);
	
	var _navLinksStrip2 = _interopRequireDefault(_navLinksStrip);
	
	var _navLinksStrip3 = __webpack_require__(116);
	
	var _navLinksStrip4 = _interopRequireDefault(_navLinksStrip3);
	
	var _navLinksStrip5 = __webpack_require__(118);
	
	var _navLinksStrip6 = _interopRequireDefault(_navLinksStrip5);
	
	var _navLinksStrip7 = __webpack_require__(120);
	
	var _navLinksStrip8 = _interopRequireDefault(_navLinksStrip7);
	
	var _map = __webpack_require__(106);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('navLinksStrip', [_angularUiRouter2.default, _navLinksStrip6.default, _navLinksStrip8.default, _map2.default]).config(_navLinksStrip2.default).controller('NavLinksStripController', _navLinksStrip4.default).name; /**
	                                                                                                                                                                                                                                                                * Created by Julio Perez on 9/20/2016.
	                                                                                                                                                                                                                                                                */

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = routes;
	/**
	 * Created by Julio Perez on 9/20/2016.
	 */
	routes.$inject = ['$stateProvider'];
	
	function routes($stateProvider) {
	
	    $stateProvider.state('navLinksStrip', {
	        url: '/navLinksStrip',
	        template: __webpack_require__(115)
	    });
	}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	module.exports = "<nav-links-strip></nav-links-strip>"

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _gaTrackingPath = __webpack_require__(117);
	
	var path = _interopRequireWildcard(_gaTrackingPath);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Created by Julio Perez on 9/20/2016.
	                                                                                                                                                           */
	
	var NavLinksStripController = function NavLinksStripController($state, navLinksStripService) {
	    _classCallCheck(this, NavLinksStripController);
	
	    var vm = this;
	    vm.subHeaderSection = 'Net Wealth Segments, $USD';
	    vm.subHeaderToggle = 'Year';
	
	    vm.navLinksStripService = navLinksStripService;
	    // vm.mapLeafletService = mapLeafletService;
	
	    vm.navLinks = vm.navLinksStripService.getSectionData();
	    vm.toggles = [{ "name": "Current",
	        "year": "2016"
	    }, { "name": "Forecast",
	        "year": "2030"
	    }];
	
	    vm.sectionSelected = $state.params.section;
	    vm.toggleSelected = $state.params.toggle;
	
	    // vm.relatedContent = vm.navLinksStripService.relatedContent;
	
	
	    if (vm.sectionSelected == null) {
	        vm.sectionSelected = vm.navLinksStripService.getContentNameByID(0).name;
	        $state.params.city = vm.sectionSelected;
	    }
	
	    if (vm.toggleSelected == null) {
	        vm.toggleSelected = "Current";
	        $state.params.city = vm.toggleSelected;
	    }
	
	    vm.changeSelection = function (section) {
	
	        vm.sectionSelected = section;
	
	        vm.trackChange(section);
	
	        $state.go('appView.headerSection', { section: section, toggle: vm.toggleSelected }, { notify: false });
	        $state.params.section = section;
	    };
	
	    vm.changeToggle = function (toggle) {
	
	        vm.toggleSelected = toggle;
	
	        vm.trackChange(toggle);
	
	        $state.go('appView.headerSection', { section: vm.sectionSelected, toggle: toggle }, { notify: false });
	        $state.params.section = toggle;
	    };
	
	    vm.trackChange = function (selection) {
	
	        if (path.isTracking) {
	            ga('send', {
	                hitType: 'event',
	                eventCategory: 'VisApps',
	                eventLabel: path.emiENV,
	                eventAction: path.emiENV + '-clicked-' + selection
	            });
	
	            ga('send', {
	                hitType: 'screenview',
	                appName: path.emiENV,
	                screenName: path.emiENV + '-clicked-' + selection
	            });
	        } else {
	            console.log("TEST: ", path.emiENV + '-clicked-' + selection);
	        }
	    };
	};
	
	exports.default = NavLinksStripController;
	
	
	NavLinksStripController.$inject = ['$state', 'navLinksStripService'];

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by Julio Perez on 8/3/2017.
	 */
	
	// export const emiENV = "PSVA-income-wealth-map-2017";
	// export const emiENV = "ELND-income-wealth-map-2017";
	var emiENV = exports.emiENV = "ECOM-income-wealth-map-2017";
	
	var isTracking = exports.isTracking = true;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Created by Julio Perez on 9/20/2016.
	 */
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(71);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _navLinksStrip = __webpack_require__(116);
	
	var _navLinksStrip2 = _interopRequireDefault(_navLinksStrip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function navLinksStrip() {
	
	    return {
	
	        restrict: "E",
	        scope: {
	            name: '='
	        },
	        template: __webpack_require__(119),
	        controller: _navLinksStrip2.default,
	        controllerAs: 'ctrl'
	
	    };
	}
	
	exports.default = _angular2.default.module('nav-links-strip.directive', []).directive('navLinksStrip', navLinksStrip).name;

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"clearfix\"></div>\r\n<div class=\"row margin-left-0\">\r\n            <div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 kill-sides\">\r\n                <h6 class=\"navlink-btn-header\">{{ctrl.subHeaderSection | uppercase}}</h6>\r\n                <span class=\"navlink-btn\"\r\n                      ng-class=\"{first: $index == 0}\"\r\n                      ng-repeat=\"navLink in ctrl.navLinks\">\r\n                    <a class=\"navlink-btn-metric\"\r\n                       id=\"{{navLink.id}}\"\r\n                       ng-class=\"{'navmenu-btn-metric-selected' : navLink.name == ctrl.sectionSelected, '': navLink.name != ctrl.sectionSelected}\"\r\n                       ng-click=\"ctrl.changeSelection(navLink.name); ctrl.linkSelected(navLink.name)\">{{navLink.name}}</br>\r\n                    <span>{{navLink.range_short}}</span>\r\n                    </a>\r\n                </span>\r\n            </div>\r\n\r\n            <div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 kill-sides\">\r\n                <h6 class=\"navlink-btn-header\">{{ctrl.subHeaderToggle | uppercase}}</h6>\r\n                <span class=\"navlink-btn\" ng-repeat=\"toggle in ctrl.toggles\">\r\n                        <a class=\"navlink-btn-metric btn-toggle\"\r\n                           id=\"{{toggle.id}}\"\r\n                           ng-class=\"{'toggle-btn-metric-selected' : toggle.name == ctrl.toggleSelected, '': toggle.name != ctrl.toggleSelected}\"\r\n                           ng-click=\"ctrl.changeToggle(toggle.name); ctrl.linkSelected(toggle.name)\">{{toggle.name}}</br>\r\n                            <span>{{toggle.year}}</span>\r\n                        </a>\r\n                    </span>\r\n            </div>\r\n\r\n            </div>"

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Created by Julio Perez on 9/20/2016.
	 */
	__webpack_require__(71);
	
	var NavLinksStripService = function () {
	    function NavLinksStripService($sce) {
	        _classCallCheck(this, NavLinksStripService);
	
	        var vm = this;
	        vm.data = __webpack_require__(121);
	        vm.contentName = vm.getContentNameByID(0);
	    }
	
	    _createClass(NavLinksStripService, [{
	        key: 'getSectionData',
	        value: function getSectionData() {
	
	            var vm = this;
	            return vm.data;
	        }
	    }, {
	        key: 'getContentNameByID',
	        value: function getContentNameByID() {
	            var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	
	            var vm = this;
	            vm.contentName = vm.data.filter(function (content) {
	                return content.index === id;
	            }).map(function (content) {
	                return {
	                    name: content.name,
	                    range_short: content.range_short,
	                    range_long: content.range_long,
	                    id: content.id
	                };
	            }).shift();
	
	            return vm.contentName;
	        }
	    }]);
	
	    return NavLinksStripService;
	}();
	
	exports.default = angular.module('navLinksStripService', []).service('navLinksStripService', NavLinksStripService).name;
	
	
	NavLinksStripService.$inject = [];

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	module.exports = [
		{
			"name": "Bottom",
			"range_short": "< $10k",
			"range_long": "< $10,000",
			"index": 0
		},
		{
			"name": "Middle",
			"range_short": "$10k - 100k",
			"range_long": "$10,000 - 100,000",
			"index": 1
		},
		{
			"name": "Affluent",
			"range_short": "$100k - 1mn",
			"range_long": "$100,000 - 1 million",
			"index": 2
		},
		{
			"name": "HNWIs",
			"range_short": "> $1mn",
			"range_long": "> 1 million",
			"index": 3
		},
		{
			"name": "Ultra-HNWIs",
			"range_short": "> $50mn",
			"range_long": "> 50 million",
			"index": 4
		}
	];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(123);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["L"] = __webpack_require__(112);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(125);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(126);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.2.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2017-03-20T18:59Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.2.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && Array.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
	        if ( nodeName( elem, "iframe" ) ) {
	            return elem.contentDocument;
	        }
	
	        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
	        // Treat the template element as a regular one in browsers that
	        // don't support it.
	        if ( nodeName( elem, "template" ) ) {
	            elem = elem.content || elem;
	        }
	
	        return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( ">tbody", elem )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName( name ) {
		var ret = jQuery.cssProps[ name ];
		if ( !ret ) {
			ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
		}
		return ret;
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with computed style
		var valueIsBorderBox,
			styles = getStyles( elem ),
			val = curCSS( elem, name, styles ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}
	
		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );
	
		// Fall back to offsetWidth/Height when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		if ( val === "auto" ) {
			val = elem[ "offset" + name[ 0 ].toUpperCase() + name.slice( 1 ) ];
		}
	
		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var doc, docElem, rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			doc = elem.ownerDocument;
			docElem = doc.documentElement;
			win = doc.defaultView;
	
			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( jQuery.isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	__webpack_require__(135);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(129);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(98)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js!../less-loader/index.js!./bootstrap-styles.loader.js!./bootstrap.config.js", function() {
				var newContent = require("!!../css-loader/index.js!../less-loader/index.js!./bootstrap-styles.loader.js!./bootstrap.config.js");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(97)();
	// imports
	
	
	// module
	exports.push([module.id, "/*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:rgba(0,0,0,0)}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.42857143;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.carousel-inner>.item>a>img,.carousel-inner>.item>img,.img-responsive,.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}.sr-only{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.42857143}dt{font-weight:700}dd{margin-left:0}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%;text-transform:uppercase}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.42857143;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.42857143}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.42857143;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.row{margin-left:-15px;margin-right:-15px}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-12{width:100%}.col-xs-11{width:91.66666667%}.col-xs-10{width:83.33333333%}.col-xs-9{width:75%}.col-xs-8{width:66.66666667%}.col-xs-7{width:58.33333333%}.col-xs-6{width:50%}.col-xs-5{width:41.66666667%}.col-xs-4{width:33.33333333%}.col-xs-3{width:25%}.col-xs-2{width:16.66666667%}.col-xs-1{width:8.33333333%}.col-xs-pull-12{right:100%}.col-xs-pull-11{right:91.66666667%}.col-xs-pull-10{right:83.33333333%}.col-xs-pull-9{right:75%}.col-xs-pull-8{right:66.66666667%}.col-xs-pull-7{right:58.33333333%}.col-xs-pull-6{right:50%}.col-xs-pull-5{right:41.66666667%}.col-xs-pull-4{right:33.33333333%}.col-xs-pull-3{right:25%}.col-xs-pull-2{right:16.66666667%}.col-xs-pull-1{right:8.33333333%}.col-xs-pull-0{right:auto}.col-xs-push-12{left:100%}.col-xs-push-11{left:91.66666667%}.col-xs-push-10{left:83.33333333%}.col-xs-push-9{left:75%}.col-xs-push-8{left:66.66666667%}.col-xs-push-7{left:58.33333333%}.col-xs-push-6{left:50%}.col-xs-push-5{left:41.66666667%}.col-xs-push-4{left:33.33333333%}.col-xs-push-3{left:25%}.col-xs-push-2{left:16.66666667%}.col-xs-push-1{left:8.33333333%}.col-xs-push-0{left:auto}.col-xs-offset-12{margin-left:100%}.col-xs-offset-11{margin-left:91.66666667%}.col-xs-offset-10{margin-left:83.33333333%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-8{margin-left:66.66666667%}.col-xs-offset-7{margin-left:58.33333333%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-5{margin-left:41.66666667%}.col-xs-offset-4{margin-left:33.33333333%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-2{margin-left:16.66666667%}.col-xs-offset-1{margin-left:8.33333333%}.col-xs-offset-0{margin-left:0}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-12{width:100%}.col-sm-11{width:91.66666667%}.col-sm-10{width:83.33333333%}.col-sm-9{width:75%}.col-sm-8{width:66.66666667%}.col-sm-7{width:58.33333333%}.col-sm-6{width:50%}.col-sm-5{width:41.66666667%}.col-sm-4{width:33.33333333%}.col-sm-3{width:25%}.col-sm-2{width:16.66666667%}.col-sm-1{width:8.33333333%}.col-sm-pull-12{right:100%}.col-sm-pull-11{right:91.66666667%}.col-sm-pull-10{right:83.33333333%}.col-sm-pull-9{right:75%}.col-sm-pull-8{right:66.66666667%}.col-sm-pull-7{right:58.33333333%}.col-sm-pull-6{right:50%}.col-sm-pull-5{right:41.66666667%}.col-sm-pull-4{right:33.33333333%}.col-sm-pull-3{right:25%}.col-sm-pull-2{right:16.66666667%}.col-sm-pull-1{right:8.33333333%}.col-sm-pull-0{right:auto}.col-sm-push-12{left:100%}.col-sm-push-11{left:91.66666667%}.col-sm-push-10{left:83.33333333%}.col-sm-push-9{left:75%}.col-sm-push-8{left:66.66666667%}.col-sm-push-7{left:58.33333333%}.col-sm-push-6{left:50%}.col-sm-push-5{left:41.66666667%}.col-sm-push-4{left:33.33333333%}.col-sm-push-3{left:25%}.col-sm-push-2{left:16.66666667%}.col-sm-push-1{left:8.33333333%}.col-sm-push-0{left:auto}.col-sm-offset-12{margin-left:100%}.col-sm-offset-11{margin-left:91.66666667%}.col-sm-offset-10{margin-left:83.33333333%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-8{margin-left:66.66666667%}.col-sm-offset-7{margin-left:58.33333333%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-5{margin-left:41.66666667%}.col-sm-offset-4{margin-left:33.33333333%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-2{margin-left:16.66666667%}.col-sm-offset-1{margin-left:8.33333333%}.col-sm-offset-0{margin-left:0}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-12{width:100%}.col-md-11{width:91.66666667%}.col-md-10{width:83.33333333%}.col-md-9{width:75%}.col-md-8{width:66.66666667%}.col-md-7{width:58.33333333%}.col-md-6{width:50%}.col-md-5{width:41.66666667%}.col-md-4{width:33.33333333%}.col-md-3{width:25%}.col-md-2{width:16.66666667%}.col-md-1{width:8.33333333%}.col-md-pull-12{right:100%}.col-md-pull-11{right:91.66666667%}.col-md-pull-10{right:83.33333333%}.col-md-pull-9{right:75%}.col-md-pull-8{right:66.66666667%}.col-md-pull-7{right:58.33333333%}.col-md-pull-6{right:50%}.col-md-pull-5{right:41.66666667%}.col-md-pull-4{right:33.33333333%}.col-md-pull-3{right:25%}.col-md-pull-2{right:16.66666667%}.col-md-pull-1{right:8.33333333%}.col-md-pull-0{right:auto}.col-md-push-12{left:100%}.col-md-push-11{left:91.66666667%}.col-md-push-10{left:83.33333333%}.col-md-push-9{left:75%}.col-md-push-8{left:66.66666667%}.col-md-push-7{left:58.33333333%}.col-md-push-6{left:50%}.col-md-push-5{left:41.66666667%}.col-md-push-4{left:33.33333333%}.col-md-push-3{left:25%}.col-md-push-2{left:16.66666667%}.col-md-push-1{left:8.33333333%}.col-md-push-0{left:auto}.col-md-offset-12{margin-left:100%}.col-md-offset-11{margin-left:91.66666667%}.col-md-offset-10{margin-left:83.33333333%}.col-md-offset-9{margin-left:75%}.col-md-offset-8{margin-left:66.66666667%}.col-md-offset-7{margin-left:58.33333333%}.col-md-offset-6{margin-left:50%}.col-md-offset-5{margin-left:41.66666667%}.col-md-offset-4{margin-left:33.33333333%}.col-md-offset-3{margin-left:25%}.col-md-offset-2{margin-left:16.66666667%}.col-md-offset-1{margin-left:8.33333333%}.col-md-offset-0{margin-left:0}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-12{width:100%}.col-lg-11{width:91.66666667%}.col-lg-10{width:83.33333333%}.col-lg-9{width:75%}.col-lg-8{width:66.66666667%}.col-lg-7{width:58.33333333%}.col-lg-6{width:50%}.col-lg-5{width:41.66666667%}.col-lg-4{width:33.33333333%}.col-lg-3{width:25%}.col-lg-2{width:16.66666667%}.col-lg-1{width:8.33333333%}.col-lg-pull-12{right:100%}.col-lg-pull-11{right:91.66666667%}.col-lg-pull-10{right:83.33333333%}.col-lg-pull-9{right:75%}.col-lg-pull-8{right:66.66666667%}.col-lg-pull-7{right:58.33333333%}.col-lg-pull-6{right:50%}.col-lg-pull-5{right:41.66666667%}.col-lg-pull-4{right:33.33333333%}.col-lg-pull-3{right:25%}.col-lg-pull-2{right:16.66666667%}.col-lg-pull-1{right:8.33333333%}.col-lg-pull-0{right:auto}.col-lg-push-12{left:100%}.col-lg-push-11{left:91.66666667%}.col-lg-push-10{left:83.33333333%}.col-lg-push-9{left:75%}.col-lg-push-8{left:66.66666667%}.col-lg-push-7{left:58.33333333%}.col-lg-push-6{left:50%}.col-lg-push-5{left:41.66666667%}.col-lg-push-4{left:33.33333333%}.col-lg-push-3{left:25%}.col-lg-push-2{left:16.66666667%}.col-lg-push-1{left:8.33333333%}.col-lg-push-0{left:auto}.col-lg-offset-12{margin-left:100%}.col-lg-offset-11{margin-left:91.66666667%}.col-lg-offset-10{margin-left:83.33333333%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-8{margin-left:66.66666667%}.col-lg-offset-7{margin-left:58.33333333%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-5{margin-left:41.66666667%}.col-lg-offset-4{margin-left:33.33333333%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-2{margin-left:16.66666667%}.col-lg-offset-1{margin-left:8.33333333%}.col-lg-offset-0{margin-left:0}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.42857143;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.42857143;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm{padding-left:0;padding-right:0}.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-sm{height:30px;line-height:30px}select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-lg{height:46px;line-height:46px}select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.42857143;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.dropdown-toggle.btn-default{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.dropdown-toggle.btn-default.focus,.open>.dropdown-toggle.btn-default:focus,.open>.dropdown-toggle.btn-default:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.dropdown-toggle.btn-default{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.dropdown-toggle.btn-primary{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.dropdown-toggle.btn-primary.focus,.open>.dropdown-toggle.btn-primary:focus,.open>.dropdown-toggle.btn-primary:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.dropdown-toggle.btn-primary{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.dropdown-toggle.btn-success{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.dropdown-toggle.btn-success.focus,.open>.dropdown-toggle.btn-success:focus,.open>.dropdown-toggle.btn-success:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.dropdown-toggle.btn-success{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.dropdown-toggle.btn-info{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.dropdown-toggle.btn-info.focus,.open>.dropdown-toggle.btn-info:focus,.open>.dropdown-toggle.btn-info:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.dropdown-toggle.btn-info{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.dropdown-toggle.btn-warning{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.dropdown-toggle.btn-warning.focus,.open>.dropdown-toggle.btn-warning:focus,.open>.dropdown-toggle.btn-warning:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.dropdown-toggle.btn-warning{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.dropdown-toggle.btn-danger{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.dropdown-toggle.btn-danger.focus,.open>.dropdown-toggle.btn-danger:focus,.open>.dropdown-toggle.btn-danger:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.dropdown-toggle.btn-danger{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}@font-face{font-family:Glyphicons Halflings;src:url(" + __webpack_require__(130) + ");src:url(" + __webpack_require__(130) + "?#iefix) format(\"embedded-opentype\"),url(" + __webpack_require__(131) + ") format(\"woff2\"),url(" + __webpack_require__(132) + ") format(\"woff\"),url(" + __webpack_require__(133) + ") format(\"truetype\"),url(" + __webpack_require__(134) + "#glyphicons_halflingsregular) format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.42857143;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{left:auto;right:0}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn{height:46px;line-height:46px}select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn,textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn{height:auto}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn{height:30px;line-height:30px}select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn,textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn{height:auto}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.42857143;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-tabs.nav-justified{width:100%;border-bottom:0}.nav-tabs.nav-justified>li{float:none}.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-tabs.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified{width:100%}.nav-justified>li{float:none}.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified{border-bottom:0}.nav-tabs-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}@media (min-width:768px){.navbar{border-radius:4px}}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#080808}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#080808;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#080808}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.42857143;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label:empty{display:none}.btn .label{position:relative;top:-1px}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.42857143;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{margin-left:auto;margin-right:auto}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.thumbnail .caption{padding:9px;color:#333}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@-webkit-keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{-webkit-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{-webkit-transform:translateY(-25%);transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{-webkit-transform:translate(0);transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.42857143}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.42857143;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-perspective:1000px;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{-webkit-transform:translate3d(100%,0,0);transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{-webkit-transform:translate3d(-100%,0,0);transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{-webkit-transform:translateZ(0);transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before,.btn-toolbar:after,.btn-toolbar:before,.clearfix:after,.clearfix:before,.container-fluid:after,.container-fluid:before,.container:after,.container:before,.dl-horizontal dd:after,.dl-horizontal dd:before,.form-horizontal .form-group:after,.form-horizontal .form-group:before,.modal-footer:after,.modal-footer:before,.modal-header:after,.modal-header:before,.nav:after,.nav:before,.navbar-collapse:after,.navbar-collapse:before,.navbar-header:after,.navbar-header:before,.navbar:after,.navbar:before,.pager:after,.pager:before,.panel-body:after,.panel-body:before,.row:after,.row:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after,.btn-toolbar:after,.clearfix:after,.container-fluid:after,.container:after,.dl-horizontal dd:after,.form-horizontal .form-group:after,.modal-footer:after,.modal-header:after,.nav:after,.navbar-collapse:after,.navbar-header:after,.navbar:after,.pager:after,.panel-body:after,.row:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}", ""]);
	
	// exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/glyphicons-halflings-regular.eot";

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/glyphicons-halflings-regular.448c3.woff2";

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/glyphicons-halflings-regular.fa277.woff";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fonts/glyphicons-halflings-regular.e18bb.ttf";

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/glyphicons-halflings-regular.89889.svg";

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(136);
	__webpack_require__(137);
	__webpack_require__(138);
	__webpack_require__(139);
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(142);
	__webpack_require__(143);
	__webpack_require__(144);
	__webpack_require__(145);
	__webpack_require__(146);
	__webpack_require__(147);

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: transition.js v3.3.7
	 * http://getbootstrap.com/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // http://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: alert.js v3.3.7
	 * http://getbootstrap.com/javascript/#alerts
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // ALERT CLASS DEFINITION
	  // ======================
	
	  var dismiss = '[data-dismiss="alert"]'
	  var Alert   = function (el) {
	    $(el).on('click', dismiss, this.close)
	  }
	
	  Alert.VERSION = '3.3.7'
	
	  Alert.TRANSITION_DURATION = 150
	
	  Alert.prototype.close = function (e) {
	    var $this    = $(this)
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = $(selector === '#' ? [] : selector)
	
	    if (e) e.preventDefault()
	
	    if (!$parent.length) {
	      $parent = $this.closest('.alert')
	    }
	
	    $parent.trigger(e = $.Event('close.bs.alert'))
	
	    if (e.isDefaultPrevented()) return
	
	    $parent.removeClass('in')
	
	    function removeElement() {
	      // detach from parent, fire event then clean up data
	      $parent.detach().trigger('closed.bs.alert').remove()
	    }
	
	    $.support.transition && $parent.hasClass('fade') ?
	      $parent
	        .one('bsTransitionEnd', removeElement)
	        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
	      removeElement()
	  }
	
	
	  // ALERT PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.alert')
	
	      if (!data) $this.data('bs.alert', (data = new Alert(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.alert
	
	  $.fn.alert             = Plugin
	  $.fn.alert.Constructor = Alert
	
	
	  // ALERT NO CONFLICT
	  // =================
	
	  $.fn.alert.noConflict = function () {
	    $.fn.alert = old
	    return this
	  }
	
	
	  // ALERT DATA-API
	  // ==============
	
	  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)
	
	}(jQuery);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: button.js v3.3.7
	 * http://getbootstrap.com/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.3.7'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);


/***/ }),
/* 139 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: carousel.js v3.3.7
	 * http://getbootstrap.com/javascript/#carousel
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CAROUSEL CLASS DEFINITION
	  // =========================
	
	  var Carousel = function (element, options) {
	    this.$element    = $(element)
	    this.$indicators = this.$element.find('.carousel-indicators')
	    this.options     = options
	    this.paused      = null
	    this.sliding     = null
	    this.interval    = null
	    this.$active     = null
	    this.$items      = null
	
	    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))
	
	    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
	      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
	      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
	  }
	
	  Carousel.VERSION  = '3.3.7'
	
	  Carousel.TRANSITION_DURATION = 600
	
	  Carousel.DEFAULTS = {
	    interval: 5000,
	    pause: 'hover',
	    wrap: true,
	    keyboard: true
	  }
	
	  Carousel.prototype.keydown = function (e) {
	    if (/input|textarea/i.test(e.target.tagName)) return
	    switch (e.which) {
	      case 37: this.prev(); break
	      case 39: this.next(); break
	      default: return
	    }
	
	    e.preventDefault()
	  }
	
	  Carousel.prototype.cycle = function (e) {
	    e || (this.paused = false)
	
	    this.interval && clearInterval(this.interval)
	
	    this.options.interval
	      && !this.paused
	      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))
	
	    return this
	  }
	
	  Carousel.prototype.getItemIndex = function (item) {
	    this.$items = item.parent().children('.item')
	    return this.$items.index(item || this.$active)
	  }
	
	  Carousel.prototype.getItemForDirection = function (direction, active) {
	    var activeIndex = this.getItemIndex(active)
	    var willWrap = (direction == 'prev' && activeIndex === 0)
	                || (direction == 'next' && activeIndex == (this.$items.length - 1))
	    if (willWrap && !this.options.wrap) return active
	    var delta = direction == 'prev' ? -1 : 1
	    var itemIndex = (activeIndex + delta) % this.$items.length
	    return this.$items.eq(itemIndex)
	  }
	
	  Carousel.prototype.to = function (pos) {
	    var that        = this
	    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))
	
	    if (pos > (this.$items.length - 1) || pos < 0) return
	
	    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
	    if (activeIndex == pos) return this.pause().cycle()
	
	    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
	  }
	
	  Carousel.prototype.pause = function (e) {
	    e || (this.paused = true)
	
	    if (this.$element.find('.next, .prev').length && $.support.transition) {
	      this.$element.trigger($.support.transition.end)
	      this.cycle(true)
	    }
	
	    this.interval = clearInterval(this.interval)
	
	    return this
	  }
	
	  Carousel.prototype.next = function () {
	    if (this.sliding) return
	    return this.slide('next')
	  }
	
	  Carousel.prototype.prev = function () {
	    if (this.sliding) return
	    return this.slide('prev')
	  }
	
	  Carousel.prototype.slide = function (type, next) {
	    var $active   = this.$element.find('.item.active')
	    var $next     = next || this.getItemForDirection(type, $active)
	    var isCycling = this.interval
	    var direction = type == 'next' ? 'left' : 'right'
	    var that      = this
	
	    if ($next.hasClass('active')) return (this.sliding = false)
	
	    var relatedTarget = $next[0]
	    var slideEvent = $.Event('slide.bs.carousel', {
	      relatedTarget: relatedTarget,
	      direction: direction
	    })
	    this.$element.trigger(slideEvent)
	    if (slideEvent.isDefaultPrevented()) return
	
	    this.sliding = true
	
	    isCycling && this.pause()
	
	    if (this.$indicators.length) {
	      this.$indicators.find('.active').removeClass('active')
	      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
	      $nextIndicator && $nextIndicator.addClass('active')
	    }
	
	    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
	    if ($.support.transition && this.$element.hasClass('slide')) {
	      $next.addClass(type)
	      $next[0].offsetWidth // force reflow
	      $active.addClass(direction)
	      $next.addClass(direction)
	      $active
	        .one('bsTransitionEnd', function () {
	          $next.removeClass([type, direction].join(' ')).addClass('active')
	          $active.removeClass(['active', direction].join(' '))
	          that.sliding = false
	          setTimeout(function () {
	            that.$element.trigger(slidEvent)
	          }, 0)
	        })
	        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
	    } else {
	      $active.removeClass('active')
	      $next.addClass('active')
	      this.sliding = false
	      this.$element.trigger(slidEvent)
	    }
	
	    isCycling && this.cycle()
	
	    return this
	  }
	
	
	  // CAROUSEL PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.carousel')
	      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
	      var action  = typeof option == 'string' ? option : options.slide
	
	      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
	      if (typeof option == 'number') data.to(option)
	      else if (action) data[action]()
	      else if (options.interval) data.pause().cycle()
	    })
	  }
	
	  var old = $.fn.carousel
	
	  $.fn.carousel             = Plugin
	  $.fn.carousel.Constructor = Carousel
	
	
	  // CAROUSEL NO CONFLICT
	  // ====================
	
	  $.fn.carousel.noConflict = function () {
	    $.fn.carousel = old
	    return this
	  }
	
	
	  // CAROUSEL DATA-API
	  // =================
	
	  var clickHandler = function (e) {
	    var href
	    var $this   = $(this)
	    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	    if (!$target.hasClass('carousel')) return
	    var options = $.extend({}, $target.data(), $this.data())
	    var slideIndex = $this.attr('data-slide-to')
	    if (slideIndex) options.interval = false
	
	    Plugin.call($target, options)
	
	    if (slideIndex) {
	      $target.data('bs.carousel').to(slideIndex)
	    }
	
	    e.preventDefault()
	  }
	
	  $(document)
	    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
	    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)
	
	  $(window).on('load', function () {
	    $('[data-ride="carousel"]').each(function () {
	      var $carousel = $(this)
	      Plugin.call($carousel, $carousel.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 140 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: collapse.js v3.3.7
	 * http://getbootstrap.com/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.3.7'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: dropdown.js v3.3.7
	 * http://getbootstrap.com/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.3.7'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector && $(selector)
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: modal.js v3.3.7
	 * http://getbootstrap.com/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options             = options
	    this.$body               = $(document.body)
	    this.$element            = $(element)
	    this.$dialog             = this.$element.find('.modal-dialog')
	    this.$backdrop           = null
	    this.isShown             = null
	    this.originalBodyPad     = null
	    this.scrollbarWidth      = 0
	    this.ignoreBackdropClick = false
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION  = '3.3.7'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	            this.$element[0] !== e.target &&
	            !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal             = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this   = $(this)
	    var href    = $this.attr('href')
	    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
	    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tooltip.js v3.3.7
	 * http://getbootstrap.com/javascript/#tooltip
	 * Inspired by the original jQuery.tipsy by Jason Frame
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TOOLTIP PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Tooltip = function (element, options) {
	    this.type       = null
	    this.options    = null
	    this.enabled    = null
	    this.timeout    = null
	    this.hoverState = null
	    this.$element   = null
	    this.inState    = null
	
	    this.init('tooltip', element, options)
	  }
	
	  Tooltip.VERSION  = '3.3.7'
	
	  Tooltip.TRANSITION_DURATION = 150
	
	  Tooltip.DEFAULTS = {
	    animation: true,
	    placement: 'top',
	    selector: false,
	    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
	    trigger: 'hover focus',
	    title: '',
	    delay: 0,
	    html: false,
	    container: false,
	    viewport: {
	      selector: 'body',
	      padding: 0
	    }
	  }
	
	  Tooltip.prototype.init = function (type, element, options) {
	    this.enabled   = true
	    this.type      = type
	    this.$element  = $(element)
	    this.options   = this.getOptions(options)
	    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
	    this.inState   = { click: false, hover: false, focus: false }
	
	    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
	      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
	    }
	
	    var triggers = this.options.trigger.split(' ')
	
	    for (var i = triggers.length; i--;) {
	      var trigger = triggers[i]
	
	      if (trigger == 'click') {
	        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
	      } else if (trigger != 'manual') {
	        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
	        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'
	
	        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
	        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
	      }
	    }
	
	    this.options.selector ?
	      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
	      this.fixTitle()
	  }
	
	  Tooltip.prototype.getDefaults = function () {
	    return Tooltip.DEFAULTS
	  }
	
	  Tooltip.prototype.getOptions = function (options) {
	    options = $.extend({}, this.getDefaults(), this.$element.data(), options)
	
	    if (options.delay && typeof options.delay == 'number') {
	      options.delay = {
	        show: options.delay,
	        hide: options.delay
	      }
	    }
	
	    return options
	  }
	
	  Tooltip.prototype.getDelegateOptions = function () {
	    var options  = {}
	    var defaults = this.getDefaults()
	
	    this._options && $.each(this._options, function (key, value) {
	      if (defaults[key] != value) options[key] = value
	    })
	
	    return options
	  }
	
	  Tooltip.prototype.enter = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
	    }
	
	    if (self.tip().hasClass('in') || self.hoverState == 'in') {
	      self.hoverState = 'in'
	      return
	    }
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'in'
	
	    if (!self.options.delay || !self.options.delay.show) return self.show()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'in') self.show()
	    }, self.options.delay.show)
	  }
	
	  Tooltip.prototype.isInStateTrue = function () {
	    for (var key in this.inState) {
	      if (this.inState[key]) return true
	    }
	
	    return false
	  }
	
	  Tooltip.prototype.leave = function (obj) {
	    var self = obj instanceof this.constructor ?
	      obj : $(obj.currentTarget).data('bs.' + this.type)
	
	    if (!self) {
	      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
	      $(obj.currentTarget).data('bs.' + this.type, self)
	    }
	
	    if (obj instanceof $.Event) {
	      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
	    }
	
	    if (self.isInStateTrue()) return
	
	    clearTimeout(self.timeout)
	
	    self.hoverState = 'out'
	
	    if (!self.options.delay || !self.options.delay.hide) return self.hide()
	
	    self.timeout = setTimeout(function () {
	      if (self.hoverState == 'out') self.hide()
	    }, self.options.delay.hide)
	  }
	
	  Tooltip.prototype.show = function () {
	    var e = $.Event('show.bs.' + this.type)
	
	    if (this.hasContent() && this.enabled) {
	      this.$element.trigger(e)
	
	      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
	      if (e.isDefaultPrevented() || !inDom) return
	      var that = this
	
	      var $tip = this.tip()
	
	      var tipId = this.getUID(this.type)
	
	      this.setContent()
	      $tip.attr('id', tipId)
	      this.$element.attr('aria-describedby', tipId)
	
	      if (this.options.animation) $tip.addClass('fade')
	
	      var placement = typeof this.options.placement == 'function' ?
	        this.options.placement.call(this, $tip[0], this.$element[0]) :
	        this.options.placement
	
	      var autoToken = /\s?auto?\s?/i
	      var autoPlace = autoToken.test(placement)
	      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'
	
	      $tip
	        .detach()
	        .css({ top: 0, left: 0, display: 'block' })
	        .addClass(placement)
	        .data('bs.' + this.type, this)
	
	      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
	      this.$element.trigger('inserted.bs.' + this.type)
	
	      var pos          = this.getPosition()
	      var actualWidth  = $tip[0].offsetWidth
	      var actualHeight = $tip[0].offsetHeight
	
	      if (autoPlace) {
	        var orgPlacement = placement
	        var viewportDim = this.getPosition(this.$viewport)
	
	        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
	                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
	                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
	                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
	                    placement
	
	        $tip
	          .removeClass(orgPlacement)
	          .addClass(placement)
	      }
	
	      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)
	
	      this.applyPlacement(calculatedOffset, placement)
	
	      var complete = function () {
	        var prevHoverState = that.hoverState
	        that.$element.trigger('shown.bs.' + that.type)
	        that.hoverState = null
	
	        if (prevHoverState == 'out') that.leave(that)
	      }
	
	      $.support.transition && this.$tip.hasClass('fade') ?
	        $tip
	          .one('bsTransitionEnd', complete)
	          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	        complete()
	    }
	  }
	
	  Tooltip.prototype.applyPlacement = function (offset, placement) {
	    var $tip   = this.tip()
	    var width  = $tip[0].offsetWidth
	    var height = $tip[0].offsetHeight
	
	    // manually read margins because getBoundingClientRect includes difference
	    var marginTop = parseInt($tip.css('margin-top'), 10)
	    var marginLeft = parseInt($tip.css('margin-left'), 10)
	
	    // we must check for NaN for ie 8/9
	    if (isNaN(marginTop))  marginTop  = 0
	    if (isNaN(marginLeft)) marginLeft = 0
	
	    offset.top  += marginTop
	    offset.left += marginLeft
	
	    // $.fn.offset doesn't round pixel values
	    // so we use setOffset directly with our own function B-0
	    $.offset.setOffset($tip[0], $.extend({
	      using: function (props) {
	        $tip.css({
	          top: Math.round(props.top),
	          left: Math.round(props.left)
	        })
	      }
	    }, offset), 0)
	
	    $tip.addClass('in')
	
	    // check to see if placing tip in new offset caused the tip to resize itself
	    var actualWidth  = $tip[0].offsetWidth
	    var actualHeight = $tip[0].offsetHeight
	
	    if (placement == 'top' && actualHeight != height) {
	      offset.top = offset.top + height - actualHeight
	    }
	
	    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)
	
	    if (delta.left) offset.left += delta.left
	    else offset.top += delta.top
	
	    var isVertical          = /top|bottom/.test(placement)
	    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
	    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'
	
	    $tip.offset(offset)
	    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
	  }
	
	  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
	    this.arrow()
	      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
	      .css(isVertical ? 'top' : 'left', '')
	  }
	
	  Tooltip.prototype.setContent = function () {
	    var $tip  = this.tip()
	    var title = this.getTitle()
	
	    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
	    $tip.removeClass('fade in top bottom left right')
	  }
	
	  Tooltip.prototype.hide = function (callback) {
	    var that = this
	    var $tip = $(this.$tip)
	    var e    = $.Event('hide.bs.' + this.type)
	
	    function complete() {
	      if (that.hoverState != 'in') $tip.detach()
	      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
	        that.$element
	          .removeAttr('aria-describedby')
	          .trigger('hidden.bs.' + that.type)
	      }
	      callback && callback()
	    }
	
	    this.$element.trigger(e)
	
	    if (e.isDefaultPrevented()) return
	
	    $tip.removeClass('in')
	
	    $.support.transition && $tip.hasClass('fade') ?
	      $tip
	        .one('bsTransitionEnd', complete)
	        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
	      complete()
	
	    this.hoverState = null
	
	    return this
	  }
	
	  Tooltip.prototype.fixTitle = function () {
	    var $e = this.$element
	    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
	      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
	    }
	  }
	
	  Tooltip.prototype.hasContent = function () {
	    return this.getTitle()
	  }
	
	  Tooltip.prototype.getPosition = function ($element) {
	    $element   = $element || this.$element
	
	    var el     = $element[0]
	    var isBody = el.tagName == 'BODY'
	
	    var elRect    = el.getBoundingClientRect()
	    if (elRect.width == null) {
	      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
	      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
	    }
	    var isSvg = window.SVGElement && el instanceof window.SVGElement
	    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
	    // See https://github.com/twbs/bootstrap/issues/20280
	    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
	    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
	    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null
	
	    return $.extend({}, elRect, scroll, outerDims, elOffset)
	  }
	
	  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
	    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
	           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
	        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }
	
	  }
	
	  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
	    var delta = { top: 0, left: 0 }
	    if (!this.$viewport) return delta
	
	    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
	    var viewportDimensions = this.getPosition(this.$viewport)
	
	    if (/right|left/.test(placement)) {
	      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
	      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
	      if (topEdgeOffset < viewportDimensions.top) { // top overflow
	        delta.top = viewportDimensions.top - topEdgeOffset
	      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
	        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
	      }
	    } else {
	      var leftEdgeOffset  = pos.left - viewportPadding
	      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
	      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
	        delta.left = viewportDimensions.left - leftEdgeOffset
	      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
	        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
	      }
	    }
	
	    return delta
	  }
	
	  Tooltip.prototype.getTitle = function () {
	    var title
	    var $e = this.$element
	    var o  = this.options
	
	    title = $e.attr('data-original-title')
	      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)
	
	    return title
	  }
	
	  Tooltip.prototype.getUID = function (prefix) {
	    do prefix += ~~(Math.random() * 1000000)
	    while (document.getElementById(prefix))
	    return prefix
	  }
	
	  Tooltip.prototype.tip = function () {
	    if (!this.$tip) {
	      this.$tip = $(this.options.template)
	      if (this.$tip.length != 1) {
	        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
	      }
	    }
	    return this.$tip
	  }
	
	  Tooltip.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
	  }
	
	  Tooltip.prototype.enable = function () {
	    this.enabled = true
	  }
	
	  Tooltip.prototype.disable = function () {
	    this.enabled = false
	  }
	
	  Tooltip.prototype.toggleEnabled = function () {
	    this.enabled = !this.enabled
	  }
	
	  Tooltip.prototype.toggle = function (e) {
	    var self = this
	    if (e) {
	      self = $(e.currentTarget).data('bs.' + this.type)
	      if (!self) {
	        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
	        $(e.currentTarget).data('bs.' + this.type, self)
	      }
	    }
	
	    if (e) {
	      self.inState.click = !self.inState.click
	      if (self.isInStateTrue()) self.enter(self)
	      else self.leave(self)
	    } else {
	      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
	    }
	  }
	
	  Tooltip.prototype.destroy = function () {
	    var that = this
	    clearTimeout(this.timeout)
	    this.hide(function () {
	      that.$element.off('.' + that.type).removeData('bs.' + that.type)
	      if (that.$tip) {
	        that.$tip.detach()
	      }
	      that.$tip = null
	      that.$arrow = null
	      that.$viewport = null
	      that.$element = null
	    })
	  }
	
	
	  // TOOLTIP PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.tooltip')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tooltip
	
	  $.fn.tooltip             = Plugin
	  $.fn.tooltip.Constructor = Tooltip
	
	
	  // TOOLTIP NO CONFLICT
	  // ===================
	
	  $.fn.tooltip.noConflict = function () {
	    $.fn.tooltip = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 144 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: popover.js v3.3.7
	 * http://getbootstrap.com/javascript/#popovers
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // POPOVER PUBLIC CLASS DEFINITION
	  // ===============================
	
	  var Popover = function (element, options) {
	    this.init('popover', element, options)
	  }
	
	  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')
	
	  Popover.VERSION  = '3.3.7'
	
	  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
	    placement: 'right',
	    trigger: 'click',
	    content: '',
	    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
	  })
	
	
	  // NOTE: POPOVER EXTENDS tooltip.js
	  // ================================
	
	  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)
	
	  Popover.prototype.constructor = Popover
	
	  Popover.prototype.getDefaults = function () {
	    return Popover.DEFAULTS
	  }
	
	  Popover.prototype.setContent = function () {
	    var $tip    = this.tip()
	    var title   = this.getTitle()
	    var content = this.getContent()
	
	    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
	    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
	      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
	    ](content)
	
	    $tip.removeClass('fade top bottom left right in')
	
	    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
	    // this manually by checking the contents.
	    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
	  }
	
	  Popover.prototype.hasContent = function () {
	    return this.getTitle() || this.getContent()
	  }
	
	  Popover.prototype.getContent = function () {
	    var $e = this.$element
	    var o  = this.options
	
	    return $e.attr('data-content')
	      || (typeof o.content == 'function' ?
	            o.content.call($e[0]) :
	            o.content)
	  }
	
	  Popover.prototype.arrow = function () {
	    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
	  }
	
	
	  // POPOVER PLUGIN DEFINITION
	  // =========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.popover')
	      var options = typeof option == 'object' && option
	
	      if (!data && /destroy|hide/.test(option)) return
	      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.popover
	
	  $.fn.popover             = Plugin
	  $.fn.popover.Constructor = Popover
	
	
	  // POPOVER NO CONFLICT
	  // ===================
	
	  $.fn.popover.noConflict = function () {
	    $.fn.popover = old
	    return this
	  }
	
	}(jQuery);


/***/ }),
/* 145 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: scrollspy.js v3.3.7
	 * http://getbootstrap.com/javascript/#scrollspy
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // SCROLLSPY CLASS DEFINITION
	  // ==========================
	
	  function ScrollSpy(element, options) {
	    this.$body          = $(document.body)
	    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
	    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
	    this.selector       = (this.options.target || '') + ' .nav li > a'
	    this.offsets        = []
	    this.targets        = []
	    this.activeTarget   = null
	    this.scrollHeight   = 0
	
	    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
	    this.refresh()
	    this.process()
	  }
	
	  ScrollSpy.VERSION  = '3.3.7'
	
	  ScrollSpy.DEFAULTS = {
	    offset: 10
	  }
	
	  ScrollSpy.prototype.getScrollHeight = function () {
	    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
	  }
	
	  ScrollSpy.prototype.refresh = function () {
	    var that          = this
	    var offsetMethod  = 'offset'
	    var offsetBase    = 0
	
	    this.offsets      = []
	    this.targets      = []
	    this.scrollHeight = this.getScrollHeight()
	
	    if (!$.isWindow(this.$scrollElement[0])) {
	      offsetMethod = 'position'
	      offsetBase   = this.$scrollElement.scrollTop()
	    }
	
	    this.$body
	      .find(this.selector)
	      .map(function () {
	        var $el   = $(this)
	        var href  = $el.data('target') || $el.attr('href')
	        var $href = /^#./.test(href) && $(href)
	
	        return ($href
	          && $href.length
	          && $href.is(':visible')
	          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
	      })
	      .sort(function (a, b) { return a[0] - b[0] })
	      .each(function () {
	        that.offsets.push(this[0])
	        that.targets.push(this[1])
	      })
	  }
	
	  ScrollSpy.prototype.process = function () {
	    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
	    var scrollHeight = this.getScrollHeight()
	    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
	    var offsets      = this.offsets
	    var targets      = this.targets
	    var activeTarget = this.activeTarget
	    var i
	
	    if (this.scrollHeight != scrollHeight) {
	      this.refresh()
	    }
	
	    if (scrollTop >= maxScroll) {
	      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
	    }
	
	    if (activeTarget && scrollTop < offsets[0]) {
	      this.activeTarget = null
	      return this.clear()
	    }
	
	    for (i = offsets.length; i--;) {
	      activeTarget != targets[i]
	        && scrollTop >= offsets[i]
	        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
	        && this.activate(targets[i])
	    }
	  }
	
	  ScrollSpy.prototype.activate = function (target) {
	    this.activeTarget = target
	
	    this.clear()
	
	    var selector = this.selector +
	      '[data-target="' + target + '"],' +
	      this.selector + '[href="' + target + '"]'
	
	    var active = $(selector)
	      .parents('li')
	      .addClass('active')
	
	    if (active.parent('.dropdown-menu').length) {
	      active = active
	        .closest('li.dropdown')
	        .addClass('active')
	    }
	
	    active.trigger('activate.bs.scrollspy')
	  }
	
	  ScrollSpy.prototype.clear = function () {
	    $(this.selector)
	      .parentsUntil(this.options.target, '.active')
	      .removeClass('active')
	  }
	
	
	  // SCROLLSPY PLUGIN DEFINITION
	  // ===========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.scrollspy')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.scrollspy
	
	  $.fn.scrollspy             = Plugin
	  $.fn.scrollspy.Constructor = ScrollSpy
	
	
	  // SCROLLSPY NO CONFLICT
	  // =====================
	
	  $.fn.scrollspy.noConflict = function () {
	    $.fn.scrollspy = old
	    return this
	  }
	
	
	  // SCROLLSPY DATA-API
	  // ==================
	
	  $(window).on('load.bs.scrollspy.data-api', function () {
	    $('[data-spy="scroll"]').each(function () {
	      var $spy = $(this)
	      Plugin.call($spy, $spy.data())
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 146 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: tab.js v3.3.7
	 * http://getbootstrap.com/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.3.7'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	          .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	            .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	            .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	/* ========================================================================
	 * Bootstrap: affix.js v3.3.7
	 * http://getbootstrap.com/javascript/#affix
	 * ========================================================================
	 * Copyright 2011-2016 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // AFFIX CLASS DEFINITION
	  // ======================
	
	  var Affix = function (element, options) {
	    this.options = $.extend({}, Affix.DEFAULTS, options)
	
	    this.$target = $(this.options.target)
	      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
	      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))
	
	    this.$element     = $(element)
	    this.affixed      = null
	    this.unpin        = null
	    this.pinnedOffset = null
	
	    this.checkPosition()
	  }
	
	  Affix.VERSION  = '3.3.7'
	
	  Affix.RESET    = 'affix affix-top affix-bottom'
	
	  Affix.DEFAULTS = {
	    offset: 0,
	    target: window
	  }
	
	  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
	    var scrollTop    = this.$target.scrollTop()
	    var position     = this.$element.offset()
	    var targetHeight = this.$target.height()
	
	    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false
	
	    if (this.affixed == 'bottom') {
	      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
	      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
	    }
	
	    var initializing   = this.affixed == null
	    var colliderTop    = initializing ? scrollTop : position.top
	    var colliderHeight = initializing ? targetHeight : height
	
	    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
	    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'
	
	    return false
	  }
	
	  Affix.prototype.getPinnedOffset = function () {
	    if (this.pinnedOffset) return this.pinnedOffset
	    this.$element.removeClass(Affix.RESET).addClass('affix')
	    var scrollTop = this.$target.scrollTop()
	    var position  = this.$element.offset()
	    return (this.pinnedOffset = position.top - scrollTop)
	  }
	
	  Affix.prototype.checkPositionWithEventLoop = function () {
	    setTimeout($.proxy(this.checkPosition, this), 1)
	  }
	
	  Affix.prototype.checkPosition = function () {
	    if (!this.$element.is(':visible')) return
	
	    var height       = this.$element.height()
	    var offset       = this.options.offset
	    var offsetTop    = offset.top
	    var offsetBottom = offset.bottom
	    var scrollHeight = Math.max($(document).height(), $(document.body).height())
	
	    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
	    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
	    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)
	
	    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)
	
	    if (this.affixed != affix) {
	      if (this.unpin != null) this.$element.css('top', '')
	
	      var affixType = 'affix' + (affix ? '-' + affix : '')
	      var e         = $.Event(affixType + '.bs.affix')
	
	      this.$element.trigger(e)
	
	      if (e.isDefaultPrevented()) return
	
	      this.affixed = affix
	      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null
	
	      this.$element
	        .removeClass(Affix.RESET)
	        .addClass(affixType)
	        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
	    }
	
	    if (affix == 'bottom') {
	      this.$element.offset({
	        top: scrollHeight - height - offsetBottom
	      })
	    }
	  }
	
	
	  // AFFIX PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.affix')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.affix
	
	  $.fn.affix             = Plugin
	  $.fn.affix.Constructor = Affix
	
	
	  // AFFIX NO CONFLICT
	  // =================
	
	  $.fn.affix.noConflict = function () {
	    $.fn.affix = old
	    return this
	  }
	
	
	  // AFFIX DATA-API
	  // ==============
	
	  $(window).on('load', function () {
	    $('[data-spy="affix"]').each(function () {
	      var $spy = $(this)
	      var data = $spy.data()
	
	      data.offset = data.offset || {}
	
	      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
	      if (data.offsetTop    != null) data.offset.top    = data.offsetTop
	
	      Plugin.call($spy, data)
	    })
	  })
	
	}(jQuery);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(149);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(98)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./style.less", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/less-loader/index.js!./style.less");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(97)();
	// imports
	
	
	// module
	exports.push([module.id, "body,html{margin:0;padding:0}body{padding-top:0;font-family:proxima-nova,Arial,sans-serif;font-weight:400;background-color:#fff}@media (min-width:629px) and (max-width:720px){.col-xs-9{width:71.5%}.col-xs-3{width:26.5%}}h1 .thin,h1.thin,h3 .thin,h3.thin{font-weight:400;font-weight:100;font-family:proxima-nova,Arial,sans-serif}.margin-top-20{margin-top:20px}.margin-top-30{margin-top:30px}.margin-left-0{margin-left:0!important}.margin-left-3{margin-left:3px!important}.margin-left-5{margin-left:5px!important}.margin-left-10{margin-left:10px!important}.margin-left-15{margin-left:15px!important}.margin-top-15{margin-top:15px!important}.margin-left-20{margin-left:20px!important}.kill-sides{margin-right:0!important;margin-left:0!important}.col-lg-12,.col-md-12,.col-sm-12,.col-xs-12,.kill-sides,.kill-sides-padding{padding-right:0!important;padding-left:0!important}.div-icon{background-color:#00aed9}.btn-country{cursor:pointer}.navlink-btn-header{margin-bottom:0!important}.navlink-btn{display:inline-block;margin:2px 0 2px 2px}.first{margin-left:0!important}.btn-toggle{min-width:82px}.navlink-btn-metric{display:inline-block;background-color:#e1e1e1;color:#828282;padding:8px 14px!important;text-decoration:none;font-size:12px;white-space:nowrap;line-height:1em;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.btn-country{min-height:40px!important}.navlink-btn-metric:hover,a.navlink-btn-metric:focus{background-color:#00aed9;color:#fff;text-decoration:none;cursor:pointer}.navmenu-btn-metric-selected,.navmenu-btn-metric:active,.toggle-btn-metric-selected,.toggle-btn-metric:active{background-color:#00aed9;color:#fff}.related-content{background-color:#f1f4f9;padding:5px 10px 10px;margin:10px 0}.related-content-btn{display:inline-block;color:#000;margin:3px 3px 3px 0;padding:3px 10px 3px 0;text-decoration:none;font-size:12px;font-weight:800;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.related-content-btn:hover,a.related-content-btn:focus{color:#00aed9;cursor:pointer}.hilite-section,.related-content-btn-selected,.related-content-btn:active{color:#00aed9}.section-content-container h3{font-weight:300;text-align:justify;margin-top:0;padding-top:0;line-height:31px;padding-bottom:15px}.section-content-container p{font-size:16px;text-align:justify;line-height:26px;padding-bottom:15px}.section-content-link,.section-content-link:hover{color:#00aed9;white-space:nowrap}#section-content{z-index:0;position:relative}.description{max-width:740px;line-height:1.7em;margin-bottom:25px}#map{width:100%;height:100%;min-height:390px;margin:0;padding:0;z-index:0}#map-content{max-width:760px;float:left;z-index:0}.view-content{text-align:center}.view-content-btn{display:inline-block;background-color:#f7941e;border:1px solid #fff;color:#fff;margin:3px 3px 3px 0;text-decoration:none;font-size:1.3em;text-align:center;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none}.view-content-btn:hover,a.view-content-btn:focus{background-color:#fff;color:#f7941e;text-decoration:none;cursor:pointer}.view-content-btn:active{background-color:#fff;color:#f7941e}.popOps{background-color:#f5f5f5;border-radius:0}.leaflet-popup-content-wrapper{border-radius:0!important;background-color:#f5f5f5!important}.leaflet-popup-content{margin:-10px 0 0!important;padding:0!important}.pop-country{margin-top:3px;margin-bottom:0;padding:3px 8px}.pop-section{background-color:#00aed9;color:#fff;margin-bottom:5px;padding:5px 8px}.nopad-left-right{padding-left:5px!important;padding-right:5px!important}", ""]);
	
	// exports


/***/ }),
/* 150 */
95,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (root, factory) {
		if (true) {
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof modules === 'object' && module.exports) {
			// define a Common JS module that relies on 'leaflet'
			module.exports = factory(require('leaflet'));
		} else {
			// Assume Leaflet is loaded into global object L already
			factory(L);
		}
	}(this, function (L) {
		'use strict';
	
		L.TileLayer.Provider = L.TileLayer.extend({
			initialize: function (arg, options) {
				var providers = L.TileLayer.Provider.providers;
	
				var parts = arg.split('.');
	
				var providerName = parts[0];
				var variantName = parts[1];
	
				if (!providers[providerName]) {
					throw 'No such provider (' + providerName + ')';
				}
	
				var provider = {
					url: providers[providerName].url,
					options: providers[providerName].options
				};
	
				// overwrite values in provider from variant.
				if (variantName && 'variants' in providers[providerName]) {
					if (!(variantName in providers[providerName].variants)) {
						throw 'No such variant of ' + providerName + ' (' + variantName + ')';
					}
					var variant = providers[providerName].variants[variantName];
					var variantOptions;
					if (typeof variant === 'string') {
						variantOptions = {
							variant: variant
						};
					} else {
						variantOptions = variant.options;
					}
					provider = {
						url: variant.url || provider.url,
						options: L.Util.extend({}, provider.options, variantOptions)
					};
				}
	
				var forceHTTP = window.location.protocol === 'file:' || provider.options.forceHTTP;
				if (provider.url.indexOf('//') === 0 && forceHTTP) {
					provider.url = 'http:' + provider.url;
				}
	
				// If retina option is set
				if (provider.options.retina) {
					// Check retina screen
					if (options.detectRetina && L.Browser.retina) {
						// The retina option will be active now
						// But we need to prevent Leaflet retina mode
						options.detectRetina = false;
					} else {
						// No retina, remove option
						provider.options.retina = '';
					}
				}
	
				// replace attribution placeholders with their values from toplevel provider attribution,
				// recursively
				var attributionReplacer = function (attr) {
					if (attr.indexOf('{attribution.') === -1) {
						return attr;
					}
					return attr.replace(/\{attribution.(\w*)\}/,
						function (match, attributionName) {
							return attributionReplacer(providers[attributionName].options.attribution);
						}
					);
				};
				provider.options.attribution = attributionReplacer(provider.options.attribution);
	
				// Compute final options combining provider options with any user overrides
				var layerOpts = L.Util.extend({}, provider.options, options);
				L.TileLayer.prototype.initialize.call(this, provider.url, layerOpts);
			}
		});
	
		/**
		 * Definition of providers.
		 * see http://leafletjs.com/reference.html#tilelayer for options in the options map.
		 */
	
		L.TileLayer.Provider.providers = {
			OpenStreetMap: {
				url: '//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution:
						'&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
				},
				variants: {
					Mapnik: {},
					BlackAndWhite: {
						url: 'http://{s}.tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png',
						options: {
							maxZoom: 18
						}
					},
					DE: {
						url: 'http://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png',
						options: {
							maxZoom: 18
						}
					},
					France: {
						url: '//{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
						options: {
							maxZoom: 20,
							attribution: '&copy; Openstreetmap France | {attribution.OpenStreetMap}'
						}
					},
					HOT: {
						url: '//{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
						options: {
							attribution: '{attribution.OpenStreetMap}, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
						}
					}
				}
			},
			OpenSeaMap: {
				url: 'http://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
				options: {
					attribution: 'Map data: &copy; <a href="http://www.openseamap.org">OpenSeaMap</a> contributors'
				}
			},
			OpenTopoMap: {
				url: '//{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
				options: {
					maxZoom: 17,
					attribution: 'Map data: {attribution.OpenStreetMap}, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
				}
			},
			Thunderforest: {
				url: '//{s}.tile.thunderforest.com/{variant}/{z}/{x}/{y}.png?apikey={apikey}',
				options: {
					attribution:
						'&copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, {attribution.OpenStreetMap}',
					variant: 'cycle'
				},
				variants: {
					OpenCycleMap: 'cycle',
					Transport: {
						options: {
							variant: 'transport',
							maxZoom: 19
						}
					},
					TransportDark: {
						options: {
							variant: 'transport-dark',
							maxZoom: 19
						}
					},
					SpinalMap: {
						options: {
							variant: 'spinal-map',
							maxZoom: 11
						}
					},
					Landscape: 'landscape',
					Outdoors: 'outdoors',
					Pioneer: 'pioneer'
				}
			},
			OpenMapSurfer: {
				url: 'http://korona.geog.uni-heidelberg.de/tiles/{variant}/x={x}&y={y}&z={z}',
				options: {
					maxZoom: 20,
					variant: 'roads',
					attribution: 'Imagery from <a href="http://giscience.uni-hd.de/">GIScience Research Group @ University of Heidelberg</a> &mdash; Map data {attribution.OpenStreetMap}'
				},
				variants: {
					Roads: 'roads',
					AdminBounds: {
						options: {
							variant: 'adminb',
							maxZoom: 19
						}
					},
					Grayscale: {
						options: {
							variant: 'roadsg',
							maxZoom: 19
						}
					}
				}
			},
			Hydda: {
				url: '//{s}.tile.openstreetmap.se/hydda/{variant}/{z}/{x}/{y}.png',
				options: {
					variant: 'full',
					attribution: 'Tiles courtesy of <a href="http://openstreetmap.se/" target="_blank">OpenStreetMap Sweden</a> &mdash; Map data {attribution.OpenStreetMap}'
				},
				variants: {
					Full: 'full',
					Base: 'base',
					RoadsAndLabels: 'roads_and_labels'
				}
			},
			MapBox: {
				url: '//api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}',
				options: {
					attribution:
						'Imagery from <a href="http://mapbox.com/about/maps/">MapBox</a> &mdash; ' +
						'Map data {attribution.OpenStreetMap}',
					subdomains: 'abcd'
				}
			},
			Stamen: {
				url: '//stamen-tiles-{s}.a.ssl.fastly.net/{variant}/{z}/{x}/{y}.{ext}',
				options: {
					attribution:
						'Map tiles by <a href="http://stamen.com">Stamen Design</a>, ' +
						'<a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; ' +
						'Map data {attribution.OpenStreetMap}',
					subdomains: 'abcd',
					minZoom: 0,
					maxZoom: 20,
					variant: 'toner',
					ext: 'png'
				},
				variants: {
					Toner: 'toner',
					TonerBackground: 'toner-background',
					TonerHybrid: 'toner-hybrid',
					TonerLines: 'toner-lines',
					TonerLabels: 'toner-labels',
					TonerLite: 'toner-lite',
					Watercolor: {
						options: {
							variant: 'watercolor',
							minZoom: 1,
							maxZoom: 16
						}
					},
					Terrain: {
						options: {
							variant: 'terrain',
							minZoom: 0,
							maxZoom: 18
						}
					},
					TerrainBackground: {
						options: {
							variant: 'terrain-background',
							minZoom: 0,
							maxZoom: 18
						}
					},
					TopOSMRelief: {
						options: {
							variant: 'toposm-color-relief',
							ext: 'jpg',
							bounds: [[22, -132], [51, -56]]
						}
					},
					TopOSMFeatures: {
						options: {
							variant: 'toposm-features',
							bounds: [[22, -132], [51, -56]],
							opacity: 0.9
						}
					}
				}
			},
			Esri: {
				url: '//server.arcgisonline.com/ArcGIS/rest/services/{variant}/MapServer/tile/{z}/{y}/{x}',
				options: {
					variant: 'World_Street_Map',
					attribution: 'Tiles &copy; Esri'
				},
				variants: {
					WorldStreetMap: {
						options: {
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
						}
					},
					DeLorme: {
						options: {
							variant: 'Specialty/DeLorme_World_Base_Map',
							minZoom: 1,
							maxZoom: 11,
							attribution: '{attribution.Esri} &mdash; Copyright: &copy;2012 DeLorme'
						}
					},
					WorldTopoMap: {
						options: {
							variant: 'World_Topo_Map',
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
						}
					},
					WorldImagery: {
						options: {
							variant: 'World_Imagery',
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
						}
					},
					WorldTerrain: {
						options: {
							variant: 'World_Terrain_Base',
							maxZoom: 13,
							attribution:
								'{attribution.Esri} &mdash; ' +
								'Source: USGS, Esri, TANA, DeLorme, and NPS'
						}
					},
					WorldShadedRelief: {
						options: {
							variant: 'World_Shaded_Relief',
							maxZoom: 13,
							attribution: '{attribution.Esri} &mdash; Source: Esri'
						}
					},
					WorldPhysical: {
						options: {
							variant: 'World_Physical_Map',
							maxZoom: 8,
							attribution: '{attribution.Esri} &mdash; Source: US National Park Service'
						}
					},
					OceanBasemap: {
						options: {
							variant: 'Ocean_Basemap',
							maxZoom: 13,
							attribution: '{attribution.Esri} &mdash; Sources: GEBCO, NOAA, CHS, OSU, UNH, CSUMB, National Geographic, DeLorme, NAVTEQ, and Esri'
						}
					},
					NatGeoWorldMap: {
						options: {
							variant: 'NatGeo_World_Map',
							maxZoom: 16,
							attribution: '{attribution.Esri} &mdash; National Geographic, Esri, DeLorme, NAVTEQ, UNEP-WCMC, USGS, NASA, ESA, METI, NRCAN, GEBCO, NOAA, iPC'
						}
					},
					WorldGrayCanvas: {
						options: {
							variant: 'Canvas/World_Light_Gray_Base',
							maxZoom: 16,
							attribution: '{attribution.Esri} &mdash; Esri, DeLorme, NAVTEQ'
						}
					}
				}
			},
			OpenWeatherMap: {
				url: 'http://{s}.tile.openweathermap.org/map/{variant}/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution: 'Map data &copy; <a href="http://openweathermap.org">OpenWeatherMap</a>',
					opacity: 0.5
				},
				variants: {
					Clouds: 'clouds',
					CloudsClassic: 'clouds_cls',
					Precipitation: 'precipitation',
					PrecipitationClassic: 'precipitation_cls',
					Rain: 'rain',
					RainClassic: 'rain_cls',
					Pressure: 'pressure',
					PressureContour: 'pressure_cntr',
					Wind: 'wind',
					Temperature: 'temp',
					Snow: 'snow'
				}
			},
			HERE: {
				/*
				 * HERE maps, formerly Nokia maps.
				 * These basemaps are free, but you need an API key. Please sign up at
				 * http://developer.here.com/getting-started
				 *
				 * Note that the base urls contain '.cit' whichs is HERE's
				 * 'Customer Integration Testing' environment. Please remove for production
				 * envirionments.
				 */
				url:
					'//{s}.{base}.maps.cit.api.here.com/maptile/2.1/' +
					'{type}/{mapID}/{variant}/{z}/{x}/{y}/{size}/{format}?' +
					'app_id={app_id}&app_code={app_code}&lg={language}',
				options: {
					attribution:
						'Map &copy; 1987-2014 <a href="http://developer.here.com">HERE</a>',
					subdomains: '1234',
					mapID: 'newest',
					'app_id': '<insert your app_id here>',
					'app_code': '<insert your app_code here>',
					base: 'base',
					variant: 'normal.day',
					maxZoom: 20,
					type: 'maptile',
					language: 'eng',
					format: 'png8',
					size: '256'
				},
				variants: {
					normalDay: 'normal.day',
					normalDayCustom: 'normal.day.custom',
					normalDayGrey: 'normal.day.grey',
					normalDayMobile: 'normal.day.mobile',
					normalDayGreyMobile: 'normal.day.grey.mobile',
					normalDayTransit: 'normal.day.transit',
					normalDayTransitMobile: 'normal.day.transit.mobile',
					normalNight: 'normal.night',
					normalNightMobile: 'normal.night.mobile',
					normalNightGrey: 'normal.night.grey',
					normalNightGreyMobile: 'normal.night.grey.mobile',
	
					basicMap: {
						options: {
							type: 'basetile'
						}
					},
					mapLabels: {
						options: {
							type: 'labeltile',
							format: 'png'
						}
					},
					trafficFlow: {
						options: {
							base: 'traffic',
							type: 'flowtile'
						}
					},
					carnavDayGrey: 'carnav.day.grey',
					hybridDay: {
						options: {
							base: 'aerial',
							variant: 'hybrid.day'
						}
					},
					hybridDayMobile: {
						options: {
							base: 'aerial',
							variant: 'hybrid.day.mobile'
						}
					},
					pedestrianDay: 'pedestrian.day',
					pedestrianNight: 'pedestrian.night',
					satelliteDay: {
						options: {
							base: 'aerial',
							variant: 'satellite.day'
						}
					},
					terrainDay: {
						options: {
							base: 'aerial',
							variant: 'terrain.day'
						}
					},
					terrainDayMobile: {
						options: {
							base: 'aerial',
							variant: 'terrain.day.mobile'
						}
					}
				}
			},
			FreeMapSK: {
				url: 'http://t{s}.freemap.sk/T/{z}/{x}/{y}.jpeg',
				options: {
					minZoom: 8,
					maxZoom: 16,
					subdomains: '1234',
					bounds: [[47.204642, 15.996093], [49.830896, 22.576904]],
					attribution:
						'{attribution.OpenStreetMap}, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>'
				}
			},
			MtbMap: {
				url: 'http://tile.mtbmap.cz/mtbmap_tiles/{z}/{x}/{y}.png',
				options: {
					attribution:
						'{attribution.OpenStreetMap} &amp; USGS'
				}
			},
			CartoDB: {
				url: 'http://{s}.basemaps.cartocdn.com/{variant}/{z}/{x}/{y}.png',
				options: {
					attribution: '{attribution.OpenStreetMap} &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
					subdomains: 'abcd',
					maxZoom: 19,
					variant: 'light_all'
				},
				variants: {
					Positron: 'light_all',
					PositronNoLabels: 'light_nolabels',
					PositronOnlyLabels: 'light_only_labels',
					DarkMatter: 'dark_all',
					DarkMatterNoLabels: 'dark_nolabels',
					DarkMatterOnlyLabels: 'dark_only_labels'
				}
			},
			HikeBike: {
				url: 'http://{s}.tiles.wmflabs.org/{variant}/{z}/{x}/{y}.png',
				options: {
					maxZoom: 19,
					attribution: '{attribution.OpenStreetMap}',
					variant: 'hikebike'
				},
				variants: {
					HikeBike: {},
					HillShading: {
						options: {
							maxZoom: 15,
							variant: 'hillshading'
						}
					}
				}
			},
			BasemapAT: {
				url: 'https://maps{s}.wien.gv.at/basemap/{variant}/normal/google3857/{z}/{y}/{x}.{format}',
				options: {
					maxZoom: 19,
					attribution: 'Datenquelle: <a href="www.basemap.at">basemap.at</a>',
					subdomains: ['', '1', '2', '3', '4'],
					format: 'png',
					bounds: [[46.358770, 8.782379], [49.037872, 17.189532]],
					variant: 'geolandbasemap'
				},
				variants: {
					basemap: {
						options: {
							maxZoom: 20, // currently only in Vienna
							variant: 'geolandbasemap'
						}
					},
					grau: 'bmapgrau',
					overlay: 'bmapoverlay',
					highdpi: {
						options: {
							variant: 'bmaphidpi',
							format: 'jpeg'
						}
					},
					orthofoto: {
						options: {
							maxZoom: 20, // currently only in Vienna
							variant: 'bmaporthofoto30cm',
							format: 'jpeg'
						}
					}
				}
			},
			NASAGIBS: {
				url: '//map1.vis.earthdata.nasa.gov/wmts-webmerc/{variant}/default/{time}/{tilematrixset}{maxZoom}/{z}/{y}/{x}.{format}',
				options: {
					attribution:
						'Imagery provided by services from the Global Imagery Browse Services (GIBS), operated by the NASA/GSFC/Earth Science Data and Information System ' +
						'(<a href="https://earthdata.nasa.gov">ESDIS</a>) with funding provided by NASA/HQ.',
					bounds: [[-85.0511287776, -179.999999975], [85.0511287776, 179.999999975]],
					minZoom: 1,
					maxZoom: 9,
					format: 'jpg',
					time: '',
					tilematrixset: 'GoogleMapsCompatible_Level'
				},
				variants: {
					ModisTerraTrueColorCR: 'MODIS_Terra_CorrectedReflectance_TrueColor',
					ModisTerraBands367CR: 'MODIS_Terra_CorrectedReflectance_Bands367',
					ViirsEarthAtNight2012: {
						options: {
							variant: 'VIIRS_CityLights_2012',
							maxZoom: 8
						}
					},
					ModisTerraLSTDay: {
						options: {
							variant: 'MODIS_Terra_Land_Surface_Temp_Day',
							format: 'png',
							maxZoom: 7,
							opacity: 0.75
						}
					},
					ModisTerraSnowCover: {
						options: {
							variant: 'MODIS_Terra_Snow_Cover',
							format: 'png',
							maxZoom: 8,
							opacity: 0.75
						}
					},
					ModisTerraAOD: {
						options: {
							variant: 'MODIS_Terra_Aerosol',
							format: 'png',
							maxZoom: 6,
							opacity: 0.75
						}
					},
					ModisTerraChlorophyll: {
						options: {
							variant: 'MODIS_Terra_Chlorophyll_A',
							format: 'png',
							maxZoom: 7,
							opacity: 0.75
						}
					}
				}
			},
			NLS: {
				// NLS maps are copyright National library of Scotland.
				// http://maps.nls.uk/projects/api/index.html
				// Please contact NLS for anything other than non-commercial low volume usage
				//
				// Map sources: Ordnance Survey 1:1m to 1:63K, 1920s-1940s
				//   z0-9  - 1:1m
				//  z10-11 - quarter inch (1:253440)
				//  z12-18 - one inch (1:63360)
				url: '//nls-{s}.tileserver.com/nls/{z}/{x}/{y}.jpg',
				options: {
					attribution: '<a href="http://geo.nls.uk/maps/">National Library of Scotland Historic Maps</a>',
					bounds: [[49.6, -12], [61.7, 3]],
					minZoom: 1,
					maxZoom: 18,
					subdomains: '0123',
				}
			},
			JusticeMap: {
				// Justice Map (http://www.justicemap.org/)
				// Visualize race and income data for your community, county and country.
				// Includes tools for data journalists, bloggers and community activists.
				url: 'http://www.justicemap.org/tile/{size}/{variant}/{z}/{x}/{y}.png',
				options: {
					attribution: '<a href="http://www.justicemap.org/terms.php">Justice Map</a>',
					// one of 'county', 'tract', 'block'
					size: 'county',
					// Bounds for USA, including Alaska and Hawaii
					bounds: [[14, -180], [72, -56]]
				},
				variants: {
					income: 'income',
					americanIndian: 'indian',
					asian: 'asian',
					black: 'black',
					hispanic: 'hispanic',
					multi: 'multi',
					nonWhite: 'nonwhite',
					white: 'white',
					plurality: 'plural'
				}
			}
		};
	
		L.tileLayer.provider = function (provider, options) {
			return new L.TileLayer.Provider(provider, options);
		};
	
		return L;
	}));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/* global L */
	
	var queue = __webpack_require__(160).queue;
	
	var cacheBusterDate = +new Date();
	
	// leaflet-image
	module.exports = function leafletImage(map, callback) {
	
	    var hasMapbox = !!L.mapbox;
	
	    var dimensions = map.getSize(),
	        layerQueue = new queue(1);
	
	    var canvas = document.createElement('canvas');
	    canvas.width = dimensions.x;
	    canvas.height = dimensions.y;
	    var ctx = canvas.getContext('2d');
	
	    // dummy canvas image when loadTile get 404 error
	    // and layer don't have errorTileUrl
	    var dummycanvas = document.createElement('canvas');
	    dummycanvas.width = 1;
	    dummycanvas.height = 1;
	    var dummyctx = dummycanvas.getContext('2d');
	    dummyctx.fillStyle = 'rgba(0,0,0,0)';
	    dummyctx.fillRect(0, 0, 1, 1);
	
	    // layers are drawn in the same order as they are composed in the DOM:
	    // tiles, paths, and then markers
	    map.eachLayer(drawTileLayer);
	    map.eachLayer(drawEsriDynamicLayer);
	    
	    if (map._pathRoot) {
	        layerQueue.defer(handlePathRoot, map._pathRoot);
	    } else if (map._panes) {
	        var firstCanvas = map._panes.overlayPane.getElementsByTagName('canvas').item(0);
	        if (firstCanvas) { layerQueue.defer(handlePathRoot, firstCanvas); }
	    }
	    map.eachLayer(drawMarkerLayer);
	    layerQueue.awaitAll(layersDone);
	
	    function drawTileLayer(l) {
	        if (l instanceof L.TileLayer) layerQueue.defer(handleTileLayer, l);
	        else if (l._heat) layerQueue.defer(handlePathRoot, l._canvas);
	    }
	
	    function drawMarkerLayer(l) {
	        if (l instanceof L.Marker && l.options.icon instanceof L.Icon) {
	            layerQueue.defer(handleMarkerLayer, l);
	        }
	    }
	    
	    function drawEsriDynamicLayer(l) {
	        if (!L.esri) return;
	       
	        if (l instanceof L.esri.DynamicMapLayer) {                       
	            layerQueue.defer(handleEsriDymamicLayer, l);
	        }
	    }
	
	    function done() {
	        callback(null, canvas);
	    }
	
	    function layersDone(err, layers) {
	        if (err) throw err;
	        layers.forEach(function (layer) {
	            if (layer && layer.canvas) {
	                ctx.drawImage(layer.canvas, 0, 0);
	            }
	        });
	        done();
	    }
	
	    function handleTileLayer(layer, callback) {
	        // `L.TileLayer.Canvas` was removed in leaflet 1.0
	        var isCanvasLayer = (L.TileLayer.Canvas && layer instanceof L.TileLayer.Canvas),
	            canvas = document.createElement('canvas');
	
	        canvas.width = dimensions.x;
	        canvas.height = dimensions.y;
	
	        var ctx = canvas.getContext('2d'),
	            bounds = map.getPixelBounds(),
	            zoom = map.getZoom(),
	            tileSize = layer.options.tileSize;
	
	        if (zoom > layer.options.maxZoom ||
	            zoom < layer.options.minZoom ||
	            // mapbox.tileLayer
	            (hasMapbox &&
	                layer instanceof L.mapbox.tileLayer && !layer.options.tiles)) {
	            return callback();
	        }
	
	        var tileBounds = L.bounds(
	            bounds.min.divideBy(tileSize)._floor(),
	            bounds.max.divideBy(tileSize)._floor()),
	            tiles = [],
	            j, i,
	            tileQueue = new queue(1);
	
	        for (j = tileBounds.min.y; j <= tileBounds.max.y; j++) {
	            for (i = tileBounds.min.x; i <= tileBounds.max.x; i++) {
	                tiles.push(new L.Point(i, j));
	            }
	        }
	
	        tiles.forEach(function (tilePoint) {
	            var originalTilePoint = tilePoint.clone();
	
	            if (layer._adjustTilePoint) {
	                layer._adjustTilePoint(tilePoint);
	            }
	
	            var tilePos = originalTilePoint
	                .scaleBy(new L.Point(tileSize, tileSize))
	                .subtract(bounds.min);
	
	            if (tilePoint.y >= 0) {
	                if (isCanvasLayer) {
	                    var tile = layer._tiles[tilePoint.x + ':' + tilePoint.y];
	                    tileQueue.defer(canvasTile, tile, tilePos, tileSize);
	                } else {
	                    var url = addCacheString(layer.getTileUrl(tilePoint));
	                    tileQueue.defer(loadTile, url, tilePos, tileSize);
	                }
	            }
	        });
	
	        tileQueue.awaitAll(tileQueueFinish);
	
	        function canvasTile(tile, tilePos, tileSize, callback) {
	            callback(null, {
	                img: tile,
	                pos: tilePos,
	                size: tileSize
	            });
	        }
	
	        function loadTile(url, tilePos, tileSize, callback) {
	            var im = new Image();
	            im.crossOrigin = '';
	            im.onload = function () {
	                callback(null, {
	                    img: this,
	                    pos: tilePos,
	                    size: tileSize
	                });
	            };
	            im.onerror = function (e) {
	                // use canvas instead of errorTileUrl if errorTileUrl get 404
	                if (layer.options.errorTileUrl != '' && e.target.errorCheck === undefined) {
	                    e.target.errorCheck = true;
	                    e.target.src = layer.options.errorTileUrl;
	                } else {
	                    callback(null, {
	                        img: dummycanvas,
	                        pos: tilePos,
	                        size: tileSize
	                    });
	                }
	            };
	            im.src = url;
	        }
	
	        function tileQueueFinish(err, data) {
	            data.forEach(drawTile);
	            callback(null, { canvas: canvas });
	        }
	
	        function drawTile(d) {
	            ctx.drawImage(d.img, Math.floor(d.pos.x), Math.floor(d.pos.y),
	                d.size, d.size);
	        }
	    }
	
	    function handlePathRoot(root, callback) {
	        var bounds = map.getPixelBounds(),
	            origin = map.getPixelOrigin(),
	            canvas = document.createElement('canvas');
	        canvas.width = dimensions.x;
	        canvas.height = dimensions.y;
	        var ctx = canvas.getContext('2d');
	        var pos = L.DomUtil.getPosition(root).subtract(bounds.min).add(origin);
	        try {
	            ctx.drawImage(root, pos.x, pos.y, canvas.width - (pos.x * 2), canvas.height - (pos.y * 2));
	            callback(null, {
	                canvas: canvas
	            });
	        } catch(e) {
	            console.error('Element could not be drawn on canvas', root); // eslint-disable-line no-console
	        }
	    }
	
	    function handleMarkerLayer(marker, callback) {
	        var canvas = document.createElement('canvas'),
	            ctx = canvas.getContext('2d'),
	            pixelBounds = map.getPixelBounds(),
	            minPoint = new L.Point(pixelBounds.min.x, pixelBounds.min.y),
	            pixelPoint = map.project(marker.getLatLng()),
	            isBase64 = /^data\:/.test(marker._icon.src),
	            url = isBase64 ? marker._icon.src : addCacheString(marker._icon.src),
	            im = new Image(),
	            options = marker.options.icon.options,
	            size = options.iconSize,
	            pos = pixelPoint.subtract(minPoint),
	            anchor = L.point(options.iconAnchor || size && size.divideBy(2, true));
	
	        if (size instanceof L.Point) size = [size.x, size.y];
	
	        var x = Math.round(pos.x - size[0] + anchor.x),
	            y = Math.round(pos.y - anchor.y);
	
	        canvas.width = dimensions.x;
	        canvas.height = dimensions.y;
	        im.crossOrigin = '';
	
	        im.onload = function () {
	            ctx.drawImage(this, x, y, size[0], size[1]);
	            callback(null, {
	                canvas: canvas
	            });
	        };
	
	        im.src = url;
	
	        if (isBase64) im.onload();
	    }
	    
	    function handleEsriDymamicLayer(dynamicLayer, callback) {
	        var canvas = document.createElement('canvas');
	        canvas.width = dimensions.x;
	        canvas.height = dimensions.y;
	    
	        var ctx = canvas.getContext('2d');
	    
	        var im = new Image();
	        im.crossOrigin = '';
	        im.src = addCacheString(dynamicLayer._currentImage._image.src);
	    
	        im.onload = function() {
	            ctx.drawImage(im, 0, 0);
	            callback(null, {
	                canvas: canvas
	            });
	        };
	    }
	
	    function addCacheString(url) {
	        // If it's a data URL we don't want to touch this.
	        if (isDataURL(url) || url.indexOf('mapbox.com/styles/v1') !== -1) {
	            return url;
	        }
	        return url + ((url.match(/\?/)) ? '&' : '?') + 'cache=' + cacheBusterDate;
	    }
	
	    function isDataURL(url) {
	        var dataURLRegex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
	        return !!url.match(dataURLRegex);
	    }
	
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3_queue = global.d3_queue || {})));
	}(this, function (exports) { 'use strict';
	
	  var version = "2.0.3";
	
	  var slice = [].slice;
	
	  var noabort = {};
	
	  function Queue(size) {
	    if (!(size >= 1)) throw new Error;
	    this._size = size;
	    this._call =
	    this._error = null;
	    this._tasks = [];
	    this._data = [];
	    this._waiting =
	    this._active =
	    this._ended =
	    this._start = 0; // inside a synchronous task callback?
	  }
	
	  Queue.prototype = queue.prototype = {
	    constructor: Queue,
	    defer: function(callback) {
	      if (typeof callback !== "function" || this._call) throw new Error;
	      if (this._error != null) return this;
	      var t = slice.call(arguments, 1);
	      t.push(callback);
	      ++this._waiting, this._tasks.push(t);
	      poke(this);
	      return this;
	    },
	    abort: function() {
	      if (this._error == null) abort(this, new Error("abort"));
	      return this;
	    },
	    await: function(callback) {
	      if (typeof callback !== "function" || this._call) throw new Error;
	      this._call = function(error, results) { callback.apply(null, [error].concat(results)); };
	      maybeNotify(this);
	      return this;
	    },
	    awaitAll: function(callback) {
	      if (typeof callback !== "function" || this._call) throw new Error;
	      this._call = callback;
	      maybeNotify(this);
	      return this;
	    }
	  };
	
	  function poke(q) {
	    if (!q._start) try { start(q); } // let the current task complete
	    catch (e) { if (q._tasks[q._ended + q._active - 1]) abort(q, e); } // task errored synchronously
	  }
	
	  function start(q) {
	    while (q._start = q._waiting && q._active < q._size) {
	      var i = q._ended + q._active,
	          t = q._tasks[i],
	          j = t.length - 1,
	          c = t[j];
	      t[j] = end(q, i);
	      --q._waiting, ++q._active;
	      t = c.apply(null, t);
	      if (!q._tasks[i]) continue; // task finished synchronously
	      q._tasks[i] = t || noabort;
	    }
	  }
	
	  function end(q, i) {
	    return function(e, r) {
	      if (!q._tasks[i]) return; // ignore multiple callbacks
	      --q._active, ++q._ended;
	      q._tasks[i] = null;
	      if (q._error != null) return; // ignore secondary errors
	      if (e != null) {
	        abort(q, e);
	      } else {
	        q._data[i] = r;
	        if (q._waiting) poke(q);
	        else maybeNotify(q);
	      }
	    };
	  }
	
	  function abort(q, e) {
	    var i = q._tasks.length, t;
	    q._error = e; // ignore active callbacks
	    q._data = undefined; // allow gc
	    q._waiting = NaN; // prevent starting
	
	    while (--i >= 0) {
	      if (t = q._tasks[i]) {
	        q._tasks[i] = null;
	        if (t.abort) try { t.abort(); }
	        catch (e) { /* ignore */ }
	      }
	    }
	
	    q._active = NaN; // allow notification
	    maybeNotify(q);
	  }
	
	  function maybeNotify(q) {
	    if (!q._active && q._call) q._call(q._error, q._data);
	  }
	
	  function queue(concurrency) {
	    return new Queue(arguments.length ? +concurrency : Infinity);
	  }
	
	  exports.version = version;
	  exports.queue = queue;
	
	}));

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Copyright 2015 Teralytics AG
	 *
	 * @author Kirill Zhuravlev <kirill.zhuravlev@teralytics.ch>
	 *
	 */
	
	(function (factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(112), __webpack_require__(102)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
	        module.exports = factory(require('leaflet', 'd3'));
	    } else {
	        factory(L, d3);
	    }
	})(function (L, d3) {
	
	    // Check requirements
	    if (typeof d3 == "undefined") {
	        throw "D3 SVG Overlay for Leaflet requires D3 library loaded first";
	    }
	    if (typeof L == "undefined") {
	        throw "D3 SVG Overlay for Leaflet requires Leaflet library loaded first";
	    }
	
	    // Tiny stylesheet bundled here instead of a separate file
	    if (L.version >= "1.0") {
	        d3.select("head").append("style").attr("type", "text/css").text("g.d3-overlay *{pointer-events:visiblePainted;}");
	    }
	
	    // Class definition
	    L.D3SvgOverlay = (L.version < "1.0" ? L.Class : L.Layer).extend({
	        includes: L.version < "1.0" ? L.Mixin.Events : [],
	
	        _undef: function _undef(a) {
	            return typeof a == "undefined";
	        },
	
	        _options: function _options(options) {
	            if (this._undef(options)) {
	                return this.options;
	            }
	            options.zoomHide = this._undef(options.zoomHide) ? false : options.zoomHide;
	            options.zoomDraw = this._undef(options.zoomDraw) ? true : options.zoomDraw;
	
	            return this.options = options;
	        },
	
	        _disableLeafletRounding: function _disableLeafletRounding() {
	            this._leaflet_round = L.Point.prototype._round;
	            L.Point.prototype._round = function () {
	                return this;
	            };
	        },
	
	        _enableLeafletRounding: function _enableLeafletRounding() {
	            L.Point.prototype._round = this._leaflet_round;
	        },
	
	        draw: function draw() {
	            this._disableLeafletRounding();
	            this._drawCallback(this.selection, this.projection, this.map.getZoom());
	            this._enableLeafletRounding();
	        },
	
	        initialize: function initialize(drawCallback, options) {
	            // (Function(selection, projection)), (Object)options
	            this._options(options || {});
	            this._drawCallback = drawCallback;
	        },
	
	        // Handler for "viewreset"-like events, updates scale and shift after the animation
	        _zoomChange: function _zoomChange(evt) {
	            this._disableLeafletRounding();
	            var newZoom = this._undef(evt.zoom) ? this.map._zoom : evt.zoom; // "viewreset" event in Leaflet has not zoom/center parameters like zoomanim
	            this._zoomDiff = newZoom - this._zoom;
	            this._scale = Math.pow(2, this._zoomDiff);
	            this.projection.scale = this._scale;
	            this._shift = this.map.latLngToLayerPoint(this._wgsOrigin)._subtract(this._wgsInitialShift.multiplyBy(this._scale));
	
	            var shift = ["translate(", this._shift.x, ",", this._shift.y, ") "];
	            var scale = ["scale(", this._scale, ",", this._scale, ") "];
	            this._rootGroup.attr("transform", shift.concat(scale).join(""));
	
	            if (this.options.zoomDraw) {
	                this.draw();
	            }
	            this._enableLeafletRounding();
	        },
	
	        onAdd: function onAdd(map) {
	            this.map = map;
	            var _layer = this;
	
	            // SVG element
	            if (L.version < "1.0") {
	                map._initPathRoot();
	                this._svg = d3.select(map._panes.overlayPane).select("svg");
	                this._rootGroup = this._svg.append("g");
	            } else {
	                this._svg = L.svg();
	                map.addLayer(this._svg);
	                this._rootGroup = d3.select(this._svg._rootGroup).classed("d3-overlay", true);
	            }
	            this._rootGroup.classed("leaflet-zoom-hide", this.options.zoomHide);
	            this.selection = this._rootGroup;
	
	            // Init shift/scale invariance helper values
	            this._pixelOrigin = map.getPixelOrigin();
	            this._wgsOrigin = L.latLng([0, 0]);
	            this._wgsInitialShift = this.map.latLngToLayerPoint(this._wgsOrigin);
	            this._zoom = this.map.getZoom();
	            this._shift = L.point(0, 0);
	            this._scale = 1;
	
	            // Create projection object
	            this.projection = {
	                latLngToLayerPoint: function latLngToLayerPoint(latLng, zoom) {
	                    zoom = _layer._undef(zoom) ? _layer._zoom : zoom;
	                    var projectedPoint = _layer.map.project(L.latLng(latLng), zoom)._round();
	                    return projectedPoint._subtract(_layer._pixelOrigin);
	                },
	                layerPointToLatLng: function layerPointToLatLng(point, zoom) {
	                    zoom = _layer._undef(zoom) ? _layer._zoom : zoom;
	                    var projectedPoint = L.point(point).add(_layer._pixelOrigin);
	                    return _layer.map.unproject(projectedPoint, zoom);
	                },
	                unitsPerMeter: 256 * Math.pow(2, _layer._zoom) / 40075017,
	                map: _layer.map,
	                layer: _layer,
	                scale: 1
	            };
	            this.projection._projectPoint = function (x, y) {
	                var point = _layer.projection.latLngToLayerPoint(new L.LatLng(y, x));
	                this.stream.point(point.x, point.y);
	            };
	            this.projection.pathFromGeojson = d3.geo.path().projection(d3.geo.transform({ point: this.projection._projectPoint }));
	
	            // Compatibility with v.1
	            this.projection.latLngToLayerFloatPoint = this.projection.latLngToLayerPoint;
	            this.projection.getZoom = this.map.getZoom.bind(this.map);
	            this.projection.getBounds = this.map.getBounds.bind(this.map);
	            this.selection = this._rootGroup;
	
	            if (L.version < "1.0") map.on("viewreset", this._zoomChange, this);
	
	            // Initial draw
	            this.draw();
	        },
	
	        // Leaflet 1.0
	        getEvents: function getEvents() {
	            return { zoomend: this._zoomChange };
	        },
	
	        onRemove: function onRemove(map) {
	            if (L.version < "1.0") {
	                map.off("viewreset", this._zoomChange, this);
	                this._rootGroup.remove();
	            } else {
	                this._svg.remove();
	            }
	        },
	
	        addTo: function addTo(map) {
	            map.addLayer(this);
	            return this;
	        }
	
	    });
	
	    L.D3SvgOverlay.version = "2.2";
	
	    // Factory method
	    L.d3SvgOverlay = function (drawCallback, options) {
	        return new L.D3SvgOverlay(drawCallback, options);
	    };
	});

/***/ }),
/* 162 */
95,
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	L.Control.MousePosition = L.Control.extend({
	  options: {
	    position: 'bottomleft',
	    separator: ' : ',
	    emptyString: 'Unavailable',
	    lngFirst: false,
	    numDigits: 5,
	    lngFormatter: undefined,
	    latFormatter: undefined,
	    prefix: ""
	  },
	
	  onAdd: function onAdd(map) {
	    this._container = L.DomUtil.create('div', 'leaflet-control-mouseposition');
	    L.DomEvent.disableClickPropagation(this._container);
	    map.on('mousemove', this._onMouseMove, this);
	    this._container.innerHTML = this.options.emptyString;
	    return this._container;
	  },
	
	  onRemove: function onRemove(map) {
	    map.off('mousemove', this._onMouseMove);
	  },
	
	  _onMouseMove: function _onMouseMove(e) {
	    var lng = this.options.lngFormatter ? this.options.lngFormatter(e.latlng.lng) : L.Util.formatNum(e.latlng.lng, this.options.numDigits);
	    var lat = this.options.latFormatter ? this.options.latFormatter(e.latlng.lat) : L.Util.formatNum(e.latlng.lat, this.options.numDigits);
	    var value = this.options.lngFirst ? lng + this.options.separator + lat : lat + this.options.separator + lng;
	    var prefixAndValue = this.options.prefix + ' ' + value;
	    this._container.innerHTML = prefixAndValue;
	  }
	
	});
	
	L.Map.mergeOptions({
	  positionControl: false
	});
	
	L.Map.addInitHook(function () {
	  if (this.options.positionControl) {
	    this.positionControl = new L.Control.MousePosition();
	    this.addControl(this.positionControl);
	  }
	});
	
	L.control.mousePosition = function (options) {
	  return new L.Control.MousePosition(options);
	};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	module.exports = __webpack_require__(166);


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	exports.iframeResizer = __webpack_require__(167);
	exports.iframeResizerContentWindow = __webpack_require__(168);


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * File: iframeResizer.js
	 * Desc: Force iframes to size to content.
	 * Requires: iframeResizer.contentWindow.js to be loaded into the target frame.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Reed Dadoune - reed@dadoune.com
	 */
	
	
	;(function(undefined) {
		'use strict';
	
		if(typeof window === 'undefined') return; // don't run for server side render
	
		var
			count                 = 0,
			logEnabled            = false,
			hiddenCheckEnabled    = false,
			msgHeader             = 'message',
			msgHeaderLen          = msgHeader.length,
			msgId                 = '[iFrameSizer]', //Must match iframe msg ID
			msgIdLen              = msgId.length,
			pagePosition          = null,
			requestAnimationFrame = window.requestAnimationFrame,
			resetRequiredMethods  = {max:1,scroll:1,bodyScroll:1,documentElementScroll:1},
			settings              = {},
			timer                 = null,
			logId                 = 'Host Page',
	
			defaults              = {
				autoResize                : true,
				bodyBackground            : null,
				bodyMargin                : null,
				bodyMarginV1              : 8,
				bodyPadding               : null,
				checkOrigin               : true,
				inPageLinks               : false,
				enablePublicMethods       : true,
				heightCalculationMethod   : 'bodyOffset',
				id                        : 'iFrameResizer',
				interval                  : 32,
				log                       : false,
				maxHeight                 : Infinity,
				maxWidth                  : Infinity,
				minHeight                 : 0,
				minWidth                  : 0,
				resizeFrom                : 'parent',
				scrolling                 : false,
				sizeHeight                : true,
				sizeWidth                 : false,
				warningTimeout            : 5000,
				tolerance                 : 0,
				widthCalculationMethod    : 'scroll',
				closedCallback            : function(){},
				initCallback              : function(){},
				messageCallback           : function(){warn('MessageCallback function not defined');},
				resizedCallback           : function(){},
				scrollCallback            : function(){return true;}
			};
	
		function addEventListener(obj,evt,func){
			/* istanbul ignore else */ // Not testable in PhantonJS
			if ('addEventListener' in window){
				obj.addEventListener(evt,func, false);
			} else if ('attachEvent' in window){//IE
				obj.attachEvent('on'+evt,func);
			}
		}
	
		function removeEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('removeEventListener' in window){
				el.removeEventListener(evt,func, false);
			} else if ('detachEvent' in window){ //IE
				el.detachEvent('on'+evt,func);
			}
		}
	
		function setupRequestAnimationFrame(){
			var
				vendors = ['moz', 'webkit', 'o', 'ms'],
				x;
	
			// Remove vendor prefixing if prefixed and break early if not
			for (x = 0; x < vendors.length && !requestAnimationFrame; x += 1) {
				requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
			}
	
			if (!(requestAnimationFrame)){
				log('setup','RequestAnimationFrame not supported');
			}
		}
	
		function getMyID(iframeId){
			var retStr = 'Host page: '+iframeId;
	
			if (window.top !== window.self){
				if (window.parentIFrame && window.parentIFrame.getId){
					retStr = window.parentIFrame.getId()+': '+iframeId;
				} else {
					retStr = 'Nested host page: '+iframeId;
				}
			}
	
			return retStr;
		}
	
		function formatLogHeader(iframeId){
			return msgId + '[' + getMyID(iframeId) + ']';
		}
	
		function isLogEnabled(iframeId){
			return settings[iframeId] ? settings[iframeId].log : logEnabled;
		}
	
		function log(iframeId,msg){
			output('log',iframeId,msg,isLogEnabled(iframeId));
		}
	
		function info(iframeId,msg){
			output('info',iframeId,msg,isLogEnabled(iframeId));
		}
	
		function warn(iframeId,msg){
			output('warn',iframeId,msg,true);
		}
	
		function output(type,iframeId,msg,enabled){
			if (true === enabled && 'object' === typeof window.console){
				console[type](formatLogHeader(iframeId),msg);
			}
		}
	
		function iFrameListener(event){
			function resizeIFrame(){
				function resize(){
					setSize(messageData);
					setPagePosition(iframeId);
					callback('resizedCallback',messageData);
				}
	
				ensureInRange('Height');
				ensureInRange('Width');
	
				syncResize(resize,messageData,'init');
			}
	
			function processMsg(){
				var data = msg.substr(msgIdLen).split(':');
	
				return {
					iframe: settings[data[0]].iframe,
					id:     data[0],
					height: data[1],
					width:  data[2],
					type:   data[3]
				};
			}
	
			function ensureInRange(Dimension){
				var
					max  = Number(settings[iframeId]['max' + Dimension]),
					min  = Number(settings[iframeId]['min' + Dimension]),
					dimension = Dimension.toLowerCase(),
					size = Number(messageData[dimension]);
	
				log(iframeId,'Checking ' + dimension + ' is in range ' + min + '-' + max);
	
				if (size<min) {
					size=min;
					log(iframeId,'Set ' + dimension + ' to min value');
				}
	
				if (size>max) {
					size=max;
					log(iframeId,'Set ' + dimension + ' to max value');
				}
	
				messageData[dimension] = '' + size;
			}
	
	
			function isMessageFromIFrame(){
				function checkAllowedOrigin(){
					function checkList(){
						var
							i = 0,
							retCode = false;
	
						log(iframeId,'Checking connection is from allowed list of origins: ' + checkOrigin);
	
						for (; i < checkOrigin.length; i++) {
							if (checkOrigin[i] === origin) {
								retCode = true;
								break;
							}
						}
						return retCode;
					}
	
					function checkSingle(){
						var remoteHost  = settings[iframeId].remoteHost;
						log(iframeId,'Checking connection is from: '+remoteHost);
						return origin === remoteHost;
					}
	
					return checkOrigin.constructor === Array ? checkList() : checkSingle();
				}
	
				var
					origin      = event.origin,
					checkOrigin = settings[iframeId].checkOrigin;
	
				if (checkOrigin && (''+origin !== 'null') && !checkAllowedOrigin()) {
					throw new Error(
						'Unexpected message received from: ' + origin +
						' for ' + messageData.iframe.id +
						'. Message was: ' + event.data +
						'. This error can be disabled by setting the checkOrigin: false option or by providing of array of trusted domains.'
					);
				}
	
				return true;
			}
	
			function isMessageForUs(){
				return msgId === (('' + msg).substr(0,msgIdLen)) && (msg.substr(msgIdLen).split(':')[0] in settings); //''+Protects against non-string msg
			}
	
			function isMessageFromMetaParent(){
				//Test if this message is from a parent above us. This is an ugly test, however, updating
				//the message format would break backwards compatibity.
				var retCode = messageData.type in {'true':1,'false':1,'undefined':1};
	
				if (retCode){
					log(iframeId,'Ignoring init message from meta parent page');
				}
	
				return retCode;
			}
	
			function getMsgBody(offset){
				return msg.substr(msg.indexOf(':')+msgHeaderLen+offset);
			}
	
			function forwardMsgFromIFrame(msgBody){
				log(iframeId,'MessageCallback passed: {iframe: '+ messageData.iframe.id + ', message: ' + msgBody + '}');
				callback('messageCallback',{
					iframe: messageData.iframe,
					message: JSON.parse(msgBody)
				});
				log(iframeId,'--');
			}
	
			function getPageInfo(){
				var
					bodyPosition   = document.body.getBoundingClientRect(),
					iFramePosition = messageData.iframe.getBoundingClientRect();
	
				return JSON.stringify({
					iframeHeight: iFramePosition.height,
					iframeWidth:  iFramePosition.width,
					clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
					clientWidth:  Math.max(document.documentElement.clientWidth,  window.innerWidth  || 0),
					offsetTop:    parseInt(iFramePosition.top  - bodyPosition.top,  10),
					offsetLeft:   parseInt(iFramePosition.left - bodyPosition.left, 10),
					scrollTop:    window.pageYOffset,
					scrollLeft:   window.pageXOffset
				});
			}
	
			function sendPageInfoToIframe(iframe,iframeId){
				function debouncedTrigger(){
					trigger(
						'Send Page Info',
						'pageInfo:' + getPageInfo(),
						iframe,
						iframeId
					);
				}
	
				debouce(debouncedTrigger,32);
			}
	
	
			function startPageInfoMonitor(){
				function setListener(type,func){
					function sendPageInfo(){
						if (settings[id]){
							sendPageInfoToIframe(settings[id].iframe,id);
						} else {
							stop();
						}
					}
	
					['scroll','resize'].forEach(function(evt){
						log(id, type +  evt + ' listener for sendPageInfo');
						func(window,evt,sendPageInfo);
					});
				}
	
				function stop(){
					setListener('Remove ', removeEventListener);
				}
	
				function start(){
					setListener('Add ', addEventListener);
				}
	
				var id = iframeId; //Create locally scoped copy of iFrame ID
	
				start();
	
				settings[id].stopPageInfo = stop;
			}
	
			function stopPageInfoMonitor(){
				if (settings[iframeId] && settings[iframeId].stopPageInfo){
					settings[iframeId].stopPageInfo();
					delete settings[iframeId].stopPageInfo;
				}
			}
	
			function checkIFrameExists(){
				var retBool = true;
	
				if (null === messageData.iframe) {
					warn(iframeId,'IFrame ('+messageData.id+') not found');
					retBool = false;
				}
				return retBool;
			}
	
			function getElementPosition(target){
				var iFramePosition = target.getBoundingClientRect();
	
				getPagePosition(iframeId);
	
				return {
					x: Math.floor( Number(iFramePosition.left) + Number(pagePosition.x) ),
					y: Math.floor( Number(iFramePosition.top)  + Number(pagePosition.y) )
				};
			}
	
			function scrollRequestFromChild(addOffset){
				/* istanbul ignore next */  //Not testable in Karma
				function reposition(){
					pagePosition = newPosition;
					scrollTo();
					log(iframeId,'--');
				}
	
				function calcOffset(){
					return {
						x: Number(messageData.width) + offset.x,
						y: Number(messageData.height) + offset.y
					};
				}
	
				function scrollParent(){
					if (window.parentIFrame){
						window.parentIFrame['scrollTo'+(addOffset?'Offset':'')](newPosition.x,newPosition.y);
					} else {
						warn(iframeId,'Unable to scroll to requested position, window.parentIFrame not found');
					}
				}
	
				var
					offset = addOffset ? getElementPosition(messageData.iframe) : {x:0,y:0},
					newPosition = calcOffset();
	
				log(iframeId,'Reposition requested from iFrame (offset x:'+offset.x+' y:'+offset.y+')');
	
				if(window.top !== window.self){
					scrollParent();
				} else {
					reposition();
				}
			}
	
			function scrollTo(){
				if (false !== callback('scrollCallback',pagePosition)){
					setPagePosition(iframeId);
				} else {
					unsetPagePosition();
				}
			}
	
			function findTarget(location){
				function jumpToTarget(){
					var jumpPosition = getElementPosition(target);
	
					log(iframeId,'Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
					pagePosition = {
						x: jumpPosition.x,
						y: jumpPosition.y
					};
	
					scrollTo();
					log(iframeId,'--');
				}
	
				function jumpToParent(){
					if (window.parentIFrame){
						window.parentIFrame.moveToAnchor(hash);
					} else {
						log(iframeId,'In page link #'+hash+' not found and window.parentIFrame not found');
					}
				}
	
				var
					hash     = location.split('#')[1] || '',
					hashData = decodeURIComponent(hash),
					target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
	
				if (target){
					jumpToTarget();
				} else if(window.top!==window.self){
					jumpToParent();
				} else {
					log(iframeId,'In page link #'+hash+' not found');
				}
			}
	
			function callback(funcName,val){
				return chkCallback(iframeId,funcName,val);
			}
	
			function actionMsg(){
	
				if(settings[iframeId].firstRun) firstRun();
	
				switch(messageData.type){
				case 'close':
					closeIFrame(messageData.iframe);
					break;
				case 'message':
					forwardMsgFromIFrame(getMsgBody(6));
					break;
				case 'scrollTo':
					scrollRequestFromChild(false);
					break;
				case 'scrollToOffset':
					scrollRequestFromChild(true);
					break;
				case 'pageInfo':
					sendPageInfoToIframe(settings[iframeId].iframe,iframeId);
					startPageInfoMonitor();
					break;
				case 'pageInfoStop':
					stopPageInfoMonitor();
					break;
				case 'inPageLink':
					findTarget(getMsgBody(9));
					break;
				case 'reset':
					resetIFrame(messageData);
					break;
				case 'init':
					resizeIFrame();
					callback('initCallback',messageData.iframe);
					break;
				default:
					resizeIFrame();
				}
			}
	
			function hasSettings(iframeId){
				var retBool = true;
	
				if (!settings[iframeId]){
					retBool = false;
					warn(messageData.type + ' No settings for ' + iframeId + '. Message was: ' + msg);
				}
	
				return retBool;
			}
	
			function iFrameReadyMsgReceived(){
				for (var iframeId in settings){
					trigger('iFrame requested init',createOutgoingMsg(iframeId),document.getElementById(iframeId),iframeId);
				}
			}
	
			function firstRun() {
				settings[iframeId].firstRun = false;
			}
	
			function clearWarningTimeout() {
				clearTimeout(settings[iframeId].msgTimeout);
				settings[iframeId].warningTimeout = 0;
			}
	
			var
				msg = event.data,
				messageData = {},
				iframeId = null;
	
			if('[iFrameResizerChild]Ready' === msg){
				iFrameReadyMsgReceived();
			} else if (isMessageForUs()){
				messageData = processMsg();
				iframeId    = logId = messageData.id;
				settings[iframeId].loaded = true;
	
				if (!isMessageFromMetaParent() && hasSettings(iframeId)){
					log(iframeId,'Received: '+msg);
	
					if ( checkIFrameExists() && isMessageFromIFrame() ){
						actionMsg();
					}
				}
			} else {
				info(iframeId,'Ignored: '+msg);
			}
	
		}
	
	
		function chkCallback(iframeId,funcName,val){
			var
				func = null,
				retVal = null;
	
			if(settings[iframeId]){
				func = settings[iframeId][funcName];
	
				if( 'function' === typeof func){
					retVal = func(val);
				} else {
					throw new TypeError(funcName+' on iFrame['+iframeId+'] is not a function');
				}
			}
	
			return retVal;
		}
	
		function closeIFrame(iframe){
			var iframeId = iframe.id;
	
			log(iframeId,'Removing iFrame: '+iframeId);
			if (iframe.parentNode) { iframe.parentNode.removeChild(iframe); }
			chkCallback(iframeId,'closedCallback',iframeId);
			log(iframeId,'--');
			delete settings[iframeId];
		}
	
		function getPagePosition(iframeId){
			if(null === pagePosition){
				pagePosition = {
					x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
					y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
				};
				log(iframeId,'Get page position: '+pagePosition.x+','+pagePosition.y);
			}
		}
	
		function setPagePosition(iframeId){
			if(null !== pagePosition){
				window.scrollTo(pagePosition.x,pagePosition.y);
				log(iframeId,'Set page position: '+pagePosition.x+','+pagePosition.y);
				unsetPagePosition();
			}
		}
	
		function unsetPagePosition(){
			pagePosition = null;
		}
	
		function resetIFrame(messageData){
			function reset(){
				setSize(messageData);
				trigger('reset','reset',messageData.iframe,messageData.id);
			}
	
			log(messageData.id,'Size reset requested by '+('init'===messageData.type?'host page':'iFrame'));
			getPagePosition(messageData.id);
			syncResize(reset,messageData,'reset');
		}
	
		function setSize(messageData){
			function setDimension(dimension){
				messageData.iframe.style[dimension] = messageData[dimension] + 'px';
				log(
					messageData.id,
					'IFrame (' + iframeId +
					') ' + dimension +
					' set to ' + messageData[dimension] + 'px'
				);
			}
	
			function chkZero(dimension){
				//FireFox sets dimension of hidden iFrames to zero.
				//So if we detect that set up an event to check for
				//when iFrame becomes visible.
	
				/* istanbul ignore next */  //Not testable in PhantomJS
				if (!hiddenCheckEnabled && '0' === messageData[dimension]){
					hiddenCheckEnabled = true;
					log(iframeId,'Hidden iFrame detected, creating visibility listener');
					fixHiddenIFrames();
				}
			}
	
			function processDimension(dimension){
				setDimension(dimension);
				chkZero(dimension);
			}
	
			var iframeId = messageData.iframe.id;
	
			if(settings[iframeId]){
				if( settings[iframeId].sizeHeight) { processDimension('height'); }
				if( settings[iframeId].sizeWidth ) { processDimension('width'); }
			}
		}
	
		function syncResize(func,messageData,doNotSync){
			/* istanbul ignore if */  //Not testable in PhantomJS
			if(doNotSync!==messageData.type && requestAnimationFrame){
				log(messageData.id,'Requesting animation frame');
				requestAnimationFrame(func);
			} else {
				func();
			}
		}
	
		function trigger(calleeMsg, msg, iframe, id, noResponseWarning) {
			function postMessageToIFrame(){
				var target = settings[id].targetOrigin;
				log(id,'[' + calleeMsg + '] Sending msg to iframe['+id+'] ('+msg+') targetOrigin: '+target);
				iframe.contentWindow.postMessage( msgId + msg, target );
			}
	
			function iFrameNotFound(){
				warn(id,'[' + calleeMsg + '] IFrame('+id+') not found');
			}
	
			function chkAndSend(){
				if(iframe && 'contentWindow' in iframe && (null !== iframe.contentWindow)){ //Null test for PhantomJS
					postMessageToIFrame();
				} else {
					iFrameNotFound();
				}
			}
	
			function warnOnNoResponse() {
				function warning() {
					if (settings[id] && !settings[id].loaded && !errorShown) {
						errorShown = true;
						warn(id, 'IFrame has not responded within '+ settings[id].warningTimeout/1000 +' seconds. Check iFrameResizer.contentWindow.js has been loaded in iFrame. This message can be ingored if everything is working, or you can set the warningTimeout option to a higher value or zero to suppress this warning.');
					}
				}
	
				if (!!noResponseWarning && !!settings[id].warningTimeout) {
					settings[id].msgTimeout = setTimeout(warning, settings[id].warningTimeout);
				}
			}
	
			var errorShown = false;
	
			id = id || iframe.id;
	
			if(settings[id]) {
				chkAndSend();
				warnOnNoResponse();
			}
	
		}
	
		function createOutgoingMsg(iframeId){
			return iframeId +
				':' + settings[iframeId].bodyMarginV1 +
				':' + settings[iframeId].sizeWidth +
				':' + settings[iframeId].log +
				':' + settings[iframeId].interval +
				':' + settings[iframeId].enablePublicMethods +
				':' + settings[iframeId].autoResize +
				':' + settings[iframeId].bodyMargin +
				':' + settings[iframeId].heightCalculationMethod +
				':' + settings[iframeId].bodyBackground +
				':' + settings[iframeId].bodyPadding +
				':' + settings[iframeId].tolerance +
				':' + settings[iframeId].inPageLinks +
				':' + settings[iframeId].resizeFrom +
				':' + settings[iframeId].widthCalculationMethod;
		}
	
		function setupIFrame(iframe,options){
			function setLimits(){
				function addStyle(style){
					if ((Infinity !== settings[iframeId][style]) && (0 !== settings[iframeId][style])){
						iframe.style[style] = settings[iframeId][style] + 'px';
						log(iframeId,'Set '+style+' = '+settings[iframeId][style]+'px');
					}
				}
	
				function chkMinMax(dimension){
					if (settings[iframeId]['min'+dimension]>settings[iframeId]['max'+dimension]){
						throw new Error('Value for min'+dimension+' can not be greater than max'+dimension);
					}
				}
	
				chkMinMax('Height');
				chkMinMax('Width');
	
				addStyle('maxHeight');
				addStyle('minHeight');
				addStyle('maxWidth');
				addStyle('minWidth');
			}
	
			function newId(){
				var id = ((options && options.id) || defaults.id + count++);
				if  (null !== document.getElementById(id)){
					id = id + count++;
				}
				return id;
			}
	
			function ensureHasId(iframeId){
				logId=iframeId;
				if (''===iframeId){
					iframe.id = iframeId =  newId();
					logEnabled = (options || {}).log;
					logId=iframeId;
					log(iframeId,'Added missing iframe ID: '+ iframeId +' (' + iframe.src + ')');
				}
	
	
				return iframeId;
			}
	
			function setScrolling(){
				log(iframeId,'IFrame scrolling ' + (settings[iframeId].scrolling ? 'enabled' : 'disabled') + ' for ' + iframeId);
				iframe.style.overflow = false === settings[iframeId].scrolling ? 'hidden' : 'auto';
				switch(settings[iframeId].scrolling) {
					case true:
						iframe.scrolling = 'yes';
						break;
					case false:
						iframe.scrolling = 'no';
						break;
					default:
						iframe.scrolling = settings[iframeId].scrolling;
				}
			}
	
			//The V1 iFrame script expects an int, where as in V2 expects a CSS
			//string value such as '1px 3em', so if we have an int for V2, set V1=V2
			//and then convert V2 to a string PX value.
			function setupBodyMarginValues(){
				if (('number'===typeof(settings[iframeId].bodyMargin)) || ('0'===settings[iframeId].bodyMargin)){
					settings[iframeId].bodyMarginV1 = settings[iframeId].bodyMargin;
					settings[iframeId].bodyMargin   = '' + settings[iframeId].bodyMargin + 'px';
				}
			}
	
			function checkReset(){
				// Reduce scope of firstRun to function, because IE8's JS execution
				// context stack is borked and this value gets externally
				// changed midway through running this function!!!
				var
					firstRun           = settings[iframeId].firstRun,
					resetRequertMethod = settings[iframeId].heightCalculationMethod in resetRequiredMethods;
	
				if (!firstRun && resetRequertMethod){
					resetIFrame({iframe:iframe, height:0, width:0, type:'init'});
				}
			}
	
			function setupIFrameObject(){
				if(Function.prototype.bind){ //Ignore unpolyfilled IE8.
					settings[iframeId].iframe.iFrameResizer = {
	
						close        : closeIFrame.bind(null,settings[iframeId].iframe),
	
						resize       : trigger.bind(null,'Window resize', 'resize', settings[iframeId].iframe),
	
						moveToAnchor : function(anchor){
							trigger('Move to anchor','moveToAnchor:'+anchor, settings[iframeId].iframe,iframeId);
						},
	
						sendMessage  : function(message){
							message = JSON.stringify(message);
							trigger('Send Message','message:'+message, settings[iframeId].iframe, iframeId);
						}
					};
				}
			}
	
			//We have to call trigger twice, as we can not be sure if all
			//iframes have completed loading when this code runs. The
			//event listener also catches the page changing in the iFrame.
			function init(msg){
				function iFrameLoaded(){
					trigger('iFrame.onload', msg, iframe, undefined , true);
					checkReset();
				}
	
				addEventListener(iframe,'load',iFrameLoaded);
				trigger('init', msg, iframe, undefined, true);
			}
	
			function checkOptions(options){
				if ('object' !== typeof options){
					throw new TypeError('Options is not an object');
				}
			}
	
			function copyOptions(options){
				for (var option in defaults) {
					if (defaults.hasOwnProperty(option)){
						settings[iframeId][option] = options.hasOwnProperty(option) ? options[option] : defaults[option];
					}
				}
			}
	
			function getTargetOrigin (remoteHost){
				return ('' === remoteHost || 'file://' === remoteHost) ? '*' : remoteHost;
			}
	
			function processOptions(options){
				options = options || {};
				settings[iframeId] = {
					firstRun	: true,
					iframe		: iframe,
					remoteHost	: iframe.src.split('/').slice(0,3).join('/')
				};
	
				checkOptions(options);
				copyOptions(options);
	
				settings[iframeId].targetOrigin = true === settings[iframeId].checkOrigin ? getTargetOrigin(settings[iframeId].remoteHost) : '*';
			}
	
			function beenHere(){
				return (iframeId in settings && 'iFrameResizer' in iframe);
			}
	
			var iframeId = ensureHasId(iframe.id);
	
			if (!beenHere()){
				processOptions(options);
				setScrolling();
				setLimits();
				setupBodyMarginValues();
				init(createOutgoingMsg(iframeId));
				setupIFrameObject();
			} else {
				warn(iframeId,'Ignored iFrame, already setup.');
			}
		}
	
		function debouce(fn,time){
			if (null === timer){
				timer = setTimeout(function(){
					timer = null;
					fn();
				}, time);
			}
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function fixHiddenIFrames(){
			function checkIFrames(){
				function checkIFrame(settingId){
					function chkDimension(dimension){
						return '0px' === settings[settingId].iframe.style[dimension];
					}
	
					function isVisible(el) {
						return (null !== el.offsetParent);
					}
	
					if (isVisible(settings[settingId].iframe) && (chkDimension('height') || chkDimension('width'))){
						trigger('Visibility change', 'resize', settings[settingId].iframe, settingId);
					}
				}
	
				for (var settingId in settings){
					checkIFrame(settingId);
				}
			}
	
			function mutationObserved(mutations){
				log('window','Mutation observed: ' + mutations[0].target + ' ' + mutations[0].type);
				debouce(checkIFrames,16);
			}
	
			function createMutationObserver(){
				var
					target = document.querySelector('body'),
	
					config = {
						attributes            : true,
						attributeOldValue     : false,
						characterData         : true,
						characterDataOldValue : false,
						childList             : true,
						subtree               : true
					},
	
					observer = new MutationObserver(mutationObserved);
	
				observer.observe(target, config);
			}
	
			var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
	
			if (MutationObserver) createMutationObserver();
		}
	
	
		function resizeIFrames(event){
			function resize(){
				sendTriggerMsg('Window '+event,'resize');
			}
	
			log('window','Trigger event: '+event);
			debouce(resize,16);
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function tabVisible() {
			function resize(){
				sendTriggerMsg('Tab Visable','resize');
			}
	
			if('hidden' !== document.visibilityState) {
				log('document','Trigger event: Visiblity change');
				debouce(resize,16);
			}
		}
	
		function sendTriggerMsg(eventName,event){
			function isIFrameResizeEnabled(iframeId) {
				return	'parent' === settings[iframeId].resizeFrom &&
						settings[iframeId].autoResize &&
						!settings[iframeId].firstRun;
			}
	
			for (var iframeId in settings){
				if(isIFrameResizeEnabled(iframeId)){
					trigger(eventName, event, document.getElementById(iframeId), iframeId);
				}
			}
		}
	
		function setupEventListeners(){
			addEventListener(window,'message',iFrameListener);
	
			addEventListener(window,'resize', function(){resizeIFrames('resize');});
	
			addEventListener(document,'visibilitychange',tabVisible);
			addEventListener(document,'-webkit-visibilitychange',tabVisible); //Andriod 4.4
			addEventListener(window,'focusin',function(){resizeIFrames('focus');}); //IE8-9
			addEventListener(window,'focus',function(){resizeIFrames('focus');});
		}
	
	
		function factory(){
			function init(options,element){
				function chkType(){
					if(!element.tagName) {
						throw new TypeError('Object is not a valid DOM element');
					} else if ('IFRAME' !== element.tagName.toUpperCase()) {
						throw new TypeError('Expected <IFRAME> tag, found <'+element.tagName+'>');
					}
				}
	
				if(element) {
					chkType();
					setupIFrame(element, options);
					iFrames.push(element);
				}
			}
	
			function warnDeprecatedOptions(options) {
				if (options && options.enablePublicMethods) {
					warn('enablePublicMethods option has been removed, public methods are now always available in the iFrame');
				}
			}
	
			var iFrames;
	
			setupRequestAnimationFrame();
			setupEventListeners();
	
			return function iFrameResizeF(options,target){
				iFrames = []; //Only return iFrames past in on this call
	
				warnDeprecatedOptions(options);
	
				switch (typeof(target)){
				case 'undefined':
				case 'string':
					Array.prototype.forEach.call(
						document.querySelectorAll( target || 'iframe' ),
						init.bind(undefined, options)
					);
					break;
				case 'object':
					init(options,target);
					break;
				default:
					throw new TypeError('Unexpected data type ('+typeof(target)+')');
				}
	
				return iFrames;
			};
		}
	
		function createJQueryPublicMethod($){
			if (!$.fn) {
				info('','Unable to bind to jQuery, it is not fully loaded.');
			} else if (!$.fn.iFrameResize){
				$.fn.iFrameResize = function $iFrameResizeF(options) {
					function init(index, element) {
						setupIFrame(element, options);
					}
	
					return this.filter('iframe').each(init).end();
				};
			}
		}
	
		if (window.jQuery) { createJQueryPublicMethod(window.jQuery); }
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module === 'object' && typeof module.exports === 'object') { //Node for browserfy
			module.exports = factory();
		} else {
			window.iFrameResize = window.iFrameResize || factory();
		}
	
	})();


/***/ }),
/* 168 */
/***/ (function(module, exports) {

	/*
	 * File: iframeResizer.contentWindow.js
	 * Desc: Include this file in any page being loaded into an iframe
	 *       to force the iframe to resize to the content size.
	 * Requires: iframeResizer.js on host page.
	 * Doc: https://github.com/davidjbradshaw/iframe-resizer
	 * Author: David J. Bradshaw - dave@bradshaw.net
	 * Contributor: Jure Mav - jure.mav@gmail.com
	 * Contributor: Ian Caunce - ian@hallnet.co.uk
	 */
	
	
	;(function(undefined) {
		'use strict';
	
		if(typeof window === 'undefined') return; // don't run for server side render
	
		var
			autoResize            = true,
			base                  = 10,
			bodyBackground        = '',
			bodyMargin            = 0,
			bodyMarginStr         = '',
			bodyObserver          = null,
			bodyPadding           = '',
			calculateWidth        = false,
			doubleEventList       = {'resize':1,'click':1},
			eventCancelTimer      = 128,
			firstRun              = true,
			height                = 1,
			heightCalcModeDefault = 'bodyOffset',
			heightCalcMode        = heightCalcModeDefault,
			initLock              = true,
			initMsg               = '',
			inPageLinks           = {},
			interval              = 32,
			intervalTimer         = null,
			logging               = false,
			msgID                 = '[iFrameSizer]',  //Must match host page msg ID
			msgIdLen              = msgID.length,
			myID                  = '',
			observer              = null,
			resetRequiredMethods  = {max:1,min:1,bodyScroll:1,documentElementScroll:1},
			resizeFrom            = 'child',
			sendPermit            = true,
			target                = window.parent,
			targetOriginDefault   = '*',
			tolerance             = 0,
			triggerLocked         = false,
			triggerLockedTimer    = null,
			throttledTimer        = 16,
			width                 = 1,
			widthCalcModeDefault  = 'scroll',
			widthCalcMode         = widthCalcModeDefault,
			win                   = window,
			messageCallback       = function(){ warn('MessageCallback function not defined'); },
			readyCallback         = function(){},
			pageInfoCallback      = function(){},
			customCalcMethods     = {
				height: function(){
					warn('Custom height calculation function not defined');
					return document.documentElement.offsetHeight;
				},
				width: function(){
					warn('Custom width calculation function not defined');
					return document.body.scrollWidth;
				}
			},
			eventHandlersByName   = {};
	
	
		function addEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('addEventListener' in window){
				el.addEventListener(evt,func, false);
			} else if ('attachEvent' in window){ //IE
				el.attachEvent('on'+evt,func);
			}
		}
	
		function removeEventListener(el,evt,func){
			/* istanbul ignore else */ // Not testable in phantonJS
			if ('removeEventListener' in window){
				el.removeEventListener(evt,func, false);
			} else if ('detachEvent' in window){ //IE
				el.detachEvent('on'+evt,func);
			}
		}
	
		function capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}
	
		//Based on underscore.js
		function throttle(func) {
			var
				context, args, result,
				timeout = null,
				previous = 0,
				later = function() {
					previous = getNow();
					timeout = null;
					result = func.apply(context, args);
					if (!timeout) {
						context = args = null;
					}
				};
	
			return function() {
				var now = getNow();
	
				if (!previous) {
					previous = now;
				}
	
				var remaining = throttledTimer - (now - previous);
	
				context = this;
				args = arguments;
	
				if (remaining <= 0 || remaining > throttledTimer) {
					if (timeout) {
						clearTimeout(timeout);
						timeout = null;
					}
	
					previous = now;
					result = func.apply(context, args);
	
					if (!timeout) {
						context = args = null;
					}
	
				} else if (!timeout) {
					timeout = setTimeout(later, remaining);
				}
	
				return result;
			};
		}
	
		var getNow = Date.now || function() {
			/* istanbul ignore next */ // Not testable in PhantonJS
			return new Date().getTime();
		};
	
		function formatLogMsg(msg){
			return msgID + '[' + myID + ']' + ' ' + msg;
		}
	
		function log(msg){
			if (logging && ('object' === typeof window.console)){
				console.log(formatLogMsg(msg));
			}
		}
	
		function warn(msg){
			if ('object' === typeof window.console){
				console.warn(formatLogMsg(msg));
			}
		}
	
	
		function init(){
			readDataFromParent();
			log('Initialising iFrame ('+location.href+')');
			readDataFromPage();
			setMargin();
			setBodyStyle('background',bodyBackground);
			setBodyStyle('padding',bodyPadding);
			injectClearFixIntoBodyElement();
			checkHeightMode();
			checkWidthMode();
			stopInfiniteResizingOfIFrame();
			setupPublicMethods();
			startEventListeners();
			inPageLinks = setupInPageLinks();
			sendSize('init','Init message from host page');
			readyCallback();
		}
	
		function readDataFromParent(){
	
			function strBool(str){
				return 'true' === str ? true : false;
			}
	
			var data = initMsg.substr(msgIdLen).split(':');
	
			myID               = data[0];
			bodyMargin         = (undefined !== data[1]) ? Number(data[1])   : bodyMargin; //For V1 compatibility
			calculateWidth     = (undefined !== data[2]) ? strBool(data[2])  : calculateWidth;
			logging            = (undefined !== data[3]) ? strBool(data[3])  : logging;
			interval           = (undefined !== data[4]) ? Number(data[4])   : interval;
			autoResize         = (undefined !== data[6]) ? strBool(data[6])  : autoResize;
			bodyMarginStr      = data[7];
			heightCalcMode     = (undefined !== data[8]) ? data[8]           : heightCalcMode;
			bodyBackground     = data[9];
			bodyPadding        = data[10];
			tolerance          = (undefined !== data[11]) ? Number(data[11]) : tolerance;
			inPageLinks.enable = (undefined !== data[12]) ? strBool(data[12]): false;
			resizeFrom         = (undefined !== data[13]) ? data[13]         : resizeFrom;
			widthCalcMode      = (undefined !== data[14]) ? data[14]         : widthCalcMode;
		}
	
		function readDataFromPage(){
			function readData(){
				var data = window.iFrameResizer;
	
				log('Reading data from page: ' + JSON.stringify(data));
	
				messageCallback     = ('messageCallback'         in data) ? data.messageCallback         : messageCallback;
				readyCallback       = ('readyCallback'           in data) ? data.readyCallback           : readyCallback;
				targetOriginDefault = ('targetOrigin'            in data) ? data.targetOrigin            : targetOriginDefault;
				heightCalcMode      = ('heightCalculationMethod' in data) ? data.heightCalculationMethod : heightCalcMode;
				widthCalcMode       = ('widthCalculationMethod'  in data) ? data.widthCalculationMethod  : widthCalcMode;
			}
	
			function setupCustomCalcMethods(calcMode, calcFunc){
				if ('function' === typeof calcMode) {
					log('Setup custom ' + calcFunc + 'CalcMethod');
					customCalcMethods[calcFunc] = calcMode;
					calcMode = 'custom';
				}
	
				return calcMode;
			}
	
			if(('iFrameResizer' in window) && (Object === window.iFrameResizer.constructor)) {
				readData();
				heightCalcMode = setupCustomCalcMethods(heightCalcMode, 'height');
				widthCalcMode  = setupCustomCalcMethods(widthCalcMode,  'width');
			}
	
			log('TargetOrigin for parent set to: ' + targetOriginDefault);
		}
	
	
		function chkCSS(attr,value){
			if (-1 !== value.indexOf('-')){
				warn('Negative CSS value ignored for '+attr);
				value='';
			}
			return value;
		}
	
		function setBodyStyle(attr,value){
			if ((undefined !== value) && ('' !== value) && ('null' !== value)){
				document.body.style[attr] = value;
				log('Body '+attr+' set to "'+value+'"');
			}
		}
	
		function setMargin(){
			//If called via V1 script, convert bodyMargin from int to str
			if (undefined === bodyMarginStr){
				bodyMarginStr = bodyMargin+'px';
			}
	
			setBodyStyle('margin',chkCSS('margin',bodyMarginStr));
		}
	
		function stopInfiniteResizingOfIFrame(){
			document.documentElement.style.height = '';
			document.body.style.height = '';
			log('HTML & body height set to "auto"');
		}
	
	
		function manageTriggerEvent(options){
	
			var listener = {
				add:    function(eventName){
					function handleEvent(){
						sendSize(options.eventName,options.eventType);
					}
	
					eventHandlersByName[eventName] = handleEvent;
	
					addEventListener(window,eventName,handleEvent);
				},
				remove: function(eventName){
					var handleEvent = eventHandlersByName[eventName];
					delete eventHandlersByName[eventName];
	
					removeEventListener(window,eventName,handleEvent);
				}
			};
	
			if(options.eventNames && Array.prototype.map){
				options.eventName = options.eventNames[0];
				options.eventNames.map(listener[options.method]);
			} else {
				listener[options.method](options.eventName);
			}
	
			log(capitalizeFirstLetter(options.method) + ' event listener: ' + options.eventType);
		}
	
		function manageEventListeners(method){
			manageTriggerEvent({method:method, eventType: 'Animation Start',           eventNames: ['animationstart','webkitAnimationStart'] });
			manageTriggerEvent({method:method, eventType: 'Animation Iteration',       eventNames: ['animationiteration','webkitAnimationIteration'] });
			manageTriggerEvent({method:method, eventType: 'Animation End',             eventNames: ['animationend','webkitAnimationEnd'] });
			manageTriggerEvent({method:method, eventType: 'Input',                     eventName:  'input' });
			manageTriggerEvent({method:method, eventType: 'Mouse Up',                  eventName:  'mouseup' });
			manageTriggerEvent({method:method, eventType: 'Mouse Down',                eventName:  'mousedown' });
			manageTriggerEvent({method:method, eventType: 'Orientation Change',        eventName:  'orientationchange' });
			manageTriggerEvent({method:method, eventType: 'Print',                     eventName:  ['afterprint', 'beforeprint'] });
			manageTriggerEvent({method:method, eventType: 'Ready State Change',        eventName:  'readystatechange' });
			manageTriggerEvent({method:method, eventType: 'Touch Start',               eventName:  'touchstart' });
			manageTriggerEvent({method:method, eventType: 'Touch End',                 eventName:  'touchend' });
			manageTriggerEvent({method:method, eventType: 'Touch Cancel',              eventName:  'touchcancel' });
			manageTriggerEvent({method:method, eventType: 'Transition Start',          eventNames: ['transitionstart','webkitTransitionStart','MSTransitionStart','oTransitionStart','otransitionstart'] });
			manageTriggerEvent({method:method, eventType: 'Transition Iteration',      eventNames: ['transitioniteration','webkitTransitionIteration','MSTransitionIteration','oTransitionIteration','otransitioniteration'] });
			manageTriggerEvent({method:method, eventType: 'Transition End',            eventNames: ['transitionend','webkitTransitionEnd','MSTransitionEnd','oTransitionEnd','otransitionend'] });
			if('child' === resizeFrom){
				manageTriggerEvent({method:method, eventType: 'IFrame Resized',        eventName:  'resize' });
			}
		}
	
		function checkCalcMode(calcMode,calcModeDefault,modes,type){
			if (calcModeDefault !== calcMode){
				if (!(calcMode in modes)){
					warn(calcMode + ' is not a valid option for '+type+'CalculationMethod.');
					calcMode=calcModeDefault;
				}
				log(type+' calculation method set to "'+calcMode+'"');
			}
	
			return calcMode;
		}
	
		function checkHeightMode(){
			heightCalcMode = checkCalcMode(heightCalcMode,heightCalcModeDefault,getHeight,'height');
		}
	
		function checkWidthMode(){
			widthCalcMode = checkCalcMode(widthCalcMode,widthCalcModeDefault,getWidth,'width');
		}
	
		function startEventListeners(){
			if ( true === autoResize ) {
				manageEventListeners('add');
				setupMutationObserver();
			}
			else {
				log('Auto Resize disabled');
			}
		}
	
		function stopMsgsToParent(){
			log('Disable outgoing messages');
			sendPermit = false;
		}
	
		function removeMsgListener(){
			log('Remove event listener: Message');
			removeEventListener(window, 'message', receiver);
		}
	
		function disconnectMutationObserver(){
			if (null !== bodyObserver){
				/* istanbul ignore next */ // Not testable in PhantonJS
				bodyObserver.disconnect();
			}
		}
	
		function stopEventListeners(){
			manageEventListeners('remove');
			disconnectMutationObserver();
			clearInterval(intervalTimer);
		}
	
		function teardown(){
			stopMsgsToParent();
			removeMsgListener();
			if (true === autoResize) stopEventListeners();
		}
	
		function injectClearFixIntoBodyElement(){
			var clearFix = document.createElement('div');
			clearFix.style.clear   = 'both';
			clearFix.style.display = 'block'; //Guard against this having been globally redefined in CSS.
			document.body.appendChild(clearFix);
		}
	
		function setupInPageLinks(){
	
			function getPagePosition (){
				return {
					x: (window.pageXOffset !== undefined) ? window.pageXOffset : document.documentElement.scrollLeft,
					y: (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop
				};
			}
	
			function getElementPosition(el){
				var
					elPosition   = el.getBoundingClientRect(),
					pagePosition = getPagePosition();
	
				return {
					x: parseInt(elPosition.left,10) + parseInt(pagePosition.x,10),
					y: parseInt(elPosition.top,10)  + parseInt(pagePosition.y,10)
				};
			}
	
			function findTarget(location){
				function jumpToTarget(target){
					var jumpPosition = getElementPosition(target);
	
					log('Moving to in page link (#'+hash+') at x: '+jumpPosition.x+' y: '+jumpPosition.y);
					sendMsg(jumpPosition.y, jumpPosition.x, 'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
				}
	
				var
					hash     = location.split('#')[1] || location, //Remove # if present
					hashData = decodeURIComponent(hash),
					target   = document.getElementById(hashData) || document.getElementsByName(hashData)[0];
	
				if (undefined !== target){
					jumpToTarget(target);
				} else {
					log('In page link (#' + hash + ') not found in iFrame, so sending to parent');
					sendMsg(0,0,'inPageLink','#'+hash);
				}
			}
	
			function checkLocationHash(){
				if ('' !== location.hash && '#' !== location.hash){
					findTarget(location.href);
				}
			}
	
			function bindAnchors(){
				function setupLink(el){
					function linkClicked(e){
						e.preventDefault();
	
						/*jshint validthis:true */
						findTarget(this.getAttribute('href'));
					}
	
					if ('#' !== el.getAttribute('href')){
						addEventListener(el,'click',linkClicked);
					}
				}
	
				Array.prototype.forEach.call( document.querySelectorAll( 'a[href^="#"]' ), setupLink );
			}
	
			function bindLocationHash(){
				addEventListener(window,'hashchange',checkLocationHash);
			}
	
			function initCheck(){ //check if page loaded with location hash after init resize
				setTimeout(checkLocationHash,eventCancelTimer);
			}
	
			function enableInPageLinks(){
				/* istanbul ignore else */ // Not testable in phantonJS
				if(Array.prototype.forEach && document.querySelectorAll){
					log('Setting up location.hash handlers');
					bindAnchors();
					bindLocationHash();
					initCheck();
				} else {
					warn('In page linking not fully supported in this browser! (See README.md for IE8 workaround)');
				}
			}
	
			if(inPageLinks.enable){
				enableInPageLinks();
			} else {
				log('In page linking not enabled');
			}
	
			return {
				findTarget:findTarget
			};
		}
	
		function setupPublicMethods(){
			log('Enable public methods');
	
			win.parentIFrame = {
	
				autoResize: function autoResizeF(resize){
					if (true === resize && false === autoResize) {
						autoResize=true;
						startEventListeners();
						//sendSize('autoResize','Auto Resize enabled');
					} else if (false === resize && true === autoResize) {
						autoResize=false;
						stopEventListeners();
					}
	
					return autoResize;
				},
	
				close: function closeF(){
					sendMsg(0,0,'close');
					teardown();
				},
	
				getId: function getIdF(){
					return myID;
				},
	
				getPageInfo: function getPageInfoF(callback){
					if ('function' === typeof callback){
						pageInfoCallback = callback;
						sendMsg(0,0,'pageInfo');
					} else {
						pageInfoCallback = function(){};
						sendMsg(0,0,'pageInfoStop');
					}
				},
	
				moveToAnchor: function moveToAnchorF(hash){
					inPageLinks.findTarget(hash);
				},
	
				reset: function resetF(){
					resetIFrame('parentIFrame.reset');
				},
	
				scrollTo: function scrollToF(x,y){
					sendMsg(y,x,'scrollTo'); // X&Y reversed at sendMsg uses height/width
				},
	
				scrollToOffset: function scrollToF(x,y){
					sendMsg(y,x,'scrollToOffset'); // X&Y reversed at sendMsg uses height/width
				},
	
				sendMessage: function sendMessageF(msg,targetOrigin){
					sendMsg(0,0,'message',JSON.stringify(msg),targetOrigin);
				},
	
				setHeightCalculationMethod: function setHeightCalculationMethodF(heightCalculationMethod){
					heightCalcMode = heightCalculationMethod;
					checkHeightMode();
				},
	
				setWidthCalculationMethod: function setWidthCalculationMethodF(widthCalculationMethod){
					widthCalcMode = widthCalculationMethod;
					checkWidthMode();
				},
	
				setTargetOrigin: function setTargetOriginF(targetOrigin){
					log('Set targetOrigin: '+targetOrigin);
					targetOriginDefault = targetOrigin;
				},
	
				size: function sizeF(customHeight, customWidth){
					var valString = ''+(customHeight?customHeight:'')+(customWidth?','+customWidth:'');
					//lockTrigger();
					sendSize('size','parentIFrame.size('+valString+')', customHeight, customWidth);
				}
			};
		}
	
		function initInterval(){
			if ( 0 !== interval ){
				log('setInterval: '+interval+'ms');
				intervalTimer = setInterval(function(){
					sendSize('interval','setInterval: '+interval);
				},Math.abs(interval));
			}
		}
	
		/* istanbul ignore next */  //Not testable in PhantomJS
		function setupBodyMutationObserver(){
			function addImageLoadListners(mutation) {
				function addImageLoadListener(element){
					if (false === element.complete) {
						log('Attach listeners to ' + element.src);
						element.addEventListener('load', imageLoaded, false);
						element.addEventListener('error', imageError, false);
						elements.push(element);
					}
				}
	
				if (mutation.type === 'attributes' && mutation.attributeName === 'src'){
					addImageLoadListener(mutation.target);
				} else if (mutation.type === 'childList'){
					Array.prototype.forEach.call(
						mutation.target.querySelectorAll('img'),
						addImageLoadListener
					);
				}
			}
	
			function removeFromArray(element){
				elements.splice(elements.indexOf(element),1);
			}
	
			function removeImageLoadListener(element){
				log('Remove listeners from ' + element.src);
				element.removeEventListener('load', imageLoaded, false);
				element.removeEventListener('error', imageError, false);
				removeFromArray(element);
			}
	
			function imageEventTriggered(event,type,typeDesc){
				removeImageLoadListener(event.target);
				sendSize(type, typeDesc + ': ' + event.target.src, undefined, undefined);
			}
	
			function imageLoaded(event) {
				imageEventTriggered(event,'imageLoad','Image loaded');
			}
	
			function imageError(event) {
				imageEventTriggered(event,'imageLoadFailed','Image load failed');
			}
	
			function mutationObserved(mutations) {
				sendSize('mutationObserver','mutationObserver: ' + mutations[0].target + ' ' + mutations[0].type);
	
				//Deal with WebKit asyncing image loading when tags are injected into the page
				mutations.forEach(addImageLoadListners);
			}
	
			function createMutationObserver(){
				var
					target = document.querySelector('body'),
	
					config = {
						attributes            : true,
						attributeOldValue     : false,
						characterData         : true,
						characterDataOldValue : false,
						childList             : true,
						subtree               : true
					};
	
				observer = new MutationObserver(mutationObserved);
	
				log('Create body MutationObserver');
				observer.observe(target, config);
	
				return observer;
			}
	
			var
				elements         = [],
				MutationObserver = window.MutationObserver || window.WebKitMutationObserver,
				observer         = createMutationObserver();
	
			return {
				disconnect: function (){
					if ('disconnect' in observer){
						log('Disconnect body MutationObserver');
						observer.disconnect();
						elements.forEach(removeImageLoadListener);
					}
				}
			};
		}
	
		function setupMutationObserver(){
			var	forceIntervalTimer = 0 > interval;
	
			/* istanbul ignore if */ // Not testable in PhantomJS
			if (window.MutationObserver || window.WebKitMutationObserver){
				if (forceIntervalTimer) {
					initInterval();
				} else {
					bodyObserver = setupBodyMutationObserver();
				}
			} else {
				log('MutationObserver not supported in this browser!');
				initInterval();
			}
		}
	
	
		// document.documentElement.offsetHeight is not reliable, so
		// we have to jump through hoops to get a better value.
		function getComputedStyle(prop,el) {
			/* istanbul ignore next */  //Not testable in PhantomJS
			function convertUnitsToPxForIE8(value) {
				var PIXEL = /^\d+(px)?$/i;
	
				if (PIXEL.test(value)) {
					return parseInt(value,base);
				}
	
				var
					style = el.style.left,
					runtimeStyle = el.runtimeStyle.left;
	
				el.runtimeStyle.left = el.currentStyle.left;
				el.style.left = value || 0;
				value = el.style.pixelLeft;
				el.style.left = style;
				el.runtimeStyle.left = runtimeStyle;
	
				return value;
			}
	
			var retVal = 0;
			el =  el || document.body;
	
			/* istanbul ignore else */ // Not testable in phantonJS
			if (('defaultView' in document) && ('getComputedStyle' in document.defaultView)) {
				retVal = document.defaultView.getComputedStyle(el, null);
				retVal = (null !== retVal) ? retVal[prop] : 0;
			} else {//IE8
				retVal =  convertUnitsToPxForIE8(el.currentStyle[prop]);
			}
	
			return parseInt(retVal,base);
		}
	
		function chkEventThottle(timer){
			if(timer > throttledTimer/2){
				throttledTimer = 2*timer;
				log('Event throttle increased to ' + throttledTimer + 'ms');
			}
		}
	
		//Idea from https://github.com/guardian/iframe-messenger
		function getMaxElement(side,elements) {
			var
				elementsLength = elements.length,
				elVal          = 0,
				maxVal         = 0,
				Side           = capitalizeFirstLetter(side),
				timer          = getNow();
	
			for (var i = 0; i < elementsLength; i++) {
				elVal = elements[i].getBoundingClientRect()[side] + getComputedStyle('margin'+Side,elements[i]);
				if (elVal > maxVal) {
					maxVal = elVal;
				}
			}
	
			timer = getNow() - timer;
	
			log('Parsed '+elementsLength+' HTML elements');
			log('Element position calculated in ' + timer + 'ms');
	
			chkEventThottle(timer);
	
			return maxVal;
		}
	
		function getAllMeasurements(dimention){
			return [
				dimention.bodyOffset(),
				dimention.bodyScroll(),
				dimention.documentElementOffset(),
				dimention.documentElementScroll()
			];
		}
	
		function getTaggedElements(side,tag){
			function noTaggedElementsFound(){
				warn('No tagged elements ('+tag+') found on page');
				return document.querySelectorAll('body *');
			}
	
			var elements = document.querySelectorAll('['+tag+']');
	
			if (0 === elements.length) noTaggedElementsFound();
	
			return getMaxElement(side,elements);
		}
	
		function getAllElements(){
			return document.querySelectorAll('body *');
		}
	
		var
			getHeight = {
				bodyOffset: function getBodyOffsetHeight(){
					return  document.body.offsetHeight + getComputedStyle('marginTop') + getComputedStyle('marginBottom');
				},
	
				offset: function(){
					return getHeight.bodyOffset(); //Backwards compatability
				},
	
				bodyScroll: function getBodyScrollHeight(){
					return document.body.scrollHeight;
				},
	
				custom: function getCustomWidth(){
					return customCalcMethods.height();
				},
	
				documentElementOffset: function getDEOffsetHeight(){
					return document.documentElement.offsetHeight;
				},
	
				documentElementScroll: function getDEScrollHeight(){
					return document.documentElement.scrollHeight;
				},
	
				max: function getMaxHeight(){
					return Math.max.apply(null,getAllMeasurements(getHeight));
				},
	
				min: function getMinHeight(){
					return Math.min.apply(null,getAllMeasurements(getHeight));
				},
	
				grow: function growHeight(){
					return getHeight.max(); //Run max without the forced downsizing
				},
	
				lowestElement: function getBestHeight(){
					return Math.max(getHeight.bodyOffset(), getMaxElement('bottom',getAllElements()));
				},
	
				taggedElement: function getTaggedElementsHeight(){
					return getTaggedElements('bottom','data-iframe-height');
				}
			},
	
			getWidth = {
				bodyScroll: function getBodyScrollWidth(){
					return document.body.scrollWidth;
				},
	
				bodyOffset: function getBodyOffsetWidth(){
					return document.body.offsetWidth;
				},
	
				custom: function getCustomWidth(){
					return customCalcMethods.width();
				},
	
				documentElementScroll: function getDEScrollWidth(){
					return document.documentElement.scrollWidth;
				},
	
				documentElementOffset: function getDEOffsetWidth(){
					return document.documentElement.offsetWidth;
				},
	
				scroll: function getMaxWidth(){
					return Math.max(getWidth.bodyScroll(), getWidth.documentElementScroll());
				},
	
				max: function getMaxWidth(){
					return Math.max.apply(null,getAllMeasurements(getWidth));
				},
	
				min: function getMinWidth(){
					return Math.min.apply(null,getAllMeasurements(getWidth));
				},
	
				rightMostElement: function rightMostElement(){
					return getMaxElement('right', getAllElements());
				},
	
				taggedElement: function getTaggedElementsWidth(){
					return getTaggedElements('right', 'data-iframe-width');
				}
			};
	
	
		function sizeIFrame(triggerEvent, triggerEventDesc, customHeight, customWidth){
	
			function resizeIFrame(){
				height = currentHeight;
				width  = currentWidth;
	
				sendMsg(height,width,triggerEvent);
			}
	
			function isSizeChangeDetected(){
				function checkTolarance(a,b){
					var retVal = Math.abs(a-b) <= tolerance;
					return !retVal;
				}
	
				currentHeight = (undefined !== customHeight)  ? customHeight : getHeight[heightCalcMode]();
				currentWidth  = (undefined !== customWidth )  ? customWidth  : getWidth[widthCalcMode]();
	
				return	checkTolarance(height,currentHeight) || (calculateWidth && checkTolarance(width,currentWidth));
			}
	
			function isForceResizableEvent(){
				return !(triggerEvent in {'init':1,'interval':1,'size':1});
			}
	
			function isForceResizableCalcMode(){
				return (heightCalcMode in resetRequiredMethods) || (calculateWidth && widthCalcMode in resetRequiredMethods);
			}
	
			function logIgnored(){
				log('No change in size detected');
			}
	
			function checkDownSizing(){
				if (isForceResizableEvent() && isForceResizableCalcMode()){
					resetIFrame(triggerEventDesc);
				} else if (!(triggerEvent in {'interval':1})){
					logIgnored();
				}
			}
	
			var	currentHeight,currentWidth;
	
			if (isSizeChangeDetected() || 'init' === triggerEvent){
				lockTrigger();
				resizeIFrame();
			} else {
				checkDownSizing();
			}
		}
	
		var sizeIFrameThrottled = throttle(sizeIFrame);
	
		function sendSize(triggerEvent, triggerEventDesc, customHeight, customWidth){
			function recordTrigger(){
				if (!(triggerEvent in {'reset':1,'resetPage':1,'init':1})){
					log( 'Trigger event: ' + triggerEventDesc );
				}
			}
	
			function isDoubleFiredEvent(){
				return  triggerLocked && (triggerEvent in doubleEventList);
			}
	
			if (!isDoubleFiredEvent()){
				recordTrigger();
				sizeIFrameThrottled(triggerEvent, triggerEventDesc, customHeight, customWidth);
			} else {
				log('Trigger event cancelled: '+triggerEvent);
			}
		}
	
		function lockTrigger(){
			if (!triggerLocked){
				triggerLocked = true;
				log('Trigger event lock on');
			}
			clearTimeout(triggerLockedTimer);
			triggerLockedTimer = setTimeout(function(){
				triggerLocked = false;
				log('Trigger event lock off');
				log('--');
			},eventCancelTimer);
		}
	
		function triggerReset(triggerEvent){
			height = getHeight[heightCalcMode]();
			width  = getWidth[widthCalcMode]();
	
			sendMsg(height,width,triggerEvent);
		}
	
		function resetIFrame(triggerEventDesc){
			var hcm = heightCalcMode;
			heightCalcMode = heightCalcModeDefault;
	
			log('Reset trigger event: ' + triggerEventDesc);
			lockTrigger();
			triggerReset('reset');
	
			heightCalcMode = hcm;
		}
	
		function sendMsg(height,width,triggerEvent,msg,targetOrigin){
			function setTargetOrigin(){
				if (undefined === targetOrigin){
					targetOrigin = targetOriginDefault;
				} else {
					log('Message targetOrigin: '+targetOrigin);
				}
			}
	
			function sendToParent(){
				var
					size  = height + ':' + width,
					message = myID + ':' +  size + ':' + triggerEvent + (undefined !== msg ? ':' + msg : '');
	
				log('Sending message to host page (' + message + ')');
				target.postMessage( msgID + message, targetOrigin);
			}
	
			if(true === sendPermit){
				setTargetOrigin();
				sendToParent();
			}
		}
	
		function receiver(event) {
			var processRequestFromParent = {
				init: function initFromParent(){
					function fireInit(){
						initMsg = event.data;
						target  = event.source;
	
						init();
						firstRun = false;
						setTimeout(function(){ initLock = false;},eventCancelTimer);
					}
	
					if (document.body){
						fireInit();
					} else {
						log('Waiting for page ready');
						addEventListener(window,'readystatechange',processRequestFromParent.initFromParent);
					}
				},
	
				reset: function resetFromParent(){
					if (!initLock){
						log('Page size reset by host page');
						triggerReset('resetPage');
					} else {
						log('Page reset ignored by init');
					}
				},
	
				resize: function resizeFromParent(){
					sendSize('resizeParent','Parent window requested size check');
				},
	
				moveToAnchor: function moveToAnchorF(){
					inPageLinks.findTarget(getData());
				},
				inPageLink: function inPageLinkF() {this.moveToAnchor();}, //Backward compatability
	
				pageInfo: function pageInfoFromParent(){
					var msgBody = getData();
					log('PageInfoFromParent called from parent: ' + msgBody );
					pageInfoCallback(JSON.parse(msgBody));
					log(' --');
				},
	
				message: function messageFromParent(){
					var msgBody = getData();
	
					log('MessageCallback called from parent: ' + msgBody );
					messageCallback(JSON.parse(msgBody));
					log(' --');
				}
			};
	
			function isMessageForUs(){
				return msgID === (''+event.data).substr(0,msgIdLen); //''+ Protects against non-string messages
			}
	
			function getMessageType(){
				return event.data.split(']')[1].split(':')[0];
			}
	
			function getData(){
				return event.data.substr(event.data.indexOf(':')+1);
			}
	
			function isMiddleTier(){
				return !(typeof module !== 'undefined' && module.exports) && ('iFrameResize' in window);
			}
	
			function isInitMsg(){
				//Test if this message is from a child below us. This is an ugly test, however, updating
				//the message format would break backwards compatibity.
				return event.data.split(':')[2] in {'true':1,'false':1};
			}
	
			function callFromParent(){
				var messageType = getMessageType();
	
				if (messageType in processRequestFromParent){
					processRequestFromParent[messageType]();
				} else if (!isMiddleTier() && !isInitMsg()){
					warn('Unexpected message ('+event.data+')');
				}
			}
	
			function processMessage(){
				if (false === firstRun) {
					callFromParent();
				} else if (isInitMsg()) {
					processRequestFromParent.init();
				} else {
					log('Ignored message of type "' + getMessageType() + '". Received before initialization.');
				}
			}
	
			if (isMessageForUs()){
				processMessage();
			}
		}
	
		//Normally the parent kicks things off when it detects the iFrame has loaded.
		//If this script is async-loaded, then tell parent page to retry init.
		function chkLateLoaded(){
			if('loading' !== document.readyState){
				window.parent.postMessage('[iFrameResizerChild]Ready','*');
			}
		}
	
		addEventListener(window, 'message', receiver);
		chkLateLoaded();
	
		
	
	})();


/***/ })
/******/ ])))));


// WEBPACK FOOTER //
// assets/app.50768.js